import { GraphQLClient, RequestOptions } from 'graphql-request';
import gql from 'graphql-tag';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
type GraphQLClientRequestHeaders = RequestOptions['requestHeaders'];
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /** currency.js */
  Currency: { input: any; output: any; }
  /** A date-time string at UTC, such as 2019-12-03T09:54:33Z, compliant with the date-time format. */
  DateTime: { input: any; output: any; }
  /** Custom scalar type for precise decimal values using decimal.js */
  Decimal: { input: any; output: any; }
  /** Duration scalar unit */
  Duration: { input: any; output: any; }
  /** The `JSON` scalar type represents JSON values as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  JSON: { input: any; output: any; }
  /** Length scalar unit */
  Length: { input: any; output: any; }
  /** Weight/Mass scalar unit */
  Mass: { input: any; output: any; }
  /** Percentage scalar unit */
  Percent: { input: any; output: any; }
  /** Volume scalar unit */
  Volume: { input: any; output: any; }
};

export type AblyTokenOutput = {
  __typename?: 'AblyTokenOutput';
  token?: Maybe<Scalars['String']['output']>;
};

export type AcceptCustomerPortalOrderInput = {
  orderUuid: Scalars['String']['input'];
};

export type AcceptCustomerPortalOrderOutput = AcceptCustomerPortalOrderSuccessOutput | MutationErrorOutput;

export type AcceptCustomerPortalOrderSuccessOutput = {
  __typename?: 'AcceptCustomerPortalOrderSuccessOutput';
  acceptedAt: Scalars['DateTime']['output'];
  orderUuid: Scalars['String']['output'];
};

export type AcceptEdiOrApiOrderInput = {
  uuid: Scalars['String']['input'];
};

export type AcceptEdiOrApiOrderOutput = {
  __typename?: 'AcceptEdiOrApiOrderOutput';
  uuid: Scalars['String']['output'];
};

export enum AccessLevel {
  Read = 'READ',
  Write = 'WRITE'
}

export type AccessorialChargeDetailsEntity = {
  __typename?: 'AccessorialChargeDetailsEntity';
  accessorialName: Scalars['String']['output'];
  accessorialUuid: Scalars['String']['output'];
  chargeDetailsByContact: Array<ContactAccessorialChargeDetailsEntity>;
};

export type AccessorialChargeDetailsReportArgs = {
  /** If not specified, returns report for all company-only accessorials. */
  accessorialUuid?: InputMaybe<Scalars['String']['input']>;
  includeContactsWithNoShipments: Scalars['Boolean']['input'];
  invoiceDateFilters?: InputMaybe<DateFilterStartEnd>;
  invoiceStatuses: Array<InvoiceStatus>;
  /** If specified, only returns shipments on orders with this controlling terminal */
  terminalUuid?: InputMaybe<Scalars['String']['input']>;
};

export type AccessorialCreateInput = {
  code?: InputMaybe<Scalars['String']['input']>;
  contactUuid?: InputMaybe<Scalars['String']['input']>;
  ediCode?: InputMaybe<Scalars['String']['input']>;
  fuelProfileUuid?: InputMaybe<Scalars['String']['input']>;
  generalLedgerCodeId?: InputMaybe<Scalars['String']['input']>;
  invoiceDisplayName?: InputMaybe<Scalars['String']['input']>;
  isAuthoCodeRequired?: InputMaybe<Scalars['Boolean']['input']>;
  isDefaultGlobalSpecial?: InputMaybe<Scalars['Boolean']['input']>;
  isSpecial?: InputMaybe<Scalars['Boolean']['input']>;
  matchingGlobalAccessorial?: InputMaybe<Scalars['String']['input']>;
  percentForSettlement?: InputMaybe<Scalars['Float']['input']>;
  skidBasedAccessorialCreateInput?: InputMaybe<SkidBasedAccessorialCreateInput>;
  specialAccessorialCreateInput?: InputMaybe<SpecialAccessorialCreateInput>;
  standardAccessorialCreateInput?: InputMaybe<StandardAccessorialCreateInput>;
  terminalUuid?: InputMaybe<Scalars['String']['input']>;
  unitBasedAccessorialCreateInput?: InputMaybe<UnitBasedAccessorialCreateInput>;
  waitTimeAccessorialCreateInput?: InputMaybe<WaitTimeAccessorialCreateInput>;
  weightBasedAccessorialCreateInput?: InputMaybe<WeightBasedAccessorialCreateInput>;
  zoneBasedAccessorialCreateInput?: InputMaybe<ZoneBasedAccessorialCreateInput>;
};

export type AccessorialDateRangeConfigEntity = {
  __typename?: 'AccessorialDateRangeConfigEntity';
  accessorialRanges: Array<AccessorialRangeEntity>;
  endDate?: Maybe<Scalars['DateTime']['output']>;
  fuelProfile?: Maybe<FuelProfileEntity>;
  /** @deprecated Use the fuel surcharge rate from the fuel profile instead. */
  fuelSurchargePercentageRate?: Maybe<Scalars['Float']['output']>;
  percentForSettlement?: Maybe<Scalars['Float']['output']>;
  /** Rate in dollars */
  rate: Scalars['Float']['output'];
  specialChargeGroups: Array<SpecialAccessorialChargeGroupEntity>;
  specialMatrixItems: Array<SpecialAccessorialMatrixItemEntity>;
  startDate: Scalars['DateTime']['output'];
  uuid: Scalars['String']['output'];
};

export type AccessorialInterface = {
  code?: Maybe<Scalars['String']['output']>;
  ediCode?: Maybe<Scalars['String']['output']>;
  enableQuickAdd: Scalars['Boolean']['output'];
  fuelProfileUuid?: Maybe<Scalars['String']['output']>;
  invoiceDisplayName?: Maybe<Scalars['String']['output']>;
  isArchived?: Maybe<Scalars['Boolean']['output']>;
  isAuthoCodeRequired: Scalars['Boolean']['output'];
  isDefaultGlobalSpecial: Scalars['Boolean']['output'];
  isSpecial?: Maybe<Scalars['Boolean']['output']>;
  name: Scalars['String']['output'];
  percentForSettlement?: Maybe<Scalars['Float']['output']>;
  quickbooksDesktopAccessorialId?: Maybe<Scalars['String']['output']>;
  quickbooksFileMappingChargeName?: Maybe<Scalars['String']['output']>;
  terminalUuid?: Maybe<Scalars['String']['output']>;
  type?: Maybe<AccessorialType>;
  uuid: Scalars['String']['output'];
};

export type AccessorialRangeCreateInput = {
  lessThanOrEqualToValue: Scalars['Int']['input'];
  rateUsdCents: Scalars['Float']['input'];
};

export type AccessorialRangeEntity = {
  __typename?: 'AccessorialRangeEntity';
  lessThanOrEqualToValue: Scalars['Int']['output'];
  rateUsdCents: Scalars['Float']['output'];
  uuid: Scalars['String']['output'];
};

export type AccessorialRangeUpdateInput = {
  lessThanOrEqualToValue?: InputMaybe<Scalars['Int']['input']>;
  rateUsdCents?: InputMaybe<Scalars['Float']['input']>;
  uuid?: InputMaybe<Scalars['String']['input']>;
};

export type AccessorialRangeUpdatesInput = {
  accessorialRangeUpdateInputs: Array<AccessorialRangeUpdateInput>;
  accessorialUuid: Scalars['String']['input'];
};

export type AccessorialToMappingInput = {
  desktopMapping?: InputMaybe<Scalars['String']['input']>;
  fileMapping?: InputMaybe<Scalars['String']['input']>;
  uuid: Scalars['String']['input'];
};

export type AccessorialToQuickbooksMappingCreateInput = {
  accessorialUuid: Scalars['String']['input'];
  contactUuid?: InputMaybe<Scalars['String']['input']>;
  quickbooksMappingId: Scalars['String']['input'];
};

export type AccessorialToQuickbooksMappingEntity = {
  __typename?: 'AccessorialToQuickbooksMappingEntity';
  accessorial: AccessorialInterface;
  createdAt: Scalars['DateTime']['output'];
  quickbooksId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  uuid: Scalars['String']['output'];
};

export type AccessorialToQuickbooksMappingUpdateInput = {
  quickbooksMappingId: Scalars['String']['input'];
  uuid: Scalars['String']['input'];
};

export enum AccessorialType {
  Skid = 'SKID',
  Special = 'SPECIAL',
  Standard = 'STANDARD',
  Unit = 'UNIT',
  WaitTime = 'WAIT_TIME',
  Weight = 'WEIGHT',
  ZoneBased = 'ZONE_BASED'
}

export type AccessorialUnion = SkidBasedAccessorialEntity | SpecialAccessorialEntity | StandardAccessorialEntity | UnitBasedAccessorialEntity | WaitTimeAccessorialEntity | WeightBasedAccessorialEntity | ZoneBasedAccessorialEntity;

export type AccessorialUpdateInput = {
  code?: InputMaybe<Scalars['String']['input']>;
  ediCode?: InputMaybe<Scalars['String']['input']>;
  fuelProfileUuid?: InputMaybe<Scalars['String']['input']>;
  generalLedgerCodeId?: InputMaybe<Scalars['String']['input']>;
  invoiceDisplayName?: InputMaybe<Scalars['String']['input']>;
  isAuthoCodeRequired?: InputMaybe<Scalars['Boolean']['input']>;
  isDefaultGlobalSpecial?: InputMaybe<Scalars['Boolean']['input']>;
  isSpecial?: InputMaybe<Scalars['Boolean']['input']>;
  matchingGlobalAccessorial?: InputMaybe<Scalars['String']['input']>;
  percentForSettlement?: InputMaybe<Scalars['Float']['input']>;
  quickbooksFileMappingChargeName?: InputMaybe<Scalars['String']['input']>;
  skidBasedAccessorialUpdateInput?: InputMaybe<SkidBasedAccessorialUpdateInput>;
  specialAccessorialUpdateInput?: InputMaybe<SpecialAccessorialUpdateInput>;
  standardAccessorialUpdateInput?: InputMaybe<StandardAccessorialUpdateInput>;
  terminalUuid?: InputMaybe<Scalars['String']['input']>;
  unitBasedAccessorialUpdateInput?: InputMaybe<UnitBasedAccessorialUpdateInput>;
  waitTimeAccessorialUpdateInput?: InputMaybe<WaitTimeAccessorialUpdateInput>;
  weightBasedAccessorialUpdateInput?: InputMaybe<WeightBasedAccessorialUpdateInput>;
  zoneBasedAccessorialUpdateInput?: InputMaybe<ZoneBasedAccessorialUpdateInput>;
};

export type AccountingReportFilterTypesErrorOutput = {
  __typename?: 'AccountingReportFilterTypesErrorOutput';
  errorMessage: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type AccountingReportFilterTypesInput = {
  /** The report type to return the list of filters for */
  reportType: AccountingReportTypeV2;
};

export type AccountingReportFilterTypesSuccessOutput = {
  __typename?: 'AccountingReportFilterTypesSuccessOutput';
  /** A list of report filter types that are required for the specified accounting report type in the query input */
  reportFilterTypes: Array<ReportFilterType>;
  success: Scalars['Boolean']['output'];
};

export type AccountingReportFiltersOutput = AccountingReportFilterTypesErrorOutput | AccountingReportFilterTypesSuccessOutput;

export enum AccountingReportType {
  AgingReport = 'AgingReport'
}

export enum AccountingReportTypeV2 {
  AgingReportDetailed = 'AGING_REPORT_DETAILED',
  DunningReport = 'DUNNING_REPORT'
}

export enum AccountsReceivableCustomerFilter {
  All = 'ALL',
  NonzeroBalance = 'NONZERO_BALANCE'
}

export type AccountsReceivableReportArgs = {
  /** If true, calculate customer balance as of the provided end date in dateFilters. If false, calculate overall customer balance with no date filter. */
  calculateBalanceAsOfEndDate: Scalars['Boolean']['input'];
  customerFilter?: InputMaybe<AccountsReceivableCustomerFilter>;
  dateFilter?: InputMaybe<DateFilterStartEnd>;
};

/** Accounts receivable report data for a particular contact */
export type AccountsReceivableReportDataForContactEntity = {
  __typename?: 'AccountsReceivableReportDataForContactEntity';
  /** Overall balance of contact (invoices minus payments), in dollars */
  balance: Scalars['Float']['output'];
  /** Contact reference number (Account ID) */
  contactReferenceNumber?: Maybe<Scalars['String']['output']>;
  contactUuid: Scalars['String']['output'];
  /** Contact display name */
  displayName: Scalars['String']['output'];
  /** Sum of credit (paymentType = CREDIT) amounts that have been applied to this contacts invoices, in dollars */
  totalCredits: Scalars['Float']['output'];
  /** Sum of debit (paymentType = DEBIT) amounts that have been applied to this contacts invoices, in dollars */
  totalDebits: Scalars['Float']['output'];
  /** Sum of posted invoice totals, in dollars */
  totalInvoices: Scalars['Float']['output'];
  /** Sum of payment (paymentType = PAYMENT) amounts that have been applied to this contacts invoices, in dollars */
  totalPayments: Scalars['Float']['output'];
  /** Sum of credit (paymentType = CREDIT) amounts that have not been applied, in dollars */
  unappliedCredits: Scalars['Float']['output'];
  /** Sum of debit (paymentType = DEBIT) amounts that have not been applied, in dollars */
  unappliedDebits: Scalars['Float']['output'];
  /** Sum of payment (paymentType = PAYMENT) amounts that have not been applied, in dollars */
  unappliedPayments: Scalars['Float']['output'];
};

export type AcknowledgeMyStopChangeInput = {
  stopUuid: Scalars['String']['input'];
};

export type AcknowledgeMyStopChangeOutput = AcknowledgeMyStopChangeSuccessOutput | MutationErrorOutput;

export type AcknowledgeMyStopChangeSuccessOutput = {
  __typename?: 'AcknowledgeMyStopChangeSuccessOutput';
  stop: StopEntity;
  /** Whether the stop was updated. This could be false if, for example, the stop had been re-assigned to a different driver. */
  updated: Scalars['Boolean']['output'];
};

export type AcknowledgeRouteChangesInput = {
  endDate: Scalars['DateTime']['input'];
  startDate: Scalars['DateTime']['input'];
};

export type AddApiUserContactMappingInput = {
  apiUserUuid: Scalars['String']['input'];
  contactUuid: Scalars['String']['input'];
};

export type AddDriversToRouteInput = {
  driverUuids: Array<Scalars['String']['input']>;
  routeUuid: Scalars['String']['input'];
};

export type AddLineItemsToSettlementBillsInput = {
  settlementBillCreateInputs?: InputMaybe<Array<NewSettlementBillInput>>;
  settlementBillUpdateInputs?: InputMaybe<Array<ExistingSettlementBillInput>>;
};

export type AddLineItemsToSettlementBillsOutput = AddLineItemsToSettlementBillsSuccessOutput | MutationErrorOutput;

export type AddLineItemsToSettlementBillsSuccessOutput = {
  __typename?: 'AddLineItemsToSettlementBillsSuccessOutput';
  driverSettlementBills: Array<DriverSettlementBillEntity>;
};

export type AddOrdersToExistingInvoiceErrorOutput = {
  __typename?: 'AddOrdersToExistingInvoiceErrorOutput';
  attemptedOrdersToAdd: Array<OrderToAddToInvoice>;
  invoiceName: Scalars['String']['output'];
  invoiceUuid: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type AddOrdersToExistingInvoiceResult = AddOrdersToExistingInvoiceErrorOutput | AddOrdersToInvoiceSuccessOutput;

export type AddOrdersToInvoiceSuccessOutput = {
  __typename?: 'AddOrdersToInvoiceSuccessOutput';
  invoiceName: Scalars['String']['output'];
  invoiceUuid: Scalars['String']['output'];
  ordersAdded: Array<OrderAddedToInvoice>;
  success: Scalars['Boolean']['output'];
};

export type AddOrdersToInvoicesForContactErrorOutput = {
  __typename?: 'AddOrdersToInvoicesForContactErrorOutput';
  contactName: Scalars['String']['output'];
  contactUuid: Scalars['String']['output'];
  proposedNewInvoicesToCreate: Array<NewInvoiceToCreate>;
  proposedUpdatesToExistingInvoices: Array<ExistingInvoiceToUpdate>;
  success: Scalars['Boolean']['output'];
};

export type AddOrdersToInvoicesForContactOutput = AddOrdersToInvoicesForContactErrorOutput | AddOrdersToInvoicesForContactSuccessOutput;

export type AddOrdersToInvoicesForContactSuccessOutput = {
  __typename?: 'AddOrdersToInvoicesForContactSuccessOutput';
  contactName: Scalars['String']['output'];
  contactUuid: Scalars['String']['output'];
  existingInvoiceAdds: Array<AddOrdersToExistingInvoiceResult>;
  newInvoiceAdds: Array<AddOrdersToNewInvoiceResult>;
  success: Scalars['Boolean']['output'];
};

export type AddOrdersToInvoicesInput = {
  addToExistingInvoices: Scalars['Boolean']['input'];
  orderUuids: Array<Scalars['String']['input']>;
};

export type AddOrdersToInvoicesOutput = AddOrdersToInvoicesSuccessOutput | MutationErrorOutput;

export type AddOrdersToInvoicesSuccessOutput = {
  __typename?: 'AddOrdersToInvoicesSuccessOutput';
  invoicesAddedToByContact: Array<AddOrdersToInvoicesForContactOutput>;
  success: Scalars['Boolean']['output'];
};

export type AddOrdersToManifestInput = {
  orderUuids?: InputMaybe<Array<Scalars['String']['input']>>;
  uuid: Scalars['String']['input'];
};

export type AddOrdersToManifestOutput = {
  __typename?: 'AddOrdersToManifestOutput';
  errorMessage?: Maybe<Scalars['String']['output']>;
  lineHaulManifest?: Maybe<LineHaulManifestEntity>;
};

export type AddOrdersToManifestV2Input = {
  manifestUuid: Scalars['String']['input'];
  orderUuids: Array<Scalars['String']['input']>;
};

export type AddOrdersToManifestV2Output = AddOrdersToManifestV2PreviousManifestErrorOutput | AddOrdersToManifestV2SuccessOutput | MutationErrorOutput;

/** An error that occurs when adding orders to a manifest. */
export type AddOrdersToManifestV2PreviousManifestErrorOutput = {
  __typename?: 'AddOrdersToManifestV2PreviousManifestErrorOutput';
  /** An array of errors that occur when adding orders to an initial manifest that have a different start terminal from the start terminal of the manifest being added to */
  originTerminalMismatchErrors: Array<OriginTerminalMismatchError>;
  /** An array of errors that occur when adding orders to a manifest that are on a previous manifest with a different end terminal from the start terminal of the manifest being added to */
  previousManifestErrors: Array<PreviousManifestError>;
};

export type AddOrdersToManifestV2SuccessOutput = {
  __typename?: 'AddOrdersToManifestV2SuccessOutput';
  lineHaulManifest: LineHaulManifestEntity;
};

export type AddOrdersToNewInvoiceErrorOutput = {
  __typename?: 'AddOrdersToNewInvoiceErrorOutput';
  attemptedOrdersToAdd: Array<OrderToAddToInvoice>;
  /** this is null when the invoice could not be created. it is not null when we created the invoice but could not add orders to it */
  createdInvoiceName?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type AddOrdersToNewInvoiceResult = AddOrdersToInvoiceSuccessOutput | AddOrdersToNewInvoiceErrorOutput;

export type AddPermissionToRoleInput = {
  accessLevel: AccessLevel;
  companyUuid?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  resource: PermissionResource;
};

export type AddServiceToContactInput = {
  contactUuid: Scalars['String']['input'];
  serviceUuid: Scalars['String']['input'];
};

export type AddTagToLegInput = {
  legUuid: Scalars['String']['input'];
  tagUuid: Scalars['String']['input'];
};

export type AddTagToOrderInput = {
  orderUuid: Scalars['String']['input'];
  tagUuid: Scalars['String']['input'];
};

export type AddThirdPartyUserToContactInput = {
  contactUuid: Scalars['String']['input'];
  email: Scalars['String']['input'];
};

export type AddUserToRoleInput = {
  userUuid: Scalars['String']['input'];
  /** The UUID of the role to add the user to */
  uuid: Scalars['String']['input'];
};

export type AddUserToRoleOutput = {
  __typename?: 'AddUserToRoleOutput';
  success: Scalars['Boolean']['output'];
};

export type AddressCreateInput = {
  associatedContactUpsertInput?: InputMaybe<ContactPersonUpsertInput>;
  city: Scalars['String']['input'];
  country: Scalars['String']['input'];
  driverInstructions?: InputMaybe<Scalars['String']['input']>;
  iataCode?: InputMaybe<Scalars['String']['input']>;
  internalNotes?: InputMaybe<Scalars['String']['input']>;
  latitude?: InputMaybe<Scalars['Float']['input']>;
  line1: Scalars['String']['input'];
  line2?: InputMaybe<Scalars['String']['input']>;
  longitude?: InputMaybe<Scalars['Float']['input']>;
  name: Scalars['String']['input'];
  preventCoordRecompute?: InputMaybe<Scalars['Boolean']['input']>;
  receivingHoursEnd?: InputMaybe<Scalars['DateTime']['input']>;
  receivingHoursStart?: InputMaybe<Scalars['DateTime']['input']>;
  specialInstructions?: InputMaybe<Scalars['String']['input']>;
  state: Scalars['String']['input'];
  type?: InputMaybe<AddressType>;
  zip: Scalars['String']['input'];
};

export type AddressEntity = {
  __typename?: 'AddressEntity';
  associatedContact?: Maybe<ContactPersonEntity>;
  city: Scalars['String']['output'];
  country: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  driverInstructions?: Maybe<Scalars['String']['output']>;
  formattedAddress: Scalars['String']['output'];
  iataCode?: Maybe<Scalars['String']['output']>;
  internalNotes?: Maybe<Scalars['String']['output']>;
  latitude?: Maybe<Scalars['Float']['output']>;
  line1: Scalars['String']['output'];
  line2?: Maybe<Scalars['String']['output']>;
  longitude?: Maybe<Scalars['Float']['output']>;
  name: Scalars['String']['output'];
  preventCoordRecompute?: Maybe<Scalars['Boolean']['output']>;
  receivingHoursEnd?: Maybe<Scalars['DateTime']['output']>;
  receivingHoursStart?: Maybe<Scalars['DateTime']['output']>;
  specialInstructions?: Maybe<Scalars['String']['output']>;
  state: Scalars['String']['output'];
  type: AddressType;
  updatedAt: Scalars['DateTime']['output'];
  uuid: Scalars['String']['output'];
  zip: Scalars['String']['output'];
};

export type AddressForCachedStop = {
  __typename?: 'AddressForCachedStop';
  city: Scalars['String']['output'];
  latitude?: Maybe<Scalars['Float']['output']>;
  line1: Scalars['String']['output'];
  line2?: Maybe<Scalars['String']['output']>;
  longitude?: Maybe<Scalars['Float']['output']>;
  name: Scalars['String']['output'];
  routeName?: Maybe<Scalars['String']['output']>;
  routeNameUuid?: Maybe<Scalars['String']['output']>;
  state: Scalars['String']['output'];
  zip: Scalars['String']['output'];
};

export enum AddressType {
  Record = 'RECORD',
  Template = 'TEMPLATE'
}

/** Filter fields for the address type enum field */
export type AddressTypeFilter = {
  /** Filter for records where the address type is equal to the provided address type value */
  eq?: InputMaybe<StandardStopType>;
};

export type AddressUpdateInput = {
  city?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  driverInstructions?: InputMaybe<Scalars['String']['input']>;
  iataCode?: InputMaybe<Scalars['String']['input']>;
  internalNotes?: InputMaybe<Scalars['String']['input']>;
  latitude?: InputMaybe<Scalars['Float']['input']>;
  line1?: InputMaybe<Scalars['String']['input']>;
  line2?: InputMaybe<Scalars['String']['input']>;
  longitude?: InputMaybe<Scalars['Float']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  preventCoordRecompute?: InputMaybe<Scalars['Boolean']['input']>;
  recalculateLatLong?: InputMaybe<Scalars['Boolean']['input']>;
  receivingHoursEnd?: InputMaybe<Scalars['DateTime']['input']>;
  receivingHoursStart?: InputMaybe<Scalars['DateTime']['input']>;
  specialInstructions?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<AddressType>;
  uuid: Scalars['String']['input'];
  zip?: InputMaybe<Scalars['String']['input']>;
};

export type AddressUpsertInput = {
  city: Scalars['String']['input'];
  country: Scalars['String']['input'];
  driverInstructions?: InputMaybe<Scalars['String']['input']>;
  iataCode?: InputMaybe<Scalars['String']['input']>;
  internalNotes?: InputMaybe<Scalars['String']['input']>;
  latitude?: InputMaybe<Scalars['Float']['input']>;
  line1: Scalars['String']['input'];
  line2?: InputMaybe<Scalars['String']['input']>;
  longitude?: InputMaybe<Scalars['Float']['input']>;
  name: Scalars['String']['input'];
  preventCoordRecompute?: InputMaybe<Scalars['Boolean']['input']>;
  preventCoordRecomputeInBackend?: InputMaybe<Scalars['Boolean']['input']>;
  receivingHoursEnd?: InputMaybe<Scalars['DateTime']['input']>;
  receivingHoursStart?: InputMaybe<Scalars['DateTime']['input']>;
  specialInstructions?: InputMaybe<Scalars['String']['input']>;
  state: Scalars['String']['input'];
  type?: InputMaybe<AddressType>;
  uuid: Scalars['String']['input'];
  zip: Scalars['String']['input'];
};

export type AdjustmentStopDriverMapCreateInput = {
  driverSettlementBillUuid?: InputMaybe<Scalars['String']['input']>;
  driverUuid?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  revenueFlatRate?: InputMaybe<Scalars['Float']['input']>;
};

export type AgentFieldsEntity = {
  __typename?: 'AgentFieldsEntity';
  activeTerminals: Array<TerminalEntity>;
  defaultDriver: DriverEntity;
  name: Scalars['String']['output'];
  uuid: Scalars['String']['output'];
};

/** The open invoice value for a contact within the specified day range */
export type AgingReportBucketEntity = {
  __typename?: 'AgingReportBucketEntity';
  /** Include invoices with date greater than this many days before the aging report start date. If null, there is no lower bound */
  greaterThanOrEqualToDays?: Maybe<Scalars['Float']['output']>;
  /** Include invoices with date less than or equal to this many days before the aging report start date. If null, there is no upper bound */
  lessThanOrEqualToDays?: Maybe<Scalars['Float']['output']>;
  /** The total value of open invoices in this bucket in dollars */
  openInvoiceValue: Scalars['Float']['output'];
};

/** Aging report data for a particular contact that includes the contact invoices and buckets with open invoice values by start and end day ranges */
export type AgingReportForContactEntity = {
  __typename?: 'AgingReportForContactEntity';
  contactAddress?: Maybe<AddressEntity>;
  contactUuid: Scalars['String']['output'];
  /** Contact display name */
  displayName: Scalars['String']['output'];
  invoices: Array<InvoiceForAgingReportEntity>;
  openInvoiceValueBuckets: Array<AgingReportBucketEntity>;
};

export type AirportInfoEntity = {
  __typename?: 'AirportInfoEntity';
  address: AddressEntity;
  createdAt: Scalars['DateTime']['output'];
  iataCode: Scalars['String']['output'];
  isActive: Scalars['Boolean']['output'];
  terminal: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  uuid: Scalars['String']['output'];
};

export type ApiLogConnection = {
  __typename?: 'ApiLogConnection';
  edges: Array<ApiLogEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type ApiLogEdge = {
  __typename?: 'ApiLogEdge';
  cursor: Scalars['String']['output'];
  node: ApiLogEntity;
};

export type ApiLogEntity = {
  __typename?: 'ApiLogEntity';
  createdAt: Scalars['DateTime']['output'];
  direction: ApiRequestDirection;
  emailTransaction?: Maybe<EmailTransactionEntity>;
  freightSnapTransaction?: Maybe<FreightSnapTransactionEntity>;
  payload?: Maybe<Scalars['String']['output']>;
  responseStatus?: Maybe<ApiResponseStatus>;
  sourceIpAddress?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  uuid: Scalars['String']['output'];
};

export enum ApiRequestDirection {
  Received = 'RECEIVED',
  Sent = 'SENT'
}

export enum ApiResponseStatus {
  Http_200 = 'HTTP_200',
  Http_500 = 'HTTP_500',
  HttpOther = 'HTTP_OTHER'
}

export type ApiUserCreateInput = {
  apiKey: Scalars['String']['input'];
  enableStaging?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  webhookUrl?: InputMaybe<Scalars['String']['input']>;
};

export type ApiUserEntity = {
  __typename?: 'ApiUserEntity';
  apiKey: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  enableStaging: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  uuid: Scalars['String']['output'];
  webhookUrl?: Maybe<Scalars['String']['output']>;
};

export type ApiUserUpdateInput = {
  apiKey?: InputMaybe<Scalars['String']['input']>;
  enableStaging?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  uuid: Scalars['String']['input'];
  webhookUrl?: InputMaybe<Scalars['String']['input']>;
};

export enum AppointmentCallStatus {
  Busy = 'BUSY',
  Called = 'CALLED',
  Cancelled = 'CANCELLED',
  Confirmed = 'CONFIRMED',
  Failed = 'FAILED',
  InProgress = 'IN_PROGRESS',
  NotCalled = 'NOT_CALLED',
  NoAnswer = 'NO_ANSWER',
  Rejected = 'REJECTED'
}

export type AppointmentConfirmationInfoOutput = {
  __typename?: 'AppointmentConfirmationInfoOutput';
  appointmentConfirmed: Scalars['Boolean']['output'];
  /** The date and time of the appointment in a human-readable format, local to the stop */
  appointmentDateTime: Scalars['String']['output'];
  /** @deprecated Use appointmentDateTime instead */
  appointmentInfoString: Scalars['String']['output'];
  /** @deprecated Use appointmentConfirmed and rescheduleRequested instead */
  appointmentTextStatus: AppointmentTextStatus;
  /** @deprecated Legacy API, always true */
  hasAppointment: Scalars['Boolean']['output'];
  /** @deprecated Use stopType instead */
  pickupOrDelivery?: Maybe<PickupOrDelivery>;
  /** Whether the contact person of the stop has requested to reschedule the appointment */
  rescheduleRequested: Scalars['Boolean']['output'];
  stopType?: Maybe<StopType>;
};

export type AppointmentOption = {
  __typename?: 'AppointmentOption';
  date: PlainDate;
  endTime: PlainTime;
  /** The appointment date in a human-readable format, local to the stop timezone */
  humanDate: Scalars['String']['output'];
  startTime: PlainTime;
};

export type AppointmentOptions = {
  __typename?: 'AppointmentOptions';
  /** Whether the appointment has been set either by the contact person or manually, possibly not confirmed */
  appointmentExists: Scalars['Boolean']['output'];
  /** A descriptive user-facing message to display */
  message?: Maybe<Scalars['String']['output']>;
  options: Array<AppointmentOption>;
  /** The number of options the API generates per page (i.e., per query). If the API returns fewer options than specified here, then we have reached the last page of possible options. */
  pageSize: Scalars['Int']['output'];
  /** Whether the contact person of the stop has requested to reschedule the appointment */
  rescheduleRequested: Scalars['Boolean']['output'];
};

export type AppointmentOptionsInput = {
  /** The start date and time from which to query for options */
  from?: InputMaybe<PlainDateTimeInput>;
  stopUuid: Scalars['String']['input'];
};

export enum AppointmentTextStatus {
  Confirmed = 'CONFIRMED',
  NotSent = 'NOT_SENT',
  Rejected = 'REJECTED',
  Sent = 'SENT'
}

export enum AppointmentWindowType {
  Soft = 'SOFT',
  SoftEnd = 'SOFT_END',
  SoftStart = 'SOFT_START',
  Strict = 'STRICT'
}

export type ApproveQuoteInput = {
  orderUuid: Scalars['String']['input'];
  quoteUuid: Scalars['String']['input'];
};

/** This is the graphql input for archiving an organization */
export type ArchiveOrganizationInput = {
  uuid: Scalars['String']['input'];
};

export type ArchiveOrganizationOutput = ArchiveOrganizationSuccessOutput | MutationErrorOutput;

export type ArchiveOrganizationSuccessOutput = {
  __typename?: 'ArchiveOrganizationSuccessOutput';
  /** The archived org */
  organization: OrganizationEntity;
};

export type ArchiveTariffChainInput = {
  id: Scalars['String']['input'];
};

export type ArchiveTariffChainOutput = ArchiveTariffChainSuccessOutput | MutationErrorOutput;

export type ArchiveTariffChainSuccessOutput = {
  __typename?: 'ArchiveTariffChainSuccessOutput';
  /** The tariff chain that was archived */
  tariffChain: TariffChainEntity;
};

export type ArriveAtStopInput = {
  /** A user entered value for when the driver arrived at the stop> If set to null, the default arrival date is used */
  arrivalTime?: InputMaybe<Scalars['DateTime']['input']>;
  stopUuid: Scalars['String']['input'];
};

/** The expected input to mark a set of stops as arrived */
export type ArriveAtStopsInput = {
  arriveAtStopInputs: Array<ArriveAtStopInput>;
};

export type ArriveAtStopsOutput = ArriveAtStopsSuccessOutput | MutationErrorOutput;

export type ArriveAtStopsSuccessOutput = {
  __typename?: 'ArriveAtStopsSuccessOutput';
  /** The list of stop UUIDs that were successfully marked as arrived */
  arrivedStopUuids: Array<Scalars['String']['output']>;
  /** The list of stop UUIDs that were not marked as arrived */
  failedStopUuids: Array<Scalars['String']['output']>;
};

export type AssignInventoryItemsToStorageUnitInput = {
  itemUuid: Scalars['String']['input'];
  /** The number of inventory items to assign to the specified storage unit */
  quantity: Scalars['Int']['input'];
  storageOrderUuid: Scalars['String']['input'];
  /** The UUID of the storage unit to assign the inventory items */
  uuid: Scalars['String']['input'];
};

export type AssignInventoryItemsToStorageUnitOutput = {
  __typename?: 'AssignInventoryItemsToStorageUnitOutput';
  success: Scalars['Boolean']['output'];
};

export type AssignOutboundReferenceNumberToStorageUnitsInput = {
  outboundReferenceNumber: Scalars['String']['input'];
  /** The UUIDs of the storage units to assign the outbound reference number to */
  uuids: Array<Scalars['String']['input']>;
};

export type AssignOutboundReferenceNumberToStorageUnitsOutput = {
  __typename?: 'AssignOutboundReferenceNumberToStorageUnitsOutput';
  success: Scalars['Boolean']['output'];
};

export type AuditLogEntry = {
  __typename?: 'AuditLogEntry';
  orderEvent: OrderEventEntity;
  snapshotDifference?: Maybe<AuditLogSnapshotDifference>;
};

export type AuditLogSnapshotDifference = {
  __typename?: 'AuditLogSnapshotDifference';
  inboundStopDifferences?: Maybe<SnapshotStopDifferences>;
  orderDifferences?: Maybe<SnapshotOrderDifferences>;
  outboundStopDifferences?: Maybe<SnapshotStopDifferences>;
};

export type AuditReportArgs = {
  businessDivisionUuid?: InputMaybe<Scalars['String']['input']>;
  contactUuid?: InputMaybe<Scalars['String']['input']>;
  daysPastDue?: InputMaybe<Scalars['Float']['input']>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  excludeMigratedOrders?: InputMaybe<Scalars['Boolean']['input']>;
  isPastDue?: InputMaybe<Scalars['Boolean']['input']>;
  lastNumberOfDays?: InputMaybe<Scalars['Float']['input']>;
  lastNumberOfMonths?: InputMaybe<Scalars['Float']['input']>;
  lastNumberOfWeeks?: InputMaybe<Scalars['Float']['input']>;
  reportAggregationPeriod: ReportAggregationPeriod;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
};

export type AuditReportBucketEntity = {
  __typename?: 'AuditReportBucketEntity';
  assigned: Array<Scalars['String']['output']>;
  attempted: Array<Scalars['String']['output']>;
  billingIssues: Array<Scalars['String']['output']>;
  cancelledFinalized: Array<Scalars['String']['output']>;
  cancelledUnfinalized: Array<Scalars['String']['output']>;
  contactUuid?: Maybe<Scalars['String']['output']>;
  daysPastDue?: Maybe<Scalars['Float']['output']>;
  endDate: Scalars['DateTime']['output'];
  noAction: Array<Scalars['String']['output']>;
  noChargeFinalized: Array<Scalars['String']['output']>;
  onHand: Array<Scalars['String']['output']>;
  onHold: Array<Scalars['String']['output']>;
  onInvoicePosted: Array<Scalars['String']['output']>;
  onInvoiceUnposted: Array<Scalars['String']['output']>;
  partiallyComplete: Array<Scalars['String']['output']>;
  startDate: Scalars['DateTime']['output'];
  unfinalized: Array<Scalars['String']['output']>;
};

export type AutoApplyAccessorialConfigEntity = {
  __typename?: 'AutoApplyAccessorialConfigEntity';
  /** @deprecated Use accessorials instead */
  accessorial: AccessorialUnion;
  accessorials: Array<AccessorialUnion>;
  contact?: Maybe<ContactEntity>;
  contactsToExcludeFromRule?: Maybe<Array<ContactEntity>>;
  contactsToIncludeWithRule?: Maybe<Array<ContactEntity>>;
  createdAt: Scalars['DateTime']['output'];
  ruleType: AutoApplyAccessorialRuleType;
  service?: Maybe<ServiceEntity>;
  stopType?: Maybe<PickupOrDelivery>;
  tag?: Maybe<TagEntity>;
  terminal?: Maybe<TerminalEntity>;
  updatedAt: Scalars['DateTime']['output'];
  uuid: Scalars['String']['output'];
};

export enum AutoApplyAccessorialRuleType {
  Contact = 'CONTACT',
  ContactAndService = 'CONTACT_AND_SERVICE',
  ContactAndServiceAndTag = 'CONTACT_AND_SERVICE_AND_TAG',
  Global = 'GLOBAL',
  IsHazmat = 'IS_HAZMAT',
  IsInBond = 'IS_IN_BOND',
  Residential = 'RESIDENTIAL',
  Service = 'SERVICE',
  ServiceAndTag = 'SERVICE_AND_TAG',
  StopType = 'STOP_TYPE',
  StopTypeAndTerminal = 'STOP_TYPE_AND_TERMINAL'
}

/** The average days to pay report values for a contact */
export type AverageDaysToPayForContactEntity = {
  __typename?: 'AverageDaysToPayForContactEntity';
  averageDaysToPay90: Scalars['Float']['output'];
  averageDaysToPay180: Scalars['Float']['output'];
  averageDaysToPay270: Scalars['Float']['output'];
  averageDaysToPay360: Scalars['Float']['output'];
  averageDaysToPay720: Scalars['Float']['output'];
  averageDaysToPayAll: Scalars['Float']['output'];
  contactReferenceNumber?: Maybe<Scalars['String']['output']>;
  contactUuid: Scalars['String']['output'];
  displayName: Scalars['String']['output'];
};

export type BackfillOrderTotalResult = {
  __typename?: 'BackfillOrderTotalResult';
  errorMessage?: Maybe<Scalars['String']['output']>;
  orderUuid: Scalars['String']['output'];
};

export type BackfillOrderTotalsOutput = {
  __typename?: 'BackfillOrderTotalsOutput';
  results: Array<BackfillOrderTotalResult>;
};

export type BatchAddShipmentsToInvoicePreview = {
  __typename?: 'BatchAddShipmentsToInvoicePreview';
  billingCycleDuration: BillingCycleDuration;
  contactName: Scalars['String']['output'];
  contactUuid: Scalars['String']['output'];
  existingInvoiceAdds: Array<InvoiceAdd>;
  newInvoiceAdds: Array<InvoiceAdd>;
};

export type BatchAddShipmentsToInvoicesInput = {
  addToExistingInvoices: Scalars['Boolean']['input'];
  contactUuid: Scalars['String']['input'];
  invoiceTimePeriodSplit?: InputMaybe<TimePeriod>;
  numberOfOrdersPerInvoice?: InputMaybe<Scalars['Float']['input']>;
  numberOfShipmentsPerInvoice?: InputMaybe<Scalars['Float']['input']>;
  shipmentUuids: Array<Scalars['String']['input']>;
};

export type BatchAddShipmentsToInvoicesInputMultiple = {
  batchAddShipmentsToInvoicesInputs: Array<BatchAddShipmentsToInvoicesInput>;
};

export enum BillingCycleDuration {
  Biweekly = 'BIWEEKLY',
  Daily = 'DAILY',
  Monthly = 'MONTHLY',
  None = 'NONE',
  Other = 'OTHER',
  Weekly = 'WEEKLY'
}

export enum BillingCycleType {
  AdHoc = 'AD_HOC',
  EveryFriday = 'EVERY_FRIDAY',
  EveryMonday = 'EVERY_MONDAY',
  EverySaturday = 'EVERY_SATURDAY',
  EverySunday = 'EVERY_SUNDAY',
  EveryThursday = 'EVERY_THURSDAY',
  EveryTuesday = 'EVERY_TUESDAY',
  EveryWednesday = 'EVERY_WEDNESDAY',
  EveryXDays = 'EVERY_X_DAYS'
}

export enum BillingShipmentStatus {
  Finalized = 'FINALIZED',
  HasIssue = 'HAS_ISSUE',
  Invoiced = 'INVOICED',
  Paid = 'PAID'
}

/** Represents the difference between 2 versions of a boolean field. Used in audit log entries */
export type BooleanFieldDifference = {
  __typename?: 'BooleanFieldDifference';
  newValue?: Maybe<Scalars['Boolean']['output']>;
  oldValue?: Maybe<Scalars['Boolean']['output']>;
};

export type BooleanFilter = {
  filterOperator?: InputMaybe<FilterOperator>;
  value: Scalars['Boolean']['input'];
};

/** A filter object that is used to filter a boolean field. Each field in the filter object represents an operator. If there is more than one non-null field passed into the filter object, the condition will be a conjunction of the non-null field operator */
export type BooleanFilterV2 = {
  /** Filters for records where the relevant boolean field is equal to the provided boolean value */
  eq?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filters for records where the relevant boolean field is not equal to the provided boolean value */
  neq?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BulkAccessorialUpdateInput = {
  accessorialToMappingInputs: Array<AccessorialToMappingInput>;
};

export type BulkChangeCallStatusArgs = {
  callStatus: AppointmentCallStatus;
  uuids: Array<Scalars['String']['input']>;
};

export type BulkConfirmAppointmentsArgs = {
  uuids: Array<Scalars['String']['input']>;
};

export type BulkCsvRouteNameInput = {
  csvRouteNameInputs: Array<CsvRouteNameInput>;
};

export type BulkEditOrdersInput = {
  completedAt?: InputMaybe<Scalars['DateTime']['input']>;
  deadlineDate?: InputMaybe<Scalars['DateTime']['input']>;
  deadlineType?: InputMaybe<DeadlineType>;
  masterAirwayBillOfLadingNumber?: InputMaybe<Scalars['String']['input']>;
  orderAction?: InputMaybe<OrderAction>;
  orderUuids: Array<Scalars['String']['input']>;
  orderUuidsForAction: Array<Scalars['String']['input']>;
  podName?: InputMaybe<Scalars['String']['input']>;
  secondaryRefNumber?: InputMaybe<Scalars['String']['input']>;
  serviceDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** The service date in ISO 8601 format. This is used to update the service date for the orders. */
  serviceDateIso8601?: InputMaybe<Scalars['String']['input']>;
  shipmentUuids: Array<Scalars['String']['input']>;
  stopAction?: InputMaybe<StopAction>;
  stopTypes?: InputMaybe<Array<PickupOrDelivery>>;
  stopUuidsForAction: Array<Scalars['String']['input']>;
  stopUuidsForServiceDate?: InputMaybe<Array<Scalars['String']['input']>>;
  warehouseUuid?: InputMaybe<Scalars['String']['input']>;
};

export type BulkUpdateContactMapping = {
  /** The column name in the CSV file that corresponds to the field name in the import contact schema */
  columnName: Scalars['String']['input'];
  /** The field in the import contact schema that corresponds to the column name in the CSV file */
  field: ImportContactField;
};

export type BusinessDivisionEntity = {
  __typename?: 'BusinessDivisionEntity';
  createdAt: Scalars['DateTime']['output'];
  name: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  uuid: Scalars['String']['output'];
};

export type CachedStopBaseEntity = {
  __typename?: 'CachedStopBaseEntity';
  address?: Maybe<AddressForCachedStop>;
  appointmentDateTime?: Maybe<Scalars['DateTime']['output']>;
  appointmentRequired?: Maybe<Scalars['Boolean']['output']>;
  /** Whether the appointment has been confirmed either by the contact person or manually */
  appointmentScheduled?: Maybe<Scalars['Boolean']['output']>;
  /** The latest time the contact person was called with a prompt to select an appointment time */
  appointmentSchedulingOptionsCalledAt?: Maybe<Scalars['DateTime']['output']>;
  /** The latest time the contact person was texted with a prompt to select an appointment time */
  appointmentSchedulingOptionsTextedAt?: Maybe<Scalars['DateTime']['output']>;
  appointmentTime?: Maybe<Scalars['DateTime']['output']>;
  createdAt: Scalars['DateTime']['output'];
  deadlineDate?: Maybe<Scalars['DateTime']['output']>;
  deliveryDate?: Maybe<Scalars['DateTime']['output']>;
  endAppointmentTime?: Maybe<Scalars['DateTime']['output']>;
  hasPreviousAttempt?: Maybe<Scalars['Boolean']['output']>;
  isSpecial?: Maybe<Scalars['Boolean']['output']>;
  serviceDate?: Maybe<Scalars['DateTime']['output']>;
  /** The service date of the stop as a PlainDate. See https://www.notion.so/Service-Date-dc8ae149b6a54bb69404aecf92176287 for details. */
  serviceDateV2?: Maybe<PlainDate>;
  serviceName?: Maybe<Scalars['String']['output']>;
  serviceTimeInMinutes?: Maybe<Scalars['Float']['output']>;
  serviceUuid?: Maybe<Scalars['String']['output']>;
  specialInstructions?: Maybe<Scalars['String']['output']>;
  standardStopType?: Maybe<StandardStopType>;
  status: StopStatus;
  stopType?: Maybe<StopType>;
  terminalName?: Maybe<Scalars['String']['output']>;
  terminalUuid?: Maybe<Scalars['String']['output']>;
  totalCharge?: Maybe<Scalars['Float']['output']>;
  uuid: Scalars['String']['output'];
};

export type CachedStopConnection = {
  __typename?: 'CachedStopConnection';
  edges: Array<CachedStopEdge>;
  pageInfo: PageInfo;
  /** If includeRecurringRunHeaders is true, this is set to the number of recurring runs present among the filtered stops before applying the limit. */
  recurringRunsCount?: Maybe<Scalars['Int']['output']>;
  /** The total number of stops and, if includeRecurringRunHeaders is true, also the number of recurring runs. Not cheap to calculate, request with prudence. */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type CachedStopEdge = {
  __typename?: 'CachedStopEdge';
  cursor: Scalars['String']['output'];
  node: StopsListElement;
};

export type CachedStopEntity = {
  __typename?: 'CachedStopEntity';
  linkedEndStop?: Maybe<CachedStopBaseEntity>;
  order?: Maybe<OrderForCachedStop>;
  otherStop?: Maybe<CachedStopBaseEntity>;
  recurringRunUuid?: Maybe<Scalars['String']['output']>;
  stop: CachedStopBaseEntity;
  stopDetails?: Maybe<StopDetailsOutput>;
};

export type CallStopsInput = {
  uuids: Array<Scalars['String']['input']>;
};

export type ChargeBreakdownReportInput = {
  /** This filters by the order billing party contact. */
  billingPartyContactUuid: Scalars['String']['input'];
  /** This filters by the order invoice date */
  invoiceDateFilter?: InputMaybe<DateFilterV2>;
  /** This filters by the order service date */
  serviceDateFilter?: InputMaybe<DateFilterV2>;
};

export type ChargeBreakdownReportPdfInput = {
  billingPartyContactUuid: Scalars['String']['input'];
  completedAtEndDate?: InputMaybe<Scalars['DateTime']['input']>;
  completedAtStartDate?: InputMaybe<Scalars['DateTime']['input']>;
  statuses?: InputMaybe<Array<InvoiceStatus>>;
};

export type ChargeBreakdownReportPdfOutput = {
  __typename?: 'ChargeBreakdownReportPdfOutput';
  errors?: Maybe<Array<Scalars['String']['output']>>;
  fileName?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type ChargesUnion = CustomChargeEntity | FreightChargeEntity;

export type CheckConsistencyOfInvoicesInput = {
  uuids: Array<Scalars['String']['input']>;
};

export type ChooseAppointmentOptionInput = {
  date: PlainDateInput;
  endTime: PlainTimeInput;
  startTime: PlainTimeInput;
  stopUuid: Scalars['String']['input'];
};

export type ChooseAppointmentOptionOutput = ChooseAppointmentOptionSuccessOutput | MutationErrorOutput;

export type ChooseAppointmentOptionSuccessOutput = {
  __typename?: 'ChooseAppointmentOptionSuccessOutput';
  /** The date and time of the appointment in a human-readable format */
  appointmentDateTime?: Maybe<Scalars['String']['output']>;
};

export type CityAndStateOptionEntity = {
  __typename?: 'CityAndStateOptionEntity';
  city: Scalars['String']['output'];
  state: Scalars['String']['output'];
};

export type ClearCompanyContactsInput = {
  companyUuid: Scalars['String']['input'];
  token: Scalars['String']['input'];
};

export type ClearCompanyContactsOutput = {
  __typename?: 'ClearCompanyContactsOutput';
  status: Scalars['String']['output'];
};

export type ClearCompanyInput = {
  companyUuid: Scalars['String']['input'];
  /** If true, delete empty driver settlement bills with no stop driver maps or settlement bill line items */
  deleteDriverSettlementBills: Scalars['Boolean']['input'];
  /** If true, delete empty invoices with no orders */
  deleteInvoices: Scalars['Boolean']['input'];
  /** If true, allow deleting orders on invoices */
  deleteOrdersOnInvoices: Scalars['Boolean']['input'];
  /** If true, delete payments that are not applied to any orders */
  deletePayments: Scalars['Boolean']['input'];
  /** If true, delete quotes */
  deleteQuotes: Scalars['Boolean']['input'];
  /** If true, delete empty routes with no stops */
  deleteRoutes: Scalars['Boolean']['input'];
  /** This keeps any orders with the provided HAWB aka shipperBillOfLadingNumber. */
  orderHawbsToKeep: Array<Scalars['String']['input']>;
  /** This filters by the order service date. If null or empty, will delete all orders across all service dates */
  orderServiceDateFilter?: InputMaybe<DateFilterV2>;
  /** This filters by the order source. If null or empty, will not delete any orders. */
  orderSourcesToDelete: Array<OrderSource>;
};

export type ClientChallengeEntity = {
  __typename?: 'ClientChallengeEntity';
  name: Scalars['String']['output'];
  squareLogoUrl?: Maybe<Scalars['String']['output']>;
  uuid: Scalars['String']['output'];
};

/** A JSON object that represents the set of configurations for the company */
export type CompanyConfiguration = {
  __typename?: 'CompanyConfiguration';
  addOrdersToOpenInvoices?: Maybe<Scalars['Boolean']['output']>;
  allCapsInOrderPage?: Maybe<Scalars['Boolean']['output']>;
  allowDriverToSelectNextStop?: Maybe<Scalars['Boolean']['output']>;
  appointmentChangeCutoffHours?: Maybe<Scalars['Int']['output']>;
  appointmentSchedulingCutoffDays?: Maybe<Scalars['Int']['output']>;
  appointmentSchedulingLeadingBufferHours?: Maybe<Scalars['Int']['output']>;
  appointmentSchedulingSlotHours?: Maybe<Scalars['Int']['output']>;
  autoApplyWaitTimeMinutes?: Maybe<Scalars['Boolean']['output']>;
  autoGroupStops?: Maybe<Scalars['Boolean']['output']>;
  autoMatchEodDocumentsToOrders?: Maybe<Scalars['Boolean']['output']>;
  blockSendingZeroDollarInvoices: Scalars['Boolean']['output'];
  companyLandscapeLogoUrl?: Maybe<Scalars['String']['output']>;
  companyOrdinalStart?: Maybe<Scalars['Int']['output']>;
  companySquareLogoUrl?: Maybe<Scalars['String']['output']>;
  createRecurringOrdersInAdvanceHours?: Maybe<Scalars['Int']['output']>;
  customDunningReportFooter?: Maybe<Scalars['String']['output']>;
  customDunningReportHeader?: Maybe<Scalars['String']['output']>;
  debounceAccessorialSearch?: Maybe<Scalars['Boolean']['output']>;
  debounceContactSearch?: Maybe<Scalars['Boolean']['output']>;
  defaultDimFactor?: Maybe<Scalars['Int']['output']>;
  defaultFuelSettlementPercentageRate?: Maybe<Scalars['Float']['output']>;
  defaultFuelSurcharge?: Maybe<Scalars['Float']['output']>;
  defaultFuelSurchargeBillingMethod?: Maybe<FuelBillingMethod>;
  defaultGenerateAppointmentDurationInMinutes?: Maybe<Scalars['Int']['output']>;
  defaultInvoiceDocumentsRequired?: Maybe<Array<DocumentType>>;
  defaultInvoiceEmailSubject?: Maybe<Scalars['String']['output']>;
  defaultMeasurementUnits?: Maybe<MeasurementUnits>;
  defaultNonCompanyDriverSettlementMode: SettlementMode;
  defaultRouteLoadTimeInMinutes?: Maybe<Scalars['Float']['output']>;
  defaultRouteStartTime?: Maybe<Scalars['String']['output']>;
  defaultRouteUnloadTimeInMinutes?: Maybe<Scalars['Float']['output']>;
  defaultStandardStopType?: Maybe<StandardStopType>;
  defaultToAccessorial?: Maybe<Scalars['Boolean']['output']>;
  driversShouldMarkFreightAsLoaded?: Maybe<Scalars['Boolean']['output']>;
  enableConsolidatedOrders?: Maybe<Scalars['Boolean']['output']>;
  enableDigitalSignatureFlow?: Maybe<Scalars['Boolean']['output']>;
  enablePaymentMethod?: Maybe<Scalars['Boolean']['output']>;
  fulfillmentTypeEnabled?: Maybe<Scalars['Boolean']['output']>;
  getDriverLocationDataFromMobile?: Maybe<Scalars['Boolean']['output']>;
  includeHyphensInInvoiceName?: Maybe<Scalars['Boolean']['output']>;
  includeINVInInvoiceName?: Maybe<Scalars['Boolean']['output']>;
  invoiceEmail?: Maybe<Scalars['String']['output']>;
  invoiceNotes?: Maybe<Scalars['String']['output']>;
  invoicePdfLogoUrl?: Maybe<Scalars['String']['output']>;
  isCourier?: Maybe<Scalars['Boolean']['output']>;
  lineHaulEnabled?: Maybe<Scalars['Boolean']['output']>;
  logisticsSectionEnabled?: Maybe<Scalars['Boolean']['output']>;
  minDigitsInCompanyOrdinalOrderName?: Maybe<Scalars['Int']['output']>;
  mobilePollingIntervalInSeconds?: Maybe<Scalars['Float']['output']>;
  notificationsEnabled?: Maybe<Scalars['Boolean']['output']>;
  orderIdentifierForCoverSheet?: Maybe<OrderIdentifier>;
  orderNameOrdinal?: Maybe<Scalars['Int']['output']>;
  orderNamingScheme?: Maybe<OrderNamingScheme>;
  packageWarehouseLocationsEnabled?: Maybe<Scalars['Boolean']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  pointToPointTariffsEnabled?: Maybe<Scalars['Boolean']['output']>;
  qbInvoiceNumberStart?: Maybe<Scalars['Int']['output']>;
  requireDimsToFinalizeCharges?: Maybe<Scalars['Boolean']['output']>;
  requireDriverToAcknowledgeRouteChange?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Use requirePODPhotoForDeliveries or requireSigneeNameForDeliveries */
  requirePODPhotoAndName?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Use requirePODPhotoForPickups or requireSigneeNameForPickups */
  requirePODPhotoAndNameForPickups?: Maybe<Scalars['Boolean']['output']>;
  requirePODPhotoForDeliveries?: Maybe<Scalars['Boolean']['output']>;
  requirePODPhotoForPickups?: Maybe<Scalars['Boolean']['output']>;
  requireReviewForEdiOrderCreation?: Maybe<Scalars['Boolean']['output']>;
  requireSigneeNameForDeliveries?: Maybe<Scalars['Boolean']['output']>;
  requireSigneeNameForPickups?: Maybe<Scalars['Boolean']['output']>;
  restrictEditingOrderName?: Maybe<Scalars['Boolean']['output']>;
  sameDayDispatchCellHeader?: Maybe<SameDayDispatchCellHeader>;
  sendSummaryEmailWithIncompleteRoutes?: Maybe<Scalars['Boolean']['output']>;
  sendgridSenderId?: Maybe<Scalars['String']['output']>;
  serviceLevelOptional?: Maybe<Scalars['Boolean']['output']>;
  showChargesOnCustomerPortal?: Maybe<Scalars['Boolean']['output']>;
  showDriverSettlementInBilling?: Maybe<Scalars['Boolean']['output']>;
  showHelpersColumnInDispatch?: Maybe<Scalars['Boolean']['output']>;
  showKilogramsAndCentimeters?: Maybe<Scalars['Boolean']['output']>;
  showManuallyConfirmedByDefault?: Maybe<Scalars['Boolean']['output']>;
  showVehicleInDailyDispatch?: Maybe<Scalars['Boolean']['output']>;
  startingInvoiceOrdinalNumber?: Maybe<Scalars['Float']['output']>;
  terminalsEnabled?: Maybe<Scalars['Boolean']['output']>;
  textNextCustomerForAppointments?: Maybe<Scalars['Boolean']['output']>;
  timeZone?: Maybe<Scalars['String']['output']>;
  useDriverNumberForDispatch?: Maybe<Scalars['Boolean']['output']>;
  useJournalNumberForInvoice?: Maybe<Scalars['Boolean']['output']>;
  useSageBusinessWorks?: Maybe<Scalars['Boolean']['output']>;
  wmsAutoMarkOnHand?: Maybe<Scalars['Boolean']['output']>;
  wmsEnabled?: Maybe<Scalars['Boolean']['output']>;
  wmsShortTermStorageEnabled?: Maybe<Scalars['Boolean']['output']>;
  wmsStorageOrdersEnabled?: Maybe<Scalars['Boolean']['output']>;
};

export type CompanyConfigurationEntity = {
  __typename?: 'CompanyConfigurationEntity';
  addOrdersToOpenInvoices: Scalars['Boolean']['output'];
  allCapsInOrderPage: Scalars['Boolean']['output'];
  allowDriverToSelectNextStop?: Maybe<Scalars['Boolean']['output']>;
  appointmentChangeCutoffHours: Scalars['Int']['output'];
  appointmentSchedulingCutoffDays: Scalars['Int']['output'];
  appointmentSchedulingLeadingBufferHours: Scalars['Int']['output'];
  appointmentSchedulingSlotHours: Scalars['Int']['output'];
  autoApplyWaitTimeMinutes: Scalars['Boolean']['output'];
  autoGroupStops: Scalars['Boolean']['output'];
  autoMatchEodDocumentsToOrders: Scalars['Boolean']['output'];
  company: CompanyEntity;
  companyOrdinalStart?: Maybe<Scalars['Int']['output']>;
  createRecurringOrdersInAdvanceHours: Scalars['Int']['output'];
  createdAt: Scalars['DateTime']['output'];
  customDriverSignableForms: Array<DriverSignableFormTemplateEntity>;
  defaultDimFactor?: Maybe<Scalars['Int']['output']>;
  defaultFuelSettlementPercentageRate?: Maybe<Scalars['Float']['output']>;
  defaultFuelSurcharge?: Maybe<Scalars['Float']['output']>;
  defaultFuelSurchargeBillingMethod: FuelBillingMethod;
  defaultGenerateAppointmentDurationInMinutes: Scalars['Int']['output'];
  defaultInvoiceDocumentsRequired: Array<DocumentType>;
  defaultRouteLoadTimeInMinutes?: Maybe<Scalars['Float']['output']>;
  defaultRouteStartTime?: Maybe<Scalars['DateTime']['output']>;
  defaultRouteUnloadTimeInMinutes?: Maybe<Scalars['Float']['output']>;
  defaultStandardStopType: StandardStopType;
  defaultToAccessorial: Scalars['Boolean']['output'];
  driversShouldMarkFreightAsLoaded: Scalars['Boolean']['output'];
  enableConsolidatedOrders: Scalars['Boolean']['output'];
  enableDigitalSignatureFlow: Scalars['Boolean']['output'];
  enablePaymentMethod: Scalars['Boolean']['output'];
  fulfillmentTypeEnabled: Scalars['Boolean']['output'];
  getDriverLocationDataFromMobile: Scalars['Boolean']['output'];
  includeHyphensInInvoiceName: Scalars['Boolean']['output'];
  includeINVInInvoiceName: Scalars['Boolean']['output'];
  invoiceNotes?: Maybe<Scalars['String']['output']>;
  invoicePdfLogoUrl?: Maybe<Scalars['String']['output']>;
  lineHaulEnabled: Scalars['Boolean']['output'];
  logisticsSectionEnabled: Scalars['Boolean']['output'];
  minDigitsInCompanyOrdinalOrderName?: Maybe<Scalars['Int']['output']>;
  mobilePollingIntervalInSeconds?: Maybe<Scalars['Float']['output']>;
  notificationsEnabled: Scalars['Boolean']['output'];
  orderIdentifierForCoverSheet: OrderIdentifier;
  orderNamingScheme: OrderNamingScheme;
  packageWarehouseLocationsEnabled: Scalars['Boolean']['output'];
  pointToPointTariffsEnabled: Scalars['Boolean']['output'];
  requireDimsToFinalizeCharges: Scalars['Boolean']['output'];
  requireDriverToAcknowledgeRouteChange: Scalars['Boolean']['output'];
  requireDriverToConfirmStopCompletedAtTime: Scalars['Boolean']['output'];
  requirePODPhotoAndName: Scalars['Boolean']['output'];
  requirePODPhotoAndNameForPickups: Scalars['Boolean']['output'];
  requirePODPhotoForDeliveries: Scalars['Boolean']['output'];
  requirePODPhotoForPickups: Scalars['Boolean']['output'];
  requireReviewForEdiOrderCreation: Scalars['Boolean']['output'];
  requireSigneeNameForDeliveries: Scalars['Boolean']['output'];
  requireSigneeNameForPickups: Scalars['Boolean']['output'];
  restrictEditingOrderName: Scalars['Boolean']['output'];
  sameDayDispatchCellHeader: SameDayDispatchCellHeader;
  sendSummaryEmailWithIncompleteRoutes: Scalars['Boolean']['output'];
  serviceLevelOptional: Scalars['Boolean']['output'];
  showChargesOnCustomerPortal: Scalars['Boolean']['output'];
  showDriverSettlementInBilling: Scalars['Boolean']['output'];
  showHelpersColumnInDispatch?: Maybe<Scalars['Boolean']['output']>;
  showKilogramsAndCentimeters: Scalars['Boolean']['output'];
  showManuallyConfirmedByDefault?: Maybe<Scalars['Boolean']['output']>;
  showVehicleInDailyDispatch?: Maybe<Scalars['Boolean']['output']>;
  startingInvoiceOrdinalNumber?: Maybe<Scalars['Float']['output']>;
  terminalsEnabled: Scalars['Boolean']['output'];
  textNextCustomerForAppointments: Scalars['Boolean']['output'];
  updatedAt: Scalars['DateTime']['output'];
  useDriverNumberForDispatch: Scalars['Boolean']['output'];
  useJournalNumberForInvoice: Scalars['Boolean']['output'];
  uuid: Scalars['String']['output'];
  wmsAutoMarkOnHand: Scalars['Boolean']['output'];
  /** @deprecated No longer in use. Present for backwards compatibility, will be removed in the future. */
  wmsBarcodeScannerEnabled: Scalars['Boolean']['output'];
  wmsEnabled: Scalars['Boolean']['output'];
  wmsShortTermStorageEnabled: Scalars['Boolean']['output'];
  wmsStorageOrdersEnabled: Scalars['Boolean']['output'];
};

export type CompanyEntity = {
  __typename?: 'CompanyEntity';
  accessorials: Array<AccessorialUnion>;
  addresses: Array<AddressEntity>;
  airportInfos: Array<AirportInfoEntity>;
  alternateIsaId?: Maybe<Scalars['String']['output']>;
  alternateStandardCarrierAlphaCode?: Maybe<Scalars['String']['output']>;
  blockSendingZeroDollarInvoices: Scalars['Boolean']['output'];
  companyLandscapeLogoUrl?: Maybe<Scalars['String']['output']>;
  companySquareLogoUrl?: Maybe<Scalars['String']['output']>;
  companyStatistics?: Maybe<CompanyStatsEntity>;
  /** A JSON object that represents the set of configurations for the company */
  configs?: Maybe<CompanyConfiguration>;
  configuration?: Maybe<CompanyConfigurationEntity>;
  createdAt: Scalars['DateTime']['output'];
  customDunningReportFooter?: Maybe<Scalars['String']['output']>;
  customDunningReportHeader?: Maybe<Scalars['String']['output']>;
  customerContacts: Array<CustomerContactEntity>;
  defaultAddress?: Maybe<AddressEntity>;
  defaultInboundEdiService?: Maybe<ServiceEntity>;
  defaultInboundOutboundEdiService?: Maybe<ServiceEntity>;
  defaultInvoiceEmailSubject?: Maybe<Scalars['String']['output']>;
  defaultLineHaulSettlementTariffChain?: Maybe<TariffChainEntity>;
  defaultLineHaulTariffChain?: Maybe<TariffChainEntity>;
  defaultMeasurementUnits: MeasurementUnits;
  defaultNonCompanyDriverSettlementMode: SettlementMode;
  defaultOrdinarySettlementTariffChain?: Maybe<TariffChainEntity>;
  defaultOrdinaryTariffChain?: Maybe<TariffChainEntity>;
  defaultOutboundEdiService?: Maybe<ServiceEntity>;
  defaultPointToPointSettlementTariffChain?: Maybe<TariffChainEntity>;
  defaultPointToPointTariffChain?: Maybe<TariffChainEntity>;
  defaultTransferSettlementTariffChain?: Maybe<TariffChainEntity>;
  defaultTransferTariffChain?: Maybe<TariffChainEntity>;
  defaultWeightUnits: WeightUnits;
  drivers: Array<DriverEntity>;
  fourthAlternateIsaId?: Maybe<Scalars['String']['output']>;
  fourthAlternateScac?: Maybe<Scalars['String']['output']>;
  freightChargeQuickbooksMappingId?: Maybe<Scalars['String']['output']>;
  freightSnapId?: Maybe<Scalars['String']['output']>;
  fuelChargeQuickbooksMappingId?: Maybe<Scalars['String']['output']>;
  id: Scalars['Float']['output'];
  invoiceEmail?: Maybe<Scalars['String']['output']>;
  isCourier?: Maybe<Scalars['Boolean']['output']>;
  isaId?: Maybe<Scalars['String']['output']>;
  lineHaulLanes: Array<LineHaulLaneEntity>;
  miscCustomChargeQuickbooksMappingId?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  orderFormFields: OrderFormFieldsEntity;
  orderImportConfiguration?: Maybe<OrderImportConfigurationEntity>;
  orderNameOrdinal?: Maybe<Scalars['Int']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  productionCompany?: Maybe<ProductionCompany>;
  purchasedProductOfferings: Array<PalletProductOffering>;
  qbInvoiceNumberStart?: Maybe<Scalars['Float']['output']>;
  quickbooksAccessToken?: Maybe<QuickbooksOauthTokenEntity>;
  quickbooksCompanyId?: Maybe<Scalars['String']['output']>;
  quickbooksDesktopAccessorialId?: Maybe<Scalars['String']['output']>;
  quickbooksDesktopAccountsReceivableId?: Maybe<Scalars['String']['output']>;
  quickbooksDesktopCompanyId?: Maybe<Scalars['String']['output']>;
  quickbooksDesktopDeliveryId?: Maybe<Scalars['String']['output']>;
  quickbooksDesktopFuelChargeId?: Maybe<Scalars['String']['output']>;
  quickbooksDesktopLineHaulId?: Maybe<Scalars['String']['output']>;
  quickbooksDesktopOrderChargeId?: Maybe<Scalars['String']['output']>;
  quickbooksDesktopPickupId?: Maybe<Scalars['String']['output']>;
  quickbooksDesktopTransferId?: Maybe<Scalars['String']['output']>;
  quickbooksFileMappingAccessorialChargeName?: Maybe<Scalars['String']['output']>;
  quickbooksFileMappingFreightChargeName?: Maybe<Scalars['String']['output']>;
  quickbooksFileMappingFuelChargeName?: Maybe<Scalars['String']['output']>;
  quickbooksFileMappingPickupChargeName?: Maybe<Scalars['String']['output']>;
  referenceNumberLabels: Array<ReferenceNumberLabelEntity>;
  secondAlternateIsaId?: Maybe<Scalars['String']['output']>;
  secondAlternateScac?: Maybe<Scalars['String']['output']>;
  segment: Segment;
  sendgridSenderId?: Maybe<Scalars['String']['output']>;
  services: Array<ServiceEntity>;
  standardCarrierAlphaCode?: Maybe<Scalars['String']['output']>;
  tags: Array<TagEntity>;
  terminals?: Maybe<Array<TerminalEntity>>;
  thirdAlternateIsaId?: Maybe<Scalars['String']['output']>;
  thirdAlternateScac?: Maybe<Scalars['String']['output']>;
  timeZone: Scalars['String']['output'];
  useSageBusinessWorks: Scalars['Boolean']['output'];
  users: Array<UserEntity>;
  uuid: Scalars['String']['output'];
  warehouses?: Maybe<Array<WarehouseEntity>>;
};

export type CompanyStatsEntity = {
  __typename?: 'CompanyStatsEntity';
  numberOfOrdersDueInFuture: Scalars['Float']['output'];
  numberOfOrdersOneToThirty: Scalars['Float']['output'];
  numberOfOrdersPastNinetyOne: Scalars['Float']['output'];
  numberOfOrdersSixtyOneToNinety: Scalars['Float']['output'];
  numberOfOrdersThirtyOneToSixty: Scalars['Float']['output'];
  numberOfUninvoicedOrdersDueInFuture: Scalars['Float']['output'];
  numberOfUninvoicedOrdersOneToThirty: Scalars['Float']['output'];
  numberOfUninvoicedOrdersPastNinetyOne: Scalars['Float']['output'];
  numberOfUninvoicedOrdersSixtyOneToNinety: Scalars['Float']['output'];
  numberOfUninvoicedOrdersThirtyOneToSixty: Scalars['Float']['output'];
};

export type CompleteRebillInput = {
  newContactUuid: Scalars['String']['input'];
  originalInvoiceUuid: Scalars['String']['input'];
  originalOrderUuid: Scalars['String']['input'];
  rebillOrderUuid: Scalars['String']['input'];
};

export type CompleteRebillOutput = {
  __typename?: 'CompleteRebillOutput';
  invoiceForRebill: InvoiceEntity;
};

export type CompleteStopBulkInput = {
  /** Pass this in to save this at the same time as completing the stop */
  completeStopInputs?: InputMaybe<Array<CompleteStopInput>>;
};

export type CompleteStopEntity = {
  __typename?: 'CompleteStopEntity';
  appointmentCallStatus?: Maybe<AppointmentCallStatus>;
  appointmentManuallyConfirmed?: Maybe<Scalars['Boolean']['output']>;
  appointmentRequired: Scalars['Boolean']['output'];
  appointmentSchedulingOptionsCalledAt?: Maybe<Scalars['DateTime']['output']>;
  appointmentSchedulingOptionsTextedAt?: Maybe<Scalars['DateTime']['output']>;
  appointmentTextStatus?: Maybe<AppointmentTextStatus>;
  appointmentTime?: Maybe<Scalars['DateTime']['output']>;
  arrivedAt?: Maybe<Scalars['DateTime']['output']>;
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  courierReadyOrDueDate?: Maybe<Scalars['DateTime']['output']>;
  createdAt: Scalars['DateTime']['output'];
  deadlineTime?: Maybe<Scalars['DateTime']['output']>;
  destinationAirport?: Maybe<Scalars['String']['output']>;
  driverCompletedAt?: Maybe<Scalars['DateTime']['output']>;
  endAppointmentTime?: Maybe<Scalars['DateTime']['output']>;
  etaArrivalTime?: Maybe<Scalars['DateTime']['output']>;
  etaFinishTime?: Maybe<Scalars['DateTime']['output']>;
  etaLastUpdated?: Maybe<Scalars['DateTime']['output']>;
  expectedInboundArrivalDate?: Maybe<Scalars['DateTime']['output']>;
  expectedOutboundDate?: Maybe<Scalars['DateTime']['output']>;
  failureCount?: Maybe<Scalars['Float']['output']>;
  inboundDeadlineDate?: Maybe<Scalars['DateTime']['output']>;
  inboundMethod?: Maybe<InboundMethod>;
  incomingCarrier?: Maybe<Scalars['String']['output']>;
  lastAppointmentTextTime?: Maybe<Scalars['DateTime']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  outboundCarrier?: Maybe<Scalars['String']['output']>;
  outboundDeadlineDate?: Maybe<Scalars['DateTime']['output']>;
  outboundMethod?: Maybe<OutboundMethod>;
  overrideServiceTimeInMinutes?: Maybe<Scalars['Float']['output']>;
  paperworkMarkedComplete?: Maybe<Scalars['Boolean']['output']>;
  postedAmountUsdCents?: Maybe<Scalars['Int']['output']>;
  proofOfDeliverySignee?: Maybe<Scalars['String']['output']>;
  routeChangeAcknowledged: Scalars['Boolean']['output'];
  serviceDate?: Maybe<Scalars['DateTime']['output']>;
  /** The service date of the stop as a PlainDate. See https://www.notion.so/Service-Date-dc8ae149b6a54bb69404aecf92176287 for details. */
  serviceDateV2?: Maybe<PlainDate>;
  settlementDeductionFlatRate?: Maybe<Scalars['Float']['output']>;
  settlementDeductionName?: Maybe<Scalars['String']['output']>;
  settlementDeductionPercentageRate?: Maybe<Scalars['Float']['output']>;
  showDriverModifiedAt?: Maybe<Scalars['DateTime']['output']>;
  snapshottedAmountUsdCents?: Maybe<Scalars['Int']['output']>;
  specialInstructions?: Maybe<Scalars['String']['output']>;
  standardStopType?: Maybe<StandardStopType>;
  status: StopStatus;
  stopType: StopType;
  textResponses?: Maybe<Scalars['String']['output']>;
  twilioCallSid?: Maybe<Scalars['String']['output']>;
  twilioTextSid?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  uuid: Scalars['String']['output'];
};

export type CompleteStopInput = {
  /** The date the stop was completed */
  completedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** If set to true, forces completion of the associated order regardless of any condition that may prevent that. */
  forceComplete?: InputMaybe<Scalars['Boolean']['input']>;
  isFromWebApp?: InputMaybe<Scalars['Boolean']['input']>;
  /** The name of the person who signed the delivery */
  proofOfDeliverySignee?: InputMaybe<Scalars['String']['input']>;
  sentFromDriverMobileApplication?: InputMaybe<Scalars['Boolean']['input']>;
  /** Pass this in to save this at the same time as completing the stop */
  shipperBillOfLadingNumber?: InputMaybe<Scalars['String']['input']>;
  stopUuid: Scalars['String']['input'];
};

export type CompleteStopInvalidInputException = {
  __typename?: 'CompleteStopInvalidInputException';
  message: Scalars['String']['output'];
};

export type CompleteStopOutput = CompleteStopEntity | CompleteStopInvalidInputException;

export type CompletedAtSortInput = {
  direction: SortOrder;
  nulls: NullsOrder;
};

export type ConsigneePortalOrderEntity = {
  __typename?: 'ConsigneePortalOrderEntity';
  companyTimezone?: Maybe<Scalars['String']['output']>;
  detailedStatus?: Maybe<OrderDetailedStatus>;
  masterAirwayBillOfLadingNumber?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  packages?: Maybe<Array<PackageEntity>>;
  receivedDate?: Maybe<Scalars['DateTime']['output']>;
  shipments: Array<ConsigneePortalShipmentEntity>;
  shipperBillOfLadingNumber?: Maybe<Scalars['String']['output']>;
  status: OrderStatus;
  uuid: Scalars['String']['output'];
};

export type ConsigneePortalShipmentEntity = {
  __typename?: 'ConsigneePortalShipmentEntity';
  address?: Maybe<AddressEntity>;
  addressUuid?: Maybe<Scalars['String']['output']>;
  appointmentTime?: Maybe<Scalars['DateTime']['output']>;
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  completedAtLocal?: Maybe<PlainDateTime>;
  /** If completedAtLocal is set, this field provides the time zone that was used to determine the local date and time. */
  completedAtLocalTimeZone?: Maybe<Scalars['String']['output']>;
  contactPhone?: Maybe<Scalars['String']['output']>;
  deliveryDate?: Maybe<Scalars['DateTime']['output']>;
  driverPlaceInRoute?: Maybe<Scalars['Float']['output']>;
  endAppointmentTime?: Maybe<Scalars['DateTime']['output']>;
  outboundMethod?: Maybe<OutboundMethod>;
  /** @deprecated Use stopType instead */
  pickupOrDelivery?: Maybe<PickupOrDelivery>;
  placeInRoute?: Maybe<Scalars['Float']['output']>;
  proofOfDeliverySignee?: Maybe<Scalars['String']['output']>;
  routeIsToday?: Maybe<Scalars['Boolean']['output']>;
  status?: Maybe<StopStatus>;
  stopType?: Maybe<StopType>;
  uuid: Scalars['String']['output'];
};

export type ConsolidatableOrdersOutput = {
  __typename?: 'ConsolidatableOrdersOutput';
  error?: Maybe<FindConsolidatableOrdersError>;
  orders: Array<OrderEntity>;
  /** Only returned for orders with multiple addresses (more than one pickup/delivery) */
  shipments?: Maybe<Array<ShipmentEntity>>;
};

export type ConsolidatedOrderCreateInput = {
  shipmentUuid: Scalars['String']['input'];
};

export type ContactAccessorialChargeDetailsEntity = {
  __typename?: 'ContactAccessorialChargeDetailsEntity';
  contactReferenceNumber?: Maybe<Scalars['String']['output']>;
  contactUuid: Scalars['String']['output'];
  displayName: Scalars['String']['output'];
  shipmentsWithAccessorialCount: Scalars['Float']['output'];
  totalAccessorialCharge: Scalars['Float']['output'];
};

export type ContactAndServicesCombination = {
  contactUuid: Scalars['String']['input'];
  serviceUuids: Array<Scalars['String']['input']>;
};

export type ContactCommentEntity = {
  __typename?: 'ContactCommentEntity';
  authorName: Scalars['String']['output'];
  comment: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  updatedAt: Scalars['DateTime']['output'];
  uuid: Scalars['String']['output'];
};

export type ContactCommunicationConfigCreateInput = {
  active: Scalars['Boolean']['input'];
  contactUuid: Scalars['String']['input'];
  sendAtHours: Scalars['Int']['input'];
  sendAtMinutes: Scalars['Int']['input'];
  type: ContactCommunicationType;
};

export type ContactCommunicationConfigEntity = {
  __typename?: 'ContactCommunicationConfigEntity';
  active: Scalars['Boolean']['output'];
  createdAt: Scalars['DateTime']['output'];
  sendAtHours: Scalars['Int']['output'];
  sendAtMinutes: Scalars['Int']['output'];
  type: ContactCommunicationType;
  updatedAt: Scalars['DateTime']['output'];
  uuid: Scalars['String']['output'];
};

export type ContactCommunicationConfigUpdateInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  contactUuid?: InputMaybe<Scalars['String']['input']>;
  sendAtHours?: InputMaybe<Scalars['Int']['input']>;
  sendAtMinutes?: InputMaybe<Scalars['Int']['input']>;
  type?: InputMaybe<ContactCommunicationType>;
  uuid: Scalars['String']['input'];
};

export enum ContactCommunicationType {
  DailyOrdersCompleted = 'DAILY_ORDERS_COMPLETED',
  DailyOrdersNotOnHand = 'DAILY_ORDERS_NOT_ON_HAND',
  DailyOrdersOnHand = 'DAILY_ORDERS_ON_HAND',
  DailyOrdersScheduled = 'DAILY_ORDERS_SCHEDULED',
  PerAppointmentDateChanged = 'PER_APPOINTMENT_DATE_CHANGED',
  PerOrderCompleted = 'PER_ORDER_COMPLETED',
  PerOrderDriverOnSite = 'PER_ORDER_DRIVER_ON_SITE',
  PerOrderOutForDelivery = 'PER_ORDER_OUT_FOR_DELIVERY',
  PerOrderScheduled = 'PER_ORDER_SCHEDULED'
}

export type ContactConnection = {
  __typename?: 'ContactConnection';
  edges: Array<ContactEdge>;
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type ContactEdge = {
  __typename?: 'ContactEdge';
  cursor: Scalars['String']['output'];
  node: ContactEntity;
};

export type ContactEmailCreateInput = {
  contactUuid: Scalars['String']['input'];
  email: Scalars['String']['input'];
  type: ContactEmailType;
};

export type ContactEmailEntity = {
  __typename?: 'ContactEmailEntity';
  createdAt: Scalars['DateTime']['output'];
  email: Scalars['String']['output'];
  type: ContactEmailType;
  updatedAt: Scalars['DateTime']['output'];
  uuid: Scalars['String']['output'];
};

export enum ContactEmailType {
  Invoice = 'INVOICE',
  OrderUpdate = 'ORDER_UPDATE'
}

export type ContactEntity = {
  addresses: Array<AddressEntity>;
  apiName?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use getAverageDaysToPayReport in ReportsService instead */
  averageDaysToPay90: Scalars['Float']['output'];
  /** @deprecated Use getAverageDaysToPayReport in ReportsService instead */
  averageDaysToPay180: Scalars['Float']['output'];
  /** @deprecated Use getAverageDaysToPayReport in ReportsService instead */
  averageDaysToPay270: Scalars['Float']['output'];
  /** @deprecated Use getAverageDaysToPayReport in ReportsService instead */
  averageDaysToPay360: Scalars['Float']['output'];
  /** @deprecated Use getAverageDaysToPayReport in ReportsService instead */
  averageDaysToPay720: Scalars['Float']['output'];
  /** @deprecated Use getAverageDaysToPayReport in ReportsService instead */
  averageDaysToPayAll: Scalars['Float']['output'];
  /** The customer balance for the contact in dollars */
  balance: Scalars['Float']['output'];
  billingContactEmail?: Maybe<Scalars['String']['output']>;
  billingCycle?: Maybe<BillingCycleType>;
  billingCycleDuration: BillingCycleDuration;
  billingPeriod?: Maybe<Scalars['Float']['output']>;
  billingPeriodDates?: Maybe<Array<Scalars['DateTime']['output']>>;
  billingRunStart: Scalars['DateTime']['output'];
  businessDivision?: Maybe<BusinessDivisionEntity>;
  company: CompanyEntity;
  contactComments: Array<ContactCommentEntity>;
  contactOpenInvoiceValue: Scalars['Float']['output'];
  contactOpenInvoiceValue0to30d: Scalars['Float']['output'];
  contactOpenInvoiceValue31to38d: Scalars['Float']['output'];
  contactOpenInvoiceValue39to45d: Scalars['Float']['output'];
  contactOpenInvoiceValue46to60d: Scalars['Float']['output'];
  contactOpenInvoiceValue61to75d: Scalars['Float']['output'];
  contactOpenInvoiceValueOver75d: Scalars['Float']['output'];
  contactPersons: Array<ContactPersonEntity>;
  contactReferenceNumber?: Maybe<Scalars['String']['output']>;
  contactStations: Array<ContactStationEntity>;
  contactStatistics: ContactStatsEntity;
  creditsAppliedToContactInvoices: Scalars['Float']['output'];
  customerTariffs: Array<TariffEntity>;
  debitsAppliedToContactInvoices: Scalars['Float']['output'];
  defaultAddress?: Maybe<AddressEntity>;
  defaultContactPerson?: Maybe<ContactPersonEntity>;
  defaultEfmHandlingStation?: Maybe<Scalars['String']['output']>;
  defaultInvoiceTerms?: Maybe<InvoiceTermEntity>;
  defaultService?: Maybe<ServiceEntity>;
  defaultServicePickupsDeliveries: Scalars['Boolean']['output'];
  dimFactor: Scalars['Int']['output'];
  displayName: Scalars['String']['output'];
  ediApplicationId?: Maybe<Scalars['String']['output']>;
  ediContactCode?: Maybe<Scalars['String']['output']>;
  ediPartnership?: Maybe<EdiPartnershipEntity>;
  ediPartnerships: Array<EdiPartnershipEntity>;
  freightChargeQuickbooksMappingId?: Maybe<Scalars['String']['output']>;
  fuelChargeQuickbooksMappingId?: Maybe<Scalars['String']['output']>;
  identifier?: Maybe<Scalars['String']['output']>;
  invoiceNotes?: Maybe<Scalars['String']['output']>;
  invoicePdfColumns: Array<PdfColumnEntity>;
  invoiceTimePeriodSplit?: Maybe<TimePeriod>;
  isActive: Scalars['Boolean']['output'];
  isEfm?: Maybe<Scalars['Boolean']['output']>;
  isOverCreditLimit: Scalars['Boolean']['output'];
  isPrepaidOnly: Scalars['Boolean']['output'];
  isaId?: Maybe<Scalars['String']['output']>;
  logo?: Maybe<DocumentEntity>;
  logoType?: Maybe<DocumentEntity>;
  masterAccount?: Maybe<MasterAccountEntity>;
  miscCustomChargeQuickbooksMappingId?: Maybe<Scalars['String']['output']>;
  numberOfOrdersPerInvoice?: Maybe<Scalars['Float']['output']>;
  orders: Array<OrderEntity>;
  overdueInvoices: Array<InvoiceEntity>;
  paymentsAppliedToContactInvoices: Scalars['Float']['output'];
  /** Total closed balance across all posted invoices */
  postedInvoicesTotalClosedBalance: Scalars['Float']['output'];
  /** Total open balance across all posted invoices */
  postedInvoicesTotalOpenBalance: Scalars['Float']['output'];
  quickbooksDesktopAccountsReceivableId?: Maybe<Scalars['String']['output']>;
  quickbooksDesktopContactId?: Maybe<Scalars['String']['output']>;
  quickbooksFileMappingCustomerName?: Maybe<Scalars['String']['output']>;
  quickbooksFileMappingFreightChargeName?: Maybe<Scalars['String']['output']>;
  quickbooksFileMappingFuelChargeName?: Maybe<Scalars['String']['output']>;
  quickbooksFileMappingPickupChargeName?: Maybe<Scalars['String']['output']>;
  quickbooksMappingId?: Maybe<Scalars['String']['output']>;
  referenceNumberLabels: Array<ReferenceNumberLabelEntity>;
  requireDriverToCheckOffPackagesAtStop: Scalars['Boolean']['output'];
  services: Array<ServiceEntity>;
  shortCode?: Maybe<Scalars['String']['output']>;
  showChargesOnCustomerPortal: Scalars['Boolean']['output'];
  showEdiReferenceNumbersOnOrderPage: Scalars['Boolean']['output'];
  skipFuelCharge?: Maybe<Scalars['Boolean']['output']>;
  standardCarrierAlphaCode?: Maybe<Scalars['String']['output']>;
  stediPartnerId?: Maybe<Scalars['String']['output']>;
  tariffZones: Array<TariffZoneEntity>;
  /** @deprecated placeholder since the column was dropped from the table */
  thirdPartyContactType?: Maybe<ThirdPartyContactType>;
  totalCredits: Scalars['Float']['output'];
  totalDebits: Scalars['Float']['output'];
  totalInvoicesAmount: Scalars['Float']['output'];
  totalPayments: Scalars['Float']['output'];
  totalPostedInvoicesAmount: Scalars['Float']['output'];
  /** @deprecated Contact type is deprecated. The column has been dropped from the db */
  type: ContactType;
  unappliedCredits?: Maybe<Scalars['Float']['output']>;
  unappliedDebits: Scalars['Float']['output'];
  unappliedPayments: Scalars['Float']['output'];
  uuid: Scalars['String']['output'];
};


export type ContactEntityContactOpenInvoiceValueArgs = {
  findOpenInvoicesArgs?: InputMaybe<FindOpenInvoicesArgs>;
};


export type ContactEntityContactOpenInvoiceValue0to30dArgs = {
  findOpenInvoicesArgs?: InputMaybe<FindOpenInvoicesArgs>;
};


export type ContactEntityContactOpenInvoiceValue31to38dArgs = {
  findOpenInvoicesArgs?: InputMaybe<FindOpenInvoicesArgs>;
};


export type ContactEntityContactOpenInvoiceValue39to45dArgs = {
  findOpenInvoicesArgs?: InputMaybe<FindOpenInvoicesArgs>;
};


export type ContactEntityContactOpenInvoiceValue46to60dArgs = {
  findOpenInvoicesArgs?: InputMaybe<FindOpenInvoicesArgs>;
};


export type ContactEntityContactOpenInvoiceValue61to75dArgs = {
  findOpenInvoicesArgs?: InputMaybe<FindOpenInvoicesArgs>;
};


export type ContactEntityContactOpenInvoiceValueOver75dArgs = {
  findOpenInvoicesArgs?: InputMaybe<FindOpenInvoicesArgs>;
};

export type ContactForContactReport = {
  __typename?: 'ContactForContactReport';
  active: Scalars['Boolean']['output'];
  addressLine1?: Maybe<Scalars['String']['output']>;
  addressLine2?: Maybe<Scalars['String']['output']>;
  addressName?: Maybe<Scalars['String']['output']>;
  billingCycle?: Maybe<Scalars['String']['output']>;
  businessDivision?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  creditLimit?: Maybe<Scalars['Float']['output']>;
  defaultInvoiceTransmissionMethod?: Maybe<Scalars['String']['output']>;
  defaultInvoiceType: Scalars['String']['output'];
  email?: Maybe<Scalars['String']['output']>;
  enableCreditHold: Scalars['Boolean']['output'];
  invoiceTimePeriodSplit?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  numberOfOrdersPerInvoice?: Maybe<Scalars['Float']['output']>;
  referenceNumber?: Maybe<Scalars['String']['output']>;
  shortcode?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  type: Scalars['String']['output'];
  zipcode?: Maybe<Scalars['String']['output']>;
};

export type ContactPersonCreateInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
};

export type ContactPersonEntity = {
  __typename?: 'ContactPersonEntity';
  createdAt: Scalars['DateTime']['output'];
  email?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  uuid: Scalars['String']['output'];
};

export type ContactPersonUpdateInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  uuid: Scalars['String']['input'];
};

export type ContactPersonUpsertInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  uuid: Scalars['String']['input'];
};

export type ContactStationCreateInput = {
  contactUuid: Scalars['String']['input'];
  isArchived: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
};

export type ContactStationCreateOutput = ContactStationCreateSuccessOutput | MutationErrorOutput;

export type ContactStationCreateSuccessOutput = {
  __typename?: 'ContactStationCreateSuccessOutput';
  contactStation: ContactStationEntity;
};

export type ContactStationEntity = {
  __typename?: 'ContactStationEntity';
  defaultPerson?: Maybe<PersonEntity>;
  id: Scalars['String']['output'];
  isArchived: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
};

export type ContactStationUpdateInput = {
  contactUuid?: InputMaybe<Scalars['String']['input']>;
  defaultPersonId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  isArchived?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
};

export type ContactStationUpdateOutput = ContactStationUpdateSuccessOutput | MutationErrorOutput;

export type ContactStationUpdateSuccessOutput = {
  __typename?: 'ContactStationUpdateSuccessOutput';
  contactStation: ContactStationEntity;
};

export type ContactStatsEntity = {
  __typename?: 'ContactStatsEntity';
  numberOfFinalizedOrders: Scalars['Float']['output'];
  numberOfOrdersWithIssues: Scalars['Float']['output'];
  numberOfTotalOrders?: Maybe<Scalars['Float']['output']>;
  numberOfUnfinalizedOrders: Scalars['Float']['output'];
};

export type ContactToServicesTariffGroupMappingEntity = {
  __typename?: 'ContactToServicesTariffGroupMappingEntity';
  contact: ContactEntity;
  services: Array<ServiceEntity>;
  uuid: Scalars['String']['output'];
};

export enum ContactType {
  Customer = 'CUSTOMER',
  ThirdParty = 'THIRD_PARTY'
}

export type CoordinatesForAddressEntity = {
  __typename?: 'CoordinatesForAddressEntity';
  latitude?: Maybe<Scalars['Float']['output']>;
  longitude?: Maybe<Scalars['Float']['output']>;
};

export type CoverSheetDocumentTypeSequenceCreateInput = {
  documentTypes: Array<DocumentType>;
  name: Scalars['String']['input'];
  orderUuids?: InputMaybe<Array<Scalars['String']['input']>>;
  type: CoverSheetDocumentTypeSequenceType;
};

export type CoverSheetDocumentTypeSequenceEntity = {
  __typename?: 'CoverSheetDocumentTypeSequenceEntity';
  documentTypes: Array<DocumentType>;
  name: Scalars['String']['output'];
  type: CoverSheetDocumentTypeSequenceType;
  uuid: Scalars['String']['output'];
};

export enum CoverSheetDocumentTypeSequenceType {
  Record = 'RECORD',
  Template = 'TEMPLATE'
}

export type CoverSheetDocumentTypeSequenceUpdateInput = {
  documentTypes?: InputMaybe<Array<DocumentType>>;
  name?: InputMaybe<Scalars['String']['input']>;
  orderUuids?: InputMaybe<Array<Scalars['String']['input']>>;
  type?: InputMaybe<CoverSheetDocumentTypeSequenceType>;
  uuid: Scalars['String']['input'];
};

export type CreateAccessorialContactInput = {
  accessorialUuid: Scalars['String']['input'];
  contactUuid: Scalars['String']['input'];
};

export type CreateAccessorialContactOutput = {
  __typename?: 'CreateAccessorialContactOutput';
  success: Scalars['Boolean']['output'];
};

export type CreateAccessorialDateRangeConfigInput = {
  accessorialDateRangeConfigToCopyUuid?: InputMaybe<Scalars['String']['input']>;
  accessorialRangeCreateInputs?: InputMaybe<Array<AccessorialRangeCreateInput>>;
  accessorialUuid: Scalars['String']['input'];
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  fuelProfileUuid?: InputMaybe<Scalars['String']['input']>;
  fuelSurchargePercentageRate?: InputMaybe<Scalars['Float']['input']>;
  percentForSettlement?: InputMaybe<Scalars['Float']['input']>;
  /** Accepts rate as a $ float with two decimal places */
  rateUsd?: InputMaybe<Scalars['Float']['input']>;
  specialChargeGroupCreateInputs?: InputMaybe<Array<SpecialAccessorialChargeGroupCreateInput>>;
  specialMatrixItemsCreateInputs?: InputMaybe<Array<SpecialAccessorialMatrixItemCreateInput>>;
  startDate: Scalars['DateTime']['input'];
};

export type CreateAccessorialDateRangeConfigOutput = {
  __typename?: 'CreateAccessorialDateRangeConfigOutput';
  success: Scalars['Boolean']['output'];
};

export type CreateAccessorialInput = {
  accessorialCreateInput: AccessorialCreateInput;
};

export type CreateAccountingReportDocumentOutput = {
  __typename?: 'CreateAccountingReportDocumentOutput';
  document: DocumentEntity;
};

export type CreateAddressInput = {
  addressCreateInput: AddressCreateInput;
  contactUuid?: InputMaybe<Scalars['String']['input']>;
};

export type CreateAirportInfoInput = {
  addressUpsertInput?: InputMaybe<AddressUpsertInput>;
  addressUuid?: InputMaybe<Scalars['String']['input']>;
  companyUuid: Scalars['String']['input'];
  iataCode: Scalars['String']['input'];
  terminal: Scalars['String']['input'];
};

export type CreateApiUserInput = {
  apiUserCreateInput: ApiUserCreateInput;
};

export type CreateAutoApplyAccessorialConfigInput = {
  accessorialUuid?: InputMaybe<Scalars['String']['input']>;
  accessorialUuids?: InputMaybe<Array<Scalars['String']['input']>>;
  contactUuid?: InputMaybe<Scalars['String']['input']>;
  contactsToExcludeUuids?: InputMaybe<Array<Scalars['String']['input']>>;
  contactsToIncludeUuids?: InputMaybe<Array<Scalars['String']['input']>>;
  ruleType: AutoApplyAccessorialRuleType;
  serviceUuid?: InputMaybe<Scalars['String']['input']>;
  stopType?: InputMaybe<PickupOrDelivery>;
  tagUuid?: InputMaybe<Scalars['String']['input']>;
  terminalUuid?: InputMaybe<Scalars['String']['input']>;
};

export type CreateBasicDocumentInput = {
  companyUuid: Scalars['String']['input'];
  documentType: DocumentType;
  fileName: Scalars['String']['input'];
  fileType: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  region?: InputMaybe<Scalars['String']['input']>;
  thumbnail?: InputMaybe<Scalars['String']['input']>;
};

export type CreateBusinessDivisionInput = {
  name: Scalars['String']['input'];
};

export type CreateBusinessDivisionOutput = {
  __typename?: 'CreateBusinessDivisionOutput';
  success: Scalars['Boolean']['output'];
};

export type CreateCompanyInput = {
  alternateIsaId?: InputMaybe<Scalars['String']['input']>;
  alternateStandardCarrierAlphaCode?: InputMaybe<Scalars['String']['input']>;
  apiName?: InputMaybe<Scalars['String']['input']>;
  blockSendingZeroDollarInvoices?: InputMaybe<Scalars['Boolean']['input']>;
  companyLandscapeLogoUrl?: InputMaybe<Scalars['String']['input']>;
  companySquareLogoUrl?: InputMaybe<Scalars['String']['input']>;
  /** A JSON object that represents the set of configurations for the company */
  configs?: InputMaybe<Scalars['String']['input']>;
  customDunningReportFooter?: InputMaybe<Scalars['String']['input']>;
  customDunningReportHeader?: InputMaybe<Scalars['String']['input']>;
  defaultAddressCreateInput: AddressCreateInput;
  defaultInvoiceEmailSubject?: InputMaybe<Scalars['String']['input']>;
  defaultLineHaulSettlementTariffChainId?: InputMaybe<Scalars['String']['input']>;
  defaultLineHaulTariffChainId?: InputMaybe<Scalars['String']['input']>;
  defaultMeasurementUnits: MeasurementUnits;
  defaultNonCompanyDriverSettlementMode: SettlementMode;
  defaultOrdinarySettlementTariffChainId?: InputMaybe<Scalars['String']['input']>;
  defaultOrdinaryTariffChainId?: InputMaybe<Scalars['String']['input']>;
  defaultPointToPointSettlementTariffChainId?: InputMaybe<Scalars['String']['input']>;
  defaultPointToPointTariffChainId?: InputMaybe<Scalars['String']['input']>;
  defaultTransferSettlementTariffChainId?: InputMaybe<Scalars['String']['input']>;
  defaultTransferTariffChainId?: InputMaybe<Scalars['String']['input']>;
  defaultWeightUnits: WeightUnits;
  ediPodFilenamePrefix?: InputMaybe<Scalars['String']['input']>;
  fourthAlternateIsaId?: InputMaybe<Scalars['String']['input']>;
  fourthAlternateScac?: InputMaybe<Scalars['String']['input']>;
  freightChargeQuickbooksMappingId?: InputMaybe<Scalars['String']['input']>;
  freightSnapId?: InputMaybe<Scalars['String']['input']>;
  fuelChargeQuickbooksMappingId?: InputMaybe<Scalars['String']['input']>;
  invoiceEmail?: InputMaybe<Scalars['String']['input']>;
  isCourier?: InputMaybe<Scalars['Boolean']['input']>;
  isaId?: InputMaybe<Scalars['String']['input']>;
  miscCustomChargeQuickbooksMappingId?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  orderNameOrdinal?: InputMaybe<Scalars['Int']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  purchasedProductOfferings?: InputMaybe<Array<PalletProductOffering>>;
  qbInvoiceNumberStart?: InputMaybe<Scalars['Float']['input']>;
  quickbooksCompanyId?: InputMaybe<Scalars['String']['input']>;
  quickbooksDesktopAccessorialId?: InputMaybe<Scalars['String']['input']>;
  quickbooksDesktopAccountsReceivableId?: InputMaybe<Scalars['String']['input']>;
  quickbooksDesktopCompanyId?: InputMaybe<Scalars['String']['input']>;
  quickbooksDesktopDeliveryId?: InputMaybe<Scalars['String']['input']>;
  quickbooksDesktopFuelChargeId?: InputMaybe<Scalars['String']['input']>;
  quickbooksDesktopLineHaulId?: InputMaybe<Scalars['String']['input']>;
  quickbooksDesktopOrderChargeId?: InputMaybe<Scalars['String']['input']>;
  quickbooksDesktopPickupId?: InputMaybe<Scalars['String']['input']>;
  quickbooksDesktopTransferId?: InputMaybe<Scalars['String']['input']>;
  quickbooksFileMappingAccessorialChargeName?: InputMaybe<Scalars['String']['input']>;
  quickbooksFileMappingFreightChargeName?: InputMaybe<Scalars['String']['input']>;
  quickbooksFileMappingFuelChargeName?: InputMaybe<Scalars['String']['input']>;
  quickbooksFileMappingPickupChargeName?: InputMaybe<Scalars['String']['input']>;
  secondAlternateIsaId?: InputMaybe<Scalars['String']['input']>;
  secondAlternateScac?: InputMaybe<Scalars['String']['input']>;
  segment: Segment;
  sendgridSenderId?: InputMaybe<Scalars['String']['input']>;
  standardCarrierAlphaCode?: InputMaybe<Scalars['String']['input']>;
  stediPartnerId?: InputMaybe<Scalars['String']['input']>;
  thirdAlternateIsaId?: InputMaybe<Scalars['String']['input']>;
  thirdAlternateScac?: InputMaybe<Scalars['String']['input']>;
  timeZone: Scalars['String']['input'];
  useSageBusinessWorks?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CreateConsolidatedOrderFromOrderInput = {
  orderUuid: Scalars['String']['input'];
};

export type CreateConsolidatedOrderInput = {
  consolidatedOrderCreateInput: ConsolidatedOrderCreateInput;
};

export type CreateContactCommentInput = {
  comment: Scalars['String']['input'];
  contactUuid: Scalars['String']['input'];
  userUuid: Scalars['String']['input'];
};

export type CreateContactCommunicationConfigInput = {
  contactCommunicationConfigCreateInput: ContactCommunicationConfigCreateInput;
};

export type CreateContactDocumentInput = {
  contactUuid: Scalars['String']['input'];
  documentType: DocumentType;
  fileName: Scalars['String']['input'];
  fileType: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  region?: InputMaybe<Scalars['String']['input']>;
};

export type CreateContactEmailInput = {
  contactEmailCreateInput: ContactEmailCreateInput;
};

export type CreateContactPersonInput = {
  contactPersonCreateInput: ContactPersonCreateInput;
  contactUuid: Scalars['String']['input'];
  stopUuid?: InputMaybe<Scalars['String']['input']>;
};

export type CreateContactToServicesMappingInput = {
  contactUuid: Scalars['String']['input'];
  serviceUuids: Array<Scalars['String']['input']>;
};

export type CreateCsvOrderFieldMappingInput = {
  csvOrderMappingUuid: Scalars['String']['input'];
  sourceColumnName: Scalars['String']['input'];
  targetFieldType: CsvOrderMappingTargetFieldType;
};

export type CreateCsvOrderImportTransactionInput = {
  bucket: Scalars['String']['input'];
  fileName: Scalars['String']['input'];
  key: Scalars['String']['input'];
  message?: InputMaybe<Scalars['String']['input']>;
  orderUuid?: InputMaybe<Scalars['String']['input']>;
  region: Scalars['String']['input'];
  /** The raw, comma-separated string contents of the CSV row */
  row: Scalars['String']['input'];
  rowNumber: Scalars['Int']['input'];
  status: CsvOrderImportTransactionStatus;
};

export type CreateCsvOrderMappingInput = {
  companyUuid: Scalars['String']['input'];
  contactUuid?: InputMaybe<Scalars['String']['input']>;
  csvOrderFieldMappingCreateInputs?: InputMaybe<Array<CreateCsvOrderFieldMappingInput>>;
  deadlineDateDefaultValue?: InputMaybe<Scalars['DateTime']['input']>;
  deadlineTypeDefaultValue?: InputMaybe<DeadlineType>;
  enableDynamicInboundOrOutboundStop: Scalars['Boolean']['input'];
  enableInboundStop: Scalars['Boolean']['input'];
  enableOutboundStop: Scalars['Boolean']['input'];
  freightBillingMethodDefaultValue?: InputMaybe<FreightBillingMethod>;
  name: Scalars['String']['input'];
  pickupOrDeliveryDefaultValue?: InputMaybe<PickupOrDelivery>;
  serviceUuid?: InputMaybe<Scalars['String']['input']>;
  stopImportType: StopImportType;
  stopTypeDefaultValue?: InputMaybe<StandardStopType>;
};

export type CreateCsvOrdersOrderInput = {
  billingPartyContactUuid: Scalars['String']['input'];
  dimFactor?: InputMaybe<Scalars['Int']['input']>;
  freightChargeRate?: InputMaybe<Scalars['Float']['input']>;
  freightChargeType?: InputMaybe<FreightBillingMethod>;
  fuelChargeType?: InputMaybe<FuelBillingMethod>;
  fuelSurcharge?: InputMaybe<Scalars['Float']['input']>;
  inboundStop?: InputMaybe<ParsedCsvOrderStopInput>;
  masterAirwayBillOfLadingNumber?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  outboundStop?: InputMaybe<ParsedCsvOrderStopInput>;
  packages: Array<CreateCsvOrdersPackageInput>;
  referenceNumber?: InputMaybe<Scalars['String']['input']>;
  serviceUuid?: InputMaybe<Scalars['String']['input']>;
  shipperBillOfLadingNumber?: InputMaybe<Scalars['String']['input']>;
};

/** A package that is either parsed from a CSV file or from an order part of an order that was detected in a parsed CSV file */
export type CreateCsvOrdersPackageInput = {
  description: Scalars['String']['input'];
  height?: InputMaybe<Scalars['Float']['input']>;
  /** A flag that is set to true if the parsed package is one that needs to be appended to the order packages */
  isNew?: InputMaybe<Scalars['Boolean']['input']>;
  length?: InputMaybe<Scalars['Float']['input']>;
  packageSpecId?: InputMaybe<Scalars['String']['input']>;
  quantity: Scalars['Int']['input'];
  type?: InputMaybe<PackageType>;
  uuid?: InputMaybe<Scalars['String']['input']>;
  weight?: InputMaybe<Scalars['Float']['input']>;
  width?: InputMaybe<Scalars['Float']['input']>;
};

export type CreateCustomerContactInput = {
  customerContactCreateInput: CustomerContactCreateInput;
};

export type CreateCustomerContactsInput = {
  customerContactCreateInputs: Array<CustomerContactCreateInput>;
};

export type CreateCustomerContactsOutput = {
  __typename?: 'CreateCustomerContactsOutput';
  customerContacts: Array<CustomerContactEntity>;
};

export type CreateDocumentInput = {
  documentCreateInput: DocumentCreateInput;
};

export type CreateDriverInput = {
  driverCreateInput: DriverCreateInput;
};

export type CreateDriverSettlementBillInput = {
  driverSettlementBillCreateInput: DriverSettlementBillCreateInput;
};

export type CreateDriverSignableFormTemplateInput = {
  formText: Scalars['String']['input'];
  title: Scalars['String']['input'];
};

export type CreateDriversInput = {
  driverCreateInputs: Array<DriverCreateInput>;
};

export type CreateDriversOutput = {
  __typename?: 'CreateDriversOutput';
  drivers: Array<DriverEntity>;
};

export type CreateDuplicateOrderForRebillInput = {
  newContactUuid: Scalars['String']['input'];
  originalOrderUuid: Scalars['String']['input'];
};

export type CreateDuplicateOrderForRebillOutput = {
  __typename?: 'CreateDuplicateOrderForRebillOutput';
  duplicatedOrder: OrderEntity;
};

export type CreateEdiPartnershipInput = {
  allowEditingShipperBillOfLadingNumber?: InputMaybe<Scalars['Boolean']['input']>;
  alternateStediPartnerId?: InputMaybe<Scalars['String']['input']>;
  autoAcceptOrders?: InputMaybe<Scalars['Boolean']['input']>;
  canCreateMultipleStops?: InputMaybe<Scalars['Boolean']['input']>;
  companyStandardCarrierAlphaCode?: InputMaybe<Scalars['String']['input']>;
  companyUuid: Scalars['String']['input'];
  contactUuid: Scalars['String']['input'];
  edi214ShipmentStatuses?: InputMaybe<Array<Edi214ShipmentStatus>>;
  ediOutboundPayloadDestination?: InputMaybe<EdiOutboundPayloadDestination>;
  enableStaging?: InputMaybe<Scalars['Boolean']['input']>;
  excludeZeroChargeInvoices?: InputMaybe<Scalars['Boolean']['input']>;
  ignoreCancellations?: InputMaybe<Scalars['Boolean']['input']>;
  ignoreNonEdiOutbound?: InputMaybe<Scalars['Boolean']['input']>;
  includeItemizedChargesIn210?: InputMaybe<Scalars['Boolean']['input']>;
  includeOutboundFilenameReceiverIsaId?: InputMaybe<Scalars['Boolean']['input']>;
  mergeLineHaul?: InputMaybe<Scalars['Boolean']['input']>;
  outboundFilenameScacPrefix?: InputMaybe<Scalars['Boolean']['input']>;
  removeSpacesFrom214Bol?: InputMaybe<Scalars['Boolean']['input']>;
  requireGenerateEdi210Ids?: InputMaybe<Scalars['Boolean']['input']>;
  send990InResponseTo204?: InputMaybe<Scalars['Boolean']['input']>;
  send990InResponseTo211?: InputMaybe<Scalars['Boolean']['input']>;
  sendBackupDocs?: InputMaybe<Scalars['Boolean']['input']>;
  stedi210MappingId?: InputMaybe<Scalars['String']['input']>;
  stedi210TransactionSettingId?: InputMaybe<Scalars['String']['input']>;
  stedi214MappingId?: InputMaybe<Scalars['String']['input']>;
  stedi214TransactionSettingId?: InputMaybe<Scalars['String']['input']>;
  stedi990MappingId?: InputMaybe<Scalars['String']['input']>;
  stedi990TransactionSettingId?: InputMaybe<Scalars['String']['input']>;
  stediPartnershipId?: InputMaybe<Scalars['String']['input']>;
  tiffPodUpload?: InputMaybe<Scalars['Boolean']['input']>;
  timeOfPodUpload?: InputMaybe<TimeOfPodUpload>;
  useStediGenerateEdiFunction?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CreateEdiPartnershipServiceMappingsInput = {
  ediPartnershipServiceMappingCreateInputs: Array<EdiPartnershipServiceMappingCreateInput>;
  ediPartnershipUuid: Scalars['String']['input'];
};

export type CreateEdiPartnershipServiceMappingsOutput = {
  __typename?: 'CreateEdiPartnershipServiceMappingsOutput';
  ediPartnershipServiceMappings: Array<EdiPartnershipServiceMappingEntity>;
};

export type CreateEdiTransactionInput = {
  code: EdiTransactionCode;
  edi210NetAmountDueCents?: InputMaybe<Scalars['Int']['input']>;
  edi214ShipmentStatus?: InputMaybe<Edi214ShipmentStatus>;
  edi990ActionCode?: InputMaybe<Edi990ActionCode>;
  ediPayloadId?: InputMaybe<Scalars['String']['input']>;
  hawb?: InputMaybe<Scalars['String']['input']>;
  ignoreInAudit?: InputMaybe<Scalars['Boolean']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  orderUuid?: InputMaybe<Scalars['String']['input']>;
  payload: Scalars['String']['input'];
  purposeCode?: InputMaybe<EdiTransactionPurposeCode>;
  receiverIsaId: Scalars['String']['input'];
  senderIsaId: Scalars['String']['input'];
};

export type CreateEdiTransactionOutput = {
  __typename?: 'CreateEdiTransactionOutput';
  ediTransaction: EdiTransactionEntity;
};

export type CreateEmailTransactionInput = {
  contactUuid: Scalars['String']['input'];
  documentUuid: Scalars['String']['input'];
  emailResponse?: InputMaybe<Scalars['String']['input']>;
  emailResponseStatus?: InputMaybe<Scalars['Int']['input']>;
  emails: Array<Scalars['String']['input']>;
  failureReason?: InputMaybe<Scalars['String']['input']>;
  invoiceUuid?: InputMaybe<Scalars['String']['input']>;
  sendgridMessageId?: InputMaybe<Scalars['String']['input']>;
};

export type CreateEmailTransactionOutput = {
  __typename?: 'CreateEmailTransactionOutput';
  success: Scalars['Boolean']['output'];
};

export type CreateEndOfDayDocumentProcessingJobInput = {
  companyUuid: Scalars['String']['input'];
  dateUploadedFor: Scalars['DateTime']['input'];
  status: EndOfDayDocumentsProcessingJobStatus;
  terminalUuid?: InputMaybe<Scalars['String']['input']>;
  uploadedFileName: Scalars['String']['input'];
};

export type CreateEodDocumentsInput = {
  /** A flag that determines whether the EOD documents should be automatched to the orders */
  autoMatchingEnabled: Scalars['Boolean']['input'];
  documentCreateInputs: Array<EodDocumentCreateInput>;
  /** The UUID of the job associated with the original EOD document that was uploaded. */
  endOfDayDocumentsProcessingJobUuid: Scalars['String']['input'];
};

export type CreateEquipmentInput = {
  /** Contains equipment details */
  equipmentCreateInput: EquipmentCreateInput;
};

export type CreateEquipmentLicenseInput = {
  equipmentLicenseCreateInput: EquipmentLicenseCreateInput;
  /** UUID of the equipment this license will be associated with */
  equipmentUuid: Scalars['String']['input'];
};

export type CreateEquipmentsInput = {
  equipmentCreateInputs: Array<EquipmentCreateInput>;
};

export type CreateEquipmentsOutput = {
  __typename?: 'CreateEquipmentsOutput';
  equipments: Array<EquipmentEntity>;
};

export type CreateFeatureFlagCompanyOverrideInput = {
  active: Scalars['Boolean']['input'];
  companyUuid: Scalars['String']['input'];
  featureFlagUuid: Scalars['String']['input'];
};

export type CreateFeatureFlagInput = {
  featureFlagCreateInput: FeatureFlagCreateInput;
};

export type CreateFeatureFlagUserOverrideInput = {
  active: Scalars['Boolean']['input'];
  email: Scalars['String']['input'];
  featureFlagUuid: Scalars['String']['input'];
};

export type CreateFreightChargeInput = {
  freightChargeCreateInput: FreightChargeCreateInput;
  shipmentUuid: Scalars['String']['input'];
};

export type CreateFuelProfileDateRangeInput = {
  expirationDate: Scalars['DateTime']['input'];
  flatRateUsdCents?: InputMaybe<Scalars['Float']['input']>;
  fuelProfileUuid: Scalars['String']['input'];
  settlementPercentageRate?: InputMaybe<Scalars['Percent']['input']>;
  startDate: Scalars['DateTime']['input'];
  surchargeRate?: InputMaybe<Scalars['Float']['input']>;
};

export type CreateFuelProfileDateRangeOutput = {
  __typename?: 'CreateFuelProfileDateRangeOutput';
  error?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type CreateFuelProfileInput = {
  billingType: FuelBillingMethod;
  expirationDate: Scalars['DateTime']['input'];
  flatRateUsdCents?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  startDate: Scalars['DateTime']['input'];
  surchargeRate: Scalars['Float']['input'];
  type: FuelProfileType;
};

export type CreateGeneralLedgerCodeOutput = CreateGeneralLedgerCodeSuccessOutput | MutationErrorOutput;

export type CreateGeneralLedgerCodeSuccessOutput = {
  __typename?: 'CreateGeneralLedgerCodeSuccessOutput';
  generalLedgerCode: GeneralLedgerCodeEntity;
};

export type CreateIngestedOutlookEmailAttachmentInput = {
  ingestedOutlookEmailAttachmentCreateInput: IngestedOutlookEmailAttachmentCreateInput;
  ingestedOutlookEmailUuid: Scalars['String']['input'];
};

export type CreateIngestedOutlookEmailAttachmentOutput = {
  __typename?: 'CreateIngestedOutlookEmailAttachmentOutput';
  ingestedOutlookEmailAttachment: IngestedOutlookEmailAttachmentEntity;
};

export type CreateIngestedOutlookEmailOutput = {
  __typename?: 'CreateIngestedOutlookEmailOutput';
  ingestedOutlookEmail: IngestedOutlookEmailEntity;
};

export type CreateInventoryItemsInput = {
  itemUuid: Scalars['String']['input'];
  quantity: Scalars['Int']['input'];
  /** Dictates if a new storage unit should be created. if a storageUnitUuid is supplied it will take priority */
  shouldCreateStorageUnit?: InputMaybe<Scalars['Boolean']['input']>;
  storageOrderUuid: Scalars['String']['input'];
  /** The storage unit to associate the inventory items with, if provided */
  storageUnitUuid?: InputMaybe<Scalars['String']['input']>;
  unitOfMeasure: UnitOfMeasure;
};

export type CreateInventoryItemsOutput = {
  __typename?: 'CreateInventoryItemsOutput';
  /** The number of inventory items that were created */
  quantity: Scalars['Int']['output'];
  /** The storage unit that the items were added to, if any */
  storageUnit?: Maybe<StorageUnitEntity>;
};

export type CreateInventoryPrimaryUnitOfMeasureInput = {
  unitOfMeasure: UnitOfMeasure;
  upcCode?: InputMaybe<Scalars['String']['input']>;
};

export type CreateInventorySecondaryUnitOfMeasureInput = {
  primaryUnitsPerSecondaryUOM?: InputMaybe<Scalars['Float']['input']>;
  unitOfMeasure: UnitOfMeasure;
  upcCode?: InputMaybe<Scalars['String']['input']>;
};

export type CreateInvoiceDocumentInput = {
  documentType: DocumentType;
  fileName: Scalars['String']['input'];
  fileType: Scalars['String']['input'];
  invoiceUuid: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  pageNumber?: InputMaybe<Scalars['Int']['input']>;
  region?: InputMaybe<Scalars['String']['input']>;
  thumbnail?: InputMaybe<Scalars['String']['input']>;
};

export type CreateInvoiceDocumentsInput = {
  createInvoiceDocumentInputs: Array<CreateInvoiceDocumentInput>;
};

export type CreateInvoiceInput = {
  invoiceCreateInput: InvoiceCreateInput;
};

export type CreateInvoiceTermsForAllInput = {
  terms: Array<Scalars['String']['input']>;
};

export type CreateItemInput = {
  contactUuid: Scalars['String']['input'];
  createInventoryPrimaryUnitOfMeasureInput: CreateInventoryPrimaryUnitOfMeasureInput;
  createInventorySecondaryUnitOfMeasureInput?: InputMaybe<CreateInventorySecondaryUnitOfMeasureInput>;
  createItemStorageUnitConfigInput?: InputMaybe<CreateItemStorageUnitConfigInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  productCost?: InputMaybe<Scalars['Float']['input']>;
  sellPrice?: InputMaybe<Scalars['Float']['input']>;
  sku: Scalars['String']['input'];
  status: ItemStatus;
  warehouseUuid?: InputMaybe<Scalars['String']['input']>;
};

export type CreateItemLocationInput = {
  name: Scalars['String']['input'];
};

export type CreateItemLocationOutput = {
  __typename?: 'CreateItemLocationOutput';
  /** The item location that was created. It is null in the case a location with a duplicate name w.r.t to the company is passed in */
  itemLocation?: Maybe<ItemLocationEntity>;
};

export type CreateItemOutput = {
  __typename?: 'CreateItemOutput';
  error?: Maybe<Scalars['String']['output']>;
  item?: Maybe<ItemEntity>;
};

export type CreateItemStorageUnitConfigInput = {
  consolidationUnitUOM: UnitOfMeasure;
  dimensionsUOM: WarehouseMeasurementUnits;
  height: Scalars['Float']['input'];
  high: Scalars['Float']['input'];
  length: Scalars['Float']['input'];
  primaryUnitsPerConsolidationUnit: Scalars['Float']['input'];
  tie: Scalars['Float']['input'];
  type: MeasurementUnits;
  weight: Scalars['Float']['input'];
  weightUOM: WarehouseMeasurementUnits;
  width: Scalars['Float']['input'];
};

export type CreateLegDriverMapInput = {
  legDriverMapCreateInput: LegDriverMapCreateInput;
};

export type CreateLegInput = {
  legCreateInput: LegCreateInput;
  /** The order of this leg relative to other legs in the same shipment */
  ordinal: Scalars['Int']['input'];
  shipmentUuid: Scalars['String']['input'];
};

export type CreateLineHaulLaneInput = {
  lineHaulLaneCreateInput: LineHaulLaneCreateInput;
};

export type CreateLineHaulLaneOutput = {
  __typename?: 'CreateLineHaulLaneOutput';
  errorMessage?: Maybe<Scalars['String']['output']>;
  lineHaulLane?: Maybe<LineHaulLaneEntity>;
};

export type CreateLineHaulManifestInput = {
  lineHaulManifestCreateInput: LineHaulManifestCreateInput;
};

export type CreateLineHaulManifestsInput = {
  /** A date in ISO 8601 format */
  departDate: Scalars['String']['input'];
  lanes: Array<CreateLineHaulManifestsLaneInput>;
};

export type CreateLineHaulManifestsLaneInput = {
  count: Scalars['Int']['input'];
  endTerminalUuid: Scalars['String']['input'];
  startTerminalUuid: Scalars['String']['input'];
};

export type CreateLineHaulManifestsOutput = CreateLineHaulManifestsSuccessOutput | MutationErrorOutput;

export type CreateLineHaulManifestsSuccessOutput = {
  __typename?: 'CreateLineHaulManifestsSuccessOutput';
  lineHaulManifests: Array<LineHaulManifestEntity>;
};

export type CreateLineHaulSegmentInput = {
  lineHaulSegmentCreateInput: LineHaulSegmentCreateInput;
};

export type CreateLineHaulSegmentOutput = {
  __typename?: 'CreateLineHaulSegmentOutput';
  segment: LineHaulSegmentEntity;
};

export type CreateMasterAccountInput = {
  name: Scalars['String']['input'];
};

export type CreateMasterAccountOutput = {
  __typename?: 'CreateMasterAccountOutput';
  success: Scalars['Boolean']['output'];
};

export type CreateNotificationInput = {
  acknowledged?: InputMaybe<Scalars['Boolean']['input']>;
  contactUuid?: InputMaybe<Scalars['String']['input']>;
  driverMarkedAttemptedDriverUuid?: InputMaybe<Scalars['String']['input']>;
  driverMarkedAttemptedStopUuid?: InputMaybe<Scalars['String']['input']>;
  emailTransactionUuid?: InputMaybe<Scalars['String']['input']>;
  sourceDriverUuid?: InputMaybe<Scalars['String']['input']>;
  targetAccessorialUuid?: InputMaybe<Scalars['String']['input']>;
  targetStopUuid?: InputMaybe<Scalars['String']['input']>;
  type: NotificationType;
};

export type CreateOptimizationRunDto = {
  optimizationType?: InputMaybe<Scalars['String']['input']>;
  pinnedSlotUuid?: InputMaybe<Scalars['String']['input']>;
  routeUuid: Scalars['String']['input'];
  startAddressId?: InputMaybe<Scalars['String']['input']>;
};

export type CreateOrUpdateCsvOrdersInput = {
  /** The parsed CSV orders that have to be created */
  createOrders: Array<CreateCsvOrdersOrderInput>;
  /** The parsed CSV orders that have to be updated with new packages */
  updateOrders: Array<UpdateCsvOrdersOrderInput>;
};

export type CreateOrUpdateCsvOrdersOutput = CreateOrUpdateCsvOrdersSuccessOutput | MutationErrorOutput;

export type CreateOrUpdateCsvOrdersSuccessOutput = {
  __typename?: 'CreateOrUpdateCsvOrdersSuccessOutput';
  /** The orders that were either created or updated by the CSV file */
  orders: Array<OrderEntity>;
};

/** This is the graphql input for creating or updating a customer */
export type CreateOrUpdateCustomerInput = {
  businessDivisionUuid?: InputMaybe<Scalars['String']['input']>;
  defaultAddressUuid?: InputMaybe<Scalars['String']['input']>;
  defaultDimFactor?: InputMaybe<Scalars['Float']['input']>;
  defaultFuelSurcharge?: InputMaybe<Scalars['Float']['input']>;
  defaultInboundEdiServiceUuid?: InputMaybe<Scalars['String']['input']>;
  defaultInboundOutboundEdiServiceUuid?: InputMaybe<Scalars['String']['input']>;
  defaultLineHaulTariffChainId?: InputMaybe<Scalars['String']['input']>;
  defaultOrdinaryTariffChainId?: InputMaybe<Scalars['String']['input']>;
  defaultOutboundEdiServiceUuid?: InputMaybe<Scalars['String']['input']>;
  defaultPointToPointTariffChainId?: InputMaybe<Scalars['String']['input']>;
  defaultServiceUuid?: InputMaybe<Scalars['String']['input']>;
  defaultTransferTariffChainId?: InputMaybe<Scalars['String']['input']>;
  defaultUseTariff: Scalars['Boolean']['input'];
  enableCustomerPortalOrderEntry: Scalars['Boolean']['input'];
  invoiceOrOrderIdentifier: Scalars['String']['input'];
  isPrepaidOnly: Scalars['Boolean']['input'];
  referenceNumberLabels: Array<Scalars['String']['input']>;
  serviceUuids: Array<Scalars['String']['input']>;
  showEdiReferenceNumbersOnOrderPage: Scalars['Boolean']['input'];
  useCustomVehicleTypes: Scalars['Boolean']['input'];
  vehicleTypeUuids: Array<Scalars['String']['input']>;
};

export type CreateOrUpdateSettlementAdjustmentOutput = CreateOrUpdateSettlementAdjustmentSuccessOutput | MutationErrorOutput;

export type CreateOrUpdateSettlementAdjustmentSuccessOutput = {
  __typename?: 'CreateOrUpdateSettlementAdjustmentSuccessOutput';
  settlementAdjustment: SettlementAdjustmentEntity;
};

export type CreateOrderCommentInput = {
  comment: Scalars['String']['input'];
  orderUuid?: InputMaybe<Scalars['String']['input']>;
  showOnInvoice?: InputMaybe<Scalars['Boolean']['input']>;
  userUuid: Scalars['String']['input'];
};

export type CreateOrderDocumentDocumentInput = {
  companyUuid: Scalars['String']['input'];
  documentType: DocumentType;
  fileName: Scalars['String']['input'];
  fileType: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  region?: InputMaybe<Scalars['String']['input']>;
  thumbnail?: InputMaybe<Scalars['String']['input']>;
};

export type CreateOrderDocumentDocumentOutput = {
  __typename?: 'CreateOrderDocumentDocumentOutput';
  document: DocumentEntity;
};

export type CreateOrderDocumentInput = {
  documentType: DocumentType;
  fileName: Scalars['String']['input'];
  fileType: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  orderUuid: Scalars['String']['input'];
  pageNumber?: InputMaybe<Scalars['Int']['input']>;
  region?: InputMaybe<Scalars['String']['input']>;
  thumbnail?: InputMaybe<Scalars['String']['input']>;
  uploadOrdinal?: InputMaybe<Scalars['Int']['input']>;
  uploadedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

/** The expected input for generating a report from the orders table. */
export type CreateOrderTableReportInput = {
  /** A UUID filter intended for the active terminal */
  activeTerminalFilter?: InputMaybe<StringFilterV2>;
  activeTerminalUuidFilter?: InputMaybe<StringFilter>;
  addressCityFilter?: InputMaybe<StringFilter>;
  addressZipFilter?: InputMaybe<StringFilter>;
  appointmentRequired?: InputMaybe<BooleanFilter>;
  appointmentRequiredFilter?: InputMaybe<BooleanFilterV2>;
  attemptedAtDateFilters?: InputMaybe<DateFilterStartEnd>;
  /** A date filter intended for the order attempted date. Currently only implemented for the flat orders view. */
  attemptedDateFilter?: InputMaybe<DateFilterV2>;
  billingPartyContactDisplayNameFilter?: InputMaybe<StringFilter>;
  billingPartyContactUuidFilter?: InputMaybe<StringFilter>;
  /** Searches for orders with one of these contacts. Null represents no filter being applied at all (equivalent to "All"). An empty array should not be passed in since orders must always have a billing party contact. */
  billingPartyContactUuidsFilter?: InputMaybe<StringsFilter>;
  businessDivisionNameFilter?: InputMaybe<StringFilterV2>;
  businessDivisionUuidFilter?: InputMaybe<StringFilter>;
  businessDivisionUuidFilterV2?: InputMaybe<StringFilterV2>;
  /** A boolean filter intended for the can dispatch boolean status. Currently only implemented for the flat orders view. */
  canDispatchFilter?: InputMaybe<BooleanFilterV2>;
  /** A date filter intended for the completed at order table field */
  completedAtDateFilter?: InputMaybe<DateFilterV2>;
  completionDateFilters?: InputMaybe<DateFilterStartEnd>;
  consigneeFilter?: InputMaybe<StringFilter>;
  controllingTerminalUuidFilter?: InputMaybe<StringFilter>;
  controllingTerminalUuidFilterV2?: InputMaybe<StringFilterV2>;
  createdAtDateFilters?: InputMaybe<DateFilterStartEnd>;
  /** A date filter intended for the order created date. Currently only implemented for the flat orders view. */
  createdDateFilter?: InputMaybe<DateFilterV2>;
  customerFilter?: InputMaybe<StringFilter>;
  /** A string filter intended for the customer name field */
  customerNameFilter?: InputMaybe<StringFilterV2>;
  /** A filter for the customer portal order review status. */
  customerPortalOrderReviewStatusFilter?: InputMaybe<CustomerPortalOrderReviewStatusFilter>;
  /** A UUID filter for the customer */
  customerUuidFilter?: InputMaybe<StringFilterV2>;
  /** A date filter intended for the order deadline date. Currently only implemented for the flat orders view. */
  deadlineDateFilter?: InputMaybe<DateFilterV2>;
  deadlineDateFilters?: InputMaybe<DateFilterStartEnd>;
  destinationTerminalUuidFilter?: InputMaybe<StringFilterNullable>;
  /** A UUID filter intended for the destination terminal */
  destinationTerminalUuidFilterV2?: InputMaybe<StringFilterV2>;
  /** A float filter intended for the dim weight. Currently only implemented for the flat orders view. */
  dimWeightFilter?: InputMaybe<FloatFilterV2>;
  /** A string filter intended for the driver name flat order table field */
  driverNameFilter?: InputMaybe<StringFilterV2>;
  driverUuidFilter?: InputMaybe<StringFilter>;
  driverUuidFilterV2?: InputMaybe<StringFilterV2>;
  /** Searches for orders with one of these drivers. An empty values array represents orders with no driver (equivalent to "None"). Null represents no filter being applied at all (equivalent to "All"). */
  driverUuidsFilter?: InputMaybe<StringsFilter>;
  endStopFilter?: InputMaybe<StringFilter>;
  expectedInboundArrivalDateFilters?: InputMaybe<DateFilterStartEnd>;
  /** A string filter intended for the order external notes. Currently only implemented for the flat orders view. */
  externalNotesFilter?: InputMaybe<StringFilterV2>;
  filters?: InputMaybe<FindOrdersFiltersInput>;
  hasAppointmentScheduled?: InputMaybe<BooleanFilter>;
  hasAppointmentScheduledFilter?: InputMaybe<BooleanFilterV2>;
  hasContactInformation?: InputMaybe<BooleanFilter>;
  hasContactInformationFilter?: InputMaybe<BooleanFilterV2>;
  hasFailures?: InputMaybe<BooleanFilter>;
  hasFailuresFilter?: InputMaybe<BooleanFilterV2>;
  hasQuotesFilter?: InputMaybe<BooleanFilterV2>;
  hasRoute?: InputMaybe<BooleanFilter>;
  hasRouteFilter?: InputMaybe<BooleanFilterV2>;
  /** A string filter intended for the HAWB order table field */
  hawbFilter?: InputMaybe<StringFilterV2>;
  hideFromBilling?: InputMaybe<BooleanFilter>;
  hideFromBillingFilter?: InputMaybe<BooleanFilterV2>;
  /** A boolean filter intended for filtering out shipments associated with a consolidated order in the old consolidated order flow. */
  hideOriginalConsolidatedOrderIdFilter?: InputMaybe<BooleanFilterV2>;
  /** A string filter intended for the hold reason. Currently only implemented for the flat orders view. */
  holdReasonFilter?: InputMaybe<StringFilterV2>;
  /** A string filter intended for the secondary reference number on the inbound address table field */
  inboundAddressFilter?: InputMaybe<StringFilterV2>;
  /** A string filter intended for inbound address type. Currently only implemented for the flat orders view. */
  inboundAddressTypeFilter?: InputMaybe<StandardStopTypeFilter>;
  /** A boolean filter intended for a confirmed inbound appointment. Currently only implemented for the flat orders view. */
  inboundAppointmentConfirmedFilter?: InputMaybe<BooleanFilterV2>;
  /** A date filter intended for the inbound appointment date. Currently only implemented for the flat orders view. */
  inboundAppointmentDateFilter?: InputMaybe<DateFilterV2>;
  /** A boolean filter intended for the inbound appointment required. Currently only implemented for the flat orders view. */
  inboundAppointmentRequiredFilter?: InputMaybe<BooleanFilterV2>;
  /** A string filter intended for the INBOUND_CITY_NAME order table field */
  inboundCityFilter?: InputMaybe<StringFilterV2>;
  /** A date filter intended for the inbound completed date order table field */
  inboundCompletedDateFilter?: InputMaybe<DateFilterV2>;
  /** A boolean filter intended to filter for inbound stop completion. Currently only implemented for the flat orders view. */
  inboundCompletedFilter?: InputMaybe<BooleanFilterV2>;
  /** A string filter intended for the inbound contact name. Currently only implemented for the flat orders view. */
  inboundContactNameFilter?: InputMaybe<StringFilterV2>;
  /** A string filter intended for the inbound driver name flat order table field */
  inboundDriverNameFilter?: InputMaybe<StringFilterV2>;
  inboundDriverUuidFilter?: InputMaybe<StringFilterV2>;
  inboundDriverUuidsFilter?: InputMaybe<StringsFilter>;
  inboundMethodFilter?: InputMaybe<StopType>;
  inboundMethodFilterV2?: InputMaybe<StopTypesV2Filter>;
  inboundNotArrived?: InputMaybe<BooleanFilter>;
  inboundNotArrivedFilter?: InputMaybe<BooleanFilterV2>;
  /** A date filter intended for the inbound route date. Currently only implemented for the flat orders view. */
  inboundRouteDateFilter?: InputMaybe<DateFilterV2>;
  /** A string filter intended for the inbound route name. Currently only implemented for the flat orders view. */
  inboundRouteNameFilter?: InputMaybe<StringFilterV2>;
  /** A string filter intended for the inbound routing field. Currently only implemented for the flat orders view. */
  inboundRoutingFilter?: InputMaybe<StringFilterV2>;
  /** A date filter intended for the INBOUND_SERVICE_DATE order table field */
  inboundServiceDateFilter?: InputMaybe<DateFilterV2>;
  /** A filter intended for the inbound stop type filter. Currently only implemented for the flat orders view. */
  inboundStopTypeFilter?: InputMaybe<StopTypeFilter>;
  /** A string filter intended for the inbound terminal name field */
  inboundTerminalFilter?: InputMaybe<StringFilterV2>;
  /** A filter intended for the inbound zipcode filter. Currently only implemented for the flat orders view. */
  inboundZipcodeFilter?: InputMaybe<StringFilterV2>;
  /** A boolean filter intended to filter by whether order is part of a consolidated order. */
  includeOrdersPartOfV2ConsolidatedOrders?: InputMaybe<BooleanFilterV2>;
  /** A date filter intended for the order invoice date. Currently only implemented for the flat orders view. */
  invoiceDateFilter?: InputMaybe<DateFilterV2>;
  invoiceDateFilters?: InputMaybe<DateFilterStartEnd>;
  invoiceUuid?: InputMaybe<Scalars['String']['input']>;
  isCancelled?: InputMaybe<BooleanFilter>;
  isCancelledFilter?: InputMaybe<BooleanFilterV2>;
  isCollectOnDelivery?: InputMaybe<Scalars['Boolean']['input']>;
  isCollectOnDeliveryFilter?: InputMaybe<BooleanFilterV2>;
  isDraftOrderFilter?: InputMaybe<BooleanFilterV2>;
  isFinalized?: InputMaybe<BooleanFilter>;
  isFinalizedFilter?: InputMaybe<BooleanFilterV2>;
  isHazmat?: InputMaybe<BooleanFilter>;
  isHazmatFilter?: InputMaybe<BooleanFilterV2>;
  isInBond?: InputMaybe<BooleanFilter>;
  isInBondFilter?: InputMaybe<BooleanFilterV2>;
  isLineHaul?: InputMaybe<BooleanFilter>;
  isLineHaulFilter?: InputMaybe<BooleanFilterV2>;
  isOsd?: InputMaybe<BooleanFilter>;
  isOsdFilter?: InputMaybe<BooleanFilterV2>;
  isPicked?: InputMaybe<BooleanFilter>;
  isPickedFilter?: InputMaybe<BooleanFilterV2>;
  isPickupOrDelivery?: InputMaybe<BooleanFilter>;
  isPickupOrDeliveryFilter?: InputMaybe<BooleanFilterV2>;
  isRefused?: InputMaybe<BooleanFilter>;
  isRefusedFilter?: InputMaybe<BooleanFilterV2>;
  /** A boolean filter intended for the orders that are reweighed. Currently only implemented for the flat orders view. */
  isReweighedFilter?: InputMaybe<BooleanFilterV2>;
  isSpecial?: InputMaybe<BooleanFilter>;
  isSpecialFilter?: InputMaybe<BooleanFilterV2>;
  /** A string filter intended for the IT number order table field */
  itNumberFilter?: InputMaybe<StringFilterV2>;
  /** A UUID filter for the end terminal of the last line haul manifest that the order is on */
  lastLineHaulTerminalUuidFilter?: InputMaybe<UuidFilterV2>;
  /** A UUID filter for the line haul lane field. Currently only implemented for the flat orders view. */
  lineHaulLaneFilter?: InputMaybe<UuidFilterV2>;
  lineHaulLaneUuids?: InputMaybe<Array<Scalars['String']['input']>>;
  /** A UUID list filter for the terminals that the line haul manifests include */
  lineHaulTerminalUuidsFilter?: InputMaybe<UuidListFilter>;
  /** A date filter intended for the date marked on hand. Currently only implemented for the flat orders view. */
  markedOnHandDateFilter?: InputMaybe<DateFilterV2>;
  /** A string filter intended for the MAWB order table field */
  mawbFilter?: InputMaybe<StringFilterV2>;
  multipleSearches?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Pass as true to remove the limit. Use with caution! */
  noMaximum?: InputMaybe<Scalars['Boolean']['input']>;
  noTerminal?: InputMaybe<BooleanFilter>;
  onHand?: InputMaybe<BooleanFilter>;
  onHandFilter?: InputMaybe<BooleanFilterV2>;
  /** A filter intended for the on hand terminal. Currently only implemented for the flat orders view and is used in context of line haul orders. */
  onHandTerminalFilter?: InputMaybe<UuidFilterV2>;
  /** A boolean filter intended for on hold orders. Currently only implemented for the flat orders view. */
  onHoldFilter?: InputMaybe<BooleanFilterV2>;
  onInvoice?: InputMaybe<BooleanFilter>;
  onInvoiceFilter?: InputMaybe<BooleanFilterV2>;
  /** A string filter intended for the order city */
  orderCityFilter?: InputMaybe<StringFilterV2>;
  /** A string filter intended for the order name order table field */
  orderNameFilterV2?: InputMaybe<StringFilterV2>;
  /** A string filter intended for the order notes. Currently only implemented for the flat orders view. */
  orderNotesFilter?: InputMaybe<StringFilterV2>;
  orderNumberFilter?: InputMaybe<StringFilter>;
  /** A date filter intended for the order service date order table field */
  orderServiceDateFilter?: InputMaybe<DateFilterV2>;
  orderSource?: InputMaybe<OrderSource>;
  /** An enum filter intended for the ORDER_SOURCE order table field */
  orderSourceFilter?: InputMaybe<OrderSourceFilter>;
  /** A filter intended for the order status. Currently only implemented for the flat orders view. */
  orderStatusFilter?: InputMaybe<OrderStatusFilter>;
  /** The list of order table fields to fetch values for */
  orderTableFields: Array<OrderTableField>;
  /** A string filter intended for the order zipcode */
  orderZipFilter?: InputMaybe<StringFilterV2>;
  originTerminalUuidFilter?: InputMaybe<StringFilterNullable>;
  /** A UUID filter intended for the origin terminal */
  originTerminalUuidFilterV2?: InputMaybe<StringFilterV2>;
  /** A string filter intended for the OSD reason. Currently only implemented for the flat orders view. */
  osdReasonFilter?: InputMaybe<StringFilterV2>;
  outForDeliveryFilter?: InputMaybe<BooleanFilter>;
  outForDeliveryFilterV2?: InputMaybe<BooleanFilterV2>;
  /** A string filter intended for the secondary reference number on the outbound address table field */
  outboundAddressFilter?: InputMaybe<StringFilterV2>;
  /** A string filter intended for outbound address type. Currently only implemented for the flat orders view. */
  outboundAddressTypeFilter?: InputMaybe<StandardStopTypeFilter>;
  /** A boolean filter intended for a confirmed outbound appointment. Currently only implemented for the flat orders view. */
  outboundAppointmentConfirmedFilter?: InputMaybe<BooleanFilterV2>;
  /** A date filter intended for the outbound appointment date. Currently only implemented for the flat orders view. */
  outboundAppointmentDateFilter?: InputMaybe<DateFilterV2>;
  /** A boolean filter intended for the outbound appointment required. Currently only implemented for the flat orders view. */
  outboundAppointmentRequiredFilter?: InputMaybe<BooleanFilterV2>;
  /** A string filter intended for the OUTBOUND_CITY_NAME order table field */
  outboundCityFilter?: InputMaybe<StringFilterV2>;
  /** A date filter intended for the outbound completed date order table field */
  outboundCompletedDateFilter?: InputMaybe<DateFilterV2>;
  /** A boolean filter intended to filter for outbound stop completion. Currently only implemented for the flat orders view. */
  outboundCompletedFilter?: InputMaybe<BooleanFilterV2>;
  /** A string filter intended for the outbound contact name. Currently only implemented for the flat orders view. */
  outboundContactNameFilter?: InputMaybe<StringFilterV2>;
  /** A string filter intended for the outbound destination airport. Currently only implemented for the flat orders view. */
  outboundDestinationAirportFilter?: InputMaybe<StringFilterV2>;
  /** A string filter intended for the outbound driver name flat order table field */
  outboundDriverNameFilter?: InputMaybe<StringFilterV2>;
  outboundDriverUuidFilter?: InputMaybe<StringFilterV2>;
  outboundDriverUuidsFilter?: InputMaybe<StringsFilter>;
  outboundMethodFilter?: InputMaybe<StopType>;
  outboundMethodFilterV2?: InputMaybe<StopTypesV2Filter>;
  /** A date filter intended for the outbound route date. Currently only implemented for the flat orders view. */
  outboundRouteDateFilter?: InputMaybe<DateFilterV2>;
  /** A string filter intended for the outbound route name. Currently only implemented for the flat orders view. */
  outboundRouteNameFilter?: InputMaybe<StringFilterV2>;
  /** A string filter intended for the outbound routing field. Currently only implemented for the flat orders view. */
  outboundRoutingFilter?: InputMaybe<StringFilterV2>;
  /** A date filter intended for the outbound service date. Currently only implemented for the flat orders view. */
  outboundServiceDateFilter?: InputMaybe<DateFilterV2>;
  /** A filter intended for the outbound stop type filter. Currently only implemented for the flat orders view. */
  outboundStopTypeFilter?: InputMaybe<StopTypeFilter>;
  /** A string filter intended for the outbound terminal name field */
  outboundTerminalFilter?: InputMaybe<StringFilterV2>;
  /** A filter intended for the outbound zipcode filter. Currently only implemented for the flat orders view. */
  outboundZipcodeFilter?: InputMaybe<StringFilterV2>;
  paperworkComplete?: InputMaybe<BooleanFilter>;
  paperworkCompleteFilter?: InputMaybe<BooleanFilterV2>;
  pickupOrDelivery?: InputMaybe<PickupOrDelivery>;
  primaryAppointmentDateFilters?: InputMaybe<DateFilterStartEnd>;
  /** A string filter intended for the inbound or outbound proof of delivery name field */
  proofOfDeliveryNameFilter?: InputMaybe<StringFilterV2>;
  /** A string filter intended for the proof of delivery signee. Currently only implemented for the flat orders view. */
  proofOfDeliverySigneeFilter?: InputMaybe<StringFilterV2>;
  /** A boolean filter intended for the received at origin boolean status. Currently only implemented for the flat orders view. */
  receivedAtOriginFilter?: InputMaybe<BooleanFilterV2>;
  receivedDateFilters?: InputMaybe<DateFilterStartEnd>;
  requiresRecovery?: InputMaybe<BooleanFilter>;
  requiresRecoveryFilter?: InputMaybe<BooleanFilterV2>;
  requiresRouting?: InputMaybe<BooleanFilter>;
  requiresRoutingFilter?: InputMaybe<BooleanFilterV2>;
  /** A string filter intended for routing location. Currently only implemented for the flat orders view. */
  routingLocationFilter?: InputMaybe<StringFilterV2>;
  scheduledAtDateFilters?: InputMaybe<DateFilterStartEnd>;
  scheduledFilter?: InputMaybe<BooleanFilter>;
  scheduledFilterV2?: InputMaybe<BooleanFilterV2>;
  searchHawbOnly?: InputMaybe<Scalars['Boolean']['input']>;
  searchMiscInfoOnly?: InputMaybe<Scalars['Boolean']['input']>;
  searchRefNumbersOnly?: InputMaybe<Scalars['Boolean']['input']>;
  searchText?: InputMaybe<Scalars['String']['input']>;
  /** A string filter intended for the secondary reference number on the order table field */
  secondaryReferenceNumberFilter?: InputMaybe<StringFilterV2>;
  /** A date filter intended for the ORDER_SERVICE_DATE order table field */
  serviceDateFilter?: InputMaybe<DateFilterV2>;
  serviceDateFilters?: InputMaybe<DateFilterStartEnd>;
  /** A string filter intended for serviceLevel. Currently only implemented for the flat orders view. */
  serviceLevelFilter?: InputMaybe<StringFilterV2>;
  serviceUuids?: InputMaybe<Array<Scalars['String']['input']>>;
  shipmentStatusFilters?: InputMaybe<Array<ShipmentStatusFilter>>;
  shipperFilter?: InputMaybe<StringFilter>;
  showConsolidatedOrders?: InputMaybe<BooleanFilter>;
  showConsolidatedOrdersFilter?: InputMaybe<BooleanFilterV2>;
  /** True if ascending, False if descending, undefined if no sort */
  sortByCustomerNameAscending?: InputMaybe<Scalars['Boolean']['input']>;
  sorts?: InputMaybe<Array<OrderSort>>;
  sortsV2?: InputMaybe<Array<OrderSortV2>>;
  standardStopType?: InputMaybe<StandardStopType>;
  startStopFilter?: InputMaybe<StringFilter>;
  statusFilters?: InputMaybe<Array<StatusFilter>>;
  stopTypesFilter?: InputMaybe<StopTypesFilter>;
  tagUuids?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Searches for orders with one of these tags. An empty values array represents orders with no tags (equivalent to "None"). Null represents no filter being applied at all (equivalent to "All"). */
  tagUuidsFilter?: InputMaybe<StringsFilter>;
  /** A string filter intended for the order tags. Currently only implemented for the flat orders view. */
  tagsFilter?: InputMaybe<StringFilterV2>;
  terminalUuidFilter?: InputMaybe<StringFilter>;
  terminalUuidFilterV2?: InputMaybe<StringFilterV2>;
  /** Searches for orders with one of these terminals on the startStop or endStop. An empty values array represents orders with no terminal on the startStop and endStop (equivalent to "None"). Null represents no filter being applied at all (equivalent to "All"). */
  terminalUuidsFilter?: InputMaybe<StringsFilter>;
  /** A float filter intended for the total amount in dollars. Currently only implemented for the flat orders view. */
  totalAmountDollarsFilter?: InputMaybe<FloatFilterV2>;
  /** request total number of records, request with prudence */
  totalCount?: InputMaybe<Scalars['Boolean']['input']>;
  /** An int filter intended for the total pieces flat order table field only */
  totalPiecesFilter?: InputMaybe<IntegerFilterV2>;
  /** An int filter intended for the total skids. Currently implemented only for the flat orders view */
  totalSkidsFilter?: InputMaybe<IntegerFilterV2>;
  /** A float filter intended for the total weight flat order table field only */
  totalWeightFilter?: InputMaybe<FloatFilterV2>;
  transferPending?: InputMaybe<BooleanFilter>;
  transferPendingFilter?: InputMaybe<BooleanFilterV2>;
  /** A string filter intended for the UN number order table field */
  unNumberFilter?: InputMaybe<StringFilterV2>;
  useMultiSearch?: InputMaybe<Scalars['Boolean']['input']>;
  uuids?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Version ID for the request */
  versionId?: InputMaybe<Scalars['Float']['input']>;
  /** A string filter intended for the zipcode on inbound and outbound stops table field */
  zipcodeFilter?: InputMaybe<StringFilterV2>;
};

export type CreateOrderTableReportOutput = MutationErrorOutput | OrderTableReportDownloadOutput | OrderTableReportEmailToUserOutput;

/** This is the graphql input for creating an organization */
export type CreateOrganizationInput = {
  customerFields?: InputMaybe<CreateOrUpdateCustomerInput>;
  defaultContactPersonUuid?: InputMaybe<Scalars['String']['input']>;
  ediApplicationId?: InputMaybe<Scalars['String']['input']>;
  ediContactCode?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  isaId?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  referenceNumber?: InputMaybe<Scalars['String']['input']>;
  stediPartnerId?: InputMaybe<Scalars['String']['input']>;
  types: Array<OrganizationType>;
};

export type CreateOrganizationOutput = CreateOrganizationSuccessOutput | MutationErrorOutput;

export type CreateOrganizationSuccessOutput = {
  __typename?: 'CreateOrganizationSuccessOutput';
  /** The created organization */
  organization: OrganizationEntity;
};

export type CreatePackageInput = {
  orderUuid: Scalars['String']['input'];
  packageCreateInput: PackageCreateInput;
  shipmentUuid: Scalars['String']['input'];
};

export type CreatePackageSpecInput = {
  height?: InputMaybe<Scalars['Length']['input']>;
  length?: InputMaybe<Scalars['Length']['input']>;
  name: Scalars['String']['input'];
  weight?: InputMaybe<Scalars['Mass']['input']>;
  width?: InputMaybe<Scalars['Length']['input']>;
};

export type CreatePackageSpecOutput = {
  __typename?: 'CreatePackageSpecOutput';
  packageSpec: PackageSpecEntity;
};

export type CreatePaymentInput = {
  amountInCents: Scalars['Int']['input'];
  comment?: InputMaybe<Scalars['String']['input']>;
  contactUuid: Scalars['String']['input'];
  createPaymentToOrderMappingInputs: Array<CreatePaymentToOrderMappingInput>;
  creditTypeUuid?: InputMaybe<Scalars['String']['input']>;
  date: Scalars['DateTime']['input'];
  glTerminalUuid?: InputMaybe<Scalars['String']['input']>;
  invoiceUuid?: InputMaybe<Scalars['String']['input']>;
  paymentRail?: InputMaybe<PaymentRail>;
  paymentType: PaymentType;
  referenceNumber: Scalars['String']['input'];
};

export type CreatePaymentToOrderMappingInput = {
  amountInCents: Scalars['Int']['input'];
  orderUuid: Scalars['String']['input'];
};

export type CreatePdfColumnInput = {
  contactUuid: Scalars['String']['input'];
  pdfColumnCreateInput: PdfColumnCreateInput;
};

export type CreatePermissionInput = {
  accessLevel: AccessLevel;
  permissionResource: PermissionResource;
  roleUuid: Scalars['String']['input'];
};

export type CreatePermissionOutput = {
  __typename?: 'CreatePermissionOutput';
  success: Scalars['Boolean']['output'];
};

export type CreatePersonInput = {
  contactStationIds?: InputMaybe<Array<Scalars['String']['input']>>;
  contactUuid: Scalars['String']['input'];
  defaultDeliveryAddress?: InputMaybe<AddressUpsertInput>;
  defaultPickupAddress?: InputMaybe<AddressUpsertInput>;
  defaultServiceUuid?: InputMaybe<Scalars['String']['input']>;
  defaultVehicleTypeUuid?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  phone?: InputMaybe<Scalars['String']['input']>;
};

export type CreatePersonOutput = {
  __typename?: 'CreatePersonOutput';
  person: PersonEntity;
};

export type CreatePicklistInput = {
  date?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  /** List of item groups with quantities to be added to picklist */
  itemGroups: Array<UpsertPickListItemGroup>;
  outboundReferenceNumber?: InputMaybe<Scalars['String']['input']>;
};

export type CreatePieceInput = {
  additionalReferenceNumbers?: InputMaybe<Array<Scalars['String']['input']>>;
  orderUuid: Scalars['String']['input'];
  packageUuid?: InputMaybe<Scalars['String']['input']>;
  referenceNumber: Scalars['String']['input'];
};

export type CreatePlaceInput = {
  placeCreateInput: PlaceCreateInput;
};

export type CreatePodReportDocumentInput = {
  documentType: DocumentType;
  fileName: Scalars['String']['input'];
  fileType: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  orderUuid: Scalars['String']['input'];
  region?: InputMaybe<Scalars['String']['input']>;
  thumbnail?: InputMaybe<Scalars['String']['input']>;
};

export type CreatePodReportDocumentOutput = {
  __typename?: 'CreatePodReportDocumentOutput';
  document: DocumentEntity;
};

export type CreateProratedConsolidatedOrderInput = {
  shipmentUuids: Array<Scalars['String']['input']>;
};

export type CreateProratedConsolidatedOrderOutput = {
  __typename?: 'CreateProratedConsolidatedOrderOutput';
  consolidatedOrderUuid?: Maybe<Scalars['String']['output']>;
  errorMessage?: Maybe<Scalars['String']['output']>;
  orders: Array<OrderEntity>;
};

export type CreateQuickbooksHeaderFileMappingInput = {
  quickbooksHeaderFileMappingCreateInput: QuickbooksHeaderFileMappingCreateInput;
};

export type CreateQuoteInput = {
  quoteCreateInput: QuoteCreateInput;
};

export type CreateRecurringOrderFrequencyInput = {
  daysOfMonth?: InputMaybe<Array<Scalars['Int']['input']>>;
  daysOfWeek: Array<DayOfWeekAll>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  repeatFrequencyUnit?: InputMaybe<RepeatFrequencyUnit>;
  repeatInterval?: InputMaybe<Scalars['Int']['input']>;
  repeatIntervalWeeks: Scalars['Int']['input'];
  startDate: Scalars['DateTime']['input'];
};

export type CreateRoleInput = {
  isInternalRole: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
};

export type CreateRoleOutput = {
  __typename?: 'CreateRoleOutput';
  role: RoleEntity;
};

export type CreateRouteDriverInput = {
  routeDriverCreateInput: RouteDriverCreateInput;
};

export type CreateRouteFromRouteTemplateInput = {
  /** The date for which to create the route and its orders, defaults to the current date */
  date?: InputMaybe<PlainDateInput>;
  /** The UUID of a run (to be renamed to route template) */
  routeTemplateUuid: Scalars['String']['input'];
};

export type CreateRouteFromRouteTemplateOutput = CreateRouteFromRouteTemplateSuccessOutput | MutationErrorOutput;

export type CreateRouteFromRouteTemplateSuccessOutput = {
  __typename?: 'CreateRouteFromRouteTemplateSuccessOutput';
  /** The orders that were created and added to the route */
  orders: Array<OrderEntity>;
  /** The newly created route or an existing route that was updated */
  route: RouteEntity;
};

export type CreateRouteInput = {
  routeCreateInput: RouteCreateInput;
};

export type CreateRouteNameInput = {
  routeNameCreateInput: RouteNameCreateInput;
};

export type CreateRouteNameLocationInput = {
  routeNameLocationCreateInput: RouteNameLocationCreateInput;
  routeNameUuid: Scalars['String']['input'];
};

export type CreateRouteOptimizationInput = {
  routeOptimizationCreateInput: RouteOptimizationCreateInput;
};

export type CreateRouteSlotInput = {
  routeSlotCreateInput: RouteSlotCreateInput;
  routeUuid: Scalars['String']['input'];
};

export type CreateRoutesInput = {
  routeCreateInputs: Array<RouteCreateInput>;
};

export type CreateRunInput = {
  driverUuid?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  orderUuids?: InputMaybe<Array<Scalars['String']['input']>>;
  tagUuids?: InputMaybe<Array<Scalars['String']['input']>>;
  terminalUuid?: InputMaybe<Scalars['String']['input']>;
  vehicleTypeUuid?: InputMaybe<Scalars['String']['input']>;
};

export type CreateRunOutput = {
  __typename?: 'CreateRunOutput';
  run: RunEntity;
};

export type CreateSameDayDispatchConfigInput = {
  deliveryAppointmentTimeThreshold?: InputMaybe<Scalars['Int']['input']>;
  deliveryWithinTimeWindowColorCode?: InputMaybe<Scalars['String']['input']>;
  isNextInRouteColorCode?: InputMaybe<Scalars['String']['input']>;
  isPastDeadlineColorCode?: InputMaybe<Scalars['String']['input']>;
  isSpecialColorCode?: InputMaybe<Scalars['String']['input']>;
  pickupAppointmentTimeThreshold?: InputMaybe<Scalars['Int']['input']>;
  pickupWithinTimeWindowColorCode?: InputMaybe<Scalars['String']['input']>;
};

export type CreateSamsaraOauthTokenInput = {
  accessToken: Scalars['String']['input'];
  expiresAt: Scalars['DateTime']['input'];
  refreshToken: Scalars['String']['input'];
  scope: Scalars['String']['input'];
  tokenType: Scalars['String']['input'];
};

export type CreateSandboxRouteForDriverInput = {
  password: Scalars['String']['input'];
  phoneNumber: Scalars['String']['input'];
};

export type CreateSavedFilterViewInput = {
  dispatchTableFields?: InputMaybe<Array<DispatchTableField>>;
  displayName: Scalars['String']['input'];
  filterModelJson: Scalars['String']['input'];
  filterModelJsonV2?: InputMaybe<Scalars['JSON']['input']>;
  orderTableFields: Array<OrderTableField>;
  savedViewPageType: FilterViewPage;
  sortModelJson?: InputMaybe<Array<Scalars['JSON']['input']>>;
};

export type CreateScannedOrdersFromAdminInput = {
  scannedOrderCreateInputs: Array<ScannedOrderFromAdminCreateInput>;
};

export type CreateScannedOrdersInput = {
  scannedOrderCreateInputs: Array<ScannedOrderCreateInput>;
};

export type CreateSchedulingRegionInput = {
  dailyCapacityPieces?: InputMaybe<Scalars['Int']['input']>;
  dailyCapacityStops?: InputMaybe<Scalars['Int']['input']>;
  dailyCapacityWeight?: InputMaybe<Scalars['Mass']['input']>;
  name: Scalars['String']['input'];
};

export type CreateSchedulingRegionOutput = CreateSchedulingRegionSuccessOutput | MutationErrorOutput;

export type CreateSchedulingRegionSuccessOutput = {
  __typename?: 'CreateSchedulingRegionSuccessOutput';
  schedulingRegion: SchedulingRegionEntity;
};

export type CreateSchedulingZoneInput = {
  availabilities?: InputMaybe<Array<SchedulingZoneAvailabilityUpsertInput>>;
  locations?: InputMaybe<Array<SchedulingZoneLocationUpsertInput>>;
  name: Scalars['String']['input'];
  schedulingRegionId: Scalars['String']['input'];
};

export type CreateSchedulingZoneOutput = CreateSchedulingZoneSuccessOutput | MutationErrorOutput;

export type CreateSchedulingZoneSuccessOutput = {
  __typename?: 'CreateSchedulingZoneSuccessOutput';
  schedulingZone: SchedulingZoneEntity;
};

export type CreateSchemaCompanyMappingInput = {
  companyUuid: Scalars['String']['input'];
  contactUuid: Scalars['String']['input'];
  schemaUuid: Scalars['String']['input'];
  terminalUuid?: InputMaybe<Scalars['String']['input']>;
};

export type CreateSchemaDocumentInput = {
  schemaCompanyMappingUuid?: InputMaybe<Scalars['String']['input']>;
  schemaDocument: SchemaDocumentInput;
  schemaUuid: Scalars['String']['input'];
};

export type CreateSchemaInput = {
  companyUuid?: InputMaybe<Scalars['String']['input']>;
  contactUuid?: InputMaybe<Scalars['String']['input']>;
  schema: SchemaInput;
};

export type CreateSchemaTestSnapshotInput = {
  uuid: Scalars['String']['input'];
};

export type CreateServiceInput = {
  serviceCreateInput: ServiceCreateInput;
};

/** An object describing the service regions to create */
export type CreateServiceRegionsInput = {
  serviceRegions: Array<CreateServiceRegionsRegionInput>;
};

export type CreateServiceRegionsOutput = CreateServiceRegionsSuccessOutput | MutationErrorOutput;

/** An object describing the region operated in by a company or agent */
export type CreateServiceRegionsRegionInput = {
  name: Scalars['String']['input'];
};

export type CreateServiceRegionsSuccessOutput = {
  __typename?: 'CreateServiceRegionsSuccessOutput';
  /** All of the company's service regions, including the ones created  */
  serviceRegions: Array<ServiceRegionEntity>;
};

export type CreateSftpCredentialsInput = {
  ediPartnershipUuid: Scalars['String']['input'];
  host: Scalars['String']['input'];
  invoicePath?: InputMaybe<Scalars['String']['input']>;
  password: Scalars['String']['input'];
  path: Scalars['String']['input'];
  podNamingConvention: PodNamingConvention;
  port: Scalars['Int']['input'];
  username: Scalars['String']['input'];
};

export type CreateSftpCredentialsOutput = {
  __typename?: 'CreateSftpCredentialsOutput';
  sftpCredentials: SftpCredentialsEntity;
};

export type CreateShipmentDocumentInput = {
  documentType: DocumentType;
  driverFormTemplateUuid?: InputMaybe<Scalars['String']['input']>;
  fileName: Scalars['String']['input'];
  fileType: Scalars['String']['input'];
  isNewlyCreatedShipment?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  pageNumber?: InputMaybe<Scalars['Int']['input']>;
  region?: InputMaybe<Scalars['String']['input']>;
  shipmentUuid: Scalars['String']['input'];
  thumbnail?: InputMaybe<Scalars['String']['input']>;
};

export type CreateStandardOrderFieldsInput = {
  standardOrderFieldsCreateInput: StandardOrderFieldsCreateInput;
};

export type CreateStandardOrderInput = {
  orderCreateInput: StandardOrderCreateInput;
  timingData?: InputMaybe<CreateStandardOrderTimingData>;
};

export type CreateStandardOrderTimingData = {
  durationMs: Scalars['Float']['input'];
  endTimeUnix: Scalars['Float']['input'];
  startTimeUnix: Scalars['Float']['input'];
};

export type CreateStandardShipmentFieldInput = {
  standardShipmentFieldsCreateInput: StandardShipmentFieldsCreateInput;
};

export type CreateStorageOrderDocumentInput = {
  documentType: DocumentType;
  fileName: Scalars['String']['input'];
  fileType: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  region?: InputMaybe<Scalars['String']['input']>;
  storageOrderUuid: Scalars['String']['input'];
  thumbnail?: InputMaybe<Scalars['String']['input']>;
};

export type CreateStorageOrderDocumentOutput = {
  __typename?: 'CreateStorageOrderDocumentOutput';
  document: DocumentEntity;
};

export type CreateStorageOrderInput = {
  arrivedAt?: InputMaybe<Scalars['DateTime']['input']>;
  billOfLadingNumber?: InputMaybe<Scalars['String']['input']>;
  carrier?: InputMaybe<Scalars['String']['input']>;
  consigneeName?: InputMaybe<Scalars['String']['input']>;
  /** The UUID of the contact for whom the storage order is being created */
  contactUuid: Scalars['String']['input'];
  expectedAt?: InputMaybe<Scalars['DateTime']['input']>;
  lotNumber?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  pickupDate?: InputMaybe<Scalars['DateTime']['input']>;
  purchaseOrderNumber?: InputMaybe<Scalars['String']['input']>;
  referenceNumber: Scalars['String']['input'];
  sealNumber?: InputMaybe<Scalars['String']['input']>;
  supplierCompanyName?: InputMaybe<Scalars['String']['input']>;
  trackingNumber?: InputMaybe<Scalars['String']['input']>;
  trailerNumber?: InputMaybe<Scalars['String']['input']>;
  warehouseUuid?: InputMaybe<Scalars['String']['input']>;
};

export type CreateStorageOrderOutput = {
  __typename?: 'CreateStorageOrderOutput';
  /** The storage order that was created */
  storageOrder: StorageOrderEntity;
};

export type CreateStorageUnitInput = {
  height?: InputMaybe<Scalars['Length']['input']>;
  length?: InputMaybe<Scalars['Length']['input']>;
  /** If a name is not passed in, it is autogenerated */
  name?: InputMaybe<Scalars['String']['input']>;
  storageOrderUuid: Scalars['String']['input'];
  /** If a unit of measure is not passed in, the default contact unit of measure will be used */
  unitOfMeasure?: InputMaybe<UnitOfMeasure>;
  weight?: InputMaybe<Scalars['Mass']['input']>;
  width?: InputMaybe<Scalars['Length']['input']>;
};

export type CreateStorageUnitOutput = {
  __typename?: 'CreateStorageUnitOutput';
  storageUnit: StorageUnitEntity;
};

export type CreateStorageUnitWithInventoryItemsInput = {
  /** The UoM of the inventory items */
  itemUnitOfMeasure: UnitOfMeasure;
  /** The UUID of the item to create the inventory items for */
  itemUuid: Scalars['String']['input'];
  /** The name of the storage unit. If not supplied, will generate one based on contact reference ID */
  name?: InputMaybe<Scalars['String']['input']>;
  /** The number of inventory items to create and associate with the storage unit */
  quantity: Scalars['Int']['input'];
  /** The UUID of the storage order to create the storage unit for */
  storageOrderUuid: Scalars['String']['input'];
  /** The UoM of the storage unit */
  unitOfMeasure: UnitOfMeasure;
};

export type CreateStorageUnitWithInventoryItemsOutput = {
  __typename?: 'CreateStorageUnitWithInventoryItemsOutput';
  success: Scalars['Boolean']['output'];
};

export type CreateTagInput = {
  tagCreateInput: TagCreateInput;
};

export type CreateTariffChainInput = {
  name: Scalars['String']['input'];
  tariffGroupType: TariffGroupType;
  tariffGroupUuids: Array<Scalars['String']['input']>;
};

export type CreateTariffChainOutput = CreateTariffChainSuccessOutput | MutationErrorOutput;

export type CreateTariffChainSuccessOutput = {
  __typename?: 'CreateTariffChainSuccessOutput';
  /** The tariff chain that was created */
  tariffChain: TariffChainEntity;
};

export type CreateTariffGroupInput = {
  contactToServicesMappings: Array<CreateContactToServicesMappingInput>;
  contactUuids: Array<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  fuelProfileUuid?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  parentTariffGroupUuid?: InputMaybe<Scalars['String']['input']>;
  rateMultiplier?: InputMaybe<Scalars['Float']['input']>;
  rateType: RateType;
  serviceUuids?: InputMaybe<Array<Scalars['String']['input']>>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  tariffCreateInputs: Array<TariffCreateInput>;
  tariffGroupScope?: InputMaybe<TariffGroupScope>;
  tariffGroupType: TariffGroupType;
  tariffOverageRateCreates?: InputMaybe<Array<TariffOverageRateCreateInput>>;
  tariffType: TariffType;
  tariffZoneCreateInputs: Array<TariffZoneCreateInput>;
  tariffZoneGroupId?: InputMaybe<Scalars['String']['input']>;
  tariffZoneUpdateInputs: Array<TariffZoneUpdateInput>;
  terminalUuids: Array<Scalars['String']['input']>;
  useActualWeightInCalculation: Scalars['Boolean']['input'];
  useDeficitBilling?: InputMaybe<Scalars['Boolean']['input']>;
  vehicleTypeUuids?: InputMaybe<Array<Scalars['String']['input']>>;
  zoneType: TariffZoneType;
};

export type CreateTariffInput = {
  /** Tariff Create Input */
  tariffCreateInput: TariffCreateInput;
  tariffGroupUuid?: InputMaybe<Scalars['String']['input']>;
};

export type CreateTariffLocationInput = {
  tariffLocationCreateInput: TariffLocationCreateInput;
  tariffZoneUuid: Scalars['String']['input'];
};

export type CreateTariffLocationOutput = {
  __typename?: 'CreateTariffLocationOutput';
  tariffLocation: TariffLocationEntity;
};

export type CreateTariffOutput = {
  __typename?: 'CreateTariffOutput';
  tariff: TariffEntity;
};

export type CreateTerminalInput = {
  terminalCreateInput: TerminalCreateInput;
};

/** An object describing the lanes to create between terminals. Each lane is a direct connection between two terminals. Specifying a start/end terminal combination that already exists has no effect. */
export type CreateTerminalLanesInput = {
  terminalLanes: Array<CreateTerminalLanesLaneInput>;
};

/** An object representing a lane between two terminals, meaning orders can be moved directly from the start to the end terminal. */
export type CreateTerminalLanesLaneInput = {
  endTerminalUuid: Scalars['String']['input'];
  startTerminalUuid: Scalars['String']['input'];
};

export type CreateTerminalLanesOutput = CreateTerminalLanesSuccessOutput | MutationErrorOutput;

export type CreateTerminalLanesSuccessOutput = {
  __typename?: 'CreateTerminalLanesSuccessOutput';
  /** All of the company’s terminal lanes, including the ones created */
  terminalLanes: Array<TerminalLaneEntity>;
};

export type CreateTerminalOutput = {
  __typename?: 'CreateTerminalOutput';
  terminal: TerminalEntity;
};

export type CreateTerminalServiceAreaInput = {
  city?: InputMaybe<Scalars['String']['input']>;
  terminalUuid: Scalars['String']['input'];
  zipcode: Scalars['String']['input'];
};

export type CreateTerminalServiceAreaOutput = {
  __typename?: 'CreateTerminalServiceAreaOutput';
  city?: Maybe<Scalars['String']['output']>;
  createdServiceAreaUuid?: Maybe<Scalars['String']['output']>;
  nameOfTerminalContainingThisZipcode?: Maybe<Scalars['String']['output']>;
  zipcode: Scalars['String']['output'];
};

export type CreateTerminalServiceAreaV2Output = {
  __typename?: 'CreateTerminalServiceAreaV2Output';
  createdCount?: Maybe<Scalars['Int']['output']>;
};

export type CreateTerminalSuccessOutput = {
  __typename?: 'CreateTerminalSuccessOutput';
  /** The created terminal */
  terminal: TerminalEntity;
};

export type CreateTerminalV2Output = CreateTerminalSuccessOutput | MutationErrorOutput;

export type CreateTerminalsInput = {
  companyUuid: Scalars['String']['input'];
  /** A publicly accessible URL of the terminals downloaded from Crown */
  terminalsUrl: Scalars['String']['input'];
};

export type CreateTestCompanyInput = {
  /** If set, overrides the default dim factor of 250 for the company */
  defaultDimFactor?: InputMaybe<Scalars['Float']['input']>;
  /** If set to true, line haul configs are enabled */
  isLineHaul?: InputMaybe<Scalars['Boolean']['input']>;
  /** If set to true, multi-terminal configs are enabled */
  isMultiTerminal?: InputMaybe<Scalars['Boolean']['input']>;
  /** If set to true, requires POD photo and name */
  requirePODPhotoAndName?: InputMaybe<Scalars['Boolean']['input']>;
  segment: Segment;
};

export type CreateTestCompanyOutput = {
  __typename?: 'CreateTestCompanyOutput';
  company: CompanyEntity;
  inboundTerminal: TerminalEntity;
  outboundTerminal: TerminalEntity;
};

export type CreateTestContactInput = {
  companyUuid: Scalars['String']['input'];
};

export type CreateTestOrderCustomChargeInput = {
  customChargeUuid: Scalars['String']['input'];
  testOrderUuid: Scalars['String']['input'];
  total: Scalars['Float']['input'];
};

export type CreateTestOrderCustomChargeOutput = {
  __typename?: 'CreateTestOrderCustomChargeOutput';
  success: Scalars['Boolean']['output'];
};

export type CreateTestOrderInput = {
  companyUuid: Scalars['String']['input'];
  /** If set to true, it creates a freight charge and fuel charge for the inbound stop */
  createInboundStopFreightChargeAndFuelCharge?: InputMaybe<Scalars['Boolean']['input']>;
  /** If set to true, it creates a freight charge and fuel charge for the line haul */
  createLineHaulFreightChargeAndFuelCharge?: InputMaybe<Scalars['Boolean']['input']>;
  /** If set to true, it creates a freight charge and fuel charge for the outbound stop */
  createOutboundStopFreightChargeAndFuelCharge?: InputMaybe<Scalars['Boolean']['input']>;
  /** The combination of inbound and outbound stops to create for the order */
  stopType: TestOrderStopType;
};

export type CreateTestOrderOutput = {
  __typename?: 'CreateTestOrderOutput';
  order: OrderEntity;
};

export type CreateTestOrderRequest = {
  orderUuid: Scalars['String']['input'];
  totalCharge: Scalars['Float']['input'];
  totalFreightCharge: Scalars['Float']['input'];
  totalFuelCharge: Scalars['Float']['input'];
};

export type CreateTestOrderResponse = {
  __typename?: 'CreateTestOrderResponse';
  success: Scalars['Boolean']['output'];
};

export type CreateThirdPartyUserInput = {
  contactUuid: Scalars['String']['input'];
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
};

export type CreateUserInput = {
  arrangeStopsAndRoutesVertically?: InputMaybe<Scalars['Boolean']['input']>;
  /** If set to true, the user is assigned an internal role that provides them with the master permission resource */
  assignInternalRole?: InputMaybe<Scalars['Boolean']['input']>;
  companyUuid?: InputMaybe<Scalars['String']['input']>;
  dispatchTableColumnWidths?: InputMaybe<Scalars['JSON']['input']>;
  dispatchTableFields?: InputMaybe<Array<DispatchTableField>>;
  email: Scalars['String']['input'];
  linehaulDispatchTableFields?: InputMaybe<Array<LinehaulDispatchTableField>>;
  name?: InputMaybe<Scalars['String']['input']>;
  numberOfStops?: InputMaybe<Scalars['Float']['input']>;
  orderTableFields?: InputMaybe<Array<OrderTableField>>;
  password: Scalars['String']['input'];
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  /** The list of roles to assign to a user */
  roleUuids?: InputMaybe<Array<Scalars['String']['input']>>;
  routeCardStopTableColumnWidths?: InputMaybe<Scalars['JSON']['input']>;
  routeCardWidth?: InputMaybe<Scalars['Float']['input']>;
  sendAllInvoices?: InputMaybe<Scalars['Boolean']['input']>;
  sendSummaryEmailWithIncompleteRoutes?: InputMaybe<Scalars['Boolean']['input']>;
  terminalUuid?: InputMaybe<Scalars['String']['input']>;
  useMinimizedAppointmentTime?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CreateWarehouseEmployeeInput = {
  active: Scalars['Boolean']['input'];
  emailAddress?: InputMaybe<Scalars['String']['input']>;
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  password: Scalars['String']['input'];
  phoneNumber: Scalars['String']['input'];
};

export type CreateWarehouseEmployeeOutput = {
  __typename?: 'CreateWarehouseEmployeeOutput';
  /** The created warehouse employee. It is null if there is a duplicate phone number being used or a server-side error occurs. */
  warehouseEmployee?: Maybe<WarehouseEmployeeEntity>;
};

export type CreateWarehouseInput = {
  addressCreateInput: AddressCreateInput;
  name: Scalars['String']['input'];
  terminalUuid?: InputMaybe<Scalars['String']['input']>;
};

export type CreateWarehouseLocationInput = {
  location1?: InputMaybe<Scalars['String']['input']>;
  location2?: InputMaybe<Scalars['String']['input']>;
  location3?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  warehouseUuid?: InputMaybe<Scalars['String']['input']>;
};

export type CreateWarehouseLocationOutput = {
  __typename?: 'CreateWarehouseLocationOutput';
  /** An array of error messages. This is null if there are no errors. */
  errors?: Maybe<Array<Scalars['String']['output']>>;
  /** The warehouse location that was created. This is null if there is a warehouse location with a duplicate name passed in or  */
  warehouseLocation?: Maybe<WarehouseLocationEntity>;
};

export type CreditTypeCreateInput = {
  color?: InputMaybe<Scalars['String']['input']>;
  generalLedgerCodeId?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
};

export type CreditTypeEntity = {
  __typename?: 'CreditTypeEntity';
  color?: Maybe<Scalars['String']['output']>;
  generalLedgerCode?: Maybe<GeneralLedgerCodeEntity>;
  name: Scalars['String']['output'];
  uuid: Scalars['String']['output'];
};

export type CreditTypeUpdateInput = {
  color?: InputMaybe<Scalars['String']['input']>;
  generalLedgerCodeId?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  uuid: Scalars['String']['input'];
};

export type CsvOrderFieldMappingEntity = {
  __typename?: 'CsvOrderFieldMappingEntity';
  createdAt: Scalars['DateTime']['output'];
  sourceColumnName: Scalars['String']['output'];
  targetFieldType: CsvOrderMappingTargetFieldType;
  updatedAt: Scalars['DateTime']['output'];
  uuid: Scalars['String']['output'];
};

export enum CsvOrderImportStatus {
  Accepted = 'ACCEPTED',
  InReview = 'IN_REVIEW',
  Rejected = 'REJECTED'
}

export type CsvOrderImportTransactionEntity = {
  __typename?: 'CsvOrderImportTransactionEntity';
  bucket: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  fileName: Scalars['String']['output'];
  key: Scalars['String']['output'];
  message?: Maybe<Scalars['String']['output']>;
  region: Scalars['String']['output'];
  /** The raw, comma-separated string contents of the CSV row */
  row: Scalars['String']['output'];
  rowNumber: Scalars['Int']['output'];
  status: CsvOrderImportTransactionStatus;
  updatedAt: Scalars['DateTime']['output'];
  uuid: Scalars['String']['output'];
};

export enum CsvOrderImportTransactionStatus {
  Completed = 'COMPLETED',
  Failed = 'FAILED',
  InProgress = 'IN_PROGRESS'
}

export type CsvOrderMappingEntity = {
  __typename?: 'CsvOrderMappingEntity';
  contact?: Maybe<ContactEntity>;
  createdAt: Scalars['DateTime']['output'];
  csvOrderFieldMappings: Array<CsvOrderFieldMappingEntity>;
  deadlineDateDefaultValue?: Maybe<Scalars['DateTime']['output']>;
  deadlineTypeDefaultValue?: Maybe<DeadlineType>;
  enableDynamicInboundOrOutboundStop: Scalars['Boolean']['output'];
  enableInboundStop: Scalars['Boolean']['output'];
  enableOutboundStop: Scalars['Boolean']['output'];
  freightBillingMethodDefaultValue?: Maybe<FreightBillingMethod>;
  name: Scalars['String']['output'];
  pickupOrDeliveryDefaultValue?: Maybe<PickupOrDelivery>;
  serviceLevelDefaultValue?: Maybe<ServiceEntity>;
  stopTypeDefaultValue?: Maybe<StandardStopType>;
  /** A flag that, if set, ensures that any imports with this mapping treats rows with duplicate HAWBs as updates to existing orders rather than duplicate entries to be skipped. */
  updateOrderOnDuplicateBolNumber?: Maybe<Scalars['Boolean']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  uuid: Scalars['String']['output'];
};

export type CsvOrderMappingQueryInput = {
  uuid: Scalars['String']['input'];
};

export enum CsvOrderMappingTargetFieldType {
  AddressCity = 'ADDRESS_CITY',
  AddressLine_1 = 'ADDRESS_LINE_1',
  AddressLine_2 = 'ADDRESS_LINE_2',
  AddressName = 'ADDRESS_NAME',
  AddressState = 'ADDRESS_STATE',
  AddressZip = 'ADDRESS_ZIP',
  AppointmentEndTime = 'APPOINTMENT_END_TIME',
  AppointmentRequired = 'APPOINTMENT_REQUIRED',
  AppointmentStartTime = 'APPOINTMENT_START_TIME',
  Contact = 'CONTACT',
  ContactPersonEmail = 'CONTACT_PERSON_EMAIL',
  ContactPersonFirstName = 'CONTACT_PERSON_FIRST_NAME',
  ContactPersonLastName = 'CONTACT_PERSON_LAST_NAME',
  ContactPersonPhone = 'CONTACT_PERSON_PHONE',
  CustomerReferenceNumber = 'CUSTOMER_REFERENCE_NUMBER',
  DeadlineDate = 'DEADLINE_DATE',
  DeadlineType = 'DEADLINE_TYPE',
  DriverName = 'DRIVER_NAME',
  DriverReferenceNumber = 'DRIVER_REFERENCE_NUMBER',
  FreightChargeRate = 'FREIGHT_CHARGE_RATE',
  Hawb = 'HAWB',
  InboundAddressCity = 'INBOUND_ADDRESS_CITY',
  InboundAddressLine_1 = 'INBOUND_ADDRESS_LINE_1',
  InboundAddressLine_2 = 'INBOUND_ADDRESS_LINE_2',
  InboundAddressName = 'INBOUND_ADDRESS_NAME',
  InboundAddressState = 'INBOUND_ADDRESS_STATE',
  InboundAddressZip = 'INBOUND_ADDRESS_ZIP',
  InboundAppointmentEndTime = 'INBOUND_APPOINTMENT_END_TIME',
  InboundAppointmentRequired = 'INBOUND_APPOINTMENT_REQUIRED',
  InboundAppointmentStartTime = 'INBOUND_APPOINTMENT_START_TIME',
  InboundContactPersonEmail = 'INBOUND_CONTACT_PERSON_EMAIL',
  InboundContactPersonFirstName = 'INBOUND_CONTACT_PERSON_FIRST_NAME',
  InboundContactPersonLastName = 'INBOUND_CONTACT_PERSON_LAST_NAME',
  InboundContactPersonName = 'INBOUND_CONTACT_PERSON_NAME',
  InboundContactPersonPhone = 'INBOUND_CONTACT_PERSON_PHONE',
  InboundDeadlineDate = 'INBOUND_DEADLINE_DATE',
  InboundDeadlineType = 'INBOUND_DEADLINE_TYPE',
  InboundDriverName = 'INBOUND_DRIVER_NAME',
  InboundDriverReferenceNumber = 'INBOUND_DRIVER_REFERENCE_NUMBER',
  InboundSpecialInstructions = 'INBOUND_SPECIAL_INSTRUCTIONS',
  InboundTerminalName = 'INBOUND_TERMINAL_NAME',
  Mawb = 'MAWB',
  Notes = 'NOTES',
  OutboundAddressCity = 'OUTBOUND_ADDRESS_CITY',
  OutboundAddressLine_1 = 'OUTBOUND_ADDRESS_LINE_1',
  OutboundAddressLine_2 = 'OUTBOUND_ADDRESS_LINE_2',
  OutboundAddressName = 'OUTBOUND_ADDRESS_NAME',
  OutboundAddressState = 'OUTBOUND_ADDRESS_STATE',
  OutboundAddressZip = 'OUTBOUND_ADDRESS_ZIP',
  OutboundAppointmentEndTime = 'OUTBOUND_APPOINTMENT_END_TIME',
  OutboundAppointmentRequired = 'OUTBOUND_APPOINTMENT_REQUIRED',
  OutboundAppointmentStartTime = 'OUTBOUND_APPOINTMENT_START_TIME',
  OutboundContactPersonEmail = 'OUTBOUND_CONTACT_PERSON_EMAIL',
  OutboundContactPersonFirstName = 'OUTBOUND_CONTACT_PERSON_FIRST_NAME',
  OutboundContactPersonLastName = 'OUTBOUND_CONTACT_PERSON_LAST_NAME',
  OutboundContactPersonName = 'OUTBOUND_CONTACT_PERSON_NAME',
  OutboundContactPersonPhone = 'OUTBOUND_CONTACT_PERSON_PHONE',
  OutboundDeadlineDate = 'OUTBOUND_DEADLINE_DATE',
  OutboundDeadlineType = 'OUTBOUND_DEADLINE_TYPE',
  OutboundDriverName = 'OUTBOUND_DRIVER_NAME',
  OutboundDriverReferenceNumber = 'OUTBOUND_DRIVER_REFERENCE_NUMBER',
  OutboundSpecialInstructions = 'OUTBOUND_SPECIAL_INSTRUCTIONS',
  OutboundTerminalName = 'OUTBOUND_TERMINAL_NAME',
  PackageDescription = 'PACKAGE_DESCRIPTION',
  PackageHeight = 'PACKAGE_HEIGHT',
  PackageLength = 'PACKAGE_LENGTH',
  PackageQuantity = 'PACKAGE_QUANTITY',
  PackageWeight = 'PACKAGE_WEIGHT',
  PackageWidth = 'PACKAGE_WIDTH',
  PickupOrDelivery = 'PICKUP_OR_DELIVERY',
  ReferenceNumber = 'REFERENCE_NUMBER',
  ServiceLevel = 'SERVICE_LEVEL',
  SpecialInstructions = 'SPECIAL_INSTRUCTIONS',
  StopType = 'STOP_TYPE',
  TerminalName = 'TERMINAL_NAME'
}

export type CsvOrderPreSignedPutUrlEntity = {
  __typename?: 'CsvOrderPreSignedPutUrlEntity';
  bucket: Scalars['String']['output'];
  filename: Scalars['String']['output'];
  filetype: Scalars['String']['output'];
  key: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type CsvRouteNameInput = {
  city: Scalars['String']['input'];
  routeName: Scalars['String']['input'];
  zipcode: Scalars['String']['input'];
};

export type CustomChargeArrayUpdateInput = {
  /** Pass this field in to create a new array item */
  customChargeCreateInput?: InputMaybe<CustomChargeCreateInput>;
  /** Pass this field in to update an array item */
  customChargeUpdateInput?: InputMaybe<CustomChargeUpdateInput>;
  /** Pass this field in to upsert an array item */
  customChargeUpsertInput?: InputMaybe<CustomChargeUpsertInput>;
};

export enum CustomChargeBillingMethod {
  Accessorial = 'ACCESSORIAL',
  AdHoc = 'AD_HOC'
}

export type CustomChargeCreateInput = {
  accessorialTemplateUuid?: InputMaybe<Scalars['String']['input']>;
  authoCode?: InputMaybe<Scalars['String']['input']>;
  billingMethod: CustomChargeBillingMethod;
  description?: InputMaybe<Scalars['String']['input']>;
  /** The fuel surcharge rate expressed as a percentage out of 100 */
  fuelSurchargeRate?: InputMaybe<Scalars['Float']['input']>;
  isAutoApplied?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  quantity: Scalars['Float']['input'];
  rate?: InputMaybe<Scalars['Float']['input']>;
  settlementFlatRate?: InputMaybe<Scalars['Float']['input']>;
  settlementPercentageRate?: InputMaybe<Scalars['Float']['input']>;
  specialAccessorialMatrixItemUuid?: InputMaybe<Scalars['String']['input']>;
  /** The total charge in dollars */
  totalCharge?: InputMaybe<Scalars['Float']['input']>;
  zoneBasedAccessorialMatrixItemUuid?: InputMaybe<Scalars['String']['input']>;
};

export type CustomChargeEntity = {
  __typename?: 'CustomChargeEntity';
  accessorialRange?: Maybe<AccessorialRangeEntity>;
  accessorialTemplate?: Maybe<AccessorialInterface>;
  authoCode?: Maybe<Scalars['String']['output']>;
  billingMethod: CustomChargeBillingMethod;
  description?: Maybe<Scalars['String']['output']>;
  /** This is saved as a percentage in the range [0, 1]. */
  fuelSurchargeRate?: Maybe<Scalars['Float']['output']>;
  isAutoApplied: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  postedAmountUsdCents?: Maybe<Scalars['Int']['output']>;
  /** This is a percentage out of 100 */
  postedFuelSurchargeRate?: Maybe<Scalars['Float']['output']>;
  quantity: Scalars['Float']['output'];
  /** returns rate a double in a string for presentation */
  rate: Scalars['Float']['output'];
  settlementFlatRate?: Maybe<Scalars['Float']['output']>;
  settlementPercentageRate?: Maybe<Scalars['Float']['output']>;
  shipment?: Maybe<ShipmentEntity>;
  specialAccessorialChargeGroupUuid?: Maybe<Scalars['String']['output']>;
  specialAccessorialMatrixItem?: Maybe<SpecialAccessorialMatrixItemEntity>;
  specialAccessorialTariffZoneUuid?: Maybe<Scalars['String']['output']>;
  total: Scalars['Float']['output'];
  totalAmountCents?: Maybe<Scalars['Int']['output']>;
  uuid: Scalars['String']['output'];
  zoneBasedAccessorialChargeGroupUuid?: Maybe<Scalars['String']['output']>;
  zoneBasedAccessorialMatrixItem?: Maybe<ZoneBasedAccessorialMatrixItemEntity>;
  zoneBasedAccessorialZoneUuid?: Maybe<Scalars['String']['output']>;
};

export type CustomChargeUpdateInput = {
  accessorialTemplateUuid?: InputMaybe<Scalars['String']['input']>;
  authoCode?: InputMaybe<Scalars['String']['input']>;
  billingMethod: CustomChargeBillingMethod;
  description: Scalars['String']['input'];
  /** The fuel surcharge rate expressed as a percentage out of 100 */
  fuelSurchargeRate?: InputMaybe<Scalars['Float']['input']>;
  isAutoApplied?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  quantity?: InputMaybe<Scalars['Float']['input']>;
  rate?: InputMaybe<Scalars['Float']['input']>;
  settlementFlatRate?: InputMaybe<Scalars['Float']['input']>;
  settlementPercentageRate?: InputMaybe<Scalars['Float']['input']>;
  specialAccessorialMatrixItemUuid?: InputMaybe<Scalars['String']['input']>;
  /** The total charge in dollars */
  totalCharge?: InputMaybe<Scalars['Float']['input']>;
  uuid: Scalars['String']['input'];
  zoneBasedAccessorialMatrixItemUuid?: InputMaybe<Scalars['String']['input']>;
};

export type CustomChargeUpsertInput = {
  accessorialTemplateUuid?: InputMaybe<Scalars['String']['input']>;
  authoCode?: InputMaybe<Scalars['String']['input']>;
  billingMethod: CustomChargeBillingMethod;
  description?: InputMaybe<Scalars['String']['input']>;
  /** The fuel surcharge rate expressed as a percentage out of 100 */
  fuelSurchargeRate?: InputMaybe<Scalars['Float']['input']>;
  isAutoApplied?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  quantity: Scalars['Float']['input'];
  rate?: InputMaybe<Scalars['Float']['input']>;
  settlementFlatRate?: InputMaybe<Scalars['Float']['input']>;
  settlementPercentageRate?: InputMaybe<Scalars['Float']['input']>;
  specialAccessorialMatrixItemUuid?: InputMaybe<Scalars['String']['input']>;
  /** The total charge in dollars */
  totalCharge?: InputMaybe<Scalars['Float']['input']>;
  uuid: Scalars['String']['input'];
  zoneBasedAccessorialMatrixItemUuid?: InputMaybe<Scalars['String']['input']>;
};

export type CustomCostEntity = {
  __typename?: 'CustomCostEntity';
  accessorialRange?: Maybe<AccessorialRangeEntity>;
  accessorialTemplate?: Maybe<AccessorialInterface>;
  billingMethod?: Maybe<CustomChargeBillingMethod>;
  dependentSettlementBillingMethod?: Maybe<DependentSettlementBillingMethod>;
  description?: Maybe<Scalars['String']['output']>;
  /** The flat rate of the custom cost in dollars, if it exists */
  flatRateUsdDollars?: Maybe<Scalars['Float']['output']>;
  /** The fuel surcharge rate for the custom cost expressed as a percentage out of 100, if it exists */
  fuelSurchargeRate?: Maybe<Scalars['Float']['output']>;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  /** The percentage rate for the custom cost as a percentage out of 100 if it exists */
  percentageRate?: Maybe<Scalars['Percent']['output']>;
  quantity: Scalars['Float']['output'];
  /** The rate of the custom cost in dollars, if it exists */
  rateUsdDollars?: Maybe<Scalars['Float']['output']>;
  specialAccessorialMatrixItem?: Maybe<SpecialAccessorialMatrixItemEntity>;
  totalAmountUsdCents: Scalars['Float']['output'];
  /** The total cost for the custom cost in dollars if it exists. Meant for presentation */
  totalAmountUsdDollars?: Maybe<Scalars['Float']['output']>;
  zoneBasedAccessorialMatrixItem?: Maybe<ZoneBasedAccessorialMatrixItemEntity>;
};

export type CustomerContactCreateInput = {
  apiName?: InputMaybe<Scalars['String']['input']>;
  billingContactEmail: Scalars['String']['input'];
  billingCycle?: InputMaybe<BillingCycleType>;
  billingCycleDuration: BillingCycleDuration;
  billingPeriod?: InputMaybe<Scalars['Float']['input']>;
  billingRunStart: Scalars['DateTime']['input'];
  businessDivisionUuid?: InputMaybe<Scalars['String']['input']>;
  contactEmailCreateInputs?: InputMaybe<Array<ContactEmailCreateInput>>;
  contactPersonCreateInputs?: InputMaybe<Array<ContactPersonCreateInput>>;
  contactReferenceNumber?: InputMaybe<Scalars['String']['input']>;
  defaultAddressCreateInput?: InputMaybe<AddressCreateInput>;
  defaultContactPersonCreateInput?: InputMaybe<ContactPersonCreateInput>;
  defaultDimFactor?: InputMaybe<Scalars['Float']['input']>;
  defaultFuelSurcharge?: InputMaybe<Scalars['Float']['input']>;
  defaultInboundEdiServiceUuid?: InputMaybe<Scalars['String']['input']>;
  defaultInboundOutboundEdiServiceUuid?: InputMaybe<Scalars['String']['input']>;
  defaultInvoiceEmailSubject?: InputMaybe<Scalars['String']['input']>;
  defaultInvoiceTransmissionMethod?: InputMaybe<InvoiceTransmissionMethod>;
  defaultLineHaulTariffChainId?: InputMaybe<Scalars['String']['input']>;
  defaultOrdinaryTariffChainId?: InputMaybe<Scalars['String']['input']>;
  defaultOutboundEdiServiceUuid?: InputMaybe<Scalars['String']['input']>;
  defaultPointToPointTariffChainId?: InputMaybe<Scalars['String']['input']>;
  defaultServicePickupsDeliveries: Scalars['Boolean']['input'];
  defaultServiceUuid?: InputMaybe<Scalars['String']['input']>;
  defaultTransferTariffChainId?: InputMaybe<Scalars['String']['input']>;
  defaultUseTariff?: InputMaybe<Scalars['Boolean']['input']>;
  dimensionalWeightFactorCreateInputs?: InputMaybe<Array<DimensionalWeightCreateInput>>;
  displayName: Scalars['String']['input'];
  ediApplicationId?: InputMaybe<Scalars['String']['input']>;
  ediContactCode?: InputMaybe<Scalars['String']['input']>;
  enableCustomerPortalOrderEntry: Scalars['Boolean']['input'];
  freightChargeQuickbooksMappingId?: InputMaybe<Scalars['String']['input']>;
  fuelChargeQuickbooksMappingId?: InputMaybe<Scalars['String']['input']>;
  identifier?: InputMaybe<Scalars['String']['input']>;
  invoiceNotes?: InputMaybe<Scalars['String']['input']>;
  invoiceTimePeriodSplit?: InputMaybe<TimePeriod>;
  isActive: Scalars['Boolean']['input'];
  isPrepaidOnly?: InputMaybe<Scalars['Boolean']['input']>;
  isaId?: InputMaybe<Scalars['String']['input']>;
  masterAccountUuid?: InputMaybe<Scalars['String']['input']>;
  miscCustomChargeQuickbooksMappingId?: InputMaybe<Scalars['String']['input']>;
  numberOfOrdersPerInvoice?: InputMaybe<Scalars['Float']['input']>;
  packageSpecIds?: InputMaybe<Array<Scalars['String']['input']>>;
  quickbooksDesktopAccountsReceivableId?: InputMaybe<Scalars['String']['input']>;
  quickbooksDesktopContactId?: InputMaybe<Scalars['String']['input']>;
  quickbooksFileMappingCustomerName?: InputMaybe<Scalars['String']['input']>;
  quickbooksFileMappingFreightChargeName?: InputMaybe<Scalars['String']['input']>;
  quickbooksFileMappingFuelChargeName?: InputMaybe<Scalars['String']['input']>;
  quickbooksFileMappingPickupChargeName?: InputMaybe<Scalars['String']['input']>;
  quickbooksMappingId?: InputMaybe<Scalars['String']['input']>;
  referenceNumberLabels?: InputMaybe<Array<Scalars['String']['input']>>;
  requireDriverToCheckOffPackagesAtStop: Scalars['Boolean']['input'];
  serviceLevels?: InputMaybe<Array<ServiceLevel>>;
  serviceUuids?: InputMaybe<Array<Scalars['String']['input']>>;
  shortCode?: InputMaybe<Scalars['String']['input']>;
  showEdiReferenceNumbersOnOrderPage?: InputMaybe<Scalars['Boolean']['input']>;
  skipFuelCharge?: InputMaybe<Scalars['Boolean']['input']>;
  standardCarrierAlphaCode?: InputMaybe<Scalars['String']['input']>;
  stediPartnerId?: InputMaybe<Scalars['String']['input']>;
  useCustomPackageSpecs?: InputMaybe<Scalars['Boolean']['input']>;
  useCustomVehicleTypes?: InputMaybe<Scalars['Boolean']['input']>;
  vehicleTypeUuids?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type CustomerContactEntity = ContactEntity & {
  __typename?: 'CustomerContactEntity';
  addresses: Array<AddressEntity>;
  apiName?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use getAverageDaysToPayReport in ReportsService instead */
  averageDaysToPay90: Scalars['Float']['output'];
  /** @deprecated Use getAverageDaysToPayReport in ReportsService instead */
  averageDaysToPay180: Scalars['Float']['output'];
  /** @deprecated Use getAverageDaysToPayReport in ReportsService instead */
  averageDaysToPay270: Scalars['Float']['output'];
  /** @deprecated Use getAverageDaysToPayReport in ReportsService instead */
  averageDaysToPay360: Scalars['Float']['output'];
  /** @deprecated Use getAverageDaysToPayReport in ReportsService instead */
  averageDaysToPay720: Scalars['Float']['output'];
  /** @deprecated Use getAverageDaysToPayReport in ReportsService instead */
  averageDaysToPayAll: Scalars['Float']['output'];
  /** The customer balance for the contact in dollars */
  balance: Scalars['Float']['output'];
  billingContactEmail?: Maybe<Scalars['String']['output']>;
  billingCycle?: Maybe<BillingCycleType>;
  billingCycleDuration: BillingCycleDuration;
  billingPeriod?: Maybe<Scalars['Float']['output']>;
  billingPeriodDates?: Maybe<Array<Scalars['DateTime']['output']>>;
  billingRunStart: Scalars['DateTime']['output'];
  businessDivision?: Maybe<BusinessDivisionEntity>;
  company: CompanyEntity;
  contactComments: Array<ContactCommentEntity>;
  contactOpenInvoiceValue: Scalars['Float']['output'];
  contactOpenInvoiceValue0to30d: Scalars['Float']['output'];
  contactOpenInvoiceValue31to38d: Scalars['Float']['output'];
  contactOpenInvoiceValue39to45d: Scalars['Float']['output'];
  contactOpenInvoiceValue46to60d: Scalars['Float']['output'];
  contactOpenInvoiceValue61to75d: Scalars['Float']['output'];
  contactOpenInvoiceValueOver75d: Scalars['Float']['output'];
  contactPersons: Array<ContactPersonEntity>;
  contactReferenceNumber?: Maybe<Scalars['String']['output']>;
  contactStations: Array<ContactStationEntity>;
  contactStatistics: ContactStatsEntity;
  creditHoldLimitInCents?: Maybe<Scalars['Float']['output']>;
  creditsAppliedToContactInvoices: Scalars['Float']['output'];
  customerTariffs: Array<TariffEntity>;
  debitsAppliedToContactInvoices: Scalars['Float']['output'];
  defaultAddress?: Maybe<AddressEntity>;
  defaultContactPerson?: Maybe<ContactPersonEntity>;
  defaultDimFactor?: Maybe<Scalars['Float']['output']>;
  defaultEfmHandlingStation?: Maybe<Scalars['String']['output']>;
  defaultFuelSurcharge?: Maybe<Scalars['Float']['output']>;
  defaultInboundEdiService?: Maybe<ServiceEntity>;
  defaultInboundOutboundEdiService?: Maybe<ServiceEntity>;
  defaultInvoiceDocumentsRequired: Array<DocumentType>;
  defaultInvoiceDownloadDocuments: Array<DocumentType>;
  defaultInvoiceEmailSubject?: Maybe<Scalars['String']['output']>;
  defaultInvoiceTerms?: Maybe<InvoiceTermEntity>;
  defaultInvoiceTransmissionMethod: InvoiceTransmissionMethod;
  defaultInvoiceType: InvoiceType;
  defaultLineHaulTariffChain?: Maybe<TariffChainEntity>;
  defaultOrdinaryTariffChain?: Maybe<TariffChainEntity>;
  defaultOutboundEdiService?: Maybe<ServiceEntity>;
  defaultPointToPointTariffChain?: Maybe<TariffChainEntity>;
  defaultService?: Maybe<ServiceEntity>;
  defaultServicePickupsDeliveries: Scalars['Boolean']['output'];
  defaultTransferTariffChain?: Maybe<TariffChainEntity>;
  defaultUseTariff?: Maybe<Scalars['Boolean']['output']>;
  defaultVehicleType?: Maybe<VehicleTypeEntity>;
  /** The delivery discount rate as a percentage out of 100 if it exists */
  deliveryDiscountRate?: Maybe<Scalars['Percent']['output']>;
  dimFactor: Scalars['Int']['output'];
  displayName: Scalars['String']['output'];
  ediApplicationId?: Maybe<Scalars['String']['output']>;
  ediContactCode?: Maybe<Scalars['String']['output']>;
  ediPartnership?: Maybe<EdiPartnershipEntity>;
  ediPartnerships: Array<EdiPartnershipEntity>;
  enableCreditHold?: Maybe<Scalars['Boolean']['output']>;
  enableCustomerPortalOrderEntry: Scalars['Boolean']['output'];
  freightChargeQuickbooksMappingId?: Maybe<Scalars['String']['output']>;
  fuelChargeQuickbooksMappingId?: Maybe<Scalars['String']['output']>;
  identifier?: Maybe<Scalars['String']['output']>;
  invoiceNotes?: Maybe<Scalars['String']['output']>;
  invoicePdfColumns: Array<PdfColumnEntity>;
  invoiceTimePeriodSplit?: Maybe<TimePeriod>;
  isActive: Scalars['Boolean']['output'];
  isEfm?: Maybe<Scalars['Boolean']['output']>;
  isOverCreditLimit: Scalars['Boolean']['output'];
  isPrepaidOnly: Scalars['Boolean']['output'];
  isaId?: Maybe<Scalars['String']['output']>;
  /** The line haul discount rate as a percentage out of 100 if it exists */
  lineHaulDiscountRate?: Maybe<Scalars['Percent']['output']>;
  logo?: Maybe<DocumentEntity>;
  logoType?: Maybe<DocumentEntity>;
  masterAccount?: Maybe<MasterAccountEntity>;
  maxDaysOutstanding?: Maybe<Scalars['Float']['output']>;
  miscCustomChargeQuickbooksMappingId?: Maybe<Scalars['String']['output']>;
  numberOfOrdersPerInvoice?: Maybe<Scalars['Float']['output']>;
  orders: Array<OrderEntity>;
  overdueInvoices: Array<InvoiceEntity>;
  packageSpecs: Array<PackageSpecEntity>;
  paymentsAppliedToContactInvoices: Scalars['Float']['output'];
  /** The pickup discount rate as a percentage out of 100 if it exists */
  pickupDiscountRate?: Maybe<Scalars['Percent']['output']>;
  /** Total closed balance across all posted invoices */
  postedInvoicesTotalClosedBalance: Scalars['Float']['output'];
  /** Total open balance across all posted invoices */
  postedInvoicesTotalOpenBalance: Scalars['Float']['output'];
  quickbooksDesktopAccountsReceivableId?: Maybe<Scalars['String']['output']>;
  quickbooksDesktopContactId?: Maybe<Scalars['String']['output']>;
  quickbooksFileMappingCustomerName?: Maybe<Scalars['String']['output']>;
  quickbooksFileMappingFreightChargeName?: Maybe<Scalars['String']['output']>;
  quickbooksFileMappingFuelChargeName?: Maybe<Scalars['String']['output']>;
  quickbooksFileMappingPickupChargeName?: Maybe<Scalars['String']['output']>;
  quickbooksMappingId?: Maybe<Scalars['String']['output']>;
  referenceNumberLabels: Array<ReferenceNumberLabelEntity>;
  requireDriverToCheckOffPackagesAtStop: Scalars['Boolean']['output'];
  services: Array<ServiceEntity>;
  shortCode?: Maybe<Scalars['String']['output']>;
  showChargesOnCustomerPortal: Scalars['Boolean']['output'];
  showEdiReferenceNumbersOnOrderPage: Scalars['Boolean']['output'];
  skipFuelCharge?: Maybe<Scalars['Boolean']['output']>;
  standardCarrierAlphaCode?: Maybe<Scalars['String']['output']>;
  stediPartnerId?: Maybe<Scalars['String']['output']>;
  tariffZones: Array<TariffZoneEntity>;
  /** @deprecated placeholder since the column was dropped from the table */
  thirdPartyContactType?: Maybe<ThirdPartyContactType>;
  totalCredits: Scalars['Float']['output'];
  totalDebits: Scalars['Float']['output'];
  totalInvoicesAmount: Scalars['Float']['output'];
  totalPayments: Scalars['Float']['output'];
  totalPostedInvoicesAmount: Scalars['Float']['output'];
  /** The transfer discount rate as a percentage out of 100 if it exists */
  transferDiscountRate?: Maybe<Scalars['Percent']['output']>;
  /** @deprecated Contact type is deprecated. The column has been dropped from the db */
  type: ContactType;
  unappliedCredits?: Maybe<Scalars['Float']['output']>;
  unappliedDebits: Scalars['Float']['output'];
  unappliedPayments: Scalars['Float']['output'];
  useCustomPackageSpecs: Scalars['Boolean']['output'];
  useCustomVehicleTypes: Scalars['Boolean']['output'];
  uuid: Scalars['String']['output'];
  vehicleTypes: Array<VehicleTypeEntity>;
};


export type CustomerContactEntityContactOpenInvoiceValueArgs = {
  findOpenInvoicesArgs?: InputMaybe<FindOpenInvoicesArgs>;
};


export type CustomerContactEntityContactOpenInvoiceValue0to30dArgs = {
  findOpenInvoicesArgs?: InputMaybe<FindOpenInvoicesArgs>;
};


export type CustomerContactEntityContactOpenInvoiceValue31to38dArgs = {
  findOpenInvoicesArgs?: InputMaybe<FindOpenInvoicesArgs>;
};


export type CustomerContactEntityContactOpenInvoiceValue39to45dArgs = {
  findOpenInvoicesArgs?: InputMaybe<FindOpenInvoicesArgs>;
};


export type CustomerContactEntityContactOpenInvoiceValue46to60dArgs = {
  findOpenInvoicesArgs?: InputMaybe<FindOpenInvoicesArgs>;
};


export type CustomerContactEntityContactOpenInvoiceValue61to75dArgs = {
  findOpenInvoicesArgs?: InputMaybe<FindOpenInvoicesArgs>;
};


export type CustomerContactEntityContactOpenInvoiceValueOver75dArgs = {
  findOpenInvoicesArgs?: InputMaybe<FindOpenInvoicesArgs>;
};

export type CustomerContactUpdateInput = {
  apiName?: InputMaybe<Scalars['String']['input']>;
  billingContactEmail?: InputMaybe<Scalars['String']['input']>;
  billingCycle?: InputMaybe<BillingCycleType>;
  billingCycleDuration?: InputMaybe<BillingCycleDuration>;
  billingPeriod?: InputMaybe<Scalars['Float']['input']>;
  billingRunStart?: InputMaybe<Scalars['DateTime']['input']>;
  businessDivisionUuid?: InputMaybe<Scalars['String']['input']>;
  contactReferenceNumber?: InputMaybe<Scalars['String']['input']>;
  creditHoldLimitInCents?: InputMaybe<Scalars['Float']['input']>;
  defaultAddressUuid?: InputMaybe<Scalars['String']['input']>;
  defaultContactPersonUuid?: InputMaybe<Scalars['String']['input']>;
  defaultDimFactor?: InputMaybe<Scalars['Float']['input']>;
  defaultFuelSurcharge?: InputMaybe<Scalars['Float']['input']>;
  defaultInboundEdiServiceUuid?: InputMaybe<Scalars['String']['input']>;
  defaultInboundOutboundEdiServiceUuid?: InputMaybe<Scalars['String']['input']>;
  defaultInvoiceDocumentsRequired?: InputMaybe<Array<DocumentType>>;
  defaultInvoiceDownloadDocuments?: InputMaybe<Array<DocumentType>>;
  defaultInvoiceEmailSubject?: InputMaybe<Scalars['String']['input']>;
  defaultInvoiceTermUuid?: InputMaybe<Scalars['String']['input']>;
  defaultInvoiceTransmissionMethod?: InputMaybe<InvoiceTransmissionMethod>;
  defaultInvoiceType?: InputMaybe<InvoiceType>;
  defaultLineHaulTariffChainId?: InputMaybe<Scalars['String']['input']>;
  defaultOrdinaryTariffChainId?: InputMaybe<Scalars['String']['input']>;
  defaultOutboundEdiServiceUuid?: InputMaybe<Scalars['String']['input']>;
  defaultPointToPointTariffChainId?: InputMaybe<Scalars['String']['input']>;
  defaultServicePickupsDeliveries?: InputMaybe<Scalars['Boolean']['input']>;
  defaultServiceUuid?: InputMaybe<Scalars['String']['input']>;
  defaultTransferTariffChainId?: InputMaybe<Scalars['String']['input']>;
  defaultUseTariff?: InputMaybe<Scalars['Boolean']['input']>;
  /** The discount rate to apply to non-flat rate freight charges for delivery stop types. Note that this is a percentage out of 100 */
  deliveryDiscountRate?: InputMaybe<Scalars['Percent']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  ediApplicationId?: InputMaybe<Scalars['String']['input']>;
  ediContactCode?: InputMaybe<Scalars['String']['input']>;
  enableCreditHold?: InputMaybe<Scalars['Boolean']['input']>;
  enableCustomerPortalOrderEntry?: InputMaybe<Scalars['Boolean']['input']>;
  freightChargeQuickbooksMappingId?: InputMaybe<Scalars['String']['input']>;
  fuelChargeQuickbooksMappingId?: InputMaybe<Scalars['String']['input']>;
  identifier?: InputMaybe<Scalars['String']['input']>;
  invoiceNotes?: InputMaybe<Scalars['String']['input']>;
  invoiceTimePeriodSplit?: InputMaybe<TimePeriod>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isPrepaidOnly?: InputMaybe<Scalars['Boolean']['input']>;
  isaId?: InputMaybe<Scalars['String']['input']>;
  /** The discount rate to apply to non-flat rate freight charges for line-haul. Note that this is a percentage out of 100 */
  lineHaulDiscountRate?: InputMaybe<Scalars['Percent']['input']>;
  logoDocumentUuid?: InputMaybe<Scalars['String']['input']>;
  logoTypeDocumentUuid?: InputMaybe<Scalars['String']['input']>;
  masterAccountUuid?: InputMaybe<Scalars['String']['input']>;
  maxDaysOutstanding?: InputMaybe<Scalars['Float']['input']>;
  miscCustomChargeQuickbooksMappingId?: InputMaybe<Scalars['String']['input']>;
  numberOfOrdersPerInvoice?: InputMaybe<Scalars['Float']['input']>;
  packageSpecIds?: InputMaybe<Array<Scalars['String']['input']>>;
  /** The discount rate to apply to non-flat rate freight charges for pickup stop types. Note that this is a percentage out of 100 */
  pickupDiscountRate?: InputMaybe<Scalars['Percent']['input']>;
  quickbooksDesktopAccountsReceivableId?: InputMaybe<Scalars['String']['input']>;
  quickbooksDesktopContactId?: InputMaybe<Scalars['String']['input']>;
  quickbooksFileMappingCustomerName?: InputMaybe<Scalars['String']['input']>;
  quickbooksFileMappingFreightChargeName?: InputMaybe<Scalars['String']['input']>;
  quickbooksFileMappingFuelChargeName?: InputMaybe<Scalars['String']['input']>;
  quickbooksFileMappingPickupChargeName?: InputMaybe<Scalars['String']['input']>;
  quickbooksMappingId?: InputMaybe<Scalars['String']['input']>;
  referenceNumberLabels?: InputMaybe<Array<Scalars['String']['input']>>;
  requireDriverToCheckOffPackagesAtStop?: InputMaybe<Scalars['Boolean']['input']>;
  serviceUuids?: InputMaybe<Array<Scalars['String']['input']>>;
  shortCode?: InputMaybe<Scalars['String']['input']>;
  showChargesOnCustomerPortal?: InputMaybe<Scalars['Boolean']['input']>;
  showEdiReferenceNumbersOnOrderPage?: InputMaybe<Scalars['Boolean']['input']>;
  skipFuelCharge?: InputMaybe<Scalars['Boolean']['input']>;
  standardCarrierAlphaCode?: InputMaybe<Scalars['String']['input']>;
  stediPartnerId?: InputMaybe<Scalars['String']['input']>;
  /** The discount rate to apply to non-flat rate freight charges for transfer stop types. Note that this is a percentage out of 100 */
  transferDiscountRate?: InputMaybe<Scalars['Percent']['input']>;
  type?: InputMaybe<ContactType>;
  useCustomPackageSpecs?: InputMaybe<Scalars['Boolean']['input']>;
  useCustomVehicleTypes?: InputMaybe<Scalars['Boolean']['input']>;
  uuid: Scalars['String']['input'];
  vehicleTypeUuids?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type CustomerFieldsEntity = {
  __typename?: 'CustomerFieldsEntity';
  businessDivisionUuid?: Maybe<Scalars['String']['output']>;
  /** equivalent to the ContactVehicleType table */
  customerVehicleTypes: Array<CustomerVehicleTypeEntity>;
  defaultAddressUuid?: Maybe<Scalars['String']['output']>;
  defaultDimFactor?: Maybe<Scalars['Float']['output']>;
  defaultFuelSurcharge?: Maybe<Scalars['Float']['output']>;
  defaultInboundEdiServiceUuid?: Maybe<Scalars['String']['output']>;
  defaultInboundOutboundEdiServiceUuid?: Maybe<Scalars['String']['output']>;
  defaultLineHaulTariffChainId?: Maybe<Scalars['String']['output']>;
  defaultOrdinaryTariffChainId?: Maybe<Scalars['String']['output']>;
  defaultOutboundEdiServiceUuid?: Maybe<Scalars['String']['output']>;
  defaultPointToPointTariffChainId?: Maybe<Scalars['String']['output']>;
  defaultServiceUuid?: Maybe<Scalars['String']['output']>;
  defaultTransferTariffChainId?: Maybe<Scalars['String']['output']>;
  defaultUseTariff: Scalars['Boolean']['output'];
  enableCustomerPortalOrderEntry: Scalars['Boolean']['output'];
  invoiceOrOrderIdentifier?: Maybe<Scalars['String']['output']>;
  isPrepaidOnly: Scalars['Boolean']['output'];
  referenceNumberLabels: Array<CustomerReferenceNumberLabelEntity>;
  services: Array<CustomerServiceEntity>;
  showEdiReferenceNumbersOnOrderPage: Scalars['Boolean']['output'];
  useCustomVehicleTypes: Scalars['Boolean']['output'];
};

export type CustomerNameSortInput = {
  direction: SortOrder;
  nulls: NullsOrder;
};

/** Review status of an order in the customer portal */
export enum CustomerPortalOrderReviewStatus {
  Approved = 'APPROVED',
  Pending = 'PENDING',
  Rejected = 'REJECTED'
}

/** A filter object that is used to filter the customer portal order review status. Each field in the filter object represents an operator. If there is more than one non-null field passed into the filter object, the condition will be a conjunction of the non-null field operator */
export type CustomerPortalOrderReviewStatusFilter = {
  /** Filters for records where the order review status matches the provided value */
  eq?: InputMaybe<CustomerPortalOrderReviewStatus>;
  /** Filters for records where the order review status is in the provided values */
  in?: InputMaybe<Array<CustomerPortalOrderReviewStatus>>;
  /** Filters for records where the order review status does not match the provided value */
  neq?: InputMaybe<CustomerPortalOrderReviewStatus>;
  /** Filters for records where the order review status is not in the provided values */
  nin?: InputMaybe<Array<CustomerPortalOrderReviewStatus>>;
};

export type CustomerReferenceNumberLabelEntity = {
  __typename?: 'CustomerReferenceNumberLabelEntity';
  name: Scalars['String']['output'];
};

export type CustomerReportArgs = {
  businessDivisionUuid?: InputMaybe<Scalars['String']['input']>;
  contactUuids?: InputMaybe<Array<Scalars['String']['input']>>;
  driverUuid?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  excludeMigratedOrders?: InputMaybe<Scalars['Boolean']['input']>;
  lastNumberOfDays?: InputMaybe<Scalars['Float']['input']>;
  lastNumberOfMonths?: InputMaybe<Scalars['Float']['input']>;
  lastNumberOfWeeks?: InputMaybe<Scalars['Float']['input']>;
  orderStatuses: Array<OrderStatus>;
  reportRevenueType?: InputMaybe<ReportRevenueType>;
  reportStatistics: Array<ReportStatistic>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  stopTypes: Array<PickupOrDelivery>;
  terminalUuid?: InputMaybe<Scalars['String']['input']>;
};

export type CustomerReportBucketEntity = {
  __typename?: 'CustomerReportBucketEntity';
  customChargeRevenue: Scalars['Float']['output'];
  deliveryRevenue: Scalars['Float']['output'];
  displayName: Scalars['String']['output'];
  freightRevenue: Scalars['Float']['output'];
  fuelRevenue: Scalars['Float']['output'];
  lineHaulRevenue: Scalars['Float']['output'];
  numberOfOrders: Scalars['Float']['output'];
  numberOfPackages: Scalars['Float']['output'];
  pickupRevenue: Scalars['Float']['output'];
  recoveryRevenue: Scalars['Float']['output'];
  specialRevenue: Scalars['Float']['output'];
  surchargeRevenue: Scalars['Float']['output'];
  totalRevenue: Scalars['Float']['output'];
  totalWeight: Scalars['Float']['output'];
  transferRevenue: Scalars['Float']['output'];
  uuid: Scalars['String']['output'];
};

export type CustomerServiceEntity = {
  __typename?: 'CustomerServiceEntity';
  uuid: Scalars['String']['output'];
};

export type CustomerVehicleTypeEntity = {
  __typename?: 'CustomerVehicleTypeEntity';
  id: Scalars['String']['output'];
  vehicleTypeUuid: Scalars['String']['output'];
};

export type DateFilter = {
  filterOperator?: InputMaybe<FilterOperator>;
  filterType: DateFilterType;
  value: Scalars['DateTime']['input'];
};

/** Enum of predefined options including static dates and relative options(today, tomorrow, yesterday, before today). */
export enum DateFilterOptionV2 {
  BeforeToday = 'BEFORE_TODAY',
  LastXDays = 'LAST_X_DAYS',
  Static = 'STATIC',
  Today = 'TODAY',
  Tomorrow = 'TOMORROW',
  Yesterday = 'YESTERDAY'
}

export type DateFilterStartEnd = {
  endFilterValue?: InputMaybe<Scalars['DateTime']['input']>;
  filterOperator?: InputMaybe<FilterOperator>;
  startFilterValue?: InputMaybe<Scalars['DateTime']['input']>;
};

export enum DateFilterType {
  IsAfter = 'IS_AFTER',
  IsBefore = 'IS_BEFORE'
}

/** A filter object that is used to filter a date field. Each field in the filter object represents an operator. If there is more than one non-null field passed into the filter object, the condition will be a conjunction of the non-null field operator */
export type DateFilterV2 = {
  /** Filters for records where the relevant date field is between the provided date range */
  between?: InputMaybe<DateRangeFilterInput>;
  /** Filters for records where the relevant date field is equal to the provided date value. Deprecated: Use eqV2 instead. */
  eq?: InputMaybe<Scalars['DateTime']['input']>;
  /** Filters for records where the relevant date field is equal to a relative date value. eqV2 is to allow for smooth transition from only string dates to the new FilterDateInput system */
  eqV2?: InputMaybe<DateFilterValueInput>;
  /** Filters for records where the relevant date field is greater than the provided date value */
  gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** Filters for records where the relevant date field is greater than or equal to the provided date value */
  gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Filters for records where the relevant date field is in the provided date values */
  in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  /** Filters for records where the relevant date field is blank */
  isBlank?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filters for records where the relevant date field is not blank */
  isNotBlank?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filters for records where the relevant date field is less than the provided date value */
  lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** Filters for records where the relevant date field is less than or equal to the provided date value */
  lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Filters for records where the relevant date field is not equal to the provided date value */
  neq?: InputMaybe<Scalars['DateTime']['input']>;
  /** Filters for records where the relevant date field is not in the provided date values */
  nin?: InputMaybe<Array<Scalars['DateTime']['input']>>;
};

/** Date filter fields for the findLineHaulManifestsV2 query */
export type DateFilterV2Simple = {
  /** Filters for records where the relevant date field is equal to the provided date value. Deprecated: Use eqV2 instead. */
  eq?: InputMaybe<Scalars['DateTime']['input']>;
};

/** Object that represents the filtering input for either a static date option or a relative date option. Static dates are literal dates stored (e.g., "2024-03-15"). Relative dates are those stored as something akin to "today" or "yesterday". */
export type DateFilterValueInput = {
  /** Date value for STATIC options, null otherwise */
  date?: InputMaybe<Scalars['DateTime']['input']>;
  /** Enum of predefined options including static dates and relative options(today, tomorrow, yesterday, before today) */
  dateFilterOption?: InputMaybe<DateFilterOptionV2>;
  /** Number of days to offset the date. Only used for LAST_X_DAYS. */
  offsetDays: Scalars['Int']['input'];
};

export type DateMarkedOnHandSortInput = {
  direction: SortOrder;
  nulls: NullsOrder;
};

/** Object that represents the filtering input for a date range that is inclusive on both ends */
export type DateRangeFilterInput = {
  /** The end date of the inclusive date range */
  gte: Scalars['DateTime']['input'];
  /** The start date of the inclusive date range */
  lte: Scalars['DateTime']['input'];
};

export enum DayOfWeekAll {
  Friday = 'FRIDAY',
  Monday = 'MONDAY',
  Saturday = 'SATURDAY',
  Sunday = 'SUNDAY',
  Thursday = 'THURSDAY',
  Tuesday = 'TUESDAY',
  Wednesday = 'WEDNESDAY'
}

export enum DeadlineDateFilter {
  Overdue = 'OVERDUE',
  Today = 'TODAY',
  Tomorrow = 'TOMORROW'
}

export enum DeadlineType {
  DueBy = 'DUE_BY',
  DueOn = 'DUE_ON'
}

export type DefaultAppointmentTextOutput = {
  __typename?: 'DefaultAppointmentTextOutput';
  appointmentUuid: Scalars['String']['output'];
  message?: Maybe<Scalars['String']['output']>;
};

export type DeleteAccessorialDateRangeConfigInput = {
  uuid: Scalars['String']['input'];
};

export type DeleteContactCommentInput = {
  /** The UUID of the contact comment to be deleted */
  uuid: Scalars['String']['input'];
};

export type DeleteContactCommentOutput = DeleteContactCommentSuccessOutput | MutationErrorOutput;

export type DeleteContactCommentSuccessOutput = {
  __typename?: 'DeleteContactCommentSuccessOutput';
  success: Scalars['Boolean']['output'];
};

export type DeleteContactEmailInput = {
  uuid: Scalars['String']['input'];
};

export type DeleteFeatureFlagCompanyOverrideInput = {
  uuid: Scalars['String']['input'];
};

export type DeleteFeatureFlagUserOverrideInput = {
  uuid: Scalars['String']['input'];
};

export type DeleteFuelProfileDateRangeInput = {
  uuid: Scalars['String']['input'];
};

export type DeleteFuelProfileDateRangeOutput = {
  __typename?: 'DeleteFuelProfileDateRangeOutput';
  success: Scalars['Boolean']['output'];
};

export type DeleteGeneralLedgerCodeOutput = DeleteGeneralLedgerCodeSuccessOutput | MutationErrorOutput;

export type DeleteGeneralLedgerCodeSuccessOutput = {
  __typename?: 'DeleteGeneralLedgerCodeSuccessOutput';
  id: Scalars['String']['output'];
};

export type DeleteInventoryItemsInput = {
  itemUuid: Scalars['String']['input'];
  /** The number of inventory items to be deleted for the specified storage order */
  quantity: Scalars['Int']['input'];
  storageOrderUuid: Scalars['String']['input'];
};

export type DeleteInventoryItemsOutput = {
  __typename?: 'DeleteInventoryItemsOutput';
  /** The number of inventory items that were deleted */
  quantity: Scalars['Int']['output'];
};

export type DeleteOrderCommentInput = {
  /** The UUID of the order comment to be deleted */
  uuid: Scalars['String']['input'];
};

export type DeleteOrderCommentOutput = DeleteOrderCommentSuccessOutput | MutationErrorOutput;

export type DeleteOrderCommentSuccessOutput = {
  __typename?: 'DeleteOrderCommentSuccessOutput';
  success: Scalars['Boolean']['output'];
};

export type DeletePermissionInput = {
  uuid: Scalars['String']['input'];
};

export type DeletePermissionOutput = {
  __typename?: 'DeletePermissionOutput';
  success: Scalars['Boolean']['output'];
};

export type DeleteRoleInput = {
  uuid: Scalars['String']['input'];
};

export type DeleteRoleOutput = {
  __typename?: 'DeleteRoleOutput';
  success: Scalars['Boolean']['output'];
};

export type DeleteSchemaRunInput = {
  uuid: Scalars['String']['input'];
};

export type DeleteSlotsFromRouteInput = {
  emitMultiplayerEvent?: InputMaybe<Scalars['Boolean']['input']>;
  routeSlotUuids: Array<Scalars['String']['input']>;
  routeUuid: Scalars['String']['input'];
};

/** The expected input for deleting a stop attempt */
export type DeleteStopAttemptInput = {
  uuid: Scalars['String']['input'];
};

export type DeleteStopAttemptOutput = DeleteStopAttemptSuccessOutput | MutationErrorOutput;

/** The output of a successful stop attempt deletion */
export type DeleteStopAttemptSuccessOutput = {
  __typename?: 'DeleteStopAttemptSuccessOutput';
  success: Scalars['Boolean']['output'];
};

export type DeleteStorageOrderInput = {
  /** The UUID of the storage order to delete */
  uuid: Scalars['String']['input'];
};

export type DeleteStorageOrderOutput = {
  __typename?: 'DeleteStorageOrderOutput';
  success: Scalars['Boolean']['output'];
};

export type DeleteStorageOrdersInput = {
  /** The UUIDs of the storage order to delete */
  uuids: Array<Scalars['String']['input']>;
};

export type DeleteStorageOrdersOutput = {
  __typename?: 'DeleteStorageOrdersOutput';
  success: Scalars['Boolean']['output'];
};

export type DeleteStorageUnitInput = {
  uuid: Scalars['String']['input'];
};

export type DeleteStorageUnitOutput = {
  __typename?: 'DeleteStorageUnitOutput';
  success: Scalars['Boolean']['output'];
};

export type DeleteTariffLocationInput = {
  uuid: Scalars['String']['input'];
};

export type DeleteTariffLocationOutput = {
  __typename?: 'DeleteTariffLocationOutput';
  tariffLocation: TariffLocationEntity;
};

export type DeleteTerminalLanesInput = {
  /** The IDs of the TerminalLaneEntities to delete. */
  terminalLaneIds: Array<Scalars['String']['input']>;
};

export type DeleteTerminalLanesOutput = DeleteTerminalLanesSuccessOutput | MutationErrorOutput;

export type DeleteTerminalLanesSuccessOutput = {
  __typename?: 'DeleteTerminalLanesSuccessOutput';
  /** All of the company’s terminal lanes after deleting */
  terminalLanes: Array<TerminalLaneEntity>;
};

export type DeleteUserInput = {
  uuid: Scalars['String']['input'];
};

export type DeleteWarehouseLocationInput = {
  /** The UUID of the warehouse location to be deleted */
  uuid: Scalars['String']['input'];
};

export type DeleteWarehouseLocationOutput = {
  __typename?: 'DeleteWarehouseLocationOutput';
  success: Scalars['Boolean']['output'];
};

export enum DependentSettlementBillingMethod {
  AutoCalculate = 'AUTO_CALCULATE',
  FlatRate = 'FLAT_RATE',
  Percentage = 'PERCENTAGE'
}

export type DestinationDetailsSortInput = {
  direction: SortOrder;
  nulls: NullsOrder;
};

export enum DestinationStopType {
  Delivery = 'DELIVERY',
  PartnerPickup = 'PARTNER_PICKUP',
  Transfer = 'TRANSFER'
}

export type DestinationTerminalSortInput = {
  direction: SortOrder;
  nulls: NullsOrder;
};

export type DetachDocumentsFromShipmentsInput = {
  uuids: Array<Scalars['String']['input']>;
};

export type DimWeightSortInput = {
  direction: SortOrder;
  nulls: NullsOrder;
};

export type DimensionalWeightCreateInput = {
  factor: Scalars['Float']['input'];
  name: Scalars['String']['input'];
  type: DimensionalWeightFactorType;
};

export enum DimensionalWeightFactorType {
  CompanyLevel = 'COMPANY_LEVEL',
  ContactSpecific = 'CONTACT_SPECIFIC'
}

export type DispatchTableColorEntity = {
  __typename?: 'DispatchTableColorEntity';
  active: Scalars['Boolean']['output'];
  appointmentEndWithinMinutes?: Maybe<Scalars['Int']['output']>;
  appointmentStartWithinMinutes?: Maybe<Scalars['Int']['output']>;
  color: Scalars['String']['output'];
  deadlineDateFilter?: Maybe<DeadlineDateFilter>;
  dispatchViewId?: Maybe<Scalars['String']['output']>;
  fields: Array<DispatchTableColorField>;
  hasAppointmentDate?: Maybe<Scalars['Boolean']['output']>;
  isSpecial?: Maybe<Scalars['Boolean']['output']>;
  service?: Maybe<ServiceEntity>;
  uuid: Scalars['String']['output'];
};

export enum DispatchTableColorField {
  AppointmentEndWithin = 'APPOINTMENT_END_WITHIN',
  AppointmentPassed = 'APPOINTMENT_PASSED',
  AppointmentStartWithin = 'APPOINTMENT_START_WITHIN',
  DeadlinePassed = 'DEADLINE_PASSED',
  DeadlineToday = 'DEADLINE_TODAY',
  DeadlineTomorrow = 'DEADLINE_TOMORROW',
  HasAppointmentDate = 'HAS_APPOINTMENT_DATE',
  IsSpecial = 'IS_SPECIAL',
  Service = 'SERVICE'
}

export type DispatchTableColorUpsertInput = {
  active: Scalars['Boolean']['input'];
  /** The number of minutes within the end of the appointment for the rule to apply */
  appointmentEndWithinMinutes?: InputMaybe<Scalars['Int']['input']>;
  /** The number of minutes within the start of the appointment for the rule to apply */
  appointmentStartWithinMinutes?: InputMaybe<Scalars['Int']['input']>;
  color: Scalars['String']['input'];
  deadlineDateFilter?: InputMaybe<DeadlineDateFilter>;
  dispatchViewId?: InputMaybe<Scalars['String']['input']>;
  /** The fields that are included in the rule, all joined in a conjunction (AND operator) when determining if a rule applies to a stop */
  fields?: InputMaybe<Array<DispatchTableColorField>>;
  hasAppointmentDate?: InputMaybe<Scalars['Boolean']['input']>;
  isSpecial?: InputMaybe<Scalars['Boolean']['input']>;
  serviceUuid?: InputMaybe<Scalars['String']['input']>;
};

export enum DispatchTableField {
  Address = 'ADDRESS',
  AddressType = 'ADDRESS_TYPE',
  Appointment = 'APPOINTMENT',
  AppointmentDate = 'APPOINTMENT_DATE',
  AppointmentOptionsProposed = 'APPOINTMENT_OPTIONS_PROPOSED',
  AppointmentRequired = 'APPOINTMENT_REQUIRED',
  AppointmentScheduled = 'APPOINTMENT_SCHEDULED',
  AppointmentTime = 'APPOINTMENT_TIME',
  BusinessDivision = 'BUSINESS_DIVISION',
  CanDispatch = 'CAN_DISPATCH',
  City = 'CITY',
  Consignee = 'CONSIGNEE',
  Customer = 'CUSTOMER',
  Dims = 'DIMS',
  DueDate = 'DUE_DATE',
  Eta = 'ETA',
  HasAppointment = 'HAS_APPOINTMENT',
  InboundCity = 'INBOUND_CITY',
  InboundMethod = 'INBOUND_METHOD',
  InboundName = 'INBOUND_NAME',
  InboundPaperwork = 'INBOUND_PAPERWORK',
  InboundTerminal = 'INBOUND_TERMINAL',
  InboundZip = 'INBOUND_ZIP',
  Mawb = 'MAWB',
  OnHand = 'ON_HAND',
  OrderName = 'ORDER_NAME',
  OrderNotes = 'ORDER_NOTES',
  OrderNumber = 'ORDER_NUMBER',
  OrderStatus = 'ORDER_STATUS',
  OutboundCity = 'OUTBOUND_CITY',
  OutboundMethod = 'OUTBOUND_METHOD',
  OutboundName = 'OUTBOUND_NAME',
  OutboundPaperwork = 'OUTBOUND_PAPERWORK',
  OutboundTerminal = 'OUTBOUND_TERMINAL',
  OutboundZip = 'OUTBOUND_ZIP',
  PieceCount = 'PIECE_COUNT',
  PrimaryConsignee = 'PRIMARY_CONSIGNEE',
  Refused = 'REFUSED',
  RefNumber = 'REF_NUMBER',
  RouteName = 'ROUTE_NAME',
  ServiceDate = 'SERVICE_DATE',
  ServiceLevel = 'SERVICE_LEVEL',
  ServiceTime = 'SERVICE_TIME',
  Special = 'SPECIAL',
  SpecialInstructions = 'SPECIAL_INSTRUCTIONS',
  State = 'STATE',
  StopType = 'STOP_TYPE',
  Tags = 'TAGS',
  Terminal = 'TERMINAL',
  TotalCharges = 'TOTAL_CHARGES',
  VehicleTypeName = 'VEHICLE_TYPE_NAME',
  Weight = 'WEIGHT',
  ZipCode = 'ZIP_CODE'
}

export type DispatchViewCreateInput = {
  dispatchViewLayoutPositions?: InputMaybe<Scalars['JSON']['input']>;
  name: Scalars['String']['input'];
  numberOfStops?: InputMaybe<Scalars['Int']['input']>;
  routeCardStopTableColumnWidths?: InputMaybe<Scalars['JSON']['input']>;
  routeCardStopTableFields?: InputMaybe<Array<DispatchTableField>>;
  routeCardWidth?: InputMaybe<Scalars['Int']['input']>;
  showCompleteStops?: InputMaybe<Scalars['Boolean']['input']>;
  tabIndex?: InputMaybe<Scalars['Int']['input']>;
  useMinimizedAppointmentTime?: InputMaybe<Scalars['Boolean']['input']>;
};

export type DispatchViewCreateOutput = DispatchViewCreateSuccessOutput | MutationErrorOutput;

export type DispatchViewCreateSuccessOutput = {
  __typename?: 'DispatchViewCreateSuccessOutput';
  dispatchView: DispatchViewEntity;
};

export type DispatchViewEntity = {
  __typename?: 'DispatchViewEntity';
  dispatchTableColors: Array<DispatchTableColorEntity>;
  dispatchViewLayoutPositions: Scalars['JSON']['output'];
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  numberOfStops: Scalars['Int']['output'];
  routeCardStopTableColumnWidths?: Maybe<Scalars['JSON']['output']>;
  routeCardStopTableFields: Array<DispatchTableField>;
  routeCardWidth: Scalars['Int']['output'];
  showCompleteStops: Scalars['Boolean']['output'];
  tabIndex: Scalars['Int']['output'];
  useMinimizedAppointmentTime: Scalars['Boolean']['output'];
};

export type DispatchViewUpdateInput = {
  dispatchViewLayoutPositions?: InputMaybe<Scalars['JSON']['input']>;
  id: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  numberOfStops?: InputMaybe<Scalars['Int']['input']>;
  routeCardStopTableColumnWidths?: InputMaybe<Scalars['JSON']['input']>;
  routeCardStopTableFields?: InputMaybe<Array<DispatchTableField>>;
  routeCardWidth?: InputMaybe<Scalars['Int']['input']>;
  showCompleteStops?: InputMaybe<Scalars['Boolean']['input']>;
  tabIndex?: InputMaybe<Scalars['Int']['input']>;
  useMinimizedAppointmentTime?: InputMaybe<Scalars['Boolean']['input']>;
};

export type DispatchViewUpdateOutput = DispatchViewUpdateSuccessOutput | MutationErrorOutput;

export type DispatchViewUpdateSuccessOutput = {
  __typename?: 'DispatchViewUpdateSuccessOutput';
  dispatchView: DispatchViewEntity;
};

export type DispatchableAgentEntity = {
  __typename?: 'DispatchableAgentEntity';
  /** The default driver for this agent */
  defaultDriver: DriverEntity;
  name: Scalars['String']['output'];
  /** Non-default drivers that are dispatchable for this agent */
  nonDefaultDrivers: Array<DriverEntity>;
  uuid: Scalars['String']['output'];
};

export type DockScanReportInput = {
  contactUuid?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  terminalUuid?: InputMaybe<Scalars['String']['input']>;
};

export type DockScanReportOutput = {
  __typename?: 'DockScanReportOutput';
  rows: Array<DockScanReportRow>;
};

export type DockScanReportRow = {
  __typename?: 'DockScanReportRow';
  barcode: Scalars['String']['output'];
  consigneeName?: Maybe<Scalars['String']['output']>;
  contactName?: Maybe<Scalars['String']['output']>;
  masterAirwayBillOfLadingNumber?: Maybe<Scalars['String']['output']>;
  osdReason?: Maybe<Scalars['String']['output']>;
  packagesExpected: Scalars['Int']['output'];
  pieceMarkedOnHandOrdinal?: Maybe<Scalars['Int']['output']>;
  pieceName?: Maybe<Scalars['String']['output']>;
  piecesExpected: Scalars['Int']['output'];
  piecesOnHand: Scalars['Int']['output'];
  /** @deprecated Use scan.barcode instead */
  rawBarcode?: Maybe<Scalars['String']['output']>;
  scan: ScanEntity;
  scanType: ScanType;
  scanUuid: Scalars['String']['output'];
  scannedAt: Scalars['DateTime']['output'];
  serviceDate?: Maybe<Scalars['DateTime']['output']>;
  /** The service date of the stop as a PlainDate. See https://www.notion.so/Service-Date-dc8ae149b6a54bb69404aecf92176287 for details. */
  serviceDateV2?: Maybe<PlainDate>;
  shipperBillOfLadingNumber?: Maybe<Scalars['String']['output']>;
  terminalCode?: Maybe<Scalars['String']['output']>;
};

export type DocumentConnectInput = {
  uuid: Scalars['String']['input'];
};

export type DocumentCreateInput = {
  bucket: Scalars['String']['input'];
  companyUuid?: InputMaybe<Scalars['String']['input']>;
  dateUploadedFor?: InputMaybe<Scalars['DateTime']['input']>;
  driverFormTemplateUuid?: InputMaybe<Scalars['String']['input']>;
  fileName: Scalars['String']['input'];
  fileType: Scalars['String']['input'];
  freightSnapTransactionUuid?: InputMaybe<Scalars['String']['input']>;
  invoiceUuid?: InputMaybe<Scalars['String']['input']>;
  key: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  orderUuid?: InputMaybe<Scalars['String']['input']>;
  pageNumber?: InputMaybe<Scalars['Int']['input']>;
  region?: InputMaybe<Scalars['String']['input']>;
  shipmentUuid?: InputMaybe<Scalars['String']['input']>;
  /** The UUID of the storage order to attach the document to */
  storageOrderUuid?: InputMaybe<Scalars['String']['input']>;
  terminalUuid?: InputMaybe<Scalars['String']['input']>;
  thumbnailKey?: InputMaybe<Scalars['String']['input']>;
  type: DocumentType;
  /** A combination of the order billing party and ordinal separated by a hyphen. Used in the EOD flow */
  uniqueOrderIdentifier?: InputMaybe<Scalars['String']['input']>;
  uploadOrdinal?: InputMaybe<Scalars['Int']['input']>;
  uploadedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type DocumentEntity = {
  __typename?: 'DocumentEntity';
  bucket: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  dateUploadedFor?: Maybe<Scalars['DateTime']['output']>;
  driverFormTemplate?: Maybe<DriverSignableFormTemplateEntity>;
  fileName: Scalars['String']['output'];
  fileType: Scalars['String']['output'];
  invoice?: Maybe<InvoiceEntity>;
  isDeleted: Scalars['Boolean']['output'];
  key: Scalars['String']['output'];
  name?: Maybe<Scalars['String']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  order?: Maybe<OrderEntity>;
  pageNumber?: Maybe<Scalars['Int']['output']>;
  preSignedGetUrl: Scalars['String']['output'];
  region: Scalars['String']['output'];
  shipment?: Maybe<OrderEntity>;
  thumbnailKey?: Maybe<Scalars['String']['output']>;
  type: DocumentType;
  updatedAt: Scalars['DateTime']['output'];
  uploadOrdinal?: Maybe<Scalars['Int']['output']>;
  uploadedAt?: Maybe<Scalars['DateTime']['output']>;
  uuid: Scalars['String']['output'];
};

export type DocumentForSigningInput = {
  documentUuid: Scalars['String']['input'];
  orderUuid: Scalars['String']['input'];
};

export type DocumentForSigningOutput = {
  __typename?: 'DocumentForSigningOutput';
  document?: Maybe<DocumentEntity>;
  errorMessage?: Maybe<Scalars['String']['output']>;
};

export enum DocumentType {
  AbiNotes = 'ABI_NOTES',
  AccountingReport = 'ACCOUNTING_REPORT',
  ArrivalNotice = 'ARRIVAL_NOTICE',
  BackupEmail = 'BACKUP_EMAIL',
  BillOfLading = 'BILL_OF_LADING',
  CheckCopy = 'CHECK_COPY',
  CommercialInvoice = 'COMMERCIAL_INVOICE',
  CoverPage = 'COVER_PAGE',
  CustomDriverFormSignature = 'CUSTOM_DRIVER_FORM_SIGNATURE',
  DamageReport = 'DAMAGE_REPORT',
  DeliveryAlert = 'DELIVERY_ALERT',
  DeliveryReceipt = 'DELIVERY_RECEIPT',
  DeliverySignature = 'DELIVERY_SIGNATURE',
  DigitalProofOfDelivery = 'DIGITAL_PROOF_OF_DELIVERY',
  DigitalProofOfPickup = 'DIGITAL_PROOF_OF_PICKUP',
  EndOfDayDocument = 'END_OF_DAY_DOCUMENT',
  Hawb = 'HAWB',
  Hazmat = 'HAZMAT',
  ItemizedTransportDocument = 'ITEMIZED_TRANSPORT_DOCUMENT',
  Manifest = 'MANIFEST',
  Mawb = 'MAWB',
  OrderDocument = 'ORDER_DOCUMENT',
  OsdPhoto = 'OSD_PHOTO',
  Other = 'OTHER',
  OvernightSlip = 'OVERNIGHT_SLIP',
  PickupAlert = 'PICKUP_ALERT',
  PickupReceiptForEsign = 'PICKUP_RECEIPT_FOR_ESIGN',
  PickupSignature = 'PICKUP_SIGNATURE',
  PodReport = 'POD_REPORT',
  ProofOfDelivery = 'PROOF_OF_DELIVERY',
  ProofOfDeliveryScanned = 'PROOF_OF_DELIVERY_SCANNED',
  Rejection = 'REJECTION',
  ShipmentPhoto = 'SHIPMENT_PHOTO',
  StorageUnitPhoto = 'STORAGE_UNIT_PHOTO',
  TransferManifest = 'TRANSFER_MANIFEST',
  TransportApprovalCertificate = 'TRANSPORT_APPROVAL_CERTIFICATE',
  VoidedCheck = 'VOIDED_CHECK'
}

export type DocumentUpdateInput = {
  bucket?: InputMaybe<Scalars['String']['input']>;
  dateUploadedFor?: InputMaybe<Scalars['DateTime']['input']>;
  fileName?: InputMaybe<Scalars['String']['input']>;
  fileType?: InputMaybe<Scalars['String']['input']>;
  freightSnapTransactionUuid?: InputMaybe<Scalars['String']['input']>;
  invoiceUuid?: InputMaybe<Scalars['String']['input']>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  key?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  orderUuid?: InputMaybe<Scalars['String']['input']>;
  pageNumber?: InputMaybe<Scalars['Int']['input']>;
  region?: InputMaybe<Scalars['String']['input']>;
  shipmentUuid?: InputMaybe<Scalars['String']['input']>;
  thumbnailKey?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<DocumentType>;
  uploadOrdinal?: InputMaybe<Scalars['Int']['input']>;
  uploadedAt?: InputMaybe<Scalars['DateTime']['input']>;
  uuid?: InputMaybe<Scalars['String']['input']>;
};

export type DocumentUpsertInput = {
  bucket: Scalars['String']['input'];
  dateUploadedFor?: InputMaybe<Scalars['DateTime']['input']>;
  fileName: Scalars['String']['input'];
  fileType: Scalars['String']['input'];
  invoiceUuid?: InputMaybe<Scalars['String']['input']>;
  isDeleted: Scalars['Boolean']['input'];
  key: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  orderUuid?: InputMaybe<Scalars['String']['input']>;
  pageNumber?: InputMaybe<Scalars['Int']['input']>;
  region: Scalars['String']['input'];
  storageOrderUuid?: InputMaybe<Scalars['String']['input']>;
  thumbnailKey?: InputMaybe<Scalars['String']['input']>;
  type: DocumentType;
  uploadOrdinal?: InputMaybe<Scalars['Int']['input']>;
  uploadedAt?: InputMaybe<Scalars['DateTime']['input']>;
  uuid: Scalars['String']['input'];
};

export type DownloadInvoicesInput = {
  invoicesToDownload: Array<InvoiceToSend>;
};

export type DownloadInvoicesOutput = {
  __typename?: 'DownloadInvoicesOutput';
  combinedDocument?: Maybe<DocumentEntity>;
  documents: Array<DocumentEntity>;
  zipDocument?: Maybe<DocumentEntity>;
};

export type DriverCompletedStopsEntity = {
  __typename?: 'DriverCompletedStopsEntity';
  /** @deprecated Use arrivedAt in stopDriverMaps */
  arrivedAt?: Maybe<Scalars['DateTime']['output']>;
  /** @deprecated Use completedAt in stopDriverMaps */
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  /** @deprecated Use driver in stopDriverMaps */
  driverFirstName?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use driver in stopDriverMaps */
  driverLastName?: Maybe<Scalars['String']['output']>;
  stopDriverMaps: Array<StopDriverMapForCompletedStopsEntity>;
  /** @deprecated Use stopUuid in stopDriverMaps */
  stopUuid?: Maybe<Scalars['String']['output']>;
};

export type DriverCreateInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  address?: InputMaybe<AddressUpsertInput>;
  defaultFuelSettlementPercentageRate?: InputMaybe<Scalars['Float']['input']>;
  defaultLineHaulTariffChainId?: InputMaybe<Scalars['String']['input']>;
  defaultOrdinaryTariffChainId?: InputMaybe<Scalars['String']['input']>;
  defaultPointToPointTariffChainId?: InputMaybe<Scalars['String']['input']>;
  defaultTransferTariffChainId?: InputMaybe<Scalars['String']['input']>;
  driverPayType?: InputMaybe<DriverPayType>;
  /** The IDs of the DriverQualifications the driver will have. This will replace any existing DriverQualifications. */
  driverQualificationIds?: InputMaybe<Array<Scalars['String']['input']>>;
  driverReferenceNumber?: InputMaybe<Scalars['String']['input']>;
  driverType?: InputMaybe<DriverType>;
  emailAddress?: InputMaybe<Scalars['String']['input']>;
  equipmentUuid?: InputMaybe<Scalars['String']['input']>;
  firstName: Scalars['String']['input'];
  flatRate?: InputMaybe<Scalars['Float']['input']>;
  fuelCardNumber: Scalars['String']['input'];
  hourlyRate?: InputMaybe<Scalars['Float']['input']>;
  lastName: Scalars['String']['input'];
  notes: Scalars['String']['input'];
  password?: InputMaybe<Scalars['String']['input']>;
  perMileRate?: InputMaybe<Scalars['Float']['input']>;
  percentGrossRevenueRate?: InputMaybe<Scalars['Float']['input']>;
  phoneNumber: Scalars['String']['input'];
  sendRouteUpdateEmails?: InputMaybe<Scalars['Boolean']['input']>;
  terminalUuid?: InputMaybe<Scalars['String']['input']>;
};

export type DriverDailyLogReportPdfInput = {
  completedStopsOnly: Scalars['Boolean']['input'];
  driverUuids?: InputMaybe<Array<Scalars['String']['input']>>;
  includeLinehaulStops?: InputMaybe<Scalars['Boolean']['input']>;
  onlyEligibleForSettlement: Scalars['Boolean']['input'];
  serviceEndDate?: InputMaybe<Scalars['DateTime']['input']>;
  serviceStartDate?: InputMaybe<Scalars['DateTime']['input']>;
};

export type DriverEntity = {
  __typename?: 'DriverEntity';
  active: Scalars['Boolean']['output'];
  address?: Maybe<AddressEntity>;
  agent?: Maybe<AgentFieldsEntity>;
  agentId?: Maybe<Scalars['String']['output']>;
  company: CompanyEntity;
  currentLeg?: Maybe<LegEntity>;
  defaultFuelSettlementPercentageRate?: Maybe<Scalars['Float']['output']>;
  defaultLineHaulTariffChainId?: Maybe<Scalars['String']['output']>;
  defaultOrdinaryTariffChainId?: Maybe<Scalars['String']['output']>;
  defaultPointToPointTariffChainId?: Maybe<Scalars['String']['output']>;
  defaultTransferTariffChainId?: Maybe<Scalars['String']['output']>;
  defaultVehicle?: Maybe<EquipmentEntity>;
  driverPayType?: Maybe<DriverPayType>;
  driverReferenceNumber?: Maybe<Scalars['String']['output']>;
  driverType?: Maybe<DriverType>;
  emailAddress?: Maybe<Scalars['String']['output']>;
  expoPushTokens?: Maybe<Array<Scalars['String']['output']>>;
  /** @deprecated Use user.name instead. For backwards compatibility, returns the first space-separated word of the user.name field. */
  firstName: Scalars['String']['output'];
  flatRate?: Maybe<Scalars['Float']['output']>;
  fuelCardNumber: Scalars['String']['output'];
  hourlyRate?: Maybe<Scalars['Float']['output']>;
  lastCompletedLeg?: Maybe<LegEntity>;
  /** @deprecated Use user.name instead. For backwards compatibility, returns everything after the first space-separated word of the user.name field. */
  lastName: Scalars['String']['output'];
  legs: Array<LegEntity>;
  mobileCoordsLastUpdatedAt?: Maybe<Scalars['DateTime']['output']>;
  mobilePhoneLatitude?: Maybe<Scalars['Float']['output']>;
  mobilePhoneLongitude?: Maybe<Scalars['Float']['output']>;
  notes: Scalars['String']['output'];
  password?: Maybe<Scalars['String']['output']>;
  perMileRate?: Maybe<Scalars['Float']['output']>;
  percentGrossRevenueRate?: Maybe<Scalars['Float']['output']>;
  phoneNumber: Scalars['String']['output'];
  qualifications: Array<DriverQualificationEntity>;
  route?: Maybe<RouteEntity>;
  sendRouteUpdateEmails: Scalars['Boolean']['output'];
  status: DriverStatus;
  terminal?: Maybe<TerminalEntity>;
  /** The user associated with the driver. All drivers have a user and store personal info (i.e. name, email, phone #) on the user */
  user: UserEntity;
  uuid: Scalars['String']['output'];
};


export type DriverEntityLastCompletedLegArgs = {
  endDate: Scalars['DateTime']['input'];
  startDate: Scalars['DateTime']['input'];
};


export type DriverEntityLegsArgs = {
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
};


export type DriverEntityRouteArgs = {
  date: Scalars['DateTime']['input'];
};

export type DriverEquipmentConstraintInput = {
  driverUuid: Scalars['String']['input'];
  endTime?: InputMaybe<Scalars['DateTime']['input']>;
  equipmentUuid?: InputMaybe<Scalars['String']['input']>;
  maxPieces?: InputMaybe<Scalars['Int']['input']>;
  maxVolume?: InputMaybe<Scalars['Volume']['input']>;
  maxWeight?: InputMaybe<Scalars['Mass']['input']>;
  startTime?: InputMaybe<Scalars['DateTime']['input']>;
};

export enum DriverLocationUpdateSource {
  MobileBackground = 'MOBILE_BACKGROUND',
  MobileForeground = 'MOBILE_FOREGROUND'
}

export type DriverOnRouteEntity = {
  __typename?: 'DriverOnRouteEntity';
  type: Scalars['String']['output'];
  uuid: Scalars['String']['output'];
};

export type DriverOrdersInput = {
  driverUuid: Scalars['String']['input'];
  /** The route date to filter driver orders on */
  routeDate: Scalars['DateTime']['input'];
};

export type DriverOrdersOutput = {
  __typename?: 'DriverOrdersOutput';
  orders: Array<OrderEntity>;
};

export enum DriverPayType {
  PercentGrossRevenue = 'PERCENT_GROSS_REVENUE',
  PerMile = 'PER_MILE'
}

export type DriverQualificationEntity = {
  __typename?: 'DriverQualificationEntity';
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type DriverReportArgs = {
  businessDivisionUuid?: InputMaybe<Scalars['String']['input']>;
  contactUuid?: InputMaybe<Scalars['String']['input']>;
  driverUuids?: InputMaybe<Array<Scalars['String']['input']>>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  excludeMigratedOrders?: InputMaybe<Scalars['Boolean']['input']>;
  lastNumberOfDays?: InputMaybe<Scalars['Float']['input']>;
  lastNumberOfMonths?: InputMaybe<Scalars['Float']['input']>;
  lastNumberOfWeeks?: InputMaybe<Scalars['Float']['input']>;
  orderStatuses: Array<OrderStatus>;
  reportRevenueType?: InputMaybe<ReportRevenueType>;
  reportStatistics: Array<ReportStatistic>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  stopTypes: Array<PickupOrDelivery>;
  terminalUuid?: InputMaybe<Scalars['String']['input']>;
};

export type DriverReportBucketEntity = {
  __typename?: 'DriverReportBucketEntity';
  customChargeRevenue: Scalars['Float']['output'];
  deliveryRevenue: Scalars['Float']['output'];
  driverType?: Maybe<Scalars['String']['output']>;
  firstName: Scalars['String']['output'];
  freightRevenue: Scalars['Float']['output'];
  fuelRevenue: Scalars['Float']['output'];
  lastName: Scalars['String']['output'];
  lineHaulRevenue: Scalars['Float']['output'];
  name: Scalars['String']['output'];
  numberOfOrders: Scalars['Float']['output'];
  numberOfPackages: Scalars['Float']['output'];
  pickupRevenue: Scalars['Float']['output'];
  recoveryRevenue: Scalars['Float']['output'];
  specialRevenue: Scalars['Float']['output'];
  surchargeRevenue: Scalars['Float']['output'];
  totalRevenue: Scalars['Float']['output'];
  totalWeight: Scalars['Float']['output'];
  transferRevenue: Scalars['Float']['output'];
  uuid: Scalars['String']['output'];
};

export type DriverSettlementBillConnection = {
  __typename?: 'DriverSettlementBillConnection';
  edges: Array<DriverSettlementBillEdge>;
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type DriverSettlementBillCreateInput = {
  billEndDate?: InputMaybe<Scalars['DateTime']['input']>;
  billStartDate?: InputMaybe<Scalars['DateTime']['input']>;
  driverUuid: Scalars['String']['input'];
  finalizedDate?: InputMaybe<Scalars['DateTime']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  settlementDate?: InputMaybe<Scalars['DateTime']['input']>;
  settlementDeductionFlatRate?: InputMaybe<Scalars['Float']['input']>;
  settlementDeductionName?: InputMaybe<Scalars['String']['input']>;
  settlementDeductionPercentageRate?: InputMaybe<Scalars['Float']['input']>;
  stopDriverMapUuidAdds?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type DriverSettlementBillEdge = {
  __typename?: 'DriverSettlementBillEdge';
  cursor: Scalars['String']['output'];
  node: DriverSettlementBillEntity;
};

export type DriverSettlementBillEntity = {
  __typename?: 'DriverSettlementBillEntity';
  billEndDate?: Maybe<Scalars['DateTime']['output']>;
  billStartDate?: Maybe<Scalars['DateTime']['output']>;
  createdAt: Scalars['DateTime']['output'];
  driver: DriverEntity;
  finalizedDate?: Maybe<Scalars['DateTime']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  /** Use this for display instead of billStartDate and billEndDate */
  payPeriod: Scalars['String']['output'];
  paymentInformation: DriverSettlementPaymentEntity;
  settlementAdjustments: Array<SettlementAdjustmentEntity>;
  settlementBillLineItems: Array<SettlementBillLineItemEntity>;
  settlementDate?: Maybe<Scalars['DateTime']['output']>;
  settlementDeductionFlatRate?: Maybe<Scalars['Float']['output']>;
  settlementDeductionName?: Maybe<Scalars['String']['output']>;
  settlementDeductionPercentageRate?: Maybe<Scalars['Float']['output']>;
  settlementDeductions: Array<SettlementDeductionEntity>;
  /** If valid settlement bill snapshot exists, returns snapshot JSON */
  snapshot?: Maybe<Scalars['JSON']['output']>;
  /** If valid settlement bill snapshot exists, returns true. Use this if you just need to verify snapshot existence to avoid fetching the entire snapshot. */
  snapshotExists: Scalars['Boolean']['output'];
  /** calculated by finding oldest completed stop in bill */
  totalDriverPayoutPreDeduction?: Maybe<Scalars['Float']['output']>;
  uuid: Scalars['String']['output'];
};

export type DriverSettlementBillExportPdfInput = {
  /** The UUIDs of the driver settlement bills to include in the export. */
  driverSettlementBillUuids: Array<Scalars['String']['input']>;
  /** Whether to display the bill headers, including bill and company information. */
  includeHeaders: Scalars['Boolean']['input'];
  /** If true, return a detailed version of the bill. Otherwise, return a basic version. */
  includeLineItemDetails: Scalars['Boolean']['input'];
  /** Whether to display the line item totals aka driver pay. */
  includeLineItemTotals: Scalars['Boolean']['input'];
};

export type DriverSettlementBillForDownloadEntity = {
  __typename?: 'DriverSettlementBillForDownloadEntity';
  billEndDate?: Maybe<Scalars['DateTime']['output']>;
  billName?: Maybe<Scalars['String']['output']>;
  billStartDate?: Maybe<Scalars['DateTime']['output']>;
  billUuid: Scalars['String']['output'];
  driverFirstName?: Maybe<Scalars['String']['output']>;
  driverLastName?: Maybe<Scalars['String']['output']>;
  driverName?: Maybe<Scalars['String']['output']>;
  driverStationCode?: Maybe<Scalars['String']['output']>;
  finalizedDate?: Maybe<Scalars['DateTime']['output']>;
  settlementDate?: Maybe<Scalars['DateTime']['output']>;
  settlementDeductions?: Maybe<Array<SettlementDeductionForDownloadEntity>>;
  stopDriverMaps: Array<StopDriverMapForDownloadEntity>;
};

export type DriverSettlementBillUpdateInput = {
  billEndDate?: InputMaybe<Scalars['DateTime']['input']>;
  billStartDate?: InputMaybe<Scalars['DateTime']['input']>;
  driverUuid?: InputMaybe<Scalars['String']['input']>;
  /** The date the bill was finalized. Only pass this in if bill is not finalized yet -- if it is already finalized, pass in undefined. */
  finalizedDate?: InputMaybe<Scalars['DateTime']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  settlementDate?: InputMaybe<Scalars['DateTime']['input']>;
  settlementDeductionFlatRate?: InputMaybe<Scalars['Float']['input']>;
  settlementDeductionName?: InputMaybe<Scalars['String']['input']>;
  settlementDeductionPercentageRate?: InputMaybe<Scalars['Float']['input']>;
  stopDriverMapUuidAdds?: InputMaybe<Array<Scalars['String']['input']>>;
  stopDriverMapUuidDeletes?: InputMaybe<Array<Scalars['String']['input']>>;
  uuid: Scalars['String']['input'];
};

export type DriverSettlementPaymentEntity = {
  __typename?: 'DriverSettlementPaymentEntity';
  eligiblePay: Scalars['Currency']['output'];
  finalPay: Scalars['Currency']['output'];
  netAdjustments: Scalars['Currency']['output'];
  /** @deprecated During Robust Settlement Project. Use `netAdjustments` instead */
  totalDeductions?: Maybe<Scalars['Currency']['output']>;
};

export type DriverSettlementTotalAmountsOutput = {
  __typename?: 'DriverSettlementTotalAmountsOutput';
  totalChargesForSettlement: Scalars['Float']['output'];
  totalDriverPayout: Scalars['Float']['output'];
  totalEligibleAmountForStop: Scalars['Float']['output'];
};

export type DriverSignableFormTemplateEntity = {
  __typename?: 'DriverSignableFormTemplateEntity';
  createdAt: Scalars['DateTime']['output'];
  formText: Scalars['String']['output'];
  title: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  uuid: Scalars['String']['output'];
};

export enum DriverStatus {
  Assigned = 'ASSIGNED',
  Available = 'AVAILABLE'
}

export enum DriverType {
  CompanyDriver = 'COMPANY_DRIVER',
  Contractor = 'CONTRACTOR',
  OwnerOperator = 'OWNER_OPERATOR'
}

export type DriverUpdateInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  address?: InputMaybe<AddressUpsertInput>;
  defaultFuelSettlementPercentageRate?: InputMaybe<Scalars['Float']['input']>;
  defaultLineHaulTariffChainId?: InputMaybe<Scalars['String']['input']>;
  defaultOrdinaryTariffChainId?: InputMaybe<Scalars['String']['input']>;
  defaultPointToPointTariffChainId?: InputMaybe<Scalars['String']['input']>;
  defaultTransferTariffChainId?: InputMaybe<Scalars['String']['input']>;
  driverPayType?: InputMaybe<DriverPayType>;
  /** The IDs of the DriverQualifications the driver will have. This will replace any existing DriverQualifications. */
  driverQualificationIds?: InputMaybe<Array<Scalars['String']['input']>>;
  driverReferenceNumber?: InputMaybe<Scalars['String']['input']>;
  driverType?: InputMaybe<DriverType>;
  emailAddress?: InputMaybe<Scalars['String']['input']>;
  equipmentUuid?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  flatRate?: InputMaybe<Scalars['Float']['input']>;
  fuelCardNumber?: InputMaybe<Scalars['String']['input']>;
  hourlyRate?: InputMaybe<Scalars['Float']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  perMileRate?: InputMaybe<Scalars['Float']['input']>;
  percentGrossRevenueRate?: InputMaybe<Scalars['Float']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  sendRouteUpdateEmails?: InputMaybe<Scalars['Boolean']['input']>;
  terminalUuid?: InputMaybe<Scalars['String']['input']>;
  uuid: Scalars['String']['input'];
};

export type DunningReportInput = {
  contactUuid: Scalars['String']['input'];
};

export type DuplicateEdiPartnershipsInput = {
  destinationContactUuid: Scalars['String']['input'];
  replaceEdiPartnerships?: InputMaybe<Scalars['Boolean']['input']>;
  sourceContactUuid: Scalars['String']['input'];
};

export type DuplicateEdiPartnershipsOutput = {
  __typename?: 'DuplicateEdiPartnershipsOutput';
  contact?: Maybe<ContactEntity>;
  status: Scalars['String']['output'];
};

export type DuplicateTariffGroupInput = {
  uuid: Scalars['String']['input'];
};

export type DuplicateTariffGroupOutput = {
  __typename?: 'DuplicateTariffGroupOutput';
  tariffGroup: TariffGroupEntity;
};

export enum Edi214Status {
  Af = 'AF',
  Av = 'AV',
  D1 = 'D1',
  I1 = 'I1',
  P1 = 'P1',
  X1 = 'X1',
  X3 = 'X3',
  X4 = 'X4',
  X6 = 'X6',
  X7 = 'X7'
}

export enum EdiTransactionCode {
  FunctionalAcknowledgement = 'FUNCTIONAL_ACKNOWLEDGEMENT',
  MotorCarrierBillOfLading = 'MOTOR_CARRIER_BILL_OF_LADING',
  MotorCarrierFreightDetailsAndInvoice = 'MOTOR_CARRIER_FREIGHT_DETAILS_AND_INVOICE',
  MotorCarrierLoadTender = 'MOTOR_CARRIER_LOAD_TENDER',
  ResponseToALoadTender = 'RESPONSE_TO_A_LOAD_TENDER',
  TransportationCarrierShipmentStatusMessage = 'TRANSPORTATION_CARRIER_SHIPMENT_STATUS_MESSAGE'
}

export enum EdiTransactionStatus {
  Failed = 'FAILED',
  Ignored = 'IGNORED',
  InProgress = 'IN_PROGRESS',
  Success = 'SUCCESS'
}

export enum Edge {
  Bottom = 'BOTTOM',
  Left = 'LEFT',
  Right = 'RIGHT',
  Top = 'TOP'
}

export type EdgeAnchorEntity = {
  __typename?: 'EdgeAnchorEntity';
  blockId?: Maybe<Scalars['String']['output']>;
  edge: Edge;
  height: Scalars['Float']['output'];
  left: Scalars['Float']['output'];
  text: Scalars['String']['output'];
  top: Scalars['Float']['output'];
  uuid: Scalars['String']['output'];
  width: Scalars['Float']['output'];
};

export type EdgeAnchorInput = {
  blockId?: InputMaybe<Scalars['String']['input']>;
  edge: Edge;
  height: Scalars['Float']['input'];
  left: Scalars['Float']['input'];
  text: Scalars['String']['input'];
  top: Scalars['Float']['input'];
  width: Scalars['Float']['input'];
};

export enum Edi214ShipmentStatus {
  DeliveryAppointmentConfirmed = 'DELIVERY_APPOINTMENT_CONFIRMED',
  DeliveryArrived = 'DELIVERY_ARRIVED',
  DeliveryCompleted = 'DELIVERY_COMPLETED',
  DeliveryDispatched = 'DELIVERY_DISPATCHED',
  DeliveryOnHand = 'DELIVERY_ON_HAND',
  LineHaulArrivedAtDestination = 'LINE_HAUL_ARRIVED_AT_DESTINATION',
  LineHaulDeparted = 'LINE_HAUL_DEPARTED',
  LineHaulDepartedOrigin = 'LINE_HAUL_DEPARTED_ORIGIN',
  LineHaulReceived = 'LINE_HAUL_RECEIVED',
  OrderReceivedAtOrigin = 'ORDER_RECEIVED_AT_ORIGIN',
  PickupAppointmentConfirmed = 'PICKUP_APPOINTMENT_CONFIRMED',
  PickupArrived = 'PICKUP_ARRIVED',
  PickupCompleted = 'PICKUP_COMPLETED',
  PickupDispatched = 'PICKUP_DISPATCHED',
  PickupTransferred = 'PICKUP_TRANSFERRED',
  RecoveryCompleted = 'RECOVERY_COMPLETED'
}

export enum Edi990ActionCode {
  Accepted = 'ACCEPTED',
  Cancelled = 'CANCELLED'
}

export enum EdiOutboundPayloadDestination {
  Boomi = 'BOOMI',
  Stedi = 'STEDI'
}

export type EdiPartnershipEntity = {
  __typename?: 'EdiPartnershipEntity';
  allowEditingShipperBillOfLadingNumber: Scalars['Boolean']['output'];
  alternateStediPartnerId?: Maybe<Scalars['String']['output']>;
  autoAcceptOrders: Scalars['Boolean']['output'];
  canCreateMultipleStops: Scalars['Boolean']['output'];
  companyStandardCarrierAlphaCode?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  edi214ShipmentStatuses: Array<Edi214ShipmentStatus>;
  ediOutboundPayloadDestination: EdiOutboundPayloadDestination;
  enableStaging: Scalars['Boolean']['output'];
  enabled214Statuses: Array<Edi214Status>;
  excludeZeroChargeInvoices: Scalars['Boolean']['output'];
  ignoreCancellations: Scalars['Boolean']['output'];
  ignoreNonEdiOutbound: Scalars['Boolean']['output'];
  includeItemizedChargesIn210: Scalars['Boolean']['output'];
  includeOutboundFilenameReceiverIsaId: Scalars['Boolean']['output'];
  mergeLineHaul: Scalars['Boolean']['output'];
  outboundFilenameScacPrefix: Scalars['Boolean']['output'];
  removeSpacesFrom214Bol: Scalars['Boolean']['output'];
  requireGenerateEdi210Ids: Scalars['Boolean']['output'];
  send990InResponseTo204: Scalars['Boolean']['output'];
  send990InResponseTo211: Scalars['Boolean']['output'];
  sendBackupDocs: Scalars['Boolean']['output'];
  stedi210MappingId?: Maybe<Scalars['String']['output']>;
  stedi210TransactionSettingId?: Maybe<Scalars['String']['output']>;
  stedi214MappingId?: Maybe<Scalars['String']['output']>;
  stedi214TransactionSettingId?: Maybe<Scalars['String']['output']>;
  stedi990MappingId?: Maybe<Scalars['String']['output']>;
  stedi990TransactionSettingId?: Maybe<Scalars['String']['output']>;
  stediPartnershipId?: Maybe<Scalars['String']['output']>;
  tiffPodUpload: Scalars['Boolean']['output'];
  timeOfPodUpload: TimeOfPodUpload;
  updatedAt: Scalars['DateTime']['output'];
  useStediGenerateEdiFunction: Scalars['Boolean']['output'];
  uuid: Scalars['String']['output'];
};

export type EdiPartnershipServiceMappingCreateInput = {
  ediValue: Scalars['String']['input'];
  serviceName: Scalars['String']['input'];
};

export type EdiPartnershipServiceMappingEntity = {
  __typename?: 'EdiPartnershipServiceMappingEntity';
  createdAt: Scalars['DateTime']['output'];
  ediValue: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  uuid: Scalars['String']['output'];
};

export type EdiTransactionConnection = {
  __typename?: 'EdiTransactionConnection';
  edges: Array<EdiTransactionEdge>;
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type EdiTransactionEdge = {
  __typename?: 'EdiTransactionEdge';
  cursor: Scalars['String']['output'];
  node: EdiTransactionEntity;
};

export type EdiTransactionEntity = {
  __typename?: 'EdiTransactionEntity';
  code: EdiTransactionCode;
  createdAt: Scalars['DateTime']['output'];
  edi210NetAmountDueCents?: Maybe<Scalars['Int']['output']>;
  edi214ShipmentStatus?: Maybe<Edi214ShipmentStatus>;
  edi990ActionCode?: Maybe<Edi990ActionCode>;
  ediPayloadId?: Maybe<Scalars['String']['output']>;
  hawb?: Maybe<Scalars['String']['output']>;
  ignoreInAudit: Scalars['Boolean']['output'];
  message?: Maybe<Scalars['String']['output']>;
  order?: Maybe<OrderEntity>;
  payload: Scalars['String']['output'];
  purposeCode?: Maybe<EdiTransactionPurposeCode>;
  receiverIsaId: Scalars['String']['output'];
  senderIsaId: Scalars['String']['output'];
  status: EdiTransactionStatus;
  updatedAt: Scalars['DateTime']['output'];
  uuid: Scalars['String']['output'];
};

export enum EdiTransactionPurposeCode {
  Cancellation = 'CANCELLATION',
  Change = 'CHANGE',
  Original = 'ORIGINAL'
}

export type EditContactsInput = {
  companyUuid: Scalars['String']['input'];
  /** A publicly accessible URL with the contacts data to update */
  csvUrl: Scalars['String']['input'];
  /** The mappings between the CSV columns and the contact import fields. Should provide ContactIdentifier mapping. */
  mappings: Array<BulkUpdateContactMapping>;
};

export type EditContactsOutput = {
  __typename?: 'EditContactsOutput';
  failedContacts: Array<Scalars['String']['output']>;
  successfulContacts: Array<Scalars['String']['output']>;
};

export type EditPaymentAmountInput = {
  amountInCents: Scalars['Int']['input'];
  uuid: Scalars['String']['input'];
};

export type EmailAccountingReportInput = {
  accountingReportDocumentUuid: Scalars['String']['input'];
  ccEmails?: InputMaybe<Array<Scalars['String']['input']>>;
  recipientEmail: Scalars['String']['input'];
  reportType: AccountingReportType;
  senderEmail?: InputMaybe<Scalars['String']['input']>;
};

export type EmailAccountingReportOutput = {
  __typename?: 'EmailAccountingReportOutput';
  status: EmailAccountingReportStatus;
};

export enum EmailAccountingReportStatus {
  NoAccountingReportUrl = 'NO_ACCOUNTING_REPORT_URL',
  NoRecipientEmail = 'NO_RECIPIENT_EMAIL',
  Other = 'OTHER',
  Success = 'SUCCESS'
}

export type EmailOrderDocumentInput = {
  ccEmails?: InputMaybe<Array<Scalars['String']['input']>>;
  isQuote: Scalars['Boolean']['input'];
  orderDocumentDocumentUuid: Scalars['String']['input'];
  orderDocumentType: OrderDocumentType;
  orderIdentifier: Scalars['String']['input'];
  recipientEmail: Scalars['String']['input'];
  senderEmail?: InputMaybe<Scalars['String']['input']>;
};

export type EmailOrderDocumentOutput = {
  __typename?: 'EmailOrderDocumentOutput';
  status: EmailOrderDocumentStatus;
};

export enum EmailOrderDocumentStatus {
  NoOrderDocumentUrl = 'NO_ORDER_DOCUMENT_URL',
  NoRecipientEmail = 'NO_RECIPIENT_EMAIL',
  Other = 'OTHER',
  Success = 'SUCCESS'
}

export enum EmailSendStatus {
  Failed = 'FAILED',
  NotSent = 'NOT_SENT',
  PartiallySent = 'PARTIALLY_SENT',
  Sending = 'SENDING',
  Sent = 'SENT'
}

export type EmailTransactionConnection = {
  __typename?: 'EmailTransactionConnection';
  edges: Array<EmailTransactionEdge>;
  pageInfo: PageInfo;
};

export type EmailTransactionEdge = {
  __typename?: 'EmailTransactionEdge';
  cursor: Scalars['String']['output'];
  node: EmailTransactionEntity;
};

export type EmailTransactionEntity = {
  __typename?: 'EmailTransactionEntity';
  company: CompanyEntity;
  contact: ContactEntity;
  createdAt: Scalars['DateTime']['output'];
  document: DocumentEntity;
  emailResponse?: Maybe<Scalars['String']['output']>;
  emailResponseStatus?: Maybe<Scalars['Int']['output']>;
  emailTransactionLogs: Array<EmailTransactionLogEntity>;
  emailTransactionStatus: EmailTransactionStatus;
  emails: Array<Scalars['String']['output']>;
  failureReason?: Maybe<Scalars['String']['output']>;
  invoice?: Maybe<InvoiceEntity>;
  updatedAt: Scalars['DateTime']['output'];
  uuid: Scalars['String']['output'];
};

export type EmailTransactionLogCreateInput = {
  email: Scalars['String']['input'];
  emailTransactionUuid: Scalars['String']['input'];
  lastStatus?: InputMaybe<EmailTransactionLogStatus>;
  reason?: InputMaybe<Scalars['String']['input']>;
};

export type EmailTransactionLogEntity = {
  __typename?: 'EmailTransactionLogEntity';
  email: Scalars['String']['output'];
  lastStatus?: Maybe<EmailTransactionLogStatus>;
  reason?: Maybe<Scalars['String']['output']>;
  uuid: Scalars['String']['output'];
};

export enum EmailTransactionLogStatus {
  Blocked = 'BLOCKED',
  Bounced = 'BOUNCED',
  Deferred = 'DEFERRED',
  Delivered = 'DELIVERED',
  Dropped = 'DROPPED',
  Processed = 'PROCESSED'
}

export type EmailTransactionLogUpdateInput = {
  email: Scalars['String']['input'];
  emailTransactionUuid?: InputMaybe<Scalars['String']['input']>;
  lastStatus?: InputMaybe<EmailTransactionLogStatus>;
  reason?: InputMaybe<Scalars['String']['input']>;
  uuid: Scalars['String']['input'];
};

export enum EmailTransactionStatus {
  Failed = 'FAILED',
  PartiallySent = 'PARTIALLY_SENT',
  Sending = 'SENDING',
  Sent = 'SENT'
}

export type EndOfDayDocumentProcessingJobEntity = {
  __typename?: 'EndOfDayDocumentProcessingJobEntity';
  createdAt: Scalars['DateTime']['output'];
  dateUploadedFor: Scalars['DateTime']['output'];
  status: EndOfDayDocumentsProcessingJobStatus;
  updatedAt: Scalars['DateTime']['output'];
  uploadedFileName: Scalars['String']['output'];
  uuid: Scalars['String']['output'];
};

export enum EndOfDayDocumentsProcessingJobStatus {
  Completed = 'COMPLETED',
  Failed = 'FAILED',
  InProgress = 'IN_PROGRESS'
}

export type EodDocumentCreateInput = {
  bucket: Scalars['String']['input'];
  companyUuid: Scalars['String']['input'];
  dateUploadedFor?: InputMaybe<Scalars['DateTime']['input']>;
  fileName: Scalars['String']['input'];
  fileType: Scalars['String']['input'];
  key: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  orderUuid?: InputMaybe<Scalars['String']['input']>;
  pageNumber?: InputMaybe<Scalars['Int']['input']>;
  region: Scalars['String']['input'];
  terminalUuid?: InputMaybe<Scalars['String']['input']>;
  thumbnailKey?: InputMaybe<Scalars['String']['input']>;
  type: DocumentType;
  uploadOrdinal?: InputMaybe<Scalars['Int']['input']>;
  uploadedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type EquipmentCreateInput = {
  /** capacity of equipment */
  capacity?: InputMaybe<Scalars['Float']['input']>;
  /** equipment licenses to be created for this equipment */
  equipmentLicenseCreateInputs: Array<EquipmentLicenseCreateInput>;
  /** height of equipment */
  height?: InputMaybe<Scalars['Float']['input']>;
  /** length of equipment */
  length?: InputMaybe<Scalars['Float']['input']>;
  /** measurement system used for equipment data */
  measurementSystem: MeasurementSystem;
  /** name of equipment */
  name: Scalars['String']['input'];
  /** notes for equipment */
  notes?: InputMaybe<Scalars['String']['input']>;
  samsaraIsDeactivated?: InputMaybe<Scalars['Boolean']['input']>;
  type: EquipmentType;
  vehicleTypeUuid?: InputMaybe<Scalars['String']['input']>;
  /** weight of equipment */
  weight?: InputMaybe<Scalars['Float']['input']>;
  /** width of equipment */
  width?: InputMaybe<Scalars['Float']['input']>;
};

export type EquipmentEntity = {
  __typename?: 'EquipmentEntity';
  capacity?: Maybe<Scalars['Float']['output']>;
  equipmentLicenses: Array<EquipmentLicenseEntity>;
  height?: Maybe<Scalars['Float']['output']>;
  isActive: Scalars['Boolean']['output'];
  length?: Maybe<Scalars['Float']['output']>;
  /** Measurement system used. Defaults to Imperial */
  measurementSystem: MeasurementSystem;
  name: Scalars['String']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  samsaraIsDeactivated?: Maybe<Scalars['Boolean']['output']>;
  samsaraVehicleId?: Maybe<Scalars['String']['output']>;
  subtype?: Maybe<Scalars['String']['output']>;
  type: EquipmentType;
  uuid: Scalars['String']['output'];
  vehicleType?: Maybe<VehicleTypeEntity>;
  weight?: Maybe<Scalars['Float']['output']>;
  width?: Maybe<Scalars['Float']['output']>;
};

export type EquipmentLicenseArrayUpdateInput = {
  equipmentLicenseCreateInput?: InputMaybe<EquipmentLicenseCreateInput>;
  equipmentLicenseUpdateInput?: InputMaybe<EquipmentLicenseUpdateInput>;
};

export type EquipmentLicenseCreateInput = {
  /** Expiry date of the license */
  expiryDate: Scalars['DateTime']['input'];
  /** Issue date of the license */
  issueDate: Scalars['DateTime']['input'];
  /** Equipment license type */
  licenseType: Scalars['String']['input'];
  /** Licensing body which provided the license */
  licensingBody: Scalars['String']['input'];
  /** Equipment license Number (e.g. plate number) */
  number: Scalars['String']['input'];
};

export type EquipmentLicenseEntity = {
  __typename?: 'EquipmentLicenseEntity';
  /** Expiry date of the license */
  expiryDate: Scalars['DateTime']['output'];
  /** Issue date of the license */
  issueDate: Scalars['DateTime']['output'];
  /** Equipment license type */
  licenseType: Scalars['String']['output'];
  /** Licensing body which provided the license */
  licensingBody: Scalars['String']['output'];
  /** Equipment license Number (e.g. plate number) */
  number: Scalars['String']['output'];
  uuid: Scalars['String']['output'];
};

export type EquipmentLicenseUpdateInput = {
  /** New expiry date */
  expiryDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** New issue date */
  issueDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** New license type */
  licenseType?: InputMaybe<Scalars['String']['input']>;
  /** New licensing body */
  licensingBody?: InputMaybe<Scalars['String']['input']>;
  /** New license number */
  number?: InputMaybe<Scalars['String']['input']>;
  /** uuid of equipment license to update */
  uuid: Scalars['String']['input'];
};

export enum EquipmentType {
  Chassis = 'CHASSIS',
  Trailer = 'TRAILER',
  Vehicle = 'VEHICLE'
}

export type EquipmentUpdateInput = {
  /** capacity of equipment */
  capacity?: InputMaybe<Scalars['Float']['input']>;
  /** update objects (union type) for equipment licenses */
  equipmentLicenseArrayUpdateInputs?: InputMaybe<Array<EquipmentLicenseArrayUpdateInput>>;
  /** height of equipment */
  height?: InputMaybe<Scalars['Float']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  /** length of equipment */
  length?: InputMaybe<Scalars['Float']['input']>;
  /** measurement system used for equipment data */
  measurementSystem?: InputMaybe<MeasurementSystem>;
  /** name of equipment */
  name?: InputMaybe<Scalars['String']['input']>;
  /** notes for equipment */
  notes?: InputMaybe<Scalars['String']['input']>;
  samsaraIsDeactivated?: InputMaybe<Scalars['Boolean']['input']>;
  type?: InputMaybe<EquipmentType>;
  /** uuid of the equipment to be updated */
  uuid: Scalars['String']['input'];
  vehicleTypeUuid?: InputMaybe<Scalars['String']['input']>;
  /** weight of equipment */
  weight?: InputMaybe<Scalars['Float']['input']>;
  /** width of equipment */
  width?: InputMaybe<Scalars['Float']['input']>;
};

export type EtaEntity = {
  __typename?: 'EtaEntity';
  arrivalTime: Scalars['DateTime']['output'];
  finishTime: Scalars['DateTime']['output'];
};

export type ExistingInvoiceToUpdate = {
  __typename?: 'ExistingInvoiceToUpdate';
  invoiceUuid: Scalars['String']['output'];
  name: Scalars['String']['output'];
  ordersToAdd: Array<OrderToAddToInvoice>;
};

export type ExistingSettlementBillInput = {
  driverSettlementBillUuid: Scalars['String']['input'];
  settlementBillLineItemIds: Array<Scalars['String']['input']>;
};

export type ExportInvoicesToQuickbooksInput = {
  invoiceUuids: Array<Scalars['String']['input']>;
};

export type ExportQuickbooksResult = {
  __typename?: 'ExportQuickbooksResult';
  conductorUserFacingErrors: Array<Scalars['String']['output']>;
  duplicateInvoiceError?: Maybe<Scalars['String']['output']>;
  failedInvoiceUuid: Scalars['String']['output'];
  invoice: QuickbooksDesktopInvoiceEntity;
  missingAccessorialMappings: Array<Scalars['String']['output']>;
  missingCustomerName?: Maybe<Scalars['String']['output']>;
  missingCustomerUuid?: Maybe<Scalars['String']['output']>;
  missingFreightChargeMappings: Array<Scalars['String']['output']>;
  missingFuelChargeMappings: Array<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type ExtractedFieldEntity = {
  __typename?: 'ExtractedFieldEntity';
  field: FieldMapping;
  uuid: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type ExtractedFieldInput = {
  field: FieldMapping;
  value: Scalars['String']['input'];
};

export enum ExtractionType {
  Contact = 'CONTACT',
  Noop = 'NOOP',
  Regex = 'REGEX',
  SelectAll = 'SELECT_ALL',
  TrimLeft = 'TRIM_LEFT',
  TrimRight = 'TRIM_RIGHT'
}

export type FeatureFlagCompanyOverrideArrayUpdateInput = {
  /** Pass this field in to create a new array item */
  featureFlagCompanyOverrideCreateInput?: InputMaybe<FeatureFlagCompanyOverrideCreateInput>;
  /** Pass this field in to update an array item */
  featureFlagCompanyOverrideUpdateInput?: InputMaybe<FeatureFlagCompanyOverrideUpdateInput>;
};

export type FeatureFlagCompanyOverrideCreateInput = {
  active: Scalars['Boolean']['input'];
  companyUuid: Scalars['String']['input'];
};

export type FeatureFlagCompanyOverrideEntity = {
  __typename?: 'FeatureFlagCompanyOverrideEntity';
  active: Scalars['Boolean']['output'];
  /** Convenience field for retool */
  companyName: Scalars['String']['output'];
  uuid: Scalars['String']['output'];
};

export type FeatureFlagCompanyOverrideUpdateInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  uuid: Scalars['String']['input'];
};

export type FeatureFlagCreateInput = {
  active: Scalars['Boolean']['input'];
  featureFlagCompanyOverrideCreateInput?: InputMaybe<Array<FeatureFlagCompanyOverrideCreateInput>>;
  name: Scalars['String']['input'];
  versionId?: InputMaybe<Scalars['String']['input']>;
};

export type FeatureFlagEntity = {
  __typename?: 'FeatureFlagEntity';
  active: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  uuid: Scalars['String']['output'];
  versionId?: Maybe<Scalars['String']['output']>;
};

export type FeatureFlagInput = {
  name: Scalars['String']['input'];
};

export type FeatureFlagRemoveInput = {
  uuid: Scalars['String']['input'];
};

export type FeatureFlagUpdateInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  featureFlagCompanyOverrideArrayUpdateInput?: InputMaybe<Array<FeatureFlagCompanyOverrideArrayUpdateInput>>;
  name?: InputMaybe<Scalars['String']['input']>;
  uuid: Scalars['String']['input'];
  versionId?: InputMaybe<Scalars['String']['input']>;
};

export type FeatureFlagUserOverrideEntity = {
  __typename?: 'FeatureFlagUserOverrideEntity';
  active: Scalars['Boolean']['output'];
  createdAt: Scalars['DateTime']['output'];
  featureFlagUuid: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  user: UserEntity;
  /** Convenience field for retool  */
  userEmail: Scalars['String']['output'];
  userUuid: Scalars['String']['output'];
  uuid: Scalars['String']['output'];
};

export type FieldExtractorEntity = {
  __typename?: 'FieldExtractorEntity';
  mapping: FieldMapping;
  type: ExtractionType;
  uuid: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type FieldExtractorInput = {
  mapping: FieldMapping;
  type: ExtractionType;
  value: Scalars['String']['input'];
};

export enum FieldMapping {
  BillOfLadingNumber = 'BILL_OF_LADING_NUMBER',
  ConsigneeAddressAll = 'CONSIGNEE_ADDRESS_ALL',
  ConsigneeAddressCity = 'CONSIGNEE_ADDRESS_CITY',
  ConsigneeAddressCountry = 'CONSIGNEE_ADDRESS_COUNTRY',
  ConsigneeAddressLine_1 = 'CONSIGNEE_ADDRESS_LINE_1',
  ConsigneeAddressLine_2 = 'CONSIGNEE_ADDRESS_LINE_2',
  ConsigneeAddressState = 'CONSIGNEE_ADDRESS_STATE',
  ConsigneeAddressZip = 'CONSIGNEE_ADDRESS_ZIP',
  ConsigneeContactFirstName = 'CONSIGNEE_CONTACT_FIRST_NAME',
  ConsigneeContactLastName = 'CONSIGNEE_CONTACT_LAST_NAME',
  ConsigneeName = 'CONSIGNEE_NAME',
  ConsigneePhone = 'CONSIGNEE_PHONE',
  Contact = 'CONTACT',
  CurrentPage = 'CURRENT_PAGE',
  DeadlineDate = 'DEADLINE_DATE',
  DeadlineType = 'DEADLINE_TYPE',
  Delivery = 'DELIVERY',
  MasterAirwayBill = 'MASTER_AIRWAY_BILL',
  Package_0Description = 'PACKAGE_0_DESCRIPTION',
  Package_0Height = 'PACKAGE_0_HEIGHT',
  Package_0Length = 'PACKAGE_0_LENGTH',
  Package_0Quantity = 'PACKAGE_0_QUANTITY',
  Package_0Weight = 'PACKAGE_0_WEIGHT',
  Package_0Width = 'PACKAGE_0_WIDTH',
  Package_1Description = 'PACKAGE_1_DESCRIPTION',
  Package_1Height = 'PACKAGE_1_HEIGHT',
  Package_1Length = 'PACKAGE_1_LENGTH',
  Package_1Quantity = 'PACKAGE_1_QUANTITY',
  Package_1Weight = 'PACKAGE_1_WEIGHT',
  Package_1Width = 'PACKAGE_1_WIDTH',
  Package_2Description = 'PACKAGE_2_DESCRIPTION',
  Package_2Height = 'PACKAGE_2_HEIGHT',
  Package_2Length = 'PACKAGE_2_LENGTH',
  Package_2Quantity = 'PACKAGE_2_QUANTITY',
  Package_2Weight = 'PACKAGE_2_WEIGHT',
  Package_2Width = 'PACKAGE_2_WIDTH',
  Package_3Description = 'PACKAGE_3_DESCRIPTION',
  Package_3Height = 'PACKAGE_3_HEIGHT',
  Package_3Length = 'PACKAGE_3_LENGTH',
  Package_3Quantity = 'PACKAGE_3_QUANTITY',
  Package_3Weight = 'PACKAGE_3_WEIGHT',
  Package_3Width = 'PACKAGE_3_WIDTH',
  Package_4Description = 'PACKAGE_4_DESCRIPTION',
  Package_4Height = 'PACKAGE_4_HEIGHT',
  Package_4Length = 'PACKAGE_4_LENGTH',
  Package_4Quantity = 'PACKAGE_4_QUANTITY',
  Package_4Weight = 'PACKAGE_4_WEIGHT',
  Package_4Width = 'PACKAGE_4_WIDTH',
  Package_5Description = 'PACKAGE_5_DESCRIPTION',
  Package_5Height = 'PACKAGE_5_HEIGHT',
  Package_5Length = 'PACKAGE_5_LENGTH',
  Package_5Quantity = 'PACKAGE_5_QUANTITY',
  Package_5Weight = 'PACKAGE_5_WEIGHT',
  Package_5Width = 'PACKAGE_5_WIDTH',
  Package_6Description = 'PACKAGE_6_DESCRIPTION',
  Package_6Height = 'PACKAGE_6_HEIGHT',
  Package_6Length = 'PACKAGE_6_LENGTH',
  Package_6Quantity = 'PACKAGE_6_QUANTITY',
  Package_6Weight = 'PACKAGE_6_WEIGHT',
  Package_6Width = 'PACKAGE_6_WIDTH',
  Package_7Description = 'PACKAGE_7_DESCRIPTION',
  Package_7Height = 'PACKAGE_7_HEIGHT',
  Package_7Length = 'PACKAGE_7_LENGTH',
  Package_7Quantity = 'PACKAGE_7_QUANTITY',
  Package_7Weight = 'PACKAGE_7_WEIGHT',
  Package_7Width = 'PACKAGE_7_WIDTH',
  Package_8Description = 'PACKAGE_8_DESCRIPTION',
  Package_8Height = 'PACKAGE_8_HEIGHT',
  Package_8Length = 'PACKAGE_8_LENGTH',
  Package_8Quantity = 'PACKAGE_8_QUANTITY',
  Package_8Weight = 'PACKAGE_8_WEIGHT',
  Package_8Width = 'PACKAGE_8_WIDTH',
  Package_9Description = 'PACKAGE_9_DESCRIPTION',
  Package_9Height = 'PACKAGE_9_HEIGHT',
  Package_9Length = 'PACKAGE_9_LENGTH',
  Package_9Quantity = 'PACKAGE_9_QUANTITY',
  Package_9Weight = 'PACKAGE_9_WEIGHT',
  Package_9Width = 'PACKAGE_9_WIDTH',
  Package_10Description = 'PACKAGE_10_DESCRIPTION',
  Package_10Height = 'PACKAGE_10_HEIGHT',
  Package_10Length = 'PACKAGE_10_LENGTH',
  Package_10Quantity = 'PACKAGE_10_QUANTITY',
  Package_10Weight = 'PACKAGE_10_WEIGHT',
  Package_10Width = 'PACKAGE_10_WIDTH',
  Pickup = 'PICKUP',
  SecondaryReferenceNumber = 'SECONDARY_REFERENCE_NUMBER',
  ShipperAddressAll = 'SHIPPER_ADDRESS_ALL',
  ShipperAddressCity = 'SHIPPER_ADDRESS_CITY',
  ShipperAddressCountry = 'SHIPPER_ADDRESS_COUNTRY',
  ShipperAddressLine_1 = 'SHIPPER_ADDRESS_LINE_1',
  ShipperAddressLine_2 = 'SHIPPER_ADDRESS_LINE_2',
  ShipperAddressState = 'SHIPPER_ADDRESS_STATE',
  ShipperAddressZip = 'SHIPPER_ADDRESS_ZIP',
  ShipperContactFirstName = 'SHIPPER_CONTACT_FIRST_NAME',
  ShipperContactLastName = 'SHIPPER_CONTACT_LAST_NAME',
  ShipperName = 'SHIPPER_NAME',
  ShipperPhone = 'SHIPPER_PHONE',
  SpecialInstructions = 'SPECIAL_INSTRUCTIONS',
  TertiaryReferenceNumber = 'TERTIARY_REFERENCE_NUMBER',
  TotalPages = 'TOTAL_PAGES',
  TotalWeight = 'TOTAL_WEIGHT'
}

export type FieldMatcherEntity = {
  __typename?: 'FieldMatcherEntity';
  type: MatcherType;
  uuid: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type FieldMatcherInput = {
  type: MatcherType;
  value: Scalars['String']['input'];
};

/** Filter fields for the findLineHaulManifestsV2 query */
export type Fields = {
  departDate?: InputMaybe<DateFilterV2Simple>;
  driverUuidFilter?: InputMaybe<UuidFilterV2Simple>;
  endTerminalUuidFilter?: InputMaybe<UuidFilterV2Simple>;
  startTerminalUuidFilter?: InputMaybe<UuidFilterV2Simple>;
  statusFilter?: InputMaybe<LineHaulManifestStatusFilter>;
};

export enum FilterOperator {
  And = 'AND',
  Or = 'OR'
}

export enum FilterViewPage {
  CustomerPortalOrders = 'CUSTOMER_PORTAL_ORDERS',
  Dispatch = 'DISPATCH',
  Invoices = 'INVOICES',
  LineHaulOrders = 'LINE_HAUL_ORDERS',
  Orders = 'ORDERS',
  OrdersAudit = 'ORDERS_AUDIT',
  Quotes = 'QUOTES',
  StorageOrders = 'STORAGE_ORDERS',
  StorageUnits = 'STORAGE_UNITS'
}

export type FinalizeInvoicesInput = {
  /** The invoice date to assign all included invoices */
  invoiceDate?: InputMaybe<Scalars['DateTime']['input']>;
  uuids: Array<Scalars['String']['input']>;
};

export type FinalizeInvoicesOutput = {
  __typename?: 'FinalizeInvoicesOutput';
  count: Scalars['Int']['output'];
};

export type FinalizeOrdersInput = {
  /** The UUIDs of the orders to be finalized */
  uuids: Array<Scalars['String']['input']>;
};

export type FinalizeOrdersOutput = FinalizeOrdersSuccessOutput | MutationErrorOutput;

export type FinalizeOrdersSuccessOutput = {
  __typename?: 'FinalizeOrdersSuccessOutput';
  /** The list of order UUIDs that were not finalized */
  failedOrderUuids: Array<Scalars['String']['output']>;
  /** The list of order UUIDs that were successfully finalized */
  finalizedOrderUuids: Array<Scalars['String']['output']>;
};

export type FinalizeSettlementBillResult = {
  __typename?: 'FinalizeSettlementBillResult';
  bill: DriverSettlementBillEntity;
  /** User-facing error message if bill failed to finalize. Otherwise null. */
  error?: Maybe<Scalars['String']['output']>;
};

export type FinalizeSettlementBillsInput = {
  /** The UUIDs of the driver settlement bills to finalize */
  billUuids: Array<Scalars['String']['input']>;
};

export type FinalizeSettlementBillsOutput = FinalizeSettlementBillsSuccessOutput | MutationErrorOutput;

export type FinalizeSettlementBillsSuccessOutput = {
  __typename?: 'FinalizeSettlementBillsSuccessOutput';
  results: Array<FinalizeSettlementBillResult>;
};

export type FindAccessorialDateRangeConfigsInput = {
  /** The UUID of the accessorial to retrieve the date range configs for */
  accessorialUuid: Scalars['String']['input'];
};

export type FindAccessorialDateRangeConfigsOutput = {
  __typename?: 'FindAccessorialDateRangeConfigsOutput';
  accessorialDateRangeConfigs: Array<AccessorialDateRangeConfigEntity>;
};

export type FindBusinessDivisionsOutput = {
  __typename?: 'FindBusinessDivisionsOutput';
  businessDivisions: Array<BusinessDivisionEntity>;
};

export type FindClientQuotesInput = {
  /** forwards pagination cursor */
  after?: InputMaybe<Scalars['String']['input']>;
  /** backwards pagination cursor */
  before?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<FindQuoteFiltersInput>;
  /** forwards pagination count, provide this on initial query */
  first?: InputMaybe<Scalars['Int']['input']>;
  /** backwards pagination count */
  last?: InputMaybe<Scalars['Int']['input']>;
  searchText?: InputMaybe<Scalars['String']['input']>;
};

export enum FindCompanyDocumentStatusFilter {
  All = 'All',
  Matched = 'Matched',
  Processing = 'Processing',
  Unmatched = 'Unmatched'
}

export type FindCompanyOrdersInDateRangeInput = {
  companyUuid: Scalars['String']['input'];
  endDate: Scalars['DateTime']['input'];
  excludeOrdersOnInvoice?: InputMaybe<Scalars['Boolean']['input']>;
  limit: Scalars['Int']['input'];
  requireOrderToBeOnInvoice?: InputMaybe<Scalars['Boolean']['input']>;
  startDate: Scalars['DateTime']['input'];
  statuses: Array<OrderStatus>;
};

export type FindCompanyOrdersInDateRangeOutput = {
  __typename?: 'FindCompanyOrdersInDateRangeOutput';
  orders: Array<OrderEntity>;
};

export enum FindConsolidatableOrdersError {
  AlreadyConsolidated = 'ALREADY_CONSOLIDATED',
  MultipleAddresses = 'MULTIPLE_ADDRESSES'
}

export type FindContactItemsInput = {
  /** The UUID of the contact to retrieve all the items for */
  contactUuid: Scalars['String']['input'];
  searchText?: InputMaybe<Scalars['String']['input']>;
  warehouseUuid?: InputMaybe<Scalars['String']['input']>;
};

export type FindContactItemsOutput = {
  __typename?: 'FindContactItemsOutput';
  items: Array<ItemEntity>;
};

export type FindCustomerPortalQuotesInput = {
  /** forwards pagination cursor */
  after?: InputMaybe<Scalars['String']['input']>;
  /** backwards pagination cursor */
  before?: InputMaybe<Scalars['String']['input']>;
  /** Filters for the customerPortalQuotes query. The source filter is ignored and always set to CUSTOMER_PORTAL. */
  filters?: InputMaybe<FindQuoteFiltersInput>;
  /** forwards pagination count, provide this on initial query */
  first?: InputMaybe<Scalars['Int']['input']>;
  /** backwards pagination count */
  last?: InputMaybe<Scalars['Int']['input']>;
  searchText?: InputMaybe<Scalars['String']['input']>;
};

export type FindEmailTransactionsInput = {
  /** forwards pagination cursor */
  after?: InputMaybe<Scalars['String']['input']>;
  /** backwards pagination cursor */
  before?: InputMaybe<Scalars['String']['input']>;
  /** forwards pagination count, provide this on initial query */
  first?: InputMaybe<Scalars['Int']['input']>;
  /** backwards pagination count */
  last?: InputMaybe<Scalars['Int']['input']>;
  /** Pass as true to remove the limit. Use with caution! */
  noMaximum?: InputMaybe<Scalars['Boolean']['input']>;
  searchText?: InputMaybe<Scalars['String']['input']>;
  /** request total number of records, request with prudence */
  totalCount?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FindEmailTransactionsOutput = {
  __typename?: 'FindEmailTransactionsOutput';
  /** A connection that represents paginated email transactions */
  emailTransactionConnection: EmailTransactionConnection;
};

export type FindFuelProfileDateRangesInput = {
  fuelProfileUuid: Scalars['String']['input'];
};

export type FindFuelProfileDateRangesOutput = {
  __typename?: 'FindFuelProfileDateRangesOutput';
  fuelProfileDateRanges: Array<FuelProfileDateRangeEntity>;
};

export type FindFuelProfileInput = {
  uuid: Scalars['String']['input'];
};

export type FindFuelProfileOutput = {
  __typename?: 'FindFuelProfileOutput';
  fuelProfile: FuelProfileEntity;
};

export type FindIngestedOutlookEmailAttachmentsInput = {
  /** forwards pagination cursor */
  after?: InputMaybe<Scalars['String']['input']>;
  /** backwards pagination cursor */
  before?: InputMaybe<Scalars['String']['input']>;
  emailIntegrationTerminalUuid?: InputMaybe<Scalars['String']['input']>;
  /** forwards pagination count, provide this on initial query */
  first?: InputMaybe<Scalars['Int']['input']>;
  /** backwards pagination count */
  last?: InputMaybe<Scalars['Int']['input']>;
  statusFilter?: InputMaybe<IngestedOutlookEmailAttachmentProcessingStatus>;
};

export type FindIngestedOutlookEmailsInput = {
  /** forwards pagination cursor */
  after?: InputMaybe<Scalars['String']['input']>;
  /** backwards pagination cursor */
  before?: InputMaybe<Scalars['String']['input']>;
  emailIntegrationTerminalUuid?: InputMaybe<Scalars['String']['input']>;
  /** forwards pagination count, provide this on initial query */
  first?: InputMaybe<Scalars['Int']['input']>;
  /** backwards pagination count */
  last?: InputMaybe<Scalars['Int']['input']>;
  /** Search term for matching against messageId, subject, sender, or body */
  search?: InputMaybe<Scalars['String']['input']>;
};

export type FindInvoiceEdiTransactionsInput = {
  /** forwards pagination cursor */
  after?: InputMaybe<Scalars['String']['input']>;
  /** backwards pagination cursor */
  before?: InputMaybe<Scalars['String']['input']>;
  /** forwards pagination count, provide this on initial query */
  first?: InputMaybe<Scalars['Int']['input']>;
  includeCount?: InputMaybe<Scalars['Boolean']['input']>;
  /** The UUID of the invoice to retrieve the EDI transactions for */
  invoiceUuid: Scalars['String']['input'];
  /** backwards pagination count */
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type FindInvoiceEdiTransactionsOutput = {
  __typename?: 'FindInvoiceEdiTransactionsOutput';
  /** The paginated EDI transactions associated with the invoice. Currently, only 210 transaction sets are associated with invoices. */
  ediTransactionConnection: EdiTransactionConnection;
};

export type FindInvoiceEmailsApiLogsInput = {
  /** forwards pagination cursor */
  after?: InputMaybe<Scalars['String']['input']>;
  /** backwards pagination cursor */
  before?: InputMaybe<Scalars['String']['input']>;
  companyUuid?: InputMaybe<Scalars['String']['input']>;
  contactUuid?: InputMaybe<Scalars['String']['input']>;
  /** forwards pagination count, provide this on initial query */
  first?: InputMaybe<Scalars['Int']['input']>;
  isFailedEmailTransaction?: InputMaybe<Scalars['Boolean']['input']>;
  isSuccessfulEmailTransaction?: InputMaybe<Scalars['Boolean']['input']>;
  /** backwards pagination count */
  last?: InputMaybe<Scalars['Int']['input']>;
  /** Pass as true to remove the limit. Use with caution! */
  noMaximum?: InputMaybe<Scalars['Boolean']['input']>;
  searchText?: InputMaybe<Scalars['String']['input']>;
  sortByCreatedAtDateAsc?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FindInvoiceEmailsApiLogsOutput = {
  __typename?: 'FindInvoiceEmailsApiLogsOutput';
  apiLogConnection: ApiLogConnection;
};

export type FindInvoicesInput = {
  /** forwards pagination cursor */
  after?: InputMaybe<Scalars['String']['input']>;
  /** backwards pagination cursor */
  before?: InputMaybe<Scalars['String']['input']>;
  billingPartyContactUuid?: InputMaybe<Scalars['String']['input']>;
  businessDivisionUuid?: InputMaybe<Scalars['String']['input']>;
  /** Should not be used outside of internal tooling and audits. */
  createdAtEndDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** Should not be used outside of internal tooling and audits. */
  createdAtStartDate?: InputMaybe<Scalars['DateTime']['input']>;
  destinationTerminalUuid?: InputMaybe<Scalars['String']['input']>;
  emailSendStatus?: InputMaybe<EmailSendStatus>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** forwards pagination count, provide this on initial query */
  first?: InputMaybe<Scalars['Int']['input']>;
  groupByContact?: InputMaybe<Scalars['Boolean']['input']>;
  /** If true, only return closed invoices with a zero non-null balanceCents. If false, only return open invoices with a non-zero non-null balanceCents. If null, do not apply any balance filter. Note that only posted invoices have a non-null balanceCents. */
  hasZeroBalance?: InputMaybe<Scalars['Boolean']['input']>;
  inConsolidatedInvoice?: InputMaybe<Scalars['Boolean']['input']>;
  invoiceEndDate?: InputMaybe<Scalars['DateTime']['input']>;
  invoiceStartDate?: InputMaybe<Scalars['DateTime']['input']>;
  isClosed?: InputMaybe<Scalars['Boolean']['input']>;
  /** If true, only return invoices with a non-sync syncedToQuickbooksDesktopAt. */
  isSyncedToQuickbooksDesktop?: InputMaybe<Scalars['Boolean']['input']>;
  /** backwards pagination count */
  last?: InputMaybe<Scalars['Int']['input']>;
  masterAccountUuid?: InputMaybe<Scalars['String']['input']>;
  originTerminalUuid?: InputMaybe<Scalars['String']['input']>;
  removeLegacy?: InputMaybe<Scalars['Boolean']['input']>;
  searchText?: InputMaybe<Scalars['String']['input']>;
  sortByDueDateAscending?: InputMaybe<Scalars['Boolean']['input']>;
  sortByDueDateDescending?: InputMaybe<Scalars['Boolean']['input']>;
  sorts?: InputMaybe<Array<FindInvoicesSort>>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  status?: InputMaybe<InvoiceStatus>;
  statuses?: InputMaybe<Array<InvoiceStatus>>;
  terminalUuid?: InputMaybe<Scalars['String']['input']>;
  uuids?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type FindInvoicesSort = {
  sortBy: FindInvoicesSortFields;
  sortDirection: SortDirection;
};

export enum FindInvoicesSortFields {
  CreatedAt = 'CreatedAt',
  Date = 'Date',
  DueDate = 'DueDate',
  InvoiceNameOrJournalNumber = 'InvoiceNameOrJournalNumber'
}

export type FindItemGroupsInput = {
  /** forwards pagination cursor */
  after?: InputMaybe<Scalars['String']['input']>;
  /** backwards pagination cursor */
  before?: InputMaybe<Scalars['String']['input']>;
  billedFilter?: InputMaybe<BooleanFilter>;
  companyUuidFilter?: InputMaybe<StringFilter>;
  contactUuidFilter?: InputMaybe<StringFilter>;
  /** forwards pagination count, provide this on initial query */
  first?: InputMaybe<Scalars['Int']['input']>;
  /** backwards pagination count */
  last?: InputMaybe<Scalars['Int']['input']>;
  markedOnHandAtDateFilters?: InputMaybe<DateFilterStartEnd>;
  markedOsdAtDateFilters?: InputMaybe<DateFilterStartEnd>;
  /** Pass as true to remove the limit. Use with caution! */
  noMaximum?: InputMaybe<Scalars['Boolean']['input']>;
  pickedAtDateFilters?: InputMaybe<DateFilterStartEnd>;
  quantityFilter?: InputMaybe<ItemGroupQuantityFilter>;
  searchText?: InputMaybe<Scalars['String']['input']>;
  /** request total number of records, request with prudence */
  totalCount?: InputMaybe<Scalars['Boolean']['input']>;
  warehouseLocationUuidFilter?: InputMaybe<StringFilter>;
  warehouseUuidFilter?: InputMaybe<StringFilter>;
};

export type FindLaneFromOriginAndDestinationTerminalInput = {
  destinationTerminalUuid: Scalars['String']['input'];
  originTerminalUuid: Scalars['String']['input'];
};

export type FindLaneFromOriginAndDestinationTerminalOutput = {
  __typename?: 'FindLaneFromOriginAndDestinationTerminalOutput';
  lane?: Maybe<LineHaulLaneEntity>;
};

export type FindLineHaulManifestsOutput = {
  __typename?: 'FindLineHaulManifestsOutput';
  lineHaulManifests: Array<LineHaulManifestEntity>;
  unmanifestedSegments: Array<LineHaulSegmentEntity>;
};

/** Filters for the findLineHaulManifestsV2 query. Use either "and" or "or" filters, but not both simultaneously. Using both in the same query may lead to unexpected results. */
export type FindLineHaulManifestsV2FiltersInput = {
  and?: InputMaybe<Array<LineHaulManifestFilters>>;
  or?: InputMaybe<Array<LineHaulManifestFilters>>;
};

export type FindMasterAccountsOutput = {
  __typename?: 'FindMasterAccountsOutput';
  masterAccounts: Array<MasterAccountEntity>;
};

export type FindOpenInvoicesArgs = {
  hideCurrent?: InputMaybe<Scalars['Boolean']['input']>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
};

export type FindOrderByShipperBillOfLadingNumberInput = {
  companyUuid: Scalars['String']['input'];
  shipperBillOfLadingNumber: Scalars['String']['input'];
};

export type FindOrderByShipperBillOfLadingNumberOutput = {
  __typename?: 'FindOrderByShipperBillOfLadingNumberOutput';
  /** The most recent order that has the specified shipper bill of lading number */
  order?: Maybe<OrderEntity>;
};

/** Input type for the orders query and the order table report that contains all filters. Excludes any pagination or sorting arguments. */
export type FindOrdersFiltersInput = {
  /** A UUID filter intended for the active terminal */
  activeTerminalFilter?: InputMaybe<StringFilterV2>;
  activeTerminalUuidFilter?: InputMaybe<StringFilter>;
  addressCityFilter?: InputMaybe<StringFilter>;
  addressZipFilter?: InputMaybe<StringFilter>;
  /** Filters to be combined using a logical AND */
  and?: InputMaybe<Array<FindOrdersFiltersInput>>;
  appointmentRequired?: InputMaybe<BooleanFilter>;
  appointmentRequiredFilter?: InputMaybe<BooleanFilterV2>;
  attemptedAtDateFilters?: InputMaybe<DateFilterStartEnd>;
  /** A date filter intended for the order attempted date. Currently only implemented for the flat orders view. */
  attemptedDateFilter?: InputMaybe<DateFilterV2>;
  billingPartyContactDisplayNameFilter?: InputMaybe<StringFilter>;
  billingPartyContactUuidFilter?: InputMaybe<StringFilter>;
  /** Searches for orders with one of these contacts. Null represents no filter being applied at all (equivalent to "All"). An empty array should not be passed in since orders must always have a billing party contact. */
  billingPartyContactUuidsFilter?: InputMaybe<StringsFilter>;
  businessDivisionNameFilter?: InputMaybe<StringFilterV2>;
  businessDivisionUuidFilter?: InputMaybe<StringFilter>;
  businessDivisionUuidFilterV2?: InputMaybe<StringFilterV2>;
  /** A boolean filter intended for the can dispatch boolean status. Currently only implemented for the flat orders view. */
  canDispatchFilter?: InputMaybe<BooleanFilterV2>;
  /** A date filter intended for the completed at order table field */
  completedAtDateFilter?: InputMaybe<DateFilterV2>;
  completionDateFilters?: InputMaybe<DateFilterStartEnd>;
  consigneeFilter?: InputMaybe<StringFilter>;
  controllingTerminalUuidFilter?: InputMaybe<StringFilter>;
  controllingTerminalUuidFilterV2?: InputMaybe<StringFilterV2>;
  createdAtDateFilters?: InputMaybe<DateFilterStartEnd>;
  /** A date filter intended for the order created date. Currently only implemented for the flat orders view. */
  createdDateFilter?: InputMaybe<DateFilterV2>;
  customerFilter?: InputMaybe<StringFilter>;
  /** A string filter intended for the customer name field */
  customerNameFilter?: InputMaybe<StringFilterV2>;
  /** A filter for the customer portal order review status. */
  customerPortalOrderReviewStatusFilter?: InputMaybe<CustomerPortalOrderReviewStatusFilter>;
  /** A UUID filter for the customer */
  customerUuidFilter?: InputMaybe<StringFilterV2>;
  /** A date filter intended for the order deadline date. Currently only implemented for the flat orders view. */
  deadlineDateFilter?: InputMaybe<DateFilterV2>;
  deadlineDateFilters?: InputMaybe<DateFilterStartEnd>;
  destinationTerminalUuidFilter?: InputMaybe<StringFilterNullable>;
  /** A UUID filter intended for the destination terminal */
  destinationTerminalUuidFilterV2?: InputMaybe<StringFilterV2>;
  /** A float filter intended for the dim weight. Currently only implemented for the flat orders view. */
  dimWeightFilter?: InputMaybe<FloatFilterV2>;
  /** A string filter intended for the driver name flat order table field */
  driverNameFilter?: InputMaybe<StringFilterV2>;
  driverUuidFilter?: InputMaybe<StringFilter>;
  driverUuidFilterV2?: InputMaybe<StringFilterV2>;
  /** Searches for orders with one of these drivers. An empty values array represents orders with no driver (equivalent to "None"). Null represents no filter being applied at all (equivalent to "All"). */
  driverUuidsFilter?: InputMaybe<StringsFilter>;
  endStopFilter?: InputMaybe<StringFilter>;
  expectedInboundArrivalDateFilters?: InputMaybe<DateFilterStartEnd>;
  /** A string filter intended for the order external notes. Currently only implemented for the flat orders view. */
  externalNotesFilter?: InputMaybe<StringFilterV2>;
  hasAppointmentScheduled?: InputMaybe<BooleanFilter>;
  hasAppointmentScheduledFilter?: InputMaybe<BooleanFilterV2>;
  hasContactInformation?: InputMaybe<BooleanFilter>;
  hasContactInformationFilter?: InputMaybe<BooleanFilterV2>;
  hasFailures?: InputMaybe<BooleanFilter>;
  hasFailuresFilter?: InputMaybe<BooleanFilterV2>;
  hasQuotesFilter?: InputMaybe<BooleanFilterV2>;
  hasRoute?: InputMaybe<BooleanFilter>;
  hasRouteFilter?: InputMaybe<BooleanFilterV2>;
  /** A string filter intended for the HAWB order table field */
  hawbFilter?: InputMaybe<StringFilterV2>;
  hideFromBilling?: InputMaybe<BooleanFilter>;
  hideFromBillingFilter?: InputMaybe<BooleanFilterV2>;
  /** A boolean filter intended for filtering out shipments associated with a consolidated order in the old consolidated order flow. */
  hideOriginalConsolidatedOrderIdFilter?: InputMaybe<BooleanFilterV2>;
  /** A string filter intended for the hold reason. Currently only implemented for the flat orders view. */
  holdReasonFilter?: InputMaybe<StringFilterV2>;
  /** A string filter intended for the secondary reference number on the inbound address table field */
  inboundAddressFilter?: InputMaybe<StringFilterV2>;
  /** A string filter intended for inbound address type. Currently only implemented for the flat orders view. */
  inboundAddressTypeFilter?: InputMaybe<StandardStopTypeFilter>;
  /** A boolean filter intended for a confirmed inbound appointment. Currently only implemented for the flat orders view. */
  inboundAppointmentConfirmedFilter?: InputMaybe<BooleanFilterV2>;
  /** A date filter intended for the inbound appointment date. Currently only implemented for the flat orders view. */
  inboundAppointmentDateFilter?: InputMaybe<DateFilterV2>;
  /** A boolean filter intended for the inbound appointment required. Currently only implemented for the flat orders view. */
  inboundAppointmentRequiredFilter?: InputMaybe<BooleanFilterV2>;
  /** A string filter intended for the INBOUND_CITY_NAME order table field */
  inboundCityFilter?: InputMaybe<StringFilterV2>;
  /** A date filter intended for the inbound completed date order table field */
  inboundCompletedDateFilter?: InputMaybe<DateFilterV2>;
  /** A boolean filter intended to filter for inbound stop completion. Currently only implemented for the flat orders view. */
  inboundCompletedFilter?: InputMaybe<BooleanFilterV2>;
  /** A string filter intended for the inbound contact name. Currently only implemented for the flat orders view. */
  inboundContactNameFilter?: InputMaybe<StringFilterV2>;
  /** A string filter intended for the inbound driver name flat order table field */
  inboundDriverNameFilter?: InputMaybe<StringFilterV2>;
  inboundDriverUuidFilter?: InputMaybe<StringFilterV2>;
  inboundDriverUuidsFilter?: InputMaybe<StringsFilter>;
  inboundMethodFilter?: InputMaybe<StopType>;
  inboundMethodFilterV2?: InputMaybe<StopTypesV2Filter>;
  inboundNotArrived?: InputMaybe<BooleanFilter>;
  inboundNotArrivedFilter?: InputMaybe<BooleanFilterV2>;
  /** A date filter intended for the inbound route date. Currently only implemented for the flat orders view. */
  inboundRouteDateFilter?: InputMaybe<DateFilterV2>;
  /** A string filter intended for the inbound route name. Currently only implemented for the flat orders view. */
  inboundRouteNameFilter?: InputMaybe<StringFilterV2>;
  /** A string filter intended for the inbound routing field. Currently only implemented for the flat orders view. */
  inboundRoutingFilter?: InputMaybe<StringFilterV2>;
  /** A date filter intended for the INBOUND_SERVICE_DATE order table field */
  inboundServiceDateFilter?: InputMaybe<DateFilterV2>;
  /** A filter intended for the inbound stop type filter. Currently only implemented for the flat orders view. */
  inboundStopTypeFilter?: InputMaybe<StopTypeFilter>;
  /** A string filter intended for the inbound terminal name field */
  inboundTerminalFilter?: InputMaybe<StringFilterV2>;
  /** A filter intended for the inbound zipcode filter. Currently only implemented for the flat orders view. */
  inboundZipcodeFilter?: InputMaybe<StringFilterV2>;
  /** A boolean filter intended to filter by whether order is part of a consolidated order. */
  includeOrdersPartOfV2ConsolidatedOrders?: InputMaybe<BooleanFilterV2>;
  /** A date filter intended for the order invoice date. Currently only implemented for the flat orders view. */
  invoiceDateFilter?: InputMaybe<DateFilterV2>;
  invoiceDateFilters?: InputMaybe<DateFilterStartEnd>;
  invoiceUuid?: InputMaybe<Scalars['String']['input']>;
  isCancelled?: InputMaybe<BooleanFilter>;
  isCancelledFilter?: InputMaybe<BooleanFilterV2>;
  isCollectOnDelivery?: InputMaybe<Scalars['Boolean']['input']>;
  isCollectOnDeliveryFilter?: InputMaybe<BooleanFilterV2>;
  isDraftOrderFilter?: InputMaybe<BooleanFilterV2>;
  isFinalized?: InputMaybe<BooleanFilter>;
  isFinalizedFilter?: InputMaybe<BooleanFilterV2>;
  isHazmat?: InputMaybe<BooleanFilter>;
  isHazmatFilter?: InputMaybe<BooleanFilterV2>;
  isInBond?: InputMaybe<BooleanFilter>;
  isInBondFilter?: InputMaybe<BooleanFilterV2>;
  isLineHaul?: InputMaybe<BooleanFilter>;
  isLineHaulFilter?: InputMaybe<BooleanFilterV2>;
  isOsd?: InputMaybe<BooleanFilter>;
  isOsdFilter?: InputMaybe<BooleanFilterV2>;
  isPicked?: InputMaybe<BooleanFilter>;
  isPickedFilter?: InputMaybe<BooleanFilterV2>;
  isPickupOrDelivery?: InputMaybe<BooleanFilter>;
  isPickupOrDeliveryFilter?: InputMaybe<BooleanFilterV2>;
  isRefused?: InputMaybe<BooleanFilter>;
  isRefusedFilter?: InputMaybe<BooleanFilterV2>;
  /** A boolean filter intended for the orders that are reweighed. Currently only implemented for the flat orders view. */
  isReweighedFilter?: InputMaybe<BooleanFilterV2>;
  isSpecial?: InputMaybe<BooleanFilter>;
  isSpecialFilter?: InputMaybe<BooleanFilterV2>;
  /** A string filter intended for the IT number order table field */
  itNumberFilter?: InputMaybe<StringFilterV2>;
  /** A UUID filter for the end terminal of the last line haul manifest that the order is on */
  lastLineHaulTerminalUuidFilter?: InputMaybe<UuidFilterV2>;
  /** A UUID filter for the line haul lane field. Currently only implemented for the flat orders view. */
  lineHaulLaneFilter?: InputMaybe<UuidFilterV2>;
  lineHaulLaneUuids?: InputMaybe<Array<Scalars['String']['input']>>;
  /** A UUID list filter for the terminals that the line haul manifests include */
  lineHaulTerminalUuidsFilter?: InputMaybe<UuidListFilter>;
  /** A date filter intended for the date marked on hand. Currently only implemented for the flat orders view. */
  markedOnHandDateFilter?: InputMaybe<DateFilterV2>;
  /** A string filter intended for the MAWB order table field */
  mawbFilter?: InputMaybe<StringFilterV2>;
  noTerminal?: InputMaybe<BooleanFilter>;
  onHand?: InputMaybe<BooleanFilter>;
  onHandFilter?: InputMaybe<BooleanFilterV2>;
  /** A filter intended for the on hand terminal. Currently only implemented for the flat orders view and is used in context of line haul orders. */
  onHandTerminalFilter?: InputMaybe<UuidFilterV2>;
  /** A boolean filter intended for on hold orders. Currently only implemented for the flat orders view. */
  onHoldFilter?: InputMaybe<BooleanFilterV2>;
  onInvoice?: InputMaybe<BooleanFilter>;
  onInvoiceFilter?: InputMaybe<BooleanFilterV2>;
  /** Filters to be combined using a logical OR */
  or?: InputMaybe<Array<FindOrdersFiltersInput>>;
  /** A string filter intended for the order city */
  orderCityFilter?: InputMaybe<StringFilterV2>;
  /** A string filter intended for the order name order table field */
  orderNameFilterV2?: InputMaybe<StringFilterV2>;
  /** A string filter intended for the order notes. Currently only implemented for the flat orders view. */
  orderNotesFilter?: InputMaybe<StringFilterV2>;
  orderNumberFilter?: InputMaybe<StringFilter>;
  /** A date filter intended for the order service date order table field */
  orderServiceDateFilter?: InputMaybe<DateFilterV2>;
  orderSource?: InputMaybe<OrderSource>;
  /** An enum filter intended for the ORDER_SOURCE order table field */
  orderSourceFilter?: InputMaybe<OrderSourceFilter>;
  /** A filter intended for the order status. Currently only implemented for the flat orders view. */
  orderStatusFilter?: InputMaybe<OrderStatusFilter>;
  /** A string filter intended for the order zipcode */
  orderZipFilter?: InputMaybe<StringFilterV2>;
  originTerminalUuidFilter?: InputMaybe<StringFilterNullable>;
  /** A UUID filter intended for the origin terminal */
  originTerminalUuidFilterV2?: InputMaybe<StringFilterV2>;
  /** A string filter intended for the OSD reason. Currently only implemented for the flat orders view. */
  osdReasonFilter?: InputMaybe<StringFilterV2>;
  outForDeliveryFilter?: InputMaybe<BooleanFilter>;
  outForDeliveryFilterV2?: InputMaybe<BooleanFilterV2>;
  /** A string filter intended for the secondary reference number on the outbound address table field */
  outboundAddressFilter?: InputMaybe<StringFilterV2>;
  /** A string filter intended for outbound address type. Currently only implemented for the flat orders view. */
  outboundAddressTypeFilter?: InputMaybe<StandardStopTypeFilter>;
  /** A boolean filter intended for a confirmed outbound appointment. Currently only implemented for the flat orders view. */
  outboundAppointmentConfirmedFilter?: InputMaybe<BooleanFilterV2>;
  /** A date filter intended for the outbound appointment date. Currently only implemented for the flat orders view. */
  outboundAppointmentDateFilter?: InputMaybe<DateFilterV2>;
  /** A boolean filter intended for the outbound appointment required. Currently only implemented for the flat orders view. */
  outboundAppointmentRequiredFilter?: InputMaybe<BooleanFilterV2>;
  /** A string filter intended for the OUTBOUND_CITY_NAME order table field */
  outboundCityFilter?: InputMaybe<StringFilterV2>;
  /** A date filter intended for the outbound completed date order table field */
  outboundCompletedDateFilter?: InputMaybe<DateFilterV2>;
  /** A boolean filter intended to filter for outbound stop completion. Currently only implemented for the flat orders view. */
  outboundCompletedFilter?: InputMaybe<BooleanFilterV2>;
  /** A string filter intended for the outbound contact name. Currently only implemented for the flat orders view. */
  outboundContactNameFilter?: InputMaybe<StringFilterV2>;
  /** A string filter intended for the outbound destination airport. Currently only implemented for the flat orders view. */
  outboundDestinationAirportFilter?: InputMaybe<StringFilterV2>;
  /** A string filter intended for the outbound driver name flat order table field */
  outboundDriverNameFilter?: InputMaybe<StringFilterV2>;
  outboundDriverUuidFilter?: InputMaybe<StringFilterV2>;
  outboundDriverUuidsFilter?: InputMaybe<StringsFilter>;
  outboundMethodFilter?: InputMaybe<StopType>;
  outboundMethodFilterV2?: InputMaybe<StopTypesV2Filter>;
  /** A date filter intended for the outbound route date. Currently only implemented for the flat orders view. */
  outboundRouteDateFilter?: InputMaybe<DateFilterV2>;
  /** A string filter intended for the outbound route name. Currently only implemented for the flat orders view. */
  outboundRouteNameFilter?: InputMaybe<StringFilterV2>;
  /** A string filter intended for the outbound routing field. Currently only implemented for the flat orders view. */
  outboundRoutingFilter?: InputMaybe<StringFilterV2>;
  /** A date filter intended for the outbound service date. Currently only implemented for the flat orders view. */
  outboundServiceDateFilter?: InputMaybe<DateFilterV2>;
  /** A filter intended for the outbound stop type filter. Currently only implemented for the flat orders view. */
  outboundStopTypeFilter?: InputMaybe<StopTypeFilter>;
  /** A string filter intended for the outbound terminal name field */
  outboundTerminalFilter?: InputMaybe<StringFilterV2>;
  /** A filter intended for the outbound zipcode filter. Currently only implemented for the flat orders view. */
  outboundZipcodeFilter?: InputMaybe<StringFilterV2>;
  paperworkComplete?: InputMaybe<BooleanFilter>;
  paperworkCompleteFilter?: InputMaybe<BooleanFilterV2>;
  pickupOrDelivery?: InputMaybe<PickupOrDelivery>;
  primaryAppointmentDateFilters?: InputMaybe<DateFilterStartEnd>;
  /** A string filter intended for the inbound or outbound proof of delivery name field */
  proofOfDeliveryNameFilter?: InputMaybe<StringFilterV2>;
  /** A string filter intended for the proof of delivery signee. Currently only implemented for the flat orders view. */
  proofOfDeliverySigneeFilter?: InputMaybe<StringFilterV2>;
  /** A boolean filter intended for the received at origin boolean status. Currently only implemented for the flat orders view. */
  receivedAtOriginFilter?: InputMaybe<BooleanFilterV2>;
  receivedDateFilters?: InputMaybe<DateFilterStartEnd>;
  requiresRecovery?: InputMaybe<BooleanFilter>;
  requiresRecoveryFilter?: InputMaybe<BooleanFilterV2>;
  requiresRouting?: InputMaybe<BooleanFilter>;
  requiresRoutingFilter?: InputMaybe<BooleanFilterV2>;
  /** A string filter intended for routing location. Currently only implemented for the flat orders view. */
  routingLocationFilter?: InputMaybe<StringFilterV2>;
  scheduledAtDateFilters?: InputMaybe<DateFilterStartEnd>;
  scheduledFilter?: InputMaybe<BooleanFilter>;
  scheduledFilterV2?: InputMaybe<BooleanFilterV2>;
  /** A string filter intended for the secondary reference number on the order table field */
  secondaryReferenceNumberFilter?: InputMaybe<StringFilterV2>;
  /** A date filter intended for the ORDER_SERVICE_DATE order table field */
  serviceDateFilter?: InputMaybe<DateFilterV2>;
  serviceDateFilters?: InputMaybe<DateFilterStartEnd>;
  /** A string filter intended for serviceLevel. Currently only implemented for the flat orders view. */
  serviceLevelFilter?: InputMaybe<StringFilterV2>;
  serviceUuids?: InputMaybe<Array<Scalars['String']['input']>>;
  shipmentStatusFilters?: InputMaybe<Array<ShipmentStatusFilter>>;
  shipperFilter?: InputMaybe<StringFilter>;
  showConsolidatedOrders?: InputMaybe<BooleanFilter>;
  showConsolidatedOrdersFilter?: InputMaybe<BooleanFilterV2>;
  standardStopType?: InputMaybe<StandardStopType>;
  startStopFilter?: InputMaybe<StringFilter>;
  statusFilters?: InputMaybe<Array<StatusFilter>>;
  stopTypesFilter?: InputMaybe<StopTypesFilter>;
  tagUuids?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Searches for orders with one of these tags. An empty values array represents orders with no tags (equivalent to "None"). Null represents no filter being applied at all (equivalent to "All"). */
  tagUuidsFilter?: InputMaybe<StringsFilter>;
  /** A string filter intended for the order tags. Currently only implemented for the flat orders view. */
  tagsFilter?: InputMaybe<StringFilterV2>;
  terminalUuidFilter?: InputMaybe<StringFilter>;
  terminalUuidFilterV2?: InputMaybe<StringFilterV2>;
  /** Searches for orders with one of these terminals on the startStop or endStop. An empty values array represents orders with no terminal on the startStop and endStop (equivalent to "None"). Null represents no filter being applied at all (equivalent to "All"). */
  terminalUuidsFilter?: InputMaybe<StringsFilter>;
  /** A float filter intended for the total amount in dollars. Currently only implemented for the flat orders view. */
  totalAmountDollarsFilter?: InputMaybe<FloatFilterV2>;
  /** An int filter intended for the total pieces flat order table field only */
  totalPiecesFilter?: InputMaybe<IntegerFilterV2>;
  /** An int filter intended for the total skids. Currently implemented only for the flat orders view */
  totalSkidsFilter?: InputMaybe<IntegerFilterV2>;
  /** A float filter intended for the total weight flat order table field only */
  totalWeightFilter?: InputMaybe<FloatFilterV2>;
  transferPending?: InputMaybe<BooleanFilter>;
  transferPendingFilter?: InputMaybe<BooleanFilterV2>;
  /** A string filter intended for the UN number order table field */
  unNumberFilter?: InputMaybe<StringFilterV2>;
  /** A string filter intended for the zipcode on inbound and outbound stops table field */
  zipcodeFilter?: InputMaybe<StringFilterV2>;
};

export type FindOrdersOnInvoiceSort = {
  sortBy: FindOrdersOnInvoiceSortFields;
  sortDirection: SortDirection;
};

export enum FindOrdersOnInvoiceSortFields {
  Consignee = 'Consignee',
  MasterAirwayBillOfLadingNumber = 'MasterAirwayBillOfLadingNumber',
  ServiceDate = 'ServiceDate',
  ShipperBillOfLadingNumber = 'ShipperBillOfLadingNumber'
}

export type FindOrganizationInput = {
  uuid: Scalars['String']['input'];
};

export type FindOrganizationNotesInput = {
  organizationUuid: Scalars['String']['input'];
};

export type FindPackageSpecsOutput = {
  __typename?: 'FindPackageSpecsOutput';
  packageSpecs: Array<PackageSpecEntity>;
};

export type FindPaginatedOrganizationsInput = {
  /** forwards pagination cursor, provide this on subsequent queries */
  after?: InputMaybe<Scalars['String']['input']>;
  /** forwards pagination cursor, provide this on subsequent queries */
  before?: InputMaybe<Scalars['String']['input']>;
  /** forwards pagination count, provide this on initial query */
  first?: InputMaybe<Scalars['Int']['input']>;
  /** filter by active organizations. If not provided or undefined it returns all */
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  /** forwards pagination cursor, provide this on subsequent queries */
  last?: InputMaybe<Scalars['Int']['input']>;
  /** search on organization name and reference number */
  searchText?: InputMaybe<Scalars['String']['input']>;
};

export type FindPaymentsV2Args = {
  /** forwards pagination cursor */
  after?: InputMaybe<Scalars['String']['input']>;
  /** backwards pagination cursor */
  before?: InputMaybe<Scalars['String']['input']>;
  contactUuid?: InputMaybe<Scalars['String']['input']>;
  creditTypeUuid?: InputMaybe<Scalars['String']['input']>;
  /** forwards pagination count, provide this on initial query */
  first?: InputMaybe<Scalars['Int']['input']>;
  includeCount?: InputMaybe<Scalars['Boolean']['input']>;
  /** If true, only return payments where amountInCents = appliedAmountCents. If false, only return payments where amountInCents != appliedAmountCents. If null, return all payments. */
  isFullyApplied?: InputMaybe<Scalars['Boolean']['input']>;
  /** backwards pagination count */
  last?: InputMaybe<Scalars['Int']['input']>;
  paymentDateFilters?: InputMaybe<DateFilterStartEnd>;
  paymentRails?: InputMaybe<Array<PaymentRail>>;
  paymentType?: InputMaybe<PaymentType>;
  paymentTypes?: InputMaybe<Array<PaymentType>>;
  searchText?: InputMaybe<Scalars['String']['input']>;
  sorts?: InputMaybe<Array<PaymentSort>>;
  terminalUuid?: InputMaybe<Scalars['String']['input']>;
};

export type FindPersonsOutput = {
  __typename?: 'FindPersonsOutput';
  persons: Array<PersonEntity>;
  totalCount: Scalars['Float']['output'];
};

/** Input type for the quotesV2 query that contains all filters. Excludes any pagination or sorting arguments. */
export type FindQuoteFiltersInput = {
  contactUuidFilter?: InputMaybe<UuidFilterV2>;
  sourceFilter?: InputMaybe<QuoteSourceFilter>;
  statusFilter?: InputMaybe<QuoteStatusFilter>;
};

export enum FindReportSendJobBatchesFields {
  CreatedAtDate = 'CreatedAtDate'
}

export type FindReportSendJobBatchesInput = {
  /** forwards pagination cursor */
  after?: InputMaybe<Scalars['String']['input']>;
  /** backwards pagination cursor */
  before?: InputMaybe<Scalars['String']['input']>;
  /** forwards pagination count, provide this on initial query */
  first?: InputMaybe<Scalars['Int']['input']>;
  /** backwards pagination count */
  last?: InputMaybe<Scalars['Int']['input']>;
  sorts?: InputMaybe<Array<FindReportSendJobBatchesSort>>;
};

export type FindReportSendJobBatchesOutput = {
  __typename?: 'FindReportSendJobBatchesOutput';
  reportSendJobBatchConnection: ReportSendJobBatchConnection;
};

export type FindReportSendJobBatchesSort = {
  sortBy: FindReportSendJobBatchesFields;
  sortDirection: SortDirection;
};

export type FindReportSendJobsInput = {
  /** forwards pagination cursor */
  after?: InputMaybe<Scalars['String']['input']>;
  /** backwards pagination cursor */
  before?: InputMaybe<Scalars['String']['input']>;
  /** forwards pagination count, provide this on initial query */
  first?: InputMaybe<Scalars['Int']['input']>;
  /** backwards pagination count */
  last?: InputMaybe<Scalars['Int']['input']>;
  reportSendJobBatchId: Scalars['String']['input'];
  reportSendJobStatus?: InputMaybe<ReportSendJobStatus>;
};

export type FindReportSendJobsOutput = {
  __typename?: 'FindReportSendJobsOutput';
  reportSendJobConnection: ReportSendJobConnection;
};

export type FindRoleInput = {
  uuid: Scalars['String']['input'];
};

export type FindRoleOutput = {
  __typename?: 'FindRoleOutput';
  role: RoleEntity;
};

export type FindRolesInput = {
  includeInternalRoles: Scalars['Boolean']['input'];
};

export type FindRolesOutput = {
  __typename?: 'FindRolesOutput';
  roles: Array<RoleEntity>;
};

export type FindScannedOrdersInput = {
  /** forwards pagination cursor */
  after?: InputMaybe<Scalars['String']['input']>;
  /** backwards pagination cursor */
  before?: InputMaybe<Scalars['String']['input']>;
  companyUuid: Scalars['String']['input'];
  /** forwards pagination count, provide this on initial query */
  first?: InputMaybe<Scalars['Int']['input']>;
  /** backwards pagination count */
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type FindSchedulingRegionsOutput = {
  __typename?: 'FindSchedulingRegionsOutput';
  schedulingRegions: Array<SchedulingRegionEntity>;
};

export type FindSegmentedLineHaulOrdersInput = {
  /** forwards pagination cursor */
  after?: InputMaybe<Scalars['String']['input']>;
  /** backwards pagination cursor */
  before?: InputMaybe<Scalars['String']['input']>;
  endTerminalUuid?: InputMaybe<Scalars['String']['input']>;
  /** forwards pagination count, provide this on initial query */
  first?: InputMaybe<Scalars['Int']['input']>;
  /** backwards pagination count */
  last?: InputMaybe<Scalars['Int']['input']>;
  searchText?: InputMaybe<Scalars['String']['input']>;
  serviceDateFilters?: InputMaybe<DateFilterStartEnd>;
  sorts?: InputMaybe<Array<LineHaulOrderSort>>;
  startTerminalUuid?: InputMaybe<Scalars['String']['input']>;
};

export type FindSegmentedLineHaulOrdersInputV2 = {
  endTerminalUuid?: InputMaybe<Scalars['String']['input']>;
  /** Calculate and return the total count. Can be expensive, so use prudently */
  includeCount?: InputMaybe<Scalars['Boolean']['input']>;
  page: Scalars['Int']['input'];
  pageSize: Scalars['Int']['input'];
  searchText?: InputMaybe<Scalars['String']['input']>;
  serviceDateFilters?: InputMaybe<DateFilterStartEnd>;
  sorts?: InputMaybe<Array<LineHaulOrderSort>>;
  startTerminalUuid?: InputMaybe<Scalars['String']['input']>;
};

export type FindServicesForCustomerConfigurationInput = {
  organizationUuid: Scalars['String']['input'];
};

export type FindServicesForCustomerConfigurationOutput = FindServicesForCustomerConfigurationSuccessOutput | QueryErrorOutput;

export type FindServicesForCustomerConfigurationSuccessOutput = {
  __typename?: 'FindServicesForCustomerConfigurationSuccessOutput';
  /** The services available for customer configuration */
  services: Array<ServiceEntity>;
};

export type FindServicesForOrderInput = {
  organizationUuid: Scalars['String']['input'];
  /** The UUID of the currently selected service for the order, if one exists */
  selectedServiceUuid?: InputMaybe<Scalars['String']['input']>;
};

export type FindServicesForOrderOutput = FindServicesForOrderSuccessOutput | QueryErrorOutput;

export type FindServicesForOrderSuccessOutput = {
  __typename?: 'FindServicesForOrderSuccessOutput';
  /** The services available for order */
  services: Array<ServiceEntity>;
};

export type FindServicesForThirdPartyUserInput = {
  companyUuid: Scalars['String']['input'];
};

export type FindSettlementBillLineItemsInput = {
  /** forwards pagination cursor */
  after?: InputMaybe<Scalars['String']['input']>;
  /** backwards pagination cursor */
  before?: InputMaybe<Scalars['String']['input']>;
  /** The completed at date for the relevant stop that is tied to the settlement bill line item */
  completedDateFilter?: InputMaybe<DateFilterV2>;
  driverSettlementBillUuids?: InputMaybe<Array<Scalars['String']['input']>>;
  /** We currently do not have a use case for showing line items on finalized driver settlement bills specifically. */
  driverSettlementFinalized?: InputMaybe<Scalars['Boolean']['input']>;
  driverUuids?: InputMaybe<Array<Scalars['String']['input']>>;
  /** forwards pagination count, provide this on initial query */
  first?: InputMaybe<Scalars['Int']['input']>;
  includeCount?: InputMaybe<Scalars['Boolean']['input']>;
  /** backwards pagination count */
  last?: InputMaybe<Scalars['Int']['input']>;
  /** Pass as true to remove the limit. Use with caution! */
  noMaximum?: InputMaybe<Scalars['Boolean']['input']>;
  onDriverSettlementBill?: InputMaybe<Scalars['Boolean']['input']>;
  searchText?: InputMaybe<Scalars['String']['input']>;
  settlementDateFilter?: InputMaybe<DateFilterV2>;
};

export type FindSftpUploadsInput = {
  /** forwards pagination cursor */
  after?: InputMaybe<Scalars['String']['input']>;
  /** backwards pagination cursor */
  before?: InputMaybe<Scalars['String']['input']>;
  companyUuid?: InputMaybe<Scalars['String']['input']>;
  contactUuid?: InputMaybe<Scalars['String']['input']>;
  /** forwards pagination count, provide this on initial query */
  first?: InputMaybe<Scalars['Int']['input']>;
  /** backwards pagination count */
  last?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<SftpUploadStatus>;
  type?: InputMaybe<SftpUploadType>;
};

export type FindStopsFiltersInput = {
  addressType?: InputMaybe<StandardStopType>;
  appointmentRequired?: InputMaybe<Scalars['Boolean']['input']>;
  appointmentScheduled?: InputMaybe<Scalars['Boolean']['input']>;
  appointmentTimeFilters?: InputMaybe<DateFilterStartEnd>;
  businessDivisionUuid?: InputMaybe<Scalars['String']['input']>;
  canDispatch?: InputMaybe<Scalars['Boolean']['input']>;
  createdAtFilters?: InputMaybe<DateFilterStartEnd>;
  customerUuid?: InputMaybe<Scalars['String']['input']>;
  deadlineDateFilters?: InputMaybe<DateFilterStartEnd>;
  /** Control whether all filters need to be satisfied or at least one. Default is AND. */
  filterOperator?: InputMaybe<FilterOperator>;
  /** Filter by whether a stop has either a start or end appointment time set */
  hasAppointment?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by whether a stop has an appointment date set */
  hasAppointmentDate?: InputMaybe<Scalars['Boolean']['input']>;
  /** This is equivalent to checking if either appointmentSchedulingOptionsCalledAt or appointmentSchedulingOptionsTextedAt is non-null */
  hasAppointmentOptionsProposed?: InputMaybe<Scalars['Boolean']['input']>;
  hideOnHold?: InputMaybe<Scalars['Boolean']['input']>;
  hideStopsWithoutAddress?: InputMaybe<Scalars['Boolean']['input']>;
  isAssigned?: InputMaybe<Scalars['Boolean']['input']>;
  isPicked?: InputMaybe<Scalars['Boolean']['input']>;
  isRefusedFilter?: InputMaybe<BooleanFilterV2>;
  isSpecial?: InputMaybe<Scalars['Boolean']['input']>;
  onHand?: InputMaybe<Scalars['Boolean']['input']>;
  orderStatuses?: InputMaybe<Array<OrderStatus>>;
  orderUuid?: InputMaybe<Scalars['String']['input']>;
  orderUuids?: InputMaybe<Array<Scalars['String']['input']>>;
  pickupOrDeliveryTypes?: InputMaybe<Array<PickupOrDelivery>>;
  previouslyAttempted?: InputMaybe<Scalars['Boolean']['input']>;
  requiresRecovery?: InputMaybe<Scalars['Boolean']['input']>;
  routeNameUuid?: InputMaybe<Scalars['String']['input']>;
  searchText?: InputMaybe<Scalars['String']['input']>;
  serviceDateFilters?: InputMaybe<DateFilterStartEnd>;
  serviceLevelUuids?: InputMaybe<Array<Scalars['String']['input']>>;
  statuses?: InputMaybe<Array<StopStatus>>;
  tagUuids?: InputMaybe<Array<Scalars['String']['input']>>;
  terminalUuid?: InputMaybe<Scalars['String']['input']>;
  transferPending?: InputMaybe<Scalars['Boolean']['input']>;
  uuid?: InputMaybe<Scalars['String']['input']>;
  uuids?: InputMaybe<Array<Scalars['String']['input']>>;
  warehouseUuid?: InputMaybe<Scalars['String']['input']>;
};

export type FindStorageOrderInput = {
  /** The UUID of the storage order to retrieve */
  uuid: Scalars['String']['input'];
};

export type FindStorageOrderOutput = {
  __typename?: 'FindStorageOrderOutput';
  storageOrder: StorageOrderEntity;
};

export type FindStorageOrderStorageUnitsInput = {
  storageOrderUuid: Scalars['String']['input'];
};

export type FindStorageOrderStorageUnitsOutput = {
  __typename?: 'FindStorageOrderStorageUnitsOutput';
  storageUnits: Array<StorageUnitEntity>;
};

export type FindStorageOrdersInput = {
  /** forwards pagination cursor */
  after?: InputMaybe<Scalars['String']['input']>;
  arrivedAtDateFilters?: InputMaybe<DateFilterStartEnd>;
  /** backwards pagination cursor */
  before?: InputMaybe<Scalars['String']['input']>;
  contactUuidFilter?: InputMaybe<StringFilter>;
  expectedAtDateFilters?: InputMaybe<DateFilterStartEnd>;
  /** forwards pagination count, provide this on initial query */
  first?: InputMaybe<Scalars['Int']['input']>;
  /** backwards pagination count */
  last?: InputMaybe<Scalars['Int']['input']>;
  /** Pass as true to remove the limit. Use with caution! */
  noMaximum?: InputMaybe<Scalars['Boolean']['input']>;
  searchText?: InputMaybe<Scalars['String']['input']>;
  /** request total number of records, request with prudence */
  totalCount?: InputMaybe<Scalars['Boolean']['input']>;
  warehouseUuidFilter?: InputMaybe<StringFilter>;
};

export type FindStorageOrdersOutput = {
  __typename?: 'FindStorageOrdersOutput';
  /** A connection that represents paginated storage orders */
  storageOrderConnection: StorageOrderConnection;
};

export type FindStorageUnitInput = {
  uuid: Scalars['String']['input'];
};

export type FindStorageUnitOutput = {
  __typename?: 'FindStorageUnitOutput';
  storageUnit: StorageUnitEntity;
};

export type FindStorageUnitsInput = {
  /** forwards pagination cursor */
  after?: InputMaybe<Scalars['String']['input']>;
  /** backwards pagination cursor */
  before?: InputMaybe<Scalars['String']['input']>;
  billedFilter?: InputMaybe<BooleanFilter>;
  contactUuidFilter?: InputMaybe<StringFilter>;
  /** forwards pagination count, provide this on initial query */
  first?: InputMaybe<Scalars['Int']['input']>;
  /** backwards pagination count */
  last?: InputMaybe<Scalars['Int']['input']>;
  markedOnHandAtDateFilters?: InputMaybe<DateFilterStartEnd>;
  markedOsdAtDateFilters?: InputMaybe<DateFilterStartEnd>;
  /** Pass as true to remove the limit. Use with caution! */
  noMaximum?: InputMaybe<Scalars['Boolean']['input']>;
  pickedAtDateFilters?: InputMaybe<DateFilterStartEnd>;
  searchText?: InputMaybe<Scalars['String']['input']>;
  /** request total number of records, request with prudence */
  totalCount?: InputMaybe<Scalars['Boolean']['input']>;
  warehouseLocationUuidFilter?: InputMaybe<StringFilter>;
};

export type FindStorageUnitsOutput = {
  __typename?: 'FindStorageUnitsOutput';
  /** A connection that represents paginated storage units */
  storageUnitConnection: StorageUnitConnection;
};

export type FindTariffChainsInput = {
  isArchived: Scalars['Boolean']['input'];
};

export type FindTariffGroupsWithContactAndServicesCombinationOutput = {
  __typename?: 'FindTariffGroupsWithContactAndServicesCombinationOutput';
  /** the contact in that group that has a match */
  contactUuid: Scalars['String']['output'];
  /** the services in that group that has a match */
  matchingTariffGroups: Array<MatchingGroupsAlongWithMatchingServices>;
};

export type FindTariffZoneGroupsInput = {
  isArchived: Scalars['Boolean']['input'];
};

export type FindTerminalForAddressInput = {
  city?: InputMaybe<Scalars['String']['input']>;
  zipcode?: InputMaybe<Scalars['String']['input']>;
};

export type FindTerminalForAddressOutput = {
  __typename?: 'FindTerminalForAddressOutput';
  terminal?: Maybe<TerminalEntity>;
};

export type FindTerminalsForAddressOutput = {
  __typename?: 'FindTerminalsForAddressOutput';
  terminals?: Maybe<Array<TerminalEntity>>;
};

export type FindTerminalsForThirdPartyUserInput = {
  companyUuid: Scalars['String']['input'];
  /** Optionally filter by isActive, defaults to including all terminals */
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FindTestOrderInput = {
  uuid: Scalars['String']['input'];
};

export type FindTestOrderOutput = {
  __typename?: 'FindTestOrderOutput';
  testOrder: TestOrderEntity;
};

export type FindTestOrdersOutput = {
  __typename?: 'FindTestOrdersOutput';
  testOrders: Array<TestOrderEntity>;
};

export type FindWarehouseEmployeesOutput = {
  __typename?: 'FindWarehouseEmployeesOutput';
  warehouseEmployees: Array<WarehouseEmployeeEntity>;
};

export type FindWarehouseLocationsOutput = {
  __typename?: 'FindWarehouseLocationsOutput';
  warehouseLocations: Array<WarehouseLocationEntity>;
};

export type FingerprintAnchorEntity = {
  __typename?: 'FingerprintAnchorEntity';
  blockId?: Maybe<Scalars['String']['output']>;
  height: Scalars['Float']['output'];
  left: Scalars['Float']['output'];
  required: Scalars['Boolean']['output'];
  substring?: Maybe<Scalars['String']['output']>;
  text: Scalars['String']['output'];
  top: Scalars['Float']['output'];
  uuid: Scalars['String']['output'];
  width: Scalars['Float']['output'];
};

export type FingerprintAnchorInput = {
  blockId?: InputMaybe<Scalars['String']['input']>;
  height: Scalars['Float']['input'];
  left: Scalars['Float']['input'];
  required: Scalars['Boolean']['input'];
  substring?: InputMaybe<Scalars['String']['input']>;
  text: Scalars['String']['input'];
  top: Scalars['Float']['input'];
  width: Scalars['Float']['input'];
};

export type FingerprintAnchorMatchEntity = {
  __typename?: 'FingerprintAnchorMatchEntity';
  substring?: Maybe<Scalars['String']['output']>;
  text: Scalars['String']['output'];
  uuid: Scalars['String']['output'];
};

export type FingerprintAnchorMatchInput = {
  substring?: InputMaybe<Scalars['String']['input']>;
  text: Scalars['String']['input'];
};

/** A filter object that is used to filter a float field. Each field in the filter object represents an operator. If there is more than one non-null field passed into the filter object, the condition will be a conjunction of the non-null field operator */
export type FloatFilterV2 = {
  /** Filters for records where the relevant float field is equal to the provided float value */
  eq?: InputMaybe<Scalars['Float']['input']>;
  /** Filters for records where the relevant float field is greater than the provided float value */
  gt?: InputMaybe<Scalars['Float']['input']>;
  /** Filters for records where the relevant float field is greater than or equal to the provided float value */
  gte?: InputMaybe<Scalars['Float']['input']>;
  /** Filters for records where the relevant float field is in the provided float values */
  in?: InputMaybe<Array<Scalars['Float']['input']>>;
  /** Filters for records where the relevant float field is less than the provided float value */
  lt?: InputMaybe<Scalars['Float']['input']>;
  /** Filters for records where the relevant float field is less than or equal to the provided float value */
  lte?: InputMaybe<Scalars['Float']['input']>;
  /** Filters for records where the relevant float field is not equal to the provided float value */
  neq?: InputMaybe<Scalars['Float']['input']>;
  /** Filters for records where the relevant float field is not in the provided float values */
  nin?: InputMaybe<Array<Scalars['Float']['input']>>;
};

export type FormatCsvResEntity = {
  __typename?: 'FormatCsvResEntity';
  csvItems: Array<Array<Scalars['String']['output']>>;
  missingAccessorialMappings: Array<Scalars['String']['output']>;
  missingCustomerMappings: Array<Scalars['String']['output']>;
  missingFreightChargeMappings: Array<Scalars['String']['output']>;
  missingFuelChargeMappings: Array<Scalars['String']['output']>;
};

/** Encapsulates the paginated list of formatted orders, statistics, and metadata used in the output of order table field values retrieval queries. */
export type FormattedOrderConnection = {
  __typename?: 'FormattedOrderConnection';
  edges: Array<FormattedOrderEdge>;
  /** Not cheap to calculate, request with prudence.  Group UUID = invoice UUID */
  groupedCountsByInvoice?: Maybe<Array<GroupedCounts>>;
  pageInfo: PageInfo;
  /** Not cheap to calculate, request with prudence */
  totalCount?: Maybe<Scalars['Int']['output']>;
  /** Not cheap to calculate, request with prudence */
  uuids?: Maybe<Array<Scalars['String']['output']>>;
  /** Version ID for the response */
  versionId?: Maybe<Scalars['Float']['output']>;
};

export type FormattedOrderEdge = {
  __typename?: 'FormattedOrderEdge';
  cursor: Scalars['String']['output'];
  node: FormattedOrderEntity;
};

/** Represents a formatted order that is returned as part of an orders query */
export type FormattedOrderEntity = {
  __typename?: 'FormattedOrderEntity';
  /** The UUID of the organization associated with the order */
  contactUuid: Scalars['String']['output'];
  /** The list of formatted fields for the order. The fields whose values are returned are based on which order table fields are passed into the query input */
  formattedOrderFields: Array<FormattedOrderFieldEntity>;
  /** Custom output for the "Total Charges with Itemized" column in the orders table. Null if the value is not requested in the query input */
  itemizedChargesField?: Maybe<OrderTableItemizedChargesFieldEntity>;
  /** Custom output for the "Line Haul Manifests" column in the orders table. Null if the value is not requested in the query input */
  lineHaulManifestsField?: Maybe<OrderTableLineHaulManifestsFieldEntity>;
  /** Custom output for the "Dims" column */
  packagesField?: Maybe<OrderTablePackagesFieldEntity>;
  /** Custom output for the "Paperwork Complete" column in the orders table. Null if the value is not requested in the query input */
  paperworkField?: Maybe<OrderTablePaperworkFieldEntity>;
  /** Custom output for the "Photos" column in the orders table. Null if the value is not requested in the query input */
  photosField?: Maybe<OrderTablePhotosFieldEntity>;
  /** Custom output for the "Primary Service" column in the orders table. Null if the value is not requested in the query input */
  serviceField?: Maybe<OrderTableServiceFieldEntity>;
  /** Custom output for the "Tags" column in the orders table. Null if the value is not requested in the query input */
  tagsField?: Maybe<OrderTableTagsFieldEntity>;
  /** The UUID of the corresponding order */
  uuid: Scalars['String']['output'];
};

export type FormattedOrderFieldEntity = {
  __typename?: 'FormattedOrderFieldEntity';
  orderTableField: OrderTableField;
  value: Scalars['String']['output'];
};

export enum FreightBillingMethod {
  FlatRate = 'FLAT_RATE',
  PerMile = 'PER_MILE',
  PerPiece = 'PER_PIECE',
  Tariff = 'TARIFF',
  Weight = 'WEIGHT'
}

export type FreightChargeCreateInput = {
  authoCode?: InputMaybe<Scalars['String']['input']>;
  billingMethod: FreightBillingMethod;
  description?: InputMaybe<Scalars['String']['input']>;
  /** The discount rate to be applied to the freight charge total. Note that this is a percentage out of 100 */
  discountRate?: InputMaybe<Scalars['Percent']['input']>;
  fuelChargeCreateInput?: InputMaybe<FuelChargeCreateInput>;
  quantity?: InputMaybe<Scalars['Float']['input']>;
  rate: Scalars['Float']['input'];
  settlementFlatRate?: InputMaybe<Scalars['Float']['input']>;
  settlementPercentageRate?: InputMaybe<Scalars['Float']['input']>;
  tariffUuid?: InputMaybe<Scalars['String']['input']>;
  /** The total charge in dollars */
  totalCharge?: InputMaybe<Scalars['Float']['input']>;
};

export type FreightChargeEntity = {
  __typename?: 'FreightChargeEntity';
  authoCode?: Maybe<Scalars['String']['output']>;
  billingMethod: FreightBillingMethod;
  description?: Maybe<Scalars['String']['output']>;
  /** The discount rate for the freight charge as a percentage out of 100 if it exists */
  discountRate?: Maybe<Scalars['Percent']['output']>;
  fuelCharge?: Maybe<FuelChargeEntity>;
  ignoreQuantityRegression: Scalars['Boolean']['output'];
  postedAmountUsdCents?: Maybe<Scalars['Int']['output']>;
  quantity: Scalars['Float']['output'];
  rate: Scalars['Float']['output'];
  settlementFlatRate?: Maybe<Scalars['Float']['output']>;
  settlementPercentageRate?: Maybe<Scalars['Float']['output']>;
  shipment: ShipmentEntity;
  snapshottedAmountUsdCents?: Maybe<Scalars['Int']['output']>;
  tariff?: Maybe<TariffEntity>;
  total: Scalars['Float']['output'];
  totalAmountCents?: Maybe<Scalars['Int']['output']>;
  uuid: Scalars['String']['output'];
};

/** the freight charge amount after prorating */
export type FreightChargeForProrating = {
  __typename?: 'FreightChargeForProrating';
  totalCents: Scalars['Float']['output'];
};

export type FreightChargeUpdateInput = {
  authoCode?: InputMaybe<Scalars['String']['input']>;
  billingMethod?: InputMaybe<FreightBillingMethod>;
  description?: InputMaybe<Scalars['String']['input']>;
  /** The discount rate to be applied to the freight charge total. Note that this is a percentage out of 100 */
  discountRate?: InputMaybe<Scalars['Percent']['input']>;
  fuelChargeUpdateInput?: InputMaybe<FuelChargeUpdateInput>;
  quantity?: InputMaybe<Scalars['Float']['input']>;
  rate?: InputMaybe<Scalars['Float']['input']>;
  settlementFlatRate?: InputMaybe<Scalars['Float']['input']>;
  settlementPercentageRate?: InputMaybe<Scalars['Float']['input']>;
  tariffUuid?: InputMaybe<Scalars['String']['input']>;
  /** The total charge in dollars */
  totalCharge?: InputMaybe<Scalars['Float']['input']>;
  uuid: Scalars['String']['input'];
};

export type FreightChargeUpsertInput = {
  authoCode?: InputMaybe<Scalars['String']['input']>;
  billingMethod: FreightBillingMethod;
  description?: InputMaybe<Scalars['String']['input']>;
  /** The discount rate to be applied to the freight charge total. Note that this is a percentage out of 100 */
  discountRate?: InputMaybe<Scalars['Percent']['input']>;
  fuelChargeUpsertInput?: InputMaybe<FuelChargeUpsertInput>;
  quantity?: InputMaybe<Scalars['Float']['input']>;
  rate: Scalars['Float']['input'];
  settlementFlatRate?: InputMaybe<Scalars['Float']['input']>;
  settlementPercentageRate?: InputMaybe<Scalars['Float']['input']>;
  tariffUuid?: InputMaybe<Scalars['String']['input']>;
  /** The total charge in dollars */
  totalCharge?: InputMaybe<Scalars['Float']['input']>;
  uuid: Scalars['String']['input'];
};

export type FreightCostEntity = {
  __typename?: 'FreightCostEntity';
  billingMethod?: Maybe<FreightBillingMethod>;
  dependentSettlementBillingMethod?: Maybe<DependentSettlementBillingMethod>;
  description?: Maybe<Scalars['String']['output']>;
  /** The discount rate for the freight cost as a percentage out of 100 if it exists */
  discountRate?: Maybe<Scalars['Percent']['output']>;
  /** The flat rate of the freight cost in dollars, if it exists */
  flatRateUsdDollars?: Maybe<Scalars['Float']['output']>;
  fuelCost?: Maybe<FuelCostEntity>;
  id: Scalars['String']['output'];
  /** The percentage rate for the freight cost as a percentage out of 100 if it exists */
  percentageRate?: Maybe<Scalars['Percent']['output']>;
  quantity?: Maybe<Scalars['Float']['output']>;
  /** The rate of the freight cost in dollars, if it exists */
  rateUsdDollars?: Maybe<Scalars['Float']['output']>;
  tariff?: Maybe<TariffEntity>;
  /** @deprecated Use totalAmountUsdDollars instead. This field will be removed in a future release. */
  totalAmountUsdCents: Scalars['Float']['output'];
  /** The total cost for the freight cost in dollars if it exists. Meant for presentation */
  totalAmountUsdDollars?: Maybe<Scalars['Float']['output']>;
};

export type FreightSnapCreateInput = {
  freightSnapTransactionUuid: Scalars['String']['input'];
  proNum?: InputMaybe<Scalars['String']['input']>;
};

export enum FreightSnapFailureReason {
  EmptyFreightSnapDimensions = 'EMPTY_FREIGHT_SNAP_DIMENSIONS',
  NoMatch = 'NO_MATCH',
  NoShipmentsFoundForOrder = 'NO_SHIPMENTS_FOUND_FOR_ORDER',
  Unknown = 'UNKNOWN'
}

export type FreightSnapTransactionEntity = {
  __typename?: 'FreightSnapTransactionEntity';
  createdAt: Scalars['DateTime']['output'];
  ehdim?: Maybe<Scalars['String']['output']>;
  eldim?: Maybe<Scalars['String']['output']>;
  ewdim?: Maybe<Scalars['String']['output']>;
  failureReason?: Maybe<FreightSnapFailureReason>;
  imgs: Array<Scalars['String']['output']>;
  order?: Maybe<OrderEntity>;
  proNum?: Maybe<Scalars['String']['output']>;
  status?: Maybe<FreightSnapTransactionStatus>;
  updatedAt: Scalars['DateTime']['output'];
  uuid: Scalars['String']['output'];
  weight?: Maybe<Scalars['String']['output']>;
};

export enum FreightSnapTransactionStatus {
  Failed = 'FAILED',
  Processing = 'PROCESSING',
  Success = 'SUCCESS'
}

export enum FuelBillingMethod {
  AutoCalculate = 'AUTO_CALCULATE',
  FlatRate = 'FLAT_RATE',
  None = 'NONE',
  Percentage = 'PERCENTAGE'
}

export type FuelChargeCreateInput = {
  authoCode?: InputMaybe<Scalars['String']['input']>;
  autoCalculate?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  flatRate?: InputMaybe<Scalars['Float']['input']>;
  settlementFlatRate?: InputMaybe<Scalars['Float']['input']>;
  settlementPercentageRate?: InputMaybe<Scalars['Float']['input']>;
  surchargeRate: Scalars['Float']['input'];
  /** The total charge in dollars */
  totalCharge?: InputMaybe<Scalars['Float']['input']>;
  type: FuelBillingMethod;
};

export type FuelChargeEntity = {
  __typename?: 'FuelChargeEntity';
  authoCode?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use the AUTO_CALCULATE FuelBillingMethod value instead */
  autoCalculate: Scalars['Boolean']['output'];
  description?: Maybe<Scalars['String']['output']>;
  flatRate: Scalars['Float']['output'];
  freightCharge: FreightChargeEntity;
  postedAmountUsdCents?: Maybe<Scalars['Int']['output']>;
  settlementFlatRate?: Maybe<Scalars['Float']['output']>;
  settlementPercentageRate?: Maybe<Scalars['Float']['output']>;
  surchargeRate: Scalars['Float']['output'];
  /** @deprecated this value is wrong!! use shipmentCharges.totalFuelCharge on shipment instead */
  total: Scalars['Float']['output'];
  totalAmountCents?: Maybe<Scalars['Int']['output']>;
  type: FuelBillingMethod;
  uuid: Scalars['String']['output'];
};

/** the fuel charge amount after prorating */
export type FuelChargeForProrating = {
  __typename?: 'FuelChargeForProrating';
  totalCents: Scalars['Float']['output'];
};

export type FuelChargeFuelProfileDateRangeInput = {
  /** The appointment date for the fuel charge's stop */
  appointmentDate?: InputMaybe<Scalars['DateTime']['input']>;
  contactUuid: Scalars['String']['input'];
  /** The service date for the fuel charge's stop */
  serviceDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** The date the fuel charge's stop was completed */
  stopCompletedDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** The UUID of the fuel profile attached to the tariff selected for the stop */
  tariffGroupFuelProfileUuid?: InputMaybe<Scalars['String']['input']>;
};

export type FuelChargeFuelProfileDateRangeOutput = {
  __typename?: 'FuelChargeFuelProfileDateRangeOutput';
  fuelProfileDateRange?: Maybe<FuelProfileDateRangeEntity>;
};

export type FuelChargeUpdateInput = {
  authoCode?: InputMaybe<Scalars['String']['input']>;
  autoCalculate?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  flatRate?: InputMaybe<Scalars['Float']['input']>;
  settlementFlatRate?: InputMaybe<Scalars['Float']['input']>;
  settlementPercentageRate?: InputMaybe<Scalars['Float']['input']>;
  surchargeRate?: InputMaybe<Scalars['Float']['input']>;
  /** The total charge in dollars */
  totalCharge?: InputMaybe<Scalars['Float']['input']>;
  type?: InputMaybe<FuelBillingMethod>;
  uuid: Scalars['String']['input'];
};

export type FuelChargeUpsertInput = {
  authoCode?: InputMaybe<Scalars['String']['input']>;
  autoCalculate?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  flatRate?: InputMaybe<Scalars['Float']['input']>;
  settlementFlatRate?: InputMaybe<Scalars['Float']['input']>;
  settlementPercentageRate?: InputMaybe<Scalars['Float']['input']>;
  surchargeRate: Scalars['Float']['input'];
  /** The total charge in dollars */
  totalCharge?: InputMaybe<Scalars['Float']['input']>;
  type: FuelBillingMethod;
  uuid: Scalars['String']['input'];
};

export type FuelCostEntity = {
  __typename?: 'FuelCostEntity';
  billingMethod?: Maybe<FuelBillingMethod>;
  dependentSettlementBillingMethod?: Maybe<DependentSettlementBillingMethod>;
  /** The flat rate of the fuel cost in dollars, if it exists */
  flatRateUsdDollars?: Maybe<Scalars['Float']['output']>;
  id: Scalars['String']['output'];
  /** The percentage rate for the fuel cost as a percentage out of 100 if it exists */
  percentageRate?: Maybe<Scalars['Percent']['output']>;
  /** The surcharge rate for the fuel cost as a percentage out of 100 if it exists */
  surchargeRate?: Maybe<Scalars['Float']['output']>;
  /** @deprecated Use totalAmountUsdDollars instead. This field will be removed in a future release. */
  totalAmountUsdCents: Scalars['Float']['output'];
  /** The total cost for the fuel cost in dollars if it exists. Meant for presentation */
  totalAmountUsdDollars?: Maybe<Scalars['Float']['output']>;
};

export type FuelProfileDateRangeEntity = {
  __typename?: 'FuelProfileDateRangeEntity';
  createdAt: Scalars['DateTime']['output'];
  expirationDate: Scalars['DateTime']['output'];
  flatRateUsdCents?: Maybe<Scalars['Float']['output']>;
  settlementPercentageRate?: Maybe<Scalars['Float']['output']>;
  startDate: Scalars['DateTime']['output'];
  surchargeRate?: Maybe<Scalars['Float']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  uuid: Scalars['String']['output'];
};

export type FuelProfileEntity = {
  __typename?: 'FuelProfileEntity';
  billingType: FuelBillingMethod;
  company: CompanyEntity;
  contacts?: Maybe<Array<ContactEntity>>;
  createdAt: Scalars['DateTime']['output'];
  expirationDate?: Maybe<Scalars['DateTime']['output']>;
  flatRateUsdCents?: Maybe<Scalars['Int']['output']>;
  fuelProfileDateRanges: Array<FuelProfileDateRangeEntity>;
  name?: Maybe<Scalars['String']['output']>;
  startDate?: Maybe<Scalars['DateTime']['output']>;
  surchargeRate: Scalars['Float']['output'];
  tariffGroups: Array<TariffGroupEntity>;
  type: FuelProfileType;
  updatedAt: Scalars['DateTime']['output'];
  uuid: Scalars['String']['output'];
};

export enum FuelProfileType {
  ContactSpecific = 'CONTACT_SPECIFIC',
  Global = 'GLOBAL'
}

export enum FulfillmentType {
  Dedicated = 'DEDICATED',
  MultiTrip = 'MULTI_TRIP'
}

export type FuzzySearchItemsBySkuNameInput = {
  contactUuid?: InputMaybe<Scalars['String']['input']>;
  sku: Scalars['String']['input'];
};

export type FuzzySearchItemsBySkuNameOutput = {
  __typename?: 'FuzzySearchItemsBySkuNameOutput';
  /** The item whose SKU most closely matches the specified SKU */
  item?: Maybe<ItemEntity>;
};

export type FuzzySearchOrdersByShipperBillOfLadingNumberInput = {
  shipperBillOfLadingNumber: Scalars['String']['input'];
};

export type FuzzySearchOrdersByShipperBillOfLadingNumberOutput = {
  __typename?: 'FuzzySearchOrdersByShipperBillOfLadingNumberOutput';
  /** The candidate orders whose shipper BOLs meet the similarity threshold for the specified BOL */
  orders: Array<OrderEntity>;
};

export type FuzzySearchStorageOrdersInput = {
  searchText: Scalars['String']['input'];
};

export type FuzzySearchStorageOrdersOutput = {
  __typename?: 'FuzzySearchStorageOrdersOutput';
  storageOrders: Array<StorageOrderEntity>;
};

export type FuzzySearchStorageUnitsInput = {
  searchText: Scalars['String']['input'];
};

export type FuzzySearchStorageUnitsOutput = {
  __typename?: 'FuzzySearchStorageUnitsOutput';
  storageUnits: Array<StorageUnitEntity>;
};

export type GlCodeReportPdfInput = {
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  terminalUuid?: InputMaybe<Scalars['String']['input']>;
};

export type GeneralLedgerCodeCreateInput = {
  code: Scalars['String']['input'];
  configurationId: Scalars['String']['input'];
  description: Scalars['String']['input'];
};

export type GeneralLedgerCodeDeleteInput = {
  id: Scalars['String']['input'];
};

export type GeneralLedgerCodeEntity = {
  __typename?: 'GeneralLedgerCodeEntity';
  accessorials: Array<AccessorialUnion>;
  code: Scalars['String']['output'];
  creditTypes: Array<CreditTypeEntity>;
  description: Scalars['String']['output'];
  id: Scalars['String']['output'];
};

export type GeneralLedgerCodeUpdateInput = {
  code?: InputMaybe<Scalars['String']['input']>;
  configurationId?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
};

export type GeneralLedgerConfigurationEntity = {
  __typename?: 'GeneralLedgerConfigurationEntity';
  accessorialFallbackCodeId?: Maybe<Scalars['String']['output']>;
  deliveryChargeCodeId?: Maybe<Scalars['String']['output']>;
  fuelChargeCodeId?: Maybe<Scalars['String']['output']>;
  generalLedgerCodes: Array<GeneralLedgerCodeEntity>;
  id: Scalars['String']['output'];
  lineHaulChargeCodeId?: Maybe<Scalars['String']['output']>;
  orderChargeCodeId?: Maybe<Scalars['String']['output']>;
  pickupChargeCodeId?: Maybe<Scalars['String']['output']>;
  recoveryChargeCodeId?: Maybe<Scalars['String']['output']>;
  transferChargeCodeId?: Maybe<Scalars['String']['output']>;
};

export type GeneralLedgerConfigurationUpdateInput = {
  accessorialFallbackCodeId?: InputMaybe<Scalars['String']['input']>;
  deliveryChargeCodeId?: InputMaybe<Scalars['String']['input']>;
  fuelChargeCodeId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  lineHaulChargeCodeId?: InputMaybe<Scalars['String']['input']>;
  orderChargeCodeId?: InputMaybe<Scalars['String']['input']>;
  pickupChargeCodeId?: InputMaybe<Scalars['String']['input']>;
  recoveryChargeCodeId?: InputMaybe<Scalars['String']['input']>;
  transferChargeCodeId?: InputMaybe<Scalars['String']['input']>;
};

export type GenerateAccountingReportPreSignedPutUrlInput = {
  companyUuid: Scalars['String']['input'];
  fileName: Scalars['String']['input'];
  fileType: Scalars['String']['input'];
};

export type GenerateClearCompanyContactsTokenInput = {
  companyUuid: Scalars['String']['input'];
};

export type GenerateClearCompanyContactsTokenOutput = {
  __typename?: 'GenerateClearCompanyContactsTokenOutput';
  token: Scalars['String']['output'];
};

export type GenerateContactPreSignedPutUrlInput = {
  contactUuid: Scalars['String']['input'];
  fileName: Scalars['String']['input'];
  fileType: Scalars['String']['input'];
};

export type GenerateCsvOrderPresignedPutUrlInput = {
  filename: Scalars['String']['input'];
  filetype: Scalars['String']['input'];
};

export type GenerateCsvPresignedPutUrlForMappingPreviewInput = {
  filename: Scalars['String']['input'];
  filetype: Scalars['String']['input'];
};

export type GenerateCsvPresignedPutUrlForMappingPreviewOutput = {
  __typename?: 'GenerateCsvPresignedPutUrlForMappingPreviewOutput';
  bucket: Scalars['String']['output'];
  filename: Scalars['String']['output'];
  filetype: Scalars['String']['output'];
  key: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type GenerateDefaultAppointmentTextsArgs = {
  appointmentUuids: Array<Scalars['String']['input']>;
};

export type GenerateHistoricalInvoicesCsvInput = {
  companyUuid: Scalars['String']['input'];
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
};

export type GenerateHistoricalInvoicesCsvOutput = {
  __typename?: 'GenerateHistoricalInvoicesCsvOutput';
  s3Url?: Maybe<Scalars['String']['output']>;
};

export type GenerateInvoicePreSignedPutUrlInput = {
  fileName: Scalars['String']['input'];
  fileType: Scalars['String']['input'];
  invoiceUuid: Scalars['String']['input'];
};

export type GenerateInvoicePreSignedPutUrlOutput = {
  __typename?: 'GenerateInvoicePreSignedPutUrlOutput';
  invoiceUuid: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type GenerateInvoicePreSignedPutUrlsInput = {
  generateInvoicePreSignedPutUrlInputs: Array<GenerateInvoicePreSignedPutUrlInput>;
};

export type GenerateLabelInput = {
  /** The ZPL data to be used to generate the label */
  zplData: Scalars['String']['input'];
};

export type GenerateOrderDocumentPreSignedPutUrlInput = {
  companyUuid?: InputMaybe<Scalars['String']['input']>;
  fileName: Scalars['String']['input'];
  fileType: Scalars['String']['input'];
};

export type GenerateOrderPreSignedGetAndPutUrlsInput = {
  fileType: Scalars['String']['input'];
};

export type GenerateOrderPreSignedGetAndPutUrlsOutput = {
  __typename?: 'GenerateOrderPreSignedGetAndPutUrlsOutput';
  getUrl: Scalars['String']['output'];
  putUrl: Scalars['String']['output'];
};

export type GenerateOrderPreSignedPutUrlInput = {
  fileName: Scalars['String']['input'];
  fileType: Scalars['String']['input'];
  orderUuid: Scalars['String']['input'];
};

export type GeneratePodReportPreSignedPutUrlInput = {
  fileName: Scalars['String']['input'];
  fileType: Scalars['String']['input'];
  orderUuid: Scalars['String']['input'];
};

export type GeneratePreSignedPutUrlOutput = {
  __typename?: 'GeneratePreSignedPutUrlOutput';
  url: Scalars['String']['output'];
};

export type GenerateResetCompanyTokenInput = {
  companyUuid: Scalars['String']['input'];
  password: Scalars['String']['input'];
};

export type GenerateResetCompanyTokenOutput = {
  __typename?: 'GenerateResetCompanyTokenOutput';
  token: Scalars['String']['output'];
};

export type GenerateRoutesInput = {
  appointmentWindowType: AppointmentWindowType;
  driverEquipmentConstraints: Array<DriverEquipmentConstraintInput>;
  stopUuids: Array<Scalars['String']['input']>;
  terminalUuid?: InputMaybe<Scalars['String']['input']>;
};

export type GenerateRoutesOutput = {
  __typename?: 'GenerateRoutesOutput';
  errorMessage?: Maybe<Scalars['String']['output']>;
  routes?: Maybe<Array<RouteGenerationPreviewEntity>>;
  unassignedStopUuids?: Maybe<Array<Scalars['String']['output']>>;
};

export type GenerateShipmentPreSignedPutUrlInput = {
  fileName: Scalars['String']['input'];
  fileType: Scalars['String']['input'];
  shipmentUuid: Scalars['String']['input'];
};

export type GenerateStorageOrderPreSignedPutUrlInput = {
  fileName: Scalars['String']['input'];
  fileType: Scalars['String']['input'];
  storageOrderUuid: Scalars['String']['input'];
};

export type GenerateStorageOrderPreSignedPutUrlOutput = {
  __typename?: 'GenerateStorageOrderPreSignedPutUrlOutput';
  preSignedPutUrl: Scalars['String']['output'];
};

export type GetCityAndStateOptionsFromZipcodeInput = {
  zipcode: Scalars['String']['input'];
};

export type GetCityAndStateOptionsFromZipcodeOutput = {
  __typename?: 'GetCityAndStateOptionsFromZipcodeOutput';
  /** A list of city and state options that the zipcode could apply to */
  citiesAndStates: Array<CityAndStateOptionEntity>;
  /** The zipcode that was used to retrieve city and state options */
  zipcode: Scalars['String']['output'];
};

export type GetDispatchableDriversInput = {
  /** If provided, we will return all drivers that are assigned to this terminal or to an agent terminal in the same service region as that terminal */
  terminalUuid?: InputMaybe<Scalars['String']['input']>;
};

export type GetDispatchableDriversOutput = {
  __typename?: 'GetDispatchableDriversOutput';
  /** Agents under the company that have drivers that are dispatchable given some inputs */
  agents: Array<DispatchableAgentEntity>;
  /** Non-agent drivers under the company that are dispatchable given some inputs */
  companyDrivers: Array<DriverEntity>;
};

export type GetFeatureFlagCompanyOverridesInput = {
  featureFlagUuid: Scalars['String']['input'];
};

export type GetFeatureFlagUserOverridesInput = {
  featureFlagUuid: Scalars['String']['input'];
  userUuid?: InputMaybe<Scalars['String']['input']>;
};

export type GetInvoiceCsvsInput = {
  uuids: Array<Scalars['String']['input']>;
};

export type GetLineHaulProgressInput = {
  uuid: Scalars['String']['input'];
};

export type GetLineHaulProgressOutput = {
  __typename?: 'GetLineHaulProgressOutput';
  /** each terminal's status in the line haul */
  terminalStatuses: Array<LineHaulStatusByTerminal>;
};

export type GetOrderAuditLogEntriesInput = {
  orderUuid: Scalars['String']['input'];
};

export type GetOrderAuditLogEntriesOutput = {
  __typename?: 'GetOrderAuditLogEntriesOutput';
  auditLogEntries: Array<AuditLogEntry>;
};

export type GetOrderTableFieldHeadersOutput = {
  __typename?: 'GetOrderTableFieldHeadersOutput';
  /** The list of table headers for all order table fields */
  orderTableFieldHeaders: Array<OrderTableFieldHeaderEntity>;
};

export type GetOrderTableFieldValuesInput = {
  /** A UUID filter intended for the active terminal */
  activeTerminalFilter?: InputMaybe<StringFilterV2>;
  activeTerminalUuidFilter?: InputMaybe<StringFilter>;
  addressCityFilter?: InputMaybe<StringFilter>;
  addressZipFilter?: InputMaybe<StringFilter>;
  /** forwards pagination cursor */
  after?: InputMaybe<Scalars['String']['input']>;
  appointmentRequired?: InputMaybe<BooleanFilter>;
  appointmentRequiredFilter?: InputMaybe<BooleanFilterV2>;
  attemptedAtDateFilters?: InputMaybe<DateFilterStartEnd>;
  /** A date filter intended for the order attempted date. Currently only implemented for the flat orders view. */
  attemptedDateFilter?: InputMaybe<DateFilterV2>;
  /** backwards pagination cursor */
  before?: InputMaybe<Scalars['String']['input']>;
  billingPartyContactDisplayNameFilter?: InputMaybe<StringFilter>;
  billingPartyContactUuidFilter?: InputMaybe<StringFilter>;
  /** Searches for orders with one of these contacts. Null represents no filter being applied at all (equivalent to "All"). An empty array should not be passed in since orders must always have a billing party contact. */
  billingPartyContactUuidsFilter?: InputMaybe<StringsFilter>;
  businessDivisionNameFilter?: InputMaybe<StringFilterV2>;
  businessDivisionUuidFilter?: InputMaybe<StringFilter>;
  businessDivisionUuidFilterV2?: InputMaybe<StringFilterV2>;
  /** A boolean filter intended for the can dispatch boolean status. Currently only implemented for the flat orders view. */
  canDispatchFilter?: InputMaybe<BooleanFilterV2>;
  /** A date filter intended for the completed at order table field */
  completedAtDateFilter?: InputMaybe<DateFilterV2>;
  completionDateFilters?: InputMaybe<DateFilterStartEnd>;
  consigneeFilter?: InputMaybe<StringFilter>;
  controllingTerminalUuidFilter?: InputMaybe<StringFilter>;
  controllingTerminalUuidFilterV2?: InputMaybe<StringFilterV2>;
  createdAtDateFilters?: InputMaybe<DateFilterStartEnd>;
  /** A date filter intended for the order created date. Currently only implemented for the flat orders view. */
  createdDateFilter?: InputMaybe<DateFilterV2>;
  customerFilter?: InputMaybe<StringFilter>;
  /** A string filter intended for the customer name field */
  customerNameFilter?: InputMaybe<StringFilterV2>;
  /** A filter for the customer portal order review status. */
  customerPortalOrderReviewStatusFilter?: InputMaybe<CustomerPortalOrderReviewStatusFilter>;
  /** A UUID filter for the customer */
  customerUuidFilter?: InputMaybe<StringFilterV2>;
  /** A date filter intended for the order deadline date. Currently only implemented for the flat orders view. */
  deadlineDateFilter?: InputMaybe<DateFilterV2>;
  deadlineDateFilters?: InputMaybe<DateFilterStartEnd>;
  destinationTerminalUuidFilter?: InputMaybe<StringFilterNullable>;
  /** A UUID filter intended for the destination terminal */
  destinationTerminalUuidFilterV2?: InputMaybe<StringFilterV2>;
  /** A float filter intended for the dim weight. Currently only implemented for the flat orders view. */
  dimWeightFilter?: InputMaybe<FloatFilterV2>;
  /** A string filter intended for the driver name flat order table field */
  driverNameFilter?: InputMaybe<StringFilterV2>;
  driverUuidFilter?: InputMaybe<StringFilter>;
  driverUuidFilterV2?: InputMaybe<StringFilterV2>;
  /** Searches for orders with one of these drivers. An empty values array represents orders with no driver (equivalent to "None"). Null represents no filter being applied at all (equivalent to "All"). */
  driverUuidsFilter?: InputMaybe<StringsFilter>;
  endStopFilter?: InputMaybe<StringFilter>;
  expectedInboundArrivalDateFilters?: InputMaybe<DateFilterStartEnd>;
  /** A string filter intended for the order external notes. Currently only implemented for the flat orders view. */
  externalNotesFilter?: InputMaybe<StringFilterV2>;
  filters?: InputMaybe<FindOrdersFiltersInput>;
  /** forwards pagination count, provide this on initial query */
  first?: InputMaybe<Scalars['Int']['input']>;
  hasAppointmentScheduled?: InputMaybe<BooleanFilter>;
  hasAppointmentScheduledFilter?: InputMaybe<BooleanFilterV2>;
  hasContactInformation?: InputMaybe<BooleanFilter>;
  hasContactInformationFilter?: InputMaybe<BooleanFilterV2>;
  hasFailures?: InputMaybe<BooleanFilter>;
  hasFailuresFilter?: InputMaybe<BooleanFilterV2>;
  hasQuotesFilter?: InputMaybe<BooleanFilterV2>;
  hasRoute?: InputMaybe<BooleanFilter>;
  hasRouteFilter?: InputMaybe<BooleanFilterV2>;
  /** A string filter intended for the HAWB order table field */
  hawbFilter?: InputMaybe<StringFilterV2>;
  hideFromBilling?: InputMaybe<BooleanFilter>;
  hideFromBillingFilter?: InputMaybe<BooleanFilterV2>;
  /** A boolean filter intended for filtering out shipments associated with a consolidated order in the old consolidated order flow. */
  hideOriginalConsolidatedOrderIdFilter?: InputMaybe<BooleanFilterV2>;
  /** A string filter intended for the hold reason. Currently only implemented for the flat orders view. */
  holdReasonFilter?: InputMaybe<StringFilterV2>;
  /** A string filter intended for the secondary reference number on the inbound address table field */
  inboundAddressFilter?: InputMaybe<StringFilterV2>;
  /** A string filter intended for inbound address type. Currently only implemented for the flat orders view. */
  inboundAddressTypeFilter?: InputMaybe<StandardStopTypeFilter>;
  /** A boolean filter intended for a confirmed inbound appointment. Currently only implemented for the flat orders view. */
  inboundAppointmentConfirmedFilter?: InputMaybe<BooleanFilterV2>;
  /** A date filter intended for the inbound appointment date. Currently only implemented for the flat orders view. */
  inboundAppointmentDateFilter?: InputMaybe<DateFilterV2>;
  /** A boolean filter intended for the inbound appointment required. Currently only implemented for the flat orders view. */
  inboundAppointmentRequiredFilter?: InputMaybe<BooleanFilterV2>;
  /** A string filter intended for the INBOUND_CITY_NAME order table field */
  inboundCityFilter?: InputMaybe<StringFilterV2>;
  /** A date filter intended for the inbound completed date order table field */
  inboundCompletedDateFilter?: InputMaybe<DateFilterV2>;
  /** A boolean filter intended to filter for inbound stop completion. Currently only implemented for the flat orders view. */
  inboundCompletedFilter?: InputMaybe<BooleanFilterV2>;
  /** A string filter intended for the inbound contact name. Currently only implemented for the flat orders view. */
  inboundContactNameFilter?: InputMaybe<StringFilterV2>;
  /** A string filter intended for the inbound driver name flat order table field */
  inboundDriverNameFilter?: InputMaybe<StringFilterV2>;
  inboundDriverUuidFilter?: InputMaybe<StringFilterV2>;
  inboundDriverUuidsFilter?: InputMaybe<StringsFilter>;
  inboundMethodFilter?: InputMaybe<StopType>;
  inboundMethodFilterV2?: InputMaybe<StopTypesV2Filter>;
  inboundNotArrived?: InputMaybe<BooleanFilter>;
  inboundNotArrivedFilter?: InputMaybe<BooleanFilterV2>;
  /** A date filter intended for the inbound route date. Currently only implemented for the flat orders view. */
  inboundRouteDateFilter?: InputMaybe<DateFilterV2>;
  /** A string filter intended for the inbound route name. Currently only implemented for the flat orders view. */
  inboundRouteNameFilter?: InputMaybe<StringFilterV2>;
  /** A string filter intended for the inbound routing field. Currently only implemented for the flat orders view. */
  inboundRoutingFilter?: InputMaybe<StringFilterV2>;
  /** A date filter intended for the INBOUND_SERVICE_DATE order table field */
  inboundServiceDateFilter?: InputMaybe<DateFilterV2>;
  /** A filter intended for the inbound stop type filter. Currently only implemented for the flat orders view. */
  inboundStopTypeFilter?: InputMaybe<StopTypeFilter>;
  /** A string filter intended for the inbound terminal name field */
  inboundTerminalFilter?: InputMaybe<StringFilterV2>;
  /** A filter intended for the inbound zipcode filter. Currently only implemented for the flat orders view. */
  inboundZipcodeFilter?: InputMaybe<StringFilterV2>;
  /** If set to true, includes the formatted orders with the requested field values as part of the output */
  includeOrders?: InputMaybe<Scalars['Boolean']['input']>;
  /** A boolean filter intended to filter by whether order is part of a consolidated order. */
  includeOrdersPartOfV2ConsolidatedOrders?: InputMaybe<BooleanFilterV2>;
  /** A date filter intended for the order invoice date. Currently only implemented for the flat orders view. */
  invoiceDateFilter?: InputMaybe<DateFilterV2>;
  invoiceDateFilters?: InputMaybe<DateFilterStartEnd>;
  invoiceUuid?: InputMaybe<Scalars['String']['input']>;
  isCancelled?: InputMaybe<BooleanFilter>;
  isCancelledFilter?: InputMaybe<BooleanFilterV2>;
  isCollectOnDelivery?: InputMaybe<Scalars['Boolean']['input']>;
  isCollectOnDeliveryFilter?: InputMaybe<BooleanFilterV2>;
  isDraftOrderFilter?: InputMaybe<BooleanFilterV2>;
  isFinalized?: InputMaybe<BooleanFilter>;
  isFinalizedFilter?: InputMaybe<BooleanFilterV2>;
  isHazmat?: InputMaybe<BooleanFilter>;
  isHazmatFilter?: InputMaybe<BooleanFilterV2>;
  isInBond?: InputMaybe<BooleanFilter>;
  isInBondFilter?: InputMaybe<BooleanFilterV2>;
  isLineHaul?: InputMaybe<BooleanFilter>;
  isLineHaulFilter?: InputMaybe<BooleanFilterV2>;
  isOsd?: InputMaybe<BooleanFilter>;
  isOsdFilter?: InputMaybe<BooleanFilterV2>;
  isPicked?: InputMaybe<BooleanFilter>;
  isPickedFilter?: InputMaybe<BooleanFilterV2>;
  isPickupOrDelivery?: InputMaybe<BooleanFilter>;
  isPickupOrDeliveryFilter?: InputMaybe<BooleanFilterV2>;
  isRefused?: InputMaybe<BooleanFilter>;
  isRefusedFilter?: InputMaybe<BooleanFilterV2>;
  /** A boolean filter intended for the orders that are reweighed. Currently only implemented for the flat orders view. */
  isReweighedFilter?: InputMaybe<BooleanFilterV2>;
  isSpecial?: InputMaybe<BooleanFilter>;
  isSpecialFilter?: InputMaybe<BooleanFilterV2>;
  /** A string filter intended for the IT number order table field */
  itNumberFilter?: InputMaybe<StringFilterV2>;
  /** backwards pagination count */
  last?: InputMaybe<Scalars['Int']['input']>;
  /** A UUID filter for the end terminal of the last line haul manifest that the order is on */
  lastLineHaulTerminalUuidFilter?: InputMaybe<UuidFilterV2>;
  /** A UUID filter for the line haul lane field. Currently only implemented for the flat orders view. */
  lineHaulLaneFilter?: InputMaybe<UuidFilterV2>;
  lineHaulLaneUuids?: InputMaybe<Array<Scalars['String']['input']>>;
  /** A UUID list filter for the terminals that the line haul manifests include */
  lineHaulTerminalUuidsFilter?: InputMaybe<UuidListFilter>;
  /** A date filter intended for the date marked on hand. Currently only implemented for the flat orders view. */
  markedOnHandDateFilter?: InputMaybe<DateFilterV2>;
  /** A string filter intended for the MAWB order table field */
  mawbFilter?: InputMaybe<StringFilterV2>;
  multipleSearches?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Pass as true to remove the limit. Use with caution! */
  noMaximum?: InputMaybe<Scalars['Boolean']['input']>;
  noTerminal?: InputMaybe<BooleanFilter>;
  onHand?: InputMaybe<BooleanFilter>;
  onHandFilter?: InputMaybe<BooleanFilterV2>;
  /** A filter intended for the on hand terminal. Currently only implemented for the flat orders view and is used in context of line haul orders. */
  onHandTerminalFilter?: InputMaybe<UuidFilterV2>;
  /** A boolean filter intended for on hold orders. Currently only implemented for the flat orders view. */
  onHoldFilter?: InputMaybe<BooleanFilterV2>;
  onInvoice?: InputMaybe<BooleanFilter>;
  onInvoiceFilter?: InputMaybe<BooleanFilterV2>;
  /** A string filter intended for the order city */
  orderCityFilter?: InputMaybe<StringFilterV2>;
  /** A string filter intended for the order name order table field */
  orderNameFilterV2?: InputMaybe<StringFilterV2>;
  /** A string filter intended for the order notes. Currently only implemented for the flat orders view. */
  orderNotesFilter?: InputMaybe<StringFilterV2>;
  orderNumberFilter?: InputMaybe<StringFilter>;
  /** A date filter intended for the order service date order table field */
  orderServiceDateFilter?: InputMaybe<DateFilterV2>;
  orderSource?: InputMaybe<OrderSource>;
  /** An enum filter intended for the ORDER_SOURCE order table field */
  orderSourceFilter?: InputMaybe<OrderSourceFilter>;
  /** A filter intended for the order status. Currently only implemented for the flat orders view. */
  orderStatusFilter?: InputMaybe<OrderStatusFilter>;
  /** The list of order table fields to fetch values for */
  orderTableFields: Array<OrderTableField>;
  /** A string filter intended for the order zipcode */
  orderZipFilter?: InputMaybe<StringFilterV2>;
  originTerminalUuidFilter?: InputMaybe<StringFilterNullable>;
  /** A UUID filter intended for the origin terminal */
  originTerminalUuidFilterV2?: InputMaybe<StringFilterV2>;
  /** A string filter intended for the OSD reason. Currently only implemented for the flat orders view. */
  osdReasonFilter?: InputMaybe<StringFilterV2>;
  outForDeliveryFilter?: InputMaybe<BooleanFilter>;
  outForDeliveryFilterV2?: InputMaybe<BooleanFilterV2>;
  /** A string filter intended for the secondary reference number on the outbound address table field */
  outboundAddressFilter?: InputMaybe<StringFilterV2>;
  /** A string filter intended for outbound address type. Currently only implemented for the flat orders view. */
  outboundAddressTypeFilter?: InputMaybe<StandardStopTypeFilter>;
  /** A boolean filter intended for a confirmed outbound appointment. Currently only implemented for the flat orders view. */
  outboundAppointmentConfirmedFilter?: InputMaybe<BooleanFilterV2>;
  /** A date filter intended for the outbound appointment date. Currently only implemented for the flat orders view. */
  outboundAppointmentDateFilter?: InputMaybe<DateFilterV2>;
  /** A boolean filter intended for the outbound appointment required. Currently only implemented for the flat orders view. */
  outboundAppointmentRequiredFilter?: InputMaybe<BooleanFilterV2>;
  /** A string filter intended for the OUTBOUND_CITY_NAME order table field */
  outboundCityFilter?: InputMaybe<StringFilterV2>;
  /** A date filter intended for the outbound completed date order table field */
  outboundCompletedDateFilter?: InputMaybe<DateFilterV2>;
  /** A boolean filter intended to filter for outbound stop completion. Currently only implemented for the flat orders view. */
  outboundCompletedFilter?: InputMaybe<BooleanFilterV2>;
  /** A string filter intended for the outbound contact name. Currently only implemented for the flat orders view. */
  outboundContactNameFilter?: InputMaybe<StringFilterV2>;
  /** A string filter intended for the outbound destination airport. Currently only implemented for the flat orders view. */
  outboundDestinationAirportFilter?: InputMaybe<StringFilterV2>;
  /** A string filter intended for the outbound driver name flat order table field */
  outboundDriverNameFilter?: InputMaybe<StringFilterV2>;
  outboundDriverUuidFilter?: InputMaybe<StringFilterV2>;
  outboundDriverUuidsFilter?: InputMaybe<StringsFilter>;
  outboundMethodFilter?: InputMaybe<StopType>;
  outboundMethodFilterV2?: InputMaybe<StopTypesV2Filter>;
  /** A date filter intended for the outbound route date. Currently only implemented for the flat orders view. */
  outboundRouteDateFilter?: InputMaybe<DateFilterV2>;
  /** A string filter intended for the outbound route name. Currently only implemented for the flat orders view. */
  outboundRouteNameFilter?: InputMaybe<StringFilterV2>;
  /** A string filter intended for the outbound routing field. Currently only implemented for the flat orders view. */
  outboundRoutingFilter?: InputMaybe<StringFilterV2>;
  /** A date filter intended for the outbound service date. Currently only implemented for the flat orders view. */
  outboundServiceDateFilter?: InputMaybe<DateFilterV2>;
  /** A filter intended for the outbound stop type filter. Currently only implemented for the flat orders view. */
  outboundStopTypeFilter?: InputMaybe<StopTypeFilter>;
  /** A string filter intended for the outbound terminal name field */
  outboundTerminalFilter?: InputMaybe<StringFilterV2>;
  /** A filter intended for the outbound zipcode filter. Currently only implemented for the flat orders view. */
  outboundZipcodeFilter?: InputMaybe<StringFilterV2>;
  paperworkComplete?: InputMaybe<BooleanFilter>;
  paperworkCompleteFilter?: InputMaybe<BooleanFilterV2>;
  pickupOrDelivery?: InputMaybe<PickupOrDelivery>;
  primaryAppointmentDateFilters?: InputMaybe<DateFilterStartEnd>;
  /** A string filter intended for the inbound or outbound proof of delivery name field */
  proofOfDeliveryNameFilter?: InputMaybe<StringFilterV2>;
  /** A string filter intended for the proof of delivery signee. Currently only implemented for the flat orders view. */
  proofOfDeliverySigneeFilter?: InputMaybe<StringFilterV2>;
  /** A boolean filter intended for the received at origin boolean status. Currently only implemented for the flat orders view. */
  receivedAtOriginFilter?: InputMaybe<BooleanFilterV2>;
  receivedDateFilters?: InputMaybe<DateFilterStartEnd>;
  requiresRecovery?: InputMaybe<BooleanFilter>;
  requiresRecoveryFilter?: InputMaybe<BooleanFilterV2>;
  requiresRouting?: InputMaybe<BooleanFilter>;
  requiresRoutingFilter?: InputMaybe<BooleanFilterV2>;
  /** A string filter intended for routing location. Currently only implemented for the flat orders view. */
  routingLocationFilter?: InputMaybe<StringFilterV2>;
  scheduledAtDateFilters?: InputMaybe<DateFilterStartEnd>;
  scheduledFilter?: InputMaybe<BooleanFilter>;
  scheduledFilterV2?: InputMaybe<BooleanFilterV2>;
  searchHawbOnly?: InputMaybe<Scalars['Boolean']['input']>;
  searchMiscInfoOnly?: InputMaybe<Scalars['Boolean']['input']>;
  searchRefNumbersOnly?: InputMaybe<Scalars['Boolean']['input']>;
  searchText?: InputMaybe<Scalars['String']['input']>;
  /** A string filter intended for the secondary reference number on the order table field */
  secondaryReferenceNumberFilter?: InputMaybe<StringFilterV2>;
  /** A date filter intended for the ORDER_SERVICE_DATE order table field */
  serviceDateFilter?: InputMaybe<DateFilterV2>;
  serviceDateFilters?: InputMaybe<DateFilterStartEnd>;
  /** A string filter intended for serviceLevel. Currently only implemented for the flat orders view. */
  serviceLevelFilter?: InputMaybe<StringFilterV2>;
  serviceUuids?: InputMaybe<Array<Scalars['String']['input']>>;
  shipmentStatusFilters?: InputMaybe<Array<ShipmentStatusFilter>>;
  shipperFilter?: InputMaybe<StringFilter>;
  showConsolidatedOrders?: InputMaybe<BooleanFilter>;
  showConsolidatedOrdersFilter?: InputMaybe<BooleanFilterV2>;
  /** True if ascending, False if descending, undefined if no sort */
  sortByCustomerNameAscending?: InputMaybe<Scalars['Boolean']['input']>;
  sorts?: InputMaybe<Array<OrderSort>>;
  sortsV2?: InputMaybe<Array<OrderSortV2>>;
  standardStopType?: InputMaybe<StandardStopType>;
  startStopFilter?: InputMaybe<StringFilter>;
  statusFilters?: InputMaybe<Array<StatusFilter>>;
  stopTypesFilter?: InputMaybe<StopTypesFilter>;
  tagUuids?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Searches for orders with one of these tags. An empty values array represents orders with no tags (equivalent to "None"). Null represents no filter being applied at all (equivalent to "All"). */
  tagUuidsFilter?: InputMaybe<StringsFilter>;
  /** A string filter intended for the order tags. Currently only implemented for the flat orders view. */
  tagsFilter?: InputMaybe<StringFilterV2>;
  terminalUuidFilter?: InputMaybe<StringFilter>;
  terminalUuidFilterV2?: InputMaybe<StringFilterV2>;
  /** Searches for orders with one of these terminals on the startStop or endStop. An empty values array represents orders with no terminal on the startStop and endStop (equivalent to "None"). Null represents no filter being applied at all (equivalent to "All"). */
  terminalUuidsFilter?: InputMaybe<StringsFilter>;
  /** A float filter intended for the total amount in dollars. Currently only implemented for the flat orders view. */
  totalAmountDollarsFilter?: InputMaybe<FloatFilterV2>;
  /** request total number of records, request with prudence */
  totalCount?: InputMaybe<Scalars['Boolean']['input']>;
  /** An int filter intended for the total pieces flat order table field only */
  totalPiecesFilter?: InputMaybe<IntegerFilterV2>;
  /** An int filter intended for the total skids. Currently implemented only for the flat orders view */
  totalSkidsFilter?: InputMaybe<IntegerFilterV2>;
  /** A float filter intended for the total weight flat order table field only */
  totalWeightFilter?: InputMaybe<FloatFilterV2>;
  transferPending?: InputMaybe<BooleanFilter>;
  transferPendingFilter?: InputMaybe<BooleanFilterV2>;
  /** A string filter intended for the UN number order table field */
  unNumberFilter?: InputMaybe<StringFilterV2>;
  useFlatOrdersView?: InputMaybe<Scalars['Boolean']['input']>;
  useMultiSearch?: InputMaybe<Scalars['Boolean']['input']>;
  uuids?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Version ID for the request */
  versionId?: InputMaybe<Scalars['Float']['input']>;
  /** A string filter intended for the zipcode on inbound and outbound stops table field */
  zipcodeFilter?: InputMaybe<StringFilterV2>;
};

/** The output of the query to retrieve the order table field values for a set of orders. */
export type GetOrderTableFieldValuesOutput = {
  __typename?: 'GetOrderTableFieldValuesOutput';
  /** The paginated list of formatted orders with the values for the order table fields specified in the input */
  formattedOrderConnection: FormattedOrderConnection;
  /** The list of table headers for the order table fields requested as part of the order retrieval query */
  orderTableFieldHeaders: Array<OrderTableFieldHeaderEntity>;
};

export type GetOutlookIntegrationsInput = {
  companyUuid?: InputMaybe<Scalars['String']['input']>;
};

export type GetScannedOrderResultsForAdminArgs = {
  /** forwards pagination cursor */
  after?: InputMaybe<Scalars['String']['input']>;
  /** backwards pagination cursor */
  before?: InputMaybe<Scalars['String']['input']>;
  companyUuid?: InputMaybe<Scalars['String']['input']>;
  contactUuid?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  failed?: InputMaybe<Scalars['Boolean']['input']>;
  /** forwards pagination count, provide this on initial query */
  first?: InputMaybe<Scalars['Int']['input']>;
  /** backwards pagination count */
  last?: InputMaybe<Scalars['Int']['input']>;
  orderUuids?: InputMaybe<Array<Scalars['String']['input']>>;
  scannedOrderSource?: InputMaybe<ScannedOrderSource>;
  scannedOrderUuids?: InputMaybe<Array<Scalars['String']['input']>>;
  searchText?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
};

export type GetSchemaMatchDetailsInput = {
  bucket: Scalars['String']['input'];
  companyUuid: Scalars['String']['input'];
  key: Scalars['String']['input'];
};

export type GetServiceRegionsInput = {
  /** Filter for either archived or not archived service regions. Defaults to all. */
  isArchived?: InputMaybe<Scalars['Boolean']['input']>;
};

export type GetServiceRegionsOutput = {
  __typename?: 'GetServiceRegionsOutput';
  /** All off the company's service regions. */
  serviceRegions: Array<ServiceRegionEntity>;
};

export type GetShipmentsInput = {
  uuids?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type GetTerminalsInput = {
  excludeNotActive: Scalars['Boolean']['input'];
  /** Optionally filter by isActive, defaults to including all terminals */
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
};

export type GetTerminalsInternalInput = {
  companyUuid: Scalars['String']['input'];
  excludeNotActive: Scalars['Boolean']['input'];
};

export type GetUsersInput = {
  includeNotActive?: InputMaybe<Scalars['Boolean']['input']>;
};

export type GetXyTransformInput = {
  documentName: Scalars['String']['input'];
  schemaUuid: Scalars['String']['input'];
};

export type GetZipcodeOptionsFromCityAndStateInput = {
  city: Scalars['String']['input'];
  state: Scalars['String']['input'];
};

export type GetZipcodeOptionsFromCityAndStateOutput = {
  __typename?: 'GetZipcodeOptionsFromCityAndStateOutput';
  /** The city that was used to retrieve zipcode options */
  city: Scalars['String']['output'];
  /** The state that was used to retrieve zipcode options */
  state: Scalars['String']['output'];
  /** A list of zipcode options that the city and state could apply to */
  zipcodes: Array<ZipcodeOptionEntity>;
};

export type GroupByStopEntity = {
  __typename?: 'GroupByStopEntity';
  ADDRESS: Scalars['String']['output'];
  ADDRESS_TYPE?: Maybe<Scalars['String']['output']>;
  APPOINTMENT?: Maybe<Scalars['DateTime']['output']>;
  APPOINTMENT_DATE?: Maybe<Scalars['DateTime']['output']>;
  APPOINTMENT_REQUIRED?: Maybe<Scalars['Boolean']['output']>;
  APPOINTMENT_SCHEDULED?: Maybe<Scalars['Boolean']['output']>;
  APPOINTMENT_TIME?: Maybe<Scalars['DateTime']['output']>;
  BUSINESS_DIVISION?: Maybe<Scalars['String']['output']>;
  CITY?: Maybe<Scalars['String']['output']>;
  CONSIGNEE?: Maybe<Scalars['String']['output']>;
  CUSTOMER?: Maybe<Scalars['String']['output']>;
  DIMS?: Maybe<Scalars['String']['output']>;
  DUE_DATE?: Maybe<Scalars['DateTime']['output']>;
  INBOUND_CITY?: Maybe<Scalars['String']['output']>;
  INBOUND_METHOD?: Maybe<InboundMethod>;
  INBOUND_NAME?: Maybe<Scalars['String']['output']>;
  INBOUND_TERMINAL?: Maybe<Scalars['String']['output']>;
  INBOUND_ZIP?: Maybe<Scalars['String']['output']>;
  MAWB?: Maybe<Scalars['String']['output']>;
  ORDER_NAME?: Maybe<Scalars['String']['output']>;
  ORDER_NOTES?: Maybe<Scalars['String']['output']>;
  ORDER_NUMBER: Scalars['String']['output'];
  ORDER_STATUS?: Maybe<Scalars['String']['output']>;
  OUTBOUND_CITY?: Maybe<Scalars['String']['output']>;
  OUTBOUND_METHOD?: Maybe<OutboundMethod>;
  OUTBOUND_NAME?: Maybe<Scalars['String']['output']>;
  OUTBOUND_TERMINAL?: Maybe<Scalars['String']['output']>;
  OUTBOUND_ZIP?: Maybe<Scalars['String']['output']>;
  PIECE_COUNT?: Maybe<Scalars['Float']['output']>;
  REF_NUMBER?: Maybe<Array<Scalars['String']['output']>>;
  ROUTE_NAME?: Maybe<Scalars['String']['output']>;
  SERVICE_DATE?: Maybe<Scalars['DateTime']['output']>;
  SERVICE_LEVEL?: Maybe<Scalars['String']['output']>;
  SERVICE_TIME?: Maybe<Scalars['DateTime']['output']>;
  SPECIAL?: Maybe<Scalars['Boolean']['output']>;
  SPECIAL_INSTRUCTIONS?: Maybe<Scalars['String']['output']>;
  STOP_TYPE?: Maybe<Scalars['String']['output']>;
  TAGS?: Maybe<Array<Scalars['String']['output']>>;
  TERMINAL?: Maybe<Scalars['String']['output']>;
  TOTAL_CHARGES?: Maybe<Scalars['Float']['output']>;
  VEHICLE_TYPE_NAME?: Maybe<Scalars['String']['output']>;
  WEIGHT?: Maybe<Scalars['Float']['output']>;
  ZIP_CODE?: Maybe<Scalars['String']['output']>;
  orderNumberCellColor?: Maybe<Scalars['String']['output']>;
  orderUuid: Scalars['String']['output'];
  stopDetails?: Maybe<StopDetailsOutput>;
  uuid: Scalars['String']['output'];
};

export type GroupByStopRowUnion = GroupsOutput | StopOutput;

export enum GroupByStopsEnum {
  City = 'CITY',
  RouteName = 'ROUTE_NAME',
  ServiceLevel = 'SERVICE_LEVEL'
}

/** Filters with fields for the groupByStops query. Use either "and" or "or" or "filters", but not all simultaneously. Using all in the same query may lead to unexpected results. */
export type GroupByStopsFilters = {
  and?: InputMaybe<Array<GroupByStopsFilters>>;
  fields?: InputMaybe<GroupByStopsFiltersFields>;
  or?: InputMaybe<Array<GroupByStopsFilters>>;
};

/** Filter fields for the groupByStops query */
export type GroupByStopsFiltersFields = {
  ADDRESS_TYPE?: InputMaybe<AddressTypeFilter>;
  APPOINTMENT_OPTIONS_PROPOSED?: InputMaybe<BooleanFilterV2>;
  APPOINTMENT_REQUIRED?: InputMaybe<BooleanFilterV2>;
  APPOINTMENT_SCHEDULED?: InputMaybe<BooleanFilterV2>;
  CAN_DISPATCH?: InputMaybe<BooleanFilterV2>;
  CITY?: InputMaybe<StringFilterV2>;
  HAS_APPOINTMENT?: InputMaybe<BooleanFilterV2>;
  ON_HAND?: InputMaybe<BooleanFilterV2>;
  REFUSED?: InputMaybe<BooleanFilterV2>;
  SPECIAL?: InputMaybe<BooleanFilterV2>;
  STOP_TYPE?: InputMaybe<StopTypeFilter>;
};

/** Filters for the groupByStops query. Use either "and" or "or" filters, but not both simultaneously. Using both in the same query may lead to unexpected results. */
export type GroupByStopsFiltersInput = {
  and?: InputMaybe<Array<GroupByStopsFilters>>;
  or?: InputMaybe<Array<GroupByStopsFilters>>;
};

/** Input for grouping stops */
export type GroupByStopsInput = {
  filters?: InputMaybe<GroupByStopsFiltersInput>;
  groupByFields: Array<GroupByStopsEnum>;
  groupByValues: Array<InputMaybe<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Float']['input']>;
  offset?: InputMaybe<Scalars['Float']['input']>;
  searchText?: InputMaybe<Scalars['String']['input']>;
  /** Top-level service date filter */
  serviceDate?: InputMaybe<DateFilterV2>;
  sort?: InputMaybe<Array<GroupByStopsSort>>;
  /** If provided, filter stops by terminal uuid. If null, return stops with NO terminal. If undefined, do not apply a terminal filter at all. */
  terminalUuid?: InputMaybe<Scalars['String']['input']>;
};

export type GroupByStopsOutput = {
  __typename?: 'GroupByStopsOutput';
  count?: Maybe<Scalars['Int']['output']>;
  rows: GroupByStopRowUnion;
};

export type GroupByStopsSort = {
  direction: GroupByStopsSortDirection;
  field: DispatchTableField;
};

export enum GroupByStopsSortDirection {
  Asc = 'ASC',
  Desc = 'DESC'
}

export enum GroupOrdersForPaymentsBy {
  Invoice = 'INVOICE',
  Order = 'ORDER'
}

/** Used to track grouped counts (e.g. number of orders per invoice) */
export type GroupedCounts = {
  __typename?: 'GroupedCounts';
  /** Count of items in group */
  count: Scalars['Int']['output'];
  /** Unique group identifier / uuid */
  groupUuid: Scalars['String']['output'];
};

export type GroupsOutput = {
  __typename?: 'GroupsOutput';
  groupValues: Array<Maybe<Scalars['String']['output']>>;
};

export type HandleMultiple210OutboundInput = {
  invoiceUuids: Array<Scalars['String']['input']>;
};

export enum HazmatClass {
  Class1 = 'Class1',
  Class1_1 = 'Class1_1',
  Class1_2 = 'Class1_2',
  Class1_3 = 'Class1_3',
  Class1_4 = 'Class1_4',
  Class1_5 = 'Class1_5',
  Class1_6 = 'Class1_6',
  Class2 = 'Class2',
  Class2_1 = 'Class2_1',
  Class2_2 = 'Class2_2',
  Class2_3 = 'Class2_3',
  Class3 = 'Class3',
  Class4 = 'Class4',
  Class4_1 = 'Class4_1',
  Class4_2 = 'Class4_2',
  Class4_3 = 'Class4_3',
  Class5 = 'Class5',
  Class5_1 = 'Class5_1',
  Class5_2 = 'Class5_2',
  Class6 = 'Class6',
  Class6_1 = 'Class6_1',
  Class6_2 = 'Class6_2',
  Class7 = 'Class7',
  Class8 = 'Class8',
  Class9 = 'Class9'
}

export enum HeaderFileMappingType {
  CustomerName = 'CUSTOMER_NAME',
  InvoiceDate = 'INVOICE_DATE',
  InvoiceDueDate = 'INVOICE_DUE_DATE',
  InvoiceItemAmount = 'INVOICE_ITEM_AMOUNT',
  InvoiceItemName = 'INVOICE_ITEM_NAME',
  InvoiceItemQuantity = 'INVOICE_ITEM_QUANTITY',
  InvoiceItemRate = 'INVOICE_ITEM_RATE',
  InvoiceItemServiceDate = 'INVOICE_ITEM_SERVICE_DATE',
  InvoiceName = 'INVOICE_NAME',
  InvoiceTerms = 'INVOICE_TERMS',
  OneColumn = 'ONE_COLUMN',
  OrderReferenceNumber = 'ORDER_REFERENCE_NUMBER'
}

export type HoldReasonCreateInput = {
  isArchived?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
};

export type HoldReasonEntity = {
  __typename?: 'HoldReasonEntity';
  isArchived?: Maybe<Scalars['Boolean']['output']>;
  name: Scalars['String']['output'];
  uuid: Scalars['String']['output'];
};

export type HoldReasonUpdateInput = {
  isArchived?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  uuid: Scalars['String']['input'];
};

/** Valid field names in the import contact schema */
export enum ImportContactField {
  AccountsReceivableId = 'AccountsReceivableId',
  Action = 'Action',
  Active = 'Active',
  BillingContactEmail = 'BillingContactEmail',
  BillingContactPhone = 'BillingContactPhone',
  BillingCycleDuration = 'BillingCycleDuration',
  BillingFax = 'BillingFax',
  BusinessDivision = 'BusinessDivision',
  ContactIdentifier = 'ContactIdentifier',
  ContactReferenceNumber = 'ContactReferenceNumber',
  Country = 'Country',
  CreditHoldLimitInCents = 'CreditHoldLimitInCents',
  DefaultAddressCity = 'DefaultAddressCity',
  DefaultAddressDriverInstructions = 'DefaultAddressDriverInstructions',
  DefaultAddressLine1 = 'DefaultAddressLine1',
  DefaultAddressLine2 = 'DefaultAddressLine2',
  DefaultAddressState = 'DefaultAddressState',
  DefaultAddressZip = 'DefaultAddressZip',
  DefaultContactPersonName = 'DefaultContactPersonName',
  DefaultInvoiceTerms = 'DefaultInvoiceTerms',
  DefaultInvoiceTransmissionMethod = 'DefaultInvoiceTransmissionMethod',
  DefaultInvoiceType = 'DefaultInvoiceType',
  DefaultLineHaulTariffChain = 'DefaultLineHaulTariffChain',
  DefaultOrdinaryTariffChain = 'DefaultOrdinaryTariffChain',
  DefaultPointToPointTariffChain = 'DefaultPointToPointTariffChain',
  DefaultService = 'DefaultService',
  DefaultTransferTariffChain = 'DefaultTransferTariffChain',
  DimFactor = 'DimFactor',
  DisplayName = 'DisplayName',
  DocumentsInInvoice = 'DocumentsInInvoice',
  EnableCreditHold = 'EnableCreditHold',
  Inactive = 'Inactive',
  InvoiceTimePeriodSplit = 'InvoiceTimePeriodSplit',
  MasterAccount = 'MasterAccount',
  MaxDaysOutstanding = 'MaxDaysOutstanding',
  NumberOfOrdersPerInvoice = 'NumberOfOrdersPerInvoice',
  Prepaid = 'Prepaid',
  QuickbooksFileMappingCustomerName = 'QuickbooksFileMappingCustomerName',
  RequiredDocuments = 'RequiredDocuments',
  ServiceContactEmail = 'ServiceContactEmail',
  ServiceContactName = 'ServiceContactName',
  ServiceContactPhone = 'ServiceContactPhone',
  ServiceFax = 'ServiceFax',
  ShortCode = 'ShortCode'
}

export type ImportCrownAccessorialInput = {
  accessorialUrl: Scalars['String']['input'];
  code?: InputMaybe<Scalars['String']['input']>;
  contactUuids?: InputMaybe<Array<Scalars['String']['input']>>;
  fuelSurchargePercentageRate?: InputMaybe<Scalars['Float']['input']>;
  isSpecial?: InputMaybe<Scalars['Boolean']['input']>;
  isZoneBased?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  percentForSettlement?: InputMaybe<Scalars['Float']['input']>;
  specialAccessorialType?: InputMaybe<SpecialAccessorialType>;
  tariffZoneGroupId?: InputMaybe<Scalars['String']['input']>;
  terminalUuid?: InputMaybe<Scalars['String']['input']>;
  useContactTariffZones?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ImportCrownAccessorialOutput = {
  __typename?: 'ImportCrownAccessorialOutput';
  error?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type ImportCrownDriversInput = {
  driversUrl: Scalars['String']['input'];
};

export type ImportCrownDriversOutput = {
  __typename?: 'ImportCrownDriversOutput';
  error?: Maybe<Scalars['String']['output']>;
  failedDriverPhoneNumbers: Array<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
  successfulDriverPhoneNumbers: Array<Scalars['String']['output']>;
};

export type ImportCrownInvoicesInput = {
  /** The Pallet admin email for this company */
  adminEmail: Scalars['String']['input'];
  /** A publicly accessible URL of the charges breakdown report exported from Crown. Assumes all data has been sanitized (in plaintext format with no spaces in header names). */
  chargeBreakdownUrl: Scalars['String']['input'];
  companyUuid: Scalars['String']['input'];
  /** A publicly accessible URL of the open invoices report exported from Crown. Assumes all data has been sanitized (in plaintext format with no spaces in header names). */
  openInvoicesUrl: Scalars['String']['input'];
  skipExisting?: Scalars['Boolean']['input'];
  skipImportCharges?: Scalars['Boolean']['input'];
};

export type ImportCrownInvoicesOutput = {
  __typename?: 'ImportCrownInvoicesOutput';
  chargesFailedCrownIDs: Array<Scalars['String']['output']>;
  chargesImportedCrownIDs: Array<Scalars['String']['output']>;
  chargesSkippedCrownIDs: Array<Scalars['String']['output']>;
  invoicesFailedJournalNumbers: Array<Scalars['String']['output']>;
  invoicesImportedJournalNumbers: Array<Scalars['String']['output']>;
  invoicesSkippedJournalNumbers: Array<Scalars['String']['output']>;
  numberOfCharges: Scalars['Int']['output'];
  numberOfInvoices: Scalars['Int']['output'];
  numberOfShipments: Scalars['Int']['output'];
  shipmentsFailedCrownIDs: Array<Scalars['String']['output']>;
  shipmentsImportedCrownIDs: Array<Scalars['String']['output']>;
  shipmentsSkippedCrownIDs: Array<Scalars['String']['output']>;
};

export type ImportCrownLanesInput = {
  companyUuid: Scalars['String']['input'];
  /** A publicly accessible URL of the lanes downloaded from Crown */
  lanesUrl: Scalars['String']['input'];
};

export type ImportCrownLanesOutput = {
  __typename?: 'ImportCrownLanesOutput';
  success: Scalars['Boolean']['output'];
};

export type ImportCrownOrdersInput = {
  /** The UUID of the company whose orders are being imported */
  companyUuid: Scalars['String']['input'];
  /** Automatically finalize all imported orders */
  finalizeOrders?: InputMaybe<Scalars['Boolean']['input']>;
  /** Do not apply any charges to imported orders */
  noCharges?: InputMaybe<Scalars['Boolean']['input']>;
  /** A publicly accessible URL of the orders for this company */
  ordersUrl: Scalars['String']['input'];
  /** Only include the provided ShipIDs */
  shipIDFilter?: InputMaybe<Array<Scalars['String']['input']>>;
  skipExisting?: Scalars['Boolean']['input'];
  /** The UUID of the user (Team Pallet admin) who is importing the orders */
  userUuid: Scalars['String']['input'];
};

export type ImportCrownOrdersOutput = {
  __typename?: 'ImportCrownOrdersOutput';
  failedCrownIDs: Array<Scalars['String']['output']>;
  importedCrownIDs: Array<Scalars['String']['output']>;
  numberOfOrders: Scalars['Int']['output'];
  skippedCrownIDs: Array<Scalars['String']['output']>;
};

export type ImportCrownPaymentsInput = {
  companyUuid: Scalars['String']['input'];
  /** A publicly accessible URL of the payment application report exported from Crown. Assumes all data has been sanitized (in plaintext format with no spaces in header names). */
  paymentApplicationUrl: Scalars['String']['input'];
  /** A publicly accessible URL of the unapplied payments report exported from Crown. Assumes all data has been sanitized (in plaintext format with no spaces in header names). */
  unappliedPaymentsUrl: Scalars['String']['input'];
};

export type ImportCrownPaymentsOutput = {
  __typename?: 'ImportCrownPaymentsOutput';
  failedPaymentIDs: Array<Scalars['String']['output']>;
  importedPaymentIDs: Array<Scalars['String']['output']>;
  numberOfPayments: Scalars['Int']['output'];
};

export type ImportCrownTariffInput = {
  autoSelectAllServices: Scalars['Boolean']['input'];
  autoSelectAllVehicleTypes: Scalars['Boolean']['input'];
  companyUuid?: InputMaybe<Scalars['String']['input']>;
  contactUuid?: InputMaybe<Scalars['String']['input']>;
  contactUuids?: InputMaybe<Array<Scalars['String']['input']>>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  fuelProfileUuid?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  rateType: RateType;
  /** Used to import a (global or contact) tariff for specific service levels. */
  serviceUuids: Array<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  tariffGroupType: TariffGroupType;
  tariffType: TariffType;
  tariffUrl: Scalars['String']['input'];
  /** Zone group to use for zone-based tariffs. */
  tariffZoneGroupId?: InputMaybe<Scalars['String']['input']>;
  tariffZoneType: TariffZoneType;
  useActualWeight: Scalars['Boolean']['input'];
  /** Used to import a tariff for specific vehicle types. Only used when tariff chains are enabled for the given company. */
  vehicleTypeUuids: Array<Scalars['String']['input']>;
};

export type ImportCrownTariffOutput = {
  __typename?: 'ImportCrownTariffOutput';
  error?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type ImportCrownUsersInput = {
  usersUrl: Scalars['String']['input'];
};

export type ImportCrownUsersOutput = {
  __typename?: 'ImportCrownUsersOutput';
  error?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type ImportRecoveryTerminalInput = {
  companyUuid: Scalars['String']['input'];
  recoveryTerminalsUrl: Scalars['String']['input'];
};

export type ImportRecoveryTerminalOutput = {
  __typename?: 'ImportRecoveryTerminalOutput';
  success: Scalars['Boolean']['output'];
};

export type ImportStorageOrdersFromCsvInput = {
  contactUuid: Scalars['String']['input'];
  /** CSV text of the import */
  csvText?: InputMaybe<Scalars['String']['input']>;
  /** S3 URL of the import */
  fileUrl: Scalars['String']['input'];
  warehouseUuid?: InputMaybe<Scalars['String']['input']>;
};

export type ImportStorageOrdersFromCsvOutput = {
  __typename?: 'ImportStorageOrdersFromCsvOutput';
  errors?: Maybe<Array<Scalars['String']['output']>>;
  storageOrders: Array<StorageOrderEntity>;
};

export type ImportTerminalServiceAreasInput = {
  companyUuid: Scalars['String']['input'];
  csvDocumentUrl: Scalars['String']['input'];
  deleteExisting: Scalars['Boolean']['input'];
};

export type ImportTestSnapshotInput = {
  testSnapshot: TestSnapshotInput;
};

export type ImportWarehouseLocationsFromCsvInput = {
  csvText: Scalars['String']['input'];
};

export type ImportedOrderTypeMappingCreateInput = {
  defaultToInbound: Scalars['Boolean']['input'];
  defaultToOutbound: Scalars['Boolean']['input'];
  inboundStopType: StopType;
  lineHaul: Scalars['Boolean']['input'];
  moveType?: InputMaybe<Scalars['String']['input']>;
  orderImportConfigurationUuid: Scalars['String']['input'];
  outboundStopType: StopType;
  serviceLevel?: InputMaybe<Scalars['String']['input']>;
};

export type ImportedOrderTypeMappingEntity = {
  __typename?: 'ImportedOrderTypeMappingEntity';
  defaultToInbound: Scalars['Boolean']['output'];
  defaultToOutbound: Scalars['Boolean']['output'];
  inboundStopType: StopType;
  lineHaul: Scalars['Boolean']['output'];
  moveType?: Maybe<Scalars['String']['output']>;
  outboundStopType: StopType;
  serviceLevel?: Maybe<Scalars['String']['output']>;
  uuid: Scalars['String']['output'];
};

export type ImportedOrderTypeMappingUpdateInput = {
  defaultToInbound: Scalars['Boolean']['input'];
  defaultToOutbound: Scalars['Boolean']['input'];
  inboundStopType: StopType;
  lineHaul: Scalars['Boolean']['input'];
  moveType?: InputMaybe<Scalars['String']['input']>;
  orderImportConfigurationUuid?: InputMaybe<Scalars['String']['input']>;
  outboundStopType: StopType;
  serviceLevel?: InputMaybe<Scalars['String']['input']>;
  uuid: Scalars['String']['input'];
};

export type InBondSortInput = {
  direction: SortOrder;
  nulls: NullsOrder;
};

export type InboundAddressNameSortInput = {
  direction: SortOrder;
  nulls: NullsOrder;
};

export type InboundAddressSortInput = {
  direction: SortOrder;
  nulls: NullsOrder;
};

export type InboundCityNameSortInput = {
  direction: SortOrder;
  nulls: NullsOrder;
};

export type InboundCompletedDateSortInput = {
  direction: SortOrder;
  nulls: NullsOrder;
};

export type InboundDriverNameSortInput = {
  direction: SortOrder;
  nulls: NullsOrder;
};

export enum InboundMethod {
  InboundDelivery = 'INBOUND_DELIVERY',
  Other = 'OTHER',
  Recovery = 'RECOVERY'
}

export type InboundRouteDateSortInput = {
  direction: SortOrder;
  nulls: NullsOrder;
};

export type InboundRouteNameSortInput = {
  direction: SortOrder;
  nulls: NullsOrder;
};

export type InboundServiceDateSortInput = {
  direction: SortOrder;
  nulls: NullsOrder;
};

export type InboundZipcodeSortInput = {
  direction: SortOrder;
  nulls: NullsOrder;
};

export type IncomeAnalysisReportArgs = {
  excludeMigratedOrders?: InputMaybe<Scalars['Boolean']['input']>;
  includeContactsWithNoShipments: Scalars['Boolean']['input'];
  invoiceDateFilters?: InputMaybe<DateFilterStartEnd>;
  invoiceStatuses: Array<InvoiceStatus>;
  serviceDateFilter?: InputMaybe<DateFilterV2>;
  terminalUuid?: InputMaybe<Scalars['String']['input']>;
};

export type IndependentCustomCostCreateInput = {
  accessorialTemplateUuid?: InputMaybe<Scalars['String']['input']>;
  billingMethod: CustomChargeBillingMethod;
  description?: InputMaybe<Scalars['String']['input']>;
  /** The fuel surcharge rate expressed as a percentage out of 100 */
  fuelSurchargeRate?: InputMaybe<Scalars['Decimal']['input']>;
  name: Scalars['String']['input'];
  quantity: Scalars['Float']['input'];
  rateUsdCents?: InputMaybe<Scalars['Decimal']['input']>;
  specialAccessorialMatrixItemUuid?: InputMaybe<Scalars['String']['input']>;
  totalAmountUsdCents: Scalars['Decimal']['input'];
  zoneBasedAccessorialMatrixItemUuid?: InputMaybe<Scalars['String']['input']>;
};

export type IndependentCustomCostUpsertInput = {
  accessorialTemplateUuid?: InputMaybe<Scalars['String']['input']>;
  billingMethod: CustomChargeBillingMethod;
  description?: InputMaybe<Scalars['String']['input']>;
  /** The fuel surcharge rate expressed as a percentage out of 100 */
  fuelSurchargeRate?: InputMaybe<Scalars['Decimal']['input']>;
  id: Scalars['String']['input'];
  name: Scalars['String']['input'];
  quantity: Scalars['Float']['input'];
  rateUsdCents?: InputMaybe<Scalars['Decimal']['input']>;
  specialAccessorialMatrixItemUuid?: InputMaybe<Scalars['String']['input']>;
  totalAmountUsdCents?: InputMaybe<Scalars['Decimal']['input']>;
  zoneBasedAccessorialMatrixItemUuid?: InputMaybe<Scalars['String']['input']>;
};

export type IndependentFreightCostCreateInput = {
  billingMethod: FreightBillingMethod;
  description?: InputMaybe<Scalars['String']['input']>;
  /** Percent out of 100 */
  discountRate?: InputMaybe<Scalars['Percent']['input']>;
  flatRateUsdCents?: InputMaybe<Scalars['Decimal']['input']>;
  independentFuelCostCreateInput?: InputMaybe<IndependentFuelCostCreateInput>;
  /** Is null when billing method is per mile or flat rate */
  quantity?: InputMaybe<Scalars['Float']['input']>;
  rateUsdCents?: InputMaybe<Scalars['Decimal']['input']>;
  tariffUuid?: InputMaybe<Scalars['String']['input']>;
  totalAmountUsdCents: Scalars['Decimal']['input'];
};

export type IndependentFreightCostUpsertInput = {
  billingMethod: FreightBillingMethod;
  description?: InputMaybe<Scalars['String']['input']>;
  /** Percent out of 100 */
  discountRate?: InputMaybe<Scalars['Percent']['input']>;
  flatRateUsdCents?: InputMaybe<Scalars['Decimal']['input']>;
  id: Scalars['String']['input'];
  independentFuelCostUpsertInput?: InputMaybe<IndependentFuelCostUpsertInput>;
  /** Is null when billing method is per mile or flat rate */
  quantity?: InputMaybe<Scalars['Float']['input']>;
  rateUsdCents?: InputMaybe<Scalars['Decimal']['input']>;
  tariffUuid?: InputMaybe<Scalars['String']['input']>;
  totalAmountUsdCents?: InputMaybe<Scalars['Decimal']['input']>;
};

export type IndependentFuelCostCreateInput = {
  billingMethod: FuelBillingMethod;
  flatRateUsdCents?: InputMaybe<Scalars['Decimal']['input']>;
  /** Percent in the range [0, 100] */
  surchargeRate?: InputMaybe<Scalars['Decimal']['input']>;
  totalAmountUsdCents: Scalars['Decimal']['input'];
};

export type IndependentFuelCostUpsertInput = {
  billingMethod: FuelBillingMethod;
  flatRateUsdCents?: InputMaybe<Scalars['Decimal']['input']>;
  id: Scalars['String']['input'];
  /** Percent in the range [0, 100] */
  surchargeRate?: InputMaybe<Scalars['Decimal']['input']>;
  totalAmountUsdCents?: InputMaybe<Scalars['Decimal']['input']>;
};

export type IndependentSettlementBillLineItemCreateInput = {
  agentUuid?: InputMaybe<Scalars['String']['input']>;
  driverUuid: Scalars['String']['input'];
  independentCustomCostCreateInputs?: InputMaybe<Array<IndependentCustomCostCreateInput>>;
  independentFreightCostCreateInput?: InputMaybe<IndependentFreightCostCreateInput>;
  settlementMode: SettlementMode;
  totalAmountUsdCents: Scalars['Decimal']['input'];
};

export type IndependentSettlementBillLineItemUpsertInput = {
  agentUuid?: InputMaybe<Scalars['String']['input']>;
  driverUuid: Scalars['String']['input'];
  id: Scalars['String']['input'];
  independentCustomCostUpsertInputs?: InputMaybe<Array<IndependentCustomCostUpsertInput>>;
  independentFreightCostUpsertInput?: InputMaybe<IndependentFreightCostUpsertInput>;
  settlementMode: SettlementMode;
  /** The total amount of the settlement bill line item in USD. If undefined for an existing settlement bill line item, then the existing total amount will be kept. If undefined for a new settlement bill line item, then the total amount will be 0. */
  totalAmountUsdCents?: InputMaybe<Scalars['Decimal']['input']>;
};

export type IngestedEmailDetailsEntity = {
  __typename?: 'IngestedEmailDetailsEntity';
  attachmentUuid?: Maybe<Scalars['String']['output']>;
  fromAddress?: Maybe<Scalars['String']['output']>;
  outlookIntegrationTerminal?: Maybe<TerminalEntity>;
  receivedAt?: Maybe<Scalars['DateTime']['output']>;
  subject?: Maybe<Scalars['String']['output']>;
};

export type IngestedOutlookEmailAttachmentConnection = {
  __typename?: 'IngestedOutlookEmailAttachmentConnection';
  edges: Array<IngestedOutlookEmailAttachmentEdge>;
  pageInfo: PageInfo;
};

export type IngestedOutlookEmailAttachmentCreateInput = {
  fileHash?: InputMaybe<Scalars['String']['input']>;
  originalAttachment: Scalars['String']['input'];
};

export type IngestedOutlookEmailAttachmentEdge = {
  __typename?: 'IngestedOutlookEmailAttachmentEdge';
  cursor: Scalars['String']['output'];
  node: IngestedOutlookEmailAttachmentEntity;
};

export type IngestedOutlookEmailAttachmentEntity = {
  __typename?: 'IngestedOutlookEmailAttachmentEntity';
  attachmentFilename?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  fileName?: Maybe<Scalars['String']['output']>;
  fileType?: Maybe<Scalars['String']['output']>;
  ingestedEmailDetails: IngestedEmailDetailsEntity;
  outlookAttachmentId: Scalars['String']['output'];
  processingStatus: IngestedOutlookEmailAttachmentProcessingStatus;
  s3Bucket?: Maybe<Scalars['String']['output']>;
  s3Key?: Maybe<Scalars['String']['output']>;
  scannedOrder?: Maybe<ScannedOrderEntity>;
  uuid: Scalars['String']['output'];
};

export enum IngestedOutlookEmailAttachmentProcessingStatus {
  Completed = 'COMPLETED',
  InProgress = 'IN_PROGRESS',
  Pending = 'PENDING'
}

export type IngestedOutlookEmailConnection = {
  __typename?: 'IngestedOutlookEmailConnection';
  edges: Array<IngestedOutlookEmailEdge>;
  pageInfo: PageInfo;
};

export type IngestedOutlookEmailCreateInput = {
  attachments?: InputMaybe<Array<IngestedOutlookEmailAttachmentCreateInput>>;
  originalMessage: Scalars['String']['input'];
  outlookIntegrationUuid: Scalars['String']['input'];
};

export type IngestedOutlookEmailEdge = {
  __typename?: 'IngestedOutlookEmailEdge';
  cursor: Scalars['String']['output'];
  node: IngestedOutlookEmailEntity;
};

export type IngestedOutlookEmailEntity = {
  __typename?: 'IngestedOutlookEmailEntity';
  attachments: Array<IngestedOutlookEmailAttachmentEntity>;
  body: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  effectiveSenderAddress: Scalars['String']['output'];
  fromAddress?: Maybe<Scalars['String']['output']>;
  outlookMessageId: Scalars['String']['output'];
  outlookReceivedDateTime: Scalars['DateTime']['output'];
  subject?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  uuid: Scalars['String']['output'];
};

/** A filter object that is used to filter a integer field. Each field in the filter object represents an operator. If there is more than one non-null field passed into the filter object, the condition will be a conjunction of the non-null field operator */
export type IntegerFilterV2 = {
  /** Filters for records where the relevant integer field is equal to the provided integer value */
  eq?: InputMaybe<Scalars['Int']['input']>;
  /** Filters for records where the relevant integer field is greater than the provided integer value */
  gt?: InputMaybe<Scalars['Int']['input']>;
  /** Filters for records where the relevant integer field is greater than or equal to the provided integer value */
  gte?: InputMaybe<Scalars['Int']['input']>;
  /** Filters for records where the relevant integer field is in the provided integer values */
  in?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** Filters for records where the relevant integer field is less than the provided integer value */
  lt?: InputMaybe<Scalars['Int']['input']>;
  /** Filters for records where the relevant integer field is less than or equal to the provided integer value */
  lte?: InputMaybe<Scalars['Int']['input']>;
  /** Filters for records where the relevant integer field is not equal to the provided integer value */
  neq?: InputMaybe<Scalars['Int']['input']>;
  /** Filters for records where the relevant integer field is not in the provided integer values */
  nin?: InputMaybe<Array<Scalars['Int']['input']>>;
};

/** Deprecated, use ItemGroupEntity instead */
export type InventoryItemEntity = {
  __typename?: 'InventoryItemEntity';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['Int']['output'];
  item: ItemEntity;
  markedOnHandAt?: Maybe<Scalars['DateTime']['output']>;
  markedOsdAt?: Maybe<Scalars['DateTime']['output']>;
  pickedAt?: Maybe<Scalars['DateTime']['output']>;
  storageUnit?: Maybe<StorageUnitEntity>;
  unitOfMeasure: UnitOfMeasure;
  updatedAt: Scalars['DateTime']['output'];
  uuid: Scalars['String']['output'];
  warehouseLocation?: Maybe<WarehouseLocationEntity>;
};

export type InventoryPrimaryUnitOfMeasureEntity = {
  __typename?: 'InventoryPrimaryUnitOfMeasureEntity';
  createdAt: Scalars['DateTime']['output'];
  unitOfMeasure: UnitOfMeasure;
  upcCode?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  uuid: Scalars['String']['output'];
};

export type InventorySecondaryUnitOfMeasureEntity = {
  __typename?: 'InventorySecondaryUnitOfMeasureEntity';
  createdAt: Scalars['DateTime']['output'];
  primaryUnitsPerSecondaryUOM?: Maybe<Scalars['Float']['output']>;
  unitOfMeasure: UnitOfMeasure;
  upcCode?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  uuid: Scalars['String']['output'];
};

export type InvoiceAdd = {
  __typename?: 'InvoiceAdd';
  name?: Maybe<Scalars['String']['output']>;
  shipmentUuids: Array<Scalars['String']['output']>;
  uuid?: Maybe<Scalars['String']['output']>;
};

export type InvoiceAgingReportArgs = {
  contactUuid?: InputMaybe<Scalars['String']['input']>;
  /** If set to true, excludes any invoices that are closed */
  hideCurrent?: InputMaybe<Scalars['Boolean']['input']>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** If set to true, calculate aging from the invoice due date instead of the invoice date */
  useInvoiceDueDate?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum InvoiceBillingSummaryDetailType {
  Aggregate = 'AGGREGATE',
  Detailed = 'DETAILED'
}

export enum InvoiceBillingSummaryGroupByType {
  Contact = 'CONTACT',
  Terminal = 'TERMINAL'
}

export type InvoiceBillingSummaryLineItemEntity = {
  __typename?: 'InvoiceBillingSummaryLineItemEntity';
  contactDisplayName: Scalars['String']['output'];
  contactReferenceNumber?: Maybe<Scalars['String']['output']>;
  inboundAddressName?: Maybe<Scalars['String']['output']>;
  invoiceDate?: Maybe<Scalars['DateTime']['output']>;
  invoiceName: Scalars['String']['output'];
  invoiceStatus: Scalars['String']['output'];
  orderLineHaulLane?: Maybe<OrderLineHaulLaneEntity>;
  orderName: Scalars['String']['output'];
  orderUuid: Scalars['String']['output'];
  outboundAddressName?: Maybe<Scalars['String']['output']>;
  /** Sum of all package quantities on order */
  pieces: Scalars['Int']['output'];
  refNumbers?: Maybe<Array<Scalars['String']['output']>>;
  serviceDate?: Maybe<Scalars['DateTime']['output']>;
  /** The service date of the line item as a PlainDate. See https://www.notion.so/Service-Date-dc8ae149b6a54bb69404aecf92176287 for details. */
  serviceDateV2?: Maybe<PlainDate>;
  serviceLevel: Scalars['String']['output'];
  serviceName?: Maybe<Scalars['String']['output']>;
  shipmentsIncludedInLineItemRevenue: Array<ShipmentIncludedInRevenueEntity>;
  shipperBillOfLadingNumber: Scalars['String']['output'];
  totalCharge: Scalars['Float']['output'];
  /** Sum of all package weights on order */
  weight: Scalars['Float']['output'];
};

export type InvoiceBillingSummaryV2Group = {
  __typename?: 'InvoiceBillingSummaryV2Group';
  groupLabel: Scalars['String']['output'];
  groupTotal: Scalars['Float']['output'];
  specialGroupType?: Maybe<InvoiceBillingSummaryV2SpecialGroupType>;
  subgroups: Array<InvoiceBillingSummaryV2Subgroup>;
  totalLineItems: Scalars['Float']['output'];
};

export type InvoiceBillingSummaryV2Input = {
  billingPartyContactUuid?: InputMaybe<Scalars['String']['input']>;
  businessDivisionUuid?: InputMaybe<Scalars['String']['input']>;
  excludeMigratedOrders?: InputMaybe<Scalars['Boolean']['input']>;
  invoiceEndDate?: InputMaybe<Scalars['DateTime']['input']>;
  invoiceStartDate?: InputMaybe<Scalars['DateTime']['input']>;
  onlyLineHaul?: InputMaybe<Scalars['Boolean']['input']>;
  reportDetailType?: InputMaybe<InvoiceBillingSummaryDetailType>;
  reportGroupByType: InvoiceBillingSummaryGroupByType;
  /** Filters the order records based on whether the "order service date" meets the filter conditions */
  serviceDateFilter?: InputMaybe<DateFilterV2>;
  statuses?: InputMaybe<Array<InvoiceStatus>>;
  terminalUuid?: InputMaybe<Scalars['String']['input']>;
};

export type InvoiceBillingSummaryV2Output = {
  __typename?: 'InvoiceBillingSummaryV2Output';
  groups: Array<InvoiceBillingSummaryV2Group>;
  total: Scalars['Float']['output'];
};

export type InvoiceBillingSummaryV2PdfOutput = {
  __typename?: 'InvoiceBillingSummaryV2PdfOutput';
  fileName: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export enum InvoiceBillingSummaryV2SpecialGroupType {
  LineHaul = 'LINE_HAUL',
  NoTerminal = 'NO_TERMINAL'
}

export type InvoiceBillingSummaryV2Subgroup = {
  __typename?: 'InvoiceBillingSummaryV2Subgroup';
  lineItems: Array<InvoiceBillingSummaryLineItemEntity>;
  subgroupLabel?: Maybe<Scalars['String']['output']>;
  subgroupTotal: Scalars['Float']['output'];
};

export type InvoiceConnection = {
  __typename?: 'InvoiceConnection';
  edges: Array<InvoiceEdge>;
  pageInfo: PageInfo;
  /** Not cheap to calculate, request with prudence */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type InvoiceCreateInput = {
  associatedShipmentUuids: Array<Scalars['String']['input']>;
  billToAddressCreateInput?: InputMaybe<AddressCreateInput>;
  billToAddressUuid?: InputMaybe<Scalars['String']['input']>;
  billToContactUuid: Scalars['String']['input'];
  customChargeCreateInputs: Array<CustomChargeCreateInput>;
  customJournalNumber?: InputMaybe<Scalars['Float']['input']>;
  customName?: InputMaybe<Scalars['String']['input']>;
  customOrdinal?: InputMaybe<Scalars['Float']['input']>;
  dueDate?: InputMaybe<Scalars['DateTime']['input']>;
  invoiceDate?: InputMaybe<Scalars['DateTime']['input']>;
  invoiceTermsUuid?: InputMaybe<Scalars['String']['input']>;
  nameSuffix?: InputMaybe<Scalars['String']['input']>;
  remitToAddressUuid?: InputMaybe<Scalars['String']['input']>;
  source?: InputMaybe<InvoiceSource>;
};

export type InvoiceEdge = {
  __typename?: 'InvoiceEdge';
  cursor: Scalars['String']['output'];
  node: InvoiceEntity;
};

export type InvoiceEntity = {
  __typename?: 'InvoiceEntity';
  age: Scalars['Int']['output'];
  balanceInCents: Scalars['Int']['output'];
  balanceInDollars: Scalars['Float']['output'];
  billTo?: Maybe<AddressEntity>;
  billToContact: ContactEntity;
  createdAt: Scalars['DateTime']['output'];
  date: Scalars['DateTime']['output'];
  documents: Array<DocumentEntity>;
  dueDate?: Maybe<Scalars['DateTime']['output']>;
  emailOptions: Array<Scalars['String']['output']>;
  emailSendStatus: EmailSendStatus;
  firstShipment?: Maybe<ShipmentEntity>;
  inConsolidatedInvoice: Scalars['Boolean']['output'];
  invoiceTerms?: Maybe<InvoiceTermEntity>;
  /** The invoice total charge in dollars as a string */
  invoiceTotal: Scalars['String']['output'];
  isLegacy?: Maybe<Scalars['Boolean']['output']>;
  journalNumber: Scalars['Float']['output'];
  lastSyncedToQuickbooksAt?: Maybe<Scalars['DateTime']['output']>;
  latestEmailTransaction?: Maybe<EmailTransactionEntity>;
  name: Scalars['String']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  orders: Array<OrderEntity>;
  postedAt?: Maybe<Scalars['DateTime']['output']>;
  qbInvoiceNumber?: Maybe<Scalars['Float']['output']>;
  quickbooksInvoiceId?: Maybe<Scalars['String']['output']>;
  remitTo?: Maybe<AddressEntity>;
  shipments: Array<ShipmentEntity>;
  source: InvoiceSource;
  status: InvoiceStatus;
  syncedToQuickbooksDesktopAt?: Maybe<Scalars['DateTime']['output']>;
  totalNumber: Scalars['Float']['output'];
  totalOpenAmount: Scalars['Float']['output'];
  uuid: Scalars['String']['output'];
};

/** An invoice or unapplied payment and its fields returned as part of an invoice aging report */
export type InvoiceForAgingReportEntity = {
  __typename?: 'InvoiceForAgingReportEntity';
  age: Scalars['Int']['output'];
  date: Scalars['DateTime']['output'];
  dueDate?: Maybe<Scalars['DateTime']['output']>;
  journalNumber?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  totalOpenAmount: Scalars['Float']['output'];
};

/** An invoice and its fields returned as part of an open invoice report */
export type InvoiceForOpenInvoiceReportEntity = {
  __typename?: 'InvoiceForOpenInvoiceReportEntity';
  billingPartyContactDisplayName: Scalars['String']['output'];
  billingPartyContactReferenceNumber?: Maybe<Scalars['String']['output']>;
  billingPartyContactUuid: Scalars['String']['output'];
  date: Scalars['DateTime']['output'];
  dueDate?: Maybe<Scalars['DateTime']['output']>;
  invoiceBalanceCents: Scalars['Float']['output'];
  invoiceTotalCents: Scalars['Float']['output'];
  journalNumber?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  orders: Array<OrderForOpenInvoiceReportEntity>;
  status: InvoiceStatus;
  uuid: Scalars['String']['output'];
};

export type InvoiceRegisterReportInput = {
  contactUuid?: InputMaybe<Scalars['String']['input']>;
  /**
   * The upper bound for the date of invoices which will be included in the report.
   *     If not included, the report will include all invoices after invoiceStartDate.
   */
  invoiceEndDate?: InputMaybe<Scalars['DateTime']['input']>;
  /**
   * The lower bound for the date of invoices which will be included in the report.
   *       If not included, the report will include all invoices before invoiceEndDate.
   */
  invoiceStartDate?: InputMaybe<Scalars['DateTime']['input']>;
  statusFilter: InvoiceStatusFilter;
};

export type InvoiceSendJobBatchConnection = {
  __typename?: 'InvoiceSendJobBatchConnection';
  edges: Array<InvoiceSendJobBatchEdge>;
  pageInfo: PageInfo;
  /** Not cheap to calculate, request with prudence */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type InvoiceSendJobBatchDocumentsEntity = {
  __typename?: 'InvoiceSendJobBatchDocumentsEntity';
  invoicesBackupDocument?: Maybe<DocumentEntity>;
  invoicesCombinedDocument?: Maybe<DocumentEntity>;
  invoicesZipDocument?: Maybe<DocumentEntity>;
};

export type InvoiceSendJobBatchEdge = {
  __typename?: 'InvoiceSendJobBatchEdge';
  cursor: Scalars['String']['output'];
  node: InvoiceSendJobBatchEntity;
};

export type InvoiceSendJobBatchEntity = {
  __typename?: 'InvoiceSendJobBatchEntity';
  createdAt: Scalars['DateTime']['output'];
  invoiceBatchDocuments: InvoiceSendJobBatchDocumentsEntity;
  invoiceSendJobBatchDocumentCount: Scalars['Float']['output'];
  invoiceSendJobBatchProgress: InvoiceSendJobBatchProgressEntity;
  type: InvoiceSendJobBatchType;
  uuid: Scalars['String']['output'];
};

export type InvoiceSendJobBatchProgressEntity = {
  __typename?: 'InvoiceSendJobBatchProgressEntity';
  failCount: Scalars['Float']['output'];
  successCount: Scalars['Float']['output'];
  totalCount: Scalars['Float']['output'];
};

export enum InvoiceSendJobBatchType {
  Download = 'DOWNLOAD',
  PostAndSend = 'POST_AND_SEND',
  Send = 'SEND'
}

export type InvoiceSendJobConnection = {
  __typename?: 'InvoiceSendJobConnection';
  edges: Array<InvoiceSendJobEdge>;
  pageInfo: PageInfo;
  /** Not cheap to calculate, request with prudence */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type InvoiceSendJobEdge = {
  __typename?: 'InvoiceSendJobEdge';
  cursor: Scalars['String']['output'];
  node: InvoiceSendJobEntity;
};

export type InvoiceSendJobEntity = {
  __typename?: 'InvoiceSendJobEntity';
  acknowledged?: Maybe<Scalars['Boolean']['output']>;
  createdAt: Scalars['DateTime']['output'];
  document?: Maybe<DocumentEntity>;
  documentGenerationFailed?: Maybe<Scalars['Boolean']['output']>;
  emailSubject?: Maybe<Scalars['String']['output']>;
  emailTransaction?: Maybe<EmailTransactionEntity>;
  invoice: InvoiceEntity;
  invoiceAttachmentDocumentTypes: Array<DocumentType>;
  /** A base64-encoded string that represents the list of shipments and their charges sent on the PDF invoice */
  invoiceChargesObject?: Maybe<Scalars['String']['output']>;
  invoiceSendJobError?: Maybe<InvoiceSendJobError>;
  invoiceTransmissionMethod: InvoiceTransmissionMethod;
  note?: Maybe<Scalars['String']['output']>;
  uuid: Scalars['String']['output'];
};

export enum InvoiceSendJobError {
  DocumentGenerationFailed = 'DOCUMENT_GENERATION_FAILED',
  InvoiceHasNoShipments = 'INVOICE_HAS_NO_SHIPMENTS',
  InvoiceMissingSomeShipments = 'INVOICE_MISSING_SOME_SHIPMENTS',
  InvoiceRecentlySent = 'INVOICE_RECENTLY_SENT',
  InvoiceTotalIsZero = 'INVOICE_TOTAL_IS_ZERO'
}

export enum InvoiceSendJobStatus {
  Failed = 'FAILED',
  InProgress = 'IN_PROGRESS',
  Success = 'SUCCESS'
}

export type InvoiceShipmentUpdate = {
  customChargeArrayUpdateInputs?: InputMaybe<Array<CustomChargeArrayUpdateInput>>;
  freightChargeArrayUpdateInputs?: InputMaybe<Array<FreightChargeCreateInput>>;
  shipmentUuid: Scalars['String']['input'];
};

export enum InvoiceSource {
  ManuallyCreated = 'MANUALLY_CREATED',
  Migrated = 'MIGRATED'
}

export enum InvoiceStatus {
  Invoiced = 'INVOICED',
  NotFinalized = 'NOT_FINALIZED',
  Paid = 'PAID',
  ReadyToInvoice = 'READY_TO_INVOICE',
  Void = 'VOID'
}

export enum InvoiceStatusFilter {
  All = 'ALL',
  NotPosted = 'NOT_POSTED',
  Posted = 'POSTED'
}

export type InvoiceTermEntity = {
  __typename?: 'InvoiceTermEntity';
  terms: Scalars['String']['output'];
  uuid: Scalars['String']['output'];
};

export type InvoiceToSend = {
  attachments: Array<DocumentType>;
  /** The email subject. If not provided, a subject will be generated */
  emailSubject?: InputMaybe<Scalars['String']['input']>;
  emails?: InputMaybe<Array<Scalars['String']['input']>>;
  invoiceTransmissionMethod: InvoiceTransmissionMethod;
  invoiceType: InvoiceType;
  note?: InputMaybe<Scalars['String']['input']>;
  uuid: Scalars['String']['input'];
};

export enum InvoiceTransmissionMethod {
  Download = 'DOWNLOAD',
  Edi = 'EDI',
  Email = 'EMAIL',
  EmailAndDownload = 'EMAIL_AND_DOWNLOAD',
  None = 'NONE'
}

export enum InvoiceType {
  ExcelItemized = 'EXCEL_ITEMIZED',
  ExcelSummarized = 'EXCEL_SUMMARIZED',
  PdfItemized = 'PDF_ITEMIZED',
  PdfSummarized = 'PDF_SUMMARIZED'
}

export type InvoiceUpdateInput = {
  associatedShipmentUuids?: InputMaybe<Array<Scalars['String']['input']>>;
  billToAddressUuid?: InputMaybe<Scalars['String']['input']>;
  billToContactUuid?: InputMaybe<Scalars['String']['input']>;
  customChargeArrayUpdate?: InputMaybe<Array<CustomChargeArrayUpdateInput>>;
  date?: InputMaybe<Scalars['DateTime']['input']>;
  documentUpsertInputs?: InputMaybe<Array<DocumentUpsertInput>>;
  dueDate?: InputMaybe<Scalars['DateTime']['input']>;
  emailSendStatus?: InputMaybe<EmailSendStatus>;
  invoiceShipmentUpdate?: InputMaybe<InvoiceShipmentUpdate>;
  invoiceTermsUuid?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  newBillToAddress?: InputMaybe<AddressCreateInput>;
  newRemitToAddress?: InputMaybe<AddressCreateInput>;
  notes?: InputMaybe<Scalars['String']['input']>;
  quickbooksInvoiceId?: InputMaybe<Scalars['String']['input']>;
  remitToAddressUuid?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<InvoiceStatus>;
  uuid: Scalars['String']['input'];
};

export type InvoiceUpdateLimitedInput = {
  date?: InputMaybe<Scalars['DateTime']['input']>;
  invoiceTermsUuid?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  uuid: Scalars['String']['input'];
};

export type IsReweighedSortInput = {
  direction: SortOrder;
  nulls: NullsOrder;
};

export type ItemConnection = {
  __typename?: 'ItemConnection';
  edges: Array<ItemEdge>;
  pageInfo: PageInfo;
};

export type ItemEdge = {
  __typename?: 'ItemEdge';
  cursor: Scalars['String']['output'];
  node: ItemEntity;
};

export type ItemEntity = {
  __typename?: 'ItemEntity';
  contact: ContactEntity;
  createdAt: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  inventoryItems: Array<InventoryItemEntity>;
  itemStorageUnitConfig?: Maybe<ItemStorageUnitConfigEntity>;
  primaryUOM: InventoryPrimaryUnitOfMeasureEntity;
  productCost?: Maybe<Scalars['Float']['output']>;
  quantity: Scalars['Int']['output'];
  secondaryUOM?: Maybe<InventorySecondaryUnitOfMeasureEntity>;
  sellPrice?: Maybe<Scalars['Float']['output']>;
  sku: Scalars['String']['output'];
  status: ItemStatus;
  storageOrders: Array<StorageOrderEntity>;
  storageUnitsCount: Scalars['Int']['output'];
  updatedAt: Scalars['DateTime']['output'];
  uuid: Scalars['String']['output'];
  warehouse: WarehouseEntity;
};

export type ItemForStorageOrder = {
  __typename?: 'ItemForStorageOrder';
  item: ItemEntity;
  /** The total count of inventory items of this item type */
  totalQuantity: Scalars['Int']['output'];
  /** The count of inventory items not assigned to a storage order */
  unassignedQuantity: Scalars['Int']['output'];
};

export type ItemForStorageUnit = {
  __typename?: 'ItemForStorageUnit';
  /** The count of inventory items of this item type assigned to this storage unit */
  assignedQuantity: Scalars['Int']['output'];
  item: ItemEntity;
};

export type ItemGroupConnection = {
  __typename?: 'ItemGroupConnection';
  edges: Array<ItemGroupEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type ItemGroupEdge = {
  __typename?: 'ItemGroupEdge';
  cursor: Scalars['String']['output'];
  node: ItemGroupEntity;
};

export type ItemGroupEntity = {
  __typename?: 'ItemGroupEntity';
  createdAt: Scalars['DateTime']['output'];
  item: ItemEntity;
  markedOnHandAt?: Maybe<Scalars['DateTime']['output']>;
  markedOsdAt?: Maybe<Scalars['DateTime']['output']>;
  pickedAt?: Maybe<Scalars['DateTime']['output']>;
  quantity: Scalars['Int']['output'];
  storageOrder: StorageOrderEntity;
  storageUnit?: Maybe<StorageUnitEntity>;
  unitOfMeasure: UnitOfMeasure;
  updatedAt: Scalars['DateTime']['output'];
  uuid: Scalars['String']['output'];
};

export type ItemGroupQuantityFilter = {
  /** UUIDs of itemGroups to query regardless of the filter type. Used to display picked itemGroups when editing a picklist */
  overrideUUIDs?: InputMaybe<Array<Scalars['String']['input']>>;
  type: ItemGroupQuantityFilterType;
};

export enum ItemGroupQuantityFilterType {
  All = 'ALL',
  NotZero = 'NOT_ZERO',
  OnlyZero = 'ONLY_ZERO'
}

export type ItemLocationEntity = {
  __typename?: 'ItemLocationEntity';
  createdAt: Scalars['DateTime']['output'];
  name: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  uuid: Scalars['String']['output'];
};

export enum ItemStatus {
  Active = 'ACTIVE',
  Inactive = 'INACTIVE'
}

export type ItemStorageUnitConfigEntity = {
  __typename?: 'ItemStorageUnitConfigEntity';
  consolidationUnitUOM: UnitOfMeasure;
  createdAt: Scalars['DateTime']['output'];
  dimensionsUOM: WarehouseMeasurementUnits;
  height: Scalars['Float']['output'];
  high: Scalars['Float']['output'];
  length: Scalars['Float']['output'];
  primaryUnitsPerConsolidationUnit: Scalars['Float']['output'];
  tie: Scalars['Float']['output'];
  type: MeasurementUnits;
  updatedAt: Scalars['DateTime']['output'];
  uuid: Scalars['String']['output'];
  weight: Scalars['Float']['output'];
  weightUOM: WarehouseMeasurementUnits;
  width: Scalars['Float']['output'];
};

export type LegCreateInput = {
  endStopCreateInput: StopCreateInput;
  miles?: InputMaybe<Scalars['Float']['input']>;
  /** Manually initialize a leg's status */
  status?: InputMaybe<LegStatus>;
};

export type LegDriverMapCreateInput = {
  driverUuid: Scalars['String']['input'];
  legUuid: Scalars['String']['input'];
};

export type LegDriverMapEntity = {
  __typename?: 'LegDriverMapEntity';
  driver?: Maybe<DriverEntity>;
  uuid: Scalars['String']['output'];
};

export type LegDriverMapUpdateInput = {
  driverUuid?: InputMaybe<Scalars['String']['input']>;
  legUuid?: InputMaybe<Scalars['String']['input']>;
  uuid?: InputMaybe<Scalars['String']['input']>;
};

export type LegEntity = {
  __typename?: 'LegEntity';
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  drivers: Array<DriverEntity>;
  endStop: StopEntity;
  flatRate?: Maybe<Scalars['Float']['output']>;
  legDriverMaps: Array<LegDriverMapEntity>;
  miles?: Maybe<Scalars['Float']['output']>;
  name: Scalars['String']['output'];
  previousStopAttempts: Array<StopEntity>;
  scheduledDate?: Maybe<Scalars['DateTime']['output']>;
  shipment: ShipmentEntity;
  status: LegStatus;
  tags: Array<TagEntity>;
  uuid: Scalars['String']['output'];
};

export enum LegPdfColumnMapping {
  Miles = 'MILES'
}

export enum LegStatus {
  Completed = 'COMPLETED',
  Created = 'CREATED',
  InProgress = 'IN_PROGRESS'
}

export type LegUpdateInput = {
  endStopUpdateInput?: InputMaybe<StopUpdateInput>;
  flatRate?: InputMaybe<Scalars['Float']['input']>;
  miles?: InputMaybe<Scalars['Float']['input']>;
  /** Manually update a leg's status. Only recommended if setting to COMPLETED */
  status?: InputMaybe<LegStatus>;
  uuid: Scalars['String']['input'];
};

export type LegUpsertInput = {
  endStopUpsertInput: StopUpsertInput;
  miles?: InputMaybe<Scalars['Float']['input']>;
  /** Manually initialize a leg's status */
  status?: InputMaybe<LegStatus>;
  uuid: Scalars['String']['input'];
};

export type LineHaulFuelChargeFuelProfileDateRangeInput = {
  contactUuid: Scalars['String']['input'];
  /** The date the line haul was completed. To be used to select the fuel profile date range selection if it exists */
  lineHaulCompletedDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** The UUID of the fuel profile attached to the tariff selected for the stop */
  tariffGroupFuelProfileUuid?: InputMaybe<Scalars['String']['input']>;
};

export type LineHaulFuelChargeFuelProfileDateRangeOutput = {
  __typename?: 'LineHaulFuelChargeFuelProfileDateRangeOutput';
  fuelProfileDateRange?: Maybe<FuelProfileDateRangeEntity>;
};

export type LineHaulLaneCreateInput = {
  destinationTerminalUuid: Scalars['String']['input'];
  intermediateTerminalUuids: Array<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  originTerminalUuid: Scalars['String']['input'];
};

export type LineHaulLaneEntity = {
  __typename?: 'LineHaulLaneEntity';
  destinationTerminal: TerminalEntity;
  isActive: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  originTerminal: TerminalEntity;
  segments: Array<LineHaulSegmentEntity>;
  uuid: Scalars['String']['output'];
};

export type LineHaulLaneUpdateInput = {
  destinationTerminalUuid?: InputMaybe<Scalars['String']['input']>;
  intermediateTerminalUuids?: InputMaybe<Array<Scalars['String']['input']>>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  originTerminalUuid?: InputMaybe<Scalars['String']['input']>;
  uuid: Scalars['String']['input'];
};

export type LineHaulManifestCreateInput = {
  completedAt?: InputMaybe<Scalars['DateTime']['input']>;
  departDate: Scalars['DateTime']['input'];
  driverUuid?: InputMaybe<Scalars['String']['input']>;
  endTerminalUuid: Scalars['String']['input'];
  equipmentUuid?: InputMaybe<Scalars['String']['input']>;
  referenceNumber: Scalars['String']['input'];
  startTerminalUuid: Scalars['String']['input'];
  startedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type LineHaulManifestEntity = {
  __typename?: 'LineHaulManifestEntity';
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  confirmedByAgentAt?: Maybe<Scalars['DateTime']['output']>;
  createdAt: Scalars['DateTime']['output'];
  departDate: Scalars['DateTime']['output'];
  driver?: Maybe<DriverEntity>;
  endTerminal: TerminalEntity;
  equipment?: Maybe<EquipmentEntity>;
  orderSegments: Array<OrderLineHaulSegmentEntity>;
  orders: Array<OrderEntity>;
  referenceNumber: Scalars['String']['output'];
  sentToAgentAt?: Maybe<Scalars['DateTime']['output']>;
  startTerminal: TerminalEntity;
  startedAt?: Maybe<Scalars['DateTime']['output']>;
  status: LineHaulManifestStatus;
  uuid: Scalars['String']['output'];
};

/** Filters with fields for the findLineHaulManifestsV2 query. Use either "and" or "or" or "filters", but not all simultaneously. Using all in the same query may lead to unexpected results. */
export type LineHaulManifestFilters = {
  and?: InputMaybe<Array<LineHaulManifestFilters>>;
  fields?: InputMaybe<Fields>;
  or?: InputMaybe<Array<LineHaulManifestFilters>>;
};

/** The status of the line haul manifest */
export enum LineHaulManifestStatus {
  Arrived = 'ARRIVED',
  Departed = 'DEPARTED',
  Planning = 'PLANNING'
}

export type LineHaulManifestStatusFilter = {
  /** Filters for records where the relevant status field is equal to the provided status value */
  eq?: InputMaybe<LineHaulManifestStatus>;
  /** Filters for records where the relevant status field is in the provided status values */
  in?: InputMaybe<Array<LineHaulManifestStatus>>;
  /** Filters for records where the relevant status field is not equal to the provided status value */
  neq?: InputMaybe<LineHaulManifestStatus>;
  /** Filters for records where the relevant status field is not in the provided status values */
  nin?: InputMaybe<Array<LineHaulManifestStatus>>;
};

export type LineHaulManifestUpdateInput = {
  completedAt?: InputMaybe<Scalars['DateTime']['input']>;
  departDate: Scalars['DateTime']['input'];
  driverUuid?: InputMaybe<Scalars['String']['input']>;
  endTerminalUuid?: InputMaybe<Scalars['String']['input']>;
  equipmentUuid?: InputMaybe<Scalars['String']['input']>;
  referenceNumber?: InputMaybe<Scalars['String']['input']>;
  startTerminalUuid?: InputMaybe<Scalars['String']['input']>;
  startedAt?: InputMaybe<Scalars['DateTime']['input']>;
  uuid: Scalars['String']['input'];
};

export type LineHaulManifestsCategoryGroupsOutput = {
  __typename?: 'LineHaulManifestsCategoryGroupsOutput';
  category: LineHaulManifestsGroupBy;
  groups: Array<ManifestGroup>;
};

/** Categories available for grouping line haul manifests */
export enum LineHaulManifestsGroupBy {
  Lane = 'LANE'
}

export type LineHaulManifestsGroupsInput = {
  filters?: InputMaybe<FindLineHaulManifestsV2FiltersInput>;
  groupBy: LineHaulManifestsGroupBy;
  searchText?: InputMaybe<Scalars['String']['input']>;
};

export type LineHaulOrderSort = {
  sortBy: OrderLineHaulSegmentSortFields;
  sortDirection: SortDirection;
};

export type LineHaulSegmentCreateInput = {
  endTerminalUuid: Scalars['String']['input'];
  laneUuid: Scalars['String']['input'];
  ordinal: Scalars['Float']['input'];
  startTerminalUuid: Scalars['String']['input'];
};

export type LineHaulSegmentEntity = {
  __typename?: 'LineHaulSegmentEntity';
  endTerminal: TerminalEntity;
  ordinal: Scalars['Float']['output'];
  startTerminal: TerminalEntity;
  uuid: Scalars['String']['output'];
};

export type LineHaulSegmentUpdateInput = {
  endTerminalUuid?: InputMaybe<Scalars['String']['input']>;
  laneUuid?: InputMaybe<Scalars['String']['input']>;
  ordinal: Scalars['Float']['input'];
  startTerminalUuid?: InputMaybe<Scalars['String']['input']>;
  uuid: Scalars['String']['input'];
};

export type LineHaulStatusByTerminal = {
  __typename?: 'LineHaulStatusByTerminal';
  arrivalScans: Array<ScanEntity>;
  departureScans: Array<ScanEntity>;
  manifestDepartingFromThisTerminal?: Maybe<LineHaulManifestEntity>;
  markedArrivedAt?: Maybe<Scalars['DateTime']['output']>;
  terminal: TerminalEntity;
};

export enum LinehaulDispatchTableField {
  CustomerName = 'CUSTOMER_NAME',
  DeadlineDate = 'DEADLINE_DATE',
  DimWeight = 'DIM_WEIGHT',
  Hawb = 'HAWB',
  InboundAddressName = 'INBOUND_ADDRESS_NAME',
  IsHazmat = 'IS_HAZMAT',
  IsSpecial = 'IS_SPECIAL',
  Lane = 'LANE',
  Mawb = 'MAWB',
  Name = 'NAME',
  NextSegment = 'NEXT_SEGMENT',
  OutboundAddressName = 'OUTBOUND_ADDRESS_NAME',
  PieceCount = 'PIECE_COUNT',
  Segment = 'SEGMENT',
  Service = 'SERVICE',
  ServiceDate = 'SERVICE_DATE',
  Tags = 'TAGS',
  Weight = 'WEIGHT'
}

export type LogUnassignedScanInput = {
  barcode: Scalars['String']['input'];
  scanType?: InputMaybe<ScanType>;
  stopUuid?: InputMaybe<Scalars['String']['input']>;
  terminalUuid?: InputMaybe<Scalars['String']['input']>;
};

export type LoginInput = {
  clientUuid?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
};

export type LoginOutput = {
  __typename?: 'LoginOutput';
  clientChallenge?: Maybe<Array<ClientChallengeEntity>>;
  driver?: Maybe<DriverEntity>;
  /** @deprecated Use kind to disambiguate instead */
  fullAccessUser?: Maybe<UserEntity>;
  kind?: Maybe<Scalars['String']['output']>;
  status: LoginStatus;
  /** @deprecated Use kind to disambiguate instead */
  thirdPartyUser?: Maybe<ThirdPartyUserEntity>;
};

export type LoginPhoneInput = {
  password: Scalars['String']['input'];
  phoneNumber: Scalars['String']['input'];
};

export type LoginPhoneJwtInput = {
  jwt: Scalars['String']['input'];
  phoneNumber: Scalars['String']['input'];
};

export type LoginPhoneOutput = {
  __typename?: 'LoginPhoneOutput';
  driver?: Maybe<DriverEntity>;
  jwt?: Maybe<Scalars['String']['output']>;
  status: LoginStatus;
  warehouseEmployee?: Maybe<WarehouseEmployeeEntity>;
};

export enum LoginStatus {
  ClientChallenge = 'CLIENT_CHALLENGE',
  InvalidCredentials = 'INVALID_CREDENTIALS',
  Success = 'SUCCESS',
  ThirdPartyUserNoOrganization = 'THIRD_PARTY_USER_NO_ORGANIZATION',
  Unauthorized = 'UNAUTHORIZED'
}

export type MakeAppointmentConfirmationDecisionInput = {
  accepted: Scalars['Boolean']['input'];
  stopUuid: Scalars['String']['input'];
};

export type MakeAppointmentConfirmationDecisionOutput = AppointmentConfirmationInfoOutput | MutationErrorOutput;

export type ManifestGroup = {
  __typename?: 'ManifestGroup';
  category: LineHaulManifestsGroupBy;
  manifests: Array<LineHaulManifestEntity>;
};

export type MarkAsNotOnHandInput = {
  /** The UUID of the order to mark not on hand */
  uuid: Scalars['String']['input'];
};

export type MarkAsNotReceivedAtOriginInput = {
  /** The UUID of the order to mark not received at origin terminal */
  uuid: Scalars['String']['input'];
};

export type MarkAsOnHandInput = {
  pieceCount?: InputMaybe<Scalars['Int']['input']>;
  sentFromMobileApplication?: InputMaybe<Scalars['Boolean']['input']>;
  uuid: Scalars['String']['input'];
};

export type MarkAsOnHoldInput = {
  holdReasonUuid?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  uuid: Scalars['String']['input'];
};

export type MarkAsReceivedAtOriginInput = {
  sentFromMobileApplication?: InputMaybe<Scalars['Boolean']['input']>;
  uuid: Scalars['String']['input'];
};

export type MarkConsolidatableOrdersAsBilledIndividuallyInput = {
  orderUuid: Scalars['String']['input'];
};

export type MarkManifestAsArrivedInput = {
  /** Indicates if the manifest arrival is being marked from the line haul dispatch screen. Used as part of the business logic to determine if the manifest should be marked as on hand. */
  fromDispatch?: InputMaybe<Scalars['Boolean']['input']>;
  uuid: Scalars['String']['input'];
};

export type MarkManifestAsArrivedOutput = {
  __typename?: 'MarkManifestAsArrivedOutput';
  errorMessage?: Maybe<Scalars['String']['output']>;
  lineHaulManifest?: Maybe<LineHaulManifestEntity>;
};

export type MarkManifestAsDepartedInput = {
  uuid: Scalars['String']['input'];
};

export type MarkManifestAsDepartedOutput = {
  __typename?: 'MarkManifestAsDepartedOutput';
  errorMessage?: Maybe<Scalars['String']['output']>;
  lineHaulManifest?: Maybe<LineHaulManifestEntity>;
};

export type MarkManifestAsPlanningInput = {
  uuid: Scalars['String']['input'];
};

export type MarkManifestAsPlanningOutput = {
  __typename?: 'MarkManifestAsPlanningOutput';
  errorMessage?: Maybe<Scalars['String']['output']>;
  lineHaulManifest?: Maybe<LineHaulManifestEntity>;
};

export type MarkNotOsdInput = {
  sentFromMobileApplication?: InputMaybe<Scalars['Boolean']['input']>;
  uuid: Scalars['String']['input'];
};

export type MarkOrderAsCompleteForceInput = {
  refuseOrderInput?: InputMaybe<RefuseOrderInput>;
  uuid: Scalars['String']['input'];
};

export type MarkOrderAsPickedInput = {
  piecesPicked?: InputMaybe<Scalars['Int']['input']>;
  sentFromMobileApplication?: InputMaybe<Scalars['Boolean']['input']>;
  uuid: Scalars['String']['input'];
};

/** The expected input to the mutation that marks an order as refused, records who it was refused by, and when it was refused */
export type MarkOrderAsRefusedInput = {
  /** The person that the order was refused by */
  refusedBy: Scalars['String']['input'];
  /** The date and time when the order was marked as refused */
  refusedDate: Scalars['DateTime']['input'];
  /** The UUID of the order to mark as refused */
  uuid: Scalars['String']['input'];
};

export type MarkOrderAsRefusedOutput = MarkOrderAsRefusedSuccessOutput | MutationErrorOutput;

export type MarkOrderAsRefusedSuccessOutput = {
  __typename?: 'MarkOrderAsRefusedSuccessOutput';
  success: Scalars['Boolean']['output'];
};

export type MarkOsdInput = {
  notes?: InputMaybe<Scalars['String']['input']>;
  /** Include any notes provided on why the order was OSD */
  osdReason?: InputMaybe<Scalars['String']['input']>;
  sentFromMobileApplication?: InputMaybe<Scalars['Boolean']['input']>;
  uuid: Scalars['String']['input'];
};

export type MarkStopAsFailedV2Input = {
  attemptedAt?: InputMaybe<Scalars['DateTime']['input']>;
  notes: Scalars['String']['input'];
  uuid: Scalars['String']['input'];
};

export type MarkStorageUnitAsBilledInput = {
  /** The UUID of the storage unit to mark as billed */
  uuid: Scalars['String']['input'];
};

export type MarkStorageUnitAsBilledOutput = {
  __typename?: 'MarkStorageUnitAsBilledOutput';
  success: Scalars['Boolean']['output'];
};

export type MarkStorageUnitAsOsdInput = {
  osdReason?: InputMaybe<Scalars['String']['input']>;
  uuid: Scalars['String']['input'];
};

export type MarkStorageUnitAsOsdOutput = {
  __typename?: 'MarkStorageUnitAsOsdOutput';
  success: Scalars['Boolean']['output'];
};

export type MarkStorageUnitOnHandInput = {
  uuid: Scalars['String']['input'];
};

export type MarkStorageUnitOnHandOutput = {
  __typename?: 'MarkStorageUnitOnHandOutput';
  success: Scalars['Boolean']['output'];
};

export type MasterAccountEntity = {
  __typename?: 'MasterAccountEntity';
  createdAt: Scalars['DateTime']['output'];
  name: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  uuid: Scalars['String']['output'];
};

export enum MatcherType {
  Contains = 'CONTAINS',
  EndsWith = 'ENDS_WITH',
  NotContains = 'NOT_CONTAINS',
  NotEndsWith = 'NOT_ENDS_WITH',
  NotStartsWith = 'NOT_STARTS_WITH',
  Regex = 'REGEX',
  RegexNoMatch = 'REGEX_NO_MATCH',
  StartsWith = 'STARTS_WITH'
}

export type MatchingGroupsAlongWithMatchingServices = {
  __typename?: 'MatchingGroupsAlongWithMatchingServices';
  /** the services in that group that has a match */
  serviceUuids: Array<Scalars['String']['output']>;
  /** the tariff group that has this combination */
  tariffGroupName?: Maybe<Scalars['String']['output']>;
  /** the tariff group uuid that has this combination */
  tariffGroupUuid: Scalars['String']['output'];
};

export type MawbSortInput = {
  direction: SortOrder;
  nulls: NullsOrder;
};

export enum MeasurementSystem {
  Imperial = 'IMPERIAL',
  Metric = 'METRIC'
}

export enum MeasurementUnits {
  Centimeters = 'CENTIMETERS',
  Inches = 'INCHES'
}

export type MergeEdiOrderInput = {
  existingOrderUuid: Scalars['String']['input'];
  incomingEdiOrderUuid: Scalars['String']['input'];
};

export type MergeEdiOrderOutput = {
  __typename?: 'MergeEdiOrderOutput';
  uuid: Scalars['String']['output'];
};

export type MetricTagInput = {
  tag: Scalars['String']['input'];
  value: Scalars['String']['input'];
};

export enum MetricType {
  Count = 'COUNT',
  Distribution = 'DISTRIBUTION',
  Gauge = 'GAUGE'
}

export type MissingOrderForInvoiceMoveEntity = {
  __typename?: 'MissingOrderForInvoiceMoveEntity';
  name: Scalars['String']['output'];
  uuid: Scalars['String']['output'];
};

export type MoveShipmentsBetweenInvoicesIncompleteOperationOutput = {
  __typename?: 'MoveShipmentsBetweenInvoicesIncompleteOperationOutput';
  /** The list of shipment UUIDs that need to also be moved for the operation to be completed successfully. For example we want to move all shipments of a consolidated order even though we only specified some in the input. */
  additionalShipmentUuidsToMove: Array<Scalars['String']['output']>;
  /** The list of shipment UUIDs that were specified in the input. */
  inputShipmentUuids: Array<Scalars['String']['output']>;
  /** The list of orders that are missing for the operation to be completed successfully. For example we want to move all shipments of a consolidated order even though we only specified some in the input. */
  missingOrders: Array<MissingOrderForInvoiceMoveEntity>;
};

/** The input to move shipments to a new invoice */
export type MoveShipmentsBetweenInvoicesInput = {
  /** The uuid of the invoice that we want to move the shipments from. */
  invoiceMovingFromUuid: Scalars['String']['input'];
  /** The uuid of the new invoice that we want to move the shipments to. If null, the shipments will be moved to a newly created invoice. */
  invoiceMovingToUuid?: InputMaybe<Scalars['String']['input']>;
  shipmentUuids: Array<Scalars['String']['input']>;
};

export type MoveShipmentsBetweenInvoicesOutput = MoveShipmentsBetweenInvoicesIncompleteOperationOutput | MoveShipmentsBetweenInvoicesSuccessOutput | MutationErrorOutput;

export type MoveShipmentsBetweenInvoicesSuccessOutput = {
  __typename?: 'MoveShipmentsBetweenInvoicesSuccessOutput';
  /** The list of shipment UUIDs that were successfully moved to the new invoice */
  movedShipmentUuids: Array<Scalars['String']['output']>;
  /** The uuid of the new invoice that we moved the shipments to */
  newInvoiceUuid: Scalars['String']['output'];
};

export type MoveShipmentsToInvoiceInput = {
  invoiceUuid: Scalars['String']['input'];
  uuids: Array<Scalars['String']['input']>;
};

export type MoveShipmentsToInvoiceOutput = {
  __typename?: 'MoveShipmentsToInvoiceOutput';
  errors?: Maybe<Array<Scalars['String']['output']>>;
  /**
   * UUID of target invoice
   * @deprecated Added for backwards compatibility
   */
  uuid?: Maybe<Scalars['String']['output']>;
};

export type Mutation = {
  __typename?: 'Mutation';
  acceptCustomerPortalOrder: AcceptCustomerPortalOrderOutput;
  acceptEdiOrApiOrder: AcceptEdiOrApiOrderOutput;
  acknowledgeFailedInvoiceSendJobs: InvoiceSendJobBatchEntity;
  /** Acknowledge changes to all stops for the current driver */
  acknowledgeMyRouteChanges: Scalars['Int']['output'];
  /** Acknowledge changes to a specific stop for the current driver */
  acknowledgeMyStopChange: AcknowledgeMyStopChangeOutput;
  acknowledgeNotification: NotificationEntity;
  acknowledgeNotifications: Array<NotificationEntity>;
  addApiUserContactMapping: ApiUserEntity;
  addDriverExpoPushToken?: Maybe<DriverEntity>;
  addDriversToRoute: Array<RouteDriverEntity>;
  /** Given lists of settlement bill line items, will create new settlement bill line items and update existing ones */
  addLineItemsToSettlementBills: AddLineItemsToSettlementBillsOutput;
  addNextRouteSlotForRoute: RouteEntity;
  addOrdersToInvoices: AddOrdersToInvoicesOutput;
  addOrdersToManifest: AddOrdersToManifestOutput;
  addOrdersToManifestV2: AddOrdersToManifestV2Output;
  addPermissionToRoleInput?: Maybe<Scalars['Int']['output']>;
  addQuickbooksDesktopCustomer: QuickbooksDesktopResultEntity;
  addQuickbooksDesktopCustomers: Array<QuickbooksDesktopResultEntity>;
  addQuickbooksDesktopItem: QuickbooksDesktopResultEntity;
  addServiceToContact: ServiceEntity;
  /** Finds existing contact-to-services mappings and adds the specified services */
  addServicesToTariffGroupMappings: Array<ContactToServicesTariffGroupMappingEntity>;
  addTagToLeg: TagEntity;
  addTagToOrder: TagEntity;
  addThirdPartyUserToContact: ThirdPartyUserEntity;
  addUserToRole: AddUserToRoleOutput;
  approveQuote: QuoteEntity;
  archiveContactStation: ContactStationUpdateOutput;
  archiveDriver: UpdateDriverOutput;
  archiveOrganization: ArchiveOrganizationOutput;
  archivePackageSpec: UpdatePackageSpecOutput;
  archivePerson: UpdatePersonOutput;
  archiveSchedulingRegion: UpdateSchedulingRegionOutput;
  archiveTariffChain: ArchiveTariffChainOutput;
  archiveTariffZoneGroup: TariffZoneGroupArchiveOutput;
  archiveVehicleType: VehicleTypeUpdateOutput;
  arriveAtStop: StopEntity;
  arriveAtStops: ArriveAtStopsOutput;
  assignHelperToRoute: Array<DriverOnRouteEntity>;
  assignInventoryItemsToStorageUnit: AssignInventoryItemsToStorageUnitOutput;
  assignOutboundReferenceNumbersToStorageUnits: AssignOutboundReferenceNumberToStorageUnitsOutput;
  attachMobileSignedDocumentToOrderAndReplaceOriginal: UploadMobileSignedDocumentOutput;
  backfillAccessorialDateRangeConfigs: Scalars['Float']['output'];
  backfillContactCommunicationConfigs: Scalars['String']['output'];
  backfillFuelProfileDateRangeRates?: Maybe<Scalars['Float']['output']>;
  backfillItemGroups: Scalars['Boolean']['output'];
  backfillJETSpecial: Scalars['Int']['output'];
  /** Backfill order totals for orders that do not have a total amount stored. */
  backfillOrderTotals: BackfillOrderTotalsOutput;
  backfillPaymentAppliedAmounts: Array<PaymentEntity>;
  backfillSettlementDate: Scalars['Float']['output'];
  backfillTariffZoneGroups: Scalars['String']['output'];
  backfillTariffZoneGroupsForCompany: Scalars['String']['output'];
  batchAddShipmentsToInvoicesMultiple: Array<InvoiceEntity>;
  bulkChangeCallStatus: Scalars['Float']['output'];
  bulkConfirmAppointments: Scalars['Float']['output'];
  bulkEditOrders: Scalars['String']['output'];
  bulkUpdateAccessorialMappings: Array<AccessorialUnion>;
  bulkUpdateContactQuickbooksIds: Array<CustomerContactEntity>;
  bulkUploadRouteNames: Array<RouteNameEntity>;
  calculateRouteEtas: Array<EtaEntity>;
  callStops: Array<StopEntity>;
  chooseAppointmentOption: ChooseAppointmentOptionOutput;
  /** Clears a company. Only intended to be called via this Relay Workflow: https://run.relay.app/workflows/cm2dz61pm03eo0qlx5tb43i1q/edit. Accordingly, returns early to avoid Relay timing out. */
  clearCompany: Scalars['Int']['output'];
  clearCompanyContacts: ClearCompanyContactsOutput;
  completeRebill: CompleteRebillOutput;
  completeStopBulk: Array<StopEntity>;
  completeStopV2: CompleteStopOutput;
  connectToQuickbooksDesktop: Scalars['String']['output'];
  createAccessorial: AccessorialUnion;
  createAccessorialContact: CreateAccessorialContactOutput;
  createAccessorialDateRangeConfig: CreateAccessorialDateRangeConfigOutput;
  createAccessorialToQuickbooksMapping: AccessorialToQuickbooksMappingEntity;
  createAccountingReportDocument: CreateAccountingReportDocumentOutput;
  createAddress: AddressEntity;
  createAdjustmentStopDriverMap?: Maybe<StopDriverMapEntity>;
  createAirportInfo: AirportInfoEntity;
  createApiUser: ApiUserEntity;
  createAppointmentsForRoute: RouteEntity;
  createAutoApplyAccessorialConfig: AutoApplyAccessorialConfigEntity;
  createBusinessDivision: CreateBusinessDivisionOutput;
  createCompany: CompanyEntity;
  createConsolidatedOrder: OrderEntity;
  createConsolidatedOrderFromOrder: OrderEntity;
  createContactComment: ContactCommentEntity;
  /** @deprecated Use updateContactEmails instead. */
  createContactCommunicationConfig: ContactCommunicationConfigEntity;
  createContactDocument: DocumentEntity;
  /** @deprecated Should be used only for invoice subscriptions. Use updateContactEmails for order update subscriptions. */
  createContactEmail?: Maybe<ContactEmailEntity>;
  createContactPerson: ContactPersonEntity;
  createContactStation: ContactStationCreateOutput;
  createCoverSheetDocumentTypeSequence: CoverSheetDocumentTypeSequenceEntity;
  createCreditType: CreditTypeEntity;
  createCsvOrderFieldMapping: CsvOrderFieldMappingEntity;
  createCsvOrderImportTransaction: CsvOrderImportTransactionEntity;
  createCsvOrderMapping: CsvOrderMappingEntity;
  createCustomerContact: CustomerContactEntity;
  createCustomerContacts: CreateCustomerContactsOutput;
  createDispatchView: DispatchViewCreateOutput;
  createDocument: DocumentEntity;
  createDriver?: Maybe<DriverEntity>;
  createDriverSettlementBill: DriverSettlementBillEntity;
  createDriverSignableFormTemplate: DriverSignableFormTemplateEntity;
  createDrivers: CreateDriversOutput;
  createDuplicateOrderForRebill: CreateDuplicateOrderForRebillOutput;
  createEODDocuments: Array<DocumentEntity>;
  createEdiPartnership: EdiPartnershipEntity;
  createEdiPartnershipServiceMappings: CreateEdiPartnershipServiceMappingsOutput;
  /** Use sparingly, not meant for regular use */
  createEdiTransaction: CreateEdiTransactionOutput;
  createEmailTransaction: CreateEmailTransactionOutput;
  createEmailTransactionLog: EmailTransactionLogEntity;
  createEndOfDayDocumentProcessingJob: EndOfDayDocumentProcessingJobEntity;
  createEquipment: EquipmentEntity;
  createEquipmentLicense: EquipmentLicenseEntity;
  createEquipments: CreateEquipmentsOutput;
  createFeatureFlag: FeatureFlagEntity;
  createFeatureFlagCompanyOverride: FeatureFlagCompanyOverrideEntity;
  createFeatureFlagUserOverride?: Maybe<FeatureFlagUserOverrideEntity>;
  createFreightCharge: FreightChargeEntity;
  createFuelProfile?: Maybe<FuelProfileEntity>;
  createFuelProfileDateRange: CreateFuelProfileDateRangeOutput;
  createGeneralLedgerCode: CreateGeneralLedgerCodeOutput;
  createGeneralLedgerConfiguration: GeneralLedgerConfigurationEntity;
  createHoldReason: HoldReasonEntity;
  createImportedOrderTypeMapping: ImportedOrderTypeMappingEntity;
  createImportedOrderTypeMappings: Array<ImportedOrderTypeMappingEntity>;
  createIngestedOutlookEmail: CreateIngestedOutlookEmailOutput;
  createIngestedOutlookEmailAttachment: CreateIngestedOutlookEmailAttachmentOutput;
  /** @deprecated Deprecated. Use upsertItemGroup instead */
  createInventoryItems: CreateInventoryItemsOutput;
  createInventoryPrimaryUnitOfMeasure: InventoryPrimaryUnitOfMeasureEntity;
  createInventorySecondaryUnitOfMeasure: InventorySecondaryUnitOfMeasureEntity;
  createInvoice: InvoiceEntity;
  createInvoiceDocument: DocumentEntity;
  createInvoiceDocuments: Array<DocumentEntity>;
  createInvoiceTerms: InvoiceTermEntity;
  createInvoiceTermsForAll: Scalars['Boolean']['output'];
  createItem: CreateItemOutput;
  createItemLocation: CreateItemLocationOutput;
  createLeg: LegEntity;
  /** This is probably not the method you want to use */
  createLegDriverMap: LegDriverMapEntity;
  createLineHaulLane: CreateLineHaulLaneOutput;
  createLineHaulManifest: LineHaulManifestEntity;
  createLineHaulManifests: CreateLineHaulManifestsOutput;
  createLineHaulSegment: CreateLineHaulSegmentOutput;
  createManyReferenceNumberLabels: Array<ReferenceNumberLabelEntity>;
  createMasterAccount: CreateMasterAccountOutput;
  createNotification: NotificationEntity;
  createOrUpdateCsvOrders: CreateOrUpdateCsvOrdersOutput;
  createOrderComment: OrderCommentEntity;
  createOrderDocument: DocumentEntity;
  createOrderDocumentDocument: CreateOrderDocumentDocumentOutput;
  createOrderImportConfiguration: OrderImportConfigurationEntity;
  createOrderLineHaulSegment: OrderLineHaulSegmentEntity;
  createOrderSnapshot?: Maybe<OrderEventEntity>;
  createOrderTableReport: CreateOrderTableReportOutput;
  createOrdersFromRecurringTemplates: Array<OrderEntity>;
  createOrganization: CreateOrganizationOutput;
  createOutlookIntegration: OutlookIntegrationEntity;
  createPODReportDocument: CreatePodReportDocumentOutput;
  /** @deprecated Do not create packages directly */
  createPackage: PackageEntity;
  createPackageSpec: CreatePackageSpecOutput;
  createPayment: PaymentEntity;
  createPdfColumn: PdfColumnEntity;
  createPermission: CreatePermissionOutput;
  createPerson: CreatePersonOutput;
  /** @deprecated Use upsertPicklist instead */
  createPicklist: UpsertPicklistOutput;
  createPiece: PieceEntity;
  createPlace: PlaceEntity;
  createProratedConsolidatedOrder: CreateProratedConsolidatedOrderOutput;
  createQuickbooksHeaderFileMapping: QuickbooksHeaderFileMappingEntity;
  createQuote: QuoteEntity;
  createRecurringOrderFrequency: RecurringOrderFrequencyEntity;
  createRecurringOrdersFromTemplates: Scalars['Boolean']['output'];
  createReportGroupConfiguration: ReportGroupConfigurationEntity;
  createRole: CreateRoleOutput;
  createRoute: RouteEntity;
  /** This is probably not the API you want to use */
  createRouteDriver: RouteDriverEntity;
  createRouteFromRouteTemplate: CreateRouteFromRouteTemplateOutput;
  createRouteName: RouteNameEntity;
  createRouteNameLocation: RouteNameLocationEntity;
  createRouteOptimization: RouteOptimizationEntity;
  createRoutePaths: Array<Maybe<RoutePathEntity>>;
  createRouteSlot: Array<Maybe<RouteSlotEntity>>;
  createRoutes: Array<RouteEntity>;
  createRun: CreateRunOutput;
  createSameDayDispatchConfig: SameDayDispatchConfigEntity;
  createSamsaraOauthToken: SamsaraOauthTokenEntity;
  /** Development-only route for creating sandbox routes for a driver */
  createSandboxRouteForDriver?: Maybe<Scalars['Boolean']['output']>;
  createSavedFilterView: SavedFilterViewEntity;
  createScannedOrders: Scalars['Boolean']['output'];
  createScannedOrdersFromAdmin: Array<ScannedOrderFromAdminCreateOutput>;
  createSchedulingRegion: CreateSchedulingRegionOutput;
  createSchedulingZone: CreateSchedulingZoneOutput;
  createSchema: Scalars['String']['output'];
  createSchemaCompanyMapping: Scalars['String']['output'];
  createSchemaDocument: SchemaDocumentEntity;
  createSchemaTestSnapshot: Scalars['String']['output'];
  createService: ServiceEntity;
  /** Creates new service regions for the current company. Automatically removes duplicate regions with the same name from the input. Existing regions remain unchanged. */
  createServiceRegions: CreateServiceRegionsOutput;
  createSettlementAdjustment: CreateOrUpdateSettlementAdjustmentOutput;
  /** @deprecated Deprecated during Robust Settlement Project. Use `createSettlementAdjustment` instead */
  createSettlementDeduction: SettlementDeductionEntity;
  createSettlementDeductionType: SettlementDeductionTypeEntity;
  createSftpCredentials: CreateSftpCredentialsOutput;
  createShipmentDocument: DocumentEntity;
  createStandardOrder: StandardOrderEntity;
  createStandardOrderFields: StandardOrderFieldsEntity;
  createStandardShipmentFields: StandardShipmentFieldsEntity;
  createStorageOrder: CreateStorageOrderOutput;
  createStorageOrderDocument: CreateStorageOrderDocumentOutput;
  createStorageUnit: CreateStorageUnitOutput;
  /** @deprecated Deprecated. Use createStorageUnit instead */
  createStorageUnitWithInventoryItems: CreateStorageUnitWithInventoryItemsOutput;
  createTag: TagEntity;
  createTariff: CreateTariffOutput;
  createTariffChain: CreateTariffChainOutput;
  createTariffGroup: TariffGroupEntity;
  createTariffLocation: CreateTariffLocationOutput;
  createTariffZone: TariffZoneEntity;
  createTariffZoneGroup: TariffZoneGroupCreateOutput;
  /** @deprecated Use createTerminalV2 instead */
  createTerminal: CreateTerminalOutput;
  createTerminalLanes: CreateTerminalLanesOutput;
  /** @deprecated Deprecating because we are removing zip+city uniqueness constraint and this is not used by the frontend. Use createTerminalServiceAreasV2 instead */
  createTerminalServiceArea: TerminalServiceAreaEntity;
  /** @deprecated Deprecating because we are removing zip+city uniqueness constraint. Use createTerminalServiceAreasV2 instead */
  createTerminalServiceAreas: Array<CreateTerminalServiceAreaOutput>;
  createTerminalServiceAreasV2: CreateTerminalServiceAreaV2Output;
  createTerminalV2: CreateTerminalV2Output;
  createTerminals: Scalars['Int']['output'];
  createTestCompany: CreateTestCompanyOutput;
  createTestContact: CreateTestCompanyOutput;
  createTestOrder: CreateTestOrderOutput;
  createTestOrderCustomCharge: CreateTestOrderCustomChargeOutput;
  createTestOrderV2: CreateTestOrderResponse;
  createTestUser?: Maybe<UserEntity>;
  createThirdPartyBroker: ThirdPartyBrokerEntity;
  /** @deprecated Use addThirdPartyUserToContact instead. Deprecated on 11/14/23, to be removed on 12/14/23 */
  createThirdPartyUser: ThirdPartyUserEntity;
  createUser?: Maybe<UserEntity>;
  createVehicleType: VehicleTypeEntity;
  createWarehouse: WarehouseEntity;
  createWarehouseEmployee: CreateWarehouseEmployeeOutput;
  createWarehouseLocation: CreateWarehouseLocationOutput;
  delete: CsvOrderImportTransactionEntity;
  deleteAccessorialDateRangeConfig: AccessorialDateRangeConfigEntity;
  deleteAccessorialRange: AccessorialRangeEntity;
  deleteAutoApplyAccessorialConfig: Scalars['Boolean']['output'];
  deleteContactComment: DeleteContactCommentOutput;
  deleteContactEmail: ContactEmailEntity;
  deleteCsvOrderFieldMapping: CsvOrderFieldMappingEntity;
  deleteDocument?: Maybe<DocumentEntity>;
  deleteDrayageShipmentFields: StandardShipmentFieldsEntity;
  deleteDriverSignableFormTemplate: DriverSignableFormTemplateEntity;
  deleteEquipment: EquipmentEntity;
  deleteFeatureFlagCompanyOverride: FeatureFlagCompanyOverrideEntity;
  deleteFeatureFlagUserOverride: FeatureFlagUserOverrideEntity;
  deleteFreightCharge: FreightChargeEntity;
  deleteFuelProfileDateRange: DeleteFuelProfileDateRangeOutput;
  deleteGeneralLedgerCode: DeleteGeneralLedgerCodeOutput;
  /** @deprecated Deprecated. Use upsertItemGroup instead */
  deleteInventoryItems: DeleteInventoryItemsOutput;
  /** This is probably not the method you want to use */
  deleteLegDriverMap: LegDriverMapEntity;
  deleteOrder?: Maybe<OrderEntity>;
  deleteOrderComment: DeleteOrderCommentOutput;
  deletePackage: PackageEntity;
  deletePayment: PaymentEntity;
  deletePermission: DeletePermissionOutput;
  deleteQuickbooksHeaderFileMapping: QuickbooksHeaderFileMappingEntity;
  deleteQuote?: Maybe<QuoteEntity>;
  deleteReportGroupConfiguration: ReportGroupConfigurationEntity;
  deleteRole: DeleteRoleOutput;
  deleteRouteNameLocation: RouteNameLocationEntity;
  deleteSameDayDispatchConfig: SameDayDispatchConfigEntity;
  deleteSavedFilterView: SavedFilterViewEntity;
  deleteSchema?: Maybe<Scalars['String']['output']>;
  deleteSchemaCompanyMapping: Scalars['String']['output'];
  deleteSchemaDocument?: Maybe<Scalars['String']['output']>;
  deleteSchemaRun: Scalars['String']['output'];
  deleteSlotsFromRoute?: Maybe<Scalars['Int']['output']>;
  deleteStandardOrder: StandardOrderEntity;
  deleteStandardOrderFields: StandardOrderFieldsEntity;
  deleteStopAttempt: DeleteStopAttemptOutput;
  deleteStopDriverMap: StopDriverMapEntity;
  deleteStorageOrder: DeleteStorageOrderOutput;
  /** Deletes storage orders and all associated entities such as audit log entries, storage units, and pick ticket items */
  deleteStorageOrders: DeleteStorageOrdersOutput;
  deleteStorageUnit: DeleteStorageUnitOutput;
  deleteStuckSendingEmailTransactions?: Maybe<Scalars['Float']['output']>;
  deleteTag: TagEntity;
  deleteTariff: TariffEntity;
  deleteTariffGroup: TariffGroupEntity;
  deleteTariffLocation: DeleteTariffLocationOutput;
  deleteTariffRange: TariffRangeEntity;
  deleteTariffZone: TariffZoneEntity;
  deleteTariffZones: Scalars['String']['output'];
  deleteTariffs: Array<TariffEntity>;
  deleteTerminalLanes: DeleteTerminalLanesOutput;
  /** @deprecated Use removeThirdPartyUserFromContact instead. Deprecated on 11/14/23, to be removed by 12/14/23 */
  deleteThirdPartyUser: ThirdPartyUserEntity;
  /** Deletes all warehouse locations for a company that are not associated with a storage unit, inventory item, or package. */
  deleteUnusedWarehouseLocations: Scalars['Int']['output'];
  deleteUser?: Maybe<UserEntity>;
  deleteWarehouse: WarehouseEntity;
  deleteWarehouseLocation: DeleteWarehouseLocationOutput;
  detachDocumentFromShipment: DocumentEntity;
  detachDocumentsFromShipments: Array<DocumentEntity>;
  dismissCompletedScannedOrderResults: Scalars['Int']['output'];
  dismissScannedOrderResult: ScannedOrderResultEntity;
  downloadInvoices: DownloadInvoicesOutput;
  driverSettlementBillExportPdf: ReportFileOutput;
  driverSettlementBillExportZip: ReportFileOutput;
  duplicateEdiPartnerships: DuplicateEdiPartnershipsOutput;
  duplicateTariffGroup: DuplicateTariffGroupOutput;
  editContacts: EditContactsOutput;
  editPaymentAmount: PaymentEntity;
  emailAccountingReport: EmailAccountingReportOutput;
  emailOrderDocument: EmailOrderDocumentOutput;
  exportInvoicesToQuickbooksDesktop: Array<ExportQuickbooksResult>;
  /** Do not use for FF_ROBUST_SETTLEMENT. Use finalizeSettlementBills instead. */
  finalizeDriverSettlementBills: Scalars['Float']['output'];
  finalizeInvoices: FinalizeInvoicesOutput;
  finalizeOrder: OrderEntity;
  finalizeOrders: FinalizeOrdersOutput;
  /** If FF_ROBUST_SETTLEMENT is enabled, will create a snapshot for each bill and finalize the bill. */
  finalizeSettlementBills: FinalizeSettlementBillsOutput;
  flipIsArchived: AccessorialUnion;
  generateAccountingReportPreSignedPutUrl: Scalars['String']['output'];
  generateClearCompanyContactsToken: GenerateClearCompanyContactsTokenOutput;
  generateContactPreSignedPutUrl: GeneratePreSignedPutUrlOutput;
  generateHistoricalInvoicesCsv: GenerateHistoricalInvoicesCsvOutput;
  generateInvoicePreSignedPutUrl: Scalars['String']['output'];
  generateInvoicePreSignedPutUrls: Array<GenerateInvoicePreSignedPutUrlOutput>;
  generateLabel: Scalars['String']['output'];
  generateMobileSignedDocumentPreSignedPutUrl: Scalars['String']['output'];
  generateOrderDocumentPreSignedPutUrl: Scalars['String']['output'];
  generateOrderPreSignedGetAndPutUrls: GenerateOrderPreSignedGetAndPutUrlsOutput;
  generateOrderPreSignedPutUrl: Scalars['String']['output'];
  generatePodReportPreSignedPutUrl: Scalars['String']['output'];
  generatePreSignedPutUrl: Scalars['String']['output'];
  generateReferenceIds: Array<Scalars['String']['output']>;
  generateResetCompanyToken: GenerateResetCompanyTokenOutput;
  generateShipmentPreSignedPutUrl: Scalars['String']['output'];
  generateStorageOrderPreSignedPutUrl: GenerateStorageOrderPreSignedPutUrlOutput;
  handleMultipleInvoices210Outbound: Scalars['Boolean']['output'];
  importCrownAccessorial: ImportCrownAccessorialOutput;
  /** Calls importCrownContactsV3 */
  importCrownContactsV2: Array<Scalars['String']['output']>;
  importCrownDrivers: ImportCrownDriversOutput;
  importCrownInvoices: ImportCrownInvoicesOutput;
  importCrownLanes: ImportCrownLanesOutput;
  importCrownOrders: ImportCrownOrdersOutput;
  importCrownPayments: ImportCrownPaymentsOutput;
  importCrownTariff: ImportCrownTariffOutput;
  importCrownUsers: ImportCrownUsersOutput;
  importCustomerDefaultAddresses: Array<Scalars['String']['output']>;
  importQuickbooksDesktopMappings: Array<Scalars['String']['output']>;
  importRecoveryTerminal: ImportRecoveryTerminalOutput;
  importStorageOrdersFromCSV: ImportStorageOrdersFromCsvOutput;
  importTerminalServiceAreas: Scalars['Int']['output'];
  importTestSnapshot: Scalars['String']['output'];
  importThirdPartyPortalAccountEmails: Array<Scalars['String']['output']>;
  importWarehouseLocationsFromCsv: Scalars['Int']['output'];
  logUnassignedScan: ScanEntity;
  login?: Maybe<LoginOutput>;
  loginInternal?: Maybe<LoginOutput>;
  loginPhone?: Maybe<LoginPhoneOutput>;
  /** @deprecated use loginPhone instead */
  loginPhoneJwt?: Maybe<LoginPhoneOutput>;
  logout: Scalars['Boolean']['output'];
  makeAdminPermissionGroup: Scalars['Int']['output'];
  /** Make a decision to confirm an appointment or to request it to be rescheduled */
  makeAppointmentConfirmationDecision: MakeAppointmentConfirmationDecisionOutput;
  markAsCancelled: OrderEntity;
  markAsOnHold: OrderEntity;
  /** Mark an attempted stop as complete */
  markAttemptedStopAsComplete: StopEntity;
  markConsolidatableOrdersAsBilledIndividually: Array<OrderEntity>;
  markManifestAsArrived: MarkManifestAsArrivedOutput;
  markManifestAsDeparted: MarkManifestAsDepartedOutput;
  markManifestAsPlanning: MarkManifestAsPlanningOutput;
  markNotOsd: OrderEntity;
  markOrderAsCompleteForce: OrderEntity;
  markOrderAsHasBillingIssue: OrderEntity;
  markOrderAsNotComplete: OrderEntity;
  markOrderAsNotOnHand: OrderEntity;
  markOrderAsNotReadyToInvoice: OrderEntity;
  markOrderAsNotReceivedAtOrigin: OrderEntity;
  markOrderAsOnHand: OrderEntity;
  markOrderAsPicked: OrderEntity;
  markOrderAsReadyToInvoice: OrderEntity;
  /** @deprecated This marks an order as complete, not finalized. Use markOrderAsCompleteForce instead */
  markOrderAsReadyToInvoiceForce: OrderEntity;
  markOrderAsReceivedAtOrigin: OrderEntity;
  markOrderAsRefused: MarkOrderAsRefusedOutput;
  markOsd: OrderEntity;
  markStopAsFailed: StopEntity;
  markStopAsFailedV2: StopEntity;
  markStopAsIncomplete: StopEntity;
  markStorageUnitAsBilled: MarkStorageUnitAsBilledOutput;
  markStorageUnitAsOsd: MarkStorageUnitAsOsdOutput;
  markStorageUnitOnHand: MarkStorageUnitOnHandOutput;
  markWarehouseAsDefault: WarehouseEntity;
  matchFreightSnap?: Maybe<FreightSnapTransactionEntity>;
  matchSignedPODs: Scalars['Boolean']['output'];
  mergeEdiOrder: MergeEdiOrderOutput;
  migrateToAccessorialContacts: Scalars['Boolean']['output'];
  moveShipmentsBetweenInvoices: MoveShipmentsBetweenInvoicesOutput;
  moveShipmentsToInvoice: MoveShipmentsToInvoiceOutput;
  normalizeDocument: Scalars['String']['output'];
  openMessageInOutlook: OpenMessageInOutlookOutput;
  parseCsvOrders: ParseCsvOrdersOutput;
  pickStorageUnit: PickStorageUnitOutput;
  prorateOrders: ProrateOrdersOutput;
  queueAppointmentSchedulingProposals: QueueAppointmentSchedulingProposalsOutput;
  /** Queue appointment texts for all stops according to the UUIDs provided */
  queueAppointmentTexts: Scalars['Boolean']['output'];
  reanalyzePage: Scalars['Boolean']['output'];
  reanalyzeSchemaFile: Scalars['Boolean']['output'];
  reassignRouteSlot?: Maybe<Array<RouteEntity>>;
  recreateScannedOrderForEmailAttachment: Scalars['Boolean']['output'];
  refreshEtasForRoute: Array<EtaEntity>;
  register?: Maybe<RegisterOutput>;
  rejectCustomerPortalOrder: RejectCustomerPortalOrderOutput;
  rejectEdiOrder: RejectEdiOrderOutput;
  removeAccessorial: AccessorialUnion;
  removeAddress: AddressEntity;
  removeApiUserContactMapping: ApiUserEntity;
  removeBusinessDivision: BusinessDivisionEntity;
  removeCompany: CompanyEntity;
  removeContact?: Maybe<ContactEntity>;
  removeContactPerson: ContactPersonEntity;
  removeContacts: RemoveContactsOutput;
  removeCoverSheetDocumentTypeSequence: CoverSheetDocumentTypeSequenceEntity;
  removeCreditType: CreditTypeEntity;
  removeDispatchView: DispatchViewEntity;
  removeDriver: DriverEntity;
  removeDriverSettlementBill: DriverSettlementBillEntity;
  removeDriversFromRoute: Scalars['Int']['output'];
  removeEmailTransactionLog: EmailTransactionLogEntity;
  removeFeatureFlag: FeatureFlagEntity;
  removeFuelProfile: FuelProfileEntity;
  removeGeneralLedgerCode: GeneralLedgerCodeEntity;
  removeGeneralLedgerConfiguration: GeneralLedgerConfigurationEntity;
  removeHelperFromRoute: Scalars['String']['output'];
  removeHoldReason: HoldReasonEntity;
  removeImportedOrderTypeMapping: ImportedOrderTypeMappingEntity;
  removeInvoice: InvoiceEntity;
  removeInvoiceTerms: InvoiceTermEntity;
  removeLineHaulLane: LineHaulLaneEntity;
  removeLineHaulManifest: Scalars['String']['output'];
  removeLineHaulSegment: LineHaulSegmentEntity;
  /** Given lists of settlement bill line items, will disconnect them from the bills they are associated with and trigger any side effects */
  removeLineItemsFromSettlementBill: RemoveLineItemsFromSettlementBillOutput;
  removeMasterAccount: MasterAccountEntity;
  removeOrderHold: OrderEntity;
  removeOrderLineHaulSegment: OrderLineHaulSegmentEntity;
  /** @deprecated Use removeOrdersFromManifestV2 instead */
  removeOrdersFromManifest: AddOrdersToManifestOutput;
  removeOrdersFromManifestV2: RemoveOrdersFromManifestV2Output;
  removeRoute: RouteEntity;
  /** This is probably not the API you want to use */
  removeRouteDriver: RouteDriverEntity;
  removeService: ServiceEntity;
  removeServiceToContact: ServiceEntity;
  removeSettlementAdjustment: SettlementAdjustmentEntity;
  /** @deprecated Deprecated during Robust Settlement Project. Use `removeSettlementAdjustment` instead */
  removeSettlementDeduction: SettlementDeductionEntity;
  removeSettlementDeductionType: SettlementDeductionTypeEntity;
  removeShipmentsFromInvoice: Array<Maybe<ShipmentEntity>>;
  removeSpecialAccessorial: AccessorialUnion;
  removeStopsFromRoutes: Array<Scalars['String']['output']>;
  removeStorageUnitOnHand: RemoveStorageUnitOnHandOutput;
  removeStorageUnitOsd: RemoveStorageUnitOsdOutput;
  removeSubscriberFromShipment: ShipmentSubscriberEntity;
  removeTagFromLeg: TagEntity;
  removeTagFromOrder: TagEntity;
  removeTerminal: TerminalEntity;
  removeTerminalServiceArea: TerminalServiceAreaEntity;
  removeThirdPartyBroker: ThirdPartyBrokerEntity;
  removeThirdPartyUserFromContact: ThirdPartyUserEntity;
  removeUserFromRole: RemoveUserFromRoleOutput;
  /** @deprecated Use archive/restore instead of deleting */
  removeVehicleType: VehicleTypeEntity;
  removeZoneBasedAccessorial: AccessorialUnion;
  replayOutboundEdi: Scalars['Boolean']['output'];
  reportADocScanIssue: ReportADocScanIssueOutput;
  resetCompany: ResetCompanyOutput;
  restoreContactStation: ContactStationUpdateOutput;
  restoreDriver: UpdateDriverOutput;
  restoreOrganization: RestoreOrganizationOutput;
  restorePackageSpec: UpdatePackageSpecOutput;
  /** Restore a person to the active status (un-archive) */
  restorePerson: UpdatePersonOutput;
  restoreSchedulingRegion: UpdateSchedulingRegionOutput;
  restoreSchedulingZone: UpdateSchedulingZoneOutput;
  restoreTariffChain: RestoreTariffChainOutput;
  restoreTariffZoneGroup: TariffZoneGroupRestoreOutput;
  restoreVehicleType: VehicleTypeUpdateOutput;
  retryInvoiceSendJobBatches: InvoiceSendJobBatchEntity;
  retrySftpUploads: RetrySftpUploadsOutput;
  reuploadPods: Scalars['Boolean']['output'];
  rotateDocument: Scalars['String']['output'];
  runOptimization: RouteOptimizationEntity;
  /** Used when the uuid of an order is known */
  scanOrder: OrderEntity;
  /** Scan an order barcode. If one result is found, will perform scan logic on the order. If multiple results are found, will return the results. If no results are found, will log an unassigned scan. */
  scanOrderBarcode: ScanOrderBarcodeOutput;
  /** @deprecated Use scanOrderBarcode or scanOrder */
  scanPiece: PieceEntity;
  scanWarehouseLocation: ScanWarehouseLocationOutput;
  sendAccountingReports: SendAccountingReportsOutput;
  sendDeliveryCompleted: Scalars['Boolean']['output'];
  sendInvoices: InvoiceSendJobBatchEntity;
  sendMetric: Scalars['Boolean']['output'];
  sendRouteToAgent: SendRouteToAgentOutput;
  sendStopToAgent: SendStopToAgentOutput;
  setStorageOrderItemQuantity: StorageOrderEntity;
  signUpForThirdPartyUserAccount: SignUpForThirdPartyUserAccountOutput;
  splitAndProcessOrderDocuments: Scalars['Boolean']['output'];
  startRoute: RouteEntity;
  syncVehiclesWithSamsara: Array<EquipmentEntity>;
  testAllSnapshots: Scalars['String']['output'];
  testOneSnapshot: Scalars['String']['output'];
  testSchema?: Maybe<Scalars['String']['output']>;
  testSubmitPODByShipperRefNo: Scalars['String']['output'];
  testUpdateStatusByShipperRefNo: Scalars['String']['output'];
  textDriver: DriverEntity;
  textractSchemaFile: Scalars['Boolean']['output'];
  textractSchemaTestFile: Scalars['Boolean']['output'];
  throwGraphQLError: Scalars['String']['output'];
  throwPrismaError: Scalars['String']['output'];
  unassignInventoryItems: UnassignInventoryItemsOutput;
  unassignLegFromDriver: LegEntity;
  uncancelOrder: OrderEntity;
  unconsolidateOrder: Array<ShipmentEntity>;
  unfinalizeOrder: OrderEntity;
  unpickOrder: OrderEntity;
  unpickStorageUnit: UnpickStorageUnitOutput;
  unpostInvoice: UnpostInvoiceOutput;
  update: EquipmentLicenseEntity;
  updateAccessorial: AccessorialUnion;
  updateAccessorialContact: UpdateAccessorialContactOutput;
  updateAccessorialDateRangeConfig: UpdateAccessorialDateRangeConfigOutput;
  updateAccessorialRangesForAccessorial: Array<AccessorialRangeEntity>;
  updateAccessorialToQuickbooksMapping: AccessorialToQuickbooksMappingEntity;
  updateAddress: AddressEntity;
  updateAirportInfo: AirportInfoEntity;
  updateApiUser: ApiUserEntity;
  updateAutoApplyAccessorialConfig: AutoApplyAccessorialConfigEntity;
  updateBusinessDivision: UpdateBusinessDivisionOutput;
  updateCompany: CompanyEntity;
  updateCompanyConfiguration: CompanyConfigurationEntity;
  updateContactComment: UpdateContactCommentOutput;
  /** @deprecated Use updateContactEmails instead. */
  updateContactCommunicationConfig: ContactCommunicationConfigEntity;
  /** Update all ContactEmailEntities and ContactCommunicationConfigEntities that have to do with orders for a contact */
  updateContactEmails: UpdateContactEmailsOutput;
  updateContactPerson: ContactPersonEntity;
  updateContactStation: ContactStationUpdateOutput;
  updateContactToServicesTariffGroupMappings: Array<ContactToServicesTariffGroupMappingEntity>;
  updateCoverSheetDocumentTypeSequence: CoverSheetDocumentTypeSequenceEntity;
  updateCreditType: CreditTypeEntity;
  updateCsvOrderFieldMapping: CsvOrderFieldMappingEntity;
  updateCsvOrderImportTransaction: CsvOrderImportTransactionEntity;
  updateCsvOrderMapping: CsvOrderMappingEntity;
  updateCustomerContact: CustomerContactEntity;
  updateCustomerContactPackageSpecs: UpdateCustomerContactOutput;
  updateCustomerContactVehicleTypes: UpdateCustomerContactOutput;
  updateDefaultTariffChainsForCompany: UpdateDefaultTariffChainsForCompany;
  updateDispatchTableColors: UpdateDispatchTableColorsOutput;
  updateDispatchView: DispatchViewUpdateOutput;
  updateDocument: DocumentEntity;
  updateDocuments: Array<DocumentEntity>;
  updateDriver: DriverEntity;
  updateDriverLocation?: Maybe<DriverEntity>;
  updateDriverQualifications: UpdateDriverQualificationsOutput;
  updateDriverSettlementBill: DriverSettlementBillEntity;
  updateDriverSignableFormTemplate: DriverSignableFormTemplateEntity;
  updateEdiPartnership: UpdateEdiPartnershipOutput;
  updateEmailTransaction: UpdateEmailTransactionOutput;
  updateEmailTransactionLog: EmailTransactionLogEntity;
  updateEndOfDayDocumentProcessingJob: EndOfDayDocumentProcessingJobEntity;
  updateEquipment: EquipmentEntity;
  updateFeatureFlag?: Maybe<FeatureFlagEntity>;
  updateFeatureFlagCompanyOverride: FeatureFlagCompanyOverrideEntity;
  updateFeatureFlagUserOverride: FeatureFlagUserOverrideEntity;
  updateFreightCharge: FreightChargeEntity;
  updateFuelProfile?: Maybe<FuelProfileEntity>;
  updateFuelProfileDateRange: UpdateFuelProfileDateRangeOutput;
  updateGeneralLedgerCode: UpdateGeneralLedgerCodeOutput;
  updateGeneralLedgerConfiguration: UpdateGeneralLedgerConfigurationOutput;
  updateHoldReason: HoldReasonEntity;
  updateImportedOrderTypeMapping: ImportedOrderTypeMappingEntity;
  /** @deprecated Deprecated. Use upsertItemGroup instead */
  updateInventoryItems: UpdateInventoryItemsOutput;
  /** @deprecated Use updateInvoiceLimited instead */
  updateInvoice: InvoiceEntity;
  updateInvoiceEmail: CompanyEntity;
  /** Updates the date, name, and terms of an invoice. Think carefully before adding more fields for this mutation to update */
  updateInvoiceLimited: InvoiceEntity;
  updateItem: ItemEntity;
  updateItemLocation: UpdateItemLocationOutput;
  /** This is probably not the method you want to use */
  updateLegDriverMap: LegDriverMapEntity;
  updateLineHaulLane: UpdateLineHaulLaneOutput;
  updateLineHaulManifest: LineHaulManifestEntity;
  updateLineHaulSegment: LineHaulSegmentEntity;
  updateManifestDriver: LineHaulManifestEntity;
  updateManifestVehicle: LineHaulManifestEntity;
  updateManifestsStatus: UpdateManifestsStatusOutput;
  updateMasterAccount: UpdateMasterAccountOutput;
  /** @deprecated This is unused and should be deleted. We use updateStandardOrder instead */
  updateOrder: OrderEntity;
  updateOrderComment: OrderCommentEntity;
  /** Update (replacing) all subscriptions for a contact */
  updateOrderEventNotificationSubscriptions: UpdateOrderEventNotificationSubscriptionsOutput;
  updateOrderFormFields: OrderFormFieldsEntity;
  updateOrderImportConfiguration: OrderImportConfigurationEntity;
  updateOrderLineHaulSegment: OrderLineHaulSegmentEntity;
  updateOrderLoadedStatus: OrderEntity;
  updateOrganization: UpdateOrganizationOutput;
  updateOutlookIntegration: OutlookIntegrationEntity;
  updatePackage: PackageEntity;
  updatePackageArray: Array<PackageEntity>;
  updatePackageSpec: UpdatePackageSpecOutput;
  updatePackageWarehouseLocation: UpdatePackageWarehouseLocationOutput;
  updatePaperworkCompletedForStops: Array<StopEntity>;
  updatePayment: PaymentEntity;
  updatePermission: UpdatePermissionOutput;
  updatePermissionAccessLevel: UpdatePermissionAccessLevelOutput;
  updatePerson: UpdatePersonOutput;
  updatePieceCount: OrderEntity;
  updatePiecesPicked: OrderEntity;
  updatePlace: PlaceEntity;
  updateQuickAddAccessorials: UpdateQuickAddAccessorialsOutput;
  updateQuickbooksHeaderFileMapping: QuickbooksHeaderFileMappingEntity;
  updateQuote: QuoteEntity;
  updateRecurringOrderFrequency: RecurringOrderFrequencyEntity;
  updateReportGroupConfiguration: ReportGroupConfigurationEntity;
  updateReportsEmail: UserEntity;
  updateRole: UpdateRoleOutput;
  updateRoute: RouteEntity;
  updateRouteDrivers: RouteEntity;
  updateRouteNameLocation: RouteNameLocationEntity;
  updateRouteOptimization: RouteOptimizationEntity;
  updateRouteSlot: RouteSlotEntity;
  updateRouteSlots?: Maybe<RouteEntity>;
  updateRun: UpdateRunOutput;
  updateSameDayDispatchConfig: SameDayDispatchConfigEntity;
  updateSavedFilterView: SavedFilterViewEntity;
  /** Send the update of an ingested order scan. This will create an order on success. Not used for general CRUD updates  */
  updateScannedOrder: Scalars['String']['output'];
  updateScannedOrderResultStatus: ScannedOrderResultEntity;
  updateSchedulingRegion: UpdateSchedulingRegionOutput;
  updateSchedulingZone: UpdateSchedulingZoneOutput;
  updateSchema: Scalars['String']['output'];
  updateSchemaCompanyMapping: Scalars['String']['output'];
  updateSchemaDocument: SchemaDocumentEntity;
  updateService: ServiceEntity;
  updateServiceDateForAssignedStops: Array<RouteEntity>;
  /** Updates a service region by id. Returns the updated service region. The update will fail if attempting to update a service region as archived that has terminals associated with it that are active. */
  updateServiceRegion: UpdateServiceRegionOutput;
  updateSettlementAdjustment: CreateOrUpdateSettlementAdjustmentOutput;
  /** @deprecated Deprecated during Robust Settlement Project. Use `updateSettlementAdjustment` instead */
  updateSettlementDeduction: SettlementDeductionEntity;
  updateSettlementDeductionType: SettlementDeductionTypeEntity;
  updateSftpCredentials: CreateSftpCredentialsOutput;
  updateShipment: ShipmentEntity;
  updateShipmentStandardAccessorials: ShipmentEntity;
  /** Send the update of an ingested signed pod scan. This will create an document on success attached to the existing order shipment. Not used for general CRUD updates  */
  updateSignedPOD: ScannedOrderEntity;
  updateStandardOrder: StandardOrderEntity;
  updateStandardShipmentFields: StandardShipmentFieldsEntity;
  updateStop: StopEntity;
  updateStopDriverMap: StopDriverMapEntity;
  updateStops: Array<StopEntity>;
  updateStorageOrder: UpdateStorageOrderOutput;
  updateStorageUnit: UpdateStorageUnitOutput;
  updateTag: TagEntity;
  updateTariffChain: UpdateTariffChainOutput;
  updateTariffGroup: TariffGroupEntity;
  updateTariffRangesForTariff: Array<TariffRangeEntity>;
  updateTariffZone: TariffZoneEntity;
  updateTariffZoneGroup: TariffZoneGroupUpdateOutput;
  updateTemplateAndRecordAddresses: Array<AddressEntity>;
  /** @deprecated Use updateTerminalV2 instead */
  updateTerminal: UpdateTerminalOutput;
  updateTerminalServiceArea: TerminalServiceAreaEntity;
  updateTerminalV2: UpdateTerminalV2Output;
  updateTestOrder: UpdateTestOrderOutput;
  updateThirdPartyBroker: ThirdPartyBrokerEntity;
  /** @deprecated Removing this functionality. Use addThirdPartyUserToContact or removeThirdPartyUserFromContact instead. Deprecated on 11/14/23, to be removed on 12/14/23 */
  updateThirdPartyUser: ThirdPartyUserEntity;
  updateUser: UserEntity;
  updateVehicleForRoute: RouteEntity;
  updateVehicleType: VehicleTypeEntity;
  updateWarehouse: WarehouseEntity;
  updateWarehouseEmployee: UpdateWarehouseEmployeeOutput;
  updateWarehouseLocation: UpdateWarehouseLocationOutput;
  upsertAddress: AddressEntity;
  upsertContactPerson: ContactPersonEntity;
  upsertFreightCharge: FreightChargeEntity;
  upsertItemGroup?: Maybe<ItemGroupEntity>;
  upsertPackage: PackageEntity;
  upsertPicklist: UpsertPicklistOutput;
  upsertSamsaraOauthToken: SamsaraOauthTokenEntity;
  /** Internal resolver to upsert a shipment subscriber. Directly calls the upsert service function. */
  upsertShipmentSubscriber: ShipmentSubscriberEntity;
  /** Public endpoint to allow any viewer to make a phone number a subscriber to shipment updates, given that they provide the correct company UUID and the correct shipment UUID */
  upsertShipmentSubscriberForCompany: ShipmentSubscriberEntity;
  upsertStructuredExtractionSchemaOverride: StructuredExtractionSchemaOverrideEntity;
  upsertUserContactNotificationSubscription: UserContactNotificationSubscriptionEntity;
  validateCrownChargesFromCSV: ValidateCrownChargesOutput;
  validateCrownChargesFromPDF: ValidateCrownChargesOutput;
  validateImportedCrownInvoices: ValidateImportedCrownInvoicesOutput;
  verifyInventoryForStorageUnit: VerifyInventoryForStorageUnitOutput;
};


export type MutationAcceptCustomerPortalOrderArgs = {
  acceptCustomerPortalOrderInput: AcceptCustomerPortalOrderInput;
};


export type MutationAcceptEdiOrApiOrderArgs = {
  acceptEdiOrApiOrderInput: AcceptEdiOrApiOrderInput;
};


export type MutationAcknowledgeFailedInvoiceSendJobsArgs = {
  invoiceSendJobBatchUuid: Scalars['String']['input'];
};


export type MutationAcknowledgeMyRouteChangesArgs = {
  acknowledgeRouteChangesInput: AcknowledgeRouteChangesInput;
};


export type MutationAcknowledgeMyStopChangeArgs = {
  input: AcknowledgeMyStopChangeInput;
};


export type MutationAcknowledgeNotificationArgs = {
  uuid: Scalars['String']['input'];
};


export type MutationAcknowledgeNotificationsArgs = {
  uuids: Array<Scalars['String']['input']>;
};


export type MutationAddApiUserContactMappingArgs = {
  addApiUserContactMappingInput: AddApiUserContactMappingInput;
};


export type MutationAddDriverExpoPushTokenArgs = {
  newExpoPushToken: Scalars['String']['input'];
};


export type MutationAddDriversToRouteArgs = {
  addDriversToRouteInput: AddDriversToRouteInput;
};


export type MutationAddLineItemsToSettlementBillsArgs = {
  addLineItemsToSettlementBillsInput: AddLineItemsToSettlementBillsInput;
};


export type MutationAddNextRouteSlotForRouteArgs = {
  nextRouteSlotUuid: Scalars['String']['input'];
  routeUuid: Scalars['String']['input'];
};


export type MutationAddOrdersToInvoicesArgs = {
  input: AddOrdersToInvoicesInput;
};


export type MutationAddOrdersToManifestArgs = {
  addOrdersToManifestInput: AddOrdersToManifestInput;
};


export type MutationAddOrdersToManifestV2Args = {
  input: AddOrdersToManifestV2Input;
};


export type MutationAddPermissionToRoleInputArgs = {
  addPermissionToRoleInput: AddPermissionToRoleInput;
};


export type MutationAddQuickbooksDesktopCustomerArgs = {
  contactUuid: Scalars['String']['input'];
};


export type MutationAddQuickbooksDesktopCustomersArgs = {
  contactUuids: Array<Scalars['String']['input']>;
};


export type MutationAddQuickbooksDesktopItemArgs = {
  accountRefName: Scalars['String']['input'];
  itemName: Scalars['String']['input'];
};


export type MutationAddServiceToContactArgs = {
  addServiceToContactInput: AddServiceToContactInput;
};


export type MutationAddServicesToTariffGroupMappingsArgs = {
  serviceUuids: Array<Scalars['String']['input']>;
  uuid: Scalars['String']['input'];
};


export type MutationAddTagToLegArgs = {
  addTagToLegInput: AddTagToLegInput;
};


export type MutationAddTagToOrderArgs = {
  addTagToOrderInput: AddTagToOrderInput;
};


export type MutationAddThirdPartyUserToContactArgs = {
  addThirdPartyUserToContactInput: AddThirdPartyUserToContactInput;
};


export type MutationAddUserToRoleArgs = {
  addUserToRoleInput: AddUserToRoleInput;
};


export type MutationApproveQuoteArgs = {
  approveQuoteInput: ApproveQuoteInput;
};


export type MutationArchiveContactStationArgs = {
  id: Scalars['String']['input'];
};


export type MutationArchiveDriverArgs = {
  uuid: Scalars['String']['input'];
};


export type MutationArchiveOrganizationArgs = {
  input: ArchiveOrganizationInput;
};


export type MutationArchivePackageSpecArgs = {
  id: Scalars['String']['input'];
};


export type MutationArchivePersonArgs = {
  id: Scalars['String']['input'];
};


export type MutationArchiveSchedulingRegionArgs = {
  id: Scalars['String']['input'];
};


export type MutationArchiveTariffChainArgs = {
  archiveTariffChainInput: ArchiveTariffChainInput;
};


export type MutationArchiveTariffZoneGroupArgs = {
  id: Scalars['String']['input'];
};


export type MutationArchiveVehicleTypeArgs = {
  uuid: Scalars['String']['input'];
};


export type MutationArriveAtStopArgs = {
  arriveAtStopInput: ArriveAtStopInput;
};


export type MutationArriveAtStopsArgs = {
  arriveAtStopsInput: ArriveAtStopsInput;
};


export type MutationAssignHelperToRouteArgs = {
  helperUuid: Scalars['String']['input'];
  routeUuid: Scalars['String']['input'];
};


export type MutationAssignInventoryItemsToStorageUnitArgs = {
  assignInventoryItemsToStorageUnitInput: AssignInventoryItemsToStorageUnitInput;
};


export type MutationAssignOutboundReferenceNumbersToStorageUnitsArgs = {
  assignOutboundReferenceNumbersToStorageUnitsInput: AssignOutboundReferenceNumberToStorageUnitsInput;
};


export type MutationAttachMobileSignedDocumentToOrderAndReplaceOriginalArgs = {
  input: UploadMobileSignedDocumentInput;
};


export type MutationBackfillOrderTotalsArgs = {
  pageSize: Scalars['Float']['input'];
};


export type MutationBackfillTariffZoneGroupsForCompanyArgs = {
  companyUuid: Scalars['String']['input'];
};


export type MutationBatchAddShipmentsToInvoicesMultipleArgs = {
  batchAddShipmentsToInvoicesInputMultiple: BatchAddShipmentsToInvoicesInputMultiple;
};


export type MutationBulkChangeCallStatusArgs = {
  changeCallStatusArgs: BulkChangeCallStatusArgs;
};


export type MutationBulkConfirmAppointmentsArgs = {
  bulkConfirmAppointmentsArgs: BulkConfirmAppointmentsArgs;
};


export type MutationBulkEditOrdersArgs = {
  bulkEditOrdersInput: BulkEditOrdersInput;
};


export type MutationBulkUpdateAccessorialMappingsArgs = {
  bulkAccessorialUpdateInput: BulkAccessorialUpdateInput;
};


export type MutationBulkUpdateContactQuickbooksIdsArgs = {
  bulkUpdateContactQuickbooksId: UpdateContactQuickbooksIdsInput;
};


export type MutationBulkUploadRouteNamesArgs = {
  bulkCsvRouteNameInput: BulkCsvRouteNameInput;
};


export type MutationCalculateRouteEtasArgs = {
  uuids: Array<Scalars['String']['input']>;
};


export type MutationCallStopsArgs = {
  callStopsInput: CallStopsInput;
};


export type MutationChooseAppointmentOptionArgs = {
  input: ChooseAppointmentOptionInput;
};


export type MutationClearCompanyArgs = {
  input: ClearCompanyInput;
};


export type MutationClearCompanyContactsArgs = {
  clearCompanyContactsInput: ClearCompanyContactsInput;
};


export type MutationCompleteRebillArgs = {
  completeRebillInput: CompleteRebillInput;
};


export type MutationCompleteStopBulkArgs = {
  completeStopBulkInput: CompleteStopBulkInput;
};


export type MutationCompleteStopV2Args = {
  completeStopInput: CompleteStopInput;
};


export type MutationConnectToQuickbooksDesktopArgs = {
  qbUserEmail: Scalars['String']['input'];
};


export type MutationCreateAccessorialArgs = {
  createAccessorialInput: CreateAccessorialInput;
};


export type MutationCreateAccessorialContactArgs = {
  accessorialContactCreateInput: CreateAccessorialContactInput;
};


export type MutationCreateAccessorialDateRangeConfigArgs = {
  createAccessorialDateRangeConfigInput: CreateAccessorialDateRangeConfigInput;
};


export type MutationCreateAccessorialToQuickbooksMappingArgs = {
  accessorialToQuickbooksMappingCreateInput: AccessorialToQuickbooksMappingCreateInput;
};


export type MutationCreateAccountingReportDocumentArgs = {
  createAccountingReportDocumentInput: CreateBasicDocumentInput;
};


export type MutationCreateAddressArgs = {
  createAddressInput: CreateAddressInput;
};


export type MutationCreateAdjustmentStopDriverMapArgs = {
  adjustmentStopDriverMapCreateInput: AdjustmentStopDriverMapCreateInput;
};


export type MutationCreateAirportInfoArgs = {
  createAirportInfoInput: CreateAirportInfoInput;
};


export type MutationCreateApiUserArgs = {
  createApiUserInput: CreateApiUserInput;
};


export type MutationCreateAppointmentsForRouteArgs = {
  uuid: Scalars['String']['input'];
};


export type MutationCreateAutoApplyAccessorialConfigArgs = {
  createAutoApplyAccessorialConfigInput: CreateAutoApplyAccessorialConfigInput;
};


export type MutationCreateBusinessDivisionArgs = {
  createBusinessDivisionInput: CreateBusinessDivisionInput;
};


export type MutationCreateCompanyArgs = {
  createCompanyInput: CreateCompanyInput;
};


export type MutationCreateConsolidatedOrderArgs = {
  createConsolidatedOrderInput: CreateConsolidatedOrderInput;
};


export type MutationCreateConsolidatedOrderFromOrderArgs = {
  createConsolidatedOrderFromOrderInput: CreateConsolidatedOrderFromOrderInput;
};


export type MutationCreateContactCommentArgs = {
  createContactCommentInput: CreateContactCommentInput;
};


export type MutationCreateContactCommunicationConfigArgs = {
  createContactCommunicationConfigInput: CreateContactCommunicationConfigInput;
};


export type MutationCreateContactDocumentArgs = {
  createContactDocumentInput: CreateContactDocumentInput;
};


export type MutationCreateContactEmailArgs = {
  createContactEmailInput: CreateContactEmailInput;
};


export type MutationCreateContactPersonArgs = {
  createContactPersonInput: CreateContactPersonInput;
};


export type MutationCreateContactStationArgs = {
  contactStationCreateInput: ContactStationCreateInput;
};


export type MutationCreateCoverSheetDocumentTypeSequenceArgs = {
  coverSheetDocumentTypeSequenceCreateInput: CoverSheetDocumentTypeSequenceCreateInput;
};


export type MutationCreateCreditTypeArgs = {
  creditTypeCreateInput: CreditTypeCreateInput;
};


export type MutationCreateCsvOrderFieldMappingArgs = {
  createCsvOrderFieldMappingInput: CreateCsvOrderFieldMappingInput;
};


export type MutationCreateCsvOrderImportTransactionArgs = {
  createCsvOrderImportTransactionInput: CreateCsvOrderImportTransactionInput;
};


export type MutationCreateCsvOrderMappingArgs = {
  createCsvOrderMappingInput: CreateCsvOrderMappingInput;
};


export type MutationCreateCustomerContactArgs = {
  createCustomerContactInput: CreateCustomerContactInput;
};


export type MutationCreateCustomerContactsArgs = {
  createCustomerContactsInput: CreateCustomerContactsInput;
};


export type MutationCreateDispatchViewArgs = {
  dispatchViewCreateInput: DispatchViewCreateInput;
};


export type MutationCreateDocumentArgs = {
  createDocumentInput: CreateDocumentInput;
};


export type MutationCreateDriverArgs = {
  createDriverInput: CreateDriverInput;
};


export type MutationCreateDriverSettlementBillArgs = {
  createDriverSettlementBillInput: CreateDriverSettlementBillInput;
};


export type MutationCreateDriverSignableFormTemplateArgs = {
  createDriverSignableFormTemplateInput: CreateDriverSignableFormTemplateInput;
};


export type MutationCreateDriversArgs = {
  createDriversInput: CreateDriversInput;
};


export type MutationCreateDuplicateOrderForRebillArgs = {
  createDuplicateOrderForRebillInput: CreateDuplicateOrderForRebillInput;
};


export type MutationCreateEodDocumentsArgs = {
  createEodDocumentsInput: CreateEodDocumentsInput;
};


export type MutationCreateEdiPartnershipArgs = {
  createEdiPartnershipInput: CreateEdiPartnershipInput;
};


export type MutationCreateEdiPartnershipServiceMappingsArgs = {
  createEdiPartnershipServiceMappingsInput: CreateEdiPartnershipServiceMappingsInput;
};


export type MutationCreateEdiTransactionArgs = {
  createEdiTransactionInput: CreateEdiTransactionInput;
};


export type MutationCreateEmailTransactionArgs = {
  createEmailTransactionInput: CreateEmailTransactionInput;
};


export type MutationCreateEmailTransactionLogArgs = {
  emailTransactionLogCreateInput: EmailTransactionLogCreateInput;
};


export type MutationCreateEndOfDayDocumentProcessingJobArgs = {
  createEndOfDayDocumentProcessingJobInput: CreateEndOfDayDocumentProcessingJobInput;
};


export type MutationCreateEquipmentArgs = {
  createEquipmentInput: CreateEquipmentInput;
};


export type MutationCreateEquipmentLicenseArgs = {
  createEquipmentLicenseInput: CreateEquipmentLicenseInput;
};


export type MutationCreateEquipmentsArgs = {
  createEquipmentsInput: CreateEquipmentsInput;
};


export type MutationCreateFeatureFlagArgs = {
  createFeatureFlagInput: CreateFeatureFlagInput;
};


export type MutationCreateFeatureFlagCompanyOverrideArgs = {
  createFeatureFlagCompanyOverrideInput: CreateFeatureFlagCompanyOverrideInput;
};


export type MutationCreateFeatureFlagUserOverrideArgs = {
  createFeatureFlagUserOverrideInput: CreateFeatureFlagUserOverrideInput;
};


export type MutationCreateFreightChargeArgs = {
  createFreightChargeInput: CreateFreightChargeInput;
};


export type MutationCreateFuelProfileArgs = {
  createFuelProfileInput: CreateFuelProfileInput;
};


export type MutationCreateFuelProfileDateRangeArgs = {
  createFuelProfileDateRangeInput: CreateFuelProfileDateRangeInput;
};


export type MutationCreateGeneralLedgerCodeArgs = {
  input: GeneralLedgerCodeCreateInput;
};


export type MutationCreateHoldReasonArgs = {
  holdReasonCreateInput: HoldReasonCreateInput;
};


export type MutationCreateImportedOrderTypeMappingArgs = {
  importedOrderTypeMappingCreateInput: ImportedOrderTypeMappingCreateInput;
};


export type MutationCreateImportedOrderTypeMappingsArgs = {
  importedOrderTypeMappingCreateInputs: Array<ImportedOrderTypeMappingCreateInput>;
};


export type MutationCreateIngestedOutlookEmailArgs = {
  createIngestedOutlookEmailInput: IngestedOutlookEmailCreateInput;
};


export type MutationCreateIngestedOutlookEmailAttachmentArgs = {
  createIngestedOutlookEmailAttachmentInput: CreateIngestedOutlookEmailAttachmentInput;
};


export type MutationCreateInventoryItemsArgs = {
  createInventoryItemsInput: CreateInventoryItemsInput;
};


export type MutationCreateInventoryPrimaryUnitOfMeasureArgs = {
  createInventoryPrimaryUnitOfMeasureInput: CreateInventoryPrimaryUnitOfMeasureInput;
};


export type MutationCreateInventorySecondaryUnitOfMeasureArgs = {
  createInventorySecondaryUnitOfMeasureInput: CreateInventorySecondaryUnitOfMeasureInput;
};


export type MutationCreateInvoiceArgs = {
  createInvoiceInput: CreateInvoiceInput;
};


export type MutationCreateInvoiceDocumentArgs = {
  createInvoiceDocumentInput: CreateInvoiceDocumentInput;
};


export type MutationCreateInvoiceDocumentsArgs = {
  createInvoiceDocumentsInput: CreateInvoiceDocumentsInput;
};


export type MutationCreateInvoiceTermsArgs = {
  terms: Scalars['String']['input'];
};


export type MutationCreateInvoiceTermsForAllArgs = {
  createInvoiceTermsForAllInput: CreateInvoiceTermsForAllInput;
};


export type MutationCreateItemArgs = {
  createItemInput: CreateItemInput;
};


export type MutationCreateItemLocationArgs = {
  createItemLocationInput: CreateItemLocationInput;
};


export type MutationCreateLegArgs = {
  createLegInput: CreateLegInput;
};


export type MutationCreateLegDriverMapArgs = {
  createLegDriverMapInput: CreateLegDriverMapInput;
};


export type MutationCreateLineHaulLaneArgs = {
  createLineHaulLaneInput: CreateLineHaulLaneInput;
};


export type MutationCreateLineHaulManifestArgs = {
  createLineHaulManifestInput: CreateLineHaulManifestInput;
};


export type MutationCreateLineHaulManifestsArgs = {
  input: CreateLineHaulManifestsInput;
};


export type MutationCreateLineHaulSegmentArgs = {
  createLineHaulSegmentInput: CreateLineHaulSegmentInput;
};


export type MutationCreateManyReferenceNumberLabelsArgs = {
  referenceNumberLabels: Array<Scalars['String']['input']>;
};


export type MutationCreateMasterAccountArgs = {
  createMasterAccountInput: CreateMasterAccountInput;
};


export type MutationCreateNotificationArgs = {
  createNotificationInput: CreateNotificationInput;
};


export type MutationCreateOrUpdateCsvOrdersArgs = {
  createOrUpdateCsvOrdersInput: CreateOrUpdateCsvOrdersInput;
};


export type MutationCreateOrderCommentArgs = {
  createOrderCommentInput: CreateOrderCommentInput;
};


export type MutationCreateOrderDocumentArgs = {
  createOrderDocumentInput: CreateOrderDocumentInput;
};


export type MutationCreateOrderDocumentDocumentArgs = {
  createOrderDocumentDocumentInput: CreateOrderDocumentDocumentInput;
};


export type MutationCreateOrderImportConfigurationArgs = {
  orderImportConfigurationCreateInput: OrderImportConfigurationCreateInput;
};


export type MutationCreateOrderLineHaulSegmentArgs = {
  orderLineHaulSegmentCreateInput: OrderLineHaulSegmentCreateInput;
};


export type MutationCreateOrderSnapshotArgs = {
  orderEventSnapshotCreateInput: OrderEventSnapshotCreateInput;
};


export type MutationCreateOrderTableReportArgs = {
  createOrderTableReportInput: CreateOrderTableReportInput;
};


export type MutationCreateOrdersFromRecurringTemplatesArgs = {
  uuids: Array<Scalars['String']['input']>;
};


export type MutationCreateOrganizationArgs = {
  input: CreateOrganizationInput;
};


export type MutationCreateOutlookIntegrationArgs = {
  outlookIntegrationCreateInput: OutlookIntegrationCreateInput;
};


export type MutationCreatePodReportDocumentArgs = {
  createPodReportDocumentInput: CreatePodReportDocumentInput;
};


export type MutationCreatePackageArgs = {
  createPackageInput: CreatePackageInput;
};


export type MutationCreatePackageSpecArgs = {
  createPackageSpecInput: CreatePackageSpecInput;
};


export type MutationCreatePaymentArgs = {
  createPaymentInput: CreatePaymentInput;
};


export type MutationCreatePdfColumnArgs = {
  createPdfColumnInput: CreatePdfColumnInput;
};


export type MutationCreatePermissionArgs = {
  createPermissionInput: CreatePermissionInput;
};


export type MutationCreatePersonArgs = {
  input: CreatePersonInput;
};


export type MutationCreatePicklistArgs = {
  createPicklistInput: CreatePicklistInput;
};


export type MutationCreatePieceArgs = {
  createPieceInput: CreatePieceInput;
};


export type MutationCreatePlaceArgs = {
  createPlaceInput: CreatePlaceInput;
};


export type MutationCreateProratedConsolidatedOrderArgs = {
  createProratedConsolidatedOrderInput: CreateProratedConsolidatedOrderInput;
};


export type MutationCreateQuickbooksHeaderFileMappingArgs = {
  createQuickbooksHeaderFileMappingInput: CreateQuickbooksHeaderFileMappingInput;
};


export type MutationCreateQuoteArgs = {
  createQuoteInput: CreateQuoteInput;
};


export type MutationCreateRecurringOrderFrequencyArgs = {
  createRecurringOrderFrequencyInput: CreateRecurringOrderFrequencyInput;
};


export type MutationCreateReportGroupConfigurationArgs = {
  createReportGroupConfigurationInput: ReportGroupConfigurationCreateInput;
};


export type MutationCreateRoleArgs = {
  createRoleInput: CreateRoleInput;
};


export type MutationCreateRouteArgs = {
  createRouteInput: CreateRouteInput;
};


export type MutationCreateRouteDriverArgs = {
  createRouteDriverInput: CreateRouteDriverInput;
};


export type MutationCreateRouteFromRouteTemplateArgs = {
  input: CreateRouteFromRouteTemplateInput;
};


export type MutationCreateRouteNameArgs = {
  createRouteNameInput: CreateRouteNameInput;
};


export type MutationCreateRouteNameLocationArgs = {
  createRouteNameLocationInput: CreateRouteNameLocationInput;
  routeNameUuid: Scalars['String']['input'];
};


export type MutationCreateRouteOptimizationArgs = {
  createRouteOptimizationInput: CreateRouteOptimizationInput;
};


export type MutationCreateRoutePathsArgs = {
  routePathsCreateInput: RoutePathsCreateInput;
};


export type MutationCreateRouteSlotArgs = {
  createRouteSlotInput: CreateRouteSlotInput;
};


export type MutationCreateRoutesArgs = {
  createRoutesInput: CreateRoutesInput;
};


export type MutationCreateRunArgs = {
  createRunInput: CreateRunInput;
};


export type MutationCreateSameDayDispatchConfigArgs = {
  createSameDayDispatchConfigInput: CreateSameDayDispatchConfigInput;
};


export type MutationCreateSamsaraOauthTokenArgs = {
  createSamsaraOauthTokenInput: CreateSamsaraOauthTokenInput;
};


export type MutationCreateSandboxRouteForDriverArgs = {
  createSandboxRouteForDriverInput: CreateSandboxRouteForDriverInput;
};


export type MutationCreateSavedFilterViewArgs = {
  createSavedFilterViewInput: CreateSavedFilterViewInput;
};


export type MutationCreateScannedOrdersArgs = {
  createScannedOrdersInput: CreateScannedOrdersInput;
};


export type MutationCreateScannedOrdersFromAdminArgs = {
  createScannedOrdersFromAdminInput: CreateScannedOrdersFromAdminInput;
};


export type MutationCreateSchedulingRegionArgs = {
  input: CreateSchedulingRegionInput;
};


export type MutationCreateSchedulingZoneArgs = {
  input: CreateSchedulingZoneInput;
};


export type MutationCreateSchemaArgs = {
  createSchemaInput: CreateSchemaInput;
};


export type MutationCreateSchemaCompanyMappingArgs = {
  createSchemaCompanyMappingInput: CreateSchemaCompanyMappingInput;
};


export type MutationCreateSchemaDocumentArgs = {
  createSchemaDocumentInput: CreateSchemaDocumentInput;
};


export type MutationCreateSchemaTestSnapshotArgs = {
  createSchemaTestSnapshotInput: CreateSchemaTestSnapshotInput;
};


export type MutationCreateServiceArgs = {
  createServiceInput: CreateServiceInput;
};


export type MutationCreateServiceRegionsArgs = {
  input: CreateServiceRegionsInput;
};


export type MutationCreateSettlementAdjustmentArgs = {
  settlementAdjustmentCreateInput: SettlementAdjustmentCreateInput;
};


export type MutationCreateSettlementDeductionArgs = {
  settlementDeductionCreateInput: SettlementDeductionCreateInput;
};


export type MutationCreateSettlementDeductionTypeArgs = {
  settlementDeductionTypeCreateInput: SettlementDeductionTypeCreateInput;
};


export type MutationCreateSftpCredentialsArgs = {
  createSftpCredentialsInput: CreateSftpCredentialsInput;
};


export type MutationCreateShipmentDocumentArgs = {
  createShipmentDocumentInput: CreateShipmentDocumentInput;
};


export type MutationCreateStandardOrderArgs = {
  createStandardOrderInput: CreateStandardOrderInput;
};


export type MutationCreateStandardOrderFieldsArgs = {
  createStandardOrderFieldsInput: CreateStandardOrderFieldsInput;
};


export type MutationCreateStandardShipmentFieldsArgs = {
  createStandardShipmentFieldsInput: CreateStandardShipmentFieldInput;
};


export type MutationCreateStorageOrderArgs = {
  createStorageOrderInput: CreateStorageOrderInput;
};


export type MutationCreateStorageOrderDocumentArgs = {
  createStorageOrderDocumentInput: CreateStorageOrderDocumentInput;
};


export type MutationCreateStorageUnitArgs = {
  createStorageUnitInput: CreateStorageUnitInput;
};


export type MutationCreateStorageUnitWithInventoryItemsArgs = {
  createStorageUnitWithInventoryItemsInput: CreateStorageUnitWithInventoryItemsInput;
};


export type MutationCreateTagArgs = {
  createTagInput: CreateTagInput;
};


export type MutationCreateTariffArgs = {
  createTariffInput: CreateTariffInput;
};


export type MutationCreateTariffChainArgs = {
  createTariffChainInput: CreateTariffChainInput;
};


export type MutationCreateTariffGroupArgs = {
  createTariffGroupInput: CreateTariffGroupInput;
};


export type MutationCreateTariffLocationArgs = {
  createTariffLocationInput: CreateTariffLocationInput;
};


export type MutationCreateTariffZoneArgs = {
  contactUuid?: InputMaybe<Scalars['String']['input']>;
  tariffZoneCreateInput: TariffZoneCreateInput;
};


export type MutationCreateTariffZoneGroupArgs = {
  tariffZoneGroupCreateInput: TariffZoneGroupCreateInput;
};


export type MutationCreateTerminalArgs = {
  createTerminalInput: CreateTerminalInput;
};


export type MutationCreateTerminalLanesArgs = {
  input: CreateTerminalLanesInput;
};


export type MutationCreateTerminalServiceAreaArgs = {
  createTerminalServiceAreaInput: CreateTerminalServiceAreaInput;
};


export type MutationCreateTerminalServiceAreasArgs = {
  createTerminalServiceAreaInputs: Array<CreateTerminalServiceAreaInput>;
};


export type MutationCreateTerminalServiceAreasV2Args = {
  createTerminalServiceAreaInputs: Array<CreateTerminalServiceAreaInput>;
};


export type MutationCreateTerminalV2Args = {
  input: TerminalCreateInput;
};


export type MutationCreateTerminalsArgs = {
  createTerminalsInput: CreateTerminalsInput;
};


export type MutationCreateTestCompanyArgs = {
  createTestCompanyInput: CreateTestCompanyInput;
};


export type MutationCreateTestContactArgs = {
  createTestContactInput: CreateTestContactInput;
};


export type MutationCreateTestOrderArgs = {
  createTestOrderInput: CreateTestOrderInput;
};


export type MutationCreateTestOrderCustomChargeArgs = {
  createTestOrderCustomChargeInput: CreateTestOrderCustomChargeInput;
};


export type MutationCreateTestOrderV2Args = {
  createTestOrderRequest: CreateTestOrderRequest;
};


export type MutationCreateTestUserArgs = {
  createUserInput: CreateUserInput;
};


export type MutationCreateThirdPartyBrokerArgs = {
  thirdPartyBrokerCreateInput: ThirdPartyBrokerCreateInput;
};


export type MutationCreateThirdPartyUserArgs = {
  createThirdPartyUserInput: CreateThirdPartyUserInput;
};


export type MutationCreateUserArgs = {
  createUserInput: CreateUserInput;
};


export type MutationCreateVehicleTypeArgs = {
  vehicleTypeCreateInput: VehicleTypeCreateInput;
};


export type MutationCreateWarehouseArgs = {
  createWarehouseInput: CreateWarehouseInput;
};


export type MutationCreateWarehouseEmployeeArgs = {
  createWarehouseEmployeeInput: CreateWarehouseEmployeeInput;
};


export type MutationCreateWarehouseLocationArgs = {
  createWarehouseLocationInput: CreateWarehouseLocationInput;
};


export type MutationDeleteArgs = {
  uuid: Scalars['String']['input'];
};


export type MutationDeleteAccessorialDateRangeConfigArgs = {
  deleteAccessorialDateRangeConfigInput: DeleteAccessorialDateRangeConfigInput;
};


export type MutationDeleteAccessorialRangeArgs = {
  uuid: Scalars['String']['input'];
};


export type MutationDeleteAutoApplyAccessorialConfigArgs = {
  uuid: Scalars['String']['input'];
};


export type MutationDeleteContactCommentArgs = {
  deleteContactCommentInput: DeleteContactCommentInput;
};


export type MutationDeleteContactEmailArgs = {
  deleteContactEmailInput: DeleteContactEmailInput;
};


export type MutationDeleteCsvOrderFieldMappingArgs = {
  uuid: Scalars['String']['input'];
};


export type MutationDeleteDocumentArgs = {
  uuid: Scalars['String']['input'];
};


export type MutationDeleteDrayageShipmentFieldsArgs = {
  uuid: Scalars['String']['input'];
};


export type MutationDeleteDriverSignableFormTemplateArgs = {
  uuid: Scalars['String']['input'];
};


export type MutationDeleteEquipmentArgs = {
  uuid: Scalars['String']['input'];
};


export type MutationDeleteFeatureFlagCompanyOverrideArgs = {
  deleteFeatureFlagCompanyOverrideInput: DeleteFeatureFlagCompanyOverrideInput;
};


export type MutationDeleteFeatureFlagUserOverrideArgs = {
  deleteFeatureFlagUserOverrideInput: DeleteFeatureFlagUserOverrideInput;
};


export type MutationDeleteFreightChargeArgs = {
  uuid: Scalars['String']['input'];
};


export type MutationDeleteFuelProfileDateRangeArgs = {
  deleteFuelProfileDateRangeInput: DeleteFuelProfileDateRangeInput;
};


export type MutationDeleteGeneralLedgerCodeArgs = {
  input: GeneralLedgerCodeDeleteInput;
};


export type MutationDeleteInventoryItemsArgs = {
  deleteInventoryItemsInput: DeleteInventoryItemsInput;
};


export type MutationDeleteLegDriverMapArgs = {
  uuid: Scalars['String']['input'];
};


export type MutationDeleteOrderArgs = {
  uuid: Scalars['String']['input'];
};


export type MutationDeleteOrderCommentArgs = {
  deleteOrderCommentInput: DeleteOrderCommentInput;
};


export type MutationDeletePackageArgs = {
  uuid: Scalars['String']['input'];
};


export type MutationDeletePaymentArgs = {
  uuid: Scalars['String']['input'];
};


export type MutationDeletePermissionArgs = {
  deletePermissionInput: DeletePermissionInput;
};


export type MutationDeleteQuickbooksHeaderFileMappingArgs = {
  uuid: Scalars['String']['input'];
};


export type MutationDeleteQuoteArgs = {
  uuid: Scalars['String']['input'];
};


export type MutationDeleteReportGroupConfigurationArgs = {
  uuid: Scalars['String']['input'];
};


export type MutationDeleteRoleArgs = {
  deleteRoleInput: DeleteRoleInput;
};


export type MutationDeleteRouteNameLocationArgs = {
  uuid: Scalars['String']['input'];
};


export type MutationDeleteSameDayDispatchConfigArgs = {
  uuid: Scalars['String']['input'];
};


export type MutationDeleteSavedFilterViewArgs = {
  uuid: Scalars['String']['input'];
};


export type MutationDeleteSchemaArgs = {
  uuid: Scalars['String']['input'];
};


export type MutationDeleteSchemaCompanyMappingArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeleteSchemaDocumentArgs = {
  uuid: Scalars['String']['input'];
};


export type MutationDeleteSchemaRunArgs = {
  deleteSchemaRunInput: DeleteSchemaRunInput;
};


export type MutationDeleteSlotsFromRouteArgs = {
  deleteSlotsFromRouteInput: DeleteSlotsFromRouteInput;
};


export type MutationDeleteStandardOrderArgs = {
  uuid: Scalars['String']['input'];
};


export type MutationDeleteStandardOrderFieldsArgs = {
  uuid: Scalars['String']['input'];
};


export type MutationDeleteStopAttemptArgs = {
  deleteStopAttemptInput: DeleteStopAttemptInput;
};


export type MutationDeleteStopDriverMapArgs = {
  uuid: Scalars['String']['input'];
};


export type MutationDeleteStorageOrderArgs = {
  deleteStorageOrderInput: DeleteStorageOrderInput;
};


export type MutationDeleteStorageOrdersArgs = {
  deleteStorageOrdersInput: DeleteStorageOrdersInput;
};


export type MutationDeleteStorageUnitArgs = {
  deleteStorageUnitInput: DeleteStorageUnitInput;
};


export type MutationDeleteTagArgs = {
  uuid: Scalars['String']['input'];
};


export type MutationDeleteTariffArgs = {
  uuid: Scalars['String']['input'];
};


export type MutationDeleteTariffGroupArgs = {
  uuid: Scalars['String']['input'];
};


export type MutationDeleteTariffLocationArgs = {
  deleteTariffLocationInput: DeleteTariffLocationInput;
};


export type MutationDeleteTariffRangeArgs = {
  uuid: Scalars['String']['input'];
};


export type MutationDeleteTariffZoneArgs = {
  uuid: Scalars['String']['input'];
};


export type MutationDeleteTariffZonesArgs = {
  uuids: Array<Scalars['String']['input']>;
};


export type MutationDeleteTariffsArgs = {
  tariffsDeleteInput: TariffsDeleteInput;
};


export type MutationDeleteTerminalLanesArgs = {
  input: DeleteTerminalLanesInput;
};


export type MutationDeleteThirdPartyUserArgs = {
  uuid: Scalars['String']['input'];
};


export type MutationDeleteUserArgs = {
  deleteUserInput: DeleteUserInput;
};


export type MutationDeleteWarehouseArgs = {
  warehouseUuid: Scalars['String']['input'];
};


export type MutationDeleteWarehouseLocationArgs = {
  deleteWarehouseLocationInput: DeleteWarehouseLocationInput;
};


export type MutationDetachDocumentFromShipmentArgs = {
  uuid: Scalars['String']['input'];
};


export type MutationDetachDocumentsFromShipmentsArgs = {
  detachDocumentsFromShipmentsInput: DetachDocumentsFromShipmentsInput;
};


export type MutationDismissScannedOrderResultArgs = {
  uuid: Scalars['String']['input'];
};


export type MutationDownloadInvoicesArgs = {
  downloadInvoicesInput: DownloadInvoicesInput;
};


export type MutationDriverSettlementBillExportPdfArgs = {
  driverSettlementBillExportPdfInput: DriverSettlementBillExportPdfInput;
};


export type MutationDriverSettlementBillExportZipArgs = {
  input: DriverSettlementBillExportPdfInput;
};


export type MutationDuplicateEdiPartnershipsArgs = {
  duplicateEdiPartnershipsInput: DuplicateEdiPartnershipsInput;
};


export type MutationDuplicateTariffGroupArgs = {
  duplicateTariffGroupInput: DuplicateTariffGroupInput;
};


export type MutationEditContactsArgs = {
  editContactsInput: EditContactsInput;
};


export type MutationEditPaymentAmountArgs = {
  editPaymentAmount: EditPaymentAmountInput;
};


export type MutationEmailAccountingReportArgs = {
  emailAccountingReportInput: EmailAccountingReportInput;
};


export type MutationEmailOrderDocumentArgs = {
  emailOrderDocumentInput: EmailOrderDocumentInput;
};


export type MutationExportInvoicesToQuickbooksDesktopArgs = {
  exportInvoicesToQuickbooksInput: ExportInvoicesToQuickbooksInput;
};


export type MutationFinalizeDriverSettlementBillsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  driverUuid?: InputMaybe<Scalars['String']['input']>;
  driverUuids?: InputMaybe<Array<Scalars['String']['input']>>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  isFinalized?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  searchText?: InputMaybe<Scalars['String']['input']>;
  sortByBillStartDateAscending?: InputMaybe<Scalars['Boolean']['input']>;
  sortBySettlementDateAscending?: InputMaybe<Scalars['Boolean']['input']>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  uuids?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type MutationFinalizeInvoicesArgs = {
  finalizeInvoicesInput: FinalizeInvoicesInput;
};


export type MutationFinalizeOrderArgs = {
  uuid: Scalars['String']['input'];
};


export type MutationFinalizeOrdersArgs = {
  finalizeOrdersInput: FinalizeOrdersInput;
};


export type MutationFinalizeSettlementBillsArgs = {
  finalizeSettlementBillsInput: FinalizeSettlementBillsInput;
};


export type MutationFlipIsArchivedArgs = {
  uuid: Scalars['String']['input'];
};


export type MutationGenerateAccountingReportPreSignedPutUrlArgs = {
  generateAccountingReportPreSignedPutUrlInput: GenerateAccountingReportPreSignedPutUrlInput;
};


export type MutationGenerateClearCompanyContactsTokenArgs = {
  generateClearCompanyContactsTokenInput: GenerateClearCompanyContactsTokenInput;
};


export type MutationGenerateContactPreSignedPutUrlArgs = {
  generateContactPreSignedPutUrlInput: GenerateContactPreSignedPutUrlInput;
};


export type MutationGenerateHistoricalInvoicesCsvArgs = {
  generateHistoricalInvoicesCsvInput: GenerateHistoricalInvoicesCsvInput;
};


export type MutationGenerateInvoicePreSignedPutUrlArgs = {
  generateInvoicePreSignedPutUrlInput: GenerateInvoicePreSignedPutUrlInput;
};


export type MutationGenerateInvoicePreSignedPutUrlsArgs = {
  generateInvoicePreSignedPutUrlsInput: GenerateInvoicePreSignedPutUrlsInput;
};


export type MutationGenerateLabelArgs = {
  generateLabelInput: GenerateLabelInput;
};


export type MutationGenerateMobileSignedDocumentPreSignedPutUrlArgs = {
  input: UploadMobileSignedDocumentInput;
};


export type MutationGenerateOrderDocumentPreSignedPutUrlArgs = {
  generateOrderDocumentPreSignedPutUrlInput: GenerateOrderDocumentPreSignedPutUrlInput;
};


export type MutationGenerateOrderPreSignedGetAndPutUrlsArgs = {
  generateOrderPreSignedGetAndPutUrlsInput: GenerateOrderPreSignedGetAndPutUrlsInput;
};


export type MutationGenerateOrderPreSignedPutUrlArgs = {
  generateOrderPreSignedPutUrlInput: GenerateOrderPreSignedPutUrlInput;
};


export type MutationGeneratePodReportPreSignedPutUrlArgs = {
  generatePodReportPreSignedPutUrlInput: GeneratePodReportPreSignedPutUrlInput;
};


export type MutationGeneratePreSignedPutUrlArgs = {
  fileName: Scalars['String']['input'];
  fileType: Scalars['String']['input'];
};


export type MutationGenerateResetCompanyTokenArgs = {
  generateResetCompanyTokenInput: GenerateResetCompanyTokenInput;
};


export type MutationGenerateShipmentPreSignedPutUrlArgs = {
  generateShipmentPreSignedPutUrlInput: GenerateShipmentPreSignedPutUrlInput;
};


export type MutationGenerateStorageOrderPreSignedPutUrlArgs = {
  generateStorageOrderPreSignedPutUrlInput: GenerateStorageOrderPreSignedPutUrlInput;
};


export type MutationHandleMultipleInvoices210OutboundArgs = {
  handleMultiple210OutboundInput: HandleMultiple210OutboundInput;
};


export type MutationImportCrownAccessorialArgs = {
  importCrownAccessorialInput: ImportCrownAccessorialInput;
};


export type MutationImportCrownContactsV2Args = {
  companyUuid: Scalars['String']['input'];
  csvUrl: Scalars['String']['input'];
  useNewImporter?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationImportCrownDriversArgs = {
  importCrownDriversInput: ImportCrownDriversInput;
};


export type MutationImportCrownInvoicesArgs = {
  importCrownInvoicesInput: ImportCrownInvoicesInput;
};


export type MutationImportCrownLanesArgs = {
  importCrownLanesInput: ImportCrownLanesInput;
};


export type MutationImportCrownOrdersArgs = {
  importCrownOrdersInput: ImportCrownOrdersInput;
};


export type MutationImportCrownPaymentsArgs = {
  importCrownPaymentsInput: ImportCrownPaymentsInput;
};


export type MutationImportCrownTariffArgs = {
  importCrownTariffInput: ImportCrownTariffInput;
};


export type MutationImportCrownUsersArgs = {
  importCrownUsersInput: ImportCrownUsersInput;
};


export type MutationImportCustomerDefaultAddressesArgs = {
  companyUuid: Scalars['String']['input'];
  csvUrl: Scalars['String']['input'];
};


export type MutationImportQuickbooksDesktopMappingsArgs = {
  companyUuid: Scalars['String']['input'];
  qbDesktopMappingsUrl: Scalars['String']['input'];
};


export type MutationImportRecoveryTerminalArgs = {
  importRecoveryTerminalInput: ImportRecoveryTerminalInput;
};


export type MutationImportStorageOrdersFromCsvArgs = {
  importStorageOrdersFromCsvInput: ImportStorageOrdersFromCsvInput;
};


export type MutationImportTerminalServiceAreasArgs = {
  importTerminalServiceAreasInput: ImportTerminalServiceAreasInput;
};


export type MutationImportTestSnapshotArgs = {
  importTestSnapshotInput: ImportTestSnapshotInput;
};


export type MutationImportThirdPartyPortalAccountEmailsArgs = {
  companyUuid: Scalars['String']['input'];
  csvUrl: Scalars['String']['input'];
};


export type MutationImportWarehouseLocationsFromCsvArgs = {
  importWarehouseLocationsFromCsvInput: ImportWarehouseLocationsFromCsvInput;
};


export type MutationLogUnassignedScanArgs = {
  logUnassignedScanInput: LogUnassignedScanInput;
};


export type MutationLoginArgs = {
  loginInputData: LoginInput;
};


export type MutationLoginInternalArgs = {
  loginInputData: LoginInput;
};


export type MutationLoginPhoneArgs = {
  loginPhoneInput: LoginPhoneInput;
};


export type MutationLoginPhoneJwtArgs = {
  loginPhoneJwtInput: LoginPhoneJwtInput;
};


export type MutationMakeAppointmentConfirmationDecisionArgs = {
  input: MakeAppointmentConfirmationDecisionInput;
};


export type MutationMarkAsCancelledArgs = {
  uuid: Scalars['String']['input'];
};


export type MutationMarkAsOnHoldArgs = {
  markAsOnHoldInput: MarkAsOnHoldInput;
};


export type MutationMarkAttemptedStopAsCompleteArgs = {
  completedAt?: InputMaybe<Scalars['DateTime']['input']>;
  stopUuid: Scalars['String']['input'];
};


export type MutationMarkConsolidatableOrdersAsBilledIndividuallyArgs = {
  markConsolidatableOrdersAsBilledIndividuallyInput: MarkConsolidatableOrdersAsBilledIndividuallyInput;
};


export type MutationMarkManifestAsArrivedArgs = {
  markManifestAsArrivedInput: MarkManifestAsArrivedInput;
};


export type MutationMarkManifestAsDepartedArgs = {
  markManifestAsDepartedInput: MarkManifestAsDepartedInput;
};


export type MutationMarkManifestAsPlanningArgs = {
  markManifestAsPlanningInput: MarkManifestAsPlanningInput;
};


export type MutationMarkNotOsdArgs = {
  markAsNotOsd: MarkNotOsdInput;
};


export type MutationMarkOrderAsCompleteForceArgs = {
  markOrderAsCompleteForceInput: MarkOrderAsCompleteForceInput;
};


export type MutationMarkOrderAsHasBillingIssueArgs = {
  uuid: Scalars['String']['input'];
};


export type MutationMarkOrderAsNotCompleteArgs = {
  uuid: Scalars['String']['input'];
};


export type MutationMarkOrderAsNotOnHandArgs = {
  markAsNotOnHandInput: MarkAsNotOnHandInput;
};


export type MutationMarkOrderAsNotReadyToInvoiceArgs = {
  uuid: Scalars['String']['input'];
};


export type MutationMarkOrderAsNotReceivedAtOriginArgs = {
  markAsNotReceivedAtOriginInput: MarkAsNotReceivedAtOriginInput;
};


export type MutationMarkOrderAsOnHandArgs = {
  markAsOnHandInput: MarkAsOnHandInput;
};


export type MutationMarkOrderAsPickedArgs = {
  markOrderAsPickedInput: MarkOrderAsPickedInput;
};


export type MutationMarkOrderAsReadyToInvoiceArgs = {
  uuid: Scalars['String']['input'];
};


export type MutationMarkOrderAsReadyToInvoiceForceArgs = {
  refuseOrderInput?: InputMaybe<RefuseOrderInput>;
  uuid: Scalars['String']['input'];
};


export type MutationMarkOrderAsReceivedAtOriginArgs = {
  markAsReceivedAtOriginInput: MarkAsReceivedAtOriginInput;
};


export type MutationMarkOrderAsRefusedArgs = {
  markOrderAsRefusedInput: MarkOrderAsRefusedInput;
};


export type MutationMarkOsdArgs = {
  markOsdInput: MarkOsdInput;
};


export type MutationMarkStopAsFailedArgs = {
  uuid: Scalars['String']['input'];
};


export type MutationMarkStopAsFailedV2Args = {
  markStopAsFailedV2Input: MarkStopAsFailedV2Input;
};


export type MutationMarkStopAsIncompleteArgs = {
  uuid: Scalars['String']['input'];
};


export type MutationMarkStorageUnitAsBilledArgs = {
  markStorageUnitAsBilledInput: MarkStorageUnitAsBilledInput;
};


export type MutationMarkStorageUnitAsOsdArgs = {
  markStorageUnitAsOsdInput: MarkStorageUnitAsOsdInput;
};


export type MutationMarkStorageUnitOnHandArgs = {
  markStorageUnitOnHandInput: MarkStorageUnitOnHandInput;
};


export type MutationMarkWarehouseAsDefaultArgs = {
  warehouseUuid: Scalars['String']['input'];
};


export type MutationMatchFreightSnapArgs = {
  freightSnapCreateInput: FreightSnapCreateInput;
};


export type MutationMatchSignedPoDsArgs = {
  matchSignedPODsInput: CreateScannedOrdersInput;
};


export type MutationMergeEdiOrderArgs = {
  mergeEdiOrderInput: MergeEdiOrderInput;
};


export type MutationMoveShipmentsBetweenInvoicesArgs = {
  moveShipmentsBetweenInvoicesInput: MoveShipmentsBetweenInvoicesInput;
};


export type MutationMoveShipmentsToInvoiceArgs = {
  moveShipmentsToInvoiceInput: MoveShipmentsToInvoiceInput;
};


export type MutationNormalizeDocumentArgs = {
  normalizeDocumentInput: NormalizeDocumentInput;
};


export type MutationOpenMessageInOutlookArgs = {
  openMessageInOutlookInput: OpenMessageInOutlookInput;
};


export type MutationParseCsvOrdersArgs = {
  input: ParseCsvOrdersInput;
};


export type MutationPickStorageUnitArgs = {
  pickStorageUnitInput: PickStorageUnitInput;
};


export type MutationProrateOrdersArgs = {
  prorateOrdersInput: ProrateOrdersInput;
};


export type MutationQueueAppointmentSchedulingProposalsArgs = {
  input: QueueAppointmentSchedulingProposalsInput;
};


export type MutationQueueAppointmentTextsArgs = {
  queueAppointmentTextsArgs: QueueAppointmentTextsArgs;
};


export type MutationReanalyzePageArgs = {
  reanalyzePageInput: ReanalyzePageInput;
};


export type MutationReanalyzeSchemaFileArgs = {
  reanalyzeSchemaFileInput: ReanalyzeSchemaFileInput;
};


export type MutationReassignRouteSlotArgs = {
  routeSlotReassignInput: RouteSlotReassignInput;
};


export type MutationRecreateScannedOrderForEmailAttachmentArgs = {
  uuid: Scalars['String']['input'];
};


export type MutationRefreshEtasForRouteArgs = {
  uuid: Scalars['String']['input'];
};


export type MutationRegisterArgs = {
  registerInputData: RegisterInput;
};


export type MutationRejectCustomerPortalOrderArgs = {
  rejectCustomerPortalOrderInput: RejectCustomerPortalOrderInput;
};


export type MutationRejectEdiOrderArgs = {
  rejectEdiOrderInput: RejectEdiOrderInput;
};


export type MutationRemoveAccessorialArgs = {
  uuid: Scalars['String']['input'];
};


export type MutationRemoveAddressArgs = {
  uuid: Scalars['String']['input'];
};


export type MutationRemoveApiUserContactMappingArgs = {
  removeApiUserContactMappingInput: RemoveApiUserContactMappingInput;
};


export type MutationRemoveBusinessDivisionArgs = {
  uuid: Scalars['String']['input'];
};


export type MutationRemoveCompanyArgs = {
  id: Scalars['Int']['input'];
};


export type MutationRemoveContactArgs = {
  uuid: Scalars['String']['input'];
};


export type MutationRemoveContactPersonArgs = {
  uuid: Scalars['String']['input'];
};


export type MutationRemoveContactsArgs = {
  removeContactsInput: RemoveContactsInput;
};


export type MutationRemoveCoverSheetDocumentTypeSequenceArgs = {
  uuid: Scalars['String']['input'];
};


export type MutationRemoveCreditTypeArgs = {
  uuid: Scalars['String']['input'];
};


export type MutationRemoveDispatchViewArgs = {
  id: Scalars['String']['input'];
};


export type MutationRemoveDriverArgs = {
  uuid: Scalars['String']['input'];
};


export type MutationRemoveDriverSettlementBillArgs = {
  uuid: Scalars['String']['input'];
};


export type MutationRemoveDriversFromRouteArgs = {
  removeDriversFromRouteInput: RemoveDriversFromRouteInput;
};


export type MutationRemoveEmailTransactionLogArgs = {
  uuid: Scalars['String']['input'];
};


export type MutationRemoveFeatureFlagArgs = {
  removeFeatureFlagInput: FeatureFlagRemoveInput;
};


export type MutationRemoveFuelProfileArgs = {
  uuid: Scalars['String']['input'];
};


export type MutationRemoveGeneralLedgerCodeArgs = {
  id: Scalars['String']['input'];
};


export type MutationRemoveGeneralLedgerConfigurationArgs = {
  id: Scalars['String']['input'];
};


export type MutationRemoveHelperFromRouteArgs = {
  helperUuid: Scalars['String']['input'];
  routeUuid: Scalars['String']['input'];
};


export type MutationRemoveHoldReasonArgs = {
  uuid: Scalars['String']['input'];
};


export type MutationRemoveImportedOrderTypeMappingArgs = {
  uuid: Scalars['String']['input'];
};


export type MutationRemoveInvoiceArgs = {
  uuid: Scalars['String']['input'];
};


export type MutationRemoveInvoiceTermsArgs = {
  uuid: Scalars['String']['input'];
};


export type MutationRemoveLineHaulLaneArgs = {
  uuid: Scalars['String']['input'];
};


export type MutationRemoveLineHaulManifestArgs = {
  uuid: Scalars['String']['input'];
};


export type MutationRemoveLineHaulSegmentArgs = {
  uuid: Scalars['String']['input'];
};


export type MutationRemoveLineItemsFromSettlementBillArgs = {
  removeLineItemsFromSettlementBillInput: RemoveLineItemsFromSettlementBillInput;
};


export type MutationRemoveMasterAccountArgs = {
  uuid: Scalars['String']['input'];
};


export type MutationRemoveOrderHoldArgs = {
  removeOrderHoldInput: RemoveOrderHoldInput;
};


export type MutationRemoveOrderLineHaulSegmentArgs = {
  uuid: Scalars['String']['input'];
};


export type MutationRemoveOrdersFromManifestArgs = {
  removeOrdersFromManifestInput: RemoveOrdersFromManifestInput;
};


export type MutationRemoveOrdersFromManifestV2Args = {
  input: RemoveOrdersFromManifestV2Input;
};


export type MutationRemoveRouteArgs = {
  uuid: Scalars['String']['input'];
};


export type MutationRemoveRouteDriverArgs = {
  uuid: Scalars['String']['input'];
};


export type MutationRemoveServiceArgs = {
  uuid: Scalars['String']['input'];
};


export type MutationRemoveServiceToContactArgs = {
  removeServiceFromContactInput: RemoveServiceFromContactInput;
};


export type MutationRemoveSettlementAdjustmentArgs = {
  uuid: Scalars['String']['input'];
};


export type MutationRemoveSettlementDeductionArgs = {
  uuid: Scalars['String']['input'];
};


export type MutationRemoveSettlementDeductionTypeArgs = {
  uuid: Scalars['String']['input'];
};


export type MutationRemoveShipmentsFromInvoiceArgs = {
  removeShipmentsFromInvoiceInput: RemoveShipmentsFromInvoiceInput;
};


export type MutationRemoveSpecialAccessorialArgs = {
  uuid: Scalars['String']['input'];
};


export type MutationRemoveStopsFromRoutesArgs = {
  removeStopsFromRoutesInput: RemoveStopsFromRoutesInputType;
};


export type MutationRemoveStorageUnitOnHandArgs = {
  removeStorageUnitOnHandInput: RemoveStorageUnitOnHandInput;
};


export type MutationRemoveStorageUnitOsdArgs = {
  removeStorageUnitOsdInput: RemoveStorageUnitOsdInput;
};


export type MutationRemoveSubscriberFromShipmentArgs = {
  removeSubscriberInput: RemoveSubscriberInput;
};


export type MutationRemoveTagFromLegArgs = {
  removeTagFromLegInput: RemoveTagFromLegInput;
};


export type MutationRemoveTagFromOrderArgs = {
  removeTagFromOrderInput: RemoveTagFromOrderInput;
};


export type MutationRemoveTerminalArgs = {
  uuid: Scalars['String']['input'];
};


export type MutationRemoveTerminalServiceAreaArgs = {
  uuid: Scalars['String']['input'];
};


export type MutationRemoveThirdPartyBrokerArgs = {
  uuid: Scalars['String']['input'];
};


export type MutationRemoveThirdPartyUserFromContactArgs = {
  removeThirdPartyUserFromContactInput: RemoveThirdPartyUserFromContactInput;
};


export type MutationRemoveUserFromRoleArgs = {
  removeUserFromRoleInput: RemoveUserFromRoleInput;
};


export type MutationRemoveVehicleTypeArgs = {
  uuid: Scalars['String']['input'];
};


export type MutationRemoveZoneBasedAccessorialArgs = {
  uuid: Scalars['String']['input'];
};


export type MutationReplayOutboundEdiArgs = {
  replayOutboundEdiInput: ReplayOutboundEdiInput;
};


export type MutationReportADocScanIssueArgs = {
  reportADocScanIssueInput: ReportADocScanIssueInput;
};


export type MutationResetCompanyArgs = {
  resetCompanyInput: ResetCompanyInput;
};


export type MutationRestoreContactStationArgs = {
  id: Scalars['String']['input'];
};


export type MutationRestoreDriverArgs = {
  uuid: Scalars['String']['input'];
};


export type MutationRestoreOrganizationArgs = {
  input: RestoreOrganizationInput;
};


export type MutationRestorePackageSpecArgs = {
  id: Scalars['String']['input'];
};


export type MutationRestorePersonArgs = {
  id: Scalars['String']['input'];
};


export type MutationRestoreSchedulingRegionArgs = {
  id: Scalars['String']['input'];
};


export type MutationRestoreSchedulingZoneArgs = {
  id: Scalars['String']['input'];
};


export type MutationRestoreTariffChainArgs = {
  restoreTariffChainInput: RestoreTariffChainInput;
};


export type MutationRestoreTariffZoneGroupArgs = {
  id: Scalars['String']['input'];
};


export type MutationRestoreVehicleTypeArgs = {
  uuid: Scalars['String']['input'];
};


export type MutationRetryInvoiceSendJobBatchesArgs = {
  invoiceSendJobBatchUuids: Array<Scalars['String']['input']>;
  skipFailures: Scalars['Boolean']['input'];
};


export type MutationRetrySftpUploadsArgs = {
  retrySftpUploadsInput: RetrySftpUploadsInput;
};


export type MutationReuploadPodsArgs = {
  reuploadPodsInput: ReuploadPodsInput;
};


export type MutationRotateDocumentArgs = {
  rotateDocumentInput: RotateDocumentInput;
};


export type MutationRunOptimizationArgs = {
  createOptimizationRunInput: CreateOptimizationRunDto;
};


export type MutationScanOrderArgs = {
  scanOrderInput: ScanOrderInput;
};


export type MutationScanOrderBarcodeArgs = {
  scanOrderBarcodeInput: ScanOrderBarcodeInput;
};


export type MutationScanPieceArgs = {
  scanPieceInput: ScanPieceInput;
};


export type MutationScanWarehouseLocationArgs = {
  scanWarehouseLocationInput: ScanWarehouseLocationInput;
};


export type MutationSendAccountingReportsArgs = {
  sendAccountingReportsInput: SendAccountingReportsInput;
};


export type MutationSendDeliveryCompletedArgs = {
  sendDeliveryCompletedInput: SendDeliveryCompletedInput;
};


export type MutationSendInvoicesArgs = {
  sendInvoicesInput: SendInvoicesInput;
};


export type MutationSendMetricArgs = {
  sendMetricInput: SendMetricInput;
};


export type MutationSendRouteToAgentArgs = {
  input: SendRouteToAgentInput;
};


export type MutationSendStopToAgentArgs = {
  input: SendStopToAgentInput;
};


export type MutationSetStorageOrderItemQuantityArgs = {
  setStorageOrderItemQuantityInput: SetStorageOrderItemQuantityInput;
};


export type MutationSignUpForThirdPartyUserAccountArgs = {
  signUpForThirdPartyUserAccountInput: SignUpForThirdPartyUserAccountInput;
};


export type MutationSplitAndProcessOrderDocumentsArgs = {
  splitAndProcessOrderDocumentsInput: SplitAndProcessOrderDocumentsInput;
};


export type MutationStartRouteArgs = {
  startTime?: InputMaybe<Scalars['DateTime']['input']>;
  uuid: Scalars['String']['input'];
};


export type MutationTestOneSnapshotArgs = {
  testOneSnapshotInput: TestOneSnapshotInput;
};


export type MutationTestSchemaArgs = {
  testSchemaInput: TestSchemaInput;
};


export type MutationTextDriverArgs = {
  textDriverInput: TextDriverInput;
};


export type MutationTextractSchemaFileArgs = {
  textractSchemaFileInput: TextractSchemaFileInput;
};


export type MutationTextractSchemaTestFileArgs = {
  textractSchemaTestFileInput: TextractSchemaTestFileInput;
};


export type MutationUnassignInventoryItemsArgs = {
  unassignInventoryItemsInput: UnassignInventoryItemsInput;
};


export type MutationUnassignLegFromDriverArgs = {
  unassignLegFromDriver: UnassignLegFromDriverInput;
};


export type MutationUncancelOrderArgs = {
  uuid: Scalars['String']['input'];
};


export type MutationUnconsolidateOrderArgs = {
  unconsolidateOrderInput: UnconsolidateOrderInput;
};


export type MutationUnfinalizeOrderArgs = {
  uuid: Scalars['String']['input'];
};


export type MutationUnpickOrderArgs = {
  uuid: Scalars['String']['input'];
};


export type MutationUnpickStorageUnitArgs = {
  unpickStorageUnitInput: UnpickStorageUnitInput;
};


export type MutationUnpostInvoiceArgs = {
  unpostInvoiceInput: UnpostInvoiceInput;
};


export type MutationUpdateArgs = {
  updateEquipmentLicenseInput: UpdateEquipmentLicenseInput;
};


export type MutationUpdateAccessorialArgs = {
  updateAccessorialInput: UpdateAccessorialInput;
};


export type MutationUpdateAccessorialContactArgs = {
  accessorialContactInput: UpdateAccessorialContactInput;
};


export type MutationUpdateAccessorialDateRangeConfigArgs = {
  updateAccessorialDateRangeConfigInput: UpdateAccessorialDateRangeConfigInput;
};


export type MutationUpdateAccessorialRangesForAccessorialArgs = {
  accessorialRangeUpdatesInput: AccessorialRangeUpdatesInput;
};


export type MutationUpdateAccessorialToQuickbooksMappingArgs = {
  accessorialToQuickbooksMappingUpdateInput: AccessorialToQuickbooksMappingUpdateInput;
};


export type MutationUpdateAddressArgs = {
  updateAddressInput: UpdateAddressInput;
};


export type MutationUpdateAirportInfoArgs = {
  updateAirportInfoInput: UpdateAirportInfoInput;
};


export type MutationUpdateApiUserArgs = {
  updateApiUserInput: UpdateApiUserInput;
};


export type MutationUpdateAutoApplyAccessorialConfigArgs = {
  updateAutoApplyAccessorialConfigInput: UpdateAutoApplyAccessorialConfigInput;
};


export type MutationUpdateBusinessDivisionArgs = {
  updateBusinessDivisionInput: UpdateBusinessDivisionInput;
};


export type MutationUpdateCompanyArgs = {
  updateCompanyInput: UpdateCompanyInput;
};


export type MutationUpdateCompanyConfigurationArgs = {
  updateCompanyConfigurationInput: UpdateCompanyConfigurationInput;
};


export type MutationUpdateContactCommentArgs = {
  updateContactCommentInput: UpdateContactCommentInput;
};


export type MutationUpdateContactCommunicationConfigArgs = {
  updateContactCommunicationConfigInput: UpdateContactCommunicationConfigInput;
};


export type MutationUpdateContactEmailsArgs = {
  input: UpdateContactEmailsInput;
};


export type MutationUpdateContactPersonArgs = {
  updateContactPersonInput: UpdateContactPersonInput;
};


export type MutationUpdateContactStationArgs = {
  contactStationUpdateInput: ContactStationUpdateInput;
};


export type MutationUpdateContactToServicesTariffGroupMappingsArgs = {
  contactToServicesMappings: Array<CreateContactToServicesMappingInput>;
  uuid: Scalars['String']['input'];
};


export type MutationUpdateCoverSheetDocumentTypeSequenceArgs = {
  coverSheetDocumentTypeSequenceUpdateInput: CoverSheetDocumentTypeSequenceUpdateInput;
};


export type MutationUpdateCreditTypeArgs = {
  creditTypeUpdateInput: CreditTypeUpdateInput;
};


export type MutationUpdateCsvOrderFieldMappingArgs = {
  updateCsvOrderFieldMappingInput: UpdateCsvOrderFieldMappingInput;
};


export type MutationUpdateCsvOrderImportTransactionArgs = {
  updateCsvOrderImportTransactionInput: UpdateCsvOrderImportTransactionInput;
};


export type MutationUpdateCsvOrderMappingArgs = {
  updateCsvOrderMappingInput: UpdateCsvOrderMappingInput;
};


export type MutationUpdateCustomerContactArgs = {
  updateCustomerContactInput: UpdateCustomerContactInput;
};


export type MutationUpdateCustomerContactPackageSpecsArgs = {
  input: UpdateCustomerContactPackageSpecsInput;
};


export type MutationUpdateCustomerContactVehicleTypesArgs = {
  input: UpdateCustomerContactVehicleTypesInput;
};


export type MutationUpdateDefaultTariffChainsForCompanyArgs = {
  updateDefaultTariffChainsForCompanyInput: UpdateDefaultTariffChainsForCompanyInput;
};


export type MutationUpdateDispatchTableColorsArgs = {
  input: UpdateDispatchTableColorsInput;
};


export type MutationUpdateDispatchViewArgs = {
  dispatchViewUpdateInput: DispatchViewUpdateInput;
};


export type MutationUpdateDocumentArgs = {
  updateDocumentInput: UpdateDocumentInput;
};


export type MutationUpdateDocumentsArgs = {
  updateDocumentsInput: UpdateDocumentsInput;
};


export type MutationUpdateDriverArgs = {
  updateDriverInput: UpdateDriverInput;
};


export type MutationUpdateDriverLocationArgs = {
  updateDriverLocationInput: UpdateDriverLocationInput;
};


export type MutationUpdateDriverQualificationsArgs = {
  input: UpdateDriverQualificationsInput;
};


export type MutationUpdateDriverSettlementBillArgs = {
  updateDriverSettlementBillInput: UpdateDriverSettlementBillInput;
};


export type MutationUpdateDriverSignableFormTemplateArgs = {
  updateDriverSignableFormTemplateInput: UpdateDriverSignableFormTemplateInput;
};


export type MutationUpdateEdiPartnershipArgs = {
  updateEdiPartnershipInput: UpdateEdiPartnershipInput;
};


export type MutationUpdateEmailTransactionArgs = {
  updateEmailTransactionInput: UpdateEmailTransactionInput;
};


export type MutationUpdateEmailTransactionLogArgs = {
  emailTransactionLogInput: EmailTransactionLogUpdateInput;
};


export type MutationUpdateEndOfDayDocumentProcessingJobArgs = {
  updateEndOfDayDocumentProcessingJobInput: UpdateEndOfDayDocumentProcessingJobInput;
};


export type MutationUpdateEquipmentArgs = {
  updateEquipmentInput: UpdateEquipmentInput;
};


export type MutationUpdateFeatureFlagArgs = {
  updateFeatureFlagInput: UpdateFeatureFlagInput;
};


export type MutationUpdateFeatureFlagCompanyOverrideArgs = {
  updateFeatureFlagCompanyOverrideInput: UpdateFeatureFlagCompanyOverrideInput;
};


export type MutationUpdateFeatureFlagUserOverrideArgs = {
  updateFeatureFlagUserOverrideInput: UpdateFeatureFlagUserOverrideInput;
};


export type MutationUpdateFreightChargeArgs = {
  updateFreightChargeInput: UpdateFreightChargeInput;
};


export type MutationUpdateFuelProfileArgs = {
  updateFuelProfileInput: UpdateFuelProfileInput;
};


export type MutationUpdateFuelProfileDateRangeArgs = {
  updateFuelProfileDateRangeInput: UpdateFuelProfileDateRangeInput;
};


export type MutationUpdateGeneralLedgerCodeArgs = {
  input: GeneralLedgerCodeUpdateInput;
};


export type MutationUpdateGeneralLedgerConfigurationArgs = {
  input: GeneralLedgerConfigurationUpdateInput;
};


export type MutationUpdateHoldReasonArgs = {
  holdReasonUpdateInput: HoldReasonUpdateInput;
};


export type MutationUpdateImportedOrderTypeMappingArgs = {
  importedOrderTypeMappingInput: ImportedOrderTypeMappingUpdateInput;
};


export type MutationUpdateInventoryItemsArgs = {
  updateInventoryItemsInput: UpdateInventoryItemsInput;
};


export type MutationUpdateInvoiceArgs = {
  updateInvoiceInput: UpdateInvoiceInput;
};


export type MutationUpdateInvoiceEmailArgs = {
  email: Scalars['String']['input'];
};


export type MutationUpdateInvoiceLimitedArgs = {
  updateInvoiceLimitedInput: InvoiceUpdateLimitedInput;
};


export type MutationUpdateItemArgs = {
  updateItemInput: UpdateItemInput;
};


export type MutationUpdateItemLocationArgs = {
  updateItemLocationInput: UpdateItemLocationInput;
};


export type MutationUpdateLegDriverMapArgs = {
  updateLegDriverMapInput: UpdateLegDriverMapInput;
};


export type MutationUpdateLineHaulLaneArgs = {
  updateLineHaulLaneInput: UpdateLineHaulLaneInput;
};


export type MutationUpdateLineHaulManifestArgs = {
  updateLineHaulManifestInput: UpdateLineHaulManifestInput;
};


export type MutationUpdateLineHaulSegmentArgs = {
  updateLineHaulSegmentInput: UpdateLineHaulSegmentInput;
};


export type MutationUpdateManifestDriverArgs = {
  updateManifestDriverInput: UpdateManifestDriverInput;
};


export type MutationUpdateManifestVehicleArgs = {
  updateManifestVehicleInput: UpdateManifestVehicleInput;
};


export type MutationUpdateManifestsStatusArgs = {
  input: UpdateManifestsStatusInput;
};


export type MutationUpdateMasterAccountArgs = {
  updateMasterAccountInput: UpdateMasterAccountInput;
};


export type MutationUpdateOrderArgs = {
  updateOrderInput: UpdateOrderInput;
};


export type MutationUpdateOrderCommentArgs = {
  updateOrderCommentInput: UpdateOrderCommentInput;
};


export type MutationUpdateOrderEventNotificationSubscriptionsArgs = {
  input: UpdateOrderEventNotificationSubscriptionsInput;
};


export type MutationUpdateOrderFormFieldsArgs = {
  updateOrderFormFieldsInput: UpdateOrderFormFieldsInput;
};


export type MutationUpdateOrderImportConfigurationArgs = {
  orderImportConfigurationUpdateInput: OrderImportConfigurationUpdateInput;
};


export type MutationUpdateOrderLineHaulSegmentArgs = {
  orderLineHaulSegmentInput: OrderLineHaulSegmentUpdateInput;
};


export type MutationUpdateOrderLoadedStatusArgs = {
  updateOrderLoadedStatusInput: UpdateOrderLoadedStatusInput;
};


export type MutationUpdateOrganizationArgs = {
  input: UpdateOrganizationInput;
};


export type MutationUpdateOutlookIntegrationArgs = {
  outlookIntegrationUpdateInput: OutlookIntegrationUpdateInput;
};


export type MutationUpdatePackageArgs = {
  updatePackageInput: UpdatePackageInput;
};


export type MutationUpdatePackageArrayArgs = {
  updatePackageArrayInput: UpdatePackageArrayInput;
};


export type MutationUpdatePackageSpecArgs = {
  updatePackageSpecInput: UpdatePackageSpecInput;
};


export type MutationUpdatePackageWarehouseLocationArgs = {
  updatePackageWarehouseLocationInput: UpdatePackageWarehouseLocationInput;
};


export type MutationUpdatePaperworkCompletedForStopsArgs = {
  updatePaperworkCompleteInput: UpdatePaperworkCompleteInput;
};


export type MutationUpdatePaymentArgs = {
  updatePaymentInput: UpdatePaymentInput;
};


export type MutationUpdatePermissionArgs = {
  updatePermissionInput: UpdatePermissionInput;
};


export type MutationUpdatePermissionAccessLevelArgs = {
  updatePermissionAccessLevelInput: UpdatePermissionAccessLevelInput;
};


export type MutationUpdatePersonArgs = {
  input: UpdatePersonInput;
};


export type MutationUpdatePieceCountArgs = {
  updatePieceCountInput: UpdatePieceCountInput;
};


export type MutationUpdatePiecesPickedArgs = {
  updatePiecesPickedInput: UpdatePiecesPickedInput;
};


export type MutationUpdatePlaceArgs = {
  updatePlaceInput: UpdatePlaceInput;
};


export type MutationUpdateQuickAddAccessorialsArgs = {
  input: UpdateQuickAddAccessorialsInput;
};


export type MutationUpdateQuickbooksHeaderFileMappingArgs = {
  updateQuickbooksHeaderFileMappingInput: UpdateQuickbooksHeaderFileMappingInput;
};


export type MutationUpdateQuoteArgs = {
  updateQuoteInput: UpdateQuoteInput;
};


export type MutationUpdateRecurringOrderFrequencyArgs = {
  updateRecurringOrderFrequencyInput: UpdateRecurringOrderFrequencyInput;
};


export type MutationUpdateReportGroupConfigurationArgs = {
  updateReportGroupConfigurationInput: ReportGroupConfigurationUpdateInput;
};


export type MutationUpdateReportsEmailArgs = {
  email: Scalars['String']['input'];
  userUuid: Scalars['String']['input'];
};


export type MutationUpdateRoleArgs = {
  updateRoleInput: UpdateRoleInput;
};


export type MutationUpdateRouteArgs = {
  updateRouteInput: UpdateRouteInput;
};


export type MutationUpdateRouteDriversArgs = {
  updateRouteDriversInput: UpdateRouteDriversInput;
};


export type MutationUpdateRouteNameLocationArgs = {
  updateRouteNameLocationInput: UpdateRouteNameLocationInput;
};


export type MutationUpdateRouteOptimizationArgs = {
  updateRouteOptimizationInput: UpdateRouteOptimizationInput;
};


export type MutationUpdateRouteSlotArgs = {
  updateRouteSlotInput: UpdateRouteSlotInput;
};


export type MutationUpdateRouteSlotsArgs = {
  updateRouteSlotsInput: UpdateRouteSlotsInput;
};


export type MutationUpdateRunArgs = {
  updateRunInput: UpdateRunInput;
};


export type MutationUpdateSameDayDispatchConfigArgs = {
  updateSameDayDispatchConfigInput: UpdateSameDayDispatchConfigInput;
};


export type MutationUpdateSavedFilterViewArgs = {
  updateSavedFilterViewInput: UpdateSavedFilterViewInput;
};


export type MutationUpdateScannedOrderArgs = {
  updateScannedOrderInput: UpdateScannedOrderInput;
};


export type MutationUpdateScannedOrderResultStatusArgs = {
  updateScannedOrderResultStatusInput: UpdateScannedOrderResultStatusInput;
};


export type MutationUpdateSchedulingRegionArgs = {
  input: UpdateSchedulingRegionInput;
};


export type MutationUpdateSchedulingZoneArgs = {
  input: UpdateSchedulingZoneInput;
};


export type MutationUpdateSchemaArgs = {
  updateSchemaInput: UpdateSchemaInput;
};


export type MutationUpdateSchemaCompanyMappingArgs = {
  updateSchemaCompanyMappingInput: UpdateSchemaCompanyMappingInput;
};


export type MutationUpdateSchemaDocumentArgs = {
  updateSchemaDocumentInput: UpdateSchemaDocumentInput;
};


export type MutationUpdateServiceArgs = {
  updateServiceInput: UpdateServiceInput;
};


export type MutationUpdateServiceDateForAssignedStopsArgs = {
  updateServiceDateForAssignedStopsInput: UpdateServiceDateForAssignedStopsInput;
};


export type MutationUpdateServiceRegionArgs = {
  input: UpdateServiceRegionInput;
};


export type MutationUpdateSettlementAdjustmentArgs = {
  settlementAdjustmentUpdateInput: SettlementAdjustmentUpdateInput;
};


export type MutationUpdateSettlementDeductionArgs = {
  settlementDeductionUpdateInput: SettlementDeductionUpdateInput;
};


export type MutationUpdateSettlementDeductionTypeArgs = {
  settlementDeductionTypeInput: SettlementDeductionTypeUpdateInput;
};


export type MutationUpdateSftpCredentialsArgs = {
  updateSftpCredentialsInput: UpdateSftpCredentialsInput;
};


export type MutationUpdateShipmentArgs = {
  updateShipmentInput: UpdateShipmentInput;
};


export type MutationUpdateShipmentStandardAccessorialsArgs = {
  updateShipmentStandardAccessorialsInput: UpdateShipmentStandardAccessorialsInput;
};


export type MutationUpdateSignedPodArgs = {
  updateSignedPODInput: UpdateScannedOrderInput;
};


export type MutationUpdateStandardOrderArgs = {
  updateStandardOrderInput: UpdateStandardOrderInput;
};


export type MutationUpdateStandardShipmentFieldsArgs = {
  updateStandardShipmentFieldsInput: UpdateStandardShipmentFieldInput;
};


export type MutationUpdateStopArgs = {
  updateStopInput: UpdateStopInput;
};


export type MutationUpdateStopDriverMapArgs = {
  updateStopDriverMapInput: UpdateStopDriverMapInput;
};


export type MutationUpdateStopsArgs = {
  updateStopsInput: UpdateStopsInput;
};


export type MutationUpdateStorageOrderArgs = {
  updateStorageOrderInput: UpdateStorageOrderInput;
};


export type MutationUpdateStorageUnitArgs = {
  updateStorageUnitInput: UpdateStorageUnitInput;
};


export type MutationUpdateTagArgs = {
  updateTagInput: UpdateTagInput;
};


export type MutationUpdateTariffChainArgs = {
  updateTariffChainInput: UpdateTariffChainInput;
};


export type MutationUpdateTariffGroupArgs = {
  updateTariffGroupInput: UpdateTariffGroupInput;
};


export type MutationUpdateTariffRangesForTariffArgs = {
  tariffRangeUpdatesInput: TariffRangeUpdatesInput;
};


export type MutationUpdateTariffZoneArgs = {
  contactUuid?: InputMaybe<Scalars['String']['input']>;
  tariffZoneUpdateInput: TariffZoneUpdateInput;
};


export type MutationUpdateTariffZoneGroupArgs = {
  tariffZoneGroupUpdateInput: TariffZoneGroupUpdateInput;
};


export type MutationUpdateTemplateAndRecordAddressesArgs = {
  updateAddressInput: UpdateAddressInput;
};


export type MutationUpdateTerminalArgs = {
  updateTerminalInput: UpdateTerminalInput;
};


export type MutationUpdateTerminalServiceAreaArgs = {
  terminalServiceAreaInput: TerminalServiceAreaUpdateInput;
};


export type MutationUpdateTerminalV2Args = {
  input: TerminalUpdateInput;
};


export type MutationUpdateTestOrderArgs = {
  updateTestOrderInput: UpdateTestOrderInput;
};


export type MutationUpdateThirdPartyBrokerArgs = {
  thirdPartyBrokerUpdateInput: ThirdPartyBrokerUpdateInput;
};


export type MutationUpdateThirdPartyUserArgs = {
  updateThirdPartyUserInput: UpdateThirdPartyUserInput;
  uuid: Scalars['String']['input'];
};


export type MutationUpdateUserArgs = {
  updateUserInput: UpdateUserInput;
};


export type MutationUpdateVehicleForRouteArgs = {
  routeUuid: Scalars['String']['input'];
  vehicleUuid: Scalars['String']['input'];
};


export type MutationUpdateVehicleTypeArgs = {
  vehicleTypeUpdateInput: VehicleTypeUpdateInput;
};


export type MutationUpdateWarehouseArgs = {
  updateWarehouseInput: UpdateWarehouseInput;
};


export type MutationUpdateWarehouseEmployeeArgs = {
  updateWarehouseEmployeeInput: UpdateWarehouseEmployeeInput;
};


export type MutationUpdateWarehouseLocationArgs = {
  updateWarehouseLocationInput: UpdateWarehouseLocationInput;
};


export type MutationUpsertAddressArgs = {
  upsertAddressInput: UpsertAddressInput;
};


export type MutationUpsertContactPersonArgs = {
  upsertContactPersonInput: UpsertContactPersonInput;
};


export type MutationUpsertFreightChargeArgs = {
  upsertFreightChargeInput: UpsertFreightChargeInput;
};


export type MutationUpsertItemGroupArgs = {
  upsertItemGroupInput: UpsertItemGroupInput;
};


export type MutationUpsertPackageArgs = {
  upsertPackageInput: UpsertPackageInput;
};


export type MutationUpsertPicklistArgs = {
  upsertPicklistInput: UpsertPicklistInput;
};


export type MutationUpsertSamsaraOauthTokenArgs = {
  upsertSamsaraOauthTokenInput: UpsertSamsaraOauthTokenInput;
};


export type MutationUpsertShipmentSubscriberArgs = {
  upsertShipmentSubscriberInput: UpsertShipmentSubscriberInput;
};


export type MutationUpsertShipmentSubscriberForCompanyArgs = {
  companyUuid: Scalars['String']['input'];
  upsertShipmentSubscriberInput: UpsertShipmentSubscriberInput;
};


export type MutationUpsertStructuredExtractionSchemaOverrideArgs = {
  upsertStructuredExtractionSchemaOverrideInput: StructuredExtractionSchemaOverrideInput;
};


export type MutationUpsertUserContactNotificationSubscriptionArgs = {
  userContactNotificationSubscriptionUpsertInput: UserContactNotificationSubscriptionUpsertInput;
};


export type MutationValidateCrownChargesFromCsvArgs = {
  validateCrownChargesInput: ValidateCrownChargesInput;
};


export type MutationValidateCrownChargesFromPdfArgs = {
  validateCrownChargesInput: ValidateCrownChargesInput;
};


export type MutationValidateImportedCrownInvoicesArgs = {
  validateImportedCrownInvoicesInput: ValidateImportedCrownInvoicesInput;
};


export type MutationVerifyInventoryForStorageUnitArgs = {
  verifyInventoryForStorageUnitInput: VerifyInventoryForStorageUnitInput;
};

export type MutationErrorOutput = {
  __typename?: 'MutationErrorOutput';
  message: Scalars['String']['output'];
};

export type NameSortInput = {
  direction: SortOrder;
  nulls: NullsOrder;
};

export type NetSalesSummaryReportInput = {
  /** The UUIDs of the customers (contacts) to include in the report. If not included, the report will include net sales data for all customers. */
  customerUuids?: InputMaybe<Array<Scalars['String']['input']>>;
  invoiceEndDate?: InputMaybe<Scalars['DateTime']['input']>;
  invoiceStartDate?: InputMaybe<Scalars['DateTime']['input']>;
  terminalUuid?: InputMaybe<Scalars['String']['input']>;
};

export type NetSalesSummaryReportOutput = {
  __typename?: 'NetSalesSummaryReportOutput';
  contactRows: Array<NetSalesSummaryReportOutputRow>;
  reportTotal: NetSalesSummaryReportOutputRow;
};

export type NetSalesSummaryReportOutputRow = {
  __typename?: 'NetSalesSummaryReportOutputRow';
  /** Total of credits and debits on open invoices */
  adjustmentsInCents: Scalars['Float']['output'];
  contactName: Scalars['String']['output'];
  contactUuid: Scalars['String']['output'];
  dimWeight: Scalars['Float']['output'];
  /** openInvoiesTotal - adjustments */
  netSalesInCents: Scalars['Float']['output'];
  openInvoiesTotalInCents: Scalars['Float']['output'];
  pieces: Scalars['Int']['output'];
  weight: Scalars['Float']['output'];
};

export type NewInvoiceToCreate = {
  __typename?: 'NewInvoiceToCreate';
  name?: Maybe<Scalars['String']['output']>;
  ordersToAdd: Array<OrderToAddToInvoice>;
};

export type NewSettlementBillInput = {
  driverUuid: Scalars['String']['input'];
  settlementBillLineItemIds: Array<Scalars['String']['input']>;
};

export type NormalizeDocumentInput = {
  documentName: Scalars['String']['input'];
  schemaUuid: Scalars['String']['input'];
};

export enum NotificationChannel {
  Email = 'EMAIL',
  TextMessage = 'TEXT_MESSAGE'
}

export type NotificationEntity = {
  __typename?: 'NotificationEntity';
  acknowledged?: Maybe<Scalars['Boolean']['output']>;
  createdAt: Scalars['DateTime']['output'];
  driverMarkedAttemptedDriver?: Maybe<DriverEntity>;
  driverMarkedAttemptedStop?: Maybe<StopEntity>;
  emailTransaction?: Maybe<EmailTransactionEntity>;
  order?: Maybe<OrderEntity>;
  sourceDriver?: Maybe<DriverEntity>;
  targetAccessorial?: Maybe<AccessorialUnion>;
  targetStop?: Maybe<StopEntity>;
  type: NotificationType;
  updatedAt: Scalars['DateTime']['output'];
  uuid: Scalars['String']['output'];
};

export enum NotificationSubscriberType {
  DynamicOrderContact = 'DYNAMIC_ORDER_CONTACT',
  DynamicOrderInboundContact = 'DYNAMIC_ORDER_INBOUND_CONTACT',
  DynamicOrderOutboundContact = 'DYNAMIC_ORDER_OUTBOUND_CONTACT'
}

export enum NotificationType {
  ContactCreditLimitReached = 'CONTACT_CREDIT_LIMIT_REACHED',
  DriverAddedAccessorialToStop = 'DRIVER_ADDED_ACCESSORIAL_TO_STOP',
  DriverMarkedStopAsAttempted = 'DRIVER_MARKED_STOP_AS_ATTEMPTED',
  EmailingInvoice = 'EMAILING_INVOICE',
  OrderAwaitingApproval = 'ORDER_AWAITING_APPROVAL'
}

export enum NullsOrder {
  First = 'first',
  Last = 'last'
}

/** Represents the difference between 2 versions of a numerical field. Used in audit log entries */
export type NumberFieldDifference = {
  __typename?: 'NumberFieldDifference';
  newValue?: Maybe<Scalars['Float']['output']>;
  oldValue?: Maybe<Scalars['Float']['output']>;
};

export enum NumberOfConsignees {
  Multiple = 'MULTIPLE',
  One = 'ONE'
}

export enum NumberOfShippers {
  Multiple = 'MULTIPLE',
  One = 'ONE'
}

export enum OnTimePerformanceReportDetailType {
  Aggregate = 'AGGREGATE',
  Detailed = 'DETAILED'
}

export type OnTimePerformanceReportInput = {
  /** The UUIDs of the business divisions to include in the report. If not included, the report will include stops for all business divisions. */
  businessDivisionUuids?: InputMaybe<Array<Scalars['String']['input']>>;
  /** The UUIDs of the customers to include in the report. If not included, the report will include stops for all customers. */
  customerUuids?: InputMaybe<Array<Scalars['String']['input']>>;
  reportDetailType?: InputMaybe<OnTimePerformanceReportDetailType>;
  /** The UUIDs of the services to include in the report. If not included, the report will include stops for all services. */
  serviceUuids?: InputMaybe<Array<Scalars['String']['input']>>;
  /**
   * The upper bound for the date of stops which will be included in the report.
   *     If not included, the report will include all stops after stopStartDate.
   */
  stopEndDate?: InputMaybe<Scalars['DateTime']['input']>;
  /**
   * The lower bound for the date of stops which will be included in the report.
   *     If not included, the report will include all stops before stopEndDate.
   */
  stopStartDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** The UUIDs of the terminals to include in the report. If not included, the report will include stops for all terminals. */
  terminalUuids?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type OpenInvoiceReportArgs = {
  findInvoicesArgs: FindInvoicesInput;
};

export type OpenMessageInOutlookInput = {
  orderUuid: Scalars['String']['input'];
};

export type OpenMessageInOutlookOutput = {
  __typename?: 'OpenMessageInOutlookOutput';
  linkToOpen: Scalars['String']['output'];
};

export type OptimizationResultsOutput = {
  __typename?: 'OptimizationResultsOutput';
  error?: Maybe<Scalars['String']['output']>;
  slots?: Maybe<Array<Scalars['String']['output']>>;
};

export enum OrderAction {
  MarkAllPiecesPicked = 'MARK_ALL_PIECES_PICKED',
  MarkAsCancelled = 'MARK_AS_CANCELLED',
  MarkAsOnHand = 'MARK_AS_ON_HAND',
  MarkAsOnHold = 'MARK_AS_ON_HOLD',
  RemoveHold = 'REMOVE_HOLD',
  Uncancel = 'UNCANCEL'
}

export type OrderAddedToInvoice = {
  __typename?: 'OrderAddedToInvoice';
  orderName: Scalars['String']['output'];
  orderUuid: Scalars['String']['output'];
};

export enum OrderBillingStatus {
  HasIssues = 'HAS_ISSUES',
  NotReadyToInvoice = 'NOT_READY_TO_INVOICE',
  ReadyToInvoice = 'READY_TO_INVOICE'
}

export type OrderCommentEntity = {
  __typename?: 'OrderCommentEntity';
  authorName: Scalars['String']['output'];
  comment: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  showOnInvoice?: Maybe<Scalars['Boolean']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  user?: Maybe<UserEntity>;
  uuid: Scalars['String']['output'];
};

export type OrderCommentForCachedStop = {
  __typename?: 'OrderCommentForCachedStop';
  comment: Scalars['String']['output'];
};

export type OrderConnection = {
  __typename?: 'OrderConnection';
  edges: Array<OrderEdge>;
  /** Not cheap to calculate, request with prudence.  Group UUID = invoice UUID */
  groupedCountsByInvoice?: Maybe<Array<GroupedCounts>>;
  pageInfo: PageInfo;
  /** Not cheap to calculate, request with prudence */
  totalCount?: Maybe<Scalars['Int']['output']>;
  /** Not cheap to calculate, request with prudence */
  uuids?: Maybe<Array<Scalars['String']['output']>>;
  /** Version ID for the response */
  versionId?: Maybe<Scalars['Float']['output']>;
};

export type OrderConsigneeSortInput = {
  direction: SortOrder;
  nulls: NullsOrder;
};

/** Methods for order consolidation */
export enum OrderConsolidationMethod {
  BaseOrder = 'BASE_ORDER',
  ByWeight = 'BY_WEIGHT',
  EvenDistribution = 'EVEN_DISTRIBUTION'
}

export enum OrderConsolidationType {
  Consolidated = 'CONSOLIDATED',
  Standard = 'STANDARD'
}

export enum OrderDetailedStatus {
  Attempted = 'ATTEMPTED',
  BillingIssues = 'BILLING_ISSUES',
  Cancelled = 'CANCELLED',
  ChargesFinalized = 'CHARGES_FINALIZED',
  Complete = 'COMPLETE',
  Created = 'CREATED',
  Creating = 'CREATING',
  DeliveryScheduled = 'DELIVERY_SCHEDULED',
  InvoicePosted = 'INVOICE_POSTED',
  InProgress = 'IN_PROGRESS',
  OnHand = 'ON_HAND',
  OnHold = 'ON_HOLD',
  OnInvoice = 'ON_INVOICE',
  Osd = 'OSD',
  OutForDelivery = 'OUT_FOR_DELIVERY',
  OutForPickup = 'OUT_FOR_PICKUP',
  OutForRecovery = 'OUT_FOR_RECOVERY',
  OutForTransfer = 'OUT_FOR_TRANSFER',
  Picked = 'PICKED',
  PickupScheduled = 'PICKUP_SCHEDULED',
  Received = 'RECEIVED',
  ReceivedAtOrigin = 'RECEIVED_AT_ORIGIN',
  RecoveryScheduled = 'RECOVERY_SCHEDULED',
  TransferScheduled = 'TRANSFER_SCHEDULED'
}

export type OrderDocumentInput = {
  bucket: Scalars['String']['input'];
  endOfDayDocumentsProcessingJobUuid: Scalars['String']['input'];
  filename: Scalars['String']['input'];
  filetype: Scalars['String']['input'];
  key: Scalars['String']['input'];
  terminalUuid?: InputMaybe<Scalars['String']['input']>;
  uploadOrdinal?: InputMaybe<Scalars['Int']['input']>;
  uploadedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export enum OrderDocumentType {
  AirWaybill = 'AirWaybill',
  ArrivalNotice = 'ArrivalNotice',
  AuthoSheet = 'AuthoSheet',
  PodReport = 'PodReport'
}

export type OrderEdge = {
  __typename?: 'OrderEdge';
  cursor: Scalars['String']['output'];
  node: OrderEntity;
};

export type OrderEntity = {
  appliedAmount: Scalars['Float']['output'];
  balanceInCents: Scalars['Int']['output'];
  billingPartyContact: CustomerContactEntity;
  billingPartyContactStation?: Maybe<ContactStationEntity>;
  /** @deprecated Use personName */
  callerName?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use personPhoneNumber */
  callerPhoneNumber?: Maybe<Scalars['String']['output']>;
  cancelled?: Maybe<Scalars['DateTime']['output']>;
  /** The chargeable weight is an optional weight value (measured in cubic meters) that can be used in billing calculations for the order. */
  chargeableWeightCubicMeters?: Maybe<Scalars['Volume']['output']>;
  codCheckAmountCents?: Maybe<Scalars['Int']['output']>;
  codCheckNumber?: Maybe<Scalars['String']['output']>;
  company: CompanyEntity;
  consolidatableOrders: ConsolidatableOrdersOutput;
  consolidatedOrders?: Maybe<Array<OrderEntity>>;
  consolidatedShipmentString?: Maybe<Scalars['String']['output']>;
  contact: ContactEntity;
  coverSheetDocumentTypeSequence?: Maybe<CoverSheetDocumentTypeSequenceEntity>;
  createdAt: Scalars['DateTime']['output'];
  createdFromOrderTemplate?: Maybe<OrderEntity>;
  csvOrderImportStatus?: Maybe<CsvOrderImportStatus>;
  /** Total custom charge (accessorial charge) for the order in dollars */
  customChargeRevenue: Scalars['Float']['output'];
  /** Each custom charge (accessorial charge) itemized */
  customCharges: Array<CustomChargeEntity>;
  dateMarkedLoaded?: Maybe<Scalars['DateTime']['output']>;
  dateMarkedOnHand?: Maybe<Scalars['DateTime']['output']>;
  dateMarkedReceivedAtOrigin?: Maybe<Scalars['DateTime']['output']>;
  deletedAutoAppliedAccessorials: Array<AccessorialUnion>;
  detailedStatus?: Maybe<Scalars['String']['output']>;
  detailedStatusV2?: Maybe<OrderDetailedStatus>;
  dimWeight: Scalars['Float']['output'];
  documents: Array<DocumentEntity>;
  driverQualifications: Array<DriverQualificationEntity>;
  driverSettlementTotal: Scalars['Float']['output'];
  ediReceivedScac?: Maybe<Scalars['String']['output']>;
  ediTransactions: Array<EdiTransactionEntity>;
  emergencyResponseNumber?: Maybe<Scalars['String']['output']>;
  enableLineHaul: Scalars['Boolean']['output'];
  endStop?: Maybe<StopEntity>;
  externalNotes?: Maybe<Scalars['String']['output']>;
  fields: StandardOrderFieldsEntity;
  /** Total freight charge for the order in dollars */
  freightChargeRevenue: Scalars['Float']['output'];
  /** Total fuel charge for the order in dollars */
  fuelChargeRevenue: Scalars['Float']['output'];
  fulfillmentType?: Maybe<FulfillmentType>;
  hasDriverPod: Scalars['Boolean']['output'];
  hasDriverUploadedDocument: Scalars['Boolean']['output'];
  hasEdiCancellation: Scalars['Boolean']['output'];
  hasNoneOrCompletedInboundStop: Scalars['Boolean']['output'];
  hazmat?: Maybe<Scalars['Boolean']['output']>;
  hazmatClass?: Maybe<HazmatClass>;
  hazmatDescription?: Maybe<Scalars['String']['output']>;
  holdReason?: Maybe<HoldReasonEntity>;
  inBond?: Maybe<Scalars['Boolean']['output']>;
  inboundPaperwork: OrderPaperworkEntity;
  inboundShipment?: Maybe<ShipmentEntity>;
  invoice?: Maybe<InvoiceEntity>;
  isCollectOnDelivery?: Maybe<Scalars['Boolean']['output']>;
  isCrossDock?: Maybe<Scalars['Boolean']['output']>;
  /** Filters out draft and template orders */
  isDraftOrder: Scalars['Boolean']['output'];
  isOverdue: Scalars['Boolean']['output'];
  isReweighed?: Maybe<Scalars['Boolean']['output']>;
  issueReason?: Maybe<Scalars['String']['output']>;
  itTeNumber?: Maybe<Scalars['String']['output']>;
  lastCompletedLineHaulSegment?: Maybe<LineHaulSegmentEntity>;
  lastUpdatedByUser?: Maybe<UserEntity>;
  lineHaulCompletedDate: Scalars['DateTime']['output'];
  lineHaulLane?: Maybe<LineHaulLaneEntity>;
  lineHaulServiceDisplayString: Scalars['String']['output'];
  lineHaulShipment?: Maybe<ShipmentEntity>;
  /** The line haul events associated with an order, such as every stop at a terminal. This is the order’s own timeline, not an audit log of user actions or changes. */
  lineHaulTimeline: Array<OrderLineHaulTimelineEventEntity>;
  lockSecondaryRefNumber: Scalars['Boolean']['output'];
  /** @deprecated Use paperwork.missingDocuments instead */
  missingDocuments: Array<DocumentType>;
  name: Scalars['String']['output'];
  notes: Scalars['String']['output'];
  numPackagesOnHand: Scalars['Float']['output'];
  onHand?: Maybe<Scalars['Boolean']['output']>;
  onHold: Scalars['Boolean']['output'];
  orderChargesShipment?: Maybe<ShipmentEntity>;
  orderComments: Array<OrderCommentEntity>;
  orderConsolidationType: OrderConsolidationType;
  orderEvents: Array<OrderEventEntity>;
  orderInvoiceByDate?: Maybe<Scalars['DateTime']['output']>;
  orderPaymentMappings: Array<PaymentToOrderMappingEntity>;
  orderSegmentType: OrderSegmentType;
  /** Orders that were prorated with (but not including) this order */
  ordersProratedWith?: Maybe<Array<OrderEntity>>;
  ordersWithSameBillOfLadingNumber: Array<OrderEntity>;
  ordersWithSameBillOfLadingNumberForReviewOrders?: Maybe<Array<StandardOrderEntity>>;
  ordinal: Scalars['Int']['output'];
  osAndD: Scalars['Boolean']['output'];
  osd?: Maybe<Scalars['Boolean']['output']>;
  osdReason?: Maybe<Scalars['String']['output']>;
  outboundPaperwork: OrderPaperworkEntity;
  /** The scans out of the last terminal (if multi-terminal and line haul), or simply departure scans corresponding to outbound delivery */
  outboundScans: Array<ScanEntity>;
  outboundShipment?: Maybe<ShipmentEntity>;
  packageCount: Scalars['Float']['output'];
  packageGroup?: Maybe<PackageGroup>;
  packages: Array<PackageEntity>;
  paperwork: OrderPaperworkEntity;
  paymentMethod?: Maybe<PaymentMethod>;
  personEmail?: Maybe<Scalars['String']['output']>;
  personName?: Maybe<Scalars['String']['output']>;
  personPhoneNumber?: Maybe<Scalars['String']['output']>;
  pickedDate?: Maybe<Scalars['DateTime']['output']>;
  pieceCount?: Maybe<Scalars['Int']['output']>;
  pieceCountFromPackages: Scalars['Float']['output'];
  pieces: Array<PieceEntity>;
  piecesDelivered: PiecesDeliveredEntity;
  piecesLoaded?: Maybe<Scalars['Int']['output']>;
  piecesPicked?: Maybe<Scalars['Int']['output']>;
  postedAmountCents?: Maybe<Scalars['Int']['output']>;
  quaternaryRefNumber?: Maybe<Scalars['String']['output']>;
  quinaryRefNumber?: Maybe<Scalars['String']['output']>;
  quote?: Maybe<QuoteEntity>;
  receivedDate?: Maybe<Scalars['DateTime']['output']>;
  recurringOrderFrequency?: Maybe<RecurringOrderFrequencyEntity>;
  refNumbers: Array<Scalars['String']['output']>;
  refusedBy?: Maybe<Scalars['String']['output']>;
  refusedDate?: Maybe<Scalars['DateTime']['output']>;
  requiresPlacard?: Maybe<Scalars['Boolean']['output']>;
  run?: Maybe<RunEntity>;
  scannedOrderResult?: Maybe<ScannedOrderResultEntity>;
  /** A field that represents a concatenation of all fields on the order that we want to search by. */
  searchText?: Maybe<Scalars['String']['output']>;
  secondaryRefNumber?: Maybe<Scalars['String']['output']>;
  service?: Maybe<ServiceEntity>;
  shipments: Array<ShipmentEntity>;
  shouldBillIndividually: Scalars['Boolean']['output'];
  source: OrderSource;
  standardOrderFields: StandardOrderFieldsEntity;
  startStop?: Maybe<StopEntity>;
  status: OrderStatus;
  tags: Array<TagEntity>;
  tertiaryRefNumber?: Maybe<Scalars['String']['output']>;
  thirdPartyBrokers: Array<ThirdPartyBrokerEntity>;
  totalAmountCents?: Maybe<Scalars['Int']['output']>;
  /** The total charges for the order in dollars */
  totalCharge: Scalars['Float']['output'];
  totalCustomChargesAmount: Scalars['Float']['output'];
  totalFreightChargesAmount: Scalars['Float']['output'];
  totalFuelChargesAmount: Scalars['Float']['output'];
  totalSkids?: Maybe<Scalars['Int']['output']>;
  unNumber?: Maybe<Scalars['String']['output']>;
  upcomingLineHaulSegment?: Maybe<LineHaulSegmentEntity>;
  updatedAt: Scalars['DateTime']['output'];
  uuid: Scalars['String']['output'];
  vehicleType?: Maybe<VehicleTypeEntity>;
  warehouse?: Maybe<WarehouseEntity>;
  weight: Scalars['Float']['output'];
};

export type OrderEventEntity = {
  __typename?: 'OrderEventEntity';
  createdAt: Scalars['DateTime']['output'];
  eventType: OrderEventType;
  ignoreSnapshot: Scalars['Boolean']['output'];
  message: Scalars['String']['output'];
  order?: Maybe<OrderEntity>;
  snapshot?: Maybe<Scalars['String']['output']>;
  sourceDriver?: Maybe<DriverEntity>;
  sourceEdiTransaction?: Maybe<EdiTransactionEntity>;
  sourcePicklist?: Maybe<PicklistEntity>;
  sourceSftpUpload?: Maybe<SftpUploadEntity>;
  sourceType: OrderEventSourceType;
  sourceUser?: Maybe<UserEntity>;
  sourceWarehouseEmployee?: Maybe<WarehouseEmployeeEntity>;
  targetContactPerson?: Maybe<ContactPersonEntity>;
  targetDocument?: Maybe<DocumentEntity>;
  targetDriver?: Maybe<DriverEntity>;
  targetEmail?: Maybe<Scalars['String']['output']>;
  targetInvoice?: Maybe<InvoiceEntity>;
  targetOrderTotalAfterConsolidation?: Maybe<Scalars['Float']['output']>;
  targetOrderTotalBeforeConsolidation?: Maybe<Scalars['Float']['output']>;
  targetPhoneNumber?: Maybe<Scalars['String']['output']>;
  targetRoute?: Maybe<RouteEntity>;
  targetSettlementBill?: Maybe<DriverSettlementBillEntity>;
  targetShipment?: Maybe<ShipmentEntity>;
  targetShipmentSubscriber?: Maybe<ShipmentSubscriberEntity>;
  targetStop?: Maybe<StopEntity>;
  targetType: OrderEventTargetType;
  updatedAt: Scalars['DateTime']['output'];
  uuid: Scalars['String']['output'];
};

export type OrderEventNotificationSubscriptionEntity = {
  __typename?: 'OrderEventNotificationSubscriptionEntity';
  channel: NotificationChannel;
  eventType: OrderEventNotificationType;
  id: Scalars['String']['output'];
  subscriberType: NotificationSubscriberType;
};

export type OrderEventNotificationSubscriptionInput = {
  channel: NotificationChannel;
  eventType: OrderEventNotificationType;
  subscriberType: NotificationSubscriberType;
};

export enum OrderEventNotificationType {
  DeliveryCompleted = 'DELIVERY_COMPLETED',
  DeliveryNextStop = 'DELIVERY_NEXT_STOP',
  OrderCreated = 'ORDER_CREATED',
  PickupCompleted = 'PICKUP_COMPLETED',
  PickupNextStop = 'PICKUP_NEXT_STOP'
}

export type OrderEventSnapshotCreateInput = {
  orderUuid: Scalars['String']['input'];
  previousSnapshot?: InputMaybe<Scalars['String']['input']>;
  snapshot: Scalars['String']['input'];
};

export enum OrderEventSourceType {
  Api = 'API',
  Driver = 'DRIVER',
  EdiTransaction = 'EDI_TRANSACTION',
  Picklist = 'PICKLIST',
  SftpUpload = 'SFTP_UPLOAD',
  System = 'SYSTEM',
  ThirdPartyUser = 'THIRD_PARTY_USER',
  User = 'USER',
  WarehouseEmployee = 'WAREHOUSE_EMPLOYEE'
}

export enum OrderEventTargetType {
  ContactPerson = 'CONTACT_PERSON',
  CustomerContact = 'CUSTOMER_CONTACT',
  Document = 'DOCUMENT',
  Driver = 'DRIVER',
  Invoice = 'INVOICE',
  Order = 'ORDER',
  ShipmentAndInvoice = 'SHIPMENT_AND_INVOICE',
  ShipmentSubscriber = 'SHIPMENT_SUBSCRIBER',
  Stop = 'STOP',
  StopAndRoute = 'STOP_AND_ROUTE',
  StorageOrder = 'STORAGE_ORDER'
}

export enum OrderEventType {
  ApiOrderApproved = 'API_ORDER_APPROVED',
  Call = 'CALL',
  CustomerPortalOrderApproved = 'CUSTOMER_PORTAL_ORDER_APPROVED',
  CustomerPortalOrderRejected = 'CUSTOMER_PORTAL_ORDER_REJECTED',
  DocumentScanningOrderApproved = 'DOCUMENT_SCANNING_ORDER_APPROVED',
  DocumentScanningOrderRejected = 'DOCUMENT_SCANNING_ORDER_REJECTED',
  DocumentUploaded = 'DOCUMENT_UPLOADED',
  Edi = 'EDI',
  EdiOrderApproved = 'EDI_ORDER_APPROVED',
  NextStopPendingNotificationEmail = 'NEXT_STOP_PENDING_NOTIFICATION_EMAIL',
  NextStopPendingNotificationText = 'NEXT_STOP_PENDING_NOTIFICATION_TEXT',
  OrderCancelled = 'ORDER_CANCELLED',
  OrderCompleted = 'ORDER_COMPLETED',
  OrderConsolidated = 'ORDER_CONSOLIDATED',
  OrderCreated = 'ORDER_CREATED',
  OrderCreatedNotificationEmail = 'ORDER_CREATED_NOTIFICATION_EMAIL',
  OrderCreatedNotificationText = 'ORDER_CREATED_NOTIFICATION_TEXT',
  OrderFinalized = 'ORDER_FINALIZED',
  OrderHasIssue = 'ORDER_HAS_ISSUE',
  OrderHoldRemoved = 'ORDER_HOLD_REMOVED',
  OrderLoaded = 'ORDER_LOADED',
  OrderMarkedNotCompleted = 'ORDER_MARKED_NOT_COMPLETED',
  OrderMarkedNotOnHand = 'ORDER_MARKED_NOT_ON_HAND',
  OrderMarkedNotOsd = 'ORDER_MARKED_NOT_OSD',
  OrderMarkedNotReceivedAtOrigin = 'ORDER_MARKED_NOT_RECEIVED_AT_ORIGIN',
  OrderMarkedOnHold = 'ORDER_MARKED_ON_HOLD',
  OrderMarkedOsd = 'ORDER_MARKED_OSD',
  OrderNotReadyToInvoice = 'ORDER_NOT_READY_TO_INVOICE',
  OrderOnHand = 'ORDER_ON_HAND',
  OrderPicked = 'ORDER_PICKED',
  OrderPiecesLoadedUpdated = 'ORDER_PIECES_LOADED_UPDATED',
  OrderPiecesPickedUpdated = 'ORDER_PIECES_PICKED_UPDATED',
  OrderPieceCountUpdated = 'ORDER_PIECE_COUNT_UPDATED',
  OrderReceivedAtOrigin = 'ORDER_RECEIVED_AT_ORIGIN',
  OrderRefused = 'ORDER_REFUSED',
  OrderScanned = 'ORDER_SCANNED',
  OrderSnapshot = 'ORDER_SNAPSHOT',
  OrderUncancelled = 'ORDER_UNCANCELLED',
  OrderUnloaded = 'ORDER_UNLOADED',
  OrderUpdated = 'ORDER_UPDATED',
  OrderUpdateEmailSent = 'ORDER_UPDATE_EMAIL_SENT',
  PieceScanned = 'PIECE_SCANNED',
  QuoteApproved = 'QUOTE_APPROVED',
  ReceiptCreated = 'RECEIPT_CREATED',
  SettlementBillFinalized = 'SETTLEMENT_BILL_FINALIZED',
  SettlementBillLineItemAdded = 'SETTLEMENT_BILL_LINE_ITEM_ADDED',
  SettlementBillLineItemAddedToBill = 'SETTLEMENT_BILL_LINE_ITEM_ADDED_TO_BILL',
  SettlementBillLineItemRemoved = 'SETTLEMENT_BILL_LINE_ITEM_REMOVED',
  SettlementBillLineItemRemovedFromBill = 'SETTLEMENT_BILL_LINE_ITEM_REMOVED_FROM_BILL',
  SettlementBillUnfinalized = 'SETTLEMENT_BILL_UNFINALIZED',
  SetPackageLocation = 'SET_PACKAGE_LOCATION',
  SftpDocumentUploaded = 'SFTP_DOCUMENT_UPLOADED',
  ShipmentAddedToInvoice = 'SHIPMENT_ADDED_TO_INVOICE',
  StopAddedToRoute = 'STOP_ADDED_TO_ROUTE',
  StopAppointmentConfirmed = 'STOP_APPOINTMENT_CONFIRMED',
  StopAppointmentSchedulingOptionsCall = 'STOP_APPOINTMENT_SCHEDULING_OPTIONS_CALL',
  StopAppointmentSchedulingOptionsTextMessage = 'STOP_APPOINTMENT_SCHEDULING_OPTIONS_TEXT_MESSAGE',
  StopAppointmentUnconfirmed = 'STOP_APPOINTMENT_UNCONFIRMED',
  StopArrived = 'STOP_ARRIVED',
  StopAttempted = 'STOP_ATTEMPTED',
  StopAttemptRemoved = 'STOP_ATTEMPT_REMOVED',
  StopCompleted = 'STOP_COMPLETED',
  StopCompletedNotificationEmail = 'STOP_COMPLETED_NOTIFICATION_EMAIL',
  StopCompletedNotificationText = 'STOP_COMPLETED_NOTIFICATION_TEXT',
  StopPaperworkMarkedComplete = 'STOP_PAPERWORK_MARKED_COMPLETE',
  StopPaperworkMarkedIncomplete = 'STOP_PAPERWORK_MARKED_INCOMPLETE',
  StopRemovedFromRoute = 'STOP_REMOVED_FROM_ROUTE',
  StorageOrderInventoryDeduction = 'STORAGE_ORDER_INVENTORY_DEDUCTION',
  TextMessage = 'TEXT_MESSAGE'
}

export type OrderForCachedStop = {
  __typename?: 'OrderForCachedStop';
  businessDivisionName?: Maybe<Scalars['String']['output']>;
  businessDivisionUuid?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use personName */
  callerName?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use personPhoneNumber */
  callerPhoneNumber?: Maybe<Scalars['String']['output']>;
  contactName: Scalars['String']['output'];
  contactUuid: Scalars['String']['output'];
  dateMarkedOnHand?: Maybe<Scalars['DateTime']['output']>;
  fulfillmentType?: Maybe<FulfillmentType>;
  inboundCity?: Maybe<Scalars['String']['output']>;
  inboundName?: Maybe<Scalars['String']['output']>;
  /** Contains inbound documents grouped by type */
  inboundPaperwork?: Maybe<OrderPaperworkEntity>;
  inboundStopType?: Maybe<PickupOrDelivery>;
  inboundZip?: Maybe<Scalars['String']['output']>;
  masterAirwayBillOfLadingNumber?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  orderComments: Array<OrderCommentForCachedStop>;
  orderSegmentType: OrderSegmentType;
  outboundCity?: Maybe<Scalars['String']['output']>;
  outboundName?: Maybe<Scalars['String']['output']>;
  /** Contains outbound documents grouped by type */
  outboundPaperwork?: Maybe<OrderPaperworkEntity>;
  outboundStopType?: Maybe<PickupOrDelivery>;
  outboundZip?: Maybe<Scalars['String']['output']>;
  packages: Array<PackageForCachedStop>;
  personEmail?: Maybe<Scalars['String']['output']>;
  personName?: Maybe<Scalars['String']['output']>;
  personPhoneNumber?: Maybe<Scalars['String']['output']>;
  pickedDate?: Maybe<Scalars['DateTime']['output']>;
  receivedDate?: Maybe<Scalars['DateTime']['output']>;
  refNumbers: Array<Scalars['String']['output']>;
  serviceName?: Maybe<Scalars['String']['output']>;
  serviceUuid?: Maybe<Scalars['String']['output']>;
  shipperBillOfLadingNumber?: Maybe<Scalars['String']['output']>;
  tags: Array<TagEntity>;
  uuid: Scalars['String']['output'];
  vehicleTypeName?: Maybe<Scalars['String']['output']>;
  warehouseUuid?: Maybe<Scalars['String']['output']>;
};

/** An order and its fields returned as part of an invoice in the open invoice report */
export type OrderForOpenInvoiceReportEntity = {
  __typename?: 'OrderForOpenInvoiceReportEntity';
  addressName?: Maybe<Scalars['String']['output']>;
  destinationTerminalCode?: Maybe<Scalars['String']['output']>;
  masterAirwayBillOfLadingNumber?: Maybe<Scalars['String']['output']>;
  orderBalanceCents: Scalars['Float']['output'];
  orderName: Scalars['String']['output'];
  orderTotalCents: Scalars['Float']['output'];
  orderUuid: Scalars['String']['output'];
  originTerminalCode?: Maybe<Scalars['String']['output']>;
  pieces: Scalars['Float']['output'];
  refNumbers?: Maybe<Array<Scalars['String']['output']>>;
  serviceDate?: Maybe<Scalars['DateTime']['output']>;
  serviceDateV2?: Maybe<PlainDate>;
  shipperBillOfLadingNumber?: Maybe<Scalars['String']['output']>;
  weight: Scalars['Float']['output'];
};

export type OrderForPaymentApplicationReportEntity = {
  __typename?: 'OrderForPaymentApplicationReportEntity';
  /** The amount applied to this order by this payment in dollars */
  appliedAmount: Scalars['Float']['output'];
  inboundAddressName?: Maybe<Scalars['String']['output']>;
  /** The invoice total in cents */
  invoiceBalance?: Maybe<Scalars['Float']['output']>;
  invoiceContactDisplayName?: Maybe<Scalars['String']['output']>;
  invoiceDate?: Maybe<Scalars['DateTime']['output']>;
  invoiceJournalNumber?: Maybe<Scalars['Float']['output']>;
  invoiceName?: Maybe<Scalars['String']['output']>;
  /** The invoice total in dollars */
  invoiceTotal?: Maybe<Scalars['Float']['output']>;
  invoiceUuid?: Maybe<Scalars['String']['output']>;
  masterAirwayBillOfLadingNumber?: Maybe<Scalars['String']['output']>;
  orderBalance: Scalars['Float']['output'];
  orderName: Scalars['String']['output'];
  orderTotal: Scalars['Float']['output'];
  orderUuid: Scalars['String']['output'];
  outboundAddressName?: Maybe<Scalars['String']['output']>;
  pieces: Scalars['Float']['output'];
  refNumbers?: Maybe<Array<Scalars['String']['output']>>;
  shipperBillOfLadingNumber?: Maybe<Scalars['String']['output']>;
  weight: Scalars['Float']['output'];
};

export type OrderForPaymentJournalReportEntity = {
  __typename?: 'OrderForPaymentJournalReportEntity';
  /** The amount applied to this order by this payment in dollars */
  appliedAmountDollars: Scalars['Float']['output'];
  invoiceCustomerName?: Maybe<Scalars['String']['output']>;
  invoiceDate?: Maybe<Scalars['DateTime']['output']>;
  invoiceJournalNumber?: Maybe<Scalars['Float']['output']>;
  invoiceName?: Maybe<Scalars['String']['output']>;
  invoiceUuid?: Maybe<Scalars['String']['output']>;
  orderName: Scalars['String']['output'];
  orderUuid: Scalars['String']['output'];
  shipperBillOfLadingNumber?: Maybe<Scalars['String']['output']>;
};

export type OrderFormFieldsEntity = {
  __typename?: 'OrderFormFieldsEntity';
  onePackageRequired: Scalars['Boolean']['output'];
  onePackageWeightRequired: Scalars['Boolean']['output'];
  packagePiecesRequired: Scalars['Boolean']['output'];
  packageWeightRequired: Scalars['Boolean']['output'];
};

export enum OrderIdentifier {
  OrderName = 'ORDER_NAME',
  ShipperBillOfLadingNumber = 'SHIPPER_BILL_OF_LADING_NUMBER'
}

export type OrderImportConfigurationCreateInput = {
  alwaysCreateDummyOrderCharge: Scalars['Boolean']['input'];
};

export type OrderImportConfigurationEntity = {
  __typename?: 'OrderImportConfigurationEntity';
  alwaysCreateDummyOrderCharge: Scalars['Boolean']['output'];
  importedOrderTypeMappings: Array<ImportedOrderTypeMappingEntity>;
  uuid: Scalars['String']['output'];
};

export type OrderImportConfigurationUpdateInput = {
  alwaysCreateDummyOrderCharge: Scalars['Boolean']['input'];
  uuid: Scalars['String']['input'];
};

export type OrderLineHaulLaneEntity = {
  __typename?: 'OrderLineHaulLaneEntity';
  destinationTerminalCode: Scalars['String']['output'];
  laneUuid: Scalars['String']['output'];
  originTerminalCode: Scalars['String']['output'];
};

export type OrderLineHaulSegmentConnection = {
  __typename?: 'OrderLineHaulSegmentConnection';
  edges: Array<OrderLineHaulSegmentEdge>;
  pageInfo: PageInfo;
  /** Not cheap to calculate, request with prudence */
  totalCount?: Maybe<Scalars['Int']['output']>;
  /** Not cheap to calculate, request with prudence */
  uuids?: Maybe<Array<Scalars['String']['output']>>;
};

export type OrderLineHaulSegmentCreateInput = {
  lineHaulSegmentUuid: Scalars['String']['input'];
  orderUuid: Scalars['String']['input'];
};

export type OrderLineHaulSegmentEdge = {
  __typename?: 'OrderLineHaulSegmentEdge';
  cursor: Scalars['String']['output'];
  node: OrderLineHaulSegmentEntity;
};

export type OrderLineHaulSegmentEntity = {
  __typename?: 'OrderLineHaulSegmentEntity';
  arrivalScans: Array<ScanEntity>;
  arrivedAt?: Maybe<Scalars['DateTime']['output']>;
  departureScans: Array<ScanEntity>;
  order: OrderEntity;
  priorOrderLineHaulSegment?: Maybe<OrderLineHaulSegmentEntity>;
  segment: LineHaulSegmentEntity;
  uuid: Scalars['String']['output'];
};

export type OrderLineHaulSegmentOutput = {
  __typename?: 'OrderLineHaulSegmentOutput';
  edges: Array<OrderLineHaulSegmentEntity>;
  /** Not cheap to calculate, request with prudence */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export enum OrderLineHaulSegmentSortFields {
  CustomerName = 'CUSTOMER_NAME',
  ServiceDate = 'SERVICE_DATE'
}

export type OrderLineHaulSegmentUpdateInput = {
  arrivedAt?: InputMaybe<Scalars['DateTime']['input']>;
  lineHaulSegmentUuid?: InputMaybe<Scalars['String']['input']>;
  orderUuid?: InputMaybe<Scalars['String']['input']>;
  uuid: Scalars['String']['input'];
};

/** An event in the line haul timeline of an order. */
export type OrderLineHaulTimelineEventEntity = {
  __typename?: 'OrderLineHaulTimelineEventEntity';
  arrivalScans: Array<ScanEntity>;
  departingManifest?: Maybe<LineHaulManifestEntity>;
  departureScans: Array<ScanEntity>;
  markedArrivedAt?: Maybe<Scalars['DateTime']['output']>;
  terminal: TerminalEntity;
};

export enum OrderNamingScheme {
  CompanyOrdinal = 'COMPANY_ORDINAL',
  ContactOrdinal = 'CONTACT_ORDINAL'
}

export enum OrderPdfColumnMapping {
  ClientReferenceNumber = 'CLIENT_REFERENCE_NUMBER'
}

/** Data about an order's paperwork, e.g. whether all required documents are attached */
export type OrderPaperworkEntity = {
  __typename?: 'OrderPaperworkEntity';
  alerts?: Maybe<Array<DocumentType>>;
  /** All documents uploaded to the order */
  attachedDocuments?: Maybe<Array<DocumentType>>;
  /** Document types missing from the order, required by the company's or contact's defaultInvoiceDocumentsRequired */
  missingDocuments?: Maybe<Array<DocumentType>>;
  other?: Maybe<Array<DocumentType>>;
  /**
   * Whether all documents required for a contact are attached.
   *       Can be manually overridden (see paperworkMarkedCompleteOverride).
   *       If no documents are required, this is false until overridden.
   */
  paperworkComplete: Scalars['Boolean']['output'];
  /** Whether this order's paperwork has been manually marked complete/incomplete. Null if not overridden */
  paperworkMarkedCompleteOverride?: Maybe<Scalars['Boolean']['output']>;
  photos?: Maybe<Array<DocumentType>>;
  proofOfDeliveryOrPickupReadyToSign?: Maybe<Array<DocumentType>>;
  proofOfDeliveryOrPickupSigned?: Maybe<Array<DocumentType>>;
};

export type OrderReportArgs = {
  businessDivisionUuid?: InputMaybe<Scalars['String']['input']>;
  contactUuid?: InputMaybe<Scalars['String']['input']>;
  driverUuid?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  excludeMigratedOrders?: InputMaybe<Scalars['Boolean']['input']>;
  lastNumberOfDays?: InputMaybe<Scalars['Float']['input']>;
  lastNumberOfMonths?: InputMaybe<Scalars['Float']['input']>;
  lastNumberOfWeeks?: InputMaybe<Scalars['Float']['input']>;
  orderStatuses: Array<OrderStatus>;
  reportAggregationPeriod: ReportAggregationPeriod;
  reportRevenueType?: InputMaybe<ReportRevenueType>;
  reportStatistics: Array<ReportStatistic>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  stopTypes: Array<PickupOrDelivery>;
  terminalUuid?: InputMaybe<Scalars['String']['input']>;
};

export type OrderReportBucketEntity = {
  __typename?: 'OrderReportBucketEntity';
  customChargeRevenue: Scalars['Float']['output'];
  deliveryRevenue: Scalars['Float']['output'];
  endDate: Scalars['DateTime']['output'];
  freightRevenue: Scalars['Float']['output'];
  fuelRevenue: Scalars['Float']['output'];
  lineHaulRevenue: Scalars['Float']['output'];
  numberOfOrders: Scalars['Float']['output'];
  numberOfPackages: Scalars['Float']['output'];
  pickupRevenue: Scalars['Float']['output'];
  recoveryRevenue: Scalars['Float']['output'];
  specialRevenue: Scalars['Float']['output'];
  startDate: Scalars['DateTime']['output'];
  surchargeRevenue: Scalars['Float']['output'];
  totalRevenue: Scalars['Float']['output'];
  totalWeight: Scalars['Float']['output'];
  transferRevenue: Scalars['Float']['output'];
};

export type OrderRevenueReportInput = {
  /** forwards pagination cursor */
  after?: InputMaybe<Scalars['String']['input']>;
  /** backwards pagination cursor */
  before?: InputMaybe<Scalars['String']['input']>;
  contactUuid?: InputMaybe<Scalars['String']['input']>;
  /** forwards pagination count, provide this on initial query */
  first?: InputMaybe<Scalars['Int']['input']>;
  isLineHaul?: InputMaybe<Scalars['Boolean']['input']>;
  /** backwards pagination count */
  last?: InputMaybe<Scalars['Int']['input']>;
  onlyCompletedOrders?: InputMaybe<Scalars['Boolean']['input']>;
  serviceDateFilter?: InputMaybe<DateFilterV2>;
  serviceDateFilters?: InputMaybe<DateFilterStartEnd>;
  terminalUuid?: InputMaybe<Scalars['String']['input']>;
};

export enum OrderSegmentType {
  Cartage = 'CARTAGE',
  Courier = 'COURIER'
}

export type OrderServiceDateSortInput = {
  direction: SortOrder;
  nulls: NullsOrder;
};

export type OrderSort = {
  sortBy: OrderTableField;
  sortDirection: OrderSortDirection;
};

export enum OrderSortDirection {
  Asc = 'asc',
  Desc = 'desc'
}

export type OrderSortV2 = {
  completedAtSortInput?: InputMaybe<CompletedAtSortInput>;
  customerNameSortInput?: InputMaybe<CustomerNameSortInput>;
  dateMarkedOnHandSortInput?: InputMaybe<DateMarkedOnHandSortInput>;
  destinationDetailsSortInput?: InputMaybe<DestinationDetailsSortInput>;
  destinationTerminalSortInput?: InputMaybe<DestinationTerminalSortInput>;
  dimWeightSortInput?: InputMaybe<DimWeightSortInput>;
  fieldName: OrderTableField;
  inBondSortInput?: InputMaybe<InBondSortInput>;
  inboundAddressNameSortInput?: InputMaybe<InboundAddressNameSortInput>;
  inboundAddressSortInput?: InputMaybe<InboundAddressSortInput>;
  inboundCityNameSortInput?: InputMaybe<InboundCityNameSortInput>;
  inboundCompletedDateSortInput?: InputMaybe<InboundCompletedDateSortInput>;
  inboundDriverNameSortInput?: InputMaybe<InboundDriverNameSortInput>;
  inboundRouteDateSortInput?: InputMaybe<InboundRouteDateSortInput>;
  inboundRouteNameSortInput?: InputMaybe<InboundRouteNameSortInput>;
  inboundServiceDateSortInput?: InputMaybe<InboundServiceDateSortInput>;
  inboundZipcodeSortInput?: InputMaybe<InboundZipcodeSortInput>;
  isReweighedSortInput?: InputMaybe<IsReweighedSortInput>;
  mawbSortInput?: InputMaybe<MawbSortInput>;
  nameSortInput?: InputMaybe<NameSortInput>;
  orderConsigneeSortInput?: InputMaybe<OrderConsigneeSortInput>;
  orderServiceDateSortInput?: InputMaybe<OrderServiceDateSortInput>;
  orderSourceSortInput?: InputMaybe<OrderSourceSortInput>;
  originTerminalSortInput?: InputMaybe<OriginTerminalSortInput>;
  outboundAddressNameSortInput?: InputMaybe<OutboundAddressNameSortInput>;
  outboundAddressSortInput?: InputMaybe<OutboundAddressSortInput>;
  outboundCityNameSortInput?: InputMaybe<OutboundCityNameSortInput>;
  outboundCompletedDateSortInput?: InputMaybe<OutboundCompletedDateSortInput>;
  outboundDriverNameSortInput?: InputMaybe<OutboundDriverNameSortInput>;
  outboundMethodSortInput?: InputMaybe<OutboundMethodSortInput>;
  outboundRouteDateSortInput?: InputMaybe<OutboundRouteDateSortInput>;
  outboundRouteNameSortInput?: InputMaybe<OutboundRouteNameSortInput>;
  outboundServiceDateSortInput?: InputMaybe<OutboundServiceDateSortInput>;
  outboundZipcodeSortInput?: InputMaybe<OutboundZipcodeSortInput>;
  pieceCountSortInput?: InputMaybe<PieceCountSortInput>;
  secondaryRefNumberSortInput?: InputMaybe<SecondaryRefNumberSortInput>;
  shipperBillOfLadingNumberSortInput?: InputMaybe<ShipperBillOfLadingNumberSortInput>;
  totalPackageWeightSortInput?: InputMaybe<TotalPackageWeightSortInput>;
  totalSkidsSortInput?: InputMaybe<TotalSkidsSortInput>;
};

export enum OrderSource {
  Api = 'API',
  Consolidation = 'CONSOLIDATION',
  CsvImport = 'CSV_IMPORT',
  CustomerPortal = 'CUSTOMER_PORTAL',
  DocumentScanning = 'DOCUMENT_SCANNING',
  Edi = 'EDI',
  FromTemplate = 'FROM_TEMPLATE',
  IsTemplate = 'IS_TEMPLATE',
  ManuallyEntered = 'MANUALLY_ENTERED',
  Migrated = 'MIGRATED',
  Quote = 'QUOTE',
  Rebilled = 'REBILLED'
}

/** A filter object that is used to filter the order source enum field. Each field in the filter object represents an operator. If there is more than one non-null field passed into the filter object, the condition will be a conjunction of the non-null field operator */
export type OrderSourceFilter = {
  /** Filters for records where the relevant order source field is equal to the provided order source value */
  eq?: InputMaybe<OrderSource>;
  /** Filters for records where the relevant order source field is in the provided order source values */
  in?: InputMaybe<Array<OrderSource>>;
  /** Filters for records where the relevant order source field is not equal to the provided order source value */
  neq?: InputMaybe<OrderSource>;
  /** Filters for records where the relevant order source field is not in the provided order source values */
  nin?: InputMaybe<Array<OrderSource>>;
};

export type OrderSourceSortInput = {
  direction: SortOrder;
  nulls: NullsOrder;
};

export enum OrderStatus {
  Cancelled = 'CANCELLED',
  Created = 'CREATED',
  Delivered = 'DELIVERED',
  Finalized = 'FINALIZED',
  HasIssue = 'HAS_ISSUE',
  Invoiced = 'INVOICED',
  InProgress = 'IN_PROGRESS',
  OnHold = 'ON_HOLD'
}

/** A filter object that is used to filter the order status enum field. Each field in the filter object represents an operator. If there is more than one non-null field passed into the filter object, the condition will be a conjunction of the non-null field operator */
export type OrderStatusFilter = {
  /** Filters for records where the relevant order status field is equal to the provided order status value */
  eq?: InputMaybe<OrderStatus>;
  /** Filters for records where the relevant order status field is in the provided order status values */
  in?: InputMaybe<Array<OrderStatus>>;
  /** Filters for records where the relevant order status field is not equal to the provided order status value */
  neq?: InputMaybe<OrderStatus>;
  /** Filters for records where the relevant order status field is not in the provided order status values */
  nin?: InputMaybe<Array<OrderStatus>>;
};

export enum OrderStatusFilterType {
  Equals = 'EQUALS',
  NotEquals = 'NOT_EQUALS'
}

export type OrderTableCustomChargeFieldEntity = {
  __typename?: 'OrderTableCustomChargeFieldEntity';
  /** The billing method of the custom charge. */
  billingMethod: CustomChargeBillingMethod;
  /** The name of the custom charge. */
  name: Scalars['String']['output'];
  /** The total for the custom charge in dollars */
  total: Scalars['Float']['output'];
};

export enum OrderTableField {
  AdditionalCharges = 'ADDITIONAL_CHARGES',
  Attempted = 'ATTEMPTED',
  BillingReviewStatus = 'BILLING_REVIEW_STATUS',
  BillOfLadingNumber = 'BILL_OF_LADING_NUMBER',
  BusinessDivision = 'BUSINESS_DIVISION',
  Charges = 'CHARGES',
  CityName = 'CITY_NAME',
  Company = 'COMPANY',
  CompletedAt = 'COMPLETED_AT',
  ContactInformation = 'CONTACT_INFORMATION',
  ContactName = 'CONTACT_NAME',
  CreatedAt = 'CREATED_AT',
  CustomerName = 'CUSTOMER_NAME',
  DestinationDetails = 'DESTINATION_DETAILS',
  DestinationTerminal = 'DESTINATION_TERMINAL',
  Dims = 'DIMS',
  DimWeight = 'DIM_WEIGHT',
  DriverName = 'DRIVER_NAME',
  DriverSettlement = 'DRIVER_SETTLEMENT',
  ExternalNotes = 'EXTERNAL_NOTES',
  HasDriverPod = 'HAS_DRIVER_POD',
  HoldReason = 'HOLD_REASON',
  InboundAddress = 'INBOUND_ADDRESS',
  InboundAddressName = 'INBOUND_ADDRESS_NAME',
  InboundAddressType = 'INBOUND_ADDRESS_TYPE',
  InboundAppointment = 'INBOUND_APPOINTMENT',
  InboundAppointmentConfirmed = 'INBOUND_APPOINTMENT_CONFIRMED',
  InboundAppointmentDate = 'INBOUND_APPOINTMENT_DATE',
  InboundAppointmentTime = 'INBOUND_APPOINTMENT_TIME',
  InboundCharges = 'INBOUND_CHARGES',
  InboundCityName = 'INBOUND_CITY_NAME',
  InboundCompletedDate = 'INBOUND_COMPLETED_DATE',
  InboundContactName = 'INBOUND_CONTACT_NAME',
  InboundDriverName = 'INBOUND_DRIVER_NAME',
  InboundMethod = 'INBOUND_METHOD',
  InboundOnTimePerformanceStatus = 'INBOUND_ON_TIME_PERFORMANCE_STATUS',
  InboundPaperwork = 'INBOUND_PAPERWORK',
  InboundRouteDate = 'INBOUND_ROUTE_DATE',
  InboundRouteName = 'INBOUND_ROUTE_NAME',
  InboundRouting = 'INBOUND_ROUTING',
  InboundServiceDate = 'INBOUND_SERVICE_DATE',
  InboundStopTotalTime = 'INBOUND_STOP_TOTAL_TIME',
  InboundStopType = 'INBOUND_STOP_TYPE',
  InboundStopWaitTime = 'INBOUND_STOP_WAIT_TIME',
  InboundZipcode = 'INBOUND_ZIPCODE',
  InBond = 'IN_BOND',
  IsLinehaul = 'IS_LINEHAUL',
  IsReweighed = 'IS_REWEIGHED',
  ItTeNumber = 'IT_TE_NUMBER',
  LineHaulCharges = 'LINE_HAUL_CHARGES',
  LineHaulManifests = 'LINE_HAUL_MANIFESTS',
  Mawb = 'MAWB',
  Name = 'NAME',
  NextAddress = 'NEXT_ADDRESS',
  NextAppointment = 'NEXT_APPOINTMENT',
  NextConsignee = 'NEXT_CONSIGNEE',
  NextDeadline = 'NEXT_DEADLINE',
  Notes = 'NOTES',
  OnHold = 'ON_HOLD',
  OrderConsignee = 'ORDER_CONSIGNEE',
  OrderServiceDate = 'ORDER_SERVICE_DATE',
  OrderType = 'ORDER_TYPE',
  OriginTerminal = 'ORIGIN_TERMINAL',
  OsdReason = 'OSD_REASON',
  OutboundAddress = 'OUTBOUND_ADDRESS',
  OutboundAddressName = 'OUTBOUND_ADDRESS_NAME',
  OutboundAddressType = 'OUTBOUND_ADDRESS_TYPE',
  OutboundAppointment = 'OUTBOUND_APPOINTMENT',
  OutboundAppointmentConfirmed = 'OUTBOUND_APPOINTMENT_CONFIRMED',
  OutboundAppointmentDate = 'OUTBOUND_APPOINTMENT_DATE',
  OutboundAppointmentTime = 'OUTBOUND_APPOINTMENT_TIME',
  OutboundCharges = 'OUTBOUND_CHARGES',
  OutboundCityName = 'OUTBOUND_CITY_NAME',
  OutboundCompletedDate = 'OUTBOUND_COMPLETED_DATE',
  OutboundContactName = 'OUTBOUND_CONTACT_NAME',
  OutboundDriverName = 'OUTBOUND_DRIVER_NAME',
  OutboundMethod = 'OUTBOUND_METHOD',
  OutboundOnTimePerformanceStatus = 'OUTBOUND_ON_TIME_PERFORMANCE_STATUS',
  OutboundPaperwork = 'OUTBOUND_PAPERWORK',
  OutboundRouteDate = 'OUTBOUND_ROUTE_DATE',
  OutboundRouteName = 'OUTBOUND_ROUTE_NAME',
  OutboundRouting = 'OUTBOUND_ROUTING',
  OutboundServiceDate = 'OUTBOUND_SERVICE_DATE',
  OutboundStopTotalTime = 'OUTBOUND_STOP_TOTAL_TIME',
  OutboundStopType = 'OUTBOUND_STOP_TYPE',
  OutboundStopWaitTime = 'OUTBOUND_STOP_WAIT_TIME',
  OutboundZipcode = 'OUTBOUND_ZIPCODE',
  PaperworkComplete = 'PAPERWORK_COMPLETE',
  Photos = 'PHOTOS',
  PieceCount = 'PIECE_COUNT',
  PodName = 'POD_NAME',
  PrimaryAddress = 'PRIMARY_ADDRESS',
  PrimaryAddressType = 'PRIMARY_ADDRESS_TYPE',
  PrimaryAppointment = 'PRIMARY_APPOINTMENT',
  PrimaryConsignee = 'PRIMARY_CONSIGNEE',
  PrimaryContactName = 'PRIMARY_CONTACT_NAME',
  PrimaryDeadline = 'PRIMARY_DEADLINE',
  PrimaryServiceDate = 'PRIMARY_SERVICE_DATE',
  PrimaryServiceLevel = 'PRIMARY_SERVICE_LEVEL',
  ReceivedAt = 'RECEIVED_AT',
  RouteName = 'ROUTE_NAME',
  RoutingLocation = 'ROUTING_LOCATION',
  SecondaryRefNumber = 'SECONDARY_REF_NUMBER',
  ShipmentType = 'SHIPMENT_TYPE',
  Source = 'SOURCE',
  Special = 'SPECIAL',
  Status = 'STATUS',
  StopTypes = 'STOP_TYPES',
  Tags = 'TAGS',
  TotalChargesWithItemized = 'TOTAL_CHARGES_WITH_ITEMIZED',
  TotalSkids = 'TOTAL_SKIDS',
  UnNumber = 'UN_NUMBER',
  Weight = 'WEIGHT',
  Zipcode = 'ZIPCODE'
}

/** Represents a table or column header for an order table field that is requested as part of an order retrieval for the orders table */
export type OrderTableFieldHeaderEntity = {
  __typename?: 'OrderTableFieldHeaderEntity';
  header: Scalars['String']['output'];
  orderTableField: OrderTableField;
};

export type OrderTableItemizedChargesFieldEntity = {
  __typename?: 'OrderTableItemizedChargesFieldEntity';
  /** @deprecated Now uses charges for more granular viewing */
  customCharges: Array<OrderTableCustomChargeFieldEntity>;
  /** @deprecated Now uses charges for more granular viewing */
  freightChargeTotal: Scalars['Float']['output'];
  /** @deprecated Now uses charges for more granular viewing */
  fuelChargeTotal: Scalars['Float']['output'];
  orderTableField: OrderTableField;
  /** The result of rating the order. If null, order rating was skipped as part of retrieving the itemized charges field */
  rateOrderOutput?: Maybe<RateOrderOutput>;
  shipmentCharges: Array<OrderTableItemizedChargesFieldShipmentEntity>;
};

export type OrderTableItemizedChargesFieldShipmentEntity = {
  __typename?: 'OrderTableItemizedChargesFieldShipmentEntity';
  customCharges: Array<OrderTableCustomChargeFieldEntity>;
  freightBillingMethod?: Maybe<FreightBillingMethod>;
  freightQuantity?: Maybe<Scalars['Float']['output']>;
  freightRate?: Maybe<Scalars['Currency']['output']>;
  freightTotalAmount?: Maybe<Scalars['Currency']['output']>;
  fuelBillingMethod?: Maybe<FuelBillingMethod>;
  fuelFlatRate?: Maybe<Scalars['Currency']['output']>;
  fuelSurchargeRate?: Maybe<Scalars['Percent']['output']>;
  fuelTotalAmount?: Maybe<Scalars['Currency']['output']>;
  /** @deprecated Use stopType instead */
  pickupOrDelivery?: Maybe<PickupOrDelivery>;
  shipmentType: ShipmentType;
  stopType?: Maybe<StopType>;
  tariff?: Maybe<TariffEntity>;
};

/** Represents a single line haul manifest that an order is on. Returned as part of a formatted line haul manifests order table field */
export type OrderTableLineHaulManifestEntity = {
  __typename?: 'OrderTableLineHaulManifestEntity';
  endTerminal: TerminalEntity;
  startTerminal: TerminalEntity;
  status: LineHaulManifestStatus;
};

export type OrderTableLineHaulManifestsFieldEntity = {
  __typename?: 'OrderTableLineHaulManifestsFieldEntity';
  /** The current terminal that the order is in. Null if the order is not on a line haul manifest */
  currentTerminal?: Maybe<TerminalEntity>;
  /** The end terminal of the order. */
  endTerminal: TerminalEntity;
  lineHaulManifests: Array<OrderTableLineHaulManifestEntity>;
  orderTableField: OrderTableField;
  /** The start terminal of the order. */
  startTerminal: TerminalEntity;
};

export type OrderTablePackageEntity = {
  __typename?: 'OrderTablePackageEntity';
  height?: Maybe<Scalars['Length']['output']>;
  length?: Maybe<Scalars['Length']['output']>;
  quantity: Scalars['Int']['output'];
  uuid: Scalars['String']['output'];
  weight?: Maybe<Scalars['Mass']['output']>;
  width?: Maybe<Scalars['Length']['output']>;
};

/** Represents the custom value for the "Dims" order table field that is returned as part of a retrieval query */
export type OrderTablePackagesFieldEntity = {
  __typename?: 'OrderTablePackagesFieldEntity';
  orderTableField: OrderTableField;
  orderTablePackages: Array<OrderTablePackageEntity>;
};

export type OrderTablePaperworkFieldEntity = {
  __typename?: 'OrderTablePaperworkFieldEntity';
  /** Contains inbound documents grouped by type */
  inboundPaperwork?: Maybe<OrderPaperworkEntity>;
  orderTableField: OrderTableField;
  /** Contains outbound documents grouped by type */
  outboundPaperwork?: Maybe<OrderPaperworkEntity>;
  paperwork: OrderPaperworkEntity;
};

export type OrderTablePhotoEntity = {
  __typename?: 'OrderTablePhotoEntity';
  fileName: Scalars['String']['output'];
  preSignedGetUrl: Scalars['String']['output'];
  shipmentPickupOrDelivery: PickupOrDelivery;
  shipmentUuid: Scalars['String']['output'];
  stopType: StopType;
  type: DocumentType;
};

export type OrderTablePhotosFieldEntity = {
  __typename?: 'OrderTablePhotosFieldEntity';
  orderTableField: OrderTableField;
  orderTablePhotos: Array<OrderTablePhotoEntity>;
};

/** The output shape of the order table report when the number of orders is below the threshold and is generated and downloaded synchronously */
export type OrderTableReportDownloadOutput = {
  __typename?: 'OrderTableReportDownloadOutput';
  reportGenerationStatus: ReportGenerationStatus;
  reportUrl: Scalars['String']['output'];
};

/** The output shape of the order table report when the number of orders is above the threshold and is generated asynchronously and is emailed to the user */
export type OrderTableReportEmailToUserOutput = {
  __typename?: 'OrderTableReportEmailToUserOutput';
  reportGenerationStatus: ReportGenerationStatus;
};

export type OrderTableServiceFieldEntity = {
  __typename?: 'OrderTableServiceFieldEntity';
  orderTableField: OrderTableField;
  service?: Maybe<ServiceEntity>;
};

export type OrderTableTagEntity = {
  __typename?: 'OrderTableTagEntity';
  color?: Maybe<Scalars['String']['output']>;
  value: Scalars['String']['output'];
};

export type OrderTableTagsFieldEntity = {
  __typename?: 'OrderTableTagsFieldEntity';
  orderTableField: OrderTableField;
  orderTableTags: Array<OrderTableTagEntity>;
};

export type OrderToAddToInvoice = {
  __typename?: 'OrderToAddToInvoice';
  orderName: Scalars['String']['output'];
  orderUuid: Scalars['String']['output'];
  shipmentUuids: Array<Scalars['String']['output']>;
};

export type OrderToChargeEntity = {
  __typename?: 'OrderToChargeEntity';
  /** Amount to apply to this order */
  amountInCents: Scalars['Int']['output'];
  /** Current order balance (before applying new payment) */
  currentBalanceInCents: Scalars['Int']['output'];
  invoiceUuid?: Maybe<Scalars['String']['output']>;
  /** New order balance after applying specified amountInCents */
  lineBalanceInCents: Scalars['Int']['output'];
  /** Order total charge */
  orderTotalInCents: Scalars['Int']['output'];
  orderUuid: Scalars['String']['output'];
};

export type OrderUpdateInput = {
  billingPartyContactStationId?: InputMaybe<Scalars['String']['input']>;
  billingPartyContactUuid?: InputMaybe<Scalars['String']['input']>;
  billingStatus?: InputMaybe<OrderBillingStatus>;
  callerName?: InputMaybe<Scalars['String']['input']>;
  callerPhoneNumber?: InputMaybe<Scalars['String']['input']>;
  chargeableWeightCubicMeters?: InputMaybe<Scalars['Volume']['input']>;
  codCheckAmountCents?: InputMaybe<Scalars['Int']['input']>;
  codCheckNumber?: InputMaybe<Scalars['String']['input']>;
  consolidatedOrderUuid?: InputMaybe<Scalars['String']['input']>;
  createdFromOrderTemplateUuid?: InputMaybe<Scalars['String']['input']>;
  dateMarkedReceivedAtOrigin?: InputMaybe<Scalars['DateTime']['input']>;
  deletedAutoAppliedAccessorialUuids?: InputMaybe<Array<Scalars['String']['input']>>;
  documentUpsertInputs?: InputMaybe<Array<DocumentUpsertInput>>;
  driverQualificationIds?: InputMaybe<Array<Scalars['String']['input']>>;
  emergencyResponseNumber?: InputMaybe<Scalars['String']['input']>;
  enableLineHaul?: InputMaybe<Scalars['Boolean']['input']>;
  externalNotes?: InputMaybe<Scalars['String']['input']>;
  fulfillmentType?: InputMaybe<FulfillmentType>;
  hazmat?: InputMaybe<Scalars['Boolean']['input']>;
  hazmatClass?: InputMaybe<HazmatClass>;
  hazmatDescription?: InputMaybe<Scalars['String']['input']>;
  holdReasonUuid?: InputMaybe<Scalars['String']['input']>;
  inBond?: InputMaybe<Scalars['Boolean']['input']>;
  isCollectOnDelivery?: InputMaybe<Scalars['Boolean']['input']>;
  isCrossDock?: InputMaybe<Scalars['Boolean']['input']>;
  isDraftOrder?: InputMaybe<Scalars['Boolean']['input']>;
  isReweighed?: InputMaybe<Scalars['Boolean']['input']>;
  issueReason?: InputMaybe<Scalars['String']['input']>;
  itTeNumber?: InputMaybe<Scalars['String']['input']>;
  lineHaulLaneUuid?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  onHand?: InputMaybe<Scalars['Boolean']['input']>;
  orderCommentCreateInputs?: InputMaybe<Array<CreateOrderCommentInput>>;
  osd?: InputMaybe<Scalars['Boolean']['input']>;
  packageArrayUpdateInputs?: InputMaybe<Array<PackageArrayUpdateInput>>;
  packageGroup?: InputMaybe<PackageGroup>;
  paymentMethod?: InputMaybe<PaymentMethod>;
  personEmail?: InputMaybe<Scalars['String']['input']>;
  personName?: InputMaybe<Scalars['String']['input']>;
  personPhoneNumber?: InputMaybe<Scalars['String']['input']>;
  pickedDate?: InputMaybe<Scalars['DateTime']['input']>;
  pieceCount?: InputMaybe<Scalars['Int']['input']>;
  piecesPicked?: InputMaybe<Scalars['Int']['input']>;
  quaternaryRefNumber?: InputMaybe<Scalars['String']['input']>;
  quinaryRefNumber?: InputMaybe<Scalars['String']['input']>;
  recalculateTotals?: InputMaybe<Scalars['Boolean']['input']>;
  receivedDate?: InputMaybe<Scalars['DateTime']['input']>;
  recurringOrderFrequencyUpdateInput?: InputMaybe<UpdateRecurringOrderFrequencyInput>;
  refNumbers?: InputMaybe<Array<Scalars['String']['input']>>;
  refusedBy?: InputMaybe<Scalars['String']['input']>;
  refusedDate?: InputMaybe<Scalars['DateTime']['input']>;
  requiresPlacard?: InputMaybe<Scalars['Boolean']['input']>;
  secondaryRefNumber?: InputMaybe<Scalars['String']['input']>;
  serviceUuid?: InputMaybe<Scalars['String']['input']>;
  shipmentArrayUpdateInputs?: InputMaybe<Array<ShipmentArrayUpdateInput>>;
  standardOrderFieldsUpdateInput?: InputMaybe<StandardOrderFieldsUpdateInput>;
  status?: InputMaybe<OrderStatus>;
  tagUuids?: InputMaybe<Array<Scalars['String']['input']>>;
  tertiaryRefNumber?: InputMaybe<Scalars['String']['input']>;
  thirdPartyBrokerUuids?: InputMaybe<Array<Scalars['String']['input']>>;
  /** The total charge in dollars */
  totalCharge?: InputMaybe<Scalars['Float']['input']>;
  totalSkids?: InputMaybe<Scalars['Int']['input']>;
  unNumber?: InputMaybe<Scalars['String']['input']>;
  uuid: Scalars['String']['input'];
  vehicleTypeUuid?: InputMaybe<Scalars['String']['input']>;
  warehouseUuid?: InputMaybe<Scalars['String']['input']>;
};

export type OrderVolumeByCompanyInput = {
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
};

export type OrderVolumeByContactInput = {
  companyUuid: Scalars['String']['input'];
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
};

export type OrderVolumeByDateRangeInput = {
  companyUuid: Scalars['String']['input'];
  contactUuid?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  period: ReportAggregationPeriod;
  startDate: Scalars['DateTime']['input'];
};

export type OrderVolumeBySchemaInput = {
  companyUuid?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
};

export type OrderVolumeByUserInput = {
  companyUuid: Scalars['String']['input'];
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
};

export type OrderVolumeCompanyBucketEntity = {
  __typename?: 'OrderVolumeCompanyBucketEntity';
  companyName: Scalars['String']['output'];
  companyUuid: Scalars['String']['output'];
  sourceAmounts: Array<OrderVolumeSourceBucketEntity>;
};

export type OrderVolumeContactBucketEntity = {
  __typename?: 'OrderVolumeContactBucketEntity';
  contactName: Scalars['String']['output'];
  contactUuid: Scalars['String']['output'];
  sourceAmounts: Array<OrderVolumeSourceBucketEntity>;
};

/** The open invoice value for a contact within the specified day range */
export type OrderVolumeDateRangeBucketEntity = {
  __typename?: 'OrderVolumeDateRangeBucketEntity';
  contactUuid?: Maybe<Scalars['String']['output']>;
  endDate: Scalars['DateTime']['output'];
  sourceAmounts: Array<OrderVolumeSourceBucketEntity>;
  startDate: Scalars['DateTime']['output'];
};

export type OrderVolumeSchemaBucketEntity = {
  __typename?: 'OrderVolumeSchemaBucketEntity';
  schemaName: Scalars['String']['output'];
  schemaUuid: Scalars['String']['output'];
  total: Scalars['Float']['output'];
};

export type OrderVolumeSourceBucketEntity = {
  __typename?: 'OrderVolumeSourceBucketEntity';
  scannedOrderSource?: Maybe<ScannedOrderSource>;
  source: OrderSource;
  totalCount: Scalars['Float']['output'];
};

export type OrderVolumeUserBucketEntity = {
  __typename?: 'OrderVolumeUserBucketEntity';
  name?: Maybe<Scalars['String']['output']>;
  sourceAmounts: Array<OrderVolumeSourceBucketEntity>;
  userEmail: Scalars['String']['output'];
  userTerminalName?: Maybe<Scalars['String']['output']>;
  userUuid: Scalars['String']['output'];
};

export type OrderWithPieceNameEntity = {
  __typename?: 'OrderWithPieceNameEntity';
  order: OrderEntity;
  /** The unique piece ID associated with this scanned order */
  pieceName?: Maybe<Scalars['String']['output']>;
};

export type OrdersForPaymentsSort = {
  sortBy: OrdersForPaymentsSortField;
  sortDirection: SortDirection;
};

export enum OrdersForPaymentsSortField {
  ShipperBillOfLadingNumber = 'ShipperBillOfLadingNumber'
}

export type OrganizationConnection = {
  __typename?: 'OrganizationConnection';
  edges: Array<OrganizationEdge>;
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type OrganizationEdge = {
  __typename?: 'OrganizationEdge';
  cursor: Scalars['String']['output'];
  node: OrganizationEntity;
};

/** This entity represents the fields that an organization will always have regardless of the type */
export type OrganizationEntity = {
  __typename?: 'OrganizationEntity';
  addresses: Array<AddressEntity>;
  agentFields?: Maybe<AgentFieldsEntity>;
  contactPersons: Array<ContactPersonEntity>;
  createdAt: Scalars['DateTime']['output'];
  customerFields?: Maybe<CustomerFieldsEntity>;
  defaultContactPerson?: Maybe<ContactPersonEntity>;
  ediApplicationId?: Maybe<Scalars['String']['output']>;
  ediContactCode?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  isActive: Scalars['Boolean']['output'];
  isaId?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  referenceNumber?: Maybe<Scalars['String']['output']>;
  stediPartnerId?: Maybe<Scalars['String']['output']>;
  types: Array<OrganizationType>;
  updatedAt: Scalars['DateTime']['output'];
  uuid: Scalars['String']['output'];
};

/** The type of organization */
export enum OrganizationType {
  Agent = 'AGENT',
  Customer = 'CUSTOMER'
}

export enum OriginStopType {
  PartnerDropoff = 'PARTNER_DROPOFF',
  Pickup = 'PICKUP',
  Recovery = 'RECOVERY'
}

export type OriginTerminalMismatchError = {
  __typename?: 'OriginTerminalMismatchError';
  order: OrderEntity;
};

export type OriginTerminalSortInput = {
  direction: SortOrder;
  nulls: NullsOrder;
};

export type OutboundAddressNameSortInput = {
  direction: SortOrder;
  nulls: NullsOrder;
};

export type OutboundAddressSortInput = {
  direction: SortOrder;
  nulls: NullsOrder;
};

export type OutboundCityNameSortInput = {
  direction: SortOrder;
  nulls: NullsOrder;
};

export type OutboundCompletedDateSortInput = {
  direction: SortOrder;
  nulls: NullsOrder;
};

export type OutboundDriverNameSortInput = {
  direction: SortOrder;
  nulls: NullsOrder;
};

export enum OutboundMethod {
  AirportTransfer = 'AIRPORT_TRANSFER',
  LocalDelivery = 'LOCAL_DELIVERY',
  Other = 'OTHER'
}

export type OutboundMethodSortInput = {
  direction: SortOrder;
  nulls: NullsOrder;
};

export type OutboundRouteDateSortInput = {
  direction: SortOrder;
  nulls: NullsOrder;
};

export type OutboundRouteNameSortInput = {
  direction: SortOrder;
  nulls: NullsOrder;
};

export type OutboundServiceDateSortInput = {
  direction: SortOrder;
  nulls: NullsOrder;
};

export type OutboundZipcodeSortInput = {
  direction: SortOrder;
  nulls: NullsOrder;
};

export type OutlookIntegrationCreateInput = {
  companyUuid: Scalars['String']['input'];
  deltaToken?: InputMaybe<Scalars['String']['input']>;
  emailCreatedAtStartDate?: InputMaybe<Scalars['DateTime']['input']>;
  entraTenantId: Scalars['String']['input'];
  entraUserId: Scalars['String']['input'];
  outboundEmailDomains: Array<Scalars['String']['input']>;
  terminalUuid?: InputMaybe<Scalars['String']['input']>;
};

export type OutlookIntegrationEntity = {
  __typename?: 'OutlookIntegrationEntity';
  company: CompanyEntity;
  createdAt: Scalars['DateTime']['output'];
  emailCreatedAtStartDate?: Maybe<Scalars['DateTime']['output']>;
  entraTenantId: Scalars['String']['output'];
  entraUserId: Scalars['String']['output'];
  outboundEmailDomains: Array<Scalars['String']['output']>;
  terminal?: Maybe<TerminalEntity>;
  updatedAt: Scalars['DateTime']['output'];
  user: UserEntity;
  uuid: Scalars['String']['output'];
};

export type OutlookIntegrationUpdateInput = {
  companyUuid?: InputMaybe<Scalars['String']['input']>;
  deltaToken?: InputMaybe<Scalars['String']['input']>;
  emailCreatedAtStartDate?: InputMaybe<Scalars['DateTime']['input']>;
  entraTenantId?: InputMaybe<Scalars['String']['input']>;
  entraUserId?: InputMaybe<Scalars['String']['input']>;
  outboundEmailDomains: Array<Scalars['String']['input']>;
  terminalUuid?: InputMaybe<Scalars['String']['input']>;
  uuid: Scalars['String']['input'];
};

export type PackageArrayUpdateInput = {
  packageUpsertInput: PackageUpsertInput;
};

export type PackageCreateInput = {
  class?: InputMaybe<Scalars['Float']['input']>;
  description: Scalars['String']['input'];
  freightSnapTransactionUuid?: InputMaybe<Scalars['String']['input']>;
  hazmat?: InputMaybe<Scalars['Boolean']['input']>;
  height?: InputMaybe<Scalars['Float']['input']>;
  length?: InputMaybe<Scalars['Float']['input']>;
  nmfc?: InputMaybe<Scalars['String']['input']>;
  packageSpecId?: InputMaybe<Scalars['String']['input']>;
  quantity: Scalars['Int']['input'];
  quantityCompletedAtStop?: InputMaybe<Scalars['Int']['input']>;
  reasonUncompletedAtStop?: InputMaybe<Scalars['String']['input']>;
  skuNumber?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<PackageType>;
  /** Represents the warehouse location assigned to the package if it is turned on for the customer */
  warehouseLocationUuid?: InputMaybe<Scalars['String']['input']>;
  weight?: InputMaybe<Scalars['Float']['input']>;
  width?: InputMaybe<Scalars['Float']['input']>;
};

export type PackageEntity = {
  __typename?: 'PackageEntity';
  class?: Maybe<Scalars['Float']['output']>;
  createdAt: Scalars['DateTime']['output'];
  description: Scalars['String']['output'];
  hazmat?: Maybe<Scalars['Boolean']['output']>;
  height?: Maybe<Scalars['Float']['output']>;
  length?: Maybe<Scalars['Float']['output']>;
  nmfc?: Maybe<Scalars['String']['output']>;
  order?: Maybe<OrderEntity>;
  packageSpec?: Maybe<PackageSpecEntity>;
  /**
   * The first piece associated with the package
   * @deprecated Use pieces instead as packages now have multiple pieces
   */
  piece?: Maybe<PieceEntity>;
  /** All pieces associated with the package */
  pieces?: Maybe<Array<PieceEntity>>;
  quantity: Scalars['Int']['output'];
  quantityCompletedAtStop?: Maybe<Scalars['Int']['output']>;
  reasonUncompletedAtStop?: Maybe<Scalars['String']['output']>;
  skuNumber?: Maybe<Scalars['String']['output']>;
  type?: Maybe<PackageType>;
  updatedAt: Scalars['DateTime']['output'];
  uuid: Scalars['String']['output'];
  warehouseLocation?: Maybe<WarehouseLocationEntity>;
  weight?: Maybe<Scalars['Float']['output']>;
  width?: Maybe<Scalars['Float']['output']>;
};

export enum PackageField {
  Description = 'DESCRIPTION',
  Height = 'HEIGHT',
  Length = 'LENGTH',
  Quantity = 'QUANTITY',
  Weight = 'WEIGHT',
  Width = 'WIDTH'
}

export type PackageForCachedStop = {
  __typename?: 'PackageForCachedStop';
  description?: Maybe<Scalars['String']['output']>;
  height?: Maybe<Scalars['Float']['output']>;
  length?: Maybe<Scalars['Float']['output']>;
  quantity: Scalars['Int']['output'];
  weight?: Maybe<Scalars['Float']['output']>;
  width?: Maybe<Scalars['Float']['output']>;
};

export enum PackageGroup {
  I = 'I',
  Ii = 'II',
  Iii = 'III'
}

export type PackageSpecEntity = {
  __typename?: 'PackageSpecEntity';
  height?: Maybe<Scalars['Length']['output']>;
  id: Scalars['String']['output'];
  length?: Maybe<Scalars['Length']['output']>;
  name: Scalars['String']['output'];
  status: PackageSpecStatus;
  weight?: Maybe<Scalars['Mass']['output']>;
  width?: Maybe<Scalars['Length']['output']>;
};

export enum PackageSpecStatus {
  Active = 'ACTIVE',
  Archived = 'ARCHIVED'
}

export type PackageTableColumnEntity = {
  __typename?: 'PackageTableColumnEntity';
  columnIndex: Scalars['Int']['output'];
  header: Scalars['String']['output'];
  packageField?: Maybe<PackageField>;
  required: Scalars['Boolean']['output'];
  uuid: Scalars['String']['output'];
};

export type PackageTableColumnInput = {
  columnIndex: Scalars['Int']['input'];
  header: Scalars['String']['input'];
  packageField?: InputMaybe<PackageField>;
  required: Scalars['Boolean']['input'];
};

export type PackageTableEntity = {
  __typename?: 'PackageTableEntity';
  blockId: Scalars['String']['output'];
  headerRowIndex: Scalars['Int']['output'];
  packageTableColumns: Array<PackageTableColumnEntity>;
  title?: Maybe<Scalars['String']['output']>;
  uuid: Scalars['String']['output'];
};

export type PackageTableInput = {
  blockId: Scalars['String']['input'];
  headerRowIndex: Scalars['Int']['input'];
  packageTableColumns: Array<PackageTableColumnInput>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export enum PackageType {
  Box = 'BOX',
  Bundle = 'BUNDLE',
  Container = 'CONTAINER',
  Crate = 'CRATE',
  Other = 'OTHER',
  Pallet = 'PALLET',
  Piece = 'PIECE',
  Skid = 'SKID'
}

export type PackageUpdateInput = {
  class?: InputMaybe<Scalars['Float']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  hazmat?: InputMaybe<Scalars['Boolean']['input']>;
  height?: InputMaybe<Scalars['Float']['input']>;
  length?: InputMaybe<Scalars['Float']['input']>;
  nmfc?: InputMaybe<Scalars['String']['input']>;
  quantity?: InputMaybe<Scalars['Int']['input']>;
  quantityCompletedAtStop?: InputMaybe<Scalars['Int']['input']>;
  reasonUncompletedAtStop?: InputMaybe<Scalars['String']['input']>;
  skuNumber?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<PackageType>;
  uuid: Scalars['String']['input'];
  weight?: InputMaybe<Scalars['Float']['input']>;
  width?: InputMaybe<Scalars['Float']['input']>;
};

export type PackageUpsertInput = {
  class?: InputMaybe<Scalars['Float']['input']>;
  description: Scalars['String']['input'];
  hazmat?: InputMaybe<Scalars['Boolean']['input']>;
  height?: InputMaybe<Scalars['Float']['input']>;
  length?: InputMaybe<Scalars['Float']['input']>;
  nmfc?: InputMaybe<Scalars['String']['input']>;
  packageSpecId?: InputMaybe<Scalars['String']['input']>;
  quantity: Scalars['Int']['input'];
  quantityCompletedAtStop?: InputMaybe<Scalars['Int']['input']>;
  reasonUncompletedAtStop?: InputMaybe<Scalars['String']['input']>;
  skuNumber?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<PackageType>;
  uuid: Scalars['String']['input'];
  /** Represents the warehouse location assigned to the package if it is turned on for the customer */
  warehouseLocationUuid?: InputMaybe<Scalars['String']['input']>;
  weight?: InputMaybe<Scalars['Float']['input']>;
  width?: InputMaybe<Scalars['Float']['input']>;
};

export type PageInfo = {
  __typename?: 'PageInfo';
  endCursor?: Maybe<Scalars['String']['output']>;
  hasNextPage: Scalars['Boolean']['output'];
  hasPreviousPage: Scalars['Boolean']['output'];
  startCursor?: Maybe<Scalars['String']['output']>;
};

export enum PalletProductOffering {
  EmailIngestion = 'EMAIL_INGESTION',
  Tms = 'TMS',
  Wms = 'WMS'
}

export type ParseCsvOrderRowErrorEntity = {
  __typename?: 'ParseCsvOrderRowErrorEntity';
  message: Scalars['String']['output'];
  /** The row where the error occurred. Note that this is NOT 0-indexed */
  row: Scalars['Int']['output'];
};

export type ParseCsvOrdersInput = {
  bucket: Scalars['String']['input'];
  csvOrderMappingUuid: Scalars['String']['input'];
  filename: Scalars['String']['input'];
  filetype: Scalars['String']['input'];
  key: Scalars['String']['input'];
};

export type ParseCsvOrdersOutput = MutationErrorOutput | ParseCsvOrdersSuccessOutput;

export type ParseCsvOrdersSuccessOutput = {
  __typename?: 'ParseCsvOrdersSuccessOutput';
  enableInboundStop: Scalars['Boolean']['output'];
  enableOutboundStop: Scalars['Boolean']['output'];
  errors: Array<ParseCsvOrderRowErrorEntity>;
  parsedOrderUpdates: Array<ParsedCsvOrderUpdateEntity>;
  parsedOrders: Array<ParsedCsvOrderEntity>;
};

export type ParsedCsvOrderEntity = {
  __typename?: 'ParsedCsvOrderEntity';
  billingPartyContact: ContactEntity;
  customerReferenceNumber?: Maybe<Scalars['String']['output']>;
  dimFactor?: Maybe<Scalars['Int']['output']>;
  freightChargeRate?: Maybe<Scalars['Float']['output']>;
  freightChargeType?: Maybe<FreightBillingMethod>;
  fuelChargeType?: Maybe<FuelBillingMethod>;
  fuelSurcharge?: Maybe<Scalars['Float']['output']>;
  inboundStop?: Maybe<ParsedCsvOrderStopEntity>;
  masterAirwayBillOfLadingNumber?: Maybe<Scalars['String']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  outboundStop?: Maybe<ParsedCsvOrderStopEntity>;
  packages: Array<ParsedCsvOrderPackageEntity>;
  referenceNumber?: Maybe<Scalars['String']['output']>;
  serviceLevel?: Maybe<ServiceEntity>;
  shipperBillOfLadingNumber: Scalars['String']['output'];
};

/** A package that is either parsed from a CSV file or from an order part of an order that was detected in a parsed CSV file */
export type ParsedCsvOrderPackageEntity = {
  __typename?: 'ParsedCsvOrderPackageEntity';
  description: Scalars['String']['output'];
  height?: Maybe<Scalars['Float']['output']>;
  /** A flag that is set to true if the parsed package is one that needs to be appended to the order packages */
  isNew?: Maybe<Scalars['Boolean']['output']>;
  length?: Maybe<Scalars['Float']['output']>;
  packageSpec?: Maybe<PackageSpecEntity>;
  quantity: Scalars['Int']['output'];
  type?: Maybe<PackageType>;
  /** Either the UUID of an existing package, or a new UUID for the new package */
  uuid: Scalars['String']['output'];
  weight?: Maybe<Scalars['Float']['output']>;
  width?: Maybe<Scalars['Float']['output']>;
};

export type ParsedCsvOrderStopEntity = {
  __typename?: 'ParsedCsvOrderStopEntity';
  addressCity: Scalars['String']['output'];
  addressLine1: Scalars['String']['output'];
  addressLine2?: Maybe<Scalars['String']['output']>;
  addressName: Scalars['String']['output'];
  addressState: Scalars['String']['output'];
  addressZip: Scalars['String']['output'];
  appointmentEndTime?: Maybe<PlainTime>;
  appointmentRequired: Scalars['Boolean']['output'];
  appointmentStartTime?: Maybe<PlainTime>;
  contactPersonEmail?: Maybe<Scalars['String']['output']>;
  contactPersonFirstName?: Maybe<Scalars['String']['output']>;
  contactPersonLastName?: Maybe<Scalars['String']['output']>;
  contactPersonPhone?: Maybe<Scalars['String']['output']>;
  deadlineDate?: Maybe<Scalars['DateTime']['output']>;
  deadlineType?: Maybe<DeadlineType>;
  driver?: Maybe<DriverEntity>;
  driverName?: Maybe<Scalars['String']['output']>;
  driverReferenceNumber?: Maybe<Scalars['String']['output']>;
  pickupOrDelivery: PickupOrDelivery;
  serviceDate: Scalars['DateTime']['output'];
  /** The service date of the parsed stop as a PlainDate. See https://www.notion.so/Service-Date-dc8ae149b6a54bb69404aecf92176287 for details. */
  serviceDateV2: PlainDate;
  specialInstructions?: Maybe<Scalars['String']['output']>;
  terminal?: Maybe<TerminalEntity>;
  terminalName?: Maybe<Scalars['String']['output']>;
};

export type ParsedCsvOrderStopInput = {
  addressCity: Scalars['String']['input'];
  addressLine1: Scalars['String']['input'];
  addressLine2?: InputMaybe<Scalars['String']['input']>;
  addressName: Scalars['String']['input'];
  addressState: Scalars['String']['input'];
  addressZip: Scalars['String']['input'];
  appointmentEndTime?: InputMaybe<PlainTimeInput>;
  appointmentRequired?: InputMaybe<Scalars['Boolean']['input']>;
  appointmentStartTime?: InputMaybe<PlainTimeInput>;
  contactPersonEmail?: InputMaybe<Scalars['String']['input']>;
  contactPersonFirstName?: InputMaybe<Scalars['String']['input']>;
  contactPersonLastName?: InputMaybe<Scalars['String']['input']>;
  contactPersonPhone?: InputMaybe<Scalars['String']['input']>;
  deadlineDate?: InputMaybe<Scalars['DateTime']['input']>;
  deadlineType?: InputMaybe<DeadlineType>;
  driverUuid?: InputMaybe<Scalars['String']['input']>;
  pickupOrDelivery: PickupOrDelivery;
  serviceDate: Scalars['DateTime']['input'];
  /** The service date, in ISO 8601 date format. */
  serviceDateIso8601?: InputMaybe<Scalars['String']['input']>;
  specialInstructions?: InputMaybe<Scalars['String']['input']>;
  terminalUuid?: InputMaybe<Scalars['String']['input']>;
};

export type ParsedCsvOrderUpdateEntity = {
  __typename?: 'ParsedCsvOrderUpdateEntity';
  billingPartyContact: ContactEntity;
  packages: Array<ParsedCsvOrderPackageEntity>;
  shipperBillOfLadingNumber: Scalars['String']['output'];
  uuid: Scalars['String']['output'];
};

export type PaymentConnection = {
  __typename?: 'PaymentConnection';
  edges: Array<PaymentEdge>;
  pageInfo: PageInfo;
  /** Not cheap to calculate, request with prudence */
  totalCount?: Maybe<Scalars['Int']['output']>;
  /** Not cheap to calculate, request with prudence */
  uuids?: Maybe<Array<Scalars['String']['output']>>;
  /** Version ID for the response */
  versionId?: Maybe<Scalars['Float']['output']>;
};

export type PaymentEdge = {
  __typename?: 'PaymentEdge';
  cursor: Scalars['String']['output'];
  node: PaymentEntity;
};

export type PaymentEntity = {
  __typename?: 'PaymentEntity';
  amountInCents: Scalars['Int']['output'];
  appliedAmountInCents: Scalars['Float']['output'];
  comment?: Maybe<Scalars['String']['output']>;
  contact: ContactEntity;
  creditNumber?: Maybe<Scalars['Float']['output']>;
  creditType?: Maybe<CreditTypeEntity>;
  date: Scalars['DateTime']['output'];
  glTerminal?: Maybe<TerminalEntity>;
  invoicesAppliedTo: Array<InvoiceEntity>;
  paymentRail?: Maybe<PaymentRail>;
  paymentToOrderMappings: Array<PaymentToOrderMappingEntity>;
  paymentType: PaymentType;
  referenceNumber: Scalars['String']['output'];
  unappliedAmountInCents: Scalars['Float']['output'];
  uuid: Scalars['String']['output'];
};

export type PaymentForCheckRegisterReportEntity = {
  __typename?: 'PaymentForCheckRegisterReportEntity';
  amountInCents?: Maybe<Scalars['Float']['output']>;
  comment?: Maybe<Scalars['String']['output']>;
  contactDisplayName?: Maybe<Scalars['String']['output']>;
  contactReferenceNumber?: Maybe<Scalars['String']['output']>;
  paymentDate?: Maybe<Scalars['DateTime']['output']>;
  paymentUuid: Scalars['String']['output'];
  referenceNumber: Scalars['String']['output'];
  terminalCodes?: Maybe<Array<Scalars['String']['output']>>;
};

export type PaymentForPaymentApplicationReportEntity = {
  __typename?: 'PaymentForPaymentApplicationReportEntity';
  comment?: Maybe<Scalars['String']['output']>;
  contactDisplayName: Scalars['String']['output'];
  contactReferenceNumber?: Maybe<Scalars['String']['output']>;
  contactUuid: Scalars['String']['output'];
  masterAccountName?: Maybe<Scalars['String']['output']>;
  orders: Array<OrderForPaymentApplicationReportEntity>;
  paymentDate: Scalars['DateTime']['output'];
  paymentRail?: Maybe<PaymentRail>;
  paymentType: PaymentType;
  paymentUuid: Scalars['String']['output'];
  referenceNumber: Scalars['String']['output'];
  /** The total amount of the payment in dollars */
  totalAmount: Scalars['Float']['output'];
  /** The amount not applied yet in dollars */
  unappliedAmount: Scalars['Float']['output'];
};

export type PaymentForPaymentJournalReportEntity = {
  __typename?: 'PaymentForPaymentJournalReportEntity';
  comment?: Maybe<Scalars['String']['output']>;
  contactDisplayName: Scalars['String']['output'];
  contactReferenceNumber?: Maybe<Scalars['String']['output']>;
  contactUuid: Scalars['String']['output'];
  creditNumber?: Maybe<Scalars['Float']['output']>;
  creditTypeName?: Maybe<Scalars['String']['output']>;
  glTerminalName?: Maybe<Scalars['String']['output']>;
  orders: Array<OrderForPaymentJournalReportEntity>;
  paymentDate: Scalars['DateTime']['output'];
  paymentRail?: Maybe<PaymentRail>;
  paymentType: PaymentType;
  paymentUuid: Scalars['String']['output'];
  referenceNumber: Scalars['String']['output'];
  /** The total amount of the payment in dollars */
  totalAmount: Scalars['Float']['output'];
  /** The amount not applied yet in dollars */
  unappliedAmountDollars: Scalars['Float']['output'];
};

export enum PaymentMethod {
  Collect = 'COLLECT',
  PrepaidBySeller = 'PREPAID_BY_SELLER',
  ServiceFreightNoCharges = 'SERVICE_FREIGHT_NO_CHARGES',
  ThirdPartyPay = 'THIRD_PARTY_PAY'
}

export enum PaymentRail {
  Ach = 'ACH',
  Check = 'CHECK'
}

export type PaymentSort = {
  sortBy: PaymentTableField;
  sortDirection: SortDirection;
};

export enum PaymentTableField {
  Amount = 'amount',
  Date = 'date'
}

export type PaymentToOrderMappingEntity = {
  __typename?: 'PaymentToOrderMappingEntity';
  amountInCents: Scalars['Int']['output'];
  order: OrderEntity;
  payment: PaymentEntity;
  uuid: Scalars['String']['output'];
};

export enum PaymentType {
  Credit = 'CREDIT',
  Debit = 'DEBIT',
  Payment = 'PAYMENT'
}

export type PdfColumnCreateInput = {
  legPDFColumnMapping?: InputMaybe<LegPdfColumnMapping>;
  orderColumnMapping?: InputMaybe<OrderPdfColumnMapping>;
  shipmentPDFColumnMapping?: InputMaybe<ShipmentPdfColumnMapping>;
  stopPDFColumnMapping?: InputMaybe<StopPdfColumnMapping>;
};

export type PdfColumnEntity = {
  __typename?: 'PdfColumnEntity';
  createdAt: Scalars['DateTime']['output'];
  legPDFColumnMapping?: Maybe<LegPdfColumnMapping>;
  orderColumnMapping?: Maybe<OrderPdfColumnMapping>;
  shipmentPDFColumnMapping?: Maybe<ShipmentPdfColumnMapping>;
  stopPDFColumnMapping?: Maybe<StopPdfColumnMapping>;
  updatedAt: Scalars['DateTime']['output'];
  uuid: Scalars['String']['output'];
};

export type PermissionEntity = {
  __typename?: 'PermissionEntity';
  accessLevel: AccessLevel;
  permissionResource: PermissionResource;
  uuid: Scalars['String']['output'];
};

export enum PermissionResource {
  AccountingReports = 'ACCOUNTING_REPORTS',
  Appointments = 'APPOINTMENTS',
  BillingReview = 'BILLING_REVIEW',
  CompanyAccessorials = 'COMPANY_ACCESSORIALS',
  CompanyBilling = 'COMPANY_BILLING',
  CompanyBusinessDivisions = 'COMPANY_BUSINESS_DIVISIONS',
  CompanyCustomForms = 'COMPANY_CUSTOM_FORMS',
  CompanyDrivers = 'COMPANY_DRIVERS',
  CompanyEquipment = 'COMPANY_EQUIPMENT',
  CompanyFuelProfiles = 'COMPANY_FUEL_PROFILES',
  CompanyHoldReasons = 'COMPANY_HOLD_REASONS',
  CompanyLineHaul = 'COMPANY_LINE_HAUL',
  CompanyRecoveryTerminals = 'COMPANY_RECOVERY_TERMINALS',
  CompanyRecurringOrders = 'COMPANY_RECURRING_ORDERS',
  CompanyRouteNames = 'COMPANY_ROUTE_NAMES',
  CompanyScheduling = 'COMPANY_SCHEDULING',
  CompanyServices = 'COMPANY_SERVICES',
  CompanyTariffs = 'COMPANY_TARIFFS',
  CompanyTerminals = 'COMPANY_TERMINALS',
  CompanyThirdPartyBrokers = 'COMPANY_THIRD_PARTY_BROKERS',
  CompanyUsers = 'COMPANY_USERS',
  CompanyWarehouseEmployees = 'COMPANY_WAREHOUSE_EMPLOYEES',
  Contacts = 'CONTACTS',
  Customers = 'CUSTOMERS',
  CustomerPortalOrders = 'CUSTOMER_PORTAL_ORDERS',
  DailyControlCenter = 'DAILY_CONTROL_CENTER',
  DeleteOrders = 'DELETE_ORDERS',
  DriverSettlements = 'DRIVER_SETTLEMENTS',
  EdiApiOrders = 'EDI_API_ORDERS',
  EmailOrders = 'EMAIL_ORDERS',
  EndOfDay = 'END_OF_DAY',
  FinalizeChargesOrders = 'FINALIZE_CHARGES_ORDERS',
  FinalizeChargesOrdersPaperworkIncomplete = 'FINALIZE_CHARGES_ORDERS_PAPERWORK_INCOMPLETE',
  InternalTools = 'INTERNAL_TOOLS',
  Invoices = 'INVOICES',
  LineHaulDispatch = 'LINE_HAUL_DISPATCH',
  Master = 'MASTER',
  MobileDriverApp = 'MOBILE_DRIVER_APP',
  MobileWarehouseScanning = 'MOBILE_WAREHOUSE_SCANNING',
  Orders = 'ORDERS',
  Quote = 'QUOTE',
  Reports = 'REPORTS',
  Routes = 'ROUTES',
  SavedViews = 'SAVED_VIEWS',
  ScannedOrders = 'SCANNED_ORDERS',
  SendFinalizedToBilling = 'SEND_FINALIZED_TO_BILLING',
  SettingsAutoApplyAccessorialRules = 'SETTINGS_AUTO_APPLY_ACCESSORIAL_RULES',
  SettingsDispatch = 'SETTINGS_DISPATCH',
  SettingsGeneral = 'SETTINGS_GENERAL',
  SettingsOrders = 'SETTINGS_ORDERS',
  SettingsQuickbooks = 'SETTINGS_QUICKBOOKS',
  SettingsQuickbooksDesktop = 'SETTINGS_QUICKBOOKS_DESKTOP',
  SettingsQuickbooksOnline = 'SETTINGS_QUICKBOOKS_ONLINE',
  SettingsRoles = 'SETTINGS_ROLES',
  SettingsSamsara = 'SETTINGS_SAMSARA',
  SettingsTags = 'SETTINGS_TAGS',
  Warehouses = 'WAREHOUSES'
}

export type PersonEntity = {
  __typename?: 'PersonEntity';
  defaultDeliveryAddress?: Maybe<AddressEntity>;
  defaultForContactStations?: Maybe<Array<ContactStationEntity>>;
  defaultPickupAddress?: Maybe<AddressEntity>;
  defaultService?: Maybe<ServiceEntity>;
  defaultVehicleType?: Maybe<VehicleTypeEntity>;
  email?: Maybe<Scalars['String']['output']>;
  firstName: Scalars['String']['output'];
  id: Scalars['String']['output'];
  lastName: Scalars['String']['output'];
  phone?: Maybe<Scalars['String']['output']>;
  status: PersonStatus;
};

export enum PersonStatus {
  Active = 'ACTIVE',
  Archived = 'ARCHIVED'
}

export type PickStorageUnitInput = {
  /** The number of inventory items to pick in that storage unit  */
  quantity: Scalars['Int']['input'];
  uuid: Scalars['String']['input'];
};

export type PickStorageUnitOutput = {
  __typename?: 'PickStorageUnitOutput';
  success: Scalars['Boolean']['output'];
};

export enum PickedStatus {
  Completed = 'COMPLETED',
  InProgress = 'IN_PROGRESS'
}

export type PicklistConnection = {
  __typename?: 'PicklistConnection';
  edges: Array<PicklistEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type PicklistEdge = {
  __typename?: 'PicklistEdge';
  cursor: Scalars['String']['output'];
  node: PicklistEntity;
};

export type PicklistEntity = {
  __typename?: 'PicklistEntity';
  createdAt: Scalars['DateTime']['output'];
  date: Scalars['DateTime']['output'];
  id: Scalars['String']['output'];
  outboundReferenceNumber?: Maybe<Scalars['String']['output']>;
  picklistItemGroups: Array<PicklistItemGroupEntity>;
  updatedAt: Scalars['DateTime']['output'];
};


export type PicklistEntityPicklistItemGroupsArgs = {
  storageOrderUuid?: InputMaybe<Scalars['String']['input']>;
};

/** Mapping that specifies which ItemGroups are on a Picklist */
export type PicklistItemGroupEntity = {
  __typename?: 'PicklistItemGroupEntity';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['String']['output'];
  itemGroup: ItemGroupEntity;
  pickedQuantity: Scalars['Int']['output'];
  pickedStatus: PickedStatus;
  updatedAt: Scalars['DateTime']['output'];
};

export type PicklistsInput = {
  /** forwards pagination cursor */
  after?: InputMaybe<Scalars['String']['input']>;
  /** backwards pagination cursor */
  before?: InputMaybe<Scalars['String']['input']>;
  /** UUID of company to filter by */
  companyUuid?: InputMaybe<Scalars['String']['input']>;
  /** UUID of contact to filter by */
  contactUuid?: InputMaybe<Scalars['String']['input']>;
  /** forwards pagination count, provide this on initial query */
  first?: InputMaybe<Scalars['Int']['input']>;
  /** backwards pagination count */
  last?: InputMaybe<Scalars['Int']['input']>;
  /** UUID of warehouse to filter by */
  warehouseUuid?: InputMaybe<Scalars['String']['input']>;
};

export enum PickupOrDelivery {
  Delivery = 'DELIVERY',
  Pickup = 'PICKUP',
  Recovery = 'RECOVERY',
  Transfer = 'TRANSFER'
}

export type PieceCountSortInput = {
  direction: SortOrder;
  nulls: NullsOrder;
};

export type PieceEntity = {
  __typename?: 'PieceEntity';
  additionalReferenceNumbers: Array<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  deliveredAt: Scalars['DateTime']['output'];
  markedOnHandAt: Scalars['String']['output'];
  name: Scalars['String']['output'];
  package?: Maybe<PackageEntity>;
  referenceNumber: Scalars['String']['output'];
  status: PieceStatus;
  terminal?: Maybe<TerminalEntity>;
  updatedAt: Scalars['DateTime']['output'];
  uuid: Scalars['String']['output'];
  warehouseLocation?: Maybe<WarehouseLocationEntity>;
};

export type PieceGroupEntity = {
  __typename?: 'PieceGroupEntity';
  pieceCount: Scalars['Int']['output'];
  pieces: Array<PieceEntity>;
  status: PieceStatus;
  /** Terminal where the pieces are located. This field is only populated when all pieces have arrived or departed from a terminal on a line haul lane. It is null if the status is awaiting or delivered, or if the order is not on a line haul lane. */
  terminal?: Maybe<TerminalEntity>;
};

export enum PieceStatus {
  Arrived = 'ARRIVED',
  Awaiting = 'AWAITING',
  Delivered = 'DELIVERED',
  Departed = 'DEPARTED'
}

export type PiecesDeliveredEntity = {
  __typename?: 'PiecesDeliveredEntity';
  deliveryScansCount: Scalars['Int']['output'];
};

export type PiecesGroupedByStatusInput = {
  orderUuid: Scalars['String']['input'];
};

export type PiecesGroupedByStatusOutput = {
  __typename?: 'PiecesGroupedByStatusOutput';
  pieceGroups: Array<PieceGroupEntity>;
};

export type PlaceCreateInput = {
  addressUpsertInput: AddressUpsertInput;
  appointmentTime?: InputMaybe<Scalars['DateTime']['input']>;
  notes: Scalars['String']['input'];
};

export type PlaceEntity = {
  __typename?: 'PlaceEntity';
  address: AddressEntity;
  appointmentTime?: Maybe<Scalars['DateTime']['output']>;
  createdAt: Scalars['DateTime']['output'];
  notes: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  uuid: Scalars['String']['output'];
};

export type PlaceUpdateInput = {
  addressUpsertInput?: InputMaybe<AddressUpsertInput>;
  appointmentTime?: InputMaybe<Scalars['DateTime']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  routeSlotUuid?: InputMaybe<Scalars['String']['input']>;
  uuid: Scalars['String']['input'];
};

/** A calendar date without a time zone. See https://tc39.es/proposal-temporal/docs/plaindate.html */
export type PlainDate = {
  __typename?: 'PlainDate';
  /** A day of the month, from 1 through 31. */
  day: Scalars['Int']['output'];
  /** The plain date in ISO 8601 format. */
  iso8601: Scalars['String']['output'];
  /** A month number, from 1 through 12. 1 is January. */
  month: Scalars['Int']['output'];
  /** The year of the date */
  year: Scalars['Int']['output'];
};

export type PlainDateInput = {
  day: Scalars['Int']['input'];
  month: Scalars['Int']['input'];
  year: Scalars['Int']['input'];
};

export type PlainDateTime = {
  __typename?: 'PlainDateTime';
  date: PlainDate;
  time: PlainTime;
};

export type PlainDateTimeInput = {
  date: PlainDateInput;
  time: PlainTimeInput;
};

export type PlainTime = {
  __typename?: 'PlainTime';
  /** A 24-hour clock hour, from 0 through 23 */
  hour: Scalars['Int']['output'];
  /** A minute, from 0 through 59 */
  minute: Scalars['Int']['output'];
};

export type PlainTimeInput = {
  hour: Scalars['Int']['input'];
  minute: Scalars['Int']['input'];
};

export enum PodNamingConvention {
  Blume = 'BLUME',
  Btx = 'BTX',
  Data_2Logistics = 'DATA_2_LOGISTICS',
  Flexport = 'FLEXPORT',
  ForwardAirTiff = 'FORWARD_AIR_TIFF'
}

export type PostalResultEntity = {
  __typename?: 'PostalResultEntity';
  component: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type PreSignedPutUrlEntity = {
  __typename?: 'PreSignedPutUrlEntity';
  bucket: Scalars['String']['output'];
  filename: Scalars['String']['output'];
  filetype: Scalars['String']['output'];
  key: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type PreSignedUrlRequestInput = {
  filename: Scalars['String']['input'];
  filetype: Scalars['String']['input'];
};

export type PreviewAddOrdersToInvoicesForContactOutput = {
  __typename?: 'PreviewAddOrdersToInvoicesForContactOutput';
  contactName: Scalars['String']['output'];
  contactUuid: Scalars['String']['output'];
  existingInvoicesToUpdate: Array<ExistingInvoiceToUpdate>;
  newInvoicesToCreate: Array<NewInvoiceToCreate>;
};

export type PreviewAddOrdersToInvoicesInput = {
  addToExistingInvoices: Scalars['Boolean']['input'];
  orderUuids: Array<Scalars['String']['input']>;
};

export type PreviewAddOrdersToInvoicesOutput = {
  __typename?: 'PreviewAddOrdersToInvoicesOutput';
  invoicesToAddToByContact: Array<PreviewAddOrdersToInvoicesForContactOutput>;
};

export type PreviewParseCsvOrdersInput = {
  bucket: Scalars['String']['input'];
  csvOrderMappingUuid: Scalars['String']['input'];
  filename: Scalars['String']['input'];
  filetype: Scalars['String']['input'];
  key: Scalars['String']['input'];
};

export type PreviewParseCsvOrdersOutput = PreviewParseCsvOrdersSuccessOutput | QueryErrorOutput;

export type PreviewParseCsvOrdersSuccessOutput = {
  __typename?: 'PreviewParseCsvOrdersSuccessOutput';
  errors: Array<ParseCsvOrderRowErrorEntity>;
  parsedOrders: Array<ParsedCsvOrderEntity>;
};

export type PreviewProratedConsolidationInput = {
  shipmentUuids: Array<Scalars['String']['input']>;
};

/** the output of the API is a list of orders along with information about charges after prorating */
export type PreviewProratedConsolidationOutput = {
  __typename?: 'PreviewProratedConsolidationOutput';
  proratedOrders: Array<ProratedOrderInformation>;
};

export type PreviewProratedConsolidationV2Input = {
  consolidationMethod?: InputMaybe<OrderConsolidationMethod>;
  ordersToConsolidateWithUuids: Array<Scalars['String']['input']>;
  primaryOrderUuid: Scalars['String']['input'];
  shouldProrateInbound: Scalars['Boolean']['input'];
  shouldProrateOutbound: Scalars['Boolean']['input'];
};

export type PreviewProratedConsolidationV2Output = PreviewProratedConsolidationV2SuccessOutput | QueryErrorOutput;

export type PreviewProratedConsolidationV2SuccessOutput = {
  __typename?: 'PreviewProratedConsolidationV2SuccessOutput';
  consolidationMethod: OrderConsolidationMethod;
  proratedOrders: Array<ProratedOrder>;
  proratedOverview: ProratedOverview;
  totalAfterProrating: Scalars['Float']['output'];
  /** The sum of the weights of the orders that were consolidated */
  totalWeightConsolidated: Scalars['Float']['output'];
};

export type PreviousManifestError = {
  __typename?: 'PreviousManifestError';
  manifest: LineHaulManifestEntity;
  order: OrderEntity;
};

export enum ProductionCompany {
  Intellifreight = 'INTELLIFREIGHT',
  WiseChoice = 'WISE_CHOICE'
}

export type ProrateOrdersInput = {
  consolidationMethod?: InputMaybe<OrderConsolidationMethod>;
  ordersToConsolidateWithUuids: Array<Scalars['String']['input']>;
  primaryOrderUuid: Scalars['String']['input'];
  shouldProrateInbound: Scalars['Boolean']['input'];
  shouldProrateOutbound: Scalars['Boolean']['input'];
};

export type ProrateOrdersOutput = MutationErrorOutput | ProrateOrdersSuccessOutput;

export type ProrateOrdersSuccessOutput = {
  __typename?: 'ProrateOrdersSuccessOutput';
  orderUuids: Array<Scalars['String']['output']>;
};

/** the custom charge amount before and after prorating along with which orders the custom charge was present in before prorating (since after prorating it is split across orders) */
export type ProratedCustomCharge = {
  __typename?: 'ProratedCustomCharge';
  accessorialUuid?: Maybe<Scalars['String']['output']>;
  /** before prorating, which orders was this custom charge in. This helps us tell whether it was split or combined and split. */
  initialOrderUuidsPresentIn: Array<Scalars['String']['output']>;
  initialTotalCents?: Maybe<Scalars['Float']['output']>;
  name: Scalars['String']['output'];
  proratedTotalCents: Scalars['Float']['output'];
};

/** the custom charge amount before and after prorating along with which orders the custom charge was present in before prorating (since after prorating it is split across orders) */
export type ProratedCustomChargeV2 = {
  __typename?: 'ProratedCustomChargeV2';
  /** the total of the custom charge before prorating. It is null if this custom charge was not on this order before. */
  initialTotal?: Maybe<Scalars['Float']['output']>;
  name: Scalars['String']['output'];
  proratedTotal: Scalars['Float']['output'];
};

export type ProratedOrder = {
  __typename?: 'ProratedOrder';
  hawb?: Maybe<Scalars['String']['output']>;
  inboundShipment?: Maybe<ProratedShipment>;
  /** The initial line haul charges before prorating. It can just be a number because we are not prorating line haul yet */
  lineHaulInitialTotal?: Maybe<Scalars['Float']['output']>;
  name: Scalars['String']['output'];
  /** The initial order charges before prorating. It can just be a number because we are not prorating order charges yet */
  orderChargesInitialTotal?: Maybe<Scalars['Float']['output']>;
  outboundShipment?: Maybe<ProratedShipment>;
  proportionForConsolidation?: Maybe<Scalars['Float']['output']>;
  /** @deprecated This field is deprecated as we are introducing proportions for consolidation besides weight. Use proportionForConsolidation instead.  */
  proportionOfTotalWeight: Scalars['Float']['output'];
  /** The total after prorating including shipments that were not prorated */
  totalAfterProrating: Scalars['Float']['output'];
  uuid: Scalars['String']['output'];
  /** The weight of the order */
  weight: Scalars['Float']['output'];
};

export type ProratedOrderInformation = {
  __typename?: 'ProratedOrderInformation';
  inboundShipment?: Maybe<ProratedShipmentInformation>;
  order: OrderEntity;
  outboundShipment?: Maybe<ProratedShipmentInformation>;
};

export type ProratedOverview = {
  __typename?: 'ProratedOverview';
  customCharges?: Maybe<Array<SimpleCustomCharge>>;
  inboundFreightCharge?: Maybe<SimpleFreightCharge>;
  inboundFuelCharge?: Maybe<SimpleFuelCharge>;
  outboundFreightCharge?: Maybe<SimpleFreightCharge>;
  outboundFuelCharge?: Maybe<SimpleFuelCharge>;
};

export type ProratedShipment = {
  __typename?: 'ProratedShipment';
  customCharges: Array<ProratedCustomChargeV2>;
  /** The total of the freight charge in dollars before prorating. If it is null, the shipment did not have a freight charge */
  initialFreightChargeTotal?: Maybe<Scalars['Float']['output']>;
  /** The total of the fuel charge in dollars before prorating. If it is null, the shipment did not have a fuel charge */
  initialFuelChargeTotal?: Maybe<Scalars['Float']['output']>;
  /** The total of the freight charge in dollars after prorating. If the shipment is not prorated this will equal the initial total */
  proratedFreightChargeTotal?: Maybe<Scalars['Float']['output']>;
  /** The total of the fuel charge in dollars after prorating. If the shipment is not prorated this will equal the initial total */
  proratedFuelChargeTotal?: Maybe<Scalars['Float']['output']>;
};

export type ProratedShipmentInformation = {
  __typename?: 'ProratedShipmentInformation';
  customCharges: Array<ProratedCustomCharge>;
  freightAndFuelProrateMultiplier: Scalars['Float']['output'];
  initialFreightCharge?: Maybe<FreightChargeForProrating>;
  initialFuelCharge?: Maybe<FuelChargeForProrating>;
  isProrated: Scalars['Boolean']['output'];
  proratedFreightCharge?: Maybe<FreightChargeForProrating>;
  proratedFuelCharge?: Maybe<FuelChargeForProrating>;
  shipment: ShipmentEntity;
};

export type Query = {
  __typename?: 'Query';
  ablyToken: AblyTokenOutput;
  accessorial: AccessorialUnion;
  accessorialChargeDetailsReport: Array<AccessorialChargeDetailsEntity>;
  accessorialDateRangeConfigByUuid: AccessorialDateRangeConfigEntity;
  accessorialDateRangeConfigs: FindAccessorialDateRangeConfigsOutput;
  accessorialToQuickbooksMappingByContact: Array<AccessorialToQuickbooksMappingEntity>;
  accessorials: Array<AccessorialUnion>;
  accessorialsByBillingContact: Array<AccessorialUnion>;
  accountingReportFilters: AccountingReportFiltersOutput;
  accountsReceivableReport: Array<AccountsReceivableReportDataForContactEntity>;
  activeAgents: Array<AgentFieldsEntity>;
  agingReport: Array<AgingReportForContactEntity>;
  airportInfo: AirportInfoEntity;
  airportInfos: Array<AirportInfoEntity>;
  allScannedDocuments: Array<Scalars['String']['output']>;
  apiLog: ApiLogEntity;
  apiLogs: ApiLogConnection;
  /** Public resolver to get appointment confirmation info for this stop */
  appointmentConfirmationInfo: AppointmentConfirmationInfoOutput;
  appointmentOptions: AppointmentOptions;
  /** get stops, filtered by appointment time, for the appointment scheduling page */
  appointments: Array<StopEntity>;
  auditQuickbooksDesktopInvoiceTotals: Array<Scalars['String']['output']>;
  auditReport: Array<AuditReportBucketEntity>;
  auditShipmentOnInvoiceButOtherShipmentsNot?: Maybe<Scalars['String']['output']>;
  auditUnpostedSsfEdiInvoices: Scalars['Boolean']['output'];
  autoApplyAccessorialConfig?: Maybe<AutoApplyAccessorialConfigEntity>;
  autoApplyAccessorialConfigs?: Maybe<Array<AutoApplyAccessorialConfigEntity>>;
  averageDaysToPayReport: Array<AverageDaysToPayForContactEntity>;
  businessDivisions: FindBusinessDivisionsOutput;
  chargeBreakdownReportCsv: ReportFileOutput;
  chargeBreakdownReportPdf: ChargeBreakdownReportPdfOutput;
  checkConsistencyOfInvoices: Array<Scalars['Boolean']['output']>;
  checkRegisterReport: Array<PaymentForCheckRegisterReportEntity>;
  /** Returns quotes for a client that belong to the specified company and meet the specified filter conditions. Used in the Pallet TMS quotes page. */
  clientQuotes: QuoteConnection;
  closestWarehouseToAddress?: Maybe<WarehouseEntity>;
  companies: Array<CompanyEntity>;
  company: CompanyEntity;
  companyByName?: Maybe<CompanyEntity>;
  companyByUuid?: Maybe<CompanyEntity>;
  companyConfiguration?: Maybe<CompanyConfigurationEntity>;
  companyConfigurationByCompanyUuid?: Maybe<CompanyConfigurationEntity>;
  companyContacts: Array<ContactEntity>;
  companyDocuments: Array<DocumentEntity>;
  companySchemas: Array<SchemaWithAnchorsEntity>;
  completedStopsNotOnRoutes: Array<StopEntity>;
  consigneePortalOrder: ConsigneePortalOrderEntity;
  contact: ContactEntity;
  contactCommunicationConfigs?: Maybe<Array<ContactCommunicationConfigEntity>>;
  contactEmails?: Maybe<Array<ContactEmailEntity>>;
  /** An unpaginated query for all items belonging to a contact. */
  contactItems: FindContactItemsOutput;
  contactOrderStatisticsForDateRange: ContactStatsEntity;
  contactPersons: Array<ContactPersonEntity>;
  contactServices: Array<ServiceEntity>;
  /** Get all stations for a specific contact */
  contactStations: Array<ContactStationEntity>;
  contacts: Array<ContactEntity>;
  contactsByUuids: Array<ContactEntity>;
  contactsReport: Array<ContactForContactReport>;
  coordinatesForAddress: CoordinatesForAddressEntity;
  coverSheetDocumentTypeSequences: Array<CoverSheetDocumentTypeSequenceEntity>;
  creditTypes: Array<CreditTypeEntity>;
  csvOrderImportTransactions: CsvOrderImportTransactionEntity;
  csvOrderMapping: CsvOrderMappingEntity;
  csvOrderMappings: Array<CsvOrderMappingEntity>;
  currentBillingPeriodInvoice: Array<InvoiceEntity>;
  customDriverForm?: Maybe<DriverSignableFormTemplateEntity>;
  customDriverForms?: Maybe<Array<DriverSignableFormTemplateEntity>>;
  customerPortalCompany: CompanyEntity;
  customerPortalOrders: OrderConnection;
  /** Returns quotes for a customer portal that the third party user has access to and meet the specified filter conditions. Used in the Pallet Customer Portal. */
  customerPortalQuotes: QuoteConnection;
  customerReport: Array<CustomerReportBucketEntity>;
  defaultGlobalSpecialAccessorials: Array<AccessorialUnion>;
  digitallySignableDocuments: Array<DocumentEntity>;
  /** All DispatchTableColorEntities sorted ascending by position */
  dispatchTableColors: Array<DispatchTableColorEntity>;
  dispatchViews: Array<DispatchViewEntity>;
  dispatchableDrivers: GetDispatchableDriversOutput;
  dockScanReport: DockScanReportOutput;
  document: DocumentEntity;
  documentForSigning: DocumentForSigningOutput;
  documents: Array<DocumentEntity>;
  documentsForSigning: Array<DocumentEntity>;
  driver: DriverEntity;
  driverByPhoneNumber?: Maybe<DriverEntity>;
  driverCompletedStopsLog: DriverCompletedStopsEntity;
  driverDailyLogReportPdf: ReportPdfOutput;
  driverOrders: DriverOrdersOutput;
  driverQualifications: Array<DriverQualificationEntity>;
  driverReport: Array<DriverReportBucketEntity>;
  driverSettlementBill: DriverSettlementBillEntity;
  driverSettlementBills: DriverSettlementBillConnection;
  driverSettlementBillsCountForCompany: Scalars['Float']['output'];
  driverSettlementBillsForDownload: Array<DriverSettlementBillForDownloadEntity>;
  drivers: Array<DriverEntity>;
  dummyQuery: Scalars['String']['output'];
  dunningReportPdf: ReportPdfOutput;
  ediAndApiOrdersForReview: OrderConnection;
  ediTransactions: EdiTransactionConnection;
  ediTransactionsByCompany: EdiTransactionConnection;
  emailTransactions: FindEmailTransactionsOutput;
  endOfDayDocumentProcessingJobs: Array<EndOfDayDocumentProcessingJobEntity>;
  equipment: EquipmentEntity;
  equipmentLicenses: Array<EquipmentLicenseEntity>;
  equipments: Array<EquipmentEntity>;
  etaForCustomerPortal?: Maybe<EtaEntity>;
  featureFlag?: Maybe<FeatureFlagEntity>;
  featureFlagCompanyOverrides: Array<FeatureFlagCompanyOverrideEntity>;
  featureFlagUserOverrides: Array<FeatureFlagUserOverrideEntity>;
  featureFlags: Array<FeatureFlagEntity>;
  featureFlagsForCompanyGivenUuid: Array<FeatureFlagEntity>;
  findByOrderUuid: EdiTransactionEntity;
  findCompanyOrdersInDateRange: FindCompanyOrdersInDateRangeOutput;
  findDefaultTariffGroupForCompany?: Maybe<TariffGroupEntity>;
  findDefaultTransferTariffGroupForCompany?: Maybe<TariffGroupEntity>;
  findOrderByShipperBillOfLadingNumber: FindOrderByShipperBillOfLadingNumberOutput;
  findOutboundRequest: Scalars['String']['output'];
  findServicesForCustomerConfiguration: FindServicesForCustomerConfigurationOutput;
  findTariffGroups: Array<ContactToServicesTariffGroupMappingEntity>;
  findTariffGroupsWithContactAndServiceCombination: Array<FindTariffGroupsWithContactAndServicesCombinationOutput>;
  findTariffZoneByUuid: TariffZoneEntity;
  findTariffZoneByUuidOrThrow: TariffZoneEntity;
  firstScannedOrderResultInReview?: Maybe<ScannedOrderResultEntity>;
  freightCost: FreightCostEntity;
  /** Tries to find a fuel profile date range for the fuel charge that the specified date to use falls within. */
  fuelChargeFuelProfileDateRange: FuelChargeFuelProfileDateRangeOutput;
  fuelCost: FuelCostEntity;
  fuelProfile: FindFuelProfileOutput;
  fuelProfileDateRanges: FindFuelProfileDateRangesOutput;
  fuelProfiles: Array<FuelProfileEntity>;
  fuzzySearchItemsBySkuName: FuzzySearchItemsBySkuNameOutput;
  /** Returns the most recently created order that meets the required similarity threshold */
  fuzzySearchOrdersByShippingBillOfLadingNumber: FuzzySearchOrdersByShipperBillOfLadingNumberOutput;
  fuzzySearchStorageOrders: FuzzySearchStorageOrdersOutput;
  fuzzySearchStorageUnits: FuzzySearchStorageUnitsOutput;
  generalLedgerCodes: Array<GeneralLedgerCodeEntity>;
  generalLedgerConfiguration?: Maybe<GeneralLedgerConfigurationEntity>;
  generateCsvOrderPreSignedPutUrls: Array<CsvOrderPreSignedPutUrlEntity>;
  generateCsvPresignedPutUrlForMappingPreview: GenerateCsvPresignedPutUrlForMappingPreviewOutput;
  generateDefaultAppointmentTexts: Array<DefaultAppointmentTextOutput>;
  generateRoutes: GenerateRoutesOutput;
  generateScannedOrderPreSignedPutUrls: Array<PreSignedPutUrlEntity>;
  /** Given a zipcode, invokes the Google Maps Geocode JSON API and returns a list of possible city and state options for that zipcode */
  getCityAndStateOptionsFromZipcode: GetCityAndStateOptionsFromZipcodeOutput;
  getFreightCharge: FreightChargeEntity;
  getInvoiceCsvs?: Maybe<FormatCsvResEntity>;
  getJsonSchemaWithOverride: Scalars['String']['output'];
  /** This is probably not the method you want to use */
  getLegDriverMap: LegDriverMapEntity;
  getLineHaulProgress: GetLineHaulProgressOutput;
  getNexusShipments: Scalars['String']['output'];
  getOptimizationResults?: Maybe<OptimizationResultsOutput>;
  getOrderTableFieldValues: GetOrderTableFieldValuesOutput;
  getPackage: PackageEntity;
  getQuickbooksToken?: Maybe<Scalars['String']['output']>;
  getSavedFilterViews: Array<SavedFilterViewEntity>;
  getSchemaMatchDetails: Scalars['String']['output'];
  getSftpCredentials?: Maybe<SftpCredentialsEntity>;
  getStandardOrderFields: StandardOrderFieldsEntity;
  getStandardShipmentFields: StandardShipmentFieldsEntity;
  getStructuredExtractionSchemaOverride?: Maybe<StructuredExtractionSchemaOverrideEntity>;
  getTag: TagEntity;
  getTags: Array<TagEntity>;
  getXYTransform: XyTransformEntity;
  /** Given a city and state, invokes the Smarty US Zipcode API and returns a list of possible zipcodes for that city and state */
  getZipcodeOptionsFromCityAndState: GetZipcodeOptionsFromCityAndStateOutput;
  glCodeReportPdf: ReportPdfOutput;
  groupByStops: GroupByStopsOutput;
  holdReasons: Array<HoldReasonEntity>;
  incomeAnalysisReport: Array<CustomerReportBucketEntity>;
  incompleteLegsWithAttempts: Array<LegEntity>;
  ingestedOutlookEmail: IngestedOutlookEmailEntity;
  ingestedOutlookEmailAttachments: IngestedOutlookEmailAttachmentConnection;
  ingestedOutlookEmails: IngestedOutlookEmailConnection;
  internalOnly_featureFlagsGlobal: Array<FeatureFlagEntity>;
  invoice?: Maybe<InvoiceEntity>;
  invoiceBillingSummaryReportV2: InvoiceBillingSummaryV2Output;
  invoiceBillingSummaryReportV2Pdf: InvoiceBillingSummaryV2PdfOutput;
  invoiceBillingSummaryReportV2PdfUrl: Scalars['String']['output'];
  invoiceDocuments: Array<DocumentEntity>;
  /** Given an invoice, retrieves all the EDI transactions associated with that invoice */
  invoiceEdiTransactions: FindInvoiceEdiTransactionsOutput;
  invoiceEmailsApiLogs: FindInvoiceEmailsApiLogsOutput;
  invoiceRegisterReportCsv: ReportFileOutput;
  invoiceRegisterReportPdf: ReportPdfOutput;
  invoiceSendJobBatches: InvoiceSendJobBatchConnection;
  invoiceSendJobs: InvoiceSendJobConnection;
  invoiceTerms: Array<InvoiceTermEntity>;
  invoices: InvoiceConnection;
  invoicesByUuids: Array<InvoiceEntity>;
  item: ItemEntity;
  itemGroups: ItemGroupConnection;
  itemLocations: Array<ItemLocationEntity>;
  items: ItemConnection;
  itemsBySkuName: Array<ItemEntity>;
  laneFromOriginAndDestinationTerminal: FindLaneFromOriginAndDestinationTerminalOutput;
  leg?: Maybe<LegEntity>;
  legs: Array<LegEntity>;
  /** Tries to find a line haul fuel profile date range for the fuel charge that the specified date to use falls within. */
  lineHaulFuelChargeFuelProfileDateRange: LineHaulFuelChargeFuelProfileDateRangeOutput;
  lineHaulLane: LineHaulLaneEntity;
  lineHaulLanes: Array<LineHaulLaneEntity>;
  lineHaulManifest: LineHaulManifestEntity;
  lineHaulManifests: FindLineHaulManifestsOutput;
  lineHaulManifestsGroups: LineHaulManifestsCategoryGroupsOutput;
  lineHaulSegment: LineHaulSegmentEntity;
  lineHaulSegments: Array<LineHaulSegmentEntity>;
  mapboxDirections: Scalars['Boolean']['output'];
  mapboxMatrix: Scalars['Boolean']['output'];
  masterAccounts: FindMasterAccountsOutput;
  me?: Maybe<UserEntity>;
  meAsThirdPartyUser?: Maybe<ThirdPartyUserEntity>;
  meDriver: DriverEntity;
  mobileFeatureFlag?: Maybe<FeatureFlagEntity>;
  myGroupedStopUuids: Array<Array<Scalars['String']['output']>>;
  /** Return today's stops for the current driver */
  myRoute?: Maybe<RouteEntity>;
  /** Return routes for the current driver */
  myRoutes?: Maybe<RouteConnection>;
  /** Return today's stops for the current driver */
  myStops: Array<StopEntity>;
  /** Return stops for the current driver by the UUIDs */
  myStopsByUuids: Array<StopEntity>;
  netSalesSummaryReport: NetSalesSummaryReportOutput;
  notifications: Array<NotificationEntity>;
  /** @deprecated Prefer orderTableFieldValues with totalCount set to true instead */
  numberOfOrders: Scalars['Float']['output'];
  numberOfScannedOrderResultDuplicates: Scalars['Int']['output'];
  numberOfScannedOrderResultsApproved: Scalars['Int']['output'];
  numberOfScannedOrderResultsFailed: Scalars['Int']['output'];
  numberOfScannedOrderResultsInProgress: Scalars['Int']['output'];
  numberOfScannedOrderResultsInReview: Scalars['Int']['output'];
  numberOfScannedOrderResultsRejected: Scalars['Int']['output'];
  numberOfStops: Scalars['Float']['output'];
  onTimePerformanceReportCsv: ReportFileOutput;
  onTimePerformanceReportPdf: ReportFileOutput;
  openInvoiceReport: Array<InvoiceForOpenInvoiceReportEntity>;
  order?: Maybe<OrderEntity>;
  /** Given a payment amount and invoices, preview applying payment to orders across invoices. Return amount applied and new+current balances. */
  orderAmountsToPayForInvoice: Array<OrderToChargeEntity>;
  orderAuditLogEntries?: Maybe<GetOrderAuditLogEntriesOutput>;
  /** Comments for an order */
  orderComments: Array<OrderCommentEntity>;
  orderEventNotificationSubscriptions: Array<OrderEventNotificationSubscriptionEntity>;
  orderEvents?: Maybe<Array<OrderEventEntity>>;
  orderFormFields: OrderFormFieldsEntity;
  orderImportConfiguration: OrderImportConfigurationEntity;
  orderName: Scalars['String']['output'];
  orderReport: Array<OrderReportBucketEntity>;
  orderReportByReportGroup: Array<OrderReportBucketEntity>;
  orderRevenueReport: RevenueReportOrderConnection;
  orderTableFieldHeaders: GetOrderTableFieldHeadersOutput;
  orderVolumeByCompanyReport: Array<OrderVolumeCompanyBucketEntity>;
  orderVolumeByContactReport: Array<OrderVolumeContactBucketEntity>;
  orderVolumeByDateRangeReport: Array<OrderVolumeDateRangeBucketEntity>;
  orderVolumeBySchemaReport: Array<OrderVolumeSchemaBucketEntity>;
  orderVolumeByUserReport: Array<OrderVolumeUserBucketEntity>;
  orders: OrderConnection;
  ordersByMasterAirwayBillOfLadingNumber: Array<OrderEntity>;
  ordersBySecondaryRefNumber: Array<OrderEntity>;
  ordersByShipperBillOfLadingNumber: Array<OrderEntity>;
  ordersByUuids: Array<OrderEntity>;
  ordersForPayments: OrderConnection;
  organization: OrganizationEntity;
  organizationNotes: Array<ContactCommentEntity>;
  organizations: Array<OrganizationEntity>;
  outlookIntegrations: Array<OutlookIntegrationEntity>;
  outstandingInvoicesForCustomer?: Maybe<Array<InvoiceEntity>>;
  outstandingOrdersForReview: OrderConnection;
  outstandingShipments: ShipmentConnection;
  overdueInvoices: Array<InvoiceEntity>;
  packageSpec: PackageSpecEntity;
  packageSpecs: FindPackageSpecsOutput;
  paginatedContacts: ContactConnection;
  paginatedOrdersByInvoice: OrderConnection;
  paginatedOrganizations: OrganizationConnection;
  paginatedRoutes: RouteConnection;
  parseAddress: Array<PostalResultEntity>;
  paymentApplicationReport: Array<PaymentForPaymentApplicationReportEntity>;
  paymentByUuid?: Maybe<PaymentEntity>;
  paymentJournalReport: Array<PaymentForPaymentJournalReportEntity>;
  paymentsByInvoiceUuid: Array<PaymentEntity>;
  paymentsV2: PaymentConnection;
  pdfColumn: PdfColumnEntity;
  person: PersonEntity;
  /** Find all persons for the signed in user’s company or for the specified contact */
  persons: FindPersonsOutput;
  picklists: PicklistConnection;
  piece: PieceEntity;
  piecesGroupedByStatus: PiecesGroupedByStatusOutput;
  ping: Scalars['String']['output'];
  place: PlaceEntity;
  previewAddOrdersToInvoices: PreviewAddOrdersToInvoicesOutput;
  previewBatchAddShipmentsToInvoices: BatchAddShipmentsToInvoicePreview;
  previewBatchAddShipmentsToInvoicesMultiple: Array<BatchAddShipmentsToInvoicePreview>;
  previewParseCsvOrders: PreviewParseCsvOrdersOutput;
  previewProratedConsolidation: PreviewProratedConsolidationOutput;
  previewProratedConsolidationV2: PreviewProratedConsolidationV2Output;
  queryQuickbooksDesktopAccounts: QuickbooksDesktopResultEntity;
  queryQuickbooksDesktopCustomers: QuickbooksDesktopResultEntity;
  queryQuickbooksDesktopInvoices: Array<QuickbooksDesktopInvoiceEntity>;
  queryQuickbooksDesktopItems: QuickbooksDesktopResultEntity;
  quickbooksCustomers?: Maybe<Array<QuickbooksCustomerEntity>>;
  quickbooksHeaderFileMappings: Array<QuickbooksHeaderFileMappingEntity>;
  quickbooksItems?: Maybe<Array<QuickbooksItemEntity>>;
  quickbooksOAuthUrl: Scalars['String']['output'];
  quote: QuoteEntity;
  quoteName: Scalars['String']['output'];
  quotes: QuoteConnection;
  rateAutoAppliedAccessorials: RateAutoAppliedAccessorialsOutput;
  rateOrderByUuid: RateOrderOutput;
  rateOrderContents: RateOrderOutput;
  receiptItemStorageUnits: Array<StorageUnitEntity>;
  recurringOrderFrequency: RecurringOrderFrequencyEntity;
  recurringOrderTemplates: Array<OrderEntity>;
  recurringRuns: Array<RunEntity>;
  referenceNumberFormatConfigs?: Maybe<Array<ReferenceNumberFormatConfigEntity>>;
  remainingAmountOfInvoices: Scalars['Float']['output'];
  renderServices: Array<RenderServiceWithDeploysEntity>;
  reportGroupConfigurations: Array<ReportGroupConfigurationEntity>;
  reportSendJobBatches: FindReportSendJobBatchesOutput;
  reportSendJobs: FindReportSendJobsOutput;
  reportsEmailSenderIsVerified?: Maybe<Scalars['Boolean']['output']>;
  role: FindRoleOutput;
  roles: FindRolesOutput;
  route: RouteEntity;
  routeName?: Maybe<RouteNameEntity>;
  routeNames: Array<RouteNameEntity>;
  routes: Array<RouteEntity>;
  routesSamsaraVehicleLocations: RoutesSamsaraVehicleLocationsOutput;
  sageBusinessWorksInvoiceExportCsv: ReportFileOutput;
  salesVarianceReportCsv: ReportFileOutput;
  /** Get the Samsara OAuth authorize URL */
  samaraOAuthAuthorizeUrl: Scalars['String']['output'];
  sameDayDispatchConfig?: Maybe<SameDayDispatchConfigEntity>;
  samsaraDriverVehicleAssignments?: Maybe<Scalars['String']['output']>;
  samsaraDrivers?: Maybe<SamsaraDriversEntity>;
  samsaraOAuthToken?: Maybe<SamsaraOauthTokenEntity>;
  samsaraVehicleStatsFeed?: Maybe<SamsaraVehicleStatsFeedEntity>;
  samsaraVehicles?: Maybe<SamsaraVehiclesEntity>;
  scannedOrder?: Maybe<ScannedOrderEntity>;
  scannedOrderResult?: Maybe<ScannedOrderResultEntity>;
  scannedOrderResultByOrderUuid?: Maybe<ScannedOrderResultEntity>;
  scannedOrderResults: ScannedOrderResultConnection;
  scannedOrderResultsForAdmin: ScannedOrderResultConnection;
  scannedOrders: ScannedOrderConnection;
  schedulingRegion: SchedulingRegionEntity;
  schedulingRegions: FindSchedulingRegionsOutput;
  schemaCompanyMappings: Array<SchemaCompanyMappingEntity>;
  schemaDocumentsBySchemaCompanyMapping: Array<SchemaDocumentEntity>;
  schemaFilePutUrl: Scalars['String']['output'];
  schemaRun?: Maybe<SchemaRunEntity>;
  schemaRunTestList: SchemaRunTestListEntity;
  schemaRunTestSnapshots: Array<SchemaRunEntity>;
  schemaTestFilePutUrl: Scalars['String']['output'];
  schemas: Array<SchemaWithAnchorsEntity>;
  searchSchemas: Array<SchemaEntity>;
  segmentedLineHaulOrders: OrderLineHaulSegmentConnection;
  segmentedLineHaulOrdersV2: OrderLineHaulSegmentOutput;
  selectSpecialAccessorial: SelectSpecialAccessorialOutput;
  senderIsVerified?: Maybe<Scalars['String']['output']>;
  serviceLevelReport: Array<ServiceLevelReportBucketEntity>;
  serviceRegion: ServiceRegionEntity;
  serviceRegions: GetServiceRegionsOutput;
  services: Array<ServiceEntity>;
  servicesForOrder: FindServicesForOrderOutput;
  servicesForThirdPartyUser: Array<ServiceEntity>;
  settlementBillLineItem: SettlementBillLineItemEntity;
  /** Pulls line items that are settled or settle-able (aka associated with completed stops) */
  settlementBillLineItems: SettlementBillLineItemConnection;
  settlementDeductionTypes: Array<SettlementDeductionTypeEntity>;
  sftpUploads: SftpUploadConnection;
  shipment: ShipmentEntity;
  shipmentV2?: Maybe<ShipmentEntity>;
  shipments: Array<ShipmentEntity>;
  shipmentsByContactUuid?: Maybe<Array<ShipmentEntity>>;
  shipmentsByPhoneOrReferenceNumber: Array<ShipmentEntity>;
  standardAccessorials: Array<StandardAccessorialEntity>;
  standardOrder: StandardOrderEntity;
  standardOrderForReview?: Maybe<StandardOrderEntity>;
  stationReport: Array<StationReportBucketEntity>;
  stop: StopEntity;
  stopDriverMaps: StopDriverMapConnection;
  /** Get stops for a company. Recurring run headers are included only when there are stops loaded in the cache. */
  stops: CachedStopConnection;
  stopsBySearchText: Array<StopEntity>;
  stopsOnRoutesBySearchText: Array<StopEntity>;
  storageOrder: FindStorageOrderOutput;
  storageOrderStorageUnits: FindStorageOrderStorageUnitsOutput;
  storageOrders: FindStorageOrdersOutput;
  storageUnit: FindStorageUnitOutput;
  storageUnitByName?: Maybe<StorageUnitEntity>;
  storageUnits: FindStorageUnitsOutput;
  structuredExtractionRunByScannedOrder?: Maybe<StructuredExtractionRunEntity>;
  tableFields?: Maybe<TableFieldsEntity>;
  tariff: TariffEntity;
  tariffChains: Array<TariffChainEntity>;
  tariffGroup: TariffGroupEntity;
  tariffGroups: Array<TariffGroupEntity>;
  tariffGroupsPaginated: TariffGroupConnection;
  tariffZoneGroup: TariffZoneGroupEntity;
  tariffZoneGroups: Array<TariffZoneGroupEntity>;
  tariffZones: Array<TariffZoneEntity>;
  tariffsByContact: Array<TariffEntity>;
  templateAddresses: Array<AddressEntity>;
  terminal: TerminalEntity;
  terminalForAddress: FindTerminalForAddressOutput;
  terminalReport: Array<TerminalReportBucketEntity>;
  terminals: Array<TerminalEntity>;
  terminalsForAddress: FindTerminalsForAddressOutput;
  terminalsForInternal: Array<TerminalEntity>;
  terminalsForThirdPartyUser: Array<TerminalEntity>;
  testJsonSchemaOnDocumentsForSchema: TestJsonSchemaOnDocumentsForSchemaOutput;
  testOrder: FindTestOrderOutput;
  testOrders: FindTestOrdersOutput;
  textMessages: Array<TextMessageEntity>;
  thirdPartyBrokers: Array<ThirdPartyBrokerEntity>;
  thirdPartyUser?: Maybe<ThirdPartyUserEntity>;
  thirdPartyUserByUuid?: Maybe<ThirdPartyUserEntity>;
  thirdPartyUsersByContact: Array<ThirdPartyUserEntity>;
  throwError: Scalars['Boolean']['output'];
  unappliedPaymentReportCsv: ReportFileOutput;
  /** @deprecated Use individual unified queries instead */
  unifiedSearch: UnifiedSearchEntity;
  unifiedSearchInvoices: InvoiceConnection;
  unifiedSearchOrders: OrderConnection;
  unifiedSearchQuotes: QuoteConnection;
  unifiedSearchUnacceptedEdiAndApiOrders: OrderConnection;
  unifiedSearchUnacceptedEmailOrders: ScannedOrderResultConnection;
  user?: Maybe<UserEntity>;
  userContactNotificationSubscription?: Maybe<UserContactNotificationSubscriptionEntity>;
  userRoles: Array<RoleEntity>;
  users: Array<UserEntity>;
  usersEditingOrder?: Maybe<Array<UserEntity>>;
  vehicleType: VehicleTypeEntity;
  vehicleTypes: Array<VehicleTypeEntity>;
  verifySchemaDocumentMatchesForCompany: Scalars['String']['output'];
  warehouse?: Maybe<WarehouseEntity>;
  /** @deprecated Changing naming to more accurately represent purpose of api, see startingAddressForRoute */
  warehouseAddressOfFirstRouteSlot?: Maybe<AddressEntity>;
  warehouseEmployees: FindWarehouseEmployeesOutput;
  warehouseLocations: FindWarehouseLocationsOutput;
  warehouses?: Maybe<Array<WarehouseEntity>>;
  /** returns all contacts with storage orders associated with them to enable ease of filtering by WMS contacts. If called by the customer portal, only returns contacts that the user has access to */
  wmsContacts: Array<ContactEntity>;
};


export type QueryAccessorialArgs = {
  uuid: Scalars['String']['input'];
};


export type QueryAccessorialChargeDetailsReportArgs = {
  args: AccessorialChargeDetailsReportArgs;
};


export type QueryAccessorialDateRangeConfigByUuidArgs = {
  uuid: Scalars['String']['input'];
};


export type QueryAccessorialDateRangeConfigsArgs = {
  findAccessorialDateRangeConfigsInput: FindAccessorialDateRangeConfigsInput;
};


export type QueryAccessorialToQuickbooksMappingByContactArgs = {
  contactUuid: Scalars['String']['input'];
};


export type QueryAccessorialsArgs = {
  contactUuid?: InputMaybe<Scalars['String']['input']>;
  includeArchived?: InputMaybe<Scalars['Boolean']['input']>;
  onlyShowCompanyAccessorials?: InputMaybe<Scalars['Boolean']['input']>;
  terminalUuid?: InputMaybe<Scalars['String']['input']>;
  terminalUuids?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type QueryAccessorialsByBillingContactArgs = {
  billingPartyContactUuid?: InputMaybe<Scalars['String']['input']>;
  includeArchived?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  onlyShowCompanyAccessorials?: InputMaybe<Scalars['Boolean']['input']>;
  terminalUuid?: InputMaybe<Scalars['String']['input']>;
  terminalUuids?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type QueryAccountingReportFiltersArgs = {
  accountingReportFiltersInput: AccountingReportFilterTypesInput;
};


export type QueryAccountsReceivableReportArgs = {
  args: AccountsReceivableReportArgs;
};


export type QueryAgingReportArgs = {
  args: InvoiceAgingReportArgs;
};


export type QueryAirportInfoArgs = {
  uuid: Scalars['String']['input'];
};


export type QueryApiLogArgs = {
  uuid: Scalars['String']['input'];
};


export type QueryApiLogsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  createdAtDateFilters?: InputMaybe<Array<DateFilter>>;
  emailTransactionStatus?: InputMaybe<EmailTransactionStatus>;
  first?: InputMaybe<Scalars['Int']['input']>;
  freightSnapFailureReason?: InputMaybe<FreightSnapFailureReason>;
  freightSnapTransactionStatus?: InputMaybe<FreightSnapTransactionStatus>;
  invoiceFailed?: InputMaybe<Scalars['Boolean']['input']>;
  invoiceUuid?: InputMaybe<Scalars['String']['input']>;
  isFreightSnap?: InputMaybe<Scalars['Boolean']['input']>;
  isInvoiceEmails?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  noMaximum?: InputMaybe<Scalars['Boolean']['input']>;
  searchText?: InputMaybe<Scalars['String']['input']>;
  sortByCreatedAtDateAsc?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryAppointmentConfirmationInfoArgs = {
  uuid: Scalars['String']['input'];
};


export type QueryAppointmentOptionsArgs = {
  input: AppointmentOptionsInput;
};


export type QueryAppointmentsArgs = {
  deliveryDate?: InputMaybe<Scalars['DateTime']['input']>;
  hasAppointment?: InputMaybe<Scalars['Boolean']['input']>;
  onlyMissed?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryAuditQuickbooksDesktopInvoiceTotalsArgs = {
  companyUuid: Scalars['String']['input'];
};


export type QueryAuditReportArgs = {
  args: AuditReportArgs;
};


export type QueryAuditShipmentOnInvoiceButOtherShipmentsNotArgs = {
  companyUuid: Scalars['String']['input'];
};


export type QueryAutoApplyAccessorialConfigArgs = {
  uuid: Scalars['String']['input'];
};


export type QueryChargeBreakdownReportCsvArgs = {
  chargeBreakdownReportInput?: InputMaybe<ChargeBreakdownReportPdfInput>;
  input?: InputMaybe<ChargeBreakdownReportInput>;
};


export type QueryChargeBreakdownReportPdfArgs = {
  chargeBreakdownReportPdfInput?: InputMaybe<ChargeBreakdownReportPdfInput>;
  input?: InputMaybe<ChargeBreakdownReportInput>;
};


export type QueryCheckConsistencyOfInvoicesArgs = {
  checkConsistencyOfInvoicesInput: CheckConsistencyOfInvoicesInput;
};


export type QueryCheckRegisterReportArgs = {
  args: FindPaymentsV2Args;
};


export type QueryClientQuotesArgs = {
  findClientQuotesInput: FindClientQuotesInput;
};


export type QueryClosestWarehouseToAddressArgs = {
  addressLatitude: Scalars['Float']['input'];
  addressLongitude: Scalars['Float']['input'];
};


export type QueryCompanyByNameArgs = {
  name: Scalars['String']['input'];
};


export type QueryCompanyByUuidArgs = {
  uuid: Scalars['String']['input'];
};


export type QueryCompanyConfigurationByCompanyUuidArgs = {
  uuid: Scalars['String']['input'];
};


export type QueryCompanyContactsArgs = {
  companyUuid: Scalars['String']['input'];
  excludeNonActiveContacts?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryCompanyDocumentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  companyUuid: Scalars['String']['input'];
  date: Scalars['String']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  searchText?: InputMaybe<Scalars['String']['input']>;
  statusFilter: FindCompanyDocumentStatusFilter;
  terminalUuid?: InputMaybe<Scalars['String']['input']>;
  uploadDateAscending?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryCompletedStopsNotOnRoutesArgs = {
  date: Scalars['DateTime']['input'];
};


export type QueryConsigneePortalOrderArgs = {
  uuid: Scalars['String']['input'];
};


export type QueryContactArgs = {
  uuid: Scalars['String']['input'];
};


export type QueryContactCommunicationConfigsArgs = {
  contactUuid: Scalars['String']['input'];
};


export type QueryContactEmailsArgs = {
  contactUuid: Scalars['String']['input'];
};


export type QueryContactItemsArgs = {
  findContactItemsInput: FindContactItemsInput;
};


export type QueryContactOrderStatisticsForDateRangeArgs = {
  endDate: Scalars['String']['input'];
  startDate: Scalars['String']['input'];
  uuid: Scalars['String']['input'];
};


export type QueryContactServicesArgs = {
  contactUuid: Scalars['String']['input'];
};


export type QueryContactStationsArgs = {
  contactUuid: Scalars['String']['input'];
};


export type QueryContactsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  checkHasTariffZones?: InputMaybe<Scalars['Boolean']['input']>;
  checkHasTariffs?: InputMaybe<Scalars['Boolean']['input']>;
  companyUuid?: InputMaybe<Scalars['String']['input']>;
  excludeNonActive?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  invoiceUuids?: InputMaybe<Array<Scalars['String']['input']>>;
  last?: InputMaybe<Scalars['Int']['input']>;
  searchText?: InputMaybe<Scalars['String']['input']>;
  sortByContactName?: InputMaybe<Scalars['Boolean']['input']>;
  sortByOrderNumberAscending?: InputMaybe<Scalars['Boolean']['input']>;
  sortByOrderNumberDescending?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryContactsByUuidsArgs = {
  uuids: Array<Scalars['String']['input']>;
};


export type QueryCoordinatesForAddressArgs = {
  city?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  line1?: InputMaybe<Scalars['String']['input']>;
  line2?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  zip?: InputMaybe<Scalars['String']['input']>;
};


export type QueryCsvOrderImportTransactionsArgs = {
  orderUuid: Scalars['String']['input'];
};


export type QueryCsvOrderMappingArgs = {
  input: CsvOrderMappingQueryInput;
};


export type QueryCurrentBillingPeriodInvoiceArgs = {
  contactUuid: Scalars['String']['input'];
};


export type QueryCustomDriverFormArgs = {
  uuid: Scalars['String']['input'];
};


export type QueryCustomerPortalCompanyArgs = {
  uuid: Scalars['String']['input'];
};


export type QueryCustomerPortalOrdersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  appointmentDateFilters?: InputMaybe<DateFilterStartEnd>;
  before?: InputMaybe<Scalars['String']['input']>;
  companyFilter?: InputMaybe<Scalars['String']['input']>;
  completionDateFilters?: InputMaybe<DateFilterStartEnd>;
  contactFilter?: InputMaybe<Scalars['String']['input']>;
  contactsFilter?: InputMaybe<Array<Scalars['String']['input']>>;
  createdAtDateFilters?: InputMaybe<DateFilterStartEnd>;
  dispatched?: InputMaybe<BooleanFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  ofdOfp?: InputMaybe<BooleanFilter>;
  plannedDateFilters?: InputMaybe<DateFilterStartEnd>;
  receivedDateFilters?: InputMaybe<DateFilterStartEnd>;
  searchText?: InputMaybe<Scalars['String']['input']>;
  stopTypesFilter?: InputMaybe<StopTypesFilter>;
  thirdPartyUserUuid?: InputMaybe<Scalars['String']['input']>;
  totalCount?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryCustomerPortalQuotesArgs = {
  findCustomerPortalQuotesInput: FindCustomerPortalQuotesInput;
};


export type QueryCustomerReportArgs = {
  args: CustomerReportArgs;
};


export type QueryDigitallySignableDocumentsArgs = {
  orderUuid: Scalars['String']['input'];
};


export type QueryDispatchableDriversArgs = {
  getDispatchableDriversInput: GetDispatchableDriversInput;
};


export type QueryDockScanReportArgs = {
  dockScanReportInput: DockScanReportInput;
};


export type QueryDocumentArgs = {
  uuid: Scalars['String']['input'];
};


export type QueryDocumentForSigningArgs = {
  documentForSigningInput: DocumentForSigningInput;
};


export type QueryDocumentsArgs = {
  orderUuid: Scalars['String']['input'];
};


export type QueryDocumentsForSigningArgs = {
  documentType: DocumentType;
  orderUuid: Scalars['String']['input'];
};


export type QueryDriverArgs = {
  uuid: Scalars['String']['input'];
};


export type QueryDriverByPhoneNumberArgs = {
  phoneNumber: Scalars['String']['input'];
};


export type QueryDriverCompletedStopsLogArgs = {
  driverUuid?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
};


export type QueryDriverDailyLogReportPdfArgs = {
  driverDailyLogReportPdfInput: DriverDailyLogReportPdfInput;
};


export type QueryDriverOrdersArgs = {
  driverOrdersInput: DriverOrdersInput;
};


export type QueryDriverReportArgs = {
  args: DriverReportArgs;
};


export type QueryDriverSettlementBillArgs = {
  uuid: Scalars['String']['input'];
};


export type QueryDriverSettlementBillsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  driverUuid?: InputMaybe<Scalars['String']['input']>;
  driverUuids?: InputMaybe<Array<Scalars['String']['input']>>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  isFinalized?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  searchText?: InputMaybe<Scalars['String']['input']>;
  sortByBillStartDateAscending?: InputMaybe<Scalars['Boolean']['input']>;
  sortBySettlementDateAscending?: InputMaybe<Scalars['Boolean']['input']>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  uuids?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type QueryDriverSettlementBillsForDownloadArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  driverUuid?: InputMaybe<Scalars['String']['input']>;
  driverUuids?: InputMaybe<Array<Scalars['String']['input']>>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  isFinalized?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  searchText?: InputMaybe<Scalars['String']['input']>;
  sortByBillStartDateAscending?: InputMaybe<Scalars['Boolean']['input']>;
  sortBySettlementDateAscending?: InputMaybe<Scalars['Boolean']['input']>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  uuids?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type QueryDriversArgs = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryDunningReportPdfArgs = {
  dunningReportInput: DunningReportInput;
};


export type QueryEdiAndApiOrdersForReviewArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  contactUuid?: InputMaybe<Scalars['String']['input']>;
  createdAtDateFilters?: InputMaybe<DateFilterStartEnd>;
  destinationTerminalUuid?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  noMaximum?: InputMaybe<Scalars['Boolean']['input']>;
  originTerminalUuid?: InputMaybe<Scalars['String']['input']>;
  searchText?: InputMaybe<Scalars['String']['input']>;
  sortByCreatedAtDateAsc?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryEdiTransactionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  searchTerms?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type QueryEdiTransactionsByCompanyArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  companyUuid: Scalars['String']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryEmailTransactionsArgs = {
  findEmailTransactionsInput: FindEmailTransactionsInput;
};


export type QueryEndOfDayDocumentProcessingJobsArgs = {
  companyUuid: Scalars['String']['input'];
  dateUploadedFor: Scalars['DateTime']['input'];
  searchText?: InputMaybe<Scalars['String']['input']>;
  terminalUuid?: InputMaybe<Scalars['String']['input']>;
};


export type QueryEquipmentArgs = {
  uuid: Scalars['String']['input'];
};


export type QueryEquipmentLicensesArgs = {
  equipmentUuid: Scalars['String']['input'];
};


export type QueryEquipmentsArgs = {
  includeNotActive?: InputMaybe<Scalars['Boolean']['input']>;
  types?: InputMaybe<Array<EquipmentType>>;
};


export type QueryEtaForCustomerPortalArgs = {
  uuid: Scalars['String']['input'];
};


export type QueryFeatureFlagArgs = {
  featureFlagInput: FeatureFlagInput;
};


export type QueryFeatureFlagCompanyOverridesArgs = {
  getFeatureFlagCompanyOverridesInput: GetFeatureFlagCompanyOverridesInput;
};


export type QueryFeatureFlagUserOverridesArgs = {
  getFeatureFlagUserOverridesInput: GetFeatureFlagUserOverridesInput;
};


export type QueryFeatureFlagsForCompanyGivenUuidArgs = {
  uuid: Scalars['String']['input'];
};


export type QueryFindByOrderUuidArgs = {
  orderUuid: Scalars['String']['input'];
};


export type QueryFindCompanyOrdersInDateRangeArgs = {
  findCompanyOrdersInDateRangeInput: FindCompanyOrdersInDateRangeInput;
};


export type QueryFindOrderByShipperBillOfLadingNumberArgs = {
  findOrderByShipperBillOfLadingNumberInput: FindOrderByShipperBillOfLadingNumberInput;
};


export type QueryFindServicesForCustomerConfigurationArgs = {
  findServicesForCustomerConfigurationInput: FindServicesForCustomerConfigurationInput;
};


export type QueryFindTariffGroupsWithContactAndServiceCombinationArgs = {
  mappingsList: Array<ContactAndServicesCombination>;
};


export type QueryFindTariffZoneByUuidArgs = {
  uuid: Scalars['String']['input'];
};


export type QueryFindTariffZoneByUuidOrThrowArgs = {
  uuid: Scalars['String']['input'];
};


export type QueryFreightCostArgs = {
  id: Scalars['String']['input'];
};


export type QueryFuelChargeFuelProfileDateRangeArgs = {
  fuelChargeFuelProfileDateRangeInput: FuelChargeFuelProfileDateRangeInput;
};


export type QueryFuelCostArgs = {
  id: Scalars['String']['input'];
};


export type QueryFuelProfileArgs = {
  findFuelProfileInput: FindFuelProfileInput;
};


export type QueryFuelProfileDateRangesArgs = {
  findFuelProfileDateRangesInput: FindFuelProfileDateRangesInput;
};


export type QueryFuelProfilesArgs = {
  contactUuid?: InputMaybe<Scalars['String']['input']>;
  date?: InputMaybe<Scalars['DateTime']['input']>;
  excludeContactUuid?: InputMaybe<Scalars['String']['input']>;
  orderUuid?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<FuelProfileType>;
};


export type QueryFuzzySearchItemsBySkuNameArgs = {
  fuzzySearchItemsBySkuNameInput: FuzzySearchItemsBySkuNameInput;
};


export type QueryFuzzySearchOrdersByShippingBillOfLadingNumberArgs = {
  fuzzySearchOrdersByShipperBillOfLadingNumberInput: FuzzySearchOrdersByShipperBillOfLadingNumberInput;
};


export type QueryFuzzySearchStorageOrdersArgs = {
  fuzzySearchStorageOrdersInput: FuzzySearchStorageOrdersInput;
};


export type QueryFuzzySearchStorageUnitsArgs = {
  fuzzySearchStorageUnitsInput: FuzzySearchStorageUnitsInput;
};


export type QueryGenerateCsvOrderPreSignedPutUrlsArgs = {
  generateCsvOrderPresignedPutUrlInputs: Array<GenerateCsvOrderPresignedPutUrlInput>;
};


export type QueryGenerateCsvPresignedPutUrlForMappingPreviewArgs = {
  input: GenerateCsvPresignedPutUrlForMappingPreviewInput;
};


export type QueryGenerateDefaultAppointmentTextsArgs = {
  generateDefaultAppointmentTextsArgs: GenerateDefaultAppointmentTextsArgs;
};


export type QueryGenerateRoutesArgs = {
  generateRoutesInput: GenerateRoutesInput;
};


export type QueryGenerateScannedOrderPreSignedPutUrlsArgs = {
  preSignedUrlRequests: Array<PreSignedUrlRequestInput>;
};


export type QueryGetCityAndStateOptionsFromZipcodeArgs = {
  getCityAndStateOptionsFromZipcodeInput: GetCityAndStateOptionsFromZipcodeInput;
};


export type QueryGetFreightChargeArgs = {
  uuid: Scalars['String']['input'];
};


export type QueryGetInvoiceCsvsArgs = {
  getInvoiceCsvsInput: GetInvoiceCsvsInput;
};


export type QueryGetJsonSchemaWithOverrideArgs = {
  schemaUuid: Scalars['String']['input'];
};


export type QueryGetLegDriverMapArgs = {
  uuid: Scalars['String']['input'];
};


export type QueryGetLineHaulProgressArgs = {
  getLineHaulProgressInput: GetLineHaulProgressInput;
};


export type QueryGetOptimizationResultsArgs = {
  routeOptimizationUuid: Scalars['String']['input'];
};


export type QueryGetOrderTableFieldValuesArgs = {
  getOrderTableFieldValuesInput: GetOrderTableFieldValuesInput;
};


export type QueryGetPackageArgs = {
  uuid: Scalars['String']['input'];
};


export type QueryGetSavedFilterViewsArgs = {
  pageType: Scalars['String']['input'];
};


export type QueryGetSchemaMatchDetailsArgs = {
  getSchemaMatchDetailsInput: GetSchemaMatchDetailsInput;
};


export type QueryGetSftpCredentialsArgs = {
  uuid: Scalars['String']['input'];
};


export type QueryGetStandardOrderFieldsArgs = {
  uuid: Scalars['String']['input'];
};


export type QueryGetStandardShipmentFieldsArgs = {
  uuid: Scalars['String']['input'];
};


export type QueryGetStructuredExtractionSchemaOverrideArgs = {
  schemaUuid: Scalars['String']['input'];
};


export type QueryGetTagArgs = {
  uuid: Scalars['String']['input'];
};


export type QueryGetXyTransformArgs = {
  getXyTransformInput: GetXyTransformInput;
};


export type QueryGetZipcodeOptionsFromCityAndStateArgs = {
  getZipcodeOptionsFromCityAndStateInput: GetZipcodeOptionsFromCityAndStateInput;
};


export type QueryGlCodeReportPdfArgs = {
  glCodeReportPdfInput: GlCodeReportPdfInput;
};


export type QueryGroupByStopsArgs = {
  groupByStopsInput: GroupByStopsInput;
};


export type QueryHoldReasonsArgs = {
  archived?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryIncomeAnalysisReportArgs = {
  args: IncomeAnalysisReportArgs;
};


export type QueryIngestedOutlookEmailArgs = {
  uuid: Scalars['String']['input'];
};


export type QueryIngestedOutlookEmailAttachmentsArgs = {
  findIngestedOutlookEmailAttachmentsInput: FindIngestedOutlookEmailAttachmentsInput;
};


export type QueryIngestedOutlookEmailsArgs = {
  findIngestedOutlookEmailsInput: FindIngestedOutlookEmailsInput;
};


export type QueryInvoiceArgs = {
  uuid: Scalars['String']['input'];
};


export type QueryInvoiceBillingSummaryReportV2Args = {
  invoiceBillingSummaryV2Input: InvoiceBillingSummaryV2Input;
};


export type QueryInvoiceBillingSummaryReportV2PdfArgs = {
  invoiceBillingSummaryV2Input: InvoiceBillingSummaryV2Input;
};


export type QueryInvoiceBillingSummaryReportV2PdfUrlArgs = {
  invoiceBillingSummaryV2Input: InvoiceBillingSummaryV2Input;
};


export type QueryInvoiceDocumentsArgs = {
  invoiceUuid: Scalars['String']['input'];
};


export type QueryInvoiceEdiTransactionsArgs = {
  findInvoiceEdiTransactionsInput: FindInvoiceEdiTransactionsInput;
};


export type QueryInvoiceEmailsApiLogsArgs = {
  findInvoiceEmailsApiLogsInput: FindInvoiceEmailsApiLogsInput;
};


export type QueryInvoiceRegisterReportCsvArgs = {
  invoiceRegisterReportInput: InvoiceRegisterReportInput;
};


export type QueryInvoiceRegisterReportPdfArgs = {
  invoiceRegisterReportInput: InvoiceRegisterReportInput;
};


export type QueryInvoiceSendJobBatchesArgs = {
  acknowledged?: InputMaybe<Scalars['Boolean']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  createdAtDateFilters?: InputMaybe<Array<DateFilter>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasFailures?: InputMaybe<Scalars['Boolean']['input']>;
  inProgress?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sortByCreatedAtAsc?: InputMaybe<Scalars['Boolean']['input']>;
  type?: InputMaybe<InvoiceSendJobBatchType>;
  uuids?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type QueryInvoiceSendJobsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  invoiceSendJobBatchUuid: Scalars['String']['input'];
  invoiceSendJobStatus?: InputMaybe<InvoiceSendJobStatus>;
  last?: InputMaybe<Scalars['Int']['input']>;
  searchText?: InputMaybe<Scalars['String']['input']>;
  uuids?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type QueryInvoicesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  billingPartyContactUuid?: InputMaybe<Scalars['String']['input']>;
  businessDivisionUuid?: InputMaybe<Scalars['String']['input']>;
  createdAtEndDate?: InputMaybe<Scalars['DateTime']['input']>;
  createdAtStartDate?: InputMaybe<Scalars['DateTime']['input']>;
  destinationTerminalUuid?: InputMaybe<Scalars['String']['input']>;
  emailSendStatus?: InputMaybe<EmailSendStatus>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  groupByContact?: InputMaybe<Scalars['Boolean']['input']>;
  hasZeroBalance?: InputMaybe<Scalars['Boolean']['input']>;
  inConsolidatedInvoice?: InputMaybe<Scalars['Boolean']['input']>;
  invoiceEndDate?: InputMaybe<Scalars['DateTime']['input']>;
  invoiceStartDate?: InputMaybe<Scalars['DateTime']['input']>;
  isClosed?: InputMaybe<Scalars['Boolean']['input']>;
  isSyncedToQuickbooksDesktop?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  masterAccountUuid?: InputMaybe<Scalars['String']['input']>;
  originTerminalUuid?: InputMaybe<Scalars['String']['input']>;
  removeLegacy?: InputMaybe<Scalars['Boolean']['input']>;
  searchText?: InputMaybe<Scalars['String']['input']>;
  sortByDueDateAscending?: InputMaybe<Scalars['Boolean']['input']>;
  sortByDueDateDescending?: InputMaybe<Scalars['Boolean']['input']>;
  sorts?: InputMaybe<Array<FindInvoicesSort>>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  status?: InputMaybe<InvoiceStatus>;
  statuses?: InputMaybe<Array<InvoiceStatus>>;
  terminalUuid?: InputMaybe<Scalars['String']['input']>;
  uuids?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type QueryInvoicesByUuidsArgs = {
  includeDocuments?: InputMaybe<Scalars['Boolean']['input']>;
  uuids: Array<Scalars['String']['input']>;
};


export type QueryItemArgs = {
  itemUuid: Scalars['String']['input'];
};


export type QueryItemGroupsArgs = {
  findItemGroupsInput: FindItemGroupsInput;
};


export type QueryItemsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  contactUuid?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  searchText?: InputMaybe<Scalars['String']['input']>;
  warehouseUuid?: InputMaybe<Scalars['String']['input']>;
};


export type QueryItemsBySkuNameArgs = {
  contactUuid?: InputMaybe<Scalars['String']['input']>;
  sku: Scalars['String']['input'];
};


export type QueryLaneFromOriginAndDestinationTerminalArgs = {
  findLaneFromOriginAndDestinationTerminalInput: FindLaneFromOriginAndDestinationTerminalInput;
};


export type QueryLegArgs = {
  uuid: Scalars['String']['input'];
};


export type QueryLegsArgs = {
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  maxOneUnassignedPerShipment?: InputMaybe<Scalars['Boolean']['input']>;
  shipHasArrived?: InputMaybe<Scalars['Boolean']['input']>;
  showUnscheduled?: InputMaybe<Scalars['Boolean']['input']>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  statuses?: InputMaybe<Array<LegStatus>>;
};


export type QueryLineHaulFuelChargeFuelProfileDateRangeArgs = {
  lineHaulFuelChargeFuelProfileDateRangeInput: LineHaulFuelChargeFuelProfileDateRangeInput;
};


export type QueryLineHaulLaneArgs = {
  uuid: Scalars['String']['input'];
};


export type QueryLineHaulManifestArgs = {
  uuid: Scalars['String']['input'];
};


export type QueryLineHaulManifestsArgs = {
  date: Scalars['DateTime']['input'];
  destinationTerminalUuid?: InputMaybe<Scalars['String']['input']>;
  originTerminalUuid?: InputMaybe<Scalars['String']['input']>;
  uuids?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type QueryLineHaulManifestsGroupsArgs = {
  input: LineHaulManifestsGroupsInput;
};


export type QueryLineHaulSegmentArgs = {
  uuid: Scalars['String']['input'];
};


export type QueryMobileFeatureFlagArgs = {
  featureFlagInput: FeatureFlagInput;
};


export type QueryMyGroupedStopUuidsArgs = {
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
};


export type QueryMyRouteArgs = {
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
};


export type QueryMyRoutesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  maximumTake?: InputMaybe<Scalars['Int']['input']>;
  routeSort?: InputMaybe<RouteSort>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
};


export type QueryMyStopsArgs = {
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
};


export type QueryMyStopsByUuidsArgs = {
  uuids: Array<Scalars['String']['input']>;
};


export type QueryNetSalesSummaryReportArgs = {
  netSalesSummaryReportInput: NetSalesSummaryReportInput;
};


export type QueryNumberOfOrdersArgs = {
  activeTerminalFilter?: InputMaybe<StringFilterV2>;
  activeTerminalUuidFilter?: InputMaybe<StringFilter>;
  addressCityFilter?: InputMaybe<StringFilter>;
  addressZipFilter?: InputMaybe<StringFilter>;
  after?: InputMaybe<Scalars['String']['input']>;
  appointmentRequired?: InputMaybe<BooleanFilter>;
  appointmentRequiredFilter?: InputMaybe<BooleanFilterV2>;
  attemptedAtDateFilters?: InputMaybe<DateFilterStartEnd>;
  before?: InputMaybe<Scalars['String']['input']>;
  billingPartyContactDisplayNameFilter?: InputMaybe<StringFilter>;
  billingPartyContactUuidFilter?: InputMaybe<StringFilter>;
  billingPartyContactUuidsFilter?: InputMaybe<StringsFilter>;
  businessDivisionNameFilter?: InputMaybe<StringFilterV2>;
  businessDivisionUuidFilter?: InputMaybe<StringFilter>;
  businessDivisionUuidFilterV2?: InputMaybe<StringFilterV2>;
  canDispatchFilter?: InputMaybe<BooleanFilterV2>;
  completedAtDateFilter?: InputMaybe<DateFilterV2>;
  completionDateFilters?: InputMaybe<DateFilterStartEnd>;
  consigneeFilter?: InputMaybe<StringFilter>;
  controllingTerminalUuidFilter?: InputMaybe<StringFilter>;
  controllingTerminalUuidFilterV2?: InputMaybe<StringFilterV2>;
  createdAtDateFilters?: InputMaybe<DateFilterStartEnd>;
  customerFilter?: InputMaybe<StringFilter>;
  customerNameFilter?: InputMaybe<StringFilterV2>;
  customerUuidFilter?: InputMaybe<StringFilterV2>;
  deadlineDateFilters?: InputMaybe<DateFilterStartEnd>;
  destinationTerminalUuidFilter?: InputMaybe<StringFilterNullable>;
  destinationTerminalUuidFilterV2?: InputMaybe<StringFilterV2>;
  dimWeightFilter?: InputMaybe<FloatFilterV2>;
  driverNameFilter?: InputMaybe<StringFilterV2>;
  driverUuidFilter?: InputMaybe<StringFilter>;
  driverUuidFilterV2?: InputMaybe<StringFilterV2>;
  driverUuidsFilter?: InputMaybe<StringsFilter>;
  endStopFilter?: InputMaybe<StringFilter>;
  expectedInboundArrivalDateFilters?: InputMaybe<DateFilterStartEnd>;
  externalNotesFilter?: InputMaybe<StringFilterV2>;
  filterOutOldFlowConsolidatedOrders?: InputMaybe<BooleanFilterV2>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasAppointmentScheduled?: InputMaybe<BooleanFilter>;
  hasAppointmentScheduledFilter?: InputMaybe<BooleanFilterV2>;
  hasContactInformation?: InputMaybe<BooleanFilter>;
  hasContactInformationFilter?: InputMaybe<BooleanFilterV2>;
  hasFailures?: InputMaybe<BooleanFilter>;
  hasFailuresFilter?: InputMaybe<BooleanFilterV2>;
  hasRoute?: InputMaybe<BooleanFilter>;
  hasRouteFilter?: InputMaybe<BooleanFilterV2>;
  hawbFilter?: InputMaybe<StringFilterV2>;
  hideFromBilling?: InputMaybe<BooleanFilter>;
  hideFromBillingFilter?: InputMaybe<BooleanFilterV2>;
  hideOriginalConsolidatedOrderIdFilter?: InputMaybe<BooleanFilterV2>;
  holdReasonFilter?: InputMaybe<StringFilterV2>;
  inboundAddressFilter?: InputMaybe<StringFilterV2>;
  inboundAddressTypeFilter?: InputMaybe<StandardStopTypeFilter>;
  inboundAppointmentConfirmedFilter?: InputMaybe<BooleanFilterV2>;
  inboundAppointmentDateFilter?: InputMaybe<DateFilterV2>;
  inboundAppointmentRequiredFilter?: InputMaybe<BooleanFilterV2>;
  inboundCityFilter?: InputMaybe<StringFilterV2>;
  inboundCompletedDateFilter?: InputMaybe<DateFilterV2>;
  inboundCompletedFilter?: InputMaybe<BooleanFilterV2>;
  inboundContactNameFilter?: InputMaybe<StringFilterV2>;
  inboundDriverNameFilter?: InputMaybe<StringFilterV2>;
  inboundDriverUuidFilter?: InputMaybe<StringFilterV2>;
  inboundDriverUuidsFilter?: InputMaybe<StringsFilter>;
  inboundMethodFilter?: InputMaybe<StopType>;
  inboundMethodFilterV2?: InputMaybe<StopTypesV2Filter>;
  inboundNotArrived?: InputMaybe<BooleanFilter>;
  inboundNotArrivedFilter?: InputMaybe<BooleanFilterV2>;
  inboundRouteNameFilter?: InputMaybe<StringFilterV2>;
  inboundRoutingFilter?: InputMaybe<StringFilterV2>;
  inboundServiceDateFilter?: InputMaybe<DateFilterV2>;
  inboundStopTypeFilter?: InputMaybe<StopTypeFilter>;
  inboundTerminalFilter?: InputMaybe<StringFilterV2>;
  inboundZipcodeFilter?: InputMaybe<StringFilterV2>;
  includeOrdersPartOfV2ConsolidatedOrdersFilter?: InputMaybe<BooleanFilterV2>;
  invoiceDateFilters?: InputMaybe<DateFilterStartEnd>;
  invoiceUuid?: InputMaybe<Scalars['String']['input']>;
  isCancelled?: InputMaybe<BooleanFilter>;
  isCancelledFilter?: InputMaybe<BooleanFilterV2>;
  isCollectOnDelivery?: InputMaybe<Scalars['Boolean']['input']>;
  isCollectOnDeliveryFilter?: InputMaybe<BooleanFilterV2>;
  isFinalized?: InputMaybe<BooleanFilter>;
  isFinalizedFilter?: InputMaybe<BooleanFilterV2>;
  isHazmat?: InputMaybe<BooleanFilter>;
  isHazmatFilter?: InputMaybe<BooleanFilterV2>;
  isInBond?: InputMaybe<BooleanFilter>;
  isInBondFilter?: InputMaybe<BooleanFilterV2>;
  isLineHaul?: InputMaybe<BooleanFilter>;
  isLineHaulFilter?: InputMaybe<BooleanFilterV2>;
  isOsd?: InputMaybe<BooleanFilter>;
  isOsdFilter?: InputMaybe<BooleanFilterV2>;
  isPicked?: InputMaybe<BooleanFilter>;
  isPickedFilter?: InputMaybe<BooleanFilterV2>;
  isPickupOrDelivery?: InputMaybe<BooleanFilter>;
  isPickupOrDeliveryFilter?: InputMaybe<BooleanFilterV2>;
  isRefused?: InputMaybe<BooleanFilter>;
  isRefusedFilter?: InputMaybe<BooleanFilterV2>;
  isReweighedFilter?: InputMaybe<BooleanFilterV2>;
  isSpecial?: InputMaybe<BooleanFilter>;
  isSpecialFilter?: InputMaybe<BooleanFilterV2>;
  itNumberFilter?: InputMaybe<StringFilterV2>;
  last?: InputMaybe<Scalars['Int']['input']>;
  lineHaulLaneFilter?: InputMaybe<UuidFilterV2>;
  lineHaulLaneUuids?: InputMaybe<Array<Scalars['String']['input']>>;
  markedOnHandDateFilter?: InputMaybe<DateFilterV2>;
  mawbFilter?: InputMaybe<StringFilterV2>;
  multipleSearches?: InputMaybe<Array<Scalars['String']['input']>>;
  noMaximum?: InputMaybe<Scalars['Boolean']['input']>;
  noTerminal?: InputMaybe<BooleanFilter>;
  onHand?: InputMaybe<BooleanFilter>;
  onHandFilter?: InputMaybe<BooleanFilterV2>;
  onHoldFilter?: InputMaybe<BooleanFilterV2>;
  onInvoice?: InputMaybe<BooleanFilter>;
  onInvoiceFilter?: InputMaybe<BooleanFilterV2>;
  orderCityFilter?: InputMaybe<StringFilterV2>;
  orderNameFilterV2?: InputMaybe<StringFilterV2>;
  orderNotesFilter?: InputMaybe<StringFilterV2>;
  orderNumberFilter?: InputMaybe<StringFilter>;
  orderServiceDateFilter?: InputMaybe<DateFilterV2>;
  orderSource?: InputMaybe<OrderSource>;
  orderSourceFilter?: InputMaybe<OrderSourceFilter>;
  orderStatusFilter?: InputMaybe<OrderStatusFilter>;
  orderZipFilter?: InputMaybe<StringFilterV2>;
  originTerminalUuidFilter?: InputMaybe<StringFilterNullable>;
  originTerminalUuidFilterV2?: InputMaybe<StringFilterV2>;
  osdReasonFilter?: InputMaybe<StringFilterV2>;
  outForDeliveryFilter?: InputMaybe<BooleanFilter>;
  outForDeliveryFilterV2?: InputMaybe<BooleanFilterV2>;
  outboundAddressFilter?: InputMaybe<StringFilterV2>;
  outboundAddressTypeFilter?: InputMaybe<StandardStopTypeFilter>;
  outboundAppointmentConfirmedFilter?: InputMaybe<BooleanFilterV2>;
  outboundAppointmentDateFilter?: InputMaybe<DateFilterV2>;
  outboundAppointmentRequiredFilter?: InputMaybe<BooleanFilterV2>;
  outboundCityFilter?: InputMaybe<StringFilterV2>;
  outboundCompletedDateFilter?: InputMaybe<DateFilterV2>;
  outboundCompletedFilter?: InputMaybe<BooleanFilterV2>;
  outboundContactNameFilter?: InputMaybe<StringFilterV2>;
  outboundDestinationAirportFilter?: InputMaybe<StringFilterV2>;
  outboundDriverNameFilter?: InputMaybe<StringFilterV2>;
  outboundDriverUuidFilter?: InputMaybe<StringFilterV2>;
  outboundDriverUuidsFilter?: InputMaybe<StringsFilter>;
  outboundMethodFilter?: InputMaybe<StopType>;
  outboundMethodFilterV2?: InputMaybe<StopTypesV2Filter>;
  outboundRouteNameFilter?: InputMaybe<StringFilterV2>;
  outboundRoutingFilter?: InputMaybe<StringFilterV2>;
  outboundServiceDateFilter?: InputMaybe<DateFilterV2>;
  outboundStopTypeFilter?: InputMaybe<StopTypeFilter>;
  outboundTerminalFilter?: InputMaybe<StringFilterV2>;
  outboundZipcodeFilter?: InputMaybe<StringFilterV2>;
  paperworkComplete?: InputMaybe<BooleanFilter>;
  paperworkCompleteFilter?: InputMaybe<BooleanFilterV2>;
  pickupOrDelivery?: InputMaybe<PickupOrDelivery>;
  primaryAppointmentDateFilters?: InputMaybe<DateFilterStartEnd>;
  proofOfDeliveryNameFilter?: InputMaybe<StringFilterV2>;
  proofOfDeliverySigneeFilter?: InputMaybe<StringFilterV2>;
  receivedAtOriginFilter?: InputMaybe<BooleanFilterV2>;
  receivedDateFilters?: InputMaybe<DateFilterStartEnd>;
  requiresRecovery?: InputMaybe<BooleanFilter>;
  requiresRecoveryFilter?: InputMaybe<BooleanFilterV2>;
  requiresRouting?: InputMaybe<BooleanFilter>;
  requiresRoutingFilter?: InputMaybe<BooleanFilterV2>;
  routingLocationFilter?: InputMaybe<StringFilterV2>;
  scheduledAtDateFilters?: InputMaybe<DateFilterStartEnd>;
  scheduledFilter?: InputMaybe<BooleanFilter>;
  scheduledFilterV2?: InputMaybe<BooleanFilterV2>;
  searchHawbOnly?: InputMaybe<Scalars['Boolean']['input']>;
  searchMiscInfoOnly?: InputMaybe<Scalars['Boolean']['input']>;
  searchRefNumbersOnly?: InputMaybe<Scalars['Boolean']['input']>;
  searchText?: InputMaybe<Scalars['String']['input']>;
  secondaryReferenceNumberFilter?: InputMaybe<StringFilterV2>;
  serviceDateFilter?: InputMaybe<DateFilterV2>;
  serviceDateFilters?: InputMaybe<DateFilterStartEnd>;
  serviceLevelFilter?: InputMaybe<StringFilterV2>;
  serviceUuids?: InputMaybe<Array<Scalars['String']['input']>>;
  shipmentStatusFilters?: InputMaybe<Array<ShipmentStatusFilter>>;
  shipperFilter?: InputMaybe<StringFilter>;
  showConsolidatedOrders?: InputMaybe<BooleanFilter>;
  showConsolidatedOrdersFilter?: InputMaybe<BooleanFilterV2>;
  sortByCustomerNameAscending?: InputMaybe<Scalars['Boolean']['input']>;
  sorts?: InputMaybe<Array<OrderSort>>;
  sortsV2?: InputMaybe<Array<OrderSortV2>>;
  standardStopType?: InputMaybe<StandardStopType>;
  startStopFilter?: InputMaybe<StringFilter>;
  statusFilters?: InputMaybe<Array<StatusFilter>>;
  stopTypesFilter?: InputMaybe<StopTypesFilter>;
  tagUuids?: InputMaybe<Array<Scalars['String']['input']>>;
  tagUuidsFilter?: InputMaybe<StringsFilter>;
  tagsFilter?: InputMaybe<StringFilterV2>;
  terminalUuidFilter?: InputMaybe<StringFilter>;
  terminalUuidFilterV2?: InputMaybe<StringFilterV2>;
  terminalUuidsFilter?: InputMaybe<StringsFilter>;
  totalAmountDollarsFilter?: InputMaybe<FloatFilterV2>;
  totalCount?: InputMaybe<Scalars['Boolean']['input']>;
  totalPiecesFilter?: InputMaybe<IntegerFilterV2>;
  totalSkidsFilter?: InputMaybe<IntegerFilterV2>;
  totalWeightFilter?: InputMaybe<FloatFilterV2>;
  transferPending?: InputMaybe<BooleanFilter>;
  transferPendingFilter?: InputMaybe<BooleanFilterV2>;
  unNumberFilter?: InputMaybe<StringFilterV2>;
  useMultiSearch?: InputMaybe<Scalars['Boolean']['input']>;
  uuids?: InputMaybe<Array<Scalars['String']['input']>>;
  versionId?: InputMaybe<Scalars['Float']['input']>;
  zipcodeFilter?: InputMaybe<StringFilterV2>;
};


export type QueryNumberOfScannedOrderResultDuplicatesArgs = {
  contactUuid?: InputMaybe<Scalars['String']['input']>;
  destinationTerminalUuid?: InputMaybe<Scalars['String']['input']>;
  emailIntegrationTerminalUuid?: InputMaybe<Scalars['String']['input']>;
  originTerminalUuid?: InputMaybe<Scalars['String']['input']>;
  searchText?: InputMaybe<Scalars['String']['input']>;
  sourceFilter?: ScannedOrderResultSourceFilter;
};


export type QueryNumberOfScannedOrderResultsApprovedArgs = {
  contactUuid?: InputMaybe<Scalars['String']['input']>;
  destinationTerminalUuid?: InputMaybe<Scalars['String']['input']>;
  emailIntegrationTerminalUuid?: InputMaybe<Scalars['String']['input']>;
  originTerminalUuid?: InputMaybe<Scalars['String']['input']>;
  searchText?: InputMaybe<Scalars['String']['input']>;
  sourceFilter?: ScannedOrderResultSourceFilter;
};


export type QueryNumberOfScannedOrderResultsFailedArgs = {
  contactUuid?: InputMaybe<Scalars['String']['input']>;
  destinationTerminalUuid?: InputMaybe<Scalars['String']['input']>;
  emailIntegrationTerminalUuid?: InputMaybe<Scalars['String']['input']>;
  originTerminalUuid?: InputMaybe<Scalars['String']['input']>;
  searchText?: InputMaybe<Scalars['String']['input']>;
  sourceFilter?: ScannedOrderResultSourceFilter;
};


export type QueryNumberOfScannedOrderResultsInProgressArgs = {
  contactUuid?: InputMaybe<Scalars['String']['input']>;
  destinationTerminalUuid?: InputMaybe<Scalars['String']['input']>;
  emailIntegrationTerminalUuid?: InputMaybe<Scalars['String']['input']>;
  originTerminalUuid?: InputMaybe<Scalars['String']['input']>;
  searchText?: InputMaybe<Scalars['String']['input']>;
  sourceFilter?: ScannedOrderResultSourceFilter;
};


export type QueryNumberOfScannedOrderResultsInReviewArgs = {
  contactUuid?: InputMaybe<Scalars['String']['input']>;
  destinationTerminalUuid?: InputMaybe<Scalars['String']['input']>;
  emailIntegrationTerminalUuid?: InputMaybe<Scalars['String']['input']>;
  originTerminalUuid?: InputMaybe<Scalars['String']['input']>;
  searchText?: InputMaybe<Scalars['String']['input']>;
  sourceFilter?: ScannedOrderResultSourceFilter;
};


export type QueryNumberOfScannedOrderResultsRejectedArgs = {
  contactUuid?: InputMaybe<Scalars['String']['input']>;
  destinationTerminalUuid?: InputMaybe<Scalars['String']['input']>;
  emailIntegrationTerminalUuid?: InputMaybe<Scalars['String']['input']>;
  originTerminalUuid?: InputMaybe<Scalars['String']['input']>;
  searchText?: InputMaybe<Scalars['String']['input']>;
  sourceFilter?: ScannedOrderResultSourceFilter;
};


export type QueryNumberOfStopsArgs = {
  appointmentRequired?: InputMaybe<Scalars['Boolean']['input']>;
  appointmentTimeFilters?: InputMaybe<DateFilterStartEnd>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAtFilters?: InputMaybe<DateFilterStartEnd>;
  customerUuid?: InputMaybe<Scalars['String']['input']>;
  deadlineDate?: InputMaybe<Scalars['DateTime']['input']>;
  deadlineDateFilters?: InputMaybe<DateFilterStartEnd>;
  deliveryDate?: InputMaybe<Scalars['DateTime']['input']>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  filters?: InputMaybe<Array<FindStopsFiltersInput>>;
  hasAppointment?: InputMaybe<Scalars['Boolean']['input']>;
  hideOnHold?: InputMaybe<Scalars['Boolean']['input']>;
  hideStopsWithoutAddress?: InputMaybe<Scalars['Boolean']['input']>;
  includeCount?: InputMaybe<Scalars['Boolean']['input']>;
  isAssigned?: InputMaybe<Scalars['Boolean']['input']>;
  isPicked?: InputMaybe<Scalars['Boolean']['input']>;
  isRefusedFilter?: InputMaybe<BooleanFilterV2>;
  isSpecial?: InputMaybe<Scalars['Boolean']['input']>;
  onHand?: InputMaybe<Scalars['Boolean']['input']>;
  orderStatuses?: InputMaybe<Array<OrderStatus>>;
  pickupOrDeliveryTypes?: InputMaybe<Array<PickupOrDelivery>>;
  previouslyAttempted?: InputMaybe<Scalars['Boolean']['input']>;
  requiresRecovery?: InputMaybe<Scalars['Boolean']['input']>;
  serviceDateFilters?: InputMaybe<DateFilterStartEnd>;
  serviceLevelUuids?: InputMaybe<Array<Scalars['String']['input']>>;
  standardStopTypes?: InputMaybe<Array<StandardStopType>>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  statuses?: InputMaybe<Array<StopStatus>>;
  tagUuids?: InputMaybe<Array<Scalars['String']['input']>>;
  terminalUuid?: InputMaybe<Scalars['String']['input']>;
  transferPending?: InputMaybe<Scalars['Boolean']['input']>;
  useCache?: InputMaybe<Scalars['Boolean']['input']>;
  warehouseUuid?: InputMaybe<Scalars['String']['input']>;
};


export type QueryOnTimePerformanceReportCsvArgs = {
  onTimePerformanceReportInput: OnTimePerformanceReportInput;
};


export type QueryOnTimePerformanceReportPdfArgs = {
  onTimePerformanceReportInput: OnTimePerformanceReportInput;
};


export type QueryOpenInvoiceReportArgs = {
  openInvoiceReportArgs: OpenInvoiceReportArgs;
};


export type QueryOrderArgs = {
  uuid: Scalars['String']['input'];
};


export type QueryOrderAmountsToPayForInvoiceArgs = {
  amountInCents: Scalars['Float']['input'];
  invoiceUuids: Array<Scalars['String']['input']>;
};


export type QueryOrderAuditLogEntriesArgs = {
  getOrderAuditLogEntriesInput: GetOrderAuditLogEntriesInput;
};


export type QueryOrderCommentsArgs = {
  orderUuid: Scalars['String']['input'];
};


export type QueryOrderEventNotificationSubscriptionsArgs = {
  contactUuid: Scalars['String']['input'];
};


export type QueryOrderEventsArgs = {
  eventType?: InputMaybe<OrderEventType>;
  orderUuid?: InputMaybe<Scalars['String']['input']>;
  sortByCreatedAtAsc?: InputMaybe<Scalars['Boolean']['input']>;
  storageOrderUuid?: InputMaybe<Scalars['String']['input']>;
};


export type QueryOrderNameArgs = {
  billingPartyContactUuid: Scalars['String']['input'];
};


export type QueryOrderReportArgs = {
  args: OrderReportArgs;
};


export type QueryOrderReportByReportGroupArgs = {
  uuid: Scalars['String']['input'];
};


export type QueryOrderRevenueReportArgs = {
  orderRevenueReportInput: OrderRevenueReportInput;
};


export type QueryOrderVolumeByCompanyReportArgs = {
  orderVolumeByCompanyInput: OrderVolumeByCompanyInput;
};


export type QueryOrderVolumeByContactReportArgs = {
  orderVolumeByContactInput: OrderVolumeByContactInput;
};


export type QueryOrderVolumeByDateRangeReportArgs = {
  orderVolumeByDateRangeInput: OrderVolumeByDateRangeInput;
};


export type QueryOrderVolumeBySchemaReportArgs = {
  orderVolumeBySchemaInput: OrderVolumeBySchemaInput;
};


export type QueryOrderVolumeByUserReportArgs = {
  orderVolumeByUserInput: OrderVolumeByUserInput;
};


export type QueryOrdersArgs = {
  activeTerminalFilter?: InputMaybe<StringFilterV2>;
  activeTerminalUuidFilter?: InputMaybe<StringFilter>;
  addressCityFilter?: InputMaybe<StringFilter>;
  addressZipFilter?: InputMaybe<StringFilter>;
  after?: InputMaybe<Scalars['String']['input']>;
  appointmentRequired?: InputMaybe<BooleanFilter>;
  appointmentRequiredFilter?: InputMaybe<BooleanFilterV2>;
  attemptedAtDateFilters?: InputMaybe<DateFilterStartEnd>;
  before?: InputMaybe<Scalars['String']['input']>;
  billingPartyContactDisplayNameFilter?: InputMaybe<StringFilter>;
  billingPartyContactUuidFilter?: InputMaybe<StringFilter>;
  billingPartyContactUuidsFilter?: InputMaybe<StringsFilter>;
  businessDivisionNameFilter?: InputMaybe<StringFilterV2>;
  businessDivisionUuidFilter?: InputMaybe<StringFilter>;
  businessDivisionUuidFilterV2?: InputMaybe<StringFilterV2>;
  canDispatchFilter?: InputMaybe<BooleanFilterV2>;
  completedAtDateFilter?: InputMaybe<DateFilterV2>;
  completionDateFilters?: InputMaybe<DateFilterStartEnd>;
  consigneeFilter?: InputMaybe<StringFilter>;
  controllingTerminalUuidFilter?: InputMaybe<StringFilter>;
  controllingTerminalUuidFilterV2?: InputMaybe<StringFilterV2>;
  createdAtDateFilters?: InputMaybe<DateFilterStartEnd>;
  customerFilter?: InputMaybe<StringFilter>;
  customerNameFilter?: InputMaybe<StringFilterV2>;
  customerUuidFilter?: InputMaybe<StringFilterV2>;
  deadlineDateFilters?: InputMaybe<DateFilterStartEnd>;
  destinationTerminalUuidFilter?: InputMaybe<StringFilterNullable>;
  destinationTerminalUuidFilterV2?: InputMaybe<StringFilterV2>;
  dimWeightFilter?: InputMaybe<FloatFilterV2>;
  driverNameFilter?: InputMaybe<StringFilterV2>;
  driverUuidFilter?: InputMaybe<StringFilter>;
  driverUuidFilterV2?: InputMaybe<StringFilterV2>;
  driverUuidsFilter?: InputMaybe<StringsFilter>;
  endStopFilter?: InputMaybe<StringFilter>;
  expectedInboundArrivalDateFilters?: InputMaybe<DateFilterStartEnd>;
  externalNotesFilter?: InputMaybe<StringFilterV2>;
  filterOutOldFlowConsolidatedOrders?: InputMaybe<BooleanFilterV2>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasAppointmentScheduled?: InputMaybe<BooleanFilter>;
  hasAppointmentScheduledFilter?: InputMaybe<BooleanFilterV2>;
  hasContactInformation?: InputMaybe<BooleanFilter>;
  hasContactInformationFilter?: InputMaybe<BooleanFilterV2>;
  hasFailures?: InputMaybe<BooleanFilter>;
  hasFailuresFilter?: InputMaybe<BooleanFilterV2>;
  hasRoute?: InputMaybe<BooleanFilter>;
  hasRouteFilter?: InputMaybe<BooleanFilterV2>;
  hawbFilter?: InputMaybe<StringFilterV2>;
  hideFromBilling?: InputMaybe<BooleanFilter>;
  hideFromBillingFilter?: InputMaybe<BooleanFilterV2>;
  hideOriginalConsolidatedOrderIdFilter?: InputMaybe<BooleanFilterV2>;
  holdReasonFilter?: InputMaybe<StringFilterV2>;
  inboundAddressFilter?: InputMaybe<StringFilterV2>;
  inboundAddressTypeFilter?: InputMaybe<StandardStopTypeFilter>;
  inboundAppointmentConfirmedFilter?: InputMaybe<BooleanFilterV2>;
  inboundAppointmentDateFilter?: InputMaybe<DateFilterV2>;
  inboundAppointmentRequiredFilter?: InputMaybe<BooleanFilterV2>;
  inboundCityFilter?: InputMaybe<StringFilterV2>;
  inboundCompletedDateFilter?: InputMaybe<DateFilterV2>;
  inboundCompletedFilter?: InputMaybe<BooleanFilterV2>;
  inboundContactNameFilter?: InputMaybe<StringFilterV2>;
  inboundDriverNameFilter?: InputMaybe<StringFilterV2>;
  inboundDriverUuidFilter?: InputMaybe<StringFilterV2>;
  inboundDriverUuidsFilter?: InputMaybe<StringsFilter>;
  inboundMethodFilter?: InputMaybe<StopType>;
  inboundMethodFilterV2?: InputMaybe<StopTypesV2Filter>;
  inboundNotArrived?: InputMaybe<BooleanFilter>;
  inboundNotArrivedFilter?: InputMaybe<BooleanFilterV2>;
  inboundRouteNameFilter?: InputMaybe<StringFilterV2>;
  inboundRoutingFilter?: InputMaybe<StringFilterV2>;
  inboundServiceDateFilter?: InputMaybe<DateFilterV2>;
  inboundStopTypeFilter?: InputMaybe<StopTypeFilter>;
  inboundTerminalFilter?: InputMaybe<StringFilterV2>;
  inboundZipcodeFilter?: InputMaybe<StringFilterV2>;
  includeOrdersPartOfV2ConsolidatedOrdersFilter?: InputMaybe<BooleanFilterV2>;
  invoiceDateFilters?: InputMaybe<DateFilterStartEnd>;
  invoiceUuid?: InputMaybe<Scalars['String']['input']>;
  isCancelled?: InputMaybe<BooleanFilter>;
  isCancelledFilter?: InputMaybe<BooleanFilterV2>;
  isCollectOnDelivery?: InputMaybe<Scalars['Boolean']['input']>;
  isCollectOnDeliveryFilter?: InputMaybe<BooleanFilterV2>;
  isFinalized?: InputMaybe<BooleanFilter>;
  isFinalizedFilter?: InputMaybe<BooleanFilterV2>;
  isHazmat?: InputMaybe<BooleanFilter>;
  isHazmatFilter?: InputMaybe<BooleanFilterV2>;
  isInBond?: InputMaybe<BooleanFilter>;
  isInBondFilter?: InputMaybe<BooleanFilterV2>;
  isLineHaul?: InputMaybe<BooleanFilter>;
  isLineHaulFilter?: InputMaybe<BooleanFilterV2>;
  isOsd?: InputMaybe<BooleanFilter>;
  isOsdFilter?: InputMaybe<BooleanFilterV2>;
  isPicked?: InputMaybe<BooleanFilter>;
  isPickedFilter?: InputMaybe<BooleanFilterV2>;
  isPickupOrDelivery?: InputMaybe<BooleanFilter>;
  isPickupOrDeliveryFilter?: InputMaybe<BooleanFilterV2>;
  isRefused?: InputMaybe<BooleanFilter>;
  isRefusedFilter?: InputMaybe<BooleanFilterV2>;
  isReweighedFilter?: InputMaybe<BooleanFilterV2>;
  isSpecial?: InputMaybe<BooleanFilter>;
  isSpecialFilter?: InputMaybe<BooleanFilterV2>;
  itNumberFilter?: InputMaybe<StringFilterV2>;
  last?: InputMaybe<Scalars['Int']['input']>;
  lineHaulLaneFilter?: InputMaybe<UuidFilterV2>;
  lineHaulLaneUuids?: InputMaybe<Array<Scalars['String']['input']>>;
  markedOnHandDateFilter?: InputMaybe<DateFilterV2>;
  mawbFilter?: InputMaybe<StringFilterV2>;
  multipleSearches?: InputMaybe<Array<Scalars['String']['input']>>;
  noMaximum?: InputMaybe<Scalars['Boolean']['input']>;
  noTerminal?: InputMaybe<BooleanFilter>;
  onHand?: InputMaybe<BooleanFilter>;
  onHandFilter?: InputMaybe<BooleanFilterV2>;
  onHoldFilter?: InputMaybe<BooleanFilterV2>;
  onInvoice?: InputMaybe<BooleanFilter>;
  onInvoiceFilter?: InputMaybe<BooleanFilterV2>;
  orderCityFilter?: InputMaybe<StringFilterV2>;
  orderNameFilterV2?: InputMaybe<StringFilterV2>;
  orderNotesFilter?: InputMaybe<StringFilterV2>;
  orderNumberFilter?: InputMaybe<StringFilter>;
  orderServiceDateFilter?: InputMaybe<DateFilterV2>;
  orderSource?: InputMaybe<OrderSource>;
  orderSourceFilter?: InputMaybe<OrderSourceFilter>;
  orderStatusFilter?: InputMaybe<OrderStatusFilter>;
  orderZipFilter?: InputMaybe<StringFilterV2>;
  originTerminalUuidFilter?: InputMaybe<StringFilterNullable>;
  originTerminalUuidFilterV2?: InputMaybe<StringFilterV2>;
  osdReasonFilter?: InputMaybe<StringFilterV2>;
  outForDeliveryFilter?: InputMaybe<BooleanFilter>;
  outForDeliveryFilterV2?: InputMaybe<BooleanFilterV2>;
  outboundAddressFilter?: InputMaybe<StringFilterV2>;
  outboundAddressTypeFilter?: InputMaybe<StandardStopTypeFilter>;
  outboundAppointmentConfirmedFilter?: InputMaybe<BooleanFilterV2>;
  outboundAppointmentDateFilter?: InputMaybe<DateFilterV2>;
  outboundAppointmentRequiredFilter?: InputMaybe<BooleanFilterV2>;
  outboundCityFilter?: InputMaybe<StringFilterV2>;
  outboundCompletedDateFilter?: InputMaybe<DateFilterV2>;
  outboundCompletedFilter?: InputMaybe<BooleanFilterV2>;
  outboundContactNameFilter?: InputMaybe<StringFilterV2>;
  outboundDestinationAirportFilter?: InputMaybe<StringFilterV2>;
  outboundDriverNameFilter?: InputMaybe<StringFilterV2>;
  outboundDriverUuidFilter?: InputMaybe<StringFilterV2>;
  outboundDriverUuidsFilter?: InputMaybe<StringsFilter>;
  outboundMethodFilter?: InputMaybe<StopType>;
  outboundMethodFilterV2?: InputMaybe<StopTypesV2Filter>;
  outboundRouteNameFilter?: InputMaybe<StringFilterV2>;
  outboundRoutingFilter?: InputMaybe<StringFilterV2>;
  outboundServiceDateFilter?: InputMaybe<DateFilterV2>;
  outboundStopTypeFilter?: InputMaybe<StopTypeFilter>;
  outboundTerminalFilter?: InputMaybe<StringFilterV2>;
  outboundZipcodeFilter?: InputMaybe<StringFilterV2>;
  paperworkComplete?: InputMaybe<BooleanFilter>;
  paperworkCompleteFilter?: InputMaybe<BooleanFilterV2>;
  pickupOrDelivery?: InputMaybe<PickupOrDelivery>;
  primaryAppointmentDateFilters?: InputMaybe<DateFilterStartEnd>;
  proofOfDeliveryNameFilter?: InputMaybe<StringFilterV2>;
  proofOfDeliverySigneeFilter?: InputMaybe<StringFilterV2>;
  receivedAtOriginFilter?: InputMaybe<BooleanFilterV2>;
  receivedDateFilters?: InputMaybe<DateFilterStartEnd>;
  requiresRecovery?: InputMaybe<BooleanFilter>;
  requiresRecoveryFilter?: InputMaybe<BooleanFilterV2>;
  requiresRouting?: InputMaybe<BooleanFilter>;
  requiresRoutingFilter?: InputMaybe<BooleanFilterV2>;
  routingLocationFilter?: InputMaybe<StringFilterV2>;
  scheduledAtDateFilters?: InputMaybe<DateFilterStartEnd>;
  scheduledFilter?: InputMaybe<BooleanFilter>;
  scheduledFilterV2?: InputMaybe<BooleanFilterV2>;
  searchHawbOnly?: InputMaybe<Scalars['Boolean']['input']>;
  searchMiscInfoOnly?: InputMaybe<Scalars['Boolean']['input']>;
  searchRefNumbersOnly?: InputMaybe<Scalars['Boolean']['input']>;
  searchText?: InputMaybe<Scalars['String']['input']>;
  secondaryReferenceNumberFilter?: InputMaybe<StringFilterV2>;
  serviceDateFilter?: InputMaybe<DateFilterV2>;
  serviceDateFilters?: InputMaybe<DateFilterStartEnd>;
  serviceLevelFilter?: InputMaybe<StringFilterV2>;
  serviceUuids?: InputMaybe<Array<Scalars['String']['input']>>;
  shipmentStatusFilters?: InputMaybe<Array<ShipmentStatusFilter>>;
  shipperFilter?: InputMaybe<StringFilter>;
  showConsolidatedOrders?: InputMaybe<BooleanFilter>;
  showConsolidatedOrdersFilter?: InputMaybe<BooleanFilterV2>;
  sortByCustomerNameAscending?: InputMaybe<Scalars['Boolean']['input']>;
  sorts?: InputMaybe<Array<OrderSort>>;
  sortsV2?: InputMaybe<Array<OrderSortV2>>;
  standardStopType?: InputMaybe<StandardStopType>;
  startStopFilter?: InputMaybe<StringFilter>;
  statusFilters?: InputMaybe<Array<StatusFilter>>;
  stopTypesFilter?: InputMaybe<StopTypesFilter>;
  tagUuids?: InputMaybe<Array<Scalars['String']['input']>>;
  tagUuidsFilter?: InputMaybe<StringsFilter>;
  tagsFilter?: InputMaybe<StringFilterV2>;
  terminalUuidFilter?: InputMaybe<StringFilter>;
  terminalUuidFilterV2?: InputMaybe<StringFilterV2>;
  terminalUuidsFilter?: InputMaybe<StringsFilter>;
  totalAmountDollarsFilter?: InputMaybe<FloatFilterV2>;
  totalCount?: InputMaybe<Scalars['Boolean']['input']>;
  totalPiecesFilter?: InputMaybe<IntegerFilterV2>;
  totalSkidsFilter?: InputMaybe<IntegerFilterV2>;
  totalWeightFilter?: InputMaybe<FloatFilterV2>;
  transferPending?: InputMaybe<BooleanFilter>;
  transferPendingFilter?: InputMaybe<BooleanFilterV2>;
  unNumberFilter?: InputMaybe<StringFilterV2>;
  useMultiSearch?: InputMaybe<Scalars['Boolean']['input']>;
  uuids?: InputMaybe<Array<Scalars['String']['input']>>;
  versionId?: InputMaybe<Scalars['Float']['input']>;
  zipcodeFilter?: InputMaybe<StringFilterV2>;
};


export type QueryOrdersByMasterAirwayBillOfLadingNumberArgs = {
  masterAirwayBillOfLadingNumber: Scalars['String']['input'];
};


export type QueryOrdersBySecondaryRefNumberArgs = {
  secondaryRefNumber: Scalars['String']['input'];
};


export type QueryOrdersByShipperBillOfLadingNumberArgs = {
  includeInReviewEdiOrders?: InputMaybe<Scalars['Boolean']['input']>;
  includeInReviewScannedOrdersFromEmail?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateOrders?: InputMaybe<Scalars['Boolean']['input']>;
  shipperBillOfLadingNumber: Scalars['String']['input'];
};


export type QueryOrdersByUuidsArgs = {
  uuids: Array<Scalars['String']['input']>;
};


export type QueryOrdersForPaymentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  contactUuid: Scalars['String']['input'];
  currentPaymentUuid?: InputMaybe<Scalars['String']['input']>;
  filterOutZeroBalance?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  groupOrdersBy?: GroupOrdersForPaymentsBy;
  includeTotalCount?: InputMaybe<Scalars['Boolean']['input']>;
  includeTotalCountsByInvoice?: InputMaybe<Scalars['Boolean']['input']>;
  invoiceEndDate?: InputMaybe<Scalars['DateTime']['input']>;
  invoiceStartDate?: InputMaybe<Scalars['DateTime']['input']>;
  invoiceUuid?: InputMaybe<Scalars['String']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  searchText?: InputMaybe<Scalars['String']['input']>;
  sorts?: InputMaybe<Array<OrdersForPaymentsSort>>;
};


export type QueryOrganizationArgs = {
  input: FindOrganizationInput;
};


export type QueryOrganizationNotesArgs = {
  findOrganizationNotesInput: FindOrganizationNotesInput;
};


export type QueryOutlookIntegrationsArgs = {
  getOutlookIntegrationsInput: GetOutlookIntegrationsInput;
};


export type QueryOutstandingInvoicesForCustomerArgs = {
  contactUuid: Scalars['String']['input'];
};


export type QueryOutstandingOrdersForReviewArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  billingPartyContactUuids?: InputMaybe<Array<Scalars['String']['input']>>;
  contactUuid?: InputMaybe<Scalars['String']['input']>;
  destinationTerminalUuid?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasIssues?: InputMaybe<Scalars['Boolean']['input']>;
  includeUuids?: InputMaybe<Scalars['Boolean']['input']>;
  isCancelled?: InputMaybe<Scalars['Boolean']['input']>;
  isFinalized?: InputMaybe<Scalars['Boolean']['input']>;
  isUnfinalized?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  multipleSearches?: InputMaybe<Array<Scalars['String']['input']>>;
  orderCompletionEndDate?: InputMaybe<Scalars['DateTime']['input']>;
  orderCompletionStartDate?: InputMaybe<Scalars['DateTime']['input']>;
  originTerminalUuid?: InputMaybe<Scalars['String']['input']>;
  searchText?: InputMaybe<Scalars['String']['input']>;
  sorts?: InputMaybe<Array<OrderSort>>;
  terminalUuid?: InputMaybe<Scalars['String']['input']>;
  uuids: Array<Scalars['String']['input']>;
};


export type QueryOutstandingShipmentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  billingPartyContactDisplayName?: InputMaybe<StringFilter>;
  billingPartyContactUuids?: InputMaybe<Array<Scalars['String']['input']>>;
  contactUuid?: InputMaybe<Scalars['String']['input']>;
  destinationTerminalUuid?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasIssues?: InputMaybe<Scalars['Boolean']['input']>;
  hideFromBilling?: InputMaybe<Scalars['Boolean']['input']>;
  isCancelled?: InputMaybe<Scalars['Boolean']['input']>;
  isFinalized?: InputMaybe<Scalars['Boolean']['input']>;
  isUnfinalized?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  noMaximum?: InputMaybe<Scalars['Boolean']['input']>;
  orderUuids: Array<Scalars['String']['input']>;
  originTerminalUuid?: InputMaybe<Scalars['String']['input']>;
  searchText?: InputMaybe<Scalars['String']['input']>;
  serviceUuid?: InputMaybe<Scalars['String']['input']>;
  stopCompletionEndDate?: InputMaybe<Scalars['DateTime']['input']>;
  stopCompletionStartDate?: InputMaybe<Scalars['DateTime']['input']>;
  terminalUuid?: InputMaybe<Scalars['String']['input']>;
  uuids?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type QueryOverdueInvoicesArgs = {
  contactUuid: Scalars['String']['input'];
};


export type QueryPackageSpecArgs = {
  id: Scalars['String']['input'];
};


export type QueryPaginatedContactsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  checkHasTariffZones?: InputMaybe<Scalars['Boolean']['input']>;
  checkHasTariffs?: InputMaybe<Scalars['Boolean']['input']>;
  companyUuid?: InputMaybe<Scalars['String']['input']>;
  excludeNonActive?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  invoiceUuids?: InputMaybe<Array<Scalars['String']['input']>>;
  last?: InputMaybe<Scalars['Int']['input']>;
  searchText?: InputMaybe<Scalars['String']['input']>;
  sortByContactName?: InputMaybe<Scalars['Boolean']['input']>;
  sortByOrderNumberAscending?: InputMaybe<Scalars['Boolean']['input']>;
  sortByOrderNumberDescending?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryPaginatedOrdersByInvoiceArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  invoiceUuid: Scalars['String']['input'];
  last?: InputMaybe<Scalars['Int']['input']>;
  searchText?: InputMaybe<Scalars['String']['input']>;
  sortByShipperBillOfLadingNumberAsc?: InputMaybe<Scalars['Boolean']['input']>;
  sorts?: InputMaybe<Array<FindOrdersOnInvoiceSort>>;
};


export type QueryPaginatedOrganizationsArgs = {
  findPaginatedOrganizationsInput: FindPaginatedOrganizationsInput;
};


export type QueryPaginatedRoutesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  date?: InputMaybe<Scalars['DateTime']['input']>;
  driverUuid?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  maximumTake?: InputMaybe<Scalars['Int']['input']>;
  routeSort?: InputMaybe<RouteSort>;
  routeUuids?: InputMaybe<Array<Scalars['String']['input']>>;
  searchText?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  terminalUuid?: InputMaybe<Scalars['String']['input']>;
  versionId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryParseAddressArgs = {
  address: Scalars['String']['input'];
};


export type QueryPaymentApplicationReportArgs = {
  args: FindPaymentsV2Args;
};


export type QueryPaymentByUuidArgs = {
  uuid: Scalars['String']['input'];
};


export type QueryPaymentJournalReportArgs = {
  args: FindPaymentsV2Args;
};


export type QueryPaymentsByInvoiceUuidArgs = {
  uuid: Scalars['String']['input'];
};


export type QueryPaymentsV2Args = {
  args: FindPaymentsV2Args;
};


export type QueryPdfColumnArgs = {
  uuid: Scalars['String']['input'];
};


export type QueryPersonArgs = {
  id: Scalars['String']['input'];
};


export type QueryPersonsArgs = {
  contactUuid?: InputMaybe<Scalars['String']['input']>;
};


export type QueryPicklistsArgs = {
  picklistsInput: PicklistsInput;
};


export type QueryPieceArgs = {
  uuid: Scalars['String']['input'];
};


export type QueryPiecesGroupedByStatusArgs = {
  piecesGroupedByStatusInput: PiecesGroupedByStatusInput;
};


export type QueryPlaceArgs = {
  uuid: Scalars['String']['input'];
};


export type QueryPreviewAddOrdersToInvoicesArgs = {
  previewAddOrdersToInvoicesInput: PreviewAddOrdersToInvoicesInput;
};


export type QueryPreviewBatchAddShipmentsToInvoicesArgs = {
  batchAddShipmentsToInvoicesInput: BatchAddShipmentsToInvoicesInput;
};


export type QueryPreviewBatchAddShipmentsToInvoicesMultipleArgs = {
  batchAddShipmentsToInvoicesInputMultiple: BatchAddShipmentsToInvoicesInputMultiple;
};


export type QueryPreviewParseCsvOrdersArgs = {
  input: PreviewParseCsvOrdersInput;
};


export type QueryPreviewProratedConsolidationArgs = {
  previewProratedConsolidationInput: PreviewProratedConsolidationInput;
};


export type QueryPreviewProratedConsolidationV2Args = {
  previewProratedConsolidationV2Input: PreviewProratedConsolidationV2Input;
};


export type QueryQuoteArgs = {
  uuid: Scalars['String']['input'];
};


export type QueryQuoteNameArgs = {
  billingPartyContactUuid: Scalars['String']['input'];
};


export type QueryQuotesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  createdAtEndDate?: InputMaybe<Scalars['DateTime']['input']>;
  createdAtStartDate?: InputMaybe<Scalars['DateTime']['input']>;
  destinationTerminalUuid?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  originTerminalUuid?: InputMaybe<Scalars['String']['input']>;
  quoteStatus?: InputMaybe<QuoteStatus>;
  searchText?: InputMaybe<Scalars['String']['input']>;
};


export type QueryRateAutoAppliedAccessorialsArgs = {
  rateAutoAppliedAccessorialsInput: RateAutoAppliedAccessorialsInput;
};


export type QueryRateOrderByUuidArgs = {
  persist: Scalars['Boolean']['input'];
  uuid: Scalars['String']['input'];
};


export type QueryRateOrderContentsArgs = {
  rateOrderInput: RateOrderInput;
};


export type QueryReceiptItemStorageUnitsArgs = {
  itemUuid: Scalars['String']['input'];
  receiptUuid: Scalars['String']['input'];
};


export type QueryRecurringOrderFrequencyArgs = {
  uuid: Scalars['String']['input'];
};


export type QueryRecurringOrderTemplatesArgs = {
  runUuid?: InputMaybe<Scalars['String']['input']>;
};


export type QueryReferenceNumberFormatConfigsArgs = {
  contactUuid: Scalars['String']['input'];
};


export type QueryRemainingAmountOfInvoicesArgs = {
  uuids: Array<Scalars['String']['input']>;
};


export type QueryReportSendJobBatchesArgs = {
  findReportSendJobBatchesInput: FindReportSendJobBatchesInput;
};


export type QueryReportSendJobsArgs = {
  findReportSendJobsInput: FindReportSendJobsInput;
};


export type QueryReportsEmailSenderIsVerifiedArgs = {
  userUuid: Scalars['String']['input'];
};


export type QueryRoleArgs = {
  findRoleInput: FindRoleInput;
};


export type QueryRolesArgs = {
  findRolesInput?: InputMaybe<FindRolesInput>;
};


export type QueryRouteArgs = {
  uuid: Scalars['String']['input'];
};


export type QueryRouteNameArgs = {
  uuid: Scalars['String']['input'];
};


export type QueryRoutesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  date?: InputMaybe<Scalars['DateTime']['input']>;
  driverUuid?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  maximumTake?: InputMaybe<Scalars['Int']['input']>;
  routeSort?: InputMaybe<RouteSort>;
  routeUuids?: InputMaybe<Array<Scalars['String']['input']>>;
  searchText?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  terminalUuid?: InputMaybe<Scalars['String']['input']>;
  versionId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryRoutesSamsaraVehicleLocationsArgs = {
  routeUuids: Array<Scalars['String']['input']>;
};


export type QuerySageBusinessWorksInvoiceExportCsvArgs = {
  invoiceUuids: Array<Scalars['String']['input']>;
};


export type QuerySalesVarianceReportCsvArgs = {
  salesVarianceReportInput: SalesVarianceReportInput;
};


export type QuerySamsaraDriversArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
};


export type QuerySamsaraVehicleStatsFeedArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  samsaraVehicleIds: Array<Scalars['String']['input']>;
};


export type QuerySamsaraVehiclesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
};


export type QueryScannedOrderArgs = {
  uuid: Scalars['String']['input'];
};


export type QueryScannedOrderResultArgs = {
  uuid: Scalars['String']['input'];
};


export type QueryScannedOrderResultByOrderUuidArgs = {
  uuid: Scalars['String']['input'];
};


export type QueryScannedOrderResultsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  approvedAtAfter?: InputMaybe<Scalars['DateTime']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  contactUuid?: InputMaybe<Scalars['String']['input']>;
  createdAtAfter?: InputMaybe<Scalars['DateTime']['input']>;
  destinationTerminalUuid?: InputMaybe<Scalars['String']['input']>;
  emailIntegrationTerminalUuid?: InputMaybe<Scalars['String']['input']>;
  failureReasonFilter?: InputMaybe<ScannedOrderFailureReason>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  originTerminalUuid?: InputMaybe<Scalars['String']['input']>;
  rejectedAtAfter?: InputMaybe<Scalars['DateTime']['input']>;
  searchText?: InputMaybe<Scalars['String']['input']>;
  signedPodMatchStatuses?: InputMaybe<Array<SignedPodMatchStatus>>;
  sourceFilter?: ScannedOrderResultSourceFilter;
  status?: InputMaybe<ScannedOrderResultStatus>;
  statuses?: InputMaybe<Array<ScannedOrderResultStatus>>;
  type: ScannedOrderResultType;
};


export type QueryScannedOrderResultsForAdminArgs = {
  args: GetScannedOrderResultsForAdminArgs;
};


export type QueryScannedOrdersArgs = {
  findScannedOrdersInput: FindScannedOrdersInput;
};


export type QuerySchedulingRegionArgs = {
  id: Scalars['String']['input'];
};


export type QuerySchemaCompanyMappingsArgs = {
  schemaUuid: Scalars['String']['input'];
};


export type QuerySchemaDocumentsBySchemaCompanyMappingArgs = {
  schemaCompanyMappingId: Scalars['String']['input'];
};


export type QuerySchemaFilePutUrlArgs = {
  schemaFilePutUrlInput: SchemaFilePutUrlInput;
};


export type QuerySchemaRunArgs = {
  uuid: Scalars['String']['input'];
};


export type QuerySchemaRunTestListArgs = {
  schemaRunTestListInput: SchemaRunTestListInput;
};


export type QuerySchemaTestFilePutUrlArgs = {
  schemaTestFilePutUrlInput: SchemaTestFilePutUrlInput;
};


export type QuerySearchSchemasArgs = {
  companyUuid?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  searchText?: InputMaybe<Scalars['String']['input']>;
};


export type QuerySegmentedLineHaulOrdersArgs = {
  findSegmentedLineHaulOrdersInput: FindSegmentedLineHaulOrdersInput;
};


export type QuerySegmentedLineHaulOrdersV2Args = {
  findSegmentedLineHaulOrdersInputV2: FindSegmentedLineHaulOrdersInputV2;
};


export type QuerySelectSpecialAccessorialArgs = {
  selectSpecialAccessorialInput: SelectSpecialAccessorialInput;
};


export type QueryServiceLevelReportArgs = {
  args: ServiceLevelReportArgs;
};


export type QueryServiceRegionArgs = {
  id: Scalars['String']['input'];
};


export type QueryServiceRegionsArgs = {
  input: GetServiceRegionsInput;
};


export type QueryServicesForOrderArgs = {
  findServicesForOrderInput: FindServicesForOrderInput;
};


export type QueryServicesForThirdPartyUserArgs = {
  findServicesForThirdPartyUserInput: FindServicesForThirdPartyUserInput;
};


export type QuerySettlementBillLineItemArgs = {
  id: Scalars['String']['input'];
};


export type QuerySettlementBillLineItemsArgs = {
  findSettlementBillLineItemInput: FindSettlementBillLineItemsInput;
};


export type QuerySftpUploadsArgs = {
  findSftpUploadsInput: FindSftpUploadsInput;
};


export type QueryShipmentArgs = {
  uuid: Scalars['String']['input'];
};


export type QueryShipmentV2Args = {
  uuid: Scalars['String']['input'];
};


export type QueryShipmentsArgs = {
  getShipmentsInput?: InputMaybe<GetShipmentsInput>;
};


export type QueryShipmentsByContactUuidArgs = {
  contactUuid?: InputMaybe<Scalars['String']['input']>;
  endCompletedDate?: InputMaybe<Scalars['DateTime']['input']>;
  startCompletedDate?: InputMaybe<Scalars['DateTime']['input']>;
};


export type QueryShipmentsByPhoneOrReferenceNumberArgs = {
  companyUuid: Scalars['String']['input'];
  searchText: Scalars['String']['input'];
};


export type QueryStandardOrderArgs = {
  uuid: Scalars['String']['input'];
};


export type QueryStandardOrderForReviewArgs = {
  uuid: Scalars['String']['input'];
};


export type QueryStationReportArgs = {
  args: StationReportArgs;
};


export type QueryStopArgs = {
  uuid: Scalars['String']['input'];
};


export type QueryStopDriverMapsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  chargesFinalized?: InputMaybe<Scalars['Boolean']['input']>;
  completedEndDate?: InputMaybe<Scalars['DateTime']['input']>;
  completedStartDate?: InputMaybe<Scalars['DateTime']['input']>;
  driverSettlementBillUuid?: InputMaybe<Scalars['String']['input']>;
  driverSettlementFinalized?: InputMaybe<Scalars['Boolean']['input']>;
  driverUuid?: InputMaybe<Scalars['String']['input']>;
  excludeStopDriverMapUuids?: InputMaybe<Array<Scalars['String']['input']>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  includeStopDriverMapUuids?: InputMaybe<Array<Scalars['String']['input']>>;
  invoiceStatuses?: InputMaybe<Array<InvoiceStatus>>;
  last?: InputMaybe<Scalars['Int']['input']>;
  noMaximum?: InputMaybe<Scalars['Boolean']['input']>;
  onDriverSettlementBill?: InputMaybe<Scalars['Boolean']['input']>;
  onInvoice?: InputMaybe<Scalars['Boolean']['input']>;
  searchText?: InputMaybe<Scalars['String']['input']>;
  settlementEndDate?: InputMaybe<Scalars['DateTime']['input']>;
  settlementStartDate?: InputMaybe<Scalars['DateTime']['input']>;
  sortByCompletedDateAsc?: InputMaybe<Scalars['Boolean']['input']>;
  sortBySettlementDateAsc?: InputMaybe<Scalars['Boolean']['input']>;
  stopTypes?: InputMaybe<Array<StopType>>;
};


export type QueryStopsArgs = {
  addressType?: InputMaybe<StandardStopType>;
  after?: InputMaybe<Scalars['String']['input']>;
  appointmentRequired?: InputMaybe<Scalars['Boolean']['input']>;
  appointmentScheduled?: InputMaybe<Scalars['Boolean']['input']>;
  appointmentTimeFilters?: InputMaybe<DateFilterStartEnd>;
  before?: InputMaybe<Scalars['String']['input']>;
  businessDivisionUuid?: InputMaybe<Scalars['String']['input']>;
  cacheStartIndex?: InputMaybe<Scalars['Float']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAtFilters?: InputMaybe<DateFilterStartEnd>;
  customerUuid?: InputMaybe<Scalars['String']['input']>;
  deadlineDate?: InputMaybe<Scalars['DateTime']['input']>;
  deadlineDateFilters?: InputMaybe<DateFilterStartEnd>;
  deliveryDate?: InputMaybe<Scalars['DateTime']['input']>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  filters?: InputMaybe<Array<FindStopsFiltersInput>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasAppointment?: InputMaybe<Scalars['Boolean']['input']>;
  hideOnHold?: InputMaybe<Scalars['Boolean']['input']>;
  hideStopsWithoutAddress?: InputMaybe<Scalars['Boolean']['input']>;
  includeCount?: InputMaybe<Scalars['Boolean']['input']>;
  includeRecurringRunHeaders?: InputMaybe<Scalars['Boolean']['input']>;
  isAssigned?: InputMaybe<Scalars['Boolean']['input']>;
  isPicked?: InputMaybe<Scalars['Boolean']['input']>;
  isRefusedFilter?: InputMaybe<BooleanFilterV2>;
  isSpecial?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  noMaximum?: InputMaybe<Scalars['Boolean']['input']>;
  onHand?: InputMaybe<Scalars['Boolean']['input']>;
  orderStatuses?: InputMaybe<Array<OrderStatus>>;
  orderUuid?: InputMaybe<Scalars['String']['input']>;
  orderUuids?: InputMaybe<Array<Scalars['String']['input']>>;
  pickupOrDeliveryTypes?: InputMaybe<Array<PickupOrDelivery>>;
  previouslyAttempted?: InputMaybe<Scalars['Boolean']['input']>;
  requiresRecovery?: InputMaybe<Scalars['Boolean']['input']>;
  routeNameUuid?: InputMaybe<Scalars['String']['input']>;
  searchText?: InputMaybe<Scalars['String']['input']>;
  serviceDateFilters?: InputMaybe<DateFilterStartEnd>;
  serviceLevelUuids?: InputMaybe<Array<Scalars['String']['input']>>;
  sort?: InputMaybe<StopSort>;
  sorts?: InputMaybe<Array<StopSort>>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  statuses?: InputMaybe<Array<StopStatus>>;
  tagUuids?: InputMaybe<Array<Scalars['String']['input']>>;
  terminalUuid?: InputMaybe<Scalars['String']['input']>;
  transferPending?: InputMaybe<Scalars['Boolean']['input']>;
  useCache?: InputMaybe<Scalars['Boolean']['input']>;
  uuid?: InputMaybe<Scalars['String']['input']>;
  uuids?: InputMaybe<Array<Scalars['String']['input']>>;
  warehouseUuid?: InputMaybe<Scalars['String']['input']>;
};


export type QueryStopsBySearchTextArgs = {
  searchText: Scalars['String']['input'];
};


export type QueryStopsOnRoutesBySearchTextArgs = {
  searchText: Scalars['String']['input'];
};


export type QueryStorageOrderArgs = {
  findStorageOrderInput: FindStorageOrderInput;
};


export type QueryStorageOrderStorageUnitsArgs = {
  findStorageOrderStorageUnitsInput: FindStorageOrderStorageUnitsInput;
};


export type QueryStorageOrdersArgs = {
  findStorageOrdersInput: FindStorageOrdersInput;
};


export type QueryStorageUnitArgs = {
  findStorageUnitInput: FindStorageUnitInput;
};


export type QueryStorageUnitByNameArgs = {
  name: Scalars['String']['input'];
};


export type QueryStorageUnitsArgs = {
  findStorageUnitsInput: FindStorageUnitsInput;
};


export type QueryStructuredExtractionRunByScannedOrderArgs = {
  scannedOrderUuid: Scalars['String']['input'];
};


export type QueryTariffArgs = {
  uuid: Scalars['String']['input'];
};


export type QueryTariffChainsArgs = {
  findTariffChainsInput: FindTariffChainsInput;
};


export type QueryTariffGroupArgs = {
  uuid: Scalars['String']['input'];
};


export type QueryTariffGroupsArgs = {
  excludeDefault?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryTariffGroupsPaginatedArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  contactUuid?: InputMaybe<Scalars['String']['input']>;
  excludeDefault?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  searchText?: InputMaybe<Scalars['String']['input']>;
  serviceUuid?: InputMaybe<Scalars['String']['input']>;
  tariffGroupType?: InputMaybe<TariffGroupType>;
  uuids?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type QueryTariffZoneGroupArgs = {
  id: Scalars['String']['input'];
};


export type QueryTariffZoneGroupsArgs = {
  findTariffZoneGroupsInput: FindTariffZoneGroupsInput;
};


export type QueryTariffZonesArgs = {
  contactUuid?: InputMaybe<Scalars['String']['input']>;
  defaultToGlobal?: InputMaybe<Scalars['Boolean']['input']>;
  excludeLineHaulTariffZones?: InputMaybe<Scalars['Boolean']['input']>;
  excludeMileBasedTariffZones?: InputMaybe<Scalars['Boolean']['input']>;
  tariffZoneLocationType?: InputMaybe<TariffZoneLocationType>;
  tariffZoneType?: InputMaybe<TariffZoneType>;
};


export type QueryTariffsByContactArgs = {
  contactUuid: Scalars['String']['input'];
};


export type QueryTemplateAddressesArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
  searchText?: InputMaybe<Scalars['String']['input']>;
};


export type QueryTerminalArgs = {
  uuid: Scalars['String']['input'];
};


export type QueryTerminalForAddressArgs = {
  findTerminalForAddressInput: FindTerminalForAddressInput;
};


export type QueryTerminalReportArgs = {
  args: TerminalReportArgs;
};


export type QueryTerminalsArgs = {
  getTerminalsInput?: InputMaybe<GetTerminalsInput>;
};


export type QueryTerminalsForAddressArgs = {
  findTerminalForAddressInput: FindTerminalForAddressInput;
};


export type QueryTerminalsForInternalArgs = {
  getTerminalsInternalInput: GetTerminalsInternalInput;
};


export type QueryTerminalsForThirdPartyUserArgs = {
  findTerminalsForThirdPartyUserInput: FindTerminalsForThirdPartyUserInput;
};


export type QueryTestJsonSchemaOnDocumentsForSchemaArgs = {
  testJsonSchemaOnDocumentsForSchemaInput: TestJsonSchemaOnDocumentsForSchemaInput;
};


export type QueryTestOrderArgs = {
  findTestOrderInput: FindTestOrderInput;
};


export type QueryTextMessagesArgs = {
  phoneNumber: Scalars['String']['input'];
};


export type QueryThirdPartyUserArgs = {
  email: Scalars['String']['input'];
};


export type QueryThirdPartyUserByUuidArgs = {
  uuid: Scalars['String']['input'];
};


export type QueryThirdPartyUsersByContactArgs = {
  contactUuid: Scalars['String']['input'];
};


export type QueryUnappliedPaymentReportCsvArgs = {
  unappliedPaymentReportCsvInput: UnappliedPaymentReportCsvInput;
};


export type QueryUnifiedSearchArgs = {
  unifiedSearchInput: UnifiedSearchInput;
};


export type QueryUnifiedSearchInvoicesArgs = {
  unifiedSearchInput: UnifiedSearchInput;
};


export type QueryUnifiedSearchOrdersArgs = {
  unifiedSearchInput: UnifiedSearchInput;
};


export type QueryUnifiedSearchQuotesArgs = {
  unifiedSearchInput: UnifiedSearchInput;
};


export type QueryUnifiedSearchUnacceptedEdiAndApiOrdersArgs = {
  unifiedSearchInput: UnifiedSearchInput;
};


export type QueryUnifiedSearchUnacceptedEmailOrdersArgs = {
  unifiedSearchInput: UnifiedSearchInput;
};


export type QueryUserArgs = {
  email: Scalars['String']['input'];
};


export type QueryUserContactNotificationSubscriptionArgs = {
  contactUuid: Scalars['String']['input'];
};


export type QueryUsersArgs = {
  getUsersInput?: InputMaybe<GetUsersInput>;
};


export type QueryUsersEditingOrderArgs = {
  orderUuid: Scalars['String']['input'];
};


export type QueryVehicleTypeArgs = {
  uuid: Scalars['String']['input'];
};


export type QueryVerifySchemaDocumentMatchesForCompanyArgs = {
  companyUuid: Scalars['String']['input'];
  schemaDocumentUuid?: InputMaybe<Scalars['String']['input']>;
};


export type QueryWarehouseArgs = {
  warehouseUuid: Scalars['String']['input'];
};


export type QueryWarehouseAddressOfFirstRouteSlotArgs = {
  uuid: Scalars['String']['input'];
};


export type QueryWarehouseLocationsArgs = {
  companyUuid?: InputMaybe<Scalars['String']['input']>;
  warehouseUuid?: InputMaybe<Scalars['String']['input']>;
};


export type QueryWarehousesArgs = {
  warehousesInput?: InputMaybe<WarehousesInput>;
};


export type QueryWmsContactsArgs = {
  companyUuid?: InputMaybe<Scalars['String']['input']>;
};

export type QueryErrorOutput = {
  __typename?: 'QueryErrorOutput';
  message: Scalars['String']['output'];
};

export type QueueAppointmentSchedulingProposalsInput = {
  enableCall: Scalars['Boolean']['input'];
  enableText: Scalars['Boolean']['input'];
  stopUuids?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type QueueAppointmentSchedulingProposalsOutput = MutationErrorOutput | QueueAppointmentSchedulingProposalsSuccessOutput;

export type QueueAppointmentSchedulingProposalsSuccessOutput = {
  __typename?: 'QueueAppointmentSchedulingProposalsSuccessOutput';
  /** User-facing messages for errors encountered processing stops */
  errorMessages: Array<Scalars['String']['output']>;
  /** The UUIDs of the stops for which proposals were enqueued */
  stopUuids: Array<Scalars['String']['output']>;
};

export type QueueAppointmentTextsArgs = {
  appointmentUuids: Array<Scalars['String']['input']>;
};

export type QuickbooksCustomerEntity = {
  __typename?: 'QuickbooksCustomerEntity';
  active: Scalars['Boolean']['output'];
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  quickbooksBillToId?: Maybe<Scalars['String']['output']>;
  quickbooksRemitToId?: Maybe<Scalars['String']['output']>;
};

export type QuickbooksDesktopInvoiceEntity = {
  __typename?: 'QuickbooksDesktopInvoiceEntity';
  amount: Scalars['Float']['output'];
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type QuickbooksDesktopObjectEntity = {
  __typename?: 'QuickbooksDesktopObjectEntity';
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type QuickbooksDesktopResultEntity = {
  __typename?: 'QuickbooksDesktopResultEntity';
  error?: Maybe<Scalars['String']['output']>;
  quickbooksDesktopObjects?: Maybe<Array<QuickbooksDesktopObjectEntity>>;
};

export type QuickbooksHeaderFileMappingCreateInput = {
  cellNumber: Scalars['Float']['input'];
  headerType: HeaderFileMappingType;
  name: Scalars['String']['input'];
};

export type QuickbooksHeaderFileMappingEntity = {
  __typename?: 'QuickbooksHeaderFileMappingEntity';
  cellNumber: Scalars['Float']['output'];
  headerType: HeaderFileMappingType;
  name: Scalars['String']['output'];
  uuid: Scalars['String']['output'];
};

export type QuickbooksHeaderFileMappingUpdateInput = {
  cellNumber?: InputMaybe<Scalars['Float']['input']>;
  headerType?: InputMaybe<HeaderFileMappingType>;
  name?: InputMaybe<Scalars['String']['input']>;
  uuid: Scalars['String']['input'];
};

export type QuickbooksItemEntity = {
  __typename?: 'QuickbooksItemEntity';
  active: Scalars['Boolean']['output'];
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type QuickbooksOauthTokenEntity = {
  __typename?: 'QuickbooksOauthTokenEntity';
  accessToken: Scalars['String']['output'];
  expiresAt: Scalars['DateTime']['output'];
  refreshToken: Scalars['String']['output'];
  refreshTokenExpiresAt: Scalars['DateTime']['output'];
  tokenType: Scalars['String']['output'];
  uuid: Scalars['String']['output'];
};

export type QuoteConnection = {
  __typename?: 'QuoteConnection';
  edges: Array<QuoteEdge>;
  pageInfo: PageInfo;
  /** Not cheap to calculate, request with prudence */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type QuoteCreateInput = {
  companyUuid?: InputMaybe<Scalars['String']['input']>;
  contactUuid: Scalars['String']['input'];
  dimFactor?: InputMaybe<Scalars['Float']['input']>;
  enableLineHaul?: InputMaybe<Scalars['Boolean']['input']>;
  lineHaulLaneUuid?: InputMaybe<Scalars['String']['input']>;
  measurementUnits?: InputMaybe<MeasurementUnits>;
  number: Scalars['String']['input'];
  packageCreateInputs: Array<PackageCreateInput>;
  serviceUuid?: InputMaybe<Scalars['String']['input']>;
  shipmentCreateInputs: Array<ShipmentCreateInput>;
  totalSkids?: InputMaybe<Scalars['Int']['input']>;
  weightUnits?: InputMaybe<WeightUnits>;
};

export type QuoteEdge = {
  __typename?: 'QuoteEdge';
  cursor: Scalars['String']['output'];
  node: QuoteEntity;
};

export type QuoteEntity = {
  __typename?: 'QuoteEntity';
  billingPartyContact: ContactEntity;
  company: CompanyEntity;
  createdAt: Scalars['DateTime']['output'];
  dimFactor?: Maybe<Scalars['Float']['output']>;
  enableLineHaul: Scalars['Boolean']['output'];
  lineHaulLane?: Maybe<LineHaulLaneEntity>;
  measurementUnits?: Maybe<MeasurementUnits>;
  number: Scalars['String']['output'];
  order?: Maybe<OrderEntity>;
  packages: Array<PackageEntity>;
  service?: Maybe<ServiceEntity>;
  shipments: Array<ShipmentEntity>;
  source: QuoteSource;
  status: QuoteStatus;
  totalCharge: Scalars['Currency']['output'];
  totalSkids?: Maybe<Scalars['Int']['output']>;
  uuid: Scalars['String']['output'];
  weightUnits?: Maybe<WeightUnits>;
};

/** The source of a quote */
export enum QuoteSource {
  CustomerPortal = 'CUSTOMER_PORTAL',
  ManuallyCreated = 'MANUALLY_CREATED'
}

/** A filter object that is used to filter the quote source enum field. Each field in the filter object represents an operator. If there is more than one non-null field passed into the filter object, the condition will be a conjunction of the non-null field operator */
export type QuoteSourceFilter = {
  /** Filters for records where the relevant quote source field is equal to the provided quote source value */
  eq?: InputMaybe<QuoteSource>;
  /** Filters for records where the relevant quote source field is in the provided quote source values */
  in?: InputMaybe<Array<QuoteSource>>;
  /** Filters for records where the relevant quote source field is not equal to the provided quote source value */
  neq?: InputMaybe<QuoteSource>;
  /** Filters for records where the relevant quote source field is not in the provided quote source values */
  nin?: InputMaybe<Array<QuoteSource>>;
};

/** The status of a quote */
export enum QuoteStatus {
  Approved = 'APPROVED',
  Pending = 'PENDING',
  PendingContactApproval = 'PENDING_CONTACT_APPROVAL',
  Rejected = 'REJECTED'
}

/** A filter object that is used to filter the quote status enum field. Each field in the filter object represents an operator. If there is more than one non-null field passed into the filter object, the condition will be a conjunction of the non-null field operator */
export type QuoteStatusFilter = {
  /** Filters for records where the relevant quote status field is equal to the provided quote status value */
  eq?: InputMaybe<QuoteStatus>;
  /** Filters for records where the relevant quote status field is in the provided quote status values */
  in?: InputMaybe<Array<QuoteStatus>>;
  /** Filters for records where the relevant quote status field is not equal to the provided quote status value */
  neq?: InputMaybe<QuoteStatus>;
  /** Filters for records where the relevant quote status field is not in the provided quote status values */
  nin?: InputMaybe<Array<QuoteStatus>>;
};

export type QuoteUpdateInput = {
  companyUuid?: InputMaybe<Scalars['String']['input']>;
  contactUuid?: InputMaybe<Scalars['String']['input']>;
  dimFactor?: InputMaybe<Scalars['Float']['input']>;
  enableLineHaul?: InputMaybe<Scalars['Boolean']['input']>;
  lineHaulLaneUuid?: InputMaybe<Scalars['String']['input']>;
  measurementUnits?: InputMaybe<MeasurementUnits>;
  number?: InputMaybe<Scalars['String']['input']>;
  orderUuid?: InputMaybe<Scalars['String']['input']>;
  packageArrayUpdateInputs?: InputMaybe<Array<PackageArrayUpdateInput>>;
  serviceUuid?: InputMaybe<Scalars['String']['input']>;
  shipmentArrayUpdateInputs?: InputMaybe<Array<ShipmentArrayUpdateInput>>;
  status?: InputMaybe<QuoteStatus>;
  totalSkids?: InputMaybe<Scalars['Int']['input']>;
  weightUnits?: InputMaybe<WeightUnits>;
};

/** Custom charge for the rate auto applied accessorials query */
export type RateAutoAppliedAccessorialsCustomChargeInput = {
  /** This is required - filter out custom charges that arent based on an accessorial */
  accessorialUuid: Scalars['String']['input'];
  isAutoApplied: Scalars['Boolean']['input'];
  uuid: Scalars['String']['input'];
};

export type RateAutoAppliedAccessorialsCustomChargeToAddOutput = {
  __typename?: 'RateAutoAppliedAccessorialsCustomChargeToAddOutput';
  accessorialUuid: Scalars['String']['output'];
  chargeGroupUuid?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  rate: Scalars['Currency']['output'];
  zoneUuid?: Maybe<Scalars['String']['output']>;
};

export type RateAutoAppliedAccessorialsInput = {
  contactUuid: Scalars['String']['input'];
  inboundShipment?: InputMaybe<RateAutoAppliedAccessorialsShipmentInput>;
  isHazmat: Scalars['Boolean']['input'];
  isInBond: Scalars['Boolean']['input'];
  orderChargesShipment?: InputMaybe<RateAutoAppliedAccessorialsOrderChargesShipmentInput>;
  outboundShipment?: InputMaybe<RateAutoAppliedAccessorialsShipmentInput>;
  serviceUuid: Scalars['String']['input'];
  tagUuids?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** The order charges shipment for the rate auto applied accessorials query */
export type RateAutoAppliedAccessorialsOrderChargesShipmentInput = {
  customCharges: Array<RateAutoAppliedAccessorialsCustomChargeInput>;
};

export type RateAutoAppliedAccessorialsOutput = {
  __typename?: 'RateAutoAppliedAccessorialsOutput';
  /** The set of auto applied accessorials to add to / remove from the inbound shipment */
  inboundShipment?: Maybe<RateAutoAppliedAccessorialsShipmentOutput>;
  /** The set of auto applied accessorials to add to / remove from the inbound shipment */
  orderChargesShipment?: Maybe<RateAutoAppliedAccessorialsShipmentOutput>;
  /** The set of auto applied accessorials to add to / remove from the inbound shipment */
  outboundShipment?: Maybe<RateAutoAppliedAccessorialsShipmentOutput>;
};

/** Inbound or outbound shipment input for the rate auto applied accessorials query */
export type RateAutoAppliedAccessorialsShipmentInput = {
  customCharges: Array<RateAutoAppliedAccessorialsCustomChargeInput>;
  standardStopType: StandardStopType;
  stopType: StopType;
  terminalUuid: Scalars['String']['input'];
};

export type RateAutoAppliedAccessorialsShipmentOutput = {
  __typename?: 'RateAutoAppliedAccessorialsShipmentOutput';
  /** The set of accessorials to auto-apply */
  customChargesToAdd: Array<RateAutoAppliedAccessorialsCustomChargeToAddOutput>;
  /** The set of custom charges to remove. These represent auto-applied accessorials that should no longer be auto-applied */
  customChargesToRemove: Array<Scalars['String']['output']>;
};

export type RateCustomChargeOutput = {
  __typename?: 'RateCustomChargeOutput';
  errorMessage?: Maybe<Scalars['Float']['output']>;
  existingCustomChargeUuid?: Maybe<Scalars['String']['output']>;
  fuelSurchargePercentageRate?: Maybe<Scalars['Float']['output']>;
  rateDollars?: Maybe<Scalars['Currency']['output']>;
  settlementFlatRate?: Maybe<Scalars['Currency']['output']>;
  settlementPercentageRate?: Maybe<Scalars['Percent']['output']>;
  totalDollars?: Maybe<Scalars['Currency']['output']>;
};

export type RateCustomCostOutput = {
  __typename?: 'RateCustomCostOutput';
  errorMessage?: Maybe<Scalars['Float']['output']>;
  existingCustomCostId?: Maybe<Scalars['String']['output']>;
  fuelSurchargePercentageRate?: Maybe<Scalars['Float']['output']>;
  rateDollars?: Maybe<Scalars['Currency']['output']>;
  totalDollars?: Maybe<Scalars['Currency']['output']>;
};

export type RateDependentFreightCostSuccessOutput = {
  __typename?: 'RateDependentFreightCostSuccessOutput';
  flatRateUsdDollars?: Maybe<Scalars['Currency']['output']>;
  percentageRate?: Maybe<Scalars['Percent']['output']>;
  totalDollars: Scalars['Currency']['output'];
};

export type RateDependentFuelCostSuccessOutput = {
  __typename?: 'RateDependentFuelCostSuccessOutput';
  /** The flat rate for the fuel cost. Null if the dependent billing method is not FLAT_RATE */
  flatRateUsdDollars?: Maybe<Scalars['Currency']['output']>;
  /** The percentage rate for the fuel cost. Null if the dependent billing method is not PERCENTAGE or AUTO-CALCULATE */
  percentageRate?: Maybe<Scalars['Percent']['output']>;
  totalDollars: Scalars['Currency']['output'];
};

export type RateDependentSettlementBillLineItemSuccessOutput = {
  __typename?: 'RateDependentSettlementBillLineItemSuccessOutput';
  customCostTotal: Scalars['Currency']['output'];
  customCosts: Array<RateCustomCostOutput>;
  freightCost?: Maybe<RateDependentFreightCostSuccessOutput>;
  fuelCost?: Maybe<RateDependentFuelCostSuccessOutput>;
  success: Scalars['Boolean']['output'];
  total: Scalars['Currency']['output'];
};

export type RateFreightChargeSuccessOutput = {
  __typename?: 'RateFreightChargeSuccessOutput';
  discountRate?: Maybe<Scalars['Percent']['output']>;
  miles?: Maybe<Scalars['Float']['output']>;
  quantity: Scalars['Float']['output'];
  /** The rate of the freight charge. $ / lb, $ / mi, or total $ in the flat rate case */
  rateDollars: Scalars['Currency']['output'];
  settlementFlatRate?: Maybe<Scalars['Currency']['output']>;
  settlementPercentageRate?: Maybe<Scalars['Percent']['output']>;
  tariffUuid?: Maybe<Scalars['String']['output']>;
  totalDollars: Scalars['Currency']['output'];
};

export type RateFuelChargeSuccessOutput = {
  __typename?: 'RateFuelChargeSuccessOutput';
  settlementFlatRate?: Maybe<Scalars['Currency']['output']>;
  settlementPercentageRate?: Maybe<Scalars['Percent']['output']>;
  /** The surcharge rate for the fuel charge. Null if the fuel charge billing method is not PERCENTAGE (or isn't set to auto-calculate. */
  surchargeRate?: Maybe<Scalars['Float']['output']>;
  surchargeRatePercentage?: Maybe<Scalars['Percent']['output']>;
  totalDollars: Scalars['Currency']['output'];
};

export type RateIndependentFreightCostSuccessOutput = {
  __typename?: 'RateIndependentFreightCostSuccessOutput';
  /** Percentage out of 100 */
  discountRate?: Maybe<Scalars['Percent']['output']>;
  miles?: Maybe<Scalars['Float']['output']>;
  quantity: Scalars['Float']['output'];
  /** The rate of the freight charge. $ / lb, $ / mi, or total $ in the flat rate case */
  rateDollars: Scalars['Currency']['output'];
  tariffUuid?: Maybe<Scalars['String']['output']>;
  totalDollars: Scalars['Currency']['output'];
};

export type RateIndependentFuelCostSuccessOutput = {
  __typename?: 'RateIndependentFuelCostSuccessOutput';
  flatRateUsdDollars?: Maybe<Scalars['Currency']['output']>;
  /** The surcharge rate for the fuel cost. Null if the fuel cost billing method is not PERCENTAGE (or isn't set to auto-calculate. */
  surchargeRate?: Maybe<Scalars['Float']['output']>;
  surchargeRatePercentage?: Maybe<Scalars['Percent']['output']>;
  totalDollars: Scalars['Currency']['output'];
};

export type RateIndependentSettlementBillLineItemSuccessOutput = {
  __typename?: 'RateIndependentSettlementBillLineItemSuccessOutput';
  customCostTotal: Scalars['Currency']['output'];
  customCosts: Array<RateCustomCostOutput>;
  freightCost?: Maybe<RateIndependentFreightCostSuccessOutput>;
  fuelCost?: Maybe<RateIndependentFuelCostSuccessOutput>;
  success: Scalars['Boolean']['output'];
  /** The total amount of the line item in USD */
  total: Scalars['Currency']['output'];
};

export type RateOrderAddressInput = {
  city: Scalars['String']['input'];
  country?: InputMaybe<Scalars['String']['input']>;
  latitude?: InputMaybe<Scalars['Float']['input']>;
  line1?: InputMaybe<Scalars['String']['input']>;
  line2?: InputMaybe<Scalars['String']['input']>;
  longitude?: InputMaybe<Scalars['Float']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  zip: Scalars['String']['input'];
};

export type RateOrderChargesInput = {
  customCharges: Array<RateOrderCustomChargeInput>;
  freightCharge?: InputMaybe<RateOrderFreightChargeInput>;
  fuelCharge?: InputMaybe<RateOrderFuelChargeInput>;
};

export type RateOrderCustomChargeInput = {
  accessorialUuid?: InputMaybe<Scalars['String']['input']>;
  billingMethod: CustomChargeBillingMethod;
  existingCustomChargeUuid?: InputMaybe<Scalars['String']['input']>;
  fuelSurchargeRate?: InputMaybe<Scalars['Float']['input']>;
  quantity: Scalars['Float']['input'];
  rateUsdDecimalCents?: InputMaybe<Scalars['Float']['input']>;
  settlementFlatRate?: InputMaybe<Scalars['Float']['input']>;
  settlementPercentageRate?: InputMaybe<Scalars['Float']['input']>;
  specialAccessorialChargeGroupUuid?: InputMaybe<Scalars['String']['input']>;
  specialAccessorialMatrixItemUuid?: InputMaybe<Scalars['String']['input']>;
  useAccessorialRate: Scalars['Boolean']['input'];
  zoneBasedAccessorialMatrixItemUuid?: InputMaybe<Scalars['String']['input']>;
};

export type RateOrderDependentCustomCostInput = {
  customCharge: RateOrderCustomChargeInput;
  dependentSettlementBillingMethod: DependentSettlementBillingMethod;
  existingCustomCostId?: InputMaybe<Scalars['String']['input']>;
  flatRateUsdCents?: InputMaybe<Scalars['Decimal']['input']>;
  percentageRate?: InputMaybe<Scalars['Decimal']['input']>;
};

export type RateOrderDependentFreightCostInput = {
  dependentSettlementBillingMethod: DependentSettlementBillingMethod;
  existingFreightCostId?: InputMaybe<Scalars['String']['input']>;
  flatRateUsdCents?: InputMaybe<Scalars['Decimal']['input']>;
  freightCharge: RateOrderFreightChargeInput;
  percentageRate?: InputMaybe<Scalars['Decimal']['input']>;
};

export type RateOrderDependentFuelCostInput = {
  dependentSettlementBillingMethod: DependentSettlementBillingMethod;
  existingCustomCostId?: InputMaybe<Scalars['String']['input']>;
  existingFuelCostId?: InputMaybe<Scalars['String']['input']>;
  flatRateUsdCents?: InputMaybe<Scalars['Decimal']['input']>;
  fuelCharge: RateOrderFuelChargeInput;
  percentageRate?: InputMaybe<Scalars['Decimal']['input']>;
};

export type RateOrderDependentSettlementBillLineItemInput = {
  agentUuid?: InputMaybe<Scalars['String']['input']>;
  customCosts: Array<RateOrderDependentCustomCostInput>;
  driverUuid: Scalars['String']['input'];
  /** The id of the settlement bill line item that is being rated. Set the id to null if the order is currently being created */
  existingId?: InputMaybe<Scalars['String']['input']>;
  freightCost?: InputMaybe<RateOrderDependentFreightCostInput>;
  fuelCost?: InputMaybe<RateOrderDependentFuelCostInput>;
  settlementBillFinalizedDate?: InputMaybe<Scalars['DateTime']['input']>;
  settlementBillUuid?: InputMaybe<Scalars['String']['input']>;
  settlementMode: SettlementMode;
};

export type RateOrderErrorOutput = {
  __typename?: 'RateOrderErrorOutput';
  errorMessage?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type RateOrderFreightChargeInput = {
  billingMethod: FreightBillingMethod;
  existingFreightChargeUuid?: InputMaybe<Scalars['String']['input']>;
  quantityInHundreds?: InputMaybe<Scalars['Int']['input']>;
  rateUsdCents?: InputMaybe<Scalars['Int']['input']>;
  /** Represents the freight charge rate in cents. Currently only implemented on the API layer and not stored in the database. */
  rateUsdDecimalCents?: InputMaybe<Scalars['Decimal']['input']>;
  settlementFlatRate?: InputMaybe<Scalars['Float']['input']>;
  settlementPercentageRate?: InputMaybe<Scalars['Float']['input']>;
  tariffUuid?: InputMaybe<Scalars['String']['input']>;
};

export type RateOrderFuelChargeInput = {
  existingFuelChargeUuid?: InputMaybe<Scalars['String']['input']>;
  flatRateUsdCents?: InputMaybe<Scalars['Float']['input']>;
  settlementFlatRate?: InputMaybe<Scalars['Float']['input']>;
  settlementPercentageRate?: InputMaybe<Scalars['Float']['input']>;
  /** The percentage rate from [0,1] of the fuel charge. Will be zero if fuel billing method is FLAT_RATE */
  surchargeRate: Scalars['Float']['input'];
  type: FuelBillingMethod;
};

export type RateOrderIndependentCustomCostInput = {
  accessorialUuid?: InputMaybe<Scalars['String']['input']>;
  billingMethod: CustomChargeBillingMethod;
  existingCustomCostId?: InputMaybe<Scalars['String']['input']>;
  fuelSurchargeRate?: InputMaybe<Scalars['Decimal']['input']>;
  quantity: Scalars['Float']['input'];
  rateUsdCents?: InputMaybe<Scalars['Decimal']['input']>;
  specialAccessorialChargeGroupUuid?: InputMaybe<Scalars['String']['input']>;
  specialAccessorialMatrixItemUuid?: InputMaybe<Scalars['String']['input']>;
  useAccessorialRate: Scalars['Boolean']['input'];
  zoneBasedAccessorialMatrixItemUuid?: InputMaybe<Scalars['String']['input']>;
};

export type RateOrderIndependentFreightCostInput = {
  billingMethod?: InputMaybe<FreightBillingMethod>;
  existingFreightCostId?: InputMaybe<Scalars['String']['input']>;
  flatRateUsdCents?: InputMaybe<Scalars['Decimal']['input']>;
  quantity?: InputMaybe<Scalars['Int']['input']>;
  rateUsdCents?: InputMaybe<Scalars['Decimal']['input']>;
  tariffUuid?: InputMaybe<Scalars['String']['input']>;
};

export type RateOrderIndependentFuelCostInput = {
  billingMethod: FuelBillingMethod;
  existingFuelCostId?: InputMaybe<Scalars['String']['input']>;
  flatRateUsdCents?: InputMaybe<Scalars['Decimal']['input']>;
  /** The percentage rate from [0,1] of the fuel cost */
  surchargeRate: Scalars['Decimal']['input'];
};

export type RateOrderIndependentSettlementBillLineItemInput = {
  agentUuid?: InputMaybe<Scalars['String']['input']>;
  customCosts: Array<RateOrderIndependentCustomCostInput>;
  driverUuid: Scalars['String']['input'];
  /** The id of the settlement bill line item that is being rated. Set the id to null if the order is currently being created */
  existingId?: InputMaybe<Scalars['String']['input']>;
  freightCost?: InputMaybe<RateOrderIndependentFreightCostInput>;
  fuelCost?: InputMaybe<RateOrderIndependentFuelCostInput>;
  settlementBillFinalizedDate?: InputMaybe<Scalars['DateTime']['input']>;
  settlementBillUuid?: InputMaybe<Scalars['String']['input']>;
  settlementMode: SettlementMode;
};

export type RateOrderInput = {
  companyUuid: Scalars['String']['input'];
  contactUuid: Scalars['String']['input'];
  detailedStatus: OrderDetailedStatus;
  dimFactor: Scalars['Float']['input'];
  existingOrderUuid?: InputMaybe<Scalars['String']['input']>;
  inboundShipment?: InputMaybe<RateOrderRegularShipmentAndChargesInput>;
  lineHaul?: InputMaybe<RateOrderLineHaulShipmentAndChargesInput>;
  orderCharges?: InputMaybe<RateOrderOrderChargesShipmentAndChargesInput>;
  outboundShipment?: InputMaybe<RateOrderRegularShipmentAndChargesInput>;
  packages: Array<RateOrderPackageInput>;
  serviceUuid?: InputMaybe<Scalars['String']['input']>;
  totalAmountCents?: InputMaybe<Scalars['Float']['input']>;
  totalSkids?: InputMaybe<Scalars['Float']['input']>;
  vehicleTypeUuid?: InputMaybe<Scalars['String']['input']>;
};

export type RateOrderLineHaulShipmentAndChargesInput = {
  charges: RateOrderChargesInput;
  /** Currently nullable so older clients don't break */
  dependentSettlementBillLineItems?: InputMaybe<Array<RateOrderDependentSettlementBillLineItemInput>>;
  /** Currently nullable so older clients don't break */
  independentSettlementBillLineItems?: InputMaybe<Array<RateOrderIndependentSettlementBillLineItemInput>>;
  shipmentDetails: RateOrderLineHaulShipmentInput;
};

export type RateOrderLineHaulShipmentInput = {
  completedAt?: InputMaybe<Scalars['DateTime']['input']>;
  destinationTerminalUuid?: InputMaybe<Scalars['String']['input']>;
  /** The UUID of the shipment that is being rated. Set the UUID to null if the order is currently being created */
  existingShipmentUuid?: InputMaybe<Scalars['String']['input']>;
  laneUuid?: InputMaybe<Scalars['String']['input']>;
  originTerminalUuid?: InputMaybe<Scalars['String']['input']>;
  serviceDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** The updated service date, as an ISO 8601 formatted date string. If not provided, this field will not be updated. */
  serviceDateIso8601?: InputMaybe<Scalars['String']['input']>;
  shipmentType: ShipmentType;
};

export type RateOrderOrderChargesShipmentAndChargesInput = {
  charges: RateOrderChargesInput;
  /** Currently nullable so older clients don't break */
  dependentSettlementBillLineItems?: InputMaybe<Array<RateOrderDependentSettlementBillLineItemInput>>;
  /** Currently nullable so older clients don't break */
  independentSettlementBillLineItems?: InputMaybe<Array<RateOrderIndependentSettlementBillLineItemInput>>;
  shipmentDetails: RateOrderOrderChargesShipmentInput;
};

export type RateOrderOrderChargesShipmentInput = {
  /** The UUID of the shipment that is being rated. Set the UUID to null if the order is currently being created */
  existingShipmentUuid?: InputMaybe<Scalars['String']['input']>;
  shipmentType: ShipmentType;
};

export type RateOrderOutput = RateOrderErrorOutput | RateOrderSuccessOutput;

export type RateOrderPackageInput = {
  /** height in inches */
  height?: InputMaybe<Scalars['Float']['input']>;
  /** length in inches */
  length?: InputMaybe<Scalars['Float']['input']>;
  quantity?: InputMaybe<Scalars['Float']['input']>;
  /** weight in pounds */
  weight?: InputMaybe<Scalars['Float']['input']>;
  /** width in inches */
  width?: InputMaybe<Scalars['Float']['input']>;
};

export type RateOrderRegularShipmentAndChargesInput = {
  charges: RateOrderChargesInput;
  /** Currently nullable so older clients don't break */
  dependentSettlementBillLineItems?: InputMaybe<Array<RateOrderDependentSettlementBillLineItemInput>>;
  /** Currently nullable so older clients don't break */
  independentSettlementBillLineItems?: InputMaybe<Array<RateOrderIndependentSettlementBillLineItemInput>>;
  shipmentDetails: RateOrderRegularShipmentInput;
};

export type RateOrderRegularShipmentInput = {
  /** The UUID of the shipment that is being rated. Set the UUID to null if the order is currently being created */
  existingShipmentUuid?: InputMaybe<Scalars['String']['input']>;
  overridePackageWeight: Scalars['Boolean']['input'];
  shipmentType: ShipmentType;
  stop: RateOrderStopInput;
};

export type RateOrderStopInput = {
  /** The stop's address to use for tariff selection if applicable. Null if the stop address does not exist */
  address?: InputMaybe<RateOrderAddressInput>;
  appointmentDate?: InputMaybe<Scalars['DateTime']['input']>;
  completedAt?: InputMaybe<Scalars['DateTime']['input']>;
  driverUuid?: InputMaybe<Scalars['String']['input']>;
  miles?: InputMaybe<Scalars['Float']['input']>;
  serviceDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** The stop's service date in ISO 8601 format. */
  serviceDateIso8601?: InputMaybe<Scalars['String']['input']>;
  stopType: StopType;
  terminalUuid?: InputMaybe<Scalars['String']['input']>;
};

export type RateOrderSuccessOutput = {
  __typename?: 'RateOrderSuccessOutput';
  inboundShipmentCharges?: Maybe<RateShipmentForOrderSuccessOutput>;
  lineHaulCharges?: Maybe<RateShipmentForOrderSuccessOutput>;
  orderCharges?: Maybe<RateShipmentForOrderSuccessOutput>;
  outboundShipmentCharges?: Maybe<RateShipmentForOrderSuccessOutput>;
  success: Scalars['Boolean']['output'];
  totalDollars?: Maybe<Scalars['Currency']['output']>;
};

export type RateShipmentForOrderSuccessOutput = {
  __typename?: 'RateShipmentForOrderSuccessOutput';
  customChargeTotal: Scalars['Currency']['output'];
  customCharges: Array<RateCustomChargeOutput>;
  dependentSettlementBillLineItems: Array<RateDependentSettlementBillLineItemSuccessOutput>;
  freightCharge?: Maybe<RateFreightChargeSuccessOutput>;
  fuelCharge?: Maybe<RateFuelChargeSuccessOutput>;
  independentSettlementBillLineItems: Array<RateIndependentSettlementBillLineItemSuccessOutput>;
  success: Scalars['Boolean']['output'];
  total: Scalars['Currency']['output'];
};

export enum RateType {
  Flat = 'FLAT',
  QuantityBased = 'QUANTITY_BASED'
}

export type ReanalyzePageInput = {
  documentName: Scalars['String']['input'];
  schemaUuid: Scalars['String']['input'];
};

export type ReanalyzeSchemaFileInput = {
  pngFilename: Scalars['String']['input'];
  textractType: TextractType;
};

export type RecurringOrderFrequencyEntity = {
  __typename?: 'RecurringOrderFrequencyEntity';
  daysOfMonth: Array<Scalars['Int']['output']>;
  daysOfWeek: Array<DayOfWeekAll>;
  endDate?: Maybe<Scalars['DateTime']['output']>;
  repeatFrequencyUnit: RepeatFrequencyUnit;
  repeatInterval: Scalars['Int']['output'];
  /** @deprecated Use repeatInterval instead */
  repeatIntervalWeeks?: Maybe<Scalars['Int']['output']>;
  startDate: Scalars['DateTime']['output'];
  uuid: Scalars['String']['output'];
};

export type RecurringRunHeaderEntity = {
  __typename?: 'RecurringRunHeaderEntity';
  createdAt: Scalars['DateTime']['output'];
  driver?: Maybe<DriverEntity>;
  isArchived: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  recurringOrderTemplates: Array<OrderEntity>;
  tags: Array<TagEntity>;
  terminal?: Maybe<TerminalEntity>;
  updatedAt: Scalars['DateTime']['output'];
  uuid: Scalars['String']['output'];
  vehicleType?: Maybe<VehicleTypeEntity>;
};

export type ReferenceNumberFormatCheckEntity = {
  __typename?: 'ReferenceNumberFormatCheckEntity';
  createdAt: Scalars['DateTime']['output'];
  lengthOperand?: Maybe<Scalars['Int']['output']>;
  operator?: Maybe<ReferenceNumberFormatCheckOperator>;
  startsWithOperands: Array<Scalars['String']['output']>;
  type: ReferenceNumberFormatCheckType;
  updatedAt: Scalars['DateTime']['output'];
  uuid: Scalars['String']['output'];
};

export enum ReferenceNumberFormatCheckOperator {
  And = 'AND',
  Or = 'OR'
}

export enum ReferenceNumberFormatCheckType {
  Length = 'LENGTH',
  StartsWith = 'STARTS_WITH'
}

export type ReferenceNumberFormatConfigEntity = {
  __typename?: 'ReferenceNumberFormatConfigEntity';
  checks: Array<ReferenceNumberFormatCheckEntity>;
  createdAt: Scalars['DateTime']['output'];
  updatedAt: Scalars['DateTime']['output'];
  uuid: Scalars['String']['output'];
};

export type ReferenceNumberLabelEntity = {
  __typename?: 'ReferenceNumberLabelEntity';
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type RefuseOrderInput = {
  refusedBy: Scalars['String']['input'];
  refusedDate: Scalars['DateTime']['input'];
  uuid: Scalars['String']['input'];
};

export type RegisterInput = {
  companyUuid: Scalars['String']['input'];
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
};

export type RegisterOutput = {
  __typename?: 'RegisterOutput';
  status: RegisterStatus;
};

export enum RegisterStatus {
  EmailTaken = 'EMAIL_TAKEN',
  Success = 'SUCCESS',
  UnknownError = 'UNKNOWN_ERROR'
}

export type RejectCustomerPortalOrderInput = {
  orderUuid: Scalars['String']['input'];
  rejectionReason?: InputMaybe<Scalars['String']['input']>;
};

export type RejectCustomerPortalOrderOutput = MutationErrorOutput | RejectCustomerPortalOrderSuccessOutput;

export type RejectCustomerPortalOrderSuccessOutput = {
  __typename?: 'RejectCustomerPortalOrderSuccessOutput';
  orderUuid: Scalars['String']['output'];
  rejectedAt: Scalars['DateTime']['output'];
};

export type RejectEdiOrderInput = {
  uuid: Scalars['String']['input'];
};

export type RejectEdiOrderOutput = {
  __typename?: 'RejectEdiOrderOutput';
  uuid: Scalars['String']['output'];
};

export type RemoveApiUserContactMappingInput = {
  apiUserUuid: Scalars['String']['input'];
  contactUuid: Scalars['String']['input'];
};

export type RemoveContactsInput = {
  deleteOrders: Scalars['Boolean']['input'];
  uuids: Array<Scalars['String']['input']>;
};

export type RemoveContactsOutput = {
  __typename?: 'RemoveContactsOutput';
  uuids: Array<Scalars['String']['output']>;
};

export type RemoveDriversFromRouteInput = {
  driverUuids: Array<Scalars['String']['input']>;
  routeUuid: Scalars['String']['input'];
};

export type RemoveLineItemsFromSettlementBillInput = {
  /** The IDs of the settlement bill line items to disconnect from the driver settlement bill. Will validate that these are all on the provided bill. */
  settlementBillLineItemIds: Array<Scalars['String']['input']>;
  /** The UUID of the driver settlement bill to remove line items from */
  settlementBillUuid: Scalars['String']['input'];
};

export type RemoveLineItemsFromSettlementBillOutput = MutationErrorOutput | RemoveLineItemsFromSettlementBillSuccessOutput;

export type RemoveLineItemsFromSettlementBillSuccessOutput = {
  __typename?: 'RemoveLineItemsFromSettlementBillSuccessOutput';
  settlementBillLineItemsCount: Scalars['Float']['output'];
};

export type RemoveOrderHoldInput = {
  sentFromMobileApplication?: InputMaybe<Scalars['Boolean']['input']>;
  uuid: Scalars['String']['input'];
};

export type RemoveOrdersFromManifestInput = {
  orderUuids?: InputMaybe<Array<Scalars['String']['input']>>;
  uuid: Scalars['String']['input'];
};

export type RemoveOrdersFromManifestV2Input = {
  manifestUuid: Scalars['String']['input'];
  orderUuids: Array<Scalars['String']['input']>;
};

export type RemoveOrdersFromManifestV2Output = MutationErrorOutput | RemoveOrdersFromManifestV2SuccessOutput;

/** The output of removing orders from a line haul manifest successfully */
export type RemoveOrdersFromManifestV2SuccessOutput = {
  __typename?: 'RemoveOrdersFromManifestV2SuccessOutput';
  /** The updated line haul manifest */
  lineHaulManifest: LineHaulManifestEntity;
};

export type RemoveServiceFromContactInput = {
  contactUuid: Scalars['String']['input'];
  serviceUuid: Scalars['String']['input'];
};

export type RemoveShipmentsFromInvoiceInput = {
  uuids: Array<Scalars['String']['input']>;
};

export type RemoveStopsFromRoutesInputType = {
  uuids: Array<Scalars['String']['input']>;
};

export type RemoveStorageUnitOnHandInput = {
  uuid: Scalars['String']['input'];
};

export type RemoveStorageUnitOnHandOutput = {
  __typename?: 'RemoveStorageUnitOnHandOutput';
  success: Scalars['Boolean']['output'];
};

export type RemoveStorageUnitOsdInput = {
  uuid: Scalars['String']['input'];
};

export type RemoveStorageUnitOsdOutput = {
  __typename?: 'RemoveStorageUnitOsdOutput';
  success: Scalars['Boolean']['output'];
};

export type RemoveSubscriberInput = {
  shipmentUuid: Scalars['String']['input'];
  subscriberUuid: Scalars['String']['input'];
};

export type RemoveTagFromLegInput = {
  legUuid: Scalars['String']['input'];
  tagUuid: Scalars['String']['input'];
};

export type RemoveTagFromOrderInput = {
  orderUuid: Scalars['String']['input'];
  tagUuid: Scalars['String']['input'];
};

export type RemoveThirdPartyUserFromContactInput = {
  contactUuid: Scalars['String']['input'];
  userUuid: Scalars['String']['input'];
};

export type RemoveUserFromRoleInput = {
  userUuid: Scalars['String']['input'];
  /** The UUID of the role to remove the user from */
  uuid: Scalars['String']['input'];
};

export type RemoveUserFromRoleOutput = {
  __typename?: 'RemoveUserFromRoleOutput';
  success: Scalars['Boolean']['output'];
};

export type RenderDeployEntity = {
  __typename?: 'RenderDeployEntity';
  commitHash: Scalars['String']['output'];
  commitMessage: Scalars['String']['output'];
  finishedAt?: Maybe<Scalars['Float']['output']>;
};

export type RenderServiceWithDeploysEntity = {
  __typename?: 'RenderServiceWithDeploysEntity';
  branch: Scalars['String']['output'];
  deploys: Array<RenderDeployEntity>;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  updatedAt: Scalars['Float']['output'];
};

export enum RepeatFrequencyUnit {
  Month = 'MONTH',
  Week = 'WEEK'
}

export type ReplayOutboundEdiInput = {
  orderUuids?: InputMaybe<Array<Scalars['String']['input']>>;
  referenceNumbers?: InputMaybe<Array<Scalars['String']['input']>>;
  replay214s?: InputMaybe<Scalars['Boolean']['input']>;
  replay990s?: InputMaybe<Scalars['Boolean']['input']>;
  replayPods?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ReportADocScanIssueInput = {
  message: Scalars['String']['input'];
  orderStateJsonBlob?: InputMaybe<Scalars['String']['input']>;
  scannedOrderResultUuid: Scalars['String']['input'];
};

export type ReportADocScanIssueOutput = {
  __typename?: 'ReportADocScanIssueOutput';
  success: Scalars['Boolean']['output'];
};

export enum ReportAggregationPeriod {
  Day = 'DAY',
  Month = 'MONTH',
  Week = 'WEEK',
  Year = 'YEAR'
}

/**
 * The standard output type for a report file (generally PDF or CSV)
 *   which has been generated on the backend and uploaded to S3. This type can be
 *   returned directly from reports or extended to add
 *   additional report-specific fields.
 */
export type ReportFileOutput = {
  __typename?: 'ReportFileOutput';
  errors?: Maybe<Array<Scalars['String']['output']>>;
  fileName?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export enum ReportFilterType {
  ContactUuidFilter = 'CONTACT_UUID_FILTER',
  InvoiceDateFilter = 'INVOICE_DATE_FILTER',
  InvoiceIsClosedFilter = 'INVOICE_IS_CLOSED_FILTER',
  InvoiceSourcesFilter = 'INVOICE_SOURCES_FILTER'
}

/** An input object that represents a superset of all possible filters that can be used for report generation */
export type ReportFiltersInput = {
  /** When present, filters the report by billing party UUID. Otherwise, no filtering of billing party contact occurs. */
  billingPartyContactUuids?: InputMaybe<Array<Scalars['String']['input']>>;
  /** A date range filter that is used for the 'date' field on the invoice */
  invoiceDateFilter?: InputMaybe<DateFilterStartEnd>;
  /** A date range filter that is used for the 'dueDate' field on the invoice */
  invoiceDueDateFilter?: InputMaybe<DateFilterStartEnd>;
  /** A boolean filter that is used for the 'isClosed' field on the invoice */
  invoiceIsClosedFilter?: InputMaybe<BooleanFilter>;
  /** An enum list filter that is used for the 'source' field on the invoice */
  invoiceSourcesFilter?: InputMaybe<Array<InvoiceSource>>;
};

export enum ReportGenerationStatus {
  Available = 'AVAILABLE',
  Failed = 'FAILED',
  Generating = 'GENERATING',
  NotStarted = 'NOT_STARTED',
  Uploading = 'UPLOADING'
}

export type ReportGroupConfigurationCreateInput = {
  businessDivisionUuid?: InputMaybe<Scalars['String']['input']>;
  contactUuid?: InputMaybe<Scalars['String']['input']>;
  contactUuids?: InputMaybe<Array<Scalars['String']['input']>>;
  defaultReportType: ReportType;
  driverUuid?: InputMaybe<Scalars['String']['input']>;
  driverUuids?: InputMaybe<Array<Scalars['String']['input']>>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  lastNumberOfDays?: InputMaybe<Scalars['Int']['input']>;
  lastNumberOfMonths?: InputMaybe<Scalars['Int']['input']>;
  lastNumberOfWeeks?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
  orderStatuses: Array<OrderStatus>;
  reportAggregationPeriod: ReportAggregationPeriod;
  reportRevenueType: ReportRevenueType;
  reportStatistics: Array<ReportStatistic>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  stopTypes: Array<PickupOrDelivery>;
  terminalUuid?: InputMaybe<Scalars['String']['input']>;
};

export type ReportGroupConfigurationEntity = {
  __typename?: 'ReportGroupConfigurationEntity';
  businessDivision?: Maybe<BusinessDivisionEntity>;
  contact?: Maybe<ContactEntity>;
  contacts?: Maybe<Array<ContactEntity>>;
  createdAt: Scalars['DateTime']['output'];
  defaultReportType: ReportType;
  driver?: Maybe<DriverEntity>;
  drivers?: Maybe<Array<DriverEntity>>;
  endDate?: Maybe<Scalars['DateTime']['output']>;
  lastNumberOfDays?: Maybe<Scalars['Int']['output']>;
  lastNumberOfMonths?: Maybe<Scalars['Int']['output']>;
  lastNumberOfWeeks?: Maybe<Scalars['Int']['output']>;
  name: Scalars['String']['output'];
  orderStatuses: Array<OrderStatus>;
  reportAggregationPeriod: ReportAggregationPeriod;
  reportRevenueType: ReportRevenueType;
  reportStatistics: Array<ReportStatistic>;
  startDate?: Maybe<Scalars['DateTime']['output']>;
  stopTypes: Array<PickupOrDelivery>;
  terminal?: Maybe<TerminalEntity>;
  updatedAt: Scalars['DateTime']['output'];
  uuid: Scalars['String']['output'];
};

export type ReportGroupConfigurationUpdateInput = {
  businessDivisionUuid?: InputMaybe<Scalars['String']['input']>;
  contactUuid?: InputMaybe<Scalars['String']['input']>;
  contactUuids?: InputMaybe<Array<Scalars['String']['input']>>;
  defaultReportType?: InputMaybe<ReportType>;
  driverUuid?: InputMaybe<Scalars['String']['input']>;
  driverUuids?: InputMaybe<Array<Scalars['String']['input']>>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  lastNumberOfDays?: InputMaybe<Scalars['Int']['input']>;
  lastNumberOfMonths?: InputMaybe<Scalars['Int']['input']>;
  lastNumberOfWeeks?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  orderStatuses?: InputMaybe<Array<OrderStatus>>;
  reportAggregationPeriod?: InputMaybe<ReportAggregationPeriod>;
  reportRevenueType?: InputMaybe<ReportRevenueType>;
  reportStatistics?: InputMaybe<Array<ReportStatistic>>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  stopTypes?: InputMaybe<Array<PickupOrDelivery>>;
  terminalUuid?: InputMaybe<Scalars['String']['input']>;
  uuid: Scalars['String']['input'];
};

export type ReportPdfOutput = {
  __typename?: 'ReportPdfOutput';
  errors?: Maybe<Array<Scalars['String']['output']>>;
  fileName?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export enum ReportRevenueType {
  Earned = 'EARNED',
  Projected = 'PROJECTED'
}

export type ReportSendJobBatchConnection = {
  __typename?: 'ReportSendJobBatchConnection';
  edges: Array<ReportSendJobBatchEdge>;
  pageInfo: PageInfo;
  /** Not cheap to calculate, request with prudence */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type ReportSendJobBatchEdge = {
  __typename?: 'ReportSendJobBatchEdge';
  cursor: Scalars['String']['output'];
  node: ReportSendJobBatchEntity;
};

export type ReportSendJobBatchEntity = {
  __typename?: 'ReportSendJobBatchEntity';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['String']['output'];
  reportSendJobBatchProgress: ReportSendJobBatchProgressEntity;
  reportSendJobs: Array<ReportSendJobEntity>;
  updatedAt: Scalars['DateTime']['output'];
};

export type ReportSendJobBatchProgressEntity = {
  __typename?: 'ReportSendJobBatchProgressEntity';
  failCount: Scalars['Int']['output'];
  successCount: Scalars['Int']['output'];
  totalCount: Scalars['Int']['output'];
};

export type ReportSendJobConnection = {
  __typename?: 'ReportSendJobConnection';
  edges: Array<ReportSendJobEdge>;
  pageInfo: PageInfo;
  /** Not cheap to calculate, request with prudence */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type ReportSendJobEdge = {
  __typename?: 'ReportSendJobEdge';
  cursor: Scalars['String']['output'];
  node: ReportSendJobEntity;
};

export type ReportSendJobEntity = {
  __typename?: 'ReportSendJobEntity';
  contact: ContactEntity;
  createdAt: Scalars['DateTime']['output'];
  document?: Maybe<DocumentEntity>;
  emailTransaction?: Maybe<EmailTransactionEntity>;
  id: Scalars['String']['output'];
  reportSendJobBatch: ReportSendJobBatchEntity;
  reportSendJobBatchId: Scalars['String']['output'];
  reportSendJobError?: Maybe<ReportSendJobError>;
  reportType: AccountingReportTypeV2;
  updatedAt: Scalars['DateTime']['output'];
};

export enum ReportSendJobError {
  DocumentGenerationFailed = 'DOCUMENT_GENERATION_FAILED'
}

export enum ReportSendJobStatus {
  Failed = 'FAILED',
  InProgress = 'IN_PROGRESS',
  Success = 'SUCCESS'
}

export enum ReportStatistic {
  CustomChargeRevenue = 'CUSTOM_CHARGE_REVENUE',
  DeliveryRevenue = 'DELIVERY_REVENUE',
  FreightRevenue = 'FREIGHT_REVENUE',
  FuelRevenue = 'FUEL_REVENUE',
  NumberOfOrders = 'NUMBER_OF_ORDERS',
  NumberOfPackages = 'NUMBER_OF_PACKAGES',
  PickupRevenue = 'PICKUP_REVENUE',
  RecoveryRevenue = 'RECOVERY_REVENUE',
  TotalRevenue = 'TOTAL_REVENUE',
  TotalWeight = 'TOTAL_WEIGHT',
  TransferRevenue = 'TRANSFER_REVENUE'
}

export enum ReportType {
  Customer = 'CUSTOMER',
  Driver = 'DRIVER',
  Order = 'ORDER',
  ServiceLevel = 'SERVICE_LEVEL',
  Station = 'STATION',
  Terminal = 'TERMINAL'
}

export type ResetCompanyInput = {
  companyUuid: Scalars['String']['input'];
  token: Scalars['String']['input'];
};

export type ResetCompanyOutput = {
  __typename?: 'ResetCompanyOutput';
  status: Scalars['String']['output'];
};

/** This is the graphql input for restoring an organization */
export type RestoreOrganizationInput = {
  uuid: Scalars['String']['input'];
};

export type RestoreOrganizationOutput = MutationErrorOutput | RestoreOrganizationSuccessOutput;

export type RestoreOrganizationSuccessOutput = {
  __typename?: 'RestoreOrganizationSuccessOutput';
  /** The restored org */
  organization: OrganizationEntity;
};

export type RestoreTariffChainInput = {
  id: Scalars['String']['input'];
};

export type RestoreTariffChainOutput = MutationErrorOutput | RestoreTariffChainSuccessOutput;

export type RestoreTariffChainSuccessOutput = {
  __typename?: 'RestoreTariffChainSuccessOutput';
  /** The tariff chain that was restored */
  tariffChain: TariffChainEntity;
};

export type RetrySftpUploadsInput = {
  sftpUploadUuid: Scalars['String']['input'];
};

export type RetrySftpUploadsOutput = {
  __typename?: 'RetrySftpUploadsOutput';
  sftpUpload?: Maybe<SftpUploadEntity>;
};

export type ReuploadPodsInput = {
  contactUuids: Array<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  startDate: Scalars['DateTime']['input'];
};

export type RevenueReportOrderConnection = {
  __typename?: 'RevenueReportOrderConnection';
  edges: Array<RevenueReportOrderEdge>;
  pageInfo: PageInfo;
};

export type RevenueReportOrderEdge = {
  __typename?: 'RevenueReportOrderEdge';
  cursor: Scalars['String']['output'];
  node: RevenueReportOrderEntity;
};

export type RevenueReportOrderEntity = {
  __typename?: 'RevenueReportOrderEntity';
  contactName: Scalars['String']['output'];
  contactReferenceNumber?: Maybe<Scalars['String']['output']>;
  contactUuid: Scalars['String']['output'];
  controllingTerminalCode?: Maybe<Scalars['String']['output']>;
  detailedStatusV2?: Maybe<OrderDetailedStatus>;
  inboundAddressString?: Maybe<Scalars['String']['output']>;
  inboundStopType?: Maybe<OriginStopType>;
  masterAirwayBillOfLadingNumber?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  outboundAddressString?: Maybe<Scalars['String']['output']>;
  outboundStopType?: Maybe<DestinationStopType>;
  packageQuantity: Scalars['Float']['output'];
  packageWeight: Scalars['Float']['output'];
  podUploaded: Scalars['Boolean']['output'];
  /** Single service date for the order from the order's endStop */
  serviceDates: Array<Scalars['DateTime']['output']>;
  shipperBillOfLadingNumber?: Maybe<Scalars['String']['output']>;
  stopTypes: Array<StopType>;
  totalCharge: Scalars['Float']['output'];
  uuid: Scalars['String']['output'];
};

export type RoleEntity = {
  __typename?: 'RoleEntity';
  isInternalRole: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  permissions: Array<PermissionEntity>;
  users: Array<UserEntity>;
  uuid: Scalars['String']['output'];
};

export type RotateDocumentInput = {
  degrees: Scalars['Float']['input'];
  documentName: Scalars['String']['input'];
  textractType: TextractType;
};

export type RouteConnection = {
  __typename?: 'RouteConnection';
  edges: Array<RouteEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
  versionId?: Maybe<Scalars['String']['output']>;
};

export type RouteCoordinatesEntity = {
  __typename?: 'RouteCoordinatesEntity';
  latitude: Scalars['Float']['output'];
  longitude: Scalars['Float']['output'];
  routeUuid: Scalars['String']['output'];
};

export type RouteCreateInput = {
  date: Scalars['DateTime']['input'];
  defaultStartTime?: InputMaybe<Scalars['DateTime']['input']>;
  driverUuid?: InputMaybe<Scalars['String']['input']>;
  equipmentUuid?: InputMaybe<Scalars['String']['input']>;
  loadTimeInMinutes?: InputMaybe<Scalars['Float']['input']>;
  stopUuids?: InputMaybe<Array<Scalars['String']['input']>>;
  tagUuids?: InputMaybe<Array<Scalars['String']['input']>>;
  terminalUuid?: InputMaybe<Scalars['String']['input']>;
  unloadTimeInMinutes?: InputMaybe<Scalars['Float']['input']>;
};

export type RouteDriverCreateInput = {
  driverUuid: Scalars['String']['input'];
  routeUuid: Scalars['String']['input'];
};

export type RouteDriverEntity = {
  __typename?: 'RouteDriverEntity';
  uuid: Scalars['String']['output'];
};

export type RouteEdge = {
  __typename?: 'RouteEdge';
  cursor: Scalars['String']['output'];
  node: RouteEntity;
};

export type RouteEntity = {
  __typename?: 'RouteEntity';
  company: CompanyEntity;
  createdAt: Scalars['DateTime']['output'];
  currentDriverMobilePhoneLocation?: Maybe<RouteCoordinatesEntity>;
  date: Scalars['DateTime']['output'];
  defaultStartTime?: Maybe<Scalars['DateTime']['output']>;
  driver?: Maybe<DriverEntity>;
  /** @deprecated Use driver instead. There can never be more than one driver per route */
  drivers: Array<DriverEntity>;
  endLoadTimeInMinutes?: Maybe<Scalars['Float']['output']>;
  equipments: Array<EquipmentEntity>;
  etas: Array<EtaEntity>;
  /** Return stops on this route grouped by address name. Slightly expensive to calculate, use with care */
  groupedStopUuids: Array<Array<Scalars['String']['output']>>;
  helpers: Array<DriverEntity>;
  lastDispatched?: Maybe<Scalars['DateTime']['output']>;
  locked: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  nameManuallyChanged: Scalars['Boolean']['output'];
  nextRouteSlot?: Maybe<RouteSlotEntity>;
  numberOfRescheduled?: Maybe<Scalars['Float']['output']>;
  routeInfo: RouteInfo;
  routePath?: Maybe<RoutePathEntity>;
  routeSlotsUpdatedAt?: Maybe<Scalars['DateTime']['output']>;
  slots: Array<RouteSlotEntity>;
  startLoadTimeInMinutes?: Maybe<Scalars['Float']['output']>;
  startTime?: Maybe<Scalars['DateTime']['output']>;
  tags: Array<TagEntity>;
  terminal?: Maybe<TerminalEntity>;
  totalDistanceInMeters?: Maybe<Scalars['Float']['output']>;
  totalTimeInSeconds?: Maybe<Scalars['Float']['output']>;
  uuid: Scalars['String']['output'];
};

export type RouteGenerationPreviewEntity = {
  __typename?: 'RouteGenerationPreviewEntity';
  driver: DriverEntity;
  equipment?: Maybe<EquipmentEntity>;
  stops: Array<StopPreviewForRouteGenerationEntity>;
};

export type RouteInfo = {
  __typename?: 'RouteInfo';
  pieceCount: Scalars['Float']['output'];
  status: RouteStatus;
  totalStops: Scalars['Float']['output'];
  totalStopsArrived: Scalars['Float']['output'];
  totalStopsCancelled: Scalars['Float']['output'];
  totalStopsCompleted: Scalars['Float']['output'];
  totalStopsConfirmedByAgent: Scalars['Float']['output'];
  totalStopsFailed: Scalars['Float']['output'];
  totalStopsNotArrived: Scalars['Float']['output'];
  totalStopsSentToAgent: Scalars['Float']['output'];
  totalWeight: Scalars['Float']['output'];
};

export type RouteNameCreateInput = {
  name: Scalars['String']['input'];
  routeNameLocationCreateInputs: Array<RouteNameLocationCreateInput>;
};

export type RouteNameEntity = {
  __typename?: 'RouteNameEntity';
  createdAt: Scalars['DateTime']['output'];
  name: Scalars['String']['output'];
  routeNameLocations: Array<RouteNameLocationEntity>;
  uuid: Scalars['String']['output'];
};

export type RouteNameLocationCreateInput = {
  city: Scalars['String']['input'];
  zipcode: Scalars['String']['input'];
};

export type RouteNameLocationEntity = {
  __typename?: 'RouteNameLocationEntity';
  city: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  uuid: Scalars['String']['output'];
  zipcode: Scalars['String']['output'];
};

export type RouteNameLocationUpdateInput = {
  city?: InputMaybe<Scalars['String']['input']>;
  uuid: Scalars['String']['input'];
  zipcode?: InputMaybe<Scalars['String']['input']>;
};

export type RouteOptimizationCreateInput = {
  mapboxId: Scalars['String']['input'];
  pinnedSlotUuid?: InputMaybe<Scalars['String']['input']>;
  routeUuid: Scalars['String']['input'];
};

export type RouteOptimizationEntity = {
  __typename?: 'RouteOptimizationEntity';
  createdAt: Scalars['DateTime']['output'];
  mapboxId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  uuid: Scalars['String']['output'];
};

export type RouteOptimizationUpdateInput = {
  mapboxId?: InputMaybe<Scalars['String']['input']>;
  pinnedSlotUuid?: InputMaybe<Scalars['String']['input']>;
  routeUuid?: InputMaybe<Scalars['String']['input']>;
};

export type RoutePathEntity = {
  __typename?: 'RoutePathEntity';
  coordinates?: Maybe<Array<Array<Scalars['Float']['output']>>>;
  inputCoordinates?: Maybe<Array<Array<Scalars['Float']['output']>>>;
  route: RouteEntity;
  uuid: Scalars['String']['output'];
};

export type RoutePathsCreateInput = {
  routeUuids: Array<Scalars['String']['input']>;
};

export type RouteSlotArrayUpdateInput = {
  /** Pass this field in to create a new array item */
  routeSlotCreateInput?: InputMaybe<RouteSlotCreateInput>;
  /** Pass this field in to update an array item */
  routeSlotUpdateInput?: InputMaybe<RouteSlotUpdateInput>;
};

export type RouteSlotCreateInput = {
  /** The uuids of the stops to add to create route slots from. No relation to anything drayage */
  drayageStopUuids: Array<Scalars['String']['input']>;
  emitMultiplayerEvent?: InputMaybe<Scalars['Boolean']['input']>;
  groupBy?: InputMaybe<GroupByStopsInput>;
  placeUuids?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type RouteSlotEntity = {
  __typename?: 'RouteSlotEntity';
  ordinal: Scalars['Int']['output'];
  places: Array<PlaceEntity>;
  previousSlotDistanceMeters?: Maybe<Scalars['Float']['output']>;
  previousSlotDurationSeconds?: Maybe<Scalars['Float']['output']>;
  route?: Maybe<RouteEntity>;
  stops: Array<StopEntity>;
  uuid: Scalars['String']['output'];
};

export type RouteSlotReassignInput = {
  endIndex?: InputMaybe<Scalars['Float']['input']>;
  routeUuid: Scalars['String']['input'];
  slotUuid: Scalars['String']['input'];
};

export type RouteSlotUpdateInput = {
  drayageStopUuids?: InputMaybe<Array<Scalars['String']['input']>>;
  placeUuids?: InputMaybe<Array<Scalars['String']['input']>>;
  uuid: Scalars['String']['input'];
};

export type RouteSort = {
  sortBy: RouteSortBy;
  sortDirection: SortDirection;
};

export enum RouteSortBy {
  CreatedTime = 'CREATED_TIME',
  Driver = 'DRIVER',
  Name = 'NAME',
  NumberStopsComplete = 'NUMBER_STOPS_COMPLETE',
  NumberStopsIncomplete = 'NUMBER_STOPS_INCOMPLETE',
  RouteDate = 'ROUTE_DATE',
  Status = 'STATUS'
}

export enum RouteStatus {
  AwaitingAgentConfirmation = 'AWAITING_AGENT_CONFIRMATION',
  AwaitingSendToAgent = 'AWAITING_SEND_TO_AGENT',
  Complete = 'COMPLETE',
  Incomplete = 'INCOMPLETE',
  InProgress = 'IN_PROGRESS',
  NotStarted = 'NOT_STARTED'
}

export type RouteUpdateInput = {
  date?: InputMaybe<Scalars['DateTime']['input']>;
  defaultStartTime?: InputMaybe<Scalars['DateTime']['input']>;
  endLoadTimeInMinutes?: InputMaybe<Scalars['Float']['input']>;
  equipmentUuids?: InputMaybe<Array<Scalars['String']['input']>>;
  lastDispatched?: InputMaybe<Scalars['DateTime']['input']>;
  locked?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  nameManuallyChanged?: InputMaybe<Scalars['Boolean']['input']>;
  numberOfRescheduled?: InputMaybe<Scalars['Float']['input']>;
  routeSlotsUpdatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  startLoadTimeInMinutes?: InputMaybe<Scalars['Float']['input']>;
  tagUuids?: InputMaybe<Array<Scalars['String']['input']>>;
  uuid: Scalars['String']['input'];
};

export type RoutesSamsaraVehicleLocationsOutput = {
  __typename?: 'RoutesSamsaraVehicleLocationsOutput';
  routeCoordinates: Array<RouteCoordinatesEntity>;
};

export type RunEntity = {
  __typename?: 'RunEntity';
  createdAt: Scalars['DateTime']['output'];
  driver?: Maybe<DriverEntity>;
  isArchived: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  recurringOrderTemplates: Array<OrderEntity>;
  tags: Array<TagEntity>;
  terminal?: Maybe<TerminalEntity>;
  updatedAt: Scalars['DateTime']['output'];
  uuid: Scalars['String']['output'];
  vehicleType?: Maybe<VehicleTypeEntity>;
};

export type SalesVarianceReportInput = {
  /** List of customer uuids to include in the report. If not provided, all customers will be included. */
  customerUuids?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Order service date filter for the first sales period that is being compared */
  serviceDateFilterPeriod1: DateFilterV2;
  /** Order service date filter for the second sales period that is being compared */
  serviceDateFilterPeriod2: DateFilterV2;
};

export enum SameDayDispatchCellHeader {
  BillOfLadingNumber = 'BILL_OF_LADING_NUMBER',
  ServiceLevel = 'SERVICE_LEVEL'
}

export type SameDayDispatchConfigEntity = {
  __typename?: 'SameDayDispatchConfigEntity';
  createdAt: Scalars['DateTime']['output'];
  deliveryAppointmentTimeThreshold: Scalars['Int']['output'];
  deliveryWithinTimeWindowColorCode: Scalars['String']['output'];
  isNextInRouteColorCode: Scalars['String']['output'];
  isPastDeadlineColorCode: Scalars['String']['output'];
  isSpecialColorCode: Scalars['String']['output'];
  pickupAppointmentTimeThreshold: Scalars['Int']['output'];
  pickupWithinTimeWindowColorCode: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  uuid: Scalars['String']['output'];
};

export type SamsaraDriverEntity = {
  __typename?: 'SamsaraDriverEntity';
  createdAtTime: Scalars['String']['output'];
  driverActivationStatus: Scalars['String']['output'];
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  updatedAtTime: Scalars['String']['output'];
  username: Scalars['String']['output'];
};

export type SamsaraDriversEntity = {
  __typename?: 'SamsaraDriversEntity';
  data: Array<SamsaraDriverEntity>;
  pagination: SamsaraPaginationEntity;
};

export type SamsaraGpsPingEntity = {
  __typename?: 'SamsaraGpsPingEntity';
  latitude: Scalars['Float']['output'];
  longitude: Scalars['Float']['output'];
  time: Scalars['String']['output'];
};

export type SamsaraOauthTokenEntity = {
  __typename?: 'SamsaraOauthTokenEntity';
  accessToken: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  expiresAt: Scalars['DateTime']['output'];
  refreshToken: Scalars['String']['output'];
  scope: Scalars['String']['output'];
  tokenType: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  uuid: Scalars['String']['output'];
};

export type SamsaraPaginationEntity = {
  __typename?: 'SamsaraPaginationEntity';
  endCursor: Scalars['String']['output'];
  hasNextPage: Scalars['Boolean']['output'];
};

export type SamsaraVehicleEntity = {
  __typename?: 'SamsaraVehicleEntity';
  createdAtTime: Scalars['String']['output'];
  id: Scalars['String']['output'];
  make?: Maybe<Scalars['String']['output']>;
  model?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  notes: Scalars['String']['output'];
  updatedAtTime: Scalars['String']['output'];
  vin: Scalars['String']['output'];
  year: Scalars['String']['output'];
};

export type SamsaraVehicleStatsEntity = {
  __typename?: 'SamsaraVehicleStatsEntity';
  gps?: Maybe<Array<SamsaraGpsPingEntity>>;
  /** Vehicle ID */
  id: Scalars['String']['output'];
};

export type SamsaraVehicleStatsFeedEntity = {
  __typename?: 'SamsaraVehicleStatsFeedEntity';
  data: Array<SamsaraVehicleStatsEntity>;
  pagination: SamsaraPaginationEntity;
};

export type SamsaraVehiclesEntity = {
  __typename?: 'SamsaraVehiclesEntity';
  data: Array<SamsaraVehicleEntity>;
  pagination: SamsaraPaginationEntity;
};

export type SavedFilterViewEntity = {
  __typename?: 'SavedFilterViewEntity';
  createdAt: Scalars['DateTime']['output'];
  dispatchTableFields: Array<DispatchTableField>;
  displayName: Scalars['String']['output'];
  filterModelJson: Scalars['String']['output'];
  filterModelJsonV2?: Maybe<Scalars['JSON']['output']>;
  isShared: Scalars['Boolean']['output'];
  orderTableFields: Array<OrderTableField>;
  savedViewPageType: FilterViewPage;
  sortModelJson?: Maybe<Scalars['JSON']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  user: UserEntity;
  uuid: Scalars['String']['output'];
};

export type ScanEntity = {
  __typename?: 'ScanEntity';
  barcode: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  isNewPiece: Scalars['Boolean']['output'];
  order?: Maybe<OrderEntity>;
  orderLineHaulSegmentArrival?: Maybe<OrderLineHaulSegmentEntity>;
  orderLineHaulSegmentDeparture?: Maybe<OrderLineHaulSegmentEntity>;
  orderMarkedOnHandByScan: Scalars['Boolean']['output'];
  orderMarkedReceivedAtOriginByScan: Scalars['Boolean']['output'];
  piece?: Maybe<PieceEntity>;
  /** @deprecated Deprecated in favor of Piece.barcode. Needed for backwards compatibility */
  rawBarcode: Scalars['String']['output'];
  scanType: ScanType;
  scannedAt: Scalars['DateTime']['output'];
  updatedAt: Scalars['DateTime']['output'];
  uuid: Scalars['String']['output'];
};

export type ScanOrderBarcodeInput = {
  barcode: Scalars['String']['input'];
  manifestUuid?: InputMaybe<Scalars['String']['input']>;
  scanType?: InputMaybe<ScanType>;
  stopUuid?: InputMaybe<Scalars['String']['input']>;
  terminalUuid?: InputMaybe<Scalars['String']['input']>;
};

export type ScanOrderBarcodeOrderResultEntity = {
  __typename?: 'ScanOrderBarcodeOrderResultEntity';
  order: OrderEntity;
  /** Whether the piece was parsed from a serialized barcode. This will always be true if piece is not null, but may also be true if a recognized serialzed barcode format was scanned */
  parsedFromSerializedBarcode: Scalars['Boolean']['output'];
  piece?: Maybe<PieceEntity>;
  /**
   * The unique piece ID associated with this scanned order
   * @deprecated Use parsedFromSerializedBarcode instead to determine if piece was parsed from a serialized barcode because some piece-specific barcodes may not have a distinct pieceName
   */
  pieceName?: Maybe<Scalars['String']['output']>;
};

export type ScanOrderBarcodeOutput = {
  __typename?: 'ScanOrderBarcodeOutput';
  /** The orders and associated info found by the barcode scan. If one result is found, scan logic will be performed on the order. If multiple results are found, the results will be returned. If no results are found, an unassigned scan will be logged. */
  orderResults: Array<ScanOrderBarcodeOrderResultEntity>;
  /**
   * The orders matching a barcode scan. If only one match is found, scan logic will be performed on the order.
   * @deprecated Use orderResults instead
   */
  orders: Array<OrderEntity>;
  /**
   * The orders matching a barcode scan and the piece names associated with each result. If only one match is found, scan logic will be performed on the order.
   * @deprecated Use orderResults instead
   */
  ordersWithPieceNames: Array<OrderWithPieceNameEntity>;
  /** The scan event if one or zero orders are found */
  scan?: Maybe<ScanEntity>;
  /** The result of the barcode scan */
  scanBarcodeResultType?: Maybe<ScanOrderBarcodeResultType>;
};

export enum ScanOrderBarcodeResultType {
  Error = 'ERROR',
  MoreThanOneValidOrder = 'MORE_THAN_ONE_VALID_ORDER',
  NotOnManifest = 'NOT_ON_MANIFEST',
  NotOnStop = 'NOT_ON_STOP',
  PieceAlreadyScanned = 'PIECE_ALREADY_SCANNED',
  Success = 'SUCCESS'
}

export type ScanOrderInput = {
  barcode: Scalars['String']['input'];
  /** Indicates if the barcode is a serialized barcode. This should be true if pieceUuid is provided, or if the barcode is unique to a piece */
  isSerializedBarcode?: InputMaybe<Scalars['Boolean']['input']>;
  markOnHand?: InputMaybe<Scalars['Boolean']['input']>;
  orderUuid: Scalars['String']['input'];
  pieceName?: InputMaybe<Scalars['String']['input']>;
  /** The UUID of a scanned piece if we already know what it is */
  pieceUuid?: InputMaybe<Scalars['String']['input']>;
  rawBarcode?: InputMaybe<Scalars['String']['input']>;
  scanType?: InputMaybe<ScanType>;
  /** The UUID of the stop the driver is currently at */
  stopUuid?: InputMaybe<Scalars['String']['input']>;
  terminalUuid?: InputMaybe<Scalars['String']['input']>;
};

export type ScanPieceInput = {
  markOnHand?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  orderUuid: Scalars['String']['input'];
};

export enum ScanType {
  Arrival = 'ARRIVAL',
  Delivery = 'DELIVERY',
  Departure = 'DEPARTURE'
}

export type ScanWarehouseLocationInput = {
  barcode?: InputMaybe<Scalars['String']['input']>;
  orderUuid?: InputMaybe<Scalars['String']['input']>;
  pieceUuid?: InputMaybe<Scalars['String']['input']>;
};

export type ScanWarehouseLocationOutput = {
  __typename?: 'ScanWarehouseLocationOutput';
  errors?: Maybe<Array<Scalars['String']['output']>>;
  order?: Maybe<OrderEntity>;
  package?: Maybe<PackageEntity>;
  piece?: Maybe<PieceEntity>;
  warehouseLocation?: Maybe<WarehouseLocationEntity>;
};

export enum ScannedDocumentType {
  DeliveryAlert = 'DELIVERY_ALERT',
  DeliveryReceipt = 'DELIVERY_RECEIPT',
  None = 'NONE',
  PickupAlert = 'PICKUP_ALERT'
}

export type ScannedOrderConnection = {
  __typename?: 'ScannedOrderConnection';
  edges: Array<ScannedOrderEdge>;
  pageInfo: PageInfo;
};

export type ScannedOrderCreateInput = {
  bucket: Scalars['String']['input'];
  filename: Scalars['String']['input'];
  filetype: Scalars['String']['input'];
  key: Scalars['String']['input'];
  signedPodMatchStatus?: InputMaybe<SignedPodMatchStatus>;
};

export type ScannedOrderEdge = {
  __typename?: 'ScannedOrderEdge';
  cursor: Scalars['String']['output'];
  node: ScannedOrderEntity;
};

export type ScannedOrderEntity = {
  __typename?: 'ScannedOrderEntity';
  bucket: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  failureReason?: Maybe<ScannedOrderFailureReason>;
  filename: Scalars['String']['output'];
  ingestedOutlookEmailDetails: IngestedEmailDetailsEntity;
  key: Scalars['String']['output'];
  preSignedGetUrl: Scalars['String']['output'];
  retryCount: Scalars['Int']['output'];
  s3Url: Scalars['String']['output'];
  scannedOrderResults: Array<ScannedOrderResultEntity>;
  source: ScannedOrderSource;
  status: ScannedOrderStatus;
  updatedAt: Scalars['DateTime']['output'];
  uuid: Scalars['String']['output'];
};

export enum ScannedOrderFailureReason {
  InvalidFiletype = 'INVALID_FILETYPE',
  InvalidPageSize = 'INVALID_PAGE_SIZE',
  InvalidPageSizeA0 = 'INVALID_PAGE_SIZE_A0',
  InvalidPageSizeA1 = 'INVALID_PAGE_SIZE_A1',
  InvalidPageSizeA2 = 'INVALID_PAGE_SIZE_A2',
  InvalidPageSizeA3 = 'INVALID_PAGE_SIZE_A3',
  InvalidPageSizeA4 = 'INVALID_PAGE_SIZE_A4',
  InvalidPageSizeA5 = 'INVALID_PAGE_SIZE_A5',
  InvalidPageSizeA6 = 'INVALID_PAGE_SIZE_A6',
  InvalidPageSizeA7 = 'INVALID_PAGE_SIZE_A7',
  InvalidPageSizeA8 = 'INVALID_PAGE_SIZE_A8',
  InvalidPageSizeA9 = 'INVALID_PAGE_SIZE_A9',
  InvalidPageSizeA10 = 'INVALID_PAGE_SIZE_A10',
  InvalidPageSizeB0 = 'INVALID_PAGE_SIZE_B0',
  InvalidPageSizeB1 = 'INVALID_PAGE_SIZE_B1',
  InvalidPageSizeB2 = 'INVALID_PAGE_SIZE_B2',
  InvalidPageSizeB3 = 'INVALID_PAGE_SIZE_B3',
  InvalidPageSizeB4 = 'INVALID_PAGE_SIZE_B4',
  InvalidPageSizeB5 = 'INVALID_PAGE_SIZE_B5',
  InvalidPageSizeB6 = 'INVALID_PAGE_SIZE_B6',
  InvalidPageSizeB7 = 'INVALID_PAGE_SIZE_B7',
  InvalidPageSizeB8 = 'INVALID_PAGE_SIZE_B8',
  InvalidPageSizeB9 = 'INVALID_PAGE_SIZE_B9',
  InvalidPageSizeB10 = 'INVALID_PAGE_SIZE_B10',
  InvalidPageSizeC0 = 'INVALID_PAGE_SIZE_C0',
  InvalidPageSizeC1 = 'INVALID_PAGE_SIZE_C1',
  InvalidPageSizeC2 = 'INVALID_PAGE_SIZE_C2',
  InvalidPageSizeC3 = 'INVALID_PAGE_SIZE_C3',
  InvalidPageSizeC4 = 'INVALID_PAGE_SIZE_C4',
  InvalidPageSizeC5 = 'INVALID_PAGE_SIZE_C5',
  InvalidPageSizeC6 = 'INVALID_PAGE_SIZE_C6',
  InvalidPageSizeC7 = 'INVALID_PAGE_SIZE_C7',
  InvalidPageSizeC8 = 'INVALID_PAGE_SIZE_C8',
  InvalidPageSizeC9 = 'INVALID_PAGE_SIZE_C9',
  InvalidPageSizeC10 = 'INVALID_PAGE_SIZE_C10',
  InvalidPageSizeJuniorLegal = 'INVALID_PAGE_SIZE_JUNIOR_LEGAL',
  InvalidPageSizeLegal = 'INVALID_PAGE_SIZE_LEGAL',
  InvalidPageSizeLetter = 'INVALID_PAGE_SIZE_LETTER',
  InvalidPageSizeTabloid = 'INVALID_PAGE_SIZE_TABLOID',
  LowDocumentQuality = 'LOW_DOCUMENT_QUALITY',
  NoHawbExtracted = 'NO_HAWB_EXTRACTED',
  TooManyPages = 'TOO_MANY_PAGES',
  Unknown = 'UNKNOWN',
  UnrecognizedDocument = 'UNRECOGNIZED_DOCUMENT'
}

export type ScannedOrderFromAdminCreateInput = {
  bucket: Scalars['String']['input'];
  companyUuid: Scalars['String']['input'];
  filename: Scalars['String']['input'];
  filetype: Scalars['String']['input'];
  key: Scalars['String']['input'];
};

export type ScannedOrderFromAdminCreateOutput = {
  __typename?: 'ScannedOrderFromAdminCreateOutput';
  error?: Maybe<Scalars['String']['output']>;
  scannedOrderEntity?: Maybe<ScannedOrderEntity>;
};

export type ScannedOrderResultConnection = {
  __typename?: 'ScannedOrderResultConnection';
  edges: Array<ScannedOrderResultEdge>;
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Float']['output']>;
};

export type ScannedOrderResultCreateInput = {
  contactUuid?: InputMaybe<Scalars['String']['input']>;
  documentCreateInput: DocumentCreateInput;
  extractedFields: Array<ExtractedFieldInput>;
  failureReason?: InputMaybe<ScannedOrderFailureReason>;
  pageEnd: Scalars['Int']['input'];
  pageStart: Scalars['Int']['input'];
  scannedDocumentType: ScannedDocumentType;
  scannedOrderResultPageInputs: Array<ScannedOrderResultPageInput>;
  schemaUuid?: InputMaybe<Scalars['String']['input']>;
  signedPodMatchStatus?: InputMaybe<SignedPodMatchStatus>;
  status: ScannedOrderResultStatus;
};

export type ScannedOrderResultDocumentEntity = {
  __typename?: 'ScannedOrderResultDocumentEntity';
  bucket: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  filename: Scalars['String']['output'];
  key: Scalars['String']['output'];
  preSignedGetUrl: Scalars['String']['output'];
  scannedDocumentType: ScannedDocumentType;
  scannedOrderResultDocumentPages: Array<ScannedOrderResultDocumentPageEntity>;
  updatedAt: Scalars['DateTime']['output'];
  uuid: Scalars['String']['output'];
};

export type ScannedOrderResultDocumentPageEntity = {
  __typename?: 'ScannedOrderResultDocumentPageEntity';
  bucket: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  key: Scalars['String']['output'];
  page: Scalars['Int']['output'];
  preSignedGetUrl: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  uuid: Scalars['String']['output'];
};

export type ScannedOrderResultEdge = {
  __typename?: 'ScannedOrderResultEdge';
  cursor: Scalars['String']['output'];
  node: ScannedOrderResultEntity;
};

export type ScannedOrderResultEntity = {
  __typename?: 'ScannedOrderResultEntity';
  approvedAt?: Maybe<Scalars['DateTime']['output']>;
  company: CompanyEntity;
  createdAt: Scalars['DateTime']['output'];
  dismissed: Scalars['Boolean']['output'];
  duplicateOrder?: Maybe<OrderEntity>;
  duplicateScannedOrderResultOrder?: Maybe<OrderEntity>;
  failureReason?: Maybe<ScannedOrderFailureReason>;
  filename: Scalars['String']['output'];
  /** Return the next youngest scanned order result to review. Scanned order results are processed in descending order by creation date */
  nextScannedOrderResultInReview?: Maybe<ScannedOrderResultEntity>;
  order?: Maybe<OrderEntity>;
  pageEnd: Scalars['Int']['output'];
  pageStart: Scalars['Int']['output'];
  podOrder?: Maybe<OrderEntity>;
  preSignedGetUrl?: Maybe<Scalars['String']['output']>;
  rejectedAt?: Maybe<Scalars['DateTime']['output']>;
  scannedOrder: ScannedOrderEntity;
  scannedOrderResultDocuments: Array<ScannedOrderResultDocumentEntity>;
  scannedOrderResultPages: Array<ScannedOrderResultPageEntity>;
  schemaUuid?: Maybe<Scalars['String']['output']>;
  signedPodMatchStatus?: Maybe<SignedPodMatchStatus>;
  status: ScannedOrderResultStatus;
  type: ScannedOrderResultType;
  updatedAt: Scalars['DateTime']['output'];
  uuid: Scalars['String']['output'];
};

export type ScannedOrderResultPageEntity = {
  __typename?: 'ScannedOrderResultPageEntity';
  bucket: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  key: Scalars['String']['output'];
  page: Scalars['Int']['output'];
  preSignedGetUrl: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  uuid: Scalars['String']['output'];
};

export type ScannedOrderResultPageInput = {
  bucket: Scalars['String']['input'];
  key: Scalars['String']['input'];
  page: Scalars['Int']['input'];
};

export enum ScannedOrderResultSourceFilter {
  All = 'ALL',
  EmailIntegration = 'EMAIL_INTEGRATION',
  UploadedPdf = 'UPLOADED_PDF'
}

export enum ScannedOrderResultStatus {
  Approved = 'APPROVED',
  Attached = 'ATTACHED',
  Duplicate = 'DUPLICATE',
  Failed = 'FAILED',
  InProgress = 'IN_PROGRESS',
  InReview = 'IN_REVIEW',
  ManuallyEntered = 'MANUALLY_ENTERED',
  Rejected = 'REJECTED'
}

export enum ScannedOrderResultType {
  Order = 'ORDER',
  SignedPod = 'SIGNED_POD'
}

export enum ScannedOrderSource {
  EmailIntegration = 'EMAIL_INTEGRATION',
  UploadedDocument = 'UPLOADED_DOCUMENT'
}

export enum ScannedOrderStatus {
  Approved = 'APPROVED',
  Completed = 'COMPLETED',
  Failed = 'FAILED',
  InProgress = 'IN_PROGRESS',
  InReview = 'IN_REVIEW',
  Queued = 'QUEUED',
  Rejected = 'REJECTED'
}

export type ScannedOrderUpdateInput = {
  companyUuid: Scalars['String']['input'];
  /** Included if the entire scanned order request failed */
  failureReason?: InputMaybe<ScannedOrderFailureReason>;
  outlookIntegrationUuid?: InputMaybe<Scalars['String']['input']>;
  outlookMessageId?: InputMaybe<Scalars['String']['input']>;
  scannedOrderResults: Array<ScannedOrderResultCreateInput>;
  source?: InputMaybe<ScannedOrderSource>;
  status: ScannedOrderStatus;
  userUuid?: InputMaybe<Scalars['String']['input']>;
  uuid: Scalars['String']['input'];
};

export type SchedulingRegionEntity = {
  __typename?: 'SchedulingRegionEntity';
  dailyCapacityPieces?: Maybe<Scalars['Int']['output']>;
  dailyCapacityStops?: Maybe<Scalars['Int']['output']>;
  dailyCapacityWeight?: Maybe<Scalars['Mass']['output']>;
  id: Scalars['String']['output'];
  isArchived: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  zones: Array<SchedulingZoneEntity>;
};

export type SchedulingZoneAvailabilityEntity = {
  __typename?: 'SchedulingZoneAvailabilityEntity';
  dayOfWeek: DayOfWeekAll;
  end: PlainTime;
  id: Scalars['String']['output'];
  start: PlainTime;
};

export type SchedulingZoneAvailabilityUpsertInput = {
  dayOfWeek: DayOfWeekAll;
  end: PlainTimeInput;
  id: Scalars['String']['input'];
  start: PlainTimeInput;
};

export type SchedulingZoneEntity = {
  __typename?: 'SchedulingZoneEntity';
  availabilities: Array<SchedulingZoneAvailabilityEntity>;
  id: Scalars['String']['output'];
  isArchived: Scalars['Boolean']['output'];
  locations: Array<SchedulingZoneLocationEntity>;
  name: Scalars['String']['output'];
};

export type SchedulingZoneLocationEntity = {
  __typename?: 'SchedulingZoneLocationEntity';
  city: Scalars['String']['output'];
  id: Scalars['String']['output'];
  zipcode: Scalars['String']['output'];
};

export type SchedulingZoneLocationUpsertInput = {
  city: Scalars['String']['input'];
  id: Scalars['String']['input'];
  zipcode: Scalars['String']['input'];
};

export type SchemaCompanyMappingEntity = {
  __typename?: 'SchemaCompanyMappingEntity';
  companyUuid: Scalars['String']['output'];
  contactUuid: Scalars['String']['output'];
  id: Scalars['String']['output'];
  isActive: Scalars['Boolean']['output'];
  schemaDocuments: Array<SchemaDocumentEntity>;
  terminalUuid?: Maybe<Scalars['String']['output']>;
};

export type SchemaDocumentEntity = {
  __typename?: 'SchemaDocumentEntity';
  bucket: Scalars['String']['output'];
  company?: Maybe<CompanyEntity>;
  companyUuid?: Maybe<Scalars['String']['output']>;
  key: Scalars['String']['output'];
  labelledValues?: Maybe<Scalars['String']['output']>;
  preSignedGetUrl: Scalars['String']['output'];
  uuid: Scalars['String']['output'];
};

export type SchemaDocumentInput = {
  bucket: Scalars['String']['input'];
  key: Scalars['String']['input'];
  labelledValues?: InputMaybe<Scalars['String']['input']>;
};

export type SchemaEntity = {
  __typename?: 'SchemaEntity';
  companyMappingsCount: Scalars['Float']['output'];
  companyUuid?: Maybe<Scalars['String']['output']>;
  contactUuid?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['String']['output'];
  firstTestSchemaDocument?: Maybe<SchemaDocumentEntity>;
  isActive: Scalars['Boolean']['output'];
  isMultiPage: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  originalFilename: Scalars['String']['output'];
  scannedDocumentType: ScannedDocumentType;
  testDocumentCount?: Maybe<Scalars['Float']['output']>;
  textractType: TextractType;
  updatedAt: Scalars['String']['output'];
  uuid: Scalars['String']['output'];
};

export type SchemaFieldEntity = {
  __typename?: 'SchemaFieldEntity';
  bottomEdgeAnchor?: Maybe<EdgeAnchorEntity>;
  concatenateX: Scalars['Boolean']['output'];
  fieldExtractors: Array<FieldExtractorEntity>;
  fieldMatchers: Array<FieldMatcherEntity>;
  height: Scalars['Float']['output'];
  left: Scalars['Float']['output'];
  leftEdgeAnchor?: Maybe<EdgeAnchorEntity>;
  rightEdgeAnchor?: Maybe<EdgeAnchorEntity>;
  top: Scalars['Float']['output'];
  topEdgeAnchor?: Maybe<EdgeAnchorEntity>;
  uuid: Scalars['String']['output'];
  width: Scalars['Float']['output'];
};

export type SchemaFieldInput = {
  bottomEdgeAnchor?: InputMaybe<EdgeAnchorInput>;
  concatenateX: Scalars['Boolean']['input'];
  fieldExtractors: Array<FieldExtractorInput>;
  fieldMatchers: Array<FieldMatcherInput>;
  height: Scalars['Float']['input'];
  left: Scalars['Float']['input'];
  leftEdgeAnchor?: InputMaybe<EdgeAnchorInput>;
  rightEdgeAnchor?: InputMaybe<EdgeAnchorInput>;
  top: Scalars['Float']['input'];
  topEdgeAnchor?: InputMaybe<EdgeAnchorInput>;
  width: Scalars['Float']['input'];
};

export type SchemaFilePutUrlInput = {
  filename: Scalars['String']['input'];
};

export type SchemaInput = {
  fingerprintAnchors: Array<FingerprintAnchorInput>;
  isMultiPage: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
  originalFilename: Scalars['String']['input'];
  packageTables: Array<PackageTableInput>;
  scannedDocumentType: ScannedDocumentType;
  schemaFields: Array<SchemaFieldInput>;
  textractType: TextractType;
  transformAnchors: Array<TransformAnchorInput>;
};

export type SchemaRunEntity = {
  __typename?: 'SchemaRunEntity';
  bucket: Scalars['String']['output'];
  extractedFields: Array<ExtractedFieldEntity>;
  fingerprintAnchorMatches: Array<FingerprintAnchorMatchEntity>;
  key: Scalars['String']['output'];
  schema: SchemaWithAnchorsEntity;
  schemaRunPages: Array<SchemaRunPageEntity>;
  schemaRunTestSnapshot?: Maybe<SchemaRunEntity>;
  schemaRunTestStatus?: Maybe<SchemaRunTestStatus>;
  transformAnchorMatches: Array<TransformAnchorMatchEntity>;
  type: SchemaRunType;
  uuid: Scalars['String']['output'];
};

export type SchemaRunPageEntity = {
  __typename?: 'SchemaRunPageEntity';
  bucket: Scalars['String']['output'];
  extractedFields: Array<ExtractedFieldEntity>;
  fingerprintAnchorMatches: Array<FingerprintAnchorMatchEntity>;
  key: Scalars['String']['output'];
  page: Scalars['Int']['output'];
  transformAnchorMatches: Array<TransformAnchorMatchEntity>;
  uuid: Scalars['String']['output'];
};

export type SchemaRunPageInput = {
  bucket: Scalars['String']['input'];
  extractedFields: Array<ExtractedFieldInput>;
  fingerprintAnchorMatches: Array<FingerprintAnchorMatchInput>;
  key: Scalars['String']['input'];
  page: Scalars['Int']['input'];
  transformAnchorMatches: Array<TransformAnchorMatchInput>;
};

export type SchemaRunTestListEntity = {
  __typename?: 'SchemaRunTestListEntity';
  createdAt: Scalars['DateTime']['output'];
  schemaRunTestStatus: SchemaRunTestStatus;
  schemaRuns: Array<SchemaRunEntity>;
  uuid: Scalars['String']['output'];
};

export type SchemaRunTestListInput = {
  schemaRunTestListUuid: Scalars['String']['input'];
};

export enum SchemaRunTestStatus {
  Error = 'ERROR',
  Failed = 'FAILED',
  InProgress = 'IN_PROGRESS',
  Passed = 'PASSED'
}

export enum SchemaRunType {
  ManualRun = 'MANUAL_RUN',
  TestRun = 'TEST_RUN',
  TestSnapshot = 'TEST_SNAPSHOT'
}

export type SchemaTestFilePutUrlInput = {
  filename: Scalars['String']['input'];
};

export type SchemaWithAnchorsEntity = {
  __typename?: 'SchemaWithAnchorsEntity';
  companyUuid?: Maybe<Scalars['String']['output']>;
  contactUuid?: Maybe<Scalars['String']['output']>;
  fingerprintAnchors: Array<FingerprintAnchorEntity>;
  isActive: Scalars['Boolean']['output'];
  isMultiPage: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  originalFilename: Scalars['String']['output'];
  packageTables: Array<PackageTableEntity>;
  scannedDocumentType: ScannedDocumentType;
  schemaDocuments: Array<SchemaDocumentEntity>;
  schemaFields: Array<SchemaFieldEntity>;
  structuredExtractionSchemaOverride?: Maybe<StructuredExtractionSchemaOverrideEntity>;
  textractType: TextractType;
  transformAnchors: Array<TransformAnchorEntity>;
  uuid: Scalars['String']['output'];
};

export type SecondaryRefNumberSortInput = {
  direction: SortOrder;
  nulls: NullsOrder;
};

export enum Segment {
  Cartage = 'CARTAGE',
  Standard = 'STANDARD'
}

export type SelectSpecialAccessorialInput = {
  accessorialForContactUuid?: InputMaybe<Scalars['String']['input']>;
  /** City of the stop address */
  city?: InputMaybe<Scalars['String']['input']>;
  contactUuid?: InputMaybe<Scalars['String']['input']>;
  /** Country of the stop address */
  country?: InputMaybe<Scalars['String']['input']>;
  /** The end appointment time that is set for the stop */
  endAppointment: Scalars['DateTime']['input'];
  /** Street name/house number of the stop address */
  line1?: InputMaybe<Scalars['String']['input']>;
  /** The distance to be traveled in miles for the stop */
  miles?: InputMaybe<Scalars['Float']['input']>;
  /** The stop's service date */
  serviceDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** The selected service level for the order */
  serviceUuid?: InputMaybe<Scalars['String']['input']>;
  /** The start appointment time that is set for the stop */
  startAppointment: Scalars['DateTime']['input'];
  /** State of the stop address */
  state?: InputMaybe<Scalars['String']['input']>;
  /** The selected terminal for the stop. Is optional for companies without terminals enabled */
  terminalUuid?: InputMaybe<Scalars['String']['input']>;
  /** ZIP of the stop address */
  zip?: InputMaybe<Scalars['String']['input']>;
};

export type SelectSpecialAccessorialOutput = {
  __typename?: 'SelectSpecialAccessorialOutput';
  /** The selected special accessorial UUID based on the provided parameters. The value is null when there is no special accessorial found that matches the provided parameters */
  accessorialUuid?: Maybe<Scalars['String']['output']>;
  /** The selected charge group based on the provided parameters. The value is null when there is no charge group found that matches the provided parameters */
  chargeGroupUuid?: Maybe<Scalars['String']['output']>;
  /** The selected matrix item based on the provided parameters. The value is null when there is no matrix item found that matches the provided parameters */
  matrixItemUuid?: Maybe<Scalars['String']['output']>;
  /** The selected tariff zone based on the provided parameters. The value is null when there is no tariff zone found that matches the provided parameters */
  tariffZoneUuid?: Maybe<Scalars['String']['output']>;
};

export type SendAccountingReportsInput = {
  /** The UUIDs of the contacts to which we email the report. If an empty list is provided, we will email the report to all contacts for the company. For the dunning report, if the user chooses to send to all, we will only send the report to contacts with outstanding invoices */
  contactUuids: Array<Scalars['String']['input']>;
  /** The list of report filters used to generate the accounting report */
  reportFilters: ReportFiltersInput;
  /** The type of accounting report to be generated and emailed */
  reportType: AccountingReportTypeV2;
};

export type SendAccountingReportsOutput = MutationErrorOutput | SendAccountingReportsSuccessOutput;

export type SendAccountingReportsSuccessOutput = {
  __typename?: 'SendAccountingReportsSuccessOutput';
  success: Scalars['Boolean']['output'];
};

export type SendDeliveryCompletedInput = {
  hawbs?: InputMaybe<Array<Scalars['String']['input']>>;
  orderUuids?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type SendInvoicesInput = {
  invoiceDate?: InputMaybe<Scalars['DateTime']['input']>;
  invoiceSendJobBatchType: InvoiceSendJobBatchType;
  invoicesToSend: Array<InvoiceToSend>;
  shouldPrintBackups?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SendMetricInput = {
  metricName: Scalars['String']['input'];
  tags: Array<MetricTagInput>;
  type: MetricType;
  value: Scalars['Int']['input'];
};

export type SendRouteToAgentInput = {
  agentId: Scalars['String']['input'];
  routeUuid: Scalars['String']['input'];
};

export type SendRouteToAgentOutput = MutationErrorOutput | SendRouteToAgentSuccessOutput;

export type SendRouteToAgentSuccessOutput = {
  __typename?: 'SendRouteToAgentSuccessOutput';
  route: RouteEntity;
};

export type SendStopToAgentInput = {
  agentId: Scalars['String']['input'];
  stopUuid: Scalars['String']['input'];
};

export type SendStopToAgentOutput = MutationErrorOutput | SendStopToAgentSuccessOutput;

export type SendStopToAgentSuccessOutput = {
  __typename?: 'SendStopToAgentSuccessOutput';
  stop: StopEntity;
};

export type ServiceAvailabilityDateEntity = {
  __typename?: 'ServiceAvailabilityDateEntity';
  /** @deprecated Use end instead */
  availableEndTime: Scalars['DateTime']['output'];
  /** @deprecated Use start instead */
  availableStartTime: Scalars['DateTime']['output'];
  dayCategory: SpecialDayOfWeek;
  enabled: Scalars['Boolean']['output'];
  end: PlainTime;
  id: Scalars['String']['output'];
  start: PlainTime;
};

export type ServiceCreateInput = {
  defaultAppointmentEndTime?: InputMaybe<Scalars['DateTime']['input']>;
  defaultAppointmentStartTime?: InputMaybe<Scalars['DateTime']['input']>;
  defaultDeliveryPadding?: InputMaybe<Scalars['Duration']['input']>;
  defaultFulfillmentType?: InputMaybe<FulfillmentType>;
  defaultInboundStopType?: InputMaybe<StopType>;
  defaultIsLineHaul?: InputMaybe<Scalars['Boolean']['input']>;
  defaultOutboundStopType?: InputMaybe<StopType>;
  defaultPickupPadding?: InputMaybe<Scalars['Duration']['input']>;
  defaultStartNow?: InputMaybe<Scalars['Boolean']['input']>;
  defaultTotalDuration?: InputMaybe<Scalars['Duration']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isExposedToCustomers?: InputMaybe<Scalars['Boolean']['input']>;
  markOrdersAsSpecial: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
  serviceAvailabilityDates?: InputMaybe<Array<UpsertServiceAvailabilityDateInput>>;
  timeInMinutes?: InputMaybe<Scalars['Int']['input']>;
  useApptInRouteOptimization: Scalars['Boolean']['input'];
};

export type ServiceEntity = {
  __typename?: 'ServiceEntity';
  createdAt: Scalars['DateTime']['output'];
  defaultAppointmentEndTime?: Maybe<Scalars['DateTime']['output']>;
  defaultAppointmentStartTime?: Maybe<Scalars['DateTime']['output']>;
  defaultDeliveryPadding?: Maybe<Scalars['Duration']['output']>;
  defaultFulfillmentType?: Maybe<FulfillmentType>;
  defaultInboundStopType?: Maybe<StopType>;
  defaultIsLineHaul: Scalars['Boolean']['output'];
  defaultOutboundStopType?: Maybe<StopType>;
  defaultPickupPadding?: Maybe<Scalars['Duration']['output']>;
  defaultStartNow: Scalars['Boolean']['output'];
  defaultTotalDuration?: Maybe<Scalars['Duration']['output']>;
  isActive: Scalars['Boolean']['output'];
  isExposedToCustomers: Scalars['Boolean']['output'];
  markOrdersAsSpecial: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  serviceAvailabilityDates: Array<ServiceAvailabilityDateEntity>;
  timeInMinutes?: Maybe<Scalars['Int']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  useApptInRouteOptimization: Scalars['Boolean']['output'];
  uuid: Scalars['String']['output'];
};

export enum ServiceLevel {
  AirDrop = 'AIR_DROP',
  AmazonLockerCore = 'AMAZON_LOCKER_CORE',
  AmazonLockerPremiere = 'AMAZON_LOCKER_PREMIERE',
  Amerigas = 'AMERIGAS',
  AtmInstall = 'ATM_INSTALL',
  AtmSwap = 'ATM_SWAP',
  BasicDelivery = 'BASIC_DELIVERY',
  BasicPickup = 'BASIC_PICKUP',
  Coinstar = 'COINSTAR',
  CostcoTruckManifest = 'COSTCO_TRUCK_MANIFEST',
  Ct = 'CT',
  CustomerPickup = 'CUSTOMER_PICKUP',
  DebrisRemoval = 'DEBRIS_REMOVAL',
  DeliveryExpedited = 'DELIVERY_EXPEDITED',
  DicksDropTrailer = 'DICKS_DROP_TRAILER',
  Dock = 'DOCK',
  Drop = 'DROP',
  DumpRun = 'DUMP_RUN',
  Expedited = 'EXPEDITED',
  ExpeditedPickup = 'EXPEDITED_PICKUP',
  Fn = 'FN',
  FourManDelivery = 'FOUR_MAN_DELIVERY',
  Freeosk = 'FREEOSK',
  Fs = 'FS',
  Ge_2Man = 'GE_2_MAN',
  Ge_3Man = 'GE_3_MAN',
  Ge_4Man = 'GE_4_MAN',
  Ge_5Man = 'GE_5_MAN',
  Hiseq = 'HISEQ',
  HotShot = 'HOT_SHOT',
  Inbound = 'INBOUND',
  Iscan = 'ISCAN',
  Keyme = 'KEYME',
  L2IdLs = 'L2_ID_LS',
  LiftgateCurbside = 'LIFTGATE_CURBSIDE',
  LiftgateInside = 'LIFTGATE_INSIDE',
  LinehaulTruck = 'LINEHAUL_TRUCK',
  LocalNextDay = 'LOCAL_NEXT_DAY',
  LocalSameDay = 'LOCAL_SAME_DAY',
  MedicalDevice = 'MEDICAL_DEVICE',
  Miseq = 'MISEQ',
  NextseqNovaseq = 'NEXTSEQ_NOVASEQ',
  NextDay = 'NEXT_DAY',
  OneManPlus = 'ONE_MAN_PLUS',
  OneManWg = 'ONE_MAN_WG',
  PlWd = 'PL_WD',
  RackAssist = 'RACK_ASSIST',
  RackAssist_2Man = 'RACK_ASSIST_2_MAN',
  Recovery = 'RECOVERY',
  RecoverySameDay = 'RECOVERY_SAME_DAY',
  RecoverySameDayExpedited = 'RECOVERY_SAME_DAY_EXPEDITED',
  Redbox = 'REDBOX',
  RoomOfChoice = 'ROOM_OF_CHOICE',
  Rtn = 'RTN',
  SameDay = 'SAME_DAY',
  SamsClubReturnCenter = 'SAMS_CLUB_RETURN_CENTER',
  SignatureDelivery = 'SIGNATURE_DELIVERY',
  SiteSurvey = 'SITE_SURVEY',
  SpecialProducts = 'SPECIAL_PRODUCTS',
  Standard = 'STANDARD',
  Storage = 'STORAGE',
  SvRc = 'SV_RC',
  Tcr = 'TCR',
  Td = 'TD',
  Threshold = 'THRESHOLD',
  ThresholdPlus = 'THRESHOLD_PLUS',
  Transfer = 'TRANSFER',
  TwoManDelivery = 'TWO_MAN_DELIVERY',
  TwoManPickup = 'TWO_MAN_PICKUP',
  TwoManPlus = 'TWO_MAN_PLUS',
  TwoManWg = 'TWO_MAN_WG',
  WaWga = 'WA_WGA',
  WhiteGlove = 'WHITE_GLOVE'
}

export type ServiceLevelReportArgs = {
  businessDivisionUuid?: InputMaybe<Scalars['String']['input']>;
  contactUuid?: InputMaybe<Scalars['String']['input']>;
  driverUuid?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  excludeMigratedOrders?: InputMaybe<Scalars['Boolean']['input']>;
  lastNumberOfDays?: InputMaybe<Scalars['Float']['input']>;
  lastNumberOfMonths?: InputMaybe<Scalars['Float']['input']>;
  lastNumberOfWeeks?: InputMaybe<Scalars['Float']['input']>;
  orderStatuses: Array<OrderStatus>;
  reportRevenueType?: InputMaybe<ReportRevenueType>;
  reportStatistics: Array<ReportStatistic>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  stopTypes: Array<PickupOrDelivery>;
  terminalUuid?: InputMaybe<Scalars['String']['input']>;
};

export type ServiceLevelReportBucketEntity = {
  __typename?: 'ServiceLevelReportBucketEntity';
  customChargeRevenue: Scalars['Float']['output'];
  deliveryRevenue: Scalars['Float']['output'];
  freightRevenue: Scalars['Float']['output'];
  fuelRevenue: Scalars['Float']['output'];
  lineHaulRevenue: Scalars['Float']['output'];
  name: Scalars['String']['output'];
  numberOfOrders: Scalars['Float']['output'];
  numberOfPackages: Scalars['Float']['output'];
  pickupRevenue: Scalars['Float']['output'];
  recoveryRevenue: Scalars['Float']['output'];
  specialRevenue: Scalars['Float']['output'];
  surchargeRevenue: Scalars['Float']['output'];
  totalRevenue: Scalars['Float']['output'];
  totalWeight: Scalars['Float']['output'];
  transferRevenue: Scalars['Float']['output'];
  uuid: Scalars['String']['output'];
};

/** An object describing the region and terminals operated in by a service company */
export type ServiceRegionEntity = {
  __typename?: 'ServiceRegionEntity';
  id: Scalars['String']['output'];
  isArchived: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  /** The terminals that are part of this service region */
  terminals: Array<TerminalEntity>;
};

export type ServiceUpdateInput = {
  defaultAppointmentEndTime?: InputMaybe<Scalars['DateTime']['input']>;
  defaultAppointmentStartTime?: InputMaybe<Scalars['DateTime']['input']>;
  defaultDeliveryPadding?: InputMaybe<Scalars['Duration']['input']>;
  defaultFulfillmentType?: InputMaybe<FulfillmentType>;
  defaultInboundStopType?: InputMaybe<StopType>;
  defaultIsLineHaul?: InputMaybe<Scalars['Boolean']['input']>;
  defaultOutboundStopType?: InputMaybe<StopType>;
  defaultPickupPadding?: InputMaybe<Scalars['Duration']['input']>;
  defaultStartNow?: InputMaybe<Scalars['Boolean']['input']>;
  defaultTotalDuration?: InputMaybe<Scalars['Duration']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isExposedToCustomers?: InputMaybe<Scalars['Boolean']['input']>;
  markOrdersAsSpecial?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  serviceAvailabilityDates?: InputMaybe<Array<UpsertServiceAvailabilityDateInput>>;
  timeInMinutes?: InputMaybe<Scalars['Int']['input']>;
  useApptInRouteOptimization?: InputMaybe<Scalars['Boolean']['input']>;
  uuid: Scalars['String']['input'];
};

export type SetStorageOrderItemQuantityInput = {
  itemUuid: Scalars['String']['input'];
  /** The updated total quantity for the specified item. */
  quantity: Scalars['Int']['input'];
  storageOrderUuid: Scalars['String']['input'];
};

export type SettlementAdjustmentCreateInput = {
  adjustmentType: SettlementAdjustmentType;
  driverSettlementBillUuid: Scalars['String']['input'];
  flatRate?: InputMaybe<Scalars['Float']['input']>;
  name: Scalars['String']['input'];
  percentageDecimalRate?: InputMaybe<Scalars['Float']['input']>;
};

export type SettlementAdjustmentEntity = {
  __typename?: 'SettlementAdjustmentEntity';
  adjustmentType: SettlementAdjustmentType;
  flatRate?: Maybe<Scalars['Float']['output']>;
  name: Scalars['String']['output'];
  percentageDecimalRate?: Maybe<Scalars['Float']['output']>;
  totalDollars: Scalars['Currency']['output'];
  uuid: Scalars['String']['output'];
};

/** Type of Adjustment for Settlements. Deductions are negative. Adjustments are positive. */
export enum SettlementAdjustmentType {
  Adjustment = 'ADJUSTMENT',
  Deduction = 'DEDUCTION'
}

export type SettlementAdjustmentUpdateInput = {
  adjustmentType?: InputMaybe<SettlementAdjustmentType>;
  driverSettlementBillUuid?: InputMaybe<Scalars['String']['input']>;
  flatRate?: InputMaybe<Scalars['Float']['input']>;
  name: Scalars['String']['input'];
  percentageDecimalRate?: InputMaybe<Scalars['Float']['input']>;
  uuid: Scalars['String']['input'];
};

export type SettlementBillLineItemConnection = {
  __typename?: 'SettlementBillLineItemConnection';
  edges: Array<SettlementBillLineItemEdge>;
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type SettlementBillLineItemEdge = {
  __typename?: 'SettlementBillLineItemEdge';
  cursor: Scalars['String']['output'];
  node: SettlementBillLineItemEntity;
};

/** A line item on a settlement bill. Used to track costs associated with a shipment and driver. */
export type SettlementBillLineItemEntity = {
  __typename?: 'SettlementBillLineItemEntity';
  customCosts: Array<CustomCostEntity>;
  driver: DriverEntity;
  driverSettlementBill?: Maybe<DriverSettlementBillEntity>;
  freightCost?: Maybe<FreightCostEntity>;
  id: Scalars['String']['output'];
  /** The the revenue flat rate in dollars if it exists. Meant for presentation */
  revenueFlatRate?: Maybe<Scalars['Float']['output']>;
  /** The percentage rate as a percentage out of 100, if it exists */
  revenuePercentageRate?: Maybe<Scalars['Percent']['output']>;
  settlementMode: SettlementMode;
  shipment: ShipmentEntity;
  /** The total cost for the settlement bill line item in dollars if it exists. Meant for presentation */
  totalAmountUsdDollars: Scalars['Float']['output'];
};

export type SettlementDeductionCreateInput = {
  driverSettlementBillUuid: Scalars['String']['input'];
  flatRate?: InputMaybe<Scalars['Float']['input']>;
  name: Scalars['String']['input'];
  percentageDecimalRate?: InputMaybe<Scalars['Float']['input']>;
};

export type SettlementDeductionEntity = {
  __typename?: 'SettlementDeductionEntity';
  adjustmentType?: Maybe<SettlementAdjustmentType>;
  flatRate?: Maybe<Scalars['Float']['output']>;
  name: Scalars['String']['output'];
  percentageDecimalRate?: Maybe<Scalars['Float']['output']>;
  uuid: Scalars['String']['output'];
};

export type SettlementDeductionForDownloadEntity = {
  __typename?: 'SettlementDeductionForDownloadEntity';
  flatRate?: Maybe<Scalars['Float']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  percentageDecimalRate?: Maybe<Scalars['Float']['output']>;
};

export type SettlementDeductionTypeCreateInput = {
  flatRate?: InputMaybe<Scalars['Float']['input']>;
  name: Scalars['String']['input'];
  percentageRate?: InputMaybe<Scalars['Float']['input']>;
};

export type SettlementDeductionTypeEntity = {
  __typename?: 'SettlementDeductionTypeEntity';
  flatRate?: Maybe<Scalars['Float']['output']>;
  name: Scalars['String']['output'];
  percentageRate?: Maybe<Scalars['Float']['output']>;
  uuid: Scalars['String']['output'];
};

export type SettlementDeductionTypeUpdateInput = {
  flatRate?: InputMaybe<Scalars['Float']['input']>;
  name: Scalars['String']['input'];
  percentageRate?: InputMaybe<Scalars['Float']['input']>;
  uuid: Scalars['String']['input'];
};

export type SettlementDeductionUpdateInput = {
  driverSettlementBillUuid?: InputMaybe<Scalars['String']['input']>;
  flatRate?: InputMaybe<Scalars['Float']['input']>;
  name: Scalars['String']['input'];
  percentageDecimalRate?: InputMaybe<Scalars['Float']['input']>;
  uuid: Scalars['String']['input'];
};

export enum SettlementMode {
  Dependent = 'DEPENDENT',
  Independent = 'INDEPENDENT'
}

export type SftpCredentialsEntity = {
  __typename?: 'SftpCredentialsEntity';
  createdAt: Scalars['DateTime']['output'];
  host: Scalars['String']['output'];
  invoicePath?: Maybe<Scalars['String']['output']>;
  password: Scalars['String']['output'];
  path?: Maybe<Scalars['String']['output']>;
  podNamingConvention?: Maybe<PodNamingConvention>;
  port: Scalars['Int']['output'];
  updatedAt: Scalars['DateTime']['output'];
  username: Scalars['String']['output'];
  uuid: Scalars['String']['output'];
};

export type SftpUploadConnection = {
  __typename?: 'SftpUploadConnection';
  edges: Array<SftpUploadEdge>;
  pageInfo: PageInfo;
};

export type SftpUploadEdge = {
  __typename?: 'SftpUploadEdge';
  cursor: Scalars['String']['output'];
  node: SftpUploadEntity;
};

export type SftpUploadEntity = {
  __typename?: 'SftpUploadEntity';
  company: CompanyEntity;
  contact: ContactEntity;
  createdAt: Scalars['DateTime']['output'];
  error?: Maybe<Scalars['String']['output']>;
  filename?: Maybe<Scalars['String']['output']>;
  host?: Maybe<Scalars['String']['output']>;
  invoice?: Maybe<OrderEntity>;
  order?: Maybe<OrderEntity>;
  path?: Maybe<Scalars['String']['output']>;
  status: SftpUploadStatus;
  type: SftpUploadType;
  updatedAt: Scalars['DateTime']['output'];
  uuid: Scalars['String']['output'];
};

export enum SftpUploadStatus {
  Completed = 'COMPLETED',
  Failed = 'FAILED',
  InProgress = 'IN_PROGRESS',
  Retried = 'RETRIED'
}

export enum SftpUploadType {
  Invoice = 'INVOICE',
  KuehneNagelXml = 'KUEHNE_NAGEL_XML',
  Pod = 'POD'
}

export type ShipmentArrayUpdateInput = {
  /** Pass this field in to create a new array item */
  shipmentCreateInput?: InputMaybe<ShipmentCreateInput>;
  /** Pass this field in to update an array item */
  shipmentUpdateInput?: InputMaybe<ShipmentUpdateInput>;
};

export type ShipmentChargeEntity = {
  __typename?: 'ShipmentChargeEntity';
  totalCharge: Scalars['Float']['output'];
  totalCustomCharge: Scalars['Float']['output'];
  totalFreightCharge: Scalars['Float']['output'];
  totalFuelCharge: Scalars['Float']['output'];
};

export type ShipmentConnection = {
  __typename?: 'ShipmentConnection';
  edges: Array<ShipmentEdge>;
  pageInfo: PageInfo;
  /** Not cheap to calculate, request with prudence */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export enum ShipmentConsolidationType {
  ConsolidatedIn = 'CONSOLIDATED_IN',
  Standard = 'STANDARD'
}

export type ShipmentCreateInput = {
  airline?: InputMaybe<Scalars['String']['input']>;
  airportInfoUuid?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  customChargeCreateInputs?: InputMaybe<Array<CustomChargeCreateInput>>;
  destinationAirport?: InputMaybe<Scalars['String']['input']>;
  documentConnectInputs?: InputMaybe<Array<DocumentConnectInput>>;
  documentCreateInputs?: InputMaybe<Array<DocumentCreateInput>>;
  freightChargeCreateInput?: InputMaybe<FreightChargeCreateInput>;
  hideFromBilling?: InputMaybe<Scalars['Boolean']['input']>;
  independentSettlementBillLineItemCreateInputs?: InputMaybe<Array<IndependentSettlementBillLineItemCreateInput>>;
  invoiceUuid?: InputMaybe<Scalars['String']['input']>;
  legCreateInputs?: InputMaybe<Array<LegCreateInput>>;
  overridePackageWeight?: InputMaybe<Scalars['Boolean']['input']>;
  packageCreateInputs?: InputMaybe<Array<PackageCreateInput>>;
  shipmentSubscriberUpsertInputs?: InputMaybe<Array<ShipmentSubscriberUpsertInput>>;
  shipmentType?: InputMaybe<ShipmentType>;
  shipperAddressUpsertInput?: InputMaybe<AddressUpsertInput>;
  shouldUseDimWeight?: InputMaybe<Scalars['Boolean']['input']>;
  standardShipmentFieldsCreateInput?: InputMaybe<StandardShipmentFieldsCreateInput>;
  status?: InputMaybe<ShipmentStatusWithoutBilling>;
  /** The total charge in dollars */
  totalCharge?: InputMaybe<Scalars['Float']['input']>;
  uuid?: InputMaybe<Scalars['String']['input']>;
};

export type ShipmentEdge = {
  __typename?: 'ShipmentEdge';
  cursor: Scalars['String']['output'];
  node: ShipmentEntity;
};

export type ShipmentEntity = {
  airline?: Maybe<Scalars['String']['output']>;
  airportInfo?: Maybe<AirportInfoEntity>;
  billingShipmentStatus?: Maybe<BillingShipmentStatus>;
  charges: Array<ChargesUnion>;
  consigneeAddress?: Maybe<AddressEntity>;
  consolidatableShipment?: Maybe<ShipmentEntity>;
  consolidatableShipments?: Maybe<Array<ShipmentEntity>>;
  customCharges: Array<CustomChargeEntity>;
  dateAddedToInvoice?: Maybe<Scalars['DateTime']['output']>;
  dateMarkedFinalized?: Maybe<Scalars['DateTime']['output']>;
  dateMarkedOfd?: Maybe<Scalars['DateTime']['output']>;
  destinationAirport?: Maybe<Scalars['String']['output']>;
  documents: Array<DocumentEntity>;
  failureCount: Scalars['Float']['output'];
  fields?: Maybe<StandardShipmentFieldsEntity>;
  freightCharge?: Maybe<FreightChargeEntity>;
  hasBillingIssues?: Maybe<Scalars['DateTime']['output']>;
  hasFailedStop: Scalars['Boolean']['output'];
  hasSignedPOD: Scalars['Boolean']['output'];
  hideFromBilling: Scalars['Boolean']['output'];
  independentSettlementBillLineItems: Array<SettlementBillLineItemEntity>;
  inputForConsolidatedOrder?: Maybe<OrderEntity>;
  invoice?: Maybe<InvoiceEntity>;
  legs: Array<LegEntity>;
  name: Scalars['String']['output'];
  order?: Maybe<OrderEntity>;
  ordinal: Scalars['Float']['output'];
  overridePackageWeight: Scalars['Boolean']['output'];
  packages: Array<PackageEntity>;
  postedAmountCents?: Maybe<Scalars['Int']['output']>;
  settlementBillLineItems: Array<SettlementBillLineItemEntity>;
  /** The shipment total charge, freight charge total, fuel charge total, and custom charge total in dollars */
  shipmentCharges: ShipmentChargeEntity;
  shipmentConsolidationType: ShipmentConsolidationType;
  shipmentSubscribers: Array<ShipmentSubscriberEntity>;
  shipmentType: ShipmentType;
  shipperAddress?: Maybe<AddressEntity>;
  shouldBillIndividually: Scalars['Boolean']['output'];
  shouldUseDimWeight: Scalars['Boolean']['output'];
  standardShipmentFields?: Maybe<StandardShipmentFieldsEntity>;
  status: ShipmentStatus;
  totalAmountCents?: Maybe<Scalars['Int']['output']>;
  /** The total charges for the shipment in dollars */
  totalChargesAmount: Scalars['Float']['output'];
  totalChargesForDriverSettlement: Scalars['Float']['output'];
  totalCustomChargesAmount: Scalars['Float']['output'];
  totalFreightChargesAmount: Scalars['Float']['output'];
  totalFuelChargesAmount: Scalars['Float']['output'];
  uuid: Scalars['String']['output'];
};

export type ShipmentIncludedInRevenueEntity = {
  __typename?: 'ShipmentIncludedInRevenueEntity';
  shipmentTypeForCharge: ShipmentTypeForCharge;
  shipmentUuid: Scalars['String']['output'];
  terminalCode?: Maybe<Scalars['String']['output']>;
  terminalUuid?: Maybe<Scalars['String']['output']>;
};

export enum ShipmentPdfColumnMapping {
  DeliveryDate = 'DELIVERY_DATE',
  PickupOrDelivery = 'PICKUP_OR_DELIVERY',
  ServiceLevel = 'SERVICE_LEVEL',
  TotalChargeAmount = 'TOTAL_CHARGE_AMOUNT'
}

export enum ShipmentStatus {
  Created = 'CREATED',
  Delivered = 'DELIVERED',
  Finalized = 'FINALIZED',
  HasIssue = 'HAS_ISSUE',
  Invoiced = 'INVOICED',
  InProgress = 'IN_PROGRESS',
  OutForDelivery = 'OUT_FOR_DELIVERY',
  Paid = 'PAID'
}

export type ShipmentStatusFilter = {
  filterType: ShipmentStatusFilterType;
  status: ShipmentStatus;
};

export enum ShipmentStatusFilterType {
  Equals = 'EQUALS',
  NotEquals = 'NOT_EQUALS'
}

export enum ShipmentStatusWithoutBilling {
  Created = 'CREATED',
  Delivered = 'DELIVERED',
  InProgress = 'IN_PROGRESS',
  OutForDelivery = 'OUT_FOR_DELIVERY'
}

export type ShipmentSubscriberEntity = {
  __typename?: 'ShipmentSubscriberEntity';
  email?: Maybe<Scalars['String']['output']>;
  /** Subscriber phone number */
  phoneNumber?: Maybe<Scalars['String']['output']>;
  /** Subscriber uuid */
  uuid: Scalars['String']['output'];
};

export type ShipmentSubscriberUpsertInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  /** Subscriber phone number */
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  /** Subscriber uuid */
  uuid: Scalars['String']['input'];
};

export enum ShipmentType {
  LineHaul = 'LINE_HAUL',
  OrderCharges = 'ORDER_CHARGES',
  Regular = 'REGULAR'
}

export enum ShipmentTypeForCharge {
  Delivery = 'DELIVERY',
  LineHaul = 'LINE_HAUL',
  OrderCharge = 'ORDER_CHARGE',
  Pickup = 'PICKUP',
  Recovery = 'RECOVERY',
  Transfer = 'TRANSFER'
}

export type ShipmentUpdateInput = {
  airline?: InputMaybe<Scalars['String']['input']>;
  airportInfoUuid?: InputMaybe<Scalars['String']['input']>;
  customChargeArrayUpdateInputs?: InputMaybe<Array<CustomChargeArrayUpdateInput>>;
  destinationAirport?: InputMaybe<Scalars['String']['input']>;
  freightChargeUpsertInput?: InputMaybe<FreightChargeUpsertInput>;
  hideFromBilling?: InputMaybe<Scalars['Boolean']['input']>;
  independentSettlementBillLineItemUpsertInputs?: InputMaybe<Array<IndependentSettlementBillLineItemUpsertInput>>;
  legUpdateInput?: InputMaybe<LegUpdateInput>;
  legUpsertInputs?: InputMaybe<Array<LegUpsertInput>>;
  overridePackageWeight?: InputMaybe<Scalars['Boolean']['input']>;
  packageArrayUpdateInputs?: InputMaybe<Array<PackageArrayUpdateInput>>;
  shipperAddressUpsertInput?: InputMaybe<AddressUpsertInput>;
  shouldUseDimWeight?: InputMaybe<Scalars['Boolean']['input']>;
  standardShipmentFieldsUpdateInput?: InputMaybe<StandardShipmentFieldsUpdateInput>;
  status?: InputMaybe<ShipmentStatusWithoutBilling>;
  /** The total charge in dollars */
  totalCharge?: InputMaybe<Scalars['Float']['input']>;
  uuid: Scalars['String']['input'];
};

export type ShipperBillOfLadingNumberSortInput = {
  direction: SortOrder;
  nulls: NullsOrder;
};

export type SignUpForThirdPartyUserAccountInput = {
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
};

export type SignUpForThirdPartyUserAccountOutput = {
  __typename?: 'SignUpForThirdPartyUserAccountOutput';
  status: SignUpForThirdPartyUserAccountStatus;
  thirdPartyUser?: Maybe<ThirdPartyUserEntity>;
};

export enum SignUpForThirdPartyUserAccountStatus {
  EmailAlreadyExists = 'EMAIL_ALREADY_EXISTS',
  Success = 'SUCCESS'
}

export enum SignedPodMatchStatus {
  Failed = 'FAILED',
  InProgress = 'IN_PROGRESS',
  Matched = 'MATCHED',
  Unmatched = 'UNMATCHED'
}

export type SimpleCustomCharge = {
  __typename?: 'SimpleCustomCharge';
  amount: Scalars['Float']['output'];
  name: Scalars['String']['output'];
};

export type SimpleFreightCharge = {
  __typename?: 'SimpleFreightCharge';
  amount: Scalars['Float']['output'];
  billingMethod: FreightBillingMethod;
  quantity: Scalars['Float']['output'];
  rate: Scalars['String']['output'];
};

export type SimpleFuelCharge = {
  __typename?: 'SimpleFuelCharge';
  amount: Scalars['Float']['output'];
  billingMethod: FuelBillingMethod;
  quantity: Scalars['Float']['output'];
};

export type SkidBasedAccessorialCreateInput = {
  maximumCharge?: InputMaybe<Scalars['Float']['input']>;
  minimumCharge?: InputMaybe<Scalars['Float']['input']>;
  name: Scalars['String']['input'];
  ratePerSkid: Scalars['Float']['input'];
};

export type SkidBasedAccessorialEntity = AccessorialInterface & {
  __typename?: 'SkidBasedAccessorialEntity';
  accessorialDateRangeConfigs: Array<AccessorialDateRangeConfigEntity>;
  code?: Maybe<Scalars['String']['output']>;
  contact?: Maybe<ContactEntity>;
  contacts: Array<ContactEntity>;
  ediCode?: Maybe<Scalars['String']['output']>;
  enableQuickAdd: Scalars['Boolean']['output'];
  fuelProfile?: Maybe<FuelProfileEntity>;
  fuelProfileUuid?: Maybe<Scalars['String']['output']>;
  generalLedgerCode?: Maybe<GeneralLedgerCodeEntity>;
  invoiceDisplayName?: Maybe<Scalars['String']['output']>;
  isArchived?: Maybe<Scalars['Boolean']['output']>;
  isAuthoCodeRequired: Scalars['Boolean']['output'];
  isDefaultGlobalSpecial: Scalars['Boolean']['output'];
  isSpecial?: Maybe<Scalars['Boolean']['output']>;
  matchingCustomerAccessorials?: Maybe<Array<AccessorialUnion>>;
  matchingGlobalAccessorial?: Maybe<AccessorialUnion>;
  maximumCharge?: Maybe<Scalars['Float']['output']>;
  minimumCharge?: Maybe<Scalars['Float']['output']>;
  name: Scalars['String']['output'];
  percentForSettlement?: Maybe<Scalars['Float']['output']>;
  quickbooksDesktopAccessorialId?: Maybe<Scalars['String']['output']>;
  quickbooksFileMappingChargeName?: Maybe<Scalars['String']['output']>;
  quickbooksMappingId: Scalars['String']['output'];
  /** Rate in dollars */
  ratePerSkid: Scalars['Float']['output'];
  terminal?: Maybe<TerminalEntity>;
  terminalUuid?: Maybe<Scalars['String']['output']>;
  type?: Maybe<AccessorialType>;
  uuid: Scalars['String']['output'];
};

export type SkidBasedAccessorialUpdateInput = {
  maximumCharge?: InputMaybe<Scalars['Float']['input']>;
  minimumCharge?: InputMaybe<Scalars['Float']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  ratePerSkid?: InputMaybe<Scalars['Float']['input']>;
  uuid: Scalars['String']['input'];
};

/** Represents the difference between 2 versions of an address. Used in audit log entries */
export type SnapshotAddressDifferences = {
  __typename?: 'SnapshotAddressDifferences';
  city?: Maybe<StringFieldDifference>;
  line1?: Maybe<StringFieldDifference>;
  name?: Maybe<StringFieldDifference>;
  state?: Maybe<StringFieldDifference>;
  zip?: Maybe<StringFieldDifference>;
};

/** Represents the difference between 2 versions of a custom charge. Used in audit log entries */
export type SnapshotCustomChargeDifferences = {
  __typename?: 'SnapshotCustomChargeDifferences';
  name?: Maybe<StringFieldDifference>;
  totalAmountCents?: Maybe<NumberFieldDifference>;
  wasAdded: Scalars['Boolean']['output'];
  wasDeleted: Scalars['Boolean']['output'];
};

/** Represents the difference between 2 versions of a custom cost */
export type SnapshotCustomCostDifferences = {
  __typename?: 'SnapshotCustomCostDifferences';
  name?: Maybe<StringFieldDifference>;
  totalAmountCents?: Maybe<NumberFieldDifference>;
  wasAdded: Scalars['Boolean']['output'];
  wasDeleted: Scalars['Boolean']['output'];
};

/** Represents the difference between 2 versions of a freight charge. Used in audit log entries */
export type SnapshotFreightChargeDifferences = {
  __typename?: 'SnapshotFreightChargeDifferences';
  billingMethod?: Maybe<StringFieldDifference>;
  fuelCharge?: Maybe<SnapshotFuelChargeDifferences>;
  tariff?: Maybe<StringFieldDifference>;
  totalAmountCents?: Maybe<NumberFieldDifference>;
};

/** Represents the difference between 2 versions of a freight cost */
export type SnapshotFreightCostDifferences = {
  __typename?: 'SnapshotFreightCostDifferences';
  billingMethod?: Maybe<StringFieldDifference>;
  fuelCost?: Maybe<SnapshotFuelCostDifferences>;
  tariff?: Maybe<StringFieldDifference>;
  totalAmountCents?: Maybe<NumberFieldDifference>;
};

/** Represents the difference between 2 versions of a fuel charge. Used in audit log entries */
export type SnapshotFuelChargeDifferences = {
  __typename?: 'SnapshotFuelChargeDifferences';
  surchargeRate?: Maybe<NumberFieldDifference>;
  totalAmountCents?: Maybe<NumberFieldDifference>;
  type?: Maybe<StringFieldDifference>;
};

/** Represents the difference between 2 versions of a fuel cost */
export type SnapshotFuelCostDifferences = {
  __typename?: 'SnapshotFuelCostDifferences';
  billingMethod?: Maybe<StringFieldDifference>;
  surchargeRate?: Maybe<NumberFieldDifference>;
  totalAmountCents?: Maybe<NumberFieldDifference>;
  type?: Maybe<StringFieldDifference>;
};

/** Represents the difference between 2 versions of an independent settlement bill line item */
export type SnapshotIndependentSettlementBillLineItemDifferences = {
  __typename?: 'SnapshotIndependentSettlementBillLineItemDifferences';
  customCosts?: Maybe<Array<SnapshotCustomCostDifferences>>;
  driverName?: Maybe<StringFieldDifference>;
  freightCost?: Maybe<SnapshotFreightCostDifferences>;
  wasAdded: Scalars['Boolean']['output'];
  wasDeleted: Scalars['Boolean']['output'];
};

/** Represents the difference between 2 versions of an order. Used in audit log entries */
export type SnapshotOrderDifferences = {
  __typename?: 'SnapshotOrderDifferences';
  billingPartyName?: Maybe<StringFieldDifference>;
  hawb?: Maybe<StringFieldDifference>;
  mawb?: Maybe<StringFieldDifference>;
  packages?: Maybe<Array<SnapshotPackageDifferences>>;
  refNumbers?: Maybe<StringArrayFieldDifference>;
  serviceLevel?: Maybe<StringFieldDifference>;
  totalAmountCents?: Maybe<NumberFieldDifference>;
  vehicleType?: Maybe<StringFieldDifference>;
};

/** Represents the difference between 2 versions of a package. Used in audit log entries */
export type SnapshotPackageDifferences = {
  __typename?: 'SnapshotPackageDifferences';
  description?: Maybe<StringFieldDifference>;
  height?: Maybe<NumberFieldDifference>;
  length?: Maybe<NumberFieldDifference>;
  quantity?: Maybe<NumberFieldDifference>;
  type?: Maybe<StringFieldDifference>;
  wasAdded: Scalars['Boolean']['output'];
  wasDeleted: Scalars['Boolean']['output'];
  weight?: Maybe<NumberFieldDifference>;
  width?: Maybe<NumberFieldDifference>;
};

/** Represents the difference between 2 versions of a stop. Used in audit log entries */
export type SnapshotStopDifferences = {
  __typename?: 'SnapshotStopDifferences';
  address?: Maybe<SnapshotAddressDifferences>;
  appointmentManuallyConfirmed?: Maybe<BooleanFieldDifference>;
  appointmentRequired?: Maybe<BooleanFieldDifference>;
  customCharges?: Maybe<Array<SnapshotCustomChargeDifferences>>;
  driverName?: Maybe<StringFieldDifference>;
  freightCharge?: Maybe<SnapshotFreightChargeDifferences>;
  independentSettlementBillLineItems?: Maybe<Array<SnapshotIndependentSettlementBillLineItemDifferences>>;
  isSpecial?: Maybe<BooleanFieldDifference>;
  serviceDate?: Maybe<StringFieldDifference>;
  serviceDateIso8601?: Maybe<StringFieldDifference>;
  stopType?: Maybe<StringFieldDifference>;
  terminal?: Maybe<StringFieldDifference>;
  wasAdded: Scalars['Boolean']['output'];
  wasDeleted: Scalars['Boolean']['output'];
};

export enum SortDirection {
  Asc = 'ASC',
  Desc = 'DESC'
}

export enum SortOrder {
  Asc = 'asc',
  Desc = 'desc'
}

export type SpecialAccessorialChargeGroupArrayUpdateInput = {
  /** Pass this field in to create a new array item */
  specialAccessorialChargeGroupCreateInput?: InputMaybe<SpecialAccessorialChargeGroupCreateInput>;
  /** Pass this field in to update an array item */
  specialAccessorialChargeGroupUpdateInput?: InputMaybe<SpecialAccessorialChargeGroupUpdateInput>;
};

export type SpecialAccessorialChargeGroupCreateInput = {
  dayOfWeek: SpecialDayOfWeek;
  endTime: Scalars['DateTime']['input'];
  startTime: Scalars['DateTime']['input'];
};

export type SpecialAccessorialChargeGroupEntity = {
  __typename?: 'SpecialAccessorialChargeGroupEntity';
  dayOfWeek: SpecialDayOfWeek;
  endTime: Scalars['DateTime']['output'];
  startTime: Scalars['DateTime']['output'];
  uuid: Scalars['String']['output'];
};

export type SpecialAccessorialChargeGroupUpdateInput = {
  dayOfWeek?: InputMaybe<SpecialDayOfWeek>;
  endTime?: InputMaybe<Scalars['DateTime']['input']>;
  startTime?: InputMaybe<Scalars['DateTime']['input']>;
  uuid: Scalars['String']['input'];
};

export type SpecialAccessorialCreateInput = {
  name: Scalars['String']['input'];
  serviceUuid?: InputMaybe<Scalars['String']['input']>;
  specialAccessorialType?: InputMaybe<SpecialAccessorialType>;
  specialChargeGroups: Array<SpecialAccessorialChargeGroupCreateInput>;
  specialMatrixItems: Array<SpecialAccessorialMatrixItemCreateInput>;
  specialMileRanges?: InputMaybe<Array<SpecialAccessorialMileRangeCreateInput>>;
  tariffZoneGroupId?: InputMaybe<Scalars['String']['input']>;
};

export type SpecialAccessorialEntity = AccessorialInterface & {
  __typename?: 'SpecialAccessorialEntity';
  accessorialDateRangeConfigs: Array<AccessorialDateRangeConfigEntity>;
  chargeGroups: Array<SpecialAccessorialChargeGroupEntity>;
  code?: Maybe<Scalars['String']['output']>;
  contact?: Maybe<ContactEntity>;
  contacts: Array<ContactEntity>;
  ediCode?: Maybe<Scalars['String']['output']>;
  enableQuickAdd: Scalars['Boolean']['output'];
  fuelProfile?: Maybe<FuelProfileEntity>;
  fuelProfileUuid?: Maybe<Scalars['String']['output']>;
  generalLedgerCode?: Maybe<GeneralLedgerCodeEntity>;
  invoiceDisplayName?: Maybe<Scalars['String']['output']>;
  isArchived?: Maybe<Scalars['Boolean']['output']>;
  isAuthoCodeRequired: Scalars['Boolean']['output'];
  isDefaultGlobalSpecial: Scalars['Boolean']['output'];
  /** @deprecated Prefer the isSpecial field on the accessorial charge's corresponding stop */
  isSpecial?: Maybe<Scalars['Boolean']['output']>;
  matchingCustomerAccessorials?: Maybe<Array<AccessorialUnion>>;
  matchingGlobalAccessorial?: Maybe<AccessorialUnion>;
  matrixItems: Array<SpecialAccessorialMatrixItemEntity>;
  name: Scalars['String']['output'];
  percentForSettlement?: Maybe<Scalars['Float']['output']>;
  quickbooksDesktopAccessorialId?: Maybe<Scalars['String']['output']>;
  quickbooksFileMappingChargeName?: Maybe<Scalars['String']['output']>;
  quickbooksMappingId: Scalars['String']['output'];
  serviceLevel?: Maybe<ServiceEntity>;
  specialAccessorialType?: Maybe<SpecialAccessorialType>;
  tariffZoneGroup?: Maybe<TariffZoneGroupEntity>;
  terminal?: Maybe<TerminalEntity>;
  terminalUuid?: Maybe<Scalars['String']['output']>;
  type?: Maybe<AccessorialType>;
  uuid: Scalars['String']['output'];
  zones: Array<TariffZoneEntity>;
};

export type SpecialAccessorialMatrixItemArrayUpdateInput = {
  /** Pass this field in to create a new array item */
  matrixItemCreateInput?: InputMaybe<SpecialAccessorialMatrixItemCreateInput>;
  /** Pass this field in to update an array item */
  matrixItemUpdateInput?: InputMaybe<SpecialAccessorialMatrixItemUpdateInput>;
};

export type SpecialAccessorialMatrixItemCreateInput = {
  chargeGroupDayOfWeek: SpecialDayOfWeek;
  chargeGroupEndTime: Scalars['DateTime']['input'];
  chargeGroupStartTime: Scalars['DateTime']['input'];
  chargeGroupUuid?: InputMaybe<Scalars['String']['input']>;
  /** Accepts rate as a $ float with two decimal places */
  rate: Scalars['Float']['input'];
  tariffZoneUuid: Scalars['String']['input'];
};

export type SpecialAccessorialMatrixItemEntity = {
  __typename?: 'SpecialAccessorialMatrixItemEntity';
  chargeGroupUuid: Scalars['String']['output'];
  rate: Scalars['Float']['output'];
  tariffZone: TariffZoneEntity;
  uuid: Scalars['String']['output'];
  zoneUuid: Scalars['String']['output'];
};

export type SpecialAccessorialMatrixItemUpdateInput = {
  rate?: InputMaybe<Scalars['Float']['input']>;
  uuid: Scalars['String']['input'];
};

export type SpecialAccessorialMileRangeCreateInput = {
  end: Scalars['Float']['input'];
  start: Scalars['Float']['input'];
  /** UUIDs are generated on the frontend so that we can link matrix items to mile ranges on the frontend without first creating the mile ranges */
  uuid: Scalars['String']['input'];
};

export enum SpecialAccessorialType {
  MileageBased = 'MILEAGE_BASED',
  ZoneBased = 'ZONE_BASED'
}

export type SpecialAccessorialUpdateInput = {
  chargeGroupUpdates?: InputMaybe<Array<SpecialAccessorialChargeGroupArrayUpdateInput>>;
  matrixItemsArrayUpdateInput?: InputMaybe<Array<SpecialAccessorialMatrixItemArrayUpdateInput>>;
  name?: InputMaybe<Scalars['String']['input']>;
  quickbooksMappingId?: InputMaybe<Scalars['String']['input']>;
  serviceUuid?: InputMaybe<Scalars['String']['input']>;
  uuid: Scalars['String']['input'];
};

export enum SpecialDayOfWeek {
  Holiday = 'HOLIDAY',
  Saturday = 'SATURDAY',
  Sunday = 'SUNDAY',
  Weekday = 'WEEKDAY'
}

export type SplitAndProcessOrderDocumentsInput = {
  /** A flag that determines whether the EOD documents should be automatched to the orders */
  autoMatchingEnabled: Scalars['Boolean']['input'];
  /** The UUID of the company the EOD documents are being matched for */
  companyUuid: Scalars['String']['input'];
  /** The day the EOD documents are being matched for */
  currentDate: Scalars['DateTime']['input'];
  orderDocuments: Array<OrderDocumentInput>;
};

export type StandardAccessorialCreateInput = {
  name: Scalars['String']['input'];
  /** Accepts rate as a $ float with two decimal places */
  rate: Scalars['Float']['input'];
};

export type StandardAccessorialEntity = AccessorialInterface & {
  __typename?: 'StandardAccessorialEntity';
  accessorialDateRangeConfigs: Array<AccessorialDateRangeConfigEntity>;
  code?: Maybe<Scalars['String']['output']>;
  contact?: Maybe<ContactEntity>;
  contacts: Array<ContactEntity>;
  ediCode?: Maybe<Scalars['String']['output']>;
  enableQuickAdd: Scalars['Boolean']['output'];
  fuelProfile?: Maybe<FuelProfileEntity>;
  fuelProfileUuid?: Maybe<Scalars['String']['output']>;
  generalLedgerCode?: Maybe<GeneralLedgerCodeEntity>;
  invoiceDisplayName?: Maybe<Scalars['String']['output']>;
  isArchived?: Maybe<Scalars['Boolean']['output']>;
  isAuthoCodeRequired: Scalars['Boolean']['output'];
  isDefaultGlobalSpecial: Scalars['Boolean']['output'];
  isSpecial?: Maybe<Scalars['Boolean']['output']>;
  matchingCustomerAccessorials?: Maybe<Array<AccessorialUnion>>;
  matchingGlobalAccessorial?: Maybe<AccessorialUnion>;
  name: Scalars['String']['output'];
  percentForSettlement?: Maybe<Scalars['Float']['output']>;
  quickbooksDesktopAccessorialId?: Maybe<Scalars['String']['output']>;
  quickbooksFileMappingChargeName?: Maybe<Scalars['String']['output']>;
  quickbooksMappingId: Scalars['String']['output'];
  /** Rate in dollars */
  rate: Scalars['Float']['output'];
  terminal?: Maybe<TerminalEntity>;
  terminalUuid?: Maybe<Scalars['String']['output']>;
  type?: Maybe<AccessorialType>;
  uuid: Scalars['String']['output'];
};

export type StandardAccessorialUpdateInput = {
  name?: InputMaybe<Scalars['String']['input']>;
  quickbooksMappingId?: InputMaybe<Scalars['String']['input']>;
  /** Rate in $, will be truncated to two decimal places */
  rate?: InputMaybe<Scalars['Float']['input']>;
  uuid: Scalars['String']['input'];
};

export type StandardOrderCreateInput = {
  apiReceivedReference?: InputMaybe<Scalars['String']['input']>;
  billingPartyContactStationId?: InputMaybe<Scalars['String']['input']>;
  billingPartyContactUuid: Scalars['String']['input'];
  callerName?: InputMaybe<Scalars['String']['input']>;
  callerPhoneNumber?: InputMaybe<Scalars['String']['input']>;
  chargeableWeightCubicMeters?: InputMaybe<Scalars['Volume']['input']>;
  codCheckAmountCents?: InputMaybe<Scalars['Int']['input']>;
  codCheckNumber?: InputMaybe<Scalars['String']['input']>;
  createdFromOrderTemplateUuid?: InputMaybe<Scalars['String']['input']>;
  csvOrderImportStatus?: InputMaybe<CsvOrderImportStatus>;
  dateMarkedOnHand?: InputMaybe<Scalars['DateTime']['input']>;
  dateMarkedReceivedAtOrigin?: InputMaybe<Scalars['DateTime']['input']>;
  deletedAutoAppliedAccessorialUuids?: InputMaybe<Array<Scalars['String']['input']>>;
  documentCreateInputs?: InputMaybe<Array<DocumentCreateInput>>;
  driverQualificationIds?: InputMaybe<Array<Scalars['String']['input']>>;
  ediConsigneeAddressCreateInput?: InputMaybe<AddressCreateInput>;
  ediConsigneeContactPersonCreateInput?: InputMaybe<ContactPersonCreateInput>;
  ediEquipmentType?: InputMaybe<Scalars['String']['input']>;
  ediReceivedScac?: InputMaybe<Scalars['String']['input']>;
  ediShipperAddressCreateInput?: InputMaybe<AddressCreateInput>;
  ediShipperContactPersonCreateInput?: InputMaybe<ContactPersonCreateInput>;
  emergencyResponseNumber?: InputMaybe<Scalars['String']['input']>;
  enableLinehaul?: InputMaybe<Scalars['Boolean']['input']>;
  externalNotes?: InputMaybe<Scalars['String']['input']>;
  fulfillmentType?: InputMaybe<FulfillmentType>;
  hazmat?: InputMaybe<Scalars['Boolean']['input']>;
  hazmatClass?: InputMaybe<HazmatClass>;
  hazmatDescription?: InputMaybe<Scalars['String']['input']>;
  holdReasonUuid?: InputMaybe<Scalars['String']['input']>;
  inBond?: InputMaybe<Scalars['Boolean']['input']>;
  inboundShipmentCreateInput?: InputMaybe<StandardShipmentCreateInput>;
  isCollectOnDelivery?: InputMaybe<Scalars['Boolean']['input']>;
  isCrossDock?: InputMaybe<Scalars['Boolean']['input']>;
  isDraftOrder?: InputMaybe<Scalars['Boolean']['input']>;
  isReweighed?: InputMaybe<Scalars['Boolean']['input']>;
  issueReason?: InputMaybe<Scalars['String']['input']>;
  itTeNumber?: InputMaybe<Scalars['String']['input']>;
  lineHaulLaneUuid?: InputMaybe<Scalars['String']['input']>;
  lineHaulShipmentCreateInput?: InputMaybe<StandardShipmentCreateInput>;
  lockSecondaryRefNumber?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  onHand?: InputMaybe<Scalars['Boolean']['input']>;
  onHold?: InputMaybe<Scalars['DateTime']['input']>;
  orderChargesShipmentCreateInput?: InputMaybe<StandardShipmentCreateInput>;
  orderCommentCreateInputs?: InputMaybe<Array<CreateOrderCommentInput>>;
  orderConsolidationType?: InputMaybe<OrderConsolidationType>;
  orderSegmentType?: InputMaybe<OrderSegmentType>;
  outboundShipmentCreateInput?: InputMaybe<StandardShipmentCreateInput>;
  packageCreateInputs?: InputMaybe<Array<PackageCreateInput>>;
  packageGroup?: InputMaybe<PackageGroup>;
  paymentMethod?: InputMaybe<PaymentMethod>;
  personEmail?: InputMaybe<Scalars['String']['input']>;
  personName?: InputMaybe<Scalars['String']['input']>;
  personPhoneNumber?: InputMaybe<Scalars['String']['input']>;
  pickedDate?: InputMaybe<Scalars['DateTime']['input']>;
  pieceCount?: InputMaybe<Scalars['Float']['input']>;
  piecesPicked?: InputMaybe<Scalars['Int']['input']>;
  quaternaryRefNumber?: InputMaybe<Scalars['String']['input']>;
  quinaryRefNumber?: InputMaybe<Scalars['String']['input']>;
  /** If false, the charges for the order will not be recalculated. This should only be used on manual order creation when client-side order rating has already been done. */
  recalculateCharges?: InputMaybe<Scalars['Boolean']['input']>;
  receivedDate?: InputMaybe<Scalars['DateTime']['input']>;
  recurringOrderFrequencyCreateInput?: InputMaybe<CreateRecurringOrderFrequencyInput>;
  refNumbers: Array<Scalars['String']['input']>;
  refusedBy?: InputMaybe<Scalars['String']['input']>;
  requiresPlacard?: InputMaybe<Scalars['Boolean']['input']>;
  secondaryRefNumber?: InputMaybe<Scalars['String']['input']>;
  serviceUuid?: InputMaybe<Scalars['String']['input']>;
  shipmentCreateInputs?: InputMaybe<Array<StandardShipmentCreateInput>>;
  source: OrderSource;
  standardOrderFieldsCreateInput?: InputMaybe<StandardOrderFieldsCreateInput>;
  status?: InputMaybe<OrderStatus>;
  tagUuids?: InputMaybe<Array<Scalars['String']['input']>>;
  tertiaryRefNumber?: InputMaybe<Scalars['String']['input']>;
  thirdPartyBrokerUuids?: InputMaybe<Array<Scalars['String']['input']>>;
  /** The total charge in dollars */
  totalCharge?: InputMaybe<Scalars['Float']['input']>;
  totalSkids?: InputMaybe<Scalars['Int']['input']>;
  unNumber?: InputMaybe<Scalars['String']['input']>;
  uuid?: InputMaybe<Scalars['String']['input']>;
  vehicleTypeUuid?: InputMaybe<Scalars['String']['input']>;
  warehouseUuid?: InputMaybe<Scalars['String']['input']>;
};

export type StandardOrderEntity = OrderEntity & {
  __typename?: 'StandardOrderEntity';
  appliedAmount: Scalars['Float']['output'];
  balanceInCents: Scalars['Int']['output'];
  billingPartyContact: CustomerContactEntity;
  billingPartyContactStation?: Maybe<ContactStationEntity>;
  /** @deprecated Use personName */
  callerName?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use personPhoneNumber */
  callerPhoneNumber?: Maybe<Scalars['String']['output']>;
  cancelled?: Maybe<Scalars['DateTime']['output']>;
  /** The chargeable weight is an optional weight value (measured in cubic meters) that can be used in billing calculations for the order. */
  chargeableWeightCubicMeters?: Maybe<Scalars['Volume']['output']>;
  codCheckAmountCents?: Maybe<Scalars['Int']['output']>;
  codCheckNumber?: Maybe<Scalars['String']['output']>;
  company: CompanyEntity;
  consolidatableOrders: ConsolidatableOrdersOutput;
  consolidatedOrders?: Maybe<Array<OrderEntity>>;
  consolidatedShipmentString?: Maybe<Scalars['String']['output']>;
  contact: ContactEntity;
  coverSheetDocumentTypeSequence?: Maybe<CoverSheetDocumentTypeSequenceEntity>;
  createdAt: Scalars['DateTime']['output'];
  createdFromOrderTemplate?: Maybe<OrderEntity>;
  csvOrderImportStatus?: Maybe<CsvOrderImportStatus>;
  /** Total custom charge (accessorial charge) for the order in dollars */
  customChargeRevenue: Scalars['Float']['output'];
  /** Each custom charge (accessorial charge) itemized */
  customCharges: Array<CustomChargeEntity>;
  dateMarkedLoaded?: Maybe<Scalars['DateTime']['output']>;
  dateMarkedOnHand?: Maybe<Scalars['DateTime']['output']>;
  dateMarkedReceivedAtOrigin?: Maybe<Scalars['DateTime']['output']>;
  deletedAutoAppliedAccessorials: Array<AccessorialUnion>;
  detailedStatus?: Maybe<Scalars['String']['output']>;
  detailedStatusV2?: Maybe<OrderDetailedStatus>;
  dimWeight: Scalars['Float']['output'];
  documents: Array<DocumentEntity>;
  driverQualifications: Array<DriverQualificationEntity>;
  driverSettlementTotal: Scalars['Float']['output'];
  ediReceivedScac?: Maybe<Scalars['String']['output']>;
  ediTransactions: Array<EdiTransactionEntity>;
  emergencyResponseNumber?: Maybe<Scalars['String']['output']>;
  enableLineHaul: Scalars['Boolean']['output'];
  endStop?: Maybe<StopEntity>;
  externalNotes?: Maybe<Scalars['String']['output']>;
  fields: StandardOrderFieldsEntity;
  /** Total freight charge for the order in dollars */
  freightChargeRevenue: Scalars['Float']['output'];
  /** Total fuel charge for the order in dollars */
  fuelChargeRevenue: Scalars['Float']['output'];
  fulfillmentType?: Maybe<FulfillmentType>;
  hasDriverPod: Scalars['Boolean']['output'];
  hasDriverUploadedDocument: Scalars['Boolean']['output'];
  hasEdiCancellation: Scalars['Boolean']['output'];
  hasNoneOrCompletedInboundStop: Scalars['Boolean']['output'];
  hazmat?: Maybe<Scalars['Boolean']['output']>;
  hazmatClass?: Maybe<HazmatClass>;
  hazmatDescription?: Maybe<Scalars['String']['output']>;
  holdReason?: Maybe<HoldReasonEntity>;
  inBond?: Maybe<Scalars['Boolean']['output']>;
  inboundPaperwork: OrderPaperworkEntity;
  inboundShipment?: Maybe<ShipmentEntity>;
  invoice?: Maybe<InvoiceEntity>;
  isCollectOnDelivery?: Maybe<Scalars['Boolean']['output']>;
  isCrossDock?: Maybe<Scalars['Boolean']['output']>;
  /** Filters out draft and template orders */
  isDraftOrder: Scalars['Boolean']['output'];
  isOverdue: Scalars['Boolean']['output'];
  isReweighed?: Maybe<Scalars['Boolean']['output']>;
  issueReason?: Maybe<Scalars['String']['output']>;
  itTeNumber?: Maybe<Scalars['String']['output']>;
  lastCompletedLineHaulSegment?: Maybe<LineHaulSegmentEntity>;
  lastUpdatedByUser?: Maybe<UserEntity>;
  lineHaulCompletedDate: Scalars['DateTime']['output'];
  lineHaulLane?: Maybe<LineHaulLaneEntity>;
  lineHaulServiceDisplayString: Scalars['String']['output'];
  lineHaulShipment?: Maybe<ShipmentEntity>;
  /** The line haul events associated with an order, such as every stop at a terminal. This is the order’s own timeline, not an audit log of user actions or changes. */
  lineHaulTimeline: Array<OrderLineHaulTimelineEventEntity>;
  lockSecondaryRefNumber: Scalars['Boolean']['output'];
  /** @deprecated Use paperwork.missingDocuments instead */
  missingDocuments: Array<DocumentType>;
  name: Scalars['String']['output'];
  notes: Scalars['String']['output'];
  numPackagesOnHand: Scalars['Float']['output'];
  onHand?: Maybe<Scalars['Boolean']['output']>;
  onHold: Scalars['Boolean']['output'];
  orderChargesShipment?: Maybe<ShipmentEntity>;
  orderComments: Array<OrderCommentEntity>;
  orderConsolidationType: OrderConsolidationType;
  orderEvents: Array<OrderEventEntity>;
  orderInvoiceByDate?: Maybe<Scalars['DateTime']['output']>;
  orderPaymentMappings: Array<PaymentToOrderMappingEntity>;
  orderSegmentType: OrderSegmentType;
  /** Orders that were prorated with (but not including) this order */
  ordersProratedWith?: Maybe<Array<OrderEntity>>;
  ordersWithSameBillOfLadingNumber: Array<OrderEntity>;
  ordersWithSameBillOfLadingNumberForReviewOrders?: Maybe<Array<StandardOrderEntity>>;
  ordinal: Scalars['Int']['output'];
  osAndD: Scalars['Boolean']['output'];
  osd?: Maybe<Scalars['Boolean']['output']>;
  osdReason?: Maybe<Scalars['String']['output']>;
  outboundPaperwork: OrderPaperworkEntity;
  /** The scans out of the last terminal (if multi-terminal and line haul), or simply departure scans corresponding to outbound delivery */
  outboundScans: Array<ScanEntity>;
  outboundShipment?: Maybe<ShipmentEntity>;
  packageCount: Scalars['Float']['output'];
  packageGroup?: Maybe<PackageGroup>;
  packages: Array<PackageEntity>;
  paperwork: OrderPaperworkEntity;
  paymentMethod?: Maybe<PaymentMethod>;
  personEmail?: Maybe<Scalars['String']['output']>;
  personName?: Maybe<Scalars['String']['output']>;
  personPhoneNumber?: Maybe<Scalars['String']['output']>;
  pickedDate?: Maybe<Scalars['DateTime']['output']>;
  pieceCount?: Maybe<Scalars['Int']['output']>;
  pieceCountFromPackages: Scalars['Float']['output'];
  pieces: Array<PieceEntity>;
  piecesDelivered: PiecesDeliveredEntity;
  piecesLoaded?: Maybe<Scalars['Int']['output']>;
  piecesPicked?: Maybe<Scalars['Int']['output']>;
  postedAmountCents?: Maybe<Scalars['Int']['output']>;
  quaternaryRefNumber?: Maybe<Scalars['String']['output']>;
  quinaryRefNumber?: Maybe<Scalars['String']['output']>;
  quote?: Maybe<QuoteEntity>;
  receivedDate?: Maybe<Scalars['DateTime']['output']>;
  recurringOrderFrequency?: Maybe<RecurringOrderFrequencyEntity>;
  refNumbers: Array<Scalars['String']['output']>;
  refusedBy?: Maybe<Scalars['String']['output']>;
  refusedDate?: Maybe<Scalars['DateTime']['output']>;
  requiresPlacard?: Maybe<Scalars['Boolean']['output']>;
  run?: Maybe<RunEntity>;
  scannedOrderResult?: Maybe<ScannedOrderResultEntity>;
  /** A field that represents a concatenation of all fields on the order that we want to search by. */
  searchText?: Maybe<Scalars['String']['output']>;
  secondaryRefNumber?: Maybe<Scalars['String']['output']>;
  service?: Maybe<ServiceEntity>;
  shipments: Array<ShipmentEntity>;
  shouldBillIndividually: Scalars['Boolean']['output'];
  source: OrderSource;
  standardOrderFields: StandardOrderFieldsEntity;
  startStop?: Maybe<StopEntity>;
  status: OrderStatus;
  tags: Array<TagEntity>;
  tertiaryRefNumber?: Maybe<Scalars['String']['output']>;
  thirdPartyBrokers: Array<ThirdPartyBrokerEntity>;
  totalAmountCents?: Maybe<Scalars['Int']['output']>;
  /** The total charges for the order in dollars */
  totalCharge: Scalars['Float']['output'];
  totalCustomChargesAmount: Scalars['Float']['output'];
  totalFreightChargesAmount: Scalars['Float']['output'];
  totalFuelChargesAmount: Scalars['Float']['output'];
  totalSkids?: Maybe<Scalars['Int']['output']>;
  unNumber?: Maybe<Scalars['String']['output']>;
  upcomingLineHaulSegment?: Maybe<LineHaulSegmentEntity>;
  updatedAt: Scalars['DateTime']['output'];
  uuid: Scalars['String']['output'];
  vehicleType?: Maybe<VehicleTypeEntity>;
  warehouse?: Maybe<WarehouseEntity>;
  weight: Scalars['Float']['output'];
};

export type StandardOrderFieldsCreateInput = {
  defaultConsigneeStopCreateInput?: InputMaybe<StopCreateInput>;
  defaultShipperStopCreateInput?: InputMaybe<StopCreateInput>;
  dimFactor?: InputMaybe<Scalars['Int']['input']>;
  driversNeededInVehicle?: InputMaybe<Scalars['Int']['input']>;
  houseAirwayBillOfLadingNumber?: InputMaybe<Scalars['String']['input']>;
  lockShipperBillOfLadingNumber?: InputMaybe<Scalars['Boolean']['input']>;
  masterAirwayBillOfLadingNumber?: InputMaybe<Scalars['String']['input']>;
  measurementUnits?: InputMaybe<MeasurementUnits>;
  numberOfConsignees: NumberOfConsignees;
  numberOfShippers: NumberOfShippers;
  purchaseOrderNumber?: InputMaybe<Scalars['String']['input']>;
  shipperBillOfLadingNumber?: InputMaybe<Scalars['String']['input']>;
  weightUnits?: InputMaybe<WeightUnits>;
};

export type StandardOrderFieldsEntity = {
  __typename?: 'StandardOrderFieldsEntity';
  createdAt: Scalars['DateTime']['output'];
  defaultConsigneeStop?: Maybe<StandardStopEntity>;
  defaultShipperStop?: Maybe<StandardStopEntity>;
  dimFactor?: Maybe<Scalars['Int']['output']>;
  driversNeededInVehicle?: Maybe<Scalars['Int']['output']>;
  houseAirwayBillOfLadingNumber?: Maybe<Scalars['String']['output']>;
  lockShipperBillOfLadingNumber: Scalars['Boolean']['output'];
  masterAirwayBillOfLadingNumber?: Maybe<Scalars['String']['output']>;
  measurementUnits: MeasurementUnits;
  numberOfConsignees: NumberOfConsignees;
  numberOfShippers: NumberOfShippers;
  purchaseOrderNumber?: Maybe<Scalars['String']['output']>;
  shipperBillOfLadingNumber?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  uuid: Scalars['String']['output'];
  weightUnits: WeightUnits;
};

export type StandardOrderFieldsUpdateInput = {
  defaultConsigneeStopUpsertInput?: InputMaybe<StandardStopUpsertInput>;
  defaultShipperStopUpsertInput?: InputMaybe<StandardStopUpsertInput>;
  dimFactor?: InputMaybe<Scalars['Int']['input']>;
  driversNeededInVehicle?: InputMaybe<Scalars['Int']['input']>;
  houseAirwayBillOfLadingNumber?: InputMaybe<Scalars['String']['input']>;
  lockShipperBillOfLadingNumber?: InputMaybe<Scalars['Boolean']['input']>;
  masterAirwayBillOfLadingNumber?: InputMaybe<Scalars['String']['input']>;
  measurementUnits?: InputMaybe<MeasurementUnits>;
  numberOfConsignees?: InputMaybe<NumberOfConsignees>;
  numberOfShippers?: InputMaybe<NumberOfShippers>;
  purchaseOrderNumber?: InputMaybe<Scalars['String']['input']>;
  shipperBillOfLadingNumber?: InputMaybe<Scalars['String']['input']>;
  uuid: Scalars['String']['input'];
  weightUnits?: InputMaybe<WeightUnits>;
};

export type StandardOrderUpdateInput = {
  billingPartyContactStationId?: InputMaybe<Scalars['String']['input']>;
  billingPartyContactUuid?: InputMaybe<Scalars['String']['input']>;
  billingStatus?: InputMaybe<OrderBillingStatus>;
  callerName?: InputMaybe<Scalars['String']['input']>;
  callerPhoneNumber?: InputMaybe<Scalars['String']['input']>;
  chargeableWeightCubicMeters?: InputMaybe<Scalars['Volume']['input']>;
  codCheckAmountCents?: InputMaybe<Scalars['Int']['input']>;
  codCheckNumber?: InputMaybe<Scalars['String']['input']>;
  createdFromOrderTemplateUuid?: InputMaybe<Scalars['String']['input']>;
  dateMarkedReceivedAtOrigin?: InputMaybe<Scalars['DateTime']['input']>;
  deletedAutoAppliedAccessorialUuids?: InputMaybe<Array<Scalars['String']['input']>>;
  documentUpsertInputs?: InputMaybe<Array<DocumentUpsertInput>>;
  driverQualificationIds?: InputMaybe<Array<Scalars['String']['input']>>;
  emergencyResponseNumber?: InputMaybe<Scalars['String']['input']>;
  /** Enables line haul features for the order */
  enableLineHaul?: InputMaybe<Scalars['Boolean']['input']>;
  externalNotes?: InputMaybe<Scalars['String']['input']>;
  fulfillmentType?: InputMaybe<FulfillmentType>;
  hazmat?: InputMaybe<Scalars['Boolean']['input']>;
  hazmatClass?: InputMaybe<HazmatClass>;
  hazmatDescription?: InputMaybe<Scalars['String']['input']>;
  holdReasonUuid?: InputMaybe<Scalars['String']['input']>;
  inBond?: InputMaybe<Scalars['Boolean']['input']>;
  isCollectOnDelivery?: InputMaybe<Scalars['Boolean']['input']>;
  isCrossDock?: InputMaybe<Scalars['Boolean']['input']>;
  isDraftOrder?: InputMaybe<Scalars['Boolean']['input']>;
  isReweighed?: InputMaybe<Scalars['Boolean']['input']>;
  issueReason?: InputMaybe<Scalars['String']['input']>;
  itTeNumber?: InputMaybe<Scalars['String']['input']>;
  lineHaulLaneUuid?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  onHand?: InputMaybe<Scalars['Boolean']['input']>;
  orderCommentCreateInputs?: InputMaybe<Array<CreateOrderCommentInput>>;
  osd?: InputMaybe<Scalars['Boolean']['input']>;
  packageArrayUpdateInputs?: InputMaybe<Array<PackageArrayUpdateInput>>;
  packageGroup?: InputMaybe<PackageGroup>;
  paymentMethod?: InputMaybe<PaymentMethod>;
  personEmail?: InputMaybe<Scalars['String']['input']>;
  personName?: InputMaybe<Scalars['String']['input']>;
  personPhoneNumber?: InputMaybe<Scalars['String']['input']>;
  pickedDate?: InputMaybe<Scalars['DateTime']['input']>;
  pieceCount?: InputMaybe<Scalars['Int']['input']>;
  piecesPicked?: InputMaybe<Scalars['Int']['input']>;
  recalculateTotals?: InputMaybe<Scalars['Boolean']['input']>;
  receivedDate?: InputMaybe<Scalars['DateTime']['input']>;
  recurringOrderFrequencyUpdateInput?: InputMaybe<UpdateRecurringOrderFrequencyInput>;
  refNumbers?: InputMaybe<Array<Scalars['String']['input']>>;
  refusedBy?: InputMaybe<Scalars['String']['input']>;
  refusedDate?: InputMaybe<Scalars['DateTime']['input']>;
  requiresPlacard?: InputMaybe<Scalars['Boolean']['input']>;
  secondaryRefNumber?: InputMaybe<Scalars['String']['input']>;
  serviceUuid?: InputMaybe<Scalars['String']['input']>;
  shipmentArrayUpdateInputs?: InputMaybe<Array<StandardShipmentArrayUpdateInput>>;
  standardOrderFieldsUpdateInput?: InputMaybe<StandardOrderFieldsUpdateInput>;
  status?: InputMaybe<OrderStatus>;
  tagUuids?: InputMaybe<Array<Scalars['String']['input']>>;
  tertiaryRefNumber?: InputMaybe<Scalars['String']['input']>;
  thirdPartyBrokerUuids?: InputMaybe<Array<Scalars['String']['input']>>;
  /** The total charge in dollars */
  totalCharge?: InputMaybe<Scalars['Float']['input']>;
  totalSkids?: InputMaybe<Scalars['Int']['input']>;
  unNumber?: InputMaybe<Scalars['String']['input']>;
  uuid: Scalars['String']['input'];
  vehicleTypeUuid?: InputMaybe<Scalars['String']['input']>;
  warehouseUuid?: InputMaybe<Scalars['String']['input']>;
};

export type StandardShipmentArrayUpdateInput = {
  /** Pass this field in to create a new array item */
  shipmentCreateInput?: InputMaybe<StandardShipmentCreateInput>;
  /** Pass this field in to update an array item */
  shipmentUpdateInput?: InputMaybe<StandardShipmentUpdateInput>;
};

export type StandardShipmentCreateInput = {
  airline?: InputMaybe<Scalars['String']['input']>;
  airportInfoUuid?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  customChargeCreateInputs?: InputMaybe<Array<CustomChargeCreateInput>>;
  destinationAirport?: InputMaybe<Scalars['String']['input']>;
  documentConnectInputs?: InputMaybe<Array<DocumentConnectInput>>;
  documentCreateInputs?: InputMaybe<Array<DocumentCreateInput>>;
  freightChargeCreateInput?: InputMaybe<FreightChargeCreateInput>;
  hideFromBilling?: InputMaybe<Scalars['Boolean']['input']>;
  independentSettlementBillLineItemCreateInputs?: InputMaybe<Array<IndependentSettlementBillLineItemCreateInput>>;
  invoiceUuid?: InputMaybe<Scalars['String']['input']>;
  isSpecial?: InputMaybe<Scalars['Boolean']['input']>;
  legCreateInputs?: InputMaybe<Array<LegCreateInput>>;
  overridePackageWeight?: InputMaybe<Scalars['Boolean']['input']>;
  packageCreateInputs?: InputMaybe<Array<PackageCreateInput>>;
  shipmentSubscriberUpsertInputs?: InputMaybe<Array<ShipmentSubscriberUpsertInput>>;
  shipmentType?: InputMaybe<ShipmentType>;
  shipperAddressUpsertInput?: InputMaybe<AddressUpsertInput>;
  shouldUseDimWeight?: InputMaybe<Scalars['Boolean']['input']>;
  standardShipmentFieldsCreateInput?: InputMaybe<StandardShipmentFieldsCreateInput>;
  status?: InputMaybe<ShipmentStatusWithoutBilling>;
  /** The total charge in dollars */
  totalCharge?: InputMaybe<Scalars['Float']['input']>;
  uuid?: InputMaybe<Scalars['String']['input']>;
};

export type StandardShipmentEntity = ShipmentEntity & {
  __typename?: 'StandardShipmentEntity';
  airline?: Maybe<Scalars['String']['output']>;
  airportInfo?: Maybe<AirportInfoEntity>;
  billingShipmentStatus?: Maybe<BillingShipmentStatus>;
  charges: Array<ChargesUnion>;
  consigneeAddress?: Maybe<AddressEntity>;
  consolidatableShipment?: Maybe<ShipmentEntity>;
  consolidatableShipments?: Maybe<Array<ShipmentEntity>>;
  customCharges: Array<CustomChargeEntity>;
  dateAddedToInvoice?: Maybe<Scalars['DateTime']['output']>;
  dateMarkedFinalized?: Maybe<Scalars['DateTime']['output']>;
  dateMarkedOfd?: Maybe<Scalars['DateTime']['output']>;
  destinationAirport?: Maybe<Scalars['String']['output']>;
  documents: Array<DocumentEntity>;
  failureCount: Scalars['Float']['output'];
  fields?: Maybe<StandardShipmentFieldsEntity>;
  freightCharge?: Maybe<FreightChargeEntity>;
  hasBillingIssues?: Maybe<Scalars['DateTime']['output']>;
  hasFailedStop: Scalars['Boolean']['output'];
  hasSignedPOD: Scalars['Boolean']['output'];
  hideFromBilling: Scalars['Boolean']['output'];
  independentSettlementBillLineItems: Array<SettlementBillLineItemEntity>;
  inputForConsolidatedOrder?: Maybe<OrderEntity>;
  invoice?: Maybe<InvoiceEntity>;
  legs: Array<LegEntity>;
  name: Scalars['String']['output'];
  order?: Maybe<OrderEntity>;
  ordinal: Scalars['Float']['output'];
  overridePackageWeight: Scalars['Boolean']['output'];
  packages: Array<PackageEntity>;
  postedAmountCents?: Maybe<Scalars['Int']['output']>;
  settlementBillLineItems: Array<SettlementBillLineItemEntity>;
  /** The shipment total charge, freight charge total, fuel charge total, and custom charge total in dollars */
  shipmentCharges: ShipmentChargeEntity;
  shipmentConsolidationType: ShipmentConsolidationType;
  shipmentSubscribers: Array<ShipmentSubscriberEntity>;
  shipmentType: ShipmentType;
  shipperAddress?: Maybe<AddressEntity>;
  shouldBillIndividually: Scalars['Boolean']['output'];
  shouldUseDimWeight: Scalars['Boolean']['output'];
  standardShipmentFields: StandardShipmentFieldsEntity;
  status: ShipmentStatus;
  totalAmountCents?: Maybe<Scalars['Int']['output']>;
  /** The total charges for the shipment in dollars */
  totalChargesAmount: Scalars['Float']['output'];
  totalChargesForDriverSettlement: Scalars['Float']['output'];
  totalCustomChargesAmount: Scalars['Float']['output'];
  totalFreightChargesAmount: Scalars['Float']['output'];
  totalFuelChargesAmount: Scalars['Float']['output'];
  uuid: Scalars['String']['output'];
};

export type StandardShipmentFieldsCreateInput = {
  cargoDescription?: InputMaybe<Scalars['String']['input']>;
  cargoPieces?: InputMaybe<Scalars['Int']['input']>;
  deadlineDate?: InputMaybe<Scalars['DateTime']['input']>;
  deadlineType?: InputMaybe<DeadlineType>;
  deliveryDate?: InputMaybe<Scalars['DateTime']['input']>;
  dimFactor?: InputMaybe<Scalars['Int']['input']>;
  expectedInboundArrivalDate?: InputMaybe<Scalars['DateTime']['input']>;
  inboundMethod?: InputMaybe<InboundMethod>;
  measurementUnits?: InputMaybe<MeasurementUnits>;
  outboundMethod?: InputMaybe<OutboundMethod>;
  pickupOrDelivery: PickupOrDelivery;
  serviceUuid?: InputMaybe<Scalars['String']['input']>;
  type: StandardShipmentType;
  weightUnits?: InputMaybe<WeightUnits>;
};

export type StandardShipmentFieldsEntity = {
  __typename?: 'StandardShipmentFieldsEntity';
  cargoDescription?: Maybe<Scalars['String']['output']>;
  cargoPieces?: Maybe<Scalars['Int']['output']>;
  createdAt: Scalars['DateTime']['output'];
  deadlineDate?: Maybe<Scalars['DateTime']['output']>;
  deadlineType?: Maybe<DeadlineType>;
  deliveryDate?: Maybe<Scalars['DateTime']['output']>;
  dimFactor: Scalars['Int']['output'];
  expectedInboundArrivalDate?: Maybe<Scalars['DateTime']['output']>;
  inboundMethod?: Maybe<InboundMethod>;
  measurementUnits: MeasurementUnits;
  outboundMethod?: Maybe<OutboundMethod>;
  pickupOrDelivery: PickupOrDelivery;
  service?: Maybe<ServiceEntity>;
  serviceLevel?: Maybe<ServiceLevel>;
  type: StandardShipmentType;
  updatedAt: Scalars['DateTime']['output'];
  uuid: Scalars['String']['output'];
  weight: Scalars['Float']['output'];
  weightUnits: WeightUnits;
};

export type StandardShipmentFieldsUpdateInput = {
  cargoDescription?: InputMaybe<Scalars['String']['input']>;
  cargoPieces?: InputMaybe<Scalars['Int']['input']>;
  deadlineDate?: InputMaybe<Scalars['DateTime']['input']>;
  deadlineType?: InputMaybe<DeadlineType>;
  deliveryDate?: InputMaybe<Scalars['DateTime']['input']>;
  dimFactor?: InputMaybe<Scalars['Int']['input']>;
  expectedInboundArrivalDate?: InputMaybe<Scalars['DateTime']['input']>;
  inboundMethod?: InputMaybe<InboundMethod>;
  isSpecial?: InputMaybe<Scalars['Boolean']['input']>;
  measurementUnits?: InputMaybe<MeasurementUnits>;
  name?: InputMaybe<Scalars['String']['input']>;
  outboundMethod?: InputMaybe<OutboundMethod>;
  pickupOrDelivery?: InputMaybe<PickupOrDelivery>;
  serviceUuid?: InputMaybe<Scalars['String']['input']>;
  standardShipmentFieldsCreateInput?: InputMaybe<StandardShipmentFieldsCreateInput>;
  type?: InputMaybe<StandardShipmentType>;
  uuid: Scalars['String']['input'];
  weightUnits?: InputMaybe<WeightUnits>;
};

export enum StandardShipmentType {
  SingleStop = 'SINGLE_STOP'
}

export type StandardShipmentUpdateInput = {
  airline?: InputMaybe<Scalars['String']['input']>;
  airportInfoUuid?: InputMaybe<Scalars['String']['input']>;
  customChargeArrayUpdateInputs?: InputMaybe<Array<CustomChargeArrayUpdateInput>>;
  destinationAirport?: InputMaybe<Scalars['String']['input']>;
  freightChargeUpsertInput?: InputMaybe<FreightChargeUpsertInput>;
  hideFromBilling?: InputMaybe<Scalars['Boolean']['input']>;
  independentSettlementBillLineItemUpsertInputs?: InputMaybe<Array<IndependentSettlementBillLineItemUpsertInput>>;
  isSpecial?: InputMaybe<Scalars['Boolean']['input']>;
  legUpdateInput?: InputMaybe<LegUpdateInput>;
  legUpsertInputs?: InputMaybe<Array<LegUpsertInput>>;
  overridePackageWeight?: InputMaybe<Scalars['Boolean']['input']>;
  packageArrayUpdateInputs?: InputMaybe<Array<PackageArrayUpdateInput>>;
  shipperAddressUpsertInput?: InputMaybe<AddressUpsertInput>;
  shouldUseDimWeight?: InputMaybe<Scalars['Boolean']['input']>;
  standardShipmentFieldsUpdateInput?: InputMaybe<StandardShipmentFieldsUpdateInput>;
  status?: InputMaybe<ShipmentStatusWithoutBilling>;
  /** The total charge in dollars */
  totalCharge?: InputMaybe<Scalars['Float']['input']>;
  uuid: Scalars['String']['input'];
};

export type StandardStopEntity = StopEntity & {
  __typename?: 'StandardStopEntity';
  address: AddressEntity;
  appointmentCallStatus?: Maybe<AppointmentCallStatus>;
  appointmentManuallyConfirmed?: Maybe<Scalars['Boolean']['output']>;
  appointmentRequired: Scalars['Boolean']['output'];
  appointmentSchedulingOptionsCalledAt?: Maybe<Scalars['DateTime']['output']>;
  appointmentSchedulingOptionsTextedAt?: Maybe<Scalars['DateTime']['output']>;
  appointmentTextStatus?: Maybe<AppointmentTextStatus>;
  appointmentTime?: Maybe<Scalars['DateTime']['output']>;
  arrivedAt?: Maybe<Scalars['DateTime']['output']>;
  cachedEta?: Maybe<EtaEntity>;
  canMarkAttemptComplete?: Maybe<Scalars['Boolean']['output']>;
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  confirmedByAgentAt?: Maybe<Scalars['DateTime']['output']>;
  consigneeAddress?: Maybe<AddressEntity>;
  consigneeContactPerson?: Maybe<ContactPersonEntity>;
  contactPerson?: Maybe<ContactPersonEntity>;
  courierReadyOrDueDate?: Maybe<Scalars['DateTime']['output']>;
  createdAt: Scalars['DateTime']['output'];
  deadlineTime?: Maybe<Scalars['DateTime']['output']>;
  destinationAirport?: Maybe<Scalars['String']['output']>;
  driverCompletedAt?: Maybe<Scalars['DateTime']['output']>;
  endAppointmentTime?: Maybe<Scalars['DateTime']['output']>;
  equipment?: Maybe<EquipmentEntity>;
  eta?: Maybe<EtaEntity>;
  etaArrivalTime?: Maybe<Scalars['DateTime']['output']>;
  etaFinishTime?: Maybe<Scalars['DateTime']['output']>;
  etaLastUpdated?: Maybe<Scalars['DateTime']['output']>;
  expectedInboundArrivalDate?: Maybe<Scalars['DateTime']['output']>;
  expectedOutboundDate?: Maybe<Scalars['DateTime']['output']>;
  failureCount?: Maybe<Scalars['Float']['output']>;
  formattedCallMessage?: Maybe<Scalars['String']['output']>;
  /** returns if a stop has a previous attempt */
  hasPreviousAttempt: Scalars['Boolean']['output'];
  hideFromDispatch?: Maybe<Scalars['Boolean']['output']>;
  inboundDeadlineDate?: Maybe<Scalars['DateTime']['output']>;
  inboundMethod?: Maybe<InboundMethod>;
  incomingCarrier?: Maybe<Scalars['String']['output']>;
  /** returns if a stop is an attempt */
  isAttempt: Scalars['Boolean']['output'];
  isScheduled: Scalars['Boolean']['output'];
  isSpecial?: Maybe<Scalars['Boolean']['output']>;
  lastAppointmentTextTime?: Maybe<Scalars['DateTime']['output']>;
  leg: LegEntity;
  linkedEndStop?: Maybe<StopEntity>;
  /** The local time zone of the stop, based on the address. Defaults to company time zone. */
  localTimeZone?: Maybe<Scalars['String']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  outboundCarrier?: Maybe<Scalars['String']['output']>;
  outboundDeadlineDate?: Maybe<Scalars['DateTime']['output']>;
  outboundMethod?: Maybe<OutboundMethod>;
  overrideServiceTimeInMinutes?: Maybe<Scalars['Float']['output']>;
  paperworkMarkedComplete?: Maybe<Scalars['Boolean']['output']>;
  pickupOrDelivery: StopPickupOrDelivery;
  postedAmountUsdCents?: Maybe<Scalars['Int']['output']>;
  proofOfDeliverySignee?: Maybe<Scalars['String']['output']>;
  routeChangeAcknowledged: Scalars['Boolean']['output'];
  routeName?: Maybe<RouteNameEntity>;
  routeSlot?: Maybe<RouteSlotEntity>;
  sentToAgentAt?: Maybe<Scalars['DateTime']['output']>;
  serviceDate?: Maybe<Scalars['DateTime']['output']>;
  /** The service date of the stop as a PlainDate. See https://www.notion.so/Service-Date-dc8ae149b6a54bb69404aecf92176287 for details. */
  serviceDateV2?: Maybe<PlainDate>;
  settlementDeductionFlatRate?: Maybe<Scalars['Float']['output']>;
  settlementDeductionName?: Maybe<Scalars['String']['output']>;
  settlementDeductionPercentageRate?: Maybe<Scalars['Float']['output']>;
  shipment?: Maybe<ShipmentEntity>;
  /** shipment consignee address- the address for the endStop of the last leg in the shipment that this stop's leg belongs to */
  shipmentConsigneeAddress: AddressEntity;
  /** Total volume of all packages associated with this stop's shipment */
  shipmentTotalVolume: Scalars['Float']['output'];
  /** Total weight of all packages associated with this stop's shipment */
  shipmentTotalWeight: Scalars['Float']['output'];
  shipperAddress?: Maybe<AddressEntity>;
  shipperContactPerson?: Maybe<ContactPersonEntity>;
  showDriverModifiedAt?: Maybe<Scalars['DateTime']['output']>;
  snapshottedAmountUsdCents?: Maybe<Scalars['Int']['output']>;
  specialInstructions?: Maybe<Scalars['String']['output']>;
  standardStopType?: Maybe<StandardStopType>;
  startOrEnd: StartOrEnd;
  status: StopStatus;
  stopDetails?: Maybe<StopDetailsOutput>;
  stopDriverMaps: Array<StopDriverMapEntity>;
  stopType?: Maybe<StopType>;
  terminal?: Maybe<TerminalEntity>;
  textResponses?: Maybe<Scalars['String']['output']>;
  transferAddress?: Maybe<AddressEntity>;
  twilioCallSid?: Maybe<Scalars['String']['output']>;
  twilioTextSid?: Maybe<Scalars['String']['output']>;
  /** Convenience field, not strongly typed. Recommended for display only, use the other fields if you need to do something programmatically with it */
  type?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  uuid: Scalars['String']['output'];
};

export enum StandardStopType {
  Commercial = 'COMMERCIAL',
  Dummy = 'DUMMY',
  Residential = 'RESIDENTIAL'
}

/** A filter object that is used to filter the standard stop type enum field. Each field in the filter object represents an operator. If there is more than one non-null field passed into the filter object, the condition will be a conjunction of the non-null field operator */
export type StandardStopTypeFilter = {
  /** Filters for records where the relevant standard stop type field is equal to the provided standard stop type value */
  eq?: InputMaybe<StandardStopType>;
  /** Filters for records where the relevant standard stop type field is in the provided standard stop type values */
  in?: InputMaybe<Array<StandardStopType>>;
  /** Filters for records where the relevant standard stop type field is not equal to the provided standard stop type value */
  neq?: InputMaybe<StandardStopType>;
  /** Filters for records where the relevant standard stop type field is not in the provided standard stop type values */
  nin?: InputMaybe<Array<StandardStopType>>;
};

export type StandardStopUpsertInput = {
  addressUpsertInput: AddressUpsertInput;
  appointmentCallStatus?: InputMaybe<AppointmentCallStatus>;
  appointmentManuallyConfirmed?: InputMaybe<Scalars['Boolean']['input']>;
  appointmentRequired?: InputMaybe<Scalars['Boolean']['input']>;
  appointmentSchedulingOptionsCalledAt?: InputMaybe<Scalars['DateTime']['input']>;
  appointmentSchedulingOptionsTextedAt?: InputMaybe<Scalars['DateTime']['input']>;
  appointmentTextStatus?: InputMaybe<AppointmentTextStatus>;
  appointmentTime?: InputMaybe<Scalars['DateTime']['input']>;
  arrivedAt?: InputMaybe<Scalars['DateTime']['input']>;
  completedAt?: InputMaybe<Scalars['DateTime']['input']>;
  confirmedByAgentAt?: InputMaybe<Scalars['DateTime']['input']>;
  contactPersonUpsertInput?: InputMaybe<ContactPersonUpsertInput>;
  contactPersonUpsertInputs?: InputMaybe<Array<ContactPersonUpsertInput>>;
  courierReadyOrDueDate?: InputMaybe<Scalars['DateTime']['input']>;
  deadlineTime?: InputMaybe<Scalars['DateTime']['input']>;
  destinationAirport?: InputMaybe<Scalars['String']['input']>;
  driverCompletedAt?: InputMaybe<Scalars['DateTime']['input']>;
  driverUuid?: InputMaybe<Scalars['String']['input']>;
  endAppointmentTime?: InputMaybe<Scalars['DateTime']['input']>;
  equipmentUuid?: InputMaybe<Scalars['String']['input']>;
  expectedInboundArrivalDate?: InputMaybe<Scalars['DateTime']['input']>;
  expectedOutboundDate?: InputMaybe<Scalars['DateTime']['input']>;
  hideFromDispatch?: InputMaybe<Scalars['Boolean']['input']>;
  inboundDeadlineDate?: InputMaybe<Scalars['DateTime']['input']>;
  inboundMethod?: InputMaybe<InboundMethod>;
  incomingCarrier?: InputMaybe<Scalars['String']['input']>;
  isSpecial?: InputMaybe<Scalars['Boolean']['input']>;
  lastAppointmentTextTime?: InputMaybe<Scalars['DateTime']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  outboundCarrier?: InputMaybe<Scalars['String']['input']>;
  outboundDeadlineDate?: InputMaybe<Scalars['DateTime']['input']>;
  outboundMethod?: InputMaybe<OutboundMethod>;
  overrideServiceTimeInMinutes?: InputMaybe<Scalars['Float']['input']>;
  paperworkMarkedComplete?: InputMaybe<Scalars['Boolean']['input']>;
  proofOfDeliverySignee?: InputMaybe<Scalars['String']['input']>;
  removedDriver?: InputMaybe<Scalars['Boolean']['input']>;
  routeSlotUuid?: InputMaybe<Scalars['String']['input']>;
  sentToAgentAt?: InputMaybe<Scalars['DateTime']['input']>;
  serviceDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** The service date in ISO 8601 date format. If null or unspecified, the stop's service date will not be updated. See https://www.notion.so/Service-Date-dc8ae149b6a54bb69404aecf92176287?pvs=4. */
  serviceDateIso8601?: InputMaybe<Scalars['String']['input']>;
  settlementDeductionFlatRate?: InputMaybe<Scalars['Float']['input']>;
  settlementDeductionName?: InputMaybe<Scalars['String']['input']>;
  settlementDeductionPercentageRate?: InputMaybe<Scalars['Float']['input']>;
  specialInstructions?: InputMaybe<Scalars['String']['input']>;
  standardStopType?: InputMaybe<StandardStopType>;
  status?: InputMaybe<StopStatus>;
  stopType?: InputMaybe<StopType>;
  terminalUuid?: InputMaybe<Scalars['String']['input']>;
  textResponses?: InputMaybe<Scalars['String']['input']>;
  transferAddressUpsertInput?: InputMaybe<AddressUpsertInput>;
  twilioCallSid?: InputMaybe<Scalars['String']['input']>;
  twilioTextSid?: InputMaybe<Scalars['String']['input']>;
  upsertStopDriverMapInputs?: InputMaybe<Array<UpsertStopDriverMapInput>>;
  uuid: Scalars['String']['input'];
};

export enum StartOrEnd {
  End = 'END',
  Start = 'START'
}

export type StationReportArgs = {
  businessDivisionUuid?: InputMaybe<Scalars['String']['input']>;
  contactUuid: Scalars['String']['input'];
  driverUuid?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  excludeMigratedOrders?: InputMaybe<Scalars['Boolean']['input']>;
  lastNumberOfDays?: InputMaybe<Scalars['Float']['input']>;
  lastNumberOfMonths?: InputMaybe<Scalars['Float']['input']>;
  lastNumberOfWeeks?: InputMaybe<Scalars['Float']['input']>;
  orderStatuses: Array<OrderStatus>;
  reportRevenueType?: InputMaybe<ReportRevenueType>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  stopTypes: Array<PickupOrDelivery>;
  terminalUuid?: InputMaybe<Scalars['String']['input']>;
};

export type StationReportBucketEntity = {
  __typename?: 'StationReportBucketEntity';
  customChargeRevenue: Scalars['Float']['output'];
  deliveryRevenue: Scalars['Float']['output'];
  endDate: Scalars['DateTime']['output'];
  freightRevenue: Scalars['Float']['output'];
  fuelRevenue: Scalars['Float']['output'];
  lineHaulRevenue: Scalars['Float']['output'];
  numberOfOrders: Scalars['Float']['output'];
  numberOfPackages: Scalars['Float']['output'];
  pickupRevenue: Scalars['Float']['output'];
  recoveryRevenue: Scalars['Float']['output'];
  specialRevenue: Scalars['Float']['output'];
  startDate: Scalars['DateTime']['output'];
  stationId?: Maybe<Scalars['String']['output']>;
  stationName?: Maybe<Scalars['String']['output']>;
  surchargeRevenue: Scalars['Float']['output'];
  totalRevenue: Scalars['Float']['output'];
  totalWeight: Scalars['Float']['output'];
  transferRevenue: Scalars['Float']['output'];
};

export type StatusFilter = {
  filterType: OrderStatusFilterType;
  status: OrderStatus;
};

export enum StopAction {
  MarkAttempted = 'MARK_ATTEMPTED',
  MarkComplete = 'MARK_COMPLETE',
  MarkIncomplete = 'MARK_INCOMPLETE'
}

export type StopCreateInput = {
  addressUpsertInput: AddressUpsertInput;
  appointmentCallStatus?: InputMaybe<AppointmentCallStatus>;
  appointmentManuallyConfirmed?: InputMaybe<Scalars['Boolean']['input']>;
  appointmentRequired?: InputMaybe<Scalars['Boolean']['input']>;
  appointmentSchedulingOptionsCalledAt?: InputMaybe<Scalars['DateTime']['input']>;
  appointmentSchedulingOptionsTextedAt?: InputMaybe<Scalars['DateTime']['input']>;
  appointmentTextStatus?: InputMaybe<AppointmentTextStatus>;
  appointmentTime?: InputMaybe<Scalars['DateTime']['input']>;
  completedAt?: InputMaybe<Scalars['DateTime']['input']>;
  confirmedByAgentAt?: InputMaybe<Scalars['DateTime']['input']>;
  consigneeAddressUpsertInput?: InputMaybe<AddressUpsertInput>;
  consigneeContactPersonUpsertInput?: InputMaybe<ContactPersonUpdateInput>;
  contactPersonUpsertInput?: InputMaybe<ContactPersonUpdateInput>;
  contactPersonUpsertInputs?: InputMaybe<Array<ContactPersonUpsertInput>>;
  deadlineTime?: InputMaybe<Scalars['DateTime']['input']>;
  destinationAirport?: InputMaybe<Scalars['String']['input']>;
  driverCompletedAt?: InputMaybe<Scalars['DateTime']['input']>;
  driverUuid?: InputMaybe<Scalars['String']['input']>;
  endAppointmentTime?: InputMaybe<Scalars['DateTime']['input']>;
  expectedInboundArrivalDate?: InputMaybe<Scalars['DateTime']['input']>;
  expectedOutboundDate?: InputMaybe<Scalars['DateTime']['input']>;
  failureCount?: InputMaybe<Scalars['Float']['input']>;
  hideFromDispatch?: InputMaybe<Scalars['Boolean']['input']>;
  inboundDeadlineDate?: InputMaybe<Scalars['DateTime']['input']>;
  inboundMethod?: InputMaybe<InboundMethod>;
  incomingCarrier?: InputMaybe<Scalars['String']['input']>;
  isSpecial?: InputMaybe<Scalars['Boolean']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  outboundCarrier?: InputMaybe<Scalars['String']['input']>;
  outboundDeadlineDate?: InputMaybe<Scalars['DateTime']['input']>;
  outboundMethod?: InputMaybe<OutboundMethod>;
  overrideServiceTimeInMinutes?: InputMaybe<Scalars['Float']['input']>;
  paperworkMarkedComplete?: InputMaybe<Scalars['Boolean']['input']>;
  podSignee?: InputMaybe<Scalars['String']['input']>;
  proofOfDeliverySignee?: InputMaybe<Scalars['String']['input']>;
  removedDriver?: InputMaybe<Scalars['Boolean']['input']>;
  sentToAgentAt?: InputMaybe<Scalars['DateTime']['input']>;
  serviceDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** The service date in ISO 8601 date format. If null or unspecified, the stop's service date will not be updated. See https://www.notion.so/Service-Date-dc8ae149b6a54bb69404aecf92176287?pvs=4 for details. */
  serviceDateIso8601?: InputMaybe<Scalars['String']['input']>;
  shipperAddressUpsertInput?: InputMaybe<AddressUpsertInput>;
  shipperContactPersonUpsertInput?: InputMaybe<ContactPersonUpdateInput>;
  specialInstructions?: InputMaybe<Scalars['String']['input']>;
  standardStopType?: InputMaybe<StandardStopType>;
  status?: InputMaybe<StopStatus>;
  stopType?: InputMaybe<StopType>;
  terminalUuid?: InputMaybe<Scalars['String']['input']>;
  textResponses?: InputMaybe<Scalars['String']['input']>;
  transferAddressUpsertInput?: InputMaybe<AddressUpsertInput>;
  twilioCallSid?: InputMaybe<Scalars['String']['input']>;
  twilioTextSid?: InputMaybe<Scalars['String']['input']>;
  upsertStopDriverMapInputs?: InputMaybe<Array<UpsertStopDriverMapInput>>;
  uuid?: InputMaybe<Scalars['String']['input']>;
};

export type StopDetailsOutput = {
  __typename?: 'StopDetailsOutput';
  message?: Maybe<Scalars['String']['output']>;
  stopDetailsStatus: StopDetailsStatus;
};

export enum StopDetailsStatus {
  AwaitingAgentConfirmation = 'AWAITING_AGENT_CONFIRMATION',
  AwaitingSendToAgent = 'AWAITING_SEND_TO_AGENT',
  InboundRequired = 'INBOUND_REQUIRED',
  OnHand = 'ON_HAND',
  OnRoute = 'ON_ROUTE'
}

export type StopDriverMapAddressForDownloadEntity = {
  __typename?: 'StopDriverMapAddressForDownloadEntity';
  city: Scalars['String']['output'];
  country: Scalars['String']['output'];
  line1: Scalars['String']['output'];
  line2?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  state: Scalars['String']['output'];
  zip: Scalars['String']['output'];
};

export type StopDriverMapConnection = {
  __typename?: 'StopDriverMapConnection';
  edges: Array<StopDriverMapEdge>;
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type StopDriverMapEdge = {
  __typename?: 'StopDriverMapEdge';
  cursor: Scalars['String']['output'];
  node: StopDriverMapEntity;
};

export type StopDriverMapEntity = {
  __typename?: 'StopDriverMapEntity';
  driver: DriverEntity;
  driverPayoutFinalized: Scalars['Boolean']['output'];
  driverSettlementBill?: Maybe<DriverSettlementBillEntity>;
  driverSettlementTotalAmounts: DriverSettlementTotalAmountsOutput;
  enableDriverSettlement?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  revenueFlatRate?: Maybe<Scalars['Float']['output']>;
  revenuePercentageRate?: Maybe<Scalars['Float']['output']>;
  stop: StopEntity;
  totalChargesForSettlement?: Maybe<Scalars['Float']['output']>;
  totalDriverPayoutForStop?: Maybe<Scalars['Float']['output']>;
  totalEligibleAmountForStop?: Maybe<Scalars['Float']['output']>;
  uuid: Scalars['String']['output'];
};

export type StopDriverMapForCompletedStopsEntity = {
  __typename?: 'StopDriverMapForCompletedStopsEntity';
  arrivedAt?: Maybe<Scalars['DateTime']['output']>;
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  driver: DriverEntity;
  isLineHaul?: Maybe<Scalars['Boolean']['output']>;
  linehaulEndTerminal?: Maybe<TerminalEntity>;
  linehaulStartTerminal?: Maybe<TerminalEntity>;
  order?: Maybe<OrderEntity>;
  serviceDate?: Maybe<Scalars['DateTime']['output']>;
  serviceDateV2?: Maybe<PlainDate>;
  shipperBillOfLadingNumber?: Maybe<Scalars['String']['output']>;
  stopType?: Maybe<StopType>;
  stopUuid?: Maybe<Scalars['String']['output']>;
};

export type StopDriverMapForDownloadEntity = {
  __typename?: 'StopDriverMapForDownloadEntity';
  address?: Maybe<StopDriverMapAddressForDownloadEntity>;
  arrivedAt?: Maybe<Scalars['DateTime']['output']>;
  billingPartyContactName?: Maybe<Scalars['String']['output']>;
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  driverSettlementTotalAmounts: DriverSettlementTotalAmountsOutput;
  isAttempt: Scalars['Boolean']['output'];
  order?: Maybe<OrderEntity>;
  orderName?: Maybe<Scalars['String']['output']>;
  otherDriversOnStop: Array<StopDriverMapOtherDriverForDownloadEntity>;
  packages: Array<PackageEntity>;
  serviceName?: Maybe<Scalars['String']['output']>;
  shipperBillOfLadingNumber?: Maybe<Scalars['String']['output']>;
  stopType?: Maybe<StopType>;
  stopUuid: Scalars['String']['output'];
};

export type StopDriverMapOtherDriverForDownloadEntity = {
  __typename?: 'StopDriverMapOtherDriverForDownloadEntity';
  firstName: Scalars['String']['output'];
  lastName: Scalars['String']['output'];
  name: Scalars['String']['output'];
  uuid: Scalars['String']['output'];
};

export type StopDriverMapUpdateInput = {
  driverPayoutFinalized?: InputMaybe<Scalars['Boolean']['input']>;
  driverSettlementBillUuid?: InputMaybe<Scalars['String']['input']>;
  driverUuid?: InputMaybe<Scalars['String']['input']>;
  enableDriverSettlement?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  stopUuid?: InputMaybe<Scalars['String']['input']>;
  uuid: Scalars['String']['input'];
};

export type StopDriverMapUpsertInput = {
  driverPayoutFinalized?: InputMaybe<Scalars['Boolean']['input']>;
  driverSettlementBillUuid?: InputMaybe<Scalars['String']['input']>;
  driverUuid: Scalars['String']['input'];
  enableDriverSettlement?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  revenueFlatRate?: InputMaybe<Scalars['Float']['input']>;
  revenuePercentageRate?: InputMaybe<Scalars['Float']['input']>;
  stopUuid: Scalars['String']['input'];
  uuid: Scalars['String']['input'];
};

export type StopEntity = {
  address: AddressEntity;
  appointmentCallStatus?: Maybe<AppointmentCallStatus>;
  appointmentManuallyConfirmed?: Maybe<Scalars['Boolean']['output']>;
  appointmentRequired: Scalars['Boolean']['output'];
  appointmentSchedulingOptionsCalledAt?: Maybe<Scalars['DateTime']['output']>;
  appointmentSchedulingOptionsTextedAt?: Maybe<Scalars['DateTime']['output']>;
  appointmentTextStatus?: Maybe<AppointmentTextStatus>;
  appointmentTime?: Maybe<Scalars['DateTime']['output']>;
  arrivedAt?: Maybe<Scalars['DateTime']['output']>;
  cachedEta?: Maybe<EtaEntity>;
  canMarkAttemptComplete?: Maybe<Scalars['Boolean']['output']>;
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  confirmedByAgentAt?: Maybe<Scalars['DateTime']['output']>;
  consigneeAddress?: Maybe<AddressEntity>;
  consigneeContactPerson?: Maybe<ContactPersonEntity>;
  contactPerson?: Maybe<ContactPersonEntity>;
  courierReadyOrDueDate?: Maybe<Scalars['DateTime']['output']>;
  createdAt: Scalars['DateTime']['output'];
  deadlineTime?: Maybe<Scalars['DateTime']['output']>;
  destinationAirport?: Maybe<Scalars['String']['output']>;
  driverCompletedAt?: Maybe<Scalars['DateTime']['output']>;
  endAppointmentTime?: Maybe<Scalars['DateTime']['output']>;
  equipment?: Maybe<EquipmentEntity>;
  eta?: Maybe<EtaEntity>;
  etaArrivalTime?: Maybe<Scalars['DateTime']['output']>;
  etaFinishTime?: Maybe<Scalars['DateTime']['output']>;
  etaLastUpdated?: Maybe<Scalars['DateTime']['output']>;
  expectedInboundArrivalDate?: Maybe<Scalars['DateTime']['output']>;
  expectedOutboundDate?: Maybe<Scalars['DateTime']['output']>;
  failureCount?: Maybe<Scalars['Float']['output']>;
  formattedCallMessage?: Maybe<Scalars['String']['output']>;
  /** returns if a stop has a previous attempt */
  hasPreviousAttempt: Scalars['Boolean']['output'];
  hideFromDispatch?: Maybe<Scalars['Boolean']['output']>;
  inboundDeadlineDate?: Maybe<Scalars['DateTime']['output']>;
  inboundMethod?: Maybe<InboundMethod>;
  incomingCarrier?: Maybe<Scalars['String']['output']>;
  /** returns if a stop is an attempt */
  isAttempt: Scalars['Boolean']['output'];
  isScheduled: Scalars['Boolean']['output'];
  isSpecial?: Maybe<Scalars['Boolean']['output']>;
  lastAppointmentTextTime?: Maybe<Scalars['DateTime']['output']>;
  leg: LegEntity;
  linkedEndStop?: Maybe<StopEntity>;
  /** The local time zone of the stop, based on the address. Defaults to company time zone. */
  localTimeZone?: Maybe<Scalars['String']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  outboundCarrier?: Maybe<Scalars['String']['output']>;
  outboundDeadlineDate?: Maybe<Scalars['DateTime']['output']>;
  outboundMethod?: Maybe<OutboundMethod>;
  overrideServiceTimeInMinutes?: Maybe<Scalars['Float']['output']>;
  paperworkMarkedComplete?: Maybe<Scalars['Boolean']['output']>;
  pickupOrDelivery: StopPickupOrDelivery;
  postedAmountUsdCents?: Maybe<Scalars['Int']['output']>;
  proofOfDeliverySignee?: Maybe<Scalars['String']['output']>;
  routeChangeAcknowledged: Scalars['Boolean']['output'];
  routeName?: Maybe<RouteNameEntity>;
  routeSlot?: Maybe<RouteSlotEntity>;
  sentToAgentAt?: Maybe<Scalars['DateTime']['output']>;
  serviceDate?: Maybe<Scalars['DateTime']['output']>;
  /** The service date of the stop as a PlainDate. See https://www.notion.so/Service-Date-dc8ae149b6a54bb69404aecf92176287 for details. */
  serviceDateV2?: Maybe<PlainDate>;
  settlementDeductionFlatRate?: Maybe<Scalars['Float']['output']>;
  settlementDeductionName?: Maybe<Scalars['String']['output']>;
  settlementDeductionPercentageRate?: Maybe<Scalars['Float']['output']>;
  shipment?: Maybe<ShipmentEntity>;
  /** shipment consignee address- the address for the endStop of the last leg in the shipment that this stop's leg belongs to */
  shipmentConsigneeAddress: AddressEntity;
  /** Total volume of all packages associated with this stop's shipment */
  shipmentTotalVolume: Scalars['Float']['output'];
  /** Total weight of all packages associated with this stop's shipment */
  shipmentTotalWeight: Scalars['Float']['output'];
  shipperAddress?: Maybe<AddressEntity>;
  shipperContactPerson?: Maybe<ContactPersonEntity>;
  showDriverModifiedAt?: Maybe<Scalars['DateTime']['output']>;
  snapshottedAmountUsdCents?: Maybe<Scalars['Int']['output']>;
  specialInstructions?: Maybe<Scalars['String']['output']>;
  standardStopType?: Maybe<StandardStopType>;
  startOrEnd: StartOrEnd;
  status: StopStatus;
  stopDetails?: Maybe<StopDetailsOutput>;
  stopDriverMaps: Array<StopDriverMapEntity>;
  stopType?: Maybe<StopType>;
  terminal?: Maybe<TerminalEntity>;
  textResponses?: Maybe<Scalars['String']['output']>;
  transferAddress?: Maybe<AddressEntity>;
  twilioCallSid?: Maybe<Scalars['String']['output']>;
  twilioTextSid?: Maybe<Scalars['String']['output']>;
  /** Convenience field, not strongly typed. Recommended for display only, use the other fields if you need to do something programmatically with it */
  type?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  uuid: Scalars['String']['output'];
};

export enum StopImportType {
  Both = 'BOTH',
  DynamicInboundOrOutbound = 'DYNAMIC_INBOUND_OR_OUTBOUND',
  InboundOnly = 'INBOUND_ONLY',
  OutboundOnly = 'OUTBOUND_ONLY'
}

export type StopOutput = {
  __typename?: 'StopOutput';
  stopValues: Array<Maybe<GroupByStopEntity>>;
};

export enum StopPdfColumnMapping {
  Address = 'ADDRESS',
  CompletedAtDate = 'COMPLETED_AT_DATE'
}

export enum StopPickupOrDelivery {
  Delivery = 'DELIVERY',
  Pickup = 'PICKUP'
}

export type StopPreviewForRouteGenerationEntity = {
  __typename?: 'StopPreviewForRouteGenerationEntity';
  eta: Scalars['DateTime']['output'];
  odometer: Scalars['Float']['output'];
  stop: StopEntity;
};

export type StopSort = {
  sortBy: DispatchTableField;
  sortDirection: StopSortDirection;
};

export enum StopSortDirection {
  Asc = 'asc',
  Desc = 'desc'
}

export enum StopStatus {
  Arrived = 'ARRIVED',
  Cancelled = 'CANCELLED',
  Completed = 'COMPLETED',
  Failed = 'FAILED',
  NotArrived = 'NOT_ARRIVED'
}

export enum StopType {
  Delivery = 'DELIVERY',
  None = 'NONE',
  PartnerCarrierDropoff = 'PARTNER_CARRIER_DROPOFF',
  PartnerCarrierPickup = 'PARTNER_CARRIER_PICKUP',
  Pickup = 'PICKUP',
  Recovery = 'RECOVERY',
  Transfer = 'TRANSFER'
}

/** A filter object that is used to filter the stop type enum field. Each field in the filter object represents an operator. If there is more than one non-null field passed into the filter object, the condition will be a conjunction of the non-null field operator */
export type StopTypeFilter = {
  /** Filters for records where the relevant stop type field is equal to the provided stop type value */
  eq?: InputMaybe<StopType>;
  /** Filters for records where the relevant stop type field is in the provided stop type values */
  in?: InputMaybe<Array<StopType>>;
  /** Filters for records where the relevant stop type field is not equal to the provided stop type value */
  neq?: InputMaybe<StopType>;
  /** Filters for records where the relevant stop type field is not in the provided stop type values */
  nin?: InputMaybe<Array<StopType>>;
};

export type StopTypesFilter = {
  fieldLevelFilterOperator: FilterOperator;
  filterOperator?: InputMaybe<FilterOperator>;
  stopTypes: Array<PickupOrDelivery>;
};

export type StopTypesV2Filter = {
  filterOperator?: InputMaybe<FilterOperator>;
  stopType?: InputMaybe<StopType>;
};

export type StopUpdateInput = {
  addressUpsertInput?: InputMaybe<AddressUpsertInput>;
  appointmentCallStatus?: InputMaybe<AppointmentCallStatus>;
  appointmentManuallyConfirmed?: InputMaybe<Scalars['Boolean']['input']>;
  appointmentRequired?: InputMaybe<Scalars['Boolean']['input']>;
  appointmentSchedulingOptionsCalledAt?: InputMaybe<Scalars['DateTime']['input']>;
  appointmentSchedulingOptionsTextedAt?: InputMaybe<Scalars['DateTime']['input']>;
  appointmentTextStatus?: InputMaybe<AppointmentTextStatus>;
  appointmentTime?: InputMaybe<Scalars['DateTime']['input']>;
  arrivedAt?: InputMaybe<Scalars['DateTime']['input']>;
  completedAt?: InputMaybe<Scalars['DateTime']['input']>;
  confirmedByAgentAt?: InputMaybe<Scalars['DateTime']['input']>;
  contactPersonUpsertInput?: InputMaybe<ContactPersonUpsertInput>;
  contactPersonUpsertInputs?: InputMaybe<Array<ContactPersonUpsertInput>>;
  courierReadyOrDueDate?: InputMaybe<Scalars['DateTime']['input']>;
  deadlineTime?: InputMaybe<Scalars['DateTime']['input']>;
  destinationAirport?: InputMaybe<Scalars['String']['input']>;
  driverCompletedAt?: InputMaybe<Scalars['DateTime']['input']>;
  endAppointmentTime?: InputMaybe<Scalars['DateTime']['input']>;
  equipmentUuid?: InputMaybe<Scalars['String']['input']>;
  etaArrivalTime?: InputMaybe<Scalars['DateTime']['input']>;
  etaFinishTime?: InputMaybe<Scalars['DateTime']['input']>;
  etaLastUpdated?: InputMaybe<Scalars['DateTime']['input']>;
  expectedInboundArrivalDate?: InputMaybe<Scalars['DateTime']['input']>;
  expectedOutboundDate?: InputMaybe<Scalars['DateTime']['input']>;
  failureCount?: InputMaybe<Scalars['Float']['input']>;
  hideFromDispatch?: InputMaybe<Scalars['Boolean']['input']>;
  inboundDeadlineDate?: InputMaybe<Scalars['DateTime']['input']>;
  inboundMethod?: InputMaybe<InboundMethod>;
  incomingCarrier?: InputMaybe<Scalars['String']['input']>;
  isSpecial?: InputMaybe<Scalars['Boolean']['input']>;
  lastAppointmentTextTime?: InputMaybe<Scalars['DateTime']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  orderAdditionalStopForUuid?: InputMaybe<Scalars['String']['input']>;
  outboundCarrier?: InputMaybe<Scalars['String']['input']>;
  outboundDeadlineDate?: InputMaybe<Scalars['DateTime']['input']>;
  outboundMethod?: InputMaybe<OutboundMethod>;
  overrideServiceTimeInMinutes?: InputMaybe<Scalars['Float']['input']>;
  paperworkMarkedComplete?: InputMaybe<Scalars['Boolean']['input']>;
  postedAmountUsdCents?: InputMaybe<Scalars['Int']['input']>;
  proofOfDeliverySignee?: InputMaybe<Scalars['String']['input']>;
  routeSlotUuid?: InputMaybe<Scalars['String']['input']>;
  sentToAgentAt?: InputMaybe<Scalars['DateTime']['input']>;
  serviceDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** The service date in ISO 8601 date format. */
  serviceDateIso8601?: InputMaybe<Scalars['String']['input']>;
  settlementDeductionFlatRate?: InputMaybe<Scalars['Float']['input']>;
  settlementDeductionName?: InputMaybe<Scalars['String']['input']>;
  settlementDeductionPercentageRate?: InputMaybe<Scalars['Float']['input']>;
  snapshottedAmountUsdCents?: InputMaybe<Scalars['Int']['input']>;
  specialInstructions?: InputMaybe<Scalars['String']['input']>;
  standardStopType?: InputMaybe<StandardStopType>;
  status?: InputMaybe<StopStatus>;
  stopType?: InputMaybe<StopType>;
  textResponses?: InputMaybe<Scalars['String']['input']>;
  twilioCallSid?: InputMaybe<Scalars['String']['input']>;
  twilioTextSid?: InputMaybe<Scalars['String']['input']>;
  uuid: Scalars['String']['input'];
};

export type StopUpsertInput = {
  addressUpsertInput: AddressUpsertInput;
  appointmentCallStatus?: InputMaybe<AppointmentCallStatus>;
  appointmentManuallyConfirmed?: InputMaybe<Scalars['Boolean']['input']>;
  appointmentRequired?: InputMaybe<Scalars['Boolean']['input']>;
  appointmentSchedulingOptionsCalledAt?: InputMaybe<Scalars['DateTime']['input']>;
  appointmentSchedulingOptionsTextedAt?: InputMaybe<Scalars['DateTime']['input']>;
  appointmentTextStatus?: InputMaybe<AppointmentTextStatus>;
  appointmentTime?: InputMaybe<Scalars['DateTime']['input']>;
  arrivedAt?: InputMaybe<Scalars['DateTime']['input']>;
  completedAt?: InputMaybe<Scalars['DateTime']['input']>;
  confirmedByAgentAt?: InputMaybe<Scalars['DateTime']['input']>;
  contactPersonUpsertInput?: InputMaybe<ContactPersonUpsertInput>;
  contactPersonUpsertInputs?: InputMaybe<Array<ContactPersonUpsertInput>>;
  courierReadyOrDueDate?: InputMaybe<Scalars['DateTime']['input']>;
  deadlineTime?: InputMaybe<Scalars['DateTime']['input']>;
  destinationAirport?: InputMaybe<Scalars['String']['input']>;
  driverCompletedAt?: InputMaybe<Scalars['DateTime']['input']>;
  driverUuid?: InputMaybe<Scalars['String']['input']>;
  endAppointmentTime?: InputMaybe<Scalars['DateTime']['input']>;
  equipmentUuid?: InputMaybe<Scalars['String']['input']>;
  expectedInboundArrivalDate?: InputMaybe<Scalars['DateTime']['input']>;
  expectedOutboundDate?: InputMaybe<Scalars['DateTime']['input']>;
  hideFromDispatch?: InputMaybe<Scalars['Boolean']['input']>;
  inboundDeadlineDate?: InputMaybe<Scalars['DateTime']['input']>;
  inboundMethod?: InputMaybe<InboundMethod>;
  incomingCarrier?: InputMaybe<Scalars['String']['input']>;
  isSpecial?: InputMaybe<Scalars['Boolean']['input']>;
  lastAppointmentTextTime?: InputMaybe<Scalars['DateTime']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  outboundCarrier?: InputMaybe<Scalars['String']['input']>;
  outboundDeadlineDate?: InputMaybe<Scalars['DateTime']['input']>;
  outboundMethod?: InputMaybe<OutboundMethod>;
  overrideServiceTimeInMinutes?: InputMaybe<Scalars['Float']['input']>;
  paperworkMarkedComplete?: InputMaybe<Scalars['Boolean']['input']>;
  proofOfDeliverySignee?: InputMaybe<Scalars['String']['input']>;
  removedDriver?: InputMaybe<Scalars['Boolean']['input']>;
  routeSlotUuid?: InputMaybe<Scalars['String']['input']>;
  sentToAgentAt?: InputMaybe<Scalars['DateTime']['input']>;
  serviceDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** The service date in ISO 8601 date format. If null or unspecified, the stop's service date will not be updated. See https://www.notion.so/Service-Date-dc8ae149b6a54bb69404aecf92176287?pvs=4. */
  serviceDateIso8601?: InputMaybe<Scalars['String']['input']>;
  settlementDeductionFlatRate?: InputMaybe<Scalars['Float']['input']>;
  settlementDeductionName?: InputMaybe<Scalars['String']['input']>;
  settlementDeductionPercentageRate?: InputMaybe<Scalars['Float']['input']>;
  specialInstructions?: InputMaybe<Scalars['String']['input']>;
  standardStopType?: InputMaybe<StandardStopType>;
  status?: InputMaybe<StopStatus>;
  stopType?: InputMaybe<StopType>;
  terminalUuid?: InputMaybe<Scalars['String']['input']>;
  textResponses?: InputMaybe<Scalars['String']['input']>;
  transferAddressUpsertInput?: InputMaybe<AddressUpsertInput>;
  twilioCallSid?: InputMaybe<Scalars['String']['input']>;
  twilioTextSid?: InputMaybe<Scalars['String']['input']>;
  upsertStopDriverMapInputs?: InputMaybe<Array<UpsertStopDriverMapInput>>;
  uuid: Scalars['String']['input'];
};

export type StopsListElement = CachedStopEntity | RecurringRunHeaderEntity;

export type StorageOrderConnection = {
  __typename?: 'StorageOrderConnection';
  edges: Array<StorageOrderEdge>;
  pageInfo: PageInfo;
  /** Not cheap to calculate, request with prudence */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type StorageOrderEdge = {
  __typename?: 'StorageOrderEdge';
  cursor: Scalars['String']['output'];
  node: StorageOrderEntity;
};

export type StorageOrderEntity = {
  __typename?: 'StorageOrderEntity';
  arrivedAt?: Maybe<Scalars['DateTime']['output']>;
  billOfLadingNumber?: Maybe<Scalars['String']['output']>;
  carrier?: Maybe<Scalars['String']['output']>;
  company: CompanyEntity;
  consigneeName?: Maybe<Scalars['String']['output']>;
  contact: ContactEntity;
  createdAt: Scalars['DateTime']['output'];
  documents: Array<DocumentEntity>;
  expectedAt?: Maybe<Scalars['DateTime']['output']>;
  /** @deprecated Deprecated. Use items.item instead */
  inventoryItems: Array<InventoryItemEntity>;
  isOSD: Scalars['Boolean']['output'];
  items: Array<ItemForStorageOrder>;
  lotNumber?: Maybe<Scalars['String']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  pickupDate?: Maybe<Scalars['DateTime']['output']>;
  purchaseOrderNumber?: Maybe<Scalars['String']['output']>;
  referenceNumber: Scalars['String']['output'];
  sealNumber?: Maybe<Scalars['String']['output']>;
  storageUnits: Array<StorageUnitEntity>;
  supplierCompanyName?: Maybe<Scalars['String']['output']>;
  trackingNumber?: Maybe<Scalars['String']['output']>;
  trailerNumber?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  uuid: Scalars['String']['output'];
  warehouse: WarehouseEntity;
};


export type StorageOrderEntityStorageUnitsArgs = {
  storageUnitsInput?: InputMaybe<StorageUnitsInput>;
};

export type StorageUnitConnection = {
  __typename?: 'StorageUnitConnection';
  edges: Array<StorageUnitEdge>;
  pageInfo: PageInfo;
  /** Not cheap to calculate, request with prudence */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type StorageUnitEdge = {
  __typename?: 'StorageUnitEdge';
  cursor: Scalars['String']['output'];
  node: StorageUnitEntity;
};

export type StorageUnitEntity = {
  __typename?: 'StorageUnitEntity';
  billed?: Maybe<Scalars['Boolean']['output']>;
  createdAt: Scalars['DateTime']['output'];
  /** The number of billable days in the current billing cycle. Assumes that customer is billed everytime inventory is verified */
  currentBillableDays: Scalars['Int']['output'];
  height?: Maybe<Scalars['Length']['output']>;
  /** @deprecated Use items.item instead */
  inventoryItems: Array<InventoryItemEntity>;
  inventoryLastVerifiedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Represents the description of the SKU that a storage unit is comprised of. Note that this should only be used for single-SKU storage units */
  itemDescription?: Maybe<Scalars['String']['output']>;
  /** Note that this should only be used for single-SKU storage units */
  itemUOM?: Maybe<UnitOfMeasure>;
  items: Array<ItemForStorageUnit>;
  length?: Maybe<Scalars['Length']['output']>;
  markedOnHandAt?: Maybe<Scalars['DateTime']['output']>;
  markedOsdAt?: Maybe<Scalars['DateTime']['output']>;
  name: Scalars['String']['output'];
  /** The number of days the storage unit spent in the warehouse */
  numberOfDaysInStorage: Scalars['Int']['output'];
  /**
   * The number of inventory items currently in the storage unit. An inventory item is in the storage unit if it is on hand and has not been picked yet
   * @deprecated Use items quantities instead
   */
  numberOfInventoryItems: Scalars['Int']['output'];
  osdReason?: Maybe<Scalars['String']['output']>;
  outboundReferenceNumber?: Maybe<Scalars['String']['output']>;
  pickedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Represents the SKU that a storage unit is comprised of. Note that this should only be used for single-SKU storage units */
  sku?: Maybe<Scalars['String']['output']>;
  storageOrder?: Maybe<StorageOrderEntity>;
  /**
   * The number of inventory items associated with the storage unit
   * @deprecated Use items quantities instead
   */
  totalNumberOfInventoryItems: Scalars['Int']['output'];
  unitOfMeasure: UnitOfMeasure;
  updatedAt: Scalars['DateTime']['output'];
  uuid: Scalars['String']['output'];
  warehouseLocation?: Maybe<WarehouseLocationEntity>;
  weight?: Maybe<Scalars['Mass']['output']>;
  width?: Maybe<Scalars['Length']['output']>;
};

export type StorageUnitsInput = {
  pickedFilter?: InputMaybe<StorageUnitsPickedFilterType>;
};

export enum StorageUnitsPickedFilterType {
  All = 'ALL',
  Available = 'AVAILABLE',
  Picked = 'PICKED'
}

/** Represents the difference between 2 versions of a string list. Used in audit log entries */
export type StringArrayFieldDifference = {
  __typename?: 'StringArrayFieldDifference';
  newValue?: Maybe<Array<Scalars['String']['output']>>;
  oldValue?: Maybe<Array<Scalars['String']['output']>>;
};

/** Represents the difference between 2 versions of a string field. Used in audit log entries */
export type StringFieldDifference = {
  __typename?: 'StringFieldDifference';
  newValue?: Maybe<Scalars['String']['output']>;
  oldValue?: Maybe<Scalars['String']['output']>;
};

export type StringFilter = {
  filterOperator?: InputMaybe<FilterOperator>;
  filterType: StringFilterType;
  value: Scalars['String']['input'];
};

export type StringFilterNullable = {
  filterOperator?: InputMaybe<FilterOperator>;
  filterType: StringFilterType;
  value?: InputMaybe<Scalars['String']['input']>;
};

export enum StringFilterType {
  Contains = 'CONTAINS',
  Equals = 'EQUALS',
  NotContains = 'NOT_CONTAINS',
  StartsWith = 'STARTS_WITH'
}

/** A filter object that is used to filter a string field. Each field in the filter object represents an operator. If there is more than one non-null field passed into the filter object, the condition will be a conjunction of the non-null field operator */
export type StringFilterV2 = {
  /** Filters for records where the relevant string field contains the provided string value */
  contains?: InputMaybe<Scalars['String']['input']>;
  /** Filters for records where the relevant string field contains (case insensitive) the provided string value */
  containsIgnoreCase?: InputMaybe<Scalars['String']['input']>;
  /** Filters for records where the relevant string field ends with the provided string value */
  endsWith?: InputMaybe<Scalars['String']['input']>;
  /** Filters for records where the relevant string field ends with (case insensitive) the provided string value */
  endsWithIgnoreCase?: InputMaybe<Scalars['String']['input']>;
  /** Filters for records where the relevant string field is equal to the provided string value */
  eq?: InputMaybe<Scalars['String']['input']>;
  /** Filters for records where the relevant string field is equal to (case insensitive) the provided string value */
  eqIgnoreCase?: InputMaybe<Scalars['String']['input']>;
  /** Filters for records where the relevant string field is in the provided array of string values */
  in?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Filters for records where the relevant string field is blank */
  isBlank?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filters for records where the relevant string field is not blank */
  isNotBlank?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filters for records where the relevant string field is not equal to the provided string value */
  neq?: InputMaybe<Scalars['String']['input']>;
  /** Filters for records where the relevant string field is not equal to (case insensitive) the provided string value */
  neqIgnoreCase?: InputMaybe<Scalars['String']['input']>;
  /** Filters for records where the relevant string field is not in the provided array of string values */
  nin?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Filters for records where the relevant string field starts with the provided string value */
  startsWith?: InputMaybe<Scalars['String']['input']>;
  /** Filters for records where the relevant string field starts with (case insensitive) the provided string value */
  startsWithIgnoreCase?: InputMaybe<Scalars['String']['input']>;
};

export type StringsFilter = {
  /** Operator to apply across the array of values. Only supports equality. */
  fieldLevelFilterOperator: FilterOperator;
  values: Array<Scalars['String']['input']>;
};

export type StructuredExtractionRunEntity = {
  __typename?: 'StructuredExtractionRunEntity';
  createdAt: Scalars['DateTime']['output'];
  hasError?: Maybe<Scalars['Boolean']['output']>;
  rawResult?: Maybe<Scalars['String']['output']>;
  scannedOrderUuid: Scalars['String']['output'];
  schemaName?: Maybe<Scalars['String']['output']>;
  schemaUuid?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  uuid: Scalars['String']['output'];
};

export type StructuredExtractionSchemaOverrideEntity = {
  __typename?: 'StructuredExtractionSchemaOverrideEntity';
  deadlineDateKeys?: Maybe<Array<Scalars['String']['output']>>;
  schemaExclusions?: Maybe<Scalars['String']['output']>;
  schemaOverride?: Maybe<Scalars['String']['output']>;
  specialInstructionsKeys?: Maybe<Array<Scalars['String']['output']>>;
  uuid: Scalars['String']['output'];
};

export type StructuredExtractionSchemaOverrideInput = {
  deadlineDateKeys?: InputMaybe<Array<Scalars['String']['input']>>;
  schemaExclusions?: InputMaybe<Scalars['String']['input']>;
  schemaOverride: Scalars['String']['input'];
  schemaUuid: Scalars['String']['input'];
  specialInstructionsKeys?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type TableColumnWidthEntity = {
  __typename?: 'TableColumnWidthEntity';
  colId: Scalars['String']['output'];
  width: Scalars['Float']['output'];
};

export type TableFieldsEntity = {
  __typename?: 'TableFieldsEntity';
  billingReviewOrderTableFields: Array<OrderTableField>;
  dispatchTableColumnWidths?: Maybe<Array<TableColumnWidthEntity>>;
  dispatchTableFields: Array<DispatchTableField>;
  linehaulDispatchTableFields: Array<LinehaulDispatchTableField>;
  orderTableFields: Array<OrderTableField>;
  routeCardStopTableColumnWidths?: Maybe<Array<TableColumnWidthEntity>>;
  routeCardStopTableFields: Array<DispatchTableField>;
};

export type TagCreateInput = {
  color?: InputMaybe<Scalars['String']['input']>;
  value: Scalars['String']['input'];
};

export type TagEntity = {
  __typename?: 'TagEntity';
  color?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  legs: Array<LegEntity>;
  orders: Array<OrderEntity>;
  updatedAt: Scalars['DateTime']['output'];
  uuid: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type TagUpdateInput = {
  color?: InputMaybe<Scalars['String']['input']>;
  uuid: Scalars['String']['input'];
  value?: InputMaybe<Scalars['String']['input']>;
};

export type TariffChainEntity = {
  __typename?: 'TariffChainEntity';
  id: Scalars['String']['output'];
  isArchived: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  tariffGroupType: TariffGroupType;
  /** This is an ORDERED list of tariff groups on this tariff chain. */
  tariffGroups: Array<TariffGroupEntity>;
};

export type TariffCreateInput = {
  /** UUID of billing party contact for custom tariffs */
  billingPartyContactUuid?: InputMaybe<Scalars['String']['input']>;
  maximumUsdCents?: InputMaybe<Scalars['Int']['input']>;
  minimumUsdCents?: InputMaybe<Scalars['Int']['input']>;
  rateType: RateType;
  serviceLevel?: InputMaybe<ServiceLevel>;
  serviceUuid?: InputMaybe<Scalars['String']['input']>;
  settlementPercentageRate?: InputMaybe<Scalars['Percent']['input']>;
  tariffOverageRateCreateInputs?: InputMaybe<Array<TariffOverageRateCreateInput>>;
  /** tariff ranges to be created for this tariff */
  tariffRangeCreateInputs: Array<TariffRangeCreateInput>;
  tariffType: TariffType;
  tariffZoneUuid: Scalars['String']['input'];
  useActualWeightInCalculation: Scalars['Boolean']['input'];
  visibilityLevel?: InputMaybe<TariffVisibilityLevel>;
};

export type TariffEntity = {
  __typename?: 'TariffEntity';
  billingPartyContactUuid?: Maybe<Scalars['String']['output']>;
  /** Maximum amount assessed, in USD cents */
  maximumUsdCents?: Maybe<Scalars['Int']['output']>;
  /** Minimum amount assessed, in USD cents */
  minimumUsdCents?: Maybe<Scalars['Int']['output']>;
  rateType: RateType;
  service?: Maybe<ServiceEntity>;
  settlementPercentageRate?: Maybe<Scalars['Percent']['output']>;
  tariffGroup?: Maybe<TariffGroupEntity>;
  tariffOverageRates: Array<TariffOverageRateEntity>;
  tariffRanges: Array<TariffRangeEntity>;
  /** Tariff Type */
  tariffType: TariffType;
  tariffZone: TariffZoneEntity;
  useActualWeight?: Maybe<Scalars['Boolean']['output']>;
  useActualWeightInCalculation: Scalars['Boolean']['output'];
  uuid: Scalars['String']['output'];
};

export type TariffGroupConnection = {
  __typename?: 'TariffGroupConnection';
  edges: Array<TariffGroupEdge>;
  pageInfo: PageInfo;
  /** Not cheap to calculate, request with prudence */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type TariffGroupEdge = {
  __typename?: 'TariffGroupEdge';
  cursor: Scalars['String']['output'];
  node: TariffGroupEntity;
};

export type TariffGroupEntity = {
  __typename?: 'TariffGroupEntity';
  contactToServicesMappings: Array<ContactToServicesTariffGroupMappingEntity>;
  endDate?: Maybe<Scalars['DateTime']['output']>;
  firstTariff?: Maybe<TariffEntity>;
  fuelProfile?: Maybe<FuelProfileEntity>;
  fuelProfileUuid?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  parentTariffGroup?: Maybe<TariffGroupEntity>;
  rateMultiplier?: Maybe<Scalars['Float']['output']>;
  services: Array<ServiceEntity>;
  startDate?: Maybe<Scalars['DateTime']['output']>;
  tariffGroupScope?: Maybe<TariffGroupScope>;
  tariffGroupType: TariffGroupType;
  tariffZoneGroup?: Maybe<TariffZoneGroupEntity>;
  tariffs: Array<TariffEntity>;
  terminals: Array<TerminalEntity>;
  totalContactsToServicesMappings: Scalars['Int']['output'];
  useActualWeightInCalculation: Scalars['Boolean']['output'];
  useDeficitBilling?: Maybe<Scalars['Boolean']['output']>;
  uuid: Scalars['String']['output'];
  vehicleTypes: Array<VehicleTypeEntity>;
};


export type TariffGroupEntityContactToServicesMappingsArgs = {
  first?: InputMaybe<Scalars['Float']['input']>;
};

export enum TariffGroupScope {
  Combination = 'COMBINATION',
  Contact = 'CONTACT',
  Default = 'DEFAULT'
}

export enum TariffGroupType {
  LineHaul = 'LINE_HAUL',
  Ordinary = 'ORDINARY',
  PointToPoint = 'POINT_TO_POINT',
  Transfer = 'TRANSFER'
}

export type TariffLocationCreateInput = {
  city?: InputMaybe<Scalars['String']['input']>;
  zipcode?: InputMaybe<Scalars['String']['input']>;
};

export type TariffLocationEntity = {
  __typename?: 'TariffLocationEntity';
  city?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  updatedAt: Scalars['DateTime']['output'];
  uuid: Scalars['String']['output'];
  zipcode?: Maybe<Scalars['String']['output']>;
};

export type TariffOverageRateCreateInput = {
  applicableAboveAmount: Scalars['Float']['input'];
  /** Flat rate in USD cents. Made nullable outside the entity to be backwards compatible with the old frontends. */
  flatRateUsdCents?: InputMaybe<Scalars['Float']['input']>;
  name: Scalars['String']['input'];
  rateUsdCents: Scalars['Float']['input'];
  type: TariffOverageRateType;
};

export type TariffOverageRateEntity = {
  __typename?: 'TariffOverageRateEntity';
  applicableAboveAmount: Scalars['Float']['output'];
  flatRateUsdCents: Scalars['Float']['output'];
  name: Scalars['String']['output'];
  rateUsdCents: Scalars['Float']['output'];
  type: TariffOverageRateType;
  uuid: Scalars['String']['output'];
};

export enum TariffOverageRateType {
  Miles = 'MILES',
  Pieces = 'PIECES',
  Weight = 'WEIGHT'
}

export type TariffRangeCreateInput = {
  lessThanOrEqualToValue: Scalars['Int']['input'];
  rateUsdCents: Scalars['Float']['input'];
};

export type TariffRangeEntity = {
  __typename?: 'TariffRangeEntity';
  lessThanOrEqualToValue: Scalars['Int']['output'];
  rateUsdCents: Scalars['Float']['output'];
  uuid: Scalars['String']['output'];
};

export type TariffRangeUpdateInput = {
  lessThanOrEqualToValue: Scalars['Int']['input'];
  rateUsdCents: Scalars['Float']['input'];
  uuid: Scalars['String']['input'];
};

export type TariffRangeUpdatesInput = {
  tariffRangeUpdateInputs: Array<TariffRangeUpdateInput>;
  tariffUuid: Scalars['String']['input'];
};

export enum TariffType {
  NoUnits = 'NO_UNITS',
  PerCubicFoot = 'PER_CUBIC_FOOT',
  PerHundredPounds = 'PER_HUNDRED_POUNDS',
  PerPiece = 'PER_PIECE'
}

export type TariffUpsertInput = {
  contactUuid?: InputMaybe<Scalars['String']['input']>;
  fuelProfileUuid?: InputMaybe<Scalars['String']['input']>;
  maximumUsdCents?: InputMaybe<Scalars['Int']['input']>;
  minimumUsdCents?: InputMaybe<Scalars['Int']['input']>;
  rateType?: InputMaybe<RateType>;
  serviceUuid?: InputMaybe<Scalars['String']['input']>;
  settlementPercentageRate?: InputMaybe<Scalars['Percent']['input']>;
  tariffOverageRateCreateInputs?: InputMaybe<Array<TariffOverageRateCreateInput>>;
  tariffRangeUpdateInputs?: InputMaybe<Array<TariffRangeUpdateInput>>;
  tariffType: TariffType;
  tariffZoneUuid: Scalars['String']['input'];
  useActualWeightInCalculation?: InputMaybe<Scalars['Boolean']['input']>;
  uuid?: InputMaybe<Scalars['String']['input']>;
};

export enum TariffVisibilityLevel {
  Customer = 'CUSTOMER',
  Global = 'GLOBAL'
}

export type TariffZoneCreateInput = {
  destinationTerminalUuid?: InputMaybe<Scalars['String']['input']>;
  locations?: InputMaybe<Array<TariffLocationCreateInput>>;
  mileRangeEnd?: InputMaybe<Scalars['Float']['input']>;
  mileRangeStart?: InputMaybe<Scalars['Float']['input']>;
  /** Name of tariff */
  name: Scalars['String']['input'];
  tariffZoneGroupId?: InputMaybe<Scalars['String']['input']>;
  tariffZoneLocationType?: InputMaybe<TariffZoneLocationType>;
  terminalUuid?: InputMaybe<Scalars['String']['input']>;
  type: TariffZoneType;
  uuid?: InputMaybe<Scalars['String']['input']>;
};

export type TariffZoneEntity = {
  __typename?: 'TariffZoneEntity';
  billingPartyContactId?: Maybe<Scalars['Int']['output']>;
  billingPartyContactUuid?: Maybe<Scalars['String']['output']>;
  destinationTerminal?: Maybe<TerminalEntity>;
  lineHaulLane?: Maybe<LineHaulLaneEntity>;
  locations: Array<TariffLocationEntity>;
  mileRangeEnd?: Maybe<Scalars['Float']['output']>;
  mileRangeStart?: Maybe<Scalars['Float']['output']>;
  /** Name of tariff */
  name: Scalars['String']['output'];
  tariffZoneGroupId?: Maybe<Scalars['String']['output']>;
  tariffZoneLocationType?: Maybe<TariffZoneLocationType>;
  terminal?: Maybe<TerminalEntity>;
  type: TariffZoneType;
  uuid: Scalars['String']['output'];
};

export type TariffZoneGroupArchiveOutput = MutationErrorOutput | TariffZoneGroupArchiveSuccessOutput;

export type TariffZoneGroupArchiveSuccessOutput = {
  __typename?: 'TariffZoneGroupArchiveSuccessOutput';
  /** The archived tariff zone group */
  tariffZoneGroup: TariffZoneGroupEntity;
};

export type TariffZoneGroupCreateInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
};

export type TariffZoneGroupCreateOutput = MutationErrorOutput | TariffZoneGroupCreateSuccessOutput;

export type TariffZoneGroupCreateSuccessOutput = {
  __typename?: 'TariffZoneGroupCreateSuccessOutput';
  /** The created tariff zone group */
  tariffZoneGroup: TariffZoneGroupEntity;
};

export type TariffZoneGroupEntity = {
  __typename?: 'TariffZoneGroupEntity';
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  isArchived: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  tariffZones: Array<TariffZoneEntity>;
};

export type TariffZoneGroupRestoreOutput = MutationErrorOutput | TariffZoneGroupRestoreSuccessOutput;

export type TariffZoneGroupRestoreSuccessOutput = {
  __typename?: 'TariffZoneGroupRestoreSuccessOutput';
  /** The restored tariff zone group */
  tariffZoneGroup: TariffZoneGroupEntity;
};

export type TariffZoneGroupUpdateInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

export type TariffZoneGroupUpdateOutput = MutationErrorOutput | TariffZoneGroupUpdateSuccessOutput;

export type TariffZoneGroupUpdateSuccessOutput = {
  __typename?: 'TariffZoneGroupUpdateSuccessOutput';
  /** The updated tariff zone group */
  tariffZoneGroup: TariffZoneGroupEntity;
};

export enum TariffZoneLocationType {
  LineHaulLane = 'LINE_HAUL_LANE',
  Terminal = 'TERMINAL',
  Zipcode = 'ZIPCODE'
}

export enum TariffZoneType {
  Location = 'LOCATION',
  Miles = 'MILES',
  Universal = 'UNIVERSAL',
  Zipcode = 'ZIPCODE',
  ZonePair = 'ZONE_PAIR'
}

export type TariffZoneUpdateInput = {
  destinationTerminalUuid?: InputMaybe<Scalars['String']['input']>;
  locations?: InputMaybe<Array<TariffLocationCreateInput>>;
  mileRangeEnd?: InputMaybe<Scalars['Float']['input']>;
  mileRangeStart?: InputMaybe<Scalars['Float']['input']>;
  /** Name of tariff */
  name?: InputMaybe<Scalars['String']['input']>;
  tariffZoneLocationType?: InputMaybe<TariffZoneLocationType>;
  terminalUuid?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<TariffZoneType>;
  uuid: Scalars['String']['input'];
};

export type TariffsDeleteInput = {
  uuids: Array<Scalars['String']['input']>;
};

export type TerminalCreateInput = {
  addressUuid: Scalars['String']['input'];
  /** Required if the terminal being created is an agent terminal */
  agentId?: InputMaybe<Scalars['String']['input']>;
  code: Scalars['String']['input'];
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  /** Required if and only if the line_haul_networks feature flag is enabled */
  serviceRegionId?: InputMaybe<Scalars['String']['input']>;
};

export type TerminalEntity = {
  __typename?: 'TerminalEntity';
  address: AddressEntity;
  agent?: Maybe<AgentFieldsEntity>;
  code: Scalars['String']['output'];
  isActive: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  serviceAreas: Array<TerminalServiceAreaEntity>;
  serviceRegion?: Maybe<ServiceRegionEntity>;
  serviceRegionId?: Maybe<Scalars['String']['output']>;
  startForTerminalLanes: Array<TerminalLaneEntity>;
  uuid: Scalars['String']['output'];
};

/** An object representing a lane between two terminals, meaning orders can be moved directly from the start to the end terminal. */
export type TerminalLaneEntity = {
  __typename?: 'TerminalLaneEntity';
  endTerminal: TerminalEntity;
  id: Scalars['String']['output'];
  startTerminal: TerminalEntity;
};

export type TerminalReportArgs = {
  businessDivisionUuid?: InputMaybe<Scalars['String']['input']>;
  contactUuid?: InputMaybe<Scalars['String']['input']>;
  driverUuid?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  excludeMigratedOrders?: InputMaybe<Scalars['Boolean']['input']>;
  lastNumberOfDays?: InputMaybe<Scalars['Float']['input']>;
  lastNumberOfMonths?: InputMaybe<Scalars['Float']['input']>;
  lastNumberOfWeeks?: InputMaybe<Scalars['Float']['input']>;
  orderStatuses: Array<OrderStatus>;
  reportRevenueType?: InputMaybe<ReportRevenueType>;
  reportStatistics: Array<ReportStatistic>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  stopTypes: Array<PickupOrDelivery>;
};

export type TerminalReportBucketEntity = {
  __typename?: 'TerminalReportBucketEntity';
  code: Scalars['String']['output'];
  customChargeRevenue: Scalars['Float']['output'];
  deliveryRevenue: Scalars['Float']['output'];
  endDate: Scalars['DateTime']['output'];
  freightRevenue: Scalars['Float']['output'];
  fuelRevenue: Scalars['Float']['output'];
  lineHaulRevenue: Scalars['Float']['output'];
  name: Scalars['String']['output'];
  numberOfOrders: Scalars['Float']['output'];
  numberOfPackages: Scalars['Float']['output'];
  pickupRevenue: Scalars['Float']['output'];
  recoveryRevenue: Scalars['Float']['output'];
  specialRevenue: Scalars['Float']['output'];
  startDate: Scalars['DateTime']['output'];
  surchargeRevenue: Scalars['Float']['output'];
  totalRevenue: Scalars['Float']['output'];
  totalWeight: Scalars['Float']['output'];
  transferRevenue: Scalars['Float']['output'];
  uuid: Scalars['String']['output'];
};

export type TerminalServiceAreaEntity = {
  __typename?: 'TerminalServiceAreaEntity';
  city?: Maybe<Scalars['String']['output']>;
  uuid: Scalars['String']['output'];
  zipcode: Scalars['String']['output'];
};

export type TerminalServiceAreaUpdateInput = {
  city?: InputMaybe<Scalars['String']['input']>;
  terminalUuid?: InputMaybe<Scalars['String']['input']>;
  uuid: Scalars['String']['input'];
  zipcode: Scalars['String']['input'];
};

export type TerminalUpdateInput = {
  addressUuid?: InputMaybe<Scalars['String']['input']>;
  agentId?: InputMaybe<Scalars['String']['input']>;
  code?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  /** All of the UUIDs of the terminals to which there is a lane starting at the terminal being edited, replacing the existing terminal lanes */
  laneEndTerminalUuids?: InputMaybe<Array<Scalars['String']['input']>>;
  name?: InputMaybe<Scalars['String']['input']>;
  /** Required if and only if the line_haul_networks feature flag is enabled */
  serviceRegionId?: InputMaybe<Scalars['String']['input']>;
  uuid: Scalars['String']['input'];
};

export type TestJsonSchemaOnDocumentsForSchemaInput = {
  deadlineDateKeys?: InputMaybe<Array<Scalars['String']['input']>>;
  schemaExclusions?: InputMaybe<Scalars['String']['input']>;
  schemaOverride?: InputMaybe<Scalars['String']['input']>;
  schemaUuid: Scalars['String']['input'];
};

export type TestJsonSchemaOnDocumentsForSchemaOutput = {
  __typename?: 'TestJsonSchemaOnDocumentsForSchemaOutput';
  differencesMap: Scalars['String']['output'];
  normalizedGptResults: Scalars['String']['output'];
  rawGptResults: Scalars['String']['output'];
};

export type TestOneSnapshotInput = {
  schemaRunUuid: Scalars['String']['input'];
};

export type TestOrderCustomChargeEntity = {
  __typename?: 'TestOrderCustomChargeEntity';
  createdAt: Scalars['DateTime']['output'];
  customCharge: CustomChargeEntity;
  total: Scalars['Float']['output'];
  updatedAt: Scalars['DateTime']['output'];
  uuid: Scalars['String']['output'];
};

export type TestOrderEntity = {
  __typename?: 'TestOrderEntity';
  createdAt: Scalars['DateTime']['output'];
  order: StandardOrderEntity;
  testOrderCustomCharges: Array<TestOrderCustomChargeEntity>;
  totalCharge: Scalars['Float']['output'];
  totalFreightCharge: Scalars['Float']['output'];
  totalFuelCharge: Scalars['Float']['output'];
  updatedAt: Scalars['DateTime']['output'];
  uuid: Scalars['String']['output'];
};

export enum TestOrderStopType {
  Delivery = 'DELIVERY',
  PartnerCarrierDropoffAndDelivery = 'PARTNER_CARRIER_DROPOFF_AND_DELIVERY',
  PartnerCarrierDropoffLineHaulDelivery = 'PARTNER_CARRIER_DROPOFF_LINE_HAUL_DELIVERY',
  Pickup = 'PICKUP',
  PickupAndDelivery = 'PICKUP_AND_DELIVERY',
  PickupAndTransfer = 'PICKUP_AND_TRANSFER',
  PickupLineHaulDelivery = 'PICKUP_LINE_HAUL_DELIVERY',
  PickupLineHaulTransfer = 'PICKUP_LINE_HAUL_TRANSFER',
  PickupPartnerCarrierLineHaulPickup = 'PICKUP_PARTNER_CARRIER_LINE_HAUL_PICKUP',
  PickupPartnerCarrierPickup = 'PICKUP_PARTNER_CARRIER_PICKUP',
  RecoveryAndDelivery = 'RECOVERY_AND_DELIVERY',
  RecoveryLineHaulDelivery = 'RECOVERY_LINE_HAUL_DELIVERY'
}

export type TestSchemaInput = {
  documentName: Scalars['String']['input'];
  schemaUuid: Scalars['String']['input'];
};

export type TestSnapshotInput = {
  bucket: Scalars['String']['input'];
  extractedFields: Array<ExtractedFieldInput>;
  fingerprintAnchorMatches: Array<FingerprintAnchorMatchInput>;
  key: Scalars['String']['input'];
  schemaName: Scalars['String']['input'];
  schemaRunPages: Array<SchemaRunPageInput>;
  transformAnchorMatches: Array<TransformAnchorMatchInput>;
};

export type TextDriverInput = {
  dispatchedDate: Scalars['DateTime']['input'];
  driverUuid: Scalars['String']['input'];
  messageContents: Scalars['String']['input'];
  routeUuid: Scalars['String']['input'];
};

export type TextMessageEntity = {
  __typename?: 'TextMessageEntity';
  /** Pseudo createdAt for easier sorting */
  createdAt: Scalars['DateTime']['output'];
  message: Scalars['String']['output'];
  timestamp: Scalars['DateTime']['output'];
};

export type TextractSchemaFileInput = {
  filename: Scalars['String']['input'];
  textractType: TextractType;
};

export type TextractSchemaTestFileInput = {
  filename: Scalars['String']['input'];
  schemaUuid: Scalars['String']['input'];
};

export enum TextractType {
  AnalyzeDocument = 'ANALYZE_DOCUMENT',
  DetectDocumentText = 'DETECT_DOCUMENT_TEXT'
}

export type ThirdPartyBrokerCreateInput = {
  name: Scalars['String']['input'];
};

export type ThirdPartyBrokerEntity = {
  __typename?: 'ThirdPartyBrokerEntity';
  name: Scalars['String']['output'];
  uuid: Scalars['String']['output'];
};

export type ThirdPartyBrokerUpdateInput = {
  name?: InputMaybe<Scalars['String']['input']>;
  uuid: Scalars['String']['input'];
};

export type ThirdPartyContactEntity = ContactEntity & {
  __typename?: 'ThirdPartyContactEntity';
  addresses: Array<AddressEntity>;
  apiName?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use getAverageDaysToPayReport in ReportsService instead */
  averageDaysToPay90: Scalars['Float']['output'];
  /** @deprecated Use getAverageDaysToPayReport in ReportsService instead */
  averageDaysToPay180: Scalars['Float']['output'];
  /** @deprecated Use getAverageDaysToPayReport in ReportsService instead */
  averageDaysToPay270: Scalars['Float']['output'];
  /** @deprecated Use getAverageDaysToPayReport in ReportsService instead */
  averageDaysToPay360: Scalars['Float']['output'];
  /** @deprecated Use getAverageDaysToPayReport in ReportsService instead */
  averageDaysToPay720: Scalars['Float']['output'];
  /** @deprecated Use getAverageDaysToPayReport in ReportsService instead */
  averageDaysToPayAll: Scalars['Float']['output'];
  /** The customer balance for the contact in dollars */
  balance: Scalars['Float']['output'];
  billingContactEmail?: Maybe<Scalars['String']['output']>;
  billingCycle?: Maybe<BillingCycleType>;
  billingCycleDuration: BillingCycleDuration;
  billingPeriod?: Maybe<Scalars['Float']['output']>;
  billingPeriodDates?: Maybe<Array<Scalars['DateTime']['output']>>;
  billingRunStart: Scalars['DateTime']['output'];
  businessDivision?: Maybe<BusinessDivisionEntity>;
  company: CompanyEntity;
  contactComments: Array<ContactCommentEntity>;
  contactOpenInvoiceValue: Scalars['Float']['output'];
  contactOpenInvoiceValue0to30d: Scalars['Float']['output'];
  contactOpenInvoiceValue31to38d: Scalars['Float']['output'];
  contactOpenInvoiceValue39to45d: Scalars['Float']['output'];
  contactOpenInvoiceValue46to60d: Scalars['Float']['output'];
  contactOpenInvoiceValue61to75d: Scalars['Float']['output'];
  contactOpenInvoiceValueOver75d: Scalars['Float']['output'];
  contactPersons: Array<ContactPersonEntity>;
  contactReferenceNumber?: Maybe<Scalars['String']['output']>;
  contactStations: Array<ContactStationEntity>;
  contactStatistics: ContactStatsEntity;
  creditsAppliedToContactInvoices: Scalars['Float']['output'];
  customerTariffs: Array<TariffEntity>;
  debitsAppliedToContactInvoices: Scalars['Float']['output'];
  defaultAddress?: Maybe<AddressEntity>;
  defaultContactPerson?: Maybe<ContactPersonEntity>;
  defaultEfmHandlingStation?: Maybe<Scalars['String']['output']>;
  defaultInvoiceTerms?: Maybe<InvoiceTermEntity>;
  defaultService?: Maybe<ServiceEntity>;
  defaultServicePickupsDeliveries: Scalars['Boolean']['output'];
  dimFactor: Scalars['Int']['output'];
  displayName: Scalars['String']['output'];
  ediApplicationId?: Maybe<Scalars['String']['output']>;
  ediContactCode?: Maybe<Scalars['String']['output']>;
  ediPartnership?: Maybe<EdiPartnershipEntity>;
  ediPartnerships: Array<EdiPartnershipEntity>;
  freightChargeQuickbooksMappingId?: Maybe<Scalars['String']['output']>;
  fuelChargeQuickbooksMappingId?: Maybe<Scalars['String']['output']>;
  identifier?: Maybe<Scalars['String']['output']>;
  invoiceNotes?: Maybe<Scalars['String']['output']>;
  invoicePdfColumns: Array<PdfColumnEntity>;
  invoiceTimePeriodSplit?: Maybe<TimePeriod>;
  isActive: Scalars['Boolean']['output'];
  isEfm?: Maybe<Scalars['Boolean']['output']>;
  isOverCreditLimit: Scalars['Boolean']['output'];
  isPrepaidOnly: Scalars['Boolean']['output'];
  isaId?: Maybe<Scalars['String']['output']>;
  logo?: Maybe<DocumentEntity>;
  logoType?: Maybe<DocumentEntity>;
  masterAccount?: Maybe<MasterAccountEntity>;
  miscCustomChargeQuickbooksMappingId?: Maybe<Scalars['String']['output']>;
  numberOfOrdersPerInvoice?: Maybe<Scalars['Float']['output']>;
  orders: Array<OrderEntity>;
  overdueInvoices: Array<InvoiceEntity>;
  paymentsAppliedToContactInvoices: Scalars['Float']['output'];
  /** Total closed balance across all posted invoices */
  postedInvoicesTotalClosedBalance: Scalars['Float']['output'];
  /** Total open balance across all posted invoices */
  postedInvoicesTotalOpenBalance: Scalars['Float']['output'];
  quickbooksDesktopAccountsReceivableId?: Maybe<Scalars['String']['output']>;
  quickbooksDesktopContactId?: Maybe<Scalars['String']['output']>;
  quickbooksFileMappingCustomerName?: Maybe<Scalars['String']['output']>;
  quickbooksFileMappingFreightChargeName?: Maybe<Scalars['String']['output']>;
  quickbooksFileMappingFuelChargeName?: Maybe<Scalars['String']['output']>;
  quickbooksFileMappingPickupChargeName?: Maybe<Scalars['String']['output']>;
  quickbooksMappingId?: Maybe<Scalars['String']['output']>;
  referenceNumberLabels: Array<ReferenceNumberLabelEntity>;
  requireDriverToCheckOffPackagesAtStop: Scalars['Boolean']['output'];
  services: Array<ServiceEntity>;
  shortCode?: Maybe<Scalars['String']['output']>;
  showChargesOnCustomerPortal: Scalars['Boolean']['output'];
  showEdiReferenceNumbersOnOrderPage: Scalars['Boolean']['output'];
  skipFuelCharge?: Maybe<Scalars['Boolean']['output']>;
  standardCarrierAlphaCode?: Maybe<Scalars['String']['output']>;
  stediPartnerId?: Maybe<Scalars['String']['output']>;
  tariffZones: Array<TariffZoneEntity>;
  /** @deprecated this field is a placeholder since the column was dropped from the table */
  thirdPartyContactType: ThirdPartyContactType;
  totalCredits: Scalars['Float']['output'];
  totalDebits: Scalars['Float']['output'];
  totalInvoicesAmount: Scalars['Float']['output'];
  totalPayments: Scalars['Float']['output'];
  totalPostedInvoicesAmount: Scalars['Float']['output'];
  /** @deprecated Contact type is deprecated. The column has been dropped from the db */
  type: ContactType;
  unappliedCredits?: Maybe<Scalars['Float']['output']>;
  unappliedDebits: Scalars['Float']['output'];
  unappliedPayments: Scalars['Float']['output'];
  uuid: Scalars['String']['output'];
};


export type ThirdPartyContactEntityContactOpenInvoiceValueArgs = {
  findOpenInvoicesArgs?: InputMaybe<FindOpenInvoicesArgs>;
};


export type ThirdPartyContactEntityContactOpenInvoiceValue0to30dArgs = {
  findOpenInvoicesArgs?: InputMaybe<FindOpenInvoicesArgs>;
};


export type ThirdPartyContactEntityContactOpenInvoiceValue31to38dArgs = {
  findOpenInvoicesArgs?: InputMaybe<FindOpenInvoicesArgs>;
};


export type ThirdPartyContactEntityContactOpenInvoiceValue39to45dArgs = {
  findOpenInvoicesArgs?: InputMaybe<FindOpenInvoicesArgs>;
};


export type ThirdPartyContactEntityContactOpenInvoiceValue46to60dArgs = {
  findOpenInvoicesArgs?: InputMaybe<FindOpenInvoicesArgs>;
};


export type ThirdPartyContactEntityContactOpenInvoiceValue61to75dArgs = {
  findOpenInvoicesArgs?: InputMaybe<FindOpenInvoicesArgs>;
};


export type ThirdPartyContactEntityContactOpenInvoiceValueOver75dArgs = {
  findOpenInvoicesArgs?: InputMaybe<FindOpenInvoicesArgs>;
};

export enum ThirdPartyContactType {
  OtherFacility = 'OTHER_FACILITY',
  Receiver = 'RECEIVER',
  Shipper = 'SHIPPER'
}

export type ThirdPartyUserEntity = {
  __typename?: 'ThirdPartyUserEntity';
  contacts: Array<ContactEntity>;
  email: Scalars['String']['output'];
  password: Scalars['String']['output'];
  uuid: Scalars['String']['output'];
};

export enum TimeOfPodUpload {
  DoNotSend = 'DO_NOT_SEND',
  InvoiceSent = 'INVOICE_SENT',
  StopCompletion = 'STOP_COMPLETION'
}

export enum TimePeriod {
  Day = 'DAY',
  Month = 'MONTH',
  Week = 'WEEK',
  Year = 'YEAR'
}

export type TotalPackageWeightSortInput = {
  direction: SortOrder;
  nulls: NullsOrder;
};

export type TotalSkidsSortInput = {
  direction: SortOrder;
  nulls: NullsOrder;
};

export type TransformAnchorEntity = {
  __typename?: 'TransformAnchorEntity';
  blockId?: Maybe<Scalars['String']['output']>;
  height: Scalars['Float']['output'];
  left: Scalars['Float']['output'];
  text: Scalars['String']['output'];
  top: Scalars['Float']['output'];
  uuid: Scalars['String']['output'];
  width: Scalars['Float']['output'];
};

export type TransformAnchorInput = {
  blockId?: InputMaybe<Scalars['String']['input']>;
  height: Scalars['Float']['input'];
  left: Scalars['Float']['input'];
  text: Scalars['String']['input'];
  top: Scalars['Float']['input'];
  width: Scalars['Float']['input'];
};

export type TransformAnchorMatchEntity = {
  __typename?: 'TransformAnchorMatchEntity';
  text: Scalars['String']['output'];
  uuid: Scalars['String']['output'];
};

export type TransformAnchorMatchInput = {
  text: Scalars['String']['input'];
};

/** A filter object that is used to filter a UUID field. Each field in the filter object represents an operator. If there is more than one non-null field passed into the filter object, the condition will be a conjunction of the non-null field operator */
export type UuidFilterV2 = {
  /** Filters for records where the relevant UUID is equal to the provided UUID */
  eq?: InputMaybe<Scalars['String']['input']>;
  /** Filters for records where the relevant UUID is in the provided array of UUIDs */
  in?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Filters for records where the relevant UUID field is null */
  isBlank?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filters for records where the relevant UUID field is not null */
  isNotBlank?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filters for records where the relevant UUID is not equal to the provided UUID */
  neq?: InputMaybe<Scalars['String']['input']>;
  /** Filters for records where the relevant UUID is not in the provided array of UUIDs */
  nin?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type UnappliedPaymentReportCsvInput = {
  /** The list of filters that can be used to generate the unapplied payments report. */
  reportFilters: ReportFiltersInput;
};

export type UnassignInventoryItemsInput = {
  /** The UUID of the item whose inventory items need to be unassigned from the storage unit */
  itemUuid: Scalars['String']['input'];
  /** The UUID of the storage unit to unassign the inventory items from */
  uuid: Scalars['String']['input'];
};

export type UnassignInventoryItemsOutput = {
  __typename?: 'UnassignInventoryItemsOutput';
  success: Scalars['Boolean']['output'];
};

export type UnassignLegFromDriverInput = {
  driverUuid: Scalars['String']['input'];
  legUuid: Scalars['String']['input'];
};

export type UnconsolidateOrderInput = {
  orderUuid: Scalars['String']['input'];
};

export type UnifiedSearchConnectionArgsInput = {
  /** forwards pagination cursor */
  after?: InputMaybe<Scalars['String']['input']>;
  /** backwards pagination cursor */
  before?: InputMaybe<Scalars['String']['input']>;
  /** forwards pagination count, provide this on initial query */
  first?: InputMaybe<Scalars['Int']['input']>;
  /** backwards pagination count */
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type UnifiedSearchEntity = {
  __typename?: 'UnifiedSearchEntity';
  invoices: InvoiceConnection;
  orders: OrderConnection;
  quotes: QuoteConnection;
  unacceptedEdiAndApiOrders: OrderConnection;
  unacceptedEmailOrders: ScannedOrderResultConnection;
};

export type UnifiedSearchInput = {
  contactUuid?: InputMaybe<Scalars['String']['input']>;
  destinationTerminalUuid?: InputMaybe<Scalars['String']['input']>;
  invoicesConnectionArgs?: InputMaybe<UnifiedSearchConnectionArgsInput>;
  ordersConnectionArgs: UnifiedSearchConnectionArgsInput;
  originTerminalUuid?: InputMaybe<Scalars['String']['input']>;
  quotesConnectionArgs: UnifiedSearchConnectionArgsInput;
  searchText: Scalars['String']['input'];
  unacceptedEdiAndApiOrdersConnectionArgs: UnifiedSearchConnectionArgsInput;
  unacceptedEmailOrdersConnectionArgs: UnifiedSearchConnectionArgsInput;
};

export type UnitBasedAccessorialCreateInput = {
  maximumCharge?: InputMaybe<Scalars['Float']['input']>;
  minimumCharge?: InputMaybe<Scalars['Float']['input']>;
  name: Scalars['String']['input'];
  ratePerUnit: Scalars['Float']['input'];
};

export type UnitBasedAccessorialEntity = AccessorialInterface & {
  __typename?: 'UnitBasedAccessorialEntity';
  accessorialDateRangeConfigs: Array<AccessorialDateRangeConfigEntity>;
  code?: Maybe<Scalars['String']['output']>;
  contact?: Maybe<ContactEntity>;
  contacts: Array<ContactEntity>;
  ediCode?: Maybe<Scalars['String']['output']>;
  enableQuickAdd: Scalars['Boolean']['output'];
  fuelProfile?: Maybe<FuelProfileEntity>;
  fuelProfileUuid?: Maybe<Scalars['String']['output']>;
  generalLedgerCode?: Maybe<GeneralLedgerCodeEntity>;
  invoiceDisplayName?: Maybe<Scalars['String']['output']>;
  isArchived?: Maybe<Scalars['Boolean']['output']>;
  isAuthoCodeRequired: Scalars['Boolean']['output'];
  isDefaultGlobalSpecial: Scalars['Boolean']['output'];
  isSpecial?: Maybe<Scalars['Boolean']['output']>;
  matchingCustomerAccessorials?: Maybe<Array<AccessorialUnion>>;
  matchingGlobalAccessorial?: Maybe<AccessorialUnion>;
  maximumCharge?: Maybe<Scalars['Float']['output']>;
  minimumCharge?: Maybe<Scalars['Float']['output']>;
  name: Scalars['String']['output'];
  percentForSettlement?: Maybe<Scalars['Float']['output']>;
  quickbooksDesktopAccessorialId?: Maybe<Scalars['String']['output']>;
  quickbooksFileMappingChargeName?: Maybe<Scalars['String']['output']>;
  quickbooksMappingId: Scalars['String']['output'];
  /** Rate in dollars */
  ratePerUnit: Scalars['Float']['output'];
  terminal?: Maybe<TerminalEntity>;
  terminalUuid?: Maybe<Scalars['String']['output']>;
  type?: Maybe<AccessorialType>;
  uuid: Scalars['String']['output'];
};

export type UnitBasedAccessorialUpdateInput = {
  maximumCharge?: InputMaybe<Scalars['Float']['input']>;
  minimumCharge?: InputMaybe<Scalars['Float']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  ratePerUnit?: InputMaybe<Scalars['Float']['input']>;
  uuid: Scalars['String']['input'];
};

export enum UnitOfMeasure {
  Box = 'BOX',
  Carton = 'CARTON',
  Crate = 'CRATE',
  Each = 'EACH',
  Pallet = 'PALLET',
  Skid = 'SKID',
  Unit = 'UNIT'
}

export type UnpickStorageUnitInput = {
  uuid: Scalars['String']['input'];
};

export type UnpickStorageUnitOutput = {
  __typename?: 'UnpickStorageUnitOutput';
  success: Scalars['Boolean']['output'];
};

export type UnpostInvoiceInput = {
  uuid: Scalars['String']['input'];
};

export type UnpostInvoiceOutput = {
  __typename?: 'UnpostInvoiceOutput';
  success: Scalars['Boolean']['output'];
};

export type UpdateAccessorialContactInput = {
  accessorialUuid?: InputMaybe<Scalars['String']['input']>;
  contactUuid?: InputMaybe<Scalars['String']['input']>;
  uuid: Scalars['String']['input'];
};

export type UpdateAccessorialContactOutput = {
  __typename?: 'UpdateAccessorialContactOutput';
  success: Scalars['Boolean']['output'];
};

export type UpdateAccessorialDateRangeConfigInput = {
  accessorialDateRangeConfigToCopyUuid?: InputMaybe<Scalars['String']['input']>;
  accessorialRangeCreateInputs?: InputMaybe<Array<AccessorialRangeCreateInput>>;
  accessorialRangeUpdateInputs?: InputMaybe<Array<AccessorialRangeUpdateInput>>;
  accessorialUuid?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  fuelProfileUuid?: InputMaybe<Scalars['String']['input']>;
  fuelSurchargePercentageRate?: InputMaybe<Scalars['Float']['input']>;
  percentForSettlement?: InputMaybe<Scalars['Float']['input']>;
  rateUsd?: InputMaybe<Scalars['Float']['input']>;
  specialAccessorialChargeGroupUpdateInputs?: InputMaybe<Array<SpecialAccessorialChargeGroupUpdateInput>>;
  specialAccessorialMatrixItemUpdateInputs?: InputMaybe<Array<SpecialAccessorialMatrixItemUpdateInput>>;
  specialChargeGroupCreateInputs?: InputMaybe<Array<SpecialAccessorialChargeGroupCreateInput>>;
  specialMatrixItemsCreateInputs?: InputMaybe<Array<SpecialAccessorialMatrixItemCreateInput>>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  uuid: Scalars['String']['input'];
};

export type UpdateAccessorialDateRangeConfigOutput = {
  __typename?: 'UpdateAccessorialDateRangeConfigOutput';
  success: Scalars['Boolean']['output'];
};

export type UpdateAccessorialInput = {
  accessorialUpdateInput: AccessorialUpdateInput;
};

export type UpdateAddressInput = {
  addressUpdateInput: AddressUpdateInput;
  contactPersonUpsertInput?: InputMaybe<ContactPersonUpsertInput>;
};

export type UpdateAirportInfoInput = {
  addressUpsertInput?: InputMaybe<AddressUpsertInput>;
  addressUuid?: InputMaybe<Scalars['String']['input']>;
  companyUuid?: InputMaybe<Scalars['String']['input']>;
  iataCode?: InputMaybe<Scalars['String']['input']>;
  terminal?: InputMaybe<Scalars['String']['input']>;
  uuid: Scalars['String']['input'];
};

export type UpdateApiUserInput = {
  apiUserUpdateInput: ApiUserUpdateInput;
};

export type UpdateAutoApplyAccessorialConfigInput = {
  accessorialUuid?: InputMaybe<Scalars['String']['input']>;
  accessorialUuids?: InputMaybe<Array<Scalars['String']['input']>>;
  contactUuid?: InputMaybe<Scalars['String']['input']>;
  contactsToExcludeUuids?: InputMaybe<Array<Scalars['String']['input']>>;
  contactsToIncludeUuids?: InputMaybe<Array<Scalars['String']['input']>>;
  ruleType?: InputMaybe<AutoApplyAccessorialRuleType>;
  serviceUuid?: InputMaybe<Scalars['String']['input']>;
  stopType?: InputMaybe<PickupOrDelivery>;
  tagUuid?: InputMaybe<Scalars['String']['input']>;
  terminalUuid?: InputMaybe<Scalars['String']['input']>;
  uuid: Scalars['String']['input'];
};

export type UpdateBusinessDivisionInput = {
  name?: InputMaybe<Scalars['String']['input']>;
  uuid: Scalars['String']['input'];
};

export type UpdateBusinessDivisionOutput = {
  __typename?: 'UpdateBusinessDivisionOutput';
  success: Scalars['Boolean']['output'];
};

export type UpdateCompanyConfigurationInput = {
  addOrdersToOpenInvoices?: InputMaybe<Scalars['Boolean']['input']>;
  allCapsInOrderPage?: InputMaybe<Scalars['Boolean']['input']>;
  allowDriverToSelectNextStop?: InputMaybe<Scalars['Boolean']['input']>;
  alternateIsaId?: InputMaybe<Scalars['String']['input']>;
  alternateStandardCarrierAlphaCode?: InputMaybe<Scalars['String']['input']>;
  appointmentChangeCutoffHours?: InputMaybe<Scalars['Int']['input']>;
  appointmentSchedulingCutoffDays?: InputMaybe<Scalars['Int']['input']>;
  appointmentSchedulingLeadingBufferHours?: InputMaybe<Scalars['Int']['input']>;
  appointmentSchedulingSlotHours?: InputMaybe<Scalars['Int']['input']>;
  autoApplyWaitTimeMinutes?: InputMaybe<Scalars['Boolean']['input']>;
  autoGroupStops?: InputMaybe<Scalars['Boolean']['input']>;
  autoMatchEodDocumentsToOrders?: InputMaybe<Scalars['Boolean']['input']>;
  billableRecoveriesTransfers?: InputMaybe<Scalars['Boolean']['input']>;
  blockSendingZeroDollarInvoices?: InputMaybe<Scalars['Boolean']['input']>;
  companyLandscapeLogoUrl?: InputMaybe<Scalars['String']['input']>;
  companyOrdinalStart?: InputMaybe<Scalars['Int']['input']>;
  companySquareLogoUrl?: InputMaybe<Scalars['String']['input']>;
  createRecurringOrdersInAdvanceHours?: InputMaybe<Scalars['Int']['input']>;
  customDunningReportFooter?: InputMaybe<Scalars['String']['input']>;
  customDunningReportHeader?: InputMaybe<Scalars['String']['input']>;
  debounceAccessorialSearch?: InputMaybe<Scalars['Boolean']['input']>;
  debounceContactSearch?: InputMaybe<Scalars['Boolean']['input']>;
  defaultDimFactor?: InputMaybe<Scalars['Int']['input']>;
  defaultFuelSettlementPercentageRate?: InputMaybe<Scalars['Float']['input']>;
  defaultFuelSurcharge?: InputMaybe<Scalars['Float']['input']>;
  defaultFuelSurchargeBillingMethod?: InputMaybe<FuelBillingMethod>;
  defaultGenerateAppointmentDurationInMinutes?: InputMaybe<Scalars['Int']['input']>;
  defaultInvoiceDocumentsRequired?: InputMaybe<Array<DocumentType>>;
  defaultInvoiceEmailSubject?: InputMaybe<Scalars['String']['input']>;
  defaultMeasurementUnits?: InputMaybe<MeasurementUnits>;
  defaultNonCompanyDriverSettlementMode?: InputMaybe<SettlementMode>;
  defaultRouteLoadTimeInMinutes?: InputMaybe<Scalars['Float']['input']>;
  defaultRouteStartTime?: InputMaybe<Scalars['String']['input']>;
  defaultRouteUnloadTimeInMinutes?: InputMaybe<Scalars['Float']['input']>;
  defaultStandardStopType?: InputMaybe<StandardStopType>;
  defaultToAccessorial?: InputMaybe<Scalars['Boolean']['input']>;
  driversShouldMarkFreightAsLoaded?: InputMaybe<Scalars['Boolean']['input']>;
  ediPodFilenamePrefix?: InputMaybe<Scalars['String']['input']>;
  enableConsolidatedOrders?: InputMaybe<Scalars['Boolean']['input']>;
  enableDigitalSignatureFlow?: InputMaybe<Scalars['Boolean']['input']>;
  enablePaymentMethod?: InputMaybe<Scalars['Boolean']['input']>;
  fourthAlternateIsaId?: InputMaybe<Scalars['String']['input']>;
  fourthAlternateScac?: InputMaybe<Scalars['String']['input']>;
  fulfillmentTypeEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  getDriverLocationDataFromMobile?: InputMaybe<Scalars['Boolean']['input']>;
  includeHyphensInInvoiceName?: InputMaybe<Scalars['Boolean']['input']>;
  includeINVInInvoiceName?: InputMaybe<Scalars['Boolean']['input']>;
  invoiceEmail?: InputMaybe<Scalars['String']['input']>;
  invoiceNotes?: InputMaybe<Scalars['String']['input']>;
  invoicePdfLogoUrl?: InputMaybe<Scalars['String']['input']>;
  isCourier?: InputMaybe<Scalars['Boolean']['input']>;
  isaId?: InputMaybe<Scalars['String']['input']>;
  lineHaulEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  logisticsSectionEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  minDigitsInCompanyOrdinalOrderName?: InputMaybe<Scalars['Int']['input']>;
  mobilePollingIntervalInSeconds?: InputMaybe<Scalars['Float']['input']>;
  notificationsEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  orderIdentifierForCoverSheet?: InputMaybe<OrderIdentifier>;
  orderNameOrdinal?: InputMaybe<Scalars['Int']['input']>;
  orderNamingScheme?: InputMaybe<OrderNamingScheme>;
  packageWarehouseLocationsEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  pointToPointTariffsEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  qbInvoiceNumberStart?: InputMaybe<Scalars['Int']['input']>;
  requireDimsToFinalizeCharges?: InputMaybe<Scalars['Boolean']['input']>;
  requireDriverToAcknowledgeRouteChange?: InputMaybe<Scalars['Boolean']['input']>;
  requireDriverToConfirmStopCompletedAtTime?: InputMaybe<Scalars['Boolean']['input']>;
  requirePODPhotoAndName?: InputMaybe<Scalars['Boolean']['input']>;
  requirePODPhotoAndNameForPickups?: InputMaybe<Scalars['Boolean']['input']>;
  requirePODPhotoForDeliveries?: InputMaybe<Scalars['Boolean']['input']>;
  requirePODPhotoForPickups?: InputMaybe<Scalars['Boolean']['input']>;
  requireReviewForEdiOrderCreation?: InputMaybe<Scalars['Boolean']['input']>;
  requireSigneeNameForDeliveries?: InputMaybe<Scalars['Boolean']['input']>;
  requireSigneeNameForPickups?: InputMaybe<Scalars['Boolean']['input']>;
  restrictEditingOrderName?: InputMaybe<Scalars['Boolean']['input']>;
  sameDayDispatchCellHeader?: InputMaybe<SameDayDispatchCellHeader>;
  secondAlternateIsaId?: InputMaybe<Scalars['String']['input']>;
  secondAlternateScac?: InputMaybe<Scalars['String']['input']>;
  sendSummaryEmailWithIncompleteRoutes?: InputMaybe<Scalars['Boolean']['input']>;
  sendgridSenderId?: InputMaybe<Scalars['String']['input']>;
  serviceLevelOptional?: InputMaybe<Scalars['Boolean']['input']>;
  showChargesOnCustomerPortal?: InputMaybe<Scalars['Boolean']['input']>;
  showDriverSettlementInBilling?: InputMaybe<Scalars['Boolean']['input']>;
  showHelpersColumnInDispatch?: InputMaybe<Scalars['Boolean']['input']>;
  showKilogramsAndCentimeters?: InputMaybe<Scalars['Boolean']['input']>;
  showManuallyConfirmedByDefault?: InputMaybe<Scalars['Boolean']['input']>;
  showVehicleInDailyDispatch?: InputMaybe<Scalars['Boolean']['input']>;
  standardCarrierAlphaCode?: InputMaybe<Scalars['String']['input']>;
  startingInvoiceOrdinalNumber?: InputMaybe<Scalars['Float']['input']>;
  stediPartnerId?: InputMaybe<Scalars['String']['input']>;
  terminalsEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  textNextCustomerForAppointments?: InputMaybe<Scalars['Boolean']['input']>;
  thirdAlternateIsaId?: InputMaybe<Scalars['String']['input']>;
  thirdAlternateScac?: InputMaybe<Scalars['String']['input']>;
  timeZone?: InputMaybe<Scalars['String']['input']>;
  useDriverNumberForDispatch?: InputMaybe<Scalars['Boolean']['input']>;
  useJournalNumberForInvoice?: InputMaybe<Scalars['Boolean']['input']>;
  useSageBusinessWorks?: InputMaybe<Scalars['Boolean']['input']>;
  uuid: Scalars['String']['input'];
  wmsAutoMarkOnHand?: InputMaybe<Scalars['Boolean']['input']>;
  wmsEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  wmsShortTermStorageEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  wmsStorageOrdersEnabled?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateCompanyInput = {
  alternateIsaId?: InputMaybe<Scalars['String']['input']>;
  alternateStandardCarrierAlphaCode?: InputMaybe<Scalars['String']['input']>;
  apiName?: InputMaybe<Scalars['String']['input']>;
  blockSendingZeroDollarInvoices?: InputMaybe<Scalars['Boolean']['input']>;
  companyLandscapeLogoUrl?: InputMaybe<Scalars['String']['input']>;
  companySquareLogoUrl?: InputMaybe<Scalars['String']['input']>;
  /** A JSON object that represents the set of configurations for the company */
  configs?: InputMaybe<Scalars['String']['input']>;
  customDunningReportFooter?: InputMaybe<Scalars['String']['input']>;
  customDunningReportHeader?: InputMaybe<Scalars['String']['input']>;
  defaultAddressCreateInput?: InputMaybe<AddressCreateInput>;
  defaultAddressUpdateInput?: InputMaybe<AddressUpdateInput>;
  defaultInboundEdiServiceUuid?: InputMaybe<Scalars['String']['input']>;
  defaultInboundOutboundEdiServiceUuid?: InputMaybe<Scalars['String']['input']>;
  defaultInvoiceEmailSubject?: InputMaybe<Scalars['String']['input']>;
  defaultLineHaulSettlementTariffChainId?: InputMaybe<Scalars['String']['input']>;
  defaultLineHaulTariffChainId?: InputMaybe<Scalars['String']['input']>;
  defaultMeasurementUnits?: InputMaybe<MeasurementUnits>;
  defaultNonCompanyDriverSettlementMode?: InputMaybe<SettlementMode>;
  defaultOrdinarySettlementTariffChainId?: InputMaybe<Scalars['String']['input']>;
  defaultOrdinaryTariffChainId?: InputMaybe<Scalars['String']['input']>;
  defaultOutboundEdiServiceUuid?: InputMaybe<Scalars['String']['input']>;
  defaultPointToPointSettlementTariffChainId?: InputMaybe<Scalars['String']['input']>;
  defaultPointToPointTariffChainId?: InputMaybe<Scalars['String']['input']>;
  defaultTransferSettlementTariffChainId?: InputMaybe<Scalars['String']['input']>;
  defaultTransferTariffChainId?: InputMaybe<Scalars['String']['input']>;
  defaultWeightUnits?: InputMaybe<WeightUnits>;
  ediPodFilenamePrefix?: InputMaybe<Scalars['String']['input']>;
  fourthAlternateIsaId?: InputMaybe<Scalars['String']['input']>;
  fourthAlternateScac?: InputMaybe<Scalars['String']['input']>;
  freightChargeQuickbooksMappingId?: InputMaybe<Scalars['String']['input']>;
  freightSnapId?: InputMaybe<Scalars['String']['input']>;
  fuelChargeQuickbooksMappingId?: InputMaybe<Scalars['String']['input']>;
  invoiceEmail?: InputMaybe<Scalars['String']['input']>;
  isCourier?: InputMaybe<Scalars['Boolean']['input']>;
  isaId?: InputMaybe<Scalars['String']['input']>;
  miscCustomChargeQuickbooksMappingId?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  orderNameOrdinal?: InputMaybe<Scalars['Int']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  purchasedProductOfferings?: InputMaybe<Array<PalletProductOffering>>;
  qbInvoiceNumberStart?: InputMaybe<Scalars['Float']['input']>;
  quickbooksCompanyId?: InputMaybe<Scalars['String']['input']>;
  quickbooksDesktopAccessorialId?: InputMaybe<Scalars['String']['input']>;
  quickbooksDesktopAccountsReceivableId?: InputMaybe<Scalars['String']['input']>;
  quickbooksDesktopCompanyId?: InputMaybe<Scalars['String']['input']>;
  quickbooksDesktopDeliveryId?: InputMaybe<Scalars['String']['input']>;
  quickbooksDesktopFuelChargeId?: InputMaybe<Scalars['String']['input']>;
  quickbooksDesktopLineHaulId?: InputMaybe<Scalars['String']['input']>;
  quickbooksDesktopOrderChargeId?: InputMaybe<Scalars['String']['input']>;
  quickbooksDesktopPickupId?: InputMaybe<Scalars['String']['input']>;
  quickbooksDesktopTransferId?: InputMaybe<Scalars['String']['input']>;
  quickbooksFileMappingAccessorialChargeName?: InputMaybe<Scalars['String']['input']>;
  quickbooksFileMappingFreightChargeName?: InputMaybe<Scalars['String']['input']>;
  quickbooksFileMappingFuelChargeName?: InputMaybe<Scalars['String']['input']>;
  quickbooksFileMappingPickupChargeName?: InputMaybe<Scalars['String']['input']>;
  secondAlternateIsaId?: InputMaybe<Scalars['String']['input']>;
  secondAlternateScac?: InputMaybe<Scalars['String']['input']>;
  segment?: InputMaybe<Segment>;
  sendgridSenderId?: InputMaybe<Scalars['String']['input']>;
  standardCarrierAlphaCode?: InputMaybe<Scalars['String']['input']>;
  stediPartnerId?: InputMaybe<Scalars['String']['input']>;
  thirdAlternateIsaId?: InputMaybe<Scalars['String']['input']>;
  thirdAlternateScac?: InputMaybe<Scalars['String']['input']>;
  timeZone?: InputMaybe<Scalars['String']['input']>;
  useSageBusinessWorks?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateContactCommentInput = {
  comment?: InputMaybe<Scalars['String']['input']>;
  contactUuid?: InputMaybe<Scalars['String']['input']>;
  userUuid?: InputMaybe<Scalars['String']['input']>;
  /** The UUID of the contact comment to be updated */
  uuid: Scalars['String']['input'];
};

export type UpdateContactCommentOutput = MutationErrorOutput | UpdateContactCommentSuccessOutput;

export type UpdateContactCommentSuccessOutput = {
  __typename?: 'UpdateContactCommentSuccessOutput';
  success: Scalars['Boolean']['output'];
};

export type UpdateContactCommunicationConfigInput = {
  updateContactCommunicationConfigInput: ContactCommunicationConfigUpdateInput;
};

export type UpdateContactEmailsInput = {
  communicationTypes: Array<ContactCommunicationType>;
  contactUuid: Scalars['String']['input'];
  orderUpdateEmails: Array<Scalars['String']['input']>;
};

export type UpdateContactEmailsOutput = MutationErrorOutput | UpdateContactEmailsSuccessOutput;

export type UpdateContactEmailsSuccessOutput = {
  __typename?: 'UpdateContactEmailsSuccessOutput';
  contactCommunicationConfigs: Array<ContactCommunicationConfigEntity>;
  contactEmails: Array<ContactEmailEntity>;
  contactUuid: Scalars['String']['output'];
};

export type UpdateContactPersonInput = {
  contactPersonUpdateInput: ContactPersonUpdateInput;
  stopUuid?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateContactQuickbooksIdInput = {
  quickbooksContactId?: InputMaybe<Scalars['String']['input']>;
  uuid: Scalars['String']['input'];
};

export type UpdateContactQuickbooksIdsInput = {
  updateQuickbooksIdInputs: Array<UpdateContactQuickbooksIdInput>;
};

export type UpdateCsvOrderFieldMappingInput = {
  sourceColumnName?: InputMaybe<Scalars['String']['input']>;
  targetFieldType?: InputMaybe<CsvOrderMappingTargetFieldType>;
  uuid: Scalars['String']['input'];
};

export type UpdateCsvOrderImportTransactionInput = {
  message?: InputMaybe<Scalars['String']['input']>;
  orderUuid?: InputMaybe<Scalars['String']['input']>;
  status: CsvOrderImportTransactionStatus;
  uuid: Scalars['String']['input'];
};

export type UpdateCsvOrderMappingInput = {
  companyUuid?: InputMaybe<Scalars['String']['input']>;
  contactUuid?: InputMaybe<Scalars['String']['input']>;
  csvOrderFieldMappingCreateInputs?: InputMaybe<Array<CreateCsvOrderFieldMappingInput>>;
  deadlineDateDefaultValue?: InputMaybe<Scalars['DateTime']['input']>;
  deadlineTypeDefaultValue?: InputMaybe<DeadlineType>;
  enableDynamicInboundOrOutboundStop?: InputMaybe<Scalars['Boolean']['input']>;
  enableInboundStop?: InputMaybe<Scalars['Boolean']['input']>;
  enableOutboundStop?: InputMaybe<Scalars['Boolean']['input']>;
  freightBillingMethodDefaultValue?: InputMaybe<FreightBillingMethod>;
  name?: InputMaybe<Scalars['String']['input']>;
  pickupOrDeliveryDefaultValue?: InputMaybe<PickupOrDelivery>;
  serviceUuid?: InputMaybe<Scalars['String']['input']>;
  stopImportType?: InputMaybe<StopImportType>;
  stopTypeDefaultValue?: InputMaybe<StandardStopType>;
  uuid: Scalars['String']['input'];
};

export type UpdateCsvOrdersOrderInput = {
  packages: Array<CreateCsvOrdersPackageInput>;
  uuid: Scalars['String']['input'];
};

export type UpdateCustomerContactInput = {
  customerContactUpdateInput: CustomerContactUpdateInput;
};

export type UpdateCustomerContactOutput = {
  __typename?: 'UpdateCustomerContactOutput';
  customerContact: CustomerContactEntity;
};

export type UpdateCustomerContactPackageSpecsInput = {
  packageSpecIds: Array<Scalars['String']['input']>;
  useCustomPackageSpecs: Scalars['Boolean']['input'];
  uuid: Scalars['String']['input'];
};

export type UpdateCustomerContactVehicleTypesInput = {
  useCustomVehicleTypes: Scalars['Boolean']['input'];
  uuid: Scalars['String']['input'];
  vehicleTypeUuids: Array<Scalars['String']['input']>;
};

export type UpdateDefaultTariffChainsForCompany = MutationErrorOutput | UpdateDefaultTariffChainsForCompanySuccessOutput;

export type UpdateDefaultTariffChainsForCompanyInput = {
  defaultLineHaulTariffChainId?: InputMaybe<Scalars['String']['input']>;
  defaultOrdinarySettlementTariffChainId?: InputMaybe<Scalars['String']['input']>;
  defaultOrdinaryTariffChainId?: InputMaybe<Scalars['String']['input']>;
  defaultPointToPointTariffChainId?: InputMaybe<Scalars['String']['input']>;
  defaultTransferSettlementTariffChainId?: InputMaybe<Scalars['String']['input']>;
  defaultTransferTariffChainId?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateDefaultTariffChainsForCompanySuccessOutput = {
  __typename?: 'UpdateDefaultTariffChainsForCompanySuccessOutput';
  company: CompanyEntity;
};

export type UpdateDispatchTableColorsInput = {
  /** The new list of colors with the position in the array determining the precedence for selecting a color on the frontend */
  dispatchTableColors: Array<DispatchTableColorUpsertInput>;
};

export type UpdateDispatchTableColorsOutput = MutationErrorOutput | UpdateDispatchTableColorsSuccessOutput;

export type UpdateDispatchTableColorsSuccessOutput = {
  __typename?: 'UpdateDispatchTableColorsSuccessOutput';
  /** All of the dispatch table colors for the company in the configured order of precedence */
  dispatchTableColors: Array<DispatchTableColorEntity>;
};

export type UpdateDocumentInput = {
  documentUpdateInput: DocumentUpdateInput;
};

export type UpdateDocumentsInput = {
  documentUpdateInputs: Array<DocumentUpdateInput>;
};

export type UpdateDriverInput = {
  driverUpdateInput: DriverUpdateInput;
};

export type UpdateDriverLocationInput = {
  mobilePhoneLatitude: Scalars['Float']['input'];
  mobilePhoneLongitude: Scalars['Float']['input'];
  source?: InputMaybe<DriverLocationUpdateSource>;
};

export type UpdateDriverOutput = {
  __typename?: 'UpdateDriverOutput';
  driver: DriverEntity;
};

export type UpdateDriverQualificationsElementInput = {
  /** The ID of a driver qualification to update, or a new ID to create a new qualification. This must be a UUID. */
  id: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

export type UpdateDriverQualificationsInput = {
  driverQualifications: Array<UpdateDriverQualificationsElementInput>;
};

export type UpdateDriverQualificationsOutput = {
  __typename?: 'UpdateDriverQualificationsOutput';
  driverQualifications: Array<DriverQualificationEntity>;
};

export type UpdateDriverSettlementBillInput = {
  driverSettlementBillUpdateInput: DriverSettlementBillUpdateInput;
};

export type UpdateDriverSignableFormTemplateInput = {
  formText?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  uuid: Scalars['String']['input'];
};

export type UpdateEdiPartnershipInput = {
  allowEditingShipperBillOfLadingNumber?: InputMaybe<Scalars['Boolean']['input']>;
  alternateStediPartnerId?: InputMaybe<Scalars['String']['input']>;
  autoAcceptOrders?: InputMaybe<Scalars['Boolean']['input']>;
  canCreateMultipleStops?: InputMaybe<Scalars['Boolean']['input']>;
  companyStandardCarrierAlphaCode?: InputMaybe<Scalars['String']['input']>;
  companyUuid?: InputMaybe<Scalars['String']['input']>;
  contactUuid?: InputMaybe<Scalars['String']['input']>;
  edi214ShipmentStatuses?: InputMaybe<Array<Edi214ShipmentStatus>>;
  ediOutboundPayloadDestination?: InputMaybe<EdiOutboundPayloadDestination>;
  enableStaging?: InputMaybe<Scalars['Boolean']['input']>;
  excludeZeroChargeInvoices?: InputMaybe<Scalars['Boolean']['input']>;
  ignoreCancellations?: InputMaybe<Scalars['Boolean']['input']>;
  ignoreNonEdiOutbound?: InputMaybe<Scalars['Boolean']['input']>;
  includeItemizedChargesIn210?: InputMaybe<Scalars['Boolean']['input']>;
  includeOutboundFilenameReceiverIsaId?: InputMaybe<Scalars['Boolean']['input']>;
  mergeLineHaul?: InputMaybe<Scalars['Boolean']['input']>;
  outboundFilenameScacPrefix?: InputMaybe<Scalars['Boolean']['input']>;
  removeSpacesFrom214Bol?: InputMaybe<Scalars['Boolean']['input']>;
  requireGenerateEdi210Ids?: InputMaybe<Scalars['Boolean']['input']>;
  send990InResponseTo204?: InputMaybe<Scalars['Boolean']['input']>;
  send990InResponseTo211?: InputMaybe<Scalars['Boolean']['input']>;
  sendBackupDocs?: InputMaybe<Scalars['Boolean']['input']>;
  stedi210MappingId?: InputMaybe<Scalars['String']['input']>;
  stedi210TransactionSettingId?: InputMaybe<Scalars['String']['input']>;
  stedi214MappingId?: InputMaybe<Scalars['String']['input']>;
  stedi214TransactionSettingId?: InputMaybe<Scalars['String']['input']>;
  stedi990MappingId?: InputMaybe<Scalars['String']['input']>;
  stedi990TransactionSettingId?: InputMaybe<Scalars['String']['input']>;
  stediPartnershipId?: InputMaybe<Scalars['String']['input']>;
  tiffPodUpload?: InputMaybe<Scalars['Boolean']['input']>;
  timeOfPodUpload?: InputMaybe<TimeOfPodUpload>;
  useStediGenerateEdiFunction?: InputMaybe<Scalars['Boolean']['input']>;
  uuid: Scalars['String']['input'];
};

export type UpdateEdiPartnershipOutput = {
  __typename?: 'UpdateEdiPartnershipOutput';
  ediPartnership?: Maybe<EdiPartnershipEntity>;
};

export type UpdateEmailTransactionInput = {
  contactUuid?: InputMaybe<Scalars['String']['input']>;
  documentUuid?: InputMaybe<Scalars['String']['input']>;
  emailResponse?: InputMaybe<Scalars['String']['input']>;
  emailResponseStatus?: InputMaybe<Scalars['Int']['input']>;
  emails?: InputMaybe<Array<Scalars['String']['input']>>;
  failureReason?: InputMaybe<Scalars['String']['input']>;
  invoiceUuid?: InputMaybe<Scalars['String']['input']>;
  sendgridMessageId?: InputMaybe<Scalars['String']['input']>;
  uuid: Scalars['String']['input'];
};

export type UpdateEmailTransactionOutput = {
  __typename?: 'UpdateEmailTransactionOutput';
  success: Scalars['Boolean']['output'];
};

export type UpdateEndOfDayDocumentProcessingJobInput = {
  companyUuid?: InputMaybe<Scalars['String']['input']>;
  dateUploadedFor?: InputMaybe<Scalars['DateTime']['input']>;
  status: EndOfDayDocumentsProcessingJobStatus;
  terminalUuid?: InputMaybe<Scalars['String']['input']>;
  uploadedFileName?: InputMaybe<Scalars['String']['input']>;
  uuid: Scalars['String']['input'];
};

export type UpdateEquipmentInput = {
  equipmentUpdateInput: EquipmentUpdateInput;
};

export type UpdateEquipmentLicenseInput = {
  equipmentLicenseUpdateInput: EquipmentLicenseUpdateInput;
};

export type UpdateFeatureFlagCompanyOverrideInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  uuid: Scalars['String']['input'];
};

export type UpdateFeatureFlagInput = {
  featureFlagUpdateInput: FeatureFlagUpdateInput;
};

export type UpdateFeatureFlagUserOverrideInput = {
  active: Scalars['Boolean']['input'];
  uuid: Scalars['String']['input'];
};

export type UpdateFreightChargeInput = {
  freightChargeUpdateInput: FreightChargeUpdateInput;
};

export type UpdateFuelProfileDateRangeInput = {
  expirationDate?: InputMaybe<Scalars['DateTime']['input']>;
  flatRateUsdCents?: InputMaybe<Scalars['Float']['input']>;
  fuelProfileUuid?: InputMaybe<Scalars['String']['input']>;
  settlementPercentageRate?: InputMaybe<Scalars['Percent']['input']>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  surchargeRate?: InputMaybe<Scalars['Float']['input']>;
  uuid: Scalars['String']['input'];
};

export type UpdateFuelProfileDateRangeOutput = {
  __typename?: 'UpdateFuelProfileDateRangeOutput';
  error?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type UpdateFuelProfileInput = {
  billingType?: InputMaybe<FuelBillingMethod>;
  contactUuid?: InputMaybe<Scalars['String']['input']>;
  expirationDate?: InputMaybe<Scalars['DateTime']['input']>;
  flatRateUsdCents?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  surchargeRate?: InputMaybe<Scalars['Float']['input']>;
  type?: InputMaybe<FuelProfileType>;
  unappliedContactUuid?: InputMaybe<Scalars['String']['input']>;
  uuid: Scalars['String']['input'];
};

export type UpdateGeneralLedgerCodeOutput = MutationErrorOutput | UpdateGeneralLedgerCodeSuccessOutput;

export type UpdateGeneralLedgerCodeSuccessOutput = {
  __typename?: 'UpdateGeneralLedgerCodeSuccessOutput';
  generalLedgerCode: GeneralLedgerCodeEntity;
};

export type UpdateGeneralLedgerConfigurationOutput = MutationErrorOutput | UpdateGeneralLedgerConfigurationSuccessOutput;

export type UpdateGeneralLedgerConfigurationSuccessOutput = {
  __typename?: 'UpdateGeneralLedgerConfigurationSuccessOutput';
  generalLedgerConfiguration: GeneralLedgerConfigurationEntity;
};

export type UpdateInventoryItemsInput = {
  itemUuid: Scalars['String']['input'];
  /** The updated number of inventory items for the specified item and storage order */
  quantity: Scalars['Int']['input'];
  storageOrderUuid: Scalars['String']['input'];
  unitOfMeasure: UnitOfMeasure;
};

export type UpdateInventoryItemsOutput = {
  __typename?: 'UpdateInventoryItemsOutput';
  success: Scalars['Boolean']['output'];
};

export type UpdateInvoiceInput = {
  invoiceUpdateInput: InvoiceUpdateInput;
};

export type UpdateItemInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  productCost?: InputMaybe<Scalars['Float']['input']>;
  sellPrice?: InputMaybe<Scalars['Float']['input']>;
  sku?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<ItemStatus>;
  upsertInventoryPrimaryUnitOfMeasureInput?: InputMaybe<UpsertInventoryPrimaryUnitOfMeasureInput>;
  upsertInventorySecondaryUnitOfMeasureInput?: InputMaybe<UpsertInventorySecondaryUnitOfMeasureInput>;
  upsertItemStorageUnitConfigInput?: InputMaybe<UpsertItemStorageUnitConfigInput>;
  uuid: Scalars['String']['input'];
};

export type UpdateItemLocationInput = {
  name?: InputMaybe<Scalars['String']['input']>;
  /** The UUID of the item location to be updated */
  uuid: Scalars['String']['input'];
};

export type UpdateItemLocationOutput = {
  __typename?: 'UpdateItemLocationOutput';
  /** The item location that was created. It is null in the case a location with a duplicate name w.r.t to the company is passed in */
  itemLocation?: Maybe<ItemLocationEntity>;
};

export type UpdateLegDriverMapInput = {
  legDriverMapUpdateInput: LegDriverMapUpdateInput;
};

export type UpdateLineHaulLaneInput = {
  lineHaulLaneUpdateInput: LineHaulLaneUpdateInput;
};

export type UpdateLineHaulLaneOutput = {
  __typename?: 'UpdateLineHaulLaneOutput';
  errorMessage?: Maybe<Scalars['String']['output']>;
  lineHaulLane: LineHaulLaneEntity;
};

export type UpdateLineHaulManifestInput = {
  lineHaulManifestUpdateInput: LineHaulManifestUpdateInput;
};

export type UpdateLineHaulSegmentInput = {
  lineHaulSegmentUpdateInput: LineHaulSegmentUpdateInput;
};

export type UpdateManifestDriverInput = {
  driverUuid: Scalars['String']['input'];
  uuid: Scalars['String']['input'];
};

export type UpdateManifestVehicleInput = {
  equipmentUuid: Scalars['String']['input'];
  uuid: Scalars['String']['input'];
};

export type UpdateManifestsStatusInput = {
  manifestUuids: Array<Scalars['String']['input']>;
  status: LineHaulManifestStatus;
};

export type UpdateManifestsStatusOutput = MutationErrorOutput | UpdateManifestsStatusSuccessOutput;

export type UpdateManifestsStatusSuccessOutput = {
  __typename?: 'UpdateManifestsStatusSuccessOutput';
  lineHaulManifests: Array<LineHaulManifestEntity>;
};

export type UpdateMasterAccountInput = {
  name?: InputMaybe<Scalars['String']['input']>;
  uuid: Scalars['String']['input'];
};

export type UpdateMasterAccountOutput = {
  __typename?: 'UpdateMasterAccountOutput';
  success: Scalars['Boolean']['output'];
};

export type UpdateOrderCommentInput = {
  comment?: InputMaybe<Scalars['String']['input']>;
  orderUuid?: InputMaybe<Scalars['String']['input']>;
  showOnInvoice?: InputMaybe<Scalars['Boolean']['input']>;
  userUuid?: InputMaybe<Scalars['String']['input']>;
  /** The UUID of the order comment to be updated */
  uuid: Scalars['String']['input'];
};

export type UpdateOrderEventNotificationSubscriptionsInput = {
  contactUuid: Scalars['String']['input'];
  subscriptions: Array<OrderEventNotificationSubscriptionInput>;
};

export type UpdateOrderEventNotificationSubscriptionsOutput = MutationErrorOutput | UpdateOrderEventNotificationSubscriptionsSuccessOutput;

export type UpdateOrderEventNotificationSubscriptionsSuccessOutput = {
  __typename?: 'UpdateOrderEventNotificationSubscriptionsSuccessOutput';
  contactUuid: Scalars['String']['output'];
  subscriptions: Array<OrderEventNotificationSubscriptionEntity>;
};

export type UpdateOrderFormFieldsInput = {
  onePackageRequired: Scalars['Boolean']['input'];
  onePackageWeightRequired: Scalars['Boolean']['input'];
  packagePiecesRequired?: Scalars['Boolean']['input'];
  packageWeightRequired?: Scalars['Boolean']['input'];
};

export type UpdateOrderInput = {
  orderUpdateInput: OrderUpdateInput;
};

export type UpdateOrderLoadedStatusInput = {
  loaded: Scalars['Boolean']['input'];
  sentFromMobileApplication?: InputMaybe<Scalars['Boolean']['input']>;
  uuid: Scalars['String']['input'];
};

/** This is the graphql input for editing an organization. Identical to create input except we pass in uuid */
export type UpdateOrganizationInput = {
  customerFields?: InputMaybe<CreateOrUpdateCustomerInput>;
  defaultContactPersonUuid?: InputMaybe<Scalars['String']['input']>;
  ediApplicationId?: InputMaybe<Scalars['String']['input']>;
  ediContactCode?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  isaId?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  referenceNumber?: InputMaybe<Scalars['String']['input']>;
  stediPartnerId?: InputMaybe<Scalars['String']['input']>;
  types: Array<OrganizationType>;
  uuid: Scalars['String']['input'];
};

export type UpdateOrganizationOutput = MutationErrorOutput | UpdateOrganizationSuccessOutput;

export type UpdateOrganizationSuccessOutput = {
  __typename?: 'UpdateOrganizationSuccessOutput';
  /** The updated organization */
  organization: OrganizationEntity;
};

export type UpdatePackageArrayInput = {
  orderUuid: Scalars['String']['input'];
  packageArrayUpdateInputs: Array<PackageArrayUpdateInput>;
  shipmentUuid: Scalars['String']['input'];
};

export type UpdatePackageInput = {
  packageUpdateInput: PackageUpdateInput;
};

export type UpdatePackageSpecInput = {
  height?: InputMaybe<Scalars['Length']['input']>;
  id: Scalars['String']['input'];
  length?: InputMaybe<Scalars['Length']['input']>;
  name: Scalars['String']['input'];
  weight?: InputMaybe<Scalars['Mass']['input']>;
  width?: InputMaybe<Scalars['Length']['input']>;
};

export type UpdatePackageSpecOutput = {
  __typename?: 'UpdatePackageSpecOutput';
  packageSpec: PackageSpecEntity;
};

export type UpdatePackageWarehouseLocationInput = {
  uuid: Scalars['String']['input'];
  /** The UUID of the new warehouse location that the package is being moved to */
  warehouseLocationUuid: Scalars['String']['input'];
};

export type UpdatePackageWarehouseLocationOutput = {
  __typename?: 'UpdatePackageWarehouseLocationOutput';
  success: Scalars['Boolean']['output'];
};

export type UpdatePaperworkCompleteInput = {
  paperworkCompleted?: InputMaybe<Scalars['Boolean']['input']>;
  uuid: Scalars['String']['input'];
};

export type UpdatePaymentInput = {
  amountInCents?: InputMaybe<Scalars['Int']['input']>;
  comment?: InputMaybe<Scalars['String']['input']>;
  creditTypeUuid?: InputMaybe<Scalars['String']['input']>;
  date?: InputMaybe<Scalars['DateTime']['input']>;
  glTerminalUuid?: InputMaybe<Scalars['String']['input']>;
  paymentRail?: InputMaybe<PaymentRail>;
  referenceNumber?: InputMaybe<Scalars['String']['input']>;
  updatePaymentToOrderMappingInput: Array<UpdatePaymentOrderMappingInput>;
  uuid: Scalars['String']['input'];
};

export type UpdatePaymentOrderMappingInput = {
  amountInCents: Scalars['Int']['input'];
  orderUuid: Scalars['String']['input'];
};

export type UpdatePermissionAccessLevelInput = {
  accessLevel: AccessLevel;
  uuid: Scalars['String']['input'];
};

export type UpdatePermissionAccessLevelOutput = {
  __typename?: 'UpdatePermissionAccessLevelOutput';
  success: Scalars['Boolean']['output'];
};

export type UpdatePermissionInput = {
  accessLevel?: InputMaybe<AccessLevel>;
  permissionResource?: InputMaybe<PermissionResource>;
  roleUuid?: InputMaybe<Scalars['String']['input']>;
  uuid: Scalars['String']['input'];
};

export type UpdatePermissionOutput = {
  __typename?: 'UpdatePermissionOutput';
  success: Scalars['Boolean']['output'];
};

export type UpdatePersonInput = {
  contactStationIds?: InputMaybe<Array<Scalars['String']['input']>>;
  contactUuid: Scalars['String']['input'];
  defaultDeliveryAddress?: InputMaybe<AddressUpsertInput>;
  defaultPickupAddress?: InputMaybe<AddressUpsertInput>;
  defaultServiceUuid?: InputMaybe<Scalars['String']['input']>;
  defaultVehicleTypeUuid?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName: Scalars['String']['input'];
  id: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  phone?: InputMaybe<Scalars['String']['input']>;
};

export type UpdatePersonOutput = {
  __typename?: 'UpdatePersonOutput';
  person: PersonEntity;
};

export type UpdatePieceCountInput = {
  pieceCount?: InputMaybe<Scalars['Int']['input']>;
  sentFromMobileApplication?: InputMaybe<Scalars['Boolean']['input']>;
  /** The UUID of the order whose piece count is to be updated */
  uuid: Scalars['String']['input'];
};

export type UpdatePiecesPickedInput = {
  piecesPicked?: InputMaybe<Scalars['Int']['input']>;
  sentFromMobileApplication?: InputMaybe<Scalars['Boolean']['input']>;
  /** The UUID of the order whose pieces picked is to be updated */
  uuid: Scalars['String']['input'];
};

export type UpdatePlaceInput = {
  placeUpdateInput: PlaceUpdateInput;
};

export type UpdateQuickAddAccessorialsInput = {
  quickAddAccessorialUuids: Array<Scalars['String']['input']>;
};

export type UpdateQuickAddAccessorialsOutput = {
  __typename?: 'UpdateQuickAddAccessorialsOutput';
  quickAddAccessorials: Array<AccessorialUnion>;
};

export type UpdateQuickbooksHeaderFileMappingInput = {
  quickbooksHeaderFileMappingUpdateInput: QuickbooksHeaderFileMappingUpdateInput;
};

export type UpdateQuoteInput = {
  quoteUpdateInput: QuoteUpdateInput;
  uuid: Scalars['String']['input'];
};

export type UpdateRecurringOrderFrequencyInput = {
  daysOfMonth?: InputMaybe<Array<Scalars['Int']['input']>>;
  daysOfWeek?: InputMaybe<Array<DayOfWeekAll>>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  repeatFrequencyUnit?: InputMaybe<RepeatFrequencyUnit>;
  repeatInterval?: InputMaybe<Scalars['Int']['input']>;
  repeatIntervalWeeks?: InputMaybe<Scalars['Int']['input']>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  uuid: Scalars['String']['input'];
};

export type UpdateRoleInput = {
  isInternalRole?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  uuid: Scalars['String']['input'];
};

export type UpdateRoleOutput = {
  __typename?: 'UpdateRoleOutput';
  success: Scalars['Boolean']['output'];
};

export type UpdateRouteDriversInput = {
  driverUuids: Array<Scalars['String']['input']>;
  uuid: Scalars['String']['input'];
};

export type UpdateRouteInput = {
  routeUpdateInput: RouteUpdateInput;
};

export type UpdateRouteNameLocationInput = {
  routeNameLocationCreateInput?: InputMaybe<RouteNameLocationCreateInput>;
  routeNameLocationUpdateInput: RouteNameLocationUpdateInput;
  routeNameUuid?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateRouteOptimizationInput = {
  routeOptimizationUpdateInput: RouteOptimizationUpdateInput;
  uuid: Scalars['String']['input'];
};

export type UpdateRouteSlotInput = {
  ordinal?: InputMaybe<Scalars['Int']['input']>;
  routeSlotUpdateInput: RouteSlotUpdateInput;
};

export type UpdateRouteSlotsInput = {
  routeSlotArrayUpdateInputs: Array<RouteSlotArrayUpdateInput>;
  routeSlotsUpdatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  uuid: Scalars['String']['input'];
};

export type UpdateRunInput = {
  driverUuid?: InputMaybe<Scalars['String']['input']>;
  isArchived?: InputMaybe<Scalars['Boolean']['input']>;
  /** Because name cannot be cleared out, passing in an empty string, null, or undefined will have no effect */
  name?: InputMaybe<Scalars['String']['input']>;
  /** The UUIDs of the orders to be included under the run. Passing in null or undefined value will have no effect. */
  orderUuids?: InputMaybe<Array<Scalars['String']['input']>>;
  /** The UUIDs of the tags to be associated with this run. Passing in null or undefined value will have no effect. */
  tagUuids?: InputMaybe<Array<Scalars['String']['input']>>;
  terminalUuid?: InputMaybe<Scalars['String']['input']>;
  uuid: Scalars['String']['input'];
  vehicleTypeUuid?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateRunOutput = {
  __typename?: 'UpdateRunOutput';
  run: RunEntity;
};

export type UpdateSameDayDispatchConfigInput = {
  deliveryAppointmentTimeThreshold?: InputMaybe<Scalars['Int']['input']>;
  deliveryWithinTimeWindowColorCode?: InputMaybe<Scalars['String']['input']>;
  isNextInRouteColorCode?: InputMaybe<Scalars['String']['input']>;
  isPastDeadlineColorCode?: InputMaybe<Scalars['String']['input']>;
  isSpecialColorCode?: InputMaybe<Scalars['String']['input']>;
  pickupAppointmentTimeThreshold?: InputMaybe<Scalars['Int']['input']>;
  pickupWithinTimeWindowColorCode?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateSavedFilterViewInput = {
  dispatchTableFields?: InputMaybe<Array<DispatchTableField>>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  filterModelJson?: InputMaybe<Scalars['String']['input']>;
  filterModelJsonV2?: InputMaybe<Scalars['JSON']['input']>;
  isShared?: InputMaybe<Scalars['Boolean']['input']>;
  /** The new set of order columns to display for the saved filter view. If null, then the current set of order columns is maintained for the view */
  orderTableFields?: InputMaybe<Array<OrderTableField>>;
  savedViewPageType?: InputMaybe<FilterViewPage>;
  sortModelJson?: InputMaybe<Array<Scalars['JSON']['input']>>;
  uuid: Scalars['String']['input'];
};

export type UpdateScannedOrderInput = {
  companyUuid: Scalars['String']['input'];
  scannedOrderUpdateInput: ScannedOrderUpdateInput;
};

export type UpdateScannedOrderResultStatusInput = {
  /** Associate the result with this uuid. Used when an order is manually entered */
  orderUuid?: InputMaybe<Scalars['String']['input']>;
  scannedOrderResultUuid: Scalars['String']['input'];
  status: ScannedOrderResultStatus;
};

export type UpdateSchedulingRegionInput = {
  dailyCapacityPieces?: InputMaybe<Scalars['Int']['input']>;
  dailyCapacityStops?: InputMaybe<Scalars['Int']['input']>;
  dailyCapacityWeight?: InputMaybe<Scalars['Mass']['input']>;
  id: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateSchedulingRegionOutput = MutationErrorOutput | UpdateSchedulingRegionSuccessOutput;

export type UpdateSchedulingRegionSuccessOutput = {
  __typename?: 'UpdateSchedulingRegionSuccessOutput';
  schedulingRegion: SchedulingRegionEntity;
};

export type UpdateSchedulingZoneInput = {
  availabilities?: InputMaybe<Array<SchedulingZoneAvailabilityUpsertInput>>;
  id: Scalars['String']['input'];
  locations?: InputMaybe<Array<SchedulingZoneLocationUpsertInput>>;
  name?: InputMaybe<Scalars['String']['input']>;
  schedulingRegionId?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateSchedulingZoneOutput = MutationErrorOutput | UpdateSchedulingZoneSuccessOutput;

export type UpdateSchedulingZoneSuccessOutput = {
  __typename?: 'UpdateSchedulingZoneSuccessOutput';
  schedulingZone: SchedulingZoneEntity;
};

export type UpdateSchemaCompanyMappingInput = {
  id: Scalars['String']['input'];
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  terminalUuid?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateSchemaDocumentInput = {
  schemaDocument: SchemaDocumentInput;
  uuid: Scalars['String']['input'];
};

export type UpdateSchemaInput = {
  companyUuid?: InputMaybe<Scalars['String']['input']>;
  contactUuid?: InputMaybe<Scalars['String']['input']>;
  schema: SchemaInput;
  uuid: Scalars['String']['input'];
};

export type UpdateServiceDateForAssignedStopsInput = {
  serviceDate: Scalars['DateTime']['input'];
  /** The service date to set the stop sto, as an ISO 8601 formatted date string. */
  serviceDateIso8601?: InputMaybe<Scalars['String']['input']>;
  stopUuids: Array<Scalars['String']['input']>;
};

export type UpdateServiceInput = {
  serviceCreateInput?: InputMaybe<ServiceCreateInput>;
  serviceUpdateInput: ServiceUpdateInput;
};

export type UpdateServiceRegionInput = {
  id: Scalars['String']['input'];
  isArchived?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateServiceRegionOutput = MutationErrorOutput | UpdateServiceRegionSuccessOutput;

export type UpdateServiceRegionSuccessOutput = {
  __typename?: 'UpdateServiceRegionSuccessOutput';
  /** The updated service region */
  serviceRegion: ServiceRegionEntity;
};

export type UpdateSftpCredentialsInput = {
  ediPartnershipUuid?: InputMaybe<Scalars['String']['input']>;
  host?: InputMaybe<Scalars['String']['input']>;
  invoicePath?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  path?: InputMaybe<Scalars['String']['input']>;
  podNamingConvention?: InputMaybe<PodNamingConvention>;
  port?: InputMaybe<Scalars['Int']['input']>;
  username?: InputMaybe<Scalars['String']['input']>;
  uuid: Scalars['String']['input'];
};

export type UpdateShipmentInput = {
  ordinal?: InputMaybe<Scalars['Int']['input']>;
  shipmentUpdateInput: ShipmentUpdateInput;
};

export type UpdateShipmentStandardAccessorialsInput = {
  /** Accessorial uuids to keep. Any uuids excluded are removed */
  accessorialUuids: Array<Scalars['String']['input']>;
  shipmentUuid: Scalars['String']['input'];
};

export type UpdateStandardOrderInput = {
  orderUpdateInput: StandardOrderUpdateInput;
  /** The last known updatedAt timestamp from the client-side application. Used for validating concurrent updates to ensure data consistency. */
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type UpdateStandardShipmentFieldInput = {
  standardShipmentFieldsUpdateInput: StandardShipmentFieldsUpdateInput;
};

export type UpdateStopDriverMapInput = {
  stopDriverMapUpdateInput: StopDriverMapUpdateInput;
};

export type UpdateStopInput = {
  stopUpdateInput: StopUpdateInput;
};

export type UpdateStopsInput = {
  stopUpdateInputs: Array<StopUpdateInput>;
};

export type UpdateStorageOrderInput = {
  arrivedAt?: InputMaybe<Scalars['DateTime']['input']>;
  billOfLadingNumber?: InputMaybe<Scalars['String']['input']>;
  carrier?: InputMaybe<Scalars['String']['input']>;
  consigneeName?: InputMaybe<Scalars['String']['input']>;
  /** The UUID of the contact for whom the storage order is being created */
  contactUuid?: InputMaybe<Scalars['String']['input']>;
  documentUpsertInputs?: InputMaybe<Array<DocumentUpsertInput>>;
  expectedAt?: InputMaybe<Scalars['DateTime']['input']>;
  lotNumber?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  pickupDate?: InputMaybe<Scalars['DateTime']['input']>;
  purchaseOrderNumber?: InputMaybe<Scalars['String']['input']>;
  referenceNumber?: InputMaybe<Scalars['String']['input']>;
  sealNumber?: InputMaybe<Scalars['String']['input']>;
  supplierCompanyName?: InputMaybe<Scalars['String']['input']>;
  trackingNumber?: InputMaybe<Scalars['String']['input']>;
  trailerNumber?: InputMaybe<Scalars['String']['input']>;
  /** The UUID of the storage order being updated */
  uuid: Scalars['String']['input'];
  warehouseUuid?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateStorageOrderOutput = {
  __typename?: 'UpdateStorageOrderOutput';
  /** The storage order that was updated */
  storageOrder: StorageOrderEntity;
};

export type UpdateStorageUnitInput = {
  billed?: InputMaybe<Scalars['Boolean']['input']>;
  height?: InputMaybe<Scalars['Length']['input']>;
  inventoryLastVerifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  length?: InputMaybe<Scalars['Length']['input']>;
  markedOnHandAt?: InputMaybe<Scalars['DateTime']['input']>;
  markedOsdAt?: InputMaybe<Scalars['DateTime']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  osdReason?: InputMaybe<Scalars['String']['input']>;
  outboundReferenceNumber?: InputMaybe<Scalars['String']['input']>;
  pickedAt?: InputMaybe<Scalars['DateTime']['input']>;
  storageOrderUuid?: InputMaybe<Scalars['String']['input']>;
  unitOfMeasure?: InputMaybe<UnitOfMeasure>;
  uuid: Scalars['String']['input'];
  /** The UUID of the newly assigned warehouse location for the storage unit. */
  warehouseLocationUuid?: InputMaybe<Scalars['String']['input']>;
  weight?: InputMaybe<Scalars['Mass']['input']>;
  width?: InputMaybe<Scalars['Length']['input']>;
};

export type UpdateStorageUnitOutput = {
  __typename?: 'UpdateStorageUnitOutput';
  storageUnit: StorageUnitEntity;
};

export type UpdateTagInput = {
  tagUpdateInput: TagUpdateInput;
};

export type UpdateTariffChainInput = {
  id: Scalars['String']['input'];
  name: Scalars['String']['input'];
  tariffGroupUuids: Array<Scalars['String']['input']>;
};

export type UpdateTariffChainOutput = MutationErrorOutput | UpdateTariffChainSuccessOutput;

export type UpdateTariffChainSuccessOutput = {
  __typename?: 'UpdateTariffChainSuccessOutput';
  /** The tariff chain that was updated */
  tariffChain: TariffChainEntity;
};

export type UpdateTariffGroupInput = {
  contactToServicesMappings?: InputMaybe<Array<CreateContactToServicesMappingInput>>;
  contactUuids?: InputMaybe<Array<Scalars['String']['input']>>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  fuelProfileUuid?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  parentTariffGroupUuid?: InputMaybe<Scalars['String']['input']>;
  rateMultiplier?: InputMaybe<Scalars['Float']['input']>;
  rateType?: InputMaybe<RateType>;
  serviceUuids?: InputMaybe<Array<Scalars['String']['input']>>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  tariffCreateInputs?: InputMaybe<Array<TariffCreateInput>>;
  tariffGroupScope?: InputMaybe<TariffGroupScope>;
  tariffGroupType?: InputMaybe<TariffGroupType>;
  tariffOverageRateCreates?: InputMaybe<Array<TariffOverageRateCreateInput>>;
  tariffType?: InputMaybe<TariffType>;
  tariffUpsertInputs: Array<TariffUpsertInput>;
  tariffZoneCreateInputs?: InputMaybe<Array<TariffZoneCreateInput>>;
  tariffZoneDeletes: Array<Scalars['String']['input']>;
  tariffZoneGroupId?: InputMaybe<Scalars['String']['input']>;
  tariffZoneUpdateInputs?: InputMaybe<Array<TariffZoneUpdateInput>>;
  terminalUuids?: InputMaybe<Array<Scalars['String']['input']>>;
  useActualWeightInCalculation?: InputMaybe<Scalars['Boolean']['input']>;
  useDeficitBilling?: InputMaybe<Scalars['Boolean']['input']>;
  uuid: Scalars['String']['input'];
  vehicleTypeUuids?: InputMaybe<Array<Scalars['String']['input']>>;
  zoneType?: InputMaybe<TariffZoneType>;
};

export type UpdateTerminalInput = {
  terminalUpdateInput: TerminalUpdateInput;
};

export type UpdateTerminalOutput = {
  __typename?: 'UpdateTerminalOutput';
  terminal: TerminalEntity;
};

export type UpdateTerminalSuccessOutput = {
  __typename?: 'UpdateTerminalSuccessOutput';
  /** The updated terminal */
  terminal: TerminalEntity;
};

export type UpdateTerminalV2Output = MutationErrorOutput | UpdateTerminalSuccessOutput;

export type UpdateTestOrderInput = {
  orderUuid?: InputMaybe<Scalars['String']['input']>;
  totalCharge?: InputMaybe<Scalars['Float']['input']>;
  totalFreightCharge?: InputMaybe<Scalars['Float']['input']>;
  totalFuelCharge?: InputMaybe<Scalars['Float']['input']>;
  uuid: Scalars['String']['input'];
};

export type UpdateTestOrderOutput = {
  __typename?: 'UpdateTestOrderOutput';
  success: Scalars['Boolean']['output'];
};

export type UpdateThirdPartyUserInput = {
  password: Scalars['String']['input'];
};

export type UpdateUserInput = {
  arrangeStopsAndRoutesVertically?: InputMaybe<Scalars['Boolean']['input']>;
  /** If set to true, the user is assigned an internal role that provides them with the master permission resource */
  assignInternalRole?: InputMaybe<Scalars['Boolean']['input']>;
  billingReviewOrderTableFields?: InputMaybe<Array<OrderTableField>>;
  companyUuid?: InputMaybe<Scalars['String']['input']>;
  dispatchTableColumnWidths?: InputMaybe<Scalars['JSON']['input']>;
  dispatchTableFields?: InputMaybe<Array<DispatchTableField>>;
  email?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  linehaulDispatchTableFields?: InputMaybe<Array<LinehaulDispatchTableField>>;
  name?: InputMaybe<Scalars['String']['input']>;
  numberOfStops?: InputMaybe<Scalars['Float']['input']>;
  orderTableFields?: InputMaybe<Array<OrderTableField>>;
  password?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  redirectIsAlertedOnFirstSave?: InputMaybe<Scalars['Boolean']['input']>;
  redirectIsAlertedOnOpenOrder?: InputMaybe<Scalars['Boolean']['input']>;
  reportsEmail?: InputMaybe<Scalars['String']['input']>;
  /** The list of roles to assign to a user */
  roleUuids?: InputMaybe<Array<Scalars['String']['input']>>;
  routeCardStopTableColumnWidths?: InputMaybe<Scalars['JSON']['input']>;
  routeCardStopTableFields?: InputMaybe<Array<DispatchTableField>>;
  routeCardWidth?: InputMaybe<Scalars['Float']['input']>;
  sendAllInvoices?: InputMaybe<Scalars['Boolean']['input']>;
  sendSummaryEmailWithIncompleteRoutes?: InputMaybe<Scalars['Boolean']['input']>;
  terminalUuid?: InputMaybe<Scalars['String']['input']>;
  useMinimizedAppointmentTime?: InputMaybe<Scalars['Boolean']['input']>;
  uuid: Scalars['String']['input'];
};

export type UpdateWarehouseEmployeeInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  emailAddress?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  uuid: Scalars['String']['input'];
};

export type UpdateWarehouseEmployeeOutput = {
  __typename?: 'UpdateWarehouseEmployeeOutput';
  /** The updated warehouse employee. It is null if there is a duplicate phone number being used or a server-side error occurs. */
  warehouseEmployee?: Maybe<WarehouseEmployeeEntity>;
};

export type UpdateWarehouseInput = {
  addressUpdateInput: AddressUpdateInput;
  name: Scalars['String']['input'];
  terminalUuid?: InputMaybe<Scalars['String']['input']>;
  uuid: Scalars['String']['input'];
};

export type UpdateWarehouseLocationInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  location1?: InputMaybe<Scalars['String']['input']>;
  location2?: InputMaybe<Scalars['String']['input']>;
  location3?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** The UUID of the warehouse location to be updated */
  uuid: Scalars['String']['input'];
  warehouseUuid?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateWarehouseLocationOutput = {
  __typename?: 'UpdateWarehouseLocationOutput';
  /** An array of error messages. This is null if there are no errors. */
  errors?: Maybe<Array<Scalars['String']['output']>>;
  /** The warehouse location that was updated. This is null if there is a warehouse location with a duplicate name passed in or  */
  warehouseLocation?: Maybe<WarehouseLocationEntity>;
};

export type UploadMobileSignedDocumentInput = {
  fileName: Scalars['String']['input'];
  fileType: Scalars['String']['input'];
  orderUuid: Scalars['String']['input'];
  originalDocumentUuid: Scalars['String']['input'];
};

export type UploadMobileSignedDocumentOutput = {
  __typename?: 'UploadMobileSignedDocumentOutput';
  document?: Maybe<DocumentEntity>;
  errorMessage?: Maybe<Scalars['String']['output']>;
};

export type UpsertAddressInput = {
  addressUpsertInput: AddressUpsertInput;
  contactUuid: Scalars['String']['input'];
};

export type UpsertContactPersonInput = {
  contactPersonUpsertInput: ContactPersonUpsertInput;
  contactUuid: Scalars['String']['input'];
  stopUuid?: InputMaybe<Scalars['String']['input']>;
};

export type UpsertFreightChargeInput = {
  freightChargeUpsertInput: FreightChargeUpsertInput;
  shipmentUuid: Scalars['String']['input'];
};

export type UpsertInventoryPrimaryUnitOfMeasureInput = {
  unitOfMeasure: UnitOfMeasure;
  upcCode?: InputMaybe<Scalars['String']['input']>;
  uuid: Scalars['String']['input'];
};

export type UpsertInventorySecondaryUnitOfMeasureInput = {
  primaryUnitsPerSecondaryUOM?: InputMaybe<Scalars['Float']['input']>;
  unitOfMeasure: UnitOfMeasure;
  upcCode?: InputMaybe<Scalars['String']['input']>;
  uuid: Scalars['String']['input'];
};

export type UpsertItemGroupInput = {
  /** Increments the quantity of the item group. */
  incrementQuantityBy?: InputMaybe<Scalars['Int']['input']>;
  itemUuid: Scalars['String']['input'];
  /** Sets the quantity of the item group. Takes precedence over incrementQuantityBy. */
  quantity?: InputMaybe<Scalars['Int']['input']>;
  /** Dictates if a new storage unit should be created. if a storageUnitUuid is supplied it will take priority */
  shouldCreateStorageUnit?: InputMaybe<Scalars['Boolean']['input']>;
  storageOrderUuid: Scalars['String']['input'];
  storageUnitUuid?: InputMaybe<Scalars['String']['input']>;
  unitOfMeasure?: InputMaybe<UnitOfMeasure>;
};

export type UpsertItemStorageUnitConfigInput = {
  consolidationUnitUOM: UnitOfMeasure;
  dimensionsUOM: WarehouseMeasurementUnits;
  height: Scalars['Float']['input'];
  high: Scalars['Float']['input'];
  length: Scalars['Float']['input'];
  primaryUnitsPerConsolidationUnit: Scalars['Float']['input'];
  tie: Scalars['Float']['input'];
  type: MeasurementUnits;
  uuid: Scalars['String']['input'];
  weight: Scalars['Float']['input'];
  weightUOM: WarehouseMeasurementUnits;
  width: Scalars['Float']['input'];
};

export type UpsertPackageInput = {
  orderUuid: Scalars['String']['input'];
  packageUpsertInput: PackageUpsertInput;
  shipmentUuid: Scalars['String']['input'];
};

export type UpsertPickListItemGroup = {
  itemGroupUuid: Scalars['String']['input'];
  quantity: Scalars['Int']['input'];
};

export type UpsertPicklistInput = {
  date?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  /** List of item groups with quantities to be added to picklist */
  itemGroups: Array<UpsertPickListItemGroup>;
  outboundReferenceNumber?: InputMaybe<Scalars['String']['input']>;
};

export type UpsertPicklistOutput = {
  __typename?: 'UpsertPicklistOutput';
  error?: Maybe<Scalars['String']['output']>;
  picklist?: Maybe<PicklistEntity>;
};

export type UpsertSamsaraOauthTokenInput = {
  accessToken: Scalars['String']['input'];
  expiresAt: Scalars['DateTime']['input'];
  refreshToken: Scalars['String']['input'];
  scope: Scalars['String']['input'];
  tokenType: Scalars['String']['input'];
};

export type UpsertServiceAvailabilityDateInput = {
  availableEndTime?: InputMaybe<Scalars['DateTime']['input']>;
  availableStartTime?: InputMaybe<Scalars['DateTime']['input']>;
  /** The category or type of day. This uniquely identifies the ServiceAvailabilityDateEntity for the service. */
  dayCategory: SpecialDayOfWeek;
  enabled: Scalars['Boolean']['input'];
  end?: InputMaybe<PlainTimeInput>;
  start?: InputMaybe<PlainTimeInput>;
};

export type UpsertShipmentSubscriberInput = {
  shipmentSubscriberUpsertInput: ShipmentSubscriberUpsertInput;
  shipmentUuid: Scalars['String']['input'];
};

export type UpsertStopDriverMapInput = {
  stopDriverMapUpsertInput: StopDriverMapUpsertInput;
};

export type UserContactNotificationSubscriptionEntity = {
  __typename?: 'UserContactNotificationSubscriptionEntity';
  approveOrderNotification?: Maybe<Scalars['Boolean']['output']>;
  uuid: Scalars['String']['output'];
};

export type UserContactNotificationSubscriptionUpsertInput = {
  approveOrderNotification?: InputMaybe<Scalars['Boolean']['input']>;
  contactUuid: Scalars['String']['input'];
  uuid?: InputMaybe<Scalars['String']['input']>;
};

export type UserEntity = {
  __typename?: 'UserEntity';
  arrangeStopsAndRoutesVertically: Scalars['Boolean']['output'];
  billingReviewOrderTableFields: Array<OrderTableField>;
  company: CompanyEntity;
  createdAt: Scalars['DateTime']['output'];
  dispatchTableColumnWidths?: Maybe<Scalars['JSON']['output']>;
  dispatchTableFields: Array<DispatchTableField>;
  driver?: Maybe<DriverEntity>;
  /** The email address of the user, or an empty string if it is null. The frontend is migrating towards accepting a nullable user.email, but we need this field to return a string until all clients are updated to accept nullable emails */
  email: Scalars['String']['output'];
  isActive: Scalars['Boolean']['output'];
  linehaulDispatchTableFields: Array<LinehaulDispatchTableField>;
  name?: Maybe<Scalars['String']['output']>;
  numberOfStops: Scalars['Float']['output'];
  orderTableFields: Array<OrderTableField>;
  password?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  redirectIsAlertedOnFirstSave?: Maybe<Scalars['Boolean']['output']>;
  redirectIsAlertedOnOpenOrder?: Maybe<Scalars['Boolean']['output']>;
  reportsEmail?: Maybe<Scalars['String']['output']>;
  reportsEmailSendgridSenderId?: Maybe<Scalars['String']['output']>;
  roles: Array<RoleEntity>;
  routeCardStopTableColumnWidths?: Maybe<Scalars['JSON']['output']>;
  routeCardStopTableFields: Array<DispatchTableField>;
  routeCardWidth: Scalars['Float']['output'];
  sendAllInvoices?: Maybe<Scalars['Boolean']['output']>;
  sendSummaryEmailWithIncompleteRoutes: Scalars['Boolean']['output'];
  terminal?: Maybe<TerminalEntity>;
  useMinimizedAppointmentTime: Scalars['Boolean']['output'];
  uuid: Scalars['String']['output'];
};

/** UUID filter fields for the findLineHaulManifestsV2 query */
export type UuidFilterV2Simple = {
  /** Filters for records where the relevant UUID is equal to the provided UUID */
  eq?: InputMaybe<Scalars['String']['input']>;
  /** Filters for records where the relevant UUID is in the provided array of UUIDs */
  in?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Filters for records where the relevant UUID is not equal to the provided UUID */
  neq?: InputMaybe<Scalars['String']['input']>;
  /** Filters for records where the relevant UUID is not in the provided array of UUIDs */
  nin?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** A filter object that is used to filter a UUID list field. Each field in the filter object represents an operator. If there is more than one non-null field passed into the filter object, the condition will be a conjunction of the non-null field operators. */
export type UuidListFilter = {
  /** Filters for records where the relevant list contains the provided UUID */
  contains?: InputMaybe<Scalars['String']['input']>;
  /** Filters for records where the relevant list is empty (or null) */
  isEmpty?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filters for records where the relevant list is not empty */
  isNotEmpty?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filters for records where the relevant list does not contain the provided UUID */
  notContains?: InputMaybe<Scalars['String']['input']>;
};

export type ValidateCrownChargesInput = {
  /** The UUID of the company whose orders are being imported */
  companyUuid: Scalars['String']['input'];
  /** A publicly accessible URL of invoices with charges (CSV) */
  invoicesUrl?: InputMaybe<Scalars['String']['input']>;
  /** A publicly accessible URL of order charges (CSV) */
  ordersUrl: Scalars['String']['input'];
};

export type ValidateCrownChargesOutput = {
  __typename?: 'ValidateCrownChargesOutput';
  correctCrownIDs: Array<Scalars['String']['output']>;
  /** A 2D array of the CSV results of the rate validation */
  csvResults: Array<Array<Scalars['String']['output']>>;
  /** A publicly accessible URL of the rate validation results */
  resultsUrl: Scalars['String']['output'];
  wrongCrownIDs: Array<Scalars['String']['output']>;
};

export type ValidateImportedCrownInvoicesInput = {
  /** A publicly accessible URL of the charges breakdown report exported from Crown. Assumes all data has been sanitized (in plaintext format with no spaces in header names). */
  chargeBreakdownUrl: Scalars['String']['input'];
  companyUuid: Scalars['String']['input'];
  /** A publicly accessible URL of the open invoices report exported from Crown. Assumes all data has been sanitized (in plaintext format with no spaces in header names). */
  openInvoicesUrl: Scalars['String']['input'];
};

export type ValidateImportedCrownInvoicesOutput = {
  __typename?: 'ValidateImportedCrownInvoicesOutput';
  correctCrownIDs: Array<Scalars['String']['output']>;
  correctInvoiceIDs: Array<Scalars['String']['output']>;
  /** A 2D array of the CSV results of the invoice import validation */
  invoiceCsvResults: Array<Array<Scalars['String']['output']>>;
  /** A publicly accessible URL of the invoice import validation results */
  invoiceResultsUrl: Scalars['String']['output'];
  /** A 2D array of the CSV results of the invoice order import validation */
  orderCsvResults: Array<Array<Scalars['String']['output']>>;
  /** A publicly accessible URL of the invoice order import validation results */
  orderResultsUrl: Scalars['String']['output'];
  wrongCrownIDs: Array<Scalars['String']['output']>;
  wrongInvoiceIDs: Array<Scalars['String']['output']>;
};

export type VehicleTypeCreateInput = {
  capacityNotes?: InputMaybe<Scalars['String']['input']>;
  maxVolume?: InputMaybe<Scalars['Volume']['input']>;
  maxWeight?: InputMaybe<Scalars['Mass']['input']>;
  name: Scalars['String']['input'];
  packageSpecs?: InputMaybe<Array<VehicleTypePackageSpecUpsertInput>>;
};

export type VehicleTypeEntity = {
  __typename?: 'VehicleTypeEntity';
  capacityNotes?: Maybe<Scalars['String']['output']>;
  maxVolume?: Maybe<Scalars['Volume']['output']>;
  maxWeight?: Maybe<Scalars['Mass']['output']>;
  name: Scalars['String']['output'];
  status: VehicleTypeStatus;
  uuid: Scalars['String']['output'];
  vehicleTypePackageSpecs: Array<VehicleTypePackageSpecEntity>;
};

export type VehicleTypePackageSpecEntity = {
  __typename?: 'VehicleTypePackageSpecEntity';
  /** The ID of the VehicleTypePackageSpecEntity, not VehicleTypeEntity */
  id: Scalars['String']['output'];
  maxQuantity?: Maybe<Scalars['Int']['output']>;
  packageSpec: PackageSpecEntity;
};

export type VehicleTypePackageSpecUpsertInput = {
  /** The number of packages of this spec that the vehicle can carry */
  maxQuantity?: InputMaybe<Scalars['Int']['input']>;
  packageSpecId: Scalars['String']['input'];
};

export enum VehicleTypeStatus {
  Active = 'ACTIVE',
  Archived = 'ARCHIVED'
}

export type VehicleTypeUpdateInput = {
  capacityNotes?: InputMaybe<Scalars['String']['input']>;
  maxVolume?: InputMaybe<Scalars['Volume']['input']>;
  maxWeight?: InputMaybe<Scalars['Mass']['input']>;
  name: Scalars['String']['input'];
  packageSpecs?: InputMaybe<Array<VehicleTypePackageSpecUpsertInput>>;
  uuid: Scalars['String']['input'];
};

export type VehicleTypeUpdateOutput = {
  __typename?: 'VehicleTypeUpdateOutput';
  vehicleType: VehicleTypeEntity;
};

export type VerifyInventoryForStorageUnitInput = {
  /** The UUID of the storage unit to verify inventory for */
  uuid: Scalars['String']['input'];
};

export type VerifyInventoryForStorageUnitOutput = {
  __typename?: 'VerifyInventoryForStorageUnitOutput';
  success: Scalars['Boolean']['output'];
};

export type WaitTimeAccessorialCreateInput = {
  maximumCharge?: InputMaybe<Scalars['Float']['input']>;
  minimumCharge?: InputMaybe<Scalars['Float']['input']>;
  name: Scalars['String']['input'];
  rate: Scalars['Float']['input'];
  waitTimeChargePeriod: Scalars['Float']['input'];
  waitTimeFreeMinutes: Scalars['Float']['input'];
};

export type WaitTimeAccessorialEntity = AccessorialInterface & {
  __typename?: 'WaitTimeAccessorialEntity';
  accessorialDateRangeConfigs: Array<AccessorialDateRangeConfigEntity>;
  code?: Maybe<Scalars['String']['output']>;
  contact?: Maybe<ContactEntity>;
  contacts: Array<ContactEntity>;
  ediCode?: Maybe<Scalars['String']['output']>;
  enableQuickAdd: Scalars['Boolean']['output'];
  fuelProfile?: Maybe<FuelProfileEntity>;
  fuelProfileUuid?: Maybe<Scalars['String']['output']>;
  generalLedgerCode?: Maybe<GeneralLedgerCodeEntity>;
  invoiceDisplayName?: Maybe<Scalars['String']['output']>;
  isArchived?: Maybe<Scalars['Boolean']['output']>;
  isAuthoCodeRequired: Scalars['Boolean']['output'];
  isDefaultGlobalSpecial: Scalars['Boolean']['output'];
  isSpecial?: Maybe<Scalars['Boolean']['output']>;
  matchingCustomerAccessorials?: Maybe<Array<AccessorialUnion>>;
  matchingGlobalAccessorial?: Maybe<AccessorialUnion>;
  maximumCharge?: Maybe<Scalars['Float']['output']>;
  minimumCharge?: Maybe<Scalars['Float']['output']>;
  name: Scalars['String']['output'];
  percentForSettlement?: Maybe<Scalars['Float']['output']>;
  quickbooksDesktopAccessorialId?: Maybe<Scalars['String']['output']>;
  quickbooksFileMappingChargeName?: Maybe<Scalars['String']['output']>;
  quickbooksMappingId: Scalars['String']['output'];
  /** Rate in dollars */
  rate: Scalars['Float']['output'];
  terminal?: Maybe<TerminalEntity>;
  terminalUuid?: Maybe<Scalars['String']['output']>;
  type?: Maybe<AccessorialType>;
  uuid: Scalars['String']['output'];
  waitTimeChargePeriod?: Maybe<Scalars['Float']['output']>;
  waitTimeFreeMinutes?: Maybe<Scalars['Float']['output']>;
};

export type WaitTimeAccessorialUpdateInput = {
  maximumCharge?: InputMaybe<Scalars['Float']['input']>;
  minimumCharge?: InputMaybe<Scalars['Float']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  rate?: InputMaybe<Scalars['Float']['input']>;
  uuid: Scalars['String']['input'];
  waitTimeChargePeriod?: InputMaybe<Scalars['Float']['input']>;
  waitTimeFreeMinutes?: InputMaybe<Scalars['Float']['input']>;
};

export type WarehouseEmployeeEntity = {
  __typename?: 'WarehouseEmployeeEntity';
  active: Scalars['Boolean']['output'];
  company: CompanyEntity;
  createdAt: Scalars['DateTime']['output'];
  emailAddress?: Maybe<Scalars['String']['output']>;
  firstName: Scalars['String']['output'];
  lastName: Scalars['String']['output'];
  password?: Maybe<Scalars['String']['output']>;
  phoneNumber: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  uuid: Scalars['String']['output'];
};

export type WarehouseEntity = {
  __typename?: 'WarehouseEntity';
  address: AddressEntity;
  createdAt: Scalars['DateTime']['output'];
  isDefault: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  terminal?: Maybe<TerminalEntity>;
  updatedAt: Scalars['DateTime']['output'];
  uuid: Scalars['String']['output'];
};

export type WarehouseLocationEntity = {
  __typename?: 'WarehouseLocationEntity';
  createdAt: Scalars['DateTime']['output'];
  location1?: Maybe<Scalars['String']['output']>;
  location2?: Maybe<Scalars['String']['output']>;
  location3?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  uuid: Scalars['String']['output'];
  warehouse: WarehouseEntity;
};

export enum WarehouseMeasurementUnits {
  Centimeters = 'CENTIMETERS',
  CubicFeet = 'CUBIC_FEET',
  CubicInches = 'CUBIC_INCHES',
  Feet = 'FEET',
  Inches = 'INCHES',
  Kilograms = 'KILOGRAMS',
  Liters = 'LITERS',
  Meters = 'METERS',
  Milliliters = 'MILLILITERS',
  Ounces = 'OUNCES',
  Pounds = 'POUNDS',
  SquareFeet = 'SQUARE_FEET',
  Tonnes = 'TONNES'
}

export type WarehousesInput = {
  companyUuidFilter?: InputMaybe<Scalars['String']['input']>;
};

export type WeightBasedAccessorialCreateInput = {
  /** accessorial ranges to be created for this accessorial */
  accessorialRangeCreateInputs: Array<AccessorialRangeCreateInput>;
  maximumCharge?: InputMaybe<Scalars['Float']['input']>;
  minimumCharge?: InputMaybe<Scalars['Float']['input']>;
  name: Scalars['String']['input'];
  ratePerHundredWeight: Scalars['Float']['input'];
};

export type WeightBasedAccessorialEntity = AccessorialInterface & {
  __typename?: 'WeightBasedAccessorialEntity';
  accessorialDateRangeConfigs: Array<AccessorialDateRangeConfigEntity>;
  accessorialRanges?: Maybe<Array<AccessorialRangeEntity>>;
  code?: Maybe<Scalars['String']['output']>;
  contact?: Maybe<ContactEntity>;
  contacts: Array<ContactEntity>;
  ediCode?: Maybe<Scalars['String']['output']>;
  enableQuickAdd: Scalars['Boolean']['output'];
  fuelProfile?: Maybe<FuelProfileEntity>;
  fuelProfileUuid?: Maybe<Scalars['String']['output']>;
  generalLedgerCode?: Maybe<GeneralLedgerCodeEntity>;
  invoiceDisplayName?: Maybe<Scalars['String']['output']>;
  isArchived?: Maybe<Scalars['Boolean']['output']>;
  isAuthoCodeRequired: Scalars['Boolean']['output'];
  isDefaultGlobalSpecial: Scalars['Boolean']['output'];
  isSpecial?: Maybe<Scalars['Boolean']['output']>;
  matchingCustomerAccessorials?: Maybe<Array<AccessorialUnion>>;
  matchingGlobalAccessorial?: Maybe<AccessorialUnion>;
  maximumCharge?: Maybe<Scalars['Float']['output']>;
  minimumCharge?: Maybe<Scalars['Float']['output']>;
  name: Scalars['String']['output'];
  percentForSettlement?: Maybe<Scalars['Float']['output']>;
  quickbooksDesktopAccessorialId?: Maybe<Scalars['String']['output']>;
  quickbooksFileMappingChargeName?: Maybe<Scalars['String']['output']>;
  quickbooksMappingId: Scalars['String']['output'];
  ratePerHundredWeight: Scalars['Float']['output'];
  terminal?: Maybe<TerminalEntity>;
  terminalUuid?: Maybe<Scalars['String']['output']>;
  type?: Maybe<AccessorialType>;
  uuid: Scalars['String']['output'];
};

export type WeightBasedAccessorialUpdateInput = {
  accessorialRangeUpdateInputs?: InputMaybe<Array<AccessorialRangeUpdateInput>>;
  maximumCharge?: InputMaybe<Scalars['Float']['input']>;
  minimumCharge?: InputMaybe<Scalars['Float']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  quickbooksMappingId?: InputMaybe<Scalars['String']['input']>;
  ratePerHundredWeight?: InputMaybe<Scalars['Float']['input']>;
  uuid: Scalars['String']['input'];
};

export enum WeightUnits {
  Kilograms = 'KILOGRAMS',
  Pounds = 'POUNDS'
}

export type XyTransformEntity = {
  __typename?: 'XyTransformEntity';
  rotation: Scalars['Float']['output'];
  xMin: Scalars['Float']['output'];
  xScale: Scalars['Float']['output'];
  xTranslation: Scalars['Float']['output'];
  yMin: Scalars['Float']['output'];
  yScale: Scalars['Float']['output'];
  yTranslation: Scalars['Float']['output'];
};

export type ZipcodeOptionEntity = {
  __typename?: 'ZipcodeOptionEntity';
  zipcode: Scalars['String']['output'];
};

export type ZoneBasedAccessorialChargeGroupArrayUpdateInput = {
  /** Pass this field in to create a new array item */
  zoneBasedAccessorialChargeGroupCreateInput?: InputMaybe<ZoneBasedAccessorialChargeGroupCreateInput>;
  /** Pass this field in to update an array item */
  zoneBasedAccessorialChargeGroupUpdateInput?: InputMaybe<ZoneBasedAccessorialChargeGroupUpdateInput>;
};

export type ZoneBasedAccessorialChargeGroupCreateInput = {
  name: Scalars['String']['input'];
};

export type ZoneBasedAccessorialChargeGroupEntity = {
  __typename?: 'ZoneBasedAccessorialChargeGroupEntity';
  name: Scalars['String']['output'];
  uuid: Scalars['String']['output'];
};

export type ZoneBasedAccessorialChargeGroupUpdateInput = {
  name?: InputMaybe<Scalars['String']['input']>;
  uuid: Scalars['String']['input'];
};

export type ZoneBasedAccessorialCreateInput = {
  name: Scalars['String']['input'];
  zoneBasedChargeGroups: Array<ZoneBasedAccessorialChargeGroupCreateInput>;
  zoneBasedMatrixItems: Array<ZoneBasedAccessorialMatrixItemCreateInput>;
  zones: Array<ZoneBasedAccessorialZoneCreateInput>;
};

export type ZoneBasedAccessorialEntity = AccessorialInterface & {
  __typename?: 'ZoneBasedAccessorialEntity';
  accessorialDateRangeConfigs: Array<AccessorialDateRangeConfigEntity>;
  chargeGroups: Array<ZoneBasedAccessorialChargeGroupEntity>;
  code?: Maybe<Scalars['String']['output']>;
  contact?: Maybe<ContactEntity>;
  contacts: Array<ContactEntity>;
  ediCode?: Maybe<Scalars['String']['output']>;
  enableQuickAdd: Scalars['Boolean']['output'];
  fuelProfile?: Maybe<FuelProfileEntity>;
  fuelProfileUuid?: Maybe<Scalars['String']['output']>;
  generalLedgerCode?: Maybe<GeneralLedgerCodeEntity>;
  invoiceDisplayName?: Maybe<Scalars['String']['output']>;
  isArchived?: Maybe<Scalars['Boolean']['output']>;
  isAuthoCodeRequired: Scalars['Boolean']['output'];
  isDefaultGlobalSpecial: Scalars['Boolean']['output'];
  isSpecial?: Maybe<Scalars['Boolean']['output']>;
  matchingCustomerAccessorials?: Maybe<Array<AccessorialUnion>>;
  matchingGlobalAccessorial?: Maybe<AccessorialUnion>;
  matrixItems: Array<ZoneBasedAccessorialMatrixItemEntity>;
  name: Scalars['String']['output'];
  percentForSettlement?: Maybe<Scalars['Float']['output']>;
  quickbooksDesktopAccessorialId?: Maybe<Scalars['String']['output']>;
  quickbooksFileMappingChargeName?: Maybe<Scalars['String']['output']>;
  quickbooksMappingId: Scalars['String']['output'];
  terminal?: Maybe<TerminalEntity>;
  terminalUuid?: Maybe<Scalars['String']['output']>;
  type?: Maybe<AccessorialType>;
  uuid: Scalars['String']['output'];
  zones: Array<ZoneBasedAccessorialZoneEntity>;
};

export type ZoneBasedAccessorialMatrixItemArrayUpdateInput = {
  /** Pass this field in to create a new array item */
  matrixItemCreateInput?: InputMaybe<ZoneBasedAccessorialMatrixItemCreateInput>;
  /** Pass this field in to update an array item */
  matrixItemUpdateInput?: InputMaybe<ZoneBasedAccessorialMatrixItemUpdateInput>;
};

export type ZoneBasedAccessorialMatrixItemCreateInput = {
  chargeGroupName: Scalars['String']['input'];
  /** Accepts rate as a $ float with two decimal places */
  rate: Scalars['Float']['input'];
  zoneName: Scalars['String']['input'];
};

export type ZoneBasedAccessorialMatrixItemEntity = {
  __typename?: 'ZoneBasedAccessorialMatrixItemEntity';
  chargeGroupUuid: Scalars['String']['output'];
  rate: Scalars['Float']['output'];
  uuid: Scalars['String']['output'];
  zoneUuid: Scalars['String']['output'];
};

export type ZoneBasedAccessorialMatrixItemUpdateInput = {
  rate?: InputMaybe<Scalars['Float']['input']>;
  uuid: Scalars['String']['input'];
};

export type ZoneBasedAccessorialUpdateInput = {
  chargeGroupUpdates?: InputMaybe<Array<ZoneBasedAccessorialChargeGroupArrayUpdateInput>>;
  matrixItemsArrayUpdateInput?: InputMaybe<Array<ZoneBasedAccessorialMatrixItemArrayUpdateInput>>;
  name?: InputMaybe<Scalars['String']['input']>;
  quickbooksMappingId?: InputMaybe<Scalars['String']['input']>;
  uuid: Scalars['String']['input'];
  zoneArrayUpdates?: InputMaybe<Array<ZoneBasedAccessorialZoneArrayUpdateInput>>;
};

export type ZoneBasedAccessorialZoneArrayUpdateInput = {
  /** Pass this field in to create a new array item */
  zoneBasedAccessorialZoneCreateInput?: InputMaybe<ZoneBasedAccessorialZoneCreateInput>;
  /** Pass this field in to update an array item */
  zoneBasedAccessorialZoneUpdateInput?: InputMaybe<ZoneBasedAccessorialZoneUpdateInput>;
};

export type ZoneBasedAccessorialZoneCreateInput = {
  name: Scalars['String']['input'];
};

export type ZoneBasedAccessorialZoneEntity = {
  __typename?: 'ZoneBasedAccessorialZoneEntity';
  name: Scalars['String']['output'];
  uuid: Scalars['String']['output'];
};

export type ZoneBasedAccessorialZoneUpdateInput = {
  name?: InputMaybe<Scalars['String']['input']>;
  uuid: Scalars['String']['input'];
};

export type AblyTokenQueryVariables = Exact<{ [key: string]: never; }>;


export type AblyTokenQuery = { __typename?: 'Query', ablyToken: { __typename?: 'AblyTokenOutput', token?: string | null } };

export type ActiveAgentsQueryVariables = Exact<{ [key: string]: never; }>;


export type ActiveAgentsQuery = { __typename?: 'Query', activeAgents: Array<{ __typename?: 'AgentFieldsEntity', uuid: string, name: string }> };

export type CompanyFragment = { __typename?: 'CompanyEntity', invoiceEmail?: string | null, isCourier?: boolean | null, uuid: string, phone?: string | null, quickbooksFileMappingAccessorialChargeName?: string | null, quickbooksFileMappingFuelChargeName?: string | null, quickbooksFileMappingFreightChargeName?: string | null, quickbooksDesktopAccountsReceivableId?: string | null, quickbooksFileMappingPickupChargeName?: string | null, quickbooksCompanyId?: string | null, freightChargeQuickbooksMappingId?: string | null, fuelChargeQuickbooksMappingId?: string | null, quickbooksDesktopCompanyId?: string | null, quickbooksDesktopDeliveryId?: string | null, quickbooksDesktopPickupId?: string | null, quickbooksDesktopTransferId?: string | null, quickbooksDesktopLineHaulId?: string | null, quickbooksDesktopOrderChargeId?: string | null, quickbooksDesktopAccessorialId?: string | null, quickbooksDesktopFuelChargeId?: string | null, segment: Segment, timeZone: string, defaultWeightUnits: WeightUnits, defaultMeasurementUnits: MeasurementUnits, qbInvoiceNumberStart?: number | null, productionCompany?: ProductionCompany | null, name: string, orderNameOrdinal?: number | null, customDunningReportHeader?: string | null, customDunningReportFooter?: string | null, useSageBusinessWorks: boolean, blockSendingZeroDollarInvoices: boolean, purchasedProductOfferings: Array<PalletProductOffering>, defaultInvoiceEmailSubject?: string | null, defaultNonCompanyDriverSettlementMode: SettlementMode, configuration?: { __typename?: 'CompanyConfigurationEntity', uuid: string, showDriverSettlementInBilling: boolean, sameDayDispatchCellHeader: SameDayDispatchCellHeader, defaultStandardStopType: StandardStopType, defaultFuelSurchargeBillingMethod: FuelBillingMethod, defaultFuelSurcharge?: number | null, defaultFuelSettlementPercentageRate?: number | null, defaultDimFactor?: number | null, defaultRouteStartTime?: any | null, defaultRouteLoadTimeInMinutes?: number | null, defaultRouteUnloadTimeInMinutes?: number | null, defaultGenerateAppointmentDurationInMinutes: number, enableConsolidatedOrders: boolean, requirePODPhotoAndName: boolean, requirePODPhotoAndNameForPickups: boolean, requirePODPhotoForPickups: boolean, requireSigneeNameForPickups: boolean, requirePODPhotoForDeliveries: boolean, autoGroupStops: boolean, requireDriverToConfirmStopCompletedAtTime: boolean, requireSigneeNameForDeliveries: boolean, autoMatchEodDocumentsToOrders: boolean, showChargesOnCustomerPortal: boolean, invoicePdfLogoUrl?: string | null, showManuallyConfirmedByDefault?: boolean | null, showHelpersColumnInDispatch?: boolean | null, showVehicleInDailyDispatch?: boolean | null, autoApplyWaitTimeMinutes: boolean, requireReviewForEdiOrderCreation: boolean, startingInvoiceOrdinalNumber?: number | null, useDriverNumberForDispatch: boolean, useJournalNumberForInvoice: boolean, packageWarehouseLocationsEnabled: boolean, wmsEnabled: boolean, wmsStorageOrdersEnabled: boolean, wmsShortTermStorageEnabled: boolean, wmsAutoMarkOnHand: boolean, requireDriverToAcknowledgeRouteChange: boolean, defaultToAccessorial: boolean, enablePaymentMethod: boolean, driversShouldMarkFreightAsLoaded: boolean, allCapsInOrderPage: boolean, terminalsEnabled: boolean, lineHaulEnabled: boolean, logisticsSectionEnabled: boolean, fulfillmentTypeEnabled: boolean, pointToPointTariffsEnabled: boolean, orderNamingScheme: OrderNamingScheme, companyOrdinalStart?: number | null, minDigitsInCompanyOrdinalOrderName?: number | null, serviceLevelOptional: boolean, showKilogramsAndCentimeters: boolean, addOrdersToOpenInvoices: boolean, restrictEditingOrderName: boolean, notificationsEnabled: boolean, defaultInvoiceDocumentsRequired: Array<DocumentType>, invoiceNotes?: string | null, requireDimsToFinalizeCharges: boolean, orderIdentifierForCoverSheet: OrderIdentifier, getDriverLocationDataFromMobile: boolean, enableDigitalSignatureFlow: boolean, includeHyphensInInvoiceName: boolean, includeINVInInvoiceName: boolean } | null, quickbooksAccessToken?: { __typename?: 'QuickbooksOauthTokenEntity', uuid: string, expiresAt: any, accessToken: string, refreshToken: string } | null, defaultAddress?: { __typename?: 'AddressEntity', uuid: string, name: string, line1: string, line2?: string | null, city: string, latitude?: number | null, longitude?: number | null, zip: string, state: string, country: string } | null, tags: Array<{ __typename?: 'TagEntity', createdAt: any, updatedAt: any, color?: string | null, uuid: string, value: string }>, referenceNumberLabels: Array<{ __typename?: 'ReferenceNumberLabelEntity', name: string }>, orderFormFields: { __typename?: 'OrderFormFieldsEntity', onePackageRequired: boolean, onePackageWeightRequired: boolean } };

export type ContactForAutocompleteQueryVariables = Exact<{
  uuid: Scalars['String']['input'];
}>;


export type ContactForAutocompleteQuery = { __typename?: 'Query', contact: { __typename?: 'CustomerContactEntity', isPrepaidOnly: boolean, displayName: string, uuid: string, isActive: boolean, isOverCreditLimit: boolean } | { __typename?: 'ThirdPartyContactEntity', displayName: string, uuid: string, isActive: boolean, isOverCreditLimit: boolean } };

export type ContactPackageSpecsQueryVariables = Exact<{
  contactUuid: Scalars['String']['input'];
}>;


export type ContactPackageSpecsQuery = { __typename?: 'Query', contact: { __typename?: 'CustomerContactEntity', useCustomPackageSpecs: boolean, uuid: string, packageSpecs: Array<{ __typename?: 'PackageSpecEntity', id: string, name: string, status: PackageSpecStatus }> } | { __typename?: 'ThirdPartyContactEntity', uuid: string } };

export type ContactsForAutocompleteQueryVariables = Exact<{
  excludeNonActive?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type ContactsForAutocompleteQuery = { __typename?: 'Query', contacts: Array<{ __typename?: 'CustomerContactEntity', isPrepaidOnly: boolean, displayName: string, uuid: string, isActive: boolean } | { __typename?: 'ThirdPartyContactEntity', displayName: string, uuid: string, isActive: boolean }> };

export type DispatchableDriversQueryVariables = Exact<{
  getDispatchableDriversInput: GetDispatchableDriversInput;
}>;


export type DispatchableDriversQuery = { __typename?: 'Query', dispatchableDrivers: { __typename?: 'GetDispatchableDriversOutput', companyDrivers: Array<{ __typename?: 'DriverEntity', firstName: string, lastName: string, uuid: string, phoneNumber: string, driverReferenceNumber?: string | null, driverType?: DriverType | null, user: { __typename?: 'UserEntity', name?: string | null }, terminal?: { __typename?: 'TerminalEntity', name: string } | null }>, agents: Array<{ __typename?: 'DispatchableAgentEntity', uuid: string, name: string, defaultDriver: { __typename?: 'DriverEntity', uuid: string, driverType?: DriverType | null } }> } };

export type DriverMinimalQueryVariables = Exact<{
  uuid: Scalars['String']['input'];
}>;


export type DriverMinimalQuery = { __typename?: 'Query', driver: { __typename?: 'DriverEntity', uuid: string, firstName: string, lastName: string, phoneNumber: string, driverType?: DriverType | null, user: { __typename?: 'UserEntity', name?: string | null }, agent?: { __typename?: 'AgentFieldsEntity', uuid: string, name: string } | null, terminal?: { __typename?: 'TerminalEntity', name: string } | null } };

export type LoginMutationVariables = Exact<{
  loginInputData: LoginInput;
}>;


export type LoginMutation = { __typename?: 'Mutation', login?: { __typename?: 'LoginOutput', status: LoginStatus, kind?: string | null, fullAccessUser?: { __typename?: 'UserEntity', uuid: string, company: { __typename?: 'CompanyEntity', purchasedProductOfferings: Array<PalletProductOffering> } } | null, thirdPartyUser?: { __typename?: 'ThirdPartyUserEntity', uuid: string } | null, clientChallenge?: Array<{ __typename?: 'ClientChallengeEntity', uuid: string, name: string, squareLogoUrl?: string | null }> | null } | null };

export type LogoutMutationVariables = Exact<{ [key: string]: never; }>;


export type LogoutMutation = { __typename?: 'Mutation', logout: boolean };

export type MeAsThirdPartyUserForAuthQueryVariables = Exact<{ [key: string]: never; }>;


export type MeAsThirdPartyUserForAuthQuery = { __typename?: 'Query', meAsThirdPartyUser?: { __typename?: 'ThirdPartyUserEntity', email: string, uuid: string, contacts: Array<{ __typename?: 'CustomerContactEntity', company: { __typename?: 'CompanyEntity', uuid: string, name: string } } | { __typename?: 'ThirdPartyContactEntity', company: { __typename?: 'CompanyEntity', uuid: string, name: string } }> } | null };

export type MeAsThirdPartyUserQueryVariables = Exact<{ [key: string]: never; }>;


export type MeAsThirdPartyUserQuery = { __typename?: 'Query', meAsThirdPartyUser?: { __typename?: 'ThirdPartyUserEntity', email: string, uuid: string, contacts: Array<{ __typename?: 'CustomerContactEntity', enableCustomerPortalOrderEntry: boolean, uuid: string, displayName: string, showChargesOnCustomerPortal: boolean, isPrepaidOnly: boolean, company: { __typename?: 'CompanyEntity', uuid: string, segment: Segment, timeZone: string, defaultWeightUnits: WeightUnits, isCourier?: boolean | null, defaultMeasurementUnits: MeasurementUnits, productionCompany?: ProductionCompany | null, name: string, services: Array<{ __typename?: 'ServiceEntity', uuid: string, name: string, createdAt: any, updatedAt: any, timeInMinutes?: number | null, useApptInRouteOptimization: boolean, markOrdersAsSpecial: boolean, defaultAppointmentStartTime?: any | null, defaultAppointmentEndTime?: any | null, defaultStartNow: boolean, defaultInboundStopType?: StopType | null, defaultOutboundStopType?: StopType | null, defaultPickupPadding?: any | null, defaultDeliveryPadding?: any | null, defaultTotalDuration?: any | null, defaultIsLineHaul: boolean, defaultFulfillmentType?: FulfillmentType | null, isActive: boolean, isExposedToCustomers: boolean, serviceAvailabilityDates: Array<{ __typename?: 'ServiceAvailabilityDateEntity', id: string, dayCategory: SpecialDayOfWeek, enabled: boolean, start: { __typename?: 'PlainTime', hour: number, minute: number }, end: { __typename?: 'PlainTime', hour: number, minute: number } }> }>, configuration?: { __typename?: 'CompanyConfigurationEntity', uuid: string, showDriverSettlementInBilling: boolean, sameDayDispatchCellHeader: SameDayDispatchCellHeader, defaultStandardStopType: StandardStopType, defaultFuelSurchargeBillingMethod: FuelBillingMethod, defaultFuelSurcharge?: number | null, defaultFuelSettlementPercentageRate?: number | null, defaultDimFactor?: number | null, defaultRouteStartTime?: any | null, defaultRouteLoadTimeInMinutes?: number | null, defaultRouteUnloadTimeInMinutes?: number | null, defaultGenerateAppointmentDurationInMinutes: number, enableConsolidatedOrders: boolean, requirePODPhotoAndName: boolean, requirePODPhotoAndNameForPickups: boolean, requirePODPhotoForPickups: boolean, requireSigneeNameForPickups: boolean, requirePODPhotoForDeliveries: boolean, autoGroupStops: boolean, requireDriverToConfirmStopCompletedAtTime: boolean, requireSigneeNameForDeliveries: boolean, autoMatchEodDocumentsToOrders: boolean, showChargesOnCustomerPortal: boolean, invoicePdfLogoUrl?: string | null, showManuallyConfirmedByDefault?: boolean | null, showHelpersColumnInDispatch?: boolean | null, showVehicleInDailyDispatch?: boolean | null, autoApplyWaitTimeMinutes: boolean, requireReviewForEdiOrderCreation: boolean, startingInvoiceOrdinalNumber?: number | null, useDriverNumberForDispatch: boolean, useJournalNumberForInvoice: boolean, packageWarehouseLocationsEnabled: boolean, wmsEnabled: boolean, wmsStorageOrdersEnabled: boolean, wmsShortTermStorageEnabled: boolean, wmsAutoMarkOnHand: boolean, requireDriverToAcknowledgeRouteChange: boolean, defaultToAccessorial: boolean, enablePaymentMethod: boolean, driversShouldMarkFreightAsLoaded: boolean, allCapsInOrderPage: boolean, terminalsEnabled: boolean, lineHaulEnabled: boolean, logisticsSectionEnabled: boolean, fulfillmentTypeEnabled: boolean, pointToPointTariffsEnabled: boolean, orderNamingScheme: OrderNamingScheme, companyOrdinalStart?: number | null, minDigitsInCompanyOrdinalOrderName?: number | null, serviceLevelOptional: boolean, showKilogramsAndCentimeters: boolean, addOrdersToOpenInvoices: boolean, restrictEditingOrderName: boolean, notificationsEnabled: boolean, defaultInvoiceDocumentsRequired: Array<DocumentType>, invoiceNotes?: string | null, requireDimsToFinalizeCharges: boolean, orderIdentifierForCoverSheet: OrderIdentifier, getDriverLocationDataFromMobile: boolean, enableDigitalSignatureFlow: boolean, includeHyphensInInvoiceName: boolean, includeINVInInvoiceName: boolean } | null } } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string, showChargesOnCustomerPortal: boolean, isPrepaidOnly: boolean, company: { __typename?: 'CompanyEntity', uuid: string, segment: Segment, timeZone: string, defaultWeightUnits: WeightUnits, isCourier?: boolean | null, defaultMeasurementUnits: MeasurementUnits, productionCompany?: ProductionCompany | null, name: string, services: Array<{ __typename?: 'ServiceEntity', uuid: string, name: string, createdAt: any, updatedAt: any, timeInMinutes?: number | null, useApptInRouteOptimization: boolean, markOrdersAsSpecial: boolean, defaultAppointmentStartTime?: any | null, defaultAppointmentEndTime?: any | null, defaultStartNow: boolean, defaultInboundStopType?: StopType | null, defaultOutboundStopType?: StopType | null, defaultPickupPadding?: any | null, defaultDeliveryPadding?: any | null, defaultTotalDuration?: any | null, defaultIsLineHaul: boolean, defaultFulfillmentType?: FulfillmentType | null, isActive: boolean, isExposedToCustomers: boolean, serviceAvailabilityDates: Array<{ __typename?: 'ServiceAvailabilityDateEntity', id: string, dayCategory: SpecialDayOfWeek, enabled: boolean, start: { __typename?: 'PlainTime', hour: number, minute: number }, end: { __typename?: 'PlainTime', hour: number, minute: number } }> }>, configuration?: { __typename?: 'CompanyConfigurationEntity', uuid: string, showDriverSettlementInBilling: boolean, sameDayDispatchCellHeader: SameDayDispatchCellHeader, defaultStandardStopType: StandardStopType, defaultFuelSurchargeBillingMethod: FuelBillingMethod, defaultFuelSurcharge?: number | null, defaultFuelSettlementPercentageRate?: number | null, defaultDimFactor?: number | null, defaultRouteStartTime?: any | null, defaultRouteLoadTimeInMinutes?: number | null, defaultRouteUnloadTimeInMinutes?: number | null, defaultGenerateAppointmentDurationInMinutes: number, enableConsolidatedOrders: boolean, requirePODPhotoAndName: boolean, requirePODPhotoAndNameForPickups: boolean, requirePODPhotoForPickups: boolean, requireSigneeNameForPickups: boolean, requirePODPhotoForDeliveries: boolean, autoGroupStops: boolean, requireDriverToConfirmStopCompletedAtTime: boolean, requireSigneeNameForDeliveries: boolean, autoMatchEodDocumentsToOrders: boolean, showChargesOnCustomerPortal: boolean, invoicePdfLogoUrl?: string | null, showManuallyConfirmedByDefault?: boolean | null, showHelpersColumnInDispatch?: boolean | null, showVehicleInDailyDispatch?: boolean | null, autoApplyWaitTimeMinutes: boolean, requireReviewForEdiOrderCreation: boolean, startingInvoiceOrdinalNumber?: number | null, useDriverNumberForDispatch: boolean, useJournalNumberForInvoice: boolean, packageWarehouseLocationsEnabled: boolean, wmsEnabled: boolean, wmsStorageOrdersEnabled: boolean, wmsShortTermStorageEnabled: boolean, wmsAutoMarkOnHand: boolean, requireDriverToAcknowledgeRouteChange: boolean, defaultToAccessorial: boolean, enablePaymentMethod: boolean, driversShouldMarkFreightAsLoaded: boolean, allCapsInOrderPage: boolean, terminalsEnabled: boolean, lineHaulEnabled: boolean, logisticsSectionEnabled: boolean, fulfillmentTypeEnabled: boolean, pointToPointTariffsEnabled: boolean, orderNamingScheme: OrderNamingScheme, companyOrdinalStart?: number | null, minDigitsInCompanyOrdinalOrderName?: number | null, serviceLevelOptional: boolean, showKilogramsAndCentimeters: boolean, addOrdersToOpenInvoices: boolean, restrictEditingOrderName: boolean, notificationsEnabled: boolean, defaultInvoiceDocumentsRequired: Array<DocumentType>, invoiceNotes?: string | null, requireDimsToFinalizeCharges: boolean, orderIdentifierForCoverSheet: OrderIdentifier, getDriverLocationDataFromMobile: boolean, enableDigitalSignatureFlow: boolean, includeHyphensInInvoiceName: boolean, includeINVInInvoiceName: boolean } | null } }> } | null };

export type MeForAuthQueryVariables = Exact<{ [key: string]: never; }>;


export type MeForAuthQuery = { __typename?: 'Query', me?: { __typename?: 'UserEntity', email: string, uuid: string, company: { __typename?: 'CompanyEntity', uuid: string, name: string } } | null };

export type MeQueryVariables = Exact<{ [key: string]: never; }>;


export type MeQuery = { __typename?: 'Query', me?: { __typename?: 'UserEntity', email: string, phoneNumber?: string | null, name?: string | null, uuid: string, createdAt: any, reportsEmail?: string | null, useMinimizedAppointmentTime: boolean, routeCardWidth: number, numberOfStops: number, redirectIsAlertedOnFirstSave?: boolean | null, redirectIsAlertedOnOpenOrder?: boolean | null, arrangeStopsAndRoutesVertically: boolean, terminal?: { __typename?: 'TerminalEntity', uuid: string, code: string, name: string } | null, company: { __typename?: 'CompanyEntity', invoiceEmail?: string | null, isCourier?: boolean | null, uuid: string, phone?: string | null, quickbooksFileMappingAccessorialChargeName?: string | null, quickbooksFileMappingFuelChargeName?: string | null, quickbooksFileMappingFreightChargeName?: string | null, quickbooksDesktopAccountsReceivableId?: string | null, quickbooksFileMappingPickupChargeName?: string | null, quickbooksCompanyId?: string | null, freightChargeQuickbooksMappingId?: string | null, fuelChargeQuickbooksMappingId?: string | null, quickbooksDesktopCompanyId?: string | null, quickbooksDesktopDeliveryId?: string | null, quickbooksDesktopPickupId?: string | null, quickbooksDesktopTransferId?: string | null, quickbooksDesktopLineHaulId?: string | null, quickbooksDesktopOrderChargeId?: string | null, quickbooksDesktopAccessorialId?: string | null, quickbooksDesktopFuelChargeId?: string | null, segment: Segment, timeZone: string, defaultWeightUnits: WeightUnits, defaultMeasurementUnits: MeasurementUnits, qbInvoiceNumberStart?: number | null, productionCompany?: ProductionCompany | null, name: string, orderNameOrdinal?: number | null, customDunningReportHeader?: string | null, customDunningReportFooter?: string | null, useSageBusinessWorks: boolean, blockSendingZeroDollarInvoices: boolean, purchasedProductOfferings: Array<PalletProductOffering>, defaultInvoiceEmailSubject?: string | null, defaultNonCompanyDriverSettlementMode: SettlementMode, configuration?: { __typename?: 'CompanyConfigurationEntity', uuid: string, showDriverSettlementInBilling: boolean, sameDayDispatchCellHeader: SameDayDispatchCellHeader, defaultStandardStopType: StandardStopType, defaultFuelSurchargeBillingMethod: FuelBillingMethod, defaultFuelSurcharge?: number | null, defaultFuelSettlementPercentageRate?: number | null, defaultDimFactor?: number | null, defaultRouteStartTime?: any | null, defaultRouteLoadTimeInMinutes?: number | null, defaultRouteUnloadTimeInMinutes?: number | null, defaultGenerateAppointmentDurationInMinutes: number, enableConsolidatedOrders: boolean, requirePODPhotoAndName: boolean, requirePODPhotoAndNameForPickups: boolean, requirePODPhotoForPickups: boolean, requireSigneeNameForPickups: boolean, requirePODPhotoForDeliveries: boolean, autoGroupStops: boolean, requireDriverToConfirmStopCompletedAtTime: boolean, requireSigneeNameForDeliveries: boolean, autoMatchEodDocumentsToOrders: boolean, showChargesOnCustomerPortal: boolean, invoicePdfLogoUrl?: string | null, showManuallyConfirmedByDefault?: boolean | null, showHelpersColumnInDispatch?: boolean | null, showVehicleInDailyDispatch?: boolean | null, autoApplyWaitTimeMinutes: boolean, requireReviewForEdiOrderCreation: boolean, startingInvoiceOrdinalNumber?: number | null, useDriverNumberForDispatch: boolean, useJournalNumberForInvoice: boolean, packageWarehouseLocationsEnabled: boolean, wmsEnabled: boolean, wmsStorageOrdersEnabled: boolean, wmsShortTermStorageEnabled: boolean, wmsAutoMarkOnHand: boolean, requireDriverToAcknowledgeRouteChange: boolean, defaultToAccessorial: boolean, enablePaymentMethod: boolean, driversShouldMarkFreightAsLoaded: boolean, allCapsInOrderPage: boolean, terminalsEnabled: boolean, lineHaulEnabled: boolean, logisticsSectionEnabled: boolean, fulfillmentTypeEnabled: boolean, pointToPointTariffsEnabled: boolean, orderNamingScheme: OrderNamingScheme, companyOrdinalStart?: number | null, minDigitsInCompanyOrdinalOrderName?: number | null, serviceLevelOptional: boolean, showKilogramsAndCentimeters: boolean, addOrdersToOpenInvoices: boolean, restrictEditingOrderName: boolean, notificationsEnabled: boolean, defaultInvoiceDocumentsRequired: Array<DocumentType>, invoiceNotes?: string | null, requireDimsToFinalizeCharges: boolean, orderIdentifierForCoverSheet: OrderIdentifier, getDriverLocationDataFromMobile: boolean, enableDigitalSignatureFlow: boolean, includeHyphensInInvoiceName: boolean, includeINVInInvoiceName: boolean } | null, quickbooksAccessToken?: { __typename?: 'QuickbooksOauthTokenEntity', uuid: string, expiresAt: any, accessToken: string, refreshToken: string } | null, defaultAddress?: { __typename?: 'AddressEntity', uuid: string, name: string, line1: string, line2?: string | null, city: string, latitude?: number | null, longitude?: number | null, zip: string, state: string, country: string } | null, tags: Array<{ __typename?: 'TagEntity', createdAt: any, updatedAt: any, color?: string | null, uuid: string, value: string }>, referenceNumberLabels: Array<{ __typename?: 'ReferenceNumberLabelEntity', name: string }>, orderFormFields: { __typename?: 'OrderFormFieldsEntity', onePackageRequired: boolean, onePackageWeightRequired: boolean } } } | null };

export type MeRolePermissionFragment = { __typename?: 'PermissionEntity', permissionResource: PermissionResource, accessLevel: AccessLevel };

export type MeRoleFragment = { __typename?: 'RoleEntity', uuid: string, name: string, permissions: Array<{ __typename?: 'PermissionEntity', permissionResource: PermissionResource, accessLevel: AccessLevel }> };

export type MeFragment = { __typename?: 'UserEntity', email: string, phoneNumber?: string | null, name?: string | null, uuid: string, createdAt: any, reportsEmail?: string | null, useMinimizedAppointmentTime: boolean, routeCardWidth: number, numberOfStops: number, redirectIsAlertedOnFirstSave?: boolean | null, redirectIsAlertedOnOpenOrder?: boolean | null, arrangeStopsAndRoutesVertically: boolean, terminal?: { __typename?: 'TerminalEntity', uuid: string, code: string, name: string } | null, company: { __typename?: 'CompanyEntity', invoiceEmail?: string | null, isCourier?: boolean | null, uuid: string, phone?: string | null, quickbooksFileMappingAccessorialChargeName?: string | null, quickbooksFileMappingFuelChargeName?: string | null, quickbooksFileMappingFreightChargeName?: string | null, quickbooksDesktopAccountsReceivableId?: string | null, quickbooksFileMappingPickupChargeName?: string | null, quickbooksCompanyId?: string | null, freightChargeQuickbooksMappingId?: string | null, fuelChargeQuickbooksMappingId?: string | null, quickbooksDesktopCompanyId?: string | null, quickbooksDesktopDeliveryId?: string | null, quickbooksDesktopPickupId?: string | null, quickbooksDesktopTransferId?: string | null, quickbooksDesktopLineHaulId?: string | null, quickbooksDesktopOrderChargeId?: string | null, quickbooksDesktopAccessorialId?: string | null, quickbooksDesktopFuelChargeId?: string | null, segment: Segment, timeZone: string, defaultWeightUnits: WeightUnits, defaultMeasurementUnits: MeasurementUnits, qbInvoiceNumberStart?: number | null, productionCompany?: ProductionCompany | null, name: string, orderNameOrdinal?: number | null, customDunningReportHeader?: string | null, customDunningReportFooter?: string | null, useSageBusinessWorks: boolean, blockSendingZeroDollarInvoices: boolean, purchasedProductOfferings: Array<PalletProductOffering>, defaultInvoiceEmailSubject?: string | null, defaultNonCompanyDriverSettlementMode: SettlementMode, configuration?: { __typename?: 'CompanyConfigurationEntity', uuid: string, showDriverSettlementInBilling: boolean, sameDayDispatchCellHeader: SameDayDispatchCellHeader, defaultStandardStopType: StandardStopType, defaultFuelSurchargeBillingMethod: FuelBillingMethod, defaultFuelSurcharge?: number | null, defaultFuelSettlementPercentageRate?: number | null, defaultDimFactor?: number | null, defaultRouteStartTime?: any | null, defaultRouteLoadTimeInMinutes?: number | null, defaultRouteUnloadTimeInMinutes?: number | null, defaultGenerateAppointmentDurationInMinutes: number, enableConsolidatedOrders: boolean, requirePODPhotoAndName: boolean, requirePODPhotoAndNameForPickups: boolean, requirePODPhotoForPickups: boolean, requireSigneeNameForPickups: boolean, requirePODPhotoForDeliveries: boolean, autoGroupStops: boolean, requireDriverToConfirmStopCompletedAtTime: boolean, requireSigneeNameForDeliveries: boolean, autoMatchEodDocumentsToOrders: boolean, showChargesOnCustomerPortal: boolean, invoicePdfLogoUrl?: string | null, showManuallyConfirmedByDefault?: boolean | null, showHelpersColumnInDispatch?: boolean | null, showVehicleInDailyDispatch?: boolean | null, autoApplyWaitTimeMinutes: boolean, requireReviewForEdiOrderCreation: boolean, startingInvoiceOrdinalNumber?: number | null, useDriverNumberForDispatch: boolean, useJournalNumberForInvoice: boolean, packageWarehouseLocationsEnabled: boolean, wmsEnabled: boolean, wmsStorageOrdersEnabled: boolean, wmsShortTermStorageEnabled: boolean, wmsAutoMarkOnHand: boolean, requireDriverToAcknowledgeRouteChange: boolean, defaultToAccessorial: boolean, enablePaymentMethod: boolean, driversShouldMarkFreightAsLoaded: boolean, allCapsInOrderPage: boolean, terminalsEnabled: boolean, lineHaulEnabled: boolean, logisticsSectionEnabled: boolean, fulfillmentTypeEnabled: boolean, pointToPointTariffsEnabled: boolean, orderNamingScheme: OrderNamingScheme, companyOrdinalStart?: number | null, minDigitsInCompanyOrdinalOrderName?: number | null, serviceLevelOptional: boolean, showKilogramsAndCentimeters: boolean, addOrdersToOpenInvoices: boolean, restrictEditingOrderName: boolean, notificationsEnabled: boolean, defaultInvoiceDocumentsRequired: Array<DocumentType>, invoiceNotes?: string | null, requireDimsToFinalizeCharges: boolean, orderIdentifierForCoverSheet: OrderIdentifier, getDriverLocationDataFromMobile: boolean, enableDigitalSignatureFlow: boolean, includeHyphensInInvoiceName: boolean, includeINVInInvoiceName: boolean } | null, quickbooksAccessToken?: { __typename?: 'QuickbooksOauthTokenEntity', uuid: string, expiresAt: any, accessToken: string, refreshToken: string } | null, defaultAddress?: { __typename?: 'AddressEntity', uuid: string, name: string, line1: string, line2?: string | null, city: string, latitude?: number | null, longitude?: number | null, zip: string, state: string, country: string } | null, tags: Array<{ __typename?: 'TagEntity', createdAt: any, updatedAt: any, color?: string | null, uuid: string, value: string }>, referenceNumberLabels: Array<{ __typename?: 'ReferenceNumberLabelEntity', name: string }>, orderFormFields: { __typename?: 'OrderFormFieldsEntity', onePackageRequired: boolean, onePackageWeightRequired: boolean } } };

export type OrderFormFieldsFragment = { __typename?: 'OrderFormFieldsEntity', onePackageRequired: boolean, onePackageWeightRequired: boolean };

export type UserRolesQueryVariables = Exact<{ [key: string]: never; }>;


export type UserRolesQuery = { __typename?: 'Query', userRoles: Array<{ __typename?: 'RoleEntity', uuid: string, name: string, permissions: Array<{ __typename?: 'PermissionEntity', permissionResource: PermissionResource, accessLevel: AccessLevel }> }> };

export type TableFieldsQueryVariables = Exact<{ [key: string]: never; }>;


export type TableFieldsQuery = { __typename?: 'Query', tableFields?: { __typename?: 'TableFieldsEntity', orderTableFields: Array<OrderTableField>, billingReviewOrderTableFields: Array<OrderTableField>, linehaulDispatchTableFields: Array<LinehaulDispatchTableField>, dispatchTableFields: Array<DispatchTableField>, routeCardStopTableFields: Array<DispatchTableField>, dispatchTableColumnWidths?: Array<{ __typename?: 'TableColumnWidthEntity', colId: string, width: number }> | null, routeCardStopTableColumnWidths?: Array<{ __typename?: 'TableColumnWidthEntity', colId: string, width: number }> | null } | null };

export type RegisterMutationVariables = Exact<{
  registerInputData: RegisterInput;
}>;


export type RegisterMutation = { __typename?: 'Mutation', register?: { __typename?: 'RegisterOutput', status: RegisterStatus } | null };

export type TariffChainFragment = { __typename?: 'TariffChainEntity', id: string, name: string, tariffGroupType: TariffGroupType };

export type TariffChainsQueryVariables = Exact<{
  findTariffChainsInput: FindTariffChainsInput;
}>;


export type TariffChainsQuery = { __typename?: 'Query', tariffChains: Array<{ __typename?: 'TariffChainEntity', id: string, name: string, tariffGroupType: TariffGroupType }> };

export type TemplateAddressesQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  searchText?: InputMaybe<Scalars['String']['input']>;
}>;


export type TemplateAddressesQuery = { __typename?: 'Query', templateAddresses: Array<{ __typename?: 'AddressEntity', uuid: string, name: string, line1: string, line2?: string | null, city: string, state: string, zip: string, country: string, latitude?: number | null, longitude?: number | null, preventCoordRecompute?: boolean | null, driverInstructions?: string | null, receivingHoursStart?: any | null, receivingHoursEnd?: any | null, specialInstructions?: string | null, iataCode?: string | null, associatedContact?: { __typename?: 'ContactPersonEntity', uuid: string, firstName?: string | null, lastName?: string | null, email?: string | null, notes?: string | null, phone?: string | null, createdAt: any } | null }> };

export type WhiteLabelCompanyQueryVariables = Exact<{
  uuid: Scalars['String']['input'];
}>;


export type WhiteLabelCompanyQuery = { __typename?: 'Query', companyByUuid?: { __typename?: 'CompanyEntity', uuid: string, companyLandscapeLogoUrl?: string | null, companySquareLogoUrl?: string | null, name: string } | null };

export type AccessorialRangeFragment = { __typename?: 'AccessorialRangeEntity', uuid: string, lessThanOrEqualToValue: number, rateUsdCents: number };

export type AutoApplyAccessorialConfigFragment = { __typename?: 'AutoApplyAccessorialConfigEntity', uuid: string, ruleType: AutoApplyAccessorialRuleType, stopType?: PickupOrDelivery | null, accessorials: Array<{ __typename: 'SkidBasedAccessorialEntity', isArchived?: boolean | null, isAuthoCodeRequired: boolean, isDefaultGlobalSpecial: boolean, invoiceDisplayName?: string | null, quickbooksDesktopAccessorialId?: string | null, uuid: string, quickbooksFileMappingChargeName?: string | null, quickbooksMappingId: string, percentForSettlement?: number | null, name: string, code?: string | null, ediCode?: string | null, ratePerSkid: number, maximumCharge?: number | null, minimumCharge?: number | null, contact?: { __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string } | null, matchingGlobalAccessorial?: { __typename?: 'SkidBasedAccessorialEntity', uuid: string } | { __typename?: 'SpecialAccessorialEntity', uuid: string } | { __typename?: 'StandardAccessorialEntity', uuid: string } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string } | null, matchingCustomerAccessorials?: Array<{ __typename?: 'SkidBasedAccessorialEntity', uuid: string } | { __typename?: 'SpecialAccessorialEntity', uuid: string } | { __typename?: 'StandardAccessorialEntity', uuid: string } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string }> | null, terminal?: { __typename?: 'TerminalEntity', uuid: string, name: string, code: string } | null, fuelProfile?: { __typename?: 'FuelProfileEntity', uuid: string, name?: string | null, startDate?: any | null, expirationDate?: any | null, billingType: FuelBillingMethod, type: FuelProfileType, company: { __typename?: 'CompanyEntity', uuid: string }, contacts?: Array<{ __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string }> | null, fuelProfileDateRanges: Array<{ __typename?: 'FuelProfileDateRangeEntity', uuid: string, startDate: any, expirationDate: any, surchargeRate?: number | null, flatRateUsdCents?: number | null }> } | null, generalLedgerCode?: { __typename?: 'GeneralLedgerCodeEntity', id: string, code: string } | null } | { __typename: 'SpecialAccessorialEntity', isArchived?: boolean | null, isAuthoCodeRequired: boolean, isDefaultGlobalSpecial: boolean, specialAccessorialType?: SpecialAccessorialType | null, invoiceDisplayName?: string | null, uuid: string, quickbooksDesktopAccessorialId?: string | null, quickbooksFileMappingChargeName?: string | null, quickbooksMappingId: string, percentForSettlement?: number | null, name: string, code?: string | null, ediCode?: string | null, contact?: { __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string } | null, serviceLevel?: { __typename?: 'ServiceEntity', uuid: string, name: string, createdAt: any, updatedAt: any, timeInMinutes?: number | null, useApptInRouteOptimization: boolean, markOrdersAsSpecial: boolean, defaultAppointmentStartTime?: any | null, defaultAppointmentEndTime?: any | null, defaultStartNow: boolean, defaultInboundStopType?: StopType | null, defaultOutboundStopType?: StopType | null, defaultPickupPadding?: any | null, defaultDeliveryPadding?: any | null, defaultTotalDuration?: any | null, defaultIsLineHaul: boolean, defaultFulfillmentType?: FulfillmentType | null, isActive: boolean, isExposedToCustomers: boolean, serviceAvailabilityDates: Array<{ __typename?: 'ServiceAvailabilityDateEntity', id: string, dayCategory: SpecialDayOfWeek, enabled: boolean, start: { __typename?: 'PlainTime', hour: number, minute: number }, end: { __typename?: 'PlainTime', hour: number, minute: number } }> } | null, zones: Array<{ __typename?: 'TariffZoneEntity', uuid: string, name: string }>, chargeGroups: Array<{ __typename?: 'SpecialAccessorialChargeGroupEntity', uuid: string, dayOfWeek: SpecialDayOfWeek, startTime: any, endTime: any }>, matrixItems: Array<{ __typename?: 'SpecialAccessorialMatrixItemEntity', zoneUuid: string, chargeGroupUuid: string, uuid: string, rate: number }>, matchingGlobalAccessorial?: { __typename?: 'SkidBasedAccessorialEntity', uuid: string } | { __typename?: 'SpecialAccessorialEntity', uuid: string } | { __typename?: 'StandardAccessorialEntity', uuid: string } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string } | null, matchingCustomerAccessorials?: Array<{ __typename?: 'SkidBasedAccessorialEntity', uuid: string } | { __typename?: 'SpecialAccessorialEntity', uuid: string } | { __typename?: 'StandardAccessorialEntity', uuid: string } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string }> | null, terminal?: { __typename?: 'TerminalEntity', uuid: string, name: string, code: string } | null, fuelProfile?: { __typename?: 'FuelProfileEntity', uuid: string, name?: string | null, startDate?: any | null, expirationDate?: any | null, billingType: FuelBillingMethod, type: FuelProfileType, company: { __typename?: 'CompanyEntity', uuid: string }, contacts?: Array<{ __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string }> | null, fuelProfileDateRanges: Array<{ __typename?: 'FuelProfileDateRangeEntity', uuid: string, startDate: any, expirationDate: any, surchargeRate?: number | null, flatRateUsdCents?: number | null }> } | null, tariffZoneGroup?: { __typename?: 'TariffZoneGroupEntity', id: string } | null, generalLedgerCode?: { __typename?: 'GeneralLedgerCodeEntity', id: string, code: string } | null } | { __typename: 'StandardAccessorialEntity', isArchived?: boolean | null, isAuthoCodeRequired: boolean, isDefaultGlobalSpecial: boolean, invoiceDisplayName?: string | null, quickbooksDesktopAccessorialId?: string | null, uuid: string, quickbooksFileMappingChargeName?: string | null, quickbooksMappingId: string, percentForSettlement?: number | null, name: string, code?: string | null, ediCode?: string | null, rate: number, contact?: { __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string } | null, matchingGlobalAccessorial?: { __typename?: 'SkidBasedAccessorialEntity', uuid: string } | { __typename?: 'SpecialAccessorialEntity', uuid: string } | { __typename?: 'StandardAccessorialEntity', uuid: string } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string } | null, matchingCustomerAccessorials?: Array<{ __typename?: 'SkidBasedAccessorialEntity', uuid: string } | { __typename?: 'SpecialAccessorialEntity', uuid: string } | { __typename?: 'StandardAccessorialEntity', uuid: string } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string }> | null, terminal?: { __typename?: 'TerminalEntity', uuid: string, name: string, code: string } | null, fuelProfile?: { __typename?: 'FuelProfileEntity', uuid: string, name?: string | null, startDate?: any | null, expirationDate?: any | null, billingType: FuelBillingMethod, type: FuelProfileType, company: { __typename?: 'CompanyEntity', uuid: string }, contacts?: Array<{ __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string }> | null, fuelProfileDateRanges: Array<{ __typename?: 'FuelProfileDateRangeEntity', uuid: string, startDate: any, expirationDate: any, surchargeRate?: number | null, flatRateUsdCents?: number | null }> } | null, generalLedgerCode?: { __typename?: 'GeneralLedgerCodeEntity', id: string, code: string } | null } | { __typename: 'UnitBasedAccessorialEntity', isArchived?: boolean | null, isAuthoCodeRequired: boolean, isDefaultGlobalSpecial: boolean, invoiceDisplayName?: string | null, quickbooksDesktopAccessorialId?: string | null, uuid: string, quickbooksFileMappingChargeName?: string | null, quickbooksMappingId: string, percentForSettlement?: number | null, name: string, code?: string | null, ediCode?: string | null, ratePerUnit: number, maximumCharge?: number | null, minimumCharge?: number | null, contact?: { __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string } | null, matchingGlobalAccessorial?: { __typename?: 'SkidBasedAccessorialEntity', uuid: string } | { __typename?: 'SpecialAccessorialEntity', uuid: string } | { __typename?: 'StandardAccessorialEntity', uuid: string } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string } | null, matchingCustomerAccessorials?: Array<{ __typename?: 'SkidBasedAccessorialEntity', uuid: string } | { __typename?: 'SpecialAccessorialEntity', uuid: string } | { __typename?: 'StandardAccessorialEntity', uuid: string } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string }> | null, terminal?: { __typename?: 'TerminalEntity', uuid: string, name: string, code: string } | null, fuelProfile?: { __typename?: 'FuelProfileEntity', uuid: string, name?: string | null, startDate?: any | null, expirationDate?: any | null, billingType: FuelBillingMethod, type: FuelProfileType, company: { __typename?: 'CompanyEntity', uuid: string }, contacts?: Array<{ __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string }> | null, fuelProfileDateRanges: Array<{ __typename?: 'FuelProfileDateRangeEntity', uuid: string, startDate: any, expirationDate: any, surchargeRate?: number | null, flatRateUsdCents?: number | null }> } | null, generalLedgerCode?: { __typename?: 'GeneralLedgerCodeEntity', id: string, code: string } | null } | { __typename: 'WaitTimeAccessorialEntity', isArchived?: boolean | null, isAuthoCodeRequired: boolean, isDefaultGlobalSpecial: boolean, invoiceDisplayName?: string | null, quickbooksDesktopAccessorialId?: string | null, uuid: string, quickbooksFileMappingChargeName?: string | null, quickbooksMappingId: string, percentForSettlement?: number | null, name: string, code?: string | null, ediCode?: string | null, rate: number, maximumCharge?: number | null, minimumCharge?: number | null, waitTimeChargePeriod?: number | null, waitTimeFreeMinutes?: number | null, contact?: { __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string } | null, matchingGlobalAccessorial?: { __typename?: 'SkidBasedAccessorialEntity', uuid: string } | { __typename?: 'SpecialAccessorialEntity', uuid: string } | { __typename?: 'StandardAccessorialEntity', uuid: string } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string } | null, matchingCustomerAccessorials?: Array<{ __typename?: 'SkidBasedAccessorialEntity', uuid: string } | { __typename?: 'SpecialAccessorialEntity', uuid: string } | { __typename?: 'StandardAccessorialEntity', uuid: string } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string }> | null, terminal?: { __typename?: 'TerminalEntity', uuid: string, name: string, code: string } | null, fuelProfile?: { __typename?: 'FuelProfileEntity', uuid: string, name?: string | null, startDate?: any | null, expirationDate?: any | null, billingType: FuelBillingMethod, type: FuelProfileType, company: { __typename?: 'CompanyEntity', uuid: string }, contacts?: Array<{ __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string }> | null, fuelProfileDateRanges: Array<{ __typename?: 'FuelProfileDateRangeEntity', uuid: string, startDate: any, expirationDate: any, surchargeRate?: number | null, flatRateUsdCents?: number | null }> } | null, generalLedgerCode?: { __typename?: 'GeneralLedgerCodeEntity', id: string, code: string } | null } | { __typename: 'WeightBasedAccessorialEntity', isArchived?: boolean | null, isAuthoCodeRequired: boolean, isDefaultGlobalSpecial: boolean, invoiceDisplayName?: string | null, quickbooksDesktopAccessorialId?: string | null, uuid: string, quickbooksFileMappingChargeName?: string | null, quickbooksMappingId: string, percentForSettlement?: number | null, name: string, code?: string | null, ediCode?: string | null, ratePerHundredWeight: number, maximumCharge?: number | null, minimumCharge?: number | null, contact?: { __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string } | null, accessorialRanges?: Array<{ __typename?: 'AccessorialRangeEntity', uuid: string, lessThanOrEqualToValue: number, rateUsdCents: number }> | null, matchingGlobalAccessorial?: { __typename?: 'SkidBasedAccessorialEntity', uuid: string } | { __typename?: 'SpecialAccessorialEntity', uuid: string } | { __typename?: 'StandardAccessorialEntity', uuid: string } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string } | null, matchingCustomerAccessorials?: Array<{ __typename?: 'SkidBasedAccessorialEntity', uuid: string } | { __typename?: 'SpecialAccessorialEntity', uuid: string } | { __typename?: 'StandardAccessorialEntity', uuid: string } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string }> | null, terminal?: { __typename?: 'TerminalEntity', uuid: string, name: string, code: string } | null, fuelProfile?: { __typename?: 'FuelProfileEntity', uuid: string, name?: string | null, startDate?: any | null, expirationDate?: any | null, billingType: FuelBillingMethod, type: FuelProfileType, company: { __typename?: 'CompanyEntity', uuid: string }, contacts?: Array<{ __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string }> | null, fuelProfileDateRanges: Array<{ __typename?: 'FuelProfileDateRangeEntity', uuid: string, startDate: any, expirationDate: any, surchargeRate?: number | null, flatRateUsdCents?: number | null }> } | null, generalLedgerCode?: { __typename?: 'GeneralLedgerCodeEntity', code: string, id: string } | null } | { __typename: 'ZoneBasedAccessorialEntity', isArchived?: boolean | null, isAuthoCodeRequired: boolean, isDefaultGlobalSpecial: boolean, invoiceDisplayName?: string | null, quickbooksDesktopAccessorialId?: string | null, uuid: string, quickbooksFileMappingChargeName?: string | null, quickbooksMappingId: string, percentForSettlement?: number | null, name: string, code?: string | null, ediCode?: string | null, contact?: { __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string } | null, zones: Array<{ __typename?: 'ZoneBasedAccessorialZoneEntity', uuid: string, name: string }>, chargeGroups: Array<{ __typename?: 'ZoneBasedAccessorialChargeGroupEntity', uuid: string, name: string }>, matrixItems: Array<{ __typename?: 'ZoneBasedAccessorialMatrixItemEntity', zoneUuid: string, chargeGroupUuid: string, uuid: string, rate: number }>, matchingGlobalAccessorial?: { __typename?: 'SkidBasedAccessorialEntity', uuid: string } | { __typename?: 'SpecialAccessorialEntity', uuid: string } | { __typename?: 'StandardAccessorialEntity', uuid: string } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string } | null, matchingCustomerAccessorials?: Array<{ __typename?: 'SkidBasedAccessorialEntity', uuid: string } | { __typename?: 'SpecialAccessorialEntity', uuid: string } | { __typename?: 'StandardAccessorialEntity', uuid: string } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string }> | null, terminal?: { __typename?: 'TerminalEntity', uuid: string, name: string, code: string } | null, fuelProfile?: { __typename?: 'FuelProfileEntity', uuid: string, name?: string | null, startDate?: any | null, expirationDate?: any | null, billingType: FuelBillingMethod, type: FuelProfileType, company: { __typename?: 'CompanyEntity', uuid: string }, contacts?: Array<{ __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string }> | null, fuelProfileDateRanges: Array<{ __typename?: 'FuelProfileDateRangeEntity', uuid: string, startDate: any, expirationDate: any, surchargeRate?: number | null, flatRateUsdCents?: number | null }> } | null, generalLedgerCode?: { __typename?: 'GeneralLedgerCodeEntity', id: string, code: string } | null }>, service?: { __typename?: 'ServiceEntity', uuid: string, name: string } | null, terminal?: { __typename?: 'TerminalEntity', uuid: string, name: string, code: string } | null, tag?: { __typename?: 'TagEntity', uuid: string, value: string } | null, contact?: { __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string } | null, contactsToExcludeFromRule?: Array<{ __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string }> | null, contactsToIncludeWithRule?: Array<{ __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string }> | null };

export type AutoApplyAccessorialConfigQueryVariables = Exact<{
  uuid: Scalars['String']['input'];
}>;


export type AutoApplyAccessorialConfigQuery = { __typename?: 'Query', autoApplyAccessorialConfig?: { __typename?: 'AutoApplyAccessorialConfigEntity', uuid: string, ruleType: AutoApplyAccessorialRuleType, stopType?: PickupOrDelivery | null, accessorials: Array<{ __typename: 'SkidBasedAccessorialEntity', isArchived?: boolean | null, isAuthoCodeRequired: boolean, isDefaultGlobalSpecial: boolean, invoiceDisplayName?: string | null, quickbooksDesktopAccessorialId?: string | null, uuid: string, quickbooksFileMappingChargeName?: string | null, quickbooksMappingId: string, percentForSettlement?: number | null, name: string, code?: string | null, ediCode?: string | null, ratePerSkid: number, maximumCharge?: number | null, minimumCharge?: number | null, contact?: { __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string } | null, matchingGlobalAccessorial?: { __typename?: 'SkidBasedAccessorialEntity', uuid: string } | { __typename?: 'SpecialAccessorialEntity', uuid: string } | { __typename?: 'StandardAccessorialEntity', uuid: string } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string } | null, matchingCustomerAccessorials?: Array<{ __typename?: 'SkidBasedAccessorialEntity', uuid: string } | { __typename?: 'SpecialAccessorialEntity', uuid: string } | { __typename?: 'StandardAccessorialEntity', uuid: string } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string }> | null, terminal?: { __typename?: 'TerminalEntity', uuid: string, name: string, code: string } | null, fuelProfile?: { __typename?: 'FuelProfileEntity', uuid: string, name?: string | null, startDate?: any | null, expirationDate?: any | null, billingType: FuelBillingMethod, type: FuelProfileType, company: { __typename?: 'CompanyEntity', uuid: string }, contacts?: Array<{ __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string }> | null, fuelProfileDateRanges: Array<{ __typename?: 'FuelProfileDateRangeEntity', uuid: string, startDate: any, expirationDate: any, surchargeRate?: number | null, flatRateUsdCents?: number | null }> } | null, generalLedgerCode?: { __typename?: 'GeneralLedgerCodeEntity', id: string, code: string } | null } | { __typename: 'SpecialAccessorialEntity', isArchived?: boolean | null, isAuthoCodeRequired: boolean, isDefaultGlobalSpecial: boolean, specialAccessorialType?: SpecialAccessorialType | null, invoiceDisplayName?: string | null, uuid: string, quickbooksDesktopAccessorialId?: string | null, quickbooksFileMappingChargeName?: string | null, quickbooksMappingId: string, percentForSettlement?: number | null, name: string, code?: string | null, ediCode?: string | null, contact?: { __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string } | null, serviceLevel?: { __typename?: 'ServiceEntity', uuid: string, name: string, createdAt: any, updatedAt: any, timeInMinutes?: number | null, useApptInRouteOptimization: boolean, markOrdersAsSpecial: boolean, defaultAppointmentStartTime?: any | null, defaultAppointmentEndTime?: any | null, defaultStartNow: boolean, defaultInboundStopType?: StopType | null, defaultOutboundStopType?: StopType | null, defaultPickupPadding?: any | null, defaultDeliveryPadding?: any | null, defaultTotalDuration?: any | null, defaultIsLineHaul: boolean, defaultFulfillmentType?: FulfillmentType | null, isActive: boolean, isExposedToCustomers: boolean, serviceAvailabilityDates: Array<{ __typename?: 'ServiceAvailabilityDateEntity', id: string, dayCategory: SpecialDayOfWeek, enabled: boolean, start: { __typename?: 'PlainTime', hour: number, minute: number }, end: { __typename?: 'PlainTime', hour: number, minute: number } }> } | null, zones: Array<{ __typename?: 'TariffZoneEntity', uuid: string, name: string }>, chargeGroups: Array<{ __typename?: 'SpecialAccessorialChargeGroupEntity', uuid: string, dayOfWeek: SpecialDayOfWeek, startTime: any, endTime: any }>, matrixItems: Array<{ __typename?: 'SpecialAccessorialMatrixItemEntity', zoneUuid: string, chargeGroupUuid: string, uuid: string, rate: number }>, matchingGlobalAccessorial?: { __typename?: 'SkidBasedAccessorialEntity', uuid: string } | { __typename?: 'SpecialAccessorialEntity', uuid: string } | { __typename?: 'StandardAccessorialEntity', uuid: string } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string } | null, matchingCustomerAccessorials?: Array<{ __typename?: 'SkidBasedAccessorialEntity', uuid: string } | { __typename?: 'SpecialAccessorialEntity', uuid: string } | { __typename?: 'StandardAccessorialEntity', uuid: string } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string }> | null, terminal?: { __typename?: 'TerminalEntity', uuid: string, name: string, code: string } | null, fuelProfile?: { __typename?: 'FuelProfileEntity', uuid: string, name?: string | null, startDate?: any | null, expirationDate?: any | null, billingType: FuelBillingMethod, type: FuelProfileType, company: { __typename?: 'CompanyEntity', uuid: string }, contacts?: Array<{ __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string }> | null, fuelProfileDateRanges: Array<{ __typename?: 'FuelProfileDateRangeEntity', uuid: string, startDate: any, expirationDate: any, surchargeRate?: number | null, flatRateUsdCents?: number | null }> } | null, tariffZoneGroup?: { __typename?: 'TariffZoneGroupEntity', id: string } | null, generalLedgerCode?: { __typename?: 'GeneralLedgerCodeEntity', id: string, code: string } | null } | { __typename: 'StandardAccessorialEntity', isArchived?: boolean | null, isAuthoCodeRequired: boolean, isDefaultGlobalSpecial: boolean, invoiceDisplayName?: string | null, quickbooksDesktopAccessorialId?: string | null, uuid: string, quickbooksFileMappingChargeName?: string | null, quickbooksMappingId: string, percentForSettlement?: number | null, name: string, code?: string | null, ediCode?: string | null, rate: number, contact?: { __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string } | null, matchingGlobalAccessorial?: { __typename?: 'SkidBasedAccessorialEntity', uuid: string } | { __typename?: 'SpecialAccessorialEntity', uuid: string } | { __typename?: 'StandardAccessorialEntity', uuid: string } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string } | null, matchingCustomerAccessorials?: Array<{ __typename?: 'SkidBasedAccessorialEntity', uuid: string } | { __typename?: 'SpecialAccessorialEntity', uuid: string } | { __typename?: 'StandardAccessorialEntity', uuid: string } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string }> | null, terminal?: { __typename?: 'TerminalEntity', uuid: string, name: string, code: string } | null, fuelProfile?: { __typename?: 'FuelProfileEntity', uuid: string, name?: string | null, startDate?: any | null, expirationDate?: any | null, billingType: FuelBillingMethod, type: FuelProfileType, company: { __typename?: 'CompanyEntity', uuid: string }, contacts?: Array<{ __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string }> | null, fuelProfileDateRanges: Array<{ __typename?: 'FuelProfileDateRangeEntity', uuid: string, startDate: any, expirationDate: any, surchargeRate?: number | null, flatRateUsdCents?: number | null }> } | null, generalLedgerCode?: { __typename?: 'GeneralLedgerCodeEntity', id: string, code: string } | null } | { __typename: 'UnitBasedAccessorialEntity', isArchived?: boolean | null, isAuthoCodeRequired: boolean, isDefaultGlobalSpecial: boolean, invoiceDisplayName?: string | null, quickbooksDesktopAccessorialId?: string | null, uuid: string, quickbooksFileMappingChargeName?: string | null, quickbooksMappingId: string, percentForSettlement?: number | null, name: string, code?: string | null, ediCode?: string | null, ratePerUnit: number, maximumCharge?: number | null, minimumCharge?: number | null, contact?: { __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string } | null, matchingGlobalAccessorial?: { __typename?: 'SkidBasedAccessorialEntity', uuid: string } | { __typename?: 'SpecialAccessorialEntity', uuid: string } | { __typename?: 'StandardAccessorialEntity', uuid: string } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string } | null, matchingCustomerAccessorials?: Array<{ __typename?: 'SkidBasedAccessorialEntity', uuid: string } | { __typename?: 'SpecialAccessorialEntity', uuid: string } | { __typename?: 'StandardAccessorialEntity', uuid: string } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string }> | null, terminal?: { __typename?: 'TerminalEntity', uuid: string, name: string, code: string } | null, fuelProfile?: { __typename?: 'FuelProfileEntity', uuid: string, name?: string | null, startDate?: any | null, expirationDate?: any | null, billingType: FuelBillingMethod, type: FuelProfileType, company: { __typename?: 'CompanyEntity', uuid: string }, contacts?: Array<{ __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string }> | null, fuelProfileDateRanges: Array<{ __typename?: 'FuelProfileDateRangeEntity', uuid: string, startDate: any, expirationDate: any, surchargeRate?: number | null, flatRateUsdCents?: number | null }> } | null, generalLedgerCode?: { __typename?: 'GeneralLedgerCodeEntity', id: string, code: string } | null } | { __typename: 'WaitTimeAccessorialEntity', isArchived?: boolean | null, isAuthoCodeRequired: boolean, isDefaultGlobalSpecial: boolean, invoiceDisplayName?: string | null, quickbooksDesktopAccessorialId?: string | null, uuid: string, quickbooksFileMappingChargeName?: string | null, quickbooksMappingId: string, percentForSettlement?: number | null, name: string, code?: string | null, ediCode?: string | null, rate: number, maximumCharge?: number | null, minimumCharge?: number | null, waitTimeChargePeriod?: number | null, waitTimeFreeMinutes?: number | null, contact?: { __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string } | null, matchingGlobalAccessorial?: { __typename?: 'SkidBasedAccessorialEntity', uuid: string } | { __typename?: 'SpecialAccessorialEntity', uuid: string } | { __typename?: 'StandardAccessorialEntity', uuid: string } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string } | null, matchingCustomerAccessorials?: Array<{ __typename?: 'SkidBasedAccessorialEntity', uuid: string } | { __typename?: 'SpecialAccessorialEntity', uuid: string } | { __typename?: 'StandardAccessorialEntity', uuid: string } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string }> | null, terminal?: { __typename?: 'TerminalEntity', uuid: string, name: string, code: string } | null, fuelProfile?: { __typename?: 'FuelProfileEntity', uuid: string, name?: string | null, startDate?: any | null, expirationDate?: any | null, billingType: FuelBillingMethod, type: FuelProfileType, company: { __typename?: 'CompanyEntity', uuid: string }, contacts?: Array<{ __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string }> | null, fuelProfileDateRanges: Array<{ __typename?: 'FuelProfileDateRangeEntity', uuid: string, startDate: any, expirationDate: any, surchargeRate?: number | null, flatRateUsdCents?: number | null }> } | null, generalLedgerCode?: { __typename?: 'GeneralLedgerCodeEntity', id: string, code: string } | null } | { __typename: 'WeightBasedAccessorialEntity', isArchived?: boolean | null, isAuthoCodeRequired: boolean, isDefaultGlobalSpecial: boolean, invoiceDisplayName?: string | null, quickbooksDesktopAccessorialId?: string | null, uuid: string, quickbooksFileMappingChargeName?: string | null, quickbooksMappingId: string, percentForSettlement?: number | null, name: string, code?: string | null, ediCode?: string | null, ratePerHundredWeight: number, maximumCharge?: number | null, minimumCharge?: number | null, contact?: { __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string } | null, accessorialRanges?: Array<{ __typename?: 'AccessorialRangeEntity', uuid: string, lessThanOrEqualToValue: number, rateUsdCents: number }> | null, matchingGlobalAccessorial?: { __typename?: 'SkidBasedAccessorialEntity', uuid: string } | { __typename?: 'SpecialAccessorialEntity', uuid: string } | { __typename?: 'StandardAccessorialEntity', uuid: string } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string } | null, matchingCustomerAccessorials?: Array<{ __typename?: 'SkidBasedAccessorialEntity', uuid: string } | { __typename?: 'SpecialAccessorialEntity', uuid: string } | { __typename?: 'StandardAccessorialEntity', uuid: string } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string }> | null, terminal?: { __typename?: 'TerminalEntity', uuid: string, name: string, code: string } | null, fuelProfile?: { __typename?: 'FuelProfileEntity', uuid: string, name?: string | null, startDate?: any | null, expirationDate?: any | null, billingType: FuelBillingMethod, type: FuelProfileType, company: { __typename?: 'CompanyEntity', uuid: string }, contacts?: Array<{ __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string }> | null, fuelProfileDateRanges: Array<{ __typename?: 'FuelProfileDateRangeEntity', uuid: string, startDate: any, expirationDate: any, surchargeRate?: number | null, flatRateUsdCents?: number | null }> } | null, generalLedgerCode?: { __typename?: 'GeneralLedgerCodeEntity', code: string, id: string } | null } | { __typename: 'ZoneBasedAccessorialEntity', isArchived?: boolean | null, isAuthoCodeRequired: boolean, isDefaultGlobalSpecial: boolean, invoiceDisplayName?: string | null, quickbooksDesktopAccessorialId?: string | null, uuid: string, quickbooksFileMappingChargeName?: string | null, quickbooksMappingId: string, percentForSettlement?: number | null, name: string, code?: string | null, ediCode?: string | null, contact?: { __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string } | null, zones: Array<{ __typename?: 'ZoneBasedAccessorialZoneEntity', uuid: string, name: string }>, chargeGroups: Array<{ __typename?: 'ZoneBasedAccessorialChargeGroupEntity', uuid: string, name: string }>, matrixItems: Array<{ __typename?: 'ZoneBasedAccessorialMatrixItemEntity', zoneUuid: string, chargeGroupUuid: string, uuid: string, rate: number }>, matchingGlobalAccessorial?: { __typename?: 'SkidBasedAccessorialEntity', uuid: string } | { __typename?: 'SpecialAccessorialEntity', uuid: string } | { __typename?: 'StandardAccessorialEntity', uuid: string } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string } | null, matchingCustomerAccessorials?: Array<{ __typename?: 'SkidBasedAccessorialEntity', uuid: string } | { __typename?: 'SpecialAccessorialEntity', uuid: string } | { __typename?: 'StandardAccessorialEntity', uuid: string } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string }> | null, terminal?: { __typename?: 'TerminalEntity', uuid: string, name: string, code: string } | null, fuelProfile?: { __typename?: 'FuelProfileEntity', uuid: string, name?: string | null, startDate?: any | null, expirationDate?: any | null, billingType: FuelBillingMethod, type: FuelProfileType, company: { __typename?: 'CompanyEntity', uuid: string }, contacts?: Array<{ __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string }> | null, fuelProfileDateRanges: Array<{ __typename?: 'FuelProfileDateRangeEntity', uuid: string, startDate: any, expirationDate: any, surchargeRate?: number | null, flatRateUsdCents?: number | null }> } | null, generalLedgerCode?: { __typename?: 'GeneralLedgerCodeEntity', id: string, code: string } | null }>, service?: { __typename?: 'ServiceEntity', uuid: string, name: string } | null, terminal?: { __typename?: 'TerminalEntity', uuid: string, name: string, code: string } | null, tag?: { __typename?: 'TagEntity', uuid: string, value: string } | null, contact?: { __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string } | null, contactsToExcludeFromRule?: Array<{ __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string }> | null, contactsToIncludeWithRule?: Array<{ __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string }> | null } | null };

export type AutoApplyAccessorialConfigsQueryVariables = Exact<{ [key: string]: never; }>;


export type AutoApplyAccessorialConfigsQuery = { __typename?: 'Query', autoApplyAccessorialConfigs?: Array<{ __typename?: 'AutoApplyAccessorialConfigEntity', uuid: string, ruleType: AutoApplyAccessorialRuleType, stopType?: PickupOrDelivery | null, accessorials: Array<{ __typename: 'SkidBasedAccessorialEntity', isArchived?: boolean | null, isAuthoCodeRequired: boolean, isDefaultGlobalSpecial: boolean, invoiceDisplayName?: string | null, quickbooksDesktopAccessorialId?: string | null, uuid: string, quickbooksFileMappingChargeName?: string | null, quickbooksMappingId: string, percentForSettlement?: number | null, name: string, code?: string | null, ediCode?: string | null, ratePerSkid: number, maximumCharge?: number | null, minimumCharge?: number | null, contact?: { __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string } | null, matchingGlobalAccessorial?: { __typename?: 'SkidBasedAccessorialEntity', uuid: string } | { __typename?: 'SpecialAccessorialEntity', uuid: string } | { __typename?: 'StandardAccessorialEntity', uuid: string } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string } | null, matchingCustomerAccessorials?: Array<{ __typename?: 'SkidBasedAccessorialEntity', uuid: string } | { __typename?: 'SpecialAccessorialEntity', uuid: string } | { __typename?: 'StandardAccessorialEntity', uuid: string } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string }> | null, terminal?: { __typename?: 'TerminalEntity', uuid: string, name: string, code: string } | null, fuelProfile?: { __typename?: 'FuelProfileEntity', uuid: string, name?: string | null, startDate?: any | null, expirationDate?: any | null, billingType: FuelBillingMethod, type: FuelProfileType, company: { __typename?: 'CompanyEntity', uuid: string }, contacts?: Array<{ __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string }> | null, fuelProfileDateRanges: Array<{ __typename?: 'FuelProfileDateRangeEntity', uuid: string, startDate: any, expirationDate: any, surchargeRate?: number | null, flatRateUsdCents?: number | null }> } | null, generalLedgerCode?: { __typename?: 'GeneralLedgerCodeEntity', id: string, code: string } | null } | { __typename: 'SpecialAccessorialEntity', isArchived?: boolean | null, isAuthoCodeRequired: boolean, isDefaultGlobalSpecial: boolean, specialAccessorialType?: SpecialAccessorialType | null, invoiceDisplayName?: string | null, uuid: string, quickbooksDesktopAccessorialId?: string | null, quickbooksFileMappingChargeName?: string | null, quickbooksMappingId: string, percentForSettlement?: number | null, name: string, code?: string | null, ediCode?: string | null, contact?: { __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string } | null, serviceLevel?: { __typename?: 'ServiceEntity', uuid: string, name: string, createdAt: any, updatedAt: any, timeInMinutes?: number | null, useApptInRouteOptimization: boolean, markOrdersAsSpecial: boolean, defaultAppointmentStartTime?: any | null, defaultAppointmentEndTime?: any | null, defaultStartNow: boolean, defaultInboundStopType?: StopType | null, defaultOutboundStopType?: StopType | null, defaultPickupPadding?: any | null, defaultDeliveryPadding?: any | null, defaultTotalDuration?: any | null, defaultIsLineHaul: boolean, defaultFulfillmentType?: FulfillmentType | null, isActive: boolean, isExposedToCustomers: boolean, serviceAvailabilityDates: Array<{ __typename?: 'ServiceAvailabilityDateEntity', id: string, dayCategory: SpecialDayOfWeek, enabled: boolean, start: { __typename?: 'PlainTime', hour: number, minute: number }, end: { __typename?: 'PlainTime', hour: number, minute: number } }> } | null, zones: Array<{ __typename?: 'TariffZoneEntity', uuid: string, name: string }>, chargeGroups: Array<{ __typename?: 'SpecialAccessorialChargeGroupEntity', uuid: string, dayOfWeek: SpecialDayOfWeek, startTime: any, endTime: any }>, matrixItems: Array<{ __typename?: 'SpecialAccessorialMatrixItemEntity', zoneUuid: string, chargeGroupUuid: string, uuid: string, rate: number }>, matchingGlobalAccessorial?: { __typename?: 'SkidBasedAccessorialEntity', uuid: string } | { __typename?: 'SpecialAccessorialEntity', uuid: string } | { __typename?: 'StandardAccessorialEntity', uuid: string } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string } | null, matchingCustomerAccessorials?: Array<{ __typename?: 'SkidBasedAccessorialEntity', uuid: string } | { __typename?: 'SpecialAccessorialEntity', uuid: string } | { __typename?: 'StandardAccessorialEntity', uuid: string } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string }> | null, terminal?: { __typename?: 'TerminalEntity', uuid: string, name: string, code: string } | null, fuelProfile?: { __typename?: 'FuelProfileEntity', uuid: string, name?: string | null, startDate?: any | null, expirationDate?: any | null, billingType: FuelBillingMethod, type: FuelProfileType, company: { __typename?: 'CompanyEntity', uuid: string }, contacts?: Array<{ __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string }> | null, fuelProfileDateRanges: Array<{ __typename?: 'FuelProfileDateRangeEntity', uuid: string, startDate: any, expirationDate: any, surchargeRate?: number | null, flatRateUsdCents?: number | null }> } | null, tariffZoneGroup?: { __typename?: 'TariffZoneGroupEntity', id: string } | null, generalLedgerCode?: { __typename?: 'GeneralLedgerCodeEntity', id: string, code: string } | null } | { __typename: 'StandardAccessorialEntity', isArchived?: boolean | null, isAuthoCodeRequired: boolean, isDefaultGlobalSpecial: boolean, invoiceDisplayName?: string | null, quickbooksDesktopAccessorialId?: string | null, uuid: string, quickbooksFileMappingChargeName?: string | null, quickbooksMappingId: string, percentForSettlement?: number | null, name: string, code?: string | null, ediCode?: string | null, rate: number, contact?: { __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string } | null, matchingGlobalAccessorial?: { __typename?: 'SkidBasedAccessorialEntity', uuid: string } | { __typename?: 'SpecialAccessorialEntity', uuid: string } | { __typename?: 'StandardAccessorialEntity', uuid: string } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string } | null, matchingCustomerAccessorials?: Array<{ __typename?: 'SkidBasedAccessorialEntity', uuid: string } | { __typename?: 'SpecialAccessorialEntity', uuid: string } | { __typename?: 'StandardAccessorialEntity', uuid: string } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string }> | null, terminal?: { __typename?: 'TerminalEntity', uuid: string, name: string, code: string } | null, fuelProfile?: { __typename?: 'FuelProfileEntity', uuid: string, name?: string | null, startDate?: any | null, expirationDate?: any | null, billingType: FuelBillingMethod, type: FuelProfileType, company: { __typename?: 'CompanyEntity', uuid: string }, contacts?: Array<{ __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string }> | null, fuelProfileDateRanges: Array<{ __typename?: 'FuelProfileDateRangeEntity', uuid: string, startDate: any, expirationDate: any, surchargeRate?: number | null, flatRateUsdCents?: number | null }> } | null, generalLedgerCode?: { __typename?: 'GeneralLedgerCodeEntity', id: string, code: string } | null } | { __typename: 'UnitBasedAccessorialEntity', isArchived?: boolean | null, isAuthoCodeRequired: boolean, isDefaultGlobalSpecial: boolean, invoiceDisplayName?: string | null, quickbooksDesktopAccessorialId?: string | null, uuid: string, quickbooksFileMappingChargeName?: string | null, quickbooksMappingId: string, percentForSettlement?: number | null, name: string, code?: string | null, ediCode?: string | null, ratePerUnit: number, maximumCharge?: number | null, minimumCharge?: number | null, contact?: { __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string } | null, matchingGlobalAccessorial?: { __typename?: 'SkidBasedAccessorialEntity', uuid: string } | { __typename?: 'SpecialAccessorialEntity', uuid: string } | { __typename?: 'StandardAccessorialEntity', uuid: string } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string } | null, matchingCustomerAccessorials?: Array<{ __typename?: 'SkidBasedAccessorialEntity', uuid: string } | { __typename?: 'SpecialAccessorialEntity', uuid: string } | { __typename?: 'StandardAccessorialEntity', uuid: string } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string }> | null, terminal?: { __typename?: 'TerminalEntity', uuid: string, name: string, code: string } | null, fuelProfile?: { __typename?: 'FuelProfileEntity', uuid: string, name?: string | null, startDate?: any | null, expirationDate?: any | null, billingType: FuelBillingMethod, type: FuelProfileType, company: { __typename?: 'CompanyEntity', uuid: string }, contacts?: Array<{ __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string }> | null, fuelProfileDateRanges: Array<{ __typename?: 'FuelProfileDateRangeEntity', uuid: string, startDate: any, expirationDate: any, surchargeRate?: number | null, flatRateUsdCents?: number | null }> } | null, generalLedgerCode?: { __typename?: 'GeneralLedgerCodeEntity', id: string, code: string } | null } | { __typename: 'WaitTimeAccessorialEntity', isArchived?: boolean | null, isAuthoCodeRequired: boolean, isDefaultGlobalSpecial: boolean, invoiceDisplayName?: string | null, quickbooksDesktopAccessorialId?: string | null, uuid: string, quickbooksFileMappingChargeName?: string | null, quickbooksMappingId: string, percentForSettlement?: number | null, name: string, code?: string | null, ediCode?: string | null, rate: number, maximumCharge?: number | null, minimumCharge?: number | null, waitTimeChargePeriod?: number | null, waitTimeFreeMinutes?: number | null, contact?: { __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string } | null, matchingGlobalAccessorial?: { __typename?: 'SkidBasedAccessorialEntity', uuid: string } | { __typename?: 'SpecialAccessorialEntity', uuid: string } | { __typename?: 'StandardAccessorialEntity', uuid: string } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string } | null, matchingCustomerAccessorials?: Array<{ __typename?: 'SkidBasedAccessorialEntity', uuid: string } | { __typename?: 'SpecialAccessorialEntity', uuid: string } | { __typename?: 'StandardAccessorialEntity', uuid: string } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string }> | null, terminal?: { __typename?: 'TerminalEntity', uuid: string, name: string, code: string } | null, fuelProfile?: { __typename?: 'FuelProfileEntity', uuid: string, name?: string | null, startDate?: any | null, expirationDate?: any | null, billingType: FuelBillingMethod, type: FuelProfileType, company: { __typename?: 'CompanyEntity', uuid: string }, contacts?: Array<{ __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string }> | null, fuelProfileDateRanges: Array<{ __typename?: 'FuelProfileDateRangeEntity', uuid: string, startDate: any, expirationDate: any, surchargeRate?: number | null, flatRateUsdCents?: number | null }> } | null, generalLedgerCode?: { __typename?: 'GeneralLedgerCodeEntity', id: string, code: string } | null } | { __typename: 'WeightBasedAccessorialEntity', isArchived?: boolean | null, isAuthoCodeRequired: boolean, isDefaultGlobalSpecial: boolean, invoiceDisplayName?: string | null, quickbooksDesktopAccessorialId?: string | null, uuid: string, quickbooksFileMappingChargeName?: string | null, quickbooksMappingId: string, percentForSettlement?: number | null, name: string, code?: string | null, ediCode?: string | null, ratePerHundredWeight: number, maximumCharge?: number | null, minimumCharge?: number | null, contact?: { __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string } | null, accessorialRanges?: Array<{ __typename?: 'AccessorialRangeEntity', uuid: string, lessThanOrEqualToValue: number, rateUsdCents: number }> | null, matchingGlobalAccessorial?: { __typename?: 'SkidBasedAccessorialEntity', uuid: string } | { __typename?: 'SpecialAccessorialEntity', uuid: string } | { __typename?: 'StandardAccessorialEntity', uuid: string } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string } | null, matchingCustomerAccessorials?: Array<{ __typename?: 'SkidBasedAccessorialEntity', uuid: string } | { __typename?: 'SpecialAccessorialEntity', uuid: string } | { __typename?: 'StandardAccessorialEntity', uuid: string } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string }> | null, terminal?: { __typename?: 'TerminalEntity', uuid: string, name: string, code: string } | null, fuelProfile?: { __typename?: 'FuelProfileEntity', uuid: string, name?: string | null, startDate?: any | null, expirationDate?: any | null, billingType: FuelBillingMethod, type: FuelProfileType, company: { __typename?: 'CompanyEntity', uuid: string }, contacts?: Array<{ __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string }> | null, fuelProfileDateRanges: Array<{ __typename?: 'FuelProfileDateRangeEntity', uuid: string, startDate: any, expirationDate: any, surchargeRate?: number | null, flatRateUsdCents?: number | null }> } | null, generalLedgerCode?: { __typename?: 'GeneralLedgerCodeEntity', code: string, id: string } | null } | { __typename: 'ZoneBasedAccessorialEntity', isArchived?: boolean | null, isAuthoCodeRequired: boolean, isDefaultGlobalSpecial: boolean, invoiceDisplayName?: string | null, quickbooksDesktopAccessorialId?: string | null, uuid: string, quickbooksFileMappingChargeName?: string | null, quickbooksMappingId: string, percentForSettlement?: number | null, name: string, code?: string | null, ediCode?: string | null, contact?: { __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string } | null, zones: Array<{ __typename?: 'ZoneBasedAccessorialZoneEntity', uuid: string, name: string }>, chargeGroups: Array<{ __typename?: 'ZoneBasedAccessorialChargeGroupEntity', uuid: string, name: string }>, matrixItems: Array<{ __typename?: 'ZoneBasedAccessorialMatrixItemEntity', zoneUuid: string, chargeGroupUuid: string, uuid: string, rate: number }>, matchingGlobalAccessorial?: { __typename?: 'SkidBasedAccessorialEntity', uuid: string } | { __typename?: 'SpecialAccessorialEntity', uuid: string } | { __typename?: 'StandardAccessorialEntity', uuid: string } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string } | null, matchingCustomerAccessorials?: Array<{ __typename?: 'SkidBasedAccessorialEntity', uuid: string } | { __typename?: 'SpecialAccessorialEntity', uuid: string } | { __typename?: 'StandardAccessorialEntity', uuid: string } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string }> | null, terminal?: { __typename?: 'TerminalEntity', uuid: string, name: string, code: string } | null, fuelProfile?: { __typename?: 'FuelProfileEntity', uuid: string, name?: string | null, startDate?: any | null, expirationDate?: any | null, billingType: FuelBillingMethod, type: FuelProfileType, company: { __typename?: 'CompanyEntity', uuid: string }, contacts?: Array<{ __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string }> | null, fuelProfileDateRanges: Array<{ __typename?: 'FuelProfileDateRangeEntity', uuid: string, startDate: any, expirationDate: any, surchargeRate?: number | null, flatRateUsdCents?: number | null }> } | null, generalLedgerCode?: { __typename?: 'GeneralLedgerCodeEntity', id: string, code: string } | null }>, service?: { __typename?: 'ServiceEntity', uuid: string, name: string } | null, terminal?: { __typename?: 'TerminalEntity', uuid: string, name: string, code: string } | null, tag?: { __typename?: 'TagEntity', uuid: string, value: string } | null, contact?: { __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string } | null, contactsToExcludeFromRule?: Array<{ __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string }> | null, contactsToIncludeWithRule?: Array<{ __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string }> | null }> | null };

export type CreateAutoApplyAccessorialConfigMutationVariables = Exact<{
  createAutoApplyAccessorialConfigInput: CreateAutoApplyAccessorialConfigInput;
}>;


export type CreateAutoApplyAccessorialConfigMutation = { __typename?: 'Mutation', createAutoApplyAccessorialConfig: { __typename?: 'AutoApplyAccessorialConfigEntity', uuid: string, ruleType: AutoApplyAccessorialRuleType, stopType?: PickupOrDelivery | null, accessorials: Array<{ __typename: 'SkidBasedAccessorialEntity', isArchived?: boolean | null, isAuthoCodeRequired: boolean, isDefaultGlobalSpecial: boolean, invoiceDisplayName?: string | null, quickbooksDesktopAccessorialId?: string | null, uuid: string, quickbooksFileMappingChargeName?: string | null, quickbooksMappingId: string, percentForSettlement?: number | null, name: string, code?: string | null, ediCode?: string | null, ratePerSkid: number, maximumCharge?: number | null, minimumCharge?: number | null, contact?: { __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string } | null, matchingGlobalAccessorial?: { __typename?: 'SkidBasedAccessorialEntity', uuid: string } | { __typename?: 'SpecialAccessorialEntity', uuid: string } | { __typename?: 'StandardAccessorialEntity', uuid: string } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string } | null, matchingCustomerAccessorials?: Array<{ __typename?: 'SkidBasedAccessorialEntity', uuid: string } | { __typename?: 'SpecialAccessorialEntity', uuid: string } | { __typename?: 'StandardAccessorialEntity', uuid: string } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string }> | null, terminal?: { __typename?: 'TerminalEntity', uuid: string, name: string, code: string } | null, fuelProfile?: { __typename?: 'FuelProfileEntity', uuid: string, name?: string | null, startDate?: any | null, expirationDate?: any | null, billingType: FuelBillingMethod, type: FuelProfileType, company: { __typename?: 'CompanyEntity', uuid: string }, contacts?: Array<{ __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string }> | null, fuelProfileDateRanges: Array<{ __typename?: 'FuelProfileDateRangeEntity', uuid: string, startDate: any, expirationDate: any, surchargeRate?: number | null, flatRateUsdCents?: number | null }> } | null, generalLedgerCode?: { __typename?: 'GeneralLedgerCodeEntity', id: string, code: string } | null } | { __typename: 'SpecialAccessorialEntity', isArchived?: boolean | null, isAuthoCodeRequired: boolean, isDefaultGlobalSpecial: boolean, specialAccessorialType?: SpecialAccessorialType | null, invoiceDisplayName?: string | null, uuid: string, quickbooksDesktopAccessorialId?: string | null, quickbooksFileMappingChargeName?: string | null, quickbooksMappingId: string, percentForSettlement?: number | null, name: string, code?: string | null, ediCode?: string | null, contact?: { __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string } | null, serviceLevel?: { __typename?: 'ServiceEntity', uuid: string, name: string, createdAt: any, updatedAt: any, timeInMinutes?: number | null, useApptInRouteOptimization: boolean, markOrdersAsSpecial: boolean, defaultAppointmentStartTime?: any | null, defaultAppointmentEndTime?: any | null, defaultStartNow: boolean, defaultInboundStopType?: StopType | null, defaultOutboundStopType?: StopType | null, defaultPickupPadding?: any | null, defaultDeliveryPadding?: any | null, defaultTotalDuration?: any | null, defaultIsLineHaul: boolean, defaultFulfillmentType?: FulfillmentType | null, isActive: boolean, isExposedToCustomers: boolean, serviceAvailabilityDates: Array<{ __typename?: 'ServiceAvailabilityDateEntity', id: string, dayCategory: SpecialDayOfWeek, enabled: boolean, start: { __typename?: 'PlainTime', hour: number, minute: number }, end: { __typename?: 'PlainTime', hour: number, minute: number } }> } | null, zones: Array<{ __typename?: 'TariffZoneEntity', uuid: string, name: string }>, chargeGroups: Array<{ __typename?: 'SpecialAccessorialChargeGroupEntity', uuid: string, dayOfWeek: SpecialDayOfWeek, startTime: any, endTime: any }>, matrixItems: Array<{ __typename?: 'SpecialAccessorialMatrixItemEntity', zoneUuid: string, chargeGroupUuid: string, uuid: string, rate: number }>, matchingGlobalAccessorial?: { __typename?: 'SkidBasedAccessorialEntity', uuid: string } | { __typename?: 'SpecialAccessorialEntity', uuid: string } | { __typename?: 'StandardAccessorialEntity', uuid: string } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string } | null, matchingCustomerAccessorials?: Array<{ __typename?: 'SkidBasedAccessorialEntity', uuid: string } | { __typename?: 'SpecialAccessorialEntity', uuid: string } | { __typename?: 'StandardAccessorialEntity', uuid: string } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string }> | null, terminal?: { __typename?: 'TerminalEntity', uuid: string, name: string, code: string } | null, fuelProfile?: { __typename?: 'FuelProfileEntity', uuid: string, name?: string | null, startDate?: any | null, expirationDate?: any | null, billingType: FuelBillingMethod, type: FuelProfileType, company: { __typename?: 'CompanyEntity', uuid: string }, contacts?: Array<{ __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string }> | null, fuelProfileDateRanges: Array<{ __typename?: 'FuelProfileDateRangeEntity', uuid: string, startDate: any, expirationDate: any, surchargeRate?: number | null, flatRateUsdCents?: number | null }> } | null, tariffZoneGroup?: { __typename?: 'TariffZoneGroupEntity', id: string } | null, generalLedgerCode?: { __typename?: 'GeneralLedgerCodeEntity', id: string, code: string } | null } | { __typename: 'StandardAccessorialEntity', isArchived?: boolean | null, isAuthoCodeRequired: boolean, isDefaultGlobalSpecial: boolean, invoiceDisplayName?: string | null, quickbooksDesktopAccessorialId?: string | null, uuid: string, quickbooksFileMappingChargeName?: string | null, quickbooksMappingId: string, percentForSettlement?: number | null, name: string, code?: string | null, ediCode?: string | null, rate: number, contact?: { __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string } | null, matchingGlobalAccessorial?: { __typename?: 'SkidBasedAccessorialEntity', uuid: string } | { __typename?: 'SpecialAccessorialEntity', uuid: string } | { __typename?: 'StandardAccessorialEntity', uuid: string } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string } | null, matchingCustomerAccessorials?: Array<{ __typename?: 'SkidBasedAccessorialEntity', uuid: string } | { __typename?: 'SpecialAccessorialEntity', uuid: string } | { __typename?: 'StandardAccessorialEntity', uuid: string } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string }> | null, terminal?: { __typename?: 'TerminalEntity', uuid: string, name: string, code: string } | null, fuelProfile?: { __typename?: 'FuelProfileEntity', uuid: string, name?: string | null, startDate?: any | null, expirationDate?: any | null, billingType: FuelBillingMethod, type: FuelProfileType, company: { __typename?: 'CompanyEntity', uuid: string }, contacts?: Array<{ __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string }> | null, fuelProfileDateRanges: Array<{ __typename?: 'FuelProfileDateRangeEntity', uuid: string, startDate: any, expirationDate: any, surchargeRate?: number | null, flatRateUsdCents?: number | null }> } | null, generalLedgerCode?: { __typename?: 'GeneralLedgerCodeEntity', id: string, code: string } | null } | { __typename: 'UnitBasedAccessorialEntity', isArchived?: boolean | null, isAuthoCodeRequired: boolean, isDefaultGlobalSpecial: boolean, invoiceDisplayName?: string | null, quickbooksDesktopAccessorialId?: string | null, uuid: string, quickbooksFileMappingChargeName?: string | null, quickbooksMappingId: string, percentForSettlement?: number | null, name: string, code?: string | null, ediCode?: string | null, ratePerUnit: number, maximumCharge?: number | null, minimumCharge?: number | null, contact?: { __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string } | null, matchingGlobalAccessorial?: { __typename?: 'SkidBasedAccessorialEntity', uuid: string } | { __typename?: 'SpecialAccessorialEntity', uuid: string } | { __typename?: 'StandardAccessorialEntity', uuid: string } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string } | null, matchingCustomerAccessorials?: Array<{ __typename?: 'SkidBasedAccessorialEntity', uuid: string } | { __typename?: 'SpecialAccessorialEntity', uuid: string } | { __typename?: 'StandardAccessorialEntity', uuid: string } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string }> | null, terminal?: { __typename?: 'TerminalEntity', uuid: string, name: string, code: string } | null, fuelProfile?: { __typename?: 'FuelProfileEntity', uuid: string, name?: string | null, startDate?: any | null, expirationDate?: any | null, billingType: FuelBillingMethod, type: FuelProfileType, company: { __typename?: 'CompanyEntity', uuid: string }, contacts?: Array<{ __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string }> | null, fuelProfileDateRanges: Array<{ __typename?: 'FuelProfileDateRangeEntity', uuid: string, startDate: any, expirationDate: any, surchargeRate?: number | null, flatRateUsdCents?: number | null }> } | null, generalLedgerCode?: { __typename?: 'GeneralLedgerCodeEntity', id: string, code: string } | null } | { __typename: 'WaitTimeAccessorialEntity', isArchived?: boolean | null, isAuthoCodeRequired: boolean, isDefaultGlobalSpecial: boolean, invoiceDisplayName?: string | null, quickbooksDesktopAccessorialId?: string | null, uuid: string, quickbooksFileMappingChargeName?: string | null, quickbooksMappingId: string, percentForSettlement?: number | null, name: string, code?: string | null, ediCode?: string | null, rate: number, maximumCharge?: number | null, minimumCharge?: number | null, waitTimeChargePeriod?: number | null, waitTimeFreeMinutes?: number | null, contact?: { __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string } | null, matchingGlobalAccessorial?: { __typename?: 'SkidBasedAccessorialEntity', uuid: string } | { __typename?: 'SpecialAccessorialEntity', uuid: string } | { __typename?: 'StandardAccessorialEntity', uuid: string } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string } | null, matchingCustomerAccessorials?: Array<{ __typename?: 'SkidBasedAccessorialEntity', uuid: string } | { __typename?: 'SpecialAccessorialEntity', uuid: string } | { __typename?: 'StandardAccessorialEntity', uuid: string } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string }> | null, terminal?: { __typename?: 'TerminalEntity', uuid: string, name: string, code: string } | null, fuelProfile?: { __typename?: 'FuelProfileEntity', uuid: string, name?: string | null, startDate?: any | null, expirationDate?: any | null, billingType: FuelBillingMethod, type: FuelProfileType, company: { __typename?: 'CompanyEntity', uuid: string }, contacts?: Array<{ __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string }> | null, fuelProfileDateRanges: Array<{ __typename?: 'FuelProfileDateRangeEntity', uuid: string, startDate: any, expirationDate: any, surchargeRate?: number | null, flatRateUsdCents?: number | null }> } | null, generalLedgerCode?: { __typename?: 'GeneralLedgerCodeEntity', id: string, code: string } | null } | { __typename: 'WeightBasedAccessorialEntity', isArchived?: boolean | null, isAuthoCodeRequired: boolean, isDefaultGlobalSpecial: boolean, invoiceDisplayName?: string | null, quickbooksDesktopAccessorialId?: string | null, uuid: string, quickbooksFileMappingChargeName?: string | null, quickbooksMappingId: string, percentForSettlement?: number | null, name: string, code?: string | null, ediCode?: string | null, ratePerHundredWeight: number, maximumCharge?: number | null, minimumCharge?: number | null, contact?: { __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string } | null, accessorialRanges?: Array<{ __typename?: 'AccessorialRangeEntity', uuid: string, lessThanOrEqualToValue: number, rateUsdCents: number }> | null, matchingGlobalAccessorial?: { __typename?: 'SkidBasedAccessorialEntity', uuid: string } | { __typename?: 'SpecialAccessorialEntity', uuid: string } | { __typename?: 'StandardAccessorialEntity', uuid: string } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string } | null, matchingCustomerAccessorials?: Array<{ __typename?: 'SkidBasedAccessorialEntity', uuid: string } | { __typename?: 'SpecialAccessorialEntity', uuid: string } | { __typename?: 'StandardAccessorialEntity', uuid: string } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string }> | null, terminal?: { __typename?: 'TerminalEntity', uuid: string, name: string, code: string } | null, fuelProfile?: { __typename?: 'FuelProfileEntity', uuid: string, name?: string | null, startDate?: any | null, expirationDate?: any | null, billingType: FuelBillingMethod, type: FuelProfileType, company: { __typename?: 'CompanyEntity', uuid: string }, contacts?: Array<{ __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string }> | null, fuelProfileDateRanges: Array<{ __typename?: 'FuelProfileDateRangeEntity', uuid: string, startDate: any, expirationDate: any, surchargeRate?: number | null, flatRateUsdCents?: number | null }> } | null, generalLedgerCode?: { __typename?: 'GeneralLedgerCodeEntity', code: string, id: string } | null } | { __typename: 'ZoneBasedAccessorialEntity', isArchived?: boolean | null, isAuthoCodeRequired: boolean, isDefaultGlobalSpecial: boolean, invoiceDisplayName?: string | null, quickbooksDesktopAccessorialId?: string | null, uuid: string, quickbooksFileMappingChargeName?: string | null, quickbooksMappingId: string, percentForSettlement?: number | null, name: string, code?: string | null, ediCode?: string | null, contact?: { __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string } | null, zones: Array<{ __typename?: 'ZoneBasedAccessorialZoneEntity', uuid: string, name: string }>, chargeGroups: Array<{ __typename?: 'ZoneBasedAccessorialChargeGroupEntity', uuid: string, name: string }>, matrixItems: Array<{ __typename?: 'ZoneBasedAccessorialMatrixItemEntity', zoneUuid: string, chargeGroupUuid: string, uuid: string, rate: number }>, matchingGlobalAccessorial?: { __typename?: 'SkidBasedAccessorialEntity', uuid: string } | { __typename?: 'SpecialAccessorialEntity', uuid: string } | { __typename?: 'StandardAccessorialEntity', uuid: string } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string } | null, matchingCustomerAccessorials?: Array<{ __typename?: 'SkidBasedAccessorialEntity', uuid: string } | { __typename?: 'SpecialAccessorialEntity', uuid: string } | { __typename?: 'StandardAccessorialEntity', uuid: string } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string }> | null, terminal?: { __typename?: 'TerminalEntity', uuid: string, name: string, code: string } | null, fuelProfile?: { __typename?: 'FuelProfileEntity', uuid: string, name?: string | null, startDate?: any | null, expirationDate?: any | null, billingType: FuelBillingMethod, type: FuelProfileType, company: { __typename?: 'CompanyEntity', uuid: string }, contacts?: Array<{ __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string }> | null, fuelProfileDateRanges: Array<{ __typename?: 'FuelProfileDateRangeEntity', uuid: string, startDate: any, expirationDate: any, surchargeRate?: number | null, flatRateUsdCents?: number | null }> } | null, generalLedgerCode?: { __typename?: 'GeneralLedgerCodeEntity', id: string, code: string } | null }>, service?: { __typename?: 'ServiceEntity', uuid: string, name: string } | null, terminal?: { __typename?: 'TerminalEntity', uuid: string, name: string, code: string } | null, tag?: { __typename?: 'TagEntity', uuid: string, value: string } | null, contact?: { __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string } | null, contactsToExcludeFromRule?: Array<{ __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string }> | null, contactsToIncludeWithRule?: Array<{ __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string }> | null } };

export type DeleteAutoApplyAccessorialConfigMutationVariables = Exact<{
  uuid: Scalars['String']['input'];
}>;


export type DeleteAutoApplyAccessorialConfigMutation = { __typename?: 'Mutation', deleteAutoApplyAccessorialConfig: boolean };

export type SelectSpecialAccessorialQueryVariables = Exact<{
  selectSpecialAccessorialInput: SelectSpecialAccessorialInput;
}>;


export type SelectSpecialAccessorialQuery = { __typename?: 'Query', selectSpecialAccessorial: { __typename?: 'SelectSpecialAccessorialOutput', accessorialUuid?: string | null, tariffZoneUuid?: string | null, chargeGroupUuid?: string | null, matrixItemUuid?: string | null } };

export type UpdateAutoApplyAccessorialConfigMutationVariables = Exact<{
  updateAutoApplyAccessorialConfigInput: UpdateAutoApplyAccessorialConfigInput;
}>;


export type UpdateAutoApplyAccessorialConfigMutation = { __typename?: 'Mutation', updateAutoApplyAccessorialConfig: { __typename?: 'AutoApplyAccessorialConfigEntity', uuid: string, ruleType: AutoApplyAccessorialRuleType, stopType?: PickupOrDelivery | null, accessorials: Array<{ __typename: 'SkidBasedAccessorialEntity', isArchived?: boolean | null, isAuthoCodeRequired: boolean, isDefaultGlobalSpecial: boolean, invoiceDisplayName?: string | null, quickbooksDesktopAccessorialId?: string | null, uuid: string, quickbooksFileMappingChargeName?: string | null, quickbooksMappingId: string, percentForSettlement?: number | null, name: string, code?: string | null, ediCode?: string | null, ratePerSkid: number, maximumCharge?: number | null, minimumCharge?: number | null, contact?: { __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string } | null, matchingGlobalAccessorial?: { __typename?: 'SkidBasedAccessorialEntity', uuid: string } | { __typename?: 'SpecialAccessorialEntity', uuid: string } | { __typename?: 'StandardAccessorialEntity', uuid: string } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string } | null, matchingCustomerAccessorials?: Array<{ __typename?: 'SkidBasedAccessorialEntity', uuid: string } | { __typename?: 'SpecialAccessorialEntity', uuid: string } | { __typename?: 'StandardAccessorialEntity', uuid: string } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string }> | null, terminal?: { __typename?: 'TerminalEntity', uuid: string, name: string, code: string } | null, fuelProfile?: { __typename?: 'FuelProfileEntity', uuid: string, name?: string | null, startDate?: any | null, expirationDate?: any | null, billingType: FuelBillingMethod, type: FuelProfileType, company: { __typename?: 'CompanyEntity', uuid: string }, contacts?: Array<{ __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string }> | null, fuelProfileDateRanges: Array<{ __typename?: 'FuelProfileDateRangeEntity', uuid: string, startDate: any, expirationDate: any, surchargeRate?: number | null, flatRateUsdCents?: number | null }> } | null, generalLedgerCode?: { __typename?: 'GeneralLedgerCodeEntity', id: string, code: string } | null } | { __typename: 'SpecialAccessorialEntity', isArchived?: boolean | null, isAuthoCodeRequired: boolean, isDefaultGlobalSpecial: boolean, specialAccessorialType?: SpecialAccessorialType | null, invoiceDisplayName?: string | null, uuid: string, quickbooksDesktopAccessorialId?: string | null, quickbooksFileMappingChargeName?: string | null, quickbooksMappingId: string, percentForSettlement?: number | null, name: string, code?: string | null, ediCode?: string | null, contact?: { __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string } | null, serviceLevel?: { __typename?: 'ServiceEntity', uuid: string, name: string, createdAt: any, updatedAt: any, timeInMinutes?: number | null, useApptInRouteOptimization: boolean, markOrdersAsSpecial: boolean, defaultAppointmentStartTime?: any | null, defaultAppointmentEndTime?: any | null, defaultStartNow: boolean, defaultInboundStopType?: StopType | null, defaultOutboundStopType?: StopType | null, defaultPickupPadding?: any | null, defaultDeliveryPadding?: any | null, defaultTotalDuration?: any | null, defaultIsLineHaul: boolean, defaultFulfillmentType?: FulfillmentType | null, isActive: boolean, isExposedToCustomers: boolean, serviceAvailabilityDates: Array<{ __typename?: 'ServiceAvailabilityDateEntity', id: string, dayCategory: SpecialDayOfWeek, enabled: boolean, start: { __typename?: 'PlainTime', hour: number, minute: number }, end: { __typename?: 'PlainTime', hour: number, minute: number } }> } | null, zones: Array<{ __typename?: 'TariffZoneEntity', uuid: string, name: string }>, chargeGroups: Array<{ __typename?: 'SpecialAccessorialChargeGroupEntity', uuid: string, dayOfWeek: SpecialDayOfWeek, startTime: any, endTime: any }>, matrixItems: Array<{ __typename?: 'SpecialAccessorialMatrixItemEntity', zoneUuid: string, chargeGroupUuid: string, uuid: string, rate: number }>, matchingGlobalAccessorial?: { __typename?: 'SkidBasedAccessorialEntity', uuid: string } | { __typename?: 'SpecialAccessorialEntity', uuid: string } | { __typename?: 'StandardAccessorialEntity', uuid: string } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string } | null, matchingCustomerAccessorials?: Array<{ __typename?: 'SkidBasedAccessorialEntity', uuid: string } | { __typename?: 'SpecialAccessorialEntity', uuid: string } | { __typename?: 'StandardAccessorialEntity', uuid: string } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string }> | null, terminal?: { __typename?: 'TerminalEntity', uuid: string, name: string, code: string } | null, fuelProfile?: { __typename?: 'FuelProfileEntity', uuid: string, name?: string | null, startDate?: any | null, expirationDate?: any | null, billingType: FuelBillingMethod, type: FuelProfileType, company: { __typename?: 'CompanyEntity', uuid: string }, contacts?: Array<{ __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string }> | null, fuelProfileDateRanges: Array<{ __typename?: 'FuelProfileDateRangeEntity', uuid: string, startDate: any, expirationDate: any, surchargeRate?: number | null, flatRateUsdCents?: number | null }> } | null, tariffZoneGroup?: { __typename?: 'TariffZoneGroupEntity', id: string } | null, generalLedgerCode?: { __typename?: 'GeneralLedgerCodeEntity', id: string, code: string } | null } | { __typename: 'StandardAccessorialEntity', isArchived?: boolean | null, isAuthoCodeRequired: boolean, isDefaultGlobalSpecial: boolean, invoiceDisplayName?: string | null, quickbooksDesktopAccessorialId?: string | null, uuid: string, quickbooksFileMappingChargeName?: string | null, quickbooksMappingId: string, percentForSettlement?: number | null, name: string, code?: string | null, ediCode?: string | null, rate: number, contact?: { __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string } | null, matchingGlobalAccessorial?: { __typename?: 'SkidBasedAccessorialEntity', uuid: string } | { __typename?: 'SpecialAccessorialEntity', uuid: string } | { __typename?: 'StandardAccessorialEntity', uuid: string } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string } | null, matchingCustomerAccessorials?: Array<{ __typename?: 'SkidBasedAccessorialEntity', uuid: string } | { __typename?: 'SpecialAccessorialEntity', uuid: string } | { __typename?: 'StandardAccessorialEntity', uuid: string } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string }> | null, terminal?: { __typename?: 'TerminalEntity', uuid: string, name: string, code: string } | null, fuelProfile?: { __typename?: 'FuelProfileEntity', uuid: string, name?: string | null, startDate?: any | null, expirationDate?: any | null, billingType: FuelBillingMethod, type: FuelProfileType, company: { __typename?: 'CompanyEntity', uuid: string }, contacts?: Array<{ __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string }> | null, fuelProfileDateRanges: Array<{ __typename?: 'FuelProfileDateRangeEntity', uuid: string, startDate: any, expirationDate: any, surchargeRate?: number | null, flatRateUsdCents?: number | null }> } | null, generalLedgerCode?: { __typename?: 'GeneralLedgerCodeEntity', id: string, code: string } | null } | { __typename: 'UnitBasedAccessorialEntity', isArchived?: boolean | null, isAuthoCodeRequired: boolean, isDefaultGlobalSpecial: boolean, invoiceDisplayName?: string | null, quickbooksDesktopAccessorialId?: string | null, uuid: string, quickbooksFileMappingChargeName?: string | null, quickbooksMappingId: string, percentForSettlement?: number | null, name: string, code?: string | null, ediCode?: string | null, ratePerUnit: number, maximumCharge?: number | null, minimumCharge?: number | null, contact?: { __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string } | null, matchingGlobalAccessorial?: { __typename?: 'SkidBasedAccessorialEntity', uuid: string } | { __typename?: 'SpecialAccessorialEntity', uuid: string } | { __typename?: 'StandardAccessorialEntity', uuid: string } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string } | null, matchingCustomerAccessorials?: Array<{ __typename?: 'SkidBasedAccessorialEntity', uuid: string } | { __typename?: 'SpecialAccessorialEntity', uuid: string } | { __typename?: 'StandardAccessorialEntity', uuid: string } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string }> | null, terminal?: { __typename?: 'TerminalEntity', uuid: string, name: string, code: string } | null, fuelProfile?: { __typename?: 'FuelProfileEntity', uuid: string, name?: string | null, startDate?: any | null, expirationDate?: any | null, billingType: FuelBillingMethod, type: FuelProfileType, company: { __typename?: 'CompanyEntity', uuid: string }, contacts?: Array<{ __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string }> | null, fuelProfileDateRanges: Array<{ __typename?: 'FuelProfileDateRangeEntity', uuid: string, startDate: any, expirationDate: any, surchargeRate?: number | null, flatRateUsdCents?: number | null }> } | null, generalLedgerCode?: { __typename?: 'GeneralLedgerCodeEntity', id: string, code: string } | null } | { __typename: 'WaitTimeAccessorialEntity', isArchived?: boolean | null, isAuthoCodeRequired: boolean, isDefaultGlobalSpecial: boolean, invoiceDisplayName?: string | null, quickbooksDesktopAccessorialId?: string | null, uuid: string, quickbooksFileMappingChargeName?: string | null, quickbooksMappingId: string, percentForSettlement?: number | null, name: string, code?: string | null, ediCode?: string | null, rate: number, maximumCharge?: number | null, minimumCharge?: number | null, waitTimeChargePeriod?: number | null, waitTimeFreeMinutes?: number | null, contact?: { __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string } | null, matchingGlobalAccessorial?: { __typename?: 'SkidBasedAccessorialEntity', uuid: string } | { __typename?: 'SpecialAccessorialEntity', uuid: string } | { __typename?: 'StandardAccessorialEntity', uuid: string } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string } | null, matchingCustomerAccessorials?: Array<{ __typename?: 'SkidBasedAccessorialEntity', uuid: string } | { __typename?: 'SpecialAccessorialEntity', uuid: string } | { __typename?: 'StandardAccessorialEntity', uuid: string } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string }> | null, terminal?: { __typename?: 'TerminalEntity', uuid: string, name: string, code: string } | null, fuelProfile?: { __typename?: 'FuelProfileEntity', uuid: string, name?: string | null, startDate?: any | null, expirationDate?: any | null, billingType: FuelBillingMethod, type: FuelProfileType, company: { __typename?: 'CompanyEntity', uuid: string }, contacts?: Array<{ __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string }> | null, fuelProfileDateRanges: Array<{ __typename?: 'FuelProfileDateRangeEntity', uuid: string, startDate: any, expirationDate: any, surchargeRate?: number | null, flatRateUsdCents?: number | null }> } | null, generalLedgerCode?: { __typename?: 'GeneralLedgerCodeEntity', id: string, code: string } | null } | { __typename: 'WeightBasedAccessorialEntity', isArchived?: boolean | null, isAuthoCodeRequired: boolean, isDefaultGlobalSpecial: boolean, invoiceDisplayName?: string | null, quickbooksDesktopAccessorialId?: string | null, uuid: string, quickbooksFileMappingChargeName?: string | null, quickbooksMappingId: string, percentForSettlement?: number | null, name: string, code?: string | null, ediCode?: string | null, ratePerHundredWeight: number, maximumCharge?: number | null, minimumCharge?: number | null, contact?: { __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string } | null, accessorialRanges?: Array<{ __typename?: 'AccessorialRangeEntity', uuid: string, lessThanOrEqualToValue: number, rateUsdCents: number }> | null, matchingGlobalAccessorial?: { __typename?: 'SkidBasedAccessorialEntity', uuid: string } | { __typename?: 'SpecialAccessorialEntity', uuid: string } | { __typename?: 'StandardAccessorialEntity', uuid: string } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string } | null, matchingCustomerAccessorials?: Array<{ __typename?: 'SkidBasedAccessorialEntity', uuid: string } | { __typename?: 'SpecialAccessorialEntity', uuid: string } | { __typename?: 'StandardAccessorialEntity', uuid: string } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string }> | null, terminal?: { __typename?: 'TerminalEntity', uuid: string, name: string, code: string } | null, fuelProfile?: { __typename?: 'FuelProfileEntity', uuid: string, name?: string | null, startDate?: any | null, expirationDate?: any | null, billingType: FuelBillingMethod, type: FuelProfileType, company: { __typename?: 'CompanyEntity', uuid: string }, contacts?: Array<{ __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string }> | null, fuelProfileDateRanges: Array<{ __typename?: 'FuelProfileDateRangeEntity', uuid: string, startDate: any, expirationDate: any, surchargeRate?: number | null, flatRateUsdCents?: number | null }> } | null, generalLedgerCode?: { __typename?: 'GeneralLedgerCodeEntity', code: string, id: string } | null } | { __typename: 'ZoneBasedAccessorialEntity', isArchived?: boolean | null, isAuthoCodeRequired: boolean, isDefaultGlobalSpecial: boolean, invoiceDisplayName?: string | null, quickbooksDesktopAccessorialId?: string | null, uuid: string, quickbooksFileMappingChargeName?: string | null, quickbooksMappingId: string, percentForSettlement?: number | null, name: string, code?: string | null, ediCode?: string | null, contact?: { __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string } | null, zones: Array<{ __typename?: 'ZoneBasedAccessorialZoneEntity', uuid: string, name: string }>, chargeGroups: Array<{ __typename?: 'ZoneBasedAccessorialChargeGroupEntity', uuid: string, name: string }>, matrixItems: Array<{ __typename?: 'ZoneBasedAccessorialMatrixItemEntity', zoneUuid: string, chargeGroupUuid: string, uuid: string, rate: number }>, matchingGlobalAccessorial?: { __typename?: 'SkidBasedAccessorialEntity', uuid: string } | { __typename?: 'SpecialAccessorialEntity', uuid: string } | { __typename?: 'StandardAccessorialEntity', uuid: string } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string } | null, matchingCustomerAccessorials?: Array<{ __typename?: 'SkidBasedAccessorialEntity', uuid: string } | { __typename?: 'SpecialAccessorialEntity', uuid: string } | { __typename?: 'StandardAccessorialEntity', uuid: string } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string }> | null, terminal?: { __typename?: 'TerminalEntity', uuid: string, name: string, code: string } | null, fuelProfile?: { __typename?: 'FuelProfileEntity', uuid: string, name?: string | null, startDate?: any | null, expirationDate?: any | null, billingType: FuelBillingMethod, type: FuelProfileType, company: { __typename?: 'CompanyEntity', uuid: string }, contacts?: Array<{ __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string }> | null, fuelProfileDateRanges: Array<{ __typename?: 'FuelProfileDateRangeEntity', uuid: string, startDate: any, expirationDate: any, surchargeRate?: number | null, flatRateUsdCents?: number | null }> } | null, generalLedgerCode?: { __typename?: 'GeneralLedgerCodeEntity', id: string, code: string } | null }>, service?: { __typename?: 'ServiceEntity', uuid: string, name: string } | null, terminal?: { __typename?: 'TerminalEntity', uuid: string, name: string, code: string } | null, tag?: { __typename?: 'TagEntity', uuid: string, value: string } | null, contact?: { __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string } | null, contactsToExcludeFromRule?: Array<{ __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string }> | null, contactsToIncludeWithRule?: Array<{ __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string }> | null } };

export type AddressWithContactFragment = { __typename?: 'AddressEntity', uuid: string, name: string, line1: string, line2?: string | null, city: string, state: string, zip: string, country: string, latitude?: number | null, longitude?: number | null, preventCoordRecompute?: boolean | null, driverInstructions?: string | null, receivingHoursStart?: any | null, receivingHoursEnd?: any | null, specialInstructions?: string | null, iataCode?: string | null, associatedContact?: { __typename?: 'ContactPersonEntity', uuid: string, firstName?: string | null, lastName?: string | null, email?: string | null, notes?: string | null, phone?: string | null, createdAt: any } | null };

export type AddressFragment = { __typename?: 'AddressEntity', uuid: string, name: string, line1: string, line2?: string | null, city: string, state: string, zip: string, country: string, latitude?: number | null, longitude?: number | null, driverInstructions?: string | null, receivingHoursStart?: any | null, receivingHoursEnd?: any | null, specialInstructions?: string | null };

export type CoordinatesForAddressQueryVariables = Exact<{
  line1?: InputMaybe<Scalars['String']['input']>;
  line2?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  zip?: InputMaybe<Scalars['String']['input']>;
}>;


export type CoordinatesForAddressQuery = { __typename?: 'Query', coordinatesForAddress: { __typename?: 'CoordinatesForAddressEntity', latitude?: number | null, longitude?: number | null } };

export type GetCityAndStateOptionsFromZipcodeFragment = { __typename?: 'CityAndStateOptionEntity', city: string, state: string };

export type GetCityAndStateOptionsFromZipcodeQueryVariables = Exact<{
  getCityAndStateFromZipcodeInput: GetCityAndStateOptionsFromZipcodeInput;
}>;


export type GetCityAndStateOptionsFromZipcodeQuery = { __typename?: 'Query', getCityAndStateOptionsFromZipcode: { __typename?: 'GetCityAndStateOptionsFromZipcodeOutput', zipcode: string, citiesAndStates: Array<{ __typename?: 'CityAndStateOptionEntity', city: string, state: string }> } };

export type GetZipcodeOptionsFromCityAndStateQueryVariables = Exact<{
  getZipcodeFromCityAndStateInput: GetZipcodeOptionsFromCityAndStateInput;
}>;


export type GetZipcodeOptionsFromCityAndStateQuery = { __typename?: 'Query', getZipcodeOptionsFromCityAndState: { __typename?: 'GetZipcodeOptionsFromCityAndStateOutput', city: string, state: string, zipcodes: Array<{ __typename?: 'ZipcodeOptionEntity', zipcode: string }> } };

export type GetZipcodeOptionsFromCityAndStateFragment = { __typename?: 'ZipcodeOptionEntity', zipcode: string };

export type AirportInfoQueryVariables = Exact<{
  uuid: Scalars['String']['input'];
}>;


export type AirportInfoQuery = { __typename?: 'Query', airportInfo: { __typename?: 'AirportInfoEntity', uuid: string, iataCode: string, terminal: string, address: { __typename?: 'AddressEntity', uuid: string, name: string, line1: string, line2?: string | null, city: string, state: string, zip: string, country: string, latitude?: number | null, longitude?: number | null, driverInstructions?: string | null, receivingHoursStart?: any | null, receivingHoursEnd?: any | null, specialInstructions?: string | null } } };

export type AppointmentConfirmationInfoQueryVariables = Exact<{
  stopUuid: Scalars['String']['input'];
}>;


export type AppointmentConfirmationInfoQuery = { __typename?: 'Query', appointmentConfirmationInfo: { __typename?: 'AppointmentConfirmationInfoOutput', appointmentDateTime: string, appointmentConfirmed: boolean, rescheduleRequested: boolean, stopType?: StopType | null } };

export type AppointmentFragment = { __typename?: 'StandardStopEntity', uuid: string, standardStopType?: StandardStopType | null, appointmentRequired: boolean, textResponses?: string | null, appointmentTime?: any | null, appointmentManuallyConfirmed?: boolean | null, formattedCallMessage?: string | null, endAppointmentTime?: any | null, shipmentTotalWeight: number, shipmentTotalVolume: number, lastAppointmentTextTime?: any | null, appointmentTextStatus?: AppointmentTextStatus | null, appointmentCallStatus?: AppointmentCallStatus | null, contactPerson?: { __typename?: 'ContactPersonEntity', uuid: string, phone?: string | null, firstName?: string | null, lastName?: string | null } | null, routeSlot?: { __typename?: 'RouteSlotEntity', route?: { __typename?: 'RouteEntity', name: string, drivers: Array<{ __typename?: 'DriverEntity', firstName: string, lastName: string }> } | null } | null, address: { __typename?: 'AddressEntity', line1: string, city: string, zip: string }, terminal?: { __typename?: 'TerminalEntity', uuid: string, name: string } | null, shipmentConsigneeAddress: { __typename?: 'AddressEntity', name: string }, leg: { __typename?: 'LegEntity', shipment: { __typename?: 'StandardShipmentEntity', uuid: string, order?: { __typename?: 'StandardOrderEntity', name: string, source: OrderSource, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', shipperBillOfLadingNumber?: string | null }, billingPartyContact: { __typename?: 'CustomerContactEntity', uuid: string, displayName: string } } | null, standardShipmentFields: { __typename?: 'StandardShipmentFieldsEntity', uuid: string, deliveryDate?: any | null, pickupOrDelivery: PickupOrDelivery, service?: { __typename?: 'ServiceEntity', uuid: string, name: string } | null } } } };

export type GetAppointmentsQueryVariables = Exact<{
  deliveryDate?: InputMaybe<Scalars['DateTime']['input']>;
  onlyMissed?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetAppointmentsQuery = { __typename?: 'Query', appointments: Array<{ __typename?: 'StandardStopEntity', uuid: string, standardStopType?: StandardStopType | null, appointmentRequired: boolean, textResponses?: string | null, appointmentTime?: any | null, appointmentManuallyConfirmed?: boolean | null, formattedCallMessage?: string | null, endAppointmentTime?: any | null, shipmentTotalWeight: number, shipmentTotalVolume: number, lastAppointmentTextTime?: any | null, appointmentTextStatus?: AppointmentTextStatus | null, appointmentCallStatus?: AppointmentCallStatus | null, contactPerson?: { __typename?: 'ContactPersonEntity', uuid: string, phone?: string | null, firstName?: string | null, lastName?: string | null } | null, routeSlot?: { __typename?: 'RouteSlotEntity', route?: { __typename?: 'RouteEntity', name: string, drivers: Array<{ __typename?: 'DriverEntity', firstName: string, lastName: string }> } | null } | null, address: { __typename?: 'AddressEntity', line1: string, city: string, zip: string }, terminal?: { __typename?: 'TerminalEntity', uuid: string, name: string } | null, shipmentConsigneeAddress: { __typename?: 'AddressEntity', name: string }, leg: { __typename?: 'LegEntity', shipment: { __typename?: 'StandardShipmentEntity', uuid: string, order?: { __typename?: 'StandardOrderEntity', name: string, source: OrderSource, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', shipperBillOfLadingNumber?: string | null }, billingPartyContact: { __typename?: 'CustomerContactEntity', uuid: string, displayName: string } } | null, standardShipmentFields: { __typename?: 'StandardShipmentFieldsEntity', uuid: string, deliveryDate?: any | null, pickupOrDelivery: PickupOrDelivery, service?: { __typename?: 'ServiceEntity', uuid: string, name: string } | null } } } }> };

export type BulkConfirmAppointmentsMutationVariables = Exact<{
  bulkConfirmAppointmentsArgs: BulkConfirmAppointmentsArgs;
}>;


export type BulkConfirmAppointmentsMutation = { __typename?: 'Mutation', bulkConfirmAppointments: number };

export type BulkChangeCallStatusMutationVariables = Exact<{
  changeCallStatusArgs: BulkChangeCallStatusArgs;
}>;


export type BulkChangeCallStatusMutation = { __typename?: 'Mutation', bulkChangeCallStatus: number };

export type CallStopsMutationVariables = Exact<{
  callStopsInput: CallStopsInput;
}>;


export type CallStopsMutation = { __typename?: 'Mutation', callStops: Array<{ __typename?: 'StandardStopEntity', uuid: string }> };

export type GetDefaultTextsQueryVariables = Exact<{
  generateDefaultAppointmentTextsArgs: GenerateDefaultAppointmentTextsArgs;
}>;


export type GetDefaultTextsQuery = { __typename?: 'Query', generateDefaultAppointmentTexts: Array<{ __typename?: 'DefaultAppointmentTextOutput', appointmentUuid: string, message?: string | null }> };

export type MakeAppointmentConfirmationDecisionMutationVariables = Exact<{
  input: MakeAppointmentConfirmationDecisionInput;
}>;


export type MakeAppointmentConfirmationDecisionMutation = { __typename?: 'Mutation', makeAppointmentConfirmationDecision: { __typename: 'AppointmentConfirmationInfoOutput', appointmentDateTime: string, appointmentConfirmed: boolean, rescheduleRequested: boolean } | { __typename: 'MutationErrorOutput', message: string } };

export type QueueAppointmentTextsMutationVariables = Exact<{
  queueAppointmentTextsArgs: QueueAppointmentTextsArgs;
}>;


export type QueueAppointmentTextsMutation = { __typename?: 'Mutation', queueAppointmentTexts: boolean };

export type RemoveStopsFromRoutesMutationVariables = Exact<{
  removeStopsFromRoutesInput: RemoveStopsFromRoutesInputType;
}>;


export type RemoveStopsFromRoutesMutation = { __typename?: 'Mutation', removeStopsFromRoutes: Array<string> };

export type AuditReportBucketFragment = { __typename?: 'AuditReportBucketEntity', startDate: any, endDate: any, contactUuid?: string | null, daysPastDue?: number | null, noAction: Array<string>, onHand: Array<string>, assigned: Array<string>, partiallyComplete: Array<string>, attempted: Array<string>, onHold: Array<string>, unfinalized: Array<string>, cancelledUnfinalized: Array<string>, billingIssues: Array<string>, cancelledFinalized: Array<string>, noChargeFinalized: Array<string>, onInvoiceUnposted: Array<string>, onInvoicePosted: Array<string> };

export type AuditReportQueryVariables = Exact<{
  args: AuditReportArgs;
}>;


export type AuditReportQuery = { __typename?: 'Query', auditReport: Array<{ __typename?: 'AuditReportBucketEntity', startDate: any, endDate: any, contactUuid?: string | null, daysPastDue?: number | null, noAction: Array<string>, onHand: Array<string>, assigned: Array<string>, partiallyComplete: Array<string>, attempted: Array<string>, onHold: Array<string>, unfinalized: Array<string>, cancelledUnfinalized: Array<string>, billingIssues: Array<string>, cancelledFinalized: Array<string>, noChargeFinalized: Array<string>, onInvoiceUnposted: Array<string>, onInvoicePosted: Array<string> }> };

export type CompanyConfigurationFragment = { __typename?: 'CompanyConfigurationEntity', uuid: string, showDriverSettlementInBilling: boolean, sameDayDispatchCellHeader: SameDayDispatchCellHeader, defaultStandardStopType: StandardStopType, defaultFuelSurchargeBillingMethod: FuelBillingMethod, defaultFuelSurcharge?: number | null, defaultFuelSettlementPercentageRate?: number | null, defaultDimFactor?: number | null, defaultRouteStartTime?: any | null, defaultRouteLoadTimeInMinutes?: number | null, defaultRouteUnloadTimeInMinutes?: number | null, defaultGenerateAppointmentDurationInMinutes: number, enableConsolidatedOrders: boolean, requirePODPhotoAndName: boolean, requirePODPhotoAndNameForPickups: boolean, requirePODPhotoForPickups: boolean, requireSigneeNameForPickups: boolean, requirePODPhotoForDeliveries: boolean, autoGroupStops: boolean, requireDriverToConfirmStopCompletedAtTime: boolean, requireSigneeNameForDeliveries: boolean, autoMatchEodDocumentsToOrders: boolean, showChargesOnCustomerPortal: boolean, invoicePdfLogoUrl?: string | null, showManuallyConfirmedByDefault?: boolean | null, showHelpersColumnInDispatch?: boolean | null, showVehicleInDailyDispatch?: boolean | null, autoApplyWaitTimeMinutes: boolean, requireReviewForEdiOrderCreation: boolean, startingInvoiceOrdinalNumber?: number | null, useDriverNumberForDispatch: boolean, useJournalNumberForInvoice: boolean, packageWarehouseLocationsEnabled: boolean, wmsEnabled: boolean, wmsStorageOrdersEnabled: boolean, wmsShortTermStorageEnabled: boolean, wmsAutoMarkOnHand: boolean, requireDriverToAcknowledgeRouteChange: boolean, defaultToAccessorial: boolean, enablePaymentMethod: boolean, driversShouldMarkFreightAsLoaded: boolean, allCapsInOrderPage: boolean, terminalsEnabled: boolean, lineHaulEnabled: boolean, logisticsSectionEnabled: boolean, fulfillmentTypeEnabled: boolean, pointToPointTariffsEnabled: boolean, orderNamingScheme: OrderNamingScheme, companyOrdinalStart?: number | null, minDigitsInCompanyOrdinalOrderName?: number | null, serviceLevelOptional: boolean, showKilogramsAndCentimeters: boolean, addOrdersToOpenInvoices: boolean, restrictEditingOrderName: boolean, notificationsEnabled: boolean, defaultInvoiceDocumentsRequired: Array<DocumentType>, invoiceNotes?: string | null, requireDimsToFinalizeCharges: boolean, orderIdentifierForCoverSheet: OrderIdentifier, getDriverLocationDataFromMobile: boolean, enableDigitalSignatureFlow: boolean, includeHyphensInInvoiceName: boolean, includeINVInInvoiceName: boolean };

export type CompanyConfigurationQueryVariables = Exact<{ [key: string]: never; }>;


export type CompanyConfigurationQuery = { __typename?: 'Query', companyConfiguration?: { __typename?: 'CompanyConfigurationEntity', uuid: string, showDriverSettlementInBilling: boolean, sameDayDispatchCellHeader: SameDayDispatchCellHeader, defaultStandardStopType: StandardStopType, defaultFuelSurchargeBillingMethod: FuelBillingMethod, defaultFuelSurcharge?: number | null, defaultFuelSettlementPercentageRate?: number | null, defaultDimFactor?: number | null, defaultRouteStartTime?: any | null, defaultRouteLoadTimeInMinutes?: number | null, defaultRouteUnloadTimeInMinutes?: number | null, defaultGenerateAppointmentDurationInMinutes: number, enableConsolidatedOrders: boolean, requirePODPhotoAndName: boolean, requirePODPhotoAndNameForPickups: boolean, requirePODPhotoForPickups: boolean, requireSigneeNameForPickups: boolean, requirePODPhotoForDeliveries: boolean, autoGroupStops: boolean, requireDriverToConfirmStopCompletedAtTime: boolean, requireSigneeNameForDeliveries: boolean, autoMatchEodDocumentsToOrders: boolean, showChargesOnCustomerPortal: boolean, invoicePdfLogoUrl?: string | null, showManuallyConfirmedByDefault?: boolean | null, showHelpersColumnInDispatch?: boolean | null, showVehicleInDailyDispatch?: boolean | null, autoApplyWaitTimeMinutes: boolean, requireReviewForEdiOrderCreation: boolean, startingInvoiceOrdinalNumber?: number | null, useDriverNumberForDispatch: boolean, useJournalNumberForInvoice: boolean, packageWarehouseLocationsEnabled: boolean, wmsEnabled: boolean, wmsStorageOrdersEnabled: boolean, wmsShortTermStorageEnabled: boolean, wmsAutoMarkOnHand: boolean, requireDriverToAcknowledgeRouteChange: boolean, defaultToAccessorial: boolean, enablePaymentMethod: boolean, driversShouldMarkFreightAsLoaded: boolean, allCapsInOrderPage: boolean, terminalsEnabled: boolean, lineHaulEnabled: boolean, logisticsSectionEnabled: boolean, fulfillmentTypeEnabled: boolean, pointToPointTariffsEnabled: boolean, orderNamingScheme: OrderNamingScheme, companyOrdinalStart?: number | null, minDigitsInCompanyOrdinalOrderName?: number | null, serviceLevelOptional: boolean, showKilogramsAndCentimeters: boolean, addOrdersToOpenInvoices: boolean, restrictEditingOrderName: boolean, notificationsEnabled: boolean, defaultInvoiceDocumentsRequired: Array<DocumentType>, invoiceNotes?: string | null, requireDimsToFinalizeCharges: boolean, orderIdentifierForCoverSheet: OrderIdentifier, getDriverLocationDataFromMobile: boolean, enableDigitalSignatureFlow: boolean, includeHyphensInInvoiceName: boolean, includeINVInInvoiceName: boolean } | null };

export type AllContactPersonFieldsFragment = { __typename?: 'ContactPersonEntity', email?: string | null, firstName?: string | null, lastName?: string | null, phone?: string | null, uuid: string };

export type ContactPersonFragment = { __typename?: 'ContactPersonEntity', uuid: string, firstName?: string | null, lastName?: string | null, email?: string | null, notes?: string | null, phone?: string | null, createdAt: any };

export type ContactPersonsQueryVariables = Exact<{ [key: string]: never; }>;


export type ContactPersonsQuery = { __typename?: 'Query', contactPersons: Array<{ __typename?: 'ContactPersonEntity', uuid: string, firstName?: string | null, lastName?: string | null, email?: string | null, notes?: string | null, phone?: string | null, createdAt: any }> };

export type ArchiveContactStationMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type ArchiveContactStationMutation = { __typename?: 'Mutation', archiveContactStation: { __typename: 'ContactStationUpdateSuccessOutput', contactStation: { __typename?: 'ContactStationEntity', id: string, isArchived: boolean } } | { __typename: 'MutationErrorOutput', message: string } };

export type ArchivePersonMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type ArchivePersonMutation = { __typename?: 'Mutation', archivePerson: { __typename?: 'UpdatePersonOutput', person: { __typename?: 'PersonEntity', id: string, status: PersonStatus } } };

export type CreateContactCommentMutationVariables = Exact<{
  createContactCommentInput: CreateContactCommentInput;
}>;


export type CreateContactCommentMutation = { __typename?: 'Mutation', createContactComment: { __typename?: 'ContactCommentEntity', uuid: string } };

export type DeleteContactCommentMutationVariables = Exact<{
  deleteContactCommentInput: DeleteContactCommentInput;
}>;


export type DeleteContactCommentMutation = { __typename?: 'Mutation', deleteContactComment: { __typename?: 'DeleteContactCommentSuccessOutput', success: boolean } | { __typename?: 'MutationErrorOutput', message: string } };

export type UpdateContactCommentMutationVariables = Exact<{
  updateContactCommentInput: UpdateContactCommentInput;
}>;


export type UpdateContactCommentMutation = { __typename?: 'Mutation', updateContactComment: { __typename?: 'MutationErrorOutput', message: string } | { __typename?: 'UpdateContactCommentSuccessOutput', success: boolean } };

export type ContactCommunicationConfigFragment = { __typename?: 'ContactCommunicationConfigEntity', uuid: string, active: boolean, type: ContactCommunicationType };

export type ContactCommunicationConfigsQueryVariables = Exact<{
  contactUuid: Scalars['String']['input'];
}>;


export type ContactCommunicationConfigsQuery = { __typename?: 'Query', contactCommunicationConfigs?: Array<{ __typename?: 'ContactCommunicationConfigEntity', uuid: string, active: boolean, type: ContactCommunicationType }> | null };

export type ContactDefaultSurchargeQueryVariables = Exact<{
  uuid: Scalars['String']['input'];
}>;


export type ContactDefaultSurchargeQuery = { __typename?: 'Query', contact: { __typename?: 'CustomerContactEntity', defaultFuelSurcharge?: number | null, uuid: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string } };

export type ContactEmailsQueryVariables = Exact<{
  contactUuid: Scalars['String']['input'];
}>;


export type ContactEmailsQuery = { __typename?: 'Query', contactEmails?: Array<{ __typename?: 'ContactEmailEntity', uuid: string, email: string, type: ContactEmailType }> | null };

type ContactForQuickbooks_CustomerContactEntity_Fragment = { __typename?: 'CustomerContactEntity', uuid: string, displayName: string, freightChargeQuickbooksMappingId?: string | null, fuelChargeQuickbooksMappingId?: string | null, miscCustomChargeQuickbooksMappingId?: string | null, quickbooksMappingId?: string | null };

type ContactForQuickbooks_ThirdPartyContactEntity_Fragment = { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string, freightChargeQuickbooksMappingId?: string | null, fuelChargeQuickbooksMappingId?: string | null, miscCustomChargeQuickbooksMappingId?: string | null, quickbooksMappingId?: string | null };

export type ContactForQuickbooksFragment = ContactForQuickbooks_CustomerContactEntity_Fragment | ContactForQuickbooks_ThirdPartyContactEntity_Fragment;

export type ContactIsOverCreditLimitByOrderUuidQueryVariables = Exact<{
  uuid: Scalars['String']['input'];
}>;


export type ContactIsOverCreditLimitByOrderUuidQuery = { __typename?: 'Query', order?: { __typename?: 'StandardOrderEntity', standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', shipperBillOfLadingNumber?: string | null }, contact: { __typename?: 'CustomerContactEntity', isOverCreditLimit: boolean } | { __typename?: 'ThirdPartyContactEntity', isOverCreditLimit: boolean } } | null };

export type ContactIsOverCreditLimitQueryVariables = Exact<{
  uuid: Scalars['String']['input'];
}>;


export type ContactIsOverCreditLimitQuery = { __typename?: 'Query', contact: { __typename?: 'CustomerContactEntity', isOverCreditLimit: boolean } | { __typename?: 'ThirdPartyContactEntity', isOverCreditLimit: boolean } };

export type ContactLogosQueryVariables = Exact<{
  contactUuid: Scalars['String']['input'];
}>;


export type ContactLogosQuery = { __typename?: 'Query', contact: { __typename?: 'CustomerContactEntity', uuid: string, logo?: { __typename?: 'DocumentEntity', preSignedGetUrl: string } | null, logoType?: { __typename?: 'DocumentEntity', preSignedGetUrl: string } | null } | { __typename?: 'ThirdPartyContactEntity', uuid: string, logo?: { __typename?: 'DocumentEntity', preSignedGetUrl: string } | null, logoType?: { __typename?: 'DocumentEntity', preSignedGetUrl: string } | null } };

export type ContactQueryForBluebirdQueryVariables = Exact<{
  uuid: Scalars['String']['input'];
}>;


export type ContactQueryForBluebirdQuery = { __typename?: 'Query', contact: { __typename?: 'CustomerContactEntity', uuid: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string } };

export type ContactServicesQueryVariables = Exact<{
  uuid: Scalars['String']['input'];
}>;


export type ContactServicesQuery = { __typename?: 'Query', contact: { __typename?: 'CustomerContactEntity', uuid: string, services: Array<{ __typename?: 'ServiceEntity', uuid: string, name: string }>, defaultService?: { __typename?: 'ServiceEntity', uuid: string, name: string } | null } | { __typename?: 'ThirdPartyContactEntity', uuid: string, services: Array<{ __typename?: 'ServiceEntity', uuid: string, name: string }>, defaultService?: { __typename?: 'ServiceEntity', uuid: string, name: string } | null } };

export type ContactStationsQueryVariables = Exact<{
  contactUuid: Scalars['String']['input'];
}>;


export type ContactStationsQuery = { __typename?: 'Query', contactStations: Array<{ __typename?: 'ContactStationEntity', id: string, name: string, isArchived: boolean, defaultPerson?: { __typename?: 'PersonEntity', id: string, firstName: string, lastName: string, phone?: string | null, email?: string | null } | null }> };

export type ContactQueryVariables = Exact<{
  uuid: Scalars['String']['input'];
}>;


export type ContactQuery = { __typename?: 'Query', contact: { __typename?: 'CustomerContactEntity', defaultFuelSurcharge?: number | null, defaultUseTariff?: boolean | null, pickupDiscountRate?: any | null, deliveryDiscountRate?: any | null, transferDiscountRate?: any | null, lineHaulDiscountRate?: any | null, defaultDimFactor?: number | null, billingContactEmail?: string | null, defaultInvoiceType: InvoiceType, defaultInvoiceTransmissionMethod: InvoiceTransmissionMethod, defaultInvoiceDownloadDocuments: Array<DocumentType>, defaultInvoiceDocumentsRequired: Array<DocumentType>, defaultInvoiceEmailSubject?: string | null, identifier?: string | null, numberOfOrdersPerInvoice?: number | null, invoiceTimePeriodSplit?: TimePeriod | null, creditHoldLimitInCents?: number | null, enableCreditHold?: boolean | null, maxDaysOutstanding?: number | null, isPrepaidOnly: boolean, enableCustomerPortalOrderEntry: boolean, useCustomPackageSpecs: boolean, showEdiReferenceNumbersOnOrderPage: boolean, useCustomVehicleTypes: boolean, uuid: string, displayName: string, ediApplicationId?: string | null, ediContactCode?: string | null, isActive: boolean, isaId?: string | null, contactReferenceNumber?: string | null, shortCode?: string | null, stediPartnerId?: string | null, isOverCreditLimit: boolean, quickbooksDesktopContactId?: string | null, quickbooksMappingId?: string | null, fuelChargeQuickbooksMappingId?: string | null, freightChargeQuickbooksMappingId?: string | null, miscCustomChargeQuickbooksMappingId?: string | null, type: ContactType, billingCycle?: BillingCycleType | null, billingCycleDuration: BillingCycleDuration, billingPeriod?: number | null, requireDriverToCheckOffPackagesAtStop: boolean, invoiceNotes?: string | null, defaultAddress?: { __typename?: 'AddressEntity', uuid: string, name: string, line1: string, line2?: string | null, city: string, state: string, zip: string, country: string, latitude?: number | null, longitude?: number | null, driverInstructions?: string | null, receivingHoursStart?: any | null, receivingHoursEnd?: any | null, specialInstructions?: string | null } | null, defaultContactPerson?: { __typename?: 'ContactPersonEntity', uuid: string, firstName?: string | null, lastName?: string | null, email?: string | null, notes?: string | null, phone?: string | null, createdAt: any } | null, defaultInvoiceTerms?: { __typename?: 'InvoiceTermEntity', uuid: string, terms: string } | null, packageSpecs: Array<{ __typename?: 'PackageSpecEntity', id: string }>, vehicleTypes: Array<{ __typename?: 'VehicleTypeEntity', uuid: string }>, defaultInboundEdiService?: { __typename?: 'ServiceEntity', uuid: string, name: string } | null, defaultOutboundEdiService?: { __typename?: 'ServiceEntity', uuid: string, name: string } | null, defaultInboundOutboundEdiService?: { __typename?: 'ServiceEntity', uuid: string, name: string } | null, defaultOrdinaryTariffChain?: { __typename?: 'TariffChainEntity', id: string, name: string } | null, defaultLineHaulTariffChain?: { __typename?: 'TariffChainEntity', id: string, name: string } | null, defaultTransferTariffChain?: { __typename?: 'TariffChainEntity', id: string, name: string } | null, defaultPointToPointTariffChain?: { __typename?: 'TariffChainEntity', id: string, name: string } | null, masterAccount?: { __typename?: 'MasterAccountEntity', uuid: string, name: string } | null, contactComments: Array<{ __typename?: 'ContactCommentEntity', uuid: string, updatedAt: any, createdAt: any, comment: string, authorName: string }>, services: Array<{ __typename?: 'ServiceEntity', uuid: string, name: string, createdAt: any, updatedAt: any, timeInMinutes?: number | null, useApptInRouteOptimization: boolean, markOrdersAsSpecial: boolean, defaultAppointmentStartTime?: any | null, defaultAppointmentEndTime?: any | null, defaultStartNow: boolean, defaultInboundStopType?: StopType | null, defaultOutboundStopType?: StopType | null, defaultPickupPadding?: any | null, defaultDeliveryPadding?: any | null, defaultTotalDuration?: any | null, defaultIsLineHaul: boolean, defaultFulfillmentType?: FulfillmentType | null, isActive: boolean, isExposedToCustomers: boolean, serviceAvailabilityDates: Array<{ __typename?: 'ServiceAvailabilityDateEntity', id: string, dayCategory: SpecialDayOfWeek, enabled: boolean, start: { __typename?: 'PlainTime', hour: number, minute: number }, end: { __typename?: 'PlainTime', hour: number, minute: number } }> }>, invoicePdfColumns: Array<{ __typename?: 'PdfColumnEntity', uuid: string, orderColumnMapping?: OrderPdfColumnMapping | null, shipmentPDFColumnMapping?: ShipmentPdfColumnMapping | null, legPDFColumnMapping?: LegPdfColumnMapping | null, stopPDFColumnMapping?: StopPdfColumnMapping | null }>, addresses: Array<{ __typename?: 'AddressEntity', uuid: string, name: string, line1: string, line2?: string | null, city: string, state: string, zip: string, country: string, latitude?: number | null, longitude?: number | null, driverInstructions?: string | null, receivingHoursStart?: any | null, receivingHoursEnd?: any | null, specialInstructions?: string | null }>, contactPersons: Array<{ __typename?: 'ContactPersonEntity', uuid: string, firstName?: string | null, lastName?: string | null, email?: string | null, notes?: string | null, phone?: string | null, createdAt: any }>, defaultService?: { __typename?: 'ServiceEntity', uuid: string, name: string, createdAt: any, updatedAt: any, timeInMinutes?: number | null, useApptInRouteOptimization: boolean, markOrdersAsSpecial: boolean, defaultAppointmentStartTime?: any | null, defaultAppointmentEndTime?: any | null, defaultStartNow: boolean, defaultInboundStopType?: StopType | null, defaultOutboundStopType?: StopType | null, defaultPickupPadding?: any | null, defaultDeliveryPadding?: any | null, defaultTotalDuration?: any | null, defaultIsLineHaul: boolean, defaultFulfillmentType?: FulfillmentType | null, isActive: boolean, isExposedToCustomers: boolean, serviceAvailabilityDates: Array<{ __typename?: 'ServiceAvailabilityDateEntity', id: string, dayCategory: SpecialDayOfWeek, enabled: boolean, start: { __typename?: 'PlainTime', hour: number, minute: number }, end: { __typename?: 'PlainTime', hour: number, minute: number } }> } | null, businessDivision?: { __typename?: 'BusinessDivisionEntity', uuid: string, name: string } | null, referenceNumberLabels: Array<{ __typename?: 'ReferenceNumberLabelEntity', name: string }> } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string, ediApplicationId?: string | null, ediContactCode?: string | null, isActive: boolean, isaId?: string | null, identifier?: string | null, contactReferenceNumber?: string | null, shortCode?: string | null, stediPartnerId?: string | null, isOverCreditLimit: boolean, quickbooksDesktopContactId?: string | null, quickbooksMappingId?: string | null, fuelChargeQuickbooksMappingId?: string | null, freightChargeQuickbooksMappingId?: string | null, miscCustomChargeQuickbooksMappingId?: string | null, type: ContactType, billingCycle?: BillingCycleType | null, billingCycleDuration: BillingCycleDuration, billingPeriod?: number | null, requireDriverToCheckOffPackagesAtStop: boolean, invoiceNotes?: string | null, masterAccount?: { __typename?: 'MasterAccountEntity', uuid: string, name: string } | null, contactComments: Array<{ __typename?: 'ContactCommentEntity', uuid: string, updatedAt: any, createdAt: any, comment: string, authorName: string }>, services: Array<{ __typename?: 'ServiceEntity', uuid: string, name: string, createdAt: any, updatedAt: any, timeInMinutes?: number | null, useApptInRouteOptimization: boolean, markOrdersAsSpecial: boolean, defaultAppointmentStartTime?: any | null, defaultAppointmentEndTime?: any | null, defaultStartNow: boolean, defaultInboundStopType?: StopType | null, defaultOutboundStopType?: StopType | null, defaultPickupPadding?: any | null, defaultDeliveryPadding?: any | null, defaultTotalDuration?: any | null, defaultIsLineHaul: boolean, defaultFulfillmentType?: FulfillmentType | null, isActive: boolean, isExposedToCustomers: boolean, serviceAvailabilityDates: Array<{ __typename?: 'ServiceAvailabilityDateEntity', id: string, dayCategory: SpecialDayOfWeek, enabled: boolean, start: { __typename?: 'PlainTime', hour: number, minute: number }, end: { __typename?: 'PlainTime', hour: number, minute: number } }> }>, invoicePdfColumns: Array<{ __typename?: 'PdfColumnEntity', uuid: string, orderColumnMapping?: OrderPdfColumnMapping | null, shipmentPDFColumnMapping?: ShipmentPdfColumnMapping | null, legPDFColumnMapping?: LegPdfColumnMapping | null, stopPDFColumnMapping?: StopPdfColumnMapping | null }>, addresses: Array<{ __typename?: 'AddressEntity', uuid: string, name: string, line1: string, line2?: string | null, city: string, state: string, zip: string, country: string, latitude?: number | null, longitude?: number | null, driverInstructions?: string | null, receivingHoursStart?: any | null, receivingHoursEnd?: any | null, specialInstructions?: string | null }>, contactPersons: Array<{ __typename?: 'ContactPersonEntity', uuid: string, firstName?: string | null, lastName?: string | null, email?: string | null, notes?: string | null, phone?: string | null, createdAt: any }>, defaultAddress?: { __typename?: 'AddressEntity', uuid: string, name: string, line1: string, line2?: string | null, city: string, state: string, zip: string, country: string, latitude?: number | null, longitude?: number | null, driverInstructions?: string | null, receivingHoursStart?: any | null, receivingHoursEnd?: any | null, specialInstructions?: string | null } | null, defaultContactPerson?: { __typename?: 'ContactPersonEntity', uuid: string, firstName?: string | null, lastName?: string | null, email?: string | null, notes?: string | null, phone?: string | null, createdAt: any } | null, defaultService?: { __typename?: 'ServiceEntity', uuid: string, name: string, createdAt: any, updatedAt: any, timeInMinutes?: number | null, useApptInRouteOptimization: boolean, markOrdersAsSpecial: boolean, defaultAppointmentStartTime?: any | null, defaultAppointmentEndTime?: any | null, defaultStartNow: boolean, defaultInboundStopType?: StopType | null, defaultOutboundStopType?: StopType | null, defaultPickupPadding?: any | null, defaultDeliveryPadding?: any | null, defaultTotalDuration?: any | null, defaultIsLineHaul: boolean, defaultFulfillmentType?: FulfillmentType | null, isActive: boolean, isExposedToCustomers: boolean, serviceAvailabilityDates: Array<{ __typename?: 'ServiceAvailabilityDateEntity', id: string, dayCategory: SpecialDayOfWeek, enabled: boolean, start: { __typename?: 'PlainTime', hour: number, minute: number }, end: { __typename?: 'PlainTime', hour: number, minute: number } }> } | null, businessDivision?: { __typename?: 'BusinessDivisionEntity', uuid: string, name: string } | null, referenceNumberLabels: Array<{ __typename?: 'ReferenceNumberLabelEntity', name: string }> } };

export type ContactsForInvoicingQueryVariables = Exact<{
  invoiceUuids: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type ContactsForInvoicingQuery = { __typename?: 'Query', contacts: Array<{ __typename: 'CustomerContactEntity', numberOfOrdersPerInvoice?: number | null, invoiceTimePeriodSplit?: TimePeriod | null, defaultInvoiceType: InvoiceType, defaultInvoiceTransmissionMethod: InvoiceTransmissionMethod, defaultInvoiceDocumentsRequired: Array<DocumentType>, defaultInvoiceDownloadDocuments: Array<DocumentType>, enableCreditHold?: boolean | null, defaultInvoiceEmailSubject?: string | null, uuid: string, displayName: string, stediPartnerId?: string | null, contactReferenceNumber?: string | null } | { __typename: 'ThirdPartyContactEntity', uuid: string, displayName: string, stediPartnerId?: string | null, contactReferenceNumber?: string | null }> };

export type ContactsForQuickbooksQueryVariables = Exact<{ [key: string]: never; }>;


export type ContactsForQuickbooksQuery = { __typename?: 'Query', contacts: Array<{ __typename?: 'CustomerContactEntity', uuid: string, displayName: string, freightChargeQuickbooksMappingId?: string | null, fuelChargeQuickbooksMappingId?: string | null, miscCustomChargeQuickbooksMappingId?: string | null, quickbooksMappingId?: string | null } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string, freightChargeQuickbooksMappingId?: string | null, fuelChargeQuickbooksMappingId?: string | null, miscCustomChargeQuickbooksMappingId?: string | null, quickbooksMappingId?: string | null }> };

export type ContactsPageListingQueryVariables = Exact<{ [key: string]: never; }>;


export type ContactsPageListingQuery = { __typename?: 'Query', contacts: Array<{ __typename?: 'CustomerContactEntity', uuid: string, contactReferenceNumber?: string | null, displayName: string, isActive: boolean, type: ContactType } | { __typename?: 'ThirdPartyContactEntity', uuid: string, contactReferenceNumber?: string | null, displayName: string, isActive: boolean, type: ContactType }> };

export type ContactsReportQueryVariables = Exact<{ [key: string]: never; }>;


export type ContactsReportQuery = { __typename?: 'Query', contactsReport: Array<{ __typename?: 'ContactForContactReport', name: string, email?: string | null, shortcode?: string | null, active: boolean, addressName?: string | null, addressLine1?: string | null, addressLine2?: string | null, city?: string | null, state?: string | null, zipcode?: string | null, businessDivision?: string | null, type: string, referenceNumber?: string | null, numberOfOrdersPerInvoice?: number | null, invoiceTimePeriodSplit?: string | null, enableCreditHold: boolean, creditLimit?: number | null, billingCycle?: string | null, defaultInvoiceTransmissionMethod?: string | null, defaultInvoiceType: string }> };

export type ContactsSimpleQueryVariables = Exact<{
  excludeNonActive?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type ContactsSimpleQuery = { __typename?: 'Query', contacts: Array<{ __typename?: 'CustomerContactEntity', uuid: string, displayName: string, contactReferenceNumber?: string | null, isOverCreditLimit: boolean, masterAccount?: { __typename?: 'MasterAccountEntity', uuid: string } | null } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string, contactReferenceNumber?: string | null, isOverCreditLimit: boolean, masterAccount?: { __typename?: 'MasterAccountEntity', uuid: string } | null }> };

export type ContactsQueryVariables = Exact<{ [key: string]: never; }>;


export type ContactsQuery = { __typename?: 'Query', contacts: Array<{ __typename?: 'CustomerContactEntity', defaultFuelSurcharge?: number | null, defaultUseTariff?: boolean | null, pickupDiscountRate?: any | null, deliveryDiscountRate?: any | null, transferDiscountRate?: any | null, lineHaulDiscountRate?: any | null, defaultDimFactor?: number | null, billingContactEmail?: string | null, defaultInvoiceType: InvoiceType, defaultInvoiceTransmissionMethod: InvoiceTransmissionMethod, defaultInvoiceDownloadDocuments: Array<DocumentType>, defaultInvoiceDocumentsRequired: Array<DocumentType>, defaultInvoiceEmailSubject?: string | null, identifier?: string | null, numberOfOrdersPerInvoice?: number | null, invoiceTimePeriodSplit?: TimePeriod | null, creditHoldLimitInCents?: number | null, enableCreditHold?: boolean | null, maxDaysOutstanding?: number | null, isPrepaidOnly: boolean, enableCustomerPortalOrderEntry: boolean, useCustomPackageSpecs: boolean, showEdiReferenceNumbersOnOrderPage: boolean, useCustomVehicleTypes: boolean, uuid: string, displayName: string, ediApplicationId?: string | null, ediContactCode?: string | null, isActive: boolean, isaId?: string | null, contactReferenceNumber?: string | null, shortCode?: string | null, stediPartnerId?: string | null, isOverCreditLimit: boolean, quickbooksDesktopContactId?: string | null, quickbooksMappingId?: string | null, fuelChargeQuickbooksMappingId?: string | null, freightChargeQuickbooksMappingId?: string | null, miscCustomChargeQuickbooksMappingId?: string | null, type: ContactType, billingCycle?: BillingCycleType | null, billingCycleDuration: BillingCycleDuration, billingPeriod?: number | null, requireDriverToCheckOffPackagesAtStop: boolean, invoiceNotes?: string | null, defaultAddress?: { __typename?: 'AddressEntity', uuid: string, name: string, line1: string, line2?: string | null, city: string, state: string, zip: string, country: string, latitude?: number | null, longitude?: number | null, driverInstructions?: string | null, receivingHoursStart?: any | null, receivingHoursEnd?: any | null, specialInstructions?: string | null } | null, defaultContactPerson?: { __typename?: 'ContactPersonEntity', uuid: string, firstName?: string | null, lastName?: string | null, email?: string | null, notes?: string | null, phone?: string | null, createdAt: any } | null, defaultInvoiceTerms?: { __typename?: 'InvoiceTermEntity', uuid: string, terms: string } | null, packageSpecs: Array<{ __typename?: 'PackageSpecEntity', id: string }>, vehicleTypes: Array<{ __typename?: 'VehicleTypeEntity', uuid: string }>, defaultInboundEdiService?: { __typename?: 'ServiceEntity', uuid: string, name: string } | null, defaultOutboundEdiService?: { __typename?: 'ServiceEntity', uuid: string, name: string } | null, defaultInboundOutboundEdiService?: { __typename?: 'ServiceEntity', uuid: string, name: string } | null, defaultOrdinaryTariffChain?: { __typename?: 'TariffChainEntity', id: string, name: string } | null, defaultLineHaulTariffChain?: { __typename?: 'TariffChainEntity', id: string, name: string } | null, defaultTransferTariffChain?: { __typename?: 'TariffChainEntity', id: string, name: string } | null, defaultPointToPointTariffChain?: { __typename?: 'TariffChainEntity', id: string, name: string } | null, masterAccount?: { __typename?: 'MasterAccountEntity', uuid: string, name: string } | null, contactComments: Array<{ __typename?: 'ContactCommentEntity', uuid: string, updatedAt: any, createdAt: any, comment: string, authorName: string }>, services: Array<{ __typename?: 'ServiceEntity', uuid: string, name: string, createdAt: any, updatedAt: any, timeInMinutes?: number | null, useApptInRouteOptimization: boolean, markOrdersAsSpecial: boolean, defaultAppointmentStartTime?: any | null, defaultAppointmentEndTime?: any | null, defaultStartNow: boolean, defaultInboundStopType?: StopType | null, defaultOutboundStopType?: StopType | null, defaultPickupPadding?: any | null, defaultDeliveryPadding?: any | null, defaultTotalDuration?: any | null, defaultIsLineHaul: boolean, defaultFulfillmentType?: FulfillmentType | null, isActive: boolean, isExposedToCustomers: boolean, serviceAvailabilityDates: Array<{ __typename?: 'ServiceAvailabilityDateEntity', id: string, dayCategory: SpecialDayOfWeek, enabled: boolean, start: { __typename?: 'PlainTime', hour: number, minute: number }, end: { __typename?: 'PlainTime', hour: number, minute: number } }> }>, invoicePdfColumns: Array<{ __typename?: 'PdfColumnEntity', uuid: string, orderColumnMapping?: OrderPdfColumnMapping | null, shipmentPDFColumnMapping?: ShipmentPdfColumnMapping | null, legPDFColumnMapping?: LegPdfColumnMapping | null, stopPDFColumnMapping?: StopPdfColumnMapping | null }>, addresses: Array<{ __typename?: 'AddressEntity', uuid: string, name: string, line1: string, line2?: string | null, city: string, state: string, zip: string, country: string, latitude?: number | null, longitude?: number | null, driverInstructions?: string | null, receivingHoursStart?: any | null, receivingHoursEnd?: any | null, specialInstructions?: string | null }>, contactPersons: Array<{ __typename?: 'ContactPersonEntity', uuid: string, firstName?: string | null, lastName?: string | null, email?: string | null, notes?: string | null, phone?: string | null, createdAt: any }>, defaultService?: { __typename?: 'ServiceEntity', uuid: string, name: string, createdAt: any, updatedAt: any, timeInMinutes?: number | null, useApptInRouteOptimization: boolean, markOrdersAsSpecial: boolean, defaultAppointmentStartTime?: any | null, defaultAppointmentEndTime?: any | null, defaultStartNow: boolean, defaultInboundStopType?: StopType | null, defaultOutboundStopType?: StopType | null, defaultPickupPadding?: any | null, defaultDeliveryPadding?: any | null, defaultTotalDuration?: any | null, defaultIsLineHaul: boolean, defaultFulfillmentType?: FulfillmentType | null, isActive: boolean, isExposedToCustomers: boolean, serviceAvailabilityDates: Array<{ __typename?: 'ServiceAvailabilityDateEntity', id: string, dayCategory: SpecialDayOfWeek, enabled: boolean, start: { __typename?: 'PlainTime', hour: number, minute: number }, end: { __typename?: 'PlainTime', hour: number, minute: number } }> } | null, businessDivision?: { __typename?: 'BusinessDivisionEntity', uuid: string, name: string } | null, referenceNumberLabels: Array<{ __typename?: 'ReferenceNumberLabelEntity', name: string }> } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string, ediApplicationId?: string | null, ediContactCode?: string | null, isActive: boolean, isaId?: string | null, identifier?: string | null, contactReferenceNumber?: string | null, shortCode?: string | null, stediPartnerId?: string | null, isOverCreditLimit: boolean, quickbooksDesktopContactId?: string | null, quickbooksMappingId?: string | null, fuelChargeQuickbooksMappingId?: string | null, freightChargeQuickbooksMappingId?: string | null, miscCustomChargeQuickbooksMappingId?: string | null, type: ContactType, billingCycle?: BillingCycleType | null, billingCycleDuration: BillingCycleDuration, billingPeriod?: number | null, requireDriverToCheckOffPackagesAtStop: boolean, invoiceNotes?: string | null, masterAccount?: { __typename?: 'MasterAccountEntity', uuid: string, name: string } | null, contactComments: Array<{ __typename?: 'ContactCommentEntity', uuid: string, updatedAt: any, createdAt: any, comment: string, authorName: string }>, services: Array<{ __typename?: 'ServiceEntity', uuid: string, name: string, createdAt: any, updatedAt: any, timeInMinutes?: number | null, useApptInRouteOptimization: boolean, markOrdersAsSpecial: boolean, defaultAppointmentStartTime?: any | null, defaultAppointmentEndTime?: any | null, defaultStartNow: boolean, defaultInboundStopType?: StopType | null, defaultOutboundStopType?: StopType | null, defaultPickupPadding?: any | null, defaultDeliveryPadding?: any | null, defaultTotalDuration?: any | null, defaultIsLineHaul: boolean, defaultFulfillmentType?: FulfillmentType | null, isActive: boolean, isExposedToCustomers: boolean, serviceAvailabilityDates: Array<{ __typename?: 'ServiceAvailabilityDateEntity', id: string, dayCategory: SpecialDayOfWeek, enabled: boolean, start: { __typename?: 'PlainTime', hour: number, minute: number }, end: { __typename?: 'PlainTime', hour: number, minute: number } }> }>, invoicePdfColumns: Array<{ __typename?: 'PdfColumnEntity', uuid: string, orderColumnMapping?: OrderPdfColumnMapping | null, shipmentPDFColumnMapping?: ShipmentPdfColumnMapping | null, legPDFColumnMapping?: LegPdfColumnMapping | null, stopPDFColumnMapping?: StopPdfColumnMapping | null }>, addresses: Array<{ __typename?: 'AddressEntity', uuid: string, name: string, line1: string, line2?: string | null, city: string, state: string, zip: string, country: string, latitude?: number | null, longitude?: number | null, driverInstructions?: string | null, receivingHoursStart?: any | null, receivingHoursEnd?: any | null, specialInstructions?: string | null }>, contactPersons: Array<{ __typename?: 'ContactPersonEntity', uuid: string, firstName?: string | null, lastName?: string | null, email?: string | null, notes?: string | null, phone?: string | null, createdAt: any }>, defaultAddress?: { __typename?: 'AddressEntity', uuid: string, name: string, line1: string, line2?: string | null, city: string, state: string, zip: string, country: string, latitude?: number | null, longitude?: number | null, driverInstructions?: string | null, receivingHoursStart?: any | null, receivingHoursEnd?: any | null, specialInstructions?: string | null } | null, defaultContactPerson?: { __typename?: 'ContactPersonEntity', uuid: string, firstName?: string | null, lastName?: string | null, email?: string | null, notes?: string | null, phone?: string | null, createdAt: any } | null, defaultService?: { __typename?: 'ServiceEntity', uuid: string, name: string, createdAt: any, updatedAt: any, timeInMinutes?: number | null, useApptInRouteOptimization: boolean, markOrdersAsSpecial: boolean, defaultAppointmentStartTime?: any | null, defaultAppointmentEndTime?: any | null, defaultStartNow: boolean, defaultInboundStopType?: StopType | null, defaultOutboundStopType?: StopType | null, defaultPickupPadding?: any | null, defaultDeliveryPadding?: any | null, defaultTotalDuration?: any | null, defaultIsLineHaul: boolean, defaultFulfillmentType?: FulfillmentType | null, isActive: boolean, isExposedToCustomers: boolean, serviceAvailabilityDates: Array<{ __typename?: 'ServiceAvailabilityDateEntity', id: string, dayCategory: SpecialDayOfWeek, enabled: boolean, start: { __typename?: 'PlainTime', hour: number, minute: number }, end: { __typename?: 'PlainTime', hour: number, minute: number } }> } | null, businessDivision?: { __typename?: 'BusinessDivisionEntity', uuid: string, name: string } | null, referenceNumberLabels: Array<{ __typename?: 'ReferenceNumberLabelEntity', name: string }> }> };

export type CreateAddressMutationVariables = Exact<{
  input: CreateAddressInput;
}>;


export type CreateAddressMutation = { __typename?: 'Mutation', createAddress: { __typename?: 'AddressEntity', uuid: string } };

export type CreateContactEmailMutationVariables = Exact<{
  createContactEmailInput: CreateContactEmailInput;
}>;


export type CreateContactEmailMutation = { __typename?: 'Mutation', createContactEmail?: { __typename?: 'ContactEmailEntity', uuid: string } | null };

export type CreateContactPersonMutationVariables = Exact<{
  input: CreateContactPersonInput;
}>;


export type CreateContactPersonMutation = { __typename?: 'Mutation', createContactPerson: { __typename?: 'ContactPersonEntity', uuid: string } };

export type CreateContactStationMutationVariables = Exact<{
  input: ContactStationCreateInput;
}>;


export type CreateContactStationMutation = { __typename?: 'Mutation', createContactStation: { __typename: 'ContactStationCreateSuccessOutput', contactStation: { __typename?: 'ContactStationEntity', id: string } } | { __typename: 'MutationErrorOutput', message: string } };

export type CreateCustomerContactMutationVariables = Exact<{
  input: CreateCustomerContactInput;
}>;


export type CreateCustomerContactMutation = { __typename?: 'Mutation', createCustomerContact: { __typename?: 'CustomerContactEntity', uuid: string } };

export type CreatePersonMutationVariables = Exact<{
  input: CreatePersonInput;
}>;


export type CreatePersonMutation = { __typename?: 'Mutation', createPerson: { __typename?: 'CreatePersonOutput', person: { __typename?: 'PersonEntity', id: string } } };

export type FindServicesForCustomerConfigurationQueryVariables = Exact<{
  findServicesForCustomerConfigurationInput: FindServicesForCustomerConfigurationInput;
}>;


export type FindServicesForCustomerConfigurationQuery = { __typename?: 'Query', findServicesForCustomerConfiguration: { __typename: 'FindServicesForCustomerConfigurationSuccessOutput', services: Array<{ __typename?: 'ServiceEntity', uuid: string, name: string, isActive: boolean }> } | { __typename: 'QueryErrorOutput', message: string } };

export type DeleteContactEmailMutationVariables = Exact<{
  deleteContactEmailInput: DeleteContactEmailInput;
}>;


export type DeleteContactEmailMutation = { __typename?: 'Mutation', deleteContactEmail: { __typename?: 'ContactEmailEntity', uuid: string } };

export type InvoiceTermsQueryVariables = Exact<{ [key: string]: never; }>;


export type InvoiceTermsQuery = { __typename?: 'Query', invoiceTerms: Array<{ __typename?: 'InvoiceTermEntity', uuid: string, terms: string }> };

export type OrderEventNotificationSubscriptionsQueryVariables = Exact<{
  contactUuid: Scalars['String']['input'];
}>;


export type OrderEventNotificationSubscriptionsQuery = { __typename?: 'Query', orderEventNotificationSubscriptions: Array<{ __typename?: 'OrderEventNotificationSubscriptionEntity', id: string, eventType: OrderEventNotificationType, channel: NotificationChannel, subscriberType: NotificationSubscriberType }> };

export type PaginatedContactsQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  searchText?: InputMaybe<Scalars['String']['input']>;
  sortByContactName?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type PaginatedContactsQuery = { __typename?: 'Query', paginatedContacts: { __typename?: 'ContactConnection', totalCount?: number | null, edges: Array<{ __typename?: 'ContactEdge', node: { __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string } }>, pageInfo: { __typename?: 'PageInfo', startCursor?: string | null, endCursor?: string | null, hasNextPage: boolean, hasPreviousPage: boolean } } };

export type PersonsQueryVariables = Exact<{
  contactUuid?: InputMaybe<Scalars['String']['input']>;
}>;


export type PersonsQuery = { __typename?: 'Query', persons: { __typename?: 'FindPersonsOutput', persons: Array<{ __typename?: 'PersonEntity', id: string, status: PersonStatus, firstName: string, lastName: string, phone?: string | null, email?: string | null, defaultPickupAddress?: { __typename?: 'AddressEntity', uuid: string, name: string, line1: string, line2?: string | null, city: string, state: string, zip: string, country: string, specialInstructions?: string | null } | null, defaultDeliveryAddress?: { __typename?: 'AddressEntity', uuid: string, name: string, line1: string, line2?: string | null, city: string, state: string, zip: string, country: string, specialInstructions?: string | null } | null, defaultService?: { __typename?: 'ServiceEntity', uuid: string, name: string } | null, defaultVehicleType?: { __typename?: 'VehicleTypeEntity', uuid: string, name: string } | null, defaultForContactStations?: Array<{ __typename?: 'ContactStationEntity', id: string, name: string, isArchived: boolean }> | null }> } };

export type QueryQuickbooksDesktopAccountsQueryVariables = Exact<{ [key: string]: never; }>;


export type QueryQuickbooksDesktopAccountsQuery = { __typename?: 'Query', queryQuickbooksDesktopAccounts: { __typename?: 'QuickbooksDesktopResultEntity', error?: string | null, quickbooksDesktopObjects?: Array<{ __typename?: 'QuickbooksDesktopObjectEntity', id: string, name: string }> | null } };

export type QueryQuickbooksDesktopCustomersQueryVariables = Exact<{ [key: string]: never; }>;


export type QueryQuickbooksDesktopCustomersQuery = { __typename?: 'Query', queryQuickbooksDesktopCustomers: { __typename?: 'QuickbooksDesktopResultEntity', error?: string | null, quickbooksDesktopObjects?: Array<{ __typename?: 'QuickbooksDesktopObjectEntity', id: string, name: string }> | null } };

export type RemoveAddressMutationVariables = Exact<{
  uuid: Scalars['String']['input'];
}>;


export type RemoveAddressMutation = { __typename?: 'Mutation', removeAddress: { __typename?: 'AddressEntity', uuid: string } };

export type RemoveContactPersonMutationVariables = Exact<{
  uuid: Scalars['String']['input'];
}>;


export type RemoveContactPersonMutation = { __typename?: 'Mutation', removeContactPerson: { __typename?: 'ContactPersonEntity', uuid: string } };

export type RestoreContactStationMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type RestoreContactStationMutation = { __typename?: 'Mutation', restoreContactStation: { __typename: 'ContactStationUpdateSuccessOutput', contactStation: { __typename?: 'ContactStationEntity', id: string, isArchived: boolean } } | { __typename: 'MutationErrorOutput', message: string } };

export type RestorePersonMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type RestorePersonMutation = { __typename?: 'Mutation', restorePerson: { __typename?: 'UpdatePersonOutput', person: { __typename?: 'PersonEntity', id: string, status: PersonStatus } } };

export type ShallowContactQueryVariables = Exact<{
  uuid: Scalars['String']['input'];
}>;


export type ShallowContactQuery = { __typename?: 'Query', contact: { __typename?: 'CustomerContactEntity', defaultUseTariff?: boolean | null, defaultInvoiceTransmissionMethod: InvoiceTransmissionMethod, defaultInvoiceType: InvoiceType, defaultInvoiceDownloadDocuments: Array<DocumentType>, defaultInvoiceDocumentsRequired: Array<DocumentType>, defaultDimFactor?: number | null, defaultFuelSurcharge?: number | null, numberOfOrdersPerInvoice?: number | null, invoiceTimePeriodSplit?: TimePeriod | null, isPrepaidOnly: boolean, useCustomVehicleTypes: boolean, useCustomPackageSpecs: boolean, displayName: string, type: ContactType, isActive: boolean, shortCode?: string | null, uuid: string, contactReferenceNumber?: string | null, quickbooksMappingId?: string | null, quickbooksDesktopContactId?: string | null, quickbooksFileMappingFreightChargeName?: string | null, quickbooksFileMappingCustomerName?: string | null, quickbooksFileMappingFuelChargeName?: string | null, quickbooksFileMappingPickupChargeName?: string | null, quickbooksDesktopAccountsReceivableId?: string | null, freightChargeQuickbooksMappingId?: string | null, fuelChargeQuickbooksMappingId?: string | null, miscCustomChargeQuickbooksMappingId?: string | null, stediPartnerId?: string | null, billingCycleDuration: BillingCycleDuration, billingContactEmail?: string | null, isEfm?: boolean | null, showEdiReferenceNumbersOnOrderPage: boolean, vehicleTypes: Array<{ __typename?: 'VehicleTypeEntity', uuid: string, name: string, status: VehicleTypeStatus }>, packageSpecs: Array<{ __typename?: 'PackageSpecEntity', id: string, name: string, status: PackageSpecStatus, weight?: any | null, length?: any | null, width?: any | null, height?: any | null }>, services: Array<{ __typename?: 'ServiceEntity', uuid: string, name: string, markOrdersAsSpecial: boolean, defaultAppointmentStartTime?: any | null, defaultAppointmentEndTime?: any | null }>, defaultService?: { __typename?: 'ServiceEntity', uuid: string, name: string } | null, defaultAddress?: { __typename?: 'AddressEntity', uuid: string, line1: string, line2?: string | null, city: string, latitude?: number | null, longitude?: number | null, zip: string, state: string } | null, referenceNumberLabels: Array<{ __typename?: 'ReferenceNumberLabelEntity', name: string }>, contactStations: Array<{ __typename?: 'ContactStationEntity', id: string, name: string, isArchived: boolean, defaultPerson?: { __typename?: 'PersonEntity', id: string, firstName: string, lastName: string, phone?: string | null, email?: string | null } | null }> } | { __typename?: 'ThirdPartyContactEntity', displayName: string, type: ContactType, isActive: boolean, shortCode?: string | null, uuid: string, contactReferenceNumber?: string | null, quickbooksMappingId?: string | null, quickbooksDesktopContactId?: string | null, quickbooksFileMappingFreightChargeName?: string | null, quickbooksFileMappingCustomerName?: string | null, quickbooksFileMappingFuelChargeName?: string | null, quickbooksFileMappingPickupChargeName?: string | null, quickbooksDesktopAccountsReceivableId?: string | null, freightChargeQuickbooksMappingId?: string | null, fuelChargeQuickbooksMappingId?: string | null, miscCustomChargeQuickbooksMappingId?: string | null, stediPartnerId?: string | null, billingCycleDuration: BillingCycleDuration, billingContactEmail?: string | null, isEfm?: boolean | null, showEdiReferenceNumbersOnOrderPage: boolean, services: Array<{ __typename?: 'ServiceEntity', uuid: string, name: string, markOrdersAsSpecial: boolean, defaultAppointmentStartTime?: any | null, defaultAppointmentEndTime?: any | null }>, defaultService?: { __typename?: 'ServiceEntity', uuid: string, name: string } | null, defaultAddress?: { __typename?: 'AddressEntity', uuid: string, line1: string, line2?: string | null, city: string, latitude?: number | null, longitude?: number | null, zip: string, state: string } | null, referenceNumberLabels: Array<{ __typename?: 'ReferenceNumberLabelEntity', name: string }>, contactStations: Array<{ __typename?: 'ContactStationEntity', id: string, name: string, isArchived: boolean, defaultPerson?: { __typename?: 'PersonEntity', id: string, firstName: string, lastName: string, phone?: string | null, email?: string | null } | null }> } };

export type ShallowContactsByUuidsQueryVariables = Exact<{
  uuids: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type ShallowContactsByUuidsQuery = { __typename?: 'Query', contactsByUuids: Array<{ __typename?: 'CustomerContactEntity', defaultUseTariff?: boolean | null, defaultInvoiceTransmissionMethod: InvoiceTransmissionMethod, defaultInvoiceType: InvoiceType, defaultInvoiceDownloadDocuments: Array<DocumentType>, defaultInvoiceDocumentsRequired: Array<DocumentType>, defaultDimFactor?: number | null, defaultFuelSurcharge?: number | null, numberOfOrdersPerInvoice?: number | null, invoiceTimePeriodSplit?: TimePeriod | null, isPrepaidOnly: boolean, useCustomVehicleTypes: boolean, useCustomPackageSpecs: boolean, displayName: string, type: ContactType, isActive: boolean, shortCode?: string | null, uuid: string, contactReferenceNumber?: string | null, quickbooksMappingId?: string | null, quickbooksDesktopContactId?: string | null, quickbooksFileMappingFreightChargeName?: string | null, quickbooksFileMappingCustomerName?: string | null, quickbooksFileMappingFuelChargeName?: string | null, quickbooksFileMappingPickupChargeName?: string | null, quickbooksDesktopAccountsReceivableId?: string | null, freightChargeQuickbooksMappingId?: string | null, fuelChargeQuickbooksMappingId?: string | null, miscCustomChargeQuickbooksMappingId?: string | null, stediPartnerId?: string | null, billingCycleDuration: BillingCycleDuration, billingContactEmail?: string | null, isEfm?: boolean | null, showEdiReferenceNumbersOnOrderPage: boolean, vehicleTypes: Array<{ __typename?: 'VehicleTypeEntity', uuid: string, name: string, status: VehicleTypeStatus }>, packageSpecs: Array<{ __typename?: 'PackageSpecEntity', id: string, name: string, status: PackageSpecStatus, weight?: any | null, length?: any | null, width?: any | null, height?: any | null }>, services: Array<{ __typename?: 'ServiceEntity', uuid: string, name: string, markOrdersAsSpecial: boolean, defaultAppointmentStartTime?: any | null, defaultAppointmentEndTime?: any | null }>, defaultService?: { __typename?: 'ServiceEntity', uuid: string, name: string } | null, defaultAddress?: { __typename?: 'AddressEntity', uuid: string, line1: string, line2?: string | null, city: string, latitude?: number | null, longitude?: number | null, zip: string, state: string } | null, referenceNumberLabels: Array<{ __typename?: 'ReferenceNumberLabelEntity', name: string }>, contactStations: Array<{ __typename?: 'ContactStationEntity', id: string, name: string, isArchived: boolean, defaultPerson?: { __typename?: 'PersonEntity', id: string, firstName: string, lastName: string, phone?: string | null, email?: string | null } | null }> } | { __typename?: 'ThirdPartyContactEntity', displayName: string, type: ContactType, isActive: boolean, shortCode?: string | null, uuid: string, contactReferenceNumber?: string | null, quickbooksMappingId?: string | null, quickbooksDesktopContactId?: string | null, quickbooksFileMappingFreightChargeName?: string | null, quickbooksFileMappingCustomerName?: string | null, quickbooksFileMappingFuelChargeName?: string | null, quickbooksFileMappingPickupChargeName?: string | null, quickbooksDesktopAccountsReceivableId?: string | null, freightChargeQuickbooksMappingId?: string | null, fuelChargeQuickbooksMappingId?: string | null, miscCustomChargeQuickbooksMappingId?: string | null, stediPartnerId?: string | null, billingCycleDuration: BillingCycleDuration, billingContactEmail?: string | null, isEfm?: boolean | null, showEdiReferenceNumbersOnOrderPage: boolean, services: Array<{ __typename?: 'ServiceEntity', uuid: string, name: string, markOrdersAsSpecial: boolean, defaultAppointmentStartTime?: any | null, defaultAppointmentEndTime?: any | null }>, defaultService?: { __typename?: 'ServiceEntity', uuid: string, name: string } | null, defaultAddress?: { __typename?: 'AddressEntity', uuid: string, line1: string, line2?: string | null, city: string, latitude?: number | null, longitude?: number | null, zip: string, state: string } | null, referenceNumberLabels: Array<{ __typename?: 'ReferenceNumberLabelEntity', name: string }>, contactStations: Array<{ __typename?: 'ContactStationEntity', id: string, name: string, isArchived: boolean, defaultPerson?: { __typename?: 'PersonEntity', id: string, firstName: string, lastName: string, phone?: string | null, email?: string | null } | null }> }> };

export type ShallowContactsQueryVariables = Exact<{ [key: string]: never; }>;


export type ShallowContactsQuery = { __typename?: 'Query', contacts: Array<{ __typename?: 'CustomerContactEntity', defaultUseTariff?: boolean | null, defaultInvoiceTransmissionMethod: InvoiceTransmissionMethod, defaultInvoiceType: InvoiceType, defaultInvoiceDownloadDocuments: Array<DocumentType>, defaultInvoiceDocumentsRequired: Array<DocumentType>, defaultDimFactor?: number | null, defaultFuelSurcharge?: number | null, numberOfOrdersPerInvoice?: number | null, invoiceTimePeriodSplit?: TimePeriod | null, isPrepaidOnly: boolean, useCustomVehicleTypes: boolean, useCustomPackageSpecs: boolean, displayName: string, type: ContactType, isActive: boolean, shortCode?: string | null, uuid: string, contactReferenceNumber?: string | null, quickbooksMappingId?: string | null, quickbooksDesktopContactId?: string | null, quickbooksFileMappingFreightChargeName?: string | null, quickbooksFileMappingCustomerName?: string | null, quickbooksFileMappingFuelChargeName?: string | null, quickbooksFileMappingPickupChargeName?: string | null, quickbooksDesktopAccountsReceivableId?: string | null, freightChargeQuickbooksMappingId?: string | null, fuelChargeQuickbooksMappingId?: string | null, miscCustomChargeQuickbooksMappingId?: string | null, stediPartnerId?: string | null, billingCycleDuration: BillingCycleDuration, billingContactEmail?: string | null, isEfm?: boolean | null, showEdiReferenceNumbersOnOrderPage: boolean, vehicleTypes: Array<{ __typename?: 'VehicleTypeEntity', uuid: string, name: string, status: VehicleTypeStatus }>, packageSpecs: Array<{ __typename?: 'PackageSpecEntity', id: string, name: string, status: PackageSpecStatus, weight?: any | null, length?: any | null, width?: any | null, height?: any | null }>, services: Array<{ __typename?: 'ServiceEntity', uuid: string, name: string, markOrdersAsSpecial: boolean, defaultAppointmentStartTime?: any | null, defaultAppointmentEndTime?: any | null }>, defaultService?: { __typename?: 'ServiceEntity', uuid: string, name: string } | null, defaultAddress?: { __typename?: 'AddressEntity', uuid: string, line1: string, line2?: string | null, city: string, latitude?: number | null, longitude?: number | null, zip: string, state: string } | null, referenceNumberLabels: Array<{ __typename?: 'ReferenceNumberLabelEntity', name: string }>, contactStations: Array<{ __typename?: 'ContactStationEntity', id: string, name: string, isArchived: boolean, defaultPerson?: { __typename?: 'PersonEntity', id: string, firstName: string, lastName: string, phone?: string | null, email?: string | null } | null }> } | { __typename?: 'ThirdPartyContactEntity', displayName: string, type: ContactType, isActive: boolean, shortCode?: string | null, uuid: string, contactReferenceNumber?: string | null, quickbooksMappingId?: string | null, quickbooksDesktopContactId?: string | null, quickbooksFileMappingFreightChargeName?: string | null, quickbooksFileMappingCustomerName?: string | null, quickbooksFileMappingFuelChargeName?: string | null, quickbooksFileMappingPickupChargeName?: string | null, quickbooksDesktopAccountsReceivableId?: string | null, freightChargeQuickbooksMappingId?: string | null, fuelChargeQuickbooksMappingId?: string | null, miscCustomChargeQuickbooksMappingId?: string | null, stediPartnerId?: string | null, billingCycleDuration: BillingCycleDuration, billingContactEmail?: string | null, isEfm?: boolean | null, showEdiReferenceNumbersOnOrderPage: boolean, services: Array<{ __typename?: 'ServiceEntity', uuid: string, name: string, markOrdersAsSpecial: boolean, defaultAppointmentStartTime?: any | null, defaultAppointmentEndTime?: any | null }>, defaultService?: { __typename?: 'ServiceEntity', uuid: string, name: string } | null, defaultAddress?: { __typename?: 'AddressEntity', uuid: string, line1: string, line2?: string | null, city: string, latitude?: number | null, longitude?: number | null, zip: string, state: string } | null, referenceNumberLabels: Array<{ __typename?: 'ReferenceNumberLabelEntity', name: string }>, contactStations: Array<{ __typename?: 'ContactStationEntity', id: string, name: string, isArchived: boolean, defaultPerson?: { __typename?: 'PersonEntity', id: string, firstName: string, lastName: string, phone?: string | null, email?: string | null } | null }> }> };

export type ThirdPartyUserByUuidQueryVariables = Exact<{
  uuid: Scalars['String']['input'];
}>;


export type ThirdPartyUserByUuidQuery = { __typename?: 'Query', thirdPartyUserByUuid?: { __typename?: 'ThirdPartyUserEntity', uuid: string, email: string, password: string, contacts: Array<{ __typename?: 'CustomerContactEntity', displayName: string } | { __typename?: 'ThirdPartyContactEntity', displayName: string }> } | null };

export type ThirdPartyUsersByContactQueryVariables = Exact<{
  contactUuid: Scalars['String']['input'];
}>;


export type ThirdPartyUsersByContactQuery = { __typename?: 'Query', thirdPartyUsersByContact: Array<{ __typename?: 'ThirdPartyUserEntity', uuid: string, email: string }> };

export type UpdateAddressMutationVariables = Exact<{
  input: UpdateAddressInput;
}>;


export type UpdateAddressMutation = { __typename?: 'Mutation', updateAddress: { __typename?: 'AddressEntity', uuid: string } };

export type UpdateContactCommunicationConfigMutationVariables = Exact<{
  updateContactCommunicationConfigInput: UpdateContactCommunicationConfigInput;
}>;


export type UpdateContactCommunicationConfigMutation = { __typename?: 'Mutation', updateContactCommunicationConfig: { __typename?: 'ContactCommunicationConfigEntity', uuid: string } };

export type UpdateContactEmailsMutationVariables = Exact<{
  input: UpdateContactEmailsInput;
}>;


export type UpdateContactEmailsMutation = { __typename?: 'Mutation', updateContactEmails: { __typename: 'MutationErrorOutput', message: string } | { __typename: 'UpdateContactEmailsSuccessOutput', contactUuid: string, contactCommunicationConfigs: Array<{ __typename?: 'ContactCommunicationConfigEntity', uuid: string, type: ContactCommunicationType, active: boolean }>, contactEmails: Array<{ __typename?: 'ContactEmailEntity', uuid: string, email: string, type: ContactEmailType }> } };

export type UpdateContactPersonMutationVariables = Exact<{
  input: UpdateContactPersonInput;
}>;


export type UpdateContactPersonMutation = { __typename?: 'Mutation', updateContactPerson: { __typename?: 'ContactPersonEntity', uuid: string } };

export type UpdateContactStationMutationVariables = Exact<{
  input: ContactStationUpdateInput;
}>;


export type UpdateContactStationMutation = { __typename?: 'Mutation', updateContactStation: { __typename: 'ContactStationUpdateSuccessOutput', contactStation: { __typename?: 'ContactStationEntity', id: string, name: string, defaultPerson?: { __typename?: 'PersonEntity', firstName: string, lastName: string, phone?: string | null, email?: string | null } | null } } | { __typename: 'MutationErrorOutput', message: string } };

export type UpdateCustomerContactMutationVariables = Exact<{
  input: UpdateCustomerContactInput;
}>;


export type UpdateCustomerContactMutation = { __typename?: 'Mutation', updateCustomerContact: { __typename?: 'CustomerContactEntity', uuid: string } };

export type UpdateOrderEventNotificationSubscriptionsMutationVariables = Exact<{
  input: UpdateOrderEventNotificationSubscriptionsInput;
}>;


export type UpdateOrderEventNotificationSubscriptionsMutation = { __typename?: 'Mutation', updateOrderEventNotificationSubscriptions: { __typename: 'MutationErrorOutput', message: string } | { __typename: 'UpdateOrderEventNotificationSubscriptionsSuccessOutput', contactUuid: string, subscriptions: Array<{ __typename?: 'OrderEventNotificationSubscriptionEntity', id: string, eventType: OrderEventNotificationType, channel: NotificationChannel, subscriberType: NotificationSubscriberType }> } };

export type UpdatePersonMutationVariables = Exact<{
  input: UpdatePersonInput;
}>;


export type UpdatePersonMutation = { __typename?: 'Mutation', updatePerson: { __typename?: 'UpdatePersonOutput', person: { __typename?: 'PersonEntity', id: string, status: PersonStatus, firstName: string, lastName: string, phone?: string | null, email?: string | null, defaultPickupAddress?: { __typename?: 'AddressEntity', uuid: string, name: string, line1: string, line2?: string | null, city: string, state: string, zip: string, country: string, specialInstructions?: string | null } | null, defaultDeliveryAddress?: { __typename?: 'AddressEntity', uuid: string, name: string, line1: string, line2?: string | null, city: string, state: string, zip: string, country: string, specialInstructions?: string | null } | null, defaultService?: { __typename?: 'ServiceEntity', uuid: string, name: string } | null, defaultVehicleType?: { __typename?: 'VehicleTypeEntity', uuid: string, name: string } | null } } };

export type UpsertAddressMutationVariables = Exact<{
  upsertAddressInput: UpsertAddressInput;
}>;


export type UpsertAddressMutation = { __typename?: 'Mutation', upsertAddress: { __typename?: 'AddressEntity', uuid: string } };

export type UpsertContactPersonMutationVariables = Exact<{
  input: UpsertContactPersonInput;
}>;


export type UpsertContactPersonMutation = { __typename?: 'Mutation', upsertContactPerson: { __typename?: 'ContactPersonEntity', uuid: string } };

export type UpsertUserContactNotificationSubscriptionMutationVariables = Exact<{
  input: UserContactNotificationSubscriptionUpsertInput;
}>;


export type UpsertUserContactNotificationSubscriptionMutation = { __typename?: 'Mutation', upsertUserContactNotificationSubscription: { __typename?: 'UserContactNotificationSubscriptionEntity', uuid: string, approveOrderNotification?: boolean | null } };

export type UserContactNotificationSubscriptionFragment = { __typename?: 'UserContactNotificationSubscriptionEntity', uuid: string, approveOrderNotification?: boolean | null };

export type UserContactNotificationSubscriptionQueryVariables = Exact<{
  contactUuid: Scalars['String']['input'];
}>;


export type UserContactNotificationSubscriptionQuery = { __typename?: 'Query', userContactNotificationSubscription?: { __typename?: 'UserContactNotificationSubscriptionEntity', uuid: string, approveOrderNotification?: boolean | null } | null };

export type AddThirdPartyUserToContactMutationVariables = Exact<{
  addThirdPartyUserToContactInput: AddThirdPartyUserToContactInput;
}>;


export type AddThirdPartyUserToContactMutation = { __typename?: 'Mutation', addThirdPartyUserToContact: { __typename?: 'ThirdPartyUserEntity', uuid: string } };

export type ConsigneePortalOrderFragment = { __typename?: 'ConsigneePortalOrderEntity', uuid: string, name: string, receivedDate?: any | null, status: OrderStatus, notes?: string | null, companyTimezone?: string | null, shipperBillOfLadingNumber?: string | null, masterAirwayBillOfLadingNumber?: string | null, detailedStatus?: OrderDetailedStatus | null, packages?: Array<{ __typename?: 'PackageEntity', uuid: string, class?: number | null, description: string, hazmat?: boolean | null, height?: number | null, length?: number | null, nmfc?: string | null, quantity: number, skuNumber?: string | null, type?: PackageType | null, weight?: number | null, width?: number | null, quantityCompletedAtStop?: number | null, reasonUncompletedAtStop?: string | null, packageSpec?: { __typename?: 'PackageSpecEntity', id: string, name: string } | null, warehouseLocation?: { __typename?: 'WarehouseLocationEntity', uuid: string, name: string } | null }> | null, shipments: Array<{ __typename?: 'ConsigneePortalShipmentEntity', uuid: string, deliveryDate?: any | null, appointmentTime?: any | null, endAppointmentTime?: any | null, status?: StopStatus | null, proofOfDeliverySignee?: string | null, addressUuid?: string | null, completedAtLocalTimeZone?: string | null, placeInRoute?: number | null, contactPhone?: string | null, outboundMethod?: OutboundMethod | null, driverPlaceInRoute?: number | null, routeIsToday?: boolean | null, pickupOrDelivery?: PickupOrDelivery | null, stopType?: StopType | null, completedAtLocal?: { __typename?: 'PlainDateTime', date: { __typename?: 'PlainDate', year: number, month: number, day: number }, time: { __typename?: 'PlainTime', hour: number, minute: number } } | null, address?: { __typename?: 'AddressEntity', uuid: string, name: string, line1: string, line2?: string | null, city: string, state: string, zip: string, country: string, latitude?: number | null, longitude?: number | null, driverInstructions?: string | null, receivingHoursStart?: any | null, receivingHoursEnd?: any | null, specialInstructions?: string | null } | null }> };

export type ConsigneePortalOrderQueryVariables = Exact<{
  uuid: Scalars['String']['input'];
}>;


export type ConsigneePortalOrderQuery = { __typename?: 'Query', consigneePortalOrder: { __typename?: 'ConsigneePortalOrderEntity', uuid: string, name: string, receivedDate?: any | null, status: OrderStatus, notes?: string | null, companyTimezone?: string | null, shipperBillOfLadingNumber?: string | null, masterAirwayBillOfLadingNumber?: string | null, detailedStatus?: OrderDetailedStatus | null, packages?: Array<{ __typename?: 'PackageEntity', uuid: string, class?: number | null, description: string, hazmat?: boolean | null, height?: number | null, length?: number | null, nmfc?: string | null, quantity: number, skuNumber?: string | null, type?: PackageType | null, weight?: number | null, width?: number | null, quantityCompletedAtStop?: number | null, reasonUncompletedAtStop?: string | null, packageSpec?: { __typename?: 'PackageSpecEntity', id: string, name: string } | null, warehouseLocation?: { __typename?: 'WarehouseLocationEntity', uuid: string, name: string } | null }> | null, shipments: Array<{ __typename?: 'ConsigneePortalShipmentEntity', uuid: string, deliveryDate?: any | null, appointmentTime?: any | null, endAppointmentTime?: any | null, status?: StopStatus | null, proofOfDeliverySignee?: string | null, addressUuid?: string | null, completedAtLocalTimeZone?: string | null, placeInRoute?: number | null, contactPhone?: string | null, outboundMethod?: OutboundMethod | null, driverPlaceInRoute?: number | null, routeIsToday?: boolean | null, pickupOrDelivery?: PickupOrDelivery | null, stopType?: StopType | null, completedAtLocal?: { __typename?: 'PlainDateTime', date: { __typename?: 'PlainDate', year: number, month: number, day: number }, time: { __typename?: 'PlainTime', hour: number, minute: number } } | null, address?: { __typename?: 'AddressEntity', uuid: string, name: string, line1: string, line2?: string | null, city: string, state: string, zip: string, country: string, latitude?: number | null, longitude?: number | null, driverInstructions?: string | null, receivingHoursStart?: any | null, receivingHoursEnd?: any | null, specialInstructions?: string | null } | null }> } };

export type CustomerPortalCompanyFragment = { __typename?: 'CompanyEntity', timeZone: string, segment: Segment };

export type CustomerPortalCompanyQueryVariables = Exact<{
  uuid: Scalars['String']['input'];
}>;


export type CustomerPortalCompanyQuery = { __typename?: 'Query', customerPortalCompany: { __typename?: 'CompanyEntity', timeZone: string, segment: Segment } };

export type CustomerPortalOrderShipmentFragment = { __typename?: 'StandardShipmentEntity', uuid: string, name: string, status: ShipmentStatus, hideFromBilling: boolean, totalChargesAmount: number, shipmentType: ShipmentType, documents: Array<{ __typename?: 'DocumentEntity', uuid: string }>, order?: { __typename?: 'StandardOrderEntity', standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', measurementUnits: MeasurementUnits, weightUnits: WeightUnits } } | null, standardShipmentFields: { __typename?: 'StandardShipmentFieldsEntity', deliveryDate?: any | null, deadlineDate?: any | null, pickupOrDelivery: PickupOrDelivery, service?: { __typename?: 'ServiceEntity', uuid: string, name: string, createdAt: any, updatedAt: any, timeInMinutes?: number | null, useApptInRouteOptimization: boolean, markOrdersAsSpecial: boolean, defaultAppointmentStartTime?: any | null, defaultAppointmentEndTime?: any | null, defaultStartNow: boolean, defaultInboundStopType?: StopType | null, defaultOutboundStopType?: StopType | null, defaultPickupPadding?: any | null, defaultDeliveryPadding?: any | null, defaultTotalDuration?: any | null, defaultIsLineHaul: boolean, defaultFulfillmentType?: FulfillmentType | null, isActive: boolean, isExposedToCustomers: boolean, serviceAvailabilityDates: Array<{ __typename?: 'ServiceAvailabilityDateEntity', id: string, dayCategory: SpecialDayOfWeek, enabled: boolean, start: { __typename?: 'PlainTime', hour: number, minute: number }, end: { __typename?: 'PlainTime', hour: number, minute: number } }> } | null }, freightCharge?: { __typename?: 'FreightChargeEntity', uuid: string, billingMethod: FreightBillingMethod, total: number, rate: number, description?: string | null, quantity: number, tariff?: { __typename?: 'TariffEntity', uuid: string, billingPartyContactUuid?: string | null, tariffType: TariffType, rateType: RateType, useActualWeightInCalculation: boolean, tariffOverageRates: Array<{ __typename?: 'TariffOverageRateEntity', uuid: string, name: string, type: TariffOverageRateType, rateUsdCents: number, flatRateUsdCents: number, applicableAboveAmount: number }>, tariffRanges: Array<{ __typename?: 'TariffRangeEntity', uuid: string, lessThanOrEqualToValue: number, rateUsdCents: number }>, tariffZone: { __typename?: 'TariffZoneEntity', uuid: string, name: string, type: TariffZoneType, mileRangeStart?: number | null, mileRangeEnd?: number | null, billingPartyContactUuid?: string | null, locations: Array<{ __typename?: 'TariffLocationEntity', uuid: string, city?: string | null, zipcode?: string | null }> } } | null, fuelCharge?: { __typename?: 'FuelChargeEntity', description?: string | null, surchargeRate: number, flatRate: number, type: FuelBillingMethod, uuid: string } | null } | null, customCharges: Array<{ __typename?: 'CustomChargeEntity', uuid: string, name: string, zoneBasedAccessorialZoneUuid?: string | null, zoneBasedAccessorialChargeGroupUuid?: string | null, specialAccessorialTariffZoneUuid?: string | null, specialAccessorialChargeGroupUuid?: string | null, quantity: number, description?: string | null, rate: number, total: number, customChargeBillingMethod: CustomChargeBillingMethod, accessorialTemplate?: { __typename: 'SkidBasedAccessorialEntity', uuid: string, name: string } | { __typename: 'SpecialAccessorialEntity', uuid: string, name: string } | { __typename: 'StandardAccessorialEntity', uuid: string, name: string } | { __typename: 'UnitBasedAccessorialEntity', uuid: string, name: string } | { __typename: 'WaitTimeAccessorialEntity', uuid: string, name: string } | { __typename: 'WeightBasedAccessorialEntity', uuid: string, name: string } | { __typename: 'ZoneBasedAccessorialEntity', uuid: string, name: string } | null }>, legs: Array<{ __typename?: 'LegEntity', uuid: string, status: LegStatus, endStop: { __typename?: 'StandardStopEntity', stopType?: StopType | null, localTimeZone?: string | null, appointmentTime?: any | null, endAppointmentTime?: any | null, status: StopStatus, proofOfDeliverySignee?: string | null, completedAt?: any | null, outboundMethod?: OutboundMethod | null, address: { __typename?: 'AddressEntity', uuid: string, name: string, line1: string, line2?: string | null, city: string, state: string, zip: string, country: string, latitude?: number | null, longitude?: number | null, driverInstructions?: string | null, receivingHoursStart?: any | null, receivingHoursEnd?: any | null, specialInstructions?: string | null }, routeSlot?: { __typename?: 'RouteSlotEntity', ordinal: number, route?: { __typename?: 'RouteEntity', date: any, slots: Array<{ __typename?: 'RouteSlotEntity', ordinal: number, stops: Array<{ __typename?: 'StandardStopEntity', status: StopStatus, leg: { __typename?: 'LegEntity', shipment: { __typename?: 'StandardShipmentEntity', status: ShipmentStatus } } }> }> } | null } | null, contactPerson?: { __typename?: 'ContactPersonEntity', uuid: string, firstName?: string | null, lastName?: string | null, email?: string | null, notes?: string | null, phone?: string | null, createdAt: any } | null } }>, consigneeAddress?: { __typename?: 'AddressEntity', uuid: string, name: string, line1: string, line2?: string | null, city: string, state: string, zip: string, country: string, latitude?: number | null, longitude?: number | null, driverInstructions?: string | null, receivingHoursStart?: any | null, receivingHoursEnd?: any | null, specialInstructions?: string | null } | null };

export type CustomerPortalMeQueryVariables = Exact<{ [key: string]: never; }>;


export type CustomerPortalMeQuery = { __typename?: 'Query', me?: { __typename?: 'UserEntity', company: { __typename?: 'CompanyEntity', uuid: string, name: string } } | null };

export type CustomerPortalOrderFragment = { __typename?: 'StandardOrderEntity', uuid: string, name: string, detailedStatusV2?: OrderDetailedStatus | null, receivedDate?: any | null, status: OrderStatus, osd?: boolean | null, notes: string, totalCharge: number, company: { __typename?: 'CompanyEntity', uuid: string, segment: Segment, timeZone: string }, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', measurementUnits: MeasurementUnits, weightUnits: WeightUnits, shipperBillOfLadingNumber?: string | null, masterAirwayBillOfLadingNumber?: string | null }, shipments: Array<{ __typename?: 'StandardShipmentEntity', uuid: string, name: string, status: ShipmentStatus, hideFromBilling: boolean, totalChargesAmount: number, shipmentType: ShipmentType, documents: Array<{ __typename?: 'DocumentEntity', uuid: string }>, order?: { __typename?: 'StandardOrderEntity', standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', measurementUnits: MeasurementUnits, weightUnits: WeightUnits } } | null, standardShipmentFields: { __typename?: 'StandardShipmentFieldsEntity', deliveryDate?: any | null, deadlineDate?: any | null, pickupOrDelivery: PickupOrDelivery, service?: { __typename?: 'ServiceEntity', uuid: string, name: string, createdAt: any, updatedAt: any, timeInMinutes?: number | null, useApptInRouteOptimization: boolean, markOrdersAsSpecial: boolean, defaultAppointmentStartTime?: any | null, defaultAppointmentEndTime?: any | null, defaultStartNow: boolean, defaultInboundStopType?: StopType | null, defaultOutboundStopType?: StopType | null, defaultPickupPadding?: any | null, defaultDeliveryPadding?: any | null, defaultTotalDuration?: any | null, defaultIsLineHaul: boolean, defaultFulfillmentType?: FulfillmentType | null, isActive: boolean, isExposedToCustomers: boolean, serviceAvailabilityDates: Array<{ __typename?: 'ServiceAvailabilityDateEntity', id: string, dayCategory: SpecialDayOfWeek, enabled: boolean, start: { __typename?: 'PlainTime', hour: number, minute: number }, end: { __typename?: 'PlainTime', hour: number, minute: number } }> } | null }, freightCharge?: { __typename?: 'FreightChargeEntity', uuid: string, billingMethod: FreightBillingMethod, total: number, rate: number, description?: string | null, quantity: number, tariff?: { __typename?: 'TariffEntity', uuid: string, billingPartyContactUuid?: string | null, tariffType: TariffType, rateType: RateType, useActualWeightInCalculation: boolean, tariffOverageRates: Array<{ __typename?: 'TariffOverageRateEntity', uuid: string, name: string, type: TariffOverageRateType, rateUsdCents: number, flatRateUsdCents: number, applicableAboveAmount: number }>, tariffRanges: Array<{ __typename?: 'TariffRangeEntity', uuid: string, lessThanOrEqualToValue: number, rateUsdCents: number }>, tariffZone: { __typename?: 'TariffZoneEntity', uuid: string, name: string, type: TariffZoneType, mileRangeStart?: number | null, mileRangeEnd?: number | null, billingPartyContactUuid?: string | null, locations: Array<{ __typename?: 'TariffLocationEntity', uuid: string, city?: string | null, zipcode?: string | null }> } } | null, fuelCharge?: { __typename?: 'FuelChargeEntity', description?: string | null, surchargeRate: number, flatRate: number, type: FuelBillingMethod, uuid: string } | null } | null, customCharges: Array<{ __typename?: 'CustomChargeEntity', uuid: string, name: string, zoneBasedAccessorialZoneUuid?: string | null, zoneBasedAccessorialChargeGroupUuid?: string | null, specialAccessorialTariffZoneUuid?: string | null, specialAccessorialChargeGroupUuid?: string | null, quantity: number, description?: string | null, rate: number, total: number, customChargeBillingMethod: CustomChargeBillingMethod, accessorialTemplate?: { __typename: 'SkidBasedAccessorialEntity', uuid: string, name: string } | { __typename: 'SpecialAccessorialEntity', uuid: string, name: string } | { __typename: 'StandardAccessorialEntity', uuid: string, name: string } | { __typename: 'UnitBasedAccessorialEntity', uuid: string, name: string } | { __typename: 'WaitTimeAccessorialEntity', uuid: string, name: string } | { __typename: 'WeightBasedAccessorialEntity', uuid: string, name: string } | { __typename: 'ZoneBasedAccessorialEntity', uuid: string, name: string } | null }>, legs: Array<{ __typename?: 'LegEntity', uuid: string, status: LegStatus, endStop: { __typename?: 'StandardStopEntity', stopType?: StopType | null, localTimeZone?: string | null, appointmentTime?: any | null, endAppointmentTime?: any | null, status: StopStatus, proofOfDeliverySignee?: string | null, completedAt?: any | null, outboundMethod?: OutboundMethod | null, address: { __typename?: 'AddressEntity', uuid: string, name: string, line1: string, line2?: string | null, city: string, state: string, zip: string, country: string, latitude?: number | null, longitude?: number | null, driverInstructions?: string | null, receivingHoursStart?: any | null, receivingHoursEnd?: any | null, specialInstructions?: string | null }, routeSlot?: { __typename?: 'RouteSlotEntity', ordinal: number, route?: { __typename?: 'RouteEntity', date: any, slots: Array<{ __typename?: 'RouteSlotEntity', ordinal: number, stops: Array<{ __typename?: 'StandardStopEntity', status: StopStatus, leg: { __typename?: 'LegEntity', shipment: { __typename?: 'StandardShipmentEntity', status: ShipmentStatus } } }> }> } | null } | null, contactPerson?: { __typename?: 'ContactPersonEntity', uuid: string, firstName?: string | null, lastName?: string | null, email?: string | null, notes?: string | null, phone?: string | null, createdAt: any } | null } }>, consigneeAddress?: { __typename?: 'AddressEntity', uuid: string, name: string, line1: string, line2?: string | null, city: string, state: string, zip: string, country: string, latitude?: number | null, longitude?: number | null, driverInstructions?: string | null, receivingHoursStart?: any | null, receivingHoursEnd?: any | null, specialInstructions?: string | null } | null }>, packages: Array<{ __typename?: 'PackageEntity', uuid: string, class?: number | null, description: string, hazmat?: boolean | null, height?: number | null, length?: number | null, nmfc?: string | null, quantity: number, skuNumber?: string | null, type?: PackageType | null, weight?: number | null, width?: number | null, quantityCompletedAtStop?: number | null, reasonUncompletedAtStop?: string | null, packageSpec?: { __typename?: 'PackageSpecEntity', id: string, name: string } | null, warehouseLocation?: { __typename?: 'WarehouseLocationEntity', uuid: string, name: string } | null }> };

export type CustomerPortalOrderQueryVariables = Exact<{
  uuid: Scalars['String']['input'];
}>;


export type CustomerPortalOrderQuery = { __typename?: 'Query', order?: { __typename?: 'StandardOrderEntity', uuid: string, name: string, detailedStatusV2?: OrderDetailedStatus | null, receivedDate?: any | null, status: OrderStatus, osd?: boolean | null, notes: string, totalCharge: number, company: { __typename?: 'CompanyEntity', uuid: string, segment: Segment, timeZone: string }, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', measurementUnits: MeasurementUnits, weightUnits: WeightUnits, shipperBillOfLadingNumber?: string | null, masterAirwayBillOfLadingNumber?: string | null }, shipments: Array<{ __typename?: 'StandardShipmentEntity', uuid: string, name: string, status: ShipmentStatus, hideFromBilling: boolean, totalChargesAmount: number, shipmentType: ShipmentType, documents: Array<{ __typename?: 'DocumentEntity', uuid: string }>, order?: { __typename?: 'StandardOrderEntity', standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', measurementUnits: MeasurementUnits, weightUnits: WeightUnits } } | null, standardShipmentFields: { __typename?: 'StandardShipmentFieldsEntity', deliveryDate?: any | null, deadlineDate?: any | null, pickupOrDelivery: PickupOrDelivery, service?: { __typename?: 'ServiceEntity', uuid: string, name: string, createdAt: any, updatedAt: any, timeInMinutes?: number | null, useApptInRouteOptimization: boolean, markOrdersAsSpecial: boolean, defaultAppointmentStartTime?: any | null, defaultAppointmentEndTime?: any | null, defaultStartNow: boolean, defaultInboundStopType?: StopType | null, defaultOutboundStopType?: StopType | null, defaultPickupPadding?: any | null, defaultDeliveryPadding?: any | null, defaultTotalDuration?: any | null, defaultIsLineHaul: boolean, defaultFulfillmentType?: FulfillmentType | null, isActive: boolean, isExposedToCustomers: boolean, serviceAvailabilityDates: Array<{ __typename?: 'ServiceAvailabilityDateEntity', id: string, dayCategory: SpecialDayOfWeek, enabled: boolean, start: { __typename?: 'PlainTime', hour: number, minute: number }, end: { __typename?: 'PlainTime', hour: number, minute: number } }> } | null }, freightCharge?: { __typename?: 'FreightChargeEntity', uuid: string, billingMethod: FreightBillingMethod, total: number, rate: number, description?: string | null, quantity: number, tariff?: { __typename?: 'TariffEntity', uuid: string, billingPartyContactUuid?: string | null, tariffType: TariffType, rateType: RateType, useActualWeightInCalculation: boolean, tariffOverageRates: Array<{ __typename?: 'TariffOverageRateEntity', uuid: string, name: string, type: TariffOverageRateType, rateUsdCents: number, flatRateUsdCents: number, applicableAboveAmount: number }>, tariffRanges: Array<{ __typename?: 'TariffRangeEntity', uuid: string, lessThanOrEqualToValue: number, rateUsdCents: number }>, tariffZone: { __typename?: 'TariffZoneEntity', uuid: string, name: string, type: TariffZoneType, mileRangeStart?: number | null, mileRangeEnd?: number | null, billingPartyContactUuid?: string | null, locations: Array<{ __typename?: 'TariffLocationEntity', uuid: string, city?: string | null, zipcode?: string | null }> } } | null, fuelCharge?: { __typename?: 'FuelChargeEntity', description?: string | null, surchargeRate: number, flatRate: number, type: FuelBillingMethod, uuid: string } | null } | null, customCharges: Array<{ __typename?: 'CustomChargeEntity', uuid: string, name: string, zoneBasedAccessorialZoneUuid?: string | null, zoneBasedAccessorialChargeGroupUuid?: string | null, specialAccessorialTariffZoneUuid?: string | null, specialAccessorialChargeGroupUuid?: string | null, quantity: number, description?: string | null, rate: number, total: number, customChargeBillingMethod: CustomChargeBillingMethod, accessorialTemplate?: { __typename: 'SkidBasedAccessorialEntity', uuid: string, name: string } | { __typename: 'SpecialAccessorialEntity', uuid: string, name: string } | { __typename: 'StandardAccessorialEntity', uuid: string, name: string } | { __typename: 'UnitBasedAccessorialEntity', uuid: string, name: string } | { __typename: 'WaitTimeAccessorialEntity', uuid: string, name: string } | { __typename: 'WeightBasedAccessorialEntity', uuid: string, name: string } | { __typename: 'ZoneBasedAccessorialEntity', uuid: string, name: string } | null }>, legs: Array<{ __typename?: 'LegEntity', uuid: string, status: LegStatus, endStop: { __typename?: 'StandardStopEntity', stopType?: StopType | null, localTimeZone?: string | null, appointmentTime?: any | null, endAppointmentTime?: any | null, status: StopStatus, proofOfDeliverySignee?: string | null, completedAt?: any | null, outboundMethod?: OutboundMethod | null, address: { __typename?: 'AddressEntity', uuid: string, name: string, line1: string, line2?: string | null, city: string, state: string, zip: string, country: string, latitude?: number | null, longitude?: number | null, driverInstructions?: string | null, receivingHoursStart?: any | null, receivingHoursEnd?: any | null, specialInstructions?: string | null }, routeSlot?: { __typename?: 'RouteSlotEntity', ordinal: number, route?: { __typename?: 'RouteEntity', date: any, slots: Array<{ __typename?: 'RouteSlotEntity', ordinal: number, stops: Array<{ __typename?: 'StandardStopEntity', status: StopStatus, leg: { __typename?: 'LegEntity', shipment: { __typename?: 'StandardShipmentEntity', status: ShipmentStatus } } }> }> } | null } | null, contactPerson?: { __typename?: 'ContactPersonEntity', uuid: string, firstName?: string | null, lastName?: string | null, email?: string | null, notes?: string | null, phone?: string | null, createdAt: any } | null } }>, consigneeAddress?: { __typename?: 'AddressEntity', uuid: string, name: string, line1: string, line2?: string | null, city: string, state: string, zip: string, country: string, latitude?: number | null, longitude?: number | null, driverInstructions?: string | null, receivingHoursStart?: any | null, receivingHoursEnd?: any | null, specialInstructions?: string | null } | null }>, packages: Array<{ __typename?: 'PackageEntity', uuid: string, class?: number | null, description: string, hazmat?: boolean | null, height?: number | null, length?: number | null, nmfc?: string | null, quantity: number, skuNumber?: string | null, type?: PackageType | null, weight?: number | null, width?: number | null, quantityCompletedAtStop?: number | null, reasonUncompletedAtStop?: string | null, packageSpec?: { __typename?: 'PackageSpecEntity', id: string, name: string } | null, warehouseLocation?: { __typename?: 'WarehouseLocationEntity', uuid: string, name: string } | null }> } | null };

export type CustomerPortalQuotesQueryVariables = Exact<{
  findCustomerPortalQuotesInput: FindCustomerPortalQuotesInput;
}>;


export type CustomerPortalQuotesQuery = { __typename?: 'Query', customerPortalQuotes: { __typename?: 'QuoteConnection', totalCount?: number | null, edges: Array<{ __typename?: 'QuoteEdge', node: { __typename?: 'QuoteEntity', uuid: string, createdAt: any, source: QuoteSource, number: string, status: QuoteStatus, company: { __typename?: 'CompanyEntity', name: string } } }>, pageInfo: { __typename?: 'PageInfo', startCursor?: string | null, endCursor?: string | null, hasNextPage: boolean } } };

export type CustomerPortalQuoteFragment = { __typename?: 'QuoteEntity', uuid: string, createdAt: any, source: QuoteSource, number: string, status: QuoteStatus, company: { __typename?: 'CompanyEntity', name: string } };

export type CustomerPortalShipmentForTableFragment = { __typename?: 'StandardShipmentEntity', uuid: string, shipmentType: ShipmentType, standardShipmentFields: { __typename?: 'StandardShipmentFieldsEntity', deadlineDate?: any | null, deliveryDate?: any | null, pickupOrDelivery: PickupOrDelivery }, legs: Array<{ __typename?: 'LegEntity', endStop: { __typename?: 'StandardStopEntity', stopType?: StopType | null, uuid: string, status: StopStatus, appointmentTime?: any | null, endAppointmentTime?: any | null, inboundMethod?: InboundMethod | null, outboundMethod?: OutboundMethod | null, address: { __typename?: 'AddressEntity', uuid: string, name: string, line1: string, line2?: string | null, city: string, state: string, zip: string, country: string, latitude?: number | null, longitude?: number | null, driverInstructions?: string | null, receivingHoursStart?: any | null, receivingHoursEnd?: any | null, specialInstructions?: string | null }, routeSlot?: { __typename?: 'RouteSlotEntity', route?: { __typename?: 'RouteEntity', date: any, uuid: string } | null } | null } }>, consigneeAddress?: { __typename?: 'AddressEntity', uuid: string, name: string, line1: string, line2?: string | null, city: string, state: string, zip: string, country: string, latitude?: number | null, longitude?: number | null, driverInstructions?: string | null, receivingHoursStart?: any | null, receivingHoursEnd?: any | null, specialInstructions?: string | null } | null };

export type CustomerPortalOrderForTableFragment = { __typename?: 'StandardOrderEntity', uuid: string, name: string, detailedStatusV2?: OrderDetailedStatus | null, osd?: boolean | null, onHold: boolean, receivedDate?: any | null, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', shipperBillOfLadingNumber?: string | null }, shipments: Array<{ __typename?: 'StandardShipmentEntity', uuid: string, shipmentType: ShipmentType, standardShipmentFields: { __typename?: 'StandardShipmentFieldsEntity', deadlineDate?: any | null, deliveryDate?: any | null, pickupOrDelivery: PickupOrDelivery }, legs: Array<{ __typename?: 'LegEntity', endStop: { __typename?: 'StandardStopEntity', stopType?: StopType | null, uuid: string, status: StopStatus, appointmentTime?: any | null, endAppointmentTime?: any | null, inboundMethod?: InboundMethod | null, outboundMethod?: OutboundMethod | null, address: { __typename?: 'AddressEntity', uuid: string, name: string, line1: string, line2?: string | null, city: string, state: string, zip: string, country: string, latitude?: number | null, longitude?: number | null, driverInstructions?: string | null, receivingHoursStart?: any | null, receivingHoursEnd?: any | null, specialInstructions?: string | null }, routeSlot?: { __typename?: 'RouteSlotEntity', route?: { __typename?: 'RouteEntity', date: any, uuid: string } | null } | null } }>, consigneeAddress?: { __typename?: 'AddressEntity', uuid: string, name: string, line1: string, line2?: string | null, city: string, state: string, zip: string, country: string, latitude?: number | null, longitude?: number | null, driverInstructions?: string | null, receivingHoursStart?: any | null, receivingHoursEnd?: any | null, specialInstructions?: string | null } | null }>, company: { __typename?: 'CompanyEntity', uuid: string, name: string }, contact: { __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string } };

export type CustomerPortalOrdersFragment = { __typename?: 'StandardOrderEntity', uuid: string, name: string, detailedStatusV2?: OrderDetailedStatus | null, receivedDate?: any | null, osd?: boolean | null, status: OrderStatus, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', shipperBillOfLadingNumber?: string | null }, packages: Array<{ __typename?: 'PackageEntity', uuid: string, class?: number | null, description: string, hazmat?: boolean | null, height?: number | null, length?: number | null, nmfc?: string | null, quantity: number, skuNumber?: string | null, type?: PackageType | null, weight?: number | null, width?: number | null, quantityCompletedAtStop?: number | null, reasonUncompletedAtStop?: string | null, packageSpec?: { __typename?: 'PackageSpecEntity', id: string, name: string } | null, warehouseLocation?: { __typename?: 'WarehouseLocationEntity', uuid: string, name: string } | null }>, shipments: Array<{ __typename?: 'StandardShipmentEntity', uuid: string, name: string, status: ShipmentStatus, hideFromBilling: boolean, totalChargesAmount: number, shipmentType: ShipmentType, documents: Array<{ __typename?: 'DocumentEntity', uuid: string }>, order?: { __typename?: 'StandardOrderEntity', standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', measurementUnits: MeasurementUnits, weightUnits: WeightUnits } } | null, standardShipmentFields: { __typename?: 'StandardShipmentFieldsEntity', deliveryDate?: any | null, deadlineDate?: any | null, pickupOrDelivery: PickupOrDelivery, service?: { __typename?: 'ServiceEntity', uuid: string, name: string, createdAt: any, updatedAt: any, timeInMinutes?: number | null, useApptInRouteOptimization: boolean, markOrdersAsSpecial: boolean, defaultAppointmentStartTime?: any | null, defaultAppointmentEndTime?: any | null, defaultStartNow: boolean, defaultInboundStopType?: StopType | null, defaultOutboundStopType?: StopType | null, defaultPickupPadding?: any | null, defaultDeliveryPadding?: any | null, defaultTotalDuration?: any | null, defaultIsLineHaul: boolean, defaultFulfillmentType?: FulfillmentType | null, isActive: boolean, isExposedToCustomers: boolean, serviceAvailabilityDates: Array<{ __typename?: 'ServiceAvailabilityDateEntity', id: string, dayCategory: SpecialDayOfWeek, enabled: boolean, start: { __typename?: 'PlainTime', hour: number, minute: number }, end: { __typename?: 'PlainTime', hour: number, minute: number } }> } | null }, freightCharge?: { __typename?: 'FreightChargeEntity', uuid: string, billingMethod: FreightBillingMethod, total: number, rate: number, description?: string | null, quantity: number, tariff?: { __typename?: 'TariffEntity', uuid: string, billingPartyContactUuid?: string | null, tariffType: TariffType, rateType: RateType, useActualWeightInCalculation: boolean, tariffOverageRates: Array<{ __typename?: 'TariffOverageRateEntity', uuid: string, name: string, type: TariffOverageRateType, rateUsdCents: number, flatRateUsdCents: number, applicableAboveAmount: number }>, tariffRanges: Array<{ __typename?: 'TariffRangeEntity', uuid: string, lessThanOrEqualToValue: number, rateUsdCents: number }>, tariffZone: { __typename?: 'TariffZoneEntity', uuid: string, name: string, type: TariffZoneType, mileRangeStart?: number | null, mileRangeEnd?: number | null, billingPartyContactUuid?: string | null, locations: Array<{ __typename?: 'TariffLocationEntity', uuid: string, city?: string | null, zipcode?: string | null }> } } | null, fuelCharge?: { __typename?: 'FuelChargeEntity', description?: string | null, surchargeRate: number, flatRate: number, type: FuelBillingMethod, uuid: string } | null } | null, customCharges: Array<{ __typename?: 'CustomChargeEntity', uuid: string, name: string, zoneBasedAccessorialZoneUuid?: string | null, zoneBasedAccessorialChargeGroupUuid?: string | null, specialAccessorialTariffZoneUuid?: string | null, specialAccessorialChargeGroupUuid?: string | null, quantity: number, description?: string | null, rate: number, total: number, customChargeBillingMethod: CustomChargeBillingMethod, accessorialTemplate?: { __typename: 'SkidBasedAccessorialEntity', uuid: string, name: string } | { __typename: 'SpecialAccessorialEntity', uuid: string, name: string } | { __typename: 'StandardAccessorialEntity', uuid: string, name: string } | { __typename: 'UnitBasedAccessorialEntity', uuid: string, name: string } | { __typename: 'WaitTimeAccessorialEntity', uuid: string, name: string } | { __typename: 'WeightBasedAccessorialEntity', uuid: string, name: string } | { __typename: 'ZoneBasedAccessorialEntity', uuid: string, name: string } | null }>, legs: Array<{ __typename?: 'LegEntity', uuid: string, status: LegStatus, endStop: { __typename?: 'StandardStopEntity', stopType?: StopType | null, localTimeZone?: string | null, appointmentTime?: any | null, endAppointmentTime?: any | null, status: StopStatus, proofOfDeliverySignee?: string | null, completedAt?: any | null, outboundMethod?: OutboundMethod | null, address: { __typename?: 'AddressEntity', uuid: string, name: string, line1: string, line2?: string | null, city: string, state: string, zip: string, country: string, latitude?: number | null, longitude?: number | null, driverInstructions?: string | null, receivingHoursStart?: any | null, receivingHoursEnd?: any | null, specialInstructions?: string | null }, routeSlot?: { __typename?: 'RouteSlotEntity', ordinal: number, route?: { __typename?: 'RouteEntity', date: any, slots: Array<{ __typename?: 'RouteSlotEntity', ordinal: number, stops: Array<{ __typename?: 'StandardStopEntity', status: StopStatus, leg: { __typename?: 'LegEntity', shipment: { __typename?: 'StandardShipmentEntity', status: ShipmentStatus } } }> }> } | null } | null, contactPerson?: { __typename?: 'ContactPersonEntity', uuid: string, firstName?: string | null, lastName?: string | null, email?: string | null, notes?: string | null, phone?: string | null, createdAt: any } | null } }>, consigneeAddress?: { __typename?: 'AddressEntity', uuid: string, name: string, line1: string, line2?: string | null, city: string, state: string, zip: string, country: string, latitude?: number | null, longitude?: number | null, driverInstructions?: string | null, receivingHoursStart?: any | null, receivingHoursEnd?: any | null, specialInstructions?: string | null } | null }>, company: { __typename?: 'CompanyEntity', uuid: string, name: string }, contact: { __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string } };

export type CustomerPortalOrdersQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  searchText?: InputMaybe<Scalars['String']['input']>;
  stopTypesFilter?: InputMaybe<StopTypesFilter>;
  appointmentDateFilters?: InputMaybe<DateFilterStartEnd>;
  createdAtDateFilters?: InputMaybe<DateFilterStartEnd>;
  receivedDateFilters?: InputMaybe<DateFilterStartEnd>;
  plannedDateFilters?: InputMaybe<DateFilterStartEnd>;
  dispatched?: InputMaybe<BooleanFilter>;
  ofdOfp?: InputMaybe<BooleanFilter>;
  completionDateFilters?: InputMaybe<DateFilterStartEnd>;
  companyFilter?: InputMaybe<Scalars['String']['input']>;
  contactFilter?: InputMaybe<Scalars['String']['input']>;
}>;


export type CustomerPortalOrdersQuery = { __typename?: 'Query', customerPortalOrders: { __typename?: 'OrderConnection', totalCount?: number | null, edges: Array<{ __typename?: 'OrderEdge', node: { __typename?: 'StandardOrderEntity', uuid: string, name: string, detailedStatusV2?: OrderDetailedStatus | null, osd?: boolean | null, onHold: boolean, receivedDate?: any | null, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', shipperBillOfLadingNumber?: string | null }, shipments: Array<{ __typename?: 'StandardShipmentEntity', uuid: string, shipmentType: ShipmentType, standardShipmentFields: { __typename?: 'StandardShipmentFieldsEntity', deadlineDate?: any | null, deliveryDate?: any | null, pickupOrDelivery: PickupOrDelivery }, legs: Array<{ __typename?: 'LegEntity', endStop: { __typename?: 'StandardStopEntity', stopType?: StopType | null, uuid: string, status: StopStatus, appointmentTime?: any | null, endAppointmentTime?: any | null, inboundMethod?: InboundMethod | null, outboundMethod?: OutboundMethod | null, address: { __typename?: 'AddressEntity', uuid: string, name: string, line1: string, line2?: string | null, city: string, state: string, zip: string, country: string, latitude?: number | null, longitude?: number | null, driverInstructions?: string | null, receivingHoursStart?: any | null, receivingHoursEnd?: any | null, specialInstructions?: string | null }, routeSlot?: { __typename?: 'RouteSlotEntity', route?: { __typename?: 'RouteEntity', date: any, uuid: string } | null } | null } }>, consigneeAddress?: { __typename?: 'AddressEntity', uuid: string, name: string, line1: string, line2?: string | null, city: string, state: string, zip: string, country: string, latitude?: number | null, longitude?: number | null, driverInstructions?: string | null, receivingHoursStart?: any | null, receivingHoursEnd?: any | null, specialInstructions?: string | null } | null }>, company: { __typename?: 'CompanyEntity', uuid: string, name: string }, contact: { __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string } } }>, pageInfo: { __typename?: 'PageInfo', startCursor?: string | null, endCursor?: string | null, hasNextPage: boolean, hasPreviousPage: boolean } } };

export type EtaForCustomerPortalQueryVariables = Exact<{
  uuid: Scalars['String']['input'];
}>;


export type EtaForCustomerPortalQuery = { __typename?: 'Query', etaForCustomerPortal?: { __typename?: 'EtaEntity', arrivalTime: any, finishTime: any } | null };

export type LoadCustomChargeFragment = { __typename?: 'CustomChargeEntity', uuid: string, name: string, zoneBasedAccessorialZoneUuid?: string | null, zoneBasedAccessorialChargeGroupUuid?: string | null, specialAccessorialTariffZoneUuid?: string | null, specialAccessorialChargeGroupUuid?: string | null, quantity: number, description?: string | null, rate: number, total: number, customChargeBillingMethod: CustomChargeBillingMethod, accessorialTemplate?: { __typename: 'SkidBasedAccessorialEntity', uuid: string, name: string } | { __typename: 'SpecialAccessorialEntity', uuid: string, name: string } | { __typename: 'StandardAccessorialEntity', uuid: string, name: string } | { __typename: 'UnitBasedAccessorialEntity', uuid: string, name: string } | { __typename: 'WaitTimeAccessorialEntity', uuid: string, name: string } | { __typename: 'WeightBasedAccessorialEntity', uuid: string, name: string } | { __typename: 'ZoneBasedAccessorialEntity', uuid: string, name: string } | null };

export type LoadFreightChargeFragment = { __typename?: 'FreightChargeEntity', uuid: string, billingMethod: FreightBillingMethod, total: number, rate: number, description?: string | null, quantity: number, tariff?: { __typename?: 'TariffEntity', uuid: string, billingPartyContactUuid?: string | null, tariffType: TariffType, rateType: RateType, useActualWeightInCalculation: boolean, tariffOverageRates: Array<{ __typename?: 'TariffOverageRateEntity', uuid: string, name: string, type: TariffOverageRateType, rateUsdCents: number, flatRateUsdCents: number, applicableAboveAmount: number }>, tariffRanges: Array<{ __typename?: 'TariffRangeEntity', uuid: string, lessThanOrEqualToValue: number, rateUsdCents: number }>, tariffZone: { __typename?: 'TariffZoneEntity', uuid: string, name: string, type: TariffZoneType, mileRangeStart?: number | null, mileRangeEnd?: number | null, billingPartyContactUuid?: string | null, locations: Array<{ __typename?: 'TariffLocationEntity', uuid: string, city?: string | null, zipcode?: string | null }> } } | null, fuelCharge?: { __typename?: 'FuelChargeEntity', description?: string | null, surchargeRate: number, flatRate: number, type: FuelBillingMethod, uuid: string } | null };

export type PublicUpsertShipmentSubscriberMutationVariables = Exact<{
  upsertShipmentSubscriberInput: UpsertShipmentSubscriberInput;
  companyUuid: Scalars['String']['input'];
}>;


export type PublicUpsertShipmentSubscriberMutation = { __typename?: 'Mutation', upsertShipmentSubscriberForCompany: { __typename?: 'ShipmentSubscriberEntity', phoneNumber?: string | null, uuid: string } };

export type RemoveThirdPartyUserFromContactMutationVariables = Exact<{
  removeThirdPartyUserFromContactInput: RemoveThirdPartyUserFromContactInput;
}>;


export type RemoveThirdPartyUserFromContactMutation = { __typename?: 'Mutation', removeThirdPartyUserFromContact: { __typename?: 'ThirdPartyUserEntity', uuid: string } };

export type SignUpForThirdPartyUserAccountMutationVariables = Exact<{
  signUpForThirdPartyUserAccountInput: SignUpForThirdPartyUserAccountInput;
}>;


export type SignUpForThirdPartyUserAccountMutation = { __typename?: 'Mutation', signUpForThirdPartyUserAccount: { __typename?: 'SignUpForThirdPartyUserAccountOutput', status: SignUpForThirdPartyUserAccountStatus } };

export type CalculateRouteEtasMutationVariables = Exact<{
  uuids: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type CalculateRouteEtasMutation = { __typename?: 'Mutation', calculateRouteEtas: Array<{ __typename?: 'EtaEntity', arrivalTime: any, finishTime: any }> };

export type SameDayDispatchRouteDriverCoordsFragment = { __typename?: 'RouteEntity', uuid: string, drivers: Array<{ __typename?: 'DriverEntity', uuid: string, mobilePhoneLatitude?: number | null, mobilePhoneLongitude?: number | null, mobileCoordsLastUpdatedAt?: any | null }> };

export type SameDayDispatchRoutesWithDriverCoordsQueryVariables = Exact<{
  date: Scalars['DateTime']['input'];
  searchText?: InputMaybe<Scalars['String']['input']>;
}>;


export type SameDayDispatchRoutesWithDriverCoordsQuery = { __typename?: 'Query', routes: Array<{ __typename?: 'RouteEntity', uuid: string, drivers: Array<{ __typename?: 'DriverEntity', uuid: string, mobilePhoneLatitude?: number | null, mobilePhoneLongitude?: number | null, mobileCoordsLastUpdatedAt?: any | null }> }> };

export type DispatchDriversQueryVariables = Exact<{
  startDate: Scalars['DateTime']['input'];
  endDate: Scalars['DateTime']['input'];
}>;


export type DispatchDriversQuery = { __typename?: 'Query', drivers: Array<{ __typename?: 'DriverEntity', uuid: string, status: DriverStatus, firstName: string, lastName: string, driverReferenceNumber?: string | null, lastCompletedLeg?: { __typename?: 'LegEntity', uuid: string, completedAt?: any | null, endStop: { __typename?: 'StandardStopEntity', uuid: string, address: { __typename?: 'AddressEntity', line1: string, line2?: string | null, city: string } } } | null, currentLeg?: { __typename?: 'LegEntity', uuid: string, name: string, completedAt?: any | null, endStop: { __typename?: 'StandardStopEntity', uuid: string, address: { __typename?: 'AddressEntity', line1: string, line2?: string | null, city: string } } } | null, defaultVehicle?: { __typename?: 'EquipmentEntity', uuid: string, name: string } | null }> };

export type EquipmentsByTypeQueryVariables = Exact<{
  equipmentType?: InputMaybe<Array<EquipmentType> | EquipmentType>;
}>;


export type EquipmentsByTypeQuery = { __typename?: 'Query', equipments: Array<{ __typename?: 'EquipmentEntity', uuid: string, type: EquipmentType, name: string }> };

export type LegQueryVariables = Exact<{
  uuid: Scalars['String']['input'];
}>;


export type LegQuery = { __typename?: 'Query', leg?: { __typename?: 'LegEntity', uuid: string, completedAt?: any | null, previousStopAttempts: Array<{ __typename?: 'StandardStopEntity', uuid: string, notes?: string | null, completedAt?: any | null, canMarkAttemptComplete?: boolean | null, routeSlot?: { __typename?: 'RouteSlotEntity', route?: { __typename?: 'RouteEntity', name: string, drivers: Array<{ __typename?: 'DriverEntity', uuid: string, firstName: string, lastName: string }> } | null } | null }>, shipment: { __typename?: 'StandardShipmentEntity', uuid: string } } | null };

export type LegsQueryVariables = Exact<{
  statuses?: InputMaybe<Array<LegStatus> | LegStatus>;
  maxOneUnassignedPerShipment: Scalars['Boolean']['input'];
}>;


export type LegsQuery = { __typename?: 'Query', legs: Array<{ __typename?: 'LegEntity', uuid: string, name: string, status: LegStatus, completedAt?: any | null, shipment: { __typename?: 'StandardShipmentEntity', uuid: string }, drivers: Array<{ __typename?: 'DriverEntity', uuid: string, firstName: string, lastName: string, status: DriverStatus }>, endStop: { __typename?: 'StandardStopEntity', uuid: string, appointmentTime?: any | null, address: { __typename?: 'AddressEntity', uuid: string, line1: string, line2?: string | null, city: string, latitude?: number | null, longitude?: number | null } } }> };

export type RefreshEtasForRouteMutationVariables = Exact<{
  uuid: Scalars['String']['input'];
}>;


export type RefreshEtasForRouteMutation = { __typename?: 'Mutation', refreshEtasForRoute: Array<{ __typename?: 'EtaEntity', arrivalTime: any, finishTime: any }> };

export type UnassignLegFromDriverMutationVariables = Exact<{
  unassignLegFromDriver: UnassignLegFromDriverInput;
}>;


export type UnassignLegFromDriverMutation = { __typename?: 'Mutation', unassignLegFromDriver: { __typename?: 'LegEntity', uuid: string } };

export type SameDayDispatchConfigFragment = { __typename?: 'SameDayDispatchConfigEntity', pickupAppointmentTimeThreshold: number, deliveryAppointmentTimeThreshold: number, isSpecialColorCode: string, isNextInRouteColorCode: string, isPastDeadlineColorCode: string, pickupWithinTimeWindowColorCode: string, deliveryWithinTimeWindowColorCode: string };

export type SameDayDispatchConfigQueryVariables = Exact<{ [key: string]: never; }>;


export type SameDayDispatchConfigQuery = { __typename?: 'Query', sameDayDispatchConfig?: { __typename?: 'SameDayDispatchConfigEntity', pickupAppointmentTimeThreshold: number, deliveryAppointmentTimeThreshold: number, isSpecialColorCode: string, isNextInRouteColorCode: string, isPastDeadlineColorCode: string, pickupWithinTimeWindowColorCode: string, deliveryWithinTimeWindowColorCode: string } | null };

export type UpdateSameDayDispatchConfigMutationVariables = Exact<{
  updateSameDayDispatchConfigInput: UpdateSameDayDispatchConfigInput;
}>;


export type UpdateSameDayDispatchConfigMutation = { __typename?: 'Mutation', updateSameDayDispatchConfig: { __typename?: 'SameDayDispatchConfigEntity', uuid: string } };

export type UpdateShipmentMutationVariables = Exact<{
  updateShipmentInput: UpdateShipmentInput;
}>;


export type UpdateShipmentMutation = { __typename?: 'Mutation', updateShipment: { __typename?: 'StandardShipmentEntity', uuid: string } };

export type ArchiveOrganizationMutationVariables = Exact<{
  input: ArchiveOrganizationInput;
}>;


export type ArchiveOrganizationMutation = { __typename?: 'Mutation', archiveOrganization: { __typename?: 'ArchiveOrganizationSuccessOutput', organization: { __typename?: 'OrganizationEntity', isActive: boolean, uuid: string, name: string, types: Array<OrganizationType>, referenceNumber?: string | null, email?: string | null, isaId?: string | null, ediApplicationId?: string | null, ediContactCode?: string | null, stediPartnerId?: string | null, defaultContactPerson?: { __typename?: 'ContactPersonEntity', uuid: string } | null, customerFields?: { __typename?: 'CustomerFieldsEntity', defaultAddressUuid?: string | null, businessDivisionUuid?: string | null, invoiceOrOrderIdentifier?: string | null, defaultInboundEdiServiceUuid?: string | null, defaultOutboundEdiServiceUuid?: string | null, defaultInboundOutboundEdiServiceUuid?: string | null, defaultServiceUuid?: string | null, showEdiReferenceNumbersOnOrderPage: boolean, defaultOrdinaryTariffChainId?: string | null, defaultLineHaulTariffChainId?: string | null, defaultTransferTariffChainId?: string | null, defaultPointToPointTariffChainId?: string | null, defaultFuelSurcharge?: number | null, defaultDimFactor?: number | null, defaultUseTariff: boolean, isPrepaidOnly: boolean, useCustomVehicleTypes: boolean, enableCustomerPortalOrderEntry: boolean, services: Array<{ __typename?: 'CustomerServiceEntity', uuid: string }>, customerVehicleTypes: Array<{ __typename?: 'CustomerVehicleTypeEntity', id: string, vehicleTypeUuid: string }>, referenceNumberLabels: Array<{ __typename?: 'CustomerReferenceNumberLabelEntity', name: string }> } | null } } | { __typename?: 'MutationErrorOutput', message: string } };

export type CreateOrganizationMutationVariables = Exact<{
  input: CreateOrganizationInput;
}>;


export type CreateOrganizationMutation = { __typename?: 'Mutation', createOrganization: { __typename?: 'CreateOrganizationSuccessOutput', organization: { __typename?: 'OrganizationEntity', isActive: boolean, uuid: string, name: string, types: Array<OrganizationType>, referenceNumber?: string | null, email?: string | null, isaId?: string | null, ediApplicationId?: string | null, ediContactCode?: string | null, stediPartnerId?: string | null, defaultContactPerson?: { __typename?: 'ContactPersonEntity', uuid: string } | null, customerFields?: { __typename?: 'CustomerFieldsEntity', defaultAddressUuid?: string | null, businessDivisionUuid?: string | null, invoiceOrOrderIdentifier?: string | null, defaultInboundEdiServiceUuid?: string | null, defaultOutboundEdiServiceUuid?: string | null, defaultInboundOutboundEdiServiceUuid?: string | null, defaultServiceUuid?: string | null, showEdiReferenceNumbersOnOrderPage: boolean, defaultOrdinaryTariffChainId?: string | null, defaultLineHaulTariffChainId?: string | null, defaultTransferTariffChainId?: string | null, defaultPointToPointTariffChainId?: string | null, defaultFuelSurcharge?: number | null, defaultDimFactor?: number | null, defaultUseTariff: boolean, isPrepaidOnly: boolean, useCustomVehicleTypes: boolean, enableCustomerPortalOrderEntry: boolean, services: Array<{ __typename?: 'CustomerServiceEntity', uuid: string }>, customerVehicleTypes: Array<{ __typename?: 'CustomerVehicleTypeEntity', id: string, vehicleTypeUuid: string }>, referenceNumberLabels: Array<{ __typename?: 'CustomerReferenceNumberLabelEntity', name: string }> } | null } } | { __typename?: 'MutationErrorOutput', message: string } };

export type OrganizationAddressFragment = { __typename?: 'AddressEntity', uuid: string, name: string, line1: string, line2?: string | null, city: string, state: string, zip: string, country: string, driverInstructions?: string | null };

export type OrganizationAgentTerminalFragment = { __typename?: 'TerminalEntity', uuid: string, name: string, code: string, serviceRegion?: { __typename?: 'ServiceRegionEntity', id: string, name: string } | null, address: { __typename?: 'AddressEntity', uuid: string, name: string, line1: string, line2?: string | null, city: string, state: string, zip: string, country: string, driverInstructions?: string | null } };

export type OrganizationForAddressBookQueryVariables = Exact<{
  input: FindOrganizationInput;
}>;


export type OrganizationForAddressBookQuery = { __typename?: 'Query', organization: { __typename?: 'OrganizationEntity', addresses: Array<{ __typename?: 'AddressEntity', uuid: string, name: string, line1: string, line2?: string | null, city: string, state: string, zip: string, country: string, driverInstructions?: string | null }>, agentFields?: { __typename?: 'AgentFieldsEntity', activeTerminals: Array<{ __typename?: 'TerminalEntity', uuid: string, name: string, code: string, serviceRegion?: { __typename?: 'ServiceRegionEntity', id: string, name: string } | null, address: { __typename?: 'AddressEntity', uuid: string, name: string, line1: string, line2?: string | null, city: string, state: string, zip: string, country: string, driverInstructions?: string | null } }> } | null } };

export type OrganizationForFrontendHookQueryVariables = Exact<{
  input: FindOrganizationInput;
}>;


export type OrganizationForFrontendHookQuery = { __typename?: 'Query', organization: { __typename?: 'OrganizationEntity', isActive: boolean, types: Array<OrganizationType>, addresses: Array<{ __typename?: 'AddressEntity', uuid: string, line1: string, city: string }>, contactPersons: Array<{ __typename?: 'ContactPersonEntity', uuid: string, firstName?: string | null, lastName?: string | null }> } };

export type AddressForOrganizationFragment = { __typename?: 'AddressEntity', uuid: string, line1: string, city: string };

export type ContactPersonForOrganizationFragment = { __typename?: 'ContactPersonEntity', uuid: string, firstName?: string | null, lastName?: string | null };

export type OrganizationNotesQueryVariables = Exact<{
  findOrganizationNotesInput: FindOrganizationNotesInput;
}>;


export type OrganizationNotesQuery = { __typename?: 'Query', organizationNotes: Array<{ __typename?: 'ContactCommentEntity', uuid: string, createdAt: any, updatedAt: any, comment: string, authorName: string }> };

export type OrganizationFragment = { __typename?: 'OrganizationEntity', isActive: boolean, uuid: string, name: string, types: Array<OrganizationType>, referenceNumber?: string | null, email?: string | null, isaId?: string | null, ediApplicationId?: string | null, ediContactCode?: string | null, stediPartnerId?: string | null, defaultContactPerson?: { __typename?: 'ContactPersonEntity', uuid: string } | null, customerFields?: { __typename?: 'CustomerFieldsEntity', defaultAddressUuid?: string | null, businessDivisionUuid?: string | null, invoiceOrOrderIdentifier?: string | null, defaultInboundEdiServiceUuid?: string | null, defaultOutboundEdiServiceUuid?: string | null, defaultInboundOutboundEdiServiceUuid?: string | null, defaultServiceUuid?: string | null, showEdiReferenceNumbersOnOrderPage: boolean, defaultOrdinaryTariffChainId?: string | null, defaultLineHaulTariffChainId?: string | null, defaultTransferTariffChainId?: string | null, defaultPointToPointTariffChainId?: string | null, defaultFuelSurcharge?: number | null, defaultDimFactor?: number | null, defaultUseTariff: boolean, isPrepaidOnly: boolean, useCustomVehicleTypes: boolean, enableCustomerPortalOrderEntry: boolean, services: Array<{ __typename?: 'CustomerServiceEntity', uuid: string }>, customerVehicleTypes: Array<{ __typename?: 'CustomerVehicleTypeEntity', id: string, vehicleTypeUuid: string }>, referenceNumberLabels: Array<{ __typename?: 'CustomerReferenceNumberLabelEntity', name: string }> } | null };

export type OrganizationQueryVariables = Exact<{
  input: FindOrganizationInput;
}>;


export type OrganizationQuery = { __typename?: 'Query', organization: { __typename?: 'OrganizationEntity', isActive: boolean, uuid: string, name: string, types: Array<OrganizationType>, referenceNumber?: string | null, email?: string | null, isaId?: string | null, ediApplicationId?: string | null, ediContactCode?: string | null, stediPartnerId?: string | null, defaultContactPerson?: { __typename?: 'ContactPersonEntity', uuid: string } | null, customerFields?: { __typename?: 'CustomerFieldsEntity', defaultAddressUuid?: string | null, businessDivisionUuid?: string | null, invoiceOrOrderIdentifier?: string | null, defaultInboundEdiServiceUuid?: string | null, defaultOutboundEdiServiceUuid?: string | null, defaultInboundOutboundEdiServiceUuid?: string | null, defaultServiceUuid?: string | null, showEdiReferenceNumbersOnOrderPage: boolean, defaultOrdinaryTariffChainId?: string | null, defaultLineHaulTariffChainId?: string | null, defaultTransferTariffChainId?: string | null, defaultPointToPointTariffChainId?: string | null, defaultFuelSurcharge?: number | null, defaultDimFactor?: number | null, defaultUseTariff: boolean, isPrepaidOnly: boolean, useCustomVehicleTypes: boolean, enableCustomerPortalOrderEntry: boolean, services: Array<{ __typename?: 'CustomerServiceEntity', uuid: string }>, customerVehicleTypes: Array<{ __typename?: 'CustomerVehicleTypeEntity', id: string, vehicleTypeUuid: string }>, referenceNumberLabels: Array<{ __typename?: 'CustomerReferenceNumberLabelEntity', name: string }> } | null } };

export type PaginatedOrganizationFragment = { __typename?: 'OrganizationEntity', name: string, uuid: string, referenceNumber?: string | null, types: Array<OrganizationType> };

export type PaginatedOrganizationsQueryVariables = Exact<{
  findPaginatedOrganizationsInput: FindPaginatedOrganizationsInput;
}>;


export type PaginatedOrganizationsQuery = { __typename?: 'Query', paginatedOrganizations: { __typename?: 'OrganizationConnection', totalCount?: number | null, edges: Array<{ __typename?: 'OrganizationEdge', node: { __typename?: 'OrganizationEntity', name: string, uuid: string, referenceNumber?: string | null, types: Array<OrganizationType> } }>, pageInfo: { __typename?: 'PageInfo', startCursor?: string | null, endCursor?: string | null, hasNextPage: boolean, hasPreviousPage: boolean } } };

export type RestoreOrganizationMutationVariables = Exact<{
  input: RestoreOrganizationInput;
}>;


export type RestoreOrganizationMutation = { __typename?: 'Mutation', restoreOrganization: { __typename?: 'MutationErrorOutput', message: string } | { __typename?: 'RestoreOrganizationSuccessOutput', organization: { __typename?: 'OrganizationEntity', isActive: boolean, uuid: string, name: string, types: Array<OrganizationType>, referenceNumber?: string | null, email?: string | null, isaId?: string | null, ediApplicationId?: string | null, ediContactCode?: string | null, stediPartnerId?: string | null, defaultContactPerson?: { __typename?: 'ContactPersonEntity', uuid: string } | null, customerFields?: { __typename?: 'CustomerFieldsEntity', defaultAddressUuid?: string | null, businessDivisionUuid?: string | null, invoiceOrOrderIdentifier?: string | null, defaultInboundEdiServiceUuid?: string | null, defaultOutboundEdiServiceUuid?: string | null, defaultInboundOutboundEdiServiceUuid?: string | null, defaultServiceUuid?: string | null, showEdiReferenceNumbersOnOrderPage: boolean, defaultOrdinaryTariffChainId?: string | null, defaultLineHaulTariffChainId?: string | null, defaultTransferTariffChainId?: string | null, defaultPointToPointTariffChainId?: string | null, defaultFuelSurcharge?: number | null, defaultDimFactor?: number | null, defaultUseTariff: boolean, isPrepaidOnly: boolean, useCustomVehicleTypes: boolean, enableCustomerPortalOrderEntry: boolean, services: Array<{ __typename?: 'CustomerServiceEntity', uuid: string }>, customerVehicleTypes: Array<{ __typename?: 'CustomerVehicleTypeEntity', id: string, vehicleTypeUuid: string }>, referenceNumberLabels: Array<{ __typename?: 'CustomerReferenceNumberLabelEntity', name: string }> } | null } } };

export type UpdateOrganizationMutationVariables = Exact<{
  input: UpdateOrganizationInput;
}>;


export type UpdateOrganizationMutation = { __typename?: 'Mutation', updateOrganization: { __typename?: 'MutationErrorOutput', message: string } | { __typename?: 'UpdateOrganizationSuccessOutput', organization: { __typename?: 'OrganizationEntity', isActive: boolean, uuid: string, name: string, types: Array<OrganizationType>, referenceNumber?: string | null, email?: string | null, isaId?: string | null, ediApplicationId?: string | null, ediContactCode?: string | null, stediPartnerId?: string | null, defaultContactPerson?: { __typename?: 'ContactPersonEntity', uuid: string } | null, customerFields?: { __typename?: 'CustomerFieldsEntity', defaultAddressUuid?: string | null, businessDivisionUuid?: string | null, invoiceOrOrderIdentifier?: string | null, defaultInboundEdiServiceUuid?: string | null, defaultOutboundEdiServiceUuid?: string | null, defaultInboundOutboundEdiServiceUuid?: string | null, defaultServiceUuid?: string | null, showEdiReferenceNumbersOnOrderPage: boolean, defaultOrdinaryTariffChainId?: string | null, defaultLineHaulTariffChainId?: string | null, defaultTransferTariffChainId?: string | null, defaultPointToPointTariffChainId?: string | null, defaultFuelSurcharge?: number | null, defaultDimFactor?: number | null, defaultUseTariff: boolean, isPrepaidOnly: boolean, useCustomVehicleTypes: boolean, enableCustomerPortalOrderEntry: boolean, services: Array<{ __typename?: 'CustomerServiceEntity', uuid: string }>, customerVehicleTypes: Array<{ __typename?: 'CustomerVehicleTypeEntity', id: string, vehicleTypeUuid: string }>, referenceNumberLabels: Array<{ __typename?: 'CustomerReferenceNumberLabelEntity', name: string }> } | null } } };

export type CreateDispatchViewMutationVariables = Exact<{
  input: DispatchViewCreateInput;
}>;


export type CreateDispatchViewMutation = { __typename?: 'Mutation', createDispatchView: { __typename: 'DispatchViewCreateSuccessOutput', dispatchView: { __typename?: 'DispatchViewEntity', id: string } } | { __typename: 'MutationErrorOutput', message: string } };

export type DispatchViewsQueryVariables = Exact<{ [key: string]: never; }>;


export type DispatchViewsQuery = { __typename?: 'Query', dispatchViews: Array<{ __typename?: 'DispatchViewEntity', id: string, name: string, tabIndex: number, useMinimizedAppointmentTime: boolean, numberOfStops: number, showCompleteStops: boolean, routeCardStopTableColumnWidths?: any | null, routeCardWidth: number, routeCardStopTableFields: Array<DispatchTableField>, dispatchTableColors: Array<{ __typename?: 'DispatchTableColorEntity', uuid: string, fields: Array<DispatchTableColorField>, appointmentStartWithinMinutes?: number | null, appointmentEndWithinMinutes?: number | null, deadlineDateFilter?: DeadlineDateFilter | null, hasAppointmentDate?: boolean | null, isSpecial?: boolean | null, color: string, active: boolean, service?: { __typename?: 'ServiceEntity', uuid: string, name: string } | null }> }> };

export type RemoveDispatchViewMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type RemoveDispatchViewMutation = { __typename?: 'Mutation', removeDispatchView: { __typename?: 'DispatchViewEntity', id: string } };

export type UpdateDispatchViewMutationVariables = Exact<{
  input: DispatchViewUpdateInput;
}>;


export type UpdateDispatchViewMutation = { __typename?: 'Mutation', updateDispatchView: { __typename: 'DispatchViewUpdateSuccessOutput', dispatchView: { __typename?: 'DispatchViewEntity', id: string } } | { __typename: 'MutationErrorOutput', message: string } };

export type DriversForSelectionQueryVariables = Exact<{ [key: string]: never; }>;


export type DriversForSelectionQuery = { __typename?: 'Query', drivers: Array<{ __typename?: 'DriverEntity', uuid: string, firstName: string, lastName: string, driverType?: DriverType | null, driverReferenceNumber?: string | null, active: boolean, terminal?: { __typename?: 'TerminalEntity', uuid: string, name: string } | null, defaultVehicle?: { __typename?: 'EquipmentEntity', uuid: string, name: string, vehicleType?: { __typename?: 'VehicleTypeEntity', uuid: string, name: string, maxVolume?: any | null, maxWeight?: any | null } | null } | null }> };

export type GenerateRoutesPreviewRouteFragment = { __typename?: 'RouteGenerationPreviewEntity', stops: Array<{ __typename?: 'StopPreviewForRouteGenerationEntity', odometer: number, eta: any, stop: { __typename?: 'StandardStopEntity', uuid: string, appointmentTime?: any | null, endAppointmentTime?: any | null, isSpecial?: boolean | null, status: StopStatus, stopType?: StopType | null, stopDetails?: { __typename?: 'StopDetailsOutput', message?: string | null, stopDetailsStatus: StopDetailsStatus } | null, shipment?: { __typename?: 'StandardShipmentEntity', standardShipmentFields: { __typename?: 'StandardShipmentFieldsEntity', deadlineDate?: any | null, pickupOrDelivery: PickupOrDelivery }, order?: { __typename?: 'StandardOrderEntity', uuid: string, weight: number, service?: { __typename?: 'ServiceEntity', uuid: string } | null, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', shipperBillOfLadingNumber?: string | null } } | null } | null, address: { __typename?: 'AddressEntity', name: string, line1: string, city: string, zip: string, latitude?: number | null, longitude?: number | null } } }>, equipment?: { __typename?: 'EquipmentEntity', uuid: string, name: string, vehicleType?: { __typename?: 'VehicleTypeEntity', name: string } | null } | null, driver: { __typename?: 'DriverEntity', uuid: string, firstName: string, lastName: string, driverReferenceNumber?: string | null } };

export type GenerateRoutesQueryVariables = Exact<{
  generateRoutesInput: GenerateRoutesInput;
}>;


export type GenerateRoutesQuery = { __typename?: 'Query', generateRoutes: { __typename?: 'GenerateRoutesOutput', unassignedStopUuids?: Array<string> | null, errorMessage?: string | null, routes?: Array<{ __typename?: 'RouteGenerationPreviewEntity', stops: Array<{ __typename?: 'StopPreviewForRouteGenerationEntity', odometer: number, eta: any, stop: { __typename?: 'StandardStopEntity', uuid: string, appointmentTime?: any | null, endAppointmentTime?: any | null, isSpecial?: boolean | null, status: StopStatus, stopType?: StopType | null, stopDetails?: { __typename?: 'StopDetailsOutput', message?: string | null, stopDetailsStatus: StopDetailsStatus } | null, shipment?: { __typename?: 'StandardShipmentEntity', standardShipmentFields: { __typename?: 'StandardShipmentFieldsEntity', deadlineDate?: any | null, pickupOrDelivery: PickupOrDelivery }, order?: { __typename?: 'StandardOrderEntity', uuid: string, weight: number, service?: { __typename?: 'ServiceEntity', uuid: string } | null, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', shipperBillOfLadingNumber?: string | null } } | null } | null, address: { __typename?: 'AddressEntity', name: string, line1: string, city: string, zip: string, latitude?: number | null, longitude?: number | null } } }>, equipment?: { __typename?: 'EquipmentEntity', uuid: string, name: string, vehicleType?: { __typename?: 'VehicleTypeEntity', name: string } | null } | null, driver: { __typename?: 'DriverEntity', uuid: string, firstName: string, lastName: string, driverReferenceNumber?: string | null } }> | null } };

export type DispatchTableColorFragment = { __typename?: 'DispatchTableColorEntity', uuid: string, fields: Array<DispatchTableColorField>, appointmentStartWithinMinutes?: number | null, appointmentEndWithinMinutes?: number | null, deadlineDateFilter?: DeadlineDateFilter | null, hasAppointmentDate?: boolean | null, isSpecial?: boolean | null, color: string, active: boolean, service?: { __typename?: 'ServiceEntity', uuid: string, name: string } | null };

export type DispatchTableColorsQueryVariables = Exact<{ [key: string]: never; }>;


export type DispatchTableColorsQuery = { __typename?: 'Query', dispatchTableColors: Array<{ __typename?: 'DispatchTableColorEntity', uuid: string, fields: Array<DispatchTableColorField>, appointmentStartWithinMinutes?: number | null, appointmentEndWithinMinutes?: number | null, deadlineDateFilter?: DeadlineDateFilter | null, hasAppointmentDate?: boolean | null, isSpecial?: boolean | null, color: string, active: boolean, service?: { __typename?: 'ServiceEntity', uuid: string, name: string } | null }> };

export type UpdateDispatchTableColorsMutationVariables = Exact<{
  input: UpdateDispatchTableColorsInput;
}>;


export type UpdateDispatchTableColorsMutation = { __typename?: 'Mutation', updateDispatchTableColors: { __typename: 'MutationErrorOutput', message: string } | { __typename: 'UpdateDispatchTableColorsSuccessOutput' } };

export type CreateRouteSlotMutationVariables = Exact<{
  routeSlotCreateInput: RouteSlotCreateInput;
  routeUuid: Scalars['String']['input'];
}>;


export type CreateRouteSlotMutation = { __typename?: 'Mutation', createRouteSlot: Array<{ __typename?: 'RouteSlotEntity', uuid: string } | null> };

export type DriverFragment = { __typename?: 'DriverEntity', firstName: string, lastName: string, uuid: string, driverType?: DriverType | null, driverReferenceNumber?: string | null, defaultFuelSettlementPercentageRate?: number | null, user: { __typename?: 'UserEntity', name?: string | null }, defaultVehicle?: { __typename?: 'EquipmentEntity', uuid: string } | null, terminal?: { __typename?: 'TerminalEntity', uuid: string, name: string } | null, qualifications: Array<{ __typename?: 'DriverQualificationEntity', id: string }> };

export type DriversQueryVariables = Exact<{
  active?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type DriversQuery = { __typename?: 'Query', drivers: Array<{ __typename?: 'DriverEntity', firstName: string, lastName: string, uuid: string, driverType?: DriverType | null, driverReferenceNumber?: string | null, defaultFuelSettlementPercentageRate?: number | null, user: { __typename?: 'UserEntity', name?: string | null }, defaultVehicle?: { __typename?: 'EquipmentEntity', uuid: string } | null, terminal?: { __typename?: 'TerminalEntity', uuid: string, name: string } | null, qualifications: Array<{ __typename?: 'DriverQualificationEntity', id: string }> }> };

export type DriversWithRoutesQueryVariables = Exact<{
  date: Scalars['DateTime']['input'];
}>;


export type DriversWithRoutesQuery = { __typename?: 'Query', drivers: Array<{ __typename?: 'DriverEntity', firstName: string, lastName: string, uuid: string, driverType?: DriverType | null, driverReferenceNumber?: string | null, defaultFuelSettlementPercentageRate?: number | null, route?: { __typename?: 'RouteEntity', uuid: string } | null, user: { __typename?: 'UserEntity', name?: string | null }, defaultVehicle?: { __typename?: 'EquipmentEntity', uuid: string } | null, terminal?: { __typename?: 'TerminalEntity', uuid: string, name: string } | null, qualifications: Array<{ __typename?: 'DriverQualificationEntity', id: string }> }> };

export type GetOptimizationResultsQueryVariables = Exact<{
  routeOptimizationUuid: Scalars['String']['input'];
}>;


export type GetOptimizationResultsQuery = { __typename?: 'Query', getOptimizationResults?: { __typename?: 'OptimizationResultsOutput', slots?: Array<string> | null, error?: string | null } | null };

export type GroupByStopsQueryVariables = Exact<{
  groupByStopsInput: GroupByStopsInput;
}>;


export type GroupByStopsQuery = { __typename?: 'Query', groupByStops: { __typename: 'GroupByStopsOutput', count?: number | null, rows: { __typename: 'GroupsOutput', groupValues: Array<string | null> } | { __typename: 'StopOutput', stopValues: Array<{ __typename?: 'GroupByStopEntity', ADDRESS: string, ADDRESS_TYPE?: string | null, APPOINTMENT?: any | null, APPOINTMENT_SCHEDULED?: boolean | null, APPOINTMENT_DATE?: any | null, APPOINTMENT_REQUIRED?: boolean | null, APPOINTMENT_TIME?: any | null, BUSINESS_DIVISION?: string | null, CITY?: string | null, CONSIGNEE?: string | null, CUSTOMER?: string | null, DIMS?: string | null, DUE_DATE?: any | null, INBOUND_NAME?: string | null, INBOUND_CITY?: string | null, INBOUND_METHOD?: InboundMethod | null, INBOUND_TERMINAL?: string | null, INBOUND_ZIP?: string | null, MAWB?: string | null, ORDER_NAME?: string | null, ORDER_NOTES?: string | null, ORDER_NUMBER: string, SERVICE_LEVEL?: string | null, orderUuid: string, OUTBOUND_NAME?: string | null, OUTBOUND_CITY?: string | null, OUTBOUND_METHOD?: OutboundMethod | null, OUTBOUND_TERMINAL?: string | null, OUTBOUND_ZIP?: string | null, PIECE_COUNT?: number | null, REF_NUMBER?: Array<string> | null, ROUTE_NAME?: string | null, SERVICE_DATE?: any | null, SERVICE_TIME?: any | null, SPECIAL?: boolean | null, SPECIAL_INSTRUCTIONS?: string | null, ORDER_STATUS?: string | null, STOP_TYPE?: string | null, TAGS?: Array<string> | null, TERMINAL?: string | null, TOTAL_CHARGES?: number | null, uuid: string, VEHICLE_TYPE_NAME?: string | null, WEIGHT?: number | null, ZIP_CODE?: string | null, orderNumberCellColor?: string | null, stopDetails?: { __typename?: 'StopDetailsOutput', message?: string | null, stopDetailsStatus: StopDetailsStatus } | null } | null> } } };

export type NumberOfStopsQueryVariables = Exact<{
  appointmentRequired?: InputMaybe<Scalars['Boolean']['input']>;
  tagUuids?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  hideOnHold?: InputMaybe<Scalars['Boolean']['input']>;
  hideStopsWithoutAddress?: InputMaybe<Scalars['Boolean']['input']>;
  isAssigned?: InputMaybe<Scalars['Boolean']['input']>;
  previouslyAttempted?: InputMaybe<Scalars['Boolean']['input']>;
  serviceLevelUuids?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  onHand?: InputMaybe<Scalars['Boolean']['input']>;
  standardStopTypes?: InputMaybe<Array<StandardStopType> | StandardStopType>;
  statuses?: InputMaybe<Array<StopStatus> | StopStatus>;
  orderStatuses?: InputMaybe<Array<OrderStatus> | OrderStatus>;
  customerUuid?: InputMaybe<Scalars['String']['input']>;
  createdAtFilters?: InputMaybe<DateFilterStartEnd>;
  deadlineDateFilters?: InputMaybe<DateFilterStartEnd>;
  serviceDateFilters?: InputMaybe<DateFilterStartEnd>;
  appointmentTimeFilters?: InputMaybe<DateFilterStartEnd>;
  transferPending?: InputMaybe<Scalars['Boolean']['input']>;
  pickupOrDeliveryTypes?: InputMaybe<Array<PickupOrDelivery> | PickupOrDelivery>;
  requiresRecovery?: InputMaybe<Scalars['Boolean']['input']>;
  hasAppointment?: InputMaybe<Scalars['Boolean']['input']>;
  warehouseUuid?: InputMaybe<Scalars['String']['input']>;
  terminalUuid?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<Array<FindStopsFiltersInput> | FindStopsFiltersInput>;
  useCache?: InputMaybe<Scalars['Boolean']['input']>;
  includeCount?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type NumberOfStopsQuery = { __typename?: 'Query', numberOfStops: number };

export type RouteEtaQueryVariables = Exact<{
  uuid: Scalars['String']['input'];
}>;


export type RouteEtaQuery = { __typename?: 'Query', route: { __typename?: 'RouteEntity', uuid: string, etas: Array<{ __typename?: 'EtaEntity', arrivalTime: any, finishTime: any }> } };

export type AssignHelperToRouteMutationVariables = Exact<{
  helperUuid: Scalars['String']['input'];
  routeUuid: Scalars['String']['input'];
}>;


export type AssignHelperToRouteMutation = { __typename?: 'Mutation', assignHelperToRoute: Array<{ __typename?: 'DriverOnRouteEntity', uuid: string }> };

export type CreateAppointmentsForRouteMutationVariables = Exact<{
  uuid: Scalars['String']['input'];
}>;


export type CreateAppointmentsForRouteMutation = { __typename?: 'Mutation', createAppointmentsForRoute: { __typename?: 'RouteEntity', createdAt: any, date: any, uuid: string, defaultStartTime?: any | null, totalTimeInSeconds?: number | null, totalDistanceInMeters?: number | null, startLoadTimeInMinutes?: number | null, endLoadTimeInMinutes?: number | null, locked: boolean, nameManuallyChanged: boolean, name: string, numberOfRescheduled?: number | null, routeSlotsUpdatedAt?: any | null, lastDispatched?: any | null, terminal?: { __typename?: 'TerminalEntity', uuid: string } | null, routeInfo: { __typename?: 'RouteInfo', totalStops: number, totalStopsArrived: number, totalStopsNotArrived: number, totalStopsCompleted: number, totalStopsCancelled: number, totalStopsFailed: number, status: RouteStatus, pieceCount: number, totalWeight: number, totalStopsSentToAgent: number, totalStopsConfirmedByAgent: number }, helpers: Array<{ __typename?: 'DriverEntity', firstName: string, lastName: string, uuid: string, phoneNumber: string, driverReferenceNumber?: string | null }>, equipments: Array<{ __typename?: 'EquipmentEntity', uuid: string, name: string, type: EquipmentType, vehicleType?: { __typename?: 'VehicleTypeEntity', uuid: string, name: string, status: VehicleTypeStatus, maxVolume?: any | null, maxWeight?: any | null, capacityNotes?: string | null, vehicleTypePackageSpecs: Array<{ __typename?: 'VehicleTypePackageSpecEntity', id: string, maxQuantity?: number | null, packageSpec: { __typename?: 'PackageSpecEntity', id: string, name: string } }> } | null }>, tags: Array<{ __typename?: 'TagEntity', uuid: string, value: string, color?: string | null }>, drivers: Array<{ __typename?: 'DriverEntity', uuid: string, firstName: string, lastName: string, phoneNumber: string, driverReferenceNumber?: string | null, agentId?: string | null, terminal?: { __typename?: 'TerminalEntity', uuid: string, name: string } | null }>, slots: Array<{ __typename?: 'RouteSlotEntity', uuid: string, stops: Array<{ __typename: 'StandardStopEntity', stopType?: StopType | null, standardStopType?: StandardStopType | null, inboundMethod?: InboundMethod | null, outboundMethod?: OutboundMethod | null, notes?: string | null, isSpecial?: boolean | null, proofOfDeliverySignee?: string | null, status: StopStatus, sentToAgentAt?: any | null, confirmedByAgentAt?: any | null, appointmentTextStatus?: AppointmentTextStatus | null, specialInstructions?: string | null, paperworkMarkedComplete?: boolean | null, showDriverModifiedAt?: any | null, routeChangeAcknowledged: boolean, serviceDate?: any | null, overrideServiceTimeInMinutes?: number | null, completedAt?: any | null, uuid: string, appointmentTime?: any | null, endAppointmentTime?: any | null, routeSlot?: { __typename?: 'RouteSlotEntity', uuid: string, ordinal: number, route?: { __typename?: 'RouteEntity', uuid: string, name: string } | null } | null, stopDetails?: { __typename?: 'StopDetailsOutput', stopDetailsStatus: StopDetailsStatus, message?: string | null } | null, cachedEta?: { __typename?: 'EtaEntity', arrivalTime: any, finishTime: any } | null, contactPerson?: { __typename?: 'ContactPersonEntity', firstName?: string | null, lastName?: string | null, phone?: string | null } | null, address: { __typename?: 'AddressEntity', uuid: string, name: string, line1: string, line2?: string | null, city: string, state: string, zip: string, country: string, latitude?: number | null, longitude?: number | null, driverInstructions?: string | null, receivingHoursStart?: any | null, receivingHoursEnd?: any | null, specialInstructions?: string | null }, shipment?: { __typename?: 'StandardShipmentEntity', uuid: string, hasSignedPOD: boolean, shipmentType: ShipmentType, standardShipmentFields: { __typename?: 'StandardShipmentFieldsEntity', uuid: string, deliveryDate?: any | null, pickupOrDelivery: PickupOrDelivery, deadlineDate?: any | null, deadlineType?: DeadlineType | null }, order?: { __typename?: 'StandardOrderEntity', uuid: string, refusedBy?: string | null, isCollectOnDelivery?: boolean | null, orderSegmentType: OrderSegmentType, fulfillmentType?: FulfillmentType | null, detailedStatusV2?: OrderDetailedStatus | null, hazmat?: boolean | null, name: string, refNumbers: Array<string>, dateMarkedOnHand?: any | null, totalCharge: number, startStop?: { __typename?: 'StandardStopEntity', terminal?: { __typename?: 'TerminalEntity', name: string } | null } | null, endStop?: { __typename?: 'StandardStopEntity', terminal?: { __typename?: 'TerminalEntity', name: string } | null } | null, tags: Array<{ __typename?: 'TagEntity', uuid: string, value: string, color?: string | null }>, service?: { __typename?: 'ServiceEntity', uuid: string, name: string, timeInMinutes?: number | null } | null, orderComments: Array<{ __typename?: 'OrderCommentEntity', comment: string }>, shipments: Array<{ __typename?: 'StandardShipmentEntity', shipmentType: ShipmentType, uuid: string, standardShipmentFields: { __typename?: 'StandardShipmentFieldsEntity', pickupOrDelivery: PickupOrDelivery }, airportInfo?: { __typename?: 'AirportInfoEntity', address: { __typename?: 'AddressEntity', name: string } } | null, legs: Array<{ __typename?: 'LegEntity', endStop: { __typename?: 'StandardStopEntity', stopType?: StopType | null, incomingCarrier?: string | null, inboundMethod?: InboundMethod | null, address: { __typename?: 'AddressEntity', name: string }, terminal?: { __typename?: 'TerminalEntity', name: string } | null } }> }>, packages: Array<{ __typename?: 'PackageEntity', uuid: string, description: string, weight?: number | null, quantity: number, length?: number | null, width?: number | null, height?: number | null, type?: PackageType | null, packageSpec?: { __typename?: 'PackageSpecEntity', id: string, name: string } | null, warehouseLocation?: { __typename?: 'WarehouseLocationEntity', name: string } | null }>, billingPartyContact: { __typename?: 'CustomerContactEntity', displayName: string, businessDivision?: { __typename?: 'BusinessDivisionEntity', name: string } | null }, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', shipperBillOfLadingNumber?: string | null, masterAirwayBillOfLadingNumber?: string | null, measurementUnits: MeasurementUnits }, inboundPaperwork: { __typename?: 'OrderPaperworkEntity', paperworkComplete: boolean, attachedDocuments?: Array<DocumentType> | null, missingDocuments?: Array<DocumentType> | null, alerts?: Array<DocumentType> | null, proofOfDeliveryOrPickupReadyToSign?: Array<DocumentType> | null, proofOfDeliveryOrPickupSigned?: Array<DocumentType> | null, photos?: Array<DocumentType> | null, other?: Array<DocumentType> | null }, outboundPaperwork: { __typename?: 'OrderPaperworkEntity', paperworkComplete: boolean, attachedDocuments?: Array<DocumentType> | null, missingDocuments?: Array<DocumentType> | null, alerts?: Array<DocumentType> | null, proofOfDeliveryOrPickupReadyToSign?: Array<DocumentType> | null, proofOfDeliveryOrPickupSigned?: Array<DocumentType> | null, photos?: Array<DocumentType> | null, other?: Array<DocumentType> | null } } | null } | null }> }> } };

export type CreateRoutePathsMutationVariables = Exact<{
  routePathsCreateInput: RoutePathsCreateInput;
}>;


export type CreateRoutePathsMutation = { __typename?: 'Mutation', createRoutePaths: Array<{ __typename?: 'RoutePathEntity', uuid: string, coordinates?: Array<Array<number>> | null, route: { __typename?: 'RouteEntity', uuid: string } } | null> };

export type CreateRoutesMutationVariables = Exact<{
  createRoutesInput: CreateRoutesInput;
}>;


export type CreateRoutesMutation = { __typename?: 'Mutation', createRoutes: Array<{ __typename?: 'RouteEntity', createdAt: any, date: any, uuid: string, defaultStartTime?: any | null, totalTimeInSeconds?: number | null, totalDistanceInMeters?: number | null, startLoadTimeInMinutes?: number | null, endLoadTimeInMinutes?: number | null, locked: boolean, nameManuallyChanged: boolean, name: string, numberOfRescheduled?: number | null, routeSlotsUpdatedAt?: any | null, lastDispatched?: any | null, terminal?: { __typename?: 'TerminalEntity', uuid: string } | null, routeInfo: { __typename?: 'RouteInfo', totalStops: number, totalStopsArrived: number, totalStopsNotArrived: number, totalStopsCompleted: number, totalStopsCancelled: number, totalStopsFailed: number, status: RouteStatus, pieceCount: number, totalWeight: number, totalStopsSentToAgent: number, totalStopsConfirmedByAgent: number }, helpers: Array<{ __typename?: 'DriverEntity', firstName: string, lastName: string, uuid: string, phoneNumber: string, driverReferenceNumber?: string | null }>, equipments: Array<{ __typename?: 'EquipmentEntity', uuid: string, name: string, type: EquipmentType, vehicleType?: { __typename?: 'VehicleTypeEntity', uuid: string, name: string, status: VehicleTypeStatus, maxVolume?: any | null, maxWeight?: any | null, capacityNotes?: string | null, vehicleTypePackageSpecs: Array<{ __typename?: 'VehicleTypePackageSpecEntity', id: string, maxQuantity?: number | null, packageSpec: { __typename?: 'PackageSpecEntity', id: string, name: string } }> } | null }>, tags: Array<{ __typename?: 'TagEntity', uuid: string, value: string, color?: string | null }>, drivers: Array<{ __typename?: 'DriverEntity', uuid: string, firstName: string, lastName: string, phoneNumber: string, driverReferenceNumber?: string | null, agentId?: string | null, terminal?: { __typename?: 'TerminalEntity', uuid: string, name: string } | null }>, slots: Array<{ __typename?: 'RouteSlotEntity', uuid: string, stops: Array<{ __typename: 'StandardStopEntity', stopType?: StopType | null, standardStopType?: StandardStopType | null, inboundMethod?: InboundMethod | null, outboundMethod?: OutboundMethod | null, notes?: string | null, isSpecial?: boolean | null, proofOfDeliverySignee?: string | null, status: StopStatus, sentToAgentAt?: any | null, confirmedByAgentAt?: any | null, appointmentTextStatus?: AppointmentTextStatus | null, specialInstructions?: string | null, paperworkMarkedComplete?: boolean | null, showDriverModifiedAt?: any | null, routeChangeAcknowledged: boolean, serviceDate?: any | null, overrideServiceTimeInMinutes?: number | null, completedAt?: any | null, uuid: string, appointmentTime?: any | null, endAppointmentTime?: any | null, routeSlot?: { __typename?: 'RouteSlotEntity', uuid: string, ordinal: number, route?: { __typename?: 'RouteEntity', uuid: string, name: string } | null } | null, stopDetails?: { __typename?: 'StopDetailsOutput', stopDetailsStatus: StopDetailsStatus, message?: string | null } | null, cachedEta?: { __typename?: 'EtaEntity', arrivalTime: any, finishTime: any } | null, contactPerson?: { __typename?: 'ContactPersonEntity', firstName?: string | null, lastName?: string | null, phone?: string | null } | null, address: { __typename?: 'AddressEntity', uuid: string, name: string, line1: string, line2?: string | null, city: string, state: string, zip: string, country: string, latitude?: number | null, longitude?: number | null, driverInstructions?: string | null, receivingHoursStart?: any | null, receivingHoursEnd?: any | null, specialInstructions?: string | null }, shipment?: { __typename?: 'StandardShipmentEntity', uuid: string, hasSignedPOD: boolean, shipmentType: ShipmentType, standardShipmentFields: { __typename?: 'StandardShipmentFieldsEntity', uuid: string, deliveryDate?: any | null, pickupOrDelivery: PickupOrDelivery, deadlineDate?: any | null, deadlineType?: DeadlineType | null }, order?: { __typename?: 'StandardOrderEntity', uuid: string, refusedBy?: string | null, isCollectOnDelivery?: boolean | null, orderSegmentType: OrderSegmentType, fulfillmentType?: FulfillmentType | null, detailedStatusV2?: OrderDetailedStatus | null, hazmat?: boolean | null, name: string, refNumbers: Array<string>, dateMarkedOnHand?: any | null, totalCharge: number, startStop?: { __typename?: 'StandardStopEntity', terminal?: { __typename?: 'TerminalEntity', name: string } | null } | null, endStop?: { __typename?: 'StandardStopEntity', terminal?: { __typename?: 'TerminalEntity', name: string } | null } | null, tags: Array<{ __typename?: 'TagEntity', uuid: string, value: string, color?: string | null }>, service?: { __typename?: 'ServiceEntity', uuid: string, name: string, timeInMinutes?: number | null } | null, orderComments: Array<{ __typename?: 'OrderCommentEntity', comment: string }>, shipments: Array<{ __typename?: 'StandardShipmentEntity', shipmentType: ShipmentType, uuid: string, standardShipmentFields: { __typename?: 'StandardShipmentFieldsEntity', pickupOrDelivery: PickupOrDelivery }, airportInfo?: { __typename?: 'AirportInfoEntity', address: { __typename?: 'AddressEntity', name: string } } | null, legs: Array<{ __typename?: 'LegEntity', endStop: { __typename?: 'StandardStopEntity', stopType?: StopType | null, incomingCarrier?: string | null, inboundMethod?: InboundMethod | null, address: { __typename?: 'AddressEntity', name: string }, terminal?: { __typename?: 'TerminalEntity', name: string } | null } }> }>, packages: Array<{ __typename?: 'PackageEntity', uuid: string, description: string, weight?: number | null, quantity: number, length?: number | null, width?: number | null, height?: number | null, type?: PackageType | null, packageSpec?: { __typename?: 'PackageSpecEntity', id: string, name: string } | null, warehouseLocation?: { __typename?: 'WarehouseLocationEntity', name: string } | null }>, billingPartyContact: { __typename?: 'CustomerContactEntity', displayName: string, businessDivision?: { __typename?: 'BusinessDivisionEntity', name: string } | null }, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', shipperBillOfLadingNumber?: string | null, masterAirwayBillOfLadingNumber?: string | null, measurementUnits: MeasurementUnits }, inboundPaperwork: { __typename?: 'OrderPaperworkEntity', paperworkComplete: boolean, attachedDocuments?: Array<DocumentType> | null, missingDocuments?: Array<DocumentType> | null, alerts?: Array<DocumentType> | null, proofOfDeliveryOrPickupReadyToSign?: Array<DocumentType> | null, proofOfDeliveryOrPickupSigned?: Array<DocumentType> | null, photos?: Array<DocumentType> | null, other?: Array<DocumentType> | null }, outboundPaperwork: { __typename?: 'OrderPaperworkEntity', paperworkComplete: boolean, attachedDocuments?: Array<DocumentType> | null, missingDocuments?: Array<DocumentType> | null, alerts?: Array<DocumentType> | null, proofOfDeliveryOrPickupReadyToSign?: Array<DocumentType> | null, proofOfDeliveryOrPickupSigned?: Array<DocumentType> | null, photos?: Array<DocumentType> | null, other?: Array<DocumentType> | null } } | null } | null }> }> }> };

export type DeleteSlotsFromRouteMutationVariables = Exact<{
  deleteSlotsFromRouteInput: DeleteSlotsFromRouteInput;
}>;


export type DeleteSlotsFromRouteMutation = { __typename?: 'Mutation', deleteSlotsFromRoute?: number | null };

export type DriversForHelpersQueryVariables = Exact<{
  date: Scalars['DateTime']['input'];
}>;


export type DriversForHelpersQuery = { __typename?: 'Query', drivers: Array<{ __typename?: 'DriverEntity', firstName: string, lastName: string, uuid: string, driverType?: DriverType | null, driverReferenceNumber?: string | null, defaultFuelSettlementPercentageRate?: number | null, route?: { __typename?: 'RouteEntity', uuid: string } | null, user: { __typename?: 'UserEntity', name?: string | null }, defaultVehicle?: { __typename?: 'EquipmentEntity', uuid: string } | null, terminal?: { __typename?: 'TerminalEntity', uuid: string, name: string } | null, qualifications: Array<{ __typename?: 'DriverQualificationEntity', id: string }> }> };

export type RunOptimizationMutationVariables = Exact<{
  createOptimizationRunInput: CreateOptimizationRunDto;
}>;


export type RunOptimizationMutation = { __typename?: 'Mutation', runOptimization: { __typename?: 'RouteOptimizationEntity', uuid: string } };

export type ReassignRouteSlotMutationVariables = Exact<{
  routeSlotReassignInput: RouteSlotReassignInput;
}>;


export type ReassignRouteSlotMutation = { __typename?: 'Mutation', reassignRouteSlot?: Array<{ __typename?: 'RouteEntity', createdAt: any, date: any, uuid: string, defaultStartTime?: any | null, totalTimeInSeconds?: number | null, totalDistanceInMeters?: number | null, startLoadTimeInMinutes?: number | null, endLoadTimeInMinutes?: number | null, locked: boolean, nameManuallyChanged: boolean, name: string, numberOfRescheduled?: number | null, routeSlotsUpdatedAt?: any | null, lastDispatched?: any | null, terminal?: { __typename?: 'TerminalEntity', uuid: string } | null, routeInfo: { __typename?: 'RouteInfo', totalStops: number, totalStopsArrived: number, totalStopsNotArrived: number, totalStopsCompleted: number, totalStopsCancelled: number, totalStopsFailed: number, status: RouteStatus, pieceCount: number, totalWeight: number, totalStopsSentToAgent: number, totalStopsConfirmedByAgent: number }, helpers: Array<{ __typename?: 'DriverEntity', firstName: string, lastName: string, uuid: string, phoneNumber: string, driverReferenceNumber?: string | null }>, equipments: Array<{ __typename?: 'EquipmentEntity', uuid: string, name: string, type: EquipmentType, vehicleType?: { __typename?: 'VehicleTypeEntity', uuid: string, name: string, status: VehicleTypeStatus, maxVolume?: any | null, maxWeight?: any | null, capacityNotes?: string | null, vehicleTypePackageSpecs: Array<{ __typename?: 'VehicleTypePackageSpecEntity', id: string, maxQuantity?: number | null, packageSpec: { __typename?: 'PackageSpecEntity', id: string, name: string } }> } | null }>, tags: Array<{ __typename?: 'TagEntity', uuid: string, value: string, color?: string | null }>, drivers: Array<{ __typename?: 'DriverEntity', uuid: string, firstName: string, lastName: string, phoneNumber: string, driverReferenceNumber?: string | null, agentId?: string | null, terminal?: { __typename?: 'TerminalEntity', uuid: string, name: string } | null }>, slots: Array<{ __typename?: 'RouteSlotEntity', uuid: string, stops: Array<{ __typename: 'StandardStopEntity', stopType?: StopType | null, standardStopType?: StandardStopType | null, inboundMethod?: InboundMethod | null, outboundMethod?: OutboundMethod | null, notes?: string | null, isSpecial?: boolean | null, proofOfDeliverySignee?: string | null, status: StopStatus, sentToAgentAt?: any | null, confirmedByAgentAt?: any | null, appointmentTextStatus?: AppointmentTextStatus | null, specialInstructions?: string | null, paperworkMarkedComplete?: boolean | null, showDriverModifiedAt?: any | null, routeChangeAcknowledged: boolean, serviceDate?: any | null, overrideServiceTimeInMinutes?: number | null, completedAt?: any | null, uuid: string, appointmentTime?: any | null, endAppointmentTime?: any | null, routeSlot?: { __typename?: 'RouteSlotEntity', uuid: string, ordinal: number, route?: { __typename?: 'RouteEntity', uuid: string, name: string } | null } | null, stopDetails?: { __typename?: 'StopDetailsOutput', stopDetailsStatus: StopDetailsStatus, message?: string | null } | null, cachedEta?: { __typename?: 'EtaEntity', arrivalTime: any, finishTime: any } | null, contactPerson?: { __typename?: 'ContactPersonEntity', firstName?: string | null, lastName?: string | null, phone?: string | null } | null, address: { __typename?: 'AddressEntity', uuid: string, name: string, line1: string, line2?: string | null, city: string, state: string, zip: string, country: string, latitude?: number | null, longitude?: number | null, driverInstructions?: string | null, receivingHoursStart?: any | null, receivingHoursEnd?: any | null, specialInstructions?: string | null }, shipment?: { __typename?: 'StandardShipmentEntity', uuid: string, hasSignedPOD: boolean, shipmentType: ShipmentType, standardShipmentFields: { __typename?: 'StandardShipmentFieldsEntity', uuid: string, deliveryDate?: any | null, pickupOrDelivery: PickupOrDelivery, deadlineDate?: any | null, deadlineType?: DeadlineType | null }, order?: { __typename?: 'StandardOrderEntity', uuid: string, refusedBy?: string | null, isCollectOnDelivery?: boolean | null, orderSegmentType: OrderSegmentType, fulfillmentType?: FulfillmentType | null, detailedStatusV2?: OrderDetailedStatus | null, hazmat?: boolean | null, name: string, refNumbers: Array<string>, dateMarkedOnHand?: any | null, totalCharge: number, startStop?: { __typename?: 'StandardStopEntity', terminal?: { __typename?: 'TerminalEntity', name: string } | null } | null, endStop?: { __typename?: 'StandardStopEntity', terminal?: { __typename?: 'TerminalEntity', name: string } | null } | null, tags: Array<{ __typename?: 'TagEntity', uuid: string, value: string, color?: string | null }>, service?: { __typename?: 'ServiceEntity', uuid: string, name: string, timeInMinutes?: number | null } | null, orderComments: Array<{ __typename?: 'OrderCommentEntity', comment: string }>, shipments: Array<{ __typename?: 'StandardShipmentEntity', shipmentType: ShipmentType, uuid: string, standardShipmentFields: { __typename?: 'StandardShipmentFieldsEntity', pickupOrDelivery: PickupOrDelivery }, airportInfo?: { __typename?: 'AirportInfoEntity', address: { __typename?: 'AddressEntity', name: string } } | null, legs: Array<{ __typename?: 'LegEntity', endStop: { __typename?: 'StandardStopEntity', stopType?: StopType | null, incomingCarrier?: string | null, inboundMethod?: InboundMethod | null, address: { __typename?: 'AddressEntity', name: string }, terminal?: { __typename?: 'TerminalEntity', name: string } | null } }> }>, packages: Array<{ __typename?: 'PackageEntity', uuid: string, description: string, weight?: number | null, quantity: number, length?: number | null, width?: number | null, height?: number | null, type?: PackageType | null, packageSpec?: { __typename?: 'PackageSpecEntity', id: string, name: string } | null, warehouseLocation?: { __typename?: 'WarehouseLocationEntity', name: string } | null }>, billingPartyContact: { __typename?: 'CustomerContactEntity', displayName: string, businessDivision?: { __typename?: 'BusinessDivisionEntity', name: string } | null }, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', shipperBillOfLadingNumber?: string | null, masterAirwayBillOfLadingNumber?: string | null, measurementUnits: MeasurementUnits }, inboundPaperwork: { __typename?: 'OrderPaperworkEntity', paperworkComplete: boolean, attachedDocuments?: Array<DocumentType> | null, missingDocuments?: Array<DocumentType> | null, alerts?: Array<DocumentType> | null, proofOfDeliveryOrPickupReadyToSign?: Array<DocumentType> | null, proofOfDeliveryOrPickupSigned?: Array<DocumentType> | null, photos?: Array<DocumentType> | null, other?: Array<DocumentType> | null }, outboundPaperwork: { __typename?: 'OrderPaperworkEntity', paperworkComplete: boolean, attachedDocuments?: Array<DocumentType> | null, missingDocuments?: Array<DocumentType> | null, alerts?: Array<DocumentType> | null, proofOfDeliveryOrPickupReadyToSign?: Array<DocumentType> | null, proofOfDeliveryOrPickupSigned?: Array<DocumentType> | null, photos?: Array<DocumentType> | null, other?: Array<DocumentType> | null } } | null } | null }> }> }> | null };

export type RemoveHelperFromRouteMutationVariables = Exact<{
  helperUuid: Scalars['String']['input'];
  routeUuid: Scalars['String']['input'];
}>;


export type RemoveHelperFromRouteMutation = { __typename?: 'Mutation', removeHelperFromRoute: string };

export type RemoveRouteMutationVariables = Exact<{
  uuid: Scalars['String']['input'];
}>;


export type RemoveRouteMutation = { __typename?: 'Mutation', removeRoute: { __typename?: 'RouteEntity', uuid: string } };

export type RouteInfoFragment = { __typename?: 'RouteInfo', totalStops: number, totalStopsArrived: number, totalStopsNotArrived: number, totalStopsCompleted: number, totalStopsCancelled: number, totalStopsFailed: number, status: RouteStatus, pieceCount: number, totalWeight: number, totalStopsSentToAgent: number, totalStopsConfirmedByAgent: number };

export type RoutePathByRouteQueryVariables = Exact<{
  uuid: Scalars['String']['input'];
}>;


export type RoutePathByRouteQuery = { __typename?: 'Query', route: { __typename?: 'RouteEntity', routePath?: { __typename?: 'RoutePathEntity', uuid: string, coordinates?: Array<Array<number>> | null, route: { __typename?: 'RouteEntity', uuid: string } } | null } };

export type RoutePathFragment = { __typename?: 'RoutePathEntity', uuid: string, coordinates?: Array<Array<number>> | null, route: { __typename?: 'RouteEntity', uuid: string } };

export type RoutePathsQueryVariables = Exact<{
  date: Scalars['DateTime']['input'];
}>;


export type RoutePathsQuery = { __typename?: 'Query', routes: Array<{ __typename?: 'RouteEntity', routePath?: { __typename?: 'RoutePathEntity', uuid: string, coordinates?: Array<Array<number>> | null, route: { __typename?: 'RouteEntity', uuid: string } } | null }> };

export type RouteFragment = { __typename?: 'RouteEntity', createdAt: any, date: any, uuid: string, defaultStartTime?: any | null, totalTimeInSeconds?: number | null, totalDistanceInMeters?: number | null, startLoadTimeInMinutes?: number | null, endLoadTimeInMinutes?: number | null, locked: boolean, nameManuallyChanged: boolean, name: string, numberOfRescheduled?: number | null, routeSlotsUpdatedAt?: any | null, lastDispatched?: any | null, terminal?: { __typename?: 'TerminalEntity', uuid: string } | null, routeInfo: { __typename?: 'RouteInfo', totalStops: number, totalStopsArrived: number, totalStopsNotArrived: number, totalStopsCompleted: number, totalStopsCancelled: number, totalStopsFailed: number, status: RouteStatus, pieceCount: number, totalWeight: number, totalStopsSentToAgent: number, totalStopsConfirmedByAgent: number }, helpers: Array<{ __typename?: 'DriverEntity', firstName: string, lastName: string, uuid: string, phoneNumber: string, driverReferenceNumber?: string | null }>, equipments: Array<{ __typename?: 'EquipmentEntity', uuid: string, name: string, type: EquipmentType, vehicleType?: { __typename?: 'VehicleTypeEntity', uuid: string, name: string, status: VehicleTypeStatus, maxVolume?: any | null, maxWeight?: any | null, capacityNotes?: string | null, vehicleTypePackageSpecs: Array<{ __typename?: 'VehicleTypePackageSpecEntity', id: string, maxQuantity?: number | null, packageSpec: { __typename?: 'PackageSpecEntity', id: string, name: string } }> } | null }>, tags: Array<{ __typename?: 'TagEntity', uuid: string, value: string, color?: string | null }>, drivers: Array<{ __typename?: 'DriverEntity', uuid: string, firstName: string, lastName: string, phoneNumber: string, driverReferenceNumber?: string | null, agentId?: string | null, terminal?: { __typename?: 'TerminalEntity', uuid: string, name: string } | null }>, slots: Array<{ __typename?: 'RouteSlotEntity', uuid: string, stops: Array<{ __typename: 'StandardStopEntity', stopType?: StopType | null, standardStopType?: StandardStopType | null, inboundMethod?: InboundMethod | null, outboundMethod?: OutboundMethod | null, notes?: string | null, isSpecial?: boolean | null, proofOfDeliverySignee?: string | null, status: StopStatus, sentToAgentAt?: any | null, confirmedByAgentAt?: any | null, appointmentTextStatus?: AppointmentTextStatus | null, specialInstructions?: string | null, paperworkMarkedComplete?: boolean | null, showDriverModifiedAt?: any | null, routeChangeAcknowledged: boolean, serviceDate?: any | null, overrideServiceTimeInMinutes?: number | null, completedAt?: any | null, uuid: string, appointmentTime?: any | null, endAppointmentTime?: any | null, routeSlot?: { __typename?: 'RouteSlotEntity', uuid: string, ordinal: number, route?: { __typename?: 'RouteEntity', uuid: string, name: string } | null } | null, stopDetails?: { __typename?: 'StopDetailsOutput', stopDetailsStatus: StopDetailsStatus, message?: string | null } | null, cachedEta?: { __typename?: 'EtaEntity', arrivalTime: any, finishTime: any } | null, contactPerson?: { __typename?: 'ContactPersonEntity', firstName?: string | null, lastName?: string | null, phone?: string | null } | null, address: { __typename?: 'AddressEntity', uuid: string, name: string, line1: string, line2?: string | null, city: string, state: string, zip: string, country: string, latitude?: number | null, longitude?: number | null, driverInstructions?: string | null, receivingHoursStart?: any | null, receivingHoursEnd?: any | null, specialInstructions?: string | null }, shipment?: { __typename?: 'StandardShipmentEntity', uuid: string, hasSignedPOD: boolean, shipmentType: ShipmentType, standardShipmentFields: { __typename?: 'StandardShipmentFieldsEntity', uuid: string, deliveryDate?: any | null, pickupOrDelivery: PickupOrDelivery, deadlineDate?: any | null, deadlineType?: DeadlineType | null }, order?: { __typename?: 'StandardOrderEntity', uuid: string, refusedBy?: string | null, isCollectOnDelivery?: boolean | null, orderSegmentType: OrderSegmentType, fulfillmentType?: FulfillmentType | null, detailedStatusV2?: OrderDetailedStatus | null, hazmat?: boolean | null, name: string, refNumbers: Array<string>, dateMarkedOnHand?: any | null, totalCharge: number, startStop?: { __typename?: 'StandardStopEntity', terminal?: { __typename?: 'TerminalEntity', name: string } | null } | null, endStop?: { __typename?: 'StandardStopEntity', terminal?: { __typename?: 'TerminalEntity', name: string } | null } | null, tags: Array<{ __typename?: 'TagEntity', uuid: string, value: string, color?: string | null }>, service?: { __typename?: 'ServiceEntity', uuid: string, name: string, timeInMinutes?: number | null } | null, orderComments: Array<{ __typename?: 'OrderCommentEntity', comment: string }>, shipments: Array<{ __typename?: 'StandardShipmentEntity', shipmentType: ShipmentType, uuid: string, standardShipmentFields: { __typename?: 'StandardShipmentFieldsEntity', pickupOrDelivery: PickupOrDelivery }, airportInfo?: { __typename?: 'AirportInfoEntity', address: { __typename?: 'AddressEntity', name: string } } | null, legs: Array<{ __typename?: 'LegEntity', endStop: { __typename?: 'StandardStopEntity', stopType?: StopType | null, incomingCarrier?: string | null, inboundMethod?: InboundMethod | null, address: { __typename?: 'AddressEntity', name: string }, terminal?: { __typename?: 'TerminalEntity', name: string } | null } }> }>, packages: Array<{ __typename?: 'PackageEntity', uuid: string, description: string, weight?: number | null, quantity: number, length?: number | null, width?: number | null, height?: number | null, type?: PackageType | null, packageSpec?: { __typename?: 'PackageSpecEntity', id: string, name: string } | null, warehouseLocation?: { __typename?: 'WarehouseLocationEntity', name: string } | null }>, billingPartyContact: { __typename?: 'CustomerContactEntity', displayName: string, businessDivision?: { __typename?: 'BusinessDivisionEntity', name: string } | null }, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', shipperBillOfLadingNumber?: string | null, masterAirwayBillOfLadingNumber?: string | null, measurementUnits: MeasurementUnits }, inboundPaperwork: { __typename?: 'OrderPaperworkEntity', paperworkComplete: boolean, attachedDocuments?: Array<DocumentType> | null, missingDocuments?: Array<DocumentType> | null, alerts?: Array<DocumentType> | null, proofOfDeliveryOrPickupReadyToSign?: Array<DocumentType> | null, proofOfDeliveryOrPickupSigned?: Array<DocumentType> | null, photos?: Array<DocumentType> | null, other?: Array<DocumentType> | null }, outboundPaperwork: { __typename?: 'OrderPaperworkEntity', paperworkComplete: boolean, attachedDocuments?: Array<DocumentType> | null, missingDocuments?: Array<DocumentType> | null, alerts?: Array<DocumentType> | null, proofOfDeliveryOrPickupReadyToSign?: Array<DocumentType> | null, proofOfDeliveryOrPickupSigned?: Array<DocumentType> | null, photos?: Array<DocumentType> | null, other?: Array<DocumentType> | null } } | null } | null }> }> };

export type RoutesQueryVariables = Exact<{
  date?: InputMaybe<Scalars['DateTime']['input']>;
  terminalUuid?: InputMaybe<Scalars['String']['input']>;
  routeUuids?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;


export type RoutesQuery = { __typename?: 'Query', routes: Array<{ __typename?: 'RouteEntity', createdAt: any, date: any, uuid: string, defaultStartTime?: any | null, totalTimeInSeconds?: number | null, totalDistanceInMeters?: number | null, startLoadTimeInMinutes?: number | null, endLoadTimeInMinutes?: number | null, locked: boolean, nameManuallyChanged: boolean, name: string, numberOfRescheduled?: number | null, routeSlotsUpdatedAt?: any | null, lastDispatched?: any | null, terminal?: { __typename?: 'TerminalEntity', uuid: string } | null, routeInfo: { __typename?: 'RouteInfo', totalStops: number, totalStopsArrived: number, totalStopsNotArrived: number, totalStopsCompleted: number, totalStopsCancelled: number, totalStopsFailed: number, status: RouteStatus, pieceCount: number, totalWeight: number, totalStopsSentToAgent: number, totalStopsConfirmedByAgent: number }, helpers: Array<{ __typename?: 'DriverEntity', firstName: string, lastName: string, uuid: string, phoneNumber: string, driverReferenceNumber?: string | null }>, equipments: Array<{ __typename?: 'EquipmentEntity', uuid: string, name: string, type: EquipmentType, vehicleType?: { __typename?: 'VehicleTypeEntity', uuid: string, name: string, status: VehicleTypeStatus, maxVolume?: any | null, maxWeight?: any | null, capacityNotes?: string | null, vehicleTypePackageSpecs: Array<{ __typename?: 'VehicleTypePackageSpecEntity', id: string, maxQuantity?: number | null, packageSpec: { __typename?: 'PackageSpecEntity', id: string, name: string } }> } | null }>, tags: Array<{ __typename?: 'TagEntity', uuid: string, value: string, color?: string | null }>, drivers: Array<{ __typename?: 'DriverEntity', uuid: string, firstName: string, lastName: string, phoneNumber: string, driverReferenceNumber?: string | null, agentId?: string | null, terminal?: { __typename?: 'TerminalEntity', uuid: string, name: string } | null }>, slots: Array<{ __typename?: 'RouteSlotEntity', uuid: string, stops: Array<{ __typename: 'StandardStopEntity', stopType?: StopType | null, standardStopType?: StandardStopType | null, inboundMethod?: InboundMethod | null, outboundMethod?: OutboundMethod | null, notes?: string | null, isSpecial?: boolean | null, proofOfDeliverySignee?: string | null, status: StopStatus, sentToAgentAt?: any | null, confirmedByAgentAt?: any | null, appointmentTextStatus?: AppointmentTextStatus | null, specialInstructions?: string | null, paperworkMarkedComplete?: boolean | null, showDriverModifiedAt?: any | null, routeChangeAcknowledged: boolean, serviceDate?: any | null, overrideServiceTimeInMinutes?: number | null, completedAt?: any | null, uuid: string, appointmentTime?: any | null, endAppointmentTime?: any | null, routeSlot?: { __typename?: 'RouteSlotEntity', uuid: string, ordinal: number, route?: { __typename?: 'RouteEntity', uuid: string, name: string } | null } | null, stopDetails?: { __typename?: 'StopDetailsOutput', stopDetailsStatus: StopDetailsStatus, message?: string | null } | null, cachedEta?: { __typename?: 'EtaEntity', arrivalTime: any, finishTime: any } | null, contactPerson?: { __typename?: 'ContactPersonEntity', firstName?: string | null, lastName?: string | null, phone?: string | null } | null, address: { __typename?: 'AddressEntity', uuid: string, name: string, line1: string, line2?: string | null, city: string, state: string, zip: string, country: string, latitude?: number | null, longitude?: number | null, driverInstructions?: string | null, receivingHoursStart?: any | null, receivingHoursEnd?: any | null, specialInstructions?: string | null }, shipment?: { __typename?: 'StandardShipmentEntity', uuid: string, hasSignedPOD: boolean, shipmentType: ShipmentType, standardShipmentFields: { __typename?: 'StandardShipmentFieldsEntity', uuid: string, deliveryDate?: any | null, pickupOrDelivery: PickupOrDelivery, deadlineDate?: any | null, deadlineType?: DeadlineType | null }, order?: { __typename?: 'StandardOrderEntity', uuid: string, refusedBy?: string | null, isCollectOnDelivery?: boolean | null, orderSegmentType: OrderSegmentType, fulfillmentType?: FulfillmentType | null, detailedStatusV2?: OrderDetailedStatus | null, hazmat?: boolean | null, name: string, refNumbers: Array<string>, dateMarkedOnHand?: any | null, totalCharge: number, startStop?: { __typename?: 'StandardStopEntity', terminal?: { __typename?: 'TerminalEntity', name: string } | null } | null, endStop?: { __typename?: 'StandardStopEntity', terminal?: { __typename?: 'TerminalEntity', name: string } | null } | null, tags: Array<{ __typename?: 'TagEntity', uuid: string, value: string, color?: string | null }>, service?: { __typename?: 'ServiceEntity', uuid: string, name: string, timeInMinutes?: number | null } | null, orderComments: Array<{ __typename?: 'OrderCommentEntity', comment: string }>, shipments: Array<{ __typename?: 'StandardShipmentEntity', shipmentType: ShipmentType, uuid: string, standardShipmentFields: { __typename?: 'StandardShipmentFieldsEntity', pickupOrDelivery: PickupOrDelivery }, airportInfo?: { __typename?: 'AirportInfoEntity', address: { __typename?: 'AddressEntity', name: string } } | null, legs: Array<{ __typename?: 'LegEntity', endStop: { __typename?: 'StandardStopEntity', stopType?: StopType | null, incomingCarrier?: string | null, inboundMethod?: InboundMethod | null, address: { __typename?: 'AddressEntity', name: string }, terminal?: { __typename?: 'TerminalEntity', name: string } | null } }> }>, packages: Array<{ __typename?: 'PackageEntity', uuid: string, description: string, weight?: number | null, quantity: number, length?: number | null, width?: number | null, height?: number | null, type?: PackageType | null, packageSpec?: { __typename?: 'PackageSpecEntity', id: string, name: string } | null, warehouseLocation?: { __typename?: 'WarehouseLocationEntity', name: string } | null }>, billingPartyContact: { __typename?: 'CustomerContactEntity', displayName: string, businessDivision?: { __typename?: 'BusinessDivisionEntity', name: string } | null }, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', shipperBillOfLadingNumber?: string | null, masterAirwayBillOfLadingNumber?: string | null, measurementUnits: MeasurementUnits }, inboundPaperwork: { __typename?: 'OrderPaperworkEntity', paperworkComplete: boolean, attachedDocuments?: Array<DocumentType> | null, missingDocuments?: Array<DocumentType> | null, alerts?: Array<DocumentType> | null, proofOfDeliveryOrPickupReadyToSign?: Array<DocumentType> | null, proofOfDeliveryOrPickupSigned?: Array<DocumentType> | null, photos?: Array<DocumentType> | null, other?: Array<DocumentType> | null }, outboundPaperwork: { __typename?: 'OrderPaperworkEntity', paperworkComplete: boolean, attachedDocuments?: Array<DocumentType> | null, missingDocuments?: Array<DocumentType> | null, alerts?: Array<DocumentType> | null, proofOfDeliveryOrPickupReadyToSign?: Array<DocumentType> | null, proofOfDeliveryOrPickupSigned?: Array<DocumentType> | null, photos?: Array<DocumentType> | null, other?: Array<DocumentType> | null } } | null } | null }> }> }> };

export type RoutesSamsaraVehicleLocationsQueryVariables = Exact<{
  routeUuids: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type RoutesSamsaraVehicleLocationsQuery = { __typename?: 'Query', routesSamsaraVehicleLocations: { __typename?: 'RoutesSamsaraVehicleLocationsOutput', routeCoordinates: Array<{ __typename?: 'RouteCoordinatesEntity', routeUuid: string, latitude: number, longitude: number }> } };

export type RoutesWithDriverMobilePhoneCoordinatesQueryVariables = Exact<{
  routeUuids: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type RoutesWithDriverMobilePhoneCoordinatesQuery = { __typename?: 'Query', routes: Array<{ __typename?: 'RouteEntity', uuid: string, currentDriverMobilePhoneLocation?: { __typename?: 'RouteCoordinatesEntity', latitude: number, longitude: number } | null }> };

export type RoutesWithEtaQueryVariables = Exact<{
  date: Scalars['DateTime']['input'];
}>;


export type RoutesWithEtaQuery = { __typename?: 'Query', routes: Array<{ __typename?: 'RouteEntity', uuid: string, date: any, totalTimeInSeconds?: number | null, nameManuallyChanged: boolean, locked: boolean, defaultStartTime?: any | null, startLoadTimeInMinutes?: number | null, endLoadTimeInMinutes?: number | null, name: string, numberOfRescheduled?: number | null, routeSlotsUpdatedAt?: any | null, lastDispatched?: any | null, etas: Array<{ __typename?: 'EtaEntity', arrivalTime: any, finishTime: any }>, helpers: Array<{ __typename?: 'DriverEntity', firstName: string, lastName: string, uuid: string, phoneNumber: string }>, equipments: Array<{ __typename?: 'EquipmentEntity', name: string, type: EquipmentType, uuid: string }>, drivers: Array<{ __typename?: 'DriverEntity', firstName: string, lastName: string, phoneNumber: string, uuid: string, defaultVehicle?: { __typename?: 'EquipmentEntity', name: string, uuid: string } | null }>, slots: Array<{ __typename?: 'RouteSlotEntity', uuid: string, stops: Array<{ __typename: 'StandardStopEntity', stopType?: StopType | null, standardStopType?: StandardStopType | null, inboundMethod?: InboundMethod | null, outboundMethod?: OutboundMethod | null, notes?: string | null, isSpecial?: boolean | null, proofOfDeliverySignee?: string | null, status: StopStatus, sentToAgentAt?: any | null, confirmedByAgentAt?: any | null, appointmentTextStatus?: AppointmentTextStatus | null, specialInstructions?: string | null, paperworkMarkedComplete?: boolean | null, showDriverModifiedAt?: any | null, routeChangeAcknowledged: boolean, serviceDate?: any | null, overrideServiceTimeInMinutes?: number | null, completedAt?: any | null, uuid: string, appointmentTime?: any | null, endAppointmentTime?: any | null, routeSlot?: { __typename?: 'RouteSlotEntity', uuid: string, ordinal: number, route?: { __typename?: 'RouteEntity', uuid: string, name: string } | null } | null, stopDetails?: { __typename?: 'StopDetailsOutput', stopDetailsStatus: StopDetailsStatus, message?: string | null } | null, cachedEta?: { __typename?: 'EtaEntity', arrivalTime: any, finishTime: any } | null, contactPerson?: { __typename?: 'ContactPersonEntity', firstName?: string | null, lastName?: string | null, phone?: string | null } | null, address: { __typename?: 'AddressEntity', uuid: string, name: string, line1: string, line2?: string | null, city: string, state: string, zip: string, country: string, latitude?: number | null, longitude?: number | null, driverInstructions?: string | null, receivingHoursStart?: any | null, receivingHoursEnd?: any | null, specialInstructions?: string | null }, shipment?: { __typename?: 'StandardShipmentEntity', uuid: string, hasSignedPOD: boolean, shipmentType: ShipmentType, standardShipmentFields: { __typename?: 'StandardShipmentFieldsEntity', uuid: string, deliveryDate?: any | null, pickupOrDelivery: PickupOrDelivery, deadlineDate?: any | null, deadlineType?: DeadlineType | null }, order?: { __typename?: 'StandardOrderEntity', uuid: string, refusedBy?: string | null, isCollectOnDelivery?: boolean | null, orderSegmentType: OrderSegmentType, fulfillmentType?: FulfillmentType | null, detailedStatusV2?: OrderDetailedStatus | null, hazmat?: boolean | null, name: string, refNumbers: Array<string>, dateMarkedOnHand?: any | null, totalCharge: number, startStop?: { __typename?: 'StandardStopEntity', terminal?: { __typename?: 'TerminalEntity', name: string } | null } | null, endStop?: { __typename?: 'StandardStopEntity', terminal?: { __typename?: 'TerminalEntity', name: string } | null } | null, tags: Array<{ __typename?: 'TagEntity', uuid: string, value: string, color?: string | null }>, service?: { __typename?: 'ServiceEntity', uuid: string, name: string, timeInMinutes?: number | null } | null, orderComments: Array<{ __typename?: 'OrderCommentEntity', comment: string }>, shipments: Array<{ __typename?: 'StandardShipmentEntity', shipmentType: ShipmentType, uuid: string, standardShipmentFields: { __typename?: 'StandardShipmentFieldsEntity', pickupOrDelivery: PickupOrDelivery }, airportInfo?: { __typename?: 'AirportInfoEntity', address: { __typename?: 'AddressEntity', name: string } } | null, legs: Array<{ __typename?: 'LegEntity', endStop: { __typename?: 'StandardStopEntity', stopType?: StopType | null, incomingCarrier?: string | null, inboundMethod?: InboundMethod | null, address: { __typename?: 'AddressEntity', name: string }, terminal?: { __typename?: 'TerminalEntity', name: string } | null } }> }>, packages: Array<{ __typename?: 'PackageEntity', uuid: string, description: string, weight?: number | null, quantity: number, length?: number | null, width?: number | null, height?: number | null, type?: PackageType | null, packageSpec?: { __typename?: 'PackageSpecEntity', id: string, name: string } | null, warehouseLocation?: { __typename?: 'WarehouseLocationEntity', name: string } | null }>, billingPartyContact: { __typename?: 'CustomerContactEntity', displayName: string, businessDivision?: { __typename?: 'BusinessDivisionEntity', name: string } | null }, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', shipperBillOfLadingNumber?: string | null, masterAirwayBillOfLadingNumber?: string | null, measurementUnits: MeasurementUnits }, inboundPaperwork: { __typename?: 'OrderPaperworkEntity', paperworkComplete: boolean, attachedDocuments?: Array<DocumentType> | null, missingDocuments?: Array<DocumentType> | null, alerts?: Array<DocumentType> | null, proofOfDeliveryOrPickupReadyToSign?: Array<DocumentType> | null, proofOfDeliveryOrPickupSigned?: Array<DocumentType> | null, photos?: Array<DocumentType> | null, other?: Array<DocumentType> | null }, outboundPaperwork: { __typename?: 'OrderPaperworkEntity', paperworkComplete: boolean, attachedDocuments?: Array<DocumentType> | null, missingDocuments?: Array<DocumentType> | null, alerts?: Array<DocumentType> | null, proofOfDeliveryOrPickupReadyToSign?: Array<DocumentType> | null, proofOfDeliveryOrPickupSigned?: Array<DocumentType> | null, photos?: Array<DocumentType> | null, other?: Array<DocumentType> | null } } | null } | null }> }> }> };

export type PaginatedRoutesQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  date?: InputMaybe<Scalars['DateTime']['input']>;
  terminalUuid?: InputMaybe<Scalars['String']['input']>;
  routeUuids?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  searchText?: InputMaybe<Scalars['String']['input']>;
  routeSort?: InputMaybe<RouteSort>;
  versionId?: InputMaybe<Scalars['String']['input']>;
}>;


export type PaginatedRoutesQuery = { __typename?: 'Query', paginatedRoutes: { __typename?: 'RouteConnection', totalCount: number, versionId?: string | null, edges: Array<{ __typename?: 'RouteEdge', node: { __typename?: 'RouteEntity', createdAt: any, date: any, uuid: string, defaultStartTime?: any | null, totalTimeInSeconds?: number | null, totalDistanceInMeters?: number | null, startLoadTimeInMinutes?: number | null, endLoadTimeInMinutes?: number | null, locked: boolean, nameManuallyChanged: boolean, name: string, numberOfRescheduled?: number | null, routeSlotsUpdatedAt?: any | null, lastDispatched?: any | null, terminal?: { __typename?: 'TerminalEntity', uuid: string } | null, routeInfo: { __typename?: 'RouteInfo', totalStops: number, totalStopsArrived: number, totalStopsNotArrived: number, totalStopsCompleted: number, totalStopsCancelled: number, totalStopsFailed: number, status: RouteStatus, pieceCount: number, totalWeight: number, totalStopsSentToAgent: number, totalStopsConfirmedByAgent: number }, helpers: Array<{ __typename?: 'DriverEntity', firstName: string, lastName: string, uuid: string, phoneNumber: string, driverReferenceNumber?: string | null }>, equipments: Array<{ __typename?: 'EquipmentEntity', uuid: string, name: string, type: EquipmentType, vehicleType?: { __typename?: 'VehicleTypeEntity', uuid: string, name: string, status: VehicleTypeStatus, maxVolume?: any | null, maxWeight?: any | null, capacityNotes?: string | null, vehicleTypePackageSpecs: Array<{ __typename?: 'VehicleTypePackageSpecEntity', id: string, maxQuantity?: number | null, packageSpec: { __typename?: 'PackageSpecEntity', id: string, name: string } }> } | null }>, tags: Array<{ __typename?: 'TagEntity', uuid: string, value: string, color?: string | null }>, drivers: Array<{ __typename?: 'DriverEntity', uuid: string, firstName: string, lastName: string, phoneNumber: string, driverReferenceNumber?: string | null, agentId?: string | null, terminal?: { __typename?: 'TerminalEntity', uuid: string, name: string } | null }>, slots: Array<{ __typename?: 'RouteSlotEntity', uuid: string, stops: Array<{ __typename: 'StandardStopEntity', stopType?: StopType | null, standardStopType?: StandardStopType | null, inboundMethod?: InboundMethod | null, outboundMethod?: OutboundMethod | null, notes?: string | null, isSpecial?: boolean | null, proofOfDeliverySignee?: string | null, status: StopStatus, sentToAgentAt?: any | null, confirmedByAgentAt?: any | null, appointmentTextStatus?: AppointmentTextStatus | null, specialInstructions?: string | null, paperworkMarkedComplete?: boolean | null, showDriverModifiedAt?: any | null, routeChangeAcknowledged: boolean, serviceDate?: any | null, overrideServiceTimeInMinutes?: number | null, completedAt?: any | null, uuid: string, appointmentTime?: any | null, endAppointmentTime?: any | null, routeSlot?: { __typename?: 'RouteSlotEntity', uuid: string, ordinal: number, route?: { __typename?: 'RouteEntity', uuid: string, name: string } | null } | null, stopDetails?: { __typename?: 'StopDetailsOutput', stopDetailsStatus: StopDetailsStatus, message?: string | null } | null, cachedEta?: { __typename?: 'EtaEntity', arrivalTime: any, finishTime: any } | null, contactPerson?: { __typename?: 'ContactPersonEntity', firstName?: string | null, lastName?: string | null, phone?: string | null } | null, address: { __typename?: 'AddressEntity', uuid: string, name: string, line1: string, line2?: string | null, city: string, state: string, zip: string, country: string, latitude?: number | null, longitude?: number | null, driverInstructions?: string | null, receivingHoursStart?: any | null, receivingHoursEnd?: any | null, specialInstructions?: string | null }, shipment?: { __typename?: 'StandardShipmentEntity', uuid: string, hasSignedPOD: boolean, shipmentType: ShipmentType, standardShipmentFields: { __typename?: 'StandardShipmentFieldsEntity', uuid: string, deliveryDate?: any | null, pickupOrDelivery: PickupOrDelivery, deadlineDate?: any | null, deadlineType?: DeadlineType | null }, order?: { __typename?: 'StandardOrderEntity', uuid: string, refusedBy?: string | null, isCollectOnDelivery?: boolean | null, orderSegmentType: OrderSegmentType, fulfillmentType?: FulfillmentType | null, detailedStatusV2?: OrderDetailedStatus | null, hazmat?: boolean | null, name: string, refNumbers: Array<string>, dateMarkedOnHand?: any | null, totalCharge: number, startStop?: { __typename?: 'StandardStopEntity', terminal?: { __typename?: 'TerminalEntity', name: string } | null } | null, endStop?: { __typename?: 'StandardStopEntity', terminal?: { __typename?: 'TerminalEntity', name: string } | null } | null, tags: Array<{ __typename?: 'TagEntity', uuid: string, value: string, color?: string | null }>, service?: { __typename?: 'ServiceEntity', uuid: string, name: string, timeInMinutes?: number | null } | null, orderComments: Array<{ __typename?: 'OrderCommentEntity', comment: string }>, shipments: Array<{ __typename?: 'StandardShipmentEntity', shipmentType: ShipmentType, uuid: string, standardShipmentFields: { __typename?: 'StandardShipmentFieldsEntity', pickupOrDelivery: PickupOrDelivery }, airportInfo?: { __typename?: 'AirportInfoEntity', address: { __typename?: 'AddressEntity', name: string } } | null, legs: Array<{ __typename?: 'LegEntity', endStop: { __typename?: 'StandardStopEntity', stopType?: StopType | null, incomingCarrier?: string | null, inboundMethod?: InboundMethod | null, address: { __typename?: 'AddressEntity', name: string }, terminal?: { __typename?: 'TerminalEntity', name: string } | null } }> }>, packages: Array<{ __typename?: 'PackageEntity', uuid: string, description: string, weight?: number | null, quantity: number, length?: number | null, width?: number | null, height?: number | null, type?: PackageType | null, packageSpec?: { __typename?: 'PackageSpecEntity', id: string, name: string } | null, warehouseLocation?: { __typename?: 'WarehouseLocationEntity', name: string } | null }>, billingPartyContact: { __typename?: 'CustomerContactEntity', displayName: string, businessDivision?: { __typename?: 'BusinessDivisionEntity', name: string } | null }, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', shipperBillOfLadingNumber?: string | null, masterAirwayBillOfLadingNumber?: string | null, measurementUnits: MeasurementUnits }, inboundPaperwork: { __typename?: 'OrderPaperworkEntity', paperworkComplete: boolean, attachedDocuments?: Array<DocumentType> | null, missingDocuments?: Array<DocumentType> | null, alerts?: Array<DocumentType> | null, proofOfDeliveryOrPickupReadyToSign?: Array<DocumentType> | null, proofOfDeliveryOrPickupSigned?: Array<DocumentType> | null, photos?: Array<DocumentType> | null, other?: Array<DocumentType> | null }, outboundPaperwork: { __typename?: 'OrderPaperworkEntity', paperworkComplete: boolean, attachedDocuments?: Array<DocumentType> | null, missingDocuments?: Array<DocumentType> | null, alerts?: Array<DocumentType> | null, proofOfDeliveryOrPickupReadyToSign?: Array<DocumentType> | null, proofOfDeliveryOrPickupSigned?: Array<DocumentType> | null, photos?: Array<DocumentType> | null, other?: Array<DocumentType> | null } } | null } | null }> }> } }>, pageInfo: { __typename?: 'PageInfo', startCursor?: string | null, endCursor?: string | null, hasNextPage: boolean, hasPreviousPage: boolean } } };

export type StopOnRouteFragment = { __typename: 'StandardStopEntity', stopType?: StopType | null, standardStopType?: StandardStopType | null, inboundMethod?: InboundMethod | null, outboundMethod?: OutboundMethod | null, notes?: string | null, isSpecial?: boolean | null, proofOfDeliverySignee?: string | null, status: StopStatus, sentToAgentAt?: any | null, confirmedByAgentAt?: any | null, appointmentTextStatus?: AppointmentTextStatus | null, specialInstructions?: string | null, paperworkMarkedComplete?: boolean | null, showDriverModifiedAt?: any | null, routeChangeAcknowledged: boolean, serviceDate?: any | null, overrideServiceTimeInMinutes?: number | null, completedAt?: any | null, uuid: string, appointmentTime?: any | null, endAppointmentTime?: any | null, routeSlot?: { __typename?: 'RouteSlotEntity', uuid: string, ordinal: number, route?: { __typename?: 'RouteEntity', uuid: string, name: string } | null } | null, stopDetails?: { __typename?: 'StopDetailsOutput', stopDetailsStatus: StopDetailsStatus, message?: string | null } | null, cachedEta?: { __typename?: 'EtaEntity', arrivalTime: any, finishTime: any } | null, contactPerson?: { __typename?: 'ContactPersonEntity', firstName?: string | null, lastName?: string | null, phone?: string | null } | null, address: { __typename?: 'AddressEntity', uuid: string, name: string, line1: string, line2?: string | null, city: string, state: string, zip: string, country: string, latitude?: number | null, longitude?: number | null, driverInstructions?: string | null, receivingHoursStart?: any | null, receivingHoursEnd?: any | null, specialInstructions?: string | null }, shipment?: { __typename?: 'StandardShipmentEntity', uuid: string, hasSignedPOD: boolean, shipmentType: ShipmentType, standardShipmentFields: { __typename?: 'StandardShipmentFieldsEntity', uuid: string, deliveryDate?: any | null, pickupOrDelivery: PickupOrDelivery, deadlineDate?: any | null, deadlineType?: DeadlineType | null }, order?: { __typename?: 'StandardOrderEntity', uuid: string, refusedBy?: string | null, isCollectOnDelivery?: boolean | null, orderSegmentType: OrderSegmentType, fulfillmentType?: FulfillmentType | null, detailedStatusV2?: OrderDetailedStatus | null, hazmat?: boolean | null, name: string, refNumbers: Array<string>, dateMarkedOnHand?: any | null, totalCharge: number, startStop?: { __typename?: 'StandardStopEntity', terminal?: { __typename?: 'TerminalEntity', name: string } | null } | null, endStop?: { __typename?: 'StandardStopEntity', terminal?: { __typename?: 'TerminalEntity', name: string } | null } | null, tags: Array<{ __typename?: 'TagEntity', uuid: string, value: string, color?: string | null }>, service?: { __typename?: 'ServiceEntity', uuid: string, name: string, timeInMinutes?: number | null } | null, orderComments: Array<{ __typename?: 'OrderCommentEntity', comment: string }>, shipments: Array<{ __typename?: 'StandardShipmentEntity', shipmentType: ShipmentType, uuid: string, standardShipmentFields: { __typename?: 'StandardShipmentFieldsEntity', pickupOrDelivery: PickupOrDelivery }, airportInfo?: { __typename?: 'AirportInfoEntity', address: { __typename?: 'AddressEntity', name: string } } | null, legs: Array<{ __typename?: 'LegEntity', endStop: { __typename?: 'StandardStopEntity', stopType?: StopType | null, incomingCarrier?: string | null, inboundMethod?: InboundMethod | null, address: { __typename?: 'AddressEntity', name: string }, terminal?: { __typename?: 'TerminalEntity', name: string } | null } }> }>, packages: Array<{ __typename?: 'PackageEntity', uuid: string, description: string, weight?: number | null, quantity: number, length?: number | null, width?: number | null, height?: number | null, type?: PackageType | null, packageSpec?: { __typename?: 'PackageSpecEntity', id: string, name: string } | null, warehouseLocation?: { __typename?: 'WarehouseLocationEntity', name: string } | null }>, billingPartyContact: { __typename?: 'CustomerContactEntity', displayName: string, businessDivision?: { __typename?: 'BusinessDivisionEntity', name: string } | null }, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', shipperBillOfLadingNumber?: string | null, masterAirwayBillOfLadingNumber?: string | null, measurementUnits: MeasurementUnits }, inboundPaperwork: { __typename?: 'OrderPaperworkEntity', paperworkComplete: boolean, attachedDocuments?: Array<DocumentType> | null, missingDocuments?: Array<DocumentType> | null, alerts?: Array<DocumentType> | null, proofOfDeliveryOrPickupReadyToSign?: Array<DocumentType> | null, proofOfDeliveryOrPickupSigned?: Array<DocumentType> | null, photos?: Array<DocumentType> | null, other?: Array<DocumentType> | null }, outboundPaperwork: { __typename?: 'OrderPaperworkEntity', paperworkComplete: boolean, attachedDocuments?: Array<DocumentType> | null, missingDocuments?: Array<DocumentType> | null, alerts?: Array<DocumentType> | null, proofOfDeliveryOrPickupReadyToSign?: Array<DocumentType> | null, proofOfDeliveryOrPickupSigned?: Array<DocumentType> | null, photos?: Array<DocumentType> | null, other?: Array<DocumentType> | null } } | null } | null };

export type OrderForStopOnRouteFragment = { __typename?: 'StandardOrderEntity', uuid: string, refusedBy?: string | null, isCollectOnDelivery?: boolean | null, orderSegmentType: OrderSegmentType, fulfillmentType?: FulfillmentType | null, detailedStatusV2?: OrderDetailedStatus | null, hazmat?: boolean | null, name: string, refNumbers: Array<string>, dateMarkedOnHand?: any | null, totalCharge: number, startStop?: { __typename?: 'StandardStopEntity', terminal?: { __typename?: 'TerminalEntity', name: string } | null } | null, endStop?: { __typename?: 'StandardStopEntity', terminal?: { __typename?: 'TerminalEntity', name: string } | null } | null, tags: Array<{ __typename?: 'TagEntity', uuid: string, value: string, color?: string | null }>, service?: { __typename?: 'ServiceEntity', uuid: string, name: string, timeInMinutes?: number | null } | null, orderComments: Array<{ __typename?: 'OrderCommentEntity', comment: string }>, shipments: Array<{ __typename?: 'StandardShipmentEntity', shipmentType: ShipmentType, uuid: string, standardShipmentFields: { __typename?: 'StandardShipmentFieldsEntity', pickupOrDelivery: PickupOrDelivery }, airportInfo?: { __typename?: 'AirportInfoEntity', address: { __typename?: 'AddressEntity', name: string } } | null, legs: Array<{ __typename?: 'LegEntity', endStop: { __typename?: 'StandardStopEntity', stopType?: StopType | null, incomingCarrier?: string | null, inboundMethod?: InboundMethod | null, address: { __typename?: 'AddressEntity', name: string }, terminal?: { __typename?: 'TerminalEntity', name: string } | null } }> }>, packages: Array<{ __typename?: 'PackageEntity', uuid: string, description: string, weight?: number | null, quantity: number, length?: number | null, width?: number | null, height?: number | null, type?: PackageType | null, packageSpec?: { __typename?: 'PackageSpecEntity', id: string, name: string } | null, warehouseLocation?: { __typename?: 'WarehouseLocationEntity', name: string } | null }>, billingPartyContact: { __typename?: 'CustomerContactEntity', displayName: string, businessDivision?: { __typename?: 'BusinessDivisionEntity', name: string } | null }, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', shipperBillOfLadingNumber?: string | null, masterAirwayBillOfLadingNumber?: string | null, measurementUnits: MeasurementUnits }, inboundPaperwork: { __typename?: 'OrderPaperworkEntity', paperworkComplete: boolean, attachedDocuments?: Array<DocumentType> | null, missingDocuments?: Array<DocumentType> | null, alerts?: Array<DocumentType> | null, proofOfDeliveryOrPickupReadyToSign?: Array<DocumentType> | null, proofOfDeliveryOrPickupSigned?: Array<DocumentType> | null, photos?: Array<DocumentType> | null, other?: Array<DocumentType> | null }, outboundPaperwork: { __typename?: 'OrderPaperworkEntity', paperworkComplete: boolean, attachedDocuments?: Array<DocumentType> | null, missingDocuments?: Array<DocumentType> | null, alerts?: Array<DocumentType> | null, proofOfDeliveryOrPickupReadyToSign?: Array<DocumentType> | null, proofOfDeliveryOrPickupSigned?: Array<DocumentType> | null, photos?: Array<DocumentType> | null, other?: Array<DocumentType> | null } };

export type UpdateRouteMutationVariables = Exact<{
  updateRouteInput: UpdateRouteInput;
}>;


export type UpdateRouteMutation = { __typename?: 'Mutation', updateRoute: { __typename?: 'RouteEntity', uuid: string } };

export type UpdateVehicleForRouteMutationVariables = Exact<{
  routeUuid: Scalars['String']['input'];
  vehicleUuid: Scalars['String']['input'];
}>;


export type UpdateVehicleForRouteMutation = { __typename?: 'Mutation', updateVehicleForRoute: { __typename?: 'RouteEntity', uuid: string } };

export type SameDayDispatchRouteSlotFragment = { __typename?: 'RouteSlotEntity', uuid: string, ordinal: number, previousSlotDistanceMeters?: number | null, previousSlotDurationSeconds?: number | null, stops: Array<{ __typename?: 'StandardStopEntity', uuid: string, appointmentTime?: any | null, arrivedAt?: any | null, completedAt?: any | null, endAppointmentTime?: any | null, notes?: string | null, isSpecial?: boolean | null, stopType?: StopType | null, status: StopStatus, routeChangeAcknowledged: boolean, address: { __typename?: 'AddressEntity', uuid: string, name: string, line1: string, line2?: string | null, city: string, state: string, zip: string, country: string, latitude?: number | null, longitude?: number | null, driverInstructions?: string | null, receivingHoursStart?: any | null, receivingHoursEnd?: any | null, specialInstructions?: string | null }, leg: { __typename?: 'LegEntity', uuid: string, shipment: { __typename?: 'StandardShipmentEntity', uuid: string, standardShipmentFields: { __typename?: 'StandardShipmentFieldsEntity', uuid: string, pickupOrDelivery: PickupOrDelivery, deliveryDate?: any | null }, order?: { __typename?: 'StandardOrderEntity', uuid: string, secondaryRefNumber?: string | null, name: string, pickedDate?: any | null, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', uuid: string, shipperBillOfLadingNumber?: string | null }, warehouse?: { __typename?: 'WarehouseEntity', uuid: string, name: string } | null, service?: { __typename?: 'ServiceEntity', uuid: string, name: string, createdAt: any, updatedAt: any, timeInMinutes?: number | null, useApptInRouteOptimization: boolean, markOrdersAsSpecial: boolean, defaultAppointmentStartTime?: any | null, defaultAppointmentEndTime?: any | null, defaultStartNow: boolean, defaultInboundStopType?: StopType | null, defaultOutboundStopType?: StopType | null, defaultPickupPadding?: any | null, defaultDeliveryPadding?: any | null, defaultTotalDuration?: any | null, defaultIsLineHaul: boolean, defaultFulfillmentType?: FulfillmentType | null, isActive: boolean, isExposedToCustomers: boolean, serviceAvailabilityDates: Array<{ __typename?: 'ServiceAvailabilityDateEntity', id: string, dayCategory: SpecialDayOfWeek, enabled: boolean, start: { __typename?: 'PlainTime', hour: number, minute: number }, end: { __typename?: 'PlainTime', hour: number, minute: number } }> } | null } | null, customCharges: Array<{ __typename?: 'CustomChargeEntity', accessorialTemplate?: { __typename?: 'SkidBasedAccessorialEntity', uuid: string, name: string } | { __typename?: 'SpecialAccessorialEntity', uuid: string, name: string } | { __typename?: 'StandardAccessorialEntity', uuid: string, name: string } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string, name: string } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string, name: string } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string, name: string } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string, name: string } | null }> } } }> };

export type SameDayDispatchRouteFragment = { __typename?: 'RouteEntity', uuid: string, nameManuallyChanged: boolean, name: string, company: { __typename?: 'CompanyEntity', uuid: string }, equipments: Array<{ __typename?: 'EquipmentEntity', type: EquipmentType, name: string, uuid: string, samsaraVehicleId?: string | null, samsaraIsDeactivated?: boolean | null }>, nextRouteSlot?: { __typename?: 'RouteSlotEntity', uuid: string, stops: Array<{ __typename?: 'StandardStopEntity', uuid: string }> } | null, helpers: Array<{ __typename?: 'DriverEntity', uuid: string, firstName: string, lastName: string }>, drivers: Array<{ __typename?: 'DriverEntity', uuid: string, firstName: string, lastName: string, mobilePhoneLatitude?: number | null, mobilePhoneLongitude?: number | null, mobileCoordsLastUpdatedAt?: any | null, defaultVehicle?: { __typename?: 'EquipmentEntity', uuid: string, samsaraVehicleId?: string | null, name: string } | null }>, slots: Array<{ __typename?: 'RouteSlotEntity', uuid: string, ordinal: number, previousSlotDistanceMeters?: number | null, previousSlotDurationSeconds?: number | null, stops: Array<{ __typename?: 'StandardStopEntity', uuid: string, appointmentTime?: any | null, arrivedAt?: any | null, completedAt?: any | null, endAppointmentTime?: any | null, notes?: string | null, isSpecial?: boolean | null, stopType?: StopType | null, status: StopStatus, routeChangeAcknowledged: boolean, address: { __typename?: 'AddressEntity', uuid: string, name: string, line1: string, line2?: string | null, city: string, state: string, zip: string, country: string, latitude?: number | null, longitude?: number | null, driverInstructions?: string | null, receivingHoursStart?: any | null, receivingHoursEnd?: any | null, specialInstructions?: string | null }, leg: { __typename?: 'LegEntity', uuid: string, shipment: { __typename?: 'StandardShipmentEntity', uuid: string, standardShipmentFields: { __typename?: 'StandardShipmentFieldsEntity', uuid: string, pickupOrDelivery: PickupOrDelivery, deliveryDate?: any | null }, order?: { __typename?: 'StandardOrderEntity', uuid: string, secondaryRefNumber?: string | null, name: string, pickedDate?: any | null, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', uuid: string, shipperBillOfLadingNumber?: string | null }, warehouse?: { __typename?: 'WarehouseEntity', uuid: string, name: string } | null, service?: { __typename?: 'ServiceEntity', uuid: string, name: string, createdAt: any, updatedAt: any, timeInMinutes?: number | null, useApptInRouteOptimization: boolean, markOrdersAsSpecial: boolean, defaultAppointmentStartTime?: any | null, defaultAppointmentEndTime?: any | null, defaultStartNow: boolean, defaultInboundStopType?: StopType | null, defaultOutboundStopType?: StopType | null, defaultPickupPadding?: any | null, defaultDeliveryPadding?: any | null, defaultTotalDuration?: any | null, defaultIsLineHaul: boolean, defaultFulfillmentType?: FulfillmentType | null, isActive: boolean, isExposedToCustomers: boolean, serviceAvailabilityDates: Array<{ __typename?: 'ServiceAvailabilityDateEntity', id: string, dayCategory: SpecialDayOfWeek, enabled: boolean, start: { __typename?: 'PlainTime', hour: number, minute: number }, end: { __typename?: 'PlainTime', hour: number, minute: number } }> } | null } | null, customCharges: Array<{ __typename?: 'CustomChargeEntity', accessorialTemplate?: { __typename?: 'SkidBasedAccessorialEntity', uuid: string, name: string } | { __typename?: 'SpecialAccessorialEntity', uuid: string, name: string } | { __typename?: 'StandardAccessorialEntity', uuid: string, name: string } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string, name: string } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string, name: string } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string, name: string } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string, name: string } | null }> } } }> }> };

export type SameDayDispatchRoutesQueryVariables = Exact<{
  date: Scalars['DateTime']['input'];
  searchText?: InputMaybe<Scalars['String']['input']>;
  terminalUuid?: InputMaybe<Scalars['String']['input']>;
}>;


export type SameDayDispatchRoutesQuery = { __typename?: 'Query', routes: Array<{ __typename?: 'RouteEntity', uuid: string, nameManuallyChanged: boolean, name: string, company: { __typename?: 'CompanyEntity', uuid: string }, equipments: Array<{ __typename?: 'EquipmentEntity', type: EquipmentType, name: string, uuid: string, samsaraVehicleId?: string | null, samsaraIsDeactivated?: boolean | null }>, nextRouteSlot?: { __typename?: 'RouteSlotEntity', uuid: string, stops: Array<{ __typename?: 'StandardStopEntity', uuid: string }> } | null, helpers: Array<{ __typename?: 'DriverEntity', uuid: string, firstName: string, lastName: string }>, drivers: Array<{ __typename?: 'DriverEntity', uuid: string, firstName: string, lastName: string, mobilePhoneLatitude?: number | null, mobilePhoneLongitude?: number | null, mobileCoordsLastUpdatedAt?: any | null, defaultVehicle?: { __typename?: 'EquipmentEntity', uuid: string, samsaraVehicleId?: string | null, name: string } | null }>, slots: Array<{ __typename?: 'RouteSlotEntity', uuid: string, ordinal: number, previousSlotDistanceMeters?: number | null, previousSlotDurationSeconds?: number | null, stops: Array<{ __typename?: 'StandardStopEntity', uuid: string, appointmentTime?: any | null, arrivedAt?: any | null, completedAt?: any | null, endAppointmentTime?: any | null, notes?: string | null, isSpecial?: boolean | null, stopType?: StopType | null, status: StopStatus, routeChangeAcknowledged: boolean, address: { __typename?: 'AddressEntity', uuid: string, name: string, line1: string, line2?: string | null, city: string, state: string, zip: string, country: string, latitude?: number | null, longitude?: number | null, driverInstructions?: string | null, receivingHoursStart?: any | null, receivingHoursEnd?: any | null, specialInstructions?: string | null }, leg: { __typename?: 'LegEntity', uuid: string, shipment: { __typename?: 'StandardShipmentEntity', uuid: string, standardShipmentFields: { __typename?: 'StandardShipmentFieldsEntity', uuid: string, pickupOrDelivery: PickupOrDelivery, deliveryDate?: any | null }, order?: { __typename?: 'StandardOrderEntity', uuid: string, secondaryRefNumber?: string | null, name: string, pickedDate?: any | null, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', uuid: string, shipperBillOfLadingNumber?: string | null }, warehouse?: { __typename?: 'WarehouseEntity', uuid: string, name: string } | null, service?: { __typename?: 'ServiceEntity', uuid: string, name: string, createdAt: any, updatedAt: any, timeInMinutes?: number | null, useApptInRouteOptimization: boolean, markOrdersAsSpecial: boolean, defaultAppointmentStartTime?: any | null, defaultAppointmentEndTime?: any | null, defaultStartNow: boolean, defaultInboundStopType?: StopType | null, defaultOutboundStopType?: StopType | null, defaultPickupPadding?: any | null, defaultDeliveryPadding?: any | null, defaultTotalDuration?: any | null, defaultIsLineHaul: boolean, defaultFulfillmentType?: FulfillmentType | null, isActive: boolean, isExposedToCustomers: boolean, serviceAvailabilityDates: Array<{ __typename?: 'ServiceAvailabilityDateEntity', id: string, dayCategory: SpecialDayOfWeek, enabled: boolean, start: { __typename?: 'PlainTime', hour: number, minute: number }, end: { __typename?: 'PlainTime', hour: number, minute: number } }> } | null } | null, customCharges: Array<{ __typename?: 'CustomChargeEntity', accessorialTemplate?: { __typename?: 'SkidBasedAccessorialEntity', uuid: string, name: string } | { __typename?: 'SpecialAccessorialEntity', uuid: string, name: string } | { __typename?: 'StandardAccessorialEntity', uuid: string, name: string } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string, name: string } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string, name: string } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string, name: string } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string, name: string } | null }> } } }> }> }> };

export type SamsaraVehicleStatsFeedQueryVariables = Exact<{
  samsaraVehicleIds: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type SamsaraVehicleStatsFeedQuery = { __typename?: 'Query', samsaraVehicleStatsFeed?: { __typename?: 'SamsaraVehicleStatsFeedEntity', data: Array<{ __typename?: 'SamsaraVehicleStatsEntity', id: string, gps?: Array<{ __typename?: 'SamsaraGpsPingEntity', latitude: number, longitude: number, time: string }> | null }>, pagination: { __typename?: 'SamsaraPaginationEntity', hasNextPage: boolean, endCursor: string } } | null };

export type SendRouteToAgentMutationVariables = Exact<{
  sendRouteToAgentInput: SendRouteToAgentInput;
}>;


export type SendRouteToAgentMutation = { __typename?: 'Mutation', sendRouteToAgent: { __typename?: 'MutationErrorOutput', message: string } | { __typename?: 'SendRouteToAgentSuccessOutput', route: { __typename?: 'RouteEntity', uuid: string } } };

export type StopBySearchTextFragment = { __typename?: 'StandardStopEntity', uuid: string, status: StopStatus, completedAt?: any | null, isAttempt: boolean, shipment?: { __typename?: 'StandardShipmentEntity', standardShipmentFields: { __typename?: 'StandardShipmentFieldsEntity', pickupOrDelivery: PickupOrDelivery }, order?: { __typename?: 'StandardOrderEntity', uuid: string, name: string, refNumbers: Array<string>, detailedStatus?: string | null, refusedBy?: string | null, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', shipperBillOfLadingNumber?: string | null } } | null } | null, stopDriverMaps: Array<{ __typename?: 'StopDriverMapEntity', uuid: string, enableDriverSettlement?: boolean | null, driver: { __typename?: 'DriverEntity', uuid: string, firstName: string, lastName: string, driverType?: DriverType | null }, driverSettlementBill?: { __typename?: 'DriverSettlementBillEntity', name?: string | null, settlementDate?: any | null, finalizedDate?: any | null } | null }> };

export type StopOnRouteBySearchTextFragment = { __typename?: 'StandardStopEntity', appointmentTime?: any | null, endAppointmentTime?: any | null, status: StopStatus, completedAt?: any | null, stopType?: StopType | null, cachedEta?: { __typename?: 'EtaEntity', arrivalTime: any } | null, stopDetails?: { __typename?: 'StopDetailsOutput', message?: string | null, stopDetailsStatus: StopDetailsStatus } | null, address: { __typename?: 'AddressEntity', uuid: string, name: string, line1: string, line2?: string | null, city: string, state: string, zip: string, country: string, latitude?: number | null, longitude?: number | null, driverInstructions?: string | null, receivingHoursStart?: any | null, receivingHoursEnd?: any | null, specialInstructions?: string | null }, shipment?: { __typename?: 'StandardShipmentEntity', standardShipmentFields: { __typename?: 'StandardShipmentFieldsEntity', deliveryDate?: any | null, pickupOrDelivery: PickupOrDelivery }, order?: { __typename?: 'StandardOrderEntity', uuid: string, refusedBy?: string | null, packages: Array<{ __typename?: 'PackageEntity', uuid: string, description: string, weight?: number | null, quantity: number, length?: number | null, width?: number | null, height?: number | null, type?: PackageType | null, packageSpec?: { __typename?: 'PackageSpecEntity', id: string, name: string } | null, warehouseLocation?: { __typename?: 'WarehouseLocationEntity', name: string } | null }>, billingPartyContact: { __typename?: 'CustomerContactEntity', displayName: string }, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', shipperBillOfLadingNumber?: string | null }, service?: { __typename?: 'ServiceEntity', uuid: string, name: string } | null } | null } | null, routeSlot?: { __typename?: 'RouteSlotEntity', route?: { __typename?: 'RouteEntity', name: string, date: any, terminal?: { __typename?: 'TerminalEntity', code: string } | null } | null } | null };

export type StopsBySearchTextQueryVariables = Exact<{
  searchText: Scalars['String']['input'];
}>;


export type StopsBySearchTextQuery = { __typename?: 'Query', stopsBySearchText: Array<{ __typename?: 'StandardStopEntity', uuid: string, status: StopStatus, completedAt?: any | null, isAttempt: boolean, shipment?: { __typename?: 'StandardShipmentEntity', standardShipmentFields: { __typename?: 'StandardShipmentFieldsEntity', pickupOrDelivery: PickupOrDelivery }, order?: { __typename?: 'StandardOrderEntity', uuid: string, name: string, refNumbers: Array<string>, detailedStatus?: string | null, refusedBy?: string | null, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', shipperBillOfLadingNumber?: string | null } } | null } | null, stopDriverMaps: Array<{ __typename?: 'StopDriverMapEntity', uuid: string, enableDriverSettlement?: boolean | null, driver: { __typename?: 'DriverEntity', uuid: string, firstName: string, lastName: string, driverType?: DriverType | null }, driverSettlementBill?: { __typename?: 'DriverSettlementBillEntity', name?: string | null, settlementDate?: any | null, finalizedDate?: any | null } | null }> }> };

export type StopsOnRoutesBySearchTextQueryVariables = Exact<{
  searchText: Scalars['String']['input'];
}>;


export type StopsOnRoutesBySearchTextQuery = { __typename?: 'Query', stopsOnRoutesBySearchText: Array<{ __typename?: 'StandardStopEntity', appointmentTime?: any | null, endAppointmentTime?: any | null, status: StopStatus, completedAt?: any | null, stopType?: StopType | null, cachedEta?: { __typename?: 'EtaEntity', arrivalTime: any } | null, stopDetails?: { __typename?: 'StopDetailsOutput', message?: string | null, stopDetailsStatus: StopDetailsStatus } | null, address: { __typename?: 'AddressEntity', uuid: string, name: string, line1: string, line2?: string | null, city: string, state: string, zip: string, country: string, latitude?: number | null, longitude?: number | null, driverInstructions?: string | null, receivingHoursStart?: any | null, receivingHoursEnd?: any | null, specialInstructions?: string | null }, shipment?: { __typename?: 'StandardShipmentEntity', standardShipmentFields: { __typename?: 'StandardShipmentFieldsEntity', deliveryDate?: any | null, pickupOrDelivery: PickupOrDelivery }, order?: { __typename?: 'StandardOrderEntity', uuid: string, refusedBy?: string | null, packages: Array<{ __typename?: 'PackageEntity', uuid: string, description: string, weight?: number | null, quantity: number, length?: number | null, width?: number | null, height?: number | null, type?: PackageType | null, packageSpec?: { __typename?: 'PackageSpecEntity', id: string, name: string } | null, warehouseLocation?: { __typename?: 'WarehouseLocationEntity', name: string } | null }>, billingPartyContact: { __typename?: 'CustomerContactEntity', displayName: string }, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', shipperBillOfLadingNumber?: string | null }, service?: { __typename?: 'ServiceEntity', uuid: string, name: string } | null } | null } | null, routeSlot?: { __typename?: 'RouteSlotEntity', route?: { __typename?: 'RouteEntity', name: string, date: any, terminal?: { __typename?: 'TerminalEntity', code: string } | null } | null } | null }> };

export type RecurringRunHeaderFragment = { __typename?: 'RecurringRunHeaderEntity', uuid: string, name: string, driver?: { __typename?: 'DriverEntity', uuid: string, firstName: string, lastName: string } | null, vehicleType?: { __typename?: 'VehicleTypeEntity', uuid: string, name: string } | null };

export type StopBaseFragment = { __typename?: 'CachedStopBaseEntity', uuid: string, stopType?: StopType | null, hasPreviousAttempt?: boolean | null, isSpecial?: boolean | null, specialInstructions?: string | null, serviceDate?: any | null, serviceTimeInMinutes?: number | null, terminalUuid?: string | null, terminalName?: string | null, status: StopStatus, appointmentTime?: any | null, endAppointmentTime?: any | null, appointmentScheduled?: boolean | null, appointmentRequired?: boolean | null, deadlineDate?: any | null, deliveryDate?: any | null, createdAt: any, standardStopType?: StandardStopType | null, totalCharge?: number | null, serviceDateV2?: { __typename?: 'PlainDate', iso8601: string } | null, address?: { __typename?: 'AddressForCachedStop', name: string, line1: string, line2?: string | null, city: string, zip: string, state: string, routeName?: string | null, routeNameUuid?: string | null, latitude?: number | null, longitude?: number | null } | null };

export type StopQueryForOverrideMinutesQueryVariables = Exact<{
  uuid: Scalars['String']['input'];
}>;


export type StopQueryForOverrideMinutesQuery = { __typename?: 'Query', stop: { __typename?: 'StandardStopEntity', uuid: string, overrideServiceTimeInMinutes?: number | null, routeSlot?: { __typename?: 'RouteSlotEntity', route?: { __typename?: 'RouteEntity', uuid: string } | null } | null } };

export type StopFragment = { __typename: 'CachedStopEntity', recurringRunUuid?: string | null, stopDetails?: { __typename?: 'StopDetailsOutput', message?: string | null, stopDetailsStatus: StopDetailsStatus } | null, order?: { __typename?: 'OrderForCachedStop', uuid: string, orderSegmentType: OrderSegmentType, fulfillmentType?: FulfillmentType | null, warehouseUuid?: string | null, businessDivisionName?: string | null, contactUuid: string, contactName: string, serviceUuid?: string | null, serviceName?: string | null, name: string, vehicleTypeName?: string | null, refNumbers: Array<string>, shipperBillOfLadingNumber?: string | null, masterAirwayBillOfLadingNumber?: string | null, receivedDate?: any | null, pickedDate?: any | null, inboundStopType?: PickupOrDelivery | null, outboundStopType?: PickupOrDelivery | null, inboundName?: string | null, outboundName?: string | null, inboundZip?: string | null, outboundZip?: string | null, inboundCity?: string | null, outboundCity?: string | null, inboundPaperwork?: { __typename?: 'OrderPaperworkEntity', paperworkComplete: boolean, attachedDocuments?: Array<DocumentType> | null, missingDocuments?: Array<DocumentType> | null, alerts?: Array<DocumentType> | null, proofOfDeliveryOrPickupReadyToSign?: Array<DocumentType> | null, proofOfDeliveryOrPickupSigned?: Array<DocumentType> | null, photos?: Array<DocumentType> | null, other?: Array<DocumentType> | null } | null, outboundPaperwork?: { __typename?: 'OrderPaperworkEntity', paperworkComplete: boolean, attachedDocuments?: Array<DocumentType> | null, missingDocuments?: Array<DocumentType> | null, alerts?: Array<DocumentType> | null, proofOfDeliveryOrPickupReadyToSign?: Array<DocumentType> | null, proofOfDeliveryOrPickupSigned?: Array<DocumentType> | null, photos?: Array<DocumentType> | null, other?: Array<DocumentType> | null } | null, orderComments: Array<{ __typename?: 'OrderCommentForCachedStop', comment: string }>, tags: Array<{ __typename?: 'TagEntity', uuid: string, value: string, color?: string | null }>, packages: Array<{ __typename?: 'PackageForCachedStop', weight?: number | null, length?: number | null, width?: number | null, height?: number | null, quantity: number, description?: string | null }> } | null, stop: { __typename?: 'CachedStopBaseEntity', uuid: string, stopType?: StopType | null, hasPreviousAttempt?: boolean | null, isSpecial?: boolean | null, specialInstructions?: string | null, serviceDate?: any | null, serviceTimeInMinutes?: number | null, terminalUuid?: string | null, terminalName?: string | null, status: StopStatus, appointmentTime?: any | null, endAppointmentTime?: any | null, appointmentScheduled?: boolean | null, appointmentRequired?: boolean | null, deadlineDate?: any | null, deliveryDate?: any | null, createdAt: any, standardStopType?: StandardStopType | null, totalCharge?: number | null, serviceDateV2?: { __typename?: 'PlainDate', iso8601: string } | null, address?: { __typename?: 'AddressForCachedStop', name: string, line1: string, line2?: string | null, city: string, zip: string, state: string, routeName?: string | null, routeNameUuid?: string | null, latitude?: number | null, longitude?: number | null } | null }, linkedEndStop?: { __typename?: 'CachedStopBaseEntity', uuid: string, stopType?: StopType | null, hasPreviousAttempt?: boolean | null, isSpecial?: boolean | null, specialInstructions?: string | null, serviceDate?: any | null, serviceTimeInMinutes?: number | null, terminalUuid?: string | null, terminalName?: string | null, status: StopStatus, appointmentTime?: any | null, endAppointmentTime?: any | null, appointmentScheduled?: boolean | null, appointmentRequired?: boolean | null, deadlineDate?: any | null, deliveryDate?: any | null, createdAt: any, standardStopType?: StandardStopType | null, totalCharge?: number | null, serviceDateV2?: { __typename?: 'PlainDate', iso8601: string } | null, address?: { __typename?: 'AddressForCachedStop', name: string, line1: string, line2?: string | null, city: string, zip: string, state: string, routeName?: string | null, routeNameUuid?: string | null, latitude?: number | null, longitude?: number | null } | null } | null, otherStop?: { __typename?: 'CachedStopBaseEntity', uuid: string, stopType?: StopType | null, hasPreviousAttempt?: boolean | null, isSpecial?: boolean | null, specialInstructions?: string | null, serviceDate?: any | null, serviceTimeInMinutes?: number | null, terminalUuid?: string | null, terminalName?: string | null, status: StopStatus, appointmentTime?: any | null, endAppointmentTime?: any | null, appointmentScheduled?: boolean | null, appointmentRequired?: boolean | null, deadlineDate?: any | null, deliveryDate?: any | null, createdAt: any, standardStopType?: StandardStopType | null, totalCharge?: number | null, serviceDateV2?: { __typename?: 'PlainDate', iso8601: string } | null, address?: { __typename?: 'AddressForCachedStop', name: string, line1: string, line2?: string | null, city: string, zip: string, state: string, routeName?: string | null, routeNameUuid?: string | null, latitude?: number | null, longitude?: number | null } | null } | null };

export type StopsQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  includeCount?: InputMaybe<Scalars['Boolean']['input']>;
  sort?: InputMaybe<StopSort>;
  sorts?: InputMaybe<Array<StopSort> | StopSort>;
  useCache?: InputMaybe<Scalars['Boolean']['input']>;
  cacheStartIndex?: InputMaybe<Scalars['Float']['input']>;
  uuid?: InputMaybe<Scalars['String']['input']>;
  uuids?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  orderUuid?: InputMaybe<Scalars['String']['input']>;
  searchText?: InputMaybe<Scalars['String']['input']>;
  addressType?: InputMaybe<StandardStopType>;
  appointmentRequired?: InputMaybe<Scalars['Boolean']['input']>;
  appointmentScheduled?: InputMaybe<Scalars['Boolean']['input']>;
  tagUuids?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  isAssigned?: InputMaybe<Scalars['Boolean']['input']>;
  previouslyAttempted?: InputMaybe<Scalars['Boolean']['input']>;
  businessDivisionUuid?: InputMaybe<Scalars['String']['input']>;
  serviceLevelUuids?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  onHand?: InputMaybe<Scalars['Boolean']['input']>;
  isPicked?: InputMaybe<Scalars['Boolean']['input']>;
  isRefusedFilter?: InputMaybe<BooleanFilterV2>;
  statuses?: InputMaybe<Array<StopStatus> | StopStatus>;
  orderStatuses?: InputMaybe<Array<OrderStatus> | OrderStatus>;
  customerUuid?: InputMaybe<Scalars['String']['input']>;
  createdAtFilters?: InputMaybe<DateFilterStartEnd>;
  deadlineDateFilters?: InputMaybe<DateFilterStartEnd>;
  serviceDateFilters?: InputMaybe<DateFilterStartEnd>;
  appointmentTimeFilters?: InputMaybe<DateFilterStartEnd>;
  transferPending?: InputMaybe<Scalars['Boolean']['input']>;
  pickupOrDeliveryTypes?: InputMaybe<Array<PickupOrDelivery> | PickupOrDelivery>;
  requiresRecovery?: InputMaybe<Scalars['Boolean']['input']>;
  hasAppointment?: InputMaybe<Scalars['Boolean']['input']>;
  warehouseUuid?: InputMaybe<Scalars['String']['input']>;
  terminalUuid?: InputMaybe<Scalars['String']['input']>;
  hideOnHold?: InputMaybe<Scalars['Boolean']['input']>;
  hideStopsWithoutAddress?: InputMaybe<Scalars['Boolean']['input']>;
  isSpecial?: InputMaybe<Scalars['Boolean']['input']>;
  routeNameUuid?: InputMaybe<Scalars['String']['input']>;
  includeRecurringRunHeaders?: InputMaybe<Scalars['Boolean']['input']>;
  filters?: InputMaybe<Array<FindStopsFiltersInput> | FindStopsFiltersInput>;
}>;


export type StopsQuery = { __typename?: 'Query', stops: { __typename?: 'CachedStopConnection', totalCount?: number | null, recurringRunsCount?: number | null, edges: Array<{ __typename?: 'CachedStopEdge', node: { __typename: 'CachedStopEntity', recurringRunUuid?: string | null, stopDetails?: { __typename?: 'StopDetailsOutput', message?: string | null, stopDetailsStatus: StopDetailsStatus } | null, order?: { __typename?: 'OrderForCachedStop', uuid: string, orderSegmentType: OrderSegmentType, fulfillmentType?: FulfillmentType | null, warehouseUuid?: string | null, businessDivisionName?: string | null, contactUuid: string, contactName: string, serviceUuid?: string | null, serviceName?: string | null, name: string, vehicleTypeName?: string | null, refNumbers: Array<string>, shipperBillOfLadingNumber?: string | null, masterAirwayBillOfLadingNumber?: string | null, receivedDate?: any | null, pickedDate?: any | null, inboundStopType?: PickupOrDelivery | null, outboundStopType?: PickupOrDelivery | null, inboundName?: string | null, outboundName?: string | null, inboundZip?: string | null, outboundZip?: string | null, inboundCity?: string | null, outboundCity?: string | null, inboundPaperwork?: { __typename?: 'OrderPaperworkEntity', paperworkComplete: boolean, attachedDocuments?: Array<DocumentType> | null, missingDocuments?: Array<DocumentType> | null, alerts?: Array<DocumentType> | null, proofOfDeliveryOrPickupReadyToSign?: Array<DocumentType> | null, proofOfDeliveryOrPickupSigned?: Array<DocumentType> | null, photos?: Array<DocumentType> | null, other?: Array<DocumentType> | null } | null, outboundPaperwork?: { __typename?: 'OrderPaperworkEntity', paperworkComplete: boolean, attachedDocuments?: Array<DocumentType> | null, missingDocuments?: Array<DocumentType> | null, alerts?: Array<DocumentType> | null, proofOfDeliveryOrPickupReadyToSign?: Array<DocumentType> | null, proofOfDeliveryOrPickupSigned?: Array<DocumentType> | null, photos?: Array<DocumentType> | null, other?: Array<DocumentType> | null } | null, orderComments: Array<{ __typename?: 'OrderCommentForCachedStop', comment: string }>, tags: Array<{ __typename?: 'TagEntity', uuid: string, value: string, color?: string | null }>, packages: Array<{ __typename?: 'PackageForCachedStop', weight?: number | null, length?: number | null, width?: number | null, height?: number | null, quantity: number, description?: string | null }> } | null, stop: { __typename?: 'CachedStopBaseEntity', uuid: string, stopType?: StopType | null, hasPreviousAttempt?: boolean | null, isSpecial?: boolean | null, specialInstructions?: string | null, serviceDate?: any | null, serviceTimeInMinutes?: number | null, terminalUuid?: string | null, terminalName?: string | null, status: StopStatus, appointmentTime?: any | null, endAppointmentTime?: any | null, appointmentScheduled?: boolean | null, appointmentRequired?: boolean | null, deadlineDate?: any | null, deliveryDate?: any | null, createdAt: any, standardStopType?: StandardStopType | null, totalCharge?: number | null, serviceDateV2?: { __typename?: 'PlainDate', iso8601: string } | null, address?: { __typename?: 'AddressForCachedStop', name: string, line1: string, line2?: string | null, city: string, zip: string, state: string, routeName?: string | null, routeNameUuid?: string | null, latitude?: number | null, longitude?: number | null } | null }, linkedEndStop?: { __typename?: 'CachedStopBaseEntity', uuid: string, stopType?: StopType | null, hasPreviousAttempt?: boolean | null, isSpecial?: boolean | null, specialInstructions?: string | null, serviceDate?: any | null, serviceTimeInMinutes?: number | null, terminalUuid?: string | null, terminalName?: string | null, status: StopStatus, appointmentTime?: any | null, endAppointmentTime?: any | null, appointmentScheduled?: boolean | null, appointmentRequired?: boolean | null, deadlineDate?: any | null, deliveryDate?: any | null, createdAt: any, standardStopType?: StandardStopType | null, totalCharge?: number | null, serviceDateV2?: { __typename?: 'PlainDate', iso8601: string } | null, address?: { __typename?: 'AddressForCachedStop', name: string, line1: string, line2?: string | null, city: string, zip: string, state: string, routeName?: string | null, routeNameUuid?: string | null, latitude?: number | null, longitude?: number | null } | null } | null, otherStop?: { __typename?: 'CachedStopBaseEntity', uuid: string, stopType?: StopType | null, hasPreviousAttempt?: boolean | null, isSpecial?: boolean | null, specialInstructions?: string | null, serviceDate?: any | null, serviceTimeInMinutes?: number | null, terminalUuid?: string | null, terminalName?: string | null, status: StopStatus, appointmentTime?: any | null, endAppointmentTime?: any | null, appointmentScheduled?: boolean | null, appointmentRequired?: boolean | null, deadlineDate?: any | null, deliveryDate?: any | null, createdAt: any, standardStopType?: StandardStopType | null, totalCharge?: number | null, serviceDateV2?: { __typename?: 'PlainDate', iso8601: string } | null, address?: { __typename?: 'AddressForCachedStop', name: string, line1: string, line2?: string | null, city: string, zip: string, state: string, routeName?: string | null, routeNameUuid?: string | null, latitude?: number | null, longitude?: number | null } | null } | null } | { __typename: 'RecurringRunHeaderEntity', uuid: string, name: string, driver?: { __typename?: 'DriverEntity', uuid: string, firstName: string, lastName: string } | null, vehicleType?: { __typename?: 'VehicleTypeEntity', uuid: string, name: string } | null } }>, pageInfo: { __typename?: 'PageInfo', startCursor?: string | null, endCursor?: string | null, hasNextPage: boolean, hasPreviousPage: boolean } } };

export type TextDriverMutationVariables = Exact<{
  textDriverInput: TextDriverInput;
}>;


export type TextDriverMutation = { __typename?: 'Mutation', textDriver: { __typename?: 'DriverEntity', uuid: string } };

export type UpdateRouteDriversMutationVariables = Exact<{
  updateRouteDriversInput: UpdateRouteDriversInput;
}>;


export type UpdateRouteDriversMutation = { __typename?: 'Mutation', updateRouteDrivers: { __typename?: 'RouteEntity', uuid: string } };

export type UpdateRouteSlotsMutationVariables = Exact<{
  updateRouteSlotsInput: UpdateRouteSlotsInput;
}>;


export type UpdateRouteSlotsMutation = { __typename?: 'Mutation', updateRouteSlots?: { __typename?: 'RouteEntity', uuid: string } | null };

export type CompanyDocumentsQueryVariables = Exact<{
  companyUuid: Scalars['String']['input'];
  terminalUuid?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  date: Scalars['String']['input'];
  statusFilter: FindCompanyDocumentStatusFilter;
  searchText?: InputMaybe<Scalars['String']['input']>;
  uploadDateAscending?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type CompanyDocumentsQuery = { __typename?: 'Query', companyDocuments: Array<{ __typename?: 'DocumentEntity', uuid: string, fileName: string, bucket: string, region: string, key: string, uploadedAt?: any | null, fileType: string, isDeleted: boolean, preSignedGetUrl: string, name?: string | null, type: DocumentType, pageNumber?: number | null, createdAt: any, notes?: string | null, order?: { __typename?: 'StandardOrderEntity', uuid: string, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', shipperBillOfLadingNumber?: string | null } } | null, shipment?: { __typename?: 'StandardOrderEntity', uuid: string } | null, driverFormTemplate?: { __typename?: 'DriverSignableFormTemplateEntity', uuid: string, title: string, formText: string } | null }> };

export type CompanySchemasQueryVariables = Exact<{ [key: string]: never; }>;


export type CompanySchemasQuery = { __typename?: 'Query', companySchemas: Array<{ __typename?: 'SchemaWithAnchorsEntity', uuid: string, companyUuid?: string | null, contactUuid?: string | null, isMultiPage: boolean, name: string, originalFilename: string, scannedDocumentType: ScannedDocumentType }> };

export type CustomDriverFormFragment = { __typename?: 'DriverSignableFormTemplateEntity', uuid: string, title: string, formText: string };

export type DocumentFragment = { __typename?: 'DocumentEntity', uuid: string, fileName: string, bucket: string, region: string, key: string, uploadedAt?: any | null, fileType: string, isDeleted: boolean, preSignedGetUrl: string, name?: string | null, type: DocumentType, pageNumber?: number | null, createdAt: any, notes?: string | null, order?: { __typename?: 'StandardOrderEntity', uuid: string, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', shipperBillOfLadingNumber?: string | null } } | null, shipment?: { __typename?: 'StandardOrderEntity', uuid: string } | null, driverFormTemplate?: { __typename?: 'DriverSignableFormTemplateEntity', uuid: string, title: string, formText: string } | null };

export type SplitAndProcessOrderDocumentsMutationVariables = Exact<{
  splitAndProcessOrderDocumentsInput: SplitAndProcessOrderDocumentsInput;
}>;


export type SplitAndProcessOrderDocumentsMutation = { __typename?: 'Mutation', splitAndProcessOrderDocuments: boolean };

export type UpdateDocumentsMutationVariables = Exact<{
  updateDocumentsInput: UpdateDocumentsInput;
}>;


export type UpdateDocumentsMutation = { __typename?: 'Mutation', updateDocuments: Array<{ __typename?: 'DocumentEntity', uuid: string }> };

export type CreateAdjustmentStopDriverMapMutationVariables = Exact<{
  input: AdjustmentStopDriverMapCreateInput;
}>;


export type CreateAdjustmentStopDriverMapMutation = { __typename?: 'Mutation', createAdjustmentStopDriverMap?: { __typename?: 'StopDriverMapEntity', uuid: string, name?: string | null, enableDriverSettlement?: boolean | null, revenuePercentageRate?: number | null, revenueFlatRate?: number | null, driverPayoutFinalized: boolean, driver: { __typename?: 'DriverEntity', firstName: string, lastName: string, uuid: string, driverType?: DriverType | null, driverReferenceNumber?: string | null, defaultFuelSettlementPercentageRate?: number | null, user: { __typename?: 'UserEntity', name?: string | null }, defaultVehicle?: { __typename?: 'EquipmentEntity', uuid: string } | null, terminal?: { __typename?: 'TerminalEntity', uuid: string, name: string } | null, qualifications: Array<{ __typename?: 'DriverQualificationEntity', id: string }> }, driverSettlementBill?: { __typename?: 'DriverSettlementBillEntity', uuid: string } | null, stop: { __typename?: 'StandardStopEntity', uuid: string, completedAt?: any | null, settlementDeductionName?: string | null, settlementDeductionFlatRate?: number | null, settlementDeductionPercentageRate?: number | null } } | null };

export type CreateDriverSettlementBillMutationVariables = Exact<{
  createDriverSettlementBillInput: CreateDriverSettlementBillInput;
}>;


export type CreateDriverSettlementBillMutation = { __typename?: 'Mutation', createDriverSettlementBill: { __typename?: 'DriverSettlementBillEntity', uuid: string, name?: string | null, createdAt: any, billStartDate?: any | null, billEndDate?: any | null, payPeriod: string, settlementDate?: any | null, totalDriverPayoutPreDeduction?: number | null, finalizedDate?: any | null, driver: { __typename?: 'DriverEntity', uuid: string, firstName: string, lastName: string, user: { __typename?: 'UserEntity', name?: string | null } }, settlementDeductions: Array<{ __typename?: 'SettlementDeductionEntity', uuid: string, adjustmentType?: SettlementAdjustmentType | null, name: string, flatRate?: number | null, percentageDecimalRate?: number | null }> } };

export type DeleteStopDriverMapMutationVariables = Exact<{
  uuid: Scalars['String']['input'];
}>;


export type DeleteStopDriverMapMutation = { __typename?: 'Mutation', deleteStopDriverMap: { __typename?: 'StopDriverMapEntity', uuid: string } };

export type DriverCompletedStopsFragment = { __typename?: 'DriverCompletedStopsEntity', stopDriverMaps: Array<{ __typename?: 'StopDriverMapForCompletedStopsEntity', serviceDate?: any | null, stopType?: StopType | null, isLineHaul?: boolean | null, driver: { __typename?: 'DriverEntity', uuid: string }, linehaulStartTerminal?: { __typename?: 'TerminalEntity', code: string } | null, linehaulEndTerminal?: { __typename?: 'TerminalEntity', code: string } | null, order?: { __typename?: 'StandardOrderEntity', name: string, pieceCount?: number | null, weight: number, totalCharge: number, refNumbers: Array<string>, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', masterAirwayBillOfLadingNumber?: string | null, shipperBillOfLadingNumber?: string | null }, billingPartyContact: { __typename?: 'CustomerContactEntity', displayName: string }, service?: { __typename?: 'ServiceEntity', name: string } | null, startStop?: { __typename?: 'StandardStopEntity', address: { __typename?: 'AddressEntity', name: string, line1: string, line2?: string | null, city: string, state: string, zip: string }, terminal?: { __typename?: 'TerminalEntity', name: string } | null } | null, endStop?: { __typename?: 'StandardStopEntity', address: { __typename?: 'AddressEntity', name: string, line1: string, line2?: string | null, city: string, state: string, zip: string }, terminal?: { __typename?: 'TerminalEntity', name: string } | null } | null } | null }> };

export type StopDriverMapForDriverCompletedStopsFragment = { __typename?: 'StopDriverMapForCompletedStopsEntity', serviceDate?: any | null, stopType?: StopType | null, isLineHaul?: boolean | null, driver: { __typename?: 'DriverEntity', uuid: string }, linehaulStartTerminal?: { __typename?: 'TerminalEntity', code: string } | null, linehaulEndTerminal?: { __typename?: 'TerminalEntity', code: string } | null, order?: { __typename?: 'StandardOrderEntity', name: string, pieceCount?: number | null, weight: number, totalCharge: number, refNumbers: Array<string>, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', masterAirwayBillOfLadingNumber?: string | null, shipperBillOfLadingNumber?: string | null }, billingPartyContact: { __typename?: 'CustomerContactEntity', displayName: string }, service?: { __typename?: 'ServiceEntity', name: string } | null, startStop?: { __typename?: 'StandardStopEntity', address: { __typename?: 'AddressEntity', name: string, line1: string, line2?: string | null, city: string, state: string, zip: string }, terminal?: { __typename?: 'TerminalEntity', name: string } | null } | null, endStop?: { __typename?: 'StandardStopEntity', address: { __typename?: 'AddressEntity', name: string, line1: string, line2?: string | null, city: string, state: string, zip: string }, terminal?: { __typename?: 'TerminalEntity', name: string } | null } | null } | null };

export type DriverCompletedStopsLogQueryVariables = Exact<{
  driverUuid?: InputMaybe<Scalars['String']['input']>;
  startDate: Scalars['DateTime']['input'];
  endDate: Scalars['DateTime']['input'];
}>;


export type DriverCompletedStopsLogQuery = { __typename?: 'Query', driverCompletedStopsLog: { __typename?: 'DriverCompletedStopsEntity', stopDriverMaps: Array<{ __typename?: 'StopDriverMapForCompletedStopsEntity', serviceDate?: any | null, stopType?: StopType | null, isLineHaul?: boolean | null, driver: { __typename?: 'DriverEntity', uuid: string }, linehaulStartTerminal?: { __typename?: 'TerminalEntity', code: string } | null, linehaulEndTerminal?: { __typename?: 'TerminalEntity', code: string } | null, order?: { __typename?: 'StandardOrderEntity', name: string, pieceCount?: number | null, weight: number, totalCharge: number, refNumbers: Array<string>, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', masterAirwayBillOfLadingNumber?: string | null, shipperBillOfLadingNumber?: string | null }, billingPartyContact: { __typename?: 'CustomerContactEntity', displayName: string }, service?: { __typename?: 'ServiceEntity', name: string } | null, startStop?: { __typename?: 'StandardStopEntity', address: { __typename?: 'AddressEntity', name: string, line1: string, line2?: string | null, city: string, state: string, zip: string }, terminal?: { __typename?: 'TerminalEntity', name: string } | null } | null, endStop?: { __typename?: 'StandardStopEntity', address: { __typename?: 'AddressEntity', name: string, line1: string, line2?: string | null, city: string, state: string, zip: string }, terminal?: { __typename?: 'TerminalEntity', name: string } | null } | null } | null }> } };

export type DriverSettlementBillByUuidQueryVariables = Exact<{
  uuid: Scalars['String']['input'];
}>;


export type DriverSettlementBillByUuidQuery = { __typename?: 'Query', driverSettlementBill: { __typename?: 'DriverSettlementBillEntity', uuid: string, name?: string | null, createdAt: any, billStartDate?: any | null, billEndDate?: any | null, payPeriod: string, settlementDate?: any | null, totalDriverPayoutPreDeduction?: number | null, finalizedDate?: any | null, driver: { __typename?: 'DriverEntity', uuid: string, firstName: string, lastName: string, user: { __typename?: 'UserEntity', name?: string | null } }, settlementDeductions: Array<{ __typename?: 'SettlementDeductionEntity', uuid: string, adjustmentType?: SettlementAdjustmentType | null, name: string, flatRate?: number | null, percentageDecimalRate?: number | null }> } };

export type DriverSettlementBillForDownloadFragment = { __typename?: 'DriverSettlementBillForDownloadEntity', billUuid: string, billName?: string | null, billStartDate?: any | null, billEndDate?: any | null, settlementDate?: any | null, finalizedDate?: any | null, driverFirstName?: string | null, driverLastName?: string | null, driverStationCode?: string | null, settlementDeductions?: Array<{ __typename?: 'SettlementDeductionForDownloadEntity', name?: string | null, flatRate?: number | null, percentageDecimalRate?: number | null }> | null, stopDriverMaps: Array<{ __typename?: 'StopDriverMapForDownloadEntity', stopUuid: string, arrivedAt?: any | null, completedAt?: any | null, stopType?: StopType | null, serviceName?: string | null, shipperBillOfLadingNumber?: string | null, orderName?: string | null, billingPartyContactName?: string | null, isAttempt: boolean, address?: { __typename?: 'StopDriverMapAddressForDownloadEntity', name: string, line1: string, line2?: string | null, city: string, state: string, zip: string, country: string } | null, driverSettlementTotalAmounts: { __typename?: 'DriverSettlementTotalAmountsOutput', totalChargesForSettlement: number, totalEligibleAmountForStop: number, totalDriverPayout: number }, packages: Array<{ __typename?: 'PackageEntity', uuid: string, quantity: number, weight?: number | null }>, otherDriversOnStop: Array<{ __typename?: 'StopDriverMapOtherDriverForDownloadEntity', uuid: string, firstName: string, lastName: string }>, order?: { __typename?: 'StandardOrderEntity', totalCharge: number } | null }> };

export type StopDriverMapForDownloadFragment = { __typename?: 'StopDriverMapForDownloadEntity', stopUuid: string, arrivedAt?: any | null, completedAt?: any | null, stopType?: StopType | null, serviceName?: string | null, shipperBillOfLadingNumber?: string | null, orderName?: string | null, billingPartyContactName?: string | null, isAttempt: boolean, address?: { __typename?: 'StopDriverMapAddressForDownloadEntity', name: string, line1: string, line2?: string | null, city: string, state: string, zip: string, country: string } | null, driverSettlementTotalAmounts: { __typename?: 'DriverSettlementTotalAmountsOutput', totalChargesForSettlement: number, totalEligibleAmountForStop: number, totalDriverPayout: number }, packages: Array<{ __typename?: 'PackageEntity', uuid: string, quantity: number, weight?: number | null }>, otherDriversOnStop: Array<{ __typename?: 'StopDriverMapOtherDriverForDownloadEntity', uuid: string, firstName: string, lastName: string }>, order?: { __typename?: 'StandardOrderEntity', totalCharge: number } | null };

export type StopDriverMapAddressForDownloadFragment = { __typename?: 'StopDriverMapAddressForDownloadEntity', name: string, line1: string, line2?: string | null, city: string, state: string, zip: string, country: string };

export type DriverSettlementBillFragment = { __typename?: 'DriverSettlementBillEntity', uuid: string, name?: string | null, createdAt: any, billStartDate?: any | null, billEndDate?: any | null, payPeriod: string, settlementDate?: any | null, totalDriverPayoutPreDeduction?: number | null, finalizedDate?: any | null, driver: { __typename?: 'DriverEntity', uuid: string, firstName: string, lastName: string, user: { __typename?: 'UserEntity', name?: string | null } }, settlementDeductions: Array<{ __typename?: 'SettlementDeductionEntity', uuid: string, adjustmentType?: SettlementAdjustmentType | null, name: string, flatRate?: number | null, percentageDecimalRate?: number | null }> };

export type DriverSettlementBillsCountQueryVariables = Exact<{ [key: string]: never; }>;


export type DriverSettlementBillsCountQuery = { __typename?: 'Query', driverSettlementBillsCountForCompany: number };

export type DriverSettlementBillsForDownloadQueryVariables = Exact<{
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  isFinalized?: InputMaybe<Scalars['Boolean']['input']>;
  driverUuid?: InputMaybe<Scalars['String']['input']>;
  searchText?: InputMaybe<Scalars['String']['input']>;
  uuids?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;


export type DriverSettlementBillsForDownloadQuery = { __typename?: 'Query', driverSettlementBillsForDownload: Array<{ __typename?: 'DriverSettlementBillForDownloadEntity', billUuid: string, billName?: string | null, billStartDate?: any | null, billEndDate?: any | null, settlementDate?: any | null, finalizedDate?: any | null, driverFirstName?: string | null, driverLastName?: string | null, driverStationCode?: string | null, settlementDeductions?: Array<{ __typename?: 'SettlementDeductionForDownloadEntity', name?: string | null, flatRate?: number | null, percentageDecimalRate?: number | null }> | null, stopDriverMaps: Array<{ __typename?: 'StopDriverMapForDownloadEntity', stopUuid: string, arrivedAt?: any | null, completedAt?: any | null, stopType?: StopType | null, serviceName?: string | null, shipperBillOfLadingNumber?: string | null, orderName?: string | null, billingPartyContactName?: string | null, isAttempt: boolean, address?: { __typename?: 'StopDriverMapAddressForDownloadEntity', name: string, line1: string, line2?: string | null, city: string, state: string, zip: string, country: string } | null, driverSettlementTotalAmounts: { __typename?: 'DriverSettlementTotalAmountsOutput', totalChargesForSettlement: number, totalEligibleAmountForStop: number, totalDriverPayout: number }, packages: Array<{ __typename?: 'PackageEntity', uuid: string, quantity: number, weight?: number | null }>, otherDriversOnStop: Array<{ __typename?: 'StopDriverMapOtherDriverForDownloadEntity', uuid: string, firstName: string, lastName: string }>, order?: { __typename?: 'StandardOrderEntity', totalCharge: number } | null }> }> };

export type DriverSettlementBillsV2QueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  sortByBillStartDateAscending?: InputMaybe<Scalars['Boolean']['input']>;
  sortBySettlementDateAscending?: InputMaybe<Scalars['Boolean']['input']>;
  isFinalized?: InputMaybe<Scalars['Boolean']['input']>;
  driverUuid?: InputMaybe<Scalars['String']['input']>;
  driverUuids?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  searchText?: InputMaybe<Scalars['String']['input']>;
}>;


export type DriverSettlementBillsV2Query = { __typename?: 'Query', driverSettlementBills: { __typename?: 'DriverSettlementBillConnection', totalCount?: number | null, edges: Array<{ __typename?: 'DriverSettlementBillEdge', node: { __typename?: 'DriverSettlementBillEntity', uuid: string, name?: string | null, payPeriod: string, settlementDate?: any | null, finalizedDate?: any | null, snapshotExists: boolean, driver: { __typename?: 'DriverEntity', uuid: string, user: { __typename?: 'UserEntity', name?: string | null } }, paymentInformation: { __typename?: 'DriverSettlementPaymentEntity', eligiblePay: any, netAdjustments: any, finalPay: any } } }>, pageInfo: { __typename?: 'PageInfo', startCursor?: string | null, endCursor?: string | null, hasNextPage: boolean, hasPreviousPage: boolean } } };

export type DriverSettlementBillsQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  sortByBillStartDateAscending?: InputMaybe<Scalars['Boolean']['input']>;
  sortBySettlementDateAscending?: InputMaybe<Scalars['Boolean']['input']>;
  isFinalized?: InputMaybe<Scalars['Boolean']['input']>;
  driverUuid?: InputMaybe<Scalars['String']['input']>;
  driverUuids?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  searchText?: InputMaybe<Scalars['String']['input']>;
}>;


export type DriverSettlementBillsQuery = { __typename?: 'Query', driverSettlementBills: { __typename?: 'DriverSettlementBillConnection', totalCount?: number | null, edges: Array<{ __typename?: 'DriverSettlementBillEdge', node: { __typename?: 'DriverSettlementBillEntity', uuid: string, name?: string | null, createdAt: any, billStartDate?: any | null, billEndDate?: any | null, payPeriod: string, settlementDate?: any | null, totalDriverPayoutPreDeduction?: number | null, finalizedDate?: any | null, driver: { __typename?: 'DriverEntity', uuid: string, firstName: string, lastName: string, user: { __typename?: 'UserEntity', name?: string | null } }, settlementDeductions: Array<{ __typename?: 'SettlementDeductionEntity', uuid: string, adjustmentType?: SettlementAdjustmentType | null, name: string, flatRate?: number | null, percentageDecimalRate?: number | null }> } }>, pageInfo: { __typename?: 'PageInfo', startCursor?: string | null, endCursor?: string | null, hasNextPage: boolean, hasPreviousPage: boolean } } };

export type FinalizeDriverSettlementBillsMutationVariables = Exact<{
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  isFinalized?: InputMaybe<Scalars['Boolean']['input']>;
  driverUuid?: InputMaybe<Scalars['String']['input']>;
  searchText?: InputMaybe<Scalars['String']['input']>;
  uuids?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;


export type FinalizeDriverSettlementBillsMutation = { __typename?: 'Mutation', finalizeDriverSettlementBills: number };

export type InvoiceShipmentByStopUuidQueryVariables = Exact<{
  uuid: Scalars['String']['input'];
}>;


export type InvoiceShipmentByStopUuidQuery = { __typename?: 'Query', stop: { __typename?: 'StandardStopEntity', shipment?: { __typename?: 'StandardShipmentEntity', uuid: string, overridePackageWeight: boolean, shipmentType: ShipmentType, status: ShipmentStatus, name: string, shipmentCharges: { __typename?: 'ShipmentChargeEntity', totalFreightCharge: number, totalFuelCharge: number, totalCharge: number }, shipperAddress?: { __typename?: 'AddressEntity', uuid: string, name: string, line1: string, line2?: string | null, city: string, state: string, zip: string, country: string, latitude?: number | null, longitude?: number | null, driverInstructions?: string | null, receivingHoursStart?: any | null, receivingHoursEnd?: any | null, specialInstructions?: string | null } | null, standardShipmentFields: { __typename?: 'StandardShipmentFieldsEntity', pickupOrDelivery: PickupOrDelivery }, legs: Array<{ __typename?: 'LegEntity', uuid: string, endStop: { __typename?: 'StandardStopEntity', completedAt?: any | null, paperworkMarkedComplete?: boolean | null, settlementDeductionName?: string | null, settlementDeductionFlatRate?: number | null, settlementDeductionPercentageRate?: number | null, stopType?: StopType | null, address: { __typename?: 'AddressEntity', uuid: string, name: string, line1: string, line2?: string | null, city: string, state: string, zip: string, country: string, latitude?: number | null, longitude?: number | null, driverInstructions?: string | null, receivingHoursStart?: any | null, receivingHoursEnd?: any | null, specialInstructions?: string | null } } }>, invoice?: { __typename?: 'InvoiceEntity', uuid: string } | null, charges: Array<{ __typename?: 'CustomChargeEntity', uuid: string, name: string, quantity: number, description?: string | null, rate: number, total: number, settlementFlatRate?: number | null, settlementPercentageRate?: number | null, postedFuelSurchargeRate?: number | null, customChargeBillingMethod: CustomChargeBillingMethod, accessorialTemplate?: { __typename: 'SkidBasedAccessorialEntity', uuid: string, name: string, invoiceDisplayName?: string | null } | { __typename: 'SpecialAccessorialEntity', uuid: string, name: string, invoiceDisplayName?: string | null } | { __typename: 'StandardAccessorialEntity', uuid: string, name: string, invoiceDisplayName?: string | null } | { __typename: 'UnitBasedAccessorialEntity', uuid: string, name: string, invoiceDisplayName?: string | null } | { __typename: 'WaitTimeAccessorialEntity', uuid: string, name: string, invoiceDisplayName?: string | null } | { __typename: 'WeightBasedAccessorialEntity', uuid: string, name: string, invoiceDisplayName?: string | null } | { __typename: 'ZoneBasedAccessorialEntity', uuid: string, name: string, invoiceDisplayName?: string | null } | null } | { __typename?: 'FreightChargeEntity', uuid: string, billingMethod: FreightBillingMethod, rate: number, description?: string | null, quantity: number, settlementFlatRate?: number | null, settlementPercentageRate?: number | null, tariff?: { __typename?: 'TariffEntity', uuid: string, tariffZone: { __typename?: 'TariffZoneEntity', name: string, type: TariffZoneType } } | null, fuelCharge?: { __typename?: 'FuelChargeEntity', surchargeRate: number, flatRate: number, type: FuelBillingMethod, uuid: string, settlementFlatRate?: number | null, settlementPercentageRate?: number | null } | null }> } | null } };

export type RemoveDriverSettlementBillMutationVariables = Exact<{
  uuid: Scalars['String']['input'];
}>;


export type RemoveDriverSettlementBillMutation = { __typename?: 'Mutation', removeDriverSettlementBill: { __typename?: 'DriverSettlementBillEntity', uuid: string } };

export type CreateSettlementDeductionMutationVariables = Exact<{
  settlementDeductionCreateInput: SettlementDeductionCreateInput;
}>;


export type CreateSettlementDeductionMutation = { __typename?: 'Mutation', createSettlementDeduction: { __typename?: 'SettlementDeductionEntity', uuid: string } };

export type RemoveSettlementDeductionMutationVariables = Exact<{
  uuid: Scalars['String']['input'];
}>;


export type RemoveSettlementDeductionMutation = { __typename?: 'Mutation', removeSettlementDeduction: { __typename?: 'SettlementDeductionEntity', uuid: string } };

export type SettlementDeductionFragment = { __typename?: 'SettlementDeductionEntity', uuid: string, adjustmentType?: SettlementAdjustmentType | null, name: string, flatRate?: number | null, percentageDecimalRate?: number | null };

export type UpdateSettlementDeductionMutationVariables = Exact<{
  settlementDeductionUpdateInput: SettlementDeductionUpdateInput;
}>;


export type UpdateSettlementDeductionMutation = { __typename?: 'Mutation', updateSettlementDeduction: { __typename?: 'SettlementDeductionEntity', uuid: string } };

export type StopDriverMapSummaryFragment = { __typename?: 'StopDriverMapEntity', uuid: string, name?: string | null, enableDriverSettlement?: boolean | null, revenuePercentageRate?: number | null, revenueFlatRate?: number | null, driverPayoutFinalized: boolean, driver: { __typename?: 'DriverEntity', uuid: string, firstName: string, lastName: string, driverType?: DriverType | null }, stop: { __typename?: 'StandardStopEntity', uuid: string, settlementDeductionName?: string | null, settlementDeductionFlatRate?: number | null, settlementDeductionPercentageRate?: number | null, stopType?: StopType | null, arrivedAt?: any | null, completedAt?: any | null, shipment?: { __typename?: 'StandardShipmentEntity', shipmentType: ShipmentType, order?: { __typename?: 'StandardOrderEntity', uuid: string, secondaryRefNumber?: string | null, refNumbers: Array<string>, name: string, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', shipperBillOfLadingNumber?: string | null }, billingPartyContact: { __typename?: 'CustomerContactEntity', displayName: string } } | null, standardShipmentFields: { __typename?: 'StandardShipmentFieldsEntity', pickupOrDelivery: PickupOrDelivery } } | null, address: { __typename?: 'AddressEntity', name: string } }, driverSettlementBill?: { __typename?: 'DriverSettlementBillEntity', name?: string | null, settlementDate?: any | null } | null, driverSettlementTotalAmounts: { __typename?: 'DriverSettlementTotalAmountsOutput', totalChargesForSettlement: number, totalEligibleAmountForStop: number, totalDriverPayout: number } };

export type StopDriverMapWithDriverSettlementTotalAmountsFragment = { __typename?: 'StopDriverMapEntity', driverSettlementTotalAmounts: { __typename?: 'DriverSettlementTotalAmountsOutput', totalChargesForSettlement: number, totalEligibleAmountForStop: number, totalDriverPayout: number } };

export type StopDriverMapFragment = { __typename?: 'StopDriverMapEntity', uuid: string, name?: string | null, enableDriverSettlement?: boolean | null, revenuePercentageRate?: number | null, revenueFlatRate?: number | null, driverPayoutFinalized: boolean, driver: { __typename?: 'DriverEntity', firstName: string, lastName: string, uuid: string, driverType?: DriverType | null, driverReferenceNumber?: string | null, defaultFuelSettlementPercentageRate?: number | null }, stop: { __typename?: 'StandardStopEntity', uuid: string, settlementDeductionName?: string | null, settlementDeductionFlatRate?: number | null, settlementDeductionPercentageRate?: number | null, stopType?: StopType | null, arrivedAt?: any | null, completedAt?: any | null, shipment?: { __typename?: 'StandardShipmentEntity', shipmentType: ShipmentType, order?: { __typename?: 'StandardOrderEntity', uuid: string, secondaryRefNumber?: string | null, refNumbers: Array<string>, name: string, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', shipperBillOfLadingNumber?: string | null } } | null, standardShipmentFields: { __typename?: 'StandardShipmentFieldsEntity', pickupOrDelivery: PickupOrDelivery, service?: { __typename?: 'ServiceEntity', name: string } | null }, packages: Array<{ __typename?: 'PackageEntity', quantity: number, weight?: number | null }> } | null, address: { __typename?: 'AddressEntity', uuid: string, name: string, line1: string, line2?: string | null, city: string, state: string, zip: string, country: string, latitude?: number | null, longitude?: number | null, driverInstructions?: string | null, receivingHoursStart?: any | null, receivingHoursEnd?: any | null, specialInstructions?: string | null } }, driverSettlementTotalAmounts: { __typename?: 'DriverSettlementTotalAmountsOutput', totalChargesForSettlement: number, totalEligibleAmountForStop: number, totalDriverPayout: number }, driverSettlementBill?: { __typename?: 'DriverSettlementBillEntity', name?: string | null } | null };

export type StopDriverMapsSummaryQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  noMaximum?: InputMaybe<Scalars['Boolean']['input']>;
  completedStartDate?: InputMaybe<Scalars['DateTime']['input']>;
  completedEndDate?: InputMaybe<Scalars['DateTime']['input']>;
  settlementStartDate?: InputMaybe<Scalars['DateTime']['input']>;
  settlementEndDate?: InputMaybe<Scalars['DateTime']['input']>;
  sortByCompletedDateAsc?: InputMaybe<Scalars['Boolean']['input']>;
  sortBySettlementDateAsc?: InputMaybe<Scalars['Boolean']['input']>;
  onDriverSettlementBill?: InputMaybe<Scalars['Boolean']['input']>;
  driverSettlementFinalized?: InputMaybe<Scalars['Boolean']['input']>;
  onInvoice?: InputMaybe<Scalars['Boolean']['input']>;
  chargesFinalized?: InputMaybe<Scalars['Boolean']['input']>;
  invoiceStatuses?: InputMaybe<Array<InvoiceStatus> | InvoiceStatus>;
  driverSettlementBillUuid?: InputMaybe<Scalars['String']['input']>;
  driverUuid?: InputMaybe<Scalars['String']['input']>;
  searchText?: InputMaybe<Scalars['String']['input']>;
  stopTypes?: InputMaybe<Array<StopType> | StopType>;
  includeStopDriverMapUuids?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  excludeStopDriverMapUuids?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  includeTotalAmounts: Scalars['Boolean']['input'];
}>;


export type StopDriverMapsSummaryQuery = { __typename?: 'Query', stopDriverMaps: { __typename?: 'StopDriverMapConnection', totalCount?: number | null, edges: Array<{ __typename?: 'StopDriverMapEdge', node: { __typename?: 'StopDriverMapEntity', uuid: string, name?: string | null, enableDriverSettlement?: boolean | null, revenuePercentageRate?: number | null, revenueFlatRate?: number | null, driverPayoutFinalized: boolean, driver: { __typename?: 'DriverEntity', uuid: string, firstName: string, lastName: string, driverType?: DriverType | null }, stop: { __typename?: 'StandardStopEntity', uuid: string, settlementDeductionName?: string | null, settlementDeductionFlatRate?: number | null, settlementDeductionPercentageRate?: number | null, stopType?: StopType | null, arrivedAt?: any | null, completedAt?: any | null, shipment?: { __typename?: 'StandardShipmentEntity', shipmentType: ShipmentType, order?: { __typename?: 'StandardOrderEntity', uuid: string, secondaryRefNumber?: string | null, refNumbers: Array<string>, name: string, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', shipperBillOfLadingNumber?: string | null }, billingPartyContact: { __typename?: 'CustomerContactEntity', displayName: string } } | null, standardShipmentFields: { __typename?: 'StandardShipmentFieldsEntity', pickupOrDelivery: PickupOrDelivery } } | null, address: { __typename?: 'AddressEntity', name: string } }, driverSettlementBill?: { __typename?: 'DriverSettlementBillEntity', name?: string | null, settlementDate?: any | null } | null, driverSettlementTotalAmounts: { __typename?: 'DriverSettlementTotalAmountsOutput', totalChargesForSettlement: number, totalEligibleAmountForStop: number, totalDriverPayout: number } } }>, pageInfo: { __typename?: 'PageInfo', startCursor?: string | null, endCursor?: string | null, hasNextPage: boolean, hasPreviousPage: boolean } } };

export type StopDriverMapsQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  noMaximum?: InputMaybe<Scalars['Boolean']['input']>;
  completedStartDate?: InputMaybe<Scalars['DateTime']['input']>;
  completedEndDate?: InputMaybe<Scalars['DateTime']['input']>;
  sortByCompletedDateAsc?: InputMaybe<Scalars['Boolean']['input']>;
  onDriverSettlementBill?: InputMaybe<Scalars['Boolean']['input']>;
  driverSettlementFinalized?: InputMaybe<Scalars['Boolean']['input']>;
  onInvoice?: InputMaybe<Scalars['Boolean']['input']>;
  chargesFinalized?: InputMaybe<Scalars['Boolean']['input']>;
  invoiceStatuses?: InputMaybe<Array<InvoiceStatus> | InvoiceStatus>;
  driverSettlementBillUuid?: InputMaybe<Scalars['String']['input']>;
  driverUuid?: InputMaybe<Scalars['String']['input']>;
  searchText?: InputMaybe<Scalars['String']['input']>;
  stopTypes?: InputMaybe<Array<StopType> | StopType>;
  includeStopDriverMapUuids?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  excludeStopDriverMapUuids?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;


export type StopDriverMapsQuery = { __typename?: 'Query', stopDriverMaps: { __typename?: 'StopDriverMapConnection', totalCount?: number | null, edges: Array<{ __typename?: 'StopDriverMapEdge', node: { __typename?: 'StopDriverMapEntity', uuid: string, name?: string | null, enableDriverSettlement?: boolean | null, revenuePercentageRate?: number | null, revenueFlatRate?: number | null, driverPayoutFinalized: boolean, driver: { __typename?: 'DriverEntity', firstName: string, lastName: string, uuid: string, driverType?: DriverType | null, driverReferenceNumber?: string | null, defaultFuelSettlementPercentageRate?: number | null }, stop: { __typename?: 'StandardStopEntity', uuid: string, settlementDeductionName?: string | null, settlementDeductionFlatRate?: number | null, settlementDeductionPercentageRate?: number | null, stopType?: StopType | null, arrivedAt?: any | null, completedAt?: any | null, shipment?: { __typename?: 'StandardShipmentEntity', shipmentType: ShipmentType, order?: { __typename?: 'StandardOrderEntity', uuid: string, secondaryRefNumber?: string | null, refNumbers: Array<string>, name: string, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', shipperBillOfLadingNumber?: string | null } } | null, standardShipmentFields: { __typename?: 'StandardShipmentFieldsEntity', pickupOrDelivery: PickupOrDelivery, service?: { __typename?: 'ServiceEntity', name: string } | null }, packages: Array<{ __typename?: 'PackageEntity', quantity: number, weight?: number | null }> } | null, address: { __typename?: 'AddressEntity', uuid: string, name: string, line1: string, line2?: string | null, city: string, state: string, zip: string, country: string, latitude?: number | null, longitude?: number | null, driverInstructions?: string | null, receivingHoursStart?: any | null, receivingHoursEnd?: any | null, specialInstructions?: string | null } }, driverSettlementTotalAmounts: { __typename?: 'DriverSettlementTotalAmountsOutput', totalChargesForSettlement: number, totalEligibleAmountForStop: number, totalDriverPayout: number }, driverSettlementBill?: { __typename?: 'DriverSettlementBillEntity', name?: string | null } | null } }>, pageInfo: { __typename?: 'PageInfo', startCursor?: string | null, endCursor?: string | null, hasNextPage: boolean, hasPreviousPage: boolean } } };

export type UpdateDriverSettlementBillMutationVariables = Exact<{
  updateDriverSettlementBillInput: UpdateDriverSettlementBillInput;
}>;


export type UpdateDriverSettlementBillMutation = { __typename?: 'Mutation', updateDriverSettlementBill: { __typename?: 'DriverSettlementBillEntity', uuid: string, name?: string | null, createdAt: any, billStartDate?: any | null, billEndDate?: any | null, payPeriod: string, settlementDate?: any | null, totalDriverPayoutPreDeduction?: number | null, finalizedDate?: any | null, driver: { __typename?: 'DriverEntity', uuid: string, firstName: string, lastName: string, user: { __typename?: 'UserEntity', name?: string | null } }, settlementDeductions: Array<{ __typename?: 'SettlementDeductionEntity', uuid: string, adjustmentType?: SettlementAdjustmentType | null, name: string, flatRate?: number | null, percentageDecimalRate?: number | null }> } };

export type UpdateStopDriverMapMutationVariables = Exact<{
  input: UpdateStopDriverMapInput;
}>;


export type UpdateStopDriverMapMutation = { __typename?: 'Mutation', updateStopDriverMap: { __typename?: 'StopDriverMapEntity', uuid: string, name?: string | null, enableDriverSettlement?: boolean | null, revenuePercentageRate?: number | null, revenueFlatRate?: number | null, driverPayoutFinalized: boolean, driver: { __typename?: 'DriverEntity', firstName: string, lastName: string, uuid: string, driverType?: DriverType | null, driverReferenceNumber?: string | null, defaultFuelSettlementPercentageRate?: number | null, user: { __typename?: 'UserEntity', name?: string | null }, defaultVehicle?: { __typename?: 'EquipmentEntity', uuid: string } | null, terminal?: { __typename?: 'TerminalEntity', uuid: string, name: string } | null, qualifications: Array<{ __typename?: 'DriverQualificationEntity', id: string }> }, driverSettlementBill?: { __typename?: 'DriverSettlementBillEntity', uuid: string } | null, stop: { __typename?: 'StandardStopEntity', uuid: string, completedAt?: any | null, settlementDeductionName?: string | null, settlementDeductionFlatRate?: number | null, settlementDeductionPercentageRate?: number | null } } };

export type CreateCsvOrderMappingMutationVariables = Exact<{
  createCsvOrderMappingInput: CreateCsvOrderMappingInput;
}>;


export type CreateCsvOrderMappingMutation = { __typename?: 'Mutation', createCsvOrderMapping: { __typename?: 'CsvOrderMappingEntity', uuid: string, name: string, enableDynamicInboundOrOutboundStop: boolean, enableInboundStop: boolean, enableOutboundStop: boolean, pickupOrDeliveryDefaultValue?: PickupOrDelivery | null, deadlineDateDefaultValue?: any | null, deadlineTypeDefaultValue?: DeadlineType | null, stopTypeDefaultValue?: StandardStopType | null, freightBillingMethodDefaultValue?: FreightBillingMethod | null, updateOrderOnDuplicateBolNumber?: boolean | null, csvOrderFieldMappings: Array<{ __typename?: 'CsvOrderFieldMappingEntity', sourceColumnName: string, targetFieldType: CsvOrderMappingTargetFieldType }>, contact?: { __typename?: 'CustomerContactEntity', uuid: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string } | null, serviceLevelDefaultValue?: { __typename?: 'ServiceEntity', uuid: string } | null } };

export type CsvOrderFieldMappingDetailedFragment = { __typename?: 'CsvOrderFieldMappingEntity', sourceColumnName: string, targetFieldType: CsvOrderMappingTargetFieldType };

export type CsvOrderMappingDetailedFragment = { __typename?: 'CsvOrderMappingEntity', uuid: string, name: string, enableDynamicInboundOrOutboundStop: boolean, enableInboundStop: boolean, enableOutboundStop: boolean, pickupOrDeliveryDefaultValue?: PickupOrDelivery | null, deadlineDateDefaultValue?: any | null, deadlineTypeDefaultValue?: DeadlineType | null, stopTypeDefaultValue?: StandardStopType | null, freightBillingMethodDefaultValue?: FreightBillingMethod | null, updateOrderOnDuplicateBolNumber?: boolean | null, csvOrderFieldMappings: Array<{ __typename?: 'CsvOrderFieldMappingEntity', sourceColumnName: string, targetFieldType: CsvOrderMappingTargetFieldType }>, contact?: { __typename?: 'CustomerContactEntity', uuid: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string } | null, serviceLevelDefaultValue?: { __typename?: 'ServiceEntity', uuid: string } | null };

export type CsvOrderMappingQueryVariables = Exact<{
  input: CsvOrderMappingQueryInput;
}>;


export type CsvOrderMappingQuery = { __typename?: 'Query', csvOrderMapping: { __typename?: 'CsvOrderMappingEntity', uuid: string, name: string, enableDynamicInboundOrOutboundStop: boolean, enableInboundStop: boolean, enableOutboundStop: boolean, pickupOrDeliveryDefaultValue?: PickupOrDelivery | null, deadlineDateDefaultValue?: any | null, deadlineTypeDefaultValue?: DeadlineType | null, stopTypeDefaultValue?: StandardStopType | null, freightBillingMethodDefaultValue?: FreightBillingMethod | null, updateOrderOnDuplicateBolNumber?: boolean | null, csvOrderFieldMappings: Array<{ __typename?: 'CsvOrderFieldMappingEntity', sourceColumnName: string, targetFieldType: CsvOrderMappingTargetFieldType }>, contact?: { __typename?: 'CustomerContactEntity', uuid: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string } | null, serviceLevelDefaultValue?: { __typename?: 'ServiceEntity', uuid: string } | null } };

export type CsvOrderMappingShallowFragment = { __typename?: 'CsvOrderMappingEntity', uuid: string, name: string, csvOrderFieldMappings: Array<{ __typename?: 'CsvOrderFieldMappingEntity', uuid: string }> };

export type CsvOrderMappingsForEmailToolQueryVariables = Exact<{ [key: string]: never; }>;


export type CsvOrderMappingsForEmailToolQuery = { __typename?: 'Query', csvOrderMappings: Array<{ __typename?: 'CsvOrderMappingEntity', uuid: string, name: string, csvOrderFieldMappings: Array<{ __typename?: 'CsvOrderFieldMappingEntity', uuid: string }> }> };

export type UpdateCsvOrderMappingMutationVariables = Exact<{
  updateCsvOrderMappingInput: UpdateCsvOrderMappingInput;
}>;


export type UpdateCsvOrderMappingMutation = { __typename?: 'Mutation', updateCsvOrderMapping: { __typename?: 'CsvOrderMappingEntity', uuid: string, name: string, enableDynamicInboundOrOutboundStop: boolean, enableInboundStop: boolean, enableOutboundStop: boolean, pickupOrDeliveryDefaultValue?: PickupOrDelivery | null, deadlineDateDefaultValue?: any | null, deadlineTypeDefaultValue?: DeadlineType | null, stopTypeDefaultValue?: StandardStopType | null, freightBillingMethodDefaultValue?: FreightBillingMethod | null, updateOrderOnDuplicateBolNumber?: boolean | null, csvOrderFieldMappings: Array<{ __typename?: 'CsvOrderFieldMappingEntity', sourceColumnName: string, targetFieldType: CsvOrderMappingTargetFieldType }>, contact?: { __typename?: 'CustomerContactEntity', uuid: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string } | null, serviceLevelDefaultValue?: { __typename?: 'ServiceEntity', uuid: string } | null } };

export type CreateEndOfDayDocumentProcessingJobMutationVariables = Exact<{
  createEndOfDayDocumentProcessingJobInput: CreateEndOfDayDocumentProcessingJobInput;
}>;


export type CreateEndOfDayDocumentProcessingJobMutation = { __typename?: 'Mutation', createEndOfDayDocumentProcessingJob: { __typename?: 'EndOfDayDocumentProcessingJobEntity', uuid: string } };

export type DetachDocumentsFromShipmentsMutationVariables = Exact<{
  detachDocumentsFromShipmentsInput: DetachDocumentsFromShipmentsInput;
}>;


export type DetachDocumentsFromShipmentsMutation = { __typename?: 'Mutation', detachDocumentsFromShipments: Array<{ __typename?: 'DocumentEntity', uuid: string, fileName: string, bucket: string, region: string, key: string, type: DocumentType, fileType: string }> };

export type DetachDocumentFromShipmentMutationVariables = Exact<{
  uuid: Scalars['String']['input'];
}>;


export type DetachDocumentFromShipmentMutation = { __typename?: 'Mutation', detachDocumentFromShipment: { __typename?: 'DocumentEntity', uuid: string, fileName: string, bucket: string, region: string, key: string, type: DocumentType, fileType: string } };

export type DocumentsByShipmentQueryVariables = Exact<{
  uuid: Scalars['String']['input'];
}>;


export type DocumentsByShipmentQuery = { __typename?: 'Query', shipmentV2?: { __typename?: 'StandardShipmentEntity', documents: Array<{ __typename?: 'DocumentEntity', uuid: string, fileName: string, bucket: string, region: string, key: string, uploadedAt?: any | null, fileType: string, isDeleted: boolean, preSignedGetUrl: string, name?: string | null, type: DocumentType, pageNumber?: number | null, createdAt: any, notes?: string | null, order?: { __typename?: 'StandardOrderEntity', uuid: string, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', shipperBillOfLadingNumber?: string | null } } | null, shipment?: { __typename?: 'StandardOrderEntity', uuid: string } | null, driverFormTemplate?: { __typename?: 'DriverSignableFormTemplateEntity', uuid: string, title: string, formText: string } | null }> } | null };

export type EndOfDocumentsProcessingJobFragment = { __typename?: 'EndOfDayDocumentProcessingJobEntity', uuid: string, dateUploadedFor: any, uploadedFileName: string, status: EndOfDayDocumentsProcessingJobStatus };

export type EndOfDayDocumentProcessingJobsQueryVariables = Exact<{
  companyUuid: Scalars['String']['input'];
  terminalUuid?: InputMaybe<Scalars['String']['input']>;
  dateUploadedFor: Scalars['DateTime']['input'];
  searchText?: InputMaybe<Scalars['String']['input']>;
}>;


export type EndOfDayDocumentProcessingJobsQuery = { __typename?: 'Query', endOfDayDocumentProcessingJobs: Array<{ __typename?: 'EndOfDayDocumentProcessingJobEntity', uuid: string, dateUploadedFor: any, uploadedFileName: string, status: EndOfDayDocumentsProcessingJobStatus }> };

export type ShallowRoutesWithDocumentsQueryVariables = Exact<{
  date: Scalars['DateTime']['input'];
  terminalUuid?: InputMaybe<Scalars['String']['input']>;
}>;


export type ShallowRoutesWithDocumentsQuery = { __typename?: 'Query', routes: Array<{ __typename?: 'RouteEntity', uuid: string, name: string, date: any, drivers: Array<{ __typename?: 'DriverEntity', firstName: string, lastName: string }>, slots: Array<{ __typename?: 'RouteSlotEntity', uuid: string, stops: Array<{ __typename?: 'StandardStopEntity', uuid: string, status: StopStatus, address: { __typename?: 'AddressEntity', city: string }, leg: { __typename?: 'LegEntity', uuid: string, shipment: { __typename?: 'StandardShipmentEntity', hasSignedPOD: boolean, documents: Array<{ __typename?: 'DocumentEntity', uuid: string, fileName: string, bucket: string, region: string, key: string, uploadedAt?: any | null, fileType: string, isDeleted: boolean, preSignedGetUrl: string, name?: string | null, type: DocumentType, pageNumber?: number | null, createdAt: any, notes?: string | null, order?: { __typename?: 'StandardOrderEntity', uuid: string, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', shipperBillOfLadingNumber?: string | null } } | null, shipment?: { __typename?: 'StandardOrderEntity', uuid: string } | null, driverFormTemplate?: { __typename?: 'DriverSignableFormTemplateEntity', uuid: string, title: string, formText: string } | null }> } } }> }> }> };

export type EquipmentFragment = { __typename?: 'EquipmentEntity', uuid: string, name: string, capacity?: number | null, measurementSystem: MeasurementSystem, weight?: number | null, length?: number | null, width?: number | null, height?: number | null, notes?: string | null, type: EquipmentType, samsaraVehicleId?: string | null, vehicleType?: { __typename?: 'VehicleTypeEntity', uuid: string, name: string, status: VehicleTypeStatus, maxVolume?: any | null, maxWeight?: any | null, capacityNotes?: string | null, vehicleTypePackageSpecs: Array<{ __typename?: 'VehicleTypePackageSpecEntity', id: string, maxQuantity?: number | null, packageSpec: { __typename?: 'PackageSpecEntity', id: string, name: string } }> } | null };

export type EquipmentQueryVariables = Exact<{
  uuid: Scalars['String']['input'];
}>;


export type EquipmentQuery = { __typename?: 'Query', equipment: { __typename?: 'EquipmentEntity', isActive: boolean, uuid: string, name: string, capacity?: number | null, measurementSystem: MeasurementSystem, weight?: number | null, length?: number | null, width?: number | null, height?: number | null, notes?: string | null, type: EquipmentType, samsaraVehicleId?: string | null, equipmentLicenses: Array<{ __typename?: 'EquipmentLicenseEntity', uuid: string, number: string, licenseType: string, licensingBody: string, issueDate: any, expiryDate: any }>, vehicleType?: { __typename?: 'VehicleTypeEntity', uuid: string, name: string, status: VehicleTypeStatus, maxVolume?: any | null, maxWeight?: any | null, capacityNotes?: string | null, vehicleTypePackageSpecs: Array<{ __typename?: 'VehicleTypePackageSpecEntity', id: string, maxQuantity?: number | null, packageSpec: { __typename?: 'PackageSpecEntity', id: string, name: string } }> } | null }, samsaraOAuthToken?: { __typename?: 'SamsaraOauthTokenEntity', uuid: string } | null };

export type EquipmentsQueryVariables = Exact<{
  includeNotActive?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type EquipmentsQuery = { __typename?: 'Query', equipments: Array<{ __typename?: 'EquipmentEntity', uuid: string, name: string, type: EquipmentType, samsaraVehicleId?: string | null, subtype?: string | null, isActive: boolean, vehicleType?: { __typename?: 'VehicleTypeEntity', uuid: string, name: string, status: VehicleTypeStatus, maxVolume?: any | null, maxWeight?: any | null, capacityNotes?: string | null, vehicleTypePackageSpecs: Array<{ __typename?: 'VehicleTypePackageSpecEntity', id: string, maxQuantity?: number | null, packageSpec: { __typename?: 'PackageSpecEntity', id: string, name: string } }> } | null }> };

export type FuelChargeFuelProfileDateRangeFragment = { __typename?: 'FuelProfileDateRangeEntity', uuid: string, startDate: any, expirationDate: any, surchargeRate?: number | null, flatRateUsdCents?: number | null };

export type FuelChargeFuelProfileDateRangeQueryVariables = Exact<{
  fuelChargeFuelProfileDateRangeInput: FuelChargeFuelProfileDateRangeInput;
}>;


export type FuelChargeFuelProfileDateRangeQuery = { __typename?: 'Query', fuelChargeFuelProfileDateRange: { __typename?: 'FuelChargeFuelProfileDateRangeOutput', fuelProfileDateRange?: { __typename?: 'FuelProfileDateRangeEntity', uuid: string, startDate: any, expirationDate: any, surchargeRate?: number | null, flatRateUsdCents?: number | null } | null } };

export type LineHaulFuelChargeFuelProfileDateRangeFragment = { __typename?: 'FuelProfileDateRangeEntity', uuid: string, startDate: any, expirationDate: any, surchargeRate?: number | null, flatRateUsdCents?: number | null };

export type LineHaulFuelChargeFuelProfileDateRangeQueryVariables = Exact<{
  lineHaulFuelChargeFuelProfileDateRangeInput: LineHaulFuelChargeFuelProfileDateRangeInput;
}>;


export type LineHaulFuelChargeFuelProfileDateRangeQuery = { __typename?: 'Query', lineHaulFuelChargeFuelProfileDateRange: { __typename?: 'LineHaulFuelChargeFuelProfileDateRangeOutput', fuelProfileDateRange?: { __typename?: 'FuelProfileDateRangeEntity', uuid: string, startDate: any, expirationDate: any, surchargeRate?: number | null, flatRateUsdCents?: number | null } | null } };

export type OrderForPackingSlipFragment = { __typename?: 'StandardOrderEntity', uuid: string, name: string, createdAt: any, billingPartyContact: { __typename?: 'CustomerContactEntity', uuid: string, displayName: string, defaultAddress?: { __typename?: 'AddressEntity', uuid: string, name: string, line1: string, line2?: string | null, city: string, state: string, zip: string, country: string } | null }, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', shipperBillOfLadingNumber?: string | null, masterAirwayBillOfLadingNumber?: string | null }, outboundShipment?: { __typename?: 'StandardShipmentEntity', standardShipmentFields: { __typename?: 'StandardShipmentFieldsEntity', deliveryDate?: any | null }, legs: Array<{ __typename?: 'LegEntity', endStop: { __typename?: 'StandardStopEntity', serviceDate?: any | null, outboundCarrier?: string | null, appointmentTime?: any | null, endAppointmentTime?: any | null, address: { __typename?: 'AddressEntity', name: string, line1: string, line2?: string | null, city: string, state: string, zip: string }, terminal?: { __typename?: 'TerminalEntity', code: string } | null, consigneeAddress?: { __typename?: 'AddressEntity', uuid: string, name: string, line1: string, line2?: string | null, city: string, state: string, zip: string } | null } }> } | null };

export type OrdersForPackingSlipQueryVariables = Exact<{
  searchText?: InputMaybe<Scalars['String']['input']>;
  billingPartyContactUuidsFilter?: InputMaybe<StringsFilter>;
}>;


export type OrdersForPackingSlipQuery = { __typename?: 'Query', orders: { __typename?: 'OrderConnection', edges: Array<{ __typename?: 'OrderEdge', node: { __typename?: 'StandardOrderEntity', uuid: string, name: string, createdAt: any, billingPartyContact: { __typename?: 'CustomerContactEntity', uuid: string, displayName: string, defaultAddress?: { __typename?: 'AddressEntity', uuid: string, name: string, line1: string, line2?: string | null, city: string, state: string, zip: string, country: string } | null }, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', shipperBillOfLadingNumber?: string | null, masterAirwayBillOfLadingNumber?: string | null }, outboundShipment?: { __typename?: 'StandardShipmentEntity', standardShipmentFields: { __typename?: 'StandardShipmentFieldsEntity', deliveryDate?: any | null }, legs: Array<{ __typename?: 'LegEntity', endStop: { __typename?: 'StandardStopEntity', serviceDate?: any | null, outboundCarrier?: string | null, appointmentTime?: any | null, endAppointmentTime?: any | null, address: { __typename?: 'AddressEntity', name: string, line1: string, line2?: string | null, city: string, state: string, zip: string }, terminal?: { __typename?: 'TerminalEntity', code: string } | null, consigneeAddress?: { __typename?: 'AddressEntity', uuid: string, name: string, line1: string, line2?: string | null, city: string, state: string, zip: string } | null } }> } | null } }> } };

export type PicklistsFragment = { __typename?: 'PicklistEntity', id: string, date: any, outboundReferenceNumber?: string | null, picklistItemGroups: Array<{ __typename?: 'PicklistItemGroupEntity', id: string, pickedQuantity: number, pickedStatus: PickedStatus, itemGroup: { __typename?: 'ItemGroupEntity', uuid: string, quantity: number, item: { __typename?: 'ItemEntity', sku: string, description?: string | null, primaryUOM: { __typename?: 'InventoryPrimaryUnitOfMeasureEntity', unitOfMeasure: UnitOfMeasure } }, storageUnit?: { __typename?: 'StorageUnitEntity', name: string, warehouseLocation?: { __typename?: 'WarehouseLocationEntity', name: string } | null, storageOrder?: { __typename?: 'StorageOrderEntity', uuid: string, referenceNumber: string, supplierCompanyName?: string | null, purchaseOrderNumber?: string | null, lotNumber?: string | null, contact: { __typename?: 'CustomerContactEntity', uuid: string, displayName: string, company: { __typename?: 'CompanyEntity', uuid: string }, defaultAddress?: { __typename?: 'AddressEntity', name: string, line1: string, line2?: string | null, city: string, state: string, zip: string, country: string } | null } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string, company: { __typename?: 'CompanyEntity', uuid: string }, defaultAddress?: { __typename?: 'AddressEntity', name: string, line1: string, line2?: string | null, city: string, state: string, zip: string, country: string } | null }, warehouse: { __typename?: 'WarehouseEntity', uuid: string, name: string } } | null } | null } }> };

export type PicklistsQueryVariables = Exact<{
  picklistsInput: PicklistsInput;
}>;


export type PicklistsQuery = { __typename?: 'Query', picklists: { __typename?: 'PicklistConnection', totalCount: number, edges: Array<{ __typename?: 'PicklistEdge', node: { __typename?: 'PicklistEntity', id: string, date: any, outboundReferenceNumber?: string | null, picklistItemGroups: Array<{ __typename?: 'PicklistItemGroupEntity', id: string, pickedQuantity: number, pickedStatus: PickedStatus, itemGroup: { __typename?: 'ItemGroupEntity', uuid: string, quantity: number, item: { __typename?: 'ItemEntity', sku: string, description?: string | null, primaryUOM: { __typename?: 'InventoryPrimaryUnitOfMeasureEntity', unitOfMeasure: UnitOfMeasure } }, storageUnit?: { __typename?: 'StorageUnitEntity', name: string, warehouseLocation?: { __typename?: 'WarehouseLocationEntity', name: string } | null, storageOrder?: { __typename?: 'StorageOrderEntity', uuid: string, referenceNumber: string, supplierCompanyName?: string | null, purchaseOrderNumber?: string | null, lotNumber?: string | null, contact: { __typename?: 'CustomerContactEntity', uuid: string, displayName: string, company: { __typename?: 'CompanyEntity', uuid: string }, defaultAddress?: { __typename?: 'AddressEntity', name: string, line1: string, line2?: string | null, city: string, state: string, zip: string, country: string } | null } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string, company: { __typename?: 'CompanyEntity', uuid: string }, defaultAddress?: { __typename?: 'AddressEntity', name: string, line1: string, line2?: string | null, city: string, state: string, zip: string, country: string } | null }, warehouse: { __typename?: 'WarehouseEntity', uuid: string, name: string } } | null } | null } }> } }>, pageInfo: { __typename?: 'PageInfo', startCursor?: string | null, endCursor?: string | null, hasNextPage: boolean, hasPreviousPage: boolean } } };

export type CompanyStatsQueryQueryVariables = Exact<{ [key: string]: never; }>;


export type CompanyStatsQueryQuery = { __typename?: 'Query', me?: { __typename?: 'UserEntity', company: { __typename?: 'CompanyEntity', uuid: string, companyStatistics?: { __typename?: 'CompanyStatsEntity', numberOfOrdersDueInFuture: number, numberOfUninvoicedOrdersDueInFuture: number, numberOfOrdersSixtyOneToNinety: number, numberOfOrdersThirtyOneToSixty: number, numberOfOrdersOneToThirty: number, numberOfUninvoicedOrdersSixtyOneToNinety: number, numberOfUninvoicedOrdersThirtyOneToSixty: number, numberOfUninvoicedOrdersOneToThirty: number, numberOfOrdersPastNinetyOne: number, numberOfUninvoicedOrdersPastNinetyOne: number } | null } } | null };

export type ConsolidatableOrderSummaryFragment = { __typename?: 'StandardOrderEntity', uuid: string, name: string, totalCharge: number, freightChargeRevenue: number, fuelChargeRevenue: number, weight: number, dimWeight: number, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', shipperBillOfLadingNumber?: string | null, weightUnits: WeightUnits }, customCharges: Array<{ __typename?: 'CustomChargeEntity', name: string, total: number, accessorialTemplate?: { __typename: 'SkidBasedAccessorialEntity', uuid: string, name: string } | { __typename: 'SpecialAccessorialEntity', uuid: string, name: string } | { __typename: 'StandardAccessorialEntity', uuid: string, name: string } | { __typename: 'UnitBasedAccessorialEntity', uuid: string, name: string } | { __typename: 'WaitTimeAccessorialEntity', uuid: string, name: string } | { __typename: 'WeightBasedAccessorialEntity', uuid: string, name: string } | { __typename: 'ZoneBasedAccessorialEntity', uuid: string, name: string } | null }>, packages: Array<{ __typename?: 'PackageEntity', uuid: string, quantity: number, type?: PackageType | null }>, shipments: Array<{ __typename?: 'StandardShipmentEntity', legs: Array<{ __typename?: 'LegEntity', endStop: { __typename?: 'StandardStopEntity', stopType?: StopType | null, address: { __typename?: 'AddressEntity', uuid: string, name: string, line1: string, line2?: string | null, city: string, state: string, zip: string, country: string, latitude?: number | null, longitude?: number | null, driverInstructions?: string | null, receivingHoursStart?: any | null, receivingHoursEnd?: any | null, specialInstructions?: string | null } } }> }> };

export type ConsolidatableOrderSummaryQueryVariables = Exact<{
  uuids: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type ConsolidatableOrderSummaryQuery = { __typename?: 'Query', ordersByUuids: Array<{ __typename?: 'StandardOrderEntity', uuid: string, name: string, totalCharge: number, freightChargeRevenue: number, fuelChargeRevenue: number, weight: number, dimWeight: number, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', shipperBillOfLadingNumber?: string | null, weightUnits: WeightUnits }, customCharges: Array<{ __typename?: 'CustomChargeEntity', name: string, total: number, accessorialTemplate?: { __typename: 'SkidBasedAccessorialEntity', uuid: string, name: string } | { __typename: 'SpecialAccessorialEntity', uuid: string, name: string } | { __typename: 'StandardAccessorialEntity', uuid: string, name: string } | { __typename: 'UnitBasedAccessorialEntity', uuid: string, name: string } | { __typename: 'WaitTimeAccessorialEntity', uuid: string, name: string } | { __typename: 'WeightBasedAccessorialEntity', uuid: string, name: string } | { __typename: 'ZoneBasedAccessorialEntity', uuid: string, name: string } | null }>, packages: Array<{ __typename?: 'PackageEntity', uuid: string, quantity: number, type?: PackageType | null }>, shipments: Array<{ __typename?: 'StandardShipmentEntity', legs: Array<{ __typename?: 'LegEntity', endStop: { __typename?: 'StandardStopEntity', stopType?: StopType | null, address: { __typename?: 'AddressEntity', uuid: string, name: string, line1: string, line2?: string | null, city: string, state: string, zip: string, country: string, latitude?: number | null, longitude?: number | null, driverInstructions?: string | null, receivingHoursStart?: any | null, receivingHoursEnd?: any | null, specialInstructions?: string | null } } }> }> }> };

type Contact_CustomerContactEntity_Fragment = { __typename?: 'CustomerContactEntity', defaultFuelSurcharge?: number | null, defaultUseTariff?: boolean | null, pickupDiscountRate?: any | null, deliveryDiscountRate?: any | null, transferDiscountRate?: any | null, lineHaulDiscountRate?: any | null, defaultDimFactor?: number | null, billingContactEmail?: string | null, defaultInvoiceType: InvoiceType, defaultInvoiceTransmissionMethod: InvoiceTransmissionMethod, defaultInvoiceDownloadDocuments: Array<DocumentType>, defaultInvoiceDocumentsRequired: Array<DocumentType>, defaultInvoiceEmailSubject?: string | null, identifier?: string | null, numberOfOrdersPerInvoice?: number | null, invoiceTimePeriodSplit?: TimePeriod | null, creditHoldLimitInCents?: number | null, enableCreditHold?: boolean | null, maxDaysOutstanding?: number | null, isPrepaidOnly: boolean, enableCustomerPortalOrderEntry: boolean, useCustomPackageSpecs: boolean, showEdiReferenceNumbersOnOrderPage: boolean, useCustomVehicleTypes: boolean, uuid: string, displayName: string, ediApplicationId?: string | null, ediContactCode?: string | null, isActive: boolean, isaId?: string | null, contactReferenceNumber?: string | null, shortCode?: string | null, stediPartnerId?: string | null, isOverCreditLimit: boolean, quickbooksDesktopContactId?: string | null, quickbooksMappingId?: string | null, fuelChargeQuickbooksMappingId?: string | null, freightChargeQuickbooksMappingId?: string | null, miscCustomChargeQuickbooksMappingId?: string | null, type: ContactType, billingCycle?: BillingCycleType | null, billingCycleDuration: BillingCycleDuration, billingPeriod?: number | null, requireDriverToCheckOffPackagesAtStop: boolean, invoiceNotes?: string | null, defaultAddress?: { __typename?: 'AddressEntity', uuid: string, name: string, line1: string, line2?: string | null, city: string, state: string, zip: string, country: string, latitude?: number | null, longitude?: number | null, driverInstructions?: string | null, receivingHoursStart?: any | null, receivingHoursEnd?: any | null, specialInstructions?: string | null } | null, defaultContactPerson?: { __typename?: 'ContactPersonEntity', uuid: string, firstName?: string | null, lastName?: string | null, email?: string | null, notes?: string | null, phone?: string | null, createdAt: any } | null, defaultInvoiceTerms?: { __typename?: 'InvoiceTermEntity', uuid: string, terms: string } | null, packageSpecs: Array<{ __typename?: 'PackageSpecEntity', id: string }>, vehicleTypes: Array<{ __typename?: 'VehicleTypeEntity', uuid: string }>, defaultInboundEdiService?: { __typename?: 'ServiceEntity', uuid: string, name: string } | null, defaultOutboundEdiService?: { __typename?: 'ServiceEntity', uuid: string, name: string } | null, defaultInboundOutboundEdiService?: { __typename?: 'ServiceEntity', uuid: string, name: string } | null, defaultOrdinaryTariffChain?: { __typename?: 'TariffChainEntity', id: string, name: string } | null, defaultLineHaulTariffChain?: { __typename?: 'TariffChainEntity', id: string, name: string } | null, defaultTransferTariffChain?: { __typename?: 'TariffChainEntity', id: string, name: string } | null, defaultPointToPointTariffChain?: { __typename?: 'TariffChainEntity', id: string, name: string } | null, masterAccount?: { __typename?: 'MasterAccountEntity', uuid: string, name: string } | null, contactComments: Array<{ __typename?: 'ContactCommentEntity', uuid: string, updatedAt: any, createdAt: any, comment: string, authorName: string }>, services: Array<{ __typename?: 'ServiceEntity', uuid: string, name: string, createdAt: any, updatedAt: any, timeInMinutes?: number | null, useApptInRouteOptimization: boolean, markOrdersAsSpecial: boolean, defaultAppointmentStartTime?: any | null, defaultAppointmentEndTime?: any | null, defaultStartNow: boolean, defaultInboundStopType?: StopType | null, defaultOutboundStopType?: StopType | null, defaultPickupPadding?: any | null, defaultDeliveryPadding?: any | null, defaultTotalDuration?: any | null, defaultIsLineHaul: boolean, defaultFulfillmentType?: FulfillmentType | null, isActive: boolean, isExposedToCustomers: boolean, serviceAvailabilityDates: Array<{ __typename?: 'ServiceAvailabilityDateEntity', id: string, dayCategory: SpecialDayOfWeek, enabled: boolean, start: { __typename?: 'PlainTime', hour: number, minute: number }, end: { __typename?: 'PlainTime', hour: number, minute: number } }> }>, invoicePdfColumns: Array<{ __typename?: 'PdfColumnEntity', uuid: string, orderColumnMapping?: OrderPdfColumnMapping | null, shipmentPDFColumnMapping?: ShipmentPdfColumnMapping | null, legPDFColumnMapping?: LegPdfColumnMapping | null, stopPDFColumnMapping?: StopPdfColumnMapping | null }>, addresses: Array<{ __typename?: 'AddressEntity', uuid: string, name: string, line1: string, line2?: string | null, city: string, state: string, zip: string, country: string, latitude?: number | null, longitude?: number | null, driverInstructions?: string | null, receivingHoursStart?: any | null, receivingHoursEnd?: any | null, specialInstructions?: string | null }>, contactPersons: Array<{ __typename?: 'ContactPersonEntity', uuid: string, firstName?: string | null, lastName?: string | null, email?: string | null, notes?: string | null, phone?: string | null, createdAt: any }>, defaultService?: { __typename?: 'ServiceEntity', uuid: string, name: string, createdAt: any, updatedAt: any, timeInMinutes?: number | null, useApptInRouteOptimization: boolean, markOrdersAsSpecial: boolean, defaultAppointmentStartTime?: any | null, defaultAppointmentEndTime?: any | null, defaultStartNow: boolean, defaultInboundStopType?: StopType | null, defaultOutboundStopType?: StopType | null, defaultPickupPadding?: any | null, defaultDeliveryPadding?: any | null, defaultTotalDuration?: any | null, defaultIsLineHaul: boolean, defaultFulfillmentType?: FulfillmentType | null, isActive: boolean, isExposedToCustomers: boolean, serviceAvailabilityDates: Array<{ __typename?: 'ServiceAvailabilityDateEntity', id: string, dayCategory: SpecialDayOfWeek, enabled: boolean, start: { __typename?: 'PlainTime', hour: number, minute: number }, end: { __typename?: 'PlainTime', hour: number, minute: number } }> } | null, businessDivision?: { __typename?: 'BusinessDivisionEntity', uuid: string, name: string } | null, referenceNumberLabels: Array<{ __typename?: 'ReferenceNumberLabelEntity', name: string }> };

type Contact_ThirdPartyContactEntity_Fragment = { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string, ediApplicationId?: string | null, ediContactCode?: string | null, isActive: boolean, isaId?: string | null, identifier?: string | null, contactReferenceNumber?: string | null, shortCode?: string | null, stediPartnerId?: string | null, isOverCreditLimit: boolean, quickbooksDesktopContactId?: string | null, quickbooksMappingId?: string | null, fuelChargeQuickbooksMappingId?: string | null, freightChargeQuickbooksMappingId?: string | null, miscCustomChargeQuickbooksMappingId?: string | null, type: ContactType, billingCycle?: BillingCycleType | null, billingCycleDuration: BillingCycleDuration, billingPeriod?: number | null, requireDriverToCheckOffPackagesAtStop: boolean, invoiceNotes?: string | null, masterAccount?: { __typename?: 'MasterAccountEntity', uuid: string, name: string } | null, contactComments: Array<{ __typename?: 'ContactCommentEntity', uuid: string, updatedAt: any, createdAt: any, comment: string, authorName: string }>, services: Array<{ __typename?: 'ServiceEntity', uuid: string, name: string, createdAt: any, updatedAt: any, timeInMinutes?: number | null, useApptInRouteOptimization: boolean, markOrdersAsSpecial: boolean, defaultAppointmentStartTime?: any | null, defaultAppointmentEndTime?: any | null, defaultStartNow: boolean, defaultInboundStopType?: StopType | null, defaultOutboundStopType?: StopType | null, defaultPickupPadding?: any | null, defaultDeliveryPadding?: any | null, defaultTotalDuration?: any | null, defaultIsLineHaul: boolean, defaultFulfillmentType?: FulfillmentType | null, isActive: boolean, isExposedToCustomers: boolean, serviceAvailabilityDates: Array<{ __typename?: 'ServiceAvailabilityDateEntity', id: string, dayCategory: SpecialDayOfWeek, enabled: boolean, start: { __typename?: 'PlainTime', hour: number, minute: number }, end: { __typename?: 'PlainTime', hour: number, minute: number } }> }>, invoicePdfColumns: Array<{ __typename?: 'PdfColumnEntity', uuid: string, orderColumnMapping?: OrderPdfColumnMapping | null, shipmentPDFColumnMapping?: ShipmentPdfColumnMapping | null, legPDFColumnMapping?: LegPdfColumnMapping | null, stopPDFColumnMapping?: StopPdfColumnMapping | null }>, addresses: Array<{ __typename?: 'AddressEntity', uuid: string, name: string, line1: string, line2?: string | null, city: string, state: string, zip: string, country: string, latitude?: number | null, longitude?: number | null, driverInstructions?: string | null, receivingHoursStart?: any | null, receivingHoursEnd?: any | null, specialInstructions?: string | null }>, contactPersons: Array<{ __typename?: 'ContactPersonEntity', uuid: string, firstName?: string | null, lastName?: string | null, email?: string | null, notes?: string | null, phone?: string | null, createdAt: any }>, defaultAddress?: { __typename?: 'AddressEntity', uuid: string, name: string, line1: string, line2?: string | null, city: string, state: string, zip: string, country: string, latitude?: number | null, longitude?: number | null, driverInstructions?: string | null, receivingHoursStart?: any | null, receivingHoursEnd?: any | null, specialInstructions?: string | null } | null, defaultContactPerson?: { __typename?: 'ContactPersonEntity', uuid: string, firstName?: string | null, lastName?: string | null, email?: string | null, notes?: string | null, phone?: string | null, createdAt: any } | null, defaultService?: { __typename?: 'ServiceEntity', uuid: string, name: string, createdAt: any, updatedAt: any, timeInMinutes?: number | null, useApptInRouteOptimization: boolean, markOrdersAsSpecial: boolean, defaultAppointmentStartTime?: any | null, defaultAppointmentEndTime?: any | null, defaultStartNow: boolean, defaultInboundStopType?: StopType | null, defaultOutboundStopType?: StopType | null, defaultPickupPadding?: any | null, defaultDeliveryPadding?: any | null, defaultTotalDuration?: any | null, defaultIsLineHaul: boolean, defaultFulfillmentType?: FulfillmentType | null, isActive: boolean, isExposedToCustomers: boolean, serviceAvailabilityDates: Array<{ __typename?: 'ServiceAvailabilityDateEntity', id: string, dayCategory: SpecialDayOfWeek, enabled: boolean, start: { __typename?: 'PlainTime', hour: number, minute: number }, end: { __typename?: 'PlainTime', hour: number, minute: number } }> } | null, businessDivision?: { __typename?: 'BusinessDivisionEntity', uuid: string, name: string } | null, referenceNumberLabels: Array<{ __typename?: 'ReferenceNumberLabelEntity', name: string }> };

export type ContactFragment = Contact_CustomerContactEntity_Fragment | Contact_ThirdPartyContactEntity_Fragment;

export type CreateConsolidatedOrderFromOrderMutationVariables = Exact<{
  createConsolidatedOrderFromOrderInput: CreateConsolidatedOrderFromOrderInput;
}>;


export type CreateConsolidatedOrderFromOrderMutation = { __typename?: 'Mutation', createConsolidatedOrderFromOrder: { __typename?: 'StandardOrderEntity', uuid: string } };

export type CreateConsolidatedOrderMutationVariables = Exact<{
  createConsolidatedOrderInput: CreateConsolidatedOrderInput;
}>;


export type CreateConsolidatedOrderMutation = { __typename?: 'Mutation', createConsolidatedOrder: { __typename?: 'StandardOrderEntity', uuid: string, shipments: Array<{ __typename?: 'StandardShipmentEntity', uuid: string }> } };

export type CurrentBillingPeriodInvoiceQueryVariables = Exact<{
  contactUuid: Scalars['String']['input'];
}>;


export type CurrentBillingPeriodInvoiceQuery = { __typename?: 'Query', currentBillingPeriodInvoice: Array<{ __typename?: 'InvoiceEntity', uuid: string, status: InvoiceStatus, createdAt: any, lastSyncedToQuickbooksAt?: any | null, quickbooksInvoiceId?: string | null, dueDate?: any | null, date: any, invoiceTotal: string, inConsolidatedInvoice: boolean, name: string, notes?: string | null, qbInvoiceNumber?: number | null, journalNumber: number, billToContact: { __typename?: 'CustomerContactEntity', uuid: string, displayName: string, defaultAddress?: { __typename?: 'AddressEntity', uuid: string } | null, addresses: Array<{ __typename?: 'AddressEntity', uuid: string }>, contactPersons: Array<{ __typename?: 'ContactPersonEntity', uuid: string }> } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string, defaultAddress?: { __typename?: 'AddressEntity', uuid: string } | null, addresses: Array<{ __typename?: 'AddressEntity', uuid: string }>, contactPersons: Array<{ __typename?: 'ContactPersonEntity', uuid: string }> }, documents: Array<{ __typename?: 'DocumentEntity', uuid: string, fileName: string, bucket: string, region: string, key: string, uploadedAt?: any | null, fileType: string, isDeleted: boolean, preSignedGetUrl: string, name?: string | null, type: DocumentType, pageNumber?: number | null, createdAt: any, notes?: string | null, order?: { __typename?: 'StandardOrderEntity', uuid: string, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', shipperBillOfLadingNumber?: string | null } } | null, shipment?: { __typename?: 'StandardOrderEntity', uuid: string } | null, driverFormTemplate?: { __typename?: 'DriverSignableFormTemplateEntity', uuid: string, title: string, formText: string } | null }>, invoiceTerms?: { __typename?: 'InvoiceTermEntity', uuid: string, terms: string } | null, shipments: Array<{ __typename?: 'StandardShipmentEntity', uuid: string, status: ShipmentStatus, totalChargesAmount: number, failureCount: number, hasFailedStop: boolean, name: string, overridePackageWeight: boolean, shouldUseDimWeight: boolean, totalCustomChargesAmount: number, totalFuelChargesAmount: number, totalFreightChargesAmount: number, shipmentType: ShipmentType, charges: Array<{ __typename?: 'CustomChargeEntity', uuid: string, name: string, zoneBasedAccessorialZoneUuid?: string | null, zoneBasedAccessorialChargeGroupUuid?: string | null, specialAccessorialTariffZoneUuid?: string | null, specialAccessorialChargeGroupUuid?: string | null, quantity: number, description?: string | null, rate: number, authoCode?: string | null, total: number, customChargeBillingMethod: CustomChargeBillingMethod, accessorialTemplate?: { __typename: 'SkidBasedAccessorialEntity', uuid: string, name: string, percentForSettlement?: number | null } | { __typename: 'SpecialAccessorialEntity', uuid: string, name: string, percentForSettlement?: number | null } | { __typename: 'StandardAccessorialEntity', uuid: string, name: string, percentForSettlement?: number | null } | { __typename: 'UnitBasedAccessorialEntity', uuid: string, name: string, percentForSettlement?: number | null } | { __typename: 'WaitTimeAccessorialEntity', uuid: string, name: string, percentForSettlement?: number | null } | { __typename: 'WeightBasedAccessorialEntity', uuid: string, name: string, percentForSettlement?: number | null } | { __typename: 'ZoneBasedAccessorialEntity', uuid: string, name: string, percentForSettlement?: number | null } | null } | { __typename?: 'FreightChargeEntity', uuid: string, description?: string | null, quantity: number, billingMethod: FreightBillingMethod, rate: number, authoCode?: string | null, tariff?: { __typename?: 'TariffEntity', uuid: string, billingPartyContactUuid?: string | null, tariffOverageRates: Array<{ __typename?: 'TariffOverageRateEntity', uuid: string, name: string, type: TariffOverageRateType, rateUsdCents: number, applicableAboveAmount: number }>, tariffZone: { __typename?: 'TariffZoneEntity', name: string, type: TariffZoneType } } | null, fuelCharge?: { __typename?: 'FuelChargeEntity', description?: string | null, surchargeRate: number, uuid: string, flatRate: number, authoCode?: string | null, type: FuelBillingMethod } | null }>, customCharges: Array<{ __typename?: 'CustomChargeEntity', uuid: string, description?: string | null, name: string, quantity: number, rate: number, zoneBasedAccessorialChargeGroupUuid?: string | null, zoneBasedAccessorialZoneUuid?: string | null, specialAccessorialTariffZoneUuid?: string | null, specialAccessorialChargeGroupUuid?: string | null, customChargeBillingMethod: CustomChargeBillingMethod, accessorialTemplate?: { __typename?: 'SkidBasedAccessorialEntity', uuid: string, name: string, percentForSettlement?: number | null } | { __typename?: 'SpecialAccessorialEntity', uuid: string, name: string, percentForSettlement?: number | null } | { __typename?: 'StandardAccessorialEntity', uuid: string, name: string, percentForSettlement?: number | null } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string, name: string, percentForSettlement?: number | null } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string, name: string, percentForSettlement?: number | null } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string, name: string, percentForSettlement?: number | null } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string, name: string, percentForSettlement?: number | null } | null }>, freightCharge?: { __typename?: 'FreightChargeEntity', uuid: string, billingMethod: FreightBillingMethod, description?: string | null, quantity: number, rate: number, fuelCharge?: { __typename?: 'FuelChargeEntity', description?: string | null, surchargeRate: number, uuid: string, freightCharge: { __typename?: 'FreightChargeEntity', uuid: string } } | null, tariff?: { __typename?: 'TariffEntity', uuid: string, billingPartyContactUuid?: string | null, tariffOverageRates: Array<{ __typename?: 'TariffOverageRateEntity', uuid: string, name: string, type: TariffOverageRateType, rateUsdCents: number, applicableAboveAmount: number }> } | null } | null, legs: Array<{ __typename?: 'LegEntity', uuid: string, miles?: number | null, endStop: { __typename?: 'StandardStopEntity', isSpecial?: boolean | null, uuid: string, arrivedAt?: any | null, completedAt?: any | null, status: StopStatus, appointmentRequired: boolean, proofOfDeliverySignee?: string | null, paperworkMarkedComplete?: boolean | null, address: { __typename?: 'AddressEntity', uuid: string, name: string, line1: string, line2?: string | null, city: string, state: string, zip: string, country: string, latitude?: number | null, longitude?: number | null, driverInstructions?: string | null, receivingHoursStart?: any | null, receivingHoursEnd?: any | null, specialInstructions?: string | null } } }>, order?: { __typename?: 'StandardOrderEntity', uuid: string, secondaryRefNumber?: string | null, orderInvoiceByDate?: any | null, name: string, createdAt: any, refNumbers: Array<string>, totalCharge: number, ediTransactions: Array<{ __typename?: 'EdiTransactionEntity', code: EdiTransactionCode, status: EdiTransactionStatus }>, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', shipperBillOfLadingNumber?: string | null, uuid: string, masterAirwayBillOfLadingNumber?: string | null, weightUnits: WeightUnits }, shipments: Array<{ __typename?: 'StandardShipmentEntity', uuid: string, documents: Array<{ __typename?: 'DocumentEntity', uuid: string, fileName: string, bucket: string, region: string, key: string, uploadedAt?: any | null, fileType: string, isDeleted: boolean, preSignedGetUrl: string, name?: string | null, type: DocumentType, pageNumber?: number | null, createdAt: any, notes?: string | null, order?: { __typename?: 'StandardOrderEntity', uuid: string, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', shipperBillOfLadingNumber?: string | null } } | null, shipment?: { __typename?: 'StandardOrderEntity', uuid: string } | null, driverFormTemplate?: { __typename?: 'DriverSignableFormTemplateEntity', uuid: string, title: string, formText: string } | null }> }>, billingPartyContact: { __typename?: 'CustomerContactEntity', businessDivision?: { __typename?: 'BusinessDivisionEntity', name: string } | null } } | null, packages: Array<{ __typename?: 'PackageEntity', uuid: string, weight?: number | null, description: string, quantity: number, length?: number | null, width?: number | null, height?: number | null, type?: PackageType | null, class?: number | null, hazmat?: boolean | null, nmfc?: string | null, skuNumber?: string | null, quantityCompletedAtStop?: number | null, reasonUncompletedAtStop?: string | null, packageSpec?: { __typename?: 'PackageSpecEntity', id: string, name: string } | null, warehouseLocation?: { __typename?: 'WarehouseLocationEntity', uuid: string, name: string } | null }>, standardShipmentFields: { __typename?: 'StandardShipmentFieldsEntity', uuid: string, deliveryDate?: any | null, pickupOrDelivery: PickupOrDelivery, dimFactor: number, type: StandardShipmentType, shipmentWeight: number, service?: { __typename?: 'ServiceEntity', uuid: string, name: string, createdAt: any, updatedAt: any, timeInMinutes?: number | null, useApptInRouteOptimization: boolean, markOrdersAsSpecial: boolean, defaultAppointmentStartTime?: any | null, defaultAppointmentEndTime?: any | null, defaultStartNow: boolean, defaultInboundStopType?: StopType | null, defaultOutboundStopType?: StopType | null, defaultPickupPadding?: any | null, defaultDeliveryPadding?: any | null, defaultTotalDuration?: any | null, defaultIsLineHaul: boolean, defaultFulfillmentType?: FulfillmentType | null, isActive: boolean, isExposedToCustomers: boolean, serviceAvailabilityDates: Array<{ __typename?: 'ServiceAvailabilityDateEntity', id: string, dayCategory: SpecialDayOfWeek, enabled: boolean, start: { __typename?: 'PlainTime', hour: number, minute: number }, end: { __typename?: 'PlainTime', hour: number, minute: number } }> } | null }, documents: Array<{ __typename?: 'DocumentEntity', uuid: string, fileName: string, bucket: string, region: string, key: string, uploadedAt?: any | null, fileType: string, isDeleted: boolean, preSignedGetUrl: string, name?: string | null, type: DocumentType, pageNumber?: number | null, createdAt: any, notes?: string | null, order?: { __typename?: 'StandardOrderEntity', uuid: string, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', shipperBillOfLadingNumber?: string | null } } | null, shipment?: { __typename?: 'StandardOrderEntity', uuid: string } | null, driverFormTemplate?: { __typename?: 'DriverSignableFormTemplateEntity', uuid: string, title: string, formText: string } | null }> }> }> };

export type HandleMultipleInvoices210OutboundMutationVariables = Exact<{
  handleMultiple210OutboundInput: HandleMultiple210OutboundInput;
}>;


export type HandleMultipleInvoices210OutboundMutation = { __typename?: 'Mutation', handleMultipleInvoices210Outbound: boolean };

export type InvoiceForDownloadFragmentFragment = { __typename?: 'InvoiceEntity', uuid: string, dueDate?: any | null, date: any, name: string, journalNumber: number, billToContact: { __typename?: 'CustomerContactEntity', uuid: string, displayName: string, invoiceNotes?: string | null, defaultAddress?: { __typename?: 'AddressEntity', uuid: string, name: string, line1: string, line2?: string | null, city: string, state: string, zip: string, country: string, latitude?: number | null, longitude?: number | null, driverInstructions?: string | null, receivingHoursStart?: any | null, receivingHoursEnd?: any | null, specialInstructions?: string | null } | null, businessDivision?: { __typename?: 'BusinessDivisionEntity', name: string } | null } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string, invoiceNotes?: string | null, defaultAddress?: { __typename?: 'AddressEntity', uuid: string, name: string, line1: string, line2?: string | null, city: string, state: string, zip: string, country: string, latitude?: number | null, longitude?: number | null, driverInstructions?: string | null, receivingHoursStart?: any | null, receivingHoursEnd?: any | null, specialInstructions?: string | null } | null, businessDivision?: { __typename?: 'BusinessDivisionEntity', name: string } | null }, invoiceTerms?: { __typename?: 'InvoiceTermEntity', uuid: string, terms: string } | null, shipments: Array<{ __typename?: 'StandardShipmentEntity', name: string, shipmentType: ShipmentType, standardShipmentFields: { __typename?: 'StandardShipmentFieldsEntity', pickupOrDelivery: PickupOrDelivery }, inputForConsolidatedOrder?: { __typename?: 'StandardOrderEntity', name: string } | null, shipmentCharges: { __typename?: 'ShipmentChargeEntity', totalCharge: number, totalFreightCharge: number, totalFuelCharge: number }, packages: Array<{ __typename?: 'PackageEntity', length?: number | null, width?: number | null, height?: number | null, quantity: number, weight?: number | null }>, order?: { __typename?: 'StandardOrderEntity', uuid: string, isCrossDock?: boolean | null, name: string, refNumbers: Array<string>, secondaryRefNumber?: string | null, consolidatedShipmentString?: string | null, orderComments: Array<{ __typename?: 'OrderCommentEntity', uuid: string, comment: string, showOnInvoice?: boolean | null }>, documents: Array<{ __typename?: 'DocumentEntity', uuid: string, fileName: string, bucket: string, region: string, key: string, uploadedAt?: any | null, fileType: string, isDeleted: boolean, preSignedGetUrl: string, name?: string | null, type: DocumentType, pageNumber?: number | null, createdAt: any, notes?: string | null, order?: { __typename?: 'StandardOrderEntity', uuid: string, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', shipperBillOfLadingNumber?: string | null } } | null, shipment?: { __typename?: 'StandardOrderEntity', uuid: string } | null, driverFormTemplate?: { __typename?: 'DriverSignableFormTemplateEntity', uuid: string, title: string, formText: string } | null }>, service?: { __typename?: 'ServiceEntity', name: string } | null, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', shipperBillOfLadingNumber?: string | null, masterAirwayBillOfLadingNumber?: string | null, dimFactor?: number | null } } | null, charges: Array<{ __typename?: 'CustomChargeEntity', name: string, description?: string | null, total: number, authoCode?: string | null, accessorialTemplate?: { __typename?: 'SkidBasedAccessorialEntity', name: string, invoiceDisplayName?: string | null } | { __typename?: 'SpecialAccessorialEntity', name: string, invoiceDisplayName?: string | null } | { __typename?: 'StandardAccessorialEntity', name: string, invoiceDisplayName?: string | null } | { __typename?: 'UnitBasedAccessorialEntity', name: string, invoiceDisplayName?: string | null } | { __typename?: 'WaitTimeAccessorialEntity', name: string, invoiceDisplayName?: string | null } | { __typename?: 'WeightBasedAccessorialEntity', name: string, invoiceDisplayName?: string | null } | { __typename?: 'ZoneBasedAccessorialEntity', name: string, invoiceDisplayName?: string | null } | null } | { __typename?: 'FreightChargeEntity', description?: string | null, authoCode?: string | null, tariff?: { __typename?: 'TariffEntity', tariffZone: { __typename?: 'TariffZoneEntity', type: TariffZoneType, name: string } } | null, fuelCharge?: { __typename?: 'FuelChargeEntity', description?: string | null, authoCode?: string | null } | null }>, legs: Array<{ __typename?: 'LegEntity', endStop: { __typename?: 'StandardStopEntity', completedAt?: any | null, proofOfDeliverySignee?: string | null, address: { __typename?: 'AddressEntity', name: string, line1: string, line2?: string | null, zip: string, city: string, state: string } } }> }> };

export type InvoicePdfColumnFragmentFragment = { __typename?: 'PdfColumnEntity', uuid: string, orderColumnMapping?: OrderPdfColumnMapping | null, shipmentPDFColumnMapping?: ShipmentPdfColumnMapping | null, legPDFColumnMapping?: LegPdfColumnMapping | null, stopPDFColumnMapping?: StopPdfColumnMapping | null };

export type InvoiceShipmentOrderForDownloadFragmentFragment = { __typename?: 'StandardOrderEntity', uuid: string, isCrossDock?: boolean | null, name: string, refNumbers: Array<string>, secondaryRefNumber?: string | null, consolidatedShipmentString?: string | null, orderComments: Array<{ __typename?: 'OrderCommentEntity', uuid: string, comment: string, showOnInvoice?: boolean | null }>, documents: Array<{ __typename?: 'DocumentEntity', uuid: string, fileName: string, bucket: string, region: string, key: string, uploadedAt?: any | null, fileType: string, isDeleted: boolean, preSignedGetUrl: string, name?: string | null, type: DocumentType, pageNumber?: number | null, createdAt: any, notes?: string | null, order?: { __typename?: 'StandardOrderEntity', uuid: string, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', shipperBillOfLadingNumber?: string | null } } | null, shipment?: { __typename?: 'StandardOrderEntity', uuid: string } | null, driverFormTemplate?: { __typename?: 'DriverSignableFormTemplateEntity', uuid: string, title: string, formText: string } | null }>, service?: { __typename?: 'ServiceEntity', name: string } | null, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', shipperBillOfLadingNumber?: string | null, masterAirwayBillOfLadingNumber?: string | null, dimFactor?: number | null } };

export type InvoiceShipmentForDownloadFragmentFragment = { __typename?: 'StandardShipmentEntity', name: string, shipmentType: ShipmentType, standardShipmentFields: { __typename?: 'StandardShipmentFieldsEntity', pickupOrDelivery: PickupOrDelivery }, inputForConsolidatedOrder?: { __typename?: 'StandardOrderEntity', name: string } | null, shipmentCharges: { __typename?: 'ShipmentChargeEntity', totalCharge: number, totalFreightCharge: number, totalFuelCharge: number }, packages: Array<{ __typename?: 'PackageEntity', length?: number | null, width?: number | null, height?: number | null, quantity: number, weight?: number | null }>, order?: { __typename?: 'StandardOrderEntity', uuid: string, isCrossDock?: boolean | null, name: string, refNumbers: Array<string>, secondaryRefNumber?: string | null, consolidatedShipmentString?: string | null, orderComments: Array<{ __typename?: 'OrderCommentEntity', uuid: string, comment: string, showOnInvoice?: boolean | null }>, documents: Array<{ __typename?: 'DocumentEntity', uuid: string, fileName: string, bucket: string, region: string, key: string, uploadedAt?: any | null, fileType: string, isDeleted: boolean, preSignedGetUrl: string, name?: string | null, type: DocumentType, pageNumber?: number | null, createdAt: any, notes?: string | null, order?: { __typename?: 'StandardOrderEntity', uuid: string, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', shipperBillOfLadingNumber?: string | null } } | null, shipment?: { __typename?: 'StandardOrderEntity', uuid: string } | null, driverFormTemplate?: { __typename?: 'DriverSignableFormTemplateEntity', uuid: string, title: string, formText: string } | null }>, service?: { __typename?: 'ServiceEntity', name: string } | null, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', shipperBillOfLadingNumber?: string | null, masterAirwayBillOfLadingNumber?: string | null, dimFactor?: number | null } } | null, charges: Array<{ __typename?: 'CustomChargeEntity', name: string, description?: string | null, total: number, authoCode?: string | null, accessorialTemplate?: { __typename?: 'SkidBasedAccessorialEntity', name: string, invoiceDisplayName?: string | null } | { __typename?: 'SpecialAccessorialEntity', name: string, invoiceDisplayName?: string | null } | { __typename?: 'StandardAccessorialEntity', name: string, invoiceDisplayName?: string | null } | { __typename?: 'UnitBasedAccessorialEntity', name: string, invoiceDisplayName?: string | null } | { __typename?: 'WaitTimeAccessorialEntity', name: string, invoiceDisplayName?: string | null } | { __typename?: 'WeightBasedAccessorialEntity', name: string, invoiceDisplayName?: string | null } | { __typename?: 'ZoneBasedAccessorialEntity', name: string, invoiceDisplayName?: string | null } | null } | { __typename?: 'FreightChargeEntity', description?: string | null, authoCode?: string | null, tariff?: { __typename?: 'TariffEntity', tariffZone: { __typename?: 'TariffZoneEntity', type: TariffZoneType, name: string } } | null, fuelCharge?: { __typename?: 'FuelChargeEntity', description?: string | null, authoCode?: string | null } | null }>, legs: Array<{ __typename?: 'LegEntity', endStop: { __typename?: 'StandardStopEntity', completedAt?: any | null, proofOfDeliverySignee?: string | null, address: { __typename?: 'AddressEntity', name: string, line1: string, line2?: string | null, zip: string, city: string, state: string } } }> };

export type InvoiceFragmentFragment = { __typename?: 'InvoiceEntity', uuid: string, status: InvoiceStatus, createdAt: any, lastSyncedToQuickbooksAt?: any | null, quickbooksInvoiceId?: string | null, dueDate?: any | null, date: any, invoiceTotal: string, inConsolidatedInvoice: boolean, name: string, notes?: string | null, qbInvoiceNumber?: number | null, journalNumber: number, billToContact: { __typename?: 'CustomerContactEntity', uuid: string, displayName: string, defaultAddress?: { __typename?: 'AddressEntity', uuid: string } | null, addresses: Array<{ __typename?: 'AddressEntity', uuid: string }>, contactPersons: Array<{ __typename?: 'ContactPersonEntity', uuid: string }> } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string, defaultAddress?: { __typename?: 'AddressEntity', uuid: string } | null, addresses: Array<{ __typename?: 'AddressEntity', uuid: string }>, contactPersons: Array<{ __typename?: 'ContactPersonEntity', uuid: string }> }, documents: Array<{ __typename?: 'DocumentEntity', uuid: string, fileName: string, bucket: string, region: string, key: string, uploadedAt?: any | null, fileType: string, isDeleted: boolean, preSignedGetUrl: string, name?: string | null, type: DocumentType, pageNumber?: number | null, createdAt: any, notes?: string | null, order?: { __typename?: 'StandardOrderEntity', uuid: string, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', shipperBillOfLadingNumber?: string | null } } | null, shipment?: { __typename?: 'StandardOrderEntity', uuid: string } | null, driverFormTemplate?: { __typename?: 'DriverSignableFormTemplateEntity', uuid: string, title: string, formText: string } | null }>, invoiceTerms?: { __typename?: 'InvoiceTermEntity', uuid: string, terms: string } | null, shipments: Array<{ __typename?: 'StandardShipmentEntity', uuid: string, status: ShipmentStatus, totalChargesAmount: number, failureCount: number, hasFailedStop: boolean, name: string, overridePackageWeight: boolean, shouldUseDimWeight: boolean, totalCustomChargesAmount: number, totalFuelChargesAmount: number, totalFreightChargesAmount: number, shipmentType: ShipmentType, charges: Array<{ __typename?: 'CustomChargeEntity', uuid: string, name: string, zoneBasedAccessorialZoneUuid?: string | null, zoneBasedAccessorialChargeGroupUuid?: string | null, specialAccessorialTariffZoneUuid?: string | null, specialAccessorialChargeGroupUuid?: string | null, quantity: number, description?: string | null, rate: number, authoCode?: string | null, total: number, customChargeBillingMethod: CustomChargeBillingMethod, accessorialTemplate?: { __typename: 'SkidBasedAccessorialEntity', uuid: string, name: string, percentForSettlement?: number | null } | { __typename: 'SpecialAccessorialEntity', uuid: string, name: string, percentForSettlement?: number | null } | { __typename: 'StandardAccessorialEntity', uuid: string, name: string, percentForSettlement?: number | null } | { __typename: 'UnitBasedAccessorialEntity', uuid: string, name: string, percentForSettlement?: number | null } | { __typename: 'WaitTimeAccessorialEntity', uuid: string, name: string, percentForSettlement?: number | null } | { __typename: 'WeightBasedAccessorialEntity', uuid: string, name: string, percentForSettlement?: number | null } | { __typename: 'ZoneBasedAccessorialEntity', uuid: string, name: string, percentForSettlement?: number | null } | null } | { __typename?: 'FreightChargeEntity', uuid: string, description?: string | null, quantity: number, billingMethod: FreightBillingMethod, rate: number, authoCode?: string | null, tariff?: { __typename?: 'TariffEntity', uuid: string, billingPartyContactUuid?: string | null, tariffOverageRates: Array<{ __typename?: 'TariffOverageRateEntity', uuid: string, name: string, type: TariffOverageRateType, rateUsdCents: number, applicableAboveAmount: number }>, tariffZone: { __typename?: 'TariffZoneEntity', name: string, type: TariffZoneType } } | null, fuelCharge?: { __typename?: 'FuelChargeEntity', description?: string | null, surchargeRate: number, uuid: string, flatRate: number, authoCode?: string | null, type: FuelBillingMethod } | null }>, customCharges: Array<{ __typename?: 'CustomChargeEntity', uuid: string, description?: string | null, name: string, quantity: number, rate: number, zoneBasedAccessorialChargeGroupUuid?: string | null, zoneBasedAccessorialZoneUuid?: string | null, specialAccessorialTariffZoneUuid?: string | null, specialAccessorialChargeGroupUuid?: string | null, customChargeBillingMethod: CustomChargeBillingMethod, accessorialTemplate?: { __typename?: 'SkidBasedAccessorialEntity', uuid: string, name: string, percentForSettlement?: number | null } | { __typename?: 'SpecialAccessorialEntity', uuid: string, name: string, percentForSettlement?: number | null } | { __typename?: 'StandardAccessorialEntity', uuid: string, name: string, percentForSettlement?: number | null } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string, name: string, percentForSettlement?: number | null } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string, name: string, percentForSettlement?: number | null } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string, name: string, percentForSettlement?: number | null } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string, name: string, percentForSettlement?: number | null } | null }>, freightCharge?: { __typename?: 'FreightChargeEntity', uuid: string, billingMethod: FreightBillingMethod, description?: string | null, quantity: number, rate: number, fuelCharge?: { __typename?: 'FuelChargeEntity', description?: string | null, surchargeRate: number, uuid: string, freightCharge: { __typename?: 'FreightChargeEntity', uuid: string } } | null, tariff?: { __typename?: 'TariffEntity', uuid: string, billingPartyContactUuid?: string | null, tariffOverageRates: Array<{ __typename?: 'TariffOverageRateEntity', uuid: string, name: string, type: TariffOverageRateType, rateUsdCents: number, applicableAboveAmount: number }> } | null } | null, legs: Array<{ __typename?: 'LegEntity', uuid: string, miles?: number | null, endStop: { __typename?: 'StandardStopEntity', isSpecial?: boolean | null, uuid: string, arrivedAt?: any | null, completedAt?: any | null, status: StopStatus, appointmentRequired: boolean, proofOfDeliverySignee?: string | null, paperworkMarkedComplete?: boolean | null, address: { __typename?: 'AddressEntity', uuid: string, name: string, line1: string, line2?: string | null, city: string, state: string, zip: string, country: string, latitude?: number | null, longitude?: number | null, driverInstructions?: string | null, receivingHoursStart?: any | null, receivingHoursEnd?: any | null, specialInstructions?: string | null } } }>, order?: { __typename?: 'StandardOrderEntity', uuid: string, secondaryRefNumber?: string | null, orderInvoiceByDate?: any | null, name: string, createdAt: any, refNumbers: Array<string>, totalCharge: number, ediTransactions: Array<{ __typename?: 'EdiTransactionEntity', code: EdiTransactionCode, status: EdiTransactionStatus }>, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', shipperBillOfLadingNumber?: string | null, uuid: string, masterAirwayBillOfLadingNumber?: string | null, weightUnits: WeightUnits }, shipments: Array<{ __typename?: 'StandardShipmentEntity', uuid: string, documents: Array<{ __typename?: 'DocumentEntity', uuid: string, fileName: string, bucket: string, region: string, key: string, uploadedAt?: any | null, fileType: string, isDeleted: boolean, preSignedGetUrl: string, name?: string | null, type: DocumentType, pageNumber?: number | null, createdAt: any, notes?: string | null, order?: { __typename?: 'StandardOrderEntity', uuid: string, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', shipperBillOfLadingNumber?: string | null } } | null, shipment?: { __typename?: 'StandardOrderEntity', uuid: string } | null, driverFormTemplate?: { __typename?: 'DriverSignableFormTemplateEntity', uuid: string, title: string, formText: string } | null }> }>, billingPartyContact: { __typename?: 'CustomerContactEntity', businessDivision?: { __typename?: 'BusinessDivisionEntity', name: string } | null } } | null, packages: Array<{ __typename?: 'PackageEntity', uuid: string, weight?: number | null, description: string, quantity: number, length?: number | null, width?: number | null, height?: number | null, type?: PackageType | null, class?: number | null, hazmat?: boolean | null, nmfc?: string | null, skuNumber?: string | null, quantityCompletedAtStop?: number | null, reasonUncompletedAtStop?: string | null, packageSpec?: { __typename?: 'PackageSpecEntity', id: string, name: string } | null, warehouseLocation?: { __typename?: 'WarehouseLocationEntity', uuid: string, name: string } | null }>, standardShipmentFields: { __typename?: 'StandardShipmentFieldsEntity', uuid: string, deliveryDate?: any | null, pickupOrDelivery: PickupOrDelivery, dimFactor: number, type: StandardShipmentType, shipmentWeight: number, service?: { __typename?: 'ServiceEntity', uuid: string, name: string, createdAt: any, updatedAt: any, timeInMinutes?: number | null, useApptInRouteOptimization: boolean, markOrdersAsSpecial: boolean, defaultAppointmentStartTime?: any | null, defaultAppointmentEndTime?: any | null, defaultStartNow: boolean, defaultInboundStopType?: StopType | null, defaultOutboundStopType?: StopType | null, defaultPickupPadding?: any | null, defaultDeliveryPadding?: any | null, defaultTotalDuration?: any | null, defaultIsLineHaul: boolean, defaultFulfillmentType?: FulfillmentType | null, isActive: boolean, isExposedToCustomers: boolean, serviceAvailabilityDates: Array<{ __typename?: 'ServiceAvailabilityDateEntity', id: string, dayCategory: SpecialDayOfWeek, enabled: boolean, start: { __typename?: 'PlainTime', hour: number, minute: number }, end: { __typename?: 'PlainTime', hour: number, minute: number } }> } | null }, documents: Array<{ __typename?: 'DocumentEntity', uuid: string, fileName: string, bucket: string, region: string, key: string, uploadedAt?: any | null, fileType: string, isDeleted: boolean, preSignedGetUrl: string, name?: string | null, type: DocumentType, pageNumber?: number | null, createdAt: any, notes?: string | null, order?: { __typename?: 'StandardOrderEntity', uuid: string, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', shipperBillOfLadingNumber?: string | null } } | null, shipment?: { __typename?: 'StandardOrderEntity', uuid: string } | null, driverFormTemplate?: { __typename?: 'DriverSignableFormTemplateEntity', uuid: string, title: string, formText: string } | null }> }> };

export type InvoicesQueryVariables = Exact<{
  inConsolidatedInvoice?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  createdAtStartDate?: InputMaybe<Scalars['DateTime']['input']>;
  createdAtEndDate?: InputMaybe<Scalars['DateTime']['input']>;
  invoiceStartDate?: InputMaybe<Scalars['DateTime']['input']>;
  invoiceEndDate?: InputMaybe<Scalars['DateTime']['input']>;
  statuses?: InputMaybe<Array<InvoiceStatus> | InvoiceStatus>;
  searchText?: InputMaybe<Scalars['String']['input']>;
  billingPartyContactUuid?: InputMaybe<Scalars['String']['input']>;
  sortByDueDateAscending?: InputMaybe<Scalars['Boolean']['input']>;
  sortByDueDateDescending?: InputMaybe<Scalars['Boolean']['input']>;
  groupByContact?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type InvoicesQuery = { __typename?: 'Query', invoices: { __typename?: 'InvoiceConnection', edges: Array<{ __typename?: 'InvoiceEdge', node: { __typename?: 'InvoiceEntity', uuid: string, qbInvoiceNumber?: number | null, name: string, status: InvoiceStatus, createdAt: any, inConsolidatedInvoice: boolean, invoiceTotal: string, dueDate?: any | null, lastSyncedToQuickbooksAt?: any | null, quickbooksInvoiceId?: string | null, date: any, notes?: string | null, journalNumber: number, invoiceTerms?: { __typename?: 'InvoiceTermEntity', terms: string, uuid: string } | null, shipments: Array<{ __typename?: 'StandardShipmentEntity', uuid: string, status: ShipmentStatus, totalChargesAmount: number, name: string, hasFailedStop: boolean, failureCount: number, overridePackageWeight: boolean, shouldUseDimWeight: boolean, totalCustomChargesAmount: number, totalFuelChargesAmount: number, totalFreightChargesAmount: number, shipmentType: ShipmentType, charges: Array<{ __typename?: 'CustomChargeEntity', uuid: string, name: string, zoneBasedAccessorialZoneUuid?: string | null, zoneBasedAccessorialChargeGroupUuid?: string | null, specialAccessorialTariffZoneUuid?: string | null, specialAccessorialChargeGroupUuid?: string | null, quantity: number, description?: string | null, rate: number, authoCode?: string | null, total: number, customChargeBillingMethod: CustomChargeBillingMethod, accessorialTemplate?: { __typename: 'SkidBasedAccessorialEntity', uuid: string, name: string, percentForSettlement?: number | null } | { __typename: 'SpecialAccessorialEntity', uuid: string, name: string, percentForSettlement?: number | null } | { __typename: 'StandardAccessorialEntity', uuid: string, name: string, percentForSettlement?: number | null } | { __typename: 'UnitBasedAccessorialEntity', uuid: string, name: string, percentForSettlement?: number | null } | { __typename: 'WaitTimeAccessorialEntity', uuid: string, name: string, percentForSettlement?: number | null } | { __typename: 'WeightBasedAccessorialEntity', uuid: string, name: string, percentForSettlement?: number | null } | { __typename: 'ZoneBasedAccessorialEntity', uuid: string, name: string, percentForSettlement?: number | null } | null } | { __typename?: 'FreightChargeEntity', uuid: string, description?: string | null, quantity: number, billingMethod: FreightBillingMethod, rate: number, authoCode?: string | null, tariff?: { __typename?: 'TariffEntity', uuid: string, billingPartyContactUuid?: string | null, tariffOverageRates: Array<{ __typename?: 'TariffOverageRateEntity', uuid: string, name: string, type: TariffOverageRateType, rateUsdCents: number, applicableAboveAmount: number }>, tariffZone: { __typename?: 'TariffZoneEntity', name: string, type: TariffZoneType } } | null, fuelCharge?: { __typename?: 'FuelChargeEntity', description?: string | null, surchargeRate: number, uuid: string, flatRate: number, authoCode?: string | null, type: FuelBillingMethod } | null }>, order?: { __typename?: 'StandardOrderEntity', uuid: string, secondaryRefNumber?: string | null, orderInvoiceByDate?: any | null, name: string, createdAt: any, refNumbers: Array<string>, totalCharge: number, ediTransactions: Array<{ __typename?: 'EdiTransactionEntity', code: EdiTransactionCode, status: EdiTransactionStatus }>, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', shipperBillOfLadingNumber?: string | null, uuid: string, masterAirwayBillOfLadingNumber?: string | null, weightUnits: WeightUnits }, shipments: Array<{ __typename?: 'StandardShipmentEntity', uuid: string, documents: Array<{ __typename?: 'DocumentEntity', uuid: string, fileName: string, bucket: string, region: string, key: string, uploadedAt?: any | null, fileType: string, isDeleted: boolean, preSignedGetUrl: string, name?: string | null, type: DocumentType, pageNumber?: number | null, createdAt: any, notes?: string | null, order?: { __typename?: 'StandardOrderEntity', uuid: string, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', shipperBillOfLadingNumber?: string | null } } | null, shipment?: { __typename?: 'StandardOrderEntity', uuid: string } | null, driverFormTemplate?: { __typename?: 'DriverSignableFormTemplateEntity', uuid: string, title: string, formText: string } | null }> }>, billingPartyContact: { __typename?: 'CustomerContactEntity', businessDivision?: { __typename?: 'BusinessDivisionEntity', name: string } | null } } | null, legs: Array<{ __typename?: 'LegEntity', uuid: string, miles?: number | null, endStop: { __typename?: 'StandardStopEntity', isSpecial?: boolean | null, uuid: string, arrivedAt?: any | null, completedAt?: any | null, status: StopStatus, appointmentRequired: boolean, proofOfDeliverySignee?: string | null, paperworkMarkedComplete?: boolean | null, address: { __typename?: 'AddressEntity', uuid: string, name: string, line1: string, line2?: string | null, city: string, state: string, zip: string, country: string, latitude?: number | null, longitude?: number | null, driverInstructions?: string | null, receivingHoursStart?: any | null, receivingHoursEnd?: any | null, specialInstructions?: string | null } } }>, standardShipmentFields: { __typename?: 'StandardShipmentFieldsEntity', uuid: string, deliveryDate?: any | null, pickupOrDelivery: PickupOrDelivery, dimFactor: number, type: StandardShipmentType, shipmentWeight: number, service?: { __typename?: 'ServiceEntity', uuid: string, name: string, createdAt: any, updatedAt: any, timeInMinutes?: number | null, useApptInRouteOptimization: boolean, markOrdersAsSpecial: boolean, defaultAppointmentStartTime?: any | null, defaultAppointmentEndTime?: any | null, defaultStartNow: boolean, defaultInboundStopType?: StopType | null, defaultOutboundStopType?: StopType | null, defaultPickupPadding?: any | null, defaultDeliveryPadding?: any | null, defaultTotalDuration?: any | null, defaultIsLineHaul: boolean, defaultFulfillmentType?: FulfillmentType | null, isActive: boolean, isExposedToCustomers: boolean, serviceAvailabilityDates: Array<{ __typename?: 'ServiceAvailabilityDateEntity', id: string, dayCategory: SpecialDayOfWeek, enabled: boolean, start: { __typename?: 'PlainTime', hour: number, minute: number }, end: { __typename?: 'PlainTime', hour: number, minute: number } }> } | null }, documents: Array<{ __typename?: 'DocumentEntity', uuid: string, fileName: string, bucket: string, region: string, key: string, uploadedAt?: any | null, fileType: string, isDeleted: boolean, preSignedGetUrl: string, name?: string | null, type: DocumentType, pageNumber?: number | null, createdAt: any, notes?: string | null, order?: { __typename?: 'StandardOrderEntity', uuid: string, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', shipperBillOfLadingNumber?: string | null } } | null, shipment?: { __typename?: 'StandardOrderEntity', uuid: string } | null, driverFormTemplate?: { __typename?: 'DriverSignableFormTemplateEntity', uuid: string, title: string, formText: string } | null }>, packages: Array<{ __typename?: 'PackageEntity', uuid: string, weight?: number | null, description: string, quantity: number, length?: number | null, width?: number | null, height?: number | null, type?: PackageType | null, class?: number | null, hazmat?: boolean | null, nmfc?: string | null, skuNumber?: string | null, quantityCompletedAtStop?: number | null, reasonUncompletedAtStop?: string | null, packageSpec?: { __typename?: 'PackageSpecEntity', id: string, name: string } | null, warehouseLocation?: { __typename?: 'WarehouseLocationEntity', uuid: string, name: string } | null }>, freightCharge?: { __typename?: 'FreightChargeEntity', uuid: string, billingMethod: FreightBillingMethod, rate: number, description?: string | null, quantity: number, tariff?: { __typename?: 'TariffEntity', uuid: string, billingPartyContactUuid?: string | null, tariffOverageRates: Array<{ __typename?: 'TariffOverageRateEntity', uuid: string, name: string, type: TariffOverageRateType, rateUsdCents: number, applicableAboveAmount: number }> } | null, fuelCharge?: { __typename?: 'FuelChargeEntity', description?: string | null, type: FuelBillingMethod, flatRate: number, surchargeRate: number, uuid: string, freightCharge: { __typename?: 'FreightChargeEntity', uuid: string } } | null } | null, customCharges: Array<{ __typename?: 'CustomChargeEntity', uuid: string, name: string, zoneBasedAccessorialZoneUuid?: string | null, zoneBasedAccessorialChargeGroupUuid?: string | null, specialAccessorialTariffZoneUuid?: string | null, specialAccessorialChargeGroupUuid?: string | null, quantity: number, description?: string | null, rate: number, customChargeBillingMethod: CustomChargeBillingMethod, accessorialTemplate?: { __typename?: 'SkidBasedAccessorialEntity', uuid: string, name: string, percentForSettlement?: number | null } | { __typename?: 'SpecialAccessorialEntity', uuid: string, name: string, percentForSettlement?: number | null } | { __typename?: 'StandardAccessorialEntity', uuid: string, name: string, percentForSettlement?: number | null } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string, name: string, percentForSettlement?: number | null } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string, name: string, percentForSettlement?: number | null } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string, name: string, percentForSettlement?: number | null } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string, name: string, percentForSettlement?: number | null } | null }> }>, billToContact: { __typename?: 'CustomerContactEntity', uuid: string, displayName: string, defaultAddress?: { __typename?: 'AddressEntity', uuid: string } | null, addresses: Array<{ __typename?: 'AddressEntity', uuid: string }>, contactPersons: Array<{ __typename?: 'ContactPersonEntity', uuid: string }> } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string, defaultAddress?: { __typename?: 'AddressEntity', uuid: string } | null, addresses: Array<{ __typename?: 'AddressEntity', uuid: string }>, contactPersons: Array<{ __typename?: 'ContactPersonEntity', uuid: string }> }, documents: Array<{ __typename?: 'DocumentEntity', uuid: string, fileName: string, bucket: string, region: string, key: string, uploadedAt?: any | null, fileType: string, isDeleted: boolean, preSignedGetUrl: string, name?: string | null, type: DocumentType, pageNumber?: number | null, createdAt: any, notes?: string | null, order?: { __typename?: 'StandardOrderEntity', uuid: string, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', shipperBillOfLadingNumber?: string | null } } | null, shipment?: { __typename?: 'StandardOrderEntity', uuid: string } | null, driverFormTemplate?: { __typename?: 'DriverSignableFormTemplateEntity', uuid: string, title: string, formText: string } | null }> } }>, pageInfo: { __typename?: 'PageInfo', startCursor?: string | null, endCursor?: string | null, hasPreviousPage: boolean, hasNextPage: boolean } } };

export type MarkConsolidatableOrdersAsBilledIndividuallyMutationVariables = Exact<{
  markConsolidatableOrdersAsBilledIndividuallyInput: MarkConsolidatableOrdersAsBilledIndividuallyInput;
}>;


export type MarkConsolidatableOrdersAsBilledIndividuallyMutation = { __typename?: 'Mutation', markConsolidatableOrdersAsBilledIndividually: Array<{ __typename?: 'StandardOrderEntity', uuid: string, shouldBillIndividually: boolean }> };

export type OutstandingOrdersForReviewQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  isFinalized?: InputMaybe<Scalars['Boolean']['input']>;
  hasIssues?: InputMaybe<Scalars['Boolean']['input']>;
  isUnfinalized?: InputMaybe<Scalars['Boolean']['input']>;
  isCancelled?: InputMaybe<Scalars['Boolean']['input']>;
  contactUuid?: InputMaybe<Scalars['String']['input']>;
  billingPartyContactUuids?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  originTerminalUuid?: InputMaybe<Scalars['String']['input']>;
  destinationTerminalUuid?: InputMaybe<Scalars['String']['input']>;
  searchText?: InputMaybe<Scalars['String']['input']>;
  uuids: Array<Scalars['String']['input']> | Scalars['String']['input'];
  orderCompletionStartDate?: InputMaybe<Scalars['DateTime']['input']>;
  orderCompletionEndDate?: InputMaybe<Scalars['DateTime']['input']>;
  multipleSearches?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  includeUuids?: InputMaybe<Scalars['Boolean']['input']>;
  sorts?: InputMaybe<Array<OrderSort> | OrderSort>;
}>;


export type OutstandingOrdersForReviewQuery = { __typename?: 'Query', outstandingOrdersForReview: { __typename?: 'OrderConnection', totalCount?: number | null, uuids?: Array<string> | null, edges: Array<{ __typename?: 'OrderEdge', node: { __typename?: 'StandardOrderEntity', totalCharge: number, updatedAt: any, orderSegmentType: OrderSegmentType, fulfillmentType?: FulfillmentType | null, isOverdue: boolean, detailedStatusV2?: OrderDetailedStatus | null, isCrossDock?: boolean | null, issueReason?: string | null, personName?: string | null, personPhoneNumber?: string | null, personEmail?: string | null, name: string, notes: string, onHand?: boolean | null, dateMarkedOnHand?: any | null, refNumbers: Array<string>, orderConsolidationType: OrderConsolidationType, orderInvoiceByDate?: any | null, paymentMethod?: PaymentMethod | null, source: OrderSource, status: OrderStatus, uuid: string, isDraftOrder: boolean, chargeableWeightCubicMeters?: any | null, totalSkids?: number | null, isReweighed?: boolean | null, secondaryRefNumber?: string | null, lockSecondaryRefNumber: boolean, tertiaryRefNumber?: string | null, quaternaryRefNumber?: string | null, quinaryRefNumber?: string | null, lineHaulCompletedDate: any, consolidatedShipmentString?: string | null, shouldBillIndividually: boolean, enableLineHaul: boolean, inBond?: boolean | null, hazmat?: boolean | null, tags: Array<{ __typename?: 'TagEntity', uuid: string, value: string, color?: string | null }>, thirdPartyBrokers: Array<{ __typename?: 'ThirdPartyBrokerEntity', uuid: string, name: string }>, service?: { __typename?: 'ServiceEntity', uuid: string, name: string } | null, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', uuid: string, shipperBillOfLadingNumber?: string | null, lockShipperBillOfLadingNumber: boolean, masterAirwayBillOfLadingNumber?: string | null, dimFactor?: number | null, measurementUnits: MeasurementUnits, weightUnits: WeightUnits }, documents: Array<{ __typename?: 'DocumentEntity', uuid: string, fileName: string, bucket: string, region: string, key: string, uploadedAt?: any | null, fileType: string, isDeleted: boolean, preSignedGetUrl: string, name?: string | null, type: DocumentType, pageNumber?: number | null, createdAt: any, notes?: string | null, order?: { __typename?: 'StandardOrderEntity', uuid: string, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', shipperBillOfLadingNumber?: string | null } } | null, shipment?: { __typename?: 'StandardOrderEntity', uuid: string } | null, driverFormTemplate?: { __typename?: 'DriverSignableFormTemplateEntity', uuid: string, title: string, formText: string } | null }>, paperwork: { __typename?: 'OrderPaperworkEntity', paperworkComplete: boolean, paperworkMarkedCompleteOverride?: boolean | null, attachedDocuments?: Array<DocumentType> | null, missingDocuments?: Array<DocumentType> | null }, billingPartyContact: { __typename?: 'CustomerContactEntity', uuid: string, displayName: string, numberOfOrdersPerInvoice?: number | null, invoiceTimePeriodSplit?: TimePeriod | null }, billingPartyContactStation?: { __typename?: 'ContactStationEntity', id: string, name: string, defaultPerson?: { __typename?: 'PersonEntity', id: string, firstName: string, lastName: string, phone?: string | null, email?: string | null } | null } | null, packages: Array<{ __typename?: 'PackageEntity', uuid: string, height?: number | null, length?: number | null, quantity: number, type?: PackageType | null, weight?: number | null, width?: number | null, description: string, packageSpec?: { __typename?: 'PackageSpecEntity', id: string, name: string } | null }>, shipments: Array<{ __typename?: 'StandardShipmentEntity', uuid: string, shouldBillIndividually: boolean, shouldUseDimWeight: boolean, overridePackageWeight: boolean, name: string, hideFromBilling: boolean, hasSignedPOD: boolean, status: ShipmentStatus, shipmentType: ShipmentType, documents: Array<{ __typename?: 'DocumentEntity', uuid: string, fileName: string, fileType: string, preSignedGetUrl: string, type: DocumentType, notes?: string | null, name?: string | null }>, fields?: { __typename?: 'StandardShipmentFieldsEntity', uuid: string, deadlineDate?: any | null, deadlineType?: DeadlineType | null, deliveryDate?: any | null, dimFactor: number, pickupOrDelivery: PickupOrDelivery, outboundMethod?: OutboundMethod | null, inboundMethod?: InboundMethod | null, type: StandardShipmentType, service?: { __typename?: 'ServiceEntity', uuid: string, name: string, createdAt: any, updatedAt: any, timeInMinutes?: number | null, useApptInRouteOptimization: boolean, markOrdersAsSpecial: boolean, defaultAppointmentStartTime?: any | null, defaultAppointmentEndTime?: any | null, defaultStartNow: boolean, defaultInboundStopType?: StopType | null, defaultOutboundStopType?: StopType | null, defaultPickupPadding?: any | null, defaultDeliveryPadding?: any | null, defaultTotalDuration?: any | null, defaultIsLineHaul: boolean, defaultFulfillmentType?: FulfillmentType | null, isActive: boolean, isExposedToCustomers: boolean, serviceAvailabilityDates: Array<{ __typename?: 'ServiceAvailabilityDateEntity', id: string, dayCategory: SpecialDayOfWeek, enabled: boolean, start: { __typename?: 'PlainTime', hour: number, minute: number }, end: { __typename?: 'PlainTime', hour: number, minute: number } }> } | null } | null, legs: Array<{ __typename?: 'LegEntity', uuid: string, miles?: number | null, endStop: { __typename?: 'StandardStopEntity', uuid: string, createdAt: any, specialInstructions?: string | null, stopType?: StopType | null, appointmentRequired: boolean, deadlineTime?: any | null, proofOfDeliverySignee?: string | null, arrivedAt?: any | null, completedAt?: any | null, inboundMethod?: InboundMethod | null, expectedInboundArrivalDate?: any | null, outboundMethod?: OutboundMethod | null, driverCompletedAt?: any | null, notes?: string | null, serviceDate?: any | null, status: StopStatus, appointmentTime?: any | null, endAppointmentTime?: any | null, isSpecial?: boolean | null, settlementDeductionFlatRate?: number | null, settlementDeductionName?: string | null, settlementDeductionPercentageRate?: number | null, standardStopType?: StandardStopType | null, paperworkMarkedComplete?: boolean | null, sentToAgentAt?: any | null, confirmedByAgentAt?: any | null, address: { __typename?: 'AddressEntity', internalNotes?: string | null, iataCode?: string | null, uuid: string, name: string, line1: string, line2?: string | null, city: string, state: string, zip: string, country: string, latitude?: number | null, longitude?: number | null, driverInstructions?: string | null, receivingHoursStart?: any | null, receivingHoursEnd?: any | null, specialInstructions?: string | null }, serviceDateV2?: { __typename?: 'PlainDate', iso8601: string } | null, routeSlot?: { __typename?: 'RouteSlotEntity', uuid: string, route?: { __typename?: 'RouteEntity', uuid: string, date: any, name: string, slots: Array<{ __typename?: 'RouteSlotEntity', uuid: string }>, drivers: Array<{ __typename?: 'DriverEntity', uuid: string, firstName: string, lastName: string, driverType?: DriverType | null, agent?: { __typename?: 'AgentFieldsEntity', uuid: string, name: string } | null }>, equipments: Array<{ __typename?: 'EquipmentEntity', uuid: string, name: string }> } | null } | null, terminal?: { __typename?: 'TerminalEntity', name: string, code: string, uuid: string, isActive: boolean, address: { __typename?: 'AddressEntity', line1: string, line2?: string | null, city: string, state: string, zip: string, uuid: string, name: string, latitude?: number | null, longitude?: number | null }, startForTerminalLanes: Array<{ __typename?: 'TerminalLaneEntity', id: string, endTerminal: { __typename?: 'TerminalEntity', uuid: string, code: string, name: string } }>, agent?: { __typename?: 'AgentFieldsEntity', name: string } | null } | null, stopDriverMaps: Array<{ __typename?: 'StopDriverMapEntity', uuid: string, name?: string | null, enableDriverSettlement?: boolean | null, revenuePercentageRate?: number | null, revenueFlatRate?: number | null, driverPayoutFinalized: boolean, driver: { __typename?: 'DriverEntity', firstName: string, lastName: string, uuid: string, driverType?: DriverType | null, driverReferenceNumber?: string | null, defaultFuelSettlementPercentageRate?: number | null, user: { __typename?: 'UserEntity', name?: string | null }, defaultVehicle?: { __typename?: 'EquipmentEntity', uuid: string } | null, terminal?: { __typename?: 'TerminalEntity', uuid: string, name: string } | null, qualifications: Array<{ __typename?: 'DriverQualificationEntity', id: string }> }, driverSettlementBill?: { __typename?: 'DriverSettlementBillEntity', uuid: string } | null, stop: { __typename?: 'StandardStopEntity', uuid: string, completedAt?: any | null, settlementDeductionName?: string | null, settlementDeductionFlatRate?: number | null, settlementDeductionPercentageRate?: number | null } }> }, previousStopAttempts: Array<{ __typename?: 'StandardStopEntity', stopDriverMaps: Array<{ __typename?: 'StopDriverMapEntity', uuid: string, name?: string | null, enableDriverSettlement?: boolean | null, revenuePercentageRate?: number | null, revenueFlatRate?: number | null, driverPayoutFinalized: boolean, driver: { __typename?: 'DriverEntity', firstName: string, lastName: string, uuid: string, driverType?: DriverType | null, driverReferenceNumber?: string | null, defaultFuelSettlementPercentageRate?: number | null, user: { __typename?: 'UserEntity', name?: string | null }, defaultVehicle?: { __typename?: 'EquipmentEntity', uuid: string } | null, terminal?: { __typename?: 'TerminalEntity', uuid: string, name: string } | null, qualifications: Array<{ __typename?: 'DriverQualificationEntity', id: string }> }, driverSettlementBill?: { __typename?: 'DriverSettlementBillEntity', uuid: string } | null, stop: { __typename?: 'StandardStopEntity', uuid: string, completedAt?: any | null, settlementDeductionName?: string | null, settlementDeductionFlatRate?: number | null, settlementDeductionPercentageRate?: number | null } }> }> }>, customCharges: Array<{ __typename?: 'CustomChargeEntity', uuid: string, rate: number, description?: string | null, total: number, totalAmountCents?: number | null, postedAmountUsdCents?: number | null, authoCode?: string | null, quantity: number, billingMethod: CustomChargeBillingMethod, isAutoApplied: boolean, name: string, fuelSurchargeRate?: number | null, postedFuelSurchargeRate?: number | null, zoneBasedAccessorialChargeGroupUuid?: string | null, zoneBasedAccessorialZoneUuid?: string | null, specialAccessorialTariffZoneUuid?: string | null, specialAccessorialChargeGroupUuid?: string | null, settlementFlatRate?: number | null, settlementPercentageRate?: number | null, zoneBasedAccessorialMatrixItem?: { __typename?: 'ZoneBasedAccessorialMatrixItemEntity', uuid: string } | null, specialAccessorialMatrixItem?: { __typename?: 'SpecialAccessorialMatrixItemEntity', uuid: string } | null, accessorialRange?: { __typename?: 'AccessorialRangeEntity', uuid: string, lessThanOrEqualToValue: number, rateUsdCents: number } | null, accessorialTemplate?: { __typename?: 'SkidBasedAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename?: 'SpecialAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename?: 'StandardAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | null }>, freightCharge?: { __typename?: 'FreightChargeEntity', uuid: string, quantity: number, billingMethod: FreightBillingMethod, description?: string | null, authoCode?: string | null, rate: number, discountRate?: any | null, settlementFlatRate?: number | null, settlementPercentageRate?: number | null, total: number, totalAmountCents?: number | null, postedAmountUsdCents?: number | null, fuelCharge?: { __typename?: 'FuelChargeEntity', uuid: string, surchargeRate: number, description?: string | null, authoCode?: string | null, flatRate: number, type: FuelBillingMethod, settlementFlatRate?: number | null, settlementPercentageRate?: number | null, totalAmountCents?: number | null, postedAmountUsdCents?: number | null } | null, tariff?: { __typename?: 'TariffEntity', uuid: string, billingPartyContactUuid?: string | null, tariffGroup?: { __typename?: 'TariffGroupEntity', name?: string | null, tariffGroupScope?: TariffGroupScope | null } | null, tariffZone: { __typename?: 'TariffZoneEntity', name: string } } | null } | null, inputForConsolidatedOrder?: { __typename?: 'StandardOrderEntity', uuid: string, name: string } | null, shipmentCharges: { __typename?: 'ShipmentChargeEntity', totalFuelCharge: number, totalCustomCharge: number, totalFreightCharge: number, totalCharge: number }, invoice?: { __typename?: 'InvoiceEntity', uuid: string, name: string, date: any, postedAt?: any | null } | null, independentSettlementBillLineItems: Array<{ __typename?: 'SettlementBillLineItemEntity', id: string, settlementMode: SettlementMode, totalAmountUsdDollars: number, revenuePercentageRate?: any | null, revenueFlatRate?: number | null, driver: { __typename?: 'DriverEntity', uuid: string, user: { __typename?: 'UserEntity', name?: string | null } }, driverSettlementBill?: { __typename?: 'DriverSettlementBillEntity', uuid: string, name?: string | null, finalizedDate?: any | null } | null, freightCost?: { __typename?: 'FreightCostEntity', id: string, billingMethod?: FreightBillingMethod | null, dependentSettlementBillingMethod?: DependentSettlementBillingMethod | null, percentageRate?: any | null, flatRateUsdDollars?: number | null, quantity?: number | null, rateUsdDollars?: number | null, discountRate?: any | null, totalAmountUsdDollars?: number | null, totalAmountUsdCents: number, tariff?: { __typename?: 'TariffEntity', uuid: string, tariffZone: { __typename?: 'TariffZoneEntity', name: string } } | null, fuelCost?: { __typename?: 'FuelCostEntity', id: string, billingMethod?: FuelBillingMethod | null, dependentSettlementBillingMethod?: DependentSettlementBillingMethod | null, percentageRate?: any | null, surchargeRate?: number | null, flatRateUsdDollars?: number | null, totalAmountUsdDollars?: number | null, totalAmountUsdCents: number } | null } | null, customCosts: Array<{ __typename?: 'CustomCostEntity', id: string, name: string, billingMethod?: CustomChargeBillingMethod | null, dependentSettlementBillingMethod?: DependentSettlementBillingMethod | null, percentageRate?: any | null, flatRateUsdDollars?: number | null, quantity: number, rateUsdDollars?: number | null, fuelSurchargeRate?: number | null, totalAmountUsdDollars?: number | null, totalAmountUsdCents: number, accessorialTemplate?: { __typename: 'SkidBasedAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename: 'SpecialAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename: 'StandardAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename: 'UnitBasedAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename: 'WaitTimeAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename: 'WeightBasedAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename: 'ZoneBasedAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | null, specialAccessorialMatrixItem?: { __typename?: 'SpecialAccessorialMatrixItemEntity', uuid: string, zoneUuid: string, chargeGroupUuid: string } | null, zoneBasedAccessorialMatrixItem?: { __typename?: 'ZoneBasedAccessorialMatrixItemEntity', uuid: string, zoneUuid: string, chargeGroupUuid: string } | null, accessorialRange?: { __typename?: 'AccessorialRangeEntity', uuid: string } | null }> }> }>, orderComments: Array<{ __typename?: 'OrderCommentEntity', uuid: string, updatedAt: any, comment: string, user?: { __typename?: 'UserEntity', uuid: string, email: string } | null }>, consolidatableOrders: { __typename?: 'ConsolidatableOrdersOutput', error?: FindConsolidatableOrdersError | null, orders: Array<{ __typename?: 'StandardOrderEntity', uuid: string }>, shipments?: Array<{ __typename?: 'StandardShipmentEntity', uuid: string }> | null }, consolidatedOrders?: Array<{ __typename?: 'StandardOrderEntity', uuid: string, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', shipperBillOfLadingNumber?: string | null } }> | null, deletedAutoAppliedAccessorials: Array<{ __typename?: 'SkidBasedAccessorialEntity', uuid: string } | { __typename?: 'SpecialAccessorialEntity', uuid: string } | { __typename?: 'StandardAccessorialEntity', uuid: string } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string }>, lineHaulLane?: { __typename?: 'LineHaulLaneEntity', uuid: string } | null, ordersProratedWith?: Array<{ __typename?: 'StandardOrderEntity', uuid: string, name: string, status: OrderStatus, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', shipperBillOfLadingNumber?: string | null } }> | null } }>, pageInfo: { __typename?: 'PageInfo', startCursor?: string | null, endCursor?: string | null, hasNextPage: boolean, hasPreviousPage: boolean } } };

export type OutstandingShipmentOrderShipmentFragment = { __typename?: 'StandardShipmentEntity', uuid: string, totalChargesAmount: number, shouldBillIndividually: boolean, shouldUseDimWeight: boolean, overridePackageWeight: boolean, name: string, hideFromBilling: boolean, hasSignedPOD: boolean, status: ShipmentStatus, shipmentType: ShipmentType, documents: Array<{ __typename?: 'DocumentEntity', uuid: string, fileName: string, bucket: string, region: string, key: string, uploadedAt?: any | null, fileType: string, isDeleted: boolean, preSignedGetUrl: string, name?: string | null, type: DocumentType, pageNumber?: number | null, createdAt: any, notes?: string | null, order?: { __typename?: 'StandardOrderEntity', uuid: string, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', shipperBillOfLadingNumber?: string | null } } | null, shipment?: { __typename?: 'StandardOrderEntity', uuid: string } | null, driverFormTemplate?: { __typename?: 'DriverSignableFormTemplateEntity', uuid: string, title: string, formText: string } | null }>, shipmentSubscribers: Array<{ __typename?: 'ShipmentSubscriberEntity', uuid: string, email?: string | null }>, standardShipmentFields: { __typename?: 'StandardShipmentFieldsEntity', uuid: string, pickupOrDelivery: PickupOrDelivery }, fields?: { __typename?: 'StandardShipmentFieldsEntity', uuid: string, deadlineDate?: any | null, deadlineType?: DeadlineType | null, deliveryDate?: any | null, dimFactor: number, pickupOrDelivery: PickupOrDelivery, type: StandardShipmentType, service?: { __typename?: 'ServiceEntity', uuid: string, name: string, createdAt: any, updatedAt: any, timeInMinutes?: number | null, useApptInRouteOptimization: boolean, markOrdersAsSpecial: boolean, defaultAppointmentStartTime?: any | null, defaultAppointmentEndTime?: any | null, defaultStartNow: boolean, defaultInboundStopType?: StopType | null, defaultOutboundStopType?: StopType | null, defaultPickupPadding?: any | null, defaultDeliveryPadding?: any | null, defaultTotalDuration?: any | null, defaultIsLineHaul: boolean, defaultFulfillmentType?: FulfillmentType | null, isActive: boolean, isExposedToCustomers: boolean, serviceAvailabilityDates: Array<{ __typename?: 'ServiceAvailabilityDateEntity', id: string, dayCategory: SpecialDayOfWeek, enabled: boolean, start: { __typename?: 'PlainTime', hour: number, minute: number }, end: { __typename?: 'PlainTime', hour: number, minute: number } }> } | null } | null, legs: Array<{ __typename?: 'LegEntity', uuid: string, miles?: number | null, endStop: { __typename?: 'StandardStopEntity', uuid: string, createdAt: any, specialInstructions?: string | null, stopType?: StopType | null, appointmentRequired: boolean, deadlineTime?: any | null, proofOfDeliverySignee?: string | null, arrivedAt?: any | null, completedAt?: any | null, inboundMethod?: InboundMethod | null, expectedInboundArrivalDate?: any | null, outboundMethod?: OutboundMethod | null, driverCompletedAt?: any | null, notes?: string | null, serviceDate?: any | null, status: StopStatus, appointmentTime?: any | null, endAppointmentTime?: any | null, isSpecial?: boolean | null, settlementDeductionFlatRate?: number | null, settlementDeductionName?: string | null, settlementDeductionPercentageRate?: number | null, standardStopType?: StandardStopType | null, paperworkMarkedComplete?: boolean | null, sentToAgentAt?: any | null, confirmedByAgentAt?: any | null, address: { __typename?: 'AddressEntity', internalNotes?: string | null, iataCode?: string | null, uuid: string, name: string, line1: string, line2?: string | null, city: string, state: string, zip: string, country: string, latitude?: number | null, longitude?: number | null, driverInstructions?: string | null, receivingHoursStart?: any | null, receivingHoursEnd?: any | null, specialInstructions?: string | null }, serviceDateV2?: { __typename?: 'PlainDate', iso8601: string } | null, routeSlot?: { __typename?: 'RouteSlotEntity', uuid: string, route?: { __typename?: 'RouteEntity', uuid: string, date: any, name: string, slots: Array<{ __typename?: 'RouteSlotEntity', uuid: string }>, drivers: Array<{ __typename?: 'DriverEntity', uuid: string, firstName: string, lastName: string, driverType?: DriverType | null, agent?: { __typename?: 'AgentFieldsEntity', uuid: string, name: string } | null }>, equipments: Array<{ __typename?: 'EquipmentEntity', uuid: string, name: string }> } | null } | null, terminal?: { __typename?: 'TerminalEntity', name: string, code: string, uuid: string, isActive: boolean, address: { __typename?: 'AddressEntity', line1: string, line2?: string | null, city: string, state: string, zip: string, uuid: string, name: string, latitude?: number | null, longitude?: number | null }, startForTerminalLanes: Array<{ __typename?: 'TerminalLaneEntity', id: string, endTerminal: { __typename?: 'TerminalEntity', uuid: string, code: string, name: string } }>, agent?: { __typename?: 'AgentFieldsEntity', name: string } | null } | null, stopDriverMaps: Array<{ __typename?: 'StopDriverMapEntity', uuid: string, name?: string | null, enableDriverSettlement?: boolean | null, revenuePercentageRate?: number | null, revenueFlatRate?: number | null, driverPayoutFinalized: boolean, driver: { __typename?: 'DriverEntity', firstName: string, lastName: string, uuid: string, driverType?: DriverType | null, driverReferenceNumber?: string | null, defaultFuelSettlementPercentageRate?: number | null, user: { __typename?: 'UserEntity', name?: string | null }, defaultVehicle?: { __typename?: 'EquipmentEntity', uuid: string } | null, terminal?: { __typename?: 'TerminalEntity', uuid: string, name: string } | null, qualifications: Array<{ __typename?: 'DriverQualificationEntity', id: string }> }, driverSettlementBill?: { __typename?: 'DriverSettlementBillEntity', uuid: string } | null, stop: { __typename?: 'StandardStopEntity', uuid: string, completedAt?: any | null, settlementDeductionName?: string | null, settlementDeductionFlatRate?: number | null, settlementDeductionPercentageRate?: number | null } }> }, previousStopAttempts: Array<{ __typename?: 'StandardStopEntity', stopDriverMaps: Array<{ __typename?: 'StopDriverMapEntity', uuid: string, name?: string | null, enableDriverSettlement?: boolean | null, revenuePercentageRate?: number | null, revenueFlatRate?: number | null, driverPayoutFinalized: boolean, driver: { __typename?: 'DriverEntity', firstName: string, lastName: string, uuid: string, driverType?: DriverType | null, driverReferenceNumber?: string | null, defaultFuelSettlementPercentageRate?: number | null, user: { __typename?: 'UserEntity', name?: string | null }, defaultVehicle?: { __typename?: 'EquipmentEntity', uuid: string } | null, terminal?: { __typename?: 'TerminalEntity', uuid: string, name: string } | null, qualifications: Array<{ __typename?: 'DriverQualificationEntity', id: string }> }, driverSettlementBill?: { __typename?: 'DriverSettlementBillEntity', uuid: string } | null, stop: { __typename?: 'StandardStopEntity', uuid: string, completedAt?: any | null, settlementDeductionName?: string | null, settlementDeductionFlatRate?: number | null, settlementDeductionPercentageRate?: number | null } }> }> }>, packages: Array<{ __typename?: 'PackageEntity', uuid: string, class?: number | null, description: string, hazmat?: boolean | null, height?: number | null, length?: number | null, nmfc?: string | null, quantity: number, skuNumber?: string | null, type?: PackageType | null, weight?: number | null, width?: number | null, quantityCompletedAtStop?: number | null, reasonUncompletedAtStop?: string | null, packageSpec?: { __typename?: 'PackageSpecEntity', id: string, name: string } | null, warehouseLocation?: { __typename?: 'WarehouseLocationEntity', uuid: string, name: string } | null }>, customCharges: Array<{ __typename?: 'CustomChargeEntity', uuid: string, rate: number, description?: string | null, total: number, totalAmountCents?: number | null, postedAmountUsdCents?: number | null, authoCode?: string | null, quantity: number, billingMethod: CustomChargeBillingMethod, isAutoApplied: boolean, name: string, fuelSurchargeRate?: number | null, postedFuelSurchargeRate?: number | null, zoneBasedAccessorialChargeGroupUuid?: string | null, zoneBasedAccessorialZoneUuid?: string | null, specialAccessorialTariffZoneUuid?: string | null, specialAccessorialChargeGroupUuid?: string | null, settlementFlatRate?: number | null, settlementPercentageRate?: number | null, zoneBasedAccessorialMatrixItem?: { __typename?: 'ZoneBasedAccessorialMatrixItemEntity', uuid: string } | null, specialAccessorialMatrixItem?: { __typename?: 'SpecialAccessorialMatrixItemEntity', uuid: string } | null, accessorialRange?: { __typename?: 'AccessorialRangeEntity', uuid: string, lessThanOrEqualToValue: number, rateUsdCents: number } | null, accessorialTemplate?: { __typename?: 'SkidBasedAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename?: 'SpecialAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename?: 'StandardAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | null }>, freightCharge?: { __typename?: 'FreightChargeEntity', uuid: string, quantity: number, billingMethod: FreightBillingMethod, description?: string | null, authoCode?: string | null, rate: number, settlementFlatRate?: number | null, settlementPercentageRate?: number | null, total: number, fuelCharge?: { __typename?: 'FuelChargeEntity', uuid: string, surchargeRate: number, description?: string | null, authoCode?: string | null, flatRate: number, type: FuelBillingMethod, settlementFlatRate?: number | null, settlementPercentageRate?: number | null } | null, tariff?: { __typename?: 'TariffEntity', uuid: string, billingPartyContactUuid?: string | null, tariffGroup?: { __typename?: 'TariffGroupEntity', name?: string | null, tariffGroupScope?: TariffGroupScope | null } | null, tariffZone: { __typename?: 'TariffZoneEntity', name: string } } | null } | null, inputForConsolidatedOrder?: { __typename?: 'StandardOrderEntity', uuid: string } | null, shipmentCharges: { __typename?: 'ShipmentChargeEntity', totalFuelCharge: number, totalCustomCharge: number, totalFreightCharge: number, totalCharge: number } };

export type OutstandingShipmentOrderFragment = { __typename?: 'StandardOrderEntity', uuid: string, consolidatedShipmentString?: string | null, name: string, detailedStatusV2?: OrderDetailedStatus | null, status: OrderStatus, notes: string, orderConsolidationType: OrderConsolidationType, source: OrderSource, secondaryRefNumber?: string | null, billingPartyContact: { __typename?: 'CustomerContactEntity', uuid: string }, packages: Array<{ __typename?: 'PackageEntity', uuid: string, class?: number | null, description: string, hazmat?: boolean | null, height?: number | null, length?: number | null, nmfc?: string | null, quantity: number, skuNumber?: string | null, type?: PackageType | null, weight?: number | null, width?: number | null, quantityCompletedAtStop?: number | null, reasonUncompletedAtStop?: string | null, packageSpec?: { __typename?: 'PackageSpecEntity', id: string, name: string } | null, warehouseLocation?: { __typename?: 'WarehouseLocationEntity', uuid: string, name: string } | null }>, shipments: Array<{ __typename?: 'StandardShipmentEntity', uuid: string, totalChargesAmount: number, shouldBillIndividually: boolean, shouldUseDimWeight: boolean, overridePackageWeight: boolean, name: string, hideFromBilling: boolean, hasSignedPOD: boolean, status: ShipmentStatus, shipmentType: ShipmentType, documents: Array<{ __typename?: 'DocumentEntity', uuid: string, fileName: string, bucket: string, region: string, key: string, uploadedAt?: any | null, fileType: string, isDeleted: boolean, preSignedGetUrl: string, name?: string | null, type: DocumentType, pageNumber?: number | null, createdAt: any, notes?: string | null, order?: { __typename?: 'StandardOrderEntity', uuid: string, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', shipperBillOfLadingNumber?: string | null } } | null, shipment?: { __typename?: 'StandardOrderEntity', uuid: string } | null, driverFormTemplate?: { __typename?: 'DriverSignableFormTemplateEntity', uuid: string, title: string, formText: string } | null }>, shipmentSubscribers: Array<{ __typename?: 'ShipmentSubscriberEntity', uuid: string, email?: string | null }>, standardShipmentFields: { __typename?: 'StandardShipmentFieldsEntity', uuid: string, pickupOrDelivery: PickupOrDelivery }, fields?: { __typename?: 'StandardShipmentFieldsEntity', uuid: string, deadlineDate?: any | null, deadlineType?: DeadlineType | null, deliveryDate?: any | null, dimFactor: number, pickupOrDelivery: PickupOrDelivery, type: StandardShipmentType, service?: { __typename?: 'ServiceEntity', uuid: string, name: string, createdAt: any, updatedAt: any, timeInMinutes?: number | null, useApptInRouteOptimization: boolean, markOrdersAsSpecial: boolean, defaultAppointmentStartTime?: any | null, defaultAppointmentEndTime?: any | null, defaultStartNow: boolean, defaultInboundStopType?: StopType | null, defaultOutboundStopType?: StopType | null, defaultPickupPadding?: any | null, defaultDeliveryPadding?: any | null, defaultTotalDuration?: any | null, defaultIsLineHaul: boolean, defaultFulfillmentType?: FulfillmentType | null, isActive: boolean, isExposedToCustomers: boolean, serviceAvailabilityDates: Array<{ __typename?: 'ServiceAvailabilityDateEntity', id: string, dayCategory: SpecialDayOfWeek, enabled: boolean, start: { __typename?: 'PlainTime', hour: number, minute: number }, end: { __typename?: 'PlainTime', hour: number, minute: number } }> } | null } | null, legs: Array<{ __typename?: 'LegEntity', uuid: string, miles?: number | null, endStop: { __typename?: 'StandardStopEntity', uuid: string, createdAt: any, specialInstructions?: string | null, stopType?: StopType | null, appointmentRequired: boolean, deadlineTime?: any | null, proofOfDeliverySignee?: string | null, arrivedAt?: any | null, completedAt?: any | null, inboundMethod?: InboundMethod | null, expectedInboundArrivalDate?: any | null, outboundMethod?: OutboundMethod | null, driverCompletedAt?: any | null, notes?: string | null, serviceDate?: any | null, status: StopStatus, appointmentTime?: any | null, endAppointmentTime?: any | null, isSpecial?: boolean | null, settlementDeductionFlatRate?: number | null, settlementDeductionName?: string | null, settlementDeductionPercentageRate?: number | null, standardStopType?: StandardStopType | null, paperworkMarkedComplete?: boolean | null, sentToAgentAt?: any | null, confirmedByAgentAt?: any | null, address: { __typename?: 'AddressEntity', internalNotes?: string | null, iataCode?: string | null, uuid: string, name: string, line1: string, line2?: string | null, city: string, state: string, zip: string, country: string, latitude?: number | null, longitude?: number | null, driverInstructions?: string | null, receivingHoursStart?: any | null, receivingHoursEnd?: any | null, specialInstructions?: string | null }, serviceDateV2?: { __typename?: 'PlainDate', iso8601: string } | null, routeSlot?: { __typename?: 'RouteSlotEntity', uuid: string, route?: { __typename?: 'RouteEntity', uuid: string, date: any, name: string, slots: Array<{ __typename?: 'RouteSlotEntity', uuid: string }>, drivers: Array<{ __typename?: 'DriverEntity', uuid: string, firstName: string, lastName: string, driverType?: DriverType | null, agent?: { __typename?: 'AgentFieldsEntity', uuid: string, name: string } | null }>, equipments: Array<{ __typename?: 'EquipmentEntity', uuid: string, name: string }> } | null } | null, terminal?: { __typename?: 'TerminalEntity', name: string, code: string, uuid: string, isActive: boolean, address: { __typename?: 'AddressEntity', line1: string, line2?: string | null, city: string, state: string, zip: string, uuid: string, name: string, latitude?: number | null, longitude?: number | null }, startForTerminalLanes: Array<{ __typename?: 'TerminalLaneEntity', id: string, endTerminal: { __typename?: 'TerminalEntity', uuid: string, code: string, name: string } }>, agent?: { __typename?: 'AgentFieldsEntity', name: string } | null } | null, stopDriverMaps: Array<{ __typename?: 'StopDriverMapEntity', uuid: string, name?: string | null, enableDriverSettlement?: boolean | null, revenuePercentageRate?: number | null, revenueFlatRate?: number | null, driverPayoutFinalized: boolean, driver: { __typename?: 'DriverEntity', firstName: string, lastName: string, uuid: string, driverType?: DriverType | null, driverReferenceNumber?: string | null, defaultFuelSettlementPercentageRate?: number | null, user: { __typename?: 'UserEntity', name?: string | null }, defaultVehicle?: { __typename?: 'EquipmentEntity', uuid: string } | null, terminal?: { __typename?: 'TerminalEntity', uuid: string, name: string } | null, qualifications: Array<{ __typename?: 'DriverQualificationEntity', id: string }> }, driverSettlementBill?: { __typename?: 'DriverSettlementBillEntity', uuid: string } | null, stop: { __typename?: 'StandardStopEntity', uuid: string, completedAt?: any | null, settlementDeductionName?: string | null, settlementDeductionFlatRate?: number | null, settlementDeductionPercentageRate?: number | null } }> }, previousStopAttempts: Array<{ __typename?: 'StandardStopEntity', stopDriverMaps: Array<{ __typename?: 'StopDriverMapEntity', uuid: string, name?: string | null, enableDriverSettlement?: boolean | null, revenuePercentageRate?: number | null, revenueFlatRate?: number | null, driverPayoutFinalized: boolean, driver: { __typename?: 'DriverEntity', firstName: string, lastName: string, uuid: string, driverType?: DriverType | null, driverReferenceNumber?: string | null, defaultFuelSettlementPercentageRate?: number | null, user: { __typename?: 'UserEntity', name?: string | null }, defaultVehicle?: { __typename?: 'EquipmentEntity', uuid: string } | null, terminal?: { __typename?: 'TerminalEntity', uuid: string, name: string } | null, qualifications: Array<{ __typename?: 'DriverQualificationEntity', id: string }> }, driverSettlementBill?: { __typename?: 'DriverSettlementBillEntity', uuid: string } | null, stop: { __typename?: 'StandardStopEntity', uuid: string, completedAt?: any | null, settlementDeductionName?: string | null, settlementDeductionFlatRate?: number | null, settlementDeductionPercentageRate?: number | null } }> }> }>, packages: Array<{ __typename?: 'PackageEntity', uuid: string, class?: number | null, description: string, hazmat?: boolean | null, height?: number | null, length?: number | null, nmfc?: string | null, quantity: number, skuNumber?: string | null, type?: PackageType | null, weight?: number | null, width?: number | null, quantityCompletedAtStop?: number | null, reasonUncompletedAtStop?: string | null, packageSpec?: { __typename?: 'PackageSpecEntity', id: string, name: string } | null, warehouseLocation?: { __typename?: 'WarehouseLocationEntity', uuid: string, name: string } | null }>, customCharges: Array<{ __typename?: 'CustomChargeEntity', uuid: string, rate: number, description?: string | null, total: number, totalAmountCents?: number | null, postedAmountUsdCents?: number | null, authoCode?: string | null, quantity: number, billingMethod: CustomChargeBillingMethod, isAutoApplied: boolean, name: string, fuelSurchargeRate?: number | null, postedFuelSurchargeRate?: number | null, zoneBasedAccessorialChargeGroupUuid?: string | null, zoneBasedAccessorialZoneUuid?: string | null, specialAccessorialTariffZoneUuid?: string | null, specialAccessorialChargeGroupUuid?: string | null, settlementFlatRate?: number | null, settlementPercentageRate?: number | null, zoneBasedAccessorialMatrixItem?: { __typename?: 'ZoneBasedAccessorialMatrixItemEntity', uuid: string } | null, specialAccessorialMatrixItem?: { __typename?: 'SpecialAccessorialMatrixItemEntity', uuid: string } | null, accessorialRange?: { __typename?: 'AccessorialRangeEntity', uuid: string, lessThanOrEqualToValue: number, rateUsdCents: number } | null, accessorialTemplate?: { __typename?: 'SkidBasedAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename?: 'SpecialAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename?: 'StandardAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | null }>, freightCharge?: { __typename?: 'FreightChargeEntity', uuid: string, quantity: number, billingMethod: FreightBillingMethod, description?: string | null, authoCode?: string | null, rate: number, settlementFlatRate?: number | null, settlementPercentageRate?: number | null, total: number, fuelCharge?: { __typename?: 'FuelChargeEntity', uuid: string, surchargeRate: number, description?: string | null, authoCode?: string | null, flatRate: number, type: FuelBillingMethod, settlementFlatRate?: number | null, settlementPercentageRate?: number | null } | null, tariff?: { __typename?: 'TariffEntity', uuid: string, billingPartyContactUuid?: string | null, tariffGroup?: { __typename?: 'TariffGroupEntity', name?: string | null, tariffGroupScope?: TariffGroupScope | null } | null, tariffZone: { __typename?: 'TariffZoneEntity', name: string } } | null } | null, inputForConsolidatedOrder?: { __typename?: 'StandardOrderEntity', uuid: string } | null, shipmentCharges: { __typename?: 'ShipmentChargeEntity', totalFuelCharge: number, totalCustomCharge: number, totalFreightCharge: number, totalCharge: number } }>, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', uuid: string, dimFactor?: number | null, shipperBillOfLadingNumber?: string | null, masterAirwayBillOfLadingNumber?: string | null }, tags: Array<{ __typename?: 'TagEntity', uuid: string, value: string, color?: string | null }> };

export type ConsolidatableShipmentFragment = { __typename?: 'StandardShipmentEntity', uuid: string, totalChargesAmount: number, totalAmountCents?: number | null, postedAmountCents?: number | null, shouldBillIndividually: boolean, shouldUseDimWeight: boolean, overridePackageWeight: boolean, name: string, hideFromBilling: boolean, hasSignedPOD: boolean, shipmentType: ShipmentType, status: ShipmentStatus, order?: { __typename?: 'StandardOrderEntity', uuid: string, consolidatedShipmentString?: string | null, name: string, detailedStatusV2?: OrderDetailedStatus | null, status: OrderStatus, notes: string, orderConsolidationType: OrderConsolidationType, source: OrderSource, secondaryRefNumber?: string | null, billingPartyContact: { __typename?: 'CustomerContactEntity', uuid: string }, packages: Array<{ __typename?: 'PackageEntity', uuid: string, class?: number | null, description: string, hazmat?: boolean | null, height?: number | null, length?: number | null, nmfc?: string | null, quantity: number, skuNumber?: string | null, type?: PackageType | null, weight?: number | null, width?: number | null, quantityCompletedAtStop?: number | null, reasonUncompletedAtStop?: string | null, packageSpec?: { __typename?: 'PackageSpecEntity', id: string, name: string } | null, warehouseLocation?: { __typename?: 'WarehouseLocationEntity', uuid: string, name: string } | null }>, shipments: Array<{ __typename?: 'StandardShipmentEntity', uuid: string, totalChargesAmount: number, shouldBillIndividually: boolean, shouldUseDimWeight: boolean, overridePackageWeight: boolean, name: string, hideFromBilling: boolean, hasSignedPOD: boolean, status: ShipmentStatus, shipmentType: ShipmentType, documents: Array<{ __typename?: 'DocumentEntity', uuid: string, fileName: string, bucket: string, region: string, key: string, uploadedAt?: any | null, fileType: string, isDeleted: boolean, preSignedGetUrl: string, name?: string | null, type: DocumentType, pageNumber?: number | null, createdAt: any, notes?: string | null, order?: { __typename?: 'StandardOrderEntity', uuid: string, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', shipperBillOfLadingNumber?: string | null } } | null, shipment?: { __typename?: 'StandardOrderEntity', uuid: string } | null, driverFormTemplate?: { __typename?: 'DriverSignableFormTemplateEntity', uuid: string, title: string, formText: string } | null }>, shipmentSubscribers: Array<{ __typename?: 'ShipmentSubscriberEntity', uuid: string, email?: string | null }>, standardShipmentFields: { __typename?: 'StandardShipmentFieldsEntity', uuid: string, pickupOrDelivery: PickupOrDelivery }, fields?: { __typename?: 'StandardShipmentFieldsEntity', uuid: string, deadlineDate?: any | null, deadlineType?: DeadlineType | null, deliveryDate?: any | null, dimFactor: number, pickupOrDelivery: PickupOrDelivery, type: StandardShipmentType, service?: { __typename?: 'ServiceEntity', uuid: string, name: string, createdAt: any, updatedAt: any, timeInMinutes?: number | null, useApptInRouteOptimization: boolean, markOrdersAsSpecial: boolean, defaultAppointmentStartTime?: any | null, defaultAppointmentEndTime?: any | null, defaultStartNow: boolean, defaultInboundStopType?: StopType | null, defaultOutboundStopType?: StopType | null, defaultPickupPadding?: any | null, defaultDeliveryPadding?: any | null, defaultTotalDuration?: any | null, defaultIsLineHaul: boolean, defaultFulfillmentType?: FulfillmentType | null, isActive: boolean, isExposedToCustomers: boolean, serviceAvailabilityDates: Array<{ __typename?: 'ServiceAvailabilityDateEntity', id: string, dayCategory: SpecialDayOfWeek, enabled: boolean, start: { __typename?: 'PlainTime', hour: number, minute: number }, end: { __typename?: 'PlainTime', hour: number, minute: number } }> } | null } | null, legs: Array<{ __typename?: 'LegEntity', uuid: string, miles?: number | null, endStop: { __typename?: 'StandardStopEntity', uuid: string, createdAt: any, specialInstructions?: string | null, stopType?: StopType | null, appointmentRequired: boolean, deadlineTime?: any | null, proofOfDeliverySignee?: string | null, arrivedAt?: any | null, completedAt?: any | null, inboundMethod?: InboundMethod | null, expectedInboundArrivalDate?: any | null, outboundMethod?: OutboundMethod | null, driverCompletedAt?: any | null, notes?: string | null, serviceDate?: any | null, status: StopStatus, appointmentTime?: any | null, endAppointmentTime?: any | null, isSpecial?: boolean | null, settlementDeductionFlatRate?: number | null, settlementDeductionName?: string | null, settlementDeductionPercentageRate?: number | null, standardStopType?: StandardStopType | null, paperworkMarkedComplete?: boolean | null, sentToAgentAt?: any | null, confirmedByAgentAt?: any | null, address: { __typename?: 'AddressEntity', internalNotes?: string | null, iataCode?: string | null, uuid: string, name: string, line1: string, line2?: string | null, city: string, state: string, zip: string, country: string, latitude?: number | null, longitude?: number | null, driverInstructions?: string | null, receivingHoursStart?: any | null, receivingHoursEnd?: any | null, specialInstructions?: string | null }, serviceDateV2?: { __typename?: 'PlainDate', iso8601: string } | null, routeSlot?: { __typename?: 'RouteSlotEntity', uuid: string, route?: { __typename?: 'RouteEntity', uuid: string, date: any, name: string, slots: Array<{ __typename?: 'RouteSlotEntity', uuid: string }>, drivers: Array<{ __typename?: 'DriverEntity', uuid: string, firstName: string, lastName: string, driverType?: DriverType | null, agent?: { __typename?: 'AgentFieldsEntity', uuid: string, name: string } | null }>, equipments: Array<{ __typename?: 'EquipmentEntity', uuid: string, name: string }> } | null } | null, terminal?: { __typename?: 'TerminalEntity', name: string, code: string, uuid: string, isActive: boolean, address: { __typename?: 'AddressEntity', line1: string, line2?: string | null, city: string, state: string, zip: string, uuid: string, name: string, latitude?: number | null, longitude?: number | null }, startForTerminalLanes: Array<{ __typename?: 'TerminalLaneEntity', id: string, endTerminal: { __typename?: 'TerminalEntity', uuid: string, code: string, name: string } }>, agent?: { __typename?: 'AgentFieldsEntity', name: string } | null } | null, stopDriverMaps: Array<{ __typename?: 'StopDriverMapEntity', uuid: string, name?: string | null, enableDriverSettlement?: boolean | null, revenuePercentageRate?: number | null, revenueFlatRate?: number | null, driverPayoutFinalized: boolean, driver: { __typename?: 'DriverEntity', firstName: string, lastName: string, uuid: string, driverType?: DriverType | null, driverReferenceNumber?: string | null, defaultFuelSettlementPercentageRate?: number | null, user: { __typename?: 'UserEntity', name?: string | null }, defaultVehicle?: { __typename?: 'EquipmentEntity', uuid: string } | null, terminal?: { __typename?: 'TerminalEntity', uuid: string, name: string } | null, qualifications: Array<{ __typename?: 'DriverQualificationEntity', id: string }> }, driverSettlementBill?: { __typename?: 'DriverSettlementBillEntity', uuid: string } | null, stop: { __typename?: 'StandardStopEntity', uuid: string, completedAt?: any | null, settlementDeductionName?: string | null, settlementDeductionFlatRate?: number | null, settlementDeductionPercentageRate?: number | null } }> }, previousStopAttempts: Array<{ __typename?: 'StandardStopEntity', stopDriverMaps: Array<{ __typename?: 'StopDriverMapEntity', uuid: string, name?: string | null, enableDriverSettlement?: boolean | null, revenuePercentageRate?: number | null, revenueFlatRate?: number | null, driverPayoutFinalized: boolean, driver: { __typename?: 'DriverEntity', firstName: string, lastName: string, uuid: string, driverType?: DriverType | null, driverReferenceNumber?: string | null, defaultFuelSettlementPercentageRate?: number | null, user: { __typename?: 'UserEntity', name?: string | null }, defaultVehicle?: { __typename?: 'EquipmentEntity', uuid: string } | null, terminal?: { __typename?: 'TerminalEntity', uuid: string, name: string } | null, qualifications: Array<{ __typename?: 'DriverQualificationEntity', id: string }> }, driverSettlementBill?: { __typename?: 'DriverSettlementBillEntity', uuid: string } | null, stop: { __typename?: 'StandardStopEntity', uuid: string, completedAt?: any | null, settlementDeductionName?: string | null, settlementDeductionFlatRate?: number | null, settlementDeductionPercentageRate?: number | null } }> }> }>, packages: Array<{ __typename?: 'PackageEntity', uuid: string, class?: number | null, description: string, hazmat?: boolean | null, height?: number | null, length?: number | null, nmfc?: string | null, quantity: number, skuNumber?: string | null, type?: PackageType | null, weight?: number | null, width?: number | null, quantityCompletedAtStop?: number | null, reasonUncompletedAtStop?: string | null, packageSpec?: { __typename?: 'PackageSpecEntity', id: string, name: string } | null, warehouseLocation?: { __typename?: 'WarehouseLocationEntity', uuid: string, name: string } | null }>, customCharges: Array<{ __typename?: 'CustomChargeEntity', uuid: string, rate: number, description?: string | null, total: number, totalAmountCents?: number | null, postedAmountUsdCents?: number | null, authoCode?: string | null, quantity: number, billingMethod: CustomChargeBillingMethod, isAutoApplied: boolean, name: string, fuelSurchargeRate?: number | null, postedFuelSurchargeRate?: number | null, zoneBasedAccessorialChargeGroupUuid?: string | null, zoneBasedAccessorialZoneUuid?: string | null, specialAccessorialTariffZoneUuid?: string | null, specialAccessorialChargeGroupUuid?: string | null, settlementFlatRate?: number | null, settlementPercentageRate?: number | null, zoneBasedAccessorialMatrixItem?: { __typename?: 'ZoneBasedAccessorialMatrixItemEntity', uuid: string } | null, specialAccessorialMatrixItem?: { __typename?: 'SpecialAccessorialMatrixItemEntity', uuid: string } | null, accessorialRange?: { __typename?: 'AccessorialRangeEntity', uuid: string, lessThanOrEqualToValue: number, rateUsdCents: number } | null, accessorialTemplate?: { __typename?: 'SkidBasedAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename?: 'SpecialAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename?: 'StandardAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | null }>, freightCharge?: { __typename?: 'FreightChargeEntity', uuid: string, quantity: number, billingMethod: FreightBillingMethod, description?: string | null, authoCode?: string | null, rate: number, settlementFlatRate?: number | null, settlementPercentageRate?: number | null, total: number, fuelCharge?: { __typename?: 'FuelChargeEntity', uuid: string, surchargeRate: number, description?: string | null, authoCode?: string | null, flatRate: number, type: FuelBillingMethod, settlementFlatRate?: number | null, settlementPercentageRate?: number | null } | null, tariff?: { __typename?: 'TariffEntity', uuid: string, billingPartyContactUuid?: string | null, tariffGroup?: { __typename?: 'TariffGroupEntity', name?: string | null, tariffGroupScope?: TariffGroupScope | null } | null, tariffZone: { __typename?: 'TariffZoneEntity', name: string } } | null } | null, inputForConsolidatedOrder?: { __typename?: 'StandardOrderEntity', uuid: string } | null, shipmentCharges: { __typename?: 'ShipmentChargeEntity', totalFuelCharge: number, totalCustomCharge: number, totalFreightCharge: number, totalCharge: number } }>, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', uuid: string, dimFactor?: number | null, shipperBillOfLadingNumber?: string | null, masterAirwayBillOfLadingNumber?: string | null }, tags: Array<{ __typename?: 'TagEntity', uuid: string, value: string, color?: string | null }> } | null, invoice?: { __typename?: 'InvoiceEntity', uuid: string, date: any, postedAt?: any | null, dueDate?: any | null, name: string, journalNumber: number, billToContact: { __typename?: 'CustomerContactEntity', uuid: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string } } | null, documents: Array<{ __typename?: 'DocumentEntity', uuid: string, fileName: string, bucket: string, region: string, key: string, uploadedAt?: any | null, fileType: string, isDeleted: boolean, preSignedGetUrl: string, name?: string | null, type: DocumentType, pageNumber?: number | null, createdAt: any, notes?: string | null, order?: { __typename?: 'StandardOrderEntity', uuid: string, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', shipperBillOfLadingNumber?: string | null } } | null, shipment?: { __typename?: 'StandardOrderEntity', uuid: string } | null, driverFormTemplate?: { __typename?: 'DriverSignableFormTemplateEntity', uuid: string, title: string, formText: string } | null }>, shipmentSubscribers: Array<{ __typename?: 'ShipmentSubscriberEntity', uuid: string, email?: string | null }>, shipperAddress?: { __typename?: 'AddressEntity', uuid: string, name: string, line1: string, line2?: string | null, city: string, state: string, zip: string, country: string, latitude?: number | null, longitude?: number | null, driverInstructions?: string | null, receivingHoursStart?: any | null, receivingHoursEnd?: any | null, specialInstructions?: string | null } | null, airportInfo?: { __typename?: 'AirportInfoEntity', uuid: string, iataCode: string, terminal: string, address: { __typename?: 'AddressEntity', uuid: string, name: string, line1: string, line2?: string | null, city: string, state: string, zip: string, country: string, latitude?: number | null, longitude?: number | null, driverInstructions?: string | null, receivingHoursStart?: any | null, receivingHoursEnd?: any | null, specialInstructions?: string | null } } | null, fields?: { __typename?: 'StandardShipmentFieldsEntity', uuid: string, deadlineDate?: any | null, deadlineType?: DeadlineType | null, deliveryDate?: any | null, dimFactor: number, pickupOrDelivery: PickupOrDelivery, outboundMethod?: OutboundMethod | null, inboundMethod?: InboundMethod | null, type: StandardShipmentType, service?: { __typename?: 'ServiceEntity', uuid: string, name: string, createdAt: any, updatedAt: any, timeInMinutes?: number | null, useApptInRouteOptimization: boolean, markOrdersAsSpecial: boolean, defaultAppointmentStartTime?: any | null, defaultAppointmentEndTime?: any | null, defaultStartNow: boolean, defaultInboundStopType?: StopType | null, defaultOutboundStopType?: StopType | null, defaultPickupPadding?: any | null, defaultDeliveryPadding?: any | null, defaultTotalDuration?: any | null, defaultIsLineHaul: boolean, defaultFulfillmentType?: FulfillmentType | null, isActive: boolean, isExposedToCustomers: boolean, serviceAvailabilityDates: Array<{ __typename?: 'ServiceAvailabilityDateEntity', id: string, dayCategory: SpecialDayOfWeek, enabled: boolean, start: { __typename?: 'PlainTime', hour: number, minute: number }, end: { __typename?: 'PlainTime', hour: number, minute: number } }> } | null } | null, legs: Array<{ __typename?: 'LegEntity', uuid: string, miles?: number | null, endStop: { __typename?: 'StandardStopEntity', uuid: string, createdAt: any, specialInstructions?: string | null, destinationAirport?: string | null, inboundDeadlineDate?: any | null, expectedOutboundDate?: any | null, outboundCarrier?: string | null, appointmentTextStatus?: AppointmentTextStatus | null, incomingCarrier?: string | null, appointmentCallStatus?: AppointmentCallStatus | null, appointmentManuallyConfirmed?: boolean | null, deadlineTime?: any | null, settlementDeductionFlatRate?: number | null, settlementDeductionPercentageRate?: number | null, settlementDeductionName?: string | null, proofOfDeliverySignee?: string | null, appointmentTime?: any | null, arrivedAt?: any | null, completedAt?: any | null, inboundMethod?: InboundMethod | null, expectedInboundArrivalDate?: any | null, outboundMethod?: OutboundMethod | null, driverCompletedAt?: any | null, notes?: string | null, serviceDate?: any | null, status: StopStatus, appointmentRequired: boolean, endAppointmentTime?: any | null, isSpecial?: boolean | null, hideFromDispatch?: boolean | null, standardStopType?: StandardStopType | null, stopType?: StopType | null, paperworkMarkedComplete?: boolean | null, canMarkAttemptComplete?: boolean | null, sentToAgentAt?: any | null, confirmedByAgentAt?: any | null, address: { __typename?: 'AddressEntity', preventCoordRecompute?: boolean | null, internalNotes?: string | null, iataCode?: string | null, uuid: string, name: string, line1: string, line2?: string | null, city: string, state: string, zip: string, country: string, latitude?: number | null, longitude?: number | null, driverInstructions?: string | null, receivingHoursStart?: any | null, receivingHoursEnd?: any | null, specialInstructions?: string | null }, transferAddress?: { __typename?: 'AddressEntity', uuid: string, name: string, line1: string, line2?: string | null, city: string, state: string, zip: string, country: string, latitude?: number | null, longitude?: number | null, driverInstructions?: string | null, receivingHoursStart?: any | null, receivingHoursEnd?: any | null, specialInstructions?: string | null } | null, consigneeAddress?: { __typename?: 'AddressEntity', uuid: string, name: string, line1: string, line2?: string | null, city: string, state: string, zip: string, country: string, latitude?: number | null, longitude?: number | null, driverInstructions?: string | null, receivingHoursStart?: any | null, receivingHoursEnd?: any | null, specialInstructions?: string | null } | null, consigneeContactPerson?: { __typename?: 'ContactPersonEntity', uuid: string, firstName?: string | null, lastName?: string | null, email?: string | null, notes?: string | null, phone?: string | null, createdAt: any } | null, serviceDateV2?: { __typename?: 'PlainDate', iso8601: string } | null, shipperAddress?: { __typename?: 'AddressEntity', uuid: string, name: string, line1: string, line2?: string | null, city: string, state: string, zip: string, country: string, latitude?: number | null, longitude?: number | null, driverInstructions?: string | null, receivingHoursStart?: any | null, receivingHoursEnd?: any | null, specialInstructions?: string | null } | null, shipperContactPerson?: { __typename?: 'ContactPersonEntity', uuid: string, firstName?: string | null, lastName?: string | null, email?: string | null, notes?: string | null, phone?: string | null, createdAt: any } | null, routeSlot?: { __typename?: 'RouteSlotEntity', uuid: string, route?: { __typename?: 'RouteEntity', uuid: string, date: any, name: string, slots: Array<{ __typename?: 'RouteSlotEntity', uuid: string }>, drivers: Array<{ __typename?: 'DriverEntity', uuid: string, firstName: string, lastName: string, driverType?: DriverType | null, agent?: { __typename?: 'AgentFieldsEntity', uuid: string, name: string } | null }>, equipments: Array<{ __typename?: 'EquipmentEntity', uuid: string, name: string }> } | null } | null, contactPerson?: { __typename?: 'ContactPersonEntity', uuid: string, firstName?: string | null, lastName?: string | null, email?: string | null, notes?: string | null, phone?: string | null, createdAt: any } | null, terminal?: { __typename?: 'TerminalEntity', name: string, code: string, uuid: string, isActive: boolean, address: { __typename?: 'AddressEntity', line1: string, line2?: string | null, city: string, state: string, zip: string, uuid: string, name: string, latitude?: number | null, longitude?: number | null }, startForTerminalLanes: Array<{ __typename?: 'TerminalLaneEntity', id: string, endTerminal: { __typename?: 'TerminalEntity', uuid: string, code: string, name: string } }>, agent?: { __typename?: 'AgentFieldsEntity', name: string } | null } | null, stopDriverMaps: Array<{ __typename?: 'StopDriverMapEntity', uuid: string, name?: string | null, enableDriverSettlement?: boolean | null, revenuePercentageRate?: number | null, revenueFlatRate?: number | null, driverPayoutFinalized: boolean, driver: { __typename?: 'DriverEntity', firstName: string, lastName: string, uuid: string, driverType?: DriverType | null, driverReferenceNumber?: string | null, defaultFuelSettlementPercentageRate?: number | null, user: { __typename?: 'UserEntity', name?: string | null }, defaultVehicle?: { __typename?: 'EquipmentEntity', uuid: string } | null, terminal?: { __typename?: 'TerminalEntity', uuid: string, name: string } | null, qualifications: Array<{ __typename?: 'DriverQualificationEntity', id: string }> }, driverSettlementBill?: { __typename?: 'DriverSettlementBillEntity', uuid: string } | null, stop: { __typename?: 'StandardStopEntity', uuid: string, completedAt?: any | null, settlementDeductionName?: string | null, settlementDeductionFlatRate?: number | null, settlementDeductionPercentageRate?: number | null } }> }, previousStopAttempts: Array<{ __typename?: 'StandardStopEntity', stopDriverMaps: Array<{ __typename?: 'StopDriverMapEntity', uuid: string, name?: string | null, enableDriverSettlement?: boolean | null, revenuePercentageRate?: number | null, revenueFlatRate?: number | null, driverPayoutFinalized: boolean, driver: { __typename?: 'DriverEntity', firstName: string, lastName: string, uuid: string, driverType?: DriverType | null, driverReferenceNumber?: string | null, defaultFuelSettlementPercentageRate?: number | null, user: { __typename?: 'UserEntity', name?: string | null }, defaultVehicle?: { __typename?: 'EquipmentEntity', uuid: string } | null, terminal?: { __typename?: 'TerminalEntity', uuid: string, name: string } | null, qualifications: Array<{ __typename?: 'DriverQualificationEntity', id: string }> }, driverSettlementBill?: { __typename?: 'DriverSettlementBillEntity', uuid: string } | null, stop: { __typename?: 'StandardStopEntity', uuid: string, completedAt?: any | null, settlementDeductionName?: string | null, settlementDeductionFlatRate?: number | null, settlementDeductionPercentageRate?: number | null } }> }> }>, packages: Array<{ __typename?: 'PackageEntity', uuid: string, class?: number | null, description: string, hazmat?: boolean | null, height?: number | null, length?: number | null, nmfc?: string | null, quantity: number, skuNumber?: string | null, type?: PackageType | null, weight?: number | null, width?: number | null, quantityCompletedAtStop?: number | null, reasonUncompletedAtStop?: string | null, packageSpec?: { __typename?: 'PackageSpecEntity', id: string, name: string } | null, warehouseLocation?: { __typename?: 'WarehouseLocationEntity', uuid: string, name: string } | null }>, customCharges: Array<{ __typename?: 'CustomChargeEntity', uuid: string, rate: number, description?: string | null, total: number, totalAmountCents?: number | null, postedAmountUsdCents?: number | null, authoCode?: string | null, quantity: number, billingMethod: CustomChargeBillingMethod, isAutoApplied: boolean, name: string, fuelSurchargeRate?: number | null, postedFuelSurchargeRate?: number | null, zoneBasedAccessorialChargeGroupUuid?: string | null, zoneBasedAccessorialZoneUuid?: string | null, specialAccessorialTariffZoneUuid?: string | null, specialAccessorialChargeGroupUuid?: string | null, settlementFlatRate?: number | null, settlementPercentageRate?: number | null, zoneBasedAccessorialMatrixItem?: { __typename?: 'ZoneBasedAccessorialMatrixItemEntity', uuid: string } | null, specialAccessorialMatrixItem?: { __typename?: 'SpecialAccessorialMatrixItemEntity', uuid: string } | null, accessorialRange?: { __typename?: 'AccessorialRangeEntity', uuid: string, lessThanOrEqualToValue: number, rateUsdCents: number } | null, accessorialTemplate?: { __typename?: 'SkidBasedAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename?: 'SpecialAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename?: 'StandardAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | null }>, freightCharge?: { __typename?: 'FreightChargeEntity', uuid: string, quantity: number, billingMethod: FreightBillingMethod, description?: string | null, authoCode?: string | null, rate: number, discountRate?: any | null, settlementFlatRate?: number | null, settlementPercentageRate?: number | null, total: number, totalAmountCents?: number | null, postedAmountUsdCents?: number | null, fuelCharge?: { __typename?: 'FuelChargeEntity', uuid: string, surchargeRate: number, description?: string | null, authoCode?: string | null, flatRate: number, type: FuelBillingMethod, settlementFlatRate?: number | null, settlementPercentageRate?: number | null, totalAmountCents?: number | null, postedAmountUsdCents?: number | null } | null, tariff?: { __typename?: 'TariffEntity', uuid: string, billingPartyContactUuid?: string | null, tariffGroup?: { __typename?: 'TariffGroupEntity', name?: string | null, tariffGroupScope?: TariffGroupScope | null } | null, tariffZone: { __typename?: 'TariffZoneEntity', name: string } } | null } | null, inputForConsolidatedOrder?: { __typename?: 'StandardOrderEntity', uuid: string, name: string } | null, shipmentCharges: { __typename?: 'ShipmentChargeEntity', totalFuelCharge: number, totalCustomCharge: number, totalFreightCharge: number, totalCharge: number }, independentSettlementBillLineItems: Array<{ __typename?: 'SettlementBillLineItemEntity', id: string, settlementMode: SettlementMode, totalAmountUsdDollars: number, revenuePercentageRate?: any | null, revenueFlatRate?: number | null, driver: { __typename?: 'DriverEntity', uuid: string, user: { __typename?: 'UserEntity', name?: string | null } }, driverSettlementBill?: { __typename?: 'DriverSettlementBillEntity', uuid: string, name?: string | null, finalizedDate?: any | null } | null, freightCost?: { __typename?: 'FreightCostEntity', id: string, billingMethod?: FreightBillingMethod | null, dependentSettlementBillingMethod?: DependentSettlementBillingMethod | null, percentageRate?: any | null, flatRateUsdDollars?: number | null, quantity?: number | null, rateUsdDollars?: number | null, discountRate?: any | null, totalAmountUsdDollars?: number | null, totalAmountUsdCents: number, tariff?: { __typename?: 'TariffEntity', uuid: string, tariffZone: { __typename?: 'TariffZoneEntity', name: string } } | null, fuelCost?: { __typename?: 'FuelCostEntity', id: string, billingMethod?: FuelBillingMethod | null, dependentSettlementBillingMethod?: DependentSettlementBillingMethod | null, percentageRate?: any | null, surchargeRate?: number | null, flatRateUsdDollars?: number | null, totalAmountUsdDollars?: number | null, totalAmountUsdCents: number } | null } | null, customCosts: Array<{ __typename?: 'CustomCostEntity', id: string, name: string, billingMethod?: CustomChargeBillingMethod | null, dependentSettlementBillingMethod?: DependentSettlementBillingMethod | null, percentageRate?: any | null, flatRateUsdDollars?: number | null, quantity: number, rateUsdDollars?: number | null, fuelSurchargeRate?: number | null, totalAmountUsdDollars?: number | null, totalAmountUsdCents: number, accessorialTemplate?: { __typename: 'SkidBasedAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename: 'SpecialAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename: 'StandardAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename: 'UnitBasedAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename: 'WaitTimeAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename: 'WeightBasedAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename: 'ZoneBasedAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | null, specialAccessorialMatrixItem?: { __typename?: 'SpecialAccessorialMatrixItemEntity', uuid: string, zoneUuid: string, chargeGroupUuid: string } | null, zoneBasedAccessorialMatrixItem?: { __typename?: 'ZoneBasedAccessorialMatrixItemEntity', uuid: string, zoneUuid: string, chargeGroupUuid: string } | null, accessorialRange?: { __typename?: 'AccessorialRangeEntity', uuid: string } | null }> }> };

export type OutstandingShipmentFragment = { __typename?: 'StandardShipmentEntity', uuid: string, totalChargesAmount: number, status: ShipmentStatus, consolidatableShipments?: Array<{ __typename?: 'StandardShipmentEntity', uuid: string, order?: { __typename?: 'StandardOrderEntity', uuid: string, consolidatedShipmentString?: string | null, name: string, detailedStatusV2?: OrderDetailedStatus | null, status: OrderStatus, notes: string, orderConsolidationType: OrderConsolidationType, source: OrderSource, secondaryRefNumber?: string | null, billingPartyContact: { __typename?: 'CustomerContactEntity', uuid: string }, packages: Array<{ __typename?: 'PackageEntity', uuid: string, class?: number | null, description: string, hazmat?: boolean | null, height?: number | null, length?: number | null, nmfc?: string | null, quantity: number, skuNumber?: string | null, type?: PackageType | null, weight?: number | null, width?: number | null, quantityCompletedAtStop?: number | null, reasonUncompletedAtStop?: string | null, packageSpec?: { __typename?: 'PackageSpecEntity', id: string, name: string } | null, warehouseLocation?: { __typename?: 'WarehouseLocationEntity', uuid: string, name: string } | null }>, shipments: Array<{ __typename?: 'StandardShipmentEntity', uuid: string, totalChargesAmount: number, shouldBillIndividually: boolean, shouldUseDimWeight: boolean, overridePackageWeight: boolean, name: string, hideFromBilling: boolean, hasSignedPOD: boolean, status: ShipmentStatus, shipmentType: ShipmentType, documents: Array<{ __typename?: 'DocumentEntity', uuid: string, fileName: string, bucket: string, region: string, key: string, uploadedAt?: any | null, fileType: string, isDeleted: boolean, preSignedGetUrl: string, name?: string | null, type: DocumentType, pageNumber?: number | null, createdAt: any, notes?: string | null, order?: { __typename?: 'StandardOrderEntity', uuid: string, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', shipperBillOfLadingNumber?: string | null } } | null, shipment?: { __typename?: 'StandardOrderEntity', uuid: string } | null, driverFormTemplate?: { __typename?: 'DriverSignableFormTemplateEntity', uuid: string, title: string, formText: string } | null }>, shipmentSubscribers: Array<{ __typename?: 'ShipmentSubscriberEntity', uuid: string, email?: string | null }>, standardShipmentFields: { __typename?: 'StandardShipmentFieldsEntity', uuid: string, pickupOrDelivery: PickupOrDelivery }, fields?: { __typename?: 'StandardShipmentFieldsEntity', uuid: string, deadlineDate?: any | null, deadlineType?: DeadlineType | null, deliveryDate?: any | null, dimFactor: number, pickupOrDelivery: PickupOrDelivery, type: StandardShipmentType, service?: { __typename?: 'ServiceEntity', uuid: string, name: string, createdAt: any, updatedAt: any, timeInMinutes?: number | null, useApptInRouteOptimization: boolean, markOrdersAsSpecial: boolean, defaultAppointmentStartTime?: any | null, defaultAppointmentEndTime?: any | null, defaultStartNow: boolean, defaultInboundStopType?: StopType | null, defaultOutboundStopType?: StopType | null, defaultPickupPadding?: any | null, defaultDeliveryPadding?: any | null, defaultTotalDuration?: any | null, defaultIsLineHaul: boolean, defaultFulfillmentType?: FulfillmentType | null, isActive: boolean, isExposedToCustomers: boolean, serviceAvailabilityDates: Array<{ __typename?: 'ServiceAvailabilityDateEntity', id: string, dayCategory: SpecialDayOfWeek, enabled: boolean, start: { __typename?: 'PlainTime', hour: number, minute: number }, end: { __typename?: 'PlainTime', hour: number, minute: number } }> } | null } | null, legs: Array<{ __typename?: 'LegEntity', uuid: string, miles?: number | null, endStop: { __typename?: 'StandardStopEntity', uuid: string, createdAt: any, specialInstructions?: string | null, stopType?: StopType | null, appointmentRequired: boolean, deadlineTime?: any | null, proofOfDeliverySignee?: string | null, arrivedAt?: any | null, completedAt?: any | null, inboundMethod?: InboundMethod | null, expectedInboundArrivalDate?: any | null, outboundMethod?: OutboundMethod | null, driverCompletedAt?: any | null, notes?: string | null, serviceDate?: any | null, status: StopStatus, appointmentTime?: any | null, endAppointmentTime?: any | null, isSpecial?: boolean | null, settlementDeductionFlatRate?: number | null, settlementDeductionName?: string | null, settlementDeductionPercentageRate?: number | null, standardStopType?: StandardStopType | null, paperworkMarkedComplete?: boolean | null, sentToAgentAt?: any | null, confirmedByAgentAt?: any | null, address: { __typename?: 'AddressEntity', internalNotes?: string | null, iataCode?: string | null, uuid: string, name: string, line1: string, line2?: string | null, city: string, state: string, zip: string, country: string, latitude?: number | null, longitude?: number | null, driverInstructions?: string | null, receivingHoursStart?: any | null, receivingHoursEnd?: any | null, specialInstructions?: string | null }, serviceDateV2?: { __typename?: 'PlainDate', iso8601: string } | null, routeSlot?: { __typename?: 'RouteSlotEntity', uuid: string, route?: { __typename?: 'RouteEntity', uuid: string, date: any, name: string, slots: Array<{ __typename?: 'RouteSlotEntity', uuid: string }>, drivers: Array<{ __typename?: 'DriverEntity', uuid: string, firstName: string, lastName: string, driverType?: DriverType | null, agent?: { __typename?: 'AgentFieldsEntity', uuid: string, name: string } | null }>, equipments: Array<{ __typename?: 'EquipmentEntity', uuid: string, name: string }> } | null } | null, terminal?: { __typename?: 'TerminalEntity', name: string, code: string, uuid: string, isActive: boolean, address: { __typename?: 'AddressEntity', line1: string, line2?: string | null, city: string, state: string, zip: string, uuid: string, name: string, latitude?: number | null, longitude?: number | null }, startForTerminalLanes: Array<{ __typename?: 'TerminalLaneEntity', id: string, endTerminal: { __typename?: 'TerminalEntity', uuid: string, code: string, name: string } }>, agent?: { __typename?: 'AgentFieldsEntity', name: string } | null } | null, stopDriverMaps: Array<{ __typename?: 'StopDriverMapEntity', uuid: string, name?: string | null, enableDriverSettlement?: boolean | null, revenuePercentageRate?: number | null, revenueFlatRate?: number | null, driverPayoutFinalized: boolean, driver: { __typename?: 'DriverEntity', firstName: string, lastName: string, uuid: string, driverType?: DriverType | null, driverReferenceNumber?: string | null, defaultFuelSettlementPercentageRate?: number | null, user: { __typename?: 'UserEntity', name?: string | null }, defaultVehicle?: { __typename?: 'EquipmentEntity', uuid: string } | null, terminal?: { __typename?: 'TerminalEntity', uuid: string, name: string } | null, qualifications: Array<{ __typename?: 'DriverQualificationEntity', id: string }> }, driverSettlementBill?: { __typename?: 'DriverSettlementBillEntity', uuid: string } | null, stop: { __typename?: 'StandardStopEntity', uuid: string, completedAt?: any | null, settlementDeductionName?: string | null, settlementDeductionFlatRate?: number | null, settlementDeductionPercentageRate?: number | null } }> }, previousStopAttempts: Array<{ __typename?: 'StandardStopEntity', stopDriverMaps: Array<{ __typename?: 'StopDriverMapEntity', uuid: string, name?: string | null, enableDriverSettlement?: boolean | null, revenuePercentageRate?: number | null, revenueFlatRate?: number | null, driverPayoutFinalized: boolean, driver: { __typename?: 'DriverEntity', firstName: string, lastName: string, uuid: string, driverType?: DriverType | null, driverReferenceNumber?: string | null, defaultFuelSettlementPercentageRate?: number | null, user: { __typename?: 'UserEntity', name?: string | null }, defaultVehicle?: { __typename?: 'EquipmentEntity', uuid: string } | null, terminal?: { __typename?: 'TerminalEntity', uuid: string, name: string } | null, qualifications: Array<{ __typename?: 'DriverQualificationEntity', id: string }> }, driverSettlementBill?: { __typename?: 'DriverSettlementBillEntity', uuid: string } | null, stop: { __typename?: 'StandardStopEntity', uuid: string, completedAt?: any | null, settlementDeductionName?: string | null, settlementDeductionFlatRate?: number | null, settlementDeductionPercentageRate?: number | null } }> }> }>, packages: Array<{ __typename?: 'PackageEntity', uuid: string, class?: number | null, description: string, hazmat?: boolean | null, height?: number | null, length?: number | null, nmfc?: string | null, quantity: number, skuNumber?: string | null, type?: PackageType | null, weight?: number | null, width?: number | null, quantityCompletedAtStop?: number | null, reasonUncompletedAtStop?: string | null, packageSpec?: { __typename?: 'PackageSpecEntity', id: string, name: string } | null, warehouseLocation?: { __typename?: 'WarehouseLocationEntity', uuid: string, name: string } | null }>, customCharges: Array<{ __typename?: 'CustomChargeEntity', uuid: string, rate: number, description?: string | null, total: number, totalAmountCents?: number | null, postedAmountUsdCents?: number | null, authoCode?: string | null, quantity: number, billingMethod: CustomChargeBillingMethod, isAutoApplied: boolean, name: string, fuelSurchargeRate?: number | null, postedFuelSurchargeRate?: number | null, zoneBasedAccessorialChargeGroupUuid?: string | null, zoneBasedAccessorialZoneUuid?: string | null, specialAccessorialTariffZoneUuid?: string | null, specialAccessorialChargeGroupUuid?: string | null, settlementFlatRate?: number | null, settlementPercentageRate?: number | null, zoneBasedAccessorialMatrixItem?: { __typename?: 'ZoneBasedAccessorialMatrixItemEntity', uuid: string } | null, specialAccessorialMatrixItem?: { __typename?: 'SpecialAccessorialMatrixItemEntity', uuid: string } | null, accessorialRange?: { __typename?: 'AccessorialRangeEntity', uuid: string, lessThanOrEqualToValue: number, rateUsdCents: number } | null, accessorialTemplate?: { __typename?: 'SkidBasedAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename?: 'SpecialAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename?: 'StandardAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | null }>, freightCharge?: { __typename?: 'FreightChargeEntity', uuid: string, quantity: number, billingMethod: FreightBillingMethod, description?: string | null, authoCode?: string | null, rate: number, settlementFlatRate?: number | null, settlementPercentageRate?: number | null, total: number, fuelCharge?: { __typename?: 'FuelChargeEntity', uuid: string, surchargeRate: number, description?: string | null, authoCode?: string | null, flatRate: number, type: FuelBillingMethod, settlementFlatRate?: number | null, settlementPercentageRate?: number | null } | null, tariff?: { __typename?: 'TariffEntity', uuid: string, billingPartyContactUuid?: string | null, tariffGroup?: { __typename?: 'TariffGroupEntity', name?: string | null, tariffGroupScope?: TariffGroupScope | null } | null, tariffZone: { __typename?: 'TariffZoneEntity', name: string } } | null } | null, inputForConsolidatedOrder?: { __typename?: 'StandardOrderEntity', uuid: string } | null, shipmentCharges: { __typename?: 'ShipmentChargeEntity', totalFuelCharge: number, totalCustomCharge: number, totalFreightCharge: number, totalCharge: number } }>, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', uuid: string, dimFactor?: number | null, shipperBillOfLadingNumber?: string | null, masterAirwayBillOfLadingNumber?: string | null }, tags: Array<{ __typename?: 'TagEntity', uuid: string, value: string, color?: string | null }> } | null }> | null, order?: { __typename?: 'StandardOrderEntity', uuid: string, consolidatedShipmentString?: string | null, name: string, detailedStatusV2?: OrderDetailedStatus | null, status: OrderStatus, notes: string, orderConsolidationType: OrderConsolidationType, source: OrderSource, secondaryRefNumber?: string | null, billingPartyContact: { __typename?: 'CustomerContactEntity', uuid: string }, packages: Array<{ __typename?: 'PackageEntity', uuid: string, class?: number | null, description: string, hazmat?: boolean | null, height?: number | null, length?: number | null, nmfc?: string | null, quantity: number, skuNumber?: string | null, type?: PackageType | null, weight?: number | null, width?: number | null, quantityCompletedAtStop?: number | null, reasonUncompletedAtStop?: string | null, packageSpec?: { __typename?: 'PackageSpecEntity', id: string, name: string } | null, warehouseLocation?: { __typename?: 'WarehouseLocationEntity', uuid: string, name: string } | null }>, shipments: Array<{ __typename?: 'StandardShipmentEntity', uuid: string, totalChargesAmount: number, shouldBillIndividually: boolean, shouldUseDimWeight: boolean, overridePackageWeight: boolean, name: string, hideFromBilling: boolean, hasSignedPOD: boolean, status: ShipmentStatus, shipmentType: ShipmentType, documents: Array<{ __typename?: 'DocumentEntity', uuid: string, fileName: string, bucket: string, region: string, key: string, uploadedAt?: any | null, fileType: string, isDeleted: boolean, preSignedGetUrl: string, name?: string | null, type: DocumentType, pageNumber?: number | null, createdAt: any, notes?: string | null, order?: { __typename?: 'StandardOrderEntity', uuid: string, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', shipperBillOfLadingNumber?: string | null } } | null, shipment?: { __typename?: 'StandardOrderEntity', uuid: string } | null, driverFormTemplate?: { __typename?: 'DriverSignableFormTemplateEntity', uuid: string, title: string, formText: string } | null }>, shipmentSubscribers: Array<{ __typename?: 'ShipmentSubscriberEntity', uuid: string, email?: string | null }>, standardShipmentFields: { __typename?: 'StandardShipmentFieldsEntity', uuid: string, pickupOrDelivery: PickupOrDelivery }, fields?: { __typename?: 'StandardShipmentFieldsEntity', uuid: string, deadlineDate?: any | null, deadlineType?: DeadlineType | null, deliveryDate?: any | null, dimFactor: number, pickupOrDelivery: PickupOrDelivery, type: StandardShipmentType, service?: { __typename?: 'ServiceEntity', uuid: string, name: string, createdAt: any, updatedAt: any, timeInMinutes?: number | null, useApptInRouteOptimization: boolean, markOrdersAsSpecial: boolean, defaultAppointmentStartTime?: any | null, defaultAppointmentEndTime?: any | null, defaultStartNow: boolean, defaultInboundStopType?: StopType | null, defaultOutboundStopType?: StopType | null, defaultPickupPadding?: any | null, defaultDeliveryPadding?: any | null, defaultTotalDuration?: any | null, defaultIsLineHaul: boolean, defaultFulfillmentType?: FulfillmentType | null, isActive: boolean, isExposedToCustomers: boolean, serviceAvailabilityDates: Array<{ __typename?: 'ServiceAvailabilityDateEntity', id: string, dayCategory: SpecialDayOfWeek, enabled: boolean, start: { __typename?: 'PlainTime', hour: number, minute: number }, end: { __typename?: 'PlainTime', hour: number, minute: number } }> } | null } | null, legs: Array<{ __typename?: 'LegEntity', uuid: string, miles?: number | null, endStop: { __typename?: 'StandardStopEntity', uuid: string, createdAt: any, specialInstructions?: string | null, stopType?: StopType | null, appointmentRequired: boolean, deadlineTime?: any | null, proofOfDeliverySignee?: string | null, arrivedAt?: any | null, completedAt?: any | null, inboundMethod?: InboundMethod | null, expectedInboundArrivalDate?: any | null, outboundMethod?: OutboundMethod | null, driverCompletedAt?: any | null, notes?: string | null, serviceDate?: any | null, status: StopStatus, appointmentTime?: any | null, endAppointmentTime?: any | null, isSpecial?: boolean | null, settlementDeductionFlatRate?: number | null, settlementDeductionName?: string | null, settlementDeductionPercentageRate?: number | null, standardStopType?: StandardStopType | null, paperworkMarkedComplete?: boolean | null, sentToAgentAt?: any | null, confirmedByAgentAt?: any | null, address: { __typename?: 'AddressEntity', internalNotes?: string | null, iataCode?: string | null, uuid: string, name: string, line1: string, line2?: string | null, city: string, state: string, zip: string, country: string, latitude?: number | null, longitude?: number | null, driverInstructions?: string | null, receivingHoursStart?: any | null, receivingHoursEnd?: any | null, specialInstructions?: string | null }, serviceDateV2?: { __typename?: 'PlainDate', iso8601: string } | null, routeSlot?: { __typename?: 'RouteSlotEntity', uuid: string, route?: { __typename?: 'RouteEntity', uuid: string, date: any, name: string, slots: Array<{ __typename?: 'RouteSlotEntity', uuid: string }>, drivers: Array<{ __typename?: 'DriverEntity', uuid: string, firstName: string, lastName: string, driverType?: DriverType | null, agent?: { __typename?: 'AgentFieldsEntity', uuid: string, name: string } | null }>, equipments: Array<{ __typename?: 'EquipmentEntity', uuid: string, name: string }> } | null } | null, terminal?: { __typename?: 'TerminalEntity', name: string, code: string, uuid: string, isActive: boolean, address: { __typename?: 'AddressEntity', line1: string, line2?: string | null, city: string, state: string, zip: string, uuid: string, name: string, latitude?: number | null, longitude?: number | null }, startForTerminalLanes: Array<{ __typename?: 'TerminalLaneEntity', id: string, endTerminal: { __typename?: 'TerminalEntity', uuid: string, code: string, name: string } }>, agent?: { __typename?: 'AgentFieldsEntity', name: string } | null } | null, stopDriverMaps: Array<{ __typename?: 'StopDriverMapEntity', uuid: string, name?: string | null, enableDriverSettlement?: boolean | null, revenuePercentageRate?: number | null, revenueFlatRate?: number | null, driverPayoutFinalized: boolean, driver: { __typename?: 'DriverEntity', firstName: string, lastName: string, uuid: string, driverType?: DriverType | null, driverReferenceNumber?: string | null, defaultFuelSettlementPercentageRate?: number | null, user: { __typename?: 'UserEntity', name?: string | null }, defaultVehicle?: { __typename?: 'EquipmentEntity', uuid: string } | null, terminal?: { __typename?: 'TerminalEntity', uuid: string, name: string } | null, qualifications: Array<{ __typename?: 'DriverQualificationEntity', id: string }> }, driverSettlementBill?: { __typename?: 'DriverSettlementBillEntity', uuid: string } | null, stop: { __typename?: 'StandardStopEntity', uuid: string, completedAt?: any | null, settlementDeductionName?: string | null, settlementDeductionFlatRate?: number | null, settlementDeductionPercentageRate?: number | null } }> }, previousStopAttempts: Array<{ __typename?: 'StandardStopEntity', stopDriverMaps: Array<{ __typename?: 'StopDriverMapEntity', uuid: string, name?: string | null, enableDriverSettlement?: boolean | null, revenuePercentageRate?: number | null, revenueFlatRate?: number | null, driverPayoutFinalized: boolean, driver: { __typename?: 'DriverEntity', firstName: string, lastName: string, uuid: string, driverType?: DriverType | null, driverReferenceNumber?: string | null, defaultFuelSettlementPercentageRate?: number | null, user: { __typename?: 'UserEntity', name?: string | null }, defaultVehicle?: { __typename?: 'EquipmentEntity', uuid: string } | null, terminal?: { __typename?: 'TerminalEntity', uuid: string, name: string } | null, qualifications: Array<{ __typename?: 'DriverQualificationEntity', id: string }> }, driverSettlementBill?: { __typename?: 'DriverSettlementBillEntity', uuid: string } | null, stop: { __typename?: 'StandardStopEntity', uuid: string, completedAt?: any | null, settlementDeductionName?: string | null, settlementDeductionFlatRate?: number | null, settlementDeductionPercentageRate?: number | null } }> }> }>, packages: Array<{ __typename?: 'PackageEntity', uuid: string, class?: number | null, description: string, hazmat?: boolean | null, height?: number | null, length?: number | null, nmfc?: string | null, quantity: number, skuNumber?: string | null, type?: PackageType | null, weight?: number | null, width?: number | null, quantityCompletedAtStop?: number | null, reasonUncompletedAtStop?: string | null, packageSpec?: { __typename?: 'PackageSpecEntity', id: string, name: string } | null, warehouseLocation?: { __typename?: 'WarehouseLocationEntity', uuid: string, name: string } | null }>, customCharges: Array<{ __typename?: 'CustomChargeEntity', uuid: string, rate: number, description?: string | null, total: number, totalAmountCents?: number | null, postedAmountUsdCents?: number | null, authoCode?: string | null, quantity: number, billingMethod: CustomChargeBillingMethod, isAutoApplied: boolean, name: string, fuelSurchargeRate?: number | null, postedFuelSurchargeRate?: number | null, zoneBasedAccessorialChargeGroupUuid?: string | null, zoneBasedAccessorialZoneUuid?: string | null, specialAccessorialTariffZoneUuid?: string | null, specialAccessorialChargeGroupUuid?: string | null, settlementFlatRate?: number | null, settlementPercentageRate?: number | null, zoneBasedAccessorialMatrixItem?: { __typename?: 'ZoneBasedAccessorialMatrixItemEntity', uuid: string } | null, specialAccessorialMatrixItem?: { __typename?: 'SpecialAccessorialMatrixItemEntity', uuid: string } | null, accessorialRange?: { __typename?: 'AccessorialRangeEntity', uuid: string, lessThanOrEqualToValue: number, rateUsdCents: number } | null, accessorialTemplate?: { __typename?: 'SkidBasedAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename?: 'SpecialAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename?: 'StandardAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | null }>, freightCharge?: { __typename?: 'FreightChargeEntity', uuid: string, quantity: number, billingMethod: FreightBillingMethod, description?: string | null, authoCode?: string | null, rate: number, settlementFlatRate?: number | null, settlementPercentageRate?: number | null, total: number, fuelCharge?: { __typename?: 'FuelChargeEntity', uuid: string, surchargeRate: number, description?: string | null, authoCode?: string | null, flatRate: number, type: FuelBillingMethod, settlementFlatRate?: number | null, settlementPercentageRate?: number | null } | null, tariff?: { __typename?: 'TariffEntity', uuid: string, billingPartyContactUuid?: string | null, tariffGroup?: { __typename?: 'TariffGroupEntity', name?: string | null, tariffGroupScope?: TariffGroupScope | null } | null, tariffZone: { __typename?: 'TariffZoneEntity', name: string } } | null } | null, inputForConsolidatedOrder?: { __typename?: 'StandardOrderEntity', uuid: string } | null, shipmentCharges: { __typename?: 'ShipmentChargeEntity', totalFuelCharge: number, totalCustomCharge: number, totalFreightCharge: number, totalCharge: number } }>, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', uuid: string, dimFactor?: number | null, shipperBillOfLadingNumber?: string | null, masterAirwayBillOfLadingNumber?: string | null }, tags: Array<{ __typename?: 'TagEntity', uuid: string, value: string, color?: string | null }> } | null, standardShipmentFields: { __typename?: 'StandardShipmentFieldsEntity', uuid: string, pickupOrDelivery: PickupOrDelivery }, legs: Array<{ __typename?: 'LegEntity', uuid: string, endStop: { __typename?: 'StandardStopEntity', completedAt?: any | null, address: { __typename?: 'AddressEntity', name: string, internalNotes?: string | null, iataCode?: string | null } } }> };

export type OutstandingShipmentQueryVariables = Exact<{
  uuid: Scalars['String']['input'];
}>;


export type OutstandingShipmentQuery = { __typename?: 'Query', shipment: { __typename?: 'StandardShipmentEntity', uuid: string, totalChargesAmount: number, status: ShipmentStatus, consolidatableShipments?: Array<{ __typename?: 'StandardShipmentEntity', uuid: string, order?: { __typename?: 'StandardOrderEntity', uuid: string, consolidatedShipmentString?: string | null, name: string, detailedStatusV2?: OrderDetailedStatus | null, status: OrderStatus, notes: string, orderConsolidationType: OrderConsolidationType, source: OrderSource, secondaryRefNumber?: string | null, billingPartyContact: { __typename?: 'CustomerContactEntity', uuid: string }, packages: Array<{ __typename?: 'PackageEntity', uuid: string, class?: number | null, description: string, hazmat?: boolean | null, height?: number | null, length?: number | null, nmfc?: string | null, quantity: number, skuNumber?: string | null, type?: PackageType | null, weight?: number | null, width?: number | null, quantityCompletedAtStop?: number | null, reasonUncompletedAtStop?: string | null, packageSpec?: { __typename?: 'PackageSpecEntity', id: string, name: string } | null, warehouseLocation?: { __typename?: 'WarehouseLocationEntity', uuid: string, name: string } | null }>, shipments: Array<{ __typename?: 'StandardShipmentEntity', uuid: string, totalChargesAmount: number, shouldBillIndividually: boolean, shouldUseDimWeight: boolean, overridePackageWeight: boolean, name: string, hideFromBilling: boolean, hasSignedPOD: boolean, status: ShipmentStatus, shipmentType: ShipmentType, documents: Array<{ __typename?: 'DocumentEntity', uuid: string, fileName: string, bucket: string, region: string, key: string, uploadedAt?: any | null, fileType: string, isDeleted: boolean, preSignedGetUrl: string, name?: string | null, type: DocumentType, pageNumber?: number | null, createdAt: any, notes?: string | null, order?: { __typename?: 'StandardOrderEntity', uuid: string, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', shipperBillOfLadingNumber?: string | null } } | null, shipment?: { __typename?: 'StandardOrderEntity', uuid: string } | null, driverFormTemplate?: { __typename?: 'DriverSignableFormTemplateEntity', uuid: string, title: string, formText: string } | null }>, shipmentSubscribers: Array<{ __typename?: 'ShipmentSubscriberEntity', uuid: string, email?: string | null }>, standardShipmentFields: { __typename?: 'StandardShipmentFieldsEntity', uuid: string, pickupOrDelivery: PickupOrDelivery }, fields?: { __typename?: 'StandardShipmentFieldsEntity', uuid: string, deadlineDate?: any | null, deadlineType?: DeadlineType | null, deliveryDate?: any | null, dimFactor: number, pickupOrDelivery: PickupOrDelivery, type: StandardShipmentType, service?: { __typename?: 'ServiceEntity', uuid: string, name: string, createdAt: any, updatedAt: any, timeInMinutes?: number | null, useApptInRouteOptimization: boolean, markOrdersAsSpecial: boolean, defaultAppointmentStartTime?: any | null, defaultAppointmentEndTime?: any | null, defaultStartNow: boolean, defaultInboundStopType?: StopType | null, defaultOutboundStopType?: StopType | null, defaultPickupPadding?: any | null, defaultDeliveryPadding?: any | null, defaultTotalDuration?: any | null, defaultIsLineHaul: boolean, defaultFulfillmentType?: FulfillmentType | null, isActive: boolean, isExposedToCustomers: boolean, serviceAvailabilityDates: Array<{ __typename?: 'ServiceAvailabilityDateEntity', id: string, dayCategory: SpecialDayOfWeek, enabled: boolean, start: { __typename?: 'PlainTime', hour: number, minute: number }, end: { __typename?: 'PlainTime', hour: number, minute: number } }> } | null } | null, legs: Array<{ __typename?: 'LegEntity', uuid: string, miles?: number | null, endStop: { __typename?: 'StandardStopEntity', uuid: string, createdAt: any, specialInstructions?: string | null, stopType?: StopType | null, appointmentRequired: boolean, deadlineTime?: any | null, proofOfDeliverySignee?: string | null, arrivedAt?: any | null, completedAt?: any | null, inboundMethod?: InboundMethod | null, expectedInboundArrivalDate?: any | null, outboundMethod?: OutboundMethod | null, driverCompletedAt?: any | null, notes?: string | null, serviceDate?: any | null, status: StopStatus, appointmentTime?: any | null, endAppointmentTime?: any | null, isSpecial?: boolean | null, settlementDeductionFlatRate?: number | null, settlementDeductionName?: string | null, settlementDeductionPercentageRate?: number | null, standardStopType?: StandardStopType | null, paperworkMarkedComplete?: boolean | null, sentToAgentAt?: any | null, confirmedByAgentAt?: any | null, address: { __typename?: 'AddressEntity', internalNotes?: string | null, iataCode?: string | null, uuid: string, name: string, line1: string, line2?: string | null, city: string, state: string, zip: string, country: string, latitude?: number | null, longitude?: number | null, driverInstructions?: string | null, receivingHoursStart?: any | null, receivingHoursEnd?: any | null, specialInstructions?: string | null }, serviceDateV2?: { __typename?: 'PlainDate', iso8601: string } | null, routeSlot?: { __typename?: 'RouteSlotEntity', uuid: string, route?: { __typename?: 'RouteEntity', uuid: string, date: any, name: string, slots: Array<{ __typename?: 'RouteSlotEntity', uuid: string }>, drivers: Array<{ __typename?: 'DriverEntity', uuid: string, firstName: string, lastName: string, driverType?: DriverType | null, agent?: { __typename?: 'AgentFieldsEntity', uuid: string, name: string } | null }>, equipments: Array<{ __typename?: 'EquipmentEntity', uuid: string, name: string }> } | null } | null, terminal?: { __typename?: 'TerminalEntity', name: string, code: string, uuid: string, isActive: boolean, address: { __typename?: 'AddressEntity', line1: string, line2?: string | null, city: string, state: string, zip: string, uuid: string, name: string, latitude?: number | null, longitude?: number | null }, startForTerminalLanes: Array<{ __typename?: 'TerminalLaneEntity', id: string, endTerminal: { __typename?: 'TerminalEntity', uuid: string, code: string, name: string } }>, agent?: { __typename?: 'AgentFieldsEntity', name: string } | null } | null, stopDriverMaps: Array<{ __typename?: 'StopDriverMapEntity', uuid: string, name?: string | null, enableDriverSettlement?: boolean | null, revenuePercentageRate?: number | null, revenueFlatRate?: number | null, driverPayoutFinalized: boolean, driver: { __typename?: 'DriverEntity', firstName: string, lastName: string, uuid: string, driverType?: DriverType | null, driverReferenceNumber?: string | null, defaultFuelSettlementPercentageRate?: number | null, user: { __typename?: 'UserEntity', name?: string | null }, defaultVehicle?: { __typename?: 'EquipmentEntity', uuid: string } | null, terminal?: { __typename?: 'TerminalEntity', uuid: string, name: string } | null, qualifications: Array<{ __typename?: 'DriverQualificationEntity', id: string }> }, driverSettlementBill?: { __typename?: 'DriverSettlementBillEntity', uuid: string } | null, stop: { __typename?: 'StandardStopEntity', uuid: string, completedAt?: any | null, settlementDeductionName?: string | null, settlementDeductionFlatRate?: number | null, settlementDeductionPercentageRate?: number | null } }> }, previousStopAttempts: Array<{ __typename?: 'StandardStopEntity', stopDriverMaps: Array<{ __typename?: 'StopDriverMapEntity', uuid: string, name?: string | null, enableDriverSettlement?: boolean | null, revenuePercentageRate?: number | null, revenueFlatRate?: number | null, driverPayoutFinalized: boolean, driver: { __typename?: 'DriverEntity', firstName: string, lastName: string, uuid: string, driverType?: DriverType | null, driverReferenceNumber?: string | null, defaultFuelSettlementPercentageRate?: number | null, user: { __typename?: 'UserEntity', name?: string | null }, defaultVehicle?: { __typename?: 'EquipmentEntity', uuid: string } | null, terminal?: { __typename?: 'TerminalEntity', uuid: string, name: string } | null, qualifications: Array<{ __typename?: 'DriverQualificationEntity', id: string }> }, driverSettlementBill?: { __typename?: 'DriverSettlementBillEntity', uuid: string } | null, stop: { __typename?: 'StandardStopEntity', uuid: string, completedAt?: any | null, settlementDeductionName?: string | null, settlementDeductionFlatRate?: number | null, settlementDeductionPercentageRate?: number | null } }> }> }>, packages: Array<{ __typename?: 'PackageEntity', uuid: string, class?: number | null, description: string, hazmat?: boolean | null, height?: number | null, length?: number | null, nmfc?: string | null, quantity: number, skuNumber?: string | null, type?: PackageType | null, weight?: number | null, width?: number | null, quantityCompletedAtStop?: number | null, reasonUncompletedAtStop?: string | null, packageSpec?: { __typename?: 'PackageSpecEntity', id: string, name: string } | null, warehouseLocation?: { __typename?: 'WarehouseLocationEntity', uuid: string, name: string } | null }>, customCharges: Array<{ __typename?: 'CustomChargeEntity', uuid: string, rate: number, description?: string | null, total: number, totalAmountCents?: number | null, postedAmountUsdCents?: number | null, authoCode?: string | null, quantity: number, billingMethod: CustomChargeBillingMethod, isAutoApplied: boolean, name: string, fuelSurchargeRate?: number | null, postedFuelSurchargeRate?: number | null, zoneBasedAccessorialChargeGroupUuid?: string | null, zoneBasedAccessorialZoneUuid?: string | null, specialAccessorialTariffZoneUuid?: string | null, specialAccessorialChargeGroupUuid?: string | null, settlementFlatRate?: number | null, settlementPercentageRate?: number | null, zoneBasedAccessorialMatrixItem?: { __typename?: 'ZoneBasedAccessorialMatrixItemEntity', uuid: string } | null, specialAccessorialMatrixItem?: { __typename?: 'SpecialAccessorialMatrixItemEntity', uuid: string } | null, accessorialRange?: { __typename?: 'AccessorialRangeEntity', uuid: string, lessThanOrEqualToValue: number, rateUsdCents: number } | null, accessorialTemplate?: { __typename?: 'SkidBasedAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename?: 'SpecialAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename?: 'StandardAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | null }>, freightCharge?: { __typename?: 'FreightChargeEntity', uuid: string, quantity: number, billingMethod: FreightBillingMethod, description?: string | null, authoCode?: string | null, rate: number, settlementFlatRate?: number | null, settlementPercentageRate?: number | null, total: number, fuelCharge?: { __typename?: 'FuelChargeEntity', uuid: string, surchargeRate: number, description?: string | null, authoCode?: string | null, flatRate: number, type: FuelBillingMethod, settlementFlatRate?: number | null, settlementPercentageRate?: number | null } | null, tariff?: { __typename?: 'TariffEntity', uuid: string, billingPartyContactUuid?: string | null, tariffGroup?: { __typename?: 'TariffGroupEntity', name?: string | null, tariffGroupScope?: TariffGroupScope | null } | null, tariffZone: { __typename?: 'TariffZoneEntity', name: string } } | null } | null, inputForConsolidatedOrder?: { __typename?: 'StandardOrderEntity', uuid: string } | null, shipmentCharges: { __typename?: 'ShipmentChargeEntity', totalFuelCharge: number, totalCustomCharge: number, totalFreightCharge: number, totalCharge: number } }>, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', uuid: string, dimFactor?: number | null, shipperBillOfLadingNumber?: string | null, masterAirwayBillOfLadingNumber?: string | null }, tags: Array<{ __typename?: 'TagEntity', uuid: string, value: string, color?: string | null }> } | null }> | null, order?: { __typename?: 'StandardOrderEntity', uuid: string, consolidatedShipmentString?: string | null, name: string, detailedStatusV2?: OrderDetailedStatus | null, status: OrderStatus, notes: string, orderConsolidationType: OrderConsolidationType, source: OrderSource, secondaryRefNumber?: string | null, billingPartyContact: { __typename?: 'CustomerContactEntity', uuid: string }, packages: Array<{ __typename?: 'PackageEntity', uuid: string, class?: number | null, description: string, hazmat?: boolean | null, height?: number | null, length?: number | null, nmfc?: string | null, quantity: number, skuNumber?: string | null, type?: PackageType | null, weight?: number | null, width?: number | null, quantityCompletedAtStop?: number | null, reasonUncompletedAtStop?: string | null, packageSpec?: { __typename?: 'PackageSpecEntity', id: string, name: string } | null, warehouseLocation?: { __typename?: 'WarehouseLocationEntity', uuid: string, name: string } | null }>, shipments: Array<{ __typename?: 'StandardShipmentEntity', uuid: string, totalChargesAmount: number, shouldBillIndividually: boolean, shouldUseDimWeight: boolean, overridePackageWeight: boolean, name: string, hideFromBilling: boolean, hasSignedPOD: boolean, status: ShipmentStatus, shipmentType: ShipmentType, documents: Array<{ __typename?: 'DocumentEntity', uuid: string, fileName: string, bucket: string, region: string, key: string, uploadedAt?: any | null, fileType: string, isDeleted: boolean, preSignedGetUrl: string, name?: string | null, type: DocumentType, pageNumber?: number | null, createdAt: any, notes?: string | null, order?: { __typename?: 'StandardOrderEntity', uuid: string, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', shipperBillOfLadingNumber?: string | null } } | null, shipment?: { __typename?: 'StandardOrderEntity', uuid: string } | null, driverFormTemplate?: { __typename?: 'DriverSignableFormTemplateEntity', uuid: string, title: string, formText: string } | null }>, shipmentSubscribers: Array<{ __typename?: 'ShipmentSubscriberEntity', uuid: string, email?: string | null }>, standardShipmentFields: { __typename?: 'StandardShipmentFieldsEntity', uuid: string, pickupOrDelivery: PickupOrDelivery }, fields?: { __typename?: 'StandardShipmentFieldsEntity', uuid: string, deadlineDate?: any | null, deadlineType?: DeadlineType | null, deliveryDate?: any | null, dimFactor: number, pickupOrDelivery: PickupOrDelivery, type: StandardShipmentType, service?: { __typename?: 'ServiceEntity', uuid: string, name: string, createdAt: any, updatedAt: any, timeInMinutes?: number | null, useApptInRouteOptimization: boolean, markOrdersAsSpecial: boolean, defaultAppointmentStartTime?: any | null, defaultAppointmentEndTime?: any | null, defaultStartNow: boolean, defaultInboundStopType?: StopType | null, defaultOutboundStopType?: StopType | null, defaultPickupPadding?: any | null, defaultDeliveryPadding?: any | null, defaultTotalDuration?: any | null, defaultIsLineHaul: boolean, defaultFulfillmentType?: FulfillmentType | null, isActive: boolean, isExposedToCustomers: boolean, serviceAvailabilityDates: Array<{ __typename?: 'ServiceAvailabilityDateEntity', id: string, dayCategory: SpecialDayOfWeek, enabled: boolean, start: { __typename?: 'PlainTime', hour: number, minute: number }, end: { __typename?: 'PlainTime', hour: number, minute: number } }> } | null } | null, legs: Array<{ __typename?: 'LegEntity', uuid: string, miles?: number | null, endStop: { __typename?: 'StandardStopEntity', uuid: string, createdAt: any, specialInstructions?: string | null, stopType?: StopType | null, appointmentRequired: boolean, deadlineTime?: any | null, proofOfDeliverySignee?: string | null, arrivedAt?: any | null, completedAt?: any | null, inboundMethod?: InboundMethod | null, expectedInboundArrivalDate?: any | null, outboundMethod?: OutboundMethod | null, driverCompletedAt?: any | null, notes?: string | null, serviceDate?: any | null, status: StopStatus, appointmentTime?: any | null, endAppointmentTime?: any | null, isSpecial?: boolean | null, settlementDeductionFlatRate?: number | null, settlementDeductionName?: string | null, settlementDeductionPercentageRate?: number | null, standardStopType?: StandardStopType | null, paperworkMarkedComplete?: boolean | null, sentToAgentAt?: any | null, confirmedByAgentAt?: any | null, address: { __typename?: 'AddressEntity', internalNotes?: string | null, iataCode?: string | null, uuid: string, name: string, line1: string, line2?: string | null, city: string, state: string, zip: string, country: string, latitude?: number | null, longitude?: number | null, driverInstructions?: string | null, receivingHoursStart?: any | null, receivingHoursEnd?: any | null, specialInstructions?: string | null }, serviceDateV2?: { __typename?: 'PlainDate', iso8601: string } | null, routeSlot?: { __typename?: 'RouteSlotEntity', uuid: string, route?: { __typename?: 'RouteEntity', uuid: string, date: any, name: string, slots: Array<{ __typename?: 'RouteSlotEntity', uuid: string }>, drivers: Array<{ __typename?: 'DriverEntity', uuid: string, firstName: string, lastName: string, driverType?: DriverType | null, agent?: { __typename?: 'AgentFieldsEntity', uuid: string, name: string } | null }>, equipments: Array<{ __typename?: 'EquipmentEntity', uuid: string, name: string }> } | null } | null, terminal?: { __typename?: 'TerminalEntity', name: string, code: string, uuid: string, isActive: boolean, address: { __typename?: 'AddressEntity', line1: string, line2?: string | null, city: string, state: string, zip: string, uuid: string, name: string, latitude?: number | null, longitude?: number | null }, startForTerminalLanes: Array<{ __typename?: 'TerminalLaneEntity', id: string, endTerminal: { __typename?: 'TerminalEntity', uuid: string, code: string, name: string } }>, agent?: { __typename?: 'AgentFieldsEntity', name: string } | null } | null, stopDriverMaps: Array<{ __typename?: 'StopDriverMapEntity', uuid: string, name?: string | null, enableDriverSettlement?: boolean | null, revenuePercentageRate?: number | null, revenueFlatRate?: number | null, driverPayoutFinalized: boolean, driver: { __typename?: 'DriverEntity', firstName: string, lastName: string, uuid: string, driverType?: DriverType | null, driverReferenceNumber?: string | null, defaultFuelSettlementPercentageRate?: number | null, user: { __typename?: 'UserEntity', name?: string | null }, defaultVehicle?: { __typename?: 'EquipmentEntity', uuid: string } | null, terminal?: { __typename?: 'TerminalEntity', uuid: string, name: string } | null, qualifications: Array<{ __typename?: 'DriverQualificationEntity', id: string }> }, driverSettlementBill?: { __typename?: 'DriverSettlementBillEntity', uuid: string } | null, stop: { __typename?: 'StandardStopEntity', uuid: string, completedAt?: any | null, settlementDeductionName?: string | null, settlementDeductionFlatRate?: number | null, settlementDeductionPercentageRate?: number | null } }> }, previousStopAttempts: Array<{ __typename?: 'StandardStopEntity', stopDriverMaps: Array<{ __typename?: 'StopDriverMapEntity', uuid: string, name?: string | null, enableDriverSettlement?: boolean | null, revenuePercentageRate?: number | null, revenueFlatRate?: number | null, driverPayoutFinalized: boolean, driver: { __typename?: 'DriverEntity', firstName: string, lastName: string, uuid: string, driverType?: DriverType | null, driverReferenceNumber?: string | null, defaultFuelSettlementPercentageRate?: number | null, user: { __typename?: 'UserEntity', name?: string | null }, defaultVehicle?: { __typename?: 'EquipmentEntity', uuid: string } | null, terminal?: { __typename?: 'TerminalEntity', uuid: string, name: string } | null, qualifications: Array<{ __typename?: 'DriverQualificationEntity', id: string }> }, driverSettlementBill?: { __typename?: 'DriverSettlementBillEntity', uuid: string } | null, stop: { __typename?: 'StandardStopEntity', uuid: string, completedAt?: any | null, settlementDeductionName?: string | null, settlementDeductionFlatRate?: number | null, settlementDeductionPercentageRate?: number | null } }> }> }>, packages: Array<{ __typename?: 'PackageEntity', uuid: string, class?: number | null, description: string, hazmat?: boolean | null, height?: number | null, length?: number | null, nmfc?: string | null, quantity: number, skuNumber?: string | null, type?: PackageType | null, weight?: number | null, width?: number | null, quantityCompletedAtStop?: number | null, reasonUncompletedAtStop?: string | null, packageSpec?: { __typename?: 'PackageSpecEntity', id: string, name: string } | null, warehouseLocation?: { __typename?: 'WarehouseLocationEntity', uuid: string, name: string } | null }>, customCharges: Array<{ __typename?: 'CustomChargeEntity', uuid: string, rate: number, description?: string | null, total: number, totalAmountCents?: number | null, postedAmountUsdCents?: number | null, authoCode?: string | null, quantity: number, billingMethod: CustomChargeBillingMethod, isAutoApplied: boolean, name: string, fuelSurchargeRate?: number | null, postedFuelSurchargeRate?: number | null, zoneBasedAccessorialChargeGroupUuid?: string | null, zoneBasedAccessorialZoneUuid?: string | null, specialAccessorialTariffZoneUuid?: string | null, specialAccessorialChargeGroupUuid?: string | null, settlementFlatRate?: number | null, settlementPercentageRate?: number | null, zoneBasedAccessorialMatrixItem?: { __typename?: 'ZoneBasedAccessorialMatrixItemEntity', uuid: string } | null, specialAccessorialMatrixItem?: { __typename?: 'SpecialAccessorialMatrixItemEntity', uuid: string } | null, accessorialRange?: { __typename?: 'AccessorialRangeEntity', uuid: string, lessThanOrEqualToValue: number, rateUsdCents: number } | null, accessorialTemplate?: { __typename?: 'SkidBasedAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename?: 'SpecialAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename?: 'StandardAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | null }>, freightCharge?: { __typename?: 'FreightChargeEntity', uuid: string, quantity: number, billingMethod: FreightBillingMethod, description?: string | null, authoCode?: string | null, rate: number, settlementFlatRate?: number | null, settlementPercentageRate?: number | null, total: number, fuelCharge?: { __typename?: 'FuelChargeEntity', uuid: string, surchargeRate: number, description?: string | null, authoCode?: string | null, flatRate: number, type: FuelBillingMethod, settlementFlatRate?: number | null, settlementPercentageRate?: number | null } | null, tariff?: { __typename?: 'TariffEntity', uuid: string, billingPartyContactUuid?: string | null, tariffGroup?: { __typename?: 'TariffGroupEntity', name?: string | null, tariffGroupScope?: TariffGroupScope | null } | null, tariffZone: { __typename?: 'TariffZoneEntity', name: string } } | null } | null, inputForConsolidatedOrder?: { __typename?: 'StandardOrderEntity', uuid: string } | null, shipmentCharges: { __typename?: 'ShipmentChargeEntity', totalFuelCharge: number, totalCustomCharge: number, totalFreightCharge: number, totalCharge: number } }>, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', uuid: string, dimFactor?: number | null, shipperBillOfLadingNumber?: string | null, masterAirwayBillOfLadingNumber?: string | null }, tags: Array<{ __typename?: 'TagEntity', uuid: string, value: string, color?: string | null }> } | null, standardShipmentFields: { __typename?: 'StandardShipmentFieldsEntity', uuid: string, pickupOrDelivery: PickupOrDelivery }, legs: Array<{ __typename?: 'LegEntity', uuid: string, endStop: { __typename?: 'StandardStopEntity', completedAt?: any | null, address: { __typename?: 'AddressEntity', name: string, internalNotes?: string | null, iataCode?: string | null } } }> } };

export type ShallowInvoicesQueryVariables = Exact<{
  inConsolidatedInvoice?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  createdAtStartDate?: InputMaybe<Scalars['DateTime']['input']>;
  createdAtEndDate?: InputMaybe<Scalars['DateTime']['input']>;
  invoiceStartDate?: InputMaybe<Scalars['DateTime']['input']>;
  invoiceEndDate?: InputMaybe<Scalars['DateTime']['input']>;
  statuses?: InputMaybe<Array<InvoiceStatus> | InvoiceStatus>;
  searchText?: InputMaybe<Scalars['String']['input']>;
  billingPartyContactUuid?: InputMaybe<Scalars['String']['input']>;
  sortByDueDateAscending?: InputMaybe<Scalars['Boolean']['input']>;
  sortByDueDateDescending?: InputMaybe<Scalars['Boolean']['input']>;
  groupByContact?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type ShallowInvoicesQuery = { __typename?: 'Query', invoices: { __typename?: 'InvoiceConnection', totalCount?: number | null, edges: Array<{ __typename?: 'InvoiceEdge', node: { __typename?: 'InvoiceEntity', uuid: string, qbInvoiceNumber?: number | null, quickbooksInvoiceId?: string | null, lastSyncedToQuickbooksAt?: any | null, name: string, createdAt: any, invoiceTotal: string, status: InvoiceStatus, inConsolidatedInvoice: boolean, dueDate?: any | null, invoiceTerms?: { __typename?: 'InvoiceTermEntity', terms: string } | null, billToContact: { __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string }, firstShipment?: { __typename?: 'StandardShipmentEntity', order?: { __typename?: 'StandardOrderEntity', ediTransactions: Array<{ __typename?: 'EdiTransactionEntity', status: EdiTransactionStatus, code: EdiTransactionCode }> } | null } | null } }>, pageInfo: { __typename?: 'PageInfo', startCursor?: string | null, endCursor?: string | null, hasPreviousPage: boolean, hasNextPage: boolean } } };

export type UnconsolidateOrderMutationVariables = Exact<{
  unconsolidateOrderInput: UnconsolidateOrderInput;
}>;


export type UnconsolidateOrderMutation = { __typename?: 'Mutation', unconsolidateOrder: Array<{ __typename?: 'StandardShipmentEntity', uuid: string, order?: { __typename?: 'StandardOrderEntity', uuid: string } | null }> };

export type UpdateOrderShipperBillOfLadingNumberMutationVariables = Exact<{
  updateStandardOrderInput: UpdateStandardOrderInput;
}>;


export type UpdateOrderShipperBillOfLadingNumberMutation = { __typename?: 'Mutation', updateStandardOrder: { __typename?: 'StandardOrderEntity', uuid: string } };

export type WmsContactsQueryVariables = Exact<{
  companyUuid?: InputMaybe<Scalars['String']['input']>;
}>;


export type WmsContactsQuery = { __typename?: 'Query', wmsContacts: Array<{ __typename?: 'CustomerContactEntity', uuid: string, displayName: string, company: { __typename?: 'CompanyEntity', uuid: string, name: string } } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string, company: { __typename?: 'CompanyEntity', uuid: string, name: string } }> };

export type CreateInvoiceMutationVariables = Exact<{
  createInvoiceInput: CreateInvoiceInput;
}>;


export type CreateInvoiceMutation = { __typename?: 'Mutation', createInvoice: { __typename?: 'InvoiceEntity', uuid: string } };

export type FinalizeInvoicesMutationVariables = Exact<{
  finalizeInvoicesInput: FinalizeInvoicesInput;
}>;


export type FinalizeInvoicesMutation = { __typename?: 'Mutation', finalizeInvoices: { __typename?: 'FinalizeInvoicesOutput', count: number } };

export type DocumentsByInvoiceQueryVariables = Exact<{
  invoiceUuid: Scalars['String']['input'];
}>;


export type DocumentsByInvoiceQuery = { __typename?: 'Query', invoiceDocuments: Array<{ __typename?: 'DocumentEntity', uuid: string, fileName: string, bucket: string, region: string, key: string }> };

export type InvoiceQueryVariables = Exact<{
  uuid: Scalars['String']['input'];
}>;


export type InvoiceQuery = { __typename?: 'Query', invoice?: { __typename?: 'InvoiceEntity', uuid: string, notes?: string | null, name: string, createdAt: any, dueDate?: any | null, status: InvoiceStatus, invoiceTotal: string, lastSyncedToQuickbooksAt?: any | null, quickbooksInvoiceId?: string | null, date: any, inConsolidatedInvoice: boolean, qbInvoiceNumber?: number | null, journalNumber: number, invoiceTerms?: { __typename?: 'InvoiceTermEntity', terms: string, uuid: string } | null, billToContact: { __typename?: 'CustomerContactEntity', uuid: string, displayName: string, defaultAddress?: { __typename?: 'AddressEntity', uuid: string } | null, addresses: Array<{ __typename?: 'AddressEntity', uuid: string }>, contactPersons: Array<{ __typename?: 'ContactPersonEntity', uuid: string }> } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string, defaultAddress?: { __typename?: 'AddressEntity', uuid: string } | null, addresses: Array<{ __typename?: 'AddressEntity', uuid: string }>, contactPersons: Array<{ __typename?: 'ContactPersonEntity', uuid: string }> }, documents: Array<{ __typename?: 'DocumentEntity', uuid: string, fileName: string, bucket: string, region: string, key: string, uploadedAt?: any | null, fileType: string, isDeleted: boolean, preSignedGetUrl: string, name?: string | null, type: DocumentType, pageNumber?: number | null, createdAt: any, notes?: string | null, order?: { __typename?: 'StandardOrderEntity', uuid: string, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', shipperBillOfLadingNumber?: string | null } } | null, shipment?: { __typename?: 'StandardOrderEntity', uuid: string } | null, driverFormTemplate?: { __typename?: 'DriverSignableFormTemplateEntity', uuid: string, title: string, formText: string } | null }>, shipments: Array<{ __typename?: 'StandardShipmentEntity', uuid: string, status: ShipmentStatus, hasSignedPOD: boolean, totalChargesAmount: number, failureCount: number, hasFailedStop: boolean, name: string, overridePackageWeight: boolean, shouldUseDimWeight: boolean, totalCustomChargesAmount: number, totalFuelChargesAmount: number, totalFreightChargesAmount: number, shipmentType: ShipmentType, charges: Array<{ __typename?: 'CustomChargeEntity', uuid: string, name: string, zoneBasedAccessorialZoneUuid?: string | null, zoneBasedAccessorialChargeGroupUuid?: string | null, specialAccessorialTariffZoneUuid?: string | null, specialAccessorialChargeGroupUuid?: string | null, quantity: number, description?: string | null, rate: number, authoCode?: string | null, total: number, customChargeBillingMethod: CustomChargeBillingMethod, accessorialTemplate?: { __typename: 'SkidBasedAccessorialEntity', uuid: string, name: string, percentForSettlement?: number | null } | { __typename: 'SpecialAccessorialEntity', uuid: string, name: string, percentForSettlement?: number | null } | { __typename: 'StandardAccessorialEntity', uuid: string, name: string, percentForSettlement?: number | null } | { __typename: 'UnitBasedAccessorialEntity', uuid: string, name: string, percentForSettlement?: number | null } | { __typename: 'WaitTimeAccessorialEntity', uuid: string, name: string, percentForSettlement?: number | null } | { __typename: 'WeightBasedAccessorialEntity', uuid: string, name: string, percentForSettlement?: number | null } | { __typename: 'ZoneBasedAccessorialEntity', uuid: string, name: string, percentForSettlement?: number | null } | null } | { __typename?: 'FreightChargeEntity', uuid: string, description?: string | null, quantity: number, billingMethod: FreightBillingMethod, rate: number, authoCode?: string | null, tariff?: { __typename?: 'TariffEntity', uuid: string, billingPartyContactUuid?: string | null, tariffOverageRates: Array<{ __typename?: 'TariffOverageRateEntity', uuid: string, name: string, type: TariffOverageRateType, rateUsdCents: number, applicableAboveAmount: number }>, tariffZone: { __typename?: 'TariffZoneEntity', name: string, type: TariffZoneType } } | null, fuelCharge?: { __typename?: 'FuelChargeEntity', description?: string | null, surchargeRate: number, uuid: string, flatRate: number, authoCode?: string | null, type: FuelBillingMethod } | null }>, customCharges: Array<{ __typename?: 'CustomChargeEntity', uuid: string, description?: string | null, name: string, quantity: number, rate: number, zoneBasedAccessorialChargeGroupUuid?: string | null, zoneBasedAccessorialZoneUuid?: string | null, specialAccessorialTariffZoneUuid?: string | null, specialAccessorialChargeGroupUuid?: string | null, customChargeBillingMethod: CustomChargeBillingMethod, accessorialTemplate?: { __typename?: 'SkidBasedAccessorialEntity', uuid: string, name: string, percentForSettlement?: number | null } | { __typename?: 'SpecialAccessorialEntity', uuid: string, name: string, percentForSettlement?: number | null } | { __typename?: 'StandardAccessorialEntity', uuid: string, name: string, percentForSettlement?: number | null } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string, name: string, percentForSettlement?: number | null } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string, name: string, percentForSettlement?: number | null } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string, name: string, percentForSettlement?: number | null } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string, name: string, percentForSettlement?: number | null } | null }>, freightCharge?: { __typename?: 'FreightChargeEntity', uuid: string, billingMethod: FreightBillingMethod, description?: string | null, quantity: number, rate: number, fuelCharge?: { __typename?: 'FuelChargeEntity', description?: string | null, surchargeRate: number, uuid: string, freightCharge: { __typename?: 'FreightChargeEntity', uuid: string } } | null, tariff?: { __typename?: 'TariffEntity', uuid: string, billingPartyContactUuid?: string | null, tariffOverageRates: Array<{ __typename?: 'TariffOverageRateEntity', uuid: string, name: string, type: TariffOverageRateType, rateUsdCents: number, applicableAboveAmount: number }> } | null } | null, legs: Array<{ __typename?: 'LegEntity', uuid: string, miles?: number | null, endStop: { __typename?: 'StandardStopEntity', isSpecial?: boolean | null, uuid: string, arrivedAt?: any | null, completedAt?: any | null, status: StopStatus, appointmentRequired: boolean, proofOfDeliverySignee?: string | null, paperworkMarkedComplete?: boolean | null, address: { __typename?: 'AddressEntity', uuid: string, name: string, line1: string, line2?: string | null, city: string, state: string, zip: string, country: string, latitude?: number | null, longitude?: number | null, driverInstructions?: string | null, receivingHoursStart?: any | null, receivingHoursEnd?: any | null, specialInstructions?: string | null } } }>, order?: { __typename?: 'StandardOrderEntity', uuid: string, secondaryRefNumber?: string | null, orderInvoiceByDate?: any | null, name: string, createdAt: any, refNumbers: Array<string>, totalCharge: number, ediTransactions: Array<{ __typename?: 'EdiTransactionEntity', code: EdiTransactionCode, status: EdiTransactionStatus }>, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', shipperBillOfLadingNumber?: string | null, uuid: string, masterAirwayBillOfLadingNumber?: string | null, weightUnits: WeightUnits }, shipments: Array<{ __typename?: 'StandardShipmentEntity', uuid: string, documents: Array<{ __typename?: 'DocumentEntity', uuid: string, fileName: string, bucket: string, region: string, key: string, uploadedAt?: any | null, fileType: string, isDeleted: boolean, preSignedGetUrl: string, name?: string | null, type: DocumentType, pageNumber?: number | null, createdAt: any, notes?: string | null, order?: { __typename?: 'StandardOrderEntity', uuid: string, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', shipperBillOfLadingNumber?: string | null } } | null, shipment?: { __typename?: 'StandardOrderEntity', uuid: string } | null, driverFormTemplate?: { __typename?: 'DriverSignableFormTemplateEntity', uuid: string, title: string, formText: string } | null }> }>, billingPartyContact: { __typename?: 'CustomerContactEntity', businessDivision?: { __typename?: 'BusinessDivisionEntity', name: string } | null } } | null, packages: Array<{ __typename?: 'PackageEntity', uuid: string, weight?: number | null, description: string, quantity: number, length?: number | null, width?: number | null, height?: number | null, type?: PackageType | null, class?: number | null, hazmat?: boolean | null, nmfc?: string | null, skuNumber?: string | null, quantityCompletedAtStop?: number | null, reasonUncompletedAtStop?: string | null, packageSpec?: { __typename?: 'PackageSpecEntity', id: string, name: string } | null, warehouseLocation?: { __typename?: 'WarehouseLocationEntity', uuid: string, name: string } | null }>, standardShipmentFields: { __typename?: 'StandardShipmentFieldsEntity', uuid: string, deliveryDate?: any | null, pickupOrDelivery: PickupOrDelivery, dimFactor: number, type: StandardShipmentType, shipmentWeight: number, service?: { __typename?: 'ServiceEntity', uuid: string, name: string, createdAt: any, updatedAt: any, timeInMinutes?: number | null, useApptInRouteOptimization: boolean, markOrdersAsSpecial: boolean, defaultAppointmentStartTime?: any | null, defaultAppointmentEndTime?: any | null, defaultStartNow: boolean, defaultInboundStopType?: StopType | null, defaultOutboundStopType?: StopType | null, defaultPickupPadding?: any | null, defaultDeliveryPadding?: any | null, defaultTotalDuration?: any | null, defaultIsLineHaul: boolean, defaultFulfillmentType?: FulfillmentType | null, isActive: boolean, isExposedToCustomers: boolean, serviceAvailabilityDates: Array<{ __typename?: 'ServiceAvailabilityDateEntity', id: string, dayCategory: SpecialDayOfWeek, enabled: boolean, start: { __typename?: 'PlainTime', hour: number, minute: number }, end: { __typename?: 'PlainTime', hour: number, minute: number } }> } | null }, documents: Array<{ __typename?: 'DocumentEntity', uuid: string, fileName: string, bucket: string, region: string, key: string, uploadedAt?: any | null, fileType: string, isDeleted: boolean, preSignedGetUrl: string, name?: string | null, type: DocumentType, pageNumber?: number | null, createdAt: any, notes?: string | null, order?: { __typename?: 'StandardOrderEntity', uuid: string, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', shipperBillOfLadingNumber?: string | null } } | null, shipment?: { __typename?: 'StandardOrderEntity', uuid: string } | null, driverFormTemplate?: { __typename?: 'DriverSignableFormTemplateEntity', uuid: string, title: string, formText: string } | null }> }> } | null };

export type InvoiceShipmentFragmentFragment = { __typename?: 'StandardShipmentEntity', uuid: string, overridePackageWeight: boolean, totalChargesAmount: number, shouldUseDimWeight: boolean, totalCustomChargesAmount: number, totalFuelChargesAmount: number, totalFreightChargesAmount: number, status: ShipmentStatus, name: string, failureCount: number, hasFailedStop: boolean, shipmentType: ShipmentType, standardShipmentFields: { __typename?: 'StandardShipmentFieldsEntity', uuid: string, deliveryDate?: any | null, pickupOrDelivery: PickupOrDelivery, dimFactor: number, type: StandardShipmentType, shipmentWeight: number, service?: { __typename?: 'ServiceEntity', uuid: string, name: string, createdAt: any, updatedAt: any, timeInMinutes?: number | null, useApptInRouteOptimization: boolean, markOrdersAsSpecial: boolean, defaultAppointmentStartTime?: any | null, defaultAppointmentEndTime?: any | null, defaultStartNow: boolean, defaultInboundStopType?: StopType | null, defaultOutboundStopType?: StopType | null, defaultPickupPadding?: any | null, defaultDeliveryPadding?: any | null, defaultTotalDuration?: any | null, defaultIsLineHaul: boolean, defaultFulfillmentType?: FulfillmentType | null, isActive: boolean, isExposedToCustomers: boolean, serviceAvailabilityDates: Array<{ __typename?: 'ServiceAvailabilityDateEntity', id: string, dayCategory: SpecialDayOfWeek, enabled: boolean, start: { __typename?: 'PlainTime', hour: number, minute: number }, end: { __typename?: 'PlainTime', hour: number, minute: number } }> } | null }, documents: Array<{ __typename?: 'DocumentEntity', uuid: string, fileName: string, bucket: string, region: string, key: string, uploadedAt?: any | null, fileType: string, isDeleted: boolean, preSignedGetUrl: string, name?: string | null, type: DocumentType, pageNumber?: number | null, createdAt: any, notes?: string | null, order?: { __typename?: 'StandardOrderEntity', uuid: string, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', shipperBillOfLadingNumber?: string | null } } | null, shipment?: { __typename?: 'StandardOrderEntity', uuid: string } | null, driverFormTemplate?: { __typename?: 'DriverSignableFormTemplateEntity', uuid: string, title: string, formText: string } | null }>, packages: Array<{ __typename?: 'PackageEntity', uuid: string, weight?: number | null, description: string, quantity: number, length?: number | null, width?: number | null, height?: number | null, type?: PackageType | null }>, charges: Array<{ __typename?: 'CustomChargeEntity', uuid: string, name: string, zoneBasedAccessorialZoneUuid?: string | null, zoneBasedAccessorialChargeGroupUuid?: string | null, specialAccessorialTariffZoneUuid?: string | null, specialAccessorialChargeGroupUuid?: string | null, quantity: number, description?: string | null, authoCode?: string | null, rate: number, total: number, customChargeBillingMethod: CustomChargeBillingMethod, accessorialTemplate?: { __typename: 'SkidBasedAccessorialEntity', uuid: string, name: string } | { __typename: 'SpecialAccessorialEntity', uuid: string, name: string } | { __typename: 'StandardAccessorialEntity', uuid: string, name: string } | { __typename: 'UnitBasedAccessorialEntity', uuid: string, name: string } | { __typename: 'WaitTimeAccessorialEntity', uuid: string, name: string } | { __typename: 'WeightBasedAccessorialEntity', uuid: string, name: string } | { __typename: 'ZoneBasedAccessorialEntity', uuid: string, name: string } | null } | { __typename?: 'FreightChargeEntity', uuid: string, billingMethod: FreightBillingMethod, rate: number, description?: string | null, authoCode?: string | null, quantity: number, tariff?: { __typename?: 'TariffEntity', uuid: string, billingPartyContactUuid?: string | null, tariffOverageRates: Array<{ __typename?: 'TariffOverageRateEntity', uuid: string, name: string, type: TariffOverageRateType, rateUsdCents: number, applicableAboveAmount: number }>, tariffZone: { __typename?: 'TariffZoneEntity', name: string, type: TariffZoneType } } | null, fuelCharge?: { __typename?: 'FuelChargeEntity', description?: string | null, surchargeRate: number, uuid: string, flatRate: number, authoCode?: string | null, type: FuelBillingMethod } | null }>, legs: Array<{ __typename?: 'LegEntity', uuid: string, miles?: number | null, endStop: { __typename?: 'StandardStopEntity', uuid: string, arrivedAt?: any | null, completedAt?: any | null, appointmentRequired: boolean, status: StopStatus, proofOfDeliverySignee?: string | null, paperworkMarkedComplete?: boolean | null, address: { __typename?: 'AddressEntity', name: string, uuid: string, line1: string, line2?: string | null, zip: string, city: string, state: string } } }>, order?: { __typename?: 'StandardOrderEntity', uuid: string, createdAt: any, name: string, refNumbers: Array<string>, totalCharge: number, secondaryRefNumber?: string | null, billingPartyContact: { __typename?: 'CustomerContactEntity', businessDivision?: { __typename?: 'BusinessDivisionEntity', name: string } | null }, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', uuid: string, shipperBillOfLadingNumber?: string | null, masterAirwayBillOfLadingNumber?: string | null, weightUnits: WeightUnits } } | null };

export type UpdateInvoiceLimitedMutationVariables = Exact<{
  updateInvoiceLimitedInput: InvoiceUpdateLimitedInput;
}>;


export type UpdateInvoiceLimitedMutation = { __typename?: 'Mutation', updateInvoiceLimited: { __typename?: 'InvoiceEntity', uuid: string } };

export type AddOrdersToInvoicesMutationVariables = Exact<{
  input: AddOrdersToInvoicesInput;
}>;


export type AddOrdersToInvoicesMutation = { __typename?: 'Mutation', addOrdersToInvoices: { __typename: 'AddOrdersToInvoicesSuccessOutput', success: boolean, invoicesAddedToByContact: Array<{ __typename: 'AddOrdersToInvoicesForContactErrorOutput', success: boolean, contactName: string, contactUuid: string, proposedUpdatesToExistingInvoices: Array<{ __typename?: 'ExistingInvoiceToUpdate', name: string, invoiceUuid: string, ordersToAdd: Array<{ __typename?: 'OrderToAddToInvoice', orderUuid: string, orderName: string, shipmentUuids: Array<string> }> }>, proposedNewInvoicesToCreate: Array<{ __typename?: 'NewInvoiceToCreate', name?: string | null, ordersToAdd: Array<{ __typename?: 'OrderToAddToInvoice', orderUuid: string, orderName: string, shipmentUuids: Array<string> }> }> } | { __typename: 'AddOrdersToInvoicesForContactSuccessOutput', success: boolean, contactName: string, contactUuid: string, existingInvoiceAdds: Array<{ __typename: 'AddOrdersToExistingInvoiceErrorOutput', success: boolean, invoiceName: string, invoiceUuid: string, attemptedOrdersToAdd: Array<{ __typename?: 'OrderToAddToInvoice', orderUuid: string, orderName: string, shipmentUuids: Array<string> }> } | { __typename: 'AddOrdersToInvoiceSuccessOutput', success: boolean, invoiceName: string, invoiceUuid: string, ordersAdded: Array<{ __typename?: 'OrderAddedToInvoice', orderUuid: string, orderName: string }> }>, newInvoiceAdds: Array<{ __typename: 'AddOrdersToInvoiceSuccessOutput', success: boolean, invoiceName: string, invoiceUuid: string, ordersAdded: Array<{ __typename?: 'OrderAddedToInvoice', orderUuid: string, orderName: string }> } | { __typename: 'AddOrdersToNewInvoiceErrorOutput', success: boolean, createdInvoiceName?: string | null, attemptedOrdersToAdd: Array<{ __typename?: 'OrderToAddToInvoice', orderUuid: string, orderName: string, shipmentUuids: Array<string> }> }> }> } | { __typename: 'MutationErrorOutput', message: string } };

export type PreviewAddOrdersToInvoicesQueryVariables = Exact<{
  previewAddOrdersToInvoicesInput: PreviewAddOrdersToInvoicesInput;
}>;


export type PreviewAddOrdersToInvoicesQuery = { __typename?: 'Query', previewAddOrdersToInvoices: { __typename?: 'PreviewAddOrdersToInvoicesOutput', invoicesToAddToByContact: Array<{ __typename?: 'PreviewAddOrdersToInvoicesForContactOutput', contactUuid: string, contactName: string, existingInvoicesToUpdate: Array<{ __typename?: 'ExistingInvoiceToUpdate', name: string, invoiceUuid: string, ordersToAdd: Array<{ __typename?: 'OrderToAddToInvoice', orderUuid: string, orderName: string, shipmentUuids: Array<string> }> }>, newInvoicesToCreate: Array<{ __typename?: 'NewInvoiceToCreate', name?: string | null, ordersToAdd: Array<{ __typename?: 'OrderToAddToInvoice', orderUuid: string, orderName: string, shipmentUuids: Array<string> }> }> }> } };

export type ContactsForDunningQueryQueryVariables = Exact<{
  uuids: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type ContactsForDunningQueryQuery = { __typename?: 'Query', contactsByUuids: Array<{ __typename?: 'CustomerContactEntity', defaultUseTariff?: boolean | null, defaultInvoiceTransmissionMethod: InvoiceTransmissionMethod, defaultInvoiceType: InvoiceType, defaultInvoiceDownloadDocuments: Array<DocumentType>, defaultInvoiceDocumentsRequired: Array<DocumentType>, defaultDimFactor?: number | null, defaultFuelSurcharge?: number | null, numberOfOrdersPerInvoice?: number | null, invoiceTimePeriodSplit?: TimePeriod | null, isPrepaidOnly: boolean, useCustomVehicleTypes: boolean, useCustomPackageSpecs: boolean, displayName: string, type: ContactType, isActive: boolean, shortCode?: string | null, uuid: string, contactReferenceNumber?: string | null, quickbooksMappingId?: string | null, quickbooksDesktopContactId?: string | null, quickbooksFileMappingFreightChargeName?: string | null, quickbooksFileMappingCustomerName?: string | null, quickbooksFileMappingFuelChargeName?: string | null, quickbooksFileMappingPickupChargeName?: string | null, quickbooksDesktopAccountsReceivableId?: string | null, freightChargeQuickbooksMappingId?: string | null, fuelChargeQuickbooksMappingId?: string | null, miscCustomChargeQuickbooksMappingId?: string | null, stediPartnerId?: string | null, billingCycleDuration: BillingCycleDuration, billingContactEmail?: string | null, isEfm?: boolean | null, showEdiReferenceNumbersOnOrderPage: boolean, defaultAddress?: { __typename?: 'AddressEntity', name: string, line1: string, line2?: string | null, city: string, state: string, zip: string, country: string, uuid: string, latitude?: number | null, longitude?: number | null } | null, overdueInvoices: Array<{ __typename?: 'InvoiceEntity', uuid: string, name: string, dueDate?: any | null, date: any, createdAt: any, journalNumber: number, invoiceTotal: string, balanceInCents: number, orders: Array<{ __typename?: 'StandardOrderEntity', uuid: string, name: string, refNumbers: Array<string>, totalCharge: number, balanceInCents: number, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', shipperBillOfLadingNumber?: string | null, masterAirwayBillOfLadingNumber?: string | null }, endStop?: { __typename?: 'StandardStopEntity', serviceDate?: any | null } | null, startStop?: { __typename?: 'StandardStopEntity', serviceDate?: any | null } | null }> }>, company: { __typename?: 'CompanyEntity', customDunningReportHeader?: string | null, customDunningReportFooter?: string | null }, vehicleTypes: Array<{ __typename?: 'VehicleTypeEntity', uuid: string, name: string, status: VehicleTypeStatus }>, packageSpecs: Array<{ __typename?: 'PackageSpecEntity', id: string, name: string, status: PackageSpecStatus, weight?: any | null, length?: any | null, width?: any | null, height?: any | null }>, services: Array<{ __typename?: 'ServiceEntity', uuid: string, name: string, markOrdersAsSpecial: boolean, defaultAppointmentStartTime?: any | null, defaultAppointmentEndTime?: any | null }>, defaultService?: { __typename?: 'ServiceEntity', uuid: string, name: string } | null, referenceNumberLabels: Array<{ __typename?: 'ReferenceNumberLabelEntity', name: string }>, contactStations: Array<{ __typename?: 'ContactStationEntity', id: string, name: string, isArchived: boolean, defaultPerson?: { __typename?: 'PersonEntity', id: string, firstName: string, lastName: string, phone?: string | null, email?: string | null } | null }> } | { __typename?: 'ThirdPartyContactEntity', displayName: string, type: ContactType, isActive: boolean, shortCode?: string | null, uuid: string, contactReferenceNumber?: string | null, quickbooksMappingId?: string | null, quickbooksDesktopContactId?: string | null, quickbooksFileMappingFreightChargeName?: string | null, quickbooksFileMappingCustomerName?: string | null, quickbooksFileMappingFuelChargeName?: string | null, quickbooksFileMappingPickupChargeName?: string | null, quickbooksDesktopAccountsReceivableId?: string | null, freightChargeQuickbooksMappingId?: string | null, fuelChargeQuickbooksMappingId?: string | null, miscCustomChargeQuickbooksMappingId?: string | null, stediPartnerId?: string | null, billingCycleDuration: BillingCycleDuration, billingContactEmail?: string | null, isEfm?: boolean | null, showEdiReferenceNumbersOnOrderPage: boolean, defaultAddress?: { __typename?: 'AddressEntity', name: string, line1: string, line2?: string | null, city: string, state: string, zip: string, country: string, uuid: string, latitude?: number | null, longitude?: number | null } | null, overdueInvoices: Array<{ __typename?: 'InvoiceEntity', uuid: string, name: string, dueDate?: any | null, date: any, createdAt: any, journalNumber: number, invoiceTotal: string, balanceInCents: number, orders: Array<{ __typename?: 'StandardOrderEntity', uuid: string, name: string, refNumbers: Array<string>, totalCharge: number, balanceInCents: number, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', shipperBillOfLadingNumber?: string | null, masterAirwayBillOfLadingNumber?: string | null }, endStop?: { __typename?: 'StandardStopEntity', serviceDate?: any | null } | null, startStop?: { __typename?: 'StandardStopEntity', serviceDate?: any | null } | null }> }>, company: { __typename?: 'CompanyEntity', customDunningReportHeader?: string | null, customDunningReportFooter?: string | null }, services: Array<{ __typename?: 'ServiceEntity', uuid: string, name: string, markOrdersAsSpecial: boolean, defaultAppointmentStartTime?: any | null, defaultAppointmentEndTime?: any | null }>, defaultService?: { __typename?: 'ServiceEntity', uuid: string, name: string } | null, referenceNumberLabels: Array<{ __typename?: 'ReferenceNumberLabelEntity', name: string }>, contactStations: Array<{ __typename?: 'ContactStationEntity', id: string, name: string, isArchived: boolean, defaultPerson?: { __typename?: 'PersonEntity', id: string, firstName: string, lastName: string, phone?: string | null, email?: string | null } | null }> }> };

export type DunningReportPdfQueryVariables = Exact<{
  dunningReportInput: DunningReportInput;
}>;


export type DunningReportPdfQuery = { __typename?: 'Query', dunningReportPdf: { __typename?: 'ReportPdfOutput', url?: string | null, fileName?: string | null, errors?: Array<string> | null } };

export type GlCodeReportPdfQueryVariables = Exact<{
  glCodeReportPdfInput: GlCodeReportPdfInput;
}>;


export type GlCodeReportPdfQuery = { __typename?: 'Query', glCodeReportPdf: { __typename?: 'ReportPdfOutput', url?: string | null, fileName?: string | null, errors?: Array<string> | null } };

export type InvoiceEdiTransactionFragment = { __typename?: 'EdiTransactionEntity', createdAt: any, status: EdiTransactionStatus, order?: { __typename?: 'StandardOrderEntity', name: string, secondaryRefNumber?: string | null, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', shipperBillOfLadingNumber?: string | null } } | null };

export type InvoiceEdiTransactionsQueryVariables = Exact<{
  findInvoiceEdiTransactionsInput: FindInvoiceEdiTransactionsInput;
}>;


export type InvoiceEdiTransactionsQuery = { __typename?: 'Query', invoiceEdiTransactions: { __typename?: 'FindInvoiceEdiTransactionsOutput', ediTransactionConnection: { __typename?: 'EdiTransactionConnection', totalCount?: number | null, edges: Array<{ __typename?: 'EdiTransactionEdge', node: { __typename?: 'EdiTransactionEntity', createdAt: any, status: EdiTransactionStatus, order?: { __typename?: 'StandardOrderEntity', name: string, secondaryRefNumber?: string | null, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', shipperBillOfLadingNumber?: string | null } } | null } }>, pageInfo: { __typename?: 'PageInfo', startCursor?: string | null, endCursor?: string | null, hasNextPage: boolean, hasPreviousPage: boolean } } } };

export type InvoiceEmailSendStatusQueryVariables = Exact<{
  uuids: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type InvoiceEmailSendStatusQuery = { __typename?: 'Query', invoicesByUuids: Array<{ __typename?: 'InvoiceEntity', uuid: string, emailSendStatus: EmailSendStatus }> };

export type InvoiceForDunningReportFragment = { __typename?: 'InvoiceEntity', uuid: string, name: string, dueDate?: any | null, date: any, createdAt: any, journalNumber: number, invoiceTotal: string, balanceInCents: number, orders: Array<{ __typename?: 'StandardOrderEntity', uuid: string, name: string, refNumbers: Array<string>, totalCharge: number, balanceInCents: number, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', shipperBillOfLadingNumber?: string | null, masterAirwayBillOfLadingNumber?: string | null }, endStop?: { __typename?: 'StandardStopEntity', serviceDate?: any | null } | null, startStop?: { __typename?: 'StandardStopEntity', serviceDate?: any | null } | null }> };

export type InvoiceRegisterReportCsvQueryVariables = Exact<{
  invoiceRegisterReportInput: InvoiceRegisterReportInput;
}>;


export type InvoiceRegisterReportCsvQuery = { __typename?: 'Query', invoiceRegisterReportCsv: { __typename?: 'ReportFileOutput', url?: string | null, fileName?: string | null, errors?: Array<string> | null } };

export type InvoiceRegisterReportPdfQueryVariables = Exact<{
  invoiceRegisterReportInput: InvoiceRegisterReportInput;
}>;


export type InvoiceRegisterReportPdfQuery = { __typename?: 'Query', invoiceRegisterReportPdf: { __typename?: 'ReportPdfOutput', url?: string | null, fileName?: string | null, errors?: Array<string> | null } };

export type OnTimePerformanceReportCsvQueryVariables = Exact<{
  input: OnTimePerformanceReportInput;
}>;


export type OnTimePerformanceReportCsvQuery = { __typename?: 'Query', onTimePerformanceReportCsv: { __typename: 'ReportFileOutput', url?: string | null, fileName?: string | null, errors?: Array<string> | null } };

export type OnTimePerformanceReportPdfQueryVariables = Exact<{
  input: OnTimePerformanceReportInput;
}>;


export type OnTimePerformanceReportPdfQuery = { __typename?: 'Query', onTimePerformanceReportPdf: { __typename: 'ReportFileOutput', url?: string | null, fileName?: string | null, errors?: Array<string> | null } };

export type SageBusinessWorksInvoiceExportCsvQueryVariables = Exact<{
  invoiceUuids: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type SageBusinessWorksInvoiceExportCsvQuery = { __typename?: 'Query', sageBusinessWorksInvoiceExportCsv: { __typename?: 'ReportFileOutput', url?: string | null, fileName?: string | null, errors?: Array<string> | null } };

export type InvoiceShipmentWithChargesByUuidQueryVariables = Exact<{
  uuid: Scalars['String']['input'];
}>;


export type InvoiceShipmentWithChargesByUuidQuery = { __typename?: 'Query', shipment: { __typename?: 'StandardShipmentEntity', uuid: string, overridePackageWeight: boolean, shipmentType: ShipmentType, status: ShipmentStatus, name: string, shipmentCharges: { __typename?: 'ShipmentChargeEntity', totalFreightCharge: number, totalFuelCharge: number, totalCharge: number }, shipperAddress?: { __typename?: 'AddressEntity', uuid: string, name: string, line1: string, line2?: string | null, city: string, state: string, zip: string, country: string, latitude?: number | null, longitude?: number | null, driverInstructions?: string | null, receivingHoursStart?: any | null, receivingHoursEnd?: any | null, specialInstructions?: string | null } | null, standardShipmentFields: { __typename?: 'StandardShipmentFieldsEntity', pickupOrDelivery: PickupOrDelivery }, legs: Array<{ __typename?: 'LegEntity', uuid: string, endStop: { __typename?: 'StandardStopEntity', completedAt?: any | null, paperworkMarkedComplete?: boolean | null, settlementDeductionName?: string | null, settlementDeductionFlatRate?: number | null, settlementDeductionPercentageRate?: number | null, stopType?: StopType | null, address: { __typename?: 'AddressEntity', uuid: string, name: string, line1: string, line2?: string | null, city: string, state: string, zip: string, country: string, latitude?: number | null, longitude?: number | null, driverInstructions?: string | null, receivingHoursStart?: any | null, receivingHoursEnd?: any | null, specialInstructions?: string | null } } }>, invoice?: { __typename?: 'InvoiceEntity', uuid: string } | null, charges: Array<{ __typename?: 'CustomChargeEntity', uuid: string, name: string, quantity: number, description?: string | null, rate: number, total: number, settlementFlatRate?: number | null, settlementPercentageRate?: number | null, postedFuelSurchargeRate?: number | null, customChargeBillingMethod: CustomChargeBillingMethod, accessorialTemplate?: { __typename: 'SkidBasedAccessorialEntity', uuid: string, name: string, invoiceDisplayName?: string | null } | { __typename: 'SpecialAccessorialEntity', uuid: string, name: string, invoiceDisplayName?: string | null } | { __typename: 'StandardAccessorialEntity', uuid: string, name: string, invoiceDisplayName?: string | null } | { __typename: 'UnitBasedAccessorialEntity', uuid: string, name: string, invoiceDisplayName?: string | null } | { __typename: 'WaitTimeAccessorialEntity', uuid: string, name: string, invoiceDisplayName?: string | null } | { __typename: 'WeightBasedAccessorialEntity', uuid: string, name: string, invoiceDisplayName?: string | null } | { __typename: 'ZoneBasedAccessorialEntity', uuid: string, name: string, invoiceDisplayName?: string | null } | null } | { __typename?: 'FreightChargeEntity', uuid: string, billingMethod: FreightBillingMethod, rate: number, description?: string | null, quantity: number, settlementFlatRate?: number | null, settlementPercentageRate?: number | null, tariff?: { __typename?: 'TariffEntity', uuid: string, tariffZone: { __typename?: 'TariffZoneEntity', name: string, type: TariffZoneType } } | null, fuelCharge?: { __typename?: 'FuelChargeEntity', surchargeRate: number, flatRate: number, type: FuelBillingMethod, uuid: string, settlementFlatRate?: number | null, settlementPercentageRate?: number | null } | null }> } };

export type OverdueInvoicesQueryVariables = Exact<{
  contactUuid: Scalars['String']['input'];
}>;


export type OverdueInvoicesQuery = { __typename?: 'Query', overdueInvoices: Array<{ __typename?: 'InvoiceEntity', name: string, dueDate?: any | null, date: any, journalNumber: number, totalNumber: number, balanceInCents: number }> };

export type ShipmentsByContactUuidQueryVariables = Exact<{
  contactUuid?: InputMaybe<Scalars['String']['input']>;
  startCompletedDate?: InputMaybe<Scalars['DateTime']['input']>;
  endCompletedDate?: InputMaybe<Scalars['DateTime']['input']>;
}>;


export type ShipmentsByContactUuidQuery = { __typename?: 'Query', shipmentsByContactUuid?: Array<{ __typename?: 'StandardShipmentEntity', uuid: string }> | null };

export type BatchAddShipmentsToInvoicesMultipleMutationVariables = Exact<{
  batchAddShipmentsToInvoicesInputMultiple: BatchAddShipmentsToInvoicesInputMultiple;
}>;


export type BatchAddShipmentsToInvoicesMultipleMutation = { __typename?: 'Mutation', batchAddShipmentsToInvoicesMultiple: Array<{ __typename?: 'InvoiceEntity', uuid: string, name: string, journalNumber: number, billToContact: { __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string }, shipments: Array<{ __typename?: 'StandardShipmentEntity', uuid: string, legs: Array<{ __typename?: 'LegEntity', endStop: { __typename?: 'StandardStopEntity', stopType?: StopType | null } }>, order?: { __typename?: 'StandardOrderEntity', standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', shipperBillOfLadingNumber?: string | null } } | null }> }> };

export type BatchAddShipmentsToInvoicesPreviewFragment = { __typename?: 'BatchAddShipmentsToInvoicePreview', contactName: string, contactUuid: string, billingCycleDuration: BillingCycleDuration, existingInvoiceAdds: Array<{ __typename?: 'InvoiceAdd', uuid?: string | null, name?: string | null, shipmentUuids: Array<string> }>, newInvoiceAdds: Array<{ __typename?: 'InvoiceAdd', name?: string | null, shipmentUuids: Array<string> }> };

export type BatchAddShipmentsToInvoicesResultInvoiceFragment = { __typename?: 'InvoiceEntity', uuid: string, name: string, journalNumber: number, billToContact: { __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string }, shipments: Array<{ __typename?: 'StandardShipmentEntity', uuid: string, legs: Array<{ __typename?: 'LegEntity', endStop: { __typename?: 'StandardStopEntity', stopType?: StopType | null } }>, order?: { __typename?: 'StandardOrderEntity', standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', shipperBillOfLadingNumber?: string | null } } | null }> };

export type CheckConsistencyOfInvoicesQueryVariables = Exact<{
  checkConsistencyOfInvoicesInput: CheckConsistencyOfInvoicesInput;
}>;


export type CheckConsistencyOfInvoicesQuery = { __typename?: 'Query', checkConsistencyOfInvoices: Array<boolean> };

export type CreateProratedConsolidatedOrderMutationVariables = Exact<{
  input: CreateProratedConsolidatedOrderInput;
}>;


export type CreateProratedConsolidatedOrderMutation = { __typename?: 'Mutation', createProratedConsolidatedOrder: { __typename?: 'CreateProratedConsolidatedOrderOutput', consolidatedOrderUuid?: string | null, errorMessage?: string | null, orders: Array<{ __typename?: 'StandardOrderEntity', uuid: string }> } };

export type OrderForConsolidationFlowFragment = { __typename?: 'StandardOrderEntity', uuid: string, weight: number, dimWeight: number, name: string, status: OrderStatus, pieceCountFromPackages: number, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', shipperBillOfLadingNumber?: string | null }, billingPartyContact: { __typename?: 'CustomerContactEntity', uuid: string, displayName: string }, inboundShipment?: { __typename?: 'StandardShipmentEntity', uuid: string, legs: Array<{ __typename?: 'LegEntity', endStop: { __typename?: 'StandardStopEntity', address: { __typename?: 'AddressEntity', name: string, line1: string } } }>, freightCharge?: { __typename?: 'FreightChargeEntity', uuid: string } | null } | null, outboundShipment?: { __typename?: 'StandardShipmentEntity', uuid: string, legs: Array<{ __typename?: 'LegEntity', endStop: { __typename?: 'StandardStopEntity', address: { __typename?: 'AddressEntity', name: string, line1: string } } }>, freightCharge?: { __typename?: 'FreightChargeEntity', uuid: string } | null } | null, lineHaulLane?: { __typename?: 'LineHaulLaneEntity', name: string } | null };

export type OrderInConsolidationFlowQueryVariables = Exact<{
  uuid: Scalars['String']['input'];
}>;


export type OrderInConsolidationFlowQuery = { __typename?: 'Query', standardOrder: { __typename?: 'StandardOrderEntity', uuid: string, weight: number, dimWeight: number, name: string, status: OrderStatus, pieceCountFromPackages: number, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', shipperBillOfLadingNumber?: string | null }, billingPartyContact: { __typename?: 'CustomerContactEntity', uuid: string, displayName: string }, inboundShipment?: { __typename?: 'StandardShipmentEntity', uuid: string, legs: Array<{ __typename?: 'LegEntity', endStop: { __typename?: 'StandardStopEntity', address: { __typename?: 'AddressEntity', name: string, line1: string } } }>, freightCharge?: { __typename?: 'FreightChargeEntity', uuid: string } | null } | null, outboundShipment?: { __typename?: 'StandardShipmentEntity', uuid: string, legs: Array<{ __typename?: 'LegEntity', endStop: { __typename?: 'StandardStopEntity', address: { __typename?: 'AddressEntity', name: string, line1: string } } }>, freightCharge?: { __typename?: 'FreightChargeEntity', uuid: string } | null } | null, lineHaulLane?: { __typename?: 'LineHaulLaneEntity', name: string } | null } };

export type PreviewProratedConsolidationV2QueryVariables = Exact<{
  previewProratedConsolidationV2Input: PreviewProratedConsolidationV2Input;
}>;


export type PreviewProratedConsolidationV2Query = { __typename?: 'Query', previewProratedConsolidationV2: { __typename: 'PreviewProratedConsolidationV2SuccessOutput', totalAfterProrating: number, consolidationMethod: OrderConsolidationMethod, totalWeightConsolidated: number, proratedOrders: Array<{ __typename?: 'ProratedOrder', uuid: string, name: string, hawb?: string | null, proportionForConsolidation?: number | null, proportionOfTotalWeight: number, weight: number, totalAfterProrating: number, lineHaulInitialTotal?: number | null, orderChargesInitialTotal?: number | null, inboundShipment?: { __typename?: 'ProratedShipment', initialFreightChargeTotal?: number | null, proratedFreightChargeTotal?: number | null, initialFuelChargeTotal?: number | null, proratedFuelChargeTotal?: number | null, customCharges: Array<{ __typename?: 'ProratedCustomChargeV2', initialTotal?: number | null, proratedTotal: number, name: string }> } | null, outboundShipment?: { __typename?: 'ProratedShipment', initialFreightChargeTotal?: number | null, proratedFreightChargeTotal?: number | null, initialFuelChargeTotal?: number | null, proratedFuelChargeTotal?: number | null, customCharges: Array<{ __typename?: 'ProratedCustomChargeV2', initialTotal?: number | null, proratedTotal: number, name: string }> } | null }>, proratedOverview: { __typename?: 'ProratedOverview', inboundFreightCharge?: { __typename?: 'SimpleFreightCharge', billingMethod: FreightBillingMethod, rate: string, quantity: number, amount: number } | null, outboundFreightCharge?: { __typename?: 'SimpleFreightCharge', billingMethod: FreightBillingMethod, rate: string, quantity: number, amount: number } | null, inboundFuelCharge?: { __typename?: 'SimpleFuelCharge', billingMethod: FuelBillingMethod, quantity: number, amount: number } | null, outboundFuelCharge?: { __typename?: 'SimpleFuelCharge', billingMethod: FuelBillingMethod, quantity: number, amount: number } | null, customCharges?: Array<{ __typename?: 'SimpleCustomCharge', name: string, amount: number }> | null } } | { __typename: 'QueryErrorOutput', message: string } };

export type ProratedOrderV2Fragment = { __typename?: 'ProratedOrder', uuid: string, name: string, hawb?: string | null, proportionForConsolidation?: number | null, proportionOfTotalWeight: number, weight: number, totalAfterProrating: number, lineHaulInitialTotal?: number | null, orderChargesInitialTotal?: number | null, inboundShipment?: { __typename?: 'ProratedShipment', initialFreightChargeTotal?: number | null, proratedFreightChargeTotal?: number | null, initialFuelChargeTotal?: number | null, proratedFuelChargeTotal?: number | null, customCharges: Array<{ __typename?: 'ProratedCustomChargeV2', initialTotal?: number | null, proratedTotal: number, name: string }> } | null, outboundShipment?: { __typename?: 'ProratedShipment', initialFreightChargeTotal?: number | null, proratedFreightChargeTotal?: number | null, initialFuelChargeTotal?: number | null, proratedFuelChargeTotal?: number | null, customCharges: Array<{ __typename?: 'ProratedCustomChargeV2', initialTotal?: number | null, proratedTotal: number, name: string }> } | null };

export type ProratedShipmentV2Fragment = { __typename?: 'ProratedShipment', initialFreightChargeTotal?: number | null, proratedFreightChargeTotal?: number | null, initialFuelChargeTotal?: number | null, proratedFuelChargeTotal?: number | null, customCharges: Array<{ __typename?: 'ProratedCustomChargeV2', initialTotal?: number | null, proratedTotal: number, name: string }> };

export type SimpleFreightChargeFragment = { __typename?: 'SimpleFreightCharge', billingMethod: FreightBillingMethod, rate: string, quantity: number, amount: number };

export type SimpleFuelChargeFragment = { __typename?: 'SimpleFuelCharge', billingMethod: FuelBillingMethod, quantity: number, amount: number };

export type SimpleCustomChargeFragment = { __typename?: 'SimpleCustomCharge', name: string, amount: number };

export type PreviewProratedConsolidationQueryVariables = Exact<{
  previewProratedConsolidationInput: PreviewProratedConsolidationInput;
}>;


export type PreviewProratedConsolidationQuery = { __typename?: 'Query', previewProratedConsolidation: { __typename?: 'PreviewProratedConsolidationOutput', proratedOrders: Array<{ __typename?: 'ProratedOrderInformation', order: { __typename?: 'StandardOrderEntity', uuid: string, name: string, totalCharge: number, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', shipperBillOfLadingNumber?: string | null }, inboundShipment?: { __typename?: 'StandardShipmentEntity', totalChargesAmount: number } | null, outboundShipment?: { __typename?: 'StandardShipmentEntity', totalChargesAmount: number } | null, lineHaulShipment?: { __typename?: 'StandardShipmentEntity', totalChargesAmount: number } | null, orderChargesShipment?: { __typename?: 'StandardShipmentEntity', totalChargesAmount: number } | null }, inboundShipment?: { __typename?: 'ProratedShipmentInformation', freightAndFuelProrateMultiplier: number, shipment: { __typename?: 'StandardShipmentEntity', uuid: string }, initialFreightCharge?: { __typename?: 'FreightChargeForProrating', totalCents: number } | null, initialFuelCharge?: { __typename?: 'FuelChargeForProrating', totalCents: number } | null, proratedFreightCharge?: { __typename?: 'FreightChargeForProrating', totalCents: number } | null, proratedFuelCharge?: { __typename?: 'FuelChargeForProrating', totalCents: number } | null, customCharges: Array<{ __typename?: 'ProratedCustomCharge', initialOrderUuidsPresentIn: Array<string>, initialTotalCents?: number | null, proratedTotalCents: number, name: string }> } | null, outboundShipment?: { __typename?: 'ProratedShipmentInformation', freightAndFuelProrateMultiplier: number, shipment: { __typename?: 'StandardShipmentEntity', uuid: string }, initialFreightCharge?: { __typename?: 'FreightChargeForProrating', totalCents: number } | null, initialFuelCharge?: { __typename?: 'FuelChargeForProrating', totalCents: number } | null, proratedFreightCharge?: { __typename?: 'FreightChargeForProrating', totalCents: number } | null, proratedFuelCharge?: { __typename?: 'FuelChargeForProrating', totalCents: number } | null, customCharges: Array<{ __typename?: 'ProratedCustomCharge', initialOrderUuidsPresentIn: Array<string>, initialTotalCents?: number | null, proratedTotalCents: number, name: string }> } | null }> } };

export type ProratedOrderFragment = { __typename?: 'ProratedOrderInformation', order: { __typename?: 'StandardOrderEntity', uuid: string, name: string, totalCharge: number, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', shipperBillOfLadingNumber?: string | null }, inboundShipment?: { __typename?: 'StandardShipmentEntity', totalChargesAmount: number } | null, outboundShipment?: { __typename?: 'StandardShipmentEntity', totalChargesAmount: number } | null, lineHaulShipment?: { __typename?: 'StandardShipmentEntity', totalChargesAmount: number } | null, orderChargesShipment?: { __typename?: 'StandardShipmentEntity', totalChargesAmount: number } | null }, inboundShipment?: { __typename?: 'ProratedShipmentInformation', freightAndFuelProrateMultiplier: number, shipment: { __typename?: 'StandardShipmentEntity', uuid: string }, initialFreightCharge?: { __typename?: 'FreightChargeForProrating', totalCents: number } | null, initialFuelCharge?: { __typename?: 'FuelChargeForProrating', totalCents: number } | null, proratedFreightCharge?: { __typename?: 'FreightChargeForProrating', totalCents: number } | null, proratedFuelCharge?: { __typename?: 'FuelChargeForProrating', totalCents: number } | null, customCharges: Array<{ __typename?: 'ProratedCustomCharge', initialOrderUuidsPresentIn: Array<string>, initialTotalCents?: number | null, proratedTotalCents: number, name: string }> } | null, outboundShipment?: { __typename?: 'ProratedShipmentInformation', freightAndFuelProrateMultiplier: number, shipment: { __typename?: 'StandardShipmentEntity', uuid: string }, initialFreightCharge?: { __typename?: 'FreightChargeForProrating', totalCents: number } | null, initialFuelCharge?: { __typename?: 'FuelChargeForProrating', totalCents: number } | null, proratedFreightCharge?: { __typename?: 'FreightChargeForProrating', totalCents: number } | null, proratedFuelCharge?: { __typename?: 'FuelChargeForProrating', totalCents: number } | null, customCharges: Array<{ __typename?: 'ProratedCustomCharge', initialOrderUuidsPresentIn: Array<string>, initialTotalCents?: number | null, proratedTotalCents: number, name: string }> } | null };

export type ProratedShipmentFragment = { __typename?: 'ProratedShipmentInformation', freightAndFuelProrateMultiplier: number, shipment: { __typename?: 'StandardShipmentEntity', uuid: string }, initialFreightCharge?: { __typename?: 'FreightChargeForProrating', totalCents: number } | null, initialFuelCharge?: { __typename?: 'FuelChargeForProrating', totalCents: number } | null, proratedFreightCharge?: { __typename?: 'FreightChargeForProrating', totalCents: number } | null, proratedFuelCharge?: { __typename?: 'FuelChargeForProrating', totalCents: number } | null, customCharges: Array<{ __typename?: 'ProratedCustomCharge', initialOrderUuidsPresentIn: Array<string>, initialTotalCents?: number | null, proratedTotalCents: number, name: string }> };

export type ProrateOrdersMutationVariables = Exact<{
  input: ProrateOrdersInput;
}>;


export type ProrateOrdersMutation = { __typename?: 'Mutation', prorateOrders: { __typename: 'MutationErrorOutput', message: string } | { __typename: 'ProrateOrdersSuccessOutput', orderUuids: Array<string> } };

export type TypeaheadOrderUuidsQueryForConsolidationFlowQueryVariables = Exact<{
  billingPartyContactUuidFilter?: InputMaybe<StringFilter>;
  statusFilters?: InputMaybe<Array<StatusFilter> | StatusFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  searchText?: InputMaybe<Scalars['String']['input']>;
  onInvoice?: InputMaybe<BooleanFilter>;
  versionId?: InputMaybe<Scalars['Float']['input']>;
  includeOrdersPartOfV2ConsolidatedOrdersFilter?: InputMaybe<BooleanFilterV2>;
}>;


export type TypeaheadOrderUuidsQueryForConsolidationFlowQuery = { __typename?: 'Query', orders: { __typename?: 'OrderConnection', versionId?: number | null, edges: Array<{ __typename?: 'OrderEdge', node: { __typename?: 'StandardOrderEntity', uuid: string, weight: number, dimWeight: number, name: string, status: OrderStatus, pieceCountFromPackages: number, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', shipperBillOfLadingNumber?: string | null }, billingPartyContact: { __typename?: 'CustomerContactEntity', uuid: string, displayName: string }, inboundShipment?: { __typename?: 'StandardShipmentEntity', uuid: string, legs: Array<{ __typename?: 'LegEntity', endStop: { __typename?: 'StandardStopEntity', address: { __typename?: 'AddressEntity', name: string, line1: string } } }>, freightCharge?: { __typename?: 'FreightChargeEntity', uuid: string } | null } | null, outboundShipment?: { __typename?: 'StandardShipmentEntity', uuid: string, legs: Array<{ __typename?: 'LegEntity', endStop: { __typename?: 'StandardStopEntity', address: { __typename?: 'AddressEntity', name: string, line1: string } } }>, freightCharge?: { __typename?: 'FreightChargeEntity', uuid: string } | null } | null, lineHaulLane?: { __typename?: 'LineHaulLaneEntity', name: string } | null } }>, pageInfo: { __typename?: 'PageInfo', startCursor?: string | null, endCursor?: string | null, hasNextPage: boolean, hasPreviousPage: boolean } } };

type ContactForInvoice_CustomerContactEntity_Fragment = { __typename: 'CustomerContactEntity', numberOfOrdersPerInvoice?: number | null, invoiceTimePeriodSplit?: TimePeriod | null, defaultInvoiceType: InvoiceType, defaultInvoiceTransmissionMethod: InvoiceTransmissionMethod, defaultInvoiceDocumentsRequired: Array<DocumentType>, defaultInvoiceDownloadDocuments: Array<DocumentType>, enableCreditHold?: boolean | null, defaultInvoiceEmailSubject?: string | null, uuid: string, displayName: string, stediPartnerId?: string | null, contactReferenceNumber?: string | null };

type ContactForInvoice_ThirdPartyContactEntity_Fragment = { __typename: 'ThirdPartyContactEntity', uuid: string, displayName: string, stediPartnerId?: string | null, contactReferenceNumber?: string | null };

export type ContactForInvoiceFragment = ContactForInvoice_CustomerContactEntity_Fragment | ContactForInvoice_ThirdPartyContactEntity_Fragment;

export type ContactsForInvoicesQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  searchText?: InputMaybe<Scalars['String']['input']>;
  sortByContactName?: InputMaybe<Scalars['Boolean']['input']>;
  excludeNonActive?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type ContactsForInvoicesQuery = { __typename?: 'Query', paginatedContacts: { __typename?: 'ContactConnection', totalCount?: number | null, edges: Array<{ __typename?: 'ContactEdge', node: { __typename: 'CustomerContactEntity', numberOfOrdersPerInvoice?: number | null, invoiceTimePeriodSplit?: TimePeriod | null, defaultInvoiceType: InvoiceType, defaultInvoiceTransmissionMethod: InvoiceTransmissionMethod, defaultInvoiceDocumentsRequired: Array<DocumentType>, defaultInvoiceDownloadDocuments: Array<DocumentType>, enableCreditHold?: boolean | null, defaultInvoiceEmailSubject?: string | null, uuid: string, displayName: string, stediPartnerId?: string | null, contactReferenceNumber?: string | null } | { __typename: 'ThirdPartyContactEntity', uuid: string, displayName: string, stediPartnerId?: string | null, contactReferenceNumber?: string | null } }>, pageInfo: { __typename?: 'PageInfo', startCursor?: string | null, endCursor?: string | null, hasNextPage: boolean, hasPreviousPage: boolean } } };

export type CreateContactDocumentMutationVariables = Exact<{
  createContactDocumentInput: CreateContactDocumentInput;
}>;


export type CreateContactDocumentMutation = { __typename?: 'Mutation', createContactDocument: { __typename?: 'DocumentEntity', uuid: string } };

export type CreateInvoiceDocumentsMutationVariables = Exact<{
  createInvoiceDocumentsInput: CreateInvoiceDocumentsInput;
}>;


export type CreateInvoiceDocumentsMutation = { __typename?: 'Mutation', createInvoiceDocuments: Array<{ __typename?: 'DocumentEntity', uuid: string, bucket: string, region: string, key: string, fileName: string, fileType: string, type: DocumentType, invoice?: { __typename?: 'InvoiceEntity', uuid: string, billToContact: { __typename?: 'CustomerContactEntity', uuid: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string } } | null }> };

export type DownloadInvoicesMutationVariables = Exact<{
  downloadInvoicesInput: DownloadInvoicesInput;
}>;


export type DownloadInvoicesMutation = { __typename?: 'Mutation', downloadInvoices: { __typename?: 'DownloadInvoicesOutput', combinedDocument?: { __typename?: 'DocumentEntity', uuid: string, fileName: string, bucket: string, region: string, key: string, uploadedAt?: any | null, fileType: string, isDeleted: boolean, preSignedGetUrl: string, name?: string | null, type: DocumentType, pageNumber?: number | null, createdAt: any, notes?: string | null, order?: { __typename?: 'StandardOrderEntity', uuid: string, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', shipperBillOfLadingNumber?: string | null } } | null, shipment?: { __typename?: 'StandardOrderEntity', uuid: string } | null, driverFormTemplate?: { __typename?: 'DriverSignableFormTemplateEntity', uuid: string, title: string, formText: string } | null } | null, zipDocument?: { __typename?: 'DocumentEntity', uuid: string, fileName: string, bucket: string, region: string, key: string, uploadedAt?: any | null, fileType: string, isDeleted: boolean, preSignedGetUrl: string, name?: string | null, type: DocumentType, pageNumber?: number | null, createdAt: any, notes?: string | null, order?: { __typename?: 'StandardOrderEntity', uuid: string, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', shipperBillOfLadingNumber?: string | null } } | null, shipment?: { __typename?: 'StandardOrderEntity', uuid: string } | null, driverFormTemplate?: { __typename?: 'DriverSignableFormTemplateEntity', uuid: string, title: string, formText: string } | null } | null } };

export type ExportInvoicesToQuickbooksDesktopMutationVariables = Exact<{
  exportInvoicesToQuickbooksInput: ExportInvoicesToQuickbooksInput;
}>;


export type ExportInvoicesToQuickbooksDesktopMutation = { __typename?: 'Mutation', exportInvoicesToQuickbooksDesktop: Array<{ __typename?: 'ExportQuickbooksResult', failedInvoiceUuid: string, missingFreightChargeMappings: Array<string>, missingFuelChargeMappings: Array<string>, missingAccessorialMappings: Array<string>, missingCustomerName?: string | null, missingCustomerUuid?: string | null, duplicateInvoiceError?: string | null, conductorUserFacingErrors: Array<string>, success: boolean, invoice: { __typename?: 'QuickbooksDesktopInvoiceEntity', id: string, name: string, amount: number } }> };

export type GenerateInvoicePreSignedPutUrlsMutationVariables = Exact<{
  generateInvoicePreSignedPutUrlsInput: GenerateInvoicePreSignedPutUrlsInput;
}>;


export type GenerateInvoicePreSignedPutUrlsMutation = { __typename?: 'Mutation', generateInvoicePreSignedPutUrls: Array<{ __typename?: 'GenerateInvoicePreSignedPutUrlOutput', url: string, invoiceUuid: string }> };

export type InvoiceForContactFragment = { __typename?: 'InvoiceEntity', uuid: string, source: InvoiceSource, name: string, journalNumber: number, status: InvoiceStatus, date: any, createdAt: any, billToContact: { __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string } };

export type InvoiceForInvoiceSelectionFragment = { __typename?: 'InvoiceEntity', uuid: string, name: string, journalNumber: number, date: any, dueDate?: any | null };

export type InvoiceOrderFragmentFragment = { __typename?: 'StandardOrderEntity', uuid: string, createdAt: any, name: string, missingDocuments: Array<DocumentType>, appliedAmount: number, balanceInCents: number, secondaryRefNumber?: string | null, pieceCountFromPackages: number, weight: number, documents: Array<{ __typename?: 'DocumentEntity', type: DocumentType }>, paperwork: { __typename?: 'OrderPaperworkEntity', paperworkComplete: boolean, paperworkMarkedCompleteOverride?: boolean | null, attachedDocuments?: Array<DocumentType> | null, missingDocuments?: Array<DocumentType> | null }, orderPaymentMappings: Array<{ __typename?: 'PaymentToOrderMappingEntity', uuid: string, amountInCents: number, payment: { __typename?: 'PaymentEntity', paymentType: PaymentType, contact: { __typename?: 'CustomerContactEntity', displayName: string, uuid: string } | { __typename?: 'ThirdPartyContactEntity', displayName: string, uuid: string } } }>, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', uuid: string, shipperBillOfLadingNumber?: string | null, masterAirwayBillOfLadingNumber?: string | null, weightUnits: WeightUnits }, orderComments: Array<{ __typename?: 'OrderCommentEntity', uuid: string, comment: string, showOnInvoice?: boolean | null }>, shipments: Array<{ __typename?: 'StandardShipmentEntity', uuid: string, shipmentCharges: { __typename?: 'ShipmentChargeEntity', totalCharge: number }, invoice?: { __typename?: 'InvoiceEntity', uuid: string } | null }>, endStop?: { __typename?: 'StandardStopEntity', serviceDate?: any | null, address: { __typename?: 'AddressEntity', name: string } } | null };

export type InvoiceOrderWithShipmentsFragment = { __typename?: 'StandardOrderEntity', uuid: string, createdAt: any, name: string, missingDocuments: Array<DocumentType>, appliedAmount: number, balanceInCents: number, secondaryRefNumber?: string | null, pieceCountFromPackages: number, weight: number, shipments: Array<{ __typename?: 'StandardShipmentEntity', uuid: string, overridePackageWeight: boolean, shipmentType: ShipmentType, status: ShipmentStatus, name: string, shipmentCharges: { __typename?: 'ShipmentChargeEntity', totalCharge: number, totalFreightCharge: number, totalFuelCharge: number }, invoice?: { __typename?: 'InvoiceEntity', uuid: string } | null, shipperAddress?: { __typename?: 'AddressEntity', uuid: string, name: string, line1: string, line2?: string | null, city: string, state: string, zip: string, country: string, latitude?: number | null, longitude?: number | null, driverInstructions?: string | null, receivingHoursStart?: any | null, receivingHoursEnd?: any | null, specialInstructions?: string | null } | null, standardShipmentFields: { __typename?: 'StandardShipmentFieldsEntity', pickupOrDelivery: PickupOrDelivery }, legs: Array<{ __typename?: 'LegEntity', uuid: string, endStop: { __typename?: 'StandardStopEntity', completedAt?: any | null, paperworkMarkedComplete?: boolean | null, settlementDeductionName?: string | null, settlementDeductionFlatRate?: number | null, settlementDeductionPercentageRate?: number | null, stopType?: StopType | null, address: { __typename?: 'AddressEntity', uuid: string, name: string, line1: string, line2?: string | null, city: string, state: string, zip: string, country: string, latitude?: number | null, longitude?: number | null, driverInstructions?: string | null, receivingHoursStart?: any | null, receivingHoursEnd?: any | null, specialInstructions?: string | null } } }>, charges: Array<{ __typename?: 'CustomChargeEntity', uuid: string, name: string, quantity: number, description?: string | null, rate: number, total: number, settlementFlatRate?: number | null, settlementPercentageRate?: number | null, postedFuelSurchargeRate?: number | null, customChargeBillingMethod: CustomChargeBillingMethod, accessorialTemplate?: { __typename: 'SkidBasedAccessorialEntity', uuid: string, name: string, invoiceDisplayName?: string | null } | { __typename: 'SpecialAccessorialEntity', uuid: string, name: string, invoiceDisplayName?: string | null } | { __typename: 'StandardAccessorialEntity', uuid: string, name: string, invoiceDisplayName?: string | null } | { __typename: 'UnitBasedAccessorialEntity', uuid: string, name: string, invoiceDisplayName?: string | null } | { __typename: 'WaitTimeAccessorialEntity', uuid: string, name: string, invoiceDisplayName?: string | null } | { __typename: 'WeightBasedAccessorialEntity', uuid: string, name: string, invoiceDisplayName?: string | null } | { __typename: 'ZoneBasedAccessorialEntity', uuid: string, name: string, invoiceDisplayName?: string | null } | null } | { __typename?: 'FreightChargeEntity', uuid: string, billingMethod: FreightBillingMethod, rate: number, description?: string | null, quantity: number, settlementFlatRate?: number | null, settlementPercentageRate?: number | null, tariff?: { __typename?: 'TariffEntity', uuid: string, tariffZone: { __typename?: 'TariffZoneEntity', name: string, type: TariffZoneType } } | null, fuelCharge?: { __typename?: 'FuelChargeEntity', surchargeRate: number, flatRate: number, type: FuelBillingMethod, uuid: string, settlementFlatRate?: number | null, settlementPercentageRate?: number | null } | null }> }>, documents: Array<{ __typename?: 'DocumentEntity', type: DocumentType }>, paperwork: { __typename?: 'OrderPaperworkEntity', paperworkComplete: boolean, paperworkMarkedCompleteOverride?: boolean | null, attachedDocuments?: Array<DocumentType> | null, missingDocuments?: Array<DocumentType> | null }, orderPaymentMappings: Array<{ __typename?: 'PaymentToOrderMappingEntity', uuid: string, amountInCents: number, payment: { __typename?: 'PaymentEntity', paymentType: PaymentType, contact: { __typename?: 'CustomerContactEntity', displayName: string, uuid: string } | { __typename?: 'ThirdPartyContactEntity', displayName: string, uuid: string } } }>, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', uuid: string, shipperBillOfLadingNumber?: string | null, masterAirwayBillOfLadingNumber?: string | null, weightUnits: WeightUnits }, orderComments: Array<{ __typename?: 'OrderCommentEntity', uuid: string, comment: string, showOnInvoice?: boolean | null }>, endStop?: { __typename?: 'StandardStopEntity', serviceDate?: any | null, address: { __typename?: 'AddressEntity', name: string } } | null };

export type AcknowledgeFailedInvoiceSendJobsMutationVariables = Exact<{
  invoiceSendJobBatchUuid: Scalars['String']['input'];
}>;


export type AcknowledgeFailedInvoiceSendJobsMutation = { __typename?: 'Mutation', acknowledgeFailedInvoiceSendJobs: { __typename?: 'InvoiceSendJobBatchEntity', uuid: string } };

export type InvoiceDocumentForDownloadFragment = { __typename?: 'DocumentEntity', fileType: string, preSignedGetUrl: string, invoice?: { __typename?: 'InvoiceEntity', name: string, journalNumber: number } | null };

export type InvoiceSendJobBatchFragment = { __typename?: 'InvoiceSendJobBatchEntity', uuid: string, createdAt: any, type: InvoiceSendJobBatchType, invoiceSendJobBatchProgress: { __typename?: 'InvoiceSendJobBatchProgressEntity', totalCount: number, failCount: number, successCount: number }, invoiceBatchDocuments: { __typename?: 'InvoiceSendJobBatchDocumentsEntity', invoicesBackupDocument?: { __typename?: 'DocumentEntity', preSignedGetUrl: string, fileType: string } | null, invoicesCombinedDocument?: { __typename?: 'DocumentEntity', preSignedGetUrl: string, fileType: string } | null, invoicesZipDocument?: { __typename?: 'DocumentEntity', preSignedGetUrl: string, fileType: string } | null } };

export type InvoiceSendJobBatchesQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  sortByCreatedAtAsc?: InputMaybe<Scalars['Boolean']['input']>;
  inProgress?: InputMaybe<Scalars['Boolean']['input']>;
  hasFailures?: InputMaybe<Scalars['Boolean']['input']>;
  createdAtDateFilters?: InputMaybe<Array<DateFilter> | DateFilter>;
  acknowledged?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type InvoiceSendJobBatchesQuery = { __typename?: 'Query', invoiceSendJobBatches: { __typename?: 'InvoiceSendJobBatchConnection', totalCount?: number | null, edges: Array<{ __typename?: 'InvoiceSendJobBatchEdge', node: { __typename?: 'InvoiceSendJobBatchEntity', uuid: string, createdAt: any, type: InvoiceSendJobBatchType, invoiceSendJobBatchProgress: { __typename?: 'InvoiceSendJobBatchProgressEntity', totalCount: number, failCount: number, successCount: number }, invoiceBatchDocuments: { __typename?: 'InvoiceSendJobBatchDocumentsEntity', invoicesBackupDocument?: { __typename?: 'DocumentEntity', preSignedGetUrl: string, fileType: string } | null, invoicesCombinedDocument?: { __typename?: 'DocumentEntity', preSignedGetUrl: string, fileType: string } | null, invoicesZipDocument?: { __typename?: 'DocumentEntity', preSignedGetUrl: string, fileType: string } | null } } }>, pageInfo: { __typename?: 'PageInfo', startCursor?: string | null, endCursor?: string | null, hasNextPage: boolean, hasPreviousPage: boolean } } };

export type InvoiceSendJobShallowFragment = { __typename?: 'InvoiceSendJobEntity', uuid: string, invoice: { __typename?: 'InvoiceEntity', uuid: string, name: string, journalNumber: number } };

export type InvoiceSendJobFragment = { __typename?: 'InvoiceSendJobEntity', uuid: string, createdAt: any, invoiceSendJobError?: InvoiceSendJobError | null, invoiceAttachmentDocumentTypes: Array<DocumentType>, invoiceTransmissionMethod: InvoiceTransmissionMethod, invoiceChargesObject?: string | null, invoice: { __typename?: 'InvoiceEntity', uuid: string, name: string, journalNumber: number, billToContact: { __typename?: 'CustomerContactEntity', displayName: string } | { __typename?: 'ThirdPartyContactEntity', displayName: string } }, document?: { __typename?: 'DocumentEntity', preSignedGetUrl: string } | null, emailTransaction?: { __typename?: 'EmailTransactionEntity', uuid: string, emailTransactionStatus: EmailTransactionStatus, emailTransactionLogs: Array<{ __typename?: 'EmailTransactionLogEntity', uuid: string, email: string, lastStatus?: EmailTransactionLogStatus | null, reason?: string | null }> } | null };

export type InvoiceSendJobsShallowQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  searchText?: InputMaybe<Scalars['String']['input']>;
  invoiceSendJobBatchUuid: Scalars['String']['input'];
  invoiceSendJobStatus?: InputMaybe<InvoiceSendJobStatus>;
}>;


export type InvoiceSendJobsShallowQuery = { __typename?: 'Query', invoiceSendJobs: { __typename?: 'InvoiceSendJobConnection', totalCount?: number | null, edges: Array<{ __typename?: 'InvoiceSendJobEdge', node: { __typename?: 'InvoiceSendJobEntity', uuid: string, invoice: { __typename?: 'InvoiceEntity', uuid: string, name: string, journalNumber: number } } }>, pageInfo: { __typename?: 'PageInfo', startCursor?: string | null, endCursor?: string | null, hasNextPage: boolean, hasPreviousPage: boolean } } };

export type InvoiceSendJobsQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  searchText?: InputMaybe<Scalars['String']['input']>;
  invoiceSendJobBatchUuid: Scalars['String']['input'];
  invoiceSendJobStatus?: InputMaybe<InvoiceSendJobStatus>;
}>;


export type InvoiceSendJobsQuery = { __typename?: 'Query', invoiceSendJobs: { __typename?: 'InvoiceSendJobConnection', totalCount?: number | null, edges: Array<{ __typename?: 'InvoiceSendJobEdge', node: { __typename?: 'InvoiceSendJobEntity', uuid: string, createdAt: any, invoiceSendJobError?: InvoiceSendJobError | null, invoiceAttachmentDocumentTypes: Array<DocumentType>, invoiceTransmissionMethod: InvoiceTransmissionMethod, invoiceChargesObject?: string | null, invoice: { __typename?: 'InvoiceEntity', uuid: string, name: string, journalNumber: number, billToContact: { __typename?: 'CustomerContactEntity', displayName: string } | { __typename?: 'ThirdPartyContactEntity', displayName: string } }, document?: { __typename?: 'DocumentEntity', preSignedGetUrl: string } | null, emailTransaction?: { __typename?: 'EmailTransactionEntity', uuid: string, emailTransactionStatus: EmailTransactionStatus, emailTransactionLogs: Array<{ __typename?: 'EmailTransactionLogEntity', uuid: string, email: string, lastStatus?: EmailTransactionLogStatus | null, reason?: string | null }> } | null } }>, pageInfo: { __typename?: 'PageInfo', startCursor?: string | null, endCursor?: string | null, hasNextPage: boolean, hasPreviousPage: boolean } } };

export type InvoiceShipmentWithChargesFragment = { __typename?: 'StandardShipmentEntity', uuid: string, overridePackageWeight: boolean, shipmentType: ShipmentType, status: ShipmentStatus, name: string, shipmentCharges: { __typename?: 'ShipmentChargeEntity', totalFreightCharge: number, totalFuelCharge: number, totalCharge: number }, shipperAddress?: { __typename?: 'AddressEntity', uuid: string, name: string, line1: string, line2?: string | null, city: string, state: string, zip: string, country: string, latitude?: number | null, longitude?: number | null, driverInstructions?: string | null, receivingHoursStart?: any | null, receivingHoursEnd?: any | null, specialInstructions?: string | null } | null, standardShipmentFields: { __typename?: 'StandardShipmentFieldsEntity', pickupOrDelivery: PickupOrDelivery }, legs: Array<{ __typename?: 'LegEntity', uuid: string, endStop: { __typename?: 'StandardStopEntity', completedAt?: any | null, paperworkMarkedComplete?: boolean | null, settlementDeductionName?: string | null, settlementDeductionFlatRate?: number | null, settlementDeductionPercentageRate?: number | null, stopType?: StopType | null, address: { __typename?: 'AddressEntity', uuid: string, name: string, line1: string, line2?: string | null, city: string, state: string, zip: string, country: string, latitude?: number | null, longitude?: number | null, driverInstructions?: string | null, receivingHoursStart?: any | null, receivingHoursEnd?: any | null, specialInstructions?: string | null } } }>, invoice?: { __typename?: 'InvoiceEntity', uuid: string } | null, charges: Array<{ __typename?: 'CustomChargeEntity', uuid: string, name: string, quantity: number, description?: string | null, rate: number, total: number, settlementFlatRate?: number | null, settlementPercentageRate?: number | null, postedFuelSurchargeRate?: number | null, customChargeBillingMethod: CustomChargeBillingMethod, accessorialTemplate?: { __typename: 'SkidBasedAccessorialEntity', uuid: string, name: string, invoiceDisplayName?: string | null } | { __typename: 'SpecialAccessorialEntity', uuid: string, name: string, invoiceDisplayName?: string | null } | { __typename: 'StandardAccessorialEntity', uuid: string, name: string, invoiceDisplayName?: string | null } | { __typename: 'UnitBasedAccessorialEntity', uuid: string, name: string, invoiceDisplayName?: string | null } | { __typename: 'WaitTimeAccessorialEntity', uuid: string, name: string, invoiceDisplayName?: string | null } | { __typename: 'WeightBasedAccessorialEntity', uuid: string, name: string, invoiceDisplayName?: string | null } | { __typename: 'ZoneBasedAccessorialEntity', uuid: string, name: string, invoiceDisplayName?: string | null } | null } | { __typename?: 'FreightChargeEntity', uuid: string, billingMethod: FreightBillingMethod, rate: number, description?: string | null, quantity: number, settlementFlatRate?: number | null, settlementPercentageRate?: number | null, tariff?: { __typename?: 'TariffEntity', uuid: string, tariffZone: { __typename?: 'TariffZoneEntity', name: string, type: TariffZoneType } } | null, fuelCharge?: { __typename?: 'FuelChargeEntity', surchargeRate: number, flatRate: number, type: FuelBillingMethod, uuid: string, settlementFlatRate?: number | null, settlementPercentageRate?: number | null } | null }> };

export type InvoiceStatFragment = { __typename?: 'InvoiceEntity', balanceInCents: number, invoiceTotal: string, uuid: string };

export type InvoiceStatsByUuidsQueryVariables = Exact<{
  uuids: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type InvoiceStatsByUuidsQuery = { __typename?: 'Query', invoicesByUuids: Array<{ __typename?: 'InvoiceEntity', balanceInCents: number, invoiceTotal: string, uuid: string }> };

export type InvoiceTermFragment = { __typename?: 'InvoiceTermEntity', uuid: string, terms: string };

export type InvoiceTotalQueryVariables = Exact<{
  uuid: Scalars['String']['input'];
}>;


export type InvoiceTotalQuery = { __typename?: 'Query', invoice?: { __typename?: 'InvoiceEntity', invoiceTotal: string } | null };

export type InvoiceTotalsQueryVariables = Exact<{
  uuids: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type InvoiceTotalsQuery = { __typename?: 'Query', invoicesByUuids: Array<{ __typename?: 'InvoiceEntity', balanceInCents: number, invoiceTotal: string, uuid: string }> };

export type InvoiceUuidsForBatchPostQueryVariables = Exact<{
  inConsolidatedInvoice?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  createdAtStartDate?: InputMaybe<Scalars['DateTime']['input']>;
  createdAtEndDate?: InputMaybe<Scalars['DateTime']['input']>;
  invoiceStartDate?: InputMaybe<Scalars['DateTime']['input']>;
  invoiceEndDate?: InputMaybe<Scalars['DateTime']['input']>;
  statuses?: InputMaybe<Array<InvoiceStatus> | InvoiceStatus>;
  emailSendStatus?: InputMaybe<EmailSendStatus>;
  searchText?: InputMaybe<Scalars['String']['input']>;
  billingPartyContactUuid?: InputMaybe<Scalars['String']['input']>;
  sortByDueDateAscending?: InputMaybe<Scalars['Boolean']['input']>;
  sortByDueDateDescending?: InputMaybe<Scalars['Boolean']['input']>;
  groupByContact?: InputMaybe<Scalars['Boolean']['input']>;
  uuids?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  isClosed?: InputMaybe<Scalars['Boolean']['input']>;
  isSyncedToQuickbooksDesktop?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type InvoiceUuidsForBatchPostQuery = { __typename?: 'Query', invoices: { __typename?: 'InvoiceConnection', totalCount?: number | null, edges: Array<{ __typename?: 'InvoiceEdge', node: { __typename?: 'InvoiceEntity', uuid: string, status: InvoiceStatus } }>, pageInfo: { __typename?: 'PageInfo', startCursor?: string | null, endCursor?: string | null, hasPreviousPage: boolean, hasNextPage: boolean } } };

export type InvoiceV2QueryVariables = Exact<{
  uuid: Scalars['String']['input'];
}>;


export type InvoiceV2Query = { __typename?: 'Query', invoice?: { __typename?: 'InvoiceEntity', uuid: string, name: string, journalNumber: number, createdAt: any, dueDate?: any | null, date: any, status: InvoiceStatus, source: InvoiceSource, qbInvoiceNumber?: number | null, emailOptions: Array<string>, invoiceTerms?: { __typename?: 'InvoiceTermEntity', uuid: string, terms: string } | null, billToContact: { __typename?: 'CustomerContactEntity', uuid: string, displayName: string, billingCycleDuration: BillingCycleDuration, ediPartnerships: Array<{ __typename?: 'EdiPartnershipEntity', stedi210MappingId?: string | null, ediOutboundPayloadDestination: EdiOutboundPayloadDestination }> } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string, billingCycleDuration: BillingCycleDuration, ediPartnerships: Array<{ __typename?: 'EdiPartnershipEntity', stedi210MappingId?: string | null, ediOutboundPayloadDestination: EdiOutboundPayloadDestination }> }, firstShipment?: { __typename?: 'StandardShipmentEntity', uuid: string } | null } | null };

export type InvoiceWithOrdersFragment = { __typename?: 'InvoiceEntity', uuid: string, source: InvoiceSource, name: string, journalNumber: number, status: InvoiceStatus, date: any, createdAt: any, billToContact: { __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string } };

export type InvoicesByUuidsForDownloadQueryVariables = Exact<{
  uuids: Array<Scalars['String']['input']> | Scalars['String']['input'];
  includeDocuments: Scalars['Boolean']['input'];
}>;


export type InvoicesByUuidsForDownloadQuery = { __typename?: 'Query', invoicesByUuids: Array<{ __typename?: 'InvoiceEntity', uuid: string, dueDate?: any | null, date: any, name: string, journalNumber: number, billToContact: { __typename?: 'CustomerContactEntity', uuid: string, displayName: string, invoiceNotes?: string | null, defaultAddress?: { __typename?: 'AddressEntity', uuid: string, name: string, line1: string, line2?: string | null, city: string, state: string, zip: string, country: string, latitude?: number | null, longitude?: number | null, driverInstructions?: string | null, receivingHoursStart?: any | null, receivingHoursEnd?: any | null, specialInstructions?: string | null } | null, businessDivision?: { __typename?: 'BusinessDivisionEntity', name: string } | null } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string, invoiceNotes?: string | null, defaultAddress?: { __typename?: 'AddressEntity', uuid: string, name: string, line1: string, line2?: string | null, city: string, state: string, zip: string, country: string, latitude?: number | null, longitude?: number | null, driverInstructions?: string | null, receivingHoursStart?: any | null, receivingHoursEnd?: any | null, specialInstructions?: string | null } | null, businessDivision?: { __typename?: 'BusinessDivisionEntity', name: string } | null }, invoiceTerms?: { __typename?: 'InvoiceTermEntity', uuid: string, terms: string } | null, shipments: Array<{ __typename?: 'StandardShipmentEntity', name: string, shipmentType: ShipmentType, standardShipmentFields: { __typename?: 'StandardShipmentFieldsEntity', pickupOrDelivery: PickupOrDelivery }, inputForConsolidatedOrder?: { __typename?: 'StandardOrderEntity', name: string } | null, shipmentCharges: { __typename?: 'ShipmentChargeEntity', totalCharge: number, totalFreightCharge: number, totalFuelCharge: number }, packages: Array<{ __typename?: 'PackageEntity', length?: number | null, width?: number | null, height?: number | null, quantity: number, weight?: number | null }>, order?: { __typename?: 'StandardOrderEntity', uuid: string, isCrossDock?: boolean | null, name: string, refNumbers: Array<string>, secondaryRefNumber?: string | null, consolidatedShipmentString?: string | null, orderComments: Array<{ __typename?: 'OrderCommentEntity', uuid: string, comment: string, showOnInvoice?: boolean | null }>, documents: Array<{ __typename?: 'DocumentEntity', uuid: string, fileName: string, bucket: string, region: string, key: string, uploadedAt?: any | null, fileType: string, isDeleted: boolean, preSignedGetUrl: string, name?: string | null, type: DocumentType, pageNumber?: number | null, createdAt: any, notes?: string | null, order?: { __typename?: 'StandardOrderEntity', uuid: string, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', shipperBillOfLadingNumber?: string | null } } | null, shipment?: { __typename?: 'StandardOrderEntity', uuid: string } | null, driverFormTemplate?: { __typename?: 'DriverSignableFormTemplateEntity', uuid: string, title: string, formText: string } | null }>, service?: { __typename?: 'ServiceEntity', name: string } | null, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', shipperBillOfLadingNumber?: string | null, masterAirwayBillOfLadingNumber?: string | null, dimFactor?: number | null } } | null, charges: Array<{ __typename?: 'CustomChargeEntity', name: string, description?: string | null, total: number, authoCode?: string | null, accessorialTemplate?: { __typename?: 'SkidBasedAccessorialEntity', name: string, invoiceDisplayName?: string | null } | { __typename?: 'SpecialAccessorialEntity', name: string, invoiceDisplayName?: string | null } | { __typename?: 'StandardAccessorialEntity', name: string, invoiceDisplayName?: string | null } | { __typename?: 'UnitBasedAccessorialEntity', name: string, invoiceDisplayName?: string | null } | { __typename?: 'WaitTimeAccessorialEntity', name: string, invoiceDisplayName?: string | null } | { __typename?: 'WeightBasedAccessorialEntity', name: string, invoiceDisplayName?: string | null } | { __typename?: 'ZoneBasedAccessorialEntity', name: string, invoiceDisplayName?: string | null } | null } | { __typename?: 'FreightChargeEntity', description?: string | null, authoCode?: string | null, tariff?: { __typename?: 'TariffEntity', tariffZone: { __typename?: 'TariffZoneEntity', type: TariffZoneType, name: string } } | null, fuelCharge?: { __typename?: 'FuelChargeEntity', description?: string | null, authoCode?: string | null } | null }>, legs: Array<{ __typename?: 'LegEntity', endStop: { __typename?: 'StandardStopEntity', completedAt?: any | null, proofOfDeliverySignee?: string | null, address: { __typename?: 'AddressEntity', name: string, line1: string, line2?: string | null, zip: string, city: string, state: string } } }> }> }> };

export type InvoicesByUuidsQueryVariables = Exact<{
  uuids: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type InvoicesByUuidsQuery = { __typename?: 'Query', invoicesByUuids: Array<{ __typename?: 'InvoiceEntity', uuid: string, status: InvoiceStatus, createdAt: any, lastSyncedToQuickbooksAt?: any | null, quickbooksInvoiceId?: string | null, dueDate?: any | null, date: any, invoiceTotal: string, inConsolidatedInvoice: boolean, name: string, notes?: string | null, qbInvoiceNumber?: number | null, journalNumber: number, billToContact: { __typename?: 'CustomerContactEntity', uuid: string, displayName: string, defaultAddress?: { __typename?: 'AddressEntity', uuid: string } | null, addresses: Array<{ __typename?: 'AddressEntity', uuid: string }>, contactPersons: Array<{ __typename?: 'ContactPersonEntity', uuid: string }> } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string, defaultAddress?: { __typename?: 'AddressEntity', uuid: string } | null, addresses: Array<{ __typename?: 'AddressEntity', uuid: string }>, contactPersons: Array<{ __typename?: 'ContactPersonEntity', uuid: string }> }, documents: Array<{ __typename?: 'DocumentEntity', uuid: string, fileName: string, bucket: string, region: string, key: string, uploadedAt?: any | null, fileType: string, isDeleted: boolean, preSignedGetUrl: string, name?: string | null, type: DocumentType, pageNumber?: number | null, createdAt: any, notes?: string | null, order?: { __typename?: 'StandardOrderEntity', uuid: string, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', shipperBillOfLadingNumber?: string | null } } | null, shipment?: { __typename?: 'StandardOrderEntity', uuid: string } | null, driverFormTemplate?: { __typename?: 'DriverSignableFormTemplateEntity', uuid: string, title: string, formText: string } | null }>, invoiceTerms?: { __typename?: 'InvoiceTermEntity', uuid: string, terms: string } | null, shipments: Array<{ __typename?: 'StandardShipmentEntity', uuid: string, status: ShipmentStatus, totalChargesAmount: number, failureCount: number, hasFailedStop: boolean, name: string, overridePackageWeight: boolean, shouldUseDimWeight: boolean, totalCustomChargesAmount: number, totalFuelChargesAmount: number, totalFreightChargesAmount: number, shipmentType: ShipmentType, charges: Array<{ __typename?: 'CustomChargeEntity', uuid: string, name: string, zoneBasedAccessorialZoneUuid?: string | null, zoneBasedAccessorialChargeGroupUuid?: string | null, specialAccessorialTariffZoneUuid?: string | null, specialAccessorialChargeGroupUuid?: string | null, quantity: number, description?: string | null, rate: number, authoCode?: string | null, total: number, customChargeBillingMethod: CustomChargeBillingMethod, accessorialTemplate?: { __typename: 'SkidBasedAccessorialEntity', uuid: string, name: string, percentForSettlement?: number | null } | { __typename: 'SpecialAccessorialEntity', uuid: string, name: string, percentForSettlement?: number | null } | { __typename: 'StandardAccessorialEntity', uuid: string, name: string, percentForSettlement?: number | null } | { __typename: 'UnitBasedAccessorialEntity', uuid: string, name: string, percentForSettlement?: number | null } | { __typename: 'WaitTimeAccessorialEntity', uuid: string, name: string, percentForSettlement?: number | null } | { __typename: 'WeightBasedAccessorialEntity', uuid: string, name: string, percentForSettlement?: number | null } | { __typename: 'ZoneBasedAccessorialEntity', uuid: string, name: string, percentForSettlement?: number | null } | null } | { __typename?: 'FreightChargeEntity', uuid: string, description?: string | null, quantity: number, billingMethod: FreightBillingMethod, rate: number, authoCode?: string | null, tariff?: { __typename?: 'TariffEntity', uuid: string, billingPartyContactUuid?: string | null, tariffOverageRates: Array<{ __typename?: 'TariffOverageRateEntity', uuid: string, name: string, type: TariffOverageRateType, rateUsdCents: number, applicableAboveAmount: number }>, tariffZone: { __typename?: 'TariffZoneEntity', name: string, type: TariffZoneType } } | null, fuelCharge?: { __typename?: 'FuelChargeEntity', description?: string | null, surchargeRate: number, uuid: string, flatRate: number, authoCode?: string | null, type: FuelBillingMethod } | null }>, customCharges: Array<{ __typename?: 'CustomChargeEntity', uuid: string, description?: string | null, name: string, quantity: number, rate: number, zoneBasedAccessorialChargeGroupUuid?: string | null, zoneBasedAccessorialZoneUuid?: string | null, specialAccessorialTariffZoneUuid?: string | null, specialAccessorialChargeGroupUuid?: string | null, customChargeBillingMethod: CustomChargeBillingMethod, accessorialTemplate?: { __typename?: 'SkidBasedAccessorialEntity', uuid: string, name: string, percentForSettlement?: number | null } | { __typename?: 'SpecialAccessorialEntity', uuid: string, name: string, percentForSettlement?: number | null } | { __typename?: 'StandardAccessorialEntity', uuid: string, name: string, percentForSettlement?: number | null } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string, name: string, percentForSettlement?: number | null } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string, name: string, percentForSettlement?: number | null } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string, name: string, percentForSettlement?: number | null } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string, name: string, percentForSettlement?: number | null } | null }>, freightCharge?: { __typename?: 'FreightChargeEntity', uuid: string, billingMethod: FreightBillingMethod, description?: string | null, quantity: number, rate: number, fuelCharge?: { __typename?: 'FuelChargeEntity', description?: string | null, surchargeRate: number, uuid: string, freightCharge: { __typename?: 'FreightChargeEntity', uuid: string } } | null, tariff?: { __typename?: 'TariffEntity', uuid: string, billingPartyContactUuid?: string | null, tariffOverageRates: Array<{ __typename?: 'TariffOverageRateEntity', uuid: string, name: string, type: TariffOverageRateType, rateUsdCents: number, applicableAboveAmount: number }> } | null } | null, legs: Array<{ __typename?: 'LegEntity', uuid: string, miles?: number | null, endStop: { __typename?: 'StandardStopEntity', isSpecial?: boolean | null, uuid: string, arrivedAt?: any | null, completedAt?: any | null, status: StopStatus, appointmentRequired: boolean, proofOfDeliverySignee?: string | null, paperworkMarkedComplete?: boolean | null, address: { __typename?: 'AddressEntity', uuid: string, name: string, line1: string, line2?: string | null, city: string, state: string, zip: string, country: string, latitude?: number | null, longitude?: number | null, driverInstructions?: string | null, receivingHoursStart?: any | null, receivingHoursEnd?: any | null, specialInstructions?: string | null } } }>, order?: { __typename?: 'StandardOrderEntity', uuid: string, secondaryRefNumber?: string | null, orderInvoiceByDate?: any | null, name: string, createdAt: any, refNumbers: Array<string>, totalCharge: number, ediTransactions: Array<{ __typename?: 'EdiTransactionEntity', code: EdiTransactionCode, status: EdiTransactionStatus }>, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', shipperBillOfLadingNumber?: string | null, uuid: string, masterAirwayBillOfLadingNumber?: string | null, weightUnits: WeightUnits }, shipments: Array<{ __typename?: 'StandardShipmentEntity', uuid: string, documents: Array<{ __typename?: 'DocumentEntity', uuid: string, fileName: string, bucket: string, region: string, key: string, uploadedAt?: any | null, fileType: string, isDeleted: boolean, preSignedGetUrl: string, name?: string | null, type: DocumentType, pageNumber?: number | null, createdAt: any, notes?: string | null, order?: { __typename?: 'StandardOrderEntity', uuid: string, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', shipperBillOfLadingNumber?: string | null } } | null, shipment?: { __typename?: 'StandardOrderEntity', uuid: string } | null, driverFormTemplate?: { __typename?: 'DriverSignableFormTemplateEntity', uuid: string, title: string, formText: string } | null }> }>, billingPartyContact: { __typename?: 'CustomerContactEntity', businessDivision?: { __typename?: 'BusinessDivisionEntity', name: string } | null } } | null, packages: Array<{ __typename?: 'PackageEntity', uuid: string, weight?: number | null, description: string, quantity: number, length?: number | null, width?: number | null, height?: number | null, type?: PackageType | null, class?: number | null, hazmat?: boolean | null, nmfc?: string | null, skuNumber?: string | null, quantityCompletedAtStop?: number | null, reasonUncompletedAtStop?: string | null, packageSpec?: { __typename?: 'PackageSpecEntity', id: string, name: string } | null, warehouseLocation?: { __typename?: 'WarehouseLocationEntity', uuid: string, name: string } | null }>, standardShipmentFields: { __typename?: 'StandardShipmentFieldsEntity', uuid: string, deliveryDate?: any | null, pickupOrDelivery: PickupOrDelivery, dimFactor: number, type: StandardShipmentType, shipmentWeight: number, service?: { __typename?: 'ServiceEntity', uuid: string, name: string, createdAt: any, updatedAt: any, timeInMinutes?: number | null, useApptInRouteOptimization: boolean, markOrdersAsSpecial: boolean, defaultAppointmentStartTime?: any | null, defaultAppointmentEndTime?: any | null, defaultStartNow: boolean, defaultInboundStopType?: StopType | null, defaultOutboundStopType?: StopType | null, defaultPickupPadding?: any | null, defaultDeliveryPadding?: any | null, defaultTotalDuration?: any | null, defaultIsLineHaul: boolean, defaultFulfillmentType?: FulfillmentType | null, isActive: boolean, isExposedToCustomers: boolean, serviceAvailabilityDates: Array<{ __typename?: 'ServiceAvailabilityDateEntity', id: string, dayCategory: SpecialDayOfWeek, enabled: boolean, start: { __typename?: 'PlainTime', hour: number, minute: number }, end: { __typename?: 'PlainTime', hour: number, minute: number } }> } | null }, documents: Array<{ __typename?: 'DocumentEntity', uuid: string, fileName: string, bucket: string, region: string, key: string, uploadedAt?: any | null, fileType: string, isDeleted: boolean, preSignedGetUrl: string, name?: string | null, type: DocumentType, pageNumber?: number | null, createdAt: any, notes?: string | null, order?: { __typename?: 'StandardOrderEntity', uuid: string, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', shipperBillOfLadingNumber?: string | null } } | null, shipment?: { __typename?: 'StandardOrderEntity', uuid: string } | null, driverFormTemplate?: { __typename?: 'DriverSignableFormTemplateEntity', uuid: string, title: string, formText: string } | null }> }> }> };

export type InvoicesForContactQueryVariables = Exact<{
  inConsolidatedInvoice?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  createdAtStartDate?: InputMaybe<Scalars['DateTime']['input']>;
  createdAtEndDate?: InputMaybe<Scalars['DateTime']['input']>;
  invoiceStartDate?: InputMaybe<Scalars['DateTime']['input']>;
  invoiceEndDate?: InputMaybe<Scalars['DateTime']['input']>;
  statuses?: InputMaybe<Array<InvoiceStatus> | InvoiceStatus>;
  searchText?: InputMaybe<Scalars['String']['input']>;
  billingPartyContactUuid?: InputMaybe<Scalars['String']['input']>;
  groupByContact?: InputMaybe<Scalars['Boolean']['input']>;
  uuids?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  isClosed?: InputMaybe<Scalars['Boolean']['input']>;
  emailSendStatus?: InputMaybe<EmailSendStatus>;
  hasZeroBalance?: InputMaybe<Scalars['Boolean']['input']>;
  sorts?: InputMaybe<Array<FindInvoicesSort> | FindInvoicesSort>;
}>;


export type InvoicesForContactQuery = { __typename?: 'Query', invoices: { __typename?: 'InvoiceConnection', totalCount?: number | null, edges: Array<{ __typename?: 'InvoiceEdge', node: { __typename?: 'InvoiceEntity', uuid: string, source: InvoiceSource, name: string, journalNumber: number, status: InvoiceStatus, date: any, createdAt: any, billToContact: { __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string } } }>, pageInfo: { __typename?: 'PageInfo', startCursor?: string | null, endCursor?: string | null, hasPreviousPage: boolean, hasNextPage: boolean } } };

export type InvoicesForInvoiceSelectionQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  statuses?: InputMaybe<Array<InvoiceStatus> | InvoiceStatus>;
  searchText?: InputMaybe<Scalars['String']['input']>;
  billingPartyContactUuid?: InputMaybe<Scalars['String']['input']>;
}>;


export type InvoicesForInvoiceSelectionQuery = { __typename?: 'Query', invoices: { __typename?: 'InvoiceConnection', edges: Array<{ __typename?: 'InvoiceEdge', node: { __typename?: 'InvoiceEntity', uuid: string, name: string, journalNumber: number, date: any, dueDate?: any | null } }>, pageInfo: { __typename?: 'PageInfo', startCursor?: string | null, endCursor?: string | null, hasPreviousPage: boolean, hasNextPage: boolean } } };

export type InvoiceForRegisterReportFragment = { __typename?: 'InvoiceEntity', uuid: string, date: any, name: string, journalNumber: number, status: InvoiceStatus, inConsolidatedInvoice: boolean, dueDate?: any | null, balanceInCents: number, invoiceTotal: string, billToContact: { __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string } };

export type InvoicesForRegisterReportQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  invoiceStartDate?: InputMaybe<Scalars['DateTime']['input']>;
  invoiceEndDate?: InputMaybe<Scalars['DateTime']['input']>;
  statuses?: InputMaybe<Array<InvoiceStatus> | InvoiceStatus>;
  billingPartyContactUuid?: InputMaybe<Scalars['String']['input']>;
}>;


export type InvoicesForRegisterReportQuery = { __typename?: 'Query', invoices: { __typename?: 'InvoiceConnection', totalCount?: number | null, edges: Array<{ __typename?: 'InvoiceEdge', node: { __typename?: 'InvoiceEntity', uuid: string, date: any, name: string, journalNumber: number, status: InvoiceStatus, inConsolidatedInvoice: boolean, dueDate?: any | null, balanceInCents: number, invoiceTotal: string, billToContact: { __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string } } }>, pageInfo: { __typename?: 'PageInfo', startCursor?: string | null, endCursor?: string | null, hasPreviousPage: boolean, hasNextPage: boolean } } };

export type InvoicesMetadataByUuidsQueryVariables = Exact<{
  uuids: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type InvoicesMetadataByUuidsQuery = { __typename?: 'Query', invoicesByUuids: Array<{ __typename?: 'InvoiceEntity', uuid: string, name: string, journalNumber: number, billToContact: { __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string } }> };

export type InvoicesWithOrdersQueryVariables = Exact<{
  inConsolidatedInvoice?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  createdAtStartDate?: InputMaybe<Scalars['DateTime']['input']>;
  createdAtEndDate?: InputMaybe<Scalars['DateTime']['input']>;
  invoiceStartDate?: InputMaybe<Scalars['DateTime']['input']>;
  invoiceEndDate?: InputMaybe<Scalars['DateTime']['input']>;
  statuses?: InputMaybe<Array<InvoiceStatus> | InvoiceStatus>;
  searchText?: InputMaybe<Scalars['String']['input']>;
  billingPartyContactUuid?: InputMaybe<Scalars['String']['input']>;
  groupByContact?: InputMaybe<Scalars['Boolean']['input']>;
  uuids?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  isClosed?: InputMaybe<Scalars['Boolean']['input']>;
  emailSendStatus?: InputMaybe<EmailSendStatus>;
  hasZeroBalance?: InputMaybe<Scalars['Boolean']['input']>;
  sorts?: InputMaybe<Array<FindInvoicesSort> | FindInvoicesSort>;
}>;


export type InvoicesWithOrdersQuery = { __typename?: 'Query', invoices: { __typename?: 'InvoiceConnection', totalCount?: number | null, edges: Array<{ __typename?: 'InvoiceEdge', node: { __typename?: 'InvoiceEntity', uuid: string, source: InvoiceSource, name: string, journalNumber: number, status: InvoiceStatus, date: any, createdAt: any, billToContact: { __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string } } }>, pageInfo: { __typename?: 'PageInfo', startCursor?: string | null, endCursor?: string | null, hasPreviousPage: boolean, hasNextPage: boolean } } };

export type MoveShipmentsBetweenInvoicesMutationVariables = Exact<{
  moveShipmentsBetweenInvoicesInput: MoveShipmentsBetweenInvoicesInput;
}>;


export type MoveShipmentsBetweenInvoicesMutation = { __typename?: 'Mutation', moveShipmentsBetweenInvoices: { __typename?: 'MoveShipmentsBetweenInvoicesIncompleteOperationOutput', inputShipmentUuids: Array<string>, additionalShipmentUuidsToMove: Array<string>, missingOrders: Array<{ __typename?: 'MissingOrderForInvoiceMoveEntity', uuid: string, name: string }> } | { __typename?: 'MoveShipmentsBetweenInvoicesSuccessOutput', newInvoiceUuid: string, movedShipmentUuids: Array<string> } | { __typename?: 'MutationErrorOutput', message: string } };

export type MoveShipmentsToInvoiceMutationVariables = Exact<{
  moveShipmentsToInvoiceInput: MoveShipmentsToInvoiceInput;
}>;


export type MoveShipmentsToInvoiceMutation = { __typename?: 'Mutation', moveShipmentsToInvoice: { __typename?: 'MoveShipmentsToInvoiceOutput', errors?: Array<string> | null } };

export type NetSalesSummaryReportQueryVariables = Exact<{
  netSalesSummaryReportInput: NetSalesSummaryReportInput;
}>;


export type NetSalesSummaryReportQuery = { __typename?: 'Query', netSalesSummaryReport: { __typename?: 'NetSalesSummaryReportOutput', contactRows: Array<{ __typename?: 'NetSalesSummaryReportOutputRow', contactUuid: string, contactName: string, pieces: number, weight: number, dimWeight: number, openInvoiesTotalInCents: number, adjustmentsInCents: number, netSalesInCents: number }>, reportTotal: { __typename?: 'NetSalesSummaryReportOutputRow', contactUuid: string, contactName: string, pieces: number, weight: number, dimWeight: number, openInvoiesTotalInCents: number, adjustmentsInCents: number, netSalesInCents: number } } };

export type OrderProratedWithFragment = { __typename?: 'StandardOrderEntity', uuid: string, name: string, status: OrderStatus, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', shipperBillOfLadingNumber?: string | null } };

export type PaginatedOrdersByInvoiceQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  invoiceUuid: Scalars['String']['input'];
  searchText?: InputMaybe<Scalars['String']['input']>;
  sortByShipperBillOfLadingNumberAsc?: InputMaybe<Scalars['Boolean']['input']>;
  sorts?: InputMaybe<Array<FindOrdersOnInvoiceSort> | FindOrdersOnInvoiceSort>;
}>;


export type PaginatedOrdersByInvoiceQuery = { __typename?: 'Query', paginatedOrdersByInvoice: { __typename?: 'OrderConnection', totalCount?: number | null, edges: Array<{ __typename?: 'OrderEdge', node: { __typename?: 'StandardOrderEntity', uuid: string, createdAt: any, name: string, missingDocuments: Array<DocumentType>, appliedAmount: number, balanceInCents: number, secondaryRefNumber?: string | null, pieceCountFromPackages: number, weight: number, shipments: Array<{ __typename?: 'StandardShipmentEntity', uuid: string, overridePackageWeight: boolean, shipmentType: ShipmentType, status: ShipmentStatus, name: string, shipmentCharges: { __typename?: 'ShipmentChargeEntity', totalCharge: number, totalFreightCharge: number, totalFuelCharge: number }, invoice?: { __typename?: 'InvoiceEntity', uuid: string } | null, shipperAddress?: { __typename?: 'AddressEntity', uuid: string, name: string, line1: string, line2?: string | null, city: string, state: string, zip: string, country: string, latitude?: number | null, longitude?: number | null, driverInstructions?: string | null, receivingHoursStart?: any | null, receivingHoursEnd?: any | null, specialInstructions?: string | null } | null, standardShipmentFields: { __typename?: 'StandardShipmentFieldsEntity', pickupOrDelivery: PickupOrDelivery }, legs: Array<{ __typename?: 'LegEntity', uuid: string, endStop: { __typename?: 'StandardStopEntity', completedAt?: any | null, paperworkMarkedComplete?: boolean | null, settlementDeductionName?: string | null, settlementDeductionFlatRate?: number | null, settlementDeductionPercentageRate?: number | null, stopType?: StopType | null, address: { __typename?: 'AddressEntity', uuid: string, name: string, line1: string, line2?: string | null, city: string, state: string, zip: string, country: string, latitude?: number | null, longitude?: number | null, driverInstructions?: string | null, receivingHoursStart?: any | null, receivingHoursEnd?: any | null, specialInstructions?: string | null } } }>, charges: Array<{ __typename?: 'CustomChargeEntity', uuid: string, name: string, quantity: number, description?: string | null, rate: number, total: number, settlementFlatRate?: number | null, settlementPercentageRate?: number | null, postedFuelSurchargeRate?: number | null, customChargeBillingMethod: CustomChargeBillingMethod, accessorialTemplate?: { __typename: 'SkidBasedAccessorialEntity', uuid: string, name: string, invoiceDisplayName?: string | null } | { __typename: 'SpecialAccessorialEntity', uuid: string, name: string, invoiceDisplayName?: string | null } | { __typename: 'StandardAccessorialEntity', uuid: string, name: string, invoiceDisplayName?: string | null } | { __typename: 'UnitBasedAccessorialEntity', uuid: string, name: string, invoiceDisplayName?: string | null } | { __typename: 'WaitTimeAccessorialEntity', uuid: string, name: string, invoiceDisplayName?: string | null } | { __typename: 'WeightBasedAccessorialEntity', uuid: string, name: string, invoiceDisplayName?: string | null } | { __typename: 'ZoneBasedAccessorialEntity', uuid: string, name: string, invoiceDisplayName?: string | null } | null } | { __typename?: 'FreightChargeEntity', uuid: string, billingMethod: FreightBillingMethod, rate: number, description?: string | null, quantity: number, settlementFlatRate?: number | null, settlementPercentageRate?: number | null, tariff?: { __typename?: 'TariffEntity', uuid: string, tariffZone: { __typename?: 'TariffZoneEntity', name: string, type: TariffZoneType } } | null, fuelCharge?: { __typename?: 'FuelChargeEntity', surchargeRate: number, flatRate: number, type: FuelBillingMethod, uuid: string, settlementFlatRate?: number | null, settlementPercentageRate?: number | null } | null }> }>, documents: Array<{ __typename?: 'DocumentEntity', type: DocumentType }>, paperwork: { __typename?: 'OrderPaperworkEntity', paperworkComplete: boolean, paperworkMarkedCompleteOverride?: boolean | null, attachedDocuments?: Array<DocumentType> | null, missingDocuments?: Array<DocumentType> | null }, orderPaymentMappings: Array<{ __typename?: 'PaymentToOrderMappingEntity', uuid: string, amountInCents: number, payment: { __typename?: 'PaymentEntity', paymentType: PaymentType, contact: { __typename?: 'CustomerContactEntity', displayName: string, uuid: string } | { __typename?: 'ThirdPartyContactEntity', displayName: string, uuid: string } } }>, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', uuid: string, shipperBillOfLadingNumber?: string | null, masterAirwayBillOfLadingNumber?: string | null, weightUnits: WeightUnits }, orderComments: Array<{ __typename?: 'OrderCommentEntity', uuid: string, comment: string, showOnInvoice?: boolean | null }>, endStop?: { __typename?: 'StandardStopEntity', serviceDate?: any | null, address: { __typename?: 'AddressEntity', name: string } } | null } }>, pageInfo: { __typename?: 'PageInfo', startCursor?: string | null, endCursor?: string | null, hasNextPage: boolean, hasPreviousPage: boolean } } };

export type AllInvoicesForPaymentApplicationQueryVariables = Exact<{
  billingPartyContactUuid?: InputMaybe<Scalars['String']['input']>;
  masterAccountUuid?: InputMaybe<Scalars['String']['input']>;
}>;


export type AllInvoicesForPaymentApplicationQuery = { __typename?: 'Query', invoices: { __typename?: 'InvoiceConnection', edges: Array<{ __typename?: 'InvoiceEdge', node: { __typename?: 'InvoiceEntity', uuid: string, name: string, journalNumber: number } }> } };

export type AverageDaysToPayReportDataFragment = { __typename?: 'AverageDaysToPayForContactEntity', contactUuid: string, displayName: string, contactReferenceNumber?: string | null, averageDaysToPay90: number, averageDaysToPay180: number, averageDaysToPay270: number, averageDaysToPay360: number, averageDaysToPay720: number, averageDaysToPayAll: number };

export type AverageDaysToPayReportQueryVariables = Exact<{ [key: string]: never; }>;


export type AverageDaysToPayReportQuery = { __typename?: 'Query', averageDaysToPayReport: Array<{ __typename?: 'AverageDaysToPayForContactEntity', contactUuid: string, displayName: string, contactReferenceNumber?: string | null, averageDaysToPay90: number, averageDaysToPay180: number, averageDaysToPay270: number, averageDaysToPay360: number, averageDaysToPay720: number, averageDaysToPayAll: number }> };

export type ContactBalancesByOrderUuidQueryVariables = Exact<{
  uuid: Scalars['String']['input'];
}>;


export type ContactBalancesByOrderUuidQuery = { __typename?: 'Query', order?: { __typename?: 'StandardOrderEntity', uuid: string, billingPartyContact: { __typename?: 'CustomerContactEntity', creditHoldLimitInCents?: number | null, enableCreditHold?: boolean | null, uuid: string, displayName: string, contactOpenInvoiceValue: number, postedInvoicesTotalOpenBalance: number, postedInvoicesTotalClosedBalance: number, paymentsAppliedToContactInvoices: number, unappliedPayments: number, creditsAppliedToContactInvoices: number, unappliedCredits?: number | null, debitsAppliedToContactInvoices: number, unappliedDebits: number, balance: number }, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', shipperBillOfLadingNumber?: string | null } } | null };

export type ContactBalancesQueryVariables = Exact<{
  uuid: Scalars['String']['input'];
}>;


export type ContactBalancesQuery = { __typename?: 'Query', contact: { __typename?: 'CustomerContactEntity', creditHoldLimitInCents?: number | null, enableCreditHold?: boolean | null, uuid: string, displayName: string, contactOpenInvoiceValue: number, postedInvoicesTotalOpenBalance: number, postedInvoicesTotalClosedBalance: number, paymentsAppliedToContactInvoices: number, unappliedPayments: number, creditsAppliedToContactInvoices: number, unappliedCredits?: number | null, debitsAppliedToContactInvoices: number, unappliedDebits: number, balance: number } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string, contactOpenInvoiceValue: number, postedInvoicesTotalOpenBalance: number, postedInvoicesTotalClosedBalance: number, paymentsAppliedToContactInvoices: number, unappliedPayments: number, creditsAppliedToContactInvoices: number, unappliedCredits?: number | null, debitsAppliedToContactInvoices: number, unappliedDebits: number, balance: number } };

type ContactWithBalances_CustomerContactEntity_Fragment = { __typename?: 'CustomerContactEntity', creditHoldLimitInCents?: number | null, enableCreditHold?: boolean | null, uuid: string, displayName: string, contactOpenInvoiceValue: number, postedInvoicesTotalOpenBalance: number, postedInvoicesTotalClosedBalance: number, paymentsAppliedToContactInvoices: number, unappliedPayments: number, creditsAppliedToContactInvoices: number, unappliedCredits?: number | null, debitsAppliedToContactInvoices: number, unappliedDebits: number, balance: number };

type ContactWithBalances_ThirdPartyContactEntity_Fragment = { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string, contactOpenInvoiceValue: number, postedInvoicesTotalOpenBalance: number, postedInvoicesTotalClosedBalance: number, paymentsAppliedToContactInvoices: number, unappliedPayments: number, creditsAppliedToContactInvoices: number, unappliedCredits?: number | null, debitsAppliedToContactInvoices: number, unappliedDebits: number, balance: number };

export type ContactWithBalancesFragment = ContactWithBalances_CustomerContactEntity_Fragment | ContactWithBalances_ThirdPartyContactEntity_Fragment;

export type CreatePaymentMutationVariables = Exact<{
  createPaymentInput: CreatePaymentInput;
}>;


export type CreatePaymentMutation = { __typename?: 'Mutation', createPayment: { __typename?: 'PaymentEntity', uuid: string } };

export type DeletePaymentMutationVariables = Exact<{
  uuid: Scalars['String']['input'];
}>;


export type DeletePaymentMutation = { __typename?: 'Mutation', deletePayment: { __typename?: 'PaymentEntity', uuid: string } };

export type EditPaymentAmountMutationVariables = Exact<{
  editPaymentAmount: EditPaymentAmountInput;
}>;


export type EditPaymentAmountMutation = { __typename?: 'Mutation', editPaymentAmount: { __typename?: 'PaymentEntity', uuid: string } };

export type OrderAmountsToPayForInvoiceQueryVariables = Exact<{
  invoiceUuids: Array<Scalars['String']['input']> | Scalars['String']['input'];
  amountInCents: Scalars['Float']['input'];
}>;


export type OrderAmountsToPayForInvoiceQuery = { __typename?: 'Query', orderAmountsToPayForInvoice: Array<{ __typename?: 'OrderToChargeEntity', amountInCents: number, orderUuid: string, invoiceUuid?: string | null, lineBalanceInCents: number, orderTotalInCents: number, currentBalanceInCents: number }> };

export type OrdersByUuidsForPaymentStatsQueryVariables = Exact<{
  uuids: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type OrdersByUuidsForPaymentStatsQuery = { __typename?: 'Query', ordersByUuids: Array<{ __typename?: 'StandardOrderEntity', uuid: string, invoice?: { __typename?: 'InvoiceEntity', balanceInCents: number, invoiceTotal: string } | null }> };

export type OrdersForPaymentFragment = { __typename?: 'StandardOrderEntity', uuid: string, name: string, secondaryRefNumber?: string | null, appliedAmount: number, totalCharge: number, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', shipperBillOfLadingNumber?: string | null, masterAirwayBillOfLadingNumber?: string | null }, invoice?: { __typename?: 'InvoiceEntity', uuid: string, name: string, date: any, journalNumber: number } | null };

export type InvoiceForPaymentFragment = { __typename?: 'InvoiceEntity', uuid: string, name: string, date: any, journalNumber: number };

export type OrdersForPaymentsQueryVariables = Exact<{
  contactUuid: Scalars['String']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  searchText?: InputMaybe<Scalars['String']['input']>;
  invoiceUuid?: InputMaybe<Scalars['String']['input']>;
  invoiceStartDate?: InputMaybe<Scalars['DateTime']['input']>;
  invoiceEndDate?: InputMaybe<Scalars['DateTime']['input']>;
  filterOutZeroBalance?: InputMaybe<Scalars['Boolean']['input']>;
  currentPaymentUuid?: InputMaybe<Scalars['String']['input']>;
  includeTotalCount?: InputMaybe<Scalars['Boolean']['input']>;
  includeTotalCountsByInvoice?: InputMaybe<Scalars['Boolean']['input']>;
  groupOrdersBy?: InputMaybe<GroupOrdersForPaymentsBy>;
  sorts?: InputMaybe<Array<OrdersForPaymentsSort> | OrdersForPaymentsSort>;
}>;


export type OrdersForPaymentsQuery = { __typename?: 'Query', ordersForPayments: { __typename?: 'OrderConnection', totalCount?: number | null, groupedCountsByInvoice?: Array<{ __typename?: 'GroupedCounts', groupUuid: string, count: number }> | null, edges: Array<{ __typename?: 'OrderEdge', node: { __typename?: 'StandardOrderEntity', uuid: string, name: string, secondaryRefNumber?: string | null, appliedAmount: number, totalCharge: number, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', shipperBillOfLadingNumber?: string | null, masterAirwayBillOfLadingNumber?: string | null }, invoice?: { __typename?: 'InvoiceEntity', uuid: string, name: string, date: any, journalNumber: number } | null } }>, pageInfo: { __typename?: 'PageInfo', startCursor?: string | null, endCursor?: string | null, hasNextPage: boolean, hasPreviousPage: boolean } } };

export type OutstandingInvoicesForCustomerQueryVariables = Exact<{
  contactUuid: Scalars['String']['input'];
}>;


export type OutstandingInvoicesForCustomerQuery = { __typename?: 'Query', outstandingInvoicesForCustomer?: Array<{ __typename?: 'InvoiceEntity', journalNumber: number, name: string }> | null };

export type PaymentByUuidQueryVariables = Exact<{
  uuid: Scalars['String']['input'];
}>;


export type PaymentByUuidQuery = { __typename?: 'Query', paymentByUuid?: { __typename?: 'PaymentEntity', uuid: string, amountInCents: number, comment?: string | null, referenceNumber: string, paymentType: PaymentType, paymentRail?: PaymentRail | null, date: any, glTerminal?: { __typename?: 'TerminalEntity', uuid: string, name: string } | null, creditType?: { __typename?: 'CreditTypeEntity', uuid: string, name: string } | null, paymentToOrderMappings: Array<{ __typename?: 'PaymentToOrderMappingEntity', amountInCents: number, order: { __typename?: 'StandardOrderEntity', uuid: string, invoice?: { __typename?: 'InvoiceEntity', uuid: string } | null } }> } | null };

export type PaymentForCheckRegisterReportFragment = { __typename?: 'PaymentForCheckRegisterReportEntity', paymentUuid: string, referenceNumber: string, paymentDate?: any | null, terminalCodes?: Array<string> | null, contactDisplayName?: string | null, contactReferenceNumber?: string | null, comment?: string | null, amountInCents?: number | null };

export type PaymentForInvoiceFragment = { __typename?: 'PaymentEntity', uuid: string, date: any, amountInCents: number, referenceNumber: string, paymentType: PaymentType, paymentRail?: PaymentRail | null, creditType?: { __typename?: 'CreditTypeEntity', uuid: string, name: string, color?: string | null, generalLedgerCode?: { __typename?: 'GeneralLedgerCodeEntity', code: string, description: string, id: string } | null } | null, contact: { __typename?: 'CustomerContactEntity', uuid: string, displayName: string, masterAccount?: { __typename?: 'MasterAccountEntity', uuid: string } | null } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string, masterAccount?: { __typename?: 'MasterAccountEntity', uuid: string } | null } };

export type PaymentForReportFragment = { __typename?: 'PaymentEntity', uuid: string, amountInCents: number, referenceNumber: string, date: any, paymentType: PaymentType, paymentRail?: PaymentRail | null, comment?: string | null, contact: { __typename?: 'CustomerContactEntity', uuid: string, displayName: string, contactReferenceNumber?: string | null } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string, contactReferenceNumber?: string | null }, creditType?: { __typename?: 'CreditTypeEntity', name: string } | null, paymentToOrderMappings: Array<{ __typename?: 'PaymentToOrderMappingEntity', order: { __typename?: 'StandardOrderEntity', shipments: Array<{ __typename?: 'StandardShipmentEntity', legs: Array<{ __typename?: 'LegEntity', endStop: { __typename?: 'StandardStopEntity', terminal?: { __typename?: 'TerminalEntity', uuid: string, code: string } | null } }> }> } }> };

export type PaymentFragment = { __typename?: 'PaymentEntity', uuid: string, amountInCents: number, referenceNumber: string, date: any, comment?: string | null, paymentType: PaymentType, paymentRail?: PaymentRail | null, unappliedAmountInCents: number, creditType?: { __typename?: 'CreditTypeEntity', uuid: string, name: string, color?: string | null, generalLedgerCode?: { __typename?: 'GeneralLedgerCodeEntity', code: string, description: string, id: string } | null } | null, contact: { __typename?: 'CustomerContactEntity', uuid: string, masterAccount?: { __typename?: 'MasterAccountEntity', uuid: string } | null } | { __typename?: 'ThirdPartyContactEntity', uuid: string, masterAccount?: { __typename?: 'MasterAccountEntity', uuid: string } | null }, glTerminal?: { __typename?: 'TerminalEntity', name: string } | null, paymentToOrderMappings: Array<{ __typename?: 'PaymentToOrderMappingEntity', amountInCents: number, order: { __typename?: 'StandardOrderEntity', uuid: string, totalCharge: number, invoice?: { __typename?: 'InvoiceEntity', name: string, journalNumber: number, uuid: string } | null, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', shipperBillOfLadingNumber?: string | null } } }> };

export type PaymentsByContactUuidQueryVariables = Exact<{
  args: FindPaymentsV2Args;
}>;


export type PaymentsByContactUuidQuery = { __typename?: 'Query', paymentsV2: { __typename?: 'PaymentConnection', totalCount?: number | null, edges: Array<{ __typename?: 'PaymentEdge', cursor: string, node: { __typename?: 'PaymentEntity', uuid: string, amountInCents: number, referenceNumber: string, date: any, comment?: string | null, paymentType: PaymentType, paymentRail?: PaymentRail | null, unappliedAmountInCents: number, creditType?: { __typename?: 'CreditTypeEntity', uuid: string, name: string, color?: string | null, generalLedgerCode?: { __typename?: 'GeneralLedgerCodeEntity', code: string, description: string, id: string } | null } | null, contact: { __typename?: 'CustomerContactEntity', uuid: string, masterAccount?: { __typename?: 'MasterAccountEntity', uuid: string } | null } | { __typename?: 'ThirdPartyContactEntity', uuid: string, masterAccount?: { __typename?: 'MasterAccountEntity', uuid: string } | null }, glTerminal?: { __typename?: 'TerminalEntity', name: string } | null, paymentToOrderMappings: Array<{ __typename?: 'PaymentToOrderMappingEntity', amountInCents: number, order: { __typename?: 'StandardOrderEntity', uuid: string, totalCharge: number, invoice?: { __typename?: 'InvoiceEntity', name: string, journalNumber: number, uuid: string } | null, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', shipperBillOfLadingNumber?: string | null } } }> } }>, pageInfo: { __typename?: 'PageInfo', startCursor?: string | null, endCursor?: string | null, hasNextPage: boolean, hasPreviousPage: boolean } } };

export type PaymentsByInvoiceUuidQueryVariables = Exact<{
  uuid: Scalars['String']['input'];
}>;


export type PaymentsByInvoiceUuidQuery = { __typename?: 'Query', paymentsByInvoiceUuid: Array<{ __typename?: 'PaymentEntity', uuid: string, date: any, amountInCents: number, referenceNumber: string, paymentType: PaymentType, paymentRail?: PaymentRail | null, creditType?: { __typename?: 'CreditTypeEntity', uuid: string, name: string, color?: string | null, generalLedgerCode?: { __typename?: 'GeneralLedgerCodeEntity', code: string, description: string, id: string } | null } | null, contact: { __typename?: 'CustomerContactEntity', uuid: string, displayName: string, masterAccount?: { __typename?: 'MasterAccountEntity', uuid: string } | null } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string, masterAccount?: { __typename?: 'MasterAccountEntity', uuid: string } | null } }> };

export type PaymentsForCheckRegisterReportOldQueryVariables = Exact<{
  args: FindPaymentsV2Args;
}>;


export type PaymentsForCheckRegisterReportOldQuery = { __typename?: 'Query', paymentsV2: { __typename?: 'PaymentConnection', edges: Array<{ __typename?: 'PaymentEdge', cursor: string, node: { __typename?: 'PaymentEntity', uuid: string, amountInCents: number, referenceNumber: string, date: any, paymentType: PaymentType, paymentRail?: PaymentRail | null, comment?: string | null, contact: { __typename?: 'CustomerContactEntity', uuid: string, displayName: string, contactReferenceNumber?: string | null } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string, contactReferenceNumber?: string | null }, creditType?: { __typename?: 'CreditTypeEntity', name: string } | null, paymentToOrderMappings: Array<{ __typename?: 'PaymentToOrderMappingEntity', order: { __typename?: 'StandardOrderEntity', shipments: Array<{ __typename?: 'StandardShipmentEntity', legs: Array<{ __typename?: 'LegEntity', endStop: { __typename?: 'StandardStopEntity', terminal?: { __typename?: 'TerminalEntity', uuid: string, code: string } | null } }> }> } }> } }> } };

export type PaymentsForCheckRegisterReportQueryVariables = Exact<{
  args: FindPaymentsV2Args;
}>;


export type PaymentsForCheckRegisterReportQuery = { __typename?: 'Query', checkRegisterReport: Array<{ __typename?: 'PaymentForCheckRegisterReportEntity', paymentUuid: string, referenceNumber: string, paymentDate?: any | null, terminalCodes?: Array<string> | null, contactDisplayName?: string | null, contactReferenceNumber?: string | null, comment?: string | null, amountInCents?: number | null }> };

export type UpdatePaymentMutationVariables = Exact<{
  updatePaymentInput: UpdatePaymentInput;
}>;


export type UpdatePaymentMutation = { __typename?: 'Mutation', updatePayment: { __typename?: 'PaymentEntity', uuid: string } };

export type PreviewBatchAddShipmentsToInvoicesMultipleQueryVariables = Exact<{
  batchAddShipmentsToInvoicesInputMultiple: BatchAddShipmentsToInvoicesInputMultiple;
}>;


export type PreviewBatchAddShipmentsToInvoicesMultipleQuery = { __typename?: 'Query', previewBatchAddShipmentsToInvoicesMultiple: Array<{ __typename?: 'BatchAddShipmentsToInvoicePreview', contactName: string, contactUuid: string, billingCycleDuration: BillingCycleDuration, existingInvoiceAdds: Array<{ __typename?: 'InvoiceAdd', uuid?: string | null, name?: string | null, shipmentUuids: Array<string> }>, newInvoiceAdds: Array<{ __typename?: 'InvoiceAdd', name?: string | null, shipmentUuids: Array<string> }> }> };

export type OutstandingOrderQueryVariables = Exact<{
  uuid: Scalars['String']['input'];
}>;


export type OutstandingOrderQuery = { __typename?: 'Query', standardOrder: { __typename?: 'StandardOrderEntity', updatedAt: any, orderSegmentType: OrderSegmentType, fulfillmentType?: FulfillmentType | null, isOverdue: boolean, detailedStatusV2?: OrderDetailedStatus | null, isCrossDock?: boolean | null, issueReason?: string | null, personName?: string | null, personPhoneNumber?: string | null, personEmail?: string | null, name: string, notes: string, onHand?: boolean | null, dateMarkedOnHand?: any | null, refNumbers: Array<string>, orderConsolidationType: OrderConsolidationType, orderInvoiceByDate?: any | null, paymentMethod?: PaymentMethod | null, source: OrderSource, status: OrderStatus, uuid: string, isDraftOrder: boolean, chargeableWeightCubicMeters?: any | null, totalSkids?: number | null, isReweighed?: boolean | null, secondaryRefNumber?: string | null, lockSecondaryRefNumber: boolean, tertiaryRefNumber?: string | null, quaternaryRefNumber?: string | null, quinaryRefNumber?: string | null, lineHaulCompletedDate: any, consolidatedShipmentString?: string | null, shouldBillIndividually: boolean, enableLineHaul: boolean, inBond?: boolean | null, hazmat?: boolean | null, tags: Array<{ __typename?: 'TagEntity', uuid: string, value: string, color?: string | null }>, thirdPartyBrokers: Array<{ __typename?: 'ThirdPartyBrokerEntity', uuid: string, name: string }>, service?: { __typename?: 'ServiceEntity', uuid: string, name: string } | null, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', uuid: string, shipperBillOfLadingNumber?: string | null, lockShipperBillOfLadingNumber: boolean, masterAirwayBillOfLadingNumber?: string | null, dimFactor?: number | null, measurementUnits: MeasurementUnits, weightUnits: WeightUnits }, documents: Array<{ __typename?: 'DocumentEntity', uuid: string, fileName: string, bucket: string, region: string, key: string, uploadedAt?: any | null, fileType: string, isDeleted: boolean, preSignedGetUrl: string, name?: string | null, type: DocumentType, pageNumber?: number | null, createdAt: any, notes?: string | null, order?: { __typename?: 'StandardOrderEntity', uuid: string, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', shipperBillOfLadingNumber?: string | null } } | null, shipment?: { __typename?: 'StandardOrderEntity', uuid: string } | null, driverFormTemplate?: { __typename?: 'DriverSignableFormTemplateEntity', uuid: string, title: string, formText: string } | null }>, paperwork: { __typename?: 'OrderPaperworkEntity', paperworkComplete: boolean, paperworkMarkedCompleteOverride?: boolean | null, attachedDocuments?: Array<DocumentType> | null, missingDocuments?: Array<DocumentType> | null }, billingPartyContact: { __typename?: 'CustomerContactEntity', uuid: string, displayName: string, numberOfOrdersPerInvoice?: number | null, invoiceTimePeriodSplit?: TimePeriod | null }, billingPartyContactStation?: { __typename?: 'ContactStationEntity', id: string, name: string, defaultPerson?: { __typename?: 'PersonEntity', id: string, firstName: string, lastName: string, phone?: string | null, email?: string | null } | null } | null, packages: Array<{ __typename?: 'PackageEntity', uuid: string, height?: number | null, length?: number | null, quantity: number, type?: PackageType | null, weight?: number | null, width?: number | null, description: string, packageSpec?: { __typename?: 'PackageSpecEntity', id: string, name: string } | null }>, shipments: Array<{ __typename?: 'StandardShipmentEntity', uuid: string, shouldBillIndividually: boolean, shouldUseDimWeight: boolean, overridePackageWeight: boolean, name: string, hideFromBilling: boolean, hasSignedPOD: boolean, status: ShipmentStatus, shipmentType: ShipmentType, documents: Array<{ __typename?: 'DocumentEntity', uuid: string, fileName: string, fileType: string, preSignedGetUrl: string, type: DocumentType, notes?: string | null, name?: string | null }>, fields?: { __typename?: 'StandardShipmentFieldsEntity', uuid: string, deadlineDate?: any | null, deadlineType?: DeadlineType | null, deliveryDate?: any | null, dimFactor: number, pickupOrDelivery: PickupOrDelivery, outboundMethod?: OutboundMethod | null, inboundMethod?: InboundMethod | null, type: StandardShipmentType, service?: { __typename?: 'ServiceEntity', uuid: string, name: string, createdAt: any, updatedAt: any, timeInMinutes?: number | null, useApptInRouteOptimization: boolean, markOrdersAsSpecial: boolean, defaultAppointmentStartTime?: any | null, defaultAppointmentEndTime?: any | null, defaultStartNow: boolean, defaultInboundStopType?: StopType | null, defaultOutboundStopType?: StopType | null, defaultPickupPadding?: any | null, defaultDeliveryPadding?: any | null, defaultTotalDuration?: any | null, defaultIsLineHaul: boolean, defaultFulfillmentType?: FulfillmentType | null, isActive: boolean, isExposedToCustomers: boolean, serviceAvailabilityDates: Array<{ __typename?: 'ServiceAvailabilityDateEntity', id: string, dayCategory: SpecialDayOfWeek, enabled: boolean, start: { __typename?: 'PlainTime', hour: number, minute: number }, end: { __typename?: 'PlainTime', hour: number, minute: number } }> } | null } | null, legs: Array<{ __typename?: 'LegEntity', uuid: string, miles?: number | null, endStop: { __typename?: 'StandardStopEntity', uuid: string, createdAt: any, specialInstructions?: string | null, stopType?: StopType | null, appointmentRequired: boolean, deadlineTime?: any | null, proofOfDeliverySignee?: string | null, arrivedAt?: any | null, completedAt?: any | null, inboundMethod?: InboundMethod | null, expectedInboundArrivalDate?: any | null, outboundMethod?: OutboundMethod | null, driverCompletedAt?: any | null, notes?: string | null, serviceDate?: any | null, status: StopStatus, appointmentTime?: any | null, endAppointmentTime?: any | null, isSpecial?: boolean | null, settlementDeductionFlatRate?: number | null, settlementDeductionName?: string | null, settlementDeductionPercentageRate?: number | null, standardStopType?: StandardStopType | null, paperworkMarkedComplete?: boolean | null, sentToAgentAt?: any | null, confirmedByAgentAt?: any | null, address: { __typename?: 'AddressEntity', internalNotes?: string | null, iataCode?: string | null, uuid: string, name: string, line1: string, line2?: string | null, city: string, state: string, zip: string, country: string, latitude?: number | null, longitude?: number | null, driverInstructions?: string | null, receivingHoursStart?: any | null, receivingHoursEnd?: any | null, specialInstructions?: string | null }, serviceDateV2?: { __typename?: 'PlainDate', iso8601: string } | null, routeSlot?: { __typename?: 'RouteSlotEntity', uuid: string, route?: { __typename?: 'RouteEntity', uuid: string, date: any, name: string, slots: Array<{ __typename?: 'RouteSlotEntity', uuid: string }>, drivers: Array<{ __typename?: 'DriverEntity', uuid: string, firstName: string, lastName: string, driverType?: DriverType | null, agent?: { __typename?: 'AgentFieldsEntity', uuid: string, name: string } | null }>, equipments: Array<{ __typename?: 'EquipmentEntity', uuid: string, name: string }> } | null } | null, terminal?: { __typename?: 'TerminalEntity', name: string, code: string, uuid: string, isActive: boolean, address: { __typename?: 'AddressEntity', line1: string, line2?: string | null, city: string, state: string, zip: string, uuid: string, name: string, latitude?: number | null, longitude?: number | null }, startForTerminalLanes: Array<{ __typename?: 'TerminalLaneEntity', id: string, endTerminal: { __typename?: 'TerminalEntity', uuid: string, code: string, name: string } }>, agent?: { __typename?: 'AgentFieldsEntity', name: string } | null } | null, stopDriverMaps: Array<{ __typename?: 'StopDriverMapEntity', uuid: string, name?: string | null, enableDriverSettlement?: boolean | null, revenuePercentageRate?: number | null, revenueFlatRate?: number | null, driverPayoutFinalized: boolean, driver: { __typename?: 'DriverEntity', firstName: string, lastName: string, uuid: string, driverType?: DriverType | null, driverReferenceNumber?: string | null, defaultFuelSettlementPercentageRate?: number | null, user: { __typename?: 'UserEntity', name?: string | null }, defaultVehicle?: { __typename?: 'EquipmentEntity', uuid: string } | null, terminal?: { __typename?: 'TerminalEntity', uuid: string, name: string } | null, qualifications: Array<{ __typename?: 'DriverQualificationEntity', id: string }> }, driverSettlementBill?: { __typename?: 'DriverSettlementBillEntity', uuid: string } | null, stop: { __typename?: 'StandardStopEntity', uuid: string, completedAt?: any | null, settlementDeductionName?: string | null, settlementDeductionFlatRate?: number | null, settlementDeductionPercentageRate?: number | null } }> }, previousStopAttempts: Array<{ __typename?: 'StandardStopEntity', stopDriverMaps: Array<{ __typename?: 'StopDriverMapEntity', uuid: string, name?: string | null, enableDriverSettlement?: boolean | null, revenuePercentageRate?: number | null, revenueFlatRate?: number | null, driverPayoutFinalized: boolean, driver: { __typename?: 'DriverEntity', firstName: string, lastName: string, uuid: string, driverType?: DriverType | null, driverReferenceNumber?: string | null, defaultFuelSettlementPercentageRate?: number | null, user: { __typename?: 'UserEntity', name?: string | null }, defaultVehicle?: { __typename?: 'EquipmentEntity', uuid: string } | null, terminal?: { __typename?: 'TerminalEntity', uuid: string, name: string } | null, qualifications: Array<{ __typename?: 'DriverQualificationEntity', id: string }> }, driverSettlementBill?: { __typename?: 'DriverSettlementBillEntity', uuid: string } | null, stop: { __typename?: 'StandardStopEntity', uuid: string, completedAt?: any | null, settlementDeductionName?: string | null, settlementDeductionFlatRate?: number | null, settlementDeductionPercentageRate?: number | null } }> }> }>, customCharges: Array<{ __typename?: 'CustomChargeEntity', uuid: string, rate: number, description?: string | null, total: number, totalAmountCents?: number | null, postedAmountUsdCents?: number | null, authoCode?: string | null, quantity: number, billingMethod: CustomChargeBillingMethod, isAutoApplied: boolean, name: string, fuelSurchargeRate?: number | null, postedFuelSurchargeRate?: number | null, zoneBasedAccessorialChargeGroupUuid?: string | null, zoneBasedAccessorialZoneUuid?: string | null, specialAccessorialTariffZoneUuid?: string | null, specialAccessorialChargeGroupUuid?: string | null, settlementFlatRate?: number | null, settlementPercentageRate?: number | null, zoneBasedAccessorialMatrixItem?: { __typename?: 'ZoneBasedAccessorialMatrixItemEntity', uuid: string } | null, specialAccessorialMatrixItem?: { __typename?: 'SpecialAccessorialMatrixItemEntity', uuid: string } | null, accessorialRange?: { __typename?: 'AccessorialRangeEntity', uuid: string, lessThanOrEqualToValue: number, rateUsdCents: number } | null, accessorialTemplate?: { __typename?: 'SkidBasedAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename?: 'SpecialAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename?: 'StandardAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | null }>, freightCharge?: { __typename?: 'FreightChargeEntity', uuid: string, quantity: number, billingMethod: FreightBillingMethod, description?: string | null, authoCode?: string | null, rate: number, discountRate?: any | null, settlementFlatRate?: number | null, settlementPercentageRate?: number | null, total: number, totalAmountCents?: number | null, postedAmountUsdCents?: number | null, fuelCharge?: { __typename?: 'FuelChargeEntity', uuid: string, surchargeRate: number, description?: string | null, authoCode?: string | null, flatRate: number, type: FuelBillingMethod, settlementFlatRate?: number | null, settlementPercentageRate?: number | null, totalAmountCents?: number | null, postedAmountUsdCents?: number | null } | null, tariff?: { __typename?: 'TariffEntity', uuid: string, billingPartyContactUuid?: string | null, tariffGroup?: { __typename?: 'TariffGroupEntity', name?: string | null, tariffGroupScope?: TariffGroupScope | null } | null, tariffZone: { __typename?: 'TariffZoneEntity', name: string } } | null } | null, inputForConsolidatedOrder?: { __typename?: 'StandardOrderEntity', uuid: string, name: string } | null, shipmentCharges: { __typename?: 'ShipmentChargeEntity', totalFuelCharge: number, totalCustomCharge: number, totalFreightCharge: number, totalCharge: number }, invoice?: { __typename?: 'InvoiceEntity', uuid: string, name: string, date: any, postedAt?: any | null } | null, independentSettlementBillLineItems: Array<{ __typename?: 'SettlementBillLineItemEntity', id: string, settlementMode: SettlementMode, totalAmountUsdDollars: number, revenuePercentageRate?: any | null, revenueFlatRate?: number | null, driver: { __typename?: 'DriverEntity', uuid: string, user: { __typename?: 'UserEntity', name?: string | null } }, driverSettlementBill?: { __typename?: 'DriverSettlementBillEntity', uuid: string, name?: string | null, finalizedDate?: any | null } | null, freightCost?: { __typename?: 'FreightCostEntity', id: string, billingMethod?: FreightBillingMethod | null, dependentSettlementBillingMethod?: DependentSettlementBillingMethod | null, percentageRate?: any | null, flatRateUsdDollars?: number | null, quantity?: number | null, rateUsdDollars?: number | null, discountRate?: any | null, totalAmountUsdDollars?: number | null, totalAmountUsdCents: number, tariff?: { __typename?: 'TariffEntity', uuid: string, tariffZone: { __typename?: 'TariffZoneEntity', name: string } } | null, fuelCost?: { __typename?: 'FuelCostEntity', id: string, billingMethod?: FuelBillingMethod | null, dependentSettlementBillingMethod?: DependentSettlementBillingMethod | null, percentageRate?: any | null, surchargeRate?: number | null, flatRateUsdDollars?: number | null, totalAmountUsdDollars?: number | null, totalAmountUsdCents: number } | null } | null, customCosts: Array<{ __typename?: 'CustomCostEntity', id: string, name: string, billingMethod?: CustomChargeBillingMethod | null, dependentSettlementBillingMethod?: DependentSettlementBillingMethod | null, percentageRate?: any | null, flatRateUsdDollars?: number | null, quantity: number, rateUsdDollars?: number | null, fuelSurchargeRate?: number | null, totalAmountUsdDollars?: number | null, totalAmountUsdCents: number, accessorialTemplate?: { __typename: 'SkidBasedAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename: 'SpecialAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename: 'StandardAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename: 'UnitBasedAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename: 'WaitTimeAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename: 'WeightBasedAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename: 'ZoneBasedAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | null, specialAccessorialMatrixItem?: { __typename?: 'SpecialAccessorialMatrixItemEntity', uuid: string, zoneUuid: string, chargeGroupUuid: string } | null, zoneBasedAccessorialMatrixItem?: { __typename?: 'ZoneBasedAccessorialMatrixItemEntity', uuid: string, zoneUuid: string, chargeGroupUuid: string } | null, accessorialRange?: { __typename?: 'AccessorialRangeEntity', uuid: string } | null }> }> }>, orderComments: Array<{ __typename?: 'OrderCommentEntity', uuid: string, updatedAt: any, comment: string, user?: { __typename?: 'UserEntity', uuid: string, email: string } | null }>, consolidatableOrders: { __typename?: 'ConsolidatableOrdersOutput', error?: FindConsolidatableOrdersError | null, orders: Array<{ __typename?: 'StandardOrderEntity', uuid: string }>, shipments?: Array<{ __typename?: 'StandardShipmentEntity', uuid: string }> | null }, consolidatedOrders?: Array<{ __typename?: 'StandardOrderEntity', uuid: string, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', shipperBillOfLadingNumber?: string | null } }> | null, deletedAutoAppliedAccessorials: Array<{ __typename?: 'SkidBasedAccessorialEntity', uuid: string } | { __typename?: 'SpecialAccessorialEntity', uuid: string } | { __typename?: 'StandardAccessorialEntity', uuid: string } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string }>, lineHaulLane?: { __typename?: 'LineHaulLaneEntity', uuid: string } | null, ordersProratedWith?: Array<{ __typename?: 'StandardOrderEntity', uuid: string, name: string, status: OrderStatus, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', shipperBillOfLadingNumber?: string | null } }> | null } };

export type AddQuickbooksDesktopCustomersMutationVariables = Exact<{
  contactUuids: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type AddQuickbooksDesktopCustomersMutation = { __typename?: 'Mutation', addQuickbooksDesktopCustomers: Array<{ __typename?: 'QuickbooksDesktopResultEntity', error?: string | null, quickbooksDesktopObjects?: Array<{ __typename?: 'QuickbooksDesktopObjectEntity', id: string, name: string }> | null }> };

export type GetInvoiceCsvsQueryVariables = Exact<{
  getInvoiceCsvsInput: GetInvoiceCsvsInput;
}>;


export type GetInvoiceCsvsQuery = { __typename?: 'Query', getInvoiceCsvs?: { __typename?: 'FormatCsvResEntity', csvItems: Array<Array<string>>, missingCustomerMappings: Array<string>, missingFreightChargeMappings: Array<string>, missingFuelChargeMappings: Array<string>, missingAccessorialMappings: Array<string> } | null };

export type InvoiceForQuickbooksFragment = { __typename?: 'InvoiceEntity', uuid: string, createdAt: any, name: string, dueDate?: any | null, qbInvoiceNumber?: number | null, status: InvoiceStatus, billToContact: { __typename?: 'CustomerContactEntity', displayName: string } | { __typename?: 'ThirdPartyContactEntity', displayName: string }, invoiceTerms?: { __typename?: 'InvoiceTermEntity', terms: string } | null, shipments: Array<{ __typename?: 'StandardShipmentEntity', standardShipmentFields: { __typename?: 'StandardShipmentFieldsEntity', pickupOrDelivery: PickupOrDelivery }, order?: { __typename?: 'StandardOrderEntity', secondaryRefNumber?: string | null, refNumbers: Array<string>, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', shipperBillOfLadingNumber?: string | null } } | null, legs: Array<{ __typename?: 'LegEntity', endStop: { __typename?: 'StandardStopEntity', completedAt?: any | null } }>, freightCharge?: { __typename?: 'FreightChargeEntity', uuid: string, quantity: number, rate: number, billingMethod: FreightBillingMethod, description?: string | null, fuelCharge?: { __typename?: 'FuelChargeEntity', type: FuelBillingMethod, flatRate: number, surchargeRate: number, description?: string | null } | null } | null, customCharges: Array<{ __typename?: 'CustomChargeEntity', uuid: string, name: string, rate: number, description?: string | null, quantity: number, total: number, billingMethod: CustomChargeBillingMethod, accessorialTemplate?: { __typename?: 'SkidBasedAccessorialEntity', uuid: string } | { __typename?: 'SpecialAccessorialEntity', uuid: string } | { __typename?: 'StandardAccessorialEntity', uuid: string } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string } | null }> }> };

export type InvoicesByUuidsForQuickbooksQueryVariables = Exact<{
  uuids: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type InvoicesByUuidsForQuickbooksQuery = { __typename?: 'Query', invoicesByUuids: Array<{ __typename?: 'InvoiceEntity', uuid: string, createdAt: any, name: string, dueDate?: any | null, qbInvoiceNumber?: number | null, status: InvoiceStatus, billToContact: { __typename?: 'CustomerContactEntity', displayName: string } | { __typename?: 'ThirdPartyContactEntity', displayName: string }, invoiceTerms?: { __typename?: 'InvoiceTermEntity', terms: string } | null, shipments: Array<{ __typename?: 'StandardShipmentEntity', standardShipmentFields: { __typename?: 'StandardShipmentFieldsEntity', pickupOrDelivery: PickupOrDelivery }, order?: { __typename?: 'StandardOrderEntity', secondaryRefNumber?: string | null, refNumbers: Array<string>, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', shipperBillOfLadingNumber?: string | null } } | null, legs: Array<{ __typename?: 'LegEntity', endStop: { __typename?: 'StandardStopEntity', completedAt?: any | null } }>, freightCharge?: { __typename?: 'FreightChargeEntity', uuid: string, quantity: number, rate: number, billingMethod: FreightBillingMethod, description?: string | null, fuelCharge?: { __typename?: 'FuelChargeEntity', type: FuelBillingMethod, flatRate: number, surchargeRate: number, description?: string | null } | null } | null, customCharges: Array<{ __typename?: 'CustomChargeEntity', uuid: string, name: string, rate: number, description?: string | null, quantity: number, total: number, billingMethod: CustomChargeBillingMethod, accessorialTemplate?: { __typename?: 'SkidBasedAccessorialEntity', uuid: string } | { __typename?: 'SpecialAccessorialEntity', uuid: string } | { __typename?: 'StandardAccessorialEntity', uuid: string } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string } | null }> }> }> };

export type CompleteRebillMutationVariables = Exact<{
  completeRebillInput: CompleteRebillInput;
}>;


export type CompleteRebillMutation = { __typename?: 'Mutation', completeRebill: { __typename?: 'CompleteRebillOutput', invoiceForRebill: { __typename?: 'InvoiceEntity', uuid: string, name: string } } };

export type CreateDuplicateOrderForRebillMutationVariables = Exact<{
  input: CreateDuplicateOrderForRebillInput;
}>;


export type CreateDuplicateOrderForRebillMutation = { __typename?: 'Mutation', createDuplicateOrderForRebill: { __typename?: 'CreateDuplicateOrderForRebillOutput', duplicatedOrder: { __typename?: 'StandardOrderEntity', uuid: string } } };

export type OrderForRebillQueryVariables = Exact<{
  uuid: Scalars['String']['input'];
}>;


export type OrderForRebillQuery = { __typename?: 'Query', order?: { __typename?: 'StandardOrderEntity', name: string, totalCharge: number, invoice?: { __typename?: 'InvoiceEntity', name: string, billToContact: { __typename?: 'CustomerContactEntity', uuid: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string } } | null } | null };

export type RemoveInvoiceMutationVariables = Exact<{
  uuid: Scalars['String']['input'];
}>;


export type RemoveInvoiceMutation = { __typename?: 'Mutation', removeInvoice: { __typename?: 'InvoiceEntity', uuid: string } };

export type RemoveShipmentsFromInvoiceMutationVariables = Exact<{
  removeShipmentsFromInvoiceInput: RemoveShipmentsFromInvoiceInput;
}>;


export type RemoveShipmentsFromInvoiceMutation = { __typename?: 'Mutation', removeShipmentsFromInvoice: Array<{ __typename?: 'StandardShipmentEntity', uuid: string } | null> };

export type AccessorialChargeDetailsDataFragment = { __typename?: 'AccessorialChargeDetailsEntity', accessorialUuid: string, accessorialName: string, chargeDetailsByContact: Array<{ __typename?: 'ContactAccessorialChargeDetailsEntity', contactUuid: string, displayName: string, contactReferenceNumber?: string | null, shipmentsWithAccessorialCount: number, totalAccessorialCharge: number }> };

export type ContactAccessorialChargeDetailsDataFragment = { __typename?: 'ContactAccessorialChargeDetailsEntity', contactUuid: string, displayName: string, contactReferenceNumber?: string | null, shipmentsWithAccessorialCount: number, totalAccessorialCharge: number };

export type AccessorialChargeDetailsReportQueryVariables = Exact<{
  args: AccessorialChargeDetailsReportArgs;
}>;


export type AccessorialChargeDetailsReportQuery = { __typename?: 'Query', accessorialChargeDetailsReport: Array<{ __typename?: 'AccessorialChargeDetailsEntity', accessorialUuid: string, accessorialName: string, chargeDetailsByContact: Array<{ __typename?: 'ContactAccessorialChargeDetailsEntity', contactUuid: string, displayName: string, contactReferenceNumber?: string | null, shipmentsWithAccessorialCount: number, totalAccessorialCharge: number }> }> };

export type AccountsReceivableDataFragment = { __typename?: 'AccountsReceivableReportDataForContactEntity', contactUuid: string, displayName: string, contactReferenceNumber?: string | null, totalInvoices: number, totalPayments: number, unappliedPayments: number, totalCredits: number, unappliedCredits: number, totalDebits: number, unappliedDebits: number, balance: number };

export type AccountsReceivableReportQueryVariables = Exact<{
  args: AccountsReceivableReportArgs;
}>;


export type AccountsReceivableReportQuery = { __typename?: 'Query', accountsReceivableReport: Array<{ __typename?: 'AccountsReceivableReportDataForContactEntity', contactUuid: string, displayName: string, contactReferenceNumber?: string | null, totalInvoices: number, totalPayments: number, unappliedPayments: number, totalCredits: number, unappliedCredits: number, totalDebits: number, unappliedDebits: number, balance: number }> };

export type AgingReportDataFragment = { __typename?: 'AgingReportForContactEntity', contactUuid: string, displayName: string, contactAddress?: { __typename?: 'AddressEntity', name: string, line1: string, line2?: string | null, city: string, state: string, zip: string } | null, openInvoiceValueBuckets: Array<{ __typename?: 'AgingReportBucketEntity', greaterThanOrEqualToDays?: number | null, lessThanOrEqualToDays?: number | null, openInvoiceValue: number }>, invoices: Array<{ __typename?: 'InvoiceForAgingReportEntity', journalNumber?: string | null, totalOpenAmount: number, dueDate?: any | null, date: any, age: number, name: string }> };

export type AgingReportBucketFragment = { __typename?: 'AgingReportBucketEntity', greaterThanOrEqualToDays?: number | null, lessThanOrEqualToDays?: number | null, openInvoiceValue: number };

export type InvoiceForAgingReportFragment = { __typename?: 'InvoiceForAgingReportEntity', journalNumber?: string | null, totalOpenAmount: number, dueDate?: any | null, date: any, age: number, name: string };

export type AgingReportQueryVariables = Exact<{
  args: InvoiceAgingReportArgs;
}>;


export type AgingReportQuery = { __typename?: 'Query', agingReport: Array<{ __typename?: 'AgingReportForContactEntity', contactUuid: string, displayName: string, contactAddress?: { __typename?: 'AddressEntity', name: string, line1: string, line2?: string | null, city: string, state: string, zip: string } | null, openInvoiceValueBuckets: Array<{ __typename?: 'AgingReportBucketEntity', greaterThanOrEqualToDays?: number | null, lessThanOrEqualToDays?: number | null, openInvoiceValue: number }>, invoices: Array<{ __typename?: 'InvoiceForAgingReportEntity', journalNumber?: string | null, totalOpenAmount: number, dueDate?: any | null, date: any, age: number, name: string }> }> };

export type ChargeBreakdownReportCsvQueryVariables = Exact<{
  input?: InputMaybe<ChargeBreakdownReportInput>;
}>;


export type ChargeBreakdownReportCsvQuery = { __typename?: 'Query', chargeBreakdownReportCsv: { __typename?: 'ReportFileOutput', url?: string | null, fileName?: string | null, errors?: Array<string> | null } };

export type ChargeBreakdownReportPdfQueryVariables = Exact<{
  input?: InputMaybe<ChargeBreakdownReportInput>;
}>;


export type ChargeBreakdownReportPdfQuery = { __typename?: 'Query', chargeBreakdownReportPdf: { __typename?: 'ChargeBreakdownReportPdfOutput', url?: string | null, fileName?: string | null, errors?: Array<string> | null } };

export type PaymentForMemoReportFragment = { __typename?: 'PaymentEntity', paymentType: PaymentType, paymentRail?: PaymentRail | null, amountInCents: number, date: any, creditNumber?: number | null, referenceNumber: string, comment?: string | null, creditType?: { __typename?: 'CreditTypeEntity', name: string } | null, contact: { __typename?: 'CustomerContactEntity', uuid: string, displayName: string, billingContactEmail?: string | null, defaultAddress?: { __typename?: 'AddressEntity', uuid: string, name: string, line1: string, line2?: string | null, city: string, state: string, zip: string, country: string, latitude?: number | null, longitude?: number | null, driverInstructions?: string | null, receivingHoursStart?: any | null, receivingHoursEnd?: any | null, specialInstructions?: string | null } | null, defaultContactPerson?: { __typename?: 'ContactPersonEntity', firstName?: string | null, lastName?: string | null, phone?: string | null } | null } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string, billingContactEmail?: string | null, defaultAddress?: { __typename?: 'AddressEntity', uuid: string, name: string, line1: string, line2?: string | null, city: string, state: string, zip: string, country: string, latitude?: number | null, longitude?: number | null, driverInstructions?: string | null, receivingHoursStart?: any | null, receivingHoursEnd?: any | null, specialInstructions?: string | null } | null, defaultContactPerson?: { __typename?: 'ContactPersonEntity', firstName?: string | null, lastName?: string | null, phone?: string | null } | null }, invoicesAppliedTo: Array<{ __typename?: 'InvoiceEntity', uuid: string, name: string, journalNumber: number, date: any, invoiceTotal: string, balanceInCents: number }>, paymentToOrderMappings: Array<{ __typename?: 'PaymentToOrderMappingEntity', uuid: string, amountInCents: number, order: { __typename?: 'StandardOrderEntity', totalCharge: number, balanceInCents: number, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', shipperBillOfLadingNumber?: string | null }, shipments: Array<{ __typename?: 'StandardShipmentEntity', invoice?: { __typename?: 'InvoiceEntity', uuid: string } | null }> } }> };

export type PaymentForMemoReportQueryVariables = Exact<{
  uuid: Scalars['String']['input'];
}>;


export type PaymentForMemoReportQuery = { __typename?: 'Query', paymentByUuid?: { __typename?: 'PaymentEntity', paymentType: PaymentType, paymentRail?: PaymentRail | null, amountInCents: number, date: any, creditNumber?: number | null, referenceNumber: string, comment?: string | null, creditType?: { __typename?: 'CreditTypeEntity', name: string } | null, contact: { __typename?: 'CustomerContactEntity', uuid: string, displayName: string, billingContactEmail?: string | null, defaultAddress?: { __typename?: 'AddressEntity', uuid: string, name: string, line1: string, line2?: string | null, city: string, state: string, zip: string, country: string, latitude?: number | null, longitude?: number | null, driverInstructions?: string | null, receivingHoursStart?: any | null, receivingHoursEnd?: any | null, specialInstructions?: string | null } | null, defaultContactPerson?: { __typename?: 'ContactPersonEntity', firstName?: string | null, lastName?: string | null, phone?: string | null } | null } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string, billingContactEmail?: string | null, defaultAddress?: { __typename?: 'AddressEntity', uuid: string, name: string, line1: string, line2?: string | null, city: string, state: string, zip: string, country: string, latitude?: number | null, longitude?: number | null, driverInstructions?: string | null, receivingHoursStart?: any | null, receivingHoursEnd?: any | null, specialInstructions?: string | null } | null, defaultContactPerson?: { __typename?: 'ContactPersonEntity', firstName?: string | null, lastName?: string | null, phone?: string | null } | null }, invoicesAppliedTo: Array<{ __typename?: 'InvoiceEntity', uuid: string, name: string, journalNumber: number, date: any, invoiceTotal: string, balanceInCents: number }>, paymentToOrderMappings: Array<{ __typename?: 'PaymentToOrderMappingEntity', uuid: string, amountInCents: number, order: { __typename?: 'StandardOrderEntity', totalCharge: number, balanceInCents: number, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', shipperBillOfLadingNumber?: string | null }, shipments: Array<{ __typename?: 'StandardShipmentEntity', invoice?: { __typename?: 'InvoiceEntity', uuid: string } | null }> } }> } | null };

export type DriverDailyLogReportPdfQueryVariables = Exact<{
  driverDailyLogReportPdfInput: DriverDailyLogReportPdfInput;
}>;


export type DriverDailyLogReportPdfQuery = { __typename?: 'Query', driverDailyLogReportPdf: { __typename?: 'ReportPdfOutput', url?: string | null, fileName?: string | null, errors?: Array<string> | null } };

export type EmailAccountingReportMutationVariables = Exact<{
  emailAccountingReportInput: EmailAccountingReportInput;
}>;


export type EmailAccountingReportMutation = { __typename?: 'Mutation', emailAccountingReport: { __typename?: 'EmailAccountingReportOutput', status: EmailAccountingReportStatus } };

export type IncomeAnalysisReportQueryVariables = Exact<{
  args: IncomeAnalysisReportArgs;
}>;


export type IncomeAnalysisReportQuery = { __typename?: 'Query', incomeAnalysisReport: Array<{ __typename?: 'CustomerReportBucketEntity', uuid: string, displayName: string, freightRevenue: number, fuelRevenue: number, lineHaulRevenue: number, specialRevenue: number, customChargeRevenue: number, surchargeRevenue: number, pickupRevenue: number, deliveryRevenue: number, recoveryRevenue: number, transferRevenue: number, totalRevenue: number, totalWeight: number, numberOfOrders: number, numberOfPackages: number }> };

export type InvoiceBillingSummaryReportV2PdfUrlQueryVariables = Exact<{
  invoiceBillingSummaryV2Input: InvoiceBillingSummaryV2Input;
}>;


export type InvoiceBillingSummaryReportV2PdfUrlQuery = { __typename?: 'Query', invoiceBillingSummaryReportV2PdfUrl: string };

export type InvoiceBillingSummaryReportV2GroupFragment = { __typename?: 'InvoiceBillingSummaryV2Group', groupLabel: string, groupTotal: number, totalLineItems: number, subgroups: Array<{ __typename?: 'InvoiceBillingSummaryV2Subgroup', subgroupLabel?: string | null, subgroupTotal: number, lineItems: Array<{ __typename?: 'InvoiceBillingSummaryLineItemEntity', orderName: string, invoiceName: string, totalCharge: number, shipperBillOfLadingNumber: string, invoiceStatus: string, refNumbers?: Array<string> | null, contactDisplayName: string, contactReferenceNumber?: string | null, serviceLevel: string, invoiceDate?: any | null, serviceDate?: any | null, pieces: number, weight: number, inboundAddressName?: string | null, outboundAddressName?: string | null, shipmentsIncludedInLineItemRevenue: Array<{ __typename?: 'ShipmentIncludedInRevenueEntity', terminalCode?: string | null, shipmentTypeForCharge: ShipmentTypeForCharge }>, orderLineHaulLane?: { __typename?: 'OrderLineHaulLaneEntity', originTerminalCode: string, destinationTerminalCode: string } | null }> }> };

export type InvoiceBillingSummaryReportV2LineItemFragment = { __typename?: 'InvoiceBillingSummaryLineItemEntity', orderName: string, invoiceName: string, totalCharge: number, shipperBillOfLadingNumber: string, invoiceStatus: string, refNumbers?: Array<string> | null, contactDisplayName: string, contactReferenceNumber?: string | null, serviceLevel: string, invoiceDate?: any | null, serviceDate?: any | null, pieces: number, weight: number, inboundAddressName?: string | null, outboundAddressName?: string | null, shipmentsIncludedInLineItemRevenue: Array<{ __typename?: 'ShipmentIncludedInRevenueEntity', terminalCode?: string | null, shipmentTypeForCharge: ShipmentTypeForCharge }>, orderLineHaulLane?: { __typename?: 'OrderLineHaulLaneEntity', originTerminalCode: string, destinationTerminalCode: string } | null };

export type InvoiceBillingSummaryReportV2PdfQueryVariables = Exact<{
  invoiceBillingSummaryV2Input: InvoiceBillingSummaryV2Input;
}>;


export type InvoiceBillingSummaryReportV2PdfQuery = { __typename?: 'Query', invoiceBillingSummaryReportV2Pdf: { __typename?: 'InvoiceBillingSummaryV2PdfOutput', url: string, fileName: string } };

export type InvoiceBillingSummaryReportV2SubgroupFragment = { __typename?: 'InvoiceBillingSummaryV2Subgroup', subgroupLabel?: string | null, subgroupTotal: number, lineItems: Array<{ __typename?: 'InvoiceBillingSummaryLineItemEntity', orderName: string, invoiceName: string, totalCharge: number, shipperBillOfLadingNumber: string, invoiceStatus: string, refNumbers?: Array<string> | null, contactDisplayName: string, contactReferenceNumber?: string | null, serviceLevel: string, invoiceDate?: any | null, serviceDate?: any | null, pieces: number, weight: number, inboundAddressName?: string | null, outboundAddressName?: string | null, shipmentsIncludedInLineItemRevenue: Array<{ __typename?: 'ShipmentIncludedInRevenueEntity', terminalCode?: string | null, shipmentTypeForCharge: ShipmentTypeForCharge }>, orderLineHaulLane?: { __typename?: 'OrderLineHaulLaneEntity', originTerminalCode: string, destinationTerminalCode: string } | null }> };

export type InvoiceBillingSummaryReportV2Fragment = { __typename?: 'InvoiceBillingSummaryV2Output', total: number, groups: Array<{ __typename?: 'InvoiceBillingSummaryV2Group', groupLabel: string, groupTotal: number, totalLineItems: number, subgroups: Array<{ __typename?: 'InvoiceBillingSummaryV2Subgroup', subgroupLabel?: string | null, subgroupTotal: number, lineItems: Array<{ __typename?: 'InvoiceBillingSummaryLineItemEntity', orderName: string, invoiceName: string, totalCharge: number, shipperBillOfLadingNumber: string, invoiceStatus: string, refNumbers?: Array<string> | null, contactDisplayName: string, contactReferenceNumber?: string | null, serviceLevel: string, invoiceDate?: any | null, serviceDate?: any | null, pieces: number, weight: number, inboundAddressName?: string | null, outboundAddressName?: string | null, shipmentsIncludedInLineItemRevenue: Array<{ __typename?: 'ShipmentIncludedInRevenueEntity', terminalCode?: string | null, shipmentTypeForCharge: ShipmentTypeForCharge }>, orderLineHaulLane?: { __typename?: 'OrderLineHaulLaneEntity', originTerminalCode: string, destinationTerminalCode: string } | null }> }> }> };

export type InvoiceBillingSummaryReportV2QueryVariables = Exact<{
  invoiceBillingSummaryV2Input: InvoiceBillingSummaryV2Input;
}>;


export type InvoiceBillingSummaryReportV2Query = { __typename?: 'Query', invoiceBillingSummaryReportV2: { __typename?: 'InvoiceBillingSummaryV2Output', total: number, groups: Array<{ __typename?: 'InvoiceBillingSummaryV2Group', groupLabel: string, groupTotal: number, totalLineItems: number, subgroups: Array<{ __typename?: 'InvoiceBillingSummaryV2Subgroup', subgroupLabel?: string | null, subgroupTotal: number, lineItems: Array<{ __typename?: 'InvoiceBillingSummaryLineItemEntity', orderName: string, invoiceName: string, totalCharge: number, shipperBillOfLadingNumber: string, invoiceStatus: string, refNumbers?: Array<string> | null, contactDisplayName: string, contactReferenceNumber?: string | null, serviceLevel: string, invoiceDate?: any | null, serviceDate?: any | null, pieces: number, weight: number, inboundAddressName?: string | null, outboundAddressName?: string | null, shipmentsIncludedInLineItemRevenue: Array<{ __typename?: 'ShipmentIncludedInRevenueEntity', terminalCode?: string | null, shipmentTypeForCharge: ShipmentTypeForCharge }>, orderLineHaulLane?: { __typename?: 'OrderLineHaulLaneEntity', originTerminalCode: string, destinationTerminalCode: string } | null }> }> }> } };

export type InvoiceForOpenInvoiceReportFragment = { __typename?: 'InvoiceForOpenInvoiceReportEntity', uuid: string, journalNumber?: string | null, name: string, date: any, dueDate?: any | null, status: InvoiceStatus, invoiceTotalCents: number, invoiceBalanceCents: number, billingPartyContactUuid: string, billingPartyContactDisplayName: string, billingPartyContactReferenceNumber?: string | null, orders: Array<{ __typename?: 'OrderForOpenInvoiceReportEntity', orderUuid: string, orderName: string, shipperBillOfLadingNumber?: string | null, masterAirwayBillOfLadingNumber?: string | null, refNumbers?: Array<string> | null, addressName?: string | null, originTerminalCode?: string | null, destinationTerminalCode?: string | null, serviceDate?: any | null, pieces: number, weight: number, orderTotalCents: number, orderBalanceCents: number }> };

export type OrderForOpenInvoiceReportFragment = { __typename?: 'OrderForOpenInvoiceReportEntity', orderUuid: string, orderName: string, shipperBillOfLadingNumber?: string | null, masterAirwayBillOfLadingNumber?: string | null, refNumbers?: Array<string> | null, addressName?: string | null, originTerminalCode?: string | null, destinationTerminalCode?: string | null, serviceDate?: any | null, pieces: number, weight: number, orderTotalCents: number, orderBalanceCents: number };

export type OpenInvoiceReportQueryVariables = Exact<{
  openInvoiceReportArgs: OpenInvoiceReportArgs;
}>;


export type OpenInvoiceReportQuery = { __typename?: 'Query', openInvoiceReport: Array<{ __typename?: 'InvoiceForOpenInvoiceReportEntity', uuid: string, journalNumber?: string | null, name: string, date: any, dueDate?: any | null, status: InvoiceStatus, invoiceTotalCents: number, invoiceBalanceCents: number, billingPartyContactUuid: string, billingPartyContactDisplayName: string, billingPartyContactReferenceNumber?: string | null, orders: Array<{ __typename?: 'OrderForOpenInvoiceReportEntity', orderUuid: string, orderName: string, shipperBillOfLadingNumber?: string | null, masterAirwayBillOfLadingNumber?: string | null, refNumbers?: Array<string> | null, addressName?: string | null, originTerminalCode?: string | null, destinationTerminalCode?: string | null, serviceDate?: any | null, pieces: number, weight: number, orderTotalCents: number, orderBalanceCents: number }> }> };

export type InvoiceForOrderSummaryReportFragment = { __typename?: 'InvoiceEntity', name: string, date: any, journalNumber: number, invoiceTotal: string, totalOpenAmount: number, shipments: Array<{ __typename?: 'StandardShipmentEntity', uuid: string, totalChargesAmount: number, standardShipmentFields: { __typename?: 'StandardShipmentFieldsEntity', pickupOrDelivery: PickupOrDelivery }, order?: { __typename?: 'StandardOrderEntity', uuid: string, balanceInCents: number, weight: number, dimWeight: number, refNumbers: Array<string>, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', shipperBillOfLadingNumber?: string | null, masterAirwayBillOfLadingNumber?: string | null }, packages: Array<{ __typename?: 'PackageEntity', quantity: number }> } | null, legs: Array<{ __typename?: 'LegEntity', endStop: { __typename?: 'StandardStopEntity', completedAt?: any | null, stopType?: StopType | null, address: { __typename?: 'AddressEntity', name: string } } }> }>, billToContact: { __typename?: 'CustomerContactEntity', displayName: string, billingContactEmail?: string | null, defaultContactPerson?: { __typename?: 'ContactPersonEntity', firstName?: string | null, lastName?: string | null, phone?: string | null } | null, defaultAddress?: { __typename?: 'AddressEntity', uuid: string, name: string, line1: string, line2?: string | null, city: string, state: string, zip: string, country: string, latitude?: number | null, longitude?: number | null, driverInstructions?: string | null, receivingHoursStart?: any | null, receivingHoursEnd?: any | null, specialInstructions?: string | null } | null } | { __typename?: 'ThirdPartyContactEntity', displayName: string, billingContactEmail?: string | null, defaultContactPerson?: { __typename?: 'ContactPersonEntity', firstName?: string | null, lastName?: string | null, phone?: string | null } | null, defaultAddress?: { __typename?: 'AddressEntity', uuid: string, name: string, line1: string, line2?: string | null, city: string, state: string, zip: string, country: string, latitude?: number | null, longitude?: number | null, driverInstructions?: string | null, receivingHoursStart?: any | null, receivingHoursEnd?: any | null, specialInstructions?: string | null } | null } };

export type InvoiceForOrderSummaryReportQueryVariables = Exact<{
  uuid: Scalars['String']['input'];
}>;


export type InvoiceForOrderSummaryReportQuery = { __typename?: 'Query', invoice?: { __typename?: 'InvoiceEntity', name: string, date: any, journalNumber: number, invoiceTotal: string, totalOpenAmount: number, shipments: Array<{ __typename?: 'StandardShipmentEntity', uuid: string, totalChargesAmount: number, standardShipmentFields: { __typename?: 'StandardShipmentFieldsEntity', pickupOrDelivery: PickupOrDelivery }, order?: { __typename?: 'StandardOrderEntity', uuid: string, balanceInCents: number, weight: number, dimWeight: number, refNumbers: Array<string>, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', shipperBillOfLadingNumber?: string | null, masterAirwayBillOfLadingNumber?: string | null }, packages: Array<{ __typename?: 'PackageEntity', quantity: number }> } | null, legs: Array<{ __typename?: 'LegEntity', endStop: { __typename?: 'StandardStopEntity', completedAt?: any | null, stopType?: StopType | null, address: { __typename?: 'AddressEntity', name: string } } }> }>, billToContact: { __typename?: 'CustomerContactEntity', displayName: string, billingContactEmail?: string | null, defaultContactPerson?: { __typename?: 'ContactPersonEntity', firstName?: string | null, lastName?: string | null, phone?: string | null } | null, defaultAddress?: { __typename?: 'AddressEntity', uuid: string, name: string, line1: string, line2?: string | null, city: string, state: string, zip: string, country: string, latitude?: number | null, longitude?: number | null, driverInstructions?: string | null, receivingHoursStart?: any | null, receivingHoursEnd?: any | null, specialInstructions?: string | null } | null } | { __typename?: 'ThirdPartyContactEntity', displayName: string, billingContactEmail?: string | null, defaultContactPerson?: { __typename?: 'ContactPersonEntity', firstName?: string | null, lastName?: string | null, phone?: string | null } | null, defaultAddress?: { __typename?: 'AddressEntity', uuid: string, name: string, line1: string, line2?: string | null, city: string, state: string, zip: string, country: string, latitude?: number | null, longitude?: number | null, driverInstructions?: string | null, receivingHoursStart?: any | null, receivingHoursEnd?: any | null, specialInstructions?: string | null } | null } } | null };

export type InvoicesForOrderSummaryReportQueryVariables = Exact<{
  uuids: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type InvoicesForOrderSummaryReportQuery = { __typename?: 'Query', invoicesByUuids: Array<{ __typename?: 'InvoiceEntity', name: string, date: any, journalNumber: number, invoiceTotal: string, totalOpenAmount: number, shipments: Array<{ __typename?: 'StandardShipmentEntity', uuid: string, totalChargesAmount: number, standardShipmentFields: { __typename?: 'StandardShipmentFieldsEntity', pickupOrDelivery: PickupOrDelivery }, order?: { __typename?: 'StandardOrderEntity', uuid: string, balanceInCents: number, weight: number, dimWeight: number, refNumbers: Array<string>, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', shipperBillOfLadingNumber?: string | null, masterAirwayBillOfLadingNumber?: string | null }, packages: Array<{ __typename?: 'PackageEntity', quantity: number }> } | null, legs: Array<{ __typename?: 'LegEntity', endStop: { __typename?: 'StandardStopEntity', completedAt?: any | null, stopType?: StopType | null, address: { __typename?: 'AddressEntity', name: string } } }> }>, billToContact: { __typename?: 'CustomerContactEntity', displayName: string, billingContactEmail?: string | null, defaultContactPerson?: { __typename?: 'ContactPersonEntity', firstName?: string | null, lastName?: string | null, phone?: string | null } | null, defaultAddress?: { __typename?: 'AddressEntity', uuid: string, name: string, line1: string, line2?: string | null, city: string, state: string, zip: string, country: string, latitude?: number | null, longitude?: number | null, driverInstructions?: string | null, receivingHoursStart?: any | null, receivingHoursEnd?: any | null, specialInstructions?: string | null } | null } | { __typename?: 'ThirdPartyContactEntity', displayName: string, billingContactEmail?: string | null, defaultContactPerson?: { __typename?: 'ContactPersonEntity', firstName?: string | null, lastName?: string | null, phone?: string | null } | null, defaultAddress?: { __typename?: 'AddressEntity', uuid: string, name: string, line1: string, line2?: string | null, city: string, state: string, zip: string, country: string, latitude?: number | null, longitude?: number | null, driverInstructions?: string | null, receivingHoursStart?: any | null, receivingHoursEnd?: any | null, specialInstructions?: string | null } | null } }> };

export type PaymentApplicationReportQueryVariables = Exact<{
  args: FindPaymentsV2Args;
}>;


export type PaymentApplicationReportQuery = { __typename?: 'Query', paymentApplicationReport: Array<{ __typename?: 'PaymentForPaymentApplicationReportEntity', paymentUuid: string, referenceNumber: string, paymentDate: any, paymentType: PaymentType, paymentRail?: PaymentRail | null, comment?: string | null, totalAmount: number, unappliedAmount: number, contactUuid: string, contactDisplayName: string, contactReferenceNumber?: string | null, masterAccountName?: string | null, orders: Array<{ __typename?: 'OrderForPaymentApplicationReportEntity', orderUuid: string, orderName: string, shipperBillOfLadingNumber?: string | null, masterAirwayBillOfLadingNumber?: string | null, refNumbers?: Array<string> | null, inboundAddressName?: string | null, outboundAddressName?: string | null, pieces: number, weight: number, orderTotal: number, orderBalance: number, appliedAmount: number, invoiceUuid?: string | null, invoiceName?: string | null, invoiceJournalNumber?: number | null, invoiceDate?: any | null, invoiceContactDisplayName?: string | null, invoiceTotal?: number | null, invoiceBalance?: number | null }> }> };

export type PaymentForPaymentApplicationReportFragment = { __typename?: 'PaymentForPaymentApplicationReportEntity', paymentUuid: string, referenceNumber: string, paymentDate: any, paymentType: PaymentType, paymentRail?: PaymentRail | null, comment?: string | null, totalAmount: number, unappliedAmount: number, contactUuid: string, contactDisplayName: string, contactReferenceNumber?: string | null, masterAccountName?: string | null, orders: Array<{ __typename?: 'OrderForPaymentApplicationReportEntity', orderUuid: string, orderName: string, shipperBillOfLadingNumber?: string | null, masterAirwayBillOfLadingNumber?: string | null, refNumbers?: Array<string> | null, inboundAddressName?: string | null, outboundAddressName?: string | null, pieces: number, weight: number, orderTotal: number, orderBalance: number, appliedAmount: number, invoiceUuid?: string | null, invoiceName?: string | null, invoiceJournalNumber?: number | null, invoiceDate?: any | null, invoiceContactDisplayName?: string | null, invoiceTotal?: number | null, invoiceBalance?: number | null }> };

export type OrderForPaymentApplicationReportFragment = { __typename?: 'OrderForPaymentApplicationReportEntity', orderUuid: string, orderName: string, shipperBillOfLadingNumber?: string | null, masterAirwayBillOfLadingNumber?: string | null, refNumbers?: Array<string> | null, inboundAddressName?: string | null, outboundAddressName?: string | null, pieces: number, weight: number, orderTotal: number, orderBalance: number, appliedAmount: number, invoiceUuid?: string | null, invoiceName?: string | null, invoiceJournalNumber?: number | null, invoiceDate?: any | null, invoiceContactDisplayName?: string | null, invoiceTotal?: number | null, invoiceBalance?: number | null };

export type PaymentForJournalReportOldFragment = { __typename?: 'PaymentEntity', paymentType: PaymentType, paymentRail?: PaymentRail | null, amountInCents: number, date: any, referenceNumber: string, creditNumber?: number | null, comment?: string | null, unappliedAmountInCents: number, creditType?: { __typename?: 'CreditTypeEntity', name: string } | null, contact: { __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string }, glTerminal?: { __typename?: 'TerminalEntity', name: string } | null, paymentToOrderMappings: Array<{ __typename?: 'PaymentToOrderMappingEntity', amountInCents: number, order: { __typename?: 'StandardOrderEntity', name: string, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', shipperBillOfLadingNumber?: string | null }, shipments: Array<{ __typename?: 'StandardShipmentEntity', invoice?: { __typename?: 'InvoiceEntity', name: string, journalNumber: number, date: any } | null }> } }> };

export type PaymentToOrderMappingForJournalReportFragment = { __typename?: 'PaymentToOrderMappingEntity', amountInCents: number, order: { __typename?: 'StandardOrderEntity', name: string, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', shipperBillOfLadingNumber?: string | null }, shipments: Array<{ __typename?: 'StandardShipmentEntity', invoice?: { __typename?: 'InvoiceEntity', name: string, journalNumber: number, date: any } | null }> } };

export type PaymentsForJournalReportQueryVariables = Exact<{
  args: FindPaymentsV2Args;
}>;


export type PaymentsForJournalReportQuery = { __typename?: 'Query', paymentsV2: { __typename?: 'PaymentConnection', edges: Array<{ __typename?: 'PaymentEdge', cursor: string, node: { __typename?: 'PaymentEntity', paymentType: PaymentType, paymentRail?: PaymentRail | null, amountInCents: number, date: any, referenceNumber: string, creditNumber?: number | null, comment?: string | null, unappliedAmountInCents: number, creditType?: { __typename?: 'CreditTypeEntity', name: string } | null, contact: { __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string }, glTerminal?: { __typename?: 'TerminalEntity', name: string } | null, paymentToOrderMappings: Array<{ __typename?: 'PaymentToOrderMappingEntity', amountInCents: number, order: { __typename?: 'StandardOrderEntity', name: string, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', shipperBillOfLadingNumber?: string | null }, shipments: Array<{ __typename?: 'StandardShipmentEntity', invoice?: { __typename?: 'InvoiceEntity', name: string, journalNumber: number, date: any } | null }> } }> } }> } };

export type PaymentForJournalReportFragment = { __typename?: 'PaymentForPaymentJournalReportEntity', paymentUuid: string, paymentType: PaymentType, paymentRail?: PaymentRail | null, paymentDate: any, referenceNumber: string, creditNumber?: number | null, comment?: string | null, totalAmount: number, unappliedAmountDollars: number, creditTypeName?: string | null, glTerminalName?: string | null, contactUuid: string, contactDisplayName: string, contactReferenceNumber?: string | null, orders: Array<{ __typename?: 'OrderForPaymentJournalReportEntity', orderUuid: string, orderName: string, shipperBillOfLadingNumber?: string | null, appliedAmountDollars: number, invoiceUuid?: string | null, invoiceName?: string | null, invoiceJournalNumber?: number | null, invoiceDate?: any | null, invoiceCustomerName?: string | null }> };

export type OrderForPaymentJournalReportFragment = { __typename?: 'OrderForPaymentJournalReportEntity', orderUuid: string, orderName: string, shipperBillOfLadingNumber?: string | null, appliedAmountDollars: number, invoiceUuid?: string | null, invoiceName?: string | null, invoiceJournalNumber?: number | null, invoiceDate?: any | null, invoiceCustomerName?: string | null };

export type PaymentJournalReportQueryVariables = Exact<{
  args: FindPaymentsV2Args;
}>;


export type PaymentJournalReportQuery = { __typename?: 'Query', paymentJournalReport: Array<{ __typename?: 'PaymentForPaymentJournalReportEntity', paymentUuid: string, paymentType: PaymentType, paymentRail?: PaymentRail | null, paymentDate: any, referenceNumber: string, creditNumber?: number | null, comment?: string | null, totalAmount: number, unappliedAmountDollars: number, creditTypeName?: string | null, glTerminalName?: string | null, contactUuid: string, contactDisplayName: string, contactReferenceNumber?: string | null, orders: Array<{ __typename?: 'OrderForPaymentJournalReportEntity', orderUuid: string, orderName: string, shipperBillOfLadingNumber?: string | null, appliedAmountDollars: number, invoiceUuid?: string | null, invoiceName?: string | null, invoiceJournalNumber?: number | null, invoiceDate?: any | null, invoiceCustomerName?: string | null }> }> };

export type UnappliedPaymentsReportQueryVariables = Exact<{
  input: UnappliedPaymentReportCsvInput;
}>;


export type UnappliedPaymentsReportQuery = { __typename?: 'Query', unappliedPaymentReportCsv: { __typename?: 'ReportFileOutput', url?: string | null, fileName?: string | null, errors?: Array<string> | null } };

export type RevenueReportOrderDataFragment = { __typename?: 'RevenueReportOrderEntity', uuid: string, name: string, totalCharge: number, shipperBillOfLadingNumber?: string | null, masterAirwayBillOfLadingNumber?: string | null, contactUuid: string, contactName: string, contactReferenceNumber?: string | null, packageQuantity: number, packageWeight: number, podUploaded: boolean, stopTypes: Array<StopType>, serviceDates: Array<any>, controllingTerminalCode?: string | null, inboundAddressString?: string | null, outboundAddressString?: string | null, detailedStatusV2?: OrderDetailedStatus | null, inboundStopType?: OriginStopType | null, outboundStopType?: DestinationStopType | null };

export type SendInvoicesMutationVariables = Exact<{
  sendInvoicesInput: SendInvoicesInput;
}>;


export type SendInvoicesMutation = { __typename?: 'Mutation', sendInvoices: { __typename?: 'InvoiceSendJobBatchEntity', uuid: string, createdAt: any, type: InvoiceSendJobBatchType, invoiceSendJobBatchProgress: { __typename?: 'InvoiceSendJobBatchProgressEntity', totalCount: number, failCount: number, successCount: number }, invoiceBatchDocuments: { __typename?: 'InvoiceSendJobBatchDocumentsEntity', invoicesBackupDocument?: { __typename?: 'DocumentEntity', preSignedGetUrl: string, fileType: string } | null, invoicesCombinedDocument?: { __typename?: 'DocumentEntity', preSignedGetUrl: string, fileType: string } | null, invoicesZipDocument?: { __typename?: 'DocumentEntity', preSignedGetUrl: string, fileType: string } | null } } };

export type ShallowInvoiceWithoutShipmentsFragment = { __typename?: 'InvoiceEntity', uuid: string, name: string, journalNumber: number, createdAt: any, dueDate?: any | null, date: any, status: InvoiceStatus, source: InvoiceSource, qbInvoiceNumber?: number | null, emailOptions: Array<string>, invoiceTerms?: { __typename?: 'InvoiceTermEntity', uuid: string, terms: string } | null, billToContact: { __typename?: 'CustomerContactEntity', uuid: string, displayName: string, billingCycleDuration: BillingCycleDuration, ediPartnerships: Array<{ __typename?: 'EdiPartnershipEntity', stedi210MappingId?: string | null, ediOutboundPayloadDestination: EdiOutboundPayloadDestination }> } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string, billingCycleDuration: BillingCycleDuration, ediPartnerships: Array<{ __typename?: 'EdiPartnershipEntity', stedi210MappingId?: string | null, ediOutboundPayloadDestination: EdiOutboundPayloadDestination }> }, firstShipment?: { __typename?: 'StandardShipmentEntity', uuid: string } | null };

export type ShallowInvoicesByUuidsQueryVariables = Exact<{
  uuids: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type ShallowInvoicesByUuidsQuery = { __typename?: 'Query', invoicesByUuids: Array<{ __typename?: 'InvoiceEntity', uuid: string, name: string, journalNumber: number, createdAt: any, dueDate?: any | null, date: any, status: InvoiceStatus, source: InvoiceSource, qbInvoiceNumber?: number | null, emailOptions: Array<string>, invoiceTerms?: { __typename?: 'InvoiceTermEntity', uuid: string, terms: string } | null, billToContact: { __typename?: 'CustomerContactEntity', uuid: string, displayName: string, billingCycleDuration: BillingCycleDuration, ediPartnerships: Array<{ __typename?: 'EdiPartnershipEntity', stedi210MappingId?: string | null, ediOutboundPayloadDestination: EdiOutboundPayloadDestination }> } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string, billingCycleDuration: BillingCycleDuration, ediPartnerships: Array<{ __typename?: 'EdiPartnershipEntity', stedi210MappingId?: string | null, ediOutboundPayloadDestination: EdiOutboundPayloadDestination }> }, firstShipment?: { __typename?: 'StandardShipmentEntity', uuid: string } | null }> };

export type InvoiceUuidsQueryVariables = Exact<{
  inConsolidatedInvoice?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  createdAtStartDate?: InputMaybe<Scalars['DateTime']['input']>;
  createdAtEndDate?: InputMaybe<Scalars['DateTime']['input']>;
  invoiceStartDate?: InputMaybe<Scalars['DateTime']['input']>;
  invoiceEndDate?: InputMaybe<Scalars['DateTime']['input']>;
  statuses?: InputMaybe<Array<InvoiceStatus> | InvoiceStatus>;
  searchText?: InputMaybe<Scalars['String']['input']>;
  billingPartyContactUuid?: InputMaybe<Scalars['String']['input']>;
  groupByContact?: InputMaybe<Scalars['Boolean']['input']>;
  uuids?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  isClosed?: InputMaybe<Scalars['Boolean']['input']>;
  emailSendStatus?: InputMaybe<EmailSendStatus>;
  isSyncedToQuickbooksDesktop?: InputMaybe<Scalars['Boolean']['input']>;
  sorts?: InputMaybe<Array<FindInvoicesSort> | FindInvoicesSort>;
}>;


export type InvoiceUuidsQuery = { __typename?: 'Query', invoices: { __typename?: 'InvoiceConnection', totalCount?: number | null, edges: Array<{ __typename?: 'InvoiceEdge', node: { __typename?: 'InvoiceEntity', uuid: string, status: InvoiceStatus } }>, pageInfo: { __typename?: 'PageInfo', startCursor?: string | null, endCursor?: string | null, hasPreviousPage: boolean, hasNextPage: boolean } } };

export type ShallowInvoiceV2Fragment = { __typename?: 'InvoiceEntity', uuid: string, date: any, createdAt: any, quickbooksInvoiceId?: string | null, lastSyncedToQuickbooksAt?: any | null, syncedToQuickbooksDesktopAt?: any | null, name: string, journalNumber: number, status: InvoiceStatus, dueDate?: any | null, billToContact: { __typename?: 'CustomerContactEntity', displayName: string } | { __typename?: 'ThirdPartyContactEntity', displayName: string } };

export type ShallowInvoicesV2QueryVariables = Exact<{
  inConsolidatedInvoice?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  createdAtStartDate?: InputMaybe<Scalars['DateTime']['input']>;
  createdAtEndDate?: InputMaybe<Scalars['DateTime']['input']>;
  invoiceStartDate?: InputMaybe<Scalars['DateTime']['input']>;
  invoiceEndDate?: InputMaybe<Scalars['DateTime']['input']>;
  statuses?: InputMaybe<Array<InvoiceStatus> | InvoiceStatus>;
  searchText?: InputMaybe<Scalars['String']['input']>;
  billingPartyContactUuid?: InputMaybe<Scalars['String']['input']>;
  groupByContact?: InputMaybe<Scalars['Boolean']['input']>;
  uuids?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  isClosed?: InputMaybe<Scalars['Boolean']['input']>;
  emailSendStatus?: InputMaybe<EmailSendStatus>;
  isSyncedToQuickbooksDesktop?: InputMaybe<Scalars['Boolean']['input']>;
  sorts?: InputMaybe<Array<FindInvoicesSort> | FindInvoicesSort>;
}>;


export type ShallowInvoicesV2Query = { __typename?: 'Query', invoices: { __typename?: 'InvoiceConnection', totalCount?: number | null, edges: Array<{ __typename?: 'InvoiceEdge', node: { __typename?: 'InvoiceEntity', uuid: string, date: any, createdAt: any, quickbooksInvoiceId?: string | null, lastSyncedToQuickbooksAt?: any | null, syncedToQuickbooksDesktopAt?: any | null, name: string, journalNumber: number, status: InvoiceStatus, dueDate?: any | null, billToContact: { __typename?: 'CustomerContactEntity', displayName: string } | { __typename?: 'ThirdPartyContactEntity', displayName: string } } }>, pageInfo: { __typename?: 'PageInfo', startCursor?: string | null, endCursor?: string | null, hasPreviousPage: boolean, hasNextPage: boolean } } };

export type TypeAheadOrderFragment = { __typename?: 'StandardOrderEntity', uuid: string, name: string, status: OrderStatus, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', shipperBillOfLadingNumber?: string | null }, billingPartyContact: { __typename?: 'CustomerContactEntity', uuid: string, invoiceTimePeriodSplit?: TimePeriod | null, numberOfOrdersPerInvoice?: number | null, displayName: string }, shipments: Array<{ __typename?: 'StandardShipmentEntity', uuid: string, hideFromBilling: boolean, invoice?: { __typename?: 'InvoiceEntity', uuid: string } | null }>, ordersProratedWith?: Array<{ __typename?: 'StandardOrderEntity', uuid: string, name: string, status: OrderStatus, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', shipperBillOfLadingNumber?: string | null } }> | null };

export type TypeaheadOrderUuidsQueryQueryVariables = Exact<{
  addressCityFilter?: InputMaybe<StringFilter>;
  addressZipFilter?: InputMaybe<StringFilter>;
  attemptedAtDateFilters?: InputMaybe<DateFilterStartEnd>;
  completionDateFilters?: InputMaybe<DateFilterStartEnd>;
  deadlineDateFilters?: InputMaybe<DateFilterStartEnd>;
  receivedDateFilters?: InputMaybe<DateFilterStartEnd>;
  createdAtDateFilters?: InputMaybe<DateFilterStartEnd>;
  expectedInboundArrivalDateFilters?: InputMaybe<DateFilterStartEnd>;
  scheduledAtDateFilters?: InputMaybe<DateFilterStartEnd>;
  primaryAppointmentDateFilters?: InputMaybe<DateFilterStartEnd>;
  orderNumberFilter?: InputMaybe<StringFilter>;
  billingPartyContactUuidFilter?: InputMaybe<StringFilter>;
  driverUuidFilter?: InputMaybe<StringFilter>;
  shipperFilter?: InputMaybe<StringFilter>;
  consigneeFilter?: InputMaybe<StringFilter>;
  statusFilters?: InputMaybe<Array<StatusFilter> | StatusFilter>;
  shipmentStatusFilters?: InputMaybe<Array<ShipmentStatusFilter> | ShipmentStatusFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  searchText?: InputMaybe<Scalars['String']['input']>;
  multipleSearches?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  scheduledFilter?: InputMaybe<BooleanFilter>;
  outForDeliveryFilter?: InputMaybe<BooleanFilter>;
  onHand?: InputMaybe<BooleanFilter>;
  onInvoice?: InputMaybe<BooleanFilter>;
  isCancelled?: InputMaybe<BooleanFilter>;
  isRefused?: InputMaybe<BooleanFilter>;
  isFinalized?: InputMaybe<BooleanFilter>;
  isPicked?: InputMaybe<BooleanFilter>;
  isOsd?: InputMaybe<BooleanFilter>;
  isSpecial?: InputMaybe<BooleanFilter>;
  orderSource?: InputMaybe<OrderSource>;
  noMaximum?: InputMaybe<Scalars['Boolean']['input']>;
  hasAppointmentScheduled?: InputMaybe<BooleanFilter>;
  appointmentRequired?: InputMaybe<BooleanFilter>;
  hasContactInformation?: InputMaybe<BooleanFilter>;
  hasFailures?: InputMaybe<BooleanFilter>;
  hasRoute?: InputMaybe<BooleanFilter>;
  hideFromBilling?: InputMaybe<BooleanFilter>;
  paperworkComplete?: InputMaybe<BooleanFilter>;
  pickupOrDelivery?: InputMaybe<PickupOrDelivery>;
  isPickupOrDelivery?: InputMaybe<BooleanFilter>;
  inboundNotArrived?: InputMaybe<BooleanFilter>;
  requiresRouting?: InputMaybe<BooleanFilter>;
  requiresRecovery?: InputMaybe<BooleanFilter>;
  serviceUuids?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  showConsolidatedOrders?: InputMaybe<BooleanFilter>;
  standardStopType?: InputMaybe<StandardStopType>;
  stopTypesFilter?: InputMaybe<StopTypesFilter>;
  tagUuids?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  totalCount?: InputMaybe<Scalars['Boolean']['input']>;
  transferPending?: InputMaybe<BooleanFilter>;
  uuids?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  searchRefNumbersOnly?: InputMaybe<Scalars['Boolean']['input']>;
  searchMiscInfoOnly?: InputMaybe<Scalars['Boolean']['input']>;
  useMultiSearch?: InputMaybe<Scalars['Boolean']['input']>;
  sortByCustomerNameAscending?: InputMaybe<Scalars['Boolean']['input']>;
  versionId?: InputMaybe<Scalars['Float']['input']>;
}>;


export type TypeaheadOrderUuidsQueryQuery = { __typename?: 'Query', orders: { __typename?: 'OrderConnection', versionId?: number | null, edges: Array<{ __typename?: 'OrderEdge', node: { __typename?: 'StandardOrderEntity', uuid: string, name: string, status: OrderStatus, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', shipperBillOfLadingNumber?: string | null }, billingPartyContact: { __typename?: 'CustomerContactEntity', uuid: string, invoiceTimePeriodSplit?: TimePeriod | null, numberOfOrdersPerInvoice?: number | null, displayName: string }, shipments: Array<{ __typename?: 'StandardShipmentEntity', uuid: string, hideFromBilling: boolean, invoice?: { __typename?: 'InvoiceEntity', uuid: string } | null }>, ordersProratedWith?: Array<{ __typename?: 'StandardOrderEntity', uuid: string, name: string, status: OrderStatus, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', shipperBillOfLadingNumber?: string | null } }> | null } }>, pageInfo: { __typename?: 'PageInfo', startCursor?: string | null, endCursor?: string | null, hasNextPage: boolean, hasPreviousPage: boolean } } };

export type OrderRevenueReportQueryVariables = Exact<{
  orderRevenueReportInput: OrderRevenueReportInput;
}>;


export type OrderRevenueReportQuery = { __typename?: 'Query', orderRevenueReport: { __typename?: 'RevenueReportOrderConnection', edges: Array<{ __typename?: 'RevenueReportOrderEdge', node: { __typename?: 'RevenueReportOrderEntity', uuid: string, name: string, totalCharge: number, shipperBillOfLadingNumber?: string | null, masterAirwayBillOfLadingNumber?: string | null, contactUuid: string, contactName: string, contactReferenceNumber?: string | null, packageQuantity: number, packageWeight: number, podUploaded: boolean, stopTypes: Array<StopType>, serviceDates: Array<any>, controllingTerminalCode?: string | null, inboundAddressString?: string | null, outboundAddressString?: string | null, detailedStatusV2?: OrderDetailedStatus | null, inboundStopType?: OriginStopType | null, outboundStopType?: DestinationStopType | null } }>, pageInfo: { __typename?: 'PageInfo', startCursor?: string | null, endCursor?: string | null, hasPreviousPage: boolean, hasNextPage: boolean } } };

export type UnpostInvoiceMutationVariables = Exact<{
  unpostInvoiceInput: UnpostInvoiceInput;
}>;


export type UnpostInvoiceMutation = { __typename?: 'Mutation', unpostInvoice: { __typename?: 'UnpostInvoiceOutput', success: boolean } };

export type CreateItemMutationVariables = Exact<{
  input: CreateItemInput;
}>;


export type CreateItemMutation = { __typename?: 'Mutation', createItem: { __typename?: 'CreateItemOutput', error?: string | null, item?: { __typename?: 'ItemEntity', uuid: string, description?: string | null, sku: string, primaryUOM: { __typename?: 'InventoryPrimaryUnitOfMeasureEntity', unitOfMeasure: UnitOfMeasure }, secondaryUOM?: { __typename?: 'InventorySecondaryUnitOfMeasureEntity', unitOfMeasure: UnitOfMeasure } | null, warehouse: { __typename?: 'WarehouseEntity', uuid: string, name: string } } | null } };

export type ContactItemsItemFragment = { __typename?: 'ItemEntity', uuid: string, sku: string, description?: string | null, primaryUOM: { __typename?: 'InventoryPrimaryUnitOfMeasureEntity', unitOfMeasure: UnitOfMeasure }, secondaryUOM?: { __typename?: 'InventorySecondaryUnitOfMeasureEntity', unitOfMeasure: UnitOfMeasure } | null };

export type ContactItemsQueryVariables = Exact<{
  findContactItemsInput: FindContactItemsInput;
}>;


export type ContactItemsQuery = { __typename?: 'Query', contactItems: { __typename?: 'FindContactItemsOutput', items: Array<{ __typename?: 'ItemEntity', uuid: string, sku: string, description?: string | null, primaryUOM: { __typename?: 'InventoryPrimaryUnitOfMeasureEntity', unitOfMeasure: UnitOfMeasure }, secondaryUOM?: { __typename?: 'InventorySecondaryUnitOfMeasureEntity', unitOfMeasure: UnitOfMeasure } | null }> } };

export type ItemInventorySummaryQueryVariables = Exact<{
  contactUuid?: InputMaybe<Scalars['String']['input']>;
  warehouseUuid?: InputMaybe<Scalars['String']['input']>;
}>;


export type ItemInventorySummaryQuery = { __typename?: 'Query', items: { __typename?: 'ItemConnection', edges: Array<{ __typename?: 'ItemEdge', node: { __typename?: 'ItemEntity', uuid: string, sku: string, description?: string | null, quantity: number, storageUnitsCount: number, contact: { __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string }, warehouse: { __typename?: 'WarehouseEntity', uuid: string, name: string }, storageOrders: Array<{ __typename?: 'StorageOrderEntity', uuid: string, referenceNumber: string }> } }> } };

export type ItemQueryVariables = Exact<{
  itemUuid: Scalars['String']['input'];
}>;


export type ItemQuery = { __typename?: 'Query', item: { __typename?: 'ItemEntity', uuid: string, sku: string, description?: string | null, status: ItemStatus, contact: { __typename?: 'CustomerContactEntity', uuid: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string }, warehouse: { __typename?: 'WarehouseEntity', uuid: string, name: string }, primaryUOM: { __typename?: 'InventoryPrimaryUnitOfMeasureEntity', uuid: string, unitOfMeasure: UnitOfMeasure, upcCode?: string | null }, secondaryUOM?: { __typename?: 'InventorySecondaryUnitOfMeasureEntity', uuid: string, unitOfMeasure: UnitOfMeasure, upcCode?: string | null, primaryUnitsPerSecondaryUOM?: number | null } | null, itemStorageUnitConfig?: { __typename?: 'ItemStorageUnitConfigEntity', uuid: string, type: MeasurementUnits, length: number, width: number, height: number, weight: number, consolidationUnitUOM: UnitOfMeasure, primaryUnitsPerConsolidationUnit: number, weightUOM: WarehouseMeasurementUnits, dimensionsUOM: WarehouseMeasurementUnits, tie: number, high: number } | null } };

export type ItemsBySkuNameQueryVariables = Exact<{
  contactUuid?: InputMaybe<Scalars['String']['input']>;
  sku: Scalars['String']['input'];
}>;


export type ItemsBySkuNameQuery = { __typename?: 'Query', itemsBySkuName: Array<{ __typename?: 'ItemEntity', uuid: string, description?: string | null, sku: string, primaryUOM: { __typename?: 'InventoryPrimaryUnitOfMeasureEntity', unitOfMeasure: UnitOfMeasure }, secondaryUOM?: { __typename?: 'InventorySecondaryUnitOfMeasureEntity', unitOfMeasure: UnitOfMeasure } | null, warehouse: { __typename?: 'WarehouseEntity', uuid: string, name: string } }> };

export type ShallowItemFragment = { __typename?: 'ItemEntity', uuid: string, description?: string | null, sku: string, primaryUOM: { __typename?: 'InventoryPrimaryUnitOfMeasureEntity', unitOfMeasure: UnitOfMeasure }, secondaryUOM?: { __typename?: 'InventorySecondaryUnitOfMeasureEntity', unitOfMeasure: UnitOfMeasure } | null, warehouse: { __typename?: 'WarehouseEntity', uuid: string, name: string } };

export type ShallowItemsQueryVariables = Exact<{
  contactUuid: Scalars['String']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  searchText?: InputMaybe<Scalars['String']['input']>;
  warehouseUuid?: InputMaybe<Scalars['String']['input']>;
}>;


export type ShallowItemsQuery = { __typename?: 'Query', items: { __typename?: 'ItemConnection', edges: Array<{ __typename?: 'ItemEdge', node: { __typename?: 'ItemEntity', uuid: string, description?: string | null, sku: string, primaryUOM: { __typename?: 'InventoryPrimaryUnitOfMeasureEntity', unitOfMeasure: UnitOfMeasure }, secondaryUOM?: { __typename?: 'InventorySecondaryUnitOfMeasureEntity', unitOfMeasure: UnitOfMeasure } | null, warehouse: { __typename?: 'WarehouseEntity', uuid: string, name: string } } }>, pageInfo: { __typename?: 'PageInfo', startCursor?: string | null, endCursor?: string | null, hasNextPage: boolean, hasPreviousPage: boolean } } };

export type UpdateItemMutationVariables = Exact<{
  input: UpdateItemInput;
}>;


export type UpdateItemMutation = { __typename?: 'Mutation', updateItem: { __typename?: 'ItemEntity', uuid: string, description?: string | null, sku: string, primaryUOM: { __typename?: 'InventoryPrimaryUnitOfMeasureEntity', unitOfMeasure: UnitOfMeasure }, secondaryUOM?: { __typename?: 'InventorySecondaryUnitOfMeasureEntity', unitOfMeasure: UnitOfMeasure } | null, warehouse: { __typename?: 'WarehouseEntity', uuid: string, name: string } } };

export type GenerateLabelMutationVariables = Exact<{
  generateLabelInput: GenerateLabelInput;
}>;


export type GenerateLabelMutation = { __typename?: 'Mutation', generateLabel: string };

export type LegInfoFragment = { __typename?: 'LegEntity', miles?: number | null, flatRate?: number | null, name: string, uuid: string, completedAt?: any | null, endStop: { __typename?: 'StandardStopEntity', completedAt?: any | null, address: { __typename?: 'AddressEntity', name: string } }, shipment: { __typename?: 'StandardShipmentEntity', name: string, totalChargesAmount: number, totalChargesForDriverSettlement: number, uuid: string, charges: Array<{ __typename?: 'CustomChargeEntity', total: number } | { __typename?: 'FreightChargeEntity', total: number }>, legs: Array<{ __typename?: 'LegEntity', uuid: string }>, standardShipmentFields: { __typename?: 'StandardShipmentFieldsEntity', uuid: string, pickupOrDelivery: PickupOrDelivery }, order?: { __typename?: 'StandardOrderEntity', uuid: string, name: string, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', shipperBillOfLadingNumber?: string | null }, shipments: Array<{ __typename?: 'StandardShipmentEntity', uuid: string, name: string }> } | null } };

export type AddOrdersToManifestV2MutationVariables = Exact<{
  addOrdersToManifestV2Input: AddOrdersToManifestV2Input;
}>;


export type AddOrdersToManifestV2Mutation = { __typename?: 'Mutation', addOrdersToManifestV2: { __typename: 'AddOrdersToManifestV2PreviousManifestErrorOutput', previousManifestErrors: Array<{ __typename?: 'PreviousManifestError', order: { __typename?: 'StandardOrderEntity', name: string, endStop?: { __typename?: 'StandardStopEntity', terminal?: { __typename?: 'TerminalEntity', name: string } | null } | null } }>, originTerminalMismatchErrors: Array<{ __typename?: 'OriginTerminalMismatchError', order: { __typename?: 'StandardOrderEntity', name: string } }> } | { __typename: 'AddOrdersToManifestV2SuccessOutput', lineHaulManifest: { __typename?: 'LineHaulManifestEntity', referenceNumber: string, createdAt: any, departDate: any, status: LineHaulManifestStatus, startedAt?: any | null, completedAt?: any | null, uuid: string, sentToAgentAt?: any | null, confirmedByAgentAt?: any | null, startTerminal: { __typename?: 'TerminalEntity', uuid: string, code: string }, endTerminal: { __typename?: 'TerminalEntity', uuid: string, code: string }, driver?: { __typename?: 'DriverEntity', uuid: string, driverReferenceNumber?: string | null, firstName: string, lastName: string, agent?: { __typename?: 'AgentFieldsEntity', name: string } | null } | null, equipment?: { __typename?: 'EquipmentEntity', uuid: string, name: string, type: EquipmentType } | null, orders: Array<{ __typename?: 'StandardOrderEntity', uuid: string, name: string, weight: number, dimWeight: number, pieceCountFromPackages: number, hazmat?: boolean | null, refNumbers: Array<string>, dateMarkedReceivedAtOrigin?: any | null, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', shipperBillOfLadingNumber?: string | null, masterAirwayBillOfLadingNumber?: string | null }, tags: Array<{ __typename?: 'TagEntity', value: string }>, packages: Array<{ __typename?: 'PackageEntity', length?: number | null, width?: number | null, height?: number | null, weight?: number | null }>, billingPartyContact: { __typename?: 'CustomerContactEntity', displayName: string }, shipments: Array<{ __typename?: 'StandardShipmentEntity', standardShipmentFields: { __typename?: 'StandardShipmentFieldsEntity', deadlineDate?: any | null }, legs: Array<{ __typename?: 'LegEntity', endStop: { __typename?: 'StandardStopEntity', stopType?: StopType | null, inboundMethod?: InboundMethod | null, outboundMethod?: OutboundMethod | null, serviceDate?: any | null, incomingCarrier?: string | null, outboundCarrier?: string | null, address: { __typename?: 'AddressEntity', name: string, line1: string, line2?: string | null, city: string, state: string, zip: string } } }> }> }>, orderSegments: Array<{ __typename?: 'OrderLineHaulSegmentEntity', arrivedAt?: any | null, order: { __typename?: 'StandardOrderEntity', uuid: string, name: string, detailedStatusV2?: OrderDetailedStatus | null, receivedDate?: any | null, osd?: boolean | null, status: OrderStatus, weight: number, dimWeight: number, lineHaulServiceDisplayString: string, pieceCountFromPackages: number, refNumbers: Array<string>, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', weightUnits: WeightUnits, shipperBillOfLadingNumber?: string | null, masterAirwayBillOfLadingNumber?: string | null }, tags: Array<{ __typename?: 'TagEntity', uuid: string, value: string, color?: string | null }>, lineHaulLane?: { __typename?: 'LineHaulLaneEntity', uuid: string, name: string, isActive: boolean, originTerminal: { __typename?: 'TerminalEntity', uuid: string, code: string }, destinationTerminal: { __typename?: 'TerminalEntity', uuid: string, code: string } } | null, packages: Array<{ __typename?: 'PackageEntity', uuid: string, length?: number | null, width?: number | null, height?: number | null, weight?: number | null, type?: PackageType | null }>, billingPartyContact: { __typename?: 'CustomerContactEntity', displayName: string } }, arrivalScans: Array<{ __typename?: 'ScanEntity', uuid: string, scannedAt: any }>, departureScans: Array<{ __typename?: 'ScanEntity', uuid: string, scannedAt: any }> }> } } | { __typename: 'MutationErrorOutput', message: string } };

export type AddOrdersToManifestMutationVariables = Exact<{
  addOrdersToManifestInput: AddOrdersToManifestInput;
}>;


export type AddOrdersToManifestMutation = { __typename?: 'Mutation', addOrdersToManifest: { __typename?: 'AddOrdersToManifestOutput', errorMessage?: string | null, lineHaulManifest?: { __typename?: 'LineHaulManifestEntity', referenceNumber: string, createdAt: any, departDate: any, status: LineHaulManifestStatus, startedAt?: any | null, completedAt?: any | null, uuid: string, sentToAgentAt?: any | null, confirmedByAgentAt?: any | null, startTerminal: { __typename?: 'TerminalEntity', uuid: string, code: string }, endTerminal: { __typename?: 'TerminalEntity', uuid: string, code: string }, driver?: { __typename?: 'DriverEntity', uuid: string, driverReferenceNumber?: string | null, firstName: string, lastName: string, agent?: { __typename?: 'AgentFieldsEntity', name: string } | null } | null, equipment?: { __typename?: 'EquipmentEntity', uuid: string, name: string, type: EquipmentType } | null, orders: Array<{ __typename?: 'StandardOrderEntity', uuid: string, name: string, weight: number, dimWeight: number, pieceCountFromPackages: number, hazmat?: boolean | null, refNumbers: Array<string>, dateMarkedReceivedAtOrigin?: any | null, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', shipperBillOfLadingNumber?: string | null, masterAirwayBillOfLadingNumber?: string | null }, tags: Array<{ __typename?: 'TagEntity', value: string }>, packages: Array<{ __typename?: 'PackageEntity', length?: number | null, width?: number | null, height?: number | null, weight?: number | null }>, billingPartyContact: { __typename?: 'CustomerContactEntity', displayName: string }, shipments: Array<{ __typename?: 'StandardShipmentEntity', standardShipmentFields: { __typename?: 'StandardShipmentFieldsEntity', deadlineDate?: any | null }, legs: Array<{ __typename?: 'LegEntity', endStop: { __typename?: 'StandardStopEntity', stopType?: StopType | null, inboundMethod?: InboundMethod | null, outboundMethod?: OutboundMethod | null, serviceDate?: any | null, incomingCarrier?: string | null, outboundCarrier?: string | null, address: { __typename?: 'AddressEntity', name: string, line1: string, line2?: string | null, city: string, state: string, zip: string } } }> }> }>, orderSegments: Array<{ __typename?: 'OrderLineHaulSegmentEntity', arrivedAt?: any | null, order: { __typename?: 'StandardOrderEntity', uuid: string, name: string, detailedStatusV2?: OrderDetailedStatus | null, receivedDate?: any | null, osd?: boolean | null, status: OrderStatus, weight: number, dimWeight: number, lineHaulServiceDisplayString: string, pieceCountFromPackages: number, refNumbers: Array<string>, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', weightUnits: WeightUnits, shipperBillOfLadingNumber?: string | null, masterAirwayBillOfLadingNumber?: string | null }, tags: Array<{ __typename?: 'TagEntity', uuid: string, value: string, color?: string | null }>, lineHaulLane?: { __typename?: 'LineHaulLaneEntity', uuid: string, name: string, isActive: boolean, originTerminal: { __typename?: 'TerminalEntity', uuid: string, code: string }, destinationTerminal: { __typename?: 'TerminalEntity', uuid: string, code: string } } | null, packages: Array<{ __typename?: 'PackageEntity', uuid: string, length?: number | null, width?: number | null, height?: number | null, weight?: number | null, type?: PackageType | null }>, billingPartyContact: { __typename?: 'CustomerContactEntity', displayName: string } }, arrivalScans: Array<{ __typename?: 'ScanEntity', uuid: string, scannedAt: any }>, departureScans: Array<{ __typename?: 'ScanEntity', uuid: string, scannedAt: any }> }> } | null } };

export type CreateLineHaulManifestMutationVariables = Exact<{
  createLineHaulManifestInput: CreateLineHaulManifestInput;
}>;


export type CreateLineHaulManifestMutation = { __typename?: 'Mutation', createLineHaulManifest: { __typename?: 'LineHaulManifestEntity', referenceNumber: string, createdAt: any, departDate: any, status: LineHaulManifestStatus, startedAt?: any | null, completedAt?: any | null, uuid: string, sentToAgentAt?: any | null, confirmedByAgentAt?: any | null, startTerminal: { __typename?: 'TerminalEntity', uuid: string, code: string }, endTerminal: { __typename?: 'TerminalEntity', uuid: string, code: string }, driver?: { __typename?: 'DriverEntity', uuid: string, driverReferenceNumber?: string | null, firstName: string, lastName: string, agent?: { __typename?: 'AgentFieldsEntity', name: string } | null } | null, equipment?: { __typename?: 'EquipmentEntity', uuid: string, name: string, type: EquipmentType } | null, orders: Array<{ __typename?: 'StandardOrderEntity', uuid: string, name: string, weight: number, dimWeight: number, pieceCountFromPackages: number, hazmat?: boolean | null, refNumbers: Array<string>, dateMarkedReceivedAtOrigin?: any | null, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', shipperBillOfLadingNumber?: string | null, masterAirwayBillOfLadingNumber?: string | null }, tags: Array<{ __typename?: 'TagEntity', value: string }>, packages: Array<{ __typename?: 'PackageEntity', length?: number | null, width?: number | null, height?: number | null, weight?: number | null }>, billingPartyContact: { __typename?: 'CustomerContactEntity', displayName: string }, shipments: Array<{ __typename?: 'StandardShipmentEntity', standardShipmentFields: { __typename?: 'StandardShipmentFieldsEntity', deadlineDate?: any | null }, legs: Array<{ __typename?: 'LegEntity', endStop: { __typename?: 'StandardStopEntity', stopType?: StopType | null, inboundMethod?: InboundMethod | null, outboundMethod?: OutboundMethod | null, serviceDate?: any | null, incomingCarrier?: string | null, outboundCarrier?: string | null, address: { __typename?: 'AddressEntity', name: string, line1: string, line2?: string | null, city: string, state: string, zip: string } } }> }> }>, orderSegments: Array<{ __typename?: 'OrderLineHaulSegmentEntity', arrivedAt?: any | null, order: { __typename?: 'StandardOrderEntity', uuid: string, name: string, detailedStatusV2?: OrderDetailedStatus | null, receivedDate?: any | null, osd?: boolean | null, status: OrderStatus, weight: number, dimWeight: number, lineHaulServiceDisplayString: string, pieceCountFromPackages: number, refNumbers: Array<string>, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', weightUnits: WeightUnits, shipperBillOfLadingNumber?: string | null, masterAirwayBillOfLadingNumber?: string | null }, tags: Array<{ __typename?: 'TagEntity', uuid: string, value: string, color?: string | null }>, lineHaulLane?: { __typename?: 'LineHaulLaneEntity', uuid: string, name: string, isActive: boolean, originTerminal: { __typename?: 'TerminalEntity', uuid: string, code: string }, destinationTerminal: { __typename?: 'TerminalEntity', uuid: string, code: string } } | null, packages: Array<{ __typename?: 'PackageEntity', uuid: string, length?: number | null, width?: number | null, height?: number | null, weight?: number | null, type?: PackageType | null }>, billingPartyContact: { __typename?: 'CustomerContactEntity', displayName: string } }, arrivalScans: Array<{ __typename?: 'ScanEntity', uuid: string, scannedAt: any }>, departureScans: Array<{ __typename?: 'ScanEntity', uuid: string, scannedAt: any }> }> } };

export type CreateLineHaulManifestsMutationVariables = Exact<{
  input: CreateLineHaulManifestsInput;
}>;


export type CreateLineHaulManifestsMutation = { __typename?: 'Mutation', createLineHaulManifests: { __typename: 'CreateLineHaulManifestsSuccessOutput', lineHaulManifests: Array<{ __typename?: 'LineHaulManifestEntity', uuid: string }> } | { __typename: 'MutationErrorOutput', message: string } };

export type DetailedLineHaulManifestFragment = { __typename?: 'LineHaulManifestEntity', referenceNumber: string, createdAt: any, departDate: any, status: LineHaulManifestStatus, startedAt?: any | null, completedAt?: any | null, uuid: string, sentToAgentAt?: any | null, confirmedByAgentAt?: any | null, startTerminal: { __typename?: 'TerminalEntity', uuid: string, code: string }, endTerminal: { __typename?: 'TerminalEntity', uuid: string, code: string }, driver?: { __typename?: 'DriverEntity', uuid: string, driverReferenceNumber?: string | null, firstName: string, lastName: string, agent?: { __typename?: 'AgentFieldsEntity', name: string } | null } | null, equipment?: { __typename?: 'EquipmentEntity', uuid: string, name: string, type: EquipmentType } | null, orders: Array<{ __typename?: 'StandardOrderEntity', uuid: string, name: string, weight: number, dimWeight: number, pieceCountFromPackages: number, hazmat?: boolean | null, refNumbers: Array<string>, dateMarkedReceivedAtOrigin?: any | null, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', shipperBillOfLadingNumber?: string | null, masterAirwayBillOfLadingNumber?: string | null }, tags: Array<{ __typename?: 'TagEntity', value: string }>, packages: Array<{ __typename?: 'PackageEntity', length?: number | null, width?: number | null, height?: number | null, weight?: number | null }>, billingPartyContact: { __typename?: 'CustomerContactEntity', displayName: string }, shipments: Array<{ __typename?: 'StandardShipmentEntity', standardShipmentFields: { __typename?: 'StandardShipmentFieldsEntity', deadlineDate?: any | null }, legs: Array<{ __typename?: 'LegEntity', endStop: { __typename?: 'StandardStopEntity', stopType?: StopType | null, inboundMethod?: InboundMethod | null, outboundMethod?: OutboundMethod | null, serviceDate?: any | null, incomingCarrier?: string | null, outboundCarrier?: string | null, address: { __typename?: 'AddressEntity', name: string, line1: string, line2?: string | null, city: string, state: string, zip: string } } }> }> }>, orderSegments: Array<{ __typename?: 'OrderLineHaulSegmentEntity', arrivedAt?: any | null, order: { __typename?: 'StandardOrderEntity', uuid: string, name: string, detailedStatusV2?: OrderDetailedStatus | null, receivedDate?: any | null, osd?: boolean | null, status: OrderStatus, weight: number, dimWeight: number, lineHaulServiceDisplayString: string, pieceCountFromPackages: number, refNumbers: Array<string>, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', weightUnits: WeightUnits, shipperBillOfLadingNumber?: string | null, masterAirwayBillOfLadingNumber?: string | null }, tags: Array<{ __typename?: 'TagEntity', uuid: string, value: string, color?: string | null }>, lineHaulLane?: { __typename?: 'LineHaulLaneEntity', uuid: string, name: string, isActive: boolean, originTerminal: { __typename?: 'TerminalEntity', uuid: string, code: string }, destinationTerminal: { __typename?: 'TerminalEntity', uuid: string, code: string } } | null, packages: Array<{ __typename?: 'PackageEntity', uuid: string, length?: number | null, width?: number | null, height?: number | null, weight?: number | null, type?: PackageType | null }>, billingPartyContact: { __typename?: 'CustomerContactEntity', displayName: string } }, arrivalScans: Array<{ __typename?: 'ScanEntity', uuid: string, scannedAt: any }>, departureScans: Array<{ __typename?: 'ScanEntity', uuid: string, scannedAt: any }> }> };

export type GetLineHaulProgressQueryVariables = Exact<{
  getLineHaulProgressInput: GetLineHaulProgressInput;
}>;


export type GetLineHaulProgressQuery = { __typename?: 'Query', getLineHaulProgress: { __typename?: 'GetLineHaulProgressOutput', terminalStatuses: Array<{ __typename?: 'LineHaulStatusByTerminal', markedArrivedAt?: any | null, terminal: { __typename?: 'TerminalEntity', uuid: string, code: string }, manifestDepartingFromThisTerminal?: { __typename?: 'LineHaulManifestEntity', uuid: string, status: LineHaulManifestStatus, departDate: any, startedAt?: any | null, completedAt?: any | null, referenceNumber: string, driver?: { __typename?: 'DriverEntity', firstName: string, lastName: string } | null } | null, arrivalScans: Array<{ __typename?: 'ScanEntity', uuid: string, scannedAt: any }>, departureScans: Array<{ __typename?: 'ScanEntity', uuid: string, scannedAt: any }> }> } };

export type TerminalLineHaulStatusFragment = { __typename?: 'LineHaulStatusByTerminal', markedArrivedAt?: any | null, terminal: { __typename?: 'TerminalEntity', uuid: string, code: string }, manifestDepartingFromThisTerminal?: { __typename?: 'LineHaulManifestEntity', uuid: string, status: LineHaulManifestStatus, departDate: any, startedAt?: any | null, completedAt?: any | null, referenceNumber: string, driver?: { __typename?: 'DriverEntity', firstName: string, lastName: string } | null } | null, arrivalScans: Array<{ __typename?: 'ScanEntity', uuid: string, scannedAt: any }>, departureScans: Array<{ __typename?: 'ScanEntity', uuid: string, scannedAt: any }> };

export type LineHaulManifestGroupsQueryVariables = Exact<{
  input: LineHaulManifestsGroupsInput;
}>;


export type LineHaulManifestGroupsQuery = { __typename?: 'Query', lineHaulManifestsGroups: { __typename?: 'LineHaulManifestsCategoryGroupsOutput', category: LineHaulManifestsGroupBy, groups: Array<{ __typename?: 'ManifestGroup', category: LineHaulManifestsGroupBy, manifests: Array<{ __typename?: 'LineHaulManifestEntity', referenceNumber: string, createdAt: any, departDate: any, status: LineHaulManifestStatus, startedAt?: any | null, completedAt?: any | null, uuid: string, sentToAgentAt?: any | null, confirmedByAgentAt?: any | null, startTerminal: { __typename?: 'TerminalEntity', uuid: string, code: string }, endTerminal: { __typename?: 'TerminalEntity', uuid: string, code: string }, driver?: { __typename?: 'DriverEntity', uuid: string, driverReferenceNumber?: string | null, firstName: string, lastName: string, agent?: { __typename?: 'AgentFieldsEntity', name: string } | null } | null, equipment?: { __typename?: 'EquipmentEntity', uuid: string, name: string, type: EquipmentType } | null, orders: Array<{ __typename?: 'StandardOrderEntity', uuid: string, name: string, weight: number, dimWeight: number, pieceCountFromPackages: number, hazmat?: boolean | null, refNumbers: Array<string>, dateMarkedReceivedAtOrigin?: any | null, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', shipperBillOfLadingNumber?: string | null, masterAirwayBillOfLadingNumber?: string | null }, tags: Array<{ __typename?: 'TagEntity', value: string }>, packages: Array<{ __typename?: 'PackageEntity', length?: number | null, width?: number | null, height?: number | null, weight?: number | null }>, billingPartyContact: { __typename?: 'CustomerContactEntity', displayName: string }, shipments: Array<{ __typename?: 'StandardShipmentEntity', standardShipmentFields: { __typename?: 'StandardShipmentFieldsEntity', deadlineDate?: any | null }, legs: Array<{ __typename?: 'LegEntity', endStop: { __typename?: 'StandardStopEntity', stopType?: StopType | null, inboundMethod?: InboundMethod | null, outboundMethod?: OutboundMethod | null, serviceDate?: any | null, incomingCarrier?: string | null, outboundCarrier?: string | null, address: { __typename?: 'AddressEntity', name: string, line1: string, line2?: string | null, city: string, state: string, zip: string } } }> }> }>, orderSegments: Array<{ __typename?: 'OrderLineHaulSegmentEntity', arrivedAt?: any | null, order: { __typename?: 'StandardOrderEntity', uuid: string, name: string, detailedStatusV2?: OrderDetailedStatus | null, receivedDate?: any | null, osd?: boolean | null, status: OrderStatus, weight: number, dimWeight: number, lineHaulServiceDisplayString: string, pieceCountFromPackages: number, refNumbers: Array<string>, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', weightUnits: WeightUnits, shipperBillOfLadingNumber?: string | null, masterAirwayBillOfLadingNumber?: string | null }, tags: Array<{ __typename?: 'TagEntity', uuid: string, value: string, color?: string | null }>, lineHaulLane?: { __typename?: 'LineHaulLaneEntity', uuid: string, name: string, isActive: boolean, originTerminal: { __typename?: 'TerminalEntity', uuid: string, code: string }, destinationTerminal: { __typename?: 'TerminalEntity', uuid: string, code: string } } | null, packages: Array<{ __typename?: 'PackageEntity', uuid: string, length?: number | null, width?: number | null, height?: number | null, weight?: number | null, type?: PackageType | null }>, billingPartyContact: { __typename?: 'CustomerContactEntity', displayName: string } }, arrivalScans: Array<{ __typename?: 'ScanEntity', uuid: string, scannedAt: any }>, departureScans: Array<{ __typename?: 'ScanEntity', uuid: string, scannedAt: any }> }> }> }> } };

export type LineHaulManifestOrderFragment = { __typename?: 'StandardOrderEntity', uuid: string, weight: number, dimWeight: number, refNumbers: Array<string>, name: string, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', shipperBillOfLadingNumber?: string | null, weightUnits: WeightUnits }, packages: Array<{ __typename?: 'PackageEntity', uuid: string, length?: number | null, width?: number | null, height?: number | null, weight?: number | null, quantity: number, type?: PackageType | null }>, billingPartyContact: { __typename?: 'CustomerContactEntity', displayName: string } };

export type LineHaulManifestQueryVariables = Exact<{
  uuid: Scalars['String']['input'];
}>;


export type LineHaulManifestQuery = { __typename?: 'Query', lineHaulManifest: { __typename?: 'LineHaulManifestEntity', referenceNumber: string, createdAt: any, departDate: any, status: LineHaulManifestStatus, startedAt?: any | null, completedAt?: any | null, uuid: string, sentToAgentAt?: any | null, confirmedByAgentAt?: any | null, startTerminal: { __typename?: 'TerminalEntity', uuid: string, code: string }, endTerminal: { __typename?: 'TerminalEntity', uuid: string, code: string }, driver?: { __typename?: 'DriverEntity', uuid: string, driverReferenceNumber?: string | null, firstName: string, lastName: string, agent?: { __typename?: 'AgentFieldsEntity', name: string } | null } | null, equipment?: { __typename?: 'EquipmentEntity', uuid: string, name: string, type: EquipmentType } | null, orders: Array<{ __typename?: 'StandardOrderEntity', uuid: string, name: string, weight: number, dimWeight: number, pieceCountFromPackages: number, hazmat?: boolean | null, refNumbers: Array<string>, dateMarkedReceivedAtOrigin?: any | null, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', shipperBillOfLadingNumber?: string | null, masterAirwayBillOfLadingNumber?: string | null }, tags: Array<{ __typename?: 'TagEntity', value: string }>, packages: Array<{ __typename?: 'PackageEntity', length?: number | null, width?: number | null, height?: number | null, weight?: number | null }>, billingPartyContact: { __typename?: 'CustomerContactEntity', displayName: string }, shipments: Array<{ __typename?: 'StandardShipmentEntity', standardShipmentFields: { __typename?: 'StandardShipmentFieldsEntity', deadlineDate?: any | null }, legs: Array<{ __typename?: 'LegEntity', endStop: { __typename?: 'StandardStopEntity', stopType?: StopType | null, inboundMethod?: InboundMethod | null, outboundMethod?: OutboundMethod | null, serviceDate?: any | null, incomingCarrier?: string | null, outboundCarrier?: string | null, address: { __typename?: 'AddressEntity', name: string, line1: string, line2?: string | null, city: string, state: string, zip: string } } }> }> }>, orderSegments: Array<{ __typename?: 'OrderLineHaulSegmentEntity', arrivedAt?: any | null, order: { __typename?: 'StandardOrderEntity', uuid: string, name: string, detailedStatusV2?: OrderDetailedStatus | null, receivedDate?: any | null, osd?: boolean | null, status: OrderStatus, weight: number, dimWeight: number, lineHaulServiceDisplayString: string, pieceCountFromPackages: number, refNumbers: Array<string>, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', weightUnits: WeightUnits, shipperBillOfLadingNumber?: string | null, masterAirwayBillOfLadingNumber?: string | null }, tags: Array<{ __typename?: 'TagEntity', uuid: string, value: string, color?: string | null }>, lineHaulLane?: { __typename?: 'LineHaulLaneEntity', uuid: string, name: string, isActive: boolean, originTerminal: { __typename?: 'TerminalEntity', uuid: string, code: string }, destinationTerminal: { __typename?: 'TerminalEntity', uuid: string, code: string } } | null, packages: Array<{ __typename?: 'PackageEntity', uuid: string, length?: number | null, width?: number | null, height?: number | null, weight?: number | null, type?: PackageType | null }>, billingPartyContact: { __typename?: 'CustomerContactEntity', displayName: string } }, arrivalScans: Array<{ __typename?: 'ScanEntity', uuid: string, scannedAt: any }>, departureScans: Array<{ __typename?: 'ScanEntity', uuid: string, scannedAt: any }> }> } };

export type LineHaulManifestsForPrintQueryVariables = Exact<{
  date: Scalars['DateTime']['input'];
  uuids?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;


export type LineHaulManifestsForPrintQuery = { __typename?: 'Query', lineHaulManifests: { __typename?: 'FindLineHaulManifestsOutput', lineHaulManifests: Array<{ __typename?: 'LineHaulManifestEntity', referenceNumber: string, departDate: any, status: LineHaulManifestStatus, startedAt?: any | null, completedAt?: any | null, uuid: string, startTerminal: { __typename?: 'TerminalEntity', uuid: string, code: string }, endTerminal: { __typename?: 'TerminalEntity', uuid: string, code: string }, driver?: { __typename?: 'DriverEntity', uuid: string, driverReferenceNumber?: string | null, firstName: string, lastName: string } | null, equipment?: { __typename?: 'EquipmentEntity', uuid: string, name: string, type: EquipmentType } | null, orderSegments: Array<{ __typename?: 'OrderLineHaulSegmentEntity', order: { __typename?: 'StandardOrderEntity', uuid: string, name: string, dateMarkedReceivedAtOrigin?: any | null, weight: number, dimWeight: number, pieceCountFromPackages: number, refNumbers: Array<string>, hazmat?: boolean | null, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', masterAirwayBillOfLadingNumber?: string | null, shipperBillOfLadingNumber?: string | null }, lineHaulLane?: { __typename?: 'LineHaulLaneEntity', uuid: string, name: string, isActive: boolean, originTerminal: { __typename?: 'TerminalEntity', uuid: string, code: string }, destinationTerminal: { __typename?: 'TerminalEntity', uuid: string, code: string } } | null, tags: Array<{ __typename?: 'TagEntity', value: string }>, billingPartyContact: { __typename?: 'CustomerContactEntity', displayName: string }, shipments: Array<{ __typename?: 'StandardShipmentEntity', standardShipmentFields: { __typename?: 'StandardShipmentFieldsEntity', pickupOrDelivery: PickupOrDelivery, deadlineDate?: any | null }, airportInfo?: { __typename?: 'AirportInfoEntity', address: { __typename?: 'AddressEntity', name: string } } | null, legs: Array<{ __typename?: 'LegEntity', endStop: { __typename?: 'StandardStopEntity', stopType?: StopType | null, serviceDate?: any | null, inboundMethod?: InboundMethod | null, outboundMethod?: OutboundMethod | null, incomingCarrier?: string | null, outboundCarrier?: string | null, address: { __typename?: 'AddressEntity', name: string, line1: string, line2?: string | null, city: string, state: string, zip: string } } }> }> }, segment: { __typename?: 'LineHaulSegmentEntity', ordinal: number, startTerminal: { __typename?: 'TerminalEntity', name: string, code: string }, endTerminal: { __typename?: 'TerminalEntity', name: string, code: string } }, priorOrderLineHaulSegment?: { __typename?: 'OrderLineHaulSegmentEntity', arrivedAt?: any | null } | null }> }> } };

export type LineHaulManifestForPrintFragment = { __typename?: 'LineHaulManifestEntity', referenceNumber: string, departDate: any, status: LineHaulManifestStatus, startedAt?: any | null, completedAt?: any | null, uuid: string, startTerminal: { __typename?: 'TerminalEntity', uuid: string, code: string }, endTerminal: { __typename?: 'TerminalEntity', uuid: string, code: string }, driver?: { __typename?: 'DriverEntity', uuid: string, driverReferenceNumber?: string | null, firstName: string, lastName: string } | null, equipment?: { __typename?: 'EquipmentEntity', uuid: string, name: string, type: EquipmentType } | null, orderSegments: Array<{ __typename?: 'OrderLineHaulSegmentEntity', order: { __typename?: 'StandardOrderEntity', uuid: string, name: string, dateMarkedReceivedAtOrigin?: any | null, weight: number, dimWeight: number, pieceCountFromPackages: number, refNumbers: Array<string>, hazmat?: boolean | null, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', masterAirwayBillOfLadingNumber?: string | null, shipperBillOfLadingNumber?: string | null }, lineHaulLane?: { __typename?: 'LineHaulLaneEntity', uuid: string, name: string, isActive: boolean, originTerminal: { __typename?: 'TerminalEntity', uuid: string, code: string }, destinationTerminal: { __typename?: 'TerminalEntity', uuid: string, code: string } } | null, tags: Array<{ __typename?: 'TagEntity', value: string }>, billingPartyContact: { __typename?: 'CustomerContactEntity', displayName: string }, shipments: Array<{ __typename?: 'StandardShipmentEntity', standardShipmentFields: { __typename?: 'StandardShipmentFieldsEntity', pickupOrDelivery: PickupOrDelivery, deadlineDate?: any | null }, airportInfo?: { __typename?: 'AirportInfoEntity', address: { __typename?: 'AddressEntity', name: string } } | null, legs: Array<{ __typename?: 'LegEntity', endStop: { __typename?: 'StandardStopEntity', stopType?: StopType | null, serviceDate?: any | null, inboundMethod?: InboundMethod | null, outboundMethod?: OutboundMethod | null, incomingCarrier?: string | null, outboundCarrier?: string | null, address: { __typename?: 'AddressEntity', name: string, line1: string, line2?: string | null, city: string, state: string, zip: string } } }> }> }, segment: { __typename?: 'LineHaulSegmentEntity', ordinal: number, startTerminal: { __typename?: 'TerminalEntity', name: string, code: string }, endTerminal: { __typename?: 'TerminalEntity', name: string, code: string } }, priorOrderLineHaulSegment?: { __typename?: 'OrderLineHaulSegmentEntity', arrivedAt?: any | null } | null }> };

export type LineHaulOrderForPrintedManifestFragment = { __typename?: 'StandardOrderEntity', uuid: string, name: string, dateMarkedReceivedAtOrigin?: any | null, weight: number, dimWeight: number, pieceCountFromPackages: number, refNumbers: Array<string>, hazmat?: boolean | null, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', masterAirwayBillOfLadingNumber?: string | null, shipperBillOfLadingNumber?: string | null }, lineHaulLane?: { __typename?: 'LineHaulLaneEntity', uuid: string, name: string, isActive: boolean, originTerminal: { __typename?: 'TerminalEntity', uuid: string, code: string }, destinationTerminal: { __typename?: 'TerminalEntity', uuid: string, code: string } } | null, tags: Array<{ __typename?: 'TagEntity', value: string }>, billingPartyContact: { __typename?: 'CustomerContactEntity', displayName: string }, shipments: Array<{ __typename?: 'StandardShipmentEntity', standardShipmentFields: { __typename?: 'StandardShipmentFieldsEntity', pickupOrDelivery: PickupOrDelivery, deadlineDate?: any | null }, airportInfo?: { __typename?: 'AirportInfoEntity', address: { __typename?: 'AddressEntity', name: string } } | null, legs: Array<{ __typename?: 'LegEntity', endStop: { __typename?: 'StandardStopEntity', stopType?: StopType | null, serviceDate?: any | null, inboundMethod?: InboundMethod | null, outboundMethod?: OutboundMethod | null, incomingCarrier?: string | null, outboundCarrier?: string | null, address: { __typename?: 'AddressEntity', name: string, line1: string, line2?: string | null, city: string, state: string, zip: string } } }> }> };

export type LineHaulManifestsQueryVariables = Exact<{
  date: Scalars['DateTime']['input'];
  uuids?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;


export type LineHaulManifestsQuery = { __typename?: 'Query', lineHaulManifests: { __typename?: 'FindLineHaulManifestsOutput', lineHaulManifests: Array<{ __typename?: 'LineHaulManifestEntity', referenceNumber: string, createdAt: any, departDate: any, status: LineHaulManifestStatus, startedAt?: any | null, completedAt?: any | null, uuid: string, sentToAgentAt?: any | null, confirmedByAgentAt?: any | null, startTerminal: { __typename?: 'TerminalEntity', uuid: string, code: string }, endTerminal: { __typename?: 'TerminalEntity', uuid: string, code: string }, driver?: { __typename?: 'DriverEntity', uuid: string, driverReferenceNumber?: string | null, firstName: string, lastName: string, agent?: { __typename?: 'AgentFieldsEntity', name: string } | null } | null, equipment?: { __typename?: 'EquipmentEntity', uuid: string, name: string, type: EquipmentType } | null, orders: Array<{ __typename?: 'StandardOrderEntity', uuid: string, name: string, weight: number, dimWeight: number, pieceCountFromPackages: number, hazmat?: boolean | null, refNumbers: Array<string>, dateMarkedReceivedAtOrigin?: any | null, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', shipperBillOfLadingNumber?: string | null, masterAirwayBillOfLadingNumber?: string | null }, tags: Array<{ __typename?: 'TagEntity', value: string }>, packages: Array<{ __typename?: 'PackageEntity', length?: number | null, width?: number | null, height?: number | null, weight?: number | null }>, billingPartyContact: { __typename?: 'CustomerContactEntity', displayName: string }, shipments: Array<{ __typename?: 'StandardShipmentEntity', standardShipmentFields: { __typename?: 'StandardShipmentFieldsEntity', deadlineDate?: any | null }, legs: Array<{ __typename?: 'LegEntity', endStop: { __typename?: 'StandardStopEntity', stopType?: StopType | null, inboundMethod?: InboundMethod | null, outboundMethod?: OutboundMethod | null, serviceDate?: any | null, incomingCarrier?: string | null, outboundCarrier?: string | null, address: { __typename?: 'AddressEntity', name: string, line1: string, line2?: string | null, city: string, state: string, zip: string } } }> }> }>, orderSegments: Array<{ __typename?: 'OrderLineHaulSegmentEntity', arrivedAt?: any | null, order: { __typename?: 'StandardOrderEntity', uuid: string, name: string, detailedStatusV2?: OrderDetailedStatus | null, receivedDate?: any | null, osd?: boolean | null, status: OrderStatus, weight: number, dimWeight: number, lineHaulServiceDisplayString: string, pieceCountFromPackages: number, refNumbers: Array<string>, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', weightUnits: WeightUnits, shipperBillOfLadingNumber?: string | null, masterAirwayBillOfLadingNumber?: string | null }, tags: Array<{ __typename?: 'TagEntity', uuid: string, value: string, color?: string | null }>, lineHaulLane?: { __typename?: 'LineHaulLaneEntity', uuid: string, name: string, isActive: boolean, originTerminal: { __typename?: 'TerminalEntity', uuid: string, code: string }, destinationTerminal: { __typename?: 'TerminalEntity', uuid: string, code: string } } | null, packages: Array<{ __typename?: 'PackageEntity', uuid: string, length?: number | null, width?: number | null, height?: number | null, weight?: number | null, type?: PackageType | null }>, billingPartyContact: { __typename?: 'CustomerContactEntity', displayName: string } }, arrivalScans: Array<{ __typename?: 'ScanEntity', uuid: string, scannedAt: any }>, departureScans: Array<{ __typename?: 'ScanEntity', uuid: string, scannedAt: any }> }> }>, unmanifestedSegments: Array<{ __typename?: 'LineHaulSegmentEntity', uuid: string, ordinal: number, startTerminal: { __typename?: 'TerminalEntity', uuid: string, code: string }, endTerminal: { __typename?: 'TerminalEntity', uuid: string, code: string } }> } };

export type LineHaulOrderWithUpcomingSegmentAndInboundStopStatusFragment = { __typename?: 'StandardOrderEntity', uuid: string, hasNoneOrCompletedInboundStop: boolean, upcomingLineHaulSegment?: { __typename?: 'LineHaulSegmentEntity', uuid: string, ordinal: number, startTerminal: { __typename?: 'TerminalEntity', uuid: string, code: string }, endTerminal: { __typename?: 'TerminalEntity', uuid: string, code: string } } | null, lastCompletedLineHaulSegment?: { __typename?: 'LineHaulSegmentEntity', uuid: string, ordinal: number, startTerminal: { __typename?: 'TerminalEntity', uuid: string, code: string }, endTerminal: { __typename?: 'TerminalEntity', uuid: string, code: string } } | null };

export type LineHaulOrderFragment = { __typename?: 'StandardOrderEntity', uuid: string, name: string, detailedStatusV2?: OrderDetailedStatus | null, receivedDate?: any | null, osd?: boolean | null, status: OrderStatus, weight: number, dimWeight: number, lineHaulServiceDisplayString: string, pieceCountFromPackages: number, refNumbers: Array<string>, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', weightUnits: WeightUnits, shipperBillOfLadingNumber?: string | null, masterAirwayBillOfLadingNumber?: string | null }, tags: Array<{ __typename?: 'TagEntity', uuid: string, value: string, color?: string | null }>, lineHaulLane?: { __typename?: 'LineHaulLaneEntity', uuid: string, name: string, isActive: boolean, originTerminal: { __typename?: 'TerminalEntity', uuid: string, code: string }, destinationTerminal: { __typename?: 'TerminalEntity', uuid: string, code: string } } | null, packages: Array<{ __typename?: 'PackageEntity', uuid: string, length?: number | null, width?: number | null, height?: number | null, weight?: number | null, type?: PackageType | null }>, billingPartyContact: { __typename?: 'CustomerContactEntity', displayName: string } };

export type LineHaulOrdersWithUpcomingSegmentAndInboundStopStatusQueryVariables = Exact<{
  uuids: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type LineHaulOrdersWithUpcomingSegmentAndInboundStopStatusQuery = { __typename?: 'Query', ordersByUuids: Array<{ __typename?: 'StandardOrderEntity', uuid: string, hasNoneOrCompletedInboundStop: boolean, upcomingLineHaulSegment?: { __typename?: 'LineHaulSegmentEntity', uuid: string, ordinal: number, startTerminal: { __typename?: 'TerminalEntity', uuid: string, code: string }, endTerminal: { __typename?: 'TerminalEntity', uuid: string, code: string } } | null, lastCompletedLineHaulSegment?: { __typename?: 'LineHaulSegmentEntity', uuid: string, ordinal: number, startTerminal: { __typename?: 'TerminalEntity', uuid: string, code: string }, endTerminal: { __typename?: 'TerminalEntity', uuid: string, code: string } } | null }> };

export type LineHaulSegmentsQueryVariables = Exact<{ [key: string]: never; }>;


export type LineHaulSegmentsQuery = { __typename?: 'Query', lineHaulSegments: Array<{ __typename?: 'LineHaulSegmentEntity', uuid: string, ordinal: number, startTerminal: { __typename?: 'TerminalEntity', uuid: string, code: string }, endTerminal: { __typename?: 'TerminalEntity', uuid: string, code: string } }> };

export type MarkManifestAsArrivedMutationVariables = Exact<{
  markManifestAsArrivedInput: MarkManifestAsArrivedInput;
}>;


export type MarkManifestAsArrivedMutation = { __typename?: 'Mutation', markManifestAsArrived: { __typename?: 'MarkManifestAsArrivedOutput', errorMessage?: string | null, lineHaulManifest?: { __typename?: 'LineHaulManifestEntity', referenceNumber: string, createdAt: any, departDate: any, status: LineHaulManifestStatus, startedAt?: any | null, completedAt?: any | null, uuid: string, sentToAgentAt?: any | null, confirmedByAgentAt?: any | null, startTerminal: { __typename?: 'TerminalEntity', uuid: string, code: string }, endTerminal: { __typename?: 'TerminalEntity', uuid: string, code: string }, driver?: { __typename?: 'DriverEntity', uuid: string, driverReferenceNumber?: string | null, firstName: string, lastName: string, agent?: { __typename?: 'AgentFieldsEntity', name: string } | null } | null, equipment?: { __typename?: 'EquipmentEntity', uuid: string, name: string, type: EquipmentType } | null, orders: Array<{ __typename?: 'StandardOrderEntity', uuid: string, name: string, weight: number, dimWeight: number, pieceCountFromPackages: number, hazmat?: boolean | null, refNumbers: Array<string>, dateMarkedReceivedAtOrigin?: any | null, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', shipperBillOfLadingNumber?: string | null, masterAirwayBillOfLadingNumber?: string | null }, tags: Array<{ __typename?: 'TagEntity', value: string }>, packages: Array<{ __typename?: 'PackageEntity', length?: number | null, width?: number | null, height?: number | null, weight?: number | null }>, billingPartyContact: { __typename?: 'CustomerContactEntity', displayName: string }, shipments: Array<{ __typename?: 'StandardShipmentEntity', standardShipmentFields: { __typename?: 'StandardShipmentFieldsEntity', deadlineDate?: any | null }, legs: Array<{ __typename?: 'LegEntity', endStop: { __typename?: 'StandardStopEntity', stopType?: StopType | null, inboundMethod?: InboundMethod | null, outboundMethod?: OutboundMethod | null, serviceDate?: any | null, incomingCarrier?: string | null, outboundCarrier?: string | null, address: { __typename?: 'AddressEntity', name: string, line1: string, line2?: string | null, city: string, state: string, zip: string } } }> }> }>, orderSegments: Array<{ __typename?: 'OrderLineHaulSegmentEntity', arrivedAt?: any | null, order: { __typename?: 'StandardOrderEntity', uuid: string, name: string, detailedStatusV2?: OrderDetailedStatus | null, receivedDate?: any | null, osd?: boolean | null, status: OrderStatus, weight: number, dimWeight: number, lineHaulServiceDisplayString: string, pieceCountFromPackages: number, refNumbers: Array<string>, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', weightUnits: WeightUnits, shipperBillOfLadingNumber?: string | null, masterAirwayBillOfLadingNumber?: string | null }, tags: Array<{ __typename?: 'TagEntity', uuid: string, value: string, color?: string | null }>, lineHaulLane?: { __typename?: 'LineHaulLaneEntity', uuid: string, name: string, isActive: boolean, originTerminal: { __typename?: 'TerminalEntity', uuid: string, code: string }, destinationTerminal: { __typename?: 'TerminalEntity', uuid: string, code: string } } | null, packages: Array<{ __typename?: 'PackageEntity', uuid: string, length?: number | null, width?: number | null, height?: number | null, weight?: number | null, type?: PackageType | null }>, billingPartyContact: { __typename?: 'CustomerContactEntity', displayName: string } }, arrivalScans: Array<{ __typename?: 'ScanEntity', uuid: string, scannedAt: any }>, departureScans: Array<{ __typename?: 'ScanEntity', uuid: string, scannedAt: any }> }> } | null } };

export type MarkManifestAsDepartedMutationVariables = Exact<{
  markManifestAsDepartedInput: MarkManifestAsDepartedInput;
}>;


export type MarkManifestAsDepartedMutation = { __typename?: 'Mutation', markManifestAsDeparted: { __typename?: 'MarkManifestAsDepartedOutput', errorMessage?: string | null, lineHaulManifest?: { __typename?: 'LineHaulManifestEntity', referenceNumber: string, createdAt: any, departDate: any, status: LineHaulManifestStatus, startedAt?: any | null, completedAt?: any | null, uuid: string, sentToAgentAt?: any | null, confirmedByAgentAt?: any | null, startTerminal: { __typename?: 'TerminalEntity', uuid: string, code: string }, endTerminal: { __typename?: 'TerminalEntity', uuid: string, code: string }, driver?: { __typename?: 'DriverEntity', uuid: string, driverReferenceNumber?: string | null, firstName: string, lastName: string, agent?: { __typename?: 'AgentFieldsEntity', name: string } | null } | null, equipment?: { __typename?: 'EquipmentEntity', uuid: string, name: string, type: EquipmentType } | null, orders: Array<{ __typename?: 'StandardOrderEntity', uuid: string, name: string, weight: number, dimWeight: number, pieceCountFromPackages: number, hazmat?: boolean | null, refNumbers: Array<string>, dateMarkedReceivedAtOrigin?: any | null, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', shipperBillOfLadingNumber?: string | null, masterAirwayBillOfLadingNumber?: string | null }, tags: Array<{ __typename?: 'TagEntity', value: string }>, packages: Array<{ __typename?: 'PackageEntity', length?: number | null, width?: number | null, height?: number | null, weight?: number | null }>, billingPartyContact: { __typename?: 'CustomerContactEntity', displayName: string }, shipments: Array<{ __typename?: 'StandardShipmentEntity', standardShipmentFields: { __typename?: 'StandardShipmentFieldsEntity', deadlineDate?: any | null }, legs: Array<{ __typename?: 'LegEntity', endStop: { __typename?: 'StandardStopEntity', stopType?: StopType | null, inboundMethod?: InboundMethod | null, outboundMethod?: OutboundMethod | null, serviceDate?: any | null, incomingCarrier?: string | null, outboundCarrier?: string | null, address: { __typename?: 'AddressEntity', name: string, line1: string, line2?: string | null, city: string, state: string, zip: string } } }> }> }>, orderSegments: Array<{ __typename?: 'OrderLineHaulSegmentEntity', arrivedAt?: any | null, order: { __typename?: 'StandardOrderEntity', uuid: string, name: string, detailedStatusV2?: OrderDetailedStatus | null, receivedDate?: any | null, osd?: boolean | null, status: OrderStatus, weight: number, dimWeight: number, lineHaulServiceDisplayString: string, pieceCountFromPackages: number, refNumbers: Array<string>, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', weightUnits: WeightUnits, shipperBillOfLadingNumber?: string | null, masterAirwayBillOfLadingNumber?: string | null }, tags: Array<{ __typename?: 'TagEntity', uuid: string, value: string, color?: string | null }>, lineHaulLane?: { __typename?: 'LineHaulLaneEntity', uuid: string, name: string, isActive: boolean, originTerminal: { __typename?: 'TerminalEntity', uuid: string, code: string }, destinationTerminal: { __typename?: 'TerminalEntity', uuid: string, code: string } } | null, packages: Array<{ __typename?: 'PackageEntity', uuid: string, length?: number | null, width?: number | null, height?: number | null, weight?: number | null, type?: PackageType | null }>, billingPartyContact: { __typename?: 'CustomerContactEntity', displayName: string } }, arrivalScans: Array<{ __typename?: 'ScanEntity', uuid: string, scannedAt: any }>, departureScans: Array<{ __typename?: 'ScanEntity', uuid: string, scannedAt: any }> }> } | null } };

export type MarkManifestAsPlanningMutationVariables = Exact<{
  markManifestAsPlanningInput: MarkManifestAsPlanningInput;
}>;


export type MarkManifestAsPlanningMutation = { __typename?: 'Mutation', markManifestAsPlanning: { __typename?: 'MarkManifestAsPlanningOutput', errorMessage?: string | null, lineHaulManifest?: { __typename?: 'LineHaulManifestEntity', referenceNumber: string, createdAt: any, departDate: any, status: LineHaulManifestStatus, startedAt?: any | null, completedAt?: any | null, uuid: string, sentToAgentAt?: any | null, confirmedByAgentAt?: any | null, startTerminal: { __typename?: 'TerminalEntity', uuid: string, code: string }, endTerminal: { __typename?: 'TerminalEntity', uuid: string, code: string }, driver?: { __typename?: 'DriverEntity', uuid: string, driverReferenceNumber?: string | null, firstName: string, lastName: string, agent?: { __typename?: 'AgentFieldsEntity', name: string } | null } | null, equipment?: { __typename?: 'EquipmentEntity', uuid: string, name: string, type: EquipmentType } | null, orders: Array<{ __typename?: 'StandardOrderEntity', uuid: string, name: string, weight: number, dimWeight: number, pieceCountFromPackages: number, hazmat?: boolean | null, refNumbers: Array<string>, dateMarkedReceivedAtOrigin?: any | null, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', shipperBillOfLadingNumber?: string | null, masterAirwayBillOfLadingNumber?: string | null }, tags: Array<{ __typename?: 'TagEntity', value: string }>, packages: Array<{ __typename?: 'PackageEntity', length?: number | null, width?: number | null, height?: number | null, weight?: number | null }>, billingPartyContact: { __typename?: 'CustomerContactEntity', displayName: string }, shipments: Array<{ __typename?: 'StandardShipmentEntity', standardShipmentFields: { __typename?: 'StandardShipmentFieldsEntity', deadlineDate?: any | null }, legs: Array<{ __typename?: 'LegEntity', endStop: { __typename?: 'StandardStopEntity', stopType?: StopType | null, inboundMethod?: InboundMethod | null, outboundMethod?: OutboundMethod | null, serviceDate?: any | null, incomingCarrier?: string | null, outboundCarrier?: string | null, address: { __typename?: 'AddressEntity', name: string, line1: string, line2?: string | null, city: string, state: string, zip: string } } }> }> }>, orderSegments: Array<{ __typename?: 'OrderLineHaulSegmentEntity', arrivedAt?: any | null, order: { __typename?: 'StandardOrderEntity', uuid: string, name: string, detailedStatusV2?: OrderDetailedStatus | null, receivedDate?: any | null, osd?: boolean | null, status: OrderStatus, weight: number, dimWeight: number, lineHaulServiceDisplayString: string, pieceCountFromPackages: number, refNumbers: Array<string>, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', weightUnits: WeightUnits, shipperBillOfLadingNumber?: string | null, masterAirwayBillOfLadingNumber?: string | null }, tags: Array<{ __typename?: 'TagEntity', uuid: string, value: string, color?: string | null }>, lineHaulLane?: { __typename?: 'LineHaulLaneEntity', uuid: string, name: string, isActive: boolean, originTerminal: { __typename?: 'TerminalEntity', uuid: string, code: string }, destinationTerminal: { __typename?: 'TerminalEntity', uuid: string, code: string } } | null, packages: Array<{ __typename?: 'PackageEntity', uuid: string, length?: number | null, width?: number | null, height?: number | null, weight?: number | null, type?: PackageType | null }>, billingPartyContact: { __typename?: 'CustomerContactEntity', displayName: string } }, arrivalScans: Array<{ __typename?: 'ScanEntity', uuid: string, scannedAt: any }>, departureScans: Array<{ __typename?: 'ScanEntity', uuid: string, scannedAt: any }> }> } | null } };

export type RemoveLineHaulManifestMutationVariables = Exact<{
  uuid: Scalars['String']['input'];
}>;


export type RemoveLineHaulManifestMutation = { __typename?: 'Mutation', removeLineHaulManifest: string };

export type RemoveOrdersFromManifestV2MutationVariables = Exact<{
  input: RemoveOrdersFromManifestV2Input;
}>;


export type RemoveOrdersFromManifestV2Mutation = { __typename?: 'Mutation', removeOrdersFromManifestV2: { __typename: 'MutationErrorOutput', message: string } | { __typename: 'RemoveOrdersFromManifestV2SuccessOutput' } };

export type RemoveOrdersFromManifestMutationVariables = Exact<{
  removeOrdersFromManifestInput: RemoveOrdersFromManifestInput;
}>;


export type RemoveOrdersFromManifestMutation = { __typename?: 'Mutation', removeOrdersFromManifest: { __typename?: 'AddOrdersToManifestOutput', errorMessage?: string | null, lineHaulManifest?: { __typename?: 'LineHaulManifestEntity', referenceNumber: string, createdAt: any, departDate: any, status: LineHaulManifestStatus, startedAt?: any | null, completedAt?: any | null, uuid: string, sentToAgentAt?: any | null, confirmedByAgentAt?: any | null, startTerminal: { __typename?: 'TerminalEntity', uuid: string, code: string }, endTerminal: { __typename?: 'TerminalEntity', uuid: string, code: string }, driver?: { __typename?: 'DriverEntity', uuid: string, driverReferenceNumber?: string | null, firstName: string, lastName: string, agent?: { __typename?: 'AgentFieldsEntity', name: string } | null } | null, equipment?: { __typename?: 'EquipmentEntity', uuid: string, name: string, type: EquipmentType } | null, orders: Array<{ __typename?: 'StandardOrderEntity', uuid: string, name: string, weight: number, dimWeight: number, pieceCountFromPackages: number, hazmat?: boolean | null, refNumbers: Array<string>, dateMarkedReceivedAtOrigin?: any | null, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', shipperBillOfLadingNumber?: string | null, masterAirwayBillOfLadingNumber?: string | null }, tags: Array<{ __typename?: 'TagEntity', value: string }>, packages: Array<{ __typename?: 'PackageEntity', length?: number | null, width?: number | null, height?: number | null, weight?: number | null }>, billingPartyContact: { __typename?: 'CustomerContactEntity', displayName: string }, shipments: Array<{ __typename?: 'StandardShipmentEntity', standardShipmentFields: { __typename?: 'StandardShipmentFieldsEntity', deadlineDate?: any | null }, legs: Array<{ __typename?: 'LegEntity', endStop: { __typename?: 'StandardStopEntity', stopType?: StopType | null, inboundMethod?: InboundMethod | null, outboundMethod?: OutboundMethod | null, serviceDate?: any | null, incomingCarrier?: string | null, outboundCarrier?: string | null, address: { __typename?: 'AddressEntity', name: string, line1: string, line2?: string | null, city: string, state: string, zip: string } } }> }> }>, orderSegments: Array<{ __typename?: 'OrderLineHaulSegmentEntity', arrivedAt?: any | null, order: { __typename?: 'StandardOrderEntity', uuid: string, name: string, detailedStatusV2?: OrderDetailedStatus | null, receivedDate?: any | null, osd?: boolean | null, status: OrderStatus, weight: number, dimWeight: number, lineHaulServiceDisplayString: string, pieceCountFromPackages: number, refNumbers: Array<string>, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', weightUnits: WeightUnits, shipperBillOfLadingNumber?: string | null, masterAirwayBillOfLadingNumber?: string | null }, tags: Array<{ __typename?: 'TagEntity', uuid: string, value: string, color?: string | null }>, lineHaulLane?: { __typename?: 'LineHaulLaneEntity', uuid: string, name: string, isActive: boolean, originTerminal: { __typename?: 'TerminalEntity', uuid: string, code: string }, destinationTerminal: { __typename?: 'TerminalEntity', uuid: string, code: string } } | null, packages: Array<{ __typename?: 'PackageEntity', uuid: string, length?: number | null, width?: number | null, height?: number | null, weight?: number | null, type?: PackageType | null }>, billingPartyContact: { __typename?: 'CustomerContactEntity', displayName: string } }, arrivalScans: Array<{ __typename?: 'ScanEntity', uuid: string, scannedAt: any }>, departureScans: Array<{ __typename?: 'ScanEntity', uuid: string, scannedAt: any }> }> } | null } };

export type SegmentedLineHaulOrderFragment = { __typename?: 'OrderLineHaulSegmentEntity', uuid: string, order: { __typename?: 'StandardOrderEntity', uuid: string, name: string, pieceCountFromPackages: number, dateMarkedReceivedAtOrigin?: any | null, weight: number, dimWeight: number, lineHaulServiceDisplayString: string, hazmat?: boolean | null, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', weightUnits: WeightUnits, shipperBillOfLadingNumber?: string | null, masterAirwayBillOfLadingNumber?: string | null }, tags: Array<{ __typename?: 'TagEntity', uuid: string, value: string, color?: string | null }>, lineHaulLane?: { __typename?: 'LineHaulLaneEntity', uuid: string, name: string, isActive: boolean, originTerminal: { __typename?: 'TerminalEntity', uuid: string, code: string }, destinationTerminal: { __typename?: 'TerminalEntity', uuid: string, code: string } } | null, billingPartyContact: { __typename?: 'CustomerContactEntity', displayName: string }, startStop?: { __typename?: 'StandardStopEntity', serviceDate?: any | null, isSpecial?: boolean | null, incomingCarrier?: string | null, address: { __typename?: 'AddressEntity', name: string }, terminal?: { __typename?: 'TerminalEntity', code: string } | null } | null, endStop?: { __typename?: 'StandardStopEntity', serviceDate?: any | null, isSpecial?: boolean | null, outboundCarrier?: string | null, destinationAirport?: string | null, address: { __typename?: 'AddressEntity', name: string }, terminal?: { __typename?: 'TerminalEntity', code: string } | null, leg: { __typename?: 'LegEntity', shipment: { __typename?: 'StandardShipmentEntity', standardShipmentFields: { __typename?: 'StandardShipmentFieldsEntity', deadlineDate?: any | null } } } } | null }, segment: { __typename?: 'LineHaulSegmentEntity', uuid: string, ordinal: number, startTerminal: { __typename?: 'TerminalEntity', uuid: string, code: string }, endTerminal: { __typename?: 'TerminalEntity', uuid: string, code: string } } };

export type SegmentedLineHaulOrdersV2QueryVariables = Exact<{
  findSegmentedLineHaulOrdersInputV2: FindSegmentedLineHaulOrdersInputV2;
}>;


export type SegmentedLineHaulOrdersV2Query = { __typename?: 'Query', segmentedLineHaulOrdersV2: { __typename?: 'OrderLineHaulSegmentOutput', totalCount?: number | null, edges: Array<{ __typename?: 'OrderLineHaulSegmentEntity', uuid: string, order: { __typename?: 'StandardOrderEntity', uuid: string, name: string, pieceCountFromPackages: number, dateMarkedReceivedAtOrigin?: any | null, weight: number, dimWeight: number, lineHaulServiceDisplayString: string, hazmat?: boolean | null, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', weightUnits: WeightUnits, shipperBillOfLadingNumber?: string | null, masterAirwayBillOfLadingNumber?: string | null }, tags: Array<{ __typename?: 'TagEntity', uuid: string, value: string, color?: string | null }>, lineHaulLane?: { __typename?: 'LineHaulLaneEntity', uuid: string, name: string, isActive: boolean, originTerminal: { __typename?: 'TerminalEntity', uuid: string, code: string }, destinationTerminal: { __typename?: 'TerminalEntity', uuid: string, code: string } } | null, billingPartyContact: { __typename?: 'CustomerContactEntity', displayName: string }, startStop?: { __typename?: 'StandardStopEntity', serviceDate?: any | null, isSpecial?: boolean | null, incomingCarrier?: string | null, address: { __typename?: 'AddressEntity', name: string }, terminal?: { __typename?: 'TerminalEntity', code: string } | null } | null, endStop?: { __typename?: 'StandardStopEntity', serviceDate?: any | null, isSpecial?: boolean | null, outboundCarrier?: string | null, destinationAirport?: string | null, address: { __typename?: 'AddressEntity', name: string }, terminal?: { __typename?: 'TerminalEntity', code: string } | null, leg: { __typename?: 'LegEntity', shipment: { __typename?: 'StandardShipmentEntity', standardShipmentFields: { __typename?: 'StandardShipmentFieldsEntity', deadlineDate?: any | null } } } } | null }, segment: { __typename?: 'LineHaulSegmentEntity', uuid: string, ordinal: number, startTerminal: { __typename?: 'TerminalEntity', uuid: string, code: string }, endTerminal: { __typename?: 'TerminalEntity', uuid: string, code: string } } }> } };

export type SegmentedLineHaulOrdersQueryVariables = Exact<{
  findSegmentedLineHaulOrdersInput: FindSegmentedLineHaulOrdersInput;
}>;


export type SegmentedLineHaulOrdersQuery = { __typename?: 'Query', segmentedLineHaulOrders: { __typename?: 'OrderLineHaulSegmentConnection', totalCount?: number | null, edges: Array<{ __typename?: 'OrderLineHaulSegmentEdge', node: { __typename?: 'OrderLineHaulSegmentEntity', uuid: string, order: { __typename?: 'StandardOrderEntity', uuid: string, name: string, pieceCountFromPackages: number, dateMarkedReceivedAtOrigin?: any | null, weight: number, dimWeight: number, lineHaulServiceDisplayString: string, hazmat?: boolean | null, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', weightUnits: WeightUnits, shipperBillOfLadingNumber?: string | null, masterAirwayBillOfLadingNumber?: string | null }, tags: Array<{ __typename?: 'TagEntity', uuid: string, value: string, color?: string | null }>, lineHaulLane?: { __typename?: 'LineHaulLaneEntity', uuid: string, name: string, isActive: boolean, originTerminal: { __typename?: 'TerminalEntity', uuid: string, code: string }, destinationTerminal: { __typename?: 'TerminalEntity', uuid: string, code: string } } | null, billingPartyContact: { __typename?: 'CustomerContactEntity', displayName: string }, startStop?: { __typename?: 'StandardStopEntity', serviceDate?: any | null, isSpecial?: boolean | null, incomingCarrier?: string | null, address: { __typename?: 'AddressEntity', name: string }, terminal?: { __typename?: 'TerminalEntity', code: string } | null } | null, endStop?: { __typename?: 'StandardStopEntity', serviceDate?: any | null, isSpecial?: boolean | null, outboundCarrier?: string | null, destinationAirport?: string | null, address: { __typename?: 'AddressEntity', name: string }, terminal?: { __typename?: 'TerminalEntity', code: string } | null, leg: { __typename?: 'LegEntity', shipment: { __typename?: 'StandardShipmentEntity', standardShipmentFields: { __typename?: 'StandardShipmentFieldsEntity', deadlineDate?: any | null } } } } | null }, segment: { __typename?: 'LineHaulSegmentEntity', uuid: string, ordinal: number, startTerminal: { __typename?: 'TerminalEntity', uuid: string, code: string }, endTerminal: { __typename?: 'TerminalEntity', uuid: string, code: string } } } }>, pageInfo: { __typename?: 'PageInfo', startCursor?: string | null, endCursor?: string | null, hasNextPage: boolean, hasPreviousPage: boolean } } };

export type ShallowLineHaulManifestFragment = { __typename?: 'LineHaulManifestEntity', departDate: any, uuid: string, startTerminal: { __typename?: 'TerminalEntity', uuid: string, code: string }, endTerminal: { __typename?: 'TerminalEntity', uuid: string, code: string }, driver?: { __typename?: 'DriverEntity', uuid: string, driverReferenceNumber?: string | null, firstName: string, lastName: string } | null };

export type TerminalForDetailedLineHaulManifestFragment = { __typename?: 'TerminalEntity', uuid: string, code: string };

export type UpdateManifestDriverMutationVariables = Exact<{
  updateManifestDriverInput: UpdateManifestDriverInput;
}>;


export type UpdateManifestDriverMutation = { __typename?: 'Mutation', updateManifestDriver: { __typename?: 'LineHaulManifestEntity', referenceNumber: string, createdAt: any, departDate: any, status: LineHaulManifestStatus, startedAt?: any | null, completedAt?: any | null, uuid: string, sentToAgentAt?: any | null, confirmedByAgentAt?: any | null, startTerminal: { __typename?: 'TerminalEntity', uuid: string, code: string }, endTerminal: { __typename?: 'TerminalEntity', uuid: string, code: string }, driver?: { __typename?: 'DriverEntity', uuid: string, driverReferenceNumber?: string | null, firstName: string, lastName: string, agent?: { __typename?: 'AgentFieldsEntity', name: string } | null } | null, equipment?: { __typename?: 'EquipmentEntity', uuid: string, name: string, type: EquipmentType } | null, orders: Array<{ __typename?: 'StandardOrderEntity', uuid: string, name: string, weight: number, dimWeight: number, pieceCountFromPackages: number, hazmat?: boolean | null, refNumbers: Array<string>, dateMarkedReceivedAtOrigin?: any | null, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', shipperBillOfLadingNumber?: string | null, masterAirwayBillOfLadingNumber?: string | null }, tags: Array<{ __typename?: 'TagEntity', value: string }>, packages: Array<{ __typename?: 'PackageEntity', length?: number | null, width?: number | null, height?: number | null, weight?: number | null }>, billingPartyContact: { __typename?: 'CustomerContactEntity', displayName: string }, shipments: Array<{ __typename?: 'StandardShipmentEntity', standardShipmentFields: { __typename?: 'StandardShipmentFieldsEntity', deadlineDate?: any | null }, legs: Array<{ __typename?: 'LegEntity', endStop: { __typename?: 'StandardStopEntity', stopType?: StopType | null, inboundMethod?: InboundMethod | null, outboundMethod?: OutboundMethod | null, serviceDate?: any | null, incomingCarrier?: string | null, outboundCarrier?: string | null, address: { __typename?: 'AddressEntity', name: string, line1: string, line2?: string | null, city: string, state: string, zip: string } } }> }> }>, orderSegments: Array<{ __typename?: 'OrderLineHaulSegmentEntity', arrivedAt?: any | null, order: { __typename?: 'StandardOrderEntity', uuid: string, name: string, detailedStatusV2?: OrderDetailedStatus | null, receivedDate?: any | null, osd?: boolean | null, status: OrderStatus, weight: number, dimWeight: number, lineHaulServiceDisplayString: string, pieceCountFromPackages: number, refNumbers: Array<string>, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', weightUnits: WeightUnits, shipperBillOfLadingNumber?: string | null, masterAirwayBillOfLadingNumber?: string | null }, tags: Array<{ __typename?: 'TagEntity', uuid: string, value: string, color?: string | null }>, lineHaulLane?: { __typename?: 'LineHaulLaneEntity', uuid: string, name: string, isActive: boolean, originTerminal: { __typename?: 'TerminalEntity', uuid: string, code: string }, destinationTerminal: { __typename?: 'TerminalEntity', uuid: string, code: string } } | null, packages: Array<{ __typename?: 'PackageEntity', uuid: string, length?: number | null, width?: number | null, height?: number | null, weight?: number | null, type?: PackageType | null }>, billingPartyContact: { __typename?: 'CustomerContactEntity', displayName: string } }, arrivalScans: Array<{ __typename?: 'ScanEntity', uuid: string, scannedAt: any }>, departureScans: Array<{ __typename?: 'ScanEntity', uuid: string, scannedAt: any }> }> } };

export type UpdateManifestVehicleMutationVariables = Exact<{
  updateManifestVehicleInput: UpdateManifestVehicleInput;
}>;


export type UpdateManifestVehicleMutation = { __typename?: 'Mutation', updateManifestVehicle: { __typename?: 'LineHaulManifestEntity', referenceNumber: string, createdAt: any, departDate: any, status: LineHaulManifestStatus, startedAt?: any | null, completedAt?: any | null, uuid: string, sentToAgentAt?: any | null, confirmedByAgentAt?: any | null, startTerminal: { __typename?: 'TerminalEntity', uuid: string, code: string }, endTerminal: { __typename?: 'TerminalEntity', uuid: string, code: string }, driver?: { __typename?: 'DriverEntity', uuid: string, driverReferenceNumber?: string | null, firstName: string, lastName: string, agent?: { __typename?: 'AgentFieldsEntity', name: string } | null } | null, equipment?: { __typename?: 'EquipmentEntity', uuid: string, name: string, type: EquipmentType } | null, orders: Array<{ __typename?: 'StandardOrderEntity', uuid: string, name: string, weight: number, dimWeight: number, pieceCountFromPackages: number, hazmat?: boolean | null, refNumbers: Array<string>, dateMarkedReceivedAtOrigin?: any | null, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', shipperBillOfLadingNumber?: string | null, masterAirwayBillOfLadingNumber?: string | null }, tags: Array<{ __typename?: 'TagEntity', value: string }>, packages: Array<{ __typename?: 'PackageEntity', length?: number | null, width?: number | null, height?: number | null, weight?: number | null }>, billingPartyContact: { __typename?: 'CustomerContactEntity', displayName: string }, shipments: Array<{ __typename?: 'StandardShipmentEntity', standardShipmentFields: { __typename?: 'StandardShipmentFieldsEntity', deadlineDate?: any | null }, legs: Array<{ __typename?: 'LegEntity', endStop: { __typename?: 'StandardStopEntity', stopType?: StopType | null, inboundMethod?: InboundMethod | null, outboundMethod?: OutboundMethod | null, serviceDate?: any | null, incomingCarrier?: string | null, outboundCarrier?: string | null, address: { __typename?: 'AddressEntity', name: string, line1: string, line2?: string | null, city: string, state: string, zip: string } } }> }> }>, orderSegments: Array<{ __typename?: 'OrderLineHaulSegmentEntity', arrivedAt?: any | null, order: { __typename?: 'StandardOrderEntity', uuid: string, name: string, detailedStatusV2?: OrderDetailedStatus | null, receivedDate?: any | null, osd?: boolean | null, status: OrderStatus, weight: number, dimWeight: number, lineHaulServiceDisplayString: string, pieceCountFromPackages: number, refNumbers: Array<string>, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', weightUnits: WeightUnits, shipperBillOfLadingNumber?: string | null, masterAirwayBillOfLadingNumber?: string | null }, tags: Array<{ __typename?: 'TagEntity', uuid: string, value: string, color?: string | null }>, lineHaulLane?: { __typename?: 'LineHaulLaneEntity', uuid: string, name: string, isActive: boolean, originTerminal: { __typename?: 'TerminalEntity', uuid: string, code: string }, destinationTerminal: { __typename?: 'TerminalEntity', uuid: string, code: string } } | null, packages: Array<{ __typename?: 'PackageEntity', uuid: string, length?: number | null, width?: number | null, height?: number | null, weight?: number | null, type?: PackageType | null }>, billingPartyContact: { __typename?: 'CustomerContactEntity', displayName: string } }, arrivalScans: Array<{ __typename?: 'ScanEntity', uuid: string, scannedAt: any }>, departureScans: Array<{ __typename?: 'ScanEntity', uuid: string, scannedAt: any }> }> } };

export type UpdateManifestsStatusMutationVariables = Exact<{
  input: UpdateManifestsStatusInput;
}>;


export type UpdateManifestsStatusMutation = { __typename?: 'Mutation', updateManifestsStatus: { __typename: 'MutationErrorOutput', message: string } | { __typename: 'UpdateManifestsStatusSuccessOutput', lineHaulManifests: Array<{ __typename?: 'LineHaulManifestEntity', referenceNumber: string, createdAt: any, departDate: any, status: LineHaulManifestStatus, startedAt?: any | null, completedAt?: any | null, uuid: string, sentToAgentAt?: any | null, confirmedByAgentAt?: any | null, startTerminal: { __typename?: 'TerminalEntity', uuid: string, code: string }, endTerminal: { __typename?: 'TerminalEntity', uuid: string, code: string }, driver?: { __typename?: 'DriverEntity', uuid: string, driverReferenceNumber?: string | null, firstName: string, lastName: string, agent?: { __typename?: 'AgentFieldsEntity', name: string } | null } | null, equipment?: { __typename?: 'EquipmentEntity', uuid: string, name: string, type: EquipmentType } | null, orders: Array<{ __typename?: 'StandardOrderEntity', uuid: string, name: string, weight: number, dimWeight: number, pieceCountFromPackages: number, hazmat?: boolean | null, refNumbers: Array<string>, dateMarkedReceivedAtOrigin?: any | null, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', shipperBillOfLadingNumber?: string | null, masterAirwayBillOfLadingNumber?: string | null }, tags: Array<{ __typename?: 'TagEntity', value: string }>, packages: Array<{ __typename?: 'PackageEntity', length?: number | null, width?: number | null, height?: number | null, weight?: number | null }>, billingPartyContact: { __typename?: 'CustomerContactEntity', displayName: string }, shipments: Array<{ __typename?: 'StandardShipmentEntity', standardShipmentFields: { __typename?: 'StandardShipmentFieldsEntity', deadlineDate?: any | null }, legs: Array<{ __typename?: 'LegEntity', endStop: { __typename?: 'StandardStopEntity', stopType?: StopType | null, inboundMethod?: InboundMethod | null, outboundMethod?: OutboundMethod | null, serviceDate?: any | null, incomingCarrier?: string | null, outboundCarrier?: string | null, address: { __typename?: 'AddressEntity', name: string, line1: string, line2?: string | null, city: string, state: string, zip: string } } }> }> }>, orderSegments: Array<{ __typename?: 'OrderLineHaulSegmentEntity', arrivedAt?: any | null, order: { __typename?: 'StandardOrderEntity', uuid: string, name: string, detailedStatusV2?: OrderDetailedStatus | null, receivedDate?: any | null, osd?: boolean | null, status: OrderStatus, weight: number, dimWeight: number, lineHaulServiceDisplayString: string, pieceCountFromPackages: number, refNumbers: Array<string>, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', weightUnits: WeightUnits, shipperBillOfLadingNumber?: string | null, masterAirwayBillOfLadingNumber?: string | null }, tags: Array<{ __typename?: 'TagEntity', uuid: string, value: string, color?: string | null }>, lineHaulLane?: { __typename?: 'LineHaulLaneEntity', uuid: string, name: string, isActive: boolean, originTerminal: { __typename?: 'TerminalEntity', uuid: string, code: string }, destinationTerminal: { __typename?: 'TerminalEntity', uuid: string, code: string } } | null, packages: Array<{ __typename?: 'PackageEntity', uuid: string, length?: number | null, width?: number | null, height?: number | null, weight?: number | null, type?: PackageType | null }>, billingPartyContact: { __typename?: 'CustomerContactEntity', displayName: string } }, arrivalScans: Array<{ __typename?: 'ScanEntity', uuid: string, scannedAt: any }>, departureScans: Array<{ __typename?: 'ScanEntity', uuid: string, scannedAt: any }> }> }> } };

export type ArchiveTariffChainMutationVariables = Exact<{
  archiveTariffChainInput: ArchiveTariffChainInput;
}>;


export type ArchiveTariffChainMutation = { __typename?: 'Mutation', archiveTariffChain: { __typename?: 'ArchiveTariffChainSuccessOutput', tariffChain: { __typename?: 'TariffChainEntity', id: string } } | { __typename?: 'MutationErrorOutput', message: string } };

export type CompanyDefaultTariffChainFragment = { __typename?: 'TariffChainEntity', id: string, name: string };

export type CompanyDefaultTariffChainsQueryVariables = Exact<{ [key: string]: never; }>;


export type CompanyDefaultTariffChainsQuery = { __typename?: 'Query', company: { __typename?: 'CompanyEntity', defaultOrdinaryTariffChain?: { __typename?: 'TariffChainEntity', id: string, name: string } | null, defaultLineHaulTariffChain?: { __typename?: 'TariffChainEntity', id: string, name: string } | null, defaultTransferTariffChain?: { __typename?: 'TariffChainEntity', id: string, name: string } | null, defaultPointToPointTariffChain?: { __typename?: 'TariffChainEntity', id: string, name: string } | null, defaultOrdinarySettlementTariffChain?: { __typename?: 'TariffChainEntity', id: string, name: string } | null, defaultTransferSettlementTariffChain?: { __typename?: 'TariffChainEntity', id: string, name: string } | null } };

export type CreateTariffChainMutationVariables = Exact<{
  createTariffChainInput: CreateTariffChainInput;
}>;


export type CreateTariffChainMutation = { __typename?: 'Mutation', createTariffChain: { __typename?: 'CreateTariffChainSuccessOutput', tariffChain: { __typename?: 'TariffChainEntity', id: string } } | { __typename?: 'MutationErrorOutput', message: string } };

export type RestoreTariffChainMutationVariables = Exact<{
  restoreTariffChainInput: RestoreTariffChainInput;
}>;


export type RestoreTariffChainMutation = { __typename?: 'Mutation', restoreTariffChain: { __typename?: 'MutationErrorOutput', message: string } | { __typename?: 'RestoreTariffChainSuccessOutput', tariffChain: { __typename?: 'TariffChainEntity', id: string } } };

export type TariffChainWithGroupsFragment = { __typename?: 'TariffChainEntity', id: string, name: string, tariffGroupType: TariffGroupType, tariffGroups: Array<{ __typename?: 'TariffGroupEntity', uuid: string, name?: string | null }> };

export type TariffChainsWithGroupsQueryVariables = Exact<{
  findTariffChainsInput: FindTariffChainsInput;
}>;


export type TariffChainsWithGroupsQuery = { __typename?: 'Query', tariffChains: Array<{ __typename?: 'TariffChainEntity', id: string, name: string, tariffGroupType: TariffGroupType, tariffGroups: Array<{ __typename?: 'TariffGroupEntity', uuid: string, name?: string | null }> }> };

export type UpdateDefaultTariffChainsForCompanyMutationVariables = Exact<{
  updateDefaultTariffChainsForCompanyInput: UpdateDefaultTariffChainsForCompanyInput;
}>;


export type UpdateDefaultTariffChainsForCompanyMutation = { __typename?: 'Mutation', updateDefaultTariffChainsForCompany: { __typename?: 'MutationErrorOutput', message: string } | { __typename?: 'UpdateDefaultTariffChainsForCompanySuccessOutput', company: { __typename?: 'CompanyEntity', uuid: string } } };

export type UpdateTariffChainMutationVariables = Exact<{
  updateTariffChainInput: UpdateTariffChainInput;
}>;


export type UpdateTariffChainMutation = { __typename?: 'Mutation', updateTariffChain: { __typename?: 'MutationErrorOutput', message: string } | { __typename?: 'UpdateTariffChainSuccessOutput', tariffChain: { __typename?: 'TariffChainEntity', id: string } } };

export type ContactsWithTariffsQueryVariables = Exact<{
  checkHasTariffs?: InputMaybe<Scalars['Boolean']['input']>;
  checkHasTariffZones?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type ContactsWithTariffsQuery = { __typename?: 'Query', contacts: Array<{ __typename?: 'CustomerContactEntity', uuid: string, displayName: string, customerTariffs: Array<{ __typename?: 'TariffEntity', service?: { __typename?: 'ServiceEntity', uuid: string, name: string, createdAt: any, updatedAt: any, timeInMinutes?: number | null, useApptInRouteOptimization: boolean, markOrdersAsSpecial: boolean, defaultAppointmentStartTime?: any | null, defaultAppointmentEndTime?: any | null, defaultStartNow: boolean, defaultInboundStopType?: StopType | null, defaultOutboundStopType?: StopType | null, defaultPickupPadding?: any | null, defaultDeliveryPadding?: any | null, defaultTotalDuration?: any | null, defaultIsLineHaul: boolean, defaultFulfillmentType?: FulfillmentType | null, isActive: boolean, isExposedToCustomers: boolean, serviceAvailabilityDates: Array<{ __typename?: 'ServiceAvailabilityDateEntity', id: string, dayCategory: SpecialDayOfWeek, enabled: boolean, start: { __typename?: 'PlainTime', hour: number, minute: number }, end: { __typename?: 'PlainTime', hour: number, minute: number } }> } | null }>, tariffZones: Array<{ __typename?: 'TariffZoneEntity', type: TariffZoneType }> } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string, customerTariffs: Array<{ __typename?: 'TariffEntity', service?: { __typename?: 'ServiceEntity', uuid: string, name: string, createdAt: any, updatedAt: any, timeInMinutes?: number | null, useApptInRouteOptimization: boolean, markOrdersAsSpecial: boolean, defaultAppointmentStartTime?: any | null, defaultAppointmentEndTime?: any | null, defaultStartNow: boolean, defaultInboundStopType?: StopType | null, defaultOutboundStopType?: StopType | null, defaultPickupPadding?: any | null, defaultDeliveryPadding?: any | null, defaultTotalDuration?: any | null, defaultIsLineHaul: boolean, defaultFulfillmentType?: FulfillmentType | null, isActive: boolean, isExposedToCustomers: boolean, serviceAvailabilityDates: Array<{ __typename?: 'ServiceAvailabilityDateEntity', id: string, dayCategory: SpecialDayOfWeek, enabled: boolean, start: { __typename?: 'PlainTime', hour: number, minute: number }, end: { __typename?: 'PlainTime', hour: number, minute: number } }> } | null }>, tariffZones: Array<{ __typename?: 'TariffZoneEntity', type: TariffZoneType }> }> };

export type CreateTariffGroupMutationVariables = Exact<{
  createTariffGroupInput: CreateTariffGroupInput;
}>;


export type CreateTariffGroupMutation = { __typename?: 'Mutation', createTariffGroup: { __typename?: 'TariffGroupEntity', uuid: string, name?: string | null } };

export type DeleteTariffGroupMutationVariables = Exact<{
  uuid: Scalars['String']['input'];
}>;


export type DeleteTariffGroupMutation = { __typename?: 'Mutation', deleteTariffGroup: { __typename?: 'TariffGroupEntity', uuid: string } };

export type DuplicateTariffGroupMutationVariables = Exact<{
  duplicateTariffGroupInput: DuplicateTariffGroupInput;
}>;


export type DuplicateTariffGroupMutation = { __typename?: 'Mutation', duplicateTariffGroup: { __typename?: 'DuplicateTariffGroupOutput', tariffGroup: { __typename?: 'TariffGroupEntity', uuid: string } } };

export type FindDefaultTariffGroupForCompanyQueryVariables = Exact<{ [key: string]: never; }>;


export type FindDefaultTariffGroupForCompanyQuery = { __typename?: 'Query', findDefaultTariffGroupForCompany?: { __typename?: 'TariffGroupEntity', uuid: string } | null };

export type FindDefaultTransferTariffGroupForCompanyQueryVariables = Exact<{ [key: string]: never; }>;


export type FindDefaultTransferTariffGroupForCompanyQuery = { __typename?: 'Query', findDefaultTransferTariffGroupForCompany?: { __typename?: 'TariffGroupEntity', uuid: string } | null };

export type FindTariffGroupsWithContactAndServiceCombinationQueryVariables = Exact<{
  mappingsList: Array<ContactAndServicesCombination> | ContactAndServicesCombination;
}>;


export type FindTariffGroupsWithContactAndServiceCombinationQuery = { __typename?: 'Query', findTariffGroupsWithContactAndServiceCombination: Array<{ __typename?: 'FindTariffGroupsWithContactAndServicesCombinationOutput', contactUuid: string, matchingTariffGroups: Array<{ __typename?: 'MatchingGroupsAlongWithMatchingServices', tariffGroupName?: string | null, tariffGroupUuid: string, serviceUuids: Array<string> }> }> };

export type ShallowTariffGroupFuelProfileFragment = { __typename?: 'FuelProfileEntity', uuid: string, name?: string | null, startDate?: any | null, expirationDate?: any | null, billingType: FuelBillingMethod, type: FuelProfileType, company: { __typename?: 'CompanyEntity', uuid: string }, contacts?: Array<{ __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string }> | null, fuelProfileDateRanges: Array<{ __typename?: 'FuelProfileDateRangeEntity', uuid: string, startDate: any, expirationDate: any, surchargeRate?: number | null, flatRateUsdCents?: number | null }> };

export type ShallowTariffGroupFragment = { __typename?: 'TariffGroupEntity', uuid: string, name?: string | null, tariffGroupScope?: TariffGroupScope | null, tariffGroupType: TariffGroupType, rateMultiplier?: number | null, useActualWeightInCalculation: boolean, contactToServicesMappings: Array<{ __typename?: 'ContactToServicesTariffGroupMappingEntity', contact: { __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string }, services: Array<{ __typename?: 'ServiceEntity', uuid: string, name: string }> }>, parentTariffGroup?: { __typename?: 'TariffGroupEntity', uuid: string, tariffs: Array<{ __typename?: 'TariffEntity', uuid: string, minimumUsdCents?: number | null, maximumUsdCents?: number | null, settlementPercentageRate?: any | null, tariffType: TariffType, rateType: RateType, billingPartyContactUuid?: string | null, useActualWeight?: boolean | null, useActualWeightInCalculation: boolean, service?: { __typename?: 'ServiceEntity', uuid: string, name: string, createdAt: any, updatedAt: any, timeInMinutes?: number | null, useApptInRouteOptimization: boolean, markOrdersAsSpecial: boolean, defaultAppointmentStartTime?: any | null, defaultAppointmentEndTime?: any | null, defaultStartNow: boolean, defaultInboundStopType?: StopType | null, defaultOutboundStopType?: StopType | null, defaultPickupPadding?: any | null, defaultDeliveryPadding?: any | null, defaultTotalDuration?: any | null, defaultIsLineHaul: boolean, defaultFulfillmentType?: FulfillmentType | null, isActive: boolean, isExposedToCustomers: boolean, serviceAvailabilityDates: Array<{ __typename?: 'ServiceAvailabilityDateEntity', id: string, dayCategory: SpecialDayOfWeek, enabled: boolean, start: { __typename?: 'PlainTime', hour: number, minute: number }, end: { __typename?: 'PlainTime', hour: number, minute: number } }> } | null, tariffOverageRates: Array<{ __typename?: 'TariffOverageRateEntity', uuid: string, name: string, type: TariffOverageRateType, rateUsdCents: number, flatRateUsdCents: number, applicableAboveAmount: number }>, tariffZone: { __typename?: 'TariffZoneEntity', uuid: string, name: string, type: TariffZoneType, mileRangeStart?: number | null, mileRangeEnd?: number | null, billingPartyContactUuid?: string | null, locations: Array<{ __typename?: 'TariffLocationEntity', uuid: string, city?: string | null, zipcode?: string | null }> }, tariffRanges: Array<{ __typename?: 'TariffRangeEntity', uuid: string, lessThanOrEqualToValue: number, rateUsdCents: number }>, tariffGroup?: { __typename?: 'TariffGroupEntity', uuid: string, name?: string | null, tariffGroupScope?: TariffGroupScope | null, tariffGroupType: TariffGroupType, rateMultiplier?: number | null, useActualWeightInCalculation: boolean, contactToServicesMappings: Array<{ __typename?: 'ContactToServicesTariffGroupMappingEntity', contact: { __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string }, services: Array<{ __typename?: 'ServiceEntity', uuid: string, name: string }> }>, parentTariffGroup?: { __typename?: 'TariffGroupEntity', uuid: string, contactToServicesMappings: Array<{ __typename?: 'ContactToServicesTariffGroupMappingEntity', contact: { __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string }, services: Array<{ __typename?: 'ServiceEntity', uuid: string, name: string }> }> } | null, fuelProfile?: { __typename?: 'FuelProfileEntity', uuid: string, name?: string | null, startDate?: any | null, expirationDate?: any | null, billingType: FuelBillingMethod, type: FuelProfileType, company: { __typename?: 'CompanyEntity', uuid: string }, contacts?: Array<{ __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string }> | null, fuelProfileDateRanges: Array<{ __typename?: 'FuelProfileDateRangeEntity', uuid: string, startDate: any, expirationDate: any, surchargeRate?: number | null, flatRateUsdCents?: number | null }> } | null } | null }>, contactToServicesMappings: Array<{ __typename?: 'ContactToServicesTariffGroupMappingEntity', contact: { __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string }, services: Array<{ __typename?: 'ServiceEntity', uuid: string, name: string }> }> } | null, fuelProfile?: { __typename?: 'FuelProfileEntity', uuid: string, name?: string | null, startDate?: any | null, expirationDate?: any | null, billingType: FuelBillingMethod, type: FuelProfileType, company: { __typename?: 'CompanyEntity', uuid: string }, contacts?: Array<{ __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string }> | null, fuelProfileDateRanges: Array<{ __typename?: 'FuelProfileDateRangeEntity', uuid: string, startDate: any, expirationDate: any, surchargeRate?: number | null, flatRateUsdCents?: number | null }> } | null, terminals: Array<{ __typename?: 'TerminalEntity', uuid: string, code: string, name: string }> };

export type TariffForTariffGroupFragment = { __typename?: 'TariffEntity', uuid: string, minimumUsdCents?: number | null, maximumUsdCents?: number | null, tariffType: TariffType, rateType: RateType, billingPartyContactUuid?: string | null, settlementPercentageRate?: any | null, useActualWeight?: boolean | null, useActualWeightInCalculation: boolean, service?: { __typename?: 'ServiceEntity', uuid: string, name: string, createdAt: any, updatedAt: any, timeInMinutes?: number | null, useApptInRouteOptimization: boolean, markOrdersAsSpecial: boolean, defaultAppointmentStartTime?: any | null, defaultAppointmentEndTime?: any | null, defaultStartNow: boolean, defaultInboundStopType?: StopType | null, defaultOutboundStopType?: StopType | null, defaultPickupPadding?: any | null, defaultDeliveryPadding?: any | null, defaultTotalDuration?: any | null, defaultIsLineHaul: boolean, defaultFulfillmentType?: FulfillmentType | null, isActive: boolean, isExposedToCustomers: boolean, serviceAvailabilityDates: Array<{ __typename?: 'ServiceAvailabilityDateEntity', id: string, dayCategory: SpecialDayOfWeek, enabled: boolean, start: { __typename?: 'PlainTime', hour: number, minute: number }, end: { __typename?: 'PlainTime', hour: number, minute: number } }> } | null, tariffOverageRates: Array<{ __typename?: 'TariffOverageRateEntity', uuid: string, name: string, type: TariffOverageRateType, rateUsdCents: number, flatRateUsdCents: number, applicableAboveAmount: number }>, tariffZone: { __typename?: 'TariffZoneEntity', uuid: string, name: string, type: TariffZoneType, mileRangeStart?: number | null, mileRangeEnd?: number | null, billingPartyContactUuid?: string | null }, tariffRanges: Array<{ __typename?: 'TariffRangeEntity', uuid: string, lessThanOrEqualToValue: number, rateUsdCents: number }> };

export type TariffGroupForTableFragment = { __typename?: 'TariffGroupEntity', uuid: string, name?: string | null, tariffGroupScope?: TariffGroupScope | null, tariffGroupType: TariffGroupType, startDate?: any | null, endDate?: any | null, rateMultiplier?: number | null, totalContactsToServicesMappings: number, firstTariff?: { __typename?: 'TariffEntity', tariffType: TariffType, rateType: RateType, tariffZone: { __typename?: 'TariffZoneEntity', type: TariffZoneType } } | null, contactToServicesMappings: Array<{ __typename?: 'ContactToServicesTariffGroupMappingEntity', contact: { __typename?: 'CustomerContactEntity', displayName: string } | { __typename?: 'ThirdPartyContactEntity', displayName: string } }> };

export type TariffGroupForTariffFragment = { __typename?: 'TariffGroupEntity', uuid: string, name?: string | null, tariffGroupScope?: TariffGroupScope | null, tariffGroupType: TariffGroupType, rateMultiplier?: number | null, useActualWeightInCalculation: boolean, contactToServicesMappings: Array<{ __typename?: 'ContactToServicesTariffGroupMappingEntity', contact: { __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string }, services: Array<{ __typename?: 'ServiceEntity', uuid: string, name: string }> }>, parentTariffGroup?: { __typename?: 'TariffGroupEntity', uuid: string, contactToServicesMappings: Array<{ __typename?: 'ContactToServicesTariffGroupMappingEntity', contact: { __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string }, services: Array<{ __typename?: 'ServiceEntity', uuid: string, name: string }> }> } | null, fuelProfile?: { __typename?: 'FuelProfileEntity', uuid: string, name?: string | null, startDate?: any | null, expirationDate?: any | null, billingType: FuelBillingMethod, type: FuelProfileType, company: { __typename?: 'CompanyEntity', uuid: string }, contacts?: Array<{ __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string }> | null, fuelProfileDateRanges: Array<{ __typename?: 'FuelProfileDateRangeEntity', uuid: string, startDate: any, expirationDate: any, surchargeRate?: number | null, flatRateUsdCents?: number | null }> } | null };

export type TariffGroupFragment = { __typename?: 'TariffGroupEntity', uuid: string, name?: string | null, tariffGroupType: TariffGroupType, tariffGroupScope?: TariffGroupScope | null, rateMultiplier?: number | null, startDate?: any | null, endDate?: any | null, useActualWeightInCalculation: boolean, useDeficitBilling?: boolean | null, tariffs: Array<{ __typename?: 'TariffEntity', uuid: string, minimumUsdCents?: number | null, maximumUsdCents?: number | null, tariffType: TariffType, rateType: RateType, billingPartyContactUuid?: string | null, settlementPercentageRate?: any | null, useActualWeight?: boolean | null, useActualWeightInCalculation: boolean, service?: { __typename?: 'ServiceEntity', uuid: string, name: string, createdAt: any, updatedAt: any, timeInMinutes?: number | null, useApptInRouteOptimization: boolean, markOrdersAsSpecial: boolean, defaultAppointmentStartTime?: any | null, defaultAppointmentEndTime?: any | null, defaultStartNow: boolean, defaultInboundStopType?: StopType | null, defaultOutboundStopType?: StopType | null, defaultPickupPadding?: any | null, defaultDeliveryPadding?: any | null, defaultTotalDuration?: any | null, defaultIsLineHaul: boolean, defaultFulfillmentType?: FulfillmentType | null, isActive: boolean, isExposedToCustomers: boolean, serviceAvailabilityDates: Array<{ __typename?: 'ServiceAvailabilityDateEntity', id: string, dayCategory: SpecialDayOfWeek, enabled: boolean, start: { __typename?: 'PlainTime', hour: number, minute: number }, end: { __typename?: 'PlainTime', hour: number, minute: number } }> } | null, tariffOverageRates: Array<{ __typename?: 'TariffOverageRateEntity', uuid: string, name: string, type: TariffOverageRateType, rateUsdCents: number, flatRateUsdCents: number, applicableAboveAmount: number }>, tariffZone: { __typename?: 'TariffZoneEntity', uuid: string, name: string, type: TariffZoneType, mileRangeStart?: number | null, mileRangeEnd?: number | null, billingPartyContactUuid?: string | null }, tariffRanges: Array<{ __typename?: 'TariffRangeEntity', uuid: string, lessThanOrEqualToValue: number, rateUsdCents: number }> }>, contactToServicesMappings: Array<{ __typename?: 'ContactToServicesTariffGroupMappingEntity', contact: { __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string }, services: Array<{ __typename?: 'ServiceEntity', uuid: string, name: string }> }>, fuelProfile?: { __typename?: 'FuelProfileEntity', uuid: string, name?: string | null } | null, terminals: Array<{ __typename?: 'TerminalEntity', uuid: string, code: string, name: string }>, tariffZoneGroup?: { __typename?: 'TariffZoneGroupEntity', id: string } | null, services: Array<{ __typename?: 'ServiceEntity', uuid: string }>, vehicleTypes: Array<{ __typename?: 'VehicleTypeEntity', uuid: string }> };

export type TariffGroupQueryVariables = Exact<{
  tariffGroupUuid: Scalars['String']['input'];
}>;


export type TariffGroupQuery = { __typename?: 'Query', tariffGroup: { __typename?: 'TariffGroupEntity', uuid: string, name?: string | null, tariffGroupType: TariffGroupType, tariffGroupScope?: TariffGroupScope | null, rateMultiplier?: number | null, startDate?: any | null, endDate?: any | null, useActualWeightInCalculation: boolean, useDeficitBilling?: boolean | null, tariffs: Array<{ __typename?: 'TariffEntity', uuid: string, minimumUsdCents?: number | null, maximumUsdCents?: number | null, tariffType: TariffType, rateType: RateType, billingPartyContactUuid?: string | null, settlementPercentageRate?: any | null, useActualWeight?: boolean | null, useActualWeightInCalculation: boolean, service?: { __typename?: 'ServiceEntity', uuid: string, name: string, createdAt: any, updatedAt: any, timeInMinutes?: number | null, useApptInRouteOptimization: boolean, markOrdersAsSpecial: boolean, defaultAppointmentStartTime?: any | null, defaultAppointmentEndTime?: any | null, defaultStartNow: boolean, defaultInboundStopType?: StopType | null, defaultOutboundStopType?: StopType | null, defaultPickupPadding?: any | null, defaultDeliveryPadding?: any | null, defaultTotalDuration?: any | null, defaultIsLineHaul: boolean, defaultFulfillmentType?: FulfillmentType | null, isActive: boolean, isExposedToCustomers: boolean, serviceAvailabilityDates: Array<{ __typename?: 'ServiceAvailabilityDateEntity', id: string, dayCategory: SpecialDayOfWeek, enabled: boolean, start: { __typename?: 'PlainTime', hour: number, minute: number }, end: { __typename?: 'PlainTime', hour: number, minute: number } }> } | null, tariffOverageRates: Array<{ __typename?: 'TariffOverageRateEntity', uuid: string, name: string, type: TariffOverageRateType, rateUsdCents: number, flatRateUsdCents: number, applicableAboveAmount: number }>, tariffZone: { __typename?: 'TariffZoneEntity', uuid: string, name: string, type: TariffZoneType, mileRangeStart?: number | null, mileRangeEnd?: number | null, billingPartyContactUuid?: string | null }, tariffRanges: Array<{ __typename?: 'TariffRangeEntity', uuid: string, lessThanOrEqualToValue: number, rateUsdCents: number }> }>, contactToServicesMappings: Array<{ __typename?: 'ContactToServicesTariffGroupMappingEntity', contact: { __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string }, services: Array<{ __typename?: 'ServiceEntity', uuid: string, name: string }> }>, fuelProfile?: { __typename?: 'FuelProfileEntity', uuid: string, name?: string | null } | null, terminals: Array<{ __typename?: 'TerminalEntity', uuid: string, code: string, name: string }>, tariffZoneGroup?: { __typename?: 'TariffZoneGroupEntity', id: string } | null, services: Array<{ __typename?: 'ServiceEntity', uuid: string }>, vehicleTypes: Array<{ __typename?: 'VehicleTypeEntity', uuid: string }> } };

export type TariffOverageRateFragment = { __typename?: 'TariffOverageRateEntity', uuid: string, name: string, type: TariffOverageRateType, rateUsdCents: number, flatRateUsdCents: number, applicableAboveAmount: number };

export type TariffRangeFragment = { __typename?: 'TariffRangeEntity', uuid: string, lessThanOrEqualToValue: number, rateUsdCents: number };

export type TariffShallowFragment = { __typename?: 'TariffEntity', uuid: string, billingPartyContactUuid?: string | null, tariffGroup?: { __typename?: 'TariffGroupEntity', name?: string | null, tariffGroupScope?: TariffGroupScope | null } | null, tariffZone: { __typename?: 'TariffZoneEntity', name: string } };

export type TariffFragment = { __typename?: 'TariffEntity', uuid: string, minimumUsdCents?: number | null, maximumUsdCents?: number | null, settlementPercentageRate?: any | null, tariffType: TariffType, rateType: RateType, billingPartyContactUuid?: string | null, useActualWeight?: boolean | null, useActualWeightInCalculation: boolean, service?: { __typename?: 'ServiceEntity', uuid: string, name: string, createdAt: any, updatedAt: any, timeInMinutes?: number | null, useApptInRouteOptimization: boolean, markOrdersAsSpecial: boolean, defaultAppointmentStartTime?: any | null, defaultAppointmentEndTime?: any | null, defaultStartNow: boolean, defaultInboundStopType?: StopType | null, defaultOutboundStopType?: StopType | null, defaultPickupPadding?: any | null, defaultDeliveryPadding?: any | null, defaultTotalDuration?: any | null, defaultIsLineHaul: boolean, defaultFulfillmentType?: FulfillmentType | null, isActive: boolean, isExposedToCustomers: boolean, serviceAvailabilityDates: Array<{ __typename?: 'ServiceAvailabilityDateEntity', id: string, dayCategory: SpecialDayOfWeek, enabled: boolean, start: { __typename?: 'PlainTime', hour: number, minute: number }, end: { __typename?: 'PlainTime', hour: number, minute: number } }> } | null, tariffOverageRates: Array<{ __typename?: 'TariffOverageRateEntity', uuid: string, name: string, type: TariffOverageRateType, rateUsdCents: number, flatRateUsdCents: number, applicableAboveAmount: number }>, tariffZone: { __typename?: 'TariffZoneEntity', uuid: string, name: string, type: TariffZoneType, mileRangeStart?: number | null, mileRangeEnd?: number | null, billingPartyContactUuid?: string | null, locations: Array<{ __typename?: 'TariffLocationEntity', uuid: string, city?: string | null, zipcode?: string | null }> }, tariffRanges: Array<{ __typename?: 'TariffRangeEntity', uuid: string, lessThanOrEqualToValue: number, rateUsdCents: number }>, tariffGroup?: { __typename?: 'TariffGroupEntity', uuid: string, name?: string | null, tariffGroupScope?: TariffGroupScope | null, tariffGroupType: TariffGroupType, rateMultiplier?: number | null, useActualWeightInCalculation: boolean, contactToServicesMappings: Array<{ __typename?: 'ContactToServicesTariffGroupMappingEntity', contact: { __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string }, services: Array<{ __typename?: 'ServiceEntity', uuid: string, name: string }> }>, parentTariffGroup?: { __typename?: 'TariffGroupEntity', uuid: string, contactToServicesMappings: Array<{ __typename?: 'ContactToServicesTariffGroupMappingEntity', contact: { __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string }, services: Array<{ __typename?: 'ServiceEntity', uuid: string, name: string }> }> } | null, fuelProfile?: { __typename?: 'FuelProfileEntity', uuid: string, name?: string | null, startDate?: any | null, expirationDate?: any | null, billingType: FuelBillingMethod, type: FuelProfileType, company: { __typename?: 'CompanyEntity', uuid: string }, contacts?: Array<{ __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string }> | null, fuelProfileDateRanges: Array<{ __typename?: 'FuelProfileDateRangeEntity', uuid: string, startDate: any, expirationDate: any, surchargeRate?: number | null, flatRateUsdCents?: number | null }> } | null } | null };

export type TariffFragmentFragment = { __typename?: 'TariffEntity', uuid: string, tariffType: TariffType, minimumUsdCents?: number | null, rateType: RateType, maximumUsdCents?: number | null, billingPartyContactUuid?: string | null, useActualWeightInCalculation: boolean, useActualWeight?: boolean | null, service?: { __typename?: 'ServiceEntity', uuid: string, name: string, createdAt: any, updatedAt: any, timeInMinutes?: number | null, useApptInRouteOptimization: boolean, markOrdersAsSpecial: boolean, defaultAppointmentStartTime?: any | null, defaultAppointmentEndTime?: any | null, defaultStartNow: boolean, defaultInboundStopType?: StopType | null, defaultOutboundStopType?: StopType | null, defaultPickupPadding?: any | null, defaultDeliveryPadding?: any | null, defaultTotalDuration?: any | null, defaultIsLineHaul: boolean, defaultFulfillmentType?: FulfillmentType | null, isActive: boolean, isExposedToCustomers: boolean, serviceAvailabilityDates: Array<{ __typename?: 'ServiceAvailabilityDateEntity', id: string, dayCategory: SpecialDayOfWeek, enabled: boolean, start: { __typename?: 'PlainTime', hour: number, minute: number }, end: { __typename?: 'PlainTime', hour: number, minute: number } }> } | null, tariffZone: { __typename?: 'TariffZoneEntity', uuid: string, name: string, type: TariffZoneType, mileRangeStart?: number | null, mileRangeEnd?: number | null, billingPartyContactUuid?: string | null, locations: Array<{ __typename?: 'TariffLocationEntity', uuid: string, city?: string | null, zipcode?: string | null }> }, tariffOverageRates: Array<{ __typename?: 'TariffOverageRateEntity', uuid: string, name: string, type: TariffOverageRateType, rateUsdCents: number, flatRateUsdCents: number, applicableAboveAmount: number }>, tariffRanges: Array<{ __typename?: 'TariffRangeEntity', uuid: string, lessThanOrEqualToValue: number, rateUsdCents: number }>, tariffGroup?: { __typename?: 'TariffGroupEntity', uuid: string, name?: string | null, tariffGroupScope?: TariffGroupScope | null, tariffGroupType: TariffGroupType, rateMultiplier?: number | null, useActualWeightInCalculation: boolean, contactToServicesMappings: Array<{ __typename?: 'ContactToServicesTariffGroupMappingEntity', contact: { __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string }, services: Array<{ __typename?: 'ServiceEntity', uuid: string, name: string }> }>, parentTariffGroup?: { __typename?: 'TariffGroupEntity', uuid: string, tariffs: Array<{ __typename?: 'TariffEntity', uuid: string, minimumUsdCents?: number | null, maximumUsdCents?: number | null, settlementPercentageRate?: any | null, tariffType: TariffType, rateType: RateType, billingPartyContactUuid?: string | null, useActualWeight?: boolean | null, useActualWeightInCalculation: boolean, service?: { __typename?: 'ServiceEntity', uuid: string, name: string, createdAt: any, updatedAt: any, timeInMinutes?: number | null, useApptInRouteOptimization: boolean, markOrdersAsSpecial: boolean, defaultAppointmentStartTime?: any | null, defaultAppointmentEndTime?: any | null, defaultStartNow: boolean, defaultInboundStopType?: StopType | null, defaultOutboundStopType?: StopType | null, defaultPickupPadding?: any | null, defaultDeliveryPadding?: any | null, defaultTotalDuration?: any | null, defaultIsLineHaul: boolean, defaultFulfillmentType?: FulfillmentType | null, isActive: boolean, isExposedToCustomers: boolean, serviceAvailabilityDates: Array<{ __typename?: 'ServiceAvailabilityDateEntity', id: string, dayCategory: SpecialDayOfWeek, enabled: boolean, start: { __typename?: 'PlainTime', hour: number, minute: number }, end: { __typename?: 'PlainTime', hour: number, minute: number } }> } | null, tariffOverageRates: Array<{ __typename?: 'TariffOverageRateEntity', uuid: string, name: string, type: TariffOverageRateType, rateUsdCents: number, flatRateUsdCents: number, applicableAboveAmount: number }>, tariffZone: { __typename?: 'TariffZoneEntity', uuid: string, name: string, type: TariffZoneType, mileRangeStart?: number | null, mileRangeEnd?: number | null, billingPartyContactUuid?: string | null, locations: Array<{ __typename?: 'TariffLocationEntity', uuid: string, city?: string | null, zipcode?: string | null }> }, tariffRanges: Array<{ __typename?: 'TariffRangeEntity', uuid: string, lessThanOrEqualToValue: number, rateUsdCents: number }>, tariffGroup?: { __typename?: 'TariffGroupEntity', uuid: string, name?: string | null, tariffGroupScope?: TariffGroupScope | null, tariffGroupType: TariffGroupType, rateMultiplier?: number | null, useActualWeightInCalculation: boolean, contactToServicesMappings: Array<{ __typename?: 'ContactToServicesTariffGroupMappingEntity', contact: { __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string }, services: Array<{ __typename?: 'ServiceEntity', uuid: string, name: string }> }>, parentTariffGroup?: { __typename?: 'TariffGroupEntity', uuid: string, contactToServicesMappings: Array<{ __typename?: 'ContactToServicesTariffGroupMappingEntity', contact: { __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string }, services: Array<{ __typename?: 'ServiceEntity', uuid: string, name: string }> }> } | null, fuelProfile?: { __typename?: 'FuelProfileEntity', uuid: string, name?: string | null, startDate?: any | null, expirationDate?: any | null, billingType: FuelBillingMethod, type: FuelProfileType, company: { __typename?: 'CompanyEntity', uuid: string }, contacts?: Array<{ __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string }> | null, fuelProfileDateRanges: Array<{ __typename?: 'FuelProfileDateRangeEntity', uuid: string, startDate: any, expirationDate: any, surchargeRate?: number | null, flatRateUsdCents?: number | null }> } | null } | null }>, contactToServicesMappings: Array<{ __typename?: 'ContactToServicesTariffGroupMappingEntity', contact: { __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string }, services: Array<{ __typename?: 'ServiceEntity', uuid: string, name: string }> }> } | null, fuelProfile?: { __typename?: 'FuelProfileEntity', uuid: string, name?: string | null, startDate?: any | null, expirationDate?: any | null, billingType: FuelBillingMethod, type: FuelProfileType, company: { __typename?: 'CompanyEntity', uuid: string }, contacts?: Array<{ __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string }> | null, fuelProfileDateRanges: Array<{ __typename?: 'FuelProfileDateRangeEntity', uuid: string, startDate: any, expirationDate: any, surchargeRate?: number | null, flatRateUsdCents?: number | null }> } | null, terminals: Array<{ __typename?: 'TerminalEntity', uuid: string, code: string, name: string }> } | null };

export type TariffQueryVariables = Exact<{
  uuid: Scalars['String']['input'];
}>;


export type TariffQuery = { __typename?: 'Query', tariff: { __typename?: 'TariffEntity', uuid: string, tariffType: TariffType, minimumUsdCents?: number | null, rateType: RateType, maximumUsdCents?: number | null, billingPartyContactUuid?: string | null, useActualWeightInCalculation: boolean, useActualWeight?: boolean | null, service?: { __typename?: 'ServiceEntity', uuid: string, name: string, createdAt: any, updatedAt: any, timeInMinutes?: number | null, useApptInRouteOptimization: boolean, markOrdersAsSpecial: boolean, defaultAppointmentStartTime?: any | null, defaultAppointmentEndTime?: any | null, defaultStartNow: boolean, defaultInboundStopType?: StopType | null, defaultOutboundStopType?: StopType | null, defaultPickupPadding?: any | null, defaultDeliveryPadding?: any | null, defaultTotalDuration?: any | null, defaultIsLineHaul: boolean, defaultFulfillmentType?: FulfillmentType | null, isActive: boolean, isExposedToCustomers: boolean, serviceAvailabilityDates: Array<{ __typename?: 'ServiceAvailabilityDateEntity', id: string, dayCategory: SpecialDayOfWeek, enabled: boolean, start: { __typename?: 'PlainTime', hour: number, minute: number }, end: { __typename?: 'PlainTime', hour: number, minute: number } }> } | null, tariffZone: { __typename?: 'TariffZoneEntity', uuid: string, name: string, type: TariffZoneType, mileRangeStart?: number | null, mileRangeEnd?: number | null, billingPartyContactUuid?: string | null, locations: Array<{ __typename?: 'TariffLocationEntity', uuid: string, city?: string | null, zipcode?: string | null }> }, tariffOverageRates: Array<{ __typename?: 'TariffOverageRateEntity', uuid: string, name: string, type: TariffOverageRateType, rateUsdCents: number, flatRateUsdCents: number, applicableAboveAmount: number }>, tariffRanges: Array<{ __typename?: 'TariffRangeEntity', uuid: string, lessThanOrEqualToValue: number, rateUsdCents: number }>, tariffGroup?: { __typename?: 'TariffGroupEntity', uuid: string, name?: string | null, tariffGroupScope?: TariffGroupScope | null, tariffGroupType: TariffGroupType, rateMultiplier?: number | null, useActualWeightInCalculation: boolean, contactToServicesMappings: Array<{ __typename?: 'ContactToServicesTariffGroupMappingEntity', contact: { __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string }, services: Array<{ __typename?: 'ServiceEntity', uuid: string, name: string }> }>, parentTariffGroup?: { __typename?: 'TariffGroupEntity', uuid: string, tariffs: Array<{ __typename?: 'TariffEntity', uuid: string, minimumUsdCents?: number | null, maximumUsdCents?: number | null, settlementPercentageRate?: any | null, tariffType: TariffType, rateType: RateType, billingPartyContactUuid?: string | null, useActualWeight?: boolean | null, useActualWeightInCalculation: boolean, service?: { __typename?: 'ServiceEntity', uuid: string, name: string, createdAt: any, updatedAt: any, timeInMinutes?: number | null, useApptInRouteOptimization: boolean, markOrdersAsSpecial: boolean, defaultAppointmentStartTime?: any | null, defaultAppointmentEndTime?: any | null, defaultStartNow: boolean, defaultInboundStopType?: StopType | null, defaultOutboundStopType?: StopType | null, defaultPickupPadding?: any | null, defaultDeliveryPadding?: any | null, defaultTotalDuration?: any | null, defaultIsLineHaul: boolean, defaultFulfillmentType?: FulfillmentType | null, isActive: boolean, isExposedToCustomers: boolean, serviceAvailabilityDates: Array<{ __typename?: 'ServiceAvailabilityDateEntity', id: string, dayCategory: SpecialDayOfWeek, enabled: boolean, start: { __typename?: 'PlainTime', hour: number, minute: number }, end: { __typename?: 'PlainTime', hour: number, minute: number } }> } | null, tariffOverageRates: Array<{ __typename?: 'TariffOverageRateEntity', uuid: string, name: string, type: TariffOverageRateType, rateUsdCents: number, flatRateUsdCents: number, applicableAboveAmount: number }>, tariffZone: { __typename?: 'TariffZoneEntity', uuid: string, name: string, type: TariffZoneType, mileRangeStart?: number | null, mileRangeEnd?: number | null, billingPartyContactUuid?: string | null, locations: Array<{ __typename?: 'TariffLocationEntity', uuid: string, city?: string | null, zipcode?: string | null }> }, tariffRanges: Array<{ __typename?: 'TariffRangeEntity', uuid: string, lessThanOrEqualToValue: number, rateUsdCents: number }>, tariffGroup?: { __typename?: 'TariffGroupEntity', uuid: string, name?: string | null, tariffGroupScope?: TariffGroupScope | null, tariffGroupType: TariffGroupType, rateMultiplier?: number | null, useActualWeightInCalculation: boolean, contactToServicesMappings: Array<{ __typename?: 'ContactToServicesTariffGroupMappingEntity', contact: { __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string }, services: Array<{ __typename?: 'ServiceEntity', uuid: string, name: string }> }>, parentTariffGroup?: { __typename?: 'TariffGroupEntity', uuid: string, contactToServicesMappings: Array<{ __typename?: 'ContactToServicesTariffGroupMappingEntity', contact: { __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string }, services: Array<{ __typename?: 'ServiceEntity', uuid: string, name: string }> }> } | null, fuelProfile?: { __typename?: 'FuelProfileEntity', uuid: string, name?: string | null, startDate?: any | null, expirationDate?: any | null, billingType: FuelBillingMethod, type: FuelProfileType, company: { __typename?: 'CompanyEntity', uuid: string }, contacts?: Array<{ __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string }> | null, fuelProfileDateRanges: Array<{ __typename?: 'FuelProfileDateRangeEntity', uuid: string, startDate: any, expirationDate: any, surchargeRate?: number | null, flatRateUsdCents?: number | null }> } | null } | null }>, contactToServicesMappings: Array<{ __typename?: 'ContactToServicesTariffGroupMappingEntity', contact: { __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string }, services: Array<{ __typename?: 'ServiceEntity', uuid: string, name: string }> }> } | null, fuelProfile?: { __typename?: 'FuelProfileEntity', uuid: string, name?: string | null, startDate?: any | null, expirationDate?: any | null, billingType: FuelBillingMethod, type: FuelProfileType, company: { __typename?: 'CompanyEntity', uuid: string }, contacts?: Array<{ __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string }> | null, fuelProfileDateRanges: Array<{ __typename?: 'FuelProfileDateRangeEntity', uuid: string, startDate: any, expirationDate: any, surchargeRate?: number | null, flatRateUsdCents?: number | null }> } | null, terminals: Array<{ __typename?: 'TerminalEntity', uuid: string, code: string, name: string }> } | null } };

export type UpdateTariffGroupMutationVariables = Exact<{
  updateTariffGroupInput: UpdateTariffGroupInput;
}>;


export type UpdateTariffGroupMutation = { __typename?: 'Mutation', updateTariffGroup: { __typename?: 'TariffGroupEntity', uuid: string, name?: string | null } };

export type ArchiveTariffZoneGroupMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type ArchiveTariffZoneGroupMutation = { __typename?: 'Mutation', archiveTariffZoneGroup: { __typename?: 'MutationErrorOutput', message: string } | { __typename?: 'TariffZoneGroupArchiveSuccessOutput', tariffZoneGroup: { __typename?: 'TariffZoneGroupEntity', id: string } } };

export type CreateTariffZoneGroupMutationVariables = Exact<{
  tariffZoneGroupCreateInput: TariffZoneGroupCreateInput;
}>;


export type CreateTariffZoneGroupMutation = { __typename?: 'Mutation', createTariffZoneGroup: { __typename?: 'MutationErrorOutput', message: string } | { __typename?: 'TariffZoneGroupCreateSuccessOutput', tariffZoneGroup: { __typename?: 'TariffZoneGroupEntity', id: string } } };

export type RestoreTariffZoneGroupMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type RestoreTariffZoneGroupMutation = { __typename?: 'Mutation', restoreTariffZoneGroup: { __typename?: 'MutationErrorOutput', message: string } | { __typename?: 'TariffZoneGroupRestoreSuccessOutput', tariffZoneGroup: { __typename?: 'TariffZoneGroupEntity', id: string } } };

export type TariffZoneGroupFragment = { __typename?: 'TariffZoneGroupEntity', id: string, name: string, description?: string | null };

export type TariffZoneGroupsQueryVariables = Exact<{
  findTariffZoneGroupsInput: FindTariffZoneGroupsInput;
}>;


export type TariffZoneGroupsQuery = { __typename?: 'Query', tariffZoneGroups: Array<{ __typename?: 'TariffZoneGroupEntity', id: string, name: string, description?: string | null }> };

export type TariffZoneGroupWithTariffZonesFragment = { __typename?: 'TariffZoneGroupEntity', id: string, name: string, description?: string | null, tariffZones: Array<{ __typename?: 'TariffZoneEntity', uuid: string, name: string, type: TariffZoneType, lineHaulLane?: { __typename?: 'LineHaulLaneEntity', isActive: boolean } | null }> };

export type TariffZonesForGroupQueryVariables = Exact<{
  tariffZoneGroupId: Scalars['String']['input'];
}>;


export type TariffZonesForGroupQuery = { __typename?: 'Query', tariffZoneGroup: { __typename?: 'TariffZoneGroupEntity', id: string, name: string, description?: string | null, tariffZones: Array<{ __typename?: 'TariffZoneEntity', uuid: string, name: string, type: TariffZoneType, lineHaulLane?: { __typename?: 'LineHaulLaneEntity', isActive: boolean } | null }> } };

export type UpdateTariffZoneGroupMutationVariables = Exact<{
  tariffZoneGroupUpdateInput: TariffZoneGroupUpdateInput;
}>;


export type UpdateTariffZoneGroupMutation = { __typename?: 'Mutation', updateTariffZoneGroup: { __typename?: 'MutationErrorOutput', message: string } | { __typename?: 'TariffZoneGroupUpdateSuccessOutput', tariffZoneGroup: { __typename?: 'TariffZoneGroupEntity', id: string } } };

export type AccessorialDateRangeConfigByUuidQueryVariables = Exact<{
  uuid: Scalars['String']['input'];
}>;


export type AccessorialDateRangeConfigByUuidQuery = { __typename?: 'Query', accessorialDateRangeConfigByUuid: { __typename?: 'AccessorialDateRangeConfigEntity', uuid: string, specialChargeGroups: Array<{ __typename?: 'SpecialAccessorialChargeGroupEntity', uuid: string, dayOfWeek: SpecialDayOfWeek, startTime: any, endTime: any }>, specialMatrixItems: Array<{ __typename?: 'SpecialAccessorialMatrixItemEntity', chargeGroupUuid: string, uuid: string, rate: number, tariffZone: { __typename?: 'TariffZoneEntity', uuid: string, name: string, mileRangeStart?: number | null, mileRangeEnd?: number | null } }>, accessorialRanges: Array<{ __typename?: 'AccessorialRangeEntity', uuid: string, lessThanOrEqualToValue: number, rateUsdCents: number }> } };

export type AccessorialDateRangeConfigFragment = { __typename?: 'AccessorialDateRangeConfigEntity', uuid: string, startDate: any, endDate?: any | null, percentForSettlement?: number | null, fuelSurchargePercentageRate?: number | null, rate: number, fuelProfile?: { __typename?: 'FuelProfileEntity', uuid: string } | null, accessorialRanges: Array<{ __typename?: 'AccessorialRangeEntity', uuid: string, lessThanOrEqualToValue: number, rateUsdCents: number }> };

export type AccessorialDateRangeConfigsQueryVariables = Exact<{
  findAccessorialDateRangeConfigsInput: FindAccessorialDateRangeConfigsInput;
}>;


export type AccessorialDateRangeConfigsQuery = { __typename?: 'Query', accessorialDateRangeConfigs: { __typename?: 'FindAccessorialDateRangeConfigsOutput', accessorialDateRangeConfigs: Array<{ __typename?: 'AccessorialDateRangeConfigEntity', uuid: string, startDate: any, endDate?: any | null, percentForSettlement?: number | null, fuelSurchargePercentageRate?: number | null, rate: number, fuelProfile?: { __typename?: 'FuelProfileEntity', uuid: string } | null, accessorialRanges: Array<{ __typename?: 'AccessorialRangeEntity', uuid: string, lessThanOrEqualToValue: number, rateUsdCents: number }> }> } };

export type CreateAccessorialDateRangeConfigMutationVariables = Exact<{
  createAccessorialDateRangeConfigInput: CreateAccessorialDateRangeConfigInput;
}>;


export type CreateAccessorialDateRangeConfigMutation = { __typename?: 'Mutation', createAccessorialDateRangeConfig: { __typename?: 'CreateAccessorialDateRangeConfigOutput', success: boolean } };

export type DeleteAccessorialDateRangeConfigMutationVariables = Exact<{
  deleteAccessorialDateRangeConfigInput: DeleteAccessorialDateRangeConfigInput;
}>;


export type DeleteAccessorialDateRangeConfigMutation = { __typename?: 'Mutation', deleteAccessorialDateRangeConfig: { __typename?: 'AccessorialDateRangeConfigEntity', uuid: string } };

export type UpdateAccessorialDateRangeConfigMutationVariables = Exact<{
  updateAccessorialDateRangeConfigInput: UpdateAccessorialDateRangeConfigInput;
}>;


export type UpdateAccessorialDateRangeConfigMutation = { __typename?: 'Mutation', updateAccessorialDateRangeConfig: { __typename?: 'UpdateAccessorialDateRangeConfigOutput', success: boolean } };

export type AccessorialNamesByBillingContactQueryVariables = Exact<{
  billingPartyContactUuid?: InputMaybe<Scalars['String']['input']>;
  onlyShowCompanyAccessorials?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type AccessorialNamesByBillingContactQuery = { __typename?: 'Query', accessorialsByBillingContact: Array<{ __typename: 'SkidBasedAccessorialEntity', name: string, uuid: string } | { __typename: 'SpecialAccessorialEntity', name: string, uuid: string } | { __typename: 'StandardAccessorialEntity', name: string, uuid: string } | { __typename: 'UnitBasedAccessorialEntity', name: string, uuid: string } | { __typename: 'WaitTimeAccessorialEntity', name: string, uuid: string } | { __typename: 'WeightBasedAccessorialEntity', name: string, uuid: string } | { __typename: 'ZoneBasedAccessorialEntity', name: string, uuid: string }> };

type AccessorialNames_SkidBasedAccessorialEntity_Fragment = { __typename: 'SkidBasedAccessorialEntity', name: string, uuid: string };

type AccessorialNames_SpecialAccessorialEntity_Fragment = { __typename: 'SpecialAccessorialEntity', name: string, uuid: string };

type AccessorialNames_StandardAccessorialEntity_Fragment = { __typename: 'StandardAccessorialEntity', name: string, uuid: string };

type AccessorialNames_UnitBasedAccessorialEntity_Fragment = { __typename: 'UnitBasedAccessorialEntity', name: string, uuid: string };

type AccessorialNames_WaitTimeAccessorialEntity_Fragment = { __typename: 'WaitTimeAccessorialEntity', name: string, uuid: string };

type AccessorialNames_WeightBasedAccessorialEntity_Fragment = { __typename: 'WeightBasedAccessorialEntity', name: string, uuid: string };

type AccessorialNames_ZoneBasedAccessorialEntity_Fragment = { __typename: 'ZoneBasedAccessorialEntity', name: string, uuid: string };

export type AccessorialNamesFragment = AccessorialNames_SkidBasedAccessorialEntity_Fragment | AccessorialNames_SpecialAccessorialEntity_Fragment | AccessorialNames_StandardAccessorialEntity_Fragment | AccessorialNames_UnitBasedAccessorialEntity_Fragment | AccessorialNames_WaitTimeAccessorialEntity_Fragment | AccessorialNames_WeightBasedAccessorialEntity_Fragment | AccessorialNames_ZoneBasedAccessorialEntity_Fragment;

export type AccessorialsByBillingContactQueryVariables = Exact<{
  billingPartyContactUuid?: InputMaybe<Scalars['String']['input']>;
  onlyShowCompanyAccessorials?: InputMaybe<Scalars['Boolean']['input']>;
  terminalUuids?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;


export type AccessorialsByBillingContactQuery = { __typename?: 'Query', accessorialsByBillingContact: Array<{ __typename?: 'SkidBasedAccessorialEntity', uuid: string, name: string, isArchived?: boolean | null, isAuthoCodeRequired: boolean, contact?: { __typename?: 'CustomerContactEntity', uuid: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string } | null, matchingGlobalAccessorial?: { __typename?: 'SkidBasedAccessorialEntity', uuid: string } | { __typename?: 'SpecialAccessorialEntity', uuid: string } | { __typename?: 'StandardAccessorialEntity', uuid: string } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string } | null } | { __typename?: 'SpecialAccessorialEntity', uuid: string, name: string, isArchived?: boolean | null, isAuthoCodeRequired: boolean, contact?: { __typename?: 'CustomerContactEntity', uuid: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string } | null, matchingGlobalAccessorial?: { __typename?: 'SkidBasedAccessorialEntity', uuid: string } | { __typename?: 'SpecialAccessorialEntity', uuid: string } | { __typename?: 'StandardAccessorialEntity', uuid: string } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string } | null, chargeGroups: Array<{ __typename?: 'SpecialAccessorialChargeGroupEntity', uuid: string }> } | { __typename?: 'StandardAccessorialEntity', uuid: string, name: string, isArchived?: boolean | null, isAuthoCodeRequired: boolean, contact?: { __typename?: 'CustomerContactEntity', uuid: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string } | null, matchingGlobalAccessorial?: { __typename?: 'SkidBasedAccessorialEntity', uuid: string } | { __typename?: 'SpecialAccessorialEntity', uuid: string } | { __typename?: 'StandardAccessorialEntity', uuid: string } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string } | null } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string, name: string, isArchived?: boolean | null, isAuthoCodeRequired: boolean, contact?: { __typename?: 'CustomerContactEntity', uuid: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string } | null, matchingGlobalAccessorial?: { __typename?: 'SkidBasedAccessorialEntity', uuid: string } | { __typename?: 'SpecialAccessorialEntity', uuid: string } | { __typename?: 'StandardAccessorialEntity', uuid: string } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string } | null } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string, name: string, isArchived?: boolean | null, isAuthoCodeRequired: boolean, contact?: { __typename?: 'CustomerContactEntity', uuid: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string } | null, matchingGlobalAccessorial?: { __typename?: 'SkidBasedAccessorialEntity', uuid: string } | { __typename?: 'SpecialAccessorialEntity', uuid: string } | { __typename?: 'StandardAccessorialEntity', uuid: string } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string } | null } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string, name: string, isArchived?: boolean | null, isAuthoCodeRequired: boolean, contact?: { __typename?: 'CustomerContactEntity', uuid: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string } | null, matchingGlobalAccessorial?: { __typename?: 'SkidBasedAccessorialEntity', uuid: string } | { __typename?: 'SpecialAccessorialEntity', uuid: string } | { __typename?: 'StandardAccessorialEntity', uuid: string } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string } | null } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string, name: string, isArchived?: boolean | null, isAuthoCodeRequired: boolean, contact?: { __typename?: 'CustomerContactEntity', uuid: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string } | null, matchingGlobalAccessorial?: { __typename?: 'SkidBasedAccessorialEntity', uuid: string } | { __typename?: 'SpecialAccessorialEntity', uuid: string } | { __typename?: 'StandardAccessorialEntity', uuid: string } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string } | null, zones: Array<{ __typename?: 'ZoneBasedAccessorialZoneEntity', uuid: string }>, chargeGroups: Array<{ __typename?: 'ZoneBasedAccessorialChargeGroupEntity', uuid: string }> }> };

type AccessorialsUuid_SkidBasedAccessorialEntity_Fragment = { __typename?: 'SkidBasedAccessorialEntity', uuid: string };

type AccessorialsUuid_SpecialAccessorialEntity_Fragment = { __typename?: 'SpecialAccessorialEntity', uuid: string };

type AccessorialsUuid_StandardAccessorialEntity_Fragment = { __typename?: 'StandardAccessorialEntity', uuid: string };

type AccessorialsUuid_UnitBasedAccessorialEntity_Fragment = { __typename?: 'UnitBasedAccessorialEntity', uuid: string };

type AccessorialsUuid_WaitTimeAccessorialEntity_Fragment = { __typename?: 'WaitTimeAccessorialEntity', uuid: string };

type AccessorialsUuid_WeightBasedAccessorialEntity_Fragment = { __typename?: 'WeightBasedAccessorialEntity', uuid: string };

type AccessorialsUuid_ZoneBasedAccessorialEntity_Fragment = { __typename?: 'ZoneBasedAccessorialEntity', uuid: string };

export type AccessorialsUuidFragment = AccessorialsUuid_SkidBasedAccessorialEntity_Fragment | AccessorialsUuid_SpecialAccessorialEntity_Fragment | AccessorialsUuid_StandardAccessorialEntity_Fragment | AccessorialsUuid_UnitBasedAccessorialEntity_Fragment | AccessorialsUuid_WaitTimeAccessorialEntity_Fragment | AccessorialsUuid_WeightBasedAccessorialEntity_Fragment | AccessorialsUuid_ZoneBasedAccessorialEntity_Fragment;

export type CreateAccessorialMutationVariables = Exact<{
  input: CreateAccessorialInput;
}>;


export type CreateAccessorialMutation = { __typename?: 'Mutation', createAccessorial: { __typename?: 'SkidBasedAccessorialEntity', uuid: string } | { __typename?: 'SpecialAccessorialEntity', uuid: string } | { __typename?: 'StandardAccessorialEntity', uuid: string } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string } };

export type RemoveAccessorialMutationVariables = Exact<{
  input: Scalars['String']['input'];
}>;


export type RemoveAccessorialMutation = { __typename?: 'Mutation', removeAccessorial: { __typename?: 'SkidBasedAccessorialEntity', uuid: string } | { __typename?: 'SpecialAccessorialEntity', uuid: string } | { __typename?: 'StandardAccessorialEntity', uuid: string } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string } };

export type AccessorialFuelProfileFragment = { __typename?: 'FuelProfileEntity', uuid: string, name?: string | null, startDate?: any | null, expirationDate?: any | null, billingType: FuelBillingMethod, type: FuelProfileType, company: { __typename?: 'CompanyEntity', uuid: string }, contacts?: Array<{ __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string }> | null, fuelProfileDateRanges: Array<{ __typename?: 'FuelProfileDateRangeEntity', uuid: string, startDate: any, expirationDate: any, surchargeRate?: number | null, flatRateUsdCents?: number | null }> };

export type AccessorialTerminalFragment = { __typename?: 'TerminalEntity', uuid: string, name: string, code: string };

type AccessorialUnionUuidOnly_SkidBasedAccessorialEntity_Fragment = { __typename?: 'SkidBasedAccessorialEntity', uuid: string };

type AccessorialUnionUuidOnly_SpecialAccessorialEntity_Fragment = { __typename?: 'SpecialAccessorialEntity', uuid: string };

type AccessorialUnionUuidOnly_StandardAccessorialEntity_Fragment = { __typename?: 'StandardAccessorialEntity', uuid: string };

type AccessorialUnionUuidOnly_UnitBasedAccessorialEntity_Fragment = { __typename?: 'UnitBasedAccessorialEntity', uuid: string };

type AccessorialUnionUuidOnly_WaitTimeAccessorialEntity_Fragment = { __typename?: 'WaitTimeAccessorialEntity', uuid: string };

type AccessorialUnionUuidOnly_WeightBasedAccessorialEntity_Fragment = { __typename?: 'WeightBasedAccessorialEntity', uuid: string };

type AccessorialUnionUuidOnly_ZoneBasedAccessorialEntity_Fragment = { __typename?: 'ZoneBasedAccessorialEntity', uuid: string };

export type AccessorialUnionUuidOnlyFragment = AccessorialUnionUuidOnly_SkidBasedAccessorialEntity_Fragment | AccessorialUnionUuidOnly_SpecialAccessorialEntity_Fragment | AccessorialUnionUuidOnly_StandardAccessorialEntity_Fragment | AccessorialUnionUuidOnly_UnitBasedAccessorialEntity_Fragment | AccessorialUnionUuidOnly_WaitTimeAccessorialEntity_Fragment | AccessorialUnionUuidOnly_WeightBasedAccessorialEntity_Fragment | AccessorialUnionUuidOnly_ZoneBasedAccessorialEntity_Fragment;

export type AccessorialQueryVariables = Exact<{
  uuid: Scalars['String']['input'];
}>;


export type AccessorialQuery = { __typename?: 'Query', accessorial: { __typename: 'SkidBasedAccessorialEntity', isArchived?: boolean | null, isAuthoCodeRequired: boolean, isDefaultGlobalSpecial: boolean, invoiceDisplayName?: string | null, quickbooksDesktopAccessorialId?: string | null, uuid: string, quickbooksFileMappingChargeName?: string | null, quickbooksMappingId: string, percentForSettlement?: number | null, name: string, code?: string | null, ediCode?: string | null, ratePerSkid: number, maximumCharge?: number | null, minimumCharge?: number | null, contact?: { __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string } | null, matchingGlobalAccessorial?: { __typename?: 'SkidBasedAccessorialEntity', uuid: string } | { __typename?: 'SpecialAccessorialEntity', uuid: string } | { __typename?: 'StandardAccessorialEntity', uuid: string } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string } | null, matchingCustomerAccessorials?: Array<{ __typename?: 'SkidBasedAccessorialEntity', uuid: string } | { __typename?: 'SpecialAccessorialEntity', uuid: string } | { __typename?: 'StandardAccessorialEntity', uuid: string } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string }> | null, terminal?: { __typename?: 'TerminalEntity', uuid: string, name: string, code: string } | null, fuelProfile?: { __typename?: 'FuelProfileEntity', uuid: string, name?: string | null, startDate?: any | null, expirationDate?: any | null, billingType: FuelBillingMethod, type: FuelProfileType, company: { __typename?: 'CompanyEntity', uuid: string }, contacts?: Array<{ __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string }> | null, fuelProfileDateRanges: Array<{ __typename?: 'FuelProfileDateRangeEntity', uuid: string, startDate: any, expirationDate: any, surchargeRate?: number | null, flatRateUsdCents?: number | null }> } | null, generalLedgerCode?: { __typename?: 'GeneralLedgerCodeEntity', id: string, code: string } | null } | { __typename: 'SpecialAccessorialEntity', isArchived?: boolean | null, isAuthoCodeRequired: boolean, isDefaultGlobalSpecial: boolean, specialAccessorialType?: SpecialAccessorialType | null, invoiceDisplayName?: string | null, uuid: string, quickbooksDesktopAccessorialId?: string | null, quickbooksFileMappingChargeName?: string | null, quickbooksMappingId: string, percentForSettlement?: number | null, name: string, code?: string | null, ediCode?: string | null, contact?: { __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string } | null, serviceLevel?: { __typename?: 'ServiceEntity', uuid: string, name: string, createdAt: any, updatedAt: any, timeInMinutes?: number | null, useApptInRouteOptimization: boolean, markOrdersAsSpecial: boolean, defaultAppointmentStartTime?: any | null, defaultAppointmentEndTime?: any | null, defaultStartNow: boolean, defaultInboundStopType?: StopType | null, defaultOutboundStopType?: StopType | null, defaultPickupPadding?: any | null, defaultDeliveryPadding?: any | null, defaultTotalDuration?: any | null, defaultIsLineHaul: boolean, defaultFulfillmentType?: FulfillmentType | null, isActive: boolean, isExposedToCustomers: boolean, serviceAvailabilityDates: Array<{ __typename?: 'ServiceAvailabilityDateEntity', id: string, dayCategory: SpecialDayOfWeek, enabled: boolean, start: { __typename?: 'PlainTime', hour: number, minute: number }, end: { __typename?: 'PlainTime', hour: number, minute: number } }> } | null, zones: Array<{ __typename?: 'TariffZoneEntity', uuid: string, name: string }>, chargeGroups: Array<{ __typename?: 'SpecialAccessorialChargeGroupEntity', uuid: string, dayOfWeek: SpecialDayOfWeek, startTime: any, endTime: any }>, matrixItems: Array<{ __typename?: 'SpecialAccessorialMatrixItemEntity', zoneUuid: string, chargeGroupUuid: string, uuid: string, rate: number }>, matchingGlobalAccessorial?: { __typename?: 'SkidBasedAccessorialEntity', uuid: string } | { __typename?: 'SpecialAccessorialEntity', uuid: string } | { __typename?: 'StandardAccessorialEntity', uuid: string } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string } | null, matchingCustomerAccessorials?: Array<{ __typename?: 'SkidBasedAccessorialEntity', uuid: string } | { __typename?: 'SpecialAccessorialEntity', uuid: string } | { __typename?: 'StandardAccessorialEntity', uuid: string } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string }> | null, terminal?: { __typename?: 'TerminalEntity', uuid: string, name: string, code: string } | null, fuelProfile?: { __typename?: 'FuelProfileEntity', uuid: string, name?: string | null, startDate?: any | null, expirationDate?: any | null, billingType: FuelBillingMethod, type: FuelProfileType, company: { __typename?: 'CompanyEntity', uuid: string }, contacts?: Array<{ __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string }> | null, fuelProfileDateRanges: Array<{ __typename?: 'FuelProfileDateRangeEntity', uuid: string, startDate: any, expirationDate: any, surchargeRate?: number | null, flatRateUsdCents?: number | null }> } | null, tariffZoneGroup?: { __typename?: 'TariffZoneGroupEntity', id: string } | null, generalLedgerCode?: { __typename?: 'GeneralLedgerCodeEntity', id: string, code: string } | null } | { __typename: 'StandardAccessorialEntity', isArchived?: boolean | null, isAuthoCodeRequired: boolean, isDefaultGlobalSpecial: boolean, invoiceDisplayName?: string | null, quickbooksDesktopAccessorialId?: string | null, uuid: string, quickbooksFileMappingChargeName?: string | null, quickbooksMappingId: string, percentForSettlement?: number | null, name: string, code?: string | null, ediCode?: string | null, rate: number, contact?: { __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string } | null, matchingGlobalAccessorial?: { __typename?: 'SkidBasedAccessorialEntity', uuid: string } | { __typename?: 'SpecialAccessorialEntity', uuid: string } | { __typename?: 'StandardAccessorialEntity', uuid: string } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string } | null, matchingCustomerAccessorials?: Array<{ __typename?: 'SkidBasedAccessorialEntity', uuid: string } | { __typename?: 'SpecialAccessorialEntity', uuid: string } | { __typename?: 'StandardAccessorialEntity', uuid: string } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string }> | null, terminal?: { __typename?: 'TerminalEntity', uuid: string, name: string, code: string } | null, fuelProfile?: { __typename?: 'FuelProfileEntity', uuid: string, name?: string | null, startDate?: any | null, expirationDate?: any | null, billingType: FuelBillingMethod, type: FuelProfileType, company: { __typename?: 'CompanyEntity', uuid: string }, contacts?: Array<{ __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string }> | null, fuelProfileDateRanges: Array<{ __typename?: 'FuelProfileDateRangeEntity', uuid: string, startDate: any, expirationDate: any, surchargeRate?: number | null, flatRateUsdCents?: number | null }> } | null, generalLedgerCode?: { __typename?: 'GeneralLedgerCodeEntity', id: string, code: string } | null } | { __typename: 'UnitBasedAccessorialEntity', isArchived?: boolean | null, isAuthoCodeRequired: boolean, isDefaultGlobalSpecial: boolean, invoiceDisplayName?: string | null, quickbooksDesktopAccessorialId?: string | null, uuid: string, quickbooksFileMappingChargeName?: string | null, quickbooksMappingId: string, percentForSettlement?: number | null, name: string, code?: string | null, ediCode?: string | null, ratePerUnit: number, maximumCharge?: number | null, minimumCharge?: number | null, contact?: { __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string } | null, matchingGlobalAccessorial?: { __typename?: 'SkidBasedAccessorialEntity', uuid: string } | { __typename?: 'SpecialAccessorialEntity', uuid: string } | { __typename?: 'StandardAccessorialEntity', uuid: string } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string } | null, matchingCustomerAccessorials?: Array<{ __typename?: 'SkidBasedAccessorialEntity', uuid: string } | { __typename?: 'SpecialAccessorialEntity', uuid: string } | { __typename?: 'StandardAccessorialEntity', uuid: string } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string }> | null, terminal?: { __typename?: 'TerminalEntity', uuid: string, name: string, code: string } | null, fuelProfile?: { __typename?: 'FuelProfileEntity', uuid: string, name?: string | null, startDate?: any | null, expirationDate?: any | null, billingType: FuelBillingMethod, type: FuelProfileType, company: { __typename?: 'CompanyEntity', uuid: string }, contacts?: Array<{ __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string }> | null, fuelProfileDateRanges: Array<{ __typename?: 'FuelProfileDateRangeEntity', uuid: string, startDate: any, expirationDate: any, surchargeRate?: number | null, flatRateUsdCents?: number | null }> } | null, generalLedgerCode?: { __typename?: 'GeneralLedgerCodeEntity', id: string, code: string } | null } | { __typename: 'WaitTimeAccessorialEntity', isArchived?: boolean | null, isAuthoCodeRequired: boolean, isDefaultGlobalSpecial: boolean, invoiceDisplayName?: string | null, quickbooksDesktopAccessorialId?: string | null, uuid: string, quickbooksFileMappingChargeName?: string | null, quickbooksMappingId: string, percentForSettlement?: number | null, name: string, code?: string | null, ediCode?: string | null, rate: number, maximumCharge?: number | null, minimumCharge?: number | null, waitTimeChargePeriod?: number | null, waitTimeFreeMinutes?: number | null, contact?: { __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string } | null, matchingGlobalAccessorial?: { __typename?: 'SkidBasedAccessorialEntity', uuid: string } | { __typename?: 'SpecialAccessorialEntity', uuid: string } | { __typename?: 'StandardAccessorialEntity', uuid: string } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string } | null, matchingCustomerAccessorials?: Array<{ __typename?: 'SkidBasedAccessorialEntity', uuid: string } | { __typename?: 'SpecialAccessorialEntity', uuid: string } | { __typename?: 'StandardAccessorialEntity', uuid: string } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string }> | null, terminal?: { __typename?: 'TerminalEntity', uuid: string, name: string, code: string } | null, fuelProfile?: { __typename?: 'FuelProfileEntity', uuid: string, name?: string | null, startDate?: any | null, expirationDate?: any | null, billingType: FuelBillingMethod, type: FuelProfileType, company: { __typename?: 'CompanyEntity', uuid: string }, contacts?: Array<{ __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string }> | null, fuelProfileDateRanges: Array<{ __typename?: 'FuelProfileDateRangeEntity', uuid: string, startDate: any, expirationDate: any, surchargeRate?: number | null, flatRateUsdCents?: number | null }> } | null, generalLedgerCode?: { __typename?: 'GeneralLedgerCodeEntity', id: string, code: string } | null } | { __typename: 'WeightBasedAccessorialEntity', isArchived?: boolean | null, isAuthoCodeRequired: boolean, isDefaultGlobalSpecial: boolean, invoiceDisplayName?: string | null, quickbooksDesktopAccessorialId?: string | null, uuid: string, quickbooksFileMappingChargeName?: string | null, quickbooksMappingId: string, percentForSettlement?: number | null, name: string, code?: string | null, ediCode?: string | null, ratePerHundredWeight: number, maximumCharge?: number | null, minimumCharge?: number | null, contact?: { __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string } | null, accessorialRanges?: Array<{ __typename?: 'AccessorialRangeEntity', uuid: string, lessThanOrEqualToValue: number, rateUsdCents: number }> | null, matchingGlobalAccessorial?: { __typename?: 'SkidBasedAccessorialEntity', uuid: string } | { __typename?: 'SpecialAccessorialEntity', uuid: string } | { __typename?: 'StandardAccessorialEntity', uuid: string } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string } | null, matchingCustomerAccessorials?: Array<{ __typename?: 'SkidBasedAccessorialEntity', uuid: string } | { __typename?: 'SpecialAccessorialEntity', uuid: string } | { __typename?: 'StandardAccessorialEntity', uuid: string } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string }> | null, terminal?: { __typename?: 'TerminalEntity', uuid: string, name: string, code: string } | null, fuelProfile?: { __typename?: 'FuelProfileEntity', uuid: string, name?: string | null, startDate?: any | null, expirationDate?: any | null, billingType: FuelBillingMethod, type: FuelProfileType, company: { __typename?: 'CompanyEntity', uuid: string }, contacts?: Array<{ __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string }> | null, fuelProfileDateRanges: Array<{ __typename?: 'FuelProfileDateRangeEntity', uuid: string, startDate: any, expirationDate: any, surchargeRate?: number | null, flatRateUsdCents?: number | null }> } | null, generalLedgerCode?: { __typename?: 'GeneralLedgerCodeEntity', code: string, id: string } | null } | { __typename: 'ZoneBasedAccessorialEntity', isArchived?: boolean | null, isAuthoCodeRequired: boolean, isDefaultGlobalSpecial: boolean, invoiceDisplayName?: string | null, quickbooksDesktopAccessorialId?: string | null, uuid: string, quickbooksFileMappingChargeName?: string | null, quickbooksMappingId: string, percentForSettlement?: number | null, name: string, code?: string | null, ediCode?: string | null, contact?: { __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string } | null, zones: Array<{ __typename?: 'ZoneBasedAccessorialZoneEntity', uuid: string, name: string }>, chargeGroups: Array<{ __typename?: 'ZoneBasedAccessorialChargeGroupEntity', uuid: string, name: string }>, matrixItems: Array<{ __typename?: 'ZoneBasedAccessorialMatrixItemEntity', zoneUuid: string, chargeGroupUuid: string, uuid: string, rate: number }>, matchingGlobalAccessorial?: { __typename?: 'SkidBasedAccessorialEntity', uuid: string } | { __typename?: 'SpecialAccessorialEntity', uuid: string } | { __typename?: 'StandardAccessorialEntity', uuid: string } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string } | null, matchingCustomerAccessorials?: Array<{ __typename?: 'SkidBasedAccessorialEntity', uuid: string } | { __typename?: 'SpecialAccessorialEntity', uuid: string } | { __typename?: 'StandardAccessorialEntity', uuid: string } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string }> | null, terminal?: { __typename?: 'TerminalEntity', uuid: string, name: string, code: string } | null, fuelProfile?: { __typename?: 'FuelProfileEntity', uuid: string, name?: string | null, startDate?: any | null, expirationDate?: any | null, billingType: FuelBillingMethod, type: FuelProfileType, company: { __typename?: 'CompanyEntity', uuid: string }, contacts?: Array<{ __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string }> | null, fuelProfileDateRanges: Array<{ __typename?: 'FuelProfileDateRangeEntity', uuid: string, startDate: any, expirationDate: any, surchargeRate?: number | null, flatRateUsdCents?: number | null }> } | null, generalLedgerCode?: { __typename?: 'GeneralLedgerCodeEntity', id: string, code: string } | null } };

type AllAccessorialFields_SkidBasedAccessorialEntity_Fragment = { __typename: 'SkidBasedAccessorialEntity', isArchived?: boolean | null, isAuthoCodeRequired: boolean, isDefaultGlobalSpecial: boolean, invoiceDisplayName?: string | null, quickbooksDesktopAccessorialId?: string | null, uuid: string, quickbooksFileMappingChargeName?: string | null, quickbooksMappingId: string, percentForSettlement?: number | null, name: string, code?: string | null, ediCode?: string | null, ratePerSkid: number, maximumCharge?: number | null, minimumCharge?: number | null, contact?: { __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string } | null, matchingGlobalAccessorial?: { __typename?: 'SkidBasedAccessorialEntity', uuid: string } | { __typename?: 'SpecialAccessorialEntity', uuid: string } | { __typename?: 'StandardAccessorialEntity', uuid: string } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string } | null, matchingCustomerAccessorials?: Array<{ __typename?: 'SkidBasedAccessorialEntity', uuid: string } | { __typename?: 'SpecialAccessorialEntity', uuid: string } | { __typename?: 'StandardAccessorialEntity', uuid: string } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string }> | null, terminal?: { __typename?: 'TerminalEntity', uuid: string, name: string, code: string } | null, fuelProfile?: { __typename?: 'FuelProfileEntity', uuid: string, name?: string | null, startDate?: any | null, expirationDate?: any | null, billingType: FuelBillingMethod, type: FuelProfileType, company: { __typename?: 'CompanyEntity', uuid: string }, contacts?: Array<{ __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string }> | null, fuelProfileDateRanges: Array<{ __typename?: 'FuelProfileDateRangeEntity', uuid: string, startDate: any, expirationDate: any, surchargeRate?: number | null, flatRateUsdCents?: number | null }> } | null, generalLedgerCode?: { __typename?: 'GeneralLedgerCodeEntity', id: string, code: string } | null };

type AllAccessorialFields_SpecialAccessorialEntity_Fragment = { __typename: 'SpecialAccessorialEntity', isArchived?: boolean | null, isAuthoCodeRequired: boolean, isDefaultGlobalSpecial: boolean, specialAccessorialType?: SpecialAccessorialType | null, invoiceDisplayName?: string | null, uuid: string, quickbooksDesktopAccessorialId?: string | null, quickbooksFileMappingChargeName?: string | null, quickbooksMappingId: string, percentForSettlement?: number | null, name: string, code?: string | null, ediCode?: string | null, contact?: { __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string } | null, serviceLevel?: { __typename?: 'ServiceEntity', uuid: string, name: string, createdAt: any, updatedAt: any, timeInMinutes?: number | null, useApptInRouteOptimization: boolean, markOrdersAsSpecial: boolean, defaultAppointmentStartTime?: any | null, defaultAppointmentEndTime?: any | null, defaultStartNow: boolean, defaultInboundStopType?: StopType | null, defaultOutboundStopType?: StopType | null, defaultPickupPadding?: any | null, defaultDeliveryPadding?: any | null, defaultTotalDuration?: any | null, defaultIsLineHaul: boolean, defaultFulfillmentType?: FulfillmentType | null, isActive: boolean, isExposedToCustomers: boolean, serviceAvailabilityDates: Array<{ __typename?: 'ServiceAvailabilityDateEntity', id: string, dayCategory: SpecialDayOfWeek, enabled: boolean, start: { __typename?: 'PlainTime', hour: number, minute: number }, end: { __typename?: 'PlainTime', hour: number, minute: number } }> } | null, zones: Array<{ __typename?: 'TariffZoneEntity', uuid: string, name: string }>, chargeGroups: Array<{ __typename?: 'SpecialAccessorialChargeGroupEntity', uuid: string, dayOfWeek: SpecialDayOfWeek, startTime: any, endTime: any }>, matrixItems: Array<{ __typename?: 'SpecialAccessorialMatrixItemEntity', zoneUuid: string, chargeGroupUuid: string, uuid: string, rate: number }>, matchingGlobalAccessorial?: { __typename?: 'SkidBasedAccessorialEntity', uuid: string } | { __typename?: 'SpecialAccessorialEntity', uuid: string } | { __typename?: 'StandardAccessorialEntity', uuid: string } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string } | null, matchingCustomerAccessorials?: Array<{ __typename?: 'SkidBasedAccessorialEntity', uuid: string } | { __typename?: 'SpecialAccessorialEntity', uuid: string } | { __typename?: 'StandardAccessorialEntity', uuid: string } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string }> | null, terminal?: { __typename?: 'TerminalEntity', uuid: string, name: string, code: string } | null, fuelProfile?: { __typename?: 'FuelProfileEntity', uuid: string, name?: string | null, startDate?: any | null, expirationDate?: any | null, billingType: FuelBillingMethod, type: FuelProfileType, company: { __typename?: 'CompanyEntity', uuid: string }, contacts?: Array<{ __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string }> | null, fuelProfileDateRanges: Array<{ __typename?: 'FuelProfileDateRangeEntity', uuid: string, startDate: any, expirationDate: any, surchargeRate?: number | null, flatRateUsdCents?: number | null }> } | null, tariffZoneGroup?: { __typename?: 'TariffZoneGroupEntity', id: string } | null, generalLedgerCode?: { __typename?: 'GeneralLedgerCodeEntity', id: string, code: string } | null };

type AllAccessorialFields_StandardAccessorialEntity_Fragment = { __typename: 'StandardAccessorialEntity', isArchived?: boolean | null, isAuthoCodeRequired: boolean, isDefaultGlobalSpecial: boolean, invoiceDisplayName?: string | null, quickbooksDesktopAccessorialId?: string | null, uuid: string, quickbooksFileMappingChargeName?: string | null, quickbooksMappingId: string, percentForSettlement?: number | null, name: string, code?: string | null, ediCode?: string | null, rate: number, contact?: { __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string } | null, matchingGlobalAccessorial?: { __typename?: 'SkidBasedAccessorialEntity', uuid: string } | { __typename?: 'SpecialAccessorialEntity', uuid: string } | { __typename?: 'StandardAccessorialEntity', uuid: string } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string } | null, matchingCustomerAccessorials?: Array<{ __typename?: 'SkidBasedAccessorialEntity', uuid: string } | { __typename?: 'SpecialAccessorialEntity', uuid: string } | { __typename?: 'StandardAccessorialEntity', uuid: string } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string }> | null, terminal?: { __typename?: 'TerminalEntity', uuid: string, name: string, code: string } | null, fuelProfile?: { __typename?: 'FuelProfileEntity', uuid: string, name?: string | null, startDate?: any | null, expirationDate?: any | null, billingType: FuelBillingMethod, type: FuelProfileType, company: { __typename?: 'CompanyEntity', uuid: string }, contacts?: Array<{ __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string }> | null, fuelProfileDateRanges: Array<{ __typename?: 'FuelProfileDateRangeEntity', uuid: string, startDate: any, expirationDate: any, surchargeRate?: number | null, flatRateUsdCents?: number | null }> } | null, generalLedgerCode?: { __typename?: 'GeneralLedgerCodeEntity', id: string, code: string } | null };

type AllAccessorialFields_UnitBasedAccessorialEntity_Fragment = { __typename: 'UnitBasedAccessorialEntity', isArchived?: boolean | null, isAuthoCodeRequired: boolean, isDefaultGlobalSpecial: boolean, invoiceDisplayName?: string | null, quickbooksDesktopAccessorialId?: string | null, uuid: string, quickbooksFileMappingChargeName?: string | null, quickbooksMappingId: string, percentForSettlement?: number | null, name: string, code?: string | null, ediCode?: string | null, ratePerUnit: number, maximumCharge?: number | null, minimumCharge?: number | null, contact?: { __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string } | null, matchingGlobalAccessorial?: { __typename?: 'SkidBasedAccessorialEntity', uuid: string } | { __typename?: 'SpecialAccessorialEntity', uuid: string } | { __typename?: 'StandardAccessorialEntity', uuid: string } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string } | null, matchingCustomerAccessorials?: Array<{ __typename?: 'SkidBasedAccessorialEntity', uuid: string } | { __typename?: 'SpecialAccessorialEntity', uuid: string } | { __typename?: 'StandardAccessorialEntity', uuid: string } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string }> | null, terminal?: { __typename?: 'TerminalEntity', uuid: string, name: string, code: string } | null, fuelProfile?: { __typename?: 'FuelProfileEntity', uuid: string, name?: string | null, startDate?: any | null, expirationDate?: any | null, billingType: FuelBillingMethod, type: FuelProfileType, company: { __typename?: 'CompanyEntity', uuid: string }, contacts?: Array<{ __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string }> | null, fuelProfileDateRanges: Array<{ __typename?: 'FuelProfileDateRangeEntity', uuid: string, startDate: any, expirationDate: any, surchargeRate?: number | null, flatRateUsdCents?: number | null }> } | null, generalLedgerCode?: { __typename?: 'GeneralLedgerCodeEntity', id: string, code: string } | null };

type AllAccessorialFields_WaitTimeAccessorialEntity_Fragment = { __typename: 'WaitTimeAccessorialEntity', isArchived?: boolean | null, isAuthoCodeRequired: boolean, isDefaultGlobalSpecial: boolean, invoiceDisplayName?: string | null, quickbooksDesktopAccessorialId?: string | null, uuid: string, quickbooksFileMappingChargeName?: string | null, quickbooksMappingId: string, percentForSettlement?: number | null, name: string, code?: string | null, ediCode?: string | null, rate: number, maximumCharge?: number | null, minimumCharge?: number | null, waitTimeChargePeriod?: number | null, waitTimeFreeMinutes?: number | null, contact?: { __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string } | null, matchingGlobalAccessorial?: { __typename?: 'SkidBasedAccessorialEntity', uuid: string } | { __typename?: 'SpecialAccessorialEntity', uuid: string } | { __typename?: 'StandardAccessorialEntity', uuid: string } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string } | null, matchingCustomerAccessorials?: Array<{ __typename?: 'SkidBasedAccessorialEntity', uuid: string } | { __typename?: 'SpecialAccessorialEntity', uuid: string } | { __typename?: 'StandardAccessorialEntity', uuid: string } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string }> | null, terminal?: { __typename?: 'TerminalEntity', uuid: string, name: string, code: string } | null, fuelProfile?: { __typename?: 'FuelProfileEntity', uuid: string, name?: string | null, startDate?: any | null, expirationDate?: any | null, billingType: FuelBillingMethod, type: FuelProfileType, company: { __typename?: 'CompanyEntity', uuid: string }, contacts?: Array<{ __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string }> | null, fuelProfileDateRanges: Array<{ __typename?: 'FuelProfileDateRangeEntity', uuid: string, startDate: any, expirationDate: any, surchargeRate?: number | null, flatRateUsdCents?: number | null }> } | null, generalLedgerCode?: { __typename?: 'GeneralLedgerCodeEntity', id: string, code: string } | null };

type AllAccessorialFields_WeightBasedAccessorialEntity_Fragment = { __typename: 'WeightBasedAccessorialEntity', isArchived?: boolean | null, isAuthoCodeRequired: boolean, isDefaultGlobalSpecial: boolean, invoiceDisplayName?: string | null, quickbooksDesktopAccessorialId?: string | null, uuid: string, quickbooksFileMappingChargeName?: string | null, quickbooksMappingId: string, percentForSettlement?: number | null, name: string, code?: string | null, ediCode?: string | null, ratePerHundredWeight: number, maximumCharge?: number | null, minimumCharge?: number | null, contact?: { __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string } | null, accessorialRanges?: Array<{ __typename?: 'AccessorialRangeEntity', uuid: string, lessThanOrEqualToValue: number, rateUsdCents: number }> | null, matchingGlobalAccessorial?: { __typename?: 'SkidBasedAccessorialEntity', uuid: string } | { __typename?: 'SpecialAccessorialEntity', uuid: string } | { __typename?: 'StandardAccessorialEntity', uuid: string } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string } | null, matchingCustomerAccessorials?: Array<{ __typename?: 'SkidBasedAccessorialEntity', uuid: string } | { __typename?: 'SpecialAccessorialEntity', uuid: string } | { __typename?: 'StandardAccessorialEntity', uuid: string } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string }> | null, terminal?: { __typename?: 'TerminalEntity', uuid: string, name: string, code: string } | null, fuelProfile?: { __typename?: 'FuelProfileEntity', uuid: string, name?: string | null, startDate?: any | null, expirationDate?: any | null, billingType: FuelBillingMethod, type: FuelProfileType, company: { __typename?: 'CompanyEntity', uuid: string }, contacts?: Array<{ __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string }> | null, fuelProfileDateRanges: Array<{ __typename?: 'FuelProfileDateRangeEntity', uuid: string, startDate: any, expirationDate: any, surchargeRate?: number | null, flatRateUsdCents?: number | null }> } | null, generalLedgerCode?: { __typename?: 'GeneralLedgerCodeEntity', code: string, id: string } | null };

type AllAccessorialFields_ZoneBasedAccessorialEntity_Fragment = { __typename: 'ZoneBasedAccessorialEntity', isArchived?: boolean | null, isAuthoCodeRequired: boolean, isDefaultGlobalSpecial: boolean, invoiceDisplayName?: string | null, quickbooksDesktopAccessorialId?: string | null, uuid: string, quickbooksFileMappingChargeName?: string | null, quickbooksMappingId: string, percentForSettlement?: number | null, name: string, code?: string | null, ediCode?: string | null, contact?: { __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string } | null, zones: Array<{ __typename?: 'ZoneBasedAccessorialZoneEntity', uuid: string, name: string }>, chargeGroups: Array<{ __typename?: 'ZoneBasedAccessorialChargeGroupEntity', uuid: string, name: string }>, matrixItems: Array<{ __typename?: 'ZoneBasedAccessorialMatrixItemEntity', zoneUuid: string, chargeGroupUuid: string, uuid: string, rate: number }>, matchingGlobalAccessorial?: { __typename?: 'SkidBasedAccessorialEntity', uuid: string } | { __typename?: 'SpecialAccessorialEntity', uuid: string } | { __typename?: 'StandardAccessorialEntity', uuid: string } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string } | null, matchingCustomerAccessorials?: Array<{ __typename?: 'SkidBasedAccessorialEntity', uuid: string } | { __typename?: 'SpecialAccessorialEntity', uuid: string } | { __typename?: 'StandardAccessorialEntity', uuid: string } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string }> | null, terminal?: { __typename?: 'TerminalEntity', uuid: string, name: string, code: string } | null, fuelProfile?: { __typename?: 'FuelProfileEntity', uuid: string, name?: string | null, startDate?: any | null, expirationDate?: any | null, billingType: FuelBillingMethod, type: FuelProfileType, company: { __typename?: 'CompanyEntity', uuid: string }, contacts?: Array<{ __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string }> | null, fuelProfileDateRanges: Array<{ __typename?: 'FuelProfileDateRangeEntity', uuid: string, startDate: any, expirationDate: any, surchargeRate?: number | null, flatRateUsdCents?: number | null }> } | null, generalLedgerCode?: { __typename?: 'GeneralLedgerCodeEntity', id: string, code: string } | null };

export type AllAccessorialFieldsFragment = AllAccessorialFields_SkidBasedAccessorialEntity_Fragment | AllAccessorialFields_SpecialAccessorialEntity_Fragment | AllAccessorialFields_StandardAccessorialEntity_Fragment | AllAccessorialFields_UnitBasedAccessorialEntity_Fragment | AllAccessorialFields_WaitTimeAccessorialEntity_Fragment | AllAccessorialFields_WeightBasedAccessorialEntity_Fragment | AllAccessorialFields_ZoneBasedAccessorialEntity_Fragment;

export type DefaultGlobalSpecialAccessorialsQueryVariables = Exact<{ [key: string]: never; }>;


export type DefaultGlobalSpecialAccessorialsQuery = { __typename?: 'Query', defaultGlobalSpecialAccessorials: Array<{ __typename?: 'SkidBasedAccessorialEntity' } | { __typename: 'SpecialAccessorialEntity', uuid: string, name: string } | { __typename?: 'StandardAccessorialEntity' } | { __typename?: 'UnitBasedAccessorialEntity' } | { __typename?: 'WaitTimeAccessorialEntity' } | { __typename?: 'WeightBasedAccessorialEntity' } | { __typename?: 'ZoneBasedAccessorialEntity' }> };

export type AccessorialNamesQueryVariables = Exact<{
  onlyShowCompanyAccessorials?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type AccessorialNamesQuery = { __typename?: 'Query', accessorials: Array<{ __typename: 'SkidBasedAccessorialEntity', name: string, uuid: string } | { __typename: 'SpecialAccessorialEntity', name: string, uuid: string } | { __typename: 'StandardAccessorialEntity', name: string, uuid: string } | { __typename: 'UnitBasedAccessorialEntity', name: string, uuid: string } | { __typename: 'WaitTimeAccessorialEntity', name: string, uuid: string } | { __typename: 'WeightBasedAccessorialEntity', name: string, uuid: string } | { __typename: 'ZoneBasedAccessorialEntity', name: string, uuid: string }> };

type AccessorialsTableRow_SkidBasedAccessorialEntity_Fragment = { __typename: 'SkidBasedAccessorialEntity', uuid: string, isArchived?: boolean | null, name: string, enableQuickAdd: boolean, ratePerSkid: number, contact?: { __typename?: 'CustomerContactEntity', uuid: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string } | null, terminal?: { __typename?: 'TerminalEntity', uuid: string, name: string, code: string } | null, generalLedgerCode?: { __typename?: 'GeneralLedgerCodeEntity', code: string, description: string } | null };

type AccessorialsTableRow_SpecialAccessorialEntity_Fragment = { __typename: 'SpecialAccessorialEntity', uuid: string, isArchived?: boolean | null, name: string, enableQuickAdd: boolean, contact?: { __typename?: 'CustomerContactEntity', uuid: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string } | null, terminal?: { __typename?: 'TerminalEntity', uuid: string, name: string, code: string } | null, generalLedgerCode?: { __typename?: 'GeneralLedgerCodeEntity', code: string, description: string } | null };

type AccessorialsTableRow_StandardAccessorialEntity_Fragment = { __typename: 'StandardAccessorialEntity', uuid: string, isArchived?: boolean | null, name: string, enableQuickAdd: boolean, rate: number, contact?: { __typename?: 'CustomerContactEntity', uuid: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string } | null, terminal?: { __typename?: 'TerminalEntity', uuid: string, name: string, code: string } | null, generalLedgerCode?: { __typename?: 'GeneralLedgerCodeEntity', code: string, description: string } | null };

type AccessorialsTableRow_UnitBasedAccessorialEntity_Fragment = { __typename: 'UnitBasedAccessorialEntity', uuid: string, isArchived?: boolean | null, name: string, enableQuickAdd: boolean, ratePerUnit: number, contact?: { __typename?: 'CustomerContactEntity', uuid: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string } | null, terminal?: { __typename?: 'TerminalEntity', uuid: string, name: string, code: string } | null, generalLedgerCode?: { __typename?: 'GeneralLedgerCodeEntity', code: string, description: string } | null };

type AccessorialsTableRow_WaitTimeAccessorialEntity_Fragment = { __typename: 'WaitTimeAccessorialEntity', uuid: string, isArchived?: boolean | null, name: string, enableQuickAdd: boolean, rate: number, waitTimeChargePeriod?: number | null, contact?: { __typename?: 'CustomerContactEntity', uuid: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string } | null, terminal?: { __typename?: 'TerminalEntity', uuid: string, name: string, code: string } | null, generalLedgerCode?: { __typename?: 'GeneralLedgerCodeEntity', code: string, description: string } | null };

type AccessorialsTableRow_WeightBasedAccessorialEntity_Fragment = { __typename: 'WeightBasedAccessorialEntity', uuid: string, isArchived?: boolean | null, name: string, enableQuickAdd: boolean, ratePerHundredWeight: number, contact?: { __typename?: 'CustomerContactEntity', uuid: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string } | null, terminal?: { __typename?: 'TerminalEntity', uuid: string, name: string, code: string } | null, generalLedgerCode?: { __typename?: 'GeneralLedgerCodeEntity', code: string, description: string } | null };

type AccessorialsTableRow_ZoneBasedAccessorialEntity_Fragment = { __typename: 'ZoneBasedAccessorialEntity', uuid: string, isArchived?: boolean | null, name: string, enableQuickAdd: boolean, contact?: { __typename?: 'CustomerContactEntity', uuid: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string } | null, zones: Array<{ __typename?: 'ZoneBasedAccessorialZoneEntity', uuid: string }>, terminal?: { __typename?: 'TerminalEntity', uuid: string, name: string, code: string } | null, generalLedgerCode?: { __typename?: 'GeneralLedgerCodeEntity', code: string, description: string } | null };

export type AccessorialsTableRowFragment = AccessorialsTableRow_SkidBasedAccessorialEntity_Fragment | AccessorialsTableRow_SpecialAccessorialEntity_Fragment | AccessorialsTableRow_StandardAccessorialEntity_Fragment | AccessorialsTableRow_UnitBasedAccessorialEntity_Fragment | AccessorialsTableRow_WaitTimeAccessorialEntity_Fragment | AccessorialsTableRow_WeightBasedAccessorialEntity_Fragment | AccessorialsTableRow_ZoneBasedAccessorialEntity_Fragment;

export type AccessorialsTableQueryVariables = Exact<{
  contactUuid?: InputMaybe<Scalars['String']['input']>;
  onlyShowCompanyAccessorials?: InputMaybe<Scalars['Boolean']['input']>;
  includeArchived?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type AccessorialsTableQuery = { __typename?: 'Query', accessorials: Array<{ __typename: 'SkidBasedAccessorialEntity', uuid: string, isArchived?: boolean | null, name: string, enableQuickAdd: boolean, ratePerSkid: number, contact?: { __typename?: 'CustomerContactEntity', uuid: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string } | null, terminal?: { __typename?: 'TerminalEntity', uuid: string, name: string, code: string } | null, generalLedgerCode?: { __typename?: 'GeneralLedgerCodeEntity', code: string, description: string } | null } | { __typename: 'SpecialAccessorialEntity', uuid: string, isArchived?: boolean | null, name: string, enableQuickAdd: boolean, contact?: { __typename?: 'CustomerContactEntity', uuid: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string } | null, terminal?: { __typename?: 'TerminalEntity', uuid: string, name: string, code: string } | null, generalLedgerCode?: { __typename?: 'GeneralLedgerCodeEntity', code: string, description: string } | null } | { __typename: 'StandardAccessorialEntity', uuid: string, isArchived?: boolean | null, name: string, enableQuickAdd: boolean, rate: number, contact?: { __typename?: 'CustomerContactEntity', uuid: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string } | null, terminal?: { __typename?: 'TerminalEntity', uuid: string, name: string, code: string } | null, generalLedgerCode?: { __typename?: 'GeneralLedgerCodeEntity', code: string, description: string } | null } | { __typename: 'UnitBasedAccessorialEntity', uuid: string, isArchived?: boolean | null, name: string, enableQuickAdd: boolean, ratePerUnit: number, contact?: { __typename?: 'CustomerContactEntity', uuid: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string } | null, terminal?: { __typename?: 'TerminalEntity', uuid: string, name: string, code: string } | null, generalLedgerCode?: { __typename?: 'GeneralLedgerCodeEntity', code: string, description: string } | null } | { __typename: 'WaitTimeAccessorialEntity', uuid: string, isArchived?: boolean | null, name: string, enableQuickAdd: boolean, rate: number, waitTimeChargePeriod?: number | null, contact?: { __typename?: 'CustomerContactEntity', uuid: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string } | null, terminal?: { __typename?: 'TerminalEntity', uuid: string, name: string, code: string } | null, generalLedgerCode?: { __typename?: 'GeneralLedgerCodeEntity', code: string, description: string } | null } | { __typename: 'WeightBasedAccessorialEntity', uuid: string, isArchived?: boolean | null, name: string, enableQuickAdd: boolean, ratePerHundredWeight: number, contact?: { __typename?: 'CustomerContactEntity', uuid: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string } | null, terminal?: { __typename?: 'TerminalEntity', uuid: string, name: string, code: string } | null, generalLedgerCode?: { __typename?: 'GeneralLedgerCodeEntity', code: string, description: string } | null } | { __typename: 'ZoneBasedAccessorialEntity', uuid: string, isArchived?: boolean | null, name: string, enableQuickAdd: boolean, contact?: { __typename?: 'CustomerContactEntity', uuid: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string } | null, zones: Array<{ __typename?: 'ZoneBasedAccessorialZoneEntity', uuid: string }>, terminal?: { __typename?: 'TerminalEntity', uuid: string, name: string, code: string } | null, generalLedgerCode?: { __typename?: 'GeneralLedgerCodeEntity', code: string, description: string } | null }> };

export type AccessorialsQueryVariables = Exact<{
  contactUuid?: InputMaybe<Scalars['String']['input']>;
  onlyShowCompanyAccessorials?: InputMaybe<Scalars['Boolean']['input']>;
  includeArchived?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type AccessorialsQuery = { __typename?: 'Query', accessorials: Array<{ __typename: 'SkidBasedAccessorialEntity', isArchived?: boolean | null, isAuthoCodeRequired: boolean, isDefaultGlobalSpecial: boolean, invoiceDisplayName?: string | null, quickbooksDesktopAccessorialId?: string | null, uuid: string, quickbooksFileMappingChargeName?: string | null, quickbooksMappingId: string, percentForSettlement?: number | null, name: string, code?: string | null, ediCode?: string | null, ratePerSkid: number, maximumCharge?: number | null, minimumCharge?: number | null, contact?: { __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string } | null, matchingGlobalAccessorial?: { __typename?: 'SkidBasedAccessorialEntity', uuid: string } | { __typename?: 'SpecialAccessorialEntity', uuid: string } | { __typename?: 'StandardAccessorialEntity', uuid: string } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string } | null, matchingCustomerAccessorials?: Array<{ __typename?: 'SkidBasedAccessorialEntity', uuid: string } | { __typename?: 'SpecialAccessorialEntity', uuid: string } | { __typename?: 'StandardAccessorialEntity', uuid: string } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string }> | null, terminal?: { __typename?: 'TerminalEntity', uuid: string, name: string, code: string } | null, fuelProfile?: { __typename?: 'FuelProfileEntity', uuid: string, name?: string | null, startDate?: any | null, expirationDate?: any | null, billingType: FuelBillingMethod, type: FuelProfileType, company: { __typename?: 'CompanyEntity', uuid: string }, contacts?: Array<{ __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string }> | null, fuelProfileDateRanges: Array<{ __typename?: 'FuelProfileDateRangeEntity', uuid: string, startDate: any, expirationDate: any, surchargeRate?: number | null, flatRateUsdCents?: number | null }> } | null, generalLedgerCode?: { __typename?: 'GeneralLedgerCodeEntity', id: string, code: string } | null } | { __typename: 'SpecialAccessorialEntity', isArchived?: boolean | null, isAuthoCodeRequired: boolean, isDefaultGlobalSpecial: boolean, specialAccessorialType?: SpecialAccessorialType | null, invoiceDisplayName?: string | null, uuid: string, quickbooksDesktopAccessorialId?: string | null, quickbooksFileMappingChargeName?: string | null, quickbooksMappingId: string, percentForSettlement?: number | null, name: string, code?: string | null, ediCode?: string | null, contact?: { __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string } | null, serviceLevel?: { __typename?: 'ServiceEntity', uuid: string, name: string, createdAt: any, updatedAt: any, timeInMinutes?: number | null, useApptInRouteOptimization: boolean, markOrdersAsSpecial: boolean, defaultAppointmentStartTime?: any | null, defaultAppointmentEndTime?: any | null, defaultStartNow: boolean, defaultInboundStopType?: StopType | null, defaultOutboundStopType?: StopType | null, defaultPickupPadding?: any | null, defaultDeliveryPadding?: any | null, defaultTotalDuration?: any | null, defaultIsLineHaul: boolean, defaultFulfillmentType?: FulfillmentType | null, isActive: boolean, isExposedToCustomers: boolean, serviceAvailabilityDates: Array<{ __typename?: 'ServiceAvailabilityDateEntity', id: string, dayCategory: SpecialDayOfWeek, enabled: boolean, start: { __typename?: 'PlainTime', hour: number, minute: number }, end: { __typename?: 'PlainTime', hour: number, minute: number } }> } | null, zones: Array<{ __typename?: 'TariffZoneEntity', uuid: string, name: string }>, chargeGroups: Array<{ __typename?: 'SpecialAccessorialChargeGroupEntity', uuid: string, dayOfWeek: SpecialDayOfWeek, startTime: any, endTime: any }>, matrixItems: Array<{ __typename?: 'SpecialAccessorialMatrixItemEntity', zoneUuid: string, chargeGroupUuid: string, uuid: string, rate: number }>, matchingGlobalAccessorial?: { __typename?: 'SkidBasedAccessorialEntity', uuid: string } | { __typename?: 'SpecialAccessorialEntity', uuid: string } | { __typename?: 'StandardAccessorialEntity', uuid: string } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string } | null, matchingCustomerAccessorials?: Array<{ __typename?: 'SkidBasedAccessorialEntity', uuid: string } | { __typename?: 'SpecialAccessorialEntity', uuid: string } | { __typename?: 'StandardAccessorialEntity', uuid: string } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string }> | null, terminal?: { __typename?: 'TerminalEntity', uuid: string, name: string, code: string } | null, fuelProfile?: { __typename?: 'FuelProfileEntity', uuid: string, name?: string | null, startDate?: any | null, expirationDate?: any | null, billingType: FuelBillingMethod, type: FuelProfileType, company: { __typename?: 'CompanyEntity', uuid: string }, contacts?: Array<{ __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string }> | null, fuelProfileDateRanges: Array<{ __typename?: 'FuelProfileDateRangeEntity', uuid: string, startDate: any, expirationDate: any, surchargeRate?: number | null, flatRateUsdCents?: number | null }> } | null, tariffZoneGroup?: { __typename?: 'TariffZoneGroupEntity', id: string } | null, generalLedgerCode?: { __typename?: 'GeneralLedgerCodeEntity', id: string, code: string } | null } | { __typename: 'StandardAccessorialEntity', isArchived?: boolean | null, isAuthoCodeRequired: boolean, isDefaultGlobalSpecial: boolean, invoiceDisplayName?: string | null, quickbooksDesktopAccessorialId?: string | null, uuid: string, quickbooksFileMappingChargeName?: string | null, quickbooksMappingId: string, percentForSettlement?: number | null, name: string, code?: string | null, ediCode?: string | null, rate: number, contact?: { __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string } | null, matchingGlobalAccessorial?: { __typename?: 'SkidBasedAccessorialEntity', uuid: string } | { __typename?: 'SpecialAccessorialEntity', uuid: string } | { __typename?: 'StandardAccessorialEntity', uuid: string } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string } | null, matchingCustomerAccessorials?: Array<{ __typename?: 'SkidBasedAccessorialEntity', uuid: string } | { __typename?: 'SpecialAccessorialEntity', uuid: string } | { __typename?: 'StandardAccessorialEntity', uuid: string } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string }> | null, terminal?: { __typename?: 'TerminalEntity', uuid: string, name: string, code: string } | null, fuelProfile?: { __typename?: 'FuelProfileEntity', uuid: string, name?: string | null, startDate?: any | null, expirationDate?: any | null, billingType: FuelBillingMethod, type: FuelProfileType, company: { __typename?: 'CompanyEntity', uuid: string }, contacts?: Array<{ __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string }> | null, fuelProfileDateRanges: Array<{ __typename?: 'FuelProfileDateRangeEntity', uuid: string, startDate: any, expirationDate: any, surchargeRate?: number | null, flatRateUsdCents?: number | null }> } | null, generalLedgerCode?: { __typename?: 'GeneralLedgerCodeEntity', id: string, code: string } | null } | { __typename: 'UnitBasedAccessorialEntity', isArchived?: boolean | null, isAuthoCodeRequired: boolean, isDefaultGlobalSpecial: boolean, invoiceDisplayName?: string | null, quickbooksDesktopAccessorialId?: string | null, uuid: string, quickbooksFileMappingChargeName?: string | null, quickbooksMappingId: string, percentForSettlement?: number | null, name: string, code?: string | null, ediCode?: string | null, ratePerUnit: number, maximumCharge?: number | null, minimumCharge?: number | null, contact?: { __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string } | null, matchingGlobalAccessorial?: { __typename?: 'SkidBasedAccessorialEntity', uuid: string } | { __typename?: 'SpecialAccessorialEntity', uuid: string } | { __typename?: 'StandardAccessorialEntity', uuid: string } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string } | null, matchingCustomerAccessorials?: Array<{ __typename?: 'SkidBasedAccessorialEntity', uuid: string } | { __typename?: 'SpecialAccessorialEntity', uuid: string } | { __typename?: 'StandardAccessorialEntity', uuid: string } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string }> | null, terminal?: { __typename?: 'TerminalEntity', uuid: string, name: string, code: string } | null, fuelProfile?: { __typename?: 'FuelProfileEntity', uuid: string, name?: string | null, startDate?: any | null, expirationDate?: any | null, billingType: FuelBillingMethod, type: FuelProfileType, company: { __typename?: 'CompanyEntity', uuid: string }, contacts?: Array<{ __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string }> | null, fuelProfileDateRanges: Array<{ __typename?: 'FuelProfileDateRangeEntity', uuid: string, startDate: any, expirationDate: any, surchargeRate?: number | null, flatRateUsdCents?: number | null }> } | null, generalLedgerCode?: { __typename?: 'GeneralLedgerCodeEntity', id: string, code: string } | null } | { __typename: 'WaitTimeAccessorialEntity', isArchived?: boolean | null, isAuthoCodeRequired: boolean, isDefaultGlobalSpecial: boolean, invoiceDisplayName?: string | null, quickbooksDesktopAccessorialId?: string | null, uuid: string, quickbooksFileMappingChargeName?: string | null, quickbooksMappingId: string, percentForSettlement?: number | null, name: string, code?: string | null, ediCode?: string | null, rate: number, maximumCharge?: number | null, minimumCharge?: number | null, waitTimeChargePeriod?: number | null, waitTimeFreeMinutes?: number | null, contact?: { __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string } | null, matchingGlobalAccessorial?: { __typename?: 'SkidBasedAccessorialEntity', uuid: string } | { __typename?: 'SpecialAccessorialEntity', uuid: string } | { __typename?: 'StandardAccessorialEntity', uuid: string } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string } | null, matchingCustomerAccessorials?: Array<{ __typename?: 'SkidBasedAccessorialEntity', uuid: string } | { __typename?: 'SpecialAccessorialEntity', uuid: string } | { __typename?: 'StandardAccessorialEntity', uuid: string } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string }> | null, terminal?: { __typename?: 'TerminalEntity', uuid: string, name: string, code: string } | null, fuelProfile?: { __typename?: 'FuelProfileEntity', uuid: string, name?: string | null, startDate?: any | null, expirationDate?: any | null, billingType: FuelBillingMethod, type: FuelProfileType, company: { __typename?: 'CompanyEntity', uuid: string }, contacts?: Array<{ __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string }> | null, fuelProfileDateRanges: Array<{ __typename?: 'FuelProfileDateRangeEntity', uuid: string, startDate: any, expirationDate: any, surchargeRate?: number | null, flatRateUsdCents?: number | null }> } | null, generalLedgerCode?: { __typename?: 'GeneralLedgerCodeEntity', id: string, code: string } | null } | { __typename: 'WeightBasedAccessorialEntity', isArchived?: boolean | null, isAuthoCodeRequired: boolean, isDefaultGlobalSpecial: boolean, invoiceDisplayName?: string | null, quickbooksDesktopAccessorialId?: string | null, uuid: string, quickbooksFileMappingChargeName?: string | null, quickbooksMappingId: string, percentForSettlement?: number | null, name: string, code?: string | null, ediCode?: string | null, ratePerHundredWeight: number, maximumCharge?: number | null, minimumCharge?: number | null, contact?: { __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string } | null, accessorialRanges?: Array<{ __typename?: 'AccessorialRangeEntity', uuid: string, lessThanOrEqualToValue: number, rateUsdCents: number }> | null, matchingGlobalAccessorial?: { __typename?: 'SkidBasedAccessorialEntity', uuid: string } | { __typename?: 'SpecialAccessorialEntity', uuid: string } | { __typename?: 'StandardAccessorialEntity', uuid: string } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string } | null, matchingCustomerAccessorials?: Array<{ __typename?: 'SkidBasedAccessorialEntity', uuid: string } | { __typename?: 'SpecialAccessorialEntity', uuid: string } | { __typename?: 'StandardAccessorialEntity', uuid: string } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string }> | null, terminal?: { __typename?: 'TerminalEntity', uuid: string, name: string, code: string } | null, fuelProfile?: { __typename?: 'FuelProfileEntity', uuid: string, name?: string | null, startDate?: any | null, expirationDate?: any | null, billingType: FuelBillingMethod, type: FuelProfileType, company: { __typename?: 'CompanyEntity', uuid: string }, contacts?: Array<{ __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string }> | null, fuelProfileDateRanges: Array<{ __typename?: 'FuelProfileDateRangeEntity', uuid: string, startDate: any, expirationDate: any, surchargeRate?: number | null, flatRateUsdCents?: number | null }> } | null, generalLedgerCode?: { __typename?: 'GeneralLedgerCodeEntity', code: string, id: string } | null } | { __typename: 'ZoneBasedAccessorialEntity', isArchived?: boolean | null, isAuthoCodeRequired: boolean, isDefaultGlobalSpecial: boolean, invoiceDisplayName?: string | null, quickbooksDesktopAccessorialId?: string | null, uuid: string, quickbooksFileMappingChargeName?: string | null, quickbooksMappingId: string, percentForSettlement?: number | null, name: string, code?: string | null, ediCode?: string | null, contact?: { __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string } | null, zones: Array<{ __typename?: 'ZoneBasedAccessorialZoneEntity', uuid: string, name: string }>, chargeGroups: Array<{ __typename?: 'ZoneBasedAccessorialChargeGroupEntity', uuid: string, name: string }>, matrixItems: Array<{ __typename?: 'ZoneBasedAccessorialMatrixItemEntity', zoneUuid: string, chargeGroupUuid: string, uuid: string, rate: number }>, matchingGlobalAccessorial?: { __typename?: 'SkidBasedAccessorialEntity', uuid: string } | { __typename?: 'SpecialAccessorialEntity', uuid: string } | { __typename?: 'StandardAccessorialEntity', uuid: string } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string } | null, matchingCustomerAccessorials?: Array<{ __typename?: 'SkidBasedAccessorialEntity', uuid: string } | { __typename?: 'SpecialAccessorialEntity', uuid: string } | { __typename?: 'StandardAccessorialEntity', uuid: string } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string }> | null, terminal?: { __typename?: 'TerminalEntity', uuid: string, name: string, code: string } | null, fuelProfile?: { __typename?: 'FuelProfileEntity', uuid: string, name?: string | null, startDate?: any | null, expirationDate?: any | null, billingType: FuelBillingMethod, type: FuelProfileType, company: { __typename?: 'CompanyEntity', uuid: string }, contacts?: Array<{ __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string }> | null, fuelProfileDateRanges: Array<{ __typename?: 'FuelProfileDateRangeEntity', uuid: string, startDate: any, expirationDate: any, surchargeRate?: number | null, flatRateUsdCents?: number | null }> } | null, generalLedgerCode?: { __typename?: 'GeneralLedgerCodeEntity', id: string, code: string } | null }> };

export type RemoveSpecialAccessorialMutationVariables = Exact<{
  input: Scalars['String']['input'];
}>;


export type RemoveSpecialAccessorialMutation = { __typename?: 'Mutation', removeSpecialAccessorial: { __typename?: 'SkidBasedAccessorialEntity' } | { __typename?: 'SpecialAccessorialEntity', uuid: string } | { __typename?: 'StandardAccessorialEntity' } | { __typename?: 'UnitBasedAccessorialEntity' } | { __typename?: 'WaitTimeAccessorialEntity' } | { __typename?: 'WeightBasedAccessorialEntity' } | { __typename?: 'ZoneBasedAccessorialEntity' } };

export type RemoveZoneBasedAccessorialMutationVariables = Exact<{
  input: Scalars['String']['input'];
}>;


export type RemoveZoneBasedAccessorialMutation = { __typename?: 'Mutation', removeZoneBasedAccessorial: { __typename?: 'SkidBasedAccessorialEntity' } | { __typename?: 'SpecialAccessorialEntity' } | { __typename?: 'StandardAccessorialEntity' } | { __typename?: 'UnitBasedAccessorialEntity' } | { __typename?: 'WaitTimeAccessorialEntity' } | { __typename?: 'WeightBasedAccessorialEntity' } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string } };

export type UpdateAccessorialMutationVariables = Exact<{
  input: UpdateAccessorialInput;
}>;


export type UpdateAccessorialMutation = { __typename?: 'Mutation', updateAccessorial: { __typename?: 'SkidBasedAccessorialEntity', uuid: string } | { __typename?: 'SpecialAccessorialEntity', uuid: string } | { __typename?: 'StandardAccessorialEntity', uuid: string } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string } };

export type UpdateQuickAddAccessorialsMutationVariables = Exact<{
  input: UpdateQuickAddAccessorialsInput;
}>;


export type UpdateQuickAddAccessorialsMutation = { __typename?: 'Mutation', updateQuickAddAccessorials: { __typename?: 'UpdateQuickAddAccessorialsOutput', quickAddAccessorials: Array<{ __typename: 'SkidBasedAccessorialEntity', name: string, uuid: string } | { __typename: 'SpecialAccessorialEntity', name: string, uuid: string } | { __typename: 'StandardAccessorialEntity', name: string, uuid: string } | { __typename: 'UnitBasedAccessorialEntity', name: string, uuid: string } | { __typename: 'WaitTimeAccessorialEntity', name: string, uuid: string } | { __typename: 'WeightBasedAccessorialEntity', name: string, uuid: string } | { __typename: 'ZoneBasedAccessorialEntity', name: string, uuid: string }> } };

export type SenderIsVerifiedQueryVariables = Exact<{ [key: string]: never; }>;


export type SenderIsVerifiedQuery = { __typename?: 'Query', senderIsVerified?: string | null };

export type CreateCreditTypeMutationVariables = Exact<{
  creditTypeCreateInput: CreditTypeCreateInput;
}>;


export type CreateCreditTypeMutation = { __typename?: 'Mutation', createCreditType: { __typename?: 'CreditTypeEntity', uuid: string, name: string, color?: string | null, generalLedgerCode?: { __typename?: 'GeneralLedgerCodeEntity', code: string, description: string, id: string } | null } };

export type CreditTypeFragment = { __typename?: 'CreditTypeEntity', uuid: string, name: string, color?: string | null, generalLedgerCode?: { __typename?: 'GeneralLedgerCodeEntity', code: string, description: string, id: string } | null };

export type CreditTypesQueryVariables = Exact<{ [key: string]: never; }>;


export type CreditTypesQuery = { __typename?: 'Query', creditTypes: Array<{ __typename?: 'CreditTypeEntity', uuid: string, name: string, color?: string | null, generalLedgerCode?: { __typename?: 'GeneralLedgerCodeEntity', code: string, description: string, id: string } | null }> };

export type RemoveCreditTypeMutationVariables = Exact<{
  uuid: Scalars['String']['input'];
}>;


export type RemoveCreditTypeMutation = { __typename?: 'Mutation', removeCreditType: { __typename?: 'CreditTypeEntity', uuid: string, name: string, color?: string | null, generalLedgerCode?: { __typename?: 'GeneralLedgerCodeEntity', code: string, description: string, id: string } | null } };

export type UpdateCreditTypeMutationVariables = Exact<{
  creditTypeUpdateInput: CreditTypeUpdateInput;
}>;


export type UpdateCreditTypeMutation = { __typename?: 'Mutation', updateCreditType: { __typename?: 'CreditTypeEntity', uuid: string, name: string, color?: string | null, generalLedgerCode?: { __typename?: 'GeneralLedgerCodeEntity', code: string, description: string, id: string } | null } };

export type CreateGeneralLedgerCodeMutationVariables = Exact<{
  input: GeneralLedgerCodeCreateInput;
}>;


export type CreateGeneralLedgerCodeMutation = { __typename?: 'Mutation', createGeneralLedgerCode: { __typename: 'CreateGeneralLedgerCodeSuccessOutput', generalLedgerCode: { __typename?: 'GeneralLedgerCodeEntity', code: string, description: string } } | { __typename: 'MutationErrorOutput', message: string } };

export type DeleteGeneralLedgerCodeMutationVariables = Exact<{
  input: GeneralLedgerCodeDeleteInput;
}>;


export type DeleteGeneralLedgerCodeMutation = { __typename?: 'Mutation', deleteGeneralLedgerCode: { __typename: 'DeleteGeneralLedgerCodeSuccessOutput', id: string } | { __typename: 'MutationErrorOutput', message: string } };

export type GeneralLedgerCodeFragment = { __typename?: 'GeneralLedgerCodeEntity', id: string, code: string, description: string, accessorials: Array<{ __typename?: 'SkidBasedAccessorialEntity', name: string, uuid: string } | { __typename?: 'SpecialAccessorialEntity', name: string, uuid: string } | { __typename?: 'StandardAccessorialEntity', name: string, uuid: string } | { __typename?: 'UnitBasedAccessorialEntity', name: string, uuid: string } | { __typename?: 'WaitTimeAccessorialEntity', name: string, uuid: string } | { __typename?: 'WeightBasedAccessorialEntity', name: string, uuid: string } | { __typename?: 'ZoneBasedAccessorialEntity', name: string, uuid: string }>, creditTypes: Array<{ __typename?: 'CreditTypeEntity', name: string, uuid: string }> };

export type GeneralLedgerCodesQueryVariables = Exact<{ [key: string]: never; }>;


export type GeneralLedgerCodesQuery = { __typename?: 'Query', generalLedgerCodes: Array<{ __typename?: 'GeneralLedgerCodeEntity', id: string, code: string, description: string }> };

export type GeneralLedgerConfigurationQueryVariables = Exact<{ [key: string]: never; }>;


export type GeneralLedgerConfigurationQuery = { __typename?: 'Query', generalLedgerConfiguration?: { __typename?: 'GeneralLedgerConfigurationEntity', id: string, deliveryChargeCodeId?: string | null, pickupChargeCodeId?: string | null, recoveryChargeCodeId?: string | null, transferChargeCodeId?: string | null, orderChargeCodeId?: string | null, lineHaulChargeCodeId?: string | null, fuelChargeCodeId?: string | null, accessorialFallbackCodeId?: string | null, generalLedgerCodes: Array<{ __typename?: 'GeneralLedgerCodeEntity', id: string, code: string, description: string, accessorials: Array<{ __typename?: 'SkidBasedAccessorialEntity', name: string, uuid: string } | { __typename?: 'SpecialAccessorialEntity', name: string, uuid: string } | { __typename?: 'StandardAccessorialEntity', name: string, uuid: string } | { __typename?: 'UnitBasedAccessorialEntity', name: string, uuid: string } | { __typename?: 'WaitTimeAccessorialEntity', name: string, uuid: string } | { __typename?: 'WeightBasedAccessorialEntity', name: string, uuid: string } | { __typename?: 'ZoneBasedAccessorialEntity', name: string, uuid: string }>, creditTypes: Array<{ __typename?: 'CreditTypeEntity', name: string, uuid: string }> }> } | null };

export type UpdateGeneralLedgerCodeMutationVariables = Exact<{
  input: GeneralLedgerCodeUpdateInput;
}>;


export type UpdateGeneralLedgerCodeMutation = { __typename?: 'Mutation', updateGeneralLedgerCode: { __typename: 'MutationErrorOutput', message: string } | { __typename: 'UpdateGeneralLedgerCodeSuccessOutput', generalLedgerCode: { __typename?: 'GeneralLedgerCodeEntity', code: string, description: string } } };

export type UpdateGeneralLedgerConfigurationMutationVariables = Exact<{
  input: GeneralLedgerConfigurationUpdateInput;
}>;


export type UpdateGeneralLedgerConfigurationMutation = { __typename?: 'Mutation', updateGeneralLedgerConfiguration: { __typename: 'MutationErrorOutput', message: string } | { __typename: 'UpdateGeneralLedgerConfigurationSuccessOutput', generalLedgerConfiguration: { __typename?: 'GeneralLedgerConfigurationEntity', id: string } } };

export type CreateMasterAccountMutationVariables = Exact<{
  createMasterAccountInput: CreateMasterAccountInput;
}>;


export type CreateMasterAccountMutation = { __typename?: 'Mutation', createMasterAccount: { __typename?: 'CreateMasterAccountOutput', success: boolean } };

export type MasterAccountFragment = { __typename?: 'MasterAccountEntity', uuid: string, name: string };

export type MasterAccountsQueryVariables = Exact<{ [key: string]: never; }>;


export type MasterAccountsQuery = { __typename?: 'Query', masterAccounts: { __typename?: 'FindMasterAccountsOutput', masterAccounts: Array<{ __typename?: 'MasterAccountEntity', uuid: string, name: string }> } };

export type RemoveMasterAccountMutationVariables = Exact<{
  uuid: Scalars['String']['input'];
}>;


export type RemoveMasterAccountMutation = { __typename?: 'Mutation', removeMasterAccount: { __typename?: 'MasterAccountEntity', uuid: string } };

export type UpdateMasterAccountMutationVariables = Exact<{
  updateMasterAccountInput: UpdateMasterAccountInput;
}>;


export type UpdateMasterAccountMutation = { __typename?: 'Mutation', updateMasterAccount: { __typename?: 'UpdateMasterAccountOutput', success: boolean } };

export type CreateSettlementDeductionTypeMutationVariables = Exact<{
  settlementDeductionTypeCreateInput: SettlementDeductionTypeCreateInput;
}>;


export type CreateSettlementDeductionTypeMutation = { __typename?: 'Mutation', createSettlementDeductionType: { __typename?: 'SettlementDeductionTypeEntity', uuid: string, name: string, percentageRate?: number | null, flatRate?: number | null } };

export type RemoveSettlementDeductionTypeMutationVariables = Exact<{
  uuid: Scalars['String']['input'];
}>;


export type RemoveSettlementDeductionTypeMutation = { __typename?: 'Mutation', removeSettlementDeductionType: { __typename?: 'SettlementDeductionTypeEntity', uuid: string, name: string, percentageRate?: number | null, flatRate?: number | null } };

export type SettlementDeductionTypeFragment = { __typename?: 'SettlementDeductionTypeEntity', uuid: string, name: string, percentageRate?: number | null, flatRate?: number | null };

export type SettlementDeductionTypesQueryVariables = Exact<{ [key: string]: never; }>;


export type SettlementDeductionTypesQuery = { __typename?: 'Query', settlementDeductionTypes: Array<{ __typename?: 'SettlementDeductionTypeEntity', uuid: string, name: string, percentageRate?: number | null, flatRate?: number | null }> };

export type UpdateSettlementDeductionTypeMutationVariables = Exact<{
  settlementDeductionTypeUpdateInput: SettlementDeductionTypeUpdateInput;
}>;


export type UpdateSettlementDeductionTypeMutation = { __typename?: 'Mutation', updateSettlementDeductionType: { __typename?: 'SettlementDeductionTypeEntity', uuid: string, name: string, percentageRate?: number | null, flatRate?: number | null } };

export type BulkUploadRouteNamesMutationVariables = Exact<{
  bulkCsvRouteNameInput: BulkCsvRouteNameInput;
}>;


export type BulkUploadRouteNamesMutation = { __typename?: 'Mutation', bulkUploadRouteNames: Array<{ __typename?: 'RouteNameEntity', uuid: string }> };

export type FindBusinessDivisionsFragment = { __typename?: 'BusinessDivisionEntity', uuid: string, name: string };

export type BusinessDivisionsQueryVariables = Exact<{ [key: string]: never; }>;


export type BusinessDivisionsQuery = { __typename?: 'Query', businessDivisions: { __typename?: 'FindBusinessDivisionsOutput', businessDivisions: Array<{ __typename?: 'BusinessDivisionEntity', uuid: string, name: string }> } };

export type CreateBusinessDivisionMutationVariables = Exact<{
  createBusinessDivisionInput: CreateBusinessDivisionInput;
}>;


export type CreateBusinessDivisionMutation = { __typename?: 'Mutation', createBusinessDivision: { __typename?: 'CreateBusinessDivisionOutput', success: boolean } };

export type RemoveBusinessDivisionMutationVariables = Exact<{
  uuid: Scalars['String']['input'];
}>;


export type RemoveBusinessDivisionMutation = { __typename?: 'Mutation', removeBusinessDivision: { __typename?: 'BusinessDivisionEntity', uuid: string } };

export type UpdateBusinessDivisionMutationVariables = Exact<{
  updateBusinessDivisionInput: UpdateBusinessDivisionInput;
}>;


export type UpdateBusinessDivisionMutation = { __typename?: 'Mutation', updateBusinessDivision: { __typename?: 'UpdateBusinessDivisionOutput', success: boolean } };

export type CompanyQueryVariables = Exact<{ [key: string]: never; }>;


export type CompanyQuery = { __typename?: 'Query', company: { __typename?: 'CompanyEntity', uuid: string } };

export type CreateCustomDriverFormMutationVariables = Exact<{
  createDriverSignableFormTemplateInput: CreateDriverSignableFormTemplateInput;
}>;


export type CreateCustomDriverFormMutation = { __typename?: 'Mutation', createDriverSignableFormTemplate: { __typename?: 'DriverSignableFormTemplateEntity', uuid: string } };

export type CreateEquipmentMutationVariables = Exact<{
  input: CreateEquipmentInput;
}>;


export type CreateEquipmentMutation = { __typename?: 'Mutation', createEquipment: { __typename?: 'EquipmentEntity', uuid: string, name: string } };

export type CreateFuelProfileMutationVariables = Exact<{
  input: CreateFuelProfileInput;
}>;


export type CreateFuelProfileMutation = { __typename?: 'Mutation', createFuelProfile?: { __typename?: 'FuelProfileEntity', uuid: string } | null };

export type UpdateInvoiceEmailMutationVariables = Exact<{
  input: Scalars['String']['input'];
}>;


export type UpdateInvoiceEmailMutation = { __typename?: 'Mutation', updateInvoiceEmail: { __typename?: 'CompanyEntity', uuid: string, sendgridSenderId?: string | null } };

export type CreateServiceMutationVariables = Exact<{
  input: CreateServiceInput;
}>;


export type CreateServiceMutation = { __typename?: 'Mutation', createService: { __typename?: 'ServiceEntity', uuid: string, name: string } };

export type CustomDriverSignableFormQueryVariables = Exact<{
  uuid: Scalars['String']['input'];
}>;


export type CustomDriverSignableFormQuery = { __typename?: 'Query', customDriverForm?: { __typename?: 'DriverSignableFormTemplateEntity', uuid: string, title: string, formText: string, createdAt: any } | null };

export type CustomDriverSignableFormsQueryVariables = Exact<{ [key: string]: never; }>;


export type CustomDriverSignableFormsQuery = { __typename?: 'Query', customDriverForms?: Array<{ __typename?: 'DriverSignableFormTemplateEntity', uuid: string, title: string, formText: string, createdAt: any }> | null };

export type DeleteCustomDriverFormMutationVariables = Exact<{
  uuid: Scalars['String']['input'];
}>;


export type DeleteCustomDriverFormMutation = { __typename?: 'Mutation', deleteDriverSignableFormTemplate: { __typename?: 'DriverSignableFormTemplateEntity', uuid: string } };

export type DeleteEquipmentMutationVariables = Exact<{
  uuid: Scalars['String']['input'];
}>;


export type DeleteEquipmentMutation = { __typename?: 'Mutation', deleteEquipment: { __typename?: 'EquipmentEntity', uuid: string } };

export type DeleteRouteNameLocationMutationVariables = Exact<{
  uuid: Scalars['String']['input'];
}>;


export type DeleteRouteNameLocationMutation = { __typename?: 'Mutation', deleteRouteNameLocation: { __typename?: 'RouteNameLocationEntity', uuid: string } };

export type DriverSignableFormFragment = { __typename?: 'DriverSignableFormTemplateEntity', uuid: string, title: string, formText: string, createdAt: any };

export type DriversTableQueryVariables = Exact<{ [key: string]: never; }>;


export type DriversTableQuery = { __typename?: 'Query', drivers: Array<{ __typename?: 'DriverEntity', uuid: string, firstName: string, lastName: string, driverType?: DriverType | null, driverPayType?: DriverPayType | null, driverReferenceNumber?: string | null, active: boolean, terminal?: { __typename?: 'TerminalEntity', uuid: string, name: string } | null }> };

export type ArchiveDriverMutationVariables = Exact<{
  uuid: Scalars['String']['input'];
}>;


export type ArchiveDriverMutation = { __typename?: 'Mutation', archiveDriver: { __typename?: 'UpdateDriverOutput', driver: { __typename?: 'DriverEntity', uuid: string, active: boolean } } };

export type CreateDriverMutationVariables = Exact<{
  input: CreateDriverInput;
}>;


export type CreateDriverMutation = { __typename?: 'Mutation', createDriver?: { __typename?: 'DriverEntity', uuid: string, firstName: string, lastName: string } | null };

export type DriverByPhoneNumberQueryVariables = Exact<{
  phoneNumber: Scalars['String']['input'];
}>;


export type DriverByPhoneNumberQuery = { __typename?: 'Query', driverByPhoneNumber?: { __typename?: 'DriverEntity', uuid: string, firstName: string, lastName: string, company: { __typename?: 'CompanyEntity', uuid: string } } | null };

export type DriverQualificationsQueryVariables = Exact<{ [key: string]: never; }>;


export type DriverQualificationsQuery = { __typename?: 'Query', driverQualifications: Array<{ __typename?: 'DriverQualificationEntity', id: string, name: string }> };

export type DriverQueryVariables = Exact<{
  uuid: Scalars['String']['input'];
}>;


export type DriverQuery = { __typename?: 'Query', driver: { __typename?: 'DriverEntity', uuid: string, active: boolean, driverPayType?: DriverPayType | null, driverType?: DriverType | null, driverReferenceNumber?: string | null, emailAddress?: string | null, password?: string | null, firstName: string, flatRate?: number | null, fuelCardNumber: string, hourlyRate?: number | null, lastName: string, notes: string, perMileRate?: number | null, percentGrossRevenueRate?: number | null, defaultFuelSettlementPercentageRate?: number | null, phoneNumber: string, sendRouteUpdateEmails: boolean, defaultOrdinaryTariffChainId?: string | null, defaultTransferTariffChainId?: string | null, defaultLineHaulTariffChainId?: string | null, defaultPointToPointTariffChainId?: string | null, address?: { __typename?: 'AddressEntity', uuid: string, line1: string, line2?: string | null, city: string, country: string, name: string, state: string, zip: string, longitude?: number | null, latitude?: number | null } | null, defaultVehicle?: { __typename?: 'EquipmentEntity', uuid: string, name: string } | null, terminal?: { __typename?: 'TerminalEntity', uuid: string, name: string, code: string } | null, qualifications: Array<{ __typename?: 'DriverQualificationEntity', id: string, name: string }> } };

export type RestoreDriverMutationVariables = Exact<{
  uuid: Scalars['String']['input'];
}>;


export type RestoreDriverMutation = { __typename?: 'Mutation', restoreDriver: { __typename?: 'UpdateDriverOutput', driver: { __typename?: 'DriverEntity', uuid: string, active: boolean } } };

export type UpdateDriverQualificationsMutationVariables = Exact<{
  input: UpdateDriverQualificationsInput;
}>;


export type UpdateDriverQualificationsMutation = { __typename?: 'Mutation', updateDriverQualifications: { __typename?: 'UpdateDriverQualificationsOutput', driverQualifications: Array<{ __typename?: 'DriverQualificationEntity', id: string, name: string }> } };

export type VehicleTypeQueryVariables = Exact<{
  uuid: Scalars['String']['input'];
}>;


export type VehicleTypeQuery = { __typename?: 'Query', vehicleType: { __typename?: 'VehicleTypeEntity', uuid: string, name: string, status: VehicleTypeStatus, maxVolume?: any | null, maxWeight?: any | null, capacityNotes?: string | null, vehicleTypePackageSpecs: Array<{ __typename?: 'VehicleTypePackageSpecEntity', id: string, maxQuantity?: number | null, packageSpec: { __typename?: 'PackageSpecEntity', id: string, name: string } }> } };

export type FlipIsArchivedMutationVariables = Exact<{
  uuid: Scalars['String']['input'];
}>;


export type FlipIsArchivedMutation = { __typename?: 'Mutation', flipIsArchived: { __typename?: 'SkidBasedAccessorialEntity', uuid: string } | { __typename?: 'SpecialAccessorialEntity', uuid: string } | { __typename?: 'StandardAccessorialEntity', uuid: string } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string } };

export type CreateFuelProfileDateRangeMutationVariables = Exact<{
  createFuelProfileDateRangeInput: CreateFuelProfileDateRangeInput;
}>;


export type CreateFuelProfileDateRangeMutation = { __typename?: 'Mutation', createFuelProfileDateRange: { __typename?: 'CreateFuelProfileDateRangeOutput', success: boolean, error?: string | null } };

export type DeleteFuelProfileDateRangeMutationVariables = Exact<{
  deleteFuelProfileDateRangeInput: DeleteFuelProfileDateRangeInput;
}>;


export type DeleteFuelProfileDateRangeMutation = { __typename?: 'Mutation', deleteFuelProfileDateRange: { __typename?: 'DeleteFuelProfileDateRangeOutput', success: boolean } };

export type FindFuelProfileFragment = { __typename?: 'FuelProfileEntity', uuid: string, name?: string | null, billingType: FuelBillingMethod, type: FuelProfileType, fuelProfileDateRanges: Array<{ __typename?: 'FuelProfileDateRangeEntity', uuid: string, startDate: any, expirationDate: any, surchargeRate?: number | null, flatRateUsdCents?: number | null }> };

export type FuelProfileDateRangeFragment = { __typename?: 'FuelProfileDateRangeEntity', uuid: string, startDate: any, expirationDate: any, surchargeRate?: number | null, flatRateUsdCents?: number | null };

export type FuelProfileFragment = { __typename?: 'FuelProfileEntity', uuid: string, name?: string | null, startDate?: any | null, expirationDate?: any | null, billingType: FuelBillingMethod, type: FuelProfileType, company: { __typename?: 'CompanyEntity', uuid: string }, contacts?: Array<{ __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string }> | null, fuelProfileDateRanges: Array<{ __typename?: 'FuelProfileDateRangeEntity', uuid: string, startDate: any, expirationDate: any, surchargeRate?: number | null, flatRateUsdCents?: number | null }> };

export type FuelProfileQueryVariables = Exact<{
  findFuelProfileInput: FindFuelProfileInput;
}>;


export type FuelProfileQuery = { __typename?: 'Query', fuelProfile: { __typename?: 'FindFuelProfileOutput', fuelProfile: { __typename?: 'FuelProfileEntity', uuid: string, name?: string | null, billingType: FuelBillingMethod, type: FuelProfileType, fuelProfileDateRanges: Array<{ __typename?: 'FuelProfileDateRangeEntity', uuid: string, startDate: any, expirationDate: any, surchargeRate?: number | null, flatRateUsdCents?: number | null }> } } };

export type FuelProfilesQueryVariables = Exact<{
  contactUuid?: InputMaybe<Scalars['String']['input']>;
  orderUuid?: InputMaybe<Scalars['String']['input']>;
  excludeContactUuid?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<FuelProfileType>;
}>;


export type FuelProfilesQuery = { __typename?: 'Query', fuelProfiles: Array<{ __typename?: 'FuelProfileEntity', uuid: string, name?: string | null, startDate?: any | null, expirationDate?: any | null, billingType: FuelBillingMethod, type: FuelProfileType, company: { __typename?: 'CompanyEntity', uuid: string }, contacts?: Array<{ __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string }> | null, fuelProfileDateRanges: Array<{ __typename?: 'FuelProfileDateRangeEntity', uuid: string, startDate: any, expirationDate: any, surchargeRate?: number | null, flatRateUsdCents?: number | null }> }> };

export type RemoveFuelProfileMutationVariables = Exact<{
  uuid: Scalars['String']['input'];
}>;


export type RemoveFuelProfileMutation = { __typename?: 'Mutation', removeFuelProfile: { __typename?: 'FuelProfileEntity', uuid: string } };

export type UpdateFuelProfileDateRangeMutationVariables = Exact<{
  updateFuelProfileDateRangeInput: UpdateFuelProfileDateRangeInput;
}>;


export type UpdateFuelProfileDateRangeMutation = { __typename?: 'Mutation', updateFuelProfileDateRange: { __typename?: 'UpdateFuelProfileDateRangeOutput', success: boolean, error?: string | null } };

export type UpdateFuelProfileMutationVariables = Exact<{
  input: UpdateFuelProfileInput;
}>;


export type UpdateFuelProfileMutation = { __typename?: 'Mutation', updateFuelProfile?: { __typename?: 'FuelProfileEntity', uuid: string } | null };

export type CreateHoldReasonMutationVariables = Exact<{
  holdReasonCreateInput: HoldReasonCreateInput;
}>;


export type CreateHoldReasonMutation = { __typename?: 'Mutation', createHoldReason: { __typename?: 'HoldReasonEntity', uuid: string, name: string, isArchived?: boolean | null } };

export type HoldReasonFragment = { __typename?: 'HoldReasonEntity', uuid: string, name: string, isArchived?: boolean | null };

export type HoldReasonsQueryVariables = Exact<{
  archived?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type HoldReasonsQuery = { __typename?: 'Query', holdReasons: Array<{ __typename?: 'HoldReasonEntity', uuid: string, name: string, isArchived?: boolean | null }> };

export type UpdateHoldReasonMutationVariables = Exact<{
  holdReasonUpdateInput: HoldReasonUpdateInput;
}>;


export type UpdateHoldReasonMutation = { __typename?: 'Mutation', updateHoldReason: { __typename?: 'HoldReasonEntity', uuid: string, name: string, isArchived?: boolean | null } };

export type CreateLineHaulLaneMutationVariables = Exact<{
  createLineHaulLaneInput: CreateLineHaulLaneInput;
}>;


export type CreateLineHaulLaneMutation = { __typename?: 'Mutation', createLineHaulLane: { __typename?: 'CreateLineHaulLaneOutput', errorMessage?: string | null, lineHaulLane?: { __typename?: 'LineHaulLaneEntity', uuid: string } | null } };

export type LineHaulLaneFragment = { __typename?: 'LineHaulLaneEntity', uuid: string, name: string, isActive: boolean, originTerminal: { __typename?: 'TerminalEntity', name: string, code: string, uuid: string, isActive: boolean, address: { __typename?: 'AddressEntity', line1: string, line2?: string | null, city: string, state: string, zip: string, uuid: string, name: string, latitude?: number | null, longitude?: number | null }, startForTerminalLanes: Array<{ __typename?: 'TerminalLaneEntity', id: string, endTerminal: { __typename?: 'TerminalEntity', uuid: string, code: string, name: string } }>, agent?: { __typename?: 'AgentFieldsEntity', name: string } | null }, destinationTerminal: { __typename?: 'TerminalEntity', name: string, code: string, uuid: string, isActive: boolean, address: { __typename?: 'AddressEntity', line1: string, line2?: string | null, city: string, state: string, zip: string, uuid: string, name: string, latitude?: number | null, longitude?: number | null }, startForTerminalLanes: Array<{ __typename?: 'TerminalLaneEntity', id: string, endTerminal: { __typename?: 'TerminalEntity', uuid: string, code: string, name: string } }>, agent?: { __typename?: 'AgentFieldsEntity', name: string } | null }, segments: Array<{ __typename?: 'LineHaulSegmentEntity', uuid: string, ordinal: number, startTerminal: { __typename?: 'TerminalEntity', uuid: string, code: string }, endTerminal: { __typename?: 'TerminalEntity', uuid: string, code: string } }> };

export type LineHaulLaneQueryVariables = Exact<{
  uuid: Scalars['String']['input'];
}>;


export type LineHaulLaneQuery = { __typename?: 'Query', lineHaulLane: { __typename?: 'LineHaulLaneEntity', uuid: string, name: string, isActive: boolean, originTerminal: { __typename?: 'TerminalEntity', name: string, code: string, uuid: string, isActive: boolean, address: { __typename?: 'AddressEntity', line1: string, line2?: string | null, city: string, state: string, zip: string, uuid: string, name: string, latitude?: number | null, longitude?: number | null }, startForTerminalLanes: Array<{ __typename?: 'TerminalLaneEntity', id: string, endTerminal: { __typename?: 'TerminalEntity', uuid: string, code: string, name: string } }>, agent?: { __typename?: 'AgentFieldsEntity', name: string } | null }, destinationTerminal: { __typename?: 'TerminalEntity', name: string, code: string, uuid: string, isActive: boolean, address: { __typename?: 'AddressEntity', line1: string, line2?: string | null, city: string, state: string, zip: string, uuid: string, name: string, latitude?: number | null, longitude?: number | null }, startForTerminalLanes: Array<{ __typename?: 'TerminalLaneEntity', id: string, endTerminal: { __typename?: 'TerminalEntity', uuid: string, code: string, name: string } }>, agent?: { __typename?: 'AgentFieldsEntity', name: string } | null }, segments: Array<{ __typename?: 'LineHaulSegmentEntity', uuid: string, ordinal: number, startTerminal: { __typename?: 'TerminalEntity', uuid: string, code: string }, endTerminal: { __typename?: 'TerminalEntity', uuid: string, code: string } }> } };

export type LineHaulLanesQueryVariables = Exact<{ [key: string]: never; }>;


export type LineHaulLanesQuery = { __typename?: 'Query', lineHaulLanes: Array<{ __typename?: 'LineHaulLaneEntity', uuid: string, name: string, isActive: boolean, originTerminal: { __typename?: 'TerminalEntity', uuid: string, code: string }, destinationTerminal: { __typename?: 'TerminalEntity', uuid: string, code: string } }> };

export type ShallowLineHaulLaneFragment = { __typename?: 'LineHaulLaneEntity', uuid: string, name: string, isActive: boolean, originTerminal: { __typename?: 'TerminalEntity', uuid: string, code: string }, destinationTerminal: { __typename?: 'TerminalEntity', uuid: string, code: string } };

export type ShallowLineHaulSegmentFragment = { __typename?: 'LineHaulSegmentEntity', uuid: string, ordinal: number, startTerminal: { __typename?: 'TerminalEntity', uuid: string, code: string }, endTerminal: { __typename?: 'TerminalEntity', uuid: string, code: string } };

export type UpdateLineHaulLaneMutationVariables = Exact<{
  updateLineHaulLaneInput: UpdateLineHaulLaneInput;
}>;


export type UpdateLineHaulLaneMutation = { __typename?: 'Mutation', updateLineHaulLane: { __typename?: 'UpdateLineHaulLaneOutput', errorMessage?: string | null, lineHaulLane: { __typename?: 'LineHaulLaneEntity', uuid: string } } };

export type MarkOrderAsCancelledMutationVariables = Exact<{
  uuid: Scalars['String']['input'];
}>;


export type MarkOrderAsCancelledMutation = { __typename?: 'Mutation', markAsCancelled: { __typename?: 'StandardOrderEntity', uuid: string } };

export type MarkOrderAsOnHoldMutationVariables = Exact<{
  markAsOnHoldInput: MarkAsOnHoldInput;
}>;


export type MarkOrderAsOnHoldMutation = { __typename?: 'Mutation', markAsOnHold: { __typename?: 'StandardOrderEntity', uuid: string, status: OrderStatus, detailedStatusV2?: OrderDetailedStatus | null } };

export type MinimalServiceRegionsQueryVariables = Exact<{
  input: GetServiceRegionsInput;
}>;


export type MinimalServiceRegionsQuery = { __typename?: 'Query', serviceRegions: { __typename?: 'GetServiceRegionsOutput', serviceRegions: Array<{ __typename?: 'ServiceRegionEntity', id: string, name: string, isArchived: boolean }> } };

export type ArchivePackageSpecMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type ArchivePackageSpecMutation = { __typename?: 'Mutation', archivePackageSpec: { __typename?: 'UpdatePackageSpecOutput', packageSpec: { __typename?: 'PackageSpecEntity', id: string, name: string, status: PackageSpecStatus, weight?: any | null, length?: any | null, width?: any | null, height?: any | null } } };

export type CreatePackageSpecMutationVariables = Exact<{
  createPackageSpecInput: CreatePackageSpecInput;
}>;


export type CreatePackageSpecMutation = { __typename?: 'Mutation', createPackageSpec: { __typename?: 'CreatePackageSpecOutput', packageSpec: { __typename?: 'PackageSpecEntity', id: string, name: string, status: PackageSpecStatus, weight?: any | null, length?: any | null, width?: any | null, height?: any | null } } };

export type PackageSpecFragment = { __typename?: 'PackageSpecEntity', id: string, name: string, status: PackageSpecStatus, weight?: any | null, length?: any | null, width?: any | null, height?: any | null };

export type PackageSpecQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type PackageSpecQuery = { __typename?: 'Query', packageSpec: { __typename?: 'PackageSpecEntity', id: string, name: string, status: PackageSpecStatus, weight?: any | null, length?: any | null, width?: any | null, height?: any | null } };

export type PackageSpecsMinimalQueryVariables = Exact<{ [key: string]: never; }>;


export type PackageSpecsMinimalQuery = { __typename?: 'Query', packageSpecs: { __typename?: 'FindPackageSpecsOutput', packageSpecs: Array<{ __typename?: 'PackageSpecEntity', id: string, name: string, status: PackageSpecStatus }> } };

export type RestorePackageSpecMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type RestorePackageSpecMutation = { __typename?: 'Mutation', restorePackageSpec: { __typename?: 'UpdatePackageSpecOutput', packageSpec: { __typename?: 'PackageSpecEntity', id: string, name: string, status: PackageSpecStatus, weight?: any | null, length?: any | null, width?: any | null, height?: any | null } } };

export type UpdatePackageSpecMutationVariables = Exact<{
  updatePackageSpecInput: UpdatePackageSpecInput;
}>;


export type UpdatePackageSpecMutation = { __typename?: 'Mutation', updatePackageSpec: { __typename?: 'UpdatePackageSpecOutput', packageSpec: { __typename?: 'PackageSpecEntity', id: string, name: string, status: PackageSpecStatus, weight?: any | null, length?: any | null, width?: any | null, height?: any | null } } };

export type RecoveryTerminalFragment = { __typename?: 'AirportInfoEntity', uuid: string, iataCode: string, terminal: string, address: { __typename?: 'AddressEntity', uuid: string, name: string, line1: string, line2?: string | null, city: string, state: string, zip: string, country: string, latitude?: number | null, longitude?: number | null, driverInstructions?: string | null, receivingHoursStart?: any | null, receivingHoursEnd?: any | null, specialInstructions?: string | null } };

export type RecoveryTerminalsQueryVariables = Exact<{ [key: string]: never; }>;


export type RecoveryTerminalsQuery = { __typename?: 'Query', airportInfos: Array<{ __typename?: 'AirportInfoEntity', uuid: string, iataCode: string, terminal: string, address: { __typename?: 'AddressEntity', uuid: string, name: string, line1: string, line2?: string | null, city: string, state: string, zip: string, country: string, latitude?: number | null, longitude?: number | null, driverInstructions?: string | null, receivingHoursStart?: any | null, receivingHoursEnd?: any | null, specialInstructions?: string | null } }> };

export type CreateRecoveryTerminalMutationVariables = Exact<{
  iataCode: Scalars['String']['input'];
  terminal: Scalars['String']['input'];
  addressUuid: Scalars['String']['input'];
  companyUuid: Scalars['String']['input'];
}>;


export type CreateRecoveryTerminalMutation = { __typename?: 'Mutation', createAirportInfo: { __typename?: 'AirportInfoEntity', uuid: string, address: { __typename?: 'AddressEntity', uuid: string, name: string, line1: string, line2?: string | null, city: string, state: string, zip: string, country: string, latitude?: number | null, longitude?: number | null, driverInstructions?: string | null, receivingHoursStart?: any | null, receivingHoursEnd?: any | null, specialInstructions?: string | null } } };

export type UpdateRecoveryTerminalMutationVariables = Exact<{
  uuid: Scalars['String']['input'];
  iataCode?: InputMaybe<Scalars['String']['input']>;
  terminal?: InputMaybe<Scalars['String']['input']>;
  addressUuid?: InputMaybe<Scalars['String']['input']>;
}>;


export type UpdateRecoveryTerminalMutation = { __typename?: 'Mutation', updateAirportInfo: { __typename?: 'AirportInfoEntity', uuid: string } };

export type RouteNameQueryVariables = Exact<{
  uuid: Scalars['String']['input'];
}>;


export type RouteNameQuery = { __typename?: 'Query', routeName?: { __typename?: 'RouteNameEntity', uuid: string, name: string, routeNameLocations: Array<{ __typename?: 'RouteNameLocationEntity', uuid: string, zipcode: string, city: string }> } | null };

export type RouteNamesQueryVariables = Exact<{ [key: string]: never; }>;


export type RouteNamesQuery = { __typename?: 'Query', routeNames: Array<{ __typename?: 'RouteNameEntity', uuid: string, name: string }> };

export type ServiceForThirdPartyUserFragment = { __typename?: 'ServiceEntity', uuid: string, name: string, defaultInboundStopType?: StopType | null, defaultOutboundStopType?: StopType | null };

export type ServicesForThirdPartyUserQueryVariables = Exact<{
  findServicesForThirdPartyUserInput: FindServicesForThirdPartyUserInput;
}>;


export type ServicesForThirdPartyUserQuery = { __typename?: 'Query', servicesForThirdPartyUser: Array<{ __typename?: 'ServiceEntity', uuid: string, name: string, defaultInboundStopType?: StopType | null, defaultOutboundStopType?: StopType | null }> };

export type CreateTerminalServiceAreasV2MutationVariables = Exact<{
  createTerminalServiceAreaInputs: Array<CreateTerminalServiceAreaInput> | CreateTerminalServiceAreaInput;
}>;


export type CreateTerminalServiceAreasV2Mutation = { __typename?: 'Mutation', createTerminalServiceAreasV2: { __typename?: 'CreateTerminalServiceAreaV2Output', createdCount?: number | null } };

export type CreateTerminalMutationVariables = Exact<{
  input: TerminalCreateInput;
}>;


export type CreateTerminalMutation = { __typename?: 'Mutation', createTerminalV2: { __typename: 'CreateTerminalSuccessOutput', terminal: { __typename?: 'TerminalEntity', uuid: string } } | { __typename: 'MutationErrorOutput', message: string } };

export type RemoveTerminalServiceAreaMutationVariables = Exact<{
  uuid: Scalars['String']['input'];
}>;


export type RemoveTerminalServiceAreaMutation = { __typename?: 'Mutation', removeTerminalServiceArea: { __typename?: 'TerminalServiceAreaEntity', uuid: string } };

export type ShallowTerminalFragment = { __typename?: 'TerminalEntity', name: string, code: string, uuid: string, isActive: boolean, address: { __typename?: 'AddressEntity', line1: string, line2?: string | null, city: string, state: string, zip: string, uuid: string, name: string, latitude?: number | null, longitude?: number | null }, startForTerminalLanes: Array<{ __typename?: 'TerminalLaneEntity', id: string, endTerminal: { __typename?: 'TerminalEntity', uuid: string, code: string, name: string } }>, agent?: { __typename?: 'AgentFieldsEntity', name: string } | null };

export type TerminalServiceAreaFragment = { __typename?: 'TerminalServiceAreaEntity', uuid: string, zipcode: string, city?: string | null };

export type TerminalFragment = { __typename?: 'TerminalEntity', name: string, code: string, uuid: string, isActive: boolean, address: { __typename?: 'AddressEntity', line1: string, line2?: string | null, city: string, state: string, zip: string, uuid: string, name: string }, serviceAreas: Array<{ __typename?: 'TerminalServiceAreaEntity', uuid: string, zipcode: string, city?: string | null }>, serviceRegion?: { __typename?: 'ServiceRegionEntity', id: string, name: string, isArchived: boolean } | null, agent?: { __typename?: 'AgentFieldsEntity', uuid: string, name: string } | null, startForTerminalLanes: Array<{ __typename?: 'TerminalLaneEntity', id: string, endTerminal: { __typename?: 'TerminalEntity', uuid: string, code: string, name: string } }> };

export type TerminalQueryVariables = Exact<{
  uuid: Scalars['String']['input'];
}>;


export type TerminalQuery = { __typename?: 'Query', terminal: { __typename?: 'TerminalEntity', name: string, code: string, uuid: string, isActive: boolean, address: { __typename?: 'AddressEntity', line1: string, line2?: string | null, city: string, state: string, zip: string, uuid: string, name: string }, serviceAreas: Array<{ __typename?: 'TerminalServiceAreaEntity', uuid: string, zipcode: string, city?: string | null }>, serviceRegion?: { __typename?: 'ServiceRegionEntity', id: string, name: string, isArchived: boolean } | null, agent?: { __typename?: 'AgentFieldsEntity', uuid: string, name: string } | null, startForTerminalLanes: Array<{ __typename?: 'TerminalLaneEntity', id: string, endTerminal: { __typename?: 'TerminalEntity', uuid: string, code: string, name: string } }> } };

export type TerminalsForThirdPartyUserQueryVariables = Exact<{
  findTerminalsForThirdPartyUserInput: FindTerminalsForThirdPartyUserInput;
}>;


export type TerminalsForThirdPartyUserQuery = { __typename?: 'Query', terminalsForThirdPartyUser: Array<{ __typename?: 'TerminalEntity', name: string, code: string, uuid: string, isActive: boolean, address: { __typename?: 'AddressEntity', line1: string, line2?: string | null, city: string, state: string, zip: string, uuid: string, name: string, latitude?: number | null, longitude?: number | null }, startForTerminalLanes: Array<{ __typename?: 'TerminalLaneEntity', id: string, endTerminal: { __typename?: 'TerminalEntity', uuid: string, code: string, name: string } }>, agent?: { __typename?: 'AgentFieldsEntity', name: string } | null }> };

export type TerminalsQueryVariables = Exact<{
  getTerminalsInput?: InputMaybe<GetTerminalsInput>;
}>;


export type TerminalsQuery = { __typename?: 'Query', terminals: Array<{ __typename?: 'TerminalEntity', name: string, code: string, uuid: string, isActive: boolean, address: { __typename?: 'AddressEntity', line1: string, line2?: string | null, city: string, state: string, zip: string, uuid: string, name: string, latitude?: number | null, longitude?: number | null }, startForTerminalLanes: Array<{ __typename?: 'TerminalLaneEntity', id: string, endTerminal: { __typename?: 'TerminalEntity', uuid: string, code: string, name: string } }>, agent?: { __typename?: 'AgentFieldsEntity', name: string } | null }> };

export type UpdateTerminalMutationVariables = Exact<{
  input: TerminalUpdateInput;
}>;


export type UpdateTerminalMutation = { __typename?: 'Mutation', updateTerminalV2: { __typename: 'MutationErrorOutput', message: string } | { __typename: 'UpdateTerminalSuccessOutput', terminal: { __typename?: 'TerminalEntity', name: string, code: string, uuid: string, isActive: boolean, address: { __typename?: 'AddressEntity', line1: string, line2?: string | null, city: string, state: string, zip: string, uuid: string, name: string }, serviceAreas: Array<{ __typename?: 'TerminalServiceAreaEntity', uuid: string, zipcode: string, city?: string | null }>, serviceRegion?: { __typename?: 'ServiceRegionEntity', id: string, name: string, isArchived: boolean } | null, agent?: { __typename?: 'AgentFieldsEntity', uuid: string, name: string } | null, startForTerminalLanes: Array<{ __typename?: 'TerminalLaneEntity', id: string, endTerminal: { __typename?: 'TerminalEntity', uuid: string, code: string, name: string } }> } } };

export type CreateThirdPartyBrokerMutationVariables = Exact<{
  thirdPartyBrokerCreateInput: ThirdPartyBrokerCreateInput;
}>;


export type CreateThirdPartyBrokerMutation = { __typename?: 'Mutation', createThirdPartyBroker: { __typename?: 'ThirdPartyBrokerEntity', uuid: string, name: string } };

export type RemoveThirdPartyBrokerMutationVariables = Exact<{
  uuid: Scalars['String']['input'];
}>;


export type RemoveThirdPartyBrokerMutation = { __typename?: 'Mutation', removeThirdPartyBroker: { __typename?: 'ThirdPartyBrokerEntity', uuid: string, name: string } };

export type ThirdPartyBrokerFragment = { __typename?: 'ThirdPartyBrokerEntity', uuid: string, name: string };

export type ThirdPartyBrokersQueryVariables = Exact<{ [key: string]: never; }>;


export type ThirdPartyBrokersQuery = { __typename?: 'Query', thirdPartyBrokers: Array<{ __typename?: 'ThirdPartyBrokerEntity', uuid: string, name: string }> };

export type UpdateThirdPartyBrokerMutationVariables = Exact<{
  thirdPartyBrokerUpdateInput: ThirdPartyBrokerUpdateInput;
}>;


export type UpdateThirdPartyBrokerMutation = { __typename?: 'Mutation', updateThirdPartyBroker: { __typename?: 'ThirdPartyBrokerEntity', uuid: string, name: string } };

export type UpdateCompanyConfigurationMutationVariables = Exact<{
  updateCompanyConfigurationInput: UpdateCompanyConfigurationInput;
}>;


export type UpdateCompanyConfigurationMutation = { __typename?: 'Mutation', updateCompanyConfiguration: { __typename?: 'CompanyConfigurationEntity', uuid: string } };

export type UpdateCustomDriverFormMutationVariables = Exact<{
  updateDriverSignableFormTemplateInput: UpdateDriverSignableFormTemplateInput;
}>;


export type UpdateCustomDriverFormMutation = { __typename?: 'Mutation', updateDriverSignableFormTemplate: { __typename?: 'DriverSignableFormTemplateEntity', uuid: string } };

export type UpdateDriverMutationVariables = Exact<{
  input: UpdateDriverInput;
}>;


export type UpdateDriverMutation = { __typename?: 'Mutation', updateDriver: { __typename?: 'DriverEntity', firstName: string, lastName: string, uuid: string } };

export type UpdateEquipmentMutationVariables = Exact<{
  input: UpdateEquipmentInput;
}>;


export type UpdateEquipmentMutation = { __typename?: 'Mutation', updateEquipment: { __typename?: 'EquipmentEntity', name: string, uuid: string } };

export type UpdateServiceMutationVariables = Exact<{
  input: UpdateServiceInput;
}>;


export type UpdateServiceMutation = { __typename?: 'Mutation', updateService: { __typename?: 'ServiceEntity', uuid: string, name: string } };

export type UpdateTemplateAndRecordAddressesMutationVariables = Exact<{
  updateAddressInput: UpdateAddressInput;
}>;


export type UpdateTemplateAndRecordAddressesMutation = { __typename?: 'Mutation', updateTemplateAndRecordAddresses: Array<{ __typename?: 'AddressEntity', uuid: string }> };

export type CreateUserMutationVariables = Exact<{
  createUserInput: CreateUserInput;
}>;


export type CreateUserMutation = { __typename?: 'Mutation', createUser?: { __typename?: 'UserEntity', uuid: string } | null };

export type ReportsEmailSenderIsVerifiedQueryVariables = Exact<{
  userUuid: Scalars['String']['input'];
}>;


export type ReportsEmailSenderIsVerifiedQuery = { __typename?: 'Query', reportsEmailSenderIsVerified?: boolean | null };

export type UpdateUserMutationVariables = Exact<{
  updateUserInput: UpdateUserInput;
}>;


export type UpdateUserMutation = { __typename?: 'Mutation', updateUser: { __typename?: 'UserEntity', uuid: string, terminal?: { __typename?: 'TerminalEntity', uuid: string } | null } };

export type UpdateUserReportsEmailMutationVariables = Exact<{
  userUuid: Scalars['String']['input'];
  email: Scalars['String']['input'];
}>;


export type UpdateUserReportsEmailMutation = { __typename?: 'Mutation', updateReportsEmail: { __typename?: 'UserEntity', uuid: string, reportsEmailSendgridSenderId?: string | null } };

export type UserFragment = { __typename?: 'UserEntity', uuid: string, name?: string | null, reportsEmail?: string | null, email: string, phoneNumber?: string | null, sendSummaryEmailWithIncompleteRoutes: boolean, sendAllInvoices?: boolean | null, isActive: boolean, terminal?: { __typename?: 'TerminalEntity', uuid: string, name: string } | null, roles: Array<{ __typename?: 'RoleEntity', uuid: string, name: string }>, driver?: { __typename?: 'DriverEntity', uuid: string } | null };

export type UsersRoleFragment = { __typename?: 'RoleEntity', uuid: string, name: string };

export type UsersQueryVariables = Exact<{
  getUsersInput?: InputMaybe<GetUsersInput>;
}>;


export type UsersQuery = { __typename?: 'Query', users: Array<{ __typename?: 'UserEntity', uuid: string, name?: string | null, reportsEmail?: string | null, email: string, phoneNumber?: string | null, sendSummaryEmailWithIncompleteRoutes: boolean, sendAllInvoices?: boolean | null, isActive: boolean, terminal?: { __typename?: 'TerminalEntity', uuid: string, name: string } | null, roles: Array<{ __typename?: 'RoleEntity', uuid: string, name: string }>, driver?: { __typename?: 'DriverEntity', uuid: string } | null }> };

export type ArchiveVehicleTypeMutationVariables = Exact<{
  uuid: Scalars['String']['input'];
}>;


export type ArchiveVehicleTypeMutation = { __typename?: 'Mutation', archiveVehicleType: { __typename?: 'VehicleTypeUpdateOutput', vehicleType: { __typename?: 'VehicleTypeEntity', uuid: string, name: string, status: VehicleTypeStatus, maxVolume?: any | null, maxWeight?: any | null, capacityNotes?: string | null, vehicleTypePackageSpecs: Array<{ __typename?: 'VehicleTypePackageSpecEntity', id: string, maxQuantity?: number | null, packageSpec: { __typename?: 'PackageSpecEntity', id: string, name: string } }> } } };

export type CreateVehicleTypeMutationVariables = Exact<{
  vehicleTypeCreateInput: VehicleTypeCreateInput;
}>;


export type CreateVehicleTypeMutation = { __typename?: 'Mutation', createVehicleType: { __typename?: 'VehicleTypeEntity', uuid: string, name: string, status: VehicleTypeStatus, maxVolume?: any | null, maxWeight?: any | null, capacityNotes?: string | null, vehicleTypePackageSpecs: Array<{ __typename?: 'VehicleTypePackageSpecEntity', id: string, maxQuantity?: number | null, packageSpec: { __typename?: 'PackageSpecEntity', id: string, name: string } }> } };

export type RestoreVehicleTypeMutationVariables = Exact<{
  uuid: Scalars['String']['input'];
}>;


export type RestoreVehicleTypeMutation = { __typename?: 'Mutation', restoreVehicleType: { __typename?: 'VehicleTypeUpdateOutput', vehicleType: { __typename?: 'VehicleTypeEntity', uuid: string, name: string, status: VehicleTypeStatus, maxVolume?: any | null, maxWeight?: any | null, capacityNotes?: string | null, vehicleTypePackageSpecs: Array<{ __typename?: 'VehicleTypePackageSpecEntity', id: string, maxQuantity?: number | null, packageSpec: { __typename?: 'PackageSpecEntity', id: string, name: string } }> } } };

export type UpdateVehicleTypeMutationVariables = Exact<{
  vehicleTypeUpdateInput: VehicleTypeUpdateInput;
}>;


export type UpdateVehicleTypeMutation = { __typename?: 'Mutation', updateVehicleType: { __typename?: 'VehicleTypeEntity', uuid: string, name: string, status: VehicleTypeStatus, maxVolume?: any | null, maxWeight?: any | null, capacityNotes?: string | null, vehicleTypePackageSpecs: Array<{ __typename?: 'VehicleTypePackageSpecEntity', id: string, maxQuantity?: number | null, packageSpec: { __typename?: 'PackageSpecEntity', id: string, name: string } }> } };

export type VehicleTypeFragment = { __typename?: 'VehicleTypeEntity', uuid: string, name: string, status: VehicleTypeStatus, maxVolume?: any | null, maxWeight?: any | null, capacityNotes?: string | null, vehicleTypePackageSpecs: Array<{ __typename?: 'VehicleTypePackageSpecEntity', id: string, maxQuantity?: number | null, packageSpec: { __typename?: 'PackageSpecEntity', id: string, name: string } }> };

export type VehicleTypesMinimalQueryVariables = Exact<{ [key: string]: never; }>;


export type VehicleTypesMinimalQuery = { __typename?: 'Query', vehicleTypes: Array<{ __typename?: 'VehicleTypeEntity', uuid: string, name: string, status: VehicleTypeStatus }> };

export type CreatedWarehouseEmployeeFragment = { __typename?: 'WarehouseEmployeeEntity', uuid: string };

export type CreateWarehouseEmployeeMutationVariables = Exact<{
  createWarehouseEmployeeInput: CreateWarehouseEmployeeInput;
}>;


export type CreateWarehouseEmployeeMutation = { __typename?: 'Mutation', createWarehouseEmployee: { __typename?: 'CreateWarehouseEmployeeOutput', warehouseEmployee?: { __typename?: 'WarehouseEmployeeEntity', uuid: string } | null } };

export type WarehouseEmployeeFragment = { __typename?: 'WarehouseEmployeeEntity', uuid: string, firstName: string, lastName: string, emailAddress?: string | null, phoneNumber: string, active: boolean, password?: string | null };

export type WarehouseEmployeesQueryVariables = Exact<{ [key: string]: never; }>;


export type WarehouseEmployeesQuery = { __typename?: 'Query', warehouseEmployees: { __typename?: 'FindWarehouseEmployeesOutput', warehouseEmployees: Array<{ __typename?: 'WarehouseEmployeeEntity', uuid: string, firstName: string, lastName: string, emailAddress?: string | null, phoneNumber: string, active: boolean, password?: string | null }> } };

export type UpdatedWarehouseEmployeeFragment = { __typename?: 'WarehouseEmployeeEntity', uuid: string };

export type UpdateWarehouseEmployeeMutationVariables = Exact<{
  updateWarehouseEmployeeInput: UpdateWarehouseEmployeeInput;
}>;


export type UpdateWarehouseEmployeeMutation = { __typename?: 'Mutation', updateWarehouseEmployee: { __typename?: 'UpdateWarehouseEmployeeOutput', warehouseEmployee?: { __typename?: 'WarehouseEmployeeEntity', uuid: string } | null } };

export type AcknowledgeNotificationMutationVariables = Exact<{
  uuid: Scalars['String']['input'];
}>;


export type AcknowledgeNotificationMutation = { __typename?: 'Mutation', acknowledgeNotification: { __typename?: 'NotificationEntity', uuid: string } };

export type AcknowledgeNotificationsMutationVariables = Exact<{
  uuids: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type AcknowledgeNotificationsMutation = { __typename?: 'Mutation', acknowledgeNotifications: Array<{ __typename?: 'NotificationEntity', uuid: string }> };

export type NotificationFragment = { __typename?: 'NotificationEntity', uuid: string, type: NotificationType, acknowledged?: boolean | null, createdAt: any, order?: { __typename?: 'StandardOrderEntity', uuid: string, name: string, createdAt: any, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', shipperBillOfLadingNumber?: string | null } } | null, driverMarkedAttemptedStop?: { __typename?: 'StandardStopEntity', leg: { __typename?: 'LegEntity', shipment: { __typename?: 'StandardShipmentEntity', order?: { __typename?: 'StandardOrderEntity', name: string } | null } } } | null, driverMarkedAttemptedDriver?: { __typename?: 'DriverEntity', uuid: string, firstName: string, lastName: string } | null, targetAccessorial?: { __typename: 'SkidBasedAccessorialEntity', isArchived?: boolean | null, isAuthoCodeRequired: boolean, isDefaultGlobalSpecial: boolean, invoiceDisplayName?: string | null, quickbooksDesktopAccessorialId?: string | null, uuid: string, quickbooksFileMappingChargeName?: string | null, quickbooksMappingId: string, percentForSettlement?: number | null, name: string, code?: string | null, ediCode?: string | null, ratePerSkid: number, maximumCharge?: number | null, minimumCharge?: number | null, contact?: { __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string } | null, matchingGlobalAccessorial?: { __typename?: 'SkidBasedAccessorialEntity', uuid: string } | { __typename?: 'SpecialAccessorialEntity', uuid: string } | { __typename?: 'StandardAccessorialEntity', uuid: string } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string } | null, matchingCustomerAccessorials?: Array<{ __typename?: 'SkidBasedAccessorialEntity', uuid: string } | { __typename?: 'SpecialAccessorialEntity', uuid: string } | { __typename?: 'StandardAccessorialEntity', uuid: string } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string }> | null, terminal?: { __typename?: 'TerminalEntity', uuid: string, name: string, code: string } | null, fuelProfile?: { __typename?: 'FuelProfileEntity', uuid: string, name?: string | null, startDate?: any | null, expirationDate?: any | null, billingType: FuelBillingMethod, type: FuelProfileType, company: { __typename?: 'CompanyEntity', uuid: string }, contacts?: Array<{ __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string }> | null, fuelProfileDateRanges: Array<{ __typename?: 'FuelProfileDateRangeEntity', uuid: string, startDate: any, expirationDate: any, surchargeRate?: number | null, flatRateUsdCents?: number | null }> } | null, generalLedgerCode?: { __typename?: 'GeneralLedgerCodeEntity', id: string, code: string } | null } | { __typename: 'SpecialAccessorialEntity', isArchived?: boolean | null, isAuthoCodeRequired: boolean, isDefaultGlobalSpecial: boolean, specialAccessorialType?: SpecialAccessorialType | null, invoiceDisplayName?: string | null, uuid: string, quickbooksDesktopAccessorialId?: string | null, quickbooksFileMappingChargeName?: string | null, quickbooksMappingId: string, percentForSettlement?: number | null, name: string, code?: string | null, ediCode?: string | null, contact?: { __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string } | null, serviceLevel?: { __typename?: 'ServiceEntity', uuid: string, name: string, createdAt: any, updatedAt: any, timeInMinutes?: number | null, useApptInRouteOptimization: boolean, markOrdersAsSpecial: boolean, defaultAppointmentStartTime?: any | null, defaultAppointmentEndTime?: any | null, defaultStartNow: boolean, defaultInboundStopType?: StopType | null, defaultOutboundStopType?: StopType | null, defaultPickupPadding?: any | null, defaultDeliveryPadding?: any | null, defaultTotalDuration?: any | null, defaultIsLineHaul: boolean, defaultFulfillmentType?: FulfillmentType | null, isActive: boolean, isExposedToCustomers: boolean, serviceAvailabilityDates: Array<{ __typename?: 'ServiceAvailabilityDateEntity', id: string, dayCategory: SpecialDayOfWeek, enabled: boolean, start: { __typename?: 'PlainTime', hour: number, minute: number }, end: { __typename?: 'PlainTime', hour: number, minute: number } }> } | null, zones: Array<{ __typename?: 'TariffZoneEntity', uuid: string, name: string }>, chargeGroups: Array<{ __typename?: 'SpecialAccessorialChargeGroupEntity', uuid: string, dayOfWeek: SpecialDayOfWeek, startTime: any, endTime: any }>, matrixItems: Array<{ __typename?: 'SpecialAccessorialMatrixItemEntity', zoneUuid: string, chargeGroupUuid: string, uuid: string, rate: number }>, matchingGlobalAccessorial?: { __typename?: 'SkidBasedAccessorialEntity', uuid: string } | { __typename?: 'SpecialAccessorialEntity', uuid: string } | { __typename?: 'StandardAccessorialEntity', uuid: string } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string } | null, matchingCustomerAccessorials?: Array<{ __typename?: 'SkidBasedAccessorialEntity', uuid: string } | { __typename?: 'SpecialAccessorialEntity', uuid: string } | { __typename?: 'StandardAccessorialEntity', uuid: string } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string }> | null, terminal?: { __typename?: 'TerminalEntity', uuid: string, name: string, code: string } | null, fuelProfile?: { __typename?: 'FuelProfileEntity', uuid: string, name?: string | null, startDate?: any | null, expirationDate?: any | null, billingType: FuelBillingMethod, type: FuelProfileType, company: { __typename?: 'CompanyEntity', uuid: string }, contacts?: Array<{ __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string }> | null, fuelProfileDateRanges: Array<{ __typename?: 'FuelProfileDateRangeEntity', uuid: string, startDate: any, expirationDate: any, surchargeRate?: number | null, flatRateUsdCents?: number | null }> } | null, tariffZoneGroup?: { __typename?: 'TariffZoneGroupEntity', id: string } | null, generalLedgerCode?: { __typename?: 'GeneralLedgerCodeEntity', id: string, code: string } | null } | { __typename: 'StandardAccessorialEntity', isArchived?: boolean | null, isAuthoCodeRequired: boolean, isDefaultGlobalSpecial: boolean, invoiceDisplayName?: string | null, quickbooksDesktopAccessorialId?: string | null, uuid: string, quickbooksFileMappingChargeName?: string | null, quickbooksMappingId: string, percentForSettlement?: number | null, name: string, code?: string | null, ediCode?: string | null, rate: number, contact?: { __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string } | null, matchingGlobalAccessorial?: { __typename?: 'SkidBasedAccessorialEntity', uuid: string } | { __typename?: 'SpecialAccessorialEntity', uuid: string } | { __typename?: 'StandardAccessorialEntity', uuid: string } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string } | null, matchingCustomerAccessorials?: Array<{ __typename?: 'SkidBasedAccessorialEntity', uuid: string } | { __typename?: 'SpecialAccessorialEntity', uuid: string } | { __typename?: 'StandardAccessorialEntity', uuid: string } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string }> | null, terminal?: { __typename?: 'TerminalEntity', uuid: string, name: string, code: string } | null, fuelProfile?: { __typename?: 'FuelProfileEntity', uuid: string, name?: string | null, startDate?: any | null, expirationDate?: any | null, billingType: FuelBillingMethod, type: FuelProfileType, company: { __typename?: 'CompanyEntity', uuid: string }, contacts?: Array<{ __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string }> | null, fuelProfileDateRanges: Array<{ __typename?: 'FuelProfileDateRangeEntity', uuid: string, startDate: any, expirationDate: any, surchargeRate?: number | null, flatRateUsdCents?: number | null }> } | null, generalLedgerCode?: { __typename?: 'GeneralLedgerCodeEntity', id: string, code: string } | null } | { __typename: 'UnitBasedAccessorialEntity', isArchived?: boolean | null, isAuthoCodeRequired: boolean, isDefaultGlobalSpecial: boolean, invoiceDisplayName?: string | null, quickbooksDesktopAccessorialId?: string | null, uuid: string, quickbooksFileMappingChargeName?: string | null, quickbooksMappingId: string, percentForSettlement?: number | null, name: string, code?: string | null, ediCode?: string | null, ratePerUnit: number, maximumCharge?: number | null, minimumCharge?: number | null, contact?: { __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string } | null, matchingGlobalAccessorial?: { __typename?: 'SkidBasedAccessorialEntity', uuid: string } | { __typename?: 'SpecialAccessorialEntity', uuid: string } | { __typename?: 'StandardAccessorialEntity', uuid: string } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string } | null, matchingCustomerAccessorials?: Array<{ __typename?: 'SkidBasedAccessorialEntity', uuid: string } | { __typename?: 'SpecialAccessorialEntity', uuid: string } | { __typename?: 'StandardAccessorialEntity', uuid: string } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string }> | null, terminal?: { __typename?: 'TerminalEntity', uuid: string, name: string, code: string } | null, fuelProfile?: { __typename?: 'FuelProfileEntity', uuid: string, name?: string | null, startDate?: any | null, expirationDate?: any | null, billingType: FuelBillingMethod, type: FuelProfileType, company: { __typename?: 'CompanyEntity', uuid: string }, contacts?: Array<{ __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string }> | null, fuelProfileDateRanges: Array<{ __typename?: 'FuelProfileDateRangeEntity', uuid: string, startDate: any, expirationDate: any, surchargeRate?: number | null, flatRateUsdCents?: number | null }> } | null, generalLedgerCode?: { __typename?: 'GeneralLedgerCodeEntity', id: string, code: string } | null } | { __typename: 'WaitTimeAccessorialEntity', isArchived?: boolean | null, isAuthoCodeRequired: boolean, isDefaultGlobalSpecial: boolean, invoiceDisplayName?: string | null, quickbooksDesktopAccessorialId?: string | null, uuid: string, quickbooksFileMappingChargeName?: string | null, quickbooksMappingId: string, percentForSettlement?: number | null, name: string, code?: string | null, ediCode?: string | null, rate: number, maximumCharge?: number | null, minimumCharge?: number | null, waitTimeChargePeriod?: number | null, waitTimeFreeMinutes?: number | null, contact?: { __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string } | null, matchingGlobalAccessorial?: { __typename?: 'SkidBasedAccessorialEntity', uuid: string } | { __typename?: 'SpecialAccessorialEntity', uuid: string } | { __typename?: 'StandardAccessorialEntity', uuid: string } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string } | null, matchingCustomerAccessorials?: Array<{ __typename?: 'SkidBasedAccessorialEntity', uuid: string } | { __typename?: 'SpecialAccessorialEntity', uuid: string } | { __typename?: 'StandardAccessorialEntity', uuid: string } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string }> | null, terminal?: { __typename?: 'TerminalEntity', uuid: string, name: string, code: string } | null, fuelProfile?: { __typename?: 'FuelProfileEntity', uuid: string, name?: string | null, startDate?: any | null, expirationDate?: any | null, billingType: FuelBillingMethod, type: FuelProfileType, company: { __typename?: 'CompanyEntity', uuid: string }, contacts?: Array<{ __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string }> | null, fuelProfileDateRanges: Array<{ __typename?: 'FuelProfileDateRangeEntity', uuid: string, startDate: any, expirationDate: any, surchargeRate?: number | null, flatRateUsdCents?: number | null }> } | null, generalLedgerCode?: { __typename?: 'GeneralLedgerCodeEntity', id: string, code: string } | null } | { __typename: 'WeightBasedAccessorialEntity', isArchived?: boolean | null, isAuthoCodeRequired: boolean, isDefaultGlobalSpecial: boolean, invoiceDisplayName?: string | null, quickbooksDesktopAccessorialId?: string | null, uuid: string, quickbooksFileMappingChargeName?: string | null, quickbooksMappingId: string, percentForSettlement?: number | null, name: string, code?: string | null, ediCode?: string | null, ratePerHundredWeight: number, maximumCharge?: number | null, minimumCharge?: number | null, contact?: { __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string } | null, accessorialRanges?: Array<{ __typename?: 'AccessorialRangeEntity', uuid: string, lessThanOrEqualToValue: number, rateUsdCents: number }> | null, matchingGlobalAccessorial?: { __typename?: 'SkidBasedAccessorialEntity', uuid: string } | { __typename?: 'SpecialAccessorialEntity', uuid: string } | { __typename?: 'StandardAccessorialEntity', uuid: string } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string } | null, matchingCustomerAccessorials?: Array<{ __typename?: 'SkidBasedAccessorialEntity', uuid: string } | { __typename?: 'SpecialAccessorialEntity', uuid: string } | { __typename?: 'StandardAccessorialEntity', uuid: string } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string }> | null, terminal?: { __typename?: 'TerminalEntity', uuid: string, name: string, code: string } | null, fuelProfile?: { __typename?: 'FuelProfileEntity', uuid: string, name?: string | null, startDate?: any | null, expirationDate?: any | null, billingType: FuelBillingMethod, type: FuelProfileType, company: { __typename?: 'CompanyEntity', uuid: string }, contacts?: Array<{ __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string }> | null, fuelProfileDateRanges: Array<{ __typename?: 'FuelProfileDateRangeEntity', uuid: string, startDate: any, expirationDate: any, surchargeRate?: number | null, flatRateUsdCents?: number | null }> } | null, generalLedgerCode?: { __typename?: 'GeneralLedgerCodeEntity', code: string, id: string } | null } | { __typename: 'ZoneBasedAccessorialEntity', isArchived?: boolean | null, isAuthoCodeRequired: boolean, isDefaultGlobalSpecial: boolean, invoiceDisplayName?: string | null, quickbooksDesktopAccessorialId?: string | null, uuid: string, quickbooksFileMappingChargeName?: string | null, quickbooksMappingId: string, percentForSettlement?: number | null, name: string, code?: string | null, ediCode?: string | null, contact?: { __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string } | null, zones: Array<{ __typename?: 'ZoneBasedAccessorialZoneEntity', uuid: string, name: string }>, chargeGroups: Array<{ __typename?: 'ZoneBasedAccessorialChargeGroupEntity', uuid: string, name: string }>, matrixItems: Array<{ __typename?: 'ZoneBasedAccessorialMatrixItemEntity', zoneUuid: string, chargeGroupUuid: string, uuid: string, rate: number }>, matchingGlobalAccessorial?: { __typename?: 'SkidBasedAccessorialEntity', uuid: string } | { __typename?: 'SpecialAccessorialEntity', uuid: string } | { __typename?: 'StandardAccessorialEntity', uuid: string } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string } | null, matchingCustomerAccessorials?: Array<{ __typename?: 'SkidBasedAccessorialEntity', uuid: string } | { __typename?: 'SpecialAccessorialEntity', uuid: string } | { __typename?: 'StandardAccessorialEntity', uuid: string } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string }> | null, terminal?: { __typename?: 'TerminalEntity', uuid: string, name: string, code: string } | null, fuelProfile?: { __typename?: 'FuelProfileEntity', uuid: string, name?: string | null, startDate?: any | null, expirationDate?: any | null, billingType: FuelBillingMethod, type: FuelProfileType, company: { __typename?: 'CompanyEntity', uuid: string }, contacts?: Array<{ __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string }> | null, fuelProfileDateRanges: Array<{ __typename?: 'FuelProfileDateRangeEntity', uuid: string, startDate: any, expirationDate: any, surchargeRate?: number | null, flatRateUsdCents?: number | null }> } | null, generalLedgerCode?: { __typename?: 'GeneralLedgerCodeEntity', id: string, code: string } | null } | null, targetStop?: { __typename?: 'StandardStopEntity', leg: { __typename?: 'LegEntity', shipment: { __typename?: 'StandardShipmentEntity', order?: { __typename?: 'StandardOrderEntity', name: string } | null } } } | null, sourceDriver?: { __typename?: 'DriverEntity', uuid: string, firstName: string, lastName: string } | null, emailTransaction?: { __typename?: 'EmailTransactionEntity', uuid: string, updatedAt: any, invoice?: { __typename?: 'InvoiceEntity', uuid: string, name: string, journalNumber: number, billToContact: { __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string } } | null, emailTransactionLogs: Array<{ __typename?: 'EmailTransactionLogEntity', uuid: string, email: string, lastStatus?: EmailTransactionLogStatus | null, reason?: string | null }> } | null };

export type NotificationsQueryVariables = Exact<{ [key: string]: never; }>;


export type NotificationsQuery = { __typename?: 'Query', notifications: Array<{ __typename?: 'NotificationEntity', uuid: string, type: NotificationType, acknowledged?: boolean | null, createdAt: any, order?: { __typename?: 'StandardOrderEntity', uuid: string, name: string, createdAt: any, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', shipperBillOfLadingNumber?: string | null } } | null, driverMarkedAttemptedStop?: { __typename?: 'StandardStopEntity', leg: { __typename?: 'LegEntity', shipment: { __typename?: 'StandardShipmentEntity', order?: { __typename?: 'StandardOrderEntity', name: string } | null } } } | null, driverMarkedAttemptedDriver?: { __typename?: 'DriverEntity', uuid: string, firstName: string, lastName: string } | null, targetAccessorial?: { __typename: 'SkidBasedAccessorialEntity', isArchived?: boolean | null, isAuthoCodeRequired: boolean, isDefaultGlobalSpecial: boolean, invoiceDisplayName?: string | null, quickbooksDesktopAccessorialId?: string | null, uuid: string, quickbooksFileMappingChargeName?: string | null, quickbooksMappingId: string, percentForSettlement?: number | null, name: string, code?: string | null, ediCode?: string | null, ratePerSkid: number, maximumCharge?: number | null, minimumCharge?: number | null, contact?: { __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string } | null, matchingGlobalAccessorial?: { __typename?: 'SkidBasedAccessorialEntity', uuid: string } | { __typename?: 'SpecialAccessorialEntity', uuid: string } | { __typename?: 'StandardAccessorialEntity', uuid: string } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string } | null, matchingCustomerAccessorials?: Array<{ __typename?: 'SkidBasedAccessorialEntity', uuid: string } | { __typename?: 'SpecialAccessorialEntity', uuid: string } | { __typename?: 'StandardAccessorialEntity', uuid: string } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string }> | null, terminal?: { __typename?: 'TerminalEntity', uuid: string, name: string, code: string } | null, fuelProfile?: { __typename?: 'FuelProfileEntity', uuid: string, name?: string | null, startDate?: any | null, expirationDate?: any | null, billingType: FuelBillingMethod, type: FuelProfileType, company: { __typename?: 'CompanyEntity', uuid: string }, contacts?: Array<{ __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string }> | null, fuelProfileDateRanges: Array<{ __typename?: 'FuelProfileDateRangeEntity', uuid: string, startDate: any, expirationDate: any, surchargeRate?: number | null, flatRateUsdCents?: number | null }> } | null, generalLedgerCode?: { __typename?: 'GeneralLedgerCodeEntity', id: string, code: string } | null } | { __typename: 'SpecialAccessorialEntity', isArchived?: boolean | null, isAuthoCodeRequired: boolean, isDefaultGlobalSpecial: boolean, specialAccessorialType?: SpecialAccessorialType | null, invoiceDisplayName?: string | null, uuid: string, quickbooksDesktopAccessorialId?: string | null, quickbooksFileMappingChargeName?: string | null, quickbooksMappingId: string, percentForSettlement?: number | null, name: string, code?: string | null, ediCode?: string | null, contact?: { __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string } | null, serviceLevel?: { __typename?: 'ServiceEntity', uuid: string, name: string, createdAt: any, updatedAt: any, timeInMinutes?: number | null, useApptInRouteOptimization: boolean, markOrdersAsSpecial: boolean, defaultAppointmentStartTime?: any | null, defaultAppointmentEndTime?: any | null, defaultStartNow: boolean, defaultInboundStopType?: StopType | null, defaultOutboundStopType?: StopType | null, defaultPickupPadding?: any | null, defaultDeliveryPadding?: any | null, defaultTotalDuration?: any | null, defaultIsLineHaul: boolean, defaultFulfillmentType?: FulfillmentType | null, isActive: boolean, isExposedToCustomers: boolean, serviceAvailabilityDates: Array<{ __typename?: 'ServiceAvailabilityDateEntity', id: string, dayCategory: SpecialDayOfWeek, enabled: boolean, start: { __typename?: 'PlainTime', hour: number, minute: number }, end: { __typename?: 'PlainTime', hour: number, minute: number } }> } | null, zones: Array<{ __typename?: 'TariffZoneEntity', uuid: string, name: string }>, chargeGroups: Array<{ __typename?: 'SpecialAccessorialChargeGroupEntity', uuid: string, dayOfWeek: SpecialDayOfWeek, startTime: any, endTime: any }>, matrixItems: Array<{ __typename?: 'SpecialAccessorialMatrixItemEntity', zoneUuid: string, chargeGroupUuid: string, uuid: string, rate: number }>, matchingGlobalAccessorial?: { __typename?: 'SkidBasedAccessorialEntity', uuid: string } | { __typename?: 'SpecialAccessorialEntity', uuid: string } | { __typename?: 'StandardAccessorialEntity', uuid: string } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string } | null, matchingCustomerAccessorials?: Array<{ __typename?: 'SkidBasedAccessorialEntity', uuid: string } | { __typename?: 'SpecialAccessorialEntity', uuid: string } | { __typename?: 'StandardAccessorialEntity', uuid: string } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string }> | null, terminal?: { __typename?: 'TerminalEntity', uuid: string, name: string, code: string } | null, fuelProfile?: { __typename?: 'FuelProfileEntity', uuid: string, name?: string | null, startDate?: any | null, expirationDate?: any | null, billingType: FuelBillingMethod, type: FuelProfileType, company: { __typename?: 'CompanyEntity', uuid: string }, contacts?: Array<{ __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string }> | null, fuelProfileDateRanges: Array<{ __typename?: 'FuelProfileDateRangeEntity', uuid: string, startDate: any, expirationDate: any, surchargeRate?: number | null, flatRateUsdCents?: number | null }> } | null, tariffZoneGroup?: { __typename?: 'TariffZoneGroupEntity', id: string } | null, generalLedgerCode?: { __typename?: 'GeneralLedgerCodeEntity', id: string, code: string } | null } | { __typename: 'StandardAccessorialEntity', isArchived?: boolean | null, isAuthoCodeRequired: boolean, isDefaultGlobalSpecial: boolean, invoiceDisplayName?: string | null, quickbooksDesktopAccessorialId?: string | null, uuid: string, quickbooksFileMappingChargeName?: string | null, quickbooksMappingId: string, percentForSettlement?: number | null, name: string, code?: string | null, ediCode?: string | null, rate: number, contact?: { __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string } | null, matchingGlobalAccessorial?: { __typename?: 'SkidBasedAccessorialEntity', uuid: string } | { __typename?: 'SpecialAccessorialEntity', uuid: string } | { __typename?: 'StandardAccessorialEntity', uuid: string } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string } | null, matchingCustomerAccessorials?: Array<{ __typename?: 'SkidBasedAccessorialEntity', uuid: string } | { __typename?: 'SpecialAccessorialEntity', uuid: string } | { __typename?: 'StandardAccessorialEntity', uuid: string } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string }> | null, terminal?: { __typename?: 'TerminalEntity', uuid: string, name: string, code: string } | null, fuelProfile?: { __typename?: 'FuelProfileEntity', uuid: string, name?: string | null, startDate?: any | null, expirationDate?: any | null, billingType: FuelBillingMethod, type: FuelProfileType, company: { __typename?: 'CompanyEntity', uuid: string }, contacts?: Array<{ __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string }> | null, fuelProfileDateRanges: Array<{ __typename?: 'FuelProfileDateRangeEntity', uuid: string, startDate: any, expirationDate: any, surchargeRate?: number | null, flatRateUsdCents?: number | null }> } | null, generalLedgerCode?: { __typename?: 'GeneralLedgerCodeEntity', id: string, code: string } | null } | { __typename: 'UnitBasedAccessorialEntity', isArchived?: boolean | null, isAuthoCodeRequired: boolean, isDefaultGlobalSpecial: boolean, invoiceDisplayName?: string | null, quickbooksDesktopAccessorialId?: string | null, uuid: string, quickbooksFileMappingChargeName?: string | null, quickbooksMappingId: string, percentForSettlement?: number | null, name: string, code?: string | null, ediCode?: string | null, ratePerUnit: number, maximumCharge?: number | null, minimumCharge?: number | null, contact?: { __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string } | null, matchingGlobalAccessorial?: { __typename?: 'SkidBasedAccessorialEntity', uuid: string } | { __typename?: 'SpecialAccessorialEntity', uuid: string } | { __typename?: 'StandardAccessorialEntity', uuid: string } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string } | null, matchingCustomerAccessorials?: Array<{ __typename?: 'SkidBasedAccessorialEntity', uuid: string } | { __typename?: 'SpecialAccessorialEntity', uuid: string } | { __typename?: 'StandardAccessorialEntity', uuid: string } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string }> | null, terminal?: { __typename?: 'TerminalEntity', uuid: string, name: string, code: string } | null, fuelProfile?: { __typename?: 'FuelProfileEntity', uuid: string, name?: string | null, startDate?: any | null, expirationDate?: any | null, billingType: FuelBillingMethod, type: FuelProfileType, company: { __typename?: 'CompanyEntity', uuid: string }, contacts?: Array<{ __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string }> | null, fuelProfileDateRanges: Array<{ __typename?: 'FuelProfileDateRangeEntity', uuid: string, startDate: any, expirationDate: any, surchargeRate?: number | null, flatRateUsdCents?: number | null }> } | null, generalLedgerCode?: { __typename?: 'GeneralLedgerCodeEntity', id: string, code: string } | null } | { __typename: 'WaitTimeAccessorialEntity', isArchived?: boolean | null, isAuthoCodeRequired: boolean, isDefaultGlobalSpecial: boolean, invoiceDisplayName?: string | null, quickbooksDesktopAccessorialId?: string | null, uuid: string, quickbooksFileMappingChargeName?: string | null, quickbooksMappingId: string, percentForSettlement?: number | null, name: string, code?: string | null, ediCode?: string | null, rate: number, maximumCharge?: number | null, minimumCharge?: number | null, waitTimeChargePeriod?: number | null, waitTimeFreeMinutes?: number | null, contact?: { __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string } | null, matchingGlobalAccessorial?: { __typename?: 'SkidBasedAccessorialEntity', uuid: string } | { __typename?: 'SpecialAccessorialEntity', uuid: string } | { __typename?: 'StandardAccessorialEntity', uuid: string } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string } | null, matchingCustomerAccessorials?: Array<{ __typename?: 'SkidBasedAccessorialEntity', uuid: string } | { __typename?: 'SpecialAccessorialEntity', uuid: string } | { __typename?: 'StandardAccessorialEntity', uuid: string } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string }> | null, terminal?: { __typename?: 'TerminalEntity', uuid: string, name: string, code: string } | null, fuelProfile?: { __typename?: 'FuelProfileEntity', uuid: string, name?: string | null, startDate?: any | null, expirationDate?: any | null, billingType: FuelBillingMethod, type: FuelProfileType, company: { __typename?: 'CompanyEntity', uuid: string }, contacts?: Array<{ __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string }> | null, fuelProfileDateRanges: Array<{ __typename?: 'FuelProfileDateRangeEntity', uuid: string, startDate: any, expirationDate: any, surchargeRate?: number | null, flatRateUsdCents?: number | null }> } | null, generalLedgerCode?: { __typename?: 'GeneralLedgerCodeEntity', id: string, code: string } | null } | { __typename: 'WeightBasedAccessorialEntity', isArchived?: boolean | null, isAuthoCodeRequired: boolean, isDefaultGlobalSpecial: boolean, invoiceDisplayName?: string | null, quickbooksDesktopAccessorialId?: string | null, uuid: string, quickbooksFileMappingChargeName?: string | null, quickbooksMappingId: string, percentForSettlement?: number | null, name: string, code?: string | null, ediCode?: string | null, ratePerHundredWeight: number, maximumCharge?: number | null, minimumCharge?: number | null, contact?: { __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string } | null, accessorialRanges?: Array<{ __typename?: 'AccessorialRangeEntity', uuid: string, lessThanOrEqualToValue: number, rateUsdCents: number }> | null, matchingGlobalAccessorial?: { __typename?: 'SkidBasedAccessorialEntity', uuid: string } | { __typename?: 'SpecialAccessorialEntity', uuid: string } | { __typename?: 'StandardAccessorialEntity', uuid: string } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string } | null, matchingCustomerAccessorials?: Array<{ __typename?: 'SkidBasedAccessorialEntity', uuid: string } | { __typename?: 'SpecialAccessorialEntity', uuid: string } | { __typename?: 'StandardAccessorialEntity', uuid: string } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string }> | null, terminal?: { __typename?: 'TerminalEntity', uuid: string, name: string, code: string } | null, fuelProfile?: { __typename?: 'FuelProfileEntity', uuid: string, name?: string | null, startDate?: any | null, expirationDate?: any | null, billingType: FuelBillingMethod, type: FuelProfileType, company: { __typename?: 'CompanyEntity', uuid: string }, contacts?: Array<{ __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string }> | null, fuelProfileDateRanges: Array<{ __typename?: 'FuelProfileDateRangeEntity', uuid: string, startDate: any, expirationDate: any, surchargeRate?: number | null, flatRateUsdCents?: number | null }> } | null, generalLedgerCode?: { __typename?: 'GeneralLedgerCodeEntity', code: string, id: string } | null } | { __typename: 'ZoneBasedAccessorialEntity', isArchived?: boolean | null, isAuthoCodeRequired: boolean, isDefaultGlobalSpecial: boolean, invoiceDisplayName?: string | null, quickbooksDesktopAccessorialId?: string | null, uuid: string, quickbooksFileMappingChargeName?: string | null, quickbooksMappingId: string, percentForSettlement?: number | null, name: string, code?: string | null, ediCode?: string | null, contact?: { __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string } | null, zones: Array<{ __typename?: 'ZoneBasedAccessorialZoneEntity', uuid: string, name: string }>, chargeGroups: Array<{ __typename?: 'ZoneBasedAccessorialChargeGroupEntity', uuid: string, name: string }>, matrixItems: Array<{ __typename?: 'ZoneBasedAccessorialMatrixItemEntity', zoneUuid: string, chargeGroupUuid: string, uuid: string, rate: number }>, matchingGlobalAccessorial?: { __typename?: 'SkidBasedAccessorialEntity', uuid: string } | { __typename?: 'SpecialAccessorialEntity', uuid: string } | { __typename?: 'StandardAccessorialEntity', uuid: string } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string } | null, matchingCustomerAccessorials?: Array<{ __typename?: 'SkidBasedAccessorialEntity', uuid: string } | { __typename?: 'SpecialAccessorialEntity', uuid: string } | { __typename?: 'StandardAccessorialEntity', uuid: string } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string }> | null, terminal?: { __typename?: 'TerminalEntity', uuid: string, name: string, code: string } | null, fuelProfile?: { __typename?: 'FuelProfileEntity', uuid: string, name?: string | null, startDate?: any | null, expirationDate?: any | null, billingType: FuelBillingMethod, type: FuelProfileType, company: { __typename?: 'CompanyEntity', uuid: string }, contacts?: Array<{ __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string }> | null, fuelProfileDateRanges: Array<{ __typename?: 'FuelProfileDateRangeEntity', uuid: string, startDate: any, expirationDate: any, surchargeRate?: number | null, flatRateUsdCents?: number | null }> } | null, generalLedgerCode?: { __typename?: 'GeneralLedgerCodeEntity', id: string, code: string } | null } | null, targetStop?: { __typename?: 'StandardStopEntity', leg: { __typename?: 'LegEntity', shipment: { __typename?: 'StandardShipmentEntity', order?: { __typename?: 'StandardOrderEntity', name: string } | null } } } | null, sourceDriver?: { __typename?: 'DriverEntity', uuid: string, firstName: string, lastName: string } | null, emailTransaction?: { __typename?: 'EmailTransactionEntity', uuid: string, updatedAt: any, invoice?: { __typename?: 'InvoiceEntity', uuid: string, name: string, journalNumber: number, billToContact: { __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string } } | null, emailTransactionLogs: Array<{ __typename?: 'EmailTransactionLogEntity', uuid: string, email: string, lastStatus?: EmailTransactionLogStatus | null, reason?: string | null }> } | null }> };

export type AuditLogEntryFragment = { __typename?: 'AuditLogEntry', orderEvent: { __typename?: 'OrderEventEntity', uuid: string, createdAt: any, ignoreSnapshot: boolean, message: string, eventType: OrderEventType, sourceType: OrderEventSourceType, targetType: OrderEventTargetType, snapshot?: string | null, targetPhoneNumber?: string | null, targetEmail?: string | null, targetOrderTotalBeforeConsolidation?: number | null, targetOrderTotalAfterConsolidation?: number | null, order?: { __typename?: 'StandardOrderEntity', uuid: string, name: string, source: OrderSource, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', uuid: string, shipperBillOfLadingNumber?: string | null }, quote?: { __typename?: 'QuoteEntity', uuid: string, number: string } | null, createdFromOrderTemplate?: { __typename?: 'StandardOrderEntity', uuid: string, name: string } | null } | null, sourceDriver?: { __typename?: 'DriverEntity', uuid: string, firstName: string, lastName: string, user: { __typename?: 'UserEntity', name?: string | null } } | null, sourceWarehouseEmployee?: { __typename?: 'WarehouseEmployeeEntity', uuid: string, firstName: string, lastName: string } | null, sourceEdiTransaction?: { __typename?: 'EdiTransactionEntity', uuid: string, status: EdiTransactionStatus, code: EdiTransactionCode } | null, sourceSftpUpload?: { __typename?: 'SftpUploadEntity', uuid: string, type: SftpUploadType, status: SftpUploadStatus } | null, sourceUser?: { __typename?: 'UserEntity', uuid: string, email: string } | null, targetContactPerson?: { __typename?: 'ContactPersonEntity', uuid: string, firstName?: string | null, lastName?: string | null, phone?: string | null } | null, targetDocument?: { __typename?: 'DocumentEntity', fileName: string, type: DocumentType, uuid: string } | null, targetDriver?: { __typename?: 'DriverEntity', uuid: string, firstName: string, lastName: string, phoneNumber: string, user: { __typename?: 'UserEntity', name?: string | null } } | null, targetInvoice?: { __typename?: 'InvoiceEntity', uuid: string, name: string } | null, targetRoute?: { __typename?: 'RouteEntity', uuid: string, name: string } | null, targetShipment?: { __typename?: 'StandardShipmentEntity', uuid: string, name: string, legs: Array<{ __typename?: 'LegEntity', endStop: { __typename?: 'StandardStopEntity', stopType?: StopType | null } }> } | null, targetShipmentSubscriber?: { __typename?: 'ShipmentSubscriberEntity', uuid: string, phoneNumber?: string | null } | null, targetStop?: { __typename?: 'StandardStopEntity', uuid: string, address: { __typename?: 'AddressEntity', uuid: string, name: string } } | null, targetSettlementBill?: { __typename?: 'DriverSettlementBillEntity', uuid: string, name?: string | null, settlementDate?: any | null, finalizedDate?: any | null } | null }, snapshotDifference?: { __typename?: 'AuditLogSnapshotDifference', orderDifferences?: { __typename?: 'SnapshotOrderDifferences', billingPartyName?: { __typename?: 'StringFieldDifference', oldValue?: string | null, newValue?: string | null } | null, hawb?: { __typename?: 'StringFieldDifference', oldValue?: string | null, newValue?: string | null } | null, mawb?: { __typename?: 'StringFieldDifference', oldValue?: string | null, newValue?: string | null } | null, refNumbers?: { __typename?: 'StringArrayFieldDifference', oldValue?: Array<string> | null, newValue?: Array<string> | null } | null, serviceLevel?: { __typename?: 'StringFieldDifference', oldValue?: string | null, newValue?: string | null } | null, totalAmountCents?: { __typename?: 'NumberFieldDifference', oldValue?: number | null, newValue?: number | null } | null, packages?: Array<{ __typename?: 'SnapshotPackageDifferences', wasAdded: boolean, wasDeleted: boolean, height?: { __typename?: 'NumberFieldDifference', oldValue?: number | null, newValue?: number | null } | null, weight?: { __typename?: 'NumberFieldDifference', oldValue?: number | null, newValue?: number | null } | null, length?: { __typename?: 'NumberFieldDifference', oldValue?: number | null, newValue?: number | null } | null, width?: { __typename?: 'NumberFieldDifference', oldValue?: number | null, newValue?: number | null } | null, type?: { __typename?: 'StringFieldDifference', oldValue?: string | null, newValue?: string | null } | null }> | null } | null, inboundStopDifferences?: { __typename?: 'SnapshotStopDifferences', wasAdded: boolean, wasDeleted: boolean, stopType?: { __typename?: 'StringFieldDifference', oldValue?: string | null, newValue?: string | null } | null, address?: { __typename?: 'SnapshotAddressDifferences', name?: { __typename?: 'StringFieldDifference', oldValue?: string | null, newValue?: string | null } | null, line1?: { __typename?: 'StringFieldDifference', oldValue?: string | null, newValue?: string | null } | null, zip?: { __typename?: 'StringFieldDifference', oldValue?: string | null, newValue?: string | null } | null, state?: { __typename?: 'StringFieldDifference', oldValue?: string | null, newValue?: string | null } | null, city?: { __typename?: 'StringFieldDifference', oldValue?: string | null, newValue?: string | null } | null } | null, terminal?: { __typename?: 'StringFieldDifference', oldValue?: string | null, newValue?: string | null } | null, serviceDate?: { __typename?: 'StringFieldDifference', oldValue?: string | null, newValue?: string | null } | null, isSpecial?: { __typename?: 'BooleanFieldDifference', oldValue?: boolean | null, newValue?: boolean | null } | null, appointmentRequired?: { __typename?: 'BooleanFieldDifference', oldValue?: boolean | null, newValue?: boolean | null } | null, appointmentManuallyConfirmed?: { __typename?: 'BooleanFieldDifference', oldValue?: boolean | null, newValue?: boolean | null } | null, freightCharge?: { __typename?: 'SnapshotFreightChargeDifferences', totalAmountCents?: { __typename?: 'NumberFieldDifference', oldValue?: number | null, newValue?: number | null } | null, tariff?: { __typename?: 'StringFieldDifference', oldValue?: string | null, newValue?: string | null } | null, fuelCharge?: { __typename?: 'SnapshotFuelChargeDifferences', totalAmountCents?: { __typename?: 'NumberFieldDifference', oldValue?: number | null, newValue?: number | null } | null } | null, billingMethod?: { __typename?: 'StringFieldDifference', oldValue?: string | null, newValue?: string | null } | null } | null, customCharges?: Array<{ __typename?: 'SnapshotCustomChargeDifferences', wasAdded: boolean, wasDeleted: boolean, name?: { __typename?: 'StringFieldDifference', oldValue?: string | null, newValue?: string | null } | null, totalAmountCents?: { __typename?: 'NumberFieldDifference', oldValue?: number | null, newValue?: number | null } | null }> | null, independentSettlementBillLineItems?: Array<{ __typename?: 'SnapshotIndependentSettlementBillLineItemDifferences', wasAdded: boolean, wasDeleted: boolean, driverName?: { __typename?: 'StringFieldDifference', oldValue?: string | null, newValue?: string | null } | null, freightCost?: { __typename?: 'SnapshotFreightCostDifferences', billingMethod?: { __typename?: 'StringFieldDifference', oldValue?: string | null, newValue?: string | null } | null, totalAmountCents?: { __typename?: 'NumberFieldDifference', oldValue?: number | null, newValue?: number | null } | null, tariff?: { __typename?: 'StringFieldDifference', oldValue?: string | null, newValue?: string | null } | null, fuelCost?: { __typename?: 'SnapshotFuelCostDifferences', billingMethod?: { __typename?: 'StringFieldDifference', oldValue?: string | null, newValue?: string | null } | null, totalAmountCents?: { __typename?: 'NumberFieldDifference', oldValue?: number | null, newValue?: number | null } | null, type?: { __typename?: 'StringFieldDifference', oldValue?: string | null, newValue?: string | null } | null, surchargeRate?: { __typename?: 'NumberFieldDifference', oldValue?: number | null, newValue?: number | null } | null } | null } | null, customCosts?: Array<{ __typename?: 'SnapshotCustomCostDifferences', wasAdded: boolean, wasDeleted: boolean, name?: { __typename?: 'StringFieldDifference', oldValue?: string | null, newValue?: string | null } | null, totalAmountCents?: { __typename?: 'NumberFieldDifference', oldValue?: number | null, newValue?: number | null } | null }> | null }> | null } | null, outboundStopDifferences?: { __typename?: 'SnapshotStopDifferences', wasAdded: boolean, wasDeleted: boolean, stopType?: { __typename?: 'StringFieldDifference', oldValue?: string | null, newValue?: string | null } | null, address?: { __typename?: 'SnapshotAddressDifferences', name?: { __typename?: 'StringFieldDifference', oldValue?: string | null, newValue?: string | null } | null, line1?: { __typename?: 'StringFieldDifference', oldValue?: string | null, newValue?: string | null } | null, zip?: { __typename?: 'StringFieldDifference', oldValue?: string | null, newValue?: string | null } | null, state?: { __typename?: 'StringFieldDifference', oldValue?: string | null, newValue?: string | null } | null, city?: { __typename?: 'StringFieldDifference', oldValue?: string | null, newValue?: string | null } | null } | null, terminal?: { __typename?: 'StringFieldDifference', oldValue?: string | null, newValue?: string | null } | null, serviceDate?: { __typename?: 'StringFieldDifference', oldValue?: string | null, newValue?: string | null } | null, isSpecial?: { __typename?: 'BooleanFieldDifference', oldValue?: boolean | null, newValue?: boolean | null } | null, appointmentRequired?: { __typename?: 'BooleanFieldDifference', oldValue?: boolean | null, newValue?: boolean | null } | null, appointmentManuallyConfirmed?: { __typename?: 'BooleanFieldDifference', oldValue?: boolean | null, newValue?: boolean | null } | null, freightCharge?: { __typename?: 'SnapshotFreightChargeDifferences', totalAmountCents?: { __typename?: 'NumberFieldDifference', oldValue?: number | null, newValue?: number | null } | null, tariff?: { __typename?: 'StringFieldDifference', oldValue?: string | null, newValue?: string | null } | null, fuelCharge?: { __typename?: 'SnapshotFuelChargeDifferences', totalAmountCents?: { __typename?: 'NumberFieldDifference', oldValue?: number | null, newValue?: number | null } | null } | null, billingMethod?: { __typename?: 'StringFieldDifference', oldValue?: string | null, newValue?: string | null } | null } | null, customCharges?: Array<{ __typename?: 'SnapshotCustomChargeDifferences', wasAdded: boolean, wasDeleted: boolean, name?: { __typename?: 'StringFieldDifference', oldValue?: string | null, newValue?: string | null } | null, totalAmountCents?: { __typename?: 'NumberFieldDifference', oldValue?: number | null, newValue?: number | null } | null }> | null, independentSettlementBillLineItems?: Array<{ __typename?: 'SnapshotIndependentSettlementBillLineItemDifferences', wasAdded: boolean, wasDeleted: boolean, driverName?: { __typename?: 'StringFieldDifference', oldValue?: string | null, newValue?: string | null } | null, freightCost?: { __typename?: 'SnapshotFreightCostDifferences', billingMethod?: { __typename?: 'StringFieldDifference', oldValue?: string | null, newValue?: string | null } | null, totalAmountCents?: { __typename?: 'NumberFieldDifference', oldValue?: number | null, newValue?: number | null } | null, tariff?: { __typename?: 'StringFieldDifference', oldValue?: string | null, newValue?: string | null } | null, fuelCost?: { __typename?: 'SnapshotFuelCostDifferences', billingMethod?: { __typename?: 'StringFieldDifference', oldValue?: string | null, newValue?: string | null } | null, totalAmountCents?: { __typename?: 'NumberFieldDifference', oldValue?: number | null, newValue?: number | null } | null, type?: { __typename?: 'StringFieldDifference', oldValue?: string | null, newValue?: string | null } | null, surchargeRate?: { __typename?: 'NumberFieldDifference', oldValue?: number | null, newValue?: number | null } | null } | null } | null, customCosts?: Array<{ __typename?: 'SnapshotCustomCostDifferences', wasAdded: boolean, wasDeleted: boolean, name?: { __typename?: 'StringFieldDifference', oldValue?: string | null, newValue?: string | null } | null, totalAmountCents?: { __typename?: 'NumberFieldDifference', oldValue?: number | null, newValue?: number | null } | null }> | null }> | null } | null } | null };

export type SnapshotDifferenceFragment = { __typename?: 'AuditLogSnapshotDifference', orderDifferences?: { __typename?: 'SnapshotOrderDifferences', billingPartyName?: { __typename?: 'StringFieldDifference', oldValue?: string | null, newValue?: string | null } | null, hawb?: { __typename?: 'StringFieldDifference', oldValue?: string | null, newValue?: string | null } | null, mawb?: { __typename?: 'StringFieldDifference', oldValue?: string | null, newValue?: string | null } | null, refNumbers?: { __typename?: 'StringArrayFieldDifference', oldValue?: Array<string> | null, newValue?: Array<string> | null } | null, serviceLevel?: { __typename?: 'StringFieldDifference', oldValue?: string | null, newValue?: string | null } | null, totalAmountCents?: { __typename?: 'NumberFieldDifference', oldValue?: number | null, newValue?: number | null } | null, packages?: Array<{ __typename?: 'SnapshotPackageDifferences', wasAdded: boolean, wasDeleted: boolean, height?: { __typename?: 'NumberFieldDifference', oldValue?: number | null, newValue?: number | null } | null, weight?: { __typename?: 'NumberFieldDifference', oldValue?: number | null, newValue?: number | null } | null, length?: { __typename?: 'NumberFieldDifference', oldValue?: number | null, newValue?: number | null } | null, width?: { __typename?: 'NumberFieldDifference', oldValue?: number | null, newValue?: number | null } | null, type?: { __typename?: 'StringFieldDifference', oldValue?: string | null, newValue?: string | null } | null }> | null } | null, inboundStopDifferences?: { __typename?: 'SnapshotStopDifferences', wasAdded: boolean, wasDeleted: boolean, stopType?: { __typename?: 'StringFieldDifference', oldValue?: string | null, newValue?: string | null } | null, address?: { __typename?: 'SnapshotAddressDifferences', name?: { __typename?: 'StringFieldDifference', oldValue?: string | null, newValue?: string | null } | null, line1?: { __typename?: 'StringFieldDifference', oldValue?: string | null, newValue?: string | null } | null, zip?: { __typename?: 'StringFieldDifference', oldValue?: string | null, newValue?: string | null } | null, state?: { __typename?: 'StringFieldDifference', oldValue?: string | null, newValue?: string | null } | null, city?: { __typename?: 'StringFieldDifference', oldValue?: string | null, newValue?: string | null } | null } | null, terminal?: { __typename?: 'StringFieldDifference', oldValue?: string | null, newValue?: string | null } | null, serviceDate?: { __typename?: 'StringFieldDifference', oldValue?: string | null, newValue?: string | null } | null, isSpecial?: { __typename?: 'BooleanFieldDifference', oldValue?: boolean | null, newValue?: boolean | null } | null, appointmentRequired?: { __typename?: 'BooleanFieldDifference', oldValue?: boolean | null, newValue?: boolean | null } | null, appointmentManuallyConfirmed?: { __typename?: 'BooleanFieldDifference', oldValue?: boolean | null, newValue?: boolean | null } | null, freightCharge?: { __typename?: 'SnapshotFreightChargeDifferences', totalAmountCents?: { __typename?: 'NumberFieldDifference', oldValue?: number | null, newValue?: number | null } | null, tariff?: { __typename?: 'StringFieldDifference', oldValue?: string | null, newValue?: string | null } | null, fuelCharge?: { __typename?: 'SnapshotFuelChargeDifferences', totalAmountCents?: { __typename?: 'NumberFieldDifference', oldValue?: number | null, newValue?: number | null } | null } | null, billingMethod?: { __typename?: 'StringFieldDifference', oldValue?: string | null, newValue?: string | null } | null } | null, customCharges?: Array<{ __typename?: 'SnapshotCustomChargeDifferences', wasAdded: boolean, wasDeleted: boolean, name?: { __typename?: 'StringFieldDifference', oldValue?: string | null, newValue?: string | null } | null, totalAmountCents?: { __typename?: 'NumberFieldDifference', oldValue?: number | null, newValue?: number | null } | null }> | null, independentSettlementBillLineItems?: Array<{ __typename?: 'SnapshotIndependentSettlementBillLineItemDifferences', wasAdded: boolean, wasDeleted: boolean, driverName?: { __typename?: 'StringFieldDifference', oldValue?: string | null, newValue?: string | null } | null, freightCost?: { __typename?: 'SnapshotFreightCostDifferences', billingMethod?: { __typename?: 'StringFieldDifference', oldValue?: string | null, newValue?: string | null } | null, totalAmountCents?: { __typename?: 'NumberFieldDifference', oldValue?: number | null, newValue?: number | null } | null, tariff?: { __typename?: 'StringFieldDifference', oldValue?: string | null, newValue?: string | null } | null, fuelCost?: { __typename?: 'SnapshotFuelCostDifferences', billingMethod?: { __typename?: 'StringFieldDifference', oldValue?: string | null, newValue?: string | null } | null, totalAmountCents?: { __typename?: 'NumberFieldDifference', oldValue?: number | null, newValue?: number | null } | null, type?: { __typename?: 'StringFieldDifference', oldValue?: string | null, newValue?: string | null } | null, surchargeRate?: { __typename?: 'NumberFieldDifference', oldValue?: number | null, newValue?: number | null } | null } | null } | null, customCosts?: Array<{ __typename?: 'SnapshotCustomCostDifferences', wasAdded: boolean, wasDeleted: boolean, name?: { __typename?: 'StringFieldDifference', oldValue?: string | null, newValue?: string | null } | null, totalAmountCents?: { __typename?: 'NumberFieldDifference', oldValue?: number | null, newValue?: number | null } | null }> | null }> | null } | null, outboundStopDifferences?: { __typename?: 'SnapshotStopDifferences', wasAdded: boolean, wasDeleted: boolean, stopType?: { __typename?: 'StringFieldDifference', oldValue?: string | null, newValue?: string | null } | null, address?: { __typename?: 'SnapshotAddressDifferences', name?: { __typename?: 'StringFieldDifference', oldValue?: string | null, newValue?: string | null } | null, line1?: { __typename?: 'StringFieldDifference', oldValue?: string | null, newValue?: string | null } | null, zip?: { __typename?: 'StringFieldDifference', oldValue?: string | null, newValue?: string | null } | null, state?: { __typename?: 'StringFieldDifference', oldValue?: string | null, newValue?: string | null } | null, city?: { __typename?: 'StringFieldDifference', oldValue?: string | null, newValue?: string | null } | null } | null, terminal?: { __typename?: 'StringFieldDifference', oldValue?: string | null, newValue?: string | null } | null, serviceDate?: { __typename?: 'StringFieldDifference', oldValue?: string | null, newValue?: string | null } | null, isSpecial?: { __typename?: 'BooleanFieldDifference', oldValue?: boolean | null, newValue?: boolean | null } | null, appointmentRequired?: { __typename?: 'BooleanFieldDifference', oldValue?: boolean | null, newValue?: boolean | null } | null, appointmentManuallyConfirmed?: { __typename?: 'BooleanFieldDifference', oldValue?: boolean | null, newValue?: boolean | null } | null, freightCharge?: { __typename?: 'SnapshotFreightChargeDifferences', totalAmountCents?: { __typename?: 'NumberFieldDifference', oldValue?: number | null, newValue?: number | null } | null, tariff?: { __typename?: 'StringFieldDifference', oldValue?: string | null, newValue?: string | null } | null, fuelCharge?: { __typename?: 'SnapshotFuelChargeDifferences', totalAmountCents?: { __typename?: 'NumberFieldDifference', oldValue?: number | null, newValue?: number | null } | null } | null, billingMethod?: { __typename?: 'StringFieldDifference', oldValue?: string | null, newValue?: string | null } | null } | null, customCharges?: Array<{ __typename?: 'SnapshotCustomChargeDifferences', wasAdded: boolean, wasDeleted: boolean, name?: { __typename?: 'StringFieldDifference', oldValue?: string | null, newValue?: string | null } | null, totalAmountCents?: { __typename?: 'NumberFieldDifference', oldValue?: number | null, newValue?: number | null } | null }> | null, independentSettlementBillLineItems?: Array<{ __typename?: 'SnapshotIndependentSettlementBillLineItemDifferences', wasAdded: boolean, wasDeleted: boolean, driverName?: { __typename?: 'StringFieldDifference', oldValue?: string | null, newValue?: string | null } | null, freightCost?: { __typename?: 'SnapshotFreightCostDifferences', billingMethod?: { __typename?: 'StringFieldDifference', oldValue?: string | null, newValue?: string | null } | null, totalAmountCents?: { __typename?: 'NumberFieldDifference', oldValue?: number | null, newValue?: number | null } | null, tariff?: { __typename?: 'StringFieldDifference', oldValue?: string | null, newValue?: string | null } | null, fuelCost?: { __typename?: 'SnapshotFuelCostDifferences', billingMethod?: { __typename?: 'StringFieldDifference', oldValue?: string | null, newValue?: string | null } | null, totalAmountCents?: { __typename?: 'NumberFieldDifference', oldValue?: number | null, newValue?: number | null } | null, type?: { __typename?: 'StringFieldDifference', oldValue?: string | null, newValue?: string | null } | null, surchargeRate?: { __typename?: 'NumberFieldDifference', oldValue?: number | null, newValue?: number | null } | null } | null } | null, customCosts?: Array<{ __typename?: 'SnapshotCustomCostDifferences', wasAdded: boolean, wasDeleted: boolean, name?: { __typename?: 'StringFieldDifference', oldValue?: string | null, newValue?: string | null } | null, totalAmountCents?: { __typename?: 'NumberFieldDifference', oldValue?: number | null, newValue?: number | null } | null }> | null }> | null } | null };

export type OrderAuditLogEntriesQueryVariables = Exact<{
  getOrderAuditLogEntriesInput: GetOrderAuditLogEntriesInput;
}>;


export type OrderAuditLogEntriesQuery = { __typename?: 'Query', orderAuditLogEntries?: { __typename?: 'GetOrderAuditLogEntriesOutput', auditLogEntries: Array<{ __typename?: 'AuditLogEntry', orderEvent: { __typename?: 'OrderEventEntity', uuid: string, createdAt: any, ignoreSnapshot: boolean, message: string, eventType: OrderEventType, sourceType: OrderEventSourceType, targetType: OrderEventTargetType, snapshot?: string | null, targetPhoneNumber?: string | null, targetEmail?: string | null, targetOrderTotalBeforeConsolidation?: number | null, targetOrderTotalAfterConsolidation?: number | null, order?: { __typename?: 'StandardOrderEntity', uuid: string, name: string, source: OrderSource, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', uuid: string, shipperBillOfLadingNumber?: string | null }, quote?: { __typename?: 'QuoteEntity', uuid: string, number: string } | null, createdFromOrderTemplate?: { __typename?: 'StandardOrderEntity', uuid: string, name: string } | null } | null, sourceDriver?: { __typename?: 'DriverEntity', uuid: string, firstName: string, lastName: string, user: { __typename?: 'UserEntity', name?: string | null } } | null, sourceWarehouseEmployee?: { __typename?: 'WarehouseEmployeeEntity', uuid: string, firstName: string, lastName: string } | null, sourceEdiTransaction?: { __typename?: 'EdiTransactionEntity', uuid: string, status: EdiTransactionStatus, code: EdiTransactionCode } | null, sourceSftpUpload?: { __typename?: 'SftpUploadEntity', uuid: string, type: SftpUploadType, status: SftpUploadStatus } | null, sourceUser?: { __typename?: 'UserEntity', uuid: string, email: string } | null, targetContactPerson?: { __typename?: 'ContactPersonEntity', uuid: string, firstName?: string | null, lastName?: string | null, phone?: string | null } | null, targetDocument?: { __typename?: 'DocumentEntity', fileName: string, type: DocumentType, uuid: string } | null, targetDriver?: { __typename?: 'DriverEntity', uuid: string, firstName: string, lastName: string, phoneNumber: string, user: { __typename?: 'UserEntity', name?: string | null } } | null, targetInvoice?: { __typename?: 'InvoiceEntity', uuid: string, name: string } | null, targetRoute?: { __typename?: 'RouteEntity', uuid: string, name: string } | null, targetShipment?: { __typename?: 'StandardShipmentEntity', uuid: string, name: string, legs: Array<{ __typename?: 'LegEntity', endStop: { __typename?: 'StandardStopEntity', stopType?: StopType | null } }> } | null, targetShipmentSubscriber?: { __typename?: 'ShipmentSubscriberEntity', uuid: string, phoneNumber?: string | null } | null, targetStop?: { __typename?: 'StandardStopEntity', uuid: string, address: { __typename?: 'AddressEntity', uuid: string, name: string } } | null, targetSettlementBill?: { __typename?: 'DriverSettlementBillEntity', uuid: string, name?: string | null, settlementDate?: any | null, finalizedDate?: any | null } | null }, snapshotDifference?: { __typename?: 'AuditLogSnapshotDifference', orderDifferences?: { __typename?: 'SnapshotOrderDifferences', billingPartyName?: { __typename?: 'StringFieldDifference', oldValue?: string | null, newValue?: string | null } | null, hawb?: { __typename?: 'StringFieldDifference', oldValue?: string | null, newValue?: string | null } | null, mawb?: { __typename?: 'StringFieldDifference', oldValue?: string | null, newValue?: string | null } | null, refNumbers?: { __typename?: 'StringArrayFieldDifference', oldValue?: Array<string> | null, newValue?: Array<string> | null } | null, serviceLevel?: { __typename?: 'StringFieldDifference', oldValue?: string | null, newValue?: string | null } | null, totalAmountCents?: { __typename?: 'NumberFieldDifference', oldValue?: number | null, newValue?: number | null } | null, packages?: Array<{ __typename?: 'SnapshotPackageDifferences', wasAdded: boolean, wasDeleted: boolean, height?: { __typename?: 'NumberFieldDifference', oldValue?: number | null, newValue?: number | null } | null, weight?: { __typename?: 'NumberFieldDifference', oldValue?: number | null, newValue?: number | null } | null, length?: { __typename?: 'NumberFieldDifference', oldValue?: number | null, newValue?: number | null } | null, width?: { __typename?: 'NumberFieldDifference', oldValue?: number | null, newValue?: number | null } | null, type?: { __typename?: 'StringFieldDifference', oldValue?: string | null, newValue?: string | null } | null }> | null } | null, inboundStopDifferences?: { __typename?: 'SnapshotStopDifferences', wasAdded: boolean, wasDeleted: boolean, stopType?: { __typename?: 'StringFieldDifference', oldValue?: string | null, newValue?: string | null } | null, address?: { __typename?: 'SnapshotAddressDifferences', name?: { __typename?: 'StringFieldDifference', oldValue?: string | null, newValue?: string | null } | null, line1?: { __typename?: 'StringFieldDifference', oldValue?: string | null, newValue?: string | null } | null, zip?: { __typename?: 'StringFieldDifference', oldValue?: string | null, newValue?: string | null } | null, state?: { __typename?: 'StringFieldDifference', oldValue?: string | null, newValue?: string | null } | null, city?: { __typename?: 'StringFieldDifference', oldValue?: string | null, newValue?: string | null } | null } | null, terminal?: { __typename?: 'StringFieldDifference', oldValue?: string | null, newValue?: string | null } | null, serviceDate?: { __typename?: 'StringFieldDifference', oldValue?: string | null, newValue?: string | null } | null, isSpecial?: { __typename?: 'BooleanFieldDifference', oldValue?: boolean | null, newValue?: boolean | null } | null, appointmentRequired?: { __typename?: 'BooleanFieldDifference', oldValue?: boolean | null, newValue?: boolean | null } | null, appointmentManuallyConfirmed?: { __typename?: 'BooleanFieldDifference', oldValue?: boolean | null, newValue?: boolean | null } | null, freightCharge?: { __typename?: 'SnapshotFreightChargeDifferences', totalAmountCents?: { __typename?: 'NumberFieldDifference', oldValue?: number | null, newValue?: number | null } | null, tariff?: { __typename?: 'StringFieldDifference', oldValue?: string | null, newValue?: string | null } | null, fuelCharge?: { __typename?: 'SnapshotFuelChargeDifferences', totalAmountCents?: { __typename?: 'NumberFieldDifference', oldValue?: number | null, newValue?: number | null } | null } | null, billingMethod?: { __typename?: 'StringFieldDifference', oldValue?: string | null, newValue?: string | null } | null } | null, customCharges?: Array<{ __typename?: 'SnapshotCustomChargeDifferences', wasAdded: boolean, wasDeleted: boolean, name?: { __typename?: 'StringFieldDifference', oldValue?: string | null, newValue?: string | null } | null, totalAmountCents?: { __typename?: 'NumberFieldDifference', oldValue?: number | null, newValue?: number | null } | null }> | null, independentSettlementBillLineItems?: Array<{ __typename?: 'SnapshotIndependentSettlementBillLineItemDifferences', wasAdded: boolean, wasDeleted: boolean, driverName?: { __typename?: 'StringFieldDifference', oldValue?: string | null, newValue?: string | null } | null, freightCost?: { __typename?: 'SnapshotFreightCostDifferences', billingMethod?: { __typename?: 'StringFieldDifference', oldValue?: string | null, newValue?: string | null } | null, totalAmountCents?: { __typename?: 'NumberFieldDifference', oldValue?: number | null, newValue?: number | null } | null, tariff?: { __typename?: 'StringFieldDifference', oldValue?: string | null, newValue?: string | null } | null, fuelCost?: { __typename?: 'SnapshotFuelCostDifferences', billingMethod?: { __typename?: 'StringFieldDifference', oldValue?: string | null, newValue?: string | null } | null, totalAmountCents?: { __typename?: 'NumberFieldDifference', oldValue?: number | null, newValue?: number | null } | null, type?: { __typename?: 'StringFieldDifference', oldValue?: string | null, newValue?: string | null } | null, surchargeRate?: { __typename?: 'NumberFieldDifference', oldValue?: number | null, newValue?: number | null } | null } | null } | null, customCosts?: Array<{ __typename?: 'SnapshotCustomCostDifferences', wasAdded: boolean, wasDeleted: boolean, name?: { __typename?: 'StringFieldDifference', oldValue?: string | null, newValue?: string | null } | null, totalAmountCents?: { __typename?: 'NumberFieldDifference', oldValue?: number | null, newValue?: number | null } | null }> | null }> | null } | null, outboundStopDifferences?: { __typename?: 'SnapshotStopDifferences', wasAdded: boolean, wasDeleted: boolean, stopType?: { __typename?: 'StringFieldDifference', oldValue?: string | null, newValue?: string | null } | null, address?: { __typename?: 'SnapshotAddressDifferences', name?: { __typename?: 'StringFieldDifference', oldValue?: string | null, newValue?: string | null } | null, line1?: { __typename?: 'StringFieldDifference', oldValue?: string | null, newValue?: string | null } | null, zip?: { __typename?: 'StringFieldDifference', oldValue?: string | null, newValue?: string | null } | null, state?: { __typename?: 'StringFieldDifference', oldValue?: string | null, newValue?: string | null } | null, city?: { __typename?: 'StringFieldDifference', oldValue?: string | null, newValue?: string | null } | null } | null, terminal?: { __typename?: 'StringFieldDifference', oldValue?: string | null, newValue?: string | null } | null, serviceDate?: { __typename?: 'StringFieldDifference', oldValue?: string | null, newValue?: string | null } | null, isSpecial?: { __typename?: 'BooleanFieldDifference', oldValue?: boolean | null, newValue?: boolean | null } | null, appointmentRequired?: { __typename?: 'BooleanFieldDifference', oldValue?: boolean | null, newValue?: boolean | null } | null, appointmentManuallyConfirmed?: { __typename?: 'BooleanFieldDifference', oldValue?: boolean | null, newValue?: boolean | null } | null, freightCharge?: { __typename?: 'SnapshotFreightChargeDifferences', totalAmountCents?: { __typename?: 'NumberFieldDifference', oldValue?: number | null, newValue?: number | null } | null, tariff?: { __typename?: 'StringFieldDifference', oldValue?: string | null, newValue?: string | null } | null, fuelCharge?: { __typename?: 'SnapshotFuelChargeDifferences', totalAmountCents?: { __typename?: 'NumberFieldDifference', oldValue?: number | null, newValue?: number | null } | null } | null, billingMethod?: { __typename?: 'StringFieldDifference', oldValue?: string | null, newValue?: string | null } | null } | null, customCharges?: Array<{ __typename?: 'SnapshotCustomChargeDifferences', wasAdded: boolean, wasDeleted: boolean, name?: { __typename?: 'StringFieldDifference', oldValue?: string | null, newValue?: string | null } | null, totalAmountCents?: { __typename?: 'NumberFieldDifference', oldValue?: number | null, newValue?: number | null } | null }> | null, independentSettlementBillLineItems?: Array<{ __typename?: 'SnapshotIndependentSettlementBillLineItemDifferences', wasAdded: boolean, wasDeleted: boolean, driverName?: { __typename?: 'StringFieldDifference', oldValue?: string | null, newValue?: string | null } | null, freightCost?: { __typename?: 'SnapshotFreightCostDifferences', billingMethod?: { __typename?: 'StringFieldDifference', oldValue?: string | null, newValue?: string | null } | null, totalAmountCents?: { __typename?: 'NumberFieldDifference', oldValue?: number | null, newValue?: number | null } | null, tariff?: { __typename?: 'StringFieldDifference', oldValue?: string | null, newValue?: string | null } | null, fuelCost?: { __typename?: 'SnapshotFuelCostDifferences', billingMethod?: { __typename?: 'StringFieldDifference', oldValue?: string | null, newValue?: string | null } | null, totalAmountCents?: { __typename?: 'NumberFieldDifference', oldValue?: number | null, newValue?: number | null } | null, type?: { __typename?: 'StringFieldDifference', oldValue?: string | null, newValue?: string | null } | null, surchargeRate?: { __typename?: 'NumberFieldDifference', oldValue?: number | null, newValue?: number | null } | null } | null } | null, customCosts?: Array<{ __typename?: 'SnapshotCustomCostDifferences', wasAdded: boolean, wasDeleted: boolean, name?: { __typename?: 'StringFieldDifference', oldValue?: string | null, newValue?: string | null } | null, totalAmountCents?: { __typename?: 'NumberFieldDifference', oldValue?: number | null, newValue?: number | null } | null }> | null }> | null } | null } | null }> } | null };

export type OrderDifferenceFragment = { __typename?: 'SnapshotOrderDifferences', billingPartyName?: { __typename?: 'StringFieldDifference', oldValue?: string | null, newValue?: string | null } | null, hawb?: { __typename?: 'StringFieldDifference', oldValue?: string | null, newValue?: string | null } | null, mawb?: { __typename?: 'StringFieldDifference', oldValue?: string | null, newValue?: string | null } | null, refNumbers?: { __typename?: 'StringArrayFieldDifference', oldValue?: Array<string> | null, newValue?: Array<string> | null } | null, serviceLevel?: { __typename?: 'StringFieldDifference', oldValue?: string | null, newValue?: string | null } | null, totalAmountCents?: { __typename?: 'NumberFieldDifference', oldValue?: number | null, newValue?: number | null } | null, packages?: Array<{ __typename?: 'SnapshotPackageDifferences', wasAdded: boolean, wasDeleted: boolean, height?: { __typename?: 'NumberFieldDifference', oldValue?: number | null, newValue?: number | null } | null, weight?: { __typename?: 'NumberFieldDifference', oldValue?: number | null, newValue?: number | null } | null, length?: { __typename?: 'NumberFieldDifference', oldValue?: number | null, newValue?: number | null } | null, width?: { __typename?: 'NumberFieldDifference', oldValue?: number | null, newValue?: number | null } | null, type?: { __typename?: 'StringFieldDifference', oldValue?: string | null, newValue?: string | null } | null }> | null };

export type PackageDifferenceFragment = { __typename?: 'SnapshotPackageDifferences', wasAdded: boolean, wasDeleted: boolean, height?: { __typename?: 'NumberFieldDifference', oldValue?: number | null, newValue?: number | null } | null, weight?: { __typename?: 'NumberFieldDifference', oldValue?: number | null, newValue?: number | null } | null, length?: { __typename?: 'NumberFieldDifference', oldValue?: number | null, newValue?: number | null } | null, width?: { __typename?: 'NumberFieldDifference', oldValue?: number | null, newValue?: number | null } | null, type?: { __typename?: 'StringFieldDifference', oldValue?: string | null, newValue?: string | null } | null };

export type OrderEventSnapshotFragment = { __typename?: 'OrderEventEntity', uuid: string, createdAt: any, snapshot?: string | null, sourceUser?: { __typename?: 'UserEntity', uuid: string, email: string } | null };

export type OrderEventSnapshotsQueryVariables = Exact<{
  orderUuid: Scalars['String']['input'];
  eventType?: InputMaybe<OrderEventType>;
  sortByCreatedAtAsc?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type OrderEventSnapshotsQuery = { __typename?: 'Query', orderEvents?: Array<{ __typename?: 'OrderEventEntity', uuid: string, createdAt: any, snapshot?: string | null, sourceUser?: { __typename?: 'UserEntity', uuid: string, email: string } | null }> | null };

export type OrderEventFragment = { __typename?: 'OrderEventEntity', uuid: string, createdAt: any, ignoreSnapshot: boolean, message: string, eventType: OrderEventType, sourceType: OrderEventSourceType, targetType: OrderEventTargetType, snapshot?: string | null, targetPhoneNumber?: string | null, targetEmail?: string | null, targetOrderTotalBeforeConsolidation?: number | null, targetOrderTotalAfterConsolidation?: number | null, order?: { __typename?: 'StandardOrderEntity', uuid: string, name: string, source: OrderSource, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', uuid: string, shipperBillOfLadingNumber?: string | null }, quote?: { __typename?: 'QuoteEntity', uuid: string, number: string } | null, createdFromOrderTemplate?: { __typename?: 'StandardOrderEntity', uuid: string, name: string } | null } | null, sourceDriver?: { __typename?: 'DriverEntity', uuid: string, firstName: string, lastName: string, user: { __typename?: 'UserEntity', name?: string | null } } | null, sourceWarehouseEmployee?: { __typename?: 'WarehouseEmployeeEntity', uuid: string, firstName: string, lastName: string } | null, sourceEdiTransaction?: { __typename?: 'EdiTransactionEntity', uuid: string, status: EdiTransactionStatus, code: EdiTransactionCode } | null, sourceSftpUpload?: { __typename?: 'SftpUploadEntity', uuid: string, type: SftpUploadType, status: SftpUploadStatus } | null, sourceUser?: { __typename?: 'UserEntity', uuid: string, email: string } | null, targetContactPerson?: { __typename?: 'ContactPersonEntity', uuid: string, firstName?: string | null, lastName?: string | null, phone?: string | null } | null, targetDocument?: { __typename?: 'DocumentEntity', fileName: string, type: DocumentType, uuid: string } | null, targetDriver?: { __typename?: 'DriverEntity', uuid: string, firstName: string, lastName: string, phoneNumber: string, user: { __typename?: 'UserEntity', name?: string | null } } | null, targetInvoice?: { __typename?: 'InvoiceEntity', uuid: string, name: string } | null, targetRoute?: { __typename?: 'RouteEntity', uuid: string, name: string } | null, targetShipment?: { __typename?: 'StandardShipmentEntity', uuid: string, name: string, legs: Array<{ __typename?: 'LegEntity', endStop: { __typename?: 'StandardStopEntity', stopType?: StopType | null } }> } | null, targetShipmentSubscriber?: { __typename?: 'ShipmentSubscriberEntity', uuid: string, phoneNumber?: string | null } | null, targetStop?: { __typename?: 'StandardStopEntity', uuid: string, address: { __typename?: 'AddressEntity', uuid: string, name: string } } | null, targetSettlementBill?: { __typename?: 'DriverSettlementBillEntity', uuid: string, name?: string | null, settlementDate?: any | null, finalizedDate?: any | null } | null };

export type OrderEventShipmentFragment = { __typename?: 'StandardShipmentEntity', uuid: string, name: string, legs: Array<{ __typename?: 'LegEntity', endStop: { __typename?: 'StandardStopEntity', stopType?: StopType | null } }> };

export type OrderEventsQueryVariables = Exact<{
  orderUuid?: InputMaybe<Scalars['String']['input']>;
  storageOrderUuid?: InputMaybe<Scalars['String']['input']>;
}>;


export type OrderEventsQuery = { __typename?: 'Query', orderEvents?: Array<{ __typename?: 'OrderEventEntity', uuid: string, createdAt: any, ignoreSnapshot: boolean, message: string, eventType: OrderEventType, sourceType: OrderEventSourceType, targetType: OrderEventTargetType, snapshot?: string | null, targetPhoneNumber?: string | null, targetEmail?: string | null, targetOrderTotalBeforeConsolidation?: number | null, targetOrderTotalAfterConsolidation?: number | null, sourcePicklist?: { __typename?: 'PicklistEntity', id: string, outboundReferenceNumber?: string | null, picklistItemGroups: Array<{ __typename?: 'PicklistItemGroupEntity', id: string, pickedQuantity: number, pickedStatus: PickedStatus, itemGroup: { __typename?: 'ItemGroupEntity', quantity: number, item: { __typename?: 'ItemEntity', sku: string, description?: string | null }, storageUnit?: { __typename?: 'StorageUnitEntity', name: string, warehouseLocation?: { __typename?: 'WarehouseLocationEntity', name: string } | null } | null } }> } | null, order?: { __typename?: 'StandardOrderEntity', uuid: string, name: string, source: OrderSource, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', uuid: string, shipperBillOfLadingNumber?: string | null }, quote?: { __typename?: 'QuoteEntity', uuid: string, number: string } | null, createdFromOrderTemplate?: { __typename?: 'StandardOrderEntity', uuid: string, name: string } | null } | null, sourceDriver?: { __typename?: 'DriverEntity', uuid: string, firstName: string, lastName: string, user: { __typename?: 'UserEntity', name?: string | null } } | null, sourceWarehouseEmployee?: { __typename?: 'WarehouseEmployeeEntity', uuid: string, firstName: string, lastName: string } | null, sourceEdiTransaction?: { __typename?: 'EdiTransactionEntity', uuid: string, status: EdiTransactionStatus, code: EdiTransactionCode } | null, sourceSftpUpload?: { __typename?: 'SftpUploadEntity', uuid: string, type: SftpUploadType, status: SftpUploadStatus } | null, sourceUser?: { __typename?: 'UserEntity', uuid: string, email: string } | null, targetContactPerson?: { __typename?: 'ContactPersonEntity', uuid: string, firstName?: string | null, lastName?: string | null, phone?: string | null } | null, targetDocument?: { __typename?: 'DocumentEntity', fileName: string, type: DocumentType, uuid: string } | null, targetDriver?: { __typename?: 'DriverEntity', uuid: string, firstName: string, lastName: string, phoneNumber: string, user: { __typename?: 'UserEntity', name?: string | null } } | null, targetInvoice?: { __typename?: 'InvoiceEntity', uuid: string, name: string } | null, targetRoute?: { __typename?: 'RouteEntity', uuid: string, name: string } | null, targetShipment?: { __typename?: 'StandardShipmentEntity', uuid: string, name: string, legs: Array<{ __typename?: 'LegEntity', endStop: { __typename?: 'StandardStopEntity', stopType?: StopType | null } }> } | null, targetShipmentSubscriber?: { __typename?: 'ShipmentSubscriberEntity', uuid: string, phoneNumber?: string | null } | null, targetStop?: { __typename?: 'StandardStopEntity', uuid: string, address: { __typename?: 'AddressEntity', uuid: string, name: string } } | null, targetSettlementBill?: { __typename?: 'DriverSettlementBillEntity', uuid: string, name?: string | null, settlementDate?: any | null, finalizedDate?: any | null } | null }> | null };

export type PicklistItemGroupFragment = { __typename?: 'PicklistItemGroupEntity', id: string, pickedQuantity: number, pickedStatus: PickedStatus, itemGroup: { __typename?: 'ItemGroupEntity', quantity: number, item: { __typename?: 'ItemEntity', sku: string, description?: string | null }, storageUnit?: { __typename?: 'StorageUnitEntity', name: string, warehouseLocation?: { __typename?: 'WarehouseLocationEntity', name: string } | null } | null } };

export type StopDifferenceFragment = { __typename?: 'SnapshotStopDifferences', wasAdded: boolean, wasDeleted: boolean, stopType?: { __typename?: 'StringFieldDifference', oldValue?: string | null, newValue?: string | null } | null, address?: { __typename?: 'SnapshotAddressDifferences', name?: { __typename?: 'StringFieldDifference', oldValue?: string | null, newValue?: string | null } | null, line1?: { __typename?: 'StringFieldDifference', oldValue?: string | null, newValue?: string | null } | null, zip?: { __typename?: 'StringFieldDifference', oldValue?: string | null, newValue?: string | null } | null, state?: { __typename?: 'StringFieldDifference', oldValue?: string | null, newValue?: string | null } | null, city?: { __typename?: 'StringFieldDifference', oldValue?: string | null, newValue?: string | null } | null } | null, terminal?: { __typename?: 'StringFieldDifference', oldValue?: string | null, newValue?: string | null } | null, serviceDate?: { __typename?: 'StringFieldDifference', oldValue?: string | null, newValue?: string | null } | null, isSpecial?: { __typename?: 'BooleanFieldDifference', oldValue?: boolean | null, newValue?: boolean | null } | null, appointmentRequired?: { __typename?: 'BooleanFieldDifference', oldValue?: boolean | null, newValue?: boolean | null } | null, appointmentManuallyConfirmed?: { __typename?: 'BooleanFieldDifference', oldValue?: boolean | null, newValue?: boolean | null } | null, freightCharge?: { __typename?: 'SnapshotFreightChargeDifferences', totalAmountCents?: { __typename?: 'NumberFieldDifference', oldValue?: number | null, newValue?: number | null } | null, tariff?: { __typename?: 'StringFieldDifference', oldValue?: string | null, newValue?: string | null } | null, fuelCharge?: { __typename?: 'SnapshotFuelChargeDifferences', totalAmountCents?: { __typename?: 'NumberFieldDifference', oldValue?: number | null, newValue?: number | null } | null } | null, billingMethod?: { __typename?: 'StringFieldDifference', oldValue?: string | null, newValue?: string | null } | null } | null, customCharges?: Array<{ __typename?: 'SnapshotCustomChargeDifferences', wasAdded: boolean, wasDeleted: boolean, name?: { __typename?: 'StringFieldDifference', oldValue?: string | null, newValue?: string | null } | null, totalAmountCents?: { __typename?: 'NumberFieldDifference', oldValue?: number | null, newValue?: number | null } | null }> | null, independentSettlementBillLineItems?: Array<{ __typename?: 'SnapshotIndependentSettlementBillLineItemDifferences', wasAdded: boolean, wasDeleted: boolean, driverName?: { __typename?: 'StringFieldDifference', oldValue?: string | null, newValue?: string | null } | null, freightCost?: { __typename?: 'SnapshotFreightCostDifferences', billingMethod?: { __typename?: 'StringFieldDifference', oldValue?: string | null, newValue?: string | null } | null, totalAmountCents?: { __typename?: 'NumberFieldDifference', oldValue?: number | null, newValue?: number | null } | null, tariff?: { __typename?: 'StringFieldDifference', oldValue?: string | null, newValue?: string | null } | null, fuelCost?: { __typename?: 'SnapshotFuelCostDifferences', billingMethod?: { __typename?: 'StringFieldDifference', oldValue?: string | null, newValue?: string | null } | null, totalAmountCents?: { __typename?: 'NumberFieldDifference', oldValue?: number | null, newValue?: number | null } | null, type?: { __typename?: 'StringFieldDifference', oldValue?: string | null, newValue?: string | null } | null, surchargeRate?: { __typename?: 'NumberFieldDifference', oldValue?: number | null, newValue?: number | null } | null } | null } | null, customCosts?: Array<{ __typename?: 'SnapshotCustomCostDifferences', wasAdded: boolean, wasDeleted: boolean, name?: { __typename?: 'StringFieldDifference', oldValue?: string | null, newValue?: string | null } | null, totalAmountCents?: { __typename?: 'NumberFieldDifference', oldValue?: number | null, newValue?: number | null } | null }> | null }> | null };

export type AddressDifferenceFragment = { __typename?: 'SnapshotAddressDifferences', name?: { __typename?: 'StringFieldDifference', oldValue?: string | null, newValue?: string | null } | null, line1?: { __typename?: 'StringFieldDifference', oldValue?: string | null, newValue?: string | null } | null, zip?: { __typename?: 'StringFieldDifference', oldValue?: string | null, newValue?: string | null } | null, state?: { __typename?: 'StringFieldDifference', oldValue?: string | null, newValue?: string | null } | null, city?: { __typename?: 'StringFieldDifference', oldValue?: string | null, newValue?: string | null } | null };

export type FreightChargeDifferenceFragment = { __typename?: 'SnapshotFreightChargeDifferences', totalAmountCents?: { __typename?: 'NumberFieldDifference', oldValue?: number | null, newValue?: number | null } | null, tariff?: { __typename?: 'StringFieldDifference', oldValue?: string | null, newValue?: string | null } | null, fuelCharge?: { __typename?: 'SnapshotFuelChargeDifferences', totalAmountCents?: { __typename?: 'NumberFieldDifference', oldValue?: number | null, newValue?: number | null } | null } | null, billingMethod?: { __typename?: 'StringFieldDifference', oldValue?: string | null, newValue?: string | null } | null };

export type CustomChargeDifferenceFragment = { __typename?: 'SnapshotCustomChargeDifferences', wasAdded: boolean, wasDeleted: boolean, name?: { __typename?: 'StringFieldDifference', oldValue?: string | null, newValue?: string | null } | null, totalAmountCents?: { __typename?: 'NumberFieldDifference', oldValue?: number | null, newValue?: number | null } | null };

export type IndependentSettlementBillLineItemDifferenceFragment = { __typename?: 'SnapshotIndependentSettlementBillLineItemDifferences', wasAdded: boolean, wasDeleted: boolean, driverName?: { __typename?: 'StringFieldDifference', oldValue?: string | null, newValue?: string | null } | null, freightCost?: { __typename?: 'SnapshotFreightCostDifferences', billingMethod?: { __typename?: 'StringFieldDifference', oldValue?: string | null, newValue?: string | null } | null, totalAmountCents?: { __typename?: 'NumberFieldDifference', oldValue?: number | null, newValue?: number | null } | null, tariff?: { __typename?: 'StringFieldDifference', oldValue?: string | null, newValue?: string | null } | null, fuelCost?: { __typename?: 'SnapshotFuelCostDifferences', billingMethod?: { __typename?: 'StringFieldDifference', oldValue?: string | null, newValue?: string | null } | null, totalAmountCents?: { __typename?: 'NumberFieldDifference', oldValue?: number | null, newValue?: number | null } | null, type?: { __typename?: 'StringFieldDifference', oldValue?: string | null, newValue?: string | null } | null, surchargeRate?: { __typename?: 'NumberFieldDifference', oldValue?: number | null, newValue?: number | null } | null } | null } | null, customCosts?: Array<{ __typename?: 'SnapshotCustomCostDifferences', wasAdded: boolean, wasDeleted: boolean, name?: { __typename?: 'StringFieldDifference', oldValue?: string | null, newValue?: string | null } | null, totalAmountCents?: { __typename?: 'NumberFieldDifference', oldValue?: number | null, newValue?: number | null } | null }> | null };

export type FreightCostDifferenceFragment = { __typename?: 'SnapshotFreightCostDifferences', billingMethod?: { __typename?: 'StringFieldDifference', oldValue?: string | null, newValue?: string | null } | null, totalAmountCents?: { __typename?: 'NumberFieldDifference', oldValue?: number | null, newValue?: number | null } | null, tariff?: { __typename?: 'StringFieldDifference', oldValue?: string | null, newValue?: string | null } | null, fuelCost?: { __typename?: 'SnapshotFuelCostDifferences', billingMethod?: { __typename?: 'StringFieldDifference', oldValue?: string | null, newValue?: string | null } | null, totalAmountCents?: { __typename?: 'NumberFieldDifference', oldValue?: number | null, newValue?: number | null } | null, type?: { __typename?: 'StringFieldDifference', oldValue?: string | null, newValue?: string | null } | null, surchargeRate?: { __typename?: 'NumberFieldDifference', oldValue?: number | null, newValue?: number | null } | null } | null };

export type FuelCostDifferenceFragment = { __typename?: 'SnapshotFuelCostDifferences', billingMethod?: { __typename?: 'StringFieldDifference', oldValue?: string | null, newValue?: string | null } | null, totalAmountCents?: { __typename?: 'NumberFieldDifference', oldValue?: number | null, newValue?: number | null } | null, type?: { __typename?: 'StringFieldDifference', oldValue?: string | null, newValue?: string | null } | null, surchargeRate?: { __typename?: 'NumberFieldDifference', oldValue?: number | null, newValue?: number | null } | null };

export type CustomCostDifferenceFragment = { __typename?: 'SnapshotCustomCostDifferences', wasAdded: boolean, wasDeleted: boolean, name?: { __typename?: 'StringFieldDifference', oldValue?: string | null, newValue?: string | null } | null, totalAmountCents?: { __typename?: 'NumberFieldDifference', oldValue?: number | null, newValue?: number | null } | null };

export type EmailProcessingHistoryQueryVariables = Exact<{
  findIngestedOutlookEmailsInput: FindIngestedOutlookEmailsInput;
}>;


export type EmailProcessingHistoryQuery = { __typename?: 'Query', ingestedOutlookEmails: { __typename?: 'IngestedOutlookEmailConnection', edges: Array<{ __typename?: 'IngestedOutlookEmailEdge', node: { __typename?: 'IngestedOutlookEmailEntity', uuid: string, createdAt: any, subject?: string | null, effectiveSenderAddress: string, outlookReceivedDateTime: any } }>, pageInfo: { __typename?: 'PageInfo', startCursor?: string | null, endCursor?: string | null, hasNextPage: boolean, hasPreviousPage: boolean } } };

export type IngestedEmailOrderByOrderUuidQueryVariables = Exact<{
  uuid: Scalars['String']['input'];
}>;


export type IngestedEmailOrderByOrderUuidQuery = { __typename?: 'Query', scannedOrderResultByOrderUuid?: { __typename?: 'ScannedOrderResultEntity', uuid: string, scannedOrder: { __typename?: 'ScannedOrderEntity', ingestedOutlookEmailDetails: { __typename?: 'IngestedEmailDetailsEntity', attachmentUuid?: string | null, fromAddress?: string | null, subject?: string | null } } } | null };

export type IngestedEmailOrdersQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  searchText?: InputMaybe<Scalars['String']['input']>;
  contactUuid?: InputMaybe<Scalars['String']['input']>;
  originTerminalUuid?: InputMaybe<Scalars['String']['input']>;
  destinationTerminalUuid?: InputMaybe<Scalars['String']['input']>;
  emailIntegrationTerminalUuid?: InputMaybe<Scalars['String']['input']>;
}>;


export type IngestedEmailOrdersQuery = { __typename?: 'Query', numberOfScannedOrderResultsInReview: number, numberOfScannedOrderResultDuplicates: number, scannedOrderResults: { __typename?: 'ScannedOrderResultConnection', edges: Array<{ __typename?: 'ScannedOrderResultEdge', node: { __typename?: 'ScannedOrderResultEntity', uuid: string, createdAt: any, status: ScannedOrderResultStatus, signedPodMatchStatus?: SignedPodMatchStatus | null, failureReason?: ScannedOrderFailureReason | null, filename: string, pageEnd: number, pageStart: number, duplicateOrder?: { __typename?: 'StandardOrderEntity', uuid: string, source: OrderSource } | null, duplicateScannedOrderResultOrder?: { __typename?: 'StandardOrderEntity', uuid: string, source: OrderSource } | null, order?: { __typename?: 'StandardOrderEntity', uuid: string, name: string, source: OrderSource, billingPartyContact: { __typename?: 'CustomerContactEntity', uuid: string, displayName: string }, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', shipperBillOfLadingNumber?: string | null } } | null, scannedOrder: { __typename?: 'ScannedOrderEntity', ingestedOutlookEmailDetails: { __typename?: 'IngestedEmailDetailsEntity', attachmentUuid?: string | null, fromAddress?: string | null, subject?: string | null, outlookIntegrationTerminal?: { __typename?: 'TerminalEntity', uuid: string, code: string } | null } } } }>, pageInfo: { __typename?: 'PageInfo', startCursor?: string | null, endCursor?: string | null, hasNextPage: boolean, hasPreviousPage: boolean } } };

export type IngestedOutlookEmailQueryVariables = Exact<{
  uuid: Scalars['String']['input'];
}>;


export type IngestedOutlookEmailQuery = { __typename?: 'Query', ingestedOutlookEmail: { __typename?: 'IngestedOutlookEmailEntity', uuid: string, subject?: string | null, attachments: Array<{ __typename?: 'IngestedOutlookEmailAttachmentEntity', uuid: string, attachmentFilename?: string | null, processingStatus: IngestedOutlookEmailAttachmentProcessingStatus, scannedOrder?: { __typename?: 'ScannedOrderEntity', uuid: string, preSignedGetUrl: string, scannedOrderResults: Array<{ __typename?: 'ScannedOrderResultEntity', uuid: string, filename: string, pageStart: number, pageEnd: number, status: ScannedOrderResultStatus, failureReason?: ScannedOrderFailureReason | null, order?: { __typename?: 'StandardOrderEntity', uuid: string } | null, duplicateOrder?: { __typename?: 'StandardOrderEntity', uuid: string, source: OrderSource } | null, duplicateScannedOrderResultOrder?: { __typename?: 'StandardOrderEntity', uuid: string, source: OrderSource } | null, scannedOrderResultDocuments: Array<{ __typename?: 'ScannedOrderResultDocumentEntity', uuid: string, preSignedGetUrl: string, scannedOrderResultDocumentPages: Array<{ __typename?: 'ScannedOrderResultDocumentPageEntity', uuid: string, page: number }> }> }> } | null }> } };

export type OutlookIntegrationsQueryVariables = Exact<{
  getOutlookIntegrationsInput: GetOutlookIntegrationsInput;
}>;


export type OutlookIntegrationsQuery = { __typename?: 'Query', outlookIntegrations: Array<{ __typename?: 'OutlookIntegrationEntity', uuid: string, terminal?: { __typename?: 'TerminalEntity', uuid: string, code: string } | null }> };

export type AcceptCustomerPortalOrderMutationVariables = Exact<{
  acceptCustomerPortalOrderInput: AcceptCustomerPortalOrderInput;
}>;


export type AcceptCustomerPortalOrderMutation = { __typename?: 'Mutation', acceptCustomerPortalOrder: { __typename?: 'AcceptCustomerPortalOrderSuccessOutput', orderUuid: string, acceptedAt: any } | { __typename?: 'MutationErrorOutput', message: string } };

export type RejectCustomerPortalOrderMutationVariables = Exact<{
  rejectCustomerPortalOrderInput: RejectCustomerPortalOrderInput;
}>;


export type RejectCustomerPortalOrderMutation = { __typename?: 'Mutation', rejectCustomerPortalOrder: { __typename?: 'MutationErrorOutput', message: string } | { __typename?: 'RejectCustomerPortalOrderSuccessOutput', orderUuid: string, rejectedAt: any } };

export type AcceptEdiOrApiOrderMutationVariables = Exact<{
  acceptEdiOrApiOrderInput: AcceptEdiOrApiOrderInput;
}>;


export type AcceptEdiOrApiOrderMutation = { __typename?: 'Mutation', acceptEdiOrApiOrder: { __typename?: 'AcceptEdiOrApiOrderOutput', uuid: string } };

export type RejectEdiOrderMutationVariables = Exact<{
  rejectEdiOrderInput: RejectEdiOrderInput;
}>;


export type RejectEdiOrderMutation = { __typename?: 'Mutation', rejectEdiOrder: { __typename?: 'RejectEdiOrderOutput', uuid: string } };

export type AccessorialForCustomChargeRowQueryVariables = Exact<{
  uuid: Scalars['String']['input'];
}>;


export type AccessorialForCustomChargeRowQuery = { __typename?: 'Query', accessorial: { __typename?: 'SkidBasedAccessorialEntity', uuid: string, isArchived?: boolean | null, name: string } | { __typename?: 'SpecialAccessorialEntity', uuid: string, isArchived?: boolean | null, name: string } | { __typename?: 'StandardAccessorialEntity', uuid: string, isArchived?: boolean | null, name: string } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string, isArchived?: boolean | null, name: string } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string, isArchived?: boolean | null, name: string } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string, isArchived?: boolean | null, name: string } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string, isArchived?: boolean | null, name: string } };

export type AccessorialsForCustomChargeRowQueryVariables = Exact<{
  billingPartyContactUuid: Scalars['String']['input'];
  terminalUuid?: InputMaybe<Scalars['String']['input']>;
}>;


export type AccessorialsForCustomChargeRowQuery = { __typename?: 'Query', accessorialsByBillingContact: Array<{ __typename?: 'SkidBasedAccessorialEntity', uuid: string, name: string, enableQuickAdd: boolean } | { __typename?: 'SpecialAccessorialEntity', uuid: string, name: string, enableQuickAdd: boolean } | { __typename?: 'StandardAccessorialEntity', uuid: string, name: string, enableQuickAdd: boolean } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string, name: string, enableQuickAdd: boolean } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string, name: string, enableQuickAdd: boolean } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string, name: string, enableQuickAdd: boolean } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string, name: string, enableQuickAdd: boolean }> };

export type PiecesGroupedByStatusQueryVariables = Exact<{
  piecesGroupedByStatusInput: PiecesGroupedByStatusInput;
}>;


export type PiecesGroupedByStatusQuery = { __typename?: 'Query', piecesGroupedByStatus: { __typename?: 'PiecesGroupedByStatusOutput', pieceGroups: Array<{ __typename?: 'PieceGroupEntity', status: PieceStatus, pieceCount: number, terminal?: { __typename?: 'TerminalEntity', code: string } | null }> } };

export type SendStopToAgentMutationVariables = Exact<{
  sendStopToAgentInput: SendStopToAgentInput;
}>;


export type SendStopToAgentMutation = { __typename?: 'Mutation', sendStopToAgent: { __typename?: 'MutationErrorOutput', message: string } | { __typename?: 'SendStopToAgentSuccessOutput', stop: { __typename?: 'StandardStopEntity', uuid: string } } };

export type UpdatePieceCountMutationVariables = Exact<{
  updatePieceCountInput: UpdatePieceCountInput;
}>;


export type UpdatePieceCountMutation = { __typename?: 'Mutation', updatePieceCount: { __typename?: 'StandardOrderEntity', uuid: string } };

export type VehicleTypeCapacityQueryVariables = Exact<{
  vehicleTypeUuid: Scalars['String']['input'];
}>;


export type VehicleTypeCapacityQuery = { __typename?: 'Query', vehicleType: { __typename?: 'VehicleTypeEntity', uuid: string, capacityNotes?: string | null, maxWeight?: any | null, maxVolume?: any | null, vehicleTypePackageSpecs: Array<{ __typename?: 'VehicleTypePackageSpecEntity', id: string, maxQuantity?: number | null, packageSpec: { __typename?: 'PackageSpecEntity', id: string, name: string } }> } };

export type StopForUnifiedSearchFragment = { __typename?: 'StandardStopEntity', completedAt?: any | null, routeSlot?: { __typename?: 'RouteSlotEntity', route?: { __typename?: 'RouteEntity', name: string, date: any } | null } | null };

export type UnifiedSearchOrdersQueryVariables = Exact<{
  unifiedSearchInput: UnifiedSearchInput;
}>;


export type UnifiedSearchOrdersQuery = { __typename?: 'Query', unifiedSearchOrders: { __typename?: 'OrderConnection', totalCount?: number | null, edges: Array<{ __typename?: 'OrderEdge', node: { __typename?: 'StandardOrderEntity', uuid: string, name: string, source: OrderSource, billingPartyContact: { __typename?: 'CustomerContactEntity', displayName: string }, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', shipperBillOfLadingNumber?: string | null, masterAirwayBillOfLadingNumber?: string | null }, startStop?: { __typename?: 'StandardStopEntity', completedAt?: any | null, routeSlot?: { __typename?: 'RouteSlotEntity', route?: { __typename?: 'RouteEntity', name: string, date: any } | null } | null } | null, endStop?: { __typename?: 'StandardStopEntity', completedAt?: any | null, routeSlot?: { __typename?: 'RouteSlotEntity', route?: { __typename?: 'RouteEntity', name: string, date: any } | null } | null } | null } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } };

export type UnifiedSearchOrdersFragment = { __typename?: 'OrderConnection', totalCount?: number | null, edges: Array<{ __typename?: 'OrderEdge', node: { __typename?: 'StandardOrderEntity', uuid: string, name: string, source: OrderSource, billingPartyContact: { __typename?: 'CustomerContactEntity', displayName: string }, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', shipperBillOfLadingNumber?: string | null, masterAirwayBillOfLadingNumber?: string | null }, startStop?: { __typename?: 'StandardStopEntity', completedAt?: any | null, routeSlot?: { __typename?: 'RouteSlotEntity', route?: { __typename?: 'RouteEntity', name: string, date: any } | null } | null } | null, endStop?: { __typename?: 'StandardStopEntity', completedAt?: any | null, routeSlot?: { __typename?: 'RouteSlotEntity', route?: { __typename?: 'RouteEntity', name: string, date: any } | null } | null } | null } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } };

export type UnifiedSearchUnacceptedEmailOrdersQueryVariables = Exact<{
  unifiedSearchInput: UnifiedSearchInput;
}>;


export type UnifiedSearchUnacceptedEmailOrdersQuery = { __typename?: 'Query', unifiedSearchUnacceptedEmailOrders: { __typename?: 'ScannedOrderResultConnection', totalCount?: number | null, edges: Array<{ __typename?: 'ScannedOrderResultEdge', node: { __typename?: 'ScannedOrderResultEntity', uuid: string, order?: { __typename?: 'StandardOrderEntity', uuid: string, name: string, billingPartyContact: { __typename?: 'CustomerContactEntity', uuid: string, displayName: string }, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', shipperBillOfLadingNumber?: string | null, masterAirwayBillOfLadingNumber?: string | null } } | null, scannedOrder: { __typename?: 'ScannedOrderEntity', ingestedOutlookEmailDetails: { __typename?: 'IngestedEmailDetailsEntity', fromAddress?: string | null, subject?: string | null, receivedAt?: any | null } } } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } };

export type UnifiedSearchUnacceptedEmailOrdersFragment = { __typename?: 'ScannedOrderResultConnection', totalCount?: number | null, edges: Array<{ __typename?: 'ScannedOrderResultEdge', node: { __typename?: 'ScannedOrderResultEntity', uuid: string, order?: { __typename?: 'StandardOrderEntity', uuid: string, name: string, billingPartyContact: { __typename?: 'CustomerContactEntity', uuid: string, displayName: string }, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', shipperBillOfLadingNumber?: string | null, masterAirwayBillOfLadingNumber?: string | null } } | null, scannedOrder: { __typename?: 'ScannedOrderEntity', ingestedOutlookEmailDetails: { __typename?: 'IngestedEmailDetailsEntity', fromAddress?: string | null, subject?: string | null, receivedAt?: any | null } } } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } };

export type UnifiedSearchUnacceptedEdiAndApiOrdersQueryVariables = Exact<{
  unifiedSearchInput: UnifiedSearchInput;
}>;


export type UnifiedSearchUnacceptedEdiAndApiOrdersQuery = { __typename?: 'Query', unifiedSearchUnacceptedEdiAndApiOrders: { __typename?: 'OrderConnection', totalCount?: number | null, edges: Array<{ __typename?: 'OrderEdge', node: { __typename?: 'StandardOrderEntity', uuid: string, name: string, billingPartyContact: { __typename?: 'CustomerContactEntity', uuid: string, displayName: string }, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', shipperBillOfLadingNumber?: string | null, masterAirwayBillOfLadingNumber?: string | null } } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } };

export type UnifiedSearchUnacceptedEdiAndApiOrdersFragment = { __typename?: 'OrderConnection', totalCount?: number | null, edges: Array<{ __typename?: 'OrderEdge', node: { __typename?: 'StandardOrderEntity', uuid: string, name: string, billingPartyContact: { __typename?: 'CustomerContactEntity', uuid: string, displayName: string }, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', shipperBillOfLadingNumber?: string | null, masterAirwayBillOfLadingNumber?: string | null } } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } };

export type UnifiedSearchQuotesQueryVariables = Exact<{
  unifiedSearchInput: UnifiedSearchInput;
}>;


export type UnifiedSearchQuotesQuery = { __typename?: 'Query', unifiedSearchQuotes: { __typename?: 'QuoteConnection', totalCount?: number | null, edges: Array<{ __typename?: 'QuoteEdge', node: { __typename?: 'QuoteEntity', uuid: string, number: string, billingPartyContact: { __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string } } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } };

export type UnifiedSearchQuotesFragment = { __typename?: 'QuoteConnection', totalCount?: number | null, edges: Array<{ __typename?: 'QuoteEdge', node: { __typename?: 'QuoteEntity', uuid: string, number: string, billingPartyContact: { __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string } } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } };

export type UnifiedSearchInvoicesQueryVariables = Exact<{
  unifiedSearchInput: UnifiedSearchInput;
}>;


export type UnifiedSearchInvoicesQuery = { __typename?: 'Query', unifiedSearchInvoices: { __typename?: 'InvoiceConnection', totalCount?: number | null, edges: Array<{ __typename?: 'InvoiceEdge', node: { __typename?: 'InvoiceEntity', uuid: string, date: any, name: string, journalNumber: number, balanceInCents: number, balanceInDollars: number, invoiceTotal: string, billToContact: { __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string } } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } };

export type UnifiedSearchInvoicesFragment = { __typename?: 'InvoiceConnection', totalCount?: number | null, edges: Array<{ __typename?: 'InvoiceEdge', node: { __typename?: 'InvoiceEntity', uuid: string, date: any, name: string, journalNumber: number, balanceInCents: number, balanceInDollars: number, invoiceTotal: string, billToContact: { __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string } } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } };

export type CreateInvoiceDocumentMutationVariables = Exact<{
  createInvoiceDocumentInput: CreateInvoiceDocumentInput;
}>;


export type CreateInvoiceDocumentMutation = { __typename?: 'Mutation', createInvoiceDocument: { __typename?: 'DocumentEntity', uuid: string, bucket: string, region: string, key: string, fileName: string, fileType: string, type: DocumentType } };

export type CreateOrderDocumentMutationVariables = Exact<{
  createOrderDocumentInput: CreateOrderDocumentInput;
}>;


export type CreateOrderDocumentMutation = { __typename?: 'Mutation', createOrderDocument: { __typename?: 'DocumentEntity', uuid: string, bucket: string, region: string, key: string, fileName: string, fileType: string, type: DocumentType } };

export type ApiLogFragment = { __typename?: 'ApiLogEntity', uuid: string, createdAt: any, updatedAt: any, responseStatus?: ApiResponseStatus | null, sourceIpAddress?: string | null, direction: ApiRequestDirection, freightSnapTransaction?: { __typename?: 'FreightSnapTransactionEntity', uuid: string, status?: FreightSnapTransactionStatus | null, failureReason?: FreightSnapFailureReason | null, proNum?: string | null, ehdim?: string | null, eldim?: string | null, ewdim?: string | null, weight?: string | null, imgs: Array<string>, order?: { __typename?: 'StandardOrderEntity', uuid: string, name: string } | null } | null, emailTransaction?: { __typename?: 'EmailTransactionEntity', emailTransactionStatus: EmailTransactionStatus, emailResponseStatus?: number | null, failureReason?: string | null, company: { __typename?: 'CompanyEntity', uuid: string, name: string }, contact: { __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string }, document: { __typename?: 'DocumentEntity', uuid: string, preSignedGetUrl: string }, invoice?: { __typename?: 'InvoiceEntity', uuid: string, name: string, journalNumber: number } | null, emailTransactionLogs: Array<{ __typename?: 'EmailTransactionLogEntity', uuid: string, email: string, lastStatus?: EmailTransactionLogStatus | null, reason?: string | null }> } | null };

export type ApiLogsQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  createdAtDateFilters?: InputMaybe<Array<DateFilter> | DateFilter>;
  sortByCreatedAtDateAsc?: InputMaybe<Scalars['Boolean']['input']>;
  isInvoiceEmails: Scalars['Boolean']['input'];
  invoiceUuid?: InputMaybe<Scalars['String']['input']>;
  emailTransactionStatus?: InputMaybe<EmailTransactionStatus>;
  isFreightSnap: Scalars['Boolean']['input'];
  freightSnapTransactionStatus?: InputMaybe<FreightSnapTransactionStatus>;
  freightSnapFailureReason?: InputMaybe<FreightSnapFailureReason>;
  searchText?: InputMaybe<Scalars['String']['input']>;
}>;


export type ApiLogsQuery = { __typename?: 'Query', apiLogs: { __typename?: 'ApiLogConnection', totalCount: number, edges: Array<{ __typename?: 'ApiLogEdge', node: { __typename?: 'ApiLogEntity', uuid: string, createdAt: any, updatedAt: any, responseStatus?: ApiResponseStatus | null, sourceIpAddress?: string | null, direction: ApiRequestDirection, freightSnapTransaction?: { __typename?: 'FreightSnapTransactionEntity', uuid: string, status?: FreightSnapTransactionStatus | null, failureReason?: FreightSnapFailureReason | null, proNum?: string | null, ehdim?: string | null, eldim?: string | null, ewdim?: string | null, weight?: string | null, imgs: Array<string>, order?: { __typename?: 'StandardOrderEntity', uuid: string, name: string } | null } | null, emailTransaction?: { __typename?: 'EmailTransactionEntity', emailTransactionStatus: EmailTransactionStatus, emailResponseStatus?: number | null, failureReason?: string | null, company: { __typename?: 'CompanyEntity', uuid: string, name: string }, contact: { __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string }, document: { __typename?: 'DocumentEntity', uuid: string, preSignedGetUrl: string }, invoice?: { __typename?: 'InvoiceEntity', uuid: string, name: string, journalNumber: number } | null, emailTransactionLogs: Array<{ __typename?: 'EmailTransactionLogEntity', uuid: string, email: string, lastStatus?: EmailTransactionLogStatus | null, reason?: string | null }> } | null } }>, pageInfo: { __typename?: 'PageInfo', startCursor?: string | null, endCursor?: string | null, hasNextPage: boolean, hasPreviousPage: boolean } } };

export type EmailTransactionFragment = { __typename?: 'EmailTransactionEntity', emailTransactionStatus: EmailTransactionStatus, emailResponseStatus?: number | null, failureReason?: string | null, company: { __typename?: 'CompanyEntity', uuid: string, name: string }, contact: { __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string }, document: { __typename?: 'DocumentEntity', uuid: string, preSignedGetUrl: string }, invoice?: { __typename?: 'InvoiceEntity', uuid: string, name: string, journalNumber: number } | null, emailTransactionLogs: Array<{ __typename?: 'EmailTransactionLogEntity', uuid: string, email: string, lastStatus?: EmailTransactionLogStatus | null, reason?: string | null }> };

export type FreightSnapTransactionFragment = { __typename?: 'FreightSnapTransactionEntity', uuid: string, status?: FreightSnapTransactionStatus | null, failureReason?: FreightSnapFailureReason | null, proNum?: string | null, ehdim?: string | null, eldim?: string | null, ewdim?: string | null, weight?: string | null, imgs: Array<string>, order?: { __typename?: 'StandardOrderEntity', uuid: string, name: string } | null };

export type MatchFreightSnapMutationVariables = Exact<{
  freightSnapCreateInput: FreightSnapCreateInput;
}>;


export type MatchFreightSnapMutation = { __typename?: 'Mutation', matchFreightSnap?: { __typename?: 'FreightSnapTransactionEntity', uuid: string, status?: FreightSnapTransactionStatus | null, failureReason?: FreightSnapFailureReason | null, proNum?: string | null, ehdim?: string | null, eldim?: string | null, ewdim?: string | null, weight?: string | null, imgs: Array<string>, order?: { __typename?: 'StandardOrderEntity', uuid: string, name: string } | null } | null };

export type ShipmentForArrivalNoticeFragment = { __typename?: 'StandardShipmentEntity', totalFreightChargesAmount: number, totalFuelChargesAmount: number, totalChargesAmount: number, shipmentType: ShipmentType, hideFromBilling: boolean, standardShipmentFields: { __typename?: 'StandardShipmentFieldsEntity', pickupOrDelivery: PickupOrDelivery }, legs: Array<{ __typename?: 'LegEntity', endStop: { __typename?: 'StandardStopEntity', stopType?: StopType | null, inboundMethod?: InboundMethod | null, outboundMethod?: OutboundMethod | null, address: { __typename?: 'AddressEntity', uuid: string, name: string, line1: string, line2?: string | null, city: string, state: string, zip: string, country: string, latitude?: number | null, longitude?: number | null, driverInstructions?: string | null, receivingHoursStart?: any | null, receivingHoursEnd?: any | null, specialInstructions?: string | null }, terminal?: { __typename?: 'TerminalEntity', code: string, address: { __typename?: 'AddressEntity', uuid: string, name: string, line1: string, line2?: string | null, city: string, state: string, zip: string, country: string, latitude?: number | null, longitude?: number | null, driverInstructions?: string | null, receivingHoursStart?: any | null, receivingHoursEnd?: any | null, specialInstructions?: string | null } } | null, contactPerson?: { __typename?: 'ContactPersonEntity', phone?: string | null, email?: string | null, firstName?: string | null, lastName?: string | null } | null } }>, customCharges: Array<{ __typename?: 'CustomChargeEntity', uuid: string, name: string, total: number, accessorialTemplate?: { __typename: 'SkidBasedAccessorialEntity', uuid: string, name: string } | { __typename: 'SpecialAccessorialEntity', uuid: string, name: string } | { __typename: 'StandardAccessorialEntity', uuid: string, name: string } | { __typename: 'UnitBasedAccessorialEntity', uuid: string, name: string } | { __typename: 'WaitTimeAccessorialEntity', uuid: string, name: string } | { __typename: 'WeightBasedAccessorialEntity', uuid: string, name: string } | { __typename: 'ZoneBasedAccessorialEntity', uuid: string, name: string } | null }>, charges: Array<{ __typename?: 'CustomChargeEntity' } | { __typename?: 'FreightChargeEntity', uuid: string, billingMethod: FreightBillingMethod, rate: number, description?: string | null, quantity: number, fuelCharge?: { __typename?: 'FuelChargeEntity', description?: string | null, surchargeRate: number, flatRate: number, type: FuelBillingMethod, uuid: string } | null }> };

export type PackageForArrivalNoticeFragment = { __typename?: 'PackageEntity', description: string, weight?: number | null, quantity: number, length?: number | null, width?: number | null, height?: number | null, type?: PackageType | null };

export type OrderForArrivalNoticeFragment = { __typename?: 'StandardOrderEntity', uuid: string, itTeNumber?: string | null, externalNotes?: string | null, hazmat?: boolean | null, unNumber?: string | null, hazmatDescription?: string | null, emergencyResponseNumber?: string | null, requiresPlacard?: boolean | null, hazmatClass?: HazmatClass | null, packageGroup?: PackageGroup | null, isCrossDock?: boolean | null, totalCharge: number, name: string, billingPartyContact: { __typename?: 'CustomerContactEntity', displayName: string }, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', shipperBillOfLadingNumber?: string | null, masterAirwayBillOfLadingNumber?: string | null }, thirdPartyBrokers: Array<{ __typename?: 'ThirdPartyBrokerEntity', name: string }>, service?: { __typename?: 'ServiceEntity', name: string } | null, company: { __typename?: 'CompanyEntity', name: string, phone?: string | null, defaultAddress?: { __typename?: 'AddressEntity', uuid: string, name: string, line1: string, line2?: string | null, city: string, state: string, zip: string, country: string, latitude?: number | null, longitude?: number | null, driverInstructions?: string | null, receivingHoursStart?: any | null, receivingHoursEnd?: any | null, specialInstructions?: string | null } | null }, packages: Array<{ __typename?: 'PackageEntity', description: string, weight?: number | null, quantity: number, length?: number | null, width?: number | null, height?: number | null, type?: PackageType | null }>, shipments: Array<{ __typename?: 'StandardShipmentEntity', totalFreightChargesAmount: number, totalFuelChargesAmount: number, totalChargesAmount: number, shipmentType: ShipmentType, hideFromBilling: boolean, standardShipmentFields: { __typename?: 'StandardShipmentFieldsEntity', pickupOrDelivery: PickupOrDelivery }, legs: Array<{ __typename?: 'LegEntity', endStop: { __typename?: 'StandardStopEntity', stopType?: StopType | null, inboundMethod?: InboundMethod | null, outboundMethod?: OutboundMethod | null, address: { __typename?: 'AddressEntity', uuid: string, name: string, line1: string, line2?: string | null, city: string, state: string, zip: string, country: string, latitude?: number | null, longitude?: number | null, driverInstructions?: string | null, receivingHoursStart?: any | null, receivingHoursEnd?: any | null, specialInstructions?: string | null }, terminal?: { __typename?: 'TerminalEntity', code: string, address: { __typename?: 'AddressEntity', uuid: string, name: string, line1: string, line2?: string | null, city: string, state: string, zip: string, country: string, latitude?: number | null, longitude?: number | null, driverInstructions?: string | null, receivingHoursStart?: any | null, receivingHoursEnd?: any | null, specialInstructions?: string | null } } | null, contactPerson?: { __typename?: 'ContactPersonEntity', phone?: string | null, email?: string | null, firstName?: string | null, lastName?: string | null } | null } }>, customCharges: Array<{ __typename?: 'CustomChargeEntity', uuid: string, name: string, total: number, accessorialTemplate?: { __typename: 'SkidBasedAccessorialEntity', uuid: string, name: string } | { __typename: 'SpecialAccessorialEntity', uuid: string, name: string } | { __typename: 'StandardAccessorialEntity', uuid: string, name: string } | { __typename: 'UnitBasedAccessorialEntity', uuid: string, name: string } | { __typename: 'WaitTimeAccessorialEntity', uuid: string, name: string } | { __typename: 'WeightBasedAccessorialEntity', uuid: string, name: string } | { __typename: 'ZoneBasedAccessorialEntity', uuid: string, name: string } | null }>, charges: Array<{ __typename?: 'CustomChargeEntity' } | { __typename?: 'FreightChargeEntity', uuid: string, billingMethod: FreightBillingMethod, rate: number, description?: string | null, quantity: number, fuelCharge?: { __typename?: 'FuelChargeEntity', description?: string | null, surchargeRate: number, flatRate: number, type: FuelBillingMethod, uuid: string } | null }> }> };

export type OrdersForArrivalNoticesQueryVariables = Exact<{
  uuids: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type OrdersForArrivalNoticesQuery = { __typename?: 'Query', ordersByUuids: Array<{ __typename?: 'StandardOrderEntity', uuid: string, itTeNumber?: string | null, externalNotes?: string | null, hazmat?: boolean | null, unNumber?: string | null, hazmatDescription?: string | null, emergencyResponseNumber?: string | null, requiresPlacard?: boolean | null, hazmatClass?: HazmatClass | null, packageGroup?: PackageGroup | null, isCrossDock?: boolean | null, totalCharge: number, name: string, billingPartyContact: { __typename?: 'CustomerContactEntity', displayName: string }, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', shipperBillOfLadingNumber?: string | null, masterAirwayBillOfLadingNumber?: string | null }, thirdPartyBrokers: Array<{ __typename?: 'ThirdPartyBrokerEntity', name: string }>, service?: { __typename?: 'ServiceEntity', name: string } | null, company: { __typename?: 'CompanyEntity', name: string, phone?: string | null, defaultAddress?: { __typename?: 'AddressEntity', uuid: string, name: string, line1: string, line2?: string | null, city: string, state: string, zip: string, country: string, latitude?: number | null, longitude?: number | null, driverInstructions?: string | null, receivingHoursStart?: any | null, receivingHoursEnd?: any | null, specialInstructions?: string | null } | null }, packages: Array<{ __typename?: 'PackageEntity', description: string, weight?: number | null, quantity: number, length?: number | null, width?: number | null, height?: number | null, type?: PackageType | null }>, shipments: Array<{ __typename?: 'StandardShipmentEntity', totalFreightChargesAmount: number, totalFuelChargesAmount: number, totalChargesAmount: number, shipmentType: ShipmentType, hideFromBilling: boolean, standardShipmentFields: { __typename?: 'StandardShipmentFieldsEntity', pickupOrDelivery: PickupOrDelivery }, legs: Array<{ __typename?: 'LegEntity', endStop: { __typename?: 'StandardStopEntity', stopType?: StopType | null, inboundMethod?: InboundMethod | null, outboundMethod?: OutboundMethod | null, address: { __typename?: 'AddressEntity', uuid: string, name: string, line1: string, line2?: string | null, city: string, state: string, zip: string, country: string, latitude?: number | null, longitude?: number | null, driverInstructions?: string | null, receivingHoursStart?: any | null, receivingHoursEnd?: any | null, specialInstructions?: string | null }, terminal?: { __typename?: 'TerminalEntity', code: string, address: { __typename?: 'AddressEntity', uuid: string, name: string, line1: string, line2?: string | null, city: string, state: string, zip: string, country: string, latitude?: number | null, longitude?: number | null, driverInstructions?: string | null, receivingHoursStart?: any | null, receivingHoursEnd?: any | null, specialInstructions?: string | null } } | null, contactPerson?: { __typename?: 'ContactPersonEntity', phone?: string | null, email?: string | null, firstName?: string | null, lastName?: string | null } | null } }>, customCharges: Array<{ __typename?: 'CustomChargeEntity', uuid: string, name: string, total: number, accessorialTemplate?: { __typename: 'SkidBasedAccessorialEntity', uuid: string, name: string } | { __typename: 'SpecialAccessorialEntity', uuid: string, name: string } | { __typename: 'StandardAccessorialEntity', uuid: string, name: string } | { __typename: 'UnitBasedAccessorialEntity', uuid: string, name: string } | { __typename: 'WaitTimeAccessorialEntity', uuid: string, name: string } | { __typename: 'WeightBasedAccessorialEntity', uuid: string, name: string } | { __typename: 'ZoneBasedAccessorialEntity', uuid: string, name: string } | null }>, charges: Array<{ __typename?: 'CustomChargeEntity' } | { __typename?: 'FreightChargeEntity', uuid: string, billingMethod: FreightBillingMethod, rate: number, description?: string | null, quantity: number, fuelCharge?: { __typename?: 'FuelChargeEntity', description?: string | null, surchargeRate: number, flatRate: number, type: FuelBillingMethod, uuid: string } | null }> }> }> };

export type ArriveAtStopsMutationVariables = Exact<{
  arriveAtStopsInput: ArriveAtStopsInput;
}>;


export type ArriveAtStopsMutation = { __typename?: 'Mutation', arriveAtStops: { __typename?: 'ArriveAtStopsSuccessOutput', arrivedStopUuids: Array<string>, failedStopUuids: Array<string> } | { __typename?: 'MutationErrorOutput', message: string } };

export type AttemptStopsForDriverSettlementQueryVariables = Exact<{
  uuid: Scalars['String']['input'];
}>;


export type AttemptStopsForDriverSettlementQuery = { __typename?: 'Query', leg?: { __typename?: 'LegEntity', previousStopAttempts: Array<{ __typename?: 'StandardStopEntity', uuid: string, settlementDeductionName?: string | null, settlementDeductionFlatRate?: number | null, settlementDeductionPercentageRate?: number | null, stopDriverMaps: Array<{ __typename?: 'StopDriverMapEntity', uuid: string, name?: string | null, enableDriverSettlement?: boolean | null, revenuePercentageRate?: number | null, revenueFlatRate?: number | null, driverPayoutFinalized: boolean, driver: { __typename?: 'DriverEntity', firstName: string, lastName: string, uuid: string, driverType?: DriverType | null, driverReferenceNumber?: string | null, defaultFuelSettlementPercentageRate?: number | null, user: { __typename?: 'UserEntity', name?: string | null }, defaultVehicle?: { __typename?: 'EquipmentEntity', uuid: string } | null, terminal?: { __typename?: 'TerminalEntity', uuid: string, name: string } | null, qualifications: Array<{ __typename?: 'DriverQualificationEntity', id: string }> }, driverSettlementBill?: { __typename?: 'DriverSettlementBillEntity', uuid: string } | null, stop: { __typename?: 'StandardStopEntity', uuid: string, completedAt?: any | null, settlementDeductionName?: string | null, settlementDeductionFlatRate?: number | null, settlementDeductionPercentageRate?: number | null } }> }> } | null };

export type BulkEditOrdersMutationVariables = Exact<{
  bulkEditOrdersInput: BulkEditOrdersInput;
}>;


export type BulkEditOrdersMutation = { __typename?: 'Mutation', bulkEditOrders: string };

export type CoverSheetDocumentTypeSequenceFragment = { __typename?: 'CoverSheetDocumentTypeSequenceEntity', uuid: string, name: string, type: CoverSheetDocumentTypeSequenceType, documentTypes: Array<DocumentType> };

export type CoverSheetDocumentTypeSequencesQueryVariables = Exact<{ [key: string]: never; }>;


export type CoverSheetDocumentTypeSequencesQuery = { __typename?: 'Query', coverSheetDocumentTypeSequences: Array<{ __typename?: 'CoverSheetDocumentTypeSequenceEntity', uuid: string, name: string, type: CoverSheetDocumentTypeSequenceType, documentTypes: Array<DocumentType> }> };

export type CreateCoverSheetDocumentTypeSequenceMutationVariables = Exact<{
  input: CoverSheetDocumentTypeSequenceCreateInput;
}>;


export type CreateCoverSheetDocumentTypeSequenceMutation = { __typename?: 'Mutation', createCoverSheetDocumentTypeSequence: { __typename?: 'CoverSheetDocumentTypeSequenceEntity', uuid: string } };

export type OrderCoverSheetShipmentFragment = { __typename?: 'StandardShipmentEntity', uuid: string, ordinal: number, standardShipmentFields: { __typename?: 'StandardShipmentFieldsEntity', deadlineDate?: any | null, pickupOrDelivery: PickupOrDelivery }, packages: Array<{ __typename?: 'PackageEntity', description: string, weight?: number | null, quantity: number, length?: number | null, width?: number | null, height?: number | null }>, legs: Array<{ __typename?: 'LegEntity', endStop: { __typename?: 'StandardStopEntity', stopType?: StopType | null, status: StopStatus, appointmentTime?: any | null, endAppointmentTime?: any | null, completedAt?: any | null, specialInstructions?: string | null, address: { __typename?: 'AddressEntity', uuid: string, name: string, line1: string, line2?: string | null, city: string, state: string, zip: string, country: string, latitude?: number | null, longitude?: number | null, driverInstructions?: string | null, receivingHoursStart?: any | null, receivingHoursEnd?: any | null, specialInstructions?: string | null }, terminal?: { __typename?: 'TerminalEntity', code: string } | null, contactPerson?: { __typename?: 'ContactPersonEntity', phone?: string | null, email?: string | null, firstName?: string | null, lastName?: string | null } | null, routeSlot?: { __typename?: 'RouteSlotEntity', route?: { __typename?: 'RouteEntity', name: string, drivers: Array<{ __typename?: 'DriverEntity', firstName: string, lastName: string }> } | null } | null } }>, order?: { __typename?: 'StandardOrderEntity', uuid: string, name: string, refNumbers: Array<string>, coverSheetDocumentTypeSequence?: { __typename?: 'CoverSheetDocumentTypeSequenceEntity', uuid: string, name: string, type: CoverSheetDocumentTypeSequenceType, documentTypes: Array<DocumentType> } | null, billingPartyContact: { __typename?: 'CustomerContactEntity', uuid: string, displayName: string }, orderEvents: Array<{ __typename?: 'OrderEventEntity', eventType: OrderEventType, sourceType: OrderEventSourceType, createdAt: any, sourceUser?: { __typename?: 'UserEntity', email: string } | null }>, company: { __typename?: 'CompanyEntity', name: string, defaultAddress?: { __typename?: 'AddressEntity', uuid: string, name: string, line1: string, line2?: string | null, city: string, state: string, zip: string, country: string, latitude?: number | null, longitude?: number | null, driverInstructions?: string | null, receivingHoursStart?: any | null, receivingHoursEnd?: any | null, specialInstructions?: string | null } | null }, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', masterAirwayBillOfLadingNumber?: string | null, shipperBillOfLadingNumber?: string | null }, service?: { __typename?: 'ServiceEntity', name: string } | null } | null };

export type OrderCoverSheetsQueryVariables = Exact<{
  getShipmentsInput?: InputMaybe<GetShipmentsInput>;
}>;


export type OrderCoverSheetsQuery = { __typename?: 'Query', shipments: Array<{ __typename?: 'StandardShipmentEntity', uuid: string, ordinal: number, standardShipmentFields: { __typename?: 'StandardShipmentFieldsEntity', deadlineDate?: any | null, pickupOrDelivery: PickupOrDelivery }, packages: Array<{ __typename?: 'PackageEntity', description: string, weight?: number | null, quantity: number, length?: number | null, width?: number | null, height?: number | null }>, legs: Array<{ __typename?: 'LegEntity', endStop: { __typename?: 'StandardStopEntity', stopType?: StopType | null, status: StopStatus, appointmentTime?: any | null, endAppointmentTime?: any | null, completedAt?: any | null, specialInstructions?: string | null, address: { __typename?: 'AddressEntity', uuid: string, name: string, line1: string, line2?: string | null, city: string, state: string, zip: string, country: string, latitude?: number | null, longitude?: number | null, driverInstructions?: string | null, receivingHoursStart?: any | null, receivingHoursEnd?: any | null, specialInstructions?: string | null }, terminal?: { __typename?: 'TerminalEntity', code: string } | null, contactPerson?: { __typename?: 'ContactPersonEntity', phone?: string | null, email?: string | null, firstName?: string | null, lastName?: string | null } | null, routeSlot?: { __typename?: 'RouteSlotEntity', route?: { __typename?: 'RouteEntity', name: string, drivers: Array<{ __typename?: 'DriverEntity', firstName: string, lastName: string }> } | null } | null } }>, order?: { __typename?: 'StandardOrderEntity', uuid: string, name: string, refNumbers: Array<string>, coverSheetDocumentTypeSequence?: { __typename?: 'CoverSheetDocumentTypeSequenceEntity', uuid: string, name: string, type: CoverSheetDocumentTypeSequenceType, documentTypes: Array<DocumentType> } | null, billingPartyContact: { __typename?: 'CustomerContactEntity', uuid: string, displayName: string }, orderEvents: Array<{ __typename?: 'OrderEventEntity', eventType: OrderEventType, sourceType: OrderEventSourceType, createdAt: any, sourceUser?: { __typename?: 'UserEntity', email: string } | null }>, company: { __typename?: 'CompanyEntity', name: string, defaultAddress?: { __typename?: 'AddressEntity', uuid: string, name: string, line1: string, line2?: string | null, city: string, state: string, zip: string, country: string, latitude?: number | null, longitude?: number | null, driverInstructions?: string | null, receivingHoursStart?: any | null, receivingHoursEnd?: any | null, specialInstructions?: string | null } | null }, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', masterAirwayBillOfLadingNumber?: string | null, shipperBillOfLadingNumber?: string | null }, service?: { __typename?: 'ServiceEntity', name: string } | null } | null }> };

export type OrderEventForCoverSheetFragment = { __typename?: 'OrderEventEntity', eventType: OrderEventType, sourceType: OrderEventSourceType, createdAt: any, sourceUser?: { __typename?: 'UserEntity', email: string } | null };

export type ShipmentForCoverSheetFragment = { __typename?: 'StandardShipmentEntity', uuid: string, shipmentType: ShipmentType, ordinal: number, standardShipmentFields: { __typename?: 'StandardShipmentFieldsEntity', deadlineDate?: any | null, pickupOrDelivery: PickupOrDelivery }, packages: Array<{ __typename?: 'PackageEntity', description: string, weight?: number | null, quantity: number, length?: number | null, width?: number | null, height?: number | null }>, legs: Array<{ __typename?: 'LegEntity', endStop: { __typename?: 'StandardStopEntity', stopType?: StopType | null, status: StopStatus, appointmentTime?: any | null, endAppointmentTime?: any | null, completedAt?: any | null, specialInstructions?: string | null, serviceDate?: any | null, inboundMethod?: InboundMethod | null, outboundMethod?: OutboundMethod | null, isSpecial?: boolean | null, serviceDateV2?: { __typename?: 'PlainDate', iso8601: string } | null, address: { __typename?: 'AddressEntity', uuid: string, name: string, line1: string, line2?: string | null, city: string, state: string, zip: string, country: string, latitude?: number | null, longitude?: number | null, driverInstructions?: string | null, receivingHoursStart?: any | null, receivingHoursEnd?: any | null, specialInstructions?: string | null }, contactPerson?: { __typename?: 'ContactPersonEntity', phone?: string | null, email?: string | null, firstName?: string | null, lastName?: string | null } | null, routeSlot?: { __typename?: 'RouteSlotEntity', route?: { __typename?: 'RouteEntity', name: string, drivers: Array<{ __typename?: 'DriverEntity', firstName: string, lastName: string }> } | null } | null, terminal?: { __typename?: 'TerminalEntity', uuid: string, code: string } | null } }> };

export type OrderForCoverSheetFragment = { __typename?: 'StandardOrderEntity', uuid: string, name: string, refNumbers: Array<string>, inBond?: boolean | null, itTeNumber?: string | null, hazmat?: boolean | null, unNumber?: string | null, hazmatDescription?: string | null, emergencyResponseNumber?: string | null, requiresPlacard?: boolean | null, hazmatClass?: HazmatClass | null, packageGroup?: PackageGroup | null, service?: { __typename?: 'ServiceEntity', name: string } | null, coverSheetDocumentTypeSequence?: { __typename?: 'CoverSheetDocumentTypeSequenceEntity', uuid: string, name: string, type: CoverSheetDocumentTypeSequenceType, documentTypes: Array<DocumentType> } | null, billingPartyContact: { __typename?: 'CustomerContactEntity', uuid: string, displayName: string }, orderEvents: Array<{ __typename?: 'OrderEventEntity', eventType: OrderEventType, sourceType: OrderEventSourceType, createdAt: any, sourceUser?: { __typename?: 'UserEntity', email: string } | null }>, company: { __typename?: 'CompanyEntity', name: string, defaultAddress?: { __typename?: 'AddressEntity', uuid: string, name: string, line1: string, line2?: string | null, city: string, state: string, zip: string, country: string, latitude?: number | null, longitude?: number | null, driverInstructions?: string | null, receivingHoursStart?: any | null, receivingHoursEnd?: any | null, specialInstructions?: string | null } | null }, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', masterAirwayBillOfLadingNumber?: string | null, shipperBillOfLadingNumber?: string | null }, shipments: Array<{ __typename?: 'StandardShipmentEntity', uuid: string, shipmentType: ShipmentType, ordinal: number, standardShipmentFields: { __typename?: 'StandardShipmentFieldsEntity', deadlineDate?: any | null, pickupOrDelivery: PickupOrDelivery }, packages: Array<{ __typename?: 'PackageEntity', description: string, weight?: number | null, quantity: number, length?: number | null, width?: number | null, height?: number | null }>, legs: Array<{ __typename?: 'LegEntity', endStop: { __typename?: 'StandardStopEntity', stopType?: StopType | null, status: StopStatus, appointmentTime?: any | null, endAppointmentTime?: any | null, completedAt?: any | null, specialInstructions?: string | null, serviceDate?: any | null, inboundMethod?: InboundMethod | null, outboundMethod?: OutboundMethod | null, isSpecial?: boolean | null, serviceDateV2?: { __typename?: 'PlainDate', iso8601: string } | null, address: { __typename?: 'AddressEntity', uuid: string, name: string, line1: string, line2?: string | null, city: string, state: string, zip: string, country: string, latitude?: number | null, longitude?: number | null, driverInstructions?: string | null, receivingHoursStart?: any | null, receivingHoursEnd?: any | null, specialInstructions?: string | null }, contactPerson?: { __typename?: 'ContactPersonEntity', phone?: string | null, email?: string | null, firstName?: string | null, lastName?: string | null } | null, routeSlot?: { __typename?: 'RouteSlotEntity', route?: { __typename?: 'RouteEntity', name: string, drivers: Array<{ __typename?: 'DriverEntity', firstName: string, lastName: string }> } | null } | null, terminal?: { __typename?: 'TerminalEntity', uuid: string, code: string } | null } }> }> };

export type OrderInfoForCoverSheetFragment = { __typename?: 'StandardOrderEntity', uuid: string, coverSheetDocumentTypeSequence?: { __typename?: 'CoverSheetDocumentTypeSequenceEntity', uuid: string, name: string, type: CoverSheetDocumentTypeSequenceType, documentTypes: Array<DocumentType> } | null, orderEvents: Array<{ __typename?: 'OrderEventEntity', eventType: OrderEventType, sourceType: OrderEventSourceType, createdAt: any, sourceUser?: { __typename?: 'UserEntity', email: string } | null }> };

export type OrderInfosForCoverSheetsQueryVariables = Exact<{
  uuids: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type OrderInfosForCoverSheetsQuery = { __typename?: 'Query', ordersByUuids: Array<{ __typename?: 'StandardOrderEntity', uuid: string, coverSheetDocumentTypeSequence?: { __typename?: 'CoverSheetDocumentTypeSequenceEntity', uuid: string, name: string, type: CoverSheetDocumentTypeSequenceType, documentTypes: Array<DocumentType> } | null, orderEvents: Array<{ __typename?: 'OrderEventEntity', eventType: OrderEventType, sourceType: OrderEventSourceType, createdAt: any, sourceUser?: { __typename?: 'UserEntity', email: string } | null }> }> };

export type OrdersForCoverSheetsQueryVariables = Exact<{
  uuids: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type OrdersForCoverSheetsQuery = { __typename?: 'Query', ordersByUuids: Array<{ __typename?: 'StandardOrderEntity', uuid: string, name: string, refNumbers: Array<string>, inBond?: boolean | null, itTeNumber?: string | null, hazmat?: boolean | null, unNumber?: string | null, hazmatDescription?: string | null, emergencyResponseNumber?: string | null, requiresPlacard?: boolean | null, hazmatClass?: HazmatClass | null, packageGroup?: PackageGroup | null, service?: { __typename?: 'ServiceEntity', name: string } | null, coverSheetDocumentTypeSequence?: { __typename?: 'CoverSheetDocumentTypeSequenceEntity', uuid: string, name: string, type: CoverSheetDocumentTypeSequenceType, documentTypes: Array<DocumentType> } | null, billingPartyContact: { __typename?: 'CustomerContactEntity', uuid: string, displayName: string }, orderEvents: Array<{ __typename?: 'OrderEventEntity', eventType: OrderEventType, sourceType: OrderEventSourceType, createdAt: any, sourceUser?: { __typename?: 'UserEntity', email: string } | null }>, company: { __typename?: 'CompanyEntity', name: string, defaultAddress?: { __typename?: 'AddressEntity', uuid: string, name: string, line1: string, line2?: string | null, city: string, state: string, zip: string, country: string, latitude?: number | null, longitude?: number | null, driverInstructions?: string | null, receivingHoursStart?: any | null, receivingHoursEnd?: any | null, specialInstructions?: string | null } | null }, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', masterAirwayBillOfLadingNumber?: string | null, shipperBillOfLadingNumber?: string | null }, shipments: Array<{ __typename?: 'StandardShipmentEntity', uuid: string, shipmentType: ShipmentType, ordinal: number, standardShipmentFields: { __typename?: 'StandardShipmentFieldsEntity', deadlineDate?: any | null, pickupOrDelivery: PickupOrDelivery }, packages: Array<{ __typename?: 'PackageEntity', description: string, weight?: number | null, quantity: number, length?: number | null, width?: number | null, height?: number | null }>, legs: Array<{ __typename?: 'LegEntity', endStop: { __typename?: 'StandardStopEntity', stopType?: StopType | null, status: StopStatus, appointmentTime?: any | null, endAppointmentTime?: any | null, completedAt?: any | null, specialInstructions?: string | null, serviceDate?: any | null, inboundMethod?: InboundMethod | null, outboundMethod?: OutboundMethod | null, isSpecial?: boolean | null, serviceDateV2?: { __typename?: 'PlainDate', iso8601: string } | null, address: { __typename?: 'AddressEntity', uuid: string, name: string, line1: string, line2?: string | null, city: string, state: string, zip: string, country: string, latitude?: number | null, longitude?: number | null, driverInstructions?: string | null, receivingHoursStart?: any | null, receivingHoursEnd?: any | null, specialInstructions?: string | null }, contactPerson?: { __typename?: 'ContactPersonEntity', phone?: string | null, email?: string | null, firstName?: string | null, lastName?: string | null } | null, routeSlot?: { __typename?: 'RouteSlotEntity', route?: { __typename?: 'RouteEntity', name: string, drivers: Array<{ __typename?: 'DriverEntity', firstName: string, lastName: string }> } | null } | null, terminal?: { __typename?: 'TerminalEntity', uuid: string, code: string } | null } }> }> }> };

export type RemoveCoverSheetDocumentTypeSequenceMutationVariables = Exact<{
  uuid: Scalars['String']['input'];
}>;


export type RemoveCoverSheetDocumentTypeSequenceMutation = { __typename?: 'Mutation', removeCoverSheetDocumentTypeSequence: { __typename?: 'CoverSheetDocumentTypeSequenceEntity', uuid: string } };

export type UpdateCoverSheetDocumentTypeSequenceMutationVariables = Exact<{
  input: CoverSheetDocumentTypeSequenceUpdateInput;
}>;


export type UpdateCoverSheetDocumentTypeSequenceMutation = { __typename?: 'Mutation', updateCoverSheetDocumentTypeSequence: { __typename?: 'CoverSheetDocumentTypeSequenceEntity', uuid: string } };

export type CreateAccountingReportDocumentMutationVariables = Exact<{
  createAccountingReportDocumentInput: CreateBasicDocumentInput;
}>;


export type CreateAccountingReportDocumentMutation = { __typename?: 'Mutation', createAccountingReportDocument: { __typename?: 'CreateAccountingReportDocumentOutput', document: { __typename?: 'DocumentEntity', uuid: string, bucket: string, region: string, key: string, fileName: string, fileType: string, type: DocumentType } } };

export type CreateEodDocumentsMutationVariables = Exact<{
  createEodDocumentsInput: CreateEodDocumentsInput;
}>;


export type CreateEodDocumentsMutation = { __typename?: 'Mutation', createEODDocuments: Array<{ __typename?: 'DocumentEntity', uuid: string }> };

export type CreateOrderCommentMutationVariables = Exact<{
  createOrderCommentInput: CreateOrderCommentInput;
}>;


export type CreateOrderCommentMutation = { __typename?: 'Mutation', createOrderComment: { __typename?: 'OrderCommentEntity', uuid: string } };

export type CreateOrderDocumentDocumentMutationVariables = Exact<{
  createOrderDocumentDocumentInput: CreateOrderDocumentDocumentInput;
}>;


export type CreateOrderDocumentDocumentMutation = { __typename?: 'Mutation', createOrderDocumentDocument: { __typename?: 'CreateOrderDocumentDocumentOutput', document: { __typename?: 'DocumentEntity', uuid: string, bucket: string, region: string, key: string, fileName: string, fileType: string, type: DocumentType } } };

export type CreateOrderSnapshotMutationVariables = Exact<{
  orderEventSnapshotCreateInput: OrderEventSnapshotCreateInput;
}>;


export type CreateOrderSnapshotMutation = { __typename?: 'Mutation', createOrderSnapshot?: { __typename?: 'OrderEventEntity', uuid: string } | null };

export type CreateOrdersFromRecurringTemplatesMutationVariables = Exact<{
  uuids: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type CreateOrdersFromRecurringTemplatesMutation = { __typename?: 'Mutation', createOrdersFromRecurringTemplates: Array<{ __typename?: 'StandardOrderEntity', uuid: string }> };

export type CreatePodReportDocumentMutationVariables = Exact<{
  createPodReportDocumentInput: CreatePodReportDocumentInput;
}>;


export type CreatePodReportDocumentMutation = { __typename?: 'Mutation', createPODReportDocument: { __typename?: 'CreatePodReportDocumentOutput', document: { __typename?: 'DocumentEntity', uuid: string, bucket: string, region: string, key: string, fileName: string, fileType: string, type: DocumentType } } };

export type CreateRecurringRunMutationVariables = Exact<{
  input: CreateRunInput;
}>;


export type CreateRecurringRunMutation = { __typename?: 'Mutation', createRun: { __typename?: 'CreateRunOutput', run: { __typename?: 'RunEntity', uuid: string } } };

export type CreateScannedOrdersMutationVariables = Exact<{
  createScannedOrdersInput: CreateScannedOrdersInput;
}>;


export type CreateScannedOrdersMutation = { __typename?: 'Mutation', createScannedOrders: boolean };

export type MatchSignedPoDsMutationVariables = Exact<{
  matchSignedPODsInput: CreateScannedOrdersInput;
}>;


export type MatchSignedPoDsMutation = { __typename?: 'Mutation', matchSignedPODs: boolean };

export type CreateStandardOrderMutationVariables = Exact<{
  createStandardOrderInput: CreateStandardOrderInput;
}>;


export type CreateStandardOrderMutation = { __typename?: 'Mutation', createStandardOrder: { __typename?: 'StandardOrderEntity', uuid: string } };

export type CreateTagMutationVariables = Exact<{
  createTagInput: CreateTagInput;
}>;


export type CreateTagMutation = { __typename?: 'Mutation', createTag: { __typename?: 'TagEntity', uuid: string } };

export type CreateOrUpdateCsvOrdersOrderFragment = { __typename?: 'StandardOrderEntity', uuid: string };

export type CreateOrUpdateCsvOrdersMutationVariables = Exact<{
  createOrUpdateCsvOrdersInput: CreateOrUpdateCsvOrdersInput;
}>;


export type CreateOrUpdateCsvOrdersMutation = { __typename?: 'Mutation', createOrUpdateCsvOrders: { __typename: 'CreateOrUpdateCsvOrdersSuccessOutput', orders: Array<{ __typename?: 'StandardOrderEntity', uuid: string }> } | { __typename: 'MutationErrorOutput', message: string } };

export type CsvOrderMappingFragment = { __typename?: 'CsvOrderMappingEntity', uuid: string, name: string };

export type CsvOrderMappingsQueryVariables = Exact<{ [key: string]: never; }>;


export type CsvOrderMappingsQuery = { __typename?: 'Query', csvOrderMappings: Array<{ __typename?: 'CsvOrderMappingEntity', uuid: string, name: string }> };

export type CsvOrderPreSignedPutUrlFragment = { __typename?: 'CsvOrderPreSignedPutUrlEntity', url: string, bucket: string, key: string, filename: string, filetype: string };

export type GenerateCsvOrderPreSignedPutUrlsQueryVariables = Exact<{
  generateCsvOrderPresignedPutUrlInputs: Array<GenerateCsvOrderPresignedPutUrlInput> | GenerateCsvOrderPresignedPutUrlInput;
}>;


export type GenerateCsvOrderPreSignedPutUrlsQuery = { __typename?: 'Query', generateCsvOrderPreSignedPutUrls: Array<{ __typename?: 'CsvOrderPreSignedPutUrlEntity', url: string, bucket: string, key: string, filename: string, filetype: string }> };

type ParseCsvOrdersContact_CustomerContactEntity_Fragment = { __typename?: 'CustomerContactEntity', uuid: string, displayName: string };

type ParseCsvOrdersContact_ThirdPartyContactEntity_Fragment = { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string };

export type ParseCsvOrdersContactFragment = ParseCsvOrdersContact_CustomerContactEntity_Fragment | ParseCsvOrdersContact_ThirdPartyContactEntity_Fragment;

export type ParseCsvOrdersOrderUpdateFragment = { __typename?: 'ParsedCsvOrderUpdateEntity', uuid: string, shipperBillOfLadingNumber: string, billingPartyContact: { __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string }, packages: Array<{ __typename?: 'ParsedCsvOrderPackageEntity', description: string, quantity: number, type?: PackageType | null, weight?: number | null, length?: number | null, width?: number | null, height?: number | null, uuid: string, isNew?: boolean | null, packageSpec?: { __typename?: 'PackageSpecEntity', id: string, name: string } | null }> };

export type ParseCsvOrdersOrderFragment = { __typename?: 'ParsedCsvOrderEntity', customerReferenceNumber?: string | null, shipperBillOfLadingNumber: string, masterAirwayBillOfLadingNumber?: string | null, referenceNumber?: string | null, notes?: string | null, dimFactor?: number | null, freightChargeRate?: number | null, freightChargeType?: FreightBillingMethod | null, fuelSurcharge?: number | null, fuelChargeType?: FuelBillingMethod | null, billingPartyContact: { __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string }, serviceLevel?: { __typename?: 'ServiceEntity', uuid: string, name: string } | null, inboundStop?: { __typename?: 'ParsedCsvOrderStopEntity', pickupOrDelivery: PickupOrDelivery, addressName: string, addressLine1: string, addressLine2?: string | null, addressCity: string, addressState: string, addressZip: string, contactPersonFirstName?: string | null, contactPersonLastName?: string | null, contactPersonPhone?: string | null, contactPersonEmail?: string | null, specialInstructions?: string | null, deadlineDate?: any | null, deadlineType?: DeadlineType | null, serviceDate: any, appointmentRequired: boolean, terminalName?: string | null, driverName?: string | null, driverReferenceNumber?: string | null, serviceDateV2: { __typename?: 'PlainDate', iso8601: string }, appointmentStartTime?: { __typename?: 'PlainTime', hour: number, minute: number } | null, appointmentEndTime?: { __typename?: 'PlainTime', hour: number, minute: number } | null, terminal?: { __typename?: 'TerminalEntity', uuid: string, name: string } | null, driver?: { __typename?: 'DriverEntity', uuid: string, firstName: string, lastName: string } | null } | null, outboundStop?: { __typename?: 'ParsedCsvOrderStopEntity', pickupOrDelivery: PickupOrDelivery, addressName: string, addressLine1: string, addressLine2?: string | null, addressCity: string, addressState: string, addressZip: string, contactPersonFirstName?: string | null, contactPersonLastName?: string | null, contactPersonPhone?: string | null, contactPersonEmail?: string | null, specialInstructions?: string | null, deadlineDate?: any | null, deadlineType?: DeadlineType | null, serviceDate: any, appointmentRequired: boolean, terminalName?: string | null, driverName?: string | null, driverReferenceNumber?: string | null, serviceDateV2: { __typename?: 'PlainDate', iso8601: string }, appointmentStartTime?: { __typename?: 'PlainTime', hour: number, minute: number } | null, appointmentEndTime?: { __typename?: 'PlainTime', hour: number, minute: number } | null, terminal?: { __typename?: 'TerminalEntity', uuid: string, name: string } | null, driver?: { __typename?: 'DriverEntity', uuid: string, firstName: string, lastName: string } | null } | null, packages: Array<{ __typename?: 'ParsedCsvOrderPackageEntity', description: string, quantity: number, type?: PackageType | null, weight?: number | null, length?: number | null, width?: number | null, height?: number | null, uuid: string, isNew?: boolean | null, packageSpec?: { __typename?: 'PackageSpecEntity', id: string, name: string } | null }> };

export type ParseCsvOrdersPackageFragment = { __typename?: 'ParsedCsvOrderPackageEntity', description: string, quantity: number, type?: PackageType | null, weight?: number | null, length?: number | null, width?: number | null, height?: number | null, uuid: string, isNew?: boolean | null, packageSpec?: { __typename?: 'PackageSpecEntity', id: string, name: string } | null };

export type ParseCsvOrdersRowErrorFragment = { __typename?: 'ParseCsvOrderRowErrorEntity', row: number, message: string };

export type ParseCsvOrdersServiceFragment = { __typename?: 'ServiceEntity', uuid: string, name: string };

export type ParseCsvOrdersStopFragment = { __typename?: 'ParsedCsvOrderStopEntity', pickupOrDelivery: PickupOrDelivery, addressName: string, addressLine1: string, addressLine2?: string | null, addressCity: string, addressState: string, addressZip: string, contactPersonFirstName?: string | null, contactPersonLastName?: string | null, contactPersonPhone?: string | null, contactPersonEmail?: string | null, specialInstructions?: string | null, deadlineDate?: any | null, deadlineType?: DeadlineType | null, serviceDate: any, appointmentRequired: boolean, terminalName?: string | null, driverName?: string | null, driverReferenceNumber?: string | null, serviceDateV2: { __typename?: 'PlainDate', iso8601: string }, appointmentStartTime?: { __typename?: 'PlainTime', hour: number, minute: number } | null, appointmentEndTime?: { __typename?: 'PlainTime', hour: number, minute: number } | null, terminal?: { __typename?: 'TerminalEntity', uuid: string, name: string } | null, driver?: { __typename?: 'DriverEntity', uuid: string, firstName: string, lastName: string } | null };

export type ParseCsvOrdersMutationVariables = Exact<{
  parseCsvOrdersInput: ParseCsvOrdersInput;
}>;


export type ParseCsvOrdersMutation = { __typename?: 'Mutation', parseCsvOrders: { __typename: 'MutationErrorOutput', message: string } | { __typename: 'ParseCsvOrdersSuccessOutput', enableInboundStop: boolean, enableOutboundStop: boolean, parsedOrders: Array<{ __typename?: 'ParsedCsvOrderEntity', customerReferenceNumber?: string | null, shipperBillOfLadingNumber: string, masterAirwayBillOfLadingNumber?: string | null, referenceNumber?: string | null, notes?: string | null, dimFactor?: number | null, freightChargeRate?: number | null, freightChargeType?: FreightBillingMethod | null, fuelSurcharge?: number | null, fuelChargeType?: FuelBillingMethod | null, billingPartyContact: { __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string }, serviceLevel?: { __typename?: 'ServiceEntity', uuid: string, name: string } | null, inboundStop?: { __typename?: 'ParsedCsvOrderStopEntity', pickupOrDelivery: PickupOrDelivery, addressName: string, addressLine1: string, addressLine2?: string | null, addressCity: string, addressState: string, addressZip: string, contactPersonFirstName?: string | null, contactPersonLastName?: string | null, contactPersonPhone?: string | null, contactPersonEmail?: string | null, specialInstructions?: string | null, deadlineDate?: any | null, deadlineType?: DeadlineType | null, serviceDate: any, appointmentRequired: boolean, terminalName?: string | null, driverName?: string | null, driverReferenceNumber?: string | null, serviceDateV2: { __typename?: 'PlainDate', iso8601: string }, appointmentStartTime?: { __typename?: 'PlainTime', hour: number, minute: number } | null, appointmentEndTime?: { __typename?: 'PlainTime', hour: number, minute: number } | null, terminal?: { __typename?: 'TerminalEntity', uuid: string, name: string } | null, driver?: { __typename?: 'DriverEntity', uuid: string, firstName: string, lastName: string } | null } | null, outboundStop?: { __typename?: 'ParsedCsvOrderStopEntity', pickupOrDelivery: PickupOrDelivery, addressName: string, addressLine1: string, addressLine2?: string | null, addressCity: string, addressState: string, addressZip: string, contactPersonFirstName?: string | null, contactPersonLastName?: string | null, contactPersonPhone?: string | null, contactPersonEmail?: string | null, specialInstructions?: string | null, deadlineDate?: any | null, deadlineType?: DeadlineType | null, serviceDate: any, appointmentRequired: boolean, terminalName?: string | null, driverName?: string | null, driverReferenceNumber?: string | null, serviceDateV2: { __typename?: 'PlainDate', iso8601: string }, appointmentStartTime?: { __typename?: 'PlainTime', hour: number, minute: number } | null, appointmentEndTime?: { __typename?: 'PlainTime', hour: number, minute: number } | null, terminal?: { __typename?: 'TerminalEntity', uuid: string, name: string } | null, driver?: { __typename?: 'DriverEntity', uuid: string, firstName: string, lastName: string } | null } | null, packages: Array<{ __typename?: 'ParsedCsvOrderPackageEntity', description: string, quantity: number, type?: PackageType | null, weight?: number | null, length?: number | null, width?: number | null, height?: number | null, uuid: string, isNew?: boolean | null, packageSpec?: { __typename?: 'PackageSpecEntity', id: string, name: string } | null }> }>, parsedOrderUpdates: Array<{ __typename?: 'ParsedCsvOrderUpdateEntity', uuid: string, shipperBillOfLadingNumber: string, billingPartyContact: { __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string }, packages: Array<{ __typename?: 'ParsedCsvOrderPackageEntity', description: string, quantity: number, type?: PackageType | null, weight?: number | null, length?: number | null, width?: number | null, height?: number | null, uuid: string, isNew?: boolean | null, packageSpec?: { __typename?: 'PackageSpecEntity', id: string, name: string } | null }> }>, errors: Array<{ __typename?: 'ParseCsvOrderRowErrorEntity', row: number, message: string }> } };

export type CurrentOrderStatusQueryVariables = Exact<{
  uuid: Scalars['String']['input'];
}>;


export type CurrentOrderStatusQuery = { __typename?: 'Query', order?: { __typename?: 'StandardOrderEntity', detailedStatusV2?: OrderDetailedStatus | null, updatedAt: any } | null };

export type CurrentOrderStatusFragment = { __typename?: 'StandardOrderEntity', detailedStatusV2?: OrderDetailedStatus | null, updatedAt: any };

export type CustomChargeForOrderFragment = { __typename?: 'CustomChargeEntity', name: string, total: number, accessorialTemplate?: { __typename: 'SkidBasedAccessorialEntity', uuid: string, name: string } | { __typename: 'SpecialAccessorialEntity', uuid: string, name: string } | { __typename: 'StandardAccessorialEntity', uuid: string, name: string } | { __typename: 'UnitBasedAccessorialEntity', uuid: string, name: string } | { __typename: 'WaitTimeAccessorialEntity', uuid: string, name: string } | { __typename: 'WeightBasedAccessorialEntity', uuid: string, name: string } | { __typename: 'ZoneBasedAccessorialEntity', uuid: string, name: string } | null };

export type DeleteOrderMutationVariables = Exact<{
  uuid: Scalars['String']['input'];
}>;


export type DeleteOrderMutation = { __typename?: 'Mutation', deleteOrder?: { __typename?: 'StandardOrderEntity', uuid: string } | null };

export type DocumentsByOrderQueryVariables = Exact<{
  orderUuid: Scalars['String']['input'];
}>;


export type DocumentsByOrderQuery = { __typename?: 'Query', documents: Array<{ __typename?: 'DocumentEntity', uuid: string, fileName: string, bucket: string, region: string, key: string, uploadedAt?: any | null, fileType: string, isDeleted: boolean, preSignedGetUrl: string, name?: string | null, type: DocumentType, pageNumber?: number | null, createdAt: any, notes?: string | null, order?: { __typename?: 'StandardOrderEntity', uuid: string, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', shipperBillOfLadingNumber?: string | null } } | null, shipment?: { __typename?: 'StandardOrderEntity', uuid: string } | null, driverFormTemplate?: { __typename?: 'DriverSignableFormTemplateEntity', uuid: string, title: string, formText: string } | null }> };

export type EdiAndApiOrdersForReviewQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  createdAtDateFilters?: InputMaybe<DateFilterStartEnd>;
  contactUuid?: InputMaybe<Scalars['String']['input']>;
  sortByCreatedAtDateAsc?: InputMaybe<Scalars['Boolean']['input']>;
  searchText?: InputMaybe<Scalars['String']['input']>;
  originTerminalUuid?: InputMaybe<Scalars['String']['input']>;
  destinationTerminalUuid?: InputMaybe<Scalars['String']['input']>;
}>;


export type EdiAndApiOrdersForReviewQuery = { __typename?: 'Query', ediAndApiOrdersForReview: { __typename?: 'OrderConnection', totalCount?: number | null, edges: Array<{ __typename?: 'OrderEdge', node: { __typename?: 'StandardOrderEntity', createdAt: any, uuid: string, source: OrderSource, name: string, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', shipperBillOfLadingNumber?: string | null, masterAirwayBillOfLadingNumber?: string | null }, contact: { __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string } } }>, pageInfo: { __typename?: 'PageInfo', startCursor?: string | null, endCursor?: string | null, hasNextPage: boolean, hasPreviousPage: boolean } } };

export type EdiTransactionFragmentFragment = { __typename?: 'EdiTransactionEntity', uuid: string, updatedAt: any, status: EdiTransactionStatus, code: EdiTransactionCode, message?: string | null, payload: string, hawb?: string | null, order?: { __typename?: 'StandardOrderEntity', uuid: string, name: string, secondaryRefNumber?: string | null, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', shipperBillOfLadingNumber?: string | null } } | null };

export type EdiTransactionsQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  searchTerms?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;


export type EdiTransactionsQuery = { __typename?: 'Query', ediTransactions: { __typename?: 'EdiTransactionConnection', edges: Array<{ __typename?: 'EdiTransactionEdge', node: { __typename?: 'EdiTransactionEntity', uuid: string, updatedAt: any, status: EdiTransactionStatus, code: EdiTransactionCode, message?: string | null, payload: string, hawb?: string | null, order?: { __typename?: 'StandardOrderEntity', uuid: string, name: string, secondaryRefNumber?: string | null, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', shipperBillOfLadingNumber?: string | null } } | null } }>, pageInfo: { __typename?: 'PageInfo', startCursor?: string | null, endCursor?: string | null, hasNextPage: boolean, hasPreviousPage: boolean } } };

export type OrderForEdiReviewByUuidQueryVariables = Exact<{
  uuid: Scalars['String']['input'];
}>;


export type OrderForEdiReviewByUuidQuery = { __typename?: 'Query', order?: { __typename?: 'StandardOrderEntity', createdAt: any, uuid: string, source: OrderSource, name: string, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', shipperBillOfLadingNumber?: string | null, masterAirwayBillOfLadingNumber?: string | null }, contact: { __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string } } | null };

export type OrderFragmentForEdiReviewFragment = { __typename?: 'StandardOrderEntity', createdAt: any, uuid: string, source: OrderSource, name: string, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', shipperBillOfLadingNumber?: string | null, masterAirwayBillOfLadingNumber?: string | null }, contact: { __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string } };

export type OrderWithSameBillOfLadingNumberAsReviewOrderFragment = { __typename?: 'StandardOrderEntity', uuid: string, name: string };

export type EmailOrderDocumentMutationVariables = Exact<{
  emailOrderDocumentInput: EmailOrderDocumentInput;
}>;


export type EmailOrderDocumentMutation = { __typename?: 'Mutation', emailOrderDocument: { __typename?: 'EmailOrderDocumentOutput', status: EmailOrderDocumentStatus } };

export type FetchMissingAccessorialQueryVariables = Exact<{
  uuid: Scalars['String']['input'];
}>;


export type FetchMissingAccessorialQuery = { __typename?: 'Query', accessorial: { __typename?: 'SkidBasedAccessorialEntity' } | { __typename: 'SpecialAccessorialEntity', uuid: string, name: string } | { __typename: 'StandardAccessorialEntity', uuid: string, name: string } | { __typename: 'UnitBasedAccessorialEntity', uuid: string, name: string } | { __typename: 'WaitTimeAccessorialEntity', uuid: string, name: string } | { __typename: 'WeightBasedAccessorialEntity', uuid: string, name: string } | { __typename: 'ZoneBasedAccessorialEntity', uuid: string, name: string } };

export type FinalizeOrderMutationVariables = Exact<{
  uuid: Scalars['String']['input'];
}>;


export type FinalizeOrderMutation = { __typename?: 'Mutation', finalizeOrder: { __typename?: 'StandardOrderEntity', uuid: string, status: OrderStatus, detailedStatusV2?: OrderDetailedStatus | null, shipments: Array<{ __typename?: 'StandardShipmentEntity', uuid: string, status: ShipmentStatus }> } };

export type FinalizeOrdersMutationVariables = Exact<{
  finalizeOrdersInput: FinalizeOrdersInput;
}>;


export type FinalizeOrdersMutation = { __typename?: 'Mutation', finalizeOrders: { __typename: 'FinalizeOrdersSuccessOutput', finalizedOrderUuids: Array<string>, failedOrderUuids: Array<string> } | { __typename: 'MutationErrorOutput', message: string } };

export type TerminalForAddressQueryVariables = Exact<{
  findTerminalForAddressInput: FindTerminalForAddressInput;
}>;


export type TerminalForAddressQuery = { __typename?: 'Query', terminalForAddress: { __typename?: 'FindTerminalForAddressOutput', terminal?: { __typename?: 'TerminalEntity', name: string, uuid: string } | null } };

export type TerminalsForAddressQueryVariables = Exact<{
  findTerminalForAddressInput: FindTerminalForAddressInput;
}>;


export type TerminalsForAddressQuery = { __typename?: 'Query', terminalsForAddress: { __typename?: 'FindTerminalsForAddressOutput', terminals?: Array<{ __typename?: 'TerminalEntity', name: string, uuid: string }> | null } };

export type GenerateAccountingReportPreSignedPutUrlMutationVariables = Exact<{
  generateAccountingReportPreSignedPutUrlInput: GenerateAccountingReportPreSignedPutUrlInput;
}>;


export type GenerateAccountingReportPreSignedPutUrlMutation = { __typename?: 'Mutation', generateAccountingReportPreSignedPutUrl: string };

export type GenerateOrderDocumentPreSignedPutUrlMutationVariables = Exact<{
  generateOrderDocumentPreSignedPutUrlInput: GenerateOrderDocumentPreSignedPutUrlInput;
}>;


export type GenerateOrderDocumentPreSignedPutUrlMutation = { __typename?: 'Mutation', generateOrderDocumentPreSignedPutUrl: string };

export type GenerateOrderPreSignedGetAndPutUrlsMutationVariables = Exact<{
  generateOrderPreSignedGetAndPutUrlsInput: GenerateOrderPreSignedGetAndPutUrlsInput;
}>;


export type GenerateOrderPreSignedGetAndPutUrlsMutation = { __typename?: 'Mutation', generateOrderPreSignedGetAndPutUrls: { __typename?: 'GenerateOrderPreSignedGetAndPutUrlsOutput', getUrl: string, putUrl: string } };

export type GeneratePodReportPreSignedPutUrlMutationVariables = Exact<{
  generatePodReportPreSignedPutUrlInput: GeneratePodReportPreSignedPutUrlInput;
}>;


export type GeneratePodReportPreSignedPutUrlMutation = { __typename?: 'Mutation', generatePodReportPreSignedPutUrl: string };

export type GenerateContactPreSignedPutUrlMutationVariables = Exact<{
  generateContactPreSignedPutUrlInput: GenerateContactPreSignedPutUrlInput;
}>;


export type GenerateContactPreSignedPutUrlMutation = { __typename?: 'Mutation', generateContactPreSignedPutUrl: { __typename?: 'GeneratePreSignedPutUrlOutput', url: string } };

export type GenerateInvoicePreSignedPutUrlMutationVariables = Exact<{
  generateInvoicePreSignedPutUrlInput: GenerateInvoicePreSignedPutUrlInput;
}>;


export type GenerateInvoicePreSignedPutUrlMutation = { __typename?: 'Mutation', generateInvoicePreSignedPutUrl: string };

export type GenerateOrderPreSignedPutUrlMutationVariables = Exact<{
  generateOrderPreSignedPutUrlInput: GenerateOrderPreSignedPutUrlInput;
}>;


export type GenerateOrderPreSignedPutUrlMutation = { __typename?: 'Mutation', generateOrderPreSignedPutUrl: string };

export type GenerateScannedOrderPreSignedPutUrlsQueryVariables = Exact<{
  preSignedUrlRequests: Array<PreSignedUrlRequestInput> | PreSignedUrlRequestInput;
}>;


export type GenerateScannedOrderPreSignedPutUrlsQuery = { __typename?: 'Query', generateScannedOrderPreSignedPutUrls: Array<{ __typename?: 'PreSignedPutUrlEntity', url: string, bucket: string, key: string, filename: string, filetype: string }> };

export type GeneratePreSignedPutUrlMutationVariables = Exact<{
  fileName: Scalars['String']['input'];
  fileType: Scalars['String']['input'];
}>;


export type GeneratePreSignedPutUrlMutation = { __typename?: 'Mutation', generatePreSignedPutUrl: string };

export type IncompleteLegsWithAttemptsQueryVariables = Exact<{ [key: string]: never; }>;


export type IncompleteLegsWithAttemptsQuery = { __typename?: 'Query', incompleteLegsWithAttempts: Array<{ __typename?: 'LegEntity', uuid: string, previousStopAttempts: Array<{ __typename?: 'StandardStopEntity', uuid: string, completedAt?: any | null, notes?: string | null, address: { __typename?: 'AddressEntity', name: string, line1: string }, leg: { __typename?: 'LegEntity', uuid: string, shipment: { __typename?: 'StandardShipmentEntity', order?: { __typename?: 'StandardOrderEntity', standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', shipperBillOfLadingNumber?: string | null } } | null } } }> }> };

export type LaneFromOriginAndDestinationTerminalQueryVariables = Exact<{
  findLaneFromOriginAndDestinationTerminalInput: FindLaneFromOriginAndDestinationTerminalInput;
}>;


export type LaneFromOriginAndDestinationTerminalQuery = { __typename?: 'Query', laneFromOriginAndDestinationTerminal: { __typename?: 'FindLaneFromOriginAndDestinationTerminalOutput', lane?: { __typename?: 'LineHaulLaneEntity', uuid: string, name: string, isActive: boolean, originTerminal: { __typename?: 'TerminalEntity', name: string, code: string, uuid: string, isActive: boolean, address: { __typename?: 'AddressEntity', line1: string, line2?: string | null, city: string, state: string, zip: string, uuid: string, name: string, latitude?: number | null, longitude?: number | null }, startForTerminalLanes: Array<{ __typename?: 'TerminalLaneEntity', id: string, endTerminal: { __typename?: 'TerminalEntity', uuid: string, code: string, name: string } }>, agent?: { __typename?: 'AgentFieldsEntity', name: string } | null }, destinationTerminal: { __typename?: 'TerminalEntity', name: string, code: string, uuid: string, isActive: boolean, address: { __typename?: 'AddressEntity', line1: string, line2?: string | null, city: string, state: string, zip: string, uuid: string, name: string, latitude?: number | null, longitude?: number | null }, startForTerminalLanes: Array<{ __typename?: 'TerminalLaneEntity', id: string, endTerminal: { __typename?: 'TerminalEntity', uuid: string, code: string, name: string } }>, agent?: { __typename?: 'AgentFieldsEntity', name: string } | null }, segments: Array<{ __typename?: 'LineHaulSegmentEntity', uuid: string, ordinal: number, startTerminal: { __typename?: 'TerminalEntity', uuid: string, code: string }, endTerminal: { __typename?: 'TerminalEntity', uuid: string, code: string } }> } | null } };

export type MarkOrderAsCompleteForceMutationVariables = Exact<{
  markOrderAsCompleteForceInput: MarkOrderAsCompleteForceInput;
}>;


export type MarkOrderAsCompleteForceMutation = { __typename?: 'Mutation', markOrderAsCompleteForce: { __typename?: 'StandardOrderEntity', uuid: string, detailedStatusV2?: OrderDetailedStatus | null, status: OrderStatus } };

export type MarkOrderAsHasBillingIssueMutationVariables = Exact<{
  uuid: Scalars['String']['input'];
}>;


export type MarkOrderAsHasBillingIssueMutation = { __typename?: 'Mutation', markOrderAsHasBillingIssue: { __typename?: 'StandardOrderEntity', uuid: string, status: OrderStatus } };

export type MarkOrderAsNotCompleteMutationVariables = Exact<{
  uuid: Scalars['String']['input'];
}>;


export type MarkOrderAsNotCompleteMutation = { __typename?: 'Mutation', markOrderAsNotComplete: { __typename?: 'StandardOrderEntity', uuid: string, detailedStatusV2?: OrderDetailedStatus | null, status: OrderStatus } };

export type MarkOrderAsNotOnHandMutationVariables = Exact<{
  markAsNotOnHandInput: MarkAsNotOnHandInput;
}>;


export type MarkOrderAsNotOnHandMutation = { __typename?: 'Mutation', markOrderAsNotOnHand: { __typename?: 'StandardOrderEntity', uuid: string, detailedStatusV2?: OrderDetailedStatus | null, status: OrderStatus } };

export type MarkOrderAsNotReadyToInvoiceMutationVariables = Exact<{
  uuid: Scalars['String']['input'];
}>;


export type MarkOrderAsNotReadyToInvoiceMutation = { __typename?: 'Mutation', markOrderAsNotReadyToInvoice: { __typename?: 'StandardOrderEntity', uuid: string, status: OrderStatus } };

export type MarkOrderAsNotReceivedAtOriginMutationVariables = Exact<{
  markAsNotReceivedAtOriginInput: MarkAsNotReceivedAtOriginInput;
}>;


export type MarkOrderAsNotReceivedAtOriginMutation = { __typename?: 'Mutation', markOrderAsNotReceivedAtOrigin: { __typename?: 'StandardOrderEntity', uuid: string, detailedStatusV2?: OrderDetailedStatus | null, status: OrderStatus } };

export type MarkOrderAsOnHandMutationVariables = Exact<{
  markAsOnHandInput: MarkAsOnHandInput;
}>;


export type MarkOrderAsOnHandMutation = { __typename?: 'Mutation', markOrderAsOnHand: { __typename?: 'StandardOrderEntity', uuid: string, receivedDate?: any | null, detailedStatusV2?: OrderDetailedStatus | null, osd?: boolean | null, status: OrderStatus, shipments: Array<{ __typename?: 'StandardShipmentEntity', status: ShipmentStatus, standardShipmentFields: { __typename?: 'StandardShipmentFieldsEntity', pickupOrDelivery: PickupOrDelivery }, legs: Array<{ __typename?: 'LegEntity', endStop: { __typename?: 'StandardStopEntity', status: StopStatus } }> }> } };

export type MarkOrderAsReadyToInvoiceForceMutationVariables = Exact<{
  uuid: Scalars['String']['input'];
  refuseOrderInput?: InputMaybe<RefuseOrderInput>;
}>;


export type MarkOrderAsReadyToInvoiceForceMutation = { __typename?: 'Mutation', markOrderAsReadyToInvoiceForce: { __typename?: 'StandardOrderEntity', uuid: string, detailedStatusV2?: OrderDetailedStatus | null, status: OrderStatus } };

export type MarkOrderAsReadyToInvoiceMutationVariables = Exact<{
  uuid: Scalars['String']['input'];
}>;


export type MarkOrderAsReadyToInvoiceMutation = { __typename?: 'Mutation', markOrderAsReadyToInvoice: { __typename?: 'StandardOrderEntity', uuid: string, status: OrderStatus } };

export type MarkOrderAsReceivedAtOriginMutationVariables = Exact<{
  markAsReceivedAtOriginInput: MarkAsReceivedAtOriginInput;
}>;


export type MarkOrderAsReceivedAtOriginMutation = { __typename?: 'Mutation', markOrderAsReceivedAtOrigin: { __typename?: 'StandardOrderEntity', uuid: string, dateMarkedReceivedAtOrigin?: any | null, detailedStatusV2?: OrderDetailedStatus | null, osd?: boolean | null, status: OrderStatus, shipments: Array<{ __typename?: 'StandardShipmentEntity', status: ShipmentStatus, standardShipmentFields: { __typename?: 'StandardShipmentFieldsEntity', pickupOrDelivery: PickupOrDelivery }, legs: Array<{ __typename?: 'LegEntity', endStop: { __typename?: 'StandardStopEntity', status: StopStatus } }> }> } };

export type MarkOrderAsRefusedMutationVariables = Exact<{
  markOrderAsRefusedInput: MarkOrderAsRefusedInput;
}>;


export type MarkOrderAsRefusedMutation = { __typename?: 'Mutation', markOrderAsRefused: { __typename?: 'MarkOrderAsRefusedSuccessOutput', success: boolean } | { __typename?: 'MutationErrorOutput', message: string } };

export type MarkOrderAsNotOsdMutationVariables = Exact<{
  markAsNotOsd: MarkNotOsdInput;
}>;


export type MarkOrderAsNotOsdMutation = { __typename?: 'Mutation', markNotOsd: { __typename?: 'StandardOrderEntity', uuid: string, status: OrderStatus, detailedStatusV2?: OrderDetailedStatus | null } };

export type MarkOrderAsOsdMutationVariables = Exact<{
  markOsdInput: MarkOsdInput;
}>;


export type MarkOrderAsOsdMutation = { __typename?: 'Mutation', markOsd: { __typename?: 'StandardOrderEntity', uuid: string, notes: string, status: OrderStatus, detailedStatusV2?: OrderDetailedStatus | null } };

export type MarkOsdOrderFragment = { __typename?: 'StandardOrderEntity', uuid: string, notes: string, status: OrderStatus, detailedStatusV2?: OrderDetailedStatus | null };

export type MergeEdiOrderMutationVariables = Exact<{
  mergeEdiOrderInput: MergeEdiOrderInput;
}>;


export type MergeEdiOrderMutation = { __typename?: 'Mutation', mergeEdiOrder: { __typename?: 'MergeEdiOrderOutput', uuid: string } };

export type OpenMessageInOutlookMutationVariables = Exact<{
  openMessageInOutlookInput: OpenMessageInOutlookInput;
}>;


export type OpenMessageInOutlookMutation = { __typename?: 'Mutation', openMessageInOutlook: { __typename?: 'OpenMessageInOutlookOutput', linkToOpen: string } };

export type DeleteOrderCommentMutationVariables = Exact<{
  deleteOrderCommentInput: DeleteOrderCommentInput;
}>;


export type DeleteOrderCommentMutation = { __typename?: 'Mutation', deleteOrderComment: { __typename?: 'DeleteOrderCommentSuccessOutput', success: boolean } | { __typename?: 'MutationErrorOutput', message: string } };

export type UpdateOrderCommentMutationVariables = Exact<{
  updateOrderCommentInput: UpdateOrderCommentInput;
}>;


export type UpdateOrderCommentMutation = { __typename?: 'Mutation', updateOrderComment: { __typename?: 'OrderCommentEntity', uuid: string } };

export type OrderForBulkEditFragment = { __typename?: 'StandardOrderEntity', uuid: string, status: OrderStatus, onHand?: boolean | null, pickedDate?: any | null, pieceCount?: number | null, detailedStatusV2?: OrderDetailedStatus | null, secondaryRefNumber?: string | null, warehouse?: { __typename?: 'WarehouseEntity', uuid: string, name: string } | null, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', shipperBillOfLadingNumber?: string | null, masterAirwayBillOfLadingNumber?: string | null }, shipments: Array<{ __typename?: 'StandardShipmentEntity', uuid: string, shipmentType: ShipmentType, standardShipmentFields: { __typename?: 'StandardShipmentFieldsEntity', deadlineDate?: any | null, deadlineType?: DeadlineType | null, pickupOrDelivery: PickupOrDelivery }, legs: Array<{ __typename?: 'LegEntity', uuid: string, endStop: { __typename?: 'StandardStopEntity', stopType?: StopType | null, uuid: string, notes?: string | null, standardStopType?: StandardStopType | null, appointmentTextStatus?: AppointmentTextStatus | null, appointmentTime?: any | null, endAppointmentTime?: any | null, proofOfDeliverySignee?: string | null, inboundMethod?: InboundMethod | null, expectedInboundArrivalDate?: any | null, outboundMethod?: OutboundMethod | null, completedAt?: any | null, createdAt: any, status: StopStatus, isSpecial?: boolean | null, paperworkMarkedComplete?: boolean | null, contactPerson?: { __typename?: 'ContactPersonEntity', phone?: string | null, email?: string | null, firstName?: string | null, lastName?: string | null } | null, address: { __typename?: 'AddressEntity', uuid: string, name: string, line1: string, line2?: string | null, city: string, state: string, latitude?: number | null, longitude?: number | null, zip: string }, terminal?: { __typename?: 'TerminalEntity', name: string } | null }, previousStopAttempts: Array<{ __typename?: 'StandardStopEntity', completedAt?: any | null }> }> }> };

export type StandardOrderForContextMenuFragment = { __typename?: 'StandardOrderEntity', uuid: string, name: string, refusedBy?: string | null, pickedDate?: any | null, pieceCount?: number | null, onHand?: boolean | null, notes: string, status: OrderStatus, detailedStatus?: string | null, detailedStatusV2?: OrderDetailedStatus | null, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', shipperBillOfLadingNumber?: string | null }, endStop?: { __typename?: 'StandardStopEntity', uuid: string, stopType?: StopType | null, leg: { __typename?: 'LegEntity', shipment: { __typename?: 'StandardShipmentEntity', standardShipmentFields: { __typename?: 'StandardShipmentFieldsEntity', pickupOrDelivery: PickupOrDelivery } } }, terminal?: { __typename?: 'TerminalEntity', uuid: string } | null, address: { __typename?: 'AddressEntity', line1: string } } | null, shipments: Array<{ __typename?: 'StandardShipmentEntity', standardShipmentFields: { __typename?: 'StandardShipmentFieldsEntity', pickupOrDelivery: PickupOrDelivery }, fields?: { __typename?: 'StandardShipmentFieldsEntity', pickupOrDelivery: PickupOrDelivery, outboundMethod?: OutboundMethod | null, inboundMethod?: InboundMethod | null } | null, legs: Array<{ __typename?: 'LegEntity', endStop: { __typename?: 'StandardStopEntity', stopType?: StopType | null, uuid: string, status: StopStatus, proofOfDeliverySignee?: string | null, completedAt?: any | null, routeSlot?: { __typename?: 'RouteSlotEntity', route?: { __typename?: 'RouteEntity', date: any } | null } | null, address: { __typename?: 'AddressEntity', name: string } } }> }> };

export type StandardOrderForContextMenuQueryVariables = Exact<{
  uuid: Scalars['String']['input'];
}>;


export type StandardOrderForContextMenuQuery = { __typename?: 'Query', standardOrder: { __typename?: 'StandardOrderEntity', uuid: string, name: string, refusedBy?: string | null, pickedDate?: any | null, pieceCount?: number | null, onHand?: boolean | null, notes: string, status: OrderStatus, detailedStatus?: string | null, detailedStatusV2?: OrderDetailedStatus | null, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', shipperBillOfLadingNumber?: string | null }, endStop?: { __typename?: 'StandardStopEntity', uuid: string, stopType?: StopType | null, leg: { __typename?: 'LegEntity', shipment: { __typename?: 'StandardShipmentEntity', standardShipmentFields: { __typename?: 'StandardShipmentFieldsEntity', pickupOrDelivery: PickupOrDelivery } } }, terminal?: { __typename?: 'TerminalEntity', uuid: string } | null, address: { __typename?: 'AddressEntity', line1: string } } | null, shipments: Array<{ __typename?: 'StandardShipmentEntity', standardShipmentFields: { __typename?: 'StandardShipmentFieldsEntity', pickupOrDelivery: PickupOrDelivery }, fields?: { __typename?: 'StandardShipmentFieldsEntity', pickupOrDelivery: PickupOrDelivery, outboundMethod?: OutboundMethod | null, inboundMethod?: InboundMethod | null } | null, legs: Array<{ __typename?: 'LegEntity', endStop: { __typename?: 'StandardStopEntity', stopType?: StopType | null, uuid: string, status: StopStatus, proofOfDeliverySignee?: string | null, completedAt?: any | null, routeSlot?: { __typename?: 'RouteSlotEntity', route?: { __typename?: 'RouteEntity', date: any } | null } | null, address: { __typename?: 'AddressEntity', name: string } } }> }> } };

export type OrderForDocumentAttachmentsDownloadFragment = { __typename?: 'StandardOrderEntity', uuid: string, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', shipperBillOfLadingNumber?: string | null }, documents: Array<{ __typename?: 'DocumentEntity', uuid: string, fileName: string, bucket: string, region: string, key: string, uploadedAt?: any | null, fileType: string, isDeleted: boolean, preSignedGetUrl: string, name?: string | null, type: DocumentType, pageNumber?: number | null, createdAt: any, notes?: string | null, order?: { __typename?: 'StandardOrderEntity', uuid: string, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', shipperBillOfLadingNumber?: string | null } } | null, shipment?: { __typename?: 'StandardOrderEntity', uuid: string } | null, driverFormTemplate?: { __typename?: 'DriverSignableFormTemplateEntity', uuid: string, title: string, formText: string } | null }> };

export type OrdersForDocumentAttachmentsDownloadQueryVariables = Exact<{
  uuids: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type OrdersForDocumentAttachmentsDownloadQuery = { __typename?: 'Query', ordersByUuids: Array<{ __typename?: 'StandardOrderEntity', uuid: string, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', shipperBillOfLadingNumber?: string | null }, documents: Array<{ __typename?: 'DocumentEntity', uuid: string, fileName: string, bucket: string, region: string, key: string, uploadedAt?: any | null, fileType: string, isDeleted: boolean, preSignedGetUrl: string, name?: string | null, type: DocumentType, pageNumber?: number | null, createdAt: any, notes?: string | null, order?: { __typename?: 'StandardOrderEntity', uuid: string, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', shipperBillOfLadingNumber?: string | null } } | null, shipment?: { __typename?: 'StandardOrderEntity', uuid: string } | null, driverFormTemplate?: { __typename?: 'DriverSignableFormTemplateEntity', uuid: string, title: string, formText: string } | null }> }> };

export type OrderForInventoryLabelFragment = { __typename?: 'StandardOrderEntity', uuid: string, name: string, refNumbers: Array<string>, billingPartyContact: { __typename?: 'CustomerContactEntity', uuid: string, displayName: string, referenceNumberLabels: Array<{ __typename?: 'ReferenceNumberLabelEntity', name: string }> }, company: { __typename?: 'CompanyEntity', name: string, defaultWeightUnits: WeightUnits, configuration?: { __typename?: 'CompanyConfigurationEntity', terminalsEnabled: boolean } | null, referenceNumberLabels: Array<{ __typename?: 'ReferenceNumberLabelEntity', name: string }> }, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', shipperBillOfLadingNumber?: string | null, masterAirwayBillOfLadingNumber?: string | null, weightUnits: WeightUnits }, packages: Array<{ __typename?: 'PackageEntity', uuid: string, class?: number | null, description: string, hazmat?: boolean | null, height?: number | null, length?: number | null, nmfc?: string | null, quantity: number, skuNumber?: string | null, type?: PackageType | null, weight?: number | null, width?: number | null, quantityCompletedAtStop?: number | null, reasonUncompletedAtStop?: string | null, packageSpec?: { __typename?: 'PackageSpecEntity', id: string, name: string } | null, warehouseLocation?: { __typename?: 'WarehouseLocationEntity', uuid: string, name: string } | null }>, shipments: Array<{ __typename?: 'StandardShipmentEntity', uuid: string, standardShipmentFields: { __typename?: 'StandardShipmentFieldsEntity', pickupOrDelivery: PickupOrDelivery, deadlineDate?: any | null }, airportInfo?: { __typename?: 'AirportInfoEntity', iataCode: string, terminal: string } | null, legs: Array<{ __typename?: 'LegEntity', endStop: { __typename?: 'StandardStopEntity', uuid: string, stopType?: StopType | null, status: StopStatus, destinationAirport?: string | null, inboundMethod?: InboundMethod | null, outboundMethod?: OutboundMethod | null, incomingCarrier?: string | null, outboundCarrier?: string | null, address: { __typename?: 'AddressEntity', uuid: string, name: string, line1: string, line2?: string | null, city: string, state: string, zip: string, country: string, latitude?: number | null, longitude?: number | null, driverInstructions?: string | null, receivingHoursStart?: any | null, receivingHoursEnd?: any | null, specialInstructions?: string | null }, terminal?: { __typename?: 'TerminalEntity', uuid: string, code: string } | null } }> }> };

export type OrderForOrderMatchingFragment = { __typename?: 'StandardOrderEntity', uuid: string, name: string, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', shipperBillOfLadingNumber?: string | null }, shipments: Array<{ __typename?: 'StandardShipmentEntity', uuid: string, standardShipmentFields: { __typename?: 'StandardShipmentFieldsEntity', pickupOrDelivery: PickupOrDelivery }, legs: Array<{ __typename?: 'LegEntity', endStop: { __typename?: 'StandardStopEntity', address: { __typename?: 'AddressEntity', uuid: string, name: string, line1: string, line2?: string | null, city: string, state: string, zip: string, country: string, latitude?: number | null, longitude?: number | null, driverInstructions?: string | null, receivingHoursStart?: any | null, receivingHoursEnd?: any | null, specialInstructions?: string | null } } }> }> };

export type OrderForOrdersByShipperBillOfLadingNumberFragment = { __typename?: 'StandardOrderEntity', uuid: string, createdAt: any, name: string, receivedDate?: any | null, onHand?: boolean | null, source: OrderSource, isDraftOrder: boolean, shipments: Array<{ __typename?: 'StandardShipmentEntity', uuid: string }>, scannedOrderResult?: { __typename?: 'ScannedOrderResultEntity', uuid: string, status: ScannedOrderResultStatus } | null, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', shipperBillOfLadingNumber?: string | null } };

export type OrderNameQueryVariables = Exact<{
  billingPartyContactUuid: Scalars['String']['input'];
}>;


export type OrderNameQuery = { __typename?: 'Query', orderName: string };

export type OrderPodReportShipmentFragment = { __typename?: 'StandardShipmentEntity', uuid: string, ordinal: number, totalFreightChargesAmount: number, totalFuelChargesAmount: number, totalChargesAmount: number, shipmentType: ShipmentType, standardShipmentFields: { __typename?: 'StandardShipmentFieldsEntity', deadlineDate?: any | null, pickupOrDelivery: PickupOrDelivery }, documents: Array<{ __typename?: 'DocumentEntity', uuid: string, fileName: string, bucket: string, region: string, key: string, uploadedAt?: any | null, fileType: string, isDeleted: boolean, preSignedGetUrl: string, name?: string | null, type: DocumentType, pageNumber?: number | null, createdAt: any, notes?: string | null, order?: { __typename?: 'StandardOrderEntity', uuid: string, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', shipperBillOfLadingNumber?: string | null } } | null, shipment?: { __typename?: 'StandardOrderEntity', uuid: string } | null, driverFormTemplate?: { __typename?: 'DriverSignableFormTemplateEntity', uuid: string, title: string, formText: string } | null }>, packages: Array<{ __typename?: 'PackageEntity', description: string, weight?: number | null, quantity: number, length?: number | null, width?: number | null, height?: number | null }>, legs: Array<{ __typename?: 'LegEntity', endStop: { __typename?: 'StandardStopEntity', stopType?: StopType | null, status: StopStatus, appointmentTime?: any | null, endAppointmentTime?: any | null, completedAt?: any | null, specialInstructions?: string | null, proofOfDeliverySignee?: string | null, paperworkMarkedComplete?: boolean | null, address: { __typename?: 'AddressEntity', uuid: string, name: string, line1: string, line2?: string | null, city: string, state: string, zip: string, country: string, latitude?: number | null, longitude?: number | null, driverInstructions?: string | null, receivingHoursStart?: any | null, receivingHoursEnd?: any | null, specialInstructions?: string | null }, contactPerson?: { __typename?: 'ContactPersonEntity', phone?: string | null, email?: string | null, firstName?: string | null, lastName?: string | null } | null, routeSlot?: { __typename?: 'RouteSlotEntity', route?: { __typename?: 'RouteEntity', name: string, drivers: Array<{ __typename?: 'DriverEntity', firstName: string, lastName: string }> } | null } | null } }>, order?: { __typename?: 'StandardOrderEntity', uuid: string, name: string, secondaryRefNumber?: string | null, totalCharge: number, totalFreightChargesAmount: number, totalFuelChargesAmount: number, totalCustomChargesAmount: number, notes: string, ordinal: number, billingPartyContact: { __typename?: 'CustomerContactEntity', uuid: string, displayName: string }, orderEvents: Array<{ __typename?: 'OrderEventEntity', eventType: OrderEventType, sourceType: OrderEventSourceType, createdAt: any, sourceUser?: { __typename?: 'UserEntity', email: string } | null }>, company: { __typename?: 'CompanyEntity', name: string, defaultAddress?: { __typename?: 'AddressEntity', uuid: string, name: string, line1: string, line2?: string | null, city: string, state: string, zip: string, country: string, latitude?: number | null, longitude?: number | null, driverInstructions?: string | null, receivingHoursStart?: any | null, receivingHoursEnd?: any | null, specialInstructions?: string | null } | null }, shipments: Array<{ __typename?: 'StandardShipmentEntity', customCharges: Array<{ __typename?: 'CustomChargeEntity', authoCode?: string | null, name: string, total: number, accessorialTemplate?: { __typename?: 'SkidBasedAccessorialEntity', name: string } | { __typename?: 'SpecialAccessorialEntity', name: string } | { __typename?: 'StandardAccessorialEntity', name: string } | { __typename?: 'UnitBasedAccessorialEntity', name: string } | { __typename?: 'WaitTimeAccessorialEntity', name: string } | { __typename?: 'WeightBasedAccessorialEntity', name: string } | { __typename?: 'ZoneBasedAccessorialEntity', name: string } | null }> }>, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', masterAirwayBillOfLadingNumber?: string | null, shipperBillOfLadingNumber?: string | null }, service?: { __typename?: 'ServiceEntity', name: string } | null } | null, charges: Array<{ __typename?: 'CustomChargeEntity', uuid: string, authoCode?: string | null, name: string, zoneBasedAccessorialZoneUuid?: string | null, zoneBasedAccessorialChargeGroupUuid?: string | null, specialAccessorialTariffZoneUuid?: string | null, specialAccessorialChargeGroupUuid?: string | null, quantity: number, description?: string | null, rate: number, total: number, customChargeBillingMethod: CustomChargeBillingMethod, accessorialTemplate?: { __typename: 'SkidBasedAccessorialEntity', uuid: string, name: string } | { __typename: 'SpecialAccessorialEntity', uuid: string, name: string } | { __typename: 'StandardAccessorialEntity', uuid: string, name: string } | { __typename: 'UnitBasedAccessorialEntity', uuid: string, name: string } | { __typename: 'WaitTimeAccessorialEntity', uuid: string, name: string } | { __typename: 'WeightBasedAccessorialEntity', uuid: string, name: string } | { __typename: 'ZoneBasedAccessorialEntity', uuid: string, name: string } | null } | { __typename?: 'FreightChargeEntity', uuid: string, authoCode?: string | null, billingMethod: FreightBillingMethod, rate: number, description?: string | null, quantity: number, tariff?: { __typename?: 'TariffEntity', uuid: string, billingPartyContactUuid?: string | null, tariffOverageRates: Array<{ __typename?: 'TariffOverageRateEntity', uuid: string, name: string, type: TariffOverageRateType, rateUsdCents: number, applicableAboveAmount: number }> } | null, fuelCharge?: { __typename?: 'FuelChargeEntity', description?: string | null, authoCode?: string | null, surchargeRate: number, flatRate: number, type: FuelBillingMethod, uuid: string } | null }> };

export type OrderPodReportsQueryVariables = Exact<{
  getShipmentsInput?: InputMaybe<GetShipmentsInput>;
}>;


export type OrderPodReportsQuery = { __typename?: 'Query', shipments: Array<{ __typename?: 'StandardShipmentEntity', uuid: string, ordinal: number, totalFreightChargesAmount: number, totalFuelChargesAmount: number, totalChargesAmount: number, shipmentType: ShipmentType, standardShipmentFields: { __typename?: 'StandardShipmentFieldsEntity', deadlineDate?: any | null, pickupOrDelivery: PickupOrDelivery }, documents: Array<{ __typename?: 'DocumentEntity', uuid: string, fileName: string, bucket: string, region: string, key: string, uploadedAt?: any | null, fileType: string, isDeleted: boolean, preSignedGetUrl: string, name?: string | null, type: DocumentType, pageNumber?: number | null, createdAt: any, notes?: string | null, order?: { __typename?: 'StandardOrderEntity', uuid: string, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', shipperBillOfLadingNumber?: string | null } } | null, shipment?: { __typename?: 'StandardOrderEntity', uuid: string } | null, driverFormTemplate?: { __typename?: 'DriverSignableFormTemplateEntity', uuid: string, title: string, formText: string } | null }>, packages: Array<{ __typename?: 'PackageEntity', description: string, weight?: number | null, quantity: number, length?: number | null, width?: number | null, height?: number | null }>, legs: Array<{ __typename?: 'LegEntity', endStop: { __typename?: 'StandardStopEntity', stopType?: StopType | null, status: StopStatus, appointmentTime?: any | null, endAppointmentTime?: any | null, completedAt?: any | null, specialInstructions?: string | null, proofOfDeliverySignee?: string | null, paperworkMarkedComplete?: boolean | null, address: { __typename?: 'AddressEntity', uuid: string, name: string, line1: string, line2?: string | null, city: string, state: string, zip: string, country: string, latitude?: number | null, longitude?: number | null, driverInstructions?: string | null, receivingHoursStart?: any | null, receivingHoursEnd?: any | null, specialInstructions?: string | null }, contactPerson?: { __typename?: 'ContactPersonEntity', phone?: string | null, email?: string | null, firstName?: string | null, lastName?: string | null } | null, routeSlot?: { __typename?: 'RouteSlotEntity', route?: { __typename?: 'RouteEntity', name: string, drivers: Array<{ __typename?: 'DriverEntity', firstName: string, lastName: string }> } | null } | null } }>, order?: { __typename?: 'StandardOrderEntity', uuid: string, name: string, secondaryRefNumber?: string | null, totalCharge: number, totalFreightChargesAmount: number, totalFuelChargesAmount: number, totalCustomChargesAmount: number, notes: string, ordinal: number, billingPartyContact: { __typename?: 'CustomerContactEntity', uuid: string, displayName: string }, orderEvents: Array<{ __typename?: 'OrderEventEntity', eventType: OrderEventType, sourceType: OrderEventSourceType, createdAt: any, sourceUser?: { __typename?: 'UserEntity', email: string } | null }>, company: { __typename?: 'CompanyEntity', name: string, defaultAddress?: { __typename?: 'AddressEntity', uuid: string, name: string, line1: string, line2?: string | null, city: string, state: string, zip: string, country: string, latitude?: number | null, longitude?: number | null, driverInstructions?: string | null, receivingHoursStart?: any | null, receivingHoursEnd?: any | null, specialInstructions?: string | null } | null }, shipments: Array<{ __typename?: 'StandardShipmentEntity', customCharges: Array<{ __typename?: 'CustomChargeEntity', authoCode?: string | null, name: string, total: number, accessorialTemplate?: { __typename?: 'SkidBasedAccessorialEntity', name: string } | { __typename?: 'SpecialAccessorialEntity', name: string } | { __typename?: 'StandardAccessorialEntity', name: string } | { __typename?: 'UnitBasedAccessorialEntity', name: string } | { __typename?: 'WaitTimeAccessorialEntity', name: string } | { __typename?: 'WeightBasedAccessorialEntity', name: string } | { __typename?: 'ZoneBasedAccessorialEntity', name: string } | null }> }>, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', masterAirwayBillOfLadingNumber?: string | null, shipperBillOfLadingNumber?: string | null }, service?: { __typename?: 'ServiceEntity', name: string } | null } | null, charges: Array<{ __typename?: 'CustomChargeEntity', uuid: string, authoCode?: string | null, name: string, zoneBasedAccessorialZoneUuid?: string | null, zoneBasedAccessorialChargeGroupUuid?: string | null, specialAccessorialTariffZoneUuid?: string | null, specialAccessorialChargeGroupUuid?: string | null, quantity: number, description?: string | null, rate: number, total: number, customChargeBillingMethod: CustomChargeBillingMethod, accessorialTemplate?: { __typename: 'SkidBasedAccessorialEntity', uuid: string, name: string } | { __typename: 'SpecialAccessorialEntity', uuid: string, name: string } | { __typename: 'StandardAccessorialEntity', uuid: string, name: string } | { __typename: 'UnitBasedAccessorialEntity', uuid: string, name: string } | { __typename: 'WaitTimeAccessorialEntity', uuid: string, name: string } | { __typename: 'WeightBasedAccessorialEntity', uuid: string, name: string } | { __typename: 'ZoneBasedAccessorialEntity', uuid: string, name: string } | null } | { __typename?: 'FreightChargeEntity', uuid: string, authoCode?: string | null, billingMethod: FreightBillingMethod, rate: number, description?: string | null, quantity: number, tariff?: { __typename?: 'TariffEntity', uuid: string, billingPartyContactUuid?: string | null, tariffOverageRates: Array<{ __typename?: 'TariffOverageRateEntity', uuid: string, name: string, type: TariffOverageRateType, rateUsdCents: number, applicableAboveAmount: number }> } | null, fuelCharge?: { __typename?: 'FuelChargeEntity', description?: string | null, authoCode?: string | null, surchargeRate: number, flatRate: number, type: FuelBillingMethod, uuid: string } | null }> }> };

export type OrderUpdatedAtQueryVariables = Exact<{
  uuid: Scalars['String']['input'];
}>;


export type OrderUpdatedAtQuery = { __typename?: 'Query', order?: { __typename?: 'StandardOrderEntity', updatedAt: any, lastUpdatedByUser?: { __typename?: 'UserEntity', uuid: string } | null } | null };

export type OrderQueryVariables = Exact<{
  uuid: Scalars['String']['input'];
}>;


export type OrderQuery = { __typename?: 'Query', order?: { __typename?: 'StandardOrderEntity', uuid: string, name: string, status: OrderStatus, notes: string, pieceCount?: number | null, receivedDate?: any | null, pickedDate?: any | null, onHand?: boolean | null, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', shipperBillOfLadingNumber?: string | null }, shipments: Array<{ __typename?: 'StandardShipmentEntity', uuid: string, packages: Array<{ __typename?: 'PackageEntity', description: string }> }>, documents: Array<{ __typename?: 'DocumentEntity', uuid: string, fileName: string, bucket: string, region: string, key: string, uploadedAt?: any | null, fileType: string, isDeleted: boolean, preSignedGetUrl: string, name?: string | null, type: DocumentType, pageNumber?: number | null, createdAt: any, notes?: string | null, order?: { __typename?: 'StandardOrderEntity', uuid: string, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', shipperBillOfLadingNumber?: string | null } } | null, shipment?: { __typename?: 'StandardOrderEntity', uuid: string } | null, driverFormTemplate?: { __typename?: 'DriverSignableFormTemplateEntity', uuid: string, title: string, formText: string } | null }> } | null };

export type OrdersBySecondaryRefNumberQueryVariables = Exact<{
  secondaryRefNumber: Scalars['String']['input'];
}>;


export type OrdersBySecondaryRefNumberQuery = { __typename?: 'Query', ordersBySecondaryRefNumber: Array<{ __typename?: 'StandardOrderEntity', uuid: string, createdAt: any, name: string }> };

export type OrdersByShipperBillOfLadingNumberQueryVariables = Exact<{
  shipperBillOfLadingNumber: Scalars['String']['input'];
  includeInReviewScannedOrdersFromEmail?: InputMaybe<Scalars['Boolean']['input']>;
  includeInReviewEdiOrders?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type OrdersByShipperBillOfLadingNumberQuery = { __typename?: 'Query', ordersByShipperBillOfLadingNumber: Array<{ __typename?: 'StandardOrderEntity', uuid: string, createdAt: any, name: string, receivedDate?: any | null, onHand?: boolean | null, source: OrderSource, isDraftOrder: boolean, shipments: Array<{ __typename?: 'StandardShipmentEntity', uuid: string }>, scannedOrderResult?: { __typename?: 'ScannedOrderResultEntity', uuid: string, status: ScannedOrderResultStatus } | null, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', shipperBillOfLadingNumber?: string | null } }> };

export type OrdersByUuidsForBulkEditQueryVariables = Exact<{
  uuids: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type OrdersByUuidsForBulkEditQuery = { __typename?: 'Query', ordersByUuids: Array<{ __typename?: 'StandardOrderEntity', uuid: string, status: OrderStatus, onHand?: boolean | null, pickedDate?: any | null, pieceCount?: number | null, detailedStatusV2?: OrderDetailedStatus | null, secondaryRefNumber?: string | null, warehouse?: { __typename?: 'WarehouseEntity', uuid: string, name: string } | null, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', shipperBillOfLadingNumber?: string | null, masterAirwayBillOfLadingNumber?: string | null }, shipments: Array<{ __typename?: 'StandardShipmentEntity', uuid: string, shipmentType: ShipmentType, standardShipmentFields: { __typename?: 'StandardShipmentFieldsEntity', deadlineDate?: any | null, deadlineType?: DeadlineType | null, pickupOrDelivery: PickupOrDelivery }, legs: Array<{ __typename?: 'LegEntity', uuid: string, endStop: { __typename?: 'StandardStopEntity', stopType?: StopType | null, uuid: string, notes?: string | null, standardStopType?: StandardStopType | null, appointmentTextStatus?: AppointmentTextStatus | null, appointmentTime?: any | null, endAppointmentTime?: any | null, proofOfDeliverySignee?: string | null, inboundMethod?: InboundMethod | null, expectedInboundArrivalDate?: any | null, outboundMethod?: OutboundMethod | null, completedAt?: any | null, createdAt: any, status: StopStatus, isSpecial?: boolean | null, paperworkMarkedComplete?: boolean | null, contactPerson?: { __typename?: 'ContactPersonEntity', phone?: string | null, email?: string | null, firstName?: string | null, lastName?: string | null } | null, address: { __typename?: 'AddressEntity', uuid: string, name: string, line1: string, line2?: string | null, city: string, state: string, latitude?: number | null, longitude?: number | null, zip: string }, terminal?: { __typename?: 'TerminalEntity', name: string } | null }, previousStopAttempts: Array<{ __typename?: 'StandardStopEntity', completedAt?: any | null }> }> }> }> };

export type OrdersForBulkEditQueryVariables = Exact<{
  addressCityFilter?: InputMaybe<StringFilter>;
  addressZipFilter?: InputMaybe<StringFilter>;
  attemptedAtDateFilters?: InputMaybe<DateFilterStartEnd>;
  completionDateFilters?: InputMaybe<DateFilterStartEnd>;
  deadlineDateFilters?: InputMaybe<DateFilterStartEnd>;
  receivedDateFilters?: InputMaybe<DateFilterStartEnd>;
  createdAtDateFilters?: InputMaybe<DateFilterStartEnd>;
  expectedInboundArrivalDateFilters?: InputMaybe<DateFilterStartEnd>;
  invoiceDateFilters?: InputMaybe<DateFilterStartEnd>;
  scheduledAtDateFilters?: InputMaybe<DateFilterStartEnd>;
  primaryAppointmentDateFilters?: InputMaybe<DateFilterStartEnd>;
  orderNumberFilter?: InputMaybe<StringFilter>;
  billingPartyContactUuidFilter?: InputMaybe<StringFilter>;
  businessDivisionUuidFilter?: InputMaybe<StringFilter>;
  terminalUuidFilter?: InputMaybe<StringFilter>;
  activeTerminalUuidFilter?: InputMaybe<StringFilter>;
  originTerminalUuidFilter?: InputMaybe<StringFilterNullable>;
  destinationTerminalUuidFilter?: InputMaybe<StringFilterNullable>;
  driverUuidFilter?: InputMaybe<StringFilter>;
  shipperFilter?: InputMaybe<StringFilter>;
  consigneeFilter?: InputMaybe<StringFilter>;
  statusFilters?: InputMaybe<Array<StatusFilter> | StatusFilter>;
  shipmentStatusFilters?: InputMaybe<Array<ShipmentStatusFilter> | ShipmentStatusFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  searchText?: InputMaybe<Scalars['String']['input']>;
  multipleSearches?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  scheduledFilter?: InputMaybe<BooleanFilter>;
  outForDeliveryFilter?: InputMaybe<BooleanFilter>;
  onHand?: InputMaybe<BooleanFilter>;
  onInvoice?: InputMaybe<BooleanFilter>;
  isCancelled?: InputMaybe<BooleanFilter>;
  isRefused?: InputMaybe<BooleanFilter>;
  isFinalized?: InputMaybe<BooleanFilter>;
  isPicked?: InputMaybe<BooleanFilter>;
  isOsd?: InputMaybe<BooleanFilter>;
  isSpecial?: InputMaybe<BooleanFilter>;
  orderSource?: InputMaybe<OrderSource>;
  noMaximum?: InputMaybe<Scalars['Boolean']['input']>;
  hasAppointmentScheduled?: InputMaybe<BooleanFilter>;
  appointmentRequired?: InputMaybe<BooleanFilter>;
  hasContactInformation?: InputMaybe<BooleanFilter>;
  hasFailures?: InputMaybe<BooleanFilter>;
  hasRoute?: InputMaybe<BooleanFilter>;
  hawbFilter?: InputMaybe<StringFilterV2>;
  mawbFilter?: InputMaybe<StringFilterV2>;
  hideFromBilling?: InputMaybe<BooleanFilter>;
  paperworkComplete?: InputMaybe<BooleanFilter>;
  pickupOrDelivery?: InputMaybe<PickupOrDelivery>;
  isPickupOrDelivery?: InputMaybe<BooleanFilter>;
  inboundNotArrived?: InputMaybe<BooleanFilter>;
  requiresRouting?: InputMaybe<BooleanFilter>;
  requiresRecovery?: InputMaybe<BooleanFilter>;
  serviceDateFilters?: InputMaybe<DateFilterStartEnd>;
  serviceDateFilter?: InputMaybe<DateFilterV2>;
  serviceUuids?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  lineHaulLaneUuids?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  showConsolidatedOrders?: InputMaybe<BooleanFilter>;
  standardStopType?: InputMaybe<StandardStopType>;
  stopTypesFilter?: InputMaybe<StopTypesFilter>;
  tagUuids?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  totalCount?: InputMaybe<Scalars['Boolean']['input']>;
  transferPending?: InputMaybe<BooleanFilter>;
  uuids?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  searchHawbOnly?: InputMaybe<Scalars['Boolean']['input']>;
  searchRefNumbersOnly?: InputMaybe<Scalars['Boolean']['input']>;
  searchMiscInfoOnly?: InputMaybe<Scalars['Boolean']['input']>;
  useMultiSearch?: InputMaybe<Scalars['Boolean']['input']>;
  sorts?: InputMaybe<Array<OrderSort> | OrderSort>;
  noTerminal?: InputMaybe<BooleanFilter>;
  billingPartyContactUuidsFilter?: InputMaybe<StringsFilter>;
  terminalUuidsFilter?: InputMaybe<StringsFilter>;
  driverUuidsFilter?: InputMaybe<StringsFilter>;
  tagUuidsFilter?: InputMaybe<StringsFilter>;
  canDispatchFilter?: InputMaybe<BooleanFilterV2>;
  inboundRoutingFilter?: InputMaybe<StringFilterV2>;
  outboundRoutingFilter?: InputMaybe<StringFilterV2>;
  proofOfDeliverySigneeFilter?: InputMaybe<StringFilterV2>;
}>;


export type OrdersForBulkEditQuery = { __typename?: 'Query', orders: { __typename?: 'OrderConnection', totalCount?: number | null, edges: Array<{ __typename?: 'OrderEdge', node: { __typename?: 'StandardOrderEntity', uuid: string, status: OrderStatus, onHand?: boolean | null, pickedDate?: any | null, pieceCount?: number | null, detailedStatusV2?: OrderDetailedStatus | null, secondaryRefNumber?: string | null, warehouse?: { __typename?: 'WarehouseEntity', uuid: string, name: string } | null, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', shipperBillOfLadingNumber?: string | null, masterAirwayBillOfLadingNumber?: string | null }, shipments: Array<{ __typename?: 'StandardShipmentEntity', uuid: string, shipmentType: ShipmentType, standardShipmentFields: { __typename?: 'StandardShipmentFieldsEntity', deadlineDate?: any | null, deadlineType?: DeadlineType | null, pickupOrDelivery: PickupOrDelivery }, legs: Array<{ __typename?: 'LegEntity', uuid: string, endStop: { __typename?: 'StandardStopEntity', stopType?: StopType | null, uuid: string, notes?: string | null, standardStopType?: StandardStopType | null, appointmentTextStatus?: AppointmentTextStatus | null, appointmentTime?: any | null, endAppointmentTime?: any | null, proofOfDeliverySignee?: string | null, inboundMethod?: InboundMethod | null, expectedInboundArrivalDate?: any | null, outboundMethod?: OutboundMethod | null, completedAt?: any | null, createdAt: any, status: StopStatus, isSpecial?: boolean | null, paperworkMarkedComplete?: boolean | null, contactPerson?: { __typename?: 'ContactPersonEntity', phone?: string | null, email?: string | null, firstName?: string | null, lastName?: string | null } | null, address: { __typename?: 'AddressEntity', uuid: string, name: string, line1: string, line2?: string | null, city: string, state: string, latitude?: number | null, longitude?: number | null, zip: string }, terminal?: { __typename?: 'TerminalEntity', name: string } | null }, previousStopAttempts: Array<{ __typename?: 'StandardStopEntity', completedAt?: any | null }> }> }> } }>, pageInfo: { __typename?: 'PageInfo', startCursor?: string | null, endCursor?: string | null, hasNextPage: boolean, hasPreviousPage: boolean } } };

export type OrdersForInventoryLabelsQueryVariables = Exact<{
  uuids: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type OrdersForInventoryLabelsQuery = { __typename?: 'Query', ordersByUuids: Array<{ __typename?: 'StandardOrderEntity', uuid: string, name: string, refNumbers: Array<string>, billingPartyContact: { __typename?: 'CustomerContactEntity', uuid: string, displayName: string, referenceNumberLabels: Array<{ __typename?: 'ReferenceNumberLabelEntity', name: string }> }, company: { __typename?: 'CompanyEntity', name: string, defaultWeightUnits: WeightUnits, configuration?: { __typename?: 'CompanyConfigurationEntity', terminalsEnabled: boolean } | null, referenceNumberLabels: Array<{ __typename?: 'ReferenceNumberLabelEntity', name: string }> }, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', shipperBillOfLadingNumber?: string | null, masterAirwayBillOfLadingNumber?: string | null, weightUnits: WeightUnits }, packages: Array<{ __typename?: 'PackageEntity', uuid: string, class?: number | null, description: string, hazmat?: boolean | null, height?: number | null, length?: number | null, nmfc?: string | null, quantity: number, skuNumber?: string | null, type?: PackageType | null, weight?: number | null, width?: number | null, quantityCompletedAtStop?: number | null, reasonUncompletedAtStop?: string | null, packageSpec?: { __typename?: 'PackageSpecEntity', id: string, name: string } | null, warehouseLocation?: { __typename?: 'WarehouseLocationEntity', uuid: string, name: string } | null }>, shipments: Array<{ __typename?: 'StandardShipmentEntity', uuid: string, standardShipmentFields: { __typename?: 'StandardShipmentFieldsEntity', pickupOrDelivery: PickupOrDelivery, deadlineDate?: any | null }, airportInfo?: { __typename?: 'AirportInfoEntity', iataCode: string, terminal: string } | null, legs: Array<{ __typename?: 'LegEntity', endStop: { __typename?: 'StandardStopEntity', uuid: string, stopType?: StopType | null, status: StopStatus, destinationAirport?: string | null, inboundMethod?: InboundMethod | null, outboundMethod?: OutboundMethod | null, incomingCarrier?: string | null, outboundCarrier?: string | null, address: { __typename?: 'AddressEntity', uuid: string, name: string, line1: string, line2?: string | null, city: string, state: string, zip: string, country: string, latitude?: number | null, longitude?: number | null, driverInstructions?: string | null, receivingHoursStart?: any | null, receivingHoursEnd?: any | null, specialInstructions?: string | null }, terminal?: { __typename?: 'TerminalEntity', uuid: string, code: string } | null } }> }> }> };

export type OrdersForOrderMatchingQueryVariables = Exact<{
  addressCityFilter?: InputMaybe<StringFilter>;
  addressZipFilter?: InputMaybe<StringFilter>;
  attemptedAtDateFilters?: InputMaybe<DateFilterStartEnd>;
  completionDateFilters?: InputMaybe<DateFilterStartEnd>;
  deadlineDateFilters?: InputMaybe<DateFilterStartEnd>;
  receivedDateFilters?: InputMaybe<DateFilterStartEnd>;
  createdAtDateFilters?: InputMaybe<DateFilterStartEnd>;
  expectedInboundArrivalDateFilters?: InputMaybe<DateFilterStartEnd>;
  invoiceDateFilters?: InputMaybe<DateFilterStartEnd>;
  scheduledAtDateFilters?: InputMaybe<DateFilterStartEnd>;
  orderNumberFilter?: InputMaybe<StringFilter>;
  billingPartyContactUuidFilter?: InputMaybe<StringFilter>;
  driverUuidFilter?: InputMaybe<StringFilter>;
  shipperFilter?: InputMaybe<StringFilter>;
  consigneeFilter?: InputMaybe<StringFilter>;
  statusFilters?: InputMaybe<Array<StatusFilter> | StatusFilter>;
  shipmentStatusFilters?: InputMaybe<Array<ShipmentStatusFilter> | ShipmentStatusFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  searchText?: InputMaybe<Scalars['String']['input']>;
  scheduledFilter?: InputMaybe<BooleanFilter>;
  outForDeliveryFilter?: InputMaybe<BooleanFilter>;
  onHand?: InputMaybe<BooleanFilter>;
  onInvoice?: InputMaybe<BooleanFilter>;
  isCancelled?: InputMaybe<BooleanFilter>;
  isRefused?: InputMaybe<BooleanFilter>;
  isFinalized?: InputMaybe<BooleanFilter>;
  isPicked?: InputMaybe<BooleanFilter>;
  isOsd?: InputMaybe<BooleanFilter>;
  isSpecial?: InputMaybe<BooleanFilter>;
  orderSource?: InputMaybe<OrderSource>;
  noMaximum?: InputMaybe<Scalars['Boolean']['input']>;
  hasAppointmentScheduled?: InputMaybe<BooleanFilter>;
  appointmentRequired?: InputMaybe<BooleanFilter>;
  hasContactInformation?: InputMaybe<BooleanFilter>;
  hasFailures?: InputMaybe<BooleanFilter>;
  hasRoute?: InputMaybe<BooleanFilter>;
  hideFromBilling?: InputMaybe<BooleanFilter>;
  paperworkComplete?: InputMaybe<BooleanFilter>;
  pickupOrDelivery?: InputMaybe<PickupOrDelivery>;
  isPickupOrDelivery?: InputMaybe<BooleanFilter>;
  inboundNotArrived?: InputMaybe<BooleanFilter>;
  requiresRouting?: InputMaybe<BooleanFilter>;
  requiresRecovery?: InputMaybe<BooleanFilter>;
  serviceUuids?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  lineHaulLaneUuids?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  showConsolidatedOrders?: InputMaybe<BooleanFilter>;
  standardStopType?: InputMaybe<StandardStopType>;
  stopTypesFilter?: InputMaybe<StopTypesFilter>;
  tagUuids?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  totalCount?: InputMaybe<Scalars['Boolean']['input']>;
  transferPending?: InputMaybe<BooleanFilter>;
}>;


export type OrdersForOrderMatchingQuery = { __typename?: 'Query', orders: { __typename?: 'OrderConnection', totalCount?: number | null, edges: Array<{ __typename?: 'OrderEdge', node: { __typename?: 'StandardOrderEntity', uuid: string, name: string, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', shipperBillOfLadingNumber?: string | null }, shipments: Array<{ __typename?: 'StandardShipmentEntity', uuid: string, standardShipmentFields: { __typename?: 'StandardShipmentFieldsEntity', pickupOrDelivery: PickupOrDelivery }, legs: Array<{ __typename?: 'LegEntity', endStop: { __typename?: 'StandardStopEntity', address: { __typename?: 'AddressEntity', uuid: string, name: string, line1: string, line2?: string | null, city: string, state: string, zip: string, country: string, latitude?: number | null, longitude?: number | null, driverInstructions?: string | null, receivingHoursStart?: any | null, receivingHoursEnd?: any | null, specialInstructions?: string | null } } }> }> } }>, pageInfo: { __typename?: 'PageInfo', startCursor?: string | null, endCursor?: string | null, hasNextPage: boolean, hasPreviousPage: boolean } } };

type ContactForOrdersTable_CustomerContactEntity_Fragment = { __typename?: 'CustomerContactEntity', uuid: string, displayName: string, billingCycleDuration: BillingCycleDuration, invoiceTimePeriodSplit?: TimePeriod | null, numberOfOrdersPerInvoice?: number | null, businessDivision?: { __typename?: 'BusinessDivisionEntity', name: string } | null, masterAccount?: { __typename?: 'MasterAccountEntity', name: string } | null };

type ContactForOrdersTable_ThirdPartyContactEntity_Fragment = { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string, billingCycleDuration: BillingCycleDuration, invoiceTimePeriodSplit?: TimePeriod | null, numberOfOrdersPerInvoice?: number | null, businessDivision?: { __typename?: 'BusinessDivisionEntity', name: string } | null, masterAccount?: { __typename?: 'MasterAccountEntity', name: string } | null };

export type ContactForOrdersTableFragment = ContactForOrdersTable_CustomerContactEntity_Fragment | ContactForOrdersTable_ThirdPartyContactEntity_Fragment;

export type CreateOrderTableReportMutationVariables = Exact<{
  createOrderTableReportInput: CreateOrderTableReportInput;
}>;


export type CreateOrderTableReportMutation = { __typename?: 'Mutation', createOrderTableReport: { __typename?: 'MutationErrorOutput' } | { __typename?: 'OrderTableReportDownloadOutput', reportGenerationStatus: ReportGenerationStatus, reportUrl: string } | { __typename?: 'OrderTableReportEmailToUserOutput', reportGenerationStatus: ReportGenerationStatus } };

export type FormattedOrderFieldFragment = { __typename?: 'FormattedOrderFieldEntity', orderTableField: OrderTableField, value: string };

export type FormattedOrderFragment = { __typename?: 'FormattedOrderEntity', uuid: string, contactUuid: string, formattedOrderFields: Array<{ __typename?: 'FormattedOrderFieldEntity', orderTableField: OrderTableField, value: string }>, paperworkField?: { __typename?: 'OrderTablePaperworkFieldEntity', paperwork: { __typename?: 'OrderPaperworkEntity', paperworkComplete: boolean, paperworkMarkedCompleteOverride?: boolean | null, attachedDocuments?: Array<DocumentType> | null, missingDocuments?: Array<DocumentType> | null }, inboundPaperwork?: { __typename?: 'OrderPaperworkEntity', paperworkComplete: boolean, attachedDocuments?: Array<DocumentType> | null, missingDocuments?: Array<DocumentType> | null, alerts?: Array<DocumentType> | null, proofOfDeliveryOrPickupReadyToSign?: Array<DocumentType> | null, proofOfDeliveryOrPickupSigned?: Array<DocumentType> | null, photos?: Array<DocumentType> | null, other?: Array<DocumentType> | null } | null, outboundPaperwork?: { __typename?: 'OrderPaperworkEntity', paperworkComplete: boolean, attachedDocuments?: Array<DocumentType> | null, missingDocuments?: Array<DocumentType> | null, alerts?: Array<DocumentType> | null, proofOfDeliveryOrPickupReadyToSign?: Array<DocumentType> | null, proofOfDeliveryOrPickupSigned?: Array<DocumentType> | null, photos?: Array<DocumentType> | null, other?: Array<DocumentType> | null } | null } | null, tagsField?: { __typename?: 'OrderTableTagsFieldEntity', orderTableTags: Array<{ __typename?: 'OrderTableTagEntity', value: string, color?: string | null }> } | null, photosField?: { __typename?: 'OrderTablePhotosFieldEntity', orderTablePhotos: Array<{ __typename?: 'OrderTablePhotoEntity', shipmentUuid: string, shipmentPickupOrDelivery: PickupOrDelivery, fileName: string, type: DocumentType, preSignedGetUrl: string }> } | null, serviceField?: { __typename?: 'OrderTableServiceFieldEntity', service?: { __typename?: 'ServiceEntity', uuid: string, name: string } | null } | null, packagesField?: { __typename?: 'OrderTablePackagesFieldEntity', orderTablePackages: Array<{ __typename?: 'OrderTablePackageEntity', uuid: string, quantity: number, weight?: any | null, length?: any | null, width?: any | null, height?: any | null }> } | null, itemizedChargesField?: { __typename?: 'OrderTableItemizedChargesFieldEntity', freightChargeTotal: number, fuelChargeTotal: number, shipmentCharges: Array<{ __typename?: 'OrderTableItemizedChargesFieldShipmentEntity', shipmentType: ShipmentType, pickupOrDelivery?: PickupOrDelivery | null, stopType?: StopType | null, freightBillingMethod?: FreightBillingMethod | null, freightRate?: any | null, freightQuantity?: number | null, freightTotalAmount?: any | null, fuelBillingMethod?: FuelBillingMethod | null, fuelSurchargeRate?: any | null, fuelFlatRate?: any | null, fuelTotalAmount?: any | null, tariff?: { __typename?: 'TariffEntity', uuid: string, tariffZone: { __typename?: 'TariffZoneEntity', uuid: string, name: string }, tariffGroup?: { __typename?: 'TariffGroupEntity', name?: string | null } | null } | null, customCharges: Array<{ __typename?: 'OrderTableCustomChargeFieldEntity', name: string, billingMethod: CustomChargeBillingMethod, total: number }> }>, rateOrderOutput?: { __typename: 'RateOrderErrorOutput', success: boolean, errorMessage?: string | null } | { __typename: 'RateOrderSuccessOutput', success: boolean, totalDollars?: any | null, inboundShipmentCharges?: { __typename?: 'RateShipmentForOrderSuccessOutput', total: any, freightCharge?: { __typename?: 'RateFreightChargeSuccessOutput', totalDollars: any, tariffUuid?: string | null } | null, fuelCharge?: { __typename?: 'RateFuelChargeSuccessOutput', totalDollars: any, surchargeRatePercentage?: any | null } | null } | null, outboundShipmentCharges?: { __typename?: 'RateShipmentForOrderSuccessOutput', total: any, freightCharge?: { __typename?: 'RateFreightChargeSuccessOutput', totalDollars: any, tariffUuid?: string | null } | null, fuelCharge?: { __typename?: 'RateFuelChargeSuccessOutput', totalDollars: any, surchargeRatePercentage?: any | null } | null } | null, orderCharges?: { __typename?: 'RateShipmentForOrderSuccessOutput', total: any, freightCharge?: { __typename?: 'RateFreightChargeSuccessOutput', totalDollars: any, tariffUuid?: string | null } | null, fuelCharge?: { __typename?: 'RateFuelChargeSuccessOutput', totalDollars: any, surchargeRatePercentage?: any | null } | null } | null, lineHaulCharges?: { __typename?: 'RateShipmentForOrderSuccessOutput', total: any, freightCharge?: { __typename?: 'RateFreightChargeSuccessOutput', totalDollars: any, tariffUuid?: string | null } | null, fuelCharge?: { __typename?: 'RateFuelChargeSuccessOutput', totalDollars: any, surchargeRatePercentage?: any | null } | null } | null } | null, customCharges: Array<{ __typename?: 'OrderTableCustomChargeFieldEntity', name: string, billingMethod: CustomChargeBillingMethod, total: number }> } | null, lineHaulManifestsField?: { __typename?: 'OrderTableLineHaulManifestsFieldEntity', startTerminal: { __typename?: 'TerminalEntity', uuid: string, code: string }, endTerminal: { __typename?: 'TerminalEntity', uuid: string, code: string }, currentTerminal?: { __typename?: 'TerminalEntity', uuid: string, code: string } | null, lineHaulManifests: Array<{ __typename?: 'OrderTableLineHaulManifestEntity', status: LineHaulManifestStatus, startTerminal: { __typename?: 'TerminalEntity', uuid: string, code: string }, endTerminal: { __typename?: 'TerminalEntity', uuid: string, code: string } }> } | null };

export type GetOrderTableFieldValuesForCountQueryVariables = Exact<{
  getOrderTableFieldValuesInput: GetOrderTableFieldValuesInput;
}>;


export type GetOrderTableFieldValuesForCountQuery = { __typename?: 'Query', getOrderTableFieldValues: { __typename?: 'GetOrderTableFieldValuesOutput', orderTableFieldHeaders: Array<{ __typename?: 'OrderTableFieldHeaderEntity', orderTableField: OrderTableField, header: string }>, formattedOrderConnection: { __typename?: 'FormattedOrderConnection', totalCount?: number | null, edges: Array<{ __typename?: 'FormattedOrderEdge', node: { __typename?: 'FormattedOrderEntity', uuid: string, contactUuid: string, formattedOrderFields: Array<{ __typename?: 'FormattedOrderFieldEntity', orderTableField: OrderTableField, value: string }>, paperworkField?: { __typename?: 'OrderTablePaperworkFieldEntity', paperwork: { __typename?: 'OrderPaperworkEntity', paperworkComplete: boolean, paperworkMarkedCompleteOverride?: boolean | null, attachedDocuments?: Array<DocumentType> | null, missingDocuments?: Array<DocumentType> | null }, inboundPaperwork?: { __typename?: 'OrderPaperworkEntity', paperworkComplete: boolean, attachedDocuments?: Array<DocumentType> | null, missingDocuments?: Array<DocumentType> | null, alerts?: Array<DocumentType> | null, proofOfDeliveryOrPickupReadyToSign?: Array<DocumentType> | null, proofOfDeliveryOrPickupSigned?: Array<DocumentType> | null, photos?: Array<DocumentType> | null, other?: Array<DocumentType> | null } | null, outboundPaperwork?: { __typename?: 'OrderPaperworkEntity', paperworkComplete: boolean, attachedDocuments?: Array<DocumentType> | null, missingDocuments?: Array<DocumentType> | null, alerts?: Array<DocumentType> | null, proofOfDeliveryOrPickupReadyToSign?: Array<DocumentType> | null, proofOfDeliveryOrPickupSigned?: Array<DocumentType> | null, photos?: Array<DocumentType> | null, other?: Array<DocumentType> | null } | null } | null, tagsField?: { __typename?: 'OrderTableTagsFieldEntity', orderTableTags: Array<{ __typename?: 'OrderTableTagEntity', value: string, color?: string | null }> } | null, photosField?: { __typename?: 'OrderTablePhotosFieldEntity', orderTablePhotos: Array<{ __typename?: 'OrderTablePhotoEntity', shipmentUuid: string, shipmentPickupOrDelivery: PickupOrDelivery, fileName: string, type: DocumentType, preSignedGetUrl: string }> } | null, serviceField?: { __typename?: 'OrderTableServiceFieldEntity', service?: { __typename?: 'ServiceEntity', uuid: string, name: string } | null } | null, packagesField?: { __typename?: 'OrderTablePackagesFieldEntity', orderTablePackages: Array<{ __typename?: 'OrderTablePackageEntity', uuid: string, quantity: number, weight?: any | null, length?: any | null, width?: any | null, height?: any | null }> } | null, itemizedChargesField?: { __typename?: 'OrderTableItemizedChargesFieldEntity', freightChargeTotal: number, fuelChargeTotal: number, shipmentCharges: Array<{ __typename?: 'OrderTableItemizedChargesFieldShipmentEntity', shipmentType: ShipmentType, pickupOrDelivery?: PickupOrDelivery | null, stopType?: StopType | null, freightBillingMethod?: FreightBillingMethod | null, freightRate?: any | null, freightQuantity?: number | null, freightTotalAmount?: any | null, fuelBillingMethod?: FuelBillingMethod | null, fuelSurchargeRate?: any | null, fuelFlatRate?: any | null, fuelTotalAmount?: any | null, tariff?: { __typename?: 'TariffEntity', uuid: string, tariffZone: { __typename?: 'TariffZoneEntity', uuid: string, name: string }, tariffGroup?: { __typename?: 'TariffGroupEntity', name?: string | null } | null } | null, customCharges: Array<{ __typename?: 'OrderTableCustomChargeFieldEntity', name: string, billingMethod: CustomChargeBillingMethod, total: number }> }>, rateOrderOutput?: { __typename: 'RateOrderErrorOutput', success: boolean, errorMessage?: string | null } | { __typename: 'RateOrderSuccessOutput', success: boolean, totalDollars?: any | null, inboundShipmentCharges?: { __typename?: 'RateShipmentForOrderSuccessOutput', total: any, freightCharge?: { __typename?: 'RateFreightChargeSuccessOutput', totalDollars: any, tariffUuid?: string | null } | null, fuelCharge?: { __typename?: 'RateFuelChargeSuccessOutput', totalDollars: any, surchargeRatePercentage?: any | null } | null } | null, outboundShipmentCharges?: { __typename?: 'RateShipmentForOrderSuccessOutput', total: any, freightCharge?: { __typename?: 'RateFreightChargeSuccessOutput', totalDollars: any, tariffUuid?: string | null } | null, fuelCharge?: { __typename?: 'RateFuelChargeSuccessOutput', totalDollars: any, surchargeRatePercentage?: any | null } | null } | null, orderCharges?: { __typename?: 'RateShipmentForOrderSuccessOutput', total: any, freightCharge?: { __typename?: 'RateFreightChargeSuccessOutput', totalDollars: any, tariffUuid?: string | null } | null, fuelCharge?: { __typename?: 'RateFuelChargeSuccessOutput', totalDollars: any, surchargeRatePercentage?: any | null } | null } | null, lineHaulCharges?: { __typename?: 'RateShipmentForOrderSuccessOutput', total: any, freightCharge?: { __typename?: 'RateFreightChargeSuccessOutput', totalDollars: any, tariffUuid?: string | null } | null, fuelCharge?: { __typename?: 'RateFuelChargeSuccessOutput', totalDollars: any, surchargeRatePercentage?: any | null } | null } | null } | null, customCharges: Array<{ __typename?: 'OrderTableCustomChargeFieldEntity', name: string, billingMethod: CustomChargeBillingMethod, total: number }> } | null, lineHaulManifestsField?: { __typename?: 'OrderTableLineHaulManifestsFieldEntity', startTerminal: { __typename?: 'TerminalEntity', uuid: string, code: string }, endTerminal: { __typename?: 'TerminalEntity', uuid: string, code: string }, currentTerminal?: { __typename?: 'TerminalEntity', uuid: string, code: string } | null, lineHaulManifests: Array<{ __typename?: 'OrderTableLineHaulManifestEntity', status: LineHaulManifestStatus, startTerminal: { __typename?: 'TerminalEntity', uuid: string, code: string }, endTerminal: { __typename?: 'TerminalEntity', uuid: string, code: string } }> } | null } }>, pageInfo: { __typename?: 'PageInfo', startCursor?: string | null, endCursor?: string | null, hasNextPage: boolean, hasPreviousPage: boolean } } } };

export type GetOrderTableFieldValuesForSearchQueryVariables = Exact<{
  getOrderTableFieldValuesInput: GetOrderTableFieldValuesInput;
}>;


export type GetOrderTableFieldValuesForSearchQuery = { __typename?: 'Query', getOrderTableFieldValues: { __typename?: 'GetOrderTableFieldValuesOutput', orderTableFieldHeaders: Array<{ __typename?: 'OrderTableFieldHeaderEntity', orderTableField: OrderTableField, header: string }>, formattedOrderConnection: { __typename?: 'FormattedOrderConnection', totalCount?: number | null, edges: Array<{ __typename?: 'FormattedOrderEdge', node: { __typename?: 'FormattedOrderEntity', uuid: string, contactUuid: string, formattedOrderFields: Array<{ __typename?: 'FormattedOrderFieldEntity', orderTableField: OrderTableField, value: string }>, paperworkField?: { __typename?: 'OrderTablePaperworkFieldEntity', paperwork: { __typename?: 'OrderPaperworkEntity', paperworkComplete: boolean, paperworkMarkedCompleteOverride?: boolean | null, attachedDocuments?: Array<DocumentType> | null, missingDocuments?: Array<DocumentType> | null }, inboundPaperwork?: { __typename?: 'OrderPaperworkEntity', paperworkComplete: boolean, attachedDocuments?: Array<DocumentType> | null, missingDocuments?: Array<DocumentType> | null, alerts?: Array<DocumentType> | null, proofOfDeliveryOrPickupReadyToSign?: Array<DocumentType> | null, proofOfDeliveryOrPickupSigned?: Array<DocumentType> | null, photos?: Array<DocumentType> | null, other?: Array<DocumentType> | null } | null, outboundPaperwork?: { __typename?: 'OrderPaperworkEntity', paperworkComplete: boolean, attachedDocuments?: Array<DocumentType> | null, missingDocuments?: Array<DocumentType> | null, alerts?: Array<DocumentType> | null, proofOfDeliveryOrPickupReadyToSign?: Array<DocumentType> | null, proofOfDeliveryOrPickupSigned?: Array<DocumentType> | null, photos?: Array<DocumentType> | null, other?: Array<DocumentType> | null } | null } | null, tagsField?: { __typename?: 'OrderTableTagsFieldEntity', orderTableTags: Array<{ __typename?: 'OrderTableTagEntity', value: string, color?: string | null }> } | null, photosField?: { __typename?: 'OrderTablePhotosFieldEntity', orderTablePhotos: Array<{ __typename?: 'OrderTablePhotoEntity', shipmentUuid: string, shipmentPickupOrDelivery: PickupOrDelivery, fileName: string, type: DocumentType, preSignedGetUrl: string }> } | null, serviceField?: { __typename?: 'OrderTableServiceFieldEntity', service?: { __typename?: 'ServiceEntity', uuid: string, name: string } | null } | null, packagesField?: { __typename?: 'OrderTablePackagesFieldEntity', orderTablePackages: Array<{ __typename?: 'OrderTablePackageEntity', uuid: string, quantity: number, weight?: any | null, length?: any | null, width?: any | null, height?: any | null }> } | null, itemizedChargesField?: { __typename?: 'OrderTableItemizedChargesFieldEntity', freightChargeTotal: number, fuelChargeTotal: number, shipmentCharges: Array<{ __typename?: 'OrderTableItemizedChargesFieldShipmentEntity', shipmentType: ShipmentType, pickupOrDelivery?: PickupOrDelivery | null, stopType?: StopType | null, freightBillingMethod?: FreightBillingMethod | null, freightRate?: any | null, freightQuantity?: number | null, freightTotalAmount?: any | null, fuelBillingMethod?: FuelBillingMethod | null, fuelSurchargeRate?: any | null, fuelFlatRate?: any | null, fuelTotalAmount?: any | null, tariff?: { __typename?: 'TariffEntity', uuid: string, tariffZone: { __typename?: 'TariffZoneEntity', uuid: string, name: string }, tariffGroup?: { __typename?: 'TariffGroupEntity', name?: string | null } | null } | null, customCharges: Array<{ __typename?: 'OrderTableCustomChargeFieldEntity', name: string, billingMethod: CustomChargeBillingMethod, total: number }> }>, rateOrderOutput?: { __typename: 'RateOrderErrorOutput', success: boolean, errorMessage?: string | null } | { __typename: 'RateOrderSuccessOutput', success: boolean, totalDollars?: any | null, inboundShipmentCharges?: { __typename?: 'RateShipmentForOrderSuccessOutput', total: any, freightCharge?: { __typename?: 'RateFreightChargeSuccessOutput', totalDollars: any, tariffUuid?: string | null } | null, fuelCharge?: { __typename?: 'RateFuelChargeSuccessOutput', totalDollars: any, surchargeRatePercentage?: any | null } | null } | null, outboundShipmentCharges?: { __typename?: 'RateShipmentForOrderSuccessOutput', total: any, freightCharge?: { __typename?: 'RateFreightChargeSuccessOutput', totalDollars: any, tariffUuid?: string | null } | null, fuelCharge?: { __typename?: 'RateFuelChargeSuccessOutput', totalDollars: any, surchargeRatePercentage?: any | null } | null } | null, orderCharges?: { __typename?: 'RateShipmentForOrderSuccessOutput', total: any, freightCharge?: { __typename?: 'RateFreightChargeSuccessOutput', totalDollars: any, tariffUuid?: string | null } | null, fuelCharge?: { __typename?: 'RateFuelChargeSuccessOutput', totalDollars: any, surchargeRatePercentage?: any | null } | null } | null, lineHaulCharges?: { __typename?: 'RateShipmentForOrderSuccessOutput', total: any, freightCharge?: { __typename?: 'RateFreightChargeSuccessOutput', totalDollars: any, tariffUuid?: string | null } | null, fuelCharge?: { __typename?: 'RateFuelChargeSuccessOutput', totalDollars: any, surchargeRatePercentage?: any | null } | null } | null } | null, customCharges: Array<{ __typename?: 'OrderTableCustomChargeFieldEntity', name: string, billingMethod: CustomChargeBillingMethod, total: number }> } | null, lineHaulManifestsField?: { __typename?: 'OrderTableLineHaulManifestsFieldEntity', startTerminal: { __typename?: 'TerminalEntity', uuid: string, code: string }, endTerminal: { __typename?: 'TerminalEntity', uuid: string, code: string }, currentTerminal?: { __typename?: 'TerminalEntity', uuid: string, code: string } | null, lineHaulManifests: Array<{ __typename?: 'OrderTableLineHaulManifestEntity', status: LineHaulManifestStatus, startTerminal: { __typename?: 'TerminalEntity', uuid: string, code: string }, endTerminal: { __typename?: 'TerminalEntity', uuid: string, code: string } }> } | null } }>, pageInfo: { __typename?: 'PageInfo', startCursor?: string | null, endCursor?: string | null, hasNextPage: boolean, hasPreviousPage: boolean } } } };

export type GetOrderTableFieldValuesQueryVariables = Exact<{
  getOrderTableFieldValuesInput: GetOrderTableFieldValuesInput;
}>;


export type GetOrderTableFieldValuesQuery = { __typename?: 'Query', getOrderTableFieldValues: { __typename?: 'GetOrderTableFieldValuesOutput', orderTableFieldHeaders: Array<{ __typename?: 'OrderTableFieldHeaderEntity', orderTableField: OrderTableField, header: string }>, formattedOrderConnection: { __typename?: 'FormattedOrderConnection', totalCount?: number | null, edges: Array<{ __typename?: 'FormattedOrderEdge', node: { __typename?: 'FormattedOrderEntity', uuid: string, contactUuid: string, formattedOrderFields: Array<{ __typename?: 'FormattedOrderFieldEntity', orderTableField: OrderTableField, value: string }>, paperworkField?: { __typename?: 'OrderTablePaperworkFieldEntity', paperwork: { __typename?: 'OrderPaperworkEntity', paperworkComplete: boolean, paperworkMarkedCompleteOverride?: boolean | null, attachedDocuments?: Array<DocumentType> | null, missingDocuments?: Array<DocumentType> | null }, inboundPaperwork?: { __typename?: 'OrderPaperworkEntity', paperworkComplete: boolean, attachedDocuments?: Array<DocumentType> | null, missingDocuments?: Array<DocumentType> | null, alerts?: Array<DocumentType> | null, proofOfDeliveryOrPickupReadyToSign?: Array<DocumentType> | null, proofOfDeliveryOrPickupSigned?: Array<DocumentType> | null, photos?: Array<DocumentType> | null, other?: Array<DocumentType> | null } | null, outboundPaperwork?: { __typename?: 'OrderPaperworkEntity', paperworkComplete: boolean, attachedDocuments?: Array<DocumentType> | null, missingDocuments?: Array<DocumentType> | null, alerts?: Array<DocumentType> | null, proofOfDeliveryOrPickupReadyToSign?: Array<DocumentType> | null, proofOfDeliveryOrPickupSigned?: Array<DocumentType> | null, photos?: Array<DocumentType> | null, other?: Array<DocumentType> | null } | null } | null, tagsField?: { __typename?: 'OrderTableTagsFieldEntity', orderTableTags: Array<{ __typename?: 'OrderTableTagEntity', value: string, color?: string | null }> } | null, photosField?: { __typename?: 'OrderTablePhotosFieldEntity', orderTablePhotos: Array<{ __typename?: 'OrderTablePhotoEntity', shipmentUuid: string, shipmentPickupOrDelivery: PickupOrDelivery, fileName: string, type: DocumentType, preSignedGetUrl: string }> } | null, serviceField?: { __typename?: 'OrderTableServiceFieldEntity', service?: { __typename?: 'ServiceEntity', uuid: string, name: string } | null } | null, packagesField?: { __typename?: 'OrderTablePackagesFieldEntity', orderTablePackages: Array<{ __typename?: 'OrderTablePackageEntity', uuid: string, quantity: number, weight?: any | null, length?: any | null, width?: any | null, height?: any | null }> } | null, itemizedChargesField?: { __typename?: 'OrderTableItemizedChargesFieldEntity', freightChargeTotal: number, fuelChargeTotal: number, shipmentCharges: Array<{ __typename?: 'OrderTableItemizedChargesFieldShipmentEntity', shipmentType: ShipmentType, pickupOrDelivery?: PickupOrDelivery | null, stopType?: StopType | null, freightBillingMethod?: FreightBillingMethod | null, freightRate?: any | null, freightQuantity?: number | null, freightTotalAmount?: any | null, fuelBillingMethod?: FuelBillingMethod | null, fuelSurchargeRate?: any | null, fuelFlatRate?: any | null, fuelTotalAmount?: any | null, tariff?: { __typename?: 'TariffEntity', uuid: string, tariffZone: { __typename?: 'TariffZoneEntity', uuid: string, name: string }, tariffGroup?: { __typename?: 'TariffGroupEntity', name?: string | null } | null } | null, customCharges: Array<{ __typename?: 'OrderTableCustomChargeFieldEntity', name: string, billingMethod: CustomChargeBillingMethod, total: number }> }>, rateOrderOutput?: { __typename: 'RateOrderErrorOutput', success: boolean, errorMessage?: string | null } | { __typename: 'RateOrderSuccessOutput', success: boolean, totalDollars?: any | null, inboundShipmentCharges?: { __typename?: 'RateShipmentForOrderSuccessOutput', total: any, freightCharge?: { __typename?: 'RateFreightChargeSuccessOutput', totalDollars: any, tariffUuid?: string | null } | null, fuelCharge?: { __typename?: 'RateFuelChargeSuccessOutput', totalDollars: any, surchargeRatePercentage?: any | null } | null } | null, outboundShipmentCharges?: { __typename?: 'RateShipmentForOrderSuccessOutput', total: any, freightCharge?: { __typename?: 'RateFreightChargeSuccessOutput', totalDollars: any, tariffUuid?: string | null } | null, fuelCharge?: { __typename?: 'RateFuelChargeSuccessOutput', totalDollars: any, surchargeRatePercentage?: any | null } | null } | null, orderCharges?: { __typename?: 'RateShipmentForOrderSuccessOutput', total: any, freightCharge?: { __typename?: 'RateFreightChargeSuccessOutput', totalDollars: any, tariffUuid?: string | null } | null, fuelCharge?: { __typename?: 'RateFuelChargeSuccessOutput', totalDollars: any, surchargeRatePercentage?: any | null } | null } | null, lineHaulCharges?: { __typename?: 'RateShipmentForOrderSuccessOutput', total: any, freightCharge?: { __typename?: 'RateFreightChargeSuccessOutput', totalDollars: any, tariffUuid?: string | null } | null, fuelCharge?: { __typename?: 'RateFuelChargeSuccessOutput', totalDollars: any, surchargeRatePercentage?: any | null } | null } | null } | null, customCharges: Array<{ __typename?: 'OrderTableCustomChargeFieldEntity', name: string, billingMethod: CustomChargeBillingMethod, total: number }> } | null, lineHaulManifestsField?: { __typename?: 'OrderTableLineHaulManifestsFieldEntity', startTerminal: { __typename?: 'TerminalEntity', uuid: string, code: string }, endTerminal: { __typename?: 'TerminalEntity', uuid: string, code: string }, currentTerminal?: { __typename?: 'TerminalEntity', uuid: string, code: string } | null, lineHaulManifests: Array<{ __typename?: 'OrderTableLineHaulManifestEntity', status: LineHaulManifestStatus, startTerminal: { __typename?: 'TerminalEntity', uuid: string, code: string }, endTerminal: { __typename?: 'TerminalEntity', uuid: string, code: string } }> } | null } }>, pageInfo: { __typename?: 'PageInfo', startCursor?: string | null, endCursor?: string | null, hasNextPage: boolean, hasPreviousPage: boolean } } } };

export type OrderTableCustomChargeFragment = { __typename?: 'OrderTableCustomChargeFieldEntity', name: string, billingMethod: CustomChargeBillingMethod, total: number };

export type OrderTableFieldHeaderFragment = { __typename?: 'OrderTableFieldHeaderEntity', orderTableField: OrderTableField, header: string };

export type RateOrderShipmentChargesForItemizedChargesFragment = { __typename?: 'RateShipmentForOrderSuccessOutput', total: any, freightCharge?: { __typename?: 'RateFreightChargeSuccessOutput', totalDollars: any, tariffUuid?: string | null } | null, fuelCharge?: { __typename?: 'RateFuelChargeSuccessOutput', totalDollars: any, surchargeRatePercentage?: any | null } | null };

export type OrderTableFieldItemizedChargesFragment = { __typename?: 'OrderTableItemizedChargesFieldEntity', freightChargeTotal: number, fuelChargeTotal: number, shipmentCharges: Array<{ __typename?: 'OrderTableItemizedChargesFieldShipmentEntity', shipmentType: ShipmentType, pickupOrDelivery?: PickupOrDelivery | null, stopType?: StopType | null, freightBillingMethod?: FreightBillingMethod | null, freightRate?: any | null, freightQuantity?: number | null, freightTotalAmount?: any | null, fuelBillingMethod?: FuelBillingMethod | null, fuelSurchargeRate?: any | null, fuelFlatRate?: any | null, fuelTotalAmount?: any | null, tariff?: { __typename?: 'TariffEntity', uuid: string, tariffZone: { __typename?: 'TariffZoneEntity', uuid: string, name: string }, tariffGroup?: { __typename?: 'TariffGroupEntity', name?: string | null } | null } | null, customCharges: Array<{ __typename?: 'OrderTableCustomChargeFieldEntity', name: string, billingMethod: CustomChargeBillingMethod, total: number }> }>, rateOrderOutput?: { __typename: 'RateOrderErrorOutput', success: boolean, errorMessage?: string | null } | { __typename: 'RateOrderSuccessOutput', success: boolean, totalDollars?: any | null, inboundShipmentCharges?: { __typename?: 'RateShipmentForOrderSuccessOutput', total: any, freightCharge?: { __typename?: 'RateFreightChargeSuccessOutput', totalDollars: any, tariffUuid?: string | null } | null, fuelCharge?: { __typename?: 'RateFuelChargeSuccessOutput', totalDollars: any, surchargeRatePercentage?: any | null } | null } | null, outboundShipmentCharges?: { __typename?: 'RateShipmentForOrderSuccessOutput', total: any, freightCharge?: { __typename?: 'RateFreightChargeSuccessOutput', totalDollars: any, tariffUuid?: string | null } | null, fuelCharge?: { __typename?: 'RateFuelChargeSuccessOutput', totalDollars: any, surchargeRatePercentage?: any | null } | null } | null, orderCharges?: { __typename?: 'RateShipmentForOrderSuccessOutput', total: any, freightCharge?: { __typename?: 'RateFreightChargeSuccessOutput', totalDollars: any, tariffUuid?: string | null } | null, fuelCharge?: { __typename?: 'RateFuelChargeSuccessOutput', totalDollars: any, surchargeRatePercentage?: any | null } | null } | null, lineHaulCharges?: { __typename?: 'RateShipmentForOrderSuccessOutput', total: any, freightCharge?: { __typename?: 'RateFreightChargeSuccessOutput', totalDollars: any, tariffUuid?: string | null } | null, fuelCharge?: { __typename?: 'RateFuelChargeSuccessOutput', totalDollars: any, surchargeRatePercentage?: any | null } | null } | null } | null, customCharges: Array<{ __typename?: 'OrderTableCustomChargeFieldEntity', name: string, billingMethod: CustomChargeBillingMethod, total: number }> };

export type OrderTableFieldPackageFragment = { __typename?: 'OrderTablePackageEntity', uuid: string, quantity: number, weight?: any | null, length?: any | null, width?: any | null, height?: any | null };

export type OrderTableFieldPaperworkFragment = { __typename?: 'OrderTablePaperworkFieldEntity', paperwork: { __typename?: 'OrderPaperworkEntity', paperworkComplete: boolean, paperworkMarkedCompleteOverride?: boolean | null, attachedDocuments?: Array<DocumentType> | null, missingDocuments?: Array<DocumentType> | null }, inboundPaperwork?: { __typename?: 'OrderPaperworkEntity', paperworkComplete: boolean, attachedDocuments?: Array<DocumentType> | null, missingDocuments?: Array<DocumentType> | null, alerts?: Array<DocumentType> | null, proofOfDeliveryOrPickupReadyToSign?: Array<DocumentType> | null, proofOfDeliveryOrPickupSigned?: Array<DocumentType> | null, photos?: Array<DocumentType> | null, other?: Array<DocumentType> | null } | null, outboundPaperwork?: { __typename?: 'OrderPaperworkEntity', paperworkComplete: boolean, attachedDocuments?: Array<DocumentType> | null, missingDocuments?: Array<DocumentType> | null, alerts?: Array<DocumentType> | null, proofOfDeliveryOrPickupReadyToSign?: Array<DocumentType> | null, proofOfDeliveryOrPickupSigned?: Array<DocumentType> | null, photos?: Array<DocumentType> | null, other?: Array<DocumentType> | null } | null };

export type OrderTableFieldPhotoFragment = { __typename?: 'OrderTablePhotoEntity', shipmentUuid: string, shipmentPickupOrDelivery: PickupOrDelivery, fileName: string, type: DocumentType, preSignedGetUrl: string };

export type OrderTableFieldTagFragment = { __typename?: 'OrderTableTagEntity', value: string, color?: string | null };

export type OrderTableFieldValuesFormattedOrderConnectionFragment = { __typename?: 'FormattedOrderConnection', totalCount?: number | null, edges: Array<{ __typename?: 'FormattedOrderEdge', node: { __typename?: 'FormattedOrderEntity', uuid: string, contactUuid: string, formattedOrderFields: Array<{ __typename?: 'FormattedOrderFieldEntity', orderTableField: OrderTableField, value: string }>, paperworkField?: { __typename?: 'OrderTablePaperworkFieldEntity', paperwork: { __typename?: 'OrderPaperworkEntity', paperworkComplete: boolean, paperworkMarkedCompleteOverride?: boolean | null, attachedDocuments?: Array<DocumentType> | null, missingDocuments?: Array<DocumentType> | null }, inboundPaperwork?: { __typename?: 'OrderPaperworkEntity', paperworkComplete: boolean, attachedDocuments?: Array<DocumentType> | null, missingDocuments?: Array<DocumentType> | null, alerts?: Array<DocumentType> | null, proofOfDeliveryOrPickupReadyToSign?: Array<DocumentType> | null, proofOfDeliveryOrPickupSigned?: Array<DocumentType> | null, photos?: Array<DocumentType> | null, other?: Array<DocumentType> | null } | null, outboundPaperwork?: { __typename?: 'OrderPaperworkEntity', paperworkComplete: boolean, attachedDocuments?: Array<DocumentType> | null, missingDocuments?: Array<DocumentType> | null, alerts?: Array<DocumentType> | null, proofOfDeliveryOrPickupReadyToSign?: Array<DocumentType> | null, proofOfDeliveryOrPickupSigned?: Array<DocumentType> | null, photos?: Array<DocumentType> | null, other?: Array<DocumentType> | null } | null } | null, tagsField?: { __typename?: 'OrderTableTagsFieldEntity', orderTableTags: Array<{ __typename?: 'OrderTableTagEntity', value: string, color?: string | null }> } | null, photosField?: { __typename?: 'OrderTablePhotosFieldEntity', orderTablePhotos: Array<{ __typename?: 'OrderTablePhotoEntity', shipmentUuid: string, shipmentPickupOrDelivery: PickupOrDelivery, fileName: string, type: DocumentType, preSignedGetUrl: string }> } | null, serviceField?: { __typename?: 'OrderTableServiceFieldEntity', service?: { __typename?: 'ServiceEntity', uuid: string, name: string } | null } | null, packagesField?: { __typename?: 'OrderTablePackagesFieldEntity', orderTablePackages: Array<{ __typename?: 'OrderTablePackageEntity', uuid: string, quantity: number, weight?: any | null, length?: any | null, width?: any | null, height?: any | null }> } | null, itemizedChargesField?: { __typename?: 'OrderTableItemizedChargesFieldEntity', freightChargeTotal: number, fuelChargeTotal: number, shipmentCharges: Array<{ __typename?: 'OrderTableItemizedChargesFieldShipmentEntity', shipmentType: ShipmentType, pickupOrDelivery?: PickupOrDelivery | null, stopType?: StopType | null, freightBillingMethod?: FreightBillingMethod | null, freightRate?: any | null, freightQuantity?: number | null, freightTotalAmount?: any | null, fuelBillingMethod?: FuelBillingMethod | null, fuelSurchargeRate?: any | null, fuelFlatRate?: any | null, fuelTotalAmount?: any | null, tariff?: { __typename?: 'TariffEntity', uuid: string, tariffZone: { __typename?: 'TariffZoneEntity', uuid: string, name: string }, tariffGroup?: { __typename?: 'TariffGroupEntity', name?: string | null } | null } | null, customCharges: Array<{ __typename?: 'OrderTableCustomChargeFieldEntity', name: string, billingMethod: CustomChargeBillingMethod, total: number }> }>, rateOrderOutput?: { __typename: 'RateOrderErrorOutput', success: boolean, errorMessage?: string | null } | { __typename: 'RateOrderSuccessOutput', success: boolean, totalDollars?: any | null, inboundShipmentCharges?: { __typename?: 'RateShipmentForOrderSuccessOutput', total: any, freightCharge?: { __typename?: 'RateFreightChargeSuccessOutput', totalDollars: any, tariffUuid?: string | null } | null, fuelCharge?: { __typename?: 'RateFuelChargeSuccessOutput', totalDollars: any, surchargeRatePercentage?: any | null } | null } | null, outboundShipmentCharges?: { __typename?: 'RateShipmentForOrderSuccessOutput', total: any, freightCharge?: { __typename?: 'RateFreightChargeSuccessOutput', totalDollars: any, tariffUuid?: string | null } | null, fuelCharge?: { __typename?: 'RateFuelChargeSuccessOutput', totalDollars: any, surchargeRatePercentage?: any | null } | null } | null, orderCharges?: { __typename?: 'RateShipmentForOrderSuccessOutput', total: any, freightCharge?: { __typename?: 'RateFreightChargeSuccessOutput', totalDollars: any, tariffUuid?: string | null } | null, fuelCharge?: { __typename?: 'RateFuelChargeSuccessOutput', totalDollars: any, surchargeRatePercentage?: any | null } | null } | null, lineHaulCharges?: { __typename?: 'RateShipmentForOrderSuccessOutput', total: any, freightCharge?: { __typename?: 'RateFreightChargeSuccessOutput', totalDollars: any, tariffUuid?: string | null } | null, fuelCharge?: { __typename?: 'RateFuelChargeSuccessOutput', totalDollars: any, surchargeRatePercentage?: any | null } | null } | null } | null, customCharges: Array<{ __typename?: 'OrderTableCustomChargeFieldEntity', name: string, billingMethod: CustomChargeBillingMethod, total: number }> } | null, lineHaulManifestsField?: { __typename?: 'OrderTableLineHaulManifestsFieldEntity', startTerminal: { __typename?: 'TerminalEntity', uuid: string, code: string }, endTerminal: { __typename?: 'TerminalEntity', uuid: string, code: string }, currentTerminal?: { __typename?: 'TerminalEntity', uuid: string, code: string } | null, lineHaulManifests: Array<{ __typename?: 'OrderTableLineHaulManifestEntity', status: LineHaulManifestStatus, startTerminal: { __typename?: 'TerminalEntity', uuid: string, code: string }, endTerminal: { __typename?: 'TerminalEntity', uuid: string, code: string } }> } | null } }>, pageInfo: { __typename?: 'PageInfo', startCursor?: string | null, endCursor?: string | null, hasNextPage: boolean, hasPreviousPage: boolean } };

export type OrderTableFieldValuesOutputFragment = { __typename?: 'GetOrderTableFieldValuesOutput', orderTableFieldHeaders: Array<{ __typename?: 'OrderTableFieldHeaderEntity', orderTableField: OrderTableField, header: string }>, formattedOrderConnection: { __typename?: 'FormattedOrderConnection', totalCount?: number | null, edges: Array<{ __typename?: 'FormattedOrderEdge', node: { __typename?: 'FormattedOrderEntity', uuid: string, contactUuid: string, formattedOrderFields: Array<{ __typename?: 'FormattedOrderFieldEntity', orderTableField: OrderTableField, value: string }>, paperworkField?: { __typename?: 'OrderTablePaperworkFieldEntity', paperwork: { __typename?: 'OrderPaperworkEntity', paperworkComplete: boolean, paperworkMarkedCompleteOverride?: boolean | null, attachedDocuments?: Array<DocumentType> | null, missingDocuments?: Array<DocumentType> | null }, inboundPaperwork?: { __typename?: 'OrderPaperworkEntity', paperworkComplete: boolean, attachedDocuments?: Array<DocumentType> | null, missingDocuments?: Array<DocumentType> | null, alerts?: Array<DocumentType> | null, proofOfDeliveryOrPickupReadyToSign?: Array<DocumentType> | null, proofOfDeliveryOrPickupSigned?: Array<DocumentType> | null, photos?: Array<DocumentType> | null, other?: Array<DocumentType> | null } | null, outboundPaperwork?: { __typename?: 'OrderPaperworkEntity', paperworkComplete: boolean, attachedDocuments?: Array<DocumentType> | null, missingDocuments?: Array<DocumentType> | null, alerts?: Array<DocumentType> | null, proofOfDeliveryOrPickupReadyToSign?: Array<DocumentType> | null, proofOfDeliveryOrPickupSigned?: Array<DocumentType> | null, photos?: Array<DocumentType> | null, other?: Array<DocumentType> | null } | null } | null, tagsField?: { __typename?: 'OrderTableTagsFieldEntity', orderTableTags: Array<{ __typename?: 'OrderTableTagEntity', value: string, color?: string | null }> } | null, photosField?: { __typename?: 'OrderTablePhotosFieldEntity', orderTablePhotos: Array<{ __typename?: 'OrderTablePhotoEntity', shipmentUuid: string, shipmentPickupOrDelivery: PickupOrDelivery, fileName: string, type: DocumentType, preSignedGetUrl: string }> } | null, serviceField?: { __typename?: 'OrderTableServiceFieldEntity', service?: { __typename?: 'ServiceEntity', uuid: string, name: string } | null } | null, packagesField?: { __typename?: 'OrderTablePackagesFieldEntity', orderTablePackages: Array<{ __typename?: 'OrderTablePackageEntity', uuid: string, quantity: number, weight?: any | null, length?: any | null, width?: any | null, height?: any | null }> } | null, itemizedChargesField?: { __typename?: 'OrderTableItemizedChargesFieldEntity', freightChargeTotal: number, fuelChargeTotal: number, shipmentCharges: Array<{ __typename?: 'OrderTableItemizedChargesFieldShipmentEntity', shipmentType: ShipmentType, pickupOrDelivery?: PickupOrDelivery | null, stopType?: StopType | null, freightBillingMethod?: FreightBillingMethod | null, freightRate?: any | null, freightQuantity?: number | null, freightTotalAmount?: any | null, fuelBillingMethod?: FuelBillingMethod | null, fuelSurchargeRate?: any | null, fuelFlatRate?: any | null, fuelTotalAmount?: any | null, tariff?: { __typename?: 'TariffEntity', uuid: string, tariffZone: { __typename?: 'TariffZoneEntity', uuid: string, name: string }, tariffGroup?: { __typename?: 'TariffGroupEntity', name?: string | null } | null } | null, customCharges: Array<{ __typename?: 'OrderTableCustomChargeFieldEntity', name: string, billingMethod: CustomChargeBillingMethod, total: number }> }>, rateOrderOutput?: { __typename: 'RateOrderErrorOutput', success: boolean, errorMessage?: string | null } | { __typename: 'RateOrderSuccessOutput', success: boolean, totalDollars?: any | null, inboundShipmentCharges?: { __typename?: 'RateShipmentForOrderSuccessOutput', total: any, freightCharge?: { __typename?: 'RateFreightChargeSuccessOutput', totalDollars: any, tariffUuid?: string | null } | null, fuelCharge?: { __typename?: 'RateFuelChargeSuccessOutput', totalDollars: any, surchargeRatePercentage?: any | null } | null } | null, outboundShipmentCharges?: { __typename?: 'RateShipmentForOrderSuccessOutput', total: any, freightCharge?: { __typename?: 'RateFreightChargeSuccessOutput', totalDollars: any, tariffUuid?: string | null } | null, fuelCharge?: { __typename?: 'RateFuelChargeSuccessOutput', totalDollars: any, surchargeRatePercentage?: any | null } | null } | null, orderCharges?: { __typename?: 'RateShipmentForOrderSuccessOutput', total: any, freightCharge?: { __typename?: 'RateFreightChargeSuccessOutput', totalDollars: any, tariffUuid?: string | null } | null, fuelCharge?: { __typename?: 'RateFuelChargeSuccessOutput', totalDollars: any, surchargeRatePercentage?: any | null } | null } | null, lineHaulCharges?: { __typename?: 'RateShipmentForOrderSuccessOutput', total: any, freightCharge?: { __typename?: 'RateFreightChargeSuccessOutput', totalDollars: any, tariffUuid?: string | null } | null, fuelCharge?: { __typename?: 'RateFuelChargeSuccessOutput', totalDollars: any, surchargeRatePercentage?: any | null } | null } | null } | null, customCharges: Array<{ __typename?: 'OrderTableCustomChargeFieldEntity', name: string, billingMethod: CustomChargeBillingMethod, total: number }> } | null, lineHaulManifestsField?: { __typename?: 'OrderTableLineHaulManifestsFieldEntity', startTerminal: { __typename?: 'TerminalEntity', uuid: string, code: string }, endTerminal: { __typename?: 'TerminalEntity', uuid: string, code: string }, currentTerminal?: { __typename?: 'TerminalEntity', uuid: string, code: string } | null, lineHaulManifests: Array<{ __typename?: 'OrderTableLineHaulManifestEntity', status: LineHaulManifestStatus, startTerminal: { __typename?: 'TerminalEntity', uuid: string, code: string }, endTerminal: { __typename?: 'TerminalEntity', uuid: string, code: string } }> } | null } }>, pageInfo: { __typename?: 'PageInfo', startCursor?: string | null, endCursor?: string | null, hasNextPage: boolean, hasPreviousPage: boolean } } };

export type OrderCommentsQueryVariables = Exact<{
  orderUuid: Scalars['String']['input'];
}>;


export type OrderCommentsQuery = { __typename?: 'Query', orderComments: Array<{ __typename?: 'OrderCommentEntity', uuid: string, createdAt: any, updatedAt: any, comment: string, user?: { __typename?: 'UserEntity', uuid: string, email: string } | null }> };

export type OrderPaperworkWithGroupedDocumentsFragment = { __typename?: 'OrderPaperworkEntity', paperworkComplete: boolean, attachedDocuments?: Array<DocumentType> | null, missingDocuments?: Array<DocumentType> | null, alerts?: Array<DocumentType> | null, proofOfDeliveryOrPickupReadyToSign?: Array<DocumentType> | null, proofOfDeliveryOrPickupSigned?: Array<DocumentType> | null, photos?: Array<DocumentType> | null, other?: Array<DocumentType> | null };

export type OrderPaperworkFragment = { __typename?: 'OrderPaperworkEntity', paperworkComplete: boolean, paperworkMarkedCompleteOverride?: boolean | null, attachedDocuments?: Array<DocumentType> | null, missingDocuments?: Array<DocumentType> | null };

export type OrderTableFieldHeadersQueryVariables = Exact<{ [key: string]: never; }>;


export type OrderTableFieldHeadersQuery = { __typename?: 'Query', orderTableFieldHeaders: { __typename?: 'GetOrderTableFieldHeadersOutput', orderTableFieldHeaders: Array<{ __typename?: 'OrderTableFieldHeaderEntity', orderTableField: OrderTableField, header: string }> } };

export type OrderUuidsQueryVariables = Exact<{
  addressCityFilter?: InputMaybe<StringFilter>;
  addressZipFilter?: InputMaybe<StringFilter>;
  attemptedAtDateFilters?: InputMaybe<DateFilterStartEnd>;
  completionDateFilters?: InputMaybe<DateFilterStartEnd>;
  deadlineDateFilters?: InputMaybe<DateFilterStartEnd>;
  receivedDateFilters?: InputMaybe<DateFilterStartEnd>;
  createdAtDateFilters?: InputMaybe<DateFilterStartEnd>;
  expectedInboundArrivalDateFilters?: InputMaybe<DateFilterStartEnd>;
  invoiceDateFilters?: InputMaybe<DateFilterStartEnd>;
  scheduledAtDateFilters?: InputMaybe<DateFilterStartEnd>;
  primaryAppointmentDateFilters?: InputMaybe<DateFilterStartEnd>;
  orderNumberFilter?: InputMaybe<StringFilter>;
  billingPartyContactUuidFilter?: InputMaybe<StringFilter>;
  billingPartyContactDisplayNameFilter?: InputMaybe<StringFilter>;
  businessDivisionUuidFilter?: InputMaybe<StringFilter>;
  terminalUuidFilter?: InputMaybe<StringFilter>;
  activeTerminalUuidFilter?: InputMaybe<StringFilter>;
  originTerminalUuidFilter?: InputMaybe<StringFilterNullable>;
  destinationTerminalUuidFilter?: InputMaybe<StringFilterNullable>;
  driverUuidFilter?: InputMaybe<StringFilter>;
  shipperFilter?: InputMaybe<StringFilter>;
  consigneeFilter?: InputMaybe<StringFilter>;
  statusFilters?: InputMaybe<Array<StatusFilter> | StatusFilter>;
  shipmentStatusFilters?: InputMaybe<Array<ShipmentStatusFilter> | ShipmentStatusFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  searchText?: InputMaybe<Scalars['String']['input']>;
  multipleSearches?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  scheduledFilter?: InputMaybe<BooleanFilter>;
  outForDeliveryFilter?: InputMaybe<BooleanFilter>;
  onHand?: InputMaybe<BooleanFilter>;
  onInvoice?: InputMaybe<BooleanFilter>;
  isCancelled?: InputMaybe<BooleanFilter>;
  isRefused?: InputMaybe<BooleanFilter>;
  isFinalized?: InputMaybe<BooleanFilter>;
  isPicked?: InputMaybe<BooleanFilter>;
  isOsd?: InputMaybe<BooleanFilter>;
  isSpecial?: InputMaybe<BooleanFilter>;
  orderSource?: InputMaybe<OrderSource>;
  noMaximum?: InputMaybe<Scalars['Boolean']['input']>;
  hasAppointmentScheduled?: InputMaybe<BooleanFilter>;
  appointmentRequired?: InputMaybe<BooleanFilter>;
  hasContactInformation?: InputMaybe<BooleanFilter>;
  hasFailures?: InputMaybe<BooleanFilter>;
  hasRoute?: InputMaybe<BooleanFilter>;
  hideFromBilling?: InputMaybe<BooleanFilter>;
  paperworkComplete?: InputMaybe<BooleanFilter>;
  pickupOrDelivery?: InputMaybe<PickupOrDelivery>;
  isPickupOrDelivery?: InputMaybe<BooleanFilter>;
  inboundNotArrived?: InputMaybe<BooleanFilter>;
  requiresRouting?: InputMaybe<BooleanFilter>;
  requiresRecovery?: InputMaybe<BooleanFilter>;
  serviceDateFilters?: InputMaybe<DateFilterStartEnd>;
  serviceDateFilter?: InputMaybe<DateFilterV2>;
  serviceUuids?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  lineHaulLaneUuids?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  showConsolidatedOrders?: InputMaybe<BooleanFilter>;
  standardStopType?: InputMaybe<StandardStopType>;
  stopTypesFilter?: InputMaybe<StopTypesFilter>;
  tagUuids?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  transferPending?: InputMaybe<BooleanFilter>;
  uuids?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  searchHawbOnly?: InputMaybe<Scalars['Boolean']['input']>;
  searchRefNumbersOnly?: InputMaybe<Scalars['Boolean']['input']>;
  searchMiscInfoOnly?: InputMaybe<Scalars['Boolean']['input']>;
  useMultiSearch?: InputMaybe<Scalars['Boolean']['input']>;
  sorts?: InputMaybe<Array<OrderSort> | OrderSort>;
  noTerminal?: InputMaybe<BooleanFilter>;
  isCollectOnDelivery?: InputMaybe<Scalars['Boolean']['input']>;
  isHazmat?: InputMaybe<BooleanFilter>;
  isInBond?: InputMaybe<BooleanFilter>;
  billingPartyContactUuidsFilter?: InputMaybe<StringsFilter>;
  terminalUuidsFilter?: InputMaybe<StringsFilter>;
  driverUuidsFilter?: InputMaybe<StringsFilter>;
  tagUuidsFilter?: InputMaybe<StringsFilter>;
}>;


export type OrderUuidsQuery = { __typename?: 'Query', orders: { __typename?: 'OrderConnection', totalCount?: number | null, edges: Array<{ __typename?: 'OrderEdge', node: { __typename?: 'StandardOrderEntity', uuid: string } }>, pageInfo: { __typename?: 'PageInfo', startCursor?: string | null, endCursor?: string | null, hasNextPage: boolean, hasPreviousPage: boolean } } };

export type OrderWithCommentsFragment = { __typename?: 'StandardOrderEntity', orderComments: Array<{ __typename?: 'OrderCommentEntity', uuid: string, updatedAt: any, comment: string, user?: { __typename?: 'UserEntity', uuid: string, email: string } | null }> };

export type OrderWithInboundOutboundPaperworkQueryVariables = Exact<{
  uuid: Scalars['String']['input'];
}>;


export type OrderWithInboundOutboundPaperworkQuery = { __typename?: 'Query', order?: { __typename?: 'StandardOrderEntity', paperwork: { __typename?: 'OrderPaperworkEntity', paperworkComplete: boolean, paperworkMarkedCompleteOverride?: boolean | null, attachedDocuments?: Array<DocumentType> | null, missingDocuments?: Array<DocumentType> | null }, inboundPaperwork: { __typename?: 'OrderPaperworkEntity', paperworkComplete: boolean, attachedDocuments?: Array<DocumentType> | null, missingDocuments?: Array<DocumentType> | null, alerts?: Array<DocumentType> | null, proofOfDeliveryOrPickupReadyToSign?: Array<DocumentType> | null, proofOfDeliveryOrPickupSigned?: Array<DocumentType> | null, photos?: Array<DocumentType> | null, other?: Array<DocumentType> | null }, outboundPaperwork: { __typename?: 'OrderPaperworkEntity', paperworkComplete: boolean, attachedDocuments?: Array<DocumentType> | null, missingDocuments?: Array<DocumentType> | null, alerts?: Array<DocumentType> | null, proofOfDeliveryOrPickupReadyToSign?: Array<DocumentType> | null, proofOfDeliveryOrPickupSigned?: Array<DocumentType> | null, photos?: Array<DocumentType> | null, other?: Array<DocumentType> | null } } | null };

export type OrderWithItemizedChargesQueryVariables = Exact<{
  uuid: Scalars['String']['input'];
}>;


export type OrderWithItemizedChargesQuery = { __typename?: 'Query', getOrderTableFieldValues: { __typename?: 'GetOrderTableFieldValuesOutput', formattedOrderConnection: { __typename?: 'FormattedOrderConnection', edges: Array<{ __typename?: 'FormattedOrderEdge', node: { __typename?: 'FormattedOrderEntity', uuid: string, itemizedChargesField?: { __typename?: 'OrderTableItemizedChargesFieldEntity', freightChargeTotal: number, fuelChargeTotal: number, shipmentCharges: Array<{ __typename?: 'OrderTableItemizedChargesFieldShipmentEntity', shipmentType: ShipmentType, pickupOrDelivery?: PickupOrDelivery | null, stopType?: StopType | null, freightBillingMethod?: FreightBillingMethod | null, freightRate?: any | null, freightQuantity?: number | null, freightTotalAmount?: any | null, fuelBillingMethod?: FuelBillingMethod | null, fuelSurchargeRate?: any | null, fuelFlatRate?: any | null, fuelTotalAmount?: any | null, tariff?: { __typename?: 'TariffEntity', uuid: string, tariffZone: { __typename?: 'TariffZoneEntity', uuid: string, name: string }, tariffGroup?: { __typename?: 'TariffGroupEntity', name?: string | null } | null } | null, customCharges: Array<{ __typename?: 'OrderTableCustomChargeFieldEntity', name: string, billingMethod: CustomChargeBillingMethod, total: number }> }>, rateOrderOutput?: { __typename: 'RateOrderErrorOutput', success: boolean, errorMessage?: string | null } | { __typename: 'RateOrderSuccessOutput', success: boolean, totalDollars?: any | null, inboundShipmentCharges?: { __typename?: 'RateShipmentForOrderSuccessOutput', total: any, freightCharge?: { __typename?: 'RateFreightChargeSuccessOutput', totalDollars: any, tariffUuid?: string | null } | null, fuelCharge?: { __typename?: 'RateFuelChargeSuccessOutput', totalDollars: any, surchargeRatePercentage?: any | null } | null } | null, outboundShipmentCharges?: { __typename?: 'RateShipmentForOrderSuccessOutput', total: any, freightCharge?: { __typename?: 'RateFreightChargeSuccessOutput', totalDollars: any, tariffUuid?: string | null } | null, fuelCharge?: { __typename?: 'RateFuelChargeSuccessOutput', totalDollars: any, surchargeRatePercentage?: any | null } | null } | null, orderCharges?: { __typename?: 'RateShipmentForOrderSuccessOutput', total: any, freightCharge?: { __typename?: 'RateFreightChargeSuccessOutput', totalDollars: any, tariffUuid?: string | null } | null, fuelCharge?: { __typename?: 'RateFuelChargeSuccessOutput', totalDollars: any, surchargeRatePercentage?: any | null } | null } | null, lineHaulCharges?: { __typename?: 'RateShipmentForOrderSuccessOutput', total: any, freightCharge?: { __typename?: 'RateFreightChargeSuccessOutput', totalDollars: any, tariffUuid?: string | null } | null, fuelCharge?: { __typename?: 'RateFuelChargeSuccessOutput', totalDollars: any, surchargeRatePercentage?: any | null } | null } | null } | null, customCharges: Array<{ __typename?: 'OrderTableCustomChargeFieldEntity', name: string, billingMethod: CustomChargeBillingMethod, total: number }> } | null } }> } } };

export type OrderWithMissingDocumentsFragment = { __typename?: 'StandardOrderEntity', uuid: string, missingDocuments: Array<DocumentType> };

export type OrderWithMissingDocumentsQueryVariables = Exact<{
  uuid: Scalars['String']['input'];
}>;


export type OrderWithMissingDocumentsQuery = { __typename?: 'Query', order?: { __typename?: 'StandardOrderEntity', uuid: string, missingDocuments: Array<DocumentType> } | null };

export type OrderWithPaperworkFragment = { __typename?: 'StandardOrderEntity', uuid: string, paperwork: { __typename?: 'OrderPaperworkEntity', paperworkComplete: boolean, paperworkMarkedCompleteOverride?: boolean | null, attachedDocuments?: Array<DocumentType> | null, missingDocuments?: Array<DocumentType> | null } };

export type OrderWithPaperworkQueryVariables = Exact<{
  uuid: Scalars['String']['input'];
}>;


export type OrderWithPaperworkQuery = { __typename?: 'Query', order?: { __typename?: 'StandardOrderEntity', uuid: string, paperwork: { __typename?: 'OrderPaperworkEntity', paperworkComplete: boolean, paperworkMarkedCompleteOverride?: boolean | null, attachedDocuments?: Array<DocumentType> | null, missingDocuments?: Array<DocumentType> | null } } | null };

export type OrderFragment = { __typename?: 'StandardOrderEntity', weight: number, dimWeight: number, createdAt: any, receivedDate?: any | null, secondaryRefNumber?: string | null, status: OrderStatus, detailedStatusV2?: OrderDetailedStatus | null, uuid: string, name: string, missingDocuments: Array<DocumentType>, osd?: boolean | null, source: OrderSource, refNumbers: Array<string>, notes: string, dateMarkedLoaded?: any | null, dateMarkedOnHand?: any | null, dateMarkedReceivedAtOrigin?: any | null, pieceCount?: number | null, itTeNumber?: string | null, pieceCountFromPackages: number, inBond?: boolean | null, piecesPicked?: number | null, piecesLoaded?: number | null, refusedBy?: string | null, hasDriverPod: boolean, hasDriverUploadedDocument: boolean, totalSkids?: number | null, externalNotes?: string | null, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', shipperBillOfLadingNumber?: string | null, masterAirwayBillOfLadingNumber?: string | null }, packages: Array<{ __typename?: 'PackageEntity', length?: number | null, width?: number | null, height?: number | null, quantity: number }>, paperwork: { __typename?: 'OrderPaperworkEntity', paperworkComplete: boolean, paperworkMarkedCompleteOverride?: boolean | null, attachedDocuments?: Array<DocumentType> | null, missingDocuments?: Array<DocumentType> | null }, holdReason?: { __typename?: 'HoldReasonEntity', name: string } | null, service?: { __typename?: 'ServiceEntity', name: string } | null, tags: Array<{ __typename?: 'TagEntity', uuid: string, value: string, color?: string | null }>, billingPartyContact: { __typename?: 'CustomerContactEntity', uuid: string, displayName: string, billingCycleDuration: BillingCycleDuration, invoiceTimePeriodSplit?: TimePeriod | null, numberOfOrdersPerInvoice?: number | null, businessDivision?: { __typename?: 'BusinessDivisionEntity', name: string } | null, masterAccount?: { __typename?: 'MasterAccountEntity', name: string } | null }, documents: Array<{ __typename?: 'DocumentEntity', uuid: string, fileName: string, bucket: string, region: string, key: string, uploadedAt?: any | null, fileType: string, isDeleted: boolean, preSignedGetUrl: string, name?: string | null, type: DocumentType, pageNumber?: number | null, createdAt: any, notes?: string | null, order?: { __typename?: 'StandardOrderEntity', uuid: string, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', shipperBillOfLadingNumber?: string | null } } | null, shipment?: { __typename?: 'StandardOrderEntity', uuid: string } | null, driverFormTemplate?: { __typename?: 'DriverSignableFormTemplateEntity', uuid: string, title: string, formText: string } | null }>, shipments: Array<{ __typename?: 'StandardShipmentEntity', uuid: string, ordinal: number, hideFromBilling: boolean, status: ShipmentStatus, shipmentType: ShipmentType, invoice?: { __typename?: 'InvoiceEntity', uuid: string } | null, airportInfo?: { __typename?: 'AirportInfoEntity', iataCode: string } | null, standardShipmentFields: { __typename?: 'StandardShipmentFieldsEntity', pickupOrDelivery: PickupOrDelivery, deliveryDate?: any | null, deadlineType?: DeadlineType | null, deadlineDate?: any | null }, legs: Array<{ __typename?: 'LegEntity', uuid: string, endStop: { __typename?: 'StandardStopEntity', uuid: string, notes?: string | null, standardStopType?: StandardStopType | null, stopType?: StopType | null, appointmentTextStatus?: AppointmentTextStatus | null, appointmentTime?: any | null, endAppointmentTime?: any | null, proofOfDeliverySignee?: string | null, inboundMethod?: InboundMethod | null, expectedInboundArrivalDate?: any | null, outboundMethod?: OutboundMethod | null, completedAt?: any | null, driverCompletedAt?: any | null, createdAt: any, status: StopStatus, isSpecial?: boolean | null, paperworkMarkedComplete?: boolean | null, contactPerson?: { __typename?: 'ContactPersonEntity', phone?: string | null, email?: string | null, firstName?: string | null, lastName?: string | null } | null, address: { __typename?: 'AddressEntity', uuid: string, name: string, line1: string, line2?: string | null, city: string, state: string, latitude?: number | null, longitude?: number | null, zip: string }, terminal?: { __typename?: 'TerminalEntity', name: string } | null, routeSlot?: { __typename?: 'RouteSlotEntity', route?: { __typename?: 'RouteEntity', name: string, date: any, drivers: Array<{ __typename?: 'DriverEntity', firstName: string, lastName: string }> } | null } | null }, previousStopAttempts: Array<{ __typename?: 'StandardStopEntity', completedAt?: any | null }> }>, documents: Array<{ __typename?: 'DocumentEntity', uuid: string, fileName: string, preSignedGetUrl: string, type: DocumentType }> }>, lineHaulLane?: { __typename?: 'LineHaulLaneEntity', name: string, originTerminal: { __typename?: 'TerminalEntity', code: string }, destinationTerminal: { __typename?: 'TerminalEntity', code: string } } | null, startStop?: { __typename?: 'StandardStopEntity', serviceDate?: any | null, incomingCarrier?: string | null, address: { __typename?: 'AddressEntity', name: string, line1: string, line2?: string | null, city: string, state: string, zip: string }, terminal?: { __typename?: 'TerminalEntity', code: string } | null, serviceDateV2?: { __typename?: 'PlainDate', iso8601: string } | null } | null, endStop?: { __typename?: 'StandardStopEntity', serviceDate?: any | null, outboundCarrier?: string | null, address: { __typename?: 'AddressEntity', name: string, line1: string, line2?: string | null, city: string, state: string, zip: string }, terminal?: { __typename?: 'TerminalEntity', code: string } | null, serviceDateV2?: { __typename?: 'PlainDate', iso8601: string } | null } | null, orderComments: Array<{ __typename?: 'OrderCommentEntity', uuid: string, updatedAt: any, comment: string, user?: { __typename?: 'UserEntity', uuid: string, email: string } | null }> };

export type ShipmentWithDocumentsForOrdersTableFragment = { __typename?: 'StandardShipmentEntity', documents: Array<{ __typename?: 'DocumentEntity', uuid: string, fileName: string, preSignedGetUrl: string, type: DocumentType }> };

export type StopWithRouteSlotForOrdersTableFragment = { __typename?: 'StandardStopEntity', routeSlot?: { __typename?: 'RouteSlotEntity', route?: { __typename?: 'RouteEntity', name: string, date: any, drivers: Array<{ __typename?: 'DriverEntity', firstName: string, lastName: string }> } | null } | null };

export type OutstandingOrderQueryStopFragment = { __typename?: 'StandardStopEntity', uuid: string, createdAt: any, specialInstructions?: string | null, stopType?: StopType | null, appointmentRequired: boolean, deadlineTime?: any | null, proofOfDeliverySignee?: string | null, arrivedAt?: any | null, completedAt?: any | null, inboundMethod?: InboundMethod | null, expectedInboundArrivalDate?: any | null, outboundMethod?: OutboundMethod | null, driverCompletedAt?: any | null, notes?: string | null, serviceDate?: any | null, status: StopStatus, appointmentTime?: any | null, endAppointmentTime?: any | null, isSpecial?: boolean | null, settlementDeductionFlatRate?: number | null, settlementDeductionName?: string | null, settlementDeductionPercentageRate?: number | null, standardStopType?: StandardStopType | null, paperworkMarkedComplete?: boolean | null, sentToAgentAt?: any | null, confirmedByAgentAt?: any | null, address: { __typename?: 'AddressEntity', internalNotes?: string | null, iataCode?: string | null, uuid: string, name: string, line1: string, line2?: string | null, city: string, state: string, zip: string, country: string, latitude?: number | null, longitude?: number | null, driverInstructions?: string | null, receivingHoursStart?: any | null, receivingHoursEnd?: any | null, specialInstructions?: string | null }, serviceDateV2?: { __typename?: 'PlainDate', iso8601: string } | null, routeSlot?: { __typename?: 'RouteSlotEntity', uuid: string, route?: { __typename?: 'RouteEntity', uuid: string, date: any, name: string, slots: Array<{ __typename?: 'RouteSlotEntity', uuid: string }>, drivers: Array<{ __typename?: 'DriverEntity', uuid: string, firstName: string, lastName: string, driverType?: DriverType | null, agent?: { __typename?: 'AgentFieldsEntity', uuid: string, name: string } | null }>, equipments: Array<{ __typename?: 'EquipmentEntity', uuid: string, name: string }> } | null } | null, terminal?: { __typename?: 'TerminalEntity', name: string, code: string, uuid: string, isActive: boolean, address: { __typename?: 'AddressEntity', line1: string, line2?: string | null, city: string, state: string, zip: string, uuid: string, name: string, latitude?: number | null, longitude?: number | null }, startForTerminalLanes: Array<{ __typename?: 'TerminalLaneEntity', id: string, endTerminal: { __typename?: 'TerminalEntity', uuid: string, code: string, name: string } }>, agent?: { __typename?: 'AgentFieldsEntity', name: string } | null } | null, stopDriverMaps: Array<{ __typename?: 'StopDriverMapEntity', uuid: string, name?: string | null, enableDriverSettlement?: boolean | null, revenuePercentageRate?: number | null, revenueFlatRate?: number | null, driverPayoutFinalized: boolean, driver: { __typename?: 'DriverEntity', firstName: string, lastName: string, uuid: string, driverType?: DriverType | null, driverReferenceNumber?: string | null, defaultFuelSettlementPercentageRate?: number | null, user: { __typename?: 'UserEntity', name?: string | null }, defaultVehicle?: { __typename?: 'EquipmentEntity', uuid: string } | null, terminal?: { __typename?: 'TerminalEntity', uuid: string, name: string } | null, qualifications: Array<{ __typename?: 'DriverQualificationEntity', id: string }> }, driverSettlementBill?: { __typename?: 'DriverSettlementBillEntity', uuid: string } | null, stop: { __typename?: 'StandardStopEntity', uuid: string, completedAt?: any | null, settlementDeductionName?: string | null, settlementDeductionFlatRate?: number | null, settlementDeductionPercentageRate?: number | null } }> };

export type OutstandingOrderFragmentFragment = { __typename?: 'StandardOrderEntity', updatedAt: any, orderSegmentType: OrderSegmentType, fulfillmentType?: FulfillmentType | null, isOverdue: boolean, detailedStatusV2?: OrderDetailedStatus | null, isCrossDock?: boolean | null, issueReason?: string | null, personName?: string | null, personPhoneNumber?: string | null, personEmail?: string | null, name: string, notes: string, onHand?: boolean | null, dateMarkedOnHand?: any | null, refNumbers: Array<string>, orderConsolidationType: OrderConsolidationType, orderInvoiceByDate?: any | null, paymentMethod?: PaymentMethod | null, source: OrderSource, status: OrderStatus, uuid: string, isDraftOrder: boolean, chargeableWeightCubicMeters?: any | null, totalSkids?: number | null, isReweighed?: boolean | null, secondaryRefNumber?: string | null, lockSecondaryRefNumber: boolean, tertiaryRefNumber?: string | null, quaternaryRefNumber?: string | null, quinaryRefNumber?: string | null, lineHaulCompletedDate: any, consolidatedShipmentString?: string | null, shouldBillIndividually: boolean, enableLineHaul: boolean, inBond?: boolean | null, hazmat?: boolean | null, tags: Array<{ __typename?: 'TagEntity', uuid: string, value: string, color?: string | null }>, thirdPartyBrokers: Array<{ __typename?: 'ThirdPartyBrokerEntity', uuid: string, name: string }>, service?: { __typename?: 'ServiceEntity', uuid: string, name: string } | null, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', uuid: string, shipperBillOfLadingNumber?: string | null, lockShipperBillOfLadingNumber: boolean, masterAirwayBillOfLadingNumber?: string | null, dimFactor?: number | null, measurementUnits: MeasurementUnits, weightUnits: WeightUnits }, documents: Array<{ __typename?: 'DocumentEntity', uuid: string, fileName: string, bucket: string, region: string, key: string, uploadedAt?: any | null, fileType: string, isDeleted: boolean, preSignedGetUrl: string, name?: string | null, type: DocumentType, pageNumber?: number | null, createdAt: any, notes?: string | null, order?: { __typename?: 'StandardOrderEntity', uuid: string, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', shipperBillOfLadingNumber?: string | null } } | null, shipment?: { __typename?: 'StandardOrderEntity', uuid: string } | null, driverFormTemplate?: { __typename?: 'DriverSignableFormTemplateEntity', uuid: string, title: string, formText: string } | null }>, paperwork: { __typename?: 'OrderPaperworkEntity', paperworkComplete: boolean, paperworkMarkedCompleteOverride?: boolean | null, attachedDocuments?: Array<DocumentType> | null, missingDocuments?: Array<DocumentType> | null }, billingPartyContact: { __typename?: 'CustomerContactEntity', uuid: string, displayName: string, numberOfOrdersPerInvoice?: number | null, invoiceTimePeriodSplit?: TimePeriod | null }, billingPartyContactStation?: { __typename?: 'ContactStationEntity', id: string, name: string, defaultPerson?: { __typename?: 'PersonEntity', id: string, firstName: string, lastName: string, phone?: string | null, email?: string | null } | null } | null, packages: Array<{ __typename?: 'PackageEntity', uuid: string, height?: number | null, length?: number | null, quantity: number, type?: PackageType | null, weight?: number | null, width?: number | null, description: string, packageSpec?: { __typename?: 'PackageSpecEntity', id: string, name: string } | null }>, shipments: Array<{ __typename?: 'StandardShipmentEntity', uuid: string, shouldBillIndividually: boolean, shouldUseDimWeight: boolean, overridePackageWeight: boolean, name: string, hideFromBilling: boolean, hasSignedPOD: boolean, status: ShipmentStatus, shipmentType: ShipmentType, documents: Array<{ __typename?: 'DocumentEntity', uuid: string, fileName: string, fileType: string, preSignedGetUrl: string, type: DocumentType, notes?: string | null, name?: string | null }>, fields?: { __typename?: 'StandardShipmentFieldsEntity', uuid: string, deadlineDate?: any | null, deadlineType?: DeadlineType | null, deliveryDate?: any | null, dimFactor: number, pickupOrDelivery: PickupOrDelivery, outboundMethod?: OutboundMethod | null, inboundMethod?: InboundMethod | null, type: StandardShipmentType, service?: { __typename?: 'ServiceEntity', uuid: string, name: string, createdAt: any, updatedAt: any, timeInMinutes?: number | null, useApptInRouteOptimization: boolean, markOrdersAsSpecial: boolean, defaultAppointmentStartTime?: any | null, defaultAppointmentEndTime?: any | null, defaultStartNow: boolean, defaultInboundStopType?: StopType | null, defaultOutboundStopType?: StopType | null, defaultPickupPadding?: any | null, defaultDeliveryPadding?: any | null, defaultTotalDuration?: any | null, defaultIsLineHaul: boolean, defaultFulfillmentType?: FulfillmentType | null, isActive: boolean, isExposedToCustomers: boolean, serviceAvailabilityDates: Array<{ __typename?: 'ServiceAvailabilityDateEntity', id: string, dayCategory: SpecialDayOfWeek, enabled: boolean, start: { __typename?: 'PlainTime', hour: number, minute: number }, end: { __typename?: 'PlainTime', hour: number, minute: number } }> } | null } | null, legs: Array<{ __typename?: 'LegEntity', uuid: string, miles?: number | null, endStop: { __typename?: 'StandardStopEntity', uuid: string, createdAt: any, specialInstructions?: string | null, stopType?: StopType | null, appointmentRequired: boolean, deadlineTime?: any | null, proofOfDeliverySignee?: string | null, arrivedAt?: any | null, completedAt?: any | null, inboundMethod?: InboundMethod | null, expectedInboundArrivalDate?: any | null, outboundMethod?: OutboundMethod | null, driverCompletedAt?: any | null, notes?: string | null, serviceDate?: any | null, status: StopStatus, appointmentTime?: any | null, endAppointmentTime?: any | null, isSpecial?: boolean | null, settlementDeductionFlatRate?: number | null, settlementDeductionName?: string | null, settlementDeductionPercentageRate?: number | null, standardStopType?: StandardStopType | null, paperworkMarkedComplete?: boolean | null, sentToAgentAt?: any | null, confirmedByAgentAt?: any | null, address: { __typename?: 'AddressEntity', internalNotes?: string | null, iataCode?: string | null, uuid: string, name: string, line1: string, line2?: string | null, city: string, state: string, zip: string, country: string, latitude?: number | null, longitude?: number | null, driverInstructions?: string | null, receivingHoursStart?: any | null, receivingHoursEnd?: any | null, specialInstructions?: string | null }, serviceDateV2?: { __typename?: 'PlainDate', iso8601: string } | null, routeSlot?: { __typename?: 'RouteSlotEntity', uuid: string, route?: { __typename?: 'RouteEntity', uuid: string, date: any, name: string, slots: Array<{ __typename?: 'RouteSlotEntity', uuid: string }>, drivers: Array<{ __typename?: 'DriverEntity', uuid: string, firstName: string, lastName: string, driverType?: DriverType | null, agent?: { __typename?: 'AgentFieldsEntity', uuid: string, name: string } | null }>, equipments: Array<{ __typename?: 'EquipmentEntity', uuid: string, name: string }> } | null } | null, terminal?: { __typename?: 'TerminalEntity', name: string, code: string, uuid: string, isActive: boolean, address: { __typename?: 'AddressEntity', line1: string, line2?: string | null, city: string, state: string, zip: string, uuid: string, name: string, latitude?: number | null, longitude?: number | null }, startForTerminalLanes: Array<{ __typename?: 'TerminalLaneEntity', id: string, endTerminal: { __typename?: 'TerminalEntity', uuid: string, code: string, name: string } }>, agent?: { __typename?: 'AgentFieldsEntity', name: string } | null } | null, stopDriverMaps: Array<{ __typename?: 'StopDriverMapEntity', uuid: string, name?: string | null, enableDriverSettlement?: boolean | null, revenuePercentageRate?: number | null, revenueFlatRate?: number | null, driverPayoutFinalized: boolean, driver: { __typename?: 'DriverEntity', firstName: string, lastName: string, uuid: string, driverType?: DriverType | null, driverReferenceNumber?: string | null, defaultFuelSettlementPercentageRate?: number | null, user: { __typename?: 'UserEntity', name?: string | null }, defaultVehicle?: { __typename?: 'EquipmentEntity', uuid: string } | null, terminal?: { __typename?: 'TerminalEntity', uuid: string, name: string } | null, qualifications: Array<{ __typename?: 'DriverQualificationEntity', id: string }> }, driverSettlementBill?: { __typename?: 'DriverSettlementBillEntity', uuid: string } | null, stop: { __typename?: 'StandardStopEntity', uuid: string, completedAt?: any | null, settlementDeductionName?: string | null, settlementDeductionFlatRate?: number | null, settlementDeductionPercentageRate?: number | null } }> }, previousStopAttempts: Array<{ __typename?: 'StandardStopEntity', stopDriverMaps: Array<{ __typename?: 'StopDriverMapEntity', uuid: string, name?: string | null, enableDriverSettlement?: boolean | null, revenuePercentageRate?: number | null, revenueFlatRate?: number | null, driverPayoutFinalized: boolean, driver: { __typename?: 'DriverEntity', firstName: string, lastName: string, uuid: string, driverType?: DriverType | null, driverReferenceNumber?: string | null, defaultFuelSettlementPercentageRate?: number | null, user: { __typename?: 'UserEntity', name?: string | null }, defaultVehicle?: { __typename?: 'EquipmentEntity', uuid: string } | null, terminal?: { __typename?: 'TerminalEntity', uuid: string, name: string } | null, qualifications: Array<{ __typename?: 'DriverQualificationEntity', id: string }> }, driverSettlementBill?: { __typename?: 'DriverSettlementBillEntity', uuid: string } | null, stop: { __typename?: 'StandardStopEntity', uuid: string, completedAt?: any | null, settlementDeductionName?: string | null, settlementDeductionFlatRate?: number | null, settlementDeductionPercentageRate?: number | null } }> }> }>, customCharges: Array<{ __typename?: 'CustomChargeEntity', uuid: string, rate: number, description?: string | null, total: number, totalAmountCents?: number | null, postedAmountUsdCents?: number | null, authoCode?: string | null, quantity: number, billingMethod: CustomChargeBillingMethod, isAutoApplied: boolean, name: string, fuelSurchargeRate?: number | null, postedFuelSurchargeRate?: number | null, zoneBasedAccessorialChargeGroupUuid?: string | null, zoneBasedAccessorialZoneUuid?: string | null, specialAccessorialTariffZoneUuid?: string | null, specialAccessorialChargeGroupUuid?: string | null, settlementFlatRate?: number | null, settlementPercentageRate?: number | null, zoneBasedAccessorialMatrixItem?: { __typename?: 'ZoneBasedAccessorialMatrixItemEntity', uuid: string } | null, specialAccessorialMatrixItem?: { __typename?: 'SpecialAccessorialMatrixItemEntity', uuid: string } | null, accessorialRange?: { __typename?: 'AccessorialRangeEntity', uuid: string, lessThanOrEqualToValue: number, rateUsdCents: number } | null, accessorialTemplate?: { __typename?: 'SkidBasedAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename?: 'SpecialAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename?: 'StandardAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | null }>, freightCharge?: { __typename?: 'FreightChargeEntity', uuid: string, quantity: number, billingMethod: FreightBillingMethod, description?: string | null, authoCode?: string | null, rate: number, discountRate?: any | null, settlementFlatRate?: number | null, settlementPercentageRate?: number | null, total: number, totalAmountCents?: number | null, postedAmountUsdCents?: number | null, fuelCharge?: { __typename?: 'FuelChargeEntity', uuid: string, surchargeRate: number, description?: string | null, authoCode?: string | null, flatRate: number, type: FuelBillingMethod, settlementFlatRate?: number | null, settlementPercentageRate?: number | null, totalAmountCents?: number | null, postedAmountUsdCents?: number | null } | null, tariff?: { __typename?: 'TariffEntity', uuid: string, billingPartyContactUuid?: string | null, tariffGroup?: { __typename?: 'TariffGroupEntity', name?: string | null, tariffGroupScope?: TariffGroupScope | null } | null, tariffZone: { __typename?: 'TariffZoneEntity', name: string } } | null } | null, inputForConsolidatedOrder?: { __typename?: 'StandardOrderEntity', uuid: string, name: string } | null, shipmentCharges: { __typename?: 'ShipmentChargeEntity', totalFuelCharge: number, totalCustomCharge: number, totalFreightCharge: number, totalCharge: number }, invoice?: { __typename?: 'InvoiceEntity', uuid: string, name: string, date: any, postedAt?: any | null } | null, independentSettlementBillLineItems: Array<{ __typename?: 'SettlementBillLineItemEntity', id: string, settlementMode: SettlementMode, totalAmountUsdDollars: number, revenuePercentageRate?: any | null, revenueFlatRate?: number | null, driver: { __typename?: 'DriverEntity', uuid: string, user: { __typename?: 'UserEntity', name?: string | null } }, driverSettlementBill?: { __typename?: 'DriverSettlementBillEntity', uuid: string, name?: string | null, finalizedDate?: any | null } | null, freightCost?: { __typename?: 'FreightCostEntity', id: string, billingMethod?: FreightBillingMethod | null, dependentSettlementBillingMethod?: DependentSettlementBillingMethod | null, percentageRate?: any | null, flatRateUsdDollars?: number | null, quantity?: number | null, rateUsdDollars?: number | null, discountRate?: any | null, totalAmountUsdDollars?: number | null, totalAmountUsdCents: number, tariff?: { __typename?: 'TariffEntity', uuid: string, tariffZone: { __typename?: 'TariffZoneEntity', name: string } } | null, fuelCost?: { __typename?: 'FuelCostEntity', id: string, billingMethod?: FuelBillingMethod | null, dependentSettlementBillingMethod?: DependentSettlementBillingMethod | null, percentageRate?: any | null, surchargeRate?: number | null, flatRateUsdDollars?: number | null, totalAmountUsdDollars?: number | null, totalAmountUsdCents: number } | null } | null, customCosts: Array<{ __typename?: 'CustomCostEntity', id: string, name: string, billingMethod?: CustomChargeBillingMethod | null, dependentSettlementBillingMethod?: DependentSettlementBillingMethod | null, percentageRate?: any | null, flatRateUsdDollars?: number | null, quantity: number, rateUsdDollars?: number | null, fuelSurchargeRate?: number | null, totalAmountUsdDollars?: number | null, totalAmountUsdCents: number, accessorialTemplate?: { __typename: 'SkidBasedAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename: 'SpecialAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename: 'StandardAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename: 'UnitBasedAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename: 'WaitTimeAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename: 'WeightBasedAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename: 'ZoneBasedAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | null, specialAccessorialMatrixItem?: { __typename?: 'SpecialAccessorialMatrixItemEntity', uuid: string, zoneUuid: string, chargeGroupUuid: string } | null, zoneBasedAccessorialMatrixItem?: { __typename?: 'ZoneBasedAccessorialMatrixItemEntity', uuid: string, zoneUuid: string, chargeGroupUuid: string } | null, accessorialRange?: { __typename?: 'AccessorialRangeEntity', uuid: string } | null }> }> }>, orderComments: Array<{ __typename?: 'OrderCommentEntity', uuid: string, updatedAt: any, comment: string, user?: { __typename?: 'UserEntity', uuid: string, email: string } | null }>, consolidatableOrders: { __typename?: 'ConsolidatableOrdersOutput', error?: FindConsolidatableOrdersError | null, orders: Array<{ __typename?: 'StandardOrderEntity', uuid: string }>, shipments?: Array<{ __typename?: 'StandardShipmentEntity', uuid: string }> | null }, consolidatedOrders?: Array<{ __typename?: 'StandardOrderEntity', uuid: string, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', shipperBillOfLadingNumber?: string | null } }> | null, deletedAutoAppliedAccessorials: Array<{ __typename?: 'SkidBasedAccessorialEntity', uuid: string } | { __typename?: 'SpecialAccessorialEntity', uuid: string } | { __typename?: 'StandardAccessorialEntity', uuid: string } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string }>, lineHaulLane?: { __typename?: 'LineHaulLaneEntity', uuid: string } | null, ordersProratedWith?: Array<{ __typename?: 'StandardOrderEntity', uuid: string, name: string, status: OrderStatus, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', shipperBillOfLadingNumber?: string | null } }> | null };

export type PackageSpecsQueryVariables = Exact<{ [key: string]: never; }>;


export type PackageSpecsQuery = { __typename?: 'Query', packageSpecs: { __typename?: 'FindPackageSpecsOutput', packageSpecs: Array<{ __typename?: 'PackageSpecEntity', id: string, name: string, weight?: any | null, length?: any | null, width?: any | null, height?: any | null, status: PackageSpecStatus }> } };

export type PieceFragment = { __typename?: 'PieceEntity', uuid: string, referenceNumber: string, warehouseLocation?: { __typename?: 'WarehouseLocationEntity', uuid: string, name: string } | null };

export type RecurringOrderTemplateFragment = { __typename?: 'StandardOrderEntity', name: string, uuid: string, source: OrderSource, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', shipperBillOfLadingNumber?: string | null }, billingPartyContact: { __typename?: 'CustomerContactEntity', displayName: string }, recurringOrderFrequency?: { __typename?: 'RecurringOrderFrequencyEntity', uuid: string, startDate: any, endDate?: any | null, repeatFrequencyUnit: RepeatFrequencyUnit, repeatIntervalWeeks?: number | null, repeatInterval: number, daysOfWeek: Array<DayOfWeekAll>, daysOfMonth: Array<number> } | null, run?: { __typename?: 'RunEntity', uuid: string, name: string } | null };

export type RecurringOrderTemplatesQueryVariables = Exact<{
  runUuid?: InputMaybe<Scalars['String']['input']>;
}>;


export type RecurringOrderTemplatesQuery = { __typename?: 'Query', recurringOrderTemplates: Array<{ __typename?: 'StandardOrderEntity', name: string, uuid: string, source: OrderSource, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', shipperBillOfLadingNumber?: string | null }, billingPartyContact: { __typename?: 'CustomerContactEntity', displayName: string }, recurringOrderFrequency?: { __typename?: 'RecurringOrderFrequencyEntity', uuid: string, startDate: any, endDate?: any | null, repeatFrequencyUnit: RepeatFrequencyUnit, repeatIntervalWeeks?: number | null, repeatInterval: number, daysOfWeek: Array<DayOfWeekAll>, daysOfMonth: Array<number> } | null, run?: { __typename?: 'RunEntity', uuid: string, name: string } | null }> };

export type RecurringRunTemplateFragment = { __typename?: 'RunEntity', name: string, uuid: string, isArchived: boolean, terminal?: { __typename?: 'TerminalEntity', uuid: string, name: string } | null, driver?: { __typename?: 'DriverEntity', uuid: string, status: DriverStatus, firstName: string, lastName: string } | null, vehicleType?: { __typename?: 'VehicleTypeEntity', uuid: string, name: string } | null, recurringOrderTemplates: Array<{ __typename?: 'StandardOrderEntity', uuid: string }>, tags: Array<{ __typename?: 'TagEntity', uuid: string }> };

export type RecurringRunsQueryVariables = Exact<{ [key: string]: never; }>;


export type RecurringRunsQuery = { __typename?: 'Query', recurringRuns: Array<{ __typename?: 'RunEntity', name: string, uuid: string, isArchived: boolean, terminal?: { __typename?: 'TerminalEntity', uuid: string, name: string } | null, driver?: { __typename?: 'DriverEntity', uuid: string, status: DriverStatus, firstName: string, lastName: string } | null, vehicleType?: { __typename?: 'VehicleTypeEntity', uuid: string, name: string } | null, recurringOrderTemplates: Array<{ __typename?: 'StandardOrderEntity', uuid: string }>, tags: Array<{ __typename?: 'TagEntity', uuid: string }> }> };

export type RemoveOrderHoldMutationVariables = Exact<{
  removeOrderHoldInput: RemoveOrderHoldInput;
}>;


export type RemoveOrderHoldMutation = { __typename?: 'Mutation', removeOrderHold: { __typename?: 'StandardOrderEntity', uuid: string, status: OrderStatus, detailedStatusV2?: OrderDetailedStatus | null } };

export type RemoveSubscriberFromShipmentMutationVariables = Exact<{
  removeSubscriberInput: RemoveSubscriberInput;
}>;


export type RemoveSubscriberFromShipmentMutation = { __typename?: 'Mutation', removeSubscriberFromShipment: { __typename?: 'ShipmentSubscriberEntity', uuid: string } };

export type ReportADocScanIssueMutationVariables = Exact<{
  reportADocScanIssueInput: ReportADocScanIssueInput;
}>;


export type ReportADocScanIssueMutation = { __typename?: 'Mutation', reportADocScanIssue: { __typename?: 'ReportADocScanIssueOutput', success: boolean } };

export type ScannedOrderResultByOrderUuidQueryVariables = Exact<{
  uuid: Scalars['String']['input'];
}>;


export type ScannedOrderResultByOrderUuidQuery = { __typename?: 'Query', scannedOrderResultByOrderUuid?: { __typename?: 'ScannedOrderResultEntity', uuid: string, filename: string, pageEnd: number, pageStart: number, status: ScannedOrderResultStatus, type: ScannedOrderResultType, failureReason?: ScannedOrderFailureReason | null, signedPodMatchStatus?: SignedPodMatchStatus | null, scannedOrder: { __typename?: 'ScannedOrderEntity', uuid: string, bucket: string, failureReason?: ScannedOrderFailureReason | null, filename: string, key: string, preSignedGetUrl: string, retryCount: number, status: ScannedOrderStatus }, scannedOrderResultPages: Array<{ __typename?: 'ScannedOrderResultPageEntity', page: number, preSignedGetUrl: string }> } | null };

export type ServicesForOrderQueryVariables = Exact<{
  findServicesForOrderInput: FindServicesForOrderInput;
}>;


export type ServicesForOrderQuery = { __typename?: 'Query', servicesForOrder: { __typename: 'FindServicesForOrderSuccessOutput', services: Array<{ __typename?: 'ServiceEntity', uuid: string, name: string, isActive: boolean, markOrdersAsSpecial: boolean }> } | { __typename: 'QueryErrorOutput', message: string } };

export type SettlementBillLineItemForOrderFragment = { __typename?: 'SettlementBillLineItemEntity', id: string, settlementMode: SettlementMode, totalAmountUsdDollars: number, revenuePercentageRate?: any | null, revenueFlatRate?: number | null, driver: { __typename?: 'DriverEntity', uuid: string, user: { __typename?: 'UserEntity', name?: string | null } }, driverSettlementBill?: { __typename?: 'DriverSettlementBillEntity', uuid: string, name?: string | null, finalizedDate?: any | null } | null, freightCost?: { __typename?: 'FreightCostEntity', id: string, billingMethod?: FreightBillingMethod | null, dependentSettlementBillingMethod?: DependentSettlementBillingMethod | null, percentageRate?: any | null, flatRateUsdDollars?: number | null, quantity?: number | null, rateUsdDollars?: number | null, discountRate?: any | null, totalAmountUsdDollars?: number | null, totalAmountUsdCents: number, tariff?: { __typename?: 'TariffEntity', uuid: string, tariffZone: { __typename?: 'TariffZoneEntity', name: string } } | null, fuelCost?: { __typename?: 'FuelCostEntity', id: string, billingMethod?: FuelBillingMethod | null, dependentSettlementBillingMethod?: DependentSettlementBillingMethod | null, percentageRate?: any | null, surchargeRate?: number | null, flatRateUsdDollars?: number | null, totalAmountUsdDollars?: number | null, totalAmountUsdCents: number } | null } | null, customCosts: Array<{ __typename?: 'CustomCostEntity', id: string, name: string, billingMethod?: CustomChargeBillingMethod | null, dependentSettlementBillingMethod?: DependentSettlementBillingMethod | null, percentageRate?: any | null, flatRateUsdDollars?: number | null, quantity: number, rateUsdDollars?: number | null, fuelSurchargeRate?: number | null, totalAmountUsdDollars?: number | null, totalAmountUsdCents: number, accessorialTemplate?: { __typename: 'SkidBasedAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename: 'SpecialAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename: 'StandardAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename: 'UnitBasedAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename: 'WaitTimeAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename: 'WeightBasedAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename: 'ZoneBasedAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | null, specialAccessorialMatrixItem?: { __typename?: 'SpecialAccessorialMatrixItemEntity', uuid: string, zoneUuid: string, chargeGroupUuid: string } | null, zoneBasedAccessorialMatrixItem?: { __typename?: 'ZoneBasedAccessorialMatrixItemEntity', uuid: string, zoneUuid: string, chargeGroupUuid: string } | null, accessorialRange?: { __typename?: 'AccessorialRangeEntity', uuid: string } | null }> };

export type FreightCostForOrderFragment = { __typename?: 'FreightCostEntity', id: string, billingMethod?: FreightBillingMethod | null, dependentSettlementBillingMethod?: DependentSettlementBillingMethod | null, percentageRate?: any | null, flatRateUsdDollars?: number | null, quantity?: number | null, rateUsdDollars?: number | null, discountRate?: any | null, totalAmountUsdDollars?: number | null, totalAmountUsdCents: number, tariff?: { __typename?: 'TariffEntity', uuid: string, tariffZone: { __typename?: 'TariffZoneEntity', name: string } } | null, fuelCost?: { __typename?: 'FuelCostEntity', id: string, billingMethod?: FuelBillingMethod | null, dependentSettlementBillingMethod?: DependentSettlementBillingMethod | null, percentageRate?: any | null, surchargeRate?: number | null, flatRateUsdDollars?: number | null, totalAmountUsdDollars?: number | null, totalAmountUsdCents: number } | null };

export type FuelCostForOrderFragment = { __typename?: 'FuelCostEntity', id: string, billingMethod?: FuelBillingMethod | null, dependentSettlementBillingMethod?: DependentSettlementBillingMethod | null, percentageRate?: any | null, surchargeRate?: number | null, flatRateUsdDollars?: number | null, totalAmountUsdDollars?: number | null, totalAmountUsdCents: number };

export type CustomCostForOrderFragment = { __typename?: 'CustomCostEntity', id: string, name: string, billingMethod?: CustomChargeBillingMethod | null, dependentSettlementBillingMethod?: DependentSettlementBillingMethod | null, percentageRate?: any | null, flatRateUsdDollars?: number | null, quantity: number, rateUsdDollars?: number | null, fuelSurchargeRate?: number | null, totalAmountUsdDollars?: number | null, totalAmountUsdCents: number, accessorialTemplate?: { __typename: 'SkidBasedAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename: 'SpecialAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename: 'StandardAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename: 'UnitBasedAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename: 'WaitTimeAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename: 'WeightBasedAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename: 'ZoneBasedAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | null, specialAccessorialMatrixItem?: { __typename?: 'SpecialAccessorialMatrixItemEntity', uuid: string, zoneUuid: string, chargeGroupUuid: string } | null, zoneBasedAccessorialMatrixItem?: { __typename?: 'ZoneBasedAccessorialMatrixItemEntity', uuid: string, zoneUuid: string, chargeGroupUuid: string } | null, accessorialRange?: { __typename?: 'AccessorialRangeEntity', uuid: string } | null };

type ShallowContact_CustomerContactEntity_Fragment = { __typename?: 'CustomerContactEntity', defaultUseTariff?: boolean | null, defaultInvoiceTransmissionMethod: InvoiceTransmissionMethod, defaultInvoiceType: InvoiceType, defaultInvoiceDownloadDocuments: Array<DocumentType>, defaultInvoiceDocumentsRequired: Array<DocumentType>, defaultDimFactor?: number | null, defaultFuelSurcharge?: number | null, numberOfOrdersPerInvoice?: number | null, invoiceTimePeriodSplit?: TimePeriod | null, isPrepaidOnly: boolean, useCustomVehicleTypes: boolean, useCustomPackageSpecs: boolean, displayName: string, type: ContactType, isActive: boolean, shortCode?: string | null, uuid: string, contactReferenceNumber?: string | null, quickbooksMappingId?: string | null, quickbooksDesktopContactId?: string | null, quickbooksFileMappingFreightChargeName?: string | null, quickbooksFileMappingCustomerName?: string | null, quickbooksFileMappingFuelChargeName?: string | null, quickbooksFileMappingPickupChargeName?: string | null, quickbooksDesktopAccountsReceivableId?: string | null, freightChargeQuickbooksMappingId?: string | null, fuelChargeQuickbooksMappingId?: string | null, miscCustomChargeQuickbooksMappingId?: string | null, stediPartnerId?: string | null, billingCycleDuration: BillingCycleDuration, billingContactEmail?: string | null, isEfm?: boolean | null, showEdiReferenceNumbersOnOrderPage: boolean, vehicleTypes: Array<{ __typename?: 'VehicleTypeEntity', uuid: string, name: string, status: VehicleTypeStatus }>, packageSpecs: Array<{ __typename?: 'PackageSpecEntity', id: string, name: string, status: PackageSpecStatus, weight?: any | null, length?: any | null, width?: any | null, height?: any | null }>, services: Array<{ __typename?: 'ServiceEntity', uuid: string, name: string, markOrdersAsSpecial: boolean, defaultAppointmentStartTime?: any | null, defaultAppointmentEndTime?: any | null }>, defaultService?: { __typename?: 'ServiceEntity', uuid: string, name: string } | null, defaultAddress?: { __typename?: 'AddressEntity', uuid: string, line1: string, line2?: string | null, city: string, latitude?: number | null, longitude?: number | null, zip: string, state: string } | null, referenceNumberLabels: Array<{ __typename?: 'ReferenceNumberLabelEntity', name: string }>, contactStations: Array<{ __typename?: 'ContactStationEntity', id: string, name: string, isArchived: boolean, defaultPerson?: { __typename?: 'PersonEntity', id: string, firstName: string, lastName: string, phone?: string | null, email?: string | null } | null }> };

type ShallowContact_ThirdPartyContactEntity_Fragment = { __typename?: 'ThirdPartyContactEntity', displayName: string, type: ContactType, isActive: boolean, shortCode?: string | null, uuid: string, contactReferenceNumber?: string | null, quickbooksMappingId?: string | null, quickbooksDesktopContactId?: string | null, quickbooksFileMappingFreightChargeName?: string | null, quickbooksFileMappingCustomerName?: string | null, quickbooksFileMappingFuelChargeName?: string | null, quickbooksFileMappingPickupChargeName?: string | null, quickbooksDesktopAccountsReceivableId?: string | null, freightChargeQuickbooksMappingId?: string | null, fuelChargeQuickbooksMappingId?: string | null, miscCustomChargeQuickbooksMappingId?: string | null, stediPartnerId?: string | null, billingCycleDuration: BillingCycleDuration, billingContactEmail?: string | null, isEfm?: boolean | null, showEdiReferenceNumbersOnOrderPage: boolean, services: Array<{ __typename?: 'ServiceEntity', uuid: string, name: string, markOrdersAsSpecial: boolean, defaultAppointmentStartTime?: any | null, defaultAppointmentEndTime?: any | null }>, defaultService?: { __typename?: 'ServiceEntity', uuid: string, name: string } | null, defaultAddress?: { __typename?: 'AddressEntity', uuid: string, line1: string, line2?: string | null, city: string, latitude?: number | null, longitude?: number | null, zip: string, state: string } | null, referenceNumberLabels: Array<{ __typename?: 'ReferenceNumberLabelEntity', name: string }>, contactStations: Array<{ __typename?: 'ContactStationEntity', id: string, name: string, isArchived: boolean, defaultPerson?: { __typename?: 'PersonEntity', id: string, firstName: string, lastName: string, phone?: string | null, email?: string | null } | null }> };

export type ShallowContactFragment = ShallowContact_CustomerContactEntity_Fragment | ShallowContact_ThirdPartyContactEntity_Fragment;

export type ShipmentBillOfLadingQueryVariables = Exact<{
  shipmentUuid: Scalars['String']['input'];
}>;


export type ShipmentBillOfLadingQuery = { __typename?: 'Query', shipment: { __typename?: 'StandardShipmentEntity', uuid: string, fields?: { __typename?: 'StandardShipmentFieldsEntity', pickupOrDelivery: PickupOrDelivery, deadlineDate?: any | null } | null, shipperAddress?: { __typename?: 'AddressEntity', uuid: string, name: string, line1: string, line2?: string | null, city: string, state: string, zip: string } | null, legs: Array<{ __typename?: 'LegEntity', uuid: string, endStop: { __typename?: 'StandardStopEntity', stopType?: StopType | null, uuid: string, destinationAirport?: string | null, address: { __typename?: 'AddressEntity', uuid: string, name: string, line1: string, line2?: string | null, city: string, state: string, zip: string } } }>, order?: { __typename?: 'StandardOrderEntity', name: string, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', shipperBillOfLadingNumber?: string | null, masterAirwayBillOfLadingNumber?: string | null }, packages: Array<{ __typename?: 'PackageEntity', uuid: string, description: string, weight?: number | null, quantity: number, length?: number | null, width?: number | null, height?: number | null, type?: PackageType | null, packageSpec?: { __typename?: 'PackageSpecEntity', id: string, name: string } | null, warehouseLocation?: { __typename?: 'WarehouseLocationEntity', name: string } | null }>, billingPartyContact: { __typename?: 'CustomerContactEntity', uuid: string, displayName: string, addresses: Array<{ __typename?: 'AddressEntity', uuid: string, name: string, line1: string, line2?: string | null, city: string, state: string, zip: string }>, defaultAddress?: { __typename?: 'AddressEntity', name: string, line1: string, line2?: string | null, city: string, state: string, zip: string } | null }, ediTransactions: Array<{ __typename?: 'EdiTransactionEntity', uuid: string, code: EdiTransactionCode, status: EdiTransactionStatus }> } | null } };

export type StandardOrderQueryStopFragment = { __typename?: 'StandardStopEntity', uuid: string, createdAt: any, specialInstructions?: string | null, destinationAirport?: string | null, inboundDeadlineDate?: any | null, expectedOutboundDate?: any | null, outboundCarrier?: string | null, appointmentTextStatus?: AppointmentTextStatus | null, incomingCarrier?: string | null, appointmentCallStatus?: AppointmentCallStatus | null, appointmentManuallyConfirmed?: boolean | null, deadlineTime?: any | null, settlementDeductionFlatRate?: number | null, settlementDeductionPercentageRate?: number | null, settlementDeductionName?: string | null, proofOfDeliverySignee?: string | null, appointmentTime?: any | null, arrivedAt?: any | null, completedAt?: any | null, inboundMethod?: InboundMethod | null, expectedInboundArrivalDate?: any | null, outboundMethod?: OutboundMethod | null, driverCompletedAt?: any | null, notes?: string | null, serviceDate?: any | null, status: StopStatus, appointmentRequired: boolean, endAppointmentTime?: any | null, isSpecial?: boolean | null, hideFromDispatch?: boolean | null, standardStopType?: StandardStopType | null, stopType?: StopType | null, paperworkMarkedComplete?: boolean | null, canMarkAttemptComplete?: boolean | null, sentToAgentAt?: any | null, confirmedByAgentAt?: any | null, address: { __typename?: 'AddressEntity', preventCoordRecompute?: boolean | null, internalNotes?: string | null, iataCode?: string | null, uuid: string, name: string, line1: string, line2?: string | null, city: string, state: string, zip: string, country: string, latitude?: number | null, longitude?: number | null, driverInstructions?: string | null, receivingHoursStart?: any | null, receivingHoursEnd?: any | null, specialInstructions?: string | null }, transferAddress?: { __typename?: 'AddressEntity', uuid: string, name: string, line1: string, line2?: string | null, city: string, state: string, zip: string, country: string, latitude?: number | null, longitude?: number | null, driverInstructions?: string | null, receivingHoursStart?: any | null, receivingHoursEnd?: any | null, specialInstructions?: string | null } | null, consigneeAddress?: { __typename?: 'AddressEntity', uuid: string, name: string, line1: string, line2?: string | null, city: string, state: string, zip: string, country: string, latitude?: number | null, longitude?: number | null, driverInstructions?: string | null, receivingHoursStart?: any | null, receivingHoursEnd?: any | null, specialInstructions?: string | null } | null, consigneeContactPerson?: { __typename?: 'ContactPersonEntity', uuid: string, firstName?: string | null, lastName?: string | null, email?: string | null, notes?: string | null, phone?: string | null, createdAt: any } | null, serviceDateV2?: { __typename?: 'PlainDate', iso8601: string } | null, shipperAddress?: { __typename?: 'AddressEntity', uuid: string, name: string, line1: string, line2?: string | null, city: string, state: string, zip: string, country: string, latitude?: number | null, longitude?: number | null, driverInstructions?: string | null, receivingHoursStart?: any | null, receivingHoursEnd?: any | null, specialInstructions?: string | null } | null, shipperContactPerson?: { __typename?: 'ContactPersonEntity', uuid: string, firstName?: string | null, lastName?: string | null, email?: string | null, notes?: string | null, phone?: string | null, createdAt: any } | null, routeSlot?: { __typename?: 'RouteSlotEntity', uuid: string, route?: { __typename?: 'RouteEntity', uuid: string, date: any, name: string, slots: Array<{ __typename?: 'RouteSlotEntity', uuid: string }>, drivers: Array<{ __typename?: 'DriverEntity', uuid: string, firstName: string, lastName: string, driverType?: DriverType | null, agent?: { __typename?: 'AgentFieldsEntity', uuid: string, name: string } | null }>, equipments: Array<{ __typename?: 'EquipmentEntity', uuid: string, name: string }> } | null } | null, contactPerson?: { __typename?: 'ContactPersonEntity', uuid: string, firstName?: string | null, lastName?: string | null, email?: string | null, notes?: string | null, phone?: string | null, createdAt: any } | null, terminal?: { __typename?: 'TerminalEntity', name: string, code: string, uuid: string, isActive: boolean, address: { __typename?: 'AddressEntity', line1: string, line2?: string | null, city: string, state: string, zip: string, uuid: string, name: string, latitude?: number | null, longitude?: number | null }, startForTerminalLanes: Array<{ __typename?: 'TerminalLaneEntity', id: string, endTerminal: { __typename?: 'TerminalEntity', uuid: string, code: string, name: string } }>, agent?: { __typename?: 'AgentFieldsEntity', name: string } | null } | null, stopDriverMaps: Array<{ __typename?: 'StopDriverMapEntity', uuid: string, name?: string | null, enableDriverSettlement?: boolean | null, revenuePercentageRate?: number | null, revenueFlatRate?: number | null, driverPayoutFinalized: boolean, driver: { __typename?: 'DriverEntity', firstName: string, lastName: string, uuid: string, driverType?: DriverType | null, driverReferenceNumber?: string | null, defaultFuelSettlementPercentageRate?: number | null, user: { __typename?: 'UserEntity', name?: string | null }, defaultVehicle?: { __typename?: 'EquipmentEntity', uuid: string } | null, terminal?: { __typename?: 'TerminalEntity', uuid: string, name: string } | null, qualifications: Array<{ __typename?: 'DriverQualificationEntity', id: string }> }, driverSettlementBill?: { __typename?: 'DriverSettlementBillEntity', uuid: string } | null, stop: { __typename?: 'StandardStopEntity', uuid: string, completedAt?: any | null, settlementDeductionName?: string | null, settlementDeductionFlatRate?: number | null, settlementDeductionPercentageRate?: number | null } }> };

export type StandardOrderQueryVariables = Exact<{
  uuid: Scalars['String']['input'];
}>;


export type StandardOrderQuery = { __typename?: 'Query', standardOrder: { __typename?: 'StandardOrderEntity', updatedAt: any, orderSegmentType: OrderSegmentType, fulfillmentType?: FulfillmentType | null, isOverdue: boolean, detailedStatusV2?: OrderDetailedStatus | null, osd?: boolean | null, codCheckAmountCents?: number | null, codCheckNumber?: string | null, isCollectOnDelivery?: boolean | null, isCrossDock?: boolean | null, hasEdiCancellation: boolean, issueReason?: string | null, personName?: string | null, personPhoneNumber?: string | null, personEmail?: string | null, name: string, notes: string, refusedBy?: string | null, refusedDate?: any | null, onHand?: boolean | null, refNumbers: Array<string>, pieceCount?: number | null, piecesPicked?: number | null, orderConsolidationType: OrderConsolidationType, orderInvoiceByDate?: any | null, paymentMethod?: PaymentMethod | null, receivedDate?: any | null, pickedDate?: any | null, source: OrderSource, status: OrderStatus, uuid: string, isDraftOrder: boolean, chargeableWeightCubicMeters?: any | null, totalSkids?: number | null, isReweighed?: boolean | null, inBond?: boolean | null, hazmat?: boolean | null, itTeNumber?: string | null, unNumber?: string | null, hazmatDescription?: string | null, emergencyResponseNumber?: string | null, requiresPlacard?: boolean | null, hazmatClass?: HazmatClass | null, packageGroup?: PackageGroup | null, externalNotes?: string | null, totalAmountCents?: number | null, postedAmountCents?: number | null, secondaryRefNumber?: string | null, lockSecondaryRefNumber: boolean, tertiaryRefNumber?: string | null, quaternaryRefNumber?: string | null, quinaryRefNumber?: string | null, lineHaulCompletedDate: any, dateMarkedLoaded?: any | null, dateMarkedOnHand?: any | null, dateMarkedReceivedAtOrigin?: any | null, piecesLoaded?: number | null, enableLineHaul: boolean, shouldBillIndividually: boolean, consolidatedShipmentString?: string | null, ordersProratedWith?: Array<{ __typename?: 'StandardOrderEntity', uuid: string, name: string, status: OrderStatus, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', shipperBillOfLadingNumber?: string | null } }> | null, vehicleType?: { __typename?: 'VehicleTypeEntity', uuid: string, name: string } | null, holdReason?: { __typename?: 'HoldReasonEntity', uuid: string, name: string } | null, quote?: { __typename?: 'QuoteEntity', uuid: string, number: string } | null, driverQualifications: Array<{ __typename?: 'DriverQualificationEntity', id: string, name: string }>, recurringOrderFrequency?: { __typename?: 'RecurringOrderFrequencyEntity', uuid: string, startDate: any, endDate?: any | null, repeatFrequencyUnit: RepeatFrequencyUnit, repeatInterval: number, daysOfWeek: Array<DayOfWeekAll>, daysOfMonth: Array<number>, repeatIntervalWeeks?: number | null } | null, service?: { __typename?: 'ServiceEntity', uuid: string, name: string } | null, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', uuid: string, shipperBillOfLadingNumber?: string | null, lockShipperBillOfLadingNumber: boolean, masterAirwayBillOfLadingNumber?: string | null, dimFactor?: number | null, measurementUnits: MeasurementUnits, weightUnits: WeightUnits }, scannedOrderResult?: { __typename?: 'ScannedOrderResultEntity', uuid: string, filename: string, pageEnd: number, pageStart: number, status: ScannedOrderResultStatus, type: ScannedOrderResultType, failureReason?: ScannedOrderFailureReason | null, signedPodMatchStatus?: SignedPodMatchStatus | null, scannedOrder: { __typename?: 'ScannedOrderEntity', uuid: string, bucket: string, failureReason?: ScannedOrderFailureReason | null, filename: string, key: string, preSignedGetUrl: string, retryCount: number, status: ScannedOrderStatus, s3Url: string }, scannedOrderResultPages: Array<{ __typename?: 'ScannedOrderResultPageEntity', page: number, preSignedGetUrl: string }> } | null, documents: Array<{ __typename?: 'DocumentEntity', uuid: string, fileName: string, bucket: string, region: string, key: string, uploadedAt?: any | null, fileType: string, isDeleted: boolean, preSignedGetUrl: string, name?: string | null, type: DocumentType, pageNumber?: number | null, createdAt: any, notes?: string | null, order?: { __typename?: 'StandardOrderEntity', uuid: string, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', shipperBillOfLadingNumber?: string | null } } | null, shipment?: { __typename?: 'StandardOrderEntity', uuid: string } | null, driverFormTemplate?: { __typename?: 'DriverSignableFormTemplateEntity', uuid: string, title: string, formText: string } | null }>, paperwork: { __typename?: 'OrderPaperworkEntity', paperworkComplete: boolean, paperworkMarkedCompleteOverride?: boolean | null, attachedDocuments?: Array<DocumentType> | null, missingDocuments?: Array<DocumentType> | null }, billingPartyContact: { __typename?: 'CustomerContactEntity', uuid: string, displayName: string, numberOfOrdersPerInvoice?: number | null, invoiceTimePeriodSplit?: TimePeriod | null, defaultAddress?: { __typename?: 'AddressEntity', uuid: string, name: string, line1: string, line2?: string | null, city: string, state: string, zip: string, country: string, latitude?: number | null, longitude?: number | null, driverInstructions?: string | null, receivingHoursStart?: any | null, receivingHoursEnd?: any | null, specialInstructions?: string | null } | null }, billingPartyContactStation?: { __typename?: 'ContactStationEntity', id: string, name: string, defaultPerson?: { __typename?: 'PersonEntity', id: string, firstName: string, lastName: string, phone?: string | null, email?: string | null } | null } | null, packages: Array<{ __typename?: 'PackageEntity', uuid: string, class?: number | null, description: string, hazmat?: boolean | null, height?: number | null, length?: number | null, nmfc?: string | null, quantity: number, skuNumber?: string | null, type?: PackageType | null, weight?: number | null, width?: number | null, quantityCompletedAtStop?: number | null, reasonUncompletedAtStop?: string | null, packageSpec?: { __typename?: 'PackageSpecEntity', id: string, name: string } | null, warehouseLocation?: { __typename?: 'WarehouseLocationEntity', uuid: string, name: string } | null }>, pieces: Array<{ __typename?: 'PieceEntity', uuid: string, referenceNumber: string, warehouseLocation?: { __typename?: 'WarehouseLocationEntity', uuid: string, name: string } | null }>, shipments: Array<{ __typename?: 'StandardShipmentEntity', uuid: string, totalChargesAmount: number, totalAmountCents?: number | null, postedAmountCents?: number | null, shouldBillIndividually: boolean, shouldUseDimWeight: boolean, overridePackageWeight: boolean, name: string, hideFromBilling: boolean, hasSignedPOD: boolean, shipmentType: ShipmentType, status: ShipmentStatus, invoice?: { __typename?: 'InvoiceEntity', uuid: string, date: any, postedAt?: any | null, dueDate?: any | null, name: string, journalNumber: number, billToContact: { __typename?: 'CustomerContactEntity', uuid: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string } } | null, documents: Array<{ __typename?: 'DocumentEntity', uuid: string, fileName: string, bucket: string, region: string, key: string, uploadedAt?: any | null, fileType: string, isDeleted: boolean, preSignedGetUrl: string, name?: string | null, type: DocumentType, pageNumber?: number | null, createdAt: any, notes?: string | null, order?: { __typename?: 'StandardOrderEntity', uuid: string, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', shipperBillOfLadingNumber?: string | null } } | null, shipment?: { __typename?: 'StandardOrderEntity', uuid: string } | null, driverFormTemplate?: { __typename?: 'DriverSignableFormTemplateEntity', uuid: string, title: string, formText: string } | null }>, shipmentSubscribers: Array<{ __typename?: 'ShipmentSubscriberEntity', uuid: string, email?: string | null }>, shipperAddress?: { __typename?: 'AddressEntity', uuid: string, name: string, line1: string, line2?: string | null, city: string, state: string, zip: string, country: string, latitude?: number | null, longitude?: number | null, driverInstructions?: string | null, receivingHoursStart?: any | null, receivingHoursEnd?: any | null, specialInstructions?: string | null } | null, airportInfo?: { __typename?: 'AirportInfoEntity', uuid: string, iataCode: string, terminal: string, address: { __typename?: 'AddressEntity', uuid: string, name: string, line1: string, line2?: string | null, city: string, state: string, zip: string, country: string, latitude?: number | null, longitude?: number | null, driverInstructions?: string | null, receivingHoursStart?: any | null, receivingHoursEnd?: any | null, specialInstructions?: string | null } } | null, fields?: { __typename?: 'StandardShipmentFieldsEntity', uuid: string, deadlineDate?: any | null, deadlineType?: DeadlineType | null, deliveryDate?: any | null, dimFactor: number, pickupOrDelivery: PickupOrDelivery, outboundMethod?: OutboundMethod | null, inboundMethod?: InboundMethod | null, type: StandardShipmentType, service?: { __typename?: 'ServiceEntity', uuid: string, name: string, createdAt: any, updatedAt: any, timeInMinutes?: number | null, useApptInRouteOptimization: boolean, markOrdersAsSpecial: boolean, defaultAppointmentStartTime?: any | null, defaultAppointmentEndTime?: any | null, defaultStartNow: boolean, defaultInboundStopType?: StopType | null, defaultOutboundStopType?: StopType | null, defaultPickupPadding?: any | null, defaultDeliveryPadding?: any | null, defaultTotalDuration?: any | null, defaultIsLineHaul: boolean, defaultFulfillmentType?: FulfillmentType | null, isActive: boolean, isExposedToCustomers: boolean, serviceAvailabilityDates: Array<{ __typename?: 'ServiceAvailabilityDateEntity', id: string, dayCategory: SpecialDayOfWeek, enabled: boolean, start: { __typename?: 'PlainTime', hour: number, minute: number }, end: { __typename?: 'PlainTime', hour: number, minute: number } }> } | null } | null, legs: Array<{ __typename?: 'LegEntity', uuid: string, miles?: number | null, endStop: { __typename?: 'StandardStopEntity', uuid: string, createdAt: any, specialInstructions?: string | null, destinationAirport?: string | null, inboundDeadlineDate?: any | null, expectedOutboundDate?: any | null, outboundCarrier?: string | null, appointmentTextStatus?: AppointmentTextStatus | null, incomingCarrier?: string | null, appointmentCallStatus?: AppointmentCallStatus | null, appointmentManuallyConfirmed?: boolean | null, deadlineTime?: any | null, settlementDeductionFlatRate?: number | null, settlementDeductionPercentageRate?: number | null, settlementDeductionName?: string | null, proofOfDeliverySignee?: string | null, appointmentTime?: any | null, arrivedAt?: any | null, completedAt?: any | null, inboundMethod?: InboundMethod | null, expectedInboundArrivalDate?: any | null, outboundMethod?: OutboundMethod | null, driverCompletedAt?: any | null, notes?: string | null, serviceDate?: any | null, status: StopStatus, appointmentRequired: boolean, endAppointmentTime?: any | null, isSpecial?: boolean | null, hideFromDispatch?: boolean | null, standardStopType?: StandardStopType | null, stopType?: StopType | null, paperworkMarkedComplete?: boolean | null, canMarkAttemptComplete?: boolean | null, sentToAgentAt?: any | null, confirmedByAgentAt?: any | null, address: { __typename?: 'AddressEntity', preventCoordRecompute?: boolean | null, internalNotes?: string | null, iataCode?: string | null, uuid: string, name: string, line1: string, line2?: string | null, city: string, state: string, zip: string, country: string, latitude?: number | null, longitude?: number | null, driverInstructions?: string | null, receivingHoursStart?: any | null, receivingHoursEnd?: any | null, specialInstructions?: string | null }, transferAddress?: { __typename?: 'AddressEntity', uuid: string, name: string, line1: string, line2?: string | null, city: string, state: string, zip: string, country: string, latitude?: number | null, longitude?: number | null, driverInstructions?: string | null, receivingHoursStart?: any | null, receivingHoursEnd?: any | null, specialInstructions?: string | null } | null, consigneeAddress?: { __typename?: 'AddressEntity', uuid: string, name: string, line1: string, line2?: string | null, city: string, state: string, zip: string, country: string, latitude?: number | null, longitude?: number | null, driverInstructions?: string | null, receivingHoursStart?: any | null, receivingHoursEnd?: any | null, specialInstructions?: string | null } | null, consigneeContactPerson?: { __typename?: 'ContactPersonEntity', uuid: string, firstName?: string | null, lastName?: string | null, email?: string | null, notes?: string | null, phone?: string | null, createdAt: any } | null, serviceDateV2?: { __typename?: 'PlainDate', iso8601: string } | null, shipperAddress?: { __typename?: 'AddressEntity', uuid: string, name: string, line1: string, line2?: string | null, city: string, state: string, zip: string, country: string, latitude?: number | null, longitude?: number | null, driverInstructions?: string | null, receivingHoursStart?: any | null, receivingHoursEnd?: any | null, specialInstructions?: string | null } | null, shipperContactPerson?: { __typename?: 'ContactPersonEntity', uuid: string, firstName?: string | null, lastName?: string | null, email?: string | null, notes?: string | null, phone?: string | null, createdAt: any } | null, routeSlot?: { __typename?: 'RouteSlotEntity', uuid: string, route?: { __typename?: 'RouteEntity', uuid: string, date: any, name: string, slots: Array<{ __typename?: 'RouteSlotEntity', uuid: string }>, drivers: Array<{ __typename?: 'DriverEntity', uuid: string, firstName: string, lastName: string, driverType?: DriverType | null, agent?: { __typename?: 'AgentFieldsEntity', uuid: string, name: string } | null }>, equipments: Array<{ __typename?: 'EquipmentEntity', uuid: string, name: string }> } | null } | null, contactPerson?: { __typename?: 'ContactPersonEntity', uuid: string, firstName?: string | null, lastName?: string | null, email?: string | null, notes?: string | null, phone?: string | null, createdAt: any } | null, terminal?: { __typename?: 'TerminalEntity', name: string, code: string, uuid: string, isActive: boolean, address: { __typename?: 'AddressEntity', line1: string, line2?: string | null, city: string, state: string, zip: string, uuid: string, name: string, latitude?: number | null, longitude?: number | null }, startForTerminalLanes: Array<{ __typename?: 'TerminalLaneEntity', id: string, endTerminal: { __typename?: 'TerminalEntity', uuid: string, code: string, name: string } }>, agent?: { __typename?: 'AgentFieldsEntity', name: string } | null } | null, stopDriverMaps: Array<{ __typename?: 'StopDriverMapEntity', uuid: string, name?: string | null, enableDriverSettlement?: boolean | null, revenuePercentageRate?: number | null, revenueFlatRate?: number | null, driverPayoutFinalized: boolean, driver: { __typename?: 'DriverEntity', firstName: string, lastName: string, uuid: string, driverType?: DriverType | null, driverReferenceNumber?: string | null, defaultFuelSettlementPercentageRate?: number | null, user: { __typename?: 'UserEntity', name?: string | null }, defaultVehicle?: { __typename?: 'EquipmentEntity', uuid: string } | null, terminal?: { __typename?: 'TerminalEntity', uuid: string, name: string } | null, qualifications: Array<{ __typename?: 'DriverQualificationEntity', id: string }> }, driverSettlementBill?: { __typename?: 'DriverSettlementBillEntity', uuid: string } | null, stop: { __typename?: 'StandardStopEntity', uuid: string, completedAt?: any | null, settlementDeductionName?: string | null, settlementDeductionFlatRate?: number | null, settlementDeductionPercentageRate?: number | null } }> }, previousStopAttempts: Array<{ __typename?: 'StandardStopEntity', stopDriverMaps: Array<{ __typename?: 'StopDriverMapEntity', uuid: string, name?: string | null, enableDriverSettlement?: boolean | null, revenuePercentageRate?: number | null, revenueFlatRate?: number | null, driverPayoutFinalized: boolean, driver: { __typename?: 'DriverEntity', firstName: string, lastName: string, uuid: string, driverType?: DriverType | null, driverReferenceNumber?: string | null, defaultFuelSettlementPercentageRate?: number | null, user: { __typename?: 'UserEntity', name?: string | null }, defaultVehicle?: { __typename?: 'EquipmentEntity', uuid: string } | null, terminal?: { __typename?: 'TerminalEntity', uuid: string, name: string } | null, qualifications: Array<{ __typename?: 'DriverQualificationEntity', id: string }> }, driverSettlementBill?: { __typename?: 'DriverSettlementBillEntity', uuid: string } | null, stop: { __typename?: 'StandardStopEntity', uuid: string, completedAt?: any | null, settlementDeductionName?: string | null, settlementDeductionFlatRate?: number | null, settlementDeductionPercentageRate?: number | null } }> }> }>, packages: Array<{ __typename?: 'PackageEntity', uuid: string, class?: number | null, description: string, hazmat?: boolean | null, height?: number | null, length?: number | null, nmfc?: string | null, quantity: number, skuNumber?: string | null, type?: PackageType | null, weight?: number | null, width?: number | null, quantityCompletedAtStop?: number | null, reasonUncompletedAtStop?: string | null, packageSpec?: { __typename?: 'PackageSpecEntity', id: string, name: string } | null, warehouseLocation?: { __typename?: 'WarehouseLocationEntity', uuid: string, name: string } | null }>, customCharges: Array<{ __typename?: 'CustomChargeEntity', uuid: string, rate: number, description?: string | null, total: number, totalAmountCents?: number | null, postedAmountUsdCents?: number | null, authoCode?: string | null, quantity: number, billingMethod: CustomChargeBillingMethod, isAutoApplied: boolean, name: string, fuelSurchargeRate?: number | null, postedFuelSurchargeRate?: number | null, zoneBasedAccessorialChargeGroupUuid?: string | null, zoneBasedAccessorialZoneUuid?: string | null, specialAccessorialTariffZoneUuid?: string | null, specialAccessorialChargeGroupUuid?: string | null, settlementFlatRate?: number | null, settlementPercentageRate?: number | null, zoneBasedAccessorialMatrixItem?: { __typename?: 'ZoneBasedAccessorialMatrixItemEntity', uuid: string } | null, specialAccessorialMatrixItem?: { __typename?: 'SpecialAccessorialMatrixItemEntity', uuid: string } | null, accessorialRange?: { __typename?: 'AccessorialRangeEntity', uuid: string, lessThanOrEqualToValue: number, rateUsdCents: number } | null, accessorialTemplate?: { __typename?: 'SkidBasedAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename?: 'SpecialAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename?: 'StandardAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | null }>, freightCharge?: { __typename?: 'FreightChargeEntity', uuid: string, quantity: number, billingMethod: FreightBillingMethod, description?: string | null, authoCode?: string | null, rate: number, discountRate?: any | null, settlementFlatRate?: number | null, settlementPercentageRate?: number | null, total: number, totalAmountCents?: number | null, postedAmountUsdCents?: number | null, fuelCharge?: { __typename?: 'FuelChargeEntity', uuid: string, surchargeRate: number, description?: string | null, authoCode?: string | null, flatRate: number, type: FuelBillingMethod, settlementFlatRate?: number | null, settlementPercentageRate?: number | null, totalAmountCents?: number | null, postedAmountUsdCents?: number | null } | null, tariff?: { __typename?: 'TariffEntity', uuid: string, billingPartyContactUuid?: string | null, tariffGroup?: { __typename?: 'TariffGroupEntity', name?: string | null, tariffGroupScope?: TariffGroupScope | null } | null, tariffZone: { __typename?: 'TariffZoneEntity', name: string } } | null } | null, inputForConsolidatedOrder?: { __typename?: 'StandardOrderEntity', uuid: string, name: string } | null, shipmentCharges: { __typename?: 'ShipmentChargeEntity', totalFuelCharge: number, totalCustomCharge: number, totalFreightCharge: number, totalCharge: number }, independentSettlementBillLineItems: Array<{ __typename?: 'SettlementBillLineItemEntity', id: string, settlementMode: SettlementMode, totalAmountUsdDollars: number, revenuePercentageRate?: any | null, revenueFlatRate?: number | null, driver: { __typename?: 'DriverEntity', uuid: string, user: { __typename?: 'UserEntity', name?: string | null } }, driverSettlementBill?: { __typename?: 'DriverSettlementBillEntity', uuid: string, name?: string | null, finalizedDate?: any | null } | null, freightCost?: { __typename?: 'FreightCostEntity', id: string, billingMethod?: FreightBillingMethod | null, dependentSettlementBillingMethod?: DependentSettlementBillingMethod | null, percentageRate?: any | null, flatRateUsdDollars?: number | null, quantity?: number | null, rateUsdDollars?: number | null, discountRate?: any | null, totalAmountUsdDollars?: number | null, totalAmountUsdCents: number, tariff?: { __typename?: 'TariffEntity', uuid: string, tariffZone: { __typename?: 'TariffZoneEntity', name: string } } | null, fuelCost?: { __typename?: 'FuelCostEntity', id: string, billingMethod?: FuelBillingMethod | null, dependentSettlementBillingMethod?: DependentSettlementBillingMethod | null, percentageRate?: any | null, surchargeRate?: number | null, flatRateUsdDollars?: number | null, totalAmountUsdDollars?: number | null, totalAmountUsdCents: number } | null } | null, customCosts: Array<{ __typename?: 'CustomCostEntity', id: string, name: string, billingMethod?: CustomChargeBillingMethod | null, dependentSettlementBillingMethod?: DependentSettlementBillingMethod | null, percentageRate?: any | null, flatRateUsdDollars?: number | null, quantity: number, rateUsdDollars?: number | null, fuelSurchargeRate?: number | null, totalAmountUsdDollars?: number | null, totalAmountUsdCents: number, accessorialTemplate?: { __typename: 'SkidBasedAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename: 'SpecialAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename: 'StandardAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename: 'UnitBasedAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename: 'WaitTimeAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename: 'WeightBasedAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename: 'ZoneBasedAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | null, specialAccessorialMatrixItem?: { __typename?: 'SpecialAccessorialMatrixItemEntity', uuid: string, zoneUuid: string, chargeGroupUuid: string } | null, zoneBasedAccessorialMatrixItem?: { __typename?: 'ZoneBasedAccessorialMatrixItemEntity', uuid: string, zoneUuid: string, chargeGroupUuid: string } | null, accessorialRange?: { __typename?: 'AccessorialRangeEntity', uuid: string } | null }> }> }>, lineHaulTimeline: Array<{ __typename?: 'OrderLineHaulTimelineEventEntity', markedArrivedAt?: any | null, terminal: { __typename?: 'TerminalEntity', uuid: string, code: string }, departingManifest?: { __typename?: 'LineHaulManifestEntity', uuid: string, status: LineHaulManifestStatus, departDate: any, startedAt?: any | null, completedAt?: any | null, referenceNumber: string, driver?: { __typename?: 'DriverEntity', firstName: string, lastName: string, agentId?: string | null } | null } | null, arrivalScans: Array<{ __typename?: 'ScanEntity', uuid: string, scannedAt: any }>, departureScans: Array<{ __typename?: 'ScanEntity', uuid: string, scannedAt: any }> }>, tags: Array<{ __typename?: 'TagEntity', uuid: string, value: string, color?: string | null }>, thirdPartyBrokers: Array<{ __typename?: 'ThirdPartyBrokerEntity', uuid: string, name: string }>, warehouse?: { __typename?: 'WarehouseEntity', uuid: string, name: string } | null, ordersWithSameBillOfLadingNumberForReviewOrders?: Array<{ __typename?: 'StandardOrderEntity', uuid: string, name: string }> | null, orderComments: Array<{ __typename?: 'OrderCommentEntity', uuid: string, updatedAt: any, comment: string, showOnInvoice?: boolean | null, authorName: string, user?: { __typename?: 'UserEntity', uuid: string, email: string } | null }>, lineHaulLane?: { __typename?: 'LineHaulLaneEntity', uuid: string, originTerminal: { __typename?: 'TerminalEntity', uuid: string, code: string }, destinationTerminal: { __typename?: 'TerminalEntity', uuid: string, code: string } } | null, consolidatableOrders: { __typename?: 'ConsolidatableOrdersOutput', error?: FindConsolidatableOrdersError | null, orders: Array<{ __typename?: 'StandardOrderEntity', uuid: string }>, shipments?: Array<{ __typename?: 'StandardShipmentEntity', uuid: string }> | null }, consolidatedOrders?: Array<{ __typename?: 'StandardOrderEntity', uuid: string, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', shipperBillOfLadingNumber?: string | null } }> | null, deletedAutoAppliedAccessorials: Array<{ __typename?: 'SkidBasedAccessorialEntity', uuid: string } | { __typename?: 'SpecialAccessorialEntity', uuid: string } | { __typename?: 'StandardAccessorialEntity', uuid: string } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string }> } };

export type StandardOrderFragmentFragment = { __typename?: 'StandardOrderEntity', updatedAt: any, orderSegmentType: OrderSegmentType, fulfillmentType?: FulfillmentType | null, isOverdue: boolean, detailedStatusV2?: OrderDetailedStatus | null, osd?: boolean | null, codCheckAmountCents?: number | null, codCheckNumber?: string | null, isCollectOnDelivery?: boolean | null, isCrossDock?: boolean | null, hasEdiCancellation: boolean, issueReason?: string | null, personName?: string | null, personPhoneNumber?: string | null, personEmail?: string | null, name: string, notes: string, refusedBy?: string | null, refusedDate?: any | null, onHand?: boolean | null, refNumbers: Array<string>, pieceCount?: number | null, piecesPicked?: number | null, orderConsolidationType: OrderConsolidationType, orderInvoiceByDate?: any | null, paymentMethod?: PaymentMethod | null, receivedDate?: any | null, pickedDate?: any | null, source: OrderSource, status: OrderStatus, uuid: string, isDraftOrder: boolean, chargeableWeightCubicMeters?: any | null, totalSkids?: number | null, isReweighed?: boolean | null, inBond?: boolean | null, hazmat?: boolean | null, itTeNumber?: string | null, unNumber?: string | null, hazmatDescription?: string | null, emergencyResponseNumber?: string | null, requiresPlacard?: boolean | null, hazmatClass?: HazmatClass | null, packageGroup?: PackageGroup | null, externalNotes?: string | null, totalAmountCents?: number | null, postedAmountCents?: number | null, secondaryRefNumber?: string | null, lockSecondaryRefNumber: boolean, tertiaryRefNumber?: string | null, quaternaryRefNumber?: string | null, quinaryRefNumber?: string | null, lineHaulCompletedDate: any, dateMarkedLoaded?: any | null, dateMarkedOnHand?: any | null, dateMarkedReceivedAtOrigin?: any | null, piecesLoaded?: number | null, enableLineHaul: boolean, shouldBillIndividually: boolean, consolidatedShipmentString?: string | null, ordersProratedWith?: Array<{ __typename?: 'StandardOrderEntity', uuid: string, name: string, status: OrderStatus, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', shipperBillOfLadingNumber?: string | null } }> | null, vehicleType?: { __typename?: 'VehicleTypeEntity', uuid: string, name: string } | null, holdReason?: { __typename?: 'HoldReasonEntity', uuid: string, name: string } | null, quote?: { __typename?: 'QuoteEntity', uuid: string, number: string } | null, driverQualifications: Array<{ __typename?: 'DriverQualificationEntity', id: string, name: string }>, recurringOrderFrequency?: { __typename?: 'RecurringOrderFrequencyEntity', uuid: string, startDate: any, endDate?: any | null, repeatFrequencyUnit: RepeatFrequencyUnit, repeatInterval: number, daysOfWeek: Array<DayOfWeekAll>, daysOfMonth: Array<number>, repeatIntervalWeeks?: number | null } | null, service?: { __typename?: 'ServiceEntity', uuid: string, name: string } | null, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', uuid: string, shipperBillOfLadingNumber?: string | null, lockShipperBillOfLadingNumber: boolean, masterAirwayBillOfLadingNumber?: string | null, dimFactor?: number | null, measurementUnits: MeasurementUnits, weightUnits: WeightUnits }, scannedOrderResult?: { __typename?: 'ScannedOrderResultEntity', uuid: string, filename: string, pageEnd: number, pageStart: number, status: ScannedOrderResultStatus, type: ScannedOrderResultType, failureReason?: ScannedOrderFailureReason | null, signedPodMatchStatus?: SignedPodMatchStatus | null, scannedOrder: { __typename?: 'ScannedOrderEntity', uuid: string, bucket: string, failureReason?: ScannedOrderFailureReason | null, filename: string, key: string, preSignedGetUrl: string, retryCount: number, status: ScannedOrderStatus, s3Url: string }, scannedOrderResultPages: Array<{ __typename?: 'ScannedOrderResultPageEntity', page: number, preSignedGetUrl: string }> } | null, documents: Array<{ __typename?: 'DocumentEntity', uuid: string, fileName: string, bucket: string, region: string, key: string, uploadedAt?: any | null, fileType: string, isDeleted: boolean, preSignedGetUrl: string, name?: string | null, type: DocumentType, pageNumber?: number | null, createdAt: any, notes?: string | null, order?: { __typename?: 'StandardOrderEntity', uuid: string, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', shipperBillOfLadingNumber?: string | null } } | null, shipment?: { __typename?: 'StandardOrderEntity', uuid: string } | null, driverFormTemplate?: { __typename?: 'DriverSignableFormTemplateEntity', uuid: string, title: string, formText: string } | null }>, paperwork: { __typename?: 'OrderPaperworkEntity', paperworkComplete: boolean, paperworkMarkedCompleteOverride?: boolean | null, attachedDocuments?: Array<DocumentType> | null, missingDocuments?: Array<DocumentType> | null }, billingPartyContact: { __typename?: 'CustomerContactEntity', uuid: string, displayName: string, numberOfOrdersPerInvoice?: number | null, invoiceTimePeriodSplit?: TimePeriod | null, defaultAddress?: { __typename?: 'AddressEntity', uuid: string, name: string, line1: string, line2?: string | null, city: string, state: string, zip: string, country: string, latitude?: number | null, longitude?: number | null, driverInstructions?: string | null, receivingHoursStart?: any | null, receivingHoursEnd?: any | null, specialInstructions?: string | null } | null }, billingPartyContactStation?: { __typename?: 'ContactStationEntity', id: string, name: string, defaultPerson?: { __typename?: 'PersonEntity', id: string, firstName: string, lastName: string, phone?: string | null, email?: string | null } | null } | null, packages: Array<{ __typename?: 'PackageEntity', uuid: string, class?: number | null, description: string, hazmat?: boolean | null, height?: number | null, length?: number | null, nmfc?: string | null, quantity: number, skuNumber?: string | null, type?: PackageType | null, weight?: number | null, width?: number | null, quantityCompletedAtStop?: number | null, reasonUncompletedAtStop?: string | null, packageSpec?: { __typename?: 'PackageSpecEntity', id: string, name: string } | null, warehouseLocation?: { __typename?: 'WarehouseLocationEntity', uuid: string, name: string } | null }>, pieces: Array<{ __typename?: 'PieceEntity', uuid: string, referenceNumber: string, warehouseLocation?: { __typename?: 'WarehouseLocationEntity', uuid: string, name: string } | null }>, shipments: Array<{ __typename?: 'StandardShipmentEntity', uuid: string, totalChargesAmount: number, totalAmountCents?: number | null, postedAmountCents?: number | null, shouldBillIndividually: boolean, shouldUseDimWeight: boolean, overridePackageWeight: boolean, name: string, hideFromBilling: boolean, hasSignedPOD: boolean, shipmentType: ShipmentType, status: ShipmentStatus, invoice?: { __typename?: 'InvoiceEntity', uuid: string, date: any, postedAt?: any | null, dueDate?: any | null, name: string, journalNumber: number, billToContact: { __typename?: 'CustomerContactEntity', uuid: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string } } | null, documents: Array<{ __typename?: 'DocumentEntity', uuid: string, fileName: string, bucket: string, region: string, key: string, uploadedAt?: any | null, fileType: string, isDeleted: boolean, preSignedGetUrl: string, name?: string | null, type: DocumentType, pageNumber?: number | null, createdAt: any, notes?: string | null, order?: { __typename?: 'StandardOrderEntity', uuid: string, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', shipperBillOfLadingNumber?: string | null } } | null, shipment?: { __typename?: 'StandardOrderEntity', uuid: string } | null, driverFormTemplate?: { __typename?: 'DriverSignableFormTemplateEntity', uuid: string, title: string, formText: string } | null }>, shipmentSubscribers: Array<{ __typename?: 'ShipmentSubscriberEntity', uuid: string, email?: string | null }>, shipperAddress?: { __typename?: 'AddressEntity', uuid: string, name: string, line1: string, line2?: string | null, city: string, state: string, zip: string, country: string, latitude?: number | null, longitude?: number | null, driverInstructions?: string | null, receivingHoursStart?: any | null, receivingHoursEnd?: any | null, specialInstructions?: string | null } | null, airportInfo?: { __typename?: 'AirportInfoEntity', uuid: string, iataCode: string, terminal: string, address: { __typename?: 'AddressEntity', uuid: string, name: string, line1: string, line2?: string | null, city: string, state: string, zip: string, country: string, latitude?: number | null, longitude?: number | null, driverInstructions?: string | null, receivingHoursStart?: any | null, receivingHoursEnd?: any | null, specialInstructions?: string | null } } | null, fields?: { __typename?: 'StandardShipmentFieldsEntity', uuid: string, deadlineDate?: any | null, deadlineType?: DeadlineType | null, deliveryDate?: any | null, dimFactor: number, pickupOrDelivery: PickupOrDelivery, outboundMethod?: OutboundMethod | null, inboundMethod?: InboundMethod | null, type: StandardShipmentType, service?: { __typename?: 'ServiceEntity', uuid: string, name: string, createdAt: any, updatedAt: any, timeInMinutes?: number | null, useApptInRouteOptimization: boolean, markOrdersAsSpecial: boolean, defaultAppointmentStartTime?: any | null, defaultAppointmentEndTime?: any | null, defaultStartNow: boolean, defaultInboundStopType?: StopType | null, defaultOutboundStopType?: StopType | null, defaultPickupPadding?: any | null, defaultDeliveryPadding?: any | null, defaultTotalDuration?: any | null, defaultIsLineHaul: boolean, defaultFulfillmentType?: FulfillmentType | null, isActive: boolean, isExposedToCustomers: boolean, serviceAvailabilityDates: Array<{ __typename?: 'ServiceAvailabilityDateEntity', id: string, dayCategory: SpecialDayOfWeek, enabled: boolean, start: { __typename?: 'PlainTime', hour: number, minute: number }, end: { __typename?: 'PlainTime', hour: number, minute: number } }> } | null } | null, legs: Array<{ __typename?: 'LegEntity', uuid: string, miles?: number | null, endStop: { __typename?: 'StandardStopEntity', uuid: string, createdAt: any, specialInstructions?: string | null, destinationAirport?: string | null, inboundDeadlineDate?: any | null, expectedOutboundDate?: any | null, outboundCarrier?: string | null, appointmentTextStatus?: AppointmentTextStatus | null, incomingCarrier?: string | null, appointmentCallStatus?: AppointmentCallStatus | null, appointmentManuallyConfirmed?: boolean | null, deadlineTime?: any | null, settlementDeductionFlatRate?: number | null, settlementDeductionPercentageRate?: number | null, settlementDeductionName?: string | null, proofOfDeliverySignee?: string | null, appointmentTime?: any | null, arrivedAt?: any | null, completedAt?: any | null, inboundMethod?: InboundMethod | null, expectedInboundArrivalDate?: any | null, outboundMethod?: OutboundMethod | null, driverCompletedAt?: any | null, notes?: string | null, serviceDate?: any | null, status: StopStatus, appointmentRequired: boolean, endAppointmentTime?: any | null, isSpecial?: boolean | null, hideFromDispatch?: boolean | null, standardStopType?: StandardStopType | null, stopType?: StopType | null, paperworkMarkedComplete?: boolean | null, canMarkAttemptComplete?: boolean | null, sentToAgentAt?: any | null, confirmedByAgentAt?: any | null, address: { __typename?: 'AddressEntity', preventCoordRecompute?: boolean | null, internalNotes?: string | null, iataCode?: string | null, uuid: string, name: string, line1: string, line2?: string | null, city: string, state: string, zip: string, country: string, latitude?: number | null, longitude?: number | null, driverInstructions?: string | null, receivingHoursStart?: any | null, receivingHoursEnd?: any | null, specialInstructions?: string | null }, transferAddress?: { __typename?: 'AddressEntity', uuid: string, name: string, line1: string, line2?: string | null, city: string, state: string, zip: string, country: string, latitude?: number | null, longitude?: number | null, driverInstructions?: string | null, receivingHoursStart?: any | null, receivingHoursEnd?: any | null, specialInstructions?: string | null } | null, consigneeAddress?: { __typename?: 'AddressEntity', uuid: string, name: string, line1: string, line2?: string | null, city: string, state: string, zip: string, country: string, latitude?: number | null, longitude?: number | null, driverInstructions?: string | null, receivingHoursStart?: any | null, receivingHoursEnd?: any | null, specialInstructions?: string | null } | null, consigneeContactPerson?: { __typename?: 'ContactPersonEntity', uuid: string, firstName?: string | null, lastName?: string | null, email?: string | null, notes?: string | null, phone?: string | null, createdAt: any } | null, serviceDateV2?: { __typename?: 'PlainDate', iso8601: string } | null, shipperAddress?: { __typename?: 'AddressEntity', uuid: string, name: string, line1: string, line2?: string | null, city: string, state: string, zip: string, country: string, latitude?: number | null, longitude?: number | null, driverInstructions?: string | null, receivingHoursStart?: any | null, receivingHoursEnd?: any | null, specialInstructions?: string | null } | null, shipperContactPerson?: { __typename?: 'ContactPersonEntity', uuid: string, firstName?: string | null, lastName?: string | null, email?: string | null, notes?: string | null, phone?: string | null, createdAt: any } | null, routeSlot?: { __typename?: 'RouteSlotEntity', uuid: string, route?: { __typename?: 'RouteEntity', uuid: string, date: any, name: string, slots: Array<{ __typename?: 'RouteSlotEntity', uuid: string }>, drivers: Array<{ __typename?: 'DriverEntity', uuid: string, firstName: string, lastName: string, driverType?: DriverType | null, agent?: { __typename?: 'AgentFieldsEntity', uuid: string, name: string } | null }>, equipments: Array<{ __typename?: 'EquipmentEntity', uuid: string, name: string }> } | null } | null, contactPerson?: { __typename?: 'ContactPersonEntity', uuid: string, firstName?: string | null, lastName?: string | null, email?: string | null, notes?: string | null, phone?: string | null, createdAt: any } | null, terminal?: { __typename?: 'TerminalEntity', name: string, code: string, uuid: string, isActive: boolean, address: { __typename?: 'AddressEntity', line1: string, line2?: string | null, city: string, state: string, zip: string, uuid: string, name: string, latitude?: number | null, longitude?: number | null }, startForTerminalLanes: Array<{ __typename?: 'TerminalLaneEntity', id: string, endTerminal: { __typename?: 'TerminalEntity', uuid: string, code: string, name: string } }>, agent?: { __typename?: 'AgentFieldsEntity', name: string } | null } | null, stopDriverMaps: Array<{ __typename?: 'StopDriverMapEntity', uuid: string, name?: string | null, enableDriverSettlement?: boolean | null, revenuePercentageRate?: number | null, revenueFlatRate?: number | null, driverPayoutFinalized: boolean, driver: { __typename?: 'DriverEntity', firstName: string, lastName: string, uuid: string, driverType?: DriverType | null, driverReferenceNumber?: string | null, defaultFuelSettlementPercentageRate?: number | null, user: { __typename?: 'UserEntity', name?: string | null }, defaultVehicle?: { __typename?: 'EquipmentEntity', uuid: string } | null, terminal?: { __typename?: 'TerminalEntity', uuid: string, name: string } | null, qualifications: Array<{ __typename?: 'DriverQualificationEntity', id: string }> }, driverSettlementBill?: { __typename?: 'DriverSettlementBillEntity', uuid: string } | null, stop: { __typename?: 'StandardStopEntity', uuid: string, completedAt?: any | null, settlementDeductionName?: string | null, settlementDeductionFlatRate?: number | null, settlementDeductionPercentageRate?: number | null } }> }, previousStopAttempts: Array<{ __typename?: 'StandardStopEntity', stopDriverMaps: Array<{ __typename?: 'StopDriverMapEntity', uuid: string, name?: string | null, enableDriverSettlement?: boolean | null, revenuePercentageRate?: number | null, revenueFlatRate?: number | null, driverPayoutFinalized: boolean, driver: { __typename?: 'DriverEntity', firstName: string, lastName: string, uuid: string, driverType?: DriverType | null, driverReferenceNumber?: string | null, defaultFuelSettlementPercentageRate?: number | null, user: { __typename?: 'UserEntity', name?: string | null }, defaultVehicle?: { __typename?: 'EquipmentEntity', uuid: string } | null, terminal?: { __typename?: 'TerminalEntity', uuid: string, name: string } | null, qualifications: Array<{ __typename?: 'DriverQualificationEntity', id: string }> }, driverSettlementBill?: { __typename?: 'DriverSettlementBillEntity', uuid: string } | null, stop: { __typename?: 'StandardStopEntity', uuid: string, completedAt?: any | null, settlementDeductionName?: string | null, settlementDeductionFlatRate?: number | null, settlementDeductionPercentageRate?: number | null } }> }> }>, packages: Array<{ __typename?: 'PackageEntity', uuid: string, class?: number | null, description: string, hazmat?: boolean | null, height?: number | null, length?: number | null, nmfc?: string | null, quantity: number, skuNumber?: string | null, type?: PackageType | null, weight?: number | null, width?: number | null, quantityCompletedAtStop?: number | null, reasonUncompletedAtStop?: string | null, packageSpec?: { __typename?: 'PackageSpecEntity', id: string, name: string } | null, warehouseLocation?: { __typename?: 'WarehouseLocationEntity', uuid: string, name: string } | null }>, customCharges: Array<{ __typename?: 'CustomChargeEntity', uuid: string, rate: number, description?: string | null, total: number, totalAmountCents?: number | null, postedAmountUsdCents?: number | null, authoCode?: string | null, quantity: number, billingMethod: CustomChargeBillingMethod, isAutoApplied: boolean, name: string, fuelSurchargeRate?: number | null, postedFuelSurchargeRate?: number | null, zoneBasedAccessorialChargeGroupUuid?: string | null, zoneBasedAccessorialZoneUuid?: string | null, specialAccessorialTariffZoneUuid?: string | null, specialAccessorialChargeGroupUuid?: string | null, settlementFlatRate?: number | null, settlementPercentageRate?: number | null, zoneBasedAccessorialMatrixItem?: { __typename?: 'ZoneBasedAccessorialMatrixItemEntity', uuid: string } | null, specialAccessorialMatrixItem?: { __typename?: 'SpecialAccessorialMatrixItemEntity', uuid: string } | null, accessorialRange?: { __typename?: 'AccessorialRangeEntity', uuid: string, lessThanOrEqualToValue: number, rateUsdCents: number } | null, accessorialTemplate?: { __typename?: 'SkidBasedAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename?: 'SpecialAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename?: 'StandardAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | null }>, freightCharge?: { __typename?: 'FreightChargeEntity', uuid: string, quantity: number, billingMethod: FreightBillingMethod, description?: string | null, authoCode?: string | null, rate: number, discountRate?: any | null, settlementFlatRate?: number | null, settlementPercentageRate?: number | null, total: number, totalAmountCents?: number | null, postedAmountUsdCents?: number | null, fuelCharge?: { __typename?: 'FuelChargeEntity', uuid: string, surchargeRate: number, description?: string | null, authoCode?: string | null, flatRate: number, type: FuelBillingMethod, settlementFlatRate?: number | null, settlementPercentageRate?: number | null, totalAmountCents?: number | null, postedAmountUsdCents?: number | null } | null, tariff?: { __typename?: 'TariffEntity', uuid: string, billingPartyContactUuid?: string | null, tariffGroup?: { __typename?: 'TariffGroupEntity', name?: string | null, tariffGroupScope?: TariffGroupScope | null } | null, tariffZone: { __typename?: 'TariffZoneEntity', name: string } } | null } | null, inputForConsolidatedOrder?: { __typename?: 'StandardOrderEntity', uuid: string, name: string } | null, shipmentCharges: { __typename?: 'ShipmentChargeEntity', totalFuelCharge: number, totalCustomCharge: number, totalFreightCharge: number, totalCharge: number }, independentSettlementBillLineItems: Array<{ __typename?: 'SettlementBillLineItemEntity', id: string, settlementMode: SettlementMode, totalAmountUsdDollars: number, revenuePercentageRate?: any | null, revenueFlatRate?: number | null, driver: { __typename?: 'DriverEntity', uuid: string, user: { __typename?: 'UserEntity', name?: string | null } }, driverSettlementBill?: { __typename?: 'DriverSettlementBillEntity', uuid: string, name?: string | null, finalizedDate?: any | null } | null, freightCost?: { __typename?: 'FreightCostEntity', id: string, billingMethod?: FreightBillingMethod | null, dependentSettlementBillingMethod?: DependentSettlementBillingMethod | null, percentageRate?: any | null, flatRateUsdDollars?: number | null, quantity?: number | null, rateUsdDollars?: number | null, discountRate?: any | null, totalAmountUsdDollars?: number | null, totalAmountUsdCents: number, tariff?: { __typename?: 'TariffEntity', uuid: string, tariffZone: { __typename?: 'TariffZoneEntity', name: string } } | null, fuelCost?: { __typename?: 'FuelCostEntity', id: string, billingMethod?: FuelBillingMethod | null, dependentSettlementBillingMethod?: DependentSettlementBillingMethod | null, percentageRate?: any | null, surchargeRate?: number | null, flatRateUsdDollars?: number | null, totalAmountUsdDollars?: number | null, totalAmountUsdCents: number } | null } | null, customCosts: Array<{ __typename?: 'CustomCostEntity', id: string, name: string, billingMethod?: CustomChargeBillingMethod | null, dependentSettlementBillingMethod?: DependentSettlementBillingMethod | null, percentageRate?: any | null, flatRateUsdDollars?: number | null, quantity: number, rateUsdDollars?: number | null, fuelSurchargeRate?: number | null, totalAmountUsdDollars?: number | null, totalAmountUsdCents: number, accessorialTemplate?: { __typename: 'SkidBasedAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename: 'SpecialAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename: 'StandardAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename: 'UnitBasedAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename: 'WaitTimeAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename: 'WeightBasedAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename: 'ZoneBasedAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | null, specialAccessorialMatrixItem?: { __typename?: 'SpecialAccessorialMatrixItemEntity', uuid: string, zoneUuid: string, chargeGroupUuid: string } | null, zoneBasedAccessorialMatrixItem?: { __typename?: 'ZoneBasedAccessorialMatrixItemEntity', uuid: string, zoneUuid: string, chargeGroupUuid: string } | null, accessorialRange?: { __typename?: 'AccessorialRangeEntity', uuid: string } | null }> }> }>, lineHaulTimeline: Array<{ __typename?: 'OrderLineHaulTimelineEventEntity', markedArrivedAt?: any | null, terminal: { __typename?: 'TerminalEntity', uuid: string, code: string }, departingManifest?: { __typename?: 'LineHaulManifestEntity', uuid: string, status: LineHaulManifestStatus, departDate: any, startedAt?: any | null, completedAt?: any | null, referenceNumber: string, driver?: { __typename?: 'DriverEntity', firstName: string, lastName: string, agentId?: string | null } | null } | null, arrivalScans: Array<{ __typename?: 'ScanEntity', uuid: string, scannedAt: any }>, departureScans: Array<{ __typename?: 'ScanEntity', uuid: string, scannedAt: any }> }>, tags: Array<{ __typename?: 'TagEntity', uuid: string, value: string, color?: string | null }>, thirdPartyBrokers: Array<{ __typename?: 'ThirdPartyBrokerEntity', uuid: string, name: string }>, warehouse?: { __typename?: 'WarehouseEntity', uuid: string, name: string } | null, ordersWithSameBillOfLadingNumberForReviewOrders?: Array<{ __typename?: 'StandardOrderEntity', uuid: string, name: string }> | null, orderComments: Array<{ __typename?: 'OrderCommentEntity', uuid: string, updatedAt: any, comment: string, showOnInvoice?: boolean | null, authorName: string, user?: { __typename?: 'UserEntity', uuid: string, email: string } | null }>, lineHaulLane?: { __typename?: 'LineHaulLaneEntity', uuid: string, originTerminal: { __typename?: 'TerminalEntity', uuid: string, code: string }, destinationTerminal: { __typename?: 'TerminalEntity', uuid: string, code: string } } | null, consolidatableOrders: { __typename?: 'ConsolidatableOrdersOutput', error?: FindConsolidatableOrdersError | null, orders: Array<{ __typename?: 'StandardOrderEntity', uuid: string }>, shipments?: Array<{ __typename?: 'StandardShipmentEntity', uuid: string }> | null }, consolidatedOrders?: Array<{ __typename?: 'StandardOrderEntity', uuid: string, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', shipperBillOfLadingNumber?: string | null } }> | null, deletedAutoAppliedAccessorials: Array<{ __typename?: 'SkidBasedAccessorialEntity', uuid: string } | { __typename?: 'SpecialAccessorialEntity', uuid: string } | { __typename?: 'StandardAccessorialEntity', uuid: string } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string }> };

export type StopDriverMapForOrderFragment = { __typename?: 'StopDriverMapEntity', uuid: string, name?: string | null, enableDriverSettlement?: boolean | null, revenuePercentageRate?: number | null, revenueFlatRate?: number | null, driverPayoutFinalized: boolean, driver: { __typename?: 'DriverEntity', firstName: string, lastName: string, uuid: string, driverType?: DriverType | null, driverReferenceNumber?: string | null, defaultFuelSettlementPercentageRate?: number | null, user: { __typename?: 'UserEntity', name?: string | null }, defaultVehicle?: { __typename?: 'EquipmentEntity', uuid: string } | null, terminal?: { __typename?: 'TerminalEntity', uuid: string, name: string } | null, qualifications: Array<{ __typename?: 'DriverQualificationEntity', id: string }> }, driverSettlementBill?: { __typename?: 'DriverSettlementBillEntity', uuid: string } | null, stop: { __typename?: 'StandardStopEntity', uuid: string, completedAt?: any | null, settlementDeductionName?: string | null, settlementDeductionFlatRate?: number | null, settlementDeductionPercentageRate?: number | null } };

export type StopForDriverSettlementFragment = { __typename?: 'StandardStopEntity', uuid: string, settlementDeductionName?: string | null, settlementDeductionFlatRate?: number | null, settlementDeductionPercentageRate?: number | null, stopDriverMaps: Array<{ __typename?: 'StopDriverMapEntity', uuid: string, name?: string | null, enableDriverSettlement?: boolean | null, revenuePercentageRate?: number | null, revenueFlatRate?: number | null, driverPayoutFinalized: boolean, driver: { __typename?: 'DriverEntity', firstName: string, lastName: string, uuid: string, driverType?: DriverType | null, driverReferenceNumber?: string | null, defaultFuelSettlementPercentageRate?: number | null, user: { __typename?: 'UserEntity', name?: string | null }, defaultVehicle?: { __typename?: 'EquipmentEntity', uuid: string } | null, terminal?: { __typename?: 'TerminalEntity', uuid: string, name: string } | null, qualifications: Array<{ __typename?: 'DriverQualificationEntity', id: string }> }, driverSettlementBill?: { __typename?: 'DriverSettlementBillEntity', uuid: string } | null, stop: { __typename?: 'StandardStopEntity', uuid: string, completedAt?: any | null, settlementDeductionName?: string | null, settlementDeductionFlatRate?: number | null, settlementDeductionPercentageRate?: number | null } }> };

export type StopForDriverSettlementQueryVariables = Exact<{
  uuid: Scalars['String']['input'];
}>;


export type StopForDriverSettlementQuery = { __typename?: 'Query', stop: { __typename?: 'StandardStopEntity', uuid: string, settlementDeductionName?: string | null, settlementDeductionFlatRate?: number | null, settlementDeductionPercentageRate?: number | null, stopDriverMaps: Array<{ __typename?: 'StopDriverMapEntity', uuid: string, name?: string | null, enableDriverSettlement?: boolean | null, revenuePercentageRate?: number | null, revenueFlatRate?: number | null, driverPayoutFinalized: boolean, driver: { __typename?: 'DriverEntity', firstName: string, lastName: string, uuid: string, driverType?: DriverType | null, driverReferenceNumber?: string | null, defaultFuelSettlementPercentageRate?: number | null, user: { __typename?: 'UserEntity', name?: string | null }, defaultVehicle?: { __typename?: 'EquipmentEntity', uuid: string } | null, terminal?: { __typename?: 'TerminalEntity', uuid: string, name: string } | null, qualifications: Array<{ __typename?: 'DriverQualificationEntity', id: string }> }, driverSettlementBill?: { __typename?: 'DriverSettlementBillEntity', uuid: string } | null, stop: { __typename?: 'StandardStopEntity', uuid: string, completedAt?: any | null, settlementDeductionName?: string | null, settlementDeductionFlatRate?: number | null, settlementDeductionPercentageRate?: number | null } }> } };

export type UncancelOrderMutationVariables = Exact<{
  uuid: Scalars['String']['input'];
}>;


export type UncancelOrderMutation = { __typename?: 'Mutation', uncancelOrder: { __typename?: 'StandardOrderEntity', uuid: string, status: OrderStatus, detailedStatusV2?: OrderDetailedStatus | null } };

export type UnfinalizeOrderMutationVariables = Exact<{
  uuid: Scalars['String']['input'];
}>;


export type UnfinalizeOrderMutation = { __typename?: 'Mutation', unfinalizeOrder: { __typename?: 'StandardOrderEntity', uuid: string, status: OrderStatus, detailedStatusV2?: OrderDetailedStatus | null, shipments: Array<{ __typename?: 'StandardShipmentEntity', uuid: string, status: ShipmentStatus }> } };

export type UpdateDocumentMutationVariables = Exact<{
  updateDocumentInput: UpdateDocumentInput;
}>;


export type UpdateDocumentMutation = { __typename?: 'Mutation', updateDocument: { __typename?: 'DocumentEntity', uuid: string } };

export type UpdatePaperworkCompletedForStopsMutationVariables = Exact<{
  updatePaperworkCompleteInput: UpdatePaperworkCompleteInput;
}>;


export type UpdatePaperworkCompletedForStopsMutation = { __typename?: 'Mutation', updatePaperworkCompletedForStops: Array<{ __typename?: 'StandardStopEntity', uuid: string }> };

export type UpdateRecurringRunMutationVariables = Exact<{
  input: UpdateRunInput;
}>;


export type UpdateRecurringRunMutation = { __typename?: 'Mutation', updateRun: { __typename?: 'UpdateRunOutput', run: { __typename?: 'RunEntity', name: string, uuid: string, isArchived: boolean, terminal?: { __typename?: 'TerminalEntity', uuid: string, name: string } | null, driver?: { __typename?: 'DriverEntity', uuid: string, status: DriverStatus, firstName: string, lastName: string } | null, vehicleType?: { __typename?: 'VehicleTypeEntity', uuid: string, name: string } | null, recurringOrderTemplates: Array<{ __typename?: 'StandardOrderEntity', uuid: string }>, tags: Array<{ __typename?: 'TagEntity', uuid: string }> } } };

export type UpdateStandardOrderMutationVariables = Exact<{
  updateStandardOrderInput: UpdateStandardOrderInput;
}>;


export type UpdateStandardOrderMutation = { __typename?: 'Mutation', updateStandardOrder: { __typename?: 'StandardOrderEntity', uuid: string, detailedStatusV2?: OrderDetailedStatus | null, status: OrderStatus, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', shipperBillOfLadingNumber?: string | null } } };

export type RateOrderByUuidQueryVariables = Exact<{
  uuid: Scalars['String']['input'];
  persist: Scalars['Boolean']['input'];
}>;


export type RateOrderByUuidQuery = { __typename?: 'Query', rateOrderByUuid: { __typename: 'RateOrderErrorOutput', success: boolean, errorMessage?: string | null } | { __typename: 'RateOrderSuccessOutput', success: boolean } };

export type RateOrderTotalDollarsQueryVariables = Exact<{
  rateOrderInput: RateOrderInput;
}>;


export type RateOrderTotalDollarsQuery = { __typename?: 'Query', rateOrderContents: { __typename: 'RateOrderErrorOutput', success: boolean, errorMessage?: string | null } | { __typename: 'RateOrderSuccessOutput', success: boolean, totalDollars?: any | null, inboundShipmentCharges?: { __typename?: 'RateShipmentForOrderSuccessOutput', freightCharge?: { __typename?: 'RateFreightChargeSuccessOutput', totalDollars: any } | null, fuelCharge?: { __typename?: 'RateFuelChargeSuccessOutput', totalDollars: any } | null } | null, outboundShipmentCharges?: { __typename?: 'RateShipmentForOrderSuccessOutput', freightCharge?: { __typename?: 'RateFreightChargeSuccessOutput', totalDollars: any } | null, fuelCharge?: { __typename?: 'RateFuelChargeSuccessOutput', totalDollars: any } | null } | null } };

export type RateOrderSettlementBillLineItemFragment = { __typename?: 'RateIndependentSettlementBillLineItemSuccessOutput', customCostTotal: any, success: boolean, total: any, customCosts: Array<{ __typename?: 'RateCustomCostOutput', errorMessage?: number | null, existingCustomCostId?: string | null, fuelSurchargePercentageRate?: number | null, rateDollars?: any | null, totalDollars?: any | null }>, freightCost?: { __typename?: 'RateIndependentFreightCostSuccessOutput', discountRate?: any | null, miles?: number | null, quantity: number, rateDollars: any, tariffUuid?: string | null, totalDollars: any } | null, fuelCost?: { __typename?: 'RateIndependentFuelCostSuccessOutput', surchargeRate?: number | null, surchargeRatePercentage?: any | null, totalDollars: any } | null };

export type RateOrderQueryVariables = Exact<{
  rateOrderInput: RateOrderInput;
}>;


export type RateOrderQuery = { __typename?: 'Query', rateOrderContents: { __typename: 'RateOrderErrorOutput', success: boolean, errorMessage?: string | null } | { __typename: 'RateOrderSuccessOutput', success: boolean, totalDollars?: any | null, inboundShipmentCharges?: { __typename?: 'RateShipmentForOrderSuccessOutput', freightCharge?: { __typename?: 'RateFreightChargeSuccessOutput', rateDollars: any, totalDollars: any, tariffUuid?: string | null, quantity: number, discountRate?: any | null, miles?: number | null, settlementFlatRate?: any | null, settlementPercentageRate?: any | null } | null, fuelCharge?: { __typename?: 'RateFuelChargeSuccessOutput', surchargeRatePercentage?: any | null, totalDollars: any, settlementFlatRate?: any | null, settlementPercentageRate?: any | null } | null, customCharges: Array<{ __typename?: 'RateCustomChargeOutput', rateDollars?: any | null, totalDollars?: any | null, fuelSurchargePercentageRate?: number | null, settlementFlatRate?: any | null, settlementPercentageRate?: any | null }>, independentSettlementBillLineItems: Array<{ __typename?: 'RateIndependentSettlementBillLineItemSuccessOutput', customCostTotal: any, success: boolean, total: any, customCosts: Array<{ __typename?: 'RateCustomCostOutput', errorMessage?: number | null, existingCustomCostId?: string | null, fuelSurchargePercentageRate?: number | null, rateDollars?: any | null, totalDollars?: any | null }>, freightCost?: { __typename?: 'RateIndependentFreightCostSuccessOutput', discountRate?: any | null, miles?: number | null, quantity: number, rateDollars: any, tariffUuid?: string | null, totalDollars: any } | null, fuelCost?: { __typename?: 'RateIndependentFuelCostSuccessOutput', surchargeRate?: number | null, surchargeRatePercentage?: any | null, totalDollars: any } | null }> } | null, outboundShipmentCharges?: { __typename?: 'RateShipmentForOrderSuccessOutput', freightCharge?: { __typename?: 'RateFreightChargeSuccessOutput', rateDollars: any, totalDollars: any, tariffUuid?: string | null, quantity: number, discountRate?: any | null, miles?: number | null, settlementFlatRate?: any | null, settlementPercentageRate?: any | null } | null, fuelCharge?: { __typename?: 'RateFuelChargeSuccessOutput', surchargeRatePercentage?: any | null, totalDollars: any, settlementFlatRate?: any | null, settlementPercentageRate?: any | null } | null, customCharges: Array<{ __typename?: 'RateCustomChargeOutput', rateDollars?: any | null, totalDollars?: any | null, fuelSurchargePercentageRate?: number | null, settlementFlatRate?: any | null, settlementPercentageRate?: any | null }>, independentSettlementBillLineItems: Array<{ __typename?: 'RateIndependentSettlementBillLineItemSuccessOutput', customCostTotal: any, success: boolean, total: any, customCosts: Array<{ __typename?: 'RateCustomCostOutput', errorMessage?: number | null, existingCustomCostId?: string | null, fuelSurchargePercentageRate?: number | null, rateDollars?: any | null, totalDollars?: any | null }>, freightCost?: { __typename?: 'RateIndependentFreightCostSuccessOutput', discountRate?: any | null, miles?: number | null, quantity: number, rateDollars: any, tariffUuid?: string | null, totalDollars: any } | null, fuelCost?: { __typename?: 'RateIndependentFuelCostSuccessOutput', surchargeRate?: number | null, surchargeRatePercentage?: any | null, totalDollars: any } | null }> } | null, lineHaulCharges?: { __typename?: 'RateShipmentForOrderSuccessOutput', freightCharge?: { __typename?: 'RateFreightChargeSuccessOutput', rateDollars: any, totalDollars: any, tariffUuid?: string | null, quantity: number, discountRate?: any | null, miles?: number | null, settlementFlatRate?: any | null, settlementPercentageRate?: any | null } | null, fuelCharge?: { __typename?: 'RateFuelChargeSuccessOutput', surchargeRatePercentage?: any | null, totalDollars: any, settlementFlatRate?: any | null, settlementPercentageRate?: any | null } | null, customCharges: Array<{ __typename?: 'RateCustomChargeOutput', rateDollars?: any | null, totalDollars?: any | null, fuelSurchargePercentageRate?: number | null, settlementFlatRate?: any | null, settlementPercentageRate?: any | null }>, independentSettlementBillLineItems: Array<{ __typename?: 'RateIndependentSettlementBillLineItemSuccessOutput', customCostTotal: any, success: boolean, total: any, customCosts: Array<{ __typename?: 'RateCustomCostOutput', errorMessage?: number | null, existingCustomCostId?: string | null, fuelSurchargePercentageRate?: number | null, rateDollars?: any | null, totalDollars?: any | null }>, freightCost?: { __typename?: 'RateIndependentFreightCostSuccessOutput', discountRate?: any | null, miles?: number | null, quantity: number, rateDollars: any, tariffUuid?: string | null, totalDollars: any } | null, fuelCost?: { __typename?: 'RateIndependentFuelCostSuccessOutput', surchargeRate?: number | null, surchargeRatePercentage?: any | null, totalDollars: any } | null }> } | null, orderCharges?: { __typename?: 'RateShipmentForOrderSuccessOutput', freightCharge?: { __typename?: 'RateFreightChargeSuccessOutput', rateDollars: any, totalDollars: any, tariffUuid?: string | null, quantity: number, discountRate?: any | null, miles?: number | null, settlementFlatRate?: any | null, settlementPercentageRate?: any | null } | null, fuelCharge?: { __typename?: 'RateFuelChargeSuccessOutput', surchargeRatePercentage?: any | null, totalDollars: any, settlementFlatRate?: any | null, settlementPercentageRate?: any | null } | null, customCharges: Array<{ __typename?: 'RateCustomChargeOutput', rateDollars?: any | null, totalDollars?: any | null, fuelSurchargePercentageRate?: number | null, settlementFlatRate?: any | null, settlementPercentageRate?: any | null }>, independentSettlementBillLineItems: Array<{ __typename?: 'RateIndependentSettlementBillLineItemSuccessOutput', customCostTotal: any, success: boolean, total: any, customCosts: Array<{ __typename?: 'RateCustomCostOutput', errorMessage?: number | null, existingCustomCostId?: string | null, fuelSurchargePercentageRate?: number | null, rateDollars?: any | null, totalDollars?: any | null }>, freightCost?: { __typename?: 'RateIndependentFreightCostSuccessOutput', discountRate?: any | null, miles?: number | null, quantity: number, rateDollars: any, tariffUuid?: string | null, totalDollars: any } | null, fuelCost?: { __typename?: 'RateIndependentFuelCostSuccessOutput', surchargeRate?: number | null, surchargeRatePercentage?: any | null, totalDollars: any } | null }> } | null } };

export type PackageFragment = { __typename?: 'PackageEntity', uuid: string, class?: number | null, description: string, hazmat?: boolean | null, height?: number | null, length?: number | null, nmfc?: string | null, quantity: number, skuNumber?: string | null, type?: PackageType | null, weight?: number | null, width?: number | null, quantityCompletedAtStop?: number | null, reasonUncompletedAtStop?: string | null, packageSpec?: { __typename?: 'PackageSpecEntity', id: string, name: string } | null, warehouseLocation?: { __typename?: 'WarehouseLocationEntity', uuid: string, name: string } | null };

export type ShallowPackageFragment = { __typename?: 'PackageEntity', uuid: string, description: string, weight?: number | null, quantity: number, length?: number | null, width?: number | null, height?: number | null, type?: PackageType | null, packageSpec?: { __typename?: 'PackageSpecEntity', id: string, name: string } | null, warehouseLocation?: { __typename?: 'WarehouseLocationEntity', name: string } | null };

export type UpdatePackageMutationVariables = Exact<{
  updatePackageInput: UpdatePackageInput;
}>;


export type UpdatePackageMutation = { __typename?: 'Mutation', updatePackage: { __typename?: 'PackageEntity', uuid: string } };

export type CreatePermissionMutationVariables = Exact<{
  createPermissionInput: CreatePermissionInput;
}>;


export type CreatePermissionMutation = { __typename?: 'Mutation', createPermission: { __typename?: 'CreatePermissionOutput', success: boolean } };

export type DeletePermissionMutationVariables = Exact<{
  deletePermissionInput: DeletePermissionInput;
}>;


export type DeletePermissionMutation = { __typename?: 'Mutation', deletePermission: { __typename?: 'DeletePermissionOutput', success: boolean } };

export type UpdatePermissionAccessLevelMutationVariables = Exact<{
  updatePermissionAccessLevelInput: UpdatePermissionAccessLevelInput;
}>;


export type UpdatePermissionAccessLevelMutation = { __typename?: 'Mutation', updatePermissionAccessLevel: { __typename?: 'UpdatePermissionAccessLevelOutput', success: boolean } };

export type UpdatePermissionMutationVariables = Exact<{
  updatePermissionInput: UpdatePermissionInput;
}>;


export type UpdatePermissionMutation = { __typename?: 'Mutation', updatePermission: { __typename?: 'UpdatePermissionOutput', success: boolean } };

export type ApproveQuoteMutationVariables = Exact<{
  approveQuoteInput: ApproveQuoteInput;
}>;


export type ApproveQuoteMutation = { __typename?: 'Mutation', approveQuote: { __typename?: 'QuoteEntity', uuid: string } };

export type ClientQuotesQueryVariables = Exact<{
  findClientQuotesInput: FindClientQuotesInput;
}>;


export type ClientQuotesQuery = { __typename?: 'Query', clientQuotes: { __typename?: 'QuoteConnection', totalCount?: number | null, edges: Array<{ __typename?: 'QuoteEdge', node: { __typename?: 'QuoteEntity', uuid: string, createdAt: any, source: QuoteSource, status: QuoteStatus, number: string, totalCharge: any, billingPartyContact: { __typename?: 'CustomerContactEntity', displayName: string, uuid: string } | { __typename?: 'ThirdPartyContactEntity', displayName: string, uuid: string }, order?: { __typename?: 'StandardOrderEntity', uuid: string } | null } }>, pageInfo: { __typename?: 'PageInfo', startCursor?: string | null, endCursor?: string | null, hasNextPage: boolean } } };

export type ClientQuoteFragment = { __typename?: 'QuoteEntity', uuid: string, createdAt: any, source: QuoteSource, status: QuoteStatus, number: string, totalCharge: any, billingPartyContact: { __typename?: 'CustomerContactEntity', displayName: string, uuid: string } | { __typename?: 'ThirdPartyContactEntity', displayName: string, uuid: string }, order?: { __typename?: 'StandardOrderEntity', uuid: string } | null };

export type CreateQuoteMutationVariables = Exact<{
  createQuoteInput: CreateQuoteInput;
}>;


export type CreateQuoteMutation = { __typename?: 'Mutation', createQuote: { __typename?: 'QuoteEntity', uuid: string } };

export type QuoteNameQueryVariables = Exact<{
  billingPartyContactUuid: Scalars['String']['input'];
}>;


export type QuoteNameQuery = { __typename?: 'Query', quoteName: string };

export type QuoteFragment = { __typename?: 'QuoteEntity', uuid: string, number: string, createdAt: any, status: QuoteStatus, dimFactor?: number | null, measurementUnits?: MeasurementUnits | null, weightUnits?: WeightUnits | null, totalSkids?: number | null, source: QuoteSource, enableLineHaul: boolean, service?: { __typename?: 'ServiceEntity', uuid: string } | null, shipments: Array<{ __typename?: 'StandardShipmentEntity', uuid: string, totalChargesAmount: number, totalAmountCents?: number | null, postedAmountCents?: number | null, shouldBillIndividually: boolean, shouldUseDimWeight: boolean, overridePackageWeight: boolean, name: string, hideFromBilling: boolean, hasSignedPOD: boolean, shipmentType: ShipmentType, status: ShipmentStatus, invoice?: { __typename?: 'InvoiceEntity', uuid: string, date: any, postedAt?: any | null, dueDate?: any | null, name: string, journalNumber: number, billToContact: { __typename?: 'CustomerContactEntity', uuid: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string } } | null, documents: Array<{ __typename?: 'DocumentEntity', uuid: string, fileName: string, bucket: string, region: string, key: string, uploadedAt?: any | null, fileType: string, isDeleted: boolean, preSignedGetUrl: string, name?: string | null, type: DocumentType, pageNumber?: number | null, createdAt: any, notes?: string | null, order?: { __typename?: 'StandardOrderEntity', uuid: string, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', shipperBillOfLadingNumber?: string | null } } | null, shipment?: { __typename?: 'StandardOrderEntity', uuid: string } | null, driverFormTemplate?: { __typename?: 'DriverSignableFormTemplateEntity', uuid: string, title: string, formText: string } | null }>, shipmentSubscribers: Array<{ __typename?: 'ShipmentSubscriberEntity', uuid: string, email?: string | null }>, shipperAddress?: { __typename?: 'AddressEntity', uuid: string, name: string, line1: string, line2?: string | null, city: string, state: string, zip: string, country: string, latitude?: number | null, longitude?: number | null, driverInstructions?: string | null, receivingHoursStart?: any | null, receivingHoursEnd?: any | null, specialInstructions?: string | null } | null, airportInfo?: { __typename?: 'AirportInfoEntity', uuid: string, iataCode: string, terminal: string, address: { __typename?: 'AddressEntity', uuid: string, name: string, line1: string, line2?: string | null, city: string, state: string, zip: string, country: string, latitude?: number | null, longitude?: number | null, driverInstructions?: string | null, receivingHoursStart?: any | null, receivingHoursEnd?: any | null, specialInstructions?: string | null } } | null, fields?: { __typename?: 'StandardShipmentFieldsEntity', uuid: string, deadlineDate?: any | null, deadlineType?: DeadlineType | null, deliveryDate?: any | null, dimFactor: number, pickupOrDelivery: PickupOrDelivery, outboundMethod?: OutboundMethod | null, inboundMethod?: InboundMethod | null, type: StandardShipmentType, service?: { __typename?: 'ServiceEntity', uuid: string, name: string, createdAt: any, updatedAt: any, timeInMinutes?: number | null, useApptInRouteOptimization: boolean, markOrdersAsSpecial: boolean, defaultAppointmentStartTime?: any | null, defaultAppointmentEndTime?: any | null, defaultStartNow: boolean, defaultInboundStopType?: StopType | null, defaultOutboundStopType?: StopType | null, defaultPickupPadding?: any | null, defaultDeliveryPadding?: any | null, defaultTotalDuration?: any | null, defaultIsLineHaul: boolean, defaultFulfillmentType?: FulfillmentType | null, isActive: boolean, isExposedToCustomers: boolean, serviceAvailabilityDates: Array<{ __typename?: 'ServiceAvailabilityDateEntity', id: string, dayCategory: SpecialDayOfWeek, enabled: boolean, start: { __typename?: 'PlainTime', hour: number, minute: number }, end: { __typename?: 'PlainTime', hour: number, minute: number } }> } | null } | null, legs: Array<{ __typename?: 'LegEntity', uuid: string, miles?: number | null, endStop: { __typename?: 'StandardStopEntity', uuid: string, createdAt: any, specialInstructions?: string | null, destinationAirport?: string | null, inboundDeadlineDate?: any | null, expectedOutboundDate?: any | null, outboundCarrier?: string | null, appointmentTextStatus?: AppointmentTextStatus | null, incomingCarrier?: string | null, appointmentCallStatus?: AppointmentCallStatus | null, appointmentManuallyConfirmed?: boolean | null, deadlineTime?: any | null, settlementDeductionFlatRate?: number | null, settlementDeductionPercentageRate?: number | null, settlementDeductionName?: string | null, proofOfDeliverySignee?: string | null, appointmentTime?: any | null, arrivedAt?: any | null, completedAt?: any | null, inboundMethod?: InboundMethod | null, expectedInboundArrivalDate?: any | null, outboundMethod?: OutboundMethod | null, driverCompletedAt?: any | null, notes?: string | null, serviceDate?: any | null, status: StopStatus, appointmentRequired: boolean, endAppointmentTime?: any | null, isSpecial?: boolean | null, hideFromDispatch?: boolean | null, standardStopType?: StandardStopType | null, stopType?: StopType | null, paperworkMarkedComplete?: boolean | null, canMarkAttemptComplete?: boolean | null, sentToAgentAt?: any | null, confirmedByAgentAt?: any | null, address: { __typename?: 'AddressEntity', preventCoordRecompute?: boolean | null, internalNotes?: string | null, iataCode?: string | null, uuid: string, name: string, line1: string, line2?: string | null, city: string, state: string, zip: string, country: string, latitude?: number | null, longitude?: number | null, driverInstructions?: string | null, receivingHoursStart?: any | null, receivingHoursEnd?: any | null, specialInstructions?: string | null }, transferAddress?: { __typename?: 'AddressEntity', uuid: string, name: string, line1: string, line2?: string | null, city: string, state: string, zip: string, country: string, latitude?: number | null, longitude?: number | null, driverInstructions?: string | null, receivingHoursStart?: any | null, receivingHoursEnd?: any | null, specialInstructions?: string | null } | null, consigneeAddress?: { __typename?: 'AddressEntity', uuid: string, name: string, line1: string, line2?: string | null, city: string, state: string, zip: string, country: string, latitude?: number | null, longitude?: number | null, driverInstructions?: string | null, receivingHoursStart?: any | null, receivingHoursEnd?: any | null, specialInstructions?: string | null } | null, consigneeContactPerson?: { __typename?: 'ContactPersonEntity', uuid: string, firstName?: string | null, lastName?: string | null, email?: string | null, notes?: string | null, phone?: string | null, createdAt: any } | null, serviceDateV2?: { __typename?: 'PlainDate', iso8601: string } | null, shipperAddress?: { __typename?: 'AddressEntity', uuid: string, name: string, line1: string, line2?: string | null, city: string, state: string, zip: string, country: string, latitude?: number | null, longitude?: number | null, driverInstructions?: string | null, receivingHoursStart?: any | null, receivingHoursEnd?: any | null, specialInstructions?: string | null } | null, shipperContactPerson?: { __typename?: 'ContactPersonEntity', uuid: string, firstName?: string | null, lastName?: string | null, email?: string | null, notes?: string | null, phone?: string | null, createdAt: any } | null, routeSlot?: { __typename?: 'RouteSlotEntity', uuid: string, route?: { __typename?: 'RouteEntity', uuid: string, date: any, name: string, slots: Array<{ __typename?: 'RouteSlotEntity', uuid: string }>, drivers: Array<{ __typename?: 'DriverEntity', uuid: string, firstName: string, lastName: string, driverType?: DriverType | null, agent?: { __typename?: 'AgentFieldsEntity', uuid: string, name: string } | null }>, equipments: Array<{ __typename?: 'EquipmentEntity', uuid: string, name: string }> } | null } | null, contactPerson?: { __typename?: 'ContactPersonEntity', uuid: string, firstName?: string | null, lastName?: string | null, email?: string | null, notes?: string | null, phone?: string | null, createdAt: any } | null, terminal?: { __typename?: 'TerminalEntity', name: string, code: string, uuid: string, isActive: boolean, address: { __typename?: 'AddressEntity', line1: string, line2?: string | null, city: string, state: string, zip: string, uuid: string, name: string, latitude?: number | null, longitude?: number | null }, startForTerminalLanes: Array<{ __typename?: 'TerminalLaneEntity', id: string, endTerminal: { __typename?: 'TerminalEntity', uuid: string, code: string, name: string } }>, agent?: { __typename?: 'AgentFieldsEntity', name: string } | null } | null, stopDriverMaps: Array<{ __typename?: 'StopDriverMapEntity', uuid: string, name?: string | null, enableDriverSettlement?: boolean | null, revenuePercentageRate?: number | null, revenueFlatRate?: number | null, driverPayoutFinalized: boolean, driver: { __typename?: 'DriverEntity', firstName: string, lastName: string, uuid: string, driverType?: DriverType | null, driverReferenceNumber?: string | null, defaultFuelSettlementPercentageRate?: number | null, user: { __typename?: 'UserEntity', name?: string | null }, defaultVehicle?: { __typename?: 'EquipmentEntity', uuid: string } | null, terminal?: { __typename?: 'TerminalEntity', uuid: string, name: string } | null, qualifications: Array<{ __typename?: 'DriverQualificationEntity', id: string }> }, driverSettlementBill?: { __typename?: 'DriverSettlementBillEntity', uuid: string } | null, stop: { __typename?: 'StandardStopEntity', uuid: string, completedAt?: any | null, settlementDeductionName?: string | null, settlementDeductionFlatRate?: number | null, settlementDeductionPercentageRate?: number | null } }> }, previousStopAttempts: Array<{ __typename?: 'StandardStopEntity', stopDriverMaps: Array<{ __typename?: 'StopDriverMapEntity', uuid: string, name?: string | null, enableDriverSettlement?: boolean | null, revenuePercentageRate?: number | null, revenueFlatRate?: number | null, driverPayoutFinalized: boolean, driver: { __typename?: 'DriverEntity', firstName: string, lastName: string, uuid: string, driverType?: DriverType | null, driverReferenceNumber?: string | null, defaultFuelSettlementPercentageRate?: number | null, user: { __typename?: 'UserEntity', name?: string | null }, defaultVehicle?: { __typename?: 'EquipmentEntity', uuid: string } | null, terminal?: { __typename?: 'TerminalEntity', uuid: string, name: string } | null, qualifications: Array<{ __typename?: 'DriverQualificationEntity', id: string }> }, driverSettlementBill?: { __typename?: 'DriverSettlementBillEntity', uuid: string } | null, stop: { __typename?: 'StandardStopEntity', uuid: string, completedAt?: any | null, settlementDeductionName?: string | null, settlementDeductionFlatRate?: number | null, settlementDeductionPercentageRate?: number | null } }> }> }>, packages: Array<{ __typename?: 'PackageEntity', uuid: string, class?: number | null, description: string, hazmat?: boolean | null, height?: number | null, length?: number | null, nmfc?: string | null, quantity: number, skuNumber?: string | null, type?: PackageType | null, weight?: number | null, width?: number | null, quantityCompletedAtStop?: number | null, reasonUncompletedAtStop?: string | null, packageSpec?: { __typename?: 'PackageSpecEntity', id: string, name: string } | null, warehouseLocation?: { __typename?: 'WarehouseLocationEntity', uuid: string, name: string } | null }>, customCharges: Array<{ __typename?: 'CustomChargeEntity', uuid: string, rate: number, description?: string | null, total: number, totalAmountCents?: number | null, postedAmountUsdCents?: number | null, authoCode?: string | null, quantity: number, billingMethod: CustomChargeBillingMethod, isAutoApplied: boolean, name: string, fuelSurchargeRate?: number | null, postedFuelSurchargeRate?: number | null, zoneBasedAccessorialChargeGroupUuid?: string | null, zoneBasedAccessorialZoneUuid?: string | null, specialAccessorialTariffZoneUuid?: string | null, specialAccessorialChargeGroupUuid?: string | null, settlementFlatRate?: number | null, settlementPercentageRate?: number | null, zoneBasedAccessorialMatrixItem?: { __typename?: 'ZoneBasedAccessorialMatrixItemEntity', uuid: string } | null, specialAccessorialMatrixItem?: { __typename?: 'SpecialAccessorialMatrixItemEntity', uuid: string } | null, accessorialRange?: { __typename?: 'AccessorialRangeEntity', uuid: string, lessThanOrEqualToValue: number, rateUsdCents: number } | null, accessorialTemplate?: { __typename?: 'SkidBasedAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename?: 'SpecialAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename?: 'StandardAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | null }>, freightCharge?: { __typename?: 'FreightChargeEntity', uuid: string, quantity: number, billingMethod: FreightBillingMethod, description?: string | null, authoCode?: string | null, rate: number, discountRate?: any | null, settlementFlatRate?: number | null, settlementPercentageRate?: number | null, total: number, totalAmountCents?: number | null, postedAmountUsdCents?: number | null, fuelCharge?: { __typename?: 'FuelChargeEntity', uuid: string, surchargeRate: number, description?: string | null, authoCode?: string | null, flatRate: number, type: FuelBillingMethod, settlementFlatRate?: number | null, settlementPercentageRate?: number | null, totalAmountCents?: number | null, postedAmountUsdCents?: number | null } | null, tariff?: { __typename?: 'TariffEntity', uuid: string, billingPartyContactUuid?: string | null, tariffGroup?: { __typename?: 'TariffGroupEntity', name?: string | null, tariffGroupScope?: TariffGroupScope | null } | null, tariffZone: { __typename?: 'TariffZoneEntity', name: string } } | null } | null, inputForConsolidatedOrder?: { __typename?: 'StandardOrderEntity', uuid: string, name: string } | null, shipmentCharges: { __typename?: 'ShipmentChargeEntity', totalFuelCharge: number, totalCustomCharge: number, totalFreightCharge: number, totalCharge: number }, independentSettlementBillLineItems: Array<{ __typename?: 'SettlementBillLineItemEntity', id: string, settlementMode: SettlementMode, totalAmountUsdDollars: number, revenuePercentageRate?: any | null, revenueFlatRate?: number | null, driver: { __typename?: 'DriverEntity', uuid: string, user: { __typename?: 'UserEntity', name?: string | null } }, driverSettlementBill?: { __typename?: 'DriverSettlementBillEntity', uuid: string, name?: string | null, finalizedDate?: any | null } | null, freightCost?: { __typename?: 'FreightCostEntity', id: string, billingMethod?: FreightBillingMethod | null, dependentSettlementBillingMethod?: DependentSettlementBillingMethod | null, percentageRate?: any | null, flatRateUsdDollars?: number | null, quantity?: number | null, rateUsdDollars?: number | null, discountRate?: any | null, totalAmountUsdDollars?: number | null, totalAmountUsdCents: number, tariff?: { __typename?: 'TariffEntity', uuid: string, tariffZone: { __typename?: 'TariffZoneEntity', name: string } } | null, fuelCost?: { __typename?: 'FuelCostEntity', id: string, billingMethod?: FuelBillingMethod | null, dependentSettlementBillingMethod?: DependentSettlementBillingMethod | null, percentageRate?: any | null, surchargeRate?: number | null, flatRateUsdDollars?: number | null, totalAmountUsdDollars?: number | null, totalAmountUsdCents: number } | null } | null, customCosts: Array<{ __typename?: 'CustomCostEntity', id: string, name: string, billingMethod?: CustomChargeBillingMethod | null, dependentSettlementBillingMethod?: DependentSettlementBillingMethod | null, percentageRate?: any | null, flatRateUsdDollars?: number | null, quantity: number, rateUsdDollars?: number | null, fuelSurchargeRate?: number | null, totalAmountUsdDollars?: number | null, totalAmountUsdCents: number, accessorialTemplate?: { __typename: 'SkidBasedAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename: 'SpecialAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename: 'StandardAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename: 'UnitBasedAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename: 'WaitTimeAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename: 'WeightBasedAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename: 'ZoneBasedAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | null, specialAccessorialMatrixItem?: { __typename?: 'SpecialAccessorialMatrixItemEntity', uuid: string, zoneUuid: string, chargeGroupUuid: string } | null, zoneBasedAccessorialMatrixItem?: { __typename?: 'ZoneBasedAccessorialMatrixItemEntity', uuid: string, zoneUuid: string, chargeGroupUuid: string } | null, accessorialRange?: { __typename?: 'AccessorialRangeEntity', uuid: string } | null }> }> }>, packages: Array<{ __typename?: 'PackageEntity', uuid: string, class?: number | null, description: string, hazmat?: boolean | null, height?: number | null, length?: number | null, nmfc?: string | null, quantity: number, skuNumber?: string | null, type?: PackageType | null, weight?: number | null, width?: number | null, quantityCompletedAtStop?: number | null, reasonUncompletedAtStop?: string | null, packageSpec?: { __typename?: 'PackageSpecEntity', id: string, name: string } | null, warehouseLocation?: { __typename?: 'WarehouseLocationEntity', uuid: string, name: string } | null }>, billingPartyContact: { __typename?: 'CustomerContactEntity', defaultFuelSurcharge?: number | null, defaultUseTariff?: boolean | null, pickupDiscountRate?: any | null, deliveryDiscountRate?: any | null, transferDiscountRate?: any | null, lineHaulDiscountRate?: any | null, defaultDimFactor?: number | null, billingContactEmail?: string | null, defaultInvoiceType: InvoiceType, defaultInvoiceTransmissionMethod: InvoiceTransmissionMethod, defaultInvoiceDownloadDocuments: Array<DocumentType>, defaultInvoiceDocumentsRequired: Array<DocumentType>, defaultInvoiceEmailSubject?: string | null, identifier?: string | null, numberOfOrdersPerInvoice?: number | null, invoiceTimePeriodSplit?: TimePeriod | null, creditHoldLimitInCents?: number | null, enableCreditHold?: boolean | null, maxDaysOutstanding?: number | null, isPrepaidOnly: boolean, enableCustomerPortalOrderEntry: boolean, useCustomPackageSpecs: boolean, showEdiReferenceNumbersOnOrderPage: boolean, useCustomVehicleTypes: boolean, uuid: string, displayName: string, ediApplicationId?: string | null, ediContactCode?: string | null, isActive: boolean, isaId?: string | null, contactReferenceNumber?: string | null, shortCode?: string | null, stediPartnerId?: string | null, isOverCreditLimit: boolean, quickbooksDesktopContactId?: string | null, quickbooksMappingId?: string | null, fuelChargeQuickbooksMappingId?: string | null, freightChargeQuickbooksMappingId?: string | null, miscCustomChargeQuickbooksMappingId?: string | null, type: ContactType, billingCycle?: BillingCycleType | null, billingCycleDuration: BillingCycleDuration, billingPeriod?: number | null, requireDriverToCheckOffPackagesAtStop: boolean, invoiceNotes?: string | null, defaultAddress?: { __typename?: 'AddressEntity', uuid: string, name: string, line1: string, line2?: string | null, city: string, state: string, zip: string, country: string, latitude?: number | null, longitude?: number | null, driverInstructions?: string | null, receivingHoursStart?: any | null, receivingHoursEnd?: any | null, specialInstructions?: string | null } | null, defaultContactPerson?: { __typename?: 'ContactPersonEntity', uuid: string, firstName?: string | null, lastName?: string | null, email?: string | null, notes?: string | null, phone?: string | null, createdAt: any } | null, defaultInvoiceTerms?: { __typename?: 'InvoiceTermEntity', uuid: string, terms: string } | null, packageSpecs: Array<{ __typename?: 'PackageSpecEntity', id: string }>, vehicleTypes: Array<{ __typename?: 'VehicleTypeEntity', uuid: string }>, defaultInboundEdiService?: { __typename?: 'ServiceEntity', uuid: string, name: string } | null, defaultOutboundEdiService?: { __typename?: 'ServiceEntity', uuid: string, name: string } | null, defaultInboundOutboundEdiService?: { __typename?: 'ServiceEntity', uuid: string, name: string } | null, defaultOrdinaryTariffChain?: { __typename?: 'TariffChainEntity', id: string, name: string } | null, defaultLineHaulTariffChain?: { __typename?: 'TariffChainEntity', id: string, name: string } | null, defaultTransferTariffChain?: { __typename?: 'TariffChainEntity', id: string, name: string } | null, defaultPointToPointTariffChain?: { __typename?: 'TariffChainEntity', id: string, name: string } | null, masterAccount?: { __typename?: 'MasterAccountEntity', uuid: string, name: string } | null, contactComments: Array<{ __typename?: 'ContactCommentEntity', uuid: string, updatedAt: any, createdAt: any, comment: string, authorName: string }>, services: Array<{ __typename?: 'ServiceEntity', uuid: string, name: string, createdAt: any, updatedAt: any, timeInMinutes?: number | null, useApptInRouteOptimization: boolean, markOrdersAsSpecial: boolean, defaultAppointmentStartTime?: any | null, defaultAppointmentEndTime?: any | null, defaultStartNow: boolean, defaultInboundStopType?: StopType | null, defaultOutboundStopType?: StopType | null, defaultPickupPadding?: any | null, defaultDeliveryPadding?: any | null, defaultTotalDuration?: any | null, defaultIsLineHaul: boolean, defaultFulfillmentType?: FulfillmentType | null, isActive: boolean, isExposedToCustomers: boolean, serviceAvailabilityDates: Array<{ __typename?: 'ServiceAvailabilityDateEntity', id: string, dayCategory: SpecialDayOfWeek, enabled: boolean, start: { __typename?: 'PlainTime', hour: number, minute: number }, end: { __typename?: 'PlainTime', hour: number, minute: number } }> }>, invoicePdfColumns: Array<{ __typename?: 'PdfColumnEntity', uuid: string, orderColumnMapping?: OrderPdfColumnMapping | null, shipmentPDFColumnMapping?: ShipmentPdfColumnMapping | null, legPDFColumnMapping?: LegPdfColumnMapping | null, stopPDFColumnMapping?: StopPdfColumnMapping | null }>, addresses: Array<{ __typename?: 'AddressEntity', uuid: string, name: string, line1: string, line2?: string | null, city: string, state: string, zip: string, country: string, latitude?: number | null, longitude?: number | null, driverInstructions?: string | null, receivingHoursStart?: any | null, receivingHoursEnd?: any | null, specialInstructions?: string | null }>, contactPersons: Array<{ __typename?: 'ContactPersonEntity', uuid: string, firstName?: string | null, lastName?: string | null, email?: string | null, notes?: string | null, phone?: string | null, createdAt: any }>, defaultService?: { __typename?: 'ServiceEntity', uuid: string, name: string, createdAt: any, updatedAt: any, timeInMinutes?: number | null, useApptInRouteOptimization: boolean, markOrdersAsSpecial: boolean, defaultAppointmentStartTime?: any | null, defaultAppointmentEndTime?: any | null, defaultStartNow: boolean, defaultInboundStopType?: StopType | null, defaultOutboundStopType?: StopType | null, defaultPickupPadding?: any | null, defaultDeliveryPadding?: any | null, defaultTotalDuration?: any | null, defaultIsLineHaul: boolean, defaultFulfillmentType?: FulfillmentType | null, isActive: boolean, isExposedToCustomers: boolean, serviceAvailabilityDates: Array<{ __typename?: 'ServiceAvailabilityDateEntity', id: string, dayCategory: SpecialDayOfWeek, enabled: boolean, start: { __typename?: 'PlainTime', hour: number, minute: number }, end: { __typename?: 'PlainTime', hour: number, minute: number } }> } | null, businessDivision?: { __typename?: 'BusinessDivisionEntity', uuid: string, name: string } | null, referenceNumberLabels: Array<{ __typename?: 'ReferenceNumberLabelEntity', name: string }> } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string, ediApplicationId?: string | null, ediContactCode?: string | null, isActive: boolean, isaId?: string | null, identifier?: string | null, contactReferenceNumber?: string | null, shortCode?: string | null, stediPartnerId?: string | null, isOverCreditLimit: boolean, quickbooksDesktopContactId?: string | null, quickbooksMappingId?: string | null, fuelChargeQuickbooksMappingId?: string | null, freightChargeQuickbooksMappingId?: string | null, miscCustomChargeQuickbooksMappingId?: string | null, type: ContactType, billingCycle?: BillingCycleType | null, billingCycleDuration: BillingCycleDuration, billingPeriod?: number | null, requireDriverToCheckOffPackagesAtStop: boolean, invoiceNotes?: string | null, masterAccount?: { __typename?: 'MasterAccountEntity', uuid: string, name: string } | null, contactComments: Array<{ __typename?: 'ContactCommentEntity', uuid: string, updatedAt: any, createdAt: any, comment: string, authorName: string }>, services: Array<{ __typename?: 'ServiceEntity', uuid: string, name: string, createdAt: any, updatedAt: any, timeInMinutes?: number | null, useApptInRouteOptimization: boolean, markOrdersAsSpecial: boolean, defaultAppointmentStartTime?: any | null, defaultAppointmentEndTime?: any | null, defaultStartNow: boolean, defaultInboundStopType?: StopType | null, defaultOutboundStopType?: StopType | null, defaultPickupPadding?: any | null, defaultDeliveryPadding?: any | null, defaultTotalDuration?: any | null, defaultIsLineHaul: boolean, defaultFulfillmentType?: FulfillmentType | null, isActive: boolean, isExposedToCustomers: boolean, serviceAvailabilityDates: Array<{ __typename?: 'ServiceAvailabilityDateEntity', id: string, dayCategory: SpecialDayOfWeek, enabled: boolean, start: { __typename?: 'PlainTime', hour: number, minute: number }, end: { __typename?: 'PlainTime', hour: number, minute: number } }> }>, invoicePdfColumns: Array<{ __typename?: 'PdfColumnEntity', uuid: string, orderColumnMapping?: OrderPdfColumnMapping | null, shipmentPDFColumnMapping?: ShipmentPdfColumnMapping | null, legPDFColumnMapping?: LegPdfColumnMapping | null, stopPDFColumnMapping?: StopPdfColumnMapping | null }>, addresses: Array<{ __typename?: 'AddressEntity', uuid: string, name: string, line1: string, line2?: string | null, city: string, state: string, zip: string, country: string, latitude?: number | null, longitude?: number | null, driverInstructions?: string | null, receivingHoursStart?: any | null, receivingHoursEnd?: any | null, specialInstructions?: string | null }>, contactPersons: Array<{ __typename?: 'ContactPersonEntity', uuid: string, firstName?: string | null, lastName?: string | null, email?: string | null, notes?: string | null, phone?: string | null, createdAt: any }>, defaultAddress?: { __typename?: 'AddressEntity', uuid: string, name: string, line1: string, line2?: string | null, city: string, state: string, zip: string, country: string, latitude?: number | null, longitude?: number | null, driverInstructions?: string | null, receivingHoursStart?: any | null, receivingHoursEnd?: any | null, specialInstructions?: string | null } | null, defaultContactPerson?: { __typename?: 'ContactPersonEntity', uuid: string, firstName?: string | null, lastName?: string | null, email?: string | null, notes?: string | null, phone?: string | null, createdAt: any } | null, defaultService?: { __typename?: 'ServiceEntity', uuid: string, name: string, createdAt: any, updatedAt: any, timeInMinutes?: number | null, useApptInRouteOptimization: boolean, markOrdersAsSpecial: boolean, defaultAppointmentStartTime?: any | null, defaultAppointmentEndTime?: any | null, defaultStartNow: boolean, defaultInboundStopType?: StopType | null, defaultOutboundStopType?: StopType | null, defaultPickupPadding?: any | null, defaultDeliveryPadding?: any | null, defaultTotalDuration?: any | null, defaultIsLineHaul: boolean, defaultFulfillmentType?: FulfillmentType | null, isActive: boolean, isExposedToCustomers: boolean, serviceAvailabilityDates: Array<{ __typename?: 'ServiceAvailabilityDateEntity', id: string, dayCategory: SpecialDayOfWeek, enabled: boolean, start: { __typename?: 'PlainTime', hour: number, minute: number }, end: { __typename?: 'PlainTime', hour: number, minute: number } }> } | null, businessDivision?: { __typename?: 'BusinessDivisionEntity', uuid: string, name: string } | null, referenceNumberLabels: Array<{ __typename?: 'ReferenceNumberLabelEntity', name: string }> }, company: { __typename?: 'CompanyEntity', invoiceEmail?: string | null, isCourier?: boolean | null, uuid: string, phone?: string | null, quickbooksFileMappingAccessorialChargeName?: string | null, quickbooksFileMappingFuelChargeName?: string | null, quickbooksFileMappingFreightChargeName?: string | null, quickbooksDesktopAccountsReceivableId?: string | null, quickbooksFileMappingPickupChargeName?: string | null, quickbooksCompanyId?: string | null, freightChargeQuickbooksMappingId?: string | null, fuelChargeQuickbooksMappingId?: string | null, quickbooksDesktopCompanyId?: string | null, quickbooksDesktopDeliveryId?: string | null, quickbooksDesktopPickupId?: string | null, quickbooksDesktopTransferId?: string | null, quickbooksDesktopLineHaulId?: string | null, quickbooksDesktopOrderChargeId?: string | null, quickbooksDesktopAccessorialId?: string | null, quickbooksDesktopFuelChargeId?: string | null, segment: Segment, timeZone: string, defaultWeightUnits: WeightUnits, defaultMeasurementUnits: MeasurementUnits, qbInvoiceNumberStart?: number | null, productionCompany?: ProductionCompany | null, name: string, orderNameOrdinal?: number | null, customDunningReportHeader?: string | null, customDunningReportFooter?: string | null, useSageBusinessWorks: boolean, blockSendingZeroDollarInvoices: boolean, purchasedProductOfferings: Array<PalletProductOffering>, defaultInvoiceEmailSubject?: string | null, defaultNonCompanyDriverSettlementMode: SettlementMode, configuration?: { __typename?: 'CompanyConfigurationEntity', uuid: string, showDriverSettlementInBilling: boolean, sameDayDispatchCellHeader: SameDayDispatchCellHeader, defaultStandardStopType: StandardStopType, defaultFuelSurchargeBillingMethod: FuelBillingMethod, defaultFuelSurcharge?: number | null, defaultFuelSettlementPercentageRate?: number | null, defaultDimFactor?: number | null, defaultRouteStartTime?: any | null, defaultRouteLoadTimeInMinutes?: number | null, defaultRouteUnloadTimeInMinutes?: number | null, defaultGenerateAppointmentDurationInMinutes: number, enableConsolidatedOrders: boolean, requirePODPhotoAndName: boolean, requirePODPhotoAndNameForPickups: boolean, requirePODPhotoForPickups: boolean, requireSigneeNameForPickups: boolean, requirePODPhotoForDeliveries: boolean, autoGroupStops: boolean, requireDriverToConfirmStopCompletedAtTime: boolean, requireSigneeNameForDeliveries: boolean, autoMatchEodDocumentsToOrders: boolean, showChargesOnCustomerPortal: boolean, invoicePdfLogoUrl?: string | null, showManuallyConfirmedByDefault?: boolean | null, showHelpersColumnInDispatch?: boolean | null, showVehicleInDailyDispatch?: boolean | null, autoApplyWaitTimeMinutes: boolean, requireReviewForEdiOrderCreation: boolean, startingInvoiceOrdinalNumber?: number | null, useDriverNumberForDispatch: boolean, useJournalNumberForInvoice: boolean, packageWarehouseLocationsEnabled: boolean, wmsEnabled: boolean, wmsStorageOrdersEnabled: boolean, wmsShortTermStorageEnabled: boolean, wmsAutoMarkOnHand: boolean, requireDriverToAcknowledgeRouteChange: boolean, defaultToAccessorial: boolean, enablePaymentMethod: boolean, driversShouldMarkFreightAsLoaded: boolean, allCapsInOrderPage: boolean, terminalsEnabled: boolean, lineHaulEnabled: boolean, logisticsSectionEnabled: boolean, fulfillmentTypeEnabled: boolean, pointToPointTariffsEnabled: boolean, orderNamingScheme: OrderNamingScheme, companyOrdinalStart?: number | null, minDigitsInCompanyOrdinalOrderName?: number | null, serviceLevelOptional: boolean, showKilogramsAndCentimeters: boolean, addOrdersToOpenInvoices: boolean, restrictEditingOrderName: boolean, notificationsEnabled: boolean, defaultInvoiceDocumentsRequired: Array<DocumentType>, invoiceNotes?: string | null, requireDimsToFinalizeCharges: boolean, orderIdentifierForCoverSheet: OrderIdentifier, getDriverLocationDataFromMobile: boolean, enableDigitalSignatureFlow: boolean, includeHyphensInInvoiceName: boolean, includeINVInInvoiceName: boolean } | null, quickbooksAccessToken?: { __typename?: 'QuickbooksOauthTokenEntity', uuid: string, expiresAt: any, accessToken: string, refreshToken: string } | null, defaultAddress?: { __typename?: 'AddressEntity', uuid: string, name: string, line1: string, line2?: string | null, city: string, latitude?: number | null, longitude?: number | null, zip: string, state: string, country: string } | null, tags: Array<{ __typename?: 'TagEntity', createdAt: any, updatedAt: any, color?: string | null, uuid: string, value: string }>, referenceNumberLabels: Array<{ __typename?: 'ReferenceNumberLabelEntity', name: string }>, orderFormFields: { __typename?: 'OrderFormFieldsEntity', onePackageRequired: boolean, onePackageWeightRequired: boolean } }, order?: { __typename?: 'StandardOrderEntity', uuid: string } | null };

export type QuoteQueryVariables = Exact<{
  uuid: Scalars['String']['input'];
}>;


export type QuoteQuery = { __typename?: 'Query', quote: { __typename?: 'QuoteEntity', uuid: string, number: string, createdAt: any, status: QuoteStatus, dimFactor?: number | null, measurementUnits?: MeasurementUnits | null, weightUnits?: WeightUnits | null, totalSkids?: number | null, source: QuoteSource, enableLineHaul: boolean, billingPartyContact: { __typename?: 'CustomerContactEntity', defaultDimFactor?: number | null, defaultFuelSurcharge?: number | null, defaultUseTariff?: boolean | null, pickupDiscountRate?: any | null, deliveryDiscountRate?: any | null, transferDiscountRate?: any | null, lineHaulDiscountRate?: any | null, billingContactEmail?: string | null, defaultInvoiceType: InvoiceType, defaultInvoiceTransmissionMethod: InvoiceTransmissionMethod, defaultInvoiceDownloadDocuments: Array<DocumentType>, defaultInvoiceDocumentsRequired: Array<DocumentType>, defaultInvoiceEmailSubject?: string | null, identifier?: string | null, numberOfOrdersPerInvoice?: number | null, invoiceTimePeriodSplit?: TimePeriod | null, creditHoldLimitInCents?: number | null, enableCreditHold?: boolean | null, maxDaysOutstanding?: number | null, isPrepaidOnly: boolean, enableCustomerPortalOrderEntry: boolean, useCustomPackageSpecs: boolean, showEdiReferenceNumbersOnOrderPage: boolean, useCustomVehicleTypes: boolean, uuid: string, displayName: string, ediApplicationId?: string | null, ediContactCode?: string | null, isActive: boolean, isaId?: string | null, contactReferenceNumber?: string | null, shortCode?: string | null, stediPartnerId?: string | null, isOverCreditLimit: boolean, quickbooksDesktopContactId?: string | null, quickbooksMappingId?: string | null, fuelChargeQuickbooksMappingId?: string | null, freightChargeQuickbooksMappingId?: string | null, miscCustomChargeQuickbooksMappingId?: string | null, type: ContactType, billingCycle?: BillingCycleType | null, billingCycleDuration: BillingCycleDuration, billingPeriod?: number | null, requireDriverToCheckOffPackagesAtStop: boolean, invoiceNotes?: string | null, defaultAddress?: { __typename?: 'AddressEntity', uuid: string, name: string, line1: string, line2?: string | null, city: string, state: string, zip: string, country: string, latitude?: number | null, longitude?: number | null, driverInstructions?: string | null, receivingHoursStart?: any | null, receivingHoursEnd?: any | null, specialInstructions?: string | null } | null, defaultContactPerson?: { __typename?: 'ContactPersonEntity', uuid: string, firstName?: string | null, lastName?: string | null, email?: string | null, notes?: string | null, phone?: string | null, createdAt: any } | null, defaultInvoiceTerms?: { __typename?: 'InvoiceTermEntity', uuid: string, terms: string } | null, packageSpecs: Array<{ __typename?: 'PackageSpecEntity', id: string }>, vehicleTypes: Array<{ __typename?: 'VehicleTypeEntity', uuid: string }>, defaultInboundEdiService?: { __typename?: 'ServiceEntity', uuid: string, name: string } | null, defaultOutboundEdiService?: { __typename?: 'ServiceEntity', uuid: string, name: string } | null, defaultInboundOutboundEdiService?: { __typename?: 'ServiceEntity', uuid: string, name: string } | null, defaultOrdinaryTariffChain?: { __typename?: 'TariffChainEntity', id: string, name: string } | null, defaultLineHaulTariffChain?: { __typename?: 'TariffChainEntity', id: string, name: string } | null, defaultTransferTariffChain?: { __typename?: 'TariffChainEntity', id: string, name: string } | null, defaultPointToPointTariffChain?: { __typename?: 'TariffChainEntity', id: string, name: string } | null, masterAccount?: { __typename?: 'MasterAccountEntity', uuid: string, name: string } | null, contactComments: Array<{ __typename?: 'ContactCommentEntity', uuid: string, updatedAt: any, createdAt: any, comment: string, authorName: string }>, services: Array<{ __typename?: 'ServiceEntity', uuid: string, name: string, createdAt: any, updatedAt: any, timeInMinutes?: number | null, useApptInRouteOptimization: boolean, markOrdersAsSpecial: boolean, defaultAppointmentStartTime?: any | null, defaultAppointmentEndTime?: any | null, defaultStartNow: boolean, defaultInboundStopType?: StopType | null, defaultOutboundStopType?: StopType | null, defaultPickupPadding?: any | null, defaultDeliveryPadding?: any | null, defaultTotalDuration?: any | null, defaultIsLineHaul: boolean, defaultFulfillmentType?: FulfillmentType | null, isActive: boolean, isExposedToCustomers: boolean, serviceAvailabilityDates: Array<{ __typename?: 'ServiceAvailabilityDateEntity', id: string, dayCategory: SpecialDayOfWeek, enabled: boolean, start: { __typename?: 'PlainTime', hour: number, minute: number }, end: { __typename?: 'PlainTime', hour: number, minute: number } }> }>, invoicePdfColumns: Array<{ __typename?: 'PdfColumnEntity', uuid: string, orderColumnMapping?: OrderPdfColumnMapping | null, shipmentPDFColumnMapping?: ShipmentPdfColumnMapping | null, legPDFColumnMapping?: LegPdfColumnMapping | null, stopPDFColumnMapping?: StopPdfColumnMapping | null }>, addresses: Array<{ __typename?: 'AddressEntity', uuid: string, name: string, line1: string, line2?: string | null, city: string, state: string, zip: string, country: string, latitude?: number | null, longitude?: number | null, driverInstructions?: string | null, receivingHoursStart?: any | null, receivingHoursEnd?: any | null, specialInstructions?: string | null }>, contactPersons: Array<{ __typename?: 'ContactPersonEntity', uuid: string, firstName?: string | null, lastName?: string | null, email?: string | null, notes?: string | null, phone?: string | null, createdAt: any }>, defaultService?: { __typename?: 'ServiceEntity', uuid: string, name: string, createdAt: any, updatedAt: any, timeInMinutes?: number | null, useApptInRouteOptimization: boolean, markOrdersAsSpecial: boolean, defaultAppointmentStartTime?: any | null, defaultAppointmentEndTime?: any | null, defaultStartNow: boolean, defaultInboundStopType?: StopType | null, defaultOutboundStopType?: StopType | null, defaultPickupPadding?: any | null, defaultDeliveryPadding?: any | null, defaultTotalDuration?: any | null, defaultIsLineHaul: boolean, defaultFulfillmentType?: FulfillmentType | null, isActive: boolean, isExposedToCustomers: boolean, serviceAvailabilityDates: Array<{ __typename?: 'ServiceAvailabilityDateEntity', id: string, dayCategory: SpecialDayOfWeek, enabled: boolean, start: { __typename?: 'PlainTime', hour: number, minute: number }, end: { __typename?: 'PlainTime', hour: number, minute: number } }> } | null, businessDivision?: { __typename?: 'BusinessDivisionEntity', uuid: string, name: string } | null, referenceNumberLabels: Array<{ __typename?: 'ReferenceNumberLabelEntity', name: string }> } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string, ediApplicationId?: string | null, ediContactCode?: string | null, isActive: boolean, isaId?: string | null, identifier?: string | null, contactReferenceNumber?: string | null, shortCode?: string | null, stediPartnerId?: string | null, isOverCreditLimit: boolean, quickbooksDesktopContactId?: string | null, quickbooksMappingId?: string | null, fuelChargeQuickbooksMappingId?: string | null, freightChargeQuickbooksMappingId?: string | null, miscCustomChargeQuickbooksMappingId?: string | null, type: ContactType, billingCycle?: BillingCycleType | null, billingCycleDuration: BillingCycleDuration, billingPeriod?: number | null, requireDriverToCheckOffPackagesAtStop: boolean, invoiceNotes?: string | null, masterAccount?: { __typename?: 'MasterAccountEntity', uuid: string, name: string } | null, contactComments: Array<{ __typename?: 'ContactCommentEntity', uuid: string, updatedAt: any, createdAt: any, comment: string, authorName: string }>, services: Array<{ __typename?: 'ServiceEntity', uuid: string, name: string, createdAt: any, updatedAt: any, timeInMinutes?: number | null, useApptInRouteOptimization: boolean, markOrdersAsSpecial: boolean, defaultAppointmentStartTime?: any | null, defaultAppointmentEndTime?: any | null, defaultStartNow: boolean, defaultInboundStopType?: StopType | null, defaultOutboundStopType?: StopType | null, defaultPickupPadding?: any | null, defaultDeliveryPadding?: any | null, defaultTotalDuration?: any | null, defaultIsLineHaul: boolean, defaultFulfillmentType?: FulfillmentType | null, isActive: boolean, isExposedToCustomers: boolean, serviceAvailabilityDates: Array<{ __typename?: 'ServiceAvailabilityDateEntity', id: string, dayCategory: SpecialDayOfWeek, enabled: boolean, start: { __typename?: 'PlainTime', hour: number, minute: number }, end: { __typename?: 'PlainTime', hour: number, minute: number } }> }>, invoicePdfColumns: Array<{ __typename?: 'PdfColumnEntity', uuid: string, orderColumnMapping?: OrderPdfColumnMapping | null, shipmentPDFColumnMapping?: ShipmentPdfColumnMapping | null, legPDFColumnMapping?: LegPdfColumnMapping | null, stopPDFColumnMapping?: StopPdfColumnMapping | null }>, addresses: Array<{ __typename?: 'AddressEntity', uuid: string, name: string, line1: string, line2?: string | null, city: string, state: string, zip: string, country: string, latitude?: number | null, longitude?: number | null, driverInstructions?: string | null, receivingHoursStart?: any | null, receivingHoursEnd?: any | null, specialInstructions?: string | null }>, contactPersons: Array<{ __typename?: 'ContactPersonEntity', uuid: string, firstName?: string | null, lastName?: string | null, email?: string | null, notes?: string | null, phone?: string | null, createdAt: any }>, defaultAddress?: { __typename?: 'AddressEntity', uuid: string, name: string, line1: string, line2?: string | null, city: string, state: string, zip: string, country: string, latitude?: number | null, longitude?: number | null, driverInstructions?: string | null, receivingHoursStart?: any | null, receivingHoursEnd?: any | null, specialInstructions?: string | null } | null, defaultContactPerson?: { __typename?: 'ContactPersonEntity', uuid: string, firstName?: string | null, lastName?: string | null, email?: string | null, notes?: string | null, phone?: string | null, createdAt: any } | null, defaultService?: { __typename?: 'ServiceEntity', uuid: string, name: string, createdAt: any, updatedAt: any, timeInMinutes?: number | null, useApptInRouteOptimization: boolean, markOrdersAsSpecial: boolean, defaultAppointmentStartTime?: any | null, defaultAppointmentEndTime?: any | null, defaultStartNow: boolean, defaultInboundStopType?: StopType | null, defaultOutboundStopType?: StopType | null, defaultPickupPadding?: any | null, defaultDeliveryPadding?: any | null, defaultTotalDuration?: any | null, defaultIsLineHaul: boolean, defaultFulfillmentType?: FulfillmentType | null, isActive: boolean, isExposedToCustomers: boolean, serviceAvailabilityDates: Array<{ __typename?: 'ServiceAvailabilityDateEntity', id: string, dayCategory: SpecialDayOfWeek, enabled: boolean, start: { __typename?: 'PlainTime', hour: number, minute: number }, end: { __typename?: 'PlainTime', hour: number, minute: number } }> } | null, businessDivision?: { __typename?: 'BusinessDivisionEntity', uuid: string, name: string } | null, referenceNumberLabels: Array<{ __typename?: 'ReferenceNumberLabelEntity', name: string }> }, lineHaulLane?: { __typename?: 'LineHaulLaneEntity', uuid: string, originTerminal: { __typename?: 'TerminalEntity', uuid: string, code: string }, destinationTerminal: { __typename?: 'TerminalEntity', uuid: string, code: string } } | null, service?: { __typename?: 'ServiceEntity', uuid: string } | null, shipments: Array<{ __typename?: 'StandardShipmentEntity', uuid: string, totalChargesAmount: number, totalAmountCents?: number | null, postedAmountCents?: number | null, shouldBillIndividually: boolean, shouldUseDimWeight: boolean, overridePackageWeight: boolean, name: string, hideFromBilling: boolean, hasSignedPOD: boolean, shipmentType: ShipmentType, status: ShipmentStatus, invoice?: { __typename?: 'InvoiceEntity', uuid: string, date: any, postedAt?: any | null, dueDate?: any | null, name: string, journalNumber: number, billToContact: { __typename?: 'CustomerContactEntity', uuid: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string } } | null, documents: Array<{ __typename?: 'DocumentEntity', uuid: string, fileName: string, bucket: string, region: string, key: string, uploadedAt?: any | null, fileType: string, isDeleted: boolean, preSignedGetUrl: string, name?: string | null, type: DocumentType, pageNumber?: number | null, createdAt: any, notes?: string | null, order?: { __typename?: 'StandardOrderEntity', uuid: string, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', shipperBillOfLadingNumber?: string | null } } | null, shipment?: { __typename?: 'StandardOrderEntity', uuid: string } | null, driverFormTemplate?: { __typename?: 'DriverSignableFormTemplateEntity', uuid: string, title: string, formText: string } | null }>, shipmentSubscribers: Array<{ __typename?: 'ShipmentSubscriberEntity', uuid: string, email?: string | null }>, shipperAddress?: { __typename?: 'AddressEntity', uuid: string, name: string, line1: string, line2?: string | null, city: string, state: string, zip: string, country: string, latitude?: number | null, longitude?: number | null, driverInstructions?: string | null, receivingHoursStart?: any | null, receivingHoursEnd?: any | null, specialInstructions?: string | null } | null, airportInfo?: { __typename?: 'AirportInfoEntity', uuid: string, iataCode: string, terminal: string, address: { __typename?: 'AddressEntity', uuid: string, name: string, line1: string, line2?: string | null, city: string, state: string, zip: string, country: string, latitude?: number | null, longitude?: number | null, driverInstructions?: string | null, receivingHoursStart?: any | null, receivingHoursEnd?: any | null, specialInstructions?: string | null } } | null, fields?: { __typename?: 'StandardShipmentFieldsEntity', uuid: string, deadlineDate?: any | null, deadlineType?: DeadlineType | null, deliveryDate?: any | null, dimFactor: number, pickupOrDelivery: PickupOrDelivery, outboundMethod?: OutboundMethod | null, inboundMethod?: InboundMethod | null, type: StandardShipmentType, service?: { __typename?: 'ServiceEntity', uuid: string, name: string, createdAt: any, updatedAt: any, timeInMinutes?: number | null, useApptInRouteOptimization: boolean, markOrdersAsSpecial: boolean, defaultAppointmentStartTime?: any | null, defaultAppointmentEndTime?: any | null, defaultStartNow: boolean, defaultInboundStopType?: StopType | null, defaultOutboundStopType?: StopType | null, defaultPickupPadding?: any | null, defaultDeliveryPadding?: any | null, defaultTotalDuration?: any | null, defaultIsLineHaul: boolean, defaultFulfillmentType?: FulfillmentType | null, isActive: boolean, isExposedToCustomers: boolean, serviceAvailabilityDates: Array<{ __typename?: 'ServiceAvailabilityDateEntity', id: string, dayCategory: SpecialDayOfWeek, enabled: boolean, start: { __typename?: 'PlainTime', hour: number, minute: number }, end: { __typename?: 'PlainTime', hour: number, minute: number } }> } | null } | null, legs: Array<{ __typename?: 'LegEntity', uuid: string, miles?: number | null, endStop: { __typename?: 'StandardStopEntity', uuid: string, createdAt: any, specialInstructions?: string | null, destinationAirport?: string | null, inboundDeadlineDate?: any | null, expectedOutboundDate?: any | null, outboundCarrier?: string | null, appointmentTextStatus?: AppointmentTextStatus | null, incomingCarrier?: string | null, appointmentCallStatus?: AppointmentCallStatus | null, appointmentManuallyConfirmed?: boolean | null, deadlineTime?: any | null, settlementDeductionFlatRate?: number | null, settlementDeductionPercentageRate?: number | null, settlementDeductionName?: string | null, proofOfDeliverySignee?: string | null, appointmentTime?: any | null, arrivedAt?: any | null, completedAt?: any | null, inboundMethod?: InboundMethod | null, expectedInboundArrivalDate?: any | null, outboundMethod?: OutboundMethod | null, driverCompletedAt?: any | null, notes?: string | null, serviceDate?: any | null, status: StopStatus, appointmentRequired: boolean, endAppointmentTime?: any | null, isSpecial?: boolean | null, hideFromDispatch?: boolean | null, standardStopType?: StandardStopType | null, stopType?: StopType | null, paperworkMarkedComplete?: boolean | null, canMarkAttemptComplete?: boolean | null, sentToAgentAt?: any | null, confirmedByAgentAt?: any | null, address: { __typename?: 'AddressEntity', preventCoordRecompute?: boolean | null, internalNotes?: string | null, iataCode?: string | null, uuid: string, name: string, line1: string, line2?: string | null, city: string, state: string, zip: string, country: string, latitude?: number | null, longitude?: number | null, driverInstructions?: string | null, receivingHoursStart?: any | null, receivingHoursEnd?: any | null, specialInstructions?: string | null }, transferAddress?: { __typename?: 'AddressEntity', uuid: string, name: string, line1: string, line2?: string | null, city: string, state: string, zip: string, country: string, latitude?: number | null, longitude?: number | null, driverInstructions?: string | null, receivingHoursStart?: any | null, receivingHoursEnd?: any | null, specialInstructions?: string | null } | null, consigneeAddress?: { __typename?: 'AddressEntity', uuid: string, name: string, line1: string, line2?: string | null, city: string, state: string, zip: string, country: string, latitude?: number | null, longitude?: number | null, driverInstructions?: string | null, receivingHoursStart?: any | null, receivingHoursEnd?: any | null, specialInstructions?: string | null } | null, consigneeContactPerson?: { __typename?: 'ContactPersonEntity', uuid: string, firstName?: string | null, lastName?: string | null, email?: string | null, notes?: string | null, phone?: string | null, createdAt: any } | null, serviceDateV2?: { __typename?: 'PlainDate', iso8601: string } | null, shipperAddress?: { __typename?: 'AddressEntity', uuid: string, name: string, line1: string, line2?: string | null, city: string, state: string, zip: string, country: string, latitude?: number | null, longitude?: number | null, driverInstructions?: string | null, receivingHoursStart?: any | null, receivingHoursEnd?: any | null, specialInstructions?: string | null } | null, shipperContactPerson?: { __typename?: 'ContactPersonEntity', uuid: string, firstName?: string | null, lastName?: string | null, email?: string | null, notes?: string | null, phone?: string | null, createdAt: any } | null, routeSlot?: { __typename?: 'RouteSlotEntity', uuid: string, route?: { __typename?: 'RouteEntity', uuid: string, date: any, name: string, slots: Array<{ __typename?: 'RouteSlotEntity', uuid: string }>, drivers: Array<{ __typename?: 'DriverEntity', uuid: string, firstName: string, lastName: string, driverType?: DriverType | null, agent?: { __typename?: 'AgentFieldsEntity', uuid: string, name: string } | null }>, equipments: Array<{ __typename?: 'EquipmentEntity', uuid: string, name: string }> } | null } | null, contactPerson?: { __typename?: 'ContactPersonEntity', uuid: string, firstName?: string | null, lastName?: string | null, email?: string | null, notes?: string | null, phone?: string | null, createdAt: any } | null, terminal?: { __typename?: 'TerminalEntity', name: string, code: string, uuid: string, isActive: boolean, address: { __typename?: 'AddressEntity', line1: string, line2?: string | null, city: string, state: string, zip: string, uuid: string, name: string, latitude?: number | null, longitude?: number | null }, startForTerminalLanes: Array<{ __typename?: 'TerminalLaneEntity', id: string, endTerminal: { __typename?: 'TerminalEntity', uuid: string, code: string, name: string } }>, agent?: { __typename?: 'AgentFieldsEntity', name: string } | null } | null, stopDriverMaps: Array<{ __typename?: 'StopDriverMapEntity', uuid: string, name?: string | null, enableDriverSettlement?: boolean | null, revenuePercentageRate?: number | null, revenueFlatRate?: number | null, driverPayoutFinalized: boolean, driver: { __typename?: 'DriverEntity', firstName: string, lastName: string, uuid: string, driverType?: DriverType | null, driverReferenceNumber?: string | null, defaultFuelSettlementPercentageRate?: number | null, user: { __typename?: 'UserEntity', name?: string | null }, defaultVehicle?: { __typename?: 'EquipmentEntity', uuid: string } | null, terminal?: { __typename?: 'TerminalEntity', uuid: string, name: string } | null, qualifications: Array<{ __typename?: 'DriverQualificationEntity', id: string }> }, driverSettlementBill?: { __typename?: 'DriverSettlementBillEntity', uuid: string } | null, stop: { __typename?: 'StandardStopEntity', uuid: string, completedAt?: any | null, settlementDeductionName?: string | null, settlementDeductionFlatRate?: number | null, settlementDeductionPercentageRate?: number | null } }> }, previousStopAttempts: Array<{ __typename?: 'StandardStopEntity', stopDriverMaps: Array<{ __typename?: 'StopDriverMapEntity', uuid: string, name?: string | null, enableDriverSettlement?: boolean | null, revenuePercentageRate?: number | null, revenueFlatRate?: number | null, driverPayoutFinalized: boolean, driver: { __typename?: 'DriverEntity', firstName: string, lastName: string, uuid: string, driverType?: DriverType | null, driverReferenceNumber?: string | null, defaultFuelSettlementPercentageRate?: number | null, user: { __typename?: 'UserEntity', name?: string | null }, defaultVehicle?: { __typename?: 'EquipmentEntity', uuid: string } | null, terminal?: { __typename?: 'TerminalEntity', uuid: string, name: string } | null, qualifications: Array<{ __typename?: 'DriverQualificationEntity', id: string }> }, driverSettlementBill?: { __typename?: 'DriverSettlementBillEntity', uuid: string } | null, stop: { __typename?: 'StandardStopEntity', uuid: string, completedAt?: any | null, settlementDeductionName?: string | null, settlementDeductionFlatRate?: number | null, settlementDeductionPercentageRate?: number | null } }> }> }>, packages: Array<{ __typename?: 'PackageEntity', uuid: string, class?: number | null, description: string, hazmat?: boolean | null, height?: number | null, length?: number | null, nmfc?: string | null, quantity: number, skuNumber?: string | null, type?: PackageType | null, weight?: number | null, width?: number | null, quantityCompletedAtStop?: number | null, reasonUncompletedAtStop?: string | null, packageSpec?: { __typename?: 'PackageSpecEntity', id: string, name: string } | null, warehouseLocation?: { __typename?: 'WarehouseLocationEntity', uuid: string, name: string } | null }>, customCharges: Array<{ __typename?: 'CustomChargeEntity', uuid: string, rate: number, description?: string | null, total: number, totalAmountCents?: number | null, postedAmountUsdCents?: number | null, authoCode?: string | null, quantity: number, billingMethod: CustomChargeBillingMethod, isAutoApplied: boolean, name: string, fuelSurchargeRate?: number | null, postedFuelSurchargeRate?: number | null, zoneBasedAccessorialChargeGroupUuid?: string | null, zoneBasedAccessorialZoneUuid?: string | null, specialAccessorialTariffZoneUuid?: string | null, specialAccessorialChargeGroupUuid?: string | null, settlementFlatRate?: number | null, settlementPercentageRate?: number | null, zoneBasedAccessorialMatrixItem?: { __typename?: 'ZoneBasedAccessorialMatrixItemEntity', uuid: string } | null, specialAccessorialMatrixItem?: { __typename?: 'SpecialAccessorialMatrixItemEntity', uuid: string } | null, accessorialRange?: { __typename?: 'AccessorialRangeEntity', uuid: string, lessThanOrEqualToValue: number, rateUsdCents: number } | null, accessorialTemplate?: { __typename?: 'SkidBasedAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename?: 'SpecialAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename?: 'StandardAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | null }>, freightCharge?: { __typename?: 'FreightChargeEntity', uuid: string, quantity: number, billingMethod: FreightBillingMethod, description?: string | null, authoCode?: string | null, rate: number, discountRate?: any | null, settlementFlatRate?: number | null, settlementPercentageRate?: number | null, total: number, totalAmountCents?: number | null, postedAmountUsdCents?: number | null, fuelCharge?: { __typename?: 'FuelChargeEntity', uuid: string, surchargeRate: number, description?: string | null, authoCode?: string | null, flatRate: number, type: FuelBillingMethod, settlementFlatRate?: number | null, settlementPercentageRate?: number | null, totalAmountCents?: number | null, postedAmountUsdCents?: number | null } | null, tariff?: { __typename?: 'TariffEntity', uuid: string, billingPartyContactUuid?: string | null, tariffGroup?: { __typename?: 'TariffGroupEntity', name?: string | null, tariffGroupScope?: TariffGroupScope | null } | null, tariffZone: { __typename?: 'TariffZoneEntity', name: string } } | null } | null, inputForConsolidatedOrder?: { __typename?: 'StandardOrderEntity', uuid: string, name: string } | null, shipmentCharges: { __typename?: 'ShipmentChargeEntity', totalFuelCharge: number, totalCustomCharge: number, totalFreightCharge: number, totalCharge: number }, independentSettlementBillLineItems: Array<{ __typename?: 'SettlementBillLineItemEntity', id: string, settlementMode: SettlementMode, totalAmountUsdDollars: number, revenuePercentageRate?: any | null, revenueFlatRate?: number | null, driver: { __typename?: 'DriverEntity', uuid: string, user: { __typename?: 'UserEntity', name?: string | null } }, driverSettlementBill?: { __typename?: 'DriverSettlementBillEntity', uuid: string, name?: string | null, finalizedDate?: any | null } | null, freightCost?: { __typename?: 'FreightCostEntity', id: string, billingMethod?: FreightBillingMethod | null, dependentSettlementBillingMethod?: DependentSettlementBillingMethod | null, percentageRate?: any | null, flatRateUsdDollars?: number | null, quantity?: number | null, rateUsdDollars?: number | null, discountRate?: any | null, totalAmountUsdDollars?: number | null, totalAmountUsdCents: number, tariff?: { __typename?: 'TariffEntity', uuid: string, tariffZone: { __typename?: 'TariffZoneEntity', name: string } } | null, fuelCost?: { __typename?: 'FuelCostEntity', id: string, billingMethod?: FuelBillingMethod | null, dependentSettlementBillingMethod?: DependentSettlementBillingMethod | null, percentageRate?: any | null, surchargeRate?: number | null, flatRateUsdDollars?: number | null, totalAmountUsdDollars?: number | null, totalAmountUsdCents: number } | null } | null, customCosts: Array<{ __typename?: 'CustomCostEntity', id: string, name: string, billingMethod?: CustomChargeBillingMethod | null, dependentSettlementBillingMethod?: DependentSettlementBillingMethod | null, percentageRate?: any | null, flatRateUsdDollars?: number | null, quantity: number, rateUsdDollars?: number | null, fuelSurchargeRate?: number | null, totalAmountUsdDollars?: number | null, totalAmountUsdCents: number, accessorialTemplate?: { __typename: 'SkidBasedAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename: 'SpecialAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename: 'StandardAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename: 'UnitBasedAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename: 'WaitTimeAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename: 'WeightBasedAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename: 'ZoneBasedAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | null, specialAccessorialMatrixItem?: { __typename?: 'SpecialAccessorialMatrixItemEntity', uuid: string, zoneUuid: string, chargeGroupUuid: string } | null, zoneBasedAccessorialMatrixItem?: { __typename?: 'ZoneBasedAccessorialMatrixItemEntity', uuid: string, zoneUuid: string, chargeGroupUuid: string } | null, accessorialRange?: { __typename?: 'AccessorialRangeEntity', uuid: string } | null }> }> }>, packages: Array<{ __typename?: 'PackageEntity', uuid: string, class?: number | null, description: string, hazmat?: boolean | null, height?: number | null, length?: number | null, nmfc?: string | null, quantity: number, skuNumber?: string | null, type?: PackageType | null, weight?: number | null, width?: number | null, quantityCompletedAtStop?: number | null, reasonUncompletedAtStop?: string | null, packageSpec?: { __typename?: 'PackageSpecEntity', id: string, name: string } | null, warehouseLocation?: { __typename?: 'WarehouseLocationEntity', uuid: string, name: string } | null }>, company: { __typename?: 'CompanyEntity', invoiceEmail?: string | null, isCourier?: boolean | null, uuid: string, phone?: string | null, quickbooksFileMappingAccessorialChargeName?: string | null, quickbooksFileMappingFuelChargeName?: string | null, quickbooksFileMappingFreightChargeName?: string | null, quickbooksDesktopAccountsReceivableId?: string | null, quickbooksFileMappingPickupChargeName?: string | null, quickbooksCompanyId?: string | null, freightChargeQuickbooksMappingId?: string | null, fuelChargeQuickbooksMappingId?: string | null, quickbooksDesktopCompanyId?: string | null, quickbooksDesktopDeliveryId?: string | null, quickbooksDesktopPickupId?: string | null, quickbooksDesktopTransferId?: string | null, quickbooksDesktopLineHaulId?: string | null, quickbooksDesktopOrderChargeId?: string | null, quickbooksDesktopAccessorialId?: string | null, quickbooksDesktopFuelChargeId?: string | null, segment: Segment, timeZone: string, defaultWeightUnits: WeightUnits, defaultMeasurementUnits: MeasurementUnits, qbInvoiceNumberStart?: number | null, productionCompany?: ProductionCompany | null, name: string, orderNameOrdinal?: number | null, customDunningReportHeader?: string | null, customDunningReportFooter?: string | null, useSageBusinessWorks: boolean, blockSendingZeroDollarInvoices: boolean, purchasedProductOfferings: Array<PalletProductOffering>, defaultInvoiceEmailSubject?: string | null, defaultNonCompanyDriverSettlementMode: SettlementMode, configuration?: { __typename?: 'CompanyConfigurationEntity', uuid: string, showDriverSettlementInBilling: boolean, sameDayDispatchCellHeader: SameDayDispatchCellHeader, defaultStandardStopType: StandardStopType, defaultFuelSurchargeBillingMethod: FuelBillingMethod, defaultFuelSurcharge?: number | null, defaultFuelSettlementPercentageRate?: number | null, defaultDimFactor?: number | null, defaultRouteStartTime?: any | null, defaultRouteLoadTimeInMinutes?: number | null, defaultRouteUnloadTimeInMinutes?: number | null, defaultGenerateAppointmentDurationInMinutes: number, enableConsolidatedOrders: boolean, requirePODPhotoAndName: boolean, requirePODPhotoAndNameForPickups: boolean, requirePODPhotoForPickups: boolean, requireSigneeNameForPickups: boolean, requirePODPhotoForDeliveries: boolean, autoGroupStops: boolean, requireDriverToConfirmStopCompletedAtTime: boolean, requireSigneeNameForDeliveries: boolean, autoMatchEodDocumentsToOrders: boolean, showChargesOnCustomerPortal: boolean, invoicePdfLogoUrl?: string | null, showManuallyConfirmedByDefault?: boolean | null, showHelpersColumnInDispatch?: boolean | null, showVehicleInDailyDispatch?: boolean | null, autoApplyWaitTimeMinutes: boolean, requireReviewForEdiOrderCreation: boolean, startingInvoiceOrdinalNumber?: number | null, useDriverNumberForDispatch: boolean, useJournalNumberForInvoice: boolean, packageWarehouseLocationsEnabled: boolean, wmsEnabled: boolean, wmsStorageOrdersEnabled: boolean, wmsShortTermStorageEnabled: boolean, wmsAutoMarkOnHand: boolean, requireDriverToAcknowledgeRouteChange: boolean, defaultToAccessorial: boolean, enablePaymentMethod: boolean, driversShouldMarkFreightAsLoaded: boolean, allCapsInOrderPage: boolean, terminalsEnabled: boolean, lineHaulEnabled: boolean, logisticsSectionEnabled: boolean, fulfillmentTypeEnabled: boolean, pointToPointTariffsEnabled: boolean, orderNamingScheme: OrderNamingScheme, companyOrdinalStart?: number | null, minDigitsInCompanyOrdinalOrderName?: number | null, serviceLevelOptional: boolean, showKilogramsAndCentimeters: boolean, addOrdersToOpenInvoices: boolean, restrictEditingOrderName: boolean, notificationsEnabled: boolean, defaultInvoiceDocumentsRequired: Array<DocumentType>, invoiceNotes?: string | null, requireDimsToFinalizeCharges: boolean, orderIdentifierForCoverSheet: OrderIdentifier, getDriverLocationDataFromMobile: boolean, enableDigitalSignatureFlow: boolean, includeHyphensInInvoiceName: boolean, includeINVInInvoiceName: boolean } | null, quickbooksAccessToken?: { __typename?: 'QuickbooksOauthTokenEntity', uuid: string, expiresAt: any, accessToken: string, refreshToken: string } | null, defaultAddress?: { __typename?: 'AddressEntity', uuid: string, name: string, line1: string, line2?: string | null, city: string, latitude?: number | null, longitude?: number | null, zip: string, state: string, country: string } | null, tags: Array<{ __typename?: 'TagEntity', createdAt: any, updatedAt: any, color?: string | null, uuid: string, value: string }>, referenceNumberLabels: Array<{ __typename?: 'ReferenceNumberLabelEntity', name: string }>, orderFormFields: { __typename?: 'OrderFormFieldsEntity', onePackageRequired: boolean, onePackageWeightRequired: boolean } }, order?: { __typename?: 'StandardOrderEntity', uuid: string } | null } };

export type QuotesQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  searchText?: InputMaybe<Scalars['String']['input']>;
  quoteStatus?: InputMaybe<QuoteStatus>;
  originTerminalUuid?: InputMaybe<Scalars['String']['input']>;
  destinationTerminalUuid?: InputMaybe<Scalars['String']['input']>;
  createdAtStartDate?: InputMaybe<Scalars['DateTime']['input']>;
  createdAtEndDate?: InputMaybe<Scalars['DateTime']['input']>;
}>;


export type QuotesQuery = { __typename?: 'Query', quotes: { __typename?: 'QuoteConnection', edges: Array<{ __typename?: 'QuoteEdge', node: { __typename?: 'QuoteEntity', uuid: string, number: string, createdAt: any, status: QuoteStatus, dimFactor?: number | null, measurementUnits?: MeasurementUnits | null, weightUnits?: WeightUnits | null, totalSkids?: number | null, source: QuoteSource, enableLineHaul: boolean, service?: { __typename?: 'ServiceEntity', uuid: string } | null, shipments: Array<{ __typename?: 'StandardShipmentEntity', uuid: string, totalChargesAmount: number, totalAmountCents?: number | null, postedAmountCents?: number | null, shouldBillIndividually: boolean, shouldUseDimWeight: boolean, overridePackageWeight: boolean, name: string, hideFromBilling: boolean, hasSignedPOD: boolean, shipmentType: ShipmentType, status: ShipmentStatus, invoice?: { __typename?: 'InvoiceEntity', uuid: string, date: any, postedAt?: any | null, dueDate?: any | null, name: string, journalNumber: number, billToContact: { __typename?: 'CustomerContactEntity', uuid: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string } } | null, documents: Array<{ __typename?: 'DocumentEntity', uuid: string, fileName: string, bucket: string, region: string, key: string, uploadedAt?: any | null, fileType: string, isDeleted: boolean, preSignedGetUrl: string, name?: string | null, type: DocumentType, pageNumber?: number | null, createdAt: any, notes?: string | null, order?: { __typename?: 'StandardOrderEntity', uuid: string, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', shipperBillOfLadingNumber?: string | null } } | null, shipment?: { __typename?: 'StandardOrderEntity', uuid: string } | null, driverFormTemplate?: { __typename?: 'DriverSignableFormTemplateEntity', uuid: string, title: string, formText: string } | null }>, shipmentSubscribers: Array<{ __typename?: 'ShipmentSubscriberEntity', uuid: string, email?: string | null }>, shipperAddress?: { __typename?: 'AddressEntity', uuid: string, name: string, line1: string, line2?: string | null, city: string, state: string, zip: string, country: string, latitude?: number | null, longitude?: number | null, driverInstructions?: string | null, receivingHoursStart?: any | null, receivingHoursEnd?: any | null, specialInstructions?: string | null } | null, airportInfo?: { __typename?: 'AirportInfoEntity', uuid: string, iataCode: string, terminal: string, address: { __typename?: 'AddressEntity', uuid: string, name: string, line1: string, line2?: string | null, city: string, state: string, zip: string, country: string, latitude?: number | null, longitude?: number | null, driverInstructions?: string | null, receivingHoursStart?: any | null, receivingHoursEnd?: any | null, specialInstructions?: string | null } } | null, fields?: { __typename?: 'StandardShipmentFieldsEntity', uuid: string, deadlineDate?: any | null, deadlineType?: DeadlineType | null, deliveryDate?: any | null, dimFactor: number, pickupOrDelivery: PickupOrDelivery, outboundMethod?: OutboundMethod | null, inboundMethod?: InboundMethod | null, type: StandardShipmentType, service?: { __typename?: 'ServiceEntity', uuid: string, name: string, createdAt: any, updatedAt: any, timeInMinutes?: number | null, useApptInRouteOptimization: boolean, markOrdersAsSpecial: boolean, defaultAppointmentStartTime?: any | null, defaultAppointmentEndTime?: any | null, defaultStartNow: boolean, defaultInboundStopType?: StopType | null, defaultOutboundStopType?: StopType | null, defaultPickupPadding?: any | null, defaultDeliveryPadding?: any | null, defaultTotalDuration?: any | null, defaultIsLineHaul: boolean, defaultFulfillmentType?: FulfillmentType | null, isActive: boolean, isExposedToCustomers: boolean, serviceAvailabilityDates: Array<{ __typename?: 'ServiceAvailabilityDateEntity', id: string, dayCategory: SpecialDayOfWeek, enabled: boolean, start: { __typename?: 'PlainTime', hour: number, minute: number }, end: { __typename?: 'PlainTime', hour: number, minute: number } }> } | null } | null, legs: Array<{ __typename?: 'LegEntity', uuid: string, miles?: number | null, endStop: { __typename?: 'StandardStopEntity', uuid: string, createdAt: any, specialInstructions?: string | null, destinationAirport?: string | null, inboundDeadlineDate?: any | null, expectedOutboundDate?: any | null, outboundCarrier?: string | null, appointmentTextStatus?: AppointmentTextStatus | null, incomingCarrier?: string | null, appointmentCallStatus?: AppointmentCallStatus | null, appointmentManuallyConfirmed?: boolean | null, deadlineTime?: any | null, settlementDeductionFlatRate?: number | null, settlementDeductionPercentageRate?: number | null, settlementDeductionName?: string | null, proofOfDeliverySignee?: string | null, appointmentTime?: any | null, arrivedAt?: any | null, completedAt?: any | null, inboundMethod?: InboundMethod | null, expectedInboundArrivalDate?: any | null, outboundMethod?: OutboundMethod | null, driverCompletedAt?: any | null, notes?: string | null, serviceDate?: any | null, status: StopStatus, appointmentRequired: boolean, endAppointmentTime?: any | null, isSpecial?: boolean | null, hideFromDispatch?: boolean | null, standardStopType?: StandardStopType | null, stopType?: StopType | null, paperworkMarkedComplete?: boolean | null, canMarkAttemptComplete?: boolean | null, sentToAgentAt?: any | null, confirmedByAgentAt?: any | null, address: { __typename?: 'AddressEntity', preventCoordRecompute?: boolean | null, internalNotes?: string | null, iataCode?: string | null, uuid: string, name: string, line1: string, line2?: string | null, city: string, state: string, zip: string, country: string, latitude?: number | null, longitude?: number | null, driverInstructions?: string | null, receivingHoursStart?: any | null, receivingHoursEnd?: any | null, specialInstructions?: string | null }, transferAddress?: { __typename?: 'AddressEntity', uuid: string, name: string, line1: string, line2?: string | null, city: string, state: string, zip: string, country: string, latitude?: number | null, longitude?: number | null, driverInstructions?: string | null, receivingHoursStart?: any | null, receivingHoursEnd?: any | null, specialInstructions?: string | null } | null, consigneeAddress?: { __typename?: 'AddressEntity', uuid: string, name: string, line1: string, line2?: string | null, city: string, state: string, zip: string, country: string, latitude?: number | null, longitude?: number | null, driverInstructions?: string | null, receivingHoursStart?: any | null, receivingHoursEnd?: any | null, specialInstructions?: string | null } | null, consigneeContactPerson?: { __typename?: 'ContactPersonEntity', uuid: string, firstName?: string | null, lastName?: string | null, email?: string | null, notes?: string | null, phone?: string | null, createdAt: any } | null, serviceDateV2?: { __typename?: 'PlainDate', iso8601: string } | null, shipperAddress?: { __typename?: 'AddressEntity', uuid: string, name: string, line1: string, line2?: string | null, city: string, state: string, zip: string, country: string, latitude?: number | null, longitude?: number | null, driverInstructions?: string | null, receivingHoursStart?: any | null, receivingHoursEnd?: any | null, specialInstructions?: string | null } | null, shipperContactPerson?: { __typename?: 'ContactPersonEntity', uuid: string, firstName?: string | null, lastName?: string | null, email?: string | null, notes?: string | null, phone?: string | null, createdAt: any } | null, routeSlot?: { __typename?: 'RouteSlotEntity', uuid: string, route?: { __typename?: 'RouteEntity', uuid: string, date: any, name: string, slots: Array<{ __typename?: 'RouteSlotEntity', uuid: string }>, drivers: Array<{ __typename?: 'DriverEntity', uuid: string, firstName: string, lastName: string, driverType?: DriverType | null, agent?: { __typename?: 'AgentFieldsEntity', uuid: string, name: string } | null }>, equipments: Array<{ __typename?: 'EquipmentEntity', uuid: string, name: string }> } | null } | null, contactPerson?: { __typename?: 'ContactPersonEntity', uuid: string, firstName?: string | null, lastName?: string | null, email?: string | null, notes?: string | null, phone?: string | null, createdAt: any } | null, terminal?: { __typename?: 'TerminalEntity', name: string, code: string, uuid: string, isActive: boolean, address: { __typename?: 'AddressEntity', line1: string, line2?: string | null, city: string, state: string, zip: string, uuid: string, name: string, latitude?: number | null, longitude?: number | null }, startForTerminalLanes: Array<{ __typename?: 'TerminalLaneEntity', id: string, endTerminal: { __typename?: 'TerminalEntity', uuid: string, code: string, name: string } }>, agent?: { __typename?: 'AgentFieldsEntity', name: string } | null } | null, stopDriverMaps: Array<{ __typename?: 'StopDriverMapEntity', uuid: string, name?: string | null, enableDriverSettlement?: boolean | null, revenuePercentageRate?: number | null, revenueFlatRate?: number | null, driverPayoutFinalized: boolean, driver: { __typename?: 'DriverEntity', firstName: string, lastName: string, uuid: string, driverType?: DriverType | null, driverReferenceNumber?: string | null, defaultFuelSettlementPercentageRate?: number | null, user: { __typename?: 'UserEntity', name?: string | null }, defaultVehicle?: { __typename?: 'EquipmentEntity', uuid: string } | null, terminal?: { __typename?: 'TerminalEntity', uuid: string, name: string } | null, qualifications: Array<{ __typename?: 'DriverQualificationEntity', id: string }> }, driverSettlementBill?: { __typename?: 'DriverSettlementBillEntity', uuid: string } | null, stop: { __typename?: 'StandardStopEntity', uuid: string, completedAt?: any | null, settlementDeductionName?: string | null, settlementDeductionFlatRate?: number | null, settlementDeductionPercentageRate?: number | null } }> }, previousStopAttempts: Array<{ __typename?: 'StandardStopEntity', stopDriverMaps: Array<{ __typename?: 'StopDriverMapEntity', uuid: string, name?: string | null, enableDriverSettlement?: boolean | null, revenuePercentageRate?: number | null, revenueFlatRate?: number | null, driverPayoutFinalized: boolean, driver: { __typename?: 'DriverEntity', firstName: string, lastName: string, uuid: string, driverType?: DriverType | null, driverReferenceNumber?: string | null, defaultFuelSettlementPercentageRate?: number | null, user: { __typename?: 'UserEntity', name?: string | null }, defaultVehicle?: { __typename?: 'EquipmentEntity', uuid: string } | null, terminal?: { __typename?: 'TerminalEntity', uuid: string, name: string } | null, qualifications: Array<{ __typename?: 'DriverQualificationEntity', id: string }> }, driverSettlementBill?: { __typename?: 'DriverSettlementBillEntity', uuid: string } | null, stop: { __typename?: 'StandardStopEntity', uuid: string, completedAt?: any | null, settlementDeductionName?: string | null, settlementDeductionFlatRate?: number | null, settlementDeductionPercentageRate?: number | null } }> }> }>, packages: Array<{ __typename?: 'PackageEntity', uuid: string, class?: number | null, description: string, hazmat?: boolean | null, height?: number | null, length?: number | null, nmfc?: string | null, quantity: number, skuNumber?: string | null, type?: PackageType | null, weight?: number | null, width?: number | null, quantityCompletedAtStop?: number | null, reasonUncompletedAtStop?: string | null, packageSpec?: { __typename?: 'PackageSpecEntity', id: string, name: string } | null, warehouseLocation?: { __typename?: 'WarehouseLocationEntity', uuid: string, name: string } | null }>, customCharges: Array<{ __typename?: 'CustomChargeEntity', uuid: string, rate: number, description?: string | null, total: number, totalAmountCents?: number | null, postedAmountUsdCents?: number | null, authoCode?: string | null, quantity: number, billingMethod: CustomChargeBillingMethod, isAutoApplied: boolean, name: string, fuelSurchargeRate?: number | null, postedFuelSurchargeRate?: number | null, zoneBasedAccessorialChargeGroupUuid?: string | null, zoneBasedAccessorialZoneUuid?: string | null, specialAccessorialTariffZoneUuid?: string | null, specialAccessorialChargeGroupUuid?: string | null, settlementFlatRate?: number | null, settlementPercentageRate?: number | null, zoneBasedAccessorialMatrixItem?: { __typename?: 'ZoneBasedAccessorialMatrixItemEntity', uuid: string } | null, specialAccessorialMatrixItem?: { __typename?: 'SpecialAccessorialMatrixItemEntity', uuid: string } | null, accessorialRange?: { __typename?: 'AccessorialRangeEntity', uuid: string, lessThanOrEqualToValue: number, rateUsdCents: number } | null, accessorialTemplate?: { __typename?: 'SkidBasedAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename?: 'SpecialAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename?: 'StandardAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | null }>, freightCharge?: { __typename?: 'FreightChargeEntity', uuid: string, quantity: number, billingMethod: FreightBillingMethod, description?: string | null, authoCode?: string | null, rate: number, discountRate?: any | null, settlementFlatRate?: number | null, settlementPercentageRate?: number | null, total: number, totalAmountCents?: number | null, postedAmountUsdCents?: number | null, fuelCharge?: { __typename?: 'FuelChargeEntity', uuid: string, surchargeRate: number, description?: string | null, authoCode?: string | null, flatRate: number, type: FuelBillingMethod, settlementFlatRate?: number | null, settlementPercentageRate?: number | null, totalAmountCents?: number | null, postedAmountUsdCents?: number | null } | null, tariff?: { __typename?: 'TariffEntity', uuid: string, billingPartyContactUuid?: string | null, tariffGroup?: { __typename?: 'TariffGroupEntity', name?: string | null, tariffGroupScope?: TariffGroupScope | null } | null, tariffZone: { __typename?: 'TariffZoneEntity', name: string } } | null } | null, inputForConsolidatedOrder?: { __typename?: 'StandardOrderEntity', uuid: string, name: string } | null, shipmentCharges: { __typename?: 'ShipmentChargeEntity', totalFuelCharge: number, totalCustomCharge: number, totalFreightCharge: number, totalCharge: number }, independentSettlementBillLineItems: Array<{ __typename?: 'SettlementBillLineItemEntity', id: string, settlementMode: SettlementMode, totalAmountUsdDollars: number, revenuePercentageRate?: any | null, revenueFlatRate?: number | null, driver: { __typename?: 'DriverEntity', uuid: string, user: { __typename?: 'UserEntity', name?: string | null } }, driverSettlementBill?: { __typename?: 'DriverSettlementBillEntity', uuid: string, name?: string | null, finalizedDate?: any | null } | null, freightCost?: { __typename?: 'FreightCostEntity', id: string, billingMethod?: FreightBillingMethod | null, dependentSettlementBillingMethod?: DependentSettlementBillingMethod | null, percentageRate?: any | null, flatRateUsdDollars?: number | null, quantity?: number | null, rateUsdDollars?: number | null, discountRate?: any | null, totalAmountUsdDollars?: number | null, totalAmountUsdCents: number, tariff?: { __typename?: 'TariffEntity', uuid: string, tariffZone: { __typename?: 'TariffZoneEntity', name: string } } | null, fuelCost?: { __typename?: 'FuelCostEntity', id: string, billingMethod?: FuelBillingMethod | null, dependentSettlementBillingMethod?: DependentSettlementBillingMethod | null, percentageRate?: any | null, surchargeRate?: number | null, flatRateUsdDollars?: number | null, totalAmountUsdDollars?: number | null, totalAmountUsdCents: number } | null } | null, customCosts: Array<{ __typename?: 'CustomCostEntity', id: string, name: string, billingMethod?: CustomChargeBillingMethod | null, dependentSettlementBillingMethod?: DependentSettlementBillingMethod | null, percentageRate?: any | null, flatRateUsdDollars?: number | null, quantity: number, rateUsdDollars?: number | null, fuelSurchargeRate?: number | null, totalAmountUsdDollars?: number | null, totalAmountUsdCents: number, accessorialTemplate?: { __typename: 'SkidBasedAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename: 'SpecialAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename: 'StandardAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename: 'UnitBasedAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename: 'WaitTimeAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename: 'WeightBasedAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename: 'ZoneBasedAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | null, specialAccessorialMatrixItem?: { __typename?: 'SpecialAccessorialMatrixItemEntity', uuid: string, zoneUuid: string, chargeGroupUuid: string } | null, zoneBasedAccessorialMatrixItem?: { __typename?: 'ZoneBasedAccessorialMatrixItemEntity', uuid: string, zoneUuid: string, chargeGroupUuid: string } | null, accessorialRange?: { __typename?: 'AccessorialRangeEntity', uuid: string } | null }> }> }>, packages: Array<{ __typename?: 'PackageEntity', uuid: string, class?: number | null, description: string, hazmat?: boolean | null, height?: number | null, length?: number | null, nmfc?: string | null, quantity: number, skuNumber?: string | null, type?: PackageType | null, weight?: number | null, width?: number | null, quantityCompletedAtStop?: number | null, reasonUncompletedAtStop?: string | null, packageSpec?: { __typename?: 'PackageSpecEntity', id: string, name: string } | null, warehouseLocation?: { __typename?: 'WarehouseLocationEntity', uuid: string, name: string } | null }>, billingPartyContact: { __typename?: 'CustomerContactEntity', defaultFuelSurcharge?: number | null, defaultUseTariff?: boolean | null, pickupDiscountRate?: any | null, deliveryDiscountRate?: any | null, transferDiscountRate?: any | null, lineHaulDiscountRate?: any | null, defaultDimFactor?: number | null, billingContactEmail?: string | null, defaultInvoiceType: InvoiceType, defaultInvoiceTransmissionMethod: InvoiceTransmissionMethod, defaultInvoiceDownloadDocuments: Array<DocumentType>, defaultInvoiceDocumentsRequired: Array<DocumentType>, defaultInvoiceEmailSubject?: string | null, identifier?: string | null, numberOfOrdersPerInvoice?: number | null, invoiceTimePeriodSplit?: TimePeriod | null, creditHoldLimitInCents?: number | null, enableCreditHold?: boolean | null, maxDaysOutstanding?: number | null, isPrepaidOnly: boolean, enableCustomerPortalOrderEntry: boolean, useCustomPackageSpecs: boolean, showEdiReferenceNumbersOnOrderPage: boolean, useCustomVehicleTypes: boolean, uuid: string, displayName: string, ediApplicationId?: string | null, ediContactCode?: string | null, isActive: boolean, isaId?: string | null, contactReferenceNumber?: string | null, shortCode?: string | null, stediPartnerId?: string | null, isOverCreditLimit: boolean, quickbooksDesktopContactId?: string | null, quickbooksMappingId?: string | null, fuelChargeQuickbooksMappingId?: string | null, freightChargeQuickbooksMappingId?: string | null, miscCustomChargeQuickbooksMappingId?: string | null, type: ContactType, billingCycle?: BillingCycleType | null, billingCycleDuration: BillingCycleDuration, billingPeriod?: number | null, requireDriverToCheckOffPackagesAtStop: boolean, invoiceNotes?: string | null, defaultAddress?: { __typename?: 'AddressEntity', uuid: string, name: string, line1: string, line2?: string | null, city: string, state: string, zip: string, country: string, latitude?: number | null, longitude?: number | null, driverInstructions?: string | null, receivingHoursStart?: any | null, receivingHoursEnd?: any | null, specialInstructions?: string | null } | null, defaultContactPerson?: { __typename?: 'ContactPersonEntity', uuid: string, firstName?: string | null, lastName?: string | null, email?: string | null, notes?: string | null, phone?: string | null, createdAt: any } | null, defaultInvoiceTerms?: { __typename?: 'InvoiceTermEntity', uuid: string, terms: string } | null, packageSpecs: Array<{ __typename?: 'PackageSpecEntity', id: string }>, vehicleTypes: Array<{ __typename?: 'VehicleTypeEntity', uuid: string }>, defaultInboundEdiService?: { __typename?: 'ServiceEntity', uuid: string, name: string } | null, defaultOutboundEdiService?: { __typename?: 'ServiceEntity', uuid: string, name: string } | null, defaultInboundOutboundEdiService?: { __typename?: 'ServiceEntity', uuid: string, name: string } | null, defaultOrdinaryTariffChain?: { __typename?: 'TariffChainEntity', id: string, name: string } | null, defaultLineHaulTariffChain?: { __typename?: 'TariffChainEntity', id: string, name: string } | null, defaultTransferTariffChain?: { __typename?: 'TariffChainEntity', id: string, name: string } | null, defaultPointToPointTariffChain?: { __typename?: 'TariffChainEntity', id: string, name: string } | null, masterAccount?: { __typename?: 'MasterAccountEntity', uuid: string, name: string } | null, contactComments: Array<{ __typename?: 'ContactCommentEntity', uuid: string, updatedAt: any, createdAt: any, comment: string, authorName: string }>, services: Array<{ __typename?: 'ServiceEntity', uuid: string, name: string, createdAt: any, updatedAt: any, timeInMinutes?: number | null, useApptInRouteOptimization: boolean, markOrdersAsSpecial: boolean, defaultAppointmentStartTime?: any | null, defaultAppointmentEndTime?: any | null, defaultStartNow: boolean, defaultInboundStopType?: StopType | null, defaultOutboundStopType?: StopType | null, defaultPickupPadding?: any | null, defaultDeliveryPadding?: any | null, defaultTotalDuration?: any | null, defaultIsLineHaul: boolean, defaultFulfillmentType?: FulfillmentType | null, isActive: boolean, isExposedToCustomers: boolean, serviceAvailabilityDates: Array<{ __typename?: 'ServiceAvailabilityDateEntity', id: string, dayCategory: SpecialDayOfWeek, enabled: boolean, start: { __typename?: 'PlainTime', hour: number, minute: number }, end: { __typename?: 'PlainTime', hour: number, minute: number } }> }>, invoicePdfColumns: Array<{ __typename?: 'PdfColumnEntity', uuid: string, orderColumnMapping?: OrderPdfColumnMapping | null, shipmentPDFColumnMapping?: ShipmentPdfColumnMapping | null, legPDFColumnMapping?: LegPdfColumnMapping | null, stopPDFColumnMapping?: StopPdfColumnMapping | null }>, addresses: Array<{ __typename?: 'AddressEntity', uuid: string, name: string, line1: string, line2?: string | null, city: string, state: string, zip: string, country: string, latitude?: number | null, longitude?: number | null, driverInstructions?: string | null, receivingHoursStart?: any | null, receivingHoursEnd?: any | null, specialInstructions?: string | null }>, contactPersons: Array<{ __typename?: 'ContactPersonEntity', uuid: string, firstName?: string | null, lastName?: string | null, email?: string | null, notes?: string | null, phone?: string | null, createdAt: any }>, defaultService?: { __typename?: 'ServiceEntity', uuid: string, name: string, createdAt: any, updatedAt: any, timeInMinutes?: number | null, useApptInRouteOptimization: boolean, markOrdersAsSpecial: boolean, defaultAppointmentStartTime?: any | null, defaultAppointmentEndTime?: any | null, defaultStartNow: boolean, defaultInboundStopType?: StopType | null, defaultOutboundStopType?: StopType | null, defaultPickupPadding?: any | null, defaultDeliveryPadding?: any | null, defaultTotalDuration?: any | null, defaultIsLineHaul: boolean, defaultFulfillmentType?: FulfillmentType | null, isActive: boolean, isExposedToCustomers: boolean, serviceAvailabilityDates: Array<{ __typename?: 'ServiceAvailabilityDateEntity', id: string, dayCategory: SpecialDayOfWeek, enabled: boolean, start: { __typename?: 'PlainTime', hour: number, minute: number }, end: { __typename?: 'PlainTime', hour: number, minute: number } }> } | null, businessDivision?: { __typename?: 'BusinessDivisionEntity', uuid: string, name: string } | null, referenceNumberLabels: Array<{ __typename?: 'ReferenceNumberLabelEntity', name: string }> } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string, ediApplicationId?: string | null, ediContactCode?: string | null, isActive: boolean, isaId?: string | null, identifier?: string | null, contactReferenceNumber?: string | null, shortCode?: string | null, stediPartnerId?: string | null, isOverCreditLimit: boolean, quickbooksDesktopContactId?: string | null, quickbooksMappingId?: string | null, fuelChargeQuickbooksMappingId?: string | null, freightChargeQuickbooksMappingId?: string | null, miscCustomChargeQuickbooksMappingId?: string | null, type: ContactType, billingCycle?: BillingCycleType | null, billingCycleDuration: BillingCycleDuration, billingPeriod?: number | null, requireDriverToCheckOffPackagesAtStop: boolean, invoiceNotes?: string | null, masterAccount?: { __typename?: 'MasterAccountEntity', uuid: string, name: string } | null, contactComments: Array<{ __typename?: 'ContactCommentEntity', uuid: string, updatedAt: any, createdAt: any, comment: string, authorName: string }>, services: Array<{ __typename?: 'ServiceEntity', uuid: string, name: string, createdAt: any, updatedAt: any, timeInMinutes?: number | null, useApptInRouteOptimization: boolean, markOrdersAsSpecial: boolean, defaultAppointmentStartTime?: any | null, defaultAppointmentEndTime?: any | null, defaultStartNow: boolean, defaultInboundStopType?: StopType | null, defaultOutboundStopType?: StopType | null, defaultPickupPadding?: any | null, defaultDeliveryPadding?: any | null, defaultTotalDuration?: any | null, defaultIsLineHaul: boolean, defaultFulfillmentType?: FulfillmentType | null, isActive: boolean, isExposedToCustomers: boolean, serviceAvailabilityDates: Array<{ __typename?: 'ServiceAvailabilityDateEntity', id: string, dayCategory: SpecialDayOfWeek, enabled: boolean, start: { __typename?: 'PlainTime', hour: number, minute: number }, end: { __typename?: 'PlainTime', hour: number, minute: number } }> }>, invoicePdfColumns: Array<{ __typename?: 'PdfColumnEntity', uuid: string, orderColumnMapping?: OrderPdfColumnMapping | null, shipmentPDFColumnMapping?: ShipmentPdfColumnMapping | null, legPDFColumnMapping?: LegPdfColumnMapping | null, stopPDFColumnMapping?: StopPdfColumnMapping | null }>, addresses: Array<{ __typename?: 'AddressEntity', uuid: string, name: string, line1: string, line2?: string | null, city: string, state: string, zip: string, country: string, latitude?: number | null, longitude?: number | null, driverInstructions?: string | null, receivingHoursStart?: any | null, receivingHoursEnd?: any | null, specialInstructions?: string | null }>, contactPersons: Array<{ __typename?: 'ContactPersonEntity', uuid: string, firstName?: string | null, lastName?: string | null, email?: string | null, notes?: string | null, phone?: string | null, createdAt: any }>, defaultAddress?: { __typename?: 'AddressEntity', uuid: string, name: string, line1: string, line2?: string | null, city: string, state: string, zip: string, country: string, latitude?: number | null, longitude?: number | null, driverInstructions?: string | null, receivingHoursStart?: any | null, receivingHoursEnd?: any | null, specialInstructions?: string | null } | null, defaultContactPerson?: { __typename?: 'ContactPersonEntity', uuid: string, firstName?: string | null, lastName?: string | null, email?: string | null, notes?: string | null, phone?: string | null, createdAt: any } | null, defaultService?: { __typename?: 'ServiceEntity', uuid: string, name: string, createdAt: any, updatedAt: any, timeInMinutes?: number | null, useApptInRouteOptimization: boolean, markOrdersAsSpecial: boolean, defaultAppointmentStartTime?: any | null, defaultAppointmentEndTime?: any | null, defaultStartNow: boolean, defaultInboundStopType?: StopType | null, defaultOutboundStopType?: StopType | null, defaultPickupPadding?: any | null, defaultDeliveryPadding?: any | null, defaultTotalDuration?: any | null, defaultIsLineHaul: boolean, defaultFulfillmentType?: FulfillmentType | null, isActive: boolean, isExposedToCustomers: boolean, serviceAvailabilityDates: Array<{ __typename?: 'ServiceAvailabilityDateEntity', id: string, dayCategory: SpecialDayOfWeek, enabled: boolean, start: { __typename?: 'PlainTime', hour: number, minute: number }, end: { __typename?: 'PlainTime', hour: number, minute: number } }> } | null, businessDivision?: { __typename?: 'BusinessDivisionEntity', uuid: string, name: string } | null, referenceNumberLabels: Array<{ __typename?: 'ReferenceNumberLabelEntity', name: string }> }, company: { __typename?: 'CompanyEntity', invoiceEmail?: string | null, isCourier?: boolean | null, uuid: string, phone?: string | null, quickbooksFileMappingAccessorialChargeName?: string | null, quickbooksFileMappingFuelChargeName?: string | null, quickbooksFileMappingFreightChargeName?: string | null, quickbooksDesktopAccountsReceivableId?: string | null, quickbooksFileMappingPickupChargeName?: string | null, quickbooksCompanyId?: string | null, freightChargeQuickbooksMappingId?: string | null, fuelChargeQuickbooksMappingId?: string | null, quickbooksDesktopCompanyId?: string | null, quickbooksDesktopDeliveryId?: string | null, quickbooksDesktopPickupId?: string | null, quickbooksDesktopTransferId?: string | null, quickbooksDesktopLineHaulId?: string | null, quickbooksDesktopOrderChargeId?: string | null, quickbooksDesktopAccessorialId?: string | null, quickbooksDesktopFuelChargeId?: string | null, segment: Segment, timeZone: string, defaultWeightUnits: WeightUnits, defaultMeasurementUnits: MeasurementUnits, qbInvoiceNumberStart?: number | null, productionCompany?: ProductionCompany | null, name: string, orderNameOrdinal?: number | null, customDunningReportHeader?: string | null, customDunningReportFooter?: string | null, useSageBusinessWorks: boolean, blockSendingZeroDollarInvoices: boolean, purchasedProductOfferings: Array<PalletProductOffering>, defaultInvoiceEmailSubject?: string | null, defaultNonCompanyDriverSettlementMode: SettlementMode, configuration?: { __typename?: 'CompanyConfigurationEntity', uuid: string, showDriverSettlementInBilling: boolean, sameDayDispatchCellHeader: SameDayDispatchCellHeader, defaultStandardStopType: StandardStopType, defaultFuelSurchargeBillingMethod: FuelBillingMethod, defaultFuelSurcharge?: number | null, defaultFuelSettlementPercentageRate?: number | null, defaultDimFactor?: number | null, defaultRouteStartTime?: any | null, defaultRouteLoadTimeInMinutes?: number | null, defaultRouteUnloadTimeInMinutes?: number | null, defaultGenerateAppointmentDurationInMinutes: number, enableConsolidatedOrders: boolean, requirePODPhotoAndName: boolean, requirePODPhotoAndNameForPickups: boolean, requirePODPhotoForPickups: boolean, requireSigneeNameForPickups: boolean, requirePODPhotoForDeliveries: boolean, autoGroupStops: boolean, requireDriverToConfirmStopCompletedAtTime: boolean, requireSigneeNameForDeliveries: boolean, autoMatchEodDocumentsToOrders: boolean, showChargesOnCustomerPortal: boolean, invoicePdfLogoUrl?: string | null, showManuallyConfirmedByDefault?: boolean | null, showHelpersColumnInDispatch?: boolean | null, showVehicleInDailyDispatch?: boolean | null, autoApplyWaitTimeMinutes: boolean, requireReviewForEdiOrderCreation: boolean, startingInvoiceOrdinalNumber?: number | null, useDriverNumberForDispatch: boolean, useJournalNumberForInvoice: boolean, packageWarehouseLocationsEnabled: boolean, wmsEnabled: boolean, wmsStorageOrdersEnabled: boolean, wmsShortTermStorageEnabled: boolean, wmsAutoMarkOnHand: boolean, requireDriverToAcknowledgeRouteChange: boolean, defaultToAccessorial: boolean, enablePaymentMethod: boolean, driversShouldMarkFreightAsLoaded: boolean, allCapsInOrderPage: boolean, terminalsEnabled: boolean, lineHaulEnabled: boolean, logisticsSectionEnabled: boolean, fulfillmentTypeEnabled: boolean, pointToPointTariffsEnabled: boolean, orderNamingScheme: OrderNamingScheme, companyOrdinalStart?: number | null, minDigitsInCompanyOrdinalOrderName?: number | null, serviceLevelOptional: boolean, showKilogramsAndCentimeters: boolean, addOrdersToOpenInvoices: boolean, restrictEditingOrderName: boolean, notificationsEnabled: boolean, defaultInvoiceDocumentsRequired: Array<DocumentType>, invoiceNotes?: string | null, requireDimsToFinalizeCharges: boolean, orderIdentifierForCoverSheet: OrderIdentifier, getDriverLocationDataFromMobile: boolean, enableDigitalSignatureFlow: boolean, includeHyphensInInvoiceName: boolean, includeINVInInvoiceName: boolean } | null, quickbooksAccessToken?: { __typename?: 'QuickbooksOauthTokenEntity', uuid: string, expiresAt: any, accessToken: string, refreshToken: string } | null, defaultAddress?: { __typename?: 'AddressEntity', uuid: string, name: string, line1: string, line2?: string | null, city: string, latitude?: number | null, longitude?: number | null, zip: string, state: string, country: string } | null, tags: Array<{ __typename?: 'TagEntity', createdAt: any, updatedAt: any, color?: string | null, uuid: string, value: string }>, referenceNumberLabels: Array<{ __typename?: 'ReferenceNumberLabelEntity', name: string }>, orderFormFields: { __typename?: 'OrderFormFieldsEntity', onePackageRequired: boolean, onePackageWeightRequired: boolean } }, order?: { __typename?: 'StandardOrderEntity', uuid: string } | null } }>, pageInfo: { __typename?: 'PageInfo', startCursor?: string | null, endCursor?: string | null, hasNextPage: boolean, hasPreviousPage: boolean } } };

export type UpdateQuoteMutationVariables = Exact<{
  updateQuoteInput: UpdateQuoteInput;
}>;


export type UpdateQuoteMutation = { __typename?: 'Mutation', updateQuote: { __typename?: 'QuoteEntity', uuid: string } };

export type CreateReportGroupConfigurationMutationVariables = Exact<{
  createReportGroupConfigurationInput: ReportGroupConfigurationCreateInput;
}>;


export type CreateReportGroupConfigurationMutation = { __typename?: 'Mutation', createReportGroupConfiguration: { __typename?: 'ReportGroupConfigurationEntity', uuid: string, name: string, orderStatuses: Array<OrderStatus>, stopTypes: Array<PickupOrDelivery>, reportAggregationPeriod: ReportAggregationPeriod, defaultReportType: ReportType, reportRevenueType: ReportRevenueType, reportStatistics: Array<ReportStatistic>, lastNumberOfDays?: number | null, lastNumberOfWeeks?: number | null, lastNumberOfMonths?: number | null, startDate?: any | null, endDate?: any | null, contact?: { __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string } | null, contacts?: Array<{ __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string }> | null, driver?: { __typename?: 'DriverEntity', uuid: string, firstName: string, lastName: string } | null, drivers?: Array<{ __typename?: 'DriverEntity', uuid: string, firstName: string, lastName: string }> | null, terminal?: { __typename?: 'TerminalEntity', uuid: string, code: string } | null } };

export type CustomerReportBucketFragment = { __typename?: 'CustomerReportBucketEntity', uuid: string, displayName: string, freightRevenue: number, fuelRevenue: number, lineHaulRevenue: number, specialRevenue: number, customChargeRevenue: number, surchargeRevenue: number, pickupRevenue: number, deliveryRevenue: number, recoveryRevenue: number, transferRevenue: number, totalRevenue: number, totalWeight: number, numberOfOrders: number, numberOfPackages: number };

export type CustomerReportQueryVariables = Exact<{
  args: CustomerReportArgs;
}>;


export type CustomerReportQuery = { __typename?: 'Query', customerReport: Array<{ __typename?: 'CustomerReportBucketEntity', uuid: string, displayName: string, freightRevenue: number, fuelRevenue: number, lineHaulRevenue: number, specialRevenue: number, customChargeRevenue: number, surchargeRevenue: number, pickupRevenue: number, deliveryRevenue: number, recoveryRevenue: number, transferRevenue: number, totalRevenue: number, totalWeight: number, numberOfOrders: number, numberOfPackages: number }> };

export type DeleteReportGroupConfigurationMutationVariables = Exact<{
  uuid: Scalars['String']['input'];
}>;


export type DeleteReportGroupConfigurationMutation = { __typename?: 'Mutation', deleteReportGroupConfiguration: { __typename?: 'ReportGroupConfigurationEntity', uuid: string, name: string, orderStatuses: Array<OrderStatus>, stopTypes: Array<PickupOrDelivery>, reportAggregationPeriod: ReportAggregationPeriod, defaultReportType: ReportType, reportRevenueType: ReportRevenueType, reportStatistics: Array<ReportStatistic>, lastNumberOfDays?: number | null, lastNumberOfWeeks?: number | null, lastNumberOfMonths?: number | null, startDate?: any | null, endDate?: any | null, contact?: { __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string } | null, contacts?: Array<{ __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string }> | null, driver?: { __typename?: 'DriverEntity', uuid: string, firstName: string, lastName: string } | null, drivers?: Array<{ __typename?: 'DriverEntity', uuid: string, firstName: string, lastName: string }> | null, terminal?: { __typename?: 'TerminalEntity', uuid: string, code: string } | null } };

export type DriverReportBucketFragment = { __typename?: 'DriverReportBucketEntity', uuid: string, firstName: string, lastName: string, driverType?: string | null, freightRevenue: number, fuelRevenue: number, lineHaulRevenue: number, specialRevenue: number, customChargeRevenue: number, surchargeRevenue: number, pickupRevenue: number, deliveryRevenue: number, recoveryRevenue: number, transferRevenue: number, totalRevenue: number, totalWeight: number, numberOfOrders: number, numberOfPackages: number };

export type DriverReportQueryVariables = Exact<{
  args: DriverReportArgs;
}>;


export type DriverReportQuery = { __typename?: 'Query', driverReport: Array<{ __typename?: 'DriverReportBucketEntity', uuid: string, firstName: string, lastName: string, driverType?: string | null, freightRevenue: number, fuelRevenue: number, lineHaulRevenue: number, specialRevenue: number, customChargeRevenue: number, surchargeRevenue: number, pickupRevenue: number, deliveryRevenue: number, recoveryRevenue: number, transferRevenue: number, totalRevenue: number, totalWeight: number, numberOfOrders: number, numberOfPackages: number }> };

export type OrderReportBucketFragment = { __typename?: 'OrderReportBucketEntity', startDate: any, endDate: any, freightRevenue: number, fuelRevenue: number, lineHaulRevenue: number, specialRevenue: number, customChargeRevenue: number, surchargeRevenue: number, pickupRevenue: number, deliveryRevenue: number, recoveryRevenue: number, transferRevenue: number, totalRevenue: number, totalWeight: number, numberOfOrders: number, numberOfPackages: number };

export type OrderReportQueryVariables = Exact<{
  args: OrderReportArgs;
}>;


export type OrderReportQuery = { __typename?: 'Query', orderReport: Array<{ __typename?: 'OrderReportBucketEntity', startDate: any, endDate: any, freightRevenue: number, fuelRevenue: number, lineHaulRevenue: number, specialRevenue: number, customChargeRevenue: number, surchargeRevenue: number, pickupRevenue: number, deliveryRevenue: number, recoveryRevenue: number, transferRevenue: number, totalRevenue: number, totalWeight: number, numberOfOrders: number, numberOfPackages: number }> };

export type ReportGroupConfigurationFragment = { __typename?: 'ReportGroupConfigurationEntity', uuid: string, name: string, orderStatuses: Array<OrderStatus>, stopTypes: Array<PickupOrDelivery>, reportAggregationPeriod: ReportAggregationPeriod, defaultReportType: ReportType, reportRevenueType: ReportRevenueType, reportStatistics: Array<ReportStatistic>, lastNumberOfDays?: number | null, lastNumberOfWeeks?: number | null, lastNumberOfMonths?: number | null, startDate?: any | null, endDate?: any | null, contact?: { __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string } | null, contacts?: Array<{ __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string }> | null, driver?: { __typename?: 'DriverEntity', uuid: string, firstName: string, lastName: string } | null, drivers?: Array<{ __typename?: 'DriverEntity', uuid: string, firstName: string, lastName: string }> | null, terminal?: { __typename?: 'TerminalEntity', uuid: string, code: string } | null };

export type ReportGroupConfigurationsQueryVariables = Exact<{ [key: string]: never; }>;


export type ReportGroupConfigurationsQuery = { __typename?: 'Query', reportGroupConfigurations: Array<{ __typename?: 'ReportGroupConfigurationEntity', uuid: string, name: string, orderStatuses: Array<OrderStatus>, stopTypes: Array<PickupOrDelivery>, reportAggregationPeriod: ReportAggregationPeriod, defaultReportType: ReportType, reportRevenueType: ReportRevenueType, reportStatistics: Array<ReportStatistic>, lastNumberOfDays?: number | null, lastNumberOfWeeks?: number | null, lastNumberOfMonths?: number | null, startDate?: any | null, endDate?: any | null, contact?: { __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string } | null, contacts?: Array<{ __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string }> | null, driver?: { __typename?: 'DriverEntity', uuid: string, firstName: string, lastName: string } | null, drivers?: Array<{ __typename?: 'DriverEntity', uuid: string, firstName: string, lastName: string }> | null, terminal?: { __typename?: 'TerminalEntity', uuid: string, code: string } | null }> };

export type ReportSendJobBatchProgressFragment = { __typename?: 'ReportSendJobBatchProgressEntity', successCount: number, failCount: number, totalCount: number };

export type ReportSendJobBatchFragment = { __typename?: 'ReportSendJobBatchEntity', id: string, createdAt: any, reportSendJobBatchProgress: { __typename?: 'ReportSendJobBatchProgressEntity', successCount: number, failCount: number, totalCount: number }, reportSendJobs: Array<{ __typename?: 'ReportSendJobEntity', id: string, createdAt: any, reportType: AccountingReportTypeV2 }> };

export type ReportSendJobBatchesQueryVariables = Exact<{
  findReportSendJobBatchesInput: FindReportSendJobBatchesInput;
}>;


export type ReportSendJobBatchesQuery = { __typename?: 'Query', reportSendJobBatches: { __typename?: 'FindReportSendJobBatchesOutput', reportSendJobBatchConnection: { __typename?: 'ReportSendJobBatchConnection', totalCount?: number | null, edges: Array<{ __typename?: 'ReportSendJobBatchEdge', node: { __typename?: 'ReportSendJobBatchEntity', id: string, createdAt: any, reportSendJobBatchProgress: { __typename?: 'ReportSendJobBatchProgressEntity', successCount: number, failCount: number, totalCount: number }, reportSendJobs: Array<{ __typename?: 'ReportSendJobEntity', id: string, createdAt: any, reportType: AccountingReportTypeV2 }> } }>, pageInfo: { __typename?: 'PageInfo', startCursor?: string | null, endCursor?: string | null, hasNextPage: boolean, hasPreviousPage: boolean } } } };

export type ReportSendJobFragment = { __typename?: 'ReportSendJobEntity', id: string, reportType: AccountingReportTypeV2, reportSendJobError?: ReportSendJobError | null, contact: { __typename?: 'CustomerContactEntity', displayName: string } | { __typename?: 'ThirdPartyContactEntity', displayName: string }, emailTransaction?: { __typename?: 'EmailTransactionEntity', emailTransactionStatus: EmailTransactionStatus, emailTransactionLogs: Array<{ __typename?: 'EmailTransactionLogEntity', uuid: string, email: string, lastStatus?: EmailTransactionLogStatus | null, reason?: string | null }> } | null, document?: { __typename?: 'DocumentEntity', preSignedGetUrl: string } | null };

export type ReportSendJobsQueryVariables = Exact<{
  findReportSendJobsInput: FindReportSendJobsInput;
}>;


export type ReportSendJobsQuery = { __typename?: 'Query', reportSendJobs: { __typename?: 'FindReportSendJobsOutput', reportSendJobConnection: { __typename?: 'ReportSendJobConnection', totalCount?: number | null, edges: Array<{ __typename?: 'ReportSendJobEdge', node: { __typename?: 'ReportSendJobEntity', id: string, reportType: AccountingReportTypeV2, reportSendJobError?: ReportSendJobError | null, contact: { __typename?: 'CustomerContactEntity', displayName: string } | { __typename?: 'ThirdPartyContactEntity', displayName: string }, emailTransaction?: { __typename?: 'EmailTransactionEntity', emailTransactionStatus: EmailTransactionStatus, emailTransactionLogs: Array<{ __typename?: 'EmailTransactionLogEntity', uuid: string, email: string, lastStatus?: EmailTransactionLogStatus | null, reason?: string | null }> } | null, document?: { __typename?: 'DocumentEntity', preSignedGetUrl: string } | null } }>, pageInfo: { __typename?: 'PageInfo', startCursor?: string | null, endCursor?: string | null, hasNextPage: boolean, hasPreviousPage: boolean } } } };

export type SendAccountingReportsMutationVariables = Exact<{
  sendAccountingReportsInput: SendAccountingReportsInput;
}>;


export type SendAccountingReportsMutation = { __typename?: 'Mutation', sendAccountingReports: { __typename?: 'MutationErrorOutput', message: string } | { __typename?: 'SendAccountingReportsSuccessOutput', success: boolean } };

export type ServiceLevelReportBucketFragment = { __typename?: 'ServiceLevelReportBucketEntity', uuid: string, name: string, freightRevenue: number, fuelRevenue: number, lineHaulRevenue: number, specialRevenue: number, customChargeRevenue: number, surchargeRevenue: number, pickupRevenue: number, deliveryRevenue: number, recoveryRevenue: number, transferRevenue: number, totalRevenue: number, totalWeight: number, numberOfOrders: number, numberOfPackages: number };

export type ServiceLevelReportQueryVariables = Exact<{
  args: ServiceLevelReportArgs;
}>;


export type ServiceLevelReportQuery = { __typename?: 'Query', serviceLevelReport: Array<{ __typename?: 'ServiceLevelReportBucketEntity', uuid: string, name: string, freightRevenue: number, fuelRevenue: number, lineHaulRevenue: number, specialRevenue: number, customChargeRevenue: number, surchargeRevenue: number, pickupRevenue: number, deliveryRevenue: number, recoveryRevenue: number, transferRevenue: number, totalRevenue: number, totalWeight: number, numberOfOrders: number, numberOfPackages: number }> };

export type StationReportBucketFragment = { __typename?: 'StationReportBucketEntity', startDate: any, endDate: any, stationId?: string | null, stationName?: string | null, freightRevenue: number, fuelRevenue: number, lineHaulRevenue: number, specialRevenue: number, customChargeRevenue: number, surchargeRevenue: number, pickupRevenue: number, deliveryRevenue: number, recoveryRevenue: number, transferRevenue: number, totalRevenue: number, totalWeight: number, numberOfOrders: number, numberOfPackages: number };

export type StationReportQueryVariables = Exact<{
  args: StationReportArgs;
}>;


export type StationReportQuery = { __typename?: 'Query', stationReport: Array<{ __typename?: 'StationReportBucketEntity', startDate: any, endDate: any, stationId?: string | null, stationName?: string | null, freightRevenue: number, fuelRevenue: number, lineHaulRevenue: number, specialRevenue: number, customChargeRevenue: number, surchargeRevenue: number, pickupRevenue: number, deliveryRevenue: number, recoveryRevenue: number, transferRevenue: number, totalRevenue: number, totalWeight: number, numberOfOrders: number, numberOfPackages: number }> };

export type TerminalReportBucketFragment = { __typename?: 'TerminalReportBucketEntity', uuid: string, name: string, code: string, freightRevenue: number, fuelRevenue: number, lineHaulRevenue: number, specialRevenue: number, customChargeRevenue: number, surchargeRevenue: number, pickupRevenue: number, deliveryRevenue: number, recoveryRevenue: number, transferRevenue: number, totalRevenue: number, totalWeight: number, numberOfOrders: number, numberOfPackages: number };

export type TerminalReportQueryVariables = Exact<{
  args: TerminalReportArgs;
}>;


export type TerminalReportQuery = { __typename?: 'Query', terminalReport: Array<{ __typename?: 'TerminalReportBucketEntity', uuid: string, name: string, code: string, freightRevenue: number, fuelRevenue: number, lineHaulRevenue: number, specialRevenue: number, customChargeRevenue: number, surchargeRevenue: number, pickupRevenue: number, deliveryRevenue: number, recoveryRevenue: number, transferRevenue: number, totalRevenue: number, totalWeight: number, numberOfOrders: number, numberOfPackages: number }> };

export type UpdateReportGroupConfigurationMutationVariables = Exact<{
  updateReportGroupConfigurationInput: ReportGroupConfigurationUpdateInput;
}>;


export type UpdateReportGroupConfigurationMutation = { __typename?: 'Mutation', updateReportGroupConfiguration: { __typename?: 'ReportGroupConfigurationEntity', uuid: string, name: string, orderStatuses: Array<OrderStatus>, stopTypes: Array<PickupOrDelivery>, reportAggregationPeriod: ReportAggregationPeriod, defaultReportType: ReportType, reportRevenueType: ReportRevenueType, reportStatistics: Array<ReportStatistic>, lastNumberOfDays?: number | null, lastNumberOfWeeks?: number | null, lastNumberOfMonths?: number | null, startDate?: any | null, endDate?: any | null, contact?: { __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string } | null, contacts?: Array<{ __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string }> | null, driver?: { __typename?: 'DriverEntity', uuid: string, firstName: string, lastName: string } | null, drivers?: Array<{ __typename?: 'DriverEntity', uuid: string, firstName: string, lastName: string }> | null, terminal?: { __typename?: 'TerminalEntity', uuid: string, code: string } | null } };

export type AppointmentOptionsQueryVariables = Exact<{
  input: AppointmentOptionsInput;
}>;


export type AppointmentOptionsQuery = { __typename?: 'Query', appointmentOptions: { __typename?: 'AppointmentOptions', appointmentExists: boolean, rescheduleRequested: boolean, message?: string | null, pageSize: number, options: Array<{ __typename?: 'AppointmentOption', humanDate: string, date: { __typename?: 'PlainDate', year: number, month: number, day: number }, startTime: { __typename?: 'PlainTime', hour: number, minute: number }, endTime: { __typename?: 'PlainTime', hour: number, minute: number } }> } };

export type ChooseAppointmentOptionMutationVariables = Exact<{
  input: ChooseAppointmentOptionInput;
}>;


export type ChooseAppointmentOptionMutation = { __typename?: 'Mutation', chooseAppointmentOption: { __typename: 'ChooseAppointmentOptionSuccessOutput', appointmentDateTime?: string | null } | { __typename: 'MutationErrorOutput', message: string } };

export type QueueAppointmentSchedulingProposalsMutationVariables = Exact<{
  input: QueueAppointmentSchedulingProposalsInput;
}>;


export type QueueAppointmentSchedulingProposalsMutation = { __typename?: 'Mutation', queueAppointmentSchedulingProposals: { __typename: 'MutationErrorOutput', message: string } | { __typename: 'QueueAppointmentSchedulingProposalsSuccessOutput', stopUuids: Array<string>, errorMessages: Array<string> } };

export type AddUserToRoleMutationVariables = Exact<{
  addUserToRoleInput: AddUserToRoleInput;
}>;


export type AddUserToRoleMutation = { __typename?: 'Mutation', addUserToRole: { __typename?: 'AddUserToRoleOutput', success: boolean } };

export type CreateRoleMutationVariables = Exact<{
  createRoleInput: CreateRoleInput;
}>;


export type CreateRoleMutation = { __typename?: 'Mutation', createRole: { __typename?: 'CreateRoleOutput', role: { __typename?: 'RoleEntity', uuid: string } } };

export type FindRoleUserFragment = { __typename?: 'UserEntity', uuid: string, email: string };

export type FindRoleFragment = { __typename?: 'RoleEntity', uuid: string, name: string, permissions: Array<{ __typename?: 'PermissionEntity', uuid: string, permissionResource: PermissionResource, accessLevel: AccessLevel }>, users: Array<{ __typename?: 'UserEntity', uuid: string, email: string }> };

export type FindRolePermissionFragment = { __typename?: 'PermissionEntity', uuid: string, permissionResource: PermissionResource, accessLevel: AccessLevel };

export type RoleQueryVariables = Exact<{
  findRoleInput: FindRoleInput;
}>;


export type RoleQuery = { __typename?: 'Query', role: { __typename?: 'FindRoleOutput', role: { __typename?: 'RoleEntity', uuid: string, name: string, permissions: Array<{ __typename?: 'PermissionEntity', uuid: string, permissionResource: PermissionResource, accessLevel: AccessLevel }>, users: Array<{ __typename?: 'UserEntity', uuid: string, email: string }> } } };

export type FindRolesFragment = { __typename?: 'RoleEntity', uuid: string, name: string, isInternalRole: boolean };

export type RolesQueryVariables = Exact<{
  findRolesInput?: InputMaybe<FindRolesInput>;
}>;


export type RolesQuery = { __typename?: 'Query', roles: { __typename?: 'FindRolesOutput', roles: Array<{ __typename?: 'RoleEntity', uuid: string, name: string, isInternalRole: boolean }> } };

export type RemoveUserFromRoleMutationVariables = Exact<{
  removeUserFromRoleInput: RemoveUserFromRoleInput;
}>;


export type RemoveUserFromRoleMutation = { __typename?: 'Mutation', removeUserFromRole: { __typename?: 'RemoveUserFromRoleOutput', success: boolean } };

export type UpdateRoleMutationVariables = Exact<{
  updateRoleInput: UpdateRoleInput;
}>;


export type UpdateRoleMutation = { __typename?: 'Mutation', updateRole: { __typename?: 'UpdateRoleOutput', success: boolean } };

export type UsersForRoleFragment = { __typename?: 'UserEntity', uuid: string, email: string, phoneNumber?: string | null, name?: string | null };

export type UsersForRoleQueryVariables = Exact<{ [key: string]: never; }>;


export type UsersForRoleQuery = { __typename?: 'Query', users: Array<{ __typename?: 'UserEntity', uuid: string, email: string, phoneNumber?: string | null, name?: string | null }> };

export type CreateShipmentDocumentMutationVariables = Exact<{
  createShipmentDocumentInput: CreateShipmentDocumentInput;
}>;


export type CreateShipmentDocumentMutation = { __typename?: 'Mutation', createShipmentDocument: { __typename?: 'DocumentEntity', uuid: string, fileName: string, bucket: string, region: string, key: string, uploadedAt?: any | null, fileType: string, isDeleted: boolean, preSignedGetUrl: string, name?: string | null, type: DocumentType, pageNumber?: number | null, createdAt: any, notes?: string | null, order?: { __typename?: 'StandardOrderEntity', uuid: string, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', shipperBillOfLadingNumber?: string | null } } | null, shipment?: { __typename?: 'StandardOrderEntity', uuid: string } | null, driverFormTemplate?: { __typename?: 'DriverSignableFormTemplateEntity', uuid: string, title: string, formText: string } | null } };

export type CompleteStopBulkMutationVariables = Exact<{
  completeStopBulkInput: CompleteStopBulkInput;
}>;


export type CompleteStopBulkMutation = { __typename?: 'Mutation', completeStopBulk: Array<{ __typename: 'StandardStopEntity', stopType?: StopType | null, standardStopType?: StandardStopType | null, inboundMethod?: InboundMethod | null, outboundMethod?: OutboundMethod | null, notes?: string | null, isSpecial?: boolean | null, proofOfDeliverySignee?: string | null, status: StopStatus, sentToAgentAt?: any | null, confirmedByAgentAt?: any | null, appointmentTextStatus?: AppointmentTextStatus | null, specialInstructions?: string | null, paperworkMarkedComplete?: boolean | null, showDriverModifiedAt?: any | null, routeChangeAcknowledged: boolean, serviceDate?: any | null, overrideServiceTimeInMinutes?: number | null, completedAt?: any | null, uuid: string, appointmentTime?: any | null, endAppointmentTime?: any | null, routeSlot?: { __typename?: 'RouteSlotEntity', uuid: string, ordinal: number, route?: { __typename?: 'RouteEntity', uuid: string, name: string } | null } | null, stopDetails?: { __typename?: 'StopDetailsOutput', stopDetailsStatus: StopDetailsStatus, message?: string | null } | null, cachedEta?: { __typename?: 'EtaEntity', arrivalTime: any, finishTime: any } | null, contactPerson?: { __typename?: 'ContactPersonEntity', firstName?: string | null, lastName?: string | null, phone?: string | null } | null, address: { __typename?: 'AddressEntity', uuid: string, name: string, line1: string, line2?: string | null, city: string, state: string, zip: string, country: string, latitude?: number | null, longitude?: number | null, driverInstructions?: string | null, receivingHoursStart?: any | null, receivingHoursEnd?: any | null, specialInstructions?: string | null }, shipment?: { __typename?: 'StandardShipmentEntity', uuid: string, hasSignedPOD: boolean, shipmentType: ShipmentType, standardShipmentFields: { __typename?: 'StandardShipmentFieldsEntity', uuid: string, deliveryDate?: any | null, pickupOrDelivery: PickupOrDelivery, deadlineDate?: any | null, deadlineType?: DeadlineType | null }, order?: { __typename?: 'StandardOrderEntity', uuid: string, refusedBy?: string | null, isCollectOnDelivery?: boolean | null, orderSegmentType: OrderSegmentType, fulfillmentType?: FulfillmentType | null, detailedStatusV2?: OrderDetailedStatus | null, hazmat?: boolean | null, name: string, refNumbers: Array<string>, dateMarkedOnHand?: any | null, totalCharge: number, startStop?: { __typename?: 'StandardStopEntity', terminal?: { __typename?: 'TerminalEntity', name: string } | null } | null, endStop?: { __typename?: 'StandardStopEntity', terminal?: { __typename?: 'TerminalEntity', name: string } | null } | null, tags: Array<{ __typename?: 'TagEntity', uuid: string, value: string, color?: string | null }>, service?: { __typename?: 'ServiceEntity', uuid: string, name: string, timeInMinutes?: number | null } | null, orderComments: Array<{ __typename?: 'OrderCommentEntity', comment: string }>, shipments: Array<{ __typename?: 'StandardShipmentEntity', shipmentType: ShipmentType, uuid: string, standardShipmentFields: { __typename?: 'StandardShipmentFieldsEntity', pickupOrDelivery: PickupOrDelivery }, airportInfo?: { __typename?: 'AirportInfoEntity', address: { __typename?: 'AddressEntity', name: string } } | null, legs: Array<{ __typename?: 'LegEntity', endStop: { __typename?: 'StandardStopEntity', stopType?: StopType | null, incomingCarrier?: string | null, inboundMethod?: InboundMethod | null, address: { __typename?: 'AddressEntity', name: string }, terminal?: { __typename?: 'TerminalEntity', name: string } | null } }> }>, packages: Array<{ __typename?: 'PackageEntity', uuid: string, description: string, weight?: number | null, quantity: number, length?: number | null, width?: number | null, height?: number | null, type?: PackageType | null, packageSpec?: { __typename?: 'PackageSpecEntity', id: string, name: string } | null, warehouseLocation?: { __typename?: 'WarehouseLocationEntity', name: string } | null }>, billingPartyContact: { __typename?: 'CustomerContactEntity', displayName: string, businessDivision?: { __typename?: 'BusinessDivisionEntity', name: string } | null }, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', shipperBillOfLadingNumber?: string | null, masterAirwayBillOfLadingNumber?: string | null, measurementUnits: MeasurementUnits }, inboundPaperwork: { __typename?: 'OrderPaperworkEntity', paperworkComplete: boolean, attachedDocuments?: Array<DocumentType> | null, missingDocuments?: Array<DocumentType> | null, alerts?: Array<DocumentType> | null, proofOfDeliveryOrPickupReadyToSign?: Array<DocumentType> | null, proofOfDeliveryOrPickupSigned?: Array<DocumentType> | null, photos?: Array<DocumentType> | null, other?: Array<DocumentType> | null }, outboundPaperwork: { __typename?: 'OrderPaperworkEntity', paperworkComplete: boolean, attachedDocuments?: Array<DocumentType> | null, missingDocuments?: Array<DocumentType> | null, alerts?: Array<DocumentType> | null, proofOfDeliveryOrPickupReadyToSign?: Array<DocumentType> | null, proofOfDeliveryOrPickupSigned?: Array<DocumentType> | null, photos?: Array<DocumentType> | null, other?: Array<DocumentType> | null } } | null } | null }> };

export type CompleteStopV2MutationVariables = Exact<{
  completeStopInput: CompleteStopInput;
}>;


export type CompleteStopV2Mutation = { __typename?: 'Mutation', completeStopV2: { __typename?: 'CompleteStopEntity', uuid: string } | { __typename?: 'CompleteStopInvalidInputException', message: string } };

export type DeleteDocumentMutationVariables = Exact<{
  uuid: Scalars['String']['input'];
}>;


export type DeleteDocumentMutation = { __typename?: 'Mutation', deleteDocument?: { __typename?: 'DocumentEntity', uuid: string } | null };

export type GenerateShipmentPreSignedPutUrlMutationVariables = Exact<{
  generateShipmentPreSignedPutUrlInput: GenerateShipmentPreSignedPutUrlInput;
}>;


export type GenerateShipmentPreSignedPutUrlMutation = { __typename?: 'Mutation', generateShipmentPreSignedPutUrl: string };

export type MarkStopAsFailedMutationVariables = Exact<{
  uuid: Scalars['String']['input'];
}>;


export type MarkStopAsFailedMutation = { __typename?: 'Mutation', markStopAsFailed: { __typename?: 'StandardStopEntity', uuid: string } };

export type MarkStopAsFailedV2MutationVariables = Exact<{
  markStopAsFailedV2Input: MarkStopAsFailedV2Input;
}>;


export type MarkStopAsFailedV2Mutation = { __typename?: 'Mutation', markStopAsFailedV2: { __typename?: 'StandardStopEntity', uuid: string } };

export type NameOfRouteQueryVariables = Exact<{
  uuid: Scalars['String']['input'];
}>;


export type NameOfRouteQuery = { __typename?: 'Query', route: { __typename?: 'RouteEntity', uuid: string, name: string } };

export type EquipmentsFetchQueryVariables = Exact<{
  equipmentTypes?: InputMaybe<Array<EquipmentType> | EquipmentType>;
}>;


export type EquipmentsFetchQuery = { __typename?: 'Query', equipments: Array<{ __typename?: 'EquipmentEntity', uuid: string, name: string }> };

export type RouteQueryVariables = Exact<{
  uuid: Scalars['String']['input'];
}>;


export type RouteQuery = { __typename?: 'Query', route: { __typename?: 'RouteEntity', createdAt: any, date: any, uuid: string, defaultStartTime?: any | null, totalTimeInSeconds?: number | null, totalDistanceInMeters?: number | null, startLoadTimeInMinutes?: number | null, endLoadTimeInMinutes?: number | null, locked: boolean, nameManuallyChanged: boolean, name: string, numberOfRescheduled?: number | null, routeSlotsUpdatedAt?: any | null, lastDispatched?: any | null, terminal?: { __typename?: 'TerminalEntity', uuid: string } | null, routeInfo: { __typename?: 'RouteInfo', totalStops: number, totalStopsArrived: number, totalStopsNotArrived: number, totalStopsCompleted: number, totalStopsCancelled: number, totalStopsFailed: number, status: RouteStatus, pieceCount: number, totalWeight: number, totalStopsSentToAgent: number, totalStopsConfirmedByAgent: number }, helpers: Array<{ __typename?: 'DriverEntity', firstName: string, lastName: string, uuid: string, phoneNumber: string, driverReferenceNumber?: string | null }>, equipments: Array<{ __typename?: 'EquipmentEntity', uuid: string, name: string, type: EquipmentType, vehicleType?: { __typename?: 'VehicleTypeEntity', uuid: string, name: string, status: VehicleTypeStatus, maxVolume?: any | null, maxWeight?: any | null, capacityNotes?: string | null, vehicleTypePackageSpecs: Array<{ __typename?: 'VehicleTypePackageSpecEntity', id: string, maxQuantity?: number | null, packageSpec: { __typename?: 'PackageSpecEntity', id: string, name: string } }> } | null }>, tags: Array<{ __typename?: 'TagEntity', uuid: string, value: string, color?: string | null }>, drivers: Array<{ __typename?: 'DriverEntity', uuid: string, firstName: string, lastName: string, phoneNumber: string, driverReferenceNumber?: string | null, agentId?: string | null, terminal?: { __typename?: 'TerminalEntity', uuid: string, name: string } | null }>, slots: Array<{ __typename?: 'RouteSlotEntity', uuid: string, stops: Array<{ __typename: 'StandardStopEntity', stopType?: StopType | null, standardStopType?: StandardStopType | null, inboundMethod?: InboundMethod | null, outboundMethod?: OutboundMethod | null, notes?: string | null, isSpecial?: boolean | null, proofOfDeliverySignee?: string | null, status: StopStatus, sentToAgentAt?: any | null, confirmedByAgentAt?: any | null, appointmentTextStatus?: AppointmentTextStatus | null, specialInstructions?: string | null, paperworkMarkedComplete?: boolean | null, showDriverModifiedAt?: any | null, routeChangeAcknowledged: boolean, serviceDate?: any | null, overrideServiceTimeInMinutes?: number | null, completedAt?: any | null, uuid: string, appointmentTime?: any | null, endAppointmentTime?: any | null, routeSlot?: { __typename?: 'RouteSlotEntity', uuid: string, ordinal: number, route?: { __typename?: 'RouteEntity', uuid: string, name: string } | null } | null, stopDetails?: { __typename?: 'StopDetailsOutput', stopDetailsStatus: StopDetailsStatus, message?: string | null } | null, cachedEta?: { __typename?: 'EtaEntity', arrivalTime: any, finishTime: any } | null, contactPerson?: { __typename?: 'ContactPersonEntity', firstName?: string | null, lastName?: string | null, phone?: string | null } | null, address: { __typename?: 'AddressEntity', uuid: string, name: string, line1: string, line2?: string | null, city: string, state: string, zip: string, country: string, latitude?: number | null, longitude?: number | null, driverInstructions?: string | null, receivingHoursStart?: any | null, receivingHoursEnd?: any | null, specialInstructions?: string | null }, shipment?: { __typename?: 'StandardShipmentEntity', uuid: string, hasSignedPOD: boolean, shipmentType: ShipmentType, standardShipmentFields: { __typename?: 'StandardShipmentFieldsEntity', uuid: string, deliveryDate?: any | null, pickupOrDelivery: PickupOrDelivery, deadlineDate?: any | null, deadlineType?: DeadlineType | null }, order?: { __typename?: 'StandardOrderEntity', uuid: string, refusedBy?: string | null, isCollectOnDelivery?: boolean | null, orderSegmentType: OrderSegmentType, fulfillmentType?: FulfillmentType | null, detailedStatusV2?: OrderDetailedStatus | null, hazmat?: boolean | null, name: string, refNumbers: Array<string>, dateMarkedOnHand?: any | null, totalCharge: number, startStop?: { __typename?: 'StandardStopEntity', terminal?: { __typename?: 'TerminalEntity', name: string } | null } | null, endStop?: { __typename?: 'StandardStopEntity', terminal?: { __typename?: 'TerminalEntity', name: string } | null } | null, tags: Array<{ __typename?: 'TagEntity', uuid: string, value: string, color?: string | null }>, service?: { __typename?: 'ServiceEntity', uuid: string, name: string, timeInMinutes?: number | null } | null, orderComments: Array<{ __typename?: 'OrderCommentEntity', comment: string }>, shipments: Array<{ __typename?: 'StandardShipmentEntity', shipmentType: ShipmentType, uuid: string, standardShipmentFields: { __typename?: 'StandardShipmentFieldsEntity', pickupOrDelivery: PickupOrDelivery }, airportInfo?: { __typename?: 'AirportInfoEntity', address: { __typename?: 'AddressEntity', name: string } } | null, legs: Array<{ __typename?: 'LegEntity', endStop: { __typename?: 'StandardStopEntity', stopType?: StopType | null, incomingCarrier?: string | null, inboundMethod?: InboundMethod | null, address: { __typename?: 'AddressEntity', name: string }, terminal?: { __typename?: 'TerminalEntity', name: string } | null } }> }>, packages: Array<{ __typename?: 'PackageEntity', uuid: string, description: string, weight?: number | null, quantity: number, length?: number | null, width?: number | null, height?: number | null, type?: PackageType | null, packageSpec?: { __typename?: 'PackageSpecEntity', id: string, name: string } | null, warehouseLocation?: { __typename?: 'WarehouseLocationEntity', name: string } | null }>, billingPartyContact: { __typename?: 'CustomerContactEntity', displayName: string, businessDivision?: { __typename?: 'BusinessDivisionEntity', name: string } | null }, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', shipperBillOfLadingNumber?: string | null, masterAirwayBillOfLadingNumber?: string | null, measurementUnits: MeasurementUnits }, inboundPaperwork: { __typename?: 'OrderPaperworkEntity', paperworkComplete: boolean, attachedDocuments?: Array<DocumentType> | null, missingDocuments?: Array<DocumentType> | null, alerts?: Array<DocumentType> | null, proofOfDeliveryOrPickupReadyToSign?: Array<DocumentType> | null, proofOfDeliveryOrPickupSigned?: Array<DocumentType> | null, photos?: Array<DocumentType> | null, other?: Array<DocumentType> | null }, outboundPaperwork: { __typename?: 'OrderPaperworkEntity', paperworkComplete: boolean, attachedDocuments?: Array<DocumentType> | null, missingDocuments?: Array<DocumentType> | null, alerts?: Array<DocumentType> | null, proofOfDeliveryOrPickupReadyToSign?: Array<DocumentType> | null, proofOfDeliveryOrPickupSigned?: Array<DocumentType> | null, photos?: Array<DocumentType> | null, other?: Array<DocumentType> | null } } | null } | null }> }> } };

export type ShallowRoutesQueryVariables = Exact<{
  date: Scalars['DateTime']['input'];
}>;


export type ShallowRoutesQuery = { __typename?: 'Query', routes: Array<{ __typename?: 'RouteEntity', uuid: string, name: string, date: any, startTime?: any | null, drivers: Array<{ __typename?: 'DriverEntity', firstName: string, lastName: string }>, slots: Array<{ __typename?: 'RouteSlotEntity', uuid: string, stops: Array<{ __typename?: 'StandardStopEntity', uuid: string, status: StopStatus, address: { __typename?: 'AddressEntity', city: string } }> }> }> };

export type UpdateServiceDateForAssignedStopsMutationVariables = Exact<{
  updateServiceDateForAssignedStopsInput: UpdateServiceDateForAssignedStopsInput;
}>;


export type UpdateServiceDateForAssignedStopsMutation = { __typename?: 'Mutation', updateServiceDateForAssignedStops: Array<{ __typename?: 'RouteEntity', uuid: string }> };

export type UpdateStopMutationVariables = Exact<{
  updateStopInput: UpdateStopInput;
}>;


export type UpdateStopMutation = { __typename?: 'Mutation', updateStop: { __typename?: 'StandardStopEntity', uuid: string, contactPerson?: { __typename?: 'ContactPersonEntity', uuid: string, phone?: string | null } | null } };

export type UpdateStopsMutationVariables = Exact<{
  updateStopsInput: UpdateStopsInput;
}>;


export type UpdateStopsMutation = { __typename?: 'Mutation', updateStops: Array<{ __typename?: 'StandardStopEntity', uuid: string }> };

export type SamaraOAuthAuthorizeUrlQueryVariables = Exact<{ [key: string]: never; }>;


export type SamaraOAuthAuthorizeUrlQuery = { __typename?: 'Query', samaraOAuthAuthorizeUrl: string };

export type SamsaraOAuthTokenQueryVariables = Exact<{ [key: string]: never; }>;


export type SamsaraOAuthTokenQuery = { __typename?: 'Query', samsaraOAuthToken?: { __typename?: 'SamsaraOauthTokenEntity', uuid: string } | null };

export type CreateSavedFilterViewMutationVariables = Exact<{
  createSavedFilterViewInput: CreateSavedFilterViewInput;
}>;


export type CreateSavedFilterViewMutation = { __typename?: 'Mutation', createSavedFilterView: { __typename?: 'SavedFilterViewEntity', uuid: string } };

export type DeleteSavedFilterViewMutationVariables = Exact<{
  uuid: Scalars['String']['input'];
}>;


export type DeleteSavedFilterViewMutation = { __typename?: 'Mutation', deleteSavedFilterView: { __typename?: 'SavedFilterViewEntity', uuid: string } };

export type GetSavedFilterViewsQueryVariables = Exact<{
  pageType: Scalars['String']['input'];
}>;


export type GetSavedFilterViewsQuery = { __typename?: 'Query', getSavedFilterViews: Array<{ __typename?: 'SavedFilterViewEntity', uuid: string, displayName: string, isShared: boolean, filterModelJson: string, filterModelJsonV2?: any | null, sortModelJson?: any | null, orderTableFields: Array<OrderTableField>, dispatchTableFields: Array<DispatchTableField>, user: { __typename?: 'UserEntity', uuid: string } }> };

export type SavedFilterViewFragment = { __typename?: 'SavedFilterViewEntity', uuid: string, displayName: string, isShared: boolean, filterModelJson: string, filterModelJsonV2?: any | null, sortModelJson?: any | null, orderTableFields: Array<OrderTableField>, dispatchTableFields: Array<DispatchTableField>, user: { __typename?: 'UserEntity', uuid: string } };

export type UpdateSavedFilterViewMutationVariables = Exact<{
  updateSavedFilterViewInput: UpdateSavedFilterViewInput;
}>;


export type UpdateSavedFilterViewMutation = { __typename?: 'Mutation', updateSavedFilterView: { __typename?: 'SavedFilterViewEntity', uuid: string } };

export type ScannedOrderResultPageFragmentFragment = { __typename?: 'ScannedOrderResultPageEntity', uuid: string, bucket: string, key: string, page: number, preSignedGetUrl: string };

export type ScannedOrderResultFragmentFragment = { __typename?: 'ScannedOrderResultEntity', uuid: string, filename: string, pageEnd: number, pageStart: number, status: ScannedOrderResultStatus, type: ScannedOrderResultType, failureReason?: ScannedOrderFailureReason | null, signedPodMatchStatus?: SignedPodMatchStatus | null, scannedOrder: { __typename?: 'ScannedOrderEntity', uuid: string, bucket: string, failureReason?: ScannedOrderFailureReason | null, filename: string, key: string, preSignedGetUrl: string, retryCount: number, status: ScannedOrderStatus }, scannedOrderResultPages: Array<{ __typename?: 'ScannedOrderResultPageEntity', page: number, preSignedGetUrl: string }> };

export type ScannedOrderResultQueryVariables = Exact<{
  uuid: Scalars['String']['input'];
}>;


export type ScannedOrderResultQuery = { __typename?: 'Query', numberOfScannedOrderResultsInReview: number, scannedOrderResult?: { __typename?: 'ScannedOrderResultEntity', uuid: string, filename: string, pageEnd: number, pageStart: number, status: ScannedOrderResultStatus, type: ScannedOrderResultType, failureReason?: ScannedOrderFailureReason | null, signedPodMatchStatus?: SignedPodMatchStatus | null, scannedOrder: { __typename?: 'ScannedOrderEntity', uuid: string, preSignedGetUrl: string, bucket: string, failureReason?: ScannedOrderFailureReason | null, filename: string, key: string, retryCount: number, status: ScannedOrderStatus }, scannedOrderResultDocuments: Array<{ __typename?: 'ScannedOrderResultDocumentEntity', uuid: string, filename: string, preSignedGetUrl: string, scannedDocumentType: ScannedDocumentType, scannedOrderResultDocumentPages: Array<{ __typename?: 'ScannedOrderResultDocumentPageEntity', uuid: string, bucket: string, key: string, page: number, preSignedGetUrl: string }> }>, scannedOrderResultPages: Array<{ __typename?: 'ScannedOrderResultPageEntity', page: number, preSignedGetUrl: string, uuid: string, bucket: string, key: string }>, nextScannedOrderResultInReview?: { __typename?: 'ScannedOrderResultEntity', uuid: string, filename: string, pageEnd: number, pageStart: number, status: ScannedOrderResultStatus, type: ScannedOrderResultType, failureReason?: ScannedOrderFailureReason | null, signedPodMatchStatus?: SignedPodMatchStatus | null, order?: { __typename?: 'StandardOrderEntity', uuid: string } | null, scannedOrder: { __typename?: 'ScannedOrderEntity', uuid: string, bucket: string, failureReason?: ScannedOrderFailureReason | null, filename: string, key: string, preSignedGetUrl: string, retryCount: number, status: ScannedOrderStatus }, scannedOrderResultPages: Array<{ __typename?: 'ScannedOrderResultPageEntity', page: number, preSignedGetUrl: string }> } | null } | null };

export type FirstScannedOrderResultInReviewQueryVariables = Exact<{ [key: string]: never; }>;


export type FirstScannedOrderResultInReviewQuery = { __typename?: 'Query', firstScannedOrderResultInReview?: { __typename?: 'ScannedOrderResultEntity', uuid: string, order?: { __typename?: 'StandardOrderEntity', uuid: string } | null } | null };

export type ScannedOrderResultWithOrdersFragment = { __typename?: 'ScannedOrderResultEntity', uuid: string, createdAt: any, status: ScannedOrderResultStatus, signedPodMatchStatus?: SignedPodMatchStatus | null, failureReason?: ScannedOrderFailureReason | null, filename: string, pageEnd: number, pageStart: number, duplicateOrder?: { __typename?: 'StandardOrderEntity', uuid: string, source: OrderSource } | null, duplicateScannedOrderResultOrder?: { __typename?: 'StandardOrderEntity', uuid: string, source: OrderSource } | null, order?: { __typename?: 'StandardOrderEntity', uuid: string, name: string, billingPartyContact: { __typename?: 'CustomerContactEntity', uuid: string, displayName: string }, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', shipperBillOfLadingNumber?: string | null } } | null, podOrder?: { __typename?: 'StandardOrderEntity', uuid: string, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', shipperBillOfLadingNumber?: string | null } } | null };

export type ScannedOrderResultsQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  approvedAtAfter?: InputMaybe<Scalars['DateTime']['input']>;
  createdAtAfter?: InputMaybe<Scalars['DateTime']['input']>;
  rejectedAtAfter?: InputMaybe<Scalars['DateTime']['input']>;
  searchText?: InputMaybe<Scalars['String']['input']>;
  type: ScannedOrderResultType;
  statuses?: InputMaybe<Array<ScannedOrderResultStatus> | ScannedOrderResultStatus>;
  signedPodMatchStatuses?: InputMaybe<Array<SignedPodMatchStatus> | SignedPodMatchStatus>;
  sourceFilter?: InputMaybe<ScannedOrderResultSourceFilter>;
  failureReasonFilter?: InputMaybe<ScannedOrderFailureReason>;
}>;


export type ScannedOrderResultsQuery = { __typename?: 'Query', numberOfScannedOrderResultDuplicates: number, numberOfScannedOrderResultsInProgress: number, numberOfScannedOrderResultsInReview: number, numberOfScannedOrderResultsFailed: number, numberOfScannedOrderResultsRejected: number, numberOfScannedOrderResultsApproved: number, scannedOrderResults: { __typename?: 'ScannedOrderResultConnection', edges: Array<{ __typename?: 'ScannedOrderResultEdge', node: { __typename?: 'ScannedOrderResultEntity', uuid: string, createdAt: any, status: ScannedOrderResultStatus, signedPodMatchStatus?: SignedPodMatchStatus | null, failureReason?: ScannedOrderFailureReason | null, filename: string, pageEnd: number, pageStart: number, duplicateOrder?: { __typename?: 'StandardOrderEntity', uuid: string, source: OrderSource } | null, duplicateScannedOrderResultOrder?: { __typename?: 'StandardOrderEntity', uuid: string, source: OrderSource } | null, order?: { __typename?: 'StandardOrderEntity', uuid: string, name: string, billingPartyContact: { __typename?: 'CustomerContactEntity', uuid: string, displayName: string }, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', shipperBillOfLadingNumber?: string | null } } | null, podOrder?: { __typename?: 'StandardOrderEntity', uuid: string, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', shipperBillOfLadingNumber?: string | null } } | null } }>, pageInfo: { __typename?: 'PageInfo', startCursor?: string | null, endCursor?: string | null, hasNextPage: boolean, hasPreviousPage: boolean } } };

export type ScannedOrderFragmentFragment = { __typename?: 'ScannedOrderEntity', uuid: string, bucket: string, failureReason?: ScannedOrderFailureReason | null, filename: string, key: string, preSignedGetUrl: string, retryCount: number, status: ScannedOrderStatus, s3Url: string };

export type UpdateScannedOrderResultStatusMutationVariables = Exact<{
  updateScannedOrderResultStatusInput: UpdateScannedOrderResultStatusInput;
}>;


export type UpdateScannedOrderResultStatusMutation = { __typename?: 'Mutation', updateScannedOrderResultStatus: { __typename?: 'ScannedOrderResultEntity', uuid: string } };

export type AllSchedulingRegionFieldsFragment = { __typename?: 'SchedulingRegionEntity', id: string, name: string, dailyCapacityPieces?: number | null, dailyCapacityStops?: number | null, dailyCapacityWeight?: any | null, isArchived: boolean, zones: Array<{ __typename?: 'SchedulingZoneEntity', id: string, name: string, isArchived: boolean, availabilities: Array<{ __typename?: 'SchedulingZoneAvailabilityEntity', id: string, dayOfWeek: DayOfWeekAll, start: { __typename?: 'PlainTime', hour: number, minute: number }, end: { __typename?: 'PlainTime', hour: number, minute: number } }>, locations: Array<{ __typename?: 'SchedulingZoneLocationEntity', id: string, zipcode: string, city: string }> }> };

export type AllSchedulingZoneFieldsFragment = { __typename?: 'SchedulingZoneEntity', id: string, name: string, isArchived: boolean, availabilities: Array<{ __typename?: 'SchedulingZoneAvailabilityEntity', id: string, dayOfWeek: DayOfWeekAll, start: { __typename?: 'PlainTime', hour: number, minute: number }, end: { __typename?: 'PlainTime', hour: number, minute: number } }>, locations: Array<{ __typename?: 'SchedulingZoneLocationEntity', id: string, zipcode: string, city: string }> };

export type ArchiveSchedulingRegionMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type ArchiveSchedulingRegionMutation = { __typename?: 'Mutation', archiveSchedulingRegion: { __typename: 'MutationErrorOutput', message: string } | { __typename: 'UpdateSchedulingRegionSuccessOutput', schedulingRegion: { __typename?: 'SchedulingRegionEntity', id: string, name: string, dailyCapacityPieces?: number | null, dailyCapacityStops?: number | null, dailyCapacityWeight?: any | null, isArchived: boolean, zones: Array<{ __typename?: 'SchedulingZoneEntity', id: string, name: string, isArchived: boolean, availabilities: Array<{ __typename?: 'SchedulingZoneAvailabilityEntity', id: string, dayOfWeek: DayOfWeekAll, start: { __typename?: 'PlainTime', hour: number, minute: number }, end: { __typename?: 'PlainTime', hour: number, minute: number } }>, locations: Array<{ __typename?: 'SchedulingZoneLocationEntity', id: string, zipcode: string, city: string }> }> } } };

export type CreateSchedulingRegionMutationVariables = Exact<{
  input: CreateSchedulingRegionInput;
}>;


export type CreateSchedulingRegionMutation = { __typename?: 'Mutation', createSchedulingRegion: { __typename: 'CreateSchedulingRegionSuccessOutput', schedulingRegion: { __typename?: 'SchedulingRegionEntity', id: string } } | { __typename: 'MutationErrorOutput', message: string } };

export type CreateSchedulingZoneMutationVariables = Exact<{
  input: CreateSchedulingZoneInput;
}>;


export type CreateSchedulingZoneMutation = { __typename?: 'Mutation', createSchedulingZone: { __typename: 'CreateSchedulingZoneSuccessOutput', schedulingZone: { __typename?: 'SchedulingZoneEntity', id: string } } | { __typename: 'MutationErrorOutput', message: string } };

export type RestoreSchedulingRegionMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type RestoreSchedulingRegionMutation = { __typename?: 'Mutation', restoreSchedulingRegion: { __typename: 'MutationErrorOutput', message: string } | { __typename: 'UpdateSchedulingRegionSuccessOutput', schedulingRegion: { __typename?: 'SchedulingRegionEntity', id: string, name: string, dailyCapacityPieces?: number | null, dailyCapacityStops?: number | null, dailyCapacityWeight?: any | null, isArchived: boolean, zones: Array<{ __typename?: 'SchedulingZoneEntity', id: string, name: string, isArchived: boolean, availabilities: Array<{ __typename?: 'SchedulingZoneAvailabilityEntity', id: string, dayOfWeek: DayOfWeekAll, start: { __typename?: 'PlainTime', hour: number, minute: number }, end: { __typename?: 'PlainTime', hour: number, minute: number } }>, locations: Array<{ __typename?: 'SchedulingZoneLocationEntity', id: string, zipcode: string, city: string }> }> } } };

export type RestoreSchedulingZoneMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type RestoreSchedulingZoneMutation = { __typename?: 'Mutation', restoreSchedulingZone: { __typename: 'MutationErrorOutput', message: string } | { __typename: 'UpdateSchedulingZoneSuccessOutput', schedulingZone: { __typename?: 'SchedulingZoneEntity', id: string, name: string, isArchived: boolean, availabilities: Array<{ __typename?: 'SchedulingZoneAvailabilityEntity', id: string, dayOfWeek: DayOfWeekAll, start: { __typename?: 'PlainTime', hour: number, minute: number }, end: { __typename?: 'PlainTime', hour: number, minute: number } }>, locations: Array<{ __typename?: 'SchedulingZoneLocationEntity', id: string, zipcode: string, city: string }> } } };

export type SchedulingRegionQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type SchedulingRegionQuery = { __typename?: 'Query', schedulingRegion: { __typename?: 'SchedulingRegionEntity', id: string, name: string, dailyCapacityPieces?: number | null, dailyCapacityStops?: number | null, dailyCapacityWeight?: any | null, isArchived: boolean, zones: Array<{ __typename?: 'SchedulingZoneEntity', id: string, name: string, isArchived: boolean, availabilities: Array<{ __typename?: 'SchedulingZoneAvailabilityEntity', id: string, dayOfWeek: DayOfWeekAll, start: { __typename?: 'PlainTime', hour: number, minute: number }, end: { __typename?: 'PlainTime', hour: number, minute: number } }>, locations: Array<{ __typename?: 'SchedulingZoneLocationEntity', id: string, zipcode: string, city: string }> }> } };

export type SchedulingRegionsQueryVariables = Exact<{ [key: string]: never; }>;


export type SchedulingRegionsQuery = { __typename?: 'Query', schedulingRegions: { __typename?: 'FindSchedulingRegionsOutput', schedulingRegions: Array<{ __typename?: 'SchedulingRegionEntity', id: string, name: string, isArchived: boolean }> } };

export type UpdateSchedulingRegionMutationVariables = Exact<{
  input: UpdateSchedulingRegionInput;
}>;


export type UpdateSchedulingRegionMutation = { __typename?: 'Mutation', updateSchedulingRegion: { __typename: 'MutationErrorOutput', message: string } | { __typename: 'UpdateSchedulingRegionSuccessOutput', schedulingRegion: { __typename?: 'SchedulingRegionEntity', id: string, name: string, dailyCapacityPieces?: number | null, dailyCapacityStops?: number | null, dailyCapacityWeight?: any | null, isArchived: boolean, zones: Array<{ __typename?: 'SchedulingZoneEntity', id: string, name: string, isArchived: boolean, availabilities: Array<{ __typename?: 'SchedulingZoneAvailabilityEntity', id: string, dayOfWeek: DayOfWeekAll, start: { __typename?: 'PlainTime', hour: number, minute: number }, end: { __typename?: 'PlainTime', hour: number, minute: number } }>, locations: Array<{ __typename?: 'SchedulingZoneLocationEntity', id: string, zipcode: string, city: string }> }> } } };

export type UpdateSchedulingZoneMutationVariables = Exact<{
  input: UpdateSchedulingZoneInput;
}>;


export type UpdateSchedulingZoneMutation = { __typename?: 'Mutation', updateSchedulingZone: { __typename: 'MutationErrorOutput', message: string } | { __typename: 'UpdateSchedulingZoneSuccessOutput', schedulingZone: { __typename?: 'SchedulingZoneEntity', id: string, name: string, isArchived: boolean, availabilities: Array<{ __typename?: 'SchedulingZoneAvailabilityEntity', id: string, dayOfWeek: DayOfWeekAll, start: { __typename?: 'PlainTime', hour: number, minute: number }, end: { __typename?: 'PlainTime', hour: number, minute: number } }>, locations: Array<{ __typename?: 'SchedulingZoneLocationEntity', id: string, zipcode: string, city: string }> } } };

export type CreateServiceRegionsMutationVariables = Exact<{
  input: CreateServiceRegionsInput;
}>;


export type CreateServiceRegionsMutation = { __typename?: 'Mutation', createServiceRegions: { __typename: 'CreateServiceRegionsSuccessOutput', serviceRegions: Array<{ __typename?: 'ServiceRegionEntity', id: string, name: string, isArchived: boolean }> } | { __typename: 'MutationErrorOutput', message: string } };

export type ServiceRegionQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type ServiceRegionQuery = { __typename?: 'Query', serviceRegion: { __typename?: 'ServiceRegionEntity', id: string, name: string, isArchived: boolean, terminals: Array<{ __typename?: 'TerminalEntity', uuid: string, code: string, name: string, isActive: boolean, serviceAreas: Array<{ __typename?: 'TerminalServiceAreaEntity', uuid: string, zipcode: string, city?: string | null }> }> } };

export type UpdateServiceRegionMutationVariables = Exact<{
  input: UpdateServiceRegionInput;
}>;


export type UpdateServiceRegionMutation = { __typename?: 'Mutation', updateServiceRegion: { __typename: 'MutationErrorOutput', message: string } | { __typename: 'UpdateServiceRegionSuccessOutput', serviceRegion: { __typename?: 'ServiceRegionEntity', id: string, name: string, isArchived: boolean } } };

export type BulkUpdateAccessorialMappingsMutationVariables = Exact<{
  bulkAccessorialUpdateInput: BulkAccessorialUpdateInput;
}>;


export type BulkUpdateAccessorialMappingsMutation = { __typename?: 'Mutation', bulkUpdateAccessorialMappings: Array<{ __typename?: 'SkidBasedAccessorialEntity' } | { __typename?: 'SpecialAccessorialEntity' } | { __typename: 'StandardAccessorialEntity', uuid: string, name: string, rate: number } | { __typename?: 'UnitBasedAccessorialEntity' } | { __typename?: 'WaitTimeAccessorialEntity' } | { __typename?: 'WeightBasedAccessorialEntity' } | { __typename?: 'ZoneBasedAccessorialEntity' }> };

export type BulkUpdateContactQuickbooksIdsMutationVariables = Exact<{
  bulkUpdateContactQuickbooksId: UpdateContactQuickbooksIdsInput;
}>;


export type BulkUpdateContactQuickbooksIdsMutation = { __typename?: 'Mutation', bulkUpdateContactQuickbooksIds: Array<{ __typename: 'CustomerContactEntity', uuid: string, displayName: string, quickbooksDesktopContactId?: string | null }> };

export type CompanyDefaultEdiSettingsQueryVariables = Exact<{ [key: string]: never; }>;


export type CompanyDefaultEdiSettingsQuery = { __typename?: 'Query', company: { __typename?: 'CompanyEntity', uuid: string, defaultInboundEdiService?: { __typename?: 'ServiceEntity', uuid: string, name: string } | null, defaultOutboundEdiService?: { __typename?: 'ServiceEntity', uuid: string, name: string } | null, defaultInboundOutboundEdiService?: { __typename?: 'ServiceEntity', uuid: string, name: string } | null } };

export type AccessorialToQuickbooksMappingByContactQueryVariables = Exact<{
  contactUuid: Scalars['String']['input'];
}>;


export type AccessorialToQuickbooksMappingByContactQuery = { __typename?: 'Query', accessorialToQuickbooksMappingByContact: Array<{ __typename?: 'AccessorialToQuickbooksMappingEntity', uuid: string, quickbooksId: string, accessorial: { __typename?: 'SkidBasedAccessorialEntity', uuid: string, name: string } | { __typename?: 'SpecialAccessorialEntity', uuid: string, name: string } | { __typename?: 'StandardAccessorialEntity', uuid: string, name: string } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string, name: string } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string, name: string } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string, name: string } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string, name: string } }> };

export type CreateAccessorialToQuickbooksMappingMutationVariables = Exact<{
  accessorialToQuickbooksMappingCreateInput: AccessorialToQuickbooksMappingCreateInput;
}>;


export type CreateAccessorialToQuickbooksMappingMutation = { __typename?: 'Mutation', createAccessorialToQuickbooksMapping: { __typename?: 'AccessorialToQuickbooksMappingEntity', uuid: string } };

export type CreateManyReferenceNumberLabelsMutationVariables = Exact<{
  referenceNumberLabels: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type CreateManyReferenceNumberLabelsMutation = { __typename?: 'Mutation', createManyReferenceNumberLabels: Array<{ __typename?: 'ReferenceNumberLabelEntity', name: string }> };

export type CreateQuickbooksHeaderFileMappingMutationVariables = Exact<{
  createQuickbooksHeaderFileMappingInput: CreateQuickbooksHeaderFileMappingInput;
}>;


export type CreateQuickbooksHeaderFileMappingMutation = { __typename?: 'Mutation', createQuickbooksHeaderFileMapping: { __typename?: 'QuickbooksHeaderFileMappingEntity', uuid: string } };

export type DeleteQuickbooksHeaderFileMappingMutationVariables = Exact<{
  uuid: Scalars['String']['input'];
}>;


export type DeleteQuickbooksHeaderFileMappingMutation = { __typename?: 'Mutation', deleteQuickbooksHeaderFileMapping: { __typename?: 'QuickbooksHeaderFileMappingEntity', uuid: string } };

export type DeleteTagMutationVariables = Exact<{
  uuid: Scalars['String']['input'];
}>;


export type DeleteTagMutation = { __typename?: 'Mutation', deleteTag: { __typename?: 'TagEntity', uuid: string } };

export type QuickbooksOAuthUrlQueryVariables = Exact<{ [key: string]: never; }>;


export type QuickbooksOAuthUrlQuery = { __typename?: 'Query', quickbooksOAuthUrl: string };

export type QueryQuickbooksDesktopItemsQueryVariables = Exact<{ [key: string]: never; }>;


export type QueryQuickbooksDesktopItemsQuery = { __typename?: 'Query', queryQuickbooksDesktopItems: { __typename?: 'QuickbooksDesktopResultEntity', error?: string | null, quickbooksDesktopObjects?: Array<{ __typename?: 'QuickbooksDesktopObjectEntity', id: string, name: string }> | null } };

export type QuickbooksCustomersQueryVariables = Exact<{ [key: string]: never; }>;


export type QuickbooksCustomersQuery = { __typename?: 'Query', quickbooksCustomers?: Array<{ __typename?: 'QuickbooksCustomerEntity', id: string, name: string, active: boolean }> | null };

export type QuickbooksHeaderFileMappingsQueryVariables = Exact<{ [key: string]: never; }>;


export type QuickbooksHeaderFileMappingsQuery = { __typename?: 'Query', quickbooksHeaderFileMappings: Array<{ __typename?: 'QuickbooksHeaderFileMappingEntity', uuid: string, name: string, cellNumber: number, headerType: HeaderFileMappingType }> };

export type QuickbooksItemsQueryVariables = Exact<{ [key: string]: never; }>;


export type QuickbooksItemsQuery = { __typename?: 'Query', quickbooksItems?: Array<{ __typename?: 'QuickbooksItemEntity', id: string, name: string, active: boolean }> | null };

export type ReferenceNumberFormatCheckFragment = { __typename?: 'ReferenceNumberFormatCheckEntity', uuid: string, type: ReferenceNumberFormatCheckType, operator?: ReferenceNumberFormatCheckOperator | null, startsWithOperands: Array<string>, lengthOperand?: number | null };

export type ReferenceNumberFormatConfigsQueryVariables = Exact<{
  contactUuid: Scalars['String']['input'];
}>;


export type ReferenceNumberFormatConfigsQuery = { __typename?: 'Query', referenceNumberFormatConfigs?: Array<{ __typename?: 'ReferenceNumberFormatConfigEntity', uuid: string, checks: Array<{ __typename?: 'ReferenceNumberFormatCheckEntity', uuid: string, type: ReferenceNumberFormatCheckType, operator?: ReferenceNumberFormatCheckOperator | null, startsWithOperands: Array<string>, lengthOperand?: number | null }> }> | null };

export type ServiceFragment = { __typename?: 'ServiceEntity', uuid: string, name: string, createdAt: any, updatedAt: any, timeInMinutes?: number | null, useApptInRouteOptimization: boolean, markOrdersAsSpecial: boolean, defaultAppointmentStartTime?: any | null, defaultAppointmentEndTime?: any | null, defaultStartNow: boolean, defaultInboundStopType?: StopType | null, defaultOutboundStopType?: StopType | null, defaultPickupPadding?: any | null, defaultDeliveryPadding?: any | null, defaultTotalDuration?: any | null, defaultIsLineHaul: boolean, defaultFulfillmentType?: FulfillmentType | null, isActive: boolean, isExposedToCustomers: boolean, serviceAvailabilityDates: Array<{ __typename?: 'ServiceAvailabilityDateEntity', id: string, dayCategory: SpecialDayOfWeek, enabled: boolean, start: { __typename?: 'PlainTime', hour: number, minute: number }, end: { __typename?: 'PlainTime', hour: number, minute: number } }> };

export type UpdateAccessorialToQuickbooksMappingMutationVariables = Exact<{
  accessorialToQuickbooksMappingUpdateInput: AccessorialToQuickbooksMappingUpdateInput;
}>;


export type UpdateAccessorialToQuickbooksMappingMutation = { __typename?: 'Mutation', updateAccessorialToQuickbooksMapping: { __typename?: 'AccessorialToQuickbooksMappingEntity', uuid: string } };

export type UpdateCompanyMutationVariables = Exact<{
  updateCompanyInput: UpdateCompanyInput;
}>;


export type UpdateCompanyMutation = { __typename?: 'Mutation', updateCompany: { __typename?: 'CompanyEntity', uuid: string } };

export type UpdateOrderFormFieldsMutationVariables = Exact<{
  updateOrderFormFieldsInput: UpdateOrderFormFieldsInput;
}>;


export type UpdateOrderFormFieldsMutation = { __typename?: 'Mutation', updateOrderFormFields: { __typename?: 'OrderFormFieldsEntity', onePackageRequired: boolean, onePackageWeightRequired: boolean } };

export type UpdateQuickbooksHeaderFileMappingMutationVariables = Exact<{
  updateQuickbooksHeaderFileMappingInput: UpdateQuickbooksHeaderFileMappingInput;
}>;


export type UpdateQuickbooksHeaderFileMappingMutation = { __typename?: 'Mutation', updateQuickbooksHeaderFileMapping: { __typename?: 'QuickbooksHeaderFileMappingEntity', uuid: string } };

export type UpdateTagMutationVariables = Exact<{
  updateTagInput: UpdateTagInput;
}>;


export type UpdateTagMutation = { __typename?: 'Mutation', updateTag: { __typename?: 'TagEntity', uuid: string } };

export type AddLineItemsToSettlementBillsMutationVariables = Exact<{
  addLineItemsToSettlementBillsInput: AddLineItemsToSettlementBillsInput;
}>;


export type AddLineItemsToSettlementBillsMutation = { __typename?: 'Mutation', addLineItemsToSettlementBills: { __typename: 'AddLineItemsToSettlementBillsSuccessOutput', driverSettlementBills: Array<{ __typename?: 'DriverSettlementBillEntity', uuid: string, name?: string | null, billStartDate?: any | null, billEndDate?: any | null, settlementDate?: any | null, driver: { __typename?: 'DriverEntity', uuid: string, firstName: string, lastName: string } }> } | { __typename: 'MutationErrorOutput', message: string } };

export type CreateSettlementAdjustmentMutationVariables = Exact<{
  settlementAdjustmentCreateInput: SettlementAdjustmentCreateInput;
}>;


export type CreateSettlementAdjustmentMutation = { __typename?: 'Mutation', createSettlementAdjustment: { __typename: 'CreateOrUpdateSettlementAdjustmentSuccessOutput', settlementAdjustment: { __typename?: 'SettlementAdjustmentEntity', uuid: string, adjustmentType: SettlementAdjustmentType, name: string, flatRate?: number | null, percentageDecimalRate?: number | null, totalDollars: any } } | { __typename: 'MutationErrorOutput', message: string } };

export type DriverSettlementBillByUuidV2QueryVariables = Exact<{
  uuid: Scalars['String']['input'];
}>;


export type DriverSettlementBillByUuidV2Query = { __typename?: 'Query', driverSettlementBill: { __typename?: 'DriverSettlementBillEntity', uuid: string, name?: string | null, createdAt: any, billStartDate?: any | null, billEndDate?: any | null, payPeriod: string, settlementDate?: any | null, totalDriverPayoutPreDeduction?: number | null, snapshot?: any | null, finalizedDate?: any | null, driver: { __typename?: 'DriverEntity', uuid: string, firstName: string, lastName: string, user: { __typename?: 'UserEntity', name?: string | null } }, settlementAdjustments: Array<{ __typename?: 'SettlementAdjustmentEntity', uuid: string, adjustmentType: SettlementAdjustmentType, name: string, flatRate?: number | null, percentageDecimalRate?: number | null, totalDollars: any }>, paymentInformation: { __typename?: 'DriverSettlementPaymentEntity', eligiblePay: any, netAdjustments: any, finalPay: any }, settlementBillLineItems: Array<{ __typename?: 'SettlementBillLineItemEntity', id: string, totalAmountUsdDollars: number, driver: { __typename?: 'DriverEntity', uuid: string, driverType?: DriverType | null, user: { __typename?: 'UserEntity', name?: string | null } }, driverSettlementBill?: { __typename?: 'DriverSettlementBillEntity', uuid: string, settlementDate?: any | null, finalizedDate?: any | null } | null, shipment: { __typename?: 'StandardShipmentEntity', order?: { __typename?: 'StandardOrderEntity', uuid: string, refNumbers: Array<string>, name: string, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', shipperBillOfLadingNumber?: string | null }, billingPartyContact: { __typename?: 'CustomerContactEntity', displayName: string } } | null, legs: Array<{ __typename?: 'LegEntity', endStop: { __typename?: 'StandardStopEntity', stopType?: StopType | null, completedAt?: any | null } }> } }> } };

export type DriverSettlementBillSummaryV2Fragment = { __typename?: 'DriverSettlementBillEntity', uuid: string, name?: string | null, payPeriod: string, settlementDate?: any | null, finalizedDate?: any | null, snapshotExists: boolean, driver: { __typename?: 'DriverEntity', uuid: string, user: { __typename?: 'UserEntity', name?: string | null } }, paymentInformation: { __typename?: 'DriverSettlementPaymentEntity', eligiblePay: any, netAdjustments: any, finalPay: any } };

export type DriverSettlementBillV2Fragment = { __typename?: 'DriverSettlementBillEntity', uuid: string, name?: string | null, createdAt: any, billStartDate?: any | null, billEndDate?: any | null, payPeriod: string, settlementDate?: any | null, totalDriverPayoutPreDeduction?: number | null, snapshot?: any | null, finalizedDate?: any | null, driver: { __typename?: 'DriverEntity', uuid: string, firstName: string, lastName: string, user: { __typename?: 'UserEntity', name?: string | null } }, settlementAdjustments: Array<{ __typename?: 'SettlementAdjustmentEntity', uuid: string, adjustmentType: SettlementAdjustmentType, name: string, flatRate?: number | null, percentageDecimalRate?: number | null, totalDollars: any }>, paymentInformation: { __typename?: 'DriverSettlementPaymentEntity', eligiblePay: any, netAdjustments: any, finalPay: any }, settlementBillLineItems: Array<{ __typename?: 'SettlementBillLineItemEntity', id: string, totalAmountUsdDollars: number, driver: { __typename?: 'DriverEntity', uuid: string, driverType?: DriverType | null, user: { __typename?: 'UserEntity', name?: string | null } }, driverSettlementBill?: { __typename?: 'DriverSettlementBillEntity', uuid: string, settlementDate?: any | null, finalizedDate?: any | null } | null, shipment: { __typename?: 'StandardShipmentEntity', order?: { __typename?: 'StandardOrderEntity', uuid: string, refNumbers: Array<string>, name: string, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', shipperBillOfLadingNumber?: string | null }, billingPartyContact: { __typename?: 'CustomerContactEntity', displayName: string } } | null, legs: Array<{ __typename?: 'LegEntity', endStop: { __typename?: 'StandardStopEntity', stopType?: StopType | null, completedAt?: any | null } }> } }> };

export type DriverSettlementBillExportPdfMutationVariables = Exact<{
  driverSettlementBillExportPdfInput: DriverSettlementBillExportPdfInput;
}>;


export type DriverSettlementBillExportPdfMutation = { __typename?: 'Mutation', driverSettlementBillExportPdf: { __typename: 'ReportFileOutput', url?: string | null, fileName?: string | null, errors?: Array<string> | null } };

export type DriverSettlementBillExportZipMutationVariables = Exact<{
  input: DriverSettlementBillExportPdfInput;
}>;


export type DriverSettlementBillExportZipMutation = { __typename?: 'Mutation', driverSettlementBillExportZip: { __typename: 'ReportFileOutput', url?: string | null, fileName?: string | null, errors?: Array<string> | null } };

export type FinalizeSettlementBillsMutationVariables = Exact<{
  finalizeSettlementBillsInput: FinalizeSettlementBillsInput;
}>;


export type FinalizeSettlementBillsMutation = { __typename?: 'Mutation', finalizeSettlementBills: { __typename: 'FinalizeSettlementBillsSuccessOutput', results: Array<{ __typename?: 'FinalizeSettlementBillResult', error?: string | null, bill: { __typename?: 'DriverSettlementBillEntity', uuid: string, name?: string | null } }> } | { __typename: 'MutationErrorOutput', message: string } };

export type SettlementBillLineItemWithCostsQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type SettlementBillLineItemWithCostsQuery = { __typename?: 'Query', settlementBillLineItem: { __typename?: 'SettlementBillLineItemEntity', id: string, totalAmountUsdDollars: number, customCosts: Array<{ __typename?: 'CustomCostEntity', id: string, name: string, billingMethod?: CustomChargeBillingMethod | null, dependentSettlementBillingMethod?: DependentSettlementBillingMethod | null, percentageRate?: any | null, flatRateUsdDollars?: number | null, quantity: number, rateUsdDollars?: number | null, fuelSurchargeRate?: number | null, totalAmountUsdDollars?: number | null, accessorialTemplate?: { __typename?: 'SkidBasedAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename?: 'SpecialAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename?: 'StandardAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | null }>, freightCost?: { __typename?: 'FreightCostEntity', id: string, billingMethod?: FreightBillingMethod | null, dependentSettlementBillingMethod?: DependentSettlementBillingMethod | null, percentageRate?: any | null, flatRateUsdDollars?: number | null, quantity?: number | null, rateUsdDollars?: number | null, discountRate?: any | null, totalAmountUsdDollars?: number | null, tariff?: { __typename?: 'TariffEntity', uuid: string } | null, fuelCost?: { __typename?: 'FuelCostEntity', id: string, billingMethod?: FuelBillingMethod | null, dependentSettlementBillingMethod?: DependentSettlementBillingMethod | null, percentageRate?: any | null, surchargeRate?: number | null, flatRateUsdDollars?: number | null, totalAmountUsdDollars?: number | null } | null } | null } };

export type RemoveLineItemsFromSettlementBillMutationVariables = Exact<{
  removeLineItemsFromSettlementBillInput: RemoveLineItemsFromSettlementBillInput;
}>;


export type RemoveLineItemsFromSettlementBillMutation = { __typename?: 'Mutation', removeLineItemsFromSettlementBill: { __typename: 'MutationErrorOutput', message: string } | { __typename: 'RemoveLineItemsFromSettlementBillSuccessOutput', settlementBillLineItemsCount: number } };

export type RemoveSettlementAdjustmentMutationVariables = Exact<{
  uuid: Scalars['String']['input'];
}>;


export type RemoveSettlementAdjustmentMutation = { __typename?: 'Mutation', removeSettlementAdjustment: { __typename?: 'SettlementAdjustmentEntity', uuid: string } };

export type SettlementAdjustmentFragment = { __typename?: 'SettlementAdjustmentEntity', uuid: string, adjustmentType: SettlementAdjustmentType, name: string, flatRate?: number | null, percentageDecimalRate?: number | null, totalDollars: any };

export type SettlementBillLineItemWithCostsFragment = { __typename?: 'SettlementBillLineItemEntity', id: string, totalAmountUsdDollars: number, customCosts: Array<{ __typename?: 'CustomCostEntity', id: string, name: string, billingMethod?: CustomChargeBillingMethod | null, dependentSettlementBillingMethod?: DependentSettlementBillingMethod | null, percentageRate?: any | null, flatRateUsdDollars?: number | null, quantity: number, rateUsdDollars?: number | null, fuelSurchargeRate?: number | null, totalAmountUsdDollars?: number | null, accessorialTemplate?: { __typename?: 'SkidBasedAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename?: 'SpecialAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename?: 'StandardAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | null }>, freightCost?: { __typename?: 'FreightCostEntity', id: string, billingMethod?: FreightBillingMethod | null, dependentSettlementBillingMethod?: DependentSettlementBillingMethod | null, percentageRate?: any | null, flatRateUsdDollars?: number | null, quantity?: number | null, rateUsdDollars?: number | null, discountRate?: any | null, totalAmountUsdDollars?: number | null, tariff?: { __typename?: 'TariffEntity', uuid: string } | null, fuelCost?: { __typename?: 'FuelCostEntity', id: string, billingMethod?: FuelBillingMethod | null, dependentSettlementBillingMethod?: DependentSettlementBillingMethod | null, percentageRate?: any | null, surchargeRate?: number | null, flatRateUsdDollars?: number | null, totalAmountUsdDollars?: number | null } | null } | null };

export type SettlementBillLineItemFragment = { __typename?: 'SettlementBillLineItemEntity', id: string, totalAmountUsdDollars: number, driver: { __typename?: 'DriverEntity', uuid: string, driverType?: DriverType | null, user: { __typename?: 'UserEntity', name?: string | null } }, driverSettlementBill?: { __typename?: 'DriverSettlementBillEntity', uuid: string, settlementDate?: any | null, finalizedDate?: any | null } | null, shipment: { __typename?: 'StandardShipmentEntity', order?: { __typename?: 'StandardOrderEntity', uuid: string, refNumbers: Array<string>, name: string, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', shipperBillOfLadingNumber?: string | null }, billingPartyContact: { __typename?: 'CustomerContactEntity', displayName: string } } | null, legs: Array<{ __typename?: 'LegEntity', endStop: { __typename?: 'StandardStopEntity', stopType?: StopType | null, completedAt?: any | null } }> } };

export type GetSettlementBillLineItemsQueryVariables = Exact<{
  input: FindSettlementBillLineItemsInput;
}>;


export type GetSettlementBillLineItemsQuery = { __typename?: 'Query', settlementBillLineItems: { __typename?: 'SettlementBillLineItemConnection', totalCount?: number | null, edges: Array<{ __typename?: 'SettlementBillLineItemEdge', node: { __typename?: 'SettlementBillLineItemEntity', id: string, totalAmountUsdDollars: number, driver: { __typename?: 'DriverEntity', uuid: string, driverType?: DriverType | null, user: { __typename?: 'UserEntity', name?: string | null } }, driverSettlementBill?: { __typename?: 'DriverSettlementBillEntity', uuid: string, settlementDate?: any | null, finalizedDate?: any | null } | null, shipment: { __typename?: 'StandardShipmentEntity', order?: { __typename?: 'StandardOrderEntity', uuid: string, refNumbers: Array<string>, name: string, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', shipperBillOfLadingNumber?: string | null }, billingPartyContact: { __typename?: 'CustomerContactEntity', displayName: string } } | null, legs: Array<{ __typename?: 'LegEntity', endStop: { __typename?: 'StandardStopEntity', stopType?: StopType | null, completedAt?: any | null } }> } } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } };

export type UpdateSettlementAdjustmentMutationVariables = Exact<{
  settlementAdjustmentUpdateInput: SettlementAdjustmentUpdateInput;
}>;


export type UpdateSettlementAdjustmentMutation = { __typename?: 'Mutation', updateSettlementAdjustment: { __typename: 'CreateOrUpdateSettlementAdjustmentSuccessOutput', settlementAdjustment: { __typename?: 'SettlementAdjustmentEntity', uuid: string, adjustmentType: SettlementAdjustmentType, name: string, flatRate?: number | null, percentageDecimalRate?: number | null, totalDollars: any } } | { __typename: 'MutationErrorOutput', message: string } };

export type CustomChargeFragment = { __typename?: 'CustomChargeEntity', uuid: string, rate: number, description?: string | null, total: number, totalAmountCents?: number | null, postedAmountUsdCents?: number | null, authoCode?: string | null, quantity: number, billingMethod: CustomChargeBillingMethod, isAutoApplied: boolean, name: string, fuelSurchargeRate?: number | null, postedFuelSurchargeRate?: number | null, zoneBasedAccessorialChargeGroupUuid?: string | null, zoneBasedAccessorialZoneUuid?: string | null, specialAccessorialTariffZoneUuid?: string | null, specialAccessorialChargeGroupUuid?: string | null, settlementFlatRate?: number | null, settlementPercentageRate?: number | null, zoneBasedAccessorialMatrixItem?: { __typename?: 'ZoneBasedAccessorialMatrixItemEntity', uuid: string } | null, specialAccessorialMatrixItem?: { __typename?: 'SpecialAccessorialMatrixItemEntity', uuid: string } | null, accessorialRange?: { __typename?: 'AccessorialRangeEntity', uuid: string, lessThanOrEqualToValue: number, rateUsdCents: number } | null, accessorialTemplate?: { __typename?: 'SkidBasedAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename?: 'SpecialAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename?: 'StandardAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | null };

export type OutstandingShipmentsUuidsQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  isFinalized?: InputMaybe<Scalars['Boolean']['input']>;
  hasIssues?: InputMaybe<Scalars['Boolean']['input']>;
  hideFromBilling?: InputMaybe<Scalars['Boolean']['input']>;
  isUnfinalized?: InputMaybe<Scalars['Boolean']['input']>;
  isCancelled?: InputMaybe<Scalars['Boolean']['input']>;
  contactUuid?: InputMaybe<Scalars['String']['input']>;
  billingPartyContactUuids?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  billingPartyContactDisplayName?: InputMaybe<StringFilter>;
  serviceUuid?: InputMaybe<Scalars['String']['input']>;
  terminalUuid?: InputMaybe<Scalars['String']['input']>;
  originTerminalUuid?: InputMaybe<Scalars['String']['input']>;
  destinationTerminalUuid?: InputMaybe<Scalars['String']['input']>;
  noMaximum?: InputMaybe<Scalars['Boolean']['input']>;
  searchText?: InputMaybe<Scalars['String']['input']>;
  stopCompletionEndDate?: InputMaybe<Scalars['DateTime']['input']>;
  stopCompletionStartDate?: InputMaybe<Scalars['DateTime']['input']>;
  uuids?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  orderUuids: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type OutstandingShipmentsUuidsQuery = { __typename?: 'Query', outstandingShipments: { __typename?: 'ShipmentConnection', edges: Array<{ __typename?: 'ShipmentEdge', node: { __typename?: 'StandardShipmentEntity', uuid: string, order?: { __typename?: 'StandardOrderEntity', uuid: string, billingPartyContact: { __typename?: 'CustomerContactEntity', invoiceTimePeriodSplit?: TimePeriod | null, numberOfOrdersPerInvoice?: number | null, uuid: string } } | null } }>, pageInfo: { __typename?: 'PageInfo', startCursor?: string | null, endCursor?: string | null, hasNextPage: boolean, hasPreviousPage: boolean } } };

export type OutstandingStandardShipmentFragment = { __typename?: 'StandardShipmentEntity', uuid: string, shouldBillIndividually: boolean, shouldUseDimWeight: boolean, overridePackageWeight: boolean, name: string, hideFromBilling: boolean, hasSignedPOD: boolean, status: ShipmentStatus, shipmentType: ShipmentType, documents: Array<{ __typename?: 'DocumentEntity', uuid: string, fileName: string, fileType: string, preSignedGetUrl: string, type: DocumentType, notes?: string | null, name?: string | null }>, fields?: { __typename?: 'StandardShipmentFieldsEntity', uuid: string, deadlineDate?: any | null, deadlineType?: DeadlineType | null, deliveryDate?: any | null, dimFactor: number, pickupOrDelivery: PickupOrDelivery, outboundMethod?: OutboundMethod | null, inboundMethod?: InboundMethod | null, type: StandardShipmentType, service?: { __typename?: 'ServiceEntity', uuid: string, name: string, createdAt: any, updatedAt: any, timeInMinutes?: number | null, useApptInRouteOptimization: boolean, markOrdersAsSpecial: boolean, defaultAppointmentStartTime?: any | null, defaultAppointmentEndTime?: any | null, defaultStartNow: boolean, defaultInboundStopType?: StopType | null, defaultOutboundStopType?: StopType | null, defaultPickupPadding?: any | null, defaultDeliveryPadding?: any | null, defaultTotalDuration?: any | null, defaultIsLineHaul: boolean, defaultFulfillmentType?: FulfillmentType | null, isActive: boolean, isExposedToCustomers: boolean, serviceAvailabilityDates: Array<{ __typename?: 'ServiceAvailabilityDateEntity', id: string, dayCategory: SpecialDayOfWeek, enabled: boolean, start: { __typename?: 'PlainTime', hour: number, minute: number }, end: { __typename?: 'PlainTime', hour: number, minute: number } }> } | null } | null, legs: Array<{ __typename?: 'LegEntity', uuid: string, miles?: number | null, endStop: { __typename?: 'StandardStopEntity', uuid: string, createdAt: any, specialInstructions?: string | null, stopType?: StopType | null, appointmentRequired: boolean, deadlineTime?: any | null, proofOfDeliverySignee?: string | null, arrivedAt?: any | null, completedAt?: any | null, inboundMethod?: InboundMethod | null, expectedInboundArrivalDate?: any | null, outboundMethod?: OutboundMethod | null, driverCompletedAt?: any | null, notes?: string | null, serviceDate?: any | null, status: StopStatus, appointmentTime?: any | null, endAppointmentTime?: any | null, isSpecial?: boolean | null, settlementDeductionFlatRate?: number | null, settlementDeductionName?: string | null, settlementDeductionPercentageRate?: number | null, standardStopType?: StandardStopType | null, paperworkMarkedComplete?: boolean | null, sentToAgentAt?: any | null, confirmedByAgentAt?: any | null, address: { __typename?: 'AddressEntity', internalNotes?: string | null, iataCode?: string | null, uuid: string, name: string, line1: string, line2?: string | null, city: string, state: string, zip: string, country: string, latitude?: number | null, longitude?: number | null, driverInstructions?: string | null, receivingHoursStart?: any | null, receivingHoursEnd?: any | null, specialInstructions?: string | null }, serviceDateV2?: { __typename?: 'PlainDate', iso8601: string } | null, routeSlot?: { __typename?: 'RouteSlotEntity', uuid: string, route?: { __typename?: 'RouteEntity', uuid: string, date: any, name: string, slots: Array<{ __typename?: 'RouteSlotEntity', uuid: string }>, drivers: Array<{ __typename?: 'DriverEntity', uuid: string, firstName: string, lastName: string, driverType?: DriverType | null, agent?: { __typename?: 'AgentFieldsEntity', uuid: string, name: string } | null }>, equipments: Array<{ __typename?: 'EquipmentEntity', uuid: string, name: string }> } | null } | null, terminal?: { __typename?: 'TerminalEntity', name: string, code: string, uuid: string, isActive: boolean, address: { __typename?: 'AddressEntity', line1: string, line2?: string | null, city: string, state: string, zip: string, uuid: string, name: string, latitude?: number | null, longitude?: number | null }, startForTerminalLanes: Array<{ __typename?: 'TerminalLaneEntity', id: string, endTerminal: { __typename?: 'TerminalEntity', uuid: string, code: string, name: string } }>, agent?: { __typename?: 'AgentFieldsEntity', name: string } | null } | null, stopDriverMaps: Array<{ __typename?: 'StopDriverMapEntity', uuid: string, name?: string | null, enableDriverSettlement?: boolean | null, revenuePercentageRate?: number | null, revenueFlatRate?: number | null, driverPayoutFinalized: boolean, driver: { __typename?: 'DriverEntity', firstName: string, lastName: string, uuid: string, driverType?: DriverType | null, driverReferenceNumber?: string | null, defaultFuelSettlementPercentageRate?: number | null, user: { __typename?: 'UserEntity', name?: string | null }, defaultVehicle?: { __typename?: 'EquipmentEntity', uuid: string } | null, terminal?: { __typename?: 'TerminalEntity', uuid: string, name: string } | null, qualifications: Array<{ __typename?: 'DriverQualificationEntity', id: string }> }, driverSettlementBill?: { __typename?: 'DriverSettlementBillEntity', uuid: string } | null, stop: { __typename?: 'StandardStopEntity', uuid: string, completedAt?: any | null, settlementDeductionName?: string | null, settlementDeductionFlatRate?: number | null, settlementDeductionPercentageRate?: number | null } }> }, previousStopAttempts: Array<{ __typename?: 'StandardStopEntity', stopDriverMaps: Array<{ __typename?: 'StopDriverMapEntity', uuid: string, name?: string | null, enableDriverSettlement?: boolean | null, revenuePercentageRate?: number | null, revenueFlatRate?: number | null, driverPayoutFinalized: boolean, driver: { __typename?: 'DriverEntity', firstName: string, lastName: string, uuid: string, driverType?: DriverType | null, driverReferenceNumber?: string | null, defaultFuelSettlementPercentageRate?: number | null, user: { __typename?: 'UserEntity', name?: string | null }, defaultVehicle?: { __typename?: 'EquipmentEntity', uuid: string } | null, terminal?: { __typename?: 'TerminalEntity', uuid: string, name: string } | null, qualifications: Array<{ __typename?: 'DriverQualificationEntity', id: string }> }, driverSettlementBill?: { __typename?: 'DriverSettlementBillEntity', uuid: string } | null, stop: { __typename?: 'StandardStopEntity', uuid: string, completedAt?: any | null, settlementDeductionName?: string | null, settlementDeductionFlatRate?: number | null, settlementDeductionPercentageRate?: number | null } }> }> }>, customCharges: Array<{ __typename?: 'CustomChargeEntity', uuid: string, rate: number, description?: string | null, total: number, totalAmountCents?: number | null, postedAmountUsdCents?: number | null, authoCode?: string | null, quantity: number, billingMethod: CustomChargeBillingMethod, isAutoApplied: boolean, name: string, fuelSurchargeRate?: number | null, postedFuelSurchargeRate?: number | null, zoneBasedAccessorialChargeGroupUuid?: string | null, zoneBasedAccessorialZoneUuid?: string | null, specialAccessorialTariffZoneUuid?: string | null, specialAccessorialChargeGroupUuid?: string | null, settlementFlatRate?: number | null, settlementPercentageRate?: number | null, zoneBasedAccessorialMatrixItem?: { __typename?: 'ZoneBasedAccessorialMatrixItemEntity', uuid: string } | null, specialAccessorialMatrixItem?: { __typename?: 'SpecialAccessorialMatrixItemEntity', uuid: string } | null, accessorialRange?: { __typename?: 'AccessorialRangeEntity', uuid: string, lessThanOrEqualToValue: number, rateUsdCents: number } | null, accessorialTemplate?: { __typename?: 'SkidBasedAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename?: 'SpecialAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename?: 'StandardAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | null }>, freightCharge?: { __typename?: 'FreightChargeEntity', uuid: string, quantity: number, billingMethod: FreightBillingMethod, description?: string | null, authoCode?: string | null, rate: number, discountRate?: any | null, settlementFlatRate?: number | null, settlementPercentageRate?: number | null, total: number, totalAmountCents?: number | null, postedAmountUsdCents?: number | null, fuelCharge?: { __typename?: 'FuelChargeEntity', uuid: string, surchargeRate: number, description?: string | null, authoCode?: string | null, flatRate: number, type: FuelBillingMethod, settlementFlatRate?: number | null, settlementPercentageRate?: number | null, totalAmountCents?: number | null, postedAmountUsdCents?: number | null } | null, tariff?: { __typename?: 'TariffEntity', uuid: string, billingPartyContactUuid?: string | null, tariffGroup?: { __typename?: 'TariffGroupEntity', name?: string | null, tariffGroupScope?: TariffGroupScope | null } | null, tariffZone: { __typename?: 'TariffZoneEntity', name: string } } | null } | null, inputForConsolidatedOrder?: { __typename?: 'StandardOrderEntity', uuid: string, name: string } | null, shipmentCharges: { __typename?: 'ShipmentChargeEntity', totalFuelCharge: number, totalCustomCharge: number, totalFreightCharge: number, totalCharge: number }, invoice?: { __typename?: 'InvoiceEntity', uuid: string, name: string, date: any, postedAt?: any | null } | null, independentSettlementBillLineItems: Array<{ __typename?: 'SettlementBillLineItemEntity', id: string, settlementMode: SettlementMode, totalAmountUsdDollars: number, revenuePercentageRate?: any | null, revenueFlatRate?: number | null, driver: { __typename?: 'DriverEntity', uuid: string, user: { __typename?: 'UserEntity', name?: string | null } }, driverSettlementBill?: { __typename?: 'DriverSettlementBillEntity', uuid: string, name?: string | null, finalizedDate?: any | null } | null, freightCost?: { __typename?: 'FreightCostEntity', id: string, billingMethod?: FreightBillingMethod | null, dependentSettlementBillingMethod?: DependentSettlementBillingMethod | null, percentageRate?: any | null, flatRateUsdDollars?: number | null, quantity?: number | null, rateUsdDollars?: number | null, discountRate?: any | null, totalAmountUsdDollars?: number | null, totalAmountUsdCents: number, tariff?: { __typename?: 'TariffEntity', uuid: string, tariffZone: { __typename?: 'TariffZoneEntity', name: string } } | null, fuelCost?: { __typename?: 'FuelCostEntity', id: string, billingMethod?: FuelBillingMethod | null, dependentSettlementBillingMethod?: DependentSettlementBillingMethod | null, percentageRate?: any | null, surchargeRate?: number | null, flatRateUsdDollars?: number | null, totalAmountUsdDollars?: number | null, totalAmountUsdCents: number } | null } | null, customCosts: Array<{ __typename?: 'CustomCostEntity', id: string, name: string, billingMethod?: CustomChargeBillingMethod | null, dependentSettlementBillingMethod?: DependentSettlementBillingMethod | null, percentageRate?: any | null, flatRateUsdDollars?: number | null, quantity: number, rateUsdDollars?: number | null, fuelSurchargeRate?: number | null, totalAmountUsdDollars?: number | null, totalAmountUsdCents: number, accessorialTemplate?: { __typename: 'SkidBasedAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename: 'SpecialAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename: 'StandardAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename: 'UnitBasedAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename: 'WaitTimeAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename: 'WeightBasedAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename: 'ZoneBasedAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | null, specialAccessorialMatrixItem?: { __typename?: 'SpecialAccessorialMatrixItemEntity', uuid: string, zoneUuid: string, chargeGroupUuid: string } | null, zoneBasedAccessorialMatrixItem?: { __typename?: 'ZoneBasedAccessorialMatrixItemEntity', uuid: string, zoneUuid: string, chargeGroupUuid: string } | null, accessorialRange?: { __typename?: 'AccessorialRangeEntity', uuid: string } | null }> }> };

export type ShipmentChargesFragment = { __typename?: 'ShipmentChargeEntity', totalFuelCharge: number, totalCustomCharge: number, totalFreightCharge: number, totalCharge: number };

export type ShipmentFragment = { __typename?: 'StandardShipmentEntity', uuid: string, ordinal: number, hideFromBilling: boolean, status: ShipmentStatus, shipmentType: ShipmentType, invoice?: { __typename?: 'InvoiceEntity', uuid: string } | null, airportInfo?: { __typename?: 'AirportInfoEntity', iataCode: string } | null, standardShipmentFields: { __typename?: 'StandardShipmentFieldsEntity', pickupOrDelivery: PickupOrDelivery, deliveryDate?: any | null, deadlineType?: DeadlineType | null, deadlineDate?: any | null }, legs: Array<{ __typename?: 'LegEntity', uuid: string, endStop: { __typename?: 'StandardStopEntity', uuid: string, notes?: string | null, standardStopType?: StandardStopType | null, stopType?: StopType | null, appointmentTextStatus?: AppointmentTextStatus | null, appointmentTime?: any | null, endAppointmentTime?: any | null, proofOfDeliverySignee?: string | null, inboundMethod?: InboundMethod | null, expectedInboundArrivalDate?: any | null, outboundMethod?: OutboundMethod | null, completedAt?: any | null, driverCompletedAt?: any | null, createdAt: any, status: StopStatus, isSpecial?: boolean | null, paperworkMarkedComplete?: boolean | null, contactPerson?: { __typename?: 'ContactPersonEntity', phone?: string | null, email?: string | null, firstName?: string | null, lastName?: string | null } | null, address: { __typename?: 'AddressEntity', uuid: string, name: string, line1: string, line2?: string | null, city: string, state: string, latitude?: number | null, longitude?: number | null, zip: string }, terminal?: { __typename?: 'TerminalEntity', name: string } | null, routeSlot?: { __typename?: 'RouteSlotEntity', route?: { __typename?: 'RouteEntity', name: string, date: any, drivers: Array<{ __typename?: 'DriverEntity', firstName: string, lastName: string }> } | null } | null }, previousStopAttempts: Array<{ __typename?: 'StandardStopEntity', completedAt?: any | null }> }>, documents: Array<{ __typename?: 'DocumentEntity', uuid: string, fileName: string, preSignedGetUrl: string, type: DocumentType }> };

export type StandardShipmentFreightChargeFragment = { __typename?: 'FreightChargeEntity', uuid: string, quantity: number, billingMethod: FreightBillingMethod, description?: string | null, authoCode?: string | null, rate: number, discountRate?: any | null, settlementFlatRate?: number | null, settlementPercentageRate?: number | null, total: number, totalAmountCents?: number | null, postedAmountUsdCents?: number | null, fuelCharge?: { __typename?: 'FuelChargeEntity', uuid: string, surchargeRate: number, description?: string | null, authoCode?: string | null, flatRate: number, type: FuelBillingMethod, settlementFlatRate?: number | null, settlementPercentageRate?: number | null, totalAmountCents?: number | null, postedAmountUsdCents?: number | null } | null, tariff?: { __typename?: 'TariffEntity', uuid: string, billingPartyContactUuid?: string | null, tariffGroup?: { __typename?: 'TariffGroupEntity', name?: string | null, tariffGroupScope?: TariffGroupScope | null } | null, tariffZone: { __typename?: 'TariffZoneEntity', name: string } } | null };

export type StandardShipmentFragment = { __typename?: 'StandardShipmentEntity', uuid: string, totalChargesAmount: number, totalAmountCents?: number | null, postedAmountCents?: number | null, shouldBillIndividually: boolean, shouldUseDimWeight: boolean, overridePackageWeight: boolean, name: string, hideFromBilling: boolean, hasSignedPOD: boolean, shipmentType: ShipmentType, status: ShipmentStatus, invoice?: { __typename?: 'InvoiceEntity', uuid: string, date: any, postedAt?: any | null, dueDate?: any | null, name: string, journalNumber: number, billToContact: { __typename?: 'CustomerContactEntity', uuid: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string } } | null, documents: Array<{ __typename?: 'DocumentEntity', uuid: string, fileName: string, bucket: string, region: string, key: string, uploadedAt?: any | null, fileType: string, isDeleted: boolean, preSignedGetUrl: string, name?: string | null, type: DocumentType, pageNumber?: number | null, createdAt: any, notes?: string | null, order?: { __typename?: 'StandardOrderEntity', uuid: string, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', shipperBillOfLadingNumber?: string | null } } | null, shipment?: { __typename?: 'StandardOrderEntity', uuid: string } | null, driverFormTemplate?: { __typename?: 'DriverSignableFormTemplateEntity', uuid: string, title: string, formText: string } | null }>, shipmentSubscribers: Array<{ __typename?: 'ShipmentSubscriberEntity', uuid: string, email?: string | null }>, shipperAddress?: { __typename?: 'AddressEntity', uuid: string, name: string, line1: string, line2?: string | null, city: string, state: string, zip: string, country: string, latitude?: number | null, longitude?: number | null, driverInstructions?: string | null, receivingHoursStart?: any | null, receivingHoursEnd?: any | null, specialInstructions?: string | null } | null, airportInfo?: { __typename?: 'AirportInfoEntity', uuid: string, iataCode: string, terminal: string, address: { __typename?: 'AddressEntity', uuid: string, name: string, line1: string, line2?: string | null, city: string, state: string, zip: string, country: string, latitude?: number | null, longitude?: number | null, driverInstructions?: string | null, receivingHoursStart?: any | null, receivingHoursEnd?: any | null, specialInstructions?: string | null } } | null, fields?: { __typename?: 'StandardShipmentFieldsEntity', uuid: string, deadlineDate?: any | null, deadlineType?: DeadlineType | null, deliveryDate?: any | null, dimFactor: number, pickupOrDelivery: PickupOrDelivery, outboundMethod?: OutboundMethod | null, inboundMethod?: InboundMethod | null, type: StandardShipmentType, service?: { __typename?: 'ServiceEntity', uuid: string, name: string, createdAt: any, updatedAt: any, timeInMinutes?: number | null, useApptInRouteOptimization: boolean, markOrdersAsSpecial: boolean, defaultAppointmentStartTime?: any | null, defaultAppointmentEndTime?: any | null, defaultStartNow: boolean, defaultInboundStopType?: StopType | null, defaultOutboundStopType?: StopType | null, defaultPickupPadding?: any | null, defaultDeliveryPadding?: any | null, defaultTotalDuration?: any | null, defaultIsLineHaul: boolean, defaultFulfillmentType?: FulfillmentType | null, isActive: boolean, isExposedToCustomers: boolean, serviceAvailabilityDates: Array<{ __typename?: 'ServiceAvailabilityDateEntity', id: string, dayCategory: SpecialDayOfWeek, enabled: boolean, start: { __typename?: 'PlainTime', hour: number, minute: number }, end: { __typename?: 'PlainTime', hour: number, minute: number } }> } | null } | null, legs: Array<{ __typename?: 'LegEntity', uuid: string, miles?: number | null, endStop: { __typename?: 'StandardStopEntity', uuid: string, createdAt: any, specialInstructions?: string | null, destinationAirport?: string | null, inboundDeadlineDate?: any | null, expectedOutboundDate?: any | null, outboundCarrier?: string | null, appointmentTextStatus?: AppointmentTextStatus | null, incomingCarrier?: string | null, appointmentCallStatus?: AppointmentCallStatus | null, appointmentManuallyConfirmed?: boolean | null, deadlineTime?: any | null, settlementDeductionFlatRate?: number | null, settlementDeductionPercentageRate?: number | null, settlementDeductionName?: string | null, proofOfDeliverySignee?: string | null, appointmentTime?: any | null, arrivedAt?: any | null, completedAt?: any | null, inboundMethod?: InboundMethod | null, expectedInboundArrivalDate?: any | null, outboundMethod?: OutboundMethod | null, driverCompletedAt?: any | null, notes?: string | null, serviceDate?: any | null, status: StopStatus, appointmentRequired: boolean, endAppointmentTime?: any | null, isSpecial?: boolean | null, hideFromDispatch?: boolean | null, standardStopType?: StandardStopType | null, stopType?: StopType | null, paperworkMarkedComplete?: boolean | null, canMarkAttemptComplete?: boolean | null, sentToAgentAt?: any | null, confirmedByAgentAt?: any | null, address: { __typename?: 'AddressEntity', preventCoordRecompute?: boolean | null, internalNotes?: string | null, iataCode?: string | null, uuid: string, name: string, line1: string, line2?: string | null, city: string, state: string, zip: string, country: string, latitude?: number | null, longitude?: number | null, driverInstructions?: string | null, receivingHoursStart?: any | null, receivingHoursEnd?: any | null, specialInstructions?: string | null }, transferAddress?: { __typename?: 'AddressEntity', uuid: string, name: string, line1: string, line2?: string | null, city: string, state: string, zip: string, country: string, latitude?: number | null, longitude?: number | null, driverInstructions?: string | null, receivingHoursStart?: any | null, receivingHoursEnd?: any | null, specialInstructions?: string | null } | null, consigneeAddress?: { __typename?: 'AddressEntity', uuid: string, name: string, line1: string, line2?: string | null, city: string, state: string, zip: string, country: string, latitude?: number | null, longitude?: number | null, driverInstructions?: string | null, receivingHoursStart?: any | null, receivingHoursEnd?: any | null, specialInstructions?: string | null } | null, consigneeContactPerson?: { __typename?: 'ContactPersonEntity', uuid: string, firstName?: string | null, lastName?: string | null, email?: string | null, notes?: string | null, phone?: string | null, createdAt: any } | null, serviceDateV2?: { __typename?: 'PlainDate', iso8601: string } | null, shipperAddress?: { __typename?: 'AddressEntity', uuid: string, name: string, line1: string, line2?: string | null, city: string, state: string, zip: string, country: string, latitude?: number | null, longitude?: number | null, driverInstructions?: string | null, receivingHoursStart?: any | null, receivingHoursEnd?: any | null, specialInstructions?: string | null } | null, shipperContactPerson?: { __typename?: 'ContactPersonEntity', uuid: string, firstName?: string | null, lastName?: string | null, email?: string | null, notes?: string | null, phone?: string | null, createdAt: any } | null, routeSlot?: { __typename?: 'RouteSlotEntity', uuid: string, route?: { __typename?: 'RouteEntity', uuid: string, date: any, name: string, slots: Array<{ __typename?: 'RouteSlotEntity', uuid: string }>, drivers: Array<{ __typename?: 'DriverEntity', uuid: string, firstName: string, lastName: string, driverType?: DriverType | null, agent?: { __typename?: 'AgentFieldsEntity', uuid: string, name: string } | null }>, equipments: Array<{ __typename?: 'EquipmentEntity', uuid: string, name: string }> } | null } | null, contactPerson?: { __typename?: 'ContactPersonEntity', uuid: string, firstName?: string | null, lastName?: string | null, email?: string | null, notes?: string | null, phone?: string | null, createdAt: any } | null, terminal?: { __typename?: 'TerminalEntity', name: string, code: string, uuid: string, isActive: boolean, address: { __typename?: 'AddressEntity', line1: string, line2?: string | null, city: string, state: string, zip: string, uuid: string, name: string, latitude?: number | null, longitude?: number | null }, startForTerminalLanes: Array<{ __typename?: 'TerminalLaneEntity', id: string, endTerminal: { __typename?: 'TerminalEntity', uuid: string, code: string, name: string } }>, agent?: { __typename?: 'AgentFieldsEntity', name: string } | null } | null, stopDriverMaps: Array<{ __typename?: 'StopDriverMapEntity', uuid: string, name?: string | null, enableDriverSettlement?: boolean | null, revenuePercentageRate?: number | null, revenueFlatRate?: number | null, driverPayoutFinalized: boolean, driver: { __typename?: 'DriverEntity', firstName: string, lastName: string, uuid: string, driverType?: DriverType | null, driverReferenceNumber?: string | null, defaultFuelSettlementPercentageRate?: number | null, user: { __typename?: 'UserEntity', name?: string | null }, defaultVehicle?: { __typename?: 'EquipmentEntity', uuid: string } | null, terminal?: { __typename?: 'TerminalEntity', uuid: string, name: string } | null, qualifications: Array<{ __typename?: 'DriverQualificationEntity', id: string }> }, driverSettlementBill?: { __typename?: 'DriverSettlementBillEntity', uuid: string } | null, stop: { __typename?: 'StandardStopEntity', uuid: string, completedAt?: any | null, settlementDeductionName?: string | null, settlementDeductionFlatRate?: number | null, settlementDeductionPercentageRate?: number | null } }> }, previousStopAttempts: Array<{ __typename?: 'StandardStopEntity', stopDriverMaps: Array<{ __typename?: 'StopDriverMapEntity', uuid: string, name?: string | null, enableDriverSettlement?: boolean | null, revenuePercentageRate?: number | null, revenueFlatRate?: number | null, driverPayoutFinalized: boolean, driver: { __typename?: 'DriverEntity', firstName: string, lastName: string, uuid: string, driverType?: DriverType | null, driverReferenceNumber?: string | null, defaultFuelSettlementPercentageRate?: number | null, user: { __typename?: 'UserEntity', name?: string | null }, defaultVehicle?: { __typename?: 'EquipmentEntity', uuid: string } | null, terminal?: { __typename?: 'TerminalEntity', uuid: string, name: string } | null, qualifications: Array<{ __typename?: 'DriverQualificationEntity', id: string }> }, driverSettlementBill?: { __typename?: 'DriverSettlementBillEntity', uuid: string } | null, stop: { __typename?: 'StandardStopEntity', uuid: string, completedAt?: any | null, settlementDeductionName?: string | null, settlementDeductionFlatRate?: number | null, settlementDeductionPercentageRate?: number | null } }> }> }>, packages: Array<{ __typename?: 'PackageEntity', uuid: string, class?: number | null, description: string, hazmat?: boolean | null, height?: number | null, length?: number | null, nmfc?: string | null, quantity: number, skuNumber?: string | null, type?: PackageType | null, weight?: number | null, width?: number | null, quantityCompletedAtStop?: number | null, reasonUncompletedAtStop?: string | null, packageSpec?: { __typename?: 'PackageSpecEntity', id: string, name: string } | null, warehouseLocation?: { __typename?: 'WarehouseLocationEntity', uuid: string, name: string } | null }>, customCharges: Array<{ __typename?: 'CustomChargeEntity', uuid: string, rate: number, description?: string | null, total: number, totalAmountCents?: number | null, postedAmountUsdCents?: number | null, authoCode?: string | null, quantity: number, billingMethod: CustomChargeBillingMethod, isAutoApplied: boolean, name: string, fuelSurchargeRate?: number | null, postedFuelSurchargeRate?: number | null, zoneBasedAccessorialChargeGroupUuid?: string | null, zoneBasedAccessorialZoneUuid?: string | null, specialAccessorialTariffZoneUuid?: string | null, specialAccessorialChargeGroupUuid?: string | null, settlementFlatRate?: number | null, settlementPercentageRate?: number | null, zoneBasedAccessorialMatrixItem?: { __typename?: 'ZoneBasedAccessorialMatrixItemEntity', uuid: string } | null, specialAccessorialMatrixItem?: { __typename?: 'SpecialAccessorialMatrixItemEntity', uuid: string } | null, accessorialRange?: { __typename?: 'AccessorialRangeEntity', uuid: string, lessThanOrEqualToValue: number, rateUsdCents: number } | null, accessorialTemplate?: { __typename?: 'SkidBasedAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename?: 'SpecialAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename?: 'StandardAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | null }>, freightCharge?: { __typename?: 'FreightChargeEntity', uuid: string, quantity: number, billingMethod: FreightBillingMethod, description?: string | null, authoCode?: string | null, rate: number, discountRate?: any | null, settlementFlatRate?: number | null, settlementPercentageRate?: number | null, total: number, totalAmountCents?: number | null, postedAmountUsdCents?: number | null, fuelCharge?: { __typename?: 'FuelChargeEntity', uuid: string, surchargeRate: number, description?: string | null, authoCode?: string | null, flatRate: number, type: FuelBillingMethod, settlementFlatRate?: number | null, settlementPercentageRate?: number | null, totalAmountCents?: number | null, postedAmountUsdCents?: number | null } | null, tariff?: { __typename?: 'TariffEntity', uuid: string, billingPartyContactUuid?: string | null, tariffGroup?: { __typename?: 'TariffGroupEntity', name?: string | null, tariffGroupScope?: TariffGroupScope | null } | null, tariffZone: { __typename?: 'TariffZoneEntity', name: string } } | null } | null, inputForConsolidatedOrder?: { __typename?: 'StandardOrderEntity', uuid: string, name: string } | null, shipmentCharges: { __typename?: 'ShipmentChargeEntity', totalFuelCharge: number, totalCustomCharge: number, totalFreightCharge: number, totalCharge: number }, independentSettlementBillLineItems: Array<{ __typename?: 'SettlementBillLineItemEntity', id: string, settlementMode: SettlementMode, totalAmountUsdDollars: number, revenuePercentageRate?: any | null, revenueFlatRate?: number | null, driver: { __typename?: 'DriverEntity', uuid: string, user: { __typename?: 'UserEntity', name?: string | null } }, driverSettlementBill?: { __typename?: 'DriverSettlementBillEntity', uuid: string, name?: string | null, finalizedDate?: any | null } | null, freightCost?: { __typename?: 'FreightCostEntity', id: string, billingMethod?: FreightBillingMethod | null, dependentSettlementBillingMethod?: DependentSettlementBillingMethod | null, percentageRate?: any | null, flatRateUsdDollars?: number | null, quantity?: number | null, rateUsdDollars?: number | null, discountRate?: any | null, totalAmountUsdDollars?: number | null, totalAmountUsdCents: number, tariff?: { __typename?: 'TariffEntity', uuid: string, tariffZone: { __typename?: 'TariffZoneEntity', name: string } } | null, fuelCost?: { __typename?: 'FuelCostEntity', id: string, billingMethod?: FuelBillingMethod | null, dependentSettlementBillingMethod?: DependentSettlementBillingMethod | null, percentageRate?: any | null, surchargeRate?: number | null, flatRateUsdDollars?: number | null, totalAmountUsdDollars?: number | null, totalAmountUsdCents: number } | null } | null, customCosts: Array<{ __typename?: 'CustomCostEntity', id: string, name: string, billingMethod?: CustomChargeBillingMethod | null, dependentSettlementBillingMethod?: DependentSettlementBillingMethod | null, percentageRate?: any | null, flatRateUsdDollars?: number | null, quantity: number, rateUsdDollars?: number | null, fuelSurchargeRate?: number | null, totalAmountUsdDollars?: number | null, totalAmountUsdCents: number, accessorialTemplate?: { __typename: 'SkidBasedAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename: 'SpecialAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename: 'StandardAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename: 'UnitBasedAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename: 'WaitTimeAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename: 'WeightBasedAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename: 'ZoneBasedAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | null, specialAccessorialMatrixItem?: { __typename?: 'SpecialAccessorialMatrixItemEntity', uuid: string, zoneUuid: string, chargeGroupUuid: string } | null, zoneBasedAccessorialMatrixItem?: { __typename?: 'ZoneBasedAccessorialMatrixItemEntity', uuid: string, zoneUuid: string, chargeGroupUuid: string } | null, accessorialRange?: { __typename?: 'AccessorialRangeEntity', uuid: string } | null }> }> };

export type AttachMobileSignedDocumentToOrderAndReplaceOriginalMutationVariables = Exact<{
  input: UploadMobileSignedDocumentInput;
}>;


export type AttachMobileSignedDocumentToOrderAndReplaceOriginalMutation = { __typename?: 'Mutation', attachMobileSignedDocumentToOrderAndReplaceOriginal: { __typename?: 'UploadMobileSignedDocumentOutput', errorMessage?: string | null, document?: { __typename?: 'DocumentEntity', uuid: string } | null } };

export type DocumentForSigningQueryVariables = Exact<{
  documentForSigningInput: DocumentForSigningInput;
}>;


export type DocumentForSigningQuery = { __typename?: 'Query', documentForSigning: { __typename?: 'DocumentForSigningOutput', errorMessage?: string | null, document?: { __typename?: 'DocumentEntity', uuid: string, preSignedGetUrl: string, fileName: string } | null } };

export type DocumentsForSigningQueryVariables = Exact<{
  orderUuid: Scalars['String']['input'];
  documentType: DocumentType;
}>;


export type DocumentsForSigningQuery = { __typename?: 'Query', documentsForSigning: Array<{ __typename?: 'DocumentEntity', uuid: string, preSignedGetUrl: string }> };

export type GenerateMobileSignedDocumentPreSignedPutUrlMutationVariables = Exact<{
  input: UploadMobileSignedDocumentInput;
}>;


export type GenerateMobileSignedDocumentPreSignedPutUrlMutation = { __typename?: 'Mutation', generateMobileSignedDocumentPreSignedPutUrl: string };

export type CompletedStopNotOnRouteQueryVariables = Exact<{
  uuid: Scalars['String']['input'];
}>;


export type CompletedStopNotOnRouteQuery = { __typename?: 'Query', stop: { __typename?: 'StandardStopEntity', uuid: string, createdAt: any, notes?: string | null, specialInstructions?: string | null, status: StopStatus, appointmentTime?: any | null, endAppointmentTime?: any | null, appointmentTextStatus?: AppointmentTextStatus | null, paperworkMarkedComplete?: boolean | null, leg: { __typename?: 'LegEntity', shipment: { __typename?: 'StandardShipmentEntity', uuid: string, standardShipmentFields: { __typename?: 'StandardShipmentFieldsEntity', pickupOrDelivery: PickupOrDelivery }, order?: { __typename?: 'StandardOrderEntity', uuid: string, name: string, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', uuid: string, shipperBillOfLadingNumber?: string | null } } | null, documents: Array<{ __typename?: 'DocumentEntity', uuid: string, fileName: string, bucket: string, region: string, key: string, uploadedAt?: any | null, fileType: string, isDeleted: boolean, preSignedGetUrl: string, name?: string | null, type: DocumentType, pageNumber?: number | null, createdAt: any, notes?: string | null, order?: { __typename?: 'StandardOrderEntity', uuid: string, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', shipperBillOfLadingNumber?: string | null } } | null, shipment?: { __typename?: 'StandardOrderEntity', uuid: string } | null, driverFormTemplate?: { __typename?: 'DriverSignableFormTemplateEntity', uuid: string, title: string, formText: string } | null }> } }, routeSlot?: { __typename?: 'RouteSlotEntity', uuid: string, route?: { __typename?: 'RouteEntity', uuid: string } | null } | null, address: { __typename?: 'AddressEntity', uuid: string, name: string, line1: string, line2?: string | null, city: string, state: string, zip: string, country: string, latitude?: number | null, longitude?: number | null, driverInstructions?: string | null, receivingHoursStart?: any | null, receivingHoursEnd?: any | null, specialInstructions?: string | null } } };

export type CompletedStopNotOnRouteFragment = { __typename?: 'StandardStopEntity', uuid: string, createdAt: any, notes?: string | null, specialInstructions?: string | null, status: StopStatus, appointmentTime?: any | null, endAppointmentTime?: any | null, appointmentTextStatus?: AppointmentTextStatus | null, paperworkMarkedComplete?: boolean | null, leg: { __typename?: 'LegEntity', shipment: { __typename?: 'StandardShipmentEntity', uuid: string, standardShipmentFields: { __typename?: 'StandardShipmentFieldsEntity', pickupOrDelivery: PickupOrDelivery }, order?: { __typename?: 'StandardOrderEntity', uuid: string, name: string, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', uuid: string, shipperBillOfLadingNumber?: string | null } } | null, documents: Array<{ __typename?: 'DocumentEntity', uuid: string, fileName: string, bucket: string, region: string, key: string, uploadedAt?: any | null, fileType: string, isDeleted: boolean, preSignedGetUrl: string, name?: string | null, type: DocumentType, pageNumber?: number | null, createdAt: any, notes?: string | null, order?: { __typename?: 'StandardOrderEntity', uuid: string, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', shipperBillOfLadingNumber?: string | null } } | null, shipment?: { __typename?: 'StandardOrderEntity', uuid: string } | null, driverFormTemplate?: { __typename?: 'DriverSignableFormTemplateEntity', uuid: string, title: string, formText: string } | null }> } }, routeSlot?: { __typename?: 'RouteSlotEntity', uuid: string, route?: { __typename?: 'RouteEntity', uuid: string } | null } | null, address: { __typename?: 'AddressEntity', uuid: string, name: string, line1: string, line2?: string | null, city: string, state: string, zip: string, country: string, latitude?: number | null, longitude?: number | null, driverInstructions?: string | null, receivingHoursStart?: any | null, receivingHoursEnd?: any | null, specialInstructions?: string | null } };

export type CompletedStopsNotOnRoutesQueryVariables = Exact<{
  date: Scalars['DateTime']['input'];
}>;


export type CompletedStopsNotOnRoutesQuery = { __typename?: 'Query', completedStopsNotOnRoutes: Array<{ __typename?: 'StandardStopEntity', uuid: string, createdAt: any, notes?: string | null, specialInstructions?: string | null, status: StopStatus, appointmentTime?: any | null, endAppointmentTime?: any | null, appointmentTextStatus?: AppointmentTextStatus | null, paperworkMarkedComplete?: boolean | null, leg: { __typename?: 'LegEntity', shipment: { __typename?: 'StandardShipmentEntity', uuid: string, standardShipmentFields: { __typename?: 'StandardShipmentFieldsEntity', pickupOrDelivery: PickupOrDelivery }, order?: { __typename?: 'StandardOrderEntity', uuid: string, name: string, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', uuid: string, shipperBillOfLadingNumber?: string | null } } | null, documents: Array<{ __typename?: 'DocumentEntity', uuid: string, fileName: string, bucket: string, region: string, key: string, uploadedAt?: any | null, fileType: string, isDeleted: boolean, preSignedGetUrl: string, name?: string | null, type: DocumentType, pageNumber?: number | null, createdAt: any, notes?: string | null, order?: { __typename?: 'StandardOrderEntity', uuid: string, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', shipperBillOfLadingNumber?: string | null } } | null, shipment?: { __typename?: 'StandardOrderEntity', uuid: string } | null, driverFormTemplate?: { __typename?: 'DriverSignableFormTemplateEntity', uuid: string, title: string, formText: string } | null }> } }, routeSlot?: { __typename?: 'RouteSlotEntity', uuid: string, route?: { __typename?: 'RouteEntity', uuid: string } | null } | null, address: { __typename?: 'AddressEntity', uuid: string, name: string, line1: string, line2?: string | null, city: string, state: string, zip: string, country: string, latitude?: number | null, longitude?: number | null, driverInstructions?: string | null, receivingHoursStart?: any | null, receivingHoursEnd?: any | null, specialInstructions?: string | null } }> };

export type DeleteStopAttemptMutationVariables = Exact<{
  deleteStopAttemptInput: DeleteStopAttemptInput;
}>;


export type DeleteStopAttemptMutation = { __typename?: 'Mutation', deleteStopAttempt: { __typename?: 'DeleteStopAttemptSuccessOutput', success: boolean } | { __typename?: 'MutationErrorOutput', message: string } };

export type MarkAttemptedStopAsCompleteMutationVariables = Exact<{
  stopUuid: Scalars['String']['input'];
}>;


export type MarkAttemptedStopAsCompleteMutation = { __typename?: 'Mutation', markAttemptedStopAsComplete: { __typename?: 'StandardStopEntity', uuid: string } };

export type MarkStopAsIncompleteMutationVariables = Exact<{
  uuid: Scalars['String']['input'];
}>;


export type MarkStopAsIncompleteMutation = { __typename?: 'Mutation', markStopAsIncomplete: { __typename?: 'StandardStopEntity', uuid: string } };

export type StopForCompletionCheckQueryVariables = Exact<{
  uuid: Scalars['String']['input'];
}>;


export type StopForCompletionCheckQuery = { __typename?: 'Query', stop: { __typename?: 'StandardStopEntity', uuid: string, leg: { __typename?: 'LegEntity', endStop: { __typename?: 'StandardStopEntity', stopType?: StopType | null }, shipment: { __typename?: 'StandardShipmentEntity', standardShipmentFields: { __typename?: 'StandardShipmentFieldsEntity', pickupOrDelivery: PickupOrDelivery } } }, terminal?: { __typename?: 'TerminalEntity', uuid: string } | null, address: { __typename?: 'AddressEntity', line1: string } } };

export type AssignOutboundReferenceNumbersToStorageUnitsMutationVariables = Exact<{
  assignOutboundReferenceNumbersToStorageUnitsInput: AssignOutboundReferenceNumberToStorageUnitsInput;
}>;


export type AssignOutboundReferenceNumbersToStorageUnitsMutation = { __typename?: 'Mutation', assignOutboundReferenceNumbersToStorageUnits: { __typename?: 'AssignOutboundReferenceNumberToStorageUnitsOutput', success: boolean } };

export type CreateStorageOrderDocumentFragment = { __typename?: 'DocumentEntity', uuid: string };

export type CreateStorageOrderDocumentMutationVariables = Exact<{
  createStorageOrderDocumentInput: CreateStorageOrderDocumentInput;
}>;


export type CreateStorageOrderDocumentMutation = { __typename?: 'Mutation', createStorageOrderDocument: { __typename?: 'CreateStorageOrderDocumentOutput', document: { __typename?: 'DocumentEntity', uuid: string } } };

export type CreateStorageOrderFragment = { __typename?: 'StorageOrderEntity', uuid: string };

export type CreateStorageOrderMutationVariables = Exact<{
  createStorageOrderInput: CreateStorageOrderInput;
}>;


export type CreateStorageOrderMutation = { __typename?: 'Mutation', createStorageOrder: { __typename?: 'CreateStorageOrderOutput', storageOrder: { __typename?: 'StorageOrderEntity', uuid: string } } };

export type CreateStorageUnitMutationVariables = Exact<{
  createStorageUnitInput: CreateStorageUnitInput;
}>;


export type CreateStorageUnitMutation = { __typename?: 'Mutation', createStorageUnit: { __typename?: 'CreateStorageUnitOutput', storageUnit: { __typename?: 'StorageUnitEntity', uuid: string, name: string, unitOfMeasure: UnitOfMeasure, weight?: any | null, length?: any | null, width?: any | null, height?: any | null, outboundReferenceNumber?: string | null, markedOnHandAt?: any | null, markedOsdAt?: any | null, osdReason?: string | null, inventoryLastVerifiedAt?: any | null, pickedAt?: any | null, warehouseLocation?: { __typename?: 'WarehouseLocationEntity', uuid: string, name: string } | null, items: Array<{ __typename?: 'ItemForStorageUnit', assignedQuantity: number, item: { __typename?: 'ItemEntity', uuid: string, sku: string, description?: string | null, primaryUOM: { __typename?: 'InventoryPrimaryUnitOfMeasureEntity', uuid: string, unitOfMeasure: UnitOfMeasure } } }> } } };

export type DeleteStorageOrderMutationVariables = Exact<{
  deleteStorageOrderInput: DeleteStorageOrderInput;
}>;


export type DeleteStorageOrderMutation = { __typename?: 'Mutation', deleteStorageOrder: { __typename?: 'DeleteStorageOrderOutput', success: boolean } };

export type DeleteStorageUnitMutationVariables = Exact<{
  deleteStorageUnitInput: DeleteStorageUnitInput;
}>;


export type DeleteStorageUnitMutation = { __typename?: 'Mutation', deleteStorageUnit: { __typename?: 'DeleteStorageUnitOutput', success: boolean } };

export type FindStorageOrderStorageUnitsFragment = { __typename?: 'StorageUnitEntity', uuid: string, name: string, unitOfMeasure: UnitOfMeasure, items: Array<{ __typename?: 'ItemForStorageUnit', assignedQuantity: number, item: { __typename?: 'ItemEntity', uuid: string, sku: string, description?: string | null } }> };

export type StorageOrderStorageUnitsQueryVariables = Exact<{
  findStorageOrderStorageUnitsInput: FindStorageOrderStorageUnitsInput;
}>;


export type StorageOrderStorageUnitsQuery = { __typename?: 'Query', storageOrderStorageUnits: { __typename?: 'FindStorageOrderStorageUnitsOutput', storageUnits: Array<{ __typename?: 'StorageUnitEntity', uuid: string, name: string, unitOfMeasure: UnitOfMeasure, items: Array<{ __typename?: 'ItemForStorageUnit', assignedQuantity: number, item: { __typename?: 'ItemEntity', uuid: string, sku: string, description?: string | null } }> }> } };

export type StorageOrderDocumentFragment = { __typename?: 'DocumentEntity', uuid: string, fileName: string, bucket: string, region: string, key: string, uploadedAt?: any | null, fileType: string, isDeleted: boolean, preSignedGetUrl: string, name?: string | null, type: DocumentType, pageNumber?: number | null, createdAt: any };

export type StorageOrderItemFragment = { __typename?: 'ItemForStorageOrder', totalQuantity: number, unassignedQuantity: number, item: { __typename?: 'ItemEntity', uuid: string, description?: string | null, sku: string, primaryUOM: { __typename?: 'InventoryPrimaryUnitOfMeasureEntity', unitOfMeasure: UnitOfMeasure }, secondaryUOM?: { __typename?: 'InventorySecondaryUnitOfMeasureEntity', unitOfMeasure: UnitOfMeasure } | null, warehouse: { __typename?: 'WarehouseEntity', uuid: string, name: string } } };

export type StorageOrderStorageUnitFragment = { __typename?: 'StorageUnitEntity', uuid: string, name: string, unitOfMeasure: UnitOfMeasure, weight?: any | null, length?: any | null, width?: any | null, height?: any | null, outboundReferenceNumber?: string | null, markedOnHandAt?: any | null, markedOsdAt?: any | null, osdReason?: string | null, inventoryLastVerifiedAt?: any | null, pickedAt?: any | null, warehouseLocation?: { __typename?: 'WarehouseLocationEntity', uuid: string, name: string } | null, items: Array<{ __typename?: 'ItemForStorageUnit', assignedQuantity: number, item: { __typename?: 'ItemEntity', uuid: string, sku: string, description?: string | null, primaryUOM: { __typename?: 'InventoryPrimaryUnitOfMeasureEntity', uuid: string, unitOfMeasure: UnitOfMeasure } } }> };

export type FindStorageOrderFragment = { __typename?: 'StorageOrderEntity', uuid: string, referenceNumber: string, purchaseOrderNumber?: string | null, carrier?: string | null, trackingNumber?: string | null, supplierCompanyName?: string | null, lotNumber?: string | null, consigneeName?: string | null, notes?: string | null, pickupDate?: any | null, expectedAt?: any | null, arrivedAt?: any | null, isOSD: boolean, contact: { __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string }, documents: Array<{ __typename?: 'DocumentEntity', uuid: string, fileName: string, bucket: string, region: string, key: string, uploadedAt?: any | null, fileType: string, isDeleted: boolean, preSignedGetUrl: string, name?: string | null, type: DocumentType, pageNumber?: number | null, createdAt: any }>, items: Array<{ __typename?: 'ItemForStorageOrder', totalQuantity: number, unassignedQuantity: number, item: { __typename?: 'ItemEntity', uuid: string, description?: string | null, sku: string, primaryUOM: { __typename?: 'InventoryPrimaryUnitOfMeasureEntity', unitOfMeasure: UnitOfMeasure }, secondaryUOM?: { __typename?: 'InventorySecondaryUnitOfMeasureEntity', unitOfMeasure: UnitOfMeasure } | null, warehouse: { __typename?: 'WarehouseEntity', uuid: string, name: string } } }>, warehouse: { __typename?: 'WarehouseEntity', uuid: string, name: string } };

export type StorageOrderQueryVariables = Exact<{
  findStorageOrderInput: FindStorageOrderInput;
  storageUnitsInput?: InputMaybe<StorageUnitsInput>;
}>;


export type StorageOrderQuery = { __typename?: 'Query', storageOrder: { __typename?: 'FindStorageOrderOutput', storageOrder: { __typename?: 'StorageOrderEntity', uuid: string, referenceNumber: string, purchaseOrderNumber?: string | null, carrier?: string | null, trackingNumber?: string | null, supplierCompanyName?: string | null, lotNumber?: string | null, consigneeName?: string | null, notes?: string | null, pickupDate?: any | null, expectedAt?: any | null, arrivedAt?: any | null, isOSD: boolean, storageUnits: Array<{ __typename?: 'StorageUnitEntity', uuid: string, name: string, unitOfMeasure: UnitOfMeasure, weight?: any | null, length?: any | null, width?: any | null, height?: any | null, outboundReferenceNumber?: string | null, markedOnHandAt?: any | null, markedOsdAt?: any | null, osdReason?: string | null, inventoryLastVerifiedAt?: any | null, pickedAt?: any | null, warehouseLocation?: { __typename?: 'WarehouseLocationEntity', uuid: string, name: string } | null, items: Array<{ __typename?: 'ItemForStorageUnit', assignedQuantity: number, item: { __typename?: 'ItemEntity', uuid: string, sku: string, description?: string | null, primaryUOM: { __typename?: 'InventoryPrimaryUnitOfMeasureEntity', uuid: string, unitOfMeasure: UnitOfMeasure } } }> }>, contact: { __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string }, documents: Array<{ __typename?: 'DocumentEntity', uuid: string, fileName: string, bucket: string, region: string, key: string, uploadedAt?: any | null, fileType: string, isDeleted: boolean, preSignedGetUrl: string, name?: string | null, type: DocumentType, pageNumber?: number | null, createdAt: any }>, items: Array<{ __typename?: 'ItemForStorageOrder', totalQuantity: number, unassignedQuantity: number, item: { __typename?: 'ItemEntity', uuid: string, description?: string | null, sku: string, primaryUOM: { __typename?: 'InventoryPrimaryUnitOfMeasureEntity', unitOfMeasure: UnitOfMeasure }, secondaryUOM?: { __typename?: 'InventorySecondaryUnitOfMeasureEntity', unitOfMeasure: UnitOfMeasure } | null, warehouse: { __typename?: 'WarehouseEntity', uuid: string, name: string } } }>, warehouse: { __typename?: 'WarehouseEntity', uuid: string, name: string } } } };

export type StorageUnitItemFragment = { __typename?: 'ItemForStorageUnit', assignedQuantity: number, item: { __typename?: 'ItemEntity', uuid: string, sku: string, description?: string | null, primaryUOM: { __typename?: 'InventoryPrimaryUnitOfMeasureEntity', uuid: string, unitOfMeasure: UnitOfMeasure } } };

export type StorageOrderFragment = { __typename?: 'StorageOrderEntity', uuid: string, referenceNumber: string, purchaseOrderNumber?: string | null, carrier?: string | null, trackingNumber?: string | null, supplierCompanyName?: string | null, lotNumber?: string | null, consigneeName?: string | null, notes?: string | null, pickupDate?: any | null, expectedAt?: any | null, arrivedAt?: any | null, isOSD: boolean, contact: { __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string }, warehouse: { __typename?: 'WarehouseEntity', uuid: string, name: string } };

type StorageOrderContact_CustomerContactEntity_Fragment = { __typename?: 'CustomerContactEntity', uuid: string, displayName: string };

type StorageOrderContact_ThirdPartyContactEntity_Fragment = { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string };

export type StorageOrderContactFragment = StorageOrderContact_CustomerContactEntity_Fragment | StorageOrderContact_ThirdPartyContactEntity_Fragment;

export type StorageOrdersQueryVariables = Exact<{
  findStorageOrdersInput: FindStorageOrdersInput;
}>;


export type StorageOrdersQuery = { __typename?: 'Query', storageOrders: { __typename?: 'FindStorageOrdersOutput', storageOrderConnection: { __typename?: 'StorageOrderConnection', totalCount?: number | null, edges: Array<{ __typename?: 'StorageOrderEdge', node: { __typename?: 'StorageOrderEntity', uuid: string, referenceNumber: string, purchaseOrderNumber?: string | null, carrier?: string | null, trackingNumber?: string | null, supplierCompanyName?: string | null, lotNumber?: string | null, consigneeName?: string | null, notes?: string | null, pickupDate?: any | null, expectedAt?: any | null, arrivedAt?: any | null, isOSD: boolean, contact: { __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string }, warehouse: { __typename?: 'WarehouseEntity', uuid: string, name: string } } }>, pageInfo: { __typename?: 'PageInfo', startCursor?: string | null, endCursor?: string | null, hasNextPage: boolean, hasPreviousPage: boolean } } } };

export type FindStorageUnitsForPicklistFragment = { __typename?: 'StorageUnitEntity', uuid: string, name: string, unitOfMeasure: UnitOfMeasure, markedOnHandAt?: any | null, markedOsdAt?: any | null, pickedAt?: any | null, itemUOM?: UnitOfMeasure | null, sku?: string | null, storageOrder?: { __typename?: 'StorageOrderEntity', referenceNumber: string, contact: { __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string } } | null, warehouseLocation?: { __typename?: 'WarehouseLocationEntity', uuid: string, name: string } | null };

export type StorageUnitsForPicklistQueryVariables = Exact<{
  findStorageUnitsInput: FindStorageUnitsInput;
}>;


export type StorageUnitsForPicklistQuery = { __typename?: 'Query', storageUnits: { __typename?: 'FindStorageUnitsOutput', storageUnitConnection: { __typename?: 'StorageUnitConnection', totalCount?: number | null, edges: Array<{ __typename?: 'StorageUnitEdge', node: { __typename?: 'StorageUnitEntity', uuid: string, name: string, unitOfMeasure: UnitOfMeasure, markedOnHandAt?: any | null, markedOsdAt?: any | null, pickedAt?: any | null, itemUOM?: UnitOfMeasure | null, sku?: string | null, storageOrder?: { __typename?: 'StorageOrderEntity', referenceNumber: string, contact: { __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string } } | null, warehouseLocation?: { __typename?: 'WarehouseLocationEntity', uuid: string, name: string } | null } }>, pageInfo: { __typename?: 'PageInfo', startCursor?: string | null, endCursor?: string | null, hasNextPage: boolean, hasPreviousPage: boolean } } } };

export type FindStorageUnitsFragment = { __typename?: 'StorageUnitEntity', uuid: string, name: string, unitOfMeasure: UnitOfMeasure, outboundReferenceNumber?: string | null, billed?: boolean | null, markedOnHandAt?: any | null, markedOsdAt?: any | null, inventoryLastVerifiedAt?: any | null, pickedAt?: any | null, currentBillableDays: number, numberOfDaysInStorage: number, itemUOM?: UnitOfMeasure | null, sku?: string | null, itemDescription?: string | null, storageOrder?: { __typename?: 'StorageOrderEntity', uuid: string, referenceNumber: string, contact: { __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string } } | null, warehouseLocation?: { __typename?: 'WarehouseLocationEntity', uuid: string, name: string } | null };

export type StorageUnitsQueryVariables = Exact<{
  findStorageUnitsInput: FindStorageUnitsInput;
}>;


export type StorageUnitsQuery = { __typename?: 'Query', storageUnits: { __typename?: 'FindStorageUnitsOutput', storageUnitConnection: { __typename?: 'StorageUnitConnection', totalCount?: number | null, edges: Array<{ __typename?: 'StorageUnitEdge', node: { __typename?: 'StorageUnitEntity', uuid: string, name: string, unitOfMeasure: UnitOfMeasure, outboundReferenceNumber?: string | null, billed?: boolean | null, markedOnHandAt?: any | null, markedOsdAt?: any | null, inventoryLastVerifiedAt?: any | null, pickedAt?: any | null, currentBillableDays: number, numberOfDaysInStorage: number, itemUOM?: UnitOfMeasure | null, sku?: string | null, itemDescription?: string | null, storageOrder?: { __typename?: 'StorageOrderEntity', uuid: string, referenceNumber: string, contact: { __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string } } | null, warehouseLocation?: { __typename?: 'WarehouseLocationEntity', uuid: string, name: string } | null } }>, pageInfo: { __typename?: 'PageInfo', startCursor?: string | null, endCursor?: string | null, hasNextPage: boolean, hasPreviousPage: boolean } } } };

export type GenerateStorageOrderPreSignedPutUrlMutationVariables = Exact<{
  generateStorageOrderPreSignedPutUrlInput: GenerateStorageOrderPreSignedPutUrlInput;
}>;


export type GenerateStorageOrderPreSignedPutUrlMutation = { __typename?: 'Mutation', generateStorageOrderPreSignedPutUrl: { __typename?: 'GenerateStorageOrderPreSignedPutUrlOutput', preSignedPutUrl: string } };

export type ImportStorageOrdersFromCsvMutationVariables = Exact<{
  importStorageOrdersFromCsvInput: ImportStorageOrdersFromCsvInput;
}>;


export type ImportStorageOrdersFromCsvMutation = { __typename?: 'Mutation', importStorageOrdersFromCSV: { __typename?: 'ImportStorageOrdersFromCsvOutput', errors?: Array<string> | null, storageOrders: Array<{ __typename?: 'StorageOrderEntity', uuid: string }> } };

export type UpsertItemGroupMutationVariables = Exact<{
  upsertItemGroupInput: UpsertItemGroupInput;
}>;


export type UpsertItemGroupMutation = { __typename?: 'Mutation', upsertItemGroup?: { __typename?: 'ItemGroupEntity', uuid: string, storageUnit?: { __typename?: 'StorageUnitEntity', uuid: string } | null } | null };

export type FindItemGroupsFragment = { __typename?: 'ItemGroupEntity', uuid: string, quantity: number, pickedAt?: any | null, storageUnit?: { __typename?: 'StorageUnitEntity', uuid: string, name: string, outboundReferenceNumber?: string | null, billed?: boolean | null, markedOnHandAt?: any | null, markedOsdAt?: any | null, inventoryLastVerifiedAt?: any | null, pickedAt?: any | null, currentBillableDays: number, numberOfDaysInStorage: number, unitOfMeasure: UnitOfMeasure, weight?: any | null, length?: any | null, width?: any | null, height?: any | null, osdReason?: string | null, warehouseLocation?: { __typename?: 'WarehouseLocationEntity', uuid: string, name: string } | null } | null, storageOrder: { __typename?: 'StorageOrderEntity', uuid: string, referenceNumber: string, arrivedAt?: any | null, consigneeName?: string | null, supplierCompanyName?: string | null, purchaseOrderNumber?: string | null, lotNumber?: string | null, contact: { __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string }, warehouse: { __typename?: 'WarehouseEntity', uuid: string, name: string } }, item: { __typename?: 'ItemEntity', sku: string, description?: string | null, primaryUOM: { __typename?: 'InventoryPrimaryUnitOfMeasureEntity', uuid: string, unitOfMeasure: UnitOfMeasure } } };

export type ItemGroupsQueryVariables = Exact<{
  findItemGroupsInput: FindItemGroupsInput;
}>;


export type ItemGroupsQuery = { __typename?: 'Query', itemGroups: { __typename?: 'ItemGroupConnection', totalCount: number, edges: Array<{ __typename?: 'ItemGroupEdge', node: { __typename?: 'ItemGroupEntity', uuid: string, quantity: number, pickedAt?: any | null, storageUnit?: { __typename?: 'StorageUnitEntity', uuid: string, name: string, outboundReferenceNumber?: string | null, billed?: boolean | null, markedOnHandAt?: any | null, markedOsdAt?: any | null, inventoryLastVerifiedAt?: any | null, pickedAt?: any | null, currentBillableDays: number, numberOfDaysInStorage: number, unitOfMeasure: UnitOfMeasure, weight?: any | null, length?: any | null, width?: any | null, height?: any | null, osdReason?: string | null, warehouseLocation?: { __typename?: 'WarehouseLocationEntity', uuid: string, name: string } | null } | null, storageOrder: { __typename?: 'StorageOrderEntity', uuid: string, referenceNumber: string, arrivedAt?: any | null, consigneeName?: string | null, supplierCompanyName?: string | null, purchaseOrderNumber?: string | null, lotNumber?: string | null, contact: { __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string }, warehouse: { __typename?: 'WarehouseEntity', uuid: string, name: string } }, item: { __typename?: 'ItemEntity', sku: string, description?: string | null, primaryUOM: { __typename?: 'InventoryPrimaryUnitOfMeasureEntity', uuid: string, unitOfMeasure: UnitOfMeasure } } } }>, pageInfo: { __typename?: 'PageInfo', startCursor?: string | null, endCursor?: string | null, hasNextPage: boolean, hasPreviousPage: boolean } } };

export type MarkStorageUnitAsBilledMutationVariables = Exact<{
  markStorageUnitAsBilledInput: MarkStorageUnitAsBilledInput;
}>;


export type MarkStorageUnitAsBilledMutation = { __typename?: 'Mutation', markStorageUnitAsBilled: { __typename?: 'MarkStorageUnitAsBilledOutput', success: boolean } };

export type MarkStorageUnitAsOsdMutationVariables = Exact<{
  markStorageUnitAsOsdInput: MarkStorageUnitAsOsdInput;
}>;


export type MarkStorageUnitAsOsdMutation = { __typename?: 'Mutation', markStorageUnitAsOsd: { __typename?: 'MarkStorageUnitAsOsdOutput', success: boolean } };

export type RemoveStorageUnitOsdMutationVariables = Exact<{
  removeStorageUnitOsdInput: RemoveStorageUnitOsdInput;
}>;


export type RemoveStorageUnitOsdMutation = { __typename?: 'Mutation', removeStorageUnitOsd: { __typename?: 'RemoveStorageUnitOsdOutput', success: boolean } };

export type SetStorageOrderItemQuantityMutationVariables = Exact<{
  setStorageOrderItemQuantityInput: SetStorageOrderItemQuantityInput;
}>;


export type SetStorageOrderItemQuantityMutation = { __typename?: 'Mutation', setStorageOrderItemQuantity: { __typename?: 'StorageOrderEntity', uuid: string } };

export type UnassignInventoryItemsMutationVariables = Exact<{
  unassignInventoryItemsInput: UnassignInventoryItemsInput;
}>;


export type UnassignInventoryItemsMutation = { __typename?: 'Mutation', unassignInventoryItems: { __typename?: 'UnassignInventoryItemsOutput', success: boolean } };

export type UpdateStorageOrderFragment = { __typename?: 'StorageOrderEntity', uuid: string };

export type UpdateStorageOrderMutationVariables = Exact<{
  updateStorageOrderInput: UpdateStorageOrderInput;
}>;


export type UpdateStorageOrderMutation = { __typename?: 'Mutation', updateStorageOrder: { __typename?: 'UpdateStorageOrderOutput', storageOrder: { __typename?: 'StorageOrderEntity', uuid: string } } };

export type UpdateStorageUnitFragment = { __typename?: 'StorageUnitEntity', uuid: string };

export type UpdateStorageUnitMutationVariables = Exact<{
  updateStorageUnitInput: UpdateStorageUnitInput;
}>;


export type UpdateStorageUnitMutation = { __typename?: 'Mutation', updateStorageUnit: { __typename?: 'UpdateStorageUnitOutput', storageUnit: { __typename?: 'StorageUnitEntity', uuid: string } } };

export type UpsertPicklistMutationVariables = Exact<{
  upsertPicklistInput: UpsertPicklistInput;
}>;


export type UpsertPicklistMutation = { __typename?: 'Mutation', upsertPicklist: { __typename?: 'UpsertPicklistOutput', error?: string | null, picklist?: { __typename?: 'PicklistEntity', id: string, date: any, outboundReferenceNumber?: string | null, picklistItemGroups: Array<{ __typename?: 'PicklistItemGroupEntity', id: string, pickedQuantity: number, pickedStatus: PickedStatus, itemGroup: { __typename?: 'ItemGroupEntity', uuid: string, quantity: number, item: { __typename?: 'ItemEntity', sku: string, description?: string | null, primaryUOM: { __typename?: 'InventoryPrimaryUnitOfMeasureEntity', unitOfMeasure: UnitOfMeasure } }, storageUnit?: { __typename?: 'StorageUnitEntity', name: string, warehouseLocation?: { __typename?: 'WarehouseLocationEntity', name: string } | null, storageOrder?: { __typename?: 'StorageOrderEntity', uuid: string, referenceNumber: string, supplierCompanyName?: string | null, purchaseOrderNumber?: string | null, lotNumber?: string | null, contact: { __typename?: 'CustomerContactEntity', uuid: string, displayName: string, company: { __typename?: 'CompanyEntity', uuid: string }, defaultAddress?: { __typename?: 'AddressEntity', name: string, line1: string, line2?: string | null, city: string, state: string, zip: string, country: string } | null } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string, company: { __typename?: 'CompanyEntity', uuid: string }, defaultAddress?: { __typename?: 'AddressEntity', name: string, line1: string, line2?: string | null, city: string, state: string, zip: string, country: string } | null }, warehouse: { __typename?: 'WarehouseEntity', uuid: string, name: string } } | null } | null } }> } | null } };

export type TagFragment = { __typename?: 'TagEntity', uuid: string, value: string, color?: string | null };

export type TagsQueryVariables = Exact<{ [key: string]: never; }>;


export type TagsQuery = { __typename?: 'Query', getTags: Array<{ __typename?: 'TagEntity', uuid: string, value: string, color?: string | null }> };

export type CreateTariffLocationMutationVariables = Exact<{
  createTariffLocationInput: CreateTariffLocationInput;
}>;


export type CreateTariffLocationMutation = { __typename?: 'Mutation', createTariffLocation: { __typename?: 'CreateTariffLocationOutput', tariffLocation: { __typename?: 'TariffLocationEntity', uuid: string } } };

export type CreateTariffZoneMutationVariables = Exact<{
  tariffZoneCreateInput: TariffZoneCreateInput;
  contactUuid?: InputMaybe<Scalars['String']['input']>;
}>;


export type CreateTariffZoneMutation = { __typename?: 'Mutation', createTariffZone: { __typename?: 'TariffZoneEntity', uuid: string, name: string, type: TariffZoneType } };

export type DeleteTariffLocationMutationVariables = Exact<{
  deleteTariffLocationInput: DeleteTariffLocationInput;
}>;


export type DeleteTariffLocationMutation = { __typename?: 'Mutation', deleteTariffLocation: { __typename?: 'DeleteTariffLocationOutput', tariffLocation: { __typename?: 'TariffLocationEntity', uuid: string } } };

export type DeleteTariffZoneMutationVariables = Exact<{
  uuid: Scalars['String']['input'];
}>;


export type DeleteTariffZoneMutation = { __typename?: 'Mutation', deleteTariffZone: { __typename?: 'TariffZoneEntity', uuid: string } };

export type FindTariffZoneByUuidQueryVariables = Exact<{
  uuid: Scalars['String']['input'];
}>;


export type FindTariffZoneByUuidQuery = { __typename?: 'Query', findTariffZoneByUuidOrThrow: { __typename?: 'TariffZoneEntity', uuid: string, name: string, type: TariffZoneType, locations: Array<{ __typename?: 'TariffLocationEntity', uuid: string, city?: string | null, zipcode?: string | null }>, terminal?: { __typename?: 'TerminalEntity', uuid: string, name: string } | null, destinationTerminal?: { __typename?: 'TerminalEntity', uuid: string, name: string } | null } };

export type ShallowTariffZoneFragment = { __typename?: 'TariffZoneEntity', uuid: string, name: string, type: TariffZoneType };

export type TariffLocationFragment = { __typename?: 'TariffLocationEntity', uuid: string, city?: string | null, zipcode?: string | null };

export type TariffZoneFragment = { __typename?: 'TariffZoneEntity', uuid: string, name: string, type: TariffZoneType, mileRangeStart?: number | null, mileRangeEnd?: number | null, billingPartyContactUuid?: string | null, locations: Array<{ __typename?: 'TariffLocationEntity', uuid: string, city?: string | null, zipcode?: string | null }> };

export type TariffZonesQueryVariables = Exact<{
  tariffZoneType?: InputMaybe<TariffZoneType>;
  contactUuid?: InputMaybe<Scalars['String']['input']>;
  tariffZoneLocationType?: InputMaybe<TariffZoneLocationType>;
  defaultToGlobal?: InputMaybe<Scalars['Boolean']['input']>;
  excludeLineHaulTariffZones?: InputMaybe<Scalars['Boolean']['input']>;
  excludeMileBasedTariffZones?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type TariffZonesQuery = { __typename?: 'Query', tariffZones: Array<{ __typename?: 'TariffZoneEntity', uuid: string, name: string, type: TariffZoneType, lineHaulLane?: { __typename?: 'LineHaulLaneEntity', isActive: boolean } | null }> };

export type UpdateTariffZoneMutationVariables = Exact<{
  tariffZoneUpdateInput: TariffZoneUpdateInput;
  contactUuid?: InputMaybe<Scalars['String']['input']>;
}>;


export type UpdateTariffZoneMutation = { __typename?: 'Mutation', updateTariffZone: { __typename?: 'TariffZoneEntity', uuid: string, name: string, type: TariffZoneType } };

export type ServicesQueryVariables = Exact<{ [key: string]: never; }>;


export type ServicesQuery = { __typename?: 'Query', services: Array<{ __typename?: 'ServiceEntity', uuid: string, name: string, createdAt: any, updatedAt: any, timeInMinutes?: number | null, useApptInRouteOptimization: boolean, markOrdersAsSpecial: boolean, defaultAppointmentStartTime?: any | null, defaultAppointmentEndTime?: any | null, defaultStartNow: boolean, defaultInboundStopType?: StopType | null, defaultOutboundStopType?: StopType | null, defaultPickupPadding?: any | null, defaultDeliveryPadding?: any | null, defaultTotalDuration?: any | null, defaultIsLineHaul: boolean, defaultFulfillmentType?: FulfillmentType | null, isActive: boolean, isExposedToCustomers: boolean, serviceAvailabilityDates: Array<{ __typename?: 'ServiceAvailabilityDateEntity', id: string, dayCategory: SpecialDayOfWeek, enabled: boolean, start: { __typename?: 'PlainTime', hour: number, minute: number }, end: { __typename?: 'PlainTime', hour: number, minute: number } }> }> };

export type TariffGroupsQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  uuids?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  searchText?: InputMaybe<Scalars['String']['input']>;
  contactUuid?: InputMaybe<Scalars['String']['input']>;
  serviceUuid?: InputMaybe<Scalars['String']['input']>;
  tariffGroupType?: InputMaybe<TariffGroupType>;
  excludeDefault?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type TariffGroupsQuery = { __typename?: 'Query', tariffGroupsPaginated: { __typename?: 'TariffGroupConnection', totalCount?: number | null, edges: Array<{ __typename?: 'TariffGroupEdge', node: { __typename?: 'TariffGroupEntity', uuid: string, name?: string | null, tariffGroupScope?: TariffGroupScope | null, tariffGroupType: TariffGroupType, startDate?: any | null, endDate?: any | null, rateMultiplier?: number | null, totalContactsToServicesMappings: number, firstTariff?: { __typename?: 'TariffEntity', tariffType: TariffType, rateType: RateType, tariffZone: { __typename?: 'TariffZoneEntity', type: TariffZoneType } } | null, contactToServicesMappings: Array<{ __typename?: 'ContactToServicesTariffGroupMappingEntity', contact: { __typename?: 'CustomerContactEntity', displayName: string } | { __typename?: 'ThirdPartyContactEntity', displayName: string } }> } }>, pageInfo: { __typename?: 'PageInfo', startCursor?: string | null, endCursor?: string | null, hasPreviousPage: boolean, hasNextPage: boolean } } };

export type ShipmentsByPhoneOrReferenceNumberQueryVariables = Exact<{
  searchText: Scalars['String']['input'];
  companyUuid: Scalars['String']['input'];
}>;


export type ShipmentsByPhoneOrReferenceNumberQuery = { __typename?: 'Query', shipmentsByPhoneOrReferenceNumber: Array<{ __typename?: 'StandardShipmentEntity', uuid: string, status: ShipmentStatus, order?: { __typename?: 'StandardOrderEntity', uuid: string, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', shipperBillOfLadingNumber?: string | null } } | null, legs: Array<{ __typename?: 'LegEntity', endStop: { __typename?: 'StandardStopEntity', stopType?: StopType | null, address: { __typename?: 'AddressEntity', uuid: string, name: string, line1: string, line2?: string | null, city: string, state: string, zip: string, country: string, latitude?: number | null, longitude?: number | null, driverInstructions?: string | null, receivingHoursStart?: any | null, receivingHoursEnd?: any | null, specialInstructions?: string | null } } }> }> };

export type TextMessageFragment = { __typename?: 'TextMessageEntity', createdAt: any, timestamp: any, message: string };

export type TextMessagesQueryVariables = Exact<{
  phoneNumber: Scalars['String']['input'];
}>;


export type TextMessagesQuery = { __typename?: 'Query', textMessages: Array<{ __typename?: 'TextMessageEntity', createdAt: any, timestamp: any, message: string }> };

export type DockScanReportQueryVariables = Exact<{
  dockScanReportInput: DockScanReportInput;
}>;


export type DockScanReportQuery = { __typename?: 'Query', dockScanReport: { __typename?: 'DockScanReportOutput', rows: Array<{ __typename?: 'DockScanReportRow', scanUuid: string, contactName?: string | null, serviceDate?: any | null, scannedAt: any, shipperBillOfLadingNumber?: string | null, masterAirwayBillOfLadingNumber?: string | null, pieceName?: string | null, barcode: string, consigneeName?: string | null, osdReason?: string | null, piecesOnHand: number, piecesExpected: number, terminalCode?: string | null, scanType: ScanType, pieceMarkedOnHandOrdinal?: number | null }> } };

export type CreateWarehouseLocationFragment = { __typename?: 'WarehouseLocationEntity', uuid: string };

export type CreateWarehouseLocationMutationVariables = Exact<{
  createWarehouseLocationInput: CreateWarehouseLocationInput;
}>;


export type CreateWarehouseLocationMutation = { __typename?: 'Mutation', createWarehouseLocation: { __typename?: 'CreateWarehouseLocationOutput', errors?: Array<string> | null, warehouseLocation?: { __typename?: 'WarehouseLocationEntity', uuid: string } | null } };

export type DeleteUnusedWarehouseLocationsMutationVariables = Exact<{ [key: string]: never; }>;


export type DeleteUnusedWarehouseLocationsMutation = { __typename?: 'Mutation', deleteUnusedWarehouseLocations: number };

export type DeleteWarehouseLocationMutationVariables = Exact<{
  deleteWarehouseLocationInput: DeleteWarehouseLocationInput;
}>;


export type DeleteWarehouseLocationMutation = { __typename?: 'Mutation', deleteWarehouseLocation: { __typename?: 'DeleteWarehouseLocationOutput', success: boolean } };

export type WarehouseLocationsLocationFragment = { __typename?: 'WarehouseLocationEntity', uuid: string, name: string, location1?: string | null, location2?: string | null, location3?: string | null, warehouse: { __typename?: 'WarehouseEntity', uuid: string, name: string } };

export type WarehouseLocationsQueryVariables = Exact<{
  companyUuid?: InputMaybe<Scalars['String']['input']>;
  warehouseUuid?: InputMaybe<Scalars['String']['input']>;
}>;


export type WarehouseLocationsQuery = { __typename?: 'Query', warehouseLocations: { __typename?: 'FindWarehouseLocationsOutput', warehouseLocations: Array<{ __typename?: 'WarehouseLocationEntity', uuid: string, name: string, location1?: string | null, location2?: string | null, location3?: string | null, warehouse: { __typename?: 'WarehouseEntity', uuid: string, name: string } }> } };

export type ImportWarehouseLocationsFromCsvMutationVariables = Exact<{
  importWarehouseLocationsFromCsvInput: ImportWarehouseLocationsFromCsvInput;
}>;


export type ImportWarehouseLocationsFromCsvMutation = { __typename?: 'Mutation', importWarehouseLocationsFromCsv: number };

export type ScanOrderMutationVariables = Exact<{
  scanOrderInput: ScanOrderInput;
}>;


export type ScanOrderMutation = { __typename?: 'Mutation', scanOrder: { __typename?: 'StandardOrderEntity', uuid: string } };

export type UpdateWarehouseLocationFragment = { __typename?: 'WarehouseLocationEntity', uuid: string };

export type UpdateWarehouseLocationMutationVariables = Exact<{
  updateWarehouseLocationInput: UpdateWarehouseLocationInput;
}>;


export type UpdateWarehouseLocationMutation = { __typename?: 'Mutation', updateWarehouseLocation: { __typename?: 'UpdateWarehouseLocationOutput', errors?: Array<string> | null, warehouseLocation?: { __typename?: 'WarehouseLocationEntity', uuid: string } | null } };

export type CreateWarehouseMutationVariables = Exact<{
  createWarehouseInput: CreateWarehouseInput;
}>;


export type CreateWarehouseMutation = { __typename?: 'Mutation', createWarehouse: { __typename?: 'WarehouseEntity', uuid: string, name: string } };

export type DeleteWarehouseMutationVariables = Exact<{
  warehouseUuid: Scalars['String']['input'];
}>;


export type DeleteWarehouseMutation = { __typename?: 'Mutation', deleteWarehouse: { __typename?: 'WarehouseEntity', uuid: string } };

export type ClosestWarehouseToAddressQueryVariables = Exact<{
  addressLatitude: Scalars['Float']['input'];
  addressLongitude: Scalars['Float']['input'];
}>;


export type ClosestWarehouseToAddressQuery = { __typename?: 'Query', closestWarehouseToAddress?: { __typename?: 'WarehouseEntity', name: string, uuid: string } | null };

export type MarkWarehouseAsDefaultMutationVariables = Exact<{
  warehouseUuid: Scalars['String']['input'];
}>;


export type MarkWarehouseAsDefaultMutation = { __typename?: 'Mutation', markWarehouseAsDefault: { __typename?: 'WarehouseEntity', uuid: string, name: string } };

export type MyWarehousesQueryVariables = Exact<{ [key: string]: never; }>;


export type MyWarehousesQuery = { __typename?: 'Query', me?: { __typename?: 'UserEntity', company: { __typename?: 'CompanyEntity', warehouses?: Array<{ __typename?: 'WarehouseEntity', uuid: string, name: string }> | null } } | null };

export type UpdateWarehouseMutationVariables = Exact<{
  updateWarehouseInput: UpdateWarehouseInput;
}>;


export type UpdateWarehouseMutation = { __typename?: 'Mutation', updateWarehouse: { __typename?: 'WarehouseEntity', uuid: string, name: string } };

export type WarehouseQueryVariables = Exact<{
  warehouseUuid: Scalars['String']['input'];
}>;


export type WarehouseQuery = { __typename?: 'Query', warehouse?: { __typename?: 'WarehouseEntity', name: string, uuid: string, isDefault: boolean, address: { __typename?: 'AddressEntity', uuid: string }, terminal?: { __typename?: 'TerminalEntity', uuid: string } | null } | null };

export type WarehousesQueryVariables = Exact<{
  warehousesInput: WarehousesInput;
}>;


export type WarehousesQuery = { __typename?: 'Query', warehouses?: Array<{ __typename?: 'WarehouseEntity', uuid: string, name: string, isDefault: boolean, address: { __typename?: 'AddressEntity', uuid: string, name: string, line1: string, line2?: string | null, city: string, state: string, zip: string, country: string, latitude?: number | null, longitude?: number | null, driverInstructions?: string | null, receivingHoursStart?: any | null, receivingHoursEnd?: any | null, specialInstructions?: string | null }, terminal?: { __typename?: 'TerminalEntity', uuid: string, code: string } | null }> | null };

export type FindLegsQueryVariables = Exact<{
  startDate: Scalars['DateTime']['input'];
  endDate: Scalars['DateTime']['input'];
}>;


export type FindLegsQuery = { __typename?: 'Query', legs: Array<{ __typename?: 'LegEntity', uuid: string, scheduledDate?: any | null, shipment: { __typename?: 'StandardShipmentEntity', uuid: string }, endStop: { __typename?: 'StandardStopEntity', address: { __typename?: 'AddressEntity', name: string, line1: string, line2?: string | null, city: string, state: string } } }> };

export const MeRolePermissionFragmentDoc = gql`
    fragment MeRolePermission on PermissionEntity {
  permissionResource
  accessLevel
}
    `;
export const MeRoleFragmentDoc = gql`
    fragment MeRole on RoleEntity {
  uuid
  name
  permissions {
    ...MeRolePermission
  }
}
    ${MeRolePermissionFragmentDoc}`;
export const CompanyConfigurationFragmentDoc = gql`
    fragment CompanyConfiguration on CompanyConfigurationEntity {
  uuid
  showDriverSettlementInBilling
  sameDayDispatchCellHeader
  defaultStandardStopType
  defaultFuelSurchargeBillingMethod
  defaultFuelSurcharge
  defaultFuelSettlementPercentageRate
  defaultDimFactor
  defaultRouteStartTime
  defaultRouteLoadTimeInMinutes
  defaultRouteUnloadTimeInMinutes
  defaultGenerateAppointmentDurationInMinutes
  enableConsolidatedOrders
  requirePODPhotoAndName
  requirePODPhotoAndNameForPickups
  requirePODPhotoForPickups
  requireSigneeNameForPickups
  requirePODPhotoForDeliveries
  autoGroupStops
  requireDriverToConfirmStopCompletedAtTime
  requireSigneeNameForDeliveries
  autoMatchEodDocumentsToOrders
  showChargesOnCustomerPortal
  invoicePdfLogoUrl
  showManuallyConfirmedByDefault
  showHelpersColumnInDispatch
  showVehicleInDailyDispatch
  autoApplyWaitTimeMinutes
  requireReviewForEdiOrderCreation
  startingInvoiceOrdinalNumber
  useDriverNumberForDispatch
  useJournalNumberForInvoice
  packageWarehouseLocationsEnabled
  wmsEnabled
  wmsStorageOrdersEnabled
  wmsShortTermStorageEnabled
  wmsAutoMarkOnHand
  requireDriverToAcknowledgeRouteChange
  defaultToAccessorial
  enablePaymentMethod
  driversShouldMarkFreightAsLoaded
  allCapsInOrderPage
  terminalsEnabled
  lineHaulEnabled
  logisticsSectionEnabled
  fulfillmentTypeEnabled
  pointToPointTariffsEnabled
  orderNamingScheme
  companyOrdinalStart
  minDigitsInCompanyOrdinalOrderName
  serviceLevelOptional
  showKilogramsAndCentimeters
  addOrdersToOpenInvoices
  restrictEditingOrderName
  notificationsEnabled
  defaultInvoiceDocumentsRequired
  invoiceNotes
  requireDimsToFinalizeCharges
  orderIdentifierForCoverSheet
  getDriverLocationDataFromMobile
  enableDigitalSignatureFlow
  includeHyphensInInvoiceName
  includeINVInInvoiceName
}
    `;
export const OrderFormFieldsFragmentDoc = gql`
    fragment OrderFormFields on OrderFormFieldsEntity {
  onePackageRequired
  onePackageWeightRequired
}
    `;
export const CompanyFragmentDoc = gql`
    fragment Company on CompanyEntity {
  invoiceEmail
  isCourier
  uuid
  configuration {
    ...CompanyConfiguration
  }
  phone
  quickbooksFileMappingAccessorialChargeName
  quickbooksFileMappingFuelChargeName
  quickbooksFileMappingFreightChargeName
  quickbooksDesktopAccountsReceivableId
  quickbooksFileMappingPickupChargeName
  quickbooksCompanyId
  freightChargeQuickbooksMappingId
  fuelChargeQuickbooksMappingId
  quickbooksDesktopCompanyId
  quickbooksDesktopDeliveryId
  quickbooksDesktopPickupId
  quickbooksDesktopTransferId
  quickbooksDesktopLineHaulId
  quickbooksDesktopOrderChargeId
  quickbooksDesktopAccessorialId
  quickbooksDesktopFuelChargeId
  quickbooksAccessToken {
    uuid
    expiresAt
    accessToken
    refreshToken
  }
  segment
  timeZone
  defaultWeightUnits
  defaultMeasurementUnits
  qbInvoiceNumberStart
  productionCompany
  name
  defaultAddress {
    uuid
    name
    line1
    line2
    city
    latitude
    longitude
    zip
    state
    country
  }
  tags {
    createdAt
    updatedAt
    color
    uuid
    value
  }
  orderNameOrdinal
  referenceNumberLabels {
    name
  }
  customDunningReportHeader
  customDunningReportFooter
  orderFormFields {
    ...OrderFormFields
  }
  useSageBusinessWorks
  blockSendingZeroDollarInvoices
  purchasedProductOfferings
  defaultInvoiceEmailSubject
  defaultNonCompanyDriverSettlementMode
}
    ${CompanyConfigurationFragmentDoc}
${OrderFormFieldsFragmentDoc}`;
export const MeFragmentDoc = gql`
    fragment Me on UserEntity {
  email
  phoneNumber
  name
  uuid
  createdAt
  reportsEmail
  useMinimizedAppointmentTime
  routeCardWidth
  numberOfStops
  redirectIsAlertedOnFirstSave
  redirectIsAlertedOnOpenOrder
  terminal {
    uuid
    code
    name
  }
  company {
    ...Company
  }
  arrangeStopsAndRoutesVertically
}
    ${CompanyFragmentDoc}`;
export const TariffChainFragmentDoc = gql`
    fragment TariffChain on TariffChainEntity {
  id
  name
  tariffGroupType
}
    `;
export const AccessorialUnionUuidOnlyFragmentDoc = gql`
    fragment AccessorialUnionUuidOnly on AccessorialUnion {
  ... on StandardAccessorialEntity {
    uuid
  }
  ... on WeightBasedAccessorialEntity {
    uuid
  }
  ... on ZoneBasedAccessorialEntity {
    uuid
  }
  ... on UnitBasedAccessorialEntity {
    uuid
  }
  ... on SkidBasedAccessorialEntity {
    uuid
  }
  ... on SpecialAccessorialEntity {
    uuid
  }
  ... on WaitTimeAccessorialEntity {
    uuid
  }
}
    `;
export const AccessorialTerminalFragmentDoc = gql`
    fragment AccessorialTerminal on TerminalEntity {
  uuid
  name
  code
}
    `;
export const AccessorialFuelProfileFragmentDoc = gql`
    fragment AccessorialFuelProfile on FuelProfileEntity {
  uuid
  name
  startDate
  expirationDate
  billingType
  type
  company {
    uuid
  }
  contacts {
    uuid
    displayName
  }
  fuelProfileDateRanges {
    uuid
    startDate
    expirationDate
    surchargeRate
    flatRateUsdCents
  }
}
    `;
export const AccessorialRangeFragmentDoc = gql`
    fragment AccessorialRange on AccessorialRangeEntity {
  uuid
  lessThanOrEqualToValue
  rateUsdCents
}
    `;
export const ServiceFragmentDoc = gql`
    fragment Service on ServiceEntity {
  uuid
  name
  createdAt
  updatedAt
  timeInMinutes
  useApptInRouteOptimization
  markOrdersAsSpecial
  defaultAppointmentStartTime
  defaultAppointmentEndTime
  defaultStartNow
  defaultInboundStopType
  defaultOutboundStopType
  defaultPickupPadding
  defaultDeliveryPadding
  defaultTotalDuration
  defaultIsLineHaul
  defaultFulfillmentType
  isActive
  isExposedToCustomers
  serviceAvailabilityDates {
    id
    dayCategory
    start {
      hour
      minute
    }
    end {
      hour
      minute
    }
    enabled
  }
}
    `;
export const AllAccessorialFieldsFragmentDoc = gql`
    fragment AllAccessorialFields on AccessorialUnion {
  ... on StandardAccessorialEntity {
    __typename
    isArchived
    isAuthoCodeRequired
    isDefaultGlobalSpecial
    invoiceDisplayName
    quickbooksDesktopAccessorialId
    uuid
    quickbooksFileMappingChargeName
    quickbooksMappingId
    percentForSettlement
    contact {
      uuid
      displayName
    }
    name
    code
    ediCode
    rate
    matchingGlobalAccessorial {
      ...AccessorialUnionUuidOnly
    }
    matchingCustomerAccessorials {
      ...AccessorialUnionUuidOnly
    }
    terminal {
      ...AccessorialTerminal
    }
    fuelProfile {
      ...AccessorialFuelProfile
    }
    generalLedgerCode {
      id
      code
    }
  }
  ... on UnitBasedAccessorialEntity {
    __typename
    isArchived
    isAuthoCodeRequired
    isDefaultGlobalSpecial
    invoiceDisplayName
    quickbooksDesktopAccessorialId
    uuid
    quickbooksFileMappingChargeName
    quickbooksMappingId
    percentForSettlement
    contact {
      uuid
      displayName
    }
    name
    code
    ediCode
    ratePerUnit
    maximumCharge
    minimumCharge
    matchingGlobalAccessorial {
      ...AccessorialUnionUuidOnly
    }
    matchingCustomerAccessorials {
      ...AccessorialUnionUuidOnly
    }
    terminal {
      ...AccessorialTerminal
    }
    fuelProfile {
      ...AccessorialFuelProfile
    }
    generalLedgerCode {
      id
      code
    }
  }
  ... on SkidBasedAccessorialEntity {
    __typename
    isArchived
    isAuthoCodeRequired
    isDefaultGlobalSpecial
    invoiceDisplayName
    quickbooksDesktopAccessorialId
    uuid
    quickbooksFileMappingChargeName
    quickbooksMappingId
    percentForSettlement
    contact {
      uuid
      displayName
    }
    name
    code
    ediCode
    ratePerSkid
    maximumCharge
    minimumCharge
    matchingGlobalAccessorial {
      ...AccessorialUnionUuidOnly
    }
    matchingCustomerAccessorials {
      ...AccessorialUnionUuidOnly
    }
    terminal {
      ...AccessorialTerminal
    }
    fuelProfile {
      ...AccessorialFuelProfile
    }
    generalLedgerCode {
      id
      code
    }
  }
  ... on WaitTimeAccessorialEntity {
    __typename
    isArchived
    isAuthoCodeRequired
    isDefaultGlobalSpecial
    invoiceDisplayName
    quickbooksDesktopAccessorialId
    uuid
    quickbooksFileMappingChargeName
    quickbooksMappingId
    percentForSettlement
    contact {
      uuid
      displayName
    }
    name
    code
    ediCode
    rate
    maximumCharge
    minimumCharge
    waitTimeChargePeriod
    waitTimeFreeMinutes
    matchingGlobalAccessorial {
      ...AccessorialUnionUuidOnly
    }
    matchingCustomerAccessorials {
      ...AccessorialUnionUuidOnly
    }
    terminal {
      ...AccessorialTerminal
    }
    fuelProfile {
      ...AccessorialFuelProfile
    }
    generalLedgerCode {
      id
      code
    }
  }
  ... on WeightBasedAccessorialEntity {
    __typename
    isArchived
    isAuthoCodeRequired
    isDefaultGlobalSpecial
    invoiceDisplayName
    quickbooksDesktopAccessorialId
    uuid
    quickbooksFileMappingChargeName
    quickbooksMappingId
    percentForSettlement
    contact {
      uuid
      displayName
    }
    name
    code
    ediCode
    ratePerHundredWeight
    maximumCharge
    minimumCharge
    accessorialRanges {
      ...AccessorialRange
    }
    matchingGlobalAccessorial {
      ...AccessorialUnionUuidOnly
    }
    matchingCustomerAccessorials {
      ...AccessorialUnionUuidOnly
    }
    terminal {
      ...AccessorialTerminal
    }
    fuelProfile {
      ...AccessorialFuelProfile
    }
    generalLedgerCode {
      code
      id
    }
  }
  ... on ZoneBasedAccessorialEntity {
    __typename
    isArchived
    isAuthoCodeRequired
    isDefaultGlobalSpecial
    invoiceDisplayName
    quickbooksDesktopAccessorialId
    uuid
    quickbooksFileMappingChargeName
    quickbooksMappingId
    percentForSettlement
    contact {
      uuid
      displayName
    }
    name
    code
    ediCode
    zones {
      uuid
      name
    }
    chargeGroups {
      uuid
      name
    }
    matrixItems {
      zoneUuid
      chargeGroupUuid
      uuid
      rate
    }
    matchingGlobalAccessorial {
      ...AccessorialUnionUuidOnly
    }
    matchingCustomerAccessorials {
      ...AccessorialUnionUuidOnly
    }
    terminal {
      ...AccessorialTerminal
    }
    fuelProfile {
      ...AccessorialFuelProfile
    }
    generalLedgerCode {
      id
      code
    }
  }
  ... on SpecialAccessorialEntity {
    __typename
    isArchived
    isAuthoCodeRequired
    isDefaultGlobalSpecial
    specialAccessorialType
    invoiceDisplayName
    uuid
    quickbooksDesktopAccessorialId
    quickbooksFileMappingChargeName
    quickbooksMappingId
    percentForSettlement
    contact {
      uuid
      displayName
    }
    name
    code
    ediCode
    serviceLevel {
      ...Service
    }
    zones {
      uuid
      name
    }
    chargeGroups {
      uuid
      dayOfWeek
      startTime
      endTime
    }
    matrixItems {
      zoneUuid
      chargeGroupUuid
      uuid
      rate
    }
    matchingGlobalAccessorial {
      ...AccessorialUnionUuidOnly
    }
    matchingCustomerAccessorials {
      ...AccessorialUnionUuidOnly
    }
    terminal {
      ...AccessorialTerminal
    }
    fuelProfile {
      ...AccessorialFuelProfile
    }
    tariffZoneGroup {
      id
    }
    generalLedgerCode {
      id
      code
    }
  }
}
    ${AccessorialUnionUuidOnlyFragmentDoc}
${AccessorialTerminalFragmentDoc}
${AccessorialFuelProfileFragmentDoc}
${AccessorialRangeFragmentDoc}
${ServiceFragmentDoc}`;
export const AutoApplyAccessorialConfigFragmentDoc = gql`
    fragment AutoApplyAccessorialConfig on AutoApplyAccessorialConfigEntity {
  uuid
  accessorials {
    ...AllAccessorialFields
  }
  ruleType
  stopType
  service {
    uuid
    name
  }
  terminal {
    uuid
    name
    code
  }
  tag {
    uuid
    value
  }
  contact {
    uuid
    displayName
  }
  contactsToExcludeFromRule {
    uuid
    displayName
  }
  contactsToIncludeWithRule {
    uuid
    displayName
  }
}
    ${AllAccessorialFieldsFragmentDoc}`;
export const ContactPersonFragmentDoc = gql`
    fragment ContactPerson on ContactPersonEntity {
  uuid
  firstName
  lastName
  email
  notes
  phone
  createdAt
}
    `;
export const AddressWithContactFragmentDoc = gql`
    fragment AddressWithContact on AddressEntity {
  uuid
  name
  line1
  line2
  city
  state
  zip
  country
  latitude
  longitude
  preventCoordRecompute
  driverInstructions
  receivingHoursStart
  receivingHoursEnd
  specialInstructions
  iataCode
  associatedContact {
    ...ContactPerson
  }
}
    ${ContactPersonFragmentDoc}`;
export const GetCityAndStateOptionsFromZipcodeFragmentDoc = gql`
    fragment GetCityAndStateOptionsFromZipcode on CityAndStateOptionEntity {
  city
  state
}
    `;
export const GetZipcodeOptionsFromCityAndStateFragmentDoc = gql`
    fragment GetZipcodeOptionsFromCityAndState on ZipcodeOptionEntity {
  zipcode
}
    `;
export const AppointmentFragmentDoc = gql`
    fragment Appointment on StopEntity {
  uuid
  standardStopType
  appointmentRequired
  textResponses
  contactPerson {
    uuid
    phone
    firstName
    lastName
  }
  routeSlot {
    route {
      name
      drivers {
        firstName
        lastName
      }
    }
  }
  appointmentTime
  appointmentManuallyConfirmed
  formattedCallMessage
  endAppointmentTime
  address {
    line1
    city
    zip
  }
  terminal {
    uuid
    name
  }
  shipmentTotalWeight
  shipmentTotalVolume
  lastAppointmentTextTime
  appointmentTextStatus
  appointmentCallStatus
  shipmentConsigneeAddress {
    name
  }
  leg {
    shipment {
      uuid
      order {
        name
        standardOrderFields {
          shipperBillOfLadingNumber
        }
        source
        billingPartyContact {
          uuid
          displayName
        }
      }
      standardShipmentFields {
        uuid
        deliveryDate
        pickupOrDelivery
        service {
          uuid
          name
        }
      }
    }
  }
}
    `;
export const AuditReportBucketFragmentDoc = gql`
    fragment AuditReportBucket on AuditReportBucketEntity {
  startDate
  endDate
  contactUuid
  daysPastDue
  noAction
  onHand
  assigned
  partiallyComplete
  attempted
  onHold
  unfinalized
  cancelledUnfinalized
  billingIssues
  cancelledFinalized
  noChargeFinalized
  onInvoiceUnposted
  onInvoicePosted
}
    `;
export const AllContactPersonFieldsFragmentDoc = gql`
    fragment AllContactPersonFields on ContactPersonEntity {
  email
  firstName
  lastName
  phone
  uuid
}
    `;
export const ContactCommunicationConfigFragmentDoc = gql`
    fragment ContactCommunicationConfig on ContactCommunicationConfigEntity {
  uuid
  active
  type
}
    `;
export const ContactForQuickbooksFragmentDoc = gql`
    fragment ContactForQuickbooks on ContactEntity {
  uuid
  displayName
  freightChargeQuickbooksMappingId
  fuelChargeQuickbooksMappingId
  miscCustomChargeQuickbooksMappingId
  quickbooksMappingId
}
    `;
export const UserContactNotificationSubscriptionFragmentDoc = gql`
    fragment UserContactNotificationSubscription on UserContactNotificationSubscriptionEntity {
  uuid
  approveOrderNotification
}
    `;
export const PackageFragmentDoc = gql`
    fragment Package on PackageEntity {
  uuid
  packageSpec {
    id
    name
  }
  class
  description
  hazmat
  height
  length
  nmfc
  quantity
  skuNumber
  type
  weight
  width
  type
  quantityCompletedAtStop
  reasonUncompletedAtStop
  warehouseLocation {
    uuid
    name
  }
}
    `;
export const AddressFragmentDoc = gql`
    fragment Address on AddressEntity {
  uuid
  name
  line1
  line2
  city
  state
  zip
  country
  latitude
  longitude
  driverInstructions
  receivingHoursStart
  receivingHoursEnd
  specialInstructions
}
    `;
export const ConsigneePortalOrderFragmentDoc = gql`
    fragment ConsigneePortalOrder on ConsigneePortalOrderEntity {
  uuid
  name
  receivedDate
  status
  notes
  companyTimezone
  shipperBillOfLadingNumber
  masterAirwayBillOfLadingNumber
  packages {
    ...Package
  }
  detailedStatus
  shipments {
    uuid
    deliveryDate
    appointmentTime
    endAppointmentTime
    status
    proofOfDeliverySignee
    addressUuid
    completedAtLocal {
      date {
        year
        month
        day
      }
      time {
        hour
        minute
      }
    }
    completedAtLocalTimeZone
    placeInRoute
    contactPhone
    outboundMethod
    address {
      ...Address
    }
    driverPlaceInRoute
    routeIsToday
    pickupOrDelivery
    stopType
  }
}
    ${PackageFragmentDoc}
${AddressFragmentDoc}`;
export const CustomerPortalCompanyFragmentDoc = gql`
    fragment CustomerPortalCompany on CompanyEntity {
  timeZone
  segment
}
    `;
export const TariffLocationFragmentDoc = gql`
    fragment TariffLocation on TariffLocationEntity {
  uuid
  city
  zipcode
}
    `;
export const TariffZoneFragmentDoc = gql`
    fragment TariffZone on TariffZoneEntity {
  uuid
  name
  type
  mileRangeStart
  mileRangeEnd
  billingPartyContactUuid
  locations {
    ...TariffLocation
  }
}
    ${TariffLocationFragmentDoc}`;
export const LoadFreightChargeFragmentDoc = gql`
    fragment LoadFreightCharge on FreightChargeEntity {
  uuid
  billingMethod
  tariff {
    uuid
    billingPartyContactUuid
    tariffType
    tariffOverageRates {
      uuid
      name
      type
      rateUsdCents
      flatRateUsdCents
      applicableAboveAmount
    }
    tariffRanges {
      uuid
      lessThanOrEqualToValue
      rateUsdCents
    }
    rateType
    tariffZone {
      ...TariffZone
    }
    useActualWeightInCalculation
  }
  total
  rate
  description
  quantity
  fuelCharge {
    description
    surchargeRate
    flatRate
    type
    uuid
  }
}
    ${TariffZoneFragmentDoc}`;
export const LoadCustomChargeFragmentDoc = gql`
    fragment LoadCustomCharge on CustomChargeEntity {
  uuid
  name
  zoneBasedAccessorialZoneUuid
  zoneBasedAccessorialChargeGroupUuid
  specialAccessorialTariffZoneUuid
  specialAccessorialChargeGroupUuid
  quantity
  description
  rate
  total
  customChargeBillingMethod: billingMethod
  accessorialTemplate {
    uuid
    name
    __typename
  }
}
    `;
export const CustomerPortalOrderShipmentFragmentDoc = gql`
    fragment CustomerPortalOrderShipment on ShipmentEntity {
  uuid
  name
  status
  hideFromBilling
  totalChargesAmount
  shipmentType
  documents {
    uuid
  }
  order {
    standardOrderFields {
      measurementUnits
      weightUnits
    }
  }
  standardShipmentFields {
    deliveryDate
    deadlineDate
    service {
      ...Service
    }
    pickupOrDelivery
  }
  freightCharge {
    ...LoadFreightCharge
  }
  customCharges {
    ...LoadCustomCharge
  }
  legs {
    uuid
    status
    endStop {
      stopType
      localTimeZone
      appointmentTime
      endAppointmentTime
      status
      proofOfDeliverySignee
      completedAt
      outboundMethod
      address {
        ...Address
      }
      routeSlot {
        ordinal
        route {
          slots {
            ordinal
            stops {
              status
              leg {
                shipment {
                  status
                }
              }
            }
          }
          date
        }
      }
      contactPerson {
        ...ContactPerson
      }
    }
  }
  consigneeAddress {
    ...Address
  }
}
    ${ServiceFragmentDoc}
${LoadFreightChargeFragmentDoc}
${LoadCustomChargeFragmentDoc}
${AddressFragmentDoc}
${ContactPersonFragmentDoc}`;
export const CustomerPortalOrderFragmentDoc = gql`
    fragment CustomerPortalOrder on OrderEntity {
  uuid
  name
  detailedStatusV2
  receivedDate
  status
  osd
  notes
  company {
    uuid
    segment
    timeZone
  }
  standardOrderFields {
    measurementUnits
    weightUnits
    shipperBillOfLadingNumber
    masterAirwayBillOfLadingNumber
  }
  shipments {
    ...CustomerPortalOrderShipment
  }
  packages {
    ...Package
  }
  totalCharge
}
    ${CustomerPortalOrderShipmentFragmentDoc}
${PackageFragmentDoc}`;
export const CustomerPortalQuoteFragmentDoc = gql`
    fragment CustomerPortalQuote on QuoteEntity {
  uuid
  createdAt
  source
  number
  status
  company {
    name
  }
}
    `;
export const CustomerPortalShipmentForTableFragmentDoc = gql`
    fragment CustomerPortalShipmentForTable on ShipmentEntity {
  uuid
  shipmentType
  standardShipmentFields {
    deadlineDate
    deliveryDate
    pickupOrDelivery
  }
  legs {
    endStop {
      stopType
      uuid
      status
      appointmentTime
      endAppointmentTime
      inboundMethod
      outboundMethod
      address {
        ...Address
      }
      routeSlot {
        route {
          date
          uuid
        }
      }
    }
  }
  consigneeAddress {
    ...Address
  }
}
    ${AddressFragmentDoc}`;
export const CustomerPortalOrderForTableFragmentDoc = gql`
    fragment CustomerPortalOrderForTable on OrderEntity {
  uuid
  name
  standardOrderFields {
    shipperBillOfLadingNumber
  }
  detailedStatusV2
  osd
  onHold
  receivedDate
  shipments {
    ...CustomerPortalShipmentForTable
  }
  company {
    uuid
    name
  }
  contact {
    uuid
    displayName
  }
}
    ${CustomerPortalShipmentForTableFragmentDoc}`;
export const CustomerPortalOrdersFragmentDoc = gql`
    fragment CustomerPortalOrders on OrderEntity {
  uuid
  name
  standardOrderFields {
    shipperBillOfLadingNumber
  }
  detailedStatusV2
  packages {
    ...Package
  }
  receivedDate
  osd
  status
  shipments {
    ...CustomerPortalOrderShipment
  }
  company {
    uuid
    name
  }
  contact {
    uuid
    displayName
  }
}
    ${PackageFragmentDoc}
${CustomerPortalOrderShipmentFragmentDoc}`;
export const SameDayDispatchRouteDriverCoordsFragmentDoc = gql`
    fragment SameDayDispatchRouteDriverCoords on RouteEntity {
  uuid
  drivers {
    uuid
    mobilePhoneLatitude
    mobilePhoneLongitude
    mobileCoordsLastUpdatedAt
  }
}
    `;
export const SameDayDispatchConfigFragmentDoc = gql`
    fragment SameDayDispatchConfig on SameDayDispatchConfigEntity {
  pickupAppointmentTimeThreshold
  deliveryAppointmentTimeThreshold
  isSpecialColorCode
  isNextInRouteColorCode
  isPastDeadlineColorCode
  pickupWithinTimeWindowColorCode
  deliveryWithinTimeWindowColorCode
}
    `;
export const OrganizationAddressFragmentDoc = gql`
    fragment OrganizationAddress on AddressEntity {
  uuid
  name
  line1
  line2
  city
  state
  zip
  country
  driverInstructions
}
    `;
export const OrganizationAgentTerminalFragmentDoc = gql`
    fragment OrganizationAgentTerminal on TerminalEntity {
  uuid
  name
  code
  serviceRegion {
    id
    name
  }
  address {
    uuid
    name
    line1
    line2
    city
    state
    zip
    country
    driverInstructions
  }
}
    `;
export const AddressForOrganizationFragmentDoc = gql`
    fragment AddressForOrganization on AddressEntity {
  uuid
  line1
  city
}
    `;
export const ContactPersonForOrganizationFragmentDoc = gql`
    fragment ContactPersonForOrganization on ContactPersonEntity {
  uuid
  firstName
  lastName
}
    `;
export const OrganizationFragmentDoc = gql`
    fragment Organization on OrganizationEntity {
  isActive
  uuid
  name
  types
  referenceNumber
  email
  defaultContactPerson {
    uuid
  }
  isaId
  ediApplicationId
  ediContactCode
  stediPartnerId
  customerFields {
    defaultAddressUuid
    businessDivisionUuid
    invoiceOrOrderIdentifier
    defaultInboundEdiServiceUuid
    defaultOutboundEdiServiceUuid
    defaultInboundOutboundEdiServiceUuid
    defaultServiceUuid
    services {
      uuid
    }
    showEdiReferenceNumbersOnOrderPage
    defaultOrdinaryTariffChainId
    defaultLineHaulTariffChainId
    defaultTransferTariffChainId
    defaultPointToPointTariffChainId
    defaultFuelSurcharge
    defaultDimFactor
    defaultUseTariff
    isPrepaidOnly
    useCustomVehicleTypes
    customerVehicleTypes {
      id
      vehicleTypeUuid
    }
    referenceNumberLabels {
      name
    }
    enableCustomerPortalOrderEntry
  }
}
    `;
export const PaginatedOrganizationFragmentDoc = gql`
    fragment PaginatedOrganization on OrganizationEntity {
  name
  uuid
  referenceNumber
  types
}
    `;
export const GenerateRoutesPreviewRouteFragmentDoc = gql`
    fragment GenerateRoutesPreviewRoute on RouteGenerationPreviewEntity {
  stops {
    odometer
    eta
    stop {
      uuid
      appointmentTime
      endAppointmentTime
      isSpecial
      status
      stopType
      stopDetails {
        message
        stopDetailsStatus
      }
      shipment {
        standardShipmentFields {
          deadlineDate
          pickupOrDelivery
        }
        order {
          uuid
          weight
          service {
            uuid
          }
          standardOrderFields {
            shipperBillOfLadingNumber
          }
        }
      }
      address {
        name
        line1
        city
        zip
        latitude
        longitude
      }
    }
  }
  equipment {
    uuid
    name
    vehicleType {
      name
    }
  }
  driver {
    uuid
    firstName
    lastName
    driverReferenceNumber
  }
}
    `;
export const DispatchTableColorFragmentDoc = gql`
    fragment DispatchTableColor on DispatchTableColorEntity {
  uuid
  fields
  appointmentStartWithinMinutes
  appointmentEndWithinMinutes
  deadlineDateFilter
  hasAppointmentDate
  isSpecial
  color
  service {
    uuid
    name
  }
  active
}
    `;
export const RoutePathFragmentDoc = gql`
    fragment RoutePath on RoutePathEntity {
  uuid
  coordinates
  route {
    uuid
  }
}
    `;
export const RouteInfoFragmentDoc = gql`
    fragment RouteInfo on RouteInfo {
  totalStops
  totalStopsArrived
  totalStopsNotArrived
  totalStopsCompleted
  totalStopsCancelled
  totalStopsFailed
  status
  pieceCount
  totalWeight
  totalStopsSentToAgent
  totalStopsConfirmedByAgent
}
    `;
export const VehicleTypeFragmentDoc = gql`
    fragment VehicleType on VehicleTypeEntity {
  uuid
  name
  status
  maxVolume
  maxWeight
  capacityNotes
  vehicleTypePackageSpecs {
    id
    packageSpec {
      id
      name
    }
    maxQuantity
  }
}
    `;
export const TagFragmentDoc = gql`
    fragment Tag on TagEntity {
  uuid
  value
  color
}
    `;
export const ShallowPackageFragmentDoc = gql`
    fragment ShallowPackage on PackageEntity {
  uuid
  description
  weight
  quantity
  length
  width
  height
  type
  packageSpec {
    id
    name
  }
  warehouseLocation {
    name
  }
}
    `;
export const OrderPaperworkWithGroupedDocumentsFragmentDoc = gql`
    fragment OrderPaperworkWithGroupedDocuments on OrderPaperworkEntity {
  paperworkComplete
  attachedDocuments
  missingDocuments
  alerts
  proofOfDeliveryOrPickupReadyToSign
  proofOfDeliveryOrPickupSigned
  photos
  other
}
    `;
export const OrderForStopOnRouteFragmentDoc = gql`
    fragment OrderForStopOnRoute on StandardOrderEntity {
  uuid
  refusedBy
  isCollectOnDelivery
  orderSegmentType
  fulfillmentType
  detailedStatusV2
  hazmat
  name
  refNumbers
  dateMarkedOnHand
  startStop {
    terminal {
      name
    }
  }
  endStop {
    terminal {
      name
    }
  }
  tags {
    ...Tag
  }
  service {
    uuid
    name
    timeInMinutes
  }
  orderComments {
    comment
  }
  shipments {
    shipmentType
    uuid
    standardShipmentFields {
      pickupOrDelivery
    }
    airportInfo {
      address {
        name
      }
    }
    legs {
      endStop {
        stopType
        incomingCarrier
        address {
          name
        }
        terminal {
          name
        }
        inboundMethod
      }
    }
  }
  packages {
    ...ShallowPackage
  }
  billingPartyContact {
    displayName
    businessDivision {
      name
    }
  }
  standardOrderFields {
    shipperBillOfLadingNumber
    masterAirwayBillOfLadingNumber
    measurementUnits
  }
  inboundPaperwork {
    ...OrderPaperworkWithGroupedDocuments
  }
  outboundPaperwork {
    ...OrderPaperworkWithGroupedDocuments
  }
  totalCharge
}
    ${TagFragmentDoc}
${ShallowPackageFragmentDoc}
${OrderPaperworkWithGroupedDocumentsFragmentDoc}`;
export const StopOnRouteFragmentDoc = gql`
    fragment StopOnRoute on StopEntity {
  __typename
  routeSlot {
    uuid
    ordinal
    route {
      uuid
      name
    }
  }
  stopDetails {
    stopDetailsStatus
    message
  }
  stopType
  standardStopType
  inboundMethod
  outboundMethod
  notes
  isSpecial
  proofOfDeliverySignee
  status
  sentToAgentAt
  confirmedByAgentAt
  appointmentTextStatus
  specialInstructions
  paperworkMarkedComplete
  showDriverModifiedAt
  routeChangeAcknowledged
  serviceDate
  overrideServiceTimeInMinutes
  completedAt
  cachedEta {
    arrivalTime
    finishTime
  }
  contactPerson {
    firstName
    lastName
    phone
  }
  uuid
  appointmentTime
  endAppointmentTime
  address {
    ...Address
  }
  shipment {
    uuid
    hasSignedPOD
    shipmentType
    standardShipmentFields {
      uuid
      deliveryDate
      pickupOrDelivery
      deadlineDate
      deadlineType
    }
    order {
      ...OrderForStopOnRoute
    }
  }
}
    ${AddressFragmentDoc}
${OrderForStopOnRouteFragmentDoc}`;
export const RouteFragmentDoc = gql`
    fragment Route on RouteEntity {
  createdAt
  date
  uuid
  defaultStartTime
  totalTimeInSeconds
  totalDistanceInMeters
  startLoadTimeInMinutes
  endLoadTimeInMinutes
  locked
  nameManuallyChanged
  name
  numberOfRescheduled
  routeSlotsUpdatedAt
  lastDispatched
  terminal {
    uuid
  }
  routeInfo {
    ...RouteInfo
  }
  helpers {
    firstName
    lastName
    uuid
    phoneNumber
    driverReferenceNumber
  }
  equipments {
    uuid
    name
    type
    vehicleType {
      ...VehicleType
    }
  }
  tags {
    ...Tag
  }
  drivers {
    uuid
    firstName
    lastName
    phoneNumber
    driverReferenceNumber
    terminal {
      uuid
      name
    }
    agentId
  }
  slots {
    uuid
    stops {
      ...StopOnRoute
    }
  }
}
    ${RouteInfoFragmentDoc}
${VehicleTypeFragmentDoc}
${TagFragmentDoc}
${StopOnRouteFragmentDoc}`;
export const SameDayDispatchRouteSlotFragmentDoc = gql`
    fragment SameDayDispatchRouteSlot on RouteSlotEntity {
  uuid
  ordinal
  previousSlotDistanceMeters
  previousSlotDurationSeconds
  stops {
    uuid
    address {
      ...Address
    }
    appointmentTime
    arrivedAt
    completedAt
    endAppointmentTime
    notes
    isSpecial
    stopType
    leg {
      uuid
      shipment {
        uuid
        standardShipmentFields {
          uuid
          pickupOrDelivery
          deliveryDate
        }
        order {
          uuid
          secondaryRefNumber
          name
          pickedDate
          standardOrderFields {
            uuid
            shipperBillOfLadingNumber
          }
          warehouse {
            uuid
            name
          }
          service {
            ...Service
          }
        }
        customCharges {
          accessorialTemplate {
            uuid
            name
          }
        }
      }
    }
    status
    routeChangeAcknowledged
  }
}
    ${AddressFragmentDoc}
${ServiceFragmentDoc}`;
export const SameDayDispatchRouteFragmentDoc = gql`
    fragment SameDayDispatchRoute on RouteEntity {
  uuid
  nameManuallyChanged
  company {
    uuid
  }
  equipments {
    type
    name
    uuid
    samsaraVehicleId
    samsaraIsDeactivated
  }
  nextRouteSlot {
    uuid
    stops {
      uuid
    }
  }
  helpers {
    uuid
    firstName
    lastName
  }
  drivers {
    uuid
    firstName
    lastName
    mobilePhoneLatitude
    mobilePhoneLongitude
    mobileCoordsLastUpdatedAt
    defaultVehicle {
      uuid
      samsaraVehicleId
      name
    }
  }
  name
  slots {
    ...SameDayDispatchRouteSlot
  }
}
    ${SameDayDispatchRouteSlotFragmentDoc}`;
export const StopBySearchTextFragmentDoc = gql`
    fragment StopBySearchText on StopEntity {
  uuid
  status
  completedAt
  isAttempt
  shipment {
    standardShipmentFields {
      pickupOrDelivery
    }
    order {
      uuid
      name
      refNumbers
      detailedStatus
      refusedBy
      standardOrderFields {
        shipperBillOfLadingNumber
      }
    }
  }
  stopDriverMaps {
    uuid
    driver {
      uuid
      firstName
      lastName
      driverType
    }
    driverSettlementBill {
      name
      settlementDate
      finalizedDate
    }
    enableDriverSettlement
  }
}
    `;
export const StopOnRouteBySearchTextFragmentDoc = gql`
    fragment StopOnRouteBySearchText on StopEntity {
  appointmentTime
  endAppointmentTime
  status
  completedAt
  stopType
  cachedEta {
    arrivalTime
  }
  stopDetails {
    message
    stopDetailsStatus
  }
  address {
    ...Address
  }
  shipment {
    standardShipmentFields {
      deliveryDate
      pickupOrDelivery
    }
    order {
      uuid
      refusedBy
      packages {
        ...ShallowPackage
      }
      billingPartyContact {
        displayName
      }
      standardOrderFields {
        shipperBillOfLadingNumber
      }
      service {
        uuid
        name
      }
    }
  }
  routeSlot {
    route {
      name
      date
      terminal {
        code
      }
    }
  }
}
    ${AddressFragmentDoc}
${ShallowPackageFragmentDoc}`;
export const RecurringRunHeaderFragmentDoc = gql`
    fragment RecurringRunHeader on RecurringRunHeaderEntity {
  uuid
  name
  driver {
    uuid
    firstName
    lastName
  }
  vehicleType {
    uuid
    name
  }
}
    `;
export const StopBaseFragmentDoc = gql`
    fragment StopBase on CachedStopBaseEntity {
  uuid
  stopType
  hasPreviousAttempt
  isSpecial
  specialInstructions
  serviceDate
  serviceDateV2 {
    iso8601
  }
  serviceTimeInMinutes
  terminalUuid
  terminalName
  status
  appointmentTime
  endAppointmentTime
  appointmentScheduled
  appointmentRequired
  deadlineDate
  deliveryDate
  createdAt
  standardStopType
  totalCharge
  address {
    name
    line1
    line2
    city
    zip
    state
    routeName
    routeNameUuid
    latitude
    longitude
  }
}
    `;
export const StopFragmentDoc = gql`
    fragment Stop on CachedStopEntity {
  __typename
  stopDetails {
    message
    stopDetailsStatus
  }
  order {
    uuid
    orderSegmentType
    fulfillmentType
    warehouseUuid
    businessDivisionName
    contactUuid
    contactName
    serviceUuid
    serviceName
    name
    vehicleTypeName
    refNumbers
    shipperBillOfLadingNumber
    masterAirwayBillOfLadingNumber
    receivedDate
    pickedDate
    inboundStopType
    outboundStopType
    inboundName
    outboundName
    inboundZip
    outboundZip
    inboundCity
    inboundPaperwork {
      ...OrderPaperworkWithGroupedDocuments
    }
    outboundPaperwork {
      ...OrderPaperworkWithGroupedDocuments
    }
    outboundCity
    orderComments {
      comment
    }
    tags {
      ...Tag
    }
    packages {
      weight
      length
      width
      height
      quantity
      description
    }
  }
  stop {
    ...StopBase
  }
  linkedEndStop {
    ...StopBase
  }
  otherStop {
    ...StopBase
  }
  recurringRunUuid
}
    ${OrderPaperworkWithGroupedDocumentsFragmentDoc}
${TagFragmentDoc}
${StopBaseFragmentDoc}`;
export const StopDriverMapForDriverCompletedStopsFragmentDoc = gql`
    fragment StopDriverMapForDriverCompletedStops on StopDriverMapForCompletedStopsEntity {
  driver {
    uuid
  }
  serviceDate
  stopType
  isLineHaul
  linehaulStartTerminal {
    code
  }
  linehaulEndTerminal {
    code
  }
  order {
    name
    pieceCount
    standardOrderFields {
      masterAirwayBillOfLadingNumber
      shipperBillOfLadingNumber
    }
    billingPartyContact {
      displayName
    }
    service {
      name
    }
    weight
    totalCharge
    refNumbers
    startStop {
      address {
        name
        line1
        line2
        city
        state
        zip
      }
      terminal {
        name
      }
    }
    endStop {
      address {
        name
        line1
        line2
        city
        state
        zip
      }
      terminal {
        name
      }
    }
  }
}
    `;
export const DriverCompletedStopsFragmentDoc = gql`
    fragment DriverCompletedStops on DriverCompletedStopsEntity {
  stopDriverMaps {
    ...StopDriverMapForDriverCompletedStops
  }
}
    ${StopDriverMapForDriverCompletedStopsFragmentDoc}`;
export const StopDriverMapAddressForDownloadFragmentDoc = gql`
    fragment StopDriverMapAddressForDownload on StopDriverMapAddressForDownloadEntity {
  name
  line1
  line2
  city
  state
  zip
  country
}
    `;
export const StopDriverMapForDownloadFragmentDoc = gql`
    fragment StopDriverMapForDownload on StopDriverMapForDownloadEntity {
  stopUuid
  arrivedAt
  completedAt
  stopType
  address {
    ...StopDriverMapAddressForDownload
  }
  serviceName
  driverSettlementTotalAmounts {
    totalChargesForSettlement
    totalEligibleAmountForStop
    totalDriverPayout
  }
  shipperBillOfLadingNumber
  orderName
  billingPartyContactName
  isAttempt
  packages {
    uuid
    quantity
    weight
  }
  otherDriversOnStop {
    uuid
    firstName
    lastName
  }
  order {
    totalCharge
  }
}
    ${StopDriverMapAddressForDownloadFragmentDoc}`;
export const DriverSettlementBillForDownloadFragmentDoc = gql`
    fragment DriverSettlementBillForDownload on DriverSettlementBillForDownloadEntity {
  billUuid
  billName
  billStartDate
  billEndDate
  settlementDate
  finalizedDate
  driverFirstName
  driverLastName
  driverStationCode
  settlementDeductions {
    name
    flatRate
    percentageDecimalRate
  }
  driverStationCode
  stopDriverMaps {
    ...StopDriverMapForDownload
  }
}
    ${StopDriverMapForDownloadFragmentDoc}`;
export const SettlementDeductionFragmentDoc = gql`
    fragment SettlementDeduction on SettlementDeductionEntity {
  uuid
  adjustmentType
  name
  flatRate
  percentageDecimalRate
}
    `;
export const DriverSettlementBillFragmentDoc = gql`
    fragment DriverSettlementBill on DriverSettlementBillEntity {
  uuid
  name
  createdAt
  billStartDate
  billEndDate
  payPeriod
  settlementDate
  totalDriverPayoutPreDeduction
  driver {
    uuid
    firstName
    lastName
    user {
      name
    }
  }
  finalizedDate
  settlementDeductions {
    ...SettlementDeduction
  }
}
    ${SettlementDeductionFragmentDoc}`;
export const StopDriverMapWithDriverSettlementTotalAmountsFragmentDoc = gql`
    fragment StopDriverMapWithDriverSettlementTotalAmounts on StopDriverMapEntity {
  driverSettlementTotalAmounts {
    totalChargesForSettlement
    totalEligibleAmountForStop
    totalDriverPayout
  }
}
    `;
export const StopDriverMapSummaryFragmentDoc = gql`
    fragment StopDriverMapSummary on StopDriverMapEntity {
  uuid
  name
  driver {
    uuid
    firstName
    lastName
    driverType
  }
  stop {
    uuid
    settlementDeductionName
    settlementDeductionFlatRate
    settlementDeductionPercentageRate
    stopType
    arrivedAt
    completedAt
    shipment {
      order {
        uuid
        standardOrderFields {
          shipperBillOfLadingNumber
        }
        secondaryRefNumber
        refNumbers
        name
        billingPartyContact {
          displayName
        }
      }
      standardShipmentFields {
        pickupOrDelivery
      }
      shipmentType
    }
    address {
      name
    }
  }
  ...StopDriverMapWithDriverSettlementTotalAmounts @include(if: $includeTotalAmounts)
  driverSettlementBill {
    name
    settlementDate
  }
  enableDriverSettlement
  revenuePercentageRate
  revenueFlatRate
  driverPayoutFinalized
}
    ${StopDriverMapWithDriverSettlementTotalAmountsFragmentDoc}`;
export const StopDriverMapFragmentDoc = gql`
    fragment StopDriverMap on StopDriverMapEntity {
  uuid
  name
  driver {
    firstName
    lastName
    uuid
    driverType
    driverReferenceNumber
    defaultFuelSettlementPercentageRate
  }
  stop {
    uuid
    settlementDeductionName
    settlementDeductionFlatRate
    settlementDeductionPercentageRate
    stopType
    arrivedAt
    completedAt
    shipment {
      order {
        uuid
        standardOrderFields {
          shipperBillOfLadingNumber
        }
        secondaryRefNumber
        refNumbers
        name
      }
      standardShipmentFields {
        pickupOrDelivery
        service {
          name
        }
      }
      packages {
        quantity
        weight
      }
      shipmentType
    }
    address {
      ...Address
    }
  }
  driverSettlementTotalAmounts {
    totalChargesForSettlement
    totalEligibleAmountForStop
    totalDriverPayout
  }
  driverSettlementBill {
    name
  }
  enableDriverSettlement
  revenuePercentageRate
  revenueFlatRate
  driverPayoutFinalized
}
    ${AddressFragmentDoc}`;
export const CsvOrderFieldMappingDetailedFragmentDoc = gql`
    fragment CsvOrderFieldMappingDetailed on CsvOrderFieldMappingEntity {
  sourceColumnName
  targetFieldType
}
    `;
export const CsvOrderMappingDetailedFragmentDoc = gql`
    fragment CsvOrderMappingDetailed on CsvOrderMappingEntity {
  uuid
  name
  csvOrderFieldMappings {
    ...CsvOrderFieldMappingDetailed
  }
  contact {
    uuid
  }
  enableDynamicInboundOrOutboundStop
  enableInboundStop
  enableOutboundStop
  pickupOrDeliveryDefaultValue
  serviceLevelDefaultValue {
    uuid
  }
  deadlineDateDefaultValue
  deadlineTypeDefaultValue
  stopTypeDefaultValue
  freightBillingMethodDefaultValue
  updateOrderOnDuplicateBolNumber
}
    ${CsvOrderFieldMappingDetailedFragmentDoc}`;
export const CsvOrderMappingShallowFragmentDoc = gql`
    fragment CsvOrderMappingShallow on CsvOrderMappingEntity {
  uuid
  name
  csvOrderFieldMappings {
    uuid
  }
}
    `;
export const EndOfDocumentsProcessingJobFragmentDoc = gql`
    fragment EndOfDocumentsProcessingJob on EndOfDayDocumentProcessingJobEntity {
  uuid
  dateUploadedFor
  uploadedFileName
  status
}
    `;
export const EquipmentFragmentDoc = gql`
    fragment Equipment on EquipmentEntity {
  uuid
  name
  capacity
  measurementSystem
  weight
  length
  width
  height
  notes
  type
  samsaraVehicleId
  vehicleType {
    ...VehicleType
  }
}
    ${VehicleTypeFragmentDoc}`;
export const FuelChargeFuelProfileDateRangeFragmentDoc = gql`
    fragment FuelChargeFuelProfileDateRange on FuelProfileDateRangeEntity {
  uuid
  startDate
  expirationDate
  surchargeRate
  flatRateUsdCents
}
    `;
export const LineHaulFuelChargeFuelProfileDateRangeFragmentDoc = gql`
    fragment LineHaulFuelChargeFuelProfileDateRange on FuelProfileDateRangeEntity {
  uuid
  startDate
  expirationDate
  surchargeRate
  flatRateUsdCents
}
    `;
export const OrderForPackingSlipFragmentDoc = gql`
    fragment OrderForPackingSlip on OrderEntity {
  uuid
  name
  createdAt
  billingPartyContact {
    uuid
    displayName
    defaultAddress {
      uuid
      name
      line1
      line2
      city
      state
      zip
      country
    }
  }
  standardOrderFields {
    shipperBillOfLadingNumber
    masterAirwayBillOfLadingNumber
  }
  outboundShipment {
    standardShipmentFields {
      deliveryDate
    }
    legs {
      endStop {
        address {
          name
          line1
          line2
          city
          state
          zip
        }
        terminal {
          code
        }
        serviceDate
        outboundCarrier
        appointmentTime
        endAppointmentTime
        consigneeAddress {
          uuid
          name
          line1
          line2
          city
          state
          zip
        }
      }
    }
  }
}
    `;
export const PicklistsFragmentDoc = gql`
    fragment Picklists on PicklistEntity {
  id
  date
  outboundReferenceNumber
  picklistItemGroups {
    id
    pickedQuantity
    pickedStatus
    itemGroup {
      uuid
      quantity
      item {
        sku
        description
        primaryUOM {
          unitOfMeasure
        }
      }
      storageUnit {
        name
        warehouseLocation {
          name
        }
        storageOrder {
          uuid
          referenceNumber
          supplierCompanyName
          purchaseOrderNumber
          lotNumber
          contact {
            uuid
            displayName
            company {
              uuid
            }
            defaultAddress {
              name
              line1
              line2
              city
              state
              zip
              country
            }
          }
          warehouse {
            uuid
            name
          }
        }
      }
    }
  }
}
    `;
export const CustomChargeForOrderFragmentDoc = gql`
    fragment CustomChargeForOrder on CustomChargeEntity {
  name
  total
  accessorialTemplate {
    uuid
    name
    __typename
  }
}
    `;
export const ConsolidatableOrderSummaryFragmentDoc = gql`
    fragment ConsolidatableOrderSummary on OrderEntity {
  uuid
  name
  standardOrderFields {
    shipperBillOfLadingNumber
    weightUnits
  }
  totalCharge
  freightChargeRevenue
  fuelChargeRevenue
  customCharges {
    ...CustomChargeForOrder
  }
  weight
  dimWeight
  packages {
    uuid
    quantity
    type
  }
  shipments {
    legs {
      endStop {
        stopType
        address {
          ...Address
        }
      }
    }
  }
}
    ${CustomChargeForOrderFragmentDoc}
${AddressFragmentDoc}`;
export const CustomDriverFormFragmentDoc = gql`
    fragment CustomDriverForm on DriverSignableFormTemplateEntity {
  uuid
  title
  formText
}
    `;
export const DocumentFragmentDoc = gql`
    fragment Document on DocumentEntity {
  uuid
  fileName
  bucket
  region
  key
  uploadedAt
  fileType
  isDeleted
  preSignedGetUrl
  name
  type
  pageNumber
  createdAt
  order {
    uuid
    standardOrderFields {
      shipperBillOfLadingNumber
    }
  }
  shipment {
    uuid
  }
  driverFormTemplate {
    ...CustomDriverForm
  }
  notes
}
    ${CustomDriverFormFragmentDoc}`;
export const InvoiceShipmentOrderForDownloadFragmentFragmentDoc = gql`
    fragment InvoiceShipmentOrderForDownloadFragment on OrderEntity {
  uuid
  isCrossDock
  name
  refNumbers
  secondaryRefNumber
  consolidatedShipmentString
  orderComments {
    uuid
    comment
    showOnInvoice
  }
  documents {
    ...Document
  }
  service {
    name
  }
  standardOrderFields {
    shipperBillOfLadingNumber
    masterAirwayBillOfLadingNumber
    dimFactor
  }
}
    ${DocumentFragmentDoc}`;
export const InvoiceShipmentForDownloadFragmentFragmentDoc = gql`
    fragment InvoiceShipmentForDownloadFragment on ShipmentEntity {
  name
  shipmentType
  standardShipmentFields {
    pickupOrDelivery
  }
  inputForConsolidatedOrder {
    name
  }
  shipmentCharges {
    totalCharge
    totalFreightCharge
    totalFuelCharge
  }
  packages {
    length
    width
    height
    quantity
    weight
  }
  order {
    ...InvoiceShipmentOrderForDownloadFragment
  }
  charges {
    ... on CustomChargeEntity {
      name
      description
      total
      accessorialTemplate {
        name
        invoiceDisplayName
      }
      authoCode
    }
    ... on FreightChargeEntity {
      tariff {
        tariffZone {
          type
          name
        }
      }
      description
      authoCode
      fuelCharge {
        description
        authoCode
      }
    }
  }
  legs {
    endStop {
      completedAt
      proofOfDeliverySignee
      address {
        name
        line1
        line2
        zip
        city
        state
      }
    }
  }
}
    ${InvoiceShipmentOrderForDownloadFragmentFragmentDoc}`;
export const InvoiceForDownloadFragmentFragmentDoc = gql`
    fragment InvoiceForDownloadFragment on InvoiceEntity {
  uuid
  billToContact {
    uuid
    displayName
    defaultAddress {
      ...Address
    }
    businessDivision {
      name
    }
    invoiceNotes
  }
  dueDate
  date
  invoiceTerms {
    uuid
    terms
  }
  name
  journalNumber
  shipments {
    ...InvoiceShipmentForDownloadFragment
  }
}
    ${AddressFragmentDoc}
${InvoiceShipmentForDownloadFragmentFragmentDoc}`;
export const InvoiceShipmentFragmentFragmentDoc = gql`
    fragment InvoiceShipmentFragment on ShipmentEntity {
  uuid
  overridePackageWeight
  totalChargesAmount
  shouldUseDimWeight
  totalCustomChargesAmount
  totalFuelChargesAmount
  totalFreightChargesAmount
  status
  name
  failureCount
  hasFailedStop
  standardShipmentFields {
    pickupOrDelivery
    deliveryDate
    dimFactor
  }
  documents {
    ...Document
  }
  packages {
    uuid
    weight
    description
    quantity
    length
    width
    height
    type
  }
  charges {
    ... on CustomChargeEntity {
      uuid
      name
      zoneBasedAccessorialZoneUuid
      zoneBasedAccessorialChargeGroupUuid
      specialAccessorialTariffZoneUuid
      specialAccessorialChargeGroupUuid
      quantity
      description
      authoCode
      rate
      total
      customChargeBillingMethod: billingMethod
      accessorialTemplate {
        uuid
        name
        __typename
      }
    }
    ... on FreightChargeEntity {
      uuid
      billingMethod
      tariff {
        uuid
        billingPartyContactUuid
        tariffOverageRates {
          uuid
          name
          type
          rateUsdCents
          applicableAboveAmount
        }
        tariffZone {
          name
          type
        }
      }
      rate
      description
      authoCode
      quantity
      fuelCharge {
        description
        authoCode
        surchargeRate
        flatRate
        type
        uuid
      }
    }
  }
  uuid
  status
  shouldUseDimWeight
  standardShipmentFields {
    shipmentWeight: weight
    service {
      ...Service
    }
    uuid
    type
  }
  charges {
    ... on CustomChargeEntity {
      uuid
      name
      zoneBasedAccessorialZoneUuid
      zoneBasedAccessorialChargeGroupUuid
      specialAccessorialTariffZoneUuid
      specialAccessorialChargeGroupUuid
      quantity
      description
      authoCode
      rate
      accessorialTemplate {
        uuid
        name
        __typename
      }
    }
    ... on FreightChargeEntity {
      uuid
      description
      authoCode
      quantity
      tariff {
        uuid
        billingPartyContactUuid
        tariffOverageRates {
          uuid
          name
          type
          rateUsdCents
          applicableAboveAmount
        }
      }
      fuelCharge {
        description
        authoCode
        flatRate
        type
        surchargeRate
        uuid
      }
    }
  }
  legs {
    uuid
    miles
    endStop {
      uuid
      arrivedAt
      completedAt
      appointmentRequired
      status
      proofOfDeliverySignee
      paperworkMarkedComplete
      address {
        name
        uuid
        line1
        line2
        zip
        city
        state
      }
    }
  }
  order {
    uuid
    createdAt
    name
    refNumbers
    totalCharge
    secondaryRefNumber
    billingPartyContact {
      businessDivision {
        name
      }
    }
    standardOrderFields {
      uuid
      shipperBillOfLadingNumber
      masterAirwayBillOfLadingNumber
      weightUnits
    }
  }
  shipmentType
}
    ${DocumentFragmentDoc}
${ServiceFragmentDoc}`;
export const InvoiceFragmentFragmentDoc = gql`
    fragment InvoiceFragment on InvoiceEntity {
  uuid
  status
  billToContact {
    uuid
    displayName
    defaultAddress {
      uuid
    }
    addresses {
      uuid
    }
    contactPersons {
      uuid
    }
  }
  createdAt
  lastSyncedToQuickbooksAt
  quickbooksInvoiceId
  documents {
    ...Document
  }
  dueDate
  date
  invoiceTotal
  invoiceTerms {
    uuid
    terms
  }
  inConsolidatedInvoice
  name
  notes
  qbInvoiceNumber
  journalNumber
  shipments {
    ...InvoiceShipmentFragment
    uuid
    totalChargesAmount
    charges {
      ... on CustomChargeEntity {
        uuid
        name
        zoneBasedAccessorialZoneUuid
        zoneBasedAccessorialChargeGroupUuid
        specialAccessorialTariffZoneUuid
        specialAccessorialChargeGroupUuid
        quantity
        description
        rate
        customChargeBillingMethod: billingMethod
        accessorialTemplate {
          uuid
          name
          percentForSettlement
        }
      }
      ... on FreightChargeEntity {
        uuid
        billingMethod
        tariff {
          uuid
          billingPartyContactUuid
          tariffOverageRates {
            uuid
            name
            type
            rateUsdCents
            applicableAboveAmount
          }
        }
        rate
        description
        quantity
        fuelCharge {
          description
          surchargeRate
          flatRate
          uuid
        }
      }
    }
    customCharges {
      uuid
      accessorialTemplate {
        uuid
        name
        percentForSettlement
      }
      customChargeBillingMethod: billingMethod
      description
      name
      quantity
      rate
      zoneBasedAccessorialChargeGroupUuid
      zoneBasedAccessorialZoneUuid
      specialAccessorialTariffZoneUuid
      specialAccessorialChargeGroupUuid
    }
    failureCount
    freightCharge {
      uuid
      billingMethod
      description
      fuelCharge {
        description
        surchargeRate
        uuid
        freightCharge {
          uuid
        }
      }
      quantity
      rate
      tariff {
        uuid
        billingPartyContactUuid
        tariffOverageRates {
          uuid
          name
          type
          rateUsdCents
          applicableAboveAmount
        }
      }
    }
    hasFailedStop
    legs {
      uuid
      endStop {
        isSpecial
        uuid
        arrivedAt
        completedAt
        status
        address {
          ...Address
        }
      }
      miles
    }
    name
    order {
      uuid
      secondaryRefNumber
      orderInvoiceByDate
      name
      ediTransactions {
        code
        status
      }
      standardOrderFields {
        shipperBillOfLadingNumber
      }
      shipments {
        uuid
        documents {
          ...Document
        }
      }
    }
    packages {
      ...Package
    }
    standardShipmentFields {
      uuid
      deliveryDate
      pickupOrDelivery
      service {
        ...Service
      }
      shipmentWeight: weight
    }
    status
    ... on StandardShipmentEntity {
      uuid
      status
      charges {
        ... on CustomChargeEntity {
          uuid
          name
          zoneBasedAccessorialZoneUuid
          zoneBasedAccessorialChargeGroupUuid
          specialAccessorialTariffZoneUuid
          specialAccessorialChargeGroupUuid
          quantity
          description
          rate
          accessorialTemplate {
            uuid
            name
            percentForSettlement
          }
        }
        ... on FreightChargeEntity {
          uuid
          description
          quantity
          tariff {
            uuid
            billingPartyContactUuid
            tariffOverageRates {
              uuid
              name
              type
              rateUsdCents
              applicableAboveAmount
            }
          }
          fuelCharge {
            description
            surchargeRate
            uuid
          }
        }
      }
    }
  }
}
    ${DocumentFragmentDoc}
${InvoiceShipmentFragmentFragmentDoc}
${AddressFragmentDoc}
${PackageFragmentDoc}
${ServiceFragmentDoc}`;
export const RecoveryTerminalFragmentDoc = gql`
    fragment RecoveryTerminal on AirportInfoEntity {
  uuid
  iataCode
  terminal
  address {
    ...Address
  }
}
    ${AddressFragmentDoc}`;
export const ShallowTerminalFragmentDoc = gql`
    fragment ShallowTerminal on TerminalEntity {
  name
  code
  uuid
  address {
    line1
    line2
    city
    state
    zip
    uuid
    name
    latitude
    longitude
  }
  isActive
  startForTerminalLanes {
    id
    endTerminal {
      uuid
      code
      name
    }
  }
  agent {
    name
  }
}
    `;
export const DriverFragmentDoc = gql`
    fragment Driver on DriverEntity {
  firstName
  lastName
  user {
    name
  }
  uuid
  defaultVehicle {
    uuid
  }
  driverType
  driverReferenceNumber
  defaultFuelSettlementPercentageRate
  terminal {
    uuid
    name
  }
  qualifications {
    id
  }
}
    `;
export const StopDriverMapForOrderFragmentDoc = gql`
    fragment StopDriverMapForOrder on StopDriverMapEntity {
  uuid
  name
  driver {
    ...Driver
  }
  driverSettlementBill {
    uuid
  }
  stop {
    uuid
    completedAt
    settlementDeductionName
    settlementDeductionFlatRate
    settlementDeductionPercentageRate
  }
  enableDriverSettlement
  revenuePercentageRate
  revenueFlatRate
  driverPayoutFinalized
}
    ${DriverFragmentDoc}`;
export const StandardOrderQueryStopFragmentDoc = gql`
    fragment StandardOrderQueryStop on StopEntity {
  uuid
  createdAt
  specialInstructions
  address {
    ...Address
    preventCoordRecompute
    internalNotes
    iataCode
  }
  destinationAirport
  inboundDeadlineDate
  expectedOutboundDate
  outboundCarrier
  appointmentTextStatus
  incomingCarrier
  appointmentCallStatus
  appointmentManuallyConfirmed
  deadlineTime
  settlementDeductionFlatRate
  settlementDeductionPercentageRate
  settlementDeductionName
  proofOfDeliverySignee
  appointmentTime
  arrivedAt
  completedAt
  inboundMethod
  expectedInboundArrivalDate
  outboundMethod
  transferAddress {
    ...Address
  }
  consigneeAddress {
    ...Address
  }
  consigneeContactPerson {
    ...ContactPerson
  }
  driverCompletedAt
  notes
  serviceDate
  serviceDateV2 {
    iso8601
  }
  shipperAddress {
    ...Address
  }
  shipperContactPerson {
    ...ContactPerson
  }
  status
  appointmentRequired
  endAppointmentTime
  isSpecial
  hideFromDispatch
  routeSlot {
    uuid
    route {
      uuid
      date
      name
      slots {
        uuid
      }
      drivers {
        uuid
        firstName
        lastName
        driverType
        agent {
          uuid
          name
        }
      }
      equipments {
        uuid
        name
      }
    }
  }
  contactPerson {
    ...ContactPerson
  }
  standardStopType
  stopType
  paperworkMarkedComplete
  terminal {
    ...ShallowTerminal
  }
  canMarkAttemptComplete
  stopDriverMaps {
    ...StopDriverMapForOrder
  }
  sentToAgentAt
  confirmedByAgentAt
}
    ${AddressFragmentDoc}
${ContactPersonFragmentDoc}
${ShallowTerminalFragmentDoc}
${StopDriverMapForOrderFragmentDoc}`;
export const CustomChargeFragmentDoc = gql`
    fragment CustomCharge on CustomChargeEntity {
  uuid
  rate
  description
  total
  totalAmountCents
  postedAmountUsdCents
  authoCode
  quantity
  billingMethod
  isAutoApplied
  name
  fuelSurchargeRate
  postedFuelSurchargeRate
  zoneBasedAccessorialMatrixItem {
    uuid
  }
  zoneBasedAccessorialChargeGroupUuid
  zoneBasedAccessorialZoneUuid
  specialAccessorialMatrixItem {
    uuid
  }
  specialAccessorialTariffZoneUuid
  specialAccessorialChargeGroupUuid
  accessorialRange {
    ...AccessorialRange
  }
  accessorialTemplate {
    uuid
    name
    type
  }
  settlementFlatRate
  settlementPercentageRate
}
    ${AccessorialRangeFragmentDoc}`;
export const TariffShallowFragmentDoc = gql`
    fragment TariffShallow on TariffEntity {
  uuid
  billingPartyContactUuid
  tariffGroup {
    name
    tariffGroupScope
  }
  tariffZone {
    name
  }
}
    `;
export const StandardShipmentFreightChargeFragmentDoc = gql`
    fragment StandardShipmentFreightCharge on FreightChargeEntity {
  uuid
  quantity
  fuelCharge {
    uuid
    surchargeRate
    description
    authoCode
    flatRate
    type
    settlementFlatRate
    settlementPercentageRate
    totalAmountCents
    postedAmountUsdCents
  }
  tariff {
    ...TariffShallow
  }
  billingMethod
  description
  authoCode
  rate
  discountRate
  settlementFlatRate
  settlementPercentageRate
  total
  totalAmountCents
  postedAmountUsdCents
}
    ${TariffShallowFragmentDoc}`;
export const ShipmentChargesFragmentDoc = gql`
    fragment ShipmentCharges on ShipmentChargeEntity {
  totalFuelCharge
  totalCustomCharge
  totalFreightCharge
  totalCharge
}
    `;
export const FuelCostForOrderFragmentDoc = gql`
    fragment FuelCostForOrder on FuelCostEntity {
  id
  billingMethod
  dependentSettlementBillingMethod
  percentageRate
  surchargeRate
  flatRateUsdDollars
  totalAmountUsdDollars
  totalAmountUsdCents
}
    `;
export const FreightCostForOrderFragmentDoc = gql`
    fragment FreightCostForOrder on FreightCostEntity {
  id
  billingMethod
  dependentSettlementBillingMethod
  percentageRate
  flatRateUsdDollars
  quantity
  rateUsdDollars
  discountRate
  totalAmountUsdDollars
  totalAmountUsdCents
  tariff {
    uuid
    tariffZone {
      name
    }
  }
  fuelCost {
    ...FuelCostForOrder
  }
}
    ${FuelCostForOrderFragmentDoc}`;
export const CustomCostForOrderFragmentDoc = gql`
    fragment CustomCostForOrder on CustomCostEntity {
  id
  name
  billingMethod
  dependentSettlementBillingMethod
  percentageRate
  flatRateUsdDollars
  quantity
  rateUsdDollars
  fuelSurchargeRate
  totalAmountUsdDollars
  totalAmountUsdCents
  accessorialTemplate {
    __typename
    uuid
    name
    type
  }
  specialAccessorialMatrixItem {
    uuid
    zoneUuid
    chargeGroupUuid
  }
  zoneBasedAccessorialMatrixItem {
    uuid
    zoneUuid
    chargeGroupUuid
  }
  accessorialRange {
    uuid
  }
}
    `;
export const SettlementBillLineItemForOrderFragmentDoc = gql`
    fragment SettlementBillLineItemForOrder on SettlementBillLineItemEntity {
  id
  settlementMode
  totalAmountUsdDollars
  revenuePercentageRate
  revenueFlatRate
  driver {
    uuid
    user {
      name
    }
  }
  driverSettlementBill {
    uuid
    name
    finalizedDate
  }
  freightCost {
    ...FreightCostForOrder
  }
  customCosts {
    ...CustomCostForOrder
  }
}
    ${FreightCostForOrderFragmentDoc}
${CustomCostForOrderFragmentDoc}`;
export const StandardShipmentFragmentDoc = gql`
    fragment StandardShipment on StandardShipmentEntity {
  uuid
  totalChargesAmount
  totalAmountCents
  postedAmountCents
  shouldBillIndividually
  shouldUseDimWeight
  overridePackageWeight
  name
  hideFromBilling
  hasSignedPOD
  invoice {
    uuid
    date
    postedAt
    dueDate
    name
    billToContact {
      uuid
    }
    journalNumber
  }
  documents {
    ...Document
  }
  shipmentSubscribers {
    uuid
    email
  }
  shipmentType
  shipperAddress {
    ...Address
  }
  airportInfo {
    ...RecoveryTerminal
  }
  fields {
    uuid
    deadlineDate
    deadlineType
    deliveryDate
    dimFactor
    pickupOrDelivery
    outboundMethod
    inboundMethod
    service {
      ...Service
    }
    type
  }
  legs {
    uuid
    miles
    endStop {
      ...StandardOrderQueryStop
    }
    previousStopAttempts {
      stopDriverMaps {
        ...StopDriverMapForOrder
      }
    }
  }
  packages {
    ...Package
  }
  customCharges {
    ...CustomCharge
  }
  freightCharge {
    ...StandardShipmentFreightCharge
  }
  status
  inputForConsolidatedOrder {
    uuid
    name
  }
  shipmentType
  shipmentCharges {
    ...ShipmentCharges
  }
  independentSettlementBillLineItems {
    ...SettlementBillLineItemForOrder
  }
}
    ${DocumentFragmentDoc}
${AddressFragmentDoc}
${RecoveryTerminalFragmentDoc}
${ServiceFragmentDoc}
${StandardOrderQueryStopFragmentDoc}
${StopDriverMapForOrderFragmentDoc}
${PackageFragmentDoc}
${CustomChargeFragmentDoc}
${StandardShipmentFreightChargeFragmentDoc}
${ShipmentChargesFragmentDoc}
${SettlementBillLineItemForOrderFragmentDoc}`;
export const OutstandingOrderQueryStopFragmentDoc = gql`
    fragment OutstandingOrderQueryStop on StopEntity {
  uuid
  createdAt
  specialInstructions
  stopType
  address {
    ...Address
    internalNotes
    iataCode
  }
  appointmentRequired
  deadlineTime
  proofOfDeliverySignee
  arrivedAt
  completedAt
  inboundMethod
  expectedInboundArrivalDate
  outboundMethod
  driverCompletedAt
  notes
  serviceDate
  serviceDateV2 {
    iso8601
  }
  status
  appointmentTime
  endAppointmentTime
  isSpecial
  settlementDeductionFlatRate
  settlementDeductionName
  settlementDeductionPercentageRate
  routeSlot {
    uuid
    route {
      uuid
      date
      name
      slots {
        uuid
      }
      drivers {
        uuid
        firstName
        lastName
        driverType
        agent {
          uuid
          name
        }
      }
      equipments {
        uuid
        name
      }
    }
  }
  standardStopType
  paperworkMarkedComplete
  terminal {
    ...ShallowTerminal
  }
  stopDriverMaps {
    ...StopDriverMapForOrder
  }
  sentToAgentAt
  confirmedByAgentAt
}
    ${AddressFragmentDoc}
${ShallowTerminalFragmentDoc}
${StopDriverMapForOrderFragmentDoc}`;
export const OutstandingShipmentOrderShipmentFragmentDoc = gql`
    fragment OutstandingShipmentOrderShipment on StandardShipmentEntity {
  uuid
  totalChargesAmount
  shouldBillIndividually
  shouldUseDimWeight
  overridePackageWeight
  name
  hideFromBilling
  hasSignedPOD
  documents {
    ...Document
  }
  shipmentSubscribers {
    uuid
    email
  }
  standardShipmentFields {
    uuid
    pickupOrDelivery
  }
  fields {
    uuid
    deadlineDate
    deadlineType
    deliveryDate
    dimFactor
    pickupOrDelivery
    service {
      ...Service
    }
    type
  }
  legs {
    uuid
    miles
    endStop {
      ...OutstandingOrderQueryStop
    }
    previousStopAttempts {
      stopDriverMaps {
        ...StopDriverMapForOrder
      }
    }
  }
  packages {
    ...Package
  }
  customCharges {
    ...CustomCharge
  }
  freightCharge {
    uuid
    quantity
    fuelCharge {
      uuid
      surchargeRate
      description
      authoCode
      flatRate
      type
      settlementFlatRate
      settlementPercentageRate
    }
    tariff {
      ...TariffShallow
    }
    billingMethod
    description
    authoCode
    rate
    settlementFlatRate
    settlementPercentageRate
    total
  }
  status
  inputForConsolidatedOrder {
    uuid
  }
  shipmentType
  shipmentCharges {
    ...ShipmentCharges
  }
}
    ${DocumentFragmentDoc}
${ServiceFragmentDoc}
${OutstandingOrderQueryStopFragmentDoc}
${StopDriverMapForOrderFragmentDoc}
${PackageFragmentDoc}
${CustomChargeFragmentDoc}
${TariffShallowFragmentDoc}
${ShipmentChargesFragmentDoc}`;
export const OutstandingShipmentOrderFragmentDoc = gql`
    fragment OutstandingShipmentOrder on OrderEntity {
  uuid
  billingPartyContact {
    uuid
  }
  consolidatedShipmentString
  name
  detailedStatusV2
  status
  notes
  packages {
    ...Package
  }
  orderConsolidationType
  shipments {
    ...OutstandingShipmentOrderShipment
  }
  source
  secondaryRefNumber
  standardOrderFields {
    uuid
    dimFactor
    shipperBillOfLadingNumber
    masterAirwayBillOfLadingNumber
  }
  tags {
    ...Tag
  }
}
    ${PackageFragmentDoc}
${OutstandingShipmentOrderShipmentFragmentDoc}
${TagFragmentDoc}`;
export const ConsolidatableShipmentFragmentDoc = gql`
    fragment ConsolidatableShipment on ShipmentEntity {
  ...StandardShipment
  order {
    ...OutstandingShipmentOrder
  }
}
    ${StandardShipmentFragmentDoc}
${OutstandingShipmentOrderFragmentDoc}`;
export const OutstandingShipmentFragmentDoc = gql`
    fragment OutstandingShipment on ShipmentEntity {
  consolidatableShipments {
    uuid
    order {
      ...OutstandingShipmentOrder
    }
  }
  order {
    ...OutstandingShipmentOrder
  }
  uuid
  standardShipmentFields {
    uuid
    pickupOrDelivery
  }
  totalChargesAmount
  legs {
    uuid
    endStop {
      address {
        name
        internalNotes
        iataCode
      }
      completedAt
    }
  }
  status
}
    ${OutstandingShipmentOrderFragmentDoc}`;
export const InvoiceEdiTransactionFragmentDoc = gql`
    fragment InvoiceEdiTransaction on EdiTransactionEntity {
  createdAt
  status
  order {
    name
    secondaryRefNumber
    standardOrderFields {
      shipperBillOfLadingNumber
    }
  }
}
    `;
export const InvoiceForDunningReportFragmentDoc = gql`
    fragment InvoiceForDunningReport on InvoiceEntity {
  uuid
  name
  dueDate
  date
  createdAt
  journalNumber
  invoiceTotal
  balanceInCents
  orders {
    uuid
    name
    refNumbers
    totalCharge
    balanceInCents
    standardOrderFields {
      shipperBillOfLadingNumber
      masterAirwayBillOfLadingNumber
    }
    endStop {
      serviceDate
    }
    startStop {
      serviceDate
    }
  }
}
    `;
export const BatchAddShipmentsToInvoicesPreviewFragmentDoc = gql`
    fragment BatchAddShipmentsToInvoicesPreview on BatchAddShipmentsToInvoicePreview {
  contactName
  contactUuid
  existingInvoiceAdds {
    uuid
    name
    shipmentUuids
  }
  newInvoiceAdds {
    name
    shipmentUuids
  }
  billingCycleDuration
}
    `;
export const BatchAddShipmentsToInvoicesResultInvoiceFragmentDoc = gql`
    fragment BatchAddShipmentsToInvoicesResultInvoice on InvoiceEntity {
  uuid
  name
  journalNumber
  billToContact {
    uuid
    displayName
  }
  shipments {
    uuid
    legs {
      endStop {
        stopType
      }
    }
    order {
      standardOrderFields {
        shipperBillOfLadingNumber
      }
    }
  }
}
    `;
export const OrderForConsolidationFlowFragmentDoc = gql`
    fragment OrderForConsolidationFlow on OrderEntity {
  uuid
  standardOrderFields {
    shipperBillOfLadingNumber
  }
  billingPartyContact {
    uuid
    displayName
  }
  inboundShipment {
    uuid
    legs {
      endStop {
        address {
          name
          line1
        }
      }
    }
    freightCharge {
      uuid
    }
  }
  outboundShipment {
    uuid
    legs {
      endStop {
        address {
          name
          line1
        }
      }
    }
    freightCharge {
      uuid
    }
  }
  lineHaulLane {
    name
  }
  weight
  dimWeight
  name
  status
  pieceCountFromPackages
}
    `;
export const ProratedShipmentV2FragmentDoc = gql`
    fragment ProratedShipmentV2 on ProratedShipment {
  initialFreightChargeTotal
  proratedFreightChargeTotal
  initialFuelChargeTotal
  proratedFuelChargeTotal
  customCharges {
    initialTotal
    proratedTotal
    name
  }
}
    `;
export const ProratedOrderV2FragmentDoc = gql`
    fragment ProratedOrderV2 on ProratedOrder {
  uuid
  name
  hawb
  proportionForConsolidation
  proportionOfTotalWeight
  weight
  inboundShipment {
    ...ProratedShipmentV2
  }
  outboundShipment {
    ...ProratedShipmentV2
  }
  totalAfterProrating
  lineHaulInitialTotal
  orderChargesInitialTotal
}
    ${ProratedShipmentV2FragmentDoc}`;
export const SimpleFreightChargeFragmentDoc = gql`
    fragment SimpleFreightCharge on SimpleFreightCharge {
  billingMethod
  rate
  quantity
  amount
}
    `;
export const SimpleFuelChargeFragmentDoc = gql`
    fragment SimpleFuelCharge on SimpleFuelCharge {
  billingMethod
  quantity
  amount
}
    `;
export const SimpleCustomChargeFragmentDoc = gql`
    fragment SimpleCustomCharge on SimpleCustomCharge {
  name
  amount
}
    `;
export const ProratedShipmentFragmentDoc = gql`
    fragment ProratedShipment on ProratedShipmentInformation {
  shipment {
    uuid
  }
  initialFreightCharge {
    totalCents
  }
  initialFuelCharge {
    totalCents
  }
  proratedFreightCharge {
    totalCents
  }
  proratedFuelCharge {
    totalCents
  }
  customCharges {
    initialOrderUuidsPresentIn
    initialTotalCents
    proratedTotalCents
    name
  }
  freightAndFuelProrateMultiplier
}
    `;
export const ProratedOrderFragmentDoc = gql`
    fragment ProratedOrder on ProratedOrderInformation {
  order {
    uuid
    name
    standardOrderFields {
      shipperBillOfLadingNumber
    }
    inboundShipment {
      totalChargesAmount
    }
    outboundShipment {
      totalChargesAmount
    }
    lineHaulShipment {
      totalChargesAmount
    }
    orderChargesShipment {
      totalChargesAmount
    }
    totalCharge
  }
  inboundShipment {
    ...ProratedShipment
  }
  outboundShipment {
    ...ProratedShipment
  }
}
    ${ProratedShipmentFragmentDoc}`;
export const ContactForInvoiceFragmentDoc = gql`
    fragment ContactForInvoice on ContactEntity {
  __typename
  uuid
  displayName
  stediPartnerId
  contactReferenceNumber
  ... on CustomerContactEntity {
    numberOfOrdersPerInvoice
    invoiceTimePeriodSplit
    defaultInvoiceType
    defaultInvoiceTransmissionMethod
    defaultInvoiceDocumentsRequired
    defaultInvoiceDownloadDocuments
    enableCreditHold
    defaultInvoiceEmailSubject
  }
}
    `;
export const InvoiceForContactFragmentDoc = gql`
    fragment InvoiceForContact on InvoiceEntity {
  uuid
  source
  name
  journalNumber
  status
  billToContact {
    uuid
    displayName
  }
  date
  createdAt
}
    `;
export const InvoiceForInvoiceSelectionFragmentDoc = gql`
    fragment InvoiceForInvoiceSelection on InvoiceEntity {
  uuid
  name
  journalNumber
  date
  dueDate
}
    `;
export const OrderPaperworkFragmentDoc = gql`
    fragment OrderPaperwork on OrderPaperworkEntity {
  paperworkComplete
  paperworkMarkedCompleteOverride
  attachedDocuments
  missingDocuments
}
    `;
export const InvoiceOrderFragmentFragmentDoc = gql`
    fragment InvoiceOrderFragment on OrderEntity {
  uuid
  createdAt
  name
  missingDocuments
  documents {
    type
  }
  paperwork {
    ...OrderPaperwork
  }
  appliedAmount
  balanceInCents
  orderPaymentMappings {
    uuid
    amountInCents
    payment {
      paymentType
      contact {
        displayName
        uuid
      }
    }
  }
  secondaryRefNumber
  standardOrderFields {
    uuid
    shipperBillOfLadingNumber
    masterAirwayBillOfLadingNumber
    weightUnits
  }
  orderComments {
    uuid
    comment
    showOnInvoice
  }
  shipments {
    uuid
    shipmentCharges {
      totalCharge
    }
    invoice {
      uuid
    }
  }
  endStop {
    serviceDate
    address {
      name
    }
  }
  pieceCountFromPackages
  weight
}
    ${OrderPaperworkFragmentDoc}`;
export const InvoiceShipmentWithChargesFragmentDoc = gql`
    fragment InvoiceShipmentWithCharges on ShipmentEntity {
  uuid
  overridePackageWeight
  shipmentType
  shipmentCharges {
    totalFreightCharge
    totalFuelCharge
    totalCharge
  }
  shipperAddress {
    ...Address
  }
  standardShipmentFields {
    pickupOrDelivery
  }
  uuid
  status
  name
  legs {
    uuid
    endStop {
      completedAt
      paperworkMarkedComplete
      settlementDeductionName
      settlementDeductionFlatRate
      settlementDeductionPercentageRate
      stopType
      address {
        ...Address
      }
    }
  }
  invoice {
    uuid
  }
  charges {
    ... on CustomChargeEntity {
      uuid
      name
      quantity
      description
      rate
      total
      customChargeBillingMethod: billingMethod
      settlementFlatRate
      settlementPercentageRate
      accessorialTemplate {
        uuid
        name
        invoiceDisplayName
        __typename
      }
      postedFuelSurchargeRate
    }
    ... on FreightChargeEntity {
      uuid
      billingMethod
      tariff {
        uuid
        tariffZone {
          name
          type
        }
      }
      rate
      description
      quantity
      settlementFlatRate
      settlementPercentageRate
      fuelCharge {
        surchargeRate
        flatRate
        type
        uuid
        settlementFlatRate
        settlementPercentageRate
      }
    }
  }
}
    ${AddressFragmentDoc}`;
export const InvoiceOrderWithShipmentsFragmentDoc = gql`
    fragment InvoiceOrderWithShipments on OrderEntity {
  ...InvoiceOrderFragment
  shipments {
    ...InvoiceShipmentWithCharges
  }
}
    ${InvoiceOrderFragmentFragmentDoc}
${InvoiceShipmentWithChargesFragmentDoc}`;
export const InvoiceDocumentForDownloadFragmentDoc = gql`
    fragment InvoiceDocumentForDownload on DocumentEntity {
  fileType
  preSignedGetUrl
  invoice {
    name
    journalNumber
  }
}
    `;
export const InvoiceSendJobBatchFragmentDoc = gql`
    fragment InvoiceSendJobBatch on InvoiceSendJobBatchEntity {
  uuid
  createdAt
  type
  invoiceSendJobBatchProgress {
    totalCount
    failCount
    successCount
  }
  invoiceBatchDocuments {
    invoicesBackupDocument {
      preSignedGetUrl
      fileType
    }
    invoicesCombinedDocument {
      preSignedGetUrl
      fileType
    }
    invoicesZipDocument {
      preSignedGetUrl
      fileType
    }
  }
}
    `;
export const InvoiceSendJobShallowFragmentDoc = gql`
    fragment InvoiceSendJobShallow on InvoiceSendJobEntity {
  uuid
  invoice {
    uuid
    name
    journalNumber
  }
}
    `;
export const InvoiceSendJobFragmentDoc = gql`
    fragment InvoiceSendJob on InvoiceSendJobEntity {
  uuid
  createdAt
  invoiceSendJobError
  invoiceAttachmentDocumentTypes
  invoiceTransmissionMethod
  invoice {
    uuid
    name
    journalNumber
    billToContact {
      displayName
    }
  }
  invoiceChargesObject
  document {
    preSignedGetUrl
  }
  emailTransaction {
    uuid
    emailTransactionStatus
    emailTransactionLogs {
      uuid
      email
      lastStatus
      reason
    }
  }
}
    `;
export const InvoiceStatFragmentDoc = gql`
    fragment InvoiceStat on InvoiceEntity {
  balanceInCents
  invoiceTotal
  uuid
}
    `;
export const InvoiceWithOrdersFragmentDoc = gql`
    fragment InvoiceWithOrders on InvoiceEntity {
  uuid
  source
  name
  journalNumber
  status
  billToContact {
    uuid
    displayName
  }
  date
  createdAt
}
    `;
export const InvoiceForRegisterReportFragmentDoc = gql`
    fragment InvoiceForRegisterReport on InvoiceEntity {
  uuid
  date
  name
  journalNumber
  status
  inConsolidatedInvoice
  dueDate
  billToContact {
    uuid
    displayName
  }
  balanceInCents
  invoiceTotal
}
    `;
export const AverageDaysToPayReportDataFragmentDoc = gql`
    fragment AverageDaysToPayReportData on AverageDaysToPayForContactEntity {
  contactUuid
  displayName
  contactReferenceNumber
  averageDaysToPay90
  averageDaysToPay180
  averageDaysToPay270
  averageDaysToPay360
  averageDaysToPay720
  averageDaysToPayAll
}
    `;
export const ContactWithBalancesFragmentDoc = gql`
    fragment ContactWithBalances on ContactEntity {
  uuid
  displayName
  contactOpenInvoiceValue
  postedInvoicesTotalOpenBalance
  postedInvoicesTotalClosedBalance
  paymentsAppliedToContactInvoices
  unappliedPayments
  creditsAppliedToContactInvoices
  unappliedCredits
  debitsAppliedToContactInvoices
  unappliedDebits
  balance
  ... on CustomerContactEntity {
    creditHoldLimitInCents
    enableCreditHold
  }
}
    `;
export const InvoiceForPaymentFragmentDoc = gql`
    fragment InvoiceForPayment on InvoiceEntity {
  uuid
  name
  date
  journalNumber
}
    `;
export const OrdersForPaymentFragmentDoc = gql`
    fragment OrdersForPayment on OrderEntity {
  uuid
  name
  secondaryRefNumber
  standardOrderFields {
    shipperBillOfLadingNumber
    masterAirwayBillOfLadingNumber
  }
  appliedAmount
  invoice {
    ...InvoiceForPayment
  }
  totalCharge
}
    ${InvoiceForPaymentFragmentDoc}`;
export const PaymentForCheckRegisterReportFragmentDoc = gql`
    fragment PaymentForCheckRegisterReport on PaymentForCheckRegisterReportEntity {
  paymentUuid
  referenceNumber
  paymentDate
  terminalCodes
  contactDisplayName
  contactReferenceNumber
  comment
  amountInCents
}
    `;
export const CreditTypeFragmentDoc = gql`
    fragment CreditType on CreditTypeEntity {
  uuid
  name
  color
  generalLedgerCode {
    code
    description
    id
  }
}
    `;
export const PaymentForInvoiceFragmentDoc = gql`
    fragment PaymentForInvoice on PaymentEntity {
  uuid
  date
  amountInCents
  referenceNumber
  paymentType
  paymentRail
  creditType {
    ...CreditType
  }
  contact {
    uuid
    displayName
    masterAccount {
      uuid
    }
  }
}
    ${CreditTypeFragmentDoc}`;
export const PaymentForReportFragmentDoc = gql`
    fragment PaymentForReport on PaymentEntity {
  uuid
  amountInCents
  referenceNumber
  date
  contact {
    uuid
    displayName
    contactReferenceNumber
  }
  paymentType
  paymentRail
  comment
  creditType {
    name
  }
  paymentToOrderMappings {
    order {
      shipments {
        legs {
          endStop {
            terminal {
              uuid
              code
            }
          }
        }
      }
    }
  }
}
    `;
export const PaymentFragmentDoc = gql`
    fragment Payment on PaymentEntity {
  uuid
  amountInCents
  referenceNumber
  date
  comment
  paymentType
  paymentRail
  creditType {
    ...CreditType
  }
  contact {
    uuid
    masterAccount {
      uuid
    }
  }
  glTerminal {
    name
  }
  unappliedAmountInCents
  paymentToOrderMappings {
    amountInCents
    order {
      uuid
      invoice {
        name
        journalNumber
        uuid
      }
      totalCharge
      standardOrderFields {
        shipperBillOfLadingNumber
      }
    }
  }
}
    ${CreditTypeFragmentDoc}`;
export const InvoiceForQuickbooksFragmentDoc = gql`
    fragment InvoiceForQuickbooks on InvoiceEntity {
  uuid
  createdAt
  name
  dueDate
  qbInvoiceNumber
  status
  billToContact {
    displayName
  }
  invoiceTerms {
    terms
  }
  shipments {
    standardShipmentFields {
      pickupOrDelivery
    }
    order {
      secondaryRefNumber
      refNumbers
      standardOrderFields {
        shipperBillOfLadingNumber
      }
    }
    legs {
      endStop {
        completedAt
      }
    }
    freightCharge {
      uuid
      quantity
      rate
      billingMethod
      description
      fuelCharge {
        type
        flatRate
        surchargeRate
        description
      }
    }
    customCharges {
      uuid
      name
      rate
      description
      quantity
      total
      billingMethod
      accessorialTemplate {
        uuid
      }
    }
  }
}
    `;
export const ContactAccessorialChargeDetailsDataFragmentDoc = gql`
    fragment ContactAccessorialChargeDetailsData on ContactAccessorialChargeDetailsEntity {
  contactUuid
  displayName
  contactReferenceNumber
  shipmentsWithAccessorialCount
  totalAccessorialCharge
}
    `;
export const AccessorialChargeDetailsDataFragmentDoc = gql`
    fragment AccessorialChargeDetailsData on AccessorialChargeDetailsEntity {
  accessorialUuid
  accessorialName
  chargeDetailsByContact {
    ...ContactAccessorialChargeDetailsData
  }
}
    ${ContactAccessorialChargeDetailsDataFragmentDoc}`;
export const AccountsReceivableDataFragmentDoc = gql`
    fragment AccountsReceivableData on AccountsReceivableReportDataForContactEntity {
  contactUuid
  displayName
  contactReferenceNumber
  totalInvoices
  totalPayments
  unappliedPayments
  totalCredits
  unappliedCredits
  totalDebits
  unappliedDebits
  balance
}
    `;
export const AgingReportBucketFragmentDoc = gql`
    fragment AgingReportBucket on AgingReportBucketEntity {
  greaterThanOrEqualToDays
  lessThanOrEqualToDays
  openInvoiceValue
}
    `;
export const InvoiceForAgingReportFragmentDoc = gql`
    fragment InvoiceForAgingReport on InvoiceForAgingReportEntity {
  journalNumber
  totalOpenAmount
  dueDate
  date
  age
  name
}
    `;
export const AgingReportDataFragmentDoc = gql`
    fragment AgingReportData on AgingReportForContactEntity {
  contactUuid
  displayName
  contactAddress {
    name
    line1
    line2
    city
    state
    zip
  }
  openInvoiceValueBuckets {
    ...AgingReportBucket
  }
  invoices {
    ...InvoiceForAgingReport
  }
}
    ${AgingReportBucketFragmentDoc}
${InvoiceForAgingReportFragmentDoc}`;
export const PaymentForMemoReportFragmentDoc = gql`
    fragment PaymentForMemoReport on PaymentEntity {
  paymentType
  paymentRail
  amountInCents
  date
  creditNumber
  referenceNumber
  comment
  creditType {
    name
  }
  contact {
    uuid
    displayName
    billingContactEmail
    defaultAddress {
      ...Address
    }
    defaultContactPerson {
      firstName
      lastName
      phone
    }
  }
  invoicesAppliedTo {
    uuid
    name
    journalNumber
    date
    invoiceTotal
    balanceInCents
  }
  paymentToOrderMappings {
    uuid
    amountInCents
    order {
      totalCharge
      balanceInCents
      standardOrderFields {
        shipperBillOfLadingNumber
      }
      shipments {
        invoice {
          uuid
        }
      }
    }
  }
}
    ${AddressFragmentDoc}`;
export const InvoiceBillingSummaryReportV2LineItemFragmentDoc = gql`
    fragment InvoiceBillingSummaryReportV2LineItem on InvoiceBillingSummaryLineItemEntity {
  orderName
  invoiceName
  totalCharge
  shipperBillOfLadingNumber
  invoiceStatus
  refNumbers
  contactDisplayName
  contactReferenceNumber
  serviceLevel
  invoiceDate
  serviceDate
  pieces
  weight
  inboundAddressName
  outboundAddressName
  shipmentsIncludedInLineItemRevenue {
    terminalCode
    shipmentTypeForCharge
  }
  orderLineHaulLane {
    originTerminalCode
    destinationTerminalCode
  }
}
    `;
export const InvoiceBillingSummaryReportV2SubgroupFragmentDoc = gql`
    fragment InvoiceBillingSummaryReportV2Subgroup on InvoiceBillingSummaryV2Subgroup {
  subgroupLabel
  lineItems {
    ...InvoiceBillingSummaryReportV2LineItem
  }
  subgroupTotal
}
    ${InvoiceBillingSummaryReportV2LineItemFragmentDoc}`;
export const InvoiceBillingSummaryReportV2GroupFragmentDoc = gql`
    fragment InvoiceBillingSummaryReportV2Group on InvoiceBillingSummaryV2Group {
  groupLabel
  subgroups {
    ...InvoiceBillingSummaryReportV2Subgroup
  }
  groupTotal
  totalLineItems
}
    ${InvoiceBillingSummaryReportV2SubgroupFragmentDoc}`;
export const InvoiceBillingSummaryReportV2FragmentDoc = gql`
    fragment InvoiceBillingSummaryReportV2 on InvoiceBillingSummaryV2Output {
  groups {
    ...InvoiceBillingSummaryReportV2Group
  }
  total
}
    ${InvoiceBillingSummaryReportV2GroupFragmentDoc}`;
export const OrderForOpenInvoiceReportFragmentDoc = gql`
    fragment OrderForOpenInvoiceReport on OrderForOpenInvoiceReportEntity {
  orderUuid
  orderName
  shipperBillOfLadingNumber
  masterAirwayBillOfLadingNumber
  refNumbers
  addressName
  originTerminalCode
  destinationTerminalCode
  serviceDate
  pieces
  weight
  orderTotalCents
  orderBalanceCents
}
    `;
export const InvoiceForOpenInvoiceReportFragmentDoc = gql`
    fragment InvoiceForOpenInvoiceReport on InvoiceForOpenInvoiceReportEntity {
  uuid
  journalNumber
  name
  date
  dueDate
  status
  invoiceTotalCents
  invoiceBalanceCents
  billingPartyContactUuid
  billingPartyContactDisplayName
  billingPartyContactReferenceNumber
  orders {
    ...OrderForOpenInvoiceReport
  }
}
    ${OrderForOpenInvoiceReportFragmentDoc}`;
export const InvoiceForOrderSummaryReportFragmentDoc = gql`
    fragment InvoiceForOrderSummaryReport on InvoiceEntity {
  name
  date
  journalNumber
  invoiceTotal
  totalOpenAmount
  shipments {
    uuid
    totalChargesAmount
    standardShipmentFields {
      pickupOrDelivery
    }
    order {
      uuid
      balanceInCents
      standardOrderFields {
        shipperBillOfLadingNumber
        masterAirwayBillOfLadingNumber
      }
      packages {
        quantity
      }
      weight
      dimWeight
      refNumbers
    }
    legs {
      endStop {
        completedAt
        stopType
        address {
          name
        }
      }
    }
  }
  billToContact {
    displayName
    billingContactEmail
    defaultContactPerson {
      firstName
      lastName
      phone
    }
    defaultAddress {
      ...Address
    }
  }
}
    ${AddressFragmentDoc}`;
export const OrderForPaymentApplicationReportFragmentDoc = gql`
    fragment OrderForPaymentApplicationReport on OrderForPaymentApplicationReportEntity {
  orderUuid
  orderName
  shipperBillOfLadingNumber
  masterAirwayBillOfLadingNumber
  refNumbers
  inboundAddressName
  outboundAddressName
  pieces
  weight
  orderTotal
  orderBalance
  appliedAmount
  invoiceUuid
  invoiceName
  invoiceJournalNumber
  invoiceDate
  invoiceContactDisplayName
  invoiceTotal
  invoiceBalance
}
    `;
export const PaymentForPaymentApplicationReportFragmentDoc = gql`
    fragment PaymentForPaymentApplicationReport on PaymentForPaymentApplicationReportEntity {
  paymentUuid
  referenceNumber
  paymentDate
  paymentType
  paymentRail
  comment
  totalAmount
  unappliedAmount
  contactUuid
  contactDisplayName
  contactReferenceNumber
  masterAccountName
  orders {
    ...OrderForPaymentApplicationReport
  }
}
    ${OrderForPaymentApplicationReportFragmentDoc}`;
export const PaymentToOrderMappingForJournalReportFragmentDoc = gql`
    fragment PaymentToOrderMappingForJournalReport on PaymentToOrderMappingEntity {
  amountInCents
  order {
    name
    standardOrderFields {
      shipperBillOfLadingNumber
    }
    shipments {
      invoice {
        name
        journalNumber
        date
      }
    }
  }
}
    `;
export const PaymentForJournalReportOldFragmentDoc = gql`
    fragment PaymentForJournalReportOld on PaymentEntity {
  paymentType
  paymentRail
  amountInCents
  date
  referenceNumber
  creditNumber
  comment
  unappliedAmountInCents
  creditType {
    name
  }
  contact {
    uuid
    displayName
  }
  glTerminal {
    name
  }
  paymentToOrderMappings {
    ...PaymentToOrderMappingForJournalReport
  }
}
    ${PaymentToOrderMappingForJournalReportFragmentDoc}`;
export const OrderForPaymentJournalReportFragmentDoc = gql`
    fragment OrderForPaymentJournalReport on OrderForPaymentJournalReportEntity {
  orderUuid
  orderName
  shipperBillOfLadingNumber
  appliedAmountDollars
  invoiceUuid
  invoiceName
  invoiceJournalNumber
  invoiceDate
  invoiceCustomerName
}
    `;
export const PaymentForJournalReportFragmentDoc = gql`
    fragment PaymentForJournalReport on PaymentForPaymentJournalReportEntity {
  paymentUuid
  paymentType
  paymentRail
  paymentDate
  referenceNumber
  creditNumber
  comment
  totalAmount
  unappliedAmountDollars
  creditTypeName
  glTerminalName
  contactUuid
  contactDisplayName
  contactReferenceNumber
  orders {
    ...OrderForPaymentJournalReport
  }
}
    ${OrderForPaymentJournalReportFragmentDoc}`;
export const RevenueReportOrderDataFragmentDoc = gql`
    fragment RevenueReportOrderData on RevenueReportOrderEntity {
  uuid
  name
  totalCharge
  shipperBillOfLadingNumber
  masterAirwayBillOfLadingNumber
  contactUuid
  contactName
  contactReferenceNumber
  packageQuantity
  packageWeight
  podUploaded
  stopTypes
  serviceDates
  controllingTerminalCode
  inboundAddressString
  outboundAddressString
  detailedStatusV2
  inboundStopType
  outboundStopType
}
    `;
export const ShallowInvoiceWithoutShipmentsFragmentDoc = gql`
    fragment ShallowInvoiceWithoutShipments on InvoiceEntity {
  uuid
  name
  journalNumber
  createdAt
  dueDate
  date
  status
  source
  qbInvoiceNumber
  emailOptions
  invoiceTerms {
    uuid
    terms
  }
  billToContact {
    uuid
    displayName
    billingCycleDuration
    ediPartnerships {
      stedi210MappingId
      ediOutboundPayloadDestination
    }
  }
  firstShipment {
    uuid
  }
}
    `;
export const ShallowInvoiceV2FragmentDoc = gql`
    fragment ShallowInvoiceV2 on InvoiceEntity {
  uuid
  date
  createdAt
  quickbooksInvoiceId
  lastSyncedToQuickbooksAt
  syncedToQuickbooksDesktopAt
  name
  journalNumber
  status
  dueDate
  billToContact {
    displayName
  }
}
    `;
export const OrderProratedWithFragmentDoc = gql`
    fragment OrderProratedWith on OrderEntity {
  uuid
  standardOrderFields {
    shipperBillOfLadingNumber
  }
  name
  status
}
    `;
export const TypeAheadOrderFragmentDoc = gql`
    fragment TypeAheadOrder on OrderEntity {
  uuid
  standardOrderFields {
    shipperBillOfLadingNumber
  }
  billingPartyContact {
    uuid
    invoiceTimePeriodSplit
    numberOfOrdersPerInvoice
    displayName
  }
  shipments {
    uuid
    hideFromBilling
    invoice {
      uuid
    }
  }
  name
  status
  ordersProratedWith {
    ...OrderProratedWith
  }
}
    ${OrderProratedWithFragmentDoc}`;
export const ContactItemsItemFragmentDoc = gql`
    fragment ContactItemsItem on ItemEntity {
  uuid
  sku
  description
  primaryUOM {
    unitOfMeasure
  }
  secondaryUOM {
    unitOfMeasure
  }
}
    `;
export const LegInfoFragmentDoc = gql`
    fragment LegInfo on LegEntity {
  miles
  flatRate
  name
  uuid
  completedAt
  endStop {
    completedAt
    address {
      name
    }
  }
  shipment {
    name
    totalChargesAmount
    totalChargesForDriverSettlement
    charges {
      ... on CustomChargeEntity {
        total
      }
      ... on FreightChargeEntity {
        total
      }
    }
    legs {
      uuid
    }
    standardShipmentFields {
      uuid
      pickupOrDelivery
    }
    uuid
    order {
      uuid
      name
      standardOrderFields {
        shipperBillOfLadingNumber
      }
      shipments {
        uuid
        name
      }
    }
  }
}
    `;
export const TerminalForDetailedLineHaulManifestFragmentDoc = gql`
    fragment TerminalForDetailedLineHaulManifest on TerminalEntity {
  uuid
  code
}
    `;
export const ShallowLineHaulLaneFragmentDoc = gql`
    fragment ShallowLineHaulLane on LineHaulLaneEntity {
  uuid
  name
  originTerminal {
    uuid
    code
  }
  destinationTerminal {
    uuid
    code
  }
  isActive
}
    `;
export const LineHaulOrderFragmentDoc = gql`
    fragment LineHaulOrder on OrderEntity {
  uuid
  name
  standardOrderFields {
    weightUnits
    shipperBillOfLadingNumber
    masterAirwayBillOfLadingNumber
  }
  detailedStatusV2
  receivedDate
  osd
  status
  tags {
    ...Tag
  }
  lineHaulLane {
    ...ShallowLineHaulLane
  }
  weight
  dimWeight
  lineHaulServiceDisplayString
  packages {
    uuid
    length
    width
    height
    weight
    type
  }
  pieceCountFromPackages
  billingPartyContact {
    displayName
  }
  refNumbers
}
    ${TagFragmentDoc}
${ShallowLineHaulLaneFragmentDoc}`;
export const DetailedLineHaulManifestFragmentDoc = gql`
    fragment DetailedLineHaulManifest on LineHaulManifestEntity {
  referenceNumber
  startTerminal {
    ...TerminalForDetailedLineHaulManifest
  }
  endTerminal {
    ...TerminalForDetailedLineHaulManifest
  }
  createdAt
  departDate
  status
  startedAt
  completedAt
  uuid
  driver {
    uuid
    driverReferenceNumber
    firstName
    lastName
    agent {
      name
    }
  }
  equipment {
    uuid
    name
    type
  }
  orders {
    uuid
    name
    standardOrderFields {
      shipperBillOfLadingNumber
      masterAirwayBillOfLadingNumber
    }
    tags {
      value
    }
    weight
    dimWeight
    pieceCountFromPackages
    packages {
      length
      width
      height
      weight
    }
    billingPartyContact {
      displayName
    }
    hazmat
    refNumbers
    dateMarkedReceivedAtOrigin
    shipments {
      standardShipmentFields {
        deadlineDate
      }
      legs {
        endStop {
          stopType
          inboundMethod
          outboundMethod
          serviceDate
          incomingCarrier
          outboundCarrier
          address {
            name
            line1
            line2
            city
            state
            zip
          }
        }
      }
    }
  }
  orderSegments {
    order {
      ...LineHaulOrder
    }
    arrivalScans {
      uuid
      scannedAt
    }
    departureScans {
      uuid
      scannedAt
    }
    arrivedAt
  }
  sentToAgentAt
  confirmedByAgentAt
}
    ${TerminalForDetailedLineHaulManifestFragmentDoc}
${LineHaulOrderFragmentDoc}`;
export const TerminalLineHaulStatusFragmentDoc = gql`
    fragment TerminalLineHaulStatus on LineHaulStatusByTerminal {
  terminal {
    uuid
    code
  }
  markedArrivedAt
  manifestDepartingFromThisTerminal {
    uuid
    status
    departDate
    startedAt
    completedAt
    referenceNumber
    driver {
      firstName
      lastName
    }
  }
  arrivalScans {
    uuid
    scannedAt
  }
  departureScans {
    uuid
    scannedAt
  }
}
    `;
export const LineHaulManifestOrderFragmentDoc = gql`
    fragment LineHaulManifestOrder on OrderEntity {
  uuid
  standardOrderFields {
    shipperBillOfLadingNumber
    weightUnits
  }
  packages {
    uuid
    length
    width
    height
    weight
    quantity
    type
  }
  weight
  dimWeight
  refNumbers
  billingPartyContact {
    displayName
  }
  name
}
    `;
export const LineHaulOrderForPrintedManifestFragmentDoc = gql`
    fragment LineHaulOrderForPrintedManifest on OrderEntity {
  uuid
  name
  dateMarkedReceivedAtOrigin
  standardOrderFields {
    masterAirwayBillOfLadingNumber
    shipperBillOfLadingNumber
  }
  lineHaulLane {
    ...ShallowLineHaulLane
  }
  weight
  dimWeight
  tags {
    value
  }
  pieceCountFromPackages
  billingPartyContact {
    displayName
  }
  shipments {
    standardShipmentFields {
      pickupOrDelivery
      deadlineDate
    }
    airportInfo {
      address {
        name
      }
    }
    legs {
      endStop {
        stopType
        serviceDate
        address {
          name
          line1
          line2
          city
          state
          zip
        }
        inboundMethod
        outboundMethod
        incomingCarrier
        outboundCarrier
      }
    }
  }
  refNumbers
  hazmat
}
    ${ShallowLineHaulLaneFragmentDoc}`;
export const LineHaulManifestForPrintFragmentDoc = gql`
    fragment LineHaulManifestForPrint on LineHaulManifestEntity {
  referenceNumber
  startTerminal {
    ...TerminalForDetailedLineHaulManifest
  }
  endTerminal {
    ...TerminalForDetailedLineHaulManifest
  }
  departDate
  status
  startedAt
  completedAt
  uuid
  driver {
    uuid
    driverReferenceNumber
    firstName
    lastName
  }
  equipment {
    uuid
    name
    type
  }
  orderSegments {
    order {
      ...LineHaulOrderForPrintedManifest
    }
    segment {
      ordinal
      startTerminal {
        name
        code
      }
      endTerminal {
        name
        code
      }
    }
    priorOrderLineHaulSegment {
      arrivedAt
    }
  }
}
    ${TerminalForDetailedLineHaulManifestFragmentDoc}
${LineHaulOrderForPrintedManifestFragmentDoc}`;
export const ShallowLineHaulSegmentFragmentDoc = gql`
    fragment ShallowLineHaulSegment on LineHaulSegmentEntity {
  uuid
  ordinal
  startTerminal {
    uuid
    code
  }
  endTerminal {
    uuid
    code
  }
}
    `;
export const LineHaulOrderWithUpcomingSegmentAndInboundStopStatusFragmentDoc = gql`
    fragment LineHaulOrderWithUpcomingSegmentAndInboundStopStatus on OrderEntity {
  uuid
  upcomingLineHaulSegment {
    ...ShallowLineHaulSegment
  }
  hasNoneOrCompletedInboundStop
  lastCompletedLineHaulSegment {
    ...ShallowLineHaulSegment
  }
}
    ${ShallowLineHaulSegmentFragmentDoc}`;
export const SegmentedLineHaulOrderFragmentDoc = gql`
    fragment SegmentedLineHaulOrder on OrderLineHaulSegmentEntity {
  uuid
  order {
    uuid
    name
    standardOrderFields {
      weightUnits
      shipperBillOfLadingNumber
      masterAirwayBillOfLadingNumber
    }
    pieceCountFromPackages
    tags {
      ...Tag
    }
    dateMarkedReceivedAtOrigin
    lineHaulLane {
      ...ShallowLineHaulLane
    }
    weight
    dimWeight
    lineHaulServiceDisplayString
    billingPartyContact {
      displayName
    }
    hazmat
    startStop {
      serviceDate
      isSpecial
      address {
        name
      }
      incomingCarrier
      terminal {
        code
      }
    }
    endStop {
      serviceDate
      isSpecial
      address {
        name
      }
      outboundCarrier
      destinationAirport
      terminal {
        code
      }
      leg {
        shipment {
          standardShipmentFields {
            deadlineDate
          }
        }
      }
    }
  }
  segment {
    ...ShallowLineHaulSegment
  }
}
    ${TagFragmentDoc}
${ShallowLineHaulLaneFragmentDoc}
${ShallowLineHaulSegmentFragmentDoc}`;
export const ShallowLineHaulManifestFragmentDoc = gql`
    fragment ShallowLineHaulManifest on LineHaulManifestEntity {
  startTerminal {
    uuid
    code
  }
  endTerminal {
    uuid
    code
  }
  departDate
  uuid
  driver {
    uuid
    driverReferenceNumber
    firstName
    lastName
  }
}
    `;
export const CompanyDefaultTariffChainFragmentDoc = gql`
    fragment CompanyDefaultTariffChain on TariffChainEntity {
  id
  name
}
    `;
export const TariffChainWithGroupsFragmentDoc = gql`
    fragment TariffChainWithGroups on TariffChainEntity {
  id
  name
  tariffGroupType
  tariffGroups {
    uuid
    name
  }
}
    `;
export const TariffGroupForTableFragmentDoc = gql`
    fragment TariffGroupForTable on TariffGroupEntity {
  uuid
  name
  tariffGroupScope
  tariffGroupType
  startDate
  endDate
  rateMultiplier
  firstTariff {
    tariffType
    rateType
    tariffZone {
      type
    }
  }
  totalContactsToServicesMappings
  contactToServicesMappings(first: 2) {
    contact {
      displayName
    }
  }
}
    `;
export const TariffOverageRateFragmentDoc = gql`
    fragment TariffOverageRate on TariffOverageRateEntity {
  uuid
  name
  type
  rateUsdCents
  flatRateUsdCents
  applicableAboveAmount
}
    `;
export const TariffRangeFragmentDoc = gql`
    fragment TariffRange on TariffRangeEntity {
  uuid
  lessThanOrEqualToValue
  rateUsdCents
}
    `;
export const TariffForTariffGroupFragmentDoc = gql`
    fragment TariffForTariffGroup on TariffEntity {
  uuid
  minimumUsdCents
  maximumUsdCents
  tariffType
  rateType
  billingPartyContactUuid
  settlementPercentageRate
  service {
    ...Service
  }
  tariffOverageRates {
    ...TariffOverageRate
  }
  tariffZone {
    uuid
    name
    type
    mileRangeStart
    mileRangeEnd
    billingPartyContactUuid
  }
  tariffRanges {
    ...TariffRange
  }
  useActualWeight
  useActualWeightInCalculation
}
    ${ServiceFragmentDoc}
${TariffOverageRateFragmentDoc}
${TariffRangeFragmentDoc}`;
export const TariffGroupFragmentDoc = gql`
    fragment TariffGroup on TariffGroupEntity {
  uuid
  name
  tariffs {
    ...TariffForTariffGroup
  }
  tariffGroupType
  tariffGroupScope
  contactToServicesMappings {
    contact {
      uuid
      displayName
    }
    services {
      uuid
      name
    }
  }
  rateMultiplier
  startDate
  endDate
  useActualWeightInCalculation
  useDeficitBilling
  fuelProfile {
    uuid
    name
  }
  terminals {
    uuid
    code
    name
  }
  tariffZoneGroup {
    id
  }
  services {
    uuid
  }
  vehicleTypes {
    uuid
  }
}
    ${TariffForTariffGroupFragmentDoc}`;
export const FuelProfileDateRangeFragmentDoc = gql`
    fragment FuelProfileDateRange on FuelProfileDateRangeEntity {
  uuid
  startDate
  expirationDate
  surchargeRate
  flatRateUsdCents
}
    `;
export const ShallowTariffGroupFuelProfileFragmentDoc = gql`
    fragment ShallowTariffGroupFuelProfile on FuelProfileEntity {
  uuid
  name
  startDate
  expirationDate
  billingType
  type
  company {
    uuid
  }
  contacts {
    uuid
    displayName
  }
  fuelProfileDateRanges {
    ...FuelProfileDateRange
  }
}
    ${FuelProfileDateRangeFragmentDoc}`;
export const TariffGroupForTariffFragmentDoc = gql`
    fragment TariffGroupForTariff on TariffGroupEntity {
  uuid
  name
  tariffGroupScope
  tariffGroupType
  contactToServicesMappings {
    contact {
      uuid
      displayName
    }
    services {
      uuid
      name
    }
  }
  parentTariffGroup {
    uuid
    contactToServicesMappings {
      contact {
        uuid
        displayName
      }
      services {
        uuid
        name
      }
    }
  }
  rateMultiplier
  useActualWeightInCalculation
  fuelProfile {
    ...ShallowTariffGroupFuelProfile
  }
}
    ${ShallowTariffGroupFuelProfileFragmentDoc}`;
export const TariffFragmentDoc = gql`
    fragment Tariff on TariffEntity {
  uuid
  minimumUsdCents
  maximumUsdCents
  settlementPercentageRate
  tariffType
  rateType
  billingPartyContactUuid
  service {
    ...Service
  }
  tariffOverageRates {
    ...TariffOverageRate
  }
  tariffZone {
    ...TariffZone
  }
  tariffRanges {
    ...TariffRange
  }
  tariffGroup {
    ...TariffGroupForTariff
  }
  useActualWeight
  useActualWeightInCalculation
}
    ${ServiceFragmentDoc}
${TariffOverageRateFragmentDoc}
${TariffZoneFragmentDoc}
${TariffRangeFragmentDoc}
${TariffGroupForTariffFragmentDoc}`;
export const ShallowTariffGroupFragmentDoc = gql`
    fragment ShallowTariffGroup on TariffGroupEntity {
  uuid
  name
  tariffGroupScope
  tariffGroupType
  contactToServicesMappings {
    contact {
      uuid
      displayName
    }
    services {
      uuid
      name
    }
  }
  parentTariffGroup {
    uuid
    tariffs {
      ...Tariff
    }
    contactToServicesMappings {
      contact {
        uuid
        displayName
      }
      services {
        uuid
        name
      }
    }
  }
  rateMultiplier
  useActualWeightInCalculation
  fuelProfile {
    ...ShallowTariffGroupFuelProfile
  }
  terminals {
    uuid
    code
    name
  }
}
    ${TariffFragmentDoc}
${ShallowTariffGroupFuelProfileFragmentDoc}`;
export const TariffFragmentFragmentDoc = gql`
    fragment TariffFragment on TariffEntity {
  uuid
  tariffType
  minimumUsdCents
  rateType
  maximumUsdCents
  billingPartyContactUuid
  service {
    ...Service
  }
  tariffZone {
    ...TariffZone
  }
  tariffOverageRates {
    ...TariffOverageRate
  }
  tariffRanges {
    ...TariffRange
  }
  useActualWeightInCalculation
  useActualWeight
  tariffGroup {
    ...ShallowTariffGroup
  }
}
    ${ServiceFragmentDoc}
${TariffZoneFragmentDoc}
${TariffOverageRateFragmentDoc}
${TariffRangeFragmentDoc}
${ShallowTariffGroupFragmentDoc}`;
export const TariffZoneGroupFragmentDoc = gql`
    fragment TariffZoneGroup on TariffZoneGroupEntity {
  id
  name
  description
}
    `;
export const TariffZoneGroupWithTariffZonesFragmentDoc = gql`
    fragment TariffZoneGroupWithTariffZones on TariffZoneGroupEntity {
  id
  name
  description
  tariffZones {
    uuid
    name
    type
    lineHaulLane {
      isActive
    }
  }
}
    `;
export const AccessorialDateRangeConfigFragmentDoc = gql`
    fragment AccessorialDateRangeConfig on AccessorialDateRangeConfigEntity {
  uuid
  startDate
  endDate
  percentForSettlement
  fuelSurchargePercentageRate
  rate
  fuelProfile {
    uuid
  }
  accessorialRanges {
    ...AccessorialRange
  }
}
    ${AccessorialRangeFragmentDoc}`;
export const AccessorialNamesFragmentDoc = gql`
    fragment AccessorialNames on AccessorialUnion {
  __typename
  ... on StandardAccessorialEntity {
    name
    uuid
  }
  ... on WeightBasedAccessorialEntity {
    name
    uuid
  }
  ... on ZoneBasedAccessorialEntity {
    name
    uuid
  }
  ... on WaitTimeAccessorialEntity {
    name
    uuid
  }
  ... on UnitBasedAccessorialEntity {
    name
    uuid
  }
  ... on SkidBasedAccessorialEntity {
    name
    uuid
  }
  ... on SpecialAccessorialEntity {
    name
    uuid
  }
}
    `;
export const AccessorialsUuidFragmentDoc = gql`
    fragment AccessorialsUuid on AccessorialUnion {
  ... on StandardAccessorialEntity {
    uuid
  }
  ... on WeightBasedAccessorialEntity {
    uuid
  }
  ... on ZoneBasedAccessorialEntity {
    uuid
  }
  ... on WaitTimeAccessorialEntity {
    uuid
  }
  ... on UnitBasedAccessorialEntity {
    uuid
  }
  ... on SkidBasedAccessorialEntity {
    uuid
  }
  ... on SpecialAccessorialEntity {
    uuid
  }
}
    `;
export const AccessorialsTableRowFragmentDoc = gql`
    fragment AccessorialsTableRow on AccessorialUnion {
  ... on StandardAccessorialEntity {
    __typename
    uuid
    isArchived
    name
    enableQuickAdd
    rate
    contact {
      uuid
    }
    terminal {
      ...AccessorialTerminal
    }
    generalLedgerCode {
      code
      description
    }
  }
  ... on UnitBasedAccessorialEntity {
    __typename
    uuid
    isArchived
    name
    enableQuickAdd
    ratePerUnit
    contact {
      uuid
    }
    terminal {
      ...AccessorialTerminal
    }
    generalLedgerCode {
      code
      description
    }
  }
  ... on SkidBasedAccessorialEntity {
    __typename
    uuid
    isArchived
    contact {
      uuid
    }
    name
    enableQuickAdd
    ratePerSkid
    terminal {
      ...AccessorialTerminal
    }
    generalLedgerCode {
      code
      description
    }
  }
  ... on WaitTimeAccessorialEntity {
    __typename
    uuid
    isArchived
    contact {
      uuid
    }
    name
    enableQuickAdd
    rate
    waitTimeChargePeriod
    terminal {
      ...AccessorialTerminal
    }
    generalLedgerCode {
      code
      description
    }
  }
  ... on WeightBasedAccessorialEntity {
    __typename
    uuid
    isArchived
    contact {
      uuid
    }
    name
    enableQuickAdd
    ratePerHundredWeight
    terminal {
      ...AccessorialTerminal
    }
    generalLedgerCode {
      code
      description
    }
  }
  ... on ZoneBasedAccessorialEntity {
    __typename
    uuid
    isArchived
    contact {
      uuid
    }
    name
    enableQuickAdd
    zones {
      uuid
    }
    terminal {
      ...AccessorialTerminal
    }
    generalLedgerCode {
      code
      description
    }
  }
  ... on SpecialAccessorialEntity {
    __typename
    uuid
    isArchived
    contact {
      uuid
    }
    name
    enableQuickAdd
    terminal {
      ...AccessorialTerminal
    }
    generalLedgerCode {
      code
      description
    }
  }
}
    ${AccessorialTerminalFragmentDoc}`;
export const GeneralLedgerCodeFragmentDoc = gql`
    fragment GeneralLedgerCode on GeneralLedgerCodeEntity {
  id
  code
  description
  accessorials {
    ... on StandardAccessorialEntity {
      name
      uuid
    }
    ... on UnitBasedAccessorialEntity {
      name
      uuid
    }
    ... on SkidBasedAccessorialEntity {
      name
      uuid
    }
    ... on WaitTimeAccessorialEntity {
      name
      uuid
    }
    ... on WeightBasedAccessorialEntity {
      name
      uuid
    }
    ... on SpecialAccessorialEntity {
      name
      uuid
    }
    ... on ZoneBasedAccessorialEntity {
      name
      uuid
    }
  }
  creditTypes {
    name
    uuid
  }
}
    `;
export const MasterAccountFragmentDoc = gql`
    fragment MasterAccount on MasterAccountEntity {
  uuid
  name
}
    `;
export const SettlementDeductionTypeFragmentDoc = gql`
    fragment SettlementDeductionType on SettlementDeductionTypeEntity {
  uuid
  name
  percentageRate
  flatRate
}
    `;
export const FindBusinessDivisionsFragmentDoc = gql`
    fragment FindBusinessDivisions on BusinessDivisionEntity {
  uuid
  name
}
    `;
export const DriverSignableFormFragmentDoc = gql`
    fragment DriverSignableForm on DriverSignableFormTemplateEntity {
  uuid
  title
  formText
  createdAt
}
    `;
export const FindFuelProfileFragmentDoc = gql`
    fragment FindFuelProfile on FuelProfileEntity {
  uuid
  name
  billingType
  type
  fuelProfileDateRanges {
    ...FuelProfileDateRange
  }
}
    ${FuelProfileDateRangeFragmentDoc}`;
export const FuelProfileFragmentDoc = gql`
    fragment FuelProfile on FuelProfileEntity {
  uuid
  name
  startDate
  expirationDate
  billingType
  type
  company {
    uuid
  }
  contacts {
    uuid
    displayName
  }
  fuelProfileDateRanges {
    ...FuelProfileDateRange
  }
}
    ${FuelProfileDateRangeFragmentDoc}`;
export const HoldReasonFragmentDoc = gql`
    fragment HoldReason on HoldReasonEntity {
  uuid
  name
  isArchived
}
    `;
export const LineHaulLaneFragmentDoc = gql`
    fragment LineHaulLane on LineHaulLaneEntity {
  uuid
  name
  originTerminal {
    ...ShallowTerminal
  }
  destinationTerminal {
    ...ShallowTerminal
  }
  segments {
    ...ShallowLineHaulSegment
  }
  isActive
}
    ${ShallowTerminalFragmentDoc}
${ShallowLineHaulSegmentFragmentDoc}`;
export const PackageSpecFragmentDoc = gql`
    fragment PackageSpec on PackageSpecEntity {
  id
  name
  status
  weight
  length
  width
  height
}
    `;
export const ServiceForThirdPartyUserFragmentDoc = gql`
    fragment ServiceForThirdPartyUser on ServiceEntity {
  uuid
  name
  defaultInboundStopType
  defaultOutboundStopType
}
    `;
export const TerminalServiceAreaFragmentDoc = gql`
    fragment TerminalServiceArea on TerminalServiceAreaEntity {
  uuid
  zipcode
  city
}
    `;
export const TerminalFragmentDoc = gql`
    fragment Terminal on TerminalEntity {
  name
  code
  uuid
  address {
    line1
    line2
    city
    state
    zip
    uuid
    name
  }
  serviceAreas {
    ...TerminalServiceArea
  }
  isActive
  serviceRegion {
    id
    name
    isArchived
  }
  agent {
    uuid
    name
  }
  startForTerminalLanes {
    id
    endTerminal {
      uuid
      code
      name
    }
  }
}
    ${TerminalServiceAreaFragmentDoc}`;
export const UsersRoleFragmentDoc = gql`
    fragment UsersRole on RoleEntity {
  uuid
  name
}
    `;
export const UserFragmentDoc = gql`
    fragment User on UserEntity {
  uuid
  name
  reportsEmail
  email
  phoneNumber
  sendSummaryEmailWithIncompleteRoutes
  sendAllInvoices
  terminal {
    uuid
    name
  }
  roles {
    ...UsersRole
  }
  isActive
  driver {
    uuid
  }
}
    ${UsersRoleFragmentDoc}`;
export const CreatedWarehouseEmployeeFragmentDoc = gql`
    fragment CreatedWarehouseEmployee on WarehouseEmployeeEntity {
  uuid
}
    `;
export const WarehouseEmployeeFragmentDoc = gql`
    fragment WarehouseEmployee on WarehouseEmployeeEntity {
  uuid
  firstName
  lastName
  emailAddress
  phoneNumber
  active
  password
}
    `;
export const UpdatedWarehouseEmployeeFragmentDoc = gql`
    fragment UpdatedWarehouseEmployee on WarehouseEmployeeEntity {
  uuid
}
    `;
export const NotificationFragmentDoc = gql`
    fragment Notification on NotificationEntity {
  uuid
  type
  acknowledged
  createdAt
  order {
    uuid
    name
    createdAt
    standardOrderFields {
      shipperBillOfLadingNumber
    }
  }
  driverMarkedAttemptedStop {
    leg {
      shipment {
        order {
          name
        }
      }
    }
  }
  driverMarkedAttemptedDriver {
    uuid
    firstName
    lastName
  }
  targetAccessorial {
    ...AllAccessorialFields
  }
  targetStop {
    leg {
      shipment {
        order {
          name
        }
      }
    }
  }
  sourceDriver {
    uuid
    firstName
    lastName
  }
  emailTransaction {
    uuid
    updatedAt
    invoice {
      uuid
      name
      journalNumber
      billToContact {
        uuid
        displayName
      }
    }
    emailTransactionLogs {
      uuid
      email
      lastStatus
      reason
    }
  }
}
    ${AllAccessorialFieldsFragmentDoc}`;
export const OrderEventShipmentFragmentDoc = gql`
    fragment OrderEventShipment on ShipmentEntity {
  uuid
  name
  legs {
    endStop {
      stopType
    }
  }
}
    `;
export const OrderEventFragmentDoc = gql`
    fragment OrderEvent on OrderEventEntity {
  uuid
  createdAt
  ignoreSnapshot
  message
  eventType
  sourceType
  targetType
  snapshot
  targetPhoneNumber
  targetEmail
  targetOrderTotalBeforeConsolidation
  targetOrderTotalAfterConsolidation
  order {
    uuid
    name
    standardOrderFields {
      uuid
      shipperBillOfLadingNumber
    }
    quote {
      uuid
      number
    }
    createdFromOrderTemplate {
      uuid
      name
    }
    source
  }
  sourceDriver {
    uuid
    firstName
    lastName
    user {
      name
    }
  }
  sourceWarehouseEmployee {
    uuid
    firstName
    lastName
  }
  sourceEdiTransaction {
    uuid
    status
    code
  }
  sourceSftpUpload {
    uuid
    type
    status
  }
  sourceUser {
    uuid
    email
  }
  targetContactPerson {
    uuid
    firstName
    lastName
    phone
  }
  targetDocument {
    fileName
    type
    uuid
  }
  targetDriver {
    uuid
    firstName
    lastName
    phoneNumber
    user {
      name
    }
  }
  targetInvoice {
    uuid
    name
  }
  targetRoute {
    uuid
    name
  }
  targetShipment {
    ...OrderEventShipment
  }
  targetShipmentSubscriber {
    uuid
    phoneNumber
  }
  targetStop {
    uuid
    address {
      uuid
      name
    }
  }
  targetSettlementBill {
    uuid
    name
    settlementDate
    finalizedDate
  }
}
    ${OrderEventShipmentFragmentDoc}`;
export const PackageDifferenceFragmentDoc = gql`
    fragment PackageDifference on SnapshotPackageDifferences {
  height {
    oldValue
    newValue
  }
  weight {
    oldValue
    newValue
  }
  length {
    oldValue
    newValue
  }
  width {
    oldValue
    newValue
  }
  type {
    oldValue
    newValue
  }
  wasAdded
  wasDeleted
}
    `;
export const OrderDifferenceFragmentDoc = gql`
    fragment OrderDifference on SnapshotOrderDifferences {
  billingPartyName {
    oldValue
    newValue
  }
  hawb {
    oldValue
    newValue
  }
  mawb {
    oldValue
    newValue
  }
  refNumbers {
    oldValue
    newValue
  }
  serviceLevel {
    oldValue
    newValue
  }
  totalAmountCents {
    oldValue
    newValue
  }
  packages {
    ...PackageDifference
  }
}
    ${PackageDifferenceFragmentDoc}`;
export const AddressDifferenceFragmentDoc = gql`
    fragment AddressDifference on SnapshotAddressDifferences {
  name {
    oldValue
    newValue
  }
  line1 {
    oldValue
    newValue
  }
  zip {
    oldValue
    newValue
  }
  state {
    oldValue
    newValue
  }
  city {
    oldValue
    newValue
  }
}
    `;
export const FreightChargeDifferenceFragmentDoc = gql`
    fragment FreightChargeDifference on SnapshotFreightChargeDifferences {
  totalAmountCents {
    oldValue
    newValue
  }
  tariff {
    oldValue
    newValue
  }
  fuelCharge {
    totalAmountCents {
      oldValue
      newValue
    }
  }
  billingMethod {
    oldValue
    newValue
  }
}
    `;
export const CustomChargeDifferenceFragmentDoc = gql`
    fragment CustomChargeDifference on SnapshotCustomChargeDifferences {
  wasAdded
  wasDeleted
  name {
    oldValue
    newValue
  }
  totalAmountCents {
    oldValue
    newValue
  }
}
    `;
export const FuelCostDifferenceFragmentDoc = gql`
    fragment FuelCostDifference on SnapshotFuelCostDifferences {
  billingMethod {
    oldValue
    newValue
  }
  totalAmountCents {
    oldValue
    newValue
  }
  type {
    oldValue
    newValue
  }
  surchargeRate {
    oldValue
    newValue
  }
}
    `;
export const FreightCostDifferenceFragmentDoc = gql`
    fragment FreightCostDifference on SnapshotFreightCostDifferences {
  billingMethod {
    oldValue
    newValue
  }
  totalAmountCents {
    oldValue
    newValue
  }
  tariff {
    oldValue
    newValue
  }
  fuelCost {
    ...FuelCostDifference
  }
}
    ${FuelCostDifferenceFragmentDoc}`;
export const CustomCostDifferenceFragmentDoc = gql`
    fragment CustomCostDifference on SnapshotCustomCostDifferences {
  wasAdded
  wasDeleted
  name {
    oldValue
    newValue
  }
  totalAmountCents {
    oldValue
    newValue
  }
}
    `;
export const IndependentSettlementBillLineItemDifferenceFragmentDoc = gql`
    fragment IndependentSettlementBillLineItemDifference on SnapshotIndependentSettlementBillLineItemDifferences {
  wasAdded
  wasDeleted
  driverName {
    oldValue
    newValue
  }
  freightCost {
    ...FreightCostDifference
  }
  customCosts {
    ...CustomCostDifference
  }
}
    ${FreightCostDifferenceFragmentDoc}
${CustomCostDifferenceFragmentDoc}`;
export const StopDifferenceFragmentDoc = gql`
    fragment StopDifference on SnapshotStopDifferences {
  wasAdded
  wasDeleted
  stopType {
    oldValue
    newValue
  }
  address {
    ...AddressDifference
  }
  terminal {
    oldValue
    newValue
  }
  serviceDate {
    oldValue
    newValue
  }
  isSpecial {
    oldValue
    newValue
  }
  appointmentRequired {
    oldValue
    newValue
  }
  appointmentManuallyConfirmed {
    oldValue
    newValue
  }
  freightCharge {
    ...FreightChargeDifference
  }
  customCharges {
    ...CustomChargeDifference
  }
  independentSettlementBillLineItems {
    ...IndependentSettlementBillLineItemDifference
  }
}
    ${AddressDifferenceFragmentDoc}
${FreightChargeDifferenceFragmentDoc}
${CustomChargeDifferenceFragmentDoc}
${IndependentSettlementBillLineItemDifferenceFragmentDoc}`;
export const SnapshotDifferenceFragmentDoc = gql`
    fragment SnapshotDifference on AuditLogSnapshotDifference {
  orderDifferences {
    ...OrderDifference
  }
  inboundStopDifferences {
    ...StopDifference
  }
  outboundStopDifferences {
    ...StopDifference
  }
}
    ${OrderDifferenceFragmentDoc}
${StopDifferenceFragmentDoc}`;
export const AuditLogEntryFragmentDoc = gql`
    fragment AuditLogEntry on AuditLogEntry {
  orderEvent {
    ...OrderEvent
  }
  snapshotDifference {
    ...SnapshotDifference
  }
}
    ${OrderEventFragmentDoc}
${SnapshotDifferenceFragmentDoc}`;
export const OrderEventSnapshotFragmentDoc = gql`
    fragment OrderEventSnapshot on OrderEventEntity {
  uuid
  createdAt
  snapshot
  sourceUser {
    uuid
    email
  }
}
    `;
export const PicklistItemGroupFragmentDoc = gql`
    fragment PicklistItemGroup on PicklistItemGroupEntity {
  id
  pickedQuantity
  pickedStatus
  itemGroup {
    quantity
    item {
      sku
      description
    }
    storageUnit {
      name
      warehouseLocation {
        name
      }
    }
  }
}
    `;
export const StopForUnifiedSearchFragmentDoc = gql`
    fragment StopForUnifiedSearch on StopEntity {
  completedAt
  routeSlot {
    route {
      name
      date
    }
  }
}
    `;
export const UnifiedSearchOrdersFragmentDoc = gql`
    fragment UnifiedSearchOrders on OrderConnection {
  edges {
    node {
      uuid
      name
      source
      billingPartyContact {
        displayName
      }
      standardOrderFields {
        shipperBillOfLadingNumber
        masterAirwayBillOfLadingNumber
      }
      startStop {
        ...StopForUnifiedSearch
      }
      endStop {
        ...StopForUnifiedSearch
      }
    }
  }
  totalCount
  pageInfo {
    hasNextPage
    hasPreviousPage
    startCursor
    endCursor
  }
}
    ${StopForUnifiedSearchFragmentDoc}`;
export const UnifiedSearchUnacceptedEmailOrdersFragmentDoc = gql`
    fragment UnifiedSearchUnacceptedEmailOrders on ScannedOrderResultConnection {
  edges {
    node {
      uuid
      order {
        uuid
        name
        billingPartyContact {
          uuid
          displayName
        }
        standardOrderFields {
          shipperBillOfLadingNumber
          masterAirwayBillOfLadingNumber
        }
      }
      scannedOrder {
        ingestedOutlookEmailDetails {
          fromAddress
          subject
          receivedAt
        }
      }
    }
  }
  totalCount
  pageInfo {
    hasNextPage
    hasPreviousPage
    startCursor
    endCursor
  }
}
    `;
export const UnifiedSearchUnacceptedEdiAndApiOrdersFragmentDoc = gql`
    fragment UnifiedSearchUnacceptedEdiAndApiOrders on OrderConnection {
  edges {
    node {
      uuid
      name
      billingPartyContact {
        uuid
        displayName
      }
      standardOrderFields {
        shipperBillOfLadingNumber
        masterAirwayBillOfLadingNumber
      }
    }
  }
  totalCount
  pageInfo {
    hasNextPage
    hasPreviousPage
    startCursor
    endCursor
  }
}
    `;
export const UnifiedSearchQuotesFragmentDoc = gql`
    fragment UnifiedSearchQuotes on QuoteConnection {
  edges {
    node {
      uuid
      number
      billingPartyContact {
        uuid
        displayName
      }
    }
  }
  totalCount
  pageInfo {
    hasNextPage
    hasPreviousPage
    startCursor
    endCursor
  }
}
    `;
export const UnifiedSearchInvoicesFragmentDoc = gql`
    fragment UnifiedSearchInvoices on InvoiceConnection {
  edges {
    node {
      uuid
      date
      name
      journalNumber
      billToContact {
        uuid
        displayName
      }
      balanceInCents
      balanceInDollars
      invoiceTotal
    }
  }
  totalCount
  pageInfo {
    hasNextPage
    hasPreviousPage
    startCursor
    endCursor
  }
}
    `;
export const FreightSnapTransactionFragmentDoc = gql`
    fragment FreightSnapTransaction on FreightSnapTransactionEntity {
  uuid
  status
  failureReason
  proNum
  ehdim
  eldim
  ewdim
  weight
  imgs
  order {
    uuid
    name
  }
}
    `;
export const EmailTransactionFragmentDoc = gql`
    fragment EmailTransaction on EmailTransactionEntity {
  emailTransactionStatus
  company {
    uuid
    name
  }
  contact {
    uuid
    displayName
  }
  document {
    uuid
    preSignedGetUrl
  }
  invoice {
    uuid
    name
    journalNumber
  }
  emailResponseStatus
  failureReason
  emailTransactionLogs {
    uuid
    email
    lastStatus
    reason
  }
}
    `;
export const ApiLogFragmentDoc = gql`
    fragment ApiLog on ApiLogEntity {
  uuid
  createdAt
  updatedAt
  responseStatus
  sourceIpAddress
  direction
  freightSnapTransaction {
    ...FreightSnapTransaction @include(if: $isFreightSnap)
  }
  emailTransaction {
    ...EmailTransaction @include(if: $isInvoiceEmails)
  }
}
    ${FreightSnapTransactionFragmentDoc}
${EmailTransactionFragmentDoc}`;
export const PackageForArrivalNoticeFragmentDoc = gql`
    fragment PackageForArrivalNotice on PackageEntity {
  description
  weight
  quantity
  length
  width
  height
  type
}
    `;
export const ShipmentForArrivalNoticeFragmentDoc = gql`
    fragment ShipmentForArrivalNotice on ShipmentEntity {
  totalFreightChargesAmount
  totalFuelChargesAmount
  totalChargesAmount
  shipmentType
  hideFromBilling
  standardShipmentFields {
    pickupOrDelivery
  }
  legs {
    endStop {
      stopType
      inboundMethod
      outboundMethod
      address {
        ...Address
      }
      terminal {
        code
        address {
          ...Address
        }
      }
      contactPerson {
        phone
        email
        firstName
        lastName
      }
    }
  }
  customCharges {
    uuid
    name
    total
    accessorialTemplate {
      uuid
      name
      __typename
    }
  }
  charges {
    ... on FreightChargeEntity {
      uuid
      billingMethod
      rate
      description
      quantity
      fuelCharge {
        description
        surchargeRate
        flatRate
        type
        uuid
      }
    }
  }
}
    ${AddressFragmentDoc}`;
export const OrderForArrivalNoticeFragmentDoc = gql`
    fragment OrderForArrivalNotice on OrderEntity {
  uuid
  itTeNumber
  externalNotes
  hazmat
  unNumber
  hazmatDescription
  emergencyResponseNumber
  requiresPlacard
  hazmatClass
  packageGroup
  isCrossDock
  totalCharge
  name
  billingPartyContact {
    displayName
  }
  standardOrderFields {
    shipperBillOfLadingNumber
    masterAirwayBillOfLadingNumber
  }
  thirdPartyBrokers {
    name
  }
  service {
    name
  }
  company {
    name
    defaultAddress {
      ...Address
    }
    phone
  }
  packages {
    ...PackageForArrivalNotice
  }
  shipments {
    ...ShipmentForArrivalNotice
  }
}
    ${AddressFragmentDoc}
${PackageForArrivalNoticeFragmentDoc}
${ShipmentForArrivalNoticeFragmentDoc}`;
export const CoverSheetDocumentTypeSequenceFragmentDoc = gql`
    fragment CoverSheetDocumentTypeSequence on CoverSheetDocumentTypeSequenceEntity {
  uuid
  name
  type
  documentTypes
}
    `;
export const OrderCoverSheetShipmentFragmentDoc = gql`
    fragment OrderCoverSheetShipment on ShipmentEntity {
  uuid
  ordinal
  standardShipmentFields {
    deadlineDate
    pickupOrDelivery
  }
  packages {
    description
    weight
    quantity
    length
    width
    height
  }
  legs {
    endStop {
      stopType
      status
      appointmentTime
      endAppointmentTime
      completedAt
      specialInstructions
      address {
        ...Address
      }
      terminal {
        code
      }
      contactPerson {
        phone
        email
        firstName
        lastName
      }
      routeSlot {
        route {
          name
          drivers {
            firstName
            lastName
          }
        }
      }
    }
  }
  order {
    uuid
    name
    refNumbers
    coverSheetDocumentTypeSequence {
      ...CoverSheetDocumentTypeSequence
    }
    billingPartyContact {
      uuid
      displayName
    }
    orderEvents {
      eventType
      sourceType
      createdAt
      sourceUser {
        email
      }
    }
    company {
      name
      defaultAddress {
        ...Address
      }
    }
    standardOrderFields {
      masterAirwayBillOfLadingNumber
      shipperBillOfLadingNumber
    }
    service {
      name
    }
  }
}
    ${AddressFragmentDoc}
${CoverSheetDocumentTypeSequenceFragmentDoc}`;
export const OrderEventForCoverSheetFragmentDoc = gql`
    fragment OrderEventForCoverSheet on OrderEventEntity {
  eventType
  sourceType
  createdAt
  sourceUser {
    email
  }
}
    `;
export const ShipmentForCoverSheetFragmentDoc = gql`
    fragment ShipmentForCoverSheet on ShipmentEntity {
  uuid
  shipmentType
  ordinal
  standardShipmentFields {
    deadlineDate
    pickupOrDelivery
  }
  packages {
    description
    weight
    quantity
    length
    width
    height
  }
  legs {
    endStop {
      stopType
      status
      appointmentTime
      endAppointmentTime
      completedAt
      specialInstructions
      serviceDate
      serviceDateV2 {
        iso8601
      }
      inboundMethod
      outboundMethod
      isSpecial
      address {
        ...Address
      }
      contactPerson {
        phone
        email
        firstName
        lastName
      }
      routeSlot {
        route {
          name
          drivers {
            firstName
            lastName
          }
        }
      }
      terminal {
        uuid
        code
      }
    }
  }
}
    ${AddressFragmentDoc}`;
export const OrderForCoverSheetFragmentDoc = gql`
    fragment OrderForCoverSheet on OrderEntity {
  uuid
  name
  refNumbers
  service {
    name
  }
  coverSheetDocumentTypeSequence {
    ...CoverSheetDocumentTypeSequence
  }
  billingPartyContact {
    uuid
    displayName
  }
  orderEvents {
    ...OrderEventForCoverSheet
  }
  company {
    name
    defaultAddress {
      ...Address
    }
  }
  standardOrderFields {
    masterAirwayBillOfLadingNumber
    shipperBillOfLadingNumber
  }
  shipments {
    ...ShipmentForCoverSheet
  }
  inBond
  itTeNumber
  hazmat
  unNumber
  hazmatDescription
  emergencyResponseNumber
  requiresPlacard
  hazmatClass
  packageGroup
}
    ${CoverSheetDocumentTypeSequenceFragmentDoc}
${OrderEventForCoverSheetFragmentDoc}
${AddressFragmentDoc}
${ShipmentForCoverSheetFragmentDoc}`;
export const OrderInfoForCoverSheetFragmentDoc = gql`
    fragment OrderInfoForCoverSheet on OrderEntity {
  uuid
  coverSheetDocumentTypeSequence {
    ...CoverSheetDocumentTypeSequence
  }
  orderEvents {
    ...OrderEventForCoverSheet
  }
}
    ${CoverSheetDocumentTypeSequenceFragmentDoc}
${OrderEventForCoverSheetFragmentDoc}`;
export const CreateOrUpdateCsvOrdersOrderFragmentDoc = gql`
    fragment CreateOrUpdateCsvOrdersOrder on OrderEntity {
  uuid
}
    `;
export const CsvOrderMappingFragmentDoc = gql`
    fragment CsvOrderMapping on CsvOrderMappingEntity {
  uuid
  name
}
    `;
export const CsvOrderPreSignedPutUrlFragmentDoc = gql`
    fragment CsvOrderPreSignedPutUrl on CsvOrderPreSignedPutUrlEntity {
  url
  bucket
  key
  filename
  filetype
}
    `;
export const ParseCsvOrdersContactFragmentDoc = gql`
    fragment ParseCsvOrdersContact on ContactEntity {
  uuid
  displayName
}
    `;
export const ParseCsvOrdersPackageFragmentDoc = gql`
    fragment ParseCsvOrdersPackage on ParsedCsvOrderPackageEntity {
  description
  quantity
  type
  packageSpec {
    id
    name
  }
  weight
  length
  width
  height
  uuid
  isNew
}
    `;
export const ParseCsvOrdersOrderUpdateFragmentDoc = gql`
    fragment ParseCsvOrdersOrderUpdate on ParsedCsvOrderUpdateEntity {
  uuid
  billingPartyContact {
    ...ParseCsvOrdersContact
  }
  shipperBillOfLadingNumber
  packages {
    ...ParseCsvOrdersPackage
  }
}
    ${ParseCsvOrdersContactFragmentDoc}
${ParseCsvOrdersPackageFragmentDoc}`;
export const ParseCsvOrdersServiceFragmentDoc = gql`
    fragment ParseCsvOrdersService on ServiceEntity {
  uuid
  name
}
    `;
export const ParseCsvOrdersStopFragmentDoc = gql`
    fragment ParseCsvOrdersStop on ParsedCsvOrderStopEntity {
  pickupOrDelivery
  addressName
  addressLine1
  addressLine2
  addressCity
  addressState
  addressZip
  contactPersonFirstName
  contactPersonLastName
  contactPersonPhone
  contactPersonEmail
  specialInstructions
  deadlineDate
  deadlineType
  serviceDate
  serviceDateV2 {
    iso8601
  }
  appointmentStartTime {
    hour
    minute
  }
  appointmentEndTime {
    hour
    minute
  }
  appointmentRequired
  terminalName
  terminal {
    uuid
    name
  }
  driverName
  driverReferenceNumber
  driver {
    uuid
    firstName
    lastName
  }
}
    `;
export const ParseCsvOrdersOrderFragmentDoc = gql`
    fragment ParseCsvOrdersOrder on ParsedCsvOrderEntity {
  billingPartyContact {
    ...ParseCsvOrdersContact
  }
  customerReferenceNumber
  shipperBillOfLadingNumber
  masterAirwayBillOfLadingNumber
  referenceNumber
  notes
  serviceLevel {
    ...ParseCsvOrdersService
  }
  inboundStop {
    ...ParseCsvOrdersStop
  }
  outboundStop {
    ...ParseCsvOrdersStop
  }
  dimFactor
  freightChargeRate
  freightChargeType
  fuelSurcharge
  fuelChargeType
  packages {
    ...ParseCsvOrdersPackage
  }
}
    ${ParseCsvOrdersContactFragmentDoc}
${ParseCsvOrdersServiceFragmentDoc}
${ParseCsvOrdersStopFragmentDoc}
${ParseCsvOrdersPackageFragmentDoc}`;
export const ParseCsvOrdersRowErrorFragmentDoc = gql`
    fragment ParseCsvOrdersRowError on ParseCsvOrderRowErrorEntity {
  row
  message
}
    `;
export const CurrentOrderStatusFragmentDoc = gql`
    fragment CurrentOrderStatus on OrderEntity {
  detailedStatusV2
  updatedAt
}
    `;
export const EdiTransactionFragmentFragmentDoc = gql`
    fragment EdiTransactionFragment on EdiTransactionEntity {
  uuid
  updatedAt
  status
  code
  message
  payload
  hawb
  order {
    uuid
    name
    secondaryRefNumber
    standardOrderFields {
      shipperBillOfLadingNumber
    }
  }
}
    `;
export const OrderFragmentForEdiReviewFragmentDoc = gql`
    fragment OrderFragmentForEdiReview on OrderEntity {
  standardOrderFields {
    shipperBillOfLadingNumber
    masterAirwayBillOfLadingNumber
  }
  createdAt
  uuid
  source
  name
  contact {
    uuid
    displayName
  }
}
    `;
export const MarkOsdOrderFragmentDoc = gql`
    fragment MarkOsdOrder on OrderEntity {
  uuid
  notes
  status
  detailedStatusV2
}
    `;
export const OrderForBulkEditFragmentDoc = gql`
    fragment OrderForBulkEdit on OrderEntity {
  uuid
  status
  onHand
  pickedDate
  pieceCount
  detailedStatusV2
  warehouse {
    uuid
    name
  }
  standardOrderFields {
    shipperBillOfLadingNumber
    masterAirwayBillOfLadingNumber
  }
  secondaryRefNumber
  shipments {
    uuid
    shipmentType
    standardShipmentFields {
      deadlineDate
      deadlineType
      pickupOrDelivery
    }
    legs {
      uuid
      endStop {
        stopType
        uuid
        notes
        standardStopType
        appointmentTextStatus
        appointmentTime
        endAppointmentTime
        proofOfDeliverySignee
        inboundMethod
        expectedInboundArrivalDate
        outboundMethod
        completedAt
        createdAt
        status
        isSpecial
        paperworkMarkedComplete
        contactPerson {
          phone
          email
          firstName
          lastName
        }
        address {
          uuid
          name
          line1
          line2
          city
          state
          latitude
          longitude
          zip
        }
        terminal {
          name
        }
      }
      previousStopAttempts {
        completedAt
      }
    }
  }
}
    `;
export const StandardOrderForContextMenuFragmentDoc = gql`
    fragment StandardOrderForContextMenu on StandardOrderEntity {
  uuid
  name
  standardOrderFields {
    shipperBillOfLadingNumber
  }
  refusedBy
  pickedDate
  pieceCount
  onHand
  notes
  status
  detailedStatus
  detailedStatusV2
  endStop {
    uuid
    stopType
    leg {
      shipment {
        standardShipmentFields {
          pickupOrDelivery
        }
      }
    }
    terminal {
      uuid
    }
    address {
      line1
    }
  }
  shipments {
    standardShipmentFields {
      pickupOrDelivery
    }
    fields {
      pickupOrDelivery
      outboundMethod
      inboundMethod
    }
    legs {
      endStop {
        stopType
        uuid
        status
        proofOfDeliverySignee
        completedAt
        routeSlot {
          route {
            date
          }
        }
        address {
          name
        }
      }
    }
  }
}
    `;
export const OrderForDocumentAttachmentsDownloadFragmentDoc = gql`
    fragment OrderForDocumentAttachmentsDownload on OrderEntity {
  uuid
  standardOrderFields {
    shipperBillOfLadingNumber
  }
  documents {
    ...Document
  }
}
    ${DocumentFragmentDoc}`;
export const OrderForInventoryLabelFragmentDoc = gql`
    fragment OrderForInventoryLabel on OrderEntity {
  uuid
  name
  refNumbers
  billingPartyContact {
    uuid
    displayName
    referenceNumberLabels {
      name
    }
  }
  company {
    name
    defaultWeightUnits
    configuration {
      terminalsEnabled
    }
    referenceNumberLabels {
      name
    }
  }
  standardOrderFields {
    shipperBillOfLadingNumber
    masterAirwayBillOfLadingNumber
    weightUnits
  }
  packages {
    ...Package
  }
  shipments {
    uuid
    standardShipmentFields {
      pickupOrDelivery
      deadlineDate
    }
    airportInfo {
      iataCode
      terminal
    }
    legs {
      endStop {
        uuid
        stopType
        status
        destinationAirport
        inboundMethod
        outboundMethod
        incomingCarrier
        outboundCarrier
        address {
          ...Address
        }
        terminal {
          uuid
          code
        }
      }
    }
  }
}
    ${PackageFragmentDoc}
${AddressFragmentDoc}`;
export const OrderForOrderMatchingFragmentDoc = gql`
    fragment OrderForOrderMatching on OrderEntity {
  uuid
  standardOrderFields {
    shipperBillOfLadingNumber
  }
  name
  shipments {
    uuid
    standardShipmentFields {
      pickupOrDelivery
    }
    legs {
      endStop {
        address {
          ...Address
        }
      }
    }
  }
}
    ${AddressFragmentDoc}`;
export const OrderForOrdersByShipperBillOfLadingNumberFragmentDoc = gql`
    fragment OrderForOrdersByShipperBillOfLadingNumber on OrderEntity {
  uuid
  createdAt
  name
  receivedDate
  onHand
  shipments {
    uuid
  }
  scannedOrderResult {
    uuid
    status
  }
  standardOrderFields {
    shipperBillOfLadingNumber
  }
  source
  isDraftOrder
}
    `;
export const OrderPodReportShipmentFragmentDoc = gql`
    fragment OrderPodReportShipment on ShipmentEntity {
  uuid
  ordinal
  totalFreightChargesAmount
  totalFuelChargesAmount
  totalChargesAmount
  shipmentType
  standardShipmentFields {
    deadlineDate
    pickupOrDelivery
  }
  documents {
    ...Document
  }
  packages {
    description
    weight
    quantity
    length
    width
    height
  }
  legs {
    endStop {
      stopType
      status
      appointmentTime
      endAppointmentTime
      completedAt
      specialInstructions
      proofOfDeliverySignee
      paperworkMarkedComplete
      address {
        ...Address
      }
      contactPerson {
        phone
        email
        firstName
        lastName
      }
      routeSlot {
        route {
          name
          drivers {
            firstName
            lastName
          }
        }
      }
    }
  }
  order {
    uuid
    name
    secondaryRefNumber
    totalCharge
    totalFreightChargesAmount
    totalFuelChargesAmount
    totalCustomChargesAmount
    notes
    billingPartyContact {
      uuid
      displayName
    }
    ordinal
    orderEvents {
      eventType
      sourceType
      createdAt
      sourceUser {
        email
      }
    }
    company {
      name
      defaultAddress {
        ...Address
      }
    }
    shipments {
      customCharges {
        authoCode
        name
        accessorialTemplate {
          name
        }
        total
      }
    }
    standardOrderFields {
      masterAirwayBillOfLadingNumber
      shipperBillOfLadingNumber
    }
    service {
      name
    }
  }
  charges {
    ... on CustomChargeEntity {
      uuid
      authoCode
      name
      zoneBasedAccessorialZoneUuid
      zoneBasedAccessorialChargeGroupUuid
      specialAccessorialTariffZoneUuid
      specialAccessorialChargeGroupUuid
      quantity
      description
      rate
      total
      customChargeBillingMethod: billingMethod
      accessorialTemplate {
        uuid
        name
        __typename
      }
    }
    ... on FreightChargeEntity {
      uuid
      authoCode
      billingMethod
      tariff {
        uuid
        billingPartyContactUuid
        tariffOverageRates {
          uuid
          name
          type
          rateUsdCents
          applicableAboveAmount
        }
      }
      rate
      description
      quantity
      fuelCharge {
        description
        authoCode
        surchargeRate
        flatRate
        type
        uuid
      }
    }
  }
}
    ${DocumentFragmentDoc}
${AddressFragmentDoc}`;
export const OrderTableFieldHeaderFragmentDoc = gql`
    fragment OrderTableFieldHeader on OrderTableFieldHeaderEntity {
  orderTableField
  header
}
    `;
export const FormattedOrderFieldFragmentDoc = gql`
    fragment FormattedOrderField on FormattedOrderFieldEntity {
  orderTableField
  value
}
    `;
export const OrderTableFieldPaperworkFragmentDoc = gql`
    fragment OrderTableFieldPaperwork on OrderTablePaperworkFieldEntity {
  paperwork {
    ...OrderPaperwork
  }
  inboundPaperwork {
    ...OrderPaperworkWithGroupedDocuments
  }
  outboundPaperwork {
    ...OrderPaperworkWithGroupedDocuments
  }
}
    ${OrderPaperworkFragmentDoc}
${OrderPaperworkWithGroupedDocumentsFragmentDoc}`;
export const OrderTableFieldTagFragmentDoc = gql`
    fragment OrderTableFieldTag on OrderTableTagEntity {
  value
  color
}
    `;
export const OrderTableFieldPhotoFragmentDoc = gql`
    fragment OrderTableFieldPhoto on OrderTablePhotoEntity {
  shipmentUuid
  shipmentPickupOrDelivery
  fileName
  type
  preSignedGetUrl
}
    `;
export const OrderTableFieldPackageFragmentDoc = gql`
    fragment OrderTableFieldPackage on OrderTablePackageEntity {
  uuid
  quantity
  weight
  length
  width
  height
}
    `;
export const OrderTableCustomChargeFragmentDoc = gql`
    fragment OrderTableCustomCharge on OrderTableCustomChargeFieldEntity {
  name
  billingMethod
  total
}
    `;
export const RateOrderShipmentChargesForItemizedChargesFragmentDoc = gql`
    fragment RateOrderShipmentChargesForItemizedCharges on RateShipmentForOrderSuccessOutput {
  total
  freightCharge {
    totalDollars
    tariffUuid
  }
  fuelCharge {
    totalDollars
    surchargeRatePercentage
  }
}
    `;
export const OrderTableFieldItemizedChargesFragmentDoc = gql`
    fragment OrderTableFieldItemizedCharges on OrderTableItemizedChargesFieldEntity {
  freightChargeTotal
  fuelChargeTotal
  shipmentCharges {
    shipmentType
    pickupOrDelivery
    stopType
    tariff {
      uuid
      tariffZone {
        uuid
        name
      }
      tariffGroup {
        name
      }
    }
    freightBillingMethod
    freightRate
    freightQuantity
    freightTotalAmount
    fuelBillingMethod
    fuelSurchargeRate
    fuelFlatRate
    fuelTotalAmount
    customCharges {
      ...OrderTableCustomCharge
    }
  }
  rateOrderOutput {
    __typename
    ... on RateOrderSuccessOutput {
      success
      totalDollars
      inboundShipmentCharges {
        ...RateOrderShipmentChargesForItemizedCharges
      }
      outboundShipmentCharges {
        ...RateOrderShipmentChargesForItemizedCharges
      }
      orderCharges {
        ...RateOrderShipmentChargesForItemizedCharges
      }
      lineHaulCharges {
        ...RateOrderShipmentChargesForItemizedCharges
      }
    }
    ... on RateOrderErrorOutput {
      success
      errorMessage
    }
  }
  customCharges {
    ...OrderTableCustomCharge
  }
}
    ${OrderTableCustomChargeFragmentDoc}
${RateOrderShipmentChargesForItemizedChargesFragmentDoc}`;
export const FormattedOrderFragmentDoc = gql`
    fragment FormattedOrder on FormattedOrderEntity {
  uuid
  formattedOrderFields {
    ...FormattedOrderField
  }
  paperworkField {
    ...OrderTableFieldPaperwork
  }
  tagsField {
    orderTableTags {
      ...OrderTableFieldTag
    }
  }
  photosField {
    orderTablePhotos {
      ...OrderTableFieldPhoto
    }
  }
  serviceField {
    service {
      uuid
      name
    }
  }
  packagesField {
    orderTablePackages {
      ...OrderTableFieldPackage
    }
  }
  itemizedChargesField {
    ...OrderTableFieldItemizedCharges
  }
  lineHaulManifestsField {
    startTerminal {
      uuid
      code
    }
    endTerminal {
      uuid
      code
    }
    currentTerminal {
      uuid
      code
    }
    lineHaulManifests {
      startTerminal {
        uuid
        code
      }
      endTerminal {
        uuid
        code
      }
      status
    }
  }
  contactUuid
}
    ${FormattedOrderFieldFragmentDoc}
${OrderTableFieldPaperworkFragmentDoc}
${OrderTableFieldTagFragmentDoc}
${OrderTableFieldPhotoFragmentDoc}
${OrderTableFieldPackageFragmentDoc}
${OrderTableFieldItemizedChargesFragmentDoc}`;
export const OrderTableFieldValuesFormattedOrderConnectionFragmentDoc = gql`
    fragment OrderTableFieldValuesFormattedOrderConnection on FormattedOrderConnection {
  edges {
    node {
      ...FormattedOrder
    }
  }
  totalCount
  pageInfo {
    startCursor
    endCursor
    hasNextPage
    hasPreviousPage
  }
}
    ${FormattedOrderFragmentDoc}`;
export const OrderTableFieldValuesOutputFragmentDoc = gql`
    fragment OrderTableFieldValuesOutput on GetOrderTableFieldValuesOutput {
  orderTableFieldHeaders {
    ...OrderTableFieldHeader
  }
  formattedOrderConnection {
    ...OrderTableFieldValuesFormattedOrderConnection
  }
}
    ${OrderTableFieldHeaderFragmentDoc}
${OrderTableFieldValuesFormattedOrderConnectionFragmentDoc}`;
export const OrderWithMissingDocumentsFragmentDoc = gql`
    fragment OrderWithMissingDocuments on OrderEntity {
  uuid
  missingDocuments
}
    `;
export const OrderWithPaperworkFragmentDoc = gql`
    fragment OrderWithPaperwork on OrderEntity {
  uuid
  paperwork {
    ...OrderPaperwork
  }
}
    ${OrderPaperworkFragmentDoc}`;
export const ContactForOrdersTableFragmentDoc = gql`
    fragment ContactForOrdersTable on ContactEntity {
  uuid
  displayName
  billingCycleDuration
  businessDivision {
    name
  }
  masterAccount {
    name
  }
  invoiceTimePeriodSplit
  numberOfOrdersPerInvoice
}
    `;
export const ShipmentWithDocumentsForOrdersTableFragmentDoc = gql`
    fragment ShipmentWithDocumentsForOrdersTable on ShipmentEntity {
  documents {
    uuid
    fileName
    preSignedGetUrl
    type
  }
}
    `;
export const StopWithRouteSlotForOrdersTableFragmentDoc = gql`
    fragment StopWithRouteSlotForOrdersTable on StopEntity {
  routeSlot {
    route {
      name
      date
      drivers {
        firstName
        lastName
      }
    }
  }
}
    `;
export const ShipmentFragmentDoc = gql`
    fragment Shipment on ShipmentEntity {
  invoice {
    uuid
  }
  uuid
  ordinal
  ...ShipmentWithDocumentsForOrdersTable @include(if: $includeDocuments)
  hideFromBilling
  status
  airportInfo {
    iataCode
  }
  standardShipmentFields {
    pickupOrDelivery
    deliveryDate
    deadlineType
    deadlineDate
  }
  legs {
    uuid
    endStop {
      uuid
      notes
      ...StopWithRouteSlotForOrdersTable @include(if: $includeRouteSlot)
      standardStopType
      stopType
      appointmentTextStatus
      appointmentTime
      endAppointmentTime
      proofOfDeliverySignee
      inboundMethod
      expectedInboundArrivalDate
      outboundMethod
      completedAt
      driverCompletedAt
      createdAt
      status
      isSpecial
      paperworkMarkedComplete
      contactPerson {
        phone
        email
        firstName
        lastName
      }
      address {
        uuid
        name
        line1
        line2
        city
        state
        latitude
        longitude
        zip
      }
      terminal {
        name
      }
    }
    previousStopAttempts {
      completedAt
    }
  }
  shipmentType
}
    ${ShipmentWithDocumentsForOrdersTableFragmentDoc}
${StopWithRouteSlotForOrdersTableFragmentDoc}`;
export const OrderWithCommentsFragmentDoc = gql`
    fragment OrderWithComments on OrderEntity {
  orderComments {
    uuid
    updatedAt
    user {
      uuid
      email
    }
    comment
  }
}
    `;
export const OrderFragmentDoc = gql`
    fragment Order on OrderEntity {
  standardOrderFields {
    shipperBillOfLadingNumber
    masterAirwayBillOfLadingNumber
  }
  packages {
    length
    width
    height
    quantity
  }
  weight
  dimWeight
  createdAt
  receivedDate
  secondaryRefNumber
  status
  detailedStatusV2
  uuid
  name
  missingDocuments
  paperwork {
    ...OrderPaperwork
  }
  osd
  source
  refNumbers
  secondaryRefNumber
  notes
  dateMarkedLoaded
  dateMarkedOnHand
  dateMarkedReceivedAtOrigin
  pieceCount
  itTeNumber
  pieceCountFromPackages
  inBond
  piecesPicked
  piecesLoaded
  refusedBy
  hasDriverPod
  hasDriverUploadedDocument
  holdReason {
    name
  }
  service {
    name
  }
  tags {
    ...Tag
  }
  billingPartyContact {
    ...ContactForOrdersTable
  }
  documents {
    ...Document
  }
  shipments {
    ...Shipment
  }
  lineHaulLane {
    name
    originTerminal {
      code
    }
    destinationTerminal {
      code
    }
  }
  startStop {
    address {
      name
      line1
      line2
      city
      state
      zip
    }
    terminal {
      code
    }
    serviceDate
    serviceDateV2 {
      iso8601
    }
    incomingCarrier
  }
  endStop {
    address {
      name
      line1
      line2
      city
      state
      zip
    }
    terminal {
      code
    }
    serviceDate
    serviceDateV2 {
      iso8601
    }
    outboundCarrier
  }
  totalSkids
  externalNotes
  ...OrderWithComments @include(if: $includeOrderComments)
}
    ${OrderPaperworkFragmentDoc}
${TagFragmentDoc}
${ContactForOrdersTableFragmentDoc}
${DocumentFragmentDoc}
${ShipmentFragmentDoc}
${OrderWithCommentsFragmentDoc}`;
export const ThirdPartyBrokerFragmentDoc = gql`
    fragment ThirdPartyBroker on ThirdPartyBrokerEntity {
  uuid
  name
}
    `;
export const OutstandingStandardShipmentFragmentDoc = gql`
    fragment OutstandingStandardShipment on StandardShipmentEntity {
  uuid
  shouldBillIndividually
  shouldUseDimWeight
  overridePackageWeight
  name
  hideFromBilling
  hasSignedPOD
  documents {
    uuid
    fileName
    fileType
    preSignedGetUrl
    type
    notes
    name
  }
  fields {
    uuid
    deadlineDate
    deadlineType
    deliveryDate
    dimFactor
    pickupOrDelivery
    outboundMethod
    inboundMethod
    service {
      ...Service
    }
    type
  }
  legs {
    uuid
    miles
    endStop {
      ...OutstandingOrderQueryStop
    }
    previousStopAttempts {
      stopDriverMaps {
        ...StopDriverMapForOrder
      }
    }
  }
  customCharges {
    ...CustomCharge
  }
  freightCharge {
    ...StandardShipmentFreightCharge
  }
  status
  inputForConsolidatedOrder {
    uuid
    name
  }
  shipmentType
  shipmentCharges {
    ...ShipmentCharges
  }
  invoice {
    uuid
    name
    date
    postedAt
  }
  independentSettlementBillLineItems {
    ...SettlementBillLineItemForOrder
  }
}
    ${ServiceFragmentDoc}
${OutstandingOrderQueryStopFragmentDoc}
${StopDriverMapForOrderFragmentDoc}
${CustomChargeFragmentDoc}
${StandardShipmentFreightChargeFragmentDoc}
${ShipmentChargesFragmentDoc}
${SettlementBillLineItemForOrderFragmentDoc}`;
export const OutstandingOrderFragmentFragmentDoc = gql`
    fragment OutstandingOrderFragment on StandardOrderEntity {
  updatedAt
  orderSegmentType
  fulfillmentType
  isOverdue
  detailedStatusV2
  isCrossDock
  issueReason
  personName
  personPhoneNumber
  personEmail
  name
  notes
  onHand
  dateMarkedOnHand
  refNumbers
  orderConsolidationType
  orderInvoiceByDate
  paymentMethod
  source
  status
  uuid
  isDraftOrder
  chargeableWeightCubicMeters
  totalSkids
  isReweighed
  tags {
    ...Tag
  }
  thirdPartyBrokers {
    ...ThirdPartyBroker
  }
  service {
    uuid
    name
  }
  standardOrderFields {
    uuid
    shipperBillOfLadingNumber
    lockShipperBillOfLadingNumber
    masterAirwayBillOfLadingNumber
    dimFactor
    measurementUnits
    weightUnits
  }
  secondaryRefNumber
  lockSecondaryRefNumber
  tertiaryRefNumber
  quaternaryRefNumber
  quinaryRefNumber
  documents {
    ...Document
  }
  paperwork {
    ...OrderPaperwork
  }
  billingPartyContact {
    uuid
    displayName
    numberOfOrdersPerInvoice
    invoiceTimePeriodSplit
  }
  billingPartyContactStation {
    id
    name
    defaultPerson {
      id
      firstName
      lastName
      phone
      email
    }
  }
  packages {
    uuid
    packageSpec {
      id
      name
    }
    height
    length
    quantity
    type
    weight
    width
    description
  }
  shipments {
    ...OutstandingStandardShipment
  }
  lineHaulCompletedDate
  orderComments {
    uuid
    updatedAt
    user {
      uuid
      email
    }
    comment
  }
  consolidatedShipmentString
  consolidatableOrders {
    error
    orders {
      uuid
    }
    shipments {
      uuid
    }
  }
  shouldBillIndividually
  consolidatedOrders {
    uuid
    standardOrderFields {
      shipperBillOfLadingNumber
    }
  }
  deletedAutoAppliedAccessorials {
    ... on StandardAccessorialEntity {
      uuid
    }
    ... on WeightBasedAccessorialEntity {
      uuid
    }
    ... on ZoneBasedAccessorialEntity {
      uuid
    }
    ... on WaitTimeAccessorialEntity {
      uuid
    }
    ... on UnitBasedAccessorialEntity {
      uuid
    }
    ... on SkidBasedAccessorialEntity {
      uuid
    }
    ... on SpecialAccessorialEntity {
      uuid
    }
  }
  enableLineHaul
  lineHaulLane {
    uuid
  }
  inBond
  hazmat
  ordersProratedWith {
    ...OrderProratedWith
  }
}
    ${TagFragmentDoc}
${ThirdPartyBrokerFragmentDoc}
${DocumentFragmentDoc}
${OrderPaperworkFragmentDoc}
${OutstandingStandardShipmentFragmentDoc}
${OrderProratedWithFragmentDoc}`;
export const RecurringOrderTemplateFragmentDoc = gql`
    fragment RecurringOrderTemplate on StandardOrderEntity {
  name
  uuid
  source
  standardOrderFields {
    shipperBillOfLadingNumber
  }
  billingPartyContact {
    displayName
  }
  recurringOrderFrequency {
    uuid
    startDate
    endDate
    repeatFrequencyUnit
    repeatIntervalWeeks
    repeatInterval
    daysOfWeek
    daysOfMonth
  }
  run {
    uuid
    name
  }
}
    `;
export const RecurringRunTemplateFragmentDoc = gql`
    fragment RecurringRunTemplate on RunEntity {
  name
  uuid
  isArchived
  terminal {
    uuid
    name
  }
  driver {
    uuid
    status
    firstName
    lastName
  }
  vehicleType {
    uuid
    name
  }
  recurringOrderTemplates {
    uuid
  }
  tags {
    uuid
  }
}
    `;
export const ShallowContactFragmentDoc = gql`
    fragment ShallowContact on ContactEntity {
  displayName
  type
  isActive
  shortCode
  uuid
  contactReferenceNumber
  quickbooksMappingId
  quickbooksDesktopContactId
  quickbooksFileMappingFreightChargeName
  quickbooksFileMappingCustomerName
  quickbooksFileMappingFuelChargeName
  quickbooksFileMappingPickupChargeName
  quickbooksDesktopAccountsReceivableId
  freightChargeQuickbooksMappingId
  fuelChargeQuickbooksMappingId
  miscCustomChargeQuickbooksMappingId
  stediPartnerId
  billingCycleDuration
  billingContactEmail
  isEfm
  services {
    uuid
    name
    markOrdersAsSpecial
    defaultAppointmentStartTime
    defaultAppointmentEndTime
  }
  defaultService {
    uuid
    name
  }
  defaultAddress {
    uuid
    line1
    line2
    city
    latitude
    longitude
    zip
    state
  }
  referenceNumberLabels {
    name
  }
  contactStations {
    id
    name
    isArchived
    defaultPerson {
      id
      firstName
      lastName
      phone
      email
    }
  }
  showEdiReferenceNumbersOnOrderPage
  ... on CustomerContactEntity {
    defaultUseTariff
    defaultInvoiceTransmissionMethod
    defaultInvoiceType
    defaultInvoiceDownloadDocuments
    defaultInvoiceDocumentsRequired
    defaultDimFactor
    defaultFuelSurcharge
    numberOfOrdersPerInvoice
    invoiceTimePeriodSplit
    isPrepaidOnly
    useCustomVehicleTypes
    vehicleTypes {
      uuid
      name
      status
    }
    useCustomPackageSpecs
    packageSpecs {
      id
      name
      status
      weight
      length
      width
      height
    }
  }
}
    `;
export const ScannedOrderResultFragmentFragmentDoc = gql`
    fragment ScannedOrderResultFragment on ScannedOrderResultEntity {
  uuid
  filename
  pageEnd
  pageStart
  status
  type
  failureReason
  scannedOrder {
    uuid
    bucket
    failureReason
    filename
    key
    preSignedGetUrl
    retryCount
    status
  }
  scannedOrderResultPages {
    page
    preSignedGetUrl
  }
  signedPodMatchStatus
}
    `;
export const ScannedOrderFragmentFragmentDoc = gql`
    fragment ScannedOrderFragment on ScannedOrderEntity {
  uuid
  bucket
  failureReason
  filename
  key
  preSignedGetUrl
  retryCount
  status
  s3Url
}
    `;
export const PieceFragmentDoc = gql`
    fragment Piece on PieceEntity {
  uuid
  referenceNumber
  warehouseLocation {
    uuid
    name
  }
}
    `;
export const OrderWithSameBillOfLadingNumberAsReviewOrderFragmentDoc = gql`
    fragment OrderWithSameBillOfLadingNumberAsReviewOrder on StandardOrderEntity {
  uuid
  name
}
    `;
export const StandardOrderFragmentFragmentDoc = gql`
    fragment StandardOrderFragment on StandardOrderEntity {
  updatedAt
  orderSegmentType
  fulfillmentType
  isOverdue
  detailedStatusV2
  osd
  codCheckAmountCents
  codCheckNumber
  isCollectOnDelivery
  isCrossDock
  hasEdiCancellation
  issueReason
  personName
  personPhoneNumber
  personEmail
  name
  notes
  refusedBy
  refusedDate
  ordersProratedWith {
    ...OrderProratedWith
  }
  vehicleType {
    uuid
    name
  }
  holdReason {
    uuid
    name
  }
  quote {
    uuid
    number
  }
  onHand
  refNumbers
  pieceCount
  piecesPicked
  orderConsolidationType
  orderInvoiceByDate
  paymentMethod
  receivedDate
  pickedDate
  source
  status
  uuid
  isDraftOrder
  chargeableWeightCubicMeters
  totalSkids
  isReweighed
  driverQualifications {
    id
    name
  }
  inBond
  hazmat
  itTeNumber
  unNumber
  hazmatDescription
  emergencyResponseNumber
  requiresPlacard
  hazmatClass
  packageGroup
  externalNotes
  totalAmountCents
  postedAmountCents
  recurringOrderFrequency {
    uuid
    startDate
    endDate
    repeatFrequencyUnit
    repeatInterval
    daysOfWeek
    daysOfMonth
    repeatIntervalWeeks
  }
  service {
    uuid
    name
  }
  standardOrderFields {
    uuid
    shipperBillOfLadingNumber
    lockShipperBillOfLadingNumber
    masterAirwayBillOfLadingNumber
    dimFactor
    measurementUnits
    weightUnits
  }
  scannedOrderResult {
    ...ScannedOrderResultFragment
    scannedOrder {
      ...ScannedOrderFragment
    }
  }
  secondaryRefNumber
  lockSecondaryRefNumber
  tertiaryRefNumber
  quaternaryRefNumber
  quinaryRefNumber
  documents {
    ...Document
  }
  paperwork {
    ...OrderPaperwork
  }
  billingPartyContact {
    defaultAddress {
      ...Address
    }
    uuid
    displayName
    numberOfOrdersPerInvoice
    invoiceTimePeriodSplit
  }
  billingPartyContactStation {
    id
    name
    defaultPerson {
      id
      firstName
      lastName
      phone
      email
    }
  }
  packages {
    ...Package
  }
  pieces {
    ...Piece
  }
  shipments {
    ...StandardShipment
  }
  lineHaulCompletedDate
  lineHaulTimeline {
    terminal {
      uuid
      code
    }
    markedArrivedAt
    departingManifest {
      uuid
      status
      departDate
      startedAt
      completedAt
      referenceNumber
      driver {
        firstName
        lastName
        agentId
      }
    }
    arrivalScans {
      uuid
      scannedAt
    }
    departureScans {
      uuid
      scannedAt
    }
  }
  tags {
    ...Tag
  }
  thirdPartyBrokers {
    ...ThirdPartyBroker
  }
  warehouse {
    uuid
    name
  }
  ordersWithSameBillOfLadingNumberForReviewOrders {
    ...OrderWithSameBillOfLadingNumberAsReviewOrder
  }
  orderComments {
    uuid
    updatedAt
    user {
      uuid
      email
    }
    comment
    showOnInvoice
    authorName
  }
  dateMarkedLoaded
  dateMarkedOnHand
  dateMarkedReceivedAtOrigin
  pieceCount
  piecesPicked
  piecesLoaded
  enableLineHaul
  lineHaulLane {
    uuid
    originTerminal {
      uuid
      code
    }
    destinationTerminal {
      uuid
      code
    }
  }
  consolidatableOrders {
    error
    orders {
      uuid
    }
    shipments {
      uuid
    }
  }
  shouldBillIndividually
  consolidatedShipmentString
  consolidatedOrders {
    uuid
    standardOrderFields {
      shipperBillOfLadingNumber
    }
  }
  deletedAutoAppliedAccessorials {
    ... on StandardAccessorialEntity {
      uuid
    }
    ... on WeightBasedAccessorialEntity {
      uuid
    }
    ... on ZoneBasedAccessorialEntity {
      uuid
    }
    ... on WaitTimeAccessorialEntity {
      uuid
    }
    ... on UnitBasedAccessorialEntity {
      uuid
    }
    ... on SkidBasedAccessorialEntity {
      uuid
    }
    ... on SpecialAccessorialEntity {
      uuid
    }
  }
}
    ${OrderProratedWithFragmentDoc}
${ScannedOrderResultFragmentFragmentDoc}
${ScannedOrderFragmentFragmentDoc}
${DocumentFragmentDoc}
${OrderPaperworkFragmentDoc}
${AddressFragmentDoc}
${PackageFragmentDoc}
${PieceFragmentDoc}
${StandardShipmentFragmentDoc}
${TagFragmentDoc}
${ThirdPartyBrokerFragmentDoc}
${OrderWithSameBillOfLadingNumberAsReviewOrderFragmentDoc}`;
export const StopForDriverSettlementFragmentDoc = gql`
    fragment StopForDriverSettlement on StopEntity {
  uuid
  stopDriverMaps {
    ...StopDriverMapForOrder
  }
  settlementDeductionName
  settlementDeductionFlatRate
  settlementDeductionPercentageRate
}
    ${StopDriverMapForOrderFragmentDoc}`;
export const RateOrderSettlementBillLineItemFragmentDoc = gql`
    fragment RateOrderSettlementBillLineItem on RateIndependentSettlementBillLineItemSuccessOutput {
  customCostTotal
  customCosts {
    errorMessage
    existingCustomCostId
    fuelSurchargePercentageRate
    rateDollars
    totalDollars
  }
  freightCost {
    discountRate
    miles
    quantity
    rateDollars
    tariffUuid
    totalDollars
  }
  fuelCost {
    surchargeRate
    surchargeRatePercentage
    totalDollars
  }
  success
  total
}
    `;
export const ClientQuoteFragmentDoc = gql`
    fragment ClientQuote on QuoteEntity {
  uuid
  createdAt
  source
  status
  number
  billingPartyContact {
    displayName
    uuid
  }
  totalCharge
  order {
    uuid
  }
}
    `;
export const InvoicePdfColumnFragmentFragmentDoc = gql`
    fragment InvoicePdfColumnFragment on PdfColumnEntity {
  uuid
  orderColumnMapping
  shipmentPDFColumnMapping
  legPDFColumnMapping
  stopPDFColumnMapping
}
    `;
export const InvoiceTermFragmentDoc = gql`
    fragment InvoiceTerm on InvoiceTermEntity {
  uuid
  terms
}
    `;
export const ContactFragmentDoc = gql`
    fragment Contact on ContactEntity {
  uuid
  displayName
  ediApplicationId
  ediContactCode
  isActive
  isaId
  identifier
  contactReferenceNumber
  shortCode
  stediPartnerId
  isOverCreditLimit
  quickbooksDesktopContactId
  stediPartnerId
  quickbooksMappingId
  fuelChargeQuickbooksMappingId
  freightChargeQuickbooksMappingId
  miscCustomChargeQuickbooksMappingId
  type
  billingCycle
  billingCycleDuration
  billingPeriod
  requireDriverToCheckOffPackagesAtStop
  invoiceNotes
  masterAccount {
    uuid
  }
  contactComments {
    uuid
    updatedAt
    createdAt
    comment
    authorName
  }
  services {
    ...Service
  }
  invoicePdfColumns {
    ...InvoicePdfColumnFragment
  }
  addresses {
    ...Address
  }
  contactPersons {
    ...ContactPerson
  }
  defaultAddress {
    ...Address
  }
  defaultContactPerson {
    ...ContactPerson
  }
  defaultService {
    ...Service
  }
  businessDivision {
    uuid
    name
  }
  masterAccount {
    uuid
    name
  }
  referenceNumberLabels {
    name
  }
  ... on CustomerContactEntity {
    defaultFuelSurcharge
    defaultUseTariff
    pickupDiscountRate
    deliveryDiscountRate
    transferDiscountRate
    lineHaulDiscountRate
    defaultDimFactor
    billingContactEmail
    defaultInvoiceType
    defaultInvoiceTransmissionMethod
    defaultInvoiceDownloadDocuments
    defaultInvoiceDocumentsRequired
    defaultInvoiceEmailSubject
    defaultAddress {
      ...Address
    }
    defaultContactPerson {
      ...ContactPerson
    }
    identifier
    numberOfOrdersPerInvoice
    invoiceTimePeriodSplit
    defaultInvoiceTerms {
      ...InvoiceTerm
    }
    creditHoldLimitInCents
    enableCreditHold
    maxDaysOutstanding
    isPrepaidOnly
    enableCustomerPortalOrderEntry
    useCustomPackageSpecs
    packageSpecs {
      id
    }
    showEdiReferenceNumbersOnOrderPage
    useCustomVehicleTypes
    vehicleTypes {
      uuid
    }
    defaultInboundEdiService {
      uuid
      name
    }
    defaultOutboundEdiService {
      uuid
      name
    }
    defaultInboundOutboundEdiService {
      uuid
      name
    }
    defaultOrdinaryTariffChain {
      id
      name
    }
    defaultLineHaulTariffChain {
      id
      name
    }
    defaultTransferTariffChain {
      id
      name
    }
    defaultPointToPointTariffChain {
      id
      name
    }
  }
}
    ${ServiceFragmentDoc}
${InvoicePdfColumnFragmentFragmentDoc}
${AddressFragmentDoc}
${ContactPersonFragmentDoc}
${InvoiceTermFragmentDoc}`;
export const QuoteFragmentDoc = gql`
    fragment Quote on QuoteEntity {
  uuid
  number
  createdAt
  service {
    uuid
  }
  status
  dimFactor
  measurementUnits
  weightUnits
  totalSkids
  source
  shipments {
    ...StandardShipment
  }
  packages {
    ...Package
  }
  billingPartyContact {
    ...Contact
  }
  company {
    ...Company
  }
  order {
    uuid
  }
  enableLineHaul
}
    ${StandardShipmentFragmentDoc}
${PackageFragmentDoc}
${ContactFragmentDoc}
${CompanyFragmentDoc}`;
export const CustomerReportBucketFragmentDoc = gql`
    fragment CustomerReportBucket on CustomerReportBucketEntity {
  uuid
  displayName
  freightRevenue
  fuelRevenue
  lineHaulRevenue
  specialRevenue
  customChargeRevenue
  surchargeRevenue
  pickupRevenue
  deliveryRevenue
  recoveryRevenue
  transferRevenue
  totalRevenue
  totalWeight
  numberOfOrders
  numberOfPackages
}
    `;
export const DriverReportBucketFragmentDoc = gql`
    fragment DriverReportBucket on DriverReportBucketEntity {
  uuid
  firstName
  lastName
  driverType
  freightRevenue
  fuelRevenue
  lineHaulRevenue
  specialRevenue
  customChargeRevenue
  surchargeRevenue
  pickupRevenue
  deliveryRevenue
  recoveryRevenue
  transferRevenue
  totalRevenue
  totalWeight
  numberOfOrders
  numberOfPackages
}
    `;
export const OrderReportBucketFragmentDoc = gql`
    fragment OrderReportBucket on OrderReportBucketEntity {
  startDate
  endDate
  freightRevenue
  fuelRevenue
  lineHaulRevenue
  specialRevenue
  customChargeRevenue
  surchargeRevenue
  pickupRevenue
  deliveryRevenue
  recoveryRevenue
  transferRevenue
  totalRevenue
  totalWeight
  numberOfOrders
  numberOfPackages
}
    `;
export const ReportGroupConfigurationFragmentDoc = gql`
    fragment ReportGroupConfiguration on ReportGroupConfigurationEntity {
  uuid
  name
  contact {
    uuid
    displayName
  }
  contacts {
    uuid
    displayName
  }
  driver {
    uuid
    firstName
    lastName
  }
  drivers {
    uuid
    firstName
    lastName
  }
  orderStatuses
  stopTypes
  reportAggregationPeriod
  defaultReportType
  reportRevenueType
  reportStatistics
  lastNumberOfDays
  lastNumberOfWeeks
  lastNumberOfMonths
  startDate
  endDate
  terminal {
    uuid
    code
  }
}
    `;
export const ReportSendJobBatchProgressFragmentDoc = gql`
    fragment ReportSendJobBatchProgress on ReportSendJobBatchProgressEntity {
  successCount
  failCount
  totalCount
}
    `;
export const ReportSendJobBatchFragmentDoc = gql`
    fragment ReportSendJobBatch on ReportSendJobBatchEntity {
  id
  createdAt
  reportSendJobBatchProgress {
    ...ReportSendJobBatchProgress
  }
  reportSendJobs {
    id
    createdAt
    reportType
  }
}
    ${ReportSendJobBatchProgressFragmentDoc}`;
export const ReportSendJobFragmentDoc = gql`
    fragment ReportSendJob on ReportSendJobEntity {
  id
  reportType
  contact {
    displayName
  }
  reportSendJobError
  emailTransaction {
    emailTransactionStatus
    emailTransactionLogs {
      uuid
      email
      lastStatus
      reason
    }
  }
  document {
    preSignedGetUrl
  }
}
    `;
export const ServiceLevelReportBucketFragmentDoc = gql`
    fragment ServiceLevelReportBucket on ServiceLevelReportBucketEntity {
  uuid
  name
  freightRevenue
  fuelRevenue
  lineHaulRevenue
  specialRevenue
  customChargeRevenue
  surchargeRevenue
  pickupRevenue
  deliveryRevenue
  recoveryRevenue
  transferRevenue
  totalRevenue
  totalWeight
  numberOfOrders
  numberOfPackages
}
    `;
export const StationReportBucketFragmentDoc = gql`
    fragment StationReportBucket on StationReportBucketEntity {
  startDate
  endDate
  stationId
  stationName
  freightRevenue
  fuelRevenue
  lineHaulRevenue
  specialRevenue
  customChargeRevenue
  surchargeRevenue
  pickupRevenue
  deliveryRevenue
  recoveryRevenue
  transferRevenue
  totalRevenue
  totalWeight
  numberOfOrders
  numberOfPackages
}
    `;
export const TerminalReportBucketFragmentDoc = gql`
    fragment TerminalReportBucket on TerminalReportBucketEntity {
  uuid
  name
  code
  freightRevenue
  fuelRevenue
  lineHaulRevenue
  specialRevenue
  customChargeRevenue
  surchargeRevenue
  pickupRevenue
  deliveryRevenue
  recoveryRevenue
  transferRevenue
  totalRevenue
  totalWeight
  numberOfOrders
  numberOfPackages
}
    `;
export const FindRolePermissionFragmentDoc = gql`
    fragment FindRolePermission on PermissionEntity {
  uuid
  permissionResource
  accessLevel
}
    `;
export const FindRoleUserFragmentDoc = gql`
    fragment FindRoleUser on UserEntity {
  uuid
  email
}
    `;
export const FindRoleFragmentDoc = gql`
    fragment FindRole on RoleEntity {
  uuid
  name
  permissions {
    ...FindRolePermission
  }
  users {
    ...FindRoleUser
  }
}
    ${FindRolePermissionFragmentDoc}
${FindRoleUserFragmentDoc}`;
export const FindRolesFragmentDoc = gql`
    fragment FindRoles on RoleEntity {
  uuid
  name
  isInternalRole
}
    `;
export const UsersForRoleFragmentDoc = gql`
    fragment UsersForRole on UserEntity {
  uuid
  email
  phoneNumber
  name
}
    `;
export const SavedFilterViewFragmentDoc = gql`
    fragment SavedFilterView on SavedFilterViewEntity {
  uuid
  user {
    uuid
  }
  displayName
  isShared
  filterModelJson
  filterModelJsonV2
  sortModelJson
  orderTableFields
  dispatchTableFields
}
    `;
export const ScannedOrderResultPageFragmentFragmentDoc = gql`
    fragment ScannedOrderResultPageFragment on ScannedOrderResultPageEntity {
  uuid
  bucket
  key
  page
  preSignedGetUrl
}
    `;
export const ScannedOrderResultWithOrdersFragmentDoc = gql`
    fragment ScannedOrderResultWithOrders on ScannedOrderResultEntity {
  uuid
  createdAt
  duplicateOrder {
    uuid
    source
  }
  duplicateScannedOrderResultOrder {
    uuid
    source
  }
  status
  signedPodMatchStatus
  failureReason
  filename
  pageEnd
  pageStart
  order {
    uuid
    name
    billingPartyContact {
      uuid
      displayName
    }
    standardOrderFields {
      shipperBillOfLadingNumber
    }
  }
  podOrder {
    uuid
    standardOrderFields {
      shipperBillOfLadingNumber
    }
  }
}
    `;
export const AllSchedulingZoneFieldsFragmentDoc = gql`
    fragment AllSchedulingZoneFields on SchedulingZoneEntity {
  id
  name
  isArchived
  availabilities {
    id
    dayOfWeek
    start {
      hour
      minute
    }
    end {
      hour
      minute
    }
  }
  locations {
    id
    zipcode
    city
  }
}
    `;
export const AllSchedulingRegionFieldsFragmentDoc = gql`
    fragment AllSchedulingRegionFields on SchedulingRegionEntity {
  id
  name
  dailyCapacityPieces
  dailyCapacityStops
  dailyCapacityWeight
  isArchived
  zones {
    ...AllSchedulingZoneFields
  }
}
    ${AllSchedulingZoneFieldsFragmentDoc}`;
export const ReferenceNumberFormatCheckFragmentDoc = gql`
    fragment ReferenceNumberFormatCheck on ReferenceNumberFormatCheckEntity {
  uuid
  type
  operator
  startsWithOperands
  lengthOperand
}
    `;
export const DriverSettlementBillSummaryV2FragmentDoc = gql`
    fragment DriverSettlementBillSummaryV2 on DriverSettlementBillEntity {
  uuid
  name
  payPeriod
  settlementDate
  finalizedDate
  snapshotExists
  driver {
    uuid
    user {
      name
    }
  }
  paymentInformation {
    eligiblePay
    netAdjustments
    finalPay
  }
}
    `;
export const SettlementAdjustmentFragmentDoc = gql`
    fragment SettlementAdjustment on SettlementAdjustmentEntity {
  uuid
  adjustmentType
  name
  flatRate
  percentageDecimalRate
  totalDollars
}
    `;
export const SettlementBillLineItemFragmentDoc = gql`
    fragment SettlementBillLineItem on SettlementBillLineItemEntity {
  id
  totalAmountUsdDollars
  driver {
    uuid
    driverType
    user {
      name
    }
  }
  driverSettlementBill {
    uuid
    settlementDate
    finalizedDate
  }
  shipment {
    order {
      uuid
      refNumbers
      name
      standardOrderFields {
        shipperBillOfLadingNumber
      }
      billingPartyContact {
        displayName
      }
    }
    legs {
      endStop {
        stopType
        completedAt
      }
    }
  }
}
    `;
export const DriverSettlementBillV2FragmentDoc = gql`
    fragment DriverSettlementBillV2 on DriverSettlementBillEntity {
  uuid
  name
  createdAt
  billStartDate
  billEndDate
  payPeriod
  settlementDate
  totalDriverPayoutPreDeduction
  snapshot
  driver {
    uuid
    firstName
    lastName
    user {
      name
    }
  }
  finalizedDate
  settlementAdjustments {
    ...SettlementAdjustment
  }
  paymentInformation {
    eligiblePay
    netAdjustments
    finalPay
  }
  settlementBillLineItems {
    ...SettlementBillLineItem
  }
}
    ${SettlementAdjustmentFragmentDoc}
${SettlementBillLineItemFragmentDoc}`;
export const SettlementBillLineItemWithCostsFragmentDoc = gql`
    fragment SettlementBillLineItemWithCosts on SettlementBillLineItemEntity {
  id
  totalAmountUsdDollars
  customCosts {
    id
    name
    billingMethod
    dependentSettlementBillingMethod
    percentageRate
    flatRateUsdDollars
    quantity
    rateUsdDollars
    fuelSurchargeRate
    totalAmountUsdDollars
    accessorialTemplate {
      uuid
      name
      type
    }
  }
  freightCost {
    id
    billingMethod
    dependentSettlementBillingMethod
    percentageRate
    flatRateUsdDollars
    quantity
    rateUsdDollars
    discountRate
    totalAmountUsdDollars
    tariff {
      uuid
    }
    fuelCost {
      id
      billingMethod
      dependentSettlementBillingMethod
      percentageRate
      surchargeRate
      flatRateUsdDollars
      totalAmountUsdDollars
    }
  }
}
    `;
export const CompletedStopNotOnRouteFragmentDoc = gql`
    fragment CompletedStopNotOnRoute on StopEntity {
  uuid
  createdAt
  notes
  specialInstructions
  leg {
    shipment {
      uuid
      standardShipmentFields {
        pickupOrDelivery
      }
      order {
        uuid
        name
        standardOrderFields {
          uuid
          shipperBillOfLadingNumber
        }
      }
      documents {
        ...Document
      }
    }
  }
  routeSlot {
    uuid
    route {
      uuid
    }
  }
  status
  appointmentTime
  endAppointmentTime
  appointmentTextStatus
  address {
    ...Address
  }
  paperworkMarkedComplete
}
    ${DocumentFragmentDoc}
${AddressFragmentDoc}`;
export const CreateStorageOrderDocumentFragmentDoc = gql`
    fragment CreateStorageOrderDocument on DocumentEntity {
  uuid
}
    `;
export const CreateStorageOrderFragmentDoc = gql`
    fragment CreateStorageOrder on StorageOrderEntity {
  uuid
}
    `;
export const FindStorageOrderStorageUnitsFragmentDoc = gql`
    fragment FindStorageOrderStorageUnits on StorageUnitEntity {
  uuid
  name
  unitOfMeasure
  items {
    assignedQuantity
    item {
      uuid
      sku
      description
    }
  }
}
    `;
export const StorageUnitItemFragmentDoc = gql`
    fragment StorageUnitItem on ItemForStorageUnit {
  item {
    uuid
    primaryUOM {
      uuid
      unitOfMeasure
    }
    sku
    description
  }
  assignedQuantity
}
    `;
export const StorageOrderStorageUnitFragmentDoc = gql`
    fragment StorageOrderStorageUnit on StorageUnitEntity {
  uuid
  name
  unitOfMeasure
  weight
  length
  width
  height
  outboundReferenceNumber
  markedOnHandAt
  markedOsdAt
  osdReason
  inventoryLastVerifiedAt
  pickedAt
  warehouseLocation {
    uuid
    name
  }
  items {
    ...StorageUnitItem
  }
}
    ${StorageUnitItemFragmentDoc}`;
export const StorageOrderContactFragmentDoc = gql`
    fragment StorageOrderContact on ContactEntity {
  uuid
  displayName
}
    `;
export const StorageOrderDocumentFragmentDoc = gql`
    fragment StorageOrderDocument on DocumentEntity {
  uuid
  fileName
  bucket
  region
  key
  uploadedAt
  fileType
  isDeleted
  preSignedGetUrl
  name
  type
  pageNumber
  createdAt
}
    `;
export const ShallowItemFragmentDoc = gql`
    fragment ShallowItem on ItemEntity {
  uuid
  description
  sku
  primaryUOM {
    unitOfMeasure
  }
  secondaryUOM {
    unitOfMeasure
  }
  warehouse {
    uuid
    name
  }
}
    `;
export const StorageOrderItemFragmentDoc = gql`
    fragment StorageOrderItem on ItemForStorageOrder {
  item {
    ...ShallowItem
  }
  totalQuantity
  unassignedQuantity
}
    ${ShallowItemFragmentDoc}`;
export const FindStorageOrderFragmentDoc = gql`
    fragment FindStorageOrder on StorageOrderEntity {
  uuid
  referenceNumber
  purchaseOrderNumber
  carrier
  trackingNumber
  supplierCompanyName
  lotNumber
  consigneeName
  notes
  pickupDate
  expectedAt
  arrivedAt
  contact {
    ...StorageOrderContact
  }
  documents {
    ...StorageOrderDocument
  }
  items {
    ...StorageOrderItem
  }
  isOSD
  warehouse {
    uuid
    name
  }
}
    ${StorageOrderContactFragmentDoc}
${StorageOrderDocumentFragmentDoc}
${StorageOrderItemFragmentDoc}`;
export const StorageOrderFragmentDoc = gql`
    fragment StorageOrder on StorageOrderEntity {
  uuid
  referenceNumber
  purchaseOrderNumber
  carrier
  trackingNumber
  supplierCompanyName
  lotNumber
  consigneeName
  notes
  pickupDate
  expectedAt
  arrivedAt
  contact {
    ...StorageOrderContact
  }
  isOSD
  warehouse {
    uuid
    name
  }
}
    ${StorageOrderContactFragmentDoc}`;
export const FindStorageUnitsForPicklistFragmentDoc = gql`
    fragment FindStorageUnitsForPicklist on StorageUnitEntity {
  uuid
  name
  unitOfMeasure
  markedOnHandAt
  markedOsdAt
  pickedAt
  storageOrder {
    referenceNumber
    contact {
      uuid
      displayName
    }
  }
  warehouseLocation {
    uuid
    name
  }
  itemUOM
  sku
}
    `;
export const FindStorageUnitsFragmentDoc = gql`
    fragment FindStorageUnits on StorageUnitEntity {
  uuid
  name
  unitOfMeasure
  outboundReferenceNumber
  billed
  markedOnHandAt
  markedOsdAt
  inventoryLastVerifiedAt
  pickedAt
  currentBillableDays
  numberOfDaysInStorage
  storageOrder {
    uuid
    referenceNumber
    contact {
      uuid
      displayName
    }
  }
  warehouseLocation {
    uuid
    name
  }
  itemUOM
  sku
  itemDescription
}
    `;
export const FindItemGroupsFragmentDoc = gql`
    fragment FindItemGroups on ItemGroupEntity {
  uuid
  quantity
  pickedAt
  storageUnit {
    uuid
    name
    outboundReferenceNumber
    billed
    markedOnHandAt
    markedOsdAt
    inventoryLastVerifiedAt
    pickedAt
    currentBillableDays
    numberOfDaysInStorage
    unitOfMeasure
    warehouseLocation {
      uuid
      name
    }
    weight
    length
    width
    height
    osdReason
  }
  storageOrder {
    uuid
    referenceNumber
    contact {
      uuid
      displayName
    }
    arrivedAt
    consigneeName
    supplierCompanyName
    purchaseOrderNumber
    lotNumber
    warehouse {
      uuid
      name
    }
  }
  item {
    sku
    description
    primaryUOM {
      uuid
      unitOfMeasure
    }
  }
}
    `;
export const UpdateStorageOrderFragmentDoc = gql`
    fragment UpdateStorageOrder on StorageOrderEntity {
  uuid
}
    `;
export const UpdateStorageUnitFragmentDoc = gql`
    fragment UpdateStorageUnit on StorageUnitEntity {
  uuid
}
    `;
export const ShallowTariffZoneFragmentDoc = gql`
    fragment ShallowTariffZone on TariffZoneEntity {
  uuid
  name
  type
}
    `;
export const TextMessageFragmentDoc = gql`
    fragment TextMessage on TextMessageEntity {
  createdAt
  timestamp
  message
}
    `;
export const CreateWarehouseLocationFragmentDoc = gql`
    fragment CreateWarehouseLocation on WarehouseLocationEntity {
  uuid
}
    `;
export const WarehouseLocationsLocationFragmentDoc = gql`
    fragment WarehouseLocationsLocation on WarehouseLocationEntity {
  uuid
  name
  location1
  location2
  location3
  warehouse {
    uuid
    name
  }
}
    `;
export const UpdateWarehouseLocationFragmentDoc = gql`
    fragment UpdateWarehouseLocation on WarehouseLocationEntity {
  uuid
}
    `;
export const AblyTokenDocument = gql`
    query ablyToken {
  ablyToken {
    token
  }
}
    `;
export const ActiveAgentsDocument = gql`
    query activeAgents {
  activeAgents {
    uuid
    name
  }
}
    `;
export const ContactForAutocompleteDocument = gql`
    query contactForAutocomplete($uuid: String!) {
  contact(uuid: $uuid) {
    displayName
    uuid
    ... on CustomerContactEntity {
      isPrepaidOnly
    }
    isActive
    isOverCreditLimit
  }
}
    `;
export const ContactPackageSpecsDocument = gql`
    query ContactPackageSpecs($contactUuid: String!) {
  contact(uuid: $contactUuid) {
    uuid
    ... on CustomerContactEntity {
      useCustomPackageSpecs
      packageSpecs {
        id
        name
        status
      }
    }
  }
}
    `;
export const ContactsForAutocompleteDocument = gql`
    query contactsForAutocomplete($excludeNonActive: Boolean) {
  contacts(excludeNonActive: $excludeNonActive) {
    displayName
    uuid
    ... on CustomerContactEntity {
      isPrepaidOnly
    }
    isActive
  }
}
    `;
export const DispatchableDriversDocument = gql`
    query dispatchableDrivers($getDispatchableDriversInput: GetDispatchableDriversInput!) {
  dispatchableDrivers(getDispatchableDriversInput: $getDispatchableDriversInput) {
    companyDrivers {
      user {
        name
      }
      firstName
      lastName
      uuid
      phoneNumber
      terminal {
        name
      }
      driverReferenceNumber
      driverType
    }
    agents {
      uuid
      name
      defaultDriver {
        uuid
        driverType
      }
    }
  }
}
    `;
export const DriverMinimalDocument = gql`
    query driverMinimal($uuid: String!) {
  driver(uuid: $uuid) {
    uuid
    user {
      name
    }
    agent {
      uuid
      name
    }
    firstName
    lastName
    phoneNumber
    driverType
    terminal {
      name
    }
  }
}
    `;
export const LoginDocument = gql`
    mutation login($loginInputData: LoginInput!) {
  login(loginInputData: $loginInputData) {
    status
    fullAccessUser {
      uuid
      company {
        purchasedProductOfferings
      }
    }
    thirdPartyUser {
      uuid
    }
    clientChallenge {
      uuid
      name
      squareLogoUrl
    }
    kind
  }
}
    `;
export const LogoutDocument = gql`
    mutation logout {
  logout
}
    `;
export const MeAsThirdPartyUserForAuthDocument = gql`
    query meAsThirdPartyUserForAuth {
  meAsThirdPartyUser {
    email
    uuid
    contacts {
      company {
        uuid
        name
      }
    }
  }
}
    `;
export const MeAsThirdPartyUserDocument = gql`
    query meAsThirdPartyUser {
  meAsThirdPartyUser {
    email
    uuid
    contacts {
      uuid
      displayName
      showChargesOnCustomerPortal
      ... on CustomerContactEntity {
        enableCustomerPortalOrderEntry
      }
      isPrepaidOnly
      company {
        uuid
        segment
        timeZone
        defaultWeightUnits
        services {
          ...Service
        }
        isCourier
        configuration {
          ...CompanyConfiguration
        }
        defaultMeasurementUnits
        productionCompany
        name
      }
    }
  }
}
    ${ServiceFragmentDoc}
${CompanyConfigurationFragmentDoc}`;
export const MeForAuthDocument = gql`
    query MeForAuth {
  me {
    email
    uuid
    company {
      uuid
      name
    }
  }
}
    `;
export const MeDocument = gql`
    query me {
  me {
    ...Me
  }
}
    ${MeFragmentDoc}`;
export const UserRolesDocument = gql`
    query userRoles {
  userRoles {
    ...MeRole
  }
}
    ${MeRoleFragmentDoc}`;
export const TableFieldsDocument = gql`
    query tableFields {
  tableFields {
    orderTableFields
    billingReviewOrderTableFields
    linehaulDispatchTableFields
    dispatchTableFields
    routeCardStopTableFields
    dispatchTableColumnWidths {
      colId
      width
    }
    routeCardStopTableColumnWidths {
      colId
      width
    }
  }
}
    `;
export const RegisterDocument = gql`
    mutation register($registerInputData: RegisterInput!) {
  register(registerInputData: $registerInputData) {
    status
  }
}
    `;
export const TariffChainsDocument = gql`
    query tariffChains($findTariffChainsInput: FindTariffChainsInput!) {
  tariffChains(findTariffChainsInput: $findTariffChainsInput) {
    ...TariffChain
  }
}
    ${TariffChainFragmentDoc}`;
export const TemplateAddressesDocument = gql`
    query templateAddresses($first: Int, $searchText: String) {
  templateAddresses(first: $first, searchText: $searchText) {
    ...AddressWithContact
  }
}
    ${AddressWithContactFragmentDoc}`;
export const WhiteLabelCompanyDocument = gql`
    query whiteLabelCompany($uuid: String!) {
  companyByUuid(uuid: $uuid) {
    uuid
    companyLandscapeLogoUrl
    companySquareLogoUrl
    name
  }
}
    `;
export const AutoApplyAccessorialConfigDocument = gql`
    query autoApplyAccessorialConfig($uuid: String!) {
  autoApplyAccessorialConfig(uuid: $uuid) {
    ...AutoApplyAccessorialConfig
  }
}
    ${AutoApplyAccessorialConfigFragmentDoc}`;
export const AutoApplyAccessorialConfigsDocument = gql`
    query autoApplyAccessorialConfigs {
  autoApplyAccessorialConfigs {
    ...AutoApplyAccessorialConfig
  }
}
    ${AutoApplyAccessorialConfigFragmentDoc}`;
export const CreateAutoApplyAccessorialConfigDocument = gql`
    mutation createAutoApplyAccessorialConfig($createAutoApplyAccessorialConfigInput: CreateAutoApplyAccessorialConfigInput!) {
  createAutoApplyAccessorialConfig(
    createAutoApplyAccessorialConfigInput: $createAutoApplyAccessorialConfigInput
  ) {
    ...AutoApplyAccessorialConfig
  }
}
    ${AutoApplyAccessorialConfigFragmentDoc}`;
export const DeleteAutoApplyAccessorialConfigDocument = gql`
    mutation deleteAutoApplyAccessorialConfig($uuid: String!) {
  deleteAutoApplyAccessorialConfig(uuid: $uuid)
}
    `;
export const SelectSpecialAccessorialDocument = gql`
    query selectSpecialAccessorial($selectSpecialAccessorialInput: SelectSpecialAccessorialInput!) {
  selectSpecialAccessorial(
    selectSpecialAccessorialInput: $selectSpecialAccessorialInput
  ) {
    accessorialUuid
    tariffZoneUuid
    chargeGroupUuid
    matrixItemUuid
  }
}
    `;
export const UpdateAutoApplyAccessorialConfigDocument = gql`
    mutation updateAutoApplyAccessorialConfig($updateAutoApplyAccessorialConfigInput: UpdateAutoApplyAccessorialConfigInput!) {
  updateAutoApplyAccessorialConfig(
    updateAutoApplyAccessorialConfigInput: $updateAutoApplyAccessorialConfigInput
  ) {
    ...AutoApplyAccessorialConfig
  }
}
    ${AutoApplyAccessorialConfigFragmentDoc}`;
export const CoordinatesForAddressDocument = gql`
    query coordinatesForAddress($line1: String, $line2: String, $city: String, $state: String, $country: String, $zip: String) {
  coordinatesForAddress(
    line1: $line1
    line2: $line2
    city: $city
    state: $state
    country: $country
    zip: $zip
  ) {
    latitude
    longitude
  }
}
    `;
export const GetCityAndStateOptionsFromZipcodeDocument = gql`
    query getCityAndStateOptionsFromZipcode($getCityAndStateFromZipcodeInput: GetCityAndStateOptionsFromZipcodeInput!) {
  getCityAndStateOptionsFromZipcode(
    getCityAndStateOptionsFromZipcodeInput: $getCityAndStateFromZipcodeInput
  ) {
    zipcode
    citiesAndStates {
      ...GetCityAndStateOptionsFromZipcode
    }
  }
}
    ${GetCityAndStateOptionsFromZipcodeFragmentDoc}`;
export const GetZipcodeOptionsFromCityAndStateDocument = gql`
    query getZipcodeOptionsFromCityAndState($getZipcodeFromCityAndStateInput: GetZipcodeOptionsFromCityAndStateInput!) {
  getZipcodeOptionsFromCityAndState(
    getZipcodeOptionsFromCityAndStateInput: $getZipcodeFromCityAndStateInput
  ) {
    city
    state
    zipcodes {
      ...GetZipcodeOptionsFromCityAndState
    }
  }
}
    ${GetZipcodeOptionsFromCityAndStateFragmentDoc}`;
export const AirportInfoDocument = gql`
    query airportInfo($uuid: String!) {
  airportInfo(uuid: $uuid) {
    ...RecoveryTerminal
  }
}
    ${RecoveryTerminalFragmentDoc}`;
export const AppointmentConfirmationInfoDocument = gql`
    query AppointmentConfirmationInfo($stopUuid: String!) {
  appointmentConfirmationInfo(uuid: $stopUuid) {
    appointmentDateTime
    appointmentConfirmed
    rescheduleRequested
    stopType
  }
}
    `;
export const GetAppointmentsDocument = gql`
    query getAppointments($deliveryDate: DateTime, $onlyMissed: Boolean) {
  appointments(deliveryDate: $deliveryDate, onlyMissed: $onlyMissed) {
    ...Appointment
  }
}
    ${AppointmentFragmentDoc}`;
export const BulkConfirmAppointmentsDocument = gql`
    mutation bulkConfirmAppointments($bulkConfirmAppointmentsArgs: BulkConfirmAppointmentsArgs!) {
  bulkConfirmAppointments(
    bulkConfirmAppointmentsArgs: $bulkConfirmAppointmentsArgs
  )
}
    `;
export const BulkChangeCallStatusDocument = gql`
    mutation bulkChangeCallStatus($changeCallStatusArgs: BulkChangeCallStatusArgs!) {
  bulkChangeCallStatus(changeCallStatusArgs: $changeCallStatusArgs)
}
    `;
export const CallStopsDocument = gql`
    mutation callStops($callStopsInput: CallStopsInput!) {
  callStops(callStopsInput: $callStopsInput) {
    uuid
  }
}
    `;
export const GetDefaultTextsDocument = gql`
    query getDefaultTexts($generateDefaultAppointmentTextsArgs: GenerateDefaultAppointmentTextsArgs!) {
  generateDefaultAppointmentTexts(
    generateDefaultAppointmentTextsArgs: $generateDefaultAppointmentTextsArgs
  ) {
    appointmentUuid
    message
  }
}
    `;
export const MakeAppointmentConfirmationDecisionDocument = gql`
    mutation MakeAppointmentConfirmationDecision($input: MakeAppointmentConfirmationDecisionInput!) {
  makeAppointmentConfirmationDecision(input: $input) {
    __typename
    ... on AppointmentConfirmationInfoOutput {
      appointmentDateTime
      appointmentConfirmed
      rescheduleRequested
    }
    ... on MutationErrorOutput {
      message
    }
  }
}
    `;
export const QueueAppointmentTextsDocument = gql`
    mutation queueAppointmentTexts($queueAppointmentTextsArgs: QueueAppointmentTextsArgs!) {
  queueAppointmentTexts(queueAppointmentTextsArgs: $queueAppointmentTextsArgs)
}
    `;
export const RemoveStopsFromRoutesDocument = gql`
    mutation removeStopsFromRoutes($removeStopsFromRoutesInput: RemoveStopsFromRoutesInputType!) {
  removeStopsFromRoutes(removeStopsFromRoutesInput: $removeStopsFromRoutesInput)
}
    `;
export const AuditReportDocument = gql`
    query auditReport($args: AuditReportArgs!) {
  auditReport(args: $args) {
    ...AuditReportBucket
  }
}
    ${AuditReportBucketFragmentDoc}`;
export const CompanyConfigurationDocument = gql`
    query companyConfiguration {
  companyConfiguration {
    ...CompanyConfiguration
  }
}
    ${CompanyConfigurationFragmentDoc}`;
export const ContactPersonsDocument = gql`
    query contactPersons {
  contactPersons {
    ...ContactPerson
  }
}
    ${ContactPersonFragmentDoc}`;
export const ArchiveContactStationDocument = gql`
    mutation archiveContactStation($id: String!) {
  archiveContactStation(id: $id) {
    __typename
    ... on ContactStationUpdateSuccessOutput {
      contactStation {
        id
        isArchived
      }
    }
    ... on MutationErrorOutput {
      message
    }
  }
}
    `;
export const ArchivePersonDocument = gql`
    mutation ArchivePerson($id: String!) {
  archivePerson(id: $id) {
    person {
      id
      status
    }
  }
}
    `;
export const CreateContactCommentDocument = gql`
    mutation createContactComment($createContactCommentInput: CreateContactCommentInput!) {
  createContactComment(createContactCommentInput: $createContactCommentInput) {
    uuid
  }
}
    `;
export const DeleteContactCommentDocument = gql`
    mutation deleteContactComment($deleteContactCommentInput: DeleteContactCommentInput!) {
  deleteContactComment(deleteContactCommentInput: $deleteContactCommentInput) {
    ... on DeleteContactCommentSuccessOutput {
      success
    }
    ... on MutationErrorOutput {
      message
    }
  }
}
    `;
export const UpdateContactCommentDocument = gql`
    mutation updateContactComment($updateContactCommentInput: UpdateContactCommentInput!) {
  updateContactComment(updateContactCommentInput: $updateContactCommentInput) {
    ... on UpdateContactCommentSuccessOutput {
      success
    }
    ... on MutationErrorOutput {
      message
    }
  }
}
    `;
export const ContactCommunicationConfigsDocument = gql`
    query contactCommunicationConfigs($contactUuid: String!) {
  contactCommunicationConfigs(contactUuid: $contactUuid) {
    ...ContactCommunicationConfig
  }
}
    ${ContactCommunicationConfigFragmentDoc}`;
export const ContactDefaultSurchargeDocument = gql`
    query contactDefaultSurcharge($uuid: String!) {
  contact(uuid: $uuid) {
    uuid
    ... on CustomerContactEntity {
      defaultFuelSurcharge
    }
  }
}
    `;
export const ContactEmailsDocument = gql`
    query contactEmails($contactUuid: String!) {
  contactEmails(contactUuid: $contactUuid) {
    uuid
    email
    type
  }
}
    `;
export const ContactIsOverCreditLimitByOrderUuidDocument = gql`
    query contactIsOverCreditLimitByOrderUuid($uuid: String!) {
  order(uuid: $uuid) {
    standardOrderFields {
      shipperBillOfLadingNumber
    }
    contact {
      isOverCreditLimit
    }
  }
}
    `;
export const ContactIsOverCreditLimitDocument = gql`
    query contactIsOverCreditLimit($uuid: String!) {
  contact(uuid: $uuid) {
    isOverCreditLimit
  }
}
    `;
export const ContactLogosDocument = gql`
    query contactLogos($contactUuid: String!) {
  contact(uuid: $contactUuid) {
    uuid
    logo {
      preSignedGetUrl
    }
    logoType {
      preSignedGetUrl
    }
  }
}
    `;
export const ContactQueryForBluebirdDocument = gql`
    query contactQueryForBluebird($uuid: String!) {
  contact(uuid: $uuid) {
    uuid
  }
}
    `;
export const ContactServicesDocument = gql`
    query contactServices($uuid: String!) {
  contact(uuid: $uuid) {
    uuid
    services {
      uuid
      name
    }
    defaultService {
      uuid
      name
    }
  }
}
    `;
export const ContactStationsDocument = gql`
    query contactStations($contactUuid: String!) {
  contactStations(contactUuid: $contactUuid) {
    id
    name
    isArchived
    defaultPerson {
      id
      firstName
      lastName
      phone
      email
    }
  }
}
    `;
export const ContactDocument = gql`
    query contact($uuid: String!) {
  contact(uuid: $uuid) {
    ...Contact
  }
}
    ${ContactFragmentDoc}`;
export const ContactsForInvoicingDocument = gql`
    query contactsForInvoicing($invoiceUuids: [String!]!) {
  contacts(invoiceUuids: $invoiceUuids) {
    ...ContactForInvoice
  }
}
    ${ContactForInvoiceFragmentDoc}`;
export const ContactsForQuickbooksDocument = gql`
    query contactsForQuickbooks {
  contacts {
    ...ContactForQuickbooks
  }
}
    ${ContactForQuickbooksFragmentDoc}`;
export const ContactsPageListingDocument = gql`
    query contactsPageListing {
  contacts {
    uuid
    contactReferenceNumber
    displayName
    isActive
    type
  }
}
    `;
export const ContactsReportDocument = gql`
    query contactsReport {
  contactsReport {
    name
    email
    shortcode
    active
    addressName
    addressLine1
    addressLine2
    city
    state
    zipcode
    businessDivision
    type
    referenceNumber
    numberOfOrdersPerInvoice
    invoiceTimePeriodSplit
    enableCreditHold
    creditLimit
    billingCycle
    defaultInvoiceTransmissionMethod
    defaultInvoiceType
  }
}
    `;
export const ContactsSimpleDocument = gql`
    query contactsSimple($excludeNonActive: Boolean) {
  contacts(excludeNonActive: $excludeNonActive) {
    uuid
    displayName
    contactReferenceNumber
    isOverCreditLimit
    masterAccount {
      uuid
    }
  }
}
    `;
export const ContactsDocument = gql`
    query contacts {
  contacts {
    ...Contact
  }
}
    ${ContactFragmentDoc}`;
export const CreateAddressDocument = gql`
    mutation createAddress($input: CreateAddressInput!) {
  createAddress(createAddressInput: $input) {
    uuid
  }
}
    `;
export const CreateContactEmailDocument = gql`
    mutation createContactEmail($createContactEmailInput: CreateContactEmailInput!) {
  createContactEmail(createContactEmailInput: $createContactEmailInput) {
    uuid
  }
}
    `;
export const CreateContactPersonDocument = gql`
    mutation createContactPerson($input: CreateContactPersonInput!) {
  createContactPerson(createContactPersonInput: $input) {
    uuid
  }
}
    `;
export const CreateContactStationDocument = gql`
    mutation createContactStation($input: ContactStationCreateInput!) {
  createContactStation(contactStationCreateInput: $input) {
    __typename
    ... on ContactStationCreateSuccessOutput {
      contactStation {
        id
      }
    }
    ... on MutationErrorOutput {
      message
    }
  }
}
    `;
export const CreateCustomerContactDocument = gql`
    mutation createCustomerContact($input: CreateCustomerContactInput!) {
  createCustomerContact(createCustomerContactInput: $input) {
    uuid
  }
}
    `;
export const CreatePersonDocument = gql`
    mutation CreatePerson($input: CreatePersonInput!) {
  createPerson(input: $input) {
    person {
      id
    }
  }
}
    `;
export const FindServicesForCustomerConfigurationDocument = gql`
    query findServicesForCustomerConfiguration($findServicesForCustomerConfigurationInput: FindServicesForCustomerConfigurationInput!) {
  findServicesForCustomerConfiguration(
    findServicesForCustomerConfigurationInput: $findServicesForCustomerConfigurationInput
  ) {
    __typename
    ... on FindServicesForCustomerConfigurationSuccessOutput {
      services {
        uuid
        name
        isActive
      }
    }
    ... on QueryErrorOutput {
      message
    }
  }
}
    `;
export const DeleteContactEmailDocument = gql`
    mutation deleteContactEmail($deleteContactEmailInput: DeleteContactEmailInput!) {
  deleteContactEmail(deleteContactEmailInput: $deleteContactEmailInput) {
    uuid
  }
}
    `;
export const InvoiceTermsDocument = gql`
    query invoiceTerms {
  invoiceTerms {
    ...InvoiceTerm
  }
}
    ${InvoiceTermFragmentDoc}`;
export const OrderEventNotificationSubscriptionsDocument = gql`
    query OrderEventNotificationSubscriptions($contactUuid: String!) {
  orderEventNotificationSubscriptions(contactUuid: $contactUuid) {
    id
    eventType
    channel
    subscriberType
  }
}
    `;
export const PaginatedContactsDocument = gql`
    query paginatedContacts($first: Int, $after: String, $last: Int, $before: String, $searchText: String, $sortByContactName: Boolean) {
  paginatedContacts(
    first: $first
    after: $after
    before: $before
    last: $last
    searchText: $searchText
    sortByContactName: $sortByContactName
  ) {
    edges {
      node {
        uuid
        displayName
      }
    }
    totalCount
    pageInfo {
      startCursor
      endCursor
      hasNextPage
      hasPreviousPage
    }
  }
}
    `;
export const PersonsDocument = gql`
    query Persons($contactUuid: String) {
  persons(contactUuid: $contactUuid) {
    persons {
      id
      status
      firstName
      lastName
      phone
      email
      defaultPickupAddress {
        uuid
        name
        line1
        line2
        city
        state
        zip
        country
        specialInstructions
      }
      defaultDeliveryAddress {
        uuid
        name
        line1
        line2
        city
        state
        zip
        country
        specialInstructions
      }
      defaultService {
        uuid
        name
      }
      defaultVehicleType {
        uuid
        name
      }
      defaultForContactStations {
        id
        name
        isArchived
      }
    }
  }
}
    `;
export const QueryQuickbooksDesktopAccountsDocument = gql`
    query queryQuickbooksDesktopAccounts {
  queryQuickbooksDesktopAccounts {
    quickbooksDesktopObjects {
      id
      name
    }
    error
  }
}
    `;
export const QueryQuickbooksDesktopCustomersDocument = gql`
    query queryQuickbooksDesktopCustomers {
  queryQuickbooksDesktopCustomers {
    quickbooksDesktopObjects {
      id
      name
    }
    error
  }
}
    `;
export const RemoveAddressDocument = gql`
    mutation removeAddress($uuid: String!) {
  removeAddress(uuid: $uuid) {
    uuid
  }
}
    `;
export const RemoveContactPersonDocument = gql`
    mutation removeContactPerson($uuid: String!) {
  removeContactPerson(uuid: $uuid) {
    uuid
  }
}
    `;
export const RestoreContactStationDocument = gql`
    mutation restoreContactStation($id: String!) {
  restoreContactStation(id: $id) {
    __typename
    ... on ContactStationUpdateSuccessOutput {
      contactStation {
        id
        isArchived
      }
    }
    ... on MutationErrorOutput {
      message
    }
  }
}
    `;
export const RestorePersonDocument = gql`
    mutation RestorePerson($id: String!) {
  restorePerson(id: $id) {
    person {
      id
      status
    }
  }
}
    `;
export const ShallowContactDocument = gql`
    query shallowContact($uuid: String!) {
  contact(uuid: $uuid) {
    ...ShallowContact
  }
}
    ${ShallowContactFragmentDoc}`;
export const ShallowContactsByUuidsDocument = gql`
    query shallowContactsByUuids($uuids: [String!]!) {
  contactsByUuids(uuids: $uuids) {
    ...ShallowContact
  }
}
    ${ShallowContactFragmentDoc}`;
export const ShallowContactsDocument = gql`
    query shallowContacts {
  contacts {
    ...ShallowContact
  }
}
    ${ShallowContactFragmentDoc}`;
export const ThirdPartyUserByUuidDocument = gql`
    query thirdPartyUserByUuid($uuid: String!) {
  thirdPartyUserByUuid(uuid: $uuid) {
    uuid
    email
    password
    contacts {
      displayName
    }
  }
}
    `;
export const ThirdPartyUsersByContactDocument = gql`
    query thirdPartyUsersByContact($contactUuid: String!) {
  thirdPartyUsersByContact(contactUuid: $contactUuid) {
    uuid
    email
  }
}
    `;
export const UpdateAddressDocument = gql`
    mutation updateAddress($input: UpdateAddressInput!) {
  updateAddress(updateAddressInput: $input) {
    uuid
  }
}
    `;
export const UpdateContactCommunicationConfigDocument = gql`
    mutation updateContactCommunicationConfig($updateContactCommunicationConfigInput: UpdateContactCommunicationConfigInput!) {
  updateContactCommunicationConfig(
    updateContactCommunicationConfigInput: $updateContactCommunicationConfigInput
  ) {
    uuid
  }
}
    `;
export const UpdateContactEmailsDocument = gql`
    mutation UpdateContactEmails($input: UpdateContactEmailsInput!) {
  updateContactEmails(input: $input) {
    __typename
    ... on UpdateContactEmailsSuccessOutput {
      contactUuid
      contactCommunicationConfigs {
        uuid
        type
        active
      }
      contactEmails {
        uuid
        email
        type
      }
    }
    ... on MutationErrorOutput {
      message
    }
  }
}
    `;
export const UpdateContactPersonDocument = gql`
    mutation updateContactPerson($input: UpdateContactPersonInput!) {
  updateContactPerson(updateContactPersonInput: $input) {
    uuid
  }
}
    `;
export const UpdateContactStationDocument = gql`
    mutation updateContactStation($input: ContactStationUpdateInput!) {
  updateContactStation(contactStationUpdateInput: $input) {
    __typename
    ... on ContactStationUpdateSuccessOutput {
      contactStation {
        id
        name
        defaultPerson {
          firstName
          lastName
          phone
          email
        }
      }
    }
    ... on MutationErrorOutput {
      message
    }
  }
}
    `;
export const UpdateCustomerContactDocument = gql`
    mutation updateCustomerContact($input: UpdateCustomerContactInput!) {
  updateCustomerContact(updateCustomerContactInput: $input) {
    uuid
  }
}
    `;
export const UpdateOrderEventNotificationSubscriptionsDocument = gql`
    mutation UpdateOrderEventNotificationSubscriptions($input: UpdateOrderEventNotificationSubscriptionsInput!) {
  updateOrderEventNotificationSubscriptions(input: $input) {
    __typename
    ... on MutationErrorOutput {
      message
    }
    ... on UpdateOrderEventNotificationSubscriptionsSuccessOutput {
      contactUuid
      subscriptions {
        id
        eventType
        channel
        subscriberType
      }
    }
  }
}
    `;
export const UpdatePersonDocument = gql`
    mutation UpdatePerson($input: UpdatePersonInput!) {
  updatePerson(input: $input) {
    person {
      id
      status
      firstName
      lastName
      phone
      email
      defaultPickupAddress {
        uuid
        name
        line1
        line2
        city
        state
        zip
        country
        specialInstructions
      }
      defaultDeliveryAddress {
        uuid
        name
        line1
        line2
        city
        state
        zip
        country
        specialInstructions
      }
      defaultService {
        uuid
        name
      }
      defaultVehicleType {
        uuid
        name
      }
    }
  }
}
    `;
export const UpsertAddressDocument = gql`
    mutation upsertAddress($upsertAddressInput: UpsertAddressInput!) {
  upsertAddress(upsertAddressInput: $upsertAddressInput) {
    uuid
  }
}
    `;
export const UpsertContactPersonDocument = gql`
    mutation upsertContactPerson($input: UpsertContactPersonInput!) {
  upsertContactPerson(upsertContactPersonInput: $input) {
    uuid
  }
}
    `;
export const UpsertUserContactNotificationSubscriptionDocument = gql`
    mutation upsertUserContactNotificationSubscription($input: UserContactNotificationSubscriptionUpsertInput!) {
  upsertUserContactNotificationSubscription(
    userContactNotificationSubscriptionUpsertInput: $input
  ) {
    ...UserContactNotificationSubscription
  }
}
    ${UserContactNotificationSubscriptionFragmentDoc}`;
export const UserContactNotificationSubscriptionDocument = gql`
    query userContactNotificationSubscription($contactUuid: String!) {
  userContactNotificationSubscription(contactUuid: $contactUuid) {
    ...UserContactNotificationSubscription
  }
}
    ${UserContactNotificationSubscriptionFragmentDoc}`;
export const AddThirdPartyUserToContactDocument = gql`
    mutation addThirdPartyUserToContact($addThirdPartyUserToContactInput: AddThirdPartyUserToContactInput!) {
  addThirdPartyUserToContact(
    addThirdPartyUserToContactInput: $addThirdPartyUserToContactInput
  ) {
    uuid
  }
}
    `;
export const ConsigneePortalOrderDocument = gql`
    query consigneePortalOrder($uuid: String!) {
  consigneePortalOrder(uuid: $uuid) {
    ...ConsigneePortalOrder
  }
}
    ${ConsigneePortalOrderFragmentDoc}`;
export const CustomerPortalCompanyDocument = gql`
    query customerPortalCompany($uuid: String!) {
  customerPortalCompany(uuid: $uuid) {
    ...CustomerPortalCompany
  }
}
    ${CustomerPortalCompanyFragmentDoc}`;
export const CustomerPortalMeDocument = gql`
    query customerPortalMe {
  me {
    company {
      uuid
      name
    }
  }
}
    `;
export const CustomerPortalOrderDocument = gql`
    query customerPortalOrder($uuid: String!) {
  order(uuid: $uuid) {
    ...CustomerPortalOrder
  }
}
    ${CustomerPortalOrderFragmentDoc}`;
export const CustomerPortalQuotesDocument = gql`
    query customerPortalQuotes($findCustomerPortalQuotesInput: FindCustomerPortalQuotesInput!) {
  customerPortalQuotes(
    findCustomerPortalQuotesInput: $findCustomerPortalQuotesInput
  ) {
    edges {
      node {
        ...CustomerPortalQuote
      }
    }
    pageInfo {
      startCursor
      endCursor
      hasNextPage
    }
    totalCount
  }
}
    ${CustomerPortalQuoteFragmentDoc}`;
export const CustomerPortalOrdersDocument = gql`
    query customerPortalOrders($first: Int, $after: String, $last: Int, $before: String, $searchText: String, $stopTypesFilter: StopTypesFilter, $appointmentDateFilters: DateFilterStartEnd, $createdAtDateFilters: DateFilterStartEnd, $receivedDateFilters: DateFilterStartEnd, $plannedDateFilters: DateFilterStartEnd, $dispatched: BooleanFilter, $ofdOfp: BooleanFilter, $completionDateFilters: DateFilterStartEnd, $companyFilter: String, $contactFilter: String) {
  customerPortalOrders(
    first: $first
    after: $after
    last: $last
    before: $before
    searchText: $searchText
    stopTypesFilter: $stopTypesFilter
    appointmentDateFilters: $appointmentDateFilters
    createdAtDateFilters: $createdAtDateFilters
    receivedDateFilters: $receivedDateFilters
    plannedDateFilters: $plannedDateFilters
    dispatched: $dispatched
    ofdOfp: $ofdOfp
    completionDateFilters: $completionDateFilters
    companyFilter: $companyFilter
    contactFilter: $contactFilter
  ) {
    totalCount
    edges {
      node {
        ...CustomerPortalOrderForTable
      }
    }
    pageInfo {
      startCursor
      endCursor
      hasNextPage
      hasPreviousPage
    }
  }
}
    ${CustomerPortalOrderForTableFragmentDoc}`;
export const EtaForCustomerPortalDocument = gql`
    query etaForCustomerPortal($uuid: String!) {
  etaForCustomerPortal(uuid: $uuid) {
    arrivalTime
    finishTime
  }
}
    `;
export const PublicUpsertShipmentSubscriberDocument = gql`
    mutation publicUpsertShipmentSubscriber($upsertShipmentSubscriberInput: UpsertShipmentSubscriberInput!, $companyUuid: String!) {
  upsertShipmentSubscriberForCompany(
    upsertShipmentSubscriberInput: $upsertShipmentSubscriberInput
    companyUuid: $companyUuid
  ) {
    phoneNumber
    uuid
  }
}
    `;
export const RemoveThirdPartyUserFromContactDocument = gql`
    mutation removeThirdPartyUserFromContact($removeThirdPartyUserFromContactInput: RemoveThirdPartyUserFromContactInput!) {
  removeThirdPartyUserFromContact(
    removeThirdPartyUserFromContactInput: $removeThirdPartyUserFromContactInput
  ) {
    uuid
  }
}
    `;
export const SignUpForThirdPartyUserAccountDocument = gql`
    mutation signUpForThirdPartyUserAccount($signUpForThirdPartyUserAccountInput: SignUpForThirdPartyUserAccountInput!) {
  signUpForThirdPartyUserAccount(
    signUpForThirdPartyUserAccountInput: $signUpForThirdPartyUserAccountInput
  ) {
    status
  }
}
    `;
export const CalculateRouteEtasDocument = gql`
    mutation calculateRouteEtas($uuids: [String!]!) {
  calculateRouteEtas(uuids: $uuids) {
    arrivalTime
    finishTime
  }
}
    `;
export const SameDayDispatchRoutesWithDriverCoordsDocument = gql`
    query sameDayDispatchRoutesWithDriverCoords($date: DateTime!, $searchText: String) {
  routes(date: $date, searchText: $searchText) {
    ...SameDayDispatchRouteDriverCoords
  }
}
    ${SameDayDispatchRouteDriverCoordsFragmentDoc}`;
export const DispatchDriversDocument = gql`
    query dispatchDrivers($startDate: DateTime!, $endDate: DateTime!) {
  drivers {
    uuid
    status
    firstName
    lastName
    driverReferenceNumber
    lastCompletedLeg(startDate: $startDate, endDate: $endDate) {
      uuid
      completedAt
      endStop {
        uuid
        address {
          line1
          line2
          city
        }
      }
    }
    currentLeg {
      uuid
      name
      completedAt
      endStop {
        uuid
        address {
          line1
          line2
          city
        }
      }
    }
    defaultVehicle {
      uuid
      name
    }
  }
}
    `;
export const EquipmentsByTypeDocument = gql`
    query equipmentsByType($equipmentType: [EquipmentType!]) {
  equipments(types: $equipmentType) {
    uuid
    type
    name
  }
}
    `;
export const LegDocument = gql`
    query leg($uuid: String!) {
  leg(uuid: $uuid) {
    uuid
    completedAt
    previousStopAttempts {
      uuid
      notes
      completedAt
      canMarkAttemptComplete
      routeSlot {
        route {
          name
          drivers {
            uuid
            firstName
            lastName
          }
        }
      }
    }
    shipment {
      uuid
    }
  }
}
    `;
export const LegsDocument = gql`
    query legs($statuses: [LegStatus!], $maxOneUnassignedPerShipment: Boolean!) {
  legs(
    statuses: $statuses
    maxOneUnassignedPerShipment: $maxOneUnassignedPerShipment
  ) {
    uuid
    name
    shipment {
      uuid
    }
    status
    drivers {
      uuid
      firstName
      lastName
      status
    }
    completedAt
    endStop {
      uuid
      address {
        uuid
        line1
        line2
        city
        latitude
        longitude
      }
      appointmentTime
    }
  }
}
    `;
export const RefreshEtasForRouteDocument = gql`
    mutation refreshEtasForRoute($uuid: String!) {
  refreshEtasForRoute(uuid: $uuid) {
    arrivalTime
    finishTime
  }
}
    `;
export const UnassignLegFromDriverDocument = gql`
    mutation unassignLegFromDriver($unassignLegFromDriver: UnassignLegFromDriverInput!) {
  unassignLegFromDriver(unassignLegFromDriver: $unassignLegFromDriver) {
    uuid
  }
}
    `;
export const SameDayDispatchConfigDocument = gql`
    query sameDayDispatchConfig {
  sameDayDispatchConfig {
    ...SameDayDispatchConfig
  }
}
    ${SameDayDispatchConfigFragmentDoc}`;
export const UpdateSameDayDispatchConfigDocument = gql`
    mutation updateSameDayDispatchConfig($updateSameDayDispatchConfigInput: UpdateSameDayDispatchConfigInput!) {
  updateSameDayDispatchConfig(
    updateSameDayDispatchConfigInput: $updateSameDayDispatchConfigInput
  ) {
    uuid
  }
}
    `;
export const UpdateShipmentDocument = gql`
    mutation updateShipment($updateShipmentInput: UpdateShipmentInput!) {
  updateShipment(updateShipmentInput: $updateShipmentInput) {
    uuid
  }
}
    `;
export const ArchiveOrganizationDocument = gql`
    mutation archiveOrganization($input: ArchiveOrganizationInput!) {
  archiveOrganization(input: $input) {
    ... on ArchiveOrganizationSuccessOutput {
      organization {
        ...Organization
      }
    }
    ... on MutationErrorOutput {
      message
    }
  }
}
    ${OrganizationFragmentDoc}`;
export const CreateOrganizationDocument = gql`
    mutation createOrganization($input: CreateOrganizationInput!) {
  createOrganization(input: $input) {
    ... on CreateOrganizationSuccessOutput {
      organization {
        ...Organization
      }
    }
    ... on MutationErrorOutput {
      message
    }
  }
}
    ${OrganizationFragmentDoc}`;
export const OrganizationForAddressBookDocument = gql`
    query organizationForAddressBook($input: FindOrganizationInput!) {
  organization(input: $input) {
    addresses {
      ...OrganizationAddress
    }
    agentFields {
      activeTerminals {
        ...OrganizationAgentTerminal
      }
    }
  }
}
    ${OrganizationAddressFragmentDoc}
${OrganizationAgentTerminalFragmentDoc}`;
export const OrganizationForFrontendHookDocument = gql`
    query organizationForFrontendHook($input: FindOrganizationInput!) {
  organization(input: $input) {
    isActive
    addresses {
      ...AddressForOrganization
    }
    contactPersons {
      ...ContactPersonForOrganization
    }
    types
  }
}
    ${AddressForOrganizationFragmentDoc}
${ContactPersonForOrganizationFragmentDoc}`;
export const OrganizationNotesDocument = gql`
    query organizationNotes($findOrganizationNotesInput: FindOrganizationNotesInput!) {
  organizationNotes(findOrganizationNotesInput: $findOrganizationNotesInput) {
    uuid
    createdAt
    updatedAt
    comment
    authorName
  }
}
    `;
export const OrganizationDocument = gql`
    query organization($input: FindOrganizationInput!) {
  organization(input: $input) {
    ...Organization
  }
}
    ${OrganizationFragmentDoc}`;
export const PaginatedOrganizationsDocument = gql`
    query paginatedOrganizations($findPaginatedOrganizationsInput: FindPaginatedOrganizationsInput!) {
  paginatedOrganizations(
    findPaginatedOrganizationsInput: $findPaginatedOrganizationsInput
  ) {
    edges {
      node {
        ...PaginatedOrganization
      }
    }
    totalCount
    pageInfo {
      startCursor
      endCursor
      hasNextPage
      hasPreviousPage
    }
  }
}
    ${PaginatedOrganizationFragmentDoc}`;
export const RestoreOrganizationDocument = gql`
    mutation restoreOrganization($input: RestoreOrganizationInput!) {
  restoreOrganization(input: $input) {
    ... on RestoreOrganizationSuccessOutput {
      organization {
        ...Organization
      }
    }
    ... on MutationErrorOutput {
      message
    }
  }
}
    ${OrganizationFragmentDoc}`;
export const UpdateOrganizationDocument = gql`
    mutation updateOrganization($input: UpdateOrganizationInput!) {
  updateOrganization(input: $input) {
    ... on UpdateOrganizationSuccessOutput {
      organization {
        ...Organization
      }
    }
    ... on MutationErrorOutput {
      message
    }
  }
}
    ${OrganizationFragmentDoc}`;
export const CreateDispatchViewDocument = gql`
    mutation createDispatchView($input: DispatchViewCreateInput!) {
  createDispatchView(dispatchViewCreateInput: $input) {
    __typename
    ... on DispatchViewCreateSuccessOutput {
      dispatchView {
        id
      }
    }
    ... on MutationErrorOutput {
      message
    }
  }
}
    `;
export const DispatchViewsDocument = gql`
    query dispatchViews {
  dispatchViews {
    id
    name
    tabIndex
    useMinimizedAppointmentTime
    numberOfStops
    showCompleteStops
    routeCardStopTableColumnWidths
    routeCardWidth
    routeCardStopTableFields
    dispatchTableColors {
      ...DispatchTableColor
    }
  }
}
    ${DispatchTableColorFragmentDoc}`;
export const RemoveDispatchViewDocument = gql`
    mutation removeDispatchView($id: String!) {
  removeDispatchView(id: $id) {
    id
  }
}
    `;
export const UpdateDispatchViewDocument = gql`
    mutation updateDispatchView($input: DispatchViewUpdateInput!) {
  updateDispatchView(dispatchViewUpdateInput: $input) {
    __typename
    ... on DispatchViewUpdateSuccessOutput {
      dispatchView {
        id
      }
    }
    ... on MutationErrorOutput {
      message
    }
  }
}
    `;
export const DriversForSelectionDocument = gql`
    query driversForSelection {
  drivers {
    uuid
    firstName
    lastName
    driverType
    driverReferenceNumber
    active
    terminal {
      uuid
      name
    }
    defaultVehicle {
      uuid
      name
      vehicleType {
        uuid
        name
        maxVolume
        maxWeight
      }
    }
  }
}
    `;
export const GenerateRoutesDocument = gql`
    query generateRoutes($generateRoutesInput: GenerateRoutesInput!) {
  generateRoutes(generateRoutesInput: $generateRoutesInput) {
    routes {
      ...GenerateRoutesPreviewRoute
    }
    unassignedStopUuids
    errorMessage
  }
}
    ${GenerateRoutesPreviewRouteFragmentDoc}`;
export const DispatchTableColorsDocument = gql`
    query dispatchTableColors {
  dispatchTableColors {
    ...DispatchTableColor
  }
}
    ${DispatchTableColorFragmentDoc}`;
export const UpdateDispatchTableColorsDocument = gql`
    mutation UpdateDispatchTableColors($input: UpdateDispatchTableColorsInput!) {
  updateDispatchTableColors(input: $input) {
    __typename
    ... on MutationErrorOutput {
      message
    }
  }
}
    `;
export const CreateRouteSlotDocument = gql`
    mutation CreateRouteSlot($routeSlotCreateInput: RouteSlotCreateInput!, $routeUuid: String!) {
  createRouteSlot(
    createRouteSlotInput: {routeSlotCreateInput: $routeSlotCreateInput, routeUuid: $routeUuid}
  ) {
    uuid
  }
}
    `;
export const DriversDocument = gql`
    query drivers($active: Boolean) {
  drivers(active: $active) {
    ...Driver
  }
}
    ${DriverFragmentDoc}`;
export const DriversWithRoutesDocument = gql`
    query driversWithRoutes($date: DateTime!) {
  drivers {
    ...Driver
    route(date: $date) {
      uuid
    }
  }
}
    ${DriverFragmentDoc}`;
export const GetOptimizationResultsDocument = gql`
    query getOptimizationResults($routeOptimizationUuid: String!) {
  getOptimizationResults(routeOptimizationUuid: $routeOptimizationUuid) {
    slots
    error
  }
}
    `;
export const GroupByStopsDocument = gql`
    query groupByStops($groupByStopsInput: GroupByStopsInput!) {
  groupByStops(groupByStopsInput: $groupByStopsInput) {
    count
    __typename
    rows {
      ... on GroupsOutput {
        groupValues
      }
      ... on StopOutput {
        stopValues {
          ADDRESS
          ADDRESS_TYPE
          APPOINTMENT
          APPOINTMENT_SCHEDULED
          APPOINTMENT_DATE
          APPOINTMENT_REQUIRED
          APPOINTMENT_TIME
          BUSINESS_DIVISION
          CITY
          CONSIGNEE
          CUSTOMER
          DIMS
          DUE_DATE
          INBOUND_NAME
          INBOUND_CITY
          INBOUND_METHOD
          INBOUND_TERMINAL
          INBOUND_ZIP
          MAWB
          ORDER_NAME
          ORDER_NOTES
          ORDER_NUMBER
          SERVICE_LEVEL
          orderUuid
          OUTBOUND_NAME
          OUTBOUND_CITY
          OUTBOUND_METHOD
          OUTBOUND_TERMINAL
          OUTBOUND_ZIP
          PIECE_COUNT
          REF_NUMBER
          ROUTE_NAME
          SERVICE_DATE
          SERVICE_TIME
          SPECIAL
          SPECIAL_INSTRUCTIONS
          ORDER_STATUS
          STOP_TYPE
          TAGS
          TERMINAL
          TOTAL_CHARGES
          uuid
          VEHICLE_TYPE_NAME
          WEIGHT
          ZIP_CODE
          orderNumberCellColor
          stopDetails {
            message
            stopDetailsStatus
          }
        }
      }
      __typename
    }
  }
}
    `;
export const NumberOfStopsDocument = gql`
    query numberOfStops($appointmentRequired: Boolean, $tagUuids: [String!], $hideOnHold: Boolean, $hideStopsWithoutAddress: Boolean, $isAssigned: Boolean, $previouslyAttempted: Boolean, $serviceLevelUuids: [String!], $onHand: Boolean, $standardStopTypes: [StandardStopType!], $statuses: [StopStatus!], $orderStatuses: [OrderStatus!], $customerUuid: String, $createdAtFilters: DateFilterStartEnd, $deadlineDateFilters: DateFilterStartEnd, $serviceDateFilters: DateFilterStartEnd, $appointmentTimeFilters: DateFilterStartEnd, $transferPending: Boolean, $pickupOrDeliveryTypes: [PickupOrDelivery!], $requiresRecovery: Boolean, $hasAppointment: Boolean, $warehouseUuid: String, $terminalUuid: String, $filters: [FindStopsFiltersInput!], $useCache: Boolean, $includeCount: Boolean) {
  numberOfStops(
    appointmentRequired: $appointmentRequired
    tagUuids: $tagUuids
    hideOnHold: $hideOnHold
    hideStopsWithoutAddress: $hideStopsWithoutAddress
    isAssigned: $isAssigned
    previouslyAttempted: $previouslyAttempted
    onHand: $onHand
    standardStopTypes: $standardStopTypes
    statuses: $statuses
    orderStatuses: $orderStatuses
    customerUuid: $customerUuid
    serviceLevelUuids: $serviceLevelUuids
    createdAtFilters: $createdAtFilters
    deadlineDateFilters: $deadlineDateFilters
    serviceDateFilters: $serviceDateFilters
    appointmentTimeFilters: $appointmentTimeFilters
    transferPending: $transferPending
    pickupOrDeliveryTypes: $pickupOrDeliveryTypes
    requiresRecovery: $requiresRecovery
    hasAppointment: $hasAppointment
    warehouseUuid: $warehouseUuid
    terminalUuid: $terminalUuid
    filters: $filters
    useCache: $useCache
    includeCount: $includeCount
  )
}
    `;
export const RouteEtaDocument = gql`
    query routeEta($uuid: String!) {
  route(uuid: $uuid) {
    uuid
    etas {
      arrivalTime
      finishTime
    }
  }
}
    `;
export const AssignHelperToRouteDocument = gql`
    mutation assignHelperToRoute($helperUuid: String!, $routeUuid: String!) {
  assignHelperToRoute(helperUuid: $helperUuid, routeUuid: $routeUuid) {
    uuid
  }
}
    `;
export const CreateAppointmentsForRouteDocument = gql`
    mutation createAppointmentsForRoute($uuid: String!) {
  createAppointmentsForRoute(uuid: $uuid) {
    ...Route
  }
}
    ${RouteFragmentDoc}`;
export const CreateRoutePathsDocument = gql`
    mutation createRoutePaths($routePathsCreateInput: RoutePathsCreateInput!) {
  createRoutePaths(routePathsCreateInput: $routePathsCreateInput) {
    ...RoutePath
  }
}
    ${RoutePathFragmentDoc}`;
export const CreateRoutesDocument = gql`
    mutation createRoutes($createRoutesInput: CreateRoutesInput!) {
  createRoutes(createRoutesInput: $createRoutesInput) {
    ...Route
  }
}
    ${RouteFragmentDoc}`;
export const DeleteSlotsFromRouteDocument = gql`
    mutation deleteSlotsFromRoute($deleteSlotsFromRouteInput: DeleteSlotsFromRouteInput!) {
  deleteSlotsFromRoute(deleteSlotsFromRouteInput: $deleteSlotsFromRouteInput)
}
    `;
export const DriversForHelpersDocument = gql`
    query driversForHelpers($date: DateTime!) {
  drivers {
    ...Driver
    route(date: $date) {
      uuid
    }
  }
}
    ${DriverFragmentDoc}`;
export const RunOptimizationDocument = gql`
    mutation runOptimization($createOptimizationRunInput: CreateOptimizationRunDto!) {
  runOptimization(createOptimizationRunInput: $createOptimizationRunInput) {
    uuid
  }
}
    `;
export const ReassignRouteSlotDocument = gql`
    mutation reassignRouteSlot($routeSlotReassignInput: RouteSlotReassignInput!) {
  reassignRouteSlot(routeSlotReassignInput: $routeSlotReassignInput) {
    ...Route
  }
}
    ${RouteFragmentDoc}`;
export const RemoveHelperFromRouteDocument = gql`
    mutation removeHelperFromRoute($helperUuid: String!, $routeUuid: String!) {
  removeHelperFromRoute(helperUuid: $helperUuid, routeUuid: $routeUuid)
}
    `;
export const RemoveRouteDocument = gql`
    mutation removeRoute($uuid: String!) {
  removeRoute(uuid: $uuid) {
    uuid
  }
}
    `;
export const RoutePathByRouteDocument = gql`
    query routePathByRoute($uuid: String!) {
  route(uuid: $uuid) {
    routePath {
      ...RoutePath
    }
  }
}
    ${RoutePathFragmentDoc}`;
export const RoutePathsDocument = gql`
    query routePaths($date: DateTime!) {
  routes(date: $date) {
    routePath {
      ...RoutePath
    }
  }
}
    ${RoutePathFragmentDoc}`;
export const RoutesDocument = gql`
    query routes($date: DateTime, $terminalUuid: String, $routeUuids: [String!]) {
  routes(date: $date, routeUuids: $routeUuids, terminalUuid: $terminalUuid) {
    ...Route
  }
}
    ${RouteFragmentDoc}`;
export const RoutesSamsaraVehicleLocationsDocument = gql`
    query routesSamsaraVehicleLocations($routeUuids: [String!]!) {
  routesSamsaraVehicleLocations(routeUuids: $routeUuids) {
    routeCoordinates {
      routeUuid
      latitude
      longitude
    }
  }
}
    `;
export const RoutesWithDriverMobilePhoneCoordinatesDocument = gql`
    query routesWithDriverMobilePhoneCoordinates($routeUuids: [String!]!) {
  routes(routeUuids: $routeUuids) {
    uuid
    currentDriverMobilePhoneLocation {
      latitude
      longitude
    }
  }
}
    `;
export const RoutesWithEtaDocument = gql`
    query routesWithEta($date: DateTime!) {
  routes(date: $date) {
    uuid
    date
    totalTimeInSeconds
    nameManuallyChanged
    locked
    etas {
      arrivalTime
      finishTime
    }
    helpers {
      firstName
      lastName
      uuid
      phoneNumber
    }
    defaultStartTime
    startLoadTimeInMinutes
    endLoadTimeInMinutes
    name
    numberOfRescheduled
    routeSlotsUpdatedAt
    lastDispatched
    equipments {
      name
      type
      uuid
    }
    drivers {
      defaultVehicle {
        name
        uuid
      }
      firstName
      lastName
      phoneNumber
      uuid
    }
    slots {
      uuid
      stops {
        ...StopOnRoute
      }
    }
  }
}
    ${StopOnRouteFragmentDoc}`;
export const PaginatedRoutesDocument = gql`
    query paginatedRoutes($first: Int, $after: String, $last: Int, $before: String, $date: DateTime, $terminalUuid: String, $routeUuids: [String!], $searchText: String, $routeSort: RouteSort, $versionId: String) {
  paginatedRoutes(
    first: $first
    after: $after
    last: $last
    before: $before
    date: $date
    routeUuids: $routeUuids
    terminalUuid: $terminalUuid
    searchText: $searchText
    routeSort: $routeSort
    versionId: $versionId
  ) {
    totalCount
    versionId
    edges {
      node {
        ...Route
      }
    }
    pageInfo {
      startCursor
      endCursor
      hasNextPage
      hasPreviousPage
    }
  }
}
    ${RouteFragmentDoc}`;
export const UpdateRouteDocument = gql`
    mutation updateRoute($updateRouteInput: UpdateRouteInput!) {
  updateRoute(updateRouteInput: $updateRouteInput) {
    uuid
  }
}
    `;
export const UpdateVehicleForRouteDocument = gql`
    mutation updateVehicleForRoute($routeUuid: String!, $vehicleUuid: String!) {
  updateVehicleForRoute(routeUuid: $routeUuid, vehicleUuid: $vehicleUuid) {
    uuid
  }
}
    `;
export const SameDayDispatchRoutesDocument = gql`
    query sameDayDispatchRoutes($date: DateTime!, $searchText: String, $terminalUuid: String) {
  routes(date: $date, searchText: $searchText, terminalUuid: $terminalUuid) {
    ...SameDayDispatchRoute
  }
}
    ${SameDayDispatchRouteFragmentDoc}`;
export const SamsaraVehicleStatsFeedDocument = gql`
    query samsaraVehicleStatsFeed($samsaraVehicleIds: [String!]!) {
  samsaraVehicleStatsFeed(samsaraVehicleIds: $samsaraVehicleIds) {
    data {
      id
      gps {
        latitude
        longitude
        time
      }
    }
    pagination {
      hasNextPage
      endCursor
    }
  }
}
    `;
export const SendRouteToAgentDocument = gql`
    mutation sendRouteToAgent($sendRouteToAgentInput: SendRouteToAgentInput!) {
  sendRouteToAgent(input: $sendRouteToAgentInput) {
    ... on SendRouteToAgentSuccessOutput {
      route {
        uuid
      }
    }
    ... on MutationErrorOutput {
      message
    }
  }
}
    `;
export const StopsBySearchTextDocument = gql`
    query stopsBySearchText($searchText: String!) {
  stopsBySearchText(searchText: $searchText) {
    ...StopBySearchText
  }
}
    ${StopBySearchTextFragmentDoc}`;
export const StopsOnRoutesBySearchTextDocument = gql`
    query stopsOnRoutesBySearchText($searchText: String!) {
  stopsOnRoutesBySearchText(searchText: $searchText) {
    ...StopOnRouteBySearchText
  }
}
    ${StopOnRouteBySearchTextFragmentDoc}`;
export const StopQueryForOverrideMinutesDocument = gql`
    query stopQueryForOverrideMinutes($uuid: String!) {
  stop(uuid: $uuid) {
    uuid
    overrideServiceTimeInMinutes
    routeSlot {
      route {
        uuid
      }
    }
  }
}
    `;
export const StopsDocument = gql`
    query stops($first: Int, $after: String, $last: Int, $before: String, $includeCount: Boolean = false, $sort: StopSort, $sorts: [StopSort!], $useCache: Boolean, $cacheStartIndex: Float, $uuid: String, $uuids: [String!], $orderUuid: String, $searchText: String, $addressType: StandardStopType, $appointmentRequired: Boolean, $appointmentScheduled: Boolean, $tagUuids: [String!], $isAssigned: Boolean, $previouslyAttempted: Boolean, $businessDivisionUuid: String, $serviceLevelUuids: [String!], $onHand: Boolean, $isPicked: Boolean, $isRefusedFilter: BooleanFilterV2, $statuses: [StopStatus!], $orderStatuses: [OrderStatus!], $customerUuid: String, $createdAtFilters: DateFilterStartEnd, $deadlineDateFilters: DateFilterStartEnd, $serviceDateFilters: DateFilterStartEnd, $appointmentTimeFilters: DateFilterStartEnd, $transferPending: Boolean, $pickupOrDeliveryTypes: [PickupOrDelivery!], $requiresRecovery: Boolean, $hasAppointment: Boolean, $warehouseUuid: String, $terminalUuid: String, $hideOnHold: Boolean, $hideStopsWithoutAddress: Boolean, $isSpecial: Boolean, $routeNameUuid: String, $includeRecurringRunHeaders: Boolean, $filters: [FindStopsFiltersInput!]) {
  stops(
    first: $first
    after: $after
    last: $last
    before: $before
    includeCount: $includeCount
    sort: $sort
    sorts: $sorts
    useCache: $useCache
    cacheStartIndex: $cacheStartIndex
    uuid: $uuid
    uuids: $uuids
    orderUuid: $orderUuid
    searchText: $searchText
    addressType: $addressType
    appointmentRequired: $appointmentRequired
    appointmentScheduled: $appointmentScheduled
    isAssigned: $isAssigned
    previouslyAttempted: $previouslyAttempted
    onHand: $onHand
    isPicked: $isPicked
    isRefusedFilter: $isRefusedFilter
    statuses: $statuses
    orderStatuses: $orderStatuses
    customerUuid: $customerUuid
    businessDivisionUuid: $businessDivisionUuid
    serviceLevelUuids: $serviceLevelUuids
    createdAtFilters: $createdAtFilters
    deadlineDateFilters: $deadlineDateFilters
    serviceDateFilters: $serviceDateFilters
    appointmentTimeFilters: $appointmentTimeFilters
    transferPending: $transferPending
    pickupOrDeliveryTypes: $pickupOrDeliveryTypes
    requiresRecovery: $requiresRecovery
    hasAppointment: $hasAppointment
    warehouseUuid: $warehouseUuid
    terminalUuid: $terminalUuid
    tagUuids: $tagUuids
    hideOnHold: $hideOnHold
    hideStopsWithoutAddress: $hideStopsWithoutAddress
    isSpecial: $isSpecial
    routeNameUuid: $routeNameUuid
    includeRecurringRunHeaders: $includeRecurringRunHeaders
    filters: $filters
  ) {
    totalCount @include(if: $includeCount)
    recurringRunsCount
    edges {
      node {
        __typename
        ... on CachedStopEntity {
          ...Stop
        }
        ... on RecurringRunHeaderEntity {
          ...RecurringRunHeader
        }
      }
    }
    pageInfo {
      startCursor
      endCursor
      hasNextPage
      hasPreviousPage
    }
  }
}
    ${StopFragmentDoc}
${RecurringRunHeaderFragmentDoc}`;
export const TextDriverDocument = gql`
    mutation textDriver($textDriverInput: TextDriverInput!) {
  textDriver(textDriverInput: $textDriverInput) {
    uuid
  }
}
    `;
export const UpdateRouteDriversDocument = gql`
    mutation updateRouteDrivers($updateRouteDriversInput: UpdateRouteDriversInput!) {
  updateRouteDrivers(updateRouteDriversInput: $updateRouteDriversInput) {
    uuid
  }
}
    `;
export const UpdateRouteSlotsDocument = gql`
    mutation updateRouteSlots($updateRouteSlotsInput: UpdateRouteSlotsInput!) {
  updateRouteSlots(updateRouteSlotsInput: $updateRouteSlotsInput) {
    uuid
  }
}
    `;
export const CompanyDocumentsDocument = gql`
    query companyDocuments($companyUuid: String!, $terminalUuid: String, $first: Int, $after: String, $last: Int, $before: String, $date: String!, $statusFilter: FindCompanyDocumentStatusFilter!, $searchText: String, $uploadDateAscending: Boolean) {
  companyDocuments(
    companyUuid: $companyUuid
    terminalUuid: $terminalUuid
    first: $first
    after: $after
    last: $last
    before: $before
    date: $date
    statusFilter: $statusFilter
    searchText: $searchText
    uploadDateAscending: $uploadDateAscending
  ) {
    ...Document
  }
}
    ${DocumentFragmentDoc}`;
export const CompanySchemasDocument = gql`
    query companySchemas {
  companySchemas {
    uuid
    companyUuid
    contactUuid
    isMultiPage
    name
    originalFilename
    scannedDocumentType
  }
}
    `;
export const SplitAndProcessOrderDocumentsDocument = gql`
    mutation splitAndProcessOrderDocuments($splitAndProcessOrderDocumentsInput: SplitAndProcessOrderDocumentsInput!) {
  splitAndProcessOrderDocuments(
    splitAndProcessOrderDocumentsInput: $splitAndProcessOrderDocumentsInput
  )
}
    `;
export const UpdateDocumentsDocument = gql`
    mutation updateDocuments($updateDocumentsInput: UpdateDocumentsInput!) {
  updateDocuments(updateDocumentsInput: $updateDocumentsInput) {
    uuid
  }
}
    `;
export const CreateAdjustmentStopDriverMapDocument = gql`
    mutation createAdjustmentStopDriverMap($input: AdjustmentStopDriverMapCreateInput!) {
  createAdjustmentStopDriverMap(adjustmentStopDriverMapCreateInput: $input) {
    ...StopDriverMapForOrder
  }
}
    ${StopDriverMapForOrderFragmentDoc}`;
export const CreateDriverSettlementBillDocument = gql`
    mutation createDriverSettlementBill($createDriverSettlementBillInput: CreateDriverSettlementBillInput!) {
  createDriverSettlementBill(
    createDriverSettlementBillInput: $createDriverSettlementBillInput
  ) {
    ...DriverSettlementBill
  }
}
    ${DriverSettlementBillFragmentDoc}`;
export const DeleteStopDriverMapDocument = gql`
    mutation deleteStopDriverMap($uuid: String!) {
  deleteStopDriverMap(uuid: $uuid) {
    uuid
  }
}
    `;
export const DriverCompletedStopsLogDocument = gql`
    query driverCompletedStopsLog($driverUuid: String, $startDate: DateTime!, $endDate: DateTime!) {
  driverCompletedStopsLog(
    driverUuid: $driverUuid
    startDate: $startDate
    endDate: $endDate
  ) {
    ...DriverCompletedStops
  }
}
    ${DriverCompletedStopsFragmentDoc}`;
export const DriverSettlementBillByUuidDocument = gql`
    query driverSettlementBillByUuid($uuid: String!) {
  driverSettlementBill(uuid: $uuid) {
    ...DriverSettlementBill
  }
}
    ${DriverSettlementBillFragmentDoc}`;
export const DriverSettlementBillsCountDocument = gql`
    query driverSettlementBillsCount {
  driverSettlementBillsCountForCompany
}
    `;
export const DriverSettlementBillsForDownloadDocument = gql`
    query driverSettlementBillsForDownload($startDate: DateTime, $endDate: DateTime, $isFinalized: Boolean, $driverUuid: String, $searchText: String, $uuids: [String!]) {
  driverSettlementBillsForDownload(
    startDate: $startDate
    endDate: $endDate
    isFinalized: $isFinalized
    driverUuid: $driverUuid
    searchText: $searchText
    uuids: $uuids
  ) {
    ...DriverSettlementBillForDownload
  }
}
    ${DriverSettlementBillForDownloadFragmentDoc}`;
export const DriverSettlementBillsV2Document = gql`
    query driverSettlementBillsV2($first: Int, $after: String, $last: Int, $before: String, $limit: Int, $startDate: DateTime, $endDate: DateTime, $sortByBillStartDateAscending: Boolean, $sortBySettlementDateAscending: Boolean, $isFinalized: Boolean, $driverUuid: String, $driverUuids: [String!], $searchText: String) {
  driverSettlementBills(
    first: $first
    after: $after
    last: $last
    before: $before
    limit: $limit
    startDate: $startDate
    endDate: $endDate
    sortByBillStartDateAscending: $sortByBillStartDateAscending
    sortBySettlementDateAscending: $sortBySettlementDateAscending
    isFinalized: $isFinalized
    driverUuid: $driverUuid
    driverUuids: $driverUuids
    searchText: $searchText
  ) {
    totalCount
    edges {
      node {
        ...DriverSettlementBillSummaryV2
      }
    }
    pageInfo {
      startCursor
      endCursor
      hasNextPage
      hasPreviousPage
    }
  }
}
    ${DriverSettlementBillSummaryV2FragmentDoc}`;
export const DriverSettlementBillsDocument = gql`
    query driverSettlementBills($first: Int, $after: String, $last: Int, $before: String, $limit: Int, $startDate: DateTime, $endDate: DateTime, $sortByBillStartDateAscending: Boolean, $sortBySettlementDateAscending: Boolean, $isFinalized: Boolean, $driverUuid: String, $driverUuids: [String!], $searchText: String) {
  driverSettlementBills(
    first: $first
    after: $after
    last: $last
    before: $before
    limit: $limit
    startDate: $startDate
    endDate: $endDate
    sortByBillStartDateAscending: $sortByBillStartDateAscending
    sortBySettlementDateAscending: $sortBySettlementDateAscending
    isFinalized: $isFinalized
    driverUuid: $driverUuid
    driverUuids: $driverUuids
    searchText: $searchText
  ) {
    totalCount
    edges {
      node {
        ...DriverSettlementBill
      }
    }
    pageInfo {
      startCursor
      endCursor
      hasNextPage
      hasPreviousPage
    }
  }
}
    ${DriverSettlementBillFragmentDoc}`;
export const FinalizeDriverSettlementBillsDocument = gql`
    mutation finalizeDriverSettlementBills($startDate: DateTime, $endDate: DateTime, $isFinalized: Boolean, $driverUuid: String, $searchText: String, $uuids: [String!]) {
  finalizeDriverSettlementBills(
    startDate: $startDate
    endDate: $endDate
    isFinalized: $isFinalized
    driverUuid: $driverUuid
    searchText: $searchText
    uuids: $uuids
  )
}
    `;
export const InvoiceShipmentByStopUuidDocument = gql`
    query invoiceShipmentByStopUuid($uuid: String!) {
  stop(uuid: $uuid) {
    shipment {
      ...InvoiceShipmentWithCharges
    }
  }
}
    ${InvoiceShipmentWithChargesFragmentDoc}`;
export const RemoveDriverSettlementBillDocument = gql`
    mutation removeDriverSettlementBill($uuid: String!) {
  removeDriverSettlementBill(uuid: $uuid) {
    uuid
  }
}
    `;
export const CreateSettlementDeductionDocument = gql`
    mutation createSettlementDeduction($settlementDeductionCreateInput: SettlementDeductionCreateInput!) {
  createSettlementDeduction(
    settlementDeductionCreateInput: $settlementDeductionCreateInput
  ) {
    uuid
  }
}
    `;
export const RemoveSettlementDeductionDocument = gql`
    mutation removeSettlementDeduction($uuid: String!) {
  removeSettlementDeduction(uuid: $uuid) {
    uuid
  }
}
    `;
export const UpdateSettlementDeductionDocument = gql`
    mutation updateSettlementDeduction($settlementDeductionUpdateInput: SettlementDeductionUpdateInput!) {
  updateSettlementDeduction(
    settlementDeductionUpdateInput: $settlementDeductionUpdateInput
  ) {
    uuid
  }
}
    `;
export const StopDriverMapsSummaryDocument = gql`
    query stopDriverMapsSummary($first: Int, $after: String, $last: Int, $before: String, $noMaximum: Boolean, $completedStartDate: DateTime, $completedEndDate: DateTime, $settlementStartDate: DateTime, $settlementEndDate: DateTime, $sortByCompletedDateAsc: Boolean, $sortBySettlementDateAsc: Boolean, $onDriverSettlementBill: Boolean, $driverSettlementFinalized: Boolean, $onInvoice: Boolean, $chargesFinalized: Boolean, $invoiceStatuses: [InvoiceStatus!], $driverSettlementBillUuid: String, $driverUuid: String, $searchText: String, $stopTypes: [StopType!], $includeStopDriverMapUuids: [String!], $excludeStopDriverMapUuids: [String!], $includeTotalAmounts: Boolean!) {
  stopDriverMaps(
    first: $first
    after: $after
    last: $last
    before: $before
    noMaximum: $noMaximum
    completedStartDate: $completedStartDate
    completedEndDate: $completedEndDate
    settlementStartDate: $settlementStartDate
    settlementEndDate: $settlementEndDate
    sortByCompletedDateAsc: $sortByCompletedDateAsc
    sortBySettlementDateAsc: $sortBySettlementDateAsc
    onDriverSettlementBill: $onDriverSettlementBill
    driverSettlementFinalized: $driverSettlementFinalized
    onInvoice: $onInvoice
    chargesFinalized: $chargesFinalized
    invoiceStatuses: $invoiceStatuses
    driverSettlementBillUuid: $driverSettlementBillUuid
    driverUuid: $driverUuid
    searchText: $searchText
    stopTypes: $stopTypes
    includeStopDriverMapUuids: $includeStopDriverMapUuids
    excludeStopDriverMapUuids: $excludeStopDriverMapUuids
  ) {
    totalCount
    edges {
      node {
        ...StopDriverMapSummary
      }
    }
    pageInfo {
      startCursor
      endCursor
      hasNextPage
      hasPreviousPage
    }
  }
}
    ${StopDriverMapSummaryFragmentDoc}`;
export const StopDriverMapsDocument = gql`
    query stopDriverMaps($first: Int, $after: String, $last: Int, $before: String, $noMaximum: Boolean, $completedStartDate: DateTime, $completedEndDate: DateTime, $sortByCompletedDateAsc: Boolean, $onDriverSettlementBill: Boolean, $driverSettlementFinalized: Boolean, $onInvoice: Boolean, $chargesFinalized: Boolean, $invoiceStatuses: [InvoiceStatus!], $driverSettlementBillUuid: String, $driverUuid: String, $searchText: String, $stopTypes: [StopType!], $includeStopDriverMapUuids: [String!], $excludeStopDriverMapUuids: [String!]) {
  stopDriverMaps(
    first: $first
    after: $after
    last: $last
    before: $before
    noMaximum: $noMaximum
    completedStartDate: $completedStartDate
    completedEndDate: $completedEndDate
    sortByCompletedDateAsc: $sortByCompletedDateAsc
    onDriverSettlementBill: $onDriverSettlementBill
    driverSettlementFinalized: $driverSettlementFinalized
    onInvoice: $onInvoice
    chargesFinalized: $chargesFinalized
    invoiceStatuses: $invoiceStatuses
    driverSettlementBillUuid: $driverSettlementBillUuid
    driverUuid: $driverUuid
    searchText: $searchText
    stopTypes: $stopTypes
    includeStopDriverMapUuids: $includeStopDriverMapUuids
    excludeStopDriverMapUuids: $excludeStopDriverMapUuids
  ) {
    totalCount
    edges {
      node {
        ...StopDriverMap
      }
    }
    pageInfo {
      startCursor
      endCursor
      hasNextPage
      hasPreviousPage
    }
  }
}
    ${StopDriverMapFragmentDoc}`;
export const UpdateDriverSettlementBillDocument = gql`
    mutation updateDriverSettlementBill($updateDriverSettlementBillInput: UpdateDriverSettlementBillInput!) {
  updateDriverSettlementBill(
    updateDriverSettlementBillInput: $updateDriverSettlementBillInput
  ) {
    ...DriverSettlementBill
  }
}
    ${DriverSettlementBillFragmentDoc}`;
export const UpdateStopDriverMapDocument = gql`
    mutation updateStopDriverMap($input: UpdateStopDriverMapInput!) {
  updateStopDriverMap(updateStopDriverMapInput: $input) {
    ...StopDriverMapForOrder
  }
}
    ${StopDriverMapForOrderFragmentDoc}`;
export const CreateCsvOrderMappingDocument = gql`
    mutation createCsvOrderMapping($createCsvOrderMappingInput: CreateCsvOrderMappingInput!) {
  createCsvOrderMapping(createCsvOrderMappingInput: $createCsvOrderMappingInput) {
    ...CsvOrderMappingDetailed
  }
}
    ${CsvOrderMappingDetailedFragmentDoc}`;
export const CsvOrderMappingDocument = gql`
    query csvOrderMapping($input: CsvOrderMappingQueryInput!) {
  csvOrderMapping(input: $input) {
    ...CsvOrderMappingDetailed
  }
}
    ${CsvOrderMappingDetailedFragmentDoc}`;
export const CsvOrderMappingsForEmailToolDocument = gql`
    query csvOrderMappingsForEmailTool {
  csvOrderMappings {
    ...CsvOrderMappingShallow
  }
}
    ${CsvOrderMappingShallowFragmentDoc}`;
export const UpdateCsvOrderMappingDocument = gql`
    mutation updateCsvOrderMapping($updateCsvOrderMappingInput: UpdateCsvOrderMappingInput!) {
  updateCsvOrderMapping(updateCsvOrderMappingInput: $updateCsvOrderMappingInput) {
    ...CsvOrderMappingDetailed
  }
}
    ${CsvOrderMappingDetailedFragmentDoc}`;
export const CreateEndOfDayDocumentProcessingJobDocument = gql`
    mutation createEndOfDayDocumentProcessingJob($createEndOfDayDocumentProcessingJobInput: CreateEndOfDayDocumentProcessingJobInput!) {
  createEndOfDayDocumentProcessingJob(
    createEndOfDayDocumentProcessingJobInput: $createEndOfDayDocumentProcessingJobInput
  ) {
    uuid
  }
}
    `;
export const DetachDocumentsFromShipmentsDocument = gql`
    mutation detachDocumentsFromShipments($detachDocumentsFromShipmentsInput: DetachDocumentsFromShipmentsInput!) {
  detachDocumentsFromShipments(
    detachDocumentsFromShipmentsInput: $detachDocumentsFromShipmentsInput
  ) {
    uuid
    fileName
    bucket
    region
    key
    type
    fileType
  }
}
    `;
export const DetachDocumentFromShipmentDocument = gql`
    mutation detachDocumentFromShipment($uuid: String!) {
  detachDocumentFromShipment(uuid: $uuid) {
    uuid
    fileName
    bucket
    region
    key
    type
    fileType
  }
}
    `;
export const DocumentsByShipmentDocument = gql`
    query documentsByShipment($uuid: String!) {
  shipmentV2(uuid: $uuid) {
    documents {
      ...Document
    }
  }
}
    ${DocumentFragmentDoc}`;
export const EndOfDayDocumentProcessingJobsDocument = gql`
    query endOfDayDocumentProcessingJobs($companyUuid: String!, $terminalUuid: String, $dateUploadedFor: DateTime!, $searchText: String) {
  endOfDayDocumentProcessingJobs(
    companyUuid: $companyUuid
    terminalUuid: $terminalUuid
    dateUploadedFor: $dateUploadedFor
    searchText: $searchText
  ) {
    ...EndOfDocumentsProcessingJob
  }
}
    ${EndOfDocumentsProcessingJobFragmentDoc}`;
export const ShallowRoutesWithDocumentsDocument = gql`
    query shallowRoutesWithDocuments($date: DateTime!, $terminalUuid: String) {
  routes(date: $date, terminalUuid: $terminalUuid) {
    uuid
    name
    date
    drivers {
      firstName
      lastName
    }
    slots {
      uuid
      stops {
        uuid
        status
        address {
          city
        }
        leg {
          uuid
          shipment {
            documents {
              ...Document
            }
            hasSignedPOD
          }
        }
      }
    }
  }
}
    ${DocumentFragmentDoc}`;
export const EquipmentDocument = gql`
    query equipment($uuid: String!) {
  equipment(uuid: $uuid) {
    ...Equipment
    equipmentLicenses {
      uuid
      number
      licenseType
      licensingBody
      issueDate
      expiryDate
    }
    vehicleType {
      uuid
    }
    isActive
  }
  samsaraOAuthToken {
    uuid
  }
}
    ${EquipmentFragmentDoc}`;
export const EquipmentsDocument = gql`
    query equipments($includeNotActive: Boolean) {
  equipments(includeNotActive: $includeNotActive) {
    uuid
    name
    type
    samsaraVehicleId
    subtype
    vehicleType {
      ...VehicleType
    }
    isActive
  }
}
    ${VehicleTypeFragmentDoc}`;
export const FuelChargeFuelProfileDateRangeDocument = gql`
    query fuelChargeFuelProfileDateRange($fuelChargeFuelProfileDateRangeInput: FuelChargeFuelProfileDateRangeInput!) {
  fuelChargeFuelProfileDateRange(
    fuelChargeFuelProfileDateRangeInput: $fuelChargeFuelProfileDateRangeInput
  ) {
    fuelProfileDateRange {
      ...FuelChargeFuelProfileDateRange
    }
  }
}
    ${FuelChargeFuelProfileDateRangeFragmentDoc}`;
export const LineHaulFuelChargeFuelProfileDateRangeDocument = gql`
    query lineHaulFuelChargeFuelProfileDateRange($lineHaulFuelChargeFuelProfileDateRangeInput: LineHaulFuelChargeFuelProfileDateRangeInput!) {
  lineHaulFuelChargeFuelProfileDateRange(
    lineHaulFuelChargeFuelProfileDateRangeInput: $lineHaulFuelChargeFuelProfileDateRangeInput
  ) {
    fuelProfileDateRange {
      ...LineHaulFuelChargeFuelProfileDateRange
    }
  }
}
    ${LineHaulFuelChargeFuelProfileDateRangeFragmentDoc}`;
export const OrdersForPackingSlipDocument = gql`
    query ordersForPackingSlip($searchText: String, $billingPartyContactUuidsFilter: StringsFilter) {
  orders(
    first: 10
    searchText: $searchText
    billingPartyContactUuidsFilter: $billingPartyContactUuidsFilter
  ) {
    edges {
      node {
        ...OrderForPackingSlip
      }
    }
  }
}
    ${OrderForPackingSlipFragmentDoc}`;
export const PicklistsDocument = gql`
    query picklists($picklistsInput: PicklistsInput!) {
  picklists(picklistsInput: $picklistsInput) {
    edges {
      node {
        ...Picklists
      }
    }
    pageInfo {
      startCursor
      endCursor
      hasNextPage
      hasPreviousPage
    }
    totalCount
  }
}
    ${PicklistsFragmentDoc}`;
export const CompanyStatsQueryDocument = gql`
    query companyStatsQuery {
  me {
    company {
      uuid
      companyStatistics {
        numberOfOrdersDueInFuture
        numberOfUninvoicedOrdersDueInFuture
        numberOfOrdersSixtyOneToNinety
        numberOfOrdersThirtyOneToSixty
        numberOfOrdersOneToThirty
        numberOfUninvoicedOrdersSixtyOneToNinety
        numberOfUninvoicedOrdersThirtyOneToSixty
        numberOfUninvoicedOrdersOneToThirty
        numberOfOrdersPastNinetyOne
        numberOfUninvoicedOrdersPastNinetyOne
      }
    }
  }
}
    `;
export const ConsolidatableOrderSummaryDocument = gql`
    query consolidatableOrderSummary($uuids: [String!]!) {
  ordersByUuids(uuids: $uuids) {
    ...ConsolidatableOrderSummary
  }
}
    ${ConsolidatableOrderSummaryFragmentDoc}`;
export const CreateConsolidatedOrderFromOrderDocument = gql`
    mutation createConsolidatedOrderFromOrder($createConsolidatedOrderFromOrderInput: CreateConsolidatedOrderFromOrderInput!) {
  createConsolidatedOrderFromOrder(
    createConsolidatedOrderFromOrderInput: $createConsolidatedOrderFromOrderInput
  ) {
    uuid
  }
}
    `;
export const CreateConsolidatedOrderDocument = gql`
    mutation createConsolidatedOrder($createConsolidatedOrderInput: CreateConsolidatedOrderInput!) {
  createConsolidatedOrder(
    createConsolidatedOrderInput: $createConsolidatedOrderInput
  ) {
    uuid
    shipments {
      uuid
    }
  }
}
    `;
export const CurrentBillingPeriodInvoiceDocument = gql`
    query currentBillingPeriodInvoice($contactUuid: String!) {
  currentBillingPeriodInvoice(contactUuid: $contactUuid) {
    ...InvoiceFragment
  }
}
    ${InvoiceFragmentFragmentDoc}`;
export const HandleMultipleInvoices210OutboundDocument = gql`
    mutation handleMultipleInvoices210Outbound($handleMultiple210OutboundInput: HandleMultiple210OutboundInput!) {
  handleMultipleInvoices210Outbound(
    handleMultiple210OutboundInput: $handleMultiple210OutboundInput
  )
}
    `;
export const InvoicesDocument = gql`
    query invoices($inConsolidatedInvoice: Boolean, $first: Int, $after: String, $last: Int, $before: String, $startDate: DateTime, $endDate: DateTime, $createdAtStartDate: DateTime, $createdAtEndDate: DateTime, $invoiceStartDate: DateTime, $invoiceEndDate: DateTime, $statuses: [InvoiceStatus!], $searchText: String, $billingPartyContactUuid: String, $sortByDueDateAscending: Boolean, $sortByDueDateDescending: Boolean, $groupByContact: Boolean) {
  invoices(
    inConsolidatedInvoice: $inConsolidatedInvoice
    first: $first
    after: $after
    before: $before
    last: $last
    startDate: $startDate
    endDate: $endDate
    createdAtStartDate: $createdAtStartDate
    createdAtEndDate: $createdAtEndDate
    invoiceStartDate: $invoiceStartDate
    invoiceEndDate: $invoiceEndDate
    statuses: $statuses
    searchText: $searchText
    billingPartyContactUuid: $billingPartyContactUuid
    sortByDueDateAscending: $sortByDueDateAscending
    sortByDueDateDescending: $sortByDueDateDescending
    groupByContact: $groupByContact
  ) {
    edges {
      node {
        ...InvoiceFragment
        uuid
        qbInvoiceNumber
        name
        status
        createdAt
        invoiceTerms {
          terms
        }
        shipments {
          uuid
          totalChargesAmount
          status
          name
          hasFailedStop
          order {
            uuid
            name
            secondaryRefNumber
            standardOrderFields {
              shipperBillOfLadingNumber
            }
          }
          legs {
            endStop {
              completedAt
            }
          }
          standardShipmentFields {
            pickupOrDelivery
            deliveryDate
            dimFactor
          }
          documents {
            ...Document
          }
          packages {
            uuid
            weight
            description
            quantity
            length
            width
            height
            type
          }
          freightCharge {
            uuid
            billingMethod
            tariff {
              uuid
              billingPartyContactUuid
              tariffOverageRates {
                uuid
                name
                type
                rateUsdCents
                applicableAboveAmount
              }
            }
            rate
            description
            quantity
            fuelCharge {
              description
              type
              flatRate
              surchargeRate
              uuid
              freightCharge {
                uuid
              }
            }
          }
          customCharges {
            uuid
            name
            zoneBasedAccessorialZoneUuid
            zoneBasedAccessorialChargeGroupUuid
            specialAccessorialTariffZoneUuid
            specialAccessorialChargeGroupUuid
            quantity
            description
            rate
            customChargeBillingMethod: billingMethod
            accessorialTemplate {
              uuid
              name
              percentForSettlement
            }
          }
        }
        inConsolidatedInvoice
        invoiceTotal
        dueDate
        billToContact {
          uuid
          displayName
        }
      }
    }
    pageInfo {
      startCursor
      endCursor
      hasPreviousPage
      hasNextPage
    }
  }
}
    ${InvoiceFragmentFragmentDoc}
${DocumentFragmentDoc}`;
export const MarkConsolidatableOrdersAsBilledIndividuallyDocument = gql`
    mutation markConsolidatableOrdersAsBilledIndividually($markConsolidatableOrdersAsBilledIndividuallyInput: MarkConsolidatableOrdersAsBilledIndividuallyInput!) {
  markConsolidatableOrdersAsBilledIndividually(
    markConsolidatableOrdersAsBilledIndividuallyInput: $markConsolidatableOrdersAsBilledIndividuallyInput
  ) {
    uuid
    shouldBillIndividually
  }
}
    `;
export const OutstandingOrdersForReviewDocument = gql`
    query outstandingOrdersForReview($first: Int, $after: String, $last: Int, $before: String, $isFinalized: Boolean, $hasIssues: Boolean, $isUnfinalized: Boolean, $isCancelled: Boolean, $contactUuid: String, $billingPartyContactUuids: [String!], $originTerminalUuid: String, $destinationTerminalUuid: String, $searchText: String, $uuids: [String!]!, $orderCompletionStartDate: DateTime, $orderCompletionEndDate: DateTime, $multipleSearches: [String!], $includeUuids: Boolean, $sorts: [OrderSort!]) {
  outstandingOrdersForReview(
    first: $first
    after: $after
    before: $before
    last: $last
    isFinalized: $isFinalized
    hasIssues: $hasIssues
    isUnfinalized: $isUnfinalized
    isCancelled: $isCancelled
    contactUuid: $contactUuid
    billingPartyContactUuids: $billingPartyContactUuids
    originTerminalUuid: $originTerminalUuid
    destinationTerminalUuid: $destinationTerminalUuid
    searchText: $searchText
    uuids: $uuids
    orderCompletionStartDate: $orderCompletionStartDate
    orderCompletionEndDate: $orderCompletionEndDate
    multipleSearches: $multipleSearches
    includeUuids: $includeUuids
    sorts: $sorts
  ) {
    totalCount
    uuids
    edges {
      node {
        totalCharge
        ...OutstandingOrderFragment
      }
    }
    pageInfo {
      startCursor
      endCursor
      hasNextPage
      hasPreviousPage
    }
  }
}
    ${OutstandingOrderFragmentFragmentDoc}`;
export const OutstandingShipmentDocument = gql`
    query outstandingShipment($uuid: String!) {
  shipment(uuid: $uuid) {
    ...OutstandingShipment
  }
}
    ${OutstandingShipmentFragmentDoc}`;
export const ShallowInvoicesDocument = gql`
    query shallowInvoices($inConsolidatedInvoice: Boolean, $first: Int, $after: String, $last: Int, $before: String, $startDate: DateTime, $endDate: DateTime, $createdAtStartDate: DateTime, $createdAtEndDate: DateTime, $invoiceStartDate: DateTime, $invoiceEndDate: DateTime, $statuses: [InvoiceStatus!], $searchText: String, $billingPartyContactUuid: String, $sortByDueDateAscending: Boolean, $sortByDueDateDescending: Boolean, $groupByContact: Boolean) {
  invoices(
    inConsolidatedInvoice: $inConsolidatedInvoice
    first: $first
    after: $after
    before: $before
    last: $last
    startDate: $startDate
    endDate: $endDate
    createdAtStartDate: $createdAtStartDate
    createdAtEndDate: $createdAtEndDate
    invoiceStartDate: $invoiceStartDate
    invoiceEndDate: $invoiceEndDate
    statuses: $statuses
    searchText: $searchText
    billingPartyContactUuid: $billingPartyContactUuid
    sortByDueDateAscending: $sortByDueDateAscending
    sortByDueDateDescending: $sortByDueDateDescending
    groupByContact: $groupByContact
  ) {
    totalCount
    edges {
      node {
        uuid
        qbInvoiceNumber
        quickbooksInvoiceId
        lastSyncedToQuickbooksAt
        name
        createdAt
        invoiceTerms {
          terms
        }
        invoiceTotal
        status
        inConsolidatedInvoice
        dueDate
        billToContact {
          uuid
          displayName
        }
        firstShipment {
          order {
            ediTransactions {
              status
              code
            }
          }
        }
      }
    }
    pageInfo {
      startCursor
      endCursor
      hasPreviousPage
      hasNextPage
    }
  }
}
    `;
export const UnconsolidateOrderDocument = gql`
    mutation unconsolidateOrder($unconsolidateOrderInput: UnconsolidateOrderInput!) {
  unconsolidateOrder(unconsolidateOrderInput: $unconsolidateOrderInput) {
    uuid
    order {
      uuid
    }
  }
}
    `;
export const UpdateOrderShipperBillOfLadingNumberDocument = gql`
    mutation updateOrderShipperBillOfLadingNumber($updateStandardOrderInput: UpdateStandardOrderInput!) {
  updateStandardOrder(updateStandardOrderInput: $updateStandardOrderInput) {
    uuid
  }
}
    `;
export const WmsContactsDocument = gql`
    query wmsContacts($companyUuid: String) {
  wmsContacts(companyUuid: $companyUuid) {
    uuid
    displayName
    company {
      uuid
      name
    }
  }
}
    `;
export const CreateInvoiceDocument = gql`
    mutation createInvoice($createInvoiceInput: CreateInvoiceInput!) {
  createInvoice(createInvoiceInput: $createInvoiceInput) {
    uuid
  }
}
    `;
export const FinalizeInvoicesDocument = gql`
    mutation finalizeInvoices($finalizeInvoicesInput: FinalizeInvoicesInput!) {
  finalizeInvoices(finalizeInvoicesInput: $finalizeInvoicesInput) {
    count
  }
}
    `;
export const DocumentsByInvoiceDocument = gql`
    query documentsByInvoice($invoiceUuid: String!) {
  invoiceDocuments(invoiceUuid: $invoiceUuid) {
    uuid
    fileName
    bucket
    region
    fileName
    key
  }
}
    `;
export const InvoiceDocument = gql`
    query invoice($uuid: String!) {
  invoice(uuid: $uuid) {
    ...InvoiceFragment
    uuid
    notes
    name
    createdAt
    dueDate
    status
    invoiceTotal
    invoiceTerms {
      uuid
      terms
    }
    billToContact {
      uuid
      displayName
      defaultAddress {
        uuid
      }
      addresses {
        uuid
      }
      contactPersons {
        uuid
      }
    }
    dueDate
    documents {
      ...Document
    }
    shipments {
      ...InvoiceShipmentFragment
      hasSignedPOD
    }
  }
}
    ${InvoiceFragmentFragmentDoc}
${DocumentFragmentDoc}
${InvoiceShipmentFragmentFragmentDoc}`;
export const UpdateInvoiceLimitedDocument = gql`
    mutation updateInvoiceLimited($updateInvoiceLimitedInput: InvoiceUpdateLimitedInput!) {
  updateInvoiceLimited(updateInvoiceLimitedInput: $updateInvoiceLimitedInput) {
    uuid
  }
}
    `;
export const AddOrdersToInvoicesDocument = gql`
    mutation addOrdersToInvoices($input: AddOrdersToInvoicesInput!) {
  addOrdersToInvoices(input: $input) {
    __typename
    ... on AddOrdersToInvoicesSuccessOutput {
      success
      invoicesAddedToByContact {
        __typename
        ... on AddOrdersToInvoicesForContactSuccessOutput {
          success
          contactName
          contactUuid
          existingInvoiceAdds {
            __typename
            ... on AddOrdersToInvoiceSuccessOutput {
              success
              invoiceName
              invoiceUuid
              ordersAdded {
                orderUuid
                orderName
              }
            }
            ... on AddOrdersToExistingInvoiceErrorOutput {
              success
              invoiceName
              invoiceUuid
              attemptedOrdersToAdd {
                orderUuid
                orderName
                shipmentUuids
              }
            }
          }
          newInvoiceAdds {
            __typename
            ... on AddOrdersToInvoiceSuccessOutput {
              success
              invoiceName
              invoiceUuid
              ordersAdded {
                orderUuid
                orderName
              }
            }
            ... on AddOrdersToNewInvoiceErrorOutput {
              success
              createdInvoiceName
              attemptedOrdersToAdd {
                orderUuid
                orderName
                shipmentUuids
              }
            }
          }
        }
        ... on AddOrdersToInvoicesForContactErrorOutput {
          success
          contactName
          contactUuid
          proposedUpdatesToExistingInvoices {
            ... on ExistingInvoiceToUpdate {
              name
              invoiceUuid
              ordersToAdd {
                orderUuid
                orderName
                shipmentUuids
              }
            }
          }
          proposedNewInvoicesToCreate {
            ... on NewInvoiceToCreate {
              name
              ordersToAdd {
                orderUuid
                orderName
                shipmentUuids
              }
            }
          }
        }
      }
    }
    ... on MutationErrorOutput {
      message
    }
  }
}
    `;
export const PreviewAddOrdersToInvoicesDocument = gql`
    query previewAddOrdersToInvoices($previewAddOrdersToInvoicesInput: PreviewAddOrdersToInvoicesInput!) {
  previewAddOrdersToInvoices(
    previewAddOrdersToInvoicesInput: $previewAddOrdersToInvoicesInput
  ) {
    invoicesToAddToByContact {
      ... on PreviewAddOrdersToInvoicesForContactOutput {
        contactUuid
        contactName
        existingInvoicesToUpdate {
          ... on ExistingInvoiceToUpdate {
            name
            invoiceUuid
            ordersToAdd {
              ... on OrderToAddToInvoice {
                orderUuid
                orderName
                shipmentUuids
              }
            }
          }
        }
        newInvoicesToCreate {
          ... on NewInvoiceToCreate {
            name
            ordersToAdd {
              ... on OrderToAddToInvoice {
                orderUuid
                orderName
                shipmentUuids
              }
            }
          }
        }
      }
    }
  }
}
    `;
export const ContactsForDunningQueryDocument = gql`
    query contactsForDunningQuery($uuids: [String!]!) {
  contactsByUuids(uuids: $uuids) {
    ...ShallowContact
    defaultAddress {
      name
      line1
      line2
      city
      state
      zip
      country
    }
    overdueInvoices {
      ...InvoiceForDunningReport
    }
    company {
      customDunningReportHeader
      customDunningReportFooter
    }
  }
}
    ${ShallowContactFragmentDoc}
${InvoiceForDunningReportFragmentDoc}`;
export const DunningReportPdfDocument = gql`
    query dunningReportPdf($dunningReportInput: DunningReportInput!) {
  dunningReportPdf(dunningReportInput: $dunningReportInput) {
    url
    fileName
    errors
  }
}
    `;
export const GlCodeReportPdfDocument = gql`
    query glCodeReportPdf($glCodeReportPdfInput: GLCodeReportPdfInput!) {
  glCodeReportPdf(glCodeReportPdfInput: $glCodeReportPdfInput) {
    url
    fileName
    errors
  }
}
    `;
export const InvoiceEdiTransactionsDocument = gql`
    query invoiceEdiTransactions($findInvoiceEdiTransactionsInput: FindInvoiceEdiTransactionsInput!) {
  invoiceEdiTransactions(
    findInvoiceEdiTransactionsInput: $findInvoiceEdiTransactionsInput
  ) {
    ediTransactionConnection {
      edges {
        node {
          ...InvoiceEdiTransaction
        }
      }
      pageInfo {
        startCursor
        endCursor
        hasNextPage
        hasPreviousPage
      }
      totalCount
    }
  }
}
    ${InvoiceEdiTransactionFragmentDoc}`;
export const InvoiceEmailSendStatusDocument = gql`
    query invoiceEmailSendStatus($uuids: [String!]!) {
  invoicesByUuids(uuids: $uuids) {
    uuid
    emailSendStatus
  }
}
    `;
export const InvoiceRegisterReportCsvDocument = gql`
    query invoiceRegisterReportCsv($invoiceRegisterReportInput: InvoiceRegisterReportInput!) {
  invoiceRegisterReportCsv(
    invoiceRegisterReportInput: $invoiceRegisterReportInput
  ) {
    url
    fileName
    errors
  }
}
    `;
export const InvoiceRegisterReportPdfDocument = gql`
    query invoiceRegisterReportPdf($invoiceRegisterReportInput: InvoiceRegisterReportInput!) {
  invoiceRegisterReportPdf(
    invoiceRegisterReportInput: $invoiceRegisterReportInput
  ) {
    url
    fileName
    errors
  }
}
    `;
export const OnTimePerformanceReportCsvDocument = gql`
    query onTimePerformanceReportCsv($input: OnTimePerformanceReportInput!) {
  onTimePerformanceReportCsv(onTimePerformanceReportInput: $input) {
    __typename
    url
    fileName
    errors
  }
}
    `;
export const OnTimePerformanceReportPdfDocument = gql`
    query onTimePerformanceReportPdf($input: OnTimePerformanceReportInput!) {
  onTimePerformanceReportPdf(onTimePerformanceReportInput: $input) {
    __typename
    url
    fileName
    errors
  }
}
    `;
export const SageBusinessWorksInvoiceExportCsvDocument = gql`
    query sageBusinessWorksInvoiceExportCsv($invoiceUuids: [String!]!) {
  sageBusinessWorksInvoiceExportCsv(invoiceUuids: $invoiceUuids) {
    url
    fileName
    errors
  }
}
    `;
export const InvoiceShipmentWithChargesByUuidDocument = gql`
    query invoiceShipmentWithChargesByUuid($uuid: String!) {
  shipment(uuid: $uuid) {
    ...InvoiceShipmentWithCharges
  }
}
    ${InvoiceShipmentWithChargesFragmentDoc}`;
export const OverdueInvoicesDocument = gql`
    query overdueInvoices($contactUuid: String!) {
  overdueInvoices(contactUuid: $contactUuid) {
    name
    dueDate
    date
    journalNumber
    totalNumber
    balanceInCents
  }
}
    `;
export const ShipmentsByContactUuidDocument = gql`
    query shipmentsByContactUuid($contactUuid: String, $startCompletedDate: DateTime, $endCompletedDate: DateTime) {
  shipmentsByContactUuid(
    contactUuid: $contactUuid
    startCompletedDate: $startCompletedDate
    endCompletedDate: $endCompletedDate
  ) {
    uuid
  }
}
    `;
export const BatchAddShipmentsToInvoicesMultipleDocument = gql`
    mutation batchAddShipmentsToInvoicesMultiple($batchAddShipmentsToInvoicesInputMultiple: BatchAddShipmentsToInvoicesInputMultiple!) {
  batchAddShipmentsToInvoicesMultiple(
    batchAddShipmentsToInvoicesInputMultiple: $batchAddShipmentsToInvoicesInputMultiple
  ) {
    ...BatchAddShipmentsToInvoicesResultInvoice
  }
}
    ${BatchAddShipmentsToInvoicesResultInvoiceFragmentDoc}`;
export const CheckConsistencyOfInvoicesDocument = gql`
    query CheckConsistencyOfInvoices($checkConsistencyOfInvoicesInput: CheckConsistencyOfInvoicesInput!) {
  checkConsistencyOfInvoices(
    checkConsistencyOfInvoicesInput: $checkConsistencyOfInvoicesInput
  )
}
    `;
export const CreateProratedConsolidatedOrderDocument = gql`
    mutation createProratedConsolidatedOrder($input: CreateProratedConsolidatedOrderInput!) {
  createProratedConsolidatedOrder(createProratedConsolidatedOrderInput: $input) {
    orders {
      uuid
    }
    consolidatedOrderUuid
    errorMessage
  }
}
    `;
export const OrderInConsolidationFlowDocument = gql`
    query orderInConsolidationFlow($uuid: String!) {
  standardOrder(uuid: $uuid) {
    ...OrderForConsolidationFlow
  }
}
    ${OrderForConsolidationFlowFragmentDoc}`;
export const PreviewProratedConsolidationV2Document = gql`
    query previewProratedConsolidationV2($previewProratedConsolidationV2Input: PreviewProratedConsolidationV2Input!) {
  previewProratedConsolidationV2(
    previewProratedConsolidationV2Input: $previewProratedConsolidationV2Input
  ) {
    __typename
    ... on PreviewProratedConsolidationV2SuccessOutput {
      proratedOrders {
        ...ProratedOrderV2
      }
      totalAfterProrating
      consolidationMethod
      totalWeightConsolidated
      proratedOverview {
        inboundFreightCharge {
          ...SimpleFreightCharge
        }
        outboundFreightCharge {
          ...SimpleFreightCharge
        }
        inboundFuelCharge {
          ...SimpleFuelCharge
        }
        outboundFuelCharge {
          ...SimpleFuelCharge
        }
        customCharges {
          ...SimpleCustomCharge
        }
      }
    }
    ... on QueryErrorOutput {
      message
    }
  }
}
    ${ProratedOrderV2FragmentDoc}
${SimpleFreightChargeFragmentDoc}
${SimpleFuelChargeFragmentDoc}
${SimpleCustomChargeFragmentDoc}`;
export const PreviewProratedConsolidationDocument = gql`
    query previewProratedConsolidation($previewProratedConsolidationInput: PreviewProratedConsolidationInput!) {
  previewProratedConsolidation(
    previewProratedConsolidationInput: $previewProratedConsolidationInput
  ) {
    proratedOrders {
      ...ProratedOrder
    }
  }
}
    ${ProratedOrderFragmentDoc}`;
export const ProrateOrdersDocument = gql`
    mutation prorateOrders($input: ProrateOrdersInput!) {
  prorateOrders(prorateOrdersInput: $input) {
    __typename
    ... on ProrateOrdersSuccessOutput {
      orderUuids
    }
    ... on MutationErrorOutput {
      message
    }
  }
}
    `;
export const TypeaheadOrderUuidsQueryForConsolidationFlowDocument = gql`
    query typeaheadOrderUuidsQueryForConsolidationFlow($billingPartyContactUuidFilter: StringFilter, $statusFilters: [StatusFilter!], $first: Int, $after: String, $last: Int, $before: String, $searchText: String, $onInvoice: BooleanFilter, $versionId: Float, $includeOrdersPartOfV2ConsolidatedOrdersFilter: BooleanFilterV2) {
  orders(
    first: $first
    last: $last
    after: $after
    before: $before
    billingPartyContactUuidFilter: $billingPartyContactUuidFilter
    onInvoice: $onInvoice
    searchText: $searchText
    statusFilters: $statusFilters
    versionId: $versionId
    includeOrdersPartOfV2ConsolidatedOrdersFilter: $includeOrdersPartOfV2ConsolidatedOrdersFilter
  ) {
    versionId
    edges {
      node {
        ...OrderForConsolidationFlow
      }
    }
    pageInfo {
      startCursor
      endCursor
      hasNextPage
      hasPreviousPage
    }
  }
}
    ${OrderForConsolidationFlowFragmentDoc}`;
export const ContactsForInvoicesDocument = gql`
    query contactsForInvoices($first: Int, $after: String, $last: Int, $before: String, $searchText: String, $sortByContactName: Boolean, $excludeNonActive: Boolean) {
  paginatedContacts(
    first: $first
    after: $after
    before: $before
    last: $last
    searchText: $searchText
    sortByContactName: $sortByContactName
    excludeNonActive: $excludeNonActive
  ) {
    edges {
      node {
        ...ContactForInvoice
      }
    }
    totalCount
    pageInfo {
      startCursor
      endCursor
      hasNextPage
      hasPreviousPage
    }
  }
}
    ${ContactForInvoiceFragmentDoc}`;
export const CreateContactDocumentDocument = gql`
    mutation createContactDocument($createContactDocumentInput: CreateContactDocumentInput!) {
  createContactDocument(createContactDocumentInput: $createContactDocumentInput) {
    uuid
  }
}
    `;
export const CreateInvoiceDocumentsDocument = gql`
    mutation createInvoiceDocuments($createInvoiceDocumentsInput: CreateInvoiceDocumentsInput!) {
  createInvoiceDocuments(
    createInvoiceDocumentsInput: $createInvoiceDocumentsInput
  ) {
    uuid
    bucket
    region
    region
    key
    fileName
    fileType
    type
    invoice {
      uuid
      billToContact {
        uuid
      }
    }
  }
}
    `;
export const DownloadInvoicesDocument = gql`
    mutation downloadInvoices($downloadInvoicesInput: DownloadInvoicesInput!) {
  downloadInvoices(downloadInvoicesInput: $downloadInvoicesInput) {
    combinedDocument {
      ...Document
    }
    zipDocument {
      ...Document
    }
  }
}
    ${DocumentFragmentDoc}`;
export const ExportInvoicesToQuickbooksDesktopDocument = gql`
    mutation exportInvoicesToQuickbooksDesktop($exportInvoicesToQuickbooksInput: ExportInvoicesToQuickbooksInput!) {
  exportInvoicesToQuickbooksDesktop(
    exportInvoicesToQuickbooksInput: $exportInvoicesToQuickbooksInput
  ) {
    invoice {
      id
      name
      amount
    }
    failedInvoiceUuid
    missingFreightChargeMappings
    missingFuelChargeMappings
    missingAccessorialMappings
    missingCustomerName
    missingCustomerUuid
    duplicateInvoiceError
    conductorUserFacingErrors
    success
  }
}
    `;
export const GenerateInvoicePreSignedPutUrlsDocument = gql`
    mutation generateInvoicePreSignedPutUrls($generateInvoicePreSignedPutUrlsInput: GenerateInvoicePreSignedPutUrlsInput!) {
  generateInvoicePreSignedPutUrls(
    generateInvoicePreSignedPutUrlsInput: $generateInvoicePreSignedPutUrlsInput
  ) {
    url
    invoiceUuid
  }
}
    `;
export const AcknowledgeFailedInvoiceSendJobsDocument = gql`
    mutation acknowledgeFailedInvoiceSendJobs($invoiceSendJobBatchUuid: String!) {
  acknowledgeFailedInvoiceSendJobs(
    invoiceSendJobBatchUuid: $invoiceSendJobBatchUuid
  ) {
    uuid
  }
}
    `;
export const InvoiceSendJobBatchesDocument = gql`
    query invoiceSendJobBatches($first: Int, $after: String, $last: Int, $before: String, $sortByCreatedAtAsc: Boolean, $inProgress: Boolean, $hasFailures: Boolean, $createdAtDateFilters: [DateFilter!], $acknowledged: Boolean) {
  invoiceSendJobBatches(
    first: $first
    after: $after
    last: $last
    before: $before
    sortByCreatedAtAsc: $sortByCreatedAtAsc
    inProgress: $inProgress
    hasFailures: $hasFailures
    createdAtDateFilters: $createdAtDateFilters
    acknowledged: $acknowledged
  ) {
    totalCount
    edges {
      node {
        ...InvoiceSendJobBatch
      }
    }
    pageInfo {
      startCursor
      endCursor
      hasNextPage
      hasPreviousPage
    }
  }
}
    ${InvoiceSendJobBatchFragmentDoc}`;
export const InvoiceSendJobsShallowDocument = gql`
    query invoiceSendJobsShallow($first: Int, $after: String, $last: Int, $before: String, $searchText: String, $invoiceSendJobBatchUuid: String!, $invoiceSendJobStatus: InvoiceSendJobStatus) {
  invoiceSendJobs(
    first: $first
    after: $after
    last: $last
    before: $before
    searchText: $searchText
    invoiceSendJobBatchUuid: $invoiceSendJobBatchUuid
    invoiceSendJobStatus: $invoiceSendJobStatus
  ) {
    totalCount
    edges {
      node {
        ...InvoiceSendJobShallow
      }
    }
    pageInfo {
      startCursor
      endCursor
      hasNextPage
      hasPreviousPage
    }
  }
}
    ${InvoiceSendJobShallowFragmentDoc}`;
export const InvoiceSendJobsDocument = gql`
    query invoiceSendJobs($first: Int, $after: String, $last: Int, $before: String, $searchText: String, $invoiceSendJobBatchUuid: String!, $invoiceSendJobStatus: InvoiceSendJobStatus) {
  invoiceSendJobs(
    first: $first
    after: $after
    last: $last
    before: $before
    searchText: $searchText
    invoiceSendJobBatchUuid: $invoiceSendJobBatchUuid
    invoiceSendJobStatus: $invoiceSendJobStatus
  ) {
    totalCount
    edges {
      node {
        ...InvoiceSendJob
      }
    }
    pageInfo {
      startCursor
      endCursor
      hasNextPage
      hasPreviousPage
    }
  }
}
    ${InvoiceSendJobFragmentDoc}`;
export const InvoiceStatsByUuidsDocument = gql`
    query invoiceStatsByUuids($uuids: [String!]!) {
  invoicesByUuids(uuids: $uuids) {
    ...InvoiceStat
  }
}
    ${InvoiceStatFragmentDoc}`;
export const InvoiceTotalDocument = gql`
    query invoiceTotal($uuid: String!) {
  invoice(uuid: $uuid) {
    invoiceTotal
  }
}
    `;
export const InvoiceTotalsDocument = gql`
    query invoiceTotals($uuids: [String!]!) {
  invoicesByUuids(uuids: $uuids) {
    ...InvoiceStat
  }
}
    ${InvoiceStatFragmentDoc}`;
export const InvoiceUuidsForBatchPostDocument = gql`
    query invoiceUuidsForBatchPost($inConsolidatedInvoice: Boolean, $first: Int, $after: String, $last: Int, $before: String, $startDate: DateTime, $endDate: DateTime, $createdAtStartDate: DateTime, $createdAtEndDate: DateTime, $invoiceStartDate: DateTime, $invoiceEndDate: DateTime, $statuses: [InvoiceStatus!], $emailSendStatus: EmailSendStatus, $searchText: String, $billingPartyContactUuid: String, $sortByDueDateAscending: Boolean, $sortByDueDateDescending: Boolean, $groupByContact: Boolean, $uuids: [String!], $isClosed: Boolean, $isSyncedToQuickbooksDesktop: Boolean) {
  invoices(
    inConsolidatedInvoice: $inConsolidatedInvoice
    first: $first
    after: $after
    before: $before
    last: $last
    startDate: $startDate
    endDate: $endDate
    createdAtStartDate: $createdAtStartDate
    createdAtEndDate: $createdAtEndDate
    invoiceStartDate: $invoiceStartDate
    invoiceEndDate: $invoiceEndDate
    statuses: $statuses
    emailSendStatus: $emailSendStatus
    searchText: $searchText
    billingPartyContactUuid: $billingPartyContactUuid
    sortByDueDateAscending: $sortByDueDateAscending
    sortByDueDateDescending: $sortByDueDateDescending
    groupByContact: $groupByContact
    uuids: $uuids
    isClosed: $isClosed
    isSyncedToQuickbooksDesktop: $isSyncedToQuickbooksDesktop
  ) {
    totalCount
    edges {
      node {
        uuid
        status
      }
    }
    pageInfo {
      startCursor
      endCursor
      hasPreviousPage
      hasNextPage
    }
  }
}
    `;
export const InvoiceV2Document = gql`
    query invoiceV2($uuid: String!) {
  invoice(uuid: $uuid) {
    ...ShallowInvoiceWithoutShipments
  }
}
    ${ShallowInvoiceWithoutShipmentsFragmentDoc}`;
export const InvoicesByUuidsForDownloadDocument = gql`
    query invoicesByUuidsForDownload($uuids: [String!]!, $includeDocuments: Boolean!) {
  invoicesByUuids(uuids: $uuids, includeDocuments: $includeDocuments) {
    ...InvoiceForDownloadFragment
  }
}
    ${InvoiceForDownloadFragmentFragmentDoc}`;
export const InvoicesByUuidsDocument = gql`
    query invoicesByUuids($uuids: [String!]!) {
  invoicesByUuids(uuids: $uuids) {
    ...InvoiceFragment
  }
}
    ${InvoiceFragmentFragmentDoc}`;
export const InvoicesForContactDocument = gql`
    query invoicesForContact($inConsolidatedInvoice: Boolean, $first: Int, $after: String, $last: Int, $before: String, $startDate: DateTime, $endDate: DateTime, $createdAtStartDate: DateTime, $createdAtEndDate: DateTime, $invoiceStartDate: DateTime, $invoiceEndDate: DateTime, $statuses: [InvoiceStatus!], $searchText: String, $billingPartyContactUuid: String, $groupByContact: Boolean, $uuids: [String!], $isClosed: Boolean, $emailSendStatus: EmailSendStatus, $hasZeroBalance: Boolean, $sorts: [FindInvoicesSort!]) {
  invoices(
    inConsolidatedInvoice: $inConsolidatedInvoice
    first: $first
    after: $after
    before: $before
    last: $last
    startDate: $startDate
    endDate: $endDate
    createdAtStartDate: $createdAtStartDate
    createdAtEndDate: $createdAtEndDate
    invoiceStartDate: $invoiceStartDate
    invoiceEndDate: $invoiceEndDate
    statuses: $statuses
    searchText: $searchText
    billingPartyContactUuid: $billingPartyContactUuid
    groupByContact: $groupByContact
    uuids: $uuids
    isClosed: $isClosed
    emailSendStatus: $emailSendStatus
    hasZeroBalance: $hasZeroBalance
    sorts: $sorts
  ) {
    totalCount
    edges {
      node {
        ...InvoiceForContact
      }
    }
    pageInfo {
      startCursor
      endCursor
      hasPreviousPage
      hasNextPage
    }
  }
}
    ${InvoiceForContactFragmentDoc}`;
export const InvoicesForInvoiceSelectionDocument = gql`
    query invoicesForInvoiceSelection($first: Int, $after: String, $last: Int, $before: String, $statuses: [InvoiceStatus!], $searchText: String, $billingPartyContactUuid: String) {
  invoices(
    first: $first
    after: $after
    before: $before
    last: $last
    statuses: $statuses
    searchText: $searchText
    billingPartyContactUuid: $billingPartyContactUuid
  ) {
    edges {
      node {
        ...InvoiceForInvoiceSelection
      }
    }
    pageInfo {
      startCursor
      endCursor
      hasPreviousPage
      hasNextPage
    }
  }
}
    ${InvoiceForInvoiceSelectionFragmentDoc}`;
export const InvoicesForRegisterReportDocument = gql`
    query invoicesForRegisterReport($first: Int, $after: String, $invoiceStartDate: DateTime, $invoiceEndDate: DateTime, $statuses: [InvoiceStatus!], $billingPartyContactUuid: String) {
  invoices(
    first: $first
    after: $after
    invoiceStartDate: $invoiceStartDate
    invoiceEndDate: $invoiceEndDate
    statuses: $statuses
    billingPartyContactUuid: $billingPartyContactUuid
  ) {
    totalCount
    edges {
      node {
        ...InvoiceForRegisterReport
      }
    }
    pageInfo {
      startCursor
      endCursor
      hasPreviousPage
      hasNextPage
    }
  }
}
    ${InvoiceForRegisterReportFragmentDoc}`;
export const InvoicesMetadataByUuidsDocument = gql`
    query invoicesMetadataByUuids($uuids: [String!]!) {
  invoicesByUuids(uuids: $uuids) {
    uuid
    name
    billToContact {
      uuid
      displayName
    }
    journalNumber
  }
}
    `;
export const InvoicesWithOrdersDocument = gql`
    query invoicesWithOrders($inConsolidatedInvoice: Boolean, $first: Int, $after: String, $last: Int, $before: String, $startDate: DateTime, $endDate: DateTime, $createdAtStartDate: DateTime, $createdAtEndDate: DateTime, $invoiceStartDate: DateTime, $invoiceEndDate: DateTime, $statuses: [InvoiceStatus!], $searchText: String, $billingPartyContactUuid: String, $groupByContact: Boolean, $uuids: [String!], $isClosed: Boolean, $emailSendStatus: EmailSendStatus, $hasZeroBalance: Boolean, $sorts: [FindInvoicesSort!]) {
  invoices(
    inConsolidatedInvoice: $inConsolidatedInvoice
    first: $first
    after: $after
    before: $before
    last: $last
    startDate: $startDate
    endDate: $endDate
    createdAtStartDate: $createdAtStartDate
    createdAtEndDate: $createdAtEndDate
    invoiceStartDate: $invoiceStartDate
    invoiceEndDate: $invoiceEndDate
    statuses: $statuses
    searchText: $searchText
    billingPartyContactUuid: $billingPartyContactUuid
    groupByContact: $groupByContact
    uuids: $uuids
    isClosed: $isClosed
    emailSendStatus: $emailSendStatus
    hasZeroBalance: $hasZeroBalance
    sorts: $sorts
  ) {
    totalCount
    edges {
      node {
        ...InvoiceForContact
      }
    }
    pageInfo {
      startCursor
      endCursor
      hasPreviousPage
      hasNextPage
    }
  }
}
    ${InvoiceForContactFragmentDoc}`;
export const MoveShipmentsBetweenInvoicesDocument = gql`
    mutation moveShipmentsBetweenInvoices($moveShipmentsBetweenInvoicesInput: MoveShipmentsBetweenInvoicesInput!) {
  moveShipmentsBetweenInvoices(
    moveShipmentsBetweenInvoicesInput: $moveShipmentsBetweenInvoicesInput
  ) {
    ... on MoveShipmentsBetweenInvoicesSuccessOutput {
      newInvoiceUuid
      movedShipmentUuids
    }
    ... on MoveShipmentsBetweenInvoicesIncompleteOperationOutput {
      inputShipmentUuids
      additionalShipmentUuidsToMove
      missingOrders {
        uuid
        name
      }
    }
    ... on MutationErrorOutput {
      message
    }
  }
}
    `;
export const MoveShipmentsToInvoiceDocument = gql`
    mutation moveShipmentsToInvoice($moveShipmentsToInvoiceInput: MoveShipmentsToInvoiceInput!) {
  moveShipmentsToInvoice(
    moveShipmentsToInvoiceInput: $moveShipmentsToInvoiceInput
  ) {
    errors
  }
}
    `;
export const NetSalesSummaryReportDocument = gql`
    query netSalesSummaryReport($netSalesSummaryReportInput: NetSalesSummaryReportInput!) {
  netSalesSummaryReport(netSalesSummaryReportInput: $netSalesSummaryReportInput) {
    contactRows {
      contactUuid
      contactName
      pieces
      weight
      dimWeight
      openInvoiesTotalInCents
      adjustmentsInCents
      netSalesInCents
    }
    reportTotal {
      contactUuid
      contactName
      pieces
      weight
      dimWeight
      openInvoiesTotalInCents
      adjustmentsInCents
      netSalesInCents
    }
  }
}
    `;
export const PaginatedOrdersByInvoiceDocument = gql`
    query paginatedOrdersByInvoice($first: Int, $after: String, $last: Int, $before: String, $invoiceUuid: String!, $searchText: String, $sortByShipperBillOfLadingNumberAsc: Boolean, $sorts: [FindOrdersOnInvoiceSort!]) {
  paginatedOrdersByInvoice(
    first: $first
    after: $after
    last: $last
    before: $before
    invoiceUuid: $invoiceUuid
    searchText: $searchText
    sortByShipperBillOfLadingNumberAsc: $sortByShipperBillOfLadingNumberAsc
    sorts: $sorts
  ) {
    totalCount
    edges {
      node {
        ...InvoiceOrderWithShipments
      }
    }
    pageInfo {
      startCursor
      endCursor
      hasNextPage
      hasPreviousPage
    }
  }
}
    ${InvoiceOrderWithShipmentsFragmentDoc}`;
export const AllInvoicesForPaymentApplicationDocument = gql`
    query allInvoicesForPaymentApplication($billingPartyContactUuid: String, $masterAccountUuid: String) {
  invoices(
    billingPartyContactUuid: $billingPartyContactUuid
    masterAccountUuid: $masterAccountUuid
  ) {
    edges {
      node {
        uuid
        name
        journalNumber
      }
    }
  }
}
    `;
export const AverageDaysToPayReportDocument = gql`
    query averageDaysToPayReport {
  averageDaysToPayReport {
    ...AverageDaysToPayReportData
  }
}
    ${AverageDaysToPayReportDataFragmentDoc}`;
export const ContactBalancesByOrderUuidDocument = gql`
    query contactBalancesByOrderUuid($uuid: String!) {
  order(uuid: $uuid) {
    uuid
    billingPartyContact {
      ...ContactWithBalances
    }
    standardOrderFields {
      shipperBillOfLadingNumber
    }
  }
}
    ${ContactWithBalancesFragmentDoc}`;
export const ContactBalancesDocument = gql`
    query contactBalances($uuid: String!) {
  contact(uuid: $uuid) {
    ...ContactWithBalances
  }
}
    ${ContactWithBalancesFragmentDoc}`;
export const CreatePaymentDocument = gql`
    mutation createPayment($createPaymentInput: CreatePaymentInput!) {
  createPayment(createPaymentInput: $createPaymentInput) {
    uuid
  }
}
    `;
export const DeletePaymentDocument = gql`
    mutation deletePayment($uuid: String!) {
  deletePayment(uuid: $uuid) {
    uuid
  }
}
    `;
export const EditPaymentAmountDocument = gql`
    mutation editPaymentAmount($editPaymentAmount: EditPaymentAmountInput!) {
  editPaymentAmount(editPaymentAmount: $editPaymentAmount) {
    uuid
  }
}
    `;
export const OrderAmountsToPayForInvoiceDocument = gql`
    query orderAmountsToPayForInvoice($invoiceUuids: [String!]!, $amountInCents: Float!) {
  orderAmountsToPayForInvoice(
    invoiceUuids: $invoiceUuids
    amountInCents: $amountInCents
  ) {
    amountInCents
    orderUuid
    invoiceUuid
    lineBalanceInCents
    orderTotalInCents
    currentBalanceInCents
  }
}
    `;
export const OrdersByUuidsForPaymentStatsDocument = gql`
    query ordersByUuidsForPaymentStats($uuids: [String!]!) {
  ordersByUuids(uuids: $uuids) {
    uuid
    invoice {
      balanceInCents
      invoiceTotal
    }
  }
}
    `;
export const OrdersForPaymentsDocument = gql`
    query ordersForPayments($contactUuid: String!, $first: Int, $after: String, $last: Int, $before: String, $searchText: String, $invoiceUuid: String, $invoiceStartDate: DateTime, $invoiceEndDate: DateTime, $filterOutZeroBalance: Boolean, $currentPaymentUuid: String, $includeTotalCount: Boolean, $includeTotalCountsByInvoice: Boolean, $groupOrdersBy: GroupOrdersForPaymentsBy, $sorts: [OrdersForPaymentsSort!]) {
  ordersForPayments(
    contactUuid: $contactUuid
    first: $first
    last: $last
    after: $after
    before: $before
    searchText: $searchText
    invoiceUuid: $invoiceUuid
    invoiceStartDate: $invoiceStartDate
    invoiceEndDate: $invoiceEndDate
    filterOutZeroBalance: $filterOutZeroBalance
    currentPaymentUuid: $currentPaymentUuid
    includeTotalCount: $includeTotalCount
    includeTotalCountsByInvoice: $includeTotalCountsByInvoice
    groupOrdersBy: $groupOrdersBy
    sorts: $sorts
  ) {
    totalCount
    groupedCountsByInvoice {
      groupUuid
      count
    }
    edges {
      node {
        ...OrdersForPayment
      }
    }
    pageInfo {
      startCursor
      endCursor
      hasNextPage
      hasPreviousPage
    }
  }
}
    ${OrdersForPaymentFragmentDoc}`;
export const OutstandingInvoicesForCustomerDocument = gql`
    query outstandingInvoicesForCustomer($contactUuid: String!) {
  outstandingInvoicesForCustomer(contactUuid: $contactUuid) {
    journalNumber
    name
  }
}
    `;
export const PaymentByUuidDocument = gql`
    query paymentByUuid($uuid: String!) {
  paymentByUuid(uuid: $uuid) {
    uuid
    amountInCents
    comment
    referenceNumber
    paymentType
    paymentRail
    date
    glTerminal {
      uuid
      name
    }
    creditType {
      uuid
      name
    }
    paymentToOrderMappings {
      amountInCents
      order {
        invoice {
          uuid
        }
        uuid
      }
    }
  }
}
    `;
export const PaymentsByContactUuidDocument = gql`
    query paymentsByContactUuid($args: FindPaymentsV2Args!) {
  paymentsV2(args: $args) {
    edges {
      node {
        ...Payment
      }
      cursor
    }
    pageInfo {
      startCursor
      endCursor
      hasNextPage
      hasPreviousPage
    }
    totalCount
  }
}
    ${PaymentFragmentDoc}`;
export const PaymentsByInvoiceUuidDocument = gql`
    query paymentsByInvoiceUuid($uuid: String!) {
  paymentsByInvoiceUuid(uuid: $uuid) {
    ...PaymentForInvoice
  }
}
    ${PaymentForInvoiceFragmentDoc}`;
export const PaymentsForCheckRegisterReportOldDocument = gql`
    query paymentsForCheckRegisterReportOld($args: FindPaymentsV2Args!) {
  paymentsV2(args: $args) {
    edges {
      node {
        ...PaymentForReport
      }
      cursor
    }
  }
}
    ${PaymentForReportFragmentDoc}`;
export const PaymentsForCheckRegisterReportDocument = gql`
    query paymentsForCheckRegisterReport($args: FindPaymentsV2Args!) {
  checkRegisterReport(args: $args) {
    ...PaymentForCheckRegisterReport
  }
}
    ${PaymentForCheckRegisterReportFragmentDoc}`;
export const UpdatePaymentDocument = gql`
    mutation updatePayment($updatePaymentInput: UpdatePaymentInput!) {
  updatePayment(updatePaymentInput: $updatePaymentInput) {
    uuid
  }
}
    `;
export const PreviewBatchAddShipmentsToInvoicesMultipleDocument = gql`
    query previewBatchAddShipmentsToInvoicesMultiple($batchAddShipmentsToInvoicesInputMultiple: BatchAddShipmentsToInvoicesInputMultiple!) {
  previewBatchAddShipmentsToInvoicesMultiple(
    batchAddShipmentsToInvoicesInputMultiple: $batchAddShipmentsToInvoicesInputMultiple
  ) {
    ...BatchAddShipmentsToInvoicesPreview
  }
}
    ${BatchAddShipmentsToInvoicesPreviewFragmentDoc}`;
export const OutstandingOrderDocument = gql`
    query outstandingOrder($uuid: String!) {
  standardOrder(uuid: $uuid) {
    ...OutstandingOrderFragment
  }
}
    ${OutstandingOrderFragmentFragmentDoc}`;
export const AddQuickbooksDesktopCustomersDocument = gql`
    mutation addQuickbooksDesktopCustomers($contactUuids: [String!]!) {
  addQuickbooksDesktopCustomers(contactUuids: $contactUuids) {
    quickbooksDesktopObjects {
      id
      name
    }
    error
  }
}
    `;
export const GetInvoiceCsvsDocument = gql`
    query getInvoiceCsvs($getInvoiceCsvsInput: GetInvoiceCsvsInput!) {
  getInvoiceCsvs(getInvoiceCsvsInput: $getInvoiceCsvsInput) {
    csvItems
    missingCustomerMappings
    missingFreightChargeMappings
    missingFuelChargeMappings
    missingAccessorialMappings
  }
}
    `;
export const InvoicesByUuidsForQuickbooksDocument = gql`
    query invoicesByUuidsForQuickbooks($uuids: [String!]!) {
  invoicesByUuids(uuids: $uuids) {
    ...InvoiceForQuickbooks
  }
}
    ${InvoiceForQuickbooksFragmentDoc}`;
export const CompleteRebillDocument = gql`
    mutation completeRebill($completeRebillInput: CompleteRebillInput!) {
  completeRebill(completeRebillInput: $completeRebillInput) {
    invoiceForRebill {
      uuid
      name
    }
  }
}
    `;
export const CreateDuplicateOrderForRebillDocument = gql`
    mutation createDuplicateOrderForRebill($input: CreateDuplicateOrderForRebillInput!) {
  createDuplicateOrderForRebill(createDuplicateOrderForRebillInput: $input) {
    duplicatedOrder {
      uuid
    }
  }
}
    `;
export const OrderForRebillDocument = gql`
    query orderForRebill($uuid: String!) {
  order(uuid: $uuid) {
    name
    totalCharge
    invoice {
      name
      billToContact {
        uuid
      }
    }
  }
}
    `;
export const RemoveInvoiceDocument = gql`
    mutation removeInvoice($uuid: String!) {
  removeInvoice(uuid: $uuid) {
    uuid
  }
}
    `;
export const RemoveShipmentsFromInvoiceDocument = gql`
    mutation removeShipmentsFromInvoice($removeShipmentsFromInvoiceInput: RemoveShipmentsFromInvoiceInput!) {
  removeShipmentsFromInvoice(
    removeShipmentsFromInvoiceInput: $removeShipmentsFromInvoiceInput
  ) {
    uuid
  }
}
    `;
export const AccessorialChargeDetailsReportDocument = gql`
    query accessorialChargeDetailsReport($args: AccessorialChargeDetailsReportArgs!) {
  accessorialChargeDetailsReport(args: $args) {
    ...AccessorialChargeDetailsData
  }
}
    ${AccessorialChargeDetailsDataFragmentDoc}`;
export const AccountsReceivableReportDocument = gql`
    query accountsReceivableReport($args: AccountsReceivableReportArgs!) {
  accountsReceivableReport(args: $args) {
    ...AccountsReceivableData
  }
}
    ${AccountsReceivableDataFragmentDoc}`;
export const AgingReportDocument = gql`
    query agingReport($args: InvoiceAgingReportArgs!) {
  agingReport(args: $args) {
    ...AgingReportData
  }
}
    ${AgingReportDataFragmentDoc}`;
export const ChargeBreakdownReportCsvDocument = gql`
    query chargeBreakdownReportCsv($input: ChargeBreakdownReportInput) {
  chargeBreakdownReportCsv(input: $input) {
    url
    fileName
    errors
  }
}
    `;
export const ChargeBreakdownReportPdfDocument = gql`
    query chargeBreakdownReportPdf($input: ChargeBreakdownReportInput) {
  chargeBreakdownReportPdf(input: $input) {
    url
    fileName
    errors
  }
}
    `;
export const PaymentForMemoReportDocument = gql`
    query paymentForMemoReport($uuid: String!) {
  paymentByUuid(uuid: $uuid) {
    ...PaymentForMemoReport
  }
}
    ${PaymentForMemoReportFragmentDoc}`;
export const DriverDailyLogReportPdfDocument = gql`
    query driverDailyLogReportPdf($driverDailyLogReportPdfInput: DriverDailyLogReportPdfInput!) {
  driverDailyLogReportPdf(
    driverDailyLogReportPdfInput: $driverDailyLogReportPdfInput
  ) {
    url
    fileName
    errors
  }
}
    `;
export const EmailAccountingReportDocument = gql`
    mutation emailAccountingReport($emailAccountingReportInput: EmailAccountingReportInput!) {
  emailAccountingReport(emailAccountingReportInput: $emailAccountingReportInput) {
    status
  }
}
    `;
export const IncomeAnalysisReportDocument = gql`
    query incomeAnalysisReport($args: IncomeAnalysisReportArgs!) {
  incomeAnalysisReport(args: $args) {
    ...CustomerReportBucket
  }
}
    ${CustomerReportBucketFragmentDoc}`;
export const InvoiceBillingSummaryReportV2PdfUrlDocument = gql`
    query invoiceBillingSummaryReportV2PdfUrl($invoiceBillingSummaryV2Input: InvoiceBillingSummaryV2Input!) {
  invoiceBillingSummaryReportV2PdfUrl(
    invoiceBillingSummaryV2Input: $invoiceBillingSummaryV2Input
  )
}
    `;
export const InvoiceBillingSummaryReportV2PdfDocument = gql`
    query invoiceBillingSummaryReportV2Pdf($invoiceBillingSummaryV2Input: InvoiceBillingSummaryV2Input!) {
  invoiceBillingSummaryReportV2Pdf(
    invoiceBillingSummaryV2Input: $invoiceBillingSummaryV2Input
  ) {
    url
    fileName
  }
}
    `;
export const InvoiceBillingSummaryReportV2Document = gql`
    query invoiceBillingSummaryReportV2($invoiceBillingSummaryV2Input: InvoiceBillingSummaryV2Input!) {
  invoiceBillingSummaryReportV2(
    invoiceBillingSummaryV2Input: $invoiceBillingSummaryV2Input
  ) {
    ...InvoiceBillingSummaryReportV2
  }
}
    ${InvoiceBillingSummaryReportV2FragmentDoc}`;
export const OpenInvoiceReportDocument = gql`
    query openInvoiceReport($openInvoiceReportArgs: OpenInvoiceReportArgs!) {
  openInvoiceReport(openInvoiceReportArgs: $openInvoiceReportArgs) {
    ...InvoiceForOpenInvoiceReport
  }
}
    ${InvoiceForOpenInvoiceReportFragmentDoc}`;
export const InvoiceForOrderSummaryReportDocument = gql`
    query invoiceForOrderSummaryReport($uuid: String!) {
  invoice(uuid: $uuid) {
    ...InvoiceForOrderSummaryReport
  }
}
    ${InvoiceForOrderSummaryReportFragmentDoc}`;
export const InvoicesForOrderSummaryReportDocument = gql`
    query invoicesForOrderSummaryReport($uuids: [String!]!) {
  invoicesByUuids(uuids: $uuids) {
    ...InvoiceForOrderSummaryReport
  }
}
    ${InvoiceForOrderSummaryReportFragmentDoc}`;
export const PaymentApplicationReportDocument = gql`
    query paymentApplicationReport($args: FindPaymentsV2Args!) {
  paymentApplicationReport(args: $args) {
    ...PaymentForPaymentApplicationReport
  }
}
    ${PaymentForPaymentApplicationReportFragmentDoc}`;
export const PaymentsForJournalReportDocument = gql`
    query paymentsForJournalReport($args: FindPaymentsV2Args!) {
  paymentsV2(args: $args) {
    edges {
      node {
        ...PaymentForJournalReportOld
      }
      cursor
    }
  }
}
    ${PaymentForJournalReportOldFragmentDoc}`;
export const PaymentJournalReportDocument = gql`
    query paymentJournalReport($args: FindPaymentsV2Args!) {
  paymentJournalReport(args: $args) {
    ...PaymentForJournalReport
  }
}
    ${PaymentForJournalReportFragmentDoc}`;
export const UnappliedPaymentsReportDocument = gql`
    query unappliedPaymentsReport($input: UnappliedPaymentReportCsvInput!) {
  unappliedPaymentReportCsv(unappliedPaymentReportCsvInput: $input) {
    url
    fileName
    errors
  }
}
    `;
export const SendInvoicesDocument = gql`
    mutation sendInvoices($sendInvoicesInput: SendInvoicesInput!) {
  sendInvoices(sendInvoicesInput: $sendInvoicesInput) {
    ...InvoiceSendJobBatch
  }
}
    ${InvoiceSendJobBatchFragmentDoc}`;
export const ShallowInvoicesByUuidsDocument = gql`
    query shallowInvoicesByUuids($uuids: [String!]!) {
  invoicesByUuids(uuids: $uuids) {
    ...ShallowInvoiceWithoutShipments
  }
}
    ${ShallowInvoiceWithoutShipmentsFragmentDoc}`;
export const InvoiceUuidsDocument = gql`
    query invoiceUuids($inConsolidatedInvoice: Boolean, $first: Int, $after: String, $last: Int, $before: String, $startDate: DateTime, $endDate: DateTime, $createdAtStartDate: DateTime, $createdAtEndDate: DateTime, $invoiceStartDate: DateTime, $invoiceEndDate: DateTime, $statuses: [InvoiceStatus!], $searchText: String, $billingPartyContactUuid: String, $groupByContact: Boolean, $uuids: [String!], $isClosed: Boolean, $emailSendStatus: EmailSendStatus, $isSyncedToQuickbooksDesktop: Boolean, $sorts: [FindInvoicesSort!]) {
  invoices(
    inConsolidatedInvoice: $inConsolidatedInvoice
    first: $first
    after: $after
    before: $before
    last: $last
    startDate: $startDate
    endDate: $endDate
    createdAtStartDate: $createdAtStartDate
    createdAtEndDate: $createdAtEndDate
    invoiceStartDate: $invoiceStartDate
    invoiceEndDate: $invoiceEndDate
    statuses: $statuses
    searchText: $searchText
    billingPartyContactUuid: $billingPartyContactUuid
    groupByContact: $groupByContact
    uuids: $uuids
    isClosed: $isClosed
    emailSendStatus: $emailSendStatus
    isSyncedToQuickbooksDesktop: $isSyncedToQuickbooksDesktop
    sorts: $sorts
  ) {
    totalCount
    edges {
      node {
        uuid
        status
      }
    }
    pageInfo {
      startCursor
      endCursor
      hasPreviousPage
      hasNextPage
    }
  }
}
    `;
export const ShallowInvoicesV2Document = gql`
    query shallowInvoicesV2($inConsolidatedInvoice: Boolean, $first: Int, $after: String, $last: Int, $before: String, $startDate: DateTime, $endDate: DateTime, $createdAtStartDate: DateTime, $createdAtEndDate: DateTime, $invoiceStartDate: DateTime, $invoiceEndDate: DateTime, $statuses: [InvoiceStatus!], $searchText: String, $billingPartyContactUuid: String, $groupByContact: Boolean, $uuids: [String!], $isClosed: Boolean, $emailSendStatus: EmailSendStatus, $isSyncedToQuickbooksDesktop: Boolean, $sorts: [FindInvoicesSort!]) {
  invoices(
    inConsolidatedInvoice: $inConsolidatedInvoice
    first: $first
    after: $after
    before: $before
    last: $last
    startDate: $startDate
    endDate: $endDate
    createdAtStartDate: $createdAtStartDate
    createdAtEndDate: $createdAtEndDate
    invoiceStartDate: $invoiceStartDate
    invoiceEndDate: $invoiceEndDate
    statuses: $statuses
    searchText: $searchText
    billingPartyContactUuid: $billingPartyContactUuid
    groupByContact: $groupByContact
    uuids: $uuids
    isClosed: $isClosed
    emailSendStatus: $emailSendStatus
    isSyncedToQuickbooksDesktop: $isSyncedToQuickbooksDesktop
    sorts: $sorts
  ) {
    totalCount
    edges {
      node {
        ...ShallowInvoiceV2
      }
    }
    pageInfo {
      startCursor
      endCursor
      hasPreviousPage
      hasNextPage
    }
  }
}
    ${ShallowInvoiceV2FragmentDoc}`;
export const TypeaheadOrderUuidsQueryDocument = gql`
    query typeaheadOrderUuidsQuery($addressCityFilter: StringFilter, $addressZipFilter: StringFilter, $attemptedAtDateFilters: DateFilterStartEnd, $completionDateFilters: DateFilterStartEnd, $deadlineDateFilters: DateFilterStartEnd, $receivedDateFilters: DateFilterStartEnd, $createdAtDateFilters: DateFilterStartEnd, $expectedInboundArrivalDateFilters: DateFilterStartEnd, $scheduledAtDateFilters: DateFilterStartEnd, $primaryAppointmentDateFilters: DateFilterStartEnd, $orderNumberFilter: StringFilter, $billingPartyContactUuidFilter: StringFilter, $driverUuidFilter: StringFilter, $shipperFilter: StringFilter, $consigneeFilter: StringFilter, $statusFilters: [StatusFilter!], $shipmentStatusFilters: [ShipmentStatusFilter!], $first: Int, $after: String, $last: Int, $before: String, $searchText: String, $multipleSearches: [String!], $scheduledFilter: BooleanFilter, $outForDeliveryFilter: BooleanFilter, $onHand: BooleanFilter, $onInvoice: BooleanFilter, $isCancelled: BooleanFilter, $isRefused: BooleanFilter, $isFinalized: BooleanFilter, $isPicked: BooleanFilter, $isOsd: BooleanFilter, $isSpecial: BooleanFilter, $orderSource: OrderSource, $noMaximum: Boolean, $hasAppointmentScheduled: BooleanFilter, $appointmentRequired: BooleanFilter, $hasContactInformation: BooleanFilter, $hasFailures: BooleanFilter, $hasRoute: BooleanFilter, $hideFromBilling: BooleanFilter, $paperworkComplete: BooleanFilter, $pickupOrDelivery: PickupOrDelivery, $isPickupOrDelivery: BooleanFilter, $inboundNotArrived: BooleanFilter, $requiresRouting: BooleanFilter, $requiresRecovery: BooleanFilter, $serviceUuids: [String!], $showConsolidatedOrders: BooleanFilter, $standardStopType: StandardStopType, $stopTypesFilter: StopTypesFilter, $tagUuids: [String!], $totalCount: Boolean, $transferPending: BooleanFilter, $uuids: [String!], $searchRefNumbersOnly: Boolean, $searchMiscInfoOnly: Boolean, $useMultiSearch: Boolean, $sortByCustomerNameAscending: Boolean, $versionId: Float) {
  orders(
    first: $first
    last: $last
    after: $after
    before: $before
    addressCityFilter: $addressCityFilter
    addressZipFilter: $addressZipFilter
    attemptedAtDateFilters: $attemptedAtDateFilters
    billingPartyContactUuidFilter: $billingPartyContactUuidFilter
    driverUuidFilter: $driverUuidFilter
    completionDateFilters: $completionDateFilters
    deadlineDateFilters: $deadlineDateFilters
    receivedDateFilters: $receivedDateFilters
    createdAtDateFilters: $createdAtDateFilters
    scheduledAtDateFilters: $scheduledAtDateFilters
    primaryAppointmentDateFilters: $primaryAppointmentDateFilters
    expectedInboundArrivalDateFilters: $expectedInboundArrivalDateFilters
    consigneeFilter: $consigneeFilter
    hasAppointmentScheduled: $hasAppointmentScheduled
    appointmentRequired: $appointmentRequired
    hasContactInformation: $hasContactInformation
    hasFailures: $hasFailures
    hasRoute: $hasRoute
    hideFromBilling: $hideFromBilling
    noMaximum: $noMaximum
    orderNumberFilter: $orderNumberFilter
    onHand: $onHand
    onInvoice: $onInvoice
    isCancelled: $isCancelled
    isRefused: $isRefused
    isFinalized: $isFinalized
    isPicked: $isPicked
    isOsd: $isOsd
    multipleSearches: $multipleSearches
    isSpecial: $isSpecial
    orderSource: $orderSource
    outForDeliveryFilter: $outForDeliveryFilter
    paperworkComplete: $paperworkComplete
    pickupOrDelivery: $pickupOrDelivery
    isPickupOrDelivery: $isPickupOrDelivery
    inboundNotArrived: $inboundNotArrived
    requiresRouting: $requiresRouting
    requiresRecovery: $requiresRecovery
    scheduledFilter: $scheduledFilter
    searchText: $searchText
    serviceUuids: $serviceUuids
    showConsolidatedOrders: $showConsolidatedOrders
    shipperFilter: $shipperFilter
    statusFilters: $statusFilters
    shipmentStatusFilters: $shipmentStatusFilters
    standardStopType: $standardStopType
    stopTypesFilter: $stopTypesFilter
    tagUuids: $tagUuids
    transferPending: $transferPending
    totalCount: $totalCount
    uuids: $uuids
    searchRefNumbersOnly: $searchRefNumbersOnly
    searchMiscInfoOnly: $searchMiscInfoOnly
    useMultiSearch: $useMultiSearch
    sortByCustomerNameAscending: $sortByCustomerNameAscending
    versionId: $versionId
  ) {
    versionId
    edges {
      node {
        ...TypeAheadOrder
      }
    }
    pageInfo {
      startCursor
      endCursor
      hasNextPage
      hasPreviousPage
    }
  }
}
    ${TypeAheadOrderFragmentDoc}`;
export const OrderRevenueReportDocument = gql`
    query orderRevenueReport($orderRevenueReportInput: OrderRevenueReportInput!) {
  orderRevenueReport(orderRevenueReportInput: $orderRevenueReportInput) {
    edges {
      node {
        ...RevenueReportOrderData
      }
    }
    pageInfo {
      startCursor
      endCursor
      hasPreviousPage
      hasNextPage
    }
  }
}
    ${RevenueReportOrderDataFragmentDoc}`;
export const UnpostInvoiceDocument = gql`
    mutation unpostInvoice($unpostInvoiceInput: UnpostInvoiceInput!) {
  unpostInvoice(unpostInvoiceInput: $unpostInvoiceInput) {
    success
  }
}
    `;
export const CreateItemDocument = gql`
    mutation createItem($input: CreateItemInput!) {
  createItem(createItemInput: $input) {
    item {
      ...ShallowItem
    }
    error
  }
}
    ${ShallowItemFragmentDoc}`;
export const ContactItemsDocument = gql`
    query contactItems($findContactItemsInput: FindContactItemsInput!) {
  contactItems(findContactItemsInput: $findContactItemsInput) {
    items {
      ...ContactItemsItem
    }
  }
}
    ${ContactItemsItemFragmentDoc}`;
export const ItemInventorySummaryDocument = gql`
    query itemInventorySummary($contactUuid: String, $warehouseUuid: String) {
  items(contactUuid: $contactUuid, warehouseUuid: $warehouseUuid) {
    edges {
      node {
        uuid
        sku
        description
        quantity
        storageUnitsCount
        contact {
          uuid
          displayName
        }
        warehouse {
          uuid
          name
        }
        storageOrders {
          uuid
          referenceNumber
        }
      }
    }
  }
}
    `;
export const ItemDocument = gql`
    query item($itemUuid: String!) {
  item(itemUuid: $itemUuid) {
    uuid
    sku
    description
    status
    contact {
      uuid
    }
    warehouse {
      uuid
      name
    }
    primaryUOM {
      uuid
      unitOfMeasure
      upcCode
    }
    secondaryUOM {
      uuid
      unitOfMeasure
      upcCode
      primaryUnitsPerSecondaryUOM
    }
    itemStorageUnitConfig {
      uuid
      type
      length
      width
      height
      weight
      consolidationUnitUOM
      primaryUnitsPerConsolidationUnit
      weightUOM
      dimensionsUOM
      tie
      high
    }
  }
}
    `;
export const ItemsBySkuNameDocument = gql`
    query itemsBySkuName($contactUuid: String, $sku: String!) {
  itemsBySkuName(contactUuid: $contactUuid, sku: $sku) {
    ...ShallowItem
  }
}
    ${ShallowItemFragmentDoc}`;
export const ShallowItemsDocument = gql`
    query shallowItems($contactUuid: String!, $first: Int, $after: String, $last: Int, $before: String, $searchText: String, $warehouseUuid: String) {
  items(
    contactUuid: $contactUuid
    first: $first
    after: $after
    last: $last
    before: $before
    searchText: $searchText
    warehouseUuid: $warehouseUuid
  ) {
    edges {
      node {
        ...ShallowItem
      }
    }
    pageInfo {
      startCursor
      endCursor
      hasNextPage
      hasPreviousPage
    }
  }
}
    ${ShallowItemFragmentDoc}`;
export const UpdateItemDocument = gql`
    mutation updateItem($input: UpdateItemInput!) {
  updateItem(updateItemInput: $input) {
    ...ShallowItem
  }
}
    ${ShallowItemFragmentDoc}`;
export const GenerateLabelDocument = gql`
    mutation generateLabel($generateLabelInput: GenerateLabelInput!) {
  generateLabel(generateLabelInput: $generateLabelInput)
}
    `;
export const AddOrdersToManifestV2Document = gql`
    mutation addOrdersToManifestV2($addOrdersToManifestV2Input: AddOrdersToManifestV2Input!) {
  addOrdersToManifestV2(input: $addOrdersToManifestV2Input) {
    __typename
    ... on AddOrdersToManifestV2PreviousManifestErrorOutput {
      previousManifestErrors {
        order {
          name
          endStop {
            terminal {
              name
            }
          }
        }
      }
      originTerminalMismatchErrors {
        order {
          name
        }
      }
    }
    ... on AddOrdersToManifestV2SuccessOutput {
      lineHaulManifest {
        ...DetailedLineHaulManifest
      }
    }
    ... on MutationErrorOutput {
      message
    }
  }
}
    ${DetailedLineHaulManifestFragmentDoc}`;
export const AddOrdersToManifestDocument = gql`
    mutation addOrdersToManifest($addOrdersToManifestInput: AddOrdersToManifestInput!) {
  addOrdersToManifest(addOrdersToManifestInput: $addOrdersToManifestInput) {
    lineHaulManifest {
      ...DetailedLineHaulManifest
    }
    errorMessage
  }
}
    ${DetailedLineHaulManifestFragmentDoc}`;
export const CreateLineHaulManifestDocument = gql`
    mutation createLineHaulManifest($createLineHaulManifestInput: CreateLineHaulManifestInput!) {
  createLineHaulManifest(
    createLineHaulManifestInput: $createLineHaulManifestInput
  ) {
    ...DetailedLineHaulManifest
  }
}
    ${DetailedLineHaulManifestFragmentDoc}`;
export const CreateLineHaulManifestsDocument = gql`
    mutation createLineHaulManifests($input: CreateLineHaulManifestsInput!) {
  createLineHaulManifests(input: $input) {
    __typename
    ... on MutationErrorOutput {
      message
    }
    ... on CreateLineHaulManifestsSuccessOutput {
      lineHaulManifests {
        uuid
      }
    }
  }
}
    `;
export const GetLineHaulProgressDocument = gql`
    query getLineHaulProgress($getLineHaulProgressInput: GetLineHaulProgressInput!) {
  getLineHaulProgress(getLineHaulProgressInput: $getLineHaulProgressInput) {
    terminalStatuses {
      ...TerminalLineHaulStatus
    }
  }
}
    ${TerminalLineHaulStatusFragmentDoc}`;
export const LineHaulManifestGroupsDocument = gql`
    query LineHaulManifestGroups($input: LineHaulManifestsGroupsInput!) {
  lineHaulManifestsGroups(input: $input) {
    category
    groups {
      category
      manifests {
        ...DetailedLineHaulManifest
      }
    }
  }
}
    ${DetailedLineHaulManifestFragmentDoc}`;
export const LineHaulManifestDocument = gql`
    query lineHaulManifest($uuid: String!) {
  lineHaulManifest(uuid: $uuid) {
    ...DetailedLineHaulManifest
  }
}
    ${DetailedLineHaulManifestFragmentDoc}`;
export const LineHaulManifestsForPrintDocument = gql`
    query lineHaulManifestsForPrint($date: DateTime!, $uuids: [String!]) {
  lineHaulManifests(date: $date, uuids: $uuids) {
    lineHaulManifests {
      ...LineHaulManifestForPrint
    }
  }
}
    ${LineHaulManifestForPrintFragmentDoc}`;
export const LineHaulManifestsDocument = gql`
    query lineHaulManifests($date: DateTime!, $uuids: [String!]) {
  lineHaulManifests(date: $date, uuids: $uuids) {
    lineHaulManifests {
      ...DetailedLineHaulManifest
    }
    unmanifestedSegments {
      ...ShallowLineHaulSegment
    }
  }
}
    ${DetailedLineHaulManifestFragmentDoc}
${ShallowLineHaulSegmentFragmentDoc}`;
export const LineHaulOrdersWithUpcomingSegmentAndInboundStopStatusDocument = gql`
    query lineHaulOrdersWithUpcomingSegmentAndInboundStopStatus($uuids: [String!]!) {
  ordersByUuids(uuids: $uuids) {
    ...LineHaulOrderWithUpcomingSegmentAndInboundStopStatus
  }
}
    ${LineHaulOrderWithUpcomingSegmentAndInboundStopStatusFragmentDoc}`;
export const LineHaulSegmentsDocument = gql`
    query lineHaulSegments {
  lineHaulSegments {
    ...ShallowLineHaulSegment
  }
}
    ${ShallowLineHaulSegmentFragmentDoc}`;
export const MarkManifestAsArrivedDocument = gql`
    mutation markManifestAsArrived($markManifestAsArrivedInput: MarkManifestAsArrivedInput!) {
  markManifestAsArrived(markManifestAsArrivedInput: $markManifestAsArrivedInput) {
    lineHaulManifest {
      ...DetailedLineHaulManifest
    }
    errorMessage
  }
}
    ${DetailedLineHaulManifestFragmentDoc}`;
export const MarkManifestAsDepartedDocument = gql`
    mutation markManifestAsDeparted($markManifestAsDepartedInput: MarkManifestAsDepartedInput!) {
  markManifestAsDeparted(
    markManifestAsDepartedInput: $markManifestAsDepartedInput
  ) {
    lineHaulManifest {
      ...DetailedLineHaulManifest
    }
    errorMessage
  }
}
    ${DetailedLineHaulManifestFragmentDoc}`;
export const MarkManifestAsPlanningDocument = gql`
    mutation markManifestAsPlanning($markManifestAsPlanningInput: MarkManifestAsPlanningInput!) {
  markManifestAsPlanning(
    markManifestAsPlanningInput: $markManifestAsPlanningInput
  ) {
    lineHaulManifest {
      ...DetailedLineHaulManifest
    }
    errorMessage
  }
}
    ${DetailedLineHaulManifestFragmentDoc}`;
export const RemoveLineHaulManifestDocument = gql`
    mutation removeLineHaulManifest($uuid: String!) {
  removeLineHaulManifest(uuid: $uuid)
}
    `;
export const RemoveOrdersFromManifestV2Document = gql`
    mutation removeOrdersFromManifestV2($input: RemoveOrdersFromManifestV2Input!) {
  removeOrdersFromManifestV2(input: $input) {
    ... on RemoveOrdersFromManifestV2SuccessOutput {
      __typename
    }
    ... on MutationErrorOutput {
      __typename
      message
    }
  }
}
    `;
export const RemoveOrdersFromManifestDocument = gql`
    mutation removeOrdersFromManifest($removeOrdersFromManifestInput: RemoveOrdersFromManifestInput!) {
  removeOrdersFromManifest(
    removeOrdersFromManifestInput: $removeOrdersFromManifestInput
  ) {
    lineHaulManifest {
      ...DetailedLineHaulManifest
    }
    errorMessage
  }
}
    ${DetailedLineHaulManifestFragmentDoc}`;
export const SegmentedLineHaulOrdersV2Document = gql`
    query segmentedLineHaulOrdersV2($findSegmentedLineHaulOrdersInputV2: FindSegmentedLineHaulOrdersInputV2!) {
  segmentedLineHaulOrdersV2(
    findSegmentedLineHaulOrdersInputV2: $findSegmentedLineHaulOrdersInputV2
  ) {
    edges {
      ...SegmentedLineHaulOrder
    }
    totalCount
  }
}
    ${SegmentedLineHaulOrderFragmentDoc}`;
export const SegmentedLineHaulOrdersDocument = gql`
    query segmentedLineHaulOrders($findSegmentedLineHaulOrdersInput: FindSegmentedLineHaulOrdersInput!) {
  segmentedLineHaulOrders(
    findSegmentedLineHaulOrdersInput: $findSegmentedLineHaulOrdersInput
  ) {
    totalCount
    edges {
      node {
        ...SegmentedLineHaulOrder
      }
    }
    pageInfo {
      startCursor
      endCursor
      hasNextPage
      hasPreviousPage
    }
  }
}
    ${SegmentedLineHaulOrderFragmentDoc}`;
export const UpdateManifestDriverDocument = gql`
    mutation updateManifestDriver($updateManifestDriverInput: UpdateManifestDriverInput!) {
  updateManifestDriver(updateManifestDriverInput: $updateManifestDriverInput) {
    ...DetailedLineHaulManifest
  }
}
    ${DetailedLineHaulManifestFragmentDoc}`;
export const UpdateManifestVehicleDocument = gql`
    mutation updateManifestVehicle($updateManifestVehicleInput: UpdateManifestVehicleInput!) {
  updateManifestVehicle(updateManifestVehicleInput: $updateManifestVehicleInput) {
    ...DetailedLineHaulManifest
  }
}
    ${DetailedLineHaulManifestFragmentDoc}`;
export const UpdateManifestsStatusDocument = gql`
    mutation updateManifestsStatus($input: UpdateManifestsStatusInput!) {
  updateManifestsStatus(input: $input) {
    __typename
    ... on UpdateManifestsStatusSuccessOutput {
      __typename
      lineHaulManifests {
        ...DetailedLineHaulManifest
      }
    }
    ... on MutationErrorOutput {
      __typename
      message
    }
  }
}
    ${DetailedLineHaulManifestFragmentDoc}`;
export const ArchiveTariffChainDocument = gql`
    mutation archiveTariffChain($archiveTariffChainInput: ArchiveTariffChainInput!) {
  archiveTariffChain(archiveTariffChainInput: $archiveTariffChainInput) {
    ... on ArchiveTariffChainSuccessOutput {
      tariffChain {
        id
      }
    }
    ... on MutationErrorOutput {
      message
    }
  }
}
    `;
export const CompanyDefaultTariffChainsDocument = gql`
    query companyDefaultTariffChains {
  company {
    defaultOrdinaryTariffChain {
      ...CompanyDefaultTariffChain
    }
    defaultLineHaulTariffChain {
      ...CompanyDefaultTariffChain
    }
    defaultTransferTariffChain {
      ...CompanyDefaultTariffChain
    }
    defaultPointToPointTariffChain {
      ...CompanyDefaultTariffChain
    }
    defaultOrdinarySettlementTariffChain {
      ...CompanyDefaultTariffChain
    }
    defaultTransferSettlementTariffChain {
      ...CompanyDefaultTariffChain
    }
  }
}
    ${CompanyDefaultTariffChainFragmentDoc}`;
export const CreateTariffChainDocument = gql`
    mutation createTariffChain($createTariffChainInput: CreateTariffChainInput!) {
  createTariffChain(createTariffChainInput: $createTariffChainInput) {
    ... on CreateTariffChainSuccessOutput {
      tariffChain {
        id
      }
    }
    ... on MutationErrorOutput {
      message
    }
  }
}
    `;
export const RestoreTariffChainDocument = gql`
    mutation restoreTariffChain($restoreTariffChainInput: RestoreTariffChainInput!) {
  restoreTariffChain(restoreTariffChainInput: $restoreTariffChainInput) {
    ... on RestoreTariffChainSuccessOutput {
      tariffChain {
        id
      }
    }
    ... on MutationErrorOutput {
      message
    }
  }
}
    `;
export const TariffChainsWithGroupsDocument = gql`
    query tariffChainsWithGroups($findTariffChainsInput: FindTariffChainsInput!) {
  tariffChains(findTariffChainsInput: $findTariffChainsInput) {
    ...TariffChainWithGroups
  }
}
    ${TariffChainWithGroupsFragmentDoc}`;
export const UpdateDefaultTariffChainsForCompanyDocument = gql`
    mutation updateDefaultTariffChainsForCompany($updateDefaultTariffChainsForCompanyInput: UpdateDefaultTariffChainsForCompanyInput!) {
  updateDefaultTariffChainsForCompany(
    updateDefaultTariffChainsForCompanyInput: $updateDefaultTariffChainsForCompanyInput
  ) {
    ... on UpdateDefaultTariffChainsForCompanySuccessOutput {
      company {
        uuid
      }
    }
    ... on MutationErrorOutput {
      message
    }
  }
}
    `;
export const UpdateTariffChainDocument = gql`
    mutation updateTariffChain($updateTariffChainInput: UpdateTariffChainInput!) {
  updateTariffChain(updateTariffChainInput: $updateTariffChainInput) {
    ... on UpdateTariffChainSuccessOutput {
      tariffChain {
        id
      }
    }
    ... on MutationErrorOutput {
      message
    }
  }
}
    `;
export const ContactsWithTariffsDocument = gql`
    query contactsWithTariffs($checkHasTariffs: Boolean, $checkHasTariffZones: Boolean) {
  contacts(
    checkHasTariffs: $checkHasTariffs
    checkHasTariffZones: $checkHasTariffZones
  ) {
    uuid
    displayName
    customerTariffs {
      service {
        ...Service
      }
    }
    tariffZones {
      type
    }
  }
}
    ${ServiceFragmentDoc}`;
export const CreateTariffGroupDocument = gql`
    mutation createTariffGroup($createTariffGroupInput: CreateTariffGroupInput!) {
  createTariffGroup(createTariffGroupInput: $createTariffGroupInput) {
    uuid
    name
  }
}
    `;
export const DeleteTariffGroupDocument = gql`
    mutation deleteTariffGroup($uuid: String!) {
  deleteTariffGroup(uuid: $uuid) {
    uuid
  }
}
    `;
export const DuplicateTariffGroupDocument = gql`
    mutation duplicateTariffGroup($duplicateTariffGroupInput: DuplicateTariffGroupInput!) {
  duplicateTariffGroup(duplicateTariffGroupInput: $duplicateTariffGroupInput) {
    tariffGroup {
      uuid
    }
  }
}
    `;
export const FindDefaultTariffGroupForCompanyDocument = gql`
    query findDefaultTariffGroupForCompany {
  findDefaultTariffGroupForCompany {
    uuid
  }
}
    `;
export const FindDefaultTransferTariffGroupForCompanyDocument = gql`
    query findDefaultTransferTariffGroupForCompany {
  findDefaultTransferTariffGroupForCompany {
    uuid
  }
}
    `;
export const FindTariffGroupsWithContactAndServiceCombinationDocument = gql`
    query findTariffGroupsWithContactAndServiceCombination($mappingsList: [ContactAndServicesCombination!]!) {
  findTariffGroupsWithContactAndServiceCombination(mappingsList: $mappingsList) {
    contactUuid
    matchingTariffGroups {
      tariffGroupName
      tariffGroupUuid
      serviceUuids
    }
  }
}
    `;
export const TariffGroupDocument = gql`
    query tariffGroup($tariffGroupUuid: String!) {
  tariffGroup(uuid: $tariffGroupUuid) {
    ...TariffGroup
  }
}
    ${TariffGroupFragmentDoc}`;
export const TariffDocument = gql`
    query tariff($uuid: String!) {
  tariff(uuid: $uuid) {
    ...TariffFragment
  }
}
    ${TariffFragmentFragmentDoc}`;
export const UpdateTariffGroupDocument = gql`
    mutation updateTariffGroup($updateTariffGroupInput: UpdateTariffGroupInput!) {
  updateTariffGroup(updateTariffGroupInput: $updateTariffGroupInput) {
    uuid
    name
  }
}
    `;
export const ArchiveTariffZoneGroupDocument = gql`
    mutation archiveTariffZoneGroup($id: String!) {
  archiveTariffZoneGroup(id: $id) {
    ... on TariffZoneGroupArchiveSuccessOutput {
      tariffZoneGroup {
        id
      }
    }
    ... on MutationErrorOutput {
      message
    }
  }
}
    `;
export const CreateTariffZoneGroupDocument = gql`
    mutation createTariffZoneGroup($tariffZoneGroupCreateInput: TariffZoneGroupCreateInput!) {
  createTariffZoneGroup(tariffZoneGroupCreateInput: $tariffZoneGroupCreateInput) {
    ... on TariffZoneGroupCreateSuccessOutput {
      tariffZoneGroup {
        id
      }
    }
    ... on MutationErrorOutput {
      message
    }
  }
}
    `;
export const RestoreTariffZoneGroupDocument = gql`
    mutation restoreTariffZoneGroup($id: String!) {
  restoreTariffZoneGroup(id: $id) {
    ... on TariffZoneGroupRestoreSuccessOutput {
      tariffZoneGroup {
        id
      }
    }
    ... on MutationErrorOutput {
      message
    }
  }
}
    `;
export const TariffZoneGroupsDocument = gql`
    query tariffZoneGroups($findTariffZoneGroupsInput: FindTariffZoneGroupsInput!) {
  tariffZoneGroups(findTariffZoneGroupsInput: $findTariffZoneGroupsInput) {
    ...TariffZoneGroup
  }
}
    ${TariffZoneGroupFragmentDoc}`;
export const TariffZonesForGroupDocument = gql`
    query tariffZonesForGroup($tariffZoneGroupId: String!) {
  tariffZoneGroup(id: $tariffZoneGroupId) {
    ...TariffZoneGroupWithTariffZones
  }
}
    ${TariffZoneGroupWithTariffZonesFragmentDoc}`;
export const UpdateTariffZoneGroupDocument = gql`
    mutation updateTariffZoneGroup($tariffZoneGroupUpdateInput: TariffZoneGroupUpdateInput!) {
  updateTariffZoneGroup(tariffZoneGroupUpdateInput: $tariffZoneGroupUpdateInput) {
    ... on TariffZoneGroupUpdateSuccessOutput {
      tariffZoneGroup {
        id
      }
    }
    ... on MutationErrorOutput {
      message
    }
  }
}
    `;
export const AccessorialDateRangeConfigByUuidDocument = gql`
    query accessorialDateRangeConfigByUuid($uuid: String!) {
  accessorialDateRangeConfigByUuid(uuid: $uuid) {
    uuid
    specialChargeGroups {
      uuid
      dayOfWeek
      startTime
      endTime
    }
    specialMatrixItems {
      tariffZone {
        uuid
        name
        mileRangeStart
        mileRangeEnd
      }
      chargeGroupUuid
      uuid
      rate
    }
    accessorialRanges {
      ...AccessorialRange
    }
  }
}
    ${AccessorialRangeFragmentDoc}`;
export const AccessorialDateRangeConfigsDocument = gql`
    query accessorialDateRangeConfigs($findAccessorialDateRangeConfigsInput: FindAccessorialDateRangeConfigsInput!) {
  accessorialDateRangeConfigs(
    findAccessorialDateRangeConfigsInput: $findAccessorialDateRangeConfigsInput
  ) {
    accessorialDateRangeConfigs {
      ...AccessorialDateRangeConfig
    }
  }
}
    ${AccessorialDateRangeConfigFragmentDoc}`;
export const CreateAccessorialDateRangeConfigDocument = gql`
    mutation createAccessorialDateRangeConfig($createAccessorialDateRangeConfigInput: CreateAccessorialDateRangeConfigInput!) {
  createAccessorialDateRangeConfig(
    createAccessorialDateRangeConfigInput: $createAccessorialDateRangeConfigInput
  ) {
    success
  }
}
    `;
export const DeleteAccessorialDateRangeConfigDocument = gql`
    mutation deleteAccessorialDateRangeConfig($deleteAccessorialDateRangeConfigInput: DeleteAccessorialDateRangeConfigInput!) {
  deleteAccessorialDateRangeConfig(
    deleteAccessorialDateRangeConfigInput: $deleteAccessorialDateRangeConfigInput
  ) {
    uuid
  }
}
    `;
export const UpdateAccessorialDateRangeConfigDocument = gql`
    mutation updateAccessorialDateRangeConfig($updateAccessorialDateRangeConfigInput: UpdateAccessorialDateRangeConfigInput!) {
  updateAccessorialDateRangeConfig(
    updateAccessorialDateRangeConfigInput: $updateAccessorialDateRangeConfigInput
  ) {
    success
  }
}
    `;
export const AccessorialNamesByBillingContactDocument = gql`
    query accessorialNamesByBillingContact($billingPartyContactUuid: String, $onlyShowCompanyAccessorials: Boolean) {
  accessorialsByBillingContact(
    billingPartyContactUuid: $billingPartyContactUuid
    onlyShowCompanyAccessorials: $onlyShowCompanyAccessorials
  ) {
    ...AccessorialNames
  }
}
    ${AccessorialNamesFragmentDoc}`;
export const AccessorialsByBillingContactDocument = gql`
    query accessorialsByBillingContact($billingPartyContactUuid: String, $onlyShowCompanyAccessorials: Boolean, $terminalUuids: [String!]) {
  accessorialsByBillingContact(
    billingPartyContactUuid: $billingPartyContactUuid
    onlyShowCompanyAccessorials: $onlyShowCompanyAccessorials
    terminalUuids: $terminalUuids
  ) {
    ... on StandardAccessorialEntity {
      uuid
      name
      isArchived
      isAuthoCodeRequired
      contact {
        uuid
      }
      matchingGlobalAccessorial {
        ...AccessorialUnionUuidOnly
      }
    }
    ... on WeightBasedAccessorialEntity {
      uuid
      name
      isArchived
      isAuthoCodeRequired
      contact {
        uuid
      }
      matchingGlobalAccessorial {
        ...AccessorialUnionUuidOnly
      }
    }
    ... on ZoneBasedAccessorialEntity {
      uuid
      name
      isArchived
      isAuthoCodeRequired
      contact {
        uuid
      }
      matchingGlobalAccessorial {
        ...AccessorialUnionUuidOnly
      }
      zones {
        uuid
      }
      chargeGroups {
        uuid
      }
    }
    ... on WaitTimeAccessorialEntity {
      uuid
      name
      isArchived
      isAuthoCodeRequired
      contact {
        uuid
      }
      matchingGlobalAccessorial {
        ...AccessorialUnionUuidOnly
      }
    }
    ... on UnitBasedAccessorialEntity {
      uuid
      name
      isArchived
      isAuthoCodeRequired
      contact {
        uuid
      }
      matchingGlobalAccessorial {
        ...AccessorialUnionUuidOnly
      }
    }
    ... on SkidBasedAccessorialEntity {
      uuid
      name
      isArchived
      isAuthoCodeRequired
      contact {
        uuid
      }
      matchingGlobalAccessorial {
        ...AccessorialUnionUuidOnly
      }
    }
    ... on SpecialAccessorialEntity {
      uuid
      name
      isArchived
      isAuthoCodeRequired
      contact {
        uuid
      }
      matchingGlobalAccessorial {
        ...AccessorialUnionUuidOnly
      }
      chargeGroups {
        uuid
      }
    }
  }
}
    ${AccessorialUnionUuidOnlyFragmentDoc}`;
export const CreateAccessorialDocument = gql`
    mutation CreateAccessorial($input: CreateAccessorialInput!) {
  createAccessorial(createAccessorialInput: $input) {
    ...AccessorialsUuid
  }
}
    ${AccessorialsUuidFragmentDoc}`;
export const RemoveAccessorialDocument = gql`
    mutation RemoveAccessorial($input: String!) {
  removeAccessorial(uuid: $input) {
    ...AccessorialsUuid
  }
}
    ${AccessorialsUuidFragmentDoc}`;
export const AccessorialDocument = gql`
    query accessorial($uuid: String!) {
  accessorial(uuid: $uuid) {
    ...AllAccessorialFields
  }
}
    ${AllAccessorialFieldsFragmentDoc}`;
export const DefaultGlobalSpecialAccessorialsDocument = gql`
    query defaultGlobalSpecialAccessorials {
  defaultGlobalSpecialAccessorials {
    ... on SpecialAccessorialEntity {
      __typename
      uuid
      name
    }
  }
}
    `;
export const AccessorialNamesDocument = gql`
    query accessorialNames($onlyShowCompanyAccessorials: Boolean) {
  accessorials(onlyShowCompanyAccessorials: $onlyShowCompanyAccessorials) {
    ...AccessorialNames
  }
}
    ${AccessorialNamesFragmentDoc}`;
export const AccessorialsTableDocument = gql`
    query accessorialsTable($contactUuid: String, $onlyShowCompanyAccessorials: Boolean, $includeArchived: Boolean) {
  accessorials(
    contactUuid: $contactUuid
    onlyShowCompanyAccessorials: $onlyShowCompanyAccessorials
    includeArchived: $includeArchived
  ) {
    ...AccessorialsTableRow
  }
}
    ${AccessorialsTableRowFragmentDoc}`;
export const AccessorialsDocument = gql`
    query accessorials($contactUuid: String, $onlyShowCompanyAccessorials: Boolean, $includeArchived: Boolean) {
  accessorials(
    contactUuid: $contactUuid
    onlyShowCompanyAccessorials: $onlyShowCompanyAccessorials
    includeArchived: $includeArchived
  ) {
    ...AllAccessorialFields
  }
}
    ${AllAccessorialFieldsFragmentDoc}`;
export const RemoveSpecialAccessorialDocument = gql`
    mutation RemoveSpecialAccessorial($input: String!) {
  removeSpecialAccessorial(uuid: $input) {
    ... on SpecialAccessorialEntity {
      uuid
    }
  }
}
    `;
export const RemoveZoneBasedAccessorialDocument = gql`
    mutation RemoveZoneBasedAccessorial($input: String!) {
  removeZoneBasedAccessorial(uuid: $input) {
    ... on ZoneBasedAccessorialEntity {
      uuid
    }
  }
}
    `;
export const UpdateAccessorialDocument = gql`
    mutation UpdateAccessorial($input: UpdateAccessorialInput!) {
  updateAccessorial(updateAccessorialInput: $input) {
    ...AccessorialsUuid
  }
}
    ${AccessorialsUuidFragmentDoc}`;
export const UpdateQuickAddAccessorialsDocument = gql`
    mutation UpdateQuickAddAccessorials($input: UpdateQuickAddAccessorialsInput!) {
  updateQuickAddAccessorials(input: $input) {
    quickAddAccessorials {
      ...AccessorialNames
    }
  }
}
    ${AccessorialNamesFragmentDoc}`;
export const SenderIsVerifiedDocument = gql`
    query senderIsVerified {
  senderIsVerified
}
    `;
export const CreateCreditTypeDocument = gql`
    mutation createCreditType($creditTypeCreateInput: CreditTypeCreateInput!) {
  createCreditType(creditTypeCreateInput: $creditTypeCreateInput) {
    ...CreditType
  }
}
    ${CreditTypeFragmentDoc}`;
export const CreditTypesDocument = gql`
    query creditTypes {
  creditTypes {
    ...CreditType
  }
}
    ${CreditTypeFragmentDoc}`;
export const RemoveCreditTypeDocument = gql`
    mutation removeCreditType($uuid: String!) {
  removeCreditType(uuid: $uuid) {
    ...CreditType
  }
}
    ${CreditTypeFragmentDoc}`;
export const UpdateCreditTypeDocument = gql`
    mutation updateCreditType($creditTypeUpdateInput: CreditTypeUpdateInput!) {
  updateCreditType(creditTypeUpdateInput: $creditTypeUpdateInput) {
    ...CreditType
  }
}
    ${CreditTypeFragmentDoc}`;
export const CreateGeneralLedgerCodeDocument = gql`
    mutation createGeneralLedgerCode($input: GeneralLedgerCodeCreateInput!) {
  createGeneralLedgerCode(input: $input) {
    __typename
    ... on MutationErrorOutput {
      message
    }
    ... on CreateGeneralLedgerCodeSuccessOutput {
      generalLedgerCode {
        code
        description
      }
    }
  }
}
    `;
export const DeleteGeneralLedgerCodeDocument = gql`
    mutation deleteGeneralLedgerCode($input: GeneralLedgerCodeDeleteInput!) {
  deleteGeneralLedgerCode(input: $input) {
    __typename
    ... on MutationErrorOutput {
      message
    }
    ... on DeleteGeneralLedgerCodeSuccessOutput {
      id
    }
  }
}
    `;
export const GeneralLedgerCodesDocument = gql`
    query generalLedgerCodes {
  generalLedgerCodes {
    id
    code
    description
  }
}
    `;
export const GeneralLedgerConfigurationDocument = gql`
    query generalLedgerConfiguration {
  generalLedgerConfiguration {
    id
    generalLedgerCodes {
      ...GeneralLedgerCode
    }
    deliveryChargeCodeId
    pickupChargeCodeId
    recoveryChargeCodeId
    transferChargeCodeId
    orderChargeCodeId
    lineHaulChargeCodeId
    fuelChargeCodeId
    accessorialFallbackCodeId
  }
}
    ${GeneralLedgerCodeFragmentDoc}`;
export const UpdateGeneralLedgerCodeDocument = gql`
    mutation updateGeneralLedgerCode($input: GeneralLedgerCodeUpdateInput!) {
  updateGeneralLedgerCode(input: $input) {
    __typename
    ... on MutationErrorOutput {
      message
    }
    ... on UpdateGeneralLedgerCodeSuccessOutput {
      generalLedgerCode {
        code
        description
      }
    }
  }
}
    `;
export const UpdateGeneralLedgerConfigurationDocument = gql`
    mutation updateGeneralLedgerConfiguration($input: GeneralLedgerConfigurationUpdateInput!) {
  updateGeneralLedgerConfiguration(input: $input) {
    __typename
    ... on MutationErrorOutput {
      message
    }
    ... on UpdateGeneralLedgerConfigurationSuccessOutput {
      generalLedgerConfiguration {
        id
      }
    }
  }
}
    `;
export const CreateMasterAccountDocument = gql`
    mutation createMasterAccount($createMasterAccountInput: CreateMasterAccountInput!) {
  createMasterAccount(createMasterAccountInput: $createMasterAccountInput) {
    success
  }
}
    `;
export const MasterAccountsDocument = gql`
    query masterAccounts {
  masterAccounts {
    masterAccounts {
      ...MasterAccount
    }
  }
}
    ${MasterAccountFragmentDoc}`;
export const RemoveMasterAccountDocument = gql`
    mutation removeMasterAccount($uuid: String!) {
  removeMasterAccount(uuid: $uuid) {
    uuid
  }
}
    `;
export const UpdateMasterAccountDocument = gql`
    mutation updateMasterAccount($updateMasterAccountInput: UpdateMasterAccountInput!) {
  updateMasterAccount(updateMasterAccountInput: $updateMasterAccountInput) {
    success
  }
}
    `;
export const CreateSettlementDeductionTypeDocument = gql`
    mutation createSettlementDeductionType($settlementDeductionTypeCreateInput: SettlementDeductionTypeCreateInput!) {
  createSettlementDeductionType(
    settlementDeductionTypeCreateInput: $settlementDeductionTypeCreateInput
  ) {
    ...SettlementDeductionType
  }
}
    ${SettlementDeductionTypeFragmentDoc}`;
export const RemoveSettlementDeductionTypeDocument = gql`
    mutation removeSettlementDeductionType($uuid: String!) {
  removeSettlementDeductionType(uuid: $uuid) {
    ...SettlementDeductionType
  }
}
    ${SettlementDeductionTypeFragmentDoc}`;
export const SettlementDeductionTypesDocument = gql`
    query settlementDeductionTypes {
  settlementDeductionTypes {
    ...SettlementDeductionType
  }
}
    ${SettlementDeductionTypeFragmentDoc}`;
export const UpdateSettlementDeductionTypeDocument = gql`
    mutation updateSettlementDeductionType($settlementDeductionTypeUpdateInput: SettlementDeductionTypeUpdateInput!) {
  updateSettlementDeductionType(
    settlementDeductionTypeInput: $settlementDeductionTypeUpdateInput
  ) {
    ...SettlementDeductionType
  }
}
    ${SettlementDeductionTypeFragmentDoc}`;
export const BulkUploadRouteNamesDocument = gql`
    mutation bulkUploadRouteNames($bulkCsvRouteNameInput: BulkCsvRouteNameInput!) {
  bulkUploadRouteNames(bulkCsvRouteNameInput: $bulkCsvRouteNameInput) {
    uuid
  }
}
    `;
export const BusinessDivisionsDocument = gql`
    query businessDivisions {
  businessDivisions {
    businessDivisions {
      ...FindBusinessDivisions
    }
  }
}
    ${FindBusinessDivisionsFragmentDoc}`;
export const CreateBusinessDivisionDocument = gql`
    mutation createBusinessDivision($createBusinessDivisionInput: CreateBusinessDivisionInput!) {
  createBusinessDivision(
    createBusinessDivisionInput: $createBusinessDivisionInput
  ) {
    success
  }
}
    `;
export const RemoveBusinessDivisionDocument = gql`
    mutation removeBusinessDivision($uuid: String!) {
  removeBusinessDivision(uuid: $uuid) {
    uuid
  }
}
    `;
export const UpdateBusinessDivisionDocument = gql`
    mutation updateBusinessDivision($updateBusinessDivisionInput: UpdateBusinessDivisionInput!) {
  updateBusinessDivision(
    updateBusinessDivisionInput: $updateBusinessDivisionInput
  ) {
    success
  }
}
    `;
export const CompanyDocument = gql`
    query company {
  company {
    uuid
  }
}
    `;
export const CreateCustomDriverFormDocument = gql`
    mutation createCustomDriverForm($createDriverSignableFormTemplateInput: CreateDriverSignableFormTemplateInput!) {
  createDriverSignableFormTemplate(
    createDriverSignableFormTemplateInput: $createDriverSignableFormTemplateInput
  ) {
    uuid
  }
}
    `;
export const CreateEquipmentDocument = gql`
    mutation CreateEquipment($input: CreateEquipmentInput!) {
  createEquipment(createEquipmentInput: $input) {
    uuid
    name
    uuid
  }
}
    `;
export const CreateFuelProfileDocument = gql`
    mutation createFuelProfile($input: CreateFuelProfileInput!) {
  createFuelProfile(createFuelProfileInput: $input) {
    uuid
  }
}
    `;
export const UpdateInvoiceEmailDocument = gql`
    mutation updateInvoiceEmail($input: String!) {
  updateInvoiceEmail(email: $input) {
    uuid
    sendgridSenderId
  }
}
    `;
export const CreateServiceDocument = gql`
    mutation createService($input: CreateServiceInput!) {
  createService(createServiceInput: $input) {
    uuid
    name
  }
}
    `;
export const CustomDriverSignableFormDocument = gql`
    query customDriverSignableForm($uuid: String!) {
  customDriverForm(uuid: $uuid) {
    ...DriverSignableForm
  }
}
    ${DriverSignableFormFragmentDoc}`;
export const CustomDriverSignableFormsDocument = gql`
    query customDriverSignableForms {
  customDriverForms {
    ...DriverSignableForm
  }
}
    ${DriverSignableFormFragmentDoc}`;
export const DeleteCustomDriverFormDocument = gql`
    mutation deleteCustomDriverForm($uuid: String!) {
  deleteDriverSignableFormTemplate(uuid: $uuid) {
    uuid
  }
}
    `;
export const DeleteEquipmentDocument = gql`
    mutation deleteEquipment($uuid: String!) {
  deleteEquipment(uuid: $uuid) {
    uuid
  }
}
    `;
export const DeleteRouteNameLocationDocument = gql`
    mutation deleteRouteNameLocation($uuid: String!) {
  deleteRouteNameLocation(uuid: $uuid) {
    uuid
  }
}
    `;
export const DriversTableDocument = gql`
    query driversTable {
  drivers {
    uuid
    firstName
    lastName
    driverType
    driverPayType
    driverReferenceNumber
    active
    terminal {
      uuid
      name
    }
  }
}
    `;
export const ArchiveDriverDocument = gql`
    mutation ArchiveDriver($uuid: String!) {
  archiveDriver(uuid: $uuid) {
    driver {
      uuid
      active
    }
  }
}
    `;
export const CreateDriverDocument = gql`
    mutation CreateDriver($input: CreateDriverInput!) {
  createDriver(createDriverInput: $input) {
    uuid
    firstName
    lastName
  }
}
    `;
export const DriverByPhoneNumberDocument = gql`
    query driverByPhoneNumber($phoneNumber: String!) {
  driverByPhoneNumber(phoneNumber: $phoneNumber) {
    uuid
    company {
      uuid
    }
    firstName
    lastName
  }
}
    `;
export const DriverQualificationsDocument = gql`
    query DriverQualifications {
  driverQualifications {
    id
    name
  }
}
    `;
export const DriverDocument = gql`
    query driver($uuid: String!) {
  driver(uuid: $uuid) {
    uuid
    active
    driverPayType
    driverType
    driverReferenceNumber
    emailAddress
    password
    address {
      uuid
      line1
      line2
      city
      country
      name
      state
      zip
      longitude
      latitude
    }
    firstName
    flatRate
    fuelCardNumber
    hourlyRate
    lastName
    notes
    perMileRate
    percentGrossRevenueRate
    defaultFuelSettlementPercentageRate
    phoneNumber
    defaultVehicle {
      uuid
      name
    }
    terminal {
      uuid
      name
      code
    }
    qualifications {
      id
      name
    }
    sendRouteUpdateEmails
    defaultOrdinaryTariffChainId
    defaultTransferTariffChainId
    defaultLineHaulTariffChainId
    defaultPointToPointTariffChainId
  }
}
    `;
export const RestoreDriverDocument = gql`
    mutation RestoreDriver($uuid: String!) {
  restoreDriver(uuid: $uuid) {
    driver {
      uuid
      active
    }
  }
}
    `;
export const UpdateDriverQualificationsDocument = gql`
    mutation UpdateDriverQualifications($input: UpdateDriverQualificationsInput!) {
  updateDriverQualifications(input: $input) {
    driverQualifications {
      id
      name
    }
  }
}
    `;
export const VehicleTypeDocument = gql`
    query VehicleType($uuid: String!) {
  vehicleType(uuid: $uuid) {
    ...VehicleType
  }
}
    ${VehicleTypeFragmentDoc}`;
export const FlipIsArchivedDocument = gql`
    mutation flipIsArchived($uuid: String!) {
  flipIsArchived(uuid: $uuid) {
    ... on StandardAccessorialEntity {
      uuid
    }
    ... on WeightBasedAccessorialEntity {
      uuid
    }
    ... on ZoneBasedAccessorialEntity {
      uuid
    }
    ... on WaitTimeAccessorialEntity {
      uuid
    }
    ... on UnitBasedAccessorialEntity {
      uuid
    }
    ... on SkidBasedAccessorialEntity {
      uuid
    }
    ... on SpecialAccessorialEntity {
      uuid
    }
  }
}
    `;
export const CreateFuelProfileDateRangeDocument = gql`
    mutation createFuelProfileDateRange($createFuelProfileDateRangeInput: CreateFuelProfileDateRangeInput!) {
  createFuelProfileDateRange(
    createFuelProfileDateRangeInput: $createFuelProfileDateRangeInput
  ) {
    success
    error
  }
}
    `;
export const DeleteFuelProfileDateRangeDocument = gql`
    mutation deleteFuelProfileDateRange($deleteFuelProfileDateRangeInput: DeleteFuelProfileDateRangeInput!) {
  deleteFuelProfileDateRange(
    deleteFuelProfileDateRangeInput: $deleteFuelProfileDateRangeInput
  ) {
    success
  }
}
    `;
export const FuelProfileDocument = gql`
    query fuelProfile($findFuelProfileInput: FindFuelProfileInput!) {
  fuelProfile(findFuelProfileInput: $findFuelProfileInput) {
    fuelProfile {
      ...FindFuelProfile
    }
  }
}
    ${FindFuelProfileFragmentDoc}`;
export const FuelProfilesDocument = gql`
    query fuelProfiles($contactUuid: String, $orderUuid: String, $excludeContactUuid: String, $type: FuelProfileType) {
  fuelProfiles(
    contactUuid: $contactUuid
    orderUuid: $orderUuid
    excludeContactUuid: $excludeContactUuid
    type: $type
  ) {
    ...FuelProfile
  }
}
    ${FuelProfileFragmentDoc}`;
export const RemoveFuelProfileDocument = gql`
    mutation removeFuelProfile($uuid: String!) {
  removeFuelProfile(uuid: $uuid) {
    uuid
  }
}
    `;
export const UpdateFuelProfileDateRangeDocument = gql`
    mutation updateFuelProfileDateRange($updateFuelProfileDateRangeInput: UpdateFuelProfileDateRangeInput!) {
  updateFuelProfileDateRange(
    updateFuelProfileDateRangeInput: $updateFuelProfileDateRangeInput
  ) {
    success
    error
  }
}
    `;
export const UpdateFuelProfileDocument = gql`
    mutation updateFuelProfile($input: UpdateFuelProfileInput!) {
  updateFuelProfile(updateFuelProfileInput: $input) {
    uuid
  }
}
    `;
export const CreateHoldReasonDocument = gql`
    mutation createHoldReason($holdReasonCreateInput: HoldReasonCreateInput!) {
  createHoldReason(holdReasonCreateInput: $holdReasonCreateInput) {
    ...HoldReason
  }
}
    ${HoldReasonFragmentDoc}`;
export const HoldReasonsDocument = gql`
    query holdReasons($archived: Boolean) {
  holdReasons(archived: $archived) {
    ...HoldReason
  }
}
    ${HoldReasonFragmentDoc}`;
export const UpdateHoldReasonDocument = gql`
    mutation updateHoldReason($holdReasonUpdateInput: HoldReasonUpdateInput!) {
  updateHoldReason(holdReasonUpdateInput: $holdReasonUpdateInput) {
    ...HoldReason
  }
}
    ${HoldReasonFragmentDoc}`;
export const CreateLineHaulLaneDocument = gql`
    mutation createLineHaulLane($createLineHaulLaneInput: CreateLineHaulLaneInput!) {
  createLineHaulLane(createLineHaulLaneInput: $createLineHaulLaneInput) {
    lineHaulLane {
      uuid
    }
    errorMessage
  }
}
    `;
export const LineHaulLaneDocument = gql`
    query lineHaulLane($uuid: String!) {
  lineHaulLane(uuid: $uuid) {
    ...LineHaulLane
  }
}
    ${LineHaulLaneFragmentDoc}`;
export const LineHaulLanesDocument = gql`
    query lineHaulLanes {
  lineHaulLanes {
    ...ShallowLineHaulLane
  }
}
    ${ShallowLineHaulLaneFragmentDoc}`;
export const UpdateLineHaulLaneDocument = gql`
    mutation updateLineHaulLane($updateLineHaulLaneInput: UpdateLineHaulLaneInput!) {
  updateLineHaulLane(updateLineHaulLaneInput: $updateLineHaulLaneInput) {
    lineHaulLane {
      uuid
    }
    errorMessage
  }
}
    `;
export const MarkOrderAsCancelledDocument = gql`
    mutation markOrderAsCancelled($uuid: String!) {
  markAsCancelled(uuid: $uuid) {
    uuid
  }
}
    `;
export const MarkOrderAsOnHoldDocument = gql`
    mutation markOrderAsOnHold($markAsOnHoldInput: MarkAsOnHoldInput!) {
  markAsOnHold(markAsOnHoldInput: $markAsOnHoldInput) {
    uuid
    status
    detailedStatusV2
  }
}
    `;
export const MinimalServiceRegionsDocument = gql`
    query MinimalServiceRegions($input: GetServiceRegionsInput!) {
  serviceRegions(input: $input) {
    serviceRegions {
      id
      name
      isArchived
    }
  }
}
    `;
export const ArchivePackageSpecDocument = gql`
    mutation ArchivePackageSpec($id: String!) {
  archivePackageSpec(id: $id) {
    packageSpec {
      ...PackageSpec
    }
  }
}
    ${PackageSpecFragmentDoc}`;
export const CreatePackageSpecDocument = gql`
    mutation CreatePackageSpec($createPackageSpecInput: CreatePackageSpecInput!) {
  createPackageSpec(createPackageSpecInput: $createPackageSpecInput) {
    packageSpec {
      ...PackageSpec
    }
  }
}
    ${PackageSpecFragmentDoc}`;
export const PackageSpecDocument = gql`
    query PackageSpec($id: String!) {
  packageSpec(id: $id) {
    ...PackageSpec
  }
}
    ${PackageSpecFragmentDoc}`;
export const PackageSpecsMinimalDocument = gql`
    query PackageSpecsMinimal {
  packageSpecs {
    packageSpecs {
      id
      name
      status
    }
  }
}
    `;
export const RestorePackageSpecDocument = gql`
    mutation RestorePackageSpec($id: String!) {
  restorePackageSpec(id: $id) {
    packageSpec {
      ...PackageSpec
    }
  }
}
    ${PackageSpecFragmentDoc}`;
export const UpdatePackageSpecDocument = gql`
    mutation UpdatePackageSpec($updatePackageSpecInput: UpdatePackageSpecInput!) {
  updatePackageSpec(updatePackageSpecInput: $updatePackageSpecInput) {
    packageSpec {
      ...PackageSpec
    }
  }
}
    ${PackageSpecFragmentDoc}`;
export const RecoveryTerminalsDocument = gql`
    query RecoveryTerminals {
  airportInfos {
    ...RecoveryTerminal
  }
}
    ${RecoveryTerminalFragmentDoc}`;
export const CreateRecoveryTerminalDocument = gql`
    mutation CreateRecoveryTerminal($iataCode: String!, $terminal: String!, $addressUuid: String!, $companyUuid: String!) {
  createAirportInfo(
    createAirportInfoInput: {iataCode: $iataCode, terminal: $terminal, addressUuid: $addressUuid, companyUuid: $companyUuid}
  ) {
    uuid
    address {
      ...Address
    }
  }
}
    ${AddressFragmentDoc}`;
export const UpdateRecoveryTerminalDocument = gql`
    mutation UpdateRecoveryTerminal($uuid: String!, $iataCode: String, $terminal: String, $addressUuid: String) {
  updateAirportInfo(
    updateAirportInfoInput: {uuid: $uuid, iataCode: $iataCode, terminal: $terminal, addressUuid: $addressUuid}
  ) {
    uuid
  }
}
    `;
export const RouteNameDocument = gql`
    query routeName($uuid: String!) {
  routeName(uuid: $uuid) {
    uuid
    name
    routeNameLocations {
      uuid
      zipcode
      city
    }
  }
}
    `;
export const RouteNamesDocument = gql`
    query routeNames {
  routeNames {
    uuid
    name
  }
}
    `;
export const ServicesForThirdPartyUserDocument = gql`
    query servicesForThirdPartyUser($findServicesForThirdPartyUserInput: FindServicesForThirdPartyUserInput!) {
  servicesForThirdPartyUser(
    findServicesForThirdPartyUserInput: $findServicesForThirdPartyUserInput
  ) {
    ...ServiceForThirdPartyUser
  }
}
    ${ServiceForThirdPartyUserFragmentDoc}`;
export const CreateTerminalServiceAreasV2Document = gql`
    mutation createTerminalServiceAreasV2($createTerminalServiceAreaInputs: [CreateTerminalServiceAreaInput!]!) {
  createTerminalServiceAreasV2(
    createTerminalServiceAreaInputs: $createTerminalServiceAreaInputs
  ) {
    createdCount
  }
}
    `;
export const CreateTerminalDocument = gql`
    mutation createTerminal($input: TerminalCreateInput!) {
  createTerminalV2(input: $input) {
    __typename
    ... on CreateTerminalSuccessOutput {
      terminal {
        uuid
      }
    }
    ... on MutationErrorOutput {
      message
    }
  }
}
    `;
export const RemoveTerminalServiceAreaDocument = gql`
    mutation removeTerminalServiceArea($uuid: String!) {
  removeTerminalServiceArea(uuid: $uuid) {
    uuid
  }
}
    `;
export const TerminalDocument = gql`
    query terminal($uuid: String!) {
  terminal(uuid: $uuid) {
    ...Terminal
  }
}
    ${TerminalFragmentDoc}`;
export const TerminalsForThirdPartyUserDocument = gql`
    query terminalsForThirdPartyUser($findTerminalsForThirdPartyUserInput: FindTerminalsForThirdPartyUserInput!) {
  terminalsForThirdPartyUser(
    findTerminalsForThirdPartyUserInput: $findTerminalsForThirdPartyUserInput
  ) {
    ...ShallowTerminal
  }
}
    ${ShallowTerminalFragmentDoc}`;
export const TerminalsDocument = gql`
    query terminals($getTerminalsInput: GetTerminalsInput) {
  terminals(getTerminalsInput: $getTerminalsInput) {
    ...ShallowTerminal
  }
}
    ${ShallowTerminalFragmentDoc}`;
export const UpdateTerminalDocument = gql`
    mutation updateTerminal($input: TerminalUpdateInput!) {
  updateTerminalV2(input: $input) {
    __typename
    ... on UpdateTerminalSuccessOutput {
      terminal {
        ...Terminal
      }
    }
    ... on MutationErrorOutput {
      message
    }
  }
}
    ${TerminalFragmentDoc}`;
export const CreateThirdPartyBrokerDocument = gql`
    mutation createThirdPartyBroker($thirdPartyBrokerCreateInput: ThirdPartyBrokerCreateInput!) {
  createThirdPartyBroker(
    thirdPartyBrokerCreateInput: $thirdPartyBrokerCreateInput
  ) {
    ...ThirdPartyBroker
  }
}
    ${ThirdPartyBrokerFragmentDoc}`;
export const RemoveThirdPartyBrokerDocument = gql`
    mutation removeThirdPartyBroker($uuid: String!) {
  removeThirdPartyBroker(uuid: $uuid) {
    ...ThirdPartyBroker
  }
}
    ${ThirdPartyBrokerFragmentDoc}`;
export const ThirdPartyBrokersDocument = gql`
    query thirdPartyBrokers {
  thirdPartyBrokers {
    ...ThirdPartyBroker
  }
}
    ${ThirdPartyBrokerFragmentDoc}`;
export const UpdateThirdPartyBrokerDocument = gql`
    mutation updateThirdPartyBroker($thirdPartyBrokerUpdateInput: ThirdPartyBrokerUpdateInput!) {
  updateThirdPartyBroker(
    thirdPartyBrokerUpdateInput: $thirdPartyBrokerUpdateInput
  ) {
    ...ThirdPartyBroker
  }
}
    ${ThirdPartyBrokerFragmentDoc}`;
export const UpdateCompanyConfigurationDocument = gql`
    mutation updateCompanyConfiguration($updateCompanyConfigurationInput: UpdateCompanyConfigurationInput!) {
  updateCompanyConfiguration(
    updateCompanyConfigurationInput: $updateCompanyConfigurationInput
  ) {
    uuid
  }
}
    `;
export const UpdateCustomDriverFormDocument = gql`
    mutation updateCustomDriverForm($updateDriverSignableFormTemplateInput: UpdateDriverSignableFormTemplateInput!) {
  updateDriverSignableFormTemplate(
    updateDriverSignableFormTemplateInput: $updateDriverSignableFormTemplateInput
  ) {
    uuid
  }
}
    `;
export const UpdateDriverDocument = gql`
    mutation UpdateDriver($input: UpdateDriverInput!) {
  updateDriver(updateDriverInput: $input) {
    firstName
    lastName
    uuid
  }
}
    `;
export const UpdateEquipmentDocument = gql`
    mutation UpdateEquipment($input: UpdateEquipmentInput!) {
  updateEquipment(updateEquipmentInput: $input) {
    name
    uuid
  }
}
    `;
export const UpdateServiceDocument = gql`
    mutation updateService($input: UpdateServiceInput!) {
  updateService(updateServiceInput: $input) {
    uuid
    name
  }
}
    `;
export const UpdateTemplateAndRecordAddressesDocument = gql`
    mutation updateTemplateAndRecordAddresses($updateAddressInput: UpdateAddressInput!) {
  updateTemplateAndRecordAddresses(updateAddressInput: $updateAddressInput) {
    uuid
  }
}
    `;
export const CreateUserDocument = gql`
    mutation CreateUser($createUserInput: CreateUserInput!) {
  createUser(createUserInput: $createUserInput) {
    uuid
  }
}
    `;
export const ReportsEmailSenderIsVerifiedDocument = gql`
    query reportsEmailSenderIsVerified($userUuid: String!) {
  reportsEmailSenderIsVerified(userUuid: $userUuid)
}
    `;
export const UpdateUserDocument = gql`
    mutation UpdateUser($updateUserInput: UpdateUserInput!) {
  updateUser(updateUserInput: $updateUserInput) {
    uuid
    terminal {
      uuid
    }
  }
}
    `;
export const UpdateUserReportsEmailDocument = gql`
    mutation updateUserReportsEmail($userUuid: String!, $email: String!) {
  updateReportsEmail(userUuid: $userUuid, email: $email) {
    uuid
    reportsEmailSendgridSenderId
  }
}
    `;
export const UsersDocument = gql`
    query users($getUsersInput: GetUsersInput) {
  users(getUsersInput: $getUsersInput) {
    ...User
  }
}
    ${UserFragmentDoc}`;
export const ArchiveVehicleTypeDocument = gql`
    mutation ArchiveVehicleType($uuid: String!) {
  archiveVehicleType(uuid: $uuid) {
    vehicleType {
      ...VehicleType
    }
  }
}
    ${VehicleTypeFragmentDoc}`;
export const CreateVehicleTypeDocument = gql`
    mutation createVehicleType($vehicleTypeCreateInput: VehicleTypeCreateInput!) {
  createVehicleType(vehicleTypeCreateInput: $vehicleTypeCreateInput) {
    ...VehicleType
  }
}
    ${VehicleTypeFragmentDoc}`;
export const RestoreVehicleTypeDocument = gql`
    mutation RestoreVehicleType($uuid: String!) {
  restoreVehicleType(uuid: $uuid) {
    vehicleType {
      ...VehicleType
    }
  }
}
    ${VehicleTypeFragmentDoc}`;
export const UpdateVehicleTypeDocument = gql`
    mutation updateVehicleType($vehicleTypeUpdateInput: VehicleTypeUpdateInput!) {
  updateVehicleType(vehicleTypeUpdateInput: $vehicleTypeUpdateInput) {
    ...VehicleType
  }
}
    ${VehicleTypeFragmentDoc}`;
export const VehicleTypesMinimalDocument = gql`
    query VehicleTypesMinimal {
  vehicleTypes {
    uuid
    name
    status
  }
}
    `;
export const CreateWarehouseEmployeeDocument = gql`
    mutation createWarehouseEmployee($createWarehouseEmployeeInput: CreateWarehouseEmployeeInput!) {
  createWarehouseEmployee(
    createWarehouseEmployeeInput: $createWarehouseEmployeeInput
  ) {
    warehouseEmployee {
      ...CreatedWarehouseEmployee
    }
  }
}
    ${CreatedWarehouseEmployeeFragmentDoc}`;
export const WarehouseEmployeesDocument = gql`
    query warehouseEmployees {
  warehouseEmployees {
    warehouseEmployees {
      ...WarehouseEmployee
    }
  }
}
    ${WarehouseEmployeeFragmentDoc}`;
export const UpdateWarehouseEmployeeDocument = gql`
    mutation updateWarehouseEmployee($updateWarehouseEmployeeInput: UpdateWarehouseEmployeeInput!) {
  updateWarehouseEmployee(
    updateWarehouseEmployeeInput: $updateWarehouseEmployeeInput
  ) {
    warehouseEmployee {
      ...UpdatedWarehouseEmployee
    }
  }
}
    ${UpdatedWarehouseEmployeeFragmentDoc}`;
export const AcknowledgeNotificationDocument = gql`
    mutation acknowledgeNotification($uuid: String!) {
  acknowledgeNotification(uuid: $uuid) {
    uuid
  }
}
    `;
export const AcknowledgeNotificationsDocument = gql`
    mutation acknowledgeNotifications($uuids: [String!]!) {
  acknowledgeNotifications(uuids: $uuids) {
    uuid
  }
}
    `;
export const NotificationsDocument = gql`
    query notifications {
  notifications {
    ...Notification
  }
}
    ${NotificationFragmentDoc}`;
export const OrderAuditLogEntriesDocument = gql`
    query orderAuditLogEntries($getOrderAuditLogEntriesInput: GetOrderAuditLogEntriesInput!) {
  orderAuditLogEntries(
    getOrderAuditLogEntriesInput: $getOrderAuditLogEntriesInput
  ) {
    auditLogEntries {
      ...AuditLogEntry
    }
  }
}
    ${AuditLogEntryFragmentDoc}`;
export const OrderEventSnapshotsDocument = gql`
    query orderEventSnapshots($orderUuid: String!, $eventType: OrderEventType, $sortByCreatedAtAsc: Boolean) {
  orderEvents(
    orderUuid: $orderUuid
    eventType: $eventType
    sortByCreatedAtAsc: $sortByCreatedAtAsc
  ) {
    ...OrderEventSnapshot
  }
}
    ${OrderEventSnapshotFragmentDoc}`;
export const OrderEventsDocument = gql`
    query orderEvents($orderUuid: String, $storageOrderUuid: String) {
  orderEvents(orderUuid: $orderUuid, storageOrderUuid: $storageOrderUuid) {
    ...OrderEvent
    sourcePicklist {
      id
      outboundReferenceNumber
      picklistItemGroups(storageOrderUuid: $storageOrderUuid) {
        ...PicklistItemGroup
      }
    }
  }
}
    ${OrderEventFragmentDoc}
${PicklistItemGroupFragmentDoc}`;
export const EmailProcessingHistoryDocument = gql`
    query emailProcessingHistory($findIngestedOutlookEmailsInput: FindIngestedOutlookEmailsInput!) {
  ingestedOutlookEmails(
    findIngestedOutlookEmailsInput: $findIngestedOutlookEmailsInput
  ) {
    edges {
      node {
        uuid
        createdAt
        subject
        effectiveSenderAddress
        outlookReceivedDateTime
      }
    }
    pageInfo {
      startCursor
      endCursor
      hasNextPage
      hasPreviousPage
    }
  }
}
    `;
export const IngestedEmailOrderByOrderUuidDocument = gql`
    query ingestedEmailOrderByOrderUuid($uuid: String!) {
  scannedOrderResultByOrderUuid(uuid: $uuid) {
    uuid
    scannedOrder {
      ingestedOutlookEmailDetails {
        attachmentUuid
        fromAddress
        subject
      }
    }
  }
}
    `;
export const IngestedEmailOrdersDocument = gql`
    query ingestedEmailOrders($first: Int, $after: String, $last: Int, $before: String, $searchText: String, $contactUuid: String, $originTerminalUuid: String, $destinationTerminalUuid: String, $emailIntegrationTerminalUuid: String) {
  numberOfScannedOrderResultsInReview(
    searchText: $searchText
    sourceFilter: EMAIL_INTEGRATION
    contactUuid: $contactUuid
    originTerminalUuid: $originTerminalUuid
    destinationTerminalUuid: $destinationTerminalUuid
    emailIntegrationTerminalUuid: $emailIntegrationTerminalUuid
  )
  numberOfScannedOrderResultDuplicates(
    searchText: $searchText
    sourceFilter: EMAIL_INTEGRATION
    contactUuid: $contactUuid
    originTerminalUuid: $originTerminalUuid
    destinationTerminalUuid: $destinationTerminalUuid
    emailIntegrationTerminalUuid: $emailIntegrationTerminalUuid
  )
  scannedOrderResults(
    first: $first
    after: $after
    last: $last
    before: $before
    searchText: $searchText
    type: ORDER
    statuses: [IN_REVIEW]
    sourceFilter: EMAIL_INTEGRATION
    emailIntegrationTerminalUuid: $emailIntegrationTerminalUuid
    contactUuid: $contactUuid
    originTerminalUuid: $originTerminalUuid
    destinationTerminalUuid: $destinationTerminalUuid
  ) {
    edges {
      node {
        uuid
        createdAt
        duplicateOrder {
          uuid
          source
        }
        duplicateScannedOrderResultOrder {
          uuid
          source
        }
        status
        signedPodMatchStatus
        failureReason
        filename
        pageEnd
        pageStart
        order {
          uuid
          name
          source
          billingPartyContact {
            uuid
            displayName
          }
          standardOrderFields {
            shipperBillOfLadingNumber
          }
        }
        scannedOrder {
          ingestedOutlookEmailDetails {
            attachmentUuid
            fromAddress
            subject
            outlookIntegrationTerminal {
              uuid
              code
            }
          }
        }
      }
    }
    pageInfo {
      startCursor
      endCursor
      hasNextPage
      hasPreviousPage
    }
  }
}
    `;
export const IngestedOutlookEmailDocument = gql`
    query ingestedOutlookEmail($uuid: String!) {
  ingestedOutlookEmail(uuid: $uuid) {
    uuid
    subject
    attachments {
      uuid
      attachmentFilename
      processingStatus
      scannedOrder {
        uuid
        preSignedGetUrl
        scannedOrderResults {
          uuid
          filename
          pageStart
          pageEnd
          status
          failureReason
          order {
            uuid
          }
          duplicateOrder {
            uuid
            source
          }
          duplicateScannedOrderResultOrder {
            uuid
            source
          }
          scannedOrderResultDocuments {
            uuid
            preSignedGetUrl
            scannedOrderResultDocumentPages {
              uuid
              page
            }
          }
        }
      }
    }
  }
}
    `;
export const OutlookIntegrationsDocument = gql`
    query outlookIntegrations($getOutlookIntegrationsInput: GetOutlookIntegrationsInput!) {
  outlookIntegrations(getOutlookIntegrationsInput: $getOutlookIntegrationsInput) {
    uuid
    terminal {
      uuid
      code
    }
  }
}
    `;
export const AcceptCustomerPortalOrderDocument = gql`
    mutation acceptCustomerPortalOrder($acceptCustomerPortalOrderInput: AcceptCustomerPortalOrderInput!) {
  acceptCustomerPortalOrder(
    acceptCustomerPortalOrderInput: $acceptCustomerPortalOrderInput
  ) {
    ... on AcceptCustomerPortalOrderSuccessOutput {
      orderUuid
      acceptedAt
    }
    ... on MutationErrorOutput {
      message
    }
  }
}
    `;
export const RejectCustomerPortalOrderDocument = gql`
    mutation rejectCustomerPortalOrder($rejectCustomerPortalOrderInput: RejectCustomerPortalOrderInput!) {
  rejectCustomerPortalOrder(
    rejectCustomerPortalOrderInput: $rejectCustomerPortalOrderInput
  ) {
    ... on RejectCustomerPortalOrderSuccessOutput {
      orderUuid
      rejectedAt
    }
    ... on MutationErrorOutput {
      message
    }
  }
}
    `;
export const AcceptEdiOrApiOrderDocument = gql`
    mutation acceptEdiOrApiOrder($acceptEdiOrApiOrderInput: AcceptEdiOrApiOrderInput!) {
  acceptEdiOrApiOrder(acceptEdiOrApiOrderInput: $acceptEdiOrApiOrderInput) {
    uuid
  }
}
    `;
export const RejectEdiOrderDocument = gql`
    mutation rejectEdiOrder($rejectEdiOrderInput: RejectEdiOrderInput!) {
  rejectEdiOrder(rejectEdiOrderInput: $rejectEdiOrderInput) {
    uuid
  }
}
    `;
export const AccessorialForCustomChargeRowDocument = gql`
    query accessorialForCustomChargeRow($uuid: String!) {
  accessorial(uuid: $uuid) {
    ... on StandardAccessorialEntity {
      uuid
      isArchived
      name
    }
    ... on WeightBasedAccessorialEntity {
      uuid
      isArchived
      name
    }
    ... on ZoneBasedAccessorialEntity {
      uuid
      isArchived
      name
    }
    ... on WaitTimeAccessorialEntity {
      uuid
      isArchived
      name
    }
    ... on UnitBasedAccessorialEntity {
      uuid
      isArchived
      name
    }
    ... on SkidBasedAccessorialEntity {
      uuid
      isArchived
      name
    }
    ... on SpecialAccessorialEntity {
      uuid
      isArchived
      name
    }
  }
}
    `;
export const AccessorialsForCustomChargeRowDocument = gql`
    query accessorialsForCustomChargeRow($billingPartyContactUuid: String!, $terminalUuid: String) {
  accessorialsByBillingContact(
    billingPartyContactUuid: $billingPartyContactUuid
    terminalUuid: $terminalUuid
  ) {
    ... on StandardAccessorialEntity {
      uuid
      name
      enableQuickAdd
    }
    ... on WeightBasedAccessorialEntity {
      uuid
      name
      enableQuickAdd
    }
    ... on ZoneBasedAccessorialEntity {
      uuid
      name
      enableQuickAdd
    }
    ... on WaitTimeAccessorialEntity {
      uuid
      name
      enableQuickAdd
    }
    ... on UnitBasedAccessorialEntity {
      uuid
      name
      enableQuickAdd
    }
    ... on SkidBasedAccessorialEntity {
      uuid
      name
      enableQuickAdd
    }
    ... on SpecialAccessorialEntity {
      uuid
      name
      enableQuickAdd
    }
  }
}
    `;
export const PiecesGroupedByStatusDocument = gql`
    query piecesGroupedByStatus($piecesGroupedByStatusInput: PiecesGroupedByStatusInput!) {
  piecesGroupedByStatus(piecesGroupedByStatusInput: $piecesGroupedByStatusInput) {
    pieceGroups {
      status
      terminal {
        code
      }
      pieceCount
    }
  }
}
    `;
export const SendStopToAgentDocument = gql`
    mutation sendStopToAgent($sendStopToAgentInput: SendStopToAgentInput!) {
  sendStopToAgent(input: $sendStopToAgentInput) {
    ... on SendStopToAgentSuccessOutput {
      stop {
        uuid
      }
    }
    ... on MutationErrorOutput {
      message
    }
  }
}
    `;
export const UpdatePieceCountDocument = gql`
    mutation updatePieceCount($updatePieceCountInput: UpdatePieceCountInput!) {
  updatePieceCount(updatePieceCountInput: $updatePieceCountInput) {
    uuid
  }
}
    `;
export const VehicleTypeCapacityDocument = gql`
    query VehicleTypeCapacity($vehicleTypeUuid: String!) {
  vehicleType(uuid: $vehicleTypeUuid) {
    uuid
    capacityNotes
    maxWeight
    maxVolume
    vehicleTypePackageSpecs {
      id
      packageSpec {
        id
        name
      }
      maxQuantity
    }
  }
}
    `;
export const UnifiedSearchOrdersDocument = gql`
    query unifiedSearchOrders($unifiedSearchInput: UnifiedSearchInput!) {
  unifiedSearchOrders(unifiedSearchInput: $unifiedSearchInput) {
    ...UnifiedSearchOrders
  }
}
    ${UnifiedSearchOrdersFragmentDoc}`;
export const UnifiedSearchUnacceptedEmailOrdersDocument = gql`
    query unifiedSearchUnacceptedEmailOrders($unifiedSearchInput: UnifiedSearchInput!) {
  unifiedSearchUnacceptedEmailOrders(unifiedSearchInput: $unifiedSearchInput) {
    ...UnifiedSearchUnacceptedEmailOrders
  }
}
    ${UnifiedSearchUnacceptedEmailOrdersFragmentDoc}`;
export const UnifiedSearchUnacceptedEdiAndApiOrdersDocument = gql`
    query unifiedSearchUnacceptedEdiAndApiOrders($unifiedSearchInput: UnifiedSearchInput!) {
  unifiedSearchUnacceptedEdiAndApiOrders(unifiedSearchInput: $unifiedSearchInput) {
    ...UnifiedSearchUnacceptedEdiAndApiOrders
  }
}
    ${UnifiedSearchUnacceptedEdiAndApiOrdersFragmentDoc}`;
export const UnifiedSearchQuotesDocument = gql`
    query unifiedSearchQuotes($unifiedSearchInput: UnifiedSearchInput!) {
  unifiedSearchQuotes(unifiedSearchInput: $unifiedSearchInput) {
    ...UnifiedSearchQuotes
  }
}
    ${UnifiedSearchQuotesFragmentDoc}`;
export const UnifiedSearchInvoicesDocument = gql`
    query unifiedSearchInvoices($unifiedSearchInput: UnifiedSearchInput!) {
  unifiedSearchInvoices(unifiedSearchInput: $unifiedSearchInput) {
    ...UnifiedSearchInvoices
  }
}
    ${UnifiedSearchInvoicesFragmentDoc}`;
export const CreateInvoiceDocumentDocument = gql`
    mutation createInvoiceDocument($createInvoiceDocumentInput: CreateInvoiceDocumentInput!) {
  createInvoiceDocument(createInvoiceDocumentInput: $createInvoiceDocumentInput) {
    uuid
    bucket
    region
    region
    key
    fileName
    fileType
    type
  }
}
    `;
export const CreateOrderDocumentDocument = gql`
    mutation createOrderDocument($createOrderDocumentInput: CreateOrderDocumentInput!) {
  createOrderDocument(createOrderDocumentInput: $createOrderDocumentInput) {
    uuid
    bucket
    region
    key
    fileName
    fileType
    type
  }
}
    `;
export const ApiLogsDocument = gql`
    query apiLogs($first: Int, $after: String, $last: Int, $before: String, $createdAtDateFilters: [DateFilter!], $sortByCreatedAtDateAsc: Boolean, $isInvoiceEmails: Boolean!, $invoiceUuid: String, $emailTransactionStatus: EmailTransactionStatus, $isFreightSnap: Boolean!, $freightSnapTransactionStatus: FreightSnapTransactionStatus, $freightSnapFailureReason: FreightSnapFailureReason, $searchText: String) {
  apiLogs(
    first: $first
    after: $after
    last: $last
    before: $before
    createdAtDateFilters: $createdAtDateFilters
    sortByCreatedAtDateAsc: $sortByCreatedAtDateAsc
    isInvoiceEmails: $isInvoiceEmails
    invoiceUuid: $invoiceUuid
    emailTransactionStatus: $emailTransactionStatus
    isFreightSnap: $isFreightSnap
    freightSnapTransactionStatus: $freightSnapTransactionStatus
    freightSnapFailureReason: $freightSnapFailureReason
    searchText: $searchText
  ) {
    totalCount
    edges {
      node {
        ...ApiLog
      }
    }
    pageInfo {
      startCursor
      endCursor
      hasNextPage
      hasPreviousPage
    }
  }
}
    ${ApiLogFragmentDoc}`;
export const MatchFreightSnapDocument = gql`
    mutation matchFreightSnap($freightSnapCreateInput: FreightSnapCreateInput!) {
  matchFreightSnap(freightSnapCreateInput: $freightSnapCreateInput) {
    ...FreightSnapTransaction
  }
}
    ${FreightSnapTransactionFragmentDoc}`;
export const OrdersForArrivalNoticesDocument = gql`
    query ordersForArrivalNotices($uuids: [String!]!) {
  ordersByUuids(uuids: $uuids) {
    ...OrderForArrivalNotice
  }
}
    ${OrderForArrivalNoticeFragmentDoc}`;
export const ArriveAtStopsDocument = gql`
    mutation arriveAtStops($arriveAtStopsInput: ArriveAtStopsInput!) {
  arriveAtStops(arriveAtStopsInput: $arriveAtStopsInput) {
    ... on ArriveAtStopsSuccessOutput {
      arrivedStopUuids
      failedStopUuids
    }
    ... on MutationErrorOutput {
      message
    }
  }
}
    `;
export const AttemptStopsForDriverSettlementDocument = gql`
    query attemptStopsForDriverSettlement($uuid: String!) {
  leg(uuid: $uuid) {
    previousStopAttempts {
      ...StopForDriverSettlement
    }
  }
}
    ${StopForDriverSettlementFragmentDoc}`;
export const BulkEditOrdersDocument = gql`
    mutation bulkEditOrders($bulkEditOrdersInput: BulkEditOrdersInput!) {
  bulkEditOrders(bulkEditOrdersInput: $bulkEditOrdersInput)
}
    `;
export const CoverSheetDocumentTypeSequencesDocument = gql`
    query coverSheetDocumentTypeSequences {
  coverSheetDocumentTypeSequences {
    ...CoverSheetDocumentTypeSequence
  }
}
    ${CoverSheetDocumentTypeSequenceFragmentDoc}`;
export const CreateCoverSheetDocumentTypeSequenceDocument = gql`
    mutation createCoverSheetDocumentTypeSequence($input: CoverSheetDocumentTypeSequenceCreateInput!) {
  createCoverSheetDocumentTypeSequence(
    coverSheetDocumentTypeSequenceCreateInput: $input
  ) {
    uuid
  }
}
    `;
export const OrderCoverSheetsDocument = gql`
    query orderCoverSheets($getShipmentsInput: GetShipmentsInput) {
  shipments(getShipmentsInput: $getShipmentsInput) {
    ...OrderCoverSheetShipment
  }
}
    ${OrderCoverSheetShipmentFragmentDoc}`;
export const OrderInfosForCoverSheetsDocument = gql`
    query orderInfosForCoverSheets($uuids: [String!]!) {
  ordersByUuids(uuids: $uuids) {
    ...OrderInfoForCoverSheet
  }
}
    ${OrderInfoForCoverSheetFragmentDoc}`;
export const OrdersForCoverSheetsDocument = gql`
    query ordersForCoverSheets($uuids: [String!]!) {
  ordersByUuids(uuids: $uuids) {
    ...OrderForCoverSheet
  }
}
    ${OrderForCoverSheetFragmentDoc}`;
export const RemoveCoverSheetDocumentTypeSequenceDocument = gql`
    mutation removeCoverSheetDocumentTypeSequence($uuid: String!) {
  removeCoverSheetDocumentTypeSequence(uuid: $uuid) {
    uuid
  }
}
    `;
export const UpdateCoverSheetDocumentTypeSequenceDocument = gql`
    mutation updateCoverSheetDocumentTypeSequence($input: CoverSheetDocumentTypeSequenceUpdateInput!) {
  updateCoverSheetDocumentTypeSequence(
    coverSheetDocumentTypeSequenceUpdateInput: $input
  ) {
    uuid
  }
}
    `;
export const CreateAccountingReportDocumentDocument = gql`
    mutation createAccountingReportDocument($createAccountingReportDocumentInput: CreateBasicDocumentInput!) {
  createAccountingReportDocument(
    createAccountingReportDocumentInput: $createAccountingReportDocumentInput
  ) {
    document {
      uuid
      bucket
      region
      region
      key
      fileName
      fileType
      type
    }
  }
}
    `;
export const CreateEodDocumentsDocument = gql`
    mutation createEODDocuments($createEodDocumentsInput: CreateEodDocumentsInput!) {
  createEODDocuments(createEodDocumentsInput: $createEodDocumentsInput) {
    uuid
  }
}
    `;
export const CreateOrderCommentDocument = gql`
    mutation createOrderComment($createOrderCommentInput: CreateOrderCommentInput!) {
  createOrderComment(createOrderCommentInput: $createOrderCommentInput) {
    uuid
  }
}
    `;
export const CreateOrderDocumentDocumentDocument = gql`
    mutation createOrderDocumentDocument($createOrderDocumentDocumentInput: CreateOrderDocumentDocumentInput!) {
  createOrderDocumentDocument(
    createOrderDocumentDocumentInput: $createOrderDocumentDocumentInput
  ) {
    document {
      uuid
      bucket
      region
      region
      key
      fileName
      fileType
      type
    }
  }
}
    `;
export const CreateOrderSnapshotDocument = gql`
    mutation createOrderSnapshot($orderEventSnapshotCreateInput: OrderEventSnapshotCreateInput!) {
  createOrderSnapshot(
    orderEventSnapshotCreateInput: $orderEventSnapshotCreateInput
  ) {
    uuid
  }
}
    `;
export const CreateOrdersFromRecurringTemplatesDocument = gql`
    mutation createOrdersFromRecurringTemplates($uuids: [String!]!) {
  createOrdersFromRecurringTemplates(uuids: $uuids) {
    uuid
  }
}
    `;
export const CreatePodReportDocumentDocument = gql`
    mutation createPODReportDocument($createPodReportDocumentInput: CreatePodReportDocumentInput!) {
  createPODReportDocument(
    createPodReportDocumentInput: $createPodReportDocumentInput
  ) {
    document {
      uuid
      bucket
      region
      region
      key
      fileName
      fileType
      type
    }
  }
}
    `;
export const CreateRecurringRunDocument = gql`
    mutation createRecurringRun($input: CreateRunInput!) {
  createRun(createRunInput: $input) {
    run {
      uuid
    }
  }
}
    `;
export const CreateScannedOrdersDocument = gql`
    mutation createScannedOrders($createScannedOrdersInput: CreateScannedOrdersInput!) {
  createScannedOrders(createScannedOrdersInput: $createScannedOrdersInput)
}
    `;
export const MatchSignedPoDsDocument = gql`
    mutation matchSignedPODs($matchSignedPODsInput: CreateScannedOrdersInput!) {
  matchSignedPODs(matchSignedPODsInput: $matchSignedPODsInput)
}
    `;
export const CreateStandardOrderDocument = gql`
    mutation createStandardOrder($createStandardOrderInput: CreateStandardOrderInput!) {
  createStandardOrder(createStandardOrderInput: $createStandardOrderInput) {
    uuid
  }
}
    `;
export const CreateTagDocument = gql`
    mutation createTag($createTagInput: CreateTagInput!) {
  createTag(createTagInput: $createTagInput) {
    uuid
  }
}
    `;
export const CreateOrUpdateCsvOrdersDocument = gql`
    mutation createOrUpdateCsvOrders($createOrUpdateCsvOrdersInput: CreateOrUpdateCsvOrdersInput!) {
  createOrUpdateCsvOrders(
    createOrUpdateCsvOrdersInput: $createOrUpdateCsvOrdersInput
  ) {
    __typename
    ... on CreateOrUpdateCsvOrdersSuccessOutput {
      orders {
        ...CreateOrUpdateCsvOrdersOrder
      }
    }
    ... on MutationErrorOutput {
      message
    }
  }
}
    ${CreateOrUpdateCsvOrdersOrderFragmentDoc}`;
export const CsvOrderMappingsDocument = gql`
    query csvOrderMappings {
  csvOrderMappings {
    ...CsvOrderMapping
  }
}
    ${CsvOrderMappingFragmentDoc}`;
export const GenerateCsvOrderPreSignedPutUrlsDocument = gql`
    query generateCsvOrderPreSignedPutUrls($generateCsvOrderPresignedPutUrlInputs: [GenerateCsvOrderPresignedPutUrlInput!]!) {
  generateCsvOrderPreSignedPutUrls(
    generateCsvOrderPresignedPutUrlInputs: $generateCsvOrderPresignedPutUrlInputs
  ) {
    ...CsvOrderPreSignedPutUrl
  }
}
    ${CsvOrderPreSignedPutUrlFragmentDoc}`;
export const ParseCsvOrdersDocument = gql`
    mutation parseCsvOrders($parseCsvOrdersInput: ParseCsvOrdersInput!) {
  parseCsvOrders(input: $parseCsvOrdersInput) {
    __typename
    ... on ParseCsvOrdersSuccessOutput {
      parsedOrders {
        ...ParseCsvOrdersOrder
      }
      parsedOrderUpdates {
        ...ParseCsvOrdersOrderUpdate
      }
      errors {
        ...ParseCsvOrdersRowError
      }
      enableInboundStop
      enableOutboundStop
    }
    ... on MutationErrorOutput {
      message
    }
  }
}
    ${ParseCsvOrdersOrderFragmentDoc}
${ParseCsvOrdersOrderUpdateFragmentDoc}
${ParseCsvOrdersRowErrorFragmentDoc}`;
export const CurrentOrderStatusDocument = gql`
    query currentOrderStatus($uuid: String!) {
  order(uuid: $uuid) {
    ...CurrentOrderStatus
  }
}
    ${CurrentOrderStatusFragmentDoc}`;
export const DeleteOrderDocument = gql`
    mutation deleteOrder($uuid: String!) {
  deleteOrder(uuid: $uuid) {
    uuid
  }
}
    `;
export const DocumentsByOrderDocument = gql`
    query documentsByOrder($orderUuid: String!) {
  documents(orderUuid: $orderUuid) {
    ...Document
  }
}
    ${DocumentFragmentDoc}`;
export const EdiAndApiOrdersForReviewDocument = gql`
    query ediAndApiOrdersForReview($first: Int, $after: String, $last: Int, $before: String, $createdAtDateFilters: DateFilterStartEnd, $contactUuid: String, $sortByCreatedAtDateAsc: Boolean, $searchText: String, $originTerminalUuid: String, $destinationTerminalUuid: String) {
  ediAndApiOrdersForReview(
    first: $first
    after: $after
    last: $last
    before: $before
    createdAtDateFilters: $createdAtDateFilters
    contactUuid: $contactUuid
    sortByCreatedAtDateAsc: $sortByCreatedAtDateAsc
    searchText: $searchText
    originTerminalUuid: $originTerminalUuid
    destinationTerminalUuid: $destinationTerminalUuid
  ) {
    totalCount
    edges {
      node {
        ...OrderFragmentForEdiReview
      }
    }
    pageInfo {
      startCursor
      endCursor
      hasNextPage
      hasPreviousPage
    }
  }
}
    ${OrderFragmentForEdiReviewFragmentDoc}`;
export const EdiTransactionsDocument = gql`
    query ediTransactions($first: Int, $after: String, $last: Int, $before: String, $searchTerms: [String!]) {
  ediTransactions(
    first: $first
    after: $after
    last: $last
    before: $before
    searchTerms: $searchTerms
  ) {
    edges {
      node {
        ...EdiTransactionFragment
      }
    }
    pageInfo {
      startCursor
      endCursor
      hasNextPage
      hasPreviousPage
    }
  }
}
    ${EdiTransactionFragmentFragmentDoc}`;
export const OrderForEdiReviewByUuidDocument = gql`
    query orderForEdiReviewByUuid($uuid: String!) {
  order(uuid: $uuid) {
    ...OrderFragmentForEdiReview
  }
}
    ${OrderFragmentForEdiReviewFragmentDoc}`;
export const EmailOrderDocumentDocument = gql`
    mutation emailOrderDocument($emailOrderDocumentInput: EmailOrderDocumentInput!) {
  emailOrderDocument(emailOrderDocumentInput: $emailOrderDocumentInput) {
    status
  }
}
    `;
export const FetchMissingAccessorialDocument = gql`
    query fetchMissingAccessorial($uuid: String!) {
  accessorial(uuid: $uuid) {
    ... on StandardAccessorialEntity {
      __typename
      uuid
      name
    }
    ... on UnitBasedAccessorialEntity {
      __typename
      uuid
      name
    }
    ... on WaitTimeAccessorialEntity {
      __typename
      uuid
      name
    }
    ... on WeightBasedAccessorialEntity {
      __typename
      uuid
      name
    }
    ... on ZoneBasedAccessorialEntity {
      __typename
      uuid
      name
    }
    ... on SpecialAccessorialEntity {
      __typename
      uuid
      name
    }
  }
}
    `;
export const FinalizeOrderDocument = gql`
    mutation finalizeOrder($uuid: String!) {
  finalizeOrder(uuid: $uuid) {
    uuid
    status
    detailedStatusV2
    shipments {
      uuid
      status
    }
  }
}
    `;
export const FinalizeOrdersDocument = gql`
    mutation finalizeOrders($finalizeOrdersInput: FinalizeOrdersInput!) {
  finalizeOrders(finalizeOrdersInput: $finalizeOrdersInput) {
    __typename
    ... on MutationErrorOutput {
      message
    }
    ... on FinalizeOrdersSuccessOutput {
      finalizedOrderUuids
      failedOrderUuids
    }
  }
}
    `;
export const TerminalForAddressDocument = gql`
    query terminalForAddress($findTerminalForAddressInput: FindTerminalForAddressInput!) {
  terminalForAddress(findTerminalForAddressInput: $findTerminalForAddressInput) {
    terminal {
      name
      uuid
    }
  }
}
    `;
export const TerminalsForAddressDocument = gql`
    query terminalsForAddress($findTerminalForAddressInput: FindTerminalForAddressInput!) {
  terminalsForAddress(findTerminalForAddressInput: $findTerminalForAddressInput) {
    terminals {
      name
      uuid
    }
  }
}
    `;
export const GenerateAccountingReportPreSignedPutUrlDocument = gql`
    mutation generateAccountingReportPreSignedPutUrl($generateAccountingReportPreSignedPutUrlInput: GenerateAccountingReportPreSignedPutUrlInput!) {
  generateAccountingReportPreSignedPutUrl(
    generateAccountingReportPreSignedPutUrlInput: $generateAccountingReportPreSignedPutUrlInput
  )
}
    `;
export const GenerateOrderDocumentPreSignedPutUrlDocument = gql`
    mutation generateOrderDocumentPreSignedPutUrl($generateOrderDocumentPreSignedPutUrlInput: GenerateOrderDocumentPreSignedPutUrlInput!) {
  generateOrderDocumentPreSignedPutUrl(
    generateOrderDocumentPreSignedPutUrlInput: $generateOrderDocumentPreSignedPutUrlInput
  )
}
    `;
export const GenerateOrderPreSignedGetAndPutUrlsDocument = gql`
    mutation generateOrderPreSignedGetAndPutUrls($generateOrderPreSignedGetAndPutUrlsInput: GenerateOrderPreSignedGetAndPutUrlsInput!) {
  generateOrderPreSignedGetAndPutUrls(
    generateOrderPreSignedGetAndPutUrlsInput: $generateOrderPreSignedGetAndPutUrlsInput
  ) {
    getUrl
    putUrl
  }
}
    `;
export const GeneratePodReportPreSignedPutUrlDocument = gql`
    mutation generatePodReportPreSignedPutUrl($generatePodReportPreSignedPutUrlInput: GeneratePodReportPreSignedPutUrlInput!) {
  generatePodReportPreSignedPutUrl(
    generatePodReportPreSignedPutUrlInput: $generatePodReportPreSignedPutUrlInput
  )
}
    `;
export const GenerateContactPreSignedPutUrlDocument = gql`
    mutation generateContactPreSignedPutUrl($generateContactPreSignedPutUrlInput: GenerateContactPreSignedPutUrlInput!) {
  generateContactPreSignedPutUrl(
    generateContactPreSignedPutUrlInput: $generateContactPreSignedPutUrlInput
  ) {
    url
  }
}
    `;
export const GenerateInvoicePreSignedPutUrlDocument = gql`
    mutation generateInvoicePreSignedPutUrl($generateInvoicePreSignedPutUrlInput: GenerateInvoicePreSignedPutUrlInput!) {
  generateInvoicePreSignedPutUrl(
    generateInvoicePreSignedPutUrlInput: $generateInvoicePreSignedPutUrlInput
  )
}
    `;
export const GenerateOrderPreSignedPutUrlDocument = gql`
    mutation generateOrderPreSignedPutUrl($generateOrderPreSignedPutUrlInput: GenerateOrderPreSignedPutUrlInput!) {
  generateOrderPreSignedPutUrl(
    generateOrderPreSignedPutUrlInput: $generateOrderPreSignedPutUrlInput
  )
}
    `;
export const GenerateScannedOrderPreSignedPutUrlsDocument = gql`
    query generateScannedOrderPreSignedPutUrls($preSignedUrlRequests: [PreSignedUrlRequestInput!]!) {
  generateScannedOrderPreSignedPutUrls(
    preSignedUrlRequests: $preSignedUrlRequests
  ) {
    url
    bucket
    key
    filename
    filetype
  }
}
    `;
export const GeneratePreSignedPutUrlDocument = gql`
    mutation generatePreSignedPutUrl($fileName: String!, $fileType: String!) {
  generatePreSignedPutUrl(fileName: $fileName, fileType: $fileType)
}
    `;
export const IncompleteLegsWithAttemptsDocument = gql`
    query incompleteLegsWithAttempts {
  incompleteLegsWithAttempts {
    uuid
    previousStopAttempts {
      uuid
      completedAt
      address {
        name
        line1
      }
      leg {
        uuid
        shipment {
          order {
            standardOrderFields {
              shipperBillOfLadingNumber
            }
          }
        }
      }
      notes
    }
  }
}
    `;
export const LaneFromOriginAndDestinationTerminalDocument = gql`
    query laneFromOriginAndDestinationTerminal($findLaneFromOriginAndDestinationTerminalInput: FindLaneFromOriginAndDestinationTerminalInput!) {
  laneFromOriginAndDestinationTerminal(
    findLaneFromOriginAndDestinationTerminalInput: $findLaneFromOriginAndDestinationTerminalInput
  ) {
    lane {
      ...LineHaulLane
    }
  }
}
    ${LineHaulLaneFragmentDoc}`;
export const MarkOrderAsCompleteForceDocument = gql`
    mutation markOrderAsCompleteForce($markOrderAsCompleteForceInput: MarkOrderAsCompleteForceInput!) {
  markOrderAsCompleteForce(
    markOrderAsCompleteForceInput: $markOrderAsCompleteForceInput
  ) {
    uuid
    detailedStatusV2
    status
  }
}
    `;
export const MarkOrderAsHasBillingIssueDocument = gql`
    mutation markOrderAsHasBillingIssue($uuid: String!) {
  markOrderAsHasBillingIssue(uuid: $uuid) {
    uuid
    status
  }
}
    `;
export const MarkOrderAsNotCompleteDocument = gql`
    mutation markOrderAsNotComplete($uuid: String!) {
  markOrderAsNotComplete(uuid: $uuid) {
    uuid
    detailedStatusV2
    status
  }
}
    `;
export const MarkOrderAsNotOnHandDocument = gql`
    mutation markOrderAsNotOnHand($markAsNotOnHandInput: MarkAsNotOnHandInput!) {
  markOrderAsNotOnHand(markAsNotOnHandInput: $markAsNotOnHandInput) {
    uuid
    detailedStatusV2
    status
  }
}
    `;
export const MarkOrderAsNotReadyToInvoiceDocument = gql`
    mutation markOrderAsNotReadyToInvoice($uuid: String!) {
  markOrderAsNotReadyToInvoice(uuid: $uuid) {
    uuid
    status
  }
}
    `;
export const MarkOrderAsNotReceivedAtOriginDocument = gql`
    mutation markOrderAsNotReceivedAtOrigin($markAsNotReceivedAtOriginInput: MarkAsNotReceivedAtOriginInput!) {
  markOrderAsNotReceivedAtOrigin(
    markAsNotReceivedAtOriginInput: $markAsNotReceivedAtOriginInput
  ) {
    uuid
    detailedStatusV2
    status
  }
}
    `;
export const MarkOrderAsOnHandDocument = gql`
    mutation markOrderAsOnHand($markAsOnHandInput: MarkAsOnHandInput!) {
  markOrderAsOnHand(markAsOnHandInput: $markAsOnHandInput) {
    uuid
    receivedDate
    detailedStatusV2
    osd
    status
    shipments {
      standardShipmentFields {
        pickupOrDelivery
      }
      status
      legs {
        endStop {
          status
        }
      }
    }
  }
}
    `;
export const MarkOrderAsReadyToInvoiceForceDocument = gql`
    mutation markOrderAsReadyToInvoiceForce($uuid: String!, $refuseOrderInput: RefuseOrderInput) {
  markOrderAsReadyToInvoiceForce(uuid: $uuid, refuseOrderInput: $refuseOrderInput) {
    uuid
    detailedStatusV2
    status
  }
}
    `;
export const MarkOrderAsReadyToInvoiceDocument = gql`
    mutation markOrderAsReadyToInvoice($uuid: String!) {
  markOrderAsReadyToInvoice(uuid: $uuid) {
    uuid
    status
  }
}
    `;
export const MarkOrderAsReceivedAtOriginDocument = gql`
    mutation markOrderAsReceivedAtOrigin($markAsReceivedAtOriginInput: MarkAsReceivedAtOriginInput!) {
  markOrderAsReceivedAtOrigin(
    markAsReceivedAtOriginInput: $markAsReceivedAtOriginInput
  ) {
    uuid
    dateMarkedReceivedAtOrigin
    detailedStatusV2
    osd
    status
    shipments {
      standardShipmentFields {
        pickupOrDelivery
      }
      status
      legs {
        endStop {
          status
        }
      }
    }
  }
}
    `;
export const MarkOrderAsRefusedDocument = gql`
    mutation markOrderAsRefused($markOrderAsRefusedInput: MarkOrderAsRefusedInput!) {
  markOrderAsRefused(markOrderAsRefusedInput: $markOrderAsRefusedInput) {
    ... on MarkOrderAsRefusedSuccessOutput {
      success
    }
    ... on MutationErrorOutput {
      message
    }
  }
}
    `;
export const MarkOrderAsNotOsdDocument = gql`
    mutation markOrderAsNotOsd($markAsNotOsd: MarkNotOsdInput!) {
  markNotOsd(markAsNotOsd: $markAsNotOsd) {
    uuid
    status
    detailedStatusV2
  }
}
    `;
export const MarkOrderAsOsdDocument = gql`
    mutation markOrderAsOSD($markOsdInput: MarkOsdInput!) {
  markOsd(markOsdInput: $markOsdInput) {
    ...MarkOsdOrder
  }
}
    ${MarkOsdOrderFragmentDoc}`;
export const MergeEdiOrderDocument = gql`
    mutation mergeEdiOrder($mergeEdiOrderInput: MergeEdiOrderInput!) {
  mergeEdiOrder(mergeEdiOrderInput: $mergeEdiOrderInput) {
    uuid
  }
}
    `;
export const OpenMessageInOutlookDocument = gql`
    mutation openMessageInOutlook($openMessageInOutlookInput: OpenMessageInOutlookInput!) {
  openMessageInOutlook(openMessageInOutlookInput: $openMessageInOutlookInput) {
    linkToOpen
  }
}
    `;
export const DeleteOrderCommentDocument = gql`
    mutation deleteOrderComment($deleteOrderCommentInput: DeleteOrderCommentInput!) {
  deleteOrderComment(deleteOrderCommentInput: $deleteOrderCommentInput) {
    ... on DeleteOrderCommentSuccessOutput {
      success
    }
    ... on MutationErrorOutput {
      message
    }
  }
}
    `;
export const UpdateOrderCommentDocument = gql`
    mutation updateOrderComment($updateOrderCommentInput: UpdateOrderCommentInput!) {
  updateOrderComment(updateOrderCommentInput: $updateOrderCommentInput) {
    uuid
  }
}
    `;
export const StandardOrderForContextMenuDocument = gql`
    query standardOrderForContextMenu($uuid: String!) {
  standardOrder(uuid: $uuid) {
    ...StandardOrderForContextMenu
  }
}
    ${StandardOrderForContextMenuFragmentDoc}`;
export const OrdersForDocumentAttachmentsDownloadDocument = gql`
    query ordersForDocumentAttachmentsDownload($uuids: [String!]!) {
  ordersByUuids(uuids: $uuids) {
    ...OrderForDocumentAttachmentsDownload
  }
}
    ${OrderForDocumentAttachmentsDownloadFragmentDoc}`;
export const OrderNameDocument = gql`
    query orderName($billingPartyContactUuid: String!) {
  orderName(billingPartyContactUuid: $billingPartyContactUuid)
}
    `;
export const OrderPodReportsDocument = gql`
    query orderPodReports($getShipmentsInput: GetShipmentsInput) {
  shipments(getShipmentsInput: $getShipmentsInput) {
    ...OrderPodReportShipment
  }
}
    ${OrderPodReportShipmentFragmentDoc}`;
export const OrderUpdatedAtDocument = gql`
    query orderUpdatedAt($uuid: String!) {
  order(uuid: $uuid) {
    updatedAt
    lastUpdatedByUser {
      uuid
    }
  }
}
    `;
export const OrderDocument = gql`
    query order($uuid: String!) {
  order(uuid: $uuid) {
    uuid
    name
    status
    notes
    pieceCount
    receivedDate
    pickedDate
    onHand
    standardOrderFields {
      shipperBillOfLadingNumber
    }
    shipments {
      uuid
      packages {
        description
      }
    }
    documents {
      ...Document
    }
  }
}
    ${DocumentFragmentDoc}`;
export const OrdersBySecondaryRefNumberDocument = gql`
    query ordersBySecondaryRefNumber($secondaryRefNumber: String!) {
  ordersBySecondaryRefNumber(secondaryRefNumber: $secondaryRefNumber) {
    uuid
    createdAt
    name
  }
}
    `;
export const OrdersByShipperBillOfLadingNumberDocument = gql`
    query ordersByShipperBillOfLadingNumber($shipperBillOfLadingNumber: String!, $includeInReviewScannedOrdersFromEmail: Boolean, $includeInReviewEdiOrders: Boolean) {
  ordersByShipperBillOfLadingNumber(
    shipperBillOfLadingNumber: $shipperBillOfLadingNumber
    includeInReviewScannedOrdersFromEmail: $includeInReviewScannedOrdersFromEmail
    includeInReviewEdiOrders: $includeInReviewEdiOrders
  ) {
    ...OrderForOrdersByShipperBillOfLadingNumber
  }
}
    ${OrderForOrdersByShipperBillOfLadingNumberFragmentDoc}`;
export const OrdersByUuidsForBulkEditDocument = gql`
    query ordersByUuidsForBulkEdit($uuids: [String!]!) {
  ordersByUuids(uuids: $uuids) {
    ...OrderForBulkEdit
  }
}
    ${OrderForBulkEditFragmentDoc}`;
export const OrdersForBulkEditDocument = gql`
    query ordersForBulkEdit($addressCityFilter: StringFilter, $addressZipFilter: StringFilter, $attemptedAtDateFilters: DateFilterStartEnd, $completionDateFilters: DateFilterStartEnd, $deadlineDateFilters: DateFilterStartEnd, $receivedDateFilters: DateFilterStartEnd, $createdAtDateFilters: DateFilterStartEnd, $expectedInboundArrivalDateFilters: DateFilterStartEnd, $invoiceDateFilters: DateFilterStartEnd, $scheduledAtDateFilters: DateFilterStartEnd, $primaryAppointmentDateFilters: DateFilterStartEnd, $orderNumberFilter: StringFilter, $billingPartyContactUuidFilter: StringFilter, $businessDivisionUuidFilter: StringFilter, $terminalUuidFilter: StringFilter, $activeTerminalUuidFilter: StringFilter, $originTerminalUuidFilter: StringFilterNullable, $destinationTerminalUuidFilter: StringFilterNullable, $driverUuidFilter: StringFilter, $shipperFilter: StringFilter, $consigneeFilter: StringFilter, $statusFilters: [StatusFilter!], $shipmentStatusFilters: [ShipmentStatusFilter!], $first: Int, $after: String, $last: Int, $before: String, $searchText: String, $multipleSearches: [String!], $scheduledFilter: BooleanFilter, $outForDeliveryFilter: BooleanFilter, $onHand: BooleanFilter, $onInvoice: BooleanFilter, $isCancelled: BooleanFilter, $isRefused: BooleanFilter, $isFinalized: BooleanFilter, $isPicked: BooleanFilter, $isOsd: BooleanFilter, $isSpecial: BooleanFilter, $orderSource: OrderSource, $noMaximum: Boolean, $hasAppointmentScheduled: BooleanFilter, $appointmentRequired: BooleanFilter, $hasContactInformation: BooleanFilter, $hasFailures: BooleanFilter, $hasRoute: BooleanFilter, $hawbFilter: StringFilterV2, $mawbFilter: StringFilterV2, $hideFromBilling: BooleanFilter, $paperworkComplete: BooleanFilter, $pickupOrDelivery: PickupOrDelivery, $isPickupOrDelivery: BooleanFilter, $inboundNotArrived: BooleanFilter, $requiresRouting: BooleanFilter, $requiresRecovery: BooleanFilter, $serviceDateFilters: DateFilterStartEnd, $serviceDateFilter: DateFilterV2, $serviceUuids: [String!], $lineHaulLaneUuids: [String!], $showConsolidatedOrders: BooleanFilter, $standardStopType: StandardStopType, $stopTypesFilter: StopTypesFilter, $tagUuids: [String!], $totalCount: Boolean, $transferPending: BooleanFilter, $uuids: [String!], $searchHawbOnly: Boolean, $searchRefNumbersOnly: Boolean, $searchMiscInfoOnly: Boolean, $useMultiSearch: Boolean, $sorts: [OrderSort!], $noTerminal: BooleanFilter, $billingPartyContactUuidsFilter: StringsFilter, $terminalUuidsFilter: StringsFilter, $driverUuidsFilter: StringsFilter, $tagUuidsFilter: StringsFilter, $canDispatchFilter: BooleanFilterV2, $inboundRoutingFilter: StringFilterV2, $outboundRoutingFilter: StringFilterV2, $proofOfDeliverySigneeFilter: StringFilterV2) {
  orders(
    first: $first
    last: $last
    after: $after
    before: $before
    addressCityFilter: $addressCityFilter
    addressZipFilter: $addressZipFilter
    attemptedAtDateFilters: $attemptedAtDateFilters
    billingPartyContactUuidFilter: $billingPartyContactUuidFilter
    businessDivisionUuidFilter: $businessDivisionUuidFilter
    terminalUuidFilter: $terminalUuidFilter
    activeTerminalUuidFilter: $activeTerminalUuidFilter
    originTerminalUuidFilter: $originTerminalUuidFilter
    destinationTerminalUuidFilter: $destinationTerminalUuidFilter
    driverUuidFilter: $driverUuidFilter
    completionDateFilters: $completionDateFilters
    deadlineDateFilters: $deadlineDateFilters
    receivedDateFilters: $receivedDateFilters
    createdAtDateFilters: $createdAtDateFilters
    scheduledAtDateFilters: $scheduledAtDateFilters
    primaryAppointmentDateFilters: $primaryAppointmentDateFilters
    expectedInboundArrivalDateFilters: $expectedInboundArrivalDateFilters
    invoiceDateFilters: $invoiceDateFilters
    consigneeFilter: $consigneeFilter
    hasAppointmentScheduled: $hasAppointmentScheduled
    appointmentRequired: $appointmentRequired
    hasContactInformation: $hasContactInformation
    hasFailures: $hasFailures
    hasRoute: $hasRoute
    hawbFilter: $hawbFilter
    mawbFilter: $mawbFilter
    hideFromBilling: $hideFromBilling
    noMaximum: $noMaximum
    orderNumberFilter: $orderNumberFilter
    onHand: $onHand
    onInvoice: $onInvoice
    isCancelled: $isCancelled
    isRefused: $isRefused
    isFinalized: $isFinalized
    isPicked: $isPicked
    isOsd: $isOsd
    multipleSearches: $multipleSearches
    isSpecial: $isSpecial
    orderSource: $orderSource
    outForDeliveryFilter: $outForDeliveryFilter
    paperworkComplete: $paperworkComplete
    pickupOrDelivery: $pickupOrDelivery
    isPickupOrDelivery: $isPickupOrDelivery
    inboundNotArrived: $inboundNotArrived
    requiresRouting: $requiresRouting
    requiresRecovery: $requiresRecovery
    scheduledFilter: $scheduledFilter
    searchText: $searchText
    serviceDateFilters: $serviceDateFilters
    serviceDateFilter: $serviceDateFilter
    serviceUuids: $serviceUuids
    lineHaulLaneUuids: $lineHaulLaneUuids
    showConsolidatedOrders: $showConsolidatedOrders
    shipperFilter: $shipperFilter
    statusFilters: $statusFilters
    shipmentStatusFilters: $shipmentStatusFilters
    standardStopType: $standardStopType
    stopTypesFilter: $stopTypesFilter
    tagUuids: $tagUuids
    transferPending: $transferPending
    totalCount: $totalCount
    uuids: $uuids
    searchHawbOnly: $searchHawbOnly
    searchRefNumbersOnly: $searchRefNumbersOnly
    searchMiscInfoOnly: $searchMiscInfoOnly
    useMultiSearch: $useMultiSearch
    noTerminal: $noTerminal
    billingPartyContactUuidsFilter: $billingPartyContactUuidsFilter
    terminalUuidsFilter: $terminalUuidsFilter
    driverUuidsFilter: $driverUuidsFilter
    tagUuidsFilter: $tagUuidsFilter
    sorts: $sorts
    canDispatchFilter: $canDispatchFilter
    inboundRoutingFilter: $inboundRoutingFilter
    outboundRoutingFilter: $outboundRoutingFilter
    proofOfDeliverySigneeFilter: $proofOfDeliverySigneeFilter
  ) {
    totalCount
    edges {
      node {
        ...OrderForBulkEdit
      }
    }
    pageInfo {
      startCursor
      endCursor
      hasNextPage
      hasPreviousPage
    }
  }
}
    ${OrderForBulkEditFragmentDoc}`;
export const OrdersForInventoryLabelsDocument = gql`
    query ordersForInventoryLabels($uuids: [String!]!) {
  ordersByUuids(uuids: $uuids) {
    ...OrderForInventoryLabel
  }
}
    ${OrderForInventoryLabelFragmentDoc}`;
export const OrdersForOrderMatchingDocument = gql`
    query ordersForOrderMatching($addressCityFilter: StringFilter, $addressZipFilter: StringFilter, $attemptedAtDateFilters: DateFilterStartEnd, $completionDateFilters: DateFilterStartEnd, $deadlineDateFilters: DateFilterStartEnd, $receivedDateFilters: DateFilterStartEnd, $createdAtDateFilters: DateFilterStartEnd, $expectedInboundArrivalDateFilters: DateFilterStartEnd, $invoiceDateFilters: DateFilterStartEnd, $scheduledAtDateFilters: DateFilterStartEnd, $orderNumberFilter: StringFilter, $billingPartyContactUuidFilter: StringFilter, $driverUuidFilter: StringFilter, $shipperFilter: StringFilter, $consigneeFilter: StringFilter, $statusFilters: [StatusFilter!], $shipmentStatusFilters: [ShipmentStatusFilter!], $first: Int, $after: String, $last: Int, $before: String, $searchText: String, $scheduledFilter: BooleanFilter, $outForDeliveryFilter: BooleanFilter, $onHand: BooleanFilter, $onInvoice: BooleanFilter, $isCancelled: BooleanFilter, $isRefused: BooleanFilter, $isFinalized: BooleanFilter, $isPicked: BooleanFilter, $isOsd: BooleanFilter, $isSpecial: BooleanFilter, $orderSource: OrderSource, $noMaximum: Boolean, $hasAppointmentScheduled: BooleanFilter, $appointmentRequired: BooleanFilter, $hasContactInformation: BooleanFilter, $hasFailures: BooleanFilter, $hasRoute: BooleanFilter, $hideFromBilling: BooleanFilter, $paperworkComplete: BooleanFilter, $pickupOrDelivery: PickupOrDelivery, $isPickupOrDelivery: BooleanFilter, $inboundNotArrived: BooleanFilter, $requiresRouting: BooleanFilter, $requiresRecovery: BooleanFilter, $serviceUuids: [String!], $lineHaulLaneUuids: [String!], $showConsolidatedOrders: BooleanFilter, $standardStopType: StandardStopType, $stopTypesFilter: StopTypesFilter, $tagUuids: [String!], $totalCount: Boolean, $transferPending: BooleanFilter) {
  orders(
    first: $first
    last: $last
    after: $after
    before: $before
    addressCityFilter: $addressCityFilter
    addressZipFilter: $addressZipFilter
    attemptedAtDateFilters: $attemptedAtDateFilters
    billingPartyContactUuidFilter: $billingPartyContactUuidFilter
    driverUuidFilter: $driverUuidFilter
    completionDateFilters: $completionDateFilters
    deadlineDateFilters: $deadlineDateFilters
    receivedDateFilters: $receivedDateFilters
    createdAtDateFilters: $createdAtDateFilters
    scheduledAtDateFilters: $scheduledAtDateFilters
    expectedInboundArrivalDateFilters: $expectedInboundArrivalDateFilters
    invoiceDateFilters: $invoiceDateFilters
    consigneeFilter: $consigneeFilter
    hasAppointmentScheduled: $hasAppointmentScheduled
    appointmentRequired: $appointmentRequired
    hasContactInformation: $hasContactInformation
    hasFailures: $hasFailures
    hasRoute: $hasRoute
    hideFromBilling: $hideFromBilling
    noMaximum: $noMaximum
    orderNumberFilter: $orderNumberFilter
    onHand: $onHand
    onInvoice: $onInvoice
    isCancelled: $isCancelled
    isRefused: $isRefused
    isFinalized: $isFinalized
    isPicked: $isPicked
    isOsd: $isOsd
    isSpecial: $isSpecial
    orderSource: $orderSource
    outForDeliveryFilter: $outForDeliveryFilter
    paperworkComplete: $paperworkComplete
    pickupOrDelivery: $pickupOrDelivery
    isPickupOrDelivery: $isPickupOrDelivery
    inboundNotArrived: $inboundNotArrived
    requiresRouting: $requiresRouting
    requiresRecovery: $requiresRecovery
    scheduledFilter: $scheduledFilter
    searchText: $searchText
    serviceUuids: $serviceUuids
    lineHaulLaneUuids: $lineHaulLaneUuids
    showConsolidatedOrders: $showConsolidatedOrders
    shipperFilter: $shipperFilter
    statusFilters: $statusFilters
    shipmentStatusFilters: $shipmentStatusFilters
    standardStopType: $standardStopType
    stopTypesFilter: $stopTypesFilter
    tagUuids: $tagUuids
    transferPending: $transferPending
    totalCount: $totalCount
  ) {
    totalCount
    edges {
      node {
        ...OrderForOrderMatching
      }
    }
    pageInfo {
      startCursor
      endCursor
      hasNextPage
      hasPreviousPage
    }
  }
}
    ${OrderForOrderMatchingFragmentDoc}`;
export const CreateOrderTableReportDocument = gql`
    mutation createOrderTableReport($createOrderTableReportInput: CreateOrderTableReportInput!) {
  createOrderTableReport(
    createOrderTableReportInput: $createOrderTableReportInput
  ) {
    ... on OrderTableReportDownloadOutput {
      reportGenerationStatus
      reportUrl
    }
    ... on OrderTableReportEmailToUserOutput {
      reportGenerationStatus
    }
  }
}
    `;
export const GetOrderTableFieldValuesForCountDocument = gql`
    query getOrderTableFieldValuesForCount($getOrderTableFieldValuesInput: GetOrderTableFieldValuesInput!) {
  getOrderTableFieldValues(
    getOrderTableFieldValuesInput: $getOrderTableFieldValuesInput
  ) {
    ...OrderTableFieldValuesOutput
  }
}
    ${OrderTableFieldValuesOutputFragmentDoc}`;
export const GetOrderTableFieldValuesForSearchDocument = gql`
    query getOrderTableFieldValuesForSearch($getOrderTableFieldValuesInput: GetOrderTableFieldValuesInput!) {
  getOrderTableFieldValues(
    getOrderTableFieldValuesInput: $getOrderTableFieldValuesInput
  ) {
    ...OrderTableFieldValuesOutput
  }
}
    ${OrderTableFieldValuesOutputFragmentDoc}`;
export const GetOrderTableFieldValuesDocument = gql`
    query getOrderTableFieldValues($getOrderTableFieldValuesInput: GetOrderTableFieldValuesInput!) {
  getOrderTableFieldValues(
    getOrderTableFieldValuesInput: $getOrderTableFieldValuesInput
  ) {
    ...OrderTableFieldValuesOutput
  }
}
    ${OrderTableFieldValuesOutputFragmentDoc}`;
export const OrderCommentsDocument = gql`
    query orderComments($orderUuid: String!) {
  orderComments(orderUuid: $orderUuid) {
    uuid
    createdAt
    updatedAt
    comment
    user {
      uuid
      email
    }
  }
}
    `;
export const OrderTableFieldHeadersDocument = gql`
    query orderTableFieldHeaders {
  orderTableFieldHeaders {
    orderTableFieldHeaders {
      ...OrderTableFieldHeader
    }
  }
}
    ${OrderTableFieldHeaderFragmentDoc}`;
export const OrderUuidsDocument = gql`
    query orderUuids($addressCityFilter: StringFilter, $addressZipFilter: StringFilter, $attemptedAtDateFilters: DateFilterStartEnd, $completionDateFilters: DateFilterStartEnd, $deadlineDateFilters: DateFilterStartEnd, $receivedDateFilters: DateFilterStartEnd, $createdAtDateFilters: DateFilterStartEnd, $expectedInboundArrivalDateFilters: DateFilterStartEnd, $invoiceDateFilters: DateFilterStartEnd, $scheduledAtDateFilters: DateFilterStartEnd, $primaryAppointmentDateFilters: DateFilterStartEnd, $orderNumberFilter: StringFilter, $billingPartyContactUuidFilter: StringFilter, $billingPartyContactDisplayNameFilter: StringFilter, $businessDivisionUuidFilter: StringFilter, $terminalUuidFilter: StringFilter, $activeTerminalUuidFilter: StringFilter, $originTerminalUuidFilter: StringFilterNullable, $destinationTerminalUuidFilter: StringFilterNullable, $driverUuidFilter: StringFilter, $shipperFilter: StringFilter, $consigneeFilter: StringFilter, $statusFilters: [StatusFilter!], $shipmentStatusFilters: [ShipmentStatusFilter!], $first: Int, $after: String, $last: Int, $before: String, $searchText: String, $multipleSearches: [String!], $scheduledFilter: BooleanFilter, $outForDeliveryFilter: BooleanFilter, $onHand: BooleanFilter, $onInvoice: BooleanFilter, $isCancelled: BooleanFilter, $isRefused: BooleanFilter, $isFinalized: BooleanFilter, $isPicked: BooleanFilter, $isOsd: BooleanFilter, $isSpecial: BooleanFilter, $orderSource: OrderSource, $noMaximum: Boolean, $hasAppointmentScheduled: BooleanFilter, $appointmentRequired: BooleanFilter, $hasContactInformation: BooleanFilter, $hasFailures: BooleanFilter, $hasRoute: BooleanFilter, $hideFromBilling: BooleanFilter, $paperworkComplete: BooleanFilter, $pickupOrDelivery: PickupOrDelivery, $isPickupOrDelivery: BooleanFilter, $inboundNotArrived: BooleanFilter, $requiresRouting: BooleanFilter, $requiresRecovery: BooleanFilter, $serviceDateFilters: DateFilterStartEnd, $serviceDateFilter: DateFilterV2, $serviceUuids: [String!], $lineHaulLaneUuids: [String!], $showConsolidatedOrders: BooleanFilter, $standardStopType: StandardStopType, $stopTypesFilter: StopTypesFilter, $tagUuids: [String!], $transferPending: BooleanFilter, $uuids: [String!], $searchHawbOnly: Boolean, $searchRefNumbersOnly: Boolean, $searchMiscInfoOnly: Boolean, $useMultiSearch: Boolean, $sorts: [OrderSort!], $noTerminal: BooleanFilter, $isCollectOnDelivery: Boolean, $isHazmat: BooleanFilter, $isInBond: BooleanFilter, $billingPartyContactUuidsFilter: StringsFilter, $terminalUuidsFilter: StringsFilter, $driverUuidsFilter: StringsFilter, $tagUuidsFilter: StringsFilter) {
  orders(
    first: $first
    last: $last
    after: $after
    before: $before
    addressCityFilter: $addressCityFilter
    addressZipFilter: $addressZipFilter
    attemptedAtDateFilters: $attemptedAtDateFilters
    billingPartyContactUuidFilter: $billingPartyContactUuidFilter
    billingPartyContactDisplayNameFilter: $billingPartyContactDisplayNameFilter
    businessDivisionUuidFilter: $businessDivisionUuidFilter
    terminalUuidFilter: $terminalUuidFilter
    activeTerminalUuidFilter: $activeTerminalUuidFilter
    originTerminalUuidFilter: $originTerminalUuidFilter
    destinationTerminalUuidFilter: $destinationTerminalUuidFilter
    driverUuidFilter: $driverUuidFilter
    completionDateFilters: $completionDateFilters
    deadlineDateFilters: $deadlineDateFilters
    receivedDateFilters: $receivedDateFilters
    createdAtDateFilters: $createdAtDateFilters
    scheduledAtDateFilters: $scheduledAtDateFilters
    primaryAppointmentDateFilters: $primaryAppointmentDateFilters
    expectedInboundArrivalDateFilters: $expectedInboundArrivalDateFilters
    invoiceDateFilters: $invoiceDateFilters
    consigneeFilter: $consigneeFilter
    hasAppointmentScheduled: $hasAppointmentScheduled
    appointmentRequired: $appointmentRequired
    hasContactInformation: $hasContactInformation
    hasFailures: $hasFailures
    hasRoute: $hasRoute
    hideFromBilling: $hideFromBilling
    noMaximum: $noMaximum
    orderNumberFilter: $orderNumberFilter
    onHand: $onHand
    onInvoice: $onInvoice
    isCancelled: $isCancelled
    isRefused: $isRefused
    isFinalized: $isFinalized
    isPicked: $isPicked
    isOsd: $isOsd
    multipleSearches: $multipleSearches
    isSpecial: $isSpecial
    orderSource: $orderSource
    outForDeliveryFilter: $outForDeliveryFilter
    paperworkComplete: $paperworkComplete
    pickupOrDelivery: $pickupOrDelivery
    isPickupOrDelivery: $isPickupOrDelivery
    inboundNotArrived: $inboundNotArrived
    requiresRouting: $requiresRouting
    requiresRecovery: $requiresRecovery
    scheduledFilter: $scheduledFilter
    searchText: $searchText
    serviceDateFilters: $serviceDateFilters
    serviceDateFilter: $serviceDateFilter
    serviceUuids: $serviceUuids
    lineHaulLaneUuids: $lineHaulLaneUuids
    showConsolidatedOrders: $showConsolidatedOrders
    shipperFilter: $shipperFilter
    statusFilters: $statusFilters
    shipmentStatusFilters: $shipmentStatusFilters
    standardStopType: $standardStopType
    stopTypesFilter: $stopTypesFilter
    tagUuids: $tagUuids
    transferPending: $transferPending
    uuids: $uuids
    searchHawbOnly: $searchHawbOnly
    searchRefNumbersOnly: $searchRefNumbersOnly
    searchMiscInfoOnly: $searchMiscInfoOnly
    useMultiSearch: $useMultiSearch
    noTerminal: $noTerminal
    sorts: $sorts
    isCollectOnDelivery: $isCollectOnDelivery
    isHazmat: $isHazmat
    isInBond: $isInBond
    billingPartyContactUuidsFilter: $billingPartyContactUuidsFilter
    terminalUuidsFilter: $terminalUuidsFilter
    driverUuidsFilter: $driverUuidsFilter
    tagUuidsFilter: $tagUuidsFilter
  ) {
    totalCount
    edges {
      node {
        uuid
      }
    }
    pageInfo {
      startCursor
      endCursor
      hasNextPage
      hasPreviousPage
    }
  }
}
    `;
export const OrderWithInboundOutboundPaperworkDocument = gql`
    query orderWithInboundOutboundPaperwork($uuid: String!) {
  order(uuid: $uuid) {
    paperwork {
      ...OrderPaperwork
    }
    inboundPaperwork {
      ...OrderPaperworkWithGroupedDocuments
    }
    outboundPaperwork {
      ...OrderPaperworkWithGroupedDocuments
    }
  }
}
    ${OrderPaperworkFragmentDoc}
${OrderPaperworkWithGroupedDocumentsFragmentDoc}`;
export const OrderWithItemizedChargesDocument = gql`
    query orderWithItemizedCharges($uuid: String!) {
  getOrderTableFieldValues(
    getOrderTableFieldValuesInput: {uuids: [$uuid], includeOrders: true, orderTableFields: [TOTAL_CHARGES_WITH_ITEMIZED]}
  ) {
    formattedOrderConnection {
      edges {
        node {
          uuid
          itemizedChargesField {
            ...OrderTableFieldItemizedCharges
          }
        }
      }
    }
  }
}
    ${OrderTableFieldItemizedChargesFragmentDoc}`;
export const OrderWithMissingDocumentsDocument = gql`
    query orderWithMissingDocuments($uuid: String!) {
  order(uuid: $uuid) {
    ...OrderWithMissingDocuments
  }
}
    ${OrderWithMissingDocumentsFragmentDoc}`;
export const OrderWithPaperworkDocument = gql`
    query orderWithPaperwork($uuid: String!) {
  order(uuid: $uuid) {
    ...OrderWithPaperwork
  }
}
    ${OrderWithPaperworkFragmentDoc}`;
export const PackageSpecsDocument = gql`
    query PackageSpecs {
  packageSpecs {
    packageSpecs {
      id
      name
      weight
      length
      width
      height
      status
    }
  }
}
    `;
export const RecurringOrderTemplatesDocument = gql`
    query recurringOrderTemplates($runUuid: String) {
  recurringOrderTemplates(runUuid: $runUuid) {
    ...RecurringOrderTemplate
  }
}
    ${RecurringOrderTemplateFragmentDoc}`;
export const RecurringRunsDocument = gql`
    query recurringRuns {
  recurringRuns {
    ...RecurringRunTemplate
  }
}
    ${RecurringRunTemplateFragmentDoc}`;
export const RemoveOrderHoldDocument = gql`
    mutation removeOrderHold($removeOrderHoldInput: RemoveOrderHoldInput!) {
  removeOrderHold(removeOrderHoldInput: $removeOrderHoldInput) {
    uuid
    status
    detailedStatusV2
  }
}
    `;
export const RemoveSubscriberFromShipmentDocument = gql`
    mutation removeSubscriberFromShipment($removeSubscriberInput: RemoveSubscriberInput!) {
  removeSubscriberFromShipment(removeSubscriberInput: $removeSubscriberInput) {
    uuid
  }
}
    `;
export const ReportADocScanIssueDocument = gql`
    mutation reportADocScanIssue($reportADocScanIssueInput: ReportADocScanIssueInput!) {
  reportADocScanIssue(reportADocScanIssueInput: $reportADocScanIssueInput) {
    success
  }
}
    `;
export const ScannedOrderResultByOrderUuidDocument = gql`
    query scannedOrderResultByOrderUuid($uuid: String!) {
  scannedOrderResultByOrderUuid(uuid: $uuid) {
    ...ScannedOrderResultFragment
  }
}
    ${ScannedOrderResultFragmentFragmentDoc}`;
export const ServicesForOrderDocument = gql`
    query servicesForOrder($findServicesForOrderInput: FindServicesForOrderInput!) {
  servicesForOrder(findServicesForOrderInput: $findServicesForOrderInput) {
    __typename
    ... on FindServicesForOrderSuccessOutput {
      services {
        uuid
        name
        isActive
        markOrdersAsSpecial
      }
    }
    ... on QueryErrorOutput {
      message
    }
  }
}
    `;
export const ShipmentBillOfLadingDocument = gql`
    query shipmentBillOfLading($shipmentUuid: String!) {
  shipment(uuid: $shipmentUuid) {
    uuid
    ... on StandardShipmentEntity {
      fields {
        pickupOrDelivery
        deadlineDate
      }
    }
    shipperAddress {
      uuid
      name
      line1
      line2
      city
      state
      zip
    }
    legs {
      uuid
      endStop {
        stopType
        uuid
        destinationAirport
        address {
          uuid
          name
          line1
          line2
          city
          state
          zip
        }
      }
    }
    order {
      name
      standardOrderFields {
        shipperBillOfLadingNumber
        masterAirwayBillOfLadingNumber
      }
      packages {
        ...ShallowPackage
      }
      billingPartyContact {
        uuid
        displayName
        addresses {
          uuid
          name
          line1
          line2
          city
          state
          zip
        }
        defaultAddress {
          name
          line1
          line2
          city
          state
          zip
        }
      }
      ediTransactions {
        uuid
        code
        status
      }
    }
  }
}
    ${ShallowPackageFragmentDoc}`;
export const StandardOrderDocument = gql`
    query standardOrder($uuid: String!) {
  standardOrder(uuid: $uuid) {
    ...StandardOrderFragment
  }
}
    ${StandardOrderFragmentFragmentDoc}`;
export const StopForDriverSettlementDocument = gql`
    query stopForDriverSettlement($uuid: String!) {
  stop(uuid: $uuid) {
    ...StopForDriverSettlement
  }
}
    ${StopForDriverSettlementFragmentDoc}`;
export const UncancelOrderDocument = gql`
    mutation uncancelOrder($uuid: String!) {
  uncancelOrder(uuid: $uuid) {
    uuid
    status
    detailedStatusV2
  }
}
    `;
export const UnfinalizeOrderDocument = gql`
    mutation unfinalizeOrder($uuid: String!) {
  unfinalizeOrder(uuid: $uuid) {
    uuid
    status
    detailedStatusV2
    shipments {
      uuid
      status
    }
  }
}
    `;
export const UpdateDocumentDocument = gql`
    mutation updateDocument($updateDocumentInput: UpdateDocumentInput!) {
  updateDocument(updateDocumentInput: $updateDocumentInput) {
    uuid
  }
}
    `;
export const UpdatePaperworkCompletedForStopsDocument = gql`
    mutation updatePaperworkCompletedForStops($updatePaperworkCompleteInput: UpdatePaperworkCompleteInput!) {
  updatePaperworkCompletedForStops(
    updatePaperworkCompleteInput: $updatePaperworkCompleteInput
  ) {
    uuid
  }
}
    `;
export const UpdateRecurringRunDocument = gql`
    mutation updateRecurringRun($input: UpdateRunInput!) {
  updateRun(updateRunInput: $input) {
    run {
      ...RecurringRunTemplate
    }
  }
}
    ${RecurringRunTemplateFragmentDoc}`;
export const UpdateStandardOrderDocument = gql`
    mutation updateStandardOrder($updateStandardOrderInput: UpdateStandardOrderInput!) {
  updateStandardOrder(updateStandardOrderInput: $updateStandardOrderInput) {
    uuid
    detailedStatusV2
    standardOrderFields {
      shipperBillOfLadingNumber
    }
    status
  }
}
    `;
export const RateOrderByUuidDocument = gql`
    query rateOrderByUuid($uuid: String!, $persist: Boolean!) {
  rateOrderByUuid(uuid: $uuid, persist: $persist) {
    __typename
    ... on RateOrderSuccessOutput {
      success
    }
    ... on RateOrderErrorOutput {
      success
      errorMessage
    }
  }
}
    `;
export const RateOrderTotalDollarsDocument = gql`
    query rateOrderTotalDollars($rateOrderInput: RateOrderInput!) {
  rateOrderContents(rateOrderInput: $rateOrderInput) {
    __typename
    ... on RateOrderSuccessOutput {
      success
      totalDollars
      inboundShipmentCharges {
        freightCharge {
          totalDollars
        }
        fuelCharge {
          totalDollars
        }
      }
      outboundShipmentCharges {
        freightCharge {
          totalDollars
        }
        fuelCharge {
          totalDollars
        }
      }
    }
    ... on RateOrderErrorOutput {
      success
      errorMessage
    }
  }
}
    `;
export const RateOrderDocument = gql`
    query rateOrder($rateOrderInput: RateOrderInput!) {
  rateOrderContents(rateOrderInput: $rateOrderInput) {
    __typename
    ... on RateOrderSuccessOutput {
      success
      totalDollars
      inboundShipmentCharges {
        freightCharge {
          rateDollars
          totalDollars
          tariffUuid
          quantity
          discountRate
          miles
          settlementFlatRate
          settlementPercentageRate
        }
        fuelCharge {
          surchargeRatePercentage
          totalDollars
          settlementFlatRate
          settlementPercentageRate
        }
        customCharges {
          rateDollars
          totalDollars
          fuelSurchargePercentageRate
          settlementFlatRate
          settlementPercentageRate
        }
        independentSettlementBillLineItems {
          ...RateOrderSettlementBillLineItem
        }
      }
      outboundShipmentCharges {
        freightCharge {
          rateDollars
          totalDollars
          tariffUuid
          quantity
          discountRate
          miles
          settlementFlatRate
          settlementPercentageRate
        }
        fuelCharge {
          surchargeRatePercentage
          totalDollars
          settlementFlatRate
          settlementPercentageRate
        }
        customCharges {
          rateDollars
          totalDollars
          fuelSurchargePercentageRate
          settlementFlatRate
          settlementPercentageRate
        }
        independentSettlementBillLineItems {
          ...RateOrderSettlementBillLineItem
        }
      }
      lineHaulCharges {
        freightCharge {
          rateDollars
          totalDollars
          tariffUuid
          quantity
          discountRate
          miles
          settlementFlatRate
          settlementPercentageRate
        }
        fuelCharge {
          surchargeRatePercentage
          totalDollars
          settlementFlatRate
          settlementPercentageRate
        }
        customCharges {
          rateDollars
          totalDollars
          fuelSurchargePercentageRate
          settlementFlatRate
          settlementPercentageRate
        }
        independentSettlementBillLineItems {
          ...RateOrderSettlementBillLineItem
        }
      }
      orderCharges {
        freightCharge {
          rateDollars
          totalDollars
          tariffUuid
          quantity
          discountRate
          miles
          settlementFlatRate
          settlementPercentageRate
        }
        fuelCharge {
          surchargeRatePercentage
          totalDollars
          settlementFlatRate
          settlementPercentageRate
        }
        customCharges {
          rateDollars
          totalDollars
          fuelSurchargePercentageRate
          settlementFlatRate
          settlementPercentageRate
        }
        independentSettlementBillLineItems {
          ...RateOrderSettlementBillLineItem
        }
      }
    }
    ... on RateOrderErrorOutput {
      success
      errorMessage
    }
  }
}
    ${RateOrderSettlementBillLineItemFragmentDoc}`;
export const UpdatePackageDocument = gql`
    mutation updatePackage($updatePackageInput: UpdatePackageInput!) {
  updatePackage(updatePackageInput: $updatePackageInput) {
    uuid
  }
}
    `;
export const CreatePermissionDocument = gql`
    mutation createPermission($createPermissionInput: CreatePermissionInput!) {
  createPermission(createPermissionInput: $createPermissionInput) {
    success
  }
}
    `;
export const DeletePermissionDocument = gql`
    mutation deletePermission($deletePermissionInput: DeletePermissionInput!) {
  deletePermission(deletePermissionInput: $deletePermissionInput) {
    success
  }
}
    `;
export const UpdatePermissionAccessLevelDocument = gql`
    mutation updatePermissionAccessLevel($updatePermissionAccessLevelInput: UpdatePermissionAccessLevelInput!) {
  updatePermissionAccessLevel(
    updatePermissionAccessLevelInput: $updatePermissionAccessLevelInput
  ) {
    success
  }
}
    `;
export const UpdatePermissionDocument = gql`
    mutation updatePermission($updatePermissionInput: UpdatePermissionInput!) {
  updatePermission(updatePermissionInput: $updatePermissionInput) {
    success
  }
}
    `;
export const ApproveQuoteDocument = gql`
    mutation approveQuote($approveQuoteInput: ApproveQuoteInput!) {
  approveQuote(approveQuoteInput: $approveQuoteInput) {
    uuid
  }
}
    `;
export const ClientQuotesDocument = gql`
    query clientQuotes($findClientQuotesInput: FindClientQuotesInput!) {
  clientQuotes(findClientQuotesInput: $findClientQuotesInput) {
    edges {
      node {
        ...ClientQuote
      }
    }
    pageInfo {
      startCursor
      endCursor
      hasNextPage
    }
    totalCount
  }
}
    ${ClientQuoteFragmentDoc}`;
export const CreateQuoteDocument = gql`
    mutation createQuote($createQuoteInput: CreateQuoteInput!) {
  createQuote(createQuoteInput: $createQuoteInput) {
    uuid
  }
}
    `;
export const QuoteNameDocument = gql`
    query quoteName($billingPartyContactUuid: String!) {
  quoteName(billingPartyContactUuid: $billingPartyContactUuid)
}
    `;
export const QuoteDocument = gql`
    query quote($uuid: String!) {
  quote(uuid: $uuid) {
    ...Quote
    billingPartyContact {
      ... on CustomerContactEntity {
        defaultDimFactor
        defaultFuelSurcharge
        defaultUseTariff
      }
    }
    lineHaulLane {
      uuid
      originTerminal {
        uuid
        code
      }
      destinationTerminal {
        uuid
        code
      }
    }
  }
}
    ${QuoteFragmentDoc}`;
export const QuotesDocument = gql`
    query quotes($first: Int, $after: String, $last: Int, $before: String, $searchText: String, $quoteStatus: QuoteStatus, $originTerminalUuid: String, $destinationTerminalUuid: String, $createdAtStartDate: DateTime, $createdAtEndDate: DateTime) {
  quotes(
    first: $first
    last: $last
    after: $after
    before: $before
    searchText: $searchText
    quoteStatus: $quoteStatus
    originTerminalUuid: $originTerminalUuid
    destinationTerminalUuid: $destinationTerminalUuid
    createdAtStartDate: $createdAtStartDate
    createdAtEndDate: $createdAtEndDate
  ) {
    edges {
      node {
        ...Quote
      }
    }
    pageInfo {
      startCursor
      endCursor
      hasNextPage
      hasPreviousPage
    }
  }
}
    ${QuoteFragmentDoc}`;
export const UpdateQuoteDocument = gql`
    mutation updateQuote($updateQuoteInput: UpdateQuoteInput!) {
  updateQuote(updateQuoteInput: $updateQuoteInput) {
    uuid
  }
}
    `;
export const CreateReportGroupConfigurationDocument = gql`
    mutation createReportGroupConfiguration($createReportGroupConfigurationInput: ReportGroupConfigurationCreateInput!) {
  createReportGroupConfiguration(
    createReportGroupConfigurationInput: $createReportGroupConfigurationInput
  ) {
    ...ReportGroupConfiguration
  }
}
    ${ReportGroupConfigurationFragmentDoc}`;
export const CustomerReportDocument = gql`
    query customerReport($args: CustomerReportArgs!) {
  customerReport(args: $args) {
    ...CustomerReportBucket
  }
}
    ${CustomerReportBucketFragmentDoc}`;
export const DeleteReportGroupConfigurationDocument = gql`
    mutation deleteReportGroupConfiguration($uuid: String!) {
  deleteReportGroupConfiguration(uuid: $uuid) {
    ...ReportGroupConfiguration
  }
}
    ${ReportGroupConfigurationFragmentDoc}`;
export const DriverReportDocument = gql`
    query driverReport($args: DriverReportArgs!) {
  driverReport(args: $args) {
    ...DriverReportBucket
  }
}
    ${DriverReportBucketFragmentDoc}`;
export const OrderReportDocument = gql`
    query orderReport($args: OrderReportArgs!) {
  orderReport(args: $args) {
    ...OrderReportBucket
  }
}
    ${OrderReportBucketFragmentDoc}`;
export const ReportGroupConfigurationsDocument = gql`
    query reportGroupConfigurations {
  reportGroupConfigurations {
    ...ReportGroupConfiguration
  }
}
    ${ReportGroupConfigurationFragmentDoc}`;
export const ReportSendJobBatchesDocument = gql`
    query reportSendJobBatches($findReportSendJobBatchesInput: FindReportSendJobBatchesInput!) {
  reportSendJobBatches(
    findReportSendJobBatchesInput: $findReportSendJobBatchesInput
  ) {
    reportSendJobBatchConnection {
      totalCount
      edges {
        node {
          ...ReportSendJobBatch
        }
      }
      pageInfo {
        startCursor
        endCursor
        hasNextPage
        hasPreviousPage
      }
    }
  }
}
    ${ReportSendJobBatchFragmentDoc}`;
export const ReportSendJobsDocument = gql`
    query reportSendJobs($findReportSendJobsInput: FindReportSendJobsInput!) {
  reportSendJobs(findReportSendJobsInput: $findReportSendJobsInput) {
    reportSendJobConnection {
      totalCount
      edges {
        node {
          ...ReportSendJob
        }
      }
      pageInfo {
        startCursor
        endCursor
        hasNextPage
        hasPreviousPage
      }
    }
  }
}
    ${ReportSendJobFragmentDoc}`;
export const SendAccountingReportsDocument = gql`
    mutation sendAccountingReports($sendAccountingReportsInput: SendAccountingReportsInput!) {
  sendAccountingReports(sendAccountingReportsInput: $sendAccountingReportsInput) {
    ... on SendAccountingReportsSuccessOutput {
      success
    }
    ... on MutationErrorOutput {
      message
    }
  }
}
    `;
export const ServiceLevelReportDocument = gql`
    query serviceLevelReport($args: ServiceLevelReportArgs!) {
  serviceLevelReport(args: $args) {
    ...ServiceLevelReportBucket
  }
}
    ${ServiceLevelReportBucketFragmentDoc}`;
export const StationReportDocument = gql`
    query stationReport($args: StationReportArgs!) {
  stationReport(args: $args) {
    ...StationReportBucket
  }
}
    ${StationReportBucketFragmentDoc}`;
export const TerminalReportDocument = gql`
    query terminalReport($args: TerminalReportArgs!) {
  terminalReport(args: $args) {
    ...TerminalReportBucket
  }
}
    ${TerminalReportBucketFragmentDoc}`;
export const UpdateReportGroupConfigurationDocument = gql`
    mutation updateReportGroupConfiguration($updateReportGroupConfigurationInput: ReportGroupConfigurationUpdateInput!) {
  updateReportGroupConfiguration(
    updateReportGroupConfigurationInput: $updateReportGroupConfigurationInput
  ) {
    ...ReportGroupConfiguration
  }
}
    ${ReportGroupConfigurationFragmentDoc}`;
export const AppointmentOptionsDocument = gql`
    query AppointmentOptions($input: AppointmentOptionsInput!) {
  appointmentOptions(input: $input) {
    appointmentExists
    rescheduleRequested
    message
    options {
      date {
        year
        month
        day
      }
      startTime {
        hour
        minute
      }
      endTime {
        hour
        minute
      }
      humanDate
    }
    pageSize
  }
}
    `;
export const ChooseAppointmentOptionDocument = gql`
    mutation ChooseAppointmentOption($input: ChooseAppointmentOptionInput!) {
  chooseAppointmentOption(input: $input) {
    __typename
    ... on ChooseAppointmentOptionSuccessOutput {
      appointmentDateTime
    }
    ... on MutationErrorOutput {
      message
    }
  }
}
    `;
export const QueueAppointmentSchedulingProposalsDocument = gql`
    mutation QueueAppointmentSchedulingProposals($input: QueueAppointmentSchedulingProposalsInput!) {
  queueAppointmentSchedulingProposals(input: $input) {
    __typename
    ... on QueueAppointmentSchedulingProposalsSuccessOutput {
      stopUuids
      errorMessages
    }
    ... on MutationErrorOutput {
      message
    }
  }
}
    `;
export const AddUserToRoleDocument = gql`
    mutation addUserToRole($addUserToRoleInput: AddUserToRoleInput!) {
  addUserToRole(addUserToRoleInput: $addUserToRoleInput) {
    success
  }
}
    `;
export const CreateRoleDocument = gql`
    mutation createRole($createRoleInput: CreateRoleInput!) {
  createRole(createRoleInput: $createRoleInput) {
    role {
      uuid
    }
  }
}
    `;
export const RoleDocument = gql`
    query role($findRoleInput: FindRoleInput!) {
  role(findRoleInput: $findRoleInput) {
    role {
      ...FindRole
    }
  }
}
    ${FindRoleFragmentDoc}`;
export const RolesDocument = gql`
    query roles($findRolesInput: FindRolesInput) {
  roles(findRolesInput: $findRolesInput) {
    roles {
      ...FindRoles
    }
  }
}
    ${FindRolesFragmentDoc}`;
export const RemoveUserFromRoleDocument = gql`
    mutation removeUserFromRole($removeUserFromRoleInput: RemoveUserFromRoleInput!) {
  removeUserFromRole(removeUserFromRoleInput: $removeUserFromRoleInput) {
    success
  }
}
    `;
export const UpdateRoleDocument = gql`
    mutation updateRole($updateRoleInput: UpdateRoleInput!) {
  updateRole(updateRoleInput: $updateRoleInput) {
    success
  }
}
    `;
export const UsersForRoleDocument = gql`
    query usersForRole {
  users {
    ...UsersForRole
  }
}
    ${UsersForRoleFragmentDoc}`;
export const CreateShipmentDocumentDocument = gql`
    mutation createShipmentDocument($createShipmentDocumentInput: CreateShipmentDocumentInput!) {
  createShipmentDocument(
    createShipmentDocumentInput: $createShipmentDocumentInput
  ) {
    ...Document
  }
}
    ${DocumentFragmentDoc}`;
export const CompleteStopBulkDocument = gql`
    mutation completeStopBulk($completeStopBulkInput: CompleteStopBulkInput!) {
  completeStopBulk(completeStopBulkInput: $completeStopBulkInput) {
    ...StopOnRoute
  }
}
    ${StopOnRouteFragmentDoc}`;
export const CompleteStopV2Document = gql`
    mutation completeStopV2($completeStopInput: CompleteStopInput!) {
  completeStopV2(completeStopInput: $completeStopInput) {
    ... on CompleteStopEntity {
      uuid
    }
    ... on CompleteStopInvalidInputException {
      message
    }
  }
}
    `;
export const DeleteDocumentDocument = gql`
    mutation deleteDocument($uuid: String!) {
  deleteDocument(uuid: $uuid) {
    uuid
  }
}
    `;
export const GenerateShipmentPreSignedPutUrlDocument = gql`
    mutation generateShipmentPreSignedPutUrl($generateShipmentPreSignedPutUrlInput: GenerateShipmentPreSignedPutUrlInput!) {
  generateShipmentPreSignedPutUrl(
    generateShipmentPreSignedPutUrlInput: $generateShipmentPreSignedPutUrlInput
  )
}
    `;
export const MarkStopAsFailedDocument = gql`
    mutation markStopAsFailed($uuid: String!) {
  markStopAsFailed(uuid: $uuid) {
    uuid
  }
}
    `;
export const MarkStopAsFailedV2Document = gql`
    mutation markStopAsFailedV2($markStopAsFailedV2Input: MarkStopAsFailedV2Input!) {
  markStopAsFailedV2(markStopAsFailedV2Input: $markStopAsFailedV2Input) {
    uuid
  }
}
    `;
export const NameOfRouteDocument = gql`
    query nameOfRoute($uuid: String!) {
  route(uuid: $uuid) {
    uuid
    name
  }
}
    `;
export const EquipmentsFetchDocument = gql`
    query equipmentsFetch($equipmentTypes: [EquipmentType!]) {
  equipments(types: $equipmentTypes) {
    uuid
    name
  }
}
    `;
export const RouteDocument = gql`
    query route($uuid: String!) {
  route(uuid: $uuid) {
    ...Route
  }
}
    ${RouteFragmentDoc}`;
export const ShallowRoutesDocument = gql`
    query shallowRoutes($date: DateTime!) {
  routes(date: $date) {
    uuid
    name
    date
    drivers {
      firstName
      lastName
    }
    startTime
    slots {
      uuid
      stops {
        uuid
        status
        address {
          city
        }
      }
    }
  }
}
    `;
export const UpdateServiceDateForAssignedStopsDocument = gql`
    mutation updateServiceDateForAssignedStops($updateServiceDateForAssignedStopsInput: UpdateServiceDateForAssignedStopsInput!) {
  updateServiceDateForAssignedStops(
    updateServiceDateForAssignedStopsInput: $updateServiceDateForAssignedStopsInput
  ) {
    uuid
  }
}
    `;
export const UpdateStopDocument = gql`
    mutation updateStop($updateStopInput: UpdateStopInput!) {
  updateStop(updateStopInput: $updateStopInput) {
    uuid
    contactPerson {
      uuid
      phone
    }
  }
}
    `;
export const UpdateStopsDocument = gql`
    mutation updateStops($updateStopsInput: UpdateStopsInput!) {
  updateStops(updateStopsInput: $updateStopsInput) {
    uuid
  }
}
    `;
export const SamaraOAuthAuthorizeUrlDocument = gql`
    query samaraOAuthAuthorizeUrl {
  samaraOAuthAuthorizeUrl
}
    `;
export const SamsaraOAuthTokenDocument = gql`
    query samsaraOAuthToken {
  samsaraOAuthToken {
    uuid
  }
}
    `;
export const CreateSavedFilterViewDocument = gql`
    mutation createSavedFilterView($createSavedFilterViewInput: CreateSavedFilterViewInput!) {
  createSavedFilterView(createSavedFilterViewInput: $createSavedFilterViewInput) {
    uuid
  }
}
    `;
export const DeleteSavedFilterViewDocument = gql`
    mutation deleteSavedFilterView($uuid: String!) {
  deleteSavedFilterView(uuid: $uuid) {
    uuid
  }
}
    `;
export const GetSavedFilterViewsDocument = gql`
    query getSavedFilterViews($pageType: String!) {
  getSavedFilterViews(pageType: $pageType) {
    ...SavedFilterView
  }
}
    ${SavedFilterViewFragmentDoc}`;
export const UpdateSavedFilterViewDocument = gql`
    mutation updateSavedFilterView($updateSavedFilterViewInput: UpdateSavedFilterViewInput!) {
  updateSavedFilterView(updateSavedFilterViewInput: $updateSavedFilterViewInput) {
    uuid
  }
}
    `;
export const ScannedOrderResultDocument = gql`
    query scannedOrderResult($uuid: String!) {
  numberOfScannedOrderResultsInReview
  scannedOrderResult(uuid: $uuid) {
    ...ScannedOrderResultFragment
    scannedOrder {
      uuid
      preSignedGetUrl
    }
    scannedOrderResultDocuments {
      uuid
      filename
      preSignedGetUrl
      scannedDocumentType
      scannedOrderResultDocumentPages {
        uuid
        bucket
        key
        page
        preSignedGetUrl
      }
    }
    scannedOrderResultPages {
      ...ScannedOrderResultPageFragment
    }
    nextScannedOrderResultInReview {
      ...ScannedOrderResultFragment
      uuid
      order {
        uuid
      }
    }
  }
}
    ${ScannedOrderResultFragmentFragmentDoc}
${ScannedOrderResultPageFragmentFragmentDoc}`;
export const FirstScannedOrderResultInReviewDocument = gql`
    query firstScannedOrderResultInReview {
  firstScannedOrderResultInReview {
    uuid
    order {
      uuid
    }
  }
}
    `;
export const ScannedOrderResultsDocument = gql`
    query scannedOrderResults($first: Int, $after: String, $last: Int, $before: String, $approvedAtAfter: DateTime, $createdAtAfter: DateTime, $rejectedAtAfter: DateTime, $searchText: String, $type: ScannedOrderResultType!, $statuses: [ScannedOrderResultStatus!], $signedPodMatchStatuses: [SignedPodMatchStatus!], $sourceFilter: ScannedOrderResultSourceFilter, $failureReasonFilter: ScannedOrderFailureReason) {
  numberOfScannedOrderResultDuplicates(
    searchText: $searchText
    sourceFilter: $sourceFilter
  )
  numberOfScannedOrderResultsInProgress(
    searchText: $searchText
    sourceFilter: $sourceFilter
  )
  numberOfScannedOrderResultsInReview(
    searchText: $searchText
    sourceFilter: $sourceFilter
  )
  numberOfScannedOrderResultsFailed(
    searchText: $searchText
    sourceFilter: $sourceFilter
  )
  numberOfScannedOrderResultsRejected(
    searchText: $searchText
    sourceFilter: $sourceFilter
  )
  numberOfScannedOrderResultsApproved(
    searchText: $searchText
    sourceFilter: $sourceFilter
  )
  scannedOrderResults(
    first: $first
    after: $after
    last: $last
    before: $before
    approvedAtAfter: $approvedAtAfter
    createdAtAfter: $createdAtAfter
    rejectedAtAfter: $rejectedAtAfter
    searchText: $searchText
    type: $type
    statuses: $statuses
    signedPodMatchStatuses: $signedPodMatchStatuses
    sourceFilter: $sourceFilter
    failureReasonFilter: $failureReasonFilter
  ) {
    edges {
      node {
        ...ScannedOrderResultWithOrders
      }
    }
    pageInfo {
      startCursor
      endCursor
      hasNextPage
      hasPreviousPage
    }
  }
}
    ${ScannedOrderResultWithOrdersFragmentDoc}`;
export const UpdateScannedOrderResultStatusDocument = gql`
    mutation updateScannedOrderResultStatus($updateScannedOrderResultStatusInput: UpdateScannedOrderResultStatusInput!) {
  updateScannedOrderResultStatus(
    updateScannedOrderResultStatusInput: $updateScannedOrderResultStatusInput
  ) {
    uuid
  }
}
    `;
export const ArchiveSchedulingRegionDocument = gql`
    mutation ArchiveSchedulingRegion($id: String!) {
  archiveSchedulingRegion(id: $id) {
    __typename
    ... on UpdateSchedulingRegionSuccessOutput {
      schedulingRegion {
        ...AllSchedulingRegionFields
      }
    }
    ... on MutationErrorOutput {
      message
    }
  }
}
    ${AllSchedulingRegionFieldsFragmentDoc}`;
export const CreateSchedulingRegionDocument = gql`
    mutation CreateSchedulingRegion($input: CreateSchedulingRegionInput!) {
  createSchedulingRegion(input: $input) {
    __typename
    ... on CreateSchedulingRegionSuccessOutput {
      schedulingRegion {
        id
      }
    }
    ... on MutationErrorOutput {
      message
    }
  }
}
    `;
export const CreateSchedulingZoneDocument = gql`
    mutation CreateSchedulingZone($input: CreateSchedulingZoneInput!) {
  createSchedulingZone(input: $input) {
    __typename
    ... on CreateSchedulingZoneSuccessOutput {
      schedulingZone {
        id
      }
    }
    ... on MutationErrorOutput {
      message
    }
  }
}
    `;
export const RestoreSchedulingRegionDocument = gql`
    mutation RestoreSchedulingRegion($id: String!) {
  restoreSchedulingRegion(id: $id) {
    __typename
    ... on UpdateSchedulingRegionSuccessOutput {
      schedulingRegion {
        ...AllSchedulingRegionFields
      }
    }
    ... on MutationErrorOutput {
      message
    }
  }
}
    ${AllSchedulingRegionFieldsFragmentDoc}`;
export const RestoreSchedulingZoneDocument = gql`
    mutation RestoreSchedulingZone($id: String!) {
  restoreSchedulingZone(id: $id) {
    __typename
    ... on UpdateSchedulingZoneSuccessOutput {
      schedulingZone {
        ...AllSchedulingZoneFields
      }
    }
    ... on MutationErrorOutput {
      message
    }
  }
}
    ${AllSchedulingZoneFieldsFragmentDoc}`;
export const SchedulingRegionDocument = gql`
    query SchedulingRegion($id: String!) {
  schedulingRegion(id: $id) {
    ...AllSchedulingRegionFields
  }
}
    ${AllSchedulingRegionFieldsFragmentDoc}`;
export const SchedulingRegionsDocument = gql`
    query SchedulingRegions {
  schedulingRegions {
    schedulingRegions {
      id
      name
      isArchived
    }
  }
}
    `;
export const UpdateSchedulingRegionDocument = gql`
    mutation UpdateSchedulingRegion($input: UpdateSchedulingRegionInput!) {
  updateSchedulingRegion(input: $input) {
    __typename
    ... on UpdateSchedulingRegionSuccessOutput {
      schedulingRegion {
        ...AllSchedulingRegionFields
      }
    }
    ... on MutationErrorOutput {
      message
    }
  }
}
    ${AllSchedulingRegionFieldsFragmentDoc}`;
export const UpdateSchedulingZoneDocument = gql`
    mutation UpdateSchedulingZone($input: UpdateSchedulingZoneInput!) {
  updateSchedulingZone(input: $input) {
    __typename
    ... on UpdateSchedulingZoneSuccessOutput {
      schedulingZone {
        ...AllSchedulingZoneFields
      }
    }
    ... on MutationErrorOutput {
      message
    }
  }
}
    ${AllSchedulingZoneFieldsFragmentDoc}`;
export const CreateServiceRegionsDocument = gql`
    mutation CreateServiceRegions($input: CreateServiceRegionsInput!) {
  createServiceRegions(input: $input) {
    __typename
    ... on CreateServiceRegionsSuccessOutput {
      serviceRegions {
        id
        name
        isArchived
      }
    }
    ... on MutationErrorOutput {
      message
    }
  }
}
    `;
export const ServiceRegionDocument = gql`
    query ServiceRegion($id: String!) {
  serviceRegion(id: $id) {
    id
    name
    isArchived
    terminals {
      uuid
      code
      name
      isActive
      serviceAreas {
        uuid
        zipcode
        city
      }
    }
  }
}
    `;
export const UpdateServiceRegionDocument = gql`
    mutation UpdateServiceRegion($input: UpdateServiceRegionInput!) {
  updateServiceRegion(input: $input) {
    __typename
    ... on UpdateServiceRegionSuccessOutput {
      serviceRegion {
        id
        name
        isArchived
      }
    }
    ... on MutationErrorOutput {
      message
    }
  }
}
    `;
export const BulkUpdateAccessorialMappingsDocument = gql`
    mutation bulkUpdateAccessorialMappings($bulkAccessorialUpdateInput: BulkAccessorialUpdateInput!) {
  bulkUpdateAccessorialMappings(
    bulkAccessorialUpdateInput: $bulkAccessorialUpdateInput
  ) {
    ... on StandardAccessorialEntity {
      __typename
      uuid
      name
      rate
    }
  }
}
    `;
export const BulkUpdateContactQuickbooksIdsDocument = gql`
    mutation bulkUpdateContactQuickbooksIds($bulkUpdateContactQuickbooksId: UpdateContactQuickbooksIdsInput!) {
  bulkUpdateContactQuickbooksIds(
    bulkUpdateContactQuickbooksId: $bulkUpdateContactQuickbooksId
  ) {
    uuid
    displayName
    quickbooksDesktopContactId
    __typename
  }
}
    `;
export const CompanyDefaultEdiSettingsDocument = gql`
    query companyDefaultEdiSettings {
  company {
    uuid
    defaultInboundEdiService {
      uuid
      name
    }
    defaultOutboundEdiService {
      uuid
      name
    }
    defaultInboundOutboundEdiService {
      uuid
      name
    }
  }
}
    `;
export const AccessorialToQuickbooksMappingByContactDocument = gql`
    query accessorialToQuickbooksMappingByContact($contactUuid: String!) {
  accessorialToQuickbooksMappingByContact(contactUuid: $contactUuid) {
    uuid
    quickbooksId
    accessorial {
      uuid
      name
    }
  }
}
    `;
export const CreateAccessorialToQuickbooksMappingDocument = gql`
    mutation createAccessorialToQuickbooksMapping($accessorialToQuickbooksMappingCreateInput: AccessorialToQuickbooksMappingCreateInput!) {
  createAccessorialToQuickbooksMapping(
    accessorialToQuickbooksMappingCreateInput: $accessorialToQuickbooksMappingCreateInput
  ) {
    uuid
  }
}
    `;
export const CreateManyReferenceNumberLabelsDocument = gql`
    mutation CreateManyReferenceNumberLabels($referenceNumberLabels: [String!]!) {
  createManyReferenceNumberLabels(referenceNumberLabels: $referenceNumberLabels) {
    name
  }
}
    `;
export const CreateQuickbooksHeaderFileMappingDocument = gql`
    mutation createQuickbooksHeaderFileMapping($createQuickbooksHeaderFileMappingInput: CreateQuickbooksHeaderFileMappingInput!) {
  createQuickbooksHeaderFileMapping(
    createQuickbooksHeaderFileMappingInput: $createQuickbooksHeaderFileMappingInput
  ) {
    uuid
  }
}
    `;
export const DeleteQuickbooksHeaderFileMappingDocument = gql`
    mutation deleteQuickbooksHeaderFileMapping($uuid: String!) {
  deleteQuickbooksHeaderFileMapping(uuid: $uuid) {
    uuid
  }
}
    `;
export const DeleteTagDocument = gql`
    mutation deleteTag($uuid: String!) {
  deleteTag(uuid: $uuid) {
    uuid
  }
}
    `;
export const QuickbooksOAuthUrlDocument = gql`
    query quickbooksOAuthUrl {
  quickbooksOAuthUrl
}
    `;
export const QueryQuickbooksDesktopItemsDocument = gql`
    query queryQuickbooksDesktopItems {
  queryQuickbooksDesktopItems {
    quickbooksDesktopObjects {
      id
      name
    }
    error
  }
}
    `;
export const QuickbooksCustomersDocument = gql`
    query quickbooksCustomers {
  quickbooksCustomers {
    id
    name
    active
  }
}
    `;
export const QuickbooksHeaderFileMappingsDocument = gql`
    query quickbooksHeaderFileMappings {
  quickbooksHeaderFileMappings {
    uuid
    name
    cellNumber
    headerType
  }
}
    `;
export const QuickbooksItemsDocument = gql`
    query quickbooksItems {
  quickbooksItems {
    id
    name
    active
  }
}
    `;
export const ReferenceNumberFormatConfigsDocument = gql`
    query referenceNumberFormatConfigs($contactUuid: String!) {
  referenceNumberFormatConfigs(contactUuid: $contactUuid) {
    uuid
    checks {
      ...ReferenceNumberFormatCheck
    }
  }
}
    ${ReferenceNumberFormatCheckFragmentDoc}`;
export const UpdateAccessorialToQuickbooksMappingDocument = gql`
    mutation updateAccessorialToQuickbooksMapping($accessorialToQuickbooksMappingUpdateInput: AccessorialToQuickbooksMappingUpdateInput!) {
  updateAccessorialToQuickbooksMapping(
    accessorialToQuickbooksMappingUpdateInput: $accessorialToQuickbooksMappingUpdateInput
  ) {
    uuid
  }
}
    `;
export const UpdateCompanyDocument = gql`
    mutation updateCompany($updateCompanyInput: UpdateCompanyInput!) {
  updateCompany(updateCompanyInput: $updateCompanyInput) {
    uuid
  }
}
    `;
export const UpdateOrderFormFieldsDocument = gql`
    mutation updateOrderFormFields($updateOrderFormFieldsInput: UpdateOrderFormFieldsInput!) {
  updateOrderFormFields(updateOrderFormFieldsInput: $updateOrderFormFieldsInput) {
    onePackageRequired
    onePackageWeightRequired
  }
}
    `;
export const UpdateQuickbooksHeaderFileMappingDocument = gql`
    mutation updateQuickbooksHeaderFileMapping($updateQuickbooksHeaderFileMappingInput: UpdateQuickbooksHeaderFileMappingInput!) {
  updateQuickbooksHeaderFileMapping(
    updateQuickbooksHeaderFileMappingInput: $updateQuickbooksHeaderFileMappingInput
  ) {
    uuid
  }
}
    `;
export const UpdateTagDocument = gql`
    mutation updateTag($updateTagInput: UpdateTagInput!) {
  updateTag(updateTagInput: $updateTagInput) {
    uuid
  }
}
    `;
export const AddLineItemsToSettlementBillsDocument = gql`
    mutation addLineItemsToSettlementBills($addLineItemsToSettlementBillsInput: AddLineItemsToSettlementBillsInput!) {
  addLineItemsToSettlementBills(
    addLineItemsToSettlementBillsInput: $addLineItemsToSettlementBillsInput
  ) {
    ... on AddLineItemsToSettlementBillsSuccessOutput {
      __typename
      driverSettlementBills {
        uuid
        name
        driver {
          uuid
          firstName
          lastName
        }
        billStartDate
        billEndDate
        settlementDate
      }
    }
    ... on MutationErrorOutput {
      __typename
      message
    }
  }
}
    `;
export const CreateSettlementAdjustmentDocument = gql`
    mutation CreateSettlementAdjustment($settlementAdjustmentCreateInput: SettlementAdjustmentCreateInput!) {
  createSettlementAdjustment(
    settlementAdjustmentCreateInput: $settlementAdjustmentCreateInput
  ) {
    ... on CreateOrUpdateSettlementAdjustmentSuccessOutput {
      __typename
      settlementAdjustment {
        ...SettlementAdjustment
      }
    }
    ... on MutationErrorOutput {
      __typename
      message
    }
  }
}
    ${SettlementAdjustmentFragmentDoc}`;
export const DriverSettlementBillByUuidV2Document = gql`
    query driverSettlementBillByUuidV2($uuid: String!) {
  driverSettlementBill(uuid: $uuid) {
    ...DriverSettlementBillV2
  }
}
    ${DriverSettlementBillV2FragmentDoc}`;
export const DriverSettlementBillExportPdfDocument = gql`
    mutation driverSettlementBillExportPdf($driverSettlementBillExportPdfInput: DriverSettlementBillExportPdfInput!) {
  driverSettlementBillExportPdf(
    driverSettlementBillExportPdfInput: $driverSettlementBillExportPdfInput
  ) {
    __typename
    url
    fileName
    errors
  }
}
    `;
export const DriverSettlementBillExportZipDocument = gql`
    mutation driverSettlementBillExportZip($input: DriverSettlementBillExportPdfInput!) {
  driverSettlementBillExportZip(input: $input) {
    __typename
    url
    fileName
    errors
  }
}
    `;
export const FinalizeSettlementBillsDocument = gql`
    mutation finalizeSettlementBills($finalizeSettlementBillsInput: FinalizeSettlementBillsInput!) {
  finalizeSettlementBills(
    finalizeSettlementBillsInput: $finalizeSettlementBillsInput
  ) {
    ... on FinalizeSettlementBillsSuccessOutput {
      __typename
      results {
        bill {
          uuid
          name
        }
        error
      }
    }
    ... on MutationErrorOutput {
      __typename
      message
    }
  }
}
    `;
export const SettlementBillLineItemWithCostsDocument = gql`
    query SettlementBillLineItemWithCosts($id: String!) {
  settlementBillLineItem(id: $id) {
    ...SettlementBillLineItemWithCosts
  }
}
    ${SettlementBillLineItemWithCostsFragmentDoc}`;
export const RemoveLineItemsFromSettlementBillDocument = gql`
    mutation removeLineItemsFromSettlementBill($removeLineItemsFromSettlementBillInput: RemoveLineItemsFromSettlementBillInput!) {
  removeLineItemsFromSettlementBill(
    removeLineItemsFromSettlementBillInput: $removeLineItemsFromSettlementBillInput
  ) {
    ... on RemoveLineItemsFromSettlementBillSuccessOutput {
      __typename
      settlementBillLineItemsCount
    }
    ... on MutationErrorOutput {
      __typename
      message
    }
  }
}
    `;
export const RemoveSettlementAdjustmentDocument = gql`
    mutation RemoveSettlementAdjustment($uuid: String!) {
  removeSettlementAdjustment(uuid: $uuid) {
    uuid
  }
}
    `;
export const GetSettlementBillLineItemsDocument = gql`
    query getSettlementBillLineItems($input: FindSettlementBillLineItemsInput!) {
  settlementBillLineItems(findSettlementBillLineItemInput: $input) {
    edges {
      node {
        ...SettlementBillLineItem
      }
    }
    pageInfo {
      hasNextPage
      hasPreviousPage
      startCursor
      endCursor
    }
    totalCount
  }
}
    ${SettlementBillLineItemFragmentDoc}`;
export const UpdateSettlementAdjustmentDocument = gql`
    mutation UpdateSettlementAdjustment($settlementAdjustmentUpdateInput: SettlementAdjustmentUpdateInput!) {
  updateSettlementAdjustment(
    settlementAdjustmentUpdateInput: $settlementAdjustmentUpdateInput
  ) {
    ... on CreateOrUpdateSettlementAdjustmentSuccessOutput {
      __typename
      settlementAdjustment {
        ...SettlementAdjustment
      }
    }
    ... on MutationErrorOutput {
      __typename
      message
    }
  }
}
    ${SettlementAdjustmentFragmentDoc}`;
export const OutstandingShipmentsUuidsDocument = gql`
    query outstandingShipmentsUuids($first: Int, $after: String, $last: Int, $before: String, $isFinalized: Boolean, $hasIssues: Boolean, $hideFromBilling: Boolean, $isUnfinalized: Boolean, $isCancelled: Boolean, $contactUuid: String, $billingPartyContactUuids: [String!], $billingPartyContactDisplayName: StringFilter, $serviceUuid: String, $terminalUuid: String, $originTerminalUuid: String, $destinationTerminalUuid: String, $noMaximum: Boolean, $searchText: String, $stopCompletionEndDate: DateTime, $stopCompletionStartDate: DateTime, $uuids: [String!], $orderUuids: [String!]!) {
  outstandingShipments(
    first: $first
    after: $after
    before: $before
    last: $last
    isFinalized: $isFinalized
    hasIssues: $hasIssues
    hideFromBilling: $hideFromBilling
    isUnfinalized: $isUnfinalized
    isCancelled: $isCancelled
    contactUuid: $contactUuid
    billingPartyContactUuids: $billingPartyContactUuids
    billingPartyContactDisplayName: $billingPartyContactDisplayName
    serviceUuid: $serviceUuid
    terminalUuid: $terminalUuid
    originTerminalUuid: $originTerminalUuid
    destinationTerminalUuid: $destinationTerminalUuid
    noMaximum: $noMaximum
    searchText: $searchText
    stopCompletionEndDate: $stopCompletionEndDate
    stopCompletionStartDate: $stopCompletionStartDate
    uuids: $uuids
    orderUuids: $orderUuids
  ) {
    edges {
      node {
        uuid
        order {
          uuid
          billingPartyContact {
            invoiceTimePeriodSplit
            numberOfOrdersPerInvoice
            uuid
          }
        }
      }
    }
    pageInfo {
      startCursor
      endCursor
      hasNextPage
      hasPreviousPage
    }
  }
}
    `;
export const AttachMobileSignedDocumentToOrderAndReplaceOriginalDocument = gql`
    mutation attachMobileSignedDocumentToOrderAndReplaceOriginal($input: UploadMobileSignedDocumentInput!) {
  attachMobileSignedDocumentToOrderAndReplaceOriginal(input: $input) {
    document {
      uuid
    }
    errorMessage
  }
}
    `;
export const DocumentForSigningDocument = gql`
    query documentForSigning($documentForSigningInput: DocumentForSigningInput!) {
  documentForSigning(documentForSigningInput: $documentForSigningInput) {
    document {
      uuid
      preSignedGetUrl
      fileName
    }
    errorMessage
  }
}
    `;
export const DocumentsForSigningDocument = gql`
    query documentsForSigning($orderUuid: String!, $documentType: DocumentType!) {
  documentsForSigning(orderUuid: $orderUuid, documentType: $documentType) {
    uuid
    preSignedGetUrl
  }
}
    `;
export const GenerateMobileSignedDocumentPreSignedPutUrlDocument = gql`
    mutation generateMobileSignedDocumentPreSignedPutUrl($input: UploadMobileSignedDocumentInput!) {
  generateMobileSignedDocumentPreSignedPutUrl(input: $input)
}
    `;
export const CompletedStopNotOnRouteDocument = gql`
    query completedStopNotOnRoute($uuid: String!) {
  stop(uuid: $uuid) {
    ...CompletedStopNotOnRoute
  }
}
    ${CompletedStopNotOnRouteFragmentDoc}`;
export const CompletedStopsNotOnRoutesDocument = gql`
    query completedStopsNotOnRoutes($date: DateTime!) {
  completedStopsNotOnRoutes(date: $date) {
    ...CompletedStopNotOnRoute
  }
}
    ${CompletedStopNotOnRouteFragmentDoc}`;
export const DeleteStopAttemptDocument = gql`
    mutation deleteStopAttempt($deleteStopAttemptInput: DeleteStopAttemptInput!) {
  deleteStopAttempt(deleteStopAttemptInput: $deleteStopAttemptInput) {
    ... on DeleteStopAttemptSuccessOutput {
      success
    }
    ... on MutationErrorOutput {
      message
    }
  }
}
    `;
export const MarkAttemptedStopAsCompleteDocument = gql`
    mutation markAttemptedStopAsComplete($stopUuid: String!) {
  markAttemptedStopAsComplete(stopUuid: $stopUuid) {
    uuid
  }
}
    `;
export const MarkStopAsIncompleteDocument = gql`
    mutation markStopAsIncomplete($uuid: String!) {
  markStopAsIncomplete(uuid: $uuid) {
    uuid
  }
}
    `;
export const StopForCompletionCheckDocument = gql`
    query stopForCompletionCheck($uuid: String!) {
  stop(uuid: $uuid) {
    uuid
    leg {
      endStop {
        stopType
      }
      shipment {
        standardShipmentFields {
          pickupOrDelivery
        }
      }
    }
    terminal {
      uuid
    }
    address {
      line1
    }
  }
}
    `;
export const AssignOutboundReferenceNumbersToStorageUnitsDocument = gql`
    mutation assignOutboundReferenceNumbersToStorageUnits($assignOutboundReferenceNumbersToStorageUnitsInput: AssignOutboundReferenceNumberToStorageUnitsInput!) {
  assignOutboundReferenceNumbersToStorageUnits(
    assignOutboundReferenceNumbersToStorageUnitsInput: $assignOutboundReferenceNumbersToStorageUnitsInput
  ) {
    success
  }
}
    `;
export const CreateStorageOrderDocumentDocument = gql`
    mutation createStorageOrderDocument($createStorageOrderDocumentInput: CreateStorageOrderDocumentInput!) {
  createStorageOrderDocument(
    createStorageOrderDocumentInput: $createStorageOrderDocumentInput
  ) {
    document {
      ...CreateStorageOrderDocument
    }
  }
}
    ${CreateStorageOrderDocumentFragmentDoc}`;
export const CreateStorageOrderDocument = gql`
    mutation createStorageOrder($createStorageOrderInput: CreateStorageOrderInput!) {
  createStorageOrder(createStorageOrderInput: $createStorageOrderInput) {
    storageOrder {
      ...CreateStorageOrder
    }
  }
}
    ${CreateStorageOrderFragmentDoc}`;
export const CreateStorageUnitDocument = gql`
    mutation createStorageUnit($createStorageUnitInput: CreateStorageUnitInput!) {
  createStorageUnit(createStorageUnitInput: $createStorageUnitInput) {
    storageUnit {
      ...StorageOrderStorageUnit
    }
  }
}
    ${StorageOrderStorageUnitFragmentDoc}`;
export const DeleteStorageOrderDocument = gql`
    mutation deleteStorageOrder($deleteStorageOrderInput: DeleteStorageOrderInput!) {
  deleteStorageOrder(deleteStorageOrderInput: $deleteStorageOrderInput) {
    success
  }
}
    `;
export const DeleteStorageUnitDocument = gql`
    mutation deleteStorageUnit($deleteStorageUnitInput: DeleteStorageUnitInput!) {
  deleteStorageUnit(deleteStorageUnitInput: $deleteStorageUnitInput) {
    success
  }
}
    `;
export const StorageOrderStorageUnitsDocument = gql`
    query storageOrderStorageUnits($findStorageOrderStorageUnitsInput: FindStorageOrderStorageUnitsInput!) {
  storageOrderStorageUnits(
    findStorageOrderStorageUnitsInput: $findStorageOrderStorageUnitsInput
  ) {
    storageUnits {
      ...FindStorageOrderStorageUnits
    }
  }
}
    ${FindStorageOrderStorageUnitsFragmentDoc}`;
export const StorageOrderDocument = gql`
    query storageOrder($findStorageOrderInput: FindStorageOrderInput!, $storageUnitsInput: StorageUnitsInput) {
  storageOrder(findStorageOrderInput: $findStorageOrderInput) {
    storageOrder {
      ...FindStorageOrder
      storageUnits(storageUnitsInput: $storageUnitsInput) {
        ...StorageOrderStorageUnit
      }
    }
  }
}
    ${FindStorageOrderFragmentDoc}
${StorageOrderStorageUnitFragmentDoc}`;
export const StorageOrdersDocument = gql`
    query storageOrders($findStorageOrdersInput: FindStorageOrdersInput!) {
  storageOrders(findStorageOrdersInput: $findStorageOrdersInput) {
    storageOrderConnection {
      totalCount
      edges {
        node {
          ...StorageOrder
        }
      }
      pageInfo {
        startCursor
        endCursor
        hasNextPage
        hasPreviousPage
      }
    }
  }
}
    ${StorageOrderFragmentDoc}`;
export const StorageUnitsForPicklistDocument = gql`
    query storageUnitsForPicklist($findStorageUnitsInput: FindStorageUnitsInput!) {
  storageUnits(findStorageUnitsInput: $findStorageUnitsInput) {
    storageUnitConnection {
      totalCount
      edges {
        node {
          ...FindStorageUnitsForPicklist
        }
      }
      pageInfo {
        startCursor
        endCursor
        hasNextPage
        hasPreviousPage
      }
    }
  }
}
    ${FindStorageUnitsForPicklistFragmentDoc}`;
export const StorageUnitsDocument = gql`
    query storageUnits($findStorageUnitsInput: FindStorageUnitsInput!) {
  storageUnits(findStorageUnitsInput: $findStorageUnitsInput) {
    storageUnitConnection {
      totalCount
      edges {
        node {
          ...FindStorageUnits
        }
      }
      pageInfo {
        startCursor
        endCursor
        hasNextPage
        hasPreviousPage
      }
    }
  }
}
    ${FindStorageUnitsFragmentDoc}`;
export const GenerateStorageOrderPreSignedPutUrlDocument = gql`
    mutation generateStorageOrderPreSignedPutUrl($generateStorageOrderPreSignedPutUrlInput: GenerateStorageOrderPreSignedPutUrlInput!) {
  generateStorageOrderPreSignedPutUrl(
    generateStorageOrderPreSignedPutUrlInput: $generateStorageOrderPreSignedPutUrlInput
  ) {
    preSignedPutUrl
  }
}
    `;
export const ImportStorageOrdersFromCsvDocument = gql`
    mutation importStorageOrdersFromCSV($importStorageOrdersFromCsvInput: ImportStorageOrdersFromCsvInput!) {
  importStorageOrdersFromCSV(
    importStorageOrdersFromCsvInput: $importStorageOrdersFromCsvInput
  ) {
    storageOrders {
      uuid
    }
    errors
  }
}
    `;
export const UpsertItemGroupDocument = gql`
    mutation upsertItemGroup($upsertItemGroupInput: UpsertItemGroupInput!) {
  upsertItemGroup(upsertItemGroupInput: $upsertItemGroupInput) {
    uuid
    storageUnit {
      uuid
    }
  }
}
    `;
export const ItemGroupsDocument = gql`
    query itemGroups($findItemGroupsInput: FindItemGroupsInput!) {
  itemGroups(findItemGroupsInput: $findItemGroupsInput) {
    edges {
      node {
        ...FindItemGroups
      }
    }
    pageInfo {
      startCursor
      endCursor
      hasNextPage
      hasPreviousPage
    }
    totalCount
  }
}
    ${FindItemGroupsFragmentDoc}`;
export const MarkStorageUnitAsBilledDocument = gql`
    mutation markStorageUnitAsBilled($markStorageUnitAsBilledInput: MarkStorageUnitAsBilledInput!) {
  markStorageUnitAsBilled(
    markStorageUnitAsBilledInput: $markStorageUnitAsBilledInput
  ) {
    success
  }
}
    `;
export const MarkStorageUnitAsOsdDocument = gql`
    mutation markStorageUnitAsOsd($markStorageUnitAsOsdInput: MarkStorageUnitAsOsdInput!) {
  markStorageUnitAsOsd(markStorageUnitAsOsdInput: $markStorageUnitAsOsdInput) {
    success
  }
}
    `;
export const RemoveStorageUnitOsdDocument = gql`
    mutation removeStorageUnitOsd($removeStorageUnitOsdInput: RemoveStorageUnitOsdInput!) {
  removeStorageUnitOsd(removeStorageUnitOsdInput: $removeStorageUnitOsdInput) {
    success
  }
}
    `;
export const SetStorageOrderItemQuantityDocument = gql`
    mutation setStorageOrderItemQuantity($setStorageOrderItemQuantityInput: SetStorageOrderItemQuantityInput!) {
  setStorageOrderItemQuantity(
    setStorageOrderItemQuantityInput: $setStorageOrderItemQuantityInput
  ) {
    uuid
  }
}
    `;
export const UnassignInventoryItemsDocument = gql`
    mutation unassignInventoryItems($unassignInventoryItemsInput: UnassignInventoryItemsInput!) {
  unassignInventoryItems(
    unassignInventoryItemsInput: $unassignInventoryItemsInput
  ) {
    success
  }
}
    `;
export const UpdateStorageOrderDocument = gql`
    mutation updateStorageOrder($updateStorageOrderInput: UpdateStorageOrderInput!) {
  updateStorageOrder(updateStorageOrderInput: $updateStorageOrderInput) {
    storageOrder {
      ...UpdateStorageOrder
    }
  }
}
    ${UpdateStorageOrderFragmentDoc}`;
export const UpdateStorageUnitDocument = gql`
    mutation updateStorageUnit($updateStorageUnitInput: UpdateStorageUnitInput!) {
  updateStorageUnit(updateStorageUnitInput: $updateStorageUnitInput) {
    storageUnit {
      ...UpdateStorageUnit
    }
  }
}
    ${UpdateStorageUnitFragmentDoc}`;
export const UpsertPicklistDocument = gql`
    mutation upsertPicklist($upsertPicklistInput: UpsertPicklistInput!) {
  upsertPicklist(upsertPicklistInput: $upsertPicklistInput) {
    picklist {
      ...Picklists
    }
    error
  }
}
    ${PicklistsFragmentDoc}`;
export const TagsDocument = gql`
    query tags {
  getTags {
    ...Tag
  }
}
    ${TagFragmentDoc}`;
export const CreateTariffLocationDocument = gql`
    mutation createTariffLocation($createTariffLocationInput: CreateTariffLocationInput!) {
  createTariffLocation(createTariffLocationInput: $createTariffLocationInput) {
    tariffLocation {
      uuid
    }
  }
}
    `;
export const CreateTariffZoneDocument = gql`
    mutation createTariffZone($tariffZoneCreateInput: TariffZoneCreateInput!, $contactUuid: String) {
  createTariffZone(
    tariffZoneCreateInput: $tariffZoneCreateInput
    contactUuid: $contactUuid
  ) {
    uuid
    name
    type
  }
}
    `;
export const DeleteTariffLocationDocument = gql`
    mutation deleteTariffLocation($deleteTariffLocationInput: DeleteTariffLocationInput!) {
  deleteTariffLocation(deleteTariffLocationInput: $deleteTariffLocationInput) {
    tariffLocation {
      uuid
    }
  }
}
    `;
export const DeleteTariffZoneDocument = gql`
    mutation deleteTariffZone($uuid: String!) {
  deleteTariffZone(uuid: $uuid) {
    uuid
  }
}
    `;
export const FindTariffZoneByUuidDocument = gql`
    query findTariffZoneByUuid($uuid: String!) {
  findTariffZoneByUuidOrThrow(uuid: $uuid) {
    uuid
    name
    type
    locations {
      ...TariffLocation
    }
    terminal {
      uuid
      name
    }
    destinationTerminal {
      uuid
      name
    }
  }
}
    ${TariffLocationFragmentDoc}`;
export const TariffZonesDocument = gql`
    query tariffZones($tariffZoneType: TariffZoneType, $contactUuid: String, $tariffZoneLocationType: TariffZoneLocationType, $defaultToGlobal: Boolean, $excludeLineHaulTariffZones: Boolean, $excludeMileBasedTariffZones: Boolean) {
  tariffZones(
    tariffZoneType: $tariffZoneType
    contactUuid: $contactUuid
    tariffZoneLocationType: $tariffZoneLocationType
    defaultToGlobal: $defaultToGlobal
    excludeLineHaulTariffZones: $excludeLineHaulTariffZones
    excludeMileBasedTariffZones: $excludeMileBasedTariffZones
  ) {
    uuid
    name
    type
    lineHaulLane {
      isActive
    }
  }
}
    `;
export const UpdateTariffZoneDocument = gql`
    mutation updateTariffZone($tariffZoneUpdateInput: TariffZoneUpdateInput!, $contactUuid: String) {
  updateTariffZone(
    tariffZoneUpdateInput: $tariffZoneUpdateInput
    contactUuid: $contactUuid
  ) {
    uuid
    name
    type
  }
}
    `;
export const ServicesDocument = gql`
    query services {
  services {
    ...Service
  }
}
    ${ServiceFragmentDoc}`;
export const TariffGroupsDocument = gql`
    query tariffGroups($first: Int, $after: String, $last: Int, $before: String, $uuids: [String!], $searchText: String, $contactUuid: String, $serviceUuid: String, $tariffGroupType: TariffGroupType, $excludeDefault: Boolean) {
  tariffGroupsPaginated(
    first: $first
    after: $after
    before: $before
    last: $last
    uuids: $uuids
    searchText: $searchText
    contactUuid: $contactUuid
    serviceUuid: $serviceUuid
    tariffGroupType: $tariffGroupType
    excludeDefault: $excludeDefault
  ) {
    edges {
      node {
        ...TariffGroupForTable
      }
    }
    pageInfo {
      startCursor
      endCursor
      hasPreviousPage
      hasNextPage
    }
    totalCount
  }
}
    ${TariffGroupForTableFragmentDoc}`;
export const ShipmentsByPhoneOrReferenceNumberDocument = gql`
    query shipmentsByPhoneOrReferenceNumber($searchText: String!, $companyUuid: String!) {
  shipmentsByPhoneOrReferenceNumber(
    searchText: $searchText
    companyUuid: $companyUuid
  ) {
    uuid
    order {
      uuid
      standardOrderFields {
        shipperBillOfLadingNumber
      }
    }
    status
    legs {
      endStop {
        stopType
        address {
          ...Address
        }
      }
    }
  }
}
    ${AddressFragmentDoc}`;
export const TextMessagesDocument = gql`
    query textMessages($phoneNumber: String!) {
  textMessages(phoneNumber: $phoneNumber) {
    ...TextMessage
  }
}
    ${TextMessageFragmentDoc}`;
export const DockScanReportDocument = gql`
    query dockScanReport($dockScanReportInput: DockScanReportInput!) {
  dockScanReport(dockScanReportInput: $dockScanReportInput) {
    rows {
      scanUuid
      contactName
      serviceDate
      scannedAt
      shipperBillOfLadingNumber
      masterAirwayBillOfLadingNumber
      pieceName
      barcode
      consigneeName
      osdReason
      piecesOnHand
      piecesExpected
      terminalCode
      scanType
      pieceMarkedOnHandOrdinal
    }
  }
}
    `;
export const CreateWarehouseLocationDocument = gql`
    mutation createWarehouseLocation($createWarehouseLocationInput: CreateWarehouseLocationInput!) {
  createWarehouseLocation(
    createWarehouseLocationInput: $createWarehouseLocationInput
  ) {
    warehouseLocation {
      ...CreateWarehouseLocation
    }
    errors
  }
}
    ${CreateWarehouseLocationFragmentDoc}`;
export const DeleteUnusedWarehouseLocationsDocument = gql`
    mutation deleteUnusedWarehouseLocations {
  deleteUnusedWarehouseLocations
}
    `;
export const DeleteWarehouseLocationDocument = gql`
    mutation deleteWarehouseLocation($deleteWarehouseLocationInput: DeleteWarehouseLocationInput!) {
  deleteWarehouseLocation(
    deleteWarehouseLocationInput: $deleteWarehouseLocationInput
  ) {
    success
  }
}
    `;
export const WarehouseLocationsDocument = gql`
    query warehouseLocations($companyUuid: String, $warehouseUuid: String) {
  warehouseLocations(companyUuid: $companyUuid, warehouseUuid: $warehouseUuid) {
    warehouseLocations {
      ...WarehouseLocationsLocation
    }
  }
}
    ${WarehouseLocationsLocationFragmentDoc}`;
export const ImportWarehouseLocationsFromCsvDocument = gql`
    mutation importWarehouseLocationsFromCsv($importWarehouseLocationsFromCsvInput: ImportWarehouseLocationsFromCsvInput!) {
  importWarehouseLocationsFromCsv(
    importWarehouseLocationsFromCsvInput: $importWarehouseLocationsFromCsvInput
  )
}
    `;
export const ScanOrderDocument = gql`
    mutation scanOrder($scanOrderInput: ScanOrderInput!) {
  scanOrder(scanOrderInput: $scanOrderInput) {
    uuid
  }
}
    `;
export const UpdateWarehouseLocationDocument = gql`
    mutation updateWarehouseLocation($updateWarehouseLocationInput: UpdateWarehouseLocationInput!) {
  updateWarehouseLocation(
    updateWarehouseLocationInput: $updateWarehouseLocationInput
  ) {
    warehouseLocation {
      ...UpdateWarehouseLocation
    }
    errors
  }
}
    ${UpdateWarehouseLocationFragmentDoc}`;
export const CreateWarehouseDocument = gql`
    mutation createWarehouse($createWarehouseInput: CreateWarehouseInput!) {
  createWarehouse(createWarehouseInput: $createWarehouseInput) {
    uuid
    name
  }
}
    `;
export const DeleteWarehouseDocument = gql`
    mutation deleteWarehouse($warehouseUuid: String!) {
  deleteWarehouse(warehouseUuid: $warehouseUuid) {
    uuid
  }
}
    `;
export const ClosestWarehouseToAddressDocument = gql`
    query closestWarehouseToAddress($addressLatitude: Float!, $addressLongitude: Float!) {
  closestWarehouseToAddress(
    addressLatitude: $addressLatitude
    addressLongitude: $addressLongitude
  ) {
    name
    uuid
  }
}
    `;
export const MarkWarehouseAsDefaultDocument = gql`
    mutation markWarehouseAsDefault($warehouseUuid: String!) {
  markWarehouseAsDefault(warehouseUuid: $warehouseUuid) {
    uuid
    name
  }
}
    `;
export const MyWarehousesDocument = gql`
    query myWarehouses {
  me {
    company {
      warehouses {
        uuid
        name
      }
    }
  }
}
    `;
export const UpdateWarehouseDocument = gql`
    mutation updateWarehouse($updateWarehouseInput: UpdateWarehouseInput!) {
  updateWarehouse(updateWarehouseInput: $updateWarehouseInput) {
    uuid
    name
  }
}
    `;
export const WarehouseDocument = gql`
    query warehouse($warehouseUuid: String!) {
  warehouse(warehouseUuid: $warehouseUuid) {
    name
    uuid
    address {
      uuid
    }
    isDefault
    terminal {
      uuid
    }
  }
}
    `;
export const WarehousesDocument = gql`
    query warehouses($warehousesInput: WarehousesInput!) {
  warehouses(warehousesInput: $warehousesInput) {
    uuid
    name
    address {
      ...Address
    }
    isDefault
    terminal {
      uuid
      code
    }
  }
}
    ${AddressFragmentDoc}`;
export const FindLegsDocument = gql`
    query findLegs($startDate: DateTime!, $endDate: DateTime!) {
  legs(
    startDate: $startDate
    endDate: $endDate
    shipHasArrived: true
    showUnscheduled: true
  ) {
    uuid
    shipment {
      uuid
    }
    scheduledDate
    endStop {
      address {
        name
        line1
        line2
        city
        state
      }
    }
  }
}
    `;

export type SdkFunctionWrapper = <T>(action: (requestHeaders?:Record<string, string>) => Promise<T>, operationName: string, operationType?: string, variables?: any) => Promise<T>;


const defaultWrapper: SdkFunctionWrapper = (action, _operationName, _operationType, _variables) => action();

export function getSdk(client: GraphQLClient, withWrapper: SdkFunctionWrapper = defaultWrapper) {
  return {
    ablyToken(variables?: AblyTokenQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<AblyTokenQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<AblyTokenQuery>(AblyTokenDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'ablyToken', 'query', variables);
    },
    activeAgents(variables?: ActiveAgentsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ActiveAgentsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<ActiveAgentsQuery>(ActiveAgentsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'activeAgents', 'query', variables);
    },
    contactForAutocomplete(variables: ContactForAutocompleteQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ContactForAutocompleteQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<ContactForAutocompleteQuery>(ContactForAutocompleteDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'contactForAutocomplete', 'query', variables);
    },
    ContactPackageSpecs(variables: ContactPackageSpecsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ContactPackageSpecsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<ContactPackageSpecsQuery>(ContactPackageSpecsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'ContactPackageSpecs', 'query', variables);
    },
    contactsForAutocomplete(variables?: ContactsForAutocompleteQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ContactsForAutocompleteQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<ContactsForAutocompleteQuery>(ContactsForAutocompleteDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'contactsForAutocomplete', 'query', variables);
    },
    dispatchableDrivers(variables: DispatchableDriversQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<DispatchableDriversQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<DispatchableDriversQuery>(DispatchableDriversDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'dispatchableDrivers', 'query', variables);
    },
    driverMinimal(variables: DriverMinimalQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<DriverMinimalQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<DriverMinimalQuery>(DriverMinimalDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'driverMinimal', 'query', variables);
    },
    login(variables: LoginMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<LoginMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<LoginMutation>(LoginDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'login', 'mutation', variables);
    },
    logout(variables?: LogoutMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<LogoutMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<LogoutMutation>(LogoutDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'logout', 'mutation', variables);
    },
    meAsThirdPartyUserForAuth(variables?: MeAsThirdPartyUserForAuthQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<MeAsThirdPartyUserForAuthQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<MeAsThirdPartyUserForAuthQuery>(MeAsThirdPartyUserForAuthDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'meAsThirdPartyUserForAuth', 'query', variables);
    },
    meAsThirdPartyUser(variables?: MeAsThirdPartyUserQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<MeAsThirdPartyUserQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<MeAsThirdPartyUserQuery>(MeAsThirdPartyUserDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'meAsThirdPartyUser', 'query', variables);
    },
    MeForAuth(variables?: MeForAuthQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<MeForAuthQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<MeForAuthQuery>(MeForAuthDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'MeForAuth', 'query', variables);
    },
    me(variables?: MeQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<MeQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<MeQuery>(MeDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'me', 'query', variables);
    },
    userRoles(variables?: UserRolesQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UserRolesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<UserRolesQuery>(UserRolesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'userRoles', 'query', variables);
    },
    tableFields(variables?: TableFieldsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<TableFieldsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<TableFieldsQuery>(TableFieldsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'tableFields', 'query', variables);
    },
    register(variables: RegisterMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<RegisterMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<RegisterMutation>(RegisterDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'register', 'mutation', variables);
    },
    tariffChains(variables: TariffChainsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<TariffChainsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<TariffChainsQuery>(TariffChainsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'tariffChains', 'query', variables);
    },
    templateAddresses(variables?: TemplateAddressesQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<TemplateAddressesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<TemplateAddressesQuery>(TemplateAddressesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'templateAddresses', 'query', variables);
    },
    whiteLabelCompany(variables: WhiteLabelCompanyQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<WhiteLabelCompanyQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<WhiteLabelCompanyQuery>(WhiteLabelCompanyDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'whiteLabelCompany', 'query', variables);
    },
    autoApplyAccessorialConfig(variables: AutoApplyAccessorialConfigQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<AutoApplyAccessorialConfigQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<AutoApplyAccessorialConfigQuery>(AutoApplyAccessorialConfigDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'autoApplyAccessorialConfig', 'query', variables);
    },
    autoApplyAccessorialConfigs(variables?: AutoApplyAccessorialConfigsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<AutoApplyAccessorialConfigsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<AutoApplyAccessorialConfigsQuery>(AutoApplyAccessorialConfigsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'autoApplyAccessorialConfigs', 'query', variables);
    },
    createAutoApplyAccessorialConfig(variables: CreateAutoApplyAccessorialConfigMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CreateAutoApplyAccessorialConfigMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateAutoApplyAccessorialConfigMutation>(CreateAutoApplyAccessorialConfigDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'createAutoApplyAccessorialConfig', 'mutation', variables);
    },
    deleteAutoApplyAccessorialConfig(variables: DeleteAutoApplyAccessorialConfigMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<DeleteAutoApplyAccessorialConfigMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<DeleteAutoApplyAccessorialConfigMutation>(DeleteAutoApplyAccessorialConfigDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'deleteAutoApplyAccessorialConfig', 'mutation', variables);
    },
    selectSpecialAccessorial(variables: SelectSpecialAccessorialQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<SelectSpecialAccessorialQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<SelectSpecialAccessorialQuery>(SelectSpecialAccessorialDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'selectSpecialAccessorial', 'query', variables);
    },
    updateAutoApplyAccessorialConfig(variables: UpdateAutoApplyAccessorialConfigMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UpdateAutoApplyAccessorialConfigMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateAutoApplyAccessorialConfigMutation>(UpdateAutoApplyAccessorialConfigDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updateAutoApplyAccessorialConfig', 'mutation', variables);
    },
    coordinatesForAddress(variables?: CoordinatesForAddressQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CoordinatesForAddressQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CoordinatesForAddressQuery>(CoordinatesForAddressDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'coordinatesForAddress', 'query', variables);
    },
    getCityAndStateOptionsFromZipcode(variables: GetCityAndStateOptionsFromZipcodeQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetCityAndStateOptionsFromZipcodeQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetCityAndStateOptionsFromZipcodeQuery>(GetCityAndStateOptionsFromZipcodeDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getCityAndStateOptionsFromZipcode', 'query', variables);
    },
    getZipcodeOptionsFromCityAndState(variables: GetZipcodeOptionsFromCityAndStateQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetZipcodeOptionsFromCityAndStateQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetZipcodeOptionsFromCityAndStateQuery>(GetZipcodeOptionsFromCityAndStateDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getZipcodeOptionsFromCityAndState', 'query', variables);
    },
    airportInfo(variables: AirportInfoQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<AirportInfoQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<AirportInfoQuery>(AirportInfoDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'airportInfo', 'query', variables);
    },
    AppointmentConfirmationInfo(variables: AppointmentConfirmationInfoQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<AppointmentConfirmationInfoQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<AppointmentConfirmationInfoQuery>(AppointmentConfirmationInfoDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AppointmentConfirmationInfo', 'query', variables);
    },
    getAppointments(variables?: GetAppointmentsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetAppointmentsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetAppointmentsQuery>(GetAppointmentsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getAppointments', 'query', variables);
    },
    bulkConfirmAppointments(variables: BulkConfirmAppointmentsMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<BulkConfirmAppointmentsMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<BulkConfirmAppointmentsMutation>(BulkConfirmAppointmentsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'bulkConfirmAppointments', 'mutation', variables);
    },
    bulkChangeCallStatus(variables: BulkChangeCallStatusMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<BulkChangeCallStatusMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<BulkChangeCallStatusMutation>(BulkChangeCallStatusDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'bulkChangeCallStatus', 'mutation', variables);
    },
    callStops(variables: CallStopsMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CallStopsMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CallStopsMutation>(CallStopsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'callStops', 'mutation', variables);
    },
    getDefaultTexts(variables: GetDefaultTextsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetDefaultTextsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetDefaultTextsQuery>(GetDefaultTextsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getDefaultTexts', 'query', variables);
    },
    MakeAppointmentConfirmationDecision(variables: MakeAppointmentConfirmationDecisionMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<MakeAppointmentConfirmationDecisionMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<MakeAppointmentConfirmationDecisionMutation>(MakeAppointmentConfirmationDecisionDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'MakeAppointmentConfirmationDecision', 'mutation', variables);
    },
    queueAppointmentTexts(variables: QueueAppointmentTextsMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<QueueAppointmentTextsMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<QueueAppointmentTextsMutation>(QueueAppointmentTextsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'queueAppointmentTexts', 'mutation', variables);
    },
    removeStopsFromRoutes(variables: RemoveStopsFromRoutesMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<RemoveStopsFromRoutesMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<RemoveStopsFromRoutesMutation>(RemoveStopsFromRoutesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'removeStopsFromRoutes', 'mutation', variables);
    },
    auditReport(variables: AuditReportQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<AuditReportQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<AuditReportQuery>(AuditReportDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'auditReport', 'query', variables);
    },
    companyConfiguration(variables?: CompanyConfigurationQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CompanyConfigurationQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CompanyConfigurationQuery>(CompanyConfigurationDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'companyConfiguration', 'query', variables);
    },
    contactPersons(variables?: ContactPersonsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ContactPersonsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<ContactPersonsQuery>(ContactPersonsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'contactPersons', 'query', variables);
    },
    archiveContactStation(variables: ArchiveContactStationMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ArchiveContactStationMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<ArchiveContactStationMutation>(ArchiveContactStationDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'archiveContactStation', 'mutation', variables);
    },
    ArchivePerson(variables: ArchivePersonMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ArchivePersonMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<ArchivePersonMutation>(ArchivePersonDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'ArchivePerson', 'mutation', variables);
    },
    createContactComment(variables: CreateContactCommentMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CreateContactCommentMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateContactCommentMutation>(CreateContactCommentDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'createContactComment', 'mutation', variables);
    },
    deleteContactComment(variables: DeleteContactCommentMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<DeleteContactCommentMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<DeleteContactCommentMutation>(DeleteContactCommentDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'deleteContactComment', 'mutation', variables);
    },
    updateContactComment(variables: UpdateContactCommentMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UpdateContactCommentMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateContactCommentMutation>(UpdateContactCommentDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updateContactComment', 'mutation', variables);
    },
    contactCommunicationConfigs(variables: ContactCommunicationConfigsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ContactCommunicationConfigsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<ContactCommunicationConfigsQuery>(ContactCommunicationConfigsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'contactCommunicationConfigs', 'query', variables);
    },
    contactDefaultSurcharge(variables: ContactDefaultSurchargeQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ContactDefaultSurchargeQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<ContactDefaultSurchargeQuery>(ContactDefaultSurchargeDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'contactDefaultSurcharge', 'query', variables);
    },
    contactEmails(variables: ContactEmailsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ContactEmailsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<ContactEmailsQuery>(ContactEmailsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'contactEmails', 'query', variables);
    },
    contactIsOverCreditLimitByOrderUuid(variables: ContactIsOverCreditLimitByOrderUuidQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ContactIsOverCreditLimitByOrderUuidQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<ContactIsOverCreditLimitByOrderUuidQuery>(ContactIsOverCreditLimitByOrderUuidDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'contactIsOverCreditLimitByOrderUuid', 'query', variables);
    },
    contactIsOverCreditLimit(variables: ContactIsOverCreditLimitQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ContactIsOverCreditLimitQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<ContactIsOverCreditLimitQuery>(ContactIsOverCreditLimitDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'contactIsOverCreditLimit', 'query', variables);
    },
    contactLogos(variables: ContactLogosQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ContactLogosQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<ContactLogosQuery>(ContactLogosDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'contactLogos', 'query', variables);
    },
    contactQueryForBluebird(variables: ContactQueryForBluebirdQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ContactQueryForBluebirdQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<ContactQueryForBluebirdQuery>(ContactQueryForBluebirdDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'contactQueryForBluebird', 'query', variables);
    },
    contactServices(variables: ContactServicesQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ContactServicesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<ContactServicesQuery>(ContactServicesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'contactServices', 'query', variables);
    },
    contactStations(variables: ContactStationsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ContactStationsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<ContactStationsQuery>(ContactStationsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'contactStations', 'query', variables);
    },
    contact(variables: ContactQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ContactQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<ContactQuery>(ContactDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'contact', 'query', variables);
    },
    contactsForInvoicing(variables: ContactsForInvoicingQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ContactsForInvoicingQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<ContactsForInvoicingQuery>(ContactsForInvoicingDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'contactsForInvoicing', 'query', variables);
    },
    contactsForQuickbooks(variables?: ContactsForQuickbooksQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ContactsForQuickbooksQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<ContactsForQuickbooksQuery>(ContactsForQuickbooksDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'contactsForQuickbooks', 'query', variables);
    },
    contactsPageListing(variables?: ContactsPageListingQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ContactsPageListingQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<ContactsPageListingQuery>(ContactsPageListingDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'contactsPageListing', 'query', variables);
    },
    contactsReport(variables?: ContactsReportQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ContactsReportQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<ContactsReportQuery>(ContactsReportDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'contactsReport', 'query', variables);
    },
    contactsSimple(variables?: ContactsSimpleQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ContactsSimpleQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<ContactsSimpleQuery>(ContactsSimpleDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'contactsSimple', 'query', variables);
    },
    contacts(variables?: ContactsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ContactsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<ContactsQuery>(ContactsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'contacts', 'query', variables);
    },
    createAddress(variables: CreateAddressMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CreateAddressMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateAddressMutation>(CreateAddressDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'createAddress', 'mutation', variables);
    },
    createContactEmail(variables: CreateContactEmailMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CreateContactEmailMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateContactEmailMutation>(CreateContactEmailDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'createContactEmail', 'mutation', variables);
    },
    createContactPerson(variables: CreateContactPersonMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CreateContactPersonMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateContactPersonMutation>(CreateContactPersonDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'createContactPerson', 'mutation', variables);
    },
    createContactStation(variables: CreateContactStationMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CreateContactStationMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateContactStationMutation>(CreateContactStationDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'createContactStation', 'mutation', variables);
    },
    createCustomerContact(variables: CreateCustomerContactMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CreateCustomerContactMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateCustomerContactMutation>(CreateCustomerContactDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'createCustomerContact', 'mutation', variables);
    },
    CreatePerson(variables: CreatePersonMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CreatePersonMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreatePersonMutation>(CreatePersonDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'CreatePerson', 'mutation', variables);
    },
    findServicesForCustomerConfiguration(variables: FindServicesForCustomerConfigurationQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<FindServicesForCustomerConfigurationQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<FindServicesForCustomerConfigurationQuery>(FindServicesForCustomerConfigurationDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'findServicesForCustomerConfiguration', 'query', variables);
    },
    deleteContactEmail(variables: DeleteContactEmailMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<DeleteContactEmailMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<DeleteContactEmailMutation>(DeleteContactEmailDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'deleteContactEmail', 'mutation', variables);
    },
    invoiceTerms(variables?: InvoiceTermsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<InvoiceTermsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<InvoiceTermsQuery>(InvoiceTermsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'invoiceTerms', 'query', variables);
    },
    OrderEventNotificationSubscriptions(variables: OrderEventNotificationSubscriptionsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<OrderEventNotificationSubscriptionsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<OrderEventNotificationSubscriptionsQuery>(OrderEventNotificationSubscriptionsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'OrderEventNotificationSubscriptions', 'query', variables);
    },
    paginatedContacts(variables?: PaginatedContactsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<PaginatedContactsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<PaginatedContactsQuery>(PaginatedContactsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'paginatedContacts', 'query', variables);
    },
    Persons(variables?: PersonsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<PersonsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<PersonsQuery>(PersonsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'Persons', 'query', variables);
    },
    queryQuickbooksDesktopAccounts(variables?: QueryQuickbooksDesktopAccountsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<QueryQuickbooksDesktopAccountsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<QueryQuickbooksDesktopAccountsQuery>(QueryQuickbooksDesktopAccountsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'queryQuickbooksDesktopAccounts', 'query', variables);
    },
    queryQuickbooksDesktopCustomers(variables?: QueryQuickbooksDesktopCustomersQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<QueryQuickbooksDesktopCustomersQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<QueryQuickbooksDesktopCustomersQuery>(QueryQuickbooksDesktopCustomersDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'queryQuickbooksDesktopCustomers', 'query', variables);
    },
    removeAddress(variables: RemoveAddressMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<RemoveAddressMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<RemoveAddressMutation>(RemoveAddressDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'removeAddress', 'mutation', variables);
    },
    removeContactPerson(variables: RemoveContactPersonMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<RemoveContactPersonMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<RemoveContactPersonMutation>(RemoveContactPersonDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'removeContactPerson', 'mutation', variables);
    },
    restoreContactStation(variables: RestoreContactStationMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<RestoreContactStationMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<RestoreContactStationMutation>(RestoreContactStationDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'restoreContactStation', 'mutation', variables);
    },
    RestorePerson(variables: RestorePersonMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<RestorePersonMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<RestorePersonMutation>(RestorePersonDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'RestorePerson', 'mutation', variables);
    },
    shallowContact(variables: ShallowContactQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ShallowContactQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<ShallowContactQuery>(ShallowContactDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'shallowContact', 'query', variables);
    },
    shallowContactsByUuids(variables: ShallowContactsByUuidsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ShallowContactsByUuidsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<ShallowContactsByUuidsQuery>(ShallowContactsByUuidsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'shallowContactsByUuids', 'query', variables);
    },
    shallowContacts(variables?: ShallowContactsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ShallowContactsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<ShallowContactsQuery>(ShallowContactsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'shallowContacts', 'query', variables);
    },
    thirdPartyUserByUuid(variables: ThirdPartyUserByUuidQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ThirdPartyUserByUuidQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<ThirdPartyUserByUuidQuery>(ThirdPartyUserByUuidDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'thirdPartyUserByUuid', 'query', variables);
    },
    thirdPartyUsersByContact(variables: ThirdPartyUsersByContactQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ThirdPartyUsersByContactQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<ThirdPartyUsersByContactQuery>(ThirdPartyUsersByContactDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'thirdPartyUsersByContact', 'query', variables);
    },
    updateAddress(variables: UpdateAddressMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UpdateAddressMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateAddressMutation>(UpdateAddressDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updateAddress', 'mutation', variables);
    },
    updateContactCommunicationConfig(variables: UpdateContactCommunicationConfigMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UpdateContactCommunicationConfigMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateContactCommunicationConfigMutation>(UpdateContactCommunicationConfigDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updateContactCommunicationConfig', 'mutation', variables);
    },
    UpdateContactEmails(variables: UpdateContactEmailsMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UpdateContactEmailsMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateContactEmailsMutation>(UpdateContactEmailsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'UpdateContactEmails', 'mutation', variables);
    },
    updateContactPerson(variables: UpdateContactPersonMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UpdateContactPersonMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateContactPersonMutation>(UpdateContactPersonDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updateContactPerson', 'mutation', variables);
    },
    updateContactStation(variables: UpdateContactStationMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UpdateContactStationMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateContactStationMutation>(UpdateContactStationDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updateContactStation', 'mutation', variables);
    },
    updateCustomerContact(variables: UpdateCustomerContactMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UpdateCustomerContactMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateCustomerContactMutation>(UpdateCustomerContactDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updateCustomerContact', 'mutation', variables);
    },
    UpdateOrderEventNotificationSubscriptions(variables: UpdateOrderEventNotificationSubscriptionsMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UpdateOrderEventNotificationSubscriptionsMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateOrderEventNotificationSubscriptionsMutation>(UpdateOrderEventNotificationSubscriptionsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'UpdateOrderEventNotificationSubscriptions', 'mutation', variables);
    },
    UpdatePerson(variables: UpdatePersonMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UpdatePersonMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdatePersonMutation>(UpdatePersonDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'UpdatePerson', 'mutation', variables);
    },
    upsertAddress(variables: UpsertAddressMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UpsertAddressMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpsertAddressMutation>(UpsertAddressDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'upsertAddress', 'mutation', variables);
    },
    upsertContactPerson(variables: UpsertContactPersonMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UpsertContactPersonMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpsertContactPersonMutation>(UpsertContactPersonDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'upsertContactPerson', 'mutation', variables);
    },
    upsertUserContactNotificationSubscription(variables: UpsertUserContactNotificationSubscriptionMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UpsertUserContactNotificationSubscriptionMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpsertUserContactNotificationSubscriptionMutation>(UpsertUserContactNotificationSubscriptionDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'upsertUserContactNotificationSubscription', 'mutation', variables);
    },
    userContactNotificationSubscription(variables: UserContactNotificationSubscriptionQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UserContactNotificationSubscriptionQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<UserContactNotificationSubscriptionQuery>(UserContactNotificationSubscriptionDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'userContactNotificationSubscription', 'query', variables);
    },
    addThirdPartyUserToContact(variables: AddThirdPartyUserToContactMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<AddThirdPartyUserToContactMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<AddThirdPartyUserToContactMutation>(AddThirdPartyUserToContactDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'addThirdPartyUserToContact', 'mutation', variables);
    },
    consigneePortalOrder(variables: ConsigneePortalOrderQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ConsigneePortalOrderQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<ConsigneePortalOrderQuery>(ConsigneePortalOrderDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'consigneePortalOrder', 'query', variables);
    },
    customerPortalCompany(variables: CustomerPortalCompanyQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CustomerPortalCompanyQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CustomerPortalCompanyQuery>(CustomerPortalCompanyDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'customerPortalCompany', 'query', variables);
    },
    customerPortalMe(variables?: CustomerPortalMeQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CustomerPortalMeQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CustomerPortalMeQuery>(CustomerPortalMeDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'customerPortalMe', 'query', variables);
    },
    customerPortalOrder(variables: CustomerPortalOrderQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CustomerPortalOrderQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CustomerPortalOrderQuery>(CustomerPortalOrderDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'customerPortalOrder', 'query', variables);
    },
    customerPortalQuotes(variables: CustomerPortalQuotesQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CustomerPortalQuotesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CustomerPortalQuotesQuery>(CustomerPortalQuotesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'customerPortalQuotes', 'query', variables);
    },
    customerPortalOrders(variables?: CustomerPortalOrdersQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CustomerPortalOrdersQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CustomerPortalOrdersQuery>(CustomerPortalOrdersDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'customerPortalOrders', 'query', variables);
    },
    etaForCustomerPortal(variables: EtaForCustomerPortalQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<EtaForCustomerPortalQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<EtaForCustomerPortalQuery>(EtaForCustomerPortalDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'etaForCustomerPortal', 'query', variables);
    },
    publicUpsertShipmentSubscriber(variables: PublicUpsertShipmentSubscriberMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<PublicUpsertShipmentSubscriberMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<PublicUpsertShipmentSubscriberMutation>(PublicUpsertShipmentSubscriberDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'publicUpsertShipmentSubscriber', 'mutation', variables);
    },
    removeThirdPartyUserFromContact(variables: RemoveThirdPartyUserFromContactMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<RemoveThirdPartyUserFromContactMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<RemoveThirdPartyUserFromContactMutation>(RemoveThirdPartyUserFromContactDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'removeThirdPartyUserFromContact', 'mutation', variables);
    },
    signUpForThirdPartyUserAccount(variables: SignUpForThirdPartyUserAccountMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<SignUpForThirdPartyUserAccountMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<SignUpForThirdPartyUserAccountMutation>(SignUpForThirdPartyUserAccountDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'signUpForThirdPartyUserAccount', 'mutation', variables);
    },
    calculateRouteEtas(variables: CalculateRouteEtasMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CalculateRouteEtasMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CalculateRouteEtasMutation>(CalculateRouteEtasDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'calculateRouteEtas', 'mutation', variables);
    },
    sameDayDispatchRoutesWithDriverCoords(variables: SameDayDispatchRoutesWithDriverCoordsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<SameDayDispatchRoutesWithDriverCoordsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<SameDayDispatchRoutesWithDriverCoordsQuery>(SameDayDispatchRoutesWithDriverCoordsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'sameDayDispatchRoutesWithDriverCoords', 'query', variables);
    },
    dispatchDrivers(variables: DispatchDriversQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<DispatchDriversQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<DispatchDriversQuery>(DispatchDriversDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'dispatchDrivers', 'query', variables);
    },
    equipmentsByType(variables?: EquipmentsByTypeQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<EquipmentsByTypeQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<EquipmentsByTypeQuery>(EquipmentsByTypeDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'equipmentsByType', 'query', variables);
    },
    leg(variables: LegQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<LegQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<LegQuery>(LegDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'leg', 'query', variables);
    },
    legs(variables: LegsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<LegsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<LegsQuery>(LegsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'legs', 'query', variables);
    },
    refreshEtasForRoute(variables: RefreshEtasForRouteMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<RefreshEtasForRouteMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<RefreshEtasForRouteMutation>(RefreshEtasForRouteDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'refreshEtasForRoute', 'mutation', variables);
    },
    unassignLegFromDriver(variables: UnassignLegFromDriverMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UnassignLegFromDriverMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UnassignLegFromDriverMutation>(UnassignLegFromDriverDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'unassignLegFromDriver', 'mutation', variables);
    },
    sameDayDispatchConfig(variables?: SameDayDispatchConfigQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<SameDayDispatchConfigQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<SameDayDispatchConfigQuery>(SameDayDispatchConfigDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'sameDayDispatchConfig', 'query', variables);
    },
    updateSameDayDispatchConfig(variables: UpdateSameDayDispatchConfigMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UpdateSameDayDispatchConfigMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateSameDayDispatchConfigMutation>(UpdateSameDayDispatchConfigDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updateSameDayDispatchConfig', 'mutation', variables);
    },
    updateShipment(variables: UpdateShipmentMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UpdateShipmentMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateShipmentMutation>(UpdateShipmentDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updateShipment', 'mutation', variables);
    },
    archiveOrganization(variables: ArchiveOrganizationMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ArchiveOrganizationMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<ArchiveOrganizationMutation>(ArchiveOrganizationDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'archiveOrganization', 'mutation', variables);
    },
    createOrganization(variables: CreateOrganizationMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CreateOrganizationMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateOrganizationMutation>(CreateOrganizationDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'createOrganization', 'mutation', variables);
    },
    organizationForAddressBook(variables: OrganizationForAddressBookQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<OrganizationForAddressBookQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<OrganizationForAddressBookQuery>(OrganizationForAddressBookDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'organizationForAddressBook', 'query', variables);
    },
    organizationForFrontendHook(variables: OrganizationForFrontendHookQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<OrganizationForFrontendHookQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<OrganizationForFrontendHookQuery>(OrganizationForFrontendHookDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'organizationForFrontendHook', 'query', variables);
    },
    organizationNotes(variables: OrganizationNotesQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<OrganizationNotesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<OrganizationNotesQuery>(OrganizationNotesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'organizationNotes', 'query', variables);
    },
    organization(variables: OrganizationQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<OrganizationQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<OrganizationQuery>(OrganizationDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'organization', 'query', variables);
    },
    paginatedOrganizations(variables: PaginatedOrganizationsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<PaginatedOrganizationsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<PaginatedOrganizationsQuery>(PaginatedOrganizationsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'paginatedOrganizations', 'query', variables);
    },
    restoreOrganization(variables: RestoreOrganizationMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<RestoreOrganizationMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<RestoreOrganizationMutation>(RestoreOrganizationDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'restoreOrganization', 'mutation', variables);
    },
    updateOrganization(variables: UpdateOrganizationMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UpdateOrganizationMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateOrganizationMutation>(UpdateOrganizationDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updateOrganization', 'mutation', variables);
    },
    createDispatchView(variables: CreateDispatchViewMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CreateDispatchViewMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateDispatchViewMutation>(CreateDispatchViewDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'createDispatchView', 'mutation', variables);
    },
    dispatchViews(variables?: DispatchViewsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<DispatchViewsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<DispatchViewsQuery>(DispatchViewsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'dispatchViews', 'query', variables);
    },
    removeDispatchView(variables: RemoveDispatchViewMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<RemoveDispatchViewMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<RemoveDispatchViewMutation>(RemoveDispatchViewDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'removeDispatchView', 'mutation', variables);
    },
    updateDispatchView(variables: UpdateDispatchViewMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UpdateDispatchViewMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateDispatchViewMutation>(UpdateDispatchViewDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updateDispatchView', 'mutation', variables);
    },
    driversForSelection(variables?: DriversForSelectionQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<DriversForSelectionQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<DriversForSelectionQuery>(DriversForSelectionDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'driversForSelection', 'query', variables);
    },
    generateRoutes(variables: GenerateRoutesQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GenerateRoutesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GenerateRoutesQuery>(GenerateRoutesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'generateRoutes', 'query', variables);
    },
    dispatchTableColors(variables?: DispatchTableColorsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<DispatchTableColorsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<DispatchTableColorsQuery>(DispatchTableColorsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'dispatchTableColors', 'query', variables);
    },
    UpdateDispatchTableColors(variables: UpdateDispatchTableColorsMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UpdateDispatchTableColorsMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateDispatchTableColorsMutation>(UpdateDispatchTableColorsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'UpdateDispatchTableColors', 'mutation', variables);
    },
    CreateRouteSlot(variables: CreateRouteSlotMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CreateRouteSlotMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateRouteSlotMutation>(CreateRouteSlotDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'CreateRouteSlot', 'mutation', variables);
    },
    drivers(variables?: DriversQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<DriversQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<DriversQuery>(DriversDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'drivers', 'query', variables);
    },
    driversWithRoutes(variables: DriversWithRoutesQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<DriversWithRoutesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<DriversWithRoutesQuery>(DriversWithRoutesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'driversWithRoutes', 'query', variables);
    },
    getOptimizationResults(variables: GetOptimizationResultsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetOptimizationResultsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetOptimizationResultsQuery>(GetOptimizationResultsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getOptimizationResults', 'query', variables);
    },
    groupByStops(variables: GroupByStopsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GroupByStopsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GroupByStopsQuery>(GroupByStopsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'groupByStops', 'query', variables);
    },
    numberOfStops(variables?: NumberOfStopsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<NumberOfStopsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<NumberOfStopsQuery>(NumberOfStopsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'numberOfStops', 'query', variables);
    },
    routeEta(variables: RouteEtaQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<RouteEtaQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<RouteEtaQuery>(RouteEtaDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'routeEta', 'query', variables);
    },
    assignHelperToRoute(variables: AssignHelperToRouteMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<AssignHelperToRouteMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<AssignHelperToRouteMutation>(AssignHelperToRouteDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'assignHelperToRoute', 'mutation', variables);
    },
    createAppointmentsForRoute(variables: CreateAppointmentsForRouteMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CreateAppointmentsForRouteMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateAppointmentsForRouteMutation>(CreateAppointmentsForRouteDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'createAppointmentsForRoute', 'mutation', variables);
    },
    createRoutePaths(variables: CreateRoutePathsMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CreateRoutePathsMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateRoutePathsMutation>(CreateRoutePathsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'createRoutePaths', 'mutation', variables);
    },
    createRoutes(variables: CreateRoutesMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CreateRoutesMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateRoutesMutation>(CreateRoutesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'createRoutes', 'mutation', variables);
    },
    deleteSlotsFromRoute(variables: DeleteSlotsFromRouteMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<DeleteSlotsFromRouteMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<DeleteSlotsFromRouteMutation>(DeleteSlotsFromRouteDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'deleteSlotsFromRoute', 'mutation', variables);
    },
    driversForHelpers(variables: DriversForHelpersQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<DriversForHelpersQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<DriversForHelpersQuery>(DriversForHelpersDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'driversForHelpers', 'query', variables);
    },
    runOptimization(variables: RunOptimizationMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<RunOptimizationMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<RunOptimizationMutation>(RunOptimizationDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'runOptimization', 'mutation', variables);
    },
    reassignRouteSlot(variables: ReassignRouteSlotMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ReassignRouteSlotMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<ReassignRouteSlotMutation>(ReassignRouteSlotDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'reassignRouteSlot', 'mutation', variables);
    },
    removeHelperFromRoute(variables: RemoveHelperFromRouteMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<RemoveHelperFromRouteMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<RemoveHelperFromRouteMutation>(RemoveHelperFromRouteDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'removeHelperFromRoute', 'mutation', variables);
    },
    removeRoute(variables: RemoveRouteMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<RemoveRouteMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<RemoveRouteMutation>(RemoveRouteDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'removeRoute', 'mutation', variables);
    },
    routePathByRoute(variables: RoutePathByRouteQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<RoutePathByRouteQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<RoutePathByRouteQuery>(RoutePathByRouteDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'routePathByRoute', 'query', variables);
    },
    routePaths(variables: RoutePathsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<RoutePathsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<RoutePathsQuery>(RoutePathsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'routePaths', 'query', variables);
    },
    routes(variables?: RoutesQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<RoutesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<RoutesQuery>(RoutesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'routes', 'query', variables);
    },
    routesSamsaraVehicleLocations(variables: RoutesSamsaraVehicleLocationsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<RoutesSamsaraVehicleLocationsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<RoutesSamsaraVehicleLocationsQuery>(RoutesSamsaraVehicleLocationsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'routesSamsaraVehicleLocations', 'query', variables);
    },
    routesWithDriverMobilePhoneCoordinates(variables: RoutesWithDriverMobilePhoneCoordinatesQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<RoutesWithDriverMobilePhoneCoordinatesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<RoutesWithDriverMobilePhoneCoordinatesQuery>(RoutesWithDriverMobilePhoneCoordinatesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'routesWithDriverMobilePhoneCoordinates', 'query', variables);
    },
    routesWithEta(variables: RoutesWithEtaQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<RoutesWithEtaQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<RoutesWithEtaQuery>(RoutesWithEtaDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'routesWithEta', 'query', variables);
    },
    paginatedRoutes(variables?: PaginatedRoutesQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<PaginatedRoutesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<PaginatedRoutesQuery>(PaginatedRoutesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'paginatedRoutes', 'query', variables);
    },
    updateRoute(variables: UpdateRouteMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UpdateRouteMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateRouteMutation>(UpdateRouteDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updateRoute', 'mutation', variables);
    },
    updateVehicleForRoute(variables: UpdateVehicleForRouteMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UpdateVehicleForRouteMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateVehicleForRouteMutation>(UpdateVehicleForRouteDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updateVehicleForRoute', 'mutation', variables);
    },
    sameDayDispatchRoutes(variables: SameDayDispatchRoutesQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<SameDayDispatchRoutesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<SameDayDispatchRoutesQuery>(SameDayDispatchRoutesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'sameDayDispatchRoutes', 'query', variables);
    },
    samsaraVehicleStatsFeed(variables: SamsaraVehicleStatsFeedQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<SamsaraVehicleStatsFeedQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<SamsaraVehicleStatsFeedQuery>(SamsaraVehicleStatsFeedDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'samsaraVehicleStatsFeed', 'query', variables);
    },
    sendRouteToAgent(variables: SendRouteToAgentMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<SendRouteToAgentMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<SendRouteToAgentMutation>(SendRouteToAgentDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'sendRouteToAgent', 'mutation', variables);
    },
    stopsBySearchText(variables: StopsBySearchTextQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<StopsBySearchTextQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<StopsBySearchTextQuery>(StopsBySearchTextDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'stopsBySearchText', 'query', variables);
    },
    stopsOnRoutesBySearchText(variables: StopsOnRoutesBySearchTextQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<StopsOnRoutesBySearchTextQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<StopsOnRoutesBySearchTextQuery>(StopsOnRoutesBySearchTextDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'stopsOnRoutesBySearchText', 'query', variables);
    },
    stopQueryForOverrideMinutes(variables: StopQueryForOverrideMinutesQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<StopQueryForOverrideMinutesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<StopQueryForOverrideMinutesQuery>(StopQueryForOverrideMinutesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'stopQueryForOverrideMinutes', 'query', variables);
    },
    stops(variables?: StopsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<StopsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<StopsQuery>(StopsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'stops', 'query', variables);
    },
    textDriver(variables: TextDriverMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<TextDriverMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<TextDriverMutation>(TextDriverDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'textDriver', 'mutation', variables);
    },
    updateRouteDrivers(variables: UpdateRouteDriversMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UpdateRouteDriversMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateRouteDriversMutation>(UpdateRouteDriversDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updateRouteDrivers', 'mutation', variables);
    },
    updateRouteSlots(variables: UpdateRouteSlotsMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UpdateRouteSlotsMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateRouteSlotsMutation>(UpdateRouteSlotsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updateRouteSlots', 'mutation', variables);
    },
    companyDocuments(variables: CompanyDocumentsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CompanyDocumentsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CompanyDocumentsQuery>(CompanyDocumentsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'companyDocuments', 'query', variables);
    },
    companySchemas(variables?: CompanySchemasQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CompanySchemasQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CompanySchemasQuery>(CompanySchemasDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'companySchemas', 'query', variables);
    },
    splitAndProcessOrderDocuments(variables: SplitAndProcessOrderDocumentsMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<SplitAndProcessOrderDocumentsMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<SplitAndProcessOrderDocumentsMutation>(SplitAndProcessOrderDocumentsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'splitAndProcessOrderDocuments', 'mutation', variables);
    },
    updateDocuments(variables: UpdateDocumentsMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UpdateDocumentsMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateDocumentsMutation>(UpdateDocumentsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updateDocuments', 'mutation', variables);
    },
    createAdjustmentStopDriverMap(variables: CreateAdjustmentStopDriverMapMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CreateAdjustmentStopDriverMapMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateAdjustmentStopDriverMapMutation>(CreateAdjustmentStopDriverMapDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'createAdjustmentStopDriverMap', 'mutation', variables);
    },
    createDriverSettlementBill(variables: CreateDriverSettlementBillMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CreateDriverSettlementBillMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateDriverSettlementBillMutation>(CreateDriverSettlementBillDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'createDriverSettlementBill', 'mutation', variables);
    },
    deleteStopDriverMap(variables: DeleteStopDriverMapMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<DeleteStopDriverMapMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<DeleteStopDriverMapMutation>(DeleteStopDriverMapDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'deleteStopDriverMap', 'mutation', variables);
    },
    driverCompletedStopsLog(variables: DriverCompletedStopsLogQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<DriverCompletedStopsLogQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<DriverCompletedStopsLogQuery>(DriverCompletedStopsLogDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'driverCompletedStopsLog', 'query', variables);
    },
    driverSettlementBillByUuid(variables: DriverSettlementBillByUuidQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<DriverSettlementBillByUuidQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<DriverSettlementBillByUuidQuery>(DriverSettlementBillByUuidDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'driverSettlementBillByUuid', 'query', variables);
    },
    driverSettlementBillsCount(variables?: DriverSettlementBillsCountQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<DriverSettlementBillsCountQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<DriverSettlementBillsCountQuery>(DriverSettlementBillsCountDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'driverSettlementBillsCount', 'query', variables);
    },
    driverSettlementBillsForDownload(variables?: DriverSettlementBillsForDownloadQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<DriverSettlementBillsForDownloadQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<DriverSettlementBillsForDownloadQuery>(DriverSettlementBillsForDownloadDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'driverSettlementBillsForDownload', 'query', variables);
    },
    driverSettlementBillsV2(variables?: DriverSettlementBillsV2QueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<DriverSettlementBillsV2Query> {
      return withWrapper((wrappedRequestHeaders) => client.request<DriverSettlementBillsV2Query>(DriverSettlementBillsV2Document, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'driverSettlementBillsV2', 'query', variables);
    },
    driverSettlementBills(variables?: DriverSettlementBillsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<DriverSettlementBillsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<DriverSettlementBillsQuery>(DriverSettlementBillsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'driverSettlementBills', 'query', variables);
    },
    finalizeDriverSettlementBills(variables?: FinalizeDriverSettlementBillsMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<FinalizeDriverSettlementBillsMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<FinalizeDriverSettlementBillsMutation>(FinalizeDriverSettlementBillsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'finalizeDriverSettlementBills', 'mutation', variables);
    },
    invoiceShipmentByStopUuid(variables: InvoiceShipmentByStopUuidQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<InvoiceShipmentByStopUuidQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<InvoiceShipmentByStopUuidQuery>(InvoiceShipmentByStopUuidDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'invoiceShipmentByStopUuid', 'query', variables);
    },
    removeDriverSettlementBill(variables: RemoveDriverSettlementBillMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<RemoveDriverSettlementBillMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<RemoveDriverSettlementBillMutation>(RemoveDriverSettlementBillDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'removeDriverSettlementBill', 'mutation', variables);
    },
    createSettlementDeduction(variables: CreateSettlementDeductionMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CreateSettlementDeductionMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateSettlementDeductionMutation>(CreateSettlementDeductionDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'createSettlementDeduction', 'mutation', variables);
    },
    removeSettlementDeduction(variables: RemoveSettlementDeductionMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<RemoveSettlementDeductionMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<RemoveSettlementDeductionMutation>(RemoveSettlementDeductionDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'removeSettlementDeduction', 'mutation', variables);
    },
    updateSettlementDeduction(variables: UpdateSettlementDeductionMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UpdateSettlementDeductionMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateSettlementDeductionMutation>(UpdateSettlementDeductionDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updateSettlementDeduction', 'mutation', variables);
    },
    stopDriverMapsSummary(variables: StopDriverMapsSummaryQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<StopDriverMapsSummaryQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<StopDriverMapsSummaryQuery>(StopDriverMapsSummaryDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'stopDriverMapsSummary', 'query', variables);
    },
    stopDriverMaps(variables?: StopDriverMapsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<StopDriverMapsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<StopDriverMapsQuery>(StopDriverMapsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'stopDriverMaps', 'query', variables);
    },
    updateDriverSettlementBill(variables: UpdateDriverSettlementBillMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UpdateDriverSettlementBillMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateDriverSettlementBillMutation>(UpdateDriverSettlementBillDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updateDriverSettlementBill', 'mutation', variables);
    },
    updateStopDriverMap(variables: UpdateStopDriverMapMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UpdateStopDriverMapMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateStopDriverMapMutation>(UpdateStopDriverMapDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updateStopDriverMap', 'mutation', variables);
    },
    createCsvOrderMapping(variables: CreateCsvOrderMappingMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CreateCsvOrderMappingMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateCsvOrderMappingMutation>(CreateCsvOrderMappingDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'createCsvOrderMapping', 'mutation', variables);
    },
    csvOrderMapping(variables: CsvOrderMappingQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CsvOrderMappingQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CsvOrderMappingQuery>(CsvOrderMappingDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'csvOrderMapping', 'query', variables);
    },
    csvOrderMappingsForEmailTool(variables?: CsvOrderMappingsForEmailToolQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CsvOrderMappingsForEmailToolQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CsvOrderMappingsForEmailToolQuery>(CsvOrderMappingsForEmailToolDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'csvOrderMappingsForEmailTool', 'query', variables);
    },
    updateCsvOrderMapping(variables: UpdateCsvOrderMappingMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UpdateCsvOrderMappingMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateCsvOrderMappingMutation>(UpdateCsvOrderMappingDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updateCsvOrderMapping', 'mutation', variables);
    },
    createEndOfDayDocumentProcessingJob(variables: CreateEndOfDayDocumentProcessingJobMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CreateEndOfDayDocumentProcessingJobMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateEndOfDayDocumentProcessingJobMutation>(CreateEndOfDayDocumentProcessingJobDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'createEndOfDayDocumentProcessingJob', 'mutation', variables);
    },
    detachDocumentsFromShipments(variables: DetachDocumentsFromShipmentsMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<DetachDocumentsFromShipmentsMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<DetachDocumentsFromShipmentsMutation>(DetachDocumentsFromShipmentsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'detachDocumentsFromShipments', 'mutation', variables);
    },
    detachDocumentFromShipment(variables: DetachDocumentFromShipmentMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<DetachDocumentFromShipmentMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<DetachDocumentFromShipmentMutation>(DetachDocumentFromShipmentDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'detachDocumentFromShipment', 'mutation', variables);
    },
    documentsByShipment(variables: DocumentsByShipmentQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<DocumentsByShipmentQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<DocumentsByShipmentQuery>(DocumentsByShipmentDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'documentsByShipment', 'query', variables);
    },
    endOfDayDocumentProcessingJobs(variables: EndOfDayDocumentProcessingJobsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<EndOfDayDocumentProcessingJobsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<EndOfDayDocumentProcessingJobsQuery>(EndOfDayDocumentProcessingJobsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'endOfDayDocumentProcessingJobs', 'query', variables);
    },
    shallowRoutesWithDocuments(variables: ShallowRoutesWithDocumentsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ShallowRoutesWithDocumentsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<ShallowRoutesWithDocumentsQuery>(ShallowRoutesWithDocumentsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'shallowRoutesWithDocuments', 'query', variables);
    },
    equipment(variables: EquipmentQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<EquipmentQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<EquipmentQuery>(EquipmentDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'equipment', 'query', variables);
    },
    equipments(variables?: EquipmentsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<EquipmentsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<EquipmentsQuery>(EquipmentsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'equipments', 'query', variables);
    },
    fuelChargeFuelProfileDateRange(variables: FuelChargeFuelProfileDateRangeQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<FuelChargeFuelProfileDateRangeQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<FuelChargeFuelProfileDateRangeQuery>(FuelChargeFuelProfileDateRangeDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'fuelChargeFuelProfileDateRange', 'query', variables);
    },
    lineHaulFuelChargeFuelProfileDateRange(variables: LineHaulFuelChargeFuelProfileDateRangeQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<LineHaulFuelChargeFuelProfileDateRangeQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<LineHaulFuelChargeFuelProfileDateRangeQuery>(LineHaulFuelChargeFuelProfileDateRangeDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'lineHaulFuelChargeFuelProfileDateRange', 'query', variables);
    },
    ordersForPackingSlip(variables?: OrdersForPackingSlipQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<OrdersForPackingSlipQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<OrdersForPackingSlipQuery>(OrdersForPackingSlipDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'ordersForPackingSlip', 'query', variables);
    },
    picklists(variables: PicklistsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<PicklistsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<PicklistsQuery>(PicklistsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'picklists', 'query', variables);
    },
    companyStatsQuery(variables?: CompanyStatsQueryQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CompanyStatsQueryQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CompanyStatsQueryQuery>(CompanyStatsQueryDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'companyStatsQuery', 'query', variables);
    },
    consolidatableOrderSummary(variables: ConsolidatableOrderSummaryQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ConsolidatableOrderSummaryQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<ConsolidatableOrderSummaryQuery>(ConsolidatableOrderSummaryDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'consolidatableOrderSummary', 'query', variables);
    },
    createConsolidatedOrderFromOrder(variables: CreateConsolidatedOrderFromOrderMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CreateConsolidatedOrderFromOrderMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateConsolidatedOrderFromOrderMutation>(CreateConsolidatedOrderFromOrderDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'createConsolidatedOrderFromOrder', 'mutation', variables);
    },
    createConsolidatedOrder(variables: CreateConsolidatedOrderMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CreateConsolidatedOrderMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateConsolidatedOrderMutation>(CreateConsolidatedOrderDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'createConsolidatedOrder', 'mutation', variables);
    },
    currentBillingPeriodInvoice(variables: CurrentBillingPeriodInvoiceQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CurrentBillingPeriodInvoiceQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CurrentBillingPeriodInvoiceQuery>(CurrentBillingPeriodInvoiceDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'currentBillingPeriodInvoice', 'query', variables);
    },
    handleMultipleInvoices210Outbound(variables: HandleMultipleInvoices210OutboundMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<HandleMultipleInvoices210OutboundMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<HandleMultipleInvoices210OutboundMutation>(HandleMultipleInvoices210OutboundDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'handleMultipleInvoices210Outbound', 'mutation', variables);
    },
    invoices(variables?: InvoicesQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<InvoicesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<InvoicesQuery>(InvoicesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'invoices', 'query', variables);
    },
    markConsolidatableOrdersAsBilledIndividually(variables: MarkConsolidatableOrdersAsBilledIndividuallyMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<MarkConsolidatableOrdersAsBilledIndividuallyMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<MarkConsolidatableOrdersAsBilledIndividuallyMutation>(MarkConsolidatableOrdersAsBilledIndividuallyDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'markConsolidatableOrdersAsBilledIndividually', 'mutation', variables);
    },
    outstandingOrdersForReview(variables: OutstandingOrdersForReviewQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<OutstandingOrdersForReviewQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<OutstandingOrdersForReviewQuery>(OutstandingOrdersForReviewDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'outstandingOrdersForReview', 'query', variables);
    },
    outstandingShipment(variables: OutstandingShipmentQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<OutstandingShipmentQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<OutstandingShipmentQuery>(OutstandingShipmentDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'outstandingShipment', 'query', variables);
    },
    shallowInvoices(variables?: ShallowInvoicesQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ShallowInvoicesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<ShallowInvoicesQuery>(ShallowInvoicesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'shallowInvoices', 'query', variables);
    },
    unconsolidateOrder(variables: UnconsolidateOrderMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UnconsolidateOrderMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UnconsolidateOrderMutation>(UnconsolidateOrderDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'unconsolidateOrder', 'mutation', variables);
    },
    updateOrderShipperBillOfLadingNumber(variables: UpdateOrderShipperBillOfLadingNumberMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UpdateOrderShipperBillOfLadingNumberMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateOrderShipperBillOfLadingNumberMutation>(UpdateOrderShipperBillOfLadingNumberDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updateOrderShipperBillOfLadingNumber', 'mutation', variables);
    },
    wmsContacts(variables?: WmsContactsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<WmsContactsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<WmsContactsQuery>(WmsContactsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'wmsContacts', 'query', variables);
    },
    createInvoice(variables: CreateInvoiceMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CreateInvoiceMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateInvoiceMutation>(CreateInvoiceDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'createInvoice', 'mutation', variables);
    },
    finalizeInvoices(variables: FinalizeInvoicesMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<FinalizeInvoicesMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<FinalizeInvoicesMutation>(FinalizeInvoicesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'finalizeInvoices', 'mutation', variables);
    },
    documentsByInvoice(variables: DocumentsByInvoiceQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<DocumentsByInvoiceQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<DocumentsByInvoiceQuery>(DocumentsByInvoiceDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'documentsByInvoice', 'query', variables);
    },
    invoice(variables: InvoiceQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<InvoiceQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<InvoiceQuery>(InvoiceDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'invoice', 'query', variables);
    },
    updateInvoiceLimited(variables: UpdateInvoiceLimitedMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UpdateInvoiceLimitedMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateInvoiceLimitedMutation>(UpdateInvoiceLimitedDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updateInvoiceLimited', 'mutation', variables);
    },
    addOrdersToInvoices(variables: AddOrdersToInvoicesMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<AddOrdersToInvoicesMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<AddOrdersToInvoicesMutation>(AddOrdersToInvoicesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'addOrdersToInvoices', 'mutation', variables);
    },
    previewAddOrdersToInvoices(variables: PreviewAddOrdersToInvoicesQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<PreviewAddOrdersToInvoicesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<PreviewAddOrdersToInvoicesQuery>(PreviewAddOrdersToInvoicesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'previewAddOrdersToInvoices', 'query', variables);
    },
    contactsForDunningQuery(variables: ContactsForDunningQueryQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ContactsForDunningQueryQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<ContactsForDunningQueryQuery>(ContactsForDunningQueryDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'contactsForDunningQuery', 'query', variables);
    },
    dunningReportPdf(variables: DunningReportPdfQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<DunningReportPdfQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<DunningReportPdfQuery>(DunningReportPdfDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'dunningReportPdf', 'query', variables);
    },
    glCodeReportPdf(variables: GlCodeReportPdfQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GlCodeReportPdfQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GlCodeReportPdfQuery>(GlCodeReportPdfDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'glCodeReportPdf', 'query', variables);
    },
    invoiceEdiTransactions(variables: InvoiceEdiTransactionsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<InvoiceEdiTransactionsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<InvoiceEdiTransactionsQuery>(InvoiceEdiTransactionsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'invoiceEdiTransactions', 'query', variables);
    },
    invoiceEmailSendStatus(variables: InvoiceEmailSendStatusQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<InvoiceEmailSendStatusQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<InvoiceEmailSendStatusQuery>(InvoiceEmailSendStatusDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'invoiceEmailSendStatus', 'query', variables);
    },
    invoiceRegisterReportCsv(variables: InvoiceRegisterReportCsvQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<InvoiceRegisterReportCsvQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<InvoiceRegisterReportCsvQuery>(InvoiceRegisterReportCsvDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'invoiceRegisterReportCsv', 'query', variables);
    },
    invoiceRegisterReportPdf(variables: InvoiceRegisterReportPdfQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<InvoiceRegisterReportPdfQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<InvoiceRegisterReportPdfQuery>(InvoiceRegisterReportPdfDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'invoiceRegisterReportPdf', 'query', variables);
    },
    onTimePerformanceReportCsv(variables: OnTimePerformanceReportCsvQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<OnTimePerformanceReportCsvQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<OnTimePerformanceReportCsvQuery>(OnTimePerformanceReportCsvDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'onTimePerformanceReportCsv', 'query', variables);
    },
    onTimePerformanceReportPdf(variables: OnTimePerformanceReportPdfQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<OnTimePerformanceReportPdfQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<OnTimePerformanceReportPdfQuery>(OnTimePerformanceReportPdfDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'onTimePerformanceReportPdf', 'query', variables);
    },
    sageBusinessWorksInvoiceExportCsv(variables: SageBusinessWorksInvoiceExportCsvQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<SageBusinessWorksInvoiceExportCsvQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<SageBusinessWorksInvoiceExportCsvQuery>(SageBusinessWorksInvoiceExportCsvDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'sageBusinessWorksInvoiceExportCsv', 'query', variables);
    },
    invoiceShipmentWithChargesByUuid(variables: InvoiceShipmentWithChargesByUuidQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<InvoiceShipmentWithChargesByUuidQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<InvoiceShipmentWithChargesByUuidQuery>(InvoiceShipmentWithChargesByUuidDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'invoiceShipmentWithChargesByUuid', 'query', variables);
    },
    overdueInvoices(variables: OverdueInvoicesQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<OverdueInvoicesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<OverdueInvoicesQuery>(OverdueInvoicesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'overdueInvoices', 'query', variables);
    },
    shipmentsByContactUuid(variables?: ShipmentsByContactUuidQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ShipmentsByContactUuidQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<ShipmentsByContactUuidQuery>(ShipmentsByContactUuidDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'shipmentsByContactUuid', 'query', variables);
    },
    batchAddShipmentsToInvoicesMultiple(variables: BatchAddShipmentsToInvoicesMultipleMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<BatchAddShipmentsToInvoicesMultipleMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<BatchAddShipmentsToInvoicesMultipleMutation>(BatchAddShipmentsToInvoicesMultipleDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'batchAddShipmentsToInvoicesMultiple', 'mutation', variables);
    },
    CheckConsistencyOfInvoices(variables: CheckConsistencyOfInvoicesQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CheckConsistencyOfInvoicesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CheckConsistencyOfInvoicesQuery>(CheckConsistencyOfInvoicesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'CheckConsistencyOfInvoices', 'query', variables);
    },
    createProratedConsolidatedOrder(variables: CreateProratedConsolidatedOrderMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CreateProratedConsolidatedOrderMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateProratedConsolidatedOrderMutation>(CreateProratedConsolidatedOrderDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'createProratedConsolidatedOrder', 'mutation', variables);
    },
    orderInConsolidationFlow(variables: OrderInConsolidationFlowQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<OrderInConsolidationFlowQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<OrderInConsolidationFlowQuery>(OrderInConsolidationFlowDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'orderInConsolidationFlow', 'query', variables);
    },
    previewProratedConsolidationV2(variables: PreviewProratedConsolidationV2QueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<PreviewProratedConsolidationV2Query> {
      return withWrapper((wrappedRequestHeaders) => client.request<PreviewProratedConsolidationV2Query>(PreviewProratedConsolidationV2Document, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'previewProratedConsolidationV2', 'query', variables);
    },
    previewProratedConsolidation(variables: PreviewProratedConsolidationQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<PreviewProratedConsolidationQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<PreviewProratedConsolidationQuery>(PreviewProratedConsolidationDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'previewProratedConsolidation', 'query', variables);
    },
    prorateOrders(variables: ProrateOrdersMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ProrateOrdersMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<ProrateOrdersMutation>(ProrateOrdersDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'prorateOrders', 'mutation', variables);
    },
    typeaheadOrderUuidsQueryForConsolidationFlow(variables?: TypeaheadOrderUuidsQueryForConsolidationFlowQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<TypeaheadOrderUuidsQueryForConsolidationFlowQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<TypeaheadOrderUuidsQueryForConsolidationFlowQuery>(TypeaheadOrderUuidsQueryForConsolidationFlowDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'typeaheadOrderUuidsQueryForConsolidationFlow', 'query', variables);
    },
    contactsForInvoices(variables?: ContactsForInvoicesQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ContactsForInvoicesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<ContactsForInvoicesQuery>(ContactsForInvoicesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'contactsForInvoices', 'query', variables);
    },
    createContactDocument(variables: CreateContactDocumentMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CreateContactDocumentMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateContactDocumentMutation>(CreateContactDocumentDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'createContactDocument', 'mutation', variables);
    },
    createInvoiceDocuments(variables: CreateInvoiceDocumentsMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CreateInvoiceDocumentsMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateInvoiceDocumentsMutation>(CreateInvoiceDocumentsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'createInvoiceDocuments', 'mutation', variables);
    },
    downloadInvoices(variables: DownloadInvoicesMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<DownloadInvoicesMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<DownloadInvoicesMutation>(DownloadInvoicesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'downloadInvoices', 'mutation', variables);
    },
    exportInvoicesToQuickbooksDesktop(variables: ExportInvoicesToQuickbooksDesktopMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ExportInvoicesToQuickbooksDesktopMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<ExportInvoicesToQuickbooksDesktopMutation>(ExportInvoicesToQuickbooksDesktopDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'exportInvoicesToQuickbooksDesktop', 'mutation', variables);
    },
    generateInvoicePreSignedPutUrls(variables: GenerateInvoicePreSignedPutUrlsMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GenerateInvoicePreSignedPutUrlsMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<GenerateInvoicePreSignedPutUrlsMutation>(GenerateInvoicePreSignedPutUrlsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'generateInvoicePreSignedPutUrls', 'mutation', variables);
    },
    acknowledgeFailedInvoiceSendJobs(variables: AcknowledgeFailedInvoiceSendJobsMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<AcknowledgeFailedInvoiceSendJobsMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<AcknowledgeFailedInvoiceSendJobsMutation>(AcknowledgeFailedInvoiceSendJobsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'acknowledgeFailedInvoiceSendJobs', 'mutation', variables);
    },
    invoiceSendJobBatches(variables?: InvoiceSendJobBatchesQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<InvoiceSendJobBatchesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<InvoiceSendJobBatchesQuery>(InvoiceSendJobBatchesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'invoiceSendJobBatches', 'query', variables);
    },
    invoiceSendJobsShallow(variables: InvoiceSendJobsShallowQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<InvoiceSendJobsShallowQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<InvoiceSendJobsShallowQuery>(InvoiceSendJobsShallowDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'invoiceSendJobsShallow', 'query', variables);
    },
    invoiceSendJobs(variables: InvoiceSendJobsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<InvoiceSendJobsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<InvoiceSendJobsQuery>(InvoiceSendJobsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'invoiceSendJobs', 'query', variables);
    },
    invoiceStatsByUuids(variables: InvoiceStatsByUuidsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<InvoiceStatsByUuidsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<InvoiceStatsByUuidsQuery>(InvoiceStatsByUuidsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'invoiceStatsByUuids', 'query', variables);
    },
    invoiceTotal(variables: InvoiceTotalQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<InvoiceTotalQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<InvoiceTotalQuery>(InvoiceTotalDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'invoiceTotal', 'query', variables);
    },
    invoiceTotals(variables: InvoiceTotalsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<InvoiceTotalsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<InvoiceTotalsQuery>(InvoiceTotalsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'invoiceTotals', 'query', variables);
    },
    invoiceUuidsForBatchPost(variables?: InvoiceUuidsForBatchPostQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<InvoiceUuidsForBatchPostQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<InvoiceUuidsForBatchPostQuery>(InvoiceUuidsForBatchPostDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'invoiceUuidsForBatchPost', 'query', variables);
    },
    invoiceV2(variables: InvoiceV2QueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<InvoiceV2Query> {
      return withWrapper((wrappedRequestHeaders) => client.request<InvoiceV2Query>(InvoiceV2Document, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'invoiceV2', 'query', variables);
    },
    invoicesByUuidsForDownload(variables: InvoicesByUuidsForDownloadQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<InvoicesByUuidsForDownloadQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<InvoicesByUuidsForDownloadQuery>(InvoicesByUuidsForDownloadDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'invoicesByUuidsForDownload', 'query', variables);
    },
    invoicesByUuids(variables: InvoicesByUuidsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<InvoicesByUuidsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<InvoicesByUuidsQuery>(InvoicesByUuidsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'invoicesByUuids', 'query', variables);
    },
    invoicesForContact(variables?: InvoicesForContactQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<InvoicesForContactQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<InvoicesForContactQuery>(InvoicesForContactDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'invoicesForContact', 'query', variables);
    },
    invoicesForInvoiceSelection(variables?: InvoicesForInvoiceSelectionQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<InvoicesForInvoiceSelectionQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<InvoicesForInvoiceSelectionQuery>(InvoicesForInvoiceSelectionDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'invoicesForInvoiceSelection', 'query', variables);
    },
    invoicesForRegisterReport(variables?: InvoicesForRegisterReportQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<InvoicesForRegisterReportQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<InvoicesForRegisterReportQuery>(InvoicesForRegisterReportDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'invoicesForRegisterReport', 'query', variables);
    },
    invoicesMetadataByUuids(variables: InvoicesMetadataByUuidsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<InvoicesMetadataByUuidsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<InvoicesMetadataByUuidsQuery>(InvoicesMetadataByUuidsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'invoicesMetadataByUuids', 'query', variables);
    },
    invoicesWithOrders(variables?: InvoicesWithOrdersQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<InvoicesWithOrdersQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<InvoicesWithOrdersQuery>(InvoicesWithOrdersDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'invoicesWithOrders', 'query', variables);
    },
    moveShipmentsBetweenInvoices(variables: MoveShipmentsBetweenInvoicesMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<MoveShipmentsBetweenInvoicesMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<MoveShipmentsBetweenInvoicesMutation>(MoveShipmentsBetweenInvoicesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'moveShipmentsBetweenInvoices', 'mutation', variables);
    },
    moveShipmentsToInvoice(variables: MoveShipmentsToInvoiceMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<MoveShipmentsToInvoiceMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<MoveShipmentsToInvoiceMutation>(MoveShipmentsToInvoiceDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'moveShipmentsToInvoice', 'mutation', variables);
    },
    netSalesSummaryReport(variables: NetSalesSummaryReportQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<NetSalesSummaryReportQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<NetSalesSummaryReportQuery>(NetSalesSummaryReportDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'netSalesSummaryReport', 'query', variables);
    },
    paginatedOrdersByInvoice(variables: PaginatedOrdersByInvoiceQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<PaginatedOrdersByInvoiceQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<PaginatedOrdersByInvoiceQuery>(PaginatedOrdersByInvoiceDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'paginatedOrdersByInvoice', 'query', variables);
    },
    allInvoicesForPaymentApplication(variables?: AllInvoicesForPaymentApplicationQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<AllInvoicesForPaymentApplicationQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<AllInvoicesForPaymentApplicationQuery>(AllInvoicesForPaymentApplicationDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'allInvoicesForPaymentApplication', 'query', variables);
    },
    averageDaysToPayReport(variables?: AverageDaysToPayReportQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<AverageDaysToPayReportQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<AverageDaysToPayReportQuery>(AverageDaysToPayReportDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'averageDaysToPayReport', 'query', variables);
    },
    contactBalancesByOrderUuid(variables: ContactBalancesByOrderUuidQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ContactBalancesByOrderUuidQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<ContactBalancesByOrderUuidQuery>(ContactBalancesByOrderUuidDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'contactBalancesByOrderUuid', 'query', variables);
    },
    contactBalances(variables: ContactBalancesQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ContactBalancesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<ContactBalancesQuery>(ContactBalancesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'contactBalances', 'query', variables);
    },
    createPayment(variables: CreatePaymentMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CreatePaymentMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreatePaymentMutation>(CreatePaymentDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'createPayment', 'mutation', variables);
    },
    deletePayment(variables: DeletePaymentMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<DeletePaymentMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<DeletePaymentMutation>(DeletePaymentDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'deletePayment', 'mutation', variables);
    },
    editPaymentAmount(variables: EditPaymentAmountMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<EditPaymentAmountMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<EditPaymentAmountMutation>(EditPaymentAmountDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'editPaymentAmount', 'mutation', variables);
    },
    orderAmountsToPayForInvoice(variables: OrderAmountsToPayForInvoiceQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<OrderAmountsToPayForInvoiceQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<OrderAmountsToPayForInvoiceQuery>(OrderAmountsToPayForInvoiceDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'orderAmountsToPayForInvoice', 'query', variables);
    },
    ordersByUuidsForPaymentStats(variables: OrdersByUuidsForPaymentStatsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<OrdersByUuidsForPaymentStatsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<OrdersByUuidsForPaymentStatsQuery>(OrdersByUuidsForPaymentStatsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'ordersByUuidsForPaymentStats', 'query', variables);
    },
    ordersForPayments(variables: OrdersForPaymentsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<OrdersForPaymentsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<OrdersForPaymentsQuery>(OrdersForPaymentsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'ordersForPayments', 'query', variables);
    },
    outstandingInvoicesForCustomer(variables: OutstandingInvoicesForCustomerQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<OutstandingInvoicesForCustomerQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<OutstandingInvoicesForCustomerQuery>(OutstandingInvoicesForCustomerDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'outstandingInvoicesForCustomer', 'query', variables);
    },
    paymentByUuid(variables: PaymentByUuidQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<PaymentByUuidQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<PaymentByUuidQuery>(PaymentByUuidDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'paymentByUuid', 'query', variables);
    },
    paymentsByContactUuid(variables: PaymentsByContactUuidQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<PaymentsByContactUuidQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<PaymentsByContactUuidQuery>(PaymentsByContactUuidDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'paymentsByContactUuid', 'query', variables);
    },
    paymentsByInvoiceUuid(variables: PaymentsByInvoiceUuidQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<PaymentsByInvoiceUuidQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<PaymentsByInvoiceUuidQuery>(PaymentsByInvoiceUuidDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'paymentsByInvoiceUuid', 'query', variables);
    },
    paymentsForCheckRegisterReportOld(variables: PaymentsForCheckRegisterReportOldQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<PaymentsForCheckRegisterReportOldQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<PaymentsForCheckRegisterReportOldQuery>(PaymentsForCheckRegisterReportOldDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'paymentsForCheckRegisterReportOld', 'query', variables);
    },
    paymentsForCheckRegisterReport(variables: PaymentsForCheckRegisterReportQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<PaymentsForCheckRegisterReportQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<PaymentsForCheckRegisterReportQuery>(PaymentsForCheckRegisterReportDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'paymentsForCheckRegisterReport', 'query', variables);
    },
    updatePayment(variables: UpdatePaymentMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UpdatePaymentMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdatePaymentMutation>(UpdatePaymentDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updatePayment', 'mutation', variables);
    },
    previewBatchAddShipmentsToInvoicesMultiple(variables: PreviewBatchAddShipmentsToInvoicesMultipleQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<PreviewBatchAddShipmentsToInvoicesMultipleQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<PreviewBatchAddShipmentsToInvoicesMultipleQuery>(PreviewBatchAddShipmentsToInvoicesMultipleDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'previewBatchAddShipmentsToInvoicesMultiple', 'query', variables);
    },
    outstandingOrder(variables: OutstandingOrderQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<OutstandingOrderQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<OutstandingOrderQuery>(OutstandingOrderDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'outstandingOrder', 'query', variables);
    },
    addQuickbooksDesktopCustomers(variables: AddQuickbooksDesktopCustomersMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<AddQuickbooksDesktopCustomersMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<AddQuickbooksDesktopCustomersMutation>(AddQuickbooksDesktopCustomersDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'addQuickbooksDesktopCustomers', 'mutation', variables);
    },
    getInvoiceCsvs(variables: GetInvoiceCsvsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetInvoiceCsvsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetInvoiceCsvsQuery>(GetInvoiceCsvsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getInvoiceCsvs', 'query', variables);
    },
    invoicesByUuidsForQuickbooks(variables: InvoicesByUuidsForQuickbooksQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<InvoicesByUuidsForQuickbooksQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<InvoicesByUuidsForQuickbooksQuery>(InvoicesByUuidsForQuickbooksDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'invoicesByUuidsForQuickbooks', 'query', variables);
    },
    completeRebill(variables: CompleteRebillMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CompleteRebillMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CompleteRebillMutation>(CompleteRebillDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'completeRebill', 'mutation', variables);
    },
    createDuplicateOrderForRebill(variables: CreateDuplicateOrderForRebillMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CreateDuplicateOrderForRebillMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateDuplicateOrderForRebillMutation>(CreateDuplicateOrderForRebillDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'createDuplicateOrderForRebill', 'mutation', variables);
    },
    orderForRebill(variables: OrderForRebillQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<OrderForRebillQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<OrderForRebillQuery>(OrderForRebillDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'orderForRebill', 'query', variables);
    },
    removeInvoice(variables: RemoveInvoiceMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<RemoveInvoiceMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<RemoveInvoiceMutation>(RemoveInvoiceDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'removeInvoice', 'mutation', variables);
    },
    removeShipmentsFromInvoice(variables: RemoveShipmentsFromInvoiceMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<RemoveShipmentsFromInvoiceMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<RemoveShipmentsFromInvoiceMutation>(RemoveShipmentsFromInvoiceDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'removeShipmentsFromInvoice', 'mutation', variables);
    },
    accessorialChargeDetailsReport(variables: AccessorialChargeDetailsReportQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<AccessorialChargeDetailsReportQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<AccessorialChargeDetailsReportQuery>(AccessorialChargeDetailsReportDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'accessorialChargeDetailsReport', 'query', variables);
    },
    accountsReceivableReport(variables: AccountsReceivableReportQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<AccountsReceivableReportQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<AccountsReceivableReportQuery>(AccountsReceivableReportDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'accountsReceivableReport', 'query', variables);
    },
    agingReport(variables: AgingReportQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<AgingReportQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<AgingReportQuery>(AgingReportDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'agingReport', 'query', variables);
    },
    chargeBreakdownReportCsv(variables?: ChargeBreakdownReportCsvQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ChargeBreakdownReportCsvQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<ChargeBreakdownReportCsvQuery>(ChargeBreakdownReportCsvDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'chargeBreakdownReportCsv', 'query', variables);
    },
    chargeBreakdownReportPdf(variables?: ChargeBreakdownReportPdfQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ChargeBreakdownReportPdfQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<ChargeBreakdownReportPdfQuery>(ChargeBreakdownReportPdfDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'chargeBreakdownReportPdf', 'query', variables);
    },
    paymentForMemoReport(variables: PaymentForMemoReportQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<PaymentForMemoReportQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<PaymentForMemoReportQuery>(PaymentForMemoReportDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'paymentForMemoReport', 'query', variables);
    },
    driverDailyLogReportPdf(variables: DriverDailyLogReportPdfQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<DriverDailyLogReportPdfQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<DriverDailyLogReportPdfQuery>(DriverDailyLogReportPdfDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'driverDailyLogReportPdf', 'query', variables);
    },
    emailAccountingReport(variables: EmailAccountingReportMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<EmailAccountingReportMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<EmailAccountingReportMutation>(EmailAccountingReportDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'emailAccountingReport', 'mutation', variables);
    },
    incomeAnalysisReport(variables: IncomeAnalysisReportQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<IncomeAnalysisReportQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<IncomeAnalysisReportQuery>(IncomeAnalysisReportDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'incomeAnalysisReport', 'query', variables);
    },
    invoiceBillingSummaryReportV2PdfUrl(variables: InvoiceBillingSummaryReportV2PdfUrlQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<InvoiceBillingSummaryReportV2PdfUrlQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<InvoiceBillingSummaryReportV2PdfUrlQuery>(InvoiceBillingSummaryReportV2PdfUrlDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'invoiceBillingSummaryReportV2PdfUrl', 'query', variables);
    },
    invoiceBillingSummaryReportV2Pdf(variables: InvoiceBillingSummaryReportV2PdfQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<InvoiceBillingSummaryReportV2PdfQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<InvoiceBillingSummaryReportV2PdfQuery>(InvoiceBillingSummaryReportV2PdfDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'invoiceBillingSummaryReportV2Pdf', 'query', variables);
    },
    invoiceBillingSummaryReportV2(variables: InvoiceBillingSummaryReportV2QueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<InvoiceBillingSummaryReportV2Query> {
      return withWrapper((wrappedRequestHeaders) => client.request<InvoiceBillingSummaryReportV2Query>(InvoiceBillingSummaryReportV2Document, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'invoiceBillingSummaryReportV2', 'query', variables);
    },
    openInvoiceReport(variables: OpenInvoiceReportQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<OpenInvoiceReportQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<OpenInvoiceReportQuery>(OpenInvoiceReportDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'openInvoiceReport', 'query', variables);
    },
    invoiceForOrderSummaryReport(variables: InvoiceForOrderSummaryReportQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<InvoiceForOrderSummaryReportQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<InvoiceForOrderSummaryReportQuery>(InvoiceForOrderSummaryReportDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'invoiceForOrderSummaryReport', 'query', variables);
    },
    invoicesForOrderSummaryReport(variables: InvoicesForOrderSummaryReportQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<InvoicesForOrderSummaryReportQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<InvoicesForOrderSummaryReportQuery>(InvoicesForOrderSummaryReportDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'invoicesForOrderSummaryReport', 'query', variables);
    },
    paymentApplicationReport(variables: PaymentApplicationReportQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<PaymentApplicationReportQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<PaymentApplicationReportQuery>(PaymentApplicationReportDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'paymentApplicationReport', 'query', variables);
    },
    paymentsForJournalReport(variables: PaymentsForJournalReportQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<PaymentsForJournalReportQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<PaymentsForJournalReportQuery>(PaymentsForJournalReportDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'paymentsForJournalReport', 'query', variables);
    },
    paymentJournalReport(variables: PaymentJournalReportQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<PaymentJournalReportQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<PaymentJournalReportQuery>(PaymentJournalReportDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'paymentJournalReport', 'query', variables);
    },
    unappliedPaymentsReport(variables: UnappliedPaymentsReportQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UnappliedPaymentsReportQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<UnappliedPaymentsReportQuery>(UnappliedPaymentsReportDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'unappliedPaymentsReport', 'query', variables);
    },
    sendInvoices(variables: SendInvoicesMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<SendInvoicesMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<SendInvoicesMutation>(SendInvoicesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'sendInvoices', 'mutation', variables);
    },
    shallowInvoicesByUuids(variables: ShallowInvoicesByUuidsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ShallowInvoicesByUuidsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<ShallowInvoicesByUuidsQuery>(ShallowInvoicesByUuidsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'shallowInvoicesByUuids', 'query', variables);
    },
    invoiceUuids(variables?: InvoiceUuidsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<InvoiceUuidsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<InvoiceUuidsQuery>(InvoiceUuidsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'invoiceUuids', 'query', variables);
    },
    shallowInvoicesV2(variables?: ShallowInvoicesV2QueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ShallowInvoicesV2Query> {
      return withWrapper((wrappedRequestHeaders) => client.request<ShallowInvoicesV2Query>(ShallowInvoicesV2Document, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'shallowInvoicesV2', 'query', variables);
    },
    typeaheadOrderUuidsQuery(variables?: TypeaheadOrderUuidsQueryQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<TypeaheadOrderUuidsQueryQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<TypeaheadOrderUuidsQueryQuery>(TypeaheadOrderUuidsQueryDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'typeaheadOrderUuidsQuery', 'query', variables);
    },
    orderRevenueReport(variables: OrderRevenueReportQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<OrderRevenueReportQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<OrderRevenueReportQuery>(OrderRevenueReportDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'orderRevenueReport', 'query', variables);
    },
    unpostInvoice(variables: UnpostInvoiceMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UnpostInvoiceMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UnpostInvoiceMutation>(UnpostInvoiceDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'unpostInvoice', 'mutation', variables);
    },
    createItem(variables: CreateItemMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CreateItemMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateItemMutation>(CreateItemDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'createItem', 'mutation', variables);
    },
    contactItems(variables: ContactItemsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ContactItemsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<ContactItemsQuery>(ContactItemsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'contactItems', 'query', variables);
    },
    itemInventorySummary(variables?: ItemInventorySummaryQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ItemInventorySummaryQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<ItemInventorySummaryQuery>(ItemInventorySummaryDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'itemInventorySummary', 'query', variables);
    },
    item(variables: ItemQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ItemQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<ItemQuery>(ItemDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'item', 'query', variables);
    },
    itemsBySkuName(variables: ItemsBySkuNameQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ItemsBySkuNameQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<ItemsBySkuNameQuery>(ItemsBySkuNameDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'itemsBySkuName', 'query', variables);
    },
    shallowItems(variables: ShallowItemsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ShallowItemsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<ShallowItemsQuery>(ShallowItemsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'shallowItems', 'query', variables);
    },
    updateItem(variables: UpdateItemMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UpdateItemMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateItemMutation>(UpdateItemDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updateItem', 'mutation', variables);
    },
    generateLabel(variables: GenerateLabelMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GenerateLabelMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<GenerateLabelMutation>(GenerateLabelDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'generateLabel', 'mutation', variables);
    },
    addOrdersToManifestV2(variables: AddOrdersToManifestV2MutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<AddOrdersToManifestV2Mutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<AddOrdersToManifestV2Mutation>(AddOrdersToManifestV2Document, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'addOrdersToManifestV2', 'mutation', variables);
    },
    addOrdersToManifest(variables: AddOrdersToManifestMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<AddOrdersToManifestMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<AddOrdersToManifestMutation>(AddOrdersToManifestDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'addOrdersToManifest', 'mutation', variables);
    },
    createLineHaulManifest(variables: CreateLineHaulManifestMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CreateLineHaulManifestMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateLineHaulManifestMutation>(CreateLineHaulManifestDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'createLineHaulManifest', 'mutation', variables);
    },
    createLineHaulManifests(variables: CreateLineHaulManifestsMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CreateLineHaulManifestsMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateLineHaulManifestsMutation>(CreateLineHaulManifestsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'createLineHaulManifests', 'mutation', variables);
    },
    getLineHaulProgress(variables: GetLineHaulProgressQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetLineHaulProgressQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetLineHaulProgressQuery>(GetLineHaulProgressDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getLineHaulProgress', 'query', variables);
    },
    LineHaulManifestGroups(variables: LineHaulManifestGroupsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<LineHaulManifestGroupsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<LineHaulManifestGroupsQuery>(LineHaulManifestGroupsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'LineHaulManifestGroups', 'query', variables);
    },
    lineHaulManifest(variables: LineHaulManifestQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<LineHaulManifestQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<LineHaulManifestQuery>(LineHaulManifestDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'lineHaulManifest', 'query', variables);
    },
    lineHaulManifestsForPrint(variables: LineHaulManifestsForPrintQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<LineHaulManifestsForPrintQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<LineHaulManifestsForPrintQuery>(LineHaulManifestsForPrintDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'lineHaulManifestsForPrint', 'query', variables);
    },
    lineHaulManifests(variables: LineHaulManifestsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<LineHaulManifestsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<LineHaulManifestsQuery>(LineHaulManifestsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'lineHaulManifests', 'query', variables);
    },
    lineHaulOrdersWithUpcomingSegmentAndInboundStopStatus(variables: LineHaulOrdersWithUpcomingSegmentAndInboundStopStatusQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<LineHaulOrdersWithUpcomingSegmentAndInboundStopStatusQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<LineHaulOrdersWithUpcomingSegmentAndInboundStopStatusQuery>(LineHaulOrdersWithUpcomingSegmentAndInboundStopStatusDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'lineHaulOrdersWithUpcomingSegmentAndInboundStopStatus', 'query', variables);
    },
    lineHaulSegments(variables?: LineHaulSegmentsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<LineHaulSegmentsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<LineHaulSegmentsQuery>(LineHaulSegmentsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'lineHaulSegments', 'query', variables);
    },
    markManifestAsArrived(variables: MarkManifestAsArrivedMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<MarkManifestAsArrivedMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<MarkManifestAsArrivedMutation>(MarkManifestAsArrivedDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'markManifestAsArrived', 'mutation', variables);
    },
    markManifestAsDeparted(variables: MarkManifestAsDepartedMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<MarkManifestAsDepartedMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<MarkManifestAsDepartedMutation>(MarkManifestAsDepartedDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'markManifestAsDeparted', 'mutation', variables);
    },
    markManifestAsPlanning(variables: MarkManifestAsPlanningMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<MarkManifestAsPlanningMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<MarkManifestAsPlanningMutation>(MarkManifestAsPlanningDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'markManifestAsPlanning', 'mutation', variables);
    },
    removeLineHaulManifest(variables: RemoveLineHaulManifestMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<RemoveLineHaulManifestMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<RemoveLineHaulManifestMutation>(RemoveLineHaulManifestDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'removeLineHaulManifest', 'mutation', variables);
    },
    removeOrdersFromManifestV2(variables: RemoveOrdersFromManifestV2MutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<RemoveOrdersFromManifestV2Mutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<RemoveOrdersFromManifestV2Mutation>(RemoveOrdersFromManifestV2Document, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'removeOrdersFromManifestV2', 'mutation', variables);
    },
    removeOrdersFromManifest(variables: RemoveOrdersFromManifestMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<RemoveOrdersFromManifestMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<RemoveOrdersFromManifestMutation>(RemoveOrdersFromManifestDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'removeOrdersFromManifest', 'mutation', variables);
    },
    segmentedLineHaulOrdersV2(variables: SegmentedLineHaulOrdersV2QueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<SegmentedLineHaulOrdersV2Query> {
      return withWrapper((wrappedRequestHeaders) => client.request<SegmentedLineHaulOrdersV2Query>(SegmentedLineHaulOrdersV2Document, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'segmentedLineHaulOrdersV2', 'query', variables);
    },
    segmentedLineHaulOrders(variables: SegmentedLineHaulOrdersQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<SegmentedLineHaulOrdersQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<SegmentedLineHaulOrdersQuery>(SegmentedLineHaulOrdersDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'segmentedLineHaulOrders', 'query', variables);
    },
    updateManifestDriver(variables: UpdateManifestDriverMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UpdateManifestDriverMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateManifestDriverMutation>(UpdateManifestDriverDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updateManifestDriver', 'mutation', variables);
    },
    updateManifestVehicle(variables: UpdateManifestVehicleMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UpdateManifestVehicleMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateManifestVehicleMutation>(UpdateManifestVehicleDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updateManifestVehicle', 'mutation', variables);
    },
    updateManifestsStatus(variables: UpdateManifestsStatusMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UpdateManifestsStatusMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateManifestsStatusMutation>(UpdateManifestsStatusDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updateManifestsStatus', 'mutation', variables);
    },
    archiveTariffChain(variables: ArchiveTariffChainMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ArchiveTariffChainMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<ArchiveTariffChainMutation>(ArchiveTariffChainDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'archiveTariffChain', 'mutation', variables);
    },
    companyDefaultTariffChains(variables?: CompanyDefaultTariffChainsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CompanyDefaultTariffChainsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CompanyDefaultTariffChainsQuery>(CompanyDefaultTariffChainsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'companyDefaultTariffChains', 'query', variables);
    },
    createTariffChain(variables: CreateTariffChainMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CreateTariffChainMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateTariffChainMutation>(CreateTariffChainDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'createTariffChain', 'mutation', variables);
    },
    restoreTariffChain(variables: RestoreTariffChainMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<RestoreTariffChainMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<RestoreTariffChainMutation>(RestoreTariffChainDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'restoreTariffChain', 'mutation', variables);
    },
    tariffChainsWithGroups(variables: TariffChainsWithGroupsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<TariffChainsWithGroupsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<TariffChainsWithGroupsQuery>(TariffChainsWithGroupsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'tariffChainsWithGroups', 'query', variables);
    },
    updateDefaultTariffChainsForCompany(variables: UpdateDefaultTariffChainsForCompanyMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UpdateDefaultTariffChainsForCompanyMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateDefaultTariffChainsForCompanyMutation>(UpdateDefaultTariffChainsForCompanyDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updateDefaultTariffChainsForCompany', 'mutation', variables);
    },
    updateTariffChain(variables: UpdateTariffChainMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UpdateTariffChainMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateTariffChainMutation>(UpdateTariffChainDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updateTariffChain', 'mutation', variables);
    },
    contactsWithTariffs(variables?: ContactsWithTariffsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ContactsWithTariffsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<ContactsWithTariffsQuery>(ContactsWithTariffsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'contactsWithTariffs', 'query', variables);
    },
    createTariffGroup(variables: CreateTariffGroupMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CreateTariffGroupMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateTariffGroupMutation>(CreateTariffGroupDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'createTariffGroup', 'mutation', variables);
    },
    deleteTariffGroup(variables: DeleteTariffGroupMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<DeleteTariffGroupMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<DeleteTariffGroupMutation>(DeleteTariffGroupDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'deleteTariffGroup', 'mutation', variables);
    },
    duplicateTariffGroup(variables: DuplicateTariffGroupMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<DuplicateTariffGroupMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<DuplicateTariffGroupMutation>(DuplicateTariffGroupDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'duplicateTariffGroup', 'mutation', variables);
    },
    findDefaultTariffGroupForCompany(variables?: FindDefaultTariffGroupForCompanyQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<FindDefaultTariffGroupForCompanyQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<FindDefaultTariffGroupForCompanyQuery>(FindDefaultTariffGroupForCompanyDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'findDefaultTariffGroupForCompany', 'query', variables);
    },
    findDefaultTransferTariffGroupForCompany(variables?: FindDefaultTransferTariffGroupForCompanyQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<FindDefaultTransferTariffGroupForCompanyQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<FindDefaultTransferTariffGroupForCompanyQuery>(FindDefaultTransferTariffGroupForCompanyDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'findDefaultTransferTariffGroupForCompany', 'query', variables);
    },
    findTariffGroupsWithContactAndServiceCombination(variables: FindTariffGroupsWithContactAndServiceCombinationQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<FindTariffGroupsWithContactAndServiceCombinationQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<FindTariffGroupsWithContactAndServiceCombinationQuery>(FindTariffGroupsWithContactAndServiceCombinationDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'findTariffGroupsWithContactAndServiceCombination', 'query', variables);
    },
    tariffGroup(variables: TariffGroupQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<TariffGroupQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<TariffGroupQuery>(TariffGroupDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'tariffGroup', 'query', variables);
    },
    tariff(variables: TariffQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<TariffQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<TariffQuery>(TariffDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'tariff', 'query', variables);
    },
    updateTariffGroup(variables: UpdateTariffGroupMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UpdateTariffGroupMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateTariffGroupMutation>(UpdateTariffGroupDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updateTariffGroup', 'mutation', variables);
    },
    archiveTariffZoneGroup(variables: ArchiveTariffZoneGroupMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ArchiveTariffZoneGroupMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<ArchiveTariffZoneGroupMutation>(ArchiveTariffZoneGroupDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'archiveTariffZoneGroup', 'mutation', variables);
    },
    createTariffZoneGroup(variables: CreateTariffZoneGroupMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CreateTariffZoneGroupMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateTariffZoneGroupMutation>(CreateTariffZoneGroupDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'createTariffZoneGroup', 'mutation', variables);
    },
    restoreTariffZoneGroup(variables: RestoreTariffZoneGroupMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<RestoreTariffZoneGroupMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<RestoreTariffZoneGroupMutation>(RestoreTariffZoneGroupDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'restoreTariffZoneGroup', 'mutation', variables);
    },
    tariffZoneGroups(variables: TariffZoneGroupsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<TariffZoneGroupsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<TariffZoneGroupsQuery>(TariffZoneGroupsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'tariffZoneGroups', 'query', variables);
    },
    tariffZonesForGroup(variables: TariffZonesForGroupQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<TariffZonesForGroupQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<TariffZonesForGroupQuery>(TariffZonesForGroupDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'tariffZonesForGroup', 'query', variables);
    },
    updateTariffZoneGroup(variables: UpdateTariffZoneGroupMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UpdateTariffZoneGroupMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateTariffZoneGroupMutation>(UpdateTariffZoneGroupDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updateTariffZoneGroup', 'mutation', variables);
    },
    accessorialDateRangeConfigByUuid(variables: AccessorialDateRangeConfigByUuidQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<AccessorialDateRangeConfigByUuidQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<AccessorialDateRangeConfigByUuidQuery>(AccessorialDateRangeConfigByUuidDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'accessorialDateRangeConfigByUuid', 'query', variables);
    },
    accessorialDateRangeConfigs(variables: AccessorialDateRangeConfigsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<AccessorialDateRangeConfigsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<AccessorialDateRangeConfigsQuery>(AccessorialDateRangeConfigsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'accessorialDateRangeConfigs', 'query', variables);
    },
    createAccessorialDateRangeConfig(variables: CreateAccessorialDateRangeConfigMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CreateAccessorialDateRangeConfigMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateAccessorialDateRangeConfigMutation>(CreateAccessorialDateRangeConfigDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'createAccessorialDateRangeConfig', 'mutation', variables);
    },
    deleteAccessorialDateRangeConfig(variables: DeleteAccessorialDateRangeConfigMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<DeleteAccessorialDateRangeConfigMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<DeleteAccessorialDateRangeConfigMutation>(DeleteAccessorialDateRangeConfigDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'deleteAccessorialDateRangeConfig', 'mutation', variables);
    },
    updateAccessorialDateRangeConfig(variables: UpdateAccessorialDateRangeConfigMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UpdateAccessorialDateRangeConfigMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateAccessorialDateRangeConfigMutation>(UpdateAccessorialDateRangeConfigDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updateAccessorialDateRangeConfig', 'mutation', variables);
    },
    accessorialNamesByBillingContact(variables?: AccessorialNamesByBillingContactQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<AccessorialNamesByBillingContactQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<AccessorialNamesByBillingContactQuery>(AccessorialNamesByBillingContactDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'accessorialNamesByBillingContact', 'query', variables);
    },
    accessorialsByBillingContact(variables?: AccessorialsByBillingContactQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<AccessorialsByBillingContactQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<AccessorialsByBillingContactQuery>(AccessorialsByBillingContactDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'accessorialsByBillingContact', 'query', variables);
    },
    CreateAccessorial(variables: CreateAccessorialMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CreateAccessorialMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateAccessorialMutation>(CreateAccessorialDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'CreateAccessorial', 'mutation', variables);
    },
    RemoveAccessorial(variables: RemoveAccessorialMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<RemoveAccessorialMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<RemoveAccessorialMutation>(RemoveAccessorialDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'RemoveAccessorial', 'mutation', variables);
    },
    accessorial(variables: AccessorialQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<AccessorialQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<AccessorialQuery>(AccessorialDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'accessorial', 'query', variables);
    },
    defaultGlobalSpecialAccessorials(variables?: DefaultGlobalSpecialAccessorialsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<DefaultGlobalSpecialAccessorialsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<DefaultGlobalSpecialAccessorialsQuery>(DefaultGlobalSpecialAccessorialsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'defaultGlobalSpecialAccessorials', 'query', variables);
    },
    accessorialNames(variables?: AccessorialNamesQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<AccessorialNamesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<AccessorialNamesQuery>(AccessorialNamesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'accessorialNames', 'query', variables);
    },
    accessorialsTable(variables?: AccessorialsTableQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<AccessorialsTableQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<AccessorialsTableQuery>(AccessorialsTableDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'accessorialsTable', 'query', variables);
    },
    accessorials(variables?: AccessorialsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<AccessorialsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<AccessorialsQuery>(AccessorialsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'accessorials', 'query', variables);
    },
    RemoveSpecialAccessorial(variables: RemoveSpecialAccessorialMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<RemoveSpecialAccessorialMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<RemoveSpecialAccessorialMutation>(RemoveSpecialAccessorialDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'RemoveSpecialAccessorial', 'mutation', variables);
    },
    RemoveZoneBasedAccessorial(variables: RemoveZoneBasedAccessorialMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<RemoveZoneBasedAccessorialMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<RemoveZoneBasedAccessorialMutation>(RemoveZoneBasedAccessorialDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'RemoveZoneBasedAccessorial', 'mutation', variables);
    },
    UpdateAccessorial(variables: UpdateAccessorialMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UpdateAccessorialMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateAccessorialMutation>(UpdateAccessorialDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'UpdateAccessorial', 'mutation', variables);
    },
    UpdateQuickAddAccessorials(variables: UpdateQuickAddAccessorialsMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UpdateQuickAddAccessorialsMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateQuickAddAccessorialsMutation>(UpdateQuickAddAccessorialsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'UpdateQuickAddAccessorials', 'mutation', variables);
    },
    senderIsVerified(variables?: SenderIsVerifiedQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<SenderIsVerifiedQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<SenderIsVerifiedQuery>(SenderIsVerifiedDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'senderIsVerified', 'query', variables);
    },
    createCreditType(variables: CreateCreditTypeMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CreateCreditTypeMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateCreditTypeMutation>(CreateCreditTypeDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'createCreditType', 'mutation', variables);
    },
    creditTypes(variables?: CreditTypesQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CreditTypesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreditTypesQuery>(CreditTypesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'creditTypes', 'query', variables);
    },
    removeCreditType(variables: RemoveCreditTypeMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<RemoveCreditTypeMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<RemoveCreditTypeMutation>(RemoveCreditTypeDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'removeCreditType', 'mutation', variables);
    },
    updateCreditType(variables: UpdateCreditTypeMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UpdateCreditTypeMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateCreditTypeMutation>(UpdateCreditTypeDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updateCreditType', 'mutation', variables);
    },
    createGeneralLedgerCode(variables: CreateGeneralLedgerCodeMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CreateGeneralLedgerCodeMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateGeneralLedgerCodeMutation>(CreateGeneralLedgerCodeDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'createGeneralLedgerCode', 'mutation', variables);
    },
    deleteGeneralLedgerCode(variables: DeleteGeneralLedgerCodeMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<DeleteGeneralLedgerCodeMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<DeleteGeneralLedgerCodeMutation>(DeleteGeneralLedgerCodeDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'deleteGeneralLedgerCode', 'mutation', variables);
    },
    generalLedgerCodes(variables?: GeneralLedgerCodesQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GeneralLedgerCodesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GeneralLedgerCodesQuery>(GeneralLedgerCodesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'generalLedgerCodes', 'query', variables);
    },
    generalLedgerConfiguration(variables?: GeneralLedgerConfigurationQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GeneralLedgerConfigurationQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GeneralLedgerConfigurationQuery>(GeneralLedgerConfigurationDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'generalLedgerConfiguration', 'query', variables);
    },
    updateGeneralLedgerCode(variables: UpdateGeneralLedgerCodeMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UpdateGeneralLedgerCodeMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateGeneralLedgerCodeMutation>(UpdateGeneralLedgerCodeDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updateGeneralLedgerCode', 'mutation', variables);
    },
    updateGeneralLedgerConfiguration(variables: UpdateGeneralLedgerConfigurationMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UpdateGeneralLedgerConfigurationMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateGeneralLedgerConfigurationMutation>(UpdateGeneralLedgerConfigurationDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updateGeneralLedgerConfiguration', 'mutation', variables);
    },
    createMasterAccount(variables: CreateMasterAccountMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CreateMasterAccountMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateMasterAccountMutation>(CreateMasterAccountDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'createMasterAccount', 'mutation', variables);
    },
    masterAccounts(variables?: MasterAccountsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<MasterAccountsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<MasterAccountsQuery>(MasterAccountsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'masterAccounts', 'query', variables);
    },
    removeMasterAccount(variables: RemoveMasterAccountMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<RemoveMasterAccountMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<RemoveMasterAccountMutation>(RemoveMasterAccountDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'removeMasterAccount', 'mutation', variables);
    },
    updateMasterAccount(variables: UpdateMasterAccountMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UpdateMasterAccountMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateMasterAccountMutation>(UpdateMasterAccountDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updateMasterAccount', 'mutation', variables);
    },
    createSettlementDeductionType(variables: CreateSettlementDeductionTypeMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CreateSettlementDeductionTypeMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateSettlementDeductionTypeMutation>(CreateSettlementDeductionTypeDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'createSettlementDeductionType', 'mutation', variables);
    },
    removeSettlementDeductionType(variables: RemoveSettlementDeductionTypeMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<RemoveSettlementDeductionTypeMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<RemoveSettlementDeductionTypeMutation>(RemoveSettlementDeductionTypeDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'removeSettlementDeductionType', 'mutation', variables);
    },
    settlementDeductionTypes(variables?: SettlementDeductionTypesQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<SettlementDeductionTypesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<SettlementDeductionTypesQuery>(SettlementDeductionTypesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'settlementDeductionTypes', 'query', variables);
    },
    updateSettlementDeductionType(variables: UpdateSettlementDeductionTypeMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UpdateSettlementDeductionTypeMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateSettlementDeductionTypeMutation>(UpdateSettlementDeductionTypeDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updateSettlementDeductionType', 'mutation', variables);
    },
    bulkUploadRouteNames(variables: BulkUploadRouteNamesMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<BulkUploadRouteNamesMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<BulkUploadRouteNamesMutation>(BulkUploadRouteNamesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'bulkUploadRouteNames', 'mutation', variables);
    },
    businessDivisions(variables?: BusinessDivisionsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<BusinessDivisionsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<BusinessDivisionsQuery>(BusinessDivisionsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'businessDivisions', 'query', variables);
    },
    createBusinessDivision(variables: CreateBusinessDivisionMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CreateBusinessDivisionMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateBusinessDivisionMutation>(CreateBusinessDivisionDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'createBusinessDivision', 'mutation', variables);
    },
    removeBusinessDivision(variables: RemoveBusinessDivisionMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<RemoveBusinessDivisionMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<RemoveBusinessDivisionMutation>(RemoveBusinessDivisionDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'removeBusinessDivision', 'mutation', variables);
    },
    updateBusinessDivision(variables: UpdateBusinessDivisionMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UpdateBusinessDivisionMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateBusinessDivisionMutation>(UpdateBusinessDivisionDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updateBusinessDivision', 'mutation', variables);
    },
    company(variables?: CompanyQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CompanyQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CompanyQuery>(CompanyDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'company', 'query', variables);
    },
    createCustomDriverForm(variables: CreateCustomDriverFormMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CreateCustomDriverFormMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateCustomDriverFormMutation>(CreateCustomDriverFormDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'createCustomDriverForm', 'mutation', variables);
    },
    CreateEquipment(variables: CreateEquipmentMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CreateEquipmentMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateEquipmentMutation>(CreateEquipmentDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'CreateEquipment', 'mutation', variables);
    },
    createFuelProfile(variables: CreateFuelProfileMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CreateFuelProfileMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateFuelProfileMutation>(CreateFuelProfileDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'createFuelProfile', 'mutation', variables);
    },
    updateInvoiceEmail(variables: UpdateInvoiceEmailMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UpdateInvoiceEmailMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateInvoiceEmailMutation>(UpdateInvoiceEmailDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updateInvoiceEmail', 'mutation', variables);
    },
    createService(variables: CreateServiceMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CreateServiceMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateServiceMutation>(CreateServiceDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'createService', 'mutation', variables);
    },
    customDriverSignableForm(variables: CustomDriverSignableFormQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CustomDriverSignableFormQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CustomDriverSignableFormQuery>(CustomDriverSignableFormDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'customDriverSignableForm', 'query', variables);
    },
    customDriverSignableForms(variables?: CustomDriverSignableFormsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CustomDriverSignableFormsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CustomDriverSignableFormsQuery>(CustomDriverSignableFormsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'customDriverSignableForms', 'query', variables);
    },
    deleteCustomDriverForm(variables: DeleteCustomDriverFormMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<DeleteCustomDriverFormMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<DeleteCustomDriverFormMutation>(DeleteCustomDriverFormDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'deleteCustomDriverForm', 'mutation', variables);
    },
    deleteEquipment(variables: DeleteEquipmentMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<DeleteEquipmentMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<DeleteEquipmentMutation>(DeleteEquipmentDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'deleteEquipment', 'mutation', variables);
    },
    deleteRouteNameLocation(variables: DeleteRouteNameLocationMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<DeleteRouteNameLocationMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<DeleteRouteNameLocationMutation>(DeleteRouteNameLocationDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'deleteRouteNameLocation', 'mutation', variables);
    },
    driversTable(variables?: DriversTableQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<DriversTableQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<DriversTableQuery>(DriversTableDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'driversTable', 'query', variables);
    },
    ArchiveDriver(variables: ArchiveDriverMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ArchiveDriverMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<ArchiveDriverMutation>(ArchiveDriverDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'ArchiveDriver', 'mutation', variables);
    },
    CreateDriver(variables: CreateDriverMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CreateDriverMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateDriverMutation>(CreateDriverDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'CreateDriver', 'mutation', variables);
    },
    driverByPhoneNumber(variables: DriverByPhoneNumberQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<DriverByPhoneNumberQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<DriverByPhoneNumberQuery>(DriverByPhoneNumberDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'driverByPhoneNumber', 'query', variables);
    },
    DriverQualifications(variables?: DriverQualificationsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<DriverQualificationsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<DriverQualificationsQuery>(DriverQualificationsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'DriverQualifications', 'query', variables);
    },
    driver(variables: DriverQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<DriverQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<DriverQuery>(DriverDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'driver', 'query', variables);
    },
    RestoreDriver(variables: RestoreDriverMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<RestoreDriverMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<RestoreDriverMutation>(RestoreDriverDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'RestoreDriver', 'mutation', variables);
    },
    UpdateDriverQualifications(variables: UpdateDriverQualificationsMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UpdateDriverQualificationsMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateDriverQualificationsMutation>(UpdateDriverQualificationsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'UpdateDriverQualifications', 'mutation', variables);
    },
    VehicleType(variables: VehicleTypeQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<VehicleTypeQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<VehicleTypeQuery>(VehicleTypeDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'VehicleType', 'query', variables);
    },
    flipIsArchived(variables: FlipIsArchivedMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<FlipIsArchivedMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<FlipIsArchivedMutation>(FlipIsArchivedDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'flipIsArchived', 'mutation', variables);
    },
    createFuelProfileDateRange(variables: CreateFuelProfileDateRangeMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CreateFuelProfileDateRangeMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateFuelProfileDateRangeMutation>(CreateFuelProfileDateRangeDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'createFuelProfileDateRange', 'mutation', variables);
    },
    deleteFuelProfileDateRange(variables: DeleteFuelProfileDateRangeMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<DeleteFuelProfileDateRangeMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<DeleteFuelProfileDateRangeMutation>(DeleteFuelProfileDateRangeDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'deleteFuelProfileDateRange', 'mutation', variables);
    },
    fuelProfile(variables: FuelProfileQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<FuelProfileQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<FuelProfileQuery>(FuelProfileDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'fuelProfile', 'query', variables);
    },
    fuelProfiles(variables?: FuelProfilesQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<FuelProfilesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<FuelProfilesQuery>(FuelProfilesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'fuelProfiles', 'query', variables);
    },
    removeFuelProfile(variables: RemoveFuelProfileMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<RemoveFuelProfileMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<RemoveFuelProfileMutation>(RemoveFuelProfileDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'removeFuelProfile', 'mutation', variables);
    },
    updateFuelProfileDateRange(variables: UpdateFuelProfileDateRangeMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UpdateFuelProfileDateRangeMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateFuelProfileDateRangeMutation>(UpdateFuelProfileDateRangeDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updateFuelProfileDateRange', 'mutation', variables);
    },
    updateFuelProfile(variables: UpdateFuelProfileMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UpdateFuelProfileMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateFuelProfileMutation>(UpdateFuelProfileDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updateFuelProfile', 'mutation', variables);
    },
    createHoldReason(variables: CreateHoldReasonMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CreateHoldReasonMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateHoldReasonMutation>(CreateHoldReasonDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'createHoldReason', 'mutation', variables);
    },
    holdReasons(variables?: HoldReasonsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<HoldReasonsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<HoldReasonsQuery>(HoldReasonsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'holdReasons', 'query', variables);
    },
    updateHoldReason(variables: UpdateHoldReasonMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UpdateHoldReasonMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateHoldReasonMutation>(UpdateHoldReasonDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updateHoldReason', 'mutation', variables);
    },
    createLineHaulLane(variables: CreateLineHaulLaneMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CreateLineHaulLaneMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateLineHaulLaneMutation>(CreateLineHaulLaneDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'createLineHaulLane', 'mutation', variables);
    },
    lineHaulLane(variables: LineHaulLaneQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<LineHaulLaneQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<LineHaulLaneQuery>(LineHaulLaneDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'lineHaulLane', 'query', variables);
    },
    lineHaulLanes(variables?: LineHaulLanesQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<LineHaulLanesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<LineHaulLanesQuery>(LineHaulLanesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'lineHaulLanes', 'query', variables);
    },
    updateLineHaulLane(variables: UpdateLineHaulLaneMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UpdateLineHaulLaneMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateLineHaulLaneMutation>(UpdateLineHaulLaneDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updateLineHaulLane', 'mutation', variables);
    },
    markOrderAsCancelled(variables: MarkOrderAsCancelledMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<MarkOrderAsCancelledMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<MarkOrderAsCancelledMutation>(MarkOrderAsCancelledDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'markOrderAsCancelled', 'mutation', variables);
    },
    markOrderAsOnHold(variables: MarkOrderAsOnHoldMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<MarkOrderAsOnHoldMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<MarkOrderAsOnHoldMutation>(MarkOrderAsOnHoldDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'markOrderAsOnHold', 'mutation', variables);
    },
    MinimalServiceRegions(variables: MinimalServiceRegionsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<MinimalServiceRegionsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<MinimalServiceRegionsQuery>(MinimalServiceRegionsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'MinimalServiceRegions', 'query', variables);
    },
    ArchivePackageSpec(variables: ArchivePackageSpecMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ArchivePackageSpecMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<ArchivePackageSpecMutation>(ArchivePackageSpecDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'ArchivePackageSpec', 'mutation', variables);
    },
    CreatePackageSpec(variables: CreatePackageSpecMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CreatePackageSpecMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreatePackageSpecMutation>(CreatePackageSpecDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'CreatePackageSpec', 'mutation', variables);
    },
    PackageSpec(variables: PackageSpecQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<PackageSpecQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<PackageSpecQuery>(PackageSpecDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'PackageSpec', 'query', variables);
    },
    PackageSpecsMinimal(variables?: PackageSpecsMinimalQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<PackageSpecsMinimalQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<PackageSpecsMinimalQuery>(PackageSpecsMinimalDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'PackageSpecsMinimal', 'query', variables);
    },
    RestorePackageSpec(variables: RestorePackageSpecMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<RestorePackageSpecMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<RestorePackageSpecMutation>(RestorePackageSpecDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'RestorePackageSpec', 'mutation', variables);
    },
    UpdatePackageSpec(variables: UpdatePackageSpecMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UpdatePackageSpecMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdatePackageSpecMutation>(UpdatePackageSpecDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'UpdatePackageSpec', 'mutation', variables);
    },
    RecoveryTerminals(variables?: RecoveryTerminalsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<RecoveryTerminalsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<RecoveryTerminalsQuery>(RecoveryTerminalsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'RecoveryTerminals', 'query', variables);
    },
    CreateRecoveryTerminal(variables: CreateRecoveryTerminalMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CreateRecoveryTerminalMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateRecoveryTerminalMutation>(CreateRecoveryTerminalDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'CreateRecoveryTerminal', 'mutation', variables);
    },
    UpdateRecoveryTerminal(variables: UpdateRecoveryTerminalMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UpdateRecoveryTerminalMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateRecoveryTerminalMutation>(UpdateRecoveryTerminalDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'UpdateRecoveryTerminal', 'mutation', variables);
    },
    routeName(variables: RouteNameQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<RouteNameQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<RouteNameQuery>(RouteNameDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'routeName', 'query', variables);
    },
    routeNames(variables?: RouteNamesQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<RouteNamesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<RouteNamesQuery>(RouteNamesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'routeNames', 'query', variables);
    },
    servicesForThirdPartyUser(variables: ServicesForThirdPartyUserQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ServicesForThirdPartyUserQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<ServicesForThirdPartyUserQuery>(ServicesForThirdPartyUserDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'servicesForThirdPartyUser', 'query', variables);
    },
    createTerminalServiceAreasV2(variables: CreateTerminalServiceAreasV2MutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CreateTerminalServiceAreasV2Mutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateTerminalServiceAreasV2Mutation>(CreateTerminalServiceAreasV2Document, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'createTerminalServiceAreasV2', 'mutation', variables);
    },
    createTerminal(variables: CreateTerminalMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CreateTerminalMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateTerminalMutation>(CreateTerminalDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'createTerminal', 'mutation', variables);
    },
    removeTerminalServiceArea(variables: RemoveTerminalServiceAreaMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<RemoveTerminalServiceAreaMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<RemoveTerminalServiceAreaMutation>(RemoveTerminalServiceAreaDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'removeTerminalServiceArea', 'mutation', variables);
    },
    terminal(variables: TerminalQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<TerminalQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<TerminalQuery>(TerminalDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'terminal', 'query', variables);
    },
    terminalsForThirdPartyUser(variables: TerminalsForThirdPartyUserQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<TerminalsForThirdPartyUserQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<TerminalsForThirdPartyUserQuery>(TerminalsForThirdPartyUserDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'terminalsForThirdPartyUser', 'query', variables);
    },
    terminals(variables?: TerminalsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<TerminalsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<TerminalsQuery>(TerminalsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'terminals', 'query', variables);
    },
    updateTerminal(variables: UpdateTerminalMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UpdateTerminalMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateTerminalMutation>(UpdateTerminalDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updateTerminal', 'mutation', variables);
    },
    createThirdPartyBroker(variables: CreateThirdPartyBrokerMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CreateThirdPartyBrokerMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateThirdPartyBrokerMutation>(CreateThirdPartyBrokerDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'createThirdPartyBroker', 'mutation', variables);
    },
    removeThirdPartyBroker(variables: RemoveThirdPartyBrokerMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<RemoveThirdPartyBrokerMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<RemoveThirdPartyBrokerMutation>(RemoveThirdPartyBrokerDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'removeThirdPartyBroker', 'mutation', variables);
    },
    thirdPartyBrokers(variables?: ThirdPartyBrokersQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ThirdPartyBrokersQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<ThirdPartyBrokersQuery>(ThirdPartyBrokersDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'thirdPartyBrokers', 'query', variables);
    },
    updateThirdPartyBroker(variables: UpdateThirdPartyBrokerMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UpdateThirdPartyBrokerMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateThirdPartyBrokerMutation>(UpdateThirdPartyBrokerDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updateThirdPartyBroker', 'mutation', variables);
    },
    updateCompanyConfiguration(variables: UpdateCompanyConfigurationMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UpdateCompanyConfigurationMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateCompanyConfigurationMutation>(UpdateCompanyConfigurationDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updateCompanyConfiguration', 'mutation', variables);
    },
    updateCustomDriverForm(variables: UpdateCustomDriverFormMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UpdateCustomDriverFormMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateCustomDriverFormMutation>(UpdateCustomDriverFormDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updateCustomDriverForm', 'mutation', variables);
    },
    UpdateDriver(variables: UpdateDriverMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UpdateDriverMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateDriverMutation>(UpdateDriverDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'UpdateDriver', 'mutation', variables);
    },
    UpdateEquipment(variables: UpdateEquipmentMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UpdateEquipmentMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateEquipmentMutation>(UpdateEquipmentDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'UpdateEquipment', 'mutation', variables);
    },
    updateService(variables: UpdateServiceMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UpdateServiceMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateServiceMutation>(UpdateServiceDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updateService', 'mutation', variables);
    },
    updateTemplateAndRecordAddresses(variables: UpdateTemplateAndRecordAddressesMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UpdateTemplateAndRecordAddressesMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateTemplateAndRecordAddressesMutation>(UpdateTemplateAndRecordAddressesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updateTemplateAndRecordAddresses', 'mutation', variables);
    },
    CreateUser(variables: CreateUserMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CreateUserMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateUserMutation>(CreateUserDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'CreateUser', 'mutation', variables);
    },
    reportsEmailSenderIsVerified(variables: ReportsEmailSenderIsVerifiedQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ReportsEmailSenderIsVerifiedQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<ReportsEmailSenderIsVerifiedQuery>(ReportsEmailSenderIsVerifiedDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'reportsEmailSenderIsVerified', 'query', variables);
    },
    UpdateUser(variables: UpdateUserMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UpdateUserMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateUserMutation>(UpdateUserDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'UpdateUser', 'mutation', variables);
    },
    updateUserReportsEmail(variables: UpdateUserReportsEmailMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UpdateUserReportsEmailMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateUserReportsEmailMutation>(UpdateUserReportsEmailDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updateUserReportsEmail', 'mutation', variables);
    },
    users(variables?: UsersQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UsersQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<UsersQuery>(UsersDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'users', 'query', variables);
    },
    ArchiveVehicleType(variables: ArchiveVehicleTypeMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ArchiveVehicleTypeMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<ArchiveVehicleTypeMutation>(ArchiveVehicleTypeDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'ArchiveVehicleType', 'mutation', variables);
    },
    createVehicleType(variables: CreateVehicleTypeMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CreateVehicleTypeMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateVehicleTypeMutation>(CreateVehicleTypeDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'createVehicleType', 'mutation', variables);
    },
    RestoreVehicleType(variables: RestoreVehicleTypeMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<RestoreVehicleTypeMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<RestoreVehicleTypeMutation>(RestoreVehicleTypeDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'RestoreVehicleType', 'mutation', variables);
    },
    updateVehicleType(variables: UpdateVehicleTypeMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UpdateVehicleTypeMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateVehicleTypeMutation>(UpdateVehicleTypeDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updateVehicleType', 'mutation', variables);
    },
    VehicleTypesMinimal(variables?: VehicleTypesMinimalQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<VehicleTypesMinimalQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<VehicleTypesMinimalQuery>(VehicleTypesMinimalDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'VehicleTypesMinimal', 'query', variables);
    },
    createWarehouseEmployee(variables: CreateWarehouseEmployeeMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CreateWarehouseEmployeeMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateWarehouseEmployeeMutation>(CreateWarehouseEmployeeDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'createWarehouseEmployee', 'mutation', variables);
    },
    warehouseEmployees(variables?: WarehouseEmployeesQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<WarehouseEmployeesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<WarehouseEmployeesQuery>(WarehouseEmployeesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'warehouseEmployees', 'query', variables);
    },
    updateWarehouseEmployee(variables: UpdateWarehouseEmployeeMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UpdateWarehouseEmployeeMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateWarehouseEmployeeMutation>(UpdateWarehouseEmployeeDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updateWarehouseEmployee', 'mutation', variables);
    },
    acknowledgeNotification(variables: AcknowledgeNotificationMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<AcknowledgeNotificationMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<AcknowledgeNotificationMutation>(AcknowledgeNotificationDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'acknowledgeNotification', 'mutation', variables);
    },
    acknowledgeNotifications(variables: AcknowledgeNotificationsMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<AcknowledgeNotificationsMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<AcknowledgeNotificationsMutation>(AcknowledgeNotificationsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'acknowledgeNotifications', 'mutation', variables);
    },
    notifications(variables?: NotificationsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<NotificationsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<NotificationsQuery>(NotificationsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'notifications', 'query', variables);
    },
    orderAuditLogEntries(variables: OrderAuditLogEntriesQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<OrderAuditLogEntriesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<OrderAuditLogEntriesQuery>(OrderAuditLogEntriesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'orderAuditLogEntries', 'query', variables);
    },
    orderEventSnapshots(variables: OrderEventSnapshotsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<OrderEventSnapshotsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<OrderEventSnapshotsQuery>(OrderEventSnapshotsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'orderEventSnapshots', 'query', variables);
    },
    orderEvents(variables?: OrderEventsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<OrderEventsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<OrderEventsQuery>(OrderEventsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'orderEvents', 'query', variables);
    },
    emailProcessingHistory(variables: EmailProcessingHistoryQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<EmailProcessingHistoryQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<EmailProcessingHistoryQuery>(EmailProcessingHistoryDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'emailProcessingHistory', 'query', variables);
    },
    ingestedEmailOrderByOrderUuid(variables: IngestedEmailOrderByOrderUuidQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<IngestedEmailOrderByOrderUuidQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<IngestedEmailOrderByOrderUuidQuery>(IngestedEmailOrderByOrderUuidDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'ingestedEmailOrderByOrderUuid', 'query', variables);
    },
    ingestedEmailOrders(variables?: IngestedEmailOrdersQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<IngestedEmailOrdersQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<IngestedEmailOrdersQuery>(IngestedEmailOrdersDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'ingestedEmailOrders', 'query', variables);
    },
    ingestedOutlookEmail(variables: IngestedOutlookEmailQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<IngestedOutlookEmailQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<IngestedOutlookEmailQuery>(IngestedOutlookEmailDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'ingestedOutlookEmail', 'query', variables);
    },
    outlookIntegrations(variables: OutlookIntegrationsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<OutlookIntegrationsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<OutlookIntegrationsQuery>(OutlookIntegrationsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'outlookIntegrations', 'query', variables);
    },
    acceptCustomerPortalOrder(variables: AcceptCustomerPortalOrderMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<AcceptCustomerPortalOrderMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<AcceptCustomerPortalOrderMutation>(AcceptCustomerPortalOrderDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'acceptCustomerPortalOrder', 'mutation', variables);
    },
    rejectCustomerPortalOrder(variables: RejectCustomerPortalOrderMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<RejectCustomerPortalOrderMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<RejectCustomerPortalOrderMutation>(RejectCustomerPortalOrderDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'rejectCustomerPortalOrder', 'mutation', variables);
    },
    acceptEdiOrApiOrder(variables: AcceptEdiOrApiOrderMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<AcceptEdiOrApiOrderMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<AcceptEdiOrApiOrderMutation>(AcceptEdiOrApiOrderDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'acceptEdiOrApiOrder', 'mutation', variables);
    },
    rejectEdiOrder(variables: RejectEdiOrderMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<RejectEdiOrderMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<RejectEdiOrderMutation>(RejectEdiOrderDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'rejectEdiOrder', 'mutation', variables);
    },
    accessorialForCustomChargeRow(variables: AccessorialForCustomChargeRowQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<AccessorialForCustomChargeRowQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<AccessorialForCustomChargeRowQuery>(AccessorialForCustomChargeRowDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'accessorialForCustomChargeRow', 'query', variables);
    },
    accessorialsForCustomChargeRow(variables: AccessorialsForCustomChargeRowQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<AccessorialsForCustomChargeRowQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<AccessorialsForCustomChargeRowQuery>(AccessorialsForCustomChargeRowDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'accessorialsForCustomChargeRow', 'query', variables);
    },
    piecesGroupedByStatus(variables: PiecesGroupedByStatusQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<PiecesGroupedByStatusQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<PiecesGroupedByStatusQuery>(PiecesGroupedByStatusDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'piecesGroupedByStatus', 'query', variables);
    },
    sendStopToAgent(variables: SendStopToAgentMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<SendStopToAgentMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<SendStopToAgentMutation>(SendStopToAgentDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'sendStopToAgent', 'mutation', variables);
    },
    updatePieceCount(variables: UpdatePieceCountMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UpdatePieceCountMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdatePieceCountMutation>(UpdatePieceCountDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updatePieceCount', 'mutation', variables);
    },
    VehicleTypeCapacity(variables: VehicleTypeCapacityQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<VehicleTypeCapacityQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<VehicleTypeCapacityQuery>(VehicleTypeCapacityDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'VehicleTypeCapacity', 'query', variables);
    },
    unifiedSearchOrders(variables: UnifiedSearchOrdersQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UnifiedSearchOrdersQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<UnifiedSearchOrdersQuery>(UnifiedSearchOrdersDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'unifiedSearchOrders', 'query', variables);
    },
    unifiedSearchUnacceptedEmailOrders(variables: UnifiedSearchUnacceptedEmailOrdersQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UnifiedSearchUnacceptedEmailOrdersQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<UnifiedSearchUnacceptedEmailOrdersQuery>(UnifiedSearchUnacceptedEmailOrdersDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'unifiedSearchUnacceptedEmailOrders', 'query', variables);
    },
    unifiedSearchUnacceptedEdiAndApiOrders(variables: UnifiedSearchUnacceptedEdiAndApiOrdersQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UnifiedSearchUnacceptedEdiAndApiOrdersQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<UnifiedSearchUnacceptedEdiAndApiOrdersQuery>(UnifiedSearchUnacceptedEdiAndApiOrdersDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'unifiedSearchUnacceptedEdiAndApiOrders', 'query', variables);
    },
    unifiedSearchQuotes(variables: UnifiedSearchQuotesQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UnifiedSearchQuotesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<UnifiedSearchQuotesQuery>(UnifiedSearchQuotesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'unifiedSearchQuotes', 'query', variables);
    },
    unifiedSearchInvoices(variables: UnifiedSearchInvoicesQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UnifiedSearchInvoicesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<UnifiedSearchInvoicesQuery>(UnifiedSearchInvoicesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'unifiedSearchInvoices', 'query', variables);
    },
    createInvoiceDocument(variables: CreateInvoiceDocumentMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CreateInvoiceDocumentMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateInvoiceDocumentMutation>(CreateInvoiceDocumentDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'createInvoiceDocument', 'mutation', variables);
    },
    createOrderDocument(variables: CreateOrderDocumentMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CreateOrderDocumentMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateOrderDocumentMutation>(CreateOrderDocumentDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'createOrderDocument', 'mutation', variables);
    },
    apiLogs(variables: ApiLogsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ApiLogsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<ApiLogsQuery>(ApiLogsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'apiLogs', 'query', variables);
    },
    matchFreightSnap(variables: MatchFreightSnapMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<MatchFreightSnapMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<MatchFreightSnapMutation>(MatchFreightSnapDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'matchFreightSnap', 'mutation', variables);
    },
    ordersForArrivalNotices(variables: OrdersForArrivalNoticesQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<OrdersForArrivalNoticesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<OrdersForArrivalNoticesQuery>(OrdersForArrivalNoticesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'ordersForArrivalNotices', 'query', variables);
    },
    arriveAtStops(variables: ArriveAtStopsMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ArriveAtStopsMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<ArriveAtStopsMutation>(ArriveAtStopsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'arriveAtStops', 'mutation', variables);
    },
    attemptStopsForDriverSettlement(variables: AttemptStopsForDriverSettlementQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<AttemptStopsForDriverSettlementQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<AttemptStopsForDriverSettlementQuery>(AttemptStopsForDriverSettlementDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'attemptStopsForDriverSettlement', 'query', variables);
    },
    bulkEditOrders(variables: BulkEditOrdersMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<BulkEditOrdersMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<BulkEditOrdersMutation>(BulkEditOrdersDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'bulkEditOrders', 'mutation', variables);
    },
    coverSheetDocumentTypeSequences(variables?: CoverSheetDocumentTypeSequencesQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CoverSheetDocumentTypeSequencesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CoverSheetDocumentTypeSequencesQuery>(CoverSheetDocumentTypeSequencesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'coverSheetDocumentTypeSequences', 'query', variables);
    },
    createCoverSheetDocumentTypeSequence(variables: CreateCoverSheetDocumentTypeSequenceMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CreateCoverSheetDocumentTypeSequenceMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateCoverSheetDocumentTypeSequenceMutation>(CreateCoverSheetDocumentTypeSequenceDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'createCoverSheetDocumentTypeSequence', 'mutation', variables);
    },
    orderCoverSheets(variables?: OrderCoverSheetsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<OrderCoverSheetsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<OrderCoverSheetsQuery>(OrderCoverSheetsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'orderCoverSheets', 'query', variables);
    },
    orderInfosForCoverSheets(variables: OrderInfosForCoverSheetsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<OrderInfosForCoverSheetsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<OrderInfosForCoverSheetsQuery>(OrderInfosForCoverSheetsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'orderInfosForCoverSheets', 'query', variables);
    },
    ordersForCoverSheets(variables: OrdersForCoverSheetsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<OrdersForCoverSheetsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<OrdersForCoverSheetsQuery>(OrdersForCoverSheetsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'ordersForCoverSheets', 'query', variables);
    },
    removeCoverSheetDocumentTypeSequence(variables: RemoveCoverSheetDocumentTypeSequenceMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<RemoveCoverSheetDocumentTypeSequenceMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<RemoveCoverSheetDocumentTypeSequenceMutation>(RemoveCoverSheetDocumentTypeSequenceDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'removeCoverSheetDocumentTypeSequence', 'mutation', variables);
    },
    updateCoverSheetDocumentTypeSequence(variables: UpdateCoverSheetDocumentTypeSequenceMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UpdateCoverSheetDocumentTypeSequenceMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateCoverSheetDocumentTypeSequenceMutation>(UpdateCoverSheetDocumentTypeSequenceDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updateCoverSheetDocumentTypeSequence', 'mutation', variables);
    },
    createAccountingReportDocument(variables: CreateAccountingReportDocumentMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CreateAccountingReportDocumentMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateAccountingReportDocumentMutation>(CreateAccountingReportDocumentDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'createAccountingReportDocument', 'mutation', variables);
    },
    createEODDocuments(variables: CreateEodDocumentsMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CreateEodDocumentsMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateEodDocumentsMutation>(CreateEodDocumentsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'createEODDocuments', 'mutation', variables);
    },
    createOrderComment(variables: CreateOrderCommentMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CreateOrderCommentMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateOrderCommentMutation>(CreateOrderCommentDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'createOrderComment', 'mutation', variables);
    },
    createOrderDocumentDocument(variables: CreateOrderDocumentDocumentMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CreateOrderDocumentDocumentMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateOrderDocumentDocumentMutation>(CreateOrderDocumentDocumentDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'createOrderDocumentDocument', 'mutation', variables);
    },
    createOrderSnapshot(variables: CreateOrderSnapshotMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CreateOrderSnapshotMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateOrderSnapshotMutation>(CreateOrderSnapshotDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'createOrderSnapshot', 'mutation', variables);
    },
    createOrdersFromRecurringTemplates(variables: CreateOrdersFromRecurringTemplatesMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CreateOrdersFromRecurringTemplatesMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateOrdersFromRecurringTemplatesMutation>(CreateOrdersFromRecurringTemplatesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'createOrdersFromRecurringTemplates', 'mutation', variables);
    },
    createPODReportDocument(variables: CreatePodReportDocumentMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CreatePodReportDocumentMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreatePodReportDocumentMutation>(CreatePodReportDocumentDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'createPODReportDocument', 'mutation', variables);
    },
    createRecurringRun(variables: CreateRecurringRunMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CreateRecurringRunMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateRecurringRunMutation>(CreateRecurringRunDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'createRecurringRun', 'mutation', variables);
    },
    createScannedOrders(variables: CreateScannedOrdersMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CreateScannedOrdersMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateScannedOrdersMutation>(CreateScannedOrdersDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'createScannedOrders', 'mutation', variables);
    },
    matchSignedPODs(variables: MatchSignedPoDsMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<MatchSignedPoDsMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<MatchSignedPoDsMutation>(MatchSignedPoDsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'matchSignedPODs', 'mutation', variables);
    },
    createStandardOrder(variables: CreateStandardOrderMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CreateStandardOrderMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateStandardOrderMutation>(CreateStandardOrderDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'createStandardOrder', 'mutation', variables);
    },
    createTag(variables: CreateTagMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CreateTagMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateTagMutation>(CreateTagDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'createTag', 'mutation', variables);
    },
    createOrUpdateCsvOrders(variables: CreateOrUpdateCsvOrdersMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CreateOrUpdateCsvOrdersMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateOrUpdateCsvOrdersMutation>(CreateOrUpdateCsvOrdersDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'createOrUpdateCsvOrders', 'mutation', variables);
    },
    csvOrderMappings(variables?: CsvOrderMappingsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CsvOrderMappingsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CsvOrderMappingsQuery>(CsvOrderMappingsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'csvOrderMappings', 'query', variables);
    },
    generateCsvOrderPreSignedPutUrls(variables: GenerateCsvOrderPreSignedPutUrlsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GenerateCsvOrderPreSignedPutUrlsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GenerateCsvOrderPreSignedPutUrlsQuery>(GenerateCsvOrderPreSignedPutUrlsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'generateCsvOrderPreSignedPutUrls', 'query', variables);
    },
    parseCsvOrders(variables: ParseCsvOrdersMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ParseCsvOrdersMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<ParseCsvOrdersMutation>(ParseCsvOrdersDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'parseCsvOrders', 'mutation', variables);
    },
    currentOrderStatus(variables: CurrentOrderStatusQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CurrentOrderStatusQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CurrentOrderStatusQuery>(CurrentOrderStatusDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'currentOrderStatus', 'query', variables);
    },
    deleteOrder(variables: DeleteOrderMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<DeleteOrderMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<DeleteOrderMutation>(DeleteOrderDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'deleteOrder', 'mutation', variables);
    },
    documentsByOrder(variables: DocumentsByOrderQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<DocumentsByOrderQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<DocumentsByOrderQuery>(DocumentsByOrderDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'documentsByOrder', 'query', variables);
    },
    ediAndApiOrdersForReview(variables?: EdiAndApiOrdersForReviewQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<EdiAndApiOrdersForReviewQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<EdiAndApiOrdersForReviewQuery>(EdiAndApiOrdersForReviewDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'ediAndApiOrdersForReview', 'query', variables);
    },
    ediTransactions(variables?: EdiTransactionsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<EdiTransactionsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<EdiTransactionsQuery>(EdiTransactionsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'ediTransactions', 'query', variables);
    },
    orderForEdiReviewByUuid(variables: OrderForEdiReviewByUuidQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<OrderForEdiReviewByUuidQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<OrderForEdiReviewByUuidQuery>(OrderForEdiReviewByUuidDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'orderForEdiReviewByUuid', 'query', variables);
    },
    emailOrderDocument(variables: EmailOrderDocumentMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<EmailOrderDocumentMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<EmailOrderDocumentMutation>(EmailOrderDocumentDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'emailOrderDocument', 'mutation', variables);
    },
    fetchMissingAccessorial(variables: FetchMissingAccessorialQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<FetchMissingAccessorialQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<FetchMissingAccessorialQuery>(FetchMissingAccessorialDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'fetchMissingAccessorial', 'query', variables);
    },
    finalizeOrder(variables: FinalizeOrderMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<FinalizeOrderMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<FinalizeOrderMutation>(FinalizeOrderDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'finalizeOrder', 'mutation', variables);
    },
    finalizeOrders(variables: FinalizeOrdersMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<FinalizeOrdersMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<FinalizeOrdersMutation>(FinalizeOrdersDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'finalizeOrders', 'mutation', variables);
    },
    terminalForAddress(variables: TerminalForAddressQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<TerminalForAddressQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<TerminalForAddressQuery>(TerminalForAddressDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'terminalForAddress', 'query', variables);
    },
    terminalsForAddress(variables: TerminalsForAddressQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<TerminalsForAddressQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<TerminalsForAddressQuery>(TerminalsForAddressDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'terminalsForAddress', 'query', variables);
    },
    generateAccountingReportPreSignedPutUrl(variables: GenerateAccountingReportPreSignedPutUrlMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GenerateAccountingReportPreSignedPutUrlMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<GenerateAccountingReportPreSignedPutUrlMutation>(GenerateAccountingReportPreSignedPutUrlDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'generateAccountingReportPreSignedPutUrl', 'mutation', variables);
    },
    generateOrderDocumentPreSignedPutUrl(variables: GenerateOrderDocumentPreSignedPutUrlMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GenerateOrderDocumentPreSignedPutUrlMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<GenerateOrderDocumentPreSignedPutUrlMutation>(GenerateOrderDocumentPreSignedPutUrlDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'generateOrderDocumentPreSignedPutUrl', 'mutation', variables);
    },
    generateOrderPreSignedGetAndPutUrls(variables: GenerateOrderPreSignedGetAndPutUrlsMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GenerateOrderPreSignedGetAndPutUrlsMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<GenerateOrderPreSignedGetAndPutUrlsMutation>(GenerateOrderPreSignedGetAndPutUrlsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'generateOrderPreSignedGetAndPutUrls', 'mutation', variables);
    },
    generatePodReportPreSignedPutUrl(variables: GeneratePodReportPreSignedPutUrlMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GeneratePodReportPreSignedPutUrlMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<GeneratePodReportPreSignedPutUrlMutation>(GeneratePodReportPreSignedPutUrlDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'generatePodReportPreSignedPutUrl', 'mutation', variables);
    },
    generateContactPreSignedPutUrl(variables: GenerateContactPreSignedPutUrlMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GenerateContactPreSignedPutUrlMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<GenerateContactPreSignedPutUrlMutation>(GenerateContactPreSignedPutUrlDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'generateContactPreSignedPutUrl', 'mutation', variables);
    },
    generateInvoicePreSignedPutUrl(variables: GenerateInvoicePreSignedPutUrlMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GenerateInvoicePreSignedPutUrlMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<GenerateInvoicePreSignedPutUrlMutation>(GenerateInvoicePreSignedPutUrlDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'generateInvoicePreSignedPutUrl', 'mutation', variables);
    },
    generateOrderPreSignedPutUrl(variables: GenerateOrderPreSignedPutUrlMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GenerateOrderPreSignedPutUrlMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<GenerateOrderPreSignedPutUrlMutation>(GenerateOrderPreSignedPutUrlDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'generateOrderPreSignedPutUrl', 'mutation', variables);
    },
    generateScannedOrderPreSignedPutUrls(variables: GenerateScannedOrderPreSignedPutUrlsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GenerateScannedOrderPreSignedPutUrlsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GenerateScannedOrderPreSignedPutUrlsQuery>(GenerateScannedOrderPreSignedPutUrlsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'generateScannedOrderPreSignedPutUrls', 'query', variables);
    },
    generatePreSignedPutUrl(variables: GeneratePreSignedPutUrlMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GeneratePreSignedPutUrlMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<GeneratePreSignedPutUrlMutation>(GeneratePreSignedPutUrlDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'generatePreSignedPutUrl', 'mutation', variables);
    },
    incompleteLegsWithAttempts(variables?: IncompleteLegsWithAttemptsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<IncompleteLegsWithAttemptsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<IncompleteLegsWithAttemptsQuery>(IncompleteLegsWithAttemptsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'incompleteLegsWithAttempts', 'query', variables);
    },
    laneFromOriginAndDestinationTerminal(variables: LaneFromOriginAndDestinationTerminalQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<LaneFromOriginAndDestinationTerminalQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<LaneFromOriginAndDestinationTerminalQuery>(LaneFromOriginAndDestinationTerminalDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'laneFromOriginAndDestinationTerminal', 'query', variables);
    },
    markOrderAsCompleteForce(variables: MarkOrderAsCompleteForceMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<MarkOrderAsCompleteForceMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<MarkOrderAsCompleteForceMutation>(MarkOrderAsCompleteForceDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'markOrderAsCompleteForce', 'mutation', variables);
    },
    markOrderAsHasBillingIssue(variables: MarkOrderAsHasBillingIssueMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<MarkOrderAsHasBillingIssueMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<MarkOrderAsHasBillingIssueMutation>(MarkOrderAsHasBillingIssueDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'markOrderAsHasBillingIssue', 'mutation', variables);
    },
    markOrderAsNotComplete(variables: MarkOrderAsNotCompleteMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<MarkOrderAsNotCompleteMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<MarkOrderAsNotCompleteMutation>(MarkOrderAsNotCompleteDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'markOrderAsNotComplete', 'mutation', variables);
    },
    markOrderAsNotOnHand(variables: MarkOrderAsNotOnHandMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<MarkOrderAsNotOnHandMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<MarkOrderAsNotOnHandMutation>(MarkOrderAsNotOnHandDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'markOrderAsNotOnHand', 'mutation', variables);
    },
    markOrderAsNotReadyToInvoice(variables: MarkOrderAsNotReadyToInvoiceMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<MarkOrderAsNotReadyToInvoiceMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<MarkOrderAsNotReadyToInvoiceMutation>(MarkOrderAsNotReadyToInvoiceDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'markOrderAsNotReadyToInvoice', 'mutation', variables);
    },
    markOrderAsNotReceivedAtOrigin(variables: MarkOrderAsNotReceivedAtOriginMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<MarkOrderAsNotReceivedAtOriginMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<MarkOrderAsNotReceivedAtOriginMutation>(MarkOrderAsNotReceivedAtOriginDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'markOrderAsNotReceivedAtOrigin', 'mutation', variables);
    },
    markOrderAsOnHand(variables: MarkOrderAsOnHandMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<MarkOrderAsOnHandMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<MarkOrderAsOnHandMutation>(MarkOrderAsOnHandDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'markOrderAsOnHand', 'mutation', variables);
    },
    markOrderAsReadyToInvoiceForce(variables: MarkOrderAsReadyToInvoiceForceMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<MarkOrderAsReadyToInvoiceForceMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<MarkOrderAsReadyToInvoiceForceMutation>(MarkOrderAsReadyToInvoiceForceDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'markOrderAsReadyToInvoiceForce', 'mutation', variables);
    },
    markOrderAsReadyToInvoice(variables: MarkOrderAsReadyToInvoiceMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<MarkOrderAsReadyToInvoiceMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<MarkOrderAsReadyToInvoiceMutation>(MarkOrderAsReadyToInvoiceDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'markOrderAsReadyToInvoice', 'mutation', variables);
    },
    markOrderAsReceivedAtOrigin(variables: MarkOrderAsReceivedAtOriginMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<MarkOrderAsReceivedAtOriginMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<MarkOrderAsReceivedAtOriginMutation>(MarkOrderAsReceivedAtOriginDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'markOrderAsReceivedAtOrigin', 'mutation', variables);
    },
    markOrderAsRefused(variables: MarkOrderAsRefusedMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<MarkOrderAsRefusedMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<MarkOrderAsRefusedMutation>(MarkOrderAsRefusedDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'markOrderAsRefused', 'mutation', variables);
    },
    markOrderAsNotOsd(variables: MarkOrderAsNotOsdMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<MarkOrderAsNotOsdMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<MarkOrderAsNotOsdMutation>(MarkOrderAsNotOsdDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'markOrderAsNotOsd', 'mutation', variables);
    },
    markOrderAsOSD(variables: MarkOrderAsOsdMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<MarkOrderAsOsdMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<MarkOrderAsOsdMutation>(MarkOrderAsOsdDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'markOrderAsOSD', 'mutation', variables);
    },
    mergeEdiOrder(variables: MergeEdiOrderMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<MergeEdiOrderMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<MergeEdiOrderMutation>(MergeEdiOrderDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'mergeEdiOrder', 'mutation', variables);
    },
    openMessageInOutlook(variables: OpenMessageInOutlookMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<OpenMessageInOutlookMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<OpenMessageInOutlookMutation>(OpenMessageInOutlookDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'openMessageInOutlook', 'mutation', variables);
    },
    deleteOrderComment(variables: DeleteOrderCommentMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<DeleteOrderCommentMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<DeleteOrderCommentMutation>(DeleteOrderCommentDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'deleteOrderComment', 'mutation', variables);
    },
    updateOrderComment(variables: UpdateOrderCommentMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UpdateOrderCommentMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateOrderCommentMutation>(UpdateOrderCommentDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updateOrderComment', 'mutation', variables);
    },
    standardOrderForContextMenu(variables: StandardOrderForContextMenuQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<StandardOrderForContextMenuQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<StandardOrderForContextMenuQuery>(StandardOrderForContextMenuDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'standardOrderForContextMenu', 'query', variables);
    },
    ordersForDocumentAttachmentsDownload(variables: OrdersForDocumentAttachmentsDownloadQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<OrdersForDocumentAttachmentsDownloadQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<OrdersForDocumentAttachmentsDownloadQuery>(OrdersForDocumentAttachmentsDownloadDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'ordersForDocumentAttachmentsDownload', 'query', variables);
    },
    orderName(variables: OrderNameQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<OrderNameQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<OrderNameQuery>(OrderNameDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'orderName', 'query', variables);
    },
    orderPodReports(variables?: OrderPodReportsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<OrderPodReportsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<OrderPodReportsQuery>(OrderPodReportsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'orderPodReports', 'query', variables);
    },
    orderUpdatedAt(variables: OrderUpdatedAtQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<OrderUpdatedAtQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<OrderUpdatedAtQuery>(OrderUpdatedAtDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'orderUpdatedAt', 'query', variables);
    },
    order(variables: OrderQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<OrderQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<OrderQuery>(OrderDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'order', 'query', variables);
    },
    ordersBySecondaryRefNumber(variables: OrdersBySecondaryRefNumberQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<OrdersBySecondaryRefNumberQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<OrdersBySecondaryRefNumberQuery>(OrdersBySecondaryRefNumberDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'ordersBySecondaryRefNumber', 'query', variables);
    },
    ordersByShipperBillOfLadingNumber(variables: OrdersByShipperBillOfLadingNumberQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<OrdersByShipperBillOfLadingNumberQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<OrdersByShipperBillOfLadingNumberQuery>(OrdersByShipperBillOfLadingNumberDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'ordersByShipperBillOfLadingNumber', 'query', variables);
    },
    ordersByUuidsForBulkEdit(variables: OrdersByUuidsForBulkEditQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<OrdersByUuidsForBulkEditQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<OrdersByUuidsForBulkEditQuery>(OrdersByUuidsForBulkEditDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'ordersByUuidsForBulkEdit', 'query', variables);
    },
    ordersForBulkEdit(variables?: OrdersForBulkEditQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<OrdersForBulkEditQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<OrdersForBulkEditQuery>(OrdersForBulkEditDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'ordersForBulkEdit', 'query', variables);
    },
    ordersForInventoryLabels(variables: OrdersForInventoryLabelsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<OrdersForInventoryLabelsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<OrdersForInventoryLabelsQuery>(OrdersForInventoryLabelsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'ordersForInventoryLabels', 'query', variables);
    },
    ordersForOrderMatching(variables?: OrdersForOrderMatchingQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<OrdersForOrderMatchingQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<OrdersForOrderMatchingQuery>(OrdersForOrderMatchingDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'ordersForOrderMatching', 'query', variables);
    },
    createOrderTableReport(variables: CreateOrderTableReportMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CreateOrderTableReportMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateOrderTableReportMutation>(CreateOrderTableReportDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'createOrderTableReport', 'mutation', variables);
    },
    getOrderTableFieldValuesForCount(variables: GetOrderTableFieldValuesForCountQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetOrderTableFieldValuesForCountQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetOrderTableFieldValuesForCountQuery>(GetOrderTableFieldValuesForCountDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getOrderTableFieldValuesForCount', 'query', variables);
    },
    getOrderTableFieldValuesForSearch(variables: GetOrderTableFieldValuesForSearchQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetOrderTableFieldValuesForSearchQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetOrderTableFieldValuesForSearchQuery>(GetOrderTableFieldValuesForSearchDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getOrderTableFieldValuesForSearch', 'query', variables);
    },
    getOrderTableFieldValues(variables: GetOrderTableFieldValuesQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetOrderTableFieldValuesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetOrderTableFieldValuesQuery>(GetOrderTableFieldValuesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getOrderTableFieldValues', 'query', variables);
    },
    orderComments(variables: OrderCommentsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<OrderCommentsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<OrderCommentsQuery>(OrderCommentsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'orderComments', 'query', variables);
    },
    orderTableFieldHeaders(variables?: OrderTableFieldHeadersQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<OrderTableFieldHeadersQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<OrderTableFieldHeadersQuery>(OrderTableFieldHeadersDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'orderTableFieldHeaders', 'query', variables);
    },
    orderUuids(variables?: OrderUuidsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<OrderUuidsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<OrderUuidsQuery>(OrderUuidsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'orderUuids', 'query', variables);
    },
    orderWithInboundOutboundPaperwork(variables: OrderWithInboundOutboundPaperworkQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<OrderWithInboundOutboundPaperworkQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<OrderWithInboundOutboundPaperworkQuery>(OrderWithInboundOutboundPaperworkDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'orderWithInboundOutboundPaperwork', 'query', variables);
    },
    orderWithItemizedCharges(variables: OrderWithItemizedChargesQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<OrderWithItemizedChargesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<OrderWithItemizedChargesQuery>(OrderWithItemizedChargesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'orderWithItemizedCharges', 'query', variables);
    },
    orderWithMissingDocuments(variables: OrderWithMissingDocumentsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<OrderWithMissingDocumentsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<OrderWithMissingDocumentsQuery>(OrderWithMissingDocumentsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'orderWithMissingDocuments', 'query', variables);
    },
    orderWithPaperwork(variables: OrderWithPaperworkQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<OrderWithPaperworkQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<OrderWithPaperworkQuery>(OrderWithPaperworkDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'orderWithPaperwork', 'query', variables);
    },
    PackageSpecs(variables?: PackageSpecsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<PackageSpecsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<PackageSpecsQuery>(PackageSpecsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'PackageSpecs', 'query', variables);
    },
    recurringOrderTemplates(variables?: RecurringOrderTemplatesQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<RecurringOrderTemplatesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<RecurringOrderTemplatesQuery>(RecurringOrderTemplatesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'recurringOrderTemplates', 'query', variables);
    },
    recurringRuns(variables?: RecurringRunsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<RecurringRunsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<RecurringRunsQuery>(RecurringRunsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'recurringRuns', 'query', variables);
    },
    removeOrderHold(variables: RemoveOrderHoldMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<RemoveOrderHoldMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<RemoveOrderHoldMutation>(RemoveOrderHoldDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'removeOrderHold', 'mutation', variables);
    },
    removeSubscriberFromShipment(variables: RemoveSubscriberFromShipmentMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<RemoveSubscriberFromShipmentMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<RemoveSubscriberFromShipmentMutation>(RemoveSubscriberFromShipmentDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'removeSubscriberFromShipment', 'mutation', variables);
    },
    reportADocScanIssue(variables: ReportADocScanIssueMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ReportADocScanIssueMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<ReportADocScanIssueMutation>(ReportADocScanIssueDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'reportADocScanIssue', 'mutation', variables);
    },
    scannedOrderResultByOrderUuid(variables: ScannedOrderResultByOrderUuidQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ScannedOrderResultByOrderUuidQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<ScannedOrderResultByOrderUuidQuery>(ScannedOrderResultByOrderUuidDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'scannedOrderResultByOrderUuid', 'query', variables);
    },
    servicesForOrder(variables: ServicesForOrderQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ServicesForOrderQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<ServicesForOrderQuery>(ServicesForOrderDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'servicesForOrder', 'query', variables);
    },
    shipmentBillOfLading(variables: ShipmentBillOfLadingQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ShipmentBillOfLadingQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<ShipmentBillOfLadingQuery>(ShipmentBillOfLadingDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'shipmentBillOfLading', 'query', variables);
    },
    standardOrder(variables: StandardOrderQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<StandardOrderQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<StandardOrderQuery>(StandardOrderDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'standardOrder', 'query', variables);
    },
    stopForDriverSettlement(variables: StopForDriverSettlementQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<StopForDriverSettlementQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<StopForDriverSettlementQuery>(StopForDriverSettlementDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'stopForDriverSettlement', 'query', variables);
    },
    uncancelOrder(variables: UncancelOrderMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UncancelOrderMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UncancelOrderMutation>(UncancelOrderDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'uncancelOrder', 'mutation', variables);
    },
    unfinalizeOrder(variables: UnfinalizeOrderMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UnfinalizeOrderMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UnfinalizeOrderMutation>(UnfinalizeOrderDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'unfinalizeOrder', 'mutation', variables);
    },
    updateDocument(variables: UpdateDocumentMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UpdateDocumentMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateDocumentMutation>(UpdateDocumentDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updateDocument', 'mutation', variables);
    },
    updatePaperworkCompletedForStops(variables: UpdatePaperworkCompletedForStopsMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UpdatePaperworkCompletedForStopsMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdatePaperworkCompletedForStopsMutation>(UpdatePaperworkCompletedForStopsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updatePaperworkCompletedForStops', 'mutation', variables);
    },
    updateRecurringRun(variables: UpdateRecurringRunMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UpdateRecurringRunMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateRecurringRunMutation>(UpdateRecurringRunDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updateRecurringRun', 'mutation', variables);
    },
    updateStandardOrder(variables: UpdateStandardOrderMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UpdateStandardOrderMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateStandardOrderMutation>(UpdateStandardOrderDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updateStandardOrder', 'mutation', variables);
    },
    rateOrderByUuid(variables: RateOrderByUuidQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<RateOrderByUuidQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<RateOrderByUuidQuery>(RateOrderByUuidDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'rateOrderByUuid', 'query', variables);
    },
    rateOrderTotalDollars(variables: RateOrderTotalDollarsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<RateOrderTotalDollarsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<RateOrderTotalDollarsQuery>(RateOrderTotalDollarsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'rateOrderTotalDollars', 'query', variables);
    },
    rateOrder(variables: RateOrderQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<RateOrderQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<RateOrderQuery>(RateOrderDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'rateOrder', 'query', variables);
    },
    updatePackage(variables: UpdatePackageMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UpdatePackageMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdatePackageMutation>(UpdatePackageDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updatePackage', 'mutation', variables);
    },
    createPermission(variables: CreatePermissionMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CreatePermissionMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreatePermissionMutation>(CreatePermissionDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'createPermission', 'mutation', variables);
    },
    deletePermission(variables: DeletePermissionMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<DeletePermissionMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<DeletePermissionMutation>(DeletePermissionDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'deletePermission', 'mutation', variables);
    },
    updatePermissionAccessLevel(variables: UpdatePermissionAccessLevelMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UpdatePermissionAccessLevelMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdatePermissionAccessLevelMutation>(UpdatePermissionAccessLevelDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updatePermissionAccessLevel', 'mutation', variables);
    },
    updatePermission(variables: UpdatePermissionMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UpdatePermissionMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdatePermissionMutation>(UpdatePermissionDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updatePermission', 'mutation', variables);
    },
    approveQuote(variables: ApproveQuoteMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ApproveQuoteMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<ApproveQuoteMutation>(ApproveQuoteDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'approveQuote', 'mutation', variables);
    },
    clientQuotes(variables: ClientQuotesQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ClientQuotesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<ClientQuotesQuery>(ClientQuotesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'clientQuotes', 'query', variables);
    },
    createQuote(variables: CreateQuoteMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CreateQuoteMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateQuoteMutation>(CreateQuoteDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'createQuote', 'mutation', variables);
    },
    quoteName(variables: QuoteNameQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<QuoteNameQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<QuoteNameQuery>(QuoteNameDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'quoteName', 'query', variables);
    },
    quote(variables: QuoteQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<QuoteQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<QuoteQuery>(QuoteDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'quote', 'query', variables);
    },
    quotes(variables?: QuotesQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<QuotesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<QuotesQuery>(QuotesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'quotes', 'query', variables);
    },
    updateQuote(variables: UpdateQuoteMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UpdateQuoteMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateQuoteMutation>(UpdateQuoteDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updateQuote', 'mutation', variables);
    },
    createReportGroupConfiguration(variables: CreateReportGroupConfigurationMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CreateReportGroupConfigurationMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateReportGroupConfigurationMutation>(CreateReportGroupConfigurationDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'createReportGroupConfiguration', 'mutation', variables);
    },
    customerReport(variables: CustomerReportQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CustomerReportQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CustomerReportQuery>(CustomerReportDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'customerReport', 'query', variables);
    },
    deleteReportGroupConfiguration(variables: DeleteReportGroupConfigurationMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<DeleteReportGroupConfigurationMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<DeleteReportGroupConfigurationMutation>(DeleteReportGroupConfigurationDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'deleteReportGroupConfiguration', 'mutation', variables);
    },
    driverReport(variables: DriverReportQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<DriverReportQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<DriverReportQuery>(DriverReportDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'driverReport', 'query', variables);
    },
    orderReport(variables: OrderReportQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<OrderReportQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<OrderReportQuery>(OrderReportDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'orderReport', 'query', variables);
    },
    reportGroupConfigurations(variables?: ReportGroupConfigurationsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ReportGroupConfigurationsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<ReportGroupConfigurationsQuery>(ReportGroupConfigurationsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'reportGroupConfigurations', 'query', variables);
    },
    reportSendJobBatches(variables: ReportSendJobBatchesQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ReportSendJobBatchesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<ReportSendJobBatchesQuery>(ReportSendJobBatchesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'reportSendJobBatches', 'query', variables);
    },
    reportSendJobs(variables: ReportSendJobsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ReportSendJobsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<ReportSendJobsQuery>(ReportSendJobsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'reportSendJobs', 'query', variables);
    },
    sendAccountingReports(variables: SendAccountingReportsMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<SendAccountingReportsMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<SendAccountingReportsMutation>(SendAccountingReportsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'sendAccountingReports', 'mutation', variables);
    },
    serviceLevelReport(variables: ServiceLevelReportQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ServiceLevelReportQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<ServiceLevelReportQuery>(ServiceLevelReportDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'serviceLevelReport', 'query', variables);
    },
    stationReport(variables: StationReportQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<StationReportQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<StationReportQuery>(StationReportDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'stationReport', 'query', variables);
    },
    terminalReport(variables: TerminalReportQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<TerminalReportQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<TerminalReportQuery>(TerminalReportDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'terminalReport', 'query', variables);
    },
    updateReportGroupConfiguration(variables: UpdateReportGroupConfigurationMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UpdateReportGroupConfigurationMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateReportGroupConfigurationMutation>(UpdateReportGroupConfigurationDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updateReportGroupConfiguration', 'mutation', variables);
    },
    AppointmentOptions(variables: AppointmentOptionsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<AppointmentOptionsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<AppointmentOptionsQuery>(AppointmentOptionsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AppointmentOptions', 'query', variables);
    },
    ChooseAppointmentOption(variables: ChooseAppointmentOptionMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ChooseAppointmentOptionMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<ChooseAppointmentOptionMutation>(ChooseAppointmentOptionDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'ChooseAppointmentOption', 'mutation', variables);
    },
    QueueAppointmentSchedulingProposals(variables: QueueAppointmentSchedulingProposalsMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<QueueAppointmentSchedulingProposalsMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<QueueAppointmentSchedulingProposalsMutation>(QueueAppointmentSchedulingProposalsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'QueueAppointmentSchedulingProposals', 'mutation', variables);
    },
    addUserToRole(variables: AddUserToRoleMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<AddUserToRoleMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<AddUserToRoleMutation>(AddUserToRoleDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'addUserToRole', 'mutation', variables);
    },
    createRole(variables: CreateRoleMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CreateRoleMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateRoleMutation>(CreateRoleDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'createRole', 'mutation', variables);
    },
    role(variables: RoleQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<RoleQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<RoleQuery>(RoleDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'role', 'query', variables);
    },
    roles(variables?: RolesQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<RolesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<RolesQuery>(RolesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'roles', 'query', variables);
    },
    removeUserFromRole(variables: RemoveUserFromRoleMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<RemoveUserFromRoleMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<RemoveUserFromRoleMutation>(RemoveUserFromRoleDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'removeUserFromRole', 'mutation', variables);
    },
    updateRole(variables: UpdateRoleMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UpdateRoleMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateRoleMutation>(UpdateRoleDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updateRole', 'mutation', variables);
    },
    usersForRole(variables?: UsersForRoleQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UsersForRoleQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<UsersForRoleQuery>(UsersForRoleDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'usersForRole', 'query', variables);
    },
    createShipmentDocument(variables: CreateShipmentDocumentMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CreateShipmentDocumentMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateShipmentDocumentMutation>(CreateShipmentDocumentDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'createShipmentDocument', 'mutation', variables);
    },
    completeStopBulk(variables: CompleteStopBulkMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CompleteStopBulkMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CompleteStopBulkMutation>(CompleteStopBulkDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'completeStopBulk', 'mutation', variables);
    },
    completeStopV2(variables: CompleteStopV2MutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CompleteStopV2Mutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CompleteStopV2Mutation>(CompleteStopV2Document, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'completeStopV2', 'mutation', variables);
    },
    deleteDocument(variables: DeleteDocumentMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<DeleteDocumentMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<DeleteDocumentMutation>(DeleteDocumentDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'deleteDocument', 'mutation', variables);
    },
    generateShipmentPreSignedPutUrl(variables: GenerateShipmentPreSignedPutUrlMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GenerateShipmentPreSignedPutUrlMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<GenerateShipmentPreSignedPutUrlMutation>(GenerateShipmentPreSignedPutUrlDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'generateShipmentPreSignedPutUrl', 'mutation', variables);
    },
    markStopAsFailed(variables: MarkStopAsFailedMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<MarkStopAsFailedMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<MarkStopAsFailedMutation>(MarkStopAsFailedDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'markStopAsFailed', 'mutation', variables);
    },
    markStopAsFailedV2(variables: MarkStopAsFailedV2MutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<MarkStopAsFailedV2Mutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<MarkStopAsFailedV2Mutation>(MarkStopAsFailedV2Document, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'markStopAsFailedV2', 'mutation', variables);
    },
    nameOfRoute(variables: NameOfRouteQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<NameOfRouteQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<NameOfRouteQuery>(NameOfRouteDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'nameOfRoute', 'query', variables);
    },
    equipmentsFetch(variables?: EquipmentsFetchQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<EquipmentsFetchQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<EquipmentsFetchQuery>(EquipmentsFetchDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'equipmentsFetch', 'query', variables);
    },
    route(variables: RouteQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<RouteQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<RouteQuery>(RouteDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'route', 'query', variables);
    },
    shallowRoutes(variables: ShallowRoutesQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ShallowRoutesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<ShallowRoutesQuery>(ShallowRoutesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'shallowRoutes', 'query', variables);
    },
    updateServiceDateForAssignedStops(variables: UpdateServiceDateForAssignedStopsMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UpdateServiceDateForAssignedStopsMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateServiceDateForAssignedStopsMutation>(UpdateServiceDateForAssignedStopsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updateServiceDateForAssignedStops', 'mutation', variables);
    },
    updateStop(variables: UpdateStopMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UpdateStopMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateStopMutation>(UpdateStopDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updateStop', 'mutation', variables);
    },
    updateStops(variables: UpdateStopsMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UpdateStopsMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateStopsMutation>(UpdateStopsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updateStops', 'mutation', variables);
    },
    samaraOAuthAuthorizeUrl(variables?: SamaraOAuthAuthorizeUrlQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<SamaraOAuthAuthorizeUrlQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<SamaraOAuthAuthorizeUrlQuery>(SamaraOAuthAuthorizeUrlDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'samaraOAuthAuthorizeUrl', 'query', variables);
    },
    samsaraOAuthToken(variables?: SamsaraOAuthTokenQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<SamsaraOAuthTokenQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<SamsaraOAuthTokenQuery>(SamsaraOAuthTokenDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'samsaraOAuthToken', 'query', variables);
    },
    createSavedFilterView(variables: CreateSavedFilterViewMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CreateSavedFilterViewMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateSavedFilterViewMutation>(CreateSavedFilterViewDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'createSavedFilterView', 'mutation', variables);
    },
    deleteSavedFilterView(variables: DeleteSavedFilterViewMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<DeleteSavedFilterViewMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<DeleteSavedFilterViewMutation>(DeleteSavedFilterViewDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'deleteSavedFilterView', 'mutation', variables);
    },
    getSavedFilterViews(variables: GetSavedFilterViewsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetSavedFilterViewsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetSavedFilterViewsQuery>(GetSavedFilterViewsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getSavedFilterViews', 'query', variables);
    },
    updateSavedFilterView(variables: UpdateSavedFilterViewMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UpdateSavedFilterViewMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateSavedFilterViewMutation>(UpdateSavedFilterViewDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updateSavedFilterView', 'mutation', variables);
    },
    scannedOrderResult(variables: ScannedOrderResultQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ScannedOrderResultQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<ScannedOrderResultQuery>(ScannedOrderResultDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'scannedOrderResult', 'query', variables);
    },
    firstScannedOrderResultInReview(variables?: FirstScannedOrderResultInReviewQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<FirstScannedOrderResultInReviewQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<FirstScannedOrderResultInReviewQuery>(FirstScannedOrderResultInReviewDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'firstScannedOrderResultInReview', 'query', variables);
    },
    scannedOrderResults(variables: ScannedOrderResultsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ScannedOrderResultsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<ScannedOrderResultsQuery>(ScannedOrderResultsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'scannedOrderResults', 'query', variables);
    },
    updateScannedOrderResultStatus(variables: UpdateScannedOrderResultStatusMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UpdateScannedOrderResultStatusMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateScannedOrderResultStatusMutation>(UpdateScannedOrderResultStatusDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updateScannedOrderResultStatus', 'mutation', variables);
    },
    ArchiveSchedulingRegion(variables: ArchiveSchedulingRegionMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ArchiveSchedulingRegionMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<ArchiveSchedulingRegionMutation>(ArchiveSchedulingRegionDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'ArchiveSchedulingRegion', 'mutation', variables);
    },
    CreateSchedulingRegion(variables: CreateSchedulingRegionMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CreateSchedulingRegionMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateSchedulingRegionMutation>(CreateSchedulingRegionDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'CreateSchedulingRegion', 'mutation', variables);
    },
    CreateSchedulingZone(variables: CreateSchedulingZoneMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CreateSchedulingZoneMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateSchedulingZoneMutation>(CreateSchedulingZoneDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'CreateSchedulingZone', 'mutation', variables);
    },
    RestoreSchedulingRegion(variables: RestoreSchedulingRegionMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<RestoreSchedulingRegionMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<RestoreSchedulingRegionMutation>(RestoreSchedulingRegionDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'RestoreSchedulingRegion', 'mutation', variables);
    },
    RestoreSchedulingZone(variables: RestoreSchedulingZoneMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<RestoreSchedulingZoneMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<RestoreSchedulingZoneMutation>(RestoreSchedulingZoneDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'RestoreSchedulingZone', 'mutation', variables);
    },
    SchedulingRegion(variables: SchedulingRegionQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<SchedulingRegionQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<SchedulingRegionQuery>(SchedulingRegionDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'SchedulingRegion', 'query', variables);
    },
    SchedulingRegions(variables?: SchedulingRegionsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<SchedulingRegionsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<SchedulingRegionsQuery>(SchedulingRegionsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'SchedulingRegions', 'query', variables);
    },
    UpdateSchedulingRegion(variables: UpdateSchedulingRegionMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UpdateSchedulingRegionMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateSchedulingRegionMutation>(UpdateSchedulingRegionDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'UpdateSchedulingRegion', 'mutation', variables);
    },
    UpdateSchedulingZone(variables: UpdateSchedulingZoneMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UpdateSchedulingZoneMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateSchedulingZoneMutation>(UpdateSchedulingZoneDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'UpdateSchedulingZone', 'mutation', variables);
    },
    CreateServiceRegions(variables: CreateServiceRegionsMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CreateServiceRegionsMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateServiceRegionsMutation>(CreateServiceRegionsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'CreateServiceRegions', 'mutation', variables);
    },
    ServiceRegion(variables: ServiceRegionQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ServiceRegionQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<ServiceRegionQuery>(ServiceRegionDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'ServiceRegion', 'query', variables);
    },
    UpdateServiceRegion(variables: UpdateServiceRegionMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UpdateServiceRegionMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateServiceRegionMutation>(UpdateServiceRegionDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'UpdateServiceRegion', 'mutation', variables);
    },
    bulkUpdateAccessorialMappings(variables: BulkUpdateAccessorialMappingsMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<BulkUpdateAccessorialMappingsMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<BulkUpdateAccessorialMappingsMutation>(BulkUpdateAccessorialMappingsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'bulkUpdateAccessorialMappings', 'mutation', variables);
    },
    bulkUpdateContactQuickbooksIds(variables: BulkUpdateContactQuickbooksIdsMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<BulkUpdateContactQuickbooksIdsMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<BulkUpdateContactQuickbooksIdsMutation>(BulkUpdateContactQuickbooksIdsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'bulkUpdateContactQuickbooksIds', 'mutation', variables);
    },
    companyDefaultEdiSettings(variables?: CompanyDefaultEdiSettingsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CompanyDefaultEdiSettingsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CompanyDefaultEdiSettingsQuery>(CompanyDefaultEdiSettingsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'companyDefaultEdiSettings', 'query', variables);
    },
    accessorialToQuickbooksMappingByContact(variables: AccessorialToQuickbooksMappingByContactQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<AccessorialToQuickbooksMappingByContactQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<AccessorialToQuickbooksMappingByContactQuery>(AccessorialToQuickbooksMappingByContactDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'accessorialToQuickbooksMappingByContact', 'query', variables);
    },
    createAccessorialToQuickbooksMapping(variables: CreateAccessorialToQuickbooksMappingMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CreateAccessorialToQuickbooksMappingMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateAccessorialToQuickbooksMappingMutation>(CreateAccessorialToQuickbooksMappingDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'createAccessorialToQuickbooksMapping', 'mutation', variables);
    },
    CreateManyReferenceNumberLabels(variables: CreateManyReferenceNumberLabelsMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CreateManyReferenceNumberLabelsMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateManyReferenceNumberLabelsMutation>(CreateManyReferenceNumberLabelsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'CreateManyReferenceNumberLabels', 'mutation', variables);
    },
    createQuickbooksHeaderFileMapping(variables: CreateQuickbooksHeaderFileMappingMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CreateQuickbooksHeaderFileMappingMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateQuickbooksHeaderFileMappingMutation>(CreateQuickbooksHeaderFileMappingDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'createQuickbooksHeaderFileMapping', 'mutation', variables);
    },
    deleteQuickbooksHeaderFileMapping(variables: DeleteQuickbooksHeaderFileMappingMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<DeleteQuickbooksHeaderFileMappingMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<DeleteQuickbooksHeaderFileMappingMutation>(DeleteQuickbooksHeaderFileMappingDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'deleteQuickbooksHeaderFileMapping', 'mutation', variables);
    },
    deleteTag(variables: DeleteTagMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<DeleteTagMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<DeleteTagMutation>(DeleteTagDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'deleteTag', 'mutation', variables);
    },
    quickbooksOAuthUrl(variables?: QuickbooksOAuthUrlQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<QuickbooksOAuthUrlQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<QuickbooksOAuthUrlQuery>(QuickbooksOAuthUrlDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'quickbooksOAuthUrl', 'query', variables);
    },
    queryQuickbooksDesktopItems(variables?: QueryQuickbooksDesktopItemsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<QueryQuickbooksDesktopItemsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<QueryQuickbooksDesktopItemsQuery>(QueryQuickbooksDesktopItemsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'queryQuickbooksDesktopItems', 'query', variables);
    },
    quickbooksCustomers(variables?: QuickbooksCustomersQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<QuickbooksCustomersQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<QuickbooksCustomersQuery>(QuickbooksCustomersDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'quickbooksCustomers', 'query', variables);
    },
    quickbooksHeaderFileMappings(variables?: QuickbooksHeaderFileMappingsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<QuickbooksHeaderFileMappingsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<QuickbooksHeaderFileMappingsQuery>(QuickbooksHeaderFileMappingsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'quickbooksHeaderFileMappings', 'query', variables);
    },
    quickbooksItems(variables?: QuickbooksItemsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<QuickbooksItemsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<QuickbooksItemsQuery>(QuickbooksItemsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'quickbooksItems', 'query', variables);
    },
    referenceNumberFormatConfigs(variables: ReferenceNumberFormatConfigsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ReferenceNumberFormatConfigsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<ReferenceNumberFormatConfigsQuery>(ReferenceNumberFormatConfigsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'referenceNumberFormatConfigs', 'query', variables);
    },
    updateAccessorialToQuickbooksMapping(variables: UpdateAccessorialToQuickbooksMappingMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UpdateAccessorialToQuickbooksMappingMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateAccessorialToQuickbooksMappingMutation>(UpdateAccessorialToQuickbooksMappingDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updateAccessorialToQuickbooksMapping', 'mutation', variables);
    },
    updateCompany(variables: UpdateCompanyMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UpdateCompanyMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateCompanyMutation>(UpdateCompanyDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updateCompany', 'mutation', variables);
    },
    updateOrderFormFields(variables: UpdateOrderFormFieldsMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UpdateOrderFormFieldsMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateOrderFormFieldsMutation>(UpdateOrderFormFieldsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updateOrderFormFields', 'mutation', variables);
    },
    updateQuickbooksHeaderFileMapping(variables: UpdateQuickbooksHeaderFileMappingMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UpdateQuickbooksHeaderFileMappingMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateQuickbooksHeaderFileMappingMutation>(UpdateQuickbooksHeaderFileMappingDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updateQuickbooksHeaderFileMapping', 'mutation', variables);
    },
    updateTag(variables: UpdateTagMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UpdateTagMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateTagMutation>(UpdateTagDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updateTag', 'mutation', variables);
    },
    addLineItemsToSettlementBills(variables: AddLineItemsToSettlementBillsMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<AddLineItemsToSettlementBillsMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<AddLineItemsToSettlementBillsMutation>(AddLineItemsToSettlementBillsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'addLineItemsToSettlementBills', 'mutation', variables);
    },
    CreateSettlementAdjustment(variables: CreateSettlementAdjustmentMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CreateSettlementAdjustmentMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateSettlementAdjustmentMutation>(CreateSettlementAdjustmentDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'CreateSettlementAdjustment', 'mutation', variables);
    },
    driverSettlementBillByUuidV2(variables: DriverSettlementBillByUuidV2QueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<DriverSettlementBillByUuidV2Query> {
      return withWrapper((wrappedRequestHeaders) => client.request<DriverSettlementBillByUuidV2Query>(DriverSettlementBillByUuidV2Document, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'driverSettlementBillByUuidV2', 'query', variables);
    },
    driverSettlementBillExportPdf(variables: DriverSettlementBillExportPdfMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<DriverSettlementBillExportPdfMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<DriverSettlementBillExportPdfMutation>(DriverSettlementBillExportPdfDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'driverSettlementBillExportPdf', 'mutation', variables);
    },
    driverSettlementBillExportZip(variables: DriverSettlementBillExportZipMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<DriverSettlementBillExportZipMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<DriverSettlementBillExportZipMutation>(DriverSettlementBillExportZipDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'driverSettlementBillExportZip', 'mutation', variables);
    },
    finalizeSettlementBills(variables: FinalizeSettlementBillsMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<FinalizeSettlementBillsMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<FinalizeSettlementBillsMutation>(FinalizeSettlementBillsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'finalizeSettlementBills', 'mutation', variables);
    },
    SettlementBillLineItemWithCosts(variables: SettlementBillLineItemWithCostsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<SettlementBillLineItemWithCostsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<SettlementBillLineItemWithCostsQuery>(SettlementBillLineItemWithCostsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'SettlementBillLineItemWithCosts', 'query', variables);
    },
    removeLineItemsFromSettlementBill(variables: RemoveLineItemsFromSettlementBillMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<RemoveLineItemsFromSettlementBillMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<RemoveLineItemsFromSettlementBillMutation>(RemoveLineItemsFromSettlementBillDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'removeLineItemsFromSettlementBill', 'mutation', variables);
    },
    RemoveSettlementAdjustment(variables: RemoveSettlementAdjustmentMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<RemoveSettlementAdjustmentMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<RemoveSettlementAdjustmentMutation>(RemoveSettlementAdjustmentDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'RemoveSettlementAdjustment', 'mutation', variables);
    },
    getSettlementBillLineItems(variables: GetSettlementBillLineItemsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetSettlementBillLineItemsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetSettlementBillLineItemsQuery>(GetSettlementBillLineItemsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getSettlementBillLineItems', 'query', variables);
    },
    UpdateSettlementAdjustment(variables: UpdateSettlementAdjustmentMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UpdateSettlementAdjustmentMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateSettlementAdjustmentMutation>(UpdateSettlementAdjustmentDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'UpdateSettlementAdjustment', 'mutation', variables);
    },
    outstandingShipmentsUuids(variables: OutstandingShipmentsUuidsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<OutstandingShipmentsUuidsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<OutstandingShipmentsUuidsQuery>(OutstandingShipmentsUuidsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'outstandingShipmentsUuids', 'query', variables);
    },
    attachMobileSignedDocumentToOrderAndReplaceOriginal(variables: AttachMobileSignedDocumentToOrderAndReplaceOriginalMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<AttachMobileSignedDocumentToOrderAndReplaceOriginalMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<AttachMobileSignedDocumentToOrderAndReplaceOriginalMutation>(AttachMobileSignedDocumentToOrderAndReplaceOriginalDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'attachMobileSignedDocumentToOrderAndReplaceOriginal', 'mutation', variables);
    },
    documentForSigning(variables: DocumentForSigningQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<DocumentForSigningQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<DocumentForSigningQuery>(DocumentForSigningDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'documentForSigning', 'query', variables);
    },
    documentsForSigning(variables: DocumentsForSigningQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<DocumentsForSigningQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<DocumentsForSigningQuery>(DocumentsForSigningDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'documentsForSigning', 'query', variables);
    },
    generateMobileSignedDocumentPreSignedPutUrl(variables: GenerateMobileSignedDocumentPreSignedPutUrlMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GenerateMobileSignedDocumentPreSignedPutUrlMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<GenerateMobileSignedDocumentPreSignedPutUrlMutation>(GenerateMobileSignedDocumentPreSignedPutUrlDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'generateMobileSignedDocumentPreSignedPutUrl', 'mutation', variables);
    },
    completedStopNotOnRoute(variables: CompletedStopNotOnRouteQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CompletedStopNotOnRouteQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CompletedStopNotOnRouteQuery>(CompletedStopNotOnRouteDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'completedStopNotOnRoute', 'query', variables);
    },
    completedStopsNotOnRoutes(variables: CompletedStopsNotOnRoutesQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CompletedStopsNotOnRoutesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CompletedStopsNotOnRoutesQuery>(CompletedStopsNotOnRoutesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'completedStopsNotOnRoutes', 'query', variables);
    },
    deleteStopAttempt(variables: DeleteStopAttemptMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<DeleteStopAttemptMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<DeleteStopAttemptMutation>(DeleteStopAttemptDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'deleteStopAttempt', 'mutation', variables);
    },
    markAttemptedStopAsComplete(variables: MarkAttemptedStopAsCompleteMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<MarkAttemptedStopAsCompleteMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<MarkAttemptedStopAsCompleteMutation>(MarkAttemptedStopAsCompleteDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'markAttemptedStopAsComplete', 'mutation', variables);
    },
    markStopAsIncomplete(variables: MarkStopAsIncompleteMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<MarkStopAsIncompleteMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<MarkStopAsIncompleteMutation>(MarkStopAsIncompleteDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'markStopAsIncomplete', 'mutation', variables);
    },
    stopForCompletionCheck(variables: StopForCompletionCheckQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<StopForCompletionCheckQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<StopForCompletionCheckQuery>(StopForCompletionCheckDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'stopForCompletionCheck', 'query', variables);
    },
    assignOutboundReferenceNumbersToStorageUnits(variables: AssignOutboundReferenceNumbersToStorageUnitsMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<AssignOutboundReferenceNumbersToStorageUnitsMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<AssignOutboundReferenceNumbersToStorageUnitsMutation>(AssignOutboundReferenceNumbersToStorageUnitsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'assignOutboundReferenceNumbersToStorageUnits', 'mutation', variables);
    },
    createStorageOrderDocument(variables: CreateStorageOrderDocumentMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CreateStorageOrderDocumentMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateStorageOrderDocumentMutation>(CreateStorageOrderDocumentDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'createStorageOrderDocument', 'mutation', variables);
    },
    createStorageOrder(variables: CreateStorageOrderMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CreateStorageOrderMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateStorageOrderMutation>(CreateStorageOrderDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'createStorageOrder', 'mutation', variables);
    },
    createStorageUnit(variables: CreateStorageUnitMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CreateStorageUnitMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateStorageUnitMutation>(CreateStorageUnitDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'createStorageUnit', 'mutation', variables);
    },
    deleteStorageOrder(variables: DeleteStorageOrderMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<DeleteStorageOrderMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<DeleteStorageOrderMutation>(DeleteStorageOrderDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'deleteStorageOrder', 'mutation', variables);
    },
    deleteStorageUnit(variables: DeleteStorageUnitMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<DeleteStorageUnitMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<DeleteStorageUnitMutation>(DeleteStorageUnitDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'deleteStorageUnit', 'mutation', variables);
    },
    storageOrderStorageUnits(variables: StorageOrderStorageUnitsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<StorageOrderStorageUnitsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<StorageOrderStorageUnitsQuery>(StorageOrderStorageUnitsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'storageOrderStorageUnits', 'query', variables);
    },
    storageOrder(variables: StorageOrderQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<StorageOrderQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<StorageOrderQuery>(StorageOrderDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'storageOrder', 'query', variables);
    },
    storageOrders(variables: StorageOrdersQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<StorageOrdersQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<StorageOrdersQuery>(StorageOrdersDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'storageOrders', 'query', variables);
    },
    storageUnitsForPicklist(variables: StorageUnitsForPicklistQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<StorageUnitsForPicklistQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<StorageUnitsForPicklistQuery>(StorageUnitsForPicklistDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'storageUnitsForPicklist', 'query', variables);
    },
    storageUnits(variables: StorageUnitsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<StorageUnitsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<StorageUnitsQuery>(StorageUnitsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'storageUnits', 'query', variables);
    },
    generateStorageOrderPreSignedPutUrl(variables: GenerateStorageOrderPreSignedPutUrlMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GenerateStorageOrderPreSignedPutUrlMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<GenerateStorageOrderPreSignedPutUrlMutation>(GenerateStorageOrderPreSignedPutUrlDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'generateStorageOrderPreSignedPutUrl', 'mutation', variables);
    },
    importStorageOrdersFromCSV(variables: ImportStorageOrdersFromCsvMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ImportStorageOrdersFromCsvMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<ImportStorageOrdersFromCsvMutation>(ImportStorageOrdersFromCsvDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'importStorageOrdersFromCSV', 'mutation', variables);
    },
    upsertItemGroup(variables: UpsertItemGroupMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UpsertItemGroupMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpsertItemGroupMutation>(UpsertItemGroupDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'upsertItemGroup', 'mutation', variables);
    },
    itemGroups(variables: ItemGroupsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ItemGroupsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<ItemGroupsQuery>(ItemGroupsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'itemGroups', 'query', variables);
    },
    markStorageUnitAsBilled(variables: MarkStorageUnitAsBilledMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<MarkStorageUnitAsBilledMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<MarkStorageUnitAsBilledMutation>(MarkStorageUnitAsBilledDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'markStorageUnitAsBilled', 'mutation', variables);
    },
    markStorageUnitAsOsd(variables: MarkStorageUnitAsOsdMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<MarkStorageUnitAsOsdMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<MarkStorageUnitAsOsdMutation>(MarkStorageUnitAsOsdDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'markStorageUnitAsOsd', 'mutation', variables);
    },
    removeStorageUnitOsd(variables: RemoveStorageUnitOsdMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<RemoveStorageUnitOsdMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<RemoveStorageUnitOsdMutation>(RemoveStorageUnitOsdDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'removeStorageUnitOsd', 'mutation', variables);
    },
    setStorageOrderItemQuantity(variables: SetStorageOrderItemQuantityMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<SetStorageOrderItemQuantityMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<SetStorageOrderItemQuantityMutation>(SetStorageOrderItemQuantityDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'setStorageOrderItemQuantity', 'mutation', variables);
    },
    unassignInventoryItems(variables: UnassignInventoryItemsMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UnassignInventoryItemsMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UnassignInventoryItemsMutation>(UnassignInventoryItemsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'unassignInventoryItems', 'mutation', variables);
    },
    updateStorageOrder(variables: UpdateStorageOrderMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UpdateStorageOrderMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateStorageOrderMutation>(UpdateStorageOrderDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updateStorageOrder', 'mutation', variables);
    },
    updateStorageUnit(variables: UpdateStorageUnitMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UpdateStorageUnitMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateStorageUnitMutation>(UpdateStorageUnitDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updateStorageUnit', 'mutation', variables);
    },
    upsertPicklist(variables: UpsertPicklistMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UpsertPicklistMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpsertPicklistMutation>(UpsertPicklistDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'upsertPicklist', 'mutation', variables);
    },
    tags(variables?: TagsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<TagsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<TagsQuery>(TagsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'tags', 'query', variables);
    },
    createTariffLocation(variables: CreateTariffLocationMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CreateTariffLocationMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateTariffLocationMutation>(CreateTariffLocationDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'createTariffLocation', 'mutation', variables);
    },
    createTariffZone(variables: CreateTariffZoneMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CreateTariffZoneMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateTariffZoneMutation>(CreateTariffZoneDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'createTariffZone', 'mutation', variables);
    },
    deleteTariffLocation(variables: DeleteTariffLocationMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<DeleteTariffLocationMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<DeleteTariffLocationMutation>(DeleteTariffLocationDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'deleteTariffLocation', 'mutation', variables);
    },
    deleteTariffZone(variables: DeleteTariffZoneMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<DeleteTariffZoneMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<DeleteTariffZoneMutation>(DeleteTariffZoneDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'deleteTariffZone', 'mutation', variables);
    },
    findTariffZoneByUuid(variables: FindTariffZoneByUuidQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<FindTariffZoneByUuidQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<FindTariffZoneByUuidQuery>(FindTariffZoneByUuidDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'findTariffZoneByUuid', 'query', variables);
    },
    tariffZones(variables?: TariffZonesQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<TariffZonesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<TariffZonesQuery>(TariffZonesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'tariffZones', 'query', variables);
    },
    updateTariffZone(variables: UpdateTariffZoneMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UpdateTariffZoneMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateTariffZoneMutation>(UpdateTariffZoneDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updateTariffZone', 'mutation', variables);
    },
    services(variables?: ServicesQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ServicesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<ServicesQuery>(ServicesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'services', 'query', variables);
    },
    tariffGroups(variables?: TariffGroupsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<TariffGroupsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<TariffGroupsQuery>(TariffGroupsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'tariffGroups', 'query', variables);
    },
    shipmentsByPhoneOrReferenceNumber(variables: ShipmentsByPhoneOrReferenceNumberQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ShipmentsByPhoneOrReferenceNumberQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<ShipmentsByPhoneOrReferenceNumberQuery>(ShipmentsByPhoneOrReferenceNumberDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'shipmentsByPhoneOrReferenceNumber', 'query', variables);
    },
    textMessages(variables: TextMessagesQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<TextMessagesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<TextMessagesQuery>(TextMessagesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'textMessages', 'query', variables);
    },
    dockScanReport(variables: DockScanReportQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<DockScanReportQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<DockScanReportQuery>(DockScanReportDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'dockScanReport', 'query', variables);
    },
    createWarehouseLocation(variables: CreateWarehouseLocationMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CreateWarehouseLocationMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateWarehouseLocationMutation>(CreateWarehouseLocationDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'createWarehouseLocation', 'mutation', variables);
    },
    deleteUnusedWarehouseLocations(variables?: DeleteUnusedWarehouseLocationsMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<DeleteUnusedWarehouseLocationsMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<DeleteUnusedWarehouseLocationsMutation>(DeleteUnusedWarehouseLocationsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'deleteUnusedWarehouseLocations', 'mutation', variables);
    },
    deleteWarehouseLocation(variables: DeleteWarehouseLocationMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<DeleteWarehouseLocationMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<DeleteWarehouseLocationMutation>(DeleteWarehouseLocationDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'deleteWarehouseLocation', 'mutation', variables);
    },
    warehouseLocations(variables?: WarehouseLocationsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<WarehouseLocationsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<WarehouseLocationsQuery>(WarehouseLocationsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'warehouseLocations', 'query', variables);
    },
    importWarehouseLocationsFromCsv(variables: ImportWarehouseLocationsFromCsvMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ImportWarehouseLocationsFromCsvMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<ImportWarehouseLocationsFromCsvMutation>(ImportWarehouseLocationsFromCsvDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'importWarehouseLocationsFromCsv', 'mutation', variables);
    },
    scanOrder(variables: ScanOrderMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ScanOrderMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<ScanOrderMutation>(ScanOrderDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'scanOrder', 'mutation', variables);
    },
    updateWarehouseLocation(variables: UpdateWarehouseLocationMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UpdateWarehouseLocationMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateWarehouseLocationMutation>(UpdateWarehouseLocationDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updateWarehouseLocation', 'mutation', variables);
    },
    createWarehouse(variables: CreateWarehouseMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CreateWarehouseMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateWarehouseMutation>(CreateWarehouseDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'createWarehouse', 'mutation', variables);
    },
    deleteWarehouse(variables: DeleteWarehouseMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<DeleteWarehouseMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<DeleteWarehouseMutation>(DeleteWarehouseDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'deleteWarehouse', 'mutation', variables);
    },
    closestWarehouseToAddress(variables: ClosestWarehouseToAddressQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ClosestWarehouseToAddressQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<ClosestWarehouseToAddressQuery>(ClosestWarehouseToAddressDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'closestWarehouseToAddress', 'query', variables);
    },
    markWarehouseAsDefault(variables: MarkWarehouseAsDefaultMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<MarkWarehouseAsDefaultMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<MarkWarehouseAsDefaultMutation>(MarkWarehouseAsDefaultDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'markWarehouseAsDefault', 'mutation', variables);
    },
    myWarehouses(variables?: MyWarehousesQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<MyWarehousesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<MyWarehousesQuery>(MyWarehousesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'myWarehouses', 'query', variables);
    },
    updateWarehouse(variables: UpdateWarehouseMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UpdateWarehouseMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateWarehouseMutation>(UpdateWarehouseDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updateWarehouse', 'mutation', variables);
    },
    warehouse(variables: WarehouseQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<WarehouseQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<WarehouseQuery>(WarehouseDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'warehouse', 'query', variables);
    },
    warehouses(variables: WarehousesQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<WarehousesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<WarehousesQuery>(WarehousesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'warehouses', 'query', variables);
    },
    findLegs(variables: FindLegsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<FindLegsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<FindLegsQuery>(FindLegsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'findLegs', 'query', variables);
    }
  };
}
export type Sdk = ReturnType<typeof getSdk>;